/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		168707334958949:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + window["webpackManifest"][chunkId];
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// expose the chunks object
/******/ 	__webpack_require__.s = installedChunks;
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(4435);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(4380)();
	}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(39);
	var toSubscriber_1 = __webpack_require__(4756);
	var observable_1 = __webpack_require__(355);
	var pipe_1 = __webpack_require__(524);
	/**
	 * A representation of any set of values over any amount of time. This is the most basic building block
	 * of RxJS.
	 *
	 * @class Observable<T>
	 */
	var Observable = (function () {
	    /**
	     * @constructor
	     * @param {Function} subscribe the function that is called when the Observable is
	     * initially subscribed to. This function is given a Subscriber, to which new values
	     * can be `next`ed, or an `error` method can be called to raise an error, or
	     * `complete` can be called to notify of a successful completion.
	     */
	    function Observable(subscribe) {
	        this._isScalar = false;
	        if (subscribe) {
	            this._subscribe = subscribe;
	        }
	    }
	    /**
	     * Creates a new Observable, with this Observable as the source, and the passed
	     * operator defined as the new observable's operator.
	     * @method lift
	     * @param {Operator} operator the operator defining the operation to take on the observable
	     * @return {Observable} a new observable with the Operator applied
	     */
	    Observable.prototype.lift = function (operator) {
	        var observable = new Observable();
	        observable.source = this;
	        observable.operator = operator;
	        return observable;
	    };
	    /**
	     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
	     *
	     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
	     *
	     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
	     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
	     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
	     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
	     * thought.
	     *
	     * Apart from starting the execution of an Observable, this method allows you to listen for values
	     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
	     * following ways.
	     *
	     * The first way is creating an object that implements {@link Observer} interface. It should have methods
	     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
	     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
	     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
	     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
	     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
	     * be left uncaught.
	     *
	     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
	     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
	     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
	     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
	     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
	     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
	     *
	     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
	     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
	     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
	     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
	     *
	     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
	     * It is an Observable itself that decides when these functions will be called. For example {@link of}
	     * by default emits all its values synchronously. Always check documentation for how given Observable
	     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
	     *
	     * @example <caption>Subscribe with an Observer</caption>
	     * const sumObserver = {
	     *   sum: 0,
	     *   next(value) {
	     *     console.log('Adding: ' + value);
	     *     this.sum = this.sum + value;
	     *   },
	     *   error() { // We actually could just remove this method,
	     *   },        // since we do not really care about errors right now.
	     *   complete() {
	     *     console.log('Sum equals: ' + this.sum);
	     *   }
	     * };
	     *
	     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
	     * .subscribe(sumObserver);
	     *
	     * // Logs:
	     * // "Adding: 1"
	     * // "Adding: 2"
	     * // "Adding: 3"
	     * // "Sum equals: 6"
	     *
	     *
	     * @example <caption>Subscribe with functions</caption>
	     * let sum = 0;
	     *
	     * Rx.Observable.of(1, 2, 3)
	     * .subscribe(
	     *   function(value) {
	     *     console.log('Adding: ' + value);
	     *     sum = sum + value;
	     *   },
	     *   undefined,
	     *   function() {
	     *     console.log('Sum equals: ' + sum);
	     *   }
	     * );
	     *
	     * // Logs:
	     * // "Adding: 1"
	     * // "Adding: 2"
	     * // "Adding: 3"
	     * // "Sum equals: 6"
	     *
	     *
	     * @example <caption>Cancel a subscription</caption>
	     * const subscription = Rx.Observable.interval(1000).subscribe(
	     *   num => console.log(num),
	     *   undefined,
	     *   () => console.log('completed!') // Will not be called, even
	     * );                                // when cancelling subscription
	     *
	     *
	     * setTimeout(() => {
	     *   subscription.unsubscribe();
	     *   console.log('unsubscribed!');
	     * }, 2500);
	     *
	     * // Logs:
	     * // 0 after 1s
	     * // 1 after 2s
	     * // "unsubscribed!" after 2.5s
	     *
	     *
	     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
	     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
	     *  Observable.
	     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
	     *  the error will be thrown as unhandled.
	     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
	     * @return {ISubscription} a subscription reference to the registered handlers
	     * @method subscribe
	     */
	    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
	        var operator = this.operator;
	        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
	        if (operator) {
	            operator.call(sink, this.source);
	        }
	        else {
	            sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
	        }
	        if (sink.syncErrorThrowable) {
	            sink.syncErrorThrowable = false;
	            if (sink.syncErrorThrown) {
	                throw sink.syncErrorValue;
	            }
	        }
	        return sink;
	    };
	    Observable.prototype._trySubscribe = function (sink) {
	        try {
	            return this._subscribe(sink);
	        }
	        catch (err) {
	            sink.syncErrorThrown = true;
	            sink.syncErrorValue = err;
	            sink.error(err);
	        }
	    };
	    /**
	     * @method forEach
	     * @param {Function} next a handler for each value emitted by the observable
	     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
	     * @return {Promise} a promise that either resolves on observable completion or
	     *  rejects with the handled error
	     */
	    Observable.prototype.forEach = function (next, PromiseCtor) {
	        var _this = this;
	        if (!PromiseCtor) {
	            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
	                PromiseCtor = root_1.root.Rx.config.Promise;
	            }
	            else if (root_1.root.Promise) {
	                PromiseCtor = root_1.root.Promise;
	            }
	        }
	        if (!PromiseCtor) {
	            throw new Error('no Promise impl found');
	        }
	        return new PromiseCtor(function (resolve, reject) {
	            // Must be declared in a separate statement to avoid a RefernceError when
	            // accessing subscription below in the closure due to Temporal Dead Zone.
	            var subscription;
	            subscription = _this.subscribe(function (value) {
	                if (subscription) {
	                    // if there is a subscription, then we can surmise
	                    // the next handling is asynchronous. Any errors thrown
	                    // need to be rejected explicitly and unsubscribe must be
	                    // called manually
	                    try {
	                        next(value);
	                    }
	                    catch (err) {
	                        reject(err);
	                        subscription.unsubscribe();
	                    }
	                }
	                else {
	                    // if there is NO subscription, then we're getting a nexted
	                    // value synchronously during subscription. We can just call it.
	                    // If it errors, Observable's `subscribe` will ensure the
	                    // unsubscription logic is called, then synchronously rethrow the error.
	                    // After that, Promise will trap the error and send it
	                    // down the rejection path.
	                    next(value);
	                }
	            }, reject, resolve);
	        });
	    };
	    Observable.prototype._subscribe = function (subscriber) {
	        return this.source.subscribe(subscriber);
	    };
	    /**
	     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
	     * @method Symbol.observable
	     * @return {Observable} this instance of the observable
	     */
	    Observable.prototype[observable_1.observable] = function () {
	        return this;
	    };
	    /* tslint:enable:max-line-length */
	    /**
	     * Used to stitch together functional operators into a chain.
	     * @method pipe
	     * @return {Observable} the Observable result of all of the operators having
	     * been called in the order they were passed in.
	     *
	     * @example
	     *
	     * import { map, filter, scan } from 'rxjs/operators';
	     *
	     * Rx.Observable.interval(1000)
	     *   .pipe(
	     *     filter(x => x % 2 === 0),
	     *     map(x => x + x),
	     *     scan((acc, x) => acc + x)
	     *   )
	     *   .subscribe(x => console.log(x))
	     */
	    Observable.prototype.pipe = function () {
	        var operations = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            operations[_i - 0] = arguments[_i];
	        }
	        if (operations.length === 0) {
	            return this;
	        }
	        return pipe_1.pipeFromArray(operations)(this);
	    };
	    /* tslint:enable:max-line-length */
	    Observable.prototype.toPromise = function (PromiseCtor) {
	        var _this = this;
	        if (!PromiseCtor) {
	            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
	                PromiseCtor = root_1.root.Rx.config.Promise;
	            }
	            else if (root_1.root.Promise) {
	                PromiseCtor = root_1.root.Promise;
	            }
	        }
	        if (!PromiseCtor) {
	            throw new Error('no Promise impl found');
	        }
	        return new PromiseCtor(function (resolve, reject) {
	            var value;
	            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
	        });
	    };
	    // HACK: Since TypeScript inherits static properties too, we have to
	    // fight against TypeScript here so Subject can have a different static create signature
	    /**
	     * Creates a new cold Observable by calling the Observable constructor
	     * @static true
	     * @owner Observable
	     * @method create
	     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
	     * @return {Observable} a new cold observable
	     */
	    Observable.create = function (subscribe) {
	        return new Observable(subscribe);
	    };
	    return Observable;
	}());
	exports.Observable = Observable;
	//# sourceMappingURL=Observable.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(965);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(82);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(124);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(124);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(378);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createTypeAnnotationBasedOnTypeof = exports.removeTypeDuplicates = exports.createUnionTypeAnnotation = exports.valueToNode = exports.toBlock = exports.toExpression = exports.toStatement = exports.toBindingIdentifierName = exports.toIdentifier = exports.toKeyAlias = exports.toSequenceExpression = exports.toComputedKey = exports.isNodesEquivalent = exports.isImmutable = exports.isScope = exports.isSpecifierDefault = exports.isVar = exports.isBlockScoped = exports.isLet = exports.isValidIdentifier = exports.isReferenced = exports.isBinding = exports.getOuterBindingIdentifiers = exports.getBindingIdentifiers = exports.TYPES = exports.react = exports.DEPRECATED_KEYS = exports.BUILDER_KEYS = exports.NODE_FIELDS = exports.ALIAS_KEYS = exports.VISITOR_KEYS = exports.NOT_LOCAL_BINDING = exports.BLOCK_SCOPED_SYMBOL = exports.INHERIT_KEYS = exports.UNARY_OPERATORS = exports.STRING_UNARY_OPERATORS = exports.NUMBER_UNARY_OPERATORS = exports.BOOLEAN_UNARY_OPERATORS = exports.BINARY_OPERATORS = exports.NUMBER_BINARY_OPERATORS = exports.BOOLEAN_BINARY_OPERATORS = exports.COMPARISON_BINARY_OPERATORS = exports.EQUALITY_BINARY_OPERATORS = exports.BOOLEAN_NUMBER_BINARY_OPERATORS = exports.UPDATE_OPERATORS = exports.LOGICAL_OPERATORS = exports.COMMENT_KEYS = exports.FOR_INIT_KEYS = exports.FLATTENABLE_KEYS = exports.STATEMENT_OR_BLOCK_KEYS = undefined;
	
	var _getOwnPropertySymbols = __webpack_require__(964);
	
	var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(90);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(168);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _constants = __webpack_require__(382);
	
	Object.defineProperty(exports, "STATEMENT_OR_BLOCK_KEYS", {
	  enumerable: true,
	  get: function get() {
	    return _constants.STATEMENT_OR_BLOCK_KEYS;
	  }
	});
	Object.defineProperty(exports, "FLATTENABLE_KEYS", {
	  enumerable: true,
	  get: function get() {
	    return _constants.FLATTENABLE_KEYS;
	  }
	});
	Object.defineProperty(exports, "FOR_INIT_KEYS", {
	  enumerable: true,
	  get: function get() {
	    return _constants.FOR_INIT_KEYS;
	  }
	});
	Object.defineProperty(exports, "COMMENT_KEYS", {
	  enumerable: true,
	  get: function get() {
	    return _constants.COMMENT_KEYS;
	  }
	});
	Object.defineProperty(exports, "LOGICAL_OPERATORS", {
	  enumerable: true,
	  get: function get() {
	    return _constants.LOGICAL_OPERATORS;
	  }
	});
	Object.defineProperty(exports, "UPDATE_OPERATORS", {
	  enumerable: true,
	  get: function get() {
	    return _constants.UPDATE_OPERATORS;
	  }
	});
	Object.defineProperty(exports, "BOOLEAN_NUMBER_BINARY_OPERATORS", {
	  enumerable: true,
	  get: function get() {
	    return _constants.BOOLEAN_NUMBER_BINARY_OPERATORS;
	  }
	});
	Object.defineProperty(exports, "EQUALITY_BINARY_OPERATORS", {
	  enumerable: true,
	  get: function get() {
	    return _constants.EQUALITY_BINARY_OPERATORS;
	  }
	});
	Object.defineProperty(exports, "COMPARISON_BINARY_OPERATORS", {
	  enumerable: true,
	  get: function get() {
	    return _constants.COMPARISON_BINARY_OPERATORS;
	  }
	});
	Object.defineProperty(exports, "BOOLEAN_BINARY_OPERATORS", {
	  enumerable: true,
	  get: function get() {
	    return _constants.BOOLEAN_BINARY_OPERATORS;
	  }
	});
	Object.defineProperty(exports, "NUMBER_BINARY_OPERATORS", {
	  enumerable: true,
	  get: function get() {
	    return _constants.NUMBER_BINARY_OPERATORS;
	  }
	});
	Object.defineProperty(exports, "BINARY_OPERATORS", {
	  enumerable: true,
	  get: function get() {
	    return _constants.BINARY_OPERATORS;
	  }
	});
	Object.defineProperty(exports, "BOOLEAN_UNARY_OPERATORS", {
	  enumerable: true,
	  get: function get() {
	    return _constants.BOOLEAN_UNARY_OPERATORS;
	  }
	});
	Object.defineProperty(exports, "NUMBER_UNARY_OPERATORS", {
	  enumerable: true,
	  get: function get() {
	    return _constants.NUMBER_UNARY_OPERATORS;
	  }
	});
	Object.defineProperty(exports, "STRING_UNARY_OPERATORS", {
	  enumerable: true,
	  get: function get() {
	    return _constants.STRING_UNARY_OPERATORS;
	  }
	});
	Object.defineProperty(exports, "UNARY_OPERATORS", {
	  enumerable: true,
	  get: function get() {
	    return _constants.UNARY_OPERATORS;
	  }
	});
	Object.defineProperty(exports, "INHERIT_KEYS", {
	  enumerable: true,
	  get: function get() {
	    return _constants.INHERIT_KEYS;
	  }
	});
	Object.defineProperty(exports, "BLOCK_SCOPED_SYMBOL", {
	  enumerable: true,
	  get: function get() {
	    return _constants.BLOCK_SCOPED_SYMBOL;
	  }
	});
	Object.defineProperty(exports, "NOT_LOCAL_BINDING", {
	  enumerable: true,
	  get: function get() {
	    return _constants.NOT_LOCAL_BINDING;
	  }
	});
	exports.is = is;
	exports.isType = isType;
	exports.validate = validate;
	exports.shallowEqual = shallowEqual;
	exports.appendToMemberExpression = appendToMemberExpression;
	exports.prependToMemberExpression = prependToMemberExpression;
	exports.ensureBlock = ensureBlock;
	exports.clone = clone;
	exports.cloneWithoutLoc = cloneWithoutLoc;
	exports.cloneDeep = cloneDeep;
	exports.buildMatchMemberExpression = buildMatchMemberExpression;
	exports.removeComments = removeComments;
	exports.inheritsComments = inheritsComments;
	exports.inheritTrailingComments = inheritTrailingComments;
	exports.inheritLeadingComments = inheritLeadingComments;
	exports.inheritInnerComments = inheritInnerComments;
	exports.inherits = inherits;
	exports.assertNode = assertNode;
	exports.isNode = isNode;
	exports.traverseFast = traverseFast;
	exports.removeProperties = removeProperties;
	exports.removePropertiesDeep = removePropertiesDeep;
	
	var _retrievers = __webpack_require__(553);
	
	Object.defineProperty(exports, "getBindingIdentifiers", {
	  enumerable: true,
	  get: function get() {
	    return _retrievers.getBindingIdentifiers;
	  }
	});
	Object.defineProperty(exports, "getOuterBindingIdentifiers", {
	  enumerable: true,
	  get: function get() {
	    return _retrievers.getOuterBindingIdentifiers;
	  }
	});
	
	var _validators = __webpack_require__(1000);
	
	Object.defineProperty(exports, "isBinding", {
	  enumerable: true,
	  get: function get() {
	    return _validators.isBinding;
	  }
	});
	Object.defineProperty(exports, "isReferenced", {
	  enumerable: true,
	  get: function get() {
	    return _validators.isReferenced;
	  }
	});
	Object.defineProperty(exports, "isValidIdentifier", {
	  enumerable: true,
	  get: function get() {
	    return _validators.isValidIdentifier;
	  }
	});
	Object.defineProperty(exports, "isLet", {
	  enumerable: true,
	  get: function get() {
	    return _validators.isLet;
	  }
	});
	Object.defineProperty(exports, "isBlockScoped", {
	  enumerable: true,
	  get: function get() {
	    return _validators.isBlockScoped;
	  }
	});
	Object.defineProperty(exports, "isVar", {
	  enumerable: true,
	  get: function get() {
	    return _validators.isVar;
	  }
	});
	Object.defineProperty(exports, "isSpecifierDefault", {
	  enumerable: true,
	  get: function get() {
	    return _validators.isSpecifierDefault;
	  }
	});
	Object.defineProperty(exports, "isScope", {
	  enumerable: true,
	  get: function get() {
	    return _validators.isScope;
	  }
	});
	Object.defineProperty(exports, "isImmutable", {
	  enumerable: true,
	  get: function get() {
	    return _validators.isImmutable;
	  }
	});
	Object.defineProperty(exports, "isNodesEquivalent", {
	  enumerable: true,
	  get: function get() {
	    return _validators.isNodesEquivalent;
	  }
	});
	
	var _converters = __webpack_require__(990);
	
	Object.defineProperty(exports, "toComputedKey", {
	  enumerable: true,
	  get: function get() {
	    return _converters.toComputedKey;
	  }
	});
	Object.defineProperty(exports, "toSequenceExpression", {
	  enumerable: true,
	  get: function get() {
	    return _converters.toSequenceExpression;
	  }
	});
	Object.defineProperty(exports, "toKeyAlias", {
	  enumerable: true,
	  get: function get() {
	    return _converters.toKeyAlias;
	  }
	});
	Object.defineProperty(exports, "toIdentifier", {
	  enumerable: true,
	  get: function get() {
	    return _converters.toIdentifier;
	  }
	});
	Object.defineProperty(exports, "toBindingIdentifierName", {
	  enumerable: true,
	  get: function get() {
	    return _converters.toBindingIdentifierName;
	  }
	});
	Object.defineProperty(exports, "toStatement", {
	  enumerable: true,
	  get: function get() {
	    return _converters.toStatement;
	  }
	});
	Object.defineProperty(exports, "toExpression", {
	  enumerable: true,
	  get: function get() {
	    return _converters.toExpression;
	  }
	});
	Object.defineProperty(exports, "toBlock", {
	  enumerable: true,
	  get: function get() {
	    return _converters.toBlock;
	  }
	});
	Object.defineProperty(exports, "valueToNode", {
	  enumerable: true,
	  get: function get() {
	    return _converters.valueToNode;
	  }
	});
	
	var _flow = __webpack_require__(998);
	
	Object.defineProperty(exports, "createUnionTypeAnnotation", {
	  enumerable: true,
	  get: function get() {
	    return _flow.createUnionTypeAnnotation;
	  }
	});
	Object.defineProperty(exports, "removeTypeDuplicates", {
	  enumerable: true,
	  get: function get() {
	    return _flow.removeTypeDuplicates;
	  }
	});
	Object.defineProperty(exports, "createTypeAnnotationBasedOnTypeof", {
	  enumerable: true,
	  get: function get() {
	    return _flow.createTypeAnnotationBasedOnTypeof;
	  }
	});
	
	var _toFastProperties = __webpack_require__(4775);
	
	var _toFastProperties2 = _interopRequireDefault(_toFastProperties);
	
	var _clone = __webpack_require__(682);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _uniq = __webpack_require__(185);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	__webpack_require__(995);
	
	var _definitions = __webpack_require__(92);
	
	var _react2 = __webpack_require__(999);
	
	var _react = _interopRequireWildcard(_react2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var t = exports;
	
	function registerType(type) {
	  var is = t["is" + type];
	  if (!is) {
	    is = t["is" + type] = function (node, opts) {
	      return t.is(type, node, opts);
	    };
	  }
	
	  t["assert" + type] = function (node, opts) {
	    opts = opts || {};
	    if (!is(node, opts)) {
	      throw new Error("Expected type " + (0, _stringify2.default)(type) + " with option " + (0, _stringify2.default)(opts));
	    }
	  };
	}
	
	exports.VISITOR_KEYS = _definitions.VISITOR_KEYS;
	exports.ALIAS_KEYS = _definitions.ALIAS_KEYS;
	exports.NODE_FIELDS = _definitions.NODE_FIELDS;
	exports.BUILDER_KEYS = _definitions.BUILDER_KEYS;
	exports.DEPRECATED_KEYS = _definitions.DEPRECATED_KEYS;
	exports.react = _react;
	
	
	for (var type in t.VISITOR_KEYS) {
	  registerType(type);
	}
	
	t.FLIPPED_ALIAS_KEYS = {};
	
	(0, _keys2.default)(t.ALIAS_KEYS).forEach(function (type) {
	  t.ALIAS_KEYS[type].forEach(function (alias) {
	    var types = t.FLIPPED_ALIAS_KEYS[alias] = t.FLIPPED_ALIAS_KEYS[alias] || [];
	    types.push(type);
	  });
	});
	
	(0, _keys2.default)(t.FLIPPED_ALIAS_KEYS).forEach(function (type) {
	  t[type.toUpperCase() + "_TYPES"] = t.FLIPPED_ALIAS_KEYS[type];
	  registerType(type);
	});
	
	var TYPES = exports.TYPES = (0, _keys2.default)(t.VISITOR_KEYS).concat((0, _keys2.default)(t.FLIPPED_ALIAS_KEYS)).concat((0, _keys2.default)(t.DEPRECATED_KEYS));
	
	function is(type, node, opts) {
	  if (!node) return false;
	
	  var matches = isType(node.type, type);
	  if (!matches) return false;
	
	  if (typeof opts === "undefined") {
	    return true;
	  } else {
	    return t.shallowEqual(node, opts);
	  }
	}
	
	function isType(nodeType, targetType) {
	  if (nodeType === targetType) return true;
	
	  if (t.ALIAS_KEYS[targetType]) return false;
	
	  var aliases = t.FLIPPED_ALIAS_KEYS[targetType];
	  if (aliases) {
	    if (aliases[0] === nodeType) return true;
	
	    for (var _iterator = aliases, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var alias = _ref;
	
	      if (nodeType === alias) return true;
	    }
	  }
	
	  return false;
	}
	
	(0, _keys2.default)(t.BUILDER_KEYS).forEach(function (type) {
	  var keys = t.BUILDER_KEYS[type];
	
	  function builder() {
	    if (arguments.length > keys.length) {
	      throw new Error("t." + type + ": Too many arguments passed. Received " + arguments.length + " but can receive " + ("no more than " + keys.length));
	    }
	
	    var node = {};
	    node.type = type;
	
	    var i = 0;
	
	    for (var _iterator2 = keys, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var _key = _ref2;
	
	      var field = t.NODE_FIELDS[type][_key];
	
	      var arg = arguments[i++];
	      if (arg === undefined) arg = (0, _clone2.default)(field.default);
	
	      node[_key] = arg;
	    }
	
	    for (var key in node) {
	      validate(node, key, node[key]);
	    }
	
	    return node;
	  }
	
	  t[type] = builder;
	  t[type[0].toLowerCase() + type.slice(1)] = builder;
	});
	
	var _loop = function _loop(_type) {
	  var newType = t.DEPRECATED_KEYS[_type];
	
	  function proxy(fn) {
	    return function () {
	      console.trace("The node type " + _type + " has been renamed to " + newType);
	      return fn.apply(this, arguments);
	    };
	  }
	
	  t[_type] = t[_type[0].toLowerCase() + _type.slice(1)] = proxy(t[newType]);
	  t["is" + _type] = proxy(t["is" + newType]);
	  t["assert" + _type] = proxy(t["assert" + newType]);
	};
	
	for (var _type in t.DEPRECATED_KEYS) {
	  _loop(_type);
	}
	
	function validate(node, key, val) {
	  if (!node) return;
	
	  var fields = t.NODE_FIELDS[node.type];
	  if (!fields) return;
	
	  var field = fields[key];
	  if (!field || !field.validate) return;
	  if (field.optional && val == null) return;
	
	  field.validate(node, key, val);
	}
	
	function shallowEqual(actual, expected) {
	  var keys = (0, _keys2.default)(expected);
	
	  for (var _iterator3 = keys, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
	    var _ref3;
	
	    if (_isArray3) {
	      if (_i3 >= _iterator3.length) break;
	      _ref3 = _iterator3[_i3++];
	    } else {
	      _i3 = _iterator3.next();
	      if (_i3.done) break;
	      _ref3 = _i3.value;
	    }
	
	    var key = _ref3;
	
	    if (actual[key] !== expected[key]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function appendToMemberExpression(member, append, computed) {
	  member.object = t.memberExpression(member.object, member.property, member.computed);
	  member.property = append;
	  member.computed = !!computed;
	  return member;
	}
	
	function prependToMemberExpression(member, prepend) {
	  member.object = t.memberExpression(prepend, member.object);
	  return member;
	}
	
	function ensureBlock(node) {
	  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "body";
	
	  return node[key] = t.toBlock(node[key], node);
	}
	
	function clone(node) {
	  if (!node) return node;
	  var newNode = {};
	  for (var key in node) {
	    if (key[0] === "_") continue;
	    newNode[key] = node[key];
	  }
	  return newNode;
	}
	
	function cloneWithoutLoc(node) {
	  var newNode = clone(node);
	  delete newNode.loc;
	  return newNode;
	}
	
	function cloneDeep(node) {
	  if (!node) return node;
	  var newNode = {};
	
	  for (var key in node) {
	    if (key[0] === "_") continue;
	
	    var val = node[key];
	
	    if (val) {
	      if (val.type) {
	        val = t.cloneDeep(val);
	      } else if (Array.isArray(val)) {
	        val = val.map(t.cloneDeep);
	      }
	    }
	
	    newNode[key] = val;
	  }
	
	  return newNode;
	}
	
	function buildMatchMemberExpression(match, allowPartial) {
	  var parts = match.split(".");
	
	  return function (member) {
	    if (!t.isMemberExpression(member)) return false;
	
	    var search = [member];
	    var i = 0;
	
	    while (search.length) {
	      var node = search.shift();
	
	      if (allowPartial && i === parts.length) {
	        return true;
	      }
	
	      if (t.isIdentifier(node)) {
	        if (parts[i] !== node.name) return false;
	      } else if (t.isStringLiteral(node)) {
	        if (parts[i] !== node.value) return false;
	      } else if (t.isMemberExpression(node)) {
	        if (node.computed && !t.isStringLiteral(node.property)) {
	          return false;
	        } else {
	          search.push(node.object);
	          search.push(node.property);
	          continue;
	        }
	      } else {
	        return false;
	      }
	
	      if (++i > parts.length) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	}
	
	function removeComments(node) {
	  for (var _iterator4 = t.COMMENT_KEYS, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
	    var _ref4;
	
	    if (_isArray4) {
	      if (_i4 >= _iterator4.length) break;
	      _ref4 = _iterator4[_i4++];
	    } else {
	      _i4 = _iterator4.next();
	      if (_i4.done) break;
	      _ref4 = _i4.value;
	    }
	
	    var key = _ref4;
	
	    delete node[key];
	  }
	  return node;
	}
	
	function inheritsComments(child, parent) {
	  inheritTrailingComments(child, parent);
	  inheritLeadingComments(child, parent);
	  inheritInnerComments(child, parent);
	  return child;
	}
	
	function inheritTrailingComments(child, parent) {
	  _inheritComments("trailingComments", child, parent);
	}
	
	function inheritLeadingComments(child, parent) {
	  _inheritComments("leadingComments", child, parent);
	}
	
	function inheritInnerComments(child, parent) {
	  _inheritComments("innerComments", child, parent);
	}
	
	function _inheritComments(key, child, parent) {
	  if (child && parent) {
	    child[key] = (0, _uniq2.default)([].concat(child[key], parent[key]).filter(Boolean));
	  }
	}
	
	function inherits(child, parent) {
	  if (!child || !parent) return child;
	
	  for (var _iterator5 = t.INHERIT_KEYS.optional, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : (0, _getIterator3.default)(_iterator5);;) {
	    var _ref5;
	
	    if (_isArray5) {
	      if (_i5 >= _iterator5.length) break;
	      _ref5 = _iterator5[_i5++];
	    } else {
	      _i5 = _iterator5.next();
	      if (_i5.done) break;
	      _ref5 = _i5.value;
	    }
	
	    var _key2 = _ref5;
	
	    if (child[_key2] == null) {
	      child[_key2] = parent[_key2];
	    }
	  }
	
	  for (var key in parent) {
	    if (key[0] === "_") child[key] = parent[key];
	  }
	
	  for (var _iterator6 = t.INHERIT_KEYS.force, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : (0, _getIterator3.default)(_iterator6);;) {
	    var _ref6;
	
	    if (_isArray6) {
	      if (_i6 >= _iterator6.length) break;
	      _ref6 = _iterator6[_i6++];
	    } else {
	      _i6 = _iterator6.next();
	      if (_i6.done) break;
	      _ref6 = _i6.value;
	    }
	
	    var _key3 = _ref6;
	
	    child[_key3] = parent[_key3];
	  }
	
	  t.inheritsComments(child, parent);
	
	  return child;
	}
	
	function assertNode(node) {
	  if (!isNode(node)) {
	    throw new TypeError("Not a valid node " + (node && node.type));
	  }
	}
	
	function isNode(node) {
	  return !!(node && _definitions.VISITOR_KEYS[node.type]);
	}
	
	(0, _toFastProperties2.default)(t);
	(0, _toFastProperties2.default)(t.VISITOR_KEYS);
	
	function traverseFast(node, enter, opts) {
	  if (!node) return;
	
	  var keys = t.VISITOR_KEYS[node.type];
	  if (!keys) return;
	
	  opts = opts || {};
	  enter(node, opts);
	
	  for (var _iterator7 = keys, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : (0, _getIterator3.default)(_iterator7);;) {
	    var _ref7;
	
	    if (_isArray7) {
	      if (_i7 >= _iterator7.length) break;
	      _ref7 = _iterator7[_i7++];
	    } else {
	      _i7 = _iterator7.next();
	      if (_i7.done) break;
	      _ref7 = _i7.value;
	    }
	
	    var key = _ref7;
	
	    var subNode = node[key];
	
	    if (Array.isArray(subNode)) {
	      for (var _iterator8 = subNode, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : (0, _getIterator3.default)(_iterator8);;) {
	        var _ref8;
	
	        if (_isArray8) {
	          if (_i8 >= _iterator8.length) break;
	          _ref8 = _iterator8[_i8++];
	        } else {
	          _i8 = _iterator8.next();
	          if (_i8.done) break;
	          _ref8 = _i8.value;
	        }
	
	        var _node = _ref8;
	
	        traverseFast(_node, enter, opts);
	      }
	    } else {
	      traverseFast(subNode, enter, opts);
	    }
	  }
	}
	
	var CLEAR_KEYS = ["tokens", "start", "end", "loc", "raw", "rawValue"];
	
	var CLEAR_KEYS_PLUS_COMMENTS = t.COMMENT_KEYS.concat(["comments"]).concat(CLEAR_KEYS);
	
	function removeProperties(node, opts) {
	  opts = opts || {};
	  var map = opts.preserveComments ? CLEAR_KEYS : CLEAR_KEYS_PLUS_COMMENTS;
	  for (var _iterator9 = map, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : (0, _getIterator3.default)(_iterator9);;) {
	    var _ref9;
	
	    if (_isArray9) {
	      if (_i9 >= _iterator9.length) break;
	      _ref9 = _iterator9[_i9++];
	    } else {
	      _i9 = _iterator9.next();
	      if (_i9.done) break;
	      _ref9 = _i9.value;
	    }
	
	    var _key4 = _ref9;
	
	    if (node[_key4] != null) node[_key4] = undefined;
	  }
	
	  for (var key in node) {
	    if (key[0] === "_" && node[key] != null) node[key] = undefined;
	  }
	
	  var syms = (0, _getOwnPropertySymbols2.default)(node);
	  for (var _iterator10 = syms, _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : (0, _getIterator3.default)(_iterator10);;) {
	    var _ref10;
	
	    if (_isArray10) {
	      if (_i10 >= _iterator10.length) break;
	      _ref10 = _iterator10[_i10++];
	    } else {
	      _i10 = _iterator10.next();
	      if (_i10.done) break;
	      _ref10 = _i10.value;
	    }
	
	    var sym = _ref10;
	
	    node[sym] = null;
	  }
	}
	
	function removePropertiesDeep(tree, opts) {
	  traverseFast(tree, removeProperties, opts);
	  return tree;
	}

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isFunction_1 = __webpack_require__(360);
	var Subscription_1 = __webpack_require__(31);
	var Observer_1 = __webpack_require__(760);
	var rxSubscriber_1 = __webpack_require__(356);
	/**
	 * Implements the {@link Observer} interface and extends the
	 * {@link Subscription} class. While the {@link Observer} is the public API for
	 * consuming the values of an {@link Observable}, all Observers get converted to
	 * a Subscriber, in order to provide Subscription-like capabilities such as
	 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
	 * implementing operators, but it is rarely used as a public API.
	 *
	 * @class Subscriber<T>
	 */
	var Subscriber = (function (_super) {
	    __extends(Subscriber, _super);
	    /**
	     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
	     * defined Observer or a `next` callback function.
	     * @param {function(e: ?any): void} [error] The `error` callback of an
	     * Observer.
	     * @param {function(): void} [complete] The `complete` callback of an
	     * Observer.
	     */
	    function Subscriber(destinationOrNext, error, complete) {
	        _super.call(this);
	        this.syncErrorValue = null;
	        this.syncErrorThrown = false;
	        this.syncErrorThrowable = false;
	        this.isStopped = false;
	        switch (arguments.length) {
	            case 0:
	                this.destination = Observer_1.empty;
	                break;
	            case 1:
	                if (!destinationOrNext) {
	                    this.destination = Observer_1.empty;
	                    break;
	                }
	                if (typeof destinationOrNext === 'object') {
	                    if (destinationOrNext instanceof Subscriber) {
	                        this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
	                        this.destination = destinationOrNext;
	                        this.destination.add(this);
	                    }
	                    else {
	                        this.syncErrorThrowable = true;
	                        this.destination = new SafeSubscriber(this, destinationOrNext);
	                    }
	                    break;
	                }
	            default:
	                this.syncErrorThrowable = true;
	                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
	                break;
	        }
	    }
	    Subscriber.prototype[rxSubscriber_1.rxSubscriber] = function () { return this; };
	    /**
	     * A static factory for a Subscriber, given a (potentially partial) definition
	     * of an Observer.
	     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
	     * @param {function(e: ?any): void} [error] The `error` callback of an
	     * Observer.
	     * @param {function(): void} [complete] The `complete` callback of an
	     * Observer.
	     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
	     * Observer represented by the given arguments.
	     */
	    Subscriber.create = function (next, error, complete) {
	        var subscriber = new Subscriber(next, error, complete);
	        subscriber.syncErrorThrowable = false;
	        return subscriber;
	    };
	    /**
	     * The {@link Observer} callback to receive notifications of type `next` from
	     * the Observable, with a value. The Observable may call this method 0 or more
	     * times.
	     * @param {T} [value] The `next` value.
	     * @return {void}
	     */
	    Subscriber.prototype.next = function (value) {
	        if (!this.isStopped) {
	            this._next(value);
	        }
	    };
	    /**
	     * The {@link Observer} callback to receive notifications of type `error` from
	     * the Observable, with an attached {@link Error}. Notifies the Observer that
	     * the Observable has experienced an error condition.
	     * @param {any} [err] The `error` exception.
	     * @return {void}
	     */
	    Subscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._error(err);
	        }
	    };
	    /**
	     * The {@link Observer} callback to receive a valueless notification of type
	     * `complete` from the Observable. Notifies the Observer that the Observable
	     * has finished sending push-based notifications.
	     * @return {void}
	     */
	    Subscriber.prototype.complete = function () {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._complete();
	        }
	    };
	    Subscriber.prototype.unsubscribe = function () {
	        if (this.closed) {
	            return;
	        }
	        this.isStopped = true;
	        _super.prototype.unsubscribe.call(this);
	    };
	    Subscriber.prototype._next = function (value) {
	        this.destination.next(value);
	    };
	    Subscriber.prototype._error = function (err) {
	        this.destination.error(err);
	        this.unsubscribe();
	    };
	    Subscriber.prototype._complete = function () {
	        this.destination.complete();
	        this.unsubscribe();
	    };
	    Subscriber.prototype._unsubscribeAndRecycle = function () {
	        var _a = this, _parent = _a._parent, _parents = _a._parents;
	        this._parent = null;
	        this._parents = null;
	        this.unsubscribe();
	        this.closed = false;
	        this.isStopped = false;
	        this._parent = _parent;
	        this._parents = _parents;
	        return this;
	    };
	    return Subscriber;
	}(Subscription_1.Subscription));
	exports.Subscriber = Subscriber;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SafeSubscriber = (function (_super) {
	    __extends(SafeSubscriber, _super);
	    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
	        _super.call(this);
	        this._parentSubscriber = _parentSubscriber;
	        var next;
	        var context = this;
	        if (isFunction_1.isFunction(observerOrNext)) {
	            next = observerOrNext;
	        }
	        else if (observerOrNext) {
	            next = observerOrNext.next;
	            error = observerOrNext.error;
	            complete = observerOrNext.complete;
	            if (observerOrNext !== Observer_1.empty) {
	                context = Object.create(observerOrNext);
	                if (isFunction_1.isFunction(context.unsubscribe)) {
	                    this.add(context.unsubscribe.bind(context));
	                }
	                context.unsubscribe = this.unsubscribe.bind(this);
	            }
	        }
	        this._context = context;
	        this._next = next;
	        this._error = error;
	        this._complete = complete;
	    }
	    SafeSubscriber.prototype.next = function (value) {
	        if (!this.isStopped && this._next) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (!_parentSubscriber.syncErrorThrowable) {
	                this.__tryOrUnsub(this._next, value);
	            }
	            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (this._error) {
	                if (!_parentSubscriber.syncErrorThrowable) {
	                    this.__tryOrUnsub(this._error, err);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parentSubscriber, this._error, err);
	                    this.unsubscribe();
	                }
	            }
	            else if (!_parentSubscriber.syncErrorThrowable) {
	                this.unsubscribe();
	                throw err;
	            }
	            else {
	                _parentSubscriber.syncErrorValue = err;
	                _parentSubscriber.syncErrorThrown = true;
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.complete = function () {
	        var _this = this;
	        if (!this.isStopped) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (this._complete) {
	                var wrappedComplete = function () { return _this._complete.call(_this._context); };
	                if (!_parentSubscriber.syncErrorThrowable) {
	                    this.__tryOrUnsub(wrappedComplete);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
	                    this.unsubscribe();
	                }
	            }
	            else {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            this.unsubscribe();
	            throw err;
	        }
	    };
	    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            parent.syncErrorValue = err;
	            parent.syncErrorThrown = true;
	            return true;
	        }
	        return false;
	    };
	    SafeSubscriber.prototype._unsubscribe = function () {
	        var _parentSubscriber = this._parentSubscriber;
	        this._context = null;
	        this._parentSubscriber = null;
	        _parentSubscriber.unsubscribe();
	    };
	    return SafeSubscriber;
	}(Subscriber));
	//# sourceMappingURL=Subscriber.js.map

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;
	
	var _entries = __webpack_require__(194);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleConfig = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	
	function prefix(props, variant) {
	  var bsClass = (props.bsClass || '').trim();
	  !(bsClass != null) ?  false ? (0, _invariant2.default)(false, 'A `bsClass` prop is required for this component') : (0, _invariant2.default)(false) : void 0;
	  return bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _propTypes2.default.string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _propTypes2.default.oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = existing;
	  propType._values = existing;
	
	  Component.propTypes = (0, _extends3.default)({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _propTypes2.default.oneOf(values);
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = (0, _extends3.default)({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries2.default)(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	
	  var elementProps = {};
	  (0, _entries2.default)(props).forEach(function (_ref2) {
	    var propName = _ref2[0],
	        propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = exports._curry = curry;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1035), __esModule: true };

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(4387);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var OuterSubscriber = (function (_super) {
	    __extends(OuterSubscriber, _super);
	    function OuterSubscriber() {
	        _super.apply(this, arguments);
	    }
	    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.destination.next(innerValue);
	    };
	    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
	        this.destination.error(error);
	    };
	    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.destination.complete();
	    };
	    return OuterSubscriber;
	}(Subscriber_1.Subscriber));
	exports.OuterSubscriber = OuterSubscriber;
	//# sourceMappingURL=OuterSubscriber.js.map

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(39);
	var isArrayLike_1 = __webpack_require__(856);
	var isPromise_1 = __webpack_require__(522);
	var isObject_1 = __webpack_require__(857);
	var Observable_1 = __webpack_require__(4);
	var iterator_1 = __webpack_require__(270);
	var InnerSubscriber_1 = __webpack_require__(4470);
	var observable_1 = __webpack_require__(355);
	function subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
	    var destination = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
	    if (destination.closed) {
	        return null;
	    }
	    if (result instanceof Observable_1.Observable) {
	        if (result._isScalar) {
	            destination.next(result.value);
	            destination.complete();
	            return null;
	        }
	        else {
	            destination.syncErrorThrowable = true;
	            return result.subscribe(destination);
	        }
	    }
	    else if (isArrayLike_1.isArrayLike(result)) {
	        for (var i = 0, len = result.length; i < len && !destination.closed; i++) {
	            destination.next(result[i]);
	        }
	        if (!destination.closed) {
	            destination.complete();
	        }
	    }
	    else if (isPromise_1.isPromise(result)) {
	        result.then(function (value) {
	            if (!destination.closed) {
	                destination.next(value);
	                destination.complete();
	            }
	        }, function (err) { return destination.error(err); })
	            .then(null, function (err) {
	            // Escaping the Promise trap: globally throw unhandled errors
	            root_1.root.setTimeout(function () { throw err; });
	        });
	        return destination;
	    }
	    else if (result && typeof result[iterator_1.iterator] === 'function') {
	        var iterator = result[iterator_1.iterator]();
	        do {
	            var item = iterator.next();
	            if (item.done) {
	                destination.complete();
	                break;
	            }
	            destination.next(item.value);
	            if (destination.closed) {
	                break;
	            }
	        } while (true);
	    }
	    else if (result && typeof result[observable_1.observable] === 'function') {
	        var obs = result[observable_1.observable]();
	        if (typeof obs.subscribe !== 'function') {
	            destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
	        }
	        else {
	            return obs.subscribe(new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
	        }
	    }
	    else {
	        var value = isObject_1.isObject(result) ? 'an invalid object' : "'" + result + "'";
	        var msg = ("You provided " + value + " where a stream was expected.")
	            + ' You can provide an Observable, Promise, Array, or Iterable.';
	        destination.error(new TypeError(msg));
	    }
	    return null;
	}
	exports.subscribeToResult = subscribeToResult;
	//# sourceMappingURL=subscribeToResult.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(235);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);
	module.exports = exports['default'];

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.reducer = exports.projectFormVaulesSelector = exports.backendFormValuesSelector = exports.successMessageSelector = exports.isJSEnabledSelector = exports.isResetModalOpenSelector = exports.isHintModalOpenSelector = exports.helpModalTypeSelector = exports.isHelpModalOpenSelector = exports.isCompletionModalOpenSelector = exports.isCodeLockedSelector = exports.consoleOutputSelector = exports.challengeTestsSelector = exports.challengeMetaSelector = exports.challengeFilesSelector = exports.submitComplete = exports.submitChallenge = exports.resetChallenge = exports.executeChallenge = exports.checkChallenge = exports.challengeMounted = exports.openModal = exports.closeModal = exports.noStoredCodeFound = exports.storedCodeFound = exports.disableJSOnError = exports.unlockCode = exports.lockCode = exports.updateSuccessMessage = exports.updateProjectFormValues = exports.updateJSEnabled = exports.updateConsole = exports.updateFile = exports.updateChallengeMeta = exports.initConsole = exports.updateTests = exports.initTests = exports.createQuestion = exports.createFiles = exports.types = exports.epics = exports.backendNS = undefined;
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxActions = __webpack_require__(342);
	
	var _stateManagment = __webpack_require__(283);
	
	var _polyvinyl = __webpack_require__(167);
	
	var _challengeModalEpic = __webpack_require__(913);
	
	var _challengeModalEpic2 = _interopRequireDefault(_challengeModalEpic);
	
	var _completionEpic = __webpack_require__(916);
	
	var _completionEpic2 = _interopRequireDefault(_completionEpic);
	
	var _executeChallengeEpic = __webpack_require__(919);
	
	var _executeChallengeEpic2 = _interopRequireDefault(_executeChallengeEpic);
	
	var _codeLockEpic = __webpack_require__(914);
	
	var _codeLockEpic2 = _interopRequireDefault(_codeLockEpic);
	
	var _createQuestionEpic = __webpack_require__(917);
	
	var _createQuestionEpic2 = _interopRequireDefault(_createQuestionEpic);
	
	var _codeStorageEpic = __webpack_require__(915);
	
	var _codeStorageEpic2 = _interopRequireDefault(_codeStorageEpic);
	
	var _currentChallengeEpic = __webpack_require__(918);
	
	var _currentChallengeEpic2 = _interopRequireDefault(_currentChallengeEpic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ns = 'challenge';
	var backendNS = exports.backendNS = 'backendChallenge';
	
	var initialState = {
	  challengeFiles: {},
	  challengeMeta: {
	    id: '',
	    nextChallengePath: '/'
	  },
	  challengeTests: [],
	  consoleOut: '',
	  isCodeLocked: false,
	  isJSEnabled: true,
	  modal: {
	    completion: false,
	    help: { open: false, type: null },
	    hint: false,
	    reset: false
	    // playground: false
	  },
	  projectFormVaules: {},
	  successMessage: 'Happy Coding!'
	};
	
	var epics = exports.epics = [_challengeModalEpic2.default, _codeLockEpic2.default, _completionEpic2.default, _createQuestionEpic2.default, _executeChallengeEpic2.default, _codeStorageEpic2.default, _currentChallengeEpic2.default];
	
	var types = exports.types = (0, _stateManagment.createTypes)(['createFiles', 'createQuestion', 'initTests', 'initConsole', 'updateConsole', 'updateChallengeMeta', 'updateFile', 'updateJSEnabled', 'updateProjectFormValues', 'updateSuccessMessage', 'updateTests', 'lockCode', 'unlockCode', 'disableJSOnError', 'storedCodeFound', 'noStoredCodeFound', 'closeModal', 'openModal', 'challengeMounted', 'checkChallenge', 'executeChallenge', 'resetChallenge', 'submitChallenge', 'submitComplete'], ns);
	
	var createFiles = exports.createFiles = (0, _reduxActions.createAction)(types.createFiles, function (challengeFiles) {
	  return Object.keys(challengeFiles).filter(function (key) {
	    return challengeFiles[key];
	  }).map(function (key) {
	    return challengeFiles[key];
	  }).reduce(function (challengeFiles, file) {
	    var _extends2;
	
	    return _extends({}, challengeFiles, (_extends2 = {}, _extends2[file.key] = _extends({}, (0, _polyvinyl.createPoly)(file), {
	      seed: file.contents.slice(0)
	    }), _extends2));
	  }, {});
	});
	var createQuestion = exports.createQuestion = (0, _reduxActions.createAction)(types.createQuestion);
	var initTests = exports.initTests = (0, _reduxActions.createAction)(types.initTests);
	var updateTests = exports.updateTests = (0, _reduxActions.createAction)(types.updateTests);
	
	var initConsole = exports.initConsole = (0, _reduxActions.createAction)(types.initConsole);
	var updateChallengeMeta = exports.updateChallengeMeta = (0, _reduxActions.createAction)(types.updateChallengeMeta);
	var updateFile = exports.updateFile = (0, _reduxActions.createAction)(types.updateFile);
	var updateConsole = exports.updateConsole = (0, _reduxActions.createAction)(types.updateConsole);
	var updateJSEnabled = exports.updateJSEnabled = (0, _reduxActions.createAction)(types.updateJSEnabled);
	var updateProjectFormValues = exports.updateProjectFormValues = (0, _reduxActions.createAction)(types.updateProjectFormValues);
	var updateSuccessMessage = exports.updateSuccessMessage = (0, _reduxActions.createAction)(types.updateSuccessMessage);
	
	var lockCode = exports.lockCode = (0, _reduxActions.createAction)(types.lockCode);
	var unlockCode = exports.unlockCode = (0, _reduxActions.createAction)(types.unlockCode);
	var disableJSOnError = exports.disableJSOnError = (0, _reduxActions.createAction)(types.disableJSOnError, function (_ref) {
	  var payload = _ref.payload;
	
	  console.error(JSON.stringify(payload));
	  return null;
	});
	var storedCodeFound = exports.storedCodeFound = (0, _reduxActions.createAction)(types.storedCodeFound);
	var noStoredCodeFound = exports.noStoredCodeFound = (0, _reduxActions.createAction)(types.noStoredCodeFound);
	
	var closeModal = exports.closeModal = (0, _reduxActions.createAction)(types.closeModal);
	var openModal = exports.openModal = (0, _reduxActions.createAction)(types.openModal, function (modal) {
	  var modalType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  return { modal: modal, modalType: modalType };
	});
	
	var challengeMounted = exports.challengeMounted = (0, _reduxActions.createAction)(types.challengeMounted);
	var checkChallenge = exports.checkChallenge = (0, _reduxActions.createAction)(types.checkChallenge);
	var executeChallenge = exports.executeChallenge = (0, _reduxActions.createAction)(types.executeChallenge);
	var resetChallenge = exports.resetChallenge = (0, _reduxActions.createAction)(types.resetChallenge);
	var submitChallenge = exports.submitChallenge = (0, _reduxActions.createAction)(types.submitChallenge);
	var submitComplete = exports.submitComplete = (0, _reduxActions.createAction)(types.submitComplete);
	
	var challengeFilesSelector = exports.challengeFilesSelector = function challengeFilesSelector(state) {
	  return state[ns].challengeFiles;
	};
	var challengeMetaSelector = exports.challengeMetaSelector = function challengeMetaSelector(state) {
	  return state[ns].challengeMeta;
	};
	var challengeTestsSelector = exports.challengeTestsSelector = function challengeTestsSelector(state) {
	  return state[ns].challengeTests;
	};
	var consoleOutputSelector = exports.consoleOutputSelector = function consoleOutputSelector(state) {
	  return state[ns].consoleOut;
	};
	var isCodeLockedSelector = exports.isCodeLockedSelector = function isCodeLockedSelector(state) {
	  return state[ns].isCodeLocked;
	};
	var isCompletionModalOpenSelector = exports.isCompletionModalOpenSelector = function isCompletionModalOpenSelector(state) {
	  return state[ns].modal.completion.open;
	};
	var isHelpModalOpenSelector = exports.isHelpModalOpenSelector = function isHelpModalOpenSelector(state) {
	  return state[ns].modal.help.open;
	};
	var helpModalTypeSelector = exports.helpModalTypeSelector = function helpModalTypeSelector(state) {
	  return state[ns].modal.help.type;
	};
	var isHintModalOpenSelector = exports.isHintModalOpenSelector = function isHintModalOpenSelector(state) {
	  return state[ns].modal.hint.open;
	};
	var isResetModalOpenSelector = exports.isResetModalOpenSelector = function isResetModalOpenSelector(state) {
	  return state[ns].modal.reset.open;
	};
	var isJSEnabledSelector = exports.isJSEnabledSelector = function isJSEnabledSelector(state) {
	  return state[ns].isJSEnabled;
	};
	var successMessageSelector = exports.successMessageSelector = function successMessageSelector(state) {
	  return state[ns].successMessage;
	};
	
	var backendFormValuesSelector = exports.backendFormValuesSelector = function backendFormValuesSelector(state) {
	  return state.form[backendNS];
	};
	var projectFormVaulesSelector = exports.projectFormVaulesSelector = function projectFormVaulesSelector(state) {
	  return state[ns].projectFormVaules || {};
	};
	
	var reducer = exports.reducer = (0, _reduxActions.handleActions)((_handleActions = {}, _handleActions[types.createFiles] = function (state, _ref2) {
	  var payload = _ref2.payload;
	  return _extends({}, state, {
	    challengeFiles: payload
	  });
	}, _handleActions[types.updateFile] = function (state, _ref3) {
	  var _extends3;
	
	  var _ref3$payload = _ref3.payload,
	      key = _ref3$payload.key,
	      editorValue = _ref3$payload.editorValue;
	  return _extends({}, state, {
	    challengeFiles: _extends({}, state.challengeFiles, (_extends3 = {}, _extends3[key] = _extends({}, state.challengeFiles[key], {
	      contents: editorValue
	    }), _extends3))
	  });
	}, _handleActions[types.storedCodeFound] = function (state, _ref4) {
	  var payload = _ref4.payload;
	  return _extends({}, state, {
	    challengeFiles: payload
	  });
	}, _handleActions[types.initTests] = function (state, _ref5) {
	  var payload = _ref5.payload;
	  return _extends({}, state, {
	    challengeTests: payload
	  });
	}, _handleActions[types.updateTests] = function (state, _ref6) {
	  var payload = _ref6.payload;
	  return _extends({}, state, {
	    challengeTests: payload
	  });
	}, _handleActions[types.initConsole] = function (state, _ref7) {
	  var payload = _ref7.payload;
	  return _extends({}, state, {
	    consoleOut: payload
	  });
	}, _handleActions[types.updateConsole] = function (state, _ref8) {
	  var payload = _ref8.payload;
	  return _extends({}, state, {
	    consoleOut: state.consoleOut + '\n' + payload
	  });
	}, _handleActions[types.updateChallengeMeta] = function (state, _ref9) {
	  var payload = _ref9.payload;
	  return _extends({}, state, {
	    challengeMeta: _extends({}, payload)
	  });
	}, _handleActions[types.resetChallenge] = function (state) {
	  return _extends({}, state, {
	    challengeFiles: _extends({}, Object.keys(state.challengeFiles).map(function (key) {
	      return state.challengeFiles[key];
	    }).reduce(function (files, file) {
	      var _extends4;
	
	      return _extends({}, files, (_extends4 = {}, _extends4[file.key] = _extends({}, file, {
	        contents: file.seed.slice()
	      }), _extends4));
	    }, {})),
	    challengeTests: state.challengeTests.map(function (_ref10) {
	      var text = _ref10.text,
	          testString = _ref10.testString;
	      return {
	        text: text,
	        testString: testString
	      };
	    }),
	    consoleOut: ''
	  });
	}, _handleActions[types.updateProjectFormValues] = function (state, _ref11) {
	  var payload = _ref11.payload;
	  return _extends({}, state, {
	    projectFormVaules: payload
	  });
	}, _handleActions[types.lockCode] = function (state) {
	  return _extends({}, state, {
	    isCodeLocked: true
	  });
	}, _handleActions[types.unlockCode] = function (state) {
	  return _extends({}, state, {
	    isJSEnabled: true,
	    isCodeLocked: false
	  });
	}, _handleActions[types.disableJSOnError] = function (state) {
	  return _extends({}, state, {
	    isJSEnabled: false
	  });
	}, _handleActions[types.updateSuccessMessage] = function (state, _ref12) {
	  var payload = _ref12.payload;
	  return _extends({}, state, {
	    successMessage: payload
	  });
	}, _handleActions[types.openModal] = function (state, _ref13) {
	  var _extends5;
	
	  var _ref13$payload = _ref13.payload,
	      modal = _ref13$payload.modal,
	      modalType = _ref13$payload.modalType;
	  return _extends({}, state, {
	    modal: _extends({}, state.modal, (_extends5 = {}, _extends5[modal] = { open: true, type: modalType === null ? state.modal[modal].type : modalType }, _extends5))
	  });
	}, _handleActions[types.closeModal] = function (state, _ref14) {
	  var _extends6;
	
	  var payload = _ref14.payload;
	  return _extends({}, state, {
	    modal: _extends({}, state.modal, (_extends6 = {}, _extends6[payload] = { open: false, type: null }, _extends6))
	  });
	}, _handleActions), initialState);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.4' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(4401);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(719);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(4402);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var AsyncAction_1 = __webpack_require__(268);
	var AsyncScheduler_1 = __webpack_require__(269);
	/**
	 *
	 * Async Scheduler
	 *
	 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
	 *
	 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
	 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
	 * in intervals.
	 *
	 * If you just want to "defer" task, that is to perform it right after currently
	 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
	 * better choice will be the {@link asap} scheduler.
	 *
	 * @example <caption>Use async scheduler to delay task</caption>
	 * const task = () => console.log('it works!');
	 *
	 * Rx.Scheduler.async.schedule(task, 2000);
	 *
	 * // After 2 seconds logs:
	 * // "it works!"
	 *
	 *
	 * @example <caption>Use async scheduler to repeat task in intervals</caption>
	 * function task(state) {
	 *   console.log(state);
	 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
	 *                                   // which we reschedule with new state and delay
	 * }
	 *
	 * Rx.Scheduler.async.schedule(task, 3000, 0);
	 *
	 * // Logs:
	 * // 0 after 3s
	 * // 1 after 4s
	 * // 2 after 5s
	 * // 3 after 6s
	 *
	 * @static true
	 * @name async
	 * @owner Scheduler
	 */
	exports.async = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
	//# sourceMappingURL=async.js.map

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(755);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(4451);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(4450);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(4449);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(754);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(756);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(40);
	var core = __webpack_require__(21);
	var ctx = __webpack_require__(85);
	var hide = __webpack_require__(95);
	var has = __webpack_require__(94);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var Size = exports.Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	
	var SIZE_MAP = exports.SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	
	var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	
	var State = exports.State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	
	var Style = exports.Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	var Subscriber_1 = __webpack_require__(11);
	var Subscription_1 = __webpack_require__(31);
	var ObjectUnsubscribedError_1 = __webpack_require__(358);
	var SubjectSubscription_1 = __webpack_require__(761);
	var rxSubscriber_1 = __webpack_require__(356);
	/**
	 * @class SubjectSubscriber<T>
	 */
	var SubjectSubscriber = (function (_super) {
	    __extends(SubjectSubscriber, _super);
	    function SubjectSubscriber(destination) {
	        _super.call(this, destination);
	        this.destination = destination;
	    }
	    return SubjectSubscriber;
	}(Subscriber_1.Subscriber));
	exports.SubjectSubscriber = SubjectSubscriber;
	/**
	 * @class Subject<T>
	 */
	var Subject = (function (_super) {
	    __extends(Subject, _super);
	    function Subject() {
	        _super.call(this);
	        this.observers = [];
	        this.closed = false;
	        this.isStopped = false;
	        this.hasError = false;
	        this.thrownError = null;
	    }
	    Subject.prototype[rxSubscriber_1.rxSubscriber] = function () {
	        return new SubjectSubscriber(this);
	    };
	    Subject.prototype.lift = function (operator) {
	        var subject = new AnonymousSubject(this, this);
	        subject.operator = operator;
	        return subject;
	    };
	    Subject.prototype.next = function (value) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        if (!this.isStopped) {
	            var observers = this.observers;
	            var len = observers.length;
	            var copy = observers.slice();
	            for (var i = 0; i < len; i++) {
	                copy[i].next(value);
	            }
	        }
	    };
	    Subject.prototype.error = function (err) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        this.hasError = true;
	        this.thrownError = err;
	        this.isStopped = true;
	        var observers = this.observers;
	        var len = observers.length;
	        var copy = observers.slice();
	        for (var i = 0; i < len; i++) {
	            copy[i].error(err);
	        }
	        this.observers.length = 0;
	    };
	    Subject.prototype.complete = function () {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        this.isStopped = true;
	        var observers = this.observers;
	        var len = observers.length;
	        var copy = observers.slice();
	        for (var i = 0; i < len; i++) {
	            copy[i].complete();
	        }
	        this.observers.length = 0;
	    };
	    Subject.prototype.unsubscribe = function () {
	        this.isStopped = true;
	        this.closed = true;
	        this.observers = null;
	    };
	    Subject.prototype._trySubscribe = function (subscriber) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else {
	            return _super.prototype._trySubscribe.call(this, subscriber);
	        }
	    };
	    Subject.prototype._subscribe = function (subscriber) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else if (this.hasError) {
	            subscriber.error(this.thrownError);
	            return Subscription_1.Subscription.EMPTY;
	        }
	        else if (this.isStopped) {
	            subscriber.complete();
	            return Subscription_1.Subscription.EMPTY;
	        }
	        else {
	            this.observers.push(subscriber);
	            return new SubjectSubscription_1.SubjectSubscription(this, subscriber);
	        }
	    };
	    Subject.prototype.asObservable = function () {
	        var observable = new Observable_1.Observable();
	        observable.source = this;
	        return observable;
	    };
	    Subject.create = function (destination, source) {
	        return new AnonymousSubject(destination, source);
	    };
	    return Subject;
	}(Observable_1.Observable));
	exports.Subject = Subject;
	/**
	 * @class AnonymousSubject<T>
	 */
	var AnonymousSubject = (function (_super) {
	    __extends(AnonymousSubject, _super);
	    function AnonymousSubject(destination, source) {
	        _super.call(this);
	        this.destination = destination;
	        this.source = source;
	    }
	    AnonymousSubject.prototype.next = function (value) {
	        var destination = this.destination;
	        if (destination && destination.next) {
	            destination.next(value);
	        }
	    };
	    AnonymousSubject.prototype.error = function (err) {
	        var destination = this.destination;
	        if (destination && destination.error) {
	            this.destination.error(err);
	        }
	    };
	    AnonymousSubject.prototype.complete = function () {
	        var destination = this.destination;
	        if (destination && destination.complete) {
	            this.destination.complete();
	        }
	    };
	    AnonymousSubject.prototype._subscribe = function (subscriber) {
	        var source = this.source;
	        if (source) {
	            return this.source.subscribe(subscriber);
	        }
	        else {
	            return Subscription_1.Subscription.EMPTY;
	        }
	    };
	    return AnonymousSubject;
	}(Subject));
	exports.AnonymousSubject = AnonymousSubject;
	//# sourceMappingURL=Subject.js.map

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isArray_1 = __webpack_require__(81);
	var isObject_1 = __webpack_require__(857);
	var isFunction_1 = __webpack_require__(360);
	var tryCatch_1 = __webpack_require__(34);
	var errorObject_1 = __webpack_require__(32);
	var UnsubscriptionError_1 = __webpack_require__(853);
	/**
	 * Represents a disposable resource, such as the execution of an Observable. A
	 * Subscription has one important method, `unsubscribe`, that takes no argument
	 * and just disposes the resource held by the subscription.
	 *
	 * Additionally, subscriptions may be grouped together through the `add()`
	 * method, which will attach a child Subscription to the current Subscription.
	 * When a Subscription is unsubscribed, all its children (and its grandchildren)
	 * will be unsubscribed as well.
	 *
	 * @class Subscription
	 */
	var Subscription = (function () {
	    /**
	     * @param {function(): void} [unsubscribe] A function describing how to
	     * perform the disposal of resources when the `unsubscribe` method is called.
	     */
	    function Subscription(unsubscribe) {
	        /**
	         * A flag to indicate whether this Subscription has already been unsubscribed.
	         * @type {boolean}
	         */
	        this.closed = false;
	        this._parent = null;
	        this._parents = null;
	        this._subscriptions = null;
	        if (unsubscribe) {
	            this._unsubscribe = unsubscribe;
	        }
	    }
	    /**
	     * Disposes the resources held by the subscription. May, for instance, cancel
	     * an ongoing Observable execution or cancel any other type of work that
	     * started when the Subscription was created.
	     * @return {void}
	     */
	    Subscription.prototype.unsubscribe = function () {
	        var hasErrors = false;
	        var errors;
	        if (this.closed) {
	            return;
	        }
	        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
	        this.closed = true;
	        this._parent = null;
	        this._parents = null;
	        // null out _subscriptions first so any child subscriptions that attempt
	        // to remove themselves from this subscription will noop
	        this._subscriptions = null;
	        var index = -1;
	        var len = _parents ? _parents.length : 0;
	        // if this._parent is null, then so is this._parents, and we
	        // don't have to remove ourselves from any parent subscriptions.
	        while (_parent) {
	            _parent.remove(this);
	            // if this._parents is null or index >= len,
	            // then _parent is set to null, and the loop exits
	            _parent = ++index < len && _parents[index] || null;
	        }
	        if (isFunction_1.isFunction(_unsubscribe)) {
	            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
	            if (trial === errorObject_1.errorObject) {
	                hasErrors = true;
	                errors = errors || (errorObject_1.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ?
	                    flattenUnsubscriptionErrors(errorObject_1.errorObject.e.errors) : [errorObject_1.errorObject.e]);
	            }
	        }
	        if (isArray_1.isArray(_subscriptions)) {
	            index = -1;
	            len = _subscriptions.length;
	            while (++index < len) {
	                var sub = _subscriptions[index];
	                if (isObject_1.isObject(sub)) {
	                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
	                    if (trial === errorObject_1.errorObject) {
	                        hasErrors = true;
	                        errors = errors || [];
	                        var err = errorObject_1.errorObject.e;
	                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
	                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
	                        }
	                        else {
	                            errors.push(err);
	                        }
	                    }
	                }
	            }
	        }
	        if (hasErrors) {
	            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
	        }
	    };
	    /**
	     * Adds a tear down to be called during the unsubscribe() of this
	     * Subscription.
	     *
	     * If the tear down being added is a subscription that is already
	     * unsubscribed, is the same reference `add` is being called on, or is
	     * `Subscription.EMPTY`, it will not be added.
	     *
	     * If this subscription is already in an `closed` state, the passed
	     * tear down logic will be executed immediately.
	     *
	     * @param {TeardownLogic} teardown The additional logic to execute on
	     * teardown.
	     * @return {Subscription} Returns the Subscription used or created to be
	     * added to the inner subscriptions list. This Subscription can be used with
	     * `remove()` to remove the passed teardown logic from the inner subscriptions
	     * list.
	     */
	    Subscription.prototype.add = function (teardown) {
	        if (!teardown || (teardown === Subscription.EMPTY)) {
	            return Subscription.EMPTY;
	        }
	        if (teardown === this) {
	            return this;
	        }
	        var subscription = teardown;
	        switch (typeof teardown) {
	            case 'function':
	                subscription = new Subscription(teardown);
	            case 'object':
	                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
	                    return subscription;
	                }
	                else if (this.closed) {
	                    subscription.unsubscribe();
	                    return subscription;
	                }
	                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
	                    var tmp = subscription;
	                    subscription = new Subscription();
	                    subscription._subscriptions = [tmp];
	                }
	                break;
	            default:
	                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
	        }
	        var subscriptions = this._subscriptions || (this._subscriptions = []);
	        subscriptions.push(subscription);
	        subscription._addParent(this);
	        return subscription;
	    };
	    /**
	     * Removes a Subscription from the internal list of subscriptions that will
	     * unsubscribe during the unsubscribe process of this Subscription.
	     * @param {Subscription} subscription The subscription to remove.
	     * @return {void}
	     */
	    Subscription.prototype.remove = function (subscription) {
	        var subscriptions = this._subscriptions;
	        if (subscriptions) {
	            var subscriptionIndex = subscriptions.indexOf(subscription);
	            if (subscriptionIndex !== -1) {
	                subscriptions.splice(subscriptionIndex, 1);
	            }
	        }
	    };
	    Subscription.prototype._addParent = function (parent) {
	        var _a = this, _parent = _a._parent, _parents = _a._parents;
	        if (!_parent || _parent === parent) {
	            // If we don't have a parent, or the new parent is the same as the
	            // current parent, then set this._parent to the new parent.
	            this._parent = parent;
	        }
	        else if (!_parents) {
	            // If there's already one parent, but not multiple, allocate an Array to
	            // store the rest of the parent Subscriptions.
	            this._parents = [parent];
	        }
	        else if (_parents.indexOf(parent) === -1) {
	            // Only add the new parent to the _parents list if it's not already there.
	            _parents.push(parent);
	        }
	    };
	    Subscription.EMPTY = (function (empty) {
	        empty.closed = true;
	        return empty;
	    }(new Subscription()));
	    return Subscription;
	}());
	exports.Subscription = Subscription;
	function flattenUnsubscriptionErrors(errors) {
	    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
	}
	//# sourceMappingURL=Subscription.js.map

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	"use strict";
	// typeof any so that it we don't have to cast when comparing a result to the error object
	exports.errorObject = { e: {} };
	//# sourceMappingURL=errorObject.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var errorObject_1 = __webpack_require__(32);
	var tryCatchTarget;
	function tryCatcher() {
	    try {
	        return tryCatchTarget.apply(this, arguments);
	    }
	    catch (e) {
	        errorObject_1.errorObject.e = e;
	        return errorObject_1.errorObject;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	exports.tryCatch = tryCatch;
	;
	//# sourceMappingURL=tryCatch.js.map

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	module.exports = exports['default'];

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	// CommonJS / Node have global context exposed as "global" variable.
	// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
	// the global "global" var for now.
	var __window = typeof window !== 'undefined' && window;
	var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
	    self instanceof WorkerGlobalScope && self;
	var __global = typeof global !== 'undefined' && global;
	var _root = __window || __global || __self;
	exports.root = _root;
	// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
	// This is needed when used with angular/tsickle which inserts a goog.module statement.
	// Wrap in IIFE
	(function () {
	    if (!_root) {
	        throw new Error('RxJS could not find any global context (window, self, global)');
	    }
	})();
	//# sourceMappingURL=root.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(396)('wks');
	var uid = __webpack_require__(297);
	var Symbol = __webpack_require__(40).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(662);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
	  if (prev === null || next === null || prev.length !== next.length) {
	    return false;
	  }
	
	  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
	  var length = prev.length;
	  for (var i = 0; i < length; i++) {
	    if (!equalityCheck(prev[i], next[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
	
	  var lastArgs = null;
	  var lastResult = null;
	  // we reference arguments instead of spreading them for performance reasons
	  return function () {
	    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
	      // apply arguments instead of spreading for performance.
	      lastResult = func.apply(null, arguments);
	    }
	
	    lastArgs = arguments;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    memoizeOptions[_key - 1] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      funcs[_key2] = arguments[_key2];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      // apply arguments instead of spreading for performance.
	      return resultFunc.apply(null, arguments);
	    }].concat(memoizeOptions));
	
	    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
	    var selector = defaultMemoize(function () {
	      var params = [];
	      var length = dependencies.length;
	
	      for (var i = 0; i < length; i++) {
	        // apply arguments instead of spreading and mutate a local list of params for performance.
	        params.push(dependencies[i].apply(null, arguments));
	      }
	
	      // apply arguments instead of spreading for performance.
	      return memoizedResultFunc.apply(null, params);
	    });
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      values[_key3] = arguments[_key3];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(592)('wks');
	var uid = __webpack_require__(411);
	var Symbol = __webpack_require__(52).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerDocument;
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	module.exports = exports["default"];

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(195);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(18);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(13);
	
	var _StyleConfig = __webpack_require__(29);
	
	var _SafeAnchor = __webpack_require__(4384);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  active: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  block: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  componentClass: _elementType2.default,
	  href: _propTypes2.default.string,
	  /**
	   * Defines HTML button type attribute
	   * @defaultValue 'button'
	   */
	  type: _propTypes2.default.oneOf(['button', 'reset', 'submit'])
	};
	
	var defaultProps = {
	  active: false,
	  block: false,
	  disabled: false
	};
	
	var Button = function (_React$Component) {
	  (0, _inherits3.default)(Button, _React$Component);
	
	  function Button() {
	    (0, _classCallCheck3.default)(this, Button);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
	    return _react2.default.createElement(_SafeAnchor2.default, (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, elementProps.disabled && 'disabled')
	    }));
	  };
	
	  Button.prototype.renderButton = function renderButton(_ref, className) {
	    var componentClass = _ref.componentClass,
	        elementProps = (0, _objectWithoutProperties3.default)(_ref, ['componentClass']);
	
	    var Component = componentClass || 'button';
	
	    return _react2.default.createElement(Component, (0, _extends4.default)({}, elementProps, {
	      type: elementProps.type || 'button',
	      className: className
	    }));
	  };
	
	  Button.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        active = _props.active,
	        block = _props.block,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['active', 'block', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
	    var fullClassName = (0, _classnames2.default)(className, classes);
	
	    if (elementProps.href) {
	      return this.renderAnchor(elementProps, fullClassName);
	    }
	
	    return this.renderButton(elementProps, fullClassName);
	  };
	
	  return Button;
	}(_react2.default.Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2.default)(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
	module.exports = exports['default'];

/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(4245);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","PUBLIC_DIR":"/usr/share/nginx/html/learn-master_ch/public"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(4781);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(4780);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(78)))

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.reducer = exports.shouldShowDonationSelector = exports.isHelpModalOpenSelector = exports.currentChallengeIdSelector = exports.completedChallengesSelector = exports.userStateLoadingSelector = exports.userSelector = exports.isSignedInSelector = exports.isDonationModalOpenSelector = exports.completionCountSelector = exports.closeHelpModal = exports.openHelpModal = exports.updateUserSignedIn = exports.closeDonationModal = exports.openDonationModal = exports.hardGoTo = exports.noUserFound = exports.fetchUserError = exports.fetchUserComplete = exports.fetchUser = exports.types = exports.epics = undefined;
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxActions = __webpack_require__(342);
	
	var _uniqBy = __webpack_require__(4347);
	
	var _uniqBy2 = _interopRequireDefault(_uniqBy);
	
	var _stateManagment = __webpack_require__(283);
	
	var _redux = __webpack_require__(19);
	
	var _fetchUserEpic = __webpack_require__(893);
	
	var _fetchUserEpic2 = _interopRequireDefault(_fetchUserEpic);
	
	var _hardGoToEpic = __webpack_require__(894);
	
	var _hardGoToEpic2 = _interopRequireDefault(_hardGoToEpic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ns = 'app';
	
	var epics = exports.epics = [_fetchUserEpic2.default, _hardGoToEpic2.default];
	
	var types = exports.types = (0, _stateManagment.createTypes)(['fetchUser', 'fetchUserComplete', 'fetchUserError', 'noUserFound', 'hardGoTo', 'updateUserSignedIn', 'openDonationModal', 'closeDonationModal', 'openHelpModal', // Added for HelpModal
	'closeHelpModal' // Added for HelpModal
	], ns);
	
	var initialState = {
	  appUsername: '',
	  completionCount: 0,
	  showLoading: true,
	  isSignedIn: false,
	  user: {},
	  showDonationModal: false,
	  helpModalOpen: false
	};
	
	var fetchUser = exports.fetchUser = (0, _reduxActions.createAction)(types.fetchUser);
	var fetchUserComplete = exports.fetchUserComplete = (0, _reduxActions.createAction)(types.fetchUserComplete);
	var fetchUserError = exports.fetchUserError = (0, _reduxActions.createAction)(types.fetchUserError);
	var noUserFound = exports.noUserFound = (0, _reduxActions.createAction)(types.noUserFound);
	
	var hardGoTo = exports.hardGoTo = (0, _reduxActions.createAction)(types.hardGoTo);
	
	var openDonationModal = exports.openDonationModal = (0, _reduxActions.createAction)(types.openDonationModal);
	var closeDonationModal = exports.closeDonationModal = (0, _reduxActions.createAction)(types.closeDonationModal);
	
	var updateUserSignedIn = exports.updateUserSignedIn = (0, _reduxActions.createAction)(types.updateUserSignedIn);
	
	var openHelpModal = exports.openHelpModal = (0, _reduxActions.createAction)(types.openHelpModal);
	var closeHelpModal = exports.closeHelpModal = (0, _reduxActions.createAction)(types.closeHelpModal);
	
	var completionCountSelector = exports.completionCountSelector = function completionCountSelector(state) {
	  return state[ns].completionCount;
	};
	var isDonationModalOpenSelector = exports.isDonationModalOpenSelector = function isDonationModalOpenSelector(state) {
	  return state[ns].showDonationModal;
	};
	var isSignedInSelector = exports.isSignedInSelector = function isSignedInSelector(state) {
	  return state[ns].isSignedIn;
	};
	var userSelector = exports.userSelector = function userSelector(state) {
	  return state[ns].user || {};
	};
	var userStateLoadingSelector = exports.userStateLoadingSelector = function userStateLoadingSelector(state) {
	  return state[ns].showLoading;
	};
	var completedChallengesSelector = exports.completedChallengesSelector = function completedChallengesSelector(state) {
	  return userSelector(state).completedChallenges || [];
	};
	var currentChallengeIdSelector = exports.currentChallengeIdSelector = function currentChallengeIdSelector(state) {
	  return userSelector(state).currentChallengeId || '';
	};
	var isHelpModalOpenSelector = exports.isHelpModalOpenSelector = function isHelpModalOpenSelector(state) {
	  return state[ns].helpModalOpen;
	}; // Help Modal selector
	
	var shouldShowDonationSelector = exports.shouldShowDonationSelector = function shouldShowDonationSelector(state) {
	  var completedChallenges = completedChallengesSelector(state);
	  var completionCount = completionCountSelector(state);
	  var currentCompletedLength = completedChallenges.length;
	  // the user has not completed 9 challenges in total yet
	  if (currentCompletedLength < 9) {
	    return false;
	  }
	  // this will mean we are on the 10th submission in total for the user
	  if (completedChallenges.length === 9) {
	    return true;
	  }
	  // this will mean we are on the 3rd submission for this browser session
	  if (completionCount === 2) {
	    return true;
	  }
	  return false;
	};
	
	var reducer = exports.reducer = (0, _reduxActions.handleActions)((_handleActions = {}, _handleActions[types.fetchUserComplete] = function (state, _ref) {
	  var _ref$payload = _ref.payload,
	      user = _ref$payload.entities.user,
	      result = _ref$payload.result;
	  return _extends({}, state, {
	    appUsername: result,
	    user: user[result],
	    showLoading: false,
	    isSignedIn: !!Object.keys(user).length
	  });
	}, _handleActions[types.fetchUserError] = function (state) {
	  return _extends({}, state, { showLoading: false });
	}, _handleActions[types.noUserFound] = function (state) {
	  return _extends({}, state, { showLoading: false });
	}, _handleActions[types.closeDonationModal] = function (state) {
	  return _extends({}, state, {
	    showDonationModal: false
	  });
	}, _handleActions[types.openDonationModal] = function (state) {
	  return _extends({}, state, {
	    showDonationModal: true
	  });
	}, _handleActions[types.updateUserSignedIn] = function (state, _ref2) {
	  var payload = _ref2.payload;
	  return _extends({}, state, {
	    isSignedIn: payload
	  });
	}, _handleActions[types.openHelpModal] = function (state) {
	  return _extends({}, state, {
	    helpModalOpen: true
	  });
	}, _handleActions[types.closeHelpModal] = function (state) {
	  return _extends({}, state, {
	    helpModalOpen: false
	  });
	}, _handleActions[_redux.types.submitComplete] = function (state, _ref3) {
	  var id = _ref3.payload.id;
	  return _extends({}, state, {
	    completionCount: state.completionCount + 1,
	    user: _extends({}, state.user, {
	      completedChallenges: (0, _uniqBy2.default)([].concat(state.user.completedChallenges, [{ id: id }]), 'id')
	    })
	  });
	}, _handleActions), initialState);

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(46);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(57);
	var IE8_DOM_DEFINE = __webpack_require__(563);
	var toPrimitive = __webpack_require__(398);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(70) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(4232),
	    baseMatchesProperty = __webpack_require__(647),
	    identity = __webpack_require__(53),
	    isArray = __webpack_require__(24),
	    property = __webpack_require__(4336);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports) {

	"use strict";
	function isScheduler(value) {
	    return value && typeof value.schedule === 'function';
	}
	exports.isScheduler = isScheduler;
	//# sourceMappingURL=isScheduler.js.map

/***/ }),
/* 66 */,
/* 67 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactGa = __webpack_require__(4390);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactGa2.default.initialize('UA-124741864-2');
	
	exports.default = _reactGa2.default;
	module.exports = exports['default'];

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	/*!
	 * Chai - flag utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/**
	 * ### .flag(object, key, [value])
	 *
	 * Get or set a flag value on an object. If a
	 * value is provided it will be set, else it will
	 * return the currently set value or `undefined` if
	 * the value is not set.
	 *
	 *     utils.flag(this, 'foo', 'bar'); // setter
	 *     utils.flag(this, 'foo'); // getter, returns `bar`
	 *
	 * @param {Object} object constructed Assertion
	 * @param {String} key
	 * @param {Mixed} value (optional)
	 * @namespace Utils
	 * @name flag
	 * @api private
	 */
	
	module.exports = function flag(obj, key, value) {
	  var flags = obj.__flags || (obj.__flags = Object.create(null));
	  if (arguments.length === 3) {
	    flags[key] = value;
	  } else {
	    return flags[key];
	  }
	};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(93)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(181),
	    getRawTag = __webpack_require__(4268),
	    objectToString = __webpack_require__(4297);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(53),
	    overRest = __webpack_require__(674),
	    setToString = __webpack_require__(461);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(102),
	    isLength = __webpack_require__(473);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(72),
	    getPrototype = __webpack_require__(456),
	    isObjectLike = __webpack_require__(43);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(640),
	    baseKeys = __webpack_require__(646),
	    isArrayLike = __webpack_require__(74);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	'use strict';
	
	var NS = exports.NAMESPACES = {
	    HTML: 'http://www.w3.org/1999/xhtml',
	    MATHML: 'http://www.w3.org/1998/Math/MathML',
	    SVG: 'http://www.w3.org/2000/svg',
	    XLINK: 'http://www.w3.org/1999/xlink',
	    XML: 'http://www.w3.org/XML/1998/namespace',
	    XMLNS: 'http://www.w3.org/2000/xmlns/'
	};
	
	exports.ATTRS = {
	    TYPE: 'type',
	    ACTION: 'action',
	    ENCODING: 'encoding',
	    PROMPT: 'prompt',
	    NAME: 'name',
	    COLOR: 'color',
	    FACE: 'face',
	    SIZE: 'size'
	};
	
	exports.DOCUMENT_MODE = {
	    NO_QUIRKS: 'no-quirks',
	    QUIRKS: 'quirks',
	    LIMITED_QUIRKS: 'limited-quirks'
	};
	
	var $ = exports.TAG_NAMES = {
	    A: 'a',
	    ADDRESS: 'address',
	    ANNOTATION_XML: 'annotation-xml',
	    APPLET: 'applet',
	    AREA: 'area',
	    ARTICLE: 'article',
	    ASIDE: 'aside',
	
	    B: 'b',
	    BASE: 'base',
	    BASEFONT: 'basefont',
	    BGSOUND: 'bgsound',
	    BIG: 'big',
	    BLOCKQUOTE: 'blockquote',
	    BODY: 'body',
	    BR: 'br',
	    BUTTON: 'button',
	
	    CAPTION: 'caption',
	    CENTER: 'center',
	    CODE: 'code',
	    COL: 'col',
	    COLGROUP: 'colgroup',
	
	    DD: 'dd',
	    DESC: 'desc',
	    DETAILS: 'details',
	    DIALOG: 'dialog',
	    DIR: 'dir',
	    DIV: 'div',
	    DL: 'dl',
	    DT: 'dt',
	
	    EM: 'em',
	    EMBED: 'embed',
	
	    FIELDSET: 'fieldset',
	    FIGCAPTION: 'figcaption',
	    FIGURE: 'figure',
	    FONT: 'font',
	    FOOTER: 'footer',
	    FOREIGN_OBJECT: 'foreignObject',
	    FORM: 'form',
	    FRAME: 'frame',
	    FRAMESET: 'frameset',
	
	    H1: 'h1',
	    H2: 'h2',
	    H3: 'h3',
	    H4: 'h4',
	    H5: 'h5',
	    H6: 'h6',
	    HEAD: 'head',
	    HEADER: 'header',
	    HGROUP: 'hgroup',
	    HR: 'hr',
	    HTML: 'html',
	
	    I: 'i',
	    IMG: 'img',
	    IMAGE: 'image',
	    INPUT: 'input',
	    IFRAME: 'iframe',
	
	    KEYGEN: 'keygen',
	
	    LABEL: 'label',
	    LI: 'li',
	    LINK: 'link',
	    LISTING: 'listing',
	
	    MAIN: 'main',
	    MALIGNMARK: 'malignmark',
	    MARQUEE: 'marquee',
	    MATH: 'math',
	    MENU: 'menu',
	    MENUITEM: 'menuitem',
	    META: 'meta',
	    MGLYPH: 'mglyph',
	    MI: 'mi',
	    MO: 'mo',
	    MN: 'mn',
	    MS: 'ms',
	    MTEXT: 'mtext',
	
	    NAV: 'nav',
	    NOBR: 'nobr',
	    NOFRAMES: 'noframes',
	    NOEMBED: 'noembed',
	    NOSCRIPT: 'noscript',
	
	    OBJECT: 'object',
	    OL: 'ol',
	    OPTGROUP: 'optgroup',
	    OPTION: 'option',
	
	    P: 'p',
	    PARAM: 'param',
	    PLAINTEXT: 'plaintext',
	    PRE: 'pre',
	
	    RB: 'rb',
	    RP: 'rp',
	    RT: 'rt',
	    RTC: 'rtc',
	    RUBY: 'ruby',
	
	    S: 's',
	    SCRIPT: 'script',
	    SECTION: 'section',
	    SELECT: 'select',
	    SOURCE: 'source',
	    SMALL: 'small',
	    SPAN: 'span',
	    STRIKE: 'strike',
	    STRONG: 'strong',
	    STYLE: 'style',
	    SUB: 'sub',
	    SUMMARY: 'summary',
	    SUP: 'sup',
	
	    TABLE: 'table',
	    TBODY: 'tbody',
	    TEMPLATE: 'template',
	    TEXTAREA: 'textarea',
	    TFOOT: 'tfoot',
	    TD: 'td',
	    TH: 'th',
	    THEAD: 'thead',
	    TITLE: 'title',
	    TR: 'tr',
	    TRACK: 'track',
	    TT: 'tt',
	
	    U: 'u',
	    UL: 'ul',
	
	    SVG: 'svg',
	
	    VAR: 'var',
	
	    WBR: 'wbr',
	
	    XMP: 'xmp'
	};
	
	var SPECIAL_ELEMENTS = exports.SPECIAL_ELEMENTS = Object.create(null);
	
	SPECIAL_ELEMENTS[NS.HTML] = Object.create(null);
	SPECIAL_ELEMENTS[NS.HTML][$.ADDRESS] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.APPLET] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.AREA] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.ARTICLE] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.ASIDE] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.BASE] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.BASEFONT] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.BGSOUND] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.BLOCKQUOTE] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.BODY] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.BR] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.BUTTON] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.CAPTION] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.CENTER] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.COL] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.COLGROUP] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.DD] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.DETAILS] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.DIR] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.DIV] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.DL] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.DT] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.EMBED] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.FIELDSET] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.FIGCAPTION] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.FIGURE] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.FOOTER] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.FORM] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.FRAME] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.FRAMESET] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.H1] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.H2] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.H3] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.H4] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.H5] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.H6] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.HEAD] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.HEADER] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.HGROUP] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.HR] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.HTML] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.IFRAME] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.IMG] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.INPUT] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.LI] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.LINK] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.LISTING] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.MAIN] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.MARQUEE] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.MENU] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.META] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.NAV] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.NOEMBED] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.NOFRAMES] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.NOSCRIPT] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.OBJECT] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.OL] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.P] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.PARAM] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.PLAINTEXT] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.PRE] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.SCRIPT] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.SECTION] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.SELECT] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.SOURCE] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.STYLE] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.SUMMARY] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.TABLE] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.TBODY] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.TD] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.TEMPLATE] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.TEXTAREA] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.TFOOT] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.TH] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.THEAD] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.TITLE] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.TR] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.TRACK] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.UL] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.WBR] = true;
	SPECIAL_ELEMENTS[NS.HTML][$.XMP] = true;
	
	SPECIAL_ELEMENTS[NS.MATHML] = Object.create(null);
	SPECIAL_ELEMENTS[NS.MATHML][$.MI] = true;
	SPECIAL_ELEMENTS[NS.MATHML][$.MO] = true;
	SPECIAL_ELEMENTS[NS.MATHML][$.MN] = true;
	SPECIAL_ELEMENTS[NS.MATHML][$.MS] = true;
	SPECIAL_ELEMENTS[NS.MATHML][$.MTEXT] = true;
	SPECIAL_ELEMENTS[NS.MATHML][$.ANNOTATION_XML] = true;
	
	SPECIAL_ELEMENTS[NS.SVG] = Object.create(null);
	SPECIAL_ELEMENTS[NS.SVG][$.TITLE] = true;
	SPECIAL_ELEMENTS[NS.SVG][$.FOREIGN_OBJECT] = true;
	SPECIAL_ELEMENTS[NS.SVG][$.DESC] = true;


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createEpicMiddleware = __webpack_require__(4448);
	
	Object.defineProperty(exports, 'createEpicMiddleware', {
	  enumerable: true,
	  get: function get() {
	    return _createEpicMiddleware.createEpicMiddleware;
	  }
	});
	
	var _ActionsObservable = __webpack_require__(751);
	
	Object.defineProperty(exports, 'ActionsObservable', {
	  enumerable: true,
	  get: function get() {
	    return _ActionsObservable.ActionsObservable;
	  }
	});
	
	var _combineEpics = __webpack_require__(4447);
	
	Object.defineProperty(exports, 'combineEpics', {
	  enumerable: true,
	  get: function get() {
	    return _combineEpics.combineEpics;
	  }
	});
	
	var _EPIC_END = __webpack_require__(752);
	
	Object.defineProperty(exports, 'EPIC_END', {
	  enumerable: true,
	  get: function get() {
	    return _EPIC_END.EPIC_END;
	  }
	});
	
	var _operators = __webpack_require__(753);
	
	Object.defineProperty(exports, 'ofType', {
	  enumerable: true,
	  get: function get() {
	    return _operators.ofType;
	  }
	});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	"use strict";
	exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
	//# sourceMappingURL=isArray.js.map

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1041), __esModule: true };

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1051), __esModule: true };

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _symbol = __webpack_require__(83);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	exports.default = function (code, opts) {
	  var stack = void 0;
	  try {
	    throw new Error();
	  } catch (error) {
	    if (error.stack) {
	      stack = error.stack.split("\n").slice(1).join("\n");
	    }
	  }
	
	  opts = (0, _assign2.default)({
	    allowReturnOutsideFunction: true,
	    allowSuperOutsideMethod: true,
	    preserveComments: false
	  }, opts);
	
	  var _getAst = function getAst() {
	    var ast = void 0;
	
	    try {
	      ast = babylon.parse(code, opts);
	
	      ast = _babelTraverse2.default.removeProperties(ast, { preserveComments: opts.preserveComments });
	
	      _babelTraverse2.default.cheap(ast, function (node) {
	        node[FROM_TEMPLATE] = true;
	      });
	    } catch (err) {
	      err.stack = err.stack + "from\n" + stack;
	      throw err;
	    }
	
	    _getAst = function getAst() {
	      return ast;
	    };
	
	    return ast;
	  };
	
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return useTemplate(_getAst(), args);
	  };
	};
	
	var _cloneDeep = __webpack_require__(4314);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _assign = __webpack_require__(329);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _has = __webpack_require__(684);
	
	var _has2 = _interopRequireDefault(_has);
	
	var _babelTraverse = __webpack_require__(91);
	
	var _babelTraverse2 = _interopRequireDefault(_babelTraverse);
	
	var _babylon = __webpack_require__(554);
	
	var babylon = _interopRequireWildcard(_babylon);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FROM_TEMPLATE = "_fromTemplate";
	var TEMPLATE_SKIP = (0, _symbol2.default)();
	
	function useTemplate(ast, nodes) {
	  ast = (0, _cloneDeep2.default)(ast);
	  var _ast = ast,
	      program = _ast.program;
	
	
	  if (nodes.length) {
	    (0, _babelTraverse2.default)(ast, templateVisitor, null, nodes);
	  }
	
	  if (program.body.length > 1) {
	    return program.body;
	  } else {
	    return program.body[0];
	  }
	}
	
	var templateVisitor = {
	  noScope: true,
	
	  enter: function enter(path, args) {
	    var node = path.node;
	
	    if (node[TEMPLATE_SKIP]) return path.skip();
	
	    if (t.isExpressionStatement(node)) {
	      node = node.expression;
	    }
	
	    var replacement = void 0;
	
	    if (t.isIdentifier(node) && node[FROM_TEMPLATE]) {
	      if ((0, _has2.default)(args[0], node.name)) {
	        replacement = args[0][node.name];
	      } else if (node.name[0] === "$") {
	        var i = +node.name.slice(1);
	        if (args[i]) replacement = args[i];
	      }
	    }
	
	    if (replacement === null) {
	      path.remove();
	    }
	
	    if (replacement) {
	      replacement[TEMPLATE_SKIP] = true;
	      path.replaceInline(replacement);
	    }
	  },
	  exit: function exit(_ref) {
	    var node = _ref.node;
	
	    if (!node.loc) _babelTraverse2.default.clearNode(node);
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(199);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defineProperties = __webpack_require__(96);
	
	var implementation = __webpack_require__(700);
	var getPolyfill = __webpack_require__(701);
	var shim = __webpack_require__(4358);
	
	var polyfill = getPolyfill();
	
	defineProperties(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ }),
/* 87 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports.default = createChainedFunction;
	module.exports = exports['default'];

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* tslint:disable:no-unused-variable */
	// Subject imported before Observable to bypass circular dependency issue since
	// Subject extends Observable and Observable references Subject in it's
	// definition
	var Subject_1 = __webpack_require__(30);
	exports.Subject = Subject_1.Subject;
	exports.AnonymousSubject = Subject_1.AnonymousSubject;
	/* tslint:enable:no-unused-variable */
	var Observable_1 = __webpack_require__(4);
	exports.Observable = Observable_1.Observable;
	// statics
	/* tslint:disable:no-use-before-declare */
	__webpack_require__(4472);
	__webpack_require__(4473);
	__webpack_require__(4474);
	__webpack_require__(4475);
	__webpack_require__(4476);
	__webpack_require__(4479);
	__webpack_require__(4480);
	__webpack_require__(4481);
	__webpack_require__(4482);
	__webpack_require__(4483);
	__webpack_require__(4484);
	__webpack_require__(4485);
	__webpack_require__(4486);
	__webpack_require__(4487);
	__webpack_require__(4488);
	__webpack_require__(4493);
	__webpack_require__(4489);
	__webpack_require__(4490);
	__webpack_require__(4491);
	__webpack_require__(4492);
	__webpack_require__(4494);
	__webpack_require__(4497);
	__webpack_require__(4495);
	__webpack_require__(4496);
	__webpack_require__(4498);
	//dom
	__webpack_require__(4477);
	__webpack_require__(4478);
	//operators
	__webpack_require__(4501);
	__webpack_require__(4502);
	__webpack_require__(4503);
	__webpack_require__(4504);
	__webpack_require__(4505);
	__webpack_require__(4506);
	__webpack_require__(4507);
	__webpack_require__(4508);
	__webpack_require__(4509);
	__webpack_require__(4510);
	__webpack_require__(4511);
	__webpack_require__(4512);
	__webpack_require__(4513);
	__webpack_require__(4519);
	__webpack_require__(4514);
	__webpack_require__(4515);
	__webpack_require__(4516);
	__webpack_require__(4517);
	__webpack_require__(4518);
	__webpack_require__(4520);
	__webpack_require__(4521);
	__webpack_require__(4522);
	__webpack_require__(4523);
	__webpack_require__(4526);
	__webpack_require__(4527);
	__webpack_require__(4528);
	__webpack_require__(4524);
	__webpack_require__(4529);
	__webpack_require__(4530);
	__webpack_require__(4531);
	__webpack_require__(4532);
	__webpack_require__(4533);
	__webpack_require__(4534);
	__webpack_require__(4535);
	__webpack_require__(4536);
	__webpack_require__(4499);
	__webpack_require__(4500);
	__webpack_require__(4537);
	__webpack_require__(4538);
	__webpack_require__(4525);
	__webpack_require__(4539);
	__webpack_require__(4540);
	__webpack_require__(4541);
	__webpack_require__(4542);
	__webpack_require__(4543);
	__webpack_require__(4544);
	__webpack_require__(4545);
	__webpack_require__(4546);
	__webpack_require__(4547);
	__webpack_require__(4548);
	__webpack_require__(4549);
	__webpack_require__(4550);
	__webpack_require__(4551);
	__webpack_require__(4552);
	__webpack_require__(4553);
	__webpack_require__(4554);
	__webpack_require__(4555);
	__webpack_require__(4556);
	__webpack_require__(4558);
	__webpack_require__(4557);
	__webpack_require__(4559);
	__webpack_require__(4560);
	__webpack_require__(4561);
	__webpack_require__(4562);
	__webpack_require__(4563);
	__webpack_require__(4564);
	__webpack_require__(4565);
	__webpack_require__(4566);
	__webpack_require__(4567);
	__webpack_require__(4568);
	__webpack_require__(4569);
	__webpack_require__(4570);
	__webpack_require__(4571);
	__webpack_require__(4572);
	__webpack_require__(4573);
	__webpack_require__(4574);
	__webpack_require__(4575);
	__webpack_require__(4576);
	__webpack_require__(4577);
	__webpack_require__(4578);
	__webpack_require__(4579);
	__webpack_require__(4580);
	__webpack_require__(4581);
	__webpack_require__(4582);
	__webpack_require__(4583);
	__webpack_require__(4584);
	__webpack_require__(4585);
	__webpack_require__(4586);
	__webpack_require__(4587);
	__webpack_require__(4588);
	__webpack_require__(4589);
	__webpack_require__(4590);
	__webpack_require__(4591);
	__webpack_require__(4592);
	__webpack_require__(4593);
	__webpack_require__(4594);
	__webpack_require__(4595);
	__webpack_require__(4596);
	__webpack_require__(4597);
	__webpack_require__(4598);
	__webpack_require__(4599);
	__webpack_require__(4600);
	/* tslint:disable:no-unused-variable */
	var Subscription_1 = __webpack_require__(31);
	exports.Subscription = Subscription_1.Subscription;
	var Subscriber_1 = __webpack_require__(11);
	exports.Subscriber = Subscriber_1.Subscriber;
	var AsyncSubject_1 = __webpack_require__(344);
	exports.AsyncSubject = AsyncSubject_1.AsyncSubject;
	var ReplaySubject_1 = __webpack_require__(345);
	exports.ReplaySubject = ReplaySubject_1.ReplaySubject;
	var BehaviorSubject_1 = __webpack_require__(759);
	exports.BehaviorSubject = BehaviorSubject_1.BehaviorSubject;
	var ConnectableObservable_1 = __webpack_require__(762);
	exports.ConnectableObservable = ConnectableObservable_1.ConnectableObservable;
	var Notification_1 = __webpack_require__(264);
	exports.Notification = Notification_1.Notification;
	var EmptyError_1 = __webpack_require__(357);
	exports.EmptyError = EmptyError_1.EmptyError;
	var ArgumentOutOfRangeError_1 = __webpack_require__(271);
	exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	var ObjectUnsubscribedError_1 = __webpack_require__(358);
	exports.ObjectUnsubscribedError = ObjectUnsubscribedError_1.ObjectUnsubscribedError;
	var TimeoutError_1 = __webpack_require__(852);
	exports.TimeoutError = TimeoutError_1.TimeoutError;
	var UnsubscriptionError_1 = __webpack_require__(853);
	exports.UnsubscriptionError = UnsubscriptionError_1.UnsubscriptionError;
	var timeInterval_1 = __webpack_require__(771);
	exports.TimeInterval = timeInterval_1.TimeInterval;
	var timestamp_1 = __webpack_require__(521);
	exports.Timestamp = timestamp_1.Timestamp;
	var TestScheduler_1 = __webpack_require__(4747);
	exports.TestScheduler = TestScheduler_1.TestScheduler;
	var VirtualTimeScheduler_1 = __webpack_require__(847);
	exports.VirtualTimeScheduler = VirtualTimeScheduler_1.VirtualTimeScheduler;
	var AjaxObservable_1 = __webpack_require__(766);
	exports.AjaxResponse = AjaxObservable_1.AjaxResponse;
	exports.AjaxError = AjaxObservable_1.AjaxError;
	exports.AjaxTimeoutError = AjaxObservable_1.AjaxTimeoutError;
	var pipe_1 = __webpack_require__(524);
	exports.pipe = pipe_1.pipe;
	var asap_1 = __webpack_require__(848);
	var async_1 = __webpack_require__(23);
	var queue_1 = __webpack_require__(849);
	var animationFrame_1 = __webpack_require__(4744);
	var rxSubscriber_1 = __webpack_require__(356);
	var iterator_1 = __webpack_require__(270);
	var observable_1 = __webpack_require__(355);
	var _operators = __webpack_require__(120);
	exports.operators = _operators;
	/* tslint:enable:no-unused-variable */
	/**
	 * @typedef {Object} Rx.Scheduler
	 * @property {Scheduler} queue Schedules on a queue in the current event frame
	 * (trampoline scheduler). Use this for iteration operations.
	 * @property {Scheduler} asap Schedules on the micro task queue, which uses the
	 * fastest transport mechanism available, either Node.js' `process.nextTick()`
	 * or Web Worker MessageChannel or setTimeout or others. Use this for
	 * asynchronous conversions.
	 * @property {Scheduler} async Schedules work with `setInterval`. Use this for
	 * time-based operations.
	 * @property {Scheduler} animationFrame Schedules work with `requestAnimationFrame`.
	 * Use this for synchronizing with the platform's painting
	 */
	var Scheduler = {
	    asap: asap_1.asap,
	    queue: queue_1.queue,
	    animationFrame: animationFrame_1.animationFrame,
	    async: async_1.async
	};
	exports.Scheduler = Scheduler;
	/**
	 * @typedef {Object} Rx.Symbol
	 * @property {Symbol|string} rxSubscriber A symbol to use as a property name to
	 * retrieve an "Rx safe" Observer from an object. "Rx safety" can be defined as
	 * an object that has all of the traits of an Rx Subscriber, including the
	 * ability to add and remove subscriptions to the subscription chain and
	 * guarantees involving event triggering (can't "next" after unsubscription,
	 * etc).
	 * @property {Symbol|string} observable A symbol to use as a property name to
	 * retrieve an Observable as defined by the [ECMAScript "Observable" spec](https://github.com/zenparsing/es-observable).
	 * @property {Symbol|string} iterator The ES6 symbol to use as a property name
	 * to retrieve an iterator from an object.
	 */
	var Symbol = {
	    rxSubscriber: rxSubscriber_1.rxSubscriber,
	    observable: observable_1.observable,
	    iterator: iterator_1.iterator
	};
	exports.Symbol = Symbol;
	//# sourceMappingURL=Rx.js.map

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ArrayObservable_1 = __webpack_require__(118);
	exports.of = ArrayObservable_1.ArrayObservable.of;
	//# sourceMappingURL=of.js.map

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1046), __esModule: true };

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.visitors = exports.Hub = exports.Scope = exports.NodePath = undefined;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _path = __webpack_require__(125);
	
	Object.defineProperty(exports, "NodePath", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_path).default;
	  }
	});
	
	var _scope = __webpack_require__(381);
	
	Object.defineProperty(exports, "Scope", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_scope).default;
	  }
	});
	
	var _hub = __webpack_require__(550);
	
	Object.defineProperty(exports, "Hub", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_hub).default;
	  }
	});
	exports.default = traverse;
	
	var _context = __webpack_require__(972);
	
	var _context2 = _interopRequireDefault(_context);
	
	var _visitors = __webpack_require__(989);
	
	var visitors = _interopRequireWildcard(_visitors);
	
	var _babelMessages = __webpack_require__(284);
	
	var messages = _interopRequireWildcard(_babelMessages);
	
	var _includes = __webpack_require__(330);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	var _cache = __webpack_require__(285);
	
	var cache = _interopRequireWildcard(_cache);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.visitors = visitors;
	function traverse(parent, opts, scope, state, parentPath) {
	  if (!parent) return;
	  if (!opts) opts = {};
	
	  if (!opts.noScope && !scope) {
	    if (parent.type !== "Program" && parent.type !== "File") {
	      throw new Error(messages.get("traverseNeedsParent", parent.type));
	    }
	  }
	
	  visitors.explode(opts);
	
	  traverse.node(parent, opts, scope, state, parentPath);
	}
	
	traverse.visitors = visitors;
	traverse.verify = visitors.verify;
	traverse.explode = visitors.explode;
	
	traverse.NodePath = __webpack_require__(125);
	traverse.Scope = __webpack_require__(381);
	traverse.Hub = __webpack_require__(550);
	
	traverse.cheap = function (node, enter) {
	  return t.traverseFast(node, enter);
	};
	
	traverse.node = function (node, opts, scope, state, parentPath, skipKeys) {
	  var keys = t.VISITOR_KEYS[node.type];
	  if (!keys) return;
	
	  var context = new _context2.default(scope, opts, state, parentPath);
	  for (var _iterator = keys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var key = _ref;
	
	    if (skipKeys && skipKeys[key]) continue;
	    if (context.visit(node, key)) return;
	  }
	};
	
	traverse.clearNode = function (node, opts) {
	  t.removeProperties(node, opts);
	
	  cache.path.delete(node);
	};
	
	traverse.removeProperties = function (tree, opts) {
	  t.traverseFast(tree, traverse.clearNode, opts);
	  return tree;
	};
	
	function hasBlacklistedType(path, state) {
	  if (path.node.type === state.type) {
	    state.has = true;
	    path.stop();
	  }
	}
	
	traverse.hasType = function (tree, scope, type, blacklistTypes) {
	  if ((0, _includes2.default)(blacklistTypes, tree.type)) return false;
	
	  if (tree.type === type) return true;
	
	  var state = {
	    has: false,
	    type: type
	  };
	
	  traverse(tree, {
	    blacklist: blacklistTypes,
	    enter: hasBlacklistedType
	  }, scope, state);
	
	  return state.has;
	};
	
	traverse.clearCache = function () {
	  cache.clear();
	};
	
	traverse.clearCache.clearPath = cache.clearPath;
	traverse.clearCache.clearScope = cache.clearScope;
	
	traverse.copyCache = function (source, destination) {
	  if (cache.path.has(source)) {
	    cache.path.set(destination, cache.path.get(source));
	  }
	};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.DEPRECATED_KEYS = exports.BUILDER_KEYS = exports.NODE_FIELDS = exports.ALIAS_KEYS = exports.VISITOR_KEYS = undefined;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(168);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(124);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.assertEach = assertEach;
	exports.assertOneOf = assertOneOf;
	exports.assertNodeType = assertNodeType;
	exports.assertNodeOrValueType = assertNodeOrValueType;
	exports.assertValueType = assertValueType;
	exports.chain = chain;
	exports.default = defineType;
	
	var _index = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VISITOR_KEYS = exports.VISITOR_KEYS = {};
	var ALIAS_KEYS = exports.ALIAS_KEYS = {};
	var NODE_FIELDS = exports.NODE_FIELDS = {};
	var BUILDER_KEYS = exports.BUILDER_KEYS = {};
	var DEPRECATED_KEYS = exports.DEPRECATED_KEYS = {};
	
	function getType(val) {
	  if (Array.isArray(val)) {
	    return "array";
	  } else if (val === null) {
	    return "null";
	  } else if (val === undefined) {
	    return "undefined";
	  } else {
	    return typeof val === "undefined" ? "undefined" : (0, _typeof3.default)(val);
	  }
	}
	
	function assertEach(callback) {
	  function validator(node, key, val) {
	    if (!Array.isArray(val)) return;
	
	    for (var i = 0; i < val.length; i++) {
	      callback(node, key + "[" + i + "]", val[i]);
	    }
	  }
	  validator.each = callback;
	  return validator;
	}
	
	function assertOneOf() {
	  for (var _len = arguments.length, vals = Array(_len), _key = 0; _key < _len; _key++) {
	    vals[_key] = arguments[_key];
	  }
	
	  function validate(node, key, val) {
	    if (vals.indexOf(val) < 0) {
	      throw new TypeError("Property " + key + " expected value to be one of " + (0, _stringify2.default)(vals) + " but got " + (0, _stringify2.default)(val));
	    }
	  }
	
	  validate.oneOf = vals;
	
	  return validate;
	}
	
	function assertNodeType() {
	  for (var _len2 = arguments.length, types = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    types[_key2] = arguments[_key2];
	  }
	
	  function validate(node, key, val) {
	    var valid = false;
	
	    for (var _iterator = types, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var type = _ref;
	
	      if (t.is(type, val)) {
	        valid = true;
	        break;
	      }
	    }
	
	    if (!valid) {
	      throw new TypeError("Property " + key + " of " + node.type + " expected node to be of a type " + (0, _stringify2.default)(types) + " " + ("but instead got " + (0, _stringify2.default)(val && val.type)));
	    }
	  }
	
	  validate.oneOfNodeTypes = types;
	
	  return validate;
	}
	
	function assertNodeOrValueType() {
	  for (var _len3 = arguments.length, types = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    types[_key3] = arguments[_key3];
	  }
	
	  function validate(node, key, val) {
	    var valid = false;
	
	    for (var _iterator2 = types, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var type = _ref2;
	
	      if (getType(val) === type || t.is(type, val)) {
	        valid = true;
	        break;
	      }
	    }
	
	    if (!valid) {
	      throw new TypeError("Property " + key + " of " + node.type + " expected node to be of a type " + (0, _stringify2.default)(types) + " " + ("but instead got " + (0, _stringify2.default)(val && val.type)));
	    }
	  }
	
	  validate.oneOfNodeOrValueTypes = types;
	
	  return validate;
	}
	
	function assertValueType(type) {
	  function validate(node, key, val) {
	    var valid = getType(val) === type;
	
	    if (!valid) {
	      throw new TypeError("Property " + key + " expected type of " + type + " but got " + getType(val));
	    }
	  }
	
	  validate.type = type;
	
	  return validate;
	}
	
	function chain() {
	  for (var _len4 = arguments.length, fns = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	    fns[_key4] = arguments[_key4];
	  }
	
	  function validate() {
	    for (var _iterator3 = fns, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
	      var _ref3;
	
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }
	
	      var fn = _ref3;
	
	      fn.apply(undefined, arguments);
	    }
	  }
	  validate.chainOf = fns;
	  return validate;
	}
	
	function defineType(type) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var inherits = opts.inherits && store[opts.inherits] || {};
	
	  opts.fields = opts.fields || inherits.fields || {};
	  opts.visitor = opts.visitor || inherits.visitor || [];
	  opts.aliases = opts.aliases || inherits.aliases || [];
	  opts.builder = opts.builder || inherits.builder || opts.visitor || [];
	
	  if (opts.deprecatedAlias) {
	    DEPRECATED_KEYS[opts.deprecatedAlias] = type;
	  }
	
	  for (var _iterator4 = opts.visitor.concat(opts.builder), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
	    var _ref4;
	
	    if (_isArray4) {
	      if (_i4 >= _iterator4.length) break;
	      _ref4 = _iterator4[_i4++];
	    } else {
	      _i4 = _iterator4.next();
	      if (_i4.done) break;
	      _ref4 = _i4.value;
	    }
	
	    var _key5 = _ref4;
	
	    opts.fields[_key5] = opts.fields[_key5] || {};
	  }
	
	  for (var key in opts.fields) {
	    var field = opts.fields[key];
	
	    if (opts.builder.indexOf(key) === -1) {
	      field.optional = true;
	    }
	    if (field.default === undefined) {
	      field.default = null;
	    } else if (!field.validate) {
	      field.validate = assertValueType(getType(field.default));
	    }
	  }
	
	  VISITOR_KEYS[type] = opts.visitor;
	  BUILDER_KEYS[type] = opts.builder;
	  NODE_FIELDS[type] = opts.fields;
	  ALIAS_KEYS[type] = opts.aliases;
	
	  store[type] = opts;
	}
	
	var store = {};

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(58);
	var createDesc = __webpack_require__(204);
	module.exports = __webpack_require__(70) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(699);
	var foreach = __webpack_require__(1239);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';
	
	var toStr = Object.prototype.toString;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
	        /* eslint-disable no-unused-vars, no-restricted-syntax */
	        for (var _ in obj) { return false; }
	        /* eslint-enable no-unused-vars, no-restricted-syntax */
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			Object.defineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = props.concat(Object.getOwnPropertySymbols(map));
		}
		foreach(props, function (name) {
			defineProperty(object, name, map[name], predicates[name]);
		});
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM2.default) {
	      var scrollDiv = document.createElement('div');
	
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	};
	
	var _inDOM = __webpack_require__(35);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = void 0;
	
	module.exports = exports['default'];

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	//Types of elements found in the DOM
	module.exports = {
		Text: "text", //Text
		Directive: "directive", //<? ... ?>
		Comment: "comment", //<!-- ... -->
		Script: "script", //<script> tags
		Style: "style", //<style> tags
		Tag: "tag", //Any tag
		CDATA: "cdata", //<![CDATA[ ... ]]>
		Doctype: "doctype",
	
		isTag: function(elem){
			return elem.type === "tag" || elem.type === "script" || elem.type === "style";
		}
	};


/***/ }),
/* 99 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(318),
	    baseAssignValue = __webpack_require__(442);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(72),
	    isObject = __webpack_require__(49);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(4418);


/***/ }),
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	var ScalarObservable_1 = __webpack_require__(506);
	var EmptyObservable_1 = __webpack_require__(119);
	var isScheduler_1 = __webpack_require__(65);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ArrayObservable = (function (_super) {
	    __extends(ArrayObservable, _super);
	    function ArrayObservable(array, scheduler) {
	        _super.call(this);
	        this.array = array;
	        this.scheduler = scheduler;
	        if (!scheduler && array.length === 1) {
	            this._isScalar = true;
	            this.value = array[0];
	        }
	    }
	    ArrayObservable.create = function (array, scheduler) {
	        return new ArrayObservable(array, scheduler);
	    };
	    /**
	     * Creates an Observable that emits some values you specify as arguments,
	     * immediately one after the other, and then emits a complete notification.
	     *
	     * <span class="informal">Emits the arguments you provide, then completes.
	     * </span>
	     *
	     * <img src="./img/of.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that only
	     * emits the arguments given, and the complete notification thereafter. It can
	     * be used for composing with other Observables, such as with {@link concat}.
	     * By default, it uses a `null` IScheduler, which means the `next`
	     * notifications are sent synchronously, although with a different IScheduler
	     * it is possible to determine when those notifications will be delivered.
	     *
	     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
	     * var numbers = Rx.Observable.of(10, 20, 30);
	     * var letters = Rx.Observable.of('a', 'b', 'c');
	     * var interval = Rx.Observable.interval(1000);
	     * var result = numbers.concat(letters).concat(interval);
	     * result.subscribe(x => console.log(x));
	     *
	     * @see {@link create}
	     * @see {@link empty}
	     * @see {@link never}
	     * @see {@link throw}
	     *
	     * @param {...T} values Arguments that represent `next` values to be emitted.
	     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
	     * the emissions of the `next` notifications.
	     * @return {Observable<T>} An Observable that emits each given input value.
	     * @static true
	     * @name of
	     * @owner Observable
	     */
	    ArrayObservable.of = function () {
	        var array = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            array[_i - 0] = arguments[_i];
	        }
	        var scheduler = array[array.length - 1];
	        if (isScheduler_1.isScheduler(scheduler)) {
	            array.pop();
	        }
	        else {
	            scheduler = null;
	        }
	        var len = array.length;
	        if (len > 1) {
	            return new ArrayObservable(array, scheduler);
	        }
	        else if (len === 1) {
	            return new ScalarObservable_1.ScalarObservable(array[0], scheduler);
	        }
	        else {
	            return new EmptyObservable_1.EmptyObservable(scheduler);
	        }
	    };
	    ArrayObservable.dispatch = function (state) {
	        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
	        if (index >= count) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(array[index]);
	        if (subscriber.closed) {
	            return;
	        }
	        state.index = index + 1;
	        this.schedule(state);
	    };
	    ArrayObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var array = this.array;
	        var count = array.length;
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(ArrayObservable.dispatch, 0, {
	                array: array, index: index, count: count, subscriber: subscriber
	            });
	        }
	        else {
	            for (var i = 0; i < count && !subscriber.closed; i++) {
	                subscriber.next(array[i]);
	            }
	            subscriber.complete();
	        }
	    };
	    return ArrayObservable;
	}(Observable_1.Observable));
	exports.ArrayObservable = ArrayObservable;
	//# sourceMappingURL=ArrayObservable.js.map

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var EmptyObservable = (function (_super) {
	    __extends(EmptyObservable, _super);
	    function EmptyObservable(scheduler) {
	        _super.call(this);
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable that emits no items to the Observer and immediately
	     * emits a complete notification.
	     *
	     * <span class="informal">Just emits 'complete', and nothing else.
	     * </span>
	     *
	     * <img src="./img/empty.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that only
	     * emits the complete notification. It can be used for composing with other
	     * Observables, such as in a {@link mergeMap}.
	     *
	     * @example <caption>Emit the number 7, then complete.</caption>
	     * var result = Rx.Observable.empty().startWith(7);
	     * result.subscribe(x => console.log(x));
	     *
	     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
	     * var interval = Rx.Observable.interval(1000);
	     * var result = interval.mergeMap(x =>
	     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
	     * );
	     * result.subscribe(x => console.log(x));
	     *
	     * // Results in the following to the console:
	     * // x is equal to the count on the interval eg(0,1,2,3,...)
	     * // x will occur every 1000ms
	     * // if x % 2 is equal to 1 print abc
	     * // if x % 2 is not equal to 1 nothing will be output
	     *
	     * @see {@link create}
	     * @see {@link never}
	     * @see {@link of}
	     * @see {@link throw}
	     *
	     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
	     * the emission of the complete notification.
	     * @return {Observable} An "empty" Observable: emits only the complete
	     * notification.
	     * @static true
	     * @name empty
	     * @owner Observable
	     */
	    EmptyObservable.create = function (scheduler) {
	        return new EmptyObservable(scheduler);
	    };
	    EmptyObservable.dispatch = function (arg) {
	        var subscriber = arg.subscriber;
	        subscriber.complete();
	    };
	    EmptyObservable.prototype._subscribe = function (subscriber) {
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(EmptyObservable.dispatch, 0, { subscriber: subscriber });
	        }
	        else {
	            subscriber.complete();
	        }
	    };
	    return EmptyObservable;
	}(Observable_1.Observable));
	exports.EmptyObservable = EmptyObservable;
	//# sourceMappingURL=EmptyObservable.js.map

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var audit_1 = __webpack_require__(509);
	exports.audit = audit_1.audit;
	var auditTime_1 = __webpack_require__(772);
	exports.auditTime = auditTime_1.auditTime;
	var buffer_1 = __webpack_require__(773);
	exports.buffer = buffer_1.buffer;
	var bufferCount_1 = __webpack_require__(774);
	exports.bufferCount = bufferCount_1.bufferCount;
	var bufferTime_1 = __webpack_require__(775);
	exports.bufferTime = bufferTime_1.bufferTime;
	var bufferToggle_1 = __webpack_require__(776);
	exports.bufferToggle = bufferToggle_1.bufferToggle;
	var bufferWhen_1 = __webpack_require__(777);
	exports.bufferWhen = bufferWhen_1.bufferWhen;
	var catchError_1 = __webpack_require__(778);
	exports.catchError = catchError_1.catchError;
	var combineAll_1 = __webpack_require__(779);
	exports.combineAll = combineAll_1.combineAll;
	var combineLatest_1 = __webpack_require__(347);
	exports.combineLatest = combineLatest_1.combineLatest;
	var concat_1 = __webpack_require__(780);
	exports.concat = concat_1.concat;
	var concatAll_1 = __webpack_require__(510);
	exports.concatAll = concatAll_1.concatAll;
	var concatMap_1 = __webpack_require__(511);
	exports.concatMap = concatMap_1.concatMap;
	var concatMapTo_1 = __webpack_require__(781);
	exports.concatMapTo = concatMapTo_1.concatMapTo;
	var count_1 = __webpack_require__(782);
	exports.count = count_1.count;
	var debounce_1 = __webpack_require__(783);
	exports.debounce = debounce_1.debounce;
	var debounceTime_1 = __webpack_require__(784);
	exports.debounceTime = debounceTime_1.debounceTime;
	var defaultIfEmpty_1 = __webpack_require__(512);
	exports.defaultIfEmpty = defaultIfEmpty_1.defaultIfEmpty;
	var delay_1 = __webpack_require__(785);
	exports.delay = delay_1.delay;
	var delayWhen_1 = __webpack_require__(786);
	exports.delayWhen = delayWhen_1.delayWhen;
	var dematerialize_1 = __webpack_require__(787);
	exports.dematerialize = dematerialize_1.dematerialize;
	var distinct_1 = __webpack_require__(788);
	exports.distinct = distinct_1.distinct;
	var distinctUntilChanged_1 = __webpack_require__(513);
	exports.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
	var distinctUntilKeyChanged_1 = __webpack_require__(789);
	exports.distinctUntilKeyChanged = distinctUntilKeyChanged_1.distinctUntilKeyChanged;
	var elementAt_1 = __webpack_require__(790);
	exports.elementAt = elementAt_1.elementAt;
	var every_1 = __webpack_require__(791);
	exports.every = every_1.every;
	var exhaust_1 = __webpack_require__(792);
	exports.exhaust = exhaust_1.exhaust;
	var exhaustMap_1 = __webpack_require__(793);
	exports.exhaustMap = exhaustMap_1.exhaustMap;
	var expand_1 = __webpack_require__(794);
	exports.expand = expand_1.expand;
	var filter_1 = __webpack_require__(348);
	exports.filter = filter_1.filter;
	var finalize_1 = __webpack_require__(795);
	exports.finalize = finalize_1.finalize;
	var find_1 = __webpack_require__(514);
	exports.find = find_1.find;
	var findIndex_1 = __webpack_require__(796);
	exports.findIndex = findIndex_1.findIndex;
	var first_1 = __webpack_require__(797);
	exports.first = first_1.first;
	var groupBy_1 = __webpack_require__(798);
	exports.groupBy = groupBy_1.groupBy;
	var ignoreElements_1 = __webpack_require__(515);
	exports.ignoreElements = ignoreElements_1.ignoreElements;
	var isEmpty_1 = __webpack_require__(799);
	exports.isEmpty = isEmpty_1.isEmpty;
	var last_1 = __webpack_require__(800);
	exports.last = last_1.last;
	var map_1 = __webpack_require__(163);
	exports.map = map_1.map;
	var mapTo_1 = __webpack_require__(516);
	exports.mapTo = mapTo_1.mapTo;
	var materialize_1 = __webpack_require__(801);
	exports.materialize = materialize_1.materialize;
	var max_1 = __webpack_require__(802);
	exports.max = max_1.max;
	var merge_1 = __webpack_require__(803);
	exports.merge = merge_1.merge;
	var mergeAll_1 = __webpack_require__(349);
	exports.mergeAll = mergeAll_1.mergeAll;
	var mergeMap_1 = __webpack_require__(266);
	exports.mergeMap = mergeMap_1.mergeMap;
	var mergeMap_2 = __webpack_require__(266);
	exports.flatMap = mergeMap_2.mergeMap;
	var mergeMapTo_1 = __webpack_require__(804);
	exports.mergeMapTo = mergeMapTo_1.mergeMapTo;
	var mergeScan_1 = __webpack_require__(805);
	exports.mergeScan = mergeScan_1.mergeScan;
	var min_1 = __webpack_require__(806);
	exports.min = min_1.min;
	var multicast_1 = __webpack_require__(164);
	exports.multicast = multicast_1.multicast;
	var observeOn_1 = __webpack_require__(350);
	exports.observeOn = observeOn_1.observeOn;
	var onErrorResumeNext_1 = __webpack_require__(517);
	exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
	var pairwise_1 = __webpack_require__(807);
	exports.pairwise = pairwise_1.pairwise;
	var partition_1 = __webpack_require__(808);
	exports.partition = partition_1.partition;
	var pluck_1 = __webpack_require__(809);
	exports.pluck = pluck_1.pluck;
	var publish_1 = __webpack_require__(810);
	exports.publish = publish_1.publish;
	var publishBehavior_1 = __webpack_require__(811);
	exports.publishBehavior = publishBehavior_1.publishBehavior;
	var publishLast_1 = __webpack_require__(812);
	exports.publishLast = publishLast_1.publishLast;
	var publishReplay_1 = __webpack_require__(813);
	exports.publishReplay = publishReplay_1.publishReplay;
	var race_1 = __webpack_require__(814);
	exports.race = race_1.race;
	var reduce_1 = __webpack_require__(267);
	exports.reduce = reduce_1.reduce;
	var repeat_1 = __webpack_require__(815);
	exports.repeat = repeat_1.repeat;
	var repeatWhen_1 = __webpack_require__(816);
	exports.repeatWhen = repeatWhen_1.repeatWhen;
	var retry_1 = __webpack_require__(817);
	exports.retry = retry_1.retry;
	var retryWhen_1 = __webpack_require__(818);
	exports.retryWhen = retryWhen_1.retryWhen;
	var refCount_1 = __webpack_require__(518);
	exports.refCount = refCount_1.refCount;
	var sample_1 = __webpack_require__(819);
	exports.sample = sample_1.sample;
	var sampleTime_1 = __webpack_require__(820);
	exports.sampleTime = sampleTime_1.sampleTime;
	var scan_1 = __webpack_require__(519);
	exports.scan = scan_1.scan;
	var sequenceEqual_1 = __webpack_require__(821);
	exports.sequenceEqual = sequenceEqual_1.sequenceEqual;
	var share_1 = __webpack_require__(822);
	exports.share = share_1.share;
	var shareReplay_1 = __webpack_require__(823);
	exports.shareReplay = shareReplay_1.shareReplay;
	var single_1 = __webpack_require__(824);
	exports.single = single_1.single;
	var skip_1 = __webpack_require__(825);
	exports.skip = skip_1.skip;
	var skipLast_1 = __webpack_require__(826);
	exports.skipLast = skipLast_1.skipLast;
	var skipUntil_1 = __webpack_require__(827);
	exports.skipUntil = skipUntil_1.skipUntil;
	var skipWhile_1 = __webpack_require__(828);
	exports.skipWhile = skipWhile_1.skipWhile;
	var startWith_1 = __webpack_require__(829);
	exports.startWith = startWith_1.startWith;
	/**
	 * TODO(https://github.com/ReactiveX/rxjs/issues/2900): Add back subscribeOn once it can be
	 * treeshaken. Currently if this export is added back, it
	 * forces apps to bring in asap scheduler along with
	 * Immediate, root, and other supporting code.
	 */
	// export { subscribeOn } from './operators/subscribeOn';
	var switchAll_1 = __webpack_require__(830);
	exports.switchAll = switchAll_1.switchAll;
	var switchMap_1 = __webpack_require__(351);
	exports.switchMap = switchMap_1.switchMap;
	var switchMapTo_1 = __webpack_require__(831);
	exports.switchMapTo = switchMapTo_1.switchMapTo;
	var take_1 = __webpack_require__(832);
	exports.take = take_1.take;
	var takeLast_1 = __webpack_require__(520);
	exports.takeLast = takeLast_1.takeLast;
	var takeUntil_1 = __webpack_require__(833);
	exports.takeUntil = takeUntil_1.takeUntil;
	var takeWhile_1 = __webpack_require__(834);
	exports.takeWhile = takeWhile_1.takeWhile;
	var tap_1 = __webpack_require__(352);
	exports.tap = tap_1.tap;
	var throttle_1 = __webpack_require__(353);
	exports.throttle = throttle_1.throttle;
	var throttleTime_1 = __webpack_require__(835);
	exports.throttleTime = throttleTime_1.throttleTime;
	var timeInterval_1 = __webpack_require__(836);
	exports.timeInterval = timeInterval_1.timeInterval;
	var timeout_1 = __webpack_require__(837);
	exports.timeout = timeout_1.timeout;
	var timeoutWith_1 = __webpack_require__(838);
	exports.timeoutWith = timeoutWith_1.timeoutWith;
	var timestamp_1 = __webpack_require__(521);
	exports.timestamp = timestamp_1.timestamp;
	var toArray_1 = __webpack_require__(839);
	exports.toArray = toArray_1.toArray;
	var window_1 = __webpack_require__(840);
	exports.window = window_1.window;
	var windowCount_1 = __webpack_require__(841);
	exports.windowCount = windowCount_1.windowCount;
	var windowTime_1 = __webpack_require__(842);
	exports.windowTime = windowTime_1.windowTime;
	var windowToggle_1 = __webpack_require__(843);
	exports.windowToggle = windowToggle_1.windowToggle;
	var windowWhen_1 = __webpack_require__(844);
	exports.windowWhen = windowWhen_1.windowWhen;
	var withLatestFrom_1 = __webpack_require__(845);
	exports.withLatestFrom = withLatestFrom_1.withLatestFrom;
	var zip_1 = __webpack_require__(354);
	exports.zip = zip_1.zip;
	var zipAll_1 = __webpack_require__(846);
	exports.zipAll = zipAll_1.zipAll;
	//# sourceMappingURL=operators.js.map

/***/ }),
/* 121 */,
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AllMarkdownRemark = exports.AllChallengeNode = exports.ChallengeNode = exports.MarkdownRemark = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileType = _propTypes2.default.shape({
	  key: _propTypes2.default.string,
	  ext: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  contents: _propTypes2.default.string,
	  head: _propTypes2.default.string,
	  tail: _propTypes2.default.string
	});
	
	var MarkdownRemark = exports.MarkdownRemark = _propTypes2.default.shape({
	  html: _propTypes2.default.string,
	  frontmatter: _propTypes2.default.shape({
	    title: _propTypes2.default.string,
	    block: _propTypes2.default.string,
	    superBlock: _propTypes2.default.string
	  })
	});
	
	var ChallengeNode = exports.ChallengeNode = _propTypes2.default.shape({
	  block: _propTypes2.default.string,
	  challengeType: _propTypes2.default.number,
	  dashedName: _propTypes2.default.string,
	  description: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  files: _propTypes2.default.shape({
	    indexhtml: FileType,
	    indexjs: FileType
	  }),
	  fields: _propTypes2.default.shape({
	    slug: _propTypes2.default.string,
	    blockName: _propTypes2.default.string
	  }),
	  guideUrl: _propTypes2.default.string,
	  head: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  helpRoom: _propTypes2.default.string,
	  suborder: _propTypes2.default.number,
	  isBeta: _propTypes2.default.bool,
	  isComingSoon: _propTypes2.default.bool,
	  isLocked: _propTypes2.default.bool,
	  isPrivate: _propTypes2.default.bool,
	  isRequired: _propTypes2.default.bool,
	  name: _propTypes2.default.string,
	  order: _propTypes2.default.number,
	  required: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    link: _propTypes2.default.string,
	    raw: _propTypes2.default.string,
	    src: _propTypes2.default.string
	  })),
	  superOrder: _propTypes2.default.number,
	  superBlock: _propTypes2.default.string,
	  tail: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  time: _propTypes2.default.string,
	  title: _propTypes2.default.string
	});
	
	var AllChallengeNode = exports.AllChallengeNode = _propTypes2.default.shape({
	  edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    node: ChallengeNode
	  }))
	});
	
	var AllMarkdownRemark = exports.AllMarkdownRemark = _propTypes2.default.shape({
	  edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    node: MarkdownRemark
	  }))
	});

/***/ }),
/* 123 */,
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(967);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(83);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _virtualTypes = __webpack_require__(551);
	
	var virtualTypes = _interopRequireWildcard(_virtualTypes);
	
	var _debug2 = __webpack_require__(306);
	
	var _debug3 = _interopRequireDefault(_debug2);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _index = __webpack_require__(91);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _assign = __webpack_require__(329);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _scope = __webpack_require__(381);
	
	var _scope2 = _interopRequireDefault(_scope);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	var _cache = __webpack_require__(285);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _debug = (0, _debug3.default)("babel");
	
	var NodePath = function () {
	  function NodePath(hub, parent) {
	    (0, _classCallCheck3.default)(this, NodePath);
	
	    this.parent = parent;
	    this.hub = hub;
	    this.contexts = [];
	    this.data = {};
	    this.shouldSkip = false;
	    this.shouldStop = false;
	    this.removed = false;
	    this.state = null;
	    this.opts = null;
	    this.skipKeys = null;
	    this.parentPath = null;
	    this.context = null;
	    this.container = null;
	    this.listKey = null;
	    this.inList = false;
	    this.parentKey = null;
	    this.key = null;
	    this.node = null;
	    this.scope = null;
	    this.type = null;
	    this.typeAnnotation = null;
	  }
	
	  NodePath.get = function get(_ref) {
	    var hub = _ref.hub,
	        parentPath = _ref.parentPath,
	        parent = _ref.parent,
	        container = _ref.container,
	        listKey = _ref.listKey,
	        key = _ref.key;
	
	    if (!hub && parentPath) {
	      hub = parentPath.hub;
	    }
	
	    (0, _invariant2.default)(parent, "To get a node path the parent needs to exist");
	
	    var targetNode = container[key];
	
	    var paths = _cache.path.get(parent) || [];
	    if (!_cache.path.has(parent)) {
	      _cache.path.set(parent, paths);
	    }
	
	    var path = void 0;
	
	    for (var i = 0; i < paths.length; i++) {
	      var pathCheck = paths[i];
	      if (pathCheck.node === targetNode) {
	        path = pathCheck;
	        break;
	      }
	    }
	
	    if (!path) {
	      path = new NodePath(hub, parent);
	      paths.push(path);
	    }
	
	    path.setup(parentPath, container, listKey, key);
	
	    return path;
	  };
	
	  NodePath.prototype.getScope = function getScope(scope) {
	    var ourScope = scope;
	
	    if (this.isScope()) {
	      ourScope = new _scope2.default(this, scope);
	    }
	
	    return ourScope;
	  };
	
	  NodePath.prototype.setData = function setData(key, val) {
	    return this.data[key] = val;
	  };
	
	  NodePath.prototype.getData = function getData(key, def) {
	    var val = this.data[key];
	    if (!val && def) val = this.data[key] = def;
	    return val;
	  };
	
	  NodePath.prototype.buildCodeFrameError = function buildCodeFrameError(msg) {
	    var Error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SyntaxError;
	
	    return this.hub.file.buildCodeFrameError(this.node, msg, Error);
	  };
	
	  NodePath.prototype.traverse = function traverse(visitor, state) {
	    (0, _index2.default)(this.node, visitor, this.scope, state, this);
	  };
	
	  NodePath.prototype.mark = function mark(type, message) {
	    this.hub.file.metadata.marked.push({
	      type: type,
	      message: message,
	      loc: this.node.loc
	    });
	  };
	
	  NodePath.prototype.set = function set(key, node) {
	    t.validate(this.node, key, node);
	    this.node[key] = node;
	  };
	
	  NodePath.prototype.getPathLocation = function getPathLocation() {
	    var parts = [];
	    var path = this;
	    do {
	      var key = path.key;
	      if (path.inList) key = path.listKey + "[" + key + "]";
	      parts.unshift(key);
	    } while (path = path.parentPath);
	    return parts.join(".");
	  };
	
	  NodePath.prototype.debug = function debug(buildMessage) {
	    if (!_debug.enabled) return;
	    _debug(this.getPathLocation() + " " + this.type + ": " + buildMessage());
	  };
	
	  return NodePath;
	}();
	
	exports.default = NodePath;
	
	
	(0, _assign2.default)(NodePath.prototype, __webpack_require__(973));
	(0, _assign2.default)(NodePath.prototype, __webpack_require__(979));
	(0, _assign2.default)(NodePath.prototype, __webpack_require__(987));
	(0, _assign2.default)(NodePath.prototype, __webpack_require__(977));
	(0, _assign2.default)(NodePath.prototype, __webpack_require__(976));
	(0, _assign2.default)(NodePath.prototype, __webpack_require__(982));
	(0, _assign2.default)(NodePath.prototype, __webpack_require__(975));
	(0, _assign2.default)(NodePath.prototype, __webpack_require__(986));
	(0, _assign2.default)(NodePath.prototype, __webpack_require__(985));
	(0, _assign2.default)(NodePath.prototype, __webpack_require__(978));
	(0, _assign2.default)(NodePath.prototype, __webpack_require__(974));
	
	var _loop2 = function _loop2() {
	  if (_isArray) {
	    if (_i >= _iterator.length) return "break";
	    _ref2 = _iterator[_i++];
	  } else {
	    _i = _iterator.next();
	    if (_i.done) return "break";
	    _ref2 = _i.value;
	  }
	
	  var type = _ref2;
	
	  var typeKey = "is" + type;
	  NodePath.prototype[typeKey] = function (opts) {
	    return t[typeKey](this.node, opts);
	  };
	
	  NodePath.prototype["assert" + type] = function (opts) {
	    if (!this[typeKey](opts)) {
	      throw new TypeError("Expected node path of type " + type);
	    }
	  };
	};
	
	for (var _iterator = t.TYPES, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	  var _ref2;
	
	  var _ret2 = _loop2();
	
	  if (_ret2 === "break") break;
	}
	
	var _loop = function _loop(type) {
	  if (type[0] === "_") return "continue";
	  if (t.TYPES.indexOf(type) < 0) t.TYPES.push(type);
	
	  var virtualType = virtualTypes[type];
	
	  NodePath.prototype["is" + type] = function (opts) {
	    return virtualType.checkPath(this, opts);
	  };
	};
	
	for (var type in virtualTypes) {
	  var _ret = _loop(type);
	
	  if (_ret === "continue") continue;
	}
	module.exports = exports["default"];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * chai
	 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	var used = [];
	
	/*!
	 * Chai version
	 */
	
	exports.version = '4.1.2';
	
	/*!
	 * Assertion Error
	 */
	
	exports.AssertionError = __webpack_require__(534);
	
	/*!
	 * Utils for plugins (not exported)
	 */
	
	var util = __webpack_require__(1018);
	
	/**
	 * # .use(function)
	 *
	 * Provides a way to extend the internals of Chai.
	 *
	 * @param {Function}
	 * @returns {this} for chaining
	 * @api public
	 */
	
	exports.use = function (fn) {
	  if (!~used.indexOf(fn)) {
	    fn(exports, util);
	    used.push(fn);
	  }
	
	  return exports;
	};
	
	/*!
	 * Utility Functions
	 */
	
	exports.util = util;
	
	/*!
	 * Configuration
	 */
	
	var config = __webpack_require__(127);
	exports.config = config;
	
	/*!
	 * Primary `Assertion` prototype
	 */
	
	var assertion = __webpack_require__(1005);
	exports.use(assertion);
	
	/*!
	 * Core Assertions
	 */
	
	var core = __webpack_require__(1006);
	exports.use(core);
	
	/*!
	 * Expect interface
	 */
	
	var expect = __webpack_require__(1008);
	exports.use(expect);
	
	/*!
	 * Should interface
	 */
	
	var should = __webpack_require__(1009);
	exports.use(should);
	
	/*!
	 * Assert interface
	 */
	
	var assert = __webpack_require__(1007);
	exports.use(assert);


/***/ }),
/* 127 */
/***/ (function(module, exports) {

	module.exports = {
	
	  /**
	   * ### config.includeStack
	   *
	   * User configurable property, influences whether stack trace
	   * is included in Assertion error message. Default of false
	   * suppresses stack trace in the error message.
	   *
	   *     chai.config.includeStack = true;  // enable stack on error
	   *
	   * @param {Boolean}
	   * @api public
	   */
	
	  includeStack: false,
	
	  /**
	   * ### config.showDiff
	   *
	   * User configurable property, influences whether or not
	   * the `showDiff` flag should be included in the thrown
	   * AssertionErrors. `false` will always be `false`; `true`
	   * will be true when the assertion has requested a diff
	   * be shown.
	   *
	   * @param {Boolean}
	   * @api public
	   */
	
	  showDiff: true,
	
	  /**
	   * ### config.truncateThreshold
	   *
	   * User configurable property, sets length threshold for actual and
	   * expected values in assertion errors. If this threshold is exceeded, for
	   * example for large data structures, the value is replaced with something
	   * like `[ Array(3) ]` or `{ Object (prop1, prop2) }`.
	   *
	   * Set it to zero if you want to disable truncating altogether.
	   *
	   * This is especially userful when doing assertions on arrays: having this
	   * set to a reasonable large value makes the failure messages readily
	   * inspectable.
	   *
	   *     chai.config.truncateThreshold = 0;  // disable truncating
	   *
	   * @param {Number}
	   * @api public
	   */
	
	  truncateThreshold: 40,
	
	  /**
	   * ### config.useProxy
	   *
	   * User configurable property, defines if chai will use a Proxy to throw
	   * an error when a non-existent property is read, which protects users
	   * from typos when using property-based assertions.
	   *
	   * Set it to false if you want to disable this feature.
	   *
	   *     chai.config.useProxy = false;  // disable use of Proxy
	   *
	   * This feature is automatically disabled regardless of this config value
	   * in environments that don't support proxies.
	   *
	   * @param {Boolean}
	   * @api public
	   */
	
	  useProxy: true,
	
	  /**
	   * ### config.proxyExcludedKeys
	   *
	   * User configurable property, defines which properties should be ignored
	   * instead of throwing an error if they do not exist on the assertion.
	   * This is only applied if the environment Chai is running in supports proxies and
	   * if the `useProxy` configuration setting is enabled.
	   * By default, `then` and `inspect` will not throw an error if they do not exist on the
	   * assertion object because the `.inspect` property is read by `util.inspect` (for example, when
	   * using `console.log` on the assertion object) and `.then` is necessary for promise type-checking.
	   *
	   *     // By default these keys will not throw an error if they do not exist on the assertion object
	   *     chai.config.proxyExcludedKeys = ['then', 'inspect'];
	   *
	   * @param {Array}
	   * @api public
	   */
	
	  proxyExcludedKeys: ['then', 'inspect', 'toJSON']
	};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

	/*!
	 * Chai - transferFlags utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/**
	 * ### .transferFlags(assertion, object, includeAll = true)
	 *
	 * Transfer all the flags for `assertion` to `object`. If
	 * `includeAll` is set to `false`, then the base Chai
	 * assertion flags (namely `object`, `ssfi`, `lockSsfi`,
	 * and `message`) will not be transferred.
	 *
	 *
	 *     var newAssertion = new Assertion();
	 *     utils.transferFlags(assertion, newAssertion);
	 *
	 *     var anotherAsseriton = new Assertion(myObj);
	 *     utils.transferFlags(assertion, anotherAssertion, false);
	 *
	 * @param {Assertion} assertion the assertion to transfer the flags from
	 * @param {Object} object the object to transfer the flags to; usually a new assertion
	 * @param {Boolean} includeAll
	 * @namespace Utils
	 * @name transferFlags
	 * @api private
	 */
	
	module.exports = function transferFlags(assertion, object, includeAll) {
	  var flags = assertion.__flags || (assertion.__flags = Object.create(null));
	
	  if (!object.__flags) {
	    object.__flags = Object.create(null);
	  }
	
	  includeAll = arguments.length === 3 ? includeAll : true;
	
	  for (var flag in flags) {
	    if (includeAll ||
	        (flag !== 'object' && flag !== 'ssfi' && flag !== 'lockSsfi' && flag != 'message')) {
	      object.__flags[flag] = flags[flag];
	    }
	  }
	};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(390);
	var defined = __webpack_require__(387);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(209);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(1144);
	var isArguments = __webpack_require__(1143);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(35);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var off = function off() {};
	if (_inDOM2.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	exports.default = off;
	module.exports = exports['default'];

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(35);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var on = function on() {};
	if (_inDOM2.default) {
	  on = function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	exports.default = on;
	module.exports = exports['default'];

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1240);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(4226),
	    getValue = __webpack_require__(4269);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(434),
	    baseEach = __webpack_require__(221),
	    castFunction = __webpack_require__(4246),
	    isArray = __webpack_require__(24);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(640),
	    baseKeysIn = __webpack_require__(4230),
	    isArrayLike = __webpack_require__(74);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 141 */,
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(18);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(13);
	
	var _StyleConfig = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _propTypes2.default.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _propTypes2.default.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _propTypes2.default.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _propTypes2.default.number,
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _propTypes2.default.bool,
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _propTypes2.default.bool,
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _propTypes2.default.bool,
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _propTypes2.default.bool,
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _propTypes2.default.number,
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _propTypes2.default.number,
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _propTypes2.default.number,
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _propTypes2.default.number
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Col = function (_React$Component) {
	  (0, _inherits3.default)(Col, _React$Component);
	
	  function Col() {
	    (0, _classCallCheck3.default)(this, Col);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Col.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      function popProp(propSuffix, modifier) {
	        var propName = '' + size + propSuffix;
	        var propValue = elementProps[propName];
	
	        if (propValue != null) {
	          classes.push((0, _bootstrapUtils.prefix)(bsProps, '' + size + modifier + '-' + propValue));
	        }
	
	        delete elementProps[propName];
	      }
	
	      popProp('', '');
	      popProp('Offset', '-offset');
	      popProp('Push', '-push');
	      popProp('Pull', '-pull');
	
	      var hiddenPropName = size + 'Hidden';
	      if (elementProps[hiddenPropName]) {
	        classes.push('hidden-' + size);
	      }
	      delete elementProps[hiddenPropName];
	    });
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, { className: (0, _classnames2.default)(className, classes) }));
	  };
	
	  return Col;
	}(_react2.default.Component);
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('col', Col);
	module.exports = exports['default'];

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(4428);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(131);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(4391);
	
	var _HelmetConstants = __webpack_require__(717);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(336);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = __webpack_require__(212);
	util.inherits = __webpack_require__(71);
	/*</replacement>*/
	
	var Readable = __webpack_require__(742);
	var Writable = __webpack_require__(503);
	
	util.inherits(Duplex, Readable);
	
	var keys = objectKeys(Writable.prototype);
	for (var v = 0; v < keys.length; v++) {
	  var method = keys[v];
	  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var ArrayObservable_1 = __webpack_require__(118);
	var isScheduler_1 = __webpack_require__(65);
	var mergeAll_1 = __webpack_require__(349);
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which concurrently emits all values from every
	 * given input Observable.
	 *
	 * <span class="informal">Flattens multiple Observables together by blending
	 * their values into one Observable.</span>
	 *
	 * <img src="./img/merge.png" width="100%">
	 *
	 * `merge` subscribes to each given input Observable (as arguments), and simply
	 * forwards (without doing any transformation) all the values from all the input
	 * Observables to the output Observable. The output Observable only completes
	 * once all input Observables have completed. Any error delivered by an input
	 * Observable will be immediately emitted on the output Observable.
	 *
	 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
	 * clicksOrTimer.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // timer will emit ascending values, one every second(1000ms) to console
	 * // clicks logs MouseEvents to console everytime the "document" is clicked
	 * // Since the two streams are merged you see these happening
	 * // as they occur.
	 *
	 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var concurrent = 2; // the argument
	 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
	 * merged.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // - First timer1 and timer2 will run concurrently
	 * // - timer1 will emit a value every 1000ms for 10 iterations
	 * // - timer2 will emit a value every 2000ms for 6 iterations
	 * // - after timer1 hits it's max iteration, timer2 will
	 * //   continue, and timer3 will start to run concurrently with timer2
	 * // - when timer2 hits it's max iteration it terminates, and
	 * //   timer3 will continue to emit a value every 500ms until it is complete
	 *
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 *
	 * @param {...ObservableInput} observables Input Observables to merge together.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
	 * concurrency of input Observables.
	 * @return {Observable} an Observable that emits items that are the result of
	 * every input Observable.
	 * @static true
	 * @name merge
	 * @owner Observable
	 */
	function merge() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    var concurrent = Number.POSITIVE_INFINITY;
	    var scheduler = null;
	    var last = observables[observables.length - 1];
	    if (isScheduler_1.isScheduler(last)) {
	        scheduler = observables.pop();
	        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
	            concurrent = observables.pop();
	        }
	    }
	    else if (typeof last === 'number') {
	        concurrent = observables.pop();
	    }
	    if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable_1.Observable) {
	        return observables[0];
	    }
	    return mergeAll_1.mergeAll(concurrent)(new ArrayObservable_1.ArrayObservable(observables, scheduler));
	}
	exports.merge = merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/**
	 * Applies a given `project` function to each value emitted by the source
	 * Observable, and emits the resulting values as an Observable.
	 *
	 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
	 * it passes each source value through a transformation function to get
	 * corresponding output values.</span>
	 *
	 * <img src="./img/map.png" width="100%">
	 *
	 * Similar to the well known `Array.prototype.map` function, this operator
	 * applies a projection to each value and emits that projection in the output
	 * Observable.
	 *
	 * @example <caption>Map every click to the clientX position of that click</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks.map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link mapTo}
	 * @see {@link pluck}
	 *
	 * @param {function(value: T, index: number): R} project The function to apply
	 * to each `value` emitted by the source Observable. The `index` parameter is
	 * the number `i` for the i-th emission that has happened since the
	 * subscription, starting from the number `0`.
	 * @param {any} [thisArg] An optional argument to define what `this` is in the
	 * `project` function.
	 * @return {Observable<R>} An Observable that emits the values from the source
	 * Observable transformed by the given `project` function.
	 * @method map
	 * @owner Observable
	 */
	function map(project, thisArg) {
	    return function mapOperation(source) {
	        if (typeof project !== 'function') {
	            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
	        }
	        return source.lift(new MapOperator(project, thisArg));
	    };
	}
	exports.map = map;
	var MapOperator = (function () {
	    function MapOperator(project, thisArg) {
	        this.project = project;
	        this.thisArg = thisArg;
	    }
	    MapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
	    };
	    return MapOperator;
	}());
	exports.MapOperator = MapOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MapSubscriber = (function (_super) {
	    __extends(MapSubscriber, _super);
	    function MapSubscriber(destination, project, thisArg) {
	        _super.call(this, destination);
	        this.project = project;
	        this.count = 0;
	        this.thisArg = thisArg || this;
	    }
	    // NOTE: This looks unoptimized, but it's actually purposefully NOT
	    // using try/catch optimizations.
	    MapSubscriber.prototype._next = function (value) {
	        var result;
	        try {
	            result = this.project.call(this.thisArg, value, this.count++);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return MapSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=map.js.map

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ConnectableObservable_1 = __webpack_require__(762);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits the results of invoking a specified selector on items
	 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
	 *
	 * <img src="./img/multicast.png" width="100%">
	 *
	 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
	 * which the source sequence's elements will be multicast to the selector function
	 * or Subject to push source elements into.
	 * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
	 * as many times as needed, without causing multiple subscriptions to the source stream.
	 * Subscribers to the given source will receive all notifications of the source from the
	 * time of the subscription forward.
	 * @return {Observable} An Observable that emits the results of invoking the selector
	 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
	 * the underlying stream.
	 * @method multicast
	 * @owner Observable
	 */
	function multicast(subjectOrSubjectFactory, selector) {
	    return function multicastOperatorFunction(source) {
	        var subjectFactory;
	        if (typeof subjectOrSubjectFactory === 'function') {
	            subjectFactory = subjectOrSubjectFactory;
	        }
	        else {
	            subjectFactory = function subjectFactory() {
	                return subjectOrSubjectFactory;
	            };
	        }
	        if (typeof selector === 'function') {
	            return source.lift(new MulticastOperator(subjectFactory, selector));
	        }
	        var connectable = Object.create(source, ConnectableObservable_1.connectableObservableDescriptor);
	        connectable.source = source;
	        connectable.subjectFactory = subjectFactory;
	        return connectable;
	    };
	}
	exports.multicast = multicast;
	var MulticastOperator = (function () {
	    function MulticastOperator(subjectFactory, selector) {
	        this.subjectFactory = subjectFactory;
	        this.selector = selector;
	    }
	    MulticastOperator.prototype.call = function (subscriber, source) {
	        var selector = this.selector;
	        var subject = this.subjectFactory();
	        var subscription = selector(subject).subscribe(subscriber);
	        subscription.add(source.subscribe(subject));
	        return subscription;
	    };
	    return MulticastOperator;
	}());
	exports.MulticastOperator = MulticastOperator;
	//# sourceMappingURL=multicast.js.map

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1214);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Spacer() {
	  return _react2.default.createElement('div', { className: 'util-spacer' });
	}
	
	Spacer.displayName = 'Spacer';
	
	exports.default = Spacer;
	module.exports = exports['default'];

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GreenPass(props) {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'span',
	      { className: 'sr-only' },
	      'Passed'
	    ),
	    _react2.default.createElement(
	      'svg',
	      _extends({
	        height: '50',
	        viewBox: '0 0 200 200',
	        width: '50',
	        xmlns: 'http://www.w3.org/2000/svg'
	      }, props),
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Passed'
	        ),
	        _react2.default.createElement('circle', {
	          cx: '100',
	          cy: '99',
	          fill: '#006400',
	          r: '95',
	          stroke: '#006400',
	          strokeDasharray: 'null',
	          strokeLinecap: 'null',
	          strokeLinejoin: 'null'
	        }),
	        _react2.default.createElement('rect', {
	          fill: '#ffffff',
	          height: '30',
	          stroke: '#ffffff',
	          strokeDasharray: 'null',
	          strokeLinecap: 'null',
	          strokeLinejoin: 'null',
	          transform: 'rotate(-45, 120, 106.321)',
	          width: '128.85878',
	          x: '55.57059',
	          y: '91.32089'
	        }),
	        _react2.default.createElement('rect', {
	          fill: '#ffffff',
	          height: '30',
	          stroke: '#ffffff',
	          strokeDasharray: 'null',
	          strokeLinecap: 'null',
	          strokeLinejoin: 'null',
	          transform: 'rotate(45, 66.75, 123.75)',
	          width: '80.66548',
	          x: '26.41726',
	          y: '108.75'
	        })
	      )
	    )
	  );
	}
	
	GreenPass.displayName = 'GreenPass';
	
	exports.default = GreenPass;
	module.exports = exports['default'];

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.castToObservable = castToObservable;
	exports.createFileStream = createFileStream;
	exports.pipe = pipe;
	exports.createPoly = createPoly;
	exports.isPoly = isPoly;
	exports.checkPoly = checkPoly;
	exports.isEmpty = isEmpty;
	exports.setContent = setContent;
	exports.setExt = setExt;
	exports.setName = setName;
	exports.setError = setError;
	exports.clearHeadTail = clearHeadTail;
	exports.appendToTail = appendToTail;
	exports.compileHeadTail = compileHeadTail;
	exports.transformContents = transformContents;
	exports.transformHeadTailAndContents = transformHeadTailAndContents;
	exports.testContents = testContents;
	exports.updateFileFromSpec = updateFileFromSpec;
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _rxjs = __webpack_require__(88);
	
	var _isPromise = __webpack_require__(522);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // originally based off of https://github.com/gulpjs/vinyl
	
	
	function castToObservable(maybe) {
	  if (maybe instanceof _rxjs.Observable) {
	    return maybe;
	  }
	  if ((0, _isPromise.isPromise)(maybe)) {
	    return _rxjs.Observable.fromPromise(maybe);
	  }
	  return _rxjs.Observable.of(maybe);
	}
	
	// createFileStream(
	//   files: [...PolyVinyl]
	// ) => Observable[...Observable[...PolyVinyl]]
	function createFileStream() {
	  var files = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return _rxjs.Observable.of(_rxjs.Observable.from(files));
	}
	
	// Observable::pipe(
	//  project(
	//    file: PolyVinyl
	//  ) => PolyVinyl|Observable[PolyVinyl]|Promise[PolyVinyl]
	// ) => Observable[...Observable[...PolyVinyl]]
	function pipe(project) {
	  var source = this;
	  return source.map(function (files) {
	    return files.flatMap(function (file) {
	      return castToObservable(project(file));
	    });
	  });
	}
	
	// interface PolyVinyl {
	//   source: String,
	//   contents: String,
	//   name: String,
	//   ext: String,
	//   path: String,
	//   key: String,
	//   head: String,
	//   tail: String,
	//   history: [...String],
	//   error: Null|Object|Error
	// }
	
	// createPoly({
	//   name: String,
	//   ext: String,
	//   contents: String,
	//   history?: [...String],
	// }) => PolyVinyl, throws
	function createPoly() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var name = _ref.name,
	      ext = _ref.ext,
	      contents = _ref.contents,
	      history = _ref.history,
	      rest = _objectWithoutProperties(_ref, ['name', 'ext', 'contents', 'history']);
	
	  (0, _invariant2.default)(typeof name === 'string', 'name must be a string but got %s', name);
	
	  (0, _invariant2.default)(typeof ext === 'string', 'ext must be a string, but was %s', ext);
	
	  (0, _invariant2.default)(typeof contents === 'string', 'contents must be a string but got %s', contents);
	
	  return _extends({}, rest, {
	    history: Array.isArray(history) ? history : [name + ext],
	    name: name,
	    ext: ext,
	    path: name + '.' + ext,
	    key: name + ext,
	    contents: contents,
	    error: null
	  });
	}
	
	// isPoly(poly: Any) => Boolean
	function isPoly(poly) {
	  return poly && typeof poly.contents === 'string' && typeof poly.name === 'string' && typeof poly.ext === 'string' && Array.isArray(poly.history);
	}
	
	// checkPoly(poly: Any) => Void, throws
	function checkPoly(poly) {
	  (0, _invariant2.default)(isPoly(poly), 'function should receive a PolyVinyl, but got %s', poly);
	}
	
	// isEmpty(poly: PolyVinyl) => Boolean, throws
	function isEmpty(poly) {
	  checkPoly(poly);
	  return !!poly.contents;
	}
	
	// setContent(contents: String, poly: PolyVinyl) => PolyVinyl
	// setContent will loose source if set
	function setContent(contents, poly) {
	  checkPoly(poly);
	  return _extends({}, poly, {
	    contents: contents,
	    source: null
	  });
	}
	
	// setExt(ext: String, poly: PolyVinyl) => PolyVinyl
	function setExt(ext, poly) {
	  checkPoly(poly);
	  var newPoly = _extends({}, poly, {
	    ext: ext,
	    path: poly.name + '.' + ext,
	    key: poly.name + ext
	  });
	  newPoly.history = [].concat(poly.history, [newPoly.path]);
	  return newPoly;
	}
	
	// setName(name: String, poly: PolyVinyl) => PolyVinyl
	function setName(name, poly) {
	  checkPoly(poly);
	  var newPoly = _extends({}, poly, {
	    name: name,
	    path: name + '.' + poly.ext,
	    key: name + poly.ext
	  });
	  newPoly.history = [].concat(poly.history, [newPoly.path]);
	  return newPoly;
	}
	
	// setError(error: Object, poly: PolyVinyl) => PolyVinyl
	function setError(error, poly) {
	  (0, _invariant2.default)((typeof error === 'undefined' ? 'undefined' : _typeof(error)) === 'object', 'error must be an object or null, but got %', error);
	  checkPoly(poly);
	  return _extends({}, poly, {
	    error: error
	  });
	}
	
	// clearHeadTail(poly: PolyVinyl) => PolyVinyl
	function clearHeadTail(poly) {
	  checkPoly(poly);
	  return _extends({}, poly, {
	    head: '',
	    tail: ''
	  });
	}
	
	// appendToTail (tail: String, poly: PolyVinyl) => PolyVinyl
	function appendToTail(tail, poly) {
	  checkPoly(poly);
	  return _extends({}, poly, {
	    tail: poly.tail.concat(tail)
	  });
	}
	
	// compileHeadTail(padding: String, poly: PolyVinyl) => PolyVinyl
	function compileHeadTail() {
	  var padding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var poly = arguments[1];
	
	  return clearHeadTail(transformContents(function () {
	    return [poly.head, poly.contents, poly.tail].join(padding);
	  }, poly));
	}
	
	// transformContents(
	//   wrap: (contents: String) => String,
	//   poly: PolyVinyl
	// ) => PolyVinyl
	// transformContents will keep a copy of the original
	// code in the `source` property. If the original polyvinyl
	// already contains a source, this version will continue as
	// the source property
	function transformContents(wrap, poly) {
	  var newPoly = setContent(wrap(poly.contents), poly);
	  // if no source exist, set the original contents as source
	  newPoly.source = poly.source || poly.contents;
	  return newPoly;
	}
	
	// transformHeadTailAndContents(
	//   wrap: (source: String) => String,
	//   poly: PolyVinyl
	// ) => PolyVinyl
	function transformHeadTailAndContents(wrap, poly) {
	  return _extends({}, transformContents(wrap, poly), {
	    head: wrap(poly.head),
	    tail: wrap(poly.tail)
	  });
	}
	
	function testContents(predicate, poly) {
	  return !!predicate(poly.contents);
	}
	
	function updateFileFromSpec(spec, poly) {
	  return setContent(poly.contents, createPoly(spec));
	}

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1036), __esModule: true };

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(1002)
	var ieee754 = __webpack_require__(1003)
	var isArray = __webpack_require__(633)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(85);
	var call = __webpack_require__(566);
	var isArrayIter = __webpack_require__(564);
	var anObject = __webpack_require__(57);
	var toLength = __webpack_require__(296);
	var getIterFn = __webpack_require__(401);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(573);
	var enumBugKeys = __webpack_require__(389);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(387);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 173 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.4' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(305);
	var createDesc = __webpack_require__(591);
	module.exports = __webpack_require__(208) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 175 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWindow;
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	module.exports = exports["default"];

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var bind = __webpack_require__(135);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 178 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var Parser = __webpack_require__(629),
	    DomHandler = __webpack_require__(1161);
	
	function defineProp(name, value){
		delete module.exports[name];
		module.exports[name] = value;
		return value;
	}
	
	module.exports = {
		Parser: Parser,
		Tokenizer: __webpack_require__(630),
		ElementType: __webpack_require__(98),
		DomHandler: DomHandler,
		get FeedHandler(){
			return defineProp("FeedHandler", __webpack_require__(2727));
		},
		get Stream(){
			return defineProp("Stream", __webpack_require__(2729));
		},
		get WritableStream(){
			return defineProp("WritableStream", __webpack_require__(631));
		},
		get ProxyHandler(){
			return defineProp("ProxyHandler", __webpack_require__(2728));
		},
		get DomUtils(){
			return defineProp("DomUtils", __webpack_require__(214));
		},
		get CollectingHandler(){
			return defineProp("CollectingHandler", __webpack_require__(2726));
		},
		// For legacy support
		DefaultHandler: DomHandler,
		get RssHandler(){
			return defineProp("RssHandler", this.FeedHandler);
		},
		//helper methods
		parseDOM: function(data, options){
			var handler = new DomHandler(options);
			new Parser(handler, options).end(data);
			return handler.dom;
		},
		parseFeed: function(feed, options){
			var handler = new module.exports.FeedHandler(options);
			new Parser(handler, options).end(feed);
			return handler.dom;
		},
		createDomStream: function(cb, options, elementCb){
			var handler = new DomHandler(cb, options, elementCb);
			return new Parser(handler, options);
		},
		// List of all events that the parser emits
		EVENTS: { /* Format: eventname: number of arguments */
			attribute: 2,
			cdatastart: 0,
			cdataend: 0,
			text: 1,
			processinginstruction: 2,
			comment: 1,
			commentend: 0,
			closetag: 1,
			opentag: 2,
			opentagname: 1,
			error: 1,
			end: 0
		}
	};


/***/ }),
/* 180 */,
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(42);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 182 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(4216);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var baseUniq = __webpack_require__(650);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each element
	 * is kept. The order of result values is determined by the order they occur
	 * in the array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length) ? baseUniq(array) : [];
	}
	
	module.exports = uniq;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Preprocessor = __webpack_require__(4374),
	    UNICODE = __webpack_require__(234),
	    neTree = __webpack_require__(4373);
	
	//Aliases
	var $ = UNICODE.CODE_POINTS,
	    $$ = UNICODE.CODE_POINT_SEQUENCES;
	
	//Replacement code points for numeric entities
	var NUMERIC_ENTITY_REPLACEMENTS = {
	    0x00: 0xFFFD, 0x0D: 0x000D, 0x80: 0x20AC, 0x81: 0x0081, 0x82: 0x201A, 0x83: 0x0192, 0x84: 0x201E,
	    0x85: 0x2026, 0x86: 0x2020, 0x87: 0x2021, 0x88: 0x02C6, 0x89: 0x2030, 0x8A: 0x0160, 0x8B: 0x2039,
	    0x8C: 0x0152, 0x8D: 0x008D, 0x8E: 0x017D, 0x8F: 0x008F, 0x90: 0x0090, 0x91: 0x2018, 0x92: 0x2019,
	    0x93: 0x201C, 0x94: 0x201D, 0x95: 0x2022, 0x96: 0x2013, 0x97: 0x2014, 0x98: 0x02DC, 0x99: 0x2122,
	    0x9A: 0x0161, 0x9B: 0x203A, 0x9C: 0x0153, 0x9D: 0x009D, 0x9E: 0x017E, 0x9F: 0x0178
	};
	
	// Named entity tree flags
	var HAS_DATA_FLAG = 1 << 0;
	var DATA_DUPLET_FLAG = 1 << 1;
	var HAS_BRANCHES_FLAG = 1 << 2;
	var MAX_BRANCH_MARKER_VALUE = HAS_DATA_FLAG | DATA_DUPLET_FLAG | HAS_BRANCHES_FLAG;
	
	
	//States
	var DATA_STATE = 'DATA_STATE',
	    CHARACTER_REFERENCE_IN_DATA_STATE = 'CHARACTER_REFERENCE_IN_DATA_STATE',
	    RCDATA_STATE = 'RCDATA_STATE',
	    CHARACTER_REFERENCE_IN_RCDATA_STATE = 'CHARACTER_REFERENCE_IN_RCDATA_STATE',
	    RAWTEXT_STATE = 'RAWTEXT_STATE',
	    SCRIPT_DATA_STATE = 'SCRIPT_DATA_STATE',
	    PLAINTEXT_STATE = 'PLAINTEXT_STATE',
	    TAG_OPEN_STATE = 'TAG_OPEN_STATE',
	    END_TAG_OPEN_STATE = 'END_TAG_OPEN_STATE',
	    TAG_NAME_STATE = 'TAG_NAME_STATE',
	    RCDATA_LESS_THAN_SIGN_STATE = 'RCDATA_LESS_THAN_SIGN_STATE',
	    RCDATA_END_TAG_OPEN_STATE = 'RCDATA_END_TAG_OPEN_STATE',
	    RCDATA_END_TAG_NAME_STATE = 'RCDATA_END_TAG_NAME_STATE',
	    RAWTEXT_LESS_THAN_SIGN_STATE = 'RAWTEXT_LESS_THAN_SIGN_STATE',
	    RAWTEXT_END_TAG_OPEN_STATE = 'RAWTEXT_END_TAG_OPEN_STATE',
	    RAWTEXT_END_TAG_NAME_STATE = 'RAWTEXT_END_TAG_NAME_STATE',
	    SCRIPT_DATA_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_LESS_THAN_SIGN_STATE',
	    SCRIPT_DATA_END_TAG_OPEN_STATE = 'SCRIPT_DATA_END_TAG_OPEN_STATE',
	    SCRIPT_DATA_END_TAG_NAME_STATE = 'SCRIPT_DATA_END_TAG_NAME_STATE',
	    SCRIPT_DATA_ESCAPE_START_STATE = 'SCRIPT_DATA_ESCAPE_START_STATE',
	    SCRIPT_DATA_ESCAPE_START_DASH_STATE = 'SCRIPT_DATA_ESCAPE_START_DASH_STATE',
	    SCRIPT_DATA_ESCAPED_STATE = 'SCRIPT_DATA_ESCAPED_STATE',
	    SCRIPT_DATA_ESCAPED_DASH_STATE = 'SCRIPT_DATA_ESCAPED_DASH_STATE',
	    SCRIPT_DATA_ESCAPED_DASH_DASH_STATE = 'SCRIPT_DATA_ESCAPED_DASH_DASH_STATE',
	    SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE',
	    SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE = 'SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE',
	    SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE = 'SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE',
	    SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE',
	    SCRIPT_DATA_DOUBLE_ESCAPED_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_STATE',
	    SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE',
	    SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE',
	    SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE',
	    SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE',
	    BEFORE_ATTRIBUTE_NAME_STATE = 'BEFORE_ATTRIBUTE_NAME_STATE',
	    ATTRIBUTE_NAME_STATE = 'ATTRIBUTE_NAME_STATE',
	    AFTER_ATTRIBUTE_NAME_STATE = 'AFTER_ATTRIBUTE_NAME_STATE',
	    BEFORE_ATTRIBUTE_VALUE_STATE = 'BEFORE_ATTRIBUTE_VALUE_STATE',
	    ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE = 'ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE',
	    ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE = 'ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE',
	    ATTRIBUTE_VALUE_UNQUOTED_STATE = 'ATTRIBUTE_VALUE_UNQUOTED_STATE',
	    CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE = 'CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE',
	    AFTER_ATTRIBUTE_VALUE_QUOTED_STATE = 'AFTER_ATTRIBUTE_VALUE_QUOTED_STATE',
	    SELF_CLOSING_START_TAG_STATE = 'SELF_CLOSING_START_TAG_STATE',
	    BOGUS_COMMENT_STATE = 'BOGUS_COMMENT_STATE',
	    BOGUS_COMMENT_STATE_CONTINUATION = 'BOGUS_COMMENT_STATE_CONTINUATION',
	    MARKUP_DECLARATION_OPEN_STATE = 'MARKUP_DECLARATION_OPEN_STATE',
	    COMMENT_START_STATE = 'COMMENT_START_STATE',
	    COMMENT_START_DASH_STATE = 'COMMENT_START_DASH_STATE',
	    COMMENT_STATE = 'COMMENT_STATE',
	    COMMENT_END_DASH_STATE = 'COMMENT_END_DASH_STATE',
	    COMMENT_END_STATE = 'COMMENT_END_STATE',
	    COMMENT_END_BANG_STATE = 'COMMENT_END_BANG_STATE',
	    DOCTYPE_STATE = 'DOCTYPE_STATE',
	    DOCTYPE_NAME_STATE = 'DOCTYPE_NAME_STATE',
	    AFTER_DOCTYPE_NAME_STATE = 'AFTER_DOCTYPE_NAME_STATE',
	    BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE = 'BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE',
	    DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE = 'DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE',
	    DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE = 'DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE',
	    BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE = 'BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE',
	    BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE = 'BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE',
	    DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE = 'DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE',
	    DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE = 'DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE',
	    AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE = 'AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE',
	    BOGUS_DOCTYPE_STATE = 'BOGUS_DOCTYPE_STATE',
	    CDATA_SECTION_STATE = 'CDATA_SECTION_STATE';
	
	//Utils
	
	//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
	//this functions if they will be situated in another module due to context switch.
	//Always perform inlining check before modifying this functions ('node --trace-inlining').
	function isWhitespace(cp) {
	    return cp === $.SPACE || cp === $.LINE_FEED || cp === $.TABULATION || cp === $.FORM_FEED;
	}
	
	function isAsciiDigit(cp) {
	    return cp >= $.DIGIT_0 && cp <= $.DIGIT_9;
	}
	
	function isAsciiUpper(cp) {
	    return cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_Z;
	}
	
	function isAsciiLower(cp) {
	    return cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_Z;
	}
	
	function isAsciiLetter(cp) {
	    return isAsciiLower(cp) || isAsciiUpper(cp);
	}
	
	function isAsciiAlphaNumeric(cp) {
	    return isAsciiLetter(cp) || isAsciiDigit(cp);
	}
	
	function isDigit(cp, isHex) {
	    return isAsciiDigit(cp) || isHex && (cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_F ||
	                                         cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_F);
	}
	
	function isReservedCodePoint(cp) {
	    return cp >= 0xD800 && cp <= 0xDFFF || cp > 0x10FFFF;
	}
	
	function toAsciiLowerCodePoint(cp) {
	    return cp + 0x0020;
	}
	
	//NOTE: String.fromCharCode() function can handle only characters from BMP subset.
	//So, we need to workaround this manually.
	//(see: https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/String/fromCharCode#Getting_it_to_work_with_higher_values)
	function toChar(cp) {
	    if (cp <= 0xFFFF)
	        return String.fromCharCode(cp);
	
	    cp -= 0x10000;
	    return String.fromCharCode(cp >>> 10 & 0x3FF | 0xD800) + String.fromCharCode(0xDC00 | cp & 0x3FF);
	}
	
	function toAsciiLowerChar(cp) {
	    return String.fromCharCode(toAsciiLowerCodePoint(cp));
	}
	
	function findNamedEntityTreeBranch(nodeIx, cp) {
	    var branchCount = neTree[++nodeIx],
	        lo = ++nodeIx,
	        hi = lo + branchCount - 1;
	
	    while (lo <= hi) {
	        var mid = lo + hi >>> 1,
	            midCp = neTree[mid];
	
	        if (midCp < cp)
	            lo = mid + 1;
	
	        else if (midCp > cp)
	            hi = mid - 1;
	
	        else
	            return neTree[mid + branchCount];
	    }
	
	    return -1;
	}
	
	
	//Tokenizer
	var Tokenizer = module.exports = function () {
	    this.preprocessor = new Preprocessor();
	
	    this.tokenQueue = [];
	
	    this.allowCDATA = false;
	
	    this.state = DATA_STATE;
	    this.returnState = '';
	
	    this.tempBuff = [];
	    this.additionalAllowedCp = void 0;
	    this.lastStartTagName = '';
	
	    this.consumedAfterSnapshot = -1;
	    this.active = false;
	
	    this.currentCharacterToken = null;
	    this.currentToken = null;
	    this.currentAttr = null;
	};
	
	//Token types
	Tokenizer.CHARACTER_TOKEN = 'CHARACTER_TOKEN';
	Tokenizer.NULL_CHARACTER_TOKEN = 'NULL_CHARACTER_TOKEN';
	Tokenizer.WHITESPACE_CHARACTER_TOKEN = 'WHITESPACE_CHARACTER_TOKEN';
	Tokenizer.START_TAG_TOKEN = 'START_TAG_TOKEN';
	Tokenizer.END_TAG_TOKEN = 'END_TAG_TOKEN';
	Tokenizer.COMMENT_TOKEN = 'COMMENT_TOKEN';
	Tokenizer.DOCTYPE_TOKEN = 'DOCTYPE_TOKEN';
	Tokenizer.EOF_TOKEN = 'EOF_TOKEN';
	Tokenizer.HIBERNATION_TOKEN = 'HIBERNATION_TOKEN';
	
	//Tokenizer initial states for different modes
	Tokenizer.MODE = {
	    DATA: DATA_STATE,
	    RCDATA: RCDATA_STATE,
	    RAWTEXT: RAWTEXT_STATE,
	    SCRIPT_DATA: SCRIPT_DATA_STATE,
	    PLAINTEXT: PLAINTEXT_STATE
	};
	
	//Static
	Tokenizer.getTokenAttr = function (token, attrName) {
	    for (var i = token.attrs.length - 1; i >= 0; i--) {
	        if (token.attrs[i].name === attrName)
	            return token.attrs[i].value;
	    }
	
	    return null;
	};
	
	//API
	Tokenizer.prototype.getNextToken = function () {
	    while (!this.tokenQueue.length && this.active) {
	        this._hibernationSnapshot();
	
	        var cp = this._consume();
	
	        if (!this._ensureHibernation())
	            this[this.state](cp);
	    }
	
	    return this.tokenQueue.shift();
	};
	
	Tokenizer.prototype.write = function (chunk, isLastChunk) {
	    this.active = true;
	    this.preprocessor.write(chunk, isLastChunk);
	};
	
	Tokenizer.prototype.insertHtmlAtCurrentPos = function (chunk) {
	    this.active = true;
	    this.preprocessor.insertHtmlAtCurrentPos(chunk);
	};
	
	//Hibernation
	Tokenizer.prototype._hibernationSnapshot = function () {
	    this.consumedAfterSnapshot = 0;
	};
	
	Tokenizer.prototype._ensureHibernation = function () {
	    if (this.preprocessor.endOfChunkHit) {
	        for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--)
	            this.preprocessor.retreat();
	
	        this.active = false;
	        this.tokenQueue.push({type: Tokenizer.HIBERNATION_TOKEN});
	
	        return true;
	    }
	
	    return false;
	};
	
	
	//Consumption
	Tokenizer.prototype._consume = function () {
	    this.consumedAfterSnapshot++;
	    return this.preprocessor.advance();
	};
	
	Tokenizer.prototype._unconsume = function () {
	    this.consumedAfterSnapshot--;
	    this.preprocessor.retreat();
	};
	
	Tokenizer.prototype._unconsumeSeveral = function (count) {
	    while (count--)
	        this._unconsume();
	};
	
	Tokenizer.prototype._reconsumeInState = function (state) {
	    this.state = state;
	    this._unconsume();
	};
	
	Tokenizer.prototype._consumeSubsequentIfMatch = function (pattern, startCp, caseSensitive) {
	    var consumedCount = 0,
	        isMatch = true,
	        patternLength = pattern.length,
	        patternPos = 0,
	        cp = startCp,
	        patternCp = void 0;
	
	    for (; patternPos < patternLength; patternPos++) {
	        if (patternPos > 0) {
	            cp = this._consume();
	            consumedCount++;
	        }
	
	        if (cp === $.EOF) {
	            isMatch = false;
	            break;
	        }
	
	        patternCp = pattern[patternPos];
	
	        if (cp !== patternCp && (caseSensitive || cp !== toAsciiLowerCodePoint(patternCp))) {
	            isMatch = false;
	            break;
	        }
	    }
	
	    if (!isMatch)
	        this._unconsumeSeveral(consumedCount);
	
	    return isMatch;
	};
	
	//Lookahead
	Tokenizer.prototype._lookahead = function () {
	    var cp = this._consume();
	
	    this._unconsume();
	
	    return cp;
	};
	
	//Temp buffer
	Tokenizer.prototype.isTempBufferEqualToScriptString = function () {
	    if (this.tempBuff.length !== $$.SCRIPT_STRING.length)
	        return false;
	
	    for (var i = 0; i < this.tempBuff.length; i++) {
	        if (this.tempBuff[i] !== $$.SCRIPT_STRING[i])
	            return false;
	    }
	
	    return true;
	};
	
	//Token creation
	Tokenizer.prototype._createStartTagToken = function () {
	    this.currentToken = {
	        type: Tokenizer.START_TAG_TOKEN,
	        tagName: '',
	        selfClosing: false,
	        attrs: []
	    };
	};
	
	Tokenizer.prototype._createEndTagToken = function () {
	    this.currentToken = {
	        type: Tokenizer.END_TAG_TOKEN,
	        tagName: '',
	        attrs: []
	    };
	};
	
	Tokenizer.prototype._createCommentToken = function () {
	    this.currentToken = {
	        type: Tokenizer.COMMENT_TOKEN,
	        data: ''
	    };
	};
	
	Tokenizer.prototype._createDoctypeToken = function (initialName) {
	    this.currentToken = {
	        type: Tokenizer.DOCTYPE_TOKEN,
	        name: initialName,
	        forceQuirks: false,
	        publicId: null,
	        systemId: null
	    };
	};
	
	Tokenizer.prototype._createCharacterToken = function (type, ch) {
	    this.currentCharacterToken = {
	        type: type,
	        chars: ch
	    };
	};
	
	//Tag attributes
	Tokenizer.prototype._createAttr = function (attrNameFirstCh) {
	    this.currentAttr = {
	        name: attrNameFirstCh,
	        value: ''
	    };
	};
	
	Tokenizer.prototype._isDuplicateAttr = function () {
	    return Tokenizer.getTokenAttr(this.currentToken, this.currentAttr.name) !== null;
	};
	
	Tokenizer.prototype._leaveAttrName = function (toState) {
	    this.state = toState;
	
	    if (!this._isDuplicateAttr())
	        this.currentToken.attrs.push(this.currentAttr);
	};
	
	Tokenizer.prototype._leaveAttrValue = function (toState) {
	    this.state = toState;
	};
	
	//Appropriate end tag token
	//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tokenization.html#appropriate-end-tag-token)
	Tokenizer.prototype._isAppropriateEndTagToken = function () {
	    return this.lastStartTagName === this.currentToken.tagName;
	};
	
	//Token emission
	Tokenizer.prototype._emitCurrentToken = function () {
	    this._emitCurrentCharacterToken();
	
	    //NOTE: store emited start tag's tagName to determine is the following end tag token is appropriate.
	    if (this.currentToken.type === Tokenizer.START_TAG_TOKEN)
	        this.lastStartTagName = this.currentToken.tagName;
	
	    this.tokenQueue.push(this.currentToken);
	    this.currentToken = null;
	};
	
	Tokenizer.prototype._emitCurrentCharacterToken = function () {
	    if (this.currentCharacterToken) {
	        this.tokenQueue.push(this.currentCharacterToken);
	        this.currentCharacterToken = null;
	    }
	};
	
	Tokenizer.prototype._emitEOFToken = function () {
	    this._emitCurrentCharacterToken();
	    this.tokenQueue.push({type: Tokenizer.EOF_TOKEN});
	};
	
	//Characters emission
	
	//OPTIMIZATION: specification uses only one type of character tokens (one token per character).
	//This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
	//If we have a sequence of characters that belong to the same group, parser can process it
	//as a single solid character token.
	//So, there are 3 types of character tokens in parse5:
	//1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
	//2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
	//3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
	Tokenizer.prototype._appendCharToCurrentCharacterToken = function (type, ch) {
	    if (this.currentCharacterToken && this.currentCharacterToken.type !== type)
	        this._emitCurrentCharacterToken();
	
	    if (this.currentCharacterToken)
	        this.currentCharacterToken.chars += ch;
	
	    else
	        this._createCharacterToken(type, ch);
	};
	
	Tokenizer.prototype._emitCodePoint = function (cp) {
	    var type = Tokenizer.CHARACTER_TOKEN;
	
	    if (isWhitespace(cp))
	        type = Tokenizer.WHITESPACE_CHARACTER_TOKEN;
	
	    else if (cp === $.NULL)
	        type = Tokenizer.NULL_CHARACTER_TOKEN;
	
	    this._appendCharToCurrentCharacterToken(type, toChar(cp));
	};
	
	Tokenizer.prototype._emitSeveralCodePoints = function (codePoints) {
	    for (var i = 0; i < codePoints.length; i++)
	        this._emitCodePoint(codePoints[i]);
	};
	
	//NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
	//So we can avoid additional checks here.
	Tokenizer.prototype._emitChar = function (ch) {
	    this._appendCharToCurrentCharacterToken(Tokenizer.CHARACTER_TOKEN, ch);
	};
	
	//Character reference tokenization
	Tokenizer.prototype._consumeNumericEntity = function (isHex) {
	    var digits = '',
	        nextCp = void 0;
	
	    do {
	        digits += toChar(this._consume());
	        nextCp = this._lookahead();
	    } while (nextCp !== $.EOF && isDigit(nextCp, isHex));
	
	    if (this._lookahead() === $.SEMICOLON)
	        this._consume();
	
	    var referencedCp = parseInt(digits, isHex ? 16 : 10),
	        replacement = NUMERIC_ENTITY_REPLACEMENTS[referencedCp];
	
	    if (replacement)
	        return replacement;
	
	    if (isReservedCodePoint(referencedCp))
	        return $.REPLACEMENT_CHARACTER;
	
	    return referencedCp;
	};
	
	// NOTE: for the details on this algorithm see
	// https://github.com/inikulin/parse5/tree/master/scripts/generate_named_entity_data/README.md
	Tokenizer.prototype._consumeNamedEntity = function (inAttr) {
	    var referencedCodePoints = null,
	        referenceSize = 0,
	        cp = null,
	        consumedCount = 0,
	        semicolonTerminated = false;
	
	    for (var i = 0; i > -1;) {
	        var current = neTree[i],
	            inNode = current < MAX_BRANCH_MARKER_VALUE,
	            nodeWithData = inNode && current & HAS_DATA_FLAG;
	
	        if (nodeWithData) {
	            referencedCodePoints = current & DATA_DUPLET_FLAG ? [neTree[++i], neTree[++i]] : [neTree[++i]];
	            referenceSize = consumedCount;
	
	            if (cp === $.SEMICOLON) {
	                semicolonTerminated = true;
	                break;
	            }
	        }
	
	        cp = this._consume();
	        consumedCount++;
	
	        if (cp === $.EOF)
	            break;
	
	        if (inNode)
	            i = current & HAS_BRANCHES_FLAG ? findNamedEntityTreeBranch(i, cp) : -1;
	
	        else
	            i = cp === current ? ++i : -1;
	    }
	
	
	    if (referencedCodePoints) {
	        if (!semicolonTerminated) {
	            //NOTE: unconsume excess (e.g. 'it' in '&notit')
	            this._unconsumeSeveral(consumedCount - referenceSize);
	
	            //NOTE: If the character reference is being consumed as part of an attribute and the next character
	            //is either a U+003D EQUALS SIGN character (=) or an alphanumeric ASCII character, then, for historical
	            //reasons, all the characters that were matched after the U+0026 AMPERSAND character (&) must be
	            //unconsumed, and nothing is returned.
	            //However, if this next character is in fact a U+003D EQUALS SIGN character (=), then this is a
	            //parse error, because some legacy user agents will misinterpret the markup in those cases.
	            //(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tokenization.html#tokenizing-character-references)
	            if (inAttr) {
	                var nextCp = this._lookahead();
	
	                if (nextCp === $.EQUALS_SIGN || isAsciiAlphaNumeric(nextCp)) {
	                    this._unconsumeSeveral(referenceSize);
	                    return null;
	                }
	            }
	        }
	
	        return referencedCodePoints;
	    }
	
	    this._unconsumeSeveral(consumedCount);
	
	    return null;
	};
	
	Tokenizer.prototype._consumeCharacterReference = function (startCp, inAttr) {
	    if (isWhitespace(startCp) || startCp === $.GREATER_THAN_SIGN ||
	        startCp === $.AMPERSAND || startCp === this.additionalAllowedCp || startCp === $.EOF) {
	        //NOTE: not a character reference. No characters are consumed, and nothing is returned.
	        this._unconsume();
	        return null;
	    }
	
	    if (startCp === $.NUMBER_SIGN) {
	        //NOTE: we have a numeric entity candidate, now we should determine if it's hex or decimal
	        var isHex = false,
	            nextCp = this._lookahead();
	
	        if (nextCp === $.LATIN_SMALL_X || nextCp === $.LATIN_CAPITAL_X) {
	            this._consume();
	            isHex = true;
	        }
	
	        nextCp = this._lookahead();
	
	        //NOTE: if we have at least one digit this is a numeric entity for sure, so we consume it
	        if (nextCp !== $.EOF && isDigit(nextCp, isHex))
	            return [this._consumeNumericEntity(isHex)];
	
	        //NOTE: otherwise this is a bogus number entity and a parse error. Unconsume the number sign
	        //and the 'x'-character if appropriate.
	        this._unconsumeSeveral(isHex ? 2 : 1);
	        return null;
	    }
	
	    this._unconsume();
	
	    return this._consumeNamedEntity(inAttr);
	};
	
	//State machine
	var _ = Tokenizer.prototype;
	
	//12.2.4.1 Data state
	//------------------------------------------------------------------
	_[DATA_STATE] = function dataState(cp) {
	    this.preprocessor.dropParsedChunk();
	
	    if (cp === $.AMPERSAND)
	        this.state = CHARACTER_REFERENCE_IN_DATA_STATE;
	
	    else if (cp === $.LESS_THAN_SIGN)
	        this.state = TAG_OPEN_STATE;
	
	    else if (cp === $.NULL)
	        this._emitCodePoint(cp);
	
	    else if (cp === $.EOF)
	        this._emitEOFToken();
	
	    else
	        this._emitCodePoint(cp);
	};
	
	
	//12.2.4.2 Character reference in data state
	//------------------------------------------------------------------
	_[CHARACTER_REFERENCE_IN_DATA_STATE] = function characterReferenceInDataState(cp) {
	    this.additionalAllowedCp = void 0;
	
	    var referencedCodePoints = this._consumeCharacterReference(cp, false);
	
	    if (!this._ensureHibernation()) {
	        if (referencedCodePoints)
	            this._emitSeveralCodePoints(referencedCodePoints);
	
	        else
	            this._emitChar('&');
	
	        this.state = DATA_STATE;
	    }
	};
	
	
	//12.2.4.3 RCDATA state
	//------------------------------------------------------------------
	_[RCDATA_STATE] = function rcdataState(cp) {
	    this.preprocessor.dropParsedChunk();
	
	    if (cp === $.AMPERSAND)
	        this.state = CHARACTER_REFERENCE_IN_RCDATA_STATE;
	
	    else if (cp === $.LESS_THAN_SIGN)
	        this.state = RCDATA_LESS_THAN_SIGN_STATE;
	
	    else if (cp === $.NULL)
	        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
	
	    else if (cp === $.EOF)
	        this._emitEOFToken();
	
	    else
	        this._emitCodePoint(cp);
	};
	
	
	//12.2.4.4 Character reference in RCDATA state
	//------------------------------------------------------------------
	_[CHARACTER_REFERENCE_IN_RCDATA_STATE] = function characterReferenceInRcdataState(cp) {
	    this.additionalAllowedCp = void 0;
	
	    var referencedCodePoints = this._consumeCharacterReference(cp, false);
	
	    if (!this._ensureHibernation()) {
	        if (referencedCodePoints)
	            this._emitSeveralCodePoints(referencedCodePoints);
	
	        else
	            this._emitChar('&');
	
	        this.state = RCDATA_STATE;
	    }
	};
	
	
	//12.2.4.5 RAWTEXT state
	//------------------------------------------------------------------
	_[RAWTEXT_STATE] = function rawtextState(cp) {
	    this.preprocessor.dropParsedChunk();
	
	    if (cp === $.LESS_THAN_SIGN)
	        this.state = RAWTEXT_LESS_THAN_SIGN_STATE;
	
	    else if (cp === $.NULL)
	        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
	
	    else if (cp === $.EOF)
	        this._emitEOFToken();
	
	    else
	        this._emitCodePoint(cp);
	};
	
	
	//12.2.4.6 Script data state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_STATE] = function scriptDataState(cp) {
	    this.preprocessor.dropParsedChunk();
	
	    if (cp === $.LESS_THAN_SIGN)
	        this.state = SCRIPT_DATA_LESS_THAN_SIGN_STATE;
	
	    else if (cp === $.NULL)
	        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
	
	    else if (cp === $.EOF)
	        this._emitEOFToken();
	
	    else
	        this._emitCodePoint(cp);
	};
	
	
	//12.2.4.7 PLAINTEXT state
	//------------------------------------------------------------------
	_[PLAINTEXT_STATE] = function plaintextState(cp) {
	    this.preprocessor.dropParsedChunk();
	
	    if (cp === $.NULL)
	        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
	
	    else if (cp === $.EOF)
	        this._emitEOFToken();
	
	    else
	        this._emitCodePoint(cp);
	};
	
	
	//12.2.4.8 Tag open state
	//------------------------------------------------------------------
	_[TAG_OPEN_STATE] = function tagOpenState(cp) {
	    if (cp === $.EXCLAMATION_MARK)
	        this.state = MARKUP_DECLARATION_OPEN_STATE;
	
	    else if (cp === $.SOLIDUS)
	        this.state = END_TAG_OPEN_STATE;
	
	    else if (isAsciiLetter(cp)) {
	        this._createStartTagToken();
	        this._reconsumeInState(TAG_NAME_STATE);
	    }
	
	    else if (cp === $.QUESTION_MARK)
	        this._reconsumeInState(BOGUS_COMMENT_STATE);
	
	    else {
	        this._emitChar('<');
	        this._reconsumeInState(DATA_STATE);
	    }
	};
	
	
	//12.2.4.9 End tag open state
	//------------------------------------------------------------------
	_[END_TAG_OPEN_STATE] = function endTagOpenState(cp) {
	    if (isAsciiLetter(cp)) {
	        this._createEndTagToken();
	        this._reconsumeInState(TAG_NAME_STATE);
	    }
	
	    else if (cp === $.GREATER_THAN_SIGN)
	        this.state = DATA_STATE;
	
	    else if (cp === $.EOF) {
	        this._reconsumeInState(DATA_STATE);
	        this._emitChar('<');
	        this._emitChar('/');
	    }
	
	    else
	        this._reconsumeInState(BOGUS_COMMENT_STATE);
	};
	
	
	//12.2.4.10 Tag name state
	//------------------------------------------------------------------
	_[TAG_NAME_STATE] = function tagNameState(cp) {
	    if (isWhitespace(cp))
	        this.state = BEFORE_ATTRIBUTE_NAME_STATE;
	
	    else if (cp === $.SOLIDUS)
	        this.state = SELF_CLOSING_START_TAG_STATE;
	
	    else if (cp === $.GREATER_THAN_SIGN) {
	        this.state = DATA_STATE;
	        this._emitCurrentToken();
	    }
	
	    else if (isAsciiUpper(cp))
	        this.currentToken.tagName += toAsciiLowerChar(cp);
	
	    else if (cp === $.NULL)
	        this.currentToken.tagName += UNICODE.REPLACEMENT_CHARACTER;
	
	    else if (cp === $.EOF)
	        this._reconsumeInState(DATA_STATE);
	
	    else
	        this.currentToken.tagName += toChar(cp);
	};
	
	
	//12.2.4.11 RCDATA less-than sign state
	//------------------------------------------------------------------
	_[RCDATA_LESS_THAN_SIGN_STATE] = function rcdataLessThanSignState(cp) {
	    if (cp === $.SOLIDUS) {
	        this.tempBuff = [];
	        this.state = RCDATA_END_TAG_OPEN_STATE;
	    }
	
	    else {
	        this._emitChar('<');
	        this._reconsumeInState(RCDATA_STATE);
	    }
	};
	
	
	//12.2.4.12 RCDATA end tag open state
	//------------------------------------------------------------------
	_[RCDATA_END_TAG_OPEN_STATE] = function rcdataEndTagOpenState(cp) {
	    if (isAsciiLetter(cp)) {
	        this._createEndTagToken();
	        this._reconsumeInState(RCDATA_END_TAG_NAME_STATE);
	    }
	
	    else {
	        this._emitChar('<');
	        this._emitChar('/');
	        this._reconsumeInState(RCDATA_STATE);
	    }
	};
	
	
	//12.2.4.13 RCDATA end tag name state
	//------------------------------------------------------------------
	_[RCDATA_END_TAG_NAME_STATE] = function rcdataEndTagNameState(cp) {
	    if (isAsciiUpper(cp)) {
	        this.currentToken.tagName += toAsciiLowerChar(cp);
	        this.tempBuff.push(cp);
	    }
	
	    else if (isAsciiLower(cp)) {
	        this.currentToken.tagName += toChar(cp);
	        this.tempBuff.push(cp);
	    }
	
	    else {
	        if (this._isAppropriateEndTagToken()) {
	            if (isWhitespace(cp)) {
	                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
	                return;
	            }
	
	            if (cp === $.SOLIDUS) {
	                this.state = SELF_CLOSING_START_TAG_STATE;
	                return;
	            }
	
	            if (cp === $.GREATER_THAN_SIGN) {
	                this.state = DATA_STATE;
	                this._emitCurrentToken();
	                return;
	            }
	        }
	
	        this._emitChar('<');
	        this._emitChar('/');
	        this._emitSeveralCodePoints(this.tempBuff);
	        this._reconsumeInState(RCDATA_STATE);
	    }
	};
	
	
	//12.2.4.14 RAWTEXT less-than sign state
	//------------------------------------------------------------------
	_[RAWTEXT_LESS_THAN_SIGN_STATE] = function rawtextLessThanSignState(cp) {
	    if (cp === $.SOLIDUS) {
	        this.tempBuff = [];
	        this.state = RAWTEXT_END_TAG_OPEN_STATE;
	    }
	
	    else {
	        this._emitChar('<');
	        this._reconsumeInState(RAWTEXT_STATE);
	    }
	};
	
	
	//12.2.4.15 RAWTEXT end tag open state
	//------------------------------------------------------------------
	_[RAWTEXT_END_TAG_OPEN_STATE] = function rawtextEndTagOpenState(cp) {
	    if (isAsciiLetter(cp)) {
	        this._createEndTagToken();
	        this._reconsumeInState(RAWTEXT_END_TAG_NAME_STATE);
	    }
	
	    else {
	        this._emitChar('<');
	        this._emitChar('/');
	        this._reconsumeInState(RAWTEXT_STATE);
	    }
	};
	
	
	//12.2.4.16 RAWTEXT end tag name state
	//------------------------------------------------------------------
	_[RAWTEXT_END_TAG_NAME_STATE] = function rawtextEndTagNameState(cp) {
	    if (isAsciiUpper(cp)) {
	        this.currentToken.tagName += toAsciiLowerChar(cp);
	        this.tempBuff.push(cp);
	    }
	
	    else if (isAsciiLower(cp)) {
	        this.currentToken.tagName += toChar(cp);
	        this.tempBuff.push(cp);
	    }
	
	    else {
	        if (this._isAppropriateEndTagToken()) {
	            if (isWhitespace(cp)) {
	                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
	                return;
	            }
	
	            if (cp === $.SOLIDUS) {
	                this.state = SELF_CLOSING_START_TAG_STATE;
	                return;
	            }
	
	            if (cp === $.GREATER_THAN_SIGN) {
	                this._emitCurrentToken();
	                this.state = DATA_STATE;
	                return;
	            }
	        }
	
	        this._emitChar('<');
	        this._emitChar('/');
	        this._emitSeveralCodePoints(this.tempBuff);
	        this._reconsumeInState(RAWTEXT_STATE);
	    }
	};
	
	
	//12.2.4.17 Script data less-than sign state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_LESS_THAN_SIGN_STATE] = function scriptDataLessThanSignState(cp) {
	    if (cp === $.SOLIDUS) {
	        this.tempBuff = [];
	        this.state = SCRIPT_DATA_END_TAG_OPEN_STATE;
	    }
	
	    else if (cp === $.EXCLAMATION_MARK) {
	        this.state = SCRIPT_DATA_ESCAPE_START_STATE;
	        this._emitChar('<');
	        this._emitChar('!');
	    }
	
	    else {
	        this._emitChar('<');
	        this._reconsumeInState(SCRIPT_DATA_STATE);
	    }
	};
	
	
	//12.2.4.18 Script data end tag open state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_END_TAG_OPEN_STATE] = function scriptDataEndTagOpenState(cp) {
	    if (isAsciiLetter(cp)) {
	        this._createEndTagToken();
	        this._reconsumeInState(SCRIPT_DATA_END_TAG_NAME_STATE);
	    }
	
	    else {
	        this._emitChar('<');
	        this._emitChar('/');
	        this._reconsumeInState(SCRIPT_DATA_STATE);
	    }
	};
	
	
	//12.2.4.19 Script data end tag name state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_END_TAG_NAME_STATE] = function scriptDataEndTagNameState(cp) {
	    if (isAsciiUpper(cp)) {
	        this.currentToken.tagName += toAsciiLowerChar(cp);
	        this.tempBuff.push(cp);
	    }
	
	    else if (isAsciiLower(cp)) {
	        this.currentToken.tagName += toChar(cp);
	        this.tempBuff.push(cp);
	    }
	
	    else {
	        if (this._isAppropriateEndTagToken()) {
	            if (isWhitespace(cp)) {
	                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
	                return;
	            }
	
	            else if (cp === $.SOLIDUS) {
	                this.state = SELF_CLOSING_START_TAG_STATE;
	                return;
	            }
	
	            else if (cp === $.GREATER_THAN_SIGN) {
	                this._emitCurrentToken();
	                this.state = DATA_STATE;
	                return;
	            }
	        }
	
	        this._emitChar('<');
	        this._emitChar('/');
	        this._emitSeveralCodePoints(this.tempBuff);
	        this._reconsumeInState(SCRIPT_DATA_STATE);
	    }
	};
	
	
	//12.2.4.20 Script data escape start state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_ESCAPE_START_STATE] = function scriptDataEscapeStartState(cp) {
	    if (cp === $.HYPHEN_MINUS) {
	        this.state = SCRIPT_DATA_ESCAPE_START_DASH_STATE;
	        this._emitChar('-');
	    }
	
	    else
	        this._reconsumeInState(SCRIPT_DATA_STATE);
	};
	
	
	//12.2.4.21 Script data escape start dash state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_ESCAPE_START_DASH_STATE] = function scriptDataEscapeStartDashState(cp) {
	    if (cp === $.HYPHEN_MINUS) {
	        this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
	        this._emitChar('-');
	    }
	
	    else
	        this._reconsumeInState(SCRIPT_DATA_STATE);
	};
	
	
	//12.2.4.22 Script data escaped state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_ESCAPED_STATE] = function scriptDataEscapedState(cp) {
	    if (cp === $.HYPHEN_MINUS) {
	        this.state = SCRIPT_DATA_ESCAPED_DASH_STATE;
	        this._emitChar('-');
	    }
	
	    else if (cp === $.LESS_THAN_SIGN)
	        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
	
	    else if (cp === $.NULL)
	        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
	
	    else if (cp === $.EOF)
	        this._reconsumeInState(DATA_STATE);
	
	    else
	        this._emitCodePoint(cp);
	};
	
	
	//12.2.4.23 Script data escaped dash state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_ESCAPED_DASH_STATE] = function scriptDataEscapedDashState(cp) {
	    if (cp === $.HYPHEN_MINUS) {
	        this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
	        this._emitChar('-');
	    }
	
	    else if (cp === $.LESS_THAN_SIGN)
	        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
	
	    else if (cp === $.NULL) {
	        this.state = SCRIPT_DATA_ESCAPED_STATE;
	        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
	    }
	
	    else if (cp === $.EOF)
	        this._reconsumeInState(DATA_STATE);
	
	    else {
	        this.state = SCRIPT_DATA_ESCAPED_STATE;
	        this._emitCodePoint(cp);
	    }
	};
	
	
	//12.2.4.24 Script data escaped dash dash state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_ESCAPED_DASH_DASH_STATE] = function scriptDataEscapedDashDashState(cp) {
	    if (cp === $.HYPHEN_MINUS)
	        this._emitChar('-');
	
	    else if (cp === $.LESS_THAN_SIGN)
	        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
	
	    else if (cp === $.GREATER_THAN_SIGN) {
	        this.state = SCRIPT_DATA_STATE;
	        this._emitChar('>');
	    }
	
	    else if (cp === $.NULL) {
	        this.state = SCRIPT_DATA_ESCAPED_STATE;
	        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
	    }
	
	    else if (cp === $.EOF)
	        this._reconsumeInState(DATA_STATE);
	
	    else {
	        this.state = SCRIPT_DATA_ESCAPED_STATE;
	        this._emitCodePoint(cp);
	    }
	};
	
	
	//12.2.4.25 Script data escaped less-than sign state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE] = function scriptDataEscapedLessThanSignState(cp) {
	    if (cp === $.SOLIDUS) {
	        this.tempBuff = [];
	        this.state = SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE;
	    }
	
	    else if (isAsciiLetter(cp)) {
	        this.tempBuff = [];
	        this._emitChar('<');
	        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE);
	    }
	
	    else {
	        this._emitChar('<');
	        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
	    }
	};
	
	
	//12.2.4.26 Script data escaped end tag open state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE] = function scriptDataEscapedEndTagOpenState(cp) {
	    if (isAsciiLetter(cp)) {
	        this._createEndTagToken();
	        this._reconsumeInState(SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE);
	    }
	
	    else {
	        this._emitChar('<');
	        this._emitChar('/');
	        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
	    }
	};
	
	
	//12.2.4.27 Script data escaped end tag name state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE] = function scriptDataEscapedEndTagNameState(cp) {
	    if (isAsciiUpper(cp)) {
	        this.currentToken.tagName += toAsciiLowerChar(cp);
	        this.tempBuff.push(cp);
	    }
	
	    else if (isAsciiLower(cp)) {
	        this.currentToken.tagName += toChar(cp);
	        this.tempBuff.push(cp);
	    }
	
	    else {
	        if (this._isAppropriateEndTagToken()) {
	            if (isWhitespace(cp)) {
	                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
	                return;
	            }
	
	            if (cp === $.SOLIDUS) {
	                this.state = SELF_CLOSING_START_TAG_STATE;
	                return;
	            }
	
	            if (cp === $.GREATER_THAN_SIGN) {
	                this._emitCurrentToken();
	                this.state = DATA_STATE;
	                return;
	            }
	        }
	
	        this._emitChar('<');
	        this._emitChar('/');
	        this._emitSeveralCodePoints(this.tempBuff);
	        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
	    }
	};
	
	
	//12.2.4.28 Script data double escape start state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE] = function scriptDataDoubleEscapeStartState(cp) {
	    if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
	        this.state = this.isTempBufferEqualToScriptString() ? SCRIPT_DATA_DOUBLE_ESCAPED_STATE : SCRIPT_DATA_ESCAPED_STATE;
	        this._emitCodePoint(cp);
	    }
	
	    else if (isAsciiUpper(cp)) {
	        this.tempBuff.push(toAsciiLowerCodePoint(cp));
	        this._emitCodePoint(cp);
	    }
	
	    else if (isAsciiLower(cp)) {
	        this.tempBuff.push(cp);
	        this._emitCodePoint(cp);
	    }
	
	    else
	        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
	};
	
	
	//12.2.4.29 Script data double escaped state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_DOUBLE_ESCAPED_STATE] = function scriptDataDoubleEscapedState(cp) {
	    if (cp === $.HYPHEN_MINUS) {
	        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE;
	        this._emitChar('-');
	    }
	
	    else if (cp === $.LESS_THAN_SIGN) {
	        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
	        this._emitChar('<');
	    }
	
	    else if (cp === $.NULL)
	        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
	
	    else if (cp === $.EOF)
	        this._reconsumeInState(DATA_STATE);
	
	    else
	        this._emitCodePoint(cp);
	};
	
	
	//12.2.4.30 Script data double escaped dash state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE] = function scriptDataDoubleEscapedDashState(cp) {
	    if (cp === $.HYPHEN_MINUS) {
	        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE;
	        this._emitChar('-');
	    }
	
	    else if (cp === $.LESS_THAN_SIGN) {
	        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
	        this._emitChar('<');
	    }
	
	    else if (cp === $.NULL) {
	        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
	        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
	    }
	
	    else if (cp === $.EOF)
	        this._reconsumeInState(DATA_STATE);
	
	    else {
	        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
	        this._emitCodePoint(cp);
	    }
	};
	
	
	//12.2.4.31 Script data double escaped dash dash state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE] = function scriptDataDoubleEscapedDashDashState(cp) {
	    if (cp === $.HYPHEN_MINUS)
	        this._emitChar('-');
	
	    else if (cp === $.LESS_THAN_SIGN) {
	        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
	        this._emitChar('<');
	    }
	
	    else if (cp === $.GREATER_THAN_SIGN) {
	        this.state = SCRIPT_DATA_STATE;
	        this._emitChar('>');
	    }
	
	    else if (cp === $.NULL) {
	        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
	        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
	    }
	
	    else if (cp === $.EOF)
	        this._reconsumeInState(DATA_STATE);
	
	    else {
	        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
	        this._emitCodePoint(cp);
	    }
	};
	
	
	//12.2.4.32 Script data double escaped less-than sign state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE] = function scriptDataDoubleEscapedLessThanSignState(cp) {
	    if (cp === $.SOLIDUS) {
	        this.tempBuff = [];
	        this.state = SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE;
	        this._emitChar('/');
	    }
	
	    else
	        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
	};
	
	
	//12.2.4.33 Script data double escape end state
	//------------------------------------------------------------------
	_[SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE] = function scriptDataDoubleEscapeEndState(cp) {
	    if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
	        this.state = this.isTempBufferEqualToScriptString() ? SCRIPT_DATA_ESCAPED_STATE : SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
	
	        this._emitCodePoint(cp);
	    }
	
	    else if (isAsciiUpper(cp)) {
	        this.tempBuff.push(toAsciiLowerCodePoint(cp));
	        this._emitCodePoint(cp);
	    }
	
	    else if (isAsciiLower(cp)) {
	        this.tempBuff.push(cp);
	        this._emitCodePoint(cp);
	    }
	
	    else
	        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
	};
	
	
	//12.2.4.34 Before attribute name state
	//------------------------------------------------------------------
	_[BEFORE_ATTRIBUTE_NAME_STATE] = function beforeAttributeNameState(cp) {
	    if (isWhitespace(cp))
	        return;
	
	    if (cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF)
	        this._reconsumeInState(AFTER_ATTRIBUTE_NAME_STATE);
	
	    else if (cp === $.EQUALS_SIGN) {
	        this._createAttr('=');
	        this.state = ATTRIBUTE_NAME_STATE;
	    }
	
	    else {
	        this._createAttr('');
	        this._reconsumeInState(ATTRIBUTE_NAME_STATE);
	    }
	};
	
	
	//12.2.4.35 Attribute name state
	//------------------------------------------------------------------
	_[ATTRIBUTE_NAME_STATE] = function attributeNameState(cp) {
	    if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF) {
	        this._leaveAttrName(AFTER_ATTRIBUTE_NAME_STATE);
	        this._unconsume();
	    }
	
	    else if (cp === $.EQUALS_SIGN)
	        this._leaveAttrName(BEFORE_ATTRIBUTE_VALUE_STATE);
	
	    else if (isAsciiUpper(cp))
	        this.currentAttr.name += toAsciiLowerChar(cp);
	
	    else if (cp === $.QUOTATION_MARK || cp === $.APOSTROPHE || cp === $.LESS_THAN_SIGN)
	        this.currentAttr.name += toChar(cp);
	
	    else if (cp === $.NULL)
	        this.currentAttr.name += UNICODE.REPLACEMENT_CHARACTER;
	
	    else
	        this.currentAttr.name += toChar(cp);
	};
	
	
	//12.2.4.36 After attribute name state
	//------------------------------------------------------------------
	_[AFTER_ATTRIBUTE_NAME_STATE] = function afterAttributeNameState(cp) {
	    if (isWhitespace(cp))
	        return;
	
	    if (cp === $.SOLIDUS)
	        this.state = SELF_CLOSING_START_TAG_STATE;
	
	    else if (cp === $.EQUALS_SIGN)
	        this.state = BEFORE_ATTRIBUTE_VALUE_STATE;
	
	    else if (cp === $.GREATER_THAN_SIGN) {
	        this.state = DATA_STATE;
	        this._emitCurrentToken();
	    }
	
	    else if (cp === $.EOF)
	        this._reconsumeInState(DATA_STATE);
	
	    else {
	        this._createAttr('');
	        this._reconsumeInState(ATTRIBUTE_NAME_STATE);
	    }
	};
	
	
	//12.2.4.37 Before attribute value state
	//------------------------------------------------------------------
	_[BEFORE_ATTRIBUTE_VALUE_STATE] = function beforeAttributeValueState(cp) {
	    if (isWhitespace(cp))
	        return;
	
	    if (cp === $.QUOTATION_MARK)
	        this.state = ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE;
	
	    else if (cp === $.APOSTROPHE)
	        this.state = ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE;
	
	    else
	        this._reconsumeInState(ATTRIBUTE_VALUE_UNQUOTED_STATE);
	};
	
	
	//12.2.4.38 Attribute value (double-quoted) state
	//------------------------------------------------------------------
	_[ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE] = function attributeValueDoubleQuotedState(cp) {
	    if (cp === $.QUOTATION_MARK)
	        this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;
	
	    else if (cp === $.AMPERSAND) {
	        this.additionalAllowedCp = $.QUOTATION_MARK;
	        this.returnState = this.state;
	        this.state = CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE;
	    }
	
	    else if (cp === $.NULL)
	        this.currentAttr.value += UNICODE.REPLACEMENT_CHARACTER;
	
	    else if (cp === $.EOF)
	        this._reconsumeInState(DATA_STATE);
	
	    else
	        this.currentAttr.value += toChar(cp);
	};
	
	
	//12.2.4.39 Attribute value (single-quoted) state
	//------------------------------------------------------------------
	_[ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE] = function attributeValueSingleQuotedState(cp) {
	    if (cp === $.APOSTROPHE)
	        this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;
	
	    else if (cp === $.AMPERSAND) {
	        this.additionalAllowedCp = $.APOSTROPHE;
	        this.returnState = this.state;
	        this.state = CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE;
	    }
	
	    else if (cp === $.NULL)
	        this.currentAttr.value += UNICODE.REPLACEMENT_CHARACTER;
	
	    else if (cp === $.EOF)
	        this._reconsumeInState(DATA_STATE);
	
	    else
	        this.currentAttr.value += toChar(cp);
	};
	
	
	//12.2.4.40 Attribute value (unquoted) state
	//------------------------------------------------------------------
	_[ATTRIBUTE_VALUE_UNQUOTED_STATE] = function attributeValueUnquotedState(cp) {
	    if (isWhitespace(cp))
	        this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);
	
	    else if (cp === $.AMPERSAND) {
	        this.additionalAllowedCp = $.GREATER_THAN_SIGN;
	        this.returnState = this.state;
	        this.state = CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE;
	    }
	
	    else if (cp === $.GREATER_THAN_SIGN) {
	        this._leaveAttrValue(DATA_STATE);
	        this._emitCurrentToken();
	    }
	
	    else if (cp === $.NULL)
	        this.currentAttr.value += UNICODE.REPLACEMENT_CHARACTER;
	
	    else if (cp === $.QUOTATION_MARK || cp === $.APOSTROPHE || cp === $.LESS_THAN_SIGN ||
	             cp === $.EQUALS_SIGN || cp === $.GRAVE_ACCENT)
	        this.currentAttr.value += toChar(cp);
	
	    else if (cp === $.EOF)
	        this._reconsumeInState(DATA_STATE);
	
	    else
	        this.currentAttr.value += toChar(cp);
	};
	
	
	//12.2.4.41 Character reference in attribute value state
	//------------------------------------------------------------------
	_[CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE] = function characterReferenceInAttributeValueState(cp) {
	    var referencedCodePoints = this._consumeCharacterReference(cp, true);
	
	    if (!this._ensureHibernation()) {
	        if (referencedCodePoints) {
	            for (var i = 0; i < referencedCodePoints.length; i++)
	                this.currentAttr.value += toChar(referencedCodePoints[i]);
	        }
	        else
	            this.currentAttr.value += '&';
	
	        this.state = this.returnState;
	    }
	};
	
	
	//12.2.4.42 After attribute value (quoted) state
	//------------------------------------------------------------------
	_[AFTER_ATTRIBUTE_VALUE_QUOTED_STATE] = function afterAttributeValueQuotedState(cp) {
	    if (isWhitespace(cp))
	        this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);
	
	    else if (cp === $.SOLIDUS)
	        this._leaveAttrValue(SELF_CLOSING_START_TAG_STATE);
	
	    else if (cp === $.GREATER_THAN_SIGN) {
	        this._leaveAttrValue(DATA_STATE);
	        this._emitCurrentToken();
	    }
	
	    else if (cp === $.EOF)
	        this._reconsumeInState(DATA_STATE);
	
	    else
	        this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
	};
	
	
	//12.2.4.43 Self-closing start tag state
	//------------------------------------------------------------------
	_[SELF_CLOSING_START_TAG_STATE] = function selfClosingStartTagState(cp) {
	    if (cp === $.GREATER_THAN_SIGN) {
	        this.currentToken.selfClosing = true;
	        this.state = DATA_STATE;
	        this._emitCurrentToken();
	    }
	
	    else if (cp === $.EOF)
	        this._reconsumeInState(DATA_STATE);
	
	    else
	        this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
	};
	
	
	//12.2.4.44 Bogus comment state
	//------------------------------------------------------------------
	_[BOGUS_COMMENT_STATE] = function bogusCommentState() {
	    this._createCommentToken();
	    this._reconsumeInState(BOGUS_COMMENT_STATE_CONTINUATION);
	};
	
	//HACK: to support streaming and make BOGUS_COMMENT_STATE reentrant we've
	//introduced BOGUS_COMMENT_STATE_CONTINUATION state which will not produce
	//comment token on each call.
	_[BOGUS_COMMENT_STATE_CONTINUATION] = function bogusCommentStateContinuation(cp) {
	    while (true) {
	        if (cp === $.GREATER_THAN_SIGN) {
	            this.state = DATA_STATE;
	            break;
	        }
	
	        else if (cp === $.EOF) {
	            this._reconsumeInState(DATA_STATE);
	            break;
	        }
	
	        else {
	            this.currentToken.data += cp === $.NULL ? UNICODE.REPLACEMENT_CHARACTER : toChar(cp);
	
	            this._hibernationSnapshot();
	            cp = this._consume();
	
	            if (this._ensureHibernation())
	                return;
	        }
	    }
	
	    this._emitCurrentToken();
	};
	
	//12.2.4.45 Markup declaration open state
	//------------------------------------------------------------------
	_[MARKUP_DECLARATION_OPEN_STATE] = function markupDeclarationOpenState(cp) {
	    var dashDashMatch = this._consumeSubsequentIfMatch($$.DASH_DASH_STRING, cp, true),
	        doctypeMatch = !dashDashMatch && this._consumeSubsequentIfMatch($$.DOCTYPE_STRING, cp, false),
	        cdataMatch = !dashDashMatch && !doctypeMatch &&
	                     this.allowCDATA &&
	                     this._consumeSubsequentIfMatch($$.CDATA_START_STRING, cp, true);
	
	    if (!this._ensureHibernation()) {
	        if (dashDashMatch) {
	            this._createCommentToken();
	            this.state = COMMENT_START_STATE;
	        }
	
	        else if (doctypeMatch)
	            this.state = DOCTYPE_STATE;
	
	        else if (cdataMatch)
	            this.state = CDATA_SECTION_STATE;
	
	        else
	            this._reconsumeInState(BOGUS_COMMENT_STATE);
	    }
	};
	
	
	//12.2.4.46 Comment start state
	//------------------------------------------------------------------
	_[COMMENT_START_STATE] = function commentStartState(cp) {
	    if (cp === $.HYPHEN_MINUS)
	        this.state = COMMENT_START_DASH_STATE;
	
	    else if (cp === $.NULL) {
	        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
	        this.state = COMMENT_STATE;
	    }
	
	    else if (cp === $.GREATER_THAN_SIGN) {
	        this.state = DATA_STATE;
	        this._emitCurrentToken();
	    }
	
	    else if (cp === $.EOF) {
	        this._emitCurrentToken();
	        this._reconsumeInState(DATA_STATE);
	    }
	
	    else {
	        this.currentToken.data += toChar(cp);
	        this.state = COMMENT_STATE;
	    }
	};
	
	
	//12.2.4.47 Comment start dash state
	//------------------------------------------------------------------
	_[COMMENT_START_DASH_STATE] = function commentStartDashState(cp) {
	    if (cp === $.HYPHEN_MINUS)
	        this.state = COMMENT_END_STATE;
	
	    else if (cp === $.NULL) {
	        this.currentToken.data += '-';
	        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
	        this.state = COMMENT_STATE;
	    }
	
	    else if (cp === $.GREATER_THAN_SIGN) {
	        this.state = DATA_STATE;
	        this._emitCurrentToken();
	    }
	
	    else if (cp === $.EOF) {
	        this._emitCurrentToken();
	        this._reconsumeInState(DATA_STATE);
	    }
	
	    else {
	        this.currentToken.data += '-';
	        this.currentToken.data += toChar(cp);
	        this.state = COMMENT_STATE;
	    }
	};
	
	
	//12.2.4.48 Comment state
	//------------------------------------------------------------------
	_[COMMENT_STATE] = function commentState(cp) {
	    if (cp === $.HYPHEN_MINUS)
	        this.state = COMMENT_END_DASH_STATE;
	
	    else if (cp === $.NULL)
	        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
	
	    else if (cp === $.EOF) {
	        this._emitCurrentToken();
	        this._reconsumeInState(DATA_STATE);
	    }
	
	    else
	        this.currentToken.data += toChar(cp);
	};
	
	
	//12.2.4.49 Comment end dash state
	//------------------------------------------------------------------
	_[COMMENT_END_DASH_STATE] = function commentEndDashState(cp) {
	    if (cp === $.HYPHEN_MINUS)
	        this.state = COMMENT_END_STATE;
	
	    else if (cp === $.NULL) {
	        this.currentToken.data += '-';
	        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
	        this.state = COMMENT_STATE;
	    }
	
	    else if (cp === $.EOF) {
	        this._emitCurrentToken();
	        this._reconsumeInState(DATA_STATE);
	    }
	
	    else {
	        this.currentToken.data += '-';
	        this.currentToken.data += toChar(cp);
	        this.state = COMMENT_STATE;
	    }
	};
	
	
	//12.2.4.50 Comment end state
	//------------------------------------------------------------------
	_[COMMENT_END_STATE] = function commentEndState(cp) {
	    if (cp === $.GREATER_THAN_SIGN) {
	        this.state = DATA_STATE;
	        this._emitCurrentToken();
	    }
	
	    else if (cp === $.EXCLAMATION_MARK)
	        this.state = COMMENT_END_BANG_STATE;
	
	    else if (cp === $.HYPHEN_MINUS)
	        this.currentToken.data += '-';
	
	    else if (cp === $.NULL) {
	        this.currentToken.data += '--';
	        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
	        this.state = COMMENT_STATE;
	    }
	
	    else if (cp === $.EOF) {
	        this._reconsumeInState(DATA_STATE);
	        this._emitCurrentToken();
	    }
	
	    else {
	        this.currentToken.data += '--';
	        this.currentToken.data += toChar(cp);
	        this.state = COMMENT_STATE;
	    }
	};
	
	
	//12.2.4.51 Comment end bang state
	//------------------------------------------------------------------
	_[COMMENT_END_BANG_STATE] = function commentEndBangState(cp) {
	    if (cp === $.HYPHEN_MINUS) {
	        this.currentToken.data += '--!';
	        this.state = COMMENT_END_DASH_STATE;
	    }
	
	    else if (cp === $.GREATER_THAN_SIGN) {
	        this.state = DATA_STATE;
	        this._emitCurrentToken();
	    }
	
	    else if (cp === $.NULL) {
	        this.currentToken.data += '--!';
	        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
	        this.state = COMMENT_STATE;
	    }
	
	    else if (cp === $.EOF) {
	        this._emitCurrentToken();
	        this._reconsumeInState(DATA_STATE);
	    }
	
	    else {
	        this.currentToken.data += '--!';
	        this.currentToken.data += toChar(cp);
	        this.state = COMMENT_STATE;
	    }
	};
	
	
	//12.2.4.52 DOCTYPE state
	//------------------------------------------------------------------
	_[DOCTYPE_STATE] = function doctypeState(cp) {
	    if (isWhitespace(cp))
	        return;
	
	    else if (cp === $.GREATER_THAN_SIGN) {
	        this._createDoctypeToken(null);
	        this.currentToken.forceQuirks = true;
	        this._emitCurrentToken();
	        this.state = DATA_STATE;
	    }
	
	    else if (cp === $.EOF) {
	        this._createDoctypeToken(null);
	        this.currentToken.forceQuirks = true;
	        this._emitCurrentToken();
	        this._reconsumeInState(DATA_STATE);
	    }
	    else {
	        this._createDoctypeToken('');
	        this._reconsumeInState(DOCTYPE_NAME_STATE);
	    }
	};
	
	
	//12.2.4.54 DOCTYPE name state
	//------------------------------------------------------------------
	_[DOCTYPE_NAME_STATE] = function doctypeNameState(cp) {
	    if (isWhitespace(cp) || cp === $.GREATER_THAN_SIGN || cp === $.EOF)
	        this._reconsumeInState(AFTER_DOCTYPE_NAME_STATE);
	
	    else if (isAsciiUpper(cp))
	        this.currentToken.name += toAsciiLowerChar(cp);
	
	    else if (cp === $.NULL)
	        this.currentToken.name += UNICODE.REPLACEMENT_CHARACTER;
	
	    else
	        this.currentToken.name += toChar(cp);
	};
	
	
	//12.2.4.55 After DOCTYPE name state
	//------------------------------------------------------------------
	_[AFTER_DOCTYPE_NAME_STATE] = function afterDoctypeNameState(cp) {
	    if (isWhitespace(cp))
	        return;
	
	    if (cp === $.GREATER_THAN_SIGN) {
	        this.state = DATA_STATE;
	        this._emitCurrentToken();
	    }
	
	    else {
	        var publicMatch = this._consumeSubsequentIfMatch($$.PUBLIC_STRING, cp, false),
	            systemMatch = !publicMatch && this._consumeSubsequentIfMatch($$.SYSTEM_STRING, cp, false);
	
	        if (!this._ensureHibernation()) {
	            if (publicMatch)
	                this.state = BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE;
	
	            else if (systemMatch)
	                this.state = BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
	
	            else {
	                this.currentToken.forceQuirks = true;
	                this.state = BOGUS_DOCTYPE_STATE;
	            }
	        }
	    }
	};
	
	
	//12.2.4.57 Before DOCTYPE public identifier state
	//------------------------------------------------------------------
	_[BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE] = function beforeDoctypePublicIdentifierState(cp) {
	    if (isWhitespace(cp))
	        return;
	
	    if (cp === $.QUOTATION_MARK) {
	        this.currentToken.publicId = '';
	        this.state = DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE;
	    }
	
	    else if (cp === $.APOSTROPHE) {
	        this.currentToken.publicId = '';
	        this.state = DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE;
	    }
	
	    else {
	        this.currentToken.forceQuirks = true;
	        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
	    }
	};
	
	
	//12.2.4.58 DOCTYPE public identifier (double-quoted) state
	//------------------------------------------------------------------
	_[DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE] = function doctypePublicIdentifierDoubleQuotedState(cp) {
	    if (cp === $.QUOTATION_MARK)
	        this.state = BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE;
	
	    else if (cp === $.NULL)
	        this.currentToken.publicId += UNICODE.REPLACEMENT_CHARACTER;
	
	    else if (cp === $.GREATER_THAN_SIGN) {
	        this.currentToken.forceQuirks = true;
	        this._emitCurrentToken();
	        this.state = DATA_STATE;
	    }
	
	    else if (cp === $.EOF) {
	        this.currentToken.forceQuirks = true;
	        this._emitCurrentToken();
	        this._reconsumeInState(DATA_STATE);
	    }
	
	    else
	        this.currentToken.publicId += toChar(cp);
	};
	
	
	//12.2.4.59 DOCTYPE public identifier (single-quoted) state
	//------------------------------------------------------------------
	_[DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE] = function doctypePublicIdentifierSingleQuotedState(cp) {
	    if (cp === $.APOSTROPHE)
	        this.state = BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE;
	
	    else if (cp === $.NULL)
	        this.currentToken.publicId += UNICODE.REPLACEMENT_CHARACTER;
	
	    else if (cp === $.GREATER_THAN_SIGN) {
	        this.currentToken.forceQuirks = true;
	        this._emitCurrentToken();
	        this.state = DATA_STATE;
	    }
	
	    else if (cp === $.EOF) {
	        this.currentToken.forceQuirks = true;
	        this._emitCurrentToken();
	        this._reconsumeInState(DATA_STATE);
	    }
	
	    else
	        this.currentToken.publicId += toChar(cp);
	};
	
	
	//12.2.4.61 Between DOCTYPE public and system identifiers state
	//------------------------------------------------------------------
	_[BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE] = function betweenDoctypePublicAndSystemIdentifiersState(cp) {
	    if (isWhitespace(cp))
	        return;
	
	    if (cp === $.GREATER_THAN_SIGN) {
	        this._emitCurrentToken();
	        this.state = DATA_STATE;
	    }
	
	    else if (cp === $.QUOTATION_MARK) {
	        this.currentToken.systemId = '';
	        this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
	    }
	
	
	    else if (cp === $.APOSTROPHE) {
	        this.currentToken.systemId = '';
	        this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
	    }
	
	    else {
	        this.currentToken.forceQuirks = true;
	        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
	    }
	};
	
	
	//12.2.4.63 Before DOCTYPE system identifier state
	//------------------------------------------------------------------
	_[BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE] = function beforeDoctypeSystemIdentifierState(cp) {
	    if (isWhitespace(cp))
	        return;
	
	    if (cp === $.QUOTATION_MARK) {
	        this.currentToken.systemId = '';
	        this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
	    }
	
	    else if (cp === $.APOSTROPHE) {
	        this.currentToken.systemId = '';
	        this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
	    }
	
	    else {
	        this.currentToken.forceQuirks = true;
	        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
	    }
	};
	
	
	//12.2.4.64 DOCTYPE system identifier (double-quoted) state
	//------------------------------------------------------------------
	_[DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE] = function doctypeSystemIdentifierDoubleQuotedState(cp) {
	    if (cp === $.QUOTATION_MARK)
	        this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
	
	    else if (cp === $.GREATER_THAN_SIGN) {
	        this.currentToken.forceQuirks = true;
	        this._emitCurrentToken();
	        this.state = DATA_STATE;
	    }
	
	    else if (cp === $.NULL)
	        this.currentToken.systemId += UNICODE.REPLACEMENT_CHARACTER;
	
	    else if (cp === $.EOF) {
	        this.currentToken.forceQuirks = true;
	        this._emitCurrentToken();
	        this._reconsumeInState(DATA_STATE);
	    }
	
	    else
	        this.currentToken.systemId += toChar(cp);
	};
	
	
	//12.2.4.65 DOCTYPE system identifier (single-quoted) state
	//------------------------------------------------------------------
	_[DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE] = function doctypeSystemIdentifierSingleQuotedState(cp) {
	    if (cp === $.APOSTROPHE)
	        this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
	
	    else if (cp === $.GREATER_THAN_SIGN) {
	        this.currentToken.forceQuirks = true;
	        this._emitCurrentToken();
	        this.state = DATA_STATE;
	    }
	
	    else if (cp === $.NULL)
	        this.currentToken.systemId += UNICODE.REPLACEMENT_CHARACTER;
	
	    else if (cp === $.EOF) {
	        this.currentToken.forceQuirks = true;
	        this._emitCurrentToken();
	        this._reconsumeInState(DATA_STATE);
	    }
	
	    else
	        this.currentToken.systemId += toChar(cp);
	};
	
	
	//12.2.4.66 After DOCTYPE system identifier state
	//------------------------------------------------------------------
	_[AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE] = function afterDoctypeSystemIdentifierState(cp) {
	    if (isWhitespace(cp))
	        return;
	
	    if (cp === $.GREATER_THAN_SIGN) {
	        this._emitCurrentToken();
	        this.state = DATA_STATE;
	    }
	
	    else if (cp === $.EOF) {
	        this.currentToken.forceQuirks = true;
	        this._emitCurrentToken();
	        this._reconsumeInState(DATA_STATE);
	    }
	
	    else
	        this.state = BOGUS_DOCTYPE_STATE;
	};
	
	
	//12.2.4.67 Bogus DOCTYPE state
	//------------------------------------------------------------------
	_[BOGUS_DOCTYPE_STATE] = function bogusDoctypeState(cp) {
	    if (cp === $.GREATER_THAN_SIGN) {
	        this._emitCurrentToken();
	        this.state = DATA_STATE;
	    }
	
	    else if (cp === $.EOF) {
	        this._emitCurrentToken();
	        this._reconsumeInState(DATA_STATE);
	    }
	};
	
	
	//12.2.4.68 CDATA section state
	//------------------------------------------------------------------
	_[CDATA_SECTION_STATE] = function cdataSectionState(cp) {
	    while (true) {
	        if (cp === $.EOF) {
	            this._reconsumeInState(DATA_STATE);
	            break;
	        }
	
	        else {
	            var cdataEndMatch = this._consumeSubsequentIfMatch($$.CDATA_END_STRING, cp, true);
	
	            if (this._ensureHibernation())
	                break;
	
	            if (cdataEndMatch) {
	                this.state = DATA_STATE;
	                break;
	            }
	
	            this._emitCodePoint(cp);
	
	            this._hibernationSnapshot();
	            cp = this._consume();
	
	            if (this._ensureHibernation())
	                break;
	        }
	    }
	};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(33);
	
	var ReactCurrentOwner = __webpack_require__(735);
	
	var warning = __webpack_require__(313);
	var canDefineProperty = __webpack_require__(738);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(736);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 188 */,
/* 189 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var assign = make_assign()
	var create = make_create()
	var trim = make_trim()
	var Global = (typeof window !== 'undefined' ? window : global)
	
	module.exports = {
		assign: assign,
		create: create,
		trim: trim,
		bind: bind,
		slice: slice,
		each: each,
		map: map,
		pluck: pluck,
		isList: isList,
		isFunction: isFunction,
		isObject: isObject,
		Global: Global
	}
	
	function make_assign() {
		if (Object.assign) {
			return Object.assign
		} else {
			return function shimAssign(obj, props1, props2, etc) {
				for (var i = 1; i < arguments.length; i++) {
					each(Object(arguments[i]), function(val, key) {
						obj[key] = val
					})
				}			
				return obj
			}
		}
	}
	
	function make_create() {
		if (Object.create) {
			return function create(obj, assignProps1, assignProps2, etc) {
				var assignArgsList = slice(arguments, 1)
				return assign.apply(this, [Object.create(obj)].concat(assignArgsList))
			}
		} else {
			function F() {} // eslint-disable-line no-inner-declarations
			return function create(obj, assignProps1, assignProps2, etc) {
				var assignArgsList = slice(arguments, 1)
				F.prototype = obj
				return assign.apply(this, [new F()].concat(assignArgsList))
			}
		}
	}
	
	function make_trim() {
		if (String.prototype.trim) {
			return function trim(str) {
				return String.prototype.trim.call(str)
			}
		} else {
			return function trim(str) {
				return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '')
			}
		}
	}
	
	function bind(obj, fn) {
		return function() {
			return fn.apply(obj, Array.prototype.slice.call(arguments, 0))
		}
	}
	
	function slice(arr, index) {
		return Array.prototype.slice.call(arr, index || 0)
	}
	
	function each(obj, fn) {
		pluck(obj, function(val, key) {
			fn(val, key)
			return false
		})
	}
	
	function map(obj, fn) {
		var res = (isList(obj) ? [] : {})
		pluck(obj, function(v, k) {
			res[k] = fn(v, k)
			return false
		})
		return res
	}
	
	function pluck(obj, fn) {
		if (isList(obj)) {
			for (var i=0; i<obj.length; i++) {
				if (fn(obj[i], i)) {
					return obj[i]
				}
			}
		} else {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					if (fn(obj[key], key)) {
						return obj[key]
					}
				}
			}
		}
	}
	
	function isList(val) {
		return (val != null && typeof val != 'function' && typeof val.length == 'number')
	}
	
	function isFunction(val) {
		return val && {}.toString.call(val) === '[object Function]'
	}
	
	function isObject(val) {
		return val && {}.toString.call(val) === '[object Object]'
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1043), __esModule: true };

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1048), __esModule: true };

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(963);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	module.exports = {
		trueFunc: function trueFunc(){
			return true;
		},
		falseFunc: function falseFunc(){
			return false;
		}
	};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(291),
	    render = __webpack_require__(311),
	    assign = __webpack_require__(329);
	
	/**
	 * HTML Tags
	 */
	
	var tags = { tag: true, script: true, style: true };
	
	/**
	 * Check if the DOM element is a tag
	 *
	 * isTag(type) includes <script> and <style> tags
	 */
	
	exports.isTag = function(type) {
	  if (type.type) type = type.type;
	  return tags[type] || false;
	};
	
	/**
	 * Convert a string to camel case notation.
	 * @param  {String} str String to be converted.
	 * @return {String}     String in camel case notation.
	 */
	
	exports.camelCase = function(str) {
	  return str.replace(/[_.-](\w|$)/g, function(_, x) {
	    return x.toUpperCase();
	  });
	};
	
	/**
	 * Convert a string from camel case to "CSS case", where word boundaries are
	 * described by hyphens ("-") and all characters are lower-case.
	 * @param  {String} str String to be converted.
	 * @return {string}     String in "CSS case".
	 */
	exports.cssCase = function(str) {
	  return str.replace(/[A-Z]/g, '-$&').toLowerCase();
	};
	
	/**
	 * Iterate over each DOM element without creating intermediary Cheerio instances.
	 *
	 * This is indented for use internally to avoid otherwise unnecessary memory pressure introduced
	 * by _make.
	 */
	
	exports.domEach = function(cheerio, fn) {
	  var i = 0, len = cheerio.length;
	  while (i < len && fn.call(cheerio, i, cheerio[i]) !== false) ++i;
	  return cheerio;
	};
	
	/**
	 * Create a deep copy of the given DOM structure by first rendering it to a
	 * string and then parsing the resultant markup.
	 *
	 * @argument {Object} dom - The htmlparser2-compliant DOM structure
	 * @argument {Object} options - The parsing/rendering options
	 */
	exports.cloneDom = function(dom, options) {
	  options = assign({}, options, { _useHtmlParser2: true });
	
	  return parse(render(dom, options), options, false).children;
	};
	
	/*
	 * A simple way to check for HTML strings or ID strings
	 */
	
	var quickExpr = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/;
	
	/*
	 * Check if string is HTML
	 */
	exports.isHtml = function(str) {
	  // Faster than running regex, if str starts with `<` and ends with `>`, assume it's HTML
	  if (str.charAt(0) === '<' && str.charAt(str.length - 1) === '>' && str.length >= 3) return true;
	
	  // Run the regex
	  var match = quickExpr.exec(str);
	  return !!(match && match[1]);
	};


/***/ }),
/* 199 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 200 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 201 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(297)('meta');
	var isObject = __webpack_require__(46);
	var has = __webpack_require__(94);
	var setDesc = __webpack_require__(58).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(93)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 203 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 204 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(58).f;
	var has = __webpack_require__(94);
	var TAG = __webpack_require__(41)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(1071)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(391)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1075);
	var global = __webpack_require__(40);
	var hide = __webpack_require__(95);
	var Iterators = __webpack_require__(201);
	var TO_STRING_TAG = __webpack_require__(41)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(584)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 209 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 210 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(52);
	var hide = __webpack_require__(174);
	var has = __webpack_require__(304);
	var SRC = __webpack_require__(411)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(173).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(169).Buffer))

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(35);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM2.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var DomUtils = module.exports;
	
	[
		__webpack_require__(1168),
		__webpack_require__(1169),
		__webpack_require__(1166),
		__webpack_require__(1167),
		__webpack_require__(1165),
		__webpack_require__(1164)
	].forEach(function(ext){
		Object.keys(ext).forEach(function(key){
			DomUtils[key] = ext[key].bind(DomUtils);
		});
	});


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nodeHasProperty = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.propsOfNode = propsOfNode;
	exports.childrenOfNode = childrenOfNode;
	exports.hasClassName = hasClassName;
	exports.treeForEach = treeForEach;
	exports.treeFilter = treeFilter;
	exports.findParentNode = findParentNode;
	exports.pathToNode = pathToNode;
	exports.parentsOfNode = parentsOfNode;
	exports.nodeHasId = nodeHasId;
	exports.nodeMatchesObjectProps = nodeMatchesObjectProps;
	exports.getTextFromNode = getTextFromNode;
	
	var _object = __webpack_require__(86);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _flatten = __webpack_require__(183);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _object3 = __webpack_require__(703);
	
	var _object4 = _interopRequireDefault(_object3);
	
	var _isSubset = __webpack_require__(2735);
	
	var _isSubset2 = _interopRequireDefault(_isSubset);
	
	var _functionPrototype = __webpack_require__(419);
	
	var _functionPrototype2 = _interopRequireDefault(_functionPrototype);
	
	var _Utils = __webpack_require__(216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function propsOfNode(node) {
	  return node && node.props || {};
	}
	
	function childrenOfNode(node) {
	  if (!node) return [];
	  return Array.isArray(node.rendered) ? (0, _flatten2['default'])(node.rendered, true) : [node.rendered];
	}
	
	function hasClassName(node, className) {
	  var classes = propsOfNode(node).className || '';
	  classes = String(classes).replace(/\s/g, ' ');
	  return (' ' + String(classes) + ' ').indexOf(' ' + String(className) + ' ') > -1;
	}
	
	function treeForEach(tree, fn) {
	  if (tree !== null && tree !== false && typeof tree !== 'undefined') {
	    fn(tree);
	  }
	  childrenOfNode(tree).forEach(function (node) {
	    return treeForEach(node, fn);
	  });
	}
	
	function treeFilter(tree, fn) {
	  var results = [];
	  treeForEach(tree, function (node) {
	    if (fn(node)) {
	      results.push(node);
	    }
	  });
	  return results;
	}
	
	/**
	 * To support sibling selectors we need to be able to find
	 * the siblings of a node. The easiest way to do that is find
	 * the parent of the node and access its children.
	 *
	 * This would be unneeded if the RST spec included sibling pointers
	 * such as node.nextSibling and node.prevSibling
	 * @param {*} root
	 * @param {*} targetNode
	 */
	function findParentNode(root, targetNode) {
	  var results = treeFilter(root, function (node) {
	    if (!node.rendered) {
	      return false;
	    }
	    return Array.isArray(node.rendered) ? node.rendered.indexOf(targetNode) !== -1 : node.rendered === targetNode;
	  });
	  return results[0] || null;
	}
	
	function pathFilter(path, fn) {
	  return path.filter(function (tree) {
	    return treeFilter(tree, fn).length !== 0;
	  });
	}
	
	function pathToNode(node, root) {
	  var queue = [root];
	  var path = [];
	
	  var hasNode = function hasNode(testNode) {
	    return node === testNode;
	  };
	
	  while (queue.length) {
	    var current = queue.pop();
	    var children = childrenOfNode(current);
	    if (current === node) return pathFilter(path, hasNode);
	
	    path.push(current);
	
	    if (children.length === 0) {
	      // leaf node. if it isn't the node we are looking for, we pop.
	      path.pop();
	    }
	    queue.push.apply(queue, _toConsumableArray(children));
	  }
	
	  return null;
	}
	
	function parentsOfNode(node, root) {
	  return pathToNode(node, root).reverse();
	}
	
	function nodeHasId(node, id) {
	  return propsOfNode(node).id === id;
	}
	
	exports.nodeHasProperty = _Utils.nodeHasProperty;
	
	
	var CAN_NEVER_MATCH = {};
	function replaceUndefined(v) {
	  return typeof v !== 'undefined' ? v : CAN_NEVER_MATCH;
	}
	function replaceUndefinedValues(obj) {
	  return (0, _object4['default'])(obj).reduce(function (acc, _ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        k = _ref2[0],
	        v = _ref2[1];
	
	    return (0, _object2['default'])({}, acc, _defineProperty({}, k, replaceUndefined(v)));
	  }, {});
	}
	
	function nodeMatchesObjectProps(node, props) {
	  return (0, _isSubset2['default'])(propsOfNode(node), replaceUndefinedValues(props));
	}
	
	function getTextFromNode(node) {
	  if (node == null) {
	    return '';
	  }
	
	  if (typeof node === 'string' || typeof node === 'number') {
	    return String(node);
	  }
	
	  if (node.type && typeof node.type === 'function') {
	    return '<' + String(node.type.displayName || (0, _functionPrototype2['default'])(node.type)) + ' />';
	  }
	
	  return childrenOfNode(node).map(getTextFromNode).join('');
	}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ITERATOR_SYMBOL = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint no-use-before-define: 0 */
	
	
	exports.getAdapter = getAdapter;
	exports.makeOptions = makeOptions;
	exports.isCustomComponentElement = isCustomComponentElement;
	exports.propsOfNode = propsOfNode;
	exports.typeOfNode = typeOfNode;
	exports.nodeHasType = nodeHasType;
	exports.nodeMatches = nodeMatches;
	exports.nodeEqual = nodeEqual;
	exports.containsChildrenSubArray = containsChildrenSubArray;
	exports.childrenToSimplifiedArray = childrenToSimplifiedArray;
	exports.isReactElementAlike = isReactElementAlike;
	exports.withSetStateAllowed = withSetStateAllowed;
	exports.AND = AND;
	exports.displayNameOfNode = displayNameOfNode;
	exports.sym = sym;
	exports.privateSet = privateSet;
	exports.cloneElement = cloneElement;
	
	var _object = __webpack_require__(86);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _isEqual = __webpack_require__(4323);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _objectIs = __webpack_require__(698);
	
	var _objectIs2 = _interopRequireDefault(_objectIs);
	
	var _object3 = __webpack_require__(703);
	
	var _object4 = _interopRequireDefault(_object3);
	
	var _functionPrototype = __webpack_require__(419);
	
	var _functionPrototype2 = _interopRequireDefault(_functionPrototype);
	
	var _configuration = __webpack_require__(606);
	
	var _configuration2 = _interopRequireDefault(_configuration);
	
	var _validateAdapter = __webpack_require__(609);
	
	var _validateAdapter2 = _interopRequireDefault(_validateAdapter);
	
	var _RSTTraversal = __webpack_require__(215);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ITERATOR_SYMBOL = exports.ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	
	function getAdapter() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (options.adapter) {
	    (0, _validateAdapter2['default'])(options.adapter);
	    return options.adapter;
	  }
	
	  var _configuration$get = _configuration2['default'].get(),
	      adapter = _configuration$get.adapter;
	
	  (0, _validateAdapter2['default'])(adapter);
	  return adapter;
	}
	
	function makeOptions(options) {
	  return (0, _object2['default'])({}, _configuration2['default'].get(), options);
	}
	
	function isCustomComponentElement(inst, adapter) {
	  return !!inst && adapter.isValidElement(inst) && typeof inst.type === 'function';
	}
	
	function propsOfNode(node) {
	  return (0, _object4['default'])(node && node.props || {}).filter(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        value = _ref2[1];
	
	    return typeof value !== 'undefined';
	  }).reduce(function (acc, _ref3) {
	    var _ref4 = _slicedToArray(_ref3, 2),
	        key = _ref4[0],
	        value = _ref4[1];
	
	    return (0, _object2['default'])(acc, _defineProperty({}, key, value));
	  }, {});
	}
	
	function typeOfNode(node) {
	  return node ? node.type : null;
	}
	
	function nodeHasType(node, type) {
	  if (!type || !node) return false;
	  if (!node.type) return false;
	  if (typeof node.type === 'string') return node.type === type;
	  return (typeof node.type === 'function' ? (0, _functionPrototype2['default'])(node.type) === type : node.type.name === type) || node.type.displayName === type;
	}
	
	function internalChildrenCompare(a, b, lenComp, isLoose) {
	  var nodeCompare = isLoose ? nodeMatches : nodeEqual;
	
	  if (a === b) return true;
	  if (!Array.isArray(a) && !Array.isArray(b)) {
	    return nodeCompare(a, b, lenComp);
	  }
	  if (!a && !b) return true;
	  if (a.length !== b.length) return false;
	  if (a.length === 0 && b.length === 0) return true;
	  for (var i = 0; i < a.length; i += 1) {
	    if (!nodeCompare(a[i], b[i], lenComp)) return false;
	  }
	  return true;
	}
	
	function childrenMatch(a, b, lenComp) {
	  return internalChildrenCompare(a, b, lenComp, true);
	}
	
	function childrenEqual(a, b, lenComp) {
	  return internalChildrenCompare(a, b, lenComp, false);
	}
	
	function removeNullaryReducer(acc, _ref5) {
	  var _ref6 = _slicedToArray(_ref5, 2),
	      key = _ref6[0],
	      value = _ref6[1];
	
	  var addition = value == null ? {} : _defineProperty({}, key, value);
	  return (0, _object2['default'])({}, acc, addition);
	}
	
	function internalNodeCompare(a, b, lenComp, isLoose) {
	  if (a === b) return true;
	  if (!a || !b) return false;
	  if (a.type !== b.type) return false;
	
	  var left = propsOfNode(a);
	  var right = propsOfNode(b);
	  if (isLoose) {
	    left = (0, _object4['default'])(left).reduce(removeNullaryReducer, {});
	    right = (0, _object4['default'])(right).reduce(removeNullaryReducer, {});
	  }
	
	  var leftKeys = Object.keys(left);
	  for (var i = 0; i < leftKeys.length; i += 1) {
	    var prop = leftKeys[i];
	    // we will check children later
	    if (prop === 'children') {
	      // continue;
	    } else if (!(prop in right)) {
	      return false;
	    } else if (right[prop] === left[prop]) {
	      // continue;
	    } else if (_typeof(right[prop]) === _typeof(left[prop]) && _typeof(left[prop]) === 'object') {
	      if (!(0, _isEqual2['default'])(left[prop], right[prop])) return false;
	    } else {
	      return false;
	    }
	  }
	
	  var leftHasChildren = 'children' in left;
	  var rightHasChildren = 'children' in right;
	  var childCompare = isLoose ? childrenMatch : childrenEqual;
	  if (leftHasChildren || rightHasChildren) {
	    if (!childCompare(childrenToSimplifiedArray(left.children), childrenToSimplifiedArray(right.children), lenComp)) {
	      return false;
	    }
	  }
	
	  if (!isTextualNode(a)) {
	    var rightKeys = Object.keys(right);
	    return lenComp(leftKeys.length - leftHasChildren, rightKeys.length - rightHasChildren);
	  }
	
	  return false;
	}
	
	function nodeMatches(a, b) {
	  var lenComp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _objectIs2['default'];
	
	  return internalNodeCompare(a, b, lenComp, true);
	}
	
	function nodeEqual(a, b) {
	  var lenComp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _objectIs2['default'];
	
	  return internalNodeCompare(a, b, lenComp, false);
	}
	
	function containsChildrenSubArray(match, node, subArray) {
	  var children = (0, _RSTTraversal.childrenOfNode)(node);
	  var checker = function checker(_, i) {
	    return arraysEqual(match, children.slice(i, i + subArray.length), subArray);
	  };
	  return children.some(checker);
	}
	
	function arraysEqual(match, left, right) {
	  return left.length === right.length && left.every(function (el, i) {
	    return match(el, right[i]);
	  });
	}
	
	function childrenToArray(children) {
	  var result = [];
	
	  var push = function push(el) {
	    if (el === null || el === false || typeof el === 'undefined') return;
	    result.push(el);
	  };
	
	  if (Array.isArray(children)) {
	    children.forEach(push);
	  } else {
	    push(children);
	  }
	  return result;
	}
	
	function childrenToSimplifiedArray(nodeChildren) {
	  var childrenArray = childrenToArray(nodeChildren);
	  var simplifiedArray = [];
	
	  for (var i = 0; i < childrenArray.length; i += 1) {
	    var child = childrenArray[i];
	    var previousChild = simplifiedArray.pop();
	
	    if (typeof previousChild === 'undefined') {
	      simplifiedArray.push(child);
	    } else if (isTextualNode(child) && isTextualNode(previousChild)) {
	      simplifiedArray.push(previousChild + child);
	    } else {
	      simplifiedArray.push(previousChild);
	      simplifiedArray.push(child);
	    }
	  }
	
	  return simplifiedArray;
	}
	
	function isTextualNode(node) {
	  return typeof node === 'string' || typeof node === 'number';
	}
	
	function isReactElementAlike(arg, adapter) {
	  return adapter.isValidElement(arg) || isTextualNode(arg) || Array.isArray(arg);
	}
	
	// TODO(lmr): can we get rid of this outside of the adapter?
	function withSetStateAllowed(fn) {
	  // NOTE(lmr):
	  // this is currently here to circumvent a React bug where `setState()` is
	  // not allowed without global being defined.
	  var cleanup = false;
	  if (typeof global.document === 'undefined') {
	    cleanup = true;
	    global.document = {};
	  }
	  fn();
	  if (cleanup) {
	    // This works around a bug in node/jest in that developers aren't able to
	    // delete things from global when running in a node vm.
	    global.document = undefined;
	    delete global.document;
	  }
	}
	
	function AND(fns) {
	  var fnsReversed = fns.slice().reverse();
	  return function (x) {
	    return fnsReversed.every(function (fn) {
	      return fn(x);
	    });
	  };
	}
	
	function displayNameOfNode(node) {
	  if (!node) return null;
	
	  var type = node.type;
	
	
	  if (!type) return null;
	
	  return type.displayName || (typeof type === 'function' ? (0, _functionPrototype2['default'])(type) : type.name || type);
	}
	
	function sym(s) {
	  return typeof Symbol === 'function' ? Symbol['for']('enzyme.' + String(s)) : s;
	}
	
	function privateSet(obj, prop, value) {
	  Object.defineProperty(obj, prop, {
	    value: value,
	    enumerable: false,
	    writable: true
	  });
	}
	
	function cloneElement(adapter, el, props) {
	  return adapter.createElement(el.type, (0, _object2['default'])({}, el.props, props));
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 217 */,
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.navigateTo = undefined;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(90);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.withPrefix = withPrefix;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(314);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(423);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*global __PREFIX_PATHS__, __PATH_PREFIX__ */
	var pathPrefix = "/";
	if (false) {
	  pathPrefix = __PATH_PREFIX__;
	}
	
	function withPrefix(path) {
	  return normalizePath(pathPrefix + path);
	}
	
	function normalizePath(path) {
	  return path.replace(/^\/\//g, "/");
	}
	
	function createLocation(path, history) {
	  var location = (0, _history.createLocation)(path, null, null, history.location);
	  location.pathname = withPrefix(location.pathname);
	  return location;
	}
	
	var NavLinkPropTypes = {
	  activeClassName: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  isActive: _propTypes2.default.func,
	  location: _propTypes2.default.object
	
	  // Set up IntersectionObserver
	};var handleIntersection = function handleIntersection(el, cb) {
	  var io = new window.IntersectionObserver(function (entries) {
	    entries.forEach(function (entry) {
	      if (el === entry.target) {
	        // Check if element is within viewport, remove listener, destroy observer, and run link callback.
	        // MSEdge doesn't currently support isIntersecting, so also test for  an intersectionRatio > 0
	        if (entry.isIntersecting || entry.intersectionRatio > 0) {
	          io.unobserve(el);
	          io.disconnect();
	          cb();
	        }
	      }
	    });
	  });
	  // Add element to the observer
	  io.observe(el);
	};
	
	var GatsbyLink = function (_React$Component) {
	  (0, _inherits3.default)(GatsbyLink, _React$Component);
	
	  function GatsbyLink(props, context) {
	    (0, _classCallCheck3.default)(this, GatsbyLink);
	
	    // Default to no support for IntersectionObserver
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	    var IOSupported = false;
	    if (typeof window !== "undefined" && window.IntersectionObserver) {
	      IOSupported = true;
	    }
	
	    var history = context.router.history;
	
	    var to = createLocation(props.to, history);
	
	    _this.state = {
	      path: (0, _history.createPath)(to),
	      to: to,
	      IOSupported: IOSupported
	    };
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  GatsbyLink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.to !== nextProps.to) {
	      var to = createLocation(nextProps.to, history);
	      this.setState({
	        path: (0, _history.createPath)(to),
	        to: to
	      });
	      // Preserve non IO functionality if no support
	      if (!this.state.IOSupported) {
	        ___loader.enqueue(this.state.to.pathname);
	      }
	    }
	  };
	
	  GatsbyLink.prototype.componentDidMount = function componentDidMount() {
	    // Preserve non IO functionality if no support
	    if (!this.state.IOSupported) {
	      ___loader.enqueue(this.state.to.pathname);
	    }
	  };
	
	  GatsbyLink.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    this.props.innerRef && this.props.innerRef(ref);
	
	    if (this.state.IOSupported && ref) {
	      // If IO supported and element reference found, setup Observer functionality
	      handleIntersection(ref, function () {
	        ___loader.enqueue(_this2.state.to.pathname);
	      });
	    }
	  };
	
	  GatsbyLink.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        _onClick = _props.onClick,
	        rest = (0, _objectWithoutProperties3.default)(_props, ["onClick"]);
	
	    var El = void 0;
	    if ((0, _keys2.default)(NavLinkPropTypes).some(function (propName) {
	      return _this3.props[propName];
	    })) {
	      El = _reactRouterDom.NavLink;
	    } else {
	      El = _reactRouterDom.Link;
	    }
	
	    return _react2.default.createElement(El, (0, _extends3.default)({
	      onClick: function onClick(e) {
	        // eslint-disable-line
	        _onClick && _onClick(e);
	
	        if (e.button === 0 && // ignore right clicks
	        !_this3.props.target && // let browser handle "target=_blank"
	        !e.defaultPrevented && // onClick prevented default
	        !e.metaKey && // ignore clicks with modifier keys...
	        !e.altKey && !e.ctrlKey && !e.shiftKey) {
	          // Is this link pointing to a hash on the same page? If so,
	          // just scroll there.
	          var pathname = _this3.state.path;
	          if (pathname.split("#").length > 1) {
	            pathname = pathname.split("#").slice(0, -1).join("");
	          }
	          if (pathname === window.location.pathname) {
	            var hashFragment = _this3.state.path.split("#").slice(1).join("#");
	            var element = document.getElementById(hashFragment);
	            if (element !== null) {
	              element.scrollIntoView();
	              return true;
	            } else {
	              // This is just a normal link to the current page so let's emulate default
	              // browser behavior by scrolling now to the top of the page.
	              window.scrollTo(0, 0);
	              return true;
	            }
	          }
	
	          // In production, make sure the necessary scripts are
	          // loaded before continuing.
	          if (true) {
	            e.preventDefault();
	            window.___navigateTo(_this3.state.to);
	          }
	        }
	
	        return true;
	      }
	    }, rest, {
	      to: this.state.to,
	      innerRef: this.handleRef
	    }));
	  };
	
	  return GatsbyLink;
	}(_react2.default.Component);
	
	GatsbyLink.propTypes = (0, _extends3.default)({}, NavLinkPropTypes, {
	  innerRef: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	});
	
	GatsbyLink.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	exports.default = GatsbyLink;
	var navigateTo = exports.navigateTo = function navigateTo(to) {
	  window.___navigateTo(to);
	};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),
/* 220 */
/***/ (function(module, exports) {

	'use strict';
	
	var fnToStr = Function.prototype.toString;
	
	var constructorRegex = /^\s*class /;
	var isES6ClassFn = function isES6ClassFn(value) {
		try {
			var fnStr = fnToStr.call(value);
			var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
			var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
			var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
			return constructorRegex.test(spaceStripped);
		} catch (e) {
			return false; // not a function
		}
	};
	
	var tryFunctionObject = function tryFunctionObject(value) {
		try {
			if (isES6ClassFn(value)) { return false; }
			fnToStr.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var fnClass = '[object Function]';
	var genClass = '[object GeneratorFunction]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isCallable(value) {
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(4217),
	    createBaseEach = __webpack_require__(4254);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 222 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 223 */,
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(4206),
	    Map = __webpack_require__(431),
	    Promise = __webpack_require__(4208),
	    Set = __webpack_require__(636),
	    WeakMap = __webpack_require__(638),
	    baseGetTag = __webpack_require__(72),
	    toSource = __webpack_require__(680);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 225 */,
/* 226 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(138),
	    isArrayLike = __webpack_require__(74),
	    isIndex = __webpack_require__(226),
	    isObject = __webpack_require__(49);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 228 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(233);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(4221),
	    isObjectLike = __webpack_require__(43);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(42),
	    stubFalse = __webpack_require__(4342);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)(module)))

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(72),
	    isObjectLike = __webpack_require__(43);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 234 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.REPLACEMENT_CHARACTER = '\uFFFD';
	
	exports.CODE_POINTS = {
	    EOF: -1,
	    NULL: 0x00,
	    TABULATION: 0x09,
	    CARRIAGE_RETURN: 0x0D,
	    LINE_FEED: 0x0A,
	    FORM_FEED: 0x0C,
	    SPACE: 0x20,
	    EXCLAMATION_MARK: 0x21,
	    QUOTATION_MARK: 0x22,
	    NUMBER_SIGN: 0x23,
	    AMPERSAND: 0x26,
	    APOSTROPHE: 0x27,
	    HYPHEN_MINUS: 0x2D,
	    SOLIDUS: 0x2F,
	    DIGIT_0: 0x30,
	    DIGIT_9: 0x39,
	    SEMICOLON: 0x3B,
	    LESS_THAN_SIGN: 0x3C,
	    EQUALS_SIGN: 0x3D,
	    GREATER_THAN_SIGN: 0x3E,
	    QUESTION_MARK: 0x3F,
	    LATIN_CAPITAL_A: 0x41,
	    LATIN_CAPITAL_F: 0x46,
	    LATIN_CAPITAL_X: 0x58,
	    LATIN_CAPITAL_Z: 0x5A,
	    GRAVE_ACCENT: 0x60,
	    LATIN_SMALL_A: 0x61,
	    LATIN_SMALL_F: 0x66,
	    LATIN_SMALL_X: 0x78,
	    LATIN_SMALL_Z: 0x7A,
	    REPLACEMENT_CHARACTER: 0xFFFD
	};
	
	exports.CODE_POINT_SEQUENCES = {
	    DASH_DASH_STRING: [0x2D, 0x2D], //--
	    DOCTYPE_STRING: [0x44, 0x4F, 0x43, 0x54, 0x59, 0x50, 0x45], //DOCTYPE
	    CDATA_START_STRING: [0x5B, 0x43, 0x44, 0x41, 0x54, 0x41, 0x5B], //[CDATA[
	    CDATA_END_STRING: [0x5D, 0x5D, 0x3E], //]]>
	    SCRIPT_STRING: [0x73, 0x63, 0x72, 0x69, 0x70, 0x74], //script
	    PUBLIC_STRING: [0x50, 0x55, 0x42, 0x4C, 0x49, 0x43], //PUBLIC
	    SYSTEM_STRING: [0x53, 0x59, 0x53, 0x54, 0x45, 0x4D] //SYSTEM
	};


/***/ }),
/* 235 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	module.exports = exports['default'];

/***/ }),
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(18);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Row = function (_React$Component) {
	  (0, _inherits3.default)(Row, _React$Component);
	
	  function Row() {
	    (0, _classCallCheck3.default)(this, Row);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Row.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, { className: (0, _classnames2.default)(className, classes) }));
	  };
	
	  return Row;
	}(_react2.default.Component);
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('row', Row);
	module.exports = exports['default'];

/***/ }),
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	/**
	 * Represents a push-based event or value that an {@link Observable} can emit.
	 * This class is particularly useful for operators that manage notifications,
	 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
	 * others. Besides wrapping the actual delivered value, it also annotates it
	 * with metadata of, for instance, what type of push message it is (`next`,
	 * `error`, or `complete`).
	 *
	 * @see {@link materialize}
	 * @see {@link dematerialize}
	 * @see {@link observeOn}
	 *
	 * @class Notification<T>
	 */
	var Notification = (function () {
	    function Notification(kind, value, error) {
	        this.kind = kind;
	        this.value = value;
	        this.error = error;
	        this.hasValue = kind === 'N';
	    }
	    /**
	     * Delivers to the given `observer` the value wrapped by this Notification.
	     * @param {Observer} observer
	     * @return
	     */
	    Notification.prototype.observe = function (observer) {
	        switch (this.kind) {
	            case 'N':
	                return observer.next && observer.next(this.value);
	            case 'E':
	                return observer.error && observer.error(this.error);
	            case 'C':
	                return observer.complete && observer.complete();
	        }
	    };
	    /**
	     * Given some {@link Observer} callbacks, deliver the value represented by the
	     * current Notification to the correctly corresponding callback.
	     * @param {function(value: T): void} next An Observer `next` callback.
	     * @param {function(err: any): void} [error] An Observer `error` callback.
	     * @param {function(): void} [complete] An Observer `complete` callback.
	     * @return {any}
	     */
	    Notification.prototype.do = function (next, error, complete) {
	        var kind = this.kind;
	        switch (kind) {
	            case 'N':
	                return next && next(this.value);
	            case 'E':
	                return error && error(this.error);
	            case 'C':
	                return complete && complete();
	        }
	    };
	    /**
	     * Takes an Observer or its individual callback functions, and calls `observe`
	     * or `do` methods accordingly.
	     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
	     * the `next` callback.
	     * @param {function(err: any): void} [error] An Observer `error` callback.
	     * @param {function(): void} [complete] An Observer `complete` callback.
	     * @return {any}
	     */
	    Notification.prototype.accept = function (nextOrObserver, error, complete) {
	        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
	            return this.observe(nextOrObserver);
	        }
	        else {
	            return this.do(nextOrObserver, error, complete);
	        }
	    };
	    /**
	     * Returns a simple Observable that just delivers the notification represented
	     * by this Notification instance.
	     * @return {any}
	     */
	    Notification.prototype.toObservable = function () {
	        var kind = this.kind;
	        switch (kind) {
	            case 'N':
	                return Observable_1.Observable.of(this.value);
	            case 'E':
	                return Observable_1.Observable.throw(this.error);
	            case 'C':
	                return Observable_1.Observable.empty();
	        }
	        throw new Error('unexpected notification kind value');
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `next` from a
	     * given value.
	     * @param {T} value The `next` value.
	     * @return {Notification<T>} The "next" Notification representing the
	     * argument.
	     */
	    Notification.createNext = function (value) {
	        if (typeof value !== 'undefined') {
	            return new Notification('N', value);
	        }
	        return Notification.undefinedValueNotification;
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `error` from a
	     * given error.
	     * @param {any} [err] The `error` error.
	     * @return {Notification<T>} The "error" Notification representing the
	     * argument.
	     */
	    Notification.createError = function (err) {
	        return new Notification('E', undefined, err);
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `complete`.
	     * @return {Notification<any>} The valueless "complete" Notification.
	     */
	    Notification.createComplete = function () {
	        return Notification.completeNotification;
	    };
	    Notification.completeNotification = new Notification('C');
	    Notification.undefinedValueNotification = new Notification('N', undefined);
	    return Notification;
	}());
	exports.Notification = Notification;
	//# sourceMappingURL=Notification.js.map

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isScheduler_1 = __webpack_require__(65);
	var of_1 = __webpack_require__(89);
	var from_1 = __webpack_require__(346);
	var concatAll_1 = __webpack_require__(510);
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which sequentially emits all values from given
	 * Observable and then moves on to the next.
	 *
	 * <span class="informal">Concatenates multiple Observables together by
	 * sequentially emitting their values, one Observable after the other.</span>
	 *
	 * <img src="./img/concat.png" width="100%">
	 *
	 * `concat` joins multiple Observables together, by subscribing to them one at a time and
	 * merging their results into the output Observable. You can pass either an array of
	 * Observables, or put them directly as arguments. Passing an empty array will result
	 * in Observable that completes immediately.
	 *
	 * `concat` will subscribe to first input Observable and emit all its values, without
	 * changing or affecting them in any way. When that Observable completes, it will
	 * subscribe to then next Observable passed and, again, emit its values. This will be
	 * repeated, until the operator runs out of Observables. When last input Observable completes,
	 * `concat` will complete as well. At any given moment only one Observable passed to operator
	 * emits values. If you would like to emit values from passed Observables concurrently, check out
	 * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
	 * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
	 *
	 * Note that if some input Observable never completes, `concat` will also never complete
	 * and Observables following the one that did not complete will never be subscribed. On the other
	 * hand, if some Observable simply completes immediately after it is subscribed, it will be
	 * invisible for `concat`, which will just move on to the next Observable.
	 *
	 * If any Observable in chain errors, instead of passing control to the next Observable,
	 * `concat` will error immediately as well. Observables that would be subscribed after
	 * the one that emitted error, never will.
	 *
	 * If you pass to `concat` the same Observable many times, its stream of values
	 * will be "replayed" on every subscription, which means you can repeat given Observable
	 * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
	 * you can always use {@link repeat}.
	 *
	 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
	 * var timer = Rx.Observable.interval(1000).take(4);
	 * var sequence = Rx.Observable.range(1, 10);
	 * var result = Rx.Observable.concat(timer, sequence);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in:
	 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
	 *
	 *
	 * @example <caption>Concatenate an array of 3 Observables</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in the following:
	 * // (Prints to console sequentially)
	 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
	 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
	 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
	 *
	 *
	 * @example <caption>Concatenate the same Observable to repeat it</caption>
	 * const timer = Rx.Observable.interval(1000).take(2);
	 *
	 * Rx.Observable.concat(timer, timer) // concating the same Observable!
	 * .subscribe(
	 *   value => console.log(value),
	 *   err => {},
	 *   () => console.log('...and it is done!')
	 * );
	 *
	 * // Logs:
	 * // 0 after 1s
	 * // 1 after 2s
	 * // 0 after 3s
	 * // 1 after 4s
	 * // "...and it is done!" also after 4s
	 *
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 *
	 * @param {ObservableInput} input1 An input Observable to concatenate with others.
	 * @param {ObservableInput} input2 An input Observable to concatenate with others.
	 * More than one input Observables may be given as argument.
	 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
	 * Observable subscription on.
	 * @return {Observable} All values of each passed Observable merged into a
	 * single Observable, in order, in serial fashion.
	 * @static true
	 * @name concat
	 * @owner Observable
	 */
	function concat() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    if (observables.length === 1 || (observables.length === 2 && isScheduler_1.isScheduler(observables[1]))) {
	        return from_1.from(observables[0]);
	    }
	    return concatAll_1.concatAll()(of_1.of.apply(void 0, observables));
	}
	exports.concat = concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var subscribeToResult_1 = __webpack_require__(17);
	var OuterSubscriber_1 = __webpack_require__(16);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link mergeAll}.</span>
	 *
	 * <img src="./img/mergeMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an Observable, and then merging those resulting Observables and
	 * emitting the results of this merger.
	 *
	 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
	 * var letters = Rx.Observable.of('a', 'b', 'c');
	 * var result = letters.mergeMap(x =>
	 *   Rx.Observable.interval(1000).map(i => x+i)
	 * );
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // a0
	 * // b0
	 * // c0
	 * // a1
	 * // b1
	 * // c1
	 * // continues to list a,b,c with respective ascending integers
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link merge}
	 * @see {@link mergeAll}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and merging the results of the Observables obtained
	 * from this transformation.
	 * @method mergeMap
	 * @owner Observable
	 */
	function mergeMap(project, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return function mergeMapOperatorFunction(source) {
	        if (typeof resultSelector === 'number') {
	            concurrent = resultSelector;
	            resultSelector = null;
	        }
	        return source.lift(new MergeMapOperator(project, resultSelector, concurrent));
	    };
	}
	exports.mergeMap = mergeMap;
	var MergeMapOperator = (function () {
	    function MergeMapOperator(project, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	    }
	    MergeMapOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
	    };
	    return MergeMapOperator;
	}());
	exports.MergeMapOperator = MergeMapOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MergeMapSubscriber = (function (_super) {
	    __extends(MergeMapSubscriber, _super);
	    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        _super.call(this, destination);
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	        this.hasCompleted = false;
	        this.buffer = [];
	        this.active = 0;
	        this.index = 0;
	    }
	    MergeMapSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            this._tryNext(value);
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeMapSubscriber.prototype._tryNext = function (value) {
	        var result;
	        var index = this.index++;
	        try {
	            result = this.project(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.active++;
	        this._innerSub(result, value, index);
	    };
	    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
	        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
	    };
	    MergeMapSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            this.destination.complete();
	        }
	    };
	    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (this.resultSelector) {
	            this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            this.destination.next(innerValue);
	        }
	    };
	    MergeMapSubscriber.prototype._notifyResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var result;
	        try {
	            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return MergeMapSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.MergeMapSubscriber = MergeMapSubscriber;
	//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var scan_1 = __webpack_require__(519);
	var takeLast_1 = __webpack_require__(520);
	var defaultIfEmpty_1 = __webpack_require__(512);
	var pipe_1 = __webpack_require__(524);
	/* tslint:enable:max-line-length */
	/**
	 * Applies an accumulator function over the source Observable, and returns the
	 * accumulated result when the source completes, given an optional seed value.
	 *
	 * <span class="informal">Combines together all values emitted on the source,
	 * using an accumulator function that knows how to join a new source value into
	 * the accumulation from the past.</span>
	 *
	 * <img src="./img/reduce.png" width="100%">
	 *
	 * Like
	 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
	 * `reduce` applies an `accumulator` function against an accumulation and each
	 * value of the source Observable (from the past) to reduce it to a single
	 * value, emitted on the output Observable. Note that `reduce` will only emit
	 * one value, only when the source Observable completes. It is equivalent to
	 * applying operator {@link scan} followed by operator {@link last}.
	 *
	 * Returns an Observable that applies a specified `accumulator` function to each
	 * item emitted by the source Observable. If a `seed` value is specified, then
	 * that value will be used as the initial value for the accumulator. If no seed
	 * value is specified, the first item of the source is used as the seed.
	 *
	 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
	 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
	 *   .takeUntil(Rx.Observable.interval(5000));
	 * var ones = clicksInFiveSeconds.mapTo(1);
	 * var seed = 0;
	 * var count = ones.reduce((acc, one) => acc + one, seed);
	 * count.subscribe(x => console.log(x));
	 *
	 * @see {@link count}
	 * @see {@link expand}
	 * @see {@link mergeScan}
	 * @see {@link scan}
	 *
	 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
	 * called on each source value.
	 * @param {R} [seed] The initial accumulation value.
	 * @return {Observable<R>} An Observable that emits a single value that is the
	 * result of accumulating the values emitted by the source Observable.
	 * @method reduce
	 * @owner Observable
	 */
	function reduce(accumulator, seed) {
	    // providing a seed of `undefined` *should* be valid and trigger
	    // hasSeed! so don't use `seed !== undefined` checks!
	    // For this reason, we have to check it here at the original call site
	    // otherwise inside Operator/Subscriber we won't know if `undefined`
	    // means they didn't provide anything or if they literally provided `undefined`
	    if (arguments.length >= 2) {
	        return function reduceOperatorFunctionWithSeed(source) {
	            return pipe_1.pipe(scan_1.scan(accumulator, seed), takeLast_1.takeLast(1), defaultIfEmpty_1.defaultIfEmpty(seed))(source);
	        };
	    }
	    return function reduceOperatorFunction(source) {
	        return pipe_1.pipe(scan_1.scan(function (acc, value, index) {
	            return accumulator(acc, value, index + 1);
	        }), takeLast_1.takeLast(1))(source);
	    };
	}
	exports.reduce = reduce;
	//# sourceMappingURL=reduce.js.map

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(39);
	var Action_1 = __webpack_require__(4737);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AsyncAction = (function (_super) {
	    __extends(AsyncAction, _super);
	    function AsyncAction(scheduler, work) {
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	        this.pending = false;
	    }
	    AsyncAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (this.closed) {
	            return this;
	        }
	        // Always replace the current state with the new state.
	        this.state = state;
	        // Set the pending flag indicating that this action has been scheduled, or
	        // has recursively rescheduled itself.
	        this.pending = true;
	        var id = this.id;
	        var scheduler = this.scheduler;
	        //
	        // Important implementation note:
	        //
	        // Actions only execute once by default, unless rescheduled from within the
	        // scheduled callback. This allows us to implement single and repeat
	        // actions via the same code path, without adding API surface area, as well
	        // as mimic traditional recursion but across asynchronous boundaries.
	        //
	        // However, JS runtimes and timers distinguish between intervals achieved by
	        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
	        // serial `setTimeout` calls can be individually delayed, which delays
	        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
	        // guarantee the interval callback will be invoked more precisely to the
	        // interval period, regardless of load.
	        //
	        // Therefore, we use `setInterval` to schedule single and repeat actions.
	        // If the action reschedules itself with the same delay, the interval is not
	        // canceled. If the action doesn't reschedule, or reschedules with a
	        // different delay, the interval will be canceled after scheduled callback
	        // execution.
	        //
	        if (id != null) {
	            this.id = this.recycleAsyncId(scheduler, id, delay);
	        }
	        this.delay = delay;
	        // If this action has already an async Id, don't request a new one.
	        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
	        return this;
	    };
	    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        return root_1.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
	    };
	    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If this action is rescheduled with the same delay time, don't clear the interval id.
	        if (delay !== null && this.delay === delay && this.pending === false) {
	            return id;
	        }
	        // Otherwise, if the action's delay time is different from the current delay,
	        // or the action has been rescheduled before it's executed, clear the interval id
	        return root_1.root.clearInterval(id) && undefined || undefined;
	    };
	    /**
	     * Immediately executes this action and the `work` it contains.
	     * @return {any}
	     */
	    AsyncAction.prototype.execute = function (state, delay) {
	        if (this.closed) {
	            return new Error('executing a cancelled action');
	        }
	        this.pending = false;
	        var error = this._execute(state, delay);
	        if (error) {
	            return error;
	        }
	        else if (this.pending === false && this.id != null) {
	            // Dequeue if the action didn't reschedule itself. Don't call
	            // unsubscribe(), because the action could reschedule later.
	            // For example:
	            // ```
	            // scheduler.schedule(function doWork(counter) {
	            //   /* ... I'm a busy worker bee ... */
	            //   var originalAction = this;
	            //   /* wait 100ms before rescheduling the action */
	            //   setTimeout(function () {
	            //     originalAction.schedule(counter + 1);
	            //   }, 100);
	            // }, 1000);
	            // ```
	            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
	        }
	    };
	    AsyncAction.prototype._execute = function (state, delay) {
	        var errored = false;
	        var errorValue = undefined;
	        try {
	            this.work(state);
	        }
	        catch (e) {
	            errored = true;
	            errorValue = !!e && e || new Error(e);
	        }
	        if (errored) {
	            this.unsubscribe();
	            return errorValue;
	        }
	    };
	    AsyncAction.prototype._unsubscribe = function () {
	        var id = this.id;
	        var scheduler = this.scheduler;
	        var actions = scheduler.actions;
	        var index = actions.indexOf(this);
	        this.work = null;
	        this.state = null;
	        this.pending = false;
	        this.scheduler = null;
	        if (index !== -1) {
	            actions.splice(index, 1);
	        }
	        if (id != null) {
	            this.id = this.recycleAsyncId(scheduler, id, null);
	        }
	        this.delay = null;
	    };
	    return AsyncAction;
	}(Action_1.Action));
	exports.AsyncAction = AsyncAction;
	//# sourceMappingURL=AsyncAction.js.map

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Scheduler_1 = __webpack_require__(4471);
	var AsyncScheduler = (function (_super) {
	    __extends(AsyncScheduler, _super);
	    function AsyncScheduler() {
	        _super.apply(this, arguments);
	        this.actions = [];
	        /**
	         * A flag to indicate whether the Scheduler is currently executing a batch of
	         * queued actions.
	         * @type {boolean}
	         */
	        this.active = false;
	        /**
	         * An internal ID used to track the latest asynchronous task such as those
	         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
	         * others.
	         * @type {any}
	         */
	        this.scheduled = undefined;
	    }
	    AsyncScheduler.prototype.flush = function (action) {
	        var actions = this.actions;
	        if (this.active) {
	            actions.push(action);
	            return;
	        }
	        var error;
	        this.active = true;
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (action = actions.shift()); // exhaust the scheduler queue
	        this.active = false;
	        if (error) {
	            while (action = actions.shift()) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AsyncScheduler;
	}(Scheduler_1.Scheduler));
	exports.AsyncScheduler = AsyncScheduler;
	//# sourceMappingURL=AsyncScheduler.js.map

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(39);
	function symbolIteratorPonyfill(root) {
	    var Symbol = root.Symbol;
	    if (typeof Symbol === 'function') {
	        if (!Symbol.iterator) {
	            Symbol.iterator = Symbol('iterator polyfill');
	        }
	        return Symbol.iterator;
	    }
	    else {
	        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
	        var Set_1 = root.Set;
	        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') {
	            return '@@iterator';
	        }
	        var Map_1 = root.Map;
	        // required for compatability with es6-shim
	        if (Map_1) {
	            var keys = Object.getOwnPropertyNames(Map_1.prototype);
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
	                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) {
	                    return key;
	                }
	            }
	        }
	        return '@@iterator';
	    }
	}
	exports.symbolIteratorPonyfill = symbolIteratorPonyfill;
	exports.iterator = symbolIteratorPonyfill(root_1.root);
	/**
	 * @deprecated use iterator instead
	 */
	exports.$$iterator = exports.iterator;
	//# sourceMappingURL=iterator.js.map

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when an element was queried at a certain index of an
	 * Observable, but no such index or position exists in that sequence.
	 *
	 * @see {@link elementAt}
	 * @see {@link take}
	 * @see {@link takeLast}
	 *
	 * @class ArgumentOutOfRangeError
	 */
	var ArgumentOutOfRangeError = (function (_super) {
	    __extends(ArgumentOutOfRangeError, _super);
	    function ArgumentOutOfRangeError() {
	        var err = _super.call(this, 'argument out of range');
	        this.name = err.name = 'ArgumentOutOfRangeError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return ArgumentOutOfRangeError;
	}(Error));
	exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError;
	//# sourceMappingURL=ArgumentOutOfRangeError.js.map

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isArray_1 = __webpack_require__(81);
	function isNumeric(val) {
	    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
	    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
	    // subtraction forces infinities to NaN
	    // adding 1 corrects loss of precision from parseFloat (#15100)
	    return !isArray_1.isArray(val) && (val - parseFloat(val) + 1) >= 0;
	}
	exports.isNumeric = isNumeric;
	;
	//# sourceMappingURL=isNumeric.js.map

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(312).EventEmitter;
	var inherits = __webpack_require__(71);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(504);
	Stream.Writable = __webpack_require__(4441);
	Stream.Duplex = __webpack_require__(4436);
	Stream.Transform = __webpack_require__(4440);
	Stream.PassThrough = __webpack_require__(4439);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ }),
/* 274 */,
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(55);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (_ref) {
	  var node = _ref.node,
	      parent = _ref.parent,
	      scope = _ref.scope,
	      id = _ref.id;
	
	  if (node.id) return;
	
	  if ((t.isObjectProperty(parent) || t.isObjectMethod(parent, { kind: "method" })) && (!parent.computed || t.isLiteral(parent.key))) {
	    id = parent.key;
	  } else if (t.isVariableDeclarator(parent)) {
	    id = parent.id;
	
	    if (t.isIdentifier(id)) {
	      var binding = scope.parent.getBinding(id.name);
	      if (binding && binding.constant && scope.getBinding(id.name) === binding) {
	        node.id = id;
	        node.id[t.NOT_LOCAL_BINDING] = true;
	        return;
	      }
	    }
	  } else if (t.isAssignmentExpression(parent)) {
	    id = parent.left;
	  } else if (!id) {
	    return;
	  }
	
	  var name = void 0;
	  if (id && t.isLiteral(id)) {
	    name = id.value;
	  } else if (id && t.isIdentifier(id)) {
	    name = id.name;
	  } else {
	    return;
	  }
	
	  name = t.toBindingIdentifierName(name);
	  id = t.identifier(name);
	
	  id[t.NOT_LOCAL_BINDING] = true;
	
	  var state = visit(node, name, scope);
	  return wrap(state, node, id, scope) || node;
	};
	
	var _babelHelperGetFunctionArity = __webpack_require__(535);
	
	var _babelHelperGetFunctionArity2 = _interopRequireDefault(_babelHelperGetFunctionArity);
	
	var _babelTemplate = __webpack_require__(84);
	
	var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buildPropertyMethodAssignmentWrapper = (0, _babelTemplate2.default)("\n  (function (FUNCTION_KEY) {\n    function FUNCTION_ID() {\n      return FUNCTION_KEY.apply(this, arguments);\n    }\n\n    FUNCTION_ID.toString = function () {\n      return FUNCTION_KEY.toString();\n    }\n\n    return FUNCTION_ID;\n  })(FUNCTION)\n");
	
	var buildGeneratorPropertyMethodAssignmentWrapper = (0, _babelTemplate2.default)("\n  (function (FUNCTION_KEY) {\n    function* FUNCTION_ID() {\n      return yield* FUNCTION_KEY.apply(this, arguments);\n    }\n\n    FUNCTION_ID.toString = function () {\n      return FUNCTION_KEY.toString();\n    };\n\n    return FUNCTION_ID;\n  })(FUNCTION)\n");
	
	var visitor = {
	  "ReferencedIdentifier|BindingIdentifier": function ReferencedIdentifierBindingIdentifier(path, state) {
	    if (path.node.name !== state.name) return;
	
	    var localDeclar = path.scope.getBindingIdentifier(state.name);
	    if (localDeclar !== state.outerDeclar) return;
	
	    state.selfReference = true;
	    path.stop();
	  }
	};
	
	function wrap(state, method, id, scope) {
	  if (state.selfReference) {
	    if (scope.hasBinding(id.name) && !scope.hasGlobal(id.name)) {
	      scope.rename(id.name);
	    } else {
	      if (!t.isFunction(method)) return;
	
	      var build = buildPropertyMethodAssignmentWrapper;
	      if (method.generator) build = buildGeneratorPropertyMethodAssignmentWrapper;
	      var _template = build({
	        FUNCTION: method,
	        FUNCTION_ID: id,
	        FUNCTION_KEY: scope.generateUidIdentifier(id.name)
	      }).expression;
	      _template.callee._skipModulesRemap = true;
	
	      var params = _template.callee.body.body[0].params;
	      for (var i = 0, len = (0, _babelHelperGetFunctionArity2.default)(method); i < len; i++) {
	        params.push(scope.generateUidIdentifier("x"));
	      }
	
	      return _template;
	    }
	  }
	
	  method.id = id;
	  scope.getProgramParent().references[id.name] = true;
	}
	
	function visit(node, name, scope) {
	  var state = {
	    selfAssignment: false,
	    selfReference: false,
	    outerDeclar: scope.getBindingIdentifier(name),
	    references: [],
	    name: name
	  };
	
	  var binding = scope.getOwnBinding(name);
	
	  if (binding) {
	    if (binding.kind === "param") {
	      state.selfReference = true;
	    } else {}
	  } else if (state.outerDeclar || scope.hasGlobal(name)) {
	    scope.traverse(node, visitor, state);
	  }
	
	  return state;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 277 */,
/* 278 */,
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.jwt = exports._csrf = undefined;
	
	var _browserCookies = __webpack_require__(1001);
	
	var _browserCookies2 = _interopRequireDefault(_browserCookies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _csrf = exports._csrf = typeof window !== 'undefined' && _browserCookies2.default.get('_csrf');
	var jwt = exports.jwt = typeof window !== 'undefined' && _browserCookies2.default.get('jwt_access_token');

/***/ }),
/* 280 */,
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ajax$ = ajax$;
	exports.post$ = post$;
	exports.postJSON$ = postJSON$;
	exports.get$ = get$;
	exports.getJSON$ = getJSON$;
	
	var _debug = __webpack_require__(306);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _rxjs = __webpack_require__(88);
	
	var _operators = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = (0, _debug2.default)('fcc:ajax$'); /*
	                                                * Copyright (c) Microsoft Open Technologies, Inc.  All rights reserved.
	                                                * Microsoft Open Technologies would like to thank its contributors, a list
	                                                * of whom are at http://rx.codeplex.com/wikipage?title=Contributors.
	                                                *
	                                                * Licensed under the Apache License, Version 2.0 (the "License"); you
	                                                * may not use this file except in compliance with the License. You may
	                                                * obtain a copy of the License at
	                                                *
	                                                * http://www.apache.org/licenses/LICENSE-2.0
	                                                *
	                                                * Unless required by applicable law or agreed to in writing, software
	                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
	                                                * implied. See the License for the specific language governing permissions
	                                                * and limitations under the License.
	                                                */
	
	var root = typeof window !== 'undefined' ? window : {};
	
	// Gets the proper XMLHttpRequest for support for older IE
	function getXMLHttpRequest() {
	  if (root.XMLHttpRequest) {
	    return new root.XMLHttpRequest();
	  } else {
	    var progId;
	    try {
	      var progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'];
	      for (var i = 0; i < 3; i++) {
	        try {
	          progId = progIds[i];
	          if (new root.ActiveXObject(progId)) {
	            break;
	          }
	        } catch (e) {
	          // purposely do nothing
	          _rxjs.noop.noop(e);
	        }
	      }
	      return new root.ActiveXObject(progId);
	    } catch (e) {
	      throw new Error('XMLHttpRequest is not supported by your browser');
	    }
	  }
	}
	
	// Get CORS support even for older IE
	function getCORSRequest() {
	  var xhr = new root.XMLHttpRequest();
	  if ('withCredentials' in xhr) {
	    return xhr;
	  } else if (root.XDomainRequest) {
	    return new XDomainRequest();
	  } else {
	    throw new Error('CORS is not supported by your browser');
	  }
	}
	
	function parseXhrResponse(responseType, xhr) {
	  switch (responseType) {
	    case 'json':
	      if ('response' in xhr) {
	        return xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || 'null');
	      } else {
	        return JSON.parse(xhr.responseText || 'null');
	      }
	    case 'xml':
	      return xhr.responseXML;
	    case 'text':
	    default:
	      return 'response' in xhr ? xhr.response : xhr.responseText;
	  }
	}
	
	function normalizeAjaxSuccessEvent(e, xhr, settings) {
	  return {
	    response: parseXhrResponse(settings.responseType || xhr.responseType, xhr),
	    status: xhr.status,
	    responseType: xhr.responseType,
	    xhr: xhr,
	    originalEvent: e
	  };
	}
	
	function normalizeAjaxErrorEvent(e, xhr, type) {
	  return {
	    type: type,
	    status: xhr.status,
	    xhr: xhr,
	    originalEvent: e
	  };
	}
	
	/*
	 * Creates an observable for an Ajax request with either a settings object
	 * with url, headers, etc or a string for a URL.
	 *
	 * @example
	 *   source = Rx.DOM.ajax('/products');
	 *   source = Rx.DOM.ajax( url: 'products', method: 'GET' });
	 *
	 * interface Options {
	 *   url: String, // URL of the request
	 *   body?: Object, // The body of the request
	 *   method? = 'GET' : 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE',
	 *   async? = true: Boolean, // Whether the request is async
	 *   headers?: Object, // optional headers
	 *   crossDomain?: true // if a cross domain request, else false
	 * }
	 *
	 * ajax$(url?: String, options: Options) => Observable[XMLHttpRequest]
	 */
	function ajax$(options) {
	  var settings = {
	    method: 'GET',
	    crossDomain: false,
	    async: true,
	    headers: {},
	    responseType: 'text',
	    createXHR: function createXHR() {
	      return this.crossDomain ? getCORSRequest() : getXMLHttpRequest();
	    },
	    normalizeError: normalizeAjaxErrorEvent,
	    normalizeSuccess: normalizeAjaxSuccessEvent
	  };
	
	  if (typeof options === 'string') {
	    settings.url = options;
	  } else {
	    for (var prop in options) {
	      if (hasOwnProperty.call(options, prop)) {
	        settings[prop] = options[prop];
	      }
	    }
	  }
	
	  var normalizeError = settings.normalizeError;
	  var normalizeSuccess = settings.normalizeSuccess;
	
	  if (!settings.crossDomain && !settings.headers['X-Requested-With']) {
	    settings.headers['X-Requested-With'] = 'XMLHttpRequest';
	  }
	  settings.hasContent = typeof settings.body !== 'undefined';
	
	  return new _rxjs.Observable.create(function (observer) {
	    var isDone = false;
	    var xhr;
	
	    var processResponse = function processResponse(xhr, e) {
	      var status = xhr.status === 1223 ? 204 : xhr.status;
	      if (status >= 200 && status <= 300 || status === 0 || status === '') {
	        try {
	          observer.next(normalizeSuccess(e, xhr, settings));
	          observer.complete();
	        } catch (err) {
	          observer.error(err);
	        }
	      } else {
	        observer.error(normalizeError(e, xhr, 'error'));
	      }
	      isDone = true;
	    };
	
	    try {
	      xhr = settings.createXHR();
	    } catch (err) {
	      observer.error(err);
	    }
	
	    try {
	      if (settings.user) {
	        xhr.open(settings.method, settings.url, settings.async, settings.user, settings.password);
	      } else {
	        xhr.open(settings.method, settings.url, settings.async);
	      }
	
	      var headers = settings.headers;
	      for (var header in headers) {
	        if (hasOwnProperty.call(headers, header)) {
	          xhr.setRequestHeader(header, headers[header]);
	        }
	      }
	
	      if (!xhr.upload || !('withCredentials' in xhr) && root.XDomainRequest) {
	        xhr.onload = function (e) {
	          if (settings.progressObserver) {
	            settings.progressObserver.next(e);
	            settings.progressObserver.complete();
	          }
	          processResponse(xhr, e);
	        };
	
	        if (settings.progressObserver) {
	          xhr.onprogress = function (e) {
	            settings.progressObserver.next(e);
	          };
	        }
	
	        xhr.onerror = function (e) {
	          if (settings.progressObserver) {
	            settings.progressObserver.error(e);
	          }
	          observer.error(normalizeError(e, xhr, 'error'));
	          isDone = true;
	        };
	
	        xhr.onabort = function (e) {
	          if (settings.progressObserver) {
	            settings.progressObserver.error(e);
	          }
	          observer.error(normalizeError(e, xhr, 'abort'));
	          isDone = true;
	        };
	      } else {
	        xhr.onreadystatechange = function (e) {
	          if (xhr.readyState === 4) {
	            processResponse(xhr, e);
	          }
	        };
	      }
	
	      debug('ajax$ sending content', settings.hasContent && settings.body);
	      xhr.send(settings.hasContent && settings.body || null);
	    } catch (err) {
	      observer.error(err);
	    }
	
	    return function () {
	      if (!isDone && xhr.readyState !== 4) {
	        xhr.abort();
	      }
	    };
	  });
	}
	
	// Creates an observable sequence from an Ajax POST Request with the body.
	// post$(url: String, body: Object) => Observable[Any]
	function post$(url, body) {
	  try {
	    body = JSON.stringify(body);
	  } catch (e) {
	    return _rxjs.Observable.throw(e);
	  }
	
	  return ajax$({ url: url, body: body, method: 'POST' });
	}
	
	// postJSON$(url: String, body: Object) => Observable[Object]
	function postJSON$(url, body) {
	  try {
	    body = JSON.stringify(body);
	  } catch (e) {
	    return _rxjs.Observable.throw(e);
	  }
	
	  return ajax$({
	    url: url,
	    body: body,
	    method: 'POST',
	    responseType: 'json',
	    headers: {
	      'Content-Type': 'application/json',
	      Accept: 'application/json'
	    },
	    normalizeError: function normalizeError(e, xhr) {
	      return parseXhrResponse('json', xhr);
	    }
	  }).pipe((0, _operators.map)(function (_ref) {
	    var response = _ref.response;
	    return response;
	  }));
	}
	
	// Creates an observable sequence from an Ajax GET Request with the body.
	// get$(url: String) => Obserable[Any]
	function get$(url) {
	  return ajax$({ url: url });
	}
	
	/**
	 * Creates an observable sequence from JSON from an Ajax request
	 *
	 * @param {String} url The URL to GET
	 * @returns {Observable} The observable sequence which contains the parsed JSON
	 */
	// getJSON$(url: String) => Observable[Object];
	function getJSON$(url) {
	  return ajax$({
	    url: url,
	    responseType: 'json',
	    headers: {
	      'Content-Type': 'application/json',
	      Accept: 'application/json'
	    },
	    normalizeError: function normalizeError(e, xhr) {
	      return parseXhrResponse('json', xhr);
	    }
	  }).map(function (_ref2) {
	    var response = _ref2.response;
	    return response;
	  });
	}

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	'use strict';
	
	var _exports$pathsMap, _exports$viewTypes, _exports$submitTypes;
	
	var html = 0;
	var js = 1;
	var backend = 2;
	var zipline = 3;
	var frontEndProject = 3;
	var backEndProject = 4;
	var bonfire = 5;
	var modern = 6;
	var step = 7;
	var quiz = 8;
	var invalid = 9;
	
	// individual exports
	exports.backend = backend;
	exports.frontEndProject = frontEndProject;
	
	exports.challengeTypes = {
	  html: html,
	  js: js,
	  backend: backend,
	  zipline: zipline,
	  frontEndProject: frontEndProject,
	  backEndProject: backEndProject,
	  bonfire: bonfire,
	  modern: modern,
	  step: step,
	  quiz: quiz,
	  invalid: invalid
	};
	
	// turn challengeType to file ext
	exports.pathsMap = (_exports$pathsMap = {}, _exports$pathsMap[html] = 'html', _exports$pathsMap[js] = 'js', _exports$pathsMap[bonfire] = 'js', _exports$pathsMap);
	// determine the component to view for each challenge
	exports.viewTypes = (_exports$viewTypes = {}, _exports$viewTypes[html] = 'classic', _exports$viewTypes[js] = 'classic', _exports$viewTypes[bonfire] = 'classic', _exports$viewTypes[frontEndProject] = 'project', _exports$viewTypes[backEndProject] = 'project', _exports$viewTypes[modern] = 'modern', _exports$viewTypes[step] = 'step', _exports$viewTypes[quiz] = 'quiz', _exports$viewTypes[backend] = 'backend', _exports$viewTypes);
	
	// determine the type of submit function to use for the challenge on completion
	exports.submitTypes = (_exports$submitTypes = {}, _exports$submitTypes[html] = 'tests', _exports$submitTypes[js] = 'tests', _exports$submitTypes[bonfire] = 'tests', _exports$submitTypes[frontEndProject] = 'project.frontEnd', _exports$submitTypes[backEndProject] = 'project.backEnd', _exports$submitTypes[step] = 'step', _exports$submitTypes[quiz] = 'quiz', _exports$submitTypes[backend] = 'backend', _exports$submitTypes[modern] = 'tests', _exports$submitTypes);

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createTypes = createTypes;
	function createTypes() {
	  var types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var ns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'annon';
	
	  return types.reduce(function (types, action) {
	    var _extends2;
	
	    return _extends({}, types, (_extends2 = {}, _extends2[action] = ns + '.' + action, _extends2));
	  }, {});
	}

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.MESSAGES = undefined;
	
	var _stringify = __webpack_require__(168);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.get = get;
	exports.parseArgs = parseArgs;
	
	var _util = __webpack_require__(55);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MESSAGES = exports.MESSAGES = {
	  tailCallReassignmentDeopt: "Function reference has been reassigned, so it will probably be dereferenced, therefore we can't optimise this with confidence",
	  classesIllegalBareSuper: "Illegal use of bare super",
	  classesIllegalSuperCall: "Direct super call is illegal in non-constructor, use super.$1() instead",
	  scopeDuplicateDeclaration: "Duplicate declaration $1",
	  settersNoRest: "Setters aren't allowed to have a rest",
	  noAssignmentsInForHead: "No assignments allowed in for-in/of head",
	  expectedMemberExpressionOrIdentifier: "Expected type MemberExpression or Identifier",
	  invalidParentForThisNode: "We don't know how to handle this node within the current parent - please open an issue",
	  readOnly: "$1 is read-only",
	  unknownForHead: "Unknown node type $1 in ForStatement",
	  didYouMean: "Did you mean $1?",
	  codeGeneratorDeopt: "Note: The code generator has deoptimised the styling of $1 as it exceeds the max of $2.",
	  missingTemplatesDirectory: "no templates directory - this is most likely the result of a broken `npm publish`. Please report to https://github.com/babel/babel/issues",
	  unsupportedOutputType: "Unsupported output type $1",
	  illegalMethodName: "Illegal method name $1",
	  lostTrackNodePath: "We lost track of this node's position, likely because the AST was directly manipulated",
	
	  modulesIllegalExportName: "Illegal export $1",
	  modulesDuplicateDeclarations: "Duplicate module declarations with the same source but in different scopes",
	
	  undeclaredVariable: "Reference to undeclared variable $1",
	  undeclaredVariableType: "Referencing a type alias outside of a type annotation",
	  undeclaredVariableSuggestion: "Reference to undeclared variable $1 - did you mean $2?",
	
	  traverseNeedsParent: "You must pass a scope and parentPath unless traversing a Program/File. Instead of that you tried to traverse a $1 node without passing scope and parentPath.",
	  traverseVerifyRootFunction: "You passed `traverse()` a function when it expected a visitor object, are you sure you didn't mean `{ enter: Function }`?",
	  traverseVerifyVisitorProperty: "You passed `traverse()` a visitor object with the property $1 that has the invalid property $2",
	  traverseVerifyNodeType: "You gave us a visitor for the node type $1 but it's not a valid type",
	
	  pluginNotObject: "Plugin $2 specified in $1 was expected to return an object when invoked but returned $3",
	  pluginNotFunction: "Plugin $2 specified in $1 was expected to return a function but returned $3",
	  pluginUnknown: "Unknown plugin $1 specified in $2 at $3, attempted to resolve relative to $4",
	  pluginInvalidProperty: "Plugin $2 specified in $1 provided an invalid property of $3"
	};
	
	function get(key) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var msg = MESSAGES[key];
	  if (!msg) throw new ReferenceError("Unknown message " + (0, _stringify2.default)(key));
	
	  args = parseArgs(args);
	
	  return msg.replace(/\$(\d+)/g, function (str, i) {
	    return args[i - 1];
	  });
	}
	
	function parseArgs(args) {
	  return args.map(function (val) {
	    if (val != null && val.inspect) {
	      return val.inspect();
	    } else {
	      try {
	        return (0, _stringify2.default)(val) || val + "";
	      } catch (e) {
	        return util.inspect(val);
	      }
	    }
	  });
	}

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.scope = exports.path = undefined;
	
	var _weakMap = __webpack_require__(968);
	
	var _weakMap2 = _interopRequireDefault(_weakMap);
	
	exports.clear = clear;
	exports.clearPath = clearPath;
	exports.clearScope = clearScope;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var path = exports.path = new _weakMap2.default();
	var scope = exports.scope = new _weakMap2.default();
	
	function clear() {
	  clearPath();
	  clearScope();
	}
	
	function clearPath() {
	  exports.path = path = new _weakMap2.default();
	}
	
	function clearScope() {
	  exports.scope = scope = new _weakMap2.default();
	}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var config = __webpack_require__(127);
	
	var fnLengthDesc = Object.getOwnPropertyDescriptor(function () {}, 'length');
	
	/*!
	 * Chai - addLengthGuard utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/**
	 * ### .addLengthGuard(fn, assertionName, isChainable)
	 *
	 * Define `length` as a getter on the given uninvoked method assertion. The
	 * getter acts as a guard against chaining `length` directly off of an uninvoked
	 * method assertion, which is a problem because it references `function`'s
	 * built-in `length` property instead of Chai's `length` assertion. When the
	 * getter catches the user making this mistake, it throws an error with a
	 * helpful message.
	 *
	 * There are two ways in which this mistake can be made. The first way is by
	 * chaining the `length` assertion directly off of an uninvoked chainable
	 * method. In this case, Chai suggests that the user use `lengthOf` instead. The
	 * second way is by chaining the `length` assertion directly off of an uninvoked
	 * non-chainable method. Non-chainable methods must be invoked prior to
	 * chaining. In this case, Chai suggests that the user consult the docs for the
	 * given assertion.
	 *
	 * If the `length` property of functions is unconfigurable, then return `fn`
	 * without modification.
	 *
	 * Note that in ES6, the function's `length` property is configurable, so once
	 * support for legacy environments is dropped, Chai's `length` property can
	 * replace the built-in function's `length` property, and this length guard will
	 * no longer be necessary. In the mean time, maintaining consistency across all
	 * environments is the priority.
	 *
	 * @param {Function} fn
	 * @param {String} assertionName
	 * @param {Boolean} isChainable
	 * @namespace Utils
	 * @name addLengthGuard
	 */
	
	module.exports = function addLengthGuard (fn, assertionName, isChainable) {
	  if (!fnLengthDesc.configurable) return fn;
	
	  Object.defineProperty(fn, 'length', {
	    get: function () {
	      if (isChainable) {
	        throw Error('Invalid Chai property: ' + assertionName + '.length. Due' +
	          ' to a compatibility issue, "length" cannot directly follow "' +
	          assertionName + '". Use "' + assertionName + '.lengthOf" instead.');
	      }
	
	      throw Error('Invalid Chai property: ' + assertionName + '.length. See' +
	        ' docs for proper usage of "' + assertionName + '".');
	    }
	  });
	
	  return fn;
	};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	// This is (almost) directly from Node.js utils
	// https://github.com/joyent/node/blob/f8c335d0caf47f16d31413f89aa28eda3878e3aa/lib/util.js
	
	var getName = __webpack_require__(625);
	var getProperties = __webpack_require__(557);
	var getEnumerableProperties = __webpack_require__(1015);
	var config = __webpack_require__(127);
	
	module.exports = inspect;
	
	/**
	 * ### .inspect(obj, [showHidden], [depth], [colors])
	 *
	 * Echoes the value of a value. Tries to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Boolean} showHidden Flag that shows hidden (not enumerable)
	 *    properties of objects. Default is false.
	 * @param {Number} depth Depth in which to descend in object. Default is 2.
	 * @param {Boolean} colors Flag to turn on ANSI escape codes to color the
	 *    output. Default is false (no coloring).
	 * @namespace Utils
	 * @name inspect
	 */
	function inspect(obj, showHidden, depth, colors) {
	  var ctx = {
	    showHidden: showHidden,
	    seen: [],
	    stylize: function (str) { return str; }
	  };
	  return formatValue(ctx, obj, (typeof depth === 'undefined' ? 2 : depth));
	}
	
	// Returns true if object is a DOM element.
	var isDOMElement = function (object) {
	  if (typeof HTMLElement === 'object') {
	    return object instanceof HTMLElement;
	  } else {
	    return object &&
	      typeof object === 'object' &&
	      'nodeType' in object &&
	      object.nodeType === 1 &&
	      typeof object.nodeName === 'string';
	  }
	};
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (value && typeof value.inspect === 'function' &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (typeof ret !== 'string') {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // If this is a DOM element, try to get the outer HTML.
	  if (isDOMElement(value)) {
	    if ('outerHTML' in value) {
	      return value.outerHTML;
	      // This value does not have an outerHTML attribute,
	      //   it could still be an XML element
	    } else {
	      // Attempt to serialize it
	      try {
	        if (document.xmlVersion) {
	          var xmlSerializer = new XMLSerializer();
	          return xmlSerializer.serializeToString(value);
	        } else {
	          // Firefox 11- do not support outerHTML
	          //   It does, however, support innerHTML
	          //   Use the following to render the element
	          var ns = "http://www.w3.org/1999/xhtml";
	          var container = document.createElementNS(ns, '_');
	
	          container.appendChild(value.cloneNode(false));
	          var html = container.innerHTML
	            .replace('><', '>' + value.innerHTML + '<');
	          container.innerHTML = '';
	          return html;
	        }
	      } catch (err) {
	        // This could be a non-native DOM implementation,
	        //   continue with the normal flow:
	        //   printing the element as if it is an object.
	      }
	    }
	  }
	
	  // Look up the keys of the object.
	  var visibleKeys = getEnumerableProperties(value);
	  var keys = ctx.showHidden ? getProperties(value) : visibleKeys;
	
	  var name, nameSuffix;
	
	  // Some type of object without properties can be shortcutted.
	  // In IE, errors have a single `stack` property, or if they are vanilla `Error`,
	  // a `stack` plus `description` property; ignore those for consistency.
	  if (keys.length === 0 || (isError(value) && (
	      (keys.length === 1 && keys[0] === 'stack') ||
	      (keys.length === 2 && keys[0] === 'description' && keys[1] === 'stack')
	     ))) {
	    if (typeof value === 'function') {
	      name = getName(value);
	      nameSuffix = name ? ': ' + name : '';
	      return ctx.stylize('[Function' + nameSuffix + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toUTCString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = ''
	    , array = false
	    , typedArray = false
	    , braces = ['{', '}'];
	
	  if (isTypedArray(value)) {
	    typedArray = true;
	    braces = ['[', ']'];
	  }
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (typeof value === 'function') {
	    name = getName(value);
	    nameSuffix = name ? ': ' + name : '';
	    base = ' [Function' + nameSuffix + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    return formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else if (typedArray) {
	    return formatTypedArray(value);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  switch (typeof value) {
	    case 'undefined':
	      return ctx.stylize('undefined', 'undefined');
	
	    case 'string':
	      var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                               .replace(/'/g, "\\'")
	                                               .replace(/\\"/g, '"') + '\'';
	      return ctx.stylize(simple, 'string');
	
	    case 'number':
	      if (value === 0 && (1/value) === -Infinity) {
	        return ctx.stylize('-0', 'number');
	      }
	      return ctx.stylize('' + value, 'number');
	
	    case 'boolean':
	      return ctx.stylize('' + value, 'boolean');
	
	    case 'symbol':
	      return ctx.stylize(value.toString(), 'symbol');
	  }
	  // For some reason typeof null is "object", so special case here.
	  if (value === null) {
	    return ctx.stylize('null', 'null');
	  }
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (Object.prototype.hasOwnProperty.call(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	function formatTypedArray(value) {
	  var str = '[ ';
	
	  for (var i = 0; i < value.length; ++i) {
	    if (str.length >= config.truncateThreshold - 7) {
	      str += '...';
	      break;
	    }
	    str += value[i] + ', ';
	  }
	  str += ' ]';
	
	  // Removing trailing `, ` if the array was not truncated
	  if (str.indexOf(',  ]') !== -1) {
	    str = str.replace(',  ]', ' ]');
	  }
	
	  return str;
	}
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name;
	  var propDescriptor = Object.getOwnPropertyDescriptor(value, key);
	  var str;
	
	  if (propDescriptor) {
	    if (propDescriptor.get) {
	      if (propDescriptor.set) {
	        str = ctx.stylize('[Getter/Setter]', 'special');
	      } else {
	        str = ctx.stylize('[Getter]', 'special');
	      }
	    } else {
	      if (propDescriptor.set) {
	        str = ctx.stylize('[Setter]', 'special');
	      }
	    }
	  }
	  if (visibleKeys.indexOf(key) < 0) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(value[key]) < 0) {
	      if (recurseTimes === null) {
	        str = formatValue(ctx, value[key], null);
	      } else {
	        str = formatValue(ctx, value[key], recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (typeof name === 'undefined') {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	function isTypedArray(ar) {
	  // Unfortunately there's no way to check if an object is a TypedArray
	  // We have to check if it's one of these types
	  return (typeof ar === 'object' && /\w+Array]$/.test(objectToString(ar)));
	}
	
	function isArray(ar) {
	  return Array.isArray(ar) ||
	         (typeof ar === 'object' && objectToString(ar) === '[object Array]');
	}
	
	function isRegExp(re) {
	  return typeof re === 'object' && objectToString(re) === '[object RegExp]';
	}
	
	function isDate(d) {
	  return typeof d === 'object' && objectToString(d) === '[object Date]';
	}
	
	function isError(e) {
	  return typeof e === 'object' && objectToString(e) === '[object Error]';
	}
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	var config = __webpack_require__(127);
	
	/*!
	 * Chai - isProxyEnabled helper
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/**
	 * ### .isProxyEnabled()
	 *
	 * Helper function to check if Chai's proxy protection feature is enabled. If
	 * proxies are unsupported or disabled via the user's Chai config, then return
	 * false. Otherwise, return true.
	 *
	 * @namespace Utils
	 * @name isProxyEnabled
	 */
	
	module.exports = function isProxyEnabled() {
	  return config.useProxy && 
	    typeof Proxy !== 'undefined' &&
	    typeof Reflect !== 'undefined';
	};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	var config = __webpack_require__(127);
	var flag = __webpack_require__(69);
	var getProperties = __webpack_require__(557);
	var isProxyEnabled = __webpack_require__(288);
	
	/*!
	 * Chai - proxify utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/**
	 * ### .proxify(object)
	 *
	 * Return a proxy of given object that throws an error when a non-existent
	 * property is read. By default, the root cause is assumed to be a misspelled
	 * property, and thus an attempt is made to offer a reasonable suggestion from
	 * the list of existing properties. However, if a nonChainableMethodName is
	 * provided, then the root cause is instead a failure to invoke a non-chainable
	 * method prior to reading the non-existent property.
	 * 
	 * If proxies are unsupported or disabled via the user's Chai config, then
	 * return object without modification.
	 *
	 * @param {Object} obj
	 * @param {String} nonChainableMethodName
	 * @namespace Utils
	 * @name proxify
	 */
	
	var builtins = ['__flags', '__methods', '_obj', 'assert'];
	
	module.exports = function proxify(obj, nonChainableMethodName) {
	  if (!isProxyEnabled()) return obj;
	
	  return new Proxy(obj, {
	    get: function proxyGetter(target, property) {
	      // This check is here because we should not throw errors on Symbol properties
	      // such as `Symbol.toStringTag`.
	      // The values for which an error should be thrown can be configured using
	      // the `config.proxyExcludedKeys` setting.
	      if (typeof property === 'string' &&
	          config.proxyExcludedKeys.indexOf(property) === -1 &&
	          !Reflect.has(target, property)) {
	        // Special message for invalid property access of non-chainable methods.
	        if (nonChainableMethodName) {
	          throw Error('Invalid Chai property: ' + nonChainableMethodName + '.' +
	            property + '. See docs for proper usage of "' +
	            nonChainableMethodName + '".');
	        }
	
	        var orderedProperties = getProperties(target).filter(function(property) {
	          return !Object.prototype.hasOwnProperty(property) &&
	            builtins.indexOf(property) === -1;
	        }).sort(function(a, b) {
	          return stringDistance(property, a) - stringDistance(property, b);
	        });
	
	        if (orderedProperties.length &&
	            stringDistance(orderedProperties[0], property) < 4) {
	          // If the property is reasonably close to an existing Chai property,
	          // suggest that property to the user.
	          throw Error('Invalid Chai property: ' + property +
	            '. Did you mean "' + orderedProperties[0] + '"?');
	        } else {
	          throw Error('Invalid Chai property: ' + property);
	        }
	      }
	
	      // Use this proxy getter as the starting point for removing implementation
	      // frames from the stack trace of a failed assertion. For property
	      // assertions, this prevents the proxy getter from showing up in the stack
	      // trace since it's invoked before the property getter. For method and
	      // chainable method assertions, this flag will end up getting changed to
	      // the method wrapper, which is good since this frame will no longer be in
	      // the stack once the method is invoked. Note that Chai builtin assertion
	      // properties such as `__flags` are skipped since this is only meant to
	      // capture the starting point of an assertion. This step is also skipped
	      // if the `lockSsfi` flag is set, thus indicating that this assertion is
	      // being called from within another assertion. In that case, the `ssfi`
	      // flag is already set to the outer assertion's starting point.
	      if (builtins.indexOf(property) === -1 && !flag(target, 'lockSsfi')) {
	        flag(target, 'ssfi', proxyGetter);
	      }
	
	      return Reflect.get(target, property);
	    }
	  });
	};
	
	/**
	 * # stringDistance(strA, strB)
	 * Return the Levenshtein distance between two strings.
	 * @param {string} strA
	 * @param {string} strB
	 * @return {number} the string distance between strA and strB
	 * @api private
	 */
	
	function stringDistance(strA, strB, memo) {
	  if (!memo) {
	    // `memo` is a two-dimensional array containing a cache of distances
	    // memo[i][j] is the distance between strA.slice(0, i) and
	    // strB.slice(0, j).
	    memo = [];
	    for (var i = 0; i <= strA.length; i++) {
	      memo[i] = [];
	    }
	  }
	
	  if (!memo[strA.length] || !memo[strA.length][strB.length]) {
	    if (strA.length === 0 || strB.length === 0) {
	      memo[strA.length][strB.length] = Math.max(strA.length, strB.length);
	    } else {
	      memo[strA.length][strB.length] = Math.min(
	        stringDistance(strA.slice(0, -1), strB, memo) + 1,
	        stringDistance(strA, strB.slice(0, -1), memo) + 1,
	        stringDistance(strA.slice(0, -1), strB.slice(0, -1), memo) +
	          (strA.slice(-1) === strB.slice(-1) ? 0 : 1)
	      );
	    }
	  }
	
	  return memo[strA.length][strB.length];
	}


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	var assign = __webpack_require__(329);
	
	/*
	 * Cheerio default options
	 */
	
	exports.default = {
	  withDomLvl1: true,
	  normalizeWhitespace: false,
	  xml: false,
	  decodeEntities: true
	};
	
	exports.flatten = function(options) {
	  return options && options.xml ? assign({xmlMode: true}, options.xml) : options;
	};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*
	  Module Dependencies
	*/
	var htmlparser = __webpack_require__(179),
	    parse5 = __webpack_require__(4365);
	
	/*
	  Parser
	*/
	exports = module.exports = function(content, options, isDocument) {
	  var dom = exports.evaluate(content, options, isDocument),
	      // Generic root element
	      root = exports.evaluate('<root></root>', options, false)[0];
	
	  root.type = 'root';
	  root.parent = null;
	
	  // Update the dom using the root
	  exports.update(dom, root);
	
	  return root;
	};
	
	function parseWithParse5 (content, isDocument) {
	  var parse = isDocument ? parse5.parse : parse5.parseFragment,
	      root = parse(content, { treeAdapter: parse5.treeAdapters.htmlparser2 });
	
	  return root.children;
	}
	
	exports.evaluate = function(content, options, isDocument) {
	  // options = options || $.fn.options;
	
	  var dom;
	
	  if (Buffer.isBuffer(content))
	    content = content.toString();
	
	  if (typeof content === 'string') {
	    var useHtmlParser2 = options.xmlMode || options._useHtmlParser2;
	
	    dom = useHtmlParser2 ? htmlparser.parseDOM(content, options) : parseWithParse5(content, isDocument);
	  } else {
	    dom = content;
	  }
	
	  return dom;
	};
	
	/*
	  Update the dom structure, for one changed layer
	*/
	exports.update = function(arr, parent) {
	  // normalize
	  if (!Array.isArray(arr)) arr = [arr];
	
	  // Update parent
	  if (parent) {
	    parent.children = arr;
	  } else {
	    parent = null;
	  }
	
	  // Update neighbors
	  for (var i = 0; i < arr.length; i++) {
	    var node = arr[i];
	
	    // Cleanly remove existing nodes from their previous structures.
	    var oldParent = node.parent || node.root,
	        oldSiblings = oldParent && oldParent.children;
	    if (oldSiblings && oldSiblings !== arr) {
	      oldSiblings.splice(oldSiblings.indexOf(node), 1);
	      if (node.prev) {
	        node.prev.next = node.next;
	      }
	      if (node.next) {
	        node.next.prev = node.prev;
	      }
	    }
	
	    if (parent) {
	      node.prev = arr[i - 1] || null;
	      node.next = arr[i + 1] || null;
	    } else {
	      node.prev = node.next = null;
	    }
	
	    if (parent && parent.type === 'root') {
	      node.root = parent;
	      node.parent = null;
	    } else {
	      node.root = null;
	      node.parent = parent;
	    }
	  }
	
	  return parent;
	};
	
	// module.exports = $.extend(exports);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(169).Buffer))

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 293 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(57);
	var dPs = __webpack_require__(1068);
	var enumBugKeys = __webpack_require__(389);
	var IE_PROTO = __webpack_require__(395)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(388)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(562).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(95);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(397);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 297 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(46);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 299 */
/***/ (function(module, exports) {



/***/ }),
/* 300 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 301 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(300);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(52);
	var core = __webpack_require__(173);
	var hide = __webpack_require__(174);
	var redefine = __webpack_require__(211);
	var ctx = __webpack_require__(302);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 304 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(130);
	var IE8_DOM_DEFINE = __webpack_require__(1102);
	var toPrimitive = __webpack_require__(1120);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(208) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	/* eslint-env browser */
	
	/**
	 * This is the web browser implementation of `debug()`.
	 */
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = localstorage();
	/**
	 * Colors.
	 */
	
	exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	// eslint-disable-next-line complexity
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
	    return true;
	  } // Internet Explorer and Edge do not support colors.
	
	
	  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
	    return false;
	  } // Is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	
	
	  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
	  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
	  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
	  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
	}
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	
	function formatArgs(args) {
	  args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);
	
	  if (!this.useColors) {
	    return;
	  }
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function (match) {
	    if (match === '%%') {
	      return;
	    }
	
	    index++;
	
	    if (match === '%c') {
	      // We only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	  args.splice(lastC, 0, c);
	}
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	
	function log() {
	  var _console;
	
	  // This hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return (typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
	}
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	
	function save(namespaces) {
	  try {
	    if (namespaces) {
	      exports.storage.setItem('debug', namespaces);
	    } else {
	      exports.storage.removeItem('debug');
	    }
	  } catch (error) {// Swallow
	    // XXX (@Qix-) should we be logging these?
	  }
	}
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	
	function load() {
	  var r;
	
	  try {
	    r = exports.storage.getItem('debug');
	  } catch (error) {} // Swallow
	  // XXX (@Qix-) should we be logging these?
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	
	
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","PUBLIC_DIR":"/usr/share/nginx/html/learn-master_ch/public"}).DEBUG;
	  }
	
	  return r;
	}
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	
	function localstorage() {
	  try {
	    // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
	    // The Browser also has localStorage in the global context.
	    return localStorage;
	  } catch (error) {// Swallow
	    // XXX (@Qix-) should we be logging these?
	  }
	}
	
	module.exports = __webpack_require__(1141)(exports);
	var formatters = module.exports.formatters;
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	formatters.j = function (v) {
	  try {
	    return JSON.stringify(v);
	  } catch (error) {
	    return '[UnexpectedJSONParseError]: ' + error.message;
	  }
	};
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78)))

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = activeElement;
	
	var _ownerDocument = __webpack_require__(48);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function activeElement() {
	  var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _ownerDocument2.default)();
	
	  try {
	    return doc.activeElement;
	  } catch (e) {/* ie throws if no active element */}
	}
	module.exports = exports['default'];

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasClass = exports.removeClass = exports.addClass = undefined;
	
	var _addClass = __webpack_require__(1145);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(1146);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _hasClass = __webpack_require__(598);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.addClass = _addClass2.default;
	exports.removeClass = _removeClass2.default;
	exports.hasClass = _hasClass2.default;
	exports.default = { addClass: _addClass2.default, removeClass: _removeClass2.default, hasClass: _hasClass2.default };

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.listen = exports.filter = exports.off = exports.on = undefined;
	
	var _on = __webpack_require__(133);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(132);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _filter = __webpack_require__(1147);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _listen = __webpack_require__(1148);
	
	var _listen2 = _interopRequireDefault(_listen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.on = _on2.default;
	exports.off = _off2.default;
	exports.filter = _filter2.default;
	exports.listen = _listen2.default;
	exports.default = { on: _on2.default, off: _off2.default, filter: _filter2.default, listen: _listen2.default };

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = style;
	
	var _camelizeStyle = __webpack_require__(599);
	
	var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
	var _hyphenateStyle = __webpack_require__(1158);
	
	var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);
	
	var _getComputedStyle2 = __webpack_require__(1152);
	
	var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);
	
	var _removeStyle = __webpack_require__(1153);
	
	var _removeStyle2 = _interopRequireDefault(_removeStyle);
	
	var _properties = __webpack_require__(1155);
	
	var _isTransform = __webpack_require__(1154);
	
	var _isTransform2 = _interopRequireDefault(_isTransform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	    if (!value && value !== 0) {
	      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
	    } else if ((0, _isTransform2.default)(key)) {
	      transforms += key + '(' + value + ') ';
	    } else {
	      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ': ' + transforms + ';';
	  }
	
	  node.style.cssText += ';' + css;
	}
	module.exports = exports['default'];

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	  Module dependencies
	*/
	var ElementType = __webpack_require__(1160);
	var entities = __webpack_require__(1170);
	
	/*
	  Boolean Attributes
	*/
	var booleanAttributes = {
	  __proto__: null,
	  allowfullscreen: true,
	  async: true,
	  autofocus: true,
	  autoplay: true,
	  checked: true,
	  controls: true,
	  default: true,
	  defer: true,
	  disabled: true,
	  hidden: true,
	  ismap: true,
	  loop: true,
	  multiple: true,
	  muted: true,
	  open: true,
	  readonly: true,
	  required: true,
	  reversed: true,
	  scoped: true,
	  seamless: true,
	  selected: true,
	  typemustmatch: true
	};
	
	var unencodedElements = {
	  __proto__: null,
	  style: true,
	  script: true,
	  xmp: true,
	  iframe: true,
	  noembed: true,
	  noframes: true,
	  plaintext: true,
	  noscript: true
	};
	
	/*
	  Format attributes
	*/
	function formatAttrs(attributes, opts) {
	  if (!attributes) return;
	
	  var output = '',
	      value;
	
	  // Loop through the attributes
	  for (var key in attributes) {
	    value = attributes[key];
	    if (output) {
	      output += ' ';
	    }
	
	    if (!value && booleanAttributes[key]) {
	      output += key;
	    } else {
	      output += key + '="' + (opts.decodeEntities ? entities.encodeXML(value) : value) + '"';
	    }
	  }
	
	  return output;
	}
	
	/*
	  Self-enclosing tags (stolen from node-htmlparser)
	*/
	var singleTag = {
	  __proto__: null,
	  area: true,
	  base: true,
	  basefont: true,
	  br: true,
	  col: true,
	  command: true,
	  embed: true,
	  frame: true,
	  hr: true,
	  img: true,
	  input: true,
	  isindex: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true,
	};
	
	
	var render = module.exports = function(dom, opts) {
	  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
	  opts = opts || {};
	
	  var output = '';
	
	  for(var i = 0; i < dom.length; i++){
	    var elem = dom[i];
	
	    if (elem.type === 'root')
	      output += render(elem.children, opts);
	    else if (ElementType.isTag(elem))
	      output += renderTag(elem, opts);
	    else if (elem.type === ElementType.Directive)
	      output += renderDirective(elem);
	    else if (elem.type === ElementType.Comment)
	      output += renderComment(elem);
	    else if (elem.type === ElementType.CDATA)
	      output += renderCdata(elem);
	    else
	      output += renderText(elem, opts);
	  }
	
	  return output;
	};
	
	function renderTag(elem, opts) {
	  // Handle SVG
	  if (elem.name === "svg") opts = {decodeEntities: opts.decodeEntities, xmlMode: true};
	
	  var tag = '<' + elem.name,
	      attribs = formatAttrs(elem.attribs, opts);
	
	  if (attribs) {
	    tag += ' ' + attribs;
	  }
	
	  if (
	    opts.xmlMode
	    && (!elem.children || elem.children.length === 0)
	  ) {
	    tag += '/>';
	  } else {
	    tag += '>';
	    if (elem.children) {
	      tag += render(elem.children, opts);
	    }
	
	    if (!singleTag[elem.name] || opts.xmlMode) {
	      tag += '</' + elem.name + '>';
	    }
	  }
	
	  return tag;
	}
	
	function renderDirective(elem) {
	  return '<' + elem.data + '>';
	}
	
	function renderText(elem, opts) {
	  var data = elem.data || '';
	
	  // if entities weren't decoded, no need to encode them back
	  if (opts.decodeEntities && !(elem.parent && elem.parent.name in unencodedElements)) {
	    data = entities.encodeXML(data);
	  }
	
	  return data;
	}
	
	function renderCdata(elem) {
	  return '<![CDATA[' + elem.children[0].data + ']]>';
	}
	
	function renderComment(elem) {
	  return '<!--' + elem.data + '-->';
	}


/***/ }),
/* 312 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(99);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(2713);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(2714);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(623);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(2715);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(2716);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(2717);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(2718);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(624);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(420);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(2719);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(2720);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(2721);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(2722);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(4465);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(4784);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(4282),
	    listCacheDelete = __webpack_require__(4283),
	    listCacheGet = __webpack_require__(4284),
	    listCacheHas = __webpack_require__(4285),
	    listCacheSet = __webpack_require__(4286);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(316),
	    stackClear = __webpack_require__(4304),
	    stackDelete = __webpack_require__(4305),
	    stackGet = __webpack_require__(4306),
	    stackHas = __webpack_require__(4307),
	    stackSet = __webpack_require__(4308);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(442),
	    eq = __webpack_require__(138);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(138);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(317),
	    arrayEach = __webpack_require__(434),
	    assignValue = __webpack_require__(318),
	    baseAssign = __webpack_require__(4210),
	    baseAssignIn = __webpack_require__(4211),
	    cloneBuffer = __webpack_require__(652),
	    copyArray = __webpack_require__(222),
	    copySymbols = __webpack_require__(4250),
	    copySymbolsIn = __webpack_require__(4251),
	    getAllKeys = __webpack_require__(663),
	    getAllKeysIn = __webpack_require__(664),
	    getTag = __webpack_require__(224),
	    initCloneArray = __webpack_require__(4276),
	    initCloneByTag = __webpack_require__(4277),
	    initCloneObject = __webpack_require__(668),
	    isArray = __webpack_require__(24),
	    isBuffer = __webpack_require__(232),
	    isMap = __webpack_require__(331),
	    isObject = __webpack_require__(49),
	    isSet = __webpack_require__(4327),
	    keys = __webpack_require__(76);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	
	    return result;
	  }
	
	  if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	
	    return result;
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(49);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(24),
	    isKey = __webpack_require__(459),
	    stringToPath = __webpack_require__(4310),
	    toString = __webpack_require__(54);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(73),
	    isIterateeCall = __webpack_require__(227);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(321),
	    isObject = __webpack_require__(49);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtor;


/***/ }),
/* 325 */
/***/ (function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(4280);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(137);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(662);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)(module)))

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(318),
	    copyObject = __webpack_require__(101),
	    createAssigner = __webpack_require__(323),
	    isArrayLike = __webpack_require__(74),
	    isPrototype = __webpack_require__(228),
	    keys = __webpack_require__(76);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(444),
	    isArrayLike = __webpack_require__(74),
	    isString = __webpack_require__(332),
	    toInteger = __webpack_require__(334),
	    values = __webpack_require__(696);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(4223),
	    baseUnary = __webpack_require__(136),
	    nodeUtil = __webpack_require__(328);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(72),
	    isArray = __webpack_require__(24),
	    isObjectLike = __webpack_require__(43);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(4229),
	    baseUnary = __webpack_require__(136),
	    nodeUtil = __webpack_require__(328);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(4345);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

	'use strict';
	
	var Mixin = module.exports = function (host) {
	    var originalMethods = {},
	        overriddenMethods = this._getOverriddenMethods(this, originalMethods);
	
	    Object.keys(overriddenMethods).forEach(function (key) {
	        if (typeof overriddenMethods[key] === 'function') {
	            originalMethods[key] = host[key];
	            host[key] = overriddenMethods[key];
	        }
	    });
	};
	
	Mixin.prototype._getOverriddenMethods = function () {
	    throw new Error('Not implemented');
	};
	


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78)))

/***/ }),
/* 337 */,
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(103);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: '/',
	      url: '/',
	      params: {},
	      isExact: pathname === '/'
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, 'You cannot change <Router history>');
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(4376);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = '' + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof options === 'string') options = { path: options };
	
	  var _options = options,
	      _options$path = _options.path,
	      path = _options$path === undefined ? '/' : _options$path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 341 */,
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.combineActions = exports.handleActions = exports.handleAction = exports.createActions = exports.createAction = undefined;
	
	var _createAction = __webpack_require__(748);
	
	var _createAction2 = _interopRequireDefault(_createAction);
	
	var _handleAction = __webpack_require__(750);
	
	var _handleAction2 = _interopRequireDefault(_handleAction);
	
	var _handleActions = __webpack_require__(4445);
	
	var _handleActions2 = _interopRequireDefault(_handleActions);
	
	var _combineActions = __webpack_require__(747);
	
	var _combineActions2 = _interopRequireDefault(_combineActions);
	
	var _createActions = __webpack_require__(4444);
	
	var _createActions2 = _interopRequireDefault(_createActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createAction = _createAction2.default;
	exports.createActions = _createActions2.default;
	exports.handleAction = _handleAction2.default;
	exports.handleActions = _handleActions2.default;
	exports.combineActions = _combineActions2.default;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.runtimeProperty = runtimeProperty;
	exports.isReference = isReference;
	exports.replaceWithOrRemove = replaceWithOrRemove;
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function runtimeProperty(name) {
	  return t.memberExpression(t.identifier("regeneratorRuntime"), t.identifier(name), false);
	} /**
	   * Copyright (c) 2014, Facebook, Inc.
	   * All rights reserved.
	   *
	   * This source code is licensed under the BSD-style license found in the
	   * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	   * additional grant of patent rights can be found in the PATENTS file in
	   * the same directory.
	   */
	
	function isReference(path) {
	  return path.isReferenced() || path.parentPath.isAssignmentExpression({ left: path.node });
	}
	
	function replaceWithOrRemove(path, replacement) {
	  if (replacement) {
	    path.replaceWith(replacement);
	  } else {
	    path.remove();
	  }
	}

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(30);
	var Subscription_1 = __webpack_require__(31);
	/**
	 * @class AsyncSubject<T>
	 */
	var AsyncSubject = (function (_super) {
	    __extends(AsyncSubject, _super);
	    function AsyncSubject() {
	        _super.apply(this, arguments);
	        this.value = null;
	        this.hasNext = false;
	        this.hasCompleted = false;
	    }
	    AsyncSubject.prototype._subscribe = function (subscriber) {
	        if (this.hasError) {
	            subscriber.error(this.thrownError);
	            return Subscription_1.Subscription.EMPTY;
	        }
	        else if (this.hasCompleted && this.hasNext) {
	            subscriber.next(this.value);
	            subscriber.complete();
	            return Subscription_1.Subscription.EMPTY;
	        }
	        return _super.prototype._subscribe.call(this, subscriber);
	    };
	    AsyncSubject.prototype.next = function (value) {
	        if (!this.hasCompleted) {
	            this.value = value;
	            this.hasNext = true;
	        }
	    };
	    AsyncSubject.prototype.error = function (error) {
	        if (!this.hasCompleted) {
	            _super.prototype.error.call(this, error);
	        }
	    };
	    AsyncSubject.prototype.complete = function () {
	        this.hasCompleted = true;
	        if (this.hasNext) {
	            _super.prototype.next.call(this, this.value);
	        }
	        _super.prototype.complete.call(this);
	    };
	    return AsyncSubject;
	}(Subject_1.Subject));
	exports.AsyncSubject = AsyncSubject;
	//# sourceMappingURL=AsyncSubject.js.map

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(30);
	var queue_1 = __webpack_require__(849);
	var Subscription_1 = __webpack_require__(31);
	var observeOn_1 = __webpack_require__(350);
	var ObjectUnsubscribedError_1 = __webpack_require__(358);
	var SubjectSubscription_1 = __webpack_require__(761);
	/**
	 * @class ReplaySubject<T>
	 */
	var ReplaySubject = (function (_super) {
	    __extends(ReplaySubject, _super);
	    function ReplaySubject(bufferSize, windowTime, scheduler) {
	        if (bufferSize === void 0) { bufferSize = Number.POSITIVE_INFINITY; }
	        if (windowTime === void 0) { windowTime = Number.POSITIVE_INFINITY; }
	        _super.call(this);
	        this.scheduler = scheduler;
	        this._events = [];
	        this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
	        this._windowTime = windowTime < 1 ? 1 : windowTime;
	    }
	    ReplaySubject.prototype.next = function (value) {
	        var now = this._getNow();
	        this._events.push(new ReplayEvent(now, value));
	        this._trimBufferThenGetEvents();
	        _super.prototype.next.call(this, value);
	    };
	    ReplaySubject.prototype._subscribe = function (subscriber) {
	        var _events = this._trimBufferThenGetEvents();
	        var scheduler = this.scheduler;
	        var subscription;
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else if (this.hasError) {
	            subscription = Subscription_1.Subscription.EMPTY;
	        }
	        else if (this.isStopped) {
	            subscription = Subscription_1.Subscription.EMPTY;
	        }
	        else {
	            this.observers.push(subscriber);
	            subscription = new SubjectSubscription_1.SubjectSubscription(this, subscriber);
	        }
	        if (scheduler) {
	            subscriber.add(subscriber = new observeOn_1.ObserveOnSubscriber(subscriber, scheduler));
	        }
	        var len = _events.length;
	        for (var i = 0; i < len && !subscriber.closed; i++) {
	            subscriber.next(_events[i].value);
	        }
	        if (this.hasError) {
	            subscriber.error(this.thrownError);
	        }
	        else if (this.isStopped) {
	            subscriber.complete();
	        }
	        return subscription;
	    };
	    ReplaySubject.prototype._getNow = function () {
	        return (this.scheduler || queue_1.queue).now();
	    };
	    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
	        var now = this._getNow();
	        var _bufferSize = this._bufferSize;
	        var _windowTime = this._windowTime;
	        var _events = this._events;
	        var eventsCount = _events.length;
	        var spliceCount = 0;
	        // Trim events that fall out of the time window.
	        // Start at the front of the list. Break early once
	        // we encounter an event that falls within the window.
	        while (spliceCount < eventsCount) {
	            if ((now - _events[spliceCount].time) < _windowTime) {
	                break;
	            }
	            spliceCount++;
	        }
	        if (eventsCount > _bufferSize) {
	            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
	        }
	        if (spliceCount > 0) {
	            _events.splice(0, spliceCount);
	        }
	        return _events;
	    };
	    return ReplaySubject;
	}(Subject_1.Subject));
	exports.ReplaySubject = ReplaySubject;
	var ReplayEvent = (function () {
	    function ReplayEvent(time, value) {
	        this.time = time;
	        this.value = value;
	    }
	    return ReplayEvent;
	}());
	//# sourceMappingURL=ReplaySubject.js.map

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var FromObservable_1 = __webpack_require__(763);
	exports.from = FromObservable_1.FromObservable.create;
	//# sourceMappingURL=from.js.map

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ArrayObservable_1 = __webpack_require__(118);
	var isArray_1 = __webpack_require__(81);
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	var none = {};
	/* tslint:enable:max-line-length */
	/**
	 * Combines multiple Observables to create an Observable whose values are
	 * calculated from the latest values of each of its input Observables.
	 *
	 * <span class="informal">Whenever any input Observable emits a value, it
	 * computes a formula using the latest values from all the inputs, then emits
	 * the output of that formula.</span>
	 *
	 * <img src="./img/combineLatest.png" width="100%">
	 *
	 * `combineLatest` combines the values from this Observable with values from
	 * Observables passed as arguments. This is done by subscribing to each
	 * Observable, in order, and collecting an array of each of the most recent
	 * values any time any of the input Observables emits, then either taking that
	 * array and passing it as arguments to an optional `project` function and
	 * emitting the return value of that, or just emitting the array of recent
	 * values directly if there is no `project` function.
	 *
	 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
	 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
	 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
	 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
	 * bmi.subscribe(x => console.log('BMI is ' + x));
	 *
	 * // With output to console:
	 * // BMI is 24.212293388429753
	 * // BMI is 23.93948099205209
	 * // BMI is 23.671253629592222
	 *
	 * @see {@link combineAll}
	 * @see {@link merge}
	 * @see {@link withLatestFrom}
	 *
	 * @param {ObservableInput} other An input Observable to combine with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {function} [project] An optional function to project the values from
	 * the combined latest values into a new value on the output Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @method combineLatest
	 * @owner Observable
	 */
	function combineLatest() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    var project = null;
	    if (typeof observables[observables.length - 1] === 'function') {
	        project = observables.pop();
	    }
	    // if the first and only other argument besides the resultSelector is an array
	    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
	    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
	        observables = observables[0].slice();
	    }
	    return function (source) { return source.lift.call(new ArrayObservable_1.ArrayObservable([source].concat(observables)), new CombineLatestOperator(project)); };
	}
	exports.combineLatest = combineLatest;
	var CombineLatestOperator = (function () {
	    function CombineLatestOperator(project) {
	        this.project = project;
	    }
	    CombineLatestOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new CombineLatestSubscriber(subscriber, this.project));
	    };
	    return CombineLatestOperator;
	}());
	exports.CombineLatestOperator = CombineLatestOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var CombineLatestSubscriber = (function (_super) {
	    __extends(CombineLatestSubscriber, _super);
	    function CombineLatestSubscriber(destination, project) {
	        _super.call(this, destination);
	        this.project = project;
	        this.active = 0;
	        this.values = [];
	        this.observables = [];
	    }
	    CombineLatestSubscriber.prototype._next = function (observable) {
	        this.values.push(none);
	        this.observables.push(observable);
	    };
	    CombineLatestSubscriber.prototype._complete = function () {
	        var observables = this.observables;
	        var len = observables.length;
	        if (len === 0) {
	            this.destination.complete();
	        }
	        else {
	            this.active = len;
	            this.toRespond = len;
	            for (var i = 0; i < len; i++) {
	                var observable = observables[i];
	                this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
	            }
	        }
	    };
	    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
	        if ((this.active -= 1) === 0) {
	            this.destination.complete();
	        }
	    };
	    CombineLatestSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var values = this.values;
	        var oldVal = values[outerIndex];
	        var toRespond = !this.toRespond
	            ? 0
	            : oldVal === none ? --this.toRespond : this.toRespond;
	        values[outerIndex] = innerValue;
	        if (toRespond === 0) {
	            if (this.project) {
	                this._tryProject(values);
	            }
	            else {
	                this.destination.next(values.slice());
	            }
	        }
	    };
	    CombineLatestSubscriber.prototype._tryProject = function (values) {
	        var result;
	        try {
	            result = this.project.apply(this, values);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return CombineLatestSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.CombineLatestSubscriber = CombineLatestSubscriber;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/* tslint:enable:max-line-length */
	/**
	 * Filter items emitted by the source Observable by only emitting those that
	 * satisfy a specified predicate.
	 *
	 * <span class="informal">Like
	 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
	 * it only emits a value from the source if it passes a criterion function.</span>
	 *
	 * <img src="./img/filter.png" width="100%">
	 *
	 * Similar to the well-known `Array.prototype.filter` method, this operator
	 * takes values from the source Observable, passes them through a `predicate`
	 * function and only emits those values that yielded `true`.
	 *
	 * @example <caption>Emit only click events whose target was a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
	 * clicksOnDivs.subscribe(x => console.log(x));
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilChanged}
	 * @see {@link distinctUntilKeyChanged}
	 * @see {@link ignoreElements}
	 * @see {@link partition}
	 * @see {@link skip}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates each value emitted by the source Observable. If it returns `true`,
	 * the value is emitted, if `false` the value is not passed to the output
	 * Observable. The `index` parameter is the number `i` for the i-th source
	 * emission that has happened since the subscription, starting from the number
	 * `0`.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable} An Observable of values from the source that were
	 * allowed by the `predicate` function.
	 * @method filter
	 * @owner Observable
	 */
	function filter(predicate, thisArg) {
	    return function filterOperatorFunction(source) {
	        return source.lift(new FilterOperator(predicate, thisArg));
	    };
	}
	exports.filter = filter;
	var FilterOperator = (function () {
	    function FilterOperator(predicate, thisArg) {
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	    }
	    FilterOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
	    };
	    return FilterOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var FilterSubscriber = (function (_super) {
	    __extends(FilterSubscriber, _super);
	    function FilterSubscriber(destination, predicate, thisArg) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	        this.count = 0;
	    }
	    // the try catch block below is left specifically for
	    // optimization and perf reasons. a tryCatcher is not necessary here.
	    FilterSubscriber.prototype._next = function (value) {
	        var result;
	        try {
	            result = this.predicate.call(this.thisArg, value, this.count++);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            this.destination.next(value);
	        }
	    };
	    return FilterSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=filter.js.map

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeMap_1 = __webpack_require__(266);
	var identity_1 = __webpack_require__(855);
	/**
	 * Converts a higher-order Observable into a first-order Observable which
	 * concurrently delivers all values that are emitted on the inner Observables.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables.</span>
	 *
	 * <img src="./img/mergeAll.png" width="100%">
	 *
	 * `mergeAll` subscribes to an Observable that emits Observables, also known as
	 * a higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, it subscribes to that and delivers all the values from the
	 * inner Observable on the output Observable. The output Observable only
	 * completes once all inner Observables have completed. Any error delivered by
	 * a inner Observable will be immediately emitted on the output Observable.
	 *
	 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
	 * var firstOrder = higherOrder.mergeAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
	 * var firstOrder = higherOrder.mergeAll(2);
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link exhaust}
	 * @see {@link merge}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits values coming from all the
	 * inner Observables emitted by the source Observable.
	 * @method mergeAll
	 * @owner Observable
	 */
	function mergeAll(concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeMap_1.mergeMap(identity_1.identity, null, concurrent);
	}
	exports.mergeAll = mergeAll;
	//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var Notification_1 = __webpack_require__(264);
	/**
	 *
	 * Re-emits all notifications from source Observable with specified scheduler.
	 *
	 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
	 *
	 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
	 * notifications emitted by the source Observable. It might be useful, if you do not have control over
	 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
	 *
	 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
	 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
	 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
	 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
	 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
	 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
	 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
	 * little bit more, to ensure that they are emitted at expected moments.
	 *
	 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
	 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
	 * will delay all notifications - including error notifications - while `delay` will pass through error
	 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
	 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
	 * for notification emissions in general.
	 *
	 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
	 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
	 *                                               // with async scheduler by default...
	 *
	 * intervals
	 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
	 * .subscribe(val => {                           // scheduler to ensure smooth animation.
	 *   someDiv.style.height = val + 'px';
	 * });
	 *
	 * @see {@link delay}
	 *
	 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
	 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
	 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
	 * but with provided scheduler.
	 *
	 * @method observeOn
	 * @owner Observable
	 */
	function observeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return function observeOnOperatorFunction(source) {
	        return source.lift(new ObserveOnOperator(scheduler, delay));
	    };
	}
	exports.observeOn = observeOn;
	var ObserveOnOperator = (function () {
	    function ObserveOnOperator(scheduler, delay) {
	        if (delay === void 0) { delay = 0; }
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    ObserveOnOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
	    };
	    return ObserveOnOperator;
	}());
	exports.ObserveOnOperator = ObserveOnOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ObserveOnSubscriber = (function (_super) {
	    __extends(ObserveOnSubscriber, _super);
	    function ObserveOnSubscriber(destination, scheduler, delay) {
	        if (delay === void 0) { delay = 0; }
	        _super.call(this, destination);
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    ObserveOnSubscriber.dispatch = function (arg) {
	        var notification = arg.notification, destination = arg.destination;
	        notification.observe(destination);
	        this.unsubscribe();
	    };
	    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
	        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
	    };
	    ObserveOnSubscriber.prototype._next = function (value) {
	        this.scheduleMessage(Notification_1.Notification.createNext(value));
	    };
	    ObserveOnSubscriber.prototype._error = function (err) {
	        this.scheduleMessage(Notification_1.Notification.createError(err));
	    };
	    ObserveOnSubscriber.prototype._complete = function () {
	        this.scheduleMessage(Notification_1.Notification.createComplete());
	    };
	    return ObserveOnSubscriber;
	}(Subscriber_1.Subscriber));
	exports.ObserveOnSubscriber = ObserveOnSubscriber;
	var ObserveOnMessage = (function () {
	    function ObserveOnMessage(notification, destination) {
	        this.notification = notification;
	        this.destination = destination;
	    }
	    return ObserveOnMessage;
	}());
	exports.ObserveOnMessage = ObserveOnMessage;
	//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable, emitting values only from the most recently projected Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link switch}.</span>
	 *
	 * <img src="./img/switchMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. Each time it observes one of these
	 * inner Observables, the output Observable begins emitting the items emitted by
	 * that inner Observable. When a new inner Observable is emitted, `switchMap`
	 * stops emitting items from the earlier-emitted inner Observable and begins
	 * emitting items from the new one. It continues to behave like this for
	 * subsequent inner Observables.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link mergeMap}
	 * @see {@link switch}
	 * @see {@link switchMapTo}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and taking only the values from the most recently
	 * projected inner Observable.
	 * @method switchMap
	 * @owner Observable
	 */
	function switchMap(project, resultSelector) {
	    return function switchMapOperatorFunction(source) {
	        return source.lift(new SwitchMapOperator(project, resultSelector));
	    };
	}
	exports.switchMap = switchMap;
	var SwitchMapOperator = (function () {
	    function SwitchMapOperator(project, resultSelector) {
	        this.project = project;
	        this.resultSelector = resultSelector;
	    }
	    SwitchMapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
	    };
	    return SwitchMapOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchMapSubscriber = (function (_super) {
	    __extends(SwitchMapSubscriber, _super);
	    function SwitchMapSubscriber(destination, project, resultSelector) {
	        _super.call(this, destination);
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.index = 0;
	    }
	    SwitchMapSubscriber.prototype._next = function (value) {
	        var result;
	        var index = this.index++;
	        try {
	            result = this.project(value, index);
	        }
	        catch (error) {
	            this.destination.error(error);
	            return;
	        }
	        this._innerSub(result, value, index);
	    };
	    SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
	        var innerSubscription = this.innerSubscription;
	        if (innerSubscription) {
	            innerSubscription.unsubscribe();
	        }
	        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, result, value, index));
	    };
	    SwitchMapSubscriber.prototype._complete = function () {
	        var innerSubscription = this.innerSubscription;
	        if (!innerSubscription || innerSubscription.closed) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    SwitchMapSubscriber.prototype._unsubscribe = function () {
	        this.innerSubscription = null;
	    };
	    SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.remove(innerSub);
	        this.innerSubscription = null;
	        if (this.isStopped) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (this.resultSelector) {
	            this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            this.destination.next(innerValue);
	        }
	    };
	    SwitchMapSubscriber.prototype._tryNotifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var result;
	        try {
	            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return SwitchMapSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/* tslint:enable:max-line-length */
	/**
	 * Perform a side effect for every emission on the source Observable, but return
	 * an Observable that is identical to the source.
	 *
	 * <span class="informal">Intercepts each emission on the source and runs a
	 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
	 *
	 * <img src="./img/do.png" width="100%">
	 *
	 * Returns a mirrored Observable of the source Observable, but modified so that
	 * the provided Observer is called to perform a side effect for every value,
	 * error, and completion emitted by the source. Any errors that are thrown in
	 * the aforementioned Observer or handlers are safely sent down the error path
	 * of the output Observable.
	 *
	 * This operator is useful for debugging your Observables for the correct values
	 * or performing other side effects.
	 *
	 * Note: this is different to a `subscribe` on the Observable. If the Observable
	 * returned by `do` is not subscribed, the side effects specified by the
	 * Observer will never happen. `do` therefore simply spies on existing
	 * execution, it does not trigger an execution to happen like `subscribe` does.
	 *
	 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks
	 *   .do(ev => console.log(ev))
	 *   .map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 * @see {@link subscribe}
	 *
	 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
	 * callback for `next`.
	 * @param {function} [error] Callback for errors in the source.
	 * @param {function} [complete] Callback for the completion of the source.
	 * @return {Observable} An Observable identical to the source, but runs the
	 * specified Observer or callback(s) for each item.
	 * @name tap
	 */
	function tap(nextOrObserver, error, complete) {
	    return function tapOperatorFunction(source) {
	        return source.lift(new DoOperator(nextOrObserver, error, complete));
	    };
	}
	exports.tap = tap;
	var DoOperator = (function () {
	    function DoOperator(nextOrObserver, error, complete) {
	        this.nextOrObserver = nextOrObserver;
	        this.error = error;
	        this.complete = complete;
	    }
	    DoOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
	    };
	    return DoOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DoSubscriber = (function (_super) {
	    __extends(DoSubscriber, _super);
	    function DoSubscriber(destination, nextOrObserver, error, complete) {
	        _super.call(this, destination);
	        var safeSubscriber = new Subscriber_1.Subscriber(nextOrObserver, error, complete);
	        safeSubscriber.syncErrorThrowable = true;
	        this.add(safeSubscriber);
	        this.safeSubscriber = safeSubscriber;
	    }
	    DoSubscriber.prototype._next = function (value) {
	        var safeSubscriber = this.safeSubscriber;
	        safeSubscriber.next(value);
	        if (safeSubscriber.syncErrorThrown) {
	            this.destination.error(safeSubscriber.syncErrorValue);
	        }
	        else {
	            this.destination.next(value);
	        }
	    };
	    DoSubscriber.prototype._error = function (err) {
	        var safeSubscriber = this.safeSubscriber;
	        safeSubscriber.error(err);
	        if (safeSubscriber.syncErrorThrown) {
	            this.destination.error(safeSubscriber.syncErrorValue);
	        }
	        else {
	            this.destination.error(err);
	        }
	    };
	    DoSubscriber.prototype._complete = function () {
	        var safeSubscriber = this.safeSubscriber;
	        safeSubscriber.complete();
	        if (safeSubscriber.syncErrorThrown) {
	            this.destination.error(safeSubscriber.syncErrorValue);
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    return DoSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=tap.js.map

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	exports.defaultThrottleConfig = {
	    leading: true,
	    trailing: false
	};
	/**
	 * Emits a value from the source Observable, then ignores subsequent source
	 * values for a duration determined by another Observable, then repeats this
	 * process.
	 *
	 * <span class="informal">It's like {@link throttleTime}, but the silencing
	 * duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/throttle.png" width="100%">
	 *
	 * `throttle` emits the source Observable values on the output Observable
	 * when its internal timer is disabled, and ignores source values when the timer
	 * is enabled. Initially, the timer is disabled. As soon as the first source
	 * value arrives, it is forwarded to the output Observable, and then the timer
	 * is enabled by calling the `durationSelector` function with the source value,
	 * which returns the "duration" Observable. When the duration Observable emits a
	 * value or completes, the timer is disabled, and this process repeats for the
	 * next source value.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounce}
	 * @see {@link delayWhen}
	 * @see {@link sample}
	 * @see {@link throttleTime}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the silencing
	 * duration for each source value, returned as an Observable or a Promise.
	 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
	 * to `{ leading: true, trailing: false }`.
	 * @return {Observable<T>} An Observable that performs the throttle operation to
	 * limit the rate of emissions from the source.
	 * @method throttle
	 * @owner Observable
	 */
	function throttle(durationSelector, config) {
	    if (config === void 0) { config = exports.defaultThrottleConfig; }
	    return function (source) { return source.lift(new ThrottleOperator(durationSelector, config.leading, config.trailing)); };
	}
	exports.throttle = throttle;
	var ThrottleOperator = (function () {
	    function ThrottleOperator(durationSelector, leading, trailing) {
	        this.durationSelector = durationSelector;
	        this.leading = leading;
	        this.trailing = trailing;
	    }
	    ThrottleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
	    };
	    return ThrottleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc
	 * @ignore
	 * @extends {Ignored}
	 */
	var ThrottleSubscriber = (function (_super) {
	    __extends(ThrottleSubscriber, _super);
	    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.durationSelector = durationSelector;
	        this._leading = _leading;
	        this._trailing = _trailing;
	        this._hasTrailingValue = false;
	    }
	    ThrottleSubscriber.prototype._next = function (value) {
	        if (this.throttled) {
	            if (this._trailing) {
	                this._hasTrailingValue = true;
	                this._trailingValue = value;
	            }
	        }
	        else {
	            var duration = this.tryDurationSelector(value);
	            if (duration) {
	                this.add(this.throttled = subscribeToResult_1.subscribeToResult(this, duration));
	            }
	            if (this._leading) {
	                this.destination.next(value);
	                if (this._trailing) {
	                    this._hasTrailingValue = true;
	                    this._trailingValue = value;
	                }
	            }
	        }
	    };
	    ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
	        try {
	            return this.durationSelector(value);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return null;
	        }
	    };
	    ThrottleSubscriber.prototype._unsubscribe = function () {
	        var _a = this, throttled = _a.throttled, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue, _trailing = _a._trailing;
	        this._trailingValue = null;
	        this._hasTrailingValue = false;
	        if (throttled) {
	            this.remove(throttled);
	            this.throttled = null;
	            throttled.unsubscribe();
	        }
	    };
	    ThrottleSubscriber.prototype._sendTrailing = function () {
	        var _a = this, destination = _a.destination, throttled = _a.throttled, _trailing = _a._trailing, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue;
	        if (throttled && _trailing && _hasTrailingValue) {
	            destination.next(_trailingValue);
	            this._trailingValue = null;
	            this._hasTrailingValue = false;
	        }
	    };
	    ThrottleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this._sendTrailing();
	        this._unsubscribe();
	    };
	    ThrottleSubscriber.prototype.notifyComplete = function () {
	        this._sendTrailing();
	        this._unsubscribe();
	    };
	    return ThrottleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=throttle.js.map

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ArrayObservable_1 = __webpack_require__(118);
	var isArray_1 = __webpack_require__(81);
	var Subscriber_1 = __webpack_require__(11);
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	var iterator_1 = __webpack_require__(270);
	/* tslint:enable:max-line-length */
	/**
	 * @param observables
	 * @return {Observable<R>}
	 * @method zip
	 * @owner Observable
	 */
	function zip() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return function zipOperatorFunction(source) {
	        return source.lift.call(zipStatic.apply(void 0, [source].concat(observables)));
	    };
	}
	exports.zip = zip;
	/* tslint:enable:max-line-length */
	/**
	 * Combines multiple Observables to create an Observable whose values are calculated from the values, in order, of each
	 * of its input Observables.
	 *
	 * If the latest parameter is a function, this function is used to compute the created value from the input values.
	 * Otherwise, an array of the input values is returned.
	 *
	 * @example <caption>Combine age and name from different sources</caption>
	 *
	 * let age$ = Observable.of<number>(27, 25, 29);
	 * let name$ = Observable.of<string>('Foo', 'Bar', 'Beer');
	 * let isDev$ = Observable.of<boolean>(true, true, false);
	 *
	 * Observable
	 *     .zip(age$,
	 *          name$,
	 *          isDev$,
	 *          (age: number, name: string, isDev: boolean) => ({ age, name, isDev }))
	 *     .subscribe(x => console.log(x));
	 *
	 * // outputs
	 * // { age: 27, name: 'Foo', isDev: true }
	 * // { age: 25, name: 'Bar', isDev: true }
	 * // { age: 29, name: 'Beer', isDev: false }
	 *
	 * @param observables
	 * @return {Observable<R>}
	 * @static true
	 * @name zip
	 * @owner Observable
	 */
	function zipStatic() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    var project = observables[observables.length - 1];
	    if (typeof project === 'function') {
	        observables.pop();
	    }
	    return new ArrayObservable_1.ArrayObservable(observables).lift(new ZipOperator(project));
	}
	exports.zipStatic = zipStatic;
	var ZipOperator = (function () {
	    function ZipOperator(project) {
	        this.project = project;
	    }
	    ZipOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ZipSubscriber(subscriber, this.project));
	    };
	    return ZipOperator;
	}());
	exports.ZipOperator = ZipOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ZipSubscriber = (function (_super) {
	    __extends(ZipSubscriber, _super);
	    function ZipSubscriber(destination, project, values) {
	        if (values === void 0) { values = Object.create(null); }
	        _super.call(this, destination);
	        this.iterators = [];
	        this.active = 0;
	        this.project = (typeof project === 'function') ? project : null;
	        this.values = values;
	    }
	    ZipSubscriber.prototype._next = function (value) {
	        var iterators = this.iterators;
	        if (isArray_1.isArray(value)) {
	            iterators.push(new StaticArrayIterator(value));
	        }
	        else if (typeof value[iterator_1.iterator] === 'function') {
	            iterators.push(new StaticIterator(value[iterator_1.iterator]()));
	        }
	        else {
	            iterators.push(new ZipBufferIterator(this.destination, this, value));
	        }
	    };
	    ZipSubscriber.prototype._complete = function () {
	        var iterators = this.iterators;
	        var len = iterators.length;
	        if (len === 0) {
	            this.destination.complete();
	            return;
	        }
	        this.active = len;
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            if (iterator.stillUnsubscribed) {
	                this.add(iterator.subscribe(iterator, i));
	            }
	            else {
	                this.active--; // not an observable
	            }
	        }
	    };
	    ZipSubscriber.prototype.notifyInactive = function () {
	        this.active--;
	        if (this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    ZipSubscriber.prototype.checkIterators = function () {
	        var iterators = this.iterators;
	        var len = iterators.length;
	        var destination = this.destination;
	        // abort if not all of them have values
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
	                return;
	            }
	        }
	        var shouldComplete = false;
	        var args = [];
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            var result = iterator.next();
	            // check to see if it's completed now that you've gotten
	            // the next value.
	            if (iterator.hasCompleted()) {
	                shouldComplete = true;
	            }
	            if (result.done) {
	                destination.complete();
	                return;
	            }
	            args.push(result.value);
	        }
	        if (this.project) {
	            this._tryProject(args);
	        }
	        else {
	            destination.next(args);
	        }
	        if (shouldComplete) {
	            destination.complete();
	        }
	    };
	    ZipSubscriber.prototype._tryProject = function (args) {
	        var result;
	        try {
	            result = this.project.apply(this, args);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return ZipSubscriber;
	}(Subscriber_1.Subscriber));
	exports.ZipSubscriber = ZipSubscriber;
	var StaticIterator = (function () {
	    function StaticIterator(iterator) {
	        this.iterator = iterator;
	        this.nextResult = iterator.next();
	    }
	    StaticIterator.prototype.hasValue = function () {
	        return true;
	    };
	    StaticIterator.prototype.next = function () {
	        var result = this.nextResult;
	        this.nextResult = this.iterator.next();
	        return result;
	    };
	    StaticIterator.prototype.hasCompleted = function () {
	        var nextResult = this.nextResult;
	        return nextResult && nextResult.done;
	    };
	    return StaticIterator;
	}());
	var StaticArrayIterator = (function () {
	    function StaticArrayIterator(array) {
	        this.array = array;
	        this.index = 0;
	        this.length = 0;
	        this.length = array.length;
	    }
	    StaticArrayIterator.prototype[iterator_1.iterator] = function () {
	        return this;
	    };
	    StaticArrayIterator.prototype.next = function (value) {
	        var i = this.index++;
	        var array = this.array;
	        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
	    };
	    StaticArrayIterator.prototype.hasValue = function () {
	        return this.array.length > this.index;
	    };
	    StaticArrayIterator.prototype.hasCompleted = function () {
	        return this.array.length === this.index;
	    };
	    return StaticArrayIterator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ZipBufferIterator = (function (_super) {
	    __extends(ZipBufferIterator, _super);
	    function ZipBufferIterator(destination, parent, observable) {
	        _super.call(this, destination);
	        this.parent = parent;
	        this.observable = observable;
	        this.stillUnsubscribed = true;
	        this.buffer = [];
	        this.isComplete = false;
	    }
	    ZipBufferIterator.prototype[iterator_1.iterator] = function () {
	        return this;
	    };
	    // NOTE: there is actually a name collision here with Subscriber.next and Iterator.next
	    //    this is legit because `next()` will never be called by a subscription in this case.
	    ZipBufferIterator.prototype.next = function () {
	        var buffer = this.buffer;
	        if (buffer.length === 0 && this.isComplete) {
	            return { value: null, done: true };
	        }
	        else {
	            return { value: buffer.shift(), done: false };
	        }
	    };
	    ZipBufferIterator.prototype.hasValue = function () {
	        return this.buffer.length > 0;
	    };
	    ZipBufferIterator.prototype.hasCompleted = function () {
	        return this.buffer.length === 0 && this.isComplete;
	    };
	    ZipBufferIterator.prototype.notifyComplete = function () {
	        if (this.buffer.length > 0) {
	            this.isComplete = true;
	            this.parent.notifyInactive();
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    ZipBufferIterator.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.buffer.push(innerValue);
	        this.parent.checkIterators();
	    };
	    ZipBufferIterator.prototype.subscribe = function (value, index) {
	        return subscribeToResult_1.subscribeToResult(this, this.observable, this, index);
	    };
	    return ZipBufferIterator;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(39);
	function getSymbolObservable(context) {
	    var $$observable;
	    var Symbol = context.Symbol;
	    if (typeof Symbol === 'function') {
	        if (Symbol.observable) {
	            $$observable = Symbol.observable;
	        }
	        else {
	            $$observable = Symbol('observable');
	            Symbol.observable = $$observable;
	        }
	    }
	    else {
	        $$observable = '@@observable';
	    }
	    return $$observable;
	}
	exports.getSymbolObservable = getSymbolObservable;
	exports.observable = getSymbolObservable(root_1.root);
	/**
	 * @deprecated use observable instead
	 */
	exports.$$observable = exports.observable;
	//# sourceMappingURL=observable.js.map

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(39);
	var Symbol = root_1.root.Symbol;
	exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
	    Symbol.for('rxSubscriber') : '@@rxSubscriber';
	/**
	 * @deprecated use rxSubscriber instead
	 */
	exports.$$rxSubscriber = exports.rxSubscriber;
	//# sourceMappingURL=rxSubscriber.js.map

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when an Observable or a sequence was queried but has no
	 * elements.
	 *
	 * @see {@link first}
	 * @see {@link last}
	 * @see {@link single}
	 *
	 * @class EmptyError
	 */
	var EmptyError = (function (_super) {
	    __extends(EmptyError, _super);
	    function EmptyError() {
	        var err = _super.call(this, 'no elements in sequence');
	        this.name = err.name = 'EmptyError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return EmptyError;
	}(Error));
	exports.EmptyError = EmptyError;
	//# sourceMappingURL=EmptyError.js.map

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when an action is invalid because the object has been
	 * unsubscribed.
	 *
	 * @see {@link Subject}
	 * @see {@link BehaviorSubject}
	 *
	 * @class ObjectUnsubscribedError
	 */
	var ObjectUnsubscribedError = (function (_super) {
	    __extends(ObjectUnsubscribedError, _super);
	    function ObjectUnsubscribedError() {
	        var err = _super.call(this, 'object unsubscribed');
	        this.name = err.name = 'ObjectUnsubscribedError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return ObjectUnsubscribedError;
	}(Error));
	exports.ObjectUnsubscribedError = ObjectUnsubscribedError;
	//# sourceMappingURL=ObjectUnsubscribedError.js.map

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	"use strict";
	function isDate(value) {
	    return value instanceof Date && !isNaN(+value);
	}
	exports.isDate = isDate;
	//# sourceMappingURL=isDate.js.map

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	"use strict";
	function isFunction(x) {
	    return typeof x === 'function';
	}
	exports.isFunction = isFunction;
	//# sourceMappingURL=isFunction.js.map

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(4759);
	// On some exotic environments, it's not clear which object `setimmeidate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1040), __esModule: true };

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1045), __esModule: true };

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(960);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _keys = __webpack_require__(90);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _create = __webpack_require__(82);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _map = __webpack_require__(548);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _includes = __webpack_require__(330);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _repeat = __webpack_require__(4341);
	
	var _repeat2 = _interopRequireDefault(_repeat);
	
	var _renamer = __webpack_require__(988);
	
	var _renamer2 = _interopRequireDefault(_renamer);
	
	var _index = __webpack_require__(91);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _defaults = __webpack_require__(470);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	var _babelMessages = __webpack_require__(284);
	
	var messages = _interopRequireWildcard(_babelMessages);
	
	var _binding2 = __webpack_require__(552);
	
	var _binding3 = _interopRequireDefault(_binding2);
	
	var _globals = __webpack_require__(2724);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	var _cache = __webpack_require__(285);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _crawlCallsCount = 0;
	
	function getCache(path, parentScope, self) {
	  var scopes = _cache.scope.get(path.node) || [];
	
	  for (var _iterator = scopes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var scope = _ref;
	
	    if (scope.parent === parentScope && scope.path === path) return scope;
	  }
	
	  scopes.push(self);
	
	  if (!_cache.scope.has(path.node)) {
	    _cache.scope.set(path.node, scopes);
	  }
	}
	
	function gatherNodeParts(node, parts) {
	  if (t.isModuleDeclaration(node)) {
	    if (node.source) {
	      gatherNodeParts(node.source, parts);
	    } else if (node.specifiers && node.specifiers.length) {
	      for (var _iterator2 = node.specifiers, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	        var _ref2;
	
	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }
	
	        var specifier = _ref2;
	
	        gatherNodeParts(specifier, parts);
	      }
	    } else if (node.declaration) {
	      gatherNodeParts(node.declaration, parts);
	    }
	  } else if (t.isModuleSpecifier(node)) {
	    gatherNodeParts(node.local, parts);
	  } else if (t.isMemberExpression(node)) {
	    gatherNodeParts(node.object, parts);
	    gatherNodeParts(node.property, parts);
	  } else if (t.isIdentifier(node)) {
	    parts.push(node.name);
	  } else if (t.isLiteral(node)) {
	    parts.push(node.value);
	  } else if (t.isCallExpression(node)) {
	    gatherNodeParts(node.callee, parts);
	  } else if (t.isObjectExpression(node) || t.isObjectPattern(node)) {
	    for (var _iterator3 = node.properties, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
	      var _ref3;
	
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }
	
	      var prop = _ref3;
	
	      gatherNodeParts(prop.key || prop.argument, parts);
	    }
	  }
	}
	
	var collectorVisitor = {
	  For: function For(path) {
	    for (var _iterator4 = t.FOR_INIT_KEYS, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
	      var _ref4;
	
	      if (_isArray4) {
	        if (_i4 >= _iterator4.length) break;
	        _ref4 = _iterator4[_i4++];
	      } else {
	        _i4 = _iterator4.next();
	        if (_i4.done) break;
	        _ref4 = _i4.value;
	      }
	
	      var key = _ref4;
	
	      var declar = path.get(key);
	      if (declar.isVar()) path.scope.getFunctionParent().registerBinding("var", declar);
	    }
	  },
	  Declaration: function Declaration(path) {
	    if (path.isBlockScoped()) return;
	
	    if (path.isExportDeclaration() && path.get("declaration").isDeclaration()) return;
	
	    path.scope.getFunctionParent().registerDeclaration(path);
	  },
	  ReferencedIdentifier: function ReferencedIdentifier(path, state) {
	    state.references.push(path);
	  },
	  ForXStatement: function ForXStatement(path, state) {
	    var left = path.get("left");
	    if (left.isPattern() || left.isIdentifier()) {
	      state.constantViolations.push(left);
	    }
	  },
	
	
	  ExportDeclaration: {
	    exit: function exit(path) {
	      var node = path.node,
	          scope = path.scope;
	
	      var declar = node.declaration;
	      if (t.isClassDeclaration(declar) || t.isFunctionDeclaration(declar)) {
	        var _id = declar.id;
	        if (!_id) return;
	
	        var binding = scope.getBinding(_id.name);
	        if (binding) binding.reference(path);
	      } else if (t.isVariableDeclaration(declar)) {
	        for (var _iterator5 = declar.declarations, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : (0, _getIterator3.default)(_iterator5);;) {
	          var _ref5;
	
	          if (_isArray5) {
	            if (_i5 >= _iterator5.length) break;
	            _ref5 = _iterator5[_i5++];
	          } else {
	            _i5 = _iterator5.next();
	            if (_i5.done) break;
	            _ref5 = _i5.value;
	          }
	
	          var decl = _ref5;
	
	          var ids = t.getBindingIdentifiers(decl);
	          for (var name in ids) {
	            var _binding = scope.getBinding(name);
	            if (_binding) _binding.reference(path);
	          }
	        }
	      }
	    }
	  },
	
	  LabeledStatement: function LabeledStatement(path) {
	    path.scope.getProgramParent().addGlobal(path.node);
	    path.scope.getBlockParent().registerDeclaration(path);
	  },
	  AssignmentExpression: function AssignmentExpression(path, state) {
	    state.assignments.push(path);
	  },
	  UpdateExpression: function UpdateExpression(path, state) {
	    state.constantViolations.push(path.get("argument"));
	  },
	  UnaryExpression: function UnaryExpression(path, state) {
	    if (path.node.operator === "delete") {
	      state.constantViolations.push(path.get("argument"));
	    }
	  },
	  BlockScoped: function BlockScoped(path) {
	    var scope = path.scope;
	    if (scope.path === path) scope = scope.parent;
	    scope.getBlockParent().registerDeclaration(path);
	  },
	  ClassDeclaration: function ClassDeclaration(path) {
	    var id = path.node.id;
	    if (!id) return;
	
	    var name = id.name;
	    path.scope.bindings[name] = path.scope.getBinding(name);
	  },
	  Block: function Block(path) {
	    var paths = path.get("body");
	    for (var _iterator6 = paths, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : (0, _getIterator3.default)(_iterator6);;) {
	      var _ref6;
	
	      if (_isArray6) {
	        if (_i6 >= _iterator6.length) break;
	        _ref6 = _iterator6[_i6++];
	      } else {
	        _i6 = _iterator6.next();
	        if (_i6.done) break;
	        _ref6 = _i6.value;
	      }
	
	      var bodyPath = _ref6;
	
	      if (bodyPath.isFunctionDeclaration()) {
	        path.scope.getBlockParent().registerDeclaration(bodyPath);
	      }
	    }
	  }
	};
	
	var uid = 0;
	
	var Scope = function () {
	  function Scope(path, parentScope) {
	    (0, _classCallCheck3.default)(this, Scope);
	
	    if (parentScope && parentScope.block === path.node) {
	      return parentScope;
	    }
	
	    var cached = getCache(path, parentScope, this);
	    if (cached) return cached;
	
	    this.uid = uid++;
	    this.parent = parentScope;
	    this.hub = path.hub;
	
	    this.parentBlock = path.parent;
	    this.block = path.node;
	    this.path = path;
	
	    this.labels = new _map2.default();
	  }
	
	  Scope.prototype.traverse = function traverse(node, opts, state) {
	    (0, _index2.default)(node, opts, this, state, this.path);
	  };
	
	  Scope.prototype.generateDeclaredUidIdentifier = function generateDeclaredUidIdentifier() {
	    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "temp";
	
	    var id = this.generateUidIdentifier(name);
	    this.push({ id: id });
	    return id;
	  };
	
	  Scope.prototype.generateUidIdentifier = function generateUidIdentifier() {
	    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "temp";
	
	    return t.identifier(this.generateUid(name));
	  };
	
	  Scope.prototype.generateUid = function generateUid() {
	    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "temp";
	
	    name = t.toIdentifier(name).replace(/^_+/, "").replace(/[0-9]+$/g, "");
	
	    var uid = void 0;
	    var i = 0;
	    do {
	      uid = this._generateUid(name, i);
	      i++;
	    } while (this.hasLabel(uid) || this.hasBinding(uid) || this.hasGlobal(uid) || this.hasReference(uid));
	
	    var program = this.getProgramParent();
	    program.references[uid] = true;
	    program.uids[uid] = true;
	
	    return uid;
	  };
	
	  Scope.prototype._generateUid = function _generateUid(name, i) {
	    var id = name;
	    if (i > 1) id += i;
	    return "_" + id;
	  };
	
	  Scope.prototype.generateUidIdentifierBasedOnNode = function generateUidIdentifierBasedOnNode(parent, defaultName) {
	    var node = parent;
	
	    if (t.isAssignmentExpression(parent)) {
	      node = parent.left;
	    } else if (t.isVariableDeclarator(parent)) {
	      node = parent.id;
	    } else if (t.isObjectProperty(node) || t.isObjectMethod(node)) {
	      node = node.key;
	    }
	
	    var parts = [];
	    gatherNodeParts(node, parts);
	
	    var id = parts.join("$");
	    id = id.replace(/^_/, "") || defaultName || "ref";
	
	    return this.generateUidIdentifier(id.slice(0, 20));
	  };
	
	  Scope.prototype.isStatic = function isStatic(node) {
	    if (t.isThisExpression(node) || t.isSuper(node)) {
	      return true;
	    }
	
	    if (t.isIdentifier(node)) {
	      var binding = this.getBinding(node.name);
	      if (binding) {
	        return binding.constant;
	      } else {
	        return this.hasBinding(node.name);
	      }
	    }
	
	    return false;
	  };
	
	  Scope.prototype.maybeGenerateMemoised = function maybeGenerateMemoised(node, dontPush) {
	    if (this.isStatic(node)) {
	      return null;
	    } else {
	      var _id2 = this.generateUidIdentifierBasedOnNode(node);
	      if (!dontPush) this.push({ id: _id2 });
	      return _id2;
	    }
	  };
	
	  Scope.prototype.checkBlockScopedCollisions = function checkBlockScopedCollisions(local, kind, name, id) {
	    if (kind === "param") return;
	
	    if (kind === "hoisted" && local.kind === "let") return;
	
	    var duplicate = kind === "let" || local.kind === "let" || local.kind === "const" || local.kind === "module" || local.kind === "param" && (kind === "let" || kind === "const");
	
	    if (duplicate) {
	      throw this.hub.file.buildCodeFrameError(id, messages.get("scopeDuplicateDeclaration", name), TypeError);
	    }
	  };
	
	  Scope.prototype.rename = function rename(oldName, newName, block) {
	    var binding = this.getBinding(oldName);
	    if (binding) {
	      newName = newName || this.generateUidIdentifier(oldName).name;
	      return new _renamer2.default(binding, oldName, newName).rename(block);
	    }
	  };
	
	  Scope.prototype._renameFromMap = function _renameFromMap(map, oldName, newName, value) {
	    if (map[oldName]) {
	      map[newName] = value;
	      map[oldName] = null;
	    }
	  };
	
	  Scope.prototype.dump = function dump() {
	    var sep = (0, _repeat2.default)("-", 60);
	    console.log(sep);
	    var scope = this;
	    do {
	      console.log("#", scope.block.type);
	      for (var name in scope.bindings) {
	        var binding = scope.bindings[name];
	        console.log(" -", name, {
	          constant: binding.constant,
	          references: binding.references,
	          violations: binding.constantViolations.length,
	          kind: binding.kind
	        });
	      }
	    } while (scope = scope.parent);
	    console.log(sep);
	  };
	
	  Scope.prototype.toArray = function toArray(node, i) {
	    var file = this.hub.file;
	
	    if (t.isIdentifier(node)) {
	      var binding = this.getBinding(node.name);
	      if (binding && binding.constant && binding.path.isGenericType("Array")) return node;
	    }
	
	    if (t.isArrayExpression(node)) {
	      return node;
	    }
	
	    if (t.isIdentifier(node, { name: "arguments" })) {
	      return t.callExpression(t.memberExpression(t.memberExpression(t.memberExpression(t.identifier("Array"), t.identifier("prototype")), t.identifier("slice")), t.identifier("call")), [node]);
	    }
	
	    var helperName = "toArray";
	    var args = [node];
	    if (i === true) {
	      helperName = "toConsumableArray";
	    } else if (i) {
	      args.push(t.numericLiteral(i));
	      helperName = "slicedToArray";
	    }
	    return t.callExpression(file.addHelper(helperName), args);
	  };
	
	  Scope.prototype.hasLabel = function hasLabel(name) {
	    return !!this.getLabel(name);
	  };
	
	  Scope.prototype.getLabel = function getLabel(name) {
	    return this.labels.get(name);
	  };
	
	  Scope.prototype.registerLabel = function registerLabel(path) {
	    this.labels.set(path.node.label.name, path);
	  };
	
	  Scope.prototype.registerDeclaration = function registerDeclaration(path) {
	    if (path.isLabeledStatement()) {
	      this.registerLabel(path);
	    } else if (path.isFunctionDeclaration()) {
	      this.registerBinding("hoisted", path.get("id"), path);
	    } else if (path.isVariableDeclaration()) {
	      var declarations = path.get("declarations");
	      for (var _iterator7 = declarations, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : (0, _getIterator3.default)(_iterator7);;) {
	        var _ref7;
	
	        if (_isArray7) {
	          if (_i7 >= _iterator7.length) break;
	          _ref7 = _iterator7[_i7++];
	        } else {
	          _i7 = _iterator7.next();
	          if (_i7.done) break;
	          _ref7 = _i7.value;
	        }
	
	        var declar = _ref7;
	
	        this.registerBinding(path.node.kind, declar);
	      }
	    } else if (path.isClassDeclaration()) {
	      this.registerBinding("let", path);
	    } else if (path.isImportDeclaration()) {
	      var specifiers = path.get("specifiers");
	      for (var _iterator8 = specifiers, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : (0, _getIterator3.default)(_iterator8);;) {
	        var _ref8;
	
	        if (_isArray8) {
	          if (_i8 >= _iterator8.length) break;
	          _ref8 = _iterator8[_i8++];
	        } else {
	          _i8 = _iterator8.next();
	          if (_i8.done) break;
	          _ref8 = _i8.value;
	        }
	
	        var specifier = _ref8;
	
	        this.registerBinding("module", specifier);
	      }
	    } else if (path.isExportDeclaration()) {
	      var _declar = path.get("declaration");
	      if (_declar.isClassDeclaration() || _declar.isFunctionDeclaration() || _declar.isVariableDeclaration()) {
	        this.registerDeclaration(_declar);
	      }
	    } else {
	      this.registerBinding("unknown", path);
	    }
	  };
	
	  Scope.prototype.buildUndefinedNode = function buildUndefinedNode() {
	    if (this.hasBinding("undefined")) {
	      return t.unaryExpression("void", t.numericLiteral(0), true);
	    } else {
	      return t.identifier("undefined");
	    }
	  };
	
	  Scope.prototype.registerConstantViolation = function registerConstantViolation(path) {
	    var ids = path.getBindingIdentifiers();
	    for (var name in ids) {
	      var binding = this.getBinding(name);
	      if (binding) binding.reassign(path);
	    }
	  };
	
	  Scope.prototype.registerBinding = function registerBinding(kind, path) {
	    var bindingPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : path;
	
	    if (!kind) throw new ReferenceError("no `kind`");
	
	    if (path.isVariableDeclaration()) {
	      var declarators = path.get("declarations");
	      for (var _iterator9 = declarators, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : (0, _getIterator3.default)(_iterator9);;) {
	        var _ref9;
	
	        if (_isArray9) {
	          if (_i9 >= _iterator9.length) break;
	          _ref9 = _iterator9[_i9++];
	        } else {
	          _i9 = _iterator9.next();
	          if (_i9.done) break;
	          _ref9 = _i9.value;
	        }
	
	        var declar = _ref9;
	
	        this.registerBinding(kind, declar);
	      }
	      return;
	    }
	
	    var parent = this.getProgramParent();
	    var ids = path.getBindingIdentifiers(true);
	
	    for (var name in ids) {
	      for (var _iterator10 = ids[name], _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : (0, _getIterator3.default)(_iterator10);;) {
	        var _ref10;
	
	        if (_isArray10) {
	          if (_i10 >= _iterator10.length) break;
	          _ref10 = _iterator10[_i10++];
	        } else {
	          _i10 = _iterator10.next();
	          if (_i10.done) break;
	          _ref10 = _i10.value;
	        }
	
	        var _id3 = _ref10;
	
	        var local = this.getOwnBinding(name);
	        if (local) {
	          if (local.identifier === _id3) continue;
	
	          this.checkBlockScopedCollisions(local, kind, name, _id3);
	        }
	
	        if (local && local.path.isFlow()) local = null;
	
	        parent.references[name] = true;
	
	        this.bindings[name] = new _binding3.default({
	          identifier: _id3,
	          existing: local,
	          scope: this,
	          path: bindingPath,
	          kind: kind
	        });
	      }
	    }
	  };
	
	  Scope.prototype.addGlobal = function addGlobal(node) {
	    this.globals[node.name] = node;
	  };
	
	  Scope.prototype.hasUid = function hasUid(name) {
	    var scope = this;
	
	    do {
	      if (scope.uids[name]) return true;
	    } while (scope = scope.parent);
	
	    return false;
	  };
	
	  Scope.prototype.hasGlobal = function hasGlobal(name) {
	    var scope = this;
	
	    do {
	      if (scope.globals[name]) return true;
	    } while (scope = scope.parent);
	
	    return false;
	  };
	
	  Scope.prototype.hasReference = function hasReference(name) {
	    var scope = this;
	
	    do {
	      if (scope.references[name]) return true;
	    } while (scope = scope.parent);
	
	    return false;
	  };
	
	  Scope.prototype.isPure = function isPure(node, constantsOnly) {
	    if (t.isIdentifier(node)) {
	      var binding = this.getBinding(node.name);
	      if (!binding) return false;
	      if (constantsOnly) return binding.constant;
	      return true;
	    } else if (t.isClass(node)) {
	      if (node.superClass && !this.isPure(node.superClass, constantsOnly)) return false;
	      return this.isPure(node.body, constantsOnly);
	    } else if (t.isClassBody(node)) {
	      for (var _iterator11 = node.body, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : (0, _getIterator3.default)(_iterator11);;) {
	        var _ref11;
	
	        if (_isArray11) {
	          if (_i11 >= _iterator11.length) break;
	          _ref11 = _iterator11[_i11++];
	        } else {
	          _i11 = _iterator11.next();
	          if (_i11.done) break;
	          _ref11 = _i11.value;
	        }
	
	        var method = _ref11;
	
	        if (!this.isPure(method, constantsOnly)) return false;
	      }
	      return true;
	    } else if (t.isBinary(node)) {
	      return this.isPure(node.left, constantsOnly) && this.isPure(node.right, constantsOnly);
	    } else if (t.isArrayExpression(node)) {
	      for (var _iterator12 = node.elements, _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : (0, _getIterator3.default)(_iterator12);;) {
	        var _ref12;
	
	        if (_isArray12) {
	          if (_i12 >= _iterator12.length) break;
	          _ref12 = _iterator12[_i12++];
	        } else {
	          _i12 = _iterator12.next();
	          if (_i12.done) break;
	          _ref12 = _i12.value;
	        }
	
	        var elem = _ref12;
	
	        if (!this.isPure(elem, constantsOnly)) return false;
	      }
	      return true;
	    } else if (t.isObjectExpression(node)) {
	      for (var _iterator13 = node.properties, _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : (0, _getIterator3.default)(_iterator13);;) {
	        var _ref13;
	
	        if (_isArray13) {
	          if (_i13 >= _iterator13.length) break;
	          _ref13 = _iterator13[_i13++];
	        } else {
	          _i13 = _iterator13.next();
	          if (_i13.done) break;
	          _ref13 = _i13.value;
	        }
	
	        var prop = _ref13;
	
	        if (!this.isPure(prop, constantsOnly)) return false;
	      }
	      return true;
	    } else if (t.isClassMethod(node)) {
	      if (node.computed && !this.isPure(node.key, constantsOnly)) return false;
	      if (node.kind === "get" || node.kind === "set") return false;
	      return true;
	    } else if (t.isClassProperty(node) || t.isObjectProperty(node)) {
	      if (node.computed && !this.isPure(node.key, constantsOnly)) return false;
	      return this.isPure(node.value, constantsOnly);
	    } else if (t.isUnaryExpression(node)) {
	      return this.isPure(node.argument, constantsOnly);
	    } else {
	      return t.isPureish(node);
	    }
	  };
	
	  Scope.prototype.setData = function setData(key, val) {
	    return this.data[key] = val;
	  };
	
	  Scope.prototype.getData = function getData(key) {
	    var scope = this;
	    do {
	      var data = scope.data[key];
	      if (data != null) return data;
	    } while (scope = scope.parent);
	  };
	
	  Scope.prototype.removeData = function removeData(key) {
	    var scope = this;
	    do {
	      var data = scope.data[key];
	      if (data != null) scope.data[key] = null;
	    } while (scope = scope.parent);
	  };
	
	  Scope.prototype.init = function init() {
	    if (!this.references) this.crawl();
	  };
	
	  Scope.prototype.crawl = function crawl() {
	    _crawlCallsCount++;
	    this._crawl();
	    _crawlCallsCount--;
	  };
	
	  Scope.prototype._crawl = function _crawl() {
	    var path = this.path;
	
	    this.references = (0, _create2.default)(null);
	    this.bindings = (0, _create2.default)(null);
	    this.globals = (0, _create2.default)(null);
	    this.uids = (0, _create2.default)(null);
	    this.data = (0, _create2.default)(null);
	
	    if (path.isLoop()) {
	      for (var _iterator14 = t.FOR_INIT_KEYS, _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : (0, _getIterator3.default)(_iterator14);;) {
	        var _ref14;
	
	        if (_isArray14) {
	          if (_i14 >= _iterator14.length) break;
	          _ref14 = _iterator14[_i14++];
	        } else {
	          _i14 = _iterator14.next();
	          if (_i14.done) break;
	          _ref14 = _i14.value;
	        }
	
	        var key = _ref14;
	
	        var node = path.get(key);
	        if (node.isBlockScoped()) this.registerBinding(node.node.kind, node);
	      }
	    }
	
	    if (path.isFunctionExpression() && path.has("id")) {
	      if (!path.get("id").node[t.NOT_LOCAL_BINDING]) {
	        this.registerBinding("local", path.get("id"), path);
	      }
	    }
	
	    if (path.isClassExpression() && path.has("id")) {
	      if (!path.get("id").node[t.NOT_LOCAL_BINDING]) {
	        this.registerBinding("local", path);
	      }
	    }
	
	    if (path.isFunction()) {
	      var params = path.get("params");
	      for (var _iterator15 = params, _isArray15 = Array.isArray(_iterator15), _i15 = 0, _iterator15 = _isArray15 ? _iterator15 : (0, _getIterator3.default)(_iterator15);;) {
	        var _ref15;
	
	        if (_isArray15) {
	          if (_i15 >= _iterator15.length) break;
	          _ref15 = _iterator15[_i15++];
	        } else {
	          _i15 = _iterator15.next();
	          if (_i15.done) break;
	          _ref15 = _i15.value;
	        }
	
	        var param = _ref15;
	
	        this.registerBinding("param", param);
	      }
	    }
	
	    if (path.isCatchClause()) {
	      this.registerBinding("let", path);
	    }
	
	    var parent = this.getProgramParent();
	    if (parent.crawling) return;
	
	    var state = {
	      references: [],
	      constantViolations: [],
	      assignments: []
	    };
	
	    this.crawling = true;
	    path.traverse(collectorVisitor, state);
	    this.crawling = false;
	
	    for (var _iterator16 = state.assignments, _isArray16 = Array.isArray(_iterator16), _i16 = 0, _iterator16 = _isArray16 ? _iterator16 : (0, _getIterator3.default)(_iterator16);;) {
	      var _ref16;
	
	      if (_isArray16) {
	        if (_i16 >= _iterator16.length) break;
	        _ref16 = _iterator16[_i16++];
	      } else {
	        _i16 = _iterator16.next();
	        if (_i16.done) break;
	        _ref16 = _i16.value;
	      }
	
	      var _path = _ref16;
	
	      var ids = _path.getBindingIdentifiers();
	      var programParent = void 0;
	      for (var name in ids) {
	        if (_path.scope.getBinding(name)) continue;
	
	        programParent = programParent || _path.scope.getProgramParent();
	        programParent.addGlobal(ids[name]);
	      }
	
	      _path.scope.registerConstantViolation(_path);
	    }
	
	    for (var _iterator17 = state.references, _isArray17 = Array.isArray(_iterator17), _i17 = 0, _iterator17 = _isArray17 ? _iterator17 : (0, _getIterator3.default)(_iterator17);;) {
	      var _ref17;
	
	      if (_isArray17) {
	        if (_i17 >= _iterator17.length) break;
	        _ref17 = _iterator17[_i17++];
	      } else {
	        _i17 = _iterator17.next();
	        if (_i17.done) break;
	        _ref17 = _i17.value;
	      }
	
	      var ref = _ref17;
	
	      var binding = ref.scope.getBinding(ref.node.name);
	      if (binding) {
	        binding.reference(ref);
	      } else {
	        ref.scope.getProgramParent().addGlobal(ref.node);
	      }
	    }
	
	    for (var _iterator18 = state.constantViolations, _isArray18 = Array.isArray(_iterator18), _i18 = 0, _iterator18 = _isArray18 ? _iterator18 : (0, _getIterator3.default)(_iterator18);;) {
	      var _ref18;
	
	      if (_isArray18) {
	        if (_i18 >= _iterator18.length) break;
	        _ref18 = _iterator18[_i18++];
	      } else {
	        _i18 = _iterator18.next();
	        if (_i18.done) break;
	        _ref18 = _i18.value;
	      }
	
	      var _path2 = _ref18;
	
	      _path2.scope.registerConstantViolation(_path2);
	    }
	  };
	
	  Scope.prototype.push = function push(opts) {
	    var path = this.path;
	
	    if (!path.isBlockStatement() && !path.isProgram()) {
	      path = this.getBlockParent().path;
	    }
	
	    if (path.isSwitchStatement()) {
	      path = this.getFunctionParent().path;
	    }
	
	    if (path.isLoop() || path.isCatchClause() || path.isFunction()) {
	      t.ensureBlock(path.node);
	      path = path.get("body");
	    }
	
	    var unique = opts.unique;
	    var kind = opts.kind || "var";
	    var blockHoist = opts._blockHoist == null ? 2 : opts._blockHoist;
	
	    var dataKey = "declaration:" + kind + ":" + blockHoist;
	    var declarPath = !unique && path.getData(dataKey);
	
	    if (!declarPath) {
	      var declar = t.variableDeclaration(kind, []);
	      declar._generated = true;
	      declar._blockHoist = blockHoist;
	
	      var _path$unshiftContaine = path.unshiftContainer("body", [declar]);
	
	      declarPath = _path$unshiftContaine[0];
	
	      if (!unique) path.setData(dataKey, declarPath);
	    }
	
	    var declarator = t.variableDeclarator(opts.id, opts.init);
	    declarPath.node.declarations.push(declarator);
	    this.registerBinding(kind, declarPath.get("declarations").pop());
	  };
	
	  Scope.prototype.getProgramParent = function getProgramParent() {
	    var scope = this;
	    do {
	      if (scope.path.isProgram()) {
	        return scope;
	      }
	    } while (scope = scope.parent);
	    throw new Error("We couldn't find a Function or Program...");
	  };
	
	  Scope.prototype.getFunctionParent = function getFunctionParent() {
	    var scope = this;
	    do {
	      if (scope.path.isFunctionParent()) {
	        return scope;
	      }
	    } while (scope = scope.parent);
	    throw new Error("We couldn't find a Function or Program...");
	  };
	
	  Scope.prototype.getBlockParent = function getBlockParent() {
	    var scope = this;
	    do {
	      if (scope.path.isBlockParent()) {
	        return scope;
	      }
	    } while (scope = scope.parent);
	    throw new Error("We couldn't find a BlockStatement, For, Switch, Function, Loop or Program...");
	  };
	
	  Scope.prototype.getAllBindings = function getAllBindings() {
	    var ids = (0, _create2.default)(null);
	
	    var scope = this;
	    do {
	      (0, _defaults2.default)(ids, scope.bindings);
	      scope = scope.parent;
	    } while (scope);
	
	    return ids;
	  };
	
	  Scope.prototype.getAllBindingsOfKind = function getAllBindingsOfKind() {
	    var ids = (0, _create2.default)(null);
	
	    for (var _iterator19 = arguments, _isArray19 = Array.isArray(_iterator19), _i19 = 0, _iterator19 = _isArray19 ? _iterator19 : (0, _getIterator3.default)(_iterator19);;) {
	      var _ref19;
	
	      if (_isArray19) {
	        if (_i19 >= _iterator19.length) break;
	        _ref19 = _iterator19[_i19++];
	      } else {
	        _i19 = _iterator19.next();
	        if (_i19.done) break;
	        _ref19 = _i19.value;
	      }
	
	      var kind = _ref19;
	
	      var scope = this;
	      do {
	        for (var name in scope.bindings) {
	          var binding = scope.bindings[name];
	          if (binding.kind === kind) ids[name] = binding;
	        }
	        scope = scope.parent;
	      } while (scope);
	    }
	
	    return ids;
	  };
	
	  Scope.prototype.bindingIdentifierEquals = function bindingIdentifierEquals(name, node) {
	    return this.getBindingIdentifier(name) === node;
	  };
	
	  Scope.prototype.warnOnFlowBinding = function warnOnFlowBinding(binding) {
	    if (_crawlCallsCount === 0 && binding && binding.path.isFlow()) {
	      console.warn("\n        You or one of the Babel plugins you are using are using Flow declarations as bindings.\n        Support for this will be removed in version 7. To find out the caller, grep for this\n        message and change it to a `console.trace()`.\n      ");
	    }
	    return binding;
	  };
	
	  Scope.prototype.getBinding = function getBinding(name) {
	    var scope = this;
	
	    do {
	      var binding = scope.getOwnBinding(name);
	      if (binding) return this.warnOnFlowBinding(binding);
	    } while (scope = scope.parent);
	  };
	
	  Scope.prototype.getOwnBinding = function getOwnBinding(name) {
	    return this.warnOnFlowBinding(this.bindings[name]);
	  };
	
	  Scope.prototype.getBindingIdentifier = function getBindingIdentifier(name) {
	    var info = this.getBinding(name);
	    return info && info.identifier;
	  };
	
	  Scope.prototype.getOwnBindingIdentifier = function getOwnBindingIdentifier(name) {
	    var binding = this.bindings[name];
	    return binding && binding.identifier;
	  };
	
	  Scope.prototype.hasOwnBinding = function hasOwnBinding(name) {
	    return !!this.getOwnBinding(name);
	  };
	
	  Scope.prototype.hasBinding = function hasBinding(name, noGlobals) {
	    if (!name) return false;
	    if (this.hasOwnBinding(name)) return true;
	    if (this.parentHasBinding(name, noGlobals)) return true;
	    if (this.hasUid(name)) return true;
	    if (!noGlobals && (0, _includes2.default)(Scope.globals, name)) return true;
	    if (!noGlobals && (0, _includes2.default)(Scope.contextVariables, name)) return true;
	    return false;
	  };
	
	  Scope.prototype.parentHasBinding = function parentHasBinding(name, noGlobals) {
	    return this.parent && this.parent.hasBinding(name, noGlobals);
	  };
	
	  Scope.prototype.moveBindingTo = function moveBindingTo(name, scope) {
	    var info = this.getBinding(name);
	    if (info) {
	      info.scope.removeOwnBinding(name);
	      info.scope = scope;
	      scope.bindings[name] = info;
	    }
	  };
	
	  Scope.prototype.removeOwnBinding = function removeOwnBinding(name) {
	    delete this.bindings[name];
	  };
	
	  Scope.prototype.removeBinding = function removeBinding(name) {
	    var info = this.getBinding(name);
	    if (info) {
	      info.scope.removeOwnBinding(name);
	    }
	
	    var scope = this;
	    do {
	      if (scope.uids[name]) {
	        scope.uids[name] = false;
	      }
	    } while (scope = scope.parent);
	  };
	
	  return Scope;
	}();
	
	Scope.globals = (0, _keys2.default)(_globals2.default.builtin);
	Scope.contextVariables = ["arguments", "undefined", "Infinity", "NaN"];
	exports.default = Scope;
	module.exports = exports["default"];

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.NOT_LOCAL_BINDING = exports.BLOCK_SCOPED_SYMBOL = exports.INHERIT_KEYS = exports.UNARY_OPERATORS = exports.STRING_UNARY_OPERATORS = exports.NUMBER_UNARY_OPERATORS = exports.BOOLEAN_UNARY_OPERATORS = exports.BINARY_OPERATORS = exports.NUMBER_BINARY_OPERATORS = exports.BOOLEAN_BINARY_OPERATORS = exports.COMPARISON_BINARY_OPERATORS = exports.EQUALITY_BINARY_OPERATORS = exports.BOOLEAN_NUMBER_BINARY_OPERATORS = exports.UPDATE_OPERATORS = exports.LOGICAL_OPERATORS = exports.COMMENT_KEYS = exports.FOR_INIT_KEYS = exports.FLATTENABLE_KEYS = exports.STATEMENT_OR_BLOCK_KEYS = undefined;
	
	var _for = __webpack_require__(966);
	
	var _for2 = _interopRequireDefault(_for);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATEMENT_OR_BLOCK_KEYS = exports.STATEMENT_OR_BLOCK_KEYS = ["consequent", "body", "alternate"];
	var FLATTENABLE_KEYS = exports.FLATTENABLE_KEYS = ["body", "expressions"];
	var FOR_INIT_KEYS = exports.FOR_INIT_KEYS = ["left", "init"];
	var COMMENT_KEYS = exports.COMMENT_KEYS = ["leadingComments", "trailingComments", "innerComments"];
	
	var LOGICAL_OPERATORS = exports.LOGICAL_OPERATORS = ["||", "&&"];
	var UPDATE_OPERATORS = exports.UPDATE_OPERATORS = ["++", "--"];
	
	var BOOLEAN_NUMBER_BINARY_OPERATORS = exports.BOOLEAN_NUMBER_BINARY_OPERATORS = [">", "<", ">=", "<="];
	var EQUALITY_BINARY_OPERATORS = exports.EQUALITY_BINARY_OPERATORS = ["==", "===", "!=", "!=="];
	var COMPARISON_BINARY_OPERATORS = exports.COMPARISON_BINARY_OPERATORS = [].concat(EQUALITY_BINARY_OPERATORS, ["in", "instanceof"]);
	var BOOLEAN_BINARY_OPERATORS = exports.BOOLEAN_BINARY_OPERATORS = [].concat(COMPARISON_BINARY_OPERATORS, BOOLEAN_NUMBER_BINARY_OPERATORS);
	var NUMBER_BINARY_OPERATORS = exports.NUMBER_BINARY_OPERATORS = ["-", "/", "%", "*", "**", "&", "|", ">>", ">>>", "<<", "^"];
	var BINARY_OPERATORS = exports.BINARY_OPERATORS = ["+"].concat(NUMBER_BINARY_OPERATORS, BOOLEAN_BINARY_OPERATORS);
	
	var BOOLEAN_UNARY_OPERATORS = exports.BOOLEAN_UNARY_OPERATORS = ["delete", "!"];
	var NUMBER_UNARY_OPERATORS = exports.NUMBER_UNARY_OPERATORS = ["+", "-", "++", "--", "~"];
	var STRING_UNARY_OPERATORS = exports.STRING_UNARY_OPERATORS = ["typeof"];
	var UNARY_OPERATORS = exports.UNARY_OPERATORS = ["void"].concat(BOOLEAN_UNARY_OPERATORS, NUMBER_UNARY_OPERATORS, STRING_UNARY_OPERATORS);
	
	var INHERIT_KEYS = exports.INHERIT_KEYS = {
	  optional: ["typeAnnotation", "typeParameters", "returnType"],
	  force: ["start", "loc", "end"]
	};
	
	var BLOCK_SCOPED_SYMBOL = exports.BLOCK_SCOPED_SYMBOL = (0, _for2.default)("var used to be block scoped");
	var NOT_LOCAL_BINDING = exports.NOT_LOCAL_BINDING = (0, _for2.default)("should not be considered a local binding");

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Export cheerio (with )
	 */
	
	exports = module.exports = __webpack_require__(559);
	
	/*
	  Export the version
	*/
	
	exports.version = __webpack_require__(4198).version;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var serialize = __webpack_require__(311),
	    defaultOptions = __webpack_require__(290).default,
	    flattenOptions = __webpack_require__(290).flatten,
	    select = __webpack_require__(596),
	    parse = __webpack_require__(291),
	    _ = {
	      merge: __webpack_require__(690),
	      defaults: __webpack_require__(470)
	    };
	
	/**
	 * $.load(str)
	 */
	
	exports.load = function(content, options, isDocument) {
	  var Cheerio = __webpack_require__(559);
	
	  options = _.defaults(flattenOptions(options || {}), defaultOptions);
	
	  if (isDocument === void 0)
	    isDocument = true;
	
	  var root = parse(content, options, isDocument);
	
	  var initialize = function(selector, context, r, opts) {
	    if (!(this instanceof initialize)) {
	      return new initialize(selector, context, r, opts);
	    }
	    opts = _.defaults(opts || {}, options);
	    return Cheerio.call(this, selector, context, r || root, opts);
	  };
	
	  // Ensure that selections created by the "loaded" `initialize` function are
	  // true Cheerio instances.
	  initialize.prototype = Object.create(Cheerio.prototype);
	  initialize.prototype.constructor = initialize;
	
	  // Mimic jQuery's prototype alias for plugin authors.
	  initialize.fn = initialize.prototype;
	
	  // Keep a reference to the top-level scope so we can chain methods that implicitly
	  // resolve selectors; e.g. $("<span>").(".bar"), which otherwise loses ._root
	  initialize.prototype._originalRoot = root;
	
	  // Add in the static methods
	  _.merge(initialize, exports);
	
	  // Add in the root
	  initialize._root = root;
	  // store options
	  initialize._options = options;
	
	  return initialize;
	};
	
	/*
	* Helper function
	*/
	
	function render(that, dom, options) {
	  if (!dom) {
	    if (that._root && that._root.children) {
	      dom = that._root.children;
	    } else {
	      return '';
	    }
	  } else if (typeof dom === 'string') {
	    dom = select(dom, that._root, options);
	  }
	
	  return serialize(dom, options);
	}
	
	/**
	 * $.html([selector | dom], [options])
	 */
	
	exports.html = function(dom, options) {
	  // be flexible about parameters, sometimes we call html(),
	  // with options as only parameter
	  // check dom argument for dom element specific properties
	  // assume there is no 'length' or 'type' properties in the options object
	  if (Object.prototype.toString.call(dom) === '[object Object]' && !options && !('length' in dom) && !('type' in dom))
	  {
	    options = dom;
	    dom = undefined;
	  }
	
	  // sometimes $.html() used without preloading html
	  // so fallback non existing options to the default ones
	  options = _.defaults(flattenOptions(options || {}), this._options, defaultOptions);
	
	  return render(this, dom, options);
	};
	
	/**
	 * $.xml([selector | dom])
	 */
	
	exports.xml = function(dom) {
	  var options = _.defaults({xml: true}, this._options);
	
	  return render(this, dom, options);
	};
	
	/**
	 * $.text(dom)
	 */
	
	exports.text = function(elems) {
	  if (!elems) {
	    elems = this.root();
	  }
	
	  var ret = '',
	      len = elems.length,
	      elem;
	
	  for (var i = 0; i < len; i++) {
	    elem = elems[i];
	    if (elem.type === 'text') ret += elem.data;
	    else if (elem.children && elem.type !== 'comment' && elem.tagName !== 'script' && elem.tagName !== 'style') {
	      ret += exports.text(elem.children);
	    }
	  }
	
	  return ret;
	};
	
	/**
	 * $.parseHTML(data [, context ] [, keepScripts ])
	 * Parses a string into an array of DOM nodes. The `context` argument has no
	 * meaning for Cheerio, but it is maintained for API compatibility with jQuery.
	 */
	exports.parseHTML = function(data, context, keepScripts) {
	  var parsed;
	
	  if (!data || typeof data !== 'string') {
	    return null;
	  }
	
	  if (typeof context === 'boolean') {
	    keepScripts = context;
	  }
	
	  parsed = this.load(data, defaultOptions, false);
	  if (!keepScripts) {
	    parsed('script').remove();
	  }
	
	  // The `children` array is used by Cheerio internally to group elements that
	  // share the same parents. When nodes created through `parseHTML` are
	  // inserted into previously-existing DOM structures, they will be removed
	  // from the `children` array. The results of `parseHTML` should remain
	  // constant across these operations, so a shallow copy should be returned.
	  return parsed.root()[0].children.slice();
	};
	
	/**
	 * $.root()
	 */
	exports.root = function() {
	  return this(this._root);
	};
	
	/**
	 * $.contains()
	 */
	exports.contains = function(container, contained) {
	
	  // According to the jQuery API, an element does not "contain" itself
	  if (contained === container) {
	    return false;
	  }
	
	  // Step up the descendants, stopping when the root element is reached
	  // (signaled by `.parent` returning a reference to the same object)
	  while (contained && contained !== contained.parent) {
	    contained = contained.parent;
	    if (contained === container) {
	      return true;
	    }
	  }
	
	  return false;
	};
	
	/**
	 * $.merge()
	 */
	
	exports.merge = function(arr1, arr2) {
	  if(!(isArrayLike(arr1) && isArrayLike(arr2))){
	    return;
	  }
	  var newLength = arr1.length + arr2.length;
	  var i = 0;
	  while(i < arr2.length){
	    arr1[i + arr1.length] = arr2[i];
	    i++;
	  }
	  arr1.length = newLength;
	  return arr1;
	};
	
	function isArrayLike(item){
	  if(Array.isArray(item)){
	    return true;
	  }
	  if(typeof item !== 'object'){
	    return false;
	  }
	  if(!item.hasOwnProperty('length')){
	    return false;
	  }
	  if(typeof item.length !== 'number') {
	    return false;
	  }
	  if(item.length < 0){
	    return false;
	  }
	  var i = 0;
	  while(i < item.length){
	    if(!(i in item)){
	      return false;
	    }
	    i++;
	  }
	  return true;
	}


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(85);
	var IObject = __webpack_require__(390);
	var toObject = __webpack_require__(172);
	var toLength = __webpack_require__(296);
	var asc = __webpack_require__(1058);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(200);
	var TAG = __webpack_require__(41)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 387 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(46);
	var document = __webpack_require__(40).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 389 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(200);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(293);
	var $export = __webpack_require__(28);
	var redefine = __webpack_require__(394);
	var hide = __webpack_require__(95);
	var Iterators = __webpack_require__(201);
	var $iterCreate = __webpack_require__(1065);
	var setToStringTag = __webpack_require__(205);
	var getPrototypeOf = __webpack_require__(572);
	var ITERATOR = __webpack_require__(41)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(199);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 393 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(95);


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(396)('keys');
	var uid = __webpack_require__(297);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(40);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 397 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(46);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(40);
	var core = __webpack_require__(21);
	var LIBRARY = __webpack_require__(293);
	var wksExt = __webpack_require__(400);
	var defineProperty = __webpack_require__(58).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(41);


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(386);
	var ITERATOR = __webpack_require__(41)('iterator');
	var Iterators = __webpack_require__(201);
	module.exports = __webpack_require__(21).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(40);
	var has = __webpack_require__(94);
	var DESCRIPTORS = __webpack_require__(70);
	var $export = __webpack_require__(28);
	var redefine = __webpack_require__(394);
	var META = __webpack_require__(202).KEY;
	var $fails = __webpack_require__(93);
	var shared = __webpack_require__(396);
	var setToStringTag = __webpack_require__(205);
	var uid = __webpack_require__(297);
	var wks = __webpack_require__(41);
	var wksExt = __webpack_require__(400);
	var wksDefine = __webpack_require__(399);
	var enumKeys = __webpack_require__(1063);
	var isArray = __webpack_require__(565);
	var anObject = __webpack_require__(57);
	var isObject = __webpack_require__(46);
	var toIObject = __webpack_require__(129);
	var toPrimitive = __webpack_require__(398);
	var createDesc = __webpack_require__(204);
	var _create = __webpack_require__(294);
	var gOPNExt = __webpack_require__(1069);
	var $GOPD = __webpack_require__(570);
	var $DP = __webpack_require__(58);
	var $keys = __webpack_require__(171);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(571).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(203).f = $propertyIsEnumerable;
	  __webpack_require__(393).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(293)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(95)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(301);
	var TAG = __webpack_require__(47)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 404 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(209);
	var document = __webpack_require__(52).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(300);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(305).f;
	var has = __webpack_require__(304);
	var TAG = __webpack_require__(47)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(592)('keys');
	var uid = __webpack_require__(411);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 409 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(1104);
	var defined = __webpack_require__(404);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 411 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		pseudo selectors
	
		---
	
		they are available in two forms:
		* filters called when the selector
		  is compiled and return a function
		  that needs to return next()
		* pseudos get called on execution
		  they need to return a boolean
	*/
	
	var DomUtils    = __webpack_require__(214),
	    isTag       = DomUtils.isTag,
	    getText     = DomUtils.getText,
	    getParent   = DomUtils.getParent,
	    getChildren = DomUtils.getChildren,
	    getSiblings = DomUtils.getSiblings,
	    hasAttrib   = DomUtils.hasAttrib,
	    getName     = DomUtils.getName,
	    getAttribute= DomUtils.getAttributeValue,
	    getNCheck   = __webpack_require__(4354),
	    checkAttrib = __webpack_require__(597).rules.equals,
	    BaseFuncs   = __webpack_require__(197),
	    trueFunc    = BaseFuncs.trueFunc,
	    falseFunc   = BaseFuncs.falseFunc;
	
	//helper methods
	function getFirstElement(elems){
		for(var i = 0; elems && i < elems.length; i++){
			if(isTag(elems[i])) return elems[i];
		}
	}
	
	function getAttribFunc(name, value){
		var data = {name: name, value: value};
		return function attribFunc(next){
			return checkAttrib(next, data);
		};
	}
	
	function getChildFunc(next){
		return function(elem){
			return !!getParent(elem) && next(elem);
		};
	}
	
	var filters = {
		contains: function(next, text){
			return function contains(elem){
				return next(elem) && getText(elem).indexOf(text) >= 0;
			};
		},
		icontains: function(next, text){
			var itext = text.toLowerCase();
			return function icontains(elem){
				return next(elem) &&
					getText(elem).toLowerCase().indexOf(itext) >= 0;
			};
		},
	
		//location specific methods
		"nth-child": function(next, rule){
			var func = getNCheck(rule);
	
			if(func === falseFunc) return func;
			if(func === trueFunc)  return getChildFunc(next);
	
			return function nthChild(elem){
				var siblings = getSiblings(elem);
	
				for(var i = 0, pos = 0; i < siblings.length; i++){
					if(isTag(siblings[i])){
						if(siblings[i] === elem) break;
						else pos++;
					}
				}
	
				return func(pos) && next(elem);
			};
		},
		"nth-last-child": function(next, rule){
			var func = getNCheck(rule);
	
			if(func === falseFunc) return func;
			if(func === trueFunc)  return getChildFunc(next);
	
			return function nthLastChild(elem){
				var siblings = getSiblings(elem);
	
				for(var pos = 0, i = siblings.length - 1; i >= 0; i--){
					if(isTag(siblings[i])){
						if(siblings[i] === elem) break;
						else pos++;
					}
				}
	
				return func(pos) && next(elem);
			};
		},
		"nth-of-type": function(next, rule){
			var func = getNCheck(rule);
	
			if(func === falseFunc) return func;
			if(func === trueFunc)  return getChildFunc(next);
	
			return function nthOfType(elem){
				var siblings = getSiblings(elem);
	
				for(var pos = 0, i = 0; i < siblings.length; i++){
					if(isTag(siblings[i])){
						if(siblings[i] === elem) break;
						if(getName(siblings[i]) === getName(elem)) pos++;
					}
				}
	
				return func(pos) && next(elem);
			};
		},
		"nth-last-of-type": function(next, rule){
			var func = getNCheck(rule);
	
			if(func === falseFunc) return func;
			if(func === trueFunc)  return getChildFunc(next);
	
			return function nthLastOfType(elem){
				var siblings = getSiblings(elem);
	
				for(var pos = 0, i = siblings.length - 1; i >= 0; i--){
					if(isTag(siblings[i])){
						if(siblings[i] === elem) break;
						if(getName(siblings[i]) === getName(elem)) pos++;
					}
				}
	
				return func(pos) && next(elem);
			};
		},
	
	    //TODO determine the actual root element
	    root: function(next){
	        return function(elem){
	            return !getParent(elem) && next(elem);
	        };
	    },
	
	    scope: function(next, rule, options, context){
	        if(!context || context.length === 0){
	            //equivalent to :root
	            return filters.root(next);
	        }
	
	        if(context.length === 1){
	            //NOTE: can't be unpacked, as :has uses this for side-effects
	            return function(elem){
	                return context[0] === elem && next(elem);
	            };
	        }
	
	        return function(elem){
	            return context.indexOf(elem) >= 0 && next(elem);
	        };
	    },
	
		//jQuery extensions (others follow as pseudos)
		checkbox: getAttribFunc("type", "checkbox"),
		file: getAttribFunc("type", "file"),
		password: getAttribFunc("type", "password"),
		radio: getAttribFunc("type", "radio"),
		reset: getAttribFunc("type", "reset"),
		image: getAttribFunc("type", "image"),
		submit: getAttribFunc("type", "submit")
	};
	
	//while filters are precompiled, pseudos get called when they are needed
	var pseudos = {
		empty: function(elem){
			return !getChildren(elem).some(function(elem){
				return isTag(elem) || elem.type === "text";
			});
		},
	
		"first-child": function(elem){
			return getFirstElement(getSiblings(elem)) === elem;
		},
		"last-child": function(elem){
			var siblings = getSiblings(elem);
	
			for(var i = siblings.length - 1; i >= 0; i--){
				if(siblings[i] === elem) return true;
				if(isTag(siblings[i])) break;
			}
	
			return false;
		},
		"first-of-type": function(elem){
			var siblings = getSiblings(elem);
	
			for(var i = 0; i < siblings.length; i++){
				if(isTag(siblings[i])){
					if(siblings[i] === elem) return true;
					if(getName(siblings[i]) === getName(elem)) break;
				}
			}
	
			return false;
		},
		"last-of-type": function(elem){
			var siblings = getSiblings(elem);
	
			for(var i = siblings.length-1; i >= 0; i--){
				if(isTag(siblings[i])){
					if(siblings[i] === elem) return true;
					if(getName(siblings[i]) === getName(elem)) break;
				}
			}
	
			return false;
		},
		"only-of-type": function(elem){
			var siblings = getSiblings(elem);
	
			for(var i = 0, j = siblings.length; i < j; i++){
				if(isTag(siblings[i])){
					if(siblings[i] === elem) continue;
					if(getName(siblings[i]) === getName(elem)) return false;
				}
			}
	
			return true;
		},
		"only-child": function(elem){
			var siblings = getSiblings(elem);
	
			for(var i = 0; i < siblings.length; i++){
				if(isTag(siblings[i]) && siblings[i] !== elem) return false;
			}
	
			return true;
		},
	
		//:matches(a, area, link)[href]
		link: function(elem){
			return hasAttrib(elem, "href");
		},
		visited: falseFunc, //seems to be a valid implementation
		//TODO: :any-link once the name is finalized (as an alias of :link)
	
		//forms
		//to consider: :target
	
		//:matches([selected], select:not([multiple]):not(> option[selected]) > option:first-of-type)
		selected: function(elem){
			if(hasAttrib(elem, "selected")) return true;
			else if(getName(elem) !== "option") return false;
	
			//the first <option> in a <select> is also selected
			var parent = getParent(elem);
	
			if(
				!parent ||
				getName(parent) !== "select" ||
				hasAttrib(parent, "multiple")
			) return false;
	
			var siblings = getChildren(parent),
				sawElem  = false;
	
			for(var i = 0; i < siblings.length; i++){
				if(isTag(siblings[i])){
					if(siblings[i] === elem){
						sawElem = true;
					} else if(!sawElem){
						return false;
					} else if(hasAttrib(siblings[i], "selected")){
						return false;
					}
				}
			}
	
			return sawElem;
		},
		//https://html.spec.whatwg.org/multipage/scripting.html#disabled-elements
		//:matches(
		//  :matches(button, input, select, textarea, menuitem, optgroup, option)[disabled],
		//  optgroup[disabled] > option),
		// fieldset[disabled] * //TODO not child of first <legend>
		//)
		disabled: function(elem){
			return hasAttrib(elem, "disabled");
		},
		enabled: function(elem){
			return !hasAttrib(elem, "disabled");
		},
		//:matches(:matches(:radio, :checkbox)[checked], :selected) (TODO menuitem)
		checked: function(elem){
			return hasAttrib(elem, "checked") || pseudos.selected(elem);
		},
		//:matches(input, select, textarea)[required]
		required: function(elem){
			return hasAttrib(elem, "required");
		},
		//:matches(input, select, textarea):not([required])
		optional: function(elem){
			return !hasAttrib(elem, "required");
		},
	
		//jQuery extensions
	
		//:not(:empty)
		parent: function(elem){
			return !pseudos.empty(elem);
		},
		//:matches(h1, h2, h3, h4, h5, h6)
		header: function(elem){
			var name = getName(elem);
			return name === "h1" ||
			       name === "h2" ||
			       name === "h3" ||
			       name === "h4" ||
			       name === "h5" ||
			       name === "h6";
		},
	
		//:matches(button, input[type=button])
		button: function(elem){
			var name = getName(elem);
			return name === "button" ||
			       name === "input" &&
			       getAttribute(elem, "type") === "button";
		},
		//:matches(input, textarea, select, button)
		input: function(elem){
			var name = getName(elem);
			return name === "input" ||
			       name === "textarea" ||
			       name === "select" ||
			       name === "button";
		},
		//input:matches(:not([type!='']), [type='text' i])
		text: function(elem){
			var attr;
			return getName(elem) === "input" && (
				!(attr = getAttribute(elem, "type")) ||
				attr.toLowerCase() === "text"
			);
		}
	};
	
	function verifyArgs(func, name, subselect){
		if(subselect === null){
			if(func.length > 1 && name !== "scope"){
				throw new SyntaxError("pseudo-selector :" + name + " requires an argument");
			}
		} else {
			if(func.length === 1){
				throw new SyntaxError("pseudo-selector :" + name + " doesn't have any arguments");
			}
		}
	}
	
	//FIXME this feels hacky
	var re_CSS3 = /^(?:(?:nth|last|first|only)-(?:child|of-type)|root|empty|(?:en|dis)abled|checked|not)$/;
	
	module.exports = {
		compile: function(next, data, options, context){
			var name = data.name,
				subselect = data.data;
	
			if(options && options.strict && !re_CSS3.test(name)){
				throw SyntaxError(":" + name + " isn't part of CSS3");
			}
	
			if(typeof filters[name] === "function"){
				verifyArgs(filters[name], name,  subselect);
				return filters[name](next, subselect, options, context);
			} else if(typeof pseudos[name] === "function"){
				var func = pseudos[name];
				verifyArgs(func, name, subselect);
	
				if(next === trueFunc) return func;
	
				return function pseudoArgs(elem){
					return func(elem, subselect) && next(elem);
				};
			} else {
				throw new SyntaxError("unmatched pseudo-class :" + name);
			}
		},
		filters: filters,
		pseudos: pseudos
	};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	  Copyright (C) 2013 Yusuke Suzuki <utatane.tea@gmail.com>
	
	  Redistribution and use in source and binary forms, with or without
	  modification, are permitted provided that the following conditions are met:
	
	    * Redistributions of source code must retain the above copyright
	      notice, this list of conditions and the following disclaimer.
	    * Redistributions in binary form must reproduce the above copyright
	      notice, this list of conditions and the following disclaimer in the
	      documentation and/or other materials provided with the distribution.
	
	  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
	  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
	  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
	  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
	  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
	  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	
	(function () {
	    'use strict';
	
	    exports.ast = __webpack_require__(1190);
	    exports.code = __webpack_require__(617);
	    exports.keyword = __webpack_require__(1191);
	}());
	/* vim: set sw=4 ts=4 et tw=80 : */


/***/ }),
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(96);
	var bind = __webpack_require__(135);
	
	var implementation = __webpack_require__(621);
	var getPolyfill = __webpack_require__(622);
	var shim = __webpack_require__(1241);
	
	var bound = bind.call(Function.call, implementation);
	
	define(bound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = bound;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(338);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(315);
	
	var _PathUtils = __webpack_require__(178);
	
	var _createTransitionManager = __webpack_require__(422);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(626);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;
	
	var _LocationUtils = __webpack_require__(315);
	
	Object.defineProperty(exports, 'createLocation', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.createLocation;
	  }
	});
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _PathUtils = __webpack_require__(178);
	
	Object.defineProperty(exports, 'parsePath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.parsePath;
	  }
	});
	Object.defineProperty(exports, 'createPath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.createPath;
	  }
	});
	
	var _createBrowserHistory2 = __webpack_require__(421);
	
	var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);
	
	var _createHashHistory2 = __webpack_require__(627);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(628);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createBrowserHistory = _createBrowserHistory3.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 424 */,
/* 425 */,
/* 426 */
/***/ (function(module, exports) {

	module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),
/* 428 */,
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(321),
	    baseLodash = __webpack_require__(446);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(321),
	    baseLodash = __webpack_require__(446);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(137),
	    root = __webpack_require__(42);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(4287),
	    mapCacheDelete = __webpack_require__(4288),
	    mapCacheGet = __webpack_require__(4289),
	    mapCacheHas = __webpack_require__(4290),
	    mapCacheSet = __webpack_require__(4291);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(432),
	    setCacheAdd = __webpack_require__(4302),
	    setCacheHas = __webpack_require__(4303);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 434 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 435 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(444);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 437 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 438 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),
/* 439 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 440 */,
/* 441 */,
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(660);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(322),
	    toKey = __webpack_require__(230);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(643),
	    baseIsNaN = __webpack_require__(4225),
	    strictIndexOf = __webpack_require__(4309);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(4222),
	    isObjectLike = __webpack_require__(43);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 446 */
/***/ (function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ }),
/* 447 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = basePropertyOf;


/***/ }),
/* 448 */,
/* 449 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 450 */,
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(637);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 452 */,
/* 453 */,
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(183),
	    overRest = __webpack_require__(674),
	    setToString = __webpack_require__(461);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(672),
	    noop = __webpack_require__(184);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(673);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(435),
	    stubArray = __webpack_require__(694);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 458 */,
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(24),
	    isSymbol = __webpack_require__(233);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 460 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(4242),
	    shortOut = __webpack_require__(679);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(101),
	    createAssigner = __webpack_require__(323),
	    keysIn = __webpack_require__(140);
	
	/**
	 * This method is like `_.assign` except that it iterates over own and
	 * inherited source properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assign
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	 */
	var assignIn = createAssigner(function(object, source) {
	  copyObject(source, keysIn(source), object);
	});
	
	module.exports = assignIn;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(73),
	    createWrap = __webpack_require__(659),
	    getHolder = __webpack_require__(325),
	    replaceHolders = __webpack_require__(229);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of `thisArg`
	 * and `partials` prepended to the arguments it receives.
	 *
	 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	 * property of bound functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new bound function.
	 * @example
	 *
	 * function greet(greeting, punctuation) {
	 *   return greeting + ' ' + this.user + punctuation;
	 * }
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * var bound = _.bind(greet, object, 'hi');
	 * bound('!');
	 * // => 'hi fred!'
	 *
	 * // Bound with placeholders.
	 * var bound = _.bind(greet, object, _, '!');
	 * bound('hi');
	 * // => 'hi fred!'
	 */
	var bind = baseRest(function(func, thisArg, partials) {
	  var bitmask = WRAP_BIND_FLAG;
	  if (partials.length) {
	    var holders = replaceHolders(partials, getHolder(bind));
	    bitmask |= WRAP_PARTIAL_FLAG;
	  }
	  return createWrap(func, bitmask, thisArg, partials, holders);
	});
	
	// Assign default placeholders.
	bind.placeholder = {};
	
	module.exports = bind;


/***/ }),
/* 467 */
/***/ (function(module, exports) {

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = compact;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(182),
	    arrayMap = __webpack_require__(100),
	    baseIteratee = __webpack_require__(60),
	    baseRest = __webpack_require__(73);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that iterates over `pairs` and invokes the corresponding
	 * function of the first predicate to return truthy. The predicate-function
	 * pairs are invoked with the `this` binding and arguments of the created
	 * function.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {Array} pairs The predicate-function pairs.
	 * @returns {Function} Returns the new composite function.
	 * @example
	 *
	 * var func = _.cond([
	 *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	 *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	 *   [_.stubTrue,                      _.constant('no match')]
	 * ]);
	 *
	 * func({ 'a': 1, 'b': 2 });
	 * // => 'matches A'
	 *
	 * func({ 'a': 0, 'b': 1 });
	 * // => 'matches B'
	 *
	 * func({ 'a': '1', 'b': '2' });
	 * // => 'no match'
	 */
	function cond(pairs) {
	  var length = pairs == null ? 0 : pairs.length,
	      toIteratee = baseIteratee;
	
	  pairs = !length ? [] : arrayMap(pairs, function(pair) {
	    if (typeof pair[1] != 'function') {
	      throw new TypeError(FUNC_ERROR_TEXT);
	    }
	    return [toIteratee(pair[0]), pair[1]];
	  });
	
	  return baseRest(function(args) {
	    var index = -1;
	    while (++index < length) {
	      var pair = pairs[index];
	      if (apply(pair[0], this, args)) {
	        return apply(pair[1], this, args);
	      }
	    }
	  });
	}
	
	module.exports = cond;


/***/ }),
/* 469 */,
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(73),
	    eq = __webpack_require__(138),
	    isIterateeCall = __webpack_require__(227),
	    keysIn = __webpack_require__(140);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var defaults = baseRest(function(object, sources) {
	  object = Object(object);
	
	  var index = -1;
	  var length = sources.length;
	  var guard = length > 2 ? sources[2] : undefined;
	
	  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	    length = 1;
	  }
	
	  while (++index < length) {
	    var source = sources[index];
	    var props = keysIn(source);
	    var propsIndex = -1;
	    var propsLength = props.length;
	
	    while (++propsIndex < propsLength) {
	      var key = props[propsIndex];
	      var value = object[key];
	
	      if (value === undefined ||
	          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        object[key] = source[key];
	      }
	    }
	  }
	
	  return object;
	});
	
	module.exports = defaults;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	var createFlow = __webpack_require__(4259);
	
	/**
	 * Creates a function that returns the result of invoking the given functions
	 * with the `this` binding of the created function, where each successive
	 * invocation is supplied the return value of the previous.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Util
	 * @param {...(Function|Function[])} [funcs] The functions to invoke.
	 * @returns {Function} Returns the new composite function.
	 * @see _.flowRight
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var addSquare = _.flow([_.add, square]);
	 * addSquare(1, 2);
	 * // => 9
	 */
	var flow = createFlow();
	
	module.exports = flow;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(72),
	    isObjectLike = __webpack_require__(43),
	    isPlainObject = __webpack_require__(75);
	
	/** `Object#toString` result references. */
	var domExcTag = '[object DOMException]',
	    errorTag = '[object Error]';
	
	/**
	 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	 * `SyntaxError`, `TypeError`, or `URIError` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	 * @example
	 *
	 * _.isError(new Error);
	 * // => true
	 *
	 * _.isError(Error);
	 * // => false
	 */
	function isError(value) {
	  if (!isObjectLike(value)) {
	    return false;
	  }
	  var tag = baseGetTag(value);
	  return tag == errorTag || tag == domExcTag ||
	    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	}
	
	module.exports = isError;


/***/ }),
/* 473 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 474 */,
/* 475 */,
/* 476 */
/***/ (function(module, exports) {

	/**
	 * This method returns `true`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `true`.
	 * @example
	 *
	 * _.times(2, _.stubTrue);
	 * // => [true, true]
	 */
	function stubTrue() {
	  return true;
	}
	
	module.exports = stubTrue;


/***/ }),
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DOCUMENT_MODE = __webpack_require__(77).DOCUMENT_MODE;
	
	//Const
	var VALID_DOCTYPE_NAME = 'html',
	    QUIRKS_MODE_SYSTEM_ID = 'http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd',
	    QUIRKS_MODE_PUBLIC_ID_PREFIXES = [
	        '+//silmaril//dtd html pro v0r11 19970101//en',
	        '-//advasoft ltd//dtd html 3.0 aswedit + extensions//en',
	        '-//as//dtd html 3.0 aswedit + extensions//en',
	        '-//ietf//dtd html 2.0 level 1//en',
	        '-//ietf//dtd html 2.0 level 2//en',
	        '-//ietf//dtd html 2.0 strict level 1//en',
	        '-//ietf//dtd html 2.0 strict level 2//en',
	        '-//ietf//dtd html 2.0 strict//en',
	        '-//ietf//dtd html 2.0//en',
	        '-//ietf//dtd html 2.1e//en',
	        '-//ietf//dtd html 3.0//en',
	        '-//ietf//dtd html 3.0//en//',
	        '-//ietf//dtd html 3.2 final//en',
	        '-//ietf//dtd html 3.2//en',
	        '-//ietf//dtd html 3//en',
	        '-//ietf//dtd html level 0//en',
	        '-//ietf//dtd html level 0//en//2.0',
	        '-//ietf//dtd html level 1//en',
	        '-//ietf//dtd html level 1//en//2.0',
	        '-//ietf//dtd html level 2//en',
	        '-//ietf//dtd html level 2//en//2.0',
	        '-//ietf//dtd html level 3//en',
	        '-//ietf//dtd html level 3//en//3.0',
	        '-//ietf//dtd html strict level 0//en',
	        '-//ietf//dtd html strict level 0//en//2.0',
	        '-//ietf//dtd html strict level 1//en',
	        '-//ietf//dtd html strict level 1//en//2.0',
	        '-//ietf//dtd html strict level 2//en',
	        '-//ietf//dtd html strict level 2//en//2.0',
	        '-//ietf//dtd html strict level 3//en',
	        '-//ietf//dtd html strict level 3//en//3.0',
	        '-//ietf//dtd html strict//en',
	        '-//ietf//dtd html strict//en//2.0',
	        '-//ietf//dtd html strict//en//3.0',
	        '-//ietf//dtd html//en',
	        '-//ietf//dtd html//en//2.0',
	        '-//ietf//dtd html//en//3.0',
	        '-//metrius//dtd metrius presentational//en',
	        '-//microsoft//dtd internet explorer 2.0 html strict//en',
	        '-//microsoft//dtd internet explorer 2.0 html//en',
	        '-//microsoft//dtd internet explorer 2.0 tables//en',
	        '-//microsoft//dtd internet explorer 3.0 html strict//en',
	        '-//microsoft//dtd internet explorer 3.0 html//en',
	        '-//microsoft//dtd internet explorer 3.0 tables//en',
	        '-//netscape comm. corp.//dtd html//en',
	        '-//netscape comm. corp.//dtd strict html//en',
	        '-//o\'reilly and associates//dtd html 2.0//en',
	        '-//o\'reilly and associates//dtd html extended 1.0//en',
	        '-//spyglass//dtd html 2.0 extended//en',
	        '-//sq//dtd html 2.0 hotmetal + extensions//en',
	        '-//sun microsystems corp.//dtd hotjava html//en',
	        '-//sun microsystems corp.//dtd hotjava strict html//en',
	        '-//w3c//dtd html 3 1995-03-24//en',
	        '-//w3c//dtd html 3.2 draft//en',
	        '-//w3c//dtd html 3.2 final//en',
	        '-//w3c//dtd html 3.2//en',
	        '-//w3c//dtd html 3.2s draft//en',
	        '-//w3c//dtd html 4.0 frameset//en',
	        '-//w3c//dtd html 4.0 transitional//en',
	        '-//w3c//dtd html experimental 19960712//en',
	        '-//w3c//dtd html experimental 970421//en',
	        '-//w3c//dtd w3 html//en',
	        '-//w3o//dtd w3 html 3.0//en',
	        '-//w3o//dtd w3 html 3.0//en//',
	        '-//webtechs//dtd mozilla html 2.0//en',
	        '-//webtechs//dtd mozilla html//en'
	    ],
	    QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = QUIRKS_MODE_PUBLIC_ID_PREFIXES.concat([
	        '-//w3c//dtd html 4.01 frameset//',
	        '-//w3c//dtd html 4.01 transitional//'
	    ]),
	    QUIRKS_MODE_PUBLIC_IDS = [
	        '-//w3o//dtd w3 html strict 3.0//en//',
	        '-/w3c/dtd html 4.0 transitional/en',
	        'html'
	    ],
	    LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = [
	        '-//W3C//DTD XHTML 1.0 Frameset//',
	        '-//W3C//DTD XHTML 1.0 Transitional//'
	    ],
	    LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = LIMITED_QUIRKS_PUBLIC_ID_PREFIXES.concat([
	        '-//W3C//DTD HTML 4.01 Frameset//',
	        '-//W3C//DTD HTML 4.01 Transitional//'
	    ]);
	
	
	//Utils
	function enquoteDoctypeId(id) {
	    var quote = id.indexOf('"') !== -1 ? '\'' : '"';
	
	    return quote + id + quote;
	}
	
	function hasPrefix(publicId, prefixes) {
	    for (var i = 0; i < prefixes.length; i++) {
	        if (publicId.indexOf(prefixes[i]) === 0)
	            return true;
	    }
	
	    return false;
	}
	
	
	//API
	exports.getDocumentMode = function (name, publicId, systemId) {
	    if (name !== VALID_DOCTYPE_NAME)
	        return DOCUMENT_MODE.QUIRKS;
	
	    if (systemId && systemId.toLowerCase() === QUIRKS_MODE_SYSTEM_ID)
	        return DOCUMENT_MODE.QUIRKS;
	
	    if (publicId !== null) {
	        publicId = publicId.toLowerCase();
	
	        if (QUIRKS_MODE_PUBLIC_IDS.indexOf(publicId) > -1)
	            return DOCUMENT_MODE.QUIRKS;
	
	        var prefixes = systemId === null ? QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : QUIRKS_MODE_PUBLIC_ID_PREFIXES;
	
	        if (hasPrefix(publicId, prefixes))
	            return DOCUMENT_MODE.QUIRKS;
	
	        prefixes = systemId === null ? LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES;
	
	        if (hasPrefix(publicId, prefixes))
	            return DOCUMENT_MODE.LIMITED_QUIRKS;
	    }
	
	    return DOCUMENT_MODE.NO_QUIRKS;
	};
	
	exports.serializeContent = function (name, publicId, systemId) {
	    var str = '!DOCTYPE ';
	
	    if (name)
	        str += name;
	
	    if (publicId !== null)
	        str += ' PUBLIC ' + enquoteDoctypeId(publicId);
	
	    else if (systemId !== null)
	        str += ' SYSTEM';
	
	    if (systemId !== null)
	        str += ' ' + enquoteDoctypeId(systemId);
	
	    return str;
	};


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DOCUMENT_MODE = __webpack_require__(77).DOCUMENT_MODE;
	
	//Node construction
	exports.createDocument = function () {
	    return {
	        nodeName: '#document',
	        mode: DOCUMENT_MODE.NO_QUIRKS,
	        childNodes: []
	    };
	};
	
	exports.createDocumentFragment = function () {
	    return {
	        nodeName: '#document-fragment',
	        childNodes: []
	    };
	};
	
	exports.createElement = function (tagName, namespaceURI, attrs) {
	    return {
	        nodeName: tagName,
	        tagName: tagName,
	        attrs: attrs,
	        namespaceURI: namespaceURI,
	        childNodes: [],
	        parentNode: null
	    };
	};
	
	exports.createCommentNode = function (data) {
	    return {
	        nodeName: '#comment',
	        data: data,
	        parentNode: null
	    };
	};
	
	var createTextNode = function (value) {
	    return {
	        nodeName: '#text',
	        value: value,
	        parentNode: null
	    };
	};
	
	
	//Tree mutation
	var appendChild = exports.appendChild = function (parentNode, newNode) {
	    parentNode.childNodes.push(newNode);
	    newNode.parentNode = parentNode;
	};
	
	var insertBefore = exports.insertBefore = function (parentNode, newNode, referenceNode) {
	    var insertionIdx = parentNode.childNodes.indexOf(referenceNode);
	
	    parentNode.childNodes.splice(insertionIdx, 0, newNode);
	    newNode.parentNode = parentNode;
	};
	
	exports.setTemplateContent = function (templateElement, contentElement) {
	    templateElement.content = contentElement;
	};
	
	exports.getTemplateContent = function (templateElement) {
	    return templateElement.content;
	};
	
	exports.setDocumentType = function (document, name, publicId, systemId) {
	    var doctypeNode = null;
	
	    for (var i = 0; i < document.childNodes.length; i++) {
	        if (document.childNodes[i].nodeName === '#documentType') {
	            doctypeNode = document.childNodes[i];
	            break;
	        }
	    }
	
	    if (doctypeNode) {
	        doctypeNode.name = name;
	        doctypeNode.publicId = publicId;
	        doctypeNode.systemId = systemId;
	    }
	
	    else {
	        appendChild(document, {
	            nodeName: '#documentType',
	            name: name,
	            publicId: publicId,
	            systemId: systemId
	        });
	    }
	};
	
	exports.setDocumentMode = function (document, mode) {
	    document.mode = mode;
	};
	
	exports.getDocumentMode = function (document) {
	    return document.mode;
	};
	
	exports.detachNode = function (node) {
	    if (node.parentNode) {
	        var idx = node.parentNode.childNodes.indexOf(node);
	
	        node.parentNode.childNodes.splice(idx, 1);
	        node.parentNode = null;
	    }
	};
	
	exports.insertText = function (parentNode, text) {
	    if (parentNode.childNodes.length) {
	        var prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];
	
	        if (prevNode.nodeName === '#text') {
	            prevNode.value += text;
	            return;
	        }
	    }
	
	    appendChild(parentNode, createTextNode(text));
	};
	
	exports.insertTextBefore = function (parentNode, text, referenceNode) {
	    var prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];
	
	    if (prevNode && prevNode.nodeName === '#text')
	        prevNode.value += text;
	    else
	        insertBefore(parentNode, createTextNode(text), referenceNode);
	};
	
	exports.adoptAttributes = function (recipient, attrs) {
	    var recipientAttrsMap = [];
	
	    for (var i = 0; i < recipient.attrs.length; i++)
	        recipientAttrsMap.push(recipient.attrs[i].name);
	
	    for (var j = 0; j < attrs.length; j++) {
	        if (recipientAttrsMap.indexOf(attrs[j].name) === -1)
	            recipient.attrs.push(attrs[j]);
	    }
	};
	
	
	//Tree traversing
	exports.getFirstChild = function (node) {
	    return node.childNodes[0];
	};
	
	exports.getChildNodes = function (node) {
	    return node.childNodes;
	};
	
	exports.getParentNode = function (node) {
	    return node.parentNode;
	};
	
	exports.getAttrList = function (element) {
	    return element.attrs;
	};
	
	//Node data
	exports.getTagName = function (element) {
	    return element.tagName;
	};
	
	exports.getNamespaceURI = function (element) {
	    return element.namespaceURI;
	};
	
	exports.getTextNodeContent = function (textNode) {
	    return textNode.value;
	};
	
	exports.getCommentNodeContent = function (commentNode) {
	    return commentNode.data;
	};
	
	exports.getDocumentTypeNodeName = function (doctypeNode) {
	    return doctypeNode.name;
	};
	
	exports.getDocumentTypeNodePublicId = function (doctypeNode) {
	    return doctypeNode.publicId;
	};
	
	exports.getDocumentTypeNodeSystemId = function (doctypeNode) {
	    return doctypeNode.systemId;
	};
	
	//Node types
	exports.isTextNode = function (node) {
	    return node.nodeName === '#text';
	};
	
	exports.isCommentNode = function (node) {
	    return node.nodeName === '#comment';
	};
	
	exports.isDocumentTypeNode = function (node) {
	    return node.nodeName === '#documentType';
	};
	
	exports.isElementNode = function (node) {
	    return !!node.tagName;
	};


/***/ }),
/* 483 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function mergeOptions(defaults, options) {
	    options = options || Object.create(null);
	
	    return [defaults, options].reduce(function (merged, optObj) {
	        Object.keys(optObj).forEach(function (key) {
	            merged[key] = optObj[key];
	        });
	
	        return merged;
	    }, Object.create(null));
	};


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78)))

/***/ }),
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.createMatchSelector = exports.getLocation = exports.ConnectedRouter = undefined;
	
	var _selectors = __webpack_require__(4415);
	
	Object.defineProperty(exports, 'getLocation', {
	  enumerable: true,
	  get: function get() {
	    return _selectors.getLocation;
	  }
	});
	Object.defineProperty(exports, 'createMatchSelector', {
	  enumerable: true,
	  get: function get() {
	    return _selectors.createMatchSelector;
	  }
	});
	
	var _reducer = __webpack_require__(727);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(726);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _ConnectedRouter2 = __webpack_require__(4413);
	
	var _ConnectedRouter3 = _interopRequireDefault(_ConnectedRouter2);
	
	var _middleware = __webpack_require__(4414);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ConnectedRouter = _ConnectedRouter3.default;
	exports.routerMiddleware = _middleware2.default;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(103);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(339);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, 'You should not use <Route> or withRouter() outside a <Router>');
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return path ? (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    return component ? // component prop gets first priority, only called if there's a match
	    match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
	    match ? render(props) : null : children ? // children come last, always called
	    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? _react2.default.Children.only(children) : null : null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ }),
/* 501 */,
/* 502 */,
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(336);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(212);
	util.inherits = __webpack_require__(71);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(4779)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(745);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(525).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(744);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(161);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(161);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78), __webpack_require__(361).setImmediate, (function() { return this; }())))

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(742);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(503);
	exports.Duplex = __webpack_require__(161);
	exports.Transform = __webpack_require__(743);
	exports.PassThrough = __webpack_require__(4437);


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownKeys;
	
	var _isMap = __webpack_require__(331);
	
	var _isMap2 = _interopRequireDefault(_isMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object) {
	
	  if ((0, _isMap2.default)(object)) {
	    return Array.from(object.keys());
	  }
	
	  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
	    return Reflect.ownKeys(object);
	  }
	
	  var keys = Object.getOwnPropertyNames(object);
	
	  if (typeof Object.getOwnPropertySymbols === 'function') {
	    keys = keys.concat(Object.getOwnPropertySymbols(object));
	  }
	
	  return keys;
	}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ScalarObservable = (function (_super) {
	    __extends(ScalarObservable, _super);
	    function ScalarObservable(value, scheduler) {
	        _super.call(this);
	        this.value = value;
	        this.scheduler = scheduler;
	        this._isScalar = true;
	        if (scheduler) {
	            this._isScalar = false;
	        }
	    }
	    ScalarObservable.create = function (value, scheduler) {
	        return new ScalarObservable(value, scheduler);
	    };
	    ScalarObservable.dispatch = function (state) {
	        var done = state.done, value = state.value, subscriber = state.subscriber;
	        if (done) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(value);
	        if (subscriber.closed) {
	            return;
	        }
	        state.done = true;
	        this.schedule(state);
	    };
	    ScalarObservable.prototype._subscribe = function (subscriber) {
	        var value = this.value;
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(ScalarObservable.dispatch, 0, {
	                done: false, value: value, subscriber: subscriber
	            });
	        }
	        else {
	            subscriber.next(value);
	            if (!subscriber.closed) {
	                subscriber.complete();
	            }
	        }
	    };
	    return ScalarObservable;
	}(Observable_1.Observable));
	exports.ScalarObservable = ScalarObservable;
	//# sourceMappingURL=ScalarObservable.js.map

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var EmptyObservable_1 = __webpack_require__(119);
	exports.empty = EmptyObservable_1.EmptyObservable.create;
	//# sourceMappingURL=empty.js.map

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isArray_1 = __webpack_require__(81);
	var ArrayObservable_1 = __webpack_require__(118);
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	function race() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    // if the only argument is an array, it was most likely called with
	    // `race([obs1, obs2, ...])`
	    if (observables.length === 1) {
	        if (isArray_1.isArray(observables[0])) {
	            observables = observables[0];
	        }
	        else {
	            return observables[0];
	        }
	    }
	    return new ArrayObservable_1.ArrayObservable(observables).lift(new RaceOperator());
	}
	exports.race = race;
	var RaceOperator = (function () {
	    function RaceOperator() {
	    }
	    RaceOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RaceSubscriber(subscriber));
	    };
	    return RaceOperator;
	}());
	exports.RaceOperator = RaceOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RaceSubscriber = (function (_super) {
	    __extends(RaceSubscriber, _super);
	    function RaceSubscriber(destination) {
	        _super.call(this, destination);
	        this.hasFirst = false;
	        this.observables = [];
	        this.subscriptions = [];
	    }
	    RaceSubscriber.prototype._next = function (observable) {
	        this.observables.push(observable);
	    };
	    RaceSubscriber.prototype._complete = function () {
	        var observables = this.observables;
	        var len = observables.length;
	        if (len === 0) {
	            this.destination.complete();
	        }
	        else {
	            for (var i = 0; i < len && !this.hasFirst; i++) {
	                var observable = observables[i];
	                var subscription = subscribeToResult_1.subscribeToResult(this, observable, observable, i);
	                if (this.subscriptions) {
	                    this.subscriptions.push(subscription);
	                }
	                this.add(subscription);
	            }
	            this.observables = null;
	        }
	    };
	    RaceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (!this.hasFirst) {
	            this.hasFirst = true;
	            for (var i = 0; i < this.subscriptions.length; i++) {
	                if (i !== outerIndex) {
	                    var subscription = this.subscriptions[i];
	                    subscription.unsubscribe();
	                    this.remove(subscription);
	                }
	            }
	            this.subscriptions = null;
	        }
	        this.destination.next(innerValue);
	    };
	    return RaceSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.RaceSubscriber = RaceSubscriber;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var tryCatch_1 = __webpack_require__(34);
	var errorObject_1 = __webpack_require__(32);
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/**
	 * Ignores source values for a duration determined by another Observable, then
	 * emits the most recent value from the source Observable, then repeats this
	 * process.
	 *
	 * <span class="informal">It's like {@link auditTime}, but the silencing
	 * duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/audit.png" width="100%">
	 *
	 * `audit` is similar to `throttle`, but emits the last value from the silenced
	 * time window, instead of the first value. `audit` emits the most recent value
	 * from the source Observable on the output Observable as soon as its internal
	 * timer becomes disabled, and ignores source values while the timer is enabled.
	 * Initially, the timer is disabled. As soon as the first source value arrives,
	 * the timer is enabled by calling the `durationSelector` function with the
	 * source value, which returns the "duration" Observable. When the duration
	 * Observable emits a value or completes, the timer is disabled, then the most
	 * recent source value is emitted on the output Observable, and this process
	 * repeats for the next source value.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounce}
	 * @see {@link delayWhen}
	 * @see {@link sample}
	 * @see {@link throttle}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the silencing
	 * duration, returned as an Observable or a Promise.
	 * @return {Observable<T>} An Observable that performs rate-limiting of
	 * emissions from the source Observable.
	 * @method audit
	 * @owner Observable
	 */
	function audit(durationSelector) {
	    return function auditOperatorFunction(source) {
	        return source.lift(new AuditOperator(durationSelector));
	    };
	}
	exports.audit = audit;
	var AuditOperator = (function () {
	    function AuditOperator(durationSelector) {
	        this.durationSelector = durationSelector;
	    }
	    AuditOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new AuditSubscriber(subscriber, this.durationSelector));
	    };
	    return AuditOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AuditSubscriber = (function (_super) {
	    __extends(AuditSubscriber, _super);
	    function AuditSubscriber(destination, durationSelector) {
	        _super.call(this, destination);
	        this.durationSelector = durationSelector;
	        this.hasValue = false;
	    }
	    AuditSubscriber.prototype._next = function (value) {
	        this.value = value;
	        this.hasValue = true;
	        if (!this.throttled) {
	            var duration = tryCatch_1.tryCatch(this.durationSelector)(value);
	            if (duration === errorObject_1.errorObject) {
	                this.destination.error(errorObject_1.errorObject.e);
	            }
	            else {
	                var innerSubscription = subscribeToResult_1.subscribeToResult(this, duration);
	                if (innerSubscription.closed) {
	                    this.clearThrottle();
	                }
	                else {
	                    this.add(this.throttled = innerSubscription);
	                }
	            }
	        }
	    };
	    AuditSubscriber.prototype.clearThrottle = function () {
	        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
	        if (throttled) {
	            this.remove(throttled);
	            this.throttled = null;
	            throttled.unsubscribe();
	        }
	        if (hasValue) {
	            this.value = null;
	            this.hasValue = false;
	            this.destination.next(value);
	        }
	    };
	    AuditSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
	        this.clearThrottle();
	    };
	    AuditSubscriber.prototype.notifyComplete = function () {
	        this.clearThrottle();
	    };
	    return AuditSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=audit.js.map

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeAll_1 = __webpack_require__(349);
	/**
	 * Converts a higher-order Observable into a first-order Observable by
	 * concatenating the inner Observables in order.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by putting one
	 * inner Observable after the other.</span>
	 *
	 * <img src="./img/concatAll.png" width="100%">
	 *
	 * Joins every Observable emitted by the source (a higher-order Observable), in
	 * a serial fashion. It subscribes to each inner Observable only after the
	 * previous inner Observable has completed, and merges all of their values into
	 * the returned observable.
	 *
	 * __Warning:__ If the source Observable emits Observables quickly and
	 * endlessly, and the inner Observables it emits generally complete slower than
	 * the source emits, you can run into memory issues as the incoming Observables
	 * collect in an unbounded buffer.
	 *
	 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
	 * to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
	 * var firstOrder = higherOrder.concatAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link combineAll}
	 * @see {@link concat}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 * @see {@link exhaust}
	 * @see {@link mergeAll}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @return {Observable} An Observable emitting values from all the inner
	 * Observables concatenated.
	 * @method concatAll
	 * @owner Observable
	 */
	function concatAll() {
	    return mergeAll_1.mergeAll(1);
	}
	exports.concatAll = concatAll;
	//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeMap_1 = __webpack_require__(266);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable, in a serialized fashion waiting for each one to complete before
	 * merging the next.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link concatAll}.</span>
	 *
	 * <img src="./img/concatMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. Each new inner Observable is
	 * concatenated with the previous inner Observable.
	 *
	 * __Warning:__ if source values arrive endlessly and faster than their
	 * corresponding inner Observables can complete, it will result in memory issues
	 * as inner Observables amass in an unbounded buffer waiting for their turn to
	 * be subscribed to.
	 *
	 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
	 * to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link concat}
	 * @see {@link concatAll}
	 * @see {@link concatMapTo}
	 * @see {@link exhaustMap}
	 * @see {@link mergeMap}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and taking values from each projected inner
	 * Observable sequentially.
	 * @method concatMap
	 * @owner Observable
	 */
	function concatMap(project, resultSelector) {
	    return mergeMap_1.mergeMap(project, resultSelector, 1);
	}
	exports.concatMap = concatMap;
	//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/* tslint:enable:max-line-length */
	/**
	 * Emits a given value if the source Observable completes without emitting any
	 * `next` value, otherwise mirrors the source Observable.
	 *
	 * <span class="informal">If the source Observable turns out to be empty, then
	 * this operator will emit a default value.</span>
	 *
	 * <img src="./img/defaultIfEmpty.png" width="100%">
	 *
	 * `defaultIfEmpty` emits the values emitted by the source Observable or a
	 * specified default value if the source Observable is empty (completes without
	 * having emitted any `next` value).
	 *
	 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
	 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link empty}
	 * @see {@link last}
	 *
	 * @param {any} [defaultValue=null] The default value used if the source
	 * Observable is empty.
	 * @return {Observable} An Observable that emits either the specified
	 * `defaultValue` if the source Observable emits no items, or the values emitted
	 * by the source Observable.
	 * @method defaultIfEmpty
	 * @owner Observable
	 */
	function defaultIfEmpty(defaultValue) {
	    if (defaultValue === void 0) { defaultValue = null; }
	    return function (source) { return source.lift(new DefaultIfEmptyOperator(defaultValue)); };
	}
	exports.defaultIfEmpty = defaultIfEmpty;
	var DefaultIfEmptyOperator = (function () {
	    function DefaultIfEmptyOperator(defaultValue) {
	        this.defaultValue = defaultValue;
	    }
	    DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
	    };
	    return DefaultIfEmptyOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DefaultIfEmptySubscriber = (function (_super) {
	    __extends(DefaultIfEmptySubscriber, _super);
	    function DefaultIfEmptySubscriber(destination, defaultValue) {
	        _super.call(this, destination);
	        this.defaultValue = defaultValue;
	        this.isEmpty = true;
	    }
	    DefaultIfEmptySubscriber.prototype._next = function (value) {
	        this.isEmpty = false;
	        this.destination.next(value);
	    };
	    DefaultIfEmptySubscriber.prototype._complete = function () {
	        if (this.isEmpty) {
	            this.destination.next(this.defaultValue);
	        }
	        this.destination.complete();
	    };
	    return DefaultIfEmptySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var tryCatch_1 = __webpack_require__(34);
	var errorObject_1 = __webpack_require__(32);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
	 *
	 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
	 *
	 * If a comparator function is not provided, an equality check is used by default.
	 *
	 * @example <caption>A simple example with numbers</caption>
	 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
	 *   .distinctUntilChanged()
	 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
	 *
	 * @example <caption>An example using a compare function</caption>
	 * interface Person {
	 *    age: number,
	 *    name: string
	 * }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'})
	 *     { age: 6, name: 'Foo'})
	 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo' }
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilKeyChanged}
	 *
	 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
	 * @method distinctUntilChanged
	 * @owner Observable
	 */
	function distinctUntilChanged(compare, keySelector) {
	    return function (source) { return source.lift(new DistinctUntilChangedOperator(compare, keySelector)); };
	}
	exports.distinctUntilChanged = distinctUntilChanged;
	var DistinctUntilChangedOperator = (function () {
	    function DistinctUntilChangedOperator(compare, keySelector) {
	        this.compare = compare;
	        this.keySelector = keySelector;
	    }
	    DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
	    };
	    return DistinctUntilChangedOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DistinctUntilChangedSubscriber = (function (_super) {
	    __extends(DistinctUntilChangedSubscriber, _super);
	    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
	        _super.call(this, destination);
	        this.keySelector = keySelector;
	        this.hasKey = false;
	        if (typeof compare === 'function') {
	            this.compare = compare;
	        }
	    }
	    DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
	        return x === y;
	    };
	    DistinctUntilChangedSubscriber.prototype._next = function (value) {
	        var keySelector = this.keySelector;
	        var key = value;
	        if (keySelector) {
	            key = tryCatch_1.tryCatch(this.keySelector)(value);
	            if (key === errorObject_1.errorObject) {
	                return this.destination.error(errorObject_1.errorObject.e);
	            }
	        }
	        var result = false;
	        if (this.hasKey) {
	            result = tryCatch_1.tryCatch(this.compare)(this.key, key);
	            if (result === errorObject_1.errorObject) {
	                return this.destination.error(errorObject_1.errorObject.e);
	            }
	        }
	        else {
	            this.hasKey = true;
	        }
	        if (Boolean(result) === false) {
	            this.key = key;
	            this.destination.next(value);
	        }
	    };
	    return DistinctUntilChangedSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/**
	 * Emits only the first value emitted by the source Observable that meets some
	 * condition.
	 *
	 * <span class="informal">Finds the first value that passes some test and emits
	 * that.</span>
	 *
	 * <img src="./img/find.png" width="100%">
	 *
	 * `find` searches for the first item in the source Observable that matches the
	 * specified condition embodied by the `predicate`, and returns the first
	 * occurrence in the source. Unlike {@link first}, the `predicate` is required
	 * in `find`, and does not emit an error if a valid value is not found.
	 *
	 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link first}
	 * @see {@link findIndex}
	 * @see {@link take}
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
	 * A function called with each item to test for condition matching.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable<T>} An Observable of the first item that matches the
	 * condition.
	 * @method find
	 * @owner Observable
	 */
	function find(predicate, thisArg) {
	    if (typeof predicate !== 'function') {
	        throw new TypeError('predicate is not a function');
	    }
	    return function (source) { return source.lift(new FindValueOperator(predicate, source, false, thisArg)); };
	}
	exports.find = find;
	var FindValueOperator = (function () {
	    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
	        this.predicate = predicate;
	        this.source = source;
	        this.yieldIndex = yieldIndex;
	        this.thisArg = thisArg;
	    }
	    FindValueOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
	    };
	    return FindValueOperator;
	}());
	exports.FindValueOperator = FindValueOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var FindValueSubscriber = (function (_super) {
	    __extends(FindValueSubscriber, _super);
	    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.source = source;
	        this.yieldIndex = yieldIndex;
	        this.thisArg = thisArg;
	        this.index = 0;
	    }
	    FindValueSubscriber.prototype.notifyComplete = function (value) {
	        var destination = this.destination;
	        destination.next(value);
	        destination.complete();
	    };
	    FindValueSubscriber.prototype._next = function (value) {
	        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
	        var index = this.index++;
	        try {
	            var result = predicate.call(thisArg || this, value, index, this.source);
	            if (result) {
	                this.notifyComplete(this.yieldIndex ? index : value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    FindValueSubscriber.prototype._complete = function () {
	        this.notifyComplete(this.yieldIndex ? -1 : undefined);
	    };
	    return FindValueSubscriber;
	}(Subscriber_1.Subscriber));
	exports.FindValueSubscriber = FindValueSubscriber;
	//# sourceMappingURL=find.js.map

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var noop_1 = __webpack_require__(523);
	/**
	 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
	 *
	 * <img src="./img/ignoreElements.png" width="100%">
	 *
	 * @return {Observable} An empty Observable that only calls `complete`
	 * or `error`, based on which one is called by the source Observable.
	 * @method ignoreElements
	 * @owner Observable
	 */
	function ignoreElements() {
	    return function ignoreElementsOperatorFunction(source) {
	        return source.lift(new IgnoreElementsOperator());
	    };
	}
	exports.ignoreElements = ignoreElements;
	var IgnoreElementsOperator = (function () {
	    function IgnoreElementsOperator() {
	    }
	    IgnoreElementsOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new IgnoreElementsSubscriber(subscriber));
	    };
	    return IgnoreElementsOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var IgnoreElementsSubscriber = (function (_super) {
	    __extends(IgnoreElementsSubscriber, _super);
	    function IgnoreElementsSubscriber() {
	        _super.apply(this, arguments);
	    }
	    IgnoreElementsSubscriber.prototype._next = function (unused) {
	        noop_1.noop();
	    };
	    return IgnoreElementsSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/**
	 * Emits the given constant value on the output Observable every time the source
	 * Observable emits a value.
	 *
	 * <span class="informal">Like {@link map}, but it maps every source value to
	 * the same output value every time.</span>
	 *
	 * <img src="./img/mapTo.png" width="100%">
	 *
	 * Takes a constant `value` as argument, and emits that whenever the source
	 * Observable emits a value. In other words, ignores the actual source value,
	 * and simply uses the emission moment to know when to emit the given `value`.
	 *
	 * @example <caption>Map every click to the string 'Hi'</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var greetings = clicks.mapTo('Hi');
	 * greetings.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 *
	 * @param {any} value The value to map each source value to.
	 * @return {Observable} An Observable that emits the given `value` every time
	 * the source Observable emits something.
	 * @method mapTo
	 * @owner Observable
	 */
	function mapTo(value) {
	    return function (source) { return source.lift(new MapToOperator(value)); };
	}
	exports.mapTo = mapTo;
	var MapToOperator = (function () {
	    function MapToOperator(value) {
	        this.value = value;
	    }
	    MapToOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MapToSubscriber(subscriber, this.value));
	    };
	    return MapToOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MapToSubscriber = (function (_super) {
	    __extends(MapToSubscriber, _super);
	    function MapToSubscriber(destination, value) {
	        _super.call(this, destination);
	        this.value = value;
	    }
	    MapToSubscriber.prototype._next = function (x) {
	        this.destination.next(this.value);
	    };
	    return MapToSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var FromObservable_1 = __webpack_require__(763);
	var isArray_1 = __webpack_require__(81);
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/* tslint:enable:max-line-length */
	/**
	 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
	 * that was passed.
	 *
	 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
	 *
	 * <img src="./img/onErrorResumeNext.png" width="100%">
	 *
	 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
	 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
	 * as the source.
	 *
	 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
	 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
	 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
	 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
	 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
	 * be happening until there is no more Observables left in the series, at which point returned Observable will
	 * complete - even if the last subscribed stream ended with an error.
	 *
	 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
	 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
	 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
	 * an error.
	 *
	 * Note that you do not get any access to errors emitted by the Observables. In particular do not
	 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
	 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
	 *
	 *
	 * @example <caption>Subscribe to the next Observable after map fails</caption>
	 * Rx.Observable.of(1, 2, 3, 0)
	 *   .map(x => {
	 *       if (x === 0) { throw Error(); }
	         return 10 / x;
	 *   })
	 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
	 *   .subscribe(
	 *     val => console.log(val),
	 *     err => console.log(err),          // Will never be called.
	 *     () => console.log('that\'s it!')
	 *   );
	 *
	 * // Logs:
	 * // 10
	 * // 5
	 * // 3.3333333333333335
	 * // 1
	 * // 2
	 * // 3
	 * // "that's it!"
	 *
	 * @see {@link concat}
	 * @see {@link catch}
	 *
	 * @param {...ObservableInput} observables Observables passed either directly or as an array.
	 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
	 * to the next passed Observable and so on, until it completes or runs out of Observables.
	 * @method onErrorResumeNext
	 * @owner Observable
	 */
	function onErrorResumeNext() {
	    var nextSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        nextSources[_i - 0] = arguments[_i];
	    }
	    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
	        nextSources = nextSources[0];
	    }
	    return function (source) { return source.lift(new OnErrorResumeNextOperator(nextSources)); };
	}
	exports.onErrorResumeNext = onErrorResumeNext;
	/* tslint:enable:max-line-length */
	function onErrorResumeNextStatic() {
	    var nextSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        nextSources[_i - 0] = arguments[_i];
	    }
	    var source = null;
	    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
	        nextSources = nextSources[0];
	    }
	    source = nextSources.shift();
	    return new FromObservable_1.FromObservable(source, null).lift(new OnErrorResumeNextOperator(nextSources));
	}
	exports.onErrorResumeNextStatic = onErrorResumeNextStatic;
	var OnErrorResumeNextOperator = (function () {
	    function OnErrorResumeNextOperator(nextSources) {
	        this.nextSources = nextSources;
	    }
	    OnErrorResumeNextOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
	    };
	    return OnErrorResumeNextOperator;
	}());
	var OnErrorResumeNextSubscriber = (function (_super) {
	    __extends(OnErrorResumeNextSubscriber, _super);
	    function OnErrorResumeNextSubscriber(destination, nextSources) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.nextSources = nextSources;
	    }
	    OnErrorResumeNextSubscriber.prototype.notifyError = function (error, innerSub) {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype._error = function (err) {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype._complete = function () {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
	        var next = this.nextSources.shift();
	        if (next) {
	            this.add(subscribeToResult_1.subscribeToResult(this, next));
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    return OnErrorResumeNextSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	function refCount() {
	    return function refCountOperatorFunction(source) {
	        return source.lift(new RefCountOperator(source));
	    };
	}
	exports.refCount = refCount;
	var RefCountOperator = (function () {
	    function RefCountOperator(connectable) {
	        this.connectable = connectable;
	    }
	    RefCountOperator.prototype.call = function (subscriber, source) {
	        var connectable = this.connectable;
	        connectable._refCount++;
	        var refCounter = new RefCountSubscriber(subscriber, connectable);
	        var subscription = source.subscribe(refCounter);
	        if (!refCounter.closed) {
	            refCounter.connection = connectable.connect();
	        }
	        return subscription;
	    };
	    return RefCountOperator;
	}());
	var RefCountSubscriber = (function (_super) {
	    __extends(RefCountSubscriber, _super);
	    function RefCountSubscriber(destination, connectable) {
	        _super.call(this, destination);
	        this.connectable = connectable;
	    }
	    RefCountSubscriber.prototype._unsubscribe = function () {
	        var connectable = this.connectable;
	        if (!connectable) {
	            this.connection = null;
	            return;
	        }
	        this.connectable = null;
	        var refCount = connectable._refCount;
	        if (refCount <= 0) {
	            this.connection = null;
	            return;
	        }
	        connectable._refCount = refCount - 1;
	        if (refCount > 1) {
	            this.connection = null;
	            return;
	        }
	        ///
	        // Compare the local RefCountSubscriber's connection Subscription to the
	        // connection Subscription on the shared ConnectableObservable. In cases
	        // where the ConnectableObservable source synchronously emits values, and
	        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
	        // execution continues to here before the RefCountOperator has a chance to
	        // supply the RefCountSubscriber with the shared connection Subscription.
	        // For example:
	        // ```
	        // Observable.range(0, 10)
	        //   .publish()
	        //   .refCount()
	        //   .take(5)
	        //   .subscribe();
	        // ```
	        // In order to account for this case, RefCountSubscriber should only dispose
	        // the ConnectableObservable's shared connection Subscription if the
	        // connection Subscription exists, *and* either:
	        //   a. RefCountSubscriber doesn't have a reference to the shared connection
	        //      Subscription yet, or,
	        //   b. RefCountSubscriber's connection Subscription reference is identical
	        //      to the shared connection Subscription
	        ///
	        var connection = this.connection;
	        var sharedConnection = connectable._connection;
	        this.connection = null;
	        if (sharedConnection && (!connection || sharedConnection === connection)) {
	            sharedConnection.unsubscribe();
	        }
	    };
	    return RefCountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=refCount.js.map

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/* tslint:enable:max-line-length */
	/**
	 * Applies an accumulator function over the source Observable, and returns each
	 * intermediate result, with an optional seed value.
	 *
	 * <span class="informal">It's like {@link reduce}, but emits the current
	 * accumulation whenever the source emits a value.</span>
	 *
	 * <img src="./img/scan.png" width="100%">
	 *
	 * Combines together all values emitted on the source, using an accumulator
	 * function that knows how to join a new source value into the accumulation from
	 * the past. Is similar to {@link reduce}, but emits the intermediate
	 * accumulations.
	 *
	 * Returns an Observable that applies a specified `accumulator` function to each
	 * item emitted by the source Observable. If a `seed` value is specified, then
	 * that value will be used as the initial value for the accumulator. If no seed
	 * value is specified, the first item of the source is used as the seed.
	 *
	 * @example <caption>Count the number of click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var ones = clicks.mapTo(1);
	 * var seed = 0;
	 * var count = ones.scan((acc, one) => acc + one, seed);
	 * count.subscribe(x => console.log(x));
	 *
	 * @see {@link expand}
	 * @see {@link mergeScan}
	 * @see {@link reduce}
	 *
	 * @param {function(acc: R, value: T, index: number): R} accumulator
	 * The accumulator function called on each source value.
	 * @param {T|R} [seed] The initial accumulation value.
	 * @return {Observable<R>} An observable of the accumulated values.
	 * @method scan
	 * @owner Observable
	 */
	function scan(accumulator, seed) {
	    var hasSeed = false;
	    // providing a seed of `undefined` *should* be valid and trigger
	    // hasSeed! so don't use `seed !== undefined` checks!
	    // For this reason, we have to check it here at the original call site
	    // otherwise inside Operator/Subscriber we won't know if `undefined`
	    // means they didn't provide anything or if they literally provided `undefined`
	    if (arguments.length >= 2) {
	        hasSeed = true;
	    }
	    return function scanOperatorFunction(source) {
	        return source.lift(new ScanOperator(accumulator, seed, hasSeed));
	    };
	}
	exports.scan = scan;
	var ScanOperator = (function () {
	    function ScanOperator(accumulator, seed, hasSeed) {
	        if (hasSeed === void 0) { hasSeed = false; }
	        this.accumulator = accumulator;
	        this.seed = seed;
	        this.hasSeed = hasSeed;
	    }
	    ScanOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
	    };
	    return ScanOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ScanSubscriber = (function (_super) {
	    __extends(ScanSubscriber, _super);
	    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
	        _super.call(this, destination);
	        this.accumulator = accumulator;
	        this._seed = _seed;
	        this.hasSeed = hasSeed;
	        this.index = 0;
	    }
	    Object.defineProperty(ScanSubscriber.prototype, "seed", {
	        get: function () {
	            return this._seed;
	        },
	        set: function (value) {
	            this.hasSeed = true;
	            this._seed = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ScanSubscriber.prototype._next = function (value) {
	        if (!this.hasSeed) {
	            this.seed = value;
	            this.destination.next(value);
	        }
	        else {
	            return this._tryNext(value);
	        }
	    };
	    ScanSubscriber.prototype._tryNext = function (value) {
	        var index = this.index++;
	        var result;
	        try {
	            result = this.accumulator(this.seed, value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	        this.seed = result;
	        this.destination.next(result);
	    };
	    return ScanSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=scan.js.map

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var ArgumentOutOfRangeError_1 = __webpack_require__(271);
	var EmptyObservable_1 = __webpack_require__(119);
	/**
	 * Emits only the last `count` values emitted by the source Observable.
	 *
	 * <span class="informal">Remembers the latest `count` values, then emits those
	 * only when the source completes.</span>
	 *
	 * <img src="./img/takeLast.png" width="100%">
	 *
	 * `takeLast` returns an Observable that emits at most the last `count` values
	 * emitted by the source Observable. If the source emits fewer than `count`
	 * values then all of its values are emitted. This operator must wait until the
	 * `complete` notification emission from the source in order to emit the `next`
	 * values on the output Observable, because otherwise it is impossible to know
	 * whether or not more values will be emitted on the source. For this reason,
	 * all values are emitted synchronously, followed by the complete notification.
	 *
	 * @example <caption>Take the last 3 values of an Observable with many values</caption>
	 * var many = Rx.Observable.range(1, 100);
	 * var lastThree = many.takeLast(3);
	 * lastThree.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeUntil}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
	 *
	 * @param {number} count The maximum number of values to emit from the end of
	 * the sequence of values emitted by the source Observable.
	 * @return {Observable<T>} An Observable that emits at most the last count
	 * values emitted by the source Observable.
	 * @method takeLast
	 * @owner Observable
	 */
	function takeLast(count) {
	    return function takeLastOperatorFunction(source) {
	        if (count === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        else {
	            return source.lift(new TakeLastOperator(count));
	        }
	    };
	}
	exports.takeLast = takeLast;
	var TakeLastOperator = (function () {
	    function TakeLastOperator(total) {
	        this.total = total;
	        if (this.total < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    TakeLastOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
	    };
	    return TakeLastOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TakeLastSubscriber = (function (_super) {
	    __extends(TakeLastSubscriber, _super);
	    function TakeLastSubscriber(destination, total) {
	        _super.call(this, destination);
	        this.total = total;
	        this.ring = new Array();
	        this.count = 0;
	    }
	    TakeLastSubscriber.prototype._next = function (value) {
	        var ring = this.ring;
	        var total = this.total;
	        var count = this.count++;
	        if (ring.length < total) {
	            ring.push(value);
	        }
	        else {
	            var index = count % total;
	            ring[index] = value;
	        }
	    };
	    TakeLastSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        var count = this.count;
	        if (count > 0) {
	            var total = this.count >= this.total ? this.total : this.count;
	            var ring = this.ring;
	            for (var i = 0; i < total; i++) {
	                var idx = (count++) % total;
	                destination.next(ring[idx]);
	            }
	        }
	        destination.complete();
	    };
	    return TakeLastSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(23);
	var map_1 = __webpack_require__(163);
	/**
	 * @param scheduler
	 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
	 * @method timestamp
	 * @owner Observable
	 */
	function timestamp(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return map_1.map(function (value) { return new Timestamp(value, scheduler.now()); });
	    // return (source: Observable<T>) => source.lift(new TimestampOperator(scheduler));
	}
	exports.timestamp = timestamp;
	var Timestamp = (function () {
	    function Timestamp(value, timestamp) {
	        this.value = value;
	        this.timestamp = timestamp;
	    }
	    return Timestamp;
	}());
	exports.Timestamp = Timestamp;
	;
	//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	"use strict";
	function isPromise(value) {
	    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
	}
	exports.isPromise = isPromise;
	//# sourceMappingURL=isPromise.js.map

/***/ }),
/* 523 */
/***/ (function(module, exports) {

	"use strict";
	/* tslint:disable:no-empty */
	function noop() { }
	exports.noop = noop;
	//# sourceMappingURL=noop.js.map

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var noop_1 = __webpack_require__(523);
	/* tslint:enable:max-line-length */
	function pipe() {
	    var fns = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        fns[_i - 0] = arguments[_i];
	    }
	    return pipeFromArray(fns);
	}
	exports.pipe = pipe;
	/* @internal */
	function pipeFromArray(fns) {
	    if (!fns) {
	        return noop_1.noop;
	    }
	    if (fns.length === 1) {
	        return fns[0];
	    }
	    return function piped(input) {
	        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
	    };
	}
	exports.pipeFromArray = pipeFromArray;
	//# sourceMappingURL=pipe.js.map

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(169)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 526 */,
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Buffer = __webpack_require__(169).Buffer;
	
	var isBufferEncoding = Buffer.isEncoding
	  || function(encoding) {
	       switch (encoding && encoding.toLowerCase()) {
	         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
	         default: return false;
	       }
	     }
	
	
	function assertEncoding(encoding) {
	  if (encoding && !isBufferEncoding(encoding)) {
	    throw new Error('Unknown encoding: ' + encoding);
	  }
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters. CESU-8 is handled as part of the UTF-8 encoding.
	//
	// @TODO Handling all encodings inside a single object makes it very difficult
	// to reason about this code, so it should be split up in the future.
	// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
	// points as used by CESU-8.
	var StringDecoder = exports.StringDecoder = function(encoding) {
	  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
	  assertEncoding(encoding);
	  switch (this.encoding) {
	    case 'utf8':
	      // CESU-8 represents each of Surrogate Pair by 3-bytes
	      this.surrogateSize = 3;
	      break;
	    case 'ucs2':
	    case 'utf16le':
	      // UTF-16 represents each of Surrogate Pair by 2-bytes
	      this.surrogateSize = 2;
	      this.detectIncompleteChar = utf16DetectIncompleteChar;
	      break;
	    case 'base64':
	      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
	      this.surrogateSize = 3;
	      this.detectIncompleteChar = base64DetectIncompleteChar;
	      break;
	    default:
	      this.write = passThroughWrite;
	      return;
	  }
	
	  // Enough space to store all bytes of a single character. UTF-8 needs 4
	  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
	  this.charBuffer = new Buffer(6);
	  // Number of bytes received for the current incomplete multi-byte character.
	  this.charReceived = 0;
	  // Number of bytes expected for the current incomplete multi-byte character.
	  this.charLength = 0;
	};
	
	
	// write decodes the given buffer and returns it as JS string that is
	// guaranteed to not contain any partial multi-byte characters. Any partial
	// character found at the end of the buffer is buffered up, and will be
	// returned when calling write again with the remaining bytes.
	//
	// Note: Converting a Buffer containing an orphan surrogate to a String
	// currently works, but converting a String to a Buffer (via `new Buffer`, or
	// Buffer#write) will replace incomplete surrogates with the unicode
	// replacement character. See https://codereview.chromium.org/121173009/ .
	StringDecoder.prototype.write = function(buffer) {
	  var charStr = '';
	  // if our last write ended with an incomplete multibyte character
	  while (this.charLength) {
	    // determine how many remaining bytes this buffer has to offer for this char
	    var available = (buffer.length >= this.charLength - this.charReceived) ?
	        this.charLength - this.charReceived :
	        buffer.length;
	
	    // add the new bytes to the char buffer
	    buffer.copy(this.charBuffer, this.charReceived, 0, available);
	    this.charReceived += available;
	
	    if (this.charReceived < this.charLength) {
	      // still not enough chars in this buffer? wait for more ...
	      return '';
	    }
	
	    // remove bytes belonging to the current character from the buffer
	    buffer = buffer.slice(available, buffer.length);
	
	    // get the character that was split
	    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
	
	    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	    var charCode = charStr.charCodeAt(charStr.length - 1);
	    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	      this.charLength += this.surrogateSize;
	      charStr = '';
	      continue;
	    }
	    this.charReceived = this.charLength = 0;
	
	    // if there are no more bytes in this buffer, just emit our char
	    if (buffer.length === 0) {
	      return charStr;
	    }
	    break;
	  }
	
	  // determine and set charLength / charReceived
	  this.detectIncompleteChar(buffer);
	
	  var end = buffer.length;
	  if (this.charLength) {
	    // buffer the incomplete character bytes we got
	    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
	    end -= this.charReceived;
	  }
	
	  charStr += buffer.toString(this.encoding, 0, end);
	
	  var end = charStr.length - 1;
	  var charCode = charStr.charCodeAt(end);
	  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	    var size = this.surrogateSize;
	    this.charLength += size;
	    this.charReceived += size;
	    this.charBuffer.copy(this.charBuffer, size, 0, size);
	    buffer.copy(this.charBuffer, 0, 0, size);
	    return charStr.substring(0, end);
	  }
	
	  // or just emit the charStr
	  return charStr;
	};
	
	// detectIncompleteChar determines if there is an incomplete UTF-8 character at
	// the end of the given buffer. If so, it sets this.charLength to the byte
	// length that character, and sets this.charReceived to the number of bytes
	// that are available for this character.
	StringDecoder.prototype.detectIncompleteChar = function(buffer) {
	  // determine how many bytes we have to check at the end of this buffer
	  var i = (buffer.length >= 3) ? 3 : buffer.length;
	
	  // Figure out if one of the last i bytes of our buffer announces an
	  // incomplete char.
	  for (; i > 0; i--) {
	    var c = buffer[buffer.length - i];
	
	    // See http://en.wikipedia.org/wiki/UTF-8#Description
	
	    // 110XXXXX
	    if (i == 1 && c >> 5 == 0x06) {
	      this.charLength = 2;
	      break;
	    }
	
	    // 1110XXXX
	    if (i <= 2 && c >> 4 == 0x0E) {
	      this.charLength = 3;
	      break;
	    }
	
	    // 11110XXX
	    if (i <= 3 && c >> 3 == 0x1E) {
	      this.charLength = 4;
	      break;
	    }
	  }
	  this.charReceived = i;
	};
	
	StringDecoder.prototype.end = function(buffer) {
	  var res = '';
	  if (buffer && buffer.length)
	    res = this.write(buffer);
	
	  if (this.charReceived) {
	    var cr = this.charReceived;
	    var buf = this.charBuffer;
	    var enc = this.encoding;
	    res += buf.slice(0, cr).toString(enc);
	  }
	
	  return res;
	};
	
	function passThroughWrite(buffer) {
	  return buffer.toString(this.encoding);
	}
	
	function utf16DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 2;
	  this.charLength = this.charReceived ? 2 : 0;
	}
	
	function base64DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 3;
	  this.charLength = this.charReceived ? 3 : 0;
	}


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.typeDetect = factory());
	}(this, (function () { 'use strict';
	
	/* !
	 * type-detect
	 * Copyright(c) 2013 jake luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	var promiseExists = typeof Promise === 'function';
	
	/* eslint-disable no-undef */
	var globalObject = typeof self === 'object' ? self : global; // eslint-disable-line id-blacklist
	
	var symbolExists = typeof Symbol !== 'undefined';
	var mapExists = typeof Map !== 'undefined';
	var setExists = typeof Set !== 'undefined';
	var weakMapExists = typeof WeakMap !== 'undefined';
	var weakSetExists = typeof WeakSet !== 'undefined';
	var dataViewExists = typeof DataView !== 'undefined';
	var symbolIteratorExists = symbolExists && typeof Symbol.iterator !== 'undefined';
	var symbolToStringTagExists = symbolExists && typeof Symbol.toStringTag !== 'undefined';
	var setEntriesExists = setExists && typeof Set.prototype.entries === 'function';
	var mapEntriesExists = mapExists && typeof Map.prototype.entries === 'function';
	var setIteratorPrototype = setEntriesExists && Object.getPrototypeOf(new Set().entries());
	var mapIteratorPrototype = mapEntriesExists && Object.getPrototypeOf(new Map().entries());
	var arrayIteratorExists = symbolIteratorExists && typeof Array.prototype[Symbol.iterator] === 'function';
	var arrayIteratorPrototype = arrayIteratorExists && Object.getPrototypeOf([][Symbol.iterator]());
	var stringIteratorExists = symbolIteratorExists && typeof String.prototype[Symbol.iterator] === 'function';
	var stringIteratorPrototype = stringIteratorExists && Object.getPrototypeOf(''[Symbol.iterator]());
	var toStringLeftSliceLength = 8;
	var toStringRightSliceLength = -1;
	/**
	 * ### typeOf (obj)
	 *
	 * Uses `Object.prototype.toString` to determine the type of an object,
	 * normalising behaviour across engine versions & well optimised.
	 *
	 * @param {Mixed} object
	 * @return {String} object type
	 * @api public
	 */
	function typeDetect(obj) {
	  /* ! Speed optimisation
	   * Pre:
	   *   string literal     x 3,039,035 ops/sec ±1.62% (78 runs sampled)
	   *   boolean literal    x 1,424,138 ops/sec ±4.54% (75 runs sampled)
	   *   number literal     x 1,653,153 ops/sec ±1.91% (82 runs sampled)
	   *   undefined          x 9,978,660 ops/sec ±1.92% (75 runs sampled)
	   *   function           x 2,556,769 ops/sec ±1.73% (77 runs sampled)
	   * Post:
	   *   string literal     x 38,564,796 ops/sec ±1.15% (79 runs sampled)
	   *   boolean literal    x 31,148,940 ops/sec ±1.10% (79 runs sampled)
	   *   number literal     x 32,679,330 ops/sec ±1.90% (78 runs sampled)
	   *   undefined          x 32,363,368 ops/sec ±1.07% (82 runs sampled)
	   *   function           x 31,296,870 ops/sec ±0.96% (83 runs sampled)
	   */
	  var typeofObj = typeof obj;
	  if (typeofObj !== 'object') {
	    return typeofObj;
	  }
	
	  /* ! Speed optimisation
	   * Pre:
	   *   null               x 28,645,765 ops/sec ±1.17% (82 runs sampled)
	   * Post:
	   *   null               x 36,428,962 ops/sec ±1.37% (84 runs sampled)
	   */
	  if (obj === null) {
	    return 'null';
	  }
	
	  /* ! Spec Conformance
	   * Test: `Object.prototype.toString.call(window)``
	   *  - Node === "[object global]"
	   *  - Chrome === "[object global]"
	   *  - Firefox === "[object Window]"
	   *  - PhantomJS === "[object Window]"
	   *  - Safari === "[object Window]"
	   *  - IE 11 === "[object Window]"
	   *  - IE Edge === "[object Window]"
	   * Test: `Object.prototype.toString.call(this)``
	   *  - Chrome Worker === "[object global]"
	   *  - Firefox Worker === "[object DedicatedWorkerGlobalScope]"
	   *  - Safari Worker === "[object DedicatedWorkerGlobalScope]"
	   *  - IE 11 Worker === "[object WorkerGlobalScope]"
	   *  - IE Edge Worker === "[object WorkerGlobalScope]"
	   */
	  if (obj === globalObject) {
	    return 'global';
	  }
	
	  /* ! Speed optimisation
	   * Pre:
	   *   array literal      x 2,888,352 ops/sec ±0.67% (82 runs sampled)
	   * Post:
	   *   array literal      x 22,479,650 ops/sec ±0.96% (81 runs sampled)
	   */
	  if (
	    Array.isArray(obj) &&
	    (symbolToStringTagExists === false || !(Symbol.toStringTag in obj))
	  ) {
	    return 'Array';
	  }
	
	  // Not caching existence of `window` and related properties due to potential
	  // for `window` to be unset before tests in quasi-browser environments.
	  if (typeof window === 'object' && window !== null) {
	    /* ! Spec Conformance
	     * (https://html.spec.whatwg.org/multipage/browsers.html#location)
	     * WhatWG HTML$7.7.3 - The `Location` interface
	     * Test: `Object.prototype.toString.call(window.location)``
	     *  - IE <=11 === "[object Object]"
	     *  - IE Edge <=13 === "[object Object]"
	     */
	    if (typeof window.location === 'object' && obj === window.location) {
	      return 'Location';
	    }
	
	    /* ! Spec Conformance
	     * (https://html.spec.whatwg.org/#document)
	     * WhatWG HTML$3.1.1 - The `Document` object
	     * Note: Most browsers currently adher to the W3C DOM Level 2 spec
	     *       (https://www.w3.org/TR/DOM-Level-2-HTML/html.html#ID-26809268)
	     *       which suggests that browsers should use HTMLTableCellElement for
	     *       both TD and TH elements. WhatWG separates these.
	     *       WhatWG HTML states:
	     *         > For historical reasons, Window objects must also have a
	     *         > writable, configurable, non-enumerable property named
	     *         > HTMLDocument whose value is the Document interface object.
	     * Test: `Object.prototype.toString.call(document)``
	     *  - Chrome === "[object HTMLDocument]"
	     *  - Firefox === "[object HTMLDocument]"
	     *  - Safari === "[object HTMLDocument]"
	     *  - IE <=10 === "[object Document]"
	     *  - IE 11 === "[object HTMLDocument]"
	     *  - IE Edge <=13 === "[object HTMLDocument]"
	     */
	    if (typeof window.document === 'object' && obj === window.document) {
	      return 'Document';
	    }
	
	    if (typeof window.navigator === 'object') {
	      /* ! Spec Conformance
	       * (https://html.spec.whatwg.org/multipage/webappapis.html#mimetypearray)
	       * WhatWG HTML$8.6.1.5 - Plugins - Interface MimeTypeArray
	       * Test: `Object.prototype.toString.call(navigator.mimeTypes)``
	       *  - IE <=10 === "[object MSMimeTypesCollection]"
	       */
	      if (typeof window.navigator.mimeTypes === 'object' &&
	          obj === window.navigator.mimeTypes) {
	        return 'MimeTypeArray';
	      }
	
	      /* ! Spec Conformance
	       * (https://html.spec.whatwg.org/multipage/webappapis.html#pluginarray)
	       * WhatWG HTML$8.6.1.5 - Plugins - Interface PluginArray
	       * Test: `Object.prototype.toString.call(navigator.plugins)``
	       *  - IE <=10 === "[object MSPluginsCollection]"
	       */
	      if (typeof window.navigator.plugins === 'object' &&
	          obj === window.navigator.plugins) {
	        return 'PluginArray';
	      }
	    }
	
	    if ((typeof window.HTMLElement === 'function' ||
	        typeof window.HTMLElement === 'object') &&
	        obj instanceof window.HTMLElement) {
	      /* ! Spec Conformance
	      * (https://html.spec.whatwg.org/multipage/webappapis.html#pluginarray)
	      * WhatWG HTML$4.4.4 - The `blockquote` element - Interface `HTMLQuoteElement`
	      * Test: `Object.prototype.toString.call(document.createElement('blockquote'))``
	      *  - IE <=10 === "[object HTMLBlockElement]"
	      */
	      if (obj.tagName === 'BLOCKQUOTE') {
	        return 'HTMLQuoteElement';
	      }
	
	      /* ! Spec Conformance
	       * (https://html.spec.whatwg.org/#htmltabledatacellelement)
	       * WhatWG HTML$4.9.9 - The `td` element - Interface `HTMLTableDataCellElement`
	       * Note: Most browsers currently adher to the W3C DOM Level 2 spec
	       *       (https://www.w3.org/TR/DOM-Level-2-HTML/html.html#ID-82915075)
	       *       which suggests that browsers should use HTMLTableCellElement for
	       *       both TD and TH elements. WhatWG separates these.
	       * Test: Object.prototype.toString.call(document.createElement('td'))
	       *  - Chrome === "[object HTMLTableCellElement]"
	       *  - Firefox === "[object HTMLTableCellElement]"
	       *  - Safari === "[object HTMLTableCellElement]"
	       */
	      if (obj.tagName === 'TD') {
	        return 'HTMLTableDataCellElement';
	      }
	
	      /* ! Spec Conformance
	       * (https://html.spec.whatwg.org/#htmltableheadercellelement)
	       * WhatWG HTML$4.9.9 - The `td` element - Interface `HTMLTableHeaderCellElement`
	       * Note: Most browsers currently adher to the W3C DOM Level 2 spec
	       *       (https://www.w3.org/TR/DOM-Level-2-HTML/html.html#ID-82915075)
	       *       which suggests that browsers should use HTMLTableCellElement for
	       *       both TD and TH elements. WhatWG separates these.
	       * Test: Object.prototype.toString.call(document.createElement('th'))
	       *  - Chrome === "[object HTMLTableCellElement]"
	       *  - Firefox === "[object HTMLTableCellElement]"
	       *  - Safari === "[object HTMLTableCellElement]"
	       */
	      if (obj.tagName === 'TH') {
	        return 'HTMLTableHeaderCellElement';
	      }
	    }
	  }
	
	  /* ! Speed optimisation
	  * Pre:
	  *   Float64Array       x 625,644 ops/sec ±1.58% (80 runs sampled)
	  *   Float32Array       x 1,279,852 ops/sec ±2.91% (77 runs sampled)
	  *   Uint32Array        x 1,178,185 ops/sec ±1.95% (83 runs sampled)
	  *   Uint16Array        x 1,008,380 ops/sec ±2.25% (80 runs sampled)
	  *   Uint8Array         x 1,128,040 ops/sec ±2.11% (81 runs sampled)
	  *   Int32Array         x 1,170,119 ops/sec ±2.88% (80 runs sampled)
	  *   Int16Array         x 1,176,348 ops/sec ±5.79% (86 runs sampled)
	  *   Int8Array          x 1,058,707 ops/sec ±4.94% (77 runs sampled)
	  *   Uint8ClampedArray  x 1,110,633 ops/sec ±4.20% (80 runs sampled)
	  * Post:
	  *   Float64Array       x 7,105,671 ops/sec ±13.47% (64 runs sampled)
	  *   Float32Array       x 5,887,912 ops/sec ±1.46% (82 runs sampled)
	  *   Uint32Array        x 6,491,661 ops/sec ±1.76% (79 runs sampled)
	  *   Uint16Array        x 6,559,795 ops/sec ±1.67% (82 runs sampled)
	  *   Uint8Array         x 6,463,966 ops/sec ±1.43% (85 runs sampled)
	  *   Int32Array         x 5,641,841 ops/sec ±3.49% (81 runs sampled)
	  *   Int16Array         x 6,583,511 ops/sec ±1.98% (80 runs sampled)
	  *   Int8Array          x 6,606,078 ops/sec ±1.74% (81 runs sampled)
	  *   Uint8ClampedArray  x 6,602,224 ops/sec ±1.77% (83 runs sampled)
	  */
	  var stringTag = (symbolToStringTagExists && obj[Symbol.toStringTag]);
	  if (typeof stringTag === 'string') {
	    return stringTag;
	  }
	
	  var objPrototype = Object.getPrototypeOf(obj);
	  /* ! Speed optimisation
	  * Pre:
	  *   regex literal      x 1,772,385 ops/sec ±1.85% (77 runs sampled)
	  *   regex constructor  x 2,143,634 ops/sec ±2.46% (78 runs sampled)
	  * Post:
	  *   regex literal      x 3,928,009 ops/sec ±0.65% (78 runs sampled)
	  *   regex constructor  x 3,931,108 ops/sec ±0.58% (84 runs sampled)
	  */
	  if (objPrototype === RegExp.prototype) {
	    return 'RegExp';
	  }
	
	  /* ! Speed optimisation
	  * Pre:
	  *   date               x 2,130,074 ops/sec ±4.42% (68 runs sampled)
	  * Post:
	  *   date               x 3,953,779 ops/sec ±1.35% (77 runs sampled)
	  */
	  if (objPrototype === Date.prototype) {
	    return 'Date';
	  }
	
	  /* ! Spec Conformance
	   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-promise.prototype-@@tostringtag)
	   * ES6$25.4.5.4 - Promise.prototype[@@toStringTag] should be "Promise":
	   * Test: `Object.prototype.toString.call(Promise.resolve())``
	   *  - Chrome <=47 === "[object Object]"
	   *  - Edge <=20 === "[object Object]"
	   *  - Firefox 29-Latest === "[object Promise]"
	   *  - Safari 7.1-Latest === "[object Promise]"
	   */
	  if (promiseExists && objPrototype === Promise.prototype) {
	    return 'Promise';
	  }
	
	  /* ! Speed optimisation
	  * Pre:
	  *   set                x 2,222,186 ops/sec ±1.31% (82 runs sampled)
	  * Post:
	  *   set                x 4,545,879 ops/sec ±1.13% (83 runs sampled)
	  */
	  if (setExists && objPrototype === Set.prototype) {
	    return 'Set';
	  }
	
	  /* ! Speed optimisation
	  * Pre:
	  *   map                x 2,396,842 ops/sec ±1.59% (81 runs sampled)
	  * Post:
	  *   map                x 4,183,945 ops/sec ±6.59% (82 runs sampled)
	  */
	  if (mapExists && objPrototype === Map.prototype) {
	    return 'Map';
	  }
	
	  /* ! Speed optimisation
	  * Pre:
	  *   weakset            x 1,323,220 ops/sec ±2.17% (76 runs sampled)
	  * Post:
	  *   weakset            x 4,237,510 ops/sec ±2.01% (77 runs sampled)
	  */
	  if (weakSetExists && objPrototype === WeakSet.prototype) {
	    return 'WeakSet';
	  }
	
	  /* ! Speed optimisation
	  * Pre:
	  *   weakmap            x 1,500,260 ops/sec ±2.02% (78 runs sampled)
	  * Post:
	  *   weakmap            x 3,881,384 ops/sec ±1.45% (82 runs sampled)
	  */
	  if (weakMapExists && objPrototype === WeakMap.prototype) {
	    return 'WeakMap';
	  }
	
	  /* ! Spec Conformance
	   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-dataview.prototype-@@tostringtag)
	   * ES6$24.2.4.21 - DataView.prototype[@@toStringTag] should be "DataView":
	   * Test: `Object.prototype.toString.call(new DataView(new ArrayBuffer(1)))``
	   *  - Edge <=13 === "[object Object]"
	   */
	  if (dataViewExists && objPrototype === DataView.prototype) {
	    return 'DataView';
	  }
	
	  /* ! Spec Conformance
	   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-%mapiteratorprototype%-@@tostringtag)
	   * ES6$23.1.5.2.2 - %MapIteratorPrototype%[@@toStringTag] should be "Map Iterator":
	   * Test: `Object.prototype.toString.call(new Map().entries())``
	   *  - Edge <=13 === "[object Object]"
	   */
	  if (mapExists && objPrototype === mapIteratorPrototype) {
	    return 'Map Iterator';
	  }
	
	  /* ! Spec Conformance
	   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-%setiteratorprototype%-@@tostringtag)
	   * ES6$23.2.5.2.2 - %SetIteratorPrototype%[@@toStringTag] should be "Set Iterator":
	   * Test: `Object.prototype.toString.call(new Set().entries())``
	   *  - Edge <=13 === "[object Object]"
	   */
	  if (setExists && objPrototype === setIteratorPrototype) {
	    return 'Set Iterator';
	  }
	
	  /* ! Spec Conformance
	   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-%arrayiteratorprototype%-@@tostringtag)
	   * ES6$22.1.5.2.2 - %ArrayIteratorPrototype%[@@toStringTag] should be "Array Iterator":
	   * Test: `Object.prototype.toString.call([][Symbol.iterator]())``
	   *  - Edge <=13 === "[object Object]"
	   */
	  if (arrayIteratorExists && objPrototype === arrayIteratorPrototype) {
	    return 'Array Iterator';
	  }
	
	  /* ! Spec Conformance
	   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-%stringiteratorprototype%-@@tostringtag)
	   * ES6$21.1.5.2.2 - %StringIteratorPrototype%[@@toStringTag] should be "String Iterator":
	   * Test: `Object.prototype.toString.call(''[Symbol.iterator]())``
	   *  - Edge <=13 === "[object Object]"
	   */
	  if (stringIteratorExists && objPrototype === stringIteratorPrototype) {
	    return 'String Iterator';
	  }
	
	  /* ! Speed optimisation
	  * Pre:
	  *   object from null   x 2,424,320 ops/sec ±1.67% (76 runs sampled)
	  * Post:
	  *   object from null   x 5,838,000 ops/sec ±0.99% (84 runs sampled)
	  */
	  if (objPrototype === null) {
	    return 'Object';
	  }
	
	  return Object
	    .prototype
	    .toString
	    .call(obj)
	    .slice(toStringLeftSliceLength, toStringRightSliceLength);
	}
	
	return typeDetect;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */
/***/ (function(module, exports) {

	/*!
	 * assertion-error
	 * Copyright(c) 2013 Jake Luer <jake@qualiancy.com>
	 * MIT Licensed
	 */
	
	/*!
	 * Return a function that will copy properties from
	 * one object to another excluding any originally
	 * listed. Returned function will create a new `{}`.
	 *
	 * @param {String} excluded properties ...
	 * @return {Function}
	 */
	
	function exclude () {
	  var excludes = [].slice.call(arguments);
	
	  function excludeProps (res, obj) {
	    Object.keys(obj).forEach(function (key) {
	      if (!~excludes.indexOf(key)) res[key] = obj[key];
	    });
	  }
	
	  return function extendExclude () {
	    var args = [].slice.call(arguments)
	      , i = 0
	      , res = {};
	
	    for (; i < args.length; i++) {
	      excludeProps(res, args[i]);
	    }
	
	    return res;
	  };
	};
	
	/*!
	 * Primary Exports
	 */
	
	module.exports = AssertionError;
	
	/**
	 * ### AssertionError
	 *
	 * An extension of the JavaScript `Error` constructor for
	 * assertion and validation scenarios.
	 *
	 * @param {String} message
	 * @param {Object} properties to include (optional)
	 * @param {callee} start stack function (optional)
	 */
	
	function AssertionError (message, _props, ssf) {
	  var extend = exclude('name', 'message', 'stack', 'constructor', 'toJSON')
	    , props = extend(_props || {});
	
	  // default values
	  this.message = message || 'Unspecified AssertionError';
	  this.showDiff = false;
	
	  // copy from properties
	  for (var key in props) {
	    this[key] = props[key];
	  }
	
	  // capture stack trace
	  ssf = ssf || AssertionError;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, ssf);
	  } else {
	    try {
	      throw new Error();
	    } catch(e) {
	      this.stack = e.stack;
	    }
	  }
	}
	
	/*!
	 * Inherit from Error.prototype
	 */
	
	AssertionError.prototype = Object.create(Error.prototype);
	
	/*!
	 * Statically set name
	 */
	
	AssertionError.prototype.name = 'AssertionError';
	
	/*!
	 * Ensure correct constructor
	 */
	
	AssertionError.prototype.constructor = AssertionError;
	
	/**
	 * Allow errors to be converted to JSON for static transfer.
	 *
	 * @param {Boolean} include stack (default: `true`)
	 * @return {Object} object that can be `JSON.stringify`
	 */
	
	AssertionError.prototype.toJSON = function (stack) {
	  var extend = exclude('constructor', 'toJSON', 'stack')
	    , props = extend({ name: this.name }, this);
	
	  // include stack if exists and not turned off
	  if (false !== stack && this.stack) {
	    props.stack = this.stack;
	  }
	
	  return props;
	};


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (node) {
	  var params = node.params;
	  for (var i = 0; i < params.length; i++) {
	    var param = params[i];
	    if (t.isAssignmentPattern(param) || t.isRestElement(param)) {
	      return i;
	    }
	  }
	  return params.length;
	};
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	module.exports = exports["default"];

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = function (path, emit) {
	  var kind = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "var";
	
	  path.traverse(visitor, { kind: kind, emit: emit });
	};
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var visitor = {
	  Scope: function Scope(path, state) {
	    if (state.kind === "let") path.skip();
	  },
	  Function: function Function(path) {
	    path.skip();
	  },
	  VariableDeclaration: function VariableDeclaration(path, state) {
	    if (state.kind && path.node.kind !== state.kind) return;
	
	    var nodes = [];
	
	    var declarations = path.get("declarations");
	    var firstId = void 0;
	
	    for (var _iterator = declarations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var declar = _ref;
	
	      firstId = declar.node.id;
	
	      if (declar.node.init) {
	        nodes.push(t.expressionStatement(t.assignmentExpression("=", declar.node.id, declar.node.init)));
	      }
	
	      for (var name in declar.getBindingIdentifiers()) {
	        state.emit(t.identifier(name), name);
	      }
	    }
	
	    if (path.parentPath.isFor({ left: path.node })) {
	      path.replaceWith(firstId);
	    } else {
	      path.replaceWithMultiple(nodes);
	    }
	  }
	};
	
	module.exports = exports["default"];

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (callee, thisNode, args) {
	  if (args.length === 1 && t.isSpreadElement(args[0]) && t.isIdentifier(args[0].argument, { name: "arguments" })) {
	    return t.callExpression(t.memberExpression(callee, t.identifier("apply")), [thisNode, args[0].argument]);
	  } else {
	    return t.callExpression(t.memberExpression(callee, t.identifier("call")), [thisNode].concat(args));
	  }
	};
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	module.exports = exports["default"];

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.is = is;
	exports.pullFlag = pullFlag;
	
	var _pull = __webpack_require__(4337);
	
	var _pull2 = _interopRequireDefault(_pull);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function is(node, flag) {
	  return t.isRegExpLiteral(node) && node.flags.indexOf(flag) >= 0;
	}
	
	function pullFlag(node, flag) {
	  var flags = node.flags.split("");
	  if (node.flags.indexOf(flag) < 0) return;
	  (0, _pull2.default)(flags, flag);
	  node.flags = flags.join("");
	}

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _symbol = __webpack_require__(83);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _babelHelperOptimiseCallExpression = __webpack_require__(537);
	
	var _babelHelperOptimiseCallExpression2 = _interopRequireDefault(_babelHelperOptimiseCallExpression);
	
	var _babelMessages = __webpack_require__(284);
	
	var messages = _interopRequireWildcard(_babelMessages);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HARDCORE_THIS_REF = (0, _symbol2.default)();
	
	function isIllegalBareSuper(node, parent) {
	  if (!t.isSuper(node)) return false;
	  if (t.isMemberExpression(parent, { computed: false })) return false;
	  if (t.isCallExpression(parent, { callee: node })) return false;
	  return true;
	}
	
	function isMemberExpressionSuper(node) {
	  return t.isMemberExpression(node) && t.isSuper(node.object);
	}
	
	function getPrototypeOfExpression(objectRef, isStatic) {
	  var targetRef = isStatic ? objectRef : t.memberExpression(objectRef, t.identifier("prototype"));
	
	  return t.logicalExpression("||", t.memberExpression(targetRef, t.identifier("__proto__")), t.callExpression(t.memberExpression(t.identifier("Object"), t.identifier("getPrototypeOf")), [targetRef]));
	}
	
	var visitor = {
	  Function: function Function(path) {
	    if (!path.inShadow("this")) {
	      path.skip();
	    }
	  },
	  ReturnStatement: function ReturnStatement(path, state) {
	    if (!path.inShadow("this")) {
	      state.returns.push(path);
	    }
	  },
	  ThisExpression: function ThisExpression(path, state) {
	    if (!path.node[HARDCORE_THIS_REF]) {
	      state.thises.push(path);
	    }
	  },
	  enter: function enter(path, state) {
	    var callback = state.specHandle;
	    if (state.isLoose) callback = state.looseHandle;
	
	    var isBareSuper = path.isCallExpression() && path.get("callee").isSuper();
	
	    var result = callback.call(state, path);
	
	    if (result) {
	      state.hasSuper = true;
	    }
	
	    if (isBareSuper) {
	      state.bareSupers.push(path);
	    }
	
	    if (result === true) {
	      path.requeue();
	    }
	
	    if (result !== true && result) {
	      if (Array.isArray(result)) {
	        path.replaceWithMultiple(result);
	      } else {
	        path.replaceWith(result);
	      }
	    }
	  }
	};
	
	var ReplaceSupers = function () {
	  function ReplaceSupers(opts) {
	    var inClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    (0, _classCallCheck3.default)(this, ReplaceSupers);
	
	    this.forceSuperMemoisation = opts.forceSuperMemoisation;
	    this.methodPath = opts.methodPath;
	    this.methodNode = opts.methodNode;
	    this.superRef = opts.superRef;
	    this.isStatic = opts.isStatic;
	    this.hasSuper = false;
	    this.inClass = inClass;
	    this.isLoose = opts.isLoose;
	    this.scope = this.methodPath.scope;
	    this.file = opts.file;
	    this.opts = opts;
	
	    this.bareSupers = [];
	    this.returns = [];
	    this.thises = [];
	  }
	
	  ReplaceSupers.prototype.getObjectRef = function getObjectRef() {
	    return this.opts.objectRef || this.opts.getObjectRef();
	  };
	
	  ReplaceSupers.prototype.setSuperProperty = function setSuperProperty(property, value, isComputed) {
	    return t.callExpression(this.file.addHelper("set"), [getPrototypeOfExpression(this.getObjectRef(), this.isStatic), isComputed ? property : t.stringLiteral(property.name), value, t.thisExpression()]);
	  };
	
	  ReplaceSupers.prototype.getSuperProperty = function getSuperProperty(property, isComputed) {
	    return t.callExpression(this.file.addHelper("get"), [getPrototypeOfExpression(this.getObjectRef(), this.isStatic), isComputed ? property : t.stringLiteral(property.name), t.thisExpression()]);
	  };
	
	  ReplaceSupers.prototype.replace = function replace() {
	    this.methodPath.traverse(visitor, this);
	  };
	
	  ReplaceSupers.prototype.getLooseSuperProperty = function getLooseSuperProperty(id, parent) {
	    var methodNode = this.methodNode;
	    var superRef = this.superRef || t.identifier("Function");
	
	    if (parent.property === id) {
	      return;
	    } else if (t.isCallExpression(parent, { callee: id })) {
	      return;
	    } else if (t.isMemberExpression(parent) && !methodNode.static) {
	      return t.memberExpression(superRef, t.identifier("prototype"));
	    } else {
	      return superRef;
	    }
	  };
	
	  ReplaceSupers.prototype.looseHandle = function looseHandle(path) {
	    var node = path.node;
	    if (path.isSuper()) {
	      return this.getLooseSuperProperty(node, path.parent);
	    } else if (path.isCallExpression()) {
	      var callee = node.callee;
	      if (!t.isMemberExpression(callee)) return;
	      if (!t.isSuper(callee.object)) return;
	
	      t.appendToMemberExpression(callee, t.identifier("call"));
	      node.arguments.unshift(t.thisExpression());
	      return true;
	    }
	  };
	
	  ReplaceSupers.prototype.specHandleAssignmentExpression = function specHandleAssignmentExpression(ref, path, node) {
	    if (node.operator === "=") {
	      return this.setSuperProperty(node.left.property, node.right, node.left.computed);
	    } else {
	      ref = ref || path.scope.generateUidIdentifier("ref");
	      return [t.variableDeclaration("var", [t.variableDeclarator(ref, node.left)]), t.expressionStatement(t.assignmentExpression("=", node.left, t.binaryExpression(node.operator[0], ref, node.right)))];
	    }
	  };
	
	  ReplaceSupers.prototype.specHandle = function specHandle(path) {
	    var property = void 0;
	    var computed = void 0;
	    var args = void 0;
	
	    var parent = path.parent;
	    var node = path.node;
	
	    if (isIllegalBareSuper(node, parent)) {
	      throw path.buildCodeFrameError(messages.get("classesIllegalBareSuper"));
	    }
	
	    if (t.isCallExpression(node)) {
	      var callee = node.callee;
	      if (t.isSuper(callee)) {
	        return;
	      } else if (isMemberExpressionSuper(callee)) {
	        property = callee.property;
	        computed = callee.computed;
	        args = node.arguments;
	      }
	    } else if (t.isMemberExpression(node) && t.isSuper(node.object)) {
	      property = node.property;
	      computed = node.computed;
	    } else if (t.isUpdateExpression(node) && isMemberExpressionSuper(node.argument)) {
	      var binary = t.binaryExpression(node.operator[0], node.argument, t.numericLiteral(1));
	      if (node.prefix) {
	        return this.specHandleAssignmentExpression(null, path, binary);
	      } else {
	        var ref = path.scope.generateUidIdentifier("ref");
	        return this.specHandleAssignmentExpression(ref, path, binary).concat(t.expressionStatement(ref));
	      }
	    } else if (t.isAssignmentExpression(node) && isMemberExpressionSuper(node.left)) {
	      return this.specHandleAssignmentExpression(null, path, node);
	    }
	
	    if (!property) return;
	
	    var superProperty = this.getSuperProperty(property, computed);
	
	    if (args) {
	      return this.optimiseCall(superProperty, args);
	    } else {
	      return superProperty;
	    }
	  };
	
	  ReplaceSupers.prototype.optimiseCall = function optimiseCall(callee, args) {
	    var thisNode = t.thisExpression();
	    thisNode[HARDCORE_THIS_REF] = true;
	    return (0, _babelHelperOptimiseCallExpression2.default)(callee, thisNode, args);
	  };
	
	  return ReplaceSupers;
	}();
	
	exports.default = ReplaceSupers;
	module.exports = exports["default"];

/***/ }),
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.fetchLink = exports.fetchScript = undefined;
	exports._fetchScript = _fetchScript;
	exports._fetchLink = _fetchLink;
	
	var _rxjs = __webpack_require__(88);
	
	var _ajaxStream = __webpack_require__(281);
	
	// value used to break browser ajax caching
	var cacheBreakerValue = Math.random();
	
	function _fetchScript() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      src = _ref.src,
	      _ref$cacheBreaker = _ref.cacheBreaker,
	      cacheBreaker = _ref$cacheBreaker === undefined ? false : _ref$cacheBreaker,
	      _ref$crossDomain = _ref.crossDomain,
	      crossDomain = _ref$crossDomain === undefined ? true : _ref$crossDomain;
	
	  if (!src) {
	    throw new Error('No source provided for script');
	  }
	  if (this.cache.has(src)) {
	    return this.cache.get(src);
	  }
	  var url = cacheBreaker ? src + '?cacheBreaker=' + cacheBreakerValue : src;
	  var script = (0, _ajaxStream.ajax$)({ url: url, crossDomain: crossDomain }).do(function (res) {
	    if (res.status !== 200) {
	      throw new Error('Request errror: ' + res.status);
	    }
	  }).map(function (_ref2) {
	    var response = _ref2.response;
	    return response;
	  }).map(function (script) {
	    return '<script>' + script + '</script>';
	  }).shareReplay();
	
	  this.cache.set(src, script);
	  return script;
	}
	var fetchScript = exports.fetchScript = _fetchScript.bind({ cache: new Map() });
	
	function _fetchLink() {
	  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      href = _ref3.link,
	      _ref3$raw = _ref3.raw,
	      raw = _ref3$raw === undefined ? false : _ref3$raw,
	      _ref3$crossDomain = _ref3.crossDomain,
	      crossDomain = _ref3$crossDomain === undefined ? true : _ref3$crossDomain;
	
	  if (!href) {
	    return _rxjs.Observable.throw(new Error('No source provided for link'));
	  }
	  if (this.cache.has(href)) {
	    return this.cache.get(href);
	  }
	  // css files with `url(...` may not work in style tags
	  // so we put them in raw links
	  if (raw) {
	    var _link = _rxjs.Observable.of('<link href=' + href + ' rel=\'stylesheet\' />').shareReplay();
	    this.cache.set(href, _link);
	    return _link;
	  }
	  var link = (0, _ajaxStream.ajax$)({ url: href, crossDomain: crossDomain }).do(function (res) {
	    if (res.status !== 200) {
	      throw new Error('Request error: ' + res.status);
	    }
	  }).map(function (_ref4) {
	    var response = _ref4.response;
	    return response;
	  }).map(function (script) {
	    return '<style>' + script + '</style>';
	  }).catch(function () {
	    return _rxjs.Observable.of('');
	  }).shareReplay();
	
	  this.cache.set(href, link);
	  return link;
	}
	
	var fetchLink = exports.fetchLink = _fetchLink.bind({ cache: new Map() });

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  return {
	    manipulateOptions: function manipulateOptions(opts, parserOpts) {
	      parserOpts.plugins.push("jsx");
	    }
	  };
	};
	
	module.exports = exports["default"];

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _babelTraverse = __webpack_require__(91);
	
	var _babelHelperReplaceSupers = __webpack_require__(539);
	
	var _babelHelperReplaceSupers2 = _interopRequireDefault(_babelHelperReplaceSupers);
	
	var _babelHelperOptimiseCallExpression = __webpack_require__(537);
	
	var _babelHelperOptimiseCallExpression2 = _interopRequireDefault(_babelHelperOptimiseCallExpression);
	
	var _babelHelperDefineMap = __webpack_require__(861);
	
	var defineMap = _interopRequireWildcard(_babelHelperDefineMap);
	
	var _babelTemplate = __webpack_require__(84);
	
	var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buildDerivedConstructor = (0, _babelTemplate2.default)("\n  (function () {\n    super(...arguments);\n  })\n");
	
	var noMethodVisitor = {
	  "FunctionExpression|FunctionDeclaration": function FunctionExpressionFunctionDeclaration(path) {
	    if (!path.is("shadow")) {
	      path.skip();
	    }
	  },
	  Method: function Method(path) {
	    path.skip();
	  }
	};
	
	var verifyConstructorVisitor = _babelTraverse.visitors.merge([noMethodVisitor, {
	  Super: function Super(path) {
	    if (this.isDerived && !this.hasBareSuper && !path.parentPath.isCallExpression({ callee: path.node })) {
	      throw path.buildCodeFrameError("'super.*' is not allowed before super()");
	    }
	  },
	
	
	  CallExpression: {
	    exit: function exit(path) {
	      if (path.get("callee").isSuper()) {
	        this.hasBareSuper = true;
	
	        if (!this.isDerived) {
	          throw path.buildCodeFrameError("super() is only allowed in a derived constructor");
	        }
	      }
	    }
	  },
	
	  ThisExpression: function ThisExpression(path) {
	    if (this.isDerived && !this.hasBareSuper) {
	      if (!path.inShadow("this")) {
	        throw path.buildCodeFrameError("'this' is not allowed before super()");
	      }
	    }
	  }
	}]);
	
	var findThisesVisitor = _babelTraverse.visitors.merge([noMethodVisitor, {
	  ThisExpression: function ThisExpression(path) {
	    this.superThises.push(path);
	  }
	}]);
	
	var ClassTransformer = function () {
	  function ClassTransformer(path, file) {
	    (0, _classCallCheck3.default)(this, ClassTransformer);
	
	    this.parent = path.parent;
	    this.scope = path.scope;
	    this.node = path.node;
	    this.path = path;
	    this.file = file;
	
	    this.clearDescriptors();
	
	    this.instancePropBody = [];
	    this.instancePropRefs = {};
	    this.staticPropBody = [];
	    this.body = [];
	
	    this.bareSuperAfter = [];
	    this.bareSupers = [];
	
	    this.pushedConstructor = false;
	    this.pushedInherits = false;
	    this.isLoose = false;
	
	    this.superThises = [];
	
	    this.classId = this.node.id;
	
	    this.classRef = this.node.id ? t.identifier(this.node.id.name) : this.scope.generateUidIdentifier("class");
	
	    this.superName = this.node.superClass || t.identifier("Function");
	    this.isDerived = !!this.node.superClass;
	  }
	
	  ClassTransformer.prototype.run = function run() {
	    var _this = this;
	
	    var superName = this.superName;
	    var file = this.file;
	    var body = this.body;
	
	    var constructorBody = this.constructorBody = t.blockStatement([]);
	    this.constructor = this.buildConstructor();
	
	    var closureParams = [];
	    var closureArgs = [];
	
	    if (this.isDerived) {
	      closureArgs.push(superName);
	
	      superName = this.scope.generateUidIdentifierBasedOnNode(superName);
	      closureParams.push(superName);
	
	      this.superName = superName;
	    }
	
	    this.buildBody();
	
	    constructorBody.body.unshift(t.expressionStatement(t.callExpression(file.addHelper("classCallCheck"), [t.thisExpression(), this.classRef])));
	
	    body = body.concat(this.staticPropBody.map(function (fn) {
	      return fn(_this.classRef);
	    }));
	
	    if (this.classId) {
	      if (body.length === 1) return t.toExpression(body[0]);
	    }
	
	    body.push(t.returnStatement(this.classRef));
	
	    var container = t.functionExpression(null, closureParams, t.blockStatement(body));
	    container.shadow = true;
	    return t.callExpression(container, closureArgs);
	  };
	
	  ClassTransformer.prototype.buildConstructor = function buildConstructor() {
	    var func = t.functionDeclaration(this.classRef, [], this.constructorBody);
	    t.inherits(func, this.node);
	    return func;
	  };
	
	  ClassTransformer.prototype.pushToMap = function pushToMap(node, enumerable) {
	    var kind = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "value";
	    var scope = arguments[3];
	
	    var mutatorMap = void 0;
	    if (node.static) {
	      this.hasStaticDescriptors = true;
	      mutatorMap = this.staticMutatorMap;
	    } else {
	      this.hasInstanceDescriptors = true;
	      mutatorMap = this.instanceMutatorMap;
	    }
	
	    var map = defineMap.push(mutatorMap, node, kind, this.file, scope);
	
	    if (enumerable) {
	      map.enumerable = t.booleanLiteral(true);
	    }
	
	    return map;
	  };
	
	  ClassTransformer.prototype.constructorMeMaybe = function constructorMeMaybe() {
	    var hasConstructor = false;
	    var paths = this.path.get("body.body");
	    for (var _iterator = paths, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var path = _ref;
	
	      hasConstructor = path.equals("kind", "constructor");
	      if (hasConstructor) break;
	    }
	    if (hasConstructor) return;
	
	    var params = void 0,
	        body = void 0;
	
	    if (this.isDerived) {
	      var _constructor = buildDerivedConstructor().expression;
	      params = _constructor.params;
	      body = _constructor.body;
	    } else {
	      params = [];
	      body = t.blockStatement([]);
	    }
	
	    this.path.get("body").unshiftContainer("body", t.classMethod("constructor", t.identifier("constructor"), params, body));
	  };
	
	  ClassTransformer.prototype.buildBody = function buildBody() {
	    this.constructorMeMaybe();
	    this.pushBody();
	    this.verifyConstructor();
	
	    if (this.userConstructor) {
	      var constructorBody = this.constructorBody;
	      constructorBody.body = constructorBody.body.concat(this.userConstructor.body.body);
	      t.inherits(this.constructor, this.userConstructor);
	      t.inherits(constructorBody, this.userConstructor.body);
	    }
	
	    this.pushDescriptors();
	  };
	
	  ClassTransformer.prototype.pushBody = function pushBody() {
	    var classBodyPaths = this.path.get("body.body");
	
	    for (var _iterator2 = classBodyPaths, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var path = _ref2;
	
	      var node = path.node;
	
	      if (path.isClassProperty()) {
	        throw path.buildCodeFrameError("Missing class properties transform.");
	      }
	
	      if (node.decorators) {
	        throw path.buildCodeFrameError("Method has decorators, put the decorator plugin before the classes one.");
	      }
	
	      if (t.isClassMethod(node)) {
	        var isConstructor = node.kind === "constructor";
	
	        if (isConstructor) {
	          path.traverse(verifyConstructorVisitor, this);
	
	          if (!this.hasBareSuper && this.isDerived) {
	            throw path.buildCodeFrameError("missing super() call in constructor");
	          }
	        }
	
	        var replaceSupers = new _babelHelperReplaceSupers2.default({
	          forceSuperMemoisation: isConstructor,
	          methodPath: path,
	          methodNode: node,
	          objectRef: this.classRef,
	          superRef: this.superName,
	          isStatic: node.static,
	          isLoose: this.isLoose,
	          scope: this.scope,
	          file: this.file
	        }, true);
	
	        replaceSupers.replace();
	
	        if (isConstructor) {
	          this.pushConstructor(replaceSupers, node, path);
	        } else {
	          this.pushMethod(node, path);
	        }
	      }
	    }
	  };
	
	  ClassTransformer.prototype.clearDescriptors = function clearDescriptors() {
	    this.hasInstanceDescriptors = false;
	    this.hasStaticDescriptors = false;
	
	    this.instanceMutatorMap = {};
	    this.staticMutatorMap = {};
	  };
	
	  ClassTransformer.prototype.pushDescriptors = function pushDescriptors() {
	    this.pushInherits();
	
	    var body = this.body;
	
	    var instanceProps = void 0;
	    var staticProps = void 0;
	
	    if (this.hasInstanceDescriptors) {
	      instanceProps = defineMap.toClassObject(this.instanceMutatorMap);
	    }
	
	    if (this.hasStaticDescriptors) {
	      staticProps = defineMap.toClassObject(this.staticMutatorMap);
	    }
	
	    if (instanceProps || staticProps) {
	      if (instanceProps) instanceProps = defineMap.toComputedObjectFromClass(instanceProps);
	      if (staticProps) staticProps = defineMap.toComputedObjectFromClass(staticProps);
	
	      var nullNode = t.nullLiteral();
	
	      var args = [this.classRef, nullNode, nullNode, nullNode, nullNode];
	
	      if (instanceProps) args[1] = instanceProps;
	      if (staticProps) args[2] = staticProps;
	
	      if (this.instanceInitializersId) {
	        args[3] = this.instanceInitializersId;
	        body.unshift(this.buildObjectAssignment(this.instanceInitializersId));
	      }
	
	      if (this.staticInitializersId) {
	        args[4] = this.staticInitializersId;
	        body.unshift(this.buildObjectAssignment(this.staticInitializersId));
	      }
	
	      var lastNonNullIndex = 0;
	      for (var i = 0; i < args.length; i++) {
	        if (args[i] !== nullNode) lastNonNullIndex = i;
	      }
	      args = args.slice(0, lastNonNullIndex + 1);
	
	      body.push(t.expressionStatement(t.callExpression(this.file.addHelper("createClass"), args)));
	    }
	
	    this.clearDescriptors();
	  };
	
	  ClassTransformer.prototype.buildObjectAssignment = function buildObjectAssignment(id) {
	    return t.variableDeclaration("var", [t.variableDeclarator(id, t.objectExpression([]))]);
	  };
	
	  ClassTransformer.prototype.wrapSuperCall = function wrapSuperCall(bareSuper, superRef, thisRef, body) {
	    var bareSuperNode = bareSuper.node;
	
	    if (this.isLoose) {
	      bareSuperNode.arguments.unshift(t.thisExpression());
	      if (bareSuperNode.arguments.length === 2 && t.isSpreadElement(bareSuperNode.arguments[1]) && t.isIdentifier(bareSuperNode.arguments[1].argument, { name: "arguments" })) {
	        bareSuperNode.arguments[1] = bareSuperNode.arguments[1].argument;
	        bareSuperNode.callee = t.memberExpression(superRef, t.identifier("apply"));
	      } else {
	        bareSuperNode.callee = t.memberExpression(superRef, t.identifier("call"));
	      }
	    } else {
	      bareSuperNode = (0, _babelHelperOptimiseCallExpression2.default)(t.logicalExpression("||", t.memberExpression(this.classRef, t.identifier("__proto__")), t.callExpression(t.memberExpression(t.identifier("Object"), t.identifier("getPrototypeOf")), [this.classRef])), t.thisExpression(), bareSuperNode.arguments);
	    }
	
	    var call = t.callExpression(this.file.addHelper("possibleConstructorReturn"), [t.thisExpression(), bareSuperNode]);
	
	    var bareSuperAfter = this.bareSuperAfter.map(function (fn) {
	      return fn(thisRef);
	    });
	
	    if (bareSuper.parentPath.isExpressionStatement() && bareSuper.parentPath.container === body.node.body && body.node.body.length - 1 === bareSuper.parentPath.key) {
	
	      if (this.superThises.length || bareSuperAfter.length) {
	        bareSuper.scope.push({ id: thisRef });
	        call = t.assignmentExpression("=", thisRef, call);
	      }
	
	      if (bareSuperAfter.length) {
	        call = t.toSequenceExpression([call].concat(bareSuperAfter, [thisRef]));
	      }
	
	      bareSuper.parentPath.replaceWith(t.returnStatement(call));
	    } else {
	      bareSuper.replaceWithMultiple([t.variableDeclaration("var", [t.variableDeclarator(thisRef, call)])].concat(bareSuperAfter, [t.expressionStatement(thisRef)]));
	    }
	  };
	
	  ClassTransformer.prototype.verifyConstructor = function verifyConstructor() {
	    var _this2 = this;
	
	    if (!this.isDerived) return;
	
	    var path = this.userConstructorPath;
	    var body = path.get("body");
	
	    path.traverse(findThisesVisitor, this);
	
	    var guaranteedSuperBeforeFinish = !!this.bareSupers.length;
	
	    var superRef = this.superName || t.identifier("Function");
	    var thisRef = path.scope.generateUidIdentifier("this");
	
	    for (var _iterator3 = this.bareSupers, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
	      var _ref3;
	
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }
	
	      var bareSuper = _ref3;
	
	      this.wrapSuperCall(bareSuper, superRef, thisRef, body);
	
	      if (guaranteedSuperBeforeFinish) {
	        bareSuper.find(function (parentPath) {
	          if (parentPath === path) {
	            return true;
	          }
	
	          if (parentPath.isLoop() || parentPath.isConditional()) {
	            guaranteedSuperBeforeFinish = false;
	            return true;
	          }
	        });
	      }
	    }
	
	    for (var _iterator4 = this.superThises, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
	      var _ref4;
	
	      if (_isArray4) {
	        if (_i4 >= _iterator4.length) break;
	        _ref4 = _iterator4[_i4++];
	      } else {
	        _i4 = _iterator4.next();
	        if (_i4.done) break;
	        _ref4 = _i4.value;
	      }
	
	      var thisPath = _ref4;
	
	      thisPath.replaceWith(thisRef);
	    }
	
	    var wrapReturn = function wrapReturn(returnArg) {
	      return t.callExpression(_this2.file.addHelper("possibleConstructorReturn"), [thisRef].concat(returnArg || []));
	    };
	
	    var bodyPaths = body.get("body");
	    if (bodyPaths.length && !bodyPaths.pop().isReturnStatement()) {
	      body.pushContainer("body", t.returnStatement(guaranteedSuperBeforeFinish ? thisRef : wrapReturn()));
	    }
	
	    for (var _iterator5 = this.superReturns, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : (0, _getIterator3.default)(_iterator5);;) {
	      var _ref5;
	
	      if (_isArray5) {
	        if (_i5 >= _iterator5.length) break;
	        _ref5 = _iterator5[_i5++];
	      } else {
	        _i5 = _iterator5.next();
	        if (_i5.done) break;
	        _ref5 = _i5.value;
	      }
	
	      var returnPath = _ref5;
	
	      if (returnPath.node.argument) {
	        var ref = returnPath.scope.generateDeclaredUidIdentifier("ret");
	        returnPath.get("argument").replaceWithMultiple([t.assignmentExpression("=", ref, returnPath.node.argument), wrapReturn(ref)]);
	      } else {
	        returnPath.get("argument").replaceWith(wrapReturn());
	      }
	    }
	  };
	
	  ClassTransformer.prototype.pushMethod = function pushMethod(node, path) {
	    var scope = path ? path.scope : this.scope;
	
	    if (node.kind === "method") {
	      if (this._processMethod(node, scope)) return;
	    }
	
	    this.pushToMap(node, false, null, scope);
	  };
	
	  ClassTransformer.prototype._processMethod = function _processMethod() {
	    return false;
	  };
	
	  ClassTransformer.prototype.pushConstructor = function pushConstructor(replaceSupers, method, path) {
	    this.bareSupers = replaceSupers.bareSupers;
	    this.superReturns = replaceSupers.returns;
	
	    if (path.scope.hasOwnBinding(this.classRef.name)) {
	      path.scope.rename(this.classRef.name);
	    }
	
	    var construct = this.constructor;
	
	    this.userConstructorPath = path;
	    this.userConstructor = method;
	    this.hasConstructor = true;
	
	    t.inheritsComments(construct, method);
	
	    construct._ignoreUserWhitespace = true;
	    construct.params = method.params;
	
	    t.inherits(construct.body, method.body);
	    construct.body.directives = method.body.directives;
	
	    this._pushConstructor();
	  };
	
	  ClassTransformer.prototype._pushConstructor = function _pushConstructor() {
	    if (this.pushedConstructor) return;
	    this.pushedConstructor = true;
	
	    if (this.hasInstanceDescriptors || this.hasStaticDescriptors) {
	      this.pushDescriptors();
	    }
	
	    this.body.push(this.constructor);
	
	    this.pushInherits();
	  };
	
	  ClassTransformer.prototype.pushInherits = function pushInherits() {
	    if (!this.isDerived || this.pushedInherits) return;
	
	    this.pushedInherits = true;
	    this.body.unshift(t.expressionStatement(t.callExpression(this.file.addHelper("inherits"), [this.classRef, this.superName])));
	  };
	
	  return ClassTransformer;
	}();
	
	exports.default = ClassTransformer;
	module.exports = exports["default"];

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _create = __webpack_require__(82);
	
	var _create2 = _interopRequireDefault(_create);
	
	exports.default = function (_ref) {
	  var t = _ref.types;
	
	  function isValidRequireCall(path) {
	    if (!path.isCallExpression()) return false;
	    if (!path.get("callee").isIdentifier({ name: "require" })) return false;
	    if (path.scope.getBinding("require")) return false;
	
	    var args = path.get("arguments");
	    if (args.length !== 1) return false;
	
	    var arg = args[0];
	    if (!arg.isStringLiteral()) return false;
	
	    return true;
	  }
	
	  var amdVisitor = {
	    ReferencedIdentifier: function ReferencedIdentifier(_ref2) {
	      var node = _ref2.node,
	          scope = _ref2.scope;
	
	      if (node.name === "exports" && !scope.getBinding("exports")) {
	        this.hasExports = true;
	      }
	
	      if (node.name === "module" && !scope.getBinding("module")) {
	        this.hasModule = true;
	      }
	    },
	    CallExpression: function CallExpression(path) {
	      if (!isValidRequireCall(path)) return;
	      this.bareSources.push(path.node.arguments[0]);
	      path.remove();
	    },
	    VariableDeclarator: function VariableDeclarator(path) {
	      var id = path.get("id");
	      if (!id.isIdentifier()) return;
	
	      var init = path.get("init");
	      if (!isValidRequireCall(init)) return;
	
	      var source = init.node.arguments[0];
	      this.sourceNames[source.value] = true;
	      this.sources.push([id.node, source]);
	
	      path.remove();
	    }
	  };
	
	  return {
	    inherits: __webpack_require__(547),
	
	    pre: function pre() {
	      this.sources = [];
	      this.sourceNames = (0, _create2.default)(null);
	
	      this.bareSources = [];
	
	      this.hasExports = false;
	      this.hasModule = false;
	    },
	
	
	    visitor: {
	      Program: {
	        exit: function exit(path) {
	          var _this = this;
	
	          if (this.ran) return;
	          this.ran = true;
	
	          path.traverse(amdVisitor, this);
	
	          var params = this.sources.map(function (source) {
	            return source[0];
	          });
	          var sources = this.sources.map(function (source) {
	            return source[1];
	          });
	
	          sources = sources.concat(this.bareSources.filter(function (str) {
	            return !_this.sourceNames[str.value];
	          }));
	
	          var moduleName = this.getModuleName();
	          if (moduleName) moduleName = t.stringLiteral(moduleName);
	
	          if (this.hasExports) {
	            sources.unshift(t.stringLiteral("exports"));
	            params.unshift(t.identifier("exports"));
	          }
	
	          if (this.hasModule) {
	            sources.unshift(t.stringLiteral("module"));
	            params.unshift(t.identifier("module"));
	          }
	
	          var node = path.node;
	
	          var factory = buildFactory({
	            PARAMS: params,
	            BODY: node.body
	          });
	          factory.expression.body.directives = node.directives;
	          node.directives = [];
	
	          node.body = [buildDefine({
	            MODULE_NAME: moduleName,
	            SOURCES: sources,
	            FACTORY: factory
	          })];
	        }
	      }
	    }
	  };
	};
	
	var _babelTemplate = __webpack_require__(84);
	
	var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buildDefine = (0, _babelTemplate2.default)("\n  define(MODULE_NAME, [SOURCES], FACTORY);\n");
	
	var buildFactory = (0, _babelTemplate2.default)("\n  (function (PARAMS) {\n    BODY;\n  })\n");
	
	module.exports = exports["default"];

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _keys = __webpack_require__(90);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _create = __webpack_require__(82);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _symbol = __webpack_require__(83);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	exports.default = function () {
	  var REASSIGN_REMAP_SKIP = (0, _symbol2.default)();
	
	  var reassignmentVisitor = {
	    ReferencedIdentifier: function ReferencedIdentifier(path) {
	      var name = path.node.name;
	      var remap = this.remaps[name];
	      if (!remap) return;
	
	      if (this.scope.getBinding(name) !== path.scope.getBinding(name)) return;
	
	      if (path.parentPath.isCallExpression({ callee: path.node })) {
	        path.replaceWith(t.sequenceExpression([t.numericLiteral(0), remap]));
	      } else if (path.isJSXIdentifier() && t.isMemberExpression(remap)) {
	        var object = remap.object,
	            property = remap.property;
	
	        path.replaceWith(t.JSXMemberExpression(t.JSXIdentifier(object.name), t.JSXIdentifier(property.name)));
	      } else {
	        path.replaceWith(remap);
	      }
	      this.requeueInParent(path);
	    },
	    AssignmentExpression: function AssignmentExpression(path) {
	      var node = path.node;
	      if (node[REASSIGN_REMAP_SKIP]) return;
	
	      var left = path.get("left");
	      if (left.isIdentifier()) {
	        var name = left.node.name;
	        var exports = this.exports[name];
	        if (!exports) return;
	
	        if (this.scope.getBinding(name) !== path.scope.getBinding(name)) return;
	
	        node[REASSIGN_REMAP_SKIP] = true;
	
	        for (var _iterator = exports, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	          var _ref;
	
	          if (_isArray) {
	            if (_i >= _iterator.length) break;
	            _ref = _iterator[_i++];
	          } else {
	            _i = _iterator.next();
	            if (_i.done) break;
	            _ref = _i.value;
	          }
	
	          var reid = _ref;
	
	          node = buildExportsAssignment(reid, node).expression;
	        }
	
	        path.replaceWith(node);
	        this.requeueInParent(path);
	      } else if (left.isObjectPattern()) {
	        for (var _iterator2 = left.node.properties, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	          var _ref2;
	
	          if (_isArray2) {
	            if (_i2 >= _iterator2.length) break;
	            _ref2 = _iterator2[_i2++];
	          } else {
	            _i2 = _iterator2.next();
	            if (_i2.done) break;
	            _ref2 = _i2.value;
	          }
	
	          var property = _ref2;
	
	          var _name = property.value.name;
	
	          var _exports = this.exports[_name];
	          if (!_exports) continue;
	
	          if (this.scope.getBinding(_name) !== path.scope.getBinding(_name)) return;
	
	          node[REASSIGN_REMAP_SKIP] = true;
	
	          path.insertAfter(buildExportsAssignment(t.identifier(_name), t.identifier(_name)));
	        }
	      } else if (left.isArrayPattern()) {
	        for (var _iterator3 = left.node.elements, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
	          var _ref3;
	
	          if (_isArray3) {
	            if (_i3 >= _iterator3.length) break;
	            _ref3 = _iterator3[_i3++];
	          } else {
	            _i3 = _iterator3.next();
	            if (_i3.done) break;
	            _ref3 = _i3.value;
	          }
	
	          var element = _ref3;
	
	          if (!element) continue;
	          var _name2 = element.name;
	
	          var _exports2 = this.exports[_name2];
	          if (!_exports2) continue;
	
	          if (this.scope.getBinding(_name2) !== path.scope.getBinding(_name2)) return;
	
	          node[REASSIGN_REMAP_SKIP] = true;
	
	          path.insertAfter(buildExportsAssignment(t.identifier(_name2), t.identifier(_name2)));
	        }
	      }
	    },
	    UpdateExpression: function UpdateExpression(path) {
	      var arg = path.get("argument");
	      if (!arg.isIdentifier()) return;
	
	      var name = arg.node.name;
	      var exports = this.exports[name];
	      if (!exports) return;
	
	      if (this.scope.getBinding(name) !== path.scope.getBinding(name)) return;
	
	      var node = t.assignmentExpression(path.node.operator[0] + "=", arg.node, t.numericLiteral(1));
	
	      if (path.parentPath.isExpressionStatement() && !path.isCompletionRecord() || path.node.prefix) {
	        path.replaceWith(node);
	        this.requeueInParent(path);
	        return;
	      }
	
	      var nodes = [];
	      nodes.push(node);
	
	      var operator = void 0;
	      if (path.node.operator === "--") {
	        operator = "+";
	      } else {
	        operator = "-";
	      }
	      nodes.push(t.binaryExpression(operator, arg.node, t.numericLiteral(1)));
	
	      path.replaceWithMultiple(t.sequenceExpression(nodes));
	    }
	  };
	
	  return {
	    inherits: _babelPluginTransformStrictMode2.default,
	
	    visitor: {
	      ThisExpression: function ThisExpression(path, state) {
	        if (this.ranCommonJS) return;
	
	        if (state.opts.allowTopLevelThis !== true && !path.findParent(function (path) {
	          return !path.is("shadow") && THIS_BREAK_KEYS.indexOf(path.type) >= 0;
	        })) {
	          path.replaceWith(t.identifier("undefined"));
	        }
	      },
	
	
	      Program: {
	        exit: function exit(path) {
	          this.ranCommonJS = true;
	
	          var strict = !!this.opts.strict;
	          var noInterop = !!this.opts.noInterop;
	
	          var scope = path.scope;
	
	          scope.rename("module");
	          scope.rename("exports");
	          scope.rename("require");
	
	          var hasExports = false;
	          var hasImports = false;
	
	          var body = path.get("body");
	          var imports = (0, _create2.default)(null);
	          var exports = (0, _create2.default)(null);
	
	          var nonHoistedExportNames = (0, _create2.default)(null);
	
	          var topNodes = [];
	          var remaps = (0, _create2.default)(null);
	
	          var requires = (0, _create2.default)(null);
	
	          function addRequire(source, blockHoist) {
	            var cached = requires[source];
	            if (cached) return cached;
	
	            var ref = path.scope.generateUidIdentifier((0, _path2.basename)(source, (0, _path2.extname)(source)));
	
	            var varDecl = t.variableDeclaration("var", [t.variableDeclarator(ref, buildRequire(t.stringLiteral(source)).expression)]);
	
	            if (imports[source]) {
	              varDecl.loc = imports[source].loc;
	            }
	
	            if (typeof blockHoist === "number" && blockHoist > 0) {
	              varDecl._blockHoist = blockHoist;
	            }
	
	            topNodes.push(varDecl);
	
	            return requires[source] = ref;
	          }
	
	          function addTo(obj, key, arr) {
	            var existing = obj[key] || [];
	            obj[key] = existing.concat(arr);
	          }
	
	          for (var _iterator4 = body, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
	            var _ref4;
	
	            if (_isArray4) {
	              if (_i4 >= _iterator4.length) break;
	              _ref4 = _iterator4[_i4++];
	            } else {
	              _i4 = _iterator4.next();
	              if (_i4.done) break;
	              _ref4 = _i4.value;
	            }
	
	            var _path = _ref4;
	
	            if (_path.isExportDeclaration()) {
	              hasExports = true;
	
	              var specifiers = [].concat(_path.get("declaration"), _path.get("specifiers"));
	              for (var _iterator6 = specifiers, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : (0, _getIterator3.default)(_iterator6);;) {
	                var _ref6;
	
	                if (_isArray6) {
	                  if (_i6 >= _iterator6.length) break;
	                  _ref6 = _iterator6[_i6++];
	                } else {
	                  _i6 = _iterator6.next();
	                  if (_i6.done) break;
	                  _ref6 = _i6.value;
	                }
	
	                var _specifier2 = _ref6;
	
	                var ids = _specifier2.getBindingIdentifiers();
	                if (ids.__esModule) {
	                  throw _specifier2.buildCodeFrameError("Illegal export \"__esModule\"");
	                }
	              }
	            }
	
	            if (_path.isImportDeclaration()) {
	              var _importsEntry$specifi;
	
	              hasImports = true;
	
	              var key = _path.node.source.value;
	              var importsEntry = imports[key] || {
	                specifiers: [],
	                maxBlockHoist: 0,
	                loc: _path.node.loc
	              };
	
	              (_importsEntry$specifi = importsEntry.specifiers).push.apply(_importsEntry$specifi, _path.node.specifiers);
	
	              if (typeof _path.node._blockHoist === "number") {
	                importsEntry.maxBlockHoist = Math.max(_path.node._blockHoist, importsEntry.maxBlockHoist);
	              }
	
	              imports[key] = importsEntry;
	
	              _path.remove();
	            } else if (_path.isExportDefaultDeclaration()) {
	              var declaration = _path.get("declaration");
	              if (declaration.isFunctionDeclaration()) {
	                var id = declaration.node.id;
	                var defNode = t.identifier("default");
	                if (id) {
	                  addTo(exports, id.name, defNode);
	                  topNodes.push(buildExportsAssignment(defNode, id));
	                  _path.replaceWith(declaration.node);
	                } else {
	                  topNodes.push(buildExportsAssignment(defNode, t.toExpression(declaration.node)));
	                  _path.remove();
	                }
	              } else if (declaration.isClassDeclaration()) {
	                var _id = declaration.node.id;
	                var _defNode = t.identifier("default");
	                if (_id) {
	                  addTo(exports, _id.name, _defNode);
	                  _path.replaceWithMultiple([declaration.node, buildExportsAssignment(_defNode, _id)]);
	                } else {
	                  _path.replaceWith(buildExportsAssignment(_defNode, t.toExpression(declaration.node)));
	
	                  _path.parentPath.requeue(_path.get("expression.left"));
	                }
	              } else {
	                _path.replaceWith(buildExportsAssignment(t.identifier("default"), declaration.node));
	
	                _path.parentPath.requeue(_path.get("expression.left"));
	              }
	            } else if (_path.isExportNamedDeclaration()) {
	              var _declaration = _path.get("declaration");
	              if (_declaration.node) {
	                if (_declaration.isFunctionDeclaration()) {
	                  var _id2 = _declaration.node.id;
	                  addTo(exports, _id2.name, _id2);
	                  topNodes.push(buildExportsAssignment(_id2, _id2));
	                  _path.replaceWith(_declaration.node);
	                } else if (_declaration.isClassDeclaration()) {
	                  var _id3 = _declaration.node.id;
	                  addTo(exports, _id3.name, _id3);
	                  _path.replaceWithMultiple([_declaration.node, buildExportsAssignment(_id3, _id3)]);
	                  nonHoistedExportNames[_id3.name] = true;
	                } else if (_declaration.isVariableDeclaration()) {
	                  var declarators = _declaration.get("declarations");
	                  for (var _iterator7 = declarators, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : (0, _getIterator3.default)(_iterator7);;) {
	                    var _ref7;
	
	                    if (_isArray7) {
	                      if (_i7 >= _iterator7.length) break;
	                      _ref7 = _iterator7[_i7++];
	                    } else {
	                      _i7 = _iterator7.next();
	                      if (_i7.done) break;
	                      _ref7 = _i7.value;
	                    }
	
	                    var decl = _ref7;
	
	                    var _id4 = decl.get("id");
	
	                    var init = decl.get("init");
	                    var exportsToInsert = [];
	                    if (!init.node) init.replaceWith(t.identifier("undefined"));
	
	                    if (_id4.isIdentifier()) {
	                      addTo(exports, _id4.node.name, _id4.node);
	                      init.replaceWith(buildExportsAssignment(_id4.node, init.node).expression);
	                      nonHoistedExportNames[_id4.node.name] = true;
	                    } else if (_id4.isObjectPattern()) {
	                      for (var _i8 = 0; _i8 < _id4.node.properties.length; _i8++) {
	                        var prop = _id4.node.properties[_i8];
	                        var propValue = prop.value;
	                        if (t.isAssignmentPattern(propValue)) {
	                          propValue = propValue.left;
	                        } else if (t.isRestProperty(prop)) {
	                          propValue = prop.argument;
	                        }
	                        addTo(exports, propValue.name, propValue);
	                        exportsToInsert.push(buildExportsAssignment(propValue, propValue));
	                        nonHoistedExportNames[propValue.name] = true;
	                      }
	                    } else if (_id4.isArrayPattern() && _id4.node.elements) {
	                      for (var _i9 = 0; _i9 < _id4.node.elements.length; _i9++) {
	                        var elem = _id4.node.elements[_i9];
	                        if (!elem) continue;
	                        if (t.isAssignmentPattern(elem)) {
	                          elem = elem.left;
	                        } else if (t.isRestElement(elem)) {
	                          elem = elem.argument;
	                        }
	                        var name = elem.name;
	                        addTo(exports, name, elem);
	                        exportsToInsert.push(buildExportsAssignment(elem, elem));
	                        nonHoistedExportNames[name] = true;
	                      }
	                    }
	                    _path.insertAfter(exportsToInsert);
	                  }
	                  _path.replaceWith(_declaration.node);
	                }
	                continue;
	              }
	
	              var _specifiers = _path.get("specifiers");
	              var nodes = [];
	              var _source = _path.node.source;
	              if (_source) {
	                var ref = addRequire(_source.value, _path.node._blockHoist);
	
	                for (var _iterator8 = _specifiers, _isArray8 = Array.isArray(_iterator8), _i10 = 0, _iterator8 = _isArray8 ? _iterator8 : (0, _getIterator3.default)(_iterator8);;) {
	                  var _ref8;
	
	                  if (_isArray8) {
	                    if (_i10 >= _iterator8.length) break;
	                    _ref8 = _iterator8[_i10++];
	                  } else {
	                    _i10 = _iterator8.next();
	                    if (_i10.done) break;
	                    _ref8 = _i10.value;
	                  }
	
	                  var _specifier3 = _ref8;
	
	                  if (_specifier3.isExportNamespaceSpecifier()) {} else if (_specifier3.isExportDefaultSpecifier()) {} else if (_specifier3.isExportSpecifier()) {
	                    if (!noInterop && _specifier3.node.local.name === "default") {
	                      topNodes.push(buildExportsFrom(t.stringLiteral(_specifier3.node.exported.name), t.memberExpression(t.callExpression(this.addHelper("interopRequireDefault"), [ref]), _specifier3.node.local)));
	                    } else {
	                      topNodes.push(buildExportsFrom(t.stringLiteral(_specifier3.node.exported.name), t.memberExpression(ref, _specifier3.node.local)));
	                    }
	                    nonHoistedExportNames[_specifier3.node.exported.name] = true;
	                  }
	                }
	              } else {
	                for (var _iterator9 = _specifiers, _isArray9 = Array.isArray(_iterator9), _i11 = 0, _iterator9 = _isArray9 ? _iterator9 : (0, _getIterator3.default)(_iterator9);;) {
	                  var _ref9;
	
	                  if (_isArray9) {
	                    if (_i11 >= _iterator9.length) break;
	                    _ref9 = _iterator9[_i11++];
	                  } else {
	                    _i11 = _iterator9.next();
	                    if (_i11.done) break;
	                    _ref9 = _i11.value;
	                  }
	
	                  var _specifier4 = _ref9;
	
	                  if (_specifier4.isExportSpecifier()) {
	                    addTo(exports, _specifier4.node.local.name, _specifier4.node.exported);
	                    nonHoistedExportNames[_specifier4.node.exported.name] = true;
	                    nodes.push(buildExportsAssignment(_specifier4.node.exported, _specifier4.node.local));
	                  }
	                }
	              }
	              _path.replaceWithMultiple(nodes);
	            } else if (_path.isExportAllDeclaration()) {
	              var exportNode = buildExportAll({
	                OBJECT: addRequire(_path.node.source.value, _path.node._blockHoist)
	              });
	              exportNode.loc = _path.node.loc;
	              topNodes.push(exportNode);
	              _path.remove();
	            }
	          }
	
	          for (var source in imports) {
	            var _imports$source = imports[source],
	                specifiers = _imports$source.specifiers,
	                maxBlockHoist = _imports$source.maxBlockHoist;
	
	            if (specifiers.length) {
	              var uid = addRequire(source, maxBlockHoist);
	
	              var wildcard = void 0;
	
	              for (var i = 0; i < specifiers.length; i++) {
	                var specifier = specifiers[i];
	                if (t.isImportNamespaceSpecifier(specifier)) {
	                  if (strict || noInterop) {
	                    remaps[specifier.local.name] = uid;
	                  } else {
	                    var varDecl = t.variableDeclaration("var", [t.variableDeclarator(specifier.local, t.callExpression(this.addHelper("interopRequireWildcard"), [uid]))]);
	
	                    if (maxBlockHoist > 0) {
	                      varDecl._blockHoist = maxBlockHoist;
	                    }
	
	                    topNodes.push(varDecl);
	                  }
	                  wildcard = specifier.local;
	                } else if (t.isImportDefaultSpecifier(specifier)) {
	                  specifiers[i] = t.importSpecifier(specifier.local, t.identifier("default"));
	                }
	              }
	
	              for (var _iterator5 = specifiers, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : (0, _getIterator3.default)(_iterator5);;) {
	                var _ref5;
	
	                if (_isArray5) {
	                  if (_i5 >= _iterator5.length) break;
	                  _ref5 = _iterator5[_i5++];
	                } else {
	                  _i5 = _iterator5.next();
	                  if (_i5.done) break;
	                  _ref5 = _i5.value;
	                }
	
	                var _specifier = _ref5;
	
	                if (t.isImportSpecifier(_specifier)) {
	                  var target = uid;
	                  if (_specifier.imported.name === "default") {
	                    if (wildcard) {
	                      target = wildcard;
	                    } else if (!noInterop) {
	                      target = wildcard = path.scope.generateUidIdentifier(uid.name);
	                      var _varDecl = t.variableDeclaration("var", [t.variableDeclarator(target, t.callExpression(this.addHelper("interopRequireDefault"), [uid]))]);
	
	                      if (maxBlockHoist > 0) {
	                        _varDecl._blockHoist = maxBlockHoist;
	                      }
	
	                      topNodes.push(_varDecl);
	                    }
	                  }
	                  remaps[_specifier.local.name] = t.memberExpression(target, t.cloneWithoutLoc(_specifier.imported));
	                }
	              }
	            } else {
	              var requireNode = buildRequire(t.stringLiteral(source));
	              requireNode.loc = imports[source].loc;
	              topNodes.push(requireNode);
	            }
	          }
	
	          if (hasImports && (0, _keys2.default)(nonHoistedExportNames).length) {
	            var maxHoistedExportsNodeAssignmentLength = 100;
	            var nonHoistedExportNamesArr = (0, _keys2.default)(nonHoistedExportNames);
	
	            var _loop = function _loop(currentExportsNodeAssignmentLength) {
	              var nonHoistedExportNamesChunk = nonHoistedExportNamesArr.slice(currentExportsNodeAssignmentLength, currentExportsNodeAssignmentLength + maxHoistedExportsNodeAssignmentLength);
	
	              var hoistedExportsNode = t.identifier("undefined");
	
	              nonHoistedExportNamesChunk.forEach(function (name) {
	                hoistedExportsNode = buildExportsAssignment(t.identifier(name), hoistedExportsNode).expression;
	              });
	
	              var node = t.expressionStatement(hoistedExportsNode);
	              node._blockHoist = 3;
	
	              topNodes.unshift(node);
	            };
	
	            for (var currentExportsNodeAssignmentLength = 0; currentExportsNodeAssignmentLength < nonHoistedExportNamesArr.length; currentExportsNodeAssignmentLength += maxHoistedExportsNodeAssignmentLength) {
	              _loop(currentExportsNodeAssignmentLength);
	            }
	          }
	
	          if (hasExports && !strict) {
	            var buildTemplate = buildExportsModuleDeclaration;
	            if (this.opts.loose) buildTemplate = buildLooseExportsModuleDeclaration;
	
	            var declar = buildTemplate();
	            declar._blockHoist = 3;
	
	            topNodes.unshift(declar);
	          }
	
	          path.unshiftContainer("body", topNodes);
	          path.traverse(reassignmentVisitor, {
	            remaps: remaps,
	            scope: scope,
	            exports: exports,
	            requeueInParent: function requeueInParent(newPath) {
	              return path.requeue(newPath);
	            }
	          });
	        }
	      }
	    }
	  };
	};
	
	var _path2 = __webpack_require__(484);
	
	var _babelTemplate = __webpack_require__(84);
	
	var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
	var _babelPluginTransformStrictMode = __webpack_require__(956);
	
	var _babelPluginTransformStrictMode2 = _interopRequireDefault(_babelPluginTransformStrictMode);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buildRequire = (0, _babelTemplate2.default)("\n  require($0);\n");
	
	var buildExportsModuleDeclaration = (0, _babelTemplate2.default)("\n  Object.defineProperty(exports, \"__esModule\", {\n    value: true\n  });\n");
	
	var buildExportsFrom = (0, _babelTemplate2.default)("\n  Object.defineProperty(exports, $0, {\n    enumerable: true,\n    get: function () {\n      return $1;\n    }\n  });\n");
	
	var buildLooseExportsModuleDeclaration = (0, _babelTemplate2.default)("\n  exports.__esModule = true;\n");
	
	var buildExportsAssignment = (0, _babelTemplate2.default)("\n  exports.$0 = $1;\n");
	
	var buildExportAll = (0, _babelTemplate2.default)("\n  Object.keys(OBJECT).forEach(function (key) {\n    if (key === \"default\" || key === \"__esModule\") return;\n    Object.defineProperty(exports, key, {\n      enumerable: true,\n      get: function () {\n        return OBJECT[key];\n      }\n    });\n  });\n");
	
	var THIS_BREAK_KEYS = ["FunctionExpression", "FunctionDeclaration", "ClassProperty", "ClassMethod", "ObjectMethod"];
	
	module.exports = exports["default"];

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1037), __esModule: true };

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1049), __esModule: true };

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hub = function Hub(file, options) {
	  (0, _classCallCheck3.default)(this, Hub);
	
	  this.file = file;
	  this.options = options;
	};
	
	exports.default = Hub;
	module.exports = exports["default"];

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Flow = exports.Pure = exports.Generated = exports.User = exports.Var = exports.BlockScoped = exports.Referenced = exports.Scope = exports.Expression = exports.Statement = exports.BindingIdentifier = exports.ReferencedMemberExpression = exports.ReferencedIdentifier = undefined;
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var ReferencedIdentifier = exports.ReferencedIdentifier = {
	  types: ["Identifier", "JSXIdentifier"],
	  checkPath: function checkPath(_ref, opts) {
	    var node = _ref.node,
	        parent = _ref.parent;
	
	    if (!t.isIdentifier(node, opts) && !t.isJSXMemberExpression(parent, opts)) {
	      if (t.isJSXIdentifier(node, opts)) {
	        if (_babelTypes.react.isCompatTag(node.name)) return false;
	      } else {
	        return false;
	      }
	    }
	
	    return t.isReferenced(node, parent);
	  }
	};
	
	var ReferencedMemberExpression = exports.ReferencedMemberExpression = {
	  types: ["MemberExpression"],
	  checkPath: function checkPath(_ref2) {
	    var node = _ref2.node,
	        parent = _ref2.parent;
	
	    return t.isMemberExpression(node) && t.isReferenced(node, parent);
	  }
	};
	
	var BindingIdentifier = exports.BindingIdentifier = {
	  types: ["Identifier"],
	  checkPath: function checkPath(_ref3) {
	    var node = _ref3.node,
	        parent = _ref3.parent;
	
	    return t.isIdentifier(node) && t.isBinding(node, parent);
	  }
	};
	
	var Statement = exports.Statement = {
	  types: ["Statement"],
	  checkPath: function checkPath(_ref4) {
	    var node = _ref4.node,
	        parent = _ref4.parent;
	
	    if (t.isStatement(node)) {
	      if (t.isVariableDeclaration(node)) {
	        if (t.isForXStatement(parent, { left: node })) return false;
	        if (t.isForStatement(parent, { init: node })) return false;
	      }
	
	      return true;
	    } else {
	      return false;
	    }
	  }
	};
	
	var Expression = exports.Expression = {
	  types: ["Expression"],
	  checkPath: function checkPath(path) {
	    if (path.isIdentifier()) {
	      return path.isReferencedIdentifier();
	    } else {
	      return t.isExpression(path.node);
	    }
	  }
	};
	
	var Scope = exports.Scope = {
	  types: ["Scopable"],
	  checkPath: function checkPath(path) {
	    return t.isScope(path.node, path.parent);
	  }
	};
	
	var Referenced = exports.Referenced = {
	  checkPath: function checkPath(path) {
	    return t.isReferenced(path.node, path.parent);
	  }
	};
	
	var BlockScoped = exports.BlockScoped = {
	  checkPath: function checkPath(path) {
	    return t.isBlockScoped(path.node);
	  }
	};
	
	var Var = exports.Var = {
	  types: ["VariableDeclaration"],
	  checkPath: function checkPath(path) {
	    return t.isVar(path.node);
	  }
	};
	
	var User = exports.User = {
	  checkPath: function checkPath(path) {
	    return path.node && !!path.node.loc;
	  }
	};
	
	var Generated = exports.Generated = {
	  checkPath: function checkPath(path) {
	    return !path.isUser();
	  }
	};
	
	var Pure = exports.Pure = {
	  checkPath: function checkPath(path, opts) {
	    return path.scope.isPure(path.node, opts);
	  }
	};
	
	var Flow = exports.Flow = {
	  types: ["Flow", "ImportDeclaration", "ExportDeclaration", "ImportSpecifier"],
	  checkPath: function checkPath(_ref5) {
	    var node = _ref5.node;
	
	    if (t.isFlow(node)) {
	      return true;
	    } else if (t.isImportDeclaration(node)) {
	      return node.importKind === "type" || node.importKind === "typeof";
	    } else if (t.isExportDeclaration(node)) {
	      return node.exportKind === "type";
	    } else if (t.isImportSpecifier(node)) {
	      return node.importKind === "type" || node.importKind === "typeof";
	    } else {
	      return false;
	    }
	  }
	};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Binding = function () {
	  function Binding(_ref) {
	    var existing = _ref.existing,
	        identifier = _ref.identifier,
	        scope = _ref.scope,
	        path = _ref.path,
	        kind = _ref.kind;
	    (0, _classCallCheck3.default)(this, Binding);
	
	    this.identifier = identifier;
	    this.scope = scope;
	    this.path = path;
	    this.kind = kind;
	
	    this.constantViolations = [];
	    this.constant = true;
	
	    this.referencePaths = [];
	    this.referenced = false;
	    this.references = 0;
	
	    this.clearValue();
	
	    if (existing) {
	      this.constantViolations = [].concat(existing.path, existing.constantViolations, this.constantViolations);
	    }
	  }
	
	  Binding.prototype.deoptValue = function deoptValue() {
	    this.clearValue();
	    this.hasDeoptedValue = true;
	  };
	
	  Binding.prototype.setValue = function setValue(value) {
	    if (this.hasDeoptedValue) return;
	    this.hasValue = true;
	    this.value = value;
	  };
	
	  Binding.prototype.clearValue = function clearValue() {
	    this.hasDeoptedValue = false;
	    this.hasValue = false;
	    this.value = null;
	  };
	
	  Binding.prototype.reassign = function reassign(path) {
	    this.constant = false;
	    if (this.constantViolations.indexOf(path) !== -1) {
	      return;
	    }
	    this.constantViolations.push(path);
	  };
	
	  Binding.prototype.reference = function reference(path) {
	    if (this.referencePaths.indexOf(path) !== -1) {
	      return;
	    }
	    this.referenced = true;
	    this.references++;
	    this.referencePaths.push(path);
	  };
	
	  Binding.prototype.dereference = function dereference() {
	    this.references--;
	    this.referenced = !!this.references;
	  };
	
	  return Binding;
	}();
	
	exports.default = Binding;
	module.exports = exports["default"];

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _create = __webpack_require__(82);
	
	var _create2 = _interopRequireDefault(_create);
	
	exports.getBindingIdentifiers = getBindingIdentifiers;
	exports.getOuterBindingIdentifiers = getOuterBindingIdentifiers;
	
	var _index = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getBindingIdentifiers(node, duplicates, outerOnly) {
	  var search = [].concat(node);
	  var ids = (0, _create2.default)(null);
	
	  while (search.length) {
	    var id = search.shift();
	    if (!id) continue;
	
	    var keys = t.getBindingIdentifiers.keys[id.type];
	
	    if (t.isIdentifier(id)) {
	      if (duplicates) {
	        var _ids = ids[id.name] = ids[id.name] || [];
	        _ids.push(id);
	      } else {
	        ids[id.name] = id;
	      }
	      continue;
	    }
	
	    if (t.isExportDeclaration(id)) {
	      if (t.isDeclaration(id.declaration)) {
	        search.push(id.declaration);
	      }
	      continue;
	    }
	
	    if (outerOnly) {
	      if (t.isFunctionDeclaration(id)) {
	        search.push(id.id);
	        continue;
	      }
	
	      if (t.isFunctionExpression(id)) {
	        continue;
	      }
	    }
	
	    if (keys) {
	      for (var i = 0; i < keys.length; i++) {
	        var key = keys[i];
	        if (id[key]) {
	          search = search.concat(id[key]);
	        }
	      }
	    }
	  }
	
	  return ids;
	}
	
	getBindingIdentifiers.keys = {
	  DeclareClass: ["id"],
	  DeclareFunction: ["id"],
	  DeclareModule: ["id"],
	  DeclareVariable: ["id"],
	  InterfaceDeclaration: ["id"],
	  TypeAlias: ["id"],
	  OpaqueType: ["id"],
	
	  CatchClause: ["param"],
	  LabeledStatement: ["label"],
	  UnaryExpression: ["argument"],
	  AssignmentExpression: ["left"],
	
	  ImportSpecifier: ["local"],
	  ImportNamespaceSpecifier: ["local"],
	  ImportDefaultSpecifier: ["local"],
	  ImportDeclaration: ["specifiers"],
	
	  ExportSpecifier: ["exported"],
	  ExportNamespaceSpecifier: ["exported"],
	  ExportDefaultSpecifier: ["exported"],
	
	  FunctionDeclaration: ["id", "params"],
	  FunctionExpression: ["id", "params"],
	
	  ClassDeclaration: ["id"],
	  ClassExpression: ["id"],
	
	  RestElement: ["argument"],
	  UpdateExpression: ["argument"],
	
	  RestProperty: ["argument"],
	  ObjectProperty: ["value"],
	
	  AssignmentPattern: ["left"],
	  ArrayPattern: ["elements"],
	  ObjectPattern: ["properties"],
	
	  VariableDeclaration: ["declarations"],
	  VariableDeclarator: ["id"]
	};
	
	function getOuterBindingIdentifiers(node, duplicates) {
	  return getBindingIdentifiers(node, duplicates, true);
	}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/* eslint max-len: 0 */
	
	// This is a trick taken from Esprima. It turns out that, on
	// non-Chrome browsers, to check whether a string is in a set, a
	// predicate containing a big ugly `switch` statement is faster than
	// a regular expression, and on Chrome the two are about on par.
	// This function uses `eval` (non-lexical) to produce such a
	// predicate from a space-separated string of words.
	//
	// It starts by sorting the words by length.
	
	function makePredicate(words) {
	  words = words.split(" ");
	  return function (str) {
	    return words.indexOf(str) >= 0;
	  };
	}
	
	// Reserved word lists for various dialects of the language
	
	var reservedWords = {
	  6: makePredicate("enum await"),
	  strict: makePredicate("implements interface let package private protected public static yield"),
	  strictBind: makePredicate("eval arguments")
	};
	
	// And the keywords
	
	var isKeyword = makePredicate("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this let const class extends export import yield super");
	
	// ## Character categories
	
	// Big ugly regular expressions that match characters in the
	// whitespace, identifier, and identifier-start categories. These
	// are only applied when a character is found to actually have a
	// code point above 128.
	// Generated by `bin/generate-identifier-regex.js`.
	
	var nonASCIIidentifierStartChars = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
	var nonASCIIidentifierChars = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D4-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0D01-\u0D03\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFB-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA900-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F";
	
	var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
	var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");
	
	nonASCIIidentifierStartChars = nonASCIIidentifierChars = null;
	
	// These are a run-length and offset encoded representation of the
	// >0xffff code points that are a valid part of identifiers. The
	// offset starts at 0x10000, and each pair of numbers represents an
	// offset to the next range, and then a size of the range. They were
	// generated by `bin/generate-identifier-regex.js`.
	// eslint-disable-next-line comma-spacing
	var astralIdentifierStartCodes = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 17, 26, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 157, 310, 10, 21, 11, 7, 153, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 26, 45, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 785, 52, 76, 44, 33, 24, 27, 35, 42, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 85, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 54, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 86, 25, 391, 63, 32, 0, 449, 56, 264, 8, 2, 36, 18, 0, 50, 29, 881, 921, 103, 110, 18, 195, 2749, 1070, 4050, 582, 8634, 568, 8, 30, 114, 29, 19, 47, 17, 3, 32, 20, 6, 18, 881, 68, 12, 0, 67, 12, 65, 0, 32, 6124, 20, 754, 9486, 1, 3071, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 4149, 196, 60, 67, 1213, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42710, 42, 4148, 12, 221, 3, 5761, 10591, 541];
	// eslint-disable-next-line comma-spacing
	var astralIdentifierCodes = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 1306, 2, 54, 14, 32, 9, 16, 3, 46, 10, 54, 9, 7, 2, 37, 13, 2, 9, 52, 0, 13, 2, 49, 13, 10, 2, 4, 9, 83, 11, 7, 0, 161, 11, 6, 9, 7, 3, 57, 0, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 87, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 423, 9, 838, 7, 2, 7, 17, 9, 57, 21, 2, 13, 19882, 9, 135, 4, 60, 6, 26, 9, 1016, 45, 17, 3, 19723, 1, 5319, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 2214, 6, 110, 6, 6, 9, 792487, 239];
	
	// This has a complexity linear to the value of the code. The
	// assumption is that looking up astral identifier characters is
	// rare.
	function isInAstralSet(code, set) {
	  var pos = 0x10000;
	  for (var i = 0; i < set.length; i += 2) {
	    pos += set[i];
	    if (pos > code) return false;
	
	    pos += set[i + 1];
	    if (pos >= code) return true;
	  }
	}
	
	// Test whether a given character code starts an identifier.
	
	function isIdentifierStart(code) {
	  if (code < 65) return code === 36;
	  if (code < 91) return true;
	  if (code < 97) return code === 95;
	  if (code < 123) return true;
	  if (code <= 0xffff) return code >= 0xaa && nonASCIIidentifierStart.test(String.fromCharCode(code));
	  return isInAstralSet(code, astralIdentifierStartCodes);
	}
	
	// Test whether a given character is part of an identifier.
	
	function isIdentifierChar(code) {
	  if (code < 48) return code === 36;
	  if (code < 58) return true;
	  if (code < 65) return false;
	  if (code < 91) return true;
	  if (code < 97) return code === 95;
	  if (code < 123) return true;
	  if (code <= 0xffff) return code >= 0xaa && nonASCIIidentifier.test(String.fromCharCode(code));
	  return isInAstralSet(code, astralIdentifierStartCodes) || isInAstralSet(code, astralIdentifierCodes);
	}
	
	// A second optional argument can be given to further configure
	var defaultOptions = {
	  // Source type ("script" or "module") for different semantics
	  sourceType: "script",
	  // Source filename.
	  sourceFilename: undefined,
	  // Line from which to start counting source. Useful for
	  // integration with other tools.
	  startLine: 1,
	  // When enabled, a return at the top level is not considered an
	  // error.
	  allowReturnOutsideFunction: false,
	  // When enabled, import/export statements are not constrained to
	  // appearing at the top of the program.
	  allowImportExportEverywhere: false,
	  // TODO
	  allowSuperOutsideMethod: false,
	  // An array of plugins to enable
	  plugins: [],
	  // TODO
	  strictMode: null
	};
	
	// Interpret and default an options object
	
	function getOptions(opts) {
	  var options = {};
	  for (var key in defaultOptions) {
	    options[key] = opts && key in opts ? opts[key] : defaultOptions[key];
	  }
	  return options;
	}
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	
	
	
	
	
	
	
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	// ## Token types
	
	// The assignment of fine-grained, information-carrying type objects
	// allows the tokenizer to store the information it has about a
	// token in a way that is very cheap for the parser to look up.
	
	// All token type variables start with an underscore, to make them
	// easy to recognize.
	
	// The `beforeExpr` property is used to disambiguate between regular
	// expressions and divisions. It is set on all token types that can
	// be followed by an expression (thus, a slash after them would be a
	// regular expression).
	//
	// `isLoop` marks a keyword as starting a loop, which is important
	// to know when parsing a label, in order to allow or disallow
	// continue jumps to that label.
	
	var beforeExpr = true;
	var startsExpr = true;
	var isLoop = true;
	var isAssign = true;
	var prefix = true;
	var postfix = true;
	
	var TokenType = function TokenType(label) {
	  var conf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  classCallCheck(this, TokenType);
	
	  this.label = label;
	  this.keyword = conf.keyword;
	  this.beforeExpr = !!conf.beforeExpr;
	  this.startsExpr = !!conf.startsExpr;
	  this.rightAssociative = !!conf.rightAssociative;
	  this.isLoop = !!conf.isLoop;
	  this.isAssign = !!conf.isAssign;
	  this.prefix = !!conf.prefix;
	  this.postfix = !!conf.postfix;
	  this.binop = conf.binop || null;
	  this.updateContext = null;
	};
	
	var KeywordTokenType = function (_TokenType) {
	  inherits(KeywordTokenType, _TokenType);
	
	  function KeywordTokenType(name) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    classCallCheck(this, KeywordTokenType);
	
	    options.keyword = name;
	
	    return possibleConstructorReturn(this, _TokenType.call(this, name, options));
	  }
	
	  return KeywordTokenType;
	}(TokenType);
	
	var BinopTokenType = function (_TokenType2) {
	  inherits(BinopTokenType, _TokenType2);
	
	  function BinopTokenType(name, prec) {
	    classCallCheck(this, BinopTokenType);
	    return possibleConstructorReturn(this, _TokenType2.call(this, name, { beforeExpr: beforeExpr, binop: prec }));
	  }
	
	  return BinopTokenType;
	}(TokenType);
	
	var types = {
	  num: new TokenType("num", { startsExpr: startsExpr }),
	  regexp: new TokenType("regexp", { startsExpr: startsExpr }),
	  string: new TokenType("string", { startsExpr: startsExpr }),
	  name: new TokenType("name", { startsExpr: startsExpr }),
	  eof: new TokenType("eof"),
	
	  // Punctuation token types.
	  bracketL: new TokenType("[", { beforeExpr: beforeExpr, startsExpr: startsExpr }),
	  bracketR: new TokenType("]"),
	  braceL: new TokenType("{", { beforeExpr: beforeExpr, startsExpr: startsExpr }),
	  braceBarL: new TokenType("{|", { beforeExpr: beforeExpr, startsExpr: startsExpr }),
	  braceR: new TokenType("}"),
	  braceBarR: new TokenType("|}"),
	  parenL: new TokenType("(", { beforeExpr: beforeExpr, startsExpr: startsExpr }),
	  parenR: new TokenType(")"),
	  comma: new TokenType(",", { beforeExpr: beforeExpr }),
	  semi: new TokenType(";", { beforeExpr: beforeExpr }),
	  colon: new TokenType(":", { beforeExpr: beforeExpr }),
	  doubleColon: new TokenType("::", { beforeExpr: beforeExpr }),
	  dot: new TokenType("."),
	  question: new TokenType("?", { beforeExpr: beforeExpr }),
	  arrow: new TokenType("=>", { beforeExpr: beforeExpr }),
	  template: new TokenType("template"),
	  ellipsis: new TokenType("...", { beforeExpr: beforeExpr }),
	  backQuote: new TokenType("`", { startsExpr: startsExpr }),
	  dollarBraceL: new TokenType("${", { beforeExpr: beforeExpr, startsExpr: startsExpr }),
	  at: new TokenType("@"),
	
	  // Operators. These carry several kinds of properties to help the
	  // parser use them properly (the presence of these properties is
	  // what categorizes them as operators).
	  //
	  // `binop`, when present, specifies that this operator is a binary
	  // operator, and will refer to its precedence.
	  //
	  // `prefix` and `postfix` mark the operator as a prefix or postfix
	  // unary operator.
	  //
	  // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
	  // binary operators with a very low precedence, that should result
	  // in AssignmentExpression nodes.
	
	  eq: new TokenType("=", { beforeExpr: beforeExpr, isAssign: isAssign }),
	  assign: new TokenType("_=", { beforeExpr: beforeExpr, isAssign: isAssign }),
	  incDec: new TokenType("++/--", { prefix: prefix, postfix: postfix, startsExpr: startsExpr }),
	  prefix: new TokenType("prefix", { beforeExpr: beforeExpr, prefix: prefix, startsExpr: startsExpr }),
	  logicalOR: new BinopTokenType("||", 1),
	  logicalAND: new BinopTokenType("&&", 2),
	  bitwiseOR: new BinopTokenType("|", 3),
	  bitwiseXOR: new BinopTokenType("^", 4),
	  bitwiseAND: new BinopTokenType("&", 5),
	  equality: new BinopTokenType("==/!=", 6),
	  relational: new BinopTokenType("</>", 7),
	  bitShift: new BinopTokenType("<</>>", 8),
	  plusMin: new TokenType("+/-", { beforeExpr: beforeExpr, binop: 9, prefix: prefix, startsExpr: startsExpr }),
	  modulo: new BinopTokenType("%", 10),
	  star: new BinopTokenType("*", 10),
	  slash: new BinopTokenType("/", 10),
	  exponent: new TokenType("**", { beforeExpr: beforeExpr, binop: 11, rightAssociative: true })
	};
	
	var keywords = {
	  "break": new KeywordTokenType("break"),
	  "case": new KeywordTokenType("case", { beforeExpr: beforeExpr }),
	  "catch": new KeywordTokenType("catch"),
	  "continue": new KeywordTokenType("continue"),
	  "debugger": new KeywordTokenType("debugger"),
	  "default": new KeywordTokenType("default", { beforeExpr: beforeExpr }),
	  "do": new KeywordTokenType("do", { isLoop: isLoop, beforeExpr: beforeExpr }),
	  "else": new KeywordTokenType("else", { beforeExpr: beforeExpr }),
	  "finally": new KeywordTokenType("finally"),
	  "for": new KeywordTokenType("for", { isLoop: isLoop }),
	  "function": new KeywordTokenType("function", { startsExpr: startsExpr }),
	  "if": new KeywordTokenType("if"),
	  "return": new KeywordTokenType("return", { beforeExpr: beforeExpr }),
	  "switch": new KeywordTokenType("switch"),
	  "throw": new KeywordTokenType("throw", { beforeExpr: beforeExpr }),
	  "try": new KeywordTokenType("try"),
	  "var": new KeywordTokenType("var"),
	  "let": new KeywordTokenType("let"),
	  "const": new KeywordTokenType("const"),
	  "while": new KeywordTokenType("while", { isLoop: isLoop }),
	  "with": new KeywordTokenType("with"),
	  "new": new KeywordTokenType("new", { beforeExpr: beforeExpr, startsExpr: startsExpr }),
	  "this": new KeywordTokenType("this", { startsExpr: startsExpr }),
	  "super": new KeywordTokenType("super", { startsExpr: startsExpr }),
	  "class": new KeywordTokenType("class"),
	  "extends": new KeywordTokenType("extends", { beforeExpr: beforeExpr }),
	  "export": new KeywordTokenType("export"),
	  "import": new KeywordTokenType("import", { startsExpr: startsExpr }),
	  "yield": new KeywordTokenType("yield", { beforeExpr: beforeExpr, startsExpr: startsExpr }),
	  "null": new KeywordTokenType("null", { startsExpr: startsExpr }),
	  "true": new KeywordTokenType("true", { startsExpr: startsExpr }),
	  "false": new KeywordTokenType("false", { startsExpr: startsExpr }),
	  "in": new KeywordTokenType("in", { beforeExpr: beforeExpr, binop: 7 }),
	  "instanceof": new KeywordTokenType("instanceof", { beforeExpr: beforeExpr, binop: 7 }),
	  "typeof": new KeywordTokenType("typeof", { beforeExpr: beforeExpr, prefix: prefix, startsExpr: startsExpr }),
	  "void": new KeywordTokenType("void", { beforeExpr: beforeExpr, prefix: prefix, startsExpr: startsExpr }),
	  "delete": new KeywordTokenType("delete", { beforeExpr: beforeExpr, prefix: prefix, startsExpr: startsExpr })
	};
	
	// Map keyword names to token types.
	Object.keys(keywords).forEach(function (name) {
	  types["_" + name] = keywords[name];
	});
	
	// Matches a whole line break (where CRLF is considered a single
	// line break). Used to count lines.
	
	var lineBreak = /\r\n?|\n|\u2028|\u2029/;
	var lineBreakG = new RegExp(lineBreak.source, "g");
	
	function isNewLine(code) {
	  return code === 10 || code === 13 || code === 0x2028 || code === 0x2029;
	}
	
	var nonASCIIwhitespace = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/;
	
	// The algorithm used to determine whether a regexp can appear at a
	// given point in the program is loosely based on sweet.js' approach.
	// See https://github.com/mozilla/sweet.js/wiki/design
	
	var TokContext = function TokContext(token, isExpr, preserveSpace, override) {
	  classCallCheck(this, TokContext);
	
	  this.token = token;
	  this.isExpr = !!isExpr;
	  this.preserveSpace = !!preserveSpace;
	  this.override = override;
	};
	
	var types$1 = {
	  braceStatement: new TokContext("{", false),
	  braceExpression: new TokContext("{", true),
	  templateQuasi: new TokContext("${", true),
	  parenStatement: new TokContext("(", false),
	  parenExpression: new TokContext("(", true),
	  template: new TokContext("`", true, true, function (p) {
	    return p.readTmplToken();
	  }),
	  functionExpression: new TokContext("function", true)
	};
	
	// Token-specific context update code
	
	types.parenR.updateContext = types.braceR.updateContext = function () {
	  if (this.state.context.length === 1) {
	    this.state.exprAllowed = true;
	    return;
	  }
	
	  var out = this.state.context.pop();
	  if (out === types$1.braceStatement && this.curContext() === types$1.functionExpression) {
	    this.state.context.pop();
	    this.state.exprAllowed = false;
	  } else if (out === types$1.templateQuasi) {
	    this.state.exprAllowed = true;
	  } else {
	    this.state.exprAllowed = !out.isExpr;
	  }
	};
	
	types.name.updateContext = function (prevType) {
	  this.state.exprAllowed = false;
	
	  if (prevType === types._let || prevType === types._const || prevType === types._var) {
	    if (lineBreak.test(this.input.slice(this.state.end))) {
	      this.state.exprAllowed = true;
	    }
	  }
	};
	
	types.braceL.updateContext = function (prevType) {
	  this.state.context.push(this.braceIsBlock(prevType) ? types$1.braceStatement : types$1.braceExpression);
	  this.state.exprAllowed = true;
	};
	
	types.dollarBraceL.updateContext = function () {
	  this.state.context.push(types$1.templateQuasi);
	  this.state.exprAllowed = true;
	};
	
	types.parenL.updateContext = function (prevType) {
	  var statementParens = prevType === types._if || prevType === types._for || prevType === types._with || prevType === types._while;
	  this.state.context.push(statementParens ? types$1.parenStatement : types$1.parenExpression);
	  this.state.exprAllowed = true;
	};
	
	types.incDec.updateContext = function () {
	  // tokExprAllowed stays unchanged
	};
	
	types._function.updateContext = function () {
	  if (this.curContext() !== types$1.braceStatement) {
	    this.state.context.push(types$1.functionExpression);
	  }
	
	  this.state.exprAllowed = false;
	};
	
	types.backQuote.updateContext = function () {
	  if (this.curContext() === types$1.template) {
	    this.state.context.pop();
	  } else {
	    this.state.context.push(types$1.template);
	  }
	  this.state.exprAllowed = false;
	};
	
	// These are used when `options.locations` is on, for the
	// `startLoc` and `endLoc` properties.
	
	var Position = function Position(line, col) {
	  classCallCheck(this, Position);
	
	  this.line = line;
	  this.column = col;
	};
	
	var SourceLocation = function SourceLocation(start, end) {
	  classCallCheck(this, SourceLocation);
	
	  this.start = start;
	  this.end = end;
	};
	
	// The `getLineInfo` function is mostly useful when the
	// `locations` option is off (for performance reasons) and you
	// want to find the line/column position for a given character
	// offset. `input` should be the code string that the offset refers
	// into.
	
	function getLineInfo(input, offset) {
	  for (var line = 1, cur = 0;;) {
	    lineBreakG.lastIndex = cur;
	    var match = lineBreakG.exec(input);
	    if (match && match.index < offset) {
	      ++line;
	      cur = match.index + match[0].length;
	    } else {
	      return new Position(line, offset - cur);
	    }
	  }
	}
	
	var State = function () {
	  function State() {
	    classCallCheck(this, State);
	  }
	
	  State.prototype.init = function init(options, input) {
	    this.strict = options.strictMode === false ? false : options.sourceType === "module";
	
	    this.input = input;
	
	    this.potentialArrowAt = -1;
	
	    this.inMethod = this.inFunction = this.inGenerator = this.inAsync = this.inPropertyName = this.inType = this.inClassProperty = this.noAnonFunctionType = false;
	
	    this.labels = [];
	
	    this.decorators = [];
	
	    this.tokens = [];
	
	    this.comments = [];
	
	    this.trailingComments = [];
	    this.leadingComments = [];
	    this.commentStack = [];
	
	    this.pos = this.lineStart = 0;
	    this.curLine = options.startLine;
	
	    this.type = types.eof;
	    this.value = null;
	    this.start = this.end = this.pos;
	    this.startLoc = this.endLoc = this.curPosition();
	
	    this.lastTokEndLoc = this.lastTokStartLoc = null;
	    this.lastTokStart = this.lastTokEnd = this.pos;
	
	    this.context = [types$1.braceStatement];
	    this.exprAllowed = true;
	
	    this.containsEsc = this.containsOctal = false;
	    this.octalPosition = null;
	
	    this.invalidTemplateEscapePosition = null;
	
	    this.exportedIdentifiers = [];
	
	    return this;
	  };
	
	  // TODO
	
	
	  // TODO
	
	
	  // Used to signify the start of a potential arrow function
	
	
	  // Flags to track whether we are in a function, a generator.
	
	
	  // Labels in scope.
	
	
	  // Leading decorators.
	
	
	  // Token store.
	
	
	  // Comment store.
	
	
	  // Comment attachment store
	
	
	  // The current position of the tokenizer in the input.
	
	
	  // Properties of the current token:
	  // Its type
	
	
	  // For tokens that include more information than their type, the value
	
	
	  // Its start and end offset
	
	
	  // And, if locations are used, the {line, column} object
	  // corresponding to those offsets
	
	
	  // Position information for the previous token
	
	
	  // The context stack is used to superficially track syntactic
	  // context to predict whether a regular expression is allowed in a
	  // given position.
	
	
	  // Used to signal to callers of `readWord1` whether the word
	  // contained any escape sequences. This is needed because words with
	  // escape sequences must not be interpreted as keywords.
	
	
	  // TODO
	
	
	  // Names of exports store. `default` is stored as a name for both
	  // `export default foo;` and `export { foo as default };`.
	
	
	  State.prototype.curPosition = function curPosition() {
	    return new Position(this.curLine, this.pos - this.lineStart);
	  };
	
	  State.prototype.clone = function clone(skipArrays) {
	    var state = new State();
	    for (var key in this) {
	      var val = this[key];
	
	      if ((!skipArrays || key === "context") && Array.isArray(val)) {
	        val = val.slice();
	      }
	
	      state[key] = val;
	    }
	    return state;
	  };
	
	  return State;
	}();
	
	// Object type used to represent tokens. Note that normally, tokens
	// simply exist as properties on the parser object. This is only
	// used for the onToken callback and the external tokenizer.
	
	var Token = function Token(state) {
	  classCallCheck(this, Token);
	
	  this.type = state.type;
	  this.value = state.value;
	  this.start = state.start;
	  this.end = state.end;
	  this.loc = new SourceLocation(state.startLoc, state.endLoc);
	};
	
	// ## Tokenizer
	
	function codePointToString(code) {
	  // UTF-16 Decoding
	  if (code <= 0xFFFF) {
	    return String.fromCharCode(code);
	  } else {
	    return String.fromCharCode((code - 0x10000 >> 10) + 0xD800, (code - 0x10000 & 1023) + 0xDC00);
	  }
	}
	
	var Tokenizer = function () {
	  function Tokenizer(options, input) {
	    classCallCheck(this, Tokenizer);
	
	    this.state = new State();
	    this.state.init(options, input);
	  }
	
	  // Move to the next token
	
	  Tokenizer.prototype.next = function next() {
	    if (!this.isLookahead) {
	      this.state.tokens.push(new Token(this.state));
	    }
	
	    this.state.lastTokEnd = this.state.end;
	    this.state.lastTokStart = this.state.start;
	    this.state.lastTokEndLoc = this.state.endLoc;
	    this.state.lastTokStartLoc = this.state.startLoc;
	    this.nextToken();
	  };
	
	  // TODO
	
	  Tokenizer.prototype.eat = function eat(type) {
	    if (this.match(type)) {
	      this.next();
	      return true;
	    } else {
	      return false;
	    }
	  };
	
	  // TODO
	
	  Tokenizer.prototype.match = function match(type) {
	    return this.state.type === type;
	  };
	
	  // TODO
	
	  Tokenizer.prototype.isKeyword = function isKeyword$$1(word) {
	    return isKeyword(word);
	  };
	
	  // TODO
	
	  Tokenizer.prototype.lookahead = function lookahead() {
	    var old = this.state;
	    this.state = old.clone(true);
	
	    this.isLookahead = true;
	    this.next();
	    this.isLookahead = false;
	
	    var curr = this.state.clone(true);
	    this.state = old;
	    return curr;
	  };
	
	  // Toggle strict mode. Re-reads the next number or string to please
	  // pedantic tests (`"use strict"; 010;` should fail).
	
	  Tokenizer.prototype.setStrict = function setStrict(strict) {
	    this.state.strict = strict;
	    if (!this.match(types.num) && !this.match(types.string)) return;
	    this.state.pos = this.state.start;
	    while (this.state.pos < this.state.lineStart) {
	      this.state.lineStart = this.input.lastIndexOf("\n", this.state.lineStart - 2) + 1;
	      --this.state.curLine;
	    }
	    this.nextToken();
	  };
	
	  Tokenizer.prototype.curContext = function curContext() {
	    return this.state.context[this.state.context.length - 1];
	  };
	
	  // Read a single token, updating the parser object's token-related
	  // properties.
	
	  Tokenizer.prototype.nextToken = function nextToken() {
	    var curContext = this.curContext();
	    if (!curContext || !curContext.preserveSpace) this.skipSpace();
	
	    this.state.containsOctal = false;
	    this.state.octalPosition = null;
	    this.state.start = this.state.pos;
	    this.state.startLoc = this.state.curPosition();
	    if (this.state.pos >= this.input.length) return this.finishToken(types.eof);
	
	    if (curContext.override) {
	      return curContext.override(this);
	    } else {
	      return this.readToken(this.fullCharCodeAtPos());
	    }
	  };
	
	  Tokenizer.prototype.readToken = function readToken(code) {
	    // Identifier or keyword. '\uXXXX' sequences are allowed in
	    // identifiers, so '\' also dispatches to that.
	    if (isIdentifierStart(code) || code === 92 /* '\' */) {
	        return this.readWord();
	      } else {
	      return this.getTokenFromCode(code);
	    }
	  };
	
	  Tokenizer.prototype.fullCharCodeAtPos = function fullCharCodeAtPos() {
	    var code = this.input.charCodeAt(this.state.pos);
	    if (code <= 0xd7ff || code >= 0xe000) return code;
	
	    var next = this.input.charCodeAt(this.state.pos + 1);
	    return (code << 10) + next - 0x35fdc00;
	  };
	
	  Tokenizer.prototype.pushComment = function pushComment(block, text, start, end, startLoc, endLoc) {
	    var comment = {
	      type: block ? "CommentBlock" : "CommentLine",
	      value: text,
	      start: start,
	      end: end,
	      loc: new SourceLocation(startLoc, endLoc)
	    };
	
	    if (!this.isLookahead) {
	      this.state.tokens.push(comment);
	      this.state.comments.push(comment);
	      this.addComment(comment);
	    }
	  };
	
	  Tokenizer.prototype.skipBlockComment = function skipBlockComment() {
	    var startLoc = this.state.curPosition();
	    var start = this.state.pos;
	    var end = this.input.indexOf("*/", this.state.pos += 2);
	    if (end === -1) this.raise(this.state.pos - 2, "Unterminated comment");
	
	    this.state.pos = end + 2;
	    lineBreakG.lastIndex = start;
	    var match = void 0;
	    while ((match = lineBreakG.exec(this.input)) && match.index < this.state.pos) {
	      ++this.state.curLine;
	      this.state.lineStart = match.index + match[0].length;
	    }
	
	    this.pushComment(true, this.input.slice(start + 2, end), start, this.state.pos, startLoc, this.state.curPosition());
	  };
	
	  Tokenizer.prototype.skipLineComment = function skipLineComment(startSkip) {
	    var start = this.state.pos;
	    var startLoc = this.state.curPosition();
	    var ch = this.input.charCodeAt(this.state.pos += startSkip);
	    while (this.state.pos < this.input.length && ch !== 10 && ch !== 13 && ch !== 8232 && ch !== 8233) {
	      ++this.state.pos;
	      ch = this.input.charCodeAt(this.state.pos);
	    }
	
	    this.pushComment(false, this.input.slice(start + startSkip, this.state.pos), start, this.state.pos, startLoc, this.state.curPosition());
	  };
	
	  // Called at the start of the parse and after every token. Skips
	  // whitespace and comments, and.
	
	  Tokenizer.prototype.skipSpace = function skipSpace() {
	    loop: while (this.state.pos < this.input.length) {
	      var ch = this.input.charCodeAt(this.state.pos);
	      switch (ch) {
	        case 32:case 160:
	          // ' '
	          ++this.state.pos;
	          break;
	
	        case 13:
	          if (this.input.charCodeAt(this.state.pos + 1) === 10) {
	            ++this.state.pos;
	          }
	
	        case 10:case 8232:case 8233:
	          ++this.state.pos;
	          ++this.state.curLine;
	          this.state.lineStart = this.state.pos;
	          break;
	
	        case 47:
	          // '/'
	          switch (this.input.charCodeAt(this.state.pos + 1)) {
	            case 42:
	              // '*'
	              this.skipBlockComment();
	              break;
	
	            case 47:
	              this.skipLineComment(2);
	              break;
	
	            default:
	              break loop;
	          }
	          break;
	
	        default:
	          if (ch > 8 && ch < 14 || ch >= 5760 && nonASCIIwhitespace.test(String.fromCharCode(ch))) {
	            ++this.state.pos;
	          } else {
	            break loop;
	          }
	      }
	    }
	  };
	
	  // Called at the end of every token. Sets `end`, `val`, and
	  // maintains `context` and `exprAllowed`, and skips the space after
	  // the token, so that the next one's `start` will point at the
	  // right position.
	
	  Tokenizer.prototype.finishToken = function finishToken(type, val) {
	    this.state.end = this.state.pos;
	    this.state.endLoc = this.state.curPosition();
	    var prevType = this.state.type;
	    this.state.type = type;
	    this.state.value = val;
	
	    this.updateContext(prevType);
	  };
	
	  // ### Token reading
	
	  // This is the function that is called to fetch the next token. It
	  // is somewhat obscure, because it works in character codes rather
	  // than characters, and because operator parsing has been inlined
	  // into it.
	  //
	  // All in the name of speed.
	  //
	
	
	  Tokenizer.prototype.readToken_dot = function readToken_dot() {
	    var next = this.input.charCodeAt(this.state.pos + 1);
	    if (next >= 48 && next <= 57) {
	      return this.readNumber(true);
	    }
	
	    var next2 = this.input.charCodeAt(this.state.pos + 2);
	    if (next === 46 && next2 === 46) {
	      // 46 = dot '.'
	      this.state.pos += 3;
	      return this.finishToken(types.ellipsis);
	    } else {
	      ++this.state.pos;
	      return this.finishToken(types.dot);
	    }
	  };
	
	  Tokenizer.prototype.readToken_slash = function readToken_slash() {
	    // '/'
	    if (this.state.exprAllowed) {
	      ++this.state.pos;
	      return this.readRegexp();
	    }
	
	    var next = this.input.charCodeAt(this.state.pos + 1);
	    if (next === 61) {
	      return this.finishOp(types.assign, 2);
	    } else {
	      return this.finishOp(types.slash, 1);
	    }
	  };
	
	  Tokenizer.prototype.readToken_mult_modulo = function readToken_mult_modulo(code) {
	    // '%*'
	    var type = code === 42 ? types.star : types.modulo;
	    var width = 1;
	    var next = this.input.charCodeAt(this.state.pos + 1);
	
	    if (next === 42) {
	      // '*'
	      width++;
	      next = this.input.charCodeAt(this.state.pos + 2);
	      type = types.exponent;
	    }
	
	    if (next === 61) {
	      width++;
	      type = types.assign;
	    }
	
	    return this.finishOp(type, width);
	  };
	
	  Tokenizer.prototype.readToken_pipe_amp = function readToken_pipe_amp(code) {
	    // '|&'
	    var next = this.input.charCodeAt(this.state.pos + 1);
	    if (next === code) return this.finishOp(code === 124 ? types.logicalOR : types.logicalAND, 2);
	    if (next === 61) return this.finishOp(types.assign, 2);
	    if (code === 124 && next === 125 && this.hasPlugin("flow")) return this.finishOp(types.braceBarR, 2);
	    return this.finishOp(code === 124 ? types.bitwiseOR : types.bitwiseAND, 1);
	  };
	
	  Tokenizer.prototype.readToken_caret = function readToken_caret() {
	    // '^'
	    var next = this.input.charCodeAt(this.state.pos + 1);
	    if (next === 61) {
	      return this.finishOp(types.assign, 2);
	    } else {
	      return this.finishOp(types.bitwiseXOR, 1);
	    }
	  };
	
	  Tokenizer.prototype.readToken_plus_min = function readToken_plus_min(code) {
	    // '+-'
	    var next = this.input.charCodeAt(this.state.pos + 1);
	
	    if (next === code) {
	      if (next === 45 && this.input.charCodeAt(this.state.pos + 2) === 62 && lineBreak.test(this.input.slice(this.state.lastTokEnd, this.state.pos))) {
	        // A `-->` line comment
	        this.skipLineComment(3);
	        this.skipSpace();
	        return this.nextToken();
	      }
	      return this.finishOp(types.incDec, 2);
	    }
	
	    if (next === 61) {
	      return this.finishOp(types.assign, 2);
	    } else {
	      return this.finishOp(types.plusMin, 1);
	    }
	  };
	
	  Tokenizer.prototype.readToken_lt_gt = function readToken_lt_gt(code) {
	    // '<>'
	    var next = this.input.charCodeAt(this.state.pos + 1);
	    var size = 1;
	
	    if (next === code) {
	      size = code === 62 && this.input.charCodeAt(this.state.pos + 2) === 62 ? 3 : 2;
	      if (this.input.charCodeAt(this.state.pos + size) === 61) return this.finishOp(types.assign, size + 1);
	      return this.finishOp(types.bitShift, size);
	    }
	
	    if (next === 33 && code === 60 && this.input.charCodeAt(this.state.pos + 2) === 45 && this.input.charCodeAt(this.state.pos + 3) === 45) {
	      if (this.inModule) this.unexpected();
	      // `<!--`, an XML-style comment that should be interpreted as a line comment
	      this.skipLineComment(4);
	      this.skipSpace();
	      return this.nextToken();
	    }
	
	    if (next === 61) {
	      // <= | >=
	      size = 2;
	    }
	
	    return this.finishOp(types.relational, size);
	  };
	
	  Tokenizer.prototype.readToken_eq_excl = function readToken_eq_excl(code) {
	    // '=!'
	    var next = this.input.charCodeAt(this.state.pos + 1);
	    if (next === 61) return this.finishOp(types.equality, this.input.charCodeAt(this.state.pos + 2) === 61 ? 3 : 2);
	    if (code === 61 && next === 62) {
	      // '=>'
	      this.state.pos += 2;
	      return this.finishToken(types.arrow);
	    }
	    return this.finishOp(code === 61 ? types.eq : types.prefix, 1);
	  };
	
	  Tokenizer.prototype.getTokenFromCode = function getTokenFromCode(code) {
	    switch (code) {
	      // The interpretation of a dot depends on whether it is followed
	      // by a digit or another two dots.
	      case 46:
	        // '.'
	        return this.readToken_dot();
	
	      // Punctuation tokens.
	      case 40:
	        ++this.state.pos;return this.finishToken(types.parenL);
	      case 41:
	        ++this.state.pos;return this.finishToken(types.parenR);
	      case 59:
	        ++this.state.pos;return this.finishToken(types.semi);
	      case 44:
	        ++this.state.pos;return this.finishToken(types.comma);
	      case 91:
	        ++this.state.pos;return this.finishToken(types.bracketL);
	      case 93:
	        ++this.state.pos;return this.finishToken(types.bracketR);
	
	      case 123:
	        if (this.hasPlugin("flow") && this.input.charCodeAt(this.state.pos + 1) === 124) {
	          return this.finishOp(types.braceBarL, 2);
	        } else {
	          ++this.state.pos;
	          return this.finishToken(types.braceL);
	        }
	
	      case 125:
	        ++this.state.pos;return this.finishToken(types.braceR);
	
	      case 58:
	        if (this.hasPlugin("functionBind") && this.input.charCodeAt(this.state.pos + 1) === 58) {
	          return this.finishOp(types.doubleColon, 2);
	        } else {
	          ++this.state.pos;
	          return this.finishToken(types.colon);
	        }
	
	      case 63:
	        ++this.state.pos;return this.finishToken(types.question);
	      case 64:
	        ++this.state.pos;return this.finishToken(types.at);
	
	      case 96:
	        // '`'
	        ++this.state.pos;
	        return this.finishToken(types.backQuote);
	
	      case 48:
	        // '0'
	        var next = this.input.charCodeAt(this.state.pos + 1);
	        if (next === 120 || next === 88) return this.readRadixNumber(16); // '0x', '0X' - hex number
	        if (next === 111 || next === 79) return this.readRadixNumber(8); // '0o', '0O' - octal number
	        if (next === 98 || next === 66) return this.readRadixNumber(2); // '0b', '0B' - binary number
	      // Anything else beginning with a digit is an integer, octal
	      // number, or float.
	      case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:
	        // 1-9
	        return this.readNumber(false);
	
	      // Quotes produce strings.
	      case 34:case 39:
	        // '"', "'"
	        return this.readString(code);
	
	      // Operators are parsed inline in tiny state machines. '=' (61) is
	      // often referred to. `finishOp` simply skips the amount of
	      // characters it is given as second argument, and returns a token
	      // of the type given by its first argument.
	
	      case 47:
	        // '/'
	        return this.readToken_slash();
	
	      case 37:case 42:
	        // '%*'
	        return this.readToken_mult_modulo(code);
	
	      case 124:case 38:
	        // '|&'
	        return this.readToken_pipe_amp(code);
	
	      case 94:
	        // '^'
	        return this.readToken_caret();
	
	      case 43:case 45:
	        // '+-'
	        return this.readToken_plus_min(code);
	
	      case 60:case 62:
	        // '<>'
	        return this.readToken_lt_gt(code);
	
	      case 61:case 33:
	        // '=!'
	        return this.readToken_eq_excl(code);
	
	      case 126:
	        // '~'
	        return this.finishOp(types.prefix, 1);
	    }
	
	    this.raise(this.state.pos, "Unexpected character '" + codePointToString(code) + "'");
	  };
	
	  Tokenizer.prototype.finishOp = function finishOp(type, size) {
	    var str = this.input.slice(this.state.pos, this.state.pos + size);
	    this.state.pos += size;
	    return this.finishToken(type, str);
	  };
	
	  Tokenizer.prototype.readRegexp = function readRegexp() {
	    var start = this.state.pos;
	    var escaped = void 0,
	        inClass = void 0;
	    for (;;) {
	      if (this.state.pos >= this.input.length) this.raise(start, "Unterminated regular expression");
	      var ch = this.input.charAt(this.state.pos);
	      if (lineBreak.test(ch)) {
	        this.raise(start, "Unterminated regular expression");
	      }
	      if (escaped) {
	        escaped = false;
	      } else {
	        if (ch === "[") {
	          inClass = true;
	        } else if (ch === "]" && inClass) {
	          inClass = false;
	        } else if (ch === "/" && !inClass) {
	          break;
	        }
	        escaped = ch === "\\";
	      }
	      ++this.state.pos;
	    }
	    var content = this.input.slice(start, this.state.pos);
	    ++this.state.pos;
	    // Need to use `readWord1` because '\uXXXX' sequences are allowed
	    // here (don't ask).
	    var mods = this.readWord1();
	    if (mods) {
	      var validFlags = /^[gmsiyu]*$/;
	      if (!validFlags.test(mods)) this.raise(start, "Invalid regular expression flag");
	    }
	    return this.finishToken(types.regexp, {
	      pattern: content,
	      flags: mods
	    });
	  };
	
	  // Read an integer in the given radix. Return null if zero digits
	  // were read, the integer value otherwise. When `len` is given, this
	  // will return `null` unless the integer has exactly `len` digits.
	
	  Tokenizer.prototype.readInt = function readInt(radix, len) {
	    var start = this.state.pos;
	    var total = 0;
	
	    for (var i = 0, e = len == null ? Infinity : len; i < e; ++i) {
	      var code = this.input.charCodeAt(this.state.pos);
	      var val = void 0;
	      if (code >= 97) {
	        val = code - 97 + 10; // a
	      } else if (code >= 65) {
	        val = code - 65 + 10; // A
	      } else if (code >= 48 && code <= 57) {
	        val = code - 48; // 0-9
	      } else {
	        val = Infinity;
	      }
	      if (val >= radix) break;
	      ++this.state.pos;
	      total = total * radix + val;
	    }
	    if (this.state.pos === start || len != null && this.state.pos - start !== len) return null;
	
	    return total;
	  };
	
	  Tokenizer.prototype.readRadixNumber = function readRadixNumber(radix) {
	    this.state.pos += 2; // 0x
	    var val = this.readInt(radix);
	    if (val == null) this.raise(this.state.start + 2, "Expected number in radix " + radix);
	    if (isIdentifierStart(this.fullCharCodeAtPos())) this.raise(this.state.pos, "Identifier directly after number");
	    return this.finishToken(types.num, val);
	  };
	
	  // Read an integer, octal integer, or floating-point number.
	
	  Tokenizer.prototype.readNumber = function readNumber(startsWithDot) {
	    var start = this.state.pos;
	    var octal = this.input.charCodeAt(start) === 48; // '0'
	    var isFloat = false;
	
	    if (!startsWithDot && this.readInt(10) === null) this.raise(start, "Invalid number");
	    if (octal && this.state.pos == start + 1) octal = false; // number === 0
	
	    var next = this.input.charCodeAt(this.state.pos);
	    if (next === 46 && !octal) {
	      // '.'
	      ++this.state.pos;
	      this.readInt(10);
	      isFloat = true;
	      next = this.input.charCodeAt(this.state.pos);
	    }
	
	    if ((next === 69 || next === 101) && !octal) {
	      // 'eE'
	      next = this.input.charCodeAt(++this.state.pos);
	      if (next === 43 || next === 45) ++this.state.pos; // '+-'
	      if (this.readInt(10) === null) this.raise(start, "Invalid number");
	      isFloat = true;
	    }
	
	    if (isIdentifierStart(this.fullCharCodeAtPos())) this.raise(this.state.pos, "Identifier directly after number");
	
	    var str = this.input.slice(start, this.state.pos);
	    var val = void 0;
	    if (isFloat) {
	      val = parseFloat(str);
	    } else if (!octal || str.length === 1) {
	      val = parseInt(str, 10);
	    } else if (this.state.strict) {
	      this.raise(start, "Invalid number");
	    } else if (/[89]/.test(str)) {
	      val = parseInt(str, 10);
	    } else {
	      val = parseInt(str, 8);
	    }
	    return this.finishToken(types.num, val);
	  };
	
	  // Read a string value, interpreting backslash-escapes.
	
	  Tokenizer.prototype.readCodePoint = function readCodePoint(throwOnInvalid) {
	    var ch = this.input.charCodeAt(this.state.pos);
	    var code = void 0;
	
	    if (ch === 123) {
	      // '{'
	      var codePos = ++this.state.pos;
	      code = this.readHexChar(this.input.indexOf("}", this.state.pos) - this.state.pos, throwOnInvalid);
	      ++this.state.pos;
	      if (code === null) {
	        --this.state.invalidTemplateEscapePosition; // to point to the '\'' instead of the 'u'
	      } else if (code > 0x10FFFF) {
	        if (throwOnInvalid) {
	          this.raise(codePos, "Code point out of bounds");
	        } else {
	          this.state.invalidTemplateEscapePosition = codePos - 2;
	          return null;
	        }
	      }
	    } else {
	      code = this.readHexChar(4, throwOnInvalid);
	    }
	    return code;
	  };
	
	  Tokenizer.prototype.readString = function readString(quote) {
	    var out = "",
	        chunkStart = ++this.state.pos;
	    for (;;) {
	      if (this.state.pos >= this.input.length) this.raise(this.state.start, "Unterminated string constant");
	      var ch = this.input.charCodeAt(this.state.pos);
	      if (ch === quote) break;
	      if (ch === 92) {
	        // '\'
	        out += this.input.slice(chunkStart, this.state.pos);
	        out += this.readEscapedChar(false);
	        chunkStart = this.state.pos;
	      } else {
	        if (isNewLine(ch)) this.raise(this.state.start, "Unterminated string constant");
	        ++this.state.pos;
	      }
	    }
	    out += this.input.slice(chunkStart, this.state.pos++);
	    return this.finishToken(types.string, out);
	  };
	
	  // Reads template string tokens.
	
	  Tokenizer.prototype.readTmplToken = function readTmplToken() {
	    var out = "",
	        chunkStart = this.state.pos,
	        containsInvalid = false;
	    for (;;) {
	      if (this.state.pos >= this.input.length) this.raise(this.state.start, "Unterminated template");
	      var ch = this.input.charCodeAt(this.state.pos);
	      if (ch === 96 || ch === 36 && this.input.charCodeAt(this.state.pos + 1) === 123) {
	        // '`', '${'
	        if (this.state.pos === this.state.start && this.match(types.template)) {
	          if (ch === 36) {
	            this.state.pos += 2;
	            return this.finishToken(types.dollarBraceL);
	          } else {
	            ++this.state.pos;
	            return this.finishToken(types.backQuote);
	          }
	        }
	        out += this.input.slice(chunkStart, this.state.pos);
	        return this.finishToken(types.template, containsInvalid ? null : out);
	      }
	      if (ch === 92) {
	        // '\'
	        out += this.input.slice(chunkStart, this.state.pos);
	        var escaped = this.readEscapedChar(true);
	        if (escaped === null) {
	          containsInvalid = true;
	        } else {
	          out += escaped;
	        }
	        chunkStart = this.state.pos;
	      } else if (isNewLine(ch)) {
	        out += this.input.slice(chunkStart, this.state.pos);
	        ++this.state.pos;
	        switch (ch) {
	          case 13:
	            if (this.input.charCodeAt(this.state.pos) === 10) ++this.state.pos;
	          case 10:
	            out += "\n";
	            break;
	          default:
	            out += String.fromCharCode(ch);
	            break;
	        }
	        ++this.state.curLine;
	        this.state.lineStart = this.state.pos;
	        chunkStart = this.state.pos;
	      } else {
	        ++this.state.pos;
	      }
	    }
	  };
	
	  // Used to read escaped characters
	
	  Tokenizer.prototype.readEscapedChar = function readEscapedChar(inTemplate) {
	    var throwOnInvalid = !inTemplate;
	    var ch = this.input.charCodeAt(++this.state.pos);
	    ++this.state.pos;
	    switch (ch) {
	      case 110:
	        return "\n"; // 'n' -> '\n'
	      case 114:
	        return "\r"; // 'r' -> '\r'
	      case 120:
	        {
	          // 'x'
	          var code = this.readHexChar(2, throwOnInvalid);
	          return code === null ? null : String.fromCharCode(code);
	        }
	      case 117:
	        {
	          // 'u'
	          var _code = this.readCodePoint(throwOnInvalid);
	          return _code === null ? null : codePointToString(_code);
	        }
	      case 116:
	        return "\t"; // 't' -> '\t'
	      case 98:
	        return "\b"; // 'b' -> '\b'
	      case 118:
	        return "\x0B"; // 'v' -> '\u000b'
	      case 102:
	        return "\f"; // 'f' -> '\f'
	      case 13:
	        if (this.input.charCodeAt(this.state.pos) === 10) ++this.state.pos; // '\r\n'
	      case 10:
	        // ' \n'
	        this.state.lineStart = this.state.pos;
	        ++this.state.curLine;
	        return "";
	      default:
	        if (ch >= 48 && ch <= 55) {
	          var codePos = this.state.pos - 1;
	          var octalStr = this.input.substr(this.state.pos - 1, 3).match(/^[0-7]+/)[0];
	          var octal = parseInt(octalStr, 8);
	          if (octal > 255) {
	            octalStr = octalStr.slice(0, -1);
	            octal = parseInt(octalStr, 8);
	          }
	          if (octal > 0) {
	            if (inTemplate) {
	              this.state.invalidTemplateEscapePosition = codePos;
	              return null;
	            } else if (this.state.strict) {
	              this.raise(codePos, "Octal literal in strict mode");
	            } else if (!this.state.containsOctal) {
	              // These properties are only used to throw an error for an octal which occurs
	              // in a directive which occurs prior to a "use strict" directive.
	              this.state.containsOctal = true;
	              this.state.octalPosition = codePos;
	            }
	          }
	          this.state.pos += octalStr.length - 1;
	          return String.fromCharCode(octal);
	        }
	        return String.fromCharCode(ch);
	    }
	  };
	
	  // Used to read character escape sequences ('\x', '\u').
	
	  Tokenizer.prototype.readHexChar = function readHexChar(len, throwOnInvalid) {
	    var codePos = this.state.pos;
	    var n = this.readInt(16, len);
	    if (n === null) {
	      if (throwOnInvalid) {
	        this.raise(codePos, "Bad character escape sequence");
	      } else {
	        this.state.pos = codePos - 1;
	        this.state.invalidTemplateEscapePosition = codePos - 1;
	      }
	    }
	    return n;
	  };
	
	  // Read an identifier, and return it as a string. Sets `this.state.containsEsc`
	  // to whether the word contained a '\u' escape.
	  //
	  // Incrementally adds only escaped chars, adding other chunks as-is
	  // as a micro-optimization.
	
	  Tokenizer.prototype.readWord1 = function readWord1() {
	    this.state.containsEsc = false;
	    var word = "",
	        first = true,
	        chunkStart = this.state.pos;
	    while (this.state.pos < this.input.length) {
	      var ch = this.fullCharCodeAtPos();
	      if (isIdentifierChar(ch)) {
	        this.state.pos += ch <= 0xffff ? 1 : 2;
	      } else if (ch === 92) {
	        // "\"
	        this.state.containsEsc = true;
	
	        word += this.input.slice(chunkStart, this.state.pos);
	        var escStart = this.state.pos;
	
	        if (this.input.charCodeAt(++this.state.pos) !== 117) {
	          // "u"
	          this.raise(this.state.pos, "Expecting Unicode escape sequence \\uXXXX");
	        }
	
	        ++this.state.pos;
	        var esc = this.readCodePoint(true);
	        if (!(first ? isIdentifierStart : isIdentifierChar)(esc, true)) {
	          this.raise(escStart, "Invalid Unicode escape");
	        }
	
	        word += codePointToString(esc);
	        chunkStart = this.state.pos;
	      } else {
	        break;
	      }
	      first = false;
	    }
	    return word + this.input.slice(chunkStart, this.state.pos);
	  };
	
	  // Read an identifier or keyword token. Will check for reserved
	  // words when necessary.
	
	  Tokenizer.prototype.readWord = function readWord() {
	    var word = this.readWord1();
	    var type = types.name;
	    if (!this.state.containsEsc && this.isKeyword(word)) {
	      type = keywords[word];
	    }
	    return this.finishToken(type, word);
	  };
	
	  Tokenizer.prototype.braceIsBlock = function braceIsBlock(prevType) {
	    if (prevType === types.colon) {
	      var parent = this.curContext();
	      if (parent === types$1.braceStatement || parent === types$1.braceExpression) {
	        return !parent.isExpr;
	      }
	    }
	
	    if (prevType === types._return) {
	      return lineBreak.test(this.input.slice(this.state.lastTokEnd, this.state.start));
	    }
	
	    if (prevType === types._else || prevType === types.semi || prevType === types.eof || prevType === types.parenR) {
	      return true;
	    }
	
	    if (prevType === types.braceL) {
	      return this.curContext() === types$1.braceStatement;
	    }
	
	    return !this.state.exprAllowed;
	  };
	
	  Tokenizer.prototype.updateContext = function updateContext(prevType) {
	    var type = this.state.type;
	    var update = void 0;
	
	    if (type.keyword && prevType === types.dot) {
	      this.state.exprAllowed = false;
	    } else if (update = type.updateContext) {
	      update.call(this, prevType);
	    } else {
	      this.state.exprAllowed = type.beforeExpr;
	    }
	  };
	
	  return Tokenizer;
	}();
	
	var plugins = {};
	var frozenDeprecatedWildcardPluginList = ["jsx", "doExpressions", "objectRestSpread", "decorators", "classProperties", "exportExtensions", "asyncGenerators", "functionBind", "functionSent", "dynamicImport", "flow"];
	
	var Parser = function (_Tokenizer) {
	  inherits(Parser, _Tokenizer);
	
	  function Parser(options, input) {
	    classCallCheck(this, Parser);
	
	    options = getOptions(options);
	
	    var _this = possibleConstructorReturn(this, _Tokenizer.call(this, options, input));
	
	    _this.options = options;
	    _this.inModule = _this.options.sourceType === "module";
	    _this.input = input;
	    _this.plugins = _this.loadPlugins(_this.options.plugins);
	    _this.filename = options.sourceFilename;
	
	    // If enabled, skip leading hashbang line.
	    if (_this.state.pos === 0 && _this.input[0] === "#" && _this.input[1] === "!") {
	      _this.skipLineComment(2);
	    }
	    return _this;
	  }
	
	  Parser.prototype.isReservedWord = function isReservedWord(word) {
	    if (word === "await") {
	      return this.inModule;
	    } else {
	      return reservedWords[6](word);
	    }
	  };
	
	  Parser.prototype.hasPlugin = function hasPlugin(name) {
	    if (this.plugins["*"] && frozenDeprecatedWildcardPluginList.indexOf(name) > -1) {
	      return true;
	    }
	
	    return !!this.plugins[name];
	  };
	
	  Parser.prototype.extend = function extend(name, f) {
	    this[name] = f(this[name]);
	  };
	
	  Parser.prototype.loadAllPlugins = function loadAllPlugins() {
	    var _this2 = this;
	
	    // ensure flow plugin loads last, also ensure estree is not loaded with *
	    var pluginNames = Object.keys(plugins).filter(function (name) {
	      return name !== "flow" && name !== "estree";
	    });
	    pluginNames.push("flow");
	
	    pluginNames.forEach(function (name) {
	      var plugin = plugins[name];
	      if (plugin) plugin(_this2);
	    });
	  };
	
	  Parser.prototype.loadPlugins = function loadPlugins(pluginList) {
	    // TODO: Deprecate "*" option in next major version of Babylon
	    if (pluginList.indexOf("*") >= 0) {
	      this.loadAllPlugins();
	
	      return { "*": true };
	    }
	
	    var pluginMap = {};
	
	    if (pluginList.indexOf("flow") >= 0) {
	      // ensure flow plugin loads last
	      pluginList = pluginList.filter(function (plugin) {
	        return plugin !== "flow";
	      });
	      pluginList.push("flow");
	    }
	
	    if (pluginList.indexOf("estree") >= 0) {
	      // ensure estree plugin loads first
	      pluginList = pluginList.filter(function (plugin) {
	        return plugin !== "estree";
	      });
	      pluginList.unshift("estree");
	    }
	
	    for (var _iterator = pluginList, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var name = _ref;
	
	      if (!pluginMap[name]) {
	        pluginMap[name] = true;
	
	        var plugin = plugins[name];
	        if (plugin) plugin(this);
	      }
	    }
	
	    return pluginMap;
	  };
	
	  Parser.prototype.parse = function parse() {
	    var file = this.startNode();
	    var program = this.startNode();
	    this.nextToken();
	    return this.parseTopLevel(file, program);
	  };
	
	  return Parser;
	}(Tokenizer);
	
	var pp = Parser.prototype;
	
	// ## Parser utilities
	
	// TODO
	
	pp.addExtra = function (node, key, val) {
	  if (!node) return;
	
	  var extra = node.extra = node.extra || {};
	  extra[key] = val;
	};
	
	// TODO
	
	pp.isRelational = function (op) {
	  return this.match(types.relational) && this.state.value === op;
	};
	
	// TODO
	
	pp.expectRelational = function (op) {
	  if (this.isRelational(op)) {
	    this.next();
	  } else {
	    this.unexpected(null, types.relational);
	  }
	};
	
	// Tests whether parsed token is a contextual keyword.
	
	pp.isContextual = function (name) {
	  return this.match(types.name) && this.state.value === name;
	};
	
	// Consumes contextual keyword if possible.
	
	pp.eatContextual = function (name) {
	  return this.state.value === name && this.eat(types.name);
	};
	
	// Asserts that following token is given contextual keyword.
	
	pp.expectContextual = function (name, message) {
	  if (!this.eatContextual(name)) this.unexpected(null, message);
	};
	
	// Test whether a semicolon can be inserted at the current position.
	
	pp.canInsertSemicolon = function () {
	  return this.match(types.eof) || this.match(types.braceR) || lineBreak.test(this.input.slice(this.state.lastTokEnd, this.state.start));
	};
	
	// TODO
	
	pp.isLineTerminator = function () {
	  return this.eat(types.semi) || this.canInsertSemicolon();
	};
	
	// Consume a semicolon, or, failing that, see if we are allowed to
	// pretend that there is a semicolon at this position.
	
	pp.semicolon = function () {
	  if (!this.isLineTerminator()) this.unexpected(null, types.semi);
	};
	
	// Expect a token of a given type. If found, consume it, otherwise,
	// raise an unexpected token error at given pos.
	
	pp.expect = function (type, pos) {
	  return this.eat(type) || this.unexpected(pos, type);
	};
	
	// Raise an unexpected token error. Can take the expected token type
	// instead of a message string.
	
	pp.unexpected = function (pos) {
	  var messageOrType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Unexpected token";
	
	  if (messageOrType && (typeof messageOrType === "undefined" ? "undefined" : _typeof(messageOrType)) === "object" && messageOrType.label) {
	    messageOrType = "Unexpected token, expected " + messageOrType.label;
	  }
	  this.raise(pos != null ? pos : this.state.start, messageOrType);
	};
	
	/* eslint max-len: 0 */
	
	var pp$1 = Parser.prototype;
	
	// ### Statement parsing
	
	// Parse a program. Initializes the parser, reads any number of
	// statements, and wraps them in a Program node.  Optionally takes a
	// `program` argument.  If present, the statements will be appended
	// to its body instead of creating a new node.
	
	pp$1.parseTopLevel = function (file, program) {
	  program.sourceType = this.options.sourceType;
	
	  this.parseBlockBody(program, true, true, types.eof);
	
	  file.program = this.finishNode(program, "Program");
	  file.comments = this.state.comments;
	  file.tokens = this.state.tokens;
	
	  return this.finishNode(file, "File");
	};
	
	var loopLabel = { kind: "loop" };
	var switchLabel = { kind: "switch" };
	
	// TODO
	
	pp$1.stmtToDirective = function (stmt) {
	  var expr = stmt.expression;
	
	  var directiveLiteral = this.startNodeAt(expr.start, expr.loc.start);
	  var directive = this.startNodeAt(stmt.start, stmt.loc.start);
	
	  var raw = this.input.slice(expr.start, expr.end);
	  var val = directiveLiteral.value = raw.slice(1, -1); // remove quotes
	
	  this.addExtra(directiveLiteral, "raw", raw);
	  this.addExtra(directiveLiteral, "rawValue", val);
	
	  directive.value = this.finishNodeAt(directiveLiteral, "DirectiveLiteral", expr.end, expr.loc.end);
	
	  return this.finishNodeAt(directive, "Directive", stmt.end, stmt.loc.end);
	};
	
	// Parse a single statement.
	//
	// If expecting a statement and finding a slash operator, parse a
	// regular expression literal. This is to handle cases like
	// `if (foo) /blah/.exec(foo)`, where looking at the previous token
	// does not help.
	
	pp$1.parseStatement = function (declaration, topLevel) {
	  if (this.match(types.at)) {
	    this.parseDecorators(true);
	  }
	
	  var starttype = this.state.type;
	  var node = this.startNode();
	
	  // Most types of statements are recognized by the keyword they
	  // start with. Many are trivial to parse, some require a bit of
	  // complexity.
	
	  switch (starttype) {
	    case types._break:case types._continue:
	      return this.parseBreakContinueStatement(node, starttype.keyword);
	    case types._debugger:
	      return this.parseDebuggerStatement(node);
	    case types._do:
	      return this.parseDoStatement(node);
	    case types._for:
	      return this.parseForStatement(node);
	    case types._function:
	      if (!declaration) this.unexpected();
	      return this.parseFunctionStatement(node);
	
	    case types._class:
	      if (!declaration) this.unexpected();
	      return this.parseClass(node, true);
	
	    case types._if:
	      return this.parseIfStatement(node);
	    case types._return:
	      return this.parseReturnStatement(node);
	    case types._switch:
	      return this.parseSwitchStatement(node);
	    case types._throw:
	      return this.parseThrowStatement(node);
	    case types._try:
	      return this.parseTryStatement(node);
	
	    case types._let:
	    case types._const:
	      if (!declaration) this.unexpected(); // NOTE: falls through to _var
	
	    case types._var:
	      return this.parseVarStatement(node, starttype);
	
	    case types._while:
	      return this.parseWhileStatement(node);
	    case types._with:
	      return this.parseWithStatement(node);
	    case types.braceL:
	      return this.parseBlock();
	    case types.semi:
	      return this.parseEmptyStatement(node);
	    case types._export:
	    case types._import:
	      if (this.hasPlugin("dynamicImport") && this.lookahead().type === types.parenL) break;
	
	      if (!this.options.allowImportExportEverywhere) {
	        if (!topLevel) {
	          this.raise(this.state.start, "'import' and 'export' may only appear at the top level");
	        }
	
	        if (!this.inModule) {
	          this.raise(this.state.start, "'import' and 'export' may appear only with 'sourceType: \"module\"'");
	        }
	      }
	      return starttype === types._import ? this.parseImport(node) : this.parseExport(node);
	
	    case types.name:
	      if (this.state.value === "async") {
	        // peek ahead and see if next token is a function
	        var state = this.state.clone();
	        this.next();
	        if (this.match(types._function) && !this.canInsertSemicolon()) {
	          this.expect(types._function);
	          return this.parseFunction(node, true, false, true);
	        } else {
	          this.state = state;
	        }
	      }
	  }
	
	  // If the statement does not start with a statement keyword or a
	  // brace, it's an ExpressionStatement or LabeledStatement. We
	  // simply start parsing an expression, and afterwards, if the
	  // next token is a colon and the expression was a simple
	  // Identifier node, we switch to interpreting it as a label.
	  var maybeName = this.state.value;
	  var expr = this.parseExpression();
	
	  if (starttype === types.name && expr.type === "Identifier" && this.eat(types.colon)) {
	    return this.parseLabeledStatement(node, maybeName, expr);
	  } else {
	    return this.parseExpressionStatement(node, expr);
	  }
	};
	
	pp$1.takeDecorators = function (node) {
	  if (this.state.decorators.length) {
	    node.decorators = this.state.decorators;
	    this.state.decorators = [];
	  }
	};
	
	pp$1.parseDecorators = function (allowExport) {
	  while (this.match(types.at)) {
	    var decorator = this.parseDecorator();
	    this.state.decorators.push(decorator);
	  }
	
	  if (allowExport && this.match(types._export)) {
	    return;
	  }
	
	  if (!this.match(types._class)) {
	    this.raise(this.state.start, "Leading decorators must be attached to a class declaration");
	  }
	};
	
	pp$1.parseDecorator = function () {
	  if (!this.hasPlugin("decorators")) {
	    this.unexpected();
	  }
	  var node = this.startNode();
	  this.next();
	  node.expression = this.parseMaybeAssign();
	  return this.finishNode(node, "Decorator");
	};
	
	pp$1.parseBreakContinueStatement = function (node, keyword) {
	  var isBreak = keyword === "break";
	  this.next();
	
	  if (this.isLineTerminator()) {
	    node.label = null;
	  } else if (!this.match(types.name)) {
	    this.unexpected();
	  } else {
	    node.label = this.parseIdentifier();
	    this.semicolon();
	  }
	
	  // Verify that there is an actual destination to break or
	  // continue to.
	  var i = void 0;
	  for (i = 0; i < this.state.labels.length; ++i) {
	    var lab = this.state.labels[i];
	    if (node.label == null || lab.name === node.label.name) {
	      if (lab.kind != null && (isBreak || lab.kind === "loop")) break;
	      if (node.label && isBreak) break;
	    }
	  }
	  if (i === this.state.labels.length) this.raise(node.start, "Unsyntactic " + keyword);
	  return this.finishNode(node, isBreak ? "BreakStatement" : "ContinueStatement");
	};
	
	pp$1.parseDebuggerStatement = function (node) {
	  this.next();
	  this.semicolon();
	  return this.finishNode(node, "DebuggerStatement");
	};
	
	pp$1.parseDoStatement = function (node) {
	  this.next();
	  this.state.labels.push(loopLabel);
	  node.body = this.parseStatement(false);
	  this.state.labels.pop();
	  this.expect(types._while);
	  node.test = this.parseParenExpression();
	  this.eat(types.semi);
	  return this.finishNode(node, "DoWhileStatement");
	};
	
	// Disambiguating between a `for` and a `for`/`in` or `for`/`of`
	// loop is non-trivial. Basically, we have to parse the init `var`
	// statement or expression, disallowing the `in` operator (see
	// the second parameter to `parseExpression`), and then check
	// whether the next token is `in` or `of`. When there is no init
	// part (semicolon immediately after the opening parenthesis), it
	// is a regular `for` loop.
	
	pp$1.parseForStatement = function (node) {
	  this.next();
	  this.state.labels.push(loopLabel);
	
	  var forAwait = false;
	  if (this.hasPlugin("asyncGenerators") && this.state.inAsync && this.isContextual("await")) {
	    forAwait = true;
	    this.next();
	  }
	  this.expect(types.parenL);
	
	  if (this.match(types.semi)) {
	    if (forAwait) {
	      this.unexpected();
	    }
	    return this.parseFor(node, null);
	  }
	
	  if (this.match(types._var) || this.match(types._let) || this.match(types._const)) {
	    var _init = this.startNode();
	    var varKind = this.state.type;
	    this.next();
	    this.parseVar(_init, true, varKind);
	    this.finishNode(_init, "VariableDeclaration");
	
	    if (this.match(types._in) || this.isContextual("of")) {
	      if (_init.declarations.length === 1 && !_init.declarations[0].init) {
	        return this.parseForIn(node, _init, forAwait);
	      }
	    }
	    if (forAwait) {
	      this.unexpected();
	    }
	    return this.parseFor(node, _init);
	  }
	
	  var refShorthandDefaultPos = { start: 0 };
	  var init = this.parseExpression(true, refShorthandDefaultPos);
	  if (this.match(types._in) || this.isContextual("of")) {
	    var description = this.isContextual("of") ? "for-of statement" : "for-in statement";
	    this.toAssignable(init, undefined, description);
	    this.checkLVal(init, undefined, undefined, description);
	    return this.parseForIn(node, init, forAwait);
	  } else if (refShorthandDefaultPos.start) {
	    this.unexpected(refShorthandDefaultPos.start);
	  }
	  if (forAwait) {
	    this.unexpected();
	  }
	  return this.parseFor(node, init);
	};
	
	pp$1.parseFunctionStatement = function (node) {
	  this.next();
	  return this.parseFunction(node, true);
	};
	
	pp$1.parseIfStatement = function (node) {
	  this.next();
	  node.test = this.parseParenExpression();
	  node.consequent = this.parseStatement(false);
	  node.alternate = this.eat(types._else) ? this.parseStatement(false) : null;
	  return this.finishNode(node, "IfStatement");
	};
	
	pp$1.parseReturnStatement = function (node) {
	  if (!this.state.inFunction && !this.options.allowReturnOutsideFunction) {
	    this.raise(this.state.start, "'return' outside of function");
	  }
	
	  this.next();
	
	  // In `return` (and `break`/`continue`), the keywords with
	  // optional arguments, we eagerly look for a semicolon or the
	  // possibility to insert one.
	
	  if (this.isLineTerminator()) {
	    node.argument = null;
	  } else {
	    node.argument = this.parseExpression();
	    this.semicolon();
	  }
	
	  return this.finishNode(node, "ReturnStatement");
	};
	
	pp$1.parseSwitchStatement = function (node) {
	  this.next();
	  node.discriminant = this.parseParenExpression();
	  node.cases = [];
	  this.expect(types.braceL);
	  this.state.labels.push(switchLabel);
	
	  // Statements under must be grouped (by label) in SwitchCase
	  // nodes. `cur` is used to keep the node that we are currently
	  // adding statements to.
	
	  var cur = void 0;
	  for (var sawDefault; !this.match(types.braceR);) {
	    if (this.match(types._case) || this.match(types._default)) {
	      var isCase = this.match(types._case);
	      if (cur) this.finishNode(cur, "SwitchCase");
	      node.cases.push(cur = this.startNode());
	      cur.consequent = [];
	      this.next();
	      if (isCase) {
	        cur.test = this.parseExpression();
	      } else {
	        if (sawDefault) this.raise(this.state.lastTokStart, "Multiple default clauses");
	        sawDefault = true;
	        cur.test = null;
	      }
	      this.expect(types.colon);
	    } else {
	      if (cur) {
	        cur.consequent.push(this.parseStatement(true));
	      } else {
	        this.unexpected();
	      }
	    }
	  }
	  if (cur) this.finishNode(cur, "SwitchCase");
	  this.next(); // Closing brace
	  this.state.labels.pop();
	  return this.finishNode(node, "SwitchStatement");
	};
	
	pp$1.parseThrowStatement = function (node) {
	  this.next();
	  if (lineBreak.test(this.input.slice(this.state.lastTokEnd, this.state.start))) this.raise(this.state.lastTokEnd, "Illegal newline after throw");
	  node.argument = this.parseExpression();
	  this.semicolon();
	  return this.finishNode(node, "ThrowStatement");
	};
	
	// Reused empty array added for node fields that are always empty.
	
	var empty = [];
	
	pp$1.parseTryStatement = function (node) {
	  this.next();
	
	  node.block = this.parseBlock();
	  node.handler = null;
	
	  if (this.match(types._catch)) {
	    var clause = this.startNode();
	    this.next();
	
	    this.expect(types.parenL);
	    clause.param = this.parseBindingAtom();
	    this.checkLVal(clause.param, true, Object.create(null), "catch clause");
	    this.expect(types.parenR);
	
	    clause.body = this.parseBlock();
	    node.handler = this.finishNode(clause, "CatchClause");
	  }
	
	  node.guardedHandlers = empty;
	  node.finalizer = this.eat(types._finally) ? this.parseBlock() : null;
	
	  if (!node.handler && !node.finalizer) {
	    this.raise(node.start, "Missing catch or finally clause");
	  }
	
	  return this.finishNode(node, "TryStatement");
	};
	
	pp$1.parseVarStatement = function (node, kind) {
	  this.next();
	  this.parseVar(node, false, kind);
	  this.semicolon();
	  return this.finishNode(node, "VariableDeclaration");
	};
	
	pp$1.parseWhileStatement = function (node) {
	  this.next();
	  node.test = this.parseParenExpression();
	  this.state.labels.push(loopLabel);
	  node.body = this.parseStatement(false);
	  this.state.labels.pop();
	  return this.finishNode(node, "WhileStatement");
	};
	
	pp$1.parseWithStatement = function (node) {
	  if (this.state.strict) this.raise(this.state.start, "'with' in strict mode");
	  this.next();
	  node.object = this.parseParenExpression();
	  node.body = this.parseStatement(false);
	  return this.finishNode(node, "WithStatement");
	};
	
	pp$1.parseEmptyStatement = function (node) {
	  this.next();
	  return this.finishNode(node, "EmptyStatement");
	};
	
	pp$1.parseLabeledStatement = function (node, maybeName, expr) {
	  for (var _iterator = this.state.labels, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var _label = _ref;
	
	    if (_label.name === maybeName) {
	      this.raise(expr.start, "Label '" + maybeName + "' is already declared");
	    }
	  }
	
	  var kind = this.state.type.isLoop ? "loop" : this.match(types._switch) ? "switch" : null;
	  for (var i = this.state.labels.length - 1; i >= 0; i--) {
	    var label = this.state.labels[i];
	    if (label.statementStart === node.start) {
	      label.statementStart = this.state.start;
	      label.kind = kind;
	    } else {
	      break;
	    }
	  }
	
	  this.state.labels.push({ name: maybeName, kind: kind, statementStart: this.state.start });
	  node.body = this.parseStatement(true);
	  this.state.labels.pop();
	  node.label = expr;
	  return this.finishNode(node, "LabeledStatement");
	};
	
	pp$1.parseExpressionStatement = function (node, expr) {
	  node.expression = expr;
	  this.semicolon();
	  return this.finishNode(node, "ExpressionStatement");
	};
	
	// Parse a semicolon-enclosed block of statements, handling `"use
	// strict"` declarations when `allowStrict` is true (used for
	// function bodies).
	
	pp$1.parseBlock = function (allowDirectives) {
	  var node = this.startNode();
	  this.expect(types.braceL);
	  this.parseBlockBody(node, allowDirectives, false, types.braceR);
	  return this.finishNode(node, "BlockStatement");
	};
	
	pp$1.isValidDirective = function (stmt) {
	  return stmt.type === "ExpressionStatement" && stmt.expression.type === "StringLiteral" && !stmt.expression.extra.parenthesized;
	};
	
	pp$1.parseBlockBody = function (node, allowDirectives, topLevel, end) {
	  node.body = [];
	  node.directives = [];
	
	  var parsedNonDirective = false;
	  var oldStrict = void 0;
	  var octalPosition = void 0;
	
	  while (!this.eat(end)) {
	    if (!parsedNonDirective && this.state.containsOctal && !octalPosition) {
	      octalPosition = this.state.octalPosition;
	    }
	
	    var stmt = this.parseStatement(true, topLevel);
	
	    if (allowDirectives && !parsedNonDirective && this.isValidDirective(stmt)) {
	      var directive = this.stmtToDirective(stmt);
	      node.directives.push(directive);
	
	      if (oldStrict === undefined && directive.value.value === "use strict") {
	        oldStrict = this.state.strict;
	        this.setStrict(true);
	
	        if (octalPosition) {
	          this.raise(octalPosition, "Octal literal in strict mode");
	        }
	      }
	
	      continue;
	    }
	
	    parsedNonDirective = true;
	    node.body.push(stmt);
	  }
	
	  if (oldStrict === false) {
	    this.setStrict(false);
	  }
	};
	
	// Parse a regular `for` loop. The disambiguation code in
	// `parseStatement` will already have parsed the init statement or
	// expression.
	
	pp$1.parseFor = function (node, init) {
	  node.init = init;
	  this.expect(types.semi);
	  node.test = this.match(types.semi) ? null : this.parseExpression();
	  this.expect(types.semi);
	  node.update = this.match(types.parenR) ? null : this.parseExpression();
	  this.expect(types.parenR);
	  node.body = this.parseStatement(false);
	  this.state.labels.pop();
	  return this.finishNode(node, "ForStatement");
	};
	
	// Parse a `for`/`in` and `for`/`of` loop, which are almost
	// same from parser's perspective.
	
	pp$1.parseForIn = function (node, init, forAwait) {
	  var type = void 0;
	  if (forAwait) {
	    this.eatContextual("of");
	    type = "ForAwaitStatement";
	  } else {
	    type = this.match(types._in) ? "ForInStatement" : "ForOfStatement";
	    this.next();
	  }
	  node.left = init;
	  node.right = this.parseExpression();
	  this.expect(types.parenR);
	  node.body = this.parseStatement(false);
	  this.state.labels.pop();
	  return this.finishNode(node, type);
	};
	
	// Parse a list of variable declarations.
	
	pp$1.parseVar = function (node, isFor, kind) {
	  node.declarations = [];
	  node.kind = kind.keyword;
	  for (;;) {
	    var decl = this.startNode();
	    this.parseVarHead(decl);
	    if (this.eat(types.eq)) {
	      decl.init = this.parseMaybeAssign(isFor);
	    } else if (kind === types._const && !(this.match(types._in) || this.isContextual("of"))) {
	      this.unexpected();
	    } else if (decl.id.type !== "Identifier" && !(isFor && (this.match(types._in) || this.isContextual("of")))) {
	      this.raise(this.state.lastTokEnd, "Complex binding patterns require an initialization value");
	    } else {
	      decl.init = null;
	    }
	    node.declarations.push(this.finishNode(decl, "VariableDeclarator"));
	    if (!this.eat(types.comma)) break;
	  }
	  return node;
	};
	
	pp$1.parseVarHead = function (decl) {
	  decl.id = this.parseBindingAtom();
	  this.checkLVal(decl.id, true, undefined, "variable declaration");
	};
	
	// Parse a function declaration or literal (depending on the
	// `isStatement` parameter).
	
	pp$1.parseFunction = function (node, isStatement, allowExpressionBody, isAsync, optionalId) {
	  var oldInMethod = this.state.inMethod;
	  this.state.inMethod = false;
	
	  this.initFunction(node, isAsync);
	
	  if (this.match(types.star)) {
	    if (node.async && !this.hasPlugin("asyncGenerators")) {
	      this.unexpected();
	    } else {
	      node.generator = true;
	      this.next();
	    }
	  }
	
	  if (isStatement && !optionalId && !this.match(types.name) && !this.match(types._yield)) {
	    this.unexpected();
	  }
	
	  if (this.match(types.name) || this.match(types._yield)) {
	    node.id = this.parseBindingIdentifier();
	  }
	
	  this.parseFunctionParams(node);
	  this.parseFunctionBody(node, allowExpressionBody);
	
	  this.state.inMethod = oldInMethod;
	
	  return this.finishNode(node, isStatement ? "FunctionDeclaration" : "FunctionExpression");
	};
	
	pp$1.parseFunctionParams = function (node) {
	  this.expect(types.parenL);
	  node.params = this.parseBindingList(types.parenR);
	};
	
	// Parse a class declaration or literal (depending on the
	// `isStatement` parameter).
	
	pp$1.parseClass = function (node, isStatement, optionalId) {
	  this.next();
	  this.takeDecorators(node);
	  this.parseClassId(node, isStatement, optionalId);
	  this.parseClassSuper(node);
	  this.parseClassBody(node);
	  return this.finishNode(node, isStatement ? "ClassDeclaration" : "ClassExpression");
	};
	
	pp$1.isClassProperty = function () {
	  return this.match(types.eq) || this.match(types.semi) || this.match(types.braceR);
	};
	
	pp$1.isClassMethod = function () {
	  return this.match(types.parenL);
	};
	
	pp$1.isNonstaticConstructor = function (method) {
	  return !method.computed && !method.static && (method.key.name === "constructor" || // Identifier
	  method.key.value === "constructor" // Literal
	  );
	};
	
	pp$1.parseClassBody = function (node) {
	  // class bodies are implicitly strict
	  var oldStrict = this.state.strict;
	  this.state.strict = true;
	
	  var hadConstructorCall = false;
	  var hadConstructor = false;
	  var decorators = [];
	  var classBody = this.startNode();
	
	  classBody.body = [];
	
	  this.expect(types.braceL);
	
	  while (!this.eat(types.braceR)) {
	    if (this.eat(types.semi)) {
	      if (decorators.length > 0) {
	        this.raise(this.state.lastTokEnd, "Decorators must not be followed by a semicolon");
	      }
	      continue;
	    }
	
	    if (this.match(types.at)) {
	      decorators.push(this.parseDecorator());
	      continue;
	    }
	
	    var method = this.startNode();
	
	    // steal the decorators if there are any
	    if (decorators.length) {
	      method.decorators = decorators;
	      decorators = [];
	    }
	
	    method.static = false;
	    if (this.match(types.name) && this.state.value === "static") {
	      var key = this.parseIdentifier(true); // eats 'static'
	      if (this.isClassMethod()) {
	        // a method named 'static'
	        method.kind = "method";
	        method.computed = false;
	        method.key = key;
	        this.parseClassMethod(classBody, method, false, false);
	        continue;
	      } else if (this.isClassProperty()) {
	        // a property named 'static'
	        method.computed = false;
	        method.key = key;
	        classBody.body.push(this.parseClassProperty(method));
	        continue;
	      }
	      // otherwise something static
	      method.static = true;
	    }
	
	    if (this.eat(types.star)) {
	      // a generator
	      method.kind = "method";
	      this.parsePropertyName(method);
	      if (this.isNonstaticConstructor(method)) {
	        this.raise(method.key.start, "Constructor can't be a generator");
	      }
	      if (!method.computed && method.static && (method.key.name === "prototype" || method.key.value === "prototype")) {
	        this.raise(method.key.start, "Classes may not have static property named prototype");
	      }
	      this.parseClassMethod(classBody, method, true, false);
	    } else {
	      var isSimple = this.match(types.name);
	      var _key = this.parsePropertyName(method);
	      if (!method.computed && method.static && (method.key.name === "prototype" || method.key.value === "prototype")) {
	        this.raise(method.key.start, "Classes may not have static property named prototype");
	      }
	      if (this.isClassMethod()) {
	        // a normal method
	        if (this.isNonstaticConstructor(method)) {
	          if (hadConstructor) {
	            this.raise(_key.start, "Duplicate constructor in the same class");
	          } else if (method.decorators) {
	            this.raise(method.start, "You can't attach decorators to a class constructor");
	          }
	          hadConstructor = true;
	          method.kind = "constructor";
	        } else {
	          method.kind = "method";
	        }
	        this.parseClassMethod(classBody, method, false, false);
	      } else if (this.isClassProperty()) {
	        // a normal property
	        if (this.isNonstaticConstructor(method)) {
	          this.raise(method.key.start, "Classes may not have a non-static field named 'constructor'");
	        }
	        classBody.body.push(this.parseClassProperty(method));
	      } else if (isSimple && _key.name === "async" && !this.isLineTerminator()) {
	        // an async method
	        var isGenerator = this.hasPlugin("asyncGenerators") && this.eat(types.star);
	        method.kind = "method";
	        this.parsePropertyName(method);
	        if (this.isNonstaticConstructor(method)) {
	          this.raise(method.key.start, "Constructor can't be an async function");
	        }
	        this.parseClassMethod(classBody, method, isGenerator, true);
	      } else if (isSimple && (_key.name === "get" || _key.name === "set") && !(this.isLineTerminator() && this.match(types.star))) {
	        // `get\n*` is an uninitialized property named 'get' followed by a generator.
	        // a getter or setter
	        method.kind = _key.name;
	        this.parsePropertyName(method);
	        if (this.isNonstaticConstructor(method)) {
	          this.raise(method.key.start, "Constructor can't have get/set modifier");
	        }
	        this.parseClassMethod(classBody, method, false, false);
	        this.checkGetterSetterParamCount(method);
	      } else if (this.hasPlugin("classConstructorCall") && isSimple && _key.name === "call" && this.match(types.name) && this.state.value === "constructor") {
	        // a (deprecated) call constructor
	        if (hadConstructorCall) {
	          this.raise(method.start, "Duplicate constructor call in the same class");
	        } else if (method.decorators) {
	          this.raise(method.start, "You can't attach decorators to a class constructor");
	        }
	        hadConstructorCall = true;
	        method.kind = "constructorCall";
	        this.parsePropertyName(method); // consume "constructor" and make it the method's name
	        this.parseClassMethod(classBody, method, false, false);
	      } else if (this.isLineTerminator()) {
	        // an uninitialized class property (due to ASI, since we don't otherwise recognize the next token)
	        if (this.isNonstaticConstructor(method)) {
	          this.raise(method.key.start, "Classes may not have a non-static field named 'constructor'");
	        }
	        classBody.body.push(this.parseClassProperty(method));
	      } else {
	        this.unexpected();
	      }
	    }
	  }
	
	  if (decorators.length) {
	    this.raise(this.state.start, "You have trailing decorators with no method");
	  }
	
	  node.body = this.finishNode(classBody, "ClassBody");
	
	  this.state.strict = oldStrict;
	};
	
	pp$1.parseClassProperty = function (node) {
	  this.state.inClassProperty = true;
	  if (this.match(types.eq)) {
	    if (!this.hasPlugin("classProperties")) this.unexpected();
	    this.next();
	    node.value = this.parseMaybeAssign();
	  } else {
	    node.value = null;
	  }
	  this.semicolon();
	  this.state.inClassProperty = false;
	  return this.finishNode(node, "ClassProperty");
	};
	
	pp$1.parseClassMethod = function (classBody, method, isGenerator, isAsync) {
	  this.parseMethod(method, isGenerator, isAsync);
	  classBody.body.push(this.finishNode(method, "ClassMethod"));
	};
	
	pp$1.parseClassId = function (node, isStatement, optionalId) {
	  if (this.match(types.name)) {
	    node.id = this.parseIdentifier();
	  } else {
	    if (optionalId || !isStatement) {
	      node.id = null;
	    } else {
	      this.unexpected();
	    }
	  }
	};
	
	pp$1.parseClassSuper = function (node) {
	  node.superClass = this.eat(types._extends) ? this.parseExprSubscripts() : null;
	};
	
	// Parses module export declaration.
	
	pp$1.parseExport = function (node) {
	  this.next();
	  // export * from '...'
	  if (this.match(types.star)) {
	    var specifier = this.startNode();
	    this.next();
	    if (this.hasPlugin("exportExtensions") && this.eatContextual("as")) {
	      specifier.exported = this.parseIdentifier();
	      node.specifiers = [this.finishNode(specifier, "ExportNamespaceSpecifier")];
	      this.parseExportSpecifiersMaybe(node);
	      this.parseExportFrom(node, true);
	    } else {
	      this.parseExportFrom(node, true);
	      return this.finishNode(node, "ExportAllDeclaration");
	    }
	  } else if (this.hasPlugin("exportExtensions") && this.isExportDefaultSpecifier()) {
	    var _specifier = this.startNode();
	    _specifier.exported = this.parseIdentifier(true);
	    node.specifiers = [this.finishNode(_specifier, "ExportDefaultSpecifier")];
	    if (this.match(types.comma) && this.lookahead().type === types.star) {
	      this.expect(types.comma);
	      var _specifier2 = this.startNode();
	      this.expect(types.star);
	      this.expectContextual("as");
	      _specifier2.exported = this.parseIdentifier();
	      node.specifiers.push(this.finishNode(_specifier2, "ExportNamespaceSpecifier"));
	    } else {
	      this.parseExportSpecifiersMaybe(node);
	    }
	    this.parseExportFrom(node, true);
	  } else if (this.eat(types._default)) {
	    // export default ...
	    var expr = this.startNode();
	    var needsSemi = false;
	    if (this.eat(types._function)) {
	      expr = this.parseFunction(expr, true, false, false, true);
	    } else if (this.match(types._class)) {
	      expr = this.parseClass(expr, true, true);
	    } else {
	      needsSemi = true;
	      expr = this.parseMaybeAssign();
	    }
	    node.declaration = expr;
	    if (needsSemi) this.semicolon();
	    this.checkExport(node, true, true);
	    return this.finishNode(node, "ExportDefaultDeclaration");
	  } else if (this.shouldParseExportDeclaration()) {
	    node.specifiers = [];
	    node.source = null;
	    node.declaration = this.parseExportDeclaration(node);
	  } else {
	    // export { x, y as z } [from '...']
	    node.declaration = null;
	    node.specifiers = this.parseExportSpecifiers();
	    this.parseExportFrom(node);
	  }
	  this.checkExport(node, true);
	  return this.finishNode(node, "ExportNamedDeclaration");
	};
	
	pp$1.parseExportDeclaration = function () {
	  return this.parseStatement(true);
	};
	
	pp$1.isExportDefaultSpecifier = function () {
	  if (this.match(types.name)) {
	    return this.state.value !== "async";
	  }
	
	  if (!this.match(types._default)) {
	    return false;
	  }
	
	  var lookahead = this.lookahead();
	  return lookahead.type === types.comma || lookahead.type === types.name && lookahead.value === "from";
	};
	
	pp$1.parseExportSpecifiersMaybe = function (node) {
	  if (this.eat(types.comma)) {
	    node.specifiers = node.specifiers.concat(this.parseExportSpecifiers());
	  }
	};
	
	pp$1.parseExportFrom = function (node, expect) {
	  if (this.eatContextual("from")) {
	    node.source = this.match(types.string) ? this.parseExprAtom() : this.unexpected();
	    this.checkExport(node);
	  } else {
	    if (expect) {
	      this.unexpected();
	    } else {
	      node.source = null;
	    }
	  }
	
	  this.semicolon();
	};
	
	pp$1.shouldParseExportDeclaration = function () {
	  return this.state.type.keyword === "var" || this.state.type.keyword === "const" || this.state.type.keyword === "let" || this.state.type.keyword === "function" || this.state.type.keyword === "class" || this.isContextual("async");
	};
	
	pp$1.checkExport = function (node, checkNames, isDefault) {
	  if (checkNames) {
	    // Check for duplicate exports
	    if (isDefault) {
	      // Default exports
	      this.checkDuplicateExports(node, "default");
	    } else if (node.specifiers && node.specifiers.length) {
	      // Named exports
	      for (var _iterator2 = node.specifiers, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	        var _ref2;
	
	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }
	
	        var specifier = _ref2;
	
	        this.checkDuplicateExports(specifier, specifier.exported.name);
	      }
	    } else if (node.declaration) {
	      // Exported declarations
	      if (node.declaration.type === "FunctionDeclaration" || node.declaration.type === "ClassDeclaration") {
	        this.checkDuplicateExports(node, node.declaration.id.name);
	      } else if (node.declaration.type === "VariableDeclaration") {
	        for (var _iterator3 = node.declaration.declarations, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	          var _ref3;
	
	          if (_isArray3) {
	            if (_i3 >= _iterator3.length) break;
	            _ref3 = _iterator3[_i3++];
	          } else {
	            _i3 = _iterator3.next();
	            if (_i3.done) break;
	            _ref3 = _i3.value;
	          }
	
	          var declaration = _ref3;
	
	          this.checkDeclaration(declaration.id);
	        }
	      }
	    }
	  }
	
	  if (this.state.decorators.length) {
	    var isClass = node.declaration && (node.declaration.type === "ClassDeclaration" || node.declaration.type === "ClassExpression");
	    if (!node.declaration || !isClass) {
	      this.raise(node.start, "You can only use decorators on an export when exporting a class");
	    }
	    this.takeDecorators(node.declaration);
	  }
	};
	
	pp$1.checkDeclaration = function (node) {
	  if (node.type === "ObjectPattern") {
	    for (var _iterator4 = node.properties, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
	      var _ref4;
	
	      if (_isArray4) {
	        if (_i4 >= _iterator4.length) break;
	        _ref4 = _iterator4[_i4++];
	      } else {
	        _i4 = _iterator4.next();
	        if (_i4.done) break;
	        _ref4 = _i4.value;
	      }
	
	      var prop = _ref4;
	
	      this.checkDeclaration(prop);
	    }
	  } else if (node.type === "ArrayPattern") {
	    for (var _iterator5 = node.elements, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
	      var _ref5;
	
	      if (_isArray5) {
	        if (_i5 >= _iterator5.length) break;
	        _ref5 = _iterator5[_i5++];
	      } else {
	        _i5 = _iterator5.next();
	        if (_i5.done) break;
	        _ref5 = _i5.value;
	      }
	
	      var elem = _ref5;
	
	      if (elem) {
	        this.checkDeclaration(elem);
	      }
	    }
	  } else if (node.type === "ObjectProperty") {
	    this.checkDeclaration(node.value);
	  } else if (node.type === "RestElement" || node.type === "RestProperty") {
	    this.checkDeclaration(node.argument);
	  } else if (node.type === "Identifier") {
	    this.checkDuplicateExports(node, node.name);
	  }
	};
	
	pp$1.checkDuplicateExports = function (node, name) {
	  if (this.state.exportedIdentifiers.indexOf(name) > -1) {
	    this.raiseDuplicateExportError(node, name);
	  }
	  this.state.exportedIdentifiers.push(name);
	};
	
	pp$1.raiseDuplicateExportError = function (node, name) {
	  this.raise(node.start, name === "default" ? "Only one default export allowed per module." : "`" + name + "` has already been exported. Exported identifiers must be unique.");
	};
	
	// Parses a comma-separated list of module exports.
	
	pp$1.parseExportSpecifiers = function () {
	  var nodes = [];
	  var first = true;
	  var needsFrom = void 0;
	
	  // export { x, y as z } [from '...']
	  this.expect(types.braceL);
	
	  while (!this.eat(types.braceR)) {
	    if (first) {
	      first = false;
	    } else {
	      this.expect(types.comma);
	      if (this.eat(types.braceR)) break;
	    }
	
	    var isDefault = this.match(types._default);
	    if (isDefault && !needsFrom) needsFrom = true;
	
	    var node = this.startNode();
	    node.local = this.parseIdentifier(isDefault);
	    node.exported = this.eatContextual("as") ? this.parseIdentifier(true) : node.local.__clone();
	    nodes.push(this.finishNode(node, "ExportSpecifier"));
	  }
	
	  // https://github.com/ember-cli/ember-cli/pull/3739
	  if (needsFrom && !this.isContextual("from")) {
	    this.unexpected();
	  }
	
	  return nodes;
	};
	
	// Parses import declaration.
	
	pp$1.parseImport = function (node) {
	  this.eat(types._import);
	
	  // import '...'
	  if (this.match(types.string)) {
	    node.specifiers = [];
	    node.source = this.parseExprAtom();
	  } else {
	    node.specifiers = [];
	    this.parseImportSpecifiers(node);
	    this.expectContextual("from");
	    node.source = this.match(types.string) ? this.parseExprAtom() : this.unexpected();
	  }
	  this.semicolon();
	  return this.finishNode(node, "ImportDeclaration");
	};
	
	// Parses a comma-separated list of module imports.
	
	pp$1.parseImportSpecifiers = function (node) {
	  var first = true;
	  if (this.match(types.name)) {
	    // import defaultObj, { x, y as z } from '...'
	    var startPos = this.state.start;
	    var startLoc = this.state.startLoc;
	    node.specifiers.push(this.parseImportSpecifierDefault(this.parseIdentifier(), startPos, startLoc));
	    if (!this.eat(types.comma)) return;
	  }
	
	  if (this.match(types.star)) {
	    var specifier = this.startNode();
	    this.next();
	    this.expectContextual("as");
	    specifier.local = this.parseIdentifier();
	    this.checkLVal(specifier.local, true, undefined, "import namespace specifier");
	    node.specifiers.push(this.finishNode(specifier, "ImportNamespaceSpecifier"));
	    return;
	  }
	
	  this.expect(types.braceL);
	  while (!this.eat(types.braceR)) {
	    if (first) {
	      first = false;
	    } else {
	      // Detect an attempt to deep destructure
	      if (this.eat(types.colon)) {
	        this.unexpected(null, "ES2015 named imports do not destructure. Use another statement for destructuring after the import.");
	      }
	
	      this.expect(types.comma);
	      if (this.eat(types.braceR)) break;
	    }
	
	    this.parseImportSpecifier(node);
	  }
	};
	
	pp$1.parseImportSpecifier = function (node) {
	  var specifier = this.startNode();
	  specifier.imported = this.parseIdentifier(true);
	  if (this.eatContextual("as")) {
	    specifier.local = this.parseIdentifier();
	  } else {
	    this.checkReservedWord(specifier.imported.name, specifier.start, true, true);
	    specifier.local = specifier.imported.__clone();
	  }
	  this.checkLVal(specifier.local, true, undefined, "import specifier");
	  node.specifiers.push(this.finishNode(specifier, "ImportSpecifier"));
	};
	
	pp$1.parseImportSpecifierDefault = function (id, startPos, startLoc) {
	  var node = this.startNodeAt(startPos, startLoc);
	  node.local = id;
	  this.checkLVal(node.local, true, undefined, "default import specifier");
	  return this.finishNode(node, "ImportDefaultSpecifier");
	};
	
	var pp$2 = Parser.prototype;
	
	// Convert existing expression atom to assignable pattern
	// if possible.
	
	pp$2.toAssignable = function (node, isBinding, contextDescription) {
	  if (node) {
	    switch (node.type) {
	      case "Identifier":
	      case "ObjectPattern":
	      case "ArrayPattern":
	      case "AssignmentPattern":
	        break;
	
	      case "ObjectExpression":
	        node.type = "ObjectPattern";
	        for (var _iterator = node.properties, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	          var _ref;
	
	          if (_isArray) {
	            if (_i >= _iterator.length) break;
	            _ref = _iterator[_i++];
	          } else {
	            _i = _iterator.next();
	            if (_i.done) break;
	            _ref = _i.value;
	          }
	
	          var prop = _ref;
	
	          if (prop.type === "ObjectMethod") {
	            if (prop.kind === "get" || prop.kind === "set") {
	              this.raise(prop.key.start, "Object pattern can't contain getter or setter");
	            } else {
	              this.raise(prop.key.start, "Object pattern can't contain methods");
	            }
	          } else {
	            this.toAssignable(prop, isBinding, "object destructuring pattern");
	          }
	        }
	        break;
	
	      case "ObjectProperty":
	        this.toAssignable(node.value, isBinding, contextDescription);
	        break;
	
	      case "SpreadProperty":
	        node.type = "RestProperty";
	        var arg = node.argument;
	        this.toAssignable(arg, isBinding, contextDescription);
	        break;
	
	      case "ArrayExpression":
	        node.type = "ArrayPattern";
	        this.toAssignableList(node.elements, isBinding, contextDescription);
	        break;
	
	      case "AssignmentExpression":
	        if (node.operator === "=") {
	          node.type = "AssignmentPattern";
	          delete node.operator;
	        } else {
	          this.raise(node.left.end, "Only '=' operator can be used for specifying default value.");
	        }
	        break;
	
	      case "MemberExpression":
	        if (!isBinding) break;
	
	      default:
	        {
	          var message = "Invalid left-hand side" + (contextDescription ? " in " + contextDescription : /* istanbul ignore next */"expression");
	          this.raise(node.start, message);
	        }
	    }
	  }
	  return node;
	};
	
	// Convert list of expression atoms to binding list.
	
	pp$2.toAssignableList = function (exprList, isBinding, contextDescription) {
	  var end = exprList.length;
	  if (end) {
	    var last = exprList[end - 1];
	    if (last && last.type === "RestElement") {
	      --end;
	    } else if (last && last.type === "SpreadElement") {
	      last.type = "RestElement";
	      var arg = last.argument;
	      this.toAssignable(arg, isBinding, contextDescription);
	      if (arg.type !== "Identifier" && arg.type !== "MemberExpression" && arg.type !== "ArrayPattern") {
	        this.unexpected(arg.start);
	      }
	      --end;
	    }
	  }
	  for (var i = 0; i < end; i++) {
	    var elt = exprList[i];
	    if (elt) this.toAssignable(elt, isBinding, contextDescription);
	  }
	  return exprList;
	};
	
	// Convert list of expression atoms to a list of
	
	pp$2.toReferencedList = function (exprList) {
	  return exprList;
	};
	
	// Parses spread element.
	
	pp$2.parseSpread = function (refShorthandDefaultPos) {
	  var node = this.startNode();
	  this.next();
	  node.argument = this.parseMaybeAssign(false, refShorthandDefaultPos);
	  return this.finishNode(node, "SpreadElement");
	};
	
	pp$2.parseRest = function () {
	  var node = this.startNode();
	  this.next();
	  node.argument = this.parseBindingIdentifier();
	  return this.finishNode(node, "RestElement");
	};
	
	pp$2.shouldAllowYieldIdentifier = function () {
	  return this.match(types._yield) && !this.state.strict && !this.state.inGenerator;
	};
	
	pp$2.parseBindingIdentifier = function () {
	  return this.parseIdentifier(this.shouldAllowYieldIdentifier());
	};
	
	// Parses lvalue (assignable) atom.
	
	pp$2.parseBindingAtom = function () {
	  switch (this.state.type) {
	    case types._yield:
	      if (this.state.strict || this.state.inGenerator) this.unexpected();
	    // fall-through
	    case types.name:
	      return this.parseIdentifier(true);
	
	    case types.bracketL:
	      var node = this.startNode();
	      this.next();
	      node.elements = this.parseBindingList(types.bracketR, true);
	      return this.finishNode(node, "ArrayPattern");
	
	    case types.braceL:
	      return this.parseObj(true);
	
	    default:
	      this.unexpected();
	  }
	};
	
	pp$2.parseBindingList = function (close, allowEmpty) {
	  var elts = [];
	  var first = true;
	  while (!this.eat(close)) {
	    if (first) {
	      first = false;
	    } else {
	      this.expect(types.comma);
	    }
	    if (allowEmpty && this.match(types.comma)) {
	      elts.push(null);
	    } else if (this.eat(close)) {
	      break;
	    } else if (this.match(types.ellipsis)) {
	      elts.push(this.parseAssignableListItemTypes(this.parseRest()));
	      this.expect(close);
	      break;
	    } else {
	      var decorators = [];
	      while (this.match(types.at)) {
	        decorators.push(this.parseDecorator());
	      }
	      var left = this.parseMaybeDefault();
	      if (decorators.length) {
	        left.decorators = decorators;
	      }
	      this.parseAssignableListItemTypes(left);
	      elts.push(this.parseMaybeDefault(left.start, left.loc.start, left));
	    }
	  }
	  return elts;
	};
	
	pp$2.parseAssignableListItemTypes = function (param) {
	  return param;
	};
	
	// Parses assignment pattern around given atom if possible.
	
	pp$2.parseMaybeDefault = function (startPos, startLoc, left) {
	  startLoc = startLoc || this.state.startLoc;
	  startPos = startPos || this.state.start;
	  left = left || this.parseBindingAtom();
	  if (!this.eat(types.eq)) return left;
	
	  var node = this.startNodeAt(startPos, startLoc);
	  node.left = left;
	  node.right = this.parseMaybeAssign();
	  return this.finishNode(node, "AssignmentPattern");
	};
	
	// Verify that a node is an lval — something that can be assigned
	// to.
	
	pp$2.checkLVal = function (expr, isBinding, checkClashes, contextDescription) {
	  switch (expr.type) {
	    case "Identifier":
	      this.checkReservedWord(expr.name, expr.start, false, true);
	
	      if (checkClashes) {
	        // we need to prefix this with an underscore for the cases where we have a key of
	        // `__proto__`. there's a bug in old V8 where the following wouldn't work:
	        //
	        //   > var obj = Object.create(null);
	        //   undefined
	        //   > obj.__proto__
	        //   null
	        //   > obj.__proto__ = true;
	        //   true
	        //   > obj.__proto__
	        //   null
	        var key = "_" + expr.name;
	
	        if (checkClashes[key]) {
	          this.raise(expr.start, "Argument name clash in strict mode");
	        } else {
	          checkClashes[key] = true;
	        }
	      }
	      break;
	
	    case "MemberExpression":
	      if (isBinding) this.raise(expr.start, (isBinding ? "Binding" : "Assigning to") + " member expression");
	      break;
	
	    case "ObjectPattern":
	      for (var _iterator2 = expr.properties, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	        var _ref2;
	
	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }
	
	        var prop = _ref2;
	
	        if (prop.type === "ObjectProperty") prop = prop.value;
	        this.checkLVal(prop, isBinding, checkClashes, "object destructuring pattern");
	      }
	      break;
	
	    case "ArrayPattern":
	      for (var _iterator3 = expr.elements, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	        var _ref3;
	
	        if (_isArray3) {
	          if (_i3 >= _iterator3.length) break;
	          _ref3 = _iterator3[_i3++];
	        } else {
	          _i3 = _iterator3.next();
	          if (_i3.done) break;
	          _ref3 = _i3.value;
	        }
	
	        var elem = _ref3;
	
	        if (elem) this.checkLVal(elem, isBinding, checkClashes, "array destructuring pattern");
	      }
	      break;
	
	    case "AssignmentPattern":
	      this.checkLVal(expr.left, isBinding, checkClashes, "assignment pattern");
	      break;
	
	    case "RestProperty":
	      this.checkLVal(expr.argument, isBinding, checkClashes, "rest property");
	      break;
	
	    case "RestElement":
	      this.checkLVal(expr.argument, isBinding, checkClashes, "rest element");
	      break;
	
	    default:
	      {
	        var message = (isBinding ? /* istanbul ignore next */"Binding invalid" : "Invalid") + " left-hand side" + (contextDescription ? " in " + contextDescription : /* istanbul ignore next */"expression");
	        this.raise(expr.start, message);
	      }
	  }
	};
	
	/* eslint max-len: 0 */
	
	// A recursive descent parser operates by defining functions for all
	// syntactic elements, and recursively calling those, each function
	// advancing the input stream and returning an AST node. Precedence
	// of constructs (for example, the fact that `!x[1]` means `!(x[1])`
	// instead of `(!x)[1]` is handled by the fact that the parser
	// function that parses unary prefix operators is called first, and
	// in turn calls the function that parses `[]` subscripts — that
	// way, it'll receive the node for `x[1]` already parsed, and wraps
	// *that* in the unary operator node.
	//
	// Acorn uses an [operator precedence parser][opp] to handle binary
	// operator precedence, because it is much more compact than using
	// the technique outlined above, which uses different, nesting
	// functions to specify precedence, for all of the ten binary
	// precedence levels that JavaScript defines.
	//
	// [opp]: http://en.wikipedia.org/wiki/Operator-precedence_parser
	
	var pp$3 = Parser.prototype;
	
	// Check if property name clashes with already added.
	// Object/class getters and setters are not allowed to clash —
	// either with each other or with an init property — and in
	// strict mode, init properties are also not allowed to be repeated.
	
	pp$3.checkPropClash = function (prop, propHash) {
	  if (prop.computed || prop.kind) return;
	
	  var key = prop.key;
	  // It is either an Identifier or a String/NumericLiteral
	  var name = key.type === "Identifier" ? key.name : String(key.value);
	
	  if (name === "__proto__") {
	    if (propHash.proto) this.raise(key.start, "Redefinition of __proto__ property");
	    propHash.proto = true;
	  }
	};
	
	// Convenience method to parse an Expression only
	pp$3.getExpression = function () {
	  this.nextToken();
	  var expr = this.parseExpression();
	  if (!this.match(types.eof)) {
	    this.unexpected();
	  }
	  return expr;
	};
	
	// ### Expression parsing
	
	// These nest, from the most general expression type at the top to
	// 'atomic', nondivisible expression types at the bottom. Most of
	// the functions will simply let the function (s) below them parse,
	// and, *if* the syntactic construct they handle is present, wrap
	// the AST node that the inner parser gave them in another node.
	
	// Parse a full expression. The optional arguments are used to
	// forbid the `in` operator (in for loops initialization expressions)
	// and provide reference for storing '=' operator inside shorthand
	// property assignment in contexts where both object expression
	// and object pattern might appear (so it's possible to raise
	// delayed syntax error at correct position).
	
	pp$3.parseExpression = function (noIn, refShorthandDefaultPos) {
	  var startPos = this.state.start;
	  var startLoc = this.state.startLoc;
	  var expr = this.parseMaybeAssign(noIn, refShorthandDefaultPos);
	  if (this.match(types.comma)) {
	    var node = this.startNodeAt(startPos, startLoc);
	    node.expressions = [expr];
	    while (this.eat(types.comma)) {
	      node.expressions.push(this.parseMaybeAssign(noIn, refShorthandDefaultPos));
	    }
	    this.toReferencedList(node.expressions);
	    return this.finishNode(node, "SequenceExpression");
	  }
	  return expr;
	};
	
	// Parse an assignment expression. This includes applications of
	// operators like `+=`.
	
	pp$3.parseMaybeAssign = function (noIn, refShorthandDefaultPos, afterLeftParse, refNeedsArrowPos) {
	  var startPos = this.state.start;
	  var startLoc = this.state.startLoc;
	
	  if (this.match(types._yield) && this.state.inGenerator) {
	    var _left = this.parseYield();
	    if (afterLeftParse) _left = afterLeftParse.call(this, _left, startPos, startLoc);
	    return _left;
	  }
	
	  var failOnShorthandAssign = void 0;
	  if (refShorthandDefaultPos) {
	    failOnShorthandAssign = false;
	  } else {
	    refShorthandDefaultPos = { start: 0 };
	    failOnShorthandAssign = true;
	  }
	
	  if (this.match(types.parenL) || this.match(types.name)) {
	    this.state.potentialArrowAt = this.state.start;
	  }
	
	  var left = this.parseMaybeConditional(noIn, refShorthandDefaultPos, refNeedsArrowPos);
	  if (afterLeftParse) left = afterLeftParse.call(this, left, startPos, startLoc);
	  if (this.state.type.isAssign) {
	    var node = this.startNodeAt(startPos, startLoc);
	    node.operator = this.state.value;
	    node.left = this.match(types.eq) ? this.toAssignable(left, undefined, "assignment expression") : left;
	    refShorthandDefaultPos.start = 0; // reset because shorthand default was used correctly
	
	    this.checkLVal(left, undefined, undefined, "assignment expression");
	
	    if (left.extra && left.extra.parenthesized) {
	      var errorMsg = void 0;
	      if (left.type === "ObjectPattern") {
	        errorMsg = "`({a}) = 0` use `({a} = 0)`";
	      } else if (left.type === "ArrayPattern") {
	        errorMsg = "`([a]) = 0` use `([a] = 0)`";
	      }
	      if (errorMsg) {
	        this.raise(left.start, "You're trying to assign to a parenthesized expression, eg. instead of " + errorMsg);
	      }
	    }
	
	    this.next();
	    node.right = this.parseMaybeAssign(noIn);
	    return this.finishNode(node, "AssignmentExpression");
	  } else if (failOnShorthandAssign && refShorthandDefaultPos.start) {
	    this.unexpected(refShorthandDefaultPos.start);
	  }
	
	  return left;
	};
	
	// Parse a ternary conditional (`?:`) operator.
	
	pp$3.parseMaybeConditional = function (noIn, refShorthandDefaultPos, refNeedsArrowPos) {
	  var startPos = this.state.start;
	  var startLoc = this.state.startLoc;
	  var expr = this.parseExprOps(noIn, refShorthandDefaultPos);
	  if (refShorthandDefaultPos && refShorthandDefaultPos.start) return expr;
	
	  return this.parseConditional(expr, noIn, startPos, startLoc, refNeedsArrowPos);
	};
	
	pp$3.parseConditional = function (expr, noIn, startPos, startLoc) {
	  if (this.eat(types.question)) {
	    var node = this.startNodeAt(startPos, startLoc);
	    node.test = expr;
	    node.consequent = this.parseMaybeAssign();
	    this.expect(types.colon);
	    node.alternate = this.parseMaybeAssign(noIn);
	    return this.finishNode(node, "ConditionalExpression");
	  }
	  return expr;
	};
	
	// Start the precedence parser.
	
	pp$3.parseExprOps = function (noIn, refShorthandDefaultPos) {
	  var startPos = this.state.start;
	  var startLoc = this.state.startLoc;
	  var expr = this.parseMaybeUnary(refShorthandDefaultPos);
	  if (refShorthandDefaultPos && refShorthandDefaultPos.start) {
	    return expr;
	  } else {
	    return this.parseExprOp(expr, startPos, startLoc, -1, noIn);
	  }
	};
	
	// Parse binary operators with the operator precedence parsing
	// algorithm. `left` is the left-hand side of the operator.
	// `minPrec` provides context that allows the function to stop and
	// defer further parser to one of its callers when it encounters an
	// operator that has a lower precedence than the set it is parsing.
	
	pp$3.parseExprOp = function (left, leftStartPos, leftStartLoc, minPrec, noIn) {
	  var prec = this.state.type.binop;
	  if (prec != null && (!noIn || !this.match(types._in))) {
	    if (prec > minPrec) {
	      var node = this.startNodeAt(leftStartPos, leftStartLoc);
	      node.left = left;
	      node.operator = this.state.value;
	
	      if (node.operator === "**" && left.type === "UnaryExpression" && left.extra && !left.extra.parenthesizedArgument && !left.extra.parenthesized) {
	        this.raise(left.argument.start, "Illegal expression. Wrap left hand side or entire exponentiation in parentheses.");
	      }
	
	      var op = this.state.type;
	      this.next();
	
	      var startPos = this.state.start;
	      var startLoc = this.state.startLoc;
	      node.right = this.parseExprOp(this.parseMaybeUnary(), startPos, startLoc, op.rightAssociative ? prec - 1 : prec, noIn);
	
	      this.finishNode(node, op === types.logicalOR || op === types.logicalAND ? "LogicalExpression" : "BinaryExpression");
	      return this.parseExprOp(node, leftStartPos, leftStartLoc, minPrec, noIn);
	    }
	  }
	  return left;
	};
	
	// Parse unary operators, both prefix and postfix.
	
	pp$3.parseMaybeUnary = function (refShorthandDefaultPos) {
	  if (this.state.type.prefix) {
	    var node = this.startNode();
	    var update = this.match(types.incDec);
	    node.operator = this.state.value;
	    node.prefix = true;
	    this.next();
	
	    var argType = this.state.type;
	    node.argument = this.parseMaybeUnary();
	
	    this.addExtra(node, "parenthesizedArgument", argType === types.parenL && (!node.argument.extra || !node.argument.extra.parenthesized));
	
	    if (refShorthandDefaultPos && refShorthandDefaultPos.start) {
	      this.unexpected(refShorthandDefaultPos.start);
	    }
	
	    if (update) {
	      this.checkLVal(node.argument, undefined, undefined, "prefix operation");
	    } else if (this.state.strict && node.operator === "delete" && node.argument.type === "Identifier") {
	      this.raise(node.start, "Deleting local variable in strict mode");
	    }
	
	    return this.finishNode(node, update ? "UpdateExpression" : "UnaryExpression");
	  }
	
	  var startPos = this.state.start;
	  var startLoc = this.state.startLoc;
	  var expr = this.parseExprSubscripts(refShorthandDefaultPos);
	  if (refShorthandDefaultPos && refShorthandDefaultPos.start) return expr;
	  while (this.state.type.postfix && !this.canInsertSemicolon()) {
	    var _node = this.startNodeAt(startPos, startLoc);
	    _node.operator = this.state.value;
	    _node.prefix = false;
	    _node.argument = expr;
	    this.checkLVal(expr, undefined, undefined, "postfix operation");
	    this.next();
	    expr = this.finishNode(_node, "UpdateExpression");
	  }
	  return expr;
	};
	
	// Parse call, dot, and `[]`-subscript expressions.
	
	pp$3.parseExprSubscripts = function (refShorthandDefaultPos) {
	  var startPos = this.state.start;
	  var startLoc = this.state.startLoc;
	  var potentialArrowAt = this.state.potentialArrowAt;
	  var expr = this.parseExprAtom(refShorthandDefaultPos);
	
	  if (expr.type === "ArrowFunctionExpression" && expr.start === potentialArrowAt) {
	    return expr;
	  }
	
	  if (refShorthandDefaultPos && refShorthandDefaultPos.start) {
	    return expr;
	  }
	
	  return this.parseSubscripts(expr, startPos, startLoc);
	};
	
	pp$3.parseSubscripts = function (base, startPos, startLoc, noCalls) {
	  for (;;) {
	    if (!noCalls && this.eat(types.doubleColon)) {
	      var node = this.startNodeAt(startPos, startLoc);
	      node.object = base;
	      node.callee = this.parseNoCallExpr();
	      return this.parseSubscripts(this.finishNode(node, "BindExpression"), startPos, startLoc, noCalls);
	    } else if (this.eat(types.dot)) {
	      var _node2 = this.startNodeAt(startPos, startLoc);
	      _node2.object = base;
	      _node2.property = this.parseIdentifier(true);
	      _node2.computed = false;
	      base = this.finishNode(_node2, "MemberExpression");
	    } else if (this.eat(types.bracketL)) {
	      var _node3 = this.startNodeAt(startPos, startLoc);
	      _node3.object = base;
	      _node3.property = this.parseExpression();
	      _node3.computed = true;
	      this.expect(types.bracketR);
	      base = this.finishNode(_node3, "MemberExpression");
	    } else if (!noCalls && this.match(types.parenL)) {
	      var possibleAsync = this.state.potentialArrowAt === base.start && base.type === "Identifier" && base.name === "async" && !this.canInsertSemicolon();
	      this.next();
	
	      var _node4 = this.startNodeAt(startPos, startLoc);
	      _node4.callee = base;
	      _node4.arguments = this.parseCallExpressionArguments(types.parenR, possibleAsync);
	      if (_node4.callee.type === "Import" && _node4.arguments.length !== 1) {
	        this.raise(_node4.start, "import() requires exactly one argument");
	      }
	      base = this.finishNode(_node4, "CallExpression");
	
	      if (possibleAsync && this.shouldParseAsyncArrow()) {
	        return this.parseAsyncArrowFromCallExpression(this.startNodeAt(startPos, startLoc), _node4);
	      } else {
	        this.toReferencedList(_node4.arguments);
	      }
	    } else if (this.match(types.backQuote)) {
	      var _node5 = this.startNodeAt(startPos, startLoc);
	      _node5.tag = base;
	      _node5.quasi = this.parseTemplate(true);
	      base = this.finishNode(_node5, "TaggedTemplateExpression");
	    } else {
	      return base;
	    }
	  }
	};
	
	pp$3.parseCallExpressionArguments = function (close, possibleAsyncArrow) {
	  var elts = [];
	  var innerParenStart = void 0;
	  var first = true;
	
	  while (!this.eat(close)) {
	    if (first) {
	      first = false;
	    } else {
	      this.expect(types.comma);
	      if (this.eat(close)) break;
	    }
	
	    // we need to make sure that if this is an async arrow functions, that we don't allow inner parens inside the params
	    if (this.match(types.parenL) && !innerParenStart) {
	      innerParenStart = this.state.start;
	    }
	
	    elts.push(this.parseExprListItem(false, possibleAsyncArrow ? { start: 0 } : undefined, possibleAsyncArrow ? { start: 0 } : undefined));
	  }
	
	  // we found an async arrow function so let's not allow any inner parens
	  if (possibleAsyncArrow && innerParenStart && this.shouldParseAsyncArrow()) {
	    this.unexpected();
	  }
	
	  return elts;
	};
	
	pp$3.shouldParseAsyncArrow = function () {
	  return this.match(types.arrow);
	};
	
	pp$3.parseAsyncArrowFromCallExpression = function (node, call) {
	  this.expect(types.arrow);
	  return this.parseArrowExpression(node, call.arguments, true);
	};
	
	// Parse a no-call expression (like argument of `new` or `::` operators).
	
	pp$3.parseNoCallExpr = function () {
	  var startPos = this.state.start;
	  var startLoc = this.state.startLoc;
	  return this.parseSubscripts(this.parseExprAtom(), startPos, startLoc, true);
	};
	
	// Parse an atomic expression — either a single token that is an
	// expression, an expression started by a keyword like `function` or
	// `new`, or an expression wrapped in punctuation like `()`, `[]`,
	// or `{}`.
	
	pp$3.parseExprAtom = function (refShorthandDefaultPos) {
	  var canBeArrow = this.state.potentialArrowAt === this.state.start;
	  var node = void 0;
	
	  switch (this.state.type) {
	    case types._super:
	      if (!this.state.inMethod && !this.state.inClassProperty && !this.options.allowSuperOutsideMethod) {
	        this.raise(this.state.start, "'super' outside of function or class");
	      }
	
	      node = this.startNode();
	      this.next();
	      if (!this.match(types.parenL) && !this.match(types.bracketL) && !this.match(types.dot)) {
	        this.unexpected();
	      }
	      if (this.match(types.parenL) && this.state.inMethod !== "constructor" && !this.options.allowSuperOutsideMethod) {
	        this.raise(node.start, "super() outside of class constructor");
	      }
	      return this.finishNode(node, "Super");
	
	    case types._import:
	      if (!this.hasPlugin("dynamicImport")) this.unexpected();
	
	      node = this.startNode();
	      this.next();
	      if (!this.match(types.parenL)) {
	        this.unexpected(null, types.parenL);
	      }
	      return this.finishNode(node, "Import");
	
	    case types._this:
	      node = this.startNode();
	      this.next();
	      return this.finishNode(node, "ThisExpression");
	
	    case types._yield:
	      if (this.state.inGenerator) this.unexpected();
	
	    case types.name:
	      node = this.startNode();
	      var allowAwait = this.state.value === "await" && this.state.inAsync;
	      var allowYield = this.shouldAllowYieldIdentifier();
	      var id = this.parseIdentifier(allowAwait || allowYield);
	
	      if (id.name === "await") {
	        if (this.state.inAsync || this.inModule) {
	          return this.parseAwait(node);
	        }
	      } else if (id.name === "async" && this.match(types._function) && !this.canInsertSemicolon()) {
	        this.next();
	        return this.parseFunction(node, false, false, true);
	      } else if (canBeArrow && id.name === "async" && this.match(types.name)) {
	        var params = [this.parseIdentifier()];
	        this.expect(types.arrow);
	        // let foo = bar => {};
	        return this.parseArrowExpression(node, params, true);
	      }
	
	      if (canBeArrow && !this.canInsertSemicolon() && this.eat(types.arrow)) {
	        return this.parseArrowExpression(node, [id]);
	      }
	
	      return id;
	
	    case types._do:
	      if (this.hasPlugin("doExpressions")) {
	        var _node6 = this.startNode();
	        this.next();
	        var oldInFunction = this.state.inFunction;
	        var oldLabels = this.state.labels;
	        this.state.labels = [];
	        this.state.inFunction = false;
	        _node6.body = this.parseBlock(false, true);
	        this.state.inFunction = oldInFunction;
	        this.state.labels = oldLabels;
	        return this.finishNode(_node6, "DoExpression");
	      }
	
	    case types.regexp:
	      var value = this.state.value;
	      node = this.parseLiteral(value.value, "RegExpLiteral");
	      node.pattern = value.pattern;
	      node.flags = value.flags;
	      return node;
	
	    case types.num:
	      return this.parseLiteral(this.state.value, "NumericLiteral");
	
	    case types.string:
	      return this.parseLiteral(this.state.value, "StringLiteral");
	
	    case types._null:
	      node = this.startNode();
	      this.next();
	      return this.finishNode(node, "NullLiteral");
	
	    case types._true:case types._false:
	      node = this.startNode();
	      node.value = this.match(types._true);
	      this.next();
	      return this.finishNode(node, "BooleanLiteral");
	
	    case types.parenL:
	      return this.parseParenAndDistinguishExpression(null, null, canBeArrow);
	
	    case types.bracketL:
	      node = this.startNode();
	      this.next();
	      node.elements = this.parseExprList(types.bracketR, true, refShorthandDefaultPos);
	      this.toReferencedList(node.elements);
	      return this.finishNode(node, "ArrayExpression");
	
	    case types.braceL:
	      return this.parseObj(false, refShorthandDefaultPos);
	
	    case types._function:
	      return this.parseFunctionExpression();
	
	    case types.at:
	      this.parseDecorators();
	
	    case types._class:
	      node = this.startNode();
	      this.takeDecorators(node);
	      return this.parseClass(node, false);
	
	    case types._new:
	      return this.parseNew();
	
	    case types.backQuote:
	      return this.parseTemplate(false);
	
	    case types.doubleColon:
	      node = this.startNode();
	      this.next();
	      node.object = null;
	      var callee = node.callee = this.parseNoCallExpr();
	      if (callee.type === "MemberExpression") {
	        return this.finishNode(node, "BindExpression");
	      } else {
	        this.raise(callee.start, "Binding should be performed on object property.");
	      }
	
	    default:
	      this.unexpected();
	  }
	};
	
	pp$3.parseFunctionExpression = function () {
	  var node = this.startNode();
	  var meta = this.parseIdentifier(true);
	  if (this.state.inGenerator && this.eat(types.dot) && this.hasPlugin("functionSent")) {
	    return this.parseMetaProperty(node, meta, "sent");
	  } else {
	    return this.parseFunction(node, false);
	  }
	};
	
	pp$3.parseMetaProperty = function (node, meta, propertyName) {
	  node.meta = meta;
	  node.property = this.parseIdentifier(true);
	
	  if (node.property.name !== propertyName) {
	    this.raise(node.property.start, "The only valid meta property for new is " + meta.name + "." + propertyName);
	  }
	
	  return this.finishNode(node, "MetaProperty");
	};
	
	pp$3.parseLiteral = function (value, type, startPos, startLoc) {
	  startPos = startPos || this.state.start;
	  startLoc = startLoc || this.state.startLoc;
	
	  var node = this.startNodeAt(startPos, startLoc);
	  this.addExtra(node, "rawValue", value);
	  this.addExtra(node, "raw", this.input.slice(startPos, this.state.end));
	  node.value = value;
	  this.next();
	  return this.finishNode(node, type);
	};
	
	pp$3.parseParenExpression = function () {
	  this.expect(types.parenL);
	  var val = this.parseExpression();
	  this.expect(types.parenR);
	  return val;
	};
	
	pp$3.parseParenAndDistinguishExpression = function (startPos, startLoc, canBeArrow) {
	  startPos = startPos || this.state.start;
	  startLoc = startLoc || this.state.startLoc;
	
	  var val = void 0;
	  this.expect(types.parenL);
	
	  var innerStartPos = this.state.start;
	  var innerStartLoc = this.state.startLoc;
	  var exprList = [];
	  var refShorthandDefaultPos = { start: 0 };
	  var refNeedsArrowPos = { start: 0 };
	  var first = true;
	  var spreadStart = void 0;
	  var optionalCommaStart = void 0;
	
	  while (!this.match(types.parenR)) {
	    if (first) {
	      first = false;
	    } else {
	      this.expect(types.comma, refNeedsArrowPos.start || null);
	      if (this.match(types.parenR)) {
	        optionalCommaStart = this.state.start;
	        break;
	      }
	    }
	
	    if (this.match(types.ellipsis)) {
	      var spreadNodeStartPos = this.state.start;
	      var spreadNodeStartLoc = this.state.startLoc;
	      spreadStart = this.state.start;
	      exprList.push(this.parseParenItem(this.parseRest(), spreadNodeStartPos, spreadNodeStartLoc));
	      break;
	    } else {
	      exprList.push(this.parseMaybeAssign(false, refShorthandDefaultPos, this.parseParenItem, refNeedsArrowPos));
	    }
	  }
	
	  var innerEndPos = this.state.start;
	  var innerEndLoc = this.state.startLoc;
	  this.expect(types.parenR);
	
	  var arrowNode = this.startNodeAt(startPos, startLoc);
	  if (canBeArrow && this.shouldParseArrow() && (arrowNode = this.parseArrow(arrowNode))) {
	    for (var _iterator = exprList, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var param = _ref;
	
	      if (param.extra && param.extra.parenthesized) this.unexpected(param.extra.parenStart);
	    }
	
	    return this.parseArrowExpression(arrowNode, exprList);
	  }
	
	  if (!exprList.length) {
	    this.unexpected(this.state.lastTokStart);
	  }
	  if (optionalCommaStart) this.unexpected(optionalCommaStart);
	  if (spreadStart) this.unexpected(spreadStart);
	  if (refShorthandDefaultPos.start) this.unexpected(refShorthandDefaultPos.start);
	  if (refNeedsArrowPos.start) this.unexpected(refNeedsArrowPos.start);
	
	  if (exprList.length > 1) {
	    val = this.startNodeAt(innerStartPos, innerStartLoc);
	    val.expressions = exprList;
	    this.toReferencedList(val.expressions);
	    this.finishNodeAt(val, "SequenceExpression", innerEndPos, innerEndLoc);
	  } else {
	    val = exprList[0];
	  }
	
	  this.addExtra(val, "parenthesized", true);
	  this.addExtra(val, "parenStart", startPos);
	
	  return val;
	};
	
	pp$3.shouldParseArrow = function () {
	  return !this.canInsertSemicolon();
	};
	
	pp$3.parseArrow = function (node) {
	  if (this.eat(types.arrow)) {
	    return node;
	  }
	};
	
	pp$3.parseParenItem = function (node) {
	  return node;
	};
	
	// New's precedence is slightly tricky. It must allow its argument
	// to be a `[]` or dot subscript expression, but not a call — at
	// least, not without wrapping it in parentheses. Thus, it uses the
	
	pp$3.parseNew = function () {
	  var node = this.startNode();
	  var meta = this.parseIdentifier(true);
	
	  if (this.eat(types.dot)) {
	    var metaProp = this.parseMetaProperty(node, meta, "target");
	
	    if (!this.state.inFunction) {
	      this.raise(metaProp.property.start, "new.target can only be used in functions");
	    }
	
	    return metaProp;
	  }
	
	  node.callee = this.parseNoCallExpr();
	
	  if (this.eat(types.parenL)) {
	    node.arguments = this.parseExprList(types.parenR);
	    this.toReferencedList(node.arguments);
	  } else {
	    node.arguments = [];
	  }
	
	  return this.finishNode(node, "NewExpression");
	};
	
	// Parse template expression.
	
	pp$3.parseTemplateElement = function (isTagged) {
	  var elem = this.startNode();
	  if (this.state.value === null) {
	    if (!isTagged || !this.hasPlugin("templateInvalidEscapes")) {
	      this.raise(this.state.invalidTemplateEscapePosition, "Invalid escape sequence in template");
	    } else {
	      this.state.invalidTemplateEscapePosition = null;
	    }
	  }
	  elem.value = {
	    raw: this.input.slice(this.state.start, this.state.end).replace(/\r\n?/g, "\n"),
	    cooked: this.state.value
	  };
	  this.next();
	  elem.tail = this.match(types.backQuote);
	  return this.finishNode(elem, "TemplateElement");
	};
	
	pp$3.parseTemplate = function (isTagged) {
	  var node = this.startNode();
	  this.next();
	  node.expressions = [];
	  var curElt = this.parseTemplateElement(isTagged);
	  node.quasis = [curElt];
	  while (!curElt.tail) {
	    this.expect(types.dollarBraceL);
	    node.expressions.push(this.parseExpression());
	    this.expect(types.braceR);
	    node.quasis.push(curElt = this.parseTemplateElement(isTagged));
	  }
	  this.next();
	  return this.finishNode(node, "TemplateLiteral");
	};
	
	// Parse an object literal or binding pattern.
	
	pp$3.parseObj = function (isPattern, refShorthandDefaultPos) {
	  var decorators = [];
	  var propHash = Object.create(null);
	  var first = true;
	  var node = this.startNode();
	
	  node.properties = [];
	  this.next();
	
	  var firstRestLocation = null;
	
	  while (!this.eat(types.braceR)) {
	    if (first) {
	      first = false;
	    } else {
	      this.expect(types.comma);
	      if (this.eat(types.braceR)) break;
	    }
	
	    while (this.match(types.at)) {
	      decorators.push(this.parseDecorator());
	    }
	
	    var prop = this.startNode(),
	        isGenerator = false,
	        isAsync = false,
	        startPos = void 0,
	        startLoc = void 0;
	    if (decorators.length) {
	      prop.decorators = decorators;
	      decorators = [];
	    }
	
	    if (this.hasPlugin("objectRestSpread") && this.match(types.ellipsis)) {
	      prop = this.parseSpread(isPattern ? { start: 0 } : undefined);
	      prop.type = isPattern ? "RestProperty" : "SpreadProperty";
	      if (isPattern) this.toAssignable(prop.argument, true, "object pattern");
	      node.properties.push(prop);
	      if (isPattern) {
	        var position = this.state.start;
	        if (firstRestLocation !== null) {
	          this.unexpected(firstRestLocation, "Cannot have multiple rest elements when destructuring");
	        } else if (this.eat(types.braceR)) {
	          break;
	        } else if (this.match(types.comma) && this.lookahead().type === types.braceR) {
	          // TODO: temporary rollback
	          // this.unexpected(position, "A trailing comma is not permitted after the rest element");
	          continue;
	        } else {
	          firstRestLocation = position;
	          continue;
	        }
	      } else {
	        continue;
	      }
	    }
	
	    prop.method = false;
	    prop.shorthand = false;
	
	    if (isPattern || refShorthandDefaultPos) {
	      startPos = this.state.start;
	      startLoc = this.state.startLoc;
	    }
	
	    if (!isPattern) {
	      isGenerator = this.eat(types.star);
	    }
	
	    if (!isPattern && this.isContextual("async")) {
	      if (isGenerator) this.unexpected();
	
	      var asyncId = this.parseIdentifier();
	      if (this.match(types.colon) || this.match(types.parenL) || this.match(types.braceR) || this.match(types.eq) || this.match(types.comma)) {
	        prop.key = asyncId;
	        prop.computed = false;
	      } else {
	        isAsync = true;
	        if (this.hasPlugin("asyncGenerators")) isGenerator = this.eat(types.star);
	        this.parsePropertyName(prop);
	      }
	    } else {
	      this.parsePropertyName(prop);
	    }
	
	    this.parseObjPropValue(prop, startPos, startLoc, isGenerator, isAsync, isPattern, refShorthandDefaultPos);
	    this.checkPropClash(prop, propHash);
	
	    if (prop.shorthand) {
	      this.addExtra(prop, "shorthand", true);
	    }
	
	    node.properties.push(prop);
	  }
	
	  if (firstRestLocation !== null) {
	    this.unexpected(firstRestLocation, "The rest element has to be the last element when destructuring");
	  }
	
	  if (decorators.length) {
	    this.raise(this.state.start, "You have trailing decorators with no property");
	  }
	
	  return this.finishNode(node, isPattern ? "ObjectPattern" : "ObjectExpression");
	};
	
	pp$3.isGetterOrSetterMethod = function (prop, isPattern) {
	  return !isPattern && !prop.computed && prop.key.type === "Identifier" && (prop.key.name === "get" || prop.key.name === "set") && (this.match(types.string) || // get "string"() {}
	  this.match(types.num) || // get 1() {}
	  this.match(types.bracketL) || // get ["string"]() {}
	  this.match(types.name) || // get foo() {}
	  this.state.type.keyword // get debugger() {}
	  );
	};
	
	// get methods aren't allowed to have any parameters
	// set methods must have exactly 1 parameter
	pp$3.checkGetterSetterParamCount = function (method) {
	  var paramCount = method.kind === "get" ? 0 : 1;
	  if (method.params.length !== paramCount) {
	    var start = method.start;
	    if (method.kind === "get") {
	      this.raise(start, "getter should have no params");
	    } else {
	      this.raise(start, "setter should have exactly one param");
	    }
	  }
	};
	
	pp$3.parseObjectMethod = function (prop, isGenerator, isAsync, isPattern) {
	  if (isAsync || isGenerator || this.match(types.parenL)) {
	    if (isPattern) this.unexpected();
	    prop.kind = "method";
	    prop.method = true;
	    this.parseMethod(prop, isGenerator, isAsync);
	
	    return this.finishNode(prop, "ObjectMethod");
	  }
	
	  if (this.isGetterOrSetterMethod(prop, isPattern)) {
	    if (isGenerator || isAsync) this.unexpected();
	    prop.kind = prop.key.name;
	    this.parsePropertyName(prop);
	    this.parseMethod(prop);
	    this.checkGetterSetterParamCount(prop);
	
	    return this.finishNode(prop, "ObjectMethod");
	  }
	};
	
	pp$3.parseObjectProperty = function (prop, startPos, startLoc, isPattern, refShorthandDefaultPos) {
	  if (this.eat(types.colon)) {
	    prop.value = isPattern ? this.parseMaybeDefault(this.state.start, this.state.startLoc) : this.parseMaybeAssign(false, refShorthandDefaultPos);
	
	    return this.finishNode(prop, "ObjectProperty");
	  }
	
	  if (!prop.computed && prop.key.type === "Identifier") {
	    this.checkReservedWord(prop.key.name, prop.key.start, true, true);
	
	    if (isPattern) {
	      prop.value = this.parseMaybeDefault(startPos, startLoc, prop.key.__clone());
	    } else if (this.match(types.eq) && refShorthandDefaultPos) {
	      if (!refShorthandDefaultPos.start) {
	        refShorthandDefaultPos.start = this.state.start;
	      }
	      prop.value = this.parseMaybeDefault(startPos, startLoc, prop.key.__clone());
	    } else {
	      prop.value = prop.key.__clone();
	    }
	    prop.shorthand = true;
	
	    return this.finishNode(prop, "ObjectProperty");
	  }
	};
	
	pp$3.parseObjPropValue = function (prop, startPos, startLoc, isGenerator, isAsync, isPattern, refShorthandDefaultPos) {
	  var node = this.parseObjectMethod(prop, isGenerator, isAsync, isPattern) || this.parseObjectProperty(prop, startPos, startLoc, isPattern, refShorthandDefaultPos);
	
	  if (!node) this.unexpected();
	
	  return node;
	};
	
	pp$3.parsePropertyName = function (prop) {
	  if (this.eat(types.bracketL)) {
	    prop.computed = true;
	    prop.key = this.parseMaybeAssign();
	    this.expect(types.bracketR);
	  } else {
	    prop.computed = false;
	    var oldInPropertyName = this.state.inPropertyName;
	    this.state.inPropertyName = true;
	    prop.key = this.match(types.num) || this.match(types.string) ? this.parseExprAtom() : this.parseIdentifier(true);
	    this.state.inPropertyName = oldInPropertyName;
	  }
	  return prop.key;
	};
	
	// Initialize empty function node.
	
	pp$3.initFunction = function (node, isAsync) {
	  node.id = null;
	  node.generator = false;
	  node.expression = false;
	  node.async = !!isAsync;
	};
	
	// Parse object or class method.
	
	pp$3.parseMethod = function (node, isGenerator, isAsync) {
	  var oldInMethod = this.state.inMethod;
	  this.state.inMethod = node.kind || true;
	  this.initFunction(node, isAsync);
	  this.expect(types.parenL);
	  node.params = this.parseBindingList(types.parenR);
	  node.generator = !!isGenerator;
	  this.parseFunctionBody(node);
	  this.state.inMethod = oldInMethod;
	  return node;
	};
	
	// Parse arrow function expression with given parameters.
	
	pp$3.parseArrowExpression = function (node, params, isAsync) {
	  this.initFunction(node, isAsync);
	  node.params = this.toAssignableList(params, true, "arrow function parameters");
	  this.parseFunctionBody(node, true);
	  return this.finishNode(node, "ArrowFunctionExpression");
	};
	
	pp$3.isStrictBody = function (node, isExpression) {
	  if (!isExpression && node.body.directives.length) {
	    for (var _iterator2 = node.body.directives, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var directive = _ref2;
	
	      if (directive.value.value === "use strict") {
	        return true;
	      }
	    }
	  }
	
	  return false;
	};
	
	// Parse function body and check parameters.
	pp$3.parseFunctionBody = function (node, allowExpression) {
	  var isExpression = allowExpression && !this.match(types.braceL);
	
	  var oldInAsync = this.state.inAsync;
	  this.state.inAsync = node.async;
	  if (isExpression) {
	    node.body = this.parseMaybeAssign();
	    node.expression = true;
	  } else {
	    // Start a new scope with regard to labels and the `inFunction`
	    // flag (restore them to their old value afterwards).
	    var oldInFunc = this.state.inFunction;
	    var oldInGen = this.state.inGenerator;
	    var oldLabels = this.state.labels;
	    this.state.inFunction = true;this.state.inGenerator = node.generator;this.state.labels = [];
	    node.body = this.parseBlock(true);
	    node.expression = false;
	    this.state.inFunction = oldInFunc;this.state.inGenerator = oldInGen;this.state.labels = oldLabels;
	  }
	  this.state.inAsync = oldInAsync;
	
	  // If this is a strict mode function, verify that argument names
	  // are not repeated, and it does not try to bind the words `eval`
	  // or `arguments`.
	  var isStrict = this.isStrictBody(node, isExpression);
	  // Also check when allowExpression === true for arrow functions
	  var checkLVal = this.state.strict || allowExpression || isStrict;
	
	  if (isStrict && node.id && node.id.type === "Identifier" && node.id.name === "yield") {
	    this.raise(node.id.start, "Binding yield in strict mode");
	  }
	
	  if (checkLVal) {
	    var nameHash = Object.create(null);
	    var oldStrict = this.state.strict;
	    if (isStrict) this.state.strict = true;
	    if (node.id) {
	      this.checkLVal(node.id, true, undefined, "function name");
	    }
	    for (var _iterator3 = node.params, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	      var _ref3;
	
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }
	
	      var param = _ref3;
	
	      if (isStrict && param.type !== "Identifier") {
	        this.raise(param.start, "Non-simple parameter in strict mode");
	      }
	      this.checkLVal(param, true, nameHash, "function parameter list");
	    }
	    this.state.strict = oldStrict;
	  }
	};
	
	// Parses a comma-separated list of expressions, and returns them as
	// an array. `close` is the token type that ends the list, and
	// `allowEmpty` can be turned on to allow subsequent commas with
	// nothing in between them to be parsed as `null` (which is needed
	// for array literals).
	
	pp$3.parseExprList = function (close, allowEmpty, refShorthandDefaultPos) {
	  var elts = [];
	  var first = true;
	
	  while (!this.eat(close)) {
	    if (first) {
	      first = false;
	    } else {
	      this.expect(types.comma);
	      if (this.eat(close)) break;
	    }
	
	    elts.push(this.parseExprListItem(allowEmpty, refShorthandDefaultPos));
	  }
	  return elts;
	};
	
	pp$3.parseExprListItem = function (allowEmpty, refShorthandDefaultPos, refNeedsArrowPos) {
	  var elt = void 0;
	  if (allowEmpty && this.match(types.comma)) {
	    elt = null;
	  } else if (this.match(types.ellipsis)) {
	    elt = this.parseSpread(refShorthandDefaultPos);
	  } else {
	    elt = this.parseMaybeAssign(false, refShorthandDefaultPos, this.parseParenItem, refNeedsArrowPos);
	  }
	  return elt;
	};
	
	// Parse the next token as an identifier. If `liberal` is true (used
	// when parsing properties), it will also convert keywords into
	// identifiers.
	
	pp$3.parseIdentifier = function (liberal) {
	  var node = this.startNode();
	  if (!liberal) {
	    this.checkReservedWord(this.state.value, this.state.start, !!this.state.type.keyword, false);
	  }
	
	  if (this.match(types.name)) {
	    node.name = this.state.value;
	  } else if (this.state.type.keyword) {
	    node.name = this.state.type.keyword;
	  } else {
	    this.unexpected();
	  }
	
	  if (!liberal && node.name === "await" && this.state.inAsync) {
	    this.raise(node.start, "invalid use of await inside of an async function");
	  }
	
	  node.loc.identifierName = node.name;
	
	  this.next();
	  return this.finishNode(node, "Identifier");
	};
	
	pp$3.checkReservedWord = function (word, startLoc, checkKeywords, isBinding) {
	  if (this.isReservedWord(word) || checkKeywords && this.isKeyword(word)) {
	    this.raise(startLoc, word + " is a reserved word");
	  }
	
	  if (this.state.strict && (reservedWords.strict(word) || isBinding && reservedWords.strictBind(word))) {
	    this.raise(startLoc, word + " is a reserved word in strict mode");
	  }
	};
	
	// Parses await expression inside async function.
	
	pp$3.parseAwait = function (node) {
	  // istanbul ignore next: this condition is checked at the call site so won't be hit here
	  if (!this.state.inAsync) {
	    this.unexpected();
	  }
	  if (this.match(types.star)) {
	    this.raise(node.start, "await* has been removed from the async functions proposal. Use Promise.all() instead.");
	  }
	  node.argument = this.parseMaybeUnary();
	  return this.finishNode(node, "AwaitExpression");
	};
	
	// Parses yield expression inside generator.
	
	pp$3.parseYield = function () {
	  var node = this.startNode();
	  this.next();
	  if (this.match(types.semi) || this.canInsertSemicolon() || !this.match(types.star) && !this.state.type.startsExpr) {
	    node.delegate = false;
	    node.argument = null;
	  } else {
	    node.delegate = this.eat(types.star);
	    node.argument = this.parseMaybeAssign();
	  }
	  return this.finishNode(node, "YieldExpression");
	};
	
	// Start an AST node, attaching a start offset.
	
	var pp$4 = Parser.prototype;
	var commentKeys = ["leadingComments", "trailingComments", "innerComments"];
	
	var Node = function () {
	  function Node(pos, loc, filename) {
	    classCallCheck(this, Node);
	
	    this.type = "";
	    this.start = pos;
	    this.end = 0;
	    this.loc = new SourceLocation(loc);
	    if (filename) this.loc.filename = filename;
	  }
	
	  Node.prototype.__clone = function __clone() {
	    var node2 = new Node();
	    for (var key in this) {
	      // Do not clone comments that are already attached to the node
	      if (commentKeys.indexOf(key) < 0) {
	        node2[key] = this[key];
	      }
	    }
	
	    return node2;
	  };
	
	  return Node;
	}();
	
	pp$4.startNode = function () {
	  return new Node(this.state.start, this.state.startLoc, this.filename);
	};
	
	pp$4.startNodeAt = function (pos, loc) {
	  return new Node(pos, loc, this.filename);
	};
	
	function finishNodeAt(node, type, pos, loc) {
	  node.type = type;
	  node.end = pos;
	  node.loc.end = loc;
	  this.processComment(node);
	  return node;
	}
	
	// Finish an AST node, adding `type` and `end` properties.
	
	pp$4.finishNode = function (node, type) {
	  return finishNodeAt.call(this, node, type, this.state.lastTokEnd, this.state.lastTokEndLoc);
	};
	
	// Finish node at given position
	
	pp$4.finishNodeAt = function (node, type, pos, loc) {
	  return finishNodeAt.call(this, node, type, pos, loc);
	};
	
	var pp$5 = Parser.prototype;
	
	// This function is used to raise exceptions on parse errors. It
	// takes an offset integer (into the current `input`) to indicate
	// the location of the error, attaches the position to the end
	// of the error message, and then raises a `SyntaxError` with that
	// message.
	
	pp$5.raise = function (pos, message) {
	  var loc = getLineInfo(this.input, pos);
	  message += " (" + loc.line + ":" + loc.column + ")";
	  var err = new SyntaxError(message);
	  err.pos = pos;
	  err.loc = loc;
	  throw err;
	};
	
	/* eslint max-len: 0 */
	
	/**
	 * Based on the comment attachment algorithm used in espree and estraverse.
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are met:
	 *
	 * * Redistributions of source code must retain the above copyright
	 *   notice, this list of conditions and the following disclaimer.
	 * * Redistributions in binary form must reproduce the above copyright
	 *   notice, this list of conditions and the following disclaimer in the
	 *   documentation and/or other materials provided with the distribution.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	 * ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
	 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
	 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
	 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
	 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
	 * THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	function last(stack) {
	  return stack[stack.length - 1];
	}
	
	var pp$6 = Parser.prototype;
	
	pp$6.addComment = function (comment) {
	  if (this.filename) comment.loc.filename = this.filename;
	  this.state.trailingComments.push(comment);
	  this.state.leadingComments.push(comment);
	};
	
	pp$6.processComment = function (node) {
	  if (node.type === "Program" && node.body.length > 0) return;
	
	  var stack = this.state.commentStack;
	
	  var firstChild = void 0,
	      lastChild = void 0,
	      trailingComments = void 0,
	      i = void 0,
	      j = void 0;
	
	  if (this.state.trailingComments.length > 0) {
	    // If the first comment in trailingComments comes after the
	    // current node, then we're good - all comments in the array will
	    // come after the node and so it's safe to add them as official
	    // trailingComments.
	    if (this.state.trailingComments[0].start >= node.end) {
	      trailingComments = this.state.trailingComments;
	      this.state.trailingComments = [];
	    } else {
	      // Otherwise, if the first comment doesn't come after the
	      // current node, that means we have a mix of leading and trailing
	      // comments in the array and that leadingComments contains the
	      // same items as trailingComments. Reset trailingComments to
	      // zero items and we'll handle this by evaluating leadingComments
	      // later.
	      this.state.trailingComments.length = 0;
	    }
	  } else {
	    var lastInStack = last(stack);
	    if (stack.length > 0 && lastInStack.trailingComments && lastInStack.trailingComments[0].start >= node.end) {
	      trailingComments = lastInStack.trailingComments;
	      lastInStack.trailingComments = null;
	    }
	  }
	
	  // Eating the stack.
	  if (stack.length > 0 && last(stack).start >= node.start) {
	    firstChild = stack.pop();
	  }
	
	  while (stack.length > 0 && last(stack).start >= node.start) {
	    lastChild = stack.pop();
	  }
	
	  if (!lastChild && firstChild) lastChild = firstChild;
	
	  // Attach comments that follow a trailing comma on the last
	  // property in an object literal or a trailing comma in function arguments
	  // as trailing comments
	  if (firstChild && this.state.leadingComments.length > 0) {
	    var lastComment = last(this.state.leadingComments);
	
	    if (firstChild.type === "ObjectProperty") {
	      if (lastComment.start >= node.start) {
	        if (this.state.commentPreviousNode) {
	          for (j = 0; j < this.state.leadingComments.length; j++) {
	            if (this.state.leadingComments[j].end < this.state.commentPreviousNode.end) {
	              this.state.leadingComments.splice(j, 1);
	              j--;
	            }
	          }
	
	          if (this.state.leadingComments.length > 0) {
	            firstChild.trailingComments = this.state.leadingComments;
	            this.state.leadingComments = [];
	          }
	        }
	      }
	    } else if (node.type === "CallExpression" && node.arguments && node.arguments.length) {
	      var lastArg = last(node.arguments);
	
	      if (lastArg && lastComment.start >= lastArg.start && lastComment.end <= node.end) {
	        if (this.state.commentPreviousNode) {
	          if (this.state.leadingComments.length > 0) {
	            lastArg.trailingComments = this.state.leadingComments;
	            this.state.leadingComments = [];
	          }
	        }
	      }
	    }
	  }
	
	  if (lastChild) {
	    if (lastChild.leadingComments) {
	      if (lastChild !== node && last(lastChild.leadingComments).end <= node.start) {
	        node.leadingComments = lastChild.leadingComments;
	        lastChild.leadingComments = null;
	      } else {
	        // A leading comment for an anonymous class had been stolen by its first ClassMethod,
	        // so this takes back the leading comment.
	        // See also: https://github.com/eslint/espree/issues/158
	        for (i = lastChild.leadingComments.length - 2; i >= 0; --i) {
	          if (lastChild.leadingComments[i].end <= node.start) {
	            node.leadingComments = lastChild.leadingComments.splice(0, i + 1);
	            break;
	          }
	        }
	      }
	    }
	  } else if (this.state.leadingComments.length > 0) {
	    if (last(this.state.leadingComments).end <= node.start) {
	      if (this.state.commentPreviousNode) {
	        for (j = 0; j < this.state.leadingComments.length; j++) {
	          if (this.state.leadingComments[j].end < this.state.commentPreviousNode.end) {
	            this.state.leadingComments.splice(j, 1);
	            j--;
	          }
	        }
	      }
	      if (this.state.leadingComments.length > 0) {
	        node.leadingComments = this.state.leadingComments;
	        this.state.leadingComments = [];
	      }
	    } else {
	      // https://github.com/eslint/espree/issues/2
	      //
	      // In special cases, such as return (without a value) and
	      // debugger, all comments will end up as leadingComments and
	      // will otherwise be eliminated. This step runs when the
	      // commentStack is empty and there are comments left
	      // in leadingComments.
	      //
	      // This loop figures out the stopping point between the actual
	      // leading and trailing comments by finding the location of the
	      // first comment that comes after the given node.
	      for (i = 0; i < this.state.leadingComments.length; i++) {
	        if (this.state.leadingComments[i].end > node.start) {
	          break;
	        }
	      }
	
	      // Split the array based on the location of the first comment
	      // that comes after the node. Keep in mind that this could
	      // result in an empty array, and if so, the array must be
	      // deleted.
	      node.leadingComments = this.state.leadingComments.slice(0, i);
	      if (node.leadingComments.length === 0) {
	        node.leadingComments = null;
	      }
	
	      // Similarly, trailing comments are attached later. The variable
	      // must be reset to null if there are no trailing comments.
	      trailingComments = this.state.leadingComments.slice(i);
	      if (trailingComments.length === 0) {
	        trailingComments = null;
	      }
	    }
	  }
	
	  this.state.commentPreviousNode = node;
	
	  if (trailingComments) {
	    if (trailingComments.length && trailingComments[0].start >= node.start && last(trailingComments).end <= node.end) {
	      node.innerComments = trailingComments;
	    } else {
	      node.trailingComments = trailingComments;
	    }
	  }
	
	  stack.push(node);
	};
	
	var pp$7 = Parser.prototype;
	
	pp$7.estreeParseRegExpLiteral = function (_ref) {
	  var pattern = _ref.pattern,
	      flags = _ref.flags;
	
	  var regex = null;
	  try {
	    regex = new RegExp(pattern, flags);
	  } catch (e) {
	    // In environments that don't support these flags value will
	    // be null as the regex can't be represented natively.
	  }
	  var node = this.estreeParseLiteral(regex);
	  node.regex = { pattern: pattern, flags: flags };
	
	  return node;
	};
	
	pp$7.estreeParseLiteral = function (value) {
	  return this.parseLiteral(value, "Literal");
	};
	
	pp$7.directiveToStmt = function (directive) {
	  var directiveLiteral = directive.value;
	
	  var stmt = this.startNodeAt(directive.start, directive.loc.start);
	  var expression = this.startNodeAt(directiveLiteral.start, directiveLiteral.loc.start);
	
	  expression.value = directiveLiteral.value;
	  expression.raw = directiveLiteral.extra.raw;
	
	  stmt.expression = this.finishNodeAt(expression, "Literal", directiveLiteral.end, directiveLiteral.loc.end);
	  stmt.directive = directiveLiteral.extra.raw.slice(1, -1);
	
	  return this.finishNodeAt(stmt, "ExpressionStatement", directive.end, directive.loc.end);
	};
	
	function isSimpleProperty(node) {
	  return node && node.type === "Property" && node.kind === "init" && node.method === false;
	}
	
	var estreePlugin = function (instance) {
	  instance.extend("checkDeclaration", function (inner) {
	    return function (node) {
	      if (isSimpleProperty(node)) {
	        this.checkDeclaration(node.value);
	      } else {
	        inner.call(this, node);
	      }
	    };
	  });
	
	  instance.extend("checkGetterSetterParamCount", function () {
	    return function (prop) {
	      var paramCount = prop.kind === "get" ? 0 : 1;
	      if (prop.value.params.length !== paramCount) {
	        var start = prop.start;
	        if (prop.kind === "get") {
	          this.raise(start, "getter should have no params");
	        } else {
	          this.raise(start, "setter should have exactly one param");
	        }
	      }
	    };
	  });
	
	  instance.extend("checkLVal", function (inner) {
	    return function (expr, isBinding, checkClashes) {
	      var _this = this;
	
	      switch (expr.type) {
	        case "ObjectPattern":
	          expr.properties.forEach(function (prop) {
	            _this.checkLVal(prop.type === "Property" ? prop.value : prop, isBinding, checkClashes, "object destructuring pattern");
	          });
	          break;
	        default:
	          for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	            args[_key - 3] = arguments[_key];
	          }
	
	          inner.call.apply(inner, [this, expr, isBinding, checkClashes].concat(args));
	      }
	    };
	  });
	
	  instance.extend("checkPropClash", function () {
	    return function (prop, propHash) {
	      if (prop.computed || !isSimpleProperty(prop)) return;
	
	      var key = prop.key;
	      // It is either an Identifier or a String/NumericLiteral
	      var name = key.type === "Identifier" ? key.name : String(key.value);
	
	      if (name === "__proto__") {
	        if (propHash.proto) this.raise(key.start, "Redefinition of __proto__ property");
	        propHash.proto = true;
	      }
	    };
	  });
	
	  instance.extend("isStrictBody", function () {
	    return function (node, isExpression) {
	      if (!isExpression && node.body.body.length > 0) {
	        for (var _iterator = node.body.body, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	          var _ref2;
	
	          if (_isArray) {
	            if (_i >= _iterator.length) break;
	            _ref2 = _iterator[_i++];
	          } else {
	            _i = _iterator.next();
	            if (_i.done) break;
	            _ref2 = _i.value;
	          }
	
	          var directive = _ref2;
	
	          if (directive.type === "ExpressionStatement" && directive.expression.type === "Literal") {
	            if (directive.expression.value === "use strict") return true;
	          } else {
	            // Break for the first non literal expression
	            break;
	          }
	        }
	      }
	
	      return false;
	    };
	  });
	
	  instance.extend("isValidDirective", function () {
	    return function (stmt) {
	      return stmt.type === "ExpressionStatement" && stmt.expression.type === "Literal" && typeof stmt.expression.value === "string" && (!stmt.expression.extra || !stmt.expression.extra.parenthesized);
	    };
	  });
	
	  instance.extend("stmtToDirective", function (inner) {
	    return function (stmt) {
	      var directive = inner.call(this, stmt);
	      var value = stmt.expression.value;
	
	      // Reset value to the actual value as in estree mode we want
	      // the stmt to have the real value and not the raw value
	      directive.value.value = value;
	
	      return directive;
	    };
	  });
	
	  instance.extend("parseBlockBody", function (inner) {
	    return function (node) {
	      var _this2 = this;
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      inner.call.apply(inner, [this, node].concat(args));
	
	      node.directives.reverse().forEach(function (directive) {
	        node.body.unshift(_this2.directiveToStmt(directive));
	      });
	      delete node.directives;
	    };
	  });
	
	  instance.extend("parseClassMethod", function () {
	    return function (classBody, method, isGenerator, isAsync) {
	      this.parseMethod(method, isGenerator, isAsync);
	      if (method.typeParameters) {
	        method.value.typeParameters = method.typeParameters;
	        delete method.typeParameters;
	      }
	      classBody.body.push(this.finishNode(method, "MethodDefinition"));
	    };
	  });
	
	  instance.extend("parseExprAtom", function (inner) {
	    return function () {
	      switch (this.state.type) {
	        case types.regexp:
	          return this.estreeParseRegExpLiteral(this.state.value);
	
	        case types.num:
	        case types.string:
	          return this.estreeParseLiteral(this.state.value);
	
	        case types._null:
	          return this.estreeParseLiteral(null);
	
	        case types._true:
	          return this.estreeParseLiteral(true);
	
	        case types._false:
	          return this.estreeParseLiteral(false);
	
	        default:
	          for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	            args[_key3] = arguments[_key3];
	          }
	
	          return inner.call.apply(inner, [this].concat(args));
	      }
	    };
	  });
	
	  instance.extend("parseLiteral", function (inner) {
	    return function () {
	      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      var node = inner.call.apply(inner, [this].concat(args));
	      node.raw = node.extra.raw;
	      delete node.extra;
	
	      return node;
	    };
	  });
	
	  instance.extend("parseMethod", function (inner) {
	    return function (node) {
	      var funcNode = this.startNode();
	      funcNode.kind = node.kind; // provide kind, so inner method correctly sets state
	
	      for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	        args[_key5 - 1] = arguments[_key5];
	      }
	
	      funcNode = inner.call.apply(inner, [this, funcNode].concat(args));
	      delete funcNode.kind;
	      node.value = this.finishNode(funcNode, "FunctionExpression");
	
	      return node;
	    };
	  });
	
	  instance.extend("parseObjectMethod", function (inner) {
	    return function () {
	      for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      var node = inner.call.apply(inner, [this].concat(args));
	
	      if (node) {
	        if (node.kind === "method") node.kind = "init";
	        node.type = "Property";
	      }
	
	      return node;
	    };
	  });
	
	  instance.extend("parseObjectProperty", function (inner) {
	    return function () {
	      for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      var node = inner.call.apply(inner, [this].concat(args));
	
	      if (node) {
	        node.kind = "init";
	        node.type = "Property";
	      }
	
	      return node;
	    };
	  });
	
	  instance.extend("toAssignable", function (inner) {
	    return function (node, isBinding) {
	      for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
	        args[_key8 - 2] = arguments[_key8];
	      }
	
	      if (isSimpleProperty(node)) {
	        this.toAssignable.apply(this, [node.value, isBinding].concat(args));
	
	        return node;
	      } else if (node.type === "ObjectExpression") {
	        node.type = "ObjectPattern";
	        for (var _iterator2 = node.properties, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	          var _ref3;
	
	          if (_isArray2) {
	            if (_i2 >= _iterator2.length) break;
	            _ref3 = _iterator2[_i2++];
	          } else {
	            _i2 = _iterator2.next();
	            if (_i2.done) break;
	            _ref3 = _i2.value;
	          }
	
	          var prop = _ref3;
	
	          if (prop.kind === "get" || prop.kind === "set") {
	            this.raise(prop.key.start, "Object pattern can't contain getter or setter");
	          } else if (prop.method) {
	            this.raise(prop.key.start, "Object pattern can't contain methods");
	          } else {
	            this.toAssignable(prop, isBinding, "object destructuring pattern");
	          }
	        }
	
	        return node;
	      }
	
	      return inner.call.apply(inner, [this, node, isBinding].concat(args));
	    };
	  });
	};
	
	/* eslint max-len: 0 */
	
	var primitiveTypes = ["any", "mixed", "empty", "bool", "boolean", "number", "string", "void", "null"];
	
	var pp$8 = Parser.prototype;
	
	pp$8.flowParseTypeInitialiser = function (tok) {
	  var oldInType = this.state.inType;
	  this.state.inType = true;
	  this.expect(tok || types.colon);
	
	  var type = this.flowParseType();
	  this.state.inType = oldInType;
	  return type;
	};
	
	pp$8.flowParsePredicate = function () {
	  var node = this.startNode();
	  var moduloLoc = this.state.startLoc;
	  var moduloPos = this.state.start;
	  this.expect(types.modulo);
	  var checksLoc = this.state.startLoc;
	  this.expectContextual("checks");
	  // Force '%' and 'checks' to be adjacent
	  if (moduloLoc.line !== checksLoc.line || moduloLoc.column !== checksLoc.column - 1) {
	    this.raise(moduloPos, "Spaces between ´%´ and ´checks´ are not allowed here.");
	  }
	  if (this.eat(types.parenL)) {
	    node.expression = this.parseExpression();
	    this.expect(types.parenR);
	    return this.finishNode(node, "DeclaredPredicate");
	  } else {
	    return this.finishNode(node, "InferredPredicate");
	  }
	};
	
	pp$8.flowParseTypeAndPredicateInitialiser = function () {
	  var oldInType = this.state.inType;
	  this.state.inType = true;
	  this.expect(types.colon);
	  var type = null;
	  var predicate = null;
	  if (this.match(types.modulo)) {
	    this.state.inType = oldInType;
	    predicate = this.flowParsePredicate();
	  } else {
	    type = this.flowParseType();
	    this.state.inType = oldInType;
	    if (this.match(types.modulo)) {
	      predicate = this.flowParsePredicate();
	    }
	  }
	  return [type, predicate];
	};
	
	pp$8.flowParseDeclareClass = function (node) {
	  this.next();
	  this.flowParseInterfaceish(node, true);
	  return this.finishNode(node, "DeclareClass");
	};
	
	pp$8.flowParseDeclareFunction = function (node) {
	  this.next();
	
	  var id = node.id = this.parseIdentifier();
	
	  var typeNode = this.startNode();
	  var typeContainer = this.startNode();
	
	  if (this.isRelational("<")) {
	    typeNode.typeParameters = this.flowParseTypeParameterDeclaration();
	  } else {
	    typeNode.typeParameters = null;
	  }
	
	  this.expect(types.parenL);
	  var tmp = this.flowParseFunctionTypeParams();
	  typeNode.params = tmp.params;
	  typeNode.rest = tmp.rest;
	  this.expect(types.parenR);
	  var predicate = null;
	
	  var _flowParseTypeAndPred = this.flowParseTypeAndPredicateInitialiser();
	
	  typeNode.returnType = _flowParseTypeAndPred[0];
	  predicate = _flowParseTypeAndPred[1];
	
	  typeContainer.typeAnnotation = this.finishNode(typeNode, "FunctionTypeAnnotation");
	  typeContainer.predicate = predicate;
	  id.typeAnnotation = this.finishNode(typeContainer, "TypeAnnotation");
	
	  this.finishNode(id, id.type);
	
	  this.semicolon();
	
	  return this.finishNode(node, "DeclareFunction");
	};
	
	pp$8.flowParseDeclare = function (node) {
	  if (this.match(types._class)) {
	    return this.flowParseDeclareClass(node);
	  } else if (this.match(types._function)) {
	    return this.flowParseDeclareFunction(node);
	  } else if (this.match(types._var)) {
	    return this.flowParseDeclareVariable(node);
	  } else if (this.isContextual("module")) {
	    if (this.lookahead().type === types.dot) {
	      return this.flowParseDeclareModuleExports(node);
	    } else {
	      return this.flowParseDeclareModule(node);
	    }
	  } else if (this.isContextual("type")) {
	    return this.flowParseDeclareTypeAlias(node);
	  } else if (this.isContextual("opaque")) {
	    return this.flowParseDeclareOpaqueType(node);
	  } else if (this.isContextual("interface")) {
	    return this.flowParseDeclareInterface(node);
	  } else if (this.match(types._export)) {
	    return this.flowParseDeclareExportDeclaration(node);
	  } else {
	    this.unexpected();
	  }
	};
	
	pp$8.flowParseDeclareExportDeclaration = function (node) {
	  this.expect(types._export);
	  if (this.isContextual("opaque") // declare export opaque ...
	  ) {
	      node.declaration = this.flowParseDeclare(this.startNode());
	      node.default = false;
	
	      return this.finishNode(node, "DeclareExportDeclaration");
	    }
	
	  throw this.unexpected();
	};
	
	pp$8.flowParseDeclareVariable = function (node) {
	  this.next();
	  node.id = this.flowParseTypeAnnotatableIdentifier();
	  this.semicolon();
	  return this.finishNode(node, "DeclareVariable");
	};
	
	pp$8.flowParseDeclareModule = function (node) {
	  this.next();
	
	  if (this.match(types.string)) {
	    node.id = this.parseExprAtom();
	  } else {
	    node.id = this.parseIdentifier();
	  }
	
	  var bodyNode = node.body = this.startNode();
	  var body = bodyNode.body = [];
	  this.expect(types.braceL);
	  while (!this.match(types.braceR)) {
	    var _bodyNode = this.startNode();
	
	    if (this.match(types._import)) {
	      var lookahead = this.lookahead();
	      if (lookahead.value !== "type" && lookahead.value !== "typeof") {
	        this.unexpected(null, "Imports within a `declare module` body must always be `import type` or `import typeof`");
	      }
	
	      this.parseImport(_bodyNode);
	    } else {
	      this.expectContextual("declare", "Only declares and type imports are allowed inside declare module");
	
	      _bodyNode = this.flowParseDeclare(_bodyNode, true);
	    }
	
	    body.push(_bodyNode);
	  }
	  this.expect(types.braceR);
	
	  this.finishNode(bodyNode, "BlockStatement");
	  return this.finishNode(node, "DeclareModule");
	};
	
	pp$8.flowParseDeclareModuleExports = function (node) {
	  this.expectContextual("module");
	  this.expect(types.dot);
	  this.expectContextual("exports");
	  node.typeAnnotation = this.flowParseTypeAnnotation();
	  this.semicolon();
	
	  return this.finishNode(node, "DeclareModuleExports");
	};
	
	pp$8.flowParseDeclareTypeAlias = function (node) {
	  this.next();
	  this.flowParseTypeAlias(node);
	  return this.finishNode(node, "DeclareTypeAlias");
	};
	
	pp$8.flowParseDeclareOpaqueType = function (node) {
	  this.next();
	  this.flowParseOpaqueType(node, true);
	  return this.finishNode(node, "DeclareOpaqueType");
	};
	
	pp$8.flowParseDeclareInterface = function (node) {
	  this.next();
	  this.flowParseInterfaceish(node);
	  return this.finishNode(node, "DeclareInterface");
	};
	
	// Interfaces
	
	pp$8.flowParseInterfaceish = function (node) {
	  node.id = this.parseIdentifier();
	
	  if (this.isRelational("<")) {
	    node.typeParameters = this.flowParseTypeParameterDeclaration();
	  } else {
	    node.typeParameters = null;
	  }
	
	  node.extends = [];
	  node.mixins = [];
	
	  if (this.eat(types._extends)) {
	    do {
	      node.extends.push(this.flowParseInterfaceExtends());
	    } while (this.eat(types.comma));
	  }
	
	  if (this.isContextual("mixins")) {
	    this.next();
	    do {
	      node.mixins.push(this.flowParseInterfaceExtends());
	    } while (this.eat(types.comma));
	  }
	
	  node.body = this.flowParseObjectType(true, false, false);
	};
	
	pp$8.flowParseInterfaceExtends = function () {
	  var node = this.startNode();
	
	  node.id = this.flowParseQualifiedTypeIdentifier();
	  if (this.isRelational("<")) {
	    node.typeParameters = this.flowParseTypeParameterInstantiation();
	  } else {
	    node.typeParameters = null;
	  }
	
	  return this.finishNode(node, "InterfaceExtends");
	};
	
	pp$8.flowParseInterface = function (node) {
	  this.flowParseInterfaceish(node, false);
	  return this.finishNode(node, "InterfaceDeclaration");
	};
	
	pp$8.flowParseRestrictedIdentifier = function (liberal) {
	  if (primitiveTypes.indexOf(this.state.value) > -1) {
	    this.raise(this.state.start, "Cannot overwrite primitive type " + this.state.value);
	  }
	
	  return this.parseIdentifier(liberal);
	};
	
	// Type aliases
	
	pp$8.flowParseTypeAlias = function (node) {
	  node.id = this.flowParseRestrictedIdentifier();
	
	  if (this.isRelational("<")) {
	    node.typeParameters = this.flowParseTypeParameterDeclaration();
	  } else {
	    node.typeParameters = null;
	  }
	
	  node.right = this.flowParseTypeInitialiser(types.eq);
	  this.semicolon();
	
	  return this.finishNode(node, "TypeAlias");
	};
	
	// Opaque type aliases
	
	pp$8.flowParseOpaqueType = function (node, declare) {
	  this.expectContextual("type");
	  node.id = this.flowParseRestrictedIdentifier();
	
	  if (this.isRelational("<")) {
	    node.typeParameters = this.flowParseTypeParameterDeclaration();
	  } else {
	    node.typeParameters = null;
	  }
	
	  // Parse the supertype
	  node.supertype = null;
	  if (this.match(types.colon)) {
	    node.supertype = this.flowParseTypeInitialiser(types.colon);
	  }
	
	  node.impltype = null;
	  if (!declare) {
	    node.impltype = this.flowParseTypeInitialiser(types.eq);
	  }
	  this.semicolon();
	
	  return this.finishNode(node, "OpaqueType");
	};
	
	// Type annotations
	
	pp$8.flowParseTypeParameter = function () {
	  var node = this.startNode();
	
	  var variance = this.flowParseVariance();
	
	  var ident = this.flowParseTypeAnnotatableIdentifier();
	  node.name = ident.name;
	  node.variance = variance;
	  node.bound = ident.typeAnnotation;
	
	  if (this.match(types.eq)) {
	    this.eat(types.eq);
	    node.default = this.flowParseType();
	  }
	
	  return this.finishNode(node, "TypeParameter");
	};
	
	pp$8.flowParseTypeParameterDeclaration = function () {
	  var oldInType = this.state.inType;
	  var node = this.startNode();
	  node.params = [];
	
	  this.state.inType = true;
	
	  // istanbul ignore else: this condition is already checked at all call sites
	  if (this.isRelational("<") || this.match(types.jsxTagStart)) {
	    this.next();
	  } else {
	    this.unexpected();
	  }
	
	  do {
	    node.params.push(this.flowParseTypeParameter());
	    if (!this.isRelational(">")) {
	      this.expect(types.comma);
	    }
	  } while (!this.isRelational(">"));
	  this.expectRelational(">");
	
	  this.state.inType = oldInType;
	
	  return this.finishNode(node, "TypeParameterDeclaration");
	};
	
	pp$8.flowParseTypeParameterInstantiation = function () {
	  var node = this.startNode();
	  var oldInType = this.state.inType;
	  node.params = [];
	
	  this.state.inType = true;
	
	  this.expectRelational("<");
	  while (!this.isRelational(">")) {
	    node.params.push(this.flowParseType());
	    if (!this.isRelational(">")) {
	      this.expect(types.comma);
	    }
	  }
	  this.expectRelational(">");
	
	  this.state.inType = oldInType;
	
	  return this.finishNode(node, "TypeParameterInstantiation");
	};
	
	pp$8.flowParseObjectPropertyKey = function () {
	  return this.match(types.num) || this.match(types.string) ? this.parseExprAtom() : this.parseIdentifier(true);
	};
	
	pp$8.flowParseObjectTypeIndexer = function (node, isStatic, variance) {
	  node.static = isStatic;
	
	  this.expect(types.bracketL);
	  if (this.lookahead().type === types.colon) {
	    node.id = this.flowParseObjectPropertyKey();
	    node.key = this.flowParseTypeInitialiser();
	  } else {
	    node.id = null;
	    node.key = this.flowParseType();
	  }
	  this.expect(types.bracketR);
	  node.value = this.flowParseTypeInitialiser();
	  node.variance = variance;
	
	  this.flowObjectTypeSemicolon();
	  return this.finishNode(node, "ObjectTypeIndexer");
	};
	
	pp$8.flowParseObjectTypeMethodish = function (node) {
	  node.params = [];
	  node.rest = null;
	  node.typeParameters = null;
	
	  if (this.isRelational("<")) {
	    node.typeParameters = this.flowParseTypeParameterDeclaration();
	  }
	
	  this.expect(types.parenL);
	  while (!this.match(types.parenR) && !this.match(types.ellipsis)) {
	    node.params.push(this.flowParseFunctionTypeParam());
	    if (!this.match(types.parenR)) {
	      this.expect(types.comma);
	    }
	  }
	
	  if (this.eat(types.ellipsis)) {
	    node.rest = this.flowParseFunctionTypeParam();
	  }
	  this.expect(types.parenR);
	  node.returnType = this.flowParseTypeInitialiser();
	
	  return this.finishNode(node, "FunctionTypeAnnotation");
	};
	
	pp$8.flowParseObjectTypeMethod = function (startPos, startLoc, isStatic, key) {
	  var node = this.startNodeAt(startPos, startLoc);
	  node.value = this.flowParseObjectTypeMethodish(this.startNodeAt(startPos, startLoc));
	  node.static = isStatic;
	  node.key = key;
	  node.optional = false;
	  this.flowObjectTypeSemicolon();
	  return this.finishNode(node, "ObjectTypeProperty");
	};
	
	pp$8.flowParseObjectTypeCallProperty = function (node, isStatic) {
	  var valueNode = this.startNode();
	  node.static = isStatic;
	  node.value = this.flowParseObjectTypeMethodish(valueNode);
	  this.flowObjectTypeSemicolon();
	  return this.finishNode(node, "ObjectTypeCallProperty");
	};
	
	pp$8.flowParseObjectType = function (allowStatic, allowExact, allowSpread) {
	  var oldInType = this.state.inType;
	  this.state.inType = true;
	
	  var nodeStart = this.startNode();
	  var node = void 0;
	  var propertyKey = void 0;
	  var isStatic = false;
	
	  nodeStart.callProperties = [];
	  nodeStart.properties = [];
	  nodeStart.indexers = [];
	
	  var endDelim = void 0;
	  var exact = void 0;
	  if (allowExact && this.match(types.braceBarL)) {
	    this.expect(types.braceBarL);
	    endDelim = types.braceBarR;
	    exact = true;
	  } else {
	    this.expect(types.braceL);
	    endDelim = types.braceR;
	    exact = false;
	  }
	
	  nodeStart.exact = exact;
	
	  while (!this.match(endDelim)) {
	    var optional = false;
	    var startPos = this.state.start;
	    var startLoc = this.state.startLoc;
	    node = this.startNode();
	    if (allowStatic && this.isContextual("static") && this.lookahead().type !== types.colon) {
	      this.next();
	      isStatic = true;
	    }
	
	    var variancePos = this.state.start;
	    var variance = this.flowParseVariance();
	
	    if (this.match(types.bracketL)) {
	      nodeStart.indexers.push(this.flowParseObjectTypeIndexer(node, isStatic, variance));
	    } else if (this.match(types.parenL) || this.isRelational("<")) {
	      if (variance) {
	        this.unexpected(variancePos);
	      }
	      nodeStart.callProperties.push(this.flowParseObjectTypeCallProperty(node, isStatic));
	    } else {
	      if (this.match(types.ellipsis)) {
	        if (!allowSpread) {
	          this.unexpected(null, "Spread operator cannot appear in class or interface definitions");
	        }
	        if (variance) {
	          this.unexpected(variance.start, "Spread properties cannot have variance");
	        }
	        this.expect(types.ellipsis);
	        node.argument = this.flowParseType();
	        this.flowObjectTypeSemicolon();
	        nodeStart.properties.push(this.finishNode(node, "ObjectTypeSpreadProperty"));
	      } else {
	        propertyKey = this.flowParseObjectPropertyKey();
	        if (this.isRelational("<") || this.match(types.parenL)) {
	          // This is a method property
	          if (variance) {
	            this.unexpected(variance.start);
	          }
	          nodeStart.properties.push(this.flowParseObjectTypeMethod(startPos, startLoc, isStatic, propertyKey));
	        } else {
	          if (this.eat(types.question)) {
	            optional = true;
	          }
	          node.key = propertyKey;
	          node.value = this.flowParseTypeInitialiser();
	          node.optional = optional;
	          node.static = isStatic;
	          node.variance = variance;
	          this.flowObjectTypeSemicolon();
	          nodeStart.properties.push(this.finishNode(node, "ObjectTypeProperty"));
	        }
	      }
	    }
	
	    isStatic = false;
	  }
	
	  this.expect(endDelim);
	
	  var out = this.finishNode(nodeStart, "ObjectTypeAnnotation");
	
	  this.state.inType = oldInType;
	
	  return out;
	};
	
	pp$8.flowObjectTypeSemicolon = function () {
	  if (!this.eat(types.semi) && !this.eat(types.comma) && !this.match(types.braceR) && !this.match(types.braceBarR)) {
	    this.unexpected();
	  }
	};
	
	pp$8.flowParseQualifiedTypeIdentifier = function (startPos, startLoc, id) {
	  startPos = startPos || this.state.start;
	  startLoc = startLoc || this.state.startLoc;
	  var node = id || this.parseIdentifier();
	
	  while (this.eat(types.dot)) {
	    var node2 = this.startNodeAt(startPos, startLoc);
	    node2.qualification = node;
	    node2.id = this.parseIdentifier();
	    node = this.finishNode(node2, "QualifiedTypeIdentifier");
	  }
	
	  return node;
	};
	
	pp$8.flowParseGenericType = function (startPos, startLoc, id) {
	  var node = this.startNodeAt(startPos, startLoc);
	
	  node.typeParameters = null;
	  node.id = this.flowParseQualifiedTypeIdentifier(startPos, startLoc, id);
	
	  if (this.isRelational("<")) {
	    node.typeParameters = this.flowParseTypeParameterInstantiation();
	  }
	
	  return this.finishNode(node, "GenericTypeAnnotation");
	};
	
	pp$8.flowParseTypeofType = function () {
	  var node = this.startNode();
	  this.expect(types._typeof);
	  node.argument = this.flowParsePrimaryType();
	  return this.finishNode(node, "TypeofTypeAnnotation");
	};
	
	pp$8.flowParseTupleType = function () {
	  var node = this.startNode();
	  node.types = [];
	  this.expect(types.bracketL);
	  // We allow trailing commas
	  while (this.state.pos < this.input.length && !this.match(types.bracketR)) {
	    node.types.push(this.flowParseType());
	    if (this.match(types.bracketR)) break;
	    this.expect(types.comma);
	  }
	  this.expect(types.bracketR);
	  return this.finishNode(node, "TupleTypeAnnotation");
	};
	
	pp$8.flowParseFunctionTypeParam = function () {
	  var name = null;
	  var optional = false;
	  var typeAnnotation = null;
	  var node = this.startNode();
	  var lh = this.lookahead();
	  if (lh.type === types.colon || lh.type === types.question) {
	    name = this.parseIdentifier();
	    if (this.eat(types.question)) {
	      optional = true;
	    }
	    typeAnnotation = this.flowParseTypeInitialiser();
	  } else {
	    typeAnnotation = this.flowParseType();
	  }
	  node.name = name;
	  node.optional = optional;
	  node.typeAnnotation = typeAnnotation;
	  return this.finishNode(node, "FunctionTypeParam");
	};
	
	pp$8.reinterpretTypeAsFunctionTypeParam = function (type) {
	  var node = this.startNodeAt(type.start, type.loc.start);
	  node.name = null;
	  node.optional = false;
	  node.typeAnnotation = type;
	  return this.finishNode(node, "FunctionTypeParam");
	};
	
	pp$8.flowParseFunctionTypeParams = function () {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var ret = { params: params, rest: null };
	  while (!this.match(types.parenR) && !this.match(types.ellipsis)) {
	    ret.params.push(this.flowParseFunctionTypeParam());
	    if (!this.match(types.parenR)) {
	      this.expect(types.comma);
	    }
	  }
	  if (this.eat(types.ellipsis)) {
	    ret.rest = this.flowParseFunctionTypeParam();
	  }
	  return ret;
	};
	
	pp$8.flowIdentToTypeAnnotation = function (startPos, startLoc, node, id) {
	  switch (id.name) {
	    case "any":
	      return this.finishNode(node, "AnyTypeAnnotation");
	
	    case "void":
	      return this.finishNode(node, "VoidTypeAnnotation");
	
	    case "bool":
	    case "boolean":
	      return this.finishNode(node, "BooleanTypeAnnotation");
	
	    case "mixed":
	      return this.finishNode(node, "MixedTypeAnnotation");
	
	    case "empty":
	      return this.finishNode(node, "EmptyTypeAnnotation");
	
	    case "number":
	      return this.finishNode(node, "NumberTypeAnnotation");
	
	    case "string":
	      return this.finishNode(node, "StringTypeAnnotation");
	
	    default:
	      return this.flowParseGenericType(startPos, startLoc, id);
	  }
	};
	
	// The parsing of types roughly parallels the parsing of expressions, and
	// primary types are kind of like primary expressions...they're the
	// primitives with which other types are constructed.
	pp$8.flowParsePrimaryType = function () {
	  var startPos = this.state.start;
	  var startLoc = this.state.startLoc;
	  var node = this.startNode();
	  var tmp = void 0;
	  var type = void 0;
	  var isGroupedType = false;
	  var oldNoAnonFunctionType = this.state.noAnonFunctionType;
	
	  switch (this.state.type) {
	    case types.name:
	      return this.flowIdentToTypeAnnotation(startPos, startLoc, node, this.parseIdentifier());
	
	    case types.braceL:
	      return this.flowParseObjectType(false, false, true);
	
	    case types.braceBarL:
	      return this.flowParseObjectType(false, true, true);
	
	    case types.bracketL:
	      return this.flowParseTupleType();
	
	    case types.relational:
	      if (this.state.value === "<") {
	        node.typeParameters = this.flowParseTypeParameterDeclaration();
	        this.expect(types.parenL);
	        tmp = this.flowParseFunctionTypeParams();
	        node.params = tmp.params;
	        node.rest = tmp.rest;
	        this.expect(types.parenR);
	
	        this.expect(types.arrow);
	
	        node.returnType = this.flowParseType();
	
	        return this.finishNode(node, "FunctionTypeAnnotation");
	      }
	      break;
	
	    case types.parenL:
	      this.next();
	
	      // Check to see if this is actually a grouped type
	      if (!this.match(types.parenR) && !this.match(types.ellipsis)) {
	        if (this.match(types.name)) {
	          var token = this.lookahead().type;
	          isGroupedType = token !== types.question && token !== types.colon;
	        } else {
	          isGroupedType = true;
	        }
	      }
	
	      if (isGroupedType) {
	        this.state.noAnonFunctionType = false;
	        type = this.flowParseType();
	        this.state.noAnonFunctionType = oldNoAnonFunctionType;
	
	        // A `,` or a `) =>` means this is an anonymous function type
	        if (this.state.noAnonFunctionType || !(this.match(types.comma) || this.match(types.parenR) && this.lookahead().type === types.arrow)) {
	          this.expect(types.parenR);
	          return type;
	        } else {
	          // Eat a comma if there is one
	          this.eat(types.comma);
	        }
	      }
	
	      if (type) {
	        tmp = this.flowParseFunctionTypeParams([this.reinterpretTypeAsFunctionTypeParam(type)]);
	      } else {
	        tmp = this.flowParseFunctionTypeParams();
	      }
	
	      node.params = tmp.params;
	      node.rest = tmp.rest;
	
	      this.expect(types.parenR);
	
	      this.expect(types.arrow);
	
	      node.returnType = this.flowParseType();
	
	      node.typeParameters = null;
	
	      return this.finishNode(node, "FunctionTypeAnnotation");
	
	    case types.string:
	      return this.parseLiteral(this.state.value, "StringLiteralTypeAnnotation");
	
	    case types._true:case types._false:
	      node.value = this.match(types._true);
	      this.next();
	      return this.finishNode(node, "BooleanLiteralTypeAnnotation");
	
	    case types.plusMin:
	      if (this.state.value === "-") {
	        this.next();
	        if (!this.match(types.num)) this.unexpected(null, "Unexpected token, expected number");
	
	        return this.parseLiteral(-this.state.value, "NumericLiteralTypeAnnotation", node.start, node.loc.start);
	      }
	
	      this.unexpected();
	    case types.num:
	      return this.parseLiteral(this.state.value, "NumericLiteralTypeAnnotation");
	
	    case types._null:
	      node.value = this.match(types._null);
	      this.next();
	      return this.finishNode(node, "NullLiteralTypeAnnotation");
	
	    case types._this:
	      node.value = this.match(types._this);
	      this.next();
	      return this.finishNode(node, "ThisTypeAnnotation");
	
	    case types.star:
	      this.next();
	      return this.finishNode(node, "ExistentialTypeParam");
	
	    default:
	      if (this.state.type.keyword === "typeof") {
	        return this.flowParseTypeofType();
	      }
	  }
	
	  this.unexpected();
	};
	
	pp$8.flowParsePostfixType = function () {
	  var startPos = this.state.start,
	      startLoc = this.state.startLoc;
	  var type = this.flowParsePrimaryType();
	  while (!this.canInsertSemicolon() && this.match(types.bracketL)) {
	    var node = this.startNodeAt(startPos, startLoc);
	    node.elementType = type;
	    this.expect(types.bracketL);
	    this.expect(types.bracketR);
	    type = this.finishNode(node, "ArrayTypeAnnotation");
	  }
	  return type;
	};
	
	pp$8.flowParsePrefixType = function () {
	  var node = this.startNode();
	  if (this.eat(types.question)) {
	    node.typeAnnotation = this.flowParsePrefixType();
	    return this.finishNode(node, "NullableTypeAnnotation");
	  } else {
	    return this.flowParsePostfixType();
	  }
	};
	
	pp$8.flowParseAnonFunctionWithoutParens = function () {
	  var param = this.flowParsePrefixType();
	  if (!this.state.noAnonFunctionType && this.eat(types.arrow)) {
	    var node = this.startNodeAt(param.start, param.loc.start);
	    node.params = [this.reinterpretTypeAsFunctionTypeParam(param)];
	    node.rest = null;
	    node.returnType = this.flowParseType();
	    node.typeParameters = null;
	    return this.finishNode(node, "FunctionTypeAnnotation");
	  }
	  return param;
	};
	
	pp$8.flowParseIntersectionType = function () {
	  var node = this.startNode();
	  this.eat(types.bitwiseAND);
	  var type = this.flowParseAnonFunctionWithoutParens();
	  node.types = [type];
	  while (this.eat(types.bitwiseAND)) {
	    node.types.push(this.flowParseAnonFunctionWithoutParens());
	  }
	  return node.types.length === 1 ? type : this.finishNode(node, "IntersectionTypeAnnotation");
	};
	
	pp$8.flowParseUnionType = function () {
	  var node = this.startNode();
	  this.eat(types.bitwiseOR);
	  var type = this.flowParseIntersectionType();
	  node.types = [type];
	  while (this.eat(types.bitwiseOR)) {
	    node.types.push(this.flowParseIntersectionType());
	  }
	  return node.types.length === 1 ? type : this.finishNode(node, "UnionTypeAnnotation");
	};
	
	pp$8.flowParseType = function () {
	  var oldInType = this.state.inType;
	  this.state.inType = true;
	  var type = this.flowParseUnionType();
	  this.state.inType = oldInType;
	  return type;
	};
	
	pp$8.flowParseTypeAnnotation = function () {
	  var node = this.startNode();
	  node.typeAnnotation = this.flowParseTypeInitialiser();
	  return this.finishNode(node, "TypeAnnotation");
	};
	
	pp$8.flowParseTypeAndPredicateAnnotation = function () {
	  var node = this.startNode();
	
	  var _flowParseTypeAndPred2 = this.flowParseTypeAndPredicateInitialiser();
	
	  node.typeAnnotation = _flowParseTypeAndPred2[0];
	  node.predicate = _flowParseTypeAndPred2[1];
	
	  return this.finishNode(node, "TypeAnnotation");
	};
	
	pp$8.flowParseTypeAnnotatableIdentifier = function () {
	  var ident = this.flowParseRestrictedIdentifier();
	  if (this.match(types.colon)) {
	    ident.typeAnnotation = this.flowParseTypeAnnotation();
	    this.finishNode(ident, ident.type);
	  }
	  return ident;
	};
	
	pp$8.typeCastToParameter = function (node) {
	  node.expression.typeAnnotation = node.typeAnnotation;
	
	  return this.finishNodeAt(node.expression, node.expression.type, node.typeAnnotation.end, node.typeAnnotation.loc.end);
	};
	
	pp$8.flowParseVariance = function () {
	  var variance = null;
	  if (this.match(types.plusMin)) {
	    if (this.state.value === "+") {
	      variance = "plus";
	    } else if (this.state.value === "-") {
	      variance = "minus";
	    }
	    this.next();
	  }
	  return variance;
	};
	
	var flowPlugin = function (instance) {
	  // plain function return types: function name(): string {}
	  instance.extend("parseFunctionBody", function (inner) {
	    return function (node, allowExpression) {
	      if (this.match(types.colon) && !allowExpression) {
	        // if allowExpression is true then we're parsing an arrow function and if
	        // there's a return type then it's been handled elsewhere
	        node.returnType = this.flowParseTypeAndPredicateAnnotation();
	      }
	
	      return inner.call(this, node, allowExpression);
	    };
	  });
	
	  // interfaces
	  instance.extend("parseStatement", function (inner) {
	    return function (declaration, topLevel) {
	      // strict mode handling of `interface` since it's a reserved word
	      if (this.state.strict && this.match(types.name) && this.state.value === "interface") {
	        var node = this.startNode();
	        this.next();
	        return this.flowParseInterface(node);
	      } else {
	        return inner.call(this, declaration, topLevel);
	      }
	    };
	  });
	
	  // declares, interfaces and type aliases
	  instance.extend("parseExpressionStatement", function (inner) {
	    return function (node, expr) {
	      if (expr.type === "Identifier") {
	        if (expr.name === "declare") {
	          if (this.match(types._class) || this.match(types.name) || this.match(types._function) || this.match(types._var) || this.match(types._export)) {
	            return this.flowParseDeclare(node);
	          }
	        } else if (this.match(types.name)) {
	          if (expr.name === "interface") {
	            return this.flowParseInterface(node);
	          } else if (expr.name === "type") {
	            return this.flowParseTypeAlias(node);
	          } else if (expr.name === "opaque") {
	            return this.flowParseOpaqueType(node, false);
	          }
	        }
	      }
	
	      return inner.call(this, node, expr);
	    };
	  });
	
	  // export type
	  instance.extend("shouldParseExportDeclaration", function (inner) {
	    return function () {
	      return this.isContextual("type") || this.isContextual("interface") || this.isContextual("opaque") || inner.call(this);
	    };
	  });
	
	  instance.extend("isExportDefaultSpecifier", function (inner) {
	    return function () {
	      if (this.match(types.name) && (this.state.value === "type" || this.state.value === "interface" || this.state.value === "opaque")) {
	        return false;
	      }
	
	      return inner.call(this);
	    };
	  });
	
	  instance.extend("parseConditional", function (inner) {
	    return function (expr, noIn, startPos, startLoc, refNeedsArrowPos) {
	      // only do the expensive clone if there is a question mark
	      // and if we come from inside parens
	      if (refNeedsArrowPos && this.match(types.question)) {
	        var state = this.state.clone();
	        try {
	          return inner.call(this, expr, noIn, startPos, startLoc);
	        } catch (err) {
	          if (err instanceof SyntaxError) {
	            this.state = state;
	            refNeedsArrowPos.start = err.pos || this.state.start;
	            return expr;
	          } else {
	            // istanbul ignore next: no such error is expected
	            throw err;
	          }
	        }
	      }
	
	      return inner.call(this, expr, noIn, startPos, startLoc);
	    };
	  });
	
	  instance.extend("parseParenItem", function (inner) {
	    return function (node, startPos, startLoc) {
	      node = inner.call(this, node, startPos, startLoc);
	      if (this.eat(types.question)) {
	        node.optional = true;
	      }
	
	      if (this.match(types.colon)) {
	        var typeCastNode = this.startNodeAt(startPos, startLoc);
	        typeCastNode.expression = node;
	        typeCastNode.typeAnnotation = this.flowParseTypeAnnotation();
	
	        return this.finishNode(typeCastNode, "TypeCastExpression");
	      }
	
	      return node;
	    };
	  });
	
	  instance.extend("parseExport", function (inner) {
	    return function (node) {
	      node = inner.call(this, node);
	      if (node.type === "ExportNamedDeclaration") {
	        node.exportKind = node.exportKind || "value";
	      }
	      return node;
	    };
	  });
	
	  instance.extend("parseExportDeclaration", function (inner) {
	    return function (node) {
	      if (this.isContextual("type")) {
	        node.exportKind = "type";
	
	        var declarationNode = this.startNode();
	        this.next();
	
	        if (this.match(types.braceL)) {
	          // export type { foo, bar };
	          node.specifiers = this.parseExportSpecifiers();
	          this.parseExportFrom(node);
	          return null;
	        } else {
	          // export type Foo = Bar;
	          return this.flowParseTypeAlias(declarationNode);
	        }
	      } else if (this.isContextual("opaque")) {
	        node.exportKind = "type";
	
	        var _declarationNode = this.startNode();
	        this.next();
	        // export opaque type Foo = Bar;
	        return this.flowParseOpaqueType(_declarationNode, false);
	      } else if (this.isContextual("interface")) {
	        node.exportKind = "type";
	        var _declarationNode2 = this.startNode();
	        this.next();
	        return this.flowParseInterface(_declarationNode2);
	      } else {
	        return inner.call(this, node);
	      }
	    };
	  });
	
	  instance.extend("parseClassId", function (inner) {
	    return function (node) {
	      inner.apply(this, arguments);
	      if (this.isRelational("<")) {
	        node.typeParameters = this.flowParseTypeParameterDeclaration();
	      }
	    };
	  });
	
	  // don't consider `void` to be a keyword as then it'll use the void token type
	  // and set startExpr
	  instance.extend("isKeyword", function (inner) {
	    return function (name) {
	      if (this.state.inType && name === "void") {
	        return false;
	      } else {
	        return inner.call(this, name);
	      }
	    };
	  });
	
	  // ensure that inside flow types, we bypass the jsx parser plugin
	  instance.extend("readToken", function (inner) {
	    return function (code) {
	      if (this.state.inType && (code === 62 || code === 60)) {
	        return this.finishOp(types.relational, 1);
	      } else {
	        return inner.call(this, code);
	      }
	    };
	  });
	
	  // don't lex any token as a jsx one inside a flow type
	  instance.extend("jsx_readToken", function (inner) {
	    return function () {
	      if (!this.state.inType) return inner.call(this);
	    };
	  });
	
	  instance.extend("toAssignable", function (inner) {
	    return function (node, isBinding, contextDescription) {
	      if (node.type === "TypeCastExpression") {
	        return inner.call(this, this.typeCastToParameter(node), isBinding, contextDescription);
	      } else {
	        return inner.call(this, node, isBinding, contextDescription);
	      }
	    };
	  });
	
	  // turn type casts that we found in function parameter head into type annotated params
	  instance.extend("toAssignableList", function (inner) {
	    return function (exprList, isBinding, contextDescription) {
	      for (var i = 0; i < exprList.length; i++) {
	        var expr = exprList[i];
	        if (expr && expr.type === "TypeCastExpression") {
	          exprList[i] = this.typeCastToParameter(expr);
	        }
	      }
	      return inner.call(this, exprList, isBinding, contextDescription);
	    };
	  });
	
	  // this is a list of nodes, from something like a call expression, we need to filter the
	  // type casts that we've found that are illegal in this context
	  instance.extend("toReferencedList", function () {
	    return function (exprList) {
	      for (var i = 0; i < exprList.length; i++) {
	        var expr = exprList[i];
	        if (expr && expr._exprListItem && expr.type === "TypeCastExpression") {
	          this.raise(expr.start, "Unexpected type cast");
	        }
	      }
	
	      return exprList;
	    };
	  });
	
	  // parse an item inside a expression list eg. `(NODE, NODE)` where NODE represents
	  // the position where this function is called
	  instance.extend("parseExprListItem", function (inner) {
	    return function () {
	      var container = this.startNode();
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var node = inner.call.apply(inner, [this].concat(args));
	      if (this.match(types.colon)) {
	        container._exprListItem = true;
	        container.expression = node;
	        container.typeAnnotation = this.flowParseTypeAnnotation();
	        return this.finishNode(container, "TypeCastExpression");
	      } else {
	        return node;
	      }
	    };
	  });
	
	  instance.extend("checkLVal", function (inner) {
	    return function (node) {
	      if (node.type !== "TypeCastExpression") {
	        return inner.apply(this, arguments);
	      }
	    };
	  });
	
	  // parse class property type annotations
	  instance.extend("parseClassProperty", function (inner) {
	    return function (node) {
	      delete node.variancePos;
	      if (this.match(types.colon)) {
	        node.typeAnnotation = this.flowParseTypeAnnotation();
	      }
	      return inner.call(this, node);
	    };
	  });
	
	  // determine whether or not we're currently in the position where a class method would appear
	  instance.extend("isClassMethod", function (inner) {
	    return function () {
	      return this.isRelational("<") || inner.call(this);
	    };
	  });
	
	  // determine whether or not we're currently in the position where a class property would appear
	  instance.extend("isClassProperty", function (inner) {
	    return function () {
	      return this.match(types.colon) || inner.call(this);
	    };
	  });
	
	  instance.extend("isNonstaticConstructor", function (inner) {
	    return function (method) {
	      return !this.match(types.colon) && inner.call(this, method);
	    };
	  });
	
	  // parse type parameters for class methods
	  instance.extend("parseClassMethod", function (inner) {
	    return function (classBody, method) {
	      if (method.variance) {
	        this.unexpected(method.variancePos);
	      }
	      delete method.variance;
	      delete method.variancePos;
	      if (this.isRelational("<")) {
	        method.typeParameters = this.flowParseTypeParameterDeclaration();
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      inner.call.apply(inner, [this, classBody, method].concat(args));
	    };
	  });
	
	  // parse a the super class type parameters and implements
	  instance.extend("parseClassSuper", function (inner) {
	    return function (node, isStatement) {
	      inner.call(this, node, isStatement);
	      if (node.superClass && this.isRelational("<")) {
	        node.superTypeParameters = this.flowParseTypeParameterInstantiation();
	      }
	      if (this.isContextual("implements")) {
	        this.next();
	        var implemented = node.implements = [];
	        do {
	          var _node = this.startNode();
	          _node.id = this.parseIdentifier();
	          if (this.isRelational("<")) {
	            _node.typeParameters = this.flowParseTypeParameterInstantiation();
	          } else {
	            _node.typeParameters = null;
	          }
	          implemented.push(this.finishNode(_node, "ClassImplements"));
	        } while (this.eat(types.comma));
	      }
	    };
	  });
	
	  instance.extend("parsePropertyName", function (inner) {
	    return function (node) {
	      var variancePos = this.state.start;
	      var variance = this.flowParseVariance();
	      var key = inner.call(this, node);
	      node.variance = variance;
	      node.variancePos = variancePos;
	      return key;
	    };
	  });
	
	  // parse type parameters for object method shorthand
	  instance.extend("parseObjPropValue", function (inner) {
	    return function (prop) {
	      if (prop.variance) {
	        this.unexpected(prop.variancePos);
	      }
	      delete prop.variance;
	      delete prop.variancePos;
	
	      var typeParameters = void 0;
	
	      // method shorthand
	      if (this.isRelational("<")) {
	        typeParameters = this.flowParseTypeParameterDeclaration();
	        if (!this.match(types.parenL)) this.unexpected();
	      }
	
	      inner.apply(this, arguments);
	
	      // add typeParameters if we found them
	      if (typeParameters) {
	        (prop.value || prop).typeParameters = typeParameters;
	      }
	    };
	  });
	
	  instance.extend("parseAssignableListItemTypes", function () {
	    return function (param) {
	      if (this.eat(types.question)) {
	        param.optional = true;
	      }
	      if (this.match(types.colon)) {
	        param.typeAnnotation = this.flowParseTypeAnnotation();
	      }
	      this.finishNode(param, param.type);
	      return param;
	    };
	  });
	
	  instance.extend("parseMaybeDefault", function (inner) {
	    return function () {
	      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      var node = inner.apply(this, args);
	
	      if (node.type === "AssignmentPattern" && node.typeAnnotation && node.right.start < node.typeAnnotation.start) {
	        this.raise(node.typeAnnotation.start, "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`");
	      }
	
	      return node;
	    };
	  });
	
	  // parse typeof and type imports
	  instance.extend("parseImportSpecifiers", function (inner) {
	    return function (node) {
	      node.importKind = "value";
	
	      var kind = null;
	      if (this.match(types._typeof)) {
	        kind = "typeof";
	      } else if (this.isContextual("type")) {
	        kind = "type";
	      }
	      if (kind) {
	        var lh = this.lookahead();
	        if (lh.type === types.name && lh.value !== "from" || lh.type === types.braceL || lh.type === types.star) {
	          this.next();
	          node.importKind = kind;
	        }
	      }
	
	      inner.call(this, node);
	    };
	  });
	
	  // parse import-type/typeof shorthand
	  instance.extend("parseImportSpecifier", function () {
	    return function (node) {
	      var specifier = this.startNode();
	      var firstIdentLoc = this.state.start;
	      var firstIdent = this.parseIdentifier(true);
	
	      var specifierTypeKind = null;
	      if (firstIdent.name === "type") {
	        specifierTypeKind = "type";
	      } else if (firstIdent.name === "typeof") {
	        specifierTypeKind = "typeof";
	      }
	
	      var isBinding = false;
	      if (this.isContextual("as")) {
	        var as_ident = this.parseIdentifier(true);
	        if (specifierTypeKind !== null && !this.match(types.name) && !this.state.type.keyword) {
	          // `import {type as ,` or `import {type as }`
	          specifier.imported = as_ident;
	          specifier.importKind = specifierTypeKind;
	          specifier.local = as_ident.__clone();
	        } else {
	          // `import {type as foo`
	          specifier.imported = firstIdent;
	          specifier.importKind = null;
	          specifier.local = this.parseIdentifier();
	        }
	      } else if (specifierTypeKind !== null && (this.match(types.name) || this.state.type.keyword)) {
	        // `import {type foo`
	        specifier.imported = this.parseIdentifier(true);
	        specifier.importKind = specifierTypeKind;
	        if (this.eatContextual("as")) {
	          specifier.local = this.parseIdentifier();
	        } else {
	          isBinding = true;
	          specifier.local = specifier.imported.__clone();
	        }
	      } else {
	        isBinding = true;
	        specifier.imported = firstIdent;
	        specifier.importKind = null;
	        specifier.local = specifier.imported.__clone();
	      }
	
	      if ((node.importKind === "type" || node.importKind === "typeof") && (specifier.importKind === "type" || specifier.importKind === "typeof")) {
	        this.raise(firstIdentLoc, "`The `type` and `typeof` keywords on named imports can only be used on regular `import` statements. It cannot be used with `import type` or `import typeof` statements`");
	      }
	
	      if (isBinding) this.checkReservedWord(specifier.local.name, specifier.start, true, true);
	
	      this.checkLVal(specifier.local, true, undefined, "import specifier");
	      node.specifiers.push(this.finishNode(specifier, "ImportSpecifier"));
	    };
	  });
	
	  // parse function type parameters - function foo<T>() {}
	  instance.extend("parseFunctionParams", function (inner) {
	    return function (node) {
	      if (this.isRelational("<")) {
	        node.typeParameters = this.flowParseTypeParameterDeclaration();
	      }
	      inner.call(this, node);
	    };
	  });
	
	  // parse flow type annotations on variable declarator heads - let foo: string = bar
	  instance.extend("parseVarHead", function (inner) {
	    return function (decl) {
	      inner.call(this, decl);
	      if (this.match(types.colon)) {
	        decl.id.typeAnnotation = this.flowParseTypeAnnotation();
	        this.finishNode(decl.id, decl.id.type);
	      }
	    };
	  });
	
	  // parse the return type of an async arrow function - let foo = (async (): number => {});
	  instance.extend("parseAsyncArrowFromCallExpression", function (inner) {
	    return function (node, call) {
	      if (this.match(types.colon)) {
	        var oldNoAnonFunctionType = this.state.noAnonFunctionType;
	        this.state.noAnonFunctionType = true;
	        node.returnType = this.flowParseTypeAnnotation();
	        this.state.noAnonFunctionType = oldNoAnonFunctionType;
	      }
	
	      return inner.call(this, node, call);
	    };
	  });
	
	  // todo description
	  instance.extend("shouldParseAsyncArrow", function (inner) {
	    return function () {
	      return this.match(types.colon) || inner.call(this);
	    };
	  });
	
	  // We need to support type parameter declarations for arrow functions. This
	  // is tricky. There are three situations we need to handle
	  //
	  // 1. This is either JSX or an arrow function. We'll try JSX first. If that
	  //    fails, we'll try an arrow function. If that fails, we'll throw the JSX
	  //    error.
	  // 2. This is an arrow function. We'll parse the type parameter declaration,
	  //    parse the rest, make sure the rest is an arrow function, and go from
	  //    there
	  // 3. This is neither. Just call the inner function
	  instance.extend("parseMaybeAssign", function (inner) {
	    return function () {
	      var jsxError = null;
	
	      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      if (types.jsxTagStart && this.match(types.jsxTagStart)) {
	        var state = this.state.clone();
	        try {
	          return inner.apply(this, args);
	        } catch (err) {
	          if (err instanceof SyntaxError) {
	            this.state = state;
	
	            // Remove `tc.j_expr` and `tc.j_oTag` from context added
	            // by parsing `jsxTagStart` to stop the JSX plugin from
	            // messing with the tokens
	            this.state.context.length -= 2;
	
	            jsxError = err;
	          } else {
	            // istanbul ignore next: no such error is expected
	            throw err;
	          }
	        }
	      }
	
	      if (jsxError != null || this.isRelational("<")) {
	        var arrowExpression = void 0;
	        var typeParameters = void 0;
	        try {
	          typeParameters = this.flowParseTypeParameterDeclaration();
	
	          arrowExpression = inner.apply(this, args);
	          arrowExpression.typeParameters = typeParameters;
	          arrowExpression.start = typeParameters.start;
	          arrowExpression.loc.start = typeParameters.loc.start;
	        } catch (err) {
	          throw jsxError || err;
	        }
	
	        if (arrowExpression.type === "ArrowFunctionExpression") {
	          return arrowExpression;
	        } else if (jsxError != null) {
	          throw jsxError;
	        } else {
	          this.raise(typeParameters.start, "Expected an arrow function after this type parameter declaration");
	        }
	      }
	
	      return inner.apply(this, args);
	    };
	  });
	
	  // handle return types for arrow functions
	  instance.extend("parseArrow", function (inner) {
	    return function (node) {
	      if (this.match(types.colon)) {
	        var state = this.state.clone();
	        try {
	          var oldNoAnonFunctionType = this.state.noAnonFunctionType;
	          this.state.noAnonFunctionType = true;
	          var returnType = this.flowParseTypeAndPredicateAnnotation();
	          this.state.noAnonFunctionType = oldNoAnonFunctionType;
	
	          if (this.canInsertSemicolon()) this.unexpected();
	          if (!this.match(types.arrow)) this.unexpected();
	          // assign after it is clear it is an arrow
	          node.returnType = returnType;
	        } catch (err) {
	          if (err instanceof SyntaxError) {
	            this.state = state;
	          } else {
	            // istanbul ignore next: no such error is expected
	            throw err;
	          }
	        }
	      }
	
	      return inner.call(this, node);
	    };
	  });
	
	  instance.extend("shouldParseArrow", function (inner) {
	    return function () {
	      return this.match(types.colon) || inner.call(this);
	    };
	  });
	};
	
	// Adapted from String.fromcodepoint to export the function without modifying String
	/*! https://mths.be/fromcodepoint v0.2.1 by @mathias */
	
	// The MIT License (MIT)
	// Copyright (c) Mathias Bynens
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
	// associated documentation files (the "Software"), to deal in the Software without restriction,
	// including without limitation the rights to use, copy, modify, merge, publish, distribute,
	// sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in all copies or
	// substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
	// NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var fromCodePoint = String.fromCodePoint;
	
	if (!fromCodePoint) {
	  var stringFromCharCode = String.fromCharCode;
	  var floor = Math.floor;
	  fromCodePoint = function fromCodePoint() {
	    var MAX_SIZE = 0x4000;
	    var codeUnits = [];
	    var highSurrogate = void 0;
	    var lowSurrogate = void 0;
	    var index = -1;
	    var length = arguments.length;
	    if (!length) {
	      return "";
	    }
	    var result = "";
	    while (++index < length) {
	      var codePoint = Number(arguments[index]);
	      if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
	      codePoint < 0 || // not a valid Unicode code point
	      codePoint > 0x10FFFF || // not a valid Unicode code point
	      floor(codePoint) != codePoint // not an integer
	      ) {
	          throw RangeError("Invalid code point: " + codePoint);
	        }
	      if (codePoint <= 0xFFFF) {
	        // BMP code point
	        codeUnits.push(codePoint);
	      } else {
	        // Astral code point; split in surrogate halves
	        // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	        codePoint -= 0x10000;
	        highSurrogate = (codePoint >> 10) + 0xD800;
	        lowSurrogate = codePoint % 0x400 + 0xDC00;
	        codeUnits.push(highSurrogate, lowSurrogate);
	      }
	      if (index + 1 == length || codeUnits.length > MAX_SIZE) {
	        result += stringFromCharCode.apply(null, codeUnits);
	        codeUnits.length = 0;
	      }
	    }
	    return result;
	  };
	}
	
	var fromCodePoint$1 = fromCodePoint;
	
	var XHTMLEntities = {
	  quot: "\"",
	  amp: "&",
	  apos: "'",
	  lt: "<",
	  gt: ">",
	  nbsp: "\xA0",
	  iexcl: "\xA1",
	  cent: "\xA2",
	  pound: "\xA3",
	  curren: "\xA4",
	  yen: "\xA5",
	  brvbar: "\xA6",
	  sect: "\xA7",
	  uml: "\xA8",
	  copy: "\xA9",
	  ordf: "\xAA",
	  laquo: "\xAB",
	  not: "\xAC",
	  shy: "\xAD",
	  reg: "\xAE",
	  macr: "\xAF",
	  deg: "\xB0",
	  plusmn: "\xB1",
	  sup2: "\xB2",
	  sup3: "\xB3",
	  acute: "\xB4",
	  micro: "\xB5",
	  para: "\xB6",
	  middot: "\xB7",
	  cedil: "\xB8",
	  sup1: "\xB9",
	  ordm: "\xBA",
	  raquo: "\xBB",
	  frac14: "\xBC",
	  frac12: "\xBD",
	  frac34: "\xBE",
	  iquest: "\xBF",
	  Agrave: "\xC0",
	  Aacute: "\xC1",
	  Acirc: "\xC2",
	  Atilde: "\xC3",
	  Auml: "\xC4",
	  Aring: "\xC5",
	  AElig: "\xC6",
	  Ccedil: "\xC7",
	  Egrave: "\xC8",
	  Eacute: "\xC9",
	  Ecirc: "\xCA",
	  Euml: "\xCB",
	  Igrave: "\xCC",
	  Iacute: "\xCD",
	  Icirc: "\xCE",
	  Iuml: "\xCF",
	  ETH: "\xD0",
	  Ntilde: "\xD1",
	  Ograve: "\xD2",
	  Oacute: "\xD3",
	  Ocirc: "\xD4",
	  Otilde: "\xD5",
	  Ouml: "\xD6",
	  times: "\xD7",
	  Oslash: "\xD8",
	  Ugrave: "\xD9",
	  Uacute: "\xDA",
	  Ucirc: "\xDB",
	  Uuml: "\xDC",
	  Yacute: "\xDD",
	  THORN: "\xDE",
	  szlig: "\xDF",
	  agrave: "\xE0",
	  aacute: "\xE1",
	  acirc: "\xE2",
	  atilde: "\xE3",
	  auml: "\xE4",
	  aring: "\xE5",
	  aelig: "\xE6",
	  ccedil: "\xE7",
	  egrave: "\xE8",
	  eacute: "\xE9",
	  ecirc: "\xEA",
	  euml: "\xEB",
	  igrave: "\xEC",
	  iacute: "\xED",
	  icirc: "\xEE",
	  iuml: "\xEF",
	  eth: "\xF0",
	  ntilde: "\xF1",
	  ograve: "\xF2",
	  oacute: "\xF3",
	  ocirc: "\xF4",
	  otilde: "\xF5",
	  ouml: "\xF6",
	  divide: "\xF7",
	  oslash: "\xF8",
	  ugrave: "\xF9",
	  uacute: "\xFA",
	  ucirc: "\xFB",
	  uuml: "\xFC",
	  yacute: "\xFD",
	  thorn: "\xFE",
	  yuml: "\xFF",
	  OElig: "\u0152",
	  oelig: "\u0153",
	  Scaron: "\u0160",
	  scaron: "\u0161",
	  Yuml: "\u0178",
	  fnof: "\u0192",
	  circ: "\u02C6",
	  tilde: "\u02DC",
	  Alpha: "\u0391",
	  Beta: "\u0392",
	  Gamma: "\u0393",
	  Delta: "\u0394",
	  Epsilon: "\u0395",
	  Zeta: "\u0396",
	  Eta: "\u0397",
	  Theta: "\u0398",
	  Iota: "\u0399",
	  Kappa: "\u039A",
	  Lambda: "\u039B",
	  Mu: "\u039C",
	  Nu: "\u039D",
	  Xi: "\u039E",
	  Omicron: "\u039F",
	  Pi: "\u03A0",
	  Rho: "\u03A1",
	  Sigma: "\u03A3",
	  Tau: "\u03A4",
	  Upsilon: "\u03A5",
	  Phi: "\u03A6",
	  Chi: "\u03A7",
	  Psi: "\u03A8",
	  Omega: "\u03A9",
	  alpha: "\u03B1",
	  beta: "\u03B2",
	  gamma: "\u03B3",
	  delta: "\u03B4",
	  epsilon: "\u03B5",
	  zeta: "\u03B6",
	  eta: "\u03B7",
	  theta: "\u03B8",
	  iota: "\u03B9",
	  kappa: "\u03BA",
	  lambda: "\u03BB",
	  mu: "\u03BC",
	  nu: "\u03BD",
	  xi: "\u03BE",
	  omicron: "\u03BF",
	  pi: "\u03C0",
	  rho: "\u03C1",
	  sigmaf: "\u03C2",
	  sigma: "\u03C3",
	  tau: "\u03C4",
	  upsilon: "\u03C5",
	  phi: "\u03C6",
	  chi: "\u03C7",
	  psi: "\u03C8",
	  omega: "\u03C9",
	  thetasym: "\u03D1",
	  upsih: "\u03D2",
	  piv: "\u03D6",
	  ensp: "\u2002",
	  emsp: "\u2003",
	  thinsp: "\u2009",
	  zwnj: "\u200C",
	  zwj: "\u200D",
	  lrm: "\u200E",
	  rlm: "\u200F",
	  ndash: "\u2013",
	  mdash: "\u2014",
	  lsquo: "\u2018",
	  rsquo: "\u2019",
	  sbquo: "\u201A",
	  ldquo: "\u201C",
	  rdquo: "\u201D",
	  bdquo: "\u201E",
	  dagger: "\u2020",
	  Dagger: "\u2021",
	  bull: "\u2022",
	  hellip: "\u2026",
	  permil: "\u2030",
	  prime: "\u2032",
	  Prime: "\u2033",
	  lsaquo: "\u2039",
	  rsaquo: "\u203A",
	  oline: "\u203E",
	  frasl: "\u2044",
	  euro: "\u20AC",
	  image: "\u2111",
	  weierp: "\u2118",
	  real: "\u211C",
	  trade: "\u2122",
	  alefsym: "\u2135",
	  larr: "\u2190",
	  uarr: "\u2191",
	  rarr: "\u2192",
	  darr: "\u2193",
	  harr: "\u2194",
	  crarr: "\u21B5",
	  lArr: "\u21D0",
	  uArr: "\u21D1",
	  rArr: "\u21D2",
	  dArr: "\u21D3",
	  hArr: "\u21D4",
	  forall: "\u2200",
	  part: "\u2202",
	  exist: "\u2203",
	  empty: "\u2205",
	  nabla: "\u2207",
	  isin: "\u2208",
	  notin: "\u2209",
	  ni: "\u220B",
	  prod: "\u220F",
	  sum: "\u2211",
	  minus: "\u2212",
	  lowast: "\u2217",
	  radic: "\u221A",
	  prop: "\u221D",
	  infin: "\u221E",
	  ang: "\u2220",
	  and: "\u2227",
	  or: "\u2228",
	  cap: "\u2229",
	  cup: "\u222A",
	  "int": "\u222B",
	  there4: "\u2234",
	  sim: "\u223C",
	  cong: "\u2245",
	  asymp: "\u2248",
	  ne: "\u2260",
	  equiv: "\u2261",
	  le: "\u2264",
	  ge: "\u2265",
	  sub: "\u2282",
	  sup: "\u2283",
	  nsub: "\u2284",
	  sube: "\u2286",
	  supe: "\u2287",
	  oplus: "\u2295",
	  otimes: "\u2297",
	  perp: "\u22A5",
	  sdot: "\u22C5",
	  lceil: "\u2308",
	  rceil: "\u2309",
	  lfloor: "\u230A",
	  rfloor: "\u230B",
	  lang: "\u2329",
	  rang: "\u232A",
	  loz: "\u25CA",
	  spades: "\u2660",
	  clubs: "\u2663",
	  hearts: "\u2665",
	  diams: "\u2666"
	};
	
	var HEX_NUMBER = /^[\da-fA-F]+$/;
	var DECIMAL_NUMBER = /^\d+$/;
	
	types$1.j_oTag = new TokContext("<tag", false);
	types$1.j_cTag = new TokContext("</tag", false);
	types$1.j_expr = new TokContext("<tag>...</tag>", true, true);
	
	types.jsxName = new TokenType("jsxName");
	types.jsxText = new TokenType("jsxText", { beforeExpr: true });
	types.jsxTagStart = new TokenType("jsxTagStart", { startsExpr: true });
	types.jsxTagEnd = new TokenType("jsxTagEnd");
	
	types.jsxTagStart.updateContext = function () {
	  this.state.context.push(types$1.j_expr); // treat as beginning of JSX expression
	  this.state.context.push(types$1.j_oTag); // start opening tag context
	  this.state.exprAllowed = false;
	};
	
	types.jsxTagEnd.updateContext = function (prevType) {
	  var out = this.state.context.pop();
	  if (out === types$1.j_oTag && prevType === types.slash || out === types$1.j_cTag) {
	    this.state.context.pop();
	    this.state.exprAllowed = this.curContext() === types$1.j_expr;
	  } else {
	    this.state.exprAllowed = true;
	  }
	};
	
	var pp$9 = Parser.prototype;
	
	// Reads inline JSX contents token.
	
	pp$9.jsxReadToken = function () {
	  var out = "";
	  var chunkStart = this.state.pos;
	  for (;;) {
	    if (this.state.pos >= this.input.length) {
	      this.raise(this.state.start, "Unterminated JSX contents");
	    }
	
	    var ch = this.input.charCodeAt(this.state.pos);
	
	    switch (ch) {
	      case 60: // "<"
	      case 123:
	        // "{"
	        if (this.state.pos === this.state.start) {
	          if (ch === 60 && this.state.exprAllowed) {
	            ++this.state.pos;
	            return this.finishToken(types.jsxTagStart);
	          }
	          return this.getTokenFromCode(ch);
	        }
	        out += this.input.slice(chunkStart, this.state.pos);
	        return this.finishToken(types.jsxText, out);
	
	      case 38:
	        // "&"
	        out += this.input.slice(chunkStart, this.state.pos);
	        out += this.jsxReadEntity();
	        chunkStart = this.state.pos;
	        break;
	
	      default:
	        if (isNewLine(ch)) {
	          out += this.input.slice(chunkStart, this.state.pos);
	          out += this.jsxReadNewLine(true);
	          chunkStart = this.state.pos;
	        } else {
	          ++this.state.pos;
	        }
	    }
	  }
	};
	
	pp$9.jsxReadNewLine = function (normalizeCRLF) {
	  var ch = this.input.charCodeAt(this.state.pos);
	  var out = void 0;
	  ++this.state.pos;
	  if (ch === 13 && this.input.charCodeAt(this.state.pos) === 10) {
	    ++this.state.pos;
	    out = normalizeCRLF ? "\n" : "\r\n";
	  } else {
	    out = String.fromCharCode(ch);
	  }
	  ++this.state.curLine;
	  this.state.lineStart = this.state.pos;
	
	  return out;
	};
	
	pp$9.jsxReadString = function (quote) {
	  var out = "";
	  var chunkStart = ++this.state.pos;
	  for (;;) {
	    if (this.state.pos >= this.input.length) {
	      this.raise(this.state.start, "Unterminated string constant");
	    }
	
	    var ch = this.input.charCodeAt(this.state.pos);
	    if (ch === quote) break;
	    if (ch === 38) {
	      // "&"
	      out += this.input.slice(chunkStart, this.state.pos);
	      out += this.jsxReadEntity();
	      chunkStart = this.state.pos;
	    } else if (isNewLine(ch)) {
	      out += this.input.slice(chunkStart, this.state.pos);
	      out += this.jsxReadNewLine(false);
	      chunkStart = this.state.pos;
	    } else {
	      ++this.state.pos;
	    }
	  }
	  out += this.input.slice(chunkStart, this.state.pos++);
	  return this.finishToken(types.string, out);
	};
	
	pp$9.jsxReadEntity = function () {
	  var str = "";
	  var count = 0;
	  var entity = void 0;
	  var ch = this.input[this.state.pos];
	
	  var startPos = ++this.state.pos;
	  while (this.state.pos < this.input.length && count++ < 10) {
	    ch = this.input[this.state.pos++];
	    if (ch === ";") {
	      if (str[0] === "#") {
	        if (str[1] === "x") {
	          str = str.substr(2);
	          if (HEX_NUMBER.test(str)) entity = fromCodePoint$1(parseInt(str, 16));
	        } else {
	          str = str.substr(1);
	          if (DECIMAL_NUMBER.test(str)) entity = fromCodePoint$1(parseInt(str, 10));
	        }
	      } else {
	        entity = XHTMLEntities[str];
	      }
	      break;
	    }
	    str += ch;
	  }
	  if (!entity) {
	    this.state.pos = startPos;
	    return "&";
	  }
	  return entity;
	};
	
	// Read a JSX identifier (valid tag or attribute name).
	//
	// Optimized version since JSX identifiers can"t contain
	// escape characters and so can be read as single slice.
	// Also assumes that first character was already checked
	// by isIdentifierStart in readToken.
	
	pp$9.jsxReadWord = function () {
	  var ch = void 0;
	  var start = this.state.pos;
	  do {
	    ch = this.input.charCodeAt(++this.state.pos);
	  } while (isIdentifierChar(ch) || ch === 45); // "-"
	  return this.finishToken(types.jsxName, this.input.slice(start, this.state.pos));
	};
	
	// Transforms JSX element name to string.
	
	function getQualifiedJSXName(object) {
	  if (object.type === "JSXIdentifier") {
	    return object.name;
	  }
	
	  if (object.type === "JSXNamespacedName") {
	    return object.namespace.name + ":" + object.name.name;
	  }
	
	  if (object.type === "JSXMemberExpression") {
	    return getQualifiedJSXName(object.object) + "." + getQualifiedJSXName(object.property);
	  }
	}
	
	// Parse next token as JSX identifier
	
	pp$9.jsxParseIdentifier = function () {
	  var node = this.startNode();
	  if (this.match(types.jsxName)) {
	    node.name = this.state.value;
	  } else if (this.state.type.keyword) {
	    node.name = this.state.type.keyword;
	  } else {
	    this.unexpected();
	  }
	  this.next();
	  return this.finishNode(node, "JSXIdentifier");
	};
	
	// Parse namespaced identifier.
	
	pp$9.jsxParseNamespacedName = function () {
	  var startPos = this.state.start;
	  var startLoc = this.state.startLoc;
	  var name = this.jsxParseIdentifier();
	  if (!this.eat(types.colon)) return name;
	
	  var node = this.startNodeAt(startPos, startLoc);
	  node.namespace = name;
	  node.name = this.jsxParseIdentifier();
	  return this.finishNode(node, "JSXNamespacedName");
	};
	
	// Parses element name in any form - namespaced, member
	// or single identifier.
	
	pp$9.jsxParseElementName = function () {
	  var startPos = this.state.start;
	  var startLoc = this.state.startLoc;
	  var node = this.jsxParseNamespacedName();
	  while (this.eat(types.dot)) {
	    var newNode = this.startNodeAt(startPos, startLoc);
	    newNode.object = node;
	    newNode.property = this.jsxParseIdentifier();
	    node = this.finishNode(newNode, "JSXMemberExpression");
	  }
	  return node;
	};
	
	// Parses any type of JSX attribute value.
	
	pp$9.jsxParseAttributeValue = function () {
	  var node = void 0;
	  switch (this.state.type) {
	    case types.braceL:
	      node = this.jsxParseExpressionContainer();
	      if (node.expression.type === "JSXEmptyExpression") {
	        this.raise(node.start, "JSX attributes must only be assigned a non-empty expression");
	      } else {
	        return node;
	      }
	
	    case types.jsxTagStart:
	    case types.string:
	      node = this.parseExprAtom();
	      node.extra = null;
	      return node;
	
	    default:
	      this.raise(this.state.start, "JSX value should be either an expression or a quoted JSX text");
	  }
	};
	
	// JSXEmptyExpression is unique type since it doesn't actually parse anything,
	// and so it should start at the end of last read token (left brace) and finish
	// at the beginning of the next one (right brace).
	
	pp$9.jsxParseEmptyExpression = function () {
	  var node = this.startNodeAt(this.state.lastTokEnd, this.state.lastTokEndLoc);
	  return this.finishNodeAt(node, "JSXEmptyExpression", this.state.start, this.state.startLoc);
	};
	
	// Parse JSX spread child
	
	pp$9.jsxParseSpreadChild = function () {
	  var node = this.startNode();
	  this.expect(types.braceL);
	  this.expect(types.ellipsis);
	  node.expression = this.parseExpression();
	  this.expect(types.braceR);
	
	  return this.finishNode(node, "JSXSpreadChild");
	};
	
	// Parses JSX expression enclosed into curly brackets.
	
	
	pp$9.jsxParseExpressionContainer = function () {
	  var node = this.startNode();
	  this.next();
	  if (this.match(types.braceR)) {
	    node.expression = this.jsxParseEmptyExpression();
	  } else {
	    node.expression = this.parseExpression();
	  }
	  this.expect(types.braceR);
	  return this.finishNode(node, "JSXExpressionContainer");
	};
	
	// Parses following JSX attribute name-value pair.
	
	pp$9.jsxParseAttribute = function () {
	  var node = this.startNode();
	  if (this.eat(types.braceL)) {
	    this.expect(types.ellipsis);
	    node.argument = this.parseMaybeAssign();
	    this.expect(types.braceR);
	    return this.finishNode(node, "JSXSpreadAttribute");
	  }
	  node.name = this.jsxParseNamespacedName();
	  node.value = this.eat(types.eq) ? this.jsxParseAttributeValue() : null;
	  return this.finishNode(node, "JSXAttribute");
	};
	
	// Parses JSX opening tag starting after "<".
	
	pp$9.jsxParseOpeningElementAt = function (startPos, startLoc) {
	  var node = this.startNodeAt(startPos, startLoc);
	  node.attributes = [];
	  node.name = this.jsxParseElementName();
	  while (!this.match(types.slash) && !this.match(types.jsxTagEnd)) {
	    node.attributes.push(this.jsxParseAttribute());
	  }
	  node.selfClosing = this.eat(types.slash);
	  this.expect(types.jsxTagEnd);
	  return this.finishNode(node, "JSXOpeningElement");
	};
	
	// Parses JSX closing tag starting after "</".
	
	pp$9.jsxParseClosingElementAt = function (startPos, startLoc) {
	  var node = this.startNodeAt(startPos, startLoc);
	  node.name = this.jsxParseElementName();
	  this.expect(types.jsxTagEnd);
	  return this.finishNode(node, "JSXClosingElement");
	};
	
	// Parses entire JSX element, including it"s opening tag
	// (starting after "<"), attributes, contents and closing tag.
	
	pp$9.jsxParseElementAt = function (startPos, startLoc) {
	  var node = this.startNodeAt(startPos, startLoc);
	  var children = [];
	  var openingElement = this.jsxParseOpeningElementAt(startPos, startLoc);
	  var closingElement = null;
	
	  if (!openingElement.selfClosing) {
	    contents: for (;;) {
	      switch (this.state.type) {
	        case types.jsxTagStart:
	          startPos = this.state.start;startLoc = this.state.startLoc;
	          this.next();
	          if (this.eat(types.slash)) {
	            closingElement = this.jsxParseClosingElementAt(startPos, startLoc);
	            break contents;
	          }
	          children.push(this.jsxParseElementAt(startPos, startLoc));
	          break;
	
	        case types.jsxText:
	          children.push(this.parseExprAtom());
	          break;
	
	        case types.braceL:
	          if (this.lookahead().type === types.ellipsis) {
	            children.push(this.jsxParseSpreadChild());
	          } else {
	            children.push(this.jsxParseExpressionContainer());
	          }
	
	          break;
	
	        // istanbul ignore next - should never happen
	        default:
	          this.unexpected();
	      }
	    }
	
	    if (getQualifiedJSXName(closingElement.name) !== getQualifiedJSXName(openingElement.name)) {
	      this.raise(closingElement.start, "Expected corresponding JSX closing tag for <" + getQualifiedJSXName(openingElement.name) + ">");
	    }
	  }
	
	  node.openingElement = openingElement;
	  node.closingElement = closingElement;
	  node.children = children;
	  if (this.match(types.relational) && this.state.value === "<") {
	    this.raise(this.state.start, "Adjacent JSX elements must be wrapped in an enclosing tag");
	  }
	  return this.finishNode(node, "JSXElement");
	};
	
	// Parses entire JSX element from current position.
	
	pp$9.jsxParseElement = function () {
	  var startPos = this.state.start;
	  var startLoc = this.state.startLoc;
	  this.next();
	  return this.jsxParseElementAt(startPos, startLoc);
	};
	
	var jsxPlugin = function (instance) {
	  instance.extend("parseExprAtom", function (inner) {
	    return function (refShortHandDefaultPos) {
	      if (this.match(types.jsxText)) {
	        var node = this.parseLiteral(this.state.value, "JSXText");
	        // https://github.com/babel/babel/issues/2078
	        node.extra = null;
	        return node;
	      } else if (this.match(types.jsxTagStart)) {
	        return this.jsxParseElement();
	      } else {
	        return inner.call(this, refShortHandDefaultPos);
	      }
	    };
	  });
	
	  instance.extend("readToken", function (inner) {
	    return function (code) {
	      if (this.state.inPropertyName) return inner.call(this, code);
	
	      var context = this.curContext();
	
	      if (context === types$1.j_expr) {
	        return this.jsxReadToken();
	      }
	
	      if (context === types$1.j_oTag || context === types$1.j_cTag) {
	        if (isIdentifierStart(code)) {
	          return this.jsxReadWord();
	        }
	
	        if (code === 62) {
	          ++this.state.pos;
	          return this.finishToken(types.jsxTagEnd);
	        }
	
	        if ((code === 34 || code === 39) && context === types$1.j_oTag) {
	          return this.jsxReadString(code);
	        }
	      }
	
	      if (code === 60 && this.state.exprAllowed) {
	        ++this.state.pos;
	        return this.finishToken(types.jsxTagStart);
	      }
	
	      return inner.call(this, code);
	    };
	  });
	
	  instance.extend("updateContext", function (inner) {
	    return function (prevType) {
	      if (this.match(types.braceL)) {
	        var curContext = this.curContext();
	        if (curContext === types$1.j_oTag) {
	          this.state.context.push(types$1.braceExpression);
	        } else if (curContext === types$1.j_expr) {
	          this.state.context.push(types$1.templateQuasi);
	        } else {
	          inner.call(this, prevType);
	        }
	        this.state.exprAllowed = true;
	      } else if (this.match(types.slash) && prevType === types.jsxTagStart) {
	        this.state.context.length -= 2; // do not consider JSX expr -> JSX open tag -> ... anymore
	        this.state.context.push(types$1.j_cTag); // reconsider as closing tag context
	        this.state.exprAllowed = false;
	      } else {
	        return inner.call(this, prevType);
	      }
	    };
	  });
	};
	
	plugins.estree = estreePlugin;
	plugins.flow = flowPlugin;
	plugins.jsx = jsxPlugin;
	
	function parse(input, options) {
	  return new Parser(options, input).parse();
	}
	
	function parseExpression(input, options) {
	  var parser = new Parser(options, input);
	  if (parser.options.strictMode) {
	    parser.state.strict = true;
	  }
	  return parser.getExpression();
	}
	
	exports.parse = parse;
	exports.parseExpression = parseExpression;
	exports.tokTypes = types;


/***/ }),
/* 555 */
/***/ (function(module, exports) {

	/*!
	 * Chai - getActual utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/**
	 * ### .getActual(object, [actual])
	 *
	 * Returns the `actual` value for an Assertion.
	 *
	 * @param {Object} object (constructed Assertion)
	 * @param {Arguments} chai.Assertion.prototype.assert arguments
	 * @namespace Utils
	 * @name getActual
	 */
	
	module.exports = function getActual(obj, args) {
	  return args.length > 4 ? args[4] : obj._obj;
	};


/***/ }),
/* 556 */
/***/ (function(module, exports) {

	/*!
	 * Chai - getOwnEnumerablePropertySymbols utility
	 * Copyright(c) 2011-2016 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/**
	 * ### .getOwnEnumerablePropertySymbols(object)
	 *
	 * This allows the retrieval of directly-owned enumerable property symbols of an
	 * object. This function is necessary because Object.getOwnPropertySymbols
	 * returns both enumerable and non-enumerable property symbols.
	 *
	 * @param {Object} object
	 * @returns {Array}
	 * @namespace Utils
	 * @name getOwnEnumerablePropertySymbols
	 * @api public
	 */
	
	module.exports = function getOwnEnumerablePropertySymbols(obj) {
	  if (typeof Object.getOwnPropertySymbols !== 'function') return [];
	
	  return Object.getOwnPropertySymbols(obj).filter(function (sym) {
	    return Object.getOwnPropertyDescriptor(obj, sym).enumerable;
	  });
	};


/***/ }),
/* 557 */
/***/ (function(module, exports) {

	/*!
	 * Chai - getProperties utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/**
	 * ### .getProperties(object)
	 *
	 * This allows the retrieval of property names of an object, enumerable or not,
	 * inherited or not.
	 *
	 * @param {Object} object
	 * @returns {Array}
	 * @namespace Utils
	 * @name getProperties
	 * @api public
	 */
	
	module.exports = function getProperties(object) {
	  var result = Object.getOwnPropertyNames(object);
	
	  function addProperty(property) {
	    if (result.indexOf(property) === -1) {
	      result.push(property);
	    }
	  }
	
	  var proto = Object.getPrototypeOf(object);
	  while (proto !== null) {
	    Object.getOwnPropertyNames(proto).forEach(addProperty);
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return result;
	};


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Chai - flag utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/*!
	 * Module dependancies
	 */
	
	var inspect = __webpack_require__(287);
	var config = __webpack_require__(127);
	
	/**
	 * ### .objDisplay(object)
	 *
	 * Determines if an object or an array matches
	 * criteria to be inspected in-line for error
	 * messages or should be truncated.
	 *
	 * @param {Mixed} javascript object to inspect
	 * @name objDisplay
	 * @namespace Utils
	 * @api public
	 */
	
	module.exports = function objDisplay(obj) {
	  var str = inspect(obj)
	    , type = Object.prototype.toString.call(obj);
	
	  if (config.truncateThreshold && str.length >= config.truncateThreshold) {
	    if (type === '[object Function]') {
	      return !obj.name || obj.name === ''
	        ? '[Function]'
	        : '[Function: ' + obj.name + ']';
	    } else if (type === '[object Array]') {
	      return '[ Array(' + obj.length + ') ]';
	    } else if (type === '[object Object]') {
	      var keys = Object.keys(obj)
	        , kstr = keys.length > 2
	          ? keys.splice(0, 2).join(', ') + ', ...'
	          : keys.join(', ');
	      return '{ Object (' + kstr + ') }';
	    } else {
	      return str;
	    }
	  } else {
	    return str;
	  }
	};


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	  Module dependencies
	*/
	
	var parse = __webpack_require__(291),
	    defaultOptions = __webpack_require__(290).default,
	    flattenOptions = __webpack_require__(290).flatten,
	    isHtml = __webpack_require__(198).isHtml,
	    _ = {
	      extend: __webpack_require__(465),
	      bind: __webpack_require__(466),
	      forEach: __webpack_require__(139),
	      defaults: __webpack_require__(470)
	    };
	
	/*
	 * The API
	 */
	
	var api = [
	  __webpack_require__(1025),
	  __webpack_require__(1029),
	  __webpack_require__(1028),
	  __webpack_require__(1026),
	  __webpack_require__(1027)
	];
	
	/*
	 * Instance of cheerio
	 */
	
	var Cheerio = module.exports = function(selector, context, root, options) {
	  if (!(this instanceof Cheerio)) return new Cheerio(selector, context, root, options);
	
	  this.options = _.defaults(flattenOptions(options), this.options, defaultOptions);
	
	  // $(), $(null), $(undefined), $(false)
	  if (!selector) return this;
	
	  if (root) {
	    if (typeof root === 'string') root = parse(root, this.options, false);
	    this._root = Cheerio.call(this, root);
	  }
	
	  // $($)
	  if (selector.cheerio) return selector;
	
	  // $(dom)
	  if (isNode(selector))
	    selector = [selector];
	
	  // $([dom])
	  if (Array.isArray(selector)) {
	    _.forEach(selector, _.bind(function(elem, idx) {
	      this[idx] = elem;
	    }, this));
	    this.length = selector.length;
	    return this;
	  }
	
	  // $(<html>)
	  if (typeof selector === 'string' && isHtml(selector)) {
	    return Cheerio.call(this, parse(selector, this.options, false).children);
	  }
	
	  // If we don't have a context, maybe we have a root, from loading
	  if (!context) {
	    context = this._root;
	  } else if (typeof context === 'string') {
	    if (isHtml(context)) {
	      // $('li', '<ul>...</ul>')
	      context = parse(context, this.options, false);
	      context = Cheerio.call(this, context);
	    } else {
	      // $('li', 'ul')
	      selector = [context, selector].join(' ');
	      context = this._root;
	    }
	  // $('li', node), $('li', [nodes])
	  } else if (!context.cheerio) {
	    context = Cheerio.call(this, context);
	  }
	
	  // If we still don't have a context, return
	  if (!context) return this;
	
	  // #id, .class, tag
	  return context.find(selector);
	};
	
	/**
	 * Mix in `static`
	 */
	
	_.extend(Cheerio, __webpack_require__(384));
	
	/*
	 * Set a signature of the object
	 */
	
	Cheerio.prototype.cheerio = '[cheerio object]';
	
	/*
	 * Make cheerio an array-like object
	 */
	
	Cheerio.prototype.length = 0;
	Cheerio.prototype.splice = Array.prototype.splice;
	
	/*
	 * Make a cheerio object
	 *
	 * @api private
	 */
	
	Cheerio.prototype._make = function(dom, context) {
	  var cheerio = new this.constructor(dom, context, this._root, this.options);
	  cheerio.prevObject = this;
	  return cheerio;
	};
	
	/**
	 * Turn a cheerio object into an array
	 */
	
	Cheerio.prototype.toArray = function() {
	  return this.get();
	};
	
	/**
	 * Plug in the API
	 */
	api.forEach(function(mod) {
	  _.extend(Cheerio.prototype, mod);
	});
	
	var isNode = function(obj) {
	  return obj.name || obj.type === 'text' || obj.type === 'comment';
	};


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var cssKeywords = __webpack_require__(1032);
	
	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
		if (cssKeywords.hasOwnProperty(key)) {
			reverseKeywords[cssKeywords[key]] = key;
		}
	}
	
	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};
	
	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}
	
			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}
	
			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}
	
			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}
	
	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	convert.rgb.hsv = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var v;
	
		if (max === 0) {
			s = 0;
		} else {
			s = (delta / max * 1000) / 10;
		}
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		v = ((max / 255) * 1000) / 10;
	
		return [h, s, v];
	};
	
	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));
	
		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
	
		return [h, w * 100, b * 100];
	};
	
	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;
	
		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;
	
		return [c * 100, m * 100, y * 100, k * 100];
	};
	
	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}
	
	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}
	
		var currentClosestDistance = Infinity;
		var currentClosestKeyword;
	
		for (var keyword in cssKeywords) {
			if (cssKeywords.hasOwnProperty(keyword)) {
				var value = cssKeywords[keyword];
	
				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);
	
				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}
	
		return currentClosestKeyword;
	};
	
	convert.keyword.rgb = function (keyword) {
		return cssKeywords[keyword];
	};
	
	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
	
		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
		return [x * 100, y * 100, z * 100];
	};
	
	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;
	
		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}
	
		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}
	
		t1 = 2 * l - t2;
	
		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}
	
			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}
	
			rgb[i] = val * 255;
		}
	
		return rgb;
	};
	
	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;
	
		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);
	
		return [h, sv * 100, v * 100];
	};
	
	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;
	
		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;
	
		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};
	
	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;
	
		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;
	
		return [h, sl * 100, l * 100];
	};
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;
	
		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}
	
		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;
	
		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}
	
		n = wh + f * (v - wh); // linear interpolation
	
		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;
	
		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;
	
		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;
	
		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;
	
		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;
	
		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;
	
		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;
	
		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
	
		x *= 95.047;
		y *= 100;
		z *= 108.883;
	
		return [x, y, z];
	};
	
	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;
	
		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;
	
		if (h < 0) {
			h += 360;
		}
	
		c = Math.sqrt(a * a + b * b);
	
		return [l, c, h];
	};
	
	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;
	
		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);
	
		return [l, a, b];
	};
	
	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
	
		value = Math.round(value / 50);
	
		if (value === 0) {
			return 30;
		}
	
		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));
	
		if (value === 2) {
			ansi += 60;
		}
	
		return ansi;
	};
	
	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};
	
	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
	
		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}
	
			if (r > 248) {
				return 231;
			}
	
			return Math.round(((r - 8) / 247) * 24) + 232;
		}
	
		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);
	
		return ansi;
	};
	
	convert.ansi16.rgb = function (args) {
		var color = args % 10;
	
		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}
	
			color = color / 10.5 * 255;
	
			return [color, color, color];
		}
	
		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;
	
		return [r, g, b];
	};
	
	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}
	
		args -= 16;
	
		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;
	
		return [r, g, b];
	};
	
	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
		if (!match) {
			return [0, 0, 0];
		}
	
		var colorString = match[0];
	
		if (match[0].length === 3) {
			colorString = colorString.split('').map(function (char) {
				return char + char;
			}).join('');
		}
	
		var integer = parseInt(colorString, 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;
	
		return [r, g, b];
	};
	
	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;
	
		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}
	
		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}
	
		hue /= 6;
		hue %= 1;
	
		return [hue * 360, chroma * 100, grayscale * 100];
	};
	
	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;
	
		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}
	
		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}
	
		return [hsl[0], c * 100, f * 100];
	};
	
	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
	
		var c = s * v;
		var f = 0;
	
		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}
	
		return [hsv[0], c * 100, f * 100];
	};
	
	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}
	
		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;
	
		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}
	
		mg = (1.0 - c) * g;
	
		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};
	
	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var v = c + g * (1.0 - c);
		var f = 0;
	
		if (v > 0.0) {
			f = c / v;
		}
	
		return [hcg[0], f * 100, v * 100];
	};
	
	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;
	
		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}
	
		return [hcg[0], s * 100, l * 100];
	};
	
	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};
	
	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;
	
		if (c < 1) {
			g = (v - c) / (1 - c);
		}
	
		return [hwb[0], c * 100, g * 100];
	};
	
	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};
	
	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};
	
	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};
	
	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};
	
	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};
	
	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};
	
	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};
	
	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(40);
	var $export = __webpack_require__(28);
	var meta = __webpack_require__(202);
	var fails = __webpack_require__(93);
	var hide = __webpack_require__(95);
	var redefineAll = __webpack_require__(295);
	var forOf = __webpack_require__(170);
	var anInstance = __webpack_require__(292);
	var isObject = __webpack_require__(46);
	var setToStringTag = __webpack_require__(205);
	var dP = __webpack_require__(58).f;
	var each = __webpack_require__(385)(0);
	var DESCRIPTORS = __webpack_require__(70);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    C = wrapper(function (target, iterable) {
	      anInstance(target, C, NAME, '_c');
	      target._c = new Base();
	      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
	        anInstance(this, C, KEY);
	        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    IS_WEAK || dP(C.prototype, 'size', {
	      get: function () {
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(40).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(70) && !__webpack_require__(93)(function () {
	  return Object.defineProperty(__webpack_require__(388)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(201);
	var ITERATOR = __webpack_require__(41)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(200);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(57);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(41)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 568 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(171);
	var gOPS = __webpack_require__(393);
	var pIE = __webpack_require__(203);
	var toObject = __webpack_require__(172);
	var IObject = __webpack_require__(390);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(93)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(203);
	var createDesc = __webpack_require__(204);
	var toIObject = __webpack_require__(129);
	var toPrimitive = __webpack_require__(398);
	var has = __webpack_require__(94);
	var IE8_DOM_DEFINE = __webpack_require__(563);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(70) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(573);
	var hiddenKeys = __webpack_require__(389).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(94);
	var toObject = __webpack_require__(172);
	var IE_PROTO = __webpack_require__(395)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(94);
	var toIObject = __webpack_require__(129);
	var arrayIndexOf = __webpack_require__(1056)(false);
	var IE_PROTO = __webpack_require__(395)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(28);
	var core = __webpack_require__(21);
	var fails = __webpack_require__(93);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(171);
	var toIObject = __webpack_require__(129);
	var isEnum = __webpack_require__(203).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 576 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(57);
	var isObject = __webpack_require__(46);
	var newPromiseCapability = __webpack_require__(392);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(28);
	var aFunction = __webpack_require__(199);
	var ctx = __webpack_require__(85);
	var forOf = __webpack_require__(170);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(28);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(40);
	var core = __webpack_require__(21);
	var dP = __webpack_require__(58);
	var DESCRIPTORS = __webpack_require__(70);
	var SPECIES = __webpack_require__(41)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(57);
	var aFunction = __webpack_require__(199);
	var SPECIES = __webpack_require__(41)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(85);
	var invoke = __webpack_require__(1064);
	var html = __webpack_require__(562);
	var cel = __webpack_require__(388);
	var global = __webpack_require__(40);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(200)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 583 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 584 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(52).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(587);
	var $export = __webpack_require__(303);
	var redefine = __webpack_require__(211);
	var hide = __webpack_require__(174);
	var Iterators = __webpack_require__(210);
	var $iterCreate = __webpack_require__(1107);
	var setToStringTag = __webpack_require__(407);
	var getPrototypeOf = __webpack_require__(1113);
	var ITERATOR = __webpack_require__(47)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 587 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(1114);
	var enumBugKeys = __webpack_require__(583);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 589 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(130);
	var isObject = __webpack_require__(209);
	var newPromiseCapability = __webpack_require__(406);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 591 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(52);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(130);
	var aFunction = __webpack_require__(300);
	var SPECIES = __webpack_require__(47)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(302);
	var invoke = __webpack_require__(1103);
	var html = __webpack_require__(585);
	var cel = __webpack_require__(405);
	var global = __webpack_require__(52);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(301)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(409);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = CSSselect;
	
	var Pseudos       = __webpack_require__(412),
	    DomUtils      = __webpack_require__(1133),
	    findOne       = DomUtils.findOne,
	    findAll       = DomUtils.findAll,
	    getChildren   = DomUtils.getChildren,
	    removeSubsets = DomUtils.removeSubsets,
	    falseFunc     = __webpack_require__(197).falseFunc,
	    compile       = __webpack_require__(1130),
	    compileUnsafe = compile.compileUnsafe,
	    compileToken  = compile.compileToken;
	
	function getSelectorFunc(searchFunc){
		return function select(query, elems, options){
	        if(typeof query !== "function") query = compileUnsafe(query, options, elems);
	        if(!Array.isArray(elems)) elems = getChildren(elems);
			else elems = removeSubsets(elems);
			return searchFunc(query, elems);
		};
	}
	
	var selectAll = getSelectorFunc(function selectAll(query, elems){
		return (query === falseFunc || !elems || elems.length === 0) ? [] : findAll(query, elems);
	});
	
	var selectOne = getSelectorFunc(function selectOne(query, elems){
		return (query === falseFunc || !elems || elems.length === 0) ? null : findOne(query, elems);
	});
	
	function is(elem, query, options){
		return (typeof query === "function" ? query : compile(query, options))(elem);
	}
	
	/*
		the exported interface
	*/
	function CSSselect(query, elems, options){
		return selectAll(query, elems, options);
	}
	
	CSSselect.compile = compile;
	CSSselect.filters = Pseudos.filters;
	CSSselect.pseudos = Pseudos.pseudos;
	
	CSSselect.selectAll = selectAll;
	CSSselect.selectOne = selectOne;
	
	CSSselect.is = is;
	
	//legacy methods (might be removed)
	CSSselect.parse = compile;
	CSSselect.iterate = selectAll;
	
	//hooks
	CSSselect._compileUnsafe = compileUnsafe;
	CSSselect._compileToken = compileToken;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	var DomUtils  = __webpack_require__(214),
	    hasAttrib = DomUtils.hasAttrib,
	    getAttributeValue = DomUtils.getAttributeValue,
	    falseFunc = __webpack_require__(197).falseFunc;
	
	//https://github.com/slevithan/XRegExp/blob/master/src/xregexp.js#L469
	var reChars = /[-[\]{}()*+?.,\\^$|#\s]/g;
	
	/*
		attribute selectors
	*/
	
	var attributeRules = {
		__proto__: null,
		equals: function(next, data){
			var name  = data.name,
			    value = data.value;
	
			if(data.ignoreCase){
				value = value.toLowerCase();
	
				return function equalsIC(elem){
					var attr = getAttributeValue(elem, name);
					return attr != null && attr.toLowerCase() === value && next(elem);
				};
			}
	
			return function equals(elem){
				return getAttributeValue(elem, name) === value && next(elem);
			};
		},
		hyphen: function(next, data){
			var name  = data.name,
			    value = data.value,
			    len = value.length;
	
			if(data.ignoreCase){
				value = value.toLowerCase();
	
				return function hyphenIC(elem){
					var attr = getAttributeValue(elem, name);
					return attr != null &&
							(attr.length === len || attr.charAt(len) === "-") &&
							attr.substr(0, len).toLowerCase() === value &&
							next(elem);
				};
			}
	
			return function hyphen(elem){
				var attr = getAttributeValue(elem, name);
				return attr != null &&
						attr.substr(0, len) === value &&
						(attr.length === len || attr.charAt(len) === "-") &&
						next(elem);
			};
		},
		element: function(next, data){
			var name = data.name,
			    value = data.value;
	
			if(/\s/.test(value)){
				return falseFunc;
			}
	
			value = value.replace(reChars, "\\$&");
	
			var pattern = "(?:^|\\s)" + value + "(?:$|\\s)",
			    flags = data.ignoreCase ? "i" : "",
			    regex = new RegExp(pattern, flags);
	
			return function element(elem){
				var attr = getAttributeValue(elem, name);
				return attr != null && regex.test(attr) && next(elem);
			};
		},
		exists: function(next, data){
			var name = data.name;
			return function exists(elem){
				return hasAttrib(elem, name) && next(elem);
			};
		},
		start: function(next, data){
			var name  = data.name,
			    value = data.value,
			    len = value.length;
	
			if(len === 0){
				return falseFunc;
			}
			
			if(data.ignoreCase){
				value = value.toLowerCase();
	
				return function startIC(elem){
					var attr = getAttributeValue(elem, name);
					return attr != null && attr.substr(0, len).toLowerCase() === value && next(elem);
				};
			}
	
			return function start(elem){
				var attr = getAttributeValue(elem, name);
				return attr != null && attr.substr(0, len) === value && next(elem);
			};
		},
		end: function(next, data){
			var name  = data.name,
			    value = data.value,
			    len   = -value.length;
	
			if(len === 0){
				return falseFunc;
			}
	
			if(data.ignoreCase){
				value = value.toLowerCase();
	
				return function endIC(elem){
					var attr = getAttributeValue(elem, name);
					return attr != null && attr.substr(len).toLowerCase() === value && next(elem);
				};
			}
	
			return function end(elem){
				var attr = getAttributeValue(elem, name);
				return attr != null && attr.substr(len) === value && next(elem);
			};
		},
		any: function(next, data){
			var name  = data.name,
			    value = data.value;
	
			if(value === ""){
				return falseFunc;
			}
	
			if(data.ignoreCase){
				var regex = new RegExp(value.replace(reChars, "\\$&"), "i");
	
				return function anyIC(elem){
					var attr = getAttributeValue(elem, name);
					return attr != null && regex.test(attr) && next(elem);
				};
			}
	
			return function any(elem){
				var attr = getAttributeValue(elem, name);
				return attr != null && attr.indexOf(value) >= 0 && next(elem);
			};
		},
		not: function(next, data){
			var name  = data.name,
			    value = data.value;
	
			if(value === ""){
				return function notEmpty(elem){
					return !!getAttributeValue(elem, name) && next(elem);
				};
			} else if(data.ignoreCase){
				value = value.toLowerCase();
	
				return function notIC(elem){
					var attr = getAttributeValue(elem, name);
					return attr != null && attr.toLowerCase() !== value && next(elem);
				};
			}
	
			return function not(elem){
				return getAttributeValue(elem, name) !== value && next(elem);
			};
		}
	};
	
	module.exports = {
		compile: function(next, data, options){
			if(options && options.strict && (
				data.ignoreCase || data.action === "not"
			)) throw SyntaxError("Unsupported attribute selector");
			return attributeRules[data.action](next, data);
		},
		rules: attributeRules
	};


/***/ }),
/* 598 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasClass;
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	module.exports = exports["default"];

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = camelizeStyleName;
	
	var _camelize = __webpack_require__(1156);
	
	var _camelize2 = _interopRequireDefault(_camelize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var msPattern = /^-ms-/; /**
	                          * Copyright 2014-2015, Facebook, Inc.
	                          * All rights reserved.
	                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	                          */
	function camelizeStyleName(string) {
	  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
	}
	module.exports = exports['default'];

/***/ }),
/* 600 */
/***/ (function(module, exports) {

	// This object will be used as the prototype for Nodes when creating a
	// DOM-Level-1-compliant structure.
	var NodePrototype = module.exports = {
		get firstChild() {
			var children = this.children;
			return children && children[0] || null;
		},
		get lastChild() {
			var children = this.children;
			return children && children[children.length - 1] || null;
		},
		get nodeType() {
			return nodeTypes[this.type] || nodeTypes.element;
		}
	};
	
	var domLvl1 = {
		tagName: "name",
		childNodes: "children",
		parentNode: "parent",
		previousSibling: "prev",
		nextSibling: "next",
		nodeValue: "data"
	};
	
	var nodeTypes = {
		element: 1,
		text: 3,
		cdata: 4,
		comment: 8
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(NodePrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	var decodeMap = __webpack_require__(4199);
	
	module.exports = decodeCodePoint;
	
	// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	function decodeCodePoint(codePoint){
	
		if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
			return "\uFFFD";
		}
	
		if(codePoint in decodeMap){
			codePoint = decodeMap[codePoint];
		}
	
		var output = "";
	
		if(codePoint > 0xFFFF){
			codePoint -= 0x10000;
			output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
			codePoint = 0xDC00 | codePoint & 0x3FF;
		}
	
		output += String.fromCharCode(codePoint);
		return output;
	}


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.typeName = typeName;
	exports.spaces = spaces;
	exports.indent = indent;
	exports.debugNode = debugNode;
	exports.debugNodes = debugNodes;
	
	var _without = __webpack_require__(4348);
	
	var _without2 = _interopRequireDefault(_without);
	
	var _escape = __webpack_require__(683);
	
	var _escape2 = _interopRequireDefault(_escape);
	
	var _compact = __webpack_require__(467);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _functionPrototype = __webpack_require__(419);
	
	var _functionPrototype2 = _interopRequireDefault(_functionPrototype);
	
	var _isString = __webpack_require__(2734);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isNumberObject = __webpack_require__(2732);
	
	var _isNumberObject2 = _interopRequireDefault(_isNumberObject);
	
	var _isCallable = __webpack_require__(220);
	
	var _isCallable2 = _interopRequireDefault(_isCallable);
	
	var _isBooleanObject = __webpack_require__(2730);
	
	var _isBooleanObject2 = _interopRequireDefault(_isBooleanObject);
	
	var _objectInspect = __webpack_require__(4356);
	
	var _objectInspect2 = _interopRequireDefault(_objectInspect);
	
	var _RSTTraversal = __webpack_require__(215);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var booleanValue = Function.bind.call(Function.call, Boolean.prototype.valueOf);
	
	function typeName(node) {
	  return typeof node.type === 'function' ? node.type.displayName || (0, _functionPrototype2['default'])(node.type) || 'Component' : node.type;
	}
	
	function spaces(n) {
	  return Array(n + 1).join(' ');
	}
	
	function indent(depth, string) {
	  return string.split('\n').map(function (x) {
	    return '' + String(spaces(depth)) + String(x);
	  }).join('\n');
	}
	
	function propString(prop) {
	  if ((0, _isString2['default'])(prop)) {
	    return (0, _objectInspect2['default'])(String(prop), { quoteStyle: 'double' });
	  }
	  if ((0, _isNumberObject2['default'])(prop)) {
	    return '{' + String((0, _objectInspect2['default'])(Number(prop))) + '}';
	  }
	  if ((0, _isBooleanObject2['default'])(prop)) {
	    return '{' + String((0, _objectInspect2['default'])(booleanValue(prop))) + '}';
	  }
	  if ((0, _isCallable2['default'])(prop)) {
	    return '{' + String((0, _objectInspect2['default'])(prop)) + '}';
	  }
	  if ((typeof prop === 'undefined' ? 'undefined' : _typeof(prop)) === 'object') {
	    return '{{...}}';
	  }
	  return '{[' + (typeof prop === 'undefined' ? 'undefined' : _typeof(prop)) + ']}';
	}
	
	function propsString(node) {
	  var props = (0, _RSTTraversal.propsOfNode)(node);
	  var keys = (0, _without2['default'])(Object.keys(props), 'children');
	  return keys.map(function (key) {
	    return String(key) + '=' + String(propString(props[key]));
	  }).join(' ');
	}
	
	function indentChildren(childrenStrs, indentLength) {
	  return childrenStrs.length ? '\n' + String(childrenStrs.map(function (x) {
	    return indent(indentLength, x);
	  }).join('\n')) + '\n' : '';
	}
	
	function debugNode(node) {
	  var indentLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (typeof node === 'string' || typeof node === 'number') return (0, _escape2['default'])(node);
	  if (!node) return '';
	
	  var childrenStrs = (0, _compact2['default'])((0, _RSTTraversal.childrenOfNode)(node).map(function (n) {
	    return debugNode(n, indentLength, options);
	  }));
	  var type = typeName(node);
	
	  var props = options.ignoreProps ? '' : propsString(node);
	  var beforeProps = props ? ' ' : '';
	  var afterProps = childrenStrs.length ? '>' : ' ';
	  var childrenIndented = indentChildren(childrenStrs, indentLength);
	  var nodeClose = childrenStrs.length ? '</' + String(type) + '>' : '/>';
	  return '<' + String(type) + beforeProps + String(props) + afterProps + String(childrenIndented) + nodeClose;
	}
	
	function debugNodes(nodes) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return nodes.map(function (node) {
	    return debugNode(node, undefined, options);
	  }).join('\n\n\n');
	}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function unimplementedError(methodName, classname) {
	  return new Error(String(methodName) + ' is a required method of ' + String(classname) + ', but was not implemented.');
	}
	
	var EnzymeAdapter = function () {
	  function EnzymeAdapter() {
	    _classCallCheck(this, EnzymeAdapter);
	
	    this.options = {};
	  }
	  // Provided a bag of options, return an `EnzymeRenderer`. Some options can be implementation
	  // specific, like `attach` etc. for React, but not part of this interface explicitly.
	  // eslint-disable-next-line class-methods-use-this, no-unused-vars
	
	
	  _createClass(EnzymeAdapter, [{
	    key: 'createRenderer',
	    value: function () {
	      function createRenderer(options) {
	        throw unimplementedError('createRenderer', 'EnzymeAdapter');
	      }
	
	      return createRenderer;
	    }()
	
	    // converts an RSTNode to the corresponding JSX Pragma Element. This will be needed
	    // in order to implement the `Wrapper.mount()` and `Wrapper.shallow()` methods, but should
	    // be pretty straightforward for people to implement.
	    // eslint-disable-next-line class-methods-use-this, no-unused-vars
	
	  }, {
	    key: 'nodeToElement',
	    value: function () {
	      function nodeToElement(node) {
	        throw unimplementedError('nodeToElement', 'EnzymeAdapter');
	      }
	
	      return nodeToElement;
	    }()
	
	    // eslint-disable-next-line class-methods-use-this, no-unused-vars
	
	  }, {
	    key: 'isValidElement',
	    value: function () {
	      function isValidElement(element) {
	        throw unimplementedError('isValidElement', 'EnzymeAdapter');
	      }
	
	      return isValidElement;
	    }()
	
	    // eslint-disable-next-line class-methods-use-this, no-unused-vars
	
	  }, {
	    key: 'createElement',
	    value: function () {
	      function createElement(type, props) {
	        throw unimplementedError('createElement', 'EnzymeAdapter');
	      }
	
	      return createElement;
	    }()
	  }]);
	
	  return EnzymeAdapter;
	}();
	
	EnzymeAdapter.MODES = {
	  STRING: 'string',
	  MOUNT: 'mount',
	  SHALLOW: 'shallow'
	};
	
	module.exports = EnzymeAdapter;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(86);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _cheerio = __webpack_require__(383);
	
	var _cheerio2 = _interopRequireDefault(_cheerio);
	
	var _flatten = __webpack_require__(183);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _uniq = __webpack_require__(185);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _compact = __webpack_require__(467);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _Utils = __webpack_require__(216);
	
	var _Debug = __webpack_require__(602);
	
	var _RSTTraversal = __webpack_require__(215);
	
	var _selectors = __webpack_require__(608);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var noop = function noop() {};
	
	var NODE = (0, _Utils.sym)('__node__');
	var NODES = (0, _Utils.sym)('__nodes__');
	var RENDERER = (0, _Utils.sym)('__renderer__');
	var UNRENDERED = (0, _Utils.sym)('__unrendered__');
	var ROOT = (0, _Utils.sym)('__root__');
	var OPTIONS = (0, _Utils.sym)('__options__');
	
	/**
	 * Finds all nodes in the current wrapper nodes' render trees that match the provided predicate
	 * function.
	 *
	 * @param {ReactWrapper} wrapper
	 * @param {Function} predicate
	 * @param {Function} filter
	 * @returns {ReactWrapper}
	 */
	function findWhereUnwrapped(wrapper, predicate) {
	  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _RSTTraversal.treeFilter;
	
	  return wrapper.flatMap(function (n) {
	    return filter(n.getNodeInternal(), predicate);
	  });
	}
	
	/**
	 * Returns a new wrapper instance with only the nodes of the current wrapper instance that match
	 * the provided predicate function.
	 *
	 * @param {ReactWrapper} wrapper
	 * @param {Function} predicate
	 * @returns {ReactWrapper}
	 */
	function filterWhereUnwrapped(wrapper, predicate) {
	  return wrapper.wrap((0, _compact2['default'])(wrapper.getNodesInternal().filter(predicate)));
	}
	
	/**
	 * @class ReactWrapper
	 */
	
	var ReactWrapper = function () {
	  function ReactWrapper(nodes, root) {
	    var passedOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    _classCallCheck(this, ReactWrapper);
	
	    if (!global.window && !global.document) {
	      throw new Error('It looks like you called `mount()` without a global document being loaded.');
	    }
	    var options = (0, _Utils.makeOptions)(passedOptions);
	
	    if (!root) {
	      (0, _Utils.privateSet)(this, UNRENDERED, nodes);
	      var renderer = (0, _Utils.getAdapter)(options).createRenderer((0, _object2['default'])({ mode: 'mount' }, options));
	      (0, _Utils.privateSet)(this, RENDERER, renderer);
	      renderer.render(nodes, options.context);
	      (0, _Utils.privateSet)(this, ROOT, this);
	      var node = this[RENDERER].getNode();
	      (0, _Utils.privateSet)(this, NODE, node);
	      (0, _Utils.privateSet)(this, NODES, [node]);
	      this.length = 1;
	    } else {
	      (0, _Utils.privateSet)(this, UNRENDERED, null);
	      (0, _Utils.privateSet)(this, RENDERER, root[RENDERER]);
	      (0, _Utils.privateSet)(this, ROOT, root);
	      if (!nodes) {
	        (0, _Utils.privateSet)(this, NODE, null);
	        (0, _Utils.privateSet)(this, NODES, []);
	      } else if (!Array.isArray(nodes)) {
	        (0, _Utils.privateSet)(this, NODE, nodes);
	        (0, _Utils.privateSet)(this, NODES, [nodes]);
	      } else {
	        (0, _Utils.privateSet)(this, NODE, nodes[0]);
	        (0, _Utils.privateSet)(this, NODES, nodes);
	      }
	      this.length = this[NODES].length;
	    }
	    (0, _Utils.privateSet)(this, OPTIONS, root ? root[OPTIONS] : options);
	  }
	
	  /**
	   * Returns the root wrapper
	   *
	   * @return {ReactWrapper}
	   */
	
	
	  _createClass(ReactWrapper, [{
	    key: 'root',
	    value: function () {
	      function root() {
	        return this[ROOT];
	      }
	
	      return root;
	    }()
	
	    /**
	     * Returns the wrapped component.
	     *
	     * @return {ReactComponent}
	     */
	
	  }, {
	    key: 'getNodeInternal',
	    value: function () {
	      function getNodeInternal() {
	        if (this.length !== 1) {
	          throw new Error('ReactWrapper::getNode() can only be called when wrapping one node');
	        }
	        return this[NODES][0];
	      }
	
	      return getNodeInternal;
	    }()
	
	    /**
	     * Returns the the wrapped components.
	     *
	     * @return {Array<ReactComponent>}
	     */
	
	  }, {
	    key: 'getNodesInternal',
	    value: function () {
	      function getNodesInternal() {
	        return this[NODES];
	      }
	
	      return getNodesInternal;
	    }()
	
	    /**
	     * Returns the wrapped ReactElement.
	     *
	     * @return {ReactElement}
	     */
	
	  }, {
	    key: 'getElement',
	    value: function () {
	      function getElement() {
	        if (this.length !== 1) {
	          throw new Error('ReactWrapper::getElement() can only be called when wrapping one node');
	        }
	        return (0, _Utils.getAdapter)(this[OPTIONS]).nodeToElement(this[NODE]);
	      }
	
	      return getElement;
	    }()
	
	    /**
	     * Returns the wrapped ReactElements.
	     *
	     * @return {Array<ReactElement>}
	     */
	
	  }, {
	    key: 'getElements',
	    value: function () {
	      function getElements() {
	        return this[NODES].map((0, _Utils.getAdapter)(this[OPTIONS]).nodeToElement);
	      }
	
	      return getElements;
	    }()
	
	    // eslint-disable-next-line class-methods-use-this
	
	  }, {
	    key: 'getNode',
	    value: function () {
	      function getNode() {
	        throw new Error('ReactWrapper::getNode() is no longer supported. Use ReactWrapper::instance() instead');
	      }
	
	      return getNode;
	    }()
	
	    // eslint-disable-next-line class-methods-use-this
	
	  }, {
	    key: 'getNodes',
	    value: function () {
	      function getNodes() {
	        throw new Error('ReactWrapper::getNodes() is no longer supported.');
	      }
	
	      return getNodes;
	    }()
	
	    /**
	     * Returns the outer most DOMComponent of the current wrapper.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @returns {DOMComponent}
	     */
	
	  }, {
	    key: 'getDOMNode',
	    value: function () {
	      function getDOMNode() {
	        var adapter = (0, _Utils.getAdapter)(this[OPTIONS]);
	        return this.single('getDOMNode', function (n) {
	          return adapter.nodeToHostNode(n);
	        });
	      }
	
	      return getDOMNode;
	    }()
	
	    /**
	     * If the root component contained a ref, you can access it here
	     * and get a wrapper around it.
	     *
	     * NOTE: can only be called on a wrapper instance that is also the root instance.
	     *
	     * @param {String} refname
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'ref',
	    value: function () {
	      function ref(refname) {
	        if (this[ROOT] !== this) {
	          throw new Error('ReactWrapper::ref(refname) can only be called on the root');
	        }
	        return this.instance().refs[refname];
	      }
	
	      return ref;
	    }()
	
	    /**
	     * Gets the instance of the component being rendered as the root node passed into `mount()`.
	     *
	     * NOTE: can only be called on a wrapper instance that is also the root instance.
	     *
	     * Example:
	     * ```
	     * const wrapper = mount(<MyComponent />);
	     * const inst = wrapper.instance();
	     * expect(inst).to.be.instanceOf(MyComponent);
	     * ```
	     * @returns {ReactComponent}
	     */
	
	  }, {
	    key: 'instance',
	    value: function () {
	      function instance() {
	        if (this.length !== 1) {
	          throw new Error('ReactWrapper::instance() can only be called on single nodes');
	        }
	        return this[NODE].instance;
	      }
	
	      return instance;
	    }()
	
	    /**
	     * Forces a re-render. Useful to run before checking the render output if something external
	     * may be updating the state of the component somewhere.
	     *
	     * NOTE: can only be called on a wrapper instance that is also the root instance.
	     *
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'update',
	    value: function () {
	      function update() {
	        var _this = this;
	
	        if (this[ROOT] !== this) {
	          throw new Error('ReactWrapper::update() can only be called on the root');
	        }
	        this.single('update', function () {
	          var node = _this[RENDERER].getNode();
	          _this[NODE] = node;
	          _this[NODES] = [node];
	        });
	        return this;
	      }
	
	      return update;
	    }()
	
	    /**
	     * A method that unmounts the component. This can be used to simulate a component going through
	     * and unmount/mount lifecycle.
	     *
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'unmount',
	    value: function () {
	      function unmount() {
	        var _this2 = this;
	
	        if (this[ROOT] !== this) {
	          throw new Error('ReactWrapper::unmount() can only be called on the root');
	        }
	        this.single('unmount', function () {
	          _this2[RENDERER].unmount();
	          _this2.update();
	        });
	        return this;
	      }
	
	      return unmount;
	    }()
	
	    /**
	     * A method that re-mounts the component. This can be used to simulate a component going through
	     * an unmount/mount lifecycle.
	     *
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'mount',
	    value: function () {
	      function mount() {
	        var _this3 = this;
	
	        if (this[ROOT] !== this) {
	          throw new Error('ReactWrapper::mount() can only be called on the root');
	        }
	        this.single('mount', function () {
	          _this3[RENDERER].render(_this3[UNRENDERED], _this3[OPTIONS].context, function () {
	            return _this3.update();
	          });
	        });
	        return this;
	      }
	
	      return mount;
	    }()
	
	    /**
	     * A method that sets the props of the root component, and re-renders. Useful for when you are
	     * wanting to test how the component behaves over time with changing props. Calling this, for
	     * instance, will call the `componentWillReceiveProps` lifecycle method.
	     *
	     * Similar to `setState`, this method accepts a props object and will merge it in with the already
	     * existing props.
	     *
	     * NOTE: can only be called on a wrapper instance that is also the root instance.
	     *
	     * @param {Object} props object
	     * @param {Function} cb - callback function
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'setProps',
	    value: function () {
	      function setProps(props) {
	        var _this4 = this;
	
	        var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	
	        if (this[ROOT] !== this) {
	          throw new Error('ReactWrapper::setProps() can only be called on the root');
	        }
	        if (typeof callback !== 'function') {
	          throw new TypeError('ReactWrapper::setProps() expects a function as its second argument');
	        }
	        var adapter = (0, _Utils.getAdapter)(this[OPTIONS]);
	        this[UNRENDERED] = (0, _Utils.cloneElement)(adapter, this[UNRENDERED], props);
	        this[RENDERER].render(this[UNRENDERED], null, function () {
	          _this4.update();
	          callback();
	        });
	        return this;
	      }
	
	      return setProps;
	    }()
	
	    /**
	     * A method to invoke `setState` on the root component instance similar to how you might in the
	     * definition of the component, and re-renders.  This method is useful for testing your component
	     * in hard to achieve states, however should be used sparingly. If possible, you should utilize
	     * your component's external API in order to get it into whatever state you want to test, in order
	     * to be as accurate of a test as possible. This is not always practical, however.
	     *
	     * NOTE: can only be called on a wrapper instance that is also the root instance.
	     *
	     * @param {Object} state to merge
	     * @param {Function} cb - callback function
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'setState',
	    value: function () {
	      function setState(state) {
	        var _this5 = this;
	
	        var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	
	        if (this[ROOT] !== this) {
	          throw new Error('ReactWrapper::setState() can only be called on the root');
	        }
	        if (typeof callback !== 'function') {
	          throw new TypeError('ReactWrapper::setState() expects a function as its second argument');
	        }
	        this.instance().setState(state, function () {
	          _this5.update();
	          callback();
	        });
	        return this;
	      }
	
	      return setState;
	    }()
	
	    /**
	     * A method that sets the context of the root component, and re-renders. Useful for when you are
	     * wanting to test how the component behaves over time with changing contexts.
	     *
	     * NOTE: can only be called on a wrapper instance that is also the root instance.
	     *
	     * @param {Object} context object
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'setContext',
	    value: function () {
	      function setContext(context) {
	        var _this6 = this;
	
	        if (this[ROOT] !== this) {
	          throw new Error('ReactWrapper::setContext() can only be called on the root');
	        }
	        if (!this[OPTIONS].context) {
	          throw new Error('ShallowWrapper::setContext() can only be called on a wrapper that was originally passed a context option');
	        }
	        this[RENDERER].render(this[UNRENDERED], context, function () {
	          return _this6.update();
	        });
	        return this;
	      }
	
	      return setContext;
	    }()
	
	    /**
	     * Whether or not a given react element matches the current render tree.
	     * It will determine if the wrapper root node "looks like" the expected
	     * element by checking if all props of the expected element are present
	     * on the wrapper root node and equals to each other.
	     *
	     * Example:
	     * ```
	     * // MyComponent outputs <div class="foo">Hello</div>
	     * const wrapper = mount(<MyComponent />);
	     * expect(wrapper.matchesElement(<div>Hello</div>)).to.equal(true);
	     * ```
	     *
	     * @param {ReactElement} node
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'matchesElement',
	    value: function () {
	      function matchesElement(node) {
	        var _this7 = this;
	
	        return this.single('matchesElement', function () {
	          return (0, _Utils.nodeMatches)(node, _this7.getNodeInternal(), function (a, b) {
	            return a <= b;
	          });
	        });
	      }
	
	      return matchesElement;
	    }()
	
	    /**
	     * Whether or not a given react element exists in the mount render tree.
	     *
	     * Example:
	     * ```
	     * const wrapper = mount(<MyComponent />);
	     * expect(wrapper.contains(<div className="foo bar" />)).to.equal(true);
	     * ```
	     *
	     * @param {ReactElement|Array<ReactElement>} nodeOrNodes
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'contains',
	    value: function () {
	      function contains(nodeOrNodes) {
	        var predicate = Array.isArray(nodeOrNodes) ? function (other) {
	          return (0, _Utils.containsChildrenSubArray)(_Utils.nodeEqual, other, nodeOrNodes);
	        } : function (other) {
	          return (0, _Utils.nodeEqual)(nodeOrNodes, other);
	        };
	        return findWhereUnwrapped(this, predicate).length > 0;
	      }
	
	      return contains;
	    }()
	
	    /**
	     * Whether or not a given react element exists in the current render tree.
	     * It will determine if one of the wrappers element "looks like" the expected
	     * element by checking if all props of the expected element are present
	     * on the wrappers element and equals to each other.
	     *
	     * Example:
	     * ```
	     * // MyComponent outputs <div><div class="foo">Hello</div></div>
	     * const wrapper = mount(<MyComponent />);
	     * expect(wrapper.containsMatchingElement(<div>Hello</div>)).to.equal(true);
	     * ```
	     *
	     * @param {ReactElement} node
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'containsMatchingElement',
	    value: function () {
	      function containsMatchingElement(node) {
	        var predicate = function () {
	          function predicate(other) {
	            return (0, _Utils.nodeMatches)(node, other, function (a, b) {
	              return a <= b;
	            });
	          }
	
	          return predicate;
	        }();
	        return findWhereUnwrapped(this, predicate).length > 0;
	      }
	
	      return containsMatchingElement;
	    }()
	
	    /**
	     * Whether or not all the given react elements exists in the current render tree.
	     * It will determine if one of the wrappers element "looks like" the expected
	     * element by checking if all props of the expected element are present
	     * on the wrappers element and equals to each other.
	     *
	     * Example:
	     * ```
	     * const wrapper = mount(<MyComponent />);
	     * expect(wrapper.containsAllMatchingElements([
	     *   <div>Hello</div>,
	     *   <div>Goodbye</div>,
	     * ])).to.equal(true);
	     * ```
	     *
	     * @param {Array<ReactElement>} nodes
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'containsAllMatchingElements',
	    value: function () {
	      function containsAllMatchingElements(nodes) {
	        var _this8 = this;
	
	        if (!Array.isArray(nodes)) {
	          throw new TypeError('nodes should be an Array');
	        }
	
	        return nodes.every(function (node) {
	          return _this8.containsMatchingElement(node);
	        });
	      }
	
	      return containsAllMatchingElements;
	    }()
	
	    /**
	     * Whether or not one of the given react elements exists in the current render tree.
	     * It will determine if one of the wrappers element "looks like" the expected
	     * element by checking if all props of the expected element are present
	     * on the wrappers element and equals to each other.
	     *
	     * Example:
	     * ```
	     * const wrapper = mount(<MyComponent />);
	     * expect(wrapper.containsAnyMatchingElements([
	     *   <div>Hello</div>,
	     *   <div>Goodbye</div>,
	     * ])).to.equal(true);
	     * ```
	     *
	     * @param {Array<ReactElement>} nodes
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'containsAnyMatchingElements',
	    value: function () {
	      function containsAnyMatchingElements(nodes) {
	        var _this9 = this;
	
	        return Array.isArray(nodes) && nodes.some(function (node) {
	          return _this9.containsMatchingElement(node);
	        });
	      }
	
	      return containsAnyMatchingElements;
	    }()
	
	    /**
	     * Finds every node in the render tree of the current wrapper that matches the provided selector.
	     *
	     * @param {String|Function} selector
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'find',
	    value: function () {
	      function find(selector) {
	        return this.wrap((0, _selectors.reduceTreesBySelector)(selector, this.getNodesInternal()));
	      }
	
	      return find;
	    }()
	
	    /**
	     * Returns whether or not current node matches a provided selector.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @param {String|Function} selector
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'is',
	    value: function () {
	      function is(selector) {
	        var predicate = (0, _selectors.buildPredicate)(selector);
	        return this.single('is', function (n) {
	          return predicate(n);
	        });
	      }
	
	      return is;
	    }()
	
	    /**
	     * Returns true if the component rendered nothing, i.e., null or false.
	     *
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'isEmptyRender',
	    value: function () {
	      function isEmptyRender() {
	        return this.single('isEmptyRender', function (n) {
	          return n.rendered === null;
	        });
	      }
	
	      return isEmptyRender;
	    }()
	
	    /**
	     * Returns a new wrapper instance with only the nodes of the current wrapper instance that match
	     * the provided predicate function.
	     *
	     * @param {Function} predicate
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'filterWhere',
	    value: function () {
	      function filterWhere(predicate) {
	        var _this10 = this;
	
	        return filterWhereUnwrapped(this, function (n) {
	          return predicate(_this10.wrap(n));
	        });
	      }
	
	      return filterWhere;
	    }()
	
	    /**
	     * Returns a new wrapper instance with only the nodes of the current wrapper instance that match
	     * the provided selector.
	     *
	     * @param {String|Function} selector
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'filter',
	    value: function () {
	      function filter(selector) {
	        var predicate = (0, _selectors.buildPredicate)(selector);
	        return filterWhereUnwrapped(this, predicate);
	      }
	
	      return filter;
	    }()
	
	    /**
	     * Returns a new wrapper instance with only the nodes of the current wrapper that did not match
	     * the provided selector. Essentially the inverse of `filter`.
	     *
	     * @param {String|Function} selector
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'not',
	    value: function () {
	      function not(selector) {
	        var predicate = (0, _selectors.buildPredicate)(selector);
	        return filterWhereUnwrapped(this, function (n) {
	          return !predicate(n);
	        });
	      }
	
	      return not;
	    }()
	
	    /**
	     * Returns a string of the rendered text of the current render tree.  This function should be
	     * looked at with skepticism if being used to test what the actual HTML output of the component
	     * will be. If that is what you would like to test, use enzyme's `render` function instead.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @returns {String}
	     */
	
	  }, {
	    key: 'text',
	    value: function () {
	      function text() {
	        var adapter = (0, _Utils.getAdapter)(this[OPTIONS]);
	        return this.single('text', function (n) {
	          return adapter.nodeToHostNode(n).textContent;
	        });
	      }
	
	      return text;
	    }()
	
	    /**
	     * Returns the HTML of the node.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @returns {String}
	     */
	
	  }, {
	    key: 'html',
	    value: function () {
	      function html() {
	        var _this11 = this;
	
	        return this.single('html', function (n) {
	          if (n === null) return null;
	          var adapter = (0, _Utils.getAdapter)(_this11[OPTIONS]);
	          var node = adapter.nodeToHostNode(n);
	          return node === null ? null : node.outerHTML.replace(/\sdata-(reactid|reactroot)+="([^"]*)+"/g, '');
	        });
	      }
	
	      return html;
	    }()
	
	    /**
	     * Returns the current node rendered to HTML and wrapped in a CheerioWrapper.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @returns {CheerioWrapper}
	     */
	
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var html = this.html();
	        return html === null ? (0, _cheerio2['default'])() : _cheerio2['default'].load('')(html);
	      }
	
	      return render;
	    }()
	
	    /**
	     * Used to simulate events. Pass an eventname and (optionally) event arguments. This method of
	     * testing events should be met with some skepticism.
	     *
	     * @param {String} event
	     * @param {Object} mock (optional)
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'simulate',
	    value: function () {
	      function simulate(event) {
	        var _this12 = this;
	
	        var mock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        this.single('simulate', function (n) {
	          _this12[RENDERER].simulateEvent(n, event, mock);
	          _this12[ROOT].update();
	        });
	        return this;
	      }
	
	      return simulate;
	    }()
	
	    /**
	     * Returns the props hash for the root node of the wrapper.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @returns {Object}
	     */
	
	  }, {
	    key: 'props',
	    value: function () {
	      function props() {
	        return this.single('props', _RSTTraversal.propsOfNode);
	      }
	
	      return props;
	    }()
	
	    /**
	     * Returns the state hash for the root node of the wrapper. Optionally pass in a prop name and it
	     * will return just that value.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @param {String} name (optional)
	     * @returns {*}
	     */
	
	  }, {
	    key: 'state',
	    value: function () {
	      function state(name) {
	        var _this13 = this;
	
	        if (this[ROOT] !== this) {
	          throw new Error('ReactWrapper::state() can only be called on the root');
	        }
	        var _state = this.single('state', function () {
	          return _this13.instance().state;
	        });
	        if (typeof name !== 'undefined') {
	          return _state[name];
	        }
	        return _state;
	      }
	
	      return state;
	    }()
	
	    /**
	     * Returns the context hash for the root node of the wrapper.
	     * Optionally pass in a prop name and it will return just that value.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @param {String} name (optional)
	     * @returns {*}
	     */
	
	  }, {
	    key: 'context',
	    value: function () {
	      function context(name) {
	        var _this14 = this;
	
	        if (this[ROOT] !== this) {
	          throw new Error('ReactWrapper::context() can only be called on the root');
	        }
	        var instance = this.single('context', function () {
	          return _this14.instance();
	        });
	        if (instance === null) {
	          throw new Error('ReactWrapper::context() can only be called on components with instances');
	        }
	        var _context = instance.context;
	        if (typeof name !== 'undefined') {
	          return _context[name];
	        }
	        return _context;
	      }
	
	      return context;
	    }()
	
	    /**
	     * Returns a new wrapper with all of the children of the current wrapper.
	     *
	     * @param {String|Function} [selector]
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'children',
	    value: function () {
	      function children(selector) {
	        var allChildren = this.flatMap(function (n) {
	          return (0, _RSTTraversal.childrenOfNode)(n.getNodeInternal()).filter(function (x) {
	            return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object';
	          });
	        });
	        return selector ? allChildren.filter(selector) : allChildren;
	      }
	
	      return children;
	    }()
	
	    /**
	     * Returns a new wrapper with a specific child
	     *
	     * @param {Number} [index]
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'childAt',
	    value: function () {
	      function childAt(index) {
	        var _this15 = this;
	
	        return this.single('childAt', function () {
	          return _this15.children().at(index);
	        });
	      }
	
	      return childAt;
	    }()
	
	    /**
	     * Returns a wrapper around all of the parents/ancestors of the wrapper. Does not include the node
	     * in the current wrapper.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @param {String|Function} [selector]
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'parents',
	    value: function () {
	      function parents(selector) {
	        var _this16 = this;
	
	        var allParents = this.wrap(this.single('parents', function (n) {
	          return (0, _RSTTraversal.parentsOfNode)(n, _this16[ROOT].getNodeInternal());
	        }));
	        return selector ? allParents.filter(selector) : allParents;
	      }
	
	      return parents;
	    }()
	
	    /**
	     * Returns a wrapper around the immediate parent of the current node.
	     *
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'parent',
	    value: function () {
	      function parent() {
	        return this.flatMap(function (n) {
	          return [n.parents().get(0)];
	        });
	      }
	
	      return parent;
	    }()
	
	    /**
	     *
	     * @param {String|Function} selector
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'closest',
	    value: function () {
	      function closest(selector) {
	        return this.is(selector) ? this : this.parents().filter(selector).first();
	      }
	
	      return closest;
	    }()
	
	    /**
	     * Returns the value of  prop with the given name of the root node.
	     *
	     * @param {String} propName
	     * @returns {*}
	     */
	
	  }, {
	    key: 'prop',
	    value: function () {
	      function prop(propName) {
	        return this.props()[propName];
	      }
	
	      return prop;
	    }()
	
	    /**
	     * Returns the key assigned to the current node.
	     *
	     * @returns {String}
	     */
	
	  }, {
	    key: 'key',
	    value: function () {
	      function key() {
	        return this.single('key', function (n) {
	          return n.key;
	        });
	      }
	
	      return key;
	    }()
	
	    /**
	     * Returns the type of the root node of this wrapper. If it's a composite component, this will be
	     * the component constructor. If it's native DOM node, it will be a string.
	     *
	     * @returns {String|Function}
	     */
	
	  }, {
	    key: 'type',
	    value: function () {
	      function type() {
	        return this.single('type', function (n) {
	          return (0, _Utils.typeOfNode)(n);
	        });
	      }
	
	      return type;
	    }()
	
	    /**
	     * Returns the name of the root node of this wrapper.
	     *
	     * In order of precedence => type.displayName -> type.name -> type.
	     *
	     * @returns {String}
	     */
	
	  }, {
	    key: 'name',
	    value: function () {
	      function name() {
	        return this.single('name', function (n) {
	          return (0, _Utils.displayNameOfNode)(n);
	        });
	      }
	
	      return name;
	    }()
	
	    /**
	     * Returns whether or not the current root node has the given class name or not.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @param {String} className
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'hasClass',
	    value: function () {
	      function hasClass(className) {
	        if (className && className.indexOf('.') !== -1) {
	          // eslint-disable-next-line no-console
	          console.warn('It looks like you\'re calling `ReactWrapper::hasClass()` with a CSS selector. hasClass() expects a class name, not a CSS selector.');
	        }
	        return this.single('hasClass', function (n) {
	          return (0, _RSTTraversal.hasClassName)(n, className);
	        });
	      }
	
	      return hasClass;
	    }()
	
	    /**
	     * Iterates through each node of the current wrapper and executes the provided function with a
	     * wrapper around the corresponding node passed in as the first argument.
	     *
	     * @param {Function} fn
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'forEach',
	    value: function () {
	      function forEach(fn) {
	        var _this17 = this;
	
	        this.getNodesInternal().forEach(function (n, i) {
	          return fn.call(_this17, _this17.wrap(n), i);
	        });
	        return this;
	      }
	
	      return forEach;
	    }()
	
	    /**
	     * Maps the current array of nodes to another array. Each node is passed in as a `ReactWrapper`
	     * to the map function.
	     *
	     * @param {Function} fn
	     * @returns {Array}
	     */
	
	  }, {
	    key: 'map',
	    value: function () {
	      function map(fn) {
	        var _this18 = this;
	
	        return this.getNodesInternal().map(function (n, i) {
	          return fn.call(_this18, _this18.wrap(n), i);
	        });
	      }
	
	      return map;
	    }()
	
	    /**
	     * Reduces the current array of nodes to another array.
	     * Each node is passed in as a `ShallowWrapper` to the reducer function.
	     *
	     * @param {Function} fn - the reducer function
	     * @param {*} initialValue - the initial value
	     * @returns {*}
	     */
	
	  }, {
	    key: 'reduce',
	    value: function () {
	      function reduce(fn) {
	        var _this19 = this;
	
	        var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
	        if (arguments.length > 1) {
	          return this.getNodesInternal().reduce(function (accum, n, i) {
	            return fn.call(_this19, accum, _this19.wrap(n), i);
	          }, initialValue);
	        }
	        return this.getNodesInternal().reduce(function (accum, n, i) {
	          return fn.call(_this19, i === 1 ? _this19.wrap(accum) : accum, _this19.wrap(n), i);
	        });
	      }
	
	      return reduce;
	    }()
	
	    /**
	     * Reduces the current array of nodes to another array, from right to left. Each node is passed
	     * in as a `ShallowWrapper` to the reducer function.
	     *
	     * @param {Function} fn - the reducer function
	     * @param {*} initialValue - the initial value
	     * @returns {*}
	     */
	
	  }, {
	    key: 'reduceRight',
	    value: function () {
	      function reduceRight(fn) {
	        var _this20 = this;
	
	        var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
	        if (arguments.length > 1) {
	          return this.getNodesInternal().reduceRight(function (accum, n, i) {
	            return fn.call(_this20, accum, _this20.wrap(n), i);
	          }, initialValue);
	        }
	        return this.getNodesInternal().reduceRight(function (accum, n, i) {
	          return fn.call(_this20, i === 1 ? _this20.wrap(accum) : accum, _this20.wrap(n), i);
	        });
	      }
	
	      return reduceRight;
	    }()
	
	    /**
	     * Returns a new wrapper with a subset of the nodes of the original wrapper, according to the
	     * rules of `Array#slice`.
	     *
	     * @param {Number} begin
	     * @param {Number} end
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'slice',
	    value: function () {
	      function slice(begin, end) {
	        return this.wrap(this.getNodesInternal().slice(begin, end));
	      }
	
	      return slice;
	    }()
	
	    /**
	     * Returns whether or not any of the nodes in the wrapper match the provided selector.
	     *
	     * @param {Function|String} selector
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'some',
	    value: function () {
	      function some(selector) {
	        if (this[ROOT] === this) {
	          throw new Error('ReactWrapper::some() can not be called on the root');
	        }
	        var predicate = (0, _selectors.buildPredicate)(selector);
	        return this.getNodesInternal().some(predicate);
	      }
	
	      return some;
	    }()
	
	    /**
	     * Returns whether or not any of the nodes in the wrapper pass the provided predicate function.
	     *
	     * @param {Function} predicate
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'someWhere',
	    value: function () {
	      function someWhere(predicate) {
	        var _this21 = this;
	
	        return this.getNodesInternal().some(function (n, i) {
	          return predicate.call(_this21, _this21.wrap(n), i);
	        });
	      }
	
	      return someWhere;
	    }()
	
	    /**
	     * Returns whether or not all of the nodes in the wrapper match the provided selector.
	     *
	     * @param {Function|String} selector
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'every',
	    value: function () {
	      function every(selector) {
	        var predicate = (0, _selectors.buildPredicate)(selector);
	        return this.getNodesInternal().every(predicate);
	      }
	
	      return every;
	    }()
	
	    /**
	     * Returns whether or not any of the nodes in the wrapper pass the provided predicate function.
	     *
	     * @param {Function} predicate
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'everyWhere',
	    value: function () {
	      function everyWhere(predicate) {
	        var _this22 = this;
	
	        return this.getNodesInternal().every(function (n, i) {
	          return predicate.call(_this22, _this22.wrap(n), i);
	        });
	      }
	
	      return everyWhere;
	    }()
	
	    /**
	     * Utility method used to create new wrappers with a mapping function that returns an array of
	     * nodes in response to a single node wrapper. The returned wrapper is a single wrapper around
	     * all of the mapped nodes flattened (and de-duplicated).
	     *
	     * @param {Function} fn
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'flatMap',
	    value: function () {
	      function flatMap(fn) {
	        var _this23 = this;
	
	        var nodes = this.getNodesInternal().map(function (n, i) {
	          return fn.call(_this23, _this23.wrap(n), i);
	        });
	        var flattened = (0, _flatten2['default'])(nodes, true);
	        var uniques = (0, _uniq2['default'])(flattened);
	        var compacted = (0, _compact2['default'])(uniques);
	        return this.wrap(compacted);
	      }
	
	      return flatMap;
	    }()
	
	    /**
	     * Finds all nodes in the current wrapper nodes' render trees that match the provided predicate
	     * function.
	     *
	     * @param {Function} predicate
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'findWhere',
	    value: function () {
	      function findWhere(predicate) {
	        var _this24 = this;
	
	        return findWhereUnwrapped(this, function (n) {
	          return predicate(_this24.wrap(n));
	        });
	      }
	
	      return findWhere;
	    }()
	
	    /**
	     * Returns the node at a given index of the current wrapper.
	     *
	     * @param {Number} index
	     * @returns {ReactElement}
	     */
	
	  }, {
	    key: 'get',
	    value: function () {
	      function get(index) {
	        return this.getElements()[index];
	      }
	
	      return get;
	    }()
	
	    /**
	     * Returns a wrapper around the node at a given index of the current wrapper.
	     *
	     * @param {Number} index
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'at',
	    value: function () {
	      function at(index) {
	        return this.wrap(this.getNodesInternal()[index]);
	      }
	
	      return at;
	    }()
	
	    /**
	     * Returns a wrapper around the first node of the current wrapper.
	     *
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'first',
	    value: function () {
	      function first() {
	        return this.at(0);
	      }
	
	      return first;
	    }()
	
	    /**
	     * Returns a wrapper around the last node of the current wrapper.
	     *
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'last',
	    value: function () {
	      function last() {
	        return this.at(this.length - 1);
	      }
	
	      return last;
	    }()
	
	    /**
	     * Delegates to exists()
	     *
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'isEmpty',
	    value: function () {
	      function isEmpty() {
	        // eslint-disable-next-line no-console
	        console.warn('Enzyme::Deprecated method isEmpty() called, use exists() instead.');
	        return !this.exists();
	      }
	
	      return isEmpty;
	    }()
	
	    /**
	     * Returns true if the current wrapper has nodes. False otherwise.
	     *
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'exists',
	    value: function () {
	      function exists() {
	        return this.length > 0;
	      }
	
	      return exists;
	    }()
	
	    /**
	     * Utility method that throws an error if the current instance has a length other than one.
	     * This is primarily used to enforce that certain methods are only run on a wrapper when it is
	     * wrapping a single node.
	     *
	     * @param {Function} fn
	     * @returns {*}
	     */
	
	  }, {
	    key: 'single',
	    value: function () {
	      function single(name, fn) {
	        var fnName = typeof name === 'string' ? name : 'unknown';
	        var callback = typeof fn === 'function' ? fn : name;
	        if (this.length !== 1) {
	          throw new Error('Method \u201C' + fnName + '\u201D is only meant to be run on a single node. ' + String(this.length) + ' found instead.');
	        }
	        return callback.call(this, this.getNodeInternal());
	      }
	
	      return single;
	    }()
	
	    /**
	     * Helpful utility method to create a new wrapper with the same root as the current wrapper, with
	     * any nodes passed in as the first parameter automatically wrapped.
	     *
	     * @param {ReactWrapper|ReactElement|Array<ReactElement>} node
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'wrap',
	    value: function () {
	      function wrap(node) {
	        var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this[ROOT];
	
	        if (node instanceof ReactWrapper) {
	          return node;
	        }
	
	        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	          args[_key - 2] = arguments[_key];
	        }
	
	        return new (Function.prototype.bind.apply(ReactWrapper, [null].concat([node, root], args)))();
	      }
	
	      return wrap;
	    }()
	
	    /**
	     * Returns an HTML-like string of the shallow render for debugging purposes.
	     *
	     * @param {Object} options - (Optional) Property bag of additional options.
	     * options.ignoreProps - if true, props are omitted from the string.
	     * @returns {String}
	     */
	
	  }, {
	    key: 'debug',
	    value: function () {
	      function debug() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return (0, _Debug.debugNodes)(this.getNodesInternal(), options);
	      }
	
	      return debug;
	    }()
	
	    /**
	     * Invokes intercepter and returns itself. intercepter is called with itself.
	     * This is helpful when debugging nodes in method chains.
	     * @param fn
	     * @returns {ReactWrapper}
	     */
	
	  }, {
	    key: 'tap',
	    value: function () {
	      function tap(intercepter) {
	        intercepter(this);
	        return this;
	      }
	
	      return tap;
	    }()
	
	    /**
	     * Detaches the react tree from the DOM. Runs `ReactDOM.unmountComponentAtNode()` under the hood.
	     *
	     * This method will most commonly be used as a "cleanup" method if you decide to use the
	     * `attachTo` option in `mount(node, options)`.
	     *
	     * The method is intentionally not "fluent" (in that it doesn't return `this`) because you should
	     * not be doing anything with this wrapper after this method is called.
	     */
	
	  }, {
	    key: 'detach',
	    value: function () {
	      function detach() {
	        if (this[ROOT] !== this) {
	          throw new Error('ReactWrapper::detach() can only be called on the root');
	        }
	        if (!this[OPTIONS].attachTo) {
	          throw new Error('ReactWrapper::detach() can only be called on when the `attachTo` option was passed into `mount()`.');
	        }
	        this[RENDERER].unmount();
	      }
	
	      return detach;
	    }()
	
	    /**
	     * Strips out all the not host-nodes from the list of nodes
	     *
	     * This method is useful if you want to check for the presence of host nodes
	     * (actually rendered HTML elements) ignoring the React nodes.
	     */
	
	  }, {
	    key: 'hostNodes',
	    value: function () {
	      function hostNodes() {
	        return this.filterWhere(function (n) {
	          return typeof n.type() === 'string';
	        });
	      }
	
	      return hostNodes;
	    }()
	  }]);
	
	  return ReactWrapper;
	}();
	
	if (_Utils.ITERATOR_SYMBOL) {
	  Object.defineProperty(ReactWrapper.prototype, _Utils.ITERATOR_SYMBOL, {
	    configurable: true,
	    value: function () {
	      function iterator() {
	        var iter = this[NODES][_Utils.ITERATOR_SYMBOL]();
	        var adapter = (0, _Utils.getAdapter)(this[OPTIONS]);
	        return {
	          next: function () {
	            function next() {
	              var next = iter.next();
	              if (next.done) {
	                return { done: true };
	              }
	              return {
	                done: false,
	                value: adapter.nodeToElement(next.value)
	              };
	            }
	
	            return next;
	          }()
	        };
	      }
	
	      return iterator;
	    }()
	  });
	}
	
	function privateWarning(prop, extraMessage) {
	  Object.defineProperty(ReactWrapper.prototype, prop, {
	    get: function () {
	      function get() {
	        throw new Error('\n        Attempted to access ReactWrapper::' + String(prop) + ', which was previously a private property on\n        Enzyme ReactWrapper instances, but is no longer and should not be relied upon.\n        ' + String(extraMessage) + '\n      ');
	      }
	
	      return get;
	    }(),
	
	    enumerable: false,
	    configurable: false
	  });
	}
	
	privateWarning('node', 'Consider using the getElement() method instead.');
	privateWarning('nodes', 'Consider using the getElements() method instead.');
	privateWarning('renderer', '');
	privateWarning('options', '');
	privateWarning('complexSelector', '');
	
	exports['default'] = ReactWrapper;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(86);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _flatten = __webpack_require__(183);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _uniq = __webpack_require__(185);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _compact = __webpack_require__(467);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _cheerio = __webpack_require__(383);
	
	var _cheerio2 = _interopRequireDefault(_cheerio);
	
	var _Utils = __webpack_require__(216);
	
	var _Debug = __webpack_require__(602);
	
	var _RSTTraversal = __webpack_require__(215);
	
	var _selectors = __webpack_require__(608);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NODE = (0, _Utils.sym)('__node__');
	var NODES = (0, _Utils.sym)('__nodes__');
	var RENDERER = (0, _Utils.sym)('__renderer__');
	var UNRENDERED = (0, _Utils.sym)('__unrendered__');
	var ROOT = (0, _Utils.sym)('__root__');
	var OPTIONS = (0, _Utils.sym)('__options__');
	/**
	 * Finds all nodes in the current wrapper nodes' render trees that match the provided predicate
	 * function.
	 *
	 * @param {ShallowWrapper} wrapper
	 * @param {Function} predicate
	 * @param {Function} filter
	 * @returns {ShallowWrapper}
	 */
	function findWhereUnwrapped(wrapper, predicate) {
	  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _RSTTraversal.treeFilter;
	
	  return wrapper.flatMap(function (n) {
	    return filter(n.getNodeInternal(), predicate);
	  });
	}
	
	/**
	 * Returns a new wrapper instance with only the nodes of the current wrapper instance that match
	 * the provided predicate function.
	 *
	 * @param {ShallowWrapper} wrapper
	 * @param {Function} predicate
	 * @returns {ShallowWrapper}
	 */
	function filterWhereUnwrapped(wrapper, predicate) {
	  return wrapper.wrap((0, _compact2['default'])(wrapper.getNodesInternal().filter(predicate)));
	}
	
	/**
	 * Ensure options passed to ShallowWrapper are valid. Throws otherwise.
	 * @param {Object} options
	 */
	function validateOptions(options) {
	  var lifecycleExperimental = options.lifecycleExperimental,
	      disableLifecycleMethods = options.disableLifecycleMethods;
	
	  if (typeof lifecycleExperimental !== 'undefined' && typeof lifecycleExperimental !== 'boolean') {
	    throw new Error('lifecycleExperimental must be either true or false if provided');
	  }
	
	  if (typeof disableLifecycleMethods !== 'undefined' && typeof disableLifecycleMethods !== 'boolean') {
	    throw new Error('disableLifecycleMethods must be either true or false if provided');
	  }
	
	  if (lifecycleExperimental != null && disableLifecycleMethods != null && lifecycleExperimental === disableLifecycleMethods) {
	    throw new Error('lifecycleExperimental and disableLifecycleMethods cannot be set to the same value');
	  }
	}
	
	function getRootNode(node) {
	  if (node.nodeType === 'host') {
	    return node;
	  }
	  return node.rendered;
	}
	
	/**
	 * @class ShallowWrapper
	 */
	
	var ShallowWrapper = function () {
	  function ShallowWrapper(nodes, root) {
	    var passedOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    _classCallCheck(this, ShallowWrapper);
	
	    validateOptions(passedOptions);
	    var options = (0, _Utils.makeOptions)(passedOptions);
	    if (!root) {
	      (0, _Utils.privateSet)(this, ROOT, this);
	      (0, _Utils.privateSet)(this, UNRENDERED, nodes);
	      var renderer = (0, _Utils.getAdapter)(options).createRenderer((0, _object2['default'])({ mode: 'shallow' }, options));
	      (0, _Utils.privateSet)(this, RENDERER, renderer);
	      this[RENDERER].render(nodes, options.context);
	
	      var _RENDERER$getNode = this[RENDERER].getNode(),
	          instance = _RENDERER$getNode.instance;
	
	      if (!options.disableLifecycleMethods && instance && typeof instance.componentDidMount === 'function') {
	        this[RENDERER].batchedUpdates(function () {
	          instance.componentDidMount();
	        });
	      }
	      (0, _Utils.privateSet)(this, NODE, getRootNode(this[RENDERER].getNode()));
	      (0, _Utils.privateSet)(this, NODES, [this[NODE]]);
	      this.length = 1;
	    } else {
	      (0, _Utils.privateSet)(this, ROOT, root);
	      (0, _Utils.privateSet)(this, UNRENDERED, null);
	      (0, _Utils.privateSet)(this, RENDERER, root[RENDERER]);
	      if (!Array.isArray(nodes)) {
	        (0, _Utils.privateSet)(this, NODE, nodes);
	        (0, _Utils.privateSet)(this, NODES, [nodes]);
	      } else {
	        (0, _Utils.privateSet)(this, NODE, nodes[0]);
	        (0, _Utils.privateSet)(this, NODES, nodes);
	      }
	      this.length = this[NODES].length;
	    }
	    (0, _Utils.privateSet)(this, OPTIONS, root ? root[OPTIONS] : options);
	  }
	
	  /**
	   * Returns the root wrapper
	   *
	   * @return {ShallowWrapper}
	   */
	
	
	  _createClass(ShallowWrapper, [{
	    key: 'root',
	    value: function () {
	      function root() {
	        return this[ROOT];
	      }
	
	      return root;
	    }()
	  }, {
	    key: 'getNodeInternal',
	    value: function () {
	      function getNodeInternal() {
	        if (this.length !== 1) {
	          throw new Error('ShallowWrapper::getNode() can only be called when wrapping one node');
	        }
	        return this[NODE];
	      }
	
	      return getNodeInternal;
	    }()
	
	    /**
	     * Returns the wrapped ReactElement.
	     *
	     * @return {ReactElement}
	     */
	
	  }, {
	    key: 'getElement',
	    value: function () {
	      function getElement() {
	        if (this.length !== 1) {
	          throw new Error('ShallowWrapper::getElement() can only be called when wrapping one node');
	        }
	        return (0, _Utils.getAdapter)(this[OPTIONS]).nodeToElement(this[NODE]);
	      }
	
	      return getElement;
	    }()
	
	    /**
	     * Returns the wrapped ReactElements.
	     *
	     * @return {Array<ReactElement>}
	     */
	
	  }, {
	    key: 'getElements',
	    value: function () {
	      function getElements() {
	        return this[NODES].map((0, _Utils.getAdapter)(this[OPTIONS]).nodeToElement);
	      }
	
	      return getElements;
	    }()
	
	    // eslint-disable-next-line class-methods-use-this
	
	  }, {
	    key: 'getNode',
	    value: function () {
	      function getNode() {
	        throw new Error('ShallowWrapper::getNode() is no longer supported. Use ShallowWrapper::getElement() instead');
	      }
	
	      return getNode;
	    }()
	  }, {
	    key: 'getNodesInternal',
	    value: function () {
	      function getNodesInternal() {
	        return this[NODES];
	      }
	
	      return getNodesInternal;
	    }()
	
	    // eslint-disable-next-line class-methods-use-this
	
	  }, {
	    key: 'getNodes',
	    value: function () {
	      function getNodes() {
	        throw new Error('ShallowWrapper::getNodes() is no longer supported. Use ShallowWrapper::getElements() instead');
	      }
	
	      return getNodes;
	    }()
	
	    /**
	     * Gets the instance of the component being rendered as the root node passed into `shallow()`.
	     *
	     * NOTE: can only be called on a wrapper instance that is also the root instance.
	     *
	     * Example:
	     * ```
	     * const wrapper = shallow(<MyComponent />);
	     * const inst = wrapper.instance();
	     * expect(inst).to.be.instanceOf(MyComponent);
	     * ```
	     * @returns {ReactComponent}
	     */
	
	  }, {
	    key: 'instance',
	    value: function () {
	      function instance() {
	        if (this[ROOT] !== this) {
	          throw new Error('ShallowWrapper::instance() can only be called on the root');
	        }
	        return this[RENDERER].getNode().instance;
	      }
	
	      return instance;
	    }()
	
	    /**
	     * Forces a re-render. Useful to run before checking the render output if something external
	     * may be updating the state of the component somewhere.
	     *
	     * NOTE: can only be called on a wrapper instance that is also the root instance.
	     *
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'update',
	    value: function () {
	      function update() {
	        var _this = this;
	
	        if (this[ROOT] !== this) {
	          throw new Error('ShallowWrapper::update() can only be called on the root');
	        }
	        this.single('update', function () {
	          _this[NODE] = getRootNode(_this[RENDERER].getNode());
	          _this[NODES] = [_this[NODE]];
	        });
	        return this;
	      }
	
	      return update;
	    }()
	
	    /**
	     * A method is for re-render with new props and context.
	     * This calls componentDidUpdate method if disableLifecycleMethods is not enabled.
	     *
	     * NOTE: can only be called on a wrapper instance that is also the root instance.
	     *
	     * @param {Object} props
	     * @param {Object} context
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'rerender',
	    value: function () {
	      function rerender(props, context) {
	        var _this2 = this;
	
	        var adapter = (0, _Utils.getAdapter)(this[OPTIONS]);
	        this.single('rerender', function () {
	          (0, _Utils.withSetStateAllowed)(function () {
	            // NOTE(lmr): In react 16, instances will be null for SFCs, but
	            // rerendering with props/context is still a valid thing to do. In
	            // this case, state will be undefined, but props/context will exist.
	            var instance = _this2.instance() || {};
	            var state = instance.state;
	
	            var prevProps = instance.props || _this2[UNRENDERED].props;
	            var prevContext = instance.context || _this2[OPTIONS].context;
	            var nextProps = (0, _object2['default'])({}, prevProps, props);
	            var nextContext = context || prevContext;
	            if (context) {
	              _this2[OPTIONS] = (0, _object2['default'])({}, _this2[OPTIONS], { context: nextContext });
	            }
	            _this2[RENDERER].batchedUpdates(function () {
	              var shouldRender = true;
	              // dirty hack:
	              // make sure that componentWillReceiveProps is called before shouldComponentUpdate
	              var originalComponentWillReceiveProps = void 0;
	              if (!_this2[OPTIONS].disableLifecycleMethods && instance && typeof instance.componentWillReceiveProps === 'function') {
	                instance.componentWillReceiveProps(nextProps, nextContext);
	                originalComponentWillReceiveProps = instance.componentWillReceiveProps;
	                instance.componentWillReceiveProps = function () {};
	              }
	              // dirty hack: avoid calling shouldComponentUpdate twice
	              var originalShouldComponentUpdate = void 0;
	              if (!_this2[OPTIONS].disableLifecycleMethods && instance && typeof instance.shouldComponentUpdate === 'function') {
	                shouldRender = instance.shouldComponentUpdate(nextProps, state, nextContext);
	                originalShouldComponentUpdate = instance.shouldComponentUpdate;
	              }
	              if (shouldRender) {
	                if (props) _this2[UNRENDERED] = (0, _Utils.cloneElement)(adapter, _this2[UNRENDERED], props);
	                if (originalShouldComponentUpdate) {
	                  instance.shouldComponentUpdate = function () {
	                    return true;
	                  };
	                }
	
	                _this2[RENDERER].render(_this2[UNRENDERED], nextContext);
	
	                if (originalShouldComponentUpdate) {
	                  instance.shouldComponentUpdate = originalShouldComponentUpdate;
	                }
	                if (!_this2[OPTIONS].disableLifecycleMethods && instance && typeof instance.componentDidUpdate === 'function') {
	                  if (adapter.options.supportPrevContextArgumentOfComponentDidUpdate) {
	                    instance.componentDidUpdate(prevProps, state, prevContext);
	                  } else {
	                    instance.componentDidUpdate(prevProps, state);
	                  }
	                }
	                _this2.update();
	                // If it doesn't need to rerender, update only its props.
	              } else if (props) {
	                instance.props = props;
	              }
	              if (originalComponentWillReceiveProps) {
	                instance.componentWillReceiveProps = originalComponentWillReceiveProps;
	              }
	            });
	          });
	        });
	        return this;
	      }
	
	      return rerender;
	    }()
	
	    /**
	     * A method that sets the props of the root component, and re-renders. Useful for when you are
	     * wanting to test how the component behaves over time with changing props. Calling this, for
	     * instance, will call the `componentWillReceiveProps` lifecycle method.
	     *
	     * Similar to `setState`, this method accepts a props object and will merge it in with the already
	     * existing props.
	     *
	     * NOTE: can only be called on a wrapper instance that is also the root instance.
	     *
	     * @param {Object} props object
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'setProps',
	    value: function () {
	      function setProps(props) {
	        if (this[ROOT] !== this) {
	          throw new Error('ShallowWrapper::setProps() can only be called on the root');
	        }
	        return this.rerender(props);
	      }
	
	      return setProps;
	    }()
	
	    /**
	     * A method to invoke `setState` on the root component instance similar to how you might in the
	     * definition of the component, and re-renders.  This method is useful for testing your component
	     * in hard to achieve states, however should be used sparingly. If possible, you should utilize
	     * your component's external API in order to get it into whatever state you want to test, in order
	     * to be as accurate of a test as possible. This is not always practical, however.
	     *
	     * NOTE: can only be called on a wrapper instance that is also the root instance.
	     *
	     * @param {Object} state to merge
	     * @param {Function} cb - callback function
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'setState',
	    value: function () {
	      function setState(state) {
	        var _this3 = this;
	
	        var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
	        if (this[ROOT] !== this) {
	          throw new Error('ShallowWrapper::setState() can only be called on the root');
	        }
	        if (this.instance() === null || this[RENDERER].getNode().nodeType === 'function') {
	          throw new Error('ShallowWrapper::setState() can only be called on class components');
	        }
	        this.single('setState', function () {
	          (0, _Utils.withSetStateAllowed)(function () {
	            var adapter = (0, _Utils.getAdapter)(_this3[OPTIONS]);
	            var instance = _this3.instance();
	            var prevProps = instance.props;
	            var prevState = instance.state;
	            var prevContext = instance.context;
	            var shouldRender = true;
	            // This is a dirty hack but it requires to know the result of shouldComponentUpdate.
	            // When shouldComponentUpdate returns false we shouldn't call componentDidUpdate.
	            // shouldComponentUpdate is called in `instance.setState`
	            // so we replace shouldComponentUpdate to know the result and restore it later.
	            var originalShouldComponentUpdate = void 0;
	            if (!_this3[OPTIONS].disableLifecycleMethods && adapter.options.enableComponentDidUpdateOnSetState && instance && typeof instance.shouldComponentUpdate === 'function') {
	              originalShouldComponentUpdate = instance.shouldComponentUpdate;
	              instance.shouldComponentUpdate = function () {
	                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                  args[_key] = arguments[_key];
	                }
	
	                shouldRender = originalShouldComponentUpdate.apply(instance, args);
	                instance.shouldComponentUpdate = originalShouldComponentUpdate;
	                return shouldRender;
	              };
	            }
	            instance.setState(state, callback);
	            if (shouldRender && !_this3[OPTIONS].disableLifecycleMethods && adapter.options.enableComponentDidUpdateOnSetState && instance && typeof instance.componentDidUpdate === 'function') {
	              if (adapter.options.supportPrevContextArgumentOfComponentDidUpdate) {
	                instance.componentDidUpdate(prevProps, prevState, prevContext);
	              } else {
	                instance.componentDidUpdate(prevProps, prevState);
	              }
	            }
	            _this3.update();
	          });
	        });
	        return this;
	      }
	
	      return setState;
	    }()
	
	    /**
	     * A method that sets the context of the root component, and re-renders. Useful for when you are
	     * wanting to test how the component behaves over time with changing contexts.
	     *
	     * NOTE: can only be called on a wrapper instance that is also the root instance.
	     *
	     * @param {Object} context object
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'setContext',
	    value: function () {
	      function setContext(context) {
	        if (this[ROOT] !== this) {
	          throw new Error('ShallowWrapper::setContext() can only be called on the root');
	        }
	        if (!this[OPTIONS].context) {
	          throw new Error('ShallowWrapper::setContext() can only be called on a wrapper that was originally passed a context option');
	        }
	        return this.rerender(null, context);
	      }
	
	      return setContext;
	    }()
	
	    /**
	     * Whether or not a given react element exists in the shallow render tree.
	     *
	     * Example:
	     * ```
	     * const wrapper = shallow(<MyComponent />);
	     * expect(wrapper.contains(<div className="foo bar" />)).to.equal(true);
	     * ```
	     *
	     * @param {ReactElement|Array<ReactElement>} nodeOrNodes
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'contains',
	    value: function () {
	      function contains(nodeOrNodes) {
	        var adapter = (0, _Utils.getAdapter)(this[OPTIONS]);
	        if (!(0, _Utils.isReactElementAlike)(nodeOrNodes, adapter)) {
	          throw new Error('ShallowWrapper::contains() can only be called with ReactElement (or array of them), string or number as argument.');
	        }
	        var predicate = Array.isArray(nodeOrNodes) ? function (other) {
	          return (0, _Utils.containsChildrenSubArray)(_Utils.nodeEqual, other, nodeOrNodes.map(adapter.elementToNode));
	        } : function (other) {
	          return (0, _Utils.nodeEqual)(adapter.elementToNode(nodeOrNodes), other);
	        };
	
	        return findWhereUnwrapped(this, predicate).length > 0;
	      }
	
	      return contains;
	    }()
	
	    /**
	     * Whether or not a given react element exists in the shallow render tree.
	     * Match is based on the expected element and not on wrappers element.
	     * It will determine if one of the wrappers element "looks like" the expected
	     * element by checking if all props of the expected element are present
	     * on the wrappers element and equals to each other.
	     *
	     * Example:
	     * ```
	     * // MyComponent outputs <div><div class="foo">Hello</div></div>
	     * const wrapper = shallow(<MyComponent />);
	     * expect(wrapper.containsMatchingElement(<div>Hello</div>)).to.equal(true);
	     * ```
	     *
	     * @param {ReactElement} node
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'containsMatchingElement',
	    value: function () {
	      function containsMatchingElement(node) {
	        var predicate = function () {
	          function predicate(other) {
	            return (0, _Utils.nodeMatches)(node, other, function (a, b) {
	              return a <= b;
	            });
	          }
	
	          return predicate;
	        }();
	        return findWhereUnwrapped(this, predicate).length > 0;
	      }
	
	      return containsMatchingElement;
	    }()
	
	    /**
	     * Whether or not all the given react elements exists in the shallow render tree.
	     * Match is based on the expected element and not on wrappers element.
	     * It will determine if one of the wrappers element "looks like" the expected
	     * element by checking if all props of the expected element are present
	     * on the wrappers element and equals to each other.
	     *
	     * Example:
	     * ```
	     * const wrapper = shallow(<MyComponent />);
	     * expect(wrapper.containsAllMatchingElements([
	     *   <div>Hello</div>,
	     *   <div>Goodbye</div>,
	     * ])).to.equal(true);
	     * ```
	     *
	     * @param {Array<ReactElement>} nodes
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'containsAllMatchingElements',
	    value: function () {
	      function containsAllMatchingElements(nodes) {
	        var _this4 = this;
	
	        if (!Array.isArray(nodes)) {
	          throw new TypeError('nodes should be an Array');
	        }
	
	        return nodes.every(function (node) {
	          return _this4.containsMatchingElement(node);
	        });
	      }
	
	      return containsAllMatchingElements;
	    }()
	
	    /**
	     * Whether or not one of the given react elements exists in the shallow render tree.
	     * Match is based on the expected element and not on wrappers element.
	     * It will determine if one of the wrappers element "looks like" the expected
	     * element by checking if all props of the expected element are present
	     * on the wrappers element and equals to each other.
	     *
	     * Example:
	     * ```
	     * const wrapper = shallow(<MyComponent />);
	     * expect(wrapper.containsAnyMatchingElements([
	     *   <div>Hello</div>,
	     *   <div>Goodbye</div>,
	     * ])).to.equal(true);
	     * ```
	     *
	     * @param {Array<ReactElement>} nodes
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'containsAnyMatchingElements',
	    value: function () {
	      function containsAnyMatchingElements(nodes) {
	        var _this5 = this;
	
	        return Array.isArray(nodes) && nodes.some(function (node) {
	          return _this5.containsMatchingElement(node);
	        });
	      }
	
	      return containsAnyMatchingElements;
	    }()
	
	    /**
	     * Whether or not a given react element exists in the shallow render tree.
	     *
	     * Example:
	     * ```
	     * const wrapper = shallow(<MyComponent />);
	     * expect(wrapper.contains(<div className="foo bar" />)).to.equal(true);
	     * ```
	     *
	     * @param {ReactElement} node
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'equals',
	    value: function () {
	      function equals(node) {
	        var _this6 = this;
	
	        return this.single('equals', function () {
	          return (0, _Utils.nodeEqual)(_this6.getNodeInternal(), node);
	        });
	      }
	
	      return equals;
	    }()
	
	    /**
	     * Whether or not a given react element matches the shallow render tree.
	     * Match is based on the expected element and not on wrapper root node.
	     * It will determine if the wrapper root node "looks like" the expected
	     * element by checking if all props of the expected element are present
	     * on the wrapper root node and equals to each other.
	     *
	     * Example:
	     * ```
	     * // MyComponent outputs <div class="foo">Hello</div>
	     * const wrapper = shallow(<MyComponent />);
	     * expect(wrapper.matchesElement(<div>Hello</div>)).to.equal(true);
	     * ```
	     *
	     * @param {ReactElement} node
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'matchesElement',
	    value: function () {
	      function matchesElement(node) {
	        var _this7 = this;
	
	        return this.single('matchesElement', function () {
	          return (0, _Utils.nodeMatches)(node, _this7.getNodeInternal(), function (a, b) {
	            return a <= b;
	          });
	        });
	      }
	
	      return matchesElement;
	    }()
	
	    /**
	     * Finds every node in the render tree of the current wrapper that matches the provided selector.
	     *
	     * @param {String|Function} selector
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'find',
	    value: function () {
	      function find(selector) {
	        return this.wrap((0, _selectors.reduceTreesBySelector)(selector, this.getNodesInternal()));
	      }
	
	      return find;
	    }()
	
	    /**
	     * Returns whether or not current node matches a provided selector.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @param {String|Function} selector
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'is',
	    value: function () {
	      function is(selector) {
	        var predicate = (0, _selectors.buildPredicate)(selector);
	        return this.single('is', function (n) {
	          return predicate(n);
	        });
	      }
	
	      return is;
	    }()
	
	    /**
	     * Returns true if the component rendered nothing, i.e., null or false.
	     *
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'isEmptyRender',
	    value: function () {
	      function isEmptyRender() {
	        return this.type() === null;
	      }
	
	      return isEmptyRender;
	    }()
	
	    /**
	     * Returns a new wrapper instance with only the nodes of the current wrapper instance that match
	     * the provided predicate function. The predicate should receive a wrapped node as its first
	     * argument.
	     *
	     * @param {Function} predicate
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'filterWhere',
	    value: function () {
	      function filterWhere(predicate) {
	        var _this8 = this;
	
	        return filterWhereUnwrapped(this, function (n) {
	          return predicate(_this8.wrap(n));
	        });
	      }
	
	      return filterWhere;
	    }()
	
	    /**
	     * Returns a new wrapper instance with only the nodes of the current wrapper instance that match
	     * the provided selector.
	     *
	     * @param {String|Function} selector
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'filter',
	    value: function () {
	      function filter(selector) {
	        var predicate = (0, _selectors.buildPredicate)(selector);
	        return filterWhereUnwrapped(this, predicate);
	      }
	
	      return filter;
	    }()
	
	    /**
	     * Returns a new wrapper instance with only the nodes of the current wrapper that did not match
	     * the provided selector. Essentially the inverse of `filter`.
	     *
	     * @param {String|Function} selector
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'not',
	    value: function () {
	      function not(selector) {
	        var predicate = (0, _selectors.buildPredicate)(selector);
	        return filterWhereUnwrapped(this, function (n) {
	          return !predicate(n);
	        });
	      }
	
	      return not;
	    }()
	
	    /**
	     * Returns a string of the rendered text of the current render tree.  This function should be
	     * looked at with skepticism if being used to test what the actual HTML output of the component
	     * will be. If that is what you would like to test, use enzyme's `render` function instead.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @returns {String}
	     */
	
	  }, {
	    key: 'text',
	    value: function () {
	      function text() {
	        return this.single('text', _RSTTraversal.getTextFromNode);
	      }
	
	      return text;
	    }()
	
	    /**
	     * Returns the HTML of the node.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @returns {String}
	     */
	
	  }, {
	    key: 'html',
	    value: function () {
	      function html() {
	        var _this9 = this;
	
	        return this.single('html', function (n) {
	          if (_this9.type() === null) return null;
	          var adapter = (0, _Utils.getAdapter)(_this9[OPTIONS]);
	          var renderer = adapter.createRenderer((0, _object2['default'])({}, _this9[OPTIONS], { mode: 'string' }));
	          return renderer.render(adapter.nodeToElement(n));
	        });
	      }
	
	      return html;
	    }()
	
	    /**
	     * Returns the current node rendered to HTML and wrapped in a CheerioWrapper.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @returns {CheerioWrapper}
	     */
	
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        return this.type() === null ? (0, _cheerio2['default'])() : _cheerio2['default'].load('')(this.html());
	      }
	
	      return render;
	    }()
	
	    /**
	     * A method that unmounts the component. This can be used to simulate a component going through
	     * and unmount/mount lifecycle.
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'unmount',
	    value: function () {
	      function unmount() {
	        this[RENDERER].unmount();
	        return this;
	      }
	
	      return unmount;
	    }()
	
	    /**
	     * Used to simulate events. Pass an eventname and (optionally) event arguments. This method of
	     * testing events should be met with some skepticism.
	     *
	     * @param {String} event
	     * @param {Array} args
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'simulate',
	    value: function () {
	      function simulate(event) {
	        var _this10 = this;
	
	        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	          args[_key2 - 1] = arguments[_key2];
	        }
	
	        return this.single('simulate', function (n) {
	          var _RENDERER;
	
	          (_RENDERER = _this10[RENDERER]).simulateEvent.apply(_RENDERER, [n, event].concat(args));
	          _this10[ROOT].update();
	        });
	      }
	
	      return simulate;
	    }()
	
	    /**
	     * Returns the props hash for the current node of the wrapper.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @returns {Object}
	     */
	
	  }, {
	    key: 'props',
	    value: function () {
	      function props() {
	        return this.single('props', _RSTTraversal.propsOfNode);
	      }
	
	      return props;
	    }()
	
	    /**
	     * Returns the state hash for the root node of the wrapper. Optionally pass in a prop name and it
	     * will return just that value.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @param {String} name (optional)
	     * @returns {*}
	     */
	
	  }, {
	    key: 'state',
	    value: function () {
	      function state(name) {
	        var _this11 = this;
	
	        if (this[ROOT] !== this) {
	          throw new Error('ShallowWrapper::state() can only be called on the root');
	        }
	        if (this.instance() === null || this[RENDERER].getNode().nodeType === 'function') {
	          throw new Error('ShallowWrapper::state() can only be called on class components');
	        }
	        var _state = this.single('state', function () {
	          return _this11.instance().state;
	        });
	        if (typeof name !== 'undefined') {
	          return _state[name];
	        }
	        return _state;
	      }
	
	      return state;
	    }()
	
	    /**
	     * Returns the context hash for the root node of the wrapper.
	     * Optionally pass in a prop name and it will return just that value.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @param {String} name (optional)
	     * @returns {*}
	     */
	
	  }, {
	    key: 'context',
	    value: function () {
	      function context(name) {
	        var _this12 = this;
	
	        if (this[ROOT] !== this) {
	          throw new Error('ShallowWrapper::context() can only be called on the root');
	        }
	        if (!this[OPTIONS].context) {
	          throw new Error('ShallowWrapper::context() can only be called on a wrapper that was originally passed a context option');
	        }
	        if (this.instance() === null) {
	          throw new Error('ShallowWrapper::context() can only be called on wrapped nodes that have a non-null instance');
	        }
	        var _context = this.single('context', function () {
	          return _this12.instance().context;
	        });
	        if (name) {
	          return _context[name];
	        }
	        return _context;
	      }
	
	      return context;
	    }()
	
	    /**
	     * Returns a new wrapper with all of the children of the current wrapper.
	     *
	     * @param {String|Function} [selector]
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'children',
	    value: function () {
	      function children(selector) {
	        var allChildren = this.flatMap(function (n) {
	          return (0, _RSTTraversal.childrenOfNode)(n.getNodeInternal());
	        });
	        return selector ? allChildren.filter(selector) : allChildren;
	      }
	
	      return children;
	    }()
	
	    /**
	     * Returns a new wrapper with a specific child
	     *
	     * @param {Number} [index]
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'childAt',
	    value: function () {
	      function childAt(index) {
	        var _this13 = this;
	
	        return this.single('childAt', function () {
	          return _this13.children().at(index);
	        });
	      }
	
	      return childAt;
	    }()
	
	    /**
	     * Returns a wrapper around all of the parents/ancestors of the wrapper. Does not include the node
	     * in the current wrapper.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @param {String|Function} [selector]
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'parents',
	    value: function () {
	      function parents(selector) {
	        var _this14 = this;
	
	        var allParents = this.wrap(this.single('parents', function (n) {
	          return (0, _RSTTraversal.parentsOfNode)(n, _this14[ROOT][NODE]);
	        }));
	        return selector ? allParents.filter(selector) : allParents;
	      }
	
	      return parents;
	    }()
	
	    /**
	     * Returns a wrapper around the immediate parent of the current node.
	     *
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'parent',
	    value: function () {
	      function parent() {
	        return this.flatMap(function (n) {
	          return [n.parents().get(0)];
	        });
	      }
	
	      return parent;
	    }()
	
	    /**
	     *
	     * @param {String|Function} selector
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'closest',
	    value: function () {
	      function closest(selector) {
	        return this.is(selector) ? this : this.parents().filter(selector).first();
	      }
	
	      return closest;
	    }()
	
	    /**
	     * Shallow renders the current node and returns a shallow wrapper around it.
	     *
	     * NOTE: can only be called on wrapper of a single node.
	     *
	     * @param {Object} options
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'shallow',
	    value: function () {
	      function shallow(options) {
	        var _this15 = this;
	
	        return this.single('shallow', function (n) {
	          return _this15.wrap((0, _Utils.getAdapter)(_this15[OPTIONS]).nodeToElement(n), null, options);
	        });
	      }
	
	      return shallow;
	    }()
	
	    /**
	     * Returns the value of prop with the given name of the current node.
	     *
	     * @param propName
	     * @returns {*}
	     */
	
	  }, {
	    key: 'prop',
	    value: function () {
	      function prop(propName) {
	        return this.props()[propName];
	      }
	
	      return prop;
	    }()
	
	    /**
	     * Returns the key assigned to the current node.
	     *
	     * @returns {String}
	     */
	
	  }, {
	    key: 'key',
	    value: function () {
	      function key() {
	        return this.single('key', function (n) {
	          return n.key;
	        });
	      }
	
	      return key;
	    }()
	
	    /**
	     * Returns the type of the current node of this wrapper. If it's a composite component, this will
	     * be the component constructor. If it's a native DOM node, it will be a string.
	     *
	     * @returns {String|Function}
	     */
	
	  }, {
	    key: 'type',
	    value: function () {
	      function type() {
	        return this.single('type', _Utils.typeOfNode);
	      }
	
	      return type;
	    }()
	
	    /**
	     * Returns the name of the current node of this wrapper.
	     *
	     * In order of precedence => type.displayName -> type.name -> type.
	     *
	     * @returns {String}
	     */
	
	  }, {
	    key: 'name',
	    value: function () {
	      function name() {
	        return this.single('name', _Utils.displayNameOfNode);
	      }
	
	      return name;
	    }()
	
	    /**
	     * Returns whether or not the current node has the given class name or not.
	     *
	     * NOTE: can only be called on a wrapper of a single node.
	     *
	     * @param className
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'hasClass',
	    value: function () {
	      function hasClass(className) {
	        if (className && className.indexOf('.') !== -1) {
	          // eslint-disable-next-line no-console
	          console.warn('It looks like you\'re calling `ShallowWrapper::hasClass()` with a CSS selector. hasClass() expects a class name, not a CSS selector.');
	        }
	        return this.single('hasClass', function (n) {
	          return (0, _RSTTraversal.hasClassName)(n, className);
	        });
	      }
	
	      return hasClass;
	    }()
	
	    /**
	     * Iterates through each node of the current wrapper and executes the provided function with a
	     * wrapper around the corresponding node passed in as the first argument.
	     *
	     * @param {Function} fn
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'forEach',
	    value: function () {
	      function forEach(fn) {
	        var _this16 = this;
	
	        this.getNodesInternal().forEach(function (n, i) {
	          return fn.call(_this16, _this16.wrap(n), i);
	        });
	        return this;
	      }
	
	      return forEach;
	    }()
	
	    /**
	     * Maps the current array of nodes to another array. Each node is passed in as a `ShallowWrapper`
	     * to the map function.
	     *
	     * @param {Function} fn
	     * @returns {Array}
	     */
	
	  }, {
	    key: 'map',
	    value: function () {
	      function map(fn) {
	        var _this17 = this;
	
	        return this.getNodesInternal().map(function (n, i) {
	          return fn.call(_this17, _this17.wrap(n), i);
	        });
	      }
	
	      return map;
	    }()
	
	    /**
	     * Reduces the current array of nodes to a value. Each node is passed in as a `ShallowWrapper`
	     * to the reducer function.
	     *
	     * @param {Function} fn - the reducer function
	     * @param {*} initialValue - the initial value
	     * @returns {*}
	     */
	
	  }, {
	    key: 'reduce',
	    value: function () {
	      function reduce(fn) {
	        var _this18 = this;
	
	        var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
	        if (arguments.length > 1) {
	          return this.getNodesInternal().reduce(function (accum, n, i) {
	            return fn.call(_this18, accum, _this18.wrap(n), i);
	          }, initialValue);
	        }
	        return this.getNodesInternal().reduce(function (accum, n, i) {
	          return fn.call(_this18, i === 1 ? _this18.wrap(accum) : accum, _this18.wrap(n), i);
	        });
	      }
	
	      return reduce;
	    }()
	
	    /**
	     * Reduces the current array of nodes to another array, from right to left. Each node is passed
	     * in as a `ShallowWrapper` to the reducer function.
	     *
	     * @param {Function} fn - the reducer function
	     * @param {*} initialValue - the initial value
	     * @returns {*}
	     */
	
	  }, {
	    key: 'reduceRight',
	    value: function () {
	      function reduceRight(fn) {
	        var _this19 = this;
	
	        var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
	        if (arguments.length > 1) {
	          return this.getNodesInternal().reduceRight(function (accum, n, i) {
	            return fn.call(_this19, accum, _this19.wrap(n), i);
	          }, initialValue);
	        }
	        return this.getNodesInternal().reduceRight(function (accum, n, i) {
	          return fn.call(_this19, i === 1 ? _this19.wrap(accum) : accum, _this19.wrap(n), i);
	        });
	      }
	
	      return reduceRight;
	    }()
	
	    /**
	     * Returns a new wrapper with a subset of the nodes of the original wrapper, according to the
	     * rules of `Array#slice`.
	     *
	     * @param {Number} begin
	     * @param {Number} end
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'slice',
	    value: function () {
	      function slice(begin, end) {
	        return this.wrap(this.getNodesInternal().slice(begin, end));
	      }
	
	      return slice;
	    }()
	
	    /**
	     * Returns whether or not any of the nodes in the wrapper match the provided selector.
	     *
	     * @param {Function|String} selector
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'some',
	    value: function () {
	      function some(selector) {
	        if (this[ROOT] === this) {
	          throw new Error('ShallowWrapper::some() can not be called on the root');
	        }
	        var predicate = (0, _selectors.buildPredicate)(selector);
	        return this.getNodesInternal().some(predicate);
	      }
	
	      return some;
	    }()
	
	    /**
	     * Returns whether or not any of the nodes in the wrapper pass the provided predicate function.
	     *
	     * @param {Function} predicate
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'someWhere',
	    value: function () {
	      function someWhere(predicate) {
	        var _this20 = this;
	
	        return this.getNodesInternal().some(function (n, i) {
	          return predicate.call(_this20, _this20.wrap(n), i);
	        });
	      }
	
	      return someWhere;
	    }()
	
	    /**
	     * Returns whether or not all of the nodes in the wrapper match the provided selector.
	     *
	     * @param {Function|String} selector
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'every',
	    value: function () {
	      function every(selector) {
	        var predicate = (0, _selectors.buildPredicate)(selector);
	        return this.getNodesInternal().every(predicate);
	      }
	
	      return every;
	    }()
	
	    /**
	     * Returns whether or not any of the nodes in the wrapper pass the provided predicate function.
	     *
	     * @param {Function} predicate
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'everyWhere',
	    value: function () {
	      function everyWhere(predicate) {
	        var _this21 = this;
	
	        return this.getNodesInternal().every(function (n, i) {
	          return predicate.call(_this21, _this21.wrap(n), i);
	        });
	      }
	
	      return everyWhere;
	    }()
	
	    /**
	     * Utility method used to create new wrappers with a mapping function that returns an array of
	     * nodes in response to a single node wrapper. The returned wrapper is a single wrapper around
	     * all of the mapped nodes flattened (and de-duplicated).
	     *
	     * @param {Function} fn
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'flatMap',
	    value: function () {
	      function flatMap(fn) {
	        var _this22 = this;
	
	        var nodes = this.getNodesInternal().map(function (n, i) {
	          return fn.call(_this22, _this22.wrap(n), i);
	        });
	        var flattened = (0, _flatten2['default'])(nodes, true);
	        var uniques = (0, _uniq2['default'])(flattened);
	        var compacted = (0, _compact2['default'])(uniques);
	        return this.wrap(compacted);
	      }
	
	      return flatMap;
	    }()
	
	    /**
	     * Finds all nodes in the current wrapper nodes' render trees that match the provided predicate
	     * function. The predicate function will receive the nodes inside a ShallowWrapper as its
	     * first argument.
	     *
	     * @param {Function} predicate
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'findWhere',
	    value: function () {
	      function findWhere(predicate) {
	        var _this23 = this;
	
	        return findWhereUnwrapped(this, function (n) {
	          return predicate(_this23.wrap(n));
	        });
	      }
	
	      return findWhere;
	    }()
	
	    /**
	     * Returns the node at a given index of the current wrapper.
	     *
	     * @param index
	     * @returns {ReactElement}
	     */
	
	  }, {
	    key: 'get',
	    value: function () {
	      function get(index) {
	        return (0, _Utils.getAdapter)(this[OPTIONS]).nodeToElement(this.getNodesInternal()[index]);
	      }
	
	      return get;
	    }()
	
	    /**
	     * Returns a wrapper around the node at a given index of the current wrapper.
	     *
	     * @param index
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'at',
	    value: function () {
	      function at(index) {
	        return this.wrap(this.getNodesInternal()[index]);
	      }
	
	      return at;
	    }()
	
	    /**
	     * Returns a wrapper around the first node of the current wrapper.
	     *
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'first',
	    value: function () {
	      function first() {
	        return this.at(0);
	      }
	
	      return first;
	    }()
	
	    /**
	     * Returns a wrapper around the last node of the current wrapper.
	     *
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'last',
	    value: function () {
	      function last() {
	        return this.at(this.length - 1);
	      }
	
	      return last;
	    }()
	
	    /**
	     * Delegates to exists()
	     *
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'isEmpty',
	    value: function () {
	      function isEmpty() {
	        // eslint-disable-next-line no-console
	        console.warn('Enzyme::Deprecated method isEmpty() called, use exists() instead.');
	        return !this.exists();
	      }
	
	      return isEmpty;
	    }()
	
	    /**
	     * Returns true if the current wrapper has nodes. False otherwise.
	     *
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'exists',
	    value: function () {
	      function exists() {
	        return this.length > 0;
	      }
	
	      return exists;
	    }()
	
	    /**
	     * Utility method that throws an error if the current instance has a length other than one.
	     * This is primarily used to enforce that certain methods are only run on a wrapper when it is
	     * wrapping a single node.
	     *
	     * @param fn
	     * @returns {*}
	     */
	
	  }, {
	    key: 'single',
	    value: function () {
	      function single(name, fn) {
	        var fnName = typeof name === 'string' ? name : 'unknown';
	        var callback = typeof fn === 'function' ? fn : name;
	        if (this.length !== 1) {
	          throw new Error('Method \u201C' + fnName + '\u201D is only meant to be run on a single node. ' + String(this.length) + ' found instead.');
	        }
	        return callback.call(this, this.getNodeInternal());
	      }
	
	      return single;
	    }()
	
	    /**
	     * Helpful utility method to create a new wrapper with the same root as the current wrapper, with
	     * any nodes passed in as the first parameter automatically wrapped.
	     *
	     * @param node
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'wrap',
	    value: function () {
	      function wrap(node) {
	        var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this[ROOT];
	
	        if (node instanceof ShallowWrapper) {
	          return node;
	        }
	
	        for (var _len3 = arguments.length, args = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	          args[_key3 - 2] = arguments[_key3];
	        }
	
	        return new (Function.prototype.bind.apply(ShallowWrapper, [null].concat([node, root], args)))();
	      }
	
	      return wrap;
	    }()
	
	    /**
	     * Returns an HTML-like string of the shallow render for debugging purposes.
	     *
	     * @param {Object} options - (Optional) Property bag of additional options.
	     * options.ignoreProps - if true, props are omitted from the string.
	     * @returns {String}
	     */
	
	  }, {
	    key: 'debug',
	    value: function () {
	      function debug() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return (0, _Debug.debugNodes)(this.getNodesInternal(), options);
	      }
	
	      return debug;
	    }()
	
	    /**
	     * Invokes intercepter and returns itself. intercepter is called with itself.
	     * This is helpful when debugging nodes in method chains.
	     * @param fn
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'tap',
	    value: function () {
	      function tap(intercepter) {
	        intercepter(this);
	        return this;
	      }
	
	      return tap;
	    }()
	
	    /**
	     * Primarily useful for HOCs (higher-order components), this method may only be
	     * run on a single, non-DOM node, and will return the node, shallow-rendered.
	     *
	     * @param {Object} options
	     * @returns {ShallowWrapper}
	     */
	
	  }, {
	    key: 'dive',
	    value: function () {
	      function dive() {
	        var _this24 = this;
	
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var adapter = (0, _Utils.getAdapter)(this[OPTIONS]);
	        var name = 'dive';
	        return this.single(name, function (n) {
	          if (n && n.nodeType === 'host') {
	            throw new TypeError('ShallowWrapper::' + name + '() can not be called on Host Components');
	          }
	          var el = (0, _Utils.getAdapter)(_this24[OPTIONS]).nodeToElement(n);
	          if (!(0, _Utils.isCustomComponentElement)(el, adapter)) {
	            throw new TypeError('ShallowWrapper::' + name + '() can only be called on components');
	          }
	          return _this24.wrap(el, null, (0, _object2['default'])({}, _this24[OPTIONS], options));
	        });
	      }
	
	      return dive;
	    }()
	
	    /**
	     * Strips out all the not host-nodes from the list of nodes
	     *
	     * This method is useful if you want to check for the presence of host nodes
	     * (actually rendered HTML elements) ignoring the React nodes.
	     */
	
	  }, {
	    key: 'hostNodes',
	    value: function () {
	      function hostNodes() {
	        return this.filterWhere(function (n) {
	          return typeof n.type() === 'string';
	        });
	      }
	
	      return hostNodes;
	    }()
	  }]);
	
	  return ShallowWrapper;
	}();
	
	if (_Utils.ITERATOR_SYMBOL) {
	  Object.defineProperty(ShallowWrapper.prototype, _Utils.ITERATOR_SYMBOL, {
	    configurable: true,
	    value: function () {
	      function iterator() {
	        var iter = this[NODES][_Utils.ITERATOR_SYMBOL]();
	        var adapter = (0, _Utils.getAdapter)(this[OPTIONS]);
	        return {
	          next: function () {
	            function next() {
	              var next = iter.next();
	              if (next.done) {
	                return { done: true };
	              }
	              return {
	                done: false,
	                value: adapter.nodeToElement(next.value)
	              };
	            }
	
	            return next;
	          }()
	        };
	      }
	
	      return iterator;
	    }()
	  });
	}
	
	function privateWarning(prop, extraMessage) {
	  Object.defineProperty(ShallowWrapper.prototype, prop, {
	    get: function () {
	      function get() {
	        throw new Error('\n        Attempted to access ShallowWrapper::' + String(prop) + ', which was previously a private property on\n        Enzyme ShallowWrapper instances, but is no longer and should not be relied upon.\n        ' + String(extraMessage) + '\n      ');
	      }
	
	      return get;
	    }(),
	
	    enumerable: false,
	    configurable: false
	  });
	}
	
	privateWarning('node', 'Consider using the getElement() method instead.');
	privateWarning('nodes', 'Consider using the getElements() method instead.');
	privateWarning('renderer', '');
	privateWarning('options', '');
	privateWarning('complexSelector', '');
	
	exports['default'] = ShallowWrapper;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	var _object = __webpack_require__(86);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _validateAdapter = __webpack_require__(609);
	
	var _validateAdapter2 = _interopRequireDefault(_validateAdapter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var configuration = {};
	
	module.exports = {
	  get: function () {
	    function get() {
	      return (0, _object2['default'])({}, configuration);
	    }
	
	    return get;
	  }(),
	  merge: function () {
	    function merge(extra) {
	      if (extra.adapter) {
	        (0, _validateAdapter2['default'])(extra.adapter);
	      }
	      (0, _object2['default'])(configuration, extra);
	    }
	
	    return merge;
	  }()
	};

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	var _ReactWrapper = __webpack_require__(604);
	
	var _ReactWrapper2 = _interopRequireDefault(_ReactWrapper);
	
	var _ShallowWrapper = __webpack_require__(605);
	
	var _ShallowWrapper2 = _interopRequireDefault(_ShallowWrapper);
	
	var _EnzymeAdapter = __webpack_require__(603);
	
	var _EnzymeAdapter2 = _interopRequireDefault(_EnzymeAdapter);
	
	var _mount = __webpack_require__(1179);
	
	var _mount2 = _interopRequireDefault(_mount);
	
	var _shallow = __webpack_require__(1181);
	
	var _shallow2 = _interopRequireDefault(_shallow);
	
	var _render = __webpack_require__(1180);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _configuration = __webpack_require__(606);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = {
	  render: _render2['default'],
	  shallow: _shallow2['default'],
	  mount: _mount2['default'],
	  ShallowWrapper: _ShallowWrapper2['default'],
	  ReactWrapper: _ReactWrapper2['default'],
	  configure: _configuration.merge,
	  EnzymeAdapter: _EnzymeAdapter2['default']
	};

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.buildPredicate = buildPredicate;
	exports.reduceTreeBySelector = reduceTreeBySelector;
	exports.reduceTreesBySelector = reduceTreesBySelector;
	
	var _rstSelectorParser = __webpack_require__(4469);
	
	var _object = __webpack_require__(4360);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _isEmpty = __webpack_require__(687);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _flatten = __webpack_require__(183);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _uniq = __webpack_require__(185);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _objectIs = __webpack_require__(698);
	
	var _objectIs2 = _interopRequireDefault(_objectIs);
	
	var _has = __webpack_require__(177);
	
	var _has2 = _interopRequireDefault(_has);
	
	var _RSTTraversal = __webpack_require__(215);
	
	var _Utils = __webpack_require__(216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// our CSS selector parser instance
	var parser = (0, _rstSelectorParser.createParser)();
	
	// Combinators that allow you to chance selectors
	var CHILD = 'childCombinator';
	var ADJACENT_SIBLING = 'adjacentSiblingCombinator';
	var GENERAL_SIBLING = 'generalSiblingCombinator';
	var DESCENDANT = 'descendantCombinator';
	
	// Selectors for targeting elements
	var SELECTOR = 'selector';
	var TYPE_SELECTOR = 'typeSelector';
	var CLASS_SELECTOR = 'classSelector';
	var ID_SELECTOR = 'idSelector';
	var ATTRIBUTE_PRESENCE = 'attributePresenceSelector';
	var ATTRIBUTE_VALUE = 'attributeValueSelector';
	// @TODO we dont support these, throw if they are used
	var PSEUDO_CLASS = 'pseudoClassSelector';
	var PSEUDO_ELEMENT = 'pseudoElementSelector';
	
	var EXACT_ATTRIBUTE_OPERATOR = '=';
	var WHITELIST_ATTRIBUTE_OPERATOR = '~=';
	var HYPHENATED_ATTRIBUTE_OPERATOR = '|=';
	var PREFIX_ATTRIBUTE_OPERATOR = '^=';
	var SUFFIX_ATTRIBUTE_OPERATOR = '$=';
	var SUBSTRING_ATTRIBUTE_OPERATOR = '*=';
	
	/**
	 * Calls reduce on a array of nodes with the passed
	 * function, returning only unique results.
	 * @param {Function} fn
	 * @param {Array<Node>} nodes
	 */
	function uniqueReduce(fn, nodes) {
	  return (0, _uniq2['default'])(nodes.reduce(fn, []));
	}
	
	/**
	 * Takes a CSS selector and returns a set of tokens parsed
	 * by scalpel.
	 * @param {String} selector
	 */
	function safelyGenerateTokens(selector) {
	  try {
	    return parser.parse(selector);
	  } catch (err) {
	    throw new Error('Failed to parse selector: ' + String(selector));
	  }
	}
	
	function matchAttributeSelector(node, token) {
	  var operator = token.operator,
	      value = token.value,
	      name = token.name;
	
	  var nodeProps = (0, _Utils.propsOfNode)(node);
	  var descriptor = Object.getOwnPropertyDescriptor(nodeProps, name);
	  if (descriptor && descriptor.get) {
	    return false;
	  }
	  var nodePropValue = nodeProps[name];
	  if (typeof nodePropValue === 'undefined') {
	    return false;
	  }
	  if (token.type === ATTRIBUTE_PRESENCE) {
	    return (0, _has2['default'])(nodeProps, token.name);
	  }
	  // Only the exact value operator ("=") can match non-strings
	  if (typeof nodePropValue !== 'string' || typeof value !== 'string') {
	    if (operator !== EXACT_ATTRIBUTE_OPERATOR) {
	      return false;
	    }
	  }
	  switch (operator) {
	    /**
	     * Represents an element with the att attribute whose value is exactly "val".
	     * @example
	     * [attr="val"] matches attr="val"
	     */
	    case EXACT_ATTRIBUTE_OPERATOR:
	      return (0, _objectIs2['default'])(nodePropValue, value);
	    /**
	     * Represents an element with the att attribute whose value is a whitespace-separated
	     * list of words, one of which is exactly
	     * @example
	     *  [rel~="copyright"] matches rel="copyright other"
	     */
	    case WHITELIST_ATTRIBUTE_OPERATOR:
	      return nodePropValue.split(' ').indexOf(value) !== -1;
	    /**
	     * Represents an element with the att attribute, its value either being exactly the
	     * value or beginning with the value immediately followed by "-"
	     * @example
	     * [hreflang|="en"] matches hreflang="en-US"
	     */
	    case HYPHENATED_ATTRIBUTE_OPERATOR:
	      return nodePropValue === value || nodePropValue.startsWith(String(value) + '-');
	    /**
	     * Represents an element with the att attribute whose value begins with the prefix value.
	     * If the value is the empty string then the selector does not represent anything.
	     * @example
	     * [type^="image"] matches type="imageobject"
	     */
	    case PREFIX_ATTRIBUTE_OPERATOR:
	      return value === '' ? false : nodePropValue.slice(0, value.length) === value;
	    /**
	     * Represents an element with the att attribute whose value ends with the suffix value.
	     * If the value is the empty string then the selector does not represent anything.
	     * @example
	     * [type$="image"] matches type="imageobject"
	     */
	    case SUFFIX_ATTRIBUTE_OPERATOR:
	      return value === '' ? false : nodePropValue.slice(-value.length) === value;
	    /**
	     * Represents an element with the att attribute whose value contains at least one
	     * instance of the value. If value is the empty string then the
	     * selector does not represent anything.
	     * @example
	     * [title*="hello"] matches title="well hello there"
	     */
	    case SUBSTRING_ATTRIBUTE_OPERATOR:
	      return value === '' ? false : nodePropValue.indexOf(value) !== -1;
	    default:
	      throw new Error('Enzyme::Selector: Unknown attribute selector operator "' + String(operator) + '"');
	  }
	}
	
	/**
	 * Takes a node and a token and determines if the node
	 * matches the predicate defined by the token.
	 * @param {Node} node
	 * @param {Token} token
	 */
	function nodeMatchesToken(node, token) {
	  if (node === null || typeof node === 'string') {
	    return false;
	  }
	  switch (token.type) {
	    /**
	     * Match against the className prop
	     * @example '.active' matches <div className='active' />
	     */
	    case CLASS_SELECTOR:
	      return (0, _RSTTraversal.hasClassName)(node, token.name);
	    /**
	     * Simple type matching
	     * @example 'div' matches <div />
	     */
	    case TYPE_SELECTOR:
	      return (0, _Utils.nodeHasType)(node, token.name);
	    /**
	     * Match against the `id` prop
	     * @example '#nav' matches <ul id="nav" />
	     */
	    case ID_SELECTOR:
	      return (0, _RSTTraversal.nodeHasId)(node, token.name);
	    /**
	     * Matches if an attribute is present, regardless
	     * of its value
	     * @example '[disabled]' matches <a disabled />
	     */
	    case ATTRIBUTE_PRESENCE:
	      return matchAttributeSelector(node, token);
	    /**
	     * Matches if an attribute is present with the
	     * provided value
	     * @example '[data-foo=foo]' matches <div data-foo="foo" />
	     */
	    case ATTRIBUTE_VALUE:
	      return matchAttributeSelector(node, token);
	    case PSEUDO_ELEMENT:
	    case PSEUDO_CLASS:
	      throw new Error('Enzyme::Selector does not support pseudo-element or pseudo-class selectors.');
	    default:
	      throw new Error('Unknown token type: ' + String(token.type));
	  }
	}
	
	/**
	 * Returns a predicate function that checks if a
	 * node matches every token in the body of a selector
	 * token.
	 * @param {Token} token
	 */
	function buildPredicateFromToken(token) {
	  return function (node) {
	    return token.body.every(function (bodyToken) {
	      return nodeMatchesToken(node, bodyToken);
	    });
	  };
	}
	
	/**
	 * Returns whether a parsed selector is a complex selector, which
	 * is defined as a selector that contains combinators.
	 * @param {Array<Token>} tokens
	 */
	function isComplexSelector(tokens) {
	  return tokens.some(function (token) {
	    return token.type !== SELECTOR;
	  });
	}
	
	/**
	 * Takes a component constructor, object, or string representing
	 * a simple selector and returns a predicate function that can
	 * be applied to a single node.
	 * @param {Function|Object|String} selector
	 */
	function buildPredicate(selector) {
	  // If the selector is a function, check if the node's constructor matches
	  if (typeof selector === 'function') {
	    return function (node) {
	      return node && node.type === selector;
	    };
	  }
	  // If the selector is an non-empty object, treat the keys/values as props
	  if ((typeof selector === 'undefined' ? 'undefined' : _typeof(selector)) === 'object') {
	    if (!Array.isArray(selector) && selector !== null && !(0, _isEmpty2['default'])(selector)) {
	      var hasUndefinedValues = (0, _object2['default'])(selector).some(function (value) {
	        return typeof value === 'undefined';
	      });
	      if (hasUndefinedValues) {
	        throw new TypeError('Enzyme::Props can’t have `undefined` values. Try using ‘findWhere()’ instead.');
	      }
	      return function (node) {
	        return (0, _RSTTraversal.nodeMatchesObjectProps)(node, selector);
	      };
	    }
	    throw new TypeError('Enzyme::Selector does not support an array, null, or empty object as a selector');
	  }
	  // If the selector is a string, parse it as a simple CSS selector
	  if (typeof selector === 'string') {
	    var tokens = safelyGenerateTokens(selector);
	    if (isComplexSelector(tokens)) {
	      throw new TypeError('This method does not support complex CSS selectors');
	    }
	    // Simple selectors only have a single selector token
	    return buildPredicateFromToken(tokens[0]);
	  }
	  throw new TypeError('Enzyme::Selector expects a string, object, or Component Constructor');
	}
	
	/**
	 * Matches only nodes which are adjacent siblings (direct next sibling)
	 * against a predicate, returning those that match.
	 * @param {Array<Node>} nodes
	 * @param {Function} predicate
	 * @param {Node} root
	 */
	function matchAdjacentSiblings(nodes, predicate, root) {
	  return nodes.reduce(function (matches, node) {
	    var parent = (0, _RSTTraversal.findParentNode)(root, node);
	    // If there's no parent, there's no siblings
	    if (!parent) {
	      return matches;
	    }
	    var nodeIndex = parent.rendered.indexOf(node);
	    var adjacentSibling = parent.rendered[nodeIndex + 1];
	    // No sibling
	    if (!adjacentSibling) {
	      return matches;
	    }
	    if (predicate(adjacentSibling)) {
	      matches.push(adjacentSibling);
	    }
	    return matches;
	  }, []);
	}
	
	/**
	 * Matches only nodes which are general siblings (any sibling *after*)
	 * against a predicate, returning those that match.
	 * @param {Array<Node>} nodes
	 * @param {Function} predicate
	 * @param {Node} root
	 */
	function matchGeneralSibling(nodes, predicate, root) {
	  return uniqueReduce(function (matches, node) {
	    var parent = (0, _RSTTraversal.findParentNode)(root, node);
	    var nodeIndex = parent.rendered.indexOf(node);
	    parent.rendered.forEach(function (sibling, i) {
	      if (i > nodeIndex && predicate(sibling)) {
	        matches.push(sibling);
	      }
	    });
	    return matches;
	  }, nodes);
	}
	
	/**
	 * Matches only nodes which are direct children (not grandchildren, etc.)
	 * against a predicate, returning those that match.
	 * @param {Array<Node>} nodes
	 * @param {Function} predicate
	 */
	function matchDirectChild(nodes, predicate) {
	  return uniqueReduce(function (matches, node) {
	    var children = (0, _RSTTraversal.childrenOfNode)(node);
	    children.forEach(function (child) {
	      if (predicate(child)) {
	        matches.push(child);
	      }
	    });
	    return matches;
	  }, nodes);
	}
	
	/**
	 * Matches all descendant nodes against a predicate,
	 * returning those that match.
	 * @param {Array<Node>} nodes
	 * @param {Function} predicate
	 */
	function matchDescendant(nodes, predicate) {
	  return uniqueReduce(function (matches, node) {
	    return matches.concat((0, _RSTTraversal.treeFilter)(node, predicate));
	  }, nodes);
	}
	
	/**
	 * Takes an RST and reduces it to a set of nodes matching
	 * the selector. The selector can be a simple selector, which
	 * is handled by `buildPredicate`, or a complex CSS selector which
	 * reduceTreeBySelector parses and reduces the tree based on the combinators.
	 * @param {Function|Object|String} selector
	 * @param {RSTNode} wrapper
	 */
	function reduceTreeBySelector(selector, root) {
	  var results = [];
	
	  if (typeof selector === 'function' || (typeof selector === 'undefined' ? 'undefined' : _typeof(selector)) === 'object') {
	    results = (0, _RSTTraversal.treeFilter)(root, buildPredicate(selector));
	  } else if (typeof selector === 'string') {
	    var tokens = safelyGenerateTokens(selector);
	    var index = 0;
	    var token = null;
	    while (index < tokens.length) {
	      token = tokens[index];
	      /**
	       * There are two types of tokens in a CSS selector:
	       *
	       * 1. Selector tokens. These target nodes directly, like
	       *    type or attribute selectors. These are easy to apply
	       *    because we can travserse the tree and return only
	       *    the nodes that match the predicate.
	       *
	       * 2. Combinator tokens. These tokens chain together
	       *    selector nodes. For example > for children, or +
	       *    for adjecent siblings. These are harder to match
	       *    as we have to track where in the tree we are
	       *    to determine if a selector node applies or not.
	       */
	      if (token.type === SELECTOR) {
	        var predicate = buildPredicateFromToken(token);
	        results = results.concat((0, _RSTTraversal.treeFilter)(root, predicate));
	      } else {
	        // We can assume there always all previously matched tokens since selectors
	        // cannot start with combinators.
	        var _token = token,
	            type = _token.type;
	        // We assume the next token is a selector, so move the index
	        // forward and build the predicate.
	
	        index += 1;
	        token = tokens[index];
	        var _predicate = buildPredicateFromToken(token);
	        // We match against only the nodes which have already been matched,
	        // since a combinator is meant to refine a previous selector.
	        switch (type) {
	          // The + combinator
	          case ADJACENT_SIBLING:
	            results = matchAdjacentSiblings(results, _predicate, root);
	            break;
	          // The ~ combinator
	          case GENERAL_SIBLING:
	            results = matchGeneralSibling(results, _predicate, root);
	            break;
	          // The > combinator
	          case CHILD:
	            results = matchDirectChild(results, _predicate);
	            break;
	          // The ' ' (whitespace) combinator
	          case DESCENDANT:
	            {
	              results = matchDescendant(results, _predicate);
	              break;
	            }
	          default:
	            throw new Error('Unkown combinator selector: ' + String(type));
	        }
	      }
	      index += 1;
	    }
	  } else {
	    throw new TypeError('Enzyme::Selector expects a string, object, or Component Constructor');
	  }
	  return results;
	}
	
	function reduceTreesBySelector(selector, roots) {
	  var results = roots.map(function (n) {
	    return reduceTreeBySelector(selector, n);
	  });
	  return (0, _uniq2['default'])((0, _flatten2['default'])(results));
	}

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = validateAdapter;
	
	var _EnzymeAdapter = __webpack_require__(603);
	
	var _EnzymeAdapter2 = _interopRequireDefault(_EnzymeAdapter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function validateAdapter(adapter) {
	  if (!adapter) {
	    throw new Error('\n      Enzyme Internal Error: Enzyme expects an adapter to be configured, but found none. To\n      configure an adapter, you should call `Enzyme.configure({ adapter: new Adapter() })`\n      before using any of Enzyme\'s top level APIs, where `Adapter` is the adapter\n      corresponding to the library currently being tested. For example:\n\n      import Adapter from \'enzyme-adapter-react-15\';\n\n      To find out more about this, see http://airbnb.io/enzyme/docs/installation/index.html\n    ');
	  }
	  if (!(adapter instanceof _EnzymeAdapter2['default'])) {
	    throw new Error('Enzyme Internal Error: configured enzyme adapter did not inherit from the EnzymeAdapter base class');
	  }
	}

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1183);


/***/ }),
/* 611 */
/***/ (function(module, exports) {

	var has = Object.prototype.hasOwnProperty;
	module.exports = function assign(target, source) {
		if (Object.assign) {
			return Object.assign(target, source);
		}
		for (var key in source) {
			if (has.call(source, key)) {
				target[key] = source[key];
			}
		}
		return target;
	};


/***/ }),
/* 612 */
/***/ (function(module, exports) {

	var $isNaN = Number.isNaN || function (a) { return a !== a; };
	
	module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 613 */
/***/ (function(module, exports) {

	module.exports = Number.isNaN || function isNaN(a) {
		return a !== a;
	};


/***/ }),
/* 614 */
/***/ (function(module, exports) {

	module.exports = function mod(number, modulo) {
		var remain = number % modulo;
		return Math.floor(remain >= 0 ? remain : remain + modulo);
	};


/***/ }),
/* 615 */
/***/ (function(module, exports) {

	module.exports = function sign(number) {
		return number >= 0 ? 1 : -1;
	};


/***/ }),
/* 616 */
/***/ (function(module, exports) {

	module.exports = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ }),
/* 617 */
/***/ (function(module, exports) {

	/*
	  Copyright (C) 2013-2014 Yusuke Suzuki <utatane.tea@gmail.com>
	  Copyright (C) 2014 Ivan Nikulin <ifaaan@gmail.com>
	
	  Redistribution and use in source and binary forms, with or without
	  modification, are permitted provided that the following conditions are met:
	
	    * Redistributions of source code must retain the above copyright
	      notice, this list of conditions and the following disclaimer.
	    * Redistributions in binary form must reproduce the above copyright
	      notice, this list of conditions and the following disclaimer in the
	      documentation and/or other materials provided with the distribution.
	
	  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
	  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
	  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
	  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
	  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
	  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	(function () {
	    'use strict';
	
	    var ES6Regex, ES5Regex, NON_ASCII_WHITESPACES, IDENTIFIER_START, IDENTIFIER_PART, ch;
	
	    // See `tools/generate-identifier-regex.js`.
	    ES5Regex = {
	        // ECMAScript 5.1/Unicode v7.0.0 NonAsciiIdentifierStart:
	        NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B2\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
	        // ECMAScript 5.1/Unicode v7.0.0 NonAsciiIdentifierPart:
	        NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B2\u08E4-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58\u0C59\u0C60-\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D60-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFC-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA69D\uA69F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C4\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2D\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/
	    };
	
	    ES6Regex = {
	        // ECMAScript 6/Unicode v7.0.0 NonAsciiIdentifierStart:
	        NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B2\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDE00-\uDE11\uDE13-\uDE2B\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF5D-\uDF61]|\uD805[\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDE00-\uDE2F\uDE44\uDE80-\uDEAA]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF98]|\uD809[\uDC00-\uDC6E]|[\uD80C\uD840-\uD868\uD86A-\uD86C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D]|\uD87E[\uDC00-\uDE1D]/,
	        // ECMAScript 6/Unicode v7.0.0 NonAsciiIdentifierPart:
	        NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B2\u08E4-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58\u0C59\u0C60-\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D60-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFC-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA69D\uA69F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C4\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2D\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDD0-\uDDDA\uDE00-\uDE11\uDE13-\uDE37\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF01-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF98]|\uD809[\uDC00-\uDC6E]|[\uD80C\uD840-\uD868\uD86A-\uD86C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
	    };
	
	    function isDecimalDigit(ch) {
	        return 0x30 <= ch && ch <= 0x39;  // 0..9
	    }
	
	    function isHexDigit(ch) {
	        return 0x30 <= ch && ch <= 0x39 ||  // 0..9
	            0x61 <= ch && ch <= 0x66 ||     // a..f
	            0x41 <= ch && ch <= 0x46;       // A..F
	    }
	
	    function isOctalDigit(ch) {
	        return ch >= 0x30 && ch <= 0x37;  // 0..7
	    }
	
	    // 7.2 White Space
	
	    NON_ASCII_WHITESPACES = [
	        0x1680, 0x180E,
	        0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006, 0x2007, 0x2008, 0x2009, 0x200A,
	        0x202F, 0x205F,
	        0x3000,
	        0xFEFF
	    ];
	
	    function isWhiteSpace(ch) {
	        return ch === 0x20 || ch === 0x09 || ch === 0x0B || ch === 0x0C || ch === 0xA0 ||
	            ch >= 0x1680 && NON_ASCII_WHITESPACES.indexOf(ch) >= 0;
	    }
	
	    // 7.3 Line Terminators
	
	    function isLineTerminator(ch) {
	        return ch === 0x0A || ch === 0x0D || ch === 0x2028 || ch === 0x2029;
	    }
	
	    // 7.6 Identifier Names and Identifiers
	
	    function fromCodePoint(cp) {
	        if (cp <= 0xFFFF) { return String.fromCharCode(cp); }
	        var cu1 = String.fromCharCode(Math.floor((cp - 0x10000) / 0x400) + 0xD800);
	        var cu2 = String.fromCharCode(((cp - 0x10000) % 0x400) + 0xDC00);
	        return cu1 + cu2;
	    }
	
	    IDENTIFIER_START = new Array(0x80);
	    for(ch = 0; ch < 0x80; ++ch) {
	        IDENTIFIER_START[ch] =
	            ch >= 0x61 && ch <= 0x7A ||  // a..z
	            ch >= 0x41 && ch <= 0x5A ||  // A..Z
	            ch === 0x24 || ch === 0x5F;  // $ (dollar) and _ (underscore)
	    }
	
	    IDENTIFIER_PART = new Array(0x80);
	    for(ch = 0; ch < 0x80; ++ch) {
	        IDENTIFIER_PART[ch] =
	            ch >= 0x61 && ch <= 0x7A ||  // a..z
	            ch >= 0x41 && ch <= 0x5A ||  // A..Z
	            ch >= 0x30 && ch <= 0x39 ||  // 0..9
	            ch === 0x24 || ch === 0x5F;  // $ (dollar) and _ (underscore)
	    }
	
	    function isIdentifierStartES5(ch) {
	        return ch < 0x80 ? IDENTIFIER_START[ch] : ES5Regex.NonAsciiIdentifierStart.test(fromCodePoint(ch));
	    }
	
	    function isIdentifierPartES5(ch) {
	        return ch < 0x80 ? IDENTIFIER_PART[ch] : ES5Regex.NonAsciiIdentifierPart.test(fromCodePoint(ch));
	    }
	
	    function isIdentifierStartES6(ch) {
	        return ch < 0x80 ? IDENTIFIER_START[ch] : ES6Regex.NonAsciiIdentifierStart.test(fromCodePoint(ch));
	    }
	
	    function isIdentifierPartES6(ch) {
	        return ch < 0x80 ? IDENTIFIER_PART[ch] : ES6Regex.NonAsciiIdentifierPart.test(fromCodePoint(ch));
	    }
	
	    module.exports = {
	        isDecimalDigit: isDecimalDigit,
	        isHexDigit: isHexDigit,
	        isOctalDigit: isOctalDigit,
	        isWhiteSpace: isWhiteSpace,
	        isLineTerminator: isLineTerminator,
	        isIdentifierStartES5: isIdentifierStartES5,
	        isIdentifierPartES5: isIdentifierPartES5,
	        isIdentifierStartES6: isIdentifierStartES6,
	        isIdentifierPartES6: isIdentifierPartES6
	    };
	}());
	/* vim: set sw=4 ts=4 et tw=80 : */


/***/ }),
/* 618 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	module.exports = typeof function foo() {}.name === 'string'; // when function names are minified, checking for "foo" would break


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isCallable = __webpack_require__(220);
	var functionsHaveNames = __webpack_require__(620);
	var bind = __webpack_require__(135);
	var functionToString = bind.call(Function.call, Function.prototype.toString);
	var stringMatch = bind.call(Function.call, String.prototype.match);
	
	var classRegex = /^class /;
	
	var isClass = function isClassConstructor(fn) {
		if (isCallable(fn)) {
			return false;
		}
		if (typeof fn !== 'function') {
			return false;
		}
		try {
			var match = stringMatch(functionToString(fn), classRegex);
			return !!match;
		} catch (e) {}
		return false;
	};
	
	var regex = /\s*function\s+([^(\s]*)\s*/;
	
	var functionProto = Function.prototype;
	
	module.exports = function getName() {
		if (!isClass(this) && !isCallable(this)) {
			throw new TypeError('Function.prototype.name sham getter called on non-function');
		}
		if (functionsHaveNames) {
			return this.name;
		}
		if (this === functionProto) {
			return '';
		}
		var str = functionToString(this);
		var match = stringMatch(str, regex);
		var name = match && match[1];
		return name;
	};


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(621);
	
	module.exports = function getPolyfill() {
		return implementation;
	};


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore right clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, 'You should not use <Link> outside a <Router>');
	
	    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(500);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 625 */
/***/ (function(module, exports) {

	'use strict';
	
	/* !
	 * Chai - getFuncName utility
	 * Copyright(c) 2012-2016 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/**
	 * ### .getFuncName(constructorFn)
	 *
	 * Returns the name of a function.
	 * When a non-function instance is passed, returns `null`.
	 * This also includes a polyfill function if `aFunc.name` is not defined.
	 *
	 * @name getFuncName
	 * @param {Function} funct
	 * @namespace Utils
	 * @api public
	 */
	
	var toString = Function.prototype.toString;
	var functionNameMatch = /\s*function(?:\s|\s*\/\*[^(?:*\/)]+\*\/\s*)*([^\s\(\/]+)/;
	function getFuncName(aFunc) {
	  if (typeof aFunc !== 'function') {
	    return null;
	  }
	
	  var name = '';
	  if (typeof Function.prototype.name === 'undefined' && typeof aFunc.name === 'undefined') {
	    // Here we run a polyfill if Function does not support the `name` property and if aFunc.name is not defined
	    var match = toString.call(aFunc).match(functionNameMatch);
	    if (match) {
	      name = match[1];
	    }
	  } else {
	    // If we've got a `name` property we just use it
	    name = aFunc.name;
	  }
	
	  return name;
	}
	
	module.exports = getFuncName;


/***/ }),
/* 626 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(315);
	
	var _PathUtils = __webpack_require__(178);
	
	var _createTransitionManager = __webpack_require__(422);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(626);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(178);
	
	var _LocationUtils = __webpack_require__(315);
	
	var _createTransitionManager = __webpack_require__(422);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	var Tokenizer = __webpack_require__(630);
	
	/*
		Options:
	
		xmlMode: Disables the special behavior for script/style tags (false by default)
		lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
		lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
	*/
	
	/*
		Callbacks:
	
		oncdataend,
		oncdatastart,
		onclosetag,
		oncomment,
		oncommentend,
		onerror,
		onopentag,
		onprocessinginstruction,
		onreset,
		ontext
	*/
	
	var formTags = {
		input: true,
		option: true,
		optgroup: true,
		select: true,
		button: true,
		datalist: true,
		textarea: true
	};
	
	var openImpliesClose = {
		tr      : { tr:true, th:true, td:true },
		th      : { th:true },
		td      : { thead:true, th:true, td:true },
		body    : { head:true, link:true, script:true },
		li      : { li:true },
		p       : { p:true },
		h1      : { p:true },
		h2      : { p:true },
		h3      : { p:true },
		h4      : { p:true },
		h5      : { p:true },
		h6      : { p:true },
		select  : formTags,
		input   : formTags,
		output  : formTags,
		button  : formTags,
		datalist: formTags,
		textarea: formTags,
		option  : { option:true },
		optgroup: { optgroup:true }
	};
	
	var voidElements = {
		__proto__: null,
		area: true,
		base: true,
		basefont: true,
		br: true,
		col: true,
		command: true,
		embed: true,
		frame: true,
		hr: true,
		img: true,
		input: true,
		isindex: true,
		keygen: true,
		link: true,
		meta: true,
		param: true,
		source: true,
		track: true,
		wbr: true,
	
		//common self closing svg elements
		path: true,
		circle: true,
		ellipse: true,
		line: true,
		rect: true,
		use: true,
		stop: true,
		polyline: true,
		polygon: true
	};
	
	var re_nameEnd = /\s|\//;
	
	function Parser(cbs, options){
		this._options = options || {};
		this._cbs = cbs || {};
	
		this._tagname = "";
		this._attribname = "";
		this._attribvalue = "";
		this._attribs = null;
		this._stack = [];
	
		this.startIndex = 0;
		this.endIndex = null;
	
		this._lowerCaseTagNames = "lowerCaseTags" in this._options ?
										!!this._options.lowerCaseTags :
										!this._options.xmlMode;
		this._lowerCaseAttributeNames = "lowerCaseAttributeNames" in this._options ?
										!!this._options.lowerCaseAttributeNames :
										!this._options.xmlMode;
	
		if(this._options.Tokenizer) {
			Tokenizer = this._options.Tokenizer;
		}
		this._tokenizer = new Tokenizer(this._options, this);
	
		if(this._cbs.onparserinit) this._cbs.onparserinit(this);
	}
	
	__webpack_require__(71)(Parser, __webpack_require__(312).EventEmitter);
	
	Parser.prototype._updatePosition = function(initialOffset){
		if(this.endIndex === null){
			if(this._tokenizer._sectionStart <= initialOffset){
				this.startIndex = 0;
			} else {
				this.startIndex = this._tokenizer._sectionStart - initialOffset;
			}
		}
		else this.startIndex = this.endIndex + 1;
		this.endIndex = this._tokenizer.getAbsoluteIndex();
	};
	
	//Tokenizer event handlers
	Parser.prototype.ontext = function(data){
		this._updatePosition(1);
		this.endIndex--;
	
		if(this._cbs.ontext) this._cbs.ontext(data);
	};
	
	Parser.prototype.onopentagname = function(name){
		if(this._lowerCaseTagNames){
			name = name.toLowerCase();
		}
	
		this._tagname = name;
	
		if(!this._options.xmlMode && name in openImpliesClose) {
			for(
				var el;
				(el = this._stack[this._stack.length - 1]) in openImpliesClose[name];
				this.onclosetag(el)
			);
		}
	
		if(this._options.xmlMode || !(name in voidElements)){
			this._stack.push(name);
		}
	
		if(this._cbs.onopentagname) this._cbs.onopentagname(name);
		if(this._cbs.onopentag) this._attribs = {};
	};
	
	Parser.prototype.onopentagend = function(){
		this._updatePosition(1);
	
		if(this._attribs){
			if(this._cbs.onopentag) this._cbs.onopentag(this._tagname, this._attribs);
			this._attribs = null;
		}
	
		if(!this._options.xmlMode && this._cbs.onclosetag && this._tagname in voidElements){
			this._cbs.onclosetag(this._tagname);
		}
	
		this._tagname = "";
	};
	
	Parser.prototype.onclosetag = function(name){
		this._updatePosition(1);
	
		if(this._lowerCaseTagNames){
			name = name.toLowerCase();
		}
	
		if(this._stack.length && (!(name in voidElements) || this._options.xmlMode)){
			var pos = this._stack.lastIndexOf(name);
			if(pos !== -1){
				if(this._cbs.onclosetag){
					pos = this._stack.length - pos;
					while(pos--) this._cbs.onclosetag(this._stack.pop());
				}
				else this._stack.length = pos;
			} else if(name === "p" && !this._options.xmlMode){
				this.onopentagname(name);
				this._closeCurrentTag();
			}
		} else if(!this._options.xmlMode && (name === "br" || name === "p")){
			this.onopentagname(name);
			this._closeCurrentTag();
		}
	};
	
	Parser.prototype.onselfclosingtag = function(){
		if(this._options.xmlMode || this._options.recognizeSelfClosing){
			this._closeCurrentTag();
		} else {
			this.onopentagend();
		}
	};
	
	Parser.prototype._closeCurrentTag = function(){
		var name = this._tagname;
	
		this.onopentagend();
	
		//self-closing tags will be on the top of the stack
		//(cheaper check than in onclosetag)
		if(this._stack[this._stack.length - 1] === name){
			if(this._cbs.onclosetag){
				this._cbs.onclosetag(name);
			}
			this._stack.pop();
		}
	};
	
	Parser.prototype.onattribname = function(name){
		if(this._lowerCaseAttributeNames){
			name = name.toLowerCase();
		}
		this._attribname = name;
	};
	
	Parser.prototype.onattribdata = function(value){
		this._attribvalue += value;
	};
	
	Parser.prototype.onattribend = function(){
		if(this._cbs.onattribute) this._cbs.onattribute(this._attribname, this._attribvalue);
		if(
			this._attribs &&
			!Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
		){
			this._attribs[this._attribname] = this._attribvalue;
		}
		this._attribname = "";
		this._attribvalue = "";
	};
	
	Parser.prototype._getInstructionName = function(value){
		var idx = value.search(re_nameEnd),
		    name = idx < 0 ? value : value.substr(0, idx);
	
		if(this._lowerCaseTagNames){
			name = name.toLowerCase();
		}
	
		return name;
	};
	
	Parser.prototype.ondeclaration = function(value){
		if(this._cbs.onprocessinginstruction){
			var name = this._getInstructionName(value);
			this._cbs.onprocessinginstruction("!" + name, "!" + value);
		}
	};
	
	Parser.prototype.onprocessinginstruction = function(value){
		if(this._cbs.onprocessinginstruction){
			var name = this._getInstructionName(value);
			this._cbs.onprocessinginstruction("?" + name, "?" + value);
		}
	};
	
	Parser.prototype.oncomment = function(value){
		this._updatePosition(4);
	
		if(this._cbs.oncomment) this._cbs.oncomment(value);
		if(this._cbs.oncommentend) this._cbs.oncommentend();
	};
	
	Parser.prototype.oncdata = function(value){
		this._updatePosition(1);
	
		if(this._options.xmlMode || this._options.recognizeCDATA){
			if(this._cbs.oncdatastart) this._cbs.oncdatastart();
			if(this._cbs.ontext) this._cbs.ontext(value);
			if(this._cbs.oncdataend) this._cbs.oncdataend();
		} else {
			this.oncomment("[CDATA[" + value + "]]");
		}
	};
	
	Parser.prototype.onerror = function(err){
		if(this._cbs.onerror) this._cbs.onerror(err);
	};
	
	Parser.prototype.onend = function(){
		if(this._cbs.onclosetag){
			for(
				var i = this._stack.length;
				i > 0;
				this._cbs.onclosetag(this._stack[--i])
			);
		}
		if(this._cbs.onend) this._cbs.onend();
	};
	
	
	//Resets the parser to a blank state, ready to parse a new HTML document
	Parser.prototype.reset = function(){
		if(this._cbs.onreset) this._cbs.onreset();
		this._tokenizer.reset();
	
		this._tagname = "";
		this._attribname = "";
		this._attribs = null;
		this._stack = [];
	
		if(this._cbs.onparserinit) this._cbs.onparserinit(this);
	};
	
	//Parses a complete HTML document and pushes it to the handler
	Parser.prototype.parseComplete = function(data){
		this.reset();
		this.end(data);
	};
	
	Parser.prototype.write = function(chunk){
		this._tokenizer.write(chunk);
	};
	
	Parser.prototype.end = function(chunk){
		this._tokenizer.end(chunk);
	};
	
	Parser.prototype.pause = function(){
		this._tokenizer.pause();
	};
	
	Parser.prototype.resume = function(){
		this._tokenizer.resume();
	};
	
	//alias for backwards compat
	Parser.prototype.parseChunk = Parser.prototype.write;
	Parser.prototype.done = Parser.prototype.end;
	
	module.exports = Parser;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = Tokenizer;
	
	var decodeCodePoint = __webpack_require__(601),
	    entityMap = __webpack_require__(426),
	    legacyMap = __webpack_require__(635),
	    xmlMap    = __webpack_require__(427),
	
	    i = 0,
	
	    TEXT                      = i++,
	    BEFORE_TAG_NAME           = i++, //after <
	    IN_TAG_NAME               = i++,
	    IN_SELF_CLOSING_TAG       = i++,
	    BEFORE_CLOSING_TAG_NAME   = i++,
	    IN_CLOSING_TAG_NAME       = i++,
	    AFTER_CLOSING_TAG_NAME    = i++,
	
	    //attributes
	    BEFORE_ATTRIBUTE_NAME     = i++,
	    IN_ATTRIBUTE_NAME         = i++,
	    AFTER_ATTRIBUTE_NAME      = i++,
	    BEFORE_ATTRIBUTE_VALUE    = i++,
	    IN_ATTRIBUTE_VALUE_DQ     = i++, // "
	    IN_ATTRIBUTE_VALUE_SQ     = i++, // '
	    IN_ATTRIBUTE_VALUE_NQ     = i++,
	
	    //declarations
	    BEFORE_DECLARATION        = i++, // !
	    IN_DECLARATION            = i++,
	
	    //processing instructions
	    IN_PROCESSING_INSTRUCTION = i++, // ?
	
	    //comments
	    BEFORE_COMMENT            = i++,
	    IN_COMMENT                = i++,
	    AFTER_COMMENT_1           = i++,
	    AFTER_COMMENT_2           = i++,
	
	    //cdata
	    BEFORE_CDATA_1            = i++, // [
	    BEFORE_CDATA_2            = i++, // C
	    BEFORE_CDATA_3            = i++, // D
	    BEFORE_CDATA_4            = i++, // A
	    BEFORE_CDATA_5            = i++, // T
	    BEFORE_CDATA_6            = i++, // A
	    IN_CDATA                  = i++, // [
	    AFTER_CDATA_1             = i++, // ]
	    AFTER_CDATA_2             = i++, // ]
	
	    //special tags
	    BEFORE_SPECIAL            = i++, //S
	    BEFORE_SPECIAL_END        = i++,   //S
	
	    BEFORE_SCRIPT_1           = i++, //C
	    BEFORE_SCRIPT_2           = i++, //R
	    BEFORE_SCRIPT_3           = i++, //I
	    BEFORE_SCRIPT_4           = i++, //P
	    BEFORE_SCRIPT_5           = i++, //T
	    AFTER_SCRIPT_1            = i++, //C
	    AFTER_SCRIPT_2            = i++, //R
	    AFTER_SCRIPT_3            = i++, //I
	    AFTER_SCRIPT_4            = i++, //P
	    AFTER_SCRIPT_5            = i++, //T
	
	    BEFORE_STYLE_1            = i++, //T
	    BEFORE_STYLE_2            = i++, //Y
	    BEFORE_STYLE_3            = i++, //L
	    BEFORE_STYLE_4            = i++, //E
	    AFTER_STYLE_1             = i++, //T
	    AFTER_STYLE_2             = i++, //Y
	    AFTER_STYLE_3             = i++, //L
	    AFTER_STYLE_4             = i++, //E
	
	    BEFORE_ENTITY             = i++, //&
	    BEFORE_NUMERIC_ENTITY     = i++, //#
	    IN_NAMED_ENTITY           = i++,
	    IN_NUMERIC_ENTITY         = i++,
	    IN_HEX_ENTITY             = i++, //X
	
	    j = 0,
	
	    SPECIAL_NONE              = j++,
	    SPECIAL_SCRIPT            = j++,
	    SPECIAL_STYLE             = j++;
	
	function whitespace(c){
		return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
	}
	
	function characterState(char, SUCCESS){
		return function(c){
			if(c === char) this._state = SUCCESS;
		};
	}
	
	function ifElseState(upper, SUCCESS, FAILURE){
		var lower = upper.toLowerCase();
	
		if(upper === lower){
			return function(c){
				if(c === lower){
					this._state = SUCCESS;
				} else {
					this._state = FAILURE;
					this._index--;
				}
			};
		} else {
			return function(c){
				if(c === lower || c === upper){
					this._state = SUCCESS;
				} else {
					this._state = FAILURE;
					this._index--;
				}
			};
		}
	}
	
	function consumeSpecialNameChar(upper, NEXT_STATE){
		var lower = upper.toLowerCase();
	
		return function(c){
			if(c === lower || c === upper){
				this._state = NEXT_STATE;
			} else {
				this._state = IN_TAG_NAME;
				this._index--; //consume the token again
			}
		};
	}
	
	function Tokenizer(options, cbs){
		this._state = TEXT;
		this._buffer = "";
		this._sectionStart = 0;
		this._index = 0;
		this._bufferOffset = 0; //chars removed from _buffer
		this._baseState = TEXT;
		this._special = SPECIAL_NONE;
		this._cbs = cbs;
		this._running = true;
		this._ended = false;
		this._xmlMode = !!(options && options.xmlMode);
		this._decodeEntities = !!(options && options.decodeEntities);
	}
	
	Tokenizer.prototype._stateText = function(c){
		if(c === "<"){
			if(this._index > this._sectionStart){
				this._cbs.ontext(this._getSection());
			}
			this._state = BEFORE_TAG_NAME;
			this._sectionStart = this._index;
		} else if(this._decodeEntities && this._special === SPECIAL_NONE && c === "&"){
			if(this._index > this._sectionStart){
				this._cbs.ontext(this._getSection());
			}
			this._baseState = TEXT;
			this._state = BEFORE_ENTITY;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateBeforeTagName = function(c){
		if(c === "/"){
			this._state = BEFORE_CLOSING_TAG_NAME;
		} else if(c === "<"){
			this._cbs.ontext(this._getSection());
			this._sectionStart = this._index;
		} else if(c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
			this._state = TEXT;
		} else if(c === "!"){
			this._state = BEFORE_DECLARATION;
			this._sectionStart = this._index + 1;
		} else if(c === "?"){
			this._state = IN_PROCESSING_INSTRUCTION;
			this._sectionStart = this._index + 1;
		} else {
			this._state = (!this._xmlMode && (c === "s" || c === "S")) ?
							BEFORE_SPECIAL : IN_TAG_NAME;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateInTagName = function(c){
		if(c === "/" || c === ">" || whitespace(c)){
			this._emitToken("onopentagname");
			this._state = BEFORE_ATTRIBUTE_NAME;
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateBeforeCloseingTagName = function(c){
		if(whitespace(c));
		else if(c === ">"){
			this._state = TEXT;
		} else if(this._special !== SPECIAL_NONE){
			if(c === "s" || c === "S"){
				this._state = BEFORE_SPECIAL_END;
			} else {
				this._state = TEXT;
				this._index--;
			}
		} else {
			this._state = IN_CLOSING_TAG_NAME;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateInCloseingTagName = function(c){
		if(c === ">" || whitespace(c)){
			this._emitToken("onclosetag");
			this._state = AFTER_CLOSING_TAG_NAME;
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateAfterCloseingTagName = function(c){
		//skip everything until ">"
		if(c === ">"){
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		}
	};
	
	Tokenizer.prototype._stateBeforeAttributeName = function(c){
		if(c === ">"){
			this._cbs.onopentagend();
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		} else if(c === "/"){
			this._state = IN_SELF_CLOSING_TAG;
		} else if(!whitespace(c)){
			this._state = IN_ATTRIBUTE_NAME;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateInSelfClosingTag = function(c){
		if(c === ">"){
			this._cbs.onselfclosingtag();
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		} else if(!whitespace(c)){
			this._state = BEFORE_ATTRIBUTE_NAME;
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateInAttributeName = function(c){
		if(c === "=" || c === "/" || c === ">" || whitespace(c)){
			this._cbs.onattribname(this._getSection());
			this._sectionStart = -1;
			this._state = AFTER_ATTRIBUTE_NAME;
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateAfterAttributeName = function(c){
		if(c === "="){
			this._state = BEFORE_ATTRIBUTE_VALUE;
		} else if(c === "/" || c === ">"){
			this._cbs.onattribend();
			this._state = BEFORE_ATTRIBUTE_NAME;
			this._index--;
		} else if(!whitespace(c)){
			this._cbs.onattribend();
			this._state = IN_ATTRIBUTE_NAME;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateBeforeAttributeValue = function(c){
		if(c === "\""){
			this._state = IN_ATTRIBUTE_VALUE_DQ;
			this._sectionStart = this._index + 1;
		} else if(c === "'"){
			this._state = IN_ATTRIBUTE_VALUE_SQ;
			this._sectionStart = this._index + 1;
		} else if(!whitespace(c)){
			this._state = IN_ATTRIBUTE_VALUE_NQ;
			this._sectionStart = this._index;
			this._index--; //reconsume token
		}
	};
	
	Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c){
		if(c === "\""){
			this._emitToken("onattribdata");
			this._cbs.onattribend();
			this._state = BEFORE_ATTRIBUTE_NAME;
		} else if(this._decodeEntities && c === "&"){
			this._emitToken("onattribdata");
			this._baseState = this._state;
			this._state = BEFORE_ENTITY;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c){
		if(c === "'"){
			this._emitToken("onattribdata");
			this._cbs.onattribend();
			this._state = BEFORE_ATTRIBUTE_NAME;
		} else if(this._decodeEntities && c === "&"){
			this._emitToken("onattribdata");
			this._baseState = this._state;
			this._state = BEFORE_ENTITY;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c){
		if(whitespace(c) || c === ">"){
			this._emitToken("onattribdata");
			this._cbs.onattribend();
			this._state = BEFORE_ATTRIBUTE_NAME;
			this._index--;
		} else if(this._decodeEntities && c === "&"){
			this._emitToken("onattribdata");
			this._baseState = this._state;
			this._state = BEFORE_ENTITY;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateBeforeDeclaration = function(c){
		this._state = c === "[" ? BEFORE_CDATA_1 :
						c === "-" ? BEFORE_COMMENT :
							IN_DECLARATION;
	};
	
	Tokenizer.prototype._stateInDeclaration = function(c){
		if(c === ">"){
			this._cbs.ondeclaration(this._getSection());
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		}
	};
	
	Tokenizer.prototype._stateInProcessingInstruction = function(c){
		if(c === ">"){
			this._cbs.onprocessinginstruction(this._getSection());
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		}
	};
	
	Tokenizer.prototype._stateBeforeComment = function(c){
		if(c === "-"){
			this._state = IN_COMMENT;
			this._sectionStart = this._index + 1;
		} else {
			this._state = IN_DECLARATION;
		}
	};
	
	Tokenizer.prototype._stateInComment = function(c){
		if(c === "-") this._state = AFTER_COMMENT_1;
	};
	
	Tokenizer.prototype._stateAfterComment1 = function(c){
		if(c === "-"){
			this._state = AFTER_COMMENT_2;
		} else {
			this._state = IN_COMMENT;
		}
	};
	
	Tokenizer.prototype._stateAfterComment2 = function(c){
		if(c === ">"){
			//remove 2 trailing chars
			this._cbs.oncomment(this._buffer.substring(this._sectionStart, this._index - 2));
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		} else if(c !== "-"){
			this._state = IN_COMMENT;
		}
		// else: stay in AFTER_COMMENT_2 (`--->`)
	};
	
	Tokenizer.prototype._stateBeforeCdata1 = ifElseState("C", BEFORE_CDATA_2, IN_DECLARATION);
	Tokenizer.prototype._stateBeforeCdata2 = ifElseState("D", BEFORE_CDATA_3, IN_DECLARATION);
	Tokenizer.prototype._stateBeforeCdata3 = ifElseState("A", BEFORE_CDATA_4, IN_DECLARATION);
	Tokenizer.prototype._stateBeforeCdata4 = ifElseState("T", BEFORE_CDATA_5, IN_DECLARATION);
	Tokenizer.prototype._stateBeforeCdata5 = ifElseState("A", BEFORE_CDATA_6, IN_DECLARATION);
	
	Tokenizer.prototype._stateBeforeCdata6 = function(c){
		if(c === "["){
			this._state = IN_CDATA;
			this._sectionStart = this._index + 1;
		} else {
			this._state = IN_DECLARATION;
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateInCdata = function(c){
		if(c === "]") this._state = AFTER_CDATA_1;
	};
	
	Tokenizer.prototype._stateAfterCdata1 = characterState("]", AFTER_CDATA_2);
	
	Tokenizer.prototype._stateAfterCdata2 = function(c){
		if(c === ">"){
			//remove 2 trailing chars
			this._cbs.oncdata(this._buffer.substring(this._sectionStart, this._index - 2));
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		} else if(c !== "]") {
			this._state = IN_CDATA;
		}
		//else: stay in AFTER_CDATA_2 (`]]]>`)
	};
	
	Tokenizer.prototype._stateBeforeSpecial = function(c){
		if(c === "c" || c === "C"){
			this._state = BEFORE_SCRIPT_1;
		} else if(c === "t" || c === "T"){
			this._state = BEFORE_STYLE_1;
		} else {
			this._state = IN_TAG_NAME;
			this._index--; //consume the token again
		}
	};
	
	Tokenizer.prototype._stateBeforeSpecialEnd = function(c){
		if(this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")){
			this._state = AFTER_SCRIPT_1;
		} else if(this._special === SPECIAL_STYLE && (c === "t" || c === "T")){
			this._state = AFTER_STYLE_1;
		}
		else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar("R", BEFORE_SCRIPT_2);
	Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar("I", BEFORE_SCRIPT_3);
	Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar("P", BEFORE_SCRIPT_4);
	Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar("T", BEFORE_SCRIPT_5);
	
	Tokenizer.prototype._stateBeforeScript5 = function(c){
		if(c === "/" || c === ">" || whitespace(c)){
			this._special = SPECIAL_SCRIPT;
		}
		this._state = IN_TAG_NAME;
		this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
	Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
	Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
	Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);
	
	Tokenizer.prototype._stateAfterScript5 = function(c){
		if(c === ">" || whitespace(c)){
			this._special = SPECIAL_NONE;
			this._state = IN_CLOSING_TAG_NAME;
			this._sectionStart = this._index - 6;
			this._index--; //reconsume the token
		}
		else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar("Y", BEFORE_STYLE_2);
	Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar("L", BEFORE_STYLE_3);
	Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar("E", BEFORE_STYLE_4);
	
	Tokenizer.prototype._stateBeforeStyle4 = function(c){
		if(c === "/" || c === ">" || whitespace(c)){
			this._special = SPECIAL_STYLE;
		}
		this._state = IN_TAG_NAME;
		this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
	Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
	Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);
	
	Tokenizer.prototype._stateAfterStyle4 = function(c){
		if(c === ">" || whitespace(c)){
			this._special = SPECIAL_NONE;
			this._state = IN_CLOSING_TAG_NAME;
			this._sectionStart = this._index - 5;
			this._index--; //reconsume the token
		}
		else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeEntity = ifElseState("#", BEFORE_NUMERIC_ENTITY, IN_NAMED_ENTITY);
	Tokenizer.prototype._stateBeforeNumericEntity = ifElseState("X", IN_HEX_ENTITY, IN_NUMERIC_ENTITY);
	
	//for entities terminated with a semicolon
	Tokenizer.prototype._parseNamedEntityStrict = function(){
		//offset = 1
		if(this._sectionStart + 1 < this._index){
			var entity = this._buffer.substring(this._sectionStart + 1, this._index),
			    map = this._xmlMode ? xmlMap : entityMap;
	
			if(map.hasOwnProperty(entity)){
				this._emitPartial(map[entity]);
				this._sectionStart = this._index + 1;
			}
		}
	};
	
	
	//parses legacy entities (without trailing semicolon)
	Tokenizer.prototype._parseLegacyEntity = function(){
		var start = this._sectionStart + 1,
		    limit = this._index - start;
	
		if(limit > 6) limit = 6; //the max length of legacy entities is 6
	
		while(limit >= 2){ //the min length of legacy entities is 2
			var entity = this._buffer.substr(start, limit);
	
			if(legacyMap.hasOwnProperty(entity)){
				this._emitPartial(legacyMap[entity]);
				this._sectionStart += limit + 1;
				return;
			} else {
				limit--;
			}
		}
	};
	
	Tokenizer.prototype._stateInNamedEntity = function(c){
		if(c === ";"){
			this._parseNamedEntityStrict();
			if(this._sectionStart + 1 < this._index && !this._xmlMode){
				this._parseLegacyEntity();
			}
			this._state = this._baseState;
		} else if((c < "a" || c > "z") && (c < "A" || c > "Z") && (c < "0" || c > "9")){
			if(this._xmlMode);
			else if(this._sectionStart + 1 === this._index);
			else if(this._baseState !== TEXT){
				if(c !== "="){
					this._parseNamedEntityStrict();
				}
			} else {
				this._parseLegacyEntity();
			}
	
			this._state = this._baseState;
			this._index--;
		}
	};
	
	Tokenizer.prototype._decodeNumericEntity = function(offset, base){
		var sectionStart = this._sectionStart + offset;
	
		if(sectionStart !== this._index){
			//parse entity
			var entity = this._buffer.substring(sectionStart, this._index);
			var parsed = parseInt(entity, base);
	
			this._emitPartial(decodeCodePoint(parsed));
			this._sectionStart = this._index;
		} else {
			this._sectionStart--;
		}
	
		this._state = this._baseState;
	};
	
	Tokenizer.prototype._stateInNumericEntity = function(c){
		if(c === ";"){
			this._decodeNumericEntity(2, 10);
			this._sectionStart++;
		} else if(c < "0" || c > "9"){
			if(!this._xmlMode){
				this._decodeNumericEntity(2, 10);
			} else {
				this._state = this._baseState;
			}
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateInHexEntity = function(c){
		if(c === ";"){
			this._decodeNumericEntity(3, 16);
			this._sectionStart++;
		} else if((c < "a" || c > "f") && (c < "A" || c > "F") && (c < "0" || c > "9")){
			if(!this._xmlMode){
				this._decodeNumericEntity(3, 16);
			} else {
				this._state = this._baseState;
			}
			this._index--;
		}
	};
	
	Tokenizer.prototype._cleanup = function (){
		if(this._sectionStart < 0){
			this._buffer = "";
			this._bufferOffset += this._index;
			this._index = 0;
		} else if(this._running){
			if(this._state === TEXT){
				if(this._sectionStart !== this._index){
					this._cbs.ontext(this._buffer.substr(this._sectionStart));
				}
				this._buffer = "";
				this._bufferOffset += this._index;
				this._index = 0;
			} else if(this._sectionStart === this._index){
				//the section just started
				this._buffer = "";
				this._bufferOffset += this._index;
				this._index = 0;
			} else {
				//remove everything unnecessary
				this._buffer = this._buffer.substr(this._sectionStart);
				this._index -= this._sectionStart;
				this._bufferOffset += this._sectionStart;
			}
	
			this._sectionStart = 0;
		}
	};
	
	//TODO make events conditional
	Tokenizer.prototype.write = function(chunk){
		if(this._ended) this._cbs.onerror(Error(".write() after done!"));
	
		this._buffer += chunk;
		this._parse();
	};
	
	Tokenizer.prototype._parse = function(){
		while(this._index < this._buffer.length && this._running){
			var c = this._buffer.charAt(this._index);
			if(this._state === TEXT) {
				this._stateText(c);
			} else if(this._state === BEFORE_TAG_NAME){
				this._stateBeforeTagName(c);
			} else if(this._state === IN_TAG_NAME) {
				this._stateInTagName(c);
			} else if(this._state === BEFORE_CLOSING_TAG_NAME){
				this._stateBeforeCloseingTagName(c);
			} else if(this._state === IN_CLOSING_TAG_NAME){
				this._stateInCloseingTagName(c);
			} else if(this._state === AFTER_CLOSING_TAG_NAME){
				this._stateAfterCloseingTagName(c);
			} else if(this._state === IN_SELF_CLOSING_TAG){
				this._stateInSelfClosingTag(c);
			}
	
			/*
			*	attributes
			*/
			else if(this._state === BEFORE_ATTRIBUTE_NAME){
				this._stateBeforeAttributeName(c);
			} else if(this._state === IN_ATTRIBUTE_NAME){
				this._stateInAttributeName(c);
			} else if(this._state === AFTER_ATTRIBUTE_NAME){
				this._stateAfterAttributeName(c);
			} else if(this._state === BEFORE_ATTRIBUTE_VALUE){
				this._stateBeforeAttributeValue(c);
			} else if(this._state === IN_ATTRIBUTE_VALUE_DQ){
				this._stateInAttributeValueDoubleQuotes(c);
			} else if(this._state === IN_ATTRIBUTE_VALUE_SQ){
				this._stateInAttributeValueSingleQuotes(c);
			} else if(this._state === IN_ATTRIBUTE_VALUE_NQ){
				this._stateInAttributeValueNoQuotes(c);
			}
	
			/*
			*	declarations
			*/
			else if(this._state === BEFORE_DECLARATION){
				this._stateBeforeDeclaration(c);
			} else if(this._state === IN_DECLARATION){
				this._stateInDeclaration(c);
			}
	
			/*
			*	processing instructions
			*/
			else if(this._state === IN_PROCESSING_INSTRUCTION){
				this._stateInProcessingInstruction(c);
			}
	
			/*
			*	comments
			*/
			else if(this._state === BEFORE_COMMENT){
				this._stateBeforeComment(c);
			} else if(this._state === IN_COMMENT){
				this._stateInComment(c);
			} else if(this._state === AFTER_COMMENT_1){
				this._stateAfterComment1(c);
			} else if(this._state === AFTER_COMMENT_2){
				this._stateAfterComment2(c);
			}
	
			/*
			*	cdata
			*/
			else if(this._state === BEFORE_CDATA_1){
				this._stateBeforeCdata1(c);
			} else if(this._state === BEFORE_CDATA_2){
				this._stateBeforeCdata2(c);
			} else if(this._state === BEFORE_CDATA_3){
				this._stateBeforeCdata3(c);
			} else if(this._state === BEFORE_CDATA_4){
				this._stateBeforeCdata4(c);
			} else if(this._state === BEFORE_CDATA_5){
				this._stateBeforeCdata5(c);
			} else if(this._state === BEFORE_CDATA_6){
				this._stateBeforeCdata6(c);
			} else if(this._state === IN_CDATA){
				this._stateInCdata(c);
			} else if(this._state === AFTER_CDATA_1){
				this._stateAfterCdata1(c);
			} else if(this._state === AFTER_CDATA_2){
				this._stateAfterCdata2(c);
			}
	
			/*
			* special tags
			*/
			else if(this._state === BEFORE_SPECIAL){
				this._stateBeforeSpecial(c);
			} else if(this._state === BEFORE_SPECIAL_END){
				this._stateBeforeSpecialEnd(c);
			}
	
			/*
			* script
			*/
			else if(this._state === BEFORE_SCRIPT_1){
				this._stateBeforeScript1(c);
			} else if(this._state === BEFORE_SCRIPT_2){
				this._stateBeforeScript2(c);
			} else if(this._state === BEFORE_SCRIPT_3){
				this._stateBeforeScript3(c);
			} else if(this._state === BEFORE_SCRIPT_4){
				this._stateBeforeScript4(c);
			} else if(this._state === BEFORE_SCRIPT_5){
				this._stateBeforeScript5(c);
			}
	
			else if(this._state === AFTER_SCRIPT_1){
				this._stateAfterScript1(c);
			} else if(this._state === AFTER_SCRIPT_2){
				this._stateAfterScript2(c);
			} else if(this._state === AFTER_SCRIPT_3){
				this._stateAfterScript3(c);
			} else if(this._state === AFTER_SCRIPT_4){
				this._stateAfterScript4(c);
			} else if(this._state === AFTER_SCRIPT_5){
				this._stateAfterScript5(c);
			}
	
			/*
			* style
			*/
			else if(this._state === BEFORE_STYLE_1){
				this._stateBeforeStyle1(c);
			} else if(this._state === BEFORE_STYLE_2){
				this._stateBeforeStyle2(c);
			} else if(this._state === BEFORE_STYLE_3){
				this._stateBeforeStyle3(c);
			} else if(this._state === BEFORE_STYLE_4){
				this._stateBeforeStyle4(c);
			}
	
			else if(this._state === AFTER_STYLE_1){
				this._stateAfterStyle1(c);
			} else if(this._state === AFTER_STYLE_2){
				this._stateAfterStyle2(c);
			} else if(this._state === AFTER_STYLE_3){
				this._stateAfterStyle3(c);
			} else if(this._state === AFTER_STYLE_4){
				this._stateAfterStyle4(c);
			}
	
			/*
			* entities
			*/
			else if(this._state === BEFORE_ENTITY){
				this._stateBeforeEntity(c);
			} else if(this._state === BEFORE_NUMERIC_ENTITY){
				this._stateBeforeNumericEntity(c);
			} else if(this._state === IN_NAMED_ENTITY){
				this._stateInNamedEntity(c);
			} else if(this._state === IN_NUMERIC_ENTITY){
				this._stateInNumericEntity(c);
			} else if(this._state === IN_HEX_ENTITY){
				this._stateInHexEntity(c);
			}
	
			else {
				this._cbs.onerror(Error("unknown _state"), this._state);
			}
	
			this._index++;
		}
	
		this._cleanup();
	};
	
	Tokenizer.prototype.pause = function(){
		this._running = false;
	};
	Tokenizer.prototype.resume = function(){
		this._running = true;
	
		if(this._index < this._buffer.length){
			this._parse();
		}
		if(this._ended){
			this._finish();
		}
	};
	
	Tokenizer.prototype.end = function(chunk){
		if(this._ended) this._cbs.onerror(Error(".end() after done!"));
		if(chunk) this.write(chunk);
	
		this._ended = true;
	
		if(this._running) this._finish();
	};
	
	Tokenizer.prototype._finish = function(){
		//if there is remaining data, emit it in a reasonable way
		if(this._sectionStart < this._index){
			this._handleTrailingData();
		}
	
		this._cbs.onend();
	};
	
	Tokenizer.prototype._handleTrailingData = function(){
		var data = this._buffer.substr(this._sectionStart);
	
		if(this._state === IN_CDATA || this._state === AFTER_CDATA_1 || this._state === AFTER_CDATA_2){
			this._cbs.oncdata(data);
		} else if(this._state === IN_COMMENT || this._state === AFTER_COMMENT_1 || this._state === AFTER_COMMENT_2){
			this._cbs.oncomment(data);
		} else if(this._state === IN_NAMED_ENTITY && !this._xmlMode){
			this._parseLegacyEntity();
			if(this._sectionStart < this._index){
				this._state = this._baseState;
				this._handleTrailingData();
			}
		} else if(this._state === IN_NUMERIC_ENTITY && !this._xmlMode){
			this._decodeNumericEntity(2, 10);
			if(this._sectionStart < this._index){
				this._state = this._baseState;
				this._handleTrailingData();
			}
		} else if(this._state === IN_HEX_ENTITY && !this._xmlMode){
			this._decodeNumericEntity(3, 16);
			if(this._sectionStart < this._index){
				this._state = this._baseState;
				this._handleTrailingData();
			}
		} else if(
			this._state !== IN_TAG_NAME &&
			this._state !== BEFORE_ATTRIBUTE_NAME &&
			this._state !== BEFORE_ATTRIBUTE_VALUE &&
			this._state !== AFTER_ATTRIBUTE_NAME &&
			this._state !== IN_ATTRIBUTE_NAME &&
			this._state !== IN_ATTRIBUTE_VALUE_SQ &&
			this._state !== IN_ATTRIBUTE_VALUE_DQ &&
			this._state !== IN_ATTRIBUTE_VALUE_NQ &&
			this._state !== IN_CLOSING_TAG_NAME
		){
			this._cbs.ontext(data);
		}
		//else, ignore remaining data
		//TODO add a way to remove current tag
	};
	
	Tokenizer.prototype.reset = function(){
		Tokenizer.call(this, {xmlMode: this._xmlMode, decodeEntities: this._decodeEntities}, this._cbs);
	};
	
	Tokenizer.prototype.getAbsoluteIndex = function(){
		return this._bufferOffset + this._index;
	};
	
	Tokenizer.prototype._getSection = function(){
		return this._buffer.substring(this._sectionStart, this._index);
	};
	
	Tokenizer.prototype._emitToken = function(name){
		this._cbs[name](this._getSection());
		this._sectionStart = -1;
	};
	
	Tokenizer.prototype._emitPartial = function(value){
		if(this._baseState !== TEXT){
			this._cbs.onattribdata(value); //TODO implement the new event
		} else {
			this._cbs.ontext(value);
		}
	};


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(629),
	    WritableStream = __webpack_require__(273).Writable || __webpack_require__(4787).Writable,
	    StringDecoder = __webpack_require__(527).StringDecoder,
	    Buffer = __webpack_require__(169).Buffer;
	
	function Stream(cbs, options){
		var parser = this._parser = new Parser(cbs, options);
		var decoder = this._decoder = new StringDecoder();
	
		WritableStream.call(this, {decodeStrings: false});
	
		this.once("finish", function(){
			parser.end(decoder.end());
		});
	}
	
	__webpack_require__(71)(Stream, WritableStream);
	
	WritableStream.prototype._write = function(chunk, encoding, cb){
		if(chunk instanceof Buffer) chunk = this._decoder.write(chunk);
		this._parser.write(chunk);
		cb();
	};

/***/ }),
/* 632 */,
/* 633 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 634 */
/***/ (function(module, exports) {

	module.exports = {"universal":50,"tag":30,"attribute":1,"pseudo":0,"descendant":-1,"child":-1,"parent":-1,"sibling":-1,"adjacent":-1}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(137),
	    root = __webpack_require__(42);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(42);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(137),
	    root = __webpack_require__(42);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 639 */
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(4244),
	    isArguments = __webpack_require__(231),
	    isArray = __webpack_require__(24),
	    isBuffer = __webpack_require__(232),
	    isIndex = __webpack_require__(226),
	    isTypedArray = __webpack_require__(333);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(442),
	    eq = __webpack_require__(138);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(221);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),
/* 643 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(4255);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(437),
	    isArray = __webpack_require__(24);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(228),
	    nativeKeys = __webpack_require__(4295);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(445),
	    get = __webpack_require__(4322),
	    hasIn = __webpack_require__(685),
	    isKey = __webpack_require__(459),
	    isStrictComparable = __webpack_require__(670),
	    matchesStrictComparable = __webpack_require__(671),
	    toKey = __webpack_require__(230);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(443),
	    baseSet = __webpack_require__(4241),
	    castPath = __webpack_require__(322);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(53),
	    metaMap = __webpack_require__(672);
	
	/**
	 * The base implementation of `setData` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(433),
	    arrayIncludes = __webpack_require__(436),
	    arrayIncludesWith = __webpack_require__(639),
	    cacheHas = __webpack_require__(449),
	    createSet = __webpack_require__(4261),
	    setToArray = __webpack_require__(460);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(100);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(42);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)(module)))

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(451);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 654 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ }),
/* 655 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(654),
	    composeArgsRight = __webpack_require__(655),
	    countHolders = __webpack_require__(4253),
	    createCtor = __webpack_require__(324),
	    createRecurry = __webpack_require__(658),
	    getHolder = __webpack_require__(325),
	    reorder = __webpack_require__(4301),
	    replaceHolders = __webpack_require__(229),
	    root = __webpack_require__(42);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_ARY_FLAG = 128,
	    WRAP_FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & WRAP_ARY_FLAG,
	      isBind = bitmask & WRAP_BIND_FLAG,
	      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	      isFlip = bitmask & WRAP_FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybrid;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(182),
	    arrayMap = __webpack_require__(100),
	    baseIteratee = __webpack_require__(60),
	    baseRest = __webpack_require__(73),
	    baseUnary = __webpack_require__(136),
	    flatRest = __webpack_require__(454);
	
	/**
	 * Creates a function like `_.over`.
	 *
	 * @private
	 * @param {Function} arrayFunc The function to iterate over iteratees.
	 * @returns {Function} Returns the new over function.
	 */
	function createOver(arrayFunc) {
	  return flatRest(function(iteratees) {
	    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
	    return baseRest(function(args) {
	      var thisArg = this;
	      return arrayFunc(iteratees, function(iteratee) {
	        return apply(iteratee, thisArg, args);
	      });
	    });
	  });
	}
	
	module.exports = createOver;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(669),
	    setData = __webpack_require__(677),
	    setWrapToString = __webpack_require__(678);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & WRAP_CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	module.exports = createRecurry;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(649),
	    createBind = __webpack_require__(4256),
	    createCurry = __webpack_require__(4257),
	    createHybrid = __webpack_require__(656),
	    createPartial = __webpack_require__(4260),
	    getData = __webpack_require__(455),
	    mergeData = __webpack_require__(4294),
	    setData = __webpack_require__(677),
	    setWrapToString = __webpack_require__(678),
	    toInteger = __webpack_require__(334);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *    1 - `_.bind`
	 *    2 - `_.bindKey`
	 *    4 - `_.curry` or `_.curryRight` of a bound function
	 *    8 - `_.curry`
	 *   16 - `_.curryRight`
	 *   32 - `_.partial`
	 *   64 - `_.partialRight`
	 *  128 - `_.rearg`
	 *  256 - `_.ary`
	 *  512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] === undefined
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setWrapToString(setter(result, newData), func, bitmask);
	}
	
	module.exports = createWrap;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(137);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(433),
	    arraySome = __webpack_require__(439),
	    cacheHas = __webpack_require__(449);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 662 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(645),
	    getSymbols = __webpack_require__(457),
	    keys = __webpack_require__(76);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(645),
	    getSymbolsIn = __webpack_require__(666),
	    keysIn = __webpack_require__(140);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(4300);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(437),
	    getPrototype = __webpack_require__(456),
	    getSymbols = __webpack_require__(457),
	    stubArray = __webpack_require__(694);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(322),
	    isArguments = __webpack_require__(231),
	    isArray = __webpack_require__(24),
	    isIndex = __webpack_require__(226),
	    isLength = __webpack_require__(473),
	    toKey = __webpack_require__(230);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(321),
	    getPrototype = __webpack_require__(456),
	    isPrototype = __webpack_require__(228);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(429),
	    getData = __webpack_require__(455),
	    getFuncName = __webpack_require__(665),
	    lodash = __webpack_require__(4349);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(49);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 671 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(638);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ }),
/* 673 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(182);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 675 */
/***/ (function(module, exports) {

	/** Used to match template delimiters. */
	var reInterpolate = /<%=([\s\S]+?)%>/g;
	
	module.exports = reInterpolate;


/***/ }),
/* 676 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  return key == '__proto__'
	    ? undefined
	    : object[key];
	}
	
	module.exports = safeGet;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(649),
	    shortOut = __webpack_require__(679);
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = shortOut(baseSetData);
	
	module.exports = setData;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	var getWrapDetails = __webpack_require__(4270),
	    insertWrapDetails = __webpack_require__(4278),
	    setToString = __webpack_require__(461),
	    updateWrapDetails = __webpack_require__(4311);
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	function setWrapToString(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	}
	
	module.exports = setWrapToString;


/***/ }),
/* 679 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 680 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(182),
	    baseRest = __webpack_require__(73),
	    isError = __webpack_require__(472);
	
	/**
	 * Attempts to invoke `func`, returning either the result or the caught error
	 * object. Any additional arguments are provided to `func` when it's invoked.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Util
	 * @param {Function} func The function to attempt.
	 * @param {...*} [args] The arguments to invoke `func` with.
	 * @returns {*} Returns the `func` result or error object.
	 * @example
	 *
	 * // Avoid throwing errors for invalid selectors.
	 * var elements = _.attempt(function(selector) {
	 *   return document.querySelectorAll(selector);
	 * }, '>_>');
	 *
	 * if (_.isError(elements)) {
	 *   elements = [];
	 * }
	 */
	var attempt = baseRest(function(func, args) {
	  try {
	    return apply(func, undefined, args);
	  } catch (e) {
	    return isError(e) ? e : new Error(e);
	  }
	});
	
	module.exports = attempt;


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(320);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeep
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return baseClone(value, CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = clone;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	var escapeHtmlChar = __webpack_require__(4265),
	    toString = __webpack_require__(54);
	
	/** Used to match HTML entities and HTML characters. */
	var reUnescapedHtml = /[&<>"']/g,
	    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	/**
	 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	 * corresponding HTML entities.
	 *
	 * **Note:** No other characters are escaped. To escape additional
	 * characters use a third-party library like [_he_](https://mths.be/he).
	 *
	 * Though the ">" character is escaped for symmetry, characters like
	 * ">" and "/" don't need escaping in HTML and have no special meaning
	 * unless they're part of a tag or unquoted attribute value. See
	 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	 * (under "semi-related fun fact") for more details.
	 *
	 * When working with HTML you should always
	 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	 * XSS vectors.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escape('fred, barney, & pebbles');
	 * // => 'fred, barney, &amp; pebbles'
	 */
	function escape(string) {
	  string = toString(string);
	  return (string && reHasUnescapedHtml.test(string))
	    ? string.replace(reUnescapedHtml, escapeHtmlChar)
	    : string;
	}
	
	module.exports = escape;


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(4218),
	    hasPath = __webpack_require__(667);
	
	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && hasPath(object, path, baseHas);
	}
	
	module.exports = has;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(4219),
	    hasPath = __webpack_require__(667);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(74),
	    isObjectLike = __webpack_require__(43);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(646),
	    getTag = __webpack_require__(224),
	    isArguments = __webpack_require__(231),
	    isArray = __webpack_require__(24),
	    isArrayLike = __webpack_require__(74),
	    isBuffer = __webpack_require__(232),
	    isPrototype = __webpack_require__(228),
	    isTypedArray = __webpack_require__(333);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ }),
/* 688 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(320),
	    baseMatchesProperty = __webpack_require__(647);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a function that performs a partial deep comparison between the
	 * value at `path` of a given object to `srcValue`, returning `true` if the
	 * object value is equivalent, else `false`.
	 *
	 * **Note:** Partial comparisons will match empty array and empty object
	 * `srcValue` values against any array or object value, respectively. See
	 * `_.isEqual` for a list of supported value comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.2.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': 1, 'b': 2, 'c': 3 },
	 *   { 'a': 4, 'b': 5, 'c': 6 }
	 * ];
	 *
	 * _.find(objects, _.matchesProperty('a', 4));
	 * // => { 'a': 4, 'b': 5, 'c': 6 }
	 */
	function matchesProperty(path, srcValue) {
	  return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	}
	
	module.exports = matchesProperty;


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(4233),
	    createAssigner = __webpack_require__(323);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(73),
	    createWrap = __webpack_require__(659),
	    getHolder = __webpack_require__(325),
	    replaceHolders = __webpack_require__(229);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes `func` with `partials` prepended to the
	 * arguments it receives. This method is like `_.bind` except it does **not**
	 * alter the `this` binding.
	 *
	 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of partially
	 * applied functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.2.0
	 * @category Function
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new partially applied function.
	 * @example
	 *
	 * function greet(greeting, name) {
	 *   return greeting + ' ' + name;
	 * }
	 *
	 * var sayHelloTo = _.partial(greet, 'hello');
	 * sayHelloTo('fred');
	 * // => 'hello fred'
	 *
	 * // Partially applied with placeholders.
	 * var greetFred = _.partial(greet, _, 'fred');
	 * greetFred('hi');
	 * // => 'hi fred'
	 */
	var partial = baseRest(function(func, partials) {
	  var holders = replaceHolders(partials, getHolder(partial));
	  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	});
	
	// Assign default placeholders.
	partial.placeholder = {};
	
	module.exports = partial;


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(4235),
	    flatRest = __webpack_require__(454);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(439),
	    baseIteratee = __webpack_require__(60),
	    baseSome = __webpack_require__(4243),
	    isArray = __webpack_require__(24),
	    isIterateeCall = __webpack_require__(227);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ }),
/* 694 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(49),
	    isSymbol = __webpack_require__(233);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(651),
	    keys = __webpack_require__(76);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ }),
/* 697 */
/***/ (function(module, exports) {

	'use strict';
	
	var generateBefore = function generateBefore(t, id) {
	  return t.variableDeclaration('var', [t.variableDeclarator(id, t.callExpression(t.memberExpression(t.identifier('Date'), t.identifier('now')), []))]);
	};
	
	var generateInside = function generateInside() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      t = _ref.t,
	      id = _ref.id,
	      line = _ref.line,
	      ch = _ref.ch,
	      timeout = _ref.timeout,
	      extra = _ref.extra;
	
	  return t.ifStatement(t.binaryExpression('>', t.binaryExpression('-', t.callExpression(t.memberExpression(t.identifier('Date'), t.identifier('now')), []), id), t.numericLiteral(timeout)), extra ? t.blockStatement([t.expressionStatement(t.callExpression(extra, [t.numericLiteral(line), t.numericLiteral(ch)])), t.breakStatement()]) : t.breakStatement());
	};
	
	var protect = function protect(t, timeout, extra) {
	  return function (path) {
	    if (!path.node.loc) {
	      // I don't really know _how_ we get into this state
	      // but https://jsbin.com/mipesawapi/1/ triggers it
	      // and the node, I'm guessing after translation,
	      // doesn't have a line in the code, so this blows up.
	      return;
	    }
	    var id = path.scope.generateUidIdentifier('LP');
	    var before = generateBefore(t, id);
	    var inside = generateInside({
	      t: t,
	      id: id,
	      line: path.node.loc.start.line,
	      ch: path.node.loc.start.column,
	      timeout: timeout,
	      extra: extra
	    });
	    var body = path.get('body');
	
	    // if we have an expression statement, convert it to a block
	    if (t.isExpressionStatement(body)) {
	      body.replaceWith(t.blockStatement([body.node]));
	    }
	    path.insertBefore(before);
	    body.unshiftContainer('body', inside);
	  };
	};
	
	module.exports = function () {
	  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
	  var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  if (typeof extra === 'string') {
	    var string = extra;
	    extra = '() => console.error("' + string.replace(/"/g, '\\"') + '")';
	  } else if (extra !== null) {
	    extra = extra.toString();
	    if (extra.startsWith('function (')) {
	      // fix anonymous functions as they'll cause
	      // the callback transform to blow up
	      extra = extra.replace(/^function \(/, 'function callback(');
	    }
	  }
	
	  return function (_ref2) {
	    var t = _ref2.types,
	        transform = _ref2.transform;
	
	    var node = extra ? transform(extra).ast.program.body[0] : null;
	
	    var callback = null;
	    if (t.isExpressionStatement(node)) {
	      callback = node.expression;
	    } else if (t.isFunctionDeclaration(node)) {
	      callback = t.functionExpression(null, node.params, node.body);
	    }
	
	    return {
	      visitor: {
	        WhileStatement: protect(t, timeout, callback),
	        ForStatement: protect(t, timeout, callback),
	        DoWhileStatement: protect(t, timeout, callback)
	      }
	    };
	  };
	};

/***/ }),
/* 698 */
/***/ (function(module, exports) {

	"use strict";
	
	/* https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.is */
	
	var NumberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		} else if (a === b) {
			return true;
		} else if (NumberIsNaN(a) && NumberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(4357);
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};
	
	var keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];
	
		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}
	
		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}
	
		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}
	
		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				return (Object.keys(arguments) || '').length === 2;
			}(1, 2));
			if (!keysWorksWithArguments) {
				var originalKeys = Object.keys;
				Object.keys = function keys(object) {
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					} else {
						return originalKeys(object);
					}
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es6-shim
	var keys = __webpack_require__(699);
	var bind = __webpack_require__(135);
	var canBeObject = function (obj) {
		return typeof obj !== 'undefined' && obj !== null;
	};
	var hasSymbols = __webpack_require__(2725)();
	var toObject = Object;
	var push = bind.call(Function.call, Array.prototype.push);
	var propIsEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);
	var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;
	
	module.exports = function assign(target, source1) {
		if (!canBeObject(target)) { throw new TypeError('target must be an object'); }
		var objTarget = toObject(target);
		var s, source, i, props, syms, value, key;
		for (s = 1; s < arguments.length; ++s) {
			source = toObject(arguments[s]);
			props = keys(source);
			var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
			if (getSymbols) {
				syms = getSymbols(source);
				for (i = 0; i < syms.length; ++i) {
					key = syms[i];
					if (propIsEnumerable(source, key)) {
						push(props, key);
					}
				}
			}
			for (i = 0; i < props.length; ++i) {
				key = props[i];
				value = source[key];
				if (propIsEnumerable(source, key)) {
					objTarget[key] = value;
				}
			}
		}
		return objTarget;
	};


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(700);
	
	var lacksProperEnumerationOrder = function () {
		if (!Object.assign) {
			return false;
		}
		// v8, specifically in node 4.x, has a bug with incorrect property enumeration order
		// note: this does not detect the bug unless there's 20 characters
		var str = 'abcdefghijklmnopqrst';
		var letters = str.split('');
		var map = {};
		for (var i = 0; i < letters.length; ++i) {
			map[letters[i]] = letters[i];
		}
		var obj = Object.assign({}, map);
		var actual = '';
		for (var k in obj) {
			actual += k;
		}
		return str !== actual;
	};
	
	var assignHasPendingExceptions = function () {
		if (!Object.assign || !Object.preventExtensions) {
			return false;
		}
		// Firefox 37 still has "pending exception" logic in its Object.assign implementation,
		// which is 72% slower than our shim, and Firefox 40's native implementation.
		var thrower = Object.preventExtensions({ 1: 2 });
		try {
			Object.assign(thrower, 'xy');
		} catch (e) {
			return thrower[1] === 'y';
		}
		return false;
	};
	
	module.exports = function getPolyfill() {
		if (!Object.assign) {
			return implementation;
		}
		if (lacksProperEnumerationOrder()) {
			return implementation;
		}
		if (assignHasPendingExceptions()) {
			return implementation;
		}
		return Object.assign;
	};


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES = __webpack_require__(610);
	var has = __webpack_require__(177);
	var bind = __webpack_require__(135);
	var isEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);
	
	module.exports = function entries(O) {
		var obj = ES.RequireObjectCoercible(O);
		var entrys = [];
		for (var key in obj) {
			if (has(obj, key) && isEnumerable(obj, key)) {
				entrys.push([key, obj[key]]);
			}
		}
		return entrys;
	};


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(96);
	
	var implementation = __webpack_require__(702);
	var getPolyfill = __webpack_require__(704);
	var shim = __webpack_require__(4359);
	
	var polyfill = getPolyfill();
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(702);
	
	module.exports = function getPolyfill() {
		return typeof Object.entries === 'function' ? Object.entries : implementation;
	};


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES = __webpack_require__(610);
	var has = __webpack_require__(177);
	var bind = __webpack_require__(135);
	var isEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);
	
	module.exports = function values(O) {
		var obj = ES.RequireObjectCoercible(O);
		var vals = [];
		for (var key in obj) {
			if (has(obj, key) && isEnumerable(obj, key)) {
				vals.push(obj[key]);
			}
		}
		return vals;
	};


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(705);
	
	module.exports = function getPolyfill() {
		return typeof Object.values === 'function' ? Object.values : implementation;
	};


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Tokenizer = __webpack_require__(186),
	    HTML = __webpack_require__(77);
	
	//Aliases
	var $ = HTML.TAG_NAMES,
	    NS = HTML.NAMESPACES,
	    ATTRS = HTML.ATTRS;
	
	
	//MIME types
	var MIME_TYPES = {
	    TEXT_HTML: 'text/html',
	    APPLICATION_XML: 'application/xhtml+xml'
	};
	
	//Attributes
	var DEFINITION_URL_ATTR = 'definitionurl',
	    ADJUSTED_DEFINITION_URL_ATTR = 'definitionURL',
	    SVG_ATTRS_ADJUSTMENT_MAP = {
	        'attributename': 'attributeName',
	        'attributetype': 'attributeType',
	        'basefrequency': 'baseFrequency',
	        'baseprofile': 'baseProfile',
	        'calcmode': 'calcMode',
	        'clippathunits': 'clipPathUnits',
	        'diffuseconstant': 'diffuseConstant',
	        'edgemode': 'edgeMode',
	        'filterunits': 'filterUnits',
	        'glyphref': 'glyphRef',
	        'gradienttransform': 'gradientTransform',
	        'gradientunits': 'gradientUnits',
	        'kernelmatrix': 'kernelMatrix',
	        'kernelunitlength': 'kernelUnitLength',
	        'keypoints': 'keyPoints',
	        'keysplines': 'keySplines',
	        'keytimes': 'keyTimes',
	        'lengthadjust': 'lengthAdjust',
	        'limitingconeangle': 'limitingConeAngle',
	        'markerheight': 'markerHeight',
	        'markerunits': 'markerUnits',
	        'markerwidth': 'markerWidth',
	        'maskcontentunits': 'maskContentUnits',
	        'maskunits': 'maskUnits',
	        'numoctaves': 'numOctaves',
	        'pathlength': 'pathLength',
	        'patterncontentunits': 'patternContentUnits',
	        'patterntransform': 'patternTransform',
	        'patternunits': 'patternUnits',
	        'pointsatx': 'pointsAtX',
	        'pointsaty': 'pointsAtY',
	        'pointsatz': 'pointsAtZ',
	        'preservealpha': 'preserveAlpha',
	        'preserveaspectratio': 'preserveAspectRatio',
	        'primitiveunits': 'primitiveUnits',
	        'refx': 'refX',
	        'refy': 'refY',
	        'repeatcount': 'repeatCount',
	        'repeatdur': 'repeatDur',
	        'requiredextensions': 'requiredExtensions',
	        'requiredfeatures': 'requiredFeatures',
	        'specularconstant': 'specularConstant',
	        'specularexponent': 'specularExponent',
	        'spreadmethod': 'spreadMethod',
	        'startoffset': 'startOffset',
	        'stddeviation': 'stdDeviation',
	        'stitchtiles': 'stitchTiles',
	        'surfacescale': 'surfaceScale',
	        'systemlanguage': 'systemLanguage',
	        'tablevalues': 'tableValues',
	        'targetx': 'targetX',
	        'targety': 'targetY',
	        'textlength': 'textLength',
	        'viewbox': 'viewBox',
	        'viewtarget': 'viewTarget',
	        'xchannelselector': 'xChannelSelector',
	        'ychannelselector': 'yChannelSelector',
	        'zoomandpan': 'zoomAndPan'
	    },
	    XML_ATTRS_ADJUSTMENT_MAP = {
	        'xlink:actuate': {prefix: 'xlink', name: 'actuate', namespace: NS.XLINK},
	        'xlink:arcrole': {prefix: 'xlink', name: 'arcrole', namespace: NS.XLINK},
	        'xlink:href': {prefix: 'xlink', name: 'href', namespace: NS.XLINK},
	        'xlink:role': {prefix: 'xlink', name: 'role', namespace: NS.XLINK},
	        'xlink:show': {prefix: 'xlink', name: 'show', namespace: NS.XLINK},
	        'xlink:title': {prefix: 'xlink', name: 'title', namespace: NS.XLINK},
	        'xlink:type': {prefix: 'xlink', name: 'type', namespace: NS.XLINK},
	        'xml:base': {prefix: 'xml', name: 'base', namespace: NS.XML},
	        'xml:lang': {prefix: 'xml', name: 'lang', namespace: NS.XML},
	        'xml:space': {prefix: 'xml', name: 'space', namespace: NS.XML},
	        'xmlns': {prefix: '', name: 'xmlns', namespace: NS.XMLNS},
	        'xmlns:xlink': {prefix: 'xmlns', name: 'xlink', namespace: NS.XMLNS}
	
	    };
	
	//SVG tag names adjustment map
	var SVG_TAG_NAMES_ADJUSTMENT_MAP = exports.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
	    'altglyph': 'altGlyph',
	    'altglyphdef': 'altGlyphDef',
	    'altglyphitem': 'altGlyphItem',
	    'animatecolor': 'animateColor',
	    'animatemotion': 'animateMotion',
	    'animatetransform': 'animateTransform',
	    'clippath': 'clipPath',
	    'feblend': 'feBlend',
	    'fecolormatrix': 'feColorMatrix',
	    'fecomponenttransfer': 'feComponentTransfer',
	    'fecomposite': 'feComposite',
	    'feconvolvematrix': 'feConvolveMatrix',
	    'fediffuselighting': 'feDiffuseLighting',
	    'fedisplacementmap': 'feDisplacementMap',
	    'fedistantlight': 'feDistantLight',
	    'feflood': 'feFlood',
	    'fefunca': 'feFuncA',
	    'fefuncb': 'feFuncB',
	    'fefuncg': 'feFuncG',
	    'fefuncr': 'feFuncR',
	    'fegaussianblur': 'feGaussianBlur',
	    'feimage': 'feImage',
	    'femerge': 'feMerge',
	    'femergenode': 'feMergeNode',
	    'femorphology': 'feMorphology',
	    'feoffset': 'feOffset',
	    'fepointlight': 'fePointLight',
	    'fespecularlighting': 'feSpecularLighting',
	    'fespotlight': 'feSpotLight',
	    'fetile': 'feTile',
	    'feturbulence': 'feTurbulence',
	    'foreignobject': 'foreignObject',
	    'glyphref': 'glyphRef',
	    'lineargradient': 'linearGradient',
	    'radialgradient': 'radialGradient',
	    'textpath': 'textPath'
	};
	
	//Tags that causes exit from foreign content
	var EXITS_FOREIGN_CONTENT = Object.create(null);
	
	EXITS_FOREIGN_CONTENT[$.B] = true;
	EXITS_FOREIGN_CONTENT[$.BIG] = true;
	EXITS_FOREIGN_CONTENT[$.BLOCKQUOTE] = true;
	EXITS_FOREIGN_CONTENT[$.BODY] = true;
	EXITS_FOREIGN_CONTENT[$.BR] = true;
	EXITS_FOREIGN_CONTENT[$.CENTER] = true;
	EXITS_FOREIGN_CONTENT[$.CODE] = true;
	EXITS_FOREIGN_CONTENT[$.DD] = true;
	EXITS_FOREIGN_CONTENT[$.DIV] = true;
	EXITS_FOREIGN_CONTENT[$.DL] = true;
	EXITS_FOREIGN_CONTENT[$.DT] = true;
	EXITS_FOREIGN_CONTENT[$.EM] = true;
	EXITS_FOREIGN_CONTENT[$.EMBED] = true;
	EXITS_FOREIGN_CONTENT[$.H1] = true;
	EXITS_FOREIGN_CONTENT[$.H2] = true;
	EXITS_FOREIGN_CONTENT[$.H3] = true;
	EXITS_FOREIGN_CONTENT[$.H4] = true;
	EXITS_FOREIGN_CONTENT[$.H5] = true;
	EXITS_FOREIGN_CONTENT[$.H6] = true;
	EXITS_FOREIGN_CONTENT[$.HEAD] = true;
	EXITS_FOREIGN_CONTENT[$.HR] = true;
	EXITS_FOREIGN_CONTENT[$.I] = true;
	EXITS_FOREIGN_CONTENT[$.IMG] = true;
	EXITS_FOREIGN_CONTENT[$.LI] = true;
	EXITS_FOREIGN_CONTENT[$.LISTING] = true;
	EXITS_FOREIGN_CONTENT[$.MENU] = true;
	EXITS_FOREIGN_CONTENT[$.META] = true;
	EXITS_FOREIGN_CONTENT[$.NOBR] = true;
	EXITS_FOREIGN_CONTENT[$.OL] = true;
	EXITS_FOREIGN_CONTENT[$.P] = true;
	EXITS_FOREIGN_CONTENT[$.PRE] = true;
	EXITS_FOREIGN_CONTENT[$.RUBY] = true;
	EXITS_FOREIGN_CONTENT[$.S] = true;
	EXITS_FOREIGN_CONTENT[$.SMALL] = true;
	EXITS_FOREIGN_CONTENT[$.SPAN] = true;
	EXITS_FOREIGN_CONTENT[$.STRONG] = true;
	EXITS_FOREIGN_CONTENT[$.STRIKE] = true;
	EXITS_FOREIGN_CONTENT[$.SUB] = true;
	EXITS_FOREIGN_CONTENT[$.SUP] = true;
	EXITS_FOREIGN_CONTENT[$.TABLE] = true;
	EXITS_FOREIGN_CONTENT[$.TT] = true;
	EXITS_FOREIGN_CONTENT[$.U] = true;
	EXITS_FOREIGN_CONTENT[$.UL] = true;
	EXITS_FOREIGN_CONTENT[$.VAR] = true;
	
	//Check exit from foreign content
	exports.causesExit = function (startTagToken) {
	    var tn = startTagToken.tagName;
	    var isFontWithAttrs = tn === $.FONT && (Tokenizer.getTokenAttr(startTagToken, ATTRS.COLOR) !== null ||
	                                            Tokenizer.getTokenAttr(startTagToken, ATTRS.SIZE) !== null ||
	                                            Tokenizer.getTokenAttr(startTagToken, ATTRS.FACE) !== null);
	
	    return isFontWithAttrs ? true : EXITS_FOREIGN_CONTENT[tn];
	};
	
	//Token adjustments
	exports.adjustTokenMathMLAttrs = function (token) {
	    for (var i = 0; i < token.attrs.length; i++) {
	        if (token.attrs[i].name === DEFINITION_URL_ATTR) {
	            token.attrs[i].name = ADJUSTED_DEFINITION_URL_ATTR;
	            break;
	        }
	    }
	};
	
	exports.adjustTokenSVGAttrs = function (token) {
	    for (var i = 0; i < token.attrs.length; i++) {
	        var adjustedAttrName = SVG_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];
	
	        if (adjustedAttrName)
	            token.attrs[i].name = adjustedAttrName;
	    }
	};
	
	exports.adjustTokenXMLAttrs = function (token) {
	    for (var i = 0; i < token.attrs.length; i++) {
	        var adjustedAttrEntry = XML_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];
	
	        if (adjustedAttrEntry) {
	            token.attrs[i].prefix = adjustedAttrEntry.prefix;
	            token.attrs[i].name = adjustedAttrEntry.name;
	            token.attrs[i].namespace = adjustedAttrEntry.namespace;
	        }
	    }
	};
	
	exports.adjustTokenSVGTagName = function (token) {
	    var adjustedTagName = SVG_TAG_NAMES_ADJUSTMENT_MAP[token.tagName];
	
	    if (adjustedTagName)
	        token.tagName = adjustedTagName;
	};
	
	//Integration points
	function isMathMLTextIntegrationPoint(tn, ns) {
	    return ns === NS.MATHML && (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS || tn === $.MTEXT);
	}
	
	function isHtmlIntegrationPoint(tn, ns, attrs) {
	    if (ns === NS.MATHML && tn === $.ANNOTATION_XML) {
	        for (var i = 0; i < attrs.length; i++) {
	            if (attrs[i].name === ATTRS.ENCODING) {
	                var value = attrs[i].value.toLowerCase();
	
	                return value === MIME_TYPES.TEXT_HTML || value === MIME_TYPES.APPLICATION_XML;
	            }
	        }
	    }
	
	    return ns === NS.SVG && (tn === $.FOREIGN_OBJECT || tn === $.DESC || tn === $.TITLE);
	}
	
	exports.isIntegrationPoint = function (tn, ns, attrs, foreignNS) {
	    if ((!foreignNS || foreignNS === NS.HTML) && isHtmlIntegrationPoint(tn, ns, attrs))
	        return true;
	
	    if ((!foreignNS || foreignNS === NS.MATHML) && isMathMLTextIntegrationPoint(tn, ns))
	        return true;
	
	    return false;
	};


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Mixin = __webpack_require__(335),
	    Tokenizer = __webpack_require__(186),
	    PositionTrackingPreprocessorMixin = __webpack_require__(709),
	    inherits = __webpack_require__(55).inherits;
	
	var LocationInfoTokenizerMixin = module.exports = function (tokenizer) {
	    Mixin.call(this, tokenizer);
	
	    this.tokenizer = tokenizer;
	    this.posTracker = new PositionTrackingPreprocessorMixin(tokenizer.preprocessor);
	    this.currentAttrLocation = null;
	    this.currentTokenLocation = null;
	};
	
	inherits(LocationInfoTokenizerMixin, Mixin);
	
	LocationInfoTokenizerMixin.prototype._getCurrentLocation = function () {
	    return {
	        line: this.posTracker.line,
	        col: this.posTracker.col,
	        startOffset: this.posTracker.offset,
	        endOffset: -1
	    };
	};
	
	LocationInfoTokenizerMixin.prototype._attachCurrentAttrLocationInfo = function () {
	    this.currentAttrLocation.endOffset = this.posTracker.offset;
	
	    var currentToken = this.tokenizer.currentToken,
	        currentAttr = this.tokenizer.currentAttr;
	
	    if (!currentToken.location.attrs)
	        currentToken.location.attrs = Object.create(null);
	
	    currentToken.location.attrs[currentAttr.name] = this.currentAttrLocation;
	};
	
	LocationInfoTokenizerMixin.prototype._getOverriddenMethods = function (mxn, orig) {
	    var methods = {
	        _createStartTagToken: function () {
	            orig._createStartTagToken.call(this);
	            this.currentToken.location = mxn.currentTokenLocation;
	        },
	
	        _createEndTagToken: function () {
	            orig._createEndTagToken.call(this);
	            this.currentToken.location = mxn.currentTokenLocation;
	        },
	
	        _createCommentToken: function () {
	            orig._createCommentToken.call(this);
	            this.currentToken.location = mxn.currentTokenLocation;
	        },
	
	        _createDoctypeToken: function (initialName) {
	            orig._createDoctypeToken.call(this, initialName);
	            this.currentToken.location = mxn.currentTokenLocation;
	        },
	
	        _createCharacterToken: function (type, ch) {
	            orig._createCharacterToken.call(this, type, ch);
	            this.currentCharacterToken.location = mxn.currentTokenLocation;
	        },
	
	        _createAttr: function (attrNameFirstCh) {
	            orig._createAttr.call(this, attrNameFirstCh);
	            mxn.currentAttrLocation = mxn._getCurrentLocation();
	        },
	
	        _leaveAttrName: function (toState) {
	            orig._leaveAttrName.call(this, toState);
	            mxn._attachCurrentAttrLocationInfo();
	        },
	
	        _leaveAttrValue: function (toState) {
	            orig._leaveAttrValue.call(this, toState);
	            mxn._attachCurrentAttrLocationInfo();
	        },
	
	        _emitCurrentToken: function () {
	            //NOTE: if we have pending character token make it's end location equal to the
	            //current token's start location.
	            if (this.currentCharacterToken)
	                this.currentCharacterToken.location.endOffset = this.currentToken.location.startOffset;
	
	            this.currentToken.location.endOffset = mxn.posTracker.offset + 1;
	            orig._emitCurrentToken.call(this);
	        },
	
	        _emitCurrentCharacterToken: function () {
	            //NOTE: if we have character token and it's location wasn't set in the _emitCurrentToken(),
	            //then set it's location at the current preprocessor position.
	            //We don't need to increment preprocessor position, since character token
	            //emission is always forced by the start of the next character token here.
	            //So, we already have advanced position.
	            if (this.currentCharacterToken && this.currentCharacterToken.location.endOffset === -1)
	                this.currentCharacterToken.location.endOffset = mxn.posTracker.offset;
	
	            orig._emitCurrentCharacterToken.call(this);
	        }
	    };
	
	    //NOTE: patch initial states for each mode to obtain token start position
	    Object.keys(Tokenizer.MODE).forEach(function (modeName) {
	        var state = Tokenizer.MODE[modeName];
	
	        methods[state] = function (cp) {
	            mxn.currentTokenLocation = mxn._getCurrentLocation();
	            orig[state].call(this, cp);
	        };
	    });
	
	    return methods;
	};
	


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Mixin = __webpack_require__(335),
	    inherits = __webpack_require__(55).inherits,
	    UNICODE = __webpack_require__(234);
	
	//Aliases
	var $ = UNICODE.CODE_POINTS;
	
	var PositionTrackingPreprocessorMixin = module.exports = function (preprocessor) {
	    // NOTE: avoid installing tracker twice
	    if (!preprocessor.__locTracker) {
	        preprocessor.__locTracker = this;
	
	        Mixin.call(this, preprocessor);
	
	        this.preprocessor = preprocessor;
	        this.isEol = false;
	        this.lineStartPos = 0;
	        this.droppedBufferSize = 0;
	
	        this.col = -1;
	        this.line = 1;
	    }
	
	    return preprocessor.__locTracker;
	};
	
	inherits(PositionTrackingPreprocessorMixin, Mixin);
	
	Object.defineProperty(PositionTrackingPreprocessorMixin.prototype, 'offset', {
	    get: function () {
	        return this.droppedBufferSize + this.preprocessor.pos;
	    }
	});
	
	PositionTrackingPreprocessorMixin.prototype._getOverriddenMethods = function (mxn, orig) {
	    return {
	        advance: function () {
	            var cp = orig.advance.call(this);
	
	            //NOTE: LF should be in the last column of the line
	            if (mxn.isEol) {
	                mxn.isEol = false;
	                mxn.line++;
	                mxn.lineStartPos = mxn.offset;
	            }
	
	            if (cp === $.LINE_FEED)
	                mxn.isEol = true;
	
	            mxn.col = mxn.offset - mxn.lineStartPos + 1;
	
	            return cp;
	        },
	
	        retreat: function () {
	            orig.retreat.call(this);
	            mxn.isEol = false;
	
	            mxn.col = mxn.offset - mxn.lineStartPos + 1;
	        },
	
	        dropParsedChunk: function () {
	            var prevPos = this.pos;
	
	            orig.dropParsedChunk.call(this);
	
	            mxn.droppedBufferSize += prevPos - this.pos;
	        }
	    };
	};


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Tokenizer = __webpack_require__(186),
	    OpenElementStack = __webpack_require__(4367),
	    FormattingElementList = __webpack_require__(4366),
	    LocationInfoParserMixin = __webpack_require__(4364),
	    defaultTreeAdapter = __webpack_require__(482),
	    mergeOptions = __webpack_require__(483),
	    doctype = __webpack_require__(481),
	    foreignContent = __webpack_require__(707),
	    UNICODE = __webpack_require__(234),
	    HTML = __webpack_require__(77);
	
	//Aliases
	var $ = HTML.TAG_NAMES,
	    NS = HTML.NAMESPACES,
	    ATTRS = HTML.ATTRS;
	
	var DEFAULT_OPTIONS = {
	    locationInfo: false,
	    treeAdapter: defaultTreeAdapter
	};
	
	//Misc constants
	var HIDDEN_INPUT_TYPE = 'hidden';
	
	//Adoption agency loops iteration count
	var AA_OUTER_LOOP_ITER = 8,
	    AA_INNER_LOOP_ITER = 3;
	
	//Insertion modes
	var INITIAL_MODE = 'INITIAL_MODE',
	    BEFORE_HTML_MODE = 'BEFORE_HTML_MODE',
	    BEFORE_HEAD_MODE = 'BEFORE_HEAD_MODE',
	    IN_HEAD_MODE = 'IN_HEAD_MODE',
	    AFTER_HEAD_MODE = 'AFTER_HEAD_MODE',
	    IN_BODY_MODE = 'IN_BODY_MODE',
	    TEXT_MODE = 'TEXT_MODE',
	    IN_TABLE_MODE = 'IN_TABLE_MODE',
	    IN_TABLE_TEXT_MODE = 'IN_TABLE_TEXT_MODE',
	    IN_CAPTION_MODE = 'IN_CAPTION_MODE',
	    IN_COLUMN_GROUP_MODE = 'IN_COLUMN_GROUP_MODE',
	    IN_TABLE_BODY_MODE = 'IN_TABLE_BODY_MODE',
	    IN_ROW_MODE = 'IN_ROW_MODE',
	    IN_CELL_MODE = 'IN_CELL_MODE',
	    IN_SELECT_MODE = 'IN_SELECT_MODE',
	    IN_SELECT_IN_TABLE_MODE = 'IN_SELECT_IN_TABLE_MODE',
	    IN_TEMPLATE_MODE = 'IN_TEMPLATE_MODE',
	    AFTER_BODY_MODE = 'AFTER_BODY_MODE',
	    IN_FRAMESET_MODE = 'IN_FRAMESET_MODE',
	    AFTER_FRAMESET_MODE = 'AFTER_FRAMESET_MODE',
	    AFTER_AFTER_BODY_MODE = 'AFTER_AFTER_BODY_MODE',
	    AFTER_AFTER_FRAMESET_MODE = 'AFTER_AFTER_FRAMESET_MODE';
	
	//Insertion mode reset map
	var INSERTION_MODE_RESET_MAP = Object.create(null);
	
	INSERTION_MODE_RESET_MAP[$.TR] = IN_ROW_MODE;
	INSERTION_MODE_RESET_MAP[$.TBODY] =
	INSERTION_MODE_RESET_MAP[$.THEAD] =
	INSERTION_MODE_RESET_MAP[$.TFOOT] = IN_TABLE_BODY_MODE;
	INSERTION_MODE_RESET_MAP[$.CAPTION] = IN_CAPTION_MODE;
	INSERTION_MODE_RESET_MAP[$.COLGROUP] = IN_COLUMN_GROUP_MODE;
	INSERTION_MODE_RESET_MAP[$.TABLE] = IN_TABLE_MODE;
	INSERTION_MODE_RESET_MAP[$.BODY] = IN_BODY_MODE;
	INSERTION_MODE_RESET_MAP[$.FRAMESET] = IN_FRAMESET_MODE;
	
	//Template insertion mode switch map
	var TEMPLATE_INSERTION_MODE_SWITCH_MAP = Object.create(null);
	
	TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.CAPTION] =
	TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.COLGROUP] =
	TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TBODY] =
	TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TFOOT] =
	TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.THEAD] = IN_TABLE_MODE;
	TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.COL] = IN_COLUMN_GROUP_MODE;
	TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TR] = IN_TABLE_BODY_MODE;
	TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TD] =
	TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TH] = IN_ROW_MODE;
	
	//Token handlers map for insertion modes
	var _ = Object.create(null);
	
	_[INITIAL_MODE] = Object.create(null);
	_[INITIAL_MODE][Tokenizer.CHARACTER_TOKEN] =
	_[INITIAL_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenInInitialMode;
	_[INITIAL_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = ignoreToken;
	_[INITIAL_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
	_[INITIAL_MODE][Tokenizer.DOCTYPE_TOKEN] = doctypeInInitialMode;
	_[INITIAL_MODE][Tokenizer.START_TAG_TOKEN] =
	_[INITIAL_MODE][Tokenizer.END_TAG_TOKEN] =
	_[INITIAL_MODE][Tokenizer.EOF_TOKEN] = tokenInInitialMode;
	
	_[BEFORE_HTML_MODE] = Object.create(null);
	_[BEFORE_HTML_MODE][Tokenizer.CHARACTER_TOKEN] =
	_[BEFORE_HTML_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenBeforeHtml;
	_[BEFORE_HTML_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = ignoreToken;
	_[BEFORE_HTML_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
	_[BEFORE_HTML_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[BEFORE_HTML_MODE][Tokenizer.START_TAG_TOKEN] = startTagBeforeHtml;
	_[BEFORE_HTML_MODE][Tokenizer.END_TAG_TOKEN] = endTagBeforeHtml;
	_[BEFORE_HTML_MODE][Tokenizer.EOF_TOKEN] = tokenBeforeHtml;
	
	_[BEFORE_HEAD_MODE] = Object.create(null);
	_[BEFORE_HEAD_MODE][Tokenizer.CHARACTER_TOKEN] =
	_[BEFORE_HEAD_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenBeforeHead;
	_[BEFORE_HEAD_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = ignoreToken;
	_[BEFORE_HEAD_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
	_[BEFORE_HEAD_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[BEFORE_HEAD_MODE][Tokenizer.START_TAG_TOKEN] = startTagBeforeHead;
	_[BEFORE_HEAD_MODE][Tokenizer.END_TAG_TOKEN] = endTagBeforeHead;
	_[BEFORE_HEAD_MODE][Tokenizer.EOF_TOKEN] = tokenBeforeHead;
	
	_[IN_HEAD_MODE] = Object.create(null);
	_[IN_HEAD_MODE][Tokenizer.CHARACTER_TOKEN] =
	_[IN_HEAD_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenInHead;
	_[IN_HEAD_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
	_[IN_HEAD_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
	_[IN_HEAD_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[IN_HEAD_MODE][Tokenizer.START_TAG_TOKEN] = startTagInHead;
	_[IN_HEAD_MODE][Tokenizer.END_TAG_TOKEN] = endTagInHead;
	_[IN_HEAD_MODE][Tokenizer.EOF_TOKEN] = tokenInHead;
	
	_[AFTER_HEAD_MODE] = Object.create(null);
	_[AFTER_HEAD_MODE][Tokenizer.CHARACTER_TOKEN] =
	_[AFTER_HEAD_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenAfterHead;
	_[AFTER_HEAD_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
	_[AFTER_HEAD_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
	_[AFTER_HEAD_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[AFTER_HEAD_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterHead;
	_[AFTER_HEAD_MODE][Tokenizer.END_TAG_TOKEN] = endTagAfterHead;
	_[AFTER_HEAD_MODE][Tokenizer.EOF_TOKEN] = tokenAfterHead;
	
	_[IN_BODY_MODE] = Object.create(null);
	_[IN_BODY_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
	_[IN_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
	_[IN_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
	_[IN_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
	_[IN_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[IN_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagInBody;
	_[IN_BODY_MODE][Tokenizer.END_TAG_TOKEN] = endTagInBody;
	_[IN_BODY_MODE][Tokenizer.EOF_TOKEN] = eofInBody;
	
	_[TEXT_MODE] = Object.create(null);
	_[TEXT_MODE][Tokenizer.CHARACTER_TOKEN] =
	_[TEXT_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
	_[TEXT_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
	_[TEXT_MODE][Tokenizer.COMMENT_TOKEN] =
	_[TEXT_MODE][Tokenizer.DOCTYPE_TOKEN] =
	_[TEXT_MODE][Tokenizer.START_TAG_TOKEN] = ignoreToken;
	_[TEXT_MODE][Tokenizer.END_TAG_TOKEN] = endTagInText;
	_[TEXT_MODE][Tokenizer.EOF_TOKEN] = eofInText;
	
	_[IN_TABLE_MODE] = Object.create(null);
	_[IN_TABLE_MODE][Tokenizer.CHARACTER_TOKEN] =
	_[IN_TABLE_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
	_[IN_TABLE_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = characterInTable;
	_[IN_TABLE_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
	_[IN_TABLE_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[IN_TABLE_MODE][Tokenizer.START_TAG_TOKEN] = startTagInTable;
	_[IN_TABLE_MODE][Tokenizer.END_TAG_TOKEN] = endTagInTable;
	_[IN_TABLE_MODE][Tokenizer.EOF_TOKEN] = eofInBody;
	
	_[IN_TABLE_TEXT_MODE] = Object.create(null);
	_[IN_TABLE_TEXT_MODE][Tokenizer.CHARACTER_TOKEN] = characterInTableText;
	_[IN_TABLE_TEXT_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
	_[IN_TABLE_TEXT_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInTableText;
	_[IN_TABLE_TEXT_MODE][Tokenizer.COMMENT_TOKEN] =
	_[IN_TABLE_TEXT_MODE][Tokenizer.DOCTYPE_TOKEN] =
	_[IN_TABLE_TEXT_MODE][Tokenizer.START_TAG_TOKEN] =
	_[IN_TABLE_TEXT_MODE][Tokenizer.END_TAG_TOKEN] =
	_[IN_TABLE_TEXT_MODE][Tokenizer.EOF_TOKEN] = tokenInTableText;
	
	_[IN_CAPTION_MODE] = Object.create(null);
	_[IN_CAPTION_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
	_[IN_CAPTION_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
	_[IN_CAPTION_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
	_[IN_CAPTION_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
	_[IN_CAPTION_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[IN_CAPTION_MODE][Tokenizer.START_TAG_TOKEN] = startTagInCaption;
	_[IN_CAPTION_MODE][Tokenizer.END_TAG_TOKEN] = endTagInCaption;
	_[IN_CAPTION_MODE][Tokenizer.EOF_TOKEN] = eofInBody;
	
	_[IN_COLUMN_GROUP_MODE] = Object.create(null);
	_[IN_COLUMN_GROUP_MODE][Tokenizer.CHARACTER_TOKEN] =
	_[IN_COLUMN_GROUP_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenInColumnGroup;
	_[IN_COLUMN_GROUP_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
	_[IN_COLUMN_GROUP_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
	_[IN_COLUMN_GROUP_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[IN_COLUMN_GROUP_MODE][Tokenizer.START_TAG_TOKEN] = startTagInColumnGroup;
	_[IN_COLUMN_GROUP_MODE][Tokenizer.END_TAG_TOKEN] = endTagInColumnGroup;
	_[IN_COLUMN_GROUP_MODE][Tokenizer.EOF_TOKEN] = eofInBody;
	
	_[IN_TABLE_BODY_MODE] = Object.create(null);
	_[IN_TABLE_BODY_MODE][Tokenizer.CHARACTER_TOKEN] =
	_[IN_TABLE_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
	_[IN_TABLE_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = characterInTable;
	_[IN_TABLE_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
	_[IN_TABLE_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[IN_TABLE_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagInTableBody;
	_[IN_TABLE_BODY_MODE][Tokenizer.END_TAG_TOKEN] = endTagInTableBody;
	_[IN_TABLE_BODY_MODE][Tokenizer.EOF_TOKEN] = eofInBody;
	
	_[IN_ROW_MODE] = Object.create(null);
	_[IN_ROW_MODE][Tokenizer.CHARACTER_TOKEN] =
	_[IN_ROW_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
	_[IN_ROW_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = characterInTable;
	_[IN_ROW_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
	_[IN_ROW_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[IN_ROW_MODE][Tokenizer.START_TAG_TOKEN] = startTagInRow;
	_[IN_ROW_MODE][Tokenizer.END_TAG_TOKEN] = endTagInRow;
	_[IN_ROW_MODE][Tokenizer.EOF_TOKEN] = eofInBody;
	
	_[IN_CELL_MODE] = Object.create(null);
	_[IN_CELL_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
	_[IN_CELL_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
	_[IN_CELL_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
	_[IN_CELL_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
	_[IN_CELL_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[IN_CELL_MODE][Tokenizer.START_TAG_TOKEN] = startTagInCell;
	_[IN_CELL_MODE][Tokenizer.END_TAG_TOKEN] = endTagInCell;
	_[IN_CELL_MODE][Tokenizer.EOF_TOKEN] = eofInBody;
	
	_[IN_SELECT_MODE] = Object.create(null);
	_[IN_SELECT_MODE][Tokenizer.CHARACTER_TOKEN] = insertCharacters;
	_[IN_SELECT_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
	_[IN_SELECT_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
	_[IN_SELECT_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
	_[IN_SELECT_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[IN_SELECT_MODE][Tokenizer.START_TAG_TOKEN] = startTagInSelect;
	_[IN_SELECT_MODE][Tokenizer.END_TAG_TOKEN] = endTagInSelect;
	_[IN_SELECT_MODE][Tokenizer.EOF_TOKEN] = eofInBody;
	
	_[IN_SELECT_IN_TABLE_MODE] = Object.create(null);
	_[IN_SELECT_IN_TABLE_MODE][Tokenizer.CHARACTER_TOKEN] = insertCharacters;
	_[IN_SELECT_IN_TABLE_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
	_[IN_SELECT_IN_TABLE_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
	_[IN_SELECT_IN_TABLE_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
	_[IN_SELECT_IN_TABLE_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[IN_SELECT_IN_TABLE_MODE][Tokenizer.START_TAG_TOKEN] = startTagInSelectInTable;
	_[IN_SELECT_IN_TABLE_MODE][Tokenizer.END_TAG_TOKEN] = endTagInSelectInTable;
	_[IN_SELECT_IN_TABLE_MODE][Tokenizer.EOF_TOKEN] = eofInBody;
	
	_[IN_TEMPLATE_MODE] = Object.create(null);
	_[IN_TEMPLATE_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
	_[IN_TEMPLATE_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
	_[IN_TEMPLATE_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
	_[IN_TEMPLATE_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
	_[IN_TEMPLATE_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[IN_TEMPLATE_MODE][Tokenizer.START_TAG_TOKEN] = startTagInTemplate;
	_[IN_TEMPLATE_MODE][Tokenizer.END_TAG_TOKEN] = endTagInTemplate;
	_[IN_TEMPLATE_MODE][Tokenizer.EOF_TOKEN] = eofInTemplate;
	
	_[AFTER_BODY_MODE] = Object.create(null);
	_[AFTER_BODY_MODE][Tokenizer.CHARACTER_TOKEN] =
	_[AFTER_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenAfterBody;
	_[AFTER_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
	_[AFTER_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendCommentToRootHtmlElement;
	_[AFTER_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[AFTER_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterBody;
	_[AFTER_BODY_MODE][Tokenizer.END_TAG_TOKEN] = endTagAfterBody;
	_[AFTER_BODY_MODE][Tokenizer.EOF_TOKEN] = stopParsing;
	
	_[IN_FRAMESET_MODE] = Object.create(null);
	_[IN_FRAMESET_MODE][Tokenizer.CHARACTER_TOKEN] =
	_[IN_FRAMESET_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
	_[IN_FRAMESET_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
	_[IN_FRAMESET_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
	_[IN_FRAMESET_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[IN_FRAMESET_MODE][Tokenizer.START_TAG_TOKEN] = startTagInFrameset;
	_[IN_FRAMESET_MODE][Tokenizer.END_TAG_TOKEN] = endTagInFrameset;
	_[IN_FRAMESET_MODE][Tokenizer.EOF_TOKEN] = stopParsing;
	
	_[AFTER_FRAMESET_MODE] = Object.create(null);
	_[AFTER_FRAMESET_MODE][Tokenizer.CHARACTER_TOKEN] =
	_[AFTER_FRAMESET_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
	_[AFTER_FRAMESET_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
	_[AFTER_FRAMESET_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
	_[AFTER_FRAMESET_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[AFTER_FRAMESET_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterFrameset;
	_[AFTER_FRAMESET_MODE][Tokenizer.END_TAG_TOKEN] = endTagAfterFrameset;
	_[AFTER_FRAMESET_MODE][Tokenizer.EOF_TOKEN] = stopParsing;
	
	_[AFTER_AFTER_BODY_MODE] = Object.create(null);
	_[AFTER_AFTER_BODY_MODE][Tokenizer.CHARACTER_TOKEN] = tokenAfterAfterBody;
	_[AFTER_AFTER_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenAfterAfterBody;
	_[AFTER_AFTER_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
	_[AFTER_AFTER_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendCommentToDocument;
	_[AFTER_AFTER_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[AFTER_AFTER_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterAfterBody;
	_[AFTER_AFTER_BODY_MODE][Tokenizer.END_TAG_TOKEN] = tokenAfterAfterBody;
	_[AFTER_AFTER_BODY_MODE][Tokenizer.EOF_TOKEN] = stopParsing;
	
	_[AFTER_AFTER_FRAMESET_MODE] = Object.create(null);
	_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.CHARACTER_TOKEN] =
	_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
	_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
	_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.COMMENT_TOKEN] = appendCommentToDocument;
	_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
	_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterAfterFrameset;
	_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.END_TAG_TOKEN] = ignoreToken;
	_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.EOF_TOKEN] = stopParsing;
	
	
	//Parser
	var Parser = module.exports = function (options) {
	    this.options = mergeOptions(DEFAULT_OPTIONS, options);
	
	    this.treeAdapter = this.options.treeAdapter;
	    this.pendingScript = null;
	
	    if (this.options.locationInfo)
	        new LocationInfoParserMixin(this);
	};
	
	// API
	Parser.prototype.parse = function (html) {
	    var document = this.treeAdapter.createDocument();
	
	    this._bootstrap(document, null);
	    this.tokenizer.write(html, true);
	    this._runParsingLoop(null);
	
	    return document;
	};
	
	Parser.prototype.parseFragment = function (html, fragmentContext) {
	    //NOTE: use <template> element as a fragment context if context element was not provided,
	    //so we will parse in "forgiving" manner
	    if (!fragmentContext)
	        fragmentContext = this.treeAdapter.createElement($.TEMPLATE, NS.HTML, []);
	
	    //NOTE: create fake element which will be used as 'document' for fragment parsing.
	    //This is important for jsdom there 'document' can't be recreated, therefore
	    //fragment parsing causes messing of the main `document`.
	    var documentMock = this.treeAdapter.createElement('documentmock', NS.HTML, []);
	
	    this._bootstrap(documentMock, fragmentContext);
	
	    if (this.treeAdapter.getTagName(fragmentContext) === $.TEMPLATE)
	        this._pushTmplInsertionMode(IN_TEMPLATE_MODE);
	
	    this._initTokenizerForFragmentParsing();
	    this._insertFakeRootElement();
	    this._resetInsertionMode();
	    this._findFormInFragmentContext();
	    this.tokenizer.write(html, true);
	    this._runParsingLoop(null);
	
	    var rootElement = this.treeAdapter.getFirstChild(documentMock),
	        fragment = this.treeAdapter.createDocumentFragment();
	
	    this._adoptNodes(rootElement, fragment);
	
	    return fragment;
	};
	
	//Bootstrap parser
	Parser.prototype._bootstrap = function (document, fragmentContext) {
	    this.tokenizer = new Tokenizer(this.options);
	
	    this.stopped = false;
	
	    this.insertionMode = INITIAL_MODE;
	    this.originalInsertionMode = '';
	
	    this.document = document;
	    this.fragmentContext = fragmentContext;
	
	    this.headElement = null;
	    this.formElement = null;
	
	    this.openElements = new OpenElementStack(this.document, this.treeAdapter);
	    this.activeFormattingElements = new FormattingElementList(this.treeAdapter);
	
	    this.tmplInsertionModeStack = [];
	    this.tmplInsertionModeStackTop = -1;
	    this.currentTmplInsertionMode = null;
	
	    this.pendingCharacterTokens = [];
	    this.hasNonWhitespacePendingCharacterToken = false;
	
	    this.framesetOk = true;
	    this.skipNextNewLine = false;
	    this.fosterParentingEnabled = false;
	};
	
	//Parsing loop
	Parser.prototype._runParsingLoop  = function (scriptHandler) {
	    while (!this.stopped) {
	        this._setupTokenizerCDATAMode();
	
	        var token = this.tokenizer.getNextToken();
	
	        if (token.type === Tokenizer.HIBERNATION_TOKEN)
	            break;
	
	        if (this.skipNextNewLine) {
	            this.skipNextNewLine = false;
	
	            if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN && token.chars[0] === '\n') {
	                if (token.chars.length === 1)
	                    continue;
	
	                token.chars = token.chars.substr(1);
	            }
	        }
	
	        this._processInputToken(token);
	
	        if (scriptHandler && this.pendingScript)
	            break;
	    }
	};
	
	Parser.prototype.runParsingLoopForCurrentChunk = function (writeCallback, scriptHandler) {
	    this._runParsingLoop(scriptHandler);
	
	    if (scriptHandler && this.pendingScript) {
	        var script = this.pendingScript;
	
	        this.pendingScript = null;
	
	        scriptHandler(script);
	
	        return;
	    }
	
	    if (writeCallback)
	        writeCallback();
	};
	
	//Text parsing
	Parser.prototype._setupTokenizerCDATAMode = function () {
	    var current = this._getAdjustedCurrentElement();
	
	    this.tokenizer.allowCDATA = current && current !== this.document &&
	                                this.treeAdapter.getNamespaceURI(current) !== NS.HTML && !this._isIntegrationPoint(current);
	};
	
	Parser.prototype._switchToTextParsing = function (currentToken, nextTokenizerState) {
	    this._insertElement(currentToken, NS.HTML);
	    this.tokenizer.state = nextTokenizerState;
	    this.originalInsertionMode = this.insertionMode;
	    this.insertionMode = TEXT_MODE;
	};
	
	Parser.prototype.switchToPlaintextParsing = function () {
	    this.insertionMode = TEXT_MODE;
	    this.originalInsertionMode = IN_BODY_MODE;
	    this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
	};
	
	//Fragment parsing
	Parser.prototype._getAdjustedCurrentElement = function () {
	    return this.openElements.stackTop === 0 && this.fragmentContext ?
	        this.fragmentContext :
	        this.openElements.current;
	};
	
	Parser.prototype._findFormInFragmentContext = function () {
	    var node = this.fragmentContext;
	
	    do {
	        if (this.treeAdapter.getTagName(node) === $.FORM) {
	            this.formElement = node;
	            break;
	        }
	
	        node = this.treeAdapter.getParentNode(node);
	    } while (node);
	};
	
	Parser.prototype._initTokenizerForFragmentParsing = function () {
	    if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === NS.HTML) {
	        var tn = this.treeAdapter.getTagName(this.fragmentContext);
	
	        if (tn === $.TITLE || tn === $.TEXTAREA)
	            this.tokenizer.state = Tokenizer.MODE.RCDATA;
	
	        else if (tn === $.STYLE || tn === $.XMP || tn === $.IFRAME ||
	                 tn === $.NOEMBED || tn === $.NOFRAMES || tn === $.NOSCRIPT)
	            this.tokenizer.state = Tokenizer.MODE.RAWTEXT;
	
	        else if (tn === $.SCRIPT)
	            this.tokenizer.state = Tokenizer.MODE.SCRIPT_DATA;
	
	        else if (tn === $.PLAINTEXT)
	            this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
	    }
	};
	
	//Tree mutation
	Parser.prototype._setDocumentType = function (token) {
	    this.treeAdapter.setDocumentType(this.document, token.name, token.publicId, token.systemId);
	};
	
	Parser.prototype._attachElementToTree = function (element) {
	    if (this._shouldFosterParentOnInsertion())
	        this._fosterParentElement(element);
	
	    else {
	        var parent = this.openElements.currentTmplContent || this.openElements.current;
	
	        this.treeAdapter.appendChild(parent, element);
	    }
	};
	
	Parser.prototype._appendElement = function (token, namespaceURI) {
	    var element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
	
	    this._attachElementToTree(element);
	};
	
	Parser.prototype._insertElement = function (token, namespaceURI) {
	    var element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
	
	    this._attachElementToTree(element);
	    this.openElements.push(element);
	};
	
	Parser.prototype._insertFakeElement = function (tagName) {
	    var element = this.treeAdapter.createElement(tagName, NS.HTML, []);
	
	    this._attachElementToTree(element);
	    this.openElements.push(element);
	};
	
	Parser.prototype._insertTemplate = function (token) {
	    var tmpl = this.treeAdapter.createElement(token.tagName, NS.HTML, token.attrs),
	        content = this.treeAdapter.createDocumentFragment();
	
	    this.treeAdapter.setTemplateContent(tmpl, content);
	    this._attachElementToTree(tmpl);
	    this.openElements.push(tmpl);
	};
	
	Parser.prototype._insertFakeRootElement = function () {
	    var element = this.treeAdapter.createElement($.HTML, NS.HTML, []);
	
	    this.treeAdapter.appendChild(this.openElements.current, element);
	    this.openElements.push(element);
	};
	
	Parser.prototype._appendCommentNode = function (token, parent) {
	    var commentNode = this.treeAdapter.createCommentNode(token.data);
	
	    this.treeAdapter.appendChild(parent, commentNode);
	};
	
	Parser.prototype._insertCharacters = function (token) {
	    if (this._shouldFosterParentOnInsertion())
	        this._fosterParentText(token.chars);
	
	    else {
	        var parent = this.openElements.currentTmplContent || this.openElements.current;
	
	        this.treeAdapter.insertText(parent, token.chars);
	    }
	};
	
	Parser.prototype._adoptNodes = function (donor, recipient) {
	    while (true) {
	        var child = this.treeAdapter.getFirstChild(donor);
	
	        if (!child)
	            break;
	
	        this.treeAdapter.detachNode(child);
	        this.treeAdapter.appendChild(recipient, child);
	    }
	};
	
	//Token processing
	Parser.prototype._shouldProcessTokenInForeignContent = function (token) {
	    var current = this._getAdjustedCurrentElement();
	
	    if (!current || current === this.document)
	        return false;
	
	    var ns = this.treeAdapter.getNamespaceURI(current);
	
	    if (ns === NS.HTML)
	        return false;
	
	    if (this.treeAdapter.getTagName(current) === $.ANNOTATION_XML && ns === NS.MATHML &&
	        token.type === Tokenizer.START_TAG_TOKEN && token.tagName === $.SVG)
	        return false;
	
	    var isCharacterToken = token.type === Tokenizer.CHARACTER_TOKEN ||
	                           token.type === Tokenizer.NULL_CHARACTER_TOKEN ||
	                           token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN,
	        isMathMLTextStartTag = token.type === Tokenizer.START_TAG_TOKEN &&
	                               token.tagName !== $.MGLYPH &&
	                               token.tagName !== $.MALIGNMARK;
	
	    if ((isMathMLTextStartTag || isCharacterToken) && this._isIntegrationPoint(current, NS.MATHML))
	        return false;
	
	    if ((token.type === Tokenizer.START_TAG_TOKEN || isCharacterToken) && this._isIntegrationPoint(current, NS.HTML))
	        return false;
	
	    return token.type !== Tokenizer.EOF_TOKEN;
	};
	
	Parser.prototype._processToken = function (token) {
	    _[this.insertionMode][token.type](this, token);
	};
	
	Parser.prototype._processTokenInBodyMode = function (token) {
	    _[IN_BODY_MODE][token.type](this, token);
	};
	
	Parser.prototype._processTokenInForeignContent = function (token) {
	    if (token.type === Tokenizer.CHARACTER_TOKEN)
	        characterInForeignContent(this, token);
	
	    else if (token.type === Tokenizer.NULL_CHARACTER_TOKEN)
	        nullCharacterInForeignContent(this, token);
	
	    else if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN)
	        insertCharacters(this, token);
	
	    else if (token.type === Tokenizer.COMMENT_TOKEN)
	        appendComment(this, token);
	
	    else if (token.type === Tokenizer.START_TAG_TOKEN)
	        startTagInForeignContent(this, token);
	
	    else if (token.type === Tokenizer.END_TAG_TOKEN)
	        endTagInForeignContent(this, token);
	};
	
	Parser.prototype._processInputToken = function (token) {
	    if (this._shouldProcessTokenInForeignContent(token))
	        this._processTokenInForeignContent(token);
	
	    else
	        this._processToken(token);
	};
	
	//Integration points
	Parser.prototype._isIntegrationPoint = function (element, foreignNS) {
	    var tn = this.treeAdapter.getTagName(element),
	        ns = this.treeAdapter.getNamespaceURI(element),
	        attrs = this.treeAdapter.getAttrList(element);
	
	    return foreignContent.isIntegrationPoint(tn, ns, attrs, foreignNS);
	};
	
	//Active formatting elements reconstruction
	Parser.prototype._reconstructActiveFormattingElements = function () {
	    var listLength = this.activeFormattingElements.length;
	
	    if (listLength) {
	        var unopenIdx = listLength,
	            entry = null;
	
	        do {
	            unopenIdx--;
	            entry = this.activeFormattingElements.entries[unopenIdx];
	
	            if (entry.type === FormattingElementList.MARKER_ENTRY || this.openElements.contains(entry.element)) {
	                unopenIdx++;
	                break;
	            }
	        } while (unopenIdx > 0);
	
	        for (var i = unopenIdx; i < listLength; i++) {
	            entry = this.activeFormattingElements.entries[i];
	            this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
	            entry.element = this.openElements.current;
	        }
	    }
	};
	
	//Close elements
	Parser.prototype._closeTableCell = function () {
	    this.openElements.generateImpliedEndTags();
	    this.openElements.popUntilTableCellPopped();
	    this.activeFormattingElements.clearToLastMarker();
	    this.insertionMode = IN_ROW_MODE;
	};
	
	Parser.prototype._closePElement = function () {
	    this.openElements.generateImpliedEndTagsWithExclusion($.P);
	    this.openElements.popUntilTagNamePopped($.P);
	};
	
	//Insertion modes
	Parser.prototype._resetInsertionMode = function () {
	    for (var i = this.openElements.stackTop, last = false; i >= 0; i--) {
	        var element = this.openElements.items[i];
	
	        if (i === 0) {
	            last = true;
	
	            if (this.fragmentContext)
	                element = this.fragmentContext;
	        }
	
	        var tn = this.treeAdapter.getTagName(element),
	            newInsertionMode = INSERTION_MODE_RESET_MAP[tn];
	
	        if (newInsertionMode) {
	            this.insertionMode = newInsertionMode;
	            break;
	        }
	
	        else if (!last && (tn === $.TD || tn === $.TH)) {
	            this.insertionMode = IN_CELL_MODE;
	            break;
	        }
	
	        else if (!last && tn === $.HEAD) {
	            this.insertionMode = IN_HEAD_MODE;
	            break;
	        }
	
	        else if (tn === $.SELECT) {
	            this._resetInsertionModeForSelect(i);
	            break;
	        }
	
	        else if (tn === $.TEMPLATE) {
	            this.insertionMode = this.currentTmplInsertionMode;
	            break;
	        }
	
	        else if (tn === $.HTML) {
	            this.insertionMode = this.headElement ? AFTER_HEAD_MODE : BEFORE_HEAD_MODE;
	            break;
	        }
	
	        else if (last) {
	            this.insertionMode = IN_BODY_MODE;
	            break;
	        }
	    }
	};
	
	Parser.prototype._resetInsertionModeForSelect = function (selectIdx) {
	    if (selectIdx > 0) {
	        for (var i = selectIdx - 1; i > 0; i--) {
	            var ancestor = this.openElements.items[i],
	                tn = this.treeAdapter.getTagName(ancestor);
	
	            if (tn === $.TEMPLATE)
	                break;
	
	            else if (tn === $.TABLE) {
	                this.insertionMode = IN_SELECT_IN_TABLE_MODE;
	                return;
	            }
	        }
	    }
	
	    this.insertionMode = IN_SELECT_MODE;
	};
	
	Parser.prototype._pushTmplInsertionMode = function (mode) {
	    this.tmplInsertionModeStack.push(mode);
	    this.tmplInsertionModeStackTop++;
	    this.currentTmplInsertionMode = mode;
	};
	
	Parser.prototype._popTmplInsertionMode = function () {
	    this.tmplInsertionModeStack.pop();
	    this.tmplInsertionModeStackTop--;
	    this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
	};
	
	//Foster parenting
	Parser.prototype._isElementCausesFosterParenting = function (element) {
	    var tn = this.treeAdapter.getTagName(element);
	
	    return tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR;
	};
	
	Parser.prototype._shouldFosterParentOnInsertion = function () {
	    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
	};
	
	Parser.prototype._findFosterParentingLocation = function () {
	    var location = {
	        parent: null,
	        beforeElement: null
	    };
	
	    for (var i = this.openElements.stackTop; i >= 0; i--) {
	        var openElement = this.openElements.items[i],
	            tn = this.treeAdapter.getTagName(openElement),
	            ns = this.treeAdapter.getNamespaceURI(openElement);
	
	        if (tn === $.TEMPLATE && ns === NS.HTML) {
	            location.parent = this.treeAdapter.getTemplateContent(openElement);
	            break;
	        }
	
	        else if (tn === $.TABLE) {
	            location.parent = this.treeAdapter.getParentNode(openElement);
	
	            if (location.parent)
	                location.beforeElement = openElement;
	            else
	                location.parent = this.openElements.items[i - 1];
	
	            break;
	        }
	    }
	
	    if (!location.parent)
	        location.parent = this.openElements.items[0];
	
	    return location;
	};
	
	Parser.prototype._fosterParentElement = function (element) {
	    var location = this._findFosterParentingLocation();
	
	    if (location.beforeElement)
	        this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
	    else
	        this.treeAdapter.appendChild(location.parent, element);
	};
	
	Parser.prototype._fosterParentText = function (chars) {
	    var location = this._findFosterParentingLocation();
	
	    if (location.beforeElement)
	        this.treeAdapter.insertTextBefore(location.parent, chars, location.beforeElement);
	    else
	        this.treeAdapter.insertText(location.parent, chars);
	};
	
	//Special elements
	Parser.prototype._isSpecialElement = function (element) {
	    var tn = this.treeAdapter.getTagName(element),
	        ns = this.treeAdapter.getNamespaceURI(element);
	
	    return HTML.SPECIAL_ELEMENTS[ns][tn];
	};
	
	//Adoption agency algorithm
	//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html#adoptionAgency)
	//------------------------------------------------------------------
	
	//Steps 5-8 of the algorithm
	function aaObtainFormattingElementEntry(p, token) {
	    var formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token.tagName);
	
	    if (formattingElementEntry) {
	        if (!p.openElements.contains(formattingElementEntry.element)) {
	            p.activeFormattingElements.removeEntry(formattingElementEntry);
	            formattingElementEntry = null;
	        }
	
	        else if (!p.openElements.hasInScope(token.tagName))
	            formattingElementEntry = null;
	    }
	
	    else
	        genericEndTagInBody(p, token);
	
	    return formattingElementEntry;
	}
	
	//Steps 9 and 10 of the algorithm
	function aaObtainFurthestBlock(p, formattingElementEntry) {
	    var furthestBlock = null;
	
	    for (var i = p.openElements.stackTop; i >= 0; i--) {
	        var element = p.openElements.items[i];
	
	        if (element === formattingElementEntry.element)
	            break;
	
	        if (p._isSpecialElement(element))
	            furthestBlock = element;
	    }
	
	    if (!furthestBlock) {
	        p.openElements.popUntilElementPopped(formattingElementEntry.element);
	        p.activeFormattingElements.removeEntry(formattingElementEntry);
	    }
	
	    return furthestBlock;
	}
	
	//Step 13 of the algorithm
	function aaInnerLoop(p, furthestBlock, formattingElement) {
	    var lastElement = furthestBlock,
	        nextElement = p.openElements.getCommonAncestor(furthestBlock);
	
	    for (var i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement) {
	        //NOTE: store next element for the next loop iteration (it may be deleted from the stack by step 9.5)
	        nextElement = p.openElements.getCommonAncestor(element);
	
	        var elementEntry = p.activeFormattingElements.getElementEntry(element),
	            counterOverflow = elementEntry && i >= AA_INNER_LOOP_ITER,
	            shouldRemoveFromOpenElements = !elementEntry || counterOverflow;
	
	        if (shouldRemoveFromOpenElements) {
	            if (counterOverflow)
	                p.activeFormattingElements.removeEntry(elementEntry);
	
	            p.openElements.remove(element);
	        }
	
	        else {
	            element = aaRecreateElementFromEntry(p, elementEntry);
	
	            if (lastElement === furthestBlock)
	                p.activeFormattingElements.bookmark = elementEntry;
	
	            p.treeAdapter.detachNode(lastElement);
	            p.treeAdapter.appendChild(element, lastElement);
	            lastElement = element;
	        }
	    }
	
	    return lastElement;
	}
	
	//Step 13.7 of the algorithm
	function aaRecreateElementFromEntry(p, elementEntry) {
	    var ns = p.treeAdapter.getNamespaceURI(elementEntry.element),
	        newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);
	
	    p.openElements.replace(elementEntry.element, newElement);
	    elementEntry.element = newElement;
	
	    return newElement;
	}
	
	//Step 14 of the algorithm
	function aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement) {
	    if (p._isElementCausesFosterParenting(commonAncestor))
	        p._fosterParentElement(lastElement);
	
	    else {
	        var tn = p.treeAdapter.getTagName(commonAncestor),
	            ns = p.treeAdapter.getNamespaceURI(commonAncestor);
	
	        if (tn === $.TEMPLATE && ns === NS.HTML)
	            commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);
	
	        p.treeAdapter.appendChild(commonAncestor, lastElement);
	    }
	}
	
	//Steps 15-19 of the algorithm
	function aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry) {
	    var ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element),
	        token = formattingElementEntry.token,
	        newElement = p.treeAdapter.createElement(token.tagName, ns, token.attrs);
	
	    p._adoptNodes(furthestBlock, newElement);
	    p.treeAdapter.appendChild(furthestBlock, newElement);
	
	    p.activeFormattingElements.insertElementAfterBookmark(newElement, formattingElementEntry.token);
	    p.activeFormattingElements.removeEntry(formattingElementEntry);
	
	    p.openElements.remove(formattingElementEntry.element);
	    p.openElements.insertAfter(furthestBlock, newElement);
	}
	
	//Algorithm entry point
	function callAdoptionAgency(p, token) {
	    var formattingElementEntry;
	
	    for (var i = 0; i < AA_OUTER_LOOP_ITER; i++) {
	        formattingElementEntry = aaObtainFormattingElementEntry(p, token, formattingElementEntry);
	
	        if (!formattingElementEntry)
	            break;
	
	        var furthestBlock = aaObtainFurthestBlock(p, formattingElementEntry);
	
	        if (!furthestBlock)
	            break;
	
	        p.activeFormattingElements.bookmark = formattingElementEntry;
	
	        var lastElement = aaInnerLoop(p, furthestBlock, formattingElementEntry.element),
	            commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);
	
	        p.treeAdapter.detachNode(lastElement);
	        aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement);
	        aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry);
	    }
	}
	
	
	//Generic token handlers
	//------------------------------------------------------------------
	function ignoreToken() {
	    //NOTE: do nothing =)
	}
	
	function appendComment(p, token) {
	    p._appendCommentNode(token, p.openElements.currentTmplContent || p.openElements.current);
	}
	
	function appendCommentToRootHtmlElement(p, token) {
	    p._appendCommentNode(token, p.openElements.items[0]);
	}
	
	function appendCommentToDocument(p, token) {
	    p._appendCommentNode(token, p.document);
	}
	
	function insertCharacters(p, token) {
	    p._insertCharacters(token);
	}
	
	function stopParsing(p) {
	    p.stopped = true;
	}
	
	//12.2.5.4.1 The "initial" insertion mode
	//------------------------------------------------------------------
	function doctypeInInitialMode(p, token) {
	    p._setDocumentType(token);
	
	    var mode = token.forceQuirks ?
	        HTML.DOCUMENT_MODE.QUIRKS :
	        doctype.getDocumentMode(token.name, token.publicId, token.systemId);
	
	    p.treeAdapter.setDocumentMode(p.document, mode);
	
	    p.insertionMode = BEFORE_HTML_MODE;
	}
	
	function tokenInInitialMode(p, token) {
	    p.treeAdapter.setDocumentMode(p.document, HTML.DOCUMENT_MODE.QUIRKS);
	    p.insertionMode = BEFORE_HTML_MODE;
	    p._processToken(token);
	}
	
	
	//12.2.5.4.2 The "before html" insertion mode
	//------------------------------------------------------------------
	function startTagBeforeHtml(p, token) {
	    if (token.tagName === $.HTML) {
	        p._insertElement(token, NS.HTML);
	        p.insertionMode = BEFORE_HEAD_MODE;
	    }
	
	    else
	        tokenBeforeHtml(p, token);
	}
	
	function endTagBeforeHtml(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.HTML || tn === $.HEAD || tn === $.BODY || tn === $.BR)
	        tokenBeforeHtml(p, token);
	}
	
	function tokenBeforeHtml(p, token) {
	    p._insertFakeRootElement();
	    p.insertionMode = BEFORE_HEAD_MODE;
	    p._processToken(token);
	}
	
	
	//12.2.5.4.3 The "before head" insertion mode
	//------------------------------------------------------------------
	function startTagBeforeHead(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.HTML)
	        startTagInBody(p, token);
	
	    else if (tn === $.HEAD) {
	        p._insertElement(token, NS.HTML);
	        p.headElement = p.openElements.current;
	        p.insertionMode = IN_HEAD_MODE;
	    }
	
	    else
	        tokenBeforeHead(p, token);
	}
	
	function endTagBeforeHead(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.HEAD || tn === $.BODY || tn === $.HTML || tn === $.BR)
	        tokenBeforeHead(p, token);
	}
	
	function tokenBeforeHead(p, token) {
	    p._insertFakeElement($.HEAD);
	    p.headElement = p.openElements.current;
	    p.insertionMode = IN_HEAD_MODE;
	    p._processToken(token);
	}
	
	
	//12.2.5.4.4 The "in head" insertion mode
	//------------------------------------------------------------------
	function startTagInHead(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.HTML)
	        startTagInBody(p, token);
	
	    else if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META)
	        p._appendElement(token, NS.HTML);
	
	    else if (tn === $.TITLE)
	        p._switchToTextParsing(token, Tokenizer.MODE.RCDATA);
	
	    //NOTE: here we assume that we always act as an interactive user agent with enabled scripting, so we parse
	    //<noscript> as a rawtext.
	    else if (tn === $.NOSCRIPT || tn === $.NOFRAMES || tn === $.STYLE)
	        p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
	
	    else if (tn === $.SCRIPT)
	        p._switchToTextParsing(token, Tokenizer.MODE.SCRIPT_DATA);
	
	    else if (tn === $.TEMPLATE) {
	        p._insertTemplate(token, NS.HTML);
	        p.activeFormattingElements.insertMarker();
	        p.framesetOk = false;
	        p.insertionMode = IN_TEMPLATE_MODE;
	        p._pushTmplInsertionMode(IN_TEMPLATE_MODE);
	    }
	
	    else if (tn !== $.HEAD)
	        tokenInHead(p, token);
	}
	
	function endTagInHead(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.HEAD) {
	        p.openElements.pop();
	        p.insertionMode = AFTER_HEAD_MODE;
	    }
	
	    else if (tn === $.BODY || tn === $.BR || tn === $.HTML)
	        tokenInHead(p, token);
	
	    else if (tn === $.TEMPLATE && p.openElements.tmplCount > 0) {
	        p.openElements.generateImpliedEndTags();
	        p.openElements.popUntilTagNamePopped($.TEMPLATE);
	        p.activeFormattingElements.clearToLastMarker();
	        p._popTmplInsertionMode();
	        p._resetInsertionMode();
	    }
	}
	
	function tokenInHead(p, token) {
	    p.openElements.pop();
	    p.insertionMode = AFTER_HEAD_MODE;
	    p._processToken(token);
	}
	
	
	//12.2.5.4.6 The "after head" insertion mode
	//------------------------------------------------------------------
	function startTagAfterHead(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.HTML)
	        startTagInBody(p, token);
	
	    else if (tn === $.BODY) {
	        p._insertElement(token, NS.HTML);
	        p.framesetOk = false;
	        p.insertionMode = IN_BODY_MODE;
	    }
	
	    else if (tn === $.FRAMESET) {
	        p._insertElement(token, NS.HTML);
	        p.insertionMode = IN_FRAMESET_MODE;
	    }
	
	    else if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META ||
	             tn === $.NOFRAMES || tn === $.SCRIPT || tn === $.STYLE || tn === $.TEMPLATE || tn === $.TITLE) {
	        p.openElements.push(p.headElement);
	        startTagInHead(p, token);
	        p.openElements.remove(p.headElement);
	    }
	
	    else if (tn !== $.HEAD)
	        tokenAfterHead(p, token);
	}
	
	function endTagAfterHead(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.BODY || tn === $.HTML || tn === $.BR)
	        tokenAfterHead(p, token);
	
	    else if (tn === $.TEMPLATE)
	        endTagInHead(p, token);
	}
	
	function tokenAfterHead(p, token) {
	    p._insertFakeElement($.BODY);
	    p.insertionMode = IN_BODY_MODE;
	    p._processToken(token);
	}
	
	
	//12.2.5.4.7 The "in body" insertion mode
	//------------------------------------------------------------------
	function whitespaceCharacterInBody(p, token) {
	    p._reconstructActiveFormattingElements();
	    p._insertCharacters(token);
	}
	
	function characterInBody(p, token) {
	    p._reconstructActiveFormattingElements();
	    p._insertCharacters(token);
	    p.framesetOk = false;
	}
	
	function htmlStartTagInBody(p, token) {
	    if (p.openElements.tmplCount === 0)
	        p.treeAdapter.adoptAttributes(p.openElements.items[0], token.attrs);
	}
	
	function bodyStartTagInBody(p, token) {
	    var bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
	
	    if (bodyElement && p.openElements.tmplCount === 0) {
	        p.framesetOk = false;
	        p.treeAdapter.adoptAttributes(bodyElement, token.attrs);
	    }
	}
	
	function framesetStartTagInBody(p, token) {
	    var bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
	
	    if (p.framesetOk && bodyElement) {
	        p.treeAdapter.detachNode(bodyElement);
	        p.openElements.popAllUpToHtmlElement();
	        p._insertElement(token, NS.HTML);
	        p.insertionMode = IN_FRAMESET_MODE;
	    }
	}
	
	function addressStartTagInBody(p, token) {
	    if (p.openElements.hasInButtonScope($.P))
	        p._closePElement();
	
	    p._insertElement(token, NS.HTML);
	}
	
	function numberedHeaderStartTagInBody(p, token) {
	    if (p.openElements.hasInButtonScope($.P))
	        p._closePElement();
	
	    var tn = p.openElements.currentTagName;
	
	    if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6)
	        p.openElements.pop();
	
	    p._insertElement(token, NS.HTML);
	}
	
	function preStartTagInBody(p, token) {
	    if (p.openElements.hasInButtonScope($.P))
	        p._closePElement();
	
	    p._insertElement(token, NS.HTML);
	    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
	    //on to the next one. (Newlines at the start of pre blocks are ignored as an authoring convenience.)
	    p.skipNextNewLine = true;
	    p.framesetOk = false;
	}
	
	function formStartTagInBody(p, token) {
	    var inTemplate = p.openElements.tmplCount > 0;
	
	    if (!p.formElement || inTemplate) {
	        if (p.openElements.hasInButtonScope($.P))
	            p._closePElement();
	
	        p._insertElement(token, NS.HTML);
	
	        if (!inTemplate)
	            p.formElement = p.openElements.current;
	    }
	}
	
	function listItemStartTagInBody(p, token) {
	    p.framesetOk = false;
	
	    var tn = token.tagName;
	
	    for (var i = p.openElements.stackTop; i >= 0; i--) {
	        var element = p.openElements.items[i],
	            elementTn = p.treeAdapter.getTagName(element),
	            closeTn = null;
	
	        if (tn === $.LI && elementTn === $.LI)
	            closeTn = $.LI;
	
	        else if ((tn === $.DD || tn === $.DT) && (elementTn === $.DD || elementTn === $.DT))
	            closeTn = elementTn;
	
	        if (closeTn) {
	            p.openElements.generateImpliedEndTagsWithExclusion(closeTn);
	            p.openElements.popUntilTagNamePopped(closeTn);
	            break;
	        }
	
	        if (elementTn !== $.ADDRESS && elementTn !== $.DIV && elementTn !== $.P && p._isSpecialElement(element))
	            break;
	    }
	
	    if (p.openElements.hasInButtonScope($.P))
	        p._closePElement();
	
	    p._insertElement(token, NS.HTML);
	}
	
	function plaintextStartTagInBody(p, token) {
	    if (p.openElements.hasInButtonScope($.P))
	        p._closePElement();
	
	    p._insertElement(token, NS.HTML);
	    p.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
	}
	
	function buttonStartTagInBody(p, token) {
	    if (p.openElements.hasInScope($.BUTTON)) {
	        p.openElements.generateImpliedEndTags();
	        p.openElements.popUntilTagNamePopped($.BUTTON);
	    }
	
	    p._reconstructActiveFormattingElements();
	    p._insertElement(token, NS.HTML);
	    p.framesetOk = false;
	}
	
	function aStartTagInBody(p, token) {
	    var activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName($.A);
	
	    if (activeElementEntry) {
	        callAdoptionAgency(p, token);
	        p.openElements.remove(activeElementEntry.element);
	        p.activeFormattingElements.removeEntry(activeElementEntry);
	    }
	
	    p._reconstructActiveFormattingElements();
	    p._insertElement(token, NS.HTML);
	    p.activeFormattingElements.pushElement(p.openElements.current, token);
	}
	
	function bStartTagInBody(p, token) {
	    p._reconstructActiveFormattingElements();
	    p._insertElement(token, NS.HTML);
	    p.activeFormattingElements.pushElement(p.openElements.current, token);
	}
	
	function nobrStartTagInBody(p, token) {
	    p._reconstructActiveFormattingElements();
	
	    if (p.openElements.hasInScope($.NOBR)) {
	        callAdoptionAgency(p, token);
	        p._reconstructActiveFormattingElements();
	    }
	
	    p._insertElement(token, NS.HTML);
	    p.activeFormattingElements.pushElement(p.openElements.current, token);
	}
	
	function appletStartTagInBody(p, token) {
	    p._reconstructActiveFormattingElements();
	    p._insertElement(token, NS.HTML);
	    p.activeFormattingElements.insertMarker();
	    p.framesetOk = false;
	}
	
	function tableStartTagInBody(p, token) {
	    if (p.treeAdapter.getDocumentMode(p.document) !== HTML.DOCUMENT_MODE.QUIRKS && p.openElements.hasInButtonScope($.P))
	        p._closePElement();
	
	    p._insertElement(token, NS.HTML);
	    p.framesetOk = false;
	    p.insertionMode = IN_TABLE_MODE;
	}
	
	function areaStartTagInBody(p, token) {
	    p._reconstructActiveFormattingElements();
	    p._appendElement(token, NS.HTML);
	    p.framesetOk = false;
	}
	
	function inputStartTagInBody(p, token) {
	    p._reconstructActiveFormattingElements();
	    p._appendElement(token, NS.HTML);
	
	    var inputType = Tokenizer.getTokenAttr(token, ATTRS.TYPE);
	
	    if (!inputType || inputType.toLowerCase() !== HIDDEN_INPUT_TYPE)
	        p.framesetOk = false;
	
	}
	
	function paramStartTagInBody(p, token) {
	    p._appendElement(token, NS.HTML);
	}
	
	function hrStartTagInBody(p, token) {
	    if (p.openElements.hasInButtonScope($.P))
	        p._closePElement();
	
	    if (p.openElements.currentTagName === $.MENUITEM)
	        p.openElements.pop();
	
	    p._appendElement(token, NS.HTML);
	    p.framesetOk = false;
	}
	
	function imageStartTagInBody(p, token) {
	    token.tagName = $.IMG;
	    areaStartTagInBody(p, token);
	}
	
	function textareaStartTagInBody(p, token) {
	    p._insertElement(token, NS.HTML);
	    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
	    //on to the next one. (Newlines at the start of textarea elements are ignored as an authoring convenience.)
	    p.skipNextNewLine = true;
	    p.tokenizer.state = Tokenizer.MODE.RCDATA;
	    p.originalInsertionMode = p.insertionMode;
	    p.framesetOk = false;
	    p.insertionMode = TEXT_MODE;
	}
	
	function xmpStartTagInBody(p, token) {
	    if (p.openElements.hasInButtonScope($.P))
	        p._closePElement();
	
	    p._reconstructActiveFormattingElements();
	    p.framesetOk = false;
	    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
	}
	
	function iframeStartTagInBody(p, token) {
	    p.framesetOk = false;
	    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
	}
	
	//NOTE: here we assume that we always act as an user agent with enabled plugins, so we parse
	//<noembed> as a rawtext.
	function noembedStartTagInBody(p, token) {
	    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
	}
	
	function selectStartTagInBody(p, token) {
	    p._reconstructActiveFormattingElements();
	    p._insertElement(token, NS.HTML);
	    p.framesetOk = false;
	
	    if (p.insertionMode === IN_TABLE_MODE ||
	        p.insertionMode === IN_CAPTION_MODE ||
	        p.insertionMode === IN_TABLE_BODY_MODE ||
	        p.insertionMode === IN_ROW_MODE ||
	        p.insertionMode === IN_CELL_MODE)
	
	        p.insertionMode = IN_SELECT_IN_TABLE_MODE;
	
	    else
	        p.insertionMode = IN_SELECT_MODE;
	}
	
	function optgroupStartTagInBody(p, token) {
	    if (p.openElements.currentTagName === $.OPTION)
	        p.openElements.pop();
	
	    p._reconstructActiveFormattingElements();
	    p._insertElement(token, NS.HTML);
	}
	
	function rbStartTagInBody(p, token) {
	    if (p.openElements.hasInScope($.RUBY))
	        p.openElements.generateImpliedEndTags();
	
	    p._insertElement(token, NS.HTML);
	}
	
	function rtStartTagInBody(p, token) {
	    if (p.openElements.hasInScope($.RUBY))
	        p.openElements.generateImpliedEndTagsWithExclusion($.RTC);
	
	    p._insertElement(token, NS.HTML);
	}
	
	function menuitemStartTagInBody(p, token) {
	    if (p.openElements.currentTagName === $.MENUITEM)
	        p.openElements.pop();
	
	    // TODO needs clarification, see https://github.com/whatwg/html/pull/907/files#r73505877
	    p._reconstructActiveFormattingElements();
	
	    p._insertElement(token, NS.HTML);
	}
	
	function menuStartTagInBody(p, token) {
	    if (p.openElements.hasInButtonScope($.P))
	        p._closePElement();
	
	    if (p.openElements.currentTagName === $.MENUITEM)
	        p.openElements.pop();
	
	    p._insertElement(token, NS.HTML);
	}
	
	function mathStartTagInBody(p, token) {
	    p._reconstructActiveFormattingElements();
	
	    foreignContent.adjustTokenMathMLAttrs(token);
	    foreignContent.adjustTokenXMLAttrs(token);
	
	    if (token.selfClosing)
	        p._appendElement(token, NS.MATHML);
	    else
	        p._insertElement(token, NS.MATHML);
	}
	
	function svgStartTagInBody(p, token) {
	    p._reconstructActiveFormattingElements();
	
	    foreignContent.adjustTokenSVGAttrs(token);
	    foreignContent.adjustTokenXMLAttrs(token);
	
	    if (token.selfClosing)
	        p._appendElement(token, NS.SVG);
	    else
	        p._insertElement(token, NS.SVG);
	}
	
	function genericStartTagInBody(p, token) {
	    p._reconstructActiveFormattingElements();
	    p._insertElement(token, NS.HTML);
	}
	
	//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
	//It's faster than using dictionary.
	function startTagInBody(p, token) {
	    var tn = token.tagName;
	
	    switch (tn.length) {
	        case 1:
	            if (tn === $.I || tn === $.S || tn === $.B || tn === $.U)
	                bStartTagInBody(p, token);
	
	            else if (tn === $.P)
	                addressStartTagInBody(p, token);
	
	            else if (tn === $.A)
	                aStartTagInBody(p, token);
	
	            else
	                genericStartTagInBody(p, token);
	
	            break;
	
	        case 2:
	            if (tn === $.DL || tn === $.OL || tn === $.UL)
	                addressStartTagInBody(p, token);
	
	            else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6)
	                numberedHeaderStartTagInBody(p, token);
	
	            else if (tn === $.LI || tn === $.DD || tn === $.DT)
	                listItemStartTagInBody(p, token);
	
	            else if (tn === $.EM || tn === $.TT)
	                bStartTagInBody(p, token);
	
	            else if (tn === $.BR)
	                areaStartTagInBody(p, token);
	
	            else if (tn === $.HR)
	                hrStartTagInBody(p, token);
	
	            else if (tn === $.RB)
	                rbStartTagInBody(p, token);
	
	            else if (tn === $.RT || tn === $.RP)
	                rtStartTagInBody(p, token);
	
	            else if (tn !== $.TH && tn !== $.TD && tn !== $.TR)
	                genericStartTagInBody(p, token);
	
	            break;
	
	        case 3:
	            if (tn === $.DIV || tn === $.DIR || tn === $.NAV)
	                addressStartTagInBody(p, token);
	
	            else if (tn === $.PRE)
	                preStartTagInBody(p, token);
	
	            else if (tn === $.BIG)
	                bStartTagInBody(p, token);
	
	            else if (tn === $.IMG || tn === $.WBR)
	                areaStartTagInBody(p, token);
	
	            else if (tn === $.XMP)
	                xmpStartTagInBody(p, token);
	
	            else if (tn === $.SVG)
	                svgStartTagInBody(p, token);
	
	            else if (tn === $.RTC)
	                rbStartTagInBody(p, token);
	
	            else if (tn !== $.COL)
	                genericStartTagInBody(p, token);
	
	            break;
	
	        case 4:
	            if (tn === $.HTML)
	                htmlStartTagInBody(p, token);
	
	            else if (tn === $.BASE || tn === $.LINK || tn === $.META)
	                startTagInHead(p, token);
	
	            else if (tn === $.BODY)
	                bodyStartTagInBody(p, token);
	
	            else if (tn === $.MAIN)
	                addressStartTagInBody(p, token);
	
	            else if (tn === $.FORM)
	                formStartTagInBody(p, token);
	
	            else if (tn === $.CODE || tn === $.FONT)
	                bStartTagInBody(p, token);
	
	            else if (tn === $.NOBR)
	                nobrStartTagInBody(p, token);
	
	            else if (tn === $.AREA)
	                areaStartTagInBody(p, token);
	
	            else if (tn === $.MATH)
	                mathStartTagInBody(p, token);
	
	            else if (tn === $.MENU)
	                menuStartTagInBody(p, token);
	
	            else if (tn !== $.HEAD)
	                genericStartTagInBody(p, token);
	
	            break;
	
	        case 5:
	            if (tn === $.STYLE || tn === $.TITLE)
	                startTagInHead(p, token);
	
	            else if (tn === $.ASIDE)
	                addressStartTagInBody(p, token);
	
	            else if (tn === $.SMALL)
	                bStartTagInBody(p, token);
	
	            else if (tn === $.TABLE)
	                tableStartTagInBody(p, token);
	
	            else if (tn === $.EMBED)
	                areaStartTagInBody(p, token);
	
	            else if (tn === $.INPUT)
	                inputStartTagInBody(p, token);
	
	            else if (tn === $.PARAM || tn === $.TRACK)
	                paramStartTagInBody(p, token);
	
	            else if (tn === $.IMAGE)
	                imageStartTagInBody(p, token);
	
	            else if (tn !== $.FRAME && tn !== $.TBODY && tn !== $.TFOOT && tn !== $.THEAD)
	                genericStartTagInBody(p, token);
	
	            break;
	
	        case 6:
	            if (tn === $.SCRIPT)
	                startTagInHead(p, token);
	
	            else if (tn === $.CENTER || tn === $.FIGURE || tn === $.FOOTER || tn === $.HEADER || tn === $.HGROUP)
	                addressStartTagInBody(p, token);
	
	            else if (tn === $.BUTTON)
	                buttonStartTagInBody(p, token);
	
	            else if (tn === $.STRIKE || tn === $.STRONG)
	                bStartTagInBody(p, token);
	
	            else if (tn === $.APPLET || tn === $.OBJECT)
	                appletStartTagInBody(p, token);
	
	            else if (tn === $.KEYGEN)
	                areaStartTagInBody(p, token);
	
	            else if (tn === $.SOURCE)
	                paramStartTagInBody(p, token);
	
	            else if (tn === $.IFRAME)
	                iframeStartTagInBody(p, token);
	
	            else if (tn === $.SELECT)
	                selectStartTagInBody(p, token);
	
	            else if (tn === $.OPTION)
	                optgroupStartTagInBody(p, token);
	
	            else
	                genericStartTagInBody(p, token);
	
	            break;
	
	        case 7:
	            if (tn === $.BGSOUND)
	                startTagInHead(p, token);
	
	            else if (tn === $.DETAILS || tn === $.ADDRESS || tn === $.ARTICLE || tn === $.SECTION || tn === $.SUMMARY)
	                addressStartTagInBody(p, token);
	
	            else if (tn === $.LISTING)
	                preStartTagInBody(p, token);
	
	            else if (tn === $.MARQUEE)
	                appletStartTagInBody(p, token);
	
	            else if (tn === $.NOEMBED)
	                noembedStartTagInBody(p, token);
	
	            else if (tn !== $.CAPTION)
	                genericStartTagInBody(p, token);
	
	            break;
	
	        case 8:
	            if (tn === $.BASEFONT)
	                startTagInHead(p, token);
	
	            else if (tn === $.MENUITEM)
	                menuitemStartTagInBody(p, token);
	
	            else if (tn === $.FRAMESET)
	                framesetStartTagInBody(p, token);
	
	            else if (tn === $.FIELDSET)
	                addressStartTagInBody(p, token);
	
	            else if (tn === $.TEXTAREA)
	                textareaStartTagInBody(p, token);
	
	            else if (tn === $.TEMPLATE)
	                startTagInHead(p, token);
	
	            else if (tn === $.NOSCRIPT)
	                noembedStartTagInBody(p, token);
	
	            else if (tn === $.OPTGROUP)
	                optgroupStartTagInBody(p, token);
	
	            else if (tn !== $.COLGROUP)
	                genericStartTagInBody(p, token);
	
	            break;
	
	        case 9:
	            if (tn === $.PLAINTEXT)
	                plaintextStartTagInBody(p, token);
	
	            else
	                genericStartTagInBody(p, token);
	
	            break;
	
	        case 10:
	            if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION)
	                addressStartTagInBody(p, token);
	
	            else
	                genericStartTagInBody(p, token);
	
	            break;
	
	        default:
	            genericStartTagInBody(p, token);
	    }
	}
	
	function bodyEndTagInBody(p) {
	    if (p.openElements.hasInScope($.BODY))
	        p.insertionMode = AFTER_BODY_MODE;
	}
	
	function htmlEndTagInBody(p, token) {
	    if (p.openElements.hasInScope($.BODY)) {
	        p.insertionMode = AFTER_BODY_MODE;
	        p._processToken(token);
	    }
	}
	
	function addressEndTagInBody(p, token) {
	    var tn = token.tagName;
	
	    if (p.openElements.hasInScope(tn)) {
	        p.openElements.generateImpliedEndTags();
	        p.openElements.popUntilTagNamePopped(tn);
	    }
	}
	
	function formEndTagInBody(p) {
	    var inTemplate = p.openElements.tmplCount > 0,
	        formElement = p.formElement;
	
	    if (!inTemplate)
	        p.formElement = null;
	
	    if ((formElement || inTemplate) && p.openElements.hasInScope($.FORM)) {
	        p.openElements.generateImpliedEndTags();
	
	        if (inTemplate)
	            p.openElements.popUntilTagNamePopped($.FORM);
	
	        else
	            p.openElements.remove(formElement);
	    }
	}
	
	function pEndTagInBody(p) {
	    if (!p.openElements.hasInButtonScope($.P))
	        p._insertFakeElement($.P);
	
	    p._closePElement();
	}
	
	function liEndTagInBody(p) {
	    if (p.openElements.hasInListItemScope($.LI)) {
	        p.openElements.generateImpliedEndTagsWithExclusion($.LI);
	        p.openElements.popUntilTagNamePopped($.LI);
	    }
	}
	
	function ddEndTagInBody(p, token) {
	    var tn = token.tagName;
	
	    if (p.openElements.hasInScope(tn)) {
	        p.openElements.generateImpliedEndTagsWithExclusion(tn);
	        p.openElements.popUntilTagNamePopped(tn);
	    }
	}
	
	function numberedHeaderEndTagInBody(p) {
	    if (p.openElements.hasNumberedHeaderInScope()) {
	        p.openElements.generateImpliedEndTags();
	        p.openElements.popUntilNumberedHeaderPopped();
	    }
	}
	
	function appletEndTagInBody(p, token) {
	    var tn = token.tagName;
	
	    if (p.openElements.hasInScope(tn)) {
	        p.openElements.generateImpliedEndTags();
	        p.openElements.popUntilTagNamePopped(tn);
	        p.activeFormattingElements.clearToLastMarker();
	    }
	}
	
	function brEndTagInBody(p) {
	    p._reconstructActiveFormattingElements();
	    p._insertFakeElement($.BR);
	    p.openElements.pop();
	    p.framesetOk = false;
	}
	
	function genericEndTagInBody(p, token) {
	    var tn = token.tagName;
	
	    for (var i = p.openElements.stackTop; i > 0; i--) {
	        var element = p.openElements.items[i];
	
	        if (p.treeAdapter.getTagName(element) === tn) {
	            p.openElements.generateImpliedEndTagsWithExclusion(tn);
	            p.openElements.popUntilElementPopped(element);
	            break;
	        }
	
	        if (p._isSpecialElement(element))
	            break;
	    }
	}
	
	//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
	//It's faster than using dictionary.
	function endTagInBody(p, token) {
	    var tn = token.tagName;
	
	    switch (tn.length) {
	        case 1:
	            if (tn === $.A || tn === $.B || tn === $.I || tn === $.S || tn === $.U)
	                callAdoptionAgency(p, token);
	
	            else if (tn === $.P)
	                pEndTagInBody(p, token);
	
	            else
	                genericEndTagInBody(p, token);
	
	            break;
	
	        case 2:
	            if (tn === $.DL || tn === $.UL || tn === $.OL)
	                addressEndTagInBody(p, token);
	
	            else if (tn === $.LI)
	                liEndTagInBody(p, token);
	
	            else if (tn === $.DD || tn === $.DT)
	                ddEndTagInBody(p, token);
	
	            else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6)
	                numberedHeaderEndTagInBody(p, token);
	
	            else if (tn === $.BR)
	                brEndTagInBody(p, token);
	
	            else if (tn === $.EM || tn === $.TT)
	                callAdoptionAgency(p, token);
	
	            else
	                genericEndTagInBody(p, token);
	
	            break;
	
	        case 3:
	            if (tn === $.BIG)
	                callAdoptionAgency(p, token);
	
	            else if (tn === $.DIR || tn === $.DIV || tn === $.NAV)
	                addressEndTagInBody(p, token);
	
	            else
	                genericEndTagInBody(p, token);
	
	            break;
	
	        case 4:
	            if (tn === $.BODY)
	                bodyEndTagInBody(p, token);
	
	            else if (tn === $.HTML)
	                htmlEndTagInBody(p, token);
	
	            else if (tn === $.FORM)
	                formEndTagInBody(p, token);
	
	            else if (tn === $.CODE || tn === $.FONT || tn === $.NOBR)
	                callAdoptionAgency(p, token);
	
	            else if (tn === $.MAIN || tn === $.MENU)
	                addressEndTagInBody(p, token);
	
	            else
	                genericEndTagInBody(p, token);
	
	            break;
	
	        case 5:
	            if (tn === $.ASIDE)
	                addressEndTagInBody(p, token);
	
	            else if (tn === $.SMALL)
	                callAdoptionAgency(p, token);
	
	            else
	                genericEndTagInBody(p, token);
	
	            break;
	
	        case 6:
	            if (tn === $.CENTER || tn === $.FIGURE || tn === $.FOOTER || tn === $.HEADER || tn === $.HGROUP)
	                addressEndTagInBody(p, token);
	
	            else if (tn === $.APPLET || tn === $.OBJECT)
	                appletEndTagInBody(p, token);
	
	            else if (tn === $.STRIKE || tn === $.STRONG)
	                callAdoptionAgency(p, token);
	
	            else
	                genericEndTagInBody(p, token);
	
	            break;
	
	        case 7:
	            if (tn === $.ADDRESS || tn === $.ARTICLE || tn === $.DETAILS || tn === $.SECTION || tn === $.SUMMARY)
	                addressEndTagInBody(p, token);
	
	            else if (tn === $.MARQUEE)
	                appletEndTagInBody(p, token);
	
	            else
	                genericEndTagInBody(p, token);
	
	            break;
	
	        case 8:
	            if (tn === $.FIELDSET)
	                addressEndTagInBody(p, token);
	
	            else if (tn === $.TEMPLATE)
	                endTagInHead(p, token);
	
	            else
	                genericEndTagInBody(p, token);
	
	            break;
	
	        case 10:
	            if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION)
	                addressEndTagInBody(p, token);
	
	            else
	                genericEndTagInBody(p, token);
	
	            break;
	
	        default :
	            genericEndTagInBody(p, token);
	    }
	}
	
	function eofInBody(p, token) {
	    if (p.tmplInsertionModeStackTop > -1)
	        eofInTemplate(p, token);
	
	    else
	        p.stopped = true;
	}
	
	//12.2.5.4.8 The "text" insertion mode
	//------------------------------------------------------------------
	function endTagInText(p, token) {
	    if (token.tagName === $.SCRIPT)
	        p.pendingScript = p.openElements.current;
	
	    p.openElements.pop();
	    p.insertionMode = p.originalInsertionMode;
	}
	
	
	function eofInText(p, token) {
	    p.openElements.pop();
	    p.insertionMode = p.originalInsertionMode;
	    p._processToken(token);
	}
	
	
	//12.2.5.4.9 The "in table" insertion mode
	//------------------------------------------------------------------
	function characterInTable(p, token) {
	    var curTn = p.openElements.currentTagName;
	
	    if (curTn === $.TABLE || curTn === $.TBODY || curTn === $.TFOOT || curTn === $.THEAD || curTn === $.TR) {
	        p.pendingCharacterTokens = [];
	        p.hasNonWhitespacePendingCharacterToken = false;
	        p.originalInsertionMode = p.insertionMode;
	        p.insertionMode = IN_TABLE_TEXT_MODE;
	        p._processToken(token);
	    }
	
	    else
	        tokenInTable(p, token);
	}
	
	function captionStartTagInTable(p, token) {
	    p.openElements.clearBackToTableContext();
	    p.activeFormattingElements.insertMarker();
	    p._insertElement(token, NS.HTML);
	    p.insertionMode = IN_CAPTION_MODE;
	}
	
	function colgroupStartTagInTable(p, token) {
	    p.openElements.clearBackToTableContext();
	    p._insertElement(token, NS.HTML);
	    p.insertionMode = IN_COLUMN_GROUP_MODE;
	}
	
	function colStartTagInTable(p, token) {
	    p.openElements.clearBackToTableContext();
	    p._insertFakeElement($.COLGROUP);
	    p.insertionMode = IN_COLUMN_GROUP_MODE;
	    p._processToken(token);
	}
	
	function tbodyStartTagInTable(p, token) {
	    p.openElements.clearBackToTableContext();
	    p._insertElement(token, NS.HTML);
	    p.insertionMode = IN_TABLE_BODY_MODE;
	}
	
	function tdStartTagInTable(p, token) {
	    p.openElements.clearBackToTableContext();
	    p._insertFakeElement($.TBODY);
	    p.insertionMode = IN_TABLE_BODY_MODE;
	    p._processToken(token);
	}
	
	function tableStartTagInTable(p, token) {
	    if (p.openElements.hasInTableScope($.TABLE)) {
	        p.openElements.popUntilTagNamePopped($.TABLE);
	        p._resetInsertionMode();
	        p._processToken(token);
	    }
	}
	
	function inputStartTagInTable(p, token) {
	    var inputType = Tokenizer.getTokenAttr(token, ATTRS.TYPE);
	
	    if (inputType && inputType.toLowerCase() === HIDDEN_INPUT_TYPE)
	        p._appendElement(token, NS.HTML);
	
	    else
	        tokenInTable(p, token);
	}
	
	function formStartTagInTable(p, token) {
	    if (!p.formElement && p.openElements.tmplCount === 0) {
	        p._insertElement(token, NS.HTML);
	        p.formElement = p.openElements.current;
	        p.openElements.pop();
	    }
	}
	
	function startTagInTable(p, token) {
	    var tn = token.tagName;
	
	    switch (tn.length) {
	        case 2:
	            if (tn === $.TD || tn === $.TH || tn === $.TR)
	                tdStartTagInTable(p, token);
	
	            else
	                tokenInTable(p, token);
	
	            break;
	
	        case 3:
	            if (tn === $.COL)
	                colStartTagInTable(p, token);
	
	            else
	                tokenInTable(p, token);
	
	            break;
	
	        case 4:
	            if (tn === $.FORM)
	                formStartTagInTable(p, token);
	
	            else
	                tokenInTable(p, token);
	
	            break;
	
	        case 5:
	            if (tn === $.TABLE)
	                tableStartTagInTable(p, token);
	
	            else if (tn === $.STYLE)
	                startTagInHead(p, token);
	
	            else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD)
	                tbodyStartTagInTable(p, token);
	
	            else if (tn === $.INPUT)
	                inputStartTagInTable(p, token);
	
	            else
	                tokenInTable(p, token);
	
	            break;
	
	        case 6:
	            if (tn === $.SCRIPT)
	                startTagInHead(p, token);
	
	            else
	                tokenInTable(p, token);
	
	            break;
	
	        case 7:
	            if (tn === $.CAPTION)
	                captionStartTagInTable(p, token);
	
	            else
	                tokenInTable(p, token);
	
	            break;
	
	        case 8:
	            if (tn === $.COLGROUP)
	                colgroupStartTagInTable(p, token);
	
	            else if (tn === $.TEMPLATE)
	                startTagInHead(p, token);
	
	            else
	                tokenInTable(p, token);
	
	            break;
	
	        default:
	            tokenInTable(p, token);
	    }
	
	}
	
	function endTagInTable(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.TABLE) {
	        if (p.openElements.hasInTableScope($.TABLE)) {
	            p.openElements.popUntilTagNamePopped($.TABLE);
	            p._resetInsertionMode();
	        }
	    }
	
	    else if (tn === $.TEMPLATE)
	        endTagInHead(p, token);
	
	    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML &&
	             tn !== $.TBODY && tn !== $.TD && tn !== $.TFOOT && tn !== $.TH && tn !== $.THEAD && tn !== $.TR)
	        tokenInTable(p, token);
	}
	
	function tokenInTable(p, token) {
	    var savedFosterParentingState = p.fosterParentingEnabled;
	
	    p.fosterParentingEnabled = true;
	    p._processTokenInBodyMode(token);
	    p.fosterParentingEnabled = savedFosterParentingState;
	}
	
	
	//12.2.5.4.10 The "in table text" insertion mode
	//------------------------------------------------------------------
	function whitespaceCharacterInTableText(p, token) {
	    p.pendingCharacterTokens.push(token);
	}
	
	function characterInTableText(p, token) {
	    p.pendingCharacterTokens.push(token);
	    p.hasNonWhitespacePendingCharacterToken = true;
	}
	
	function tokenInTableText(p, token) {
	    var i = 0;
	
	    if (p.hasNonWhitespacePendingCharacterToken) {
	        for (; i < p.pendingCharacterTokens.length; i++)
	            tokenInTable(p, p.pendingCharacterTokens[i]);
	    }
	
	    else {
	        for (; i < p.pendingCharacterTokens.length; i++)
	            p._insertCharacters(p.pendingCharacterTokens[i]);
	    }
	
	    p.insertionMode = p.originalInsertionMode;
	    p._processToken(token);
	}
	
	
	//12.2.5.4.11 The "in caption" insertion mode
	//------------------------------------------------------------------
	function startTagInCaption(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY ||
	        tn === $.TD || tn === $.TFOOT || tn === $.TH || tn === $.THEAD || tn === $.TR) {
	        if (p.openElements.hasInTableScope($.CAPTION)) {
	            p.openElements.generateImpliedEndTags();
	            p.openElements.popUntilTagNamePopped($.CAPTION);
	            p.activeFormattingElements.clearToLastMarker();
	            p.insertionMode = IN_TABLE_MODE;
	            p._processToken(token);
	        }
	    }
	
	    else
	        startTagInBody(p, token);
	}
	
	function endTagInCaption(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.CAPTION || tn === $.TABLE) {
	        if (p.openElements.hasInTableScope($.CAPTION)) {
	            p.openElements.generateImpliedEndTags();
	            p.openElements.popUntilTagNamePopped($.CAPTION);
	            p.activeFormattingElements.clearToLastMarker();
	            p.insertionMode = IN_TABLE_MODE;
	
	            if (tn === $.TABLE)
	                p._processToken(token);
	        }
	    }
	
	    else if (tn !== $.BODY && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML && tn !== $.TBODY &&
	             tn !== $.TD && tn !== $.TFOOT && tn !== $.TH && tn !== $.THEAD && tn !== $.TR)
	        endTagInBody(p, token);
	}
	
	
	//12.2.5.4.12 The "in column group" insertion mode
	//------------------------------------------------------------------
	function startTagInColumnGroup(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.HTML)
	        startTagInBody(p, token);
	
	    else if (tn === $.COL)
	        p._appendElement(token, NS.HTML);
	
	    else if (tn === $.TEMPLATE)
	        startTagInHead(p, token);
	
	    else
	        tokenInColumnGroup(p, token);
	}
	
	function endTagInColumnGroup(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.COLGROUP) {
	        if (p.openElements.currentTagName === $.COLGROUP) {
	            p.openElements.pop();
	            p.insertionMode = IN_TABLE_MODE;
	        }
	    }
	
	    else if (tn === $.TEMPLATE)
	        endTagInHead(p, token);
	
	    else if (tn !== $.COL)
	        tokenInColumnGroup(p, token);
	}
	
	function tokenInColumnGroup(p, token) {
	    if (p.openElements.currentTagName === $.COLGROUP) {
	        p.openElements.pop();
	        p.insertionMode = IN_TABLE_MODE;
	        p._processToken(token);
	    }
	}
	
	//12.2.5.4.13 The "in table body" insertion mode
	//------------------------------------------------------------------
	function startTagInTableBody(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.TR) {
	        p.openElements.clearBackToTableBodyContext();
	        p._insertElement(token, NS.HTML);
	        p.insertionMode = IN_ROW_MODE;
	    }
	
	    else if (tn === $.TH || tn === $.TD) {
	        p.openElements.clearBackToTableBodyContext();
	        p._insertFakeElement($.TR);
	        p.insertionMode = IN_ROW_MODE;
	        p._processToken(token);
	    }
	
	    else if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP ||
	             tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
	
	        if (p.openElements.hasTableBodyContextInTableScope()) {
	            p.openElements.clearBackToTableBodyContext();
	            p.openElements.pop();
	            p.insertionMode = IN_TABLE_MODE;
	            p._processToken(token);
	        }
	    }
	
	    else
	        startTagInTable(p, token);
	}
	
	function endTagInTableBody(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
	        if (p.openElements.hasInTableScope(tn)) {
	            p.openElements.clearBackToTableBodyContext();
	            p.openElements.pop();
	            p.insertionMode = IN_TABLE_MODE;
	        }
	    }
	
	    else if (tn === $.TABLE) {
	        if (p.openElements.hasTableBodyContextInTableScope()) {
	            p.openElements.clearBackToTableBodyContext();
	            p.openElements.pop();
	            p.insertionMode = IN_TABLE_MODE;
	            p._processToken(token);
	        }
	    }
	
	    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP ||
	             tn !== $.HTML && tn !== $.TD && tn !== $.TH && tn !== $.TR)
	        endTagInTable(p, token);
	}
	
	//12.2.5.4.14 The "in row" insertion mode
	//------------------------------------------------------------------
	function startTagInRow(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.TH || tn === $.TD) {
	        p.openElements.clearBackToTableRowContext();
	        p._insertElement(token, NS.HTML);
	        p.insertionMode = IN_CELL_MODE;
	        p.activeFormattingElements.insertMarker();
	    }
	
	    else if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY ||
	             tn === $.TFOOT || tn === $.THEAD || tn === $.TR) {
	        if (p.openElements.hasInTableScope($.TR)) {
	            p.openElements.clearBackToTableRowContext();
	            p.openElements.pop();
	            p.insertionMode = IN_TABLE_BODY_MODE;
	            p._processToken(token);
	        }
	    }
	
	    else
	        startTagInTable(p, token);
	}
	
	function endTagInRow(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.TR) {
	        if (p.openElements.hasInTableScope($.TR)) {
	            p.openElements.clearBackToTableRowContext();
	            p.openElements.pop();
	            p.insertionMode = IN_TABLE_BODY_MODE;
	        }
	    }
	
	    else if (tn === $.TABLE) {
	        if (p.openElements.hasInTableScope($.TR)) {
	            p.openElements.clearBackToTableRowContext();
	            p.openElements.pop();
	            p.insertionMode = IN_TABLE_BODY_MODE;
	            p._processToken(token);
	        }
	    }
	
	    else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
	        if (p.openElements.hasInTableScope(tn) || p.openElements.hasInTableScope($.TR)) {
	            p.openElements.clearBackToTableRowContext();
	            p.openElements.pop();
	            p.insertionMode = IN_TABLE_BODY_MODE;
	            p._processToken(token);
	        }
	    }
	
	    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP ||
	             tn !== $.HTML && tn !== $.TD && tn !== $.TH)
	        endTagInTable(p, token);
	}
	
	
	//12.2.5.4.15 The "in cell" insertion mode
	//------------------------------------------------------------------
	function startTagInCell(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY ||
	        tn === $.TD || tn === $.TFOOT || tn === $.TH || tn === $.THEAD || tn === $.TR) {
	
	        if (p.openElements.hasInTableScope($.TD) || p.openElements.hasInTableScope($.TH)) {
	            p._closeTableCell();
	            p._processToken(token);
	        }
	    }
	
	    else
	        startTagInBody(p, token);
	}
	
	function endTagInCell(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.TD || tn === $.TH) {
	        if (p.openElements.hasInTableScope(tn)) {
	            p.openElements.generateImpliedEndTags();
	            p.openElements.popUntilTagNamePopped(tn);
	            p.activeFormattingElements.clearToLastMarker();
	            p.insertionMode = IN_ROW_MODE;
	        }
	    }
	
	    else if (tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR) {
	        if (p.openElements.hasInTableScope(tn)) {
	            p._closeTableCell();
	            p._processToken(token);
	        }
	    }
	
	    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML)
	        endTagInBody(p, token);
	}
	
	//12.2.5.4.16 The "in select" insertion mode
	//------------------------------------------------------------------
	function startTagInSelect(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.HTML)
	        startTagInBody(p, token);
	
	    else if (tn === $.OPTION) {
	        if (p.openElements.currentTagName === $.OPTION)
	            p.openElements.pop();
	
	        p._insertElement(token, NS.HTML);
	    }
	
	    else if (tn === $.OPTGROUP) {
	        if (p.openElements.currentTagName === $.OPTION)
	            p.openElements.pop();
	
	        if (p.openElements.currentTagName === $.OPTGROUP)
	            p.openElements.pop();
	
	        p._insertElement(token, NS.HTML);
	    }
	
	    else if (tn === $.INPUT || tn === $.KEYGEN || tn === $.TEXTAREA || tn === $.SELECT) {
	        if (p.openElements.hasInSelectScope($.SELECT)) {
	            p.openElements.popUntilTagNamePopped($.SELECT);
	            p._resetInsertionMode();
	
	            if (tn !== $.SELECT)
	                p._processToken(token);
	        }
	    }
	
	    else if (tn === $.SCRIPT || tn === $.TEMPLATE)
	        startTagInHead(p, token);
	}
	
	function endTagInSelect(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.OPTGROUP) {
	        var prevOpenElement = p.openElements.items[p.openElements.stackTop - 1],
	            prevOpenElementTn = prevOpenElement && p.treeAdapter.getTagName(prevOpenElement);
	
	        if (p.openElements.currentTagName === $.OPTION && prevOpenElementTn === $.OPTGROUP)
	            p.openElements.pop();
	
	        if (p.openElements.currentTagName === $.OPTGROUP)
	            p.openElements.pop();
	    }
	
	    else if (tn === $.OPTION) {
	        if (p.openElements.currentTagName === $.OPTION)
	            p.openElements.pop();
	    }
	
	    else if (tn === $.SELECT && p.openElements.hasInSelectScope($.SELECT)) {
	        p.openElements.popUntilTagNamePopped($.SELECT);
	        p._resetInsertionMode();
	    }
	
	    else if (tn === $.TEMPLATE)
	        endTagInHead(p, token);
	}
	
	//12.2.5.4.17 The "in select in table" insertion mode
	//------------------------------------------------------------------
	function startTagInSelectInTable(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.CAPTION || tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT ||
	        tn === $.THEAD || tn === $.TR || tn === $.TD || tn === $.TH) {
	        p.openElements.popUntilTagNamePopped($.SELECT);
	        p._resetInsertionMode();
	        p._processToken(token);
	    }
	
	    else
	        startTagInSelect(p, token);
	}
	
	function endTagInSelectInTable(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.CAPTION || tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT ||
	        tn === $.THEAD || tn === $.TR || tn === $.TD || tn === $.TH) {
	        if (p.openElements.hasInTableScope(tn)) {
	            p.openElements.popUntilTagNamePopped($.SELECT);
	            p._resetInsertionMode();
	            p._processToken(token);
	        }
	    }
	
	    else
	        endTagInSelect(p, token);
	}
	
	//12.2.5.4.18 The "in template" insertion mode
	//------------------------------------------------------------------
	function startTagInTemplate(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META ||
	        tn === $.NOFRAMES || tn === $.SCRIPT || tn === $.STYLE || tn === $.TEMPLATE || tn === $.TITLE)
	        startTagInHead(p, token);
	
	    else {
	        var newInsertionMode = TEMPLATE_INSERTION_MODE_SWITCH_MAP[tn] || IN_BODY_MODE;
	
	        p._popTmplInsertionMode();
	        p._pushTmplInsertionMode(newInsertionMode);
	        p.insertionMode = newInsertionMode;
	        p._processToken(token);
	    }
	}
	
	function endTagInTemplate(p, token) {
	    if (token.tagName === $.TEMPLATE)
	        endTagInHead(p, token);
	}
	
	function eofInTemplate(p, token) {
	    if (p.openElements.tmplCount > 0) {
	        p.openElements.popUntilTagNamePopped($.TEMPLATE);
	        p.activeFormattingElements.clearToLastMarker();
	        p._popTmplInsertionMode();
	        p._resetInsertionMode();
	        p._processToken(token);
	    }
	
	    else
	        p.stopped = true;
	}
	
	
	//12.2.5.4.19 The "after body" insertion mode
	//------------------------------------------------------------------
	function startTagAfterBody(p, token) {
	    if (token.tagName === $.HTML)
	        startTagInBody(p, token);
	
	    else
	        tokenAfterBody(p, token);
	}
	
	function endTagAfterBody(p, token) {
	    if (token.tagName === $.HTML) {
	        if (!p.fragmentContext)
	            p.insertionMode = AFTER_AFTER_BODY_MODE;
	    }
	
	    else
	        tokenAfterBody(p, token);
	}
	
	function tokenAfterBody(p, token) {
	    p.insertionMode = IN_BODY_MODE;
	    p._processToken(token);
	}
	
	//12.2.5.4.20 The "in frameset" insertion mode
	//------------------------------------------------------------------
	function startTagInFrameset(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.HTML)
	        startTagInBody(p, token);
	
	    else if (tn === $.FRAMESET)
	        p._insertElement(token, NS.HTML);
	
	    else if (tn === $.FRAME)
	        p._appendElement(token, NS.HTML);
	
	    else if (tn === $.NOFRAMES)
	        startTagInHead(p, token);
	}
	
	function endTagInFrameset(p, token) {
	    if (token.tagName === $.FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
	        p.openElements.pop();
	
	        if (!p.fragmentContext && p.openElements.currentTagName !== $.FRAMESET)
	            p.insertionMode = AFTER_FRAMESET_MODE;
	    }
	}
	
	//12.2.5.4.21 The "after frameset" insertion mode
	//------------------------------------------------------------------
	function startTagAfterFrameset(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.HTML)
	        startTagInBody(p, token);
	
	    else if (tn === $.NOFRAMES)
	        startTagInHead(p, token);
	}
	
	function endTagAfterFrameset(p, token) {
	    if (token.tagName === $.HTML)
	        p.insertionMode = AFTER_AFTER_FRAMESET_MODE;
	}
	
	//12.2.5.4.22 The "after after body" insertion mode
	//------------------------------------------------------------------
	function startTagAfterAfterBody(p, token) {
	    if (token.tagName === $.HTML)
	        startTagInBody(p, token);
	
	    else
	        tokenAfterAfterBody(p, token);
	}
	
	function tokenAfterAfterBody(p, token) {
	    p.insertionMode = IN_BODY_MODE;
	    p._processToken(token);
	}
	
	//12.2.5.4.23 The "after after frameset" insertion mode
	//------------------------------------------------------------------
	function startTagAfterAfterFrameset(p, token) {
	    var tn = token.tagName;
	
	    if (tn === $.HTML)
	        startTagInBody(p, token);
	
	    else if (tn === $.NOFRAMES)
	        startTagInHead(p, token);
	}
	
	
	//12.2.5.5 The rules for parsing tokens in foreign content
	//------------------------------------------------------------------
	function nullCharacterInForeignContent(p, token) {
	    token.chars = UNICODE.REPLACEMENT_CHARACTER;
	    p._insertCharacters(token);
	}
	
	function characterInForeignContent(p, token) {
	    p._insertCharacters(token);
	    p.framesetOk = false;
	}
	
	function startTagInForeignContent(p, token) {
	    if (foreignContent.causesExit(token) && !p.fragmentContext) {
	        while (p.treeAdapter.getNamespaceURI(p.openElements.current) !== NS.HTML && !p._isIntegrationPoint(p.openElements.current))
	            p.openElements.pop();
	
	        p._processToken(token);
	    }
	
	    else {
	        var current = p._getAdjustedCurrentElement(),
	            currentNs = p.treeAdapter.getNamespaceURI(current);
	
	        if (currentNs === NS.MATHML)
	            foreignContent.adjustTokenMathMLAttrs(token);
	
	        else if (currentNs === NS.SVG) {
	            foreignContent.adjustTokenSVGTagName(token);
	            foreignContent.adjustTokenSVGAttrs(token);
	        }
	
	        foreignContent.adjustTokenXMLAttrs(token);
	
	        if (token.selfClosing)
	            p._appendElement(token, currentNs);
	        else
	            p._insertElement(token, currentNs);
	    }
	}
	
	function endTagInForeignContent(p, token) {
	    for (var i = p.openElements.stackTop; i > 0; i--) {
	        var element = p.openElements.items[i];
	
	        if (p.treeAdapter.getNamespaceURI(element) === NS.HTML) {
	            p._processToken(token);
	            break;
	        }
	
	        if (p.treeAdapter.getTagName(element).toLowerCase() === token.tagName) {
	            p.openElements.popUntilElementPopped(element);
	            break;
	        }
	    }
	}


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var WritableStream = __webpack_require__(273).Writable,
	    inherits = __webpack_require__(55).inherits,
	    Parser = __webpack_require__(710);
	
	var ParserStream = module.exports = function (options) {
	    WritableStream.call(this);
	
	    this.parser = new Parser(options);
	
	    this.lastChunkWritten = false;
	    this.writeCallback = null;
	    this.pausedByScript = false;
	
	    this.document = this.parser.treeAdapter.createDocument();
	
	    this.pendingHtmlInsertions = [];
	
	    this._resume = this._resume.bind(this);
	    this._documentWrite = this._documentWrite.bind(this);
	    this._scriptHandler = this._scriptHandler.bind(this);
	
	    this.parser._bootstrap(this.document, null);
	};
	
	inherits(ParserStream, WritableStream);
	
	//WritableStream implementation
	ParserStream.prototype._write = function (chunk, encoding, callback) {
	    this.writeCallback = callback;
	    this.parser.tokenizer.write(chunk.toString('utf8'), this.lastChunkWritten);
	    this._runParsingLoop();
	};
	
	ParserStream.prototype.end = function (chunk, encoding, callback) {
	    this.lastChunkWritten = true;
	    WritableStream.prototype.end.call(this, chunk || '', encoding, callback);
	};
	
	//Scriptable parser implementation
	ParserStream.prototype._runParsingLoop = function () {
	    this.parser.runParsingLoopForCurrentChunk(this.writeCallback, this._scriptHandler);
	};
	
	ParserStream.prototype._resume = function () {
	    if (!this.pausedByScript)
	        throw new Error('Parser was already resumed');
	
	    while (this.pendingHtmlInsertions.length) {
	        var html = this.pendingHtmlInsertions.pop();
	
	        this.parser.tokenizer.insertHtmlAtCurrentPos(html);
	    }
	
	    this.pausedByScript = false;
	
	    //NOTE: keep parsing if we don't wait for the next input chunk
	    if (this.parser.tokenizer.active)
	        this._runParsingLoop();
	};
	
	ParserStream.prototype._documentWrite = function (html) {
	    if (!this.parser.stopped)
	        this.pendingHtmlInsertions.push(html);
	};
	
	ParserStream.prototype._scriptHandler = function (scriptElement) {
	    if (this.listeners('script').length) {
	        this.pausedByScript = true;
	        this.emit('script', scriptElement, this._documentWrite, this._resume);
	    }
	    else
	        this._runParsingLoop();
	};
	


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaultTreeAdapter = __webpack_require__(482),
	    mergeOptions = __webpack_require__(483),
	    doctype = __webpack_require__(481),
	    HTML = __webpack_require__(77);
	
	//Aliases
	var $ = HTML.TAG_NAMES,
	    NS = HTML.NAMESPACES;
	
	//Default serializer options
	var DEFAULT_OPTIONS = {
	    treeAdapter: defaultTreeAdapter
	};
	
	//Escaping regexes
	var AMP_REGEX = /&/g,
	    NBSP_REGEX = /\u00a0/g,
	    DOUBLE_QUOTE_REGEX = /"/g,
	    LT_REGEX = /</g,
	    GT_REGEX = />/g;
	
	//Serializer
	var Serializer = module.exports = function (node, options) {
	    this.options = mergeOptions(DEFAULT_OPTIONS, options);
	    this.treeAdapter = this.options.treeAdapter;
	
	    this.html = '';
	    this.startNode = node;
	};
	
	// NOTE: exported as static method for the testing purposes
	Serializer.escapeString = function (str, attrMode) {
	    str = str
	        .replace(AMP_REGEX, '&amp;')
	        .replace(NBSP_REGEX, '&nbsp;');
	
	    if (attrMode)
	        str = str.replace(DOUBLE_QUOTE_REGEX, '&quot;');
	
	    else {
	        str = str
	            .replace(LT_REGEX, '&lt;')
	            .replace(GT_REGEX, '&gt;');
	    }
	
	    return str;
	};
	
	
	//API
	Serializer.prototype.serialize = function () {
	    this._serializeChildNodes(this.startNode);
	
	    return this.html;
	};
	
	
	//Internals
	Serializer.prototype._serializeChildNodes = function (parentNode) {
	    var childNodes = this.treeAdapter.getChildNodes(parentNode);
	
	    if (childNodes) {
	        for (var i = 0, cnLength = childNodes.length; i < cnLength; i++) {
	            var currentNode = childNodes[i];
	
	            if (this.treeAdapter.isElementNode(currentNode))
	                this._serializeElement(currentNode);
	
	            else if (this.treeAdapter.isTextNode(currentNode))
	                this._serializeTextNode(currentNode);
	
	            else if (this.treeAdapter.isCommentNode(currentNode))
	                this._serializeCommentNode(currentNode);
	
	            else if (this.treeAdapter.isDocumentTypeNode(currentNode))
	                this._serializeDocumentTypeNode(currentNode);
	        }
	    }
	};
	
	Serializer.prototype._serializeElement = function (node) {
	    var tn = this.treeAdapter.getTagName(node),
	        ns = this.treeAdapter.getNamespaceURI(node);
	
	    this.html += '<' + tn;
	    this._serializeAttributes(node);
	    this.html += '>';
	
	    if (tn !== $.AREA && tn !== $.BASE && tn !== $.BASEFONT && tn !== $.BGSOUND && tn !== $.BR && tn !== $.BR &&
	        tn !== $.COL && tn !== $.EMBED && tn !== $.FRAME && tn !== $.HR && tn !== $.IMG && tn !== $.INPUT &&
	        tn !== $.KEYGEN && tn !== $.LINK && tn !== $.MENUITEM && tn !== $.META && tn !== $.PARAM && tn !== $.SOURCE &&
	        tn !== $.TRACK && tn !== $.WBR) {
	
	        var childNodesHolder = tn === $.TEMPLATE && ns === NS.HTML ?
	            this.treeAdapter.getTemplateContent(node) :
	            node;
	
	        this._serializeChildNodes(childNodesHolder);
	        this.html += '</' + tn + '>';
	    }
	};
	
	Serializer.prototype._serializeAttributes = function (node) {
	    var attrs = this.treeAdapter.getAttrList(node);
	
	    for (var i = 0, attrsLength = attrs.length; i < attrsLength; i++) {
	        var attr = attrs[i],
	            value = Serializer.escapeString(attr.value, true);
	
	        this.html += ' ';
	
	        if (!attr.namespace)
	            this.html += attr.name;
	
	        else if (attr.namespace === NS.XML)
	            this.html += 'xml:' + attr.name;
	
	        else if (attr.namespace === NS.XMLNS) {
	            if (attr.name !== 'xmlns')
	                this.html += 'xmlns:';
	
	            this.html += attr.name;
	        }
	
	        else if (attr.namespace === NS.XLINK)
	            this.html += 'xlink:' + attr.name;
	
	        else
	            this.html += attr.namespace + ':' + attr.name;
	
	        this.html += '="' + value + '"';
	    }
	};
	
	Serializer.prototype._serializeTextNode = function (node) {
	    var content = this.treeAdapter.getTextNodeContent(node),
	        parent = this.treeAdapter.getParentNode(node),
	        parentTn = void 0;
	
	    if (parent && this.treeAdapter.isElementNode(parent))
	        parentTn = this.treeAdapter.getTagName(parent);
	
	    if (parentTn === $.STYLE || parentTn === $.SCRIPT || parentTn === $.XMP || parentTn === $.IFRAME ||
	        parentTn === $.NOEMBED || parentTn === $.NOFRAMES || parentTn === $.PLAINTEXT || parentTn === $.NOSCRIPT)
	
	        this.html += content;
	
	    else
	        this.html += Serializer.escapeString(content, false);
	};
	
	Serializer.prototype._serializeCommentNode = function (node) {
	    this.html += '<!--' + this.treeAdapter.getCommentNodeContent(node) + '-->';
	};
	
	Serializer.prototype._serializeDocumentTypeNode = function (node) {
	    var name = this.treeAdapter.getDocumentTypeNodeName(node);
	
	    this.html += '<' + doctype.serializeContent(name, null, null) + '>';
	};


/***/ }),
/* 713 */
/***/ (function(module, exports) {

	"use strict";
	
	var originalObject = Object;
	var originalDefProp = Object.defineProperty;
	var originalCreate = Object.create;
	
	function defProp(obj, name, value) {
	  if (originalDefProp) try {
	    originalDefProp.call(originalObject, obj, name, { value: value });
	  } catch (definePropertyIsBrokenInIE8) {
	    obj[name] = value;
	  } else {
	    obj[name] = value;
	  }
	}
	
	// For functions that will be invoked using .call or .apply, we need to
	// define those methods on the function objects themselves, rather than
	// inheriting them from Function.prototype, so that a malicious or clumsy
	// third party cannot interfere with the functionality of this module by
	// redefining Function.prototype.call or .apply.
	function makeSafeToCall(fun) {
	  if (fun) {
	    defProp(fun, "call", fun.call);
	    defProp(fun, "apply", fun.apply);
	  }
	  return fun;
	}
	
	makeSafeToCall(originalDefProp);
	makeSafeToCall(originalCreate);
	
	var hasOwn = makeSafeToCall(Object.prototype.hasOwnProperty);
	var numToStr = makeSafeToCall(Number.prototype.toString);
	var strSlice = makeSafeToCall(String.prototype.slice);
	
	var cloner = function(){};
	function create(prototype) {
	  if (originalCreate) {
	    return originalCreate.call(originalObject, prototype);
	  }
	  cloner.prototype = prototype || null;
	  return new cloner;
	}
	
	var rand = Math.random;
	var uniqueKeys = create(null);
	
	function makeUniqueKey() {
	  // Collisions are highly unlikely, but this module is in the business of
	  // making guarantees rather than safe bets.
	  do var uniqueKey = internString(strSlice.call(numToStr.call(rand(), 36), 2));
	  while (hasOwn.call(uniqueKeys, uniqueKey));
	  return uniqueKeys[uniqueKey] = uniqueKey;
	}
	
	function internString(str) {
	  var obj = {};
	  obj[str] = true;
	  return Object.keys(obj)[0];
	}
	
	// External users might find this function useful, but it is not necessary
	// for the typical use of this module.
	exports.makeUniqueKey = makeUniqueKey;
	
	// Object.getOwnPropertyNames is the only way to enumerate non-enumerable
	// properties, so if we wrap it to ignore our secret keys, there should be
	// no way (except guessing) to access those properties.
	var originalGetOPNs = Object.getOwnPropertyNames;
	Object.getOwnPropertyNames = function getOwnPropertyNames(object) {
	  for (var names = originalGetOPNs(object),
	           src = 0,
	           dst = 0,
	           len = names.length;
	       src < len;
	       ++src) {
	    if (!hasOwn.call(uniqueKeys, names[src])) {
	      if (src > dst) {
	        names[dst] = names[src];
	      }
	      ++dst;
	    }
	  }
	  names.length = dst;
	  return names;
	};
	
	function defaultCreatorFn(object) {
	  return create(null);
	}
	
	function makeAccessor(secretCreatorFn) {
	  var brand = makeUniqueKey();
	  var passkey = create(null);
	
	  secretCreatorFn = secretCreatorFn || defaultCreatorFn;
	
	  function register(object) {
	    var secret; // Created lazily.
	
	    function vault(key, forget) {
	      // Only code that has access to the passkey can retrieve (or forget)
	      // the secret object.
	      if (key === passkey) {
	        return forget
	          ? secret = null
	          : secret || (secret = secretCreatorFn(object));
	      }
	    }
	
	    defProp(object, brand, vault);
	  }
	
	  function accessor(object) {
	    if (!hasOwn.call(object, brand))
	      register(object);
	    return object[brand](passkey);
	  }
	
	  accessor.forget = function(object) {
	    if (hasOwn.call(object, brand))
	      object[brand](passkey, true);
	  };
	
	  return accessor;
	}
	
	exports.makeAccessor = makeAccessor;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 715 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 716 */,
/* 717 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 718 */,
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(219);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _Subscription = __webpack_require__(4408);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(721);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(722);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(75);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(498);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ }),
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 727 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  location: null
	
	  /**
	   * This reducer will update the state with the most recent location history
	   * has transitioned to. This may not be in sync with the router, particularly
	   * if you have asynchronously-loaded routes, so reading from and relying on
	   * this state is discouraged.
	   */
	};function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { location: payload });
	  }
	
	  return state;
	}

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(103);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createMemoryHistory = __webpack_require__(628);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _Router = __webpack_require__(338);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createMemoryHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(103);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Prompt> outside a <Router>');
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(103);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(423);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Redirect> outside a <Router>');
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var _props = this.props,
	        push = _props.push,
	        to = _props.to;
	
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(103);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PathUtils = __webpack_require__(178);
	
	var _Router = __webpack_require__(338);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var normalizeLocation = function normalizeLocation(object) {
	  var _object$pathname = object.pathname,
	      pathname = _object$pathname === undefined ? '/' : _object$pathname,
	      _object$search = object.search,
	      search = _object$search === undefined ? '' : _object$search,
	      _object$hash = object.hash,
	      hash = _object$hash === undefined ? '' : _object$hash;
	
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: (0, _PathUtils.addLeadingSlash)(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = (0, _PathUtils.addLeadingSlash)(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createLocation = function createLocation(location) {
	  return typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : normalizeLocation(location);
	};
	
	var createURL = function createURL(location) {
	  return typeof location === 'string' ? location : (0, _PathUtils.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, 'You cannot %s with <StaticRouter>', methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return (0, _PathUtils.addLeadingSlash)(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = 'PUSH';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = 'REPLACE';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);
	
	    var history = {
	      createHref: this.createHref,
	      action: 'POP',
	      location: stripBasename(basename, createLocation(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler('go'),
	      goBack: staticHandler('goBack'),
	      goForward: staticHandler('goForward'),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: '',
	  location: '/'
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(103);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(339);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Switch> outside a <Router>');
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (!_react2.default.isValidElement(element)) return;
	
	      var _element$props = element.props,
	          pathProp = _element$props.path,
	          exact = _element$props.exact,
	          strict = _element$props.strict,
	          sensitive = _element$props.sensitive,
	          from = _element$props.from;
	
	      var path = pathProp || from;
	
	      if (match == null) {
	        child = element;
	        match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.MemoryRouter = undefined;
	
	var _MemoryRouter2 = __webpack_require__(728);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _Prompt2 = __webpack_require__(729);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(730);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(500);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(338);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(731);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(732);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(339);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(739);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(340),
	    _assign = __webpack_require__(33);
	
	var ReactNoopUpdateQueue = __webpack_require__(737);
	
	var canDefineProperty = __webpack_require__(738);
	var emptyObject = __webpack_require__(176);
	var invariant = __webpack_require__(134);
	var lowPriorityWarning = __webpack_require__(4425);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 735 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 736 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(313);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(103);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(219);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(500);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);
	
	    return _react2.default.createElement(_Route2.default, { render: function render(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
	      } });
	  };
	
	  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ }),
/* 740 */,
/* 741 */,
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(336);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(633);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(312).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(745);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(525).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(212);
	util.inherits = __webpack_require__(71);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(4789);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(4438);
	var destroyImpl = __webpack_require__(744);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(161);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(527).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(161);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(527).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(78)))

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(161);
	
	/*<replacement>*/
	var util = __webpack_require__(212);
	util.inherits = __webpack_require__(71);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(336);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(312).EventEmitter;


/***/ }),
/* 746 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// based on https://github.com/lodash/lodash/blob/4.17.2/lodash.js#L14100
	// eslint-disable-next-line max-len
	var wordPattern = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:(?:1ST|2ND|3RD|(?![123])\dTH)\b)|\d*(?:(?:1st|2nd|3rd|(?![123])\dth)\b)|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
	var namespacer = '/';
	
	function camelCase(string) {
	  return string.match(wordPattern).reduce(function (camelCased, word, index) {
	    return camelCased + (index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.substring(1).toLowerCase());
	  }, '');
	}
	
	exports.default = function (type) {
	  return type.split(namespacer).map(camelCase).join(namespacer);
	};

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ACTION_TYPE_DELIMITER = undefined;
	exports.default = combineActions;
	
	var _isString = __webpack_require__(332);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isFunction = __webpack_require__(102);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isEmpty = __webpack_require__(687);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _toString = __webpack_require__(54);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	var _isSymbol = __webpack_require__(233);
	
	var _isSymbol2 = _interopRequireDefault(_isSymbol);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACTION_TYPE_DELIMITER = exports.ACTION_TYPE_DELIMITER = '||';
	
	function isValidActionType(type) {
	  return (0, _isString2.default)(type) || (0, _isFunction2.default)(type) || (0, _isSymbol2.default)(type);
	}
	
	function isValidActionTypes(types) {
	  if ((0, _isEmpty2.default)(types)) {
	    return false;
	  }
	  return types.every(isValidActionType);
	}
	
	function combineActions() {
	  for (var _len = arguments.length, actionsTypes = Array(_len), _key = 0; _key < _len; _key++) {
	    actionsTypes[_key] = arguments[_key];
	  }
	
	  (0, _invariant2.default)(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
	  var combinedActionType = actionsTypes.map(_toString2.default).join(ACTION_TYPE_DELIMITER);
	  return { toString: function toString() {
	      return combinedActionType;
	    } };
	}

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createAction;
	
	var _identity = __webpack_require__(53);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _isFunction = __webpack_require__(102);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isNull = __webpack_require__(4324);
	
	var _isNull2 = _interopRequireDefault(_isNull);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createAction(type) {
	  var payloadCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
	  var metaCreator = arguments[2];
	
	  (0, _invariant2.default)((0, _isFunction2.default)(payloadCreator) || (0, _isNull2.default)(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');
	
	  var finalPayloadCreator = (0, _isNull2.default)(payloadCreator) || payloadCreator === _identity2.default ? _identity2.default : function (head) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return head instanceof Error ? head : payloadCreator.apply(undefined, [head].concat(args));
	  };
	
	  var hasMeta = (0, _isFunction2.default)(metaCreator);
	  var typeString = type.toString();
	
	  var actionCreator = function actionCreator() {
	    var payload = finalPayloadCreator.apply(undefined, arguments);
	    var action = { type: type };
	
	    if (payload instanceof Error) {
	      action.error = true;
	    }
	
	    if (payload !== undefined) {
	      action.payload = payload;
	    }
	
	    if (hasMeta) {
	      action.meta = metaCreator.apply(undefined, arguments);
	    }
	
	    return action;
	  };
	
	  actionCreator.toString = function () {
	    return typeString;
	  };
	
	  return actionCreator;
	}

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unflattenActionCreators = exports.flattenReducerMap = exports.flattenActionMap = exports.defaultNamespace = undefined;
	
	var _camelCase = __webpack_require__(746);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _ownKeys = __webpack_require__(505);
	
	var _ownKeys2 = _interopRequireDefault(_ownKeys);
	
	var _hasGeneratorInterface = __webpack_require__(4446);
	
	var _hasGeneratorInterface2 = _interopRequireDefault(_hasGeneratorInterface);
	
	var _isPlainObject = __webpack_require__(75);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isMap = __webpack_require__(331);
	
	var _isMap2 = _interopRequireDefault(_isMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultNamespace = exports.defaultNamespace = '/';
	
	function get(key, x) {
	  return (0, _isMap2.default)(x) ? x.get(key) : x[key];
	}
	
	var flattenWhenNode = function flattenWhenNode(predicate) {
	  return function flatten(map) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        _ref$namespace = _ref.namespace,
	        namespace = _ref$namespace === undefined ? defaultNamespace : _ref$namespace,
	        prefix = _ref.prefix;
	
	    var partialFlatMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var partialFlatActionType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	    function connectNamespace(type) {
	      return partialFlatActionType ? '' + partialFlatActionType + namespace + type : type;
	    }
	
	    function connectPrefix(type) {
	      if (partialFlatActionType || !prefix) {
	        return type;
	      }
	
	      return '' + prefix + namespace + type;
	    }
	
	    (0, _ownKeys2.default)(map).forEach(function (type) {
	      var nextNamespace = connectPrefix(connectNamespace(type));
	      var mapValue = get(type, map);
	
	      if (!predicate(mapValue)) {
	        partialFlatMap[nextNamespace] = mapValue;
	      } else {
	        flatten(mapValue, { namespace: namespace, prefix: prefix }, partialFlatMap, nextNamespace);
	      }
	    });
	
	    return partialFlatMap;
	  };
	};
	
	var flattenActionMap = flattenWhenNode(_isPlainObject2.default);
	var flattenReducerMap = flattenWhenNode(function (node) {
	  return ((0, _isPlainObject2.default)(node) || (0, _isMap2.default)(node)) && !(0, _hasGeneratorInterface2.default)(node);
	});
	
	function unflattenActionCreators(flatActionCreators) {
	  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref2$namespace = _ref2.namespace,
	      namespace = _ref2$namespace === undefined ? defaultNamespace : _ref2$namespace,
	      prefix = _ref2.prefix;
	
	  function unflatten(flatActionType) {
	    var partialNestedActionCreators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var partialFlatActionTypePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var nextNamespace = (0, _camelCase2.default)(partialFlatActionTypePath.shift());
	    if (partialFlatActionTypePath.length) {
	      if (!partialNestedActionCreators[nextNamespace]) {
	        partialNestedActionCreators[nextNamespace] = {};
	      }
	      unflatten(flatActionType, partialNestedActionCreators[nextNamespace], partialFlatActionTypePath);
	    } else {
	      partialNestedActionCreators[nextNamespace] = flatActionCreators[flatActionType];
	    }
	  }
	
	  var nestedActionCreators = {};
	  Object.getOwnPropertyNames(flatActionCreators).forEach(function (type) {
	    var unprefixedType = prefix ? type.replace('' + prefix + namespace, '') : type;
	    return unflatten(type, nestedActionCreators, unprefixedType.split(namespace));
	  });
	
	  return nestedActionCreators;
	}
	
	exports.flattenActionMap = flattenActionMap;
	exports.flattenReducerMap = flattenReducerMap;
	exports.unflattenActionCreators = unflattenActionCreators;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = handleAction;
	
	var _isFunction = __webpack_require__(102);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isPlainObject = __webpack_require__(75);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _identity = __webpack_require__(53);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _isNil = __webpack_require__(688);
	
	var _isNil2 = _interopRequireDefault(_isNil);
	
	var _isUndefined = __webpack_require__(4328);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _includes = __webpack_require__(330);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _combineActions = __webpack_require__(747);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleAction(type) {
	  var reducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
	  var defaultState = arguments[2];
	
	  var types = type.toString().split(_combineActions.ACTION_TYPE_DELIMITER);
	  (0, _invariant2.default)(!(0, _isUndefined2.default)(defaultState), 'defaultState for reducer handling ' + types.join(', ') + ' should be defined');
	  (0, _invariant2.default)((0, _isFunction2.default)(reducer) || (0, _isPlainObject2.default)(reducer), 'Expected reducer to be a function or object with next and throw reducers');
	
	  var _ref = (0, _isFunction2.default)(reducer) ? [reducer, reducer] : [reducer.next, reducer.throw].map(function (aReducer) {
	    return (0, _isNil2.default)(aReducer) ? _identity2.default : aReducer;
	  }),
	      _ref2 = _slicedToArray(_ref, 2),
	      nextReducer = _ref2[0],
	      throwReducer = _ref2[1];
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];
	    var actionType = action.type;
	
	    if (!actionType || !(0, _includes2.default)(types, actionType.toString())) {
	      return state;
	    }
	
	    return (action.error === true ? throwReducer : nextReducer)(state, action);
	  };
	}

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionsObservable = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Observable2 = __webpack_require__(4);
	
	var _of2 = __webpack_require__(89);
	
	var _from2 = __webpack_require__(346);
	
	var _operators = __webpack_require__(753);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActionsObservable = exports.ActionsObservable = function (_Observable) {
	  _inherits(ActionsObservable, _Observable);
	
	  _createClass(ActionsObservable, null, [{
	    key: 'of',
	    value: function of() {
	      return new this(_of2.of.apply(undefined, arguments));
	    }
	  }, {
	    key: 'from',
	    value: function from(actions, scheduler) {
	      return new this((0, _from2.from)(actions, scheduler));
	    }
	  }]);
	
	  function ActionsObservable(actionsSubject) {
	    _classCallCheck(this, ActionsObservable);
	
	    var _this = _possibleConstructorReturn(this, (ActionsObservable.__proto__ || Object.getPrototypeOf(ActionsObservable)).call(this));
	
	    _this.source = actionsSubject;
	    return _this;
	  }
	
	  _createClass(ActionsObservable, [{
	    key: 'lift',
	    value: function lift(operator) {
	      var observable = new ActionsObservable(this);
	      observable.operator = operator;
	      return observable;
	    }
	  }, {
	    key: 'ofType',
	    value: function ofType() {
	      return _operators.ofType.apply(undefined, arguments)(this);
	    }
	  }]);
	
	  return ActionsObservable;
	}(_Observable2.Observable);

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EPIC_END = exports.EPIC_END = '@@redux-observable/EPIC_END';

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ofType = ofType;
	
	var _filter = __webpack_require__(768);
	
	var keyHasType = function keyHasType(type, key) {
	  return type === key || typeof key === 'function' && type === key.toString();
	};
	
	function ofType() {
	  for (var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++) {
	    keys[_key] = arguments[_key];
	  }
	
	  return function ofTypeOperatorFunction(source) {
	    return _filter.filter.call(source, function (_ref) {
	      var type = _ref.type;
	
	      var len = keys.length;
	      if (len === 1) {
	        return keyHasType(type, keys[0]);
	      } else {
	        for (var i = 0; i < len; i++) {
	          if (keyHasType(type, keys[i])) {
	            return true;
	          }
	        }
	      }
	      return false;
	    });
	  };
	}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(75);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(4773);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/regenerate v1.3.3 by @mathias | MIT license */
	;(function(root) {
	
		// Detect free variables `exports`.
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`.
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js/io.js or Browserified code,
		// and use it as `root`.
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var ERRORS = {
			'rangeOrder': 'A range\u2019s `stop` value must be greater than or equal ' +
				'to the `start` value.',
			'codePointRange': 'Invalid code point value. Code points range from ' +
				'U+000000 to U+10FFFF.'
		};
	
		// https://mathiasbynens.be/notes/javascript-encoding#surrogate-pairs
		var HIGH_SURROGATE_MIN = 0xD800;
		var HIGH_SURROGATE_MAX = 0xDBFF;
		var LOW_SURROGATE_MIN = 0xDC00;
		var LOW_SURROGATE_MAX = 0xDFFF;
	
		// In Regenerate output, `\0` is never preceded by `\` because we sort by
		// code point value, so let’s keep this regular expression simple.
		var regexNull = /\\x00([^0123456789]|$)/g;
	
		var object = {};
		var hasOwnProperty = object.hasOwnProperty;
		var extend = function(destination, source) {
			var key;
			for (key in source) {
				if (hasOwnProperty.call(source, key)) {
					destination[key] = source[key];
				}
			}
			return destination;
		};
	
		var forEach = function(array, callback) {
			var index = -1;
			var length = array.length;
			while (++index < length) {
				callback(array[index], index);
			}
		};
	
		var toString = object.toString;
		var isArray = function(value) {
			return toString.call(value) == '[object Array]';
		};
		var isNumber = function(value) {
			return typeof value == 'number' ||
				toString.call(value) == '[object Number]';
		};
	
		// This assumes that `number` is a positive integer that `toString()`s nicely
		// (which is the case for all code point values).
		var zeroes = '0000';
		var pad = function(number, totalCharacters) {
			var string = String(number);
			return string.length < totalCharacters
				? (zeroes + string).slice(-totalCharacters)
				: string;
		};
	
		var hex = function(number) {
			return Number(number).toString(16).toUpperCase();
		};
	
		var slice = [].slice;
	
		/*--------------------------------------------------------------------------*/
	
		var dataFromCodePoints = function(codePoints) {
			var index = -1;
			var length = codePoints.length;
			var max = length - 1;
			var result = [];
			var isStart = true;
			var tmp;
			var previous = 0;
			while (++index < length) {
				tmp = codePoints[index];
				if (isStart) {
					result.push(tmp);
					previous = tmp;
					isStart = false;
				} else {
					if (tmp == previous + 1) {
						if (index != max) {
							previous = tmp;
							continue;
						} else {
							isStart = true;
							result.push(tmp + 1);
						}
					} else {
						// End the previous range and start a new one.
						result.push(previous + 1, tmp);
						previous = tmp;
					}
				}
			}
			if (!isStart) {
				result.push(tmp + 1);
			}
			return result;
		};
	
		var dataRemove = function(data, codePoint) {
			// Iterate over the data per `(start, end)` pair.
			var index = 0;
			var start;
			var end;
			var length = data.length;
			while (index < length) {
				start = data[index];
				end = data[index + 1];
				if (codePoint >= start && codePoint < end) {
					// Modify this pair.
					if (codePoint == start) {
						if (end == start + 1) {
							// Just remove `start` and `end`.
							data.splice(index, 2);
							return data;
						} else {
							// Just replace `start` with a new value.
							data[index] = codePoint + 1;
							return data;
						}
					} else if (codePoint == end - 1) {
						// Just replace `end` with a new value.
						data[index + 1] = codePoint;
						return data;
					} else {
						// Replace `[start, end]` with `[startA, endA, startB, endB]`.
						data.splice(index, 2, start, codePoint, codePoint + 1, end);
						return data;
					}
				}
				index += 2;
			}
			return data;
		};
	
		var dataRemoveRange = function(data, rangeStart, rangeEnd) {
			if (rangeEnd < rangeStart) {
				throw Error(ERRORS.rangeOrder);
			}
			// Iterate over the data per `(start, end)` pair.
			var index = 0;
			var start;
			var end;
			while (index < data.length) {
				start = data[index];
				end = data[index + 1] - 1; // Note: the `- 1` makes `end` inclusive.
	
				// Exit as soon as no more matching pairs can be found.
				if (start > rangeEnd) {
					return data;
				}
	
				// Check if this range pair is equal to, or forms a subset of, the range
				// to be removed.
				// E.g. we have `[0, 11, 40, 51]` and want to remove 0-10 → `[40, 51]`.
				// E.g. we have `[40, 51]` and want to remove 0-100 → `[]`.
				if (rangeStart <= start && rangeEnd >= end) {
					// Remove this pair.
					data.splice(index, 2);
					continue;
				}
	
				// Check if both `rangeStart` and `rangeEnd` are within the bounds of
				// this pair.
				// E.g. we have `[0, 11]` and want to remove 4-6 → `[0, 4, 7, 11]`.
				if (rangeStart >= start && rangeEnd < end) {
					if (rangeStart == start) {
						// Replace `[start, end]` with `[startB, endB]`.
						data[index] = rangeEnd + 1;
						data[index + 1] = end + 1;
						return data;
					}
					// Replace `[start, end]` with `[startA, endA, startB, endB]`.
					data.splice(index, 2, start, rangeStart, rangeEnd + 1, end + 1);
					return data;
				}
	
				// Check if only `rangeStart` is within the bounds of this pair.
				// E.g. we have `[0, 11]` and want to remove 4-20 → `[0, 4]`.
				if (rangeStart >= start && rangeStart <= end) {
					// Replace `end` with `rangeStart`.
					data[index + 1] = rangeStart;
					// Note: we cannot `return` just yet, in case any following pairs still
					// contain matching code points.
					// E.g. we have `[0, 11, 14, 31]` and want to remove 4-20
					// → `[0, 4, 21, 31]`.
				}
	
				// Check if only `rangeEnd` is within the bounds of this pair.
				// E.g. we have `[14, 31]` and want to remove 4-20 → `[21, 31]`.
				else if (rangeEnd >= start && rangeEnd <= end) {
					// Just replace `start`.
					data[index] = rangeEnd + 1;
					return data;
				}
	
				index += 2;
			}
			return data;
		};
	
		 var dataAdd = function(data, codePoint) {
			// Iterate over the data per `(start, end)` pair.
			var index = 0;
			var start;
			var end;
			var lastIndex = null;
			var length = data.length;
			if (codePoint < 0x0 || codePoint > 0x10FFFF) {
				throw RangeError(ERRORS.codePointRange);
			}
			while (index < length) {
				start = data[index];
				end = data[index + 1];
	
				// Check if the code point is already in the set.
				if (codePoint >= start && codePoint < end) {
					return data;
				}
	
				if (codePoint == start - 1) {
					// Just replace `start` with a new value.
					data[index] = codePoint;
					return data;
				}
	
				// At this point, if `start` is `greater` than `codePoint`, insert a new
				// `[start, end]` pair before the current pair, or after the current pair
				// if there is a known `lastIndex`.
				if (start > codePoint) {
					data.splice(
						lastIndex != null ? lastIndex + 2 : 0,
						0,
						codePoint,
						codePoint + 1
					);
					return data;
				}
	
				if (codePoint == end) {
					// Check if adding this code point causes two separate ranges to become
					// a single range, e.g. `dataAdd([0, 4, 5, 10], 4)` → `[0, 10]`.
					if (codePoint + 1 == data[index + 2]) {
						data.splice(index, 4, start, data[index + 3]);
						return data;
					}
					// Else, just replace `end` with a new value.
					data[index + 1] = codePoint + 1;
					return data;
				}
				lastIndex = index;
				index += 2;
			}
			// The loop has finished; add the new pair to the end of the data set.
			data.push(codePoint, codePoint + 1);
			return data;
		};
	
		var dataAddData = function(dataA, dataB) {
			// Iterate over the data per `(start, end)` pair.
			var index = 0;
			var start;
			var end;
			var data = dataA.slice();
			var length = dataB.length;
			while (index < length) {
				start = dataB[index];
				end = dataB[index + 1] - 1;
				if (start == end) {
					data = dataAdd(data, start);
				} else {
					data = dataAddRange(data, start, end);
				}
				index += 2;
			}
			return data;
		};
	
		var dataRemoveData = function(dataA, dataB) {
			// Iterate over the data per `(start, end)` pair.
			var index = 0;
			var start;
			var end;
			var data = dataA.slice();
			var length = dataB.length;
			while (index < length) {
				start = dataB[index];
				end = dataB[index + 1] - 1;
				if (start == end) {
					data = dataRemove(data, start);
				} else {
					data = dataRemoveRange(data, start, end);
				}
				index += 2;
			}
			return data;
		};
	
		var dataAddRange = function(data, rangeStart, rangeEnd) {
			if (rangeEnd < rangeStart) {
				throw Error(ERRORS.rangeOrder);
			}
			if (
				rangeStart < 0x0 || rangeStart > 0x10FFFF ||
				rangeEnd < 0x0 || rangeEnd > 0x10FFFF
			) {
				throw RangeError(ERRORS.codePointRange);
			}
			// Iterate over the data per `(start, end)` pair.
			var index = 0;
			var start;
			var end;
			var added = false;
			var length = data.length;
			while (index < length) {
				start = data[index];
				end = data[index + 1];
	
				if (added) {
					// The range has already been added to the set; at this point, we just
					// need to get rid of the following ranges in case they overlap.
	
					// Check if this range can be combined with the previous range.
					if (start == rangeEnd + 1) {
						data.splice(index - 1, 2);
						return data;
					}
	
					// Exit as soon as no more possibly overlapping pairs can be found.
					if (start > rangeEnd) {
						return data;
					}
	
					// E.g. `[0, 11, 12, 16]` and we’ve added 5-15, so we now have
					// `[0, 16, 12, 16]`. Remove the `12,16` part, as it lies within the
					// `0,16` range that was previously added.
					if (start >= rangeStart && start <= rangeEnd) {
						// `start` lies within the range that was previously added.
	
						if (end > rangeStart && end - 1 <= rangeEnd) {
							// `end` lies within the range that was previously added as well,
							// so remove this pair.
							data.splice(index, 2);
							index -= 2;
							// Note: we cannot `return` just yet, as there may still be other
							// overlapping pairs.
						} else {
							// `start` lies within the range that was previously added, but
							// `end` doesn’t. E.g. `[0, 11, 12, 31]` and we’ve added 5-15, so
							// now we have `[0, 16, 12, 31]`. This must be written as `[0, 31]`.
							// Remove the previously added `end` and the current `start`.
							data.splice(index - 1, 2);
							index -= 2;
						}
	
						// Note: we cannot return yet.
					}
	
				}
	
				else if (start == rangeEnd + 1) {
					data[index] = rangeStart;
					return data;
				}
	
				// Check if a new pair must be inserted *before* the current one.
				else if (start > rangeEnd) {
					data.splice(index, 0, rangeStart, rangeEnd + 1);
					return data;
				}
	
				else if (rangeStart >= start && rangeStart < end && rangeEnd + 1 <= end) {
					// The new range lies entirely within an existing range pair. No action
					// needed.
					return data;
				}
	
				else if (
					// E.g. `[0, 11]` and you add 5-15 → `[0, 16]`.
					(rangeStart >= start && rangeStart < end) ||
					// E.g. `[0, 3]` and you add 3-6 → `[0, 7]`.
					end == rangeStart
				) {
					// Replace `end` with the new value.
					data[index + 1] = rangeEnd + 1;
					// Make sure the next range pair doesn’t overlap, e.g. `[0, 11, 12, 14]`
					// and you add 5-15 → `[0, 16]`, i.e. remove the `12,14` part.
					added = true;
					// Note: we cannot `return` just yet.
				}
	
				else if (rangeStart <= start && rangeEnd + 1 >= end) {
					// The new range is a superset of the old range.
					data[index] = rangeStart;
					data[index + 1] = rangeEnd + 1;
					added = true;
				}
	
				index += 2;
			}
			// The loop has finished without doing anything; add the new pair to the end
			// of the data set.
			if (!added) {
				data.push(rangeStart, rangeEnd + 1);
			}
			return data;
		};
	
		var dataContains = function(data, codePoint) {
			var index = 0;
			var length = data.length;
			// Exit early if `codePoint` is not within `data`’s overall range.
			var start = data[index];
			var end = data[length - 1];
			if (length >= 2) {
				if (codePoint < start || codePoint > end) {
					return false;
				}
			}
			// Iterate over the data per `(start, end)` pair.
			while (index < length) {
				start = data[index];
				end = data[index + 1];
				if (codePoint >= start && codePoint < end) {
					return true;
				}
				index += 2;
			}
			return false;
		};
	
		var dataIntersection = function(data, codePoints) {
			var index = 0;
			var length = codePoints.length;
			var codePoint;
			var result = [];
			while (index < length) {
				codePoint = codePoints[index];
				if (dataContains(data, codePoint)) {
					result.push(codePoint);
				}
				++index;
			}
			return dataFromCodePoints(result);
		};
	
		var dataIsEmpty = function(data) {
			return !data.length;
		};
	
		var dataIsSingleton = function(data) {
			// Check if the set only represents a single code point.
			return data.length == 2 && data[0] + 1 == data[1];
		};
	
		var dataToArray = function(data) {
			// Iterate over the data per `(start, end)` pair.
			var index = 0;
			var start;
			var end;
			var result = [];
			var length = data.length;
			while (index < length) {
				start = data[index];
				end = data[index + 1];
				while (start < end) {
					result.push(start);
					++start;
				}
				index += 2;
			}
			return result;
		};
	
		/*--------------------------------------------------------------------------*/
	
		// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
		var floor = Math.floor;
		var highSurrogate = function(codePoint) {
			return parseInt(
				floor((codePoint - 0x10000) / 0x400) + HIGH_SURROGATE_MIN,
				10
			);
		};
	
		var lowSurrogate = function(codePoint) {
			return parseInt(
				(codePoint - 0x10000) % 0x400 + LOW_SURROGATE_MIN,
				10
			);
		};
	
		var stringFromCharCode = String.fromCharCode;
		var codePointToString = function(codePoint) {
			var string;
			// https://mathiasbynens.be/notes/javascript-escapes#single
			// Note: the `\b` escape sequence for U+0008 BACKSPACE in strings has a
			// different meaning in regular expressions (word boundary), so it cannot
			// be used here.
			if (codePoint == 0x09) {
				string = '\\t';
			}
			// Note: IE < 9 treats `'\v'` as `'v'`, so avoid using it.
			// else if (codePoint == 0x0B) {
			// 	string = '\\v';
			// }
			else if (codePoint == 0x0A) {
				string = '\\n';
			}
			else if (codePoint == 0x0C) {
				string = '\\f';
			}
			else if (codePoint == 0x0D) {
				string = '\\r';
			}
			else if (codePoint == 0x5C) {
				string = '\\\\';
			}
			else if (
				codePoint == 0x24 ||
				(codePoint >= 0x28 && codePoint <= 0x2B) ||
				(codePoint >= 0x2D && codePoint <= 0x2F) ||
				codePoint == 0x3F ||
				(codePoint >= 0x5B && codePoint <= 0x5E) ||
				(codePoint >= 0x7B && codePoint <= 0x7D)
			) {
				// The code point maps to an unsafe printable ASCII character;
				// backslash-escape it. Here’s the list of those symbols:
				//
				//     $()*+-./?[\]^{|}
				//
				// See #7 for more info.
				string = '\\' + stringFromCharCode(codePoint);
			}
			else if (codePoint >= 0x20 && codePoint <= 0x7E) {
				// The code point maps to one of these printable ASCII symbols
				// (including the space character):
				//
				//      !"#%&',/0123456789:;<=>@ABCDEFGHIJKLMNO
				//     PQRSTUVWXYZ_`abcdefghijklmnopqrstuvwxyz~
				//
				// These can safely be used directly.
				string = stringFromCharCode(codePoint);
			}
			else if (codePoint <= 0xFF) {
				// https://mathiasbynens.be/notes/javascript-escapes#hexadecimal
				string = '\\x' + pad(hex(codePoint), 2);
			}
			else { // `codePoint <= 0xFFFF` holds true.
				// https://mathiasbynens.be/notes/javascript-escapes#unicode
				string = '\\u' + pad(hex(codePoint), 4);
			}
	
			// There’s no need to account for astral symbols / surrogate pairs here,
			// since `codePointToString` is private and only used for BMP code points.
			// But if that’s what you need, just add an `else` block with this code:
			//
			//     string = '\\u' + pad(hex(highSurrogate(codePoint)), 4)
			//     	+ '\\u' + pad(hex(lowSurrogate(codePoint)), 4);
	
			return string;
		};
	
		var codePointToStringUnicode = function(codePoint) {
			if (codePoint <= 0xFFFF) {
				return codePointToString(codePoint);
			}
			return '\\u{' + codePoint.toString(16).toUpperCase() + '}';
		};
	
		var symbolToCodePoint = function(symbol) {
			var length = symbol.length;
			var first = symbol.charCodeAt(0);
			var second;
			if (
				first >= HIGH_SURROGATE_MIN && first <= HIGH_SURROGATE_MAX &&
				length > 1 // There is a next code unit.
			) {
				// `first` is a high surrogate, and there is a next character. Assume
				// it’s a low surrogate (else it’s invalid usage of Regenerate anyway).
				second = symbol.charCodeAt(1);
				// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
				return (first - HIGH_SURROGATE_MIN) * 0x400 +
					second - LOW_SURROGATE_MIN + 0x10000;
			}
			return first;
		};
	
		var createBMPCharacterClasses = function(data) {
			// Iterate over the data per `(start, end)` pair.
			var result = '';
			var index = 0;
			var start;
			var end;
			var length = data.length;
			if (dataIsSingleton(data)) {
				return codePointToString(data[0]);
			}
			while (index < length) {
				start = data[index];
				end = data[index + 1] - 1; // Note: the `- 1` makes `end` inclusive.
				if (start == end) {
					result += codePointToString(start);
				} else if (start + 1 == end) {
					result += codePointToString(start) + codePointToString(end);
				} else {
					result += codePointToString(start) + '-' + codePointToString(end);
				}
				index += 2;
			}
			return '[' + result + ']';
		};
	
		var createUnicodeCharacterClasses = function(data) {
			// Iterate over the data per `(start, end)` pair.
			var result = '';
			var index = 0;
			var start;
			var end;
			var length = data.length;
			if (dataIsSingleton(data)) {
				return codePointToStringUnicode(data[0]);
			}
			while (index < length) {
				start = data[index];
				end = data[index + 1] - 1; // Note: the `- 1` makes `end` inclusive.
				if (start == end) {
					result += codePointToStringUnicode(start);
				} else if (start + 1 == end) {
					result += codePointToStringUnicode(start) + codePointToStringUnicode(end);
				} else {
					result += codePointToStringUnicode(start) + '-' + codePointToStringUnicode(end);
				}
				index += 2;
			}
			return '[' + result + ']';
		};
	
		var splitAtBMP = function(data) {
			// Iterate over the data per `(start, end)` pair.
			var loneHighSurrogates = [];
			var loneLowSurrogates = [];
			var bmp = [];
			var astral = [];
			var index = 0;
			var start;
			var end;
			var length = data.length;
			while (index < length) {
				start = data[index];
				end = data[index + 1] - 1; // Note: the `- 1` makes `end` inclusive.
	
				if (start < HIGH_SURROGATE_MIN) {
	
					// The range starts and ends before the high surrogate range.
					// E.g. (0, 0x10).
					if (end < HIGH_SURROGATE_MIN) {
						bmp.push(start, end + 1);
					}
	
					// The range starts before the high surrogate range and ends within it.
					// E.g. (0, 0xD855).
					if (end >= HIGH_SURROGATE_MIN && end <= HIGH_SURROGATE_MAX) {
						bmp.push(start, HIGH_SURROGATE_MIN);
						loneHighSurrogates.push(HIGH_SURROGATE_MIN, end + 1);
					}
	
					// The range starts before the high surrogate range and ends in the low
					// surrogate range. E.g. (0, 0xDCFF).
					if (end >= LOW_SURROGATE_MIN && end <= LOW_SURROGATE_MAX) {
						bmp.push(start, HIGH_SURROGATE_MIN);
						loneHighSurrogates.push(HIGH_SURROGATE_MIN, HIGH_SURROGATE_MAX + 1);
						loneLowSurrogates.push(LOW_SURROGATE_MIN, end + 1);
					}
	
					// The range starts before the high surrogate range and ends after the
					// low surrogate range. E.g. (0, 0x10FFFF).
					if (end > LOW_SURROGATE_MAX) {
						bmp.push(start, HIGH_SURROGATE_MIN);
						loneHighSurrogates.push(HIGH_SURROGATE_MIN, HIGH_SURROGATE_MAX + 1);
						loneLowSurrogates.push(LOW_SURROGATE_MIN, LOW_SURROGATE_MAX + 1);
						if (end <= 0xFFFF) {
							bmp.push(LOW_SURROGATE_MAX + 1, end + 1);
						} else {
							bmp.push(LOW_SURROGATE_MAX + 1, 0xFFFF + 1);
							astral.push(0xFFFF + 1, end + 1);
						}
					}
	
				} else if (start >= HIGH_SURROGATE_MIN && start <= HIGH_SURROGATE_MAX) {
	
					// The range starts and ends in the high surrogate range.
					// E.g. (0xD855, 0xD866).
					if (end >= HIGH_SURROGATE_MIN && end <= HIGH_SURROGATE_MAX) {
						loneHighSurrogates.push(start, end + 1);
					}
	
					// The range starts in the high surrogate range and ends in the low
					// surrogate range. E.g. (0xD855, 0xDCFF).
					if (end >= LOW_SURROGATE_MIN && end <= LOW_SURROGATE_MAX) {
						loneHighSurrogates.push(start, HIGH_SURROGATE_MAX + 1);
						loneLowSurrogates.push(LOW_SURROGATE_MIN, end + 1);
					}
	
					// The range starts in the high surrogate range and ends after the low
					// surrogate range. E.g. (0xD855, 0x10FFFF).
					if (end > LOW_SURROGATE_MAX) {
						loneHighSurrogates.push(start, HIGH_SURROGATE_MAX + 1);
						loneLowSurrogates.push(LOW_SURROGATE_MIN, LOW_SURROGATE_MAX + 1);
						if (end <= 0xFFFF) {
							bmp.push(LOW_SURROGATE_MAX + 1, end + 1);
						} else {
							bmp.push(LOW_SURROGATE_MAX + 1, 0xFFFF + 1);
							astral.push(0xFFFF + 1, end + 1);
						}
					}
	
				} else if (start >= LOW_SURROGATE_MIN && start <= LOW_SURROGATE_MAX) {
	
					// The range starts and ends in the low surrogate range.
					// E.g. (0xDCFF, 0xDDFF).
					if (end >= LOW_SURROGATE_MIN && end <= LOW_SURROGATE_MAX) {
						loneLowSurrogates.push(start, end + 1);
					}
	
					// The range starts in the low surrogate range and ends after the low
					// surrogate range. E.g. (0xDCFF, 0x10FFFF).
					if (end > LOW_SURROGATE_MAX) {
						loneLowSurrogates.push(start, LOW_SURROGATE_MAX + 1);
						if (end <= 0xFFFF) {
							bmp.push(LOW_SURROGATE_MAX + 1, end + 1);
						} else {
							bmp.push(LOW_SURROGATE_MAX + 1, 0xFFFF + 1);
							astral.push(0xFFFF + 1, end + 1);
						}
					}
	
				} else if (start > LOW_SURROGATE_MAX && start <= 0xFFFF) {
	
					// The range starts and ends after the low surrogate range.
					// E.g. (0xFFAA, 0x10FFFF).
					if (end <= 0xFFFF) {
						bmp.push(start, end + 1);
					} else {
						bmp.push(start, 0xFFFF + 1);
						astral.push(0xFFFF + 1, end + 1);
					}
	
				} else {
	
					// The range starts and ends in the astral range.
					astral.push(start, end + 1);
	
				}
	
				index += 2;
			}
			return {
				'loneHighSurrogates': loneHighSurrogates,
				'loneLowSurrogates': loneLowSurrogates,
				'bmp': bmp,
				'astral': astral
			};
		};
	
		var optimizeSurrogateMappings = function(surrogateMappings) {
			var result = [];
			var tmpLow = [];
			var addLow = false;
			var mapping;
			var nextMapping;
			var highSurrogates;
			var lowSurrogates;
			var nextHighSurrogates;
			var nextLowSurrogates;
			var index = -1;
			var length = surrogateMappings.length;
			while (++index < length) {
				mapping = surrogateMappings[index];
				nextMapping = surrogateMappings[index + 1];
				if (!nextMapping) {
					result.push(mapping);
					continue;
				}
				highSurrogates = mapping[0];
				lowSurrogates = mapping[1];
				nextHighSurrogates = nextMapping[0];
				nextLowSurrogates = nextMapping[1];
	
				// Check for identical high surrogate ranges.
				tmpLow = lowSurrogates;
				while (
					nextHighSurrogates &&
					highSurrogates[0] == nextHighSurrogates[0] &&
					highSurrogates[1] == nextHighSurrogates[1]
				) {
					// Merge with the next item.
					if (dataIsSingleton(nextLowSurrogates)) {
						tmpLow = dataAdd(tmpLow, nextLowSurrogates[0]);
					} else {
						tmpLow = dataAddRange(
							tmpLow,
							nextLowSurrogates[0],
							nextLowSurrogates[1] - 1
						);
					}
					++index;
					mapping = surrogateMappings[index];
					highSurrogates = mapping[0];
					lowSurrogates = mapping[1];
					nextMapping = surrogateMappings[index + 1];
					nextHighSurrogates = nextMapping && nextMapping[0];
					nextLowSurrogates = nextMapping && nextMapping[1];
					addLow = true;
				}
				result.push([
					highSurrogates,
					addLow ? tmpLow : lowSurrogates
				]);
				addLow = false;
			}
			return optimizeByLowSurrogates(result);
		};
	
		var optimizeByLowSurrogates = function(surrogateMappings) {
			if (surrogateMappings.length == 1) {
				return surrogateMappings;
			}
			var index = -1;
			var innerIndex = -1;
			while (++index < surrogateMappings.length) {
				var mapping = surrogateMappings[index];
				var lowSurrogates = mapping[1];
				var lowSurrogateStart = lowSurrogates[0];
				var lowSurrogateEnd = lowSurrogates[1];
				innerIndex = index; // Note: the loop starts at the next index.
				while (++innerIndex < surrogateMappings.length) {
					var otherMapping = surrogateMappings[innerIndex];
					var otherLowSurrogates = otherMapping[1];
					var otherLowSurrogateStart = otherLowSurrogates[0];
					var otherLowSurrogateEnd = otherLowSurrogates[1];
					if (
						lowSurrogateStart == otherLowSurrogateStart &&
						lowSurrogateEnd == otherLowSurrogateEnd
					) {
						// Add the code points in the other item to this one.
						if (dataIsSingleton(otherMapping[0])) {
							mapping[0] = dataAdd(mapping[0], otherMapping[0][0]);
						} else {
							mapping[0] = dataAddRange(
								mapping[0],
								otherMapping[0][0],
								otherMapping[0][1] - 1
							);
						}
						// Remove the other, now redundant, item.
						surrogateMappings.splice(innerIndex, 1);
						--innerIndex;
					}
				}
			}
			return surrogateMappings;
		};
	
		var surrogateSet = function(data) {
			// Exit early if `data` is an empty set.
			if (!data.length) {
				return [];
			}
	
			// Iterate over the data per `(start, end)` pair.
			var index = 0;
			var start;
			var end;
			var startHigh;
			var startLow;
			var endHigh;
			var endLow;
			var surrogateMappings = [];
			var length = data.length;
			while (index < length) {
				start = data[index];
				end = data[index + 1] - 1;
	
				startHigh = highSurrogate(start);
				startLow = lowSurrogate(start);
				endHigh = highSurrogate(end);
				endLow = lowSurrogate(end);
	
				var startsWithLowestLowSurrogate = startLow == LOW_SURROGATE_MIN;
				var endsWithHighestLowSurrogate = endLow == LOW_SURROGATE_MAX;
				var complete = false;
	
				// Append the previous high-surrogate-to-low-surrogate mappings.
				// Step 1: `(startHigh, startLow)` to `(startHigh, LOW_SURROGATE_MAX)`.
				if (
					startHigh == endHigh ||
					startsWithLowestLowSurrogate && endsWithHighestLowSurrogate
				) {
					surrogateMappings.push([
						[startHigh, endHigh + 1],
						[startLow, endLow + 1]
					]);
					complete = true;
				} else {
					surrogateMappings.push([
						[startHigh, startHigh + 1],
						[startLow, LOW_SURROGATE_MAX + 1]
					]);
				}
	
				// Step 2: `(startHigh + 1, LOW_SURROGATE_MIN)` to
				// `(endHigh - 1, LOW_SURROGATE_MAX)`.
				if (!complete && startHigh + 1 < endHigh) {
					if (endsWithHighestLowSurrogate) {
						// Combine step 2 and step 3.
						surrogateMappings.push([
							[startHigh + 1, endHigh + 1],
							[LOW_SURROGATE_MIN, endLow + 1]
						]);
						complete = true;
					} else {
						surrogateMappings.push([
							[startHigh + 1, endHigh],
							[LOW_SURROGATE_MIN, LOW_SURROGATE_MAX + 1]
						]);
					}
				}
	
				// Step 3. `(endHigh, LOW_SURROGATE_MIN)` to `(endHigh, endLow)`.
				if (!complete) {
					surrogateMappings.push([
						[endHigh, endHigh + 1],
						[LOW_SURROGATE_MIN, endLow + 1]
					]);
				}
	
				index += 2;
			}
	
			// The format of `surrogateMappings` is as follows:
			//
			//     [ surrogateMapping1, surrogateMapping2 ]
			//
			// i.e.:
			//
			//     [
			//       [ highSurrogates1, lowSurrogates1 ],
			//       [ highSurrogates2, lowSurrogates2 ]
			//     ]
			return optimizeSurrogateMappings(surrogateMappings);
		};
	
		var createSurrogateCharacterClasses = function(surrogateMappings) {
			var result = [];
			forEach(surrogateMappings, function(surrogateMapping) {
				var highSurrogates = surrogateMapping[0];
				var lowSurrogates = surrogateMapping[1];
				result.push(
					createBMPCharacterClasses(highSurrogates) +
					createBMPCharacterClasses(lowSurrogates)
				);
			});
			return result.join('|');
		};
	
		var createCharacterClassesFromData = function(data, bmpOnly, hasUnicodeFlag) {
			if (hasUnicodeFlag) {
				return createUnicodeCharacterClasses(data);
			}
			var result = [];
	
			var parts = splitAtBMP(data);
			var loneHighSurrogates = parts.loneHighSurrogates;
			var loneLowSurrogates = parts.loneLowSurrogates;
			var bmp = parts.bmp;
			var astral = parts.astral;
			var hasLoneHighSurrogates = !dataIsEmpty(loneHighSurrogates);
			var hasLoneLowSurrogates = !dataIsEmpty(loneLowSurrogates);
	
			var surrogateMappings = surrogateSet(astral);
	
			if (bmpOnly) {
				bmp = dataAddData(bmp, loneHighSurrogates);
				hasLoneHighSurrogates = false;
				bmp = dataAddData(bmp, loneLowSurrogates);
				hasLoneLowSurrogates = false;
			}
	
			if (!dataIsEmpty(bmp)) {
				// The data set contains BMP code points that are not high surrogates
				// needed for astral code points in the set.
				result.push(createBMPCharacterClasses(bmp));
			}
			if (surrogateMappings.length) {
				// The data set contains astral code points; append character classes
				// based on their surrogate pairs.
				result.push(createSurrogateCharacterClasses(surrogateMappings));
			}
			// https://gist.github.com/mathiasbynens/bbe7f870208abcfec860
			if (hasLoneHighSurrogates) {
				result.push(
					createBMPCharacterClasses(loneHighSurrogates) +
					// Make sure the high surrogates aren’t part of a surrogate pair.
					'(?![\\uDC00-\\uDFFF])'
				);
			}
			if (hasLoneLowSurrogates) {
				result.push(
					// It is not possible to accurately assert the low surrogates aren’t
					// part of a surrogate pair, since JavaScript regular expressions do
					// not support lookbehind.
					'(?:[^\\uD800-\\uDBFF]|^)' +
					createBMPCharacterClasses(loneLowSurrogates)
				);
			}
			return result.join('|');
		};
	
		/*--------------------------------------------------------------------------*/
	
		// `regenerate` can be used as a constructor (and new methods can be added to
		// its prototype) but also as a regular function, the latter of which is the
		// documented and most common usage. For that reason, it’s not capitalized.
		var regenerate = function(value) {
			if (arguments.length > 1) {
				value = slice.call(arguments);
			}
			if (this instanceof regenerate) {
				this.data = [];
				return value ? this.add(value) : this;
			}
			return (new regenerate).add(value);
		};
	
		regenerate.version = '1.3.3';
	
		var proto = regenerate.prototype;
		extend(proto, {
			'add': function(value) {
				var $this = this;
				if (value == null) {
					return $this;
				}
				if (value instanceof regenerate) {
					// Allow passing other Regenerate instances.
					$this.data = dataAddData($this.data, value.data);
					return $this;
				}
				if (arguments.length > 1) {
					value = slice.call(arguments);
				}
				if (isArray(value)) {
					forEach(value, function(item) {
						$this.add(item);
					});
					return $this;
				}
				$this.data = dataAdd(
					$this.data,
					isNumber(value) ? value : symbolToCodePoint(value)
				);
				return $this;
			},
			'remove': function(value) {
				var $this = this;
				if (value == null) {
					return $this;
				}
				if (value instanceof regenerate) {
					// Allow passing other Regenerate instances.
					$this.data = dataRemoveData($this.data, value.data);
					return $this;
				}
				if (arguments.length > 1) {
					value = slice.call(arguments);
				}
				if (isArray(value)) {
					forEach(value, function(item) {
						$this.remove(item);
					});
					return $this;
				}
				$this.data = dataRemove(
					$this.data,
					isNumber(value) ? value : symbolToCodePoint(value)
				);
				return $this;
			},
			'addRange': function(start, end) {
				var $this = this;
				$this.data = dataAddRange($this.data,
					isNumber(start) ? start : symbolToCodePoint(start),
					isNumber(end) ? end : symbolToCodePoint(end)
				);
				return $this;
			},
			'removeRange': function(start, end) {
				var $this = this;
				var startCodePoint = isNumber(start) ? start : symbolToCodePoint(start);
				var endCodePoint = isNumber(end) ? end : symbolToCodePoint(end);
				$this.data = dataRemoveRange(
					$this.data,
					startCodePoint,
					endCodePoint
				);
				return $this;
			},
			'intersection': function(argument) {
				var $this = this;
				// Allow passing other Regenerate instances.
				// TODO: Optimize this by writing and using `dataIntersectionData()`.
				var array = argument instanceof regenerate ?
					dataToArray(argument.data) :
					argument;
				$this.data = dataIntersection($this.data, array);
				return $this;
			},
			'contains': function(codePoint) {
				return dataContains(
					this.data,
					isNumber(codePoint) ? codePoint : symbolToCodePoint(codePoint)
				);
			},
			'clone': function() {
				var set = new regenerate;
				set.data = this.data.slice(0);
				return set;
			},
			'toString': function(options) {
				var result = createCharacterClassesFromData(
					this.data,
					options ? options.bmpOnly : false,
					options ? options.hasUnicodeFlag : false
				);
				if (!result) {
					// For an empty set, return something that can be inserted `/here/` to
					// form a valid regular expression. Avoid `(?:)` since that matches the
					// empty string.
					return '[]';
				}
				// Use `\0` instead of `\x00` where possible.
				return result.replace(regexNull, '\\0$1');
			},
			'toRegExp': function(flags) {
				var pattern = this.toString(
					flags && flags.indexOf('u') != -1 ?
						{ 'hasUnicodeFlag': true } :
						null
				);
				return RegExp(pattern, flags || '');
			},
			'valueOf': function() { // Note: `valueOf` is aliased as `toArray`.
				return dataToArray(this.data);
			}
		});
	
		proto.toArray = proto.valueOf;
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return regenerate;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js, io.js, or RingoJS v0.8.0+
				freeModule.exports = regenerate;
			} else { // in Narwhal or RingoJS v0.7.0-
				freeExports.regenerate = regenerate;
			}
		} else { // in Rhino or a web browser
			root.regenerate = regenerate;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)(module), (function() { return this; }())))

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _stringify = __webpack_require__(168);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assert = __webpack_require__(275);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	var _leap = __webpack_require__(4456);
	
	var leap = _interopRequireWildcard(_leap);
	
	var _meta = __webpack_require__(4457);
	
	var meta = _interopRequireWildcard(_meta);
	
	var _util = __webpack_require__(343);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasOwn = Object.prototype.hasOwnProperty; /**
	                                               * Copyright (c) 2014, Facebook, Inc.
	                                               * All rights reserved.
	                                               *
	                                               * This source code is licensed under the BSD-style license found in the
	                                               * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	                                               * additional grant of patent rights can be found in the PATENTS file in
	                                               * the same directory.
	                                               */
	
	function Emitter(contextId) {
	  _assert2.default.ok(this instanceof Emitter);
	  t.assertIdentifier(contextId);
	
	  // Used to generate unique temporary names.
	  this.nextTempId = 0;
	
	  // In order to make sure the context object does not collide with
	  // anything in the local scope, we might have to rename it, so we
	  // refer to it symbolically instead of just assuming that it will be
	  // called "context".
	  this.contextId = contextId;
	
	  // An append-only list of Statements that grows each time this.emit is
	  // called.
	  this.listing = [];
	
	  // A sparse array whose keys correspond to locations in this.listing
	  // that have been marked as branch/jump targets.
	  this.marked = [true];
	
	  // The last location will be marked when this.getDispatchLoop is
	  // called.
	  this.finalLoc = loc();
	
	  // A list of all leap.TryEntry statements emitted.
	  this.tryEntries = [];
	
	  // Each time we evaluate the body of a loop, we tell this.leapManager
	  // to enter a nested loop context that determines the meaning of break
	  // and continue statements therein.
	  this.leapManager = new leap.LeapManager(this);
	}
	
	var Ep = Emitter.prototype;
	exports.Emitter = Emitter;
	
	// Offsets into this.listing that could be used as targets for branches or
	// jumps are represented as numeric Literal nodes. This representation has
	// the amazingly convenient benefit of allowing the exact value of the
	// location to be determined at any time, even after generating code that
	// refers to the location.
	function loc() {
	  return t.numericLiteral(-1);
	}
	
	// Sets the exact value of the given location to the offset of the next
	// Statement emitted.
	Ep.mark = function (loc) {
	  t.assertLiteral(loc);
	  var index = this.listing.length;
	  if (loc.value === -1) {
	    loc.value = index;
	  } else {
	    // Locations can be marked redundantly, but their values cannot change
	    // once set the first time.
	    _assert2.default.strictEqual(loc.value, index);
	  }
	  this.marked[index] = true;
	  return loc;
	};
	
	Ep.emit = function (node) {
	  if (t.isExpression(node)) {
	    node = t.expressionStatement(node);
	  }
	
	  t.assertStatement(node);
	  this.listing.push(node);
	};
	
	// Shorthand for emitting assignment statements. This will come in handy
	// for assignments to temporary variables.
	Ep.emitAssign = function (lhs, rhs) {
	  this.emit(this.assign(lhs, rhs));
	  return lhs;
	};
	
	// Shorthand for an assignment statement.
	Ep.assign = function (lhs, rhs) {
	  return t.expressionStatement(t.assignmentExpression("=", lhs, rhs));
	};
	
	// Convenience function for generating expressions like context.next,
	// context.sent, and context.rval.
	Ep.contextProperty = function (name, computed) {
	  return t.memberExpression(this.contextId, computed ? t.stringLiteral(name) : t.identifier(name), !!computed);
	};
	
	// Shorthand for setting context.rval and jumping to `context.stop()`.
	Ep.stop = function (rval) {
	  if (rval) {
	    this.setReturnValue(rval);
	  }
	
	  this.jump(this.finalLoc);
	};
	
	Ep.setReturnValue = function (valuePath) {
	  t.assertExpression(valuePath.value);
	
	  this.emitAssign(this.contextProperty("rval"), this.explodeExpression(valuePath));
	};
	
	Ep.clearPendingException = function (tryLoc, assignee) {
	  t.assertLiteral(tryLoc);
	
	  var catchCall = t.callExpression(this.contextProperty("catch", true), [tryLoc]);
	
	  if (assignee) {
	    this.emitAssign(assignee, catchCall);
	  } else {
	    this.emit(catchCall);
	  }
	};
	
	// Emits code for an unconditional jump to the given location, even if the
	// exact value of the location is not yet known.
	Ep.jump = function (toLoc) {
	  this.emitAssign(this.contextProperty("next"), toLoc);
	  this.emit(t.breakStatement());
	};
	
	// Conditional jump.
	Ep.jumpIf = function (test, toLoc) {
	  t.assertExpression(test);
	  t.assertLiteral(toLoc);
	
	  this.emit(t.ifStatement(test, t.blockStatement([this.assign(this.contextProperty("next"), toLoc), t.breakStatement()])));
	};
	
	// Conditional jump, with the condition negated.
	Ep.jumpIfNot = function (test, toLoc) {
	  t.assertExpression(test);
	  t.assertLiteral(toLoc);
	
	  var negatedTest = void 0;
	  if (t.isUnaryExpression(test) && test.operator === "!") {
	    // Avoid double negation.
	    negatedTest = test.argument;
	  } else {
	    negatedTest = t.unaryExpression("!", test);
	  }
	
	  this.emit(t.ifStatement(negatedTest, t.blockStatement([this.assign(this.contextProperty("next"), toLoc), t.breakStatement()])));
	};
	
	// Returns a unique MemberExpression that can be used to store and
	// retrieve temporary values. Since the object of the member expression is
	// the context object, which is presumed to coexist peacefully with all
	// other local variables, and since we just increment `nextTempId`
	// monotonically, uniqueness is assured.
	Ep.makeTempVar = function () {
	  return this.contextProperty("t" + this.nextTempId++);
	};
	
	Ep.getContextFunction = function (id) {
	  return t.functionExpression(id || null /*Anonymous*/
	  , [this.contextId], t.blockStatement([this.getDispatchLoop()]), false, // Not a generator anymore!
	  false // Nor an expression.
	  );
	};
	
	// Turns this.listing into a loop of the form
	//
	//   while (1) switch (context.next) {
	//   case 0:
	//   ...
	//   case n:
	//     return context.stop();
	//   }
	//
	// Each marked location in this.listing will correspond to one generated
	// case statement.
	Ep.getDispatchLoop = function () {
	  var self = this;
	  var cases = [];
	  var current = void 0;
	
	  // If we encounter a break, continue, or return statement in a switch
	  // case, we can skip the rest of the statements until the next case.
	  var alreadyEnded = false;
	
	  self.listing.forEach(function (stmt, i) {
	    if (self.marked.hasOwnProperty(i)) {
	      cases.push(t.switchCase(t.numericLiteral(i), current = []));
	      alreadyEnded = false;
	    }
	
	    if (!alreadyEnded) {
	      current.push(stmt);
	      if (t.isCompletionStatement(stmt)) alreadyEnded = true;
	    }
	  });
	
	  // Now that we know how many statements there will be in this.listing,
	  // we can finally resolve this.finalLoc.value.
	  this.finalLoc.value = this.listing.length;
	
	  cases.push(t.switchCase(this.finalLoc, [
	    // Intentionally fall through to the "end" case...
	  ]),
	
	  // So that the runtime can jump to the final location without having
	  // to know its offset, we provide the "end" case as a synonym.
	  t.switchCase(t.stringLiteral("end"), [
	  // This will check/clear both context.thrown and context.rval.
	  t.returnStatement(t.callExpression(this.contextProperty("stop"), []))]));
	
	  return t.whileStatement(t.numericLiteral(1), t.switchStatement(t.assignmentExpression("=", this.contextProperty("prev"), this.contextProperty("next")), cases));
	};
	
	Ep.getTryLocsList = function () {
	  if (this.tryEntries.length === 0) {
	    // To avoid adding a needless [] to the majority of runtime.wrap
	    // argument lists, force the caller to handle this case specially.
	    return null;
	  }
	
	  var lastLocValue = 0;
	
	  return t.arrayExpression(this.tryEntries.map(function (tryEntry) {
	    var thisLocValue = tryEntry.firstLoc.value;
	    _assert2.default.ok(thisLocValue >= lastLocValue, "try entries out of order");
	    lastLocValue = thisLocValue;
	
	    var ce = tryEntry.catchEntry;
	    var fe = tryEntry.finallyEntry;
	
	    var locs = [tryEntry.firstLoc,
	    // The null here makes a hole in the array.
	    ce ? ce.firstLoc : null];
	
	    if (fe) {
	      locs[2] = fe.firstLoc;
	      locs[3] = fe.afterLoc;
	    }
	
	    return t.arrayExpression(locs);
	  }));
	};
	
	// All side effects must be realized in order.
	
	// If any subexpression harbors a leap, all subexpressions must be
	// neutered of side effects.
	
	// No destructive modification of AST nodes.
	
	Ep.explode = function (path, ignoreResult) {
	  var node = path.node;
	  var self = this;
	
	  t.assertNode(node);
	
	  if (t.isDeclaration(node)) throw getDeclError(node);
	
	  if (t.isStatement(node)) return self.explodeStatement(path);
	
	  if (t.isExpression(node)) return self.explodeExpression(path, ignoreResult);
	
	  switch (node.type) {
	    case "Program":
	      return path.get("body").map(self.explodeStatement, self);
	
	    case "VariableDeclarator":
	      throw getDeclError(node);
	
	    // These node types should be handled by their parent nodes
	    // (ObjectExpression, SwitchStatement, and TryStatement, respectively).
	    case "Property":
	    case "SwitchCase":
	    case "CatchClause":
	      throw new Error(node.type + " nodes should be handled by their parents");
	
	    default:
	      throw new Error("unknown Node of type " + (0, _stringify2.default)(node.type));
	  }
	};
	
	function getDeclError(node) {
	  return new Error("all declarations should have been transformed into " + "assignments before the Exploder began its work: " + (0, _stringify2.default)(node));
	}
	
	Ep.explodeStatement = function (path, labelId) {
	  var stmt = path.node;
	  var self = this;
	  var before = void 0,
	      after = void 0,
	      head = void 0;
	
	  t.assertStatement(stmt);
	
	  if (labelId) {
	    t.assertIdentifier(labelId);
	  } else {
	    labelId = null;
	  }
	
	  // Explode BlockStatement nodes even if they do not contain a yield,
	  // because we don't want or need the curly braces.
	  if (t.isBlockStatement(stmt)) {
	    path.get("body").forEach(function (path) {
	      self.explodeStatement(path);
	    });
	    return;
	  }
	
	  if (!meta.containsLeap(stmt)) {
	    // Technically we should be able to avoid emitting the statement
	    // altogether if !meta.hasSideEffects(stmt), but that leads to
	    // confusing generated code (for instance, `while (true) {}` just
	    // disappears) and is probably a more appropriate job for a dedicated
	    // dead code elimination pass.
	    self.emit(stmt);
	    return;
	  }
	
	  switch (stmt.type) {
	    case "ExpressionStatement":
	      self.explodeExpression(path.get("expression"), true);
	      break;
	
	    case "LabeledStatement":
	      after = loc();
	
	      // Did you know you can break from any labeled block statement or
	      // control structure? Well, you can! Note: when a labeled loop is
	      // encountered, the leap.LabeledEntry created here will immediately
	      // enclose a leap.LoopEntry on the leap manager's stack, and both
	      // entries will have the same label. Though this works just fine, it
	      // may seem a bit redundant. In theory, we could check here to
	      // determine if stmt knows how to handle its own label; for example,
	      // stmt happens to be a WhileStatement and so we know it's going to
	      // establish its own LoopEntry when we explode it (below). Then this
	      // LabeledEntry would be unnecessary. Alternatively, we might be
	      // tempted not to pass stmt.label down into self.explodeStatement,
	      // because we've handled the label here, but that's a mistake because
	      // labeled loops may contain labeled continue statements, which is not
	      // something we can handle in this generic case. All in all, I think a
	      // little redundancy greatly simplifies the logic of this case, since
	      // it's clear that we handle all possible LabeledStatements correctly
	      // here, regardless of whether they interact with the leap manager
	      // themselves. Also remember that labels and break/continue-to-label
	      // statements are rare, and all of this logic happens at transform
	      // time, so it has no additional runtime cost.
	      self.leapManager.withEntry(new leap.LabeledEntry(after, stmt.label), function () {
	        self.explodeStatement(path.get("body"), stmt.label);
	      });
	
	      self.mark(after);
	
	      break;
	
	    case "WhileStatement":
	      before = loc();
	      after = loc();
	
	      self.mark(before);
	      self.jumpIfNot(self.explodeExpression(path.get("test")), after);
	      self.leapManager.withEntry(new leap.LoopEntry(after, before, labelId), function () {
	        self.explodeStatement(path.get("body"));
	      });
	      self.jump(before);
	      self.mark(after);
	
	      break;
	
	    case "DoWhileStatement":
	      var first = loc();
	      var test = loc();
	      after = loc();
	
	      self.mark(first);
	      self.leapManager.withEntry(new leap.LoopEntry(after, test, labelId), function () {
	        self.explode(path.get("body"));
	      });
	      self.mark(test);
	      self.jumpIf(self.explodeExpression(path.get("test")), first);
	      self.mark(after);
	
	      break;
	
	    case "ForStatement":
	      head = loc();
	      var update = loc();
	      after = loc();
	
	      if (stmt.init) {
	        // We pass true here to indicate that if stmt.init is an expression
	        // then we do not care about its result.
	        self.explode(path.get("init"), true);
	      }
	
	      self.mark(head);
	
	      if (stmt.test) {
	        self.jumpIfNot(self.explodeExpression(path.get("test")), after);
	      } else {
	        // No test means continue unconditionally.
	      }
	
	      self.leapManager.withEntry(new leap.LoopEntry(after, update, labelId), function () {
	        self.explodeStatement(path.get("body"));
	      });
	
	      self.mark(update);
	
	      if (stmt.update) {
	        // We pass true here to indicate that if stmt.update is an
	        // expression then we do not care about its result.
	        self.explode(path.get("update"), true);
	      }
	
	      self.jump(head);
	
	      self.mark(after);
	
	      break;
	
	    case "TypeCastExpression":
	      return self.explodeExpression(path.get("expression"));
	
	    case "ForInStatement":
	      head = loc();
	      after = loc();
	
	      var keyIterNextFn = self.makeTempVar();
	      self.emitAssign(keyIterNextFn, t.callExpression(util.runtimeProperty("keys"), [self.explodeExpression(path.get("right"))]));
	
	      self.mark(head);
	
	      var keyInfoTmpVar = self.makeTempVar();
	      self.jumpIf(t.memberExpression(t.assignmentExpression("=", keyInfoTmpVar, t.callExpression(keyIterNextFn, [])), t.identifier("done"), false), after);
	
	      self.emitAssign(stmt.left, t.memberExpression(keyInfoTmpVar, t.identifier("value"), false));
	
	      self.leapManager.withEntry(new leap.LoopEntry(after, head, labelId), function () {
	        self.explodeStatement(path.get("body"));
	      });
	
	      self.jump(head);
	
	      self.mark(after);
	
	      break;
	
	    case "BreakStatement":
	      self.emitAbruptCompletion({
	        type: "break",
	        target: self.leapManager.getBreakLoc(stmt.label)
	      });
	
	      break;
	
	    case "ContinueStatement":
	      self.emitAbruptCompletion({
	        type: "continue",
	        target: self.leapManager.getContinueLoc(stmt.label)
	      });
	
	      break;
	
	    case "SwitchStatement":
	      // Always save the discriminant into a temporary variable in case the
	      // test expressions overwrite values like context.sent.
	      var disc = self.emitAssign(self.makeTempVar(), self.explodeExpression(path.get("discriminant")));
	
	      after = loc();
	      var defaultLoc = loc();
	      var condition = defaultLoc;
	      var caseLocs = [];
	
	      // If there are no cases, .cases might be undefined.
	      var cases = stmt.cases || [];
	
	      for (var i = cases.length - 1; i >= 0; --i) {
	        var c = cases[i];
	        t.assertSwitchCase(c);
	
	        if (c.test) {
	          condition = t.conditionalExpression(t.binaryExpression("===", disc, c.test), caseLocs[i] = loc(), condition);
	        } else {
	          caseLocs[i] = defaultLoc;
	        }
	      }
	
	      var discriminant = path.get("discriminant");
	      util.replaceWithOrRemove(discriminant, condition);
	      self.jump(self.explodeExpression(discriminant));
	
	      self.leapManager.withEntry(new leap.SwitchEntry(after), function () {
	        path.get("cases").forEach(function (casePath) {
	          var i = casePath.key;
	          self.mark(caseLocs[i]);
	
	          casePath.get("consequent").forEach(function (path) {
	            self.explodeStatement(path);
	          });
	        });
	      });
	
	      self.mark(after);
	      if (defaultLoc.value === -1) {
	        self.mark(defaultLoc);
	        _assert2.default.strictEqual(after.value, defaultLoc.value);
	      }
	
	      break;
	
	    case "IfStatement":
	      var elseLoc = stmt.alternate && loc();
	      after = loc();
	
	      self.jumpIfNot(self.explodeExpression(path.get("test")), elseLoc || after);
	
	      self.explodeStatement(path.get("consequent"));
	
	      if (elseLoc) {
	        self.jump(after);
	        self.mark(elseLoc);
	        self.explodeStatement(path.get("alternate"));
	      }
	
	      self.mark(after);
	
	      break;
	
	    case "ReturnStatement":
	      self.emitAbruptCompletion({
	        type: "return",
	        value: self.explodeExpression(path.get("argument"))
	      });
	
	      break;
	
	    case "WithStatement":
	      throw new Error("WithStatement not supported in generator functions.");
	
	    case "TryStatement":
	      after = loc();
	
	      var handler = stmt.handler;
	
	      var catchLoc = handler && loc();
	      var catchEntry = catchLoc && new leap.CatchEntry(catchLoc, handler.param);
	
	      var finallyLoc = stmt.finalizer && loc();
	      var finallyEntry = finallyLoc && new leap.FinallyEntry(finallyLoc, after);
	
	      var tryEntry = new leap.TryEntry(self.getUnmarkedCurrentLoc(), catchEntry, finallyEntry);
	
	      self.tryEntries.push(tryEntry);
	      self.updateContextPrevLoc(tryEntry.firstLoc);
	
	      self.leapManager.withEntry(tryEntry, function () {
	        self.explodeStatement(path.get("block"));
	
	        if (catchLoc) {
	          if (finallyLoc) {
	            // If we have both a catch block and a finally block, then
	            // because we emit the catch block first, we need to jump over
	            // it to the finally block.
	            self.jump(finallyLoc);
	          } else {
	            // If there is no finally block, then we need to jump over the
	            // catch block to the fall-through location.
	            self.jump(after);
	          }
	
	          self.updateContextPrevLoc(self.mark(catchLoc));
	
	          var bodyPath = path.get("handler.body");
	          var safeParam = self.makeTempVar();
	          self.clearPendingException(tryEntry.firstLoc, safeParam);
	
	          bodyPath.traverse(catchParamVisitor, {
	            safeParam: safeParam,
	            catchParamName: handler.param.name
	          });
	
	          self.leapManager.withEntry(catchEntry, function () {
	            self.explodeStatement(bodyPath);
	          });
	        }
	
	        if (finallyLoc) {
	          self.updateContextPrevLoc(self.mark(finallyLoc));
	
	          self.leapManager.withEntry(finallyEntry, function () {
	            self.explodeStatement(path.get("finalizer"));
	          });
	
	          self.emit(t.returnStatement(t.callExpression(self.contextProperty("finish"), [finallyEntry.firstLoc])));
	        }
	      });
	
	      self.mark(after);
	
	      break;
	
	    case "ThrowStatement":
	      self.emit(t.throwStatement(self.explodeExpression(path.get("argument"))));
	
	      break;
	
	    default:
	      throw new Error("unknown Statement of type " + (0, _stringify2.default)(stmt.type));
	  }
	};
	
	var catchParamVisitor = {
	  Identifier: function Identifier(path, state) {
	    if (path.node.name === state.catchParamName && util.isReference(path)) {
	      util.replaceWithOrRemove(path, state.safeParam);
	    }
	  },
	
	  Scope: function Scope(path, state) {
	    if (path.scope.hasOwnBinding(state.catchParamName)) {
	      // Don't descend into nested scopes that shadow the catch
	      // parameter with their own declarations.
	      path.skip();
	    }
	  }
	};
	
	Ep.emitAbruptCompletion = function (record) {
	  if (!isValidCompletion(record)) {
	    _assert2.default.ok(false, "invalid completion record: " + (0, _stringify2.default)(record));
	  }
	
	  _assert2.default.notStrictEqual(record.type, "normal", "normal completions are not abrupt");
	
	  var abruptArgs = [t.stringLiteral(record.type)];
	
	  if (record.type === "break" || record.type === "continue") {
	    t.assertLiteral(record.target);
	    abruptArgs[1] = record.target;
	  } else if (record.type === "return" || record.type === "throw") {
	    if (record.value) {
	      t.assertExpression(record.value);
	      abruptArgs[1] = record.value;
	    }
	  }
	
	  this.emit(t.returnStatement(t.callExpression(this.contextProperty("abrupt"), abruptArgs)));
	};
	
	function isValidCompletion(record) {
	  var type = record.type;
	
	  if (type === "normal") {
	    return !hasOwn.call(record, "target");
	  }
	
	  if (type === "break" || type === "continue") {
	    return !hasOwn.call(record, "value") && t.isLiteral(record.target);
	  }
	
	  if (type === "return" || type === "throw") {
	    return hasOwn.call(record, "value") && !hasOwn.call(record, "target");
	  }
	
	  return false;
	}
	
	// Not all offsets into emitter.listing are potential jump targets. For
	// example, execution typically falls into the beginning of a try block
	// without jumping directly there. This method returns the current offset
	// without marking it, so that a switch case will not necessarily be
	// generated for this offset (I say "not necessarily" because the same
	// location might end up being marked in the process of emitting other
	// statements). There's no logical harm in marking such locations as jump
	// targets, but minimizing the number of switch cases keeps the generated
	// code shorter.
	Ep.getUnmarkedCurrentLoc = function () {
	  return t.numericLiteral(this.listing.length);
	};
	
	// The context.prev property takes the value of context.next whenever we
	// evaluate the switch statement discriminant, which is generally good
	// enough for tracking the last location we jumped to, but sometimes
	// context.prev needs to be more precise, such as when we fall
	// successfully out of a try block and into a finally block without
	// jumping. This method exists to update context.prev to the freshest
	// available location. If we were implementing a full interpreter, we
	// would know the location of the current instruction with complete
	// precision at all times, but we don't have that luxury here, as it would
	// be costly and verbose to set context.prev before every statement.
	Ep.updateContextPrevLoc = function (loc) {
	  if (loc) {
	    t.assertLiteral(loc);
	
	    if (loc.value === -1) {
	      // If an uninitialized location literal was passed in, set its value
	      // to the current this.listing.length.
	      loc.value = this.listing.length;
	    } else {
	      // Otherwise assert that the location matches the current offset.
	      _assert2.default.strictEqual(loc.value, this.listing.length);
	    }
	  } else {
	    loc = this.getUnmarkedCurrentLoc();
	  }
	
	  // Make sure context.prev is up to date in case we fell into this try
	  // statement without jumping to it. TODO Consider avoiding this
	  // assignment when we know control must have jumped here.
	  this.emitAssign(this.contextProperty("prev"), loc);
	};
	
	Ep.explodeExpression = function (path, ignoreResult) {
	  var expr = path.node;
	  if (expr) {
	    t.assertExpression(expr);
	  } else {
	    return expr;
	  }
	
	  var self = this;
	  var result = void 0; // Used optionally by several cases below.
	  var after = void 0;
	
	  function finish(expr) {
	    t.assertExpression(expr);
	    if (ignoreResult) {
	      self.emit(expr);
	    } else {
	      return expr;
	    }
	  }
	
	  // If the expression does not contain a leap, then we either emit the
	  // expression as a standalone statement or return it whole.
	  if (!meta.containsLeap(expr)) {
	    return finish(expr);
	  }
	
	  // If any child contains a leap (such as a yield or labeled continue or
	  // break statement), then any sibling subexpressions will almost
	  // certainly have to be exploded in order to maintain the order of their
	  // side effects relative to the leaping child(ren).
	  var hasLeapingChildren = meta.containsLeap.onlyChildren(expr);
	
	  // In order to save the rest of explodeExpression from a combinatorial
	  // trainwreck of special cases, explodeViaTempVar is responsible for
	  // deciding when a subexpression needs to be "exploded," which is my
	  // very technical term for emitting the subexpression as an assignment
	  // to a temporary variable and the substituting the temporary variable
	  // for the original subexpression. Think of exploded view diagrams, not
	  // Michael Bay movies. The point of exploding subexpressions is to
	  // control the precise order in which the generated code realizes the
	  // side effects of those subexpressions.
	  function explodeViaTempVar(tempVar, childPath, ignoreChildResult) {
	    _assert2.default.ok(!ignoreChildResult || !tempVar, "Ignoring the result of a child expression but forcing it to " + "be assigned to a temporary variable?");
	
	    var result = self.explodeExpression(childPath, ignoreChildResult);
	
	    if (ignoreChildResult) {
	      // Side effects already emitted above.
	
	    } else if (tempVar || hasLeapingChildren && !t.isLiteral(result)) {
	      // If tempVar was provided, then the result will always be assigned
	      // to it, even if the result does not otherwise need to be assigned
	      // to a temporary variable.  When no tempVar is provided, we have
	      // the flexibility to decide whether a temporary variable is really
	      // necessary.  Unfortunately, in general, a temporary variable is
	      // required whenever any child contains a yield expression, since it
	      // is difficult to prove (at all, let alone efficiently) whether
	      // this result would evaluate to the same value before and after the
	      // yield (see #206).  One narrow case where we can prove it doesn't
	      // matter (and thus we do not need a temporary variable) is when the
	      // result in question is a Literal value.
	      result = self.emitAssign(tempVar || self.makeTempVar(), result);
	    }
	    return result;
	  }
	
	  // If ignoreResult is true, then we must take full responsibility for
	  // emitting the expression with all its side effects, and we should not
	  // return a result.
	
	  switch (expr.type) {
	    case "MemberExpression":
	      return finish(t.memberExpression(self.explodeExpression(path.get("object")), expr.computed ? explodeViaTempVar(null, path.get("property")) : expr.property, expr.computed));
	
	    case "CallExpression":
	      var calleePath = path.get("callee");
	      var argsPath = path.get("arguments");
	
	      var newCallee = void 0;
	      var newArgs = [];
	
	      var hasLeapingArgs = false;
	      argsPath.forEach(function (argPath) {
	        hasLeapingArgs = hasLeapingArgs || meta.containsLeap(argPath.node);
	      });
	
	      if (t.isMemberExpression(calleePath.node)) {
	        if (hasLeapingArgs) {
	          // If the arguments of the CallExpression contained any yield
	          // expressions, then we need to be sure to evaluate the callee
	          // before evaluating the arguments, but if the callee was a member
	          // expression, then we must be careful that the object of the
	          // member expression still gets bound to `this` for the call.
	
	          var newObject = explodeViaTempVar(
	          // Assign the exploded callee.object expression to a temporary
	          // variable so that we can use it twice without reevaluating it.
	          self.makeTempVar(), calleePath.get("object"));
	
	          var newProperty = calleePath.node.computed ? explodeViaTempVar(null, calleePath.get("property")) : calleePath.node.property;
	
	          newArgs.unshift(newObject);
	
	          newCallee = t.memberExpression(t.memberExpression(newObject, newProperty, calleePath.node.computed), t.identifier("call"), false);
	        } else {
	          newCallee = self.explodeExpression(calleePath);
	        }
	      } else {
	        newCallee = explodeViaTempVar(null, calleePath);
	
	        if (t.isMemberExpression(newCallee)) {
	          // If the callee was not previously a MemberExpression, then the
	          // CallExpression was "unqualified," meaning its `this` object
	          // should be the global object. If the exploded expression has
	          // become a MemberExpression (e.g. a context property, probably a
	          // temporary variable), then we need to force it to be unqualified
	          // by using the (0, object.property)(...) trick; otherwise, it
	          // will receive the object of the MemberExpression as its `this`
	          // object.
	          newCallee = t.sequenceExpression([t.numericLiteral(0), newCallee]);
	        }
	      }
	
	      argsPath.forEach(function (argPath) {
	        newArgs.push(explodeViaTempVar(null, argPath));
	      });
	
	      return finish(t.callExpression(newCallee, newArgs));
	
	    case "NewExpression":
	      return finish(t.newExpression(explodeViaTempVar(null, path.get("callee")), path.get("arguments").map(function (argPath) {
	        return explodeViaTempVar(null, argPath);
	      })));
	
	    case "ObjectExpression":
	      return finish(t.objectExpression(path.get("properties").map(function (propPath) {
	        if (propPath.isObjectProperty()) {
	          return t.objectProperty(propPath.node.key, explodeViaTempVar(null, propPath.get("value")), propPath.node.computed);
	        } else {
	          return propPath.node;
	        }
	      })));
	
	    case "ArrayExpression":
	      return finish(t.arrayExpression(path.get("elements").map(function (elemPath) {
	        return explodeViaTempVar(null, elemPath);
	      })));
	
	    case "SequenceExpression":
	      var lastIndex = expr.expressions.length - 1;
	
	      path.get("expressions").forEach(function (exprPath) {
	        if (exprPath.key === lastIndex) {
	          result = self.explodeExpression(exprPath, ignoreResult);
	        } else {
	          self.explodeExpression(exprPath, true);
	        }
	      });
	
	      return result;
	
	    case "LogicalExpression":
	      after = loc();
	
	      if (!ignoreResult) {
	        result = self.makeTempVar();
	      }
	
	      var left = explodeViaTempVar(result, path.get("left"));
	
	      if (expr.operator === "&&") {
	        self.jumpIfNot(left, after);
	      } else {
	        _assert2.default.strictEqual(expr.operator, "||");
	        self.jumpIf(left, after);
	      }
	
	      explodeViaTempVar(result, path.get("right"), ignoreResult);
	
	      self.mark(after);
	
	      return result;
	
	    case "ConditionalExpression":
	      var elseLoc = loc();
	      after = loc();
	      var test = self.explodeExpression(path.get("test"));
	
	      self.jumpIfNot(test, elseLoc);
	
	      if (!ignoreResult) {
	        result = self.makeTempVar();
	      }
	
	      explodeViaTempVar(result, path.get("consequent"), ignoreResult);
	      self.jump(after);
	
	      self.mark(elseLoc);
	      explodeViaTempVar(result, path.get("alternate"), ignoreResult);
	
	      self.mark(after);
	
	      return result;
	
	    case "UnaryExpression":
	      return finish(t.unaryExpression(expr.operator,
	      // Can't (and don't need to) break up the syntax of the argument.
	      // Think about delete a[b].
	      self.explodeExpression(path.get("argument")), !!expr.prefix));
	
	    case "BinaryExpression":
	      return finish(t.binaryExpression(expr.operator, explodeViaTempVar(null, path.get("left")), explodeViaTempVar(null, path.get("right"))));
	
	    case "AssignmentExpression":
	      return finish(t.assignmentExpression(expr.operator, self.explodeExpression(path.get("left")), self.explodeExpression(path.get("right"))));
	
	    case "UpdateExpression":
	      return finish(t.updateExpression(expr.operator, self.explodeExpression(path.get("argument")), expr.prefix));
	
	    case "YieldExpression":
	      after = loc();
	      var arg = expr.argument && self.explodeExpression(path.get("argument"));
	
	      if (arg && expr.delegate) {
	        var _result = self.makeTempVar();
	
	        self.emit(t.returnStatement(t.callExpression(self.contextProperty("delegateYield"), [arg, t.stringLiteral(_result.property.name), after])));
	
	        self.mark(after);
	
	        return _result;
	      }
	
	      self.emitAssign(self.contextProperty("next"), after);
	      self.emit(t.returnStatement(arg || null));
	      self.mark(after);
	
	      return self.contextProperty("sent");
	
	    default:
	      throw new Error("unknown Expression of type " + (0, _stringify2.default)(expr.type));
	  }
	};

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(30);
	var ObjectUnsubscribedError_1 = __webpack_require__(358);
	/**
	 * @class BehaviorSubject<T>
	 */
	var BehaviorSubject = (function (_super) {
	    __extends(BehaviorSubject, _super);
	    function BehaviorSubject(_value) {
	        _super.call(this);
	        this._value = _value;
	    }
	    Object.defineProperty(BehaviorSubject.prototype, "value", {
	        get: function () {
	            return this.getValue();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BehaviorSubject.prototype._subscribe = function (subscriber) {
	        var subscription = _super.prototype._subscribe.call(this, subscriber);
	        if (subscription && !subscription.closed) {
	            subscriber.next(this._value);
	        }
	        return subscription;
	    };
	    BehaviorSubject.prototype.getValue = function () {
	        if (this.hasError) {
	            throw this.thrownError;
	        }
	        else if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else {
	            return this._value;
	        }
	    };
	    BehaviorSubject.prototype.next = function (value) {
	        _super.prototype.next.call(this, this._value = value);
	    };
	    return BehaviorSubject;
	}(Subject_1.Subject));
	exports.BehaviorSubject = BehaviorSubject;
	//# sourceMappingURL=BehaviorSubject.js.map

/***/ }),
/* 760 */
/***/ (function(module, exports) {

	"use strict";
	exports.empty = {
	    closed: true,
	    next: function (value) { },
	    error: function (err) { throw err; },
	    complete: function () { }
	};
	//# sourceMappingURL=Observer.js.map

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(31);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SubjectSubscription = (function (_super) {
	    __extends(SubjectSubscription, _super);
	    function SubjectSubscription(subject, subscriber) {
	        _super.call(this);
	        this.subject = subject;
	        this.subscriber = subscriber;
	        this.closed = false;
	    }
	    SubjectSubscription.prototype.unsubscribe = function () {
	        if (this.closed) {
	            return;
	        }
	        this.closed = true;
	        var subject = this.subject;
	        var observers = subject.observers;
	        this.subject = null;
	        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
	            return;
	        }
	        var subscriberIndex = observers.indexOf(this.subscriber);
	        if (subscriberIndex !== -1) {
	            observers.splice(subscriberIndex, 1);
	        }
	    };
	    return SubjectSubscription;
	}(Subscription_1.Subscription));
	exports.SubjectSubscription = SubjectSubscription;
	//# sourceMappingURL=SubjectSubscription.js.map

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(30);
	var Observable_1 = __webpack_require__(4);
	var Subscriber_1 = __webpack_require__(11);
	var Subscription_1 = __webpack_require__(31);
	var refCount_1 = __webpack_require__(518);
	/**
	 * @class ConnectableObservable<T>
	 */
	var ConnectableObservable = (function (_super) {
	    __extends(ConnectableObservable, _super);
	    function ConnectableObservable(source, subjectFactory) {
	        _super.call(this);
	        this.source = source;
	        this.subjectFactory = subjectFactory;
	        this._refCount = 0;
	        this._isComplete = false;
	    }
	    ConnectableObservable.prototype._subscribe = function (subscriber) {
	        return this.getSubject().subscribe(subscriber);
	    };
	    ConnectableObservable.prototype.getSubject = function () {
	        var subject = this._subject;
	        if (!subject || subject.isStopped) {
	            this._subject = this.subjectFactory();
	        }
	        return this._subject;
	    };
	    ConnectableObservable.prototype.connect = function () {
	        var connection = this._connection;
	        if (!connection) {
	            this._isComplete = false;
	            connection = this._connection = new Subscription_1.Subscription();
	            connection.add(this.source
	                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
	            if (connection.closed) {
	                this._connection = null;
	                connection = Subscription_1.Subscription.EMPTY;
	            }
	            else {
	                this._connection = connection;
	            }
	        }
	        return connection;
	    };
	    ConnectableObservable.prototype.refCount = function () {
	        return refCount_1.refCount()(this);
	    };
	    return ConnectableObservable;
	}(Observable_1.Observable));
	exports.ConnectableObservable = ConnectableObservable;
	var connectableProto = ConnectableObservable.prototype;
	exports.connectableObservableDescriptor = {
	    operator: { value: null },
	    _refCount: { value: 0, writable: true },
	    _subject: { value: null, writable: true },
	    _connection: { value: null, writable: true },
	    _subscribe: { value: connectableProto._subscribe },
	    _isComplete: { value: connectableProto._isComplete, writable: true },
	    getSubject: { value: connectableProto.getSubject },
	    connect: { value: connectableProto.connect },
	    refCount: { value: connectableProto.refCount }
	};
	var ConnectableSubscriber = (function (_super) {
	    __extends(ConnectableSubscriber, _super);
	    function ConnectableSubscriber(destination, connectable) {
	        _super.call(this, destination);
	        this.connectable = connectable;
	    }
	    ConnectableSubscriber.prototype._error = function (err) {
	        this._unsubscribe();
	        _super.prototype._error.call(this, err);
	    };
	    ConnectableSubscriber.prototype._complete = function () {
	        this.connectable._isComplete = true;
	        this._unsubscribe();
	        _super.prototype._complete.call(this);
	    };
	    ConnectableSubscriber.prototype._unsubscribe = function () {
	        var connectable = this.connectable;
	        if (connectable) {
	            this.connectable = null;
	            var connection = connectable._connection;
	            connectable._refCount = 0;
	            connectable._subject = null;
	            connectable._connection = null;
	            if (connection) {
	                connection.unsubscribe();
	            }
	        }
	    };
	    return ConnectableSubscriber;
	}(Subject_1.SubjectSubscriber));
	var RefCountOperator = (function () {
	    function RefCountOperator(connectable) {
	        this.connectable = connectable;
	    }
	    RefCountOperator.prototype.call = function (subscriber, source) {
	        var connectable = this.connectable;
	        connectable._refCount++;
	        var refCounter = new RefCountSubscriber(subscriber, connectable);
	        var subscription = source.subscribe(refCounter);
	        if (!refCounter.closed) {
	            refCounter.connection = connectable.connect();
	        }
	        return subscription;
	    };
	    return RefCountOperator;
	}());
	var RefCountSubscriber = (function (_super) {
	    __extends(RefCountSubscriber, _super);
	    function RefCountSubscriber(destination, connectable) {
	        _super.call(this, destination);
	        this.connectable = connectable;
	    }
	    RefCountSubscriber.prototype._unsubscribe = function () {
	        var connectable = this.connectable;
	        if (!connectable) {
	            this.connection = null;
	            return;
	        }
	        this.connectable = null;
	        var refCount = connectable._refCount;
	        if (refCount <= 0) {
	            this.connection = null;
	            return;
	        }
	        connectable._refCount = refCount - 1;
	        if (refCount > 1) {
	            this.connection = null;
	            return;
	        }
	        ///
	        // Compare the local RefCountSubscriber's connection Subscription to the
	        // connection Subscription on the shared ConnectableObservable. In cases
	        // where the ConnectableObservable source synchronously emits values, and
	        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
	        // execution continues to here before the RefCountOperator has a chance to
	        // supply the RefCountSubscriber with the shared connection Subscription.
	        // For example:
	        // ```
	        // Observable.range(0, 10)
	        //   .publish()
	        //   .refCount()
	        //   .take(5)
	        //   .subscribe();
	        // ```
	        // In order to account for this case, RefCountSubscriber should only dispose
	        // the ConnectableObservable's shared connection Subscription if the
	        // connection Subscription exists, *and* either:
	        //   a. RefCountSubscriber doesn't have a reference to the shared connection
	        //      Subscription yet, or,
	        //   b. RefCountSubscriber's connection Subscription reference is identical
	        //      to the shared connection Subscription
	        ///
	        var connection = this.connection;
	        var sharedConnection = connectable._connection;
	        this.connection = null;
	        if (sharedConnection && (!connection || sharedConnection === connection)) {
	            sharedConnection.unsubscribe();
	        }
	    };
	    return RefCountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=ConnectableObservable.js.map

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isArray_1 = __webpack_require__(81);
	var isArrayLike_1 = __webpack_require__(856);
	var isPromise_1 = __webpack_require__(522);
	var PromiseObservable_1 = __webpack_require__(764);
	var IteratorObservable_1 = __webpack_require__(4612);
	var ArrayObservable_1 = __webpack_require__(118);
	var ArrayLikeObservable_1 = __webpack_require__(4601);
	var iterator_1 = __webpack_require__(270);
	var Observable_1 = __webpack_require__(4);
	var observeOn_1 = __webpack_require__(350);
	var observable_1 = __webpack_require__(355);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var FromObservable = (function (_super) {
	    __extends(FromObservable, _super);
	    function FromObservable(ish, scheduler) {
	        _super.call(this, null);
	        this.ish = ish;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable from an Array, an array-like object, a Promise, an
	     * iterable object, or an Observable-like object.
	     *
	     * <span class="informal">Converts almost anything to an Observable.</span>
	     *
	     * <img src="./img/from.png" width="100%">
	     *
	     * Convert various other objects and data types into Observables. `from`
	     * converts a Promise or an array-like or an
	     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
	     * object into an Observable that emits the items in that promise or array or
	     * iterable. A String, in this context, is treated as an array of characters.
	     * Observable-like objects (contains a function named with the ES2015 Symbol
	     * for Observable) can also be converted through this operator.
	     *
	     * @example <caption>Converts an array to an Observable</caption>
	     * var array = [10, 20, 30];
	     * var result = Rx.Observable.from(array);
	     * result.subscribe(x => console.log(x));
	     *
	     * // Results in the following:
	     * // 10 20 30
	     *
	     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
	     * function* generateDoubles(seed) {
	     *   var i = seed;
	     *   while (true) {
	     *     yield i;
	     *     i = 2 * i; // double it
	     *   }
	     * }
	     *
	     * var iterator = generateDoubles(3);
	     * var result = Rx.Observable.from(iterator).take(10);
	     * result.subscribe(x => console.log(x));
	     *
	     * // Results in the following:
	     * // 3 6 12 24 48 96 192 384 768 1536
	     *
	     * @see {@link create}
	     * @see {@link fromEvent}
	     * @see {@link fromEventPattern}
	     * @see {@link fromPromise}
	     *
	     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
	     * Observable-like, an Array, an iterable or an array-like object to be
	     * converted.
	     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
	     * emissions of values.
	     * @return {Observable<T>} The Observable whose values are originally from the
	     * input object that was converted.
	     * @static true
	     * @name from
	     * @owner Observable
	     */
	    FromObservable.create = function (ish, scheduler) {
	        if (ish != null) {
	            if (typeof ish[observable_1.observable] === 'function') {
	                if (ish instanceof Observable_1.Observable && !scheduler) {
	                    return ish;
	                }
	                return new FromObservable(ish, scheduler);
	            }
	            else if (isArray_1.isArray(ish)) {
	                return new ArrayObservable_1.ArrayObservable(ish, scheduler);
	            }
	            else if (isPromise_1.isPromise(ish)) {
	                return new PromiseObservable_1.PromiseObservable(ish, scheduler);
	            }
	            else if (typeof ish[iterator_1.iterator] === 'function' || typeof ish === 'string') {
	                return new IteratorObservable_1.IteratorObservable(ish, scheduler);
	            }
	            else if (isArrayLike_1.isArrayLike(ish)) {
	                return new ArrayLikeObservable_1.ArrayLikeObservable(ish, scheduler);
	            }
	        }
	        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
	    };
	    FromObservable.prototype._subscribe = function (subscriber) {
	        var ish = this.ish;
	        var scheduler = this.scheduler;
	        if (scheduler == null) {
	            return ish[observable_1.observable]().subscribe(subscriber);
	        }
	        else {
	            return ish[observable_1.observable]().subscribe(new observeOn_1.ObserveOnSubscriber(subscriber, scheduler, 0));
	        }
	    };
	    return FromObservable;
	}(Observable_1.Observable));
	exports.FromObservable = FromObservable;
	//# sourceMappingURL=FromObservable.js.map

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(39);
	var Observable_1 = __webpack_require__(4);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var PromiseObservable = (function (_super) {
	    __extends(PromiseObservable, _super);
	    function PromiseObservable(promise, scheduler) {
	        _super.call(this);
	        this.promise = promise;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Converts a Promise to an Observable.
	     *
	     * <span class="informal">Returns an Observable that just emits the Promise's
	     * resolved value, then completes.</span>
	     *
	     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
	     * Observable. If the Promise resolves with a value, the output Observable
	     * emits that resolved value as a `next`, and then completes. If the Promise
	     * is rejected, then the output Observable emits the corresponding Error.
	     *
	     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
	     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     * @see {@link bindCallback}
	     * @see {@link from}
	     *
	     * @param {PromiseLike<T>} promise The promise to be converted.
	     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
	     * the delivery of the resolved value (or the rejection).
	     * @return {Observable<T>} An Observable which wraps the Promise.
	     * @static true
	     * @name fromPromise
	     * @owner Observable
	     */
	    PromiseObservable.create = function (promise, scheduler) {
	        return new PromiseObservable(promise, scheduler);
	    };
	    PromiseObservable.prototype._subscribe = function (subscriber) {
	        var _this = this;
	        var promise = this.promise;
	        var scheduler = this.scheduler;
	        if (scheduler == null) {
	            if (this._isScalar) {
	                if (!subscriber.closed) {
	                    subscriber.next(this.value);
	                    subscriber.complete();
	                }
	            }
	            else {
	                promise.then(function (value) {
	                    _this.value = value;
	                    _this._isScalar = true;
	                    if (!subscriber.closed) {
	                        subscriber.next(value);
	                        subscriber.complete();
	                    }
	                }, function (err) {
	                    if (!subscriber.closed) {
	                        subscriber.error(err);
	                    }
	                })
	                    .then(null, function (err) {
	                    // escape the promise trap, throw unhandled errors
	                    root_1.root.setTimeout(function () { throw err; });
	                });
	            }
	        }
	        else {
	            if (this._isScalar) {
	                if (!subscriber.closed) {
	                    return scheduler.schedule(dispatchNext, 0, { value: this.value, subscriber: subscriber });
	                }
	            }
	            else {
	                promise.then(function (value) {
	                    _this.value = value;
	                    _this._isScalar = true;
	                    if (!subscriber.closed) {
	                        subscriber.add(scheduler.schedule(dispatchNext, 0, { value: value, subscriber: subscriber }));
	                    }
	                }, function (err) {
	                    if (!subscriber.closed) {
	                        subscriber.add(scheduler.schedule(dispatchError, 0, { err: err, subscriber: subscriber }));
	                    }
	                })
	                    .then(null, function (err) {
	                    // escape the promise trap, throw unhandled errors
	                    root_1.root.setTimeout(function () { throw err; });
	                });
	            }
	        }
	    };
	    return PromiseObservable;
	}(Observable_1.Observable));
	exports.PromiseObservable = PromiseObservable;
	function dispatchNext(arg) {
	    var value = arg.value, subscriber = arg.subscriber;
	    if (!subscriber.closed) {
	        subscriber.next(value);
	        subscriber.complete();
	    }
	}
	function dispatchError(arg) {
	    var err = arg.err, subscriber = arg.subscriber;
	    if (!subscriber.closed) {
	        subscriber.error(err);
	    }
	}
	//# sourceMappingURL=PromiseObservable.js.map

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isScheduler_1 = __webpack_require__(65);
	var isArray_1 = __webpack_require__(81);
	var ArrayObservable_1 = __webpack_require__(118);
	var combineLatest_1 = __webpack_require__(347);
	/* tslint:enable:max-line-length */
	/**
	 * Combines multiple Observables to create an Observable whose values are
	 * calculated from the latest values of each of its input Observables.
	 *
	 * <span class="informal">Whenever any input Observable emits a value, it
	 * computes a formula using the latest values from all the inputs, then emits
	 * the output of that formula.</span>
	 *
	 * <img src="./img/combineLatest.png" width="100%">
	 *
	 * `combineLatest` combines the values from all the Observables passed as
	 * arguments. This is done by subscribing to each Observable in order and,
	 * whenever any Observable emits, collecting an array of the most recent
	 * values from each Observable. So if you pass `n` Observables to operator,
	 * returned Observable will always emit an array of `n` values, in order
	 * corresponding to order of passed Observables (value from the first Observable
	 * on the first place and so on).
	 *
	 * Static version of `combineLatest` accepts either an array of Observables
	 * or each Observable can be put directly as an argument. Note that array of
	 * Observables is good choice, if you don't know beforehand how many Observables
	 * you will combine. Passing empty array will result in Observable that
	 * completes immediately.
	 *
	 * To ensure output array has always the same length, `combineLatest` will
	 * actually wait for all input Observables to emit at least once,
	 * before it starts emitting results. This means if some Observable emits
	 * values before other Observables started emitting, all that values but last
	 * will be lost. On the other hand, is some Observable does not emit value but
	 * completes, resulting Observable will complete at the same moment without
	 * emitting anything, since it will be now impossible to include value from
	 * completed Observable in resulting array. Also, if some input Observable does
	 * not emit any value and never completes, `combineLatest` will also never emit
	 * and never complete, since, again, it will wait for all streams to emit some
	 * value.
	 *
	 * If at least one Observable was passed to `combineLatest` and all passed Observables
	 * emitted something, resulting Observable will complete when all combined
	 * streams complete. So even if some Observable completes, result of
	 * `combineLatest` will still emit values when other Observables do. In case
	 * of completed Observable, its value from now on will always be the last
	 * emitted value. On the other hand, if any Observable errors, `combineLatest`
	 * will error immediately as well, and all other Observables will be unsubscribed.
	 *
	 * `combineLatest` accepts as optional parameter `project` function, which takes
	 * as arguments all values that would normally be emitted by resulting Observable.
	 * `project` can return any kind of value, which will be then emitted by Observable
	 * instead of default array. Note that `project` does not take as argument that array
	 * of values, but values themselves. That means default `project` can be imagined
	 * as function that takes all its arguments and puts them into an array.
	 *
	 *
	 * @example <caption>Combine two timer Observables</caption>
	 * const firstTimer = Rx.Observable.timer(0, 1000); // emit 0, 1, 2... after every second, starting from now
	 * const secondTimer = Rx.Observable.timer(500, 1000); // emit 0, 1, 2... after every second, starting 0,5s from now
	 * const combinedTimers = Rx.Observable.combineLatest(firstTimer, secondTimer);
	 * combinedTimers.subscribe(value => console.log(value));
	 * // Logs
	 * // [0, 0] after 0.5s
	 * // [1, 0] after 1s
	 * // [1, 1] after 1.5s
	 * // [2, 1] after 2s
	 *
	 *
	 * @example <caption>Combine an array of Observables</caption>
	 * const observables = [1, 5, 10].map(
	 *   n => Rx.Observable.of(n).delay(n * 1000).startWith(0) // emit 0 and then emit n after n seconds
	 * );
	 * const combined = Rx.Observable.combineLatest(observables);
	 * combined.subscribe(value => console.log(value));
	 * // Logs
	 * // [0, 0, 0] immediately
	 * // [1, 0, 0] after 1s
	 * // [1, 5, 0] after 5s
	 * // [1, 5, 10] after 10s
	 *
	 *
	 * @example <caption>Use project function to dynamically calculate the Body-Mass Index</caption>
	 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
	 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
	 * var bmi = Rx.Observable.combineLatest(weight, height, (w, h) => w / (h * h));
	 * bmi.subscribe(x => console.log('BMI is ' + x));
	 *
	 * // With output to console:
	 * // BMI is 24.212293388429753
	 * // BMI is 23.93948099205209
	 * // BMI is 23.671253629592222
	 *
	 *
	 * @see {@link combineAll}
	 * @see {@link merge}
	 * @see {@link withLatestFrom}
	 *
	 * @param {ObservableInput} observable1 An input Observable to combine with other Observables.
	 * @param {ObservableInput} observable2 An input Observable to combine with other Observables.
	 * More than one input Observables may be given as arguments
	 * or an array of Observables may be given as the first argument.
	 * @param {function} [project] An optional function to project the values from
	 * the combined latest values into a new value on the output Observable.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
	 * each input Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @static true
	 * @name combineLatest
	 * @owner Observable
	 */
	function combineLatest() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    var project = null;
	    var scheduler = null;
	    if (isScheduler_1.isScheduler(observables[observables.length - 1])) {
	        scheduler = observables.pop();
	    }
	    if (typeof observables[observables.length - 1] === 'function') {
	        project = observables.pop();
	    }
	    // if the first and only other argument besides the resultSelector is an array
	    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
	    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
	        observables = observables[0];
	    }
	    return new ArrayObservable_1.ArrayObservable(observables, scheduler).lift(new combineLatest_1.CombineLatestOperator(project));
	}
	exports.combineLatest = combineLatest;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(39);
	var tryCatch_1 = __webpack_require__(34);
	var errorObject_1 = __webpack_require__(32);
	var Observable_1 = __webpack_require__(4);
	var Subscriber_1 = __webpack_require__(11);
	var map_1 = __webpack_require__(163);
	function getCORSRequest() {
	    if (root_1.root.XMLHttpRequest) {
	        return new root_1.root.XMLHttpRequest();
	    }
	    else if (!!root_1.root.XDomainRequest) {
	        return new root_1.root.XDomainRequest();
	    }
	    else {
	        throw new Error('CORS is not supported by your browser');
	    }
	}
	function getXMLHttpRequest() {
	    if (root_1.root.XMLHttpRequest) {
	        return new root_1.root.XMLHttpRequest();
	    }
	    else {
	        var progId = void 0;
	        try {
	            var progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'];
	            for (var i = 0; i < 3; i++) {
	                try {
	                    progId = progIds[i];
	                    if (new root_1.root.ActiveXObject(progId)) {
	                        break;
	                    }
	                }
	                catch (e) {
	                }
	            }
	            return new root_1.root.ActiveXObject(progId);
	        }
	        catch (e) {
	            throw new Error('XMLHttpRequest is not supported by your browser');
	        }
	    }
	}
	function ajaxGet(url, headers) {
	    if (headers === void 0) { headers = null; }
	    return new AjaxObservable({ method: 'GET', url: url, headers: headers });
	}
	exports.ajaxGet = ajaxGet;
	;
	function ajaxPost(url, body, headers) {
	    return new AjaxObservable({ method: 'POST', url: url, body: body, headers: headers });
	}
	exports.ajaxPost = ajaxPost;
	;
	function ajaxDelete(url, headers) {
	    return new AjaxObservable({ method: 'DELETE', url: url, headers: headers });
	}
	exports.ajaxDelete = ajaxDelete;
	;
	function ajaxPut(url, body, headers) {
	    return new AjaxObservable({ method: 'PUT', url: url, body: body, headers: headers });
	}
	exports.ajaxPut = ajaxPut;
	;
	function ajaxPatch(url, body, headers) {
	    return new AjaxObservable({ method: 'PATCH', url: url, body: body, headers: headers });
	}
	exports.ajaxPatch = ajaxPatch;
	;
	var mapResponse = map_1.map(function (x, index) { return x.response; });
	function ajaxGetJSON(url, headers) {
	    return mapResponse(new AjaxObservable({
	        method: 'GET',
	        url: url,
	        responseType: 'json',
	        headers: headers
	    }));
	}
	exports.ajaxGetJSON = ajaxGetJSON;
	;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var AjaxObservable = (function (_super) {
	    __extends(AjaxObservable, _super);
	    function AjaxObservable(urlOrRequest) {
	        _super.call(this);
	        var request = {
	            async: true,
	            createXHR: function () {
	                return this.crossDomain ? getCORSRequest.call(this) : getXMLHttpRequest();
	            },
	            crossDomain: false,
	            withCredentials: false,
	            headers: {},
	            method: 'GET',
	            responseType: 'json',
	            timeout: 0
	        };
	        if (typeof urlOrRequest === 'string') {
	            request.url = urlOrRequest;
	        }
	        else {
	            for (var prop in urlOrRequest) {
	                if (urlOrRequest.hasOwnProperty(prop)) {
	                    request[prop] = urlOrRequest[prop];
	                }
	            }
	        }
	        this.request = request;
	    }
	    AjaxObservable.prototype._subscribe = function (subscriber) {
	        return new AjaxSubscriber(subscriber, this.request);
	    };
	    /**
	     * Creates an observable for an Ajax request with either a request object with
	     * url, headers, etc or a string for a URL.
	     *
	     * @example
	     * source = Rx.Observable.ajax('/products');
	     * source = Rx.Observable.ajax({ url: 'products', method: 'GET' });
	     *
	     * @param {string|Object} request Can be one of the following:
	     *   A string of the URL to make the Ajax call.
	     *   An object with the following properties
	     *   - url: URL of the request
	     *   - body: The body of the request
	     *   - method: Method of the request, such as GET, POST, PUT, PATCH, DELETE
	     *   - async: Whether the request is async
	     *   - headers: Optional headers
	     *   - crossDomain: true if a cross domain request, else false
	     *   - createXHR: a function to override if you need to use an alternate
	     *   XMLHttpRequest implementation.
	     *   - resultSelector: a function to use to alter the output value type of
	     *   the Observable. Gets {@link AjaxResponse} as an argument.
	     * @return {Observable} An observable sequence containing the XMLHttpRequest.
	     * @static true
	     * @name ajax
	     * @owner Observable
	    */
	    AjaxObservable.create = (function () {
	        var create = function (urlOrRequest) {
	            return new AjaxObservable(urlOrRequest);
	        };
	        create.get = ajaxGet;
	        create.post = ajaxPost;
	        create.delete = ajaxDelete;
	        create.put = ajaxPut;
	        create.patch = ajaxPatch;
	        create.getJSON = ajaxGetJSON;
	        return create;
	    })();
	    return AjaxObservable;
	}(Observable_1.Observable));
	exports.AjaxObservable = AjaxObservable;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AjaxSubscriber = (function (_super) {
	    __extends(AjaxSubscriber, _super);
	    function AjaxSubscriber(destination, request) {
	        _super.call(this, destination);
	        this.request = request;
	        this.done = false;
	        var headers = request.headers = request.headers || {};
	        // force CORS if requested
	        if (!request.crossDomain && !headers['X-Requested-With']) {
	            headers['X-Requested-With'] = 'XMLHttpRequest';
	        }
	        // ensure content type is set
	        if (!('Content-Type' in headers) && !(root_1.root.FormData && request.body instanceof root_1.root.FormData) && typeof request.body !== 'undefined') {
	            headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
	        }
	        // properly serialize body
	        request.body = this.serializeBody(request.body, request.headers['Content-Type']);
	        this.send();
	    }
	    AjaxSubscriber.prototype.next = function (e) {
	        this.done = true;
	        var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
	        var response = new AjaxResponse(e, xhr, request);
	        destination.next(response);
	    };
	    AjaxSubscriber.prototype.send = function () {
	        var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
	        var createXHR = request.createXHR;
	        var xhr = tryCatch_1.tryCatch(createXHR).call(request);
	        if (xhr === errorObject_1.errorObject) {
	            this.error(errorObject_1.errorObject.e);
	        }
	        else {
	            this.xhr = xhr;
	            // set up the events before open XHR
	            // https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
	            // You need to add the event listeners before calling open() on the request.
	            // Otherwise the progress events will not fire.
	            this.setupEvents(xhr, request);
	            // open XHR
	            var result = void 0;
	            if (user) {
	                result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async, user, password);
	            }
	            else {
	                result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async);
	            }
	            if (result === errorObject_1.errorObject) {
	                this.error(errorObject_1.errorObject.e);
	                return null;
	            }
	            // timeout, responseType and withCredentials can be set once the XHR is open
	            if (async) {
	                xhr.timeout = request.timeout;
	                xhr.responseType = request.responseType;
	            }
	            if ('withCredentials' in xhr) {
	                xhr.withCredentials = !!request.withCredentials;
	            }
	            // set headers
	            this.setHeaders(xhr, headers);
	            // finally send the request
	            result = body ? tryCatch_1.tryCatch(xhr.send).call(xhr, body) : tryCatch_1.tryCatch(xhr.send).call(xhr);
	            if (result === errorObject_1.errorObject) {
	                this.error(errorObject_1.errorObject.e);
	                return null;
	            }
	        }
	        return xhr;
	    };
	    AjaxSubscriber.prototype.serializeBody = function (body, contentType) {
	        if (!body || typeof body === 'string') {
	            return body;
	        }
	        else if (root_1.root.FormData && body instanceof root_1.root.FormData) {
	            return body;
	        }
	        if (contentType) {
	            var splitIndex = contentType.indexOf(';');
	            if (splitIndex !== -1) {
	                contentType = contentType.substring(0, splitIndex);
	            }
	        }
	        switch (contentType) {
	            case 'application/x-www-form-urlencoded':
	                return Object.keys(body).map(function (key) { return (encodeURI(key) + "=" + encodeURI(body[key])); }).join('&');
	            case 'application/json':
	                return JSON.stringify(body);
	            default:
	                return body;
	        }
	    };
	    AjaxSubscriber.prototype.setHeaders = function (xhr, headers) {
	        for (var key in headers) {
	            if (headers.hasOwnProperty(key)) {
	                xhr.setRequestHeader(key, headers[key]);
	            }
	        }
	    };
	    AjaxSubscriber.prototype.setupEvents = function (xhr, request) {
	        var progressSubscriber = request.progressSubscriber;
	        function xhrTimeout(e) {
	            var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
	            if (progressSubscriber) {
	                progressSubscriber.error(e);
	            }
	            subscriber.error(new AjaxTimeoutError(this, request)); //TODO: Make betterer.
	        }
	        ;
	        xhr.ontimeout = xhrTimeout;
	        xhrTimeout.request = request;
	        xhrTimeout.subscriber = this;
	        xhrTimeout.progressSubscriber = progressSubscriber;
	        if (xhr.upload && 'withCredentials' in xhr) {
	            if (progressSubscriber) {
	                var xhrProgress_1;
	                xhrProgress_1 = function (e) {
	                    var progressSubscriber = xhrProgress_1.progressSubscriber;
	                    progressSubscriber.next(e);
	                };
	                if (root_1.root.XDomainRequest) {
	                    xhr.onprogress = xhrProgress_1;
	                }
	                else {
	                    xhr.upload.onprogress = xhrProgress_1;
	                }
	                xhrProgress_1.progressSubscriber = progressSubscriber;
	            }
	            var xhrError_1;
	            xhrError_1 = function (e) {
	                var _a = xhrError_1, progressSubscriber = _a.progressSubscriber, subscriber = _a.subscriber, request = _a.request;
	                if (progressSubscriber) {
	                    progressSubscriber.error(e);
	                }
	                subscriber.error(new AjaxError('ajax error', this, request));
	            };
	            xhr.onerror = xhrError_1;
	            xhrError_1.request = request;
	            xhrError_1.subscriber = this;
	            xhrError_1.progressSubscriber = progressSubscriber;
	        }
	        function xhrReadyStateChange(e) {
	            var _a = xhrReadyStateChange, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
	            if (this.readyState === 4) {
	                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	                var status_1 = this.status === 1223 ? 204 : this.status;
	                var response = (this.responseType === 'text' ? (this.response || this.responseText) : this.response);
	                // fix status code when it is 0 (0 status is undocumented).
	                // Occurs when accessing file resources or on Android 4.1 stock browser
	                // while retrieving files from application cache.
	                if (status_1 === 0) {
	                    status_1 = response ? 200 : 0;
	                }
	                if (200 <= status_1 && status_1 < 300) {
	                    if (progressSubscriber) {
	                        progressSubscriber.complete();
	                    }
	                    subscriber.next(e);
	                    subscriber.complete();
	                }
	                else {
	                    if (progressSubscriber) {
	                        progressSubscriber.error(e);
	                    }
	                    subscriber.error(new AjaxError('ajax error ' + status_1, this, request));
	                }
	            }
	        }
	        ;
	        xhr.onreadystatechange = xhrReadyStateChange;
	        xhrReadyStateChange.subscriber = this;
	        xhrReadyStateChange.progressSubscriber = progressSubscriber;
	        xhrReadyStateChange.request = request;
	    };
	    AjaxSubscriber.prototype.unsubscribe = function () {
	        var _a = this, done = _a.done, xhr = _a.xhr;
	        if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === 'function') {
	            xhr.abort();
	        }
	        _super.prototype.unsubscribe.call(this);
	    };
	    return AjaxSubscriber;
	}(Subscriber_1.Subscriber));
	exports.AjaxSubscriber = AjaxSubscriber;
	/**
	 * A normalized AJAX response.
	 *
	 * @see {@link ajax}
	 *
	 * @class AjaxResponse
	 */
	var AjaxResponse = (function () {
	    function AjaxResponse(originalEvent, xhr, request) {
	        this.originalEvent = originalEvent;
	        this.xhr = xhr;
	        this.request = request;
	        this.status = xhr.status;
	        this.responseType = xhr.responseType || request.responseType;
	        this.response = parseXhrResponse(this.responseType, xhr);
	    }
	    return AjaxResponse;
	}());
	exports.AjaxResponse = AjaxResponse;
	/**
	 * A normalized AJAX error.
	 *
	 * @see {@link ajax}
	 *
	 * @class AjaxError
	 */
	var AjaxError = (function (_super) {
	    __extends(AjaxError, _super);
	    function AjaxError(message, xhr, request) {
	        _super.call(this, message);
	        this.message = message;
	        this.xhr = xhr;
	        this.request = request;
	        this.status = xhr.status;
	        this.responseType = xhr.responseType || request.responseType;
	        this.response = parseXhrResponse(this.responseType, xhr);
	    }
	    return AjaxError;
	}(Error));
	exports.AjaxError = AjaxError;
	function parseXhrResponse(responseType, xhr) {
	    switch (responseType) {
	        case 'json':
	            if ('response' in xhr) {
	                //IE does not support json as responseType, parse it internally
	                return xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || 'null');
	            }
	            else {
	                // HACK(benlesh): TypeScript shennanigans
	                // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
	                return JSON.parse(xhr.responseText || 'null');
	            }
	        case 'xml':
	            return xhr.responseXML;
	        case 'text':
	        default:
	            // HACK(benlesh): TypeScript shennanigans
	            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
	            return ('response' in xhr) ? xhr.response : xhr.responseText;
	    }
	}
	/**
	 * @see {@link ajax}
	 *
	 * @class AjaxTimeoutError
	 */
	var AjaxTimeoutError = (function (_super) {
	    __extends(AjaxTimeoutError, _super);
	    function AjaxTimeoutError(xhr, request) {
	        _super.call(this, 'ajax timeout', xhr, request);
	    }
	    return AjaxTimeoutError;
	}(AjaxError));
	exports.AjaxTimeoutError = AjaxTimeoutError;
	//# sourceMappingURL=AjaxObservable.js.map

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var TimerObservable_1 = __webpack_require__(4617);
	exports.timer = TimerObservable_1.TimerObservable.create;
	//# sourceMappingURL=timer.js.map

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var filter_1 = __webpack_require__(348);
	/* tslint:enable:max-line-length */
	/**
	 * Filter items emitted by the source Observable by only emitting those that
	 * satisfy a specified predicate.
	 *
	 * <span class="informal">Like
	 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
	 * it only emits a value from the source if it passes a criterion function.</span>
	 *
	 * <img src="./img/filter.png" width="100%">
	 *
	 * Similar to the well-known `Array.prototype.filter` method, this operator
	 * takes values from the source Observable, passes them through a `predicate`
	 * function and only emits those values that yielded `true`.
	 *
	 * @example <caption>Emit only click events whose target was a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
	 * clicksOnDivs.subscribe(x => console.log(x));
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilChanged}
	 * @see {@link distinctUntilKeyChanged}
	 * @see {@link ignoreElements}
	 * @see {@link partition}
	 * @see {@link skip}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates each value emitted by the source Observable. If it returns `true`,
	 * the value is emitted, if `false` the value is not passed to the output
	 * Observable. The `index` parameter is the number `i` for the i-th source
	 * emission that has happened since the subscription, starting from the number
	 * `0`.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable} An Observable of values from the source that were
	 * allowed by the `predicate` function.
	 * @method filter
	 * @owner Observable
	 */
	function filter(predicate, thisArg) {
	    return filter_1.filter(predicate, thisArg)(this);
	}
	exports.filter = filter;
	//# sourceMappingURL=filter.js.map

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var map_1 = __webpack_require__(163);
	/**
	 * Applies a given `project` function to each value emitted by the source
	 * Observable, and emits the resulting values as an Observable.
	 *
	 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
	 * it passes each source value through a transformation function to get
	 * corresponding output values.</span>
	 *
	 * <img src="./img/map.png" width="100%">
	 *
	 * Similar to the well known `Array.prototype.map` function, this operator
	 * applies a projection to each value and emits that projection in the output
	 * Observable.
	 *
	 * @example <caption>Map every click to the clientX position of that click</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks.map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link mapTo}
	 * @see {@link pluck}
	 *
	 * @param {function(value: T, index: number): R} project The function to apply
	 * to each `value` emitted by the source Observable. The `index` parameter is
	 * the number `i` for the i-th emission that has happened since the
	 * subscription, starting from the number `0`.
	 * @param {any} [thisArg] An optional argument to define what `this` is in the
	 * `project` function.
	 * @return {Observable<R>} An Observable that emits the values from the source
	 * Observable transformed by the given `project` function.
	 * @method map
	 * @owner Observable
	 */
	function map(project, thisArg) {
	    return map_1.map(project, thisArg)(this);
	}
	exports.map = map;
	//# sourceMappingURL=map.js.map

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var switchMap_1 = __webpack_require__(351);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable, emitting values only from the most recently projected Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link switch}.</span>
	 *
	 * <img src="./img/switchMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. Each time it observes one of these
	 * inner Observables, the output Observable begins emitting the items emitted by
	 * that inner Observable. When a new inner Observable is emitted, `switchMap`
	 * stops emitting items from the earlier-emitted inner Observable and begins
	 * emitting items from the new one. It continues to behave like this for
	 * subsequent inner Observables.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link mergeMap}
	 * @see {@link switch}
	 * @see {@link switchMapTo}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and taking only the values from the most recently
	 * projected inner Observable.
	 * @method switchMap
	 * @owner Observable
	 */
	function switchMap(project, resultSelector) {
	    return switchMap_1.switchMap(project, resultSelector)(this);
	}
	exports.switchMap = switchMap;
	//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(23);
	var timeInterval_1 = __webpack_require__(836);
	exports.TimeInterval = timeInterval_1.TimeInterval;
	/**
	 * @param scheduler
	 * @return {Observable<TimeInterval<any>>|WebSocketSubject<T>|Observable<T>}
	 * @method timeInterval
	 * @owner Observable
	 */
	function timeInterval(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return timeInterval_1.timeInterval(scheduler)(this);
	}
	exports.timeInterval = timeInterval;
	//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(23);
	var audit_1 = __webpack_require__(509);
	var timer_1 = __webpack_require__(767);
	/**
	 * Ignores source values for `duration` milliseconds, then emits the most recent
	 * value from the source Observable, then repeats this process.
	 *
	 * <span class="informal">When it sees a source values, it ignores that plus
	 * the next ones for `duration` milliseconds, and then it emits the most recent
	 * value from the source.</span>
	 *
	 * <img src="./img/auditTime.png" width="100%">
	 *
	 * `auditTime` is similar to `throttleTime`, but emits the last value from the
	 * silenced time window, instead of the first value. `auditTime` emits the most
	 * recent value from the source Observable on the output Observable as soon as
	 * its internal timer becomes disabled, and ignores source values while the
	 * timer is enabled. Initially, the timer is disabled. As soon as the first
	 * source value arrives, the timer is enabled. After `duration` milliseconds (or
	 * the time unit determined internally by the optional `scheduler`) has passed,
	 * the timer is disabled, then the most recent source value is emitted on the
	 * output Observable, and this process repeats for the next source value.
	 * Optionally takes a {@link IScheduler} for managing timers.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.auditTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttleTime}
	 *
	 * @param {number} duration Time to wait before emitting the most recent source
	 * value, measured in milliseconds or the time unit determined internally
	 * by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the rate-limiting behavior.
	 * @return {Observable<T>} An Observable that performs rate-limiting of
	 * emissions from the source Observable.
	 * @method auditTime
	 * @owner Observable
	 */
	function auditTime(duration, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return audit_1.audit(function () { return timer_1.timer(duration, scheduler); });
	}
	exports.auditTime = auditTime;
	//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/**
	 * Buffers the source Observable values until `closingNotifier` emits.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * that array only when another Observable emits.</span>
	 *
	 * <img src="./img/buffer.png" width="100%">
	 *
	 * Buffers the incoming Observable values until the given `closingNotifier`
	 * Observable emits a value, at which point it emits the buffer on the output
	 * Observable and starts a new buffer internally, awaiting the next time
	 * `closingNotifier` emits.
	 *
	 * @example <caption>On every click, emit array of most recent interval events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var interval = Rx.Observable.interval(1000);
	 * var buffered = interval.buffer(clicks);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link window}
	 *
	 * @param {Observable<any>} closingNotifier An Observable that signals the
	 * buffer to be emitted on the output Observable.
	 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
	 * values.
	 * @method buffer
	 * @owner Observable
	 */
	function buffer(closingNotifier) {
	    return function bufferOperatorFunction(source) {
	        return source.lift(new BufferOperator(closingNotifier));
	    };
	}
	exports.buffer = buffer;
	var BufferOperator = (function () {
	    function BufferOperator(closingNotifier) {
	        this.closingNotifier = closingNotifier;
	    }
	    BufferOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
	    };
	    return BufferOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferSubscriber = (function (_super) {
	    __extends(BufferSubscriber, _super);
	    function BufferSubscriber(destination, closingNotifier) {
	        _super.call(this, destination);
	        this.buffer = [];
	        this.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
	    }
	    BufferSubscriber.prototype._next = function (value) {
	        this.buffer.push(value);
	    };
	    BufferSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var buffer = this.buffer;
	        this.buffer = [];
	        this.destination.next(buffer);
	    };
	    return BufferSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=buffer.js.map

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/**
	 * Buffers the source Observable values until the size hits the maximum
	 * `bufferSize` given.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * that array only when its size reaches `bufferSize`.</span>
	 *
	 * <img src="./img/bufferCount.png" width="100%">
	 *
	 * Buffers a number of values from the source Observable by `bufferSize` then
	 * emits the buffer and clears it, and starts a new buffer each
	 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
	 * `null`, then new buffers are started immediately at the start of the source
	 * and when each buffer closes and is emitted.
	 *
	 * @example <caption>Emit the last two click events as an array</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferCount(2);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @example <caption>On every click, emit the last two click events as an array</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferCount(2, 1);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link pairwise}
	 * @see {@link windowCount}
	 *
	 * @param {number} bufferSize The maximum size of the buffer emitted.
	 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
	 * For example if `startBufferEvery` is `2`, then a new buffer will be started
	 * on every other value from the source. A new buffer is started at the
	 * beginning of the source by default.
	 * @return {Observable<T[]>} An Observable of arrays of buffered values.
	 * @method bufferCount
	 * @owner Observable
	 */
	function bufferCount(bufferSize, startBufferEvery) {
	    if (startBufferEvery === void 0) { startBufferEvery = null; }
	    return function bufferCountOperatorFunction(source) {
	        return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
	    };
	}
	exports.bufferCount = bufferCount;
	var BufferCountOperator = (function () {
	    function BufferCountOperator(bufferSize, startBufferEvery) {
	        this.bufferSize = bufferSize;
	        this.startBufferEvery = startBufferEvery;
	        if (!startBufferEvery || bufferSize === startBufferEvery) {
	            this.subscriberClass = BufferCountSubscriber;
	        }
	        else {
	            this.subscriberClass = BufferSkipCountSubscriber;
	        }
	    }
	    BufferCountOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
	    };
	    return BufferCountOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferCountSubscriber = (function (_super) {
	    __extends(BufferCountSubscriber, _super);
	    function BufferCountSubscriber(destination, bufferSize) {
	        _super.call(this, destination);
	        this.bufferSize = bufferSize;
	        this.buffer = [];
	    }
	    BufferCountSubscriber.prototype._next = function (value) {
	        var buffer = this.buffer;
	        buffer.push(value);
	        if (buffer.length == this.bufferSize) {
	            this.destination.next(buffer);
	            this.buffer = [];
	        }
	    };
	    BufferCountSubscriber.prototype._complete = function () {
	        var buffer = this.buffer;
	        if (buffer.length > 0) {
	            this.destination.next(buffer);
	        }
	        _super.prototype._complete.call(this);
	    };
	    return BufferCountSubscriber;
	}(Subscriber_1.Subscriber));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferSkipCountSubscriber = (function (_super) {
	    __extends(BufferSkipCountSubscriber, _super);
	    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
	        _super.call(this, destination);
	        this.bufferSize = bufferSize;
	        this.startBufferEvery = startBufferEvery;
	        this.buffers = [];
	        this.count = 0;
	    }
	    BufferSkipCountSubscriber.prototype._next = function (value) {
	        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
	        this.count++;
	        if (count % startBufferEvery === 0) {
	            buffers.push([]);
	        }
	        for (var i = buffers.length; i--;) {
	            var buffer = buffers[i];
	            buffer.push(value);
	            if (buffer.length === bufferSize) {
	                buffers.splice(i, 1);
	                this.destination.next(buffer);
	            }
	        }
	    };
	    BufferSkipCountSubscriber.prototype._complete = function () {
	        var _a = this, buffers = _a.buffers, destination = _a.destination;
	        while (buffers.length > 0) {
	            var buffer = buffers.shift();
	            if (buffer.length > 0) {
	                destination.next(buffer);
	            }
	        }
	        _super.prototype._complete.call(this);
	    };
	    return BufferSkipCountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var async_1 = __webpack_require__(23);
	var Subscriber_1 = __webpack_require__(11);
	var isScheduler_1 = __webpack_require__(65);
	/* tslint:enable:max-line-length */
	/**
	 * Buffers the source Observable values for a specific time period.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * those arrays periodically in time.</span>
	 *
	 * <img src="./img/bufferTime.png" width="100%">
	 *
	 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
	 * Unless the optional argument `bufferCreationInterval` is given, it emits and
	 * resets the buffer every `bufferTimeSpan` milliseconds. If
	 * `bufferCreationInterval` is given, this operator opens the buffer every
	 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
	 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
	 * `maxBufferSize` is specified, the buffer will be closed either after
	 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
	 *
	 * @example <caption>Every second, emit an array of the recent click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferTime(1000);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferTime(2000, 5000);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link windowTime}
	 *
	 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
	 * @param {number} [bufferCreationInterval] The interval at which to start new
	 * buffers.
	 * @param {number} [maxBufferSize] The maximum buffer size.
	 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
	 * intervals that determine buffer boundaries.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferTime
	 * @owner Observable
	 */
	function bufferTime(bufferTimeSpan) {
	    var length = arguments.length;
	    var scheduler = async_1.async;
	    if (isScheduler_1.isScheduler(arguments[arguments.length - 1])) {
	        scheduler = arguments[arguments.length - 1];
	        length--;
	    }
	    var bufferCreationInterval = null;
	    if (length >= 2) {
	        bufferCreationInterval = arguments[1];
	    }
	    var maxBufferSize = Number.POSITIVE_INFINITY;
	    if (length >= 3) {
	        maxBufferSize = arguments[2];
	    }
	    return function bufferTimeOperatorFunction(source) {
	        return source.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
	    };
	}
	exports.bufferTime = bufferTime;
	var BufferTimeOperator = (function () {
	    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
	        this.bufferTimeSpan = bufferTimeSpan;
	        this.bufferCreationInterval = bufferCreationInterval;
	        this.maxBufferSize = maxBufferSize;
	        this.scheduler = scheduler;
	    }
	    BufferTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
	    };
	    return BufferTimeOperator;
	}());
	var Context = (function () {
	    function Context() {
	        this.buffer = [];
	    }
	    return Context;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferTimeSubscriber = (function (_super) {
	    __extends(BufferTimeSubscriber, _super);
	    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
	        _super.call(this, destination);
	        this.bufferTimeSpan = bufferTimeSpan;
	        this.bufferCreationInterval = bufferCreationInterval;
	        this.maxBufferSize = maxBufferSize;
	        this.scheduler = scheduler;
	        this.contexts = [];
	        var context = this.openContext();
	        this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
	        if (this.timespanOnly) {
	            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
	            this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
	        }
	        else {
	            var closeState = { subscriber: this, context: context };
	            var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: this, scheduler: scheduler };
	            this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
	            this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
	        }
	    }
	    BufferTimeSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        var len = contexts.length;
	        var filledBufferContext;
	        for (var i = 0; i < len; i++) {
	            var context = contexts[i];
	            var buffer = context.buffer;
	            buffer.push(value);
	            if (buffer.length == this.maxBufferSize) {
	                filledBufferContext = context;
	            }
	        }
	        if (filledBufferContext) {
	            this.onBufferFull(filledBufferContext);
	        }
	    };
	    BufferTimeSubscriber.prototype._error = function (err) {
	        this.contexts.length = 0;
	        _super.prototype._error.call(this, err);
	    };
	    BufferTimeSubscriber.prototype._complete = function () {
	        var _a = this, contexts = _a.contexts, destination = _a.destination;
	        while (contexts.length > 0) {
	            var context = contexts.shift();
	            destination.next(context.buffer);
	        }
	        _super.prototype._complete.call(this);
	    };
	    BufferTimeSubscriber.prototype._unsubscribe = function () {
	        this.contexts = null;
	    };
	    BufferTimeSubscriber.prototype.onBufferFull = function (context) {
	        this.closeContext(context);
	        var closeAction = context.closeAction;
	        closeAction.unsubscribe();
	        this.remove(closeAction);
	        if (!this.closed && this.timespanOnly) {
	            context = this.openContext();
	            var bufferTimeSpan = this.bufferTimeSpan;
	            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
	            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
	        }
	    };
	    BufferTimeSubscriber.prototype.openContext = function () {
	        var context = new Context();
	        this.contexts.push(context);
	        return context;
	    };
	    BufferTimeSubscriber.prototype.closeContext = function (context) {
	        this.destination.next(context.buffer);
	        var contexts = this.contexts;
	        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
	        if (spliceIndex >= 0) {
	            contexts.splice(contexts.indexOf(context), 1);
	        }
	    };
	    return BufferTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchBufferTimeSpanOnly(state) {
	    var subscriber = state.subscriber;
	    var prevContext = state.context;
	    if (prevContext) {
	        subscriber.closeContext(prevContext);
	    }
	    if (!subscriber.closed) {
	        state.context = subscriber.openContext();
	        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
	    }
	}
	function dispatchBufferCreation(state) {
	    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
	    var context = subscriber.openContext();
	    var action = this;
	    if (!subscriber.closed) {
	        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
	        action.schedule(state, bufferCreationInterval);
	    }
	}
	function dispatchBufferClose(arg) {
	    var subscriber = arg.subscriber, context = arg.context;
	    subscriber.closeContext(context);
	}
	//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(31);
	var subscribeToResult_1 = __webpack_require__(17);
	var OuterSubscriber_1 = __webpack_require__(16);
	/**
	 * Buffers the source Observable values starting from an emission from
	 * `openings` and ending when the output of `closingSelector` emits.
	 *
	 * <span class="informal">Collects values from the past as an array. Starts
	 * collecting only when `opening` emits, and calls the `closingSelector`
	 * function to get an Observable that tells when to close the buffer.</span>
	 *
	 * <img src="./img/bufferToggle.png" width="100%">
	 *
	 * Buffers values from the source by opening the buffer via signals from an
	 * Observable provided to `openings`, and closing and sending the buffers when
	 * a Subscribable or Promise returned by the `closingSelector` function emits.
	 *
	 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var openings = Rx.Observable.interval(1000);
	 * var buffered = clicks.bufferToggle(openings, i =>
	 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
	 * );
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferWhen}
	 * @see {@link windowToggle}
	 *
	 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
	 * buffers.
	 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
	 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
	 * which, when it emits, signals that the associated buffer should be emitted
	 * and cleared.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferToggle
	 * @owner Observable
	 */
	function bufferToggle(openings, closingSelector) {
	    return function bufferToggleOperatorFunction(source) {
	        return source.lift(new BufferToggleOperator(openings, closingSelector));
	    };
	}
	exports.bufferToggle = bufferToggle;
	var BufferToggleOperator = (function () {
	    function BufferToggleOperator(openings, closingSelector) {
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	    }
	    BufferToggleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
	    };
	    return BufferToggleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferToggleSubscriber = (function (_super) {
	    __extends(BufferToggleSubscriber, _super);
	    function BufferToggleSubscriber(destination, openings, closingSelector) {
	        _super.call(this, destination);
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	        this.contexts = [];
	        this.add(subscribeToResult_1.subscribeToResult(this, openings));
	    }
	    BufferToggleSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        var len = contexts.length;
	        for (var i = 0; i < len; i++) {
	            contexts[i].buffer.push(value);
	        }
	    };
	    BufferToggleSubscriber.prototype._error = function (err) {
	        var contexts = this.contexts;
	        while (contexts.length > 0) {
	            var context = contexts.shift();
	            context.subscription.unsubscribe();
	            context.buffer = null;
	            context.subscription = null;
	        }
	        this.contexts = null;
	        _super.prototype._error.call(this, err);
	    };
	    BufferToggleSubscriber.prototype._complete = function () {
	        var contexts = this.contexts;
	        while (contexts.length > 0) {
	            var context = contexts.shift();
	            this.destination.next(context.buffer);
	            context.subscription.unsubscribe();
	            context.buffer = null;
	            context.subscription = null;
	        }
	        this.contexts = null;
	        _super.prototype._complete.call(this);
	    };
	    BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
	    };
	    BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.closeBuffer(innerSub.context);
	    };
	    BufferToggleSubscriber.prototype.openBuffer = function (value) {
	        try {
	            var closingSelector = this.closingSelector;
	            var closingNotifier = closingSelector.call(this, value);
	            if (closingNotifier) {
	                this.trySubscribe(closingNotifier);
	            }
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    BufferToggleSubscriber.prototype.closeBuffer = function (context) {
	        var contexts = this.contexts;
	        if (contexts && context) {
	            var buffer = context.buffer, subscription = context.subscription;
	            this.destination.next(buffer);
	            contexts.splice(contexts.indexOf(context), 1);
	            this.remove(subscription);
	            subscription.unsubscribe();
	        }
	    };
	    BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
	        var contexts = this.contexts;
	        var buffer = [];
	        var subscription = new Subscription_1.Subscription();
	        var context = { buffer: buffer, subscription: subscription };
	        contexts.push(context);
	        var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
	        if (!innerSubscription || innerSubscription.closed) {
	            this.closeBuffer(context);
	        }
	        else {
	            innerSubscription.context = context;
	            this.add(innerSubscription);
	            subscription.add(innerSubscription);
	        }
	    };
	    return BufferToggleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(31);
	var tryCatch_1 = __webpack_require__(34);
	var errorObject_1 = __webpack_require__(32);
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/**
	 * Buffers the source Observable values, using a factory function of closing
	 * Observables to determine when to close, emit, and reset the buffer.
	 *
	 * <span class="informal">Collects values from the past as an array. When it
	 * starts collecting values, it calls a function that returns an Observable that
	 * tells when to close the buffer and restart collecting.</span>
	 *
	 * <img src="./img/bufferWhen.png" width="100%">
	 *
	 * Opens a buffer immediately, then closes the buffer when the observable
	 * returned by calling `closingSelector` function emits a value. When it closes
	 * the buffer, it immediately opens a new buffer and repeats the process.
	 *
	 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferWhen(() =>
	 *   Rx.Observable.interval(1000 + Math.random() * 4000)
	 * );
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link windowWhen}
	 *
	 * @param {function(): Observable} closingSelector A function that takes no
	 * arguments and returns an Observable that signals buffer closure.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferWhen
	 * @owner Observable
	 */
	function bufferWhen(closingSelector) {
	    return function (source) {
	        return source.lift(new BufferWhenOperator(closingSelector));
	    };
	}
	exports.bufferWhen = bufferWhen;
	var BufferWhenOperator = (function () {
	    function BufferWhenOperator(closingSelector) {
	        this.closingSelector = closingSelector;
	    }
	    BufferWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
	    };
	    return BufferWhenOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferWhenSubscriber = (function (_super) {
	    __extends(BufferWhenSubscriber, _super);
	    function BufferWhenSubscriber(destination, closingSelector) {
	        _super.call(this, destination);
	        this.closingSelector = closingSelector;
	        this.subscribing = false;
	        this.openBuffer();
	    }
	    BufferWhenSubscriber.prototype._next = function (value) {
	        this.buffer.push(value);
	    };
	    BufferWhenSubscriber.prototype._complete = function () {
	        var buffer = this.buffer;
	        if (buffer) {
	            this.destination.next(buffer);
	        }
	        _super.prototype._complete.call(this);
	    };
	    BufferWhenSubscriber.prototype._unsubscribe = function () {
	        this.buffer = null;
	        this.subscribing = false;
	    };
	    BufferWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.openBuffer();
	    };
	    BufferWhenSubscriber.prototype.notifyComplete = function () {
	        if (this.subscribing) {
	            this.complete();
	        }
	        else {
	            this.openBuffer();
	        }
	    };
	    BufferWhenSubscriber.prototype.openBuffer = function () {
	        var closingSubscription = this.closingSubscription;
	        if (closingSubscription) {
	            this.remove(closingSubscription);
	            closingSubscription.unsubscribe();
	        }
	        var buffer = this.buffer;
	        if (this.buffer) {
	            this.destination.next(buffer);
	        }
	        this.buffer = [];
	        var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
	        if (closingNotifier === errorObject_1.errorObject) {
	            this.error(errorObject_1.errorObject.e);
	        }
	        else {
	            closingSubscription = new Subscription_1.Subscription();
	            this.closingSubscription = closingSubscription;
	            this.add(closingSubscription);
	            this.subscribing = true;
	            closingSubscription.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
	            this.subscribing = false;
	        }
	    };
	    return BufferWhenSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/**
	 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
	 *
	 * <img src="./img/catch.png" width="100%">
	 *
	 * @example <caption>Continues with a different Observable when there's an error</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 * 	   if (n == 4) {
	 * 	     throw 'four!';
	 *     }
	 *	   return n;
	 *   })
	 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
	 *   .subscribe(x => console.log(x));
	 *   // 1, 2, 3, I, II, III, IV, V
	 *
	 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 * 	   if (n === 4) {
	 * 	     throw 'four!';
	 *     }
	 * 	   return n;
	 *   })
	 *   .catch((err, caught) => caught)
	 *   .take(30)
	 *   .subscribe(x => console.log(x));
	 *   // 1, 2, 3, 1, 2, 3, ...
	 *
	 * @example <caption>Throws a new error when the source Observable throws an error</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 *     if (n == 4) {
	 *       throw 'four!';
	 *     }
	 *     return n;
	 *   })
	 *   .catch(err => {
	 *     throw 'error in source. Details: ' + err;
	 *   })
	 *   .subscribe(
	 *     x => console.log(x),
	 *     err => console.log(err)
	 *   );
	 *   // 1, 2, 3, error in source. Details: four!
	 *
	 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
	 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
	 *  is returned by the `selector` will be used to continue the observable chain.
	 * @return {Observable} An observable that originates from either the source or the observable returned by the
	 *  catch `selector` function.
	 * @name catchError
	 */
	function catchError(selector) {
	    return function catchErrorOperatorFunction(source) {
	        var operator = new CatchOperator(selector);
	        var caught = source.lift(operator);
	        return (operator.caught = caught);
	    };
	}
	exports.catchError = catchError;
	var CatchOperator = (function () {
	    function CatchOperator(selector) {
	        this.selector = selector;
	    }
	    CatchOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
	    };
	    return CatchOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var CatchSubscriber = (function (_super) {
	    __extends(CatchSubscriber, _super);
	    function CatchSubscriber(destination, selector, caught) {
	        _super.call(this, destination);
	        this.selector = selector;
	        this.caught = caught;
	    }
	    // NOTE: overriding `error` instead of `_error` because we don't want
	    // to have this flag this subscriber as `isStopped`. We can mimic the
	    // behavior of the RetrySubscriber (from the `retry` operator), where
	    // we unsubscribe from our source chain, reset our Subscriber flags,
	    // then subscribe to the selector result.
	    CatchSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var result = void 0;
	            try {
	                result = this.selector(err, this.caught);
	            }
	            catch (err2) {
	                _super.prototype.error.call(this, err2);
	                return;
	            }
	            this._unsubscribeAndRecycle();
	            this.add(subscribeToResult_1.subscribeToResult(this, result));
	        }
	    };
	    return CatchSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=catchError.js.map

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var combineLatest_1 = __webpack_require__(347);
	function combineAll(project) {
	    return function (source) { return source.lift(new combineLatest_1.CombineLatestOperator(project)); };
	}
	exports.combineAll = combineAll;
	//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concat_1 = __webpack_require__(265);
	var concat_2 = __webpack_require__(265);
	exports.concatStatic = concat_2.concat;
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which sequentially emits all values from every
	 * given input Observable after the current Observable.
	 *
	 * <span class="informal">Concatenates multiple Observables together by
	 * sequentially emitting their values, one Observable after the other.</span>
	 *
	 * <img src="./img/concat.png" width="100%">
	 *
	 * Joins this Observable with multiple other Observables by subscribing to them
	 * one at a time, starting with the source, and merging their results into the
	 * output Observable. Will wait for each Observable to complete before moving
	 * on to the next.
	 *
	 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
	 * var timer = Rx.Observable.interval(1000).take(4);
	 * var sequence = Rx.Observable.range(1, 10);
	 * var result = timer.concat(sequence);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in:
	 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
	 *
	 * @example <caption>Concatenate 3 Observables</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var result = timer1.concat(timer2, timer3);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in the following:
	 * // (Prints to console sequentially)
	 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
	 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
	 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
	 *
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 *
	 * @param {ObservableInput} other An input Observable to concatenate after the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
	 * Observable subscription on.
	 * @return {Observable} All values of each passed Observable merged into a
	 * single Observable, in order, in serial fashion.
	 * @method concat
	 * @owner Observable
	 */
	function concat() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return function (source) { return source.lift.call(concat_1.concat.apply(void 0, [source].concat(observables))); };
	}
	exports.concat = concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concatMap_1 = __webpack_require__(511);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is merged multiple
	 * times in a serialized fashion on the output Observable.
	 *
	 * <span class="informal">It's like {@link concatMap}, but maps each value
	 * always to the same inner Observable.</span>
	 *
	 * <img src="./img/concatMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then flattens those resulting Observables into one
	 * single Observable, which is the output Observable. Each new `innerObservable`
	 * instance emitted on the output Observable is concatenated with the previous
	 * `innerObservable` instance.
	 *
	 * __Warning:__ if source values arrive endlessly and faster than their
	 * corresponding inner Observables can complete, it will result in memory issues
	 * as inner Observables amass in an unbounded buffer waiting for their turn to
	 * be subscribed to.
	 *
	 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
	 * set to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link concat}
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link mergeMapTo}
	 * @see {@link switchMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An observable of values merged together by joining the
	 * passed observable with itself, one after the other, for each value emitted
	 * from the source.
	 * @method concatMapTo
	 * @owner Observable
	 */
	function concatMapTo(innerObservable, resultSelector) {
	    return concatMap_1.concatMap(function () { return innerObservable; }, resultSelector);
	}
	exports.concatMapTo = concatMapTo;
	//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/**
	 * Counts the number of emissions on the source and emits that number when the
	 * source completes.
	 *
	 * <span class="informal">Tells how many values were emitted, when the source
	 * completes.</span>
	 *
	 * <img src="./img/count.png" width="100%">
	 *
	 * `count` transforms an Observable that emits values into an Observable that
	 * emits a single value that represents the number of values emitted by the
	 * source Observable. If the source Observable terminates with an error, `count`
	 * will pass this error notification along without emitting a value first. If
	 * the source Observable does not terminate at all, `count` will neither emit
	 * a value nor terminate. This operator takes an optional `predicate` function
	 * as argument, in which case the output emission will represent the number of
	 * source values that matched `true` with the `predicate`.
	 *
	 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
	 * var seconds = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var secondsBeforeClick = seconds.takeUntil(clicks);
	 * var result = secondsBeforeClick.count();
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
	 * var numbers = Rx.Observable.range(1, 7);
	 * var result = numbers.count(i => i % 2 === 1);
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // 4
	 *
	 * @see {@link max}
	 * @see {@link min}
	 * @see {@link reduce}
	 *
	 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
	 * boolean function to select what values are to be counted. It is provided with
	 * arguments of:
	 * - `value`: the value from the source Observable.
	 * - `index`: the (zero-based) "index" of the value from the source Observable.
	 * - `source`: the source Observable instance itself.
	 * @return {Observable} An Observable of one number that represents the count as
	 * described above.
	 * @method count
	 * @owner Observable
	 */
	function count(predicate) {
	    return function (source) { return source.lift(new CountOperator(predicate, source)); };
	}
	exports.count = count;
	var CountOperator = (function () {
	    function CountOperator(predicate, source) {
	        this.predicate = predicate;
	        this.source = source;
	    }
	    CountOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
	    };
	    return CountOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var CountSubscriber = (function (_super) {
	    __extends(CountSubscriber, _super);
	    function CountSubscriber(destination, predicate, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.source = source;
	        this.count = 0;
	        this.index = 0;
	    }
	    CountSubscriber.prototype._next = function (value) {
	        if (this.predicate) {
	            this._tryPredicate(value);
	        }
	        else {
	            this.count++;
	        }
	    };
	    CountSubscriber.prototype._tryPredicate = function (value) {
	        var result;
	        try {
	            result = this.predicate(value, this.index++, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            this.count++;
	        }
	    };
	    CountSubscriber.prototype._complete = function () {
	        this.destination.next(this.count);
	        this.destination.complete();
	    };
	    return CountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=count.js.map

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/**
	 * Emits a value from the source Observable only after a particular time span
	 * determined by another Observable has passed without another source emission.
	 *
	 * <span class="informal">It's like {@link debounceTime}, but the time span of
	 * emission silence is determined by a second Observable.</span>
	 *
	 * <img src="./img/debounce.png" width="100%">
	 *
	 * `debounce` delays values emitted by the source Observable, but drops previous
	 * pending delayed emissions if a new value arrives on the source Observable.
	 * This operator keeps track of the most recent value from the source
	 * Observable, and spawns a duration Observable by calling the
	 * `durationSelector` function. The value is emitted only when the duration
	 * Observable emits a value or completes, and if no other value was emitted on
	 * the source Observable since the duration Observable was spawned. If a new
	 * value appears before the duration Observable emits, the previous value will
	 * be dropped and will not be emitted on the output Observable.
	 *
	 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
	 * delay-like operator since output emissions do not necessarily occur at the
	 * same time as they did on the source Observable.
	 *
	 * @example <caption>Emit the most recent click after a burst of clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounceTime}
	 * @see {@link delayWhen}
	 * @see {@link throttle}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the timeout
	 * duration for each source value, returned as an Observable or a Promise.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified duration Observable returned by
	 * `durationSelector`, and may drop some values if they occur too frequently.
	 * @method debounce
	 * @owner Observable
	 */
	function debounce(durationSelector) {
	    return function (source) { return source.lift(new DebounceOperator(durationSelector)); };
	}
	exports.debounce = debounce;
	var DebounceOperator = (function () {
	    function DebounceOperator(durationSelector) {
	        this.durationSelector = durationSelector;
	    }
	    DebounceOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
	    };
	    return DebounceOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DebounceSubscriber = (function (_super) {
	    __extends(DebounceSubscriber, _super);
	    function DebounceSubscriber(destination, durationSelector) {
	        _super.call(this, destination);
	        this.durationSelector = durationSelector;
	        this.hasValue = false;
	        this.durationSubscription = null;
	    }
	    DebounceSubscriber.prototype._next = function (value) {
	        try {
	            var result = this.durationSelector.call(this, value);
	            if (result) {
	                this._tryNext(value, result);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    DebounceSubscriber.prototype._complete = function () {
	        this.emitValue();
	        this.destination.complete();
	    };
	    DebounceSubscriber.prototype._tryNext = function (value, duration) {
	        var subscription = this.durationSubscription;
	        this.value = value;
	        this.hasValue = true;
	        if (subscription) {
	            subscription.unsubscribe();
	            this.remove(subscription);
	        }
	        subscription = subscribeToResult_1.subscribeToResult(this, duration);
	        if (!subscription.closed) {
	            this.add(this.durationSubscription = subscription);
	        }
	    };
	    DebounceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.emitValue();
	    };
	    DebounceSubscriber.prototype.notifyComplete = function () {
	        this.emitValue();
	    };
	    DebounceSubscriber.prototype.emitValue = function () {
	        if (this.hasValue) {
	            var value = this.value;
	            var subscription = this.durationSubscription;
	            if (subscription) {
	                this.durationSubscription = null;
	                subscription.unsubscribe();
	                this.remove(subscription);
	            }
	            this.value = null;
	            this.hasValue = false;
	            _super.prototype._next.call(this, value);
	        }
	    };
	    return DebounceSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=debounce.js.map

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var async_1 = __webpack_require__(23);
	/**
	 * Emits a value from the source Observable only after a particular time span
	 * has passed without another source emission.
	 *
	 * <span class="informal">It's like {@link delay}, but passes only the most
	 * recent value from each burst of emissions.</span>
	 *
	 * <img src="./img/debounceTime.png" width="100%">
	 *
	 * `debounceTime` delays values emitted by the source Observable, but drops
	 * previous pending delayed emissions if a new value arrives on the source
	 * Observable. This operator keeps track of the most recent value from the
	 * source Observable, and emits that only when `dueTime` enough time has passed
	 * without any other value appearing on the source Observable. If a new value
	 * appears before `dueTime` silence occurs, the previous value will be dropped
	 * and will not be emitted on the output Observable.
	 *
	 * This is a rate-limiting operator, because it is impossible for more than one
	 * value to be emitted in any time window of duration `dueTime`, but it is also
	 * a delay-like operator since output emissions do not occur at the same time as
	 * they did on the source Observable. Optionally takes a {@link IScheduler} for
	 * managing timers.
	 *
	 * @example <caption>Emit the most recent click after a burst of clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.debounceTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounce}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttleTime}
	 *
	 * @param {number} dueTime The timeout duration in milliseconds (or the time
	 * unit determined internally by the optional `scheduler`) for the window of
	 * time required to wait for emission silence before emitting the most recent
	 * source value.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the timeout for each value.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified `dueTime`, and may drop some values if they occur
	 * too frequently.
	 * @method debounceTime
	 * @owner Observable
	 */
	function debounceTime(dueTime, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return function (source) { return source.lift(new DebounceTimeOperator(dueTime, scheduler)); };
	}
	exports.debounceTime = debounceTime;
	var DebounceTimeOperator = (function () {
	    function DebounceTimeOperator(dueTime, scheduler) {
	        this.dueTime = dueTime;
	        this.scheduler = scheduler;
	    }
	    DebounceTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
	    };
	    return DebounceTimeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DebounceTimeSubscriber = (function (_super) {
	    __extends(DebounceTimeSubscriber, _super);
	    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
	        _super.call(this, destination);
	        this.dueTime = dueTime;
	        this.scheduler = scheduler;
	        this.debouncedSubscription = null;
	        this.lastValue = null;
	        this.hasValue = false;
	    }
	    DebounceTimeSubscriber.prototype._next = function (value) {
	        this.clearDebounce();
	        this.lastValue = value;
	        this.hasValue = true;
	        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
	    };
	    DebounceTimeSubscriber.prototype._complete = function () {
	        this.debouncedNext();
	        this.destination.complete();
	    };
	    DebounceTimeSubscriber.prototype.debouncedNext = function () {
	        this.clearDebounce();
	        if (this.hasValue) {
	            this.destination.next(this.lastValue);
	            this.lastValue = null;
	            this.hasValue = false;
	        }
	    };
	    DebounceTimeSubscriber.prototype.clearDebounce = function () {
	        var debouncedSubscription = this.debouncedSubscription;
	        if (debouncedSubscription !== null) {
	            this.remove(debouncedSubscription);
	            debouncedSubscription.unsubscribe();
	            this.debouncedSubscription = null;
	        }
	    };
	    return DebounceTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchNext(subscriber) {
	    subscriber.debouncedNext();
	}
	//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var async_1 = __webpack_require__(23);
	var isDate_1 = __webpack_require__(359);
	var Subscriber_1 = __webpack_require__(11);
	var Notification_1 = __webpack_require__(264);
	/**
	 * Delays the emission of items from the source Observable by a given timeout or
	 * until a given Date.
	 *
	 * <span class="informal">Time shifts each item by some specified amount of
	 * milliseconds.</span>
	 *
	 * <img src="./img/delay.png" width="100%">
	 *
	 * If the delay argument is a Number, this operator time shifts the source
	 * Observable by that amount of time expressed in milliseconds. The relative
	 * time intervals between the values are preserved.
	 *
	 * If the delay argument is a Date, this operator time shifts the start of the
	 * Observable execution until the given date occurs.
	 *
	 * @example <caption>Delay each click by one second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @example <caption>Delay all clicks until a future date happens</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var date = new Date('March 15, 2050 12:00:00'); // in the future
	 * var delayedClicks = clicks.delay(date); // click emitted only after that date
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @see {@link debounceTime}
	 * @see {@link delayWhen}
	 *
	 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
	 * a `Date` until which the emission of the source items is delayed.
	 * @param {Scheduler} [scheduler=async] The IScheduler to use for
	 * managing the timers that handle the time-shift for each item.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified timeout or Date.
	 * @method delay
	 * @owner Observable
	 */
	function delay(delay, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    var absoluteDelay = isDate_1.isDate(delay);
	    var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
	    return function (source) { return source.lift(new DelayOperator(delayFor, scheduler)); };
	}
	exports.delay = delay;
	var DelayOperator = (function () {
	    function DelayOperator(delay, scheduler) {
	        this.delay = delay;
	        this.scheduler = scheduler;
	    }
	    DelayOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
	    };
	    return DelayOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DelaySubscriber = (function (_super) {
	    __extends(DelaySubscriber, _super);
	    function DelaySubscriber(destination, delay, scheduler) {
	        _super.call(this, destination);
	        this.delay = delay;
	        this.scheduler = scheduler;
	        this.queue = [];
	        this.active = false;
	        this.errored = false;
	    }
	    DelaySubscriber.dispatch = function (state) {
	        var source = state.source;
	        var queue = source.queue;
	        var scheduler = state.scheduler;
	        var destination = state.destination;
	        while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
	            queue.shift().notification.observe(destination);
	        }
	        if (queue.length > 0) {
	            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
	            this.schedule(state, delay_1);
	        }
	        else {
	            source.active = false;
	        }
	    };
	    DelaySubscriber.prototype._schedule = function (scheduler) {
	        this.active = true;
	        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
	            source: this, destination: this.destination, scheduler: scheduler
	        }));
	    };
	    DelaySubscriber.prototype.scheduleNotification = function (notification) {
	        if (this.errored === true) {
	            return;
	        }
	        var scheduler = this.scheduler;
	        var message = new DelayMessage(scheduler.now() + this.delay, notification);
	        this.queue.push(message);
	        if (this.active === false) {
	            this._schedule(scheduler);
	        }
	    };
	    DelaySubscriber.prototype._next = function (value) {
	        this.scheduleNotification(Notification_1.Notification.createNext(value));
	    };
	    DelaySubscriber.prototype._error = function (err) {
	        this.errored = true;
	        this.queue = [];
	        this.destination.error(err);
	    };
	    DelaySubscriber.prototype._complete = function () {
	        this.scheduleNotification(Notification_1.Notification.createComplete());
	    };
	    return DelaySubscriber;
	}(Subscriber_1.Subscriber));
	var DelayMessage = (function () {
	    function DelayMessage(time, notification) {
	        this.time = time;
	        this.notification = notification;
	    }
	    return DelayMessage;
	}());
	//# sourceMappingURL=delay.js.map

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(4);
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/**
	 * Delays the emission of items from the source Observable by a given time span
	 * determined by the emissions of another Observable.
	 *
	 * <span class="informal">It's like {@link delay}, but the time span of the
	 * delay duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/delayWhen.png" width="100%">
	 *
	 * `delayWhen` time shifts each emitted value from the source Observable by a
	 * time span determined by another Observable. When the source emits a value,
	 * the `delayDurationSelector` function is called with the source value as
	 * argument, and should return an Observable, called the "duration" Observable.
	 * The source value is emitted on the output Observable only when the duration
	 * Observable emits a value or completes.
	 *
	 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
	 * is an Observable. When `subscriptionDelay` emits its first value or
	 * completes, the source Observable is subscribed to and starts behaving like
	 * described in the previous paragraph. If `subscriptionDelay` is not provided,
	 * `delayWhen` will subscribe to the source Observable as soon as the output
	 * Observable is subscribed.
	 *
	 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var delayedClicks = clicks.delayWhen(event =>
	 *   Rx.Observable.interval(Math.random() * 5000)
	 * );
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @see {@link debounce}
	 * @see {@link delay}
	 *
	 * @param {function(value: T): Observable} delayDurationSelector A function that
	 * returns an Observable for each value emitted by the source Observable, which
	 * is then used to delay the emission of that item on the output Observable
	 * until the Observable returned from this function emits a value.
	 * @param {Observable} subscriptionDelay An Observable that triggers the
	 * subscription to the source Observable once it emits any value.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by an amount of time specified by the Observable returned by
	 * `delayDurationSelector`.
	 * @method delayWhen
	 * @owner Observable
	 */
	function delayWhen(delayDurationSelector, subscriptionDelay) {
	    if (subscriptionDelay) {
	        return function (source) {
	            return new SubscriptionDelayObservable(source, subscriptionDelay)
	                .lift(new DelayWhenOperator(delayDurationSelector));
	        };
	    }
	    return function (source) { return source.lift(new DelayWhenOperator(delayDurationSelector)); };
	}
	exports.delayWhen = delayWhen;
	var DelayWhenOperator = (function () {
	    function DelayWhenOperator(delayDurationSelector) {
	        this.delayDurationSelector = delayDurationSelector;
	    }
	    DelayWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
	    };
	    return DelayWhenOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DelayWhenSubscriber = (function (_super) {
	    __extends(DelayWhenSubscriber, _super);
	    function DelayWhenSubscriber(destination, delayDurationSelector) {
	        _super.call(this, destination);
	        this.delayDurationSelector = delayDurationSelector;
	        this.completed = false;
	        this.delayNotifierSubscriptions = [];
	        this.values = [];
	    }
	    DelayWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.destination.next(outerValue);
	        this.removeSubscription(innerSub);
	        this.tryComplete();
	    };
	    DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
	        var value = this.removeSubscription(innerSub);
	        if (value) {
	            this.destination.next(value);
	        }
	        this.tryComplete();
	    };
	    DelayWhenSubscriber.prototype._next = function (value) {
	        try {
	            var delayNotifier = this.delayDurationSelector(value);
	            if (delayNotifier) {
	                this.tryDelay(delayNotifier, value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    DelayWhenSubscriber.prototype._complete = function () {
	        this.completed = true;
	        this.tryComplete();
	    };
	    DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
	        subscription.unsubscribe();
	        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
	        var value = null;
	        if (subscriptionIdx !== -1) {
	            value = this.values[subscriptionIdx];
	            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
	            this.values.splice(subscriptionIdx, 1);
	        }
	        return value;
	    };
	    DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
	        var notifierSubscription = subscribeToResult_1.subscribeToResult(this, delayNotifier, value);
	        if (notifierSubscription && !notifierSubscription.closed) {
	            this.add(notifierSubscription);
	            this.delayNotifierSubscriptions.push(notifierSubscription);
	        }
	        this.values.push(value);
	    };
	    DelayWhenSubscriber.prototype.tryComplete = function () {
	        if (this.completed && this.delayNotifierSubscriptions.length === 0) {
	            this.destination.complete();
	        }
	    };
	    return DelayWhenSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SubscriptionDelayObservable = (function (_super) {
	    __extends(SubscriptionDelayObservable, _super);
	    function SubscriptionDelayObservable(source, subscriptionDelay) {
	        _super.call(this);
	        this.source = source;
	        this.subscriptionDelay = subscriptionDelay;
	    }
	    SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
	        this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
	    };
	    return SubscriptionDelayObservable;
	}(Observable_1.Observable));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SubscriptionDelaySubscriber = (function (_super) {
	    __extends(SubscriptionDelaySubscriber, _super);
	    function SubscriptionDelaySubscriber(parent, source) {
	        _super.call(this);
	        this.parent = parent;
	        this.source = source;
	        this.sourceSubscribed = false;
	    }
	    SubscriptionDelaySubscriber.prototype._next = function (unused) {
	        this.subscribeToSource();
	    };
	    SubscriptionDelaySubscriber.prototype._error = function (err) {
	        this.unsubscribe();
	        this.parent.error(err);
	    };
	    SubscriptionDelaySubscriber.prototype._complete = function () {
	        this.subscribeToSource();
	    };
	    SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
	        if (!this.sourceSubscribed) {
	            this.sourceSubscribed = true;
	            this.unsubscribe();
	            this.source.subscribe(this.parent);
	        }
	    };
	    return SubscriptionDelaySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/**
	 * Converts an Observable of {@link Notification} objects into the emissions
	 * that they represent.
	 *
	 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
	 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
	 *
	 * <img src="./img/dematerialize.png" width="100%">
	 *
	 * `dematerialize` is assumed to operate an Observable that only emits
	 * {@link Notification} objects as `next` emissions, and does not emit any
	 * `error`. Such Observable is the output of a `materialize` operation. Those
	 * notifications are then unwrapped using the metadata they contain, and emitted
	 * as `next`, `error`, and `complete` on the output Observable.
	 *
	 * Use this operator in conjunction with {@link materialize}.
	 *
	 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
	 * var notifA = new Rx.Notification('N', 'A');
	 * var notifB = new Rx.Notification('N', 'B');
	 * var notifE = new Rx.Notification('E', void 0,
	 *   new TypeError('x.toUpperCase is not a function')
	 * );
	 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
	 * var upperCase = materialized.dematerialize();
	 * upperCase.subscribe(x => console.log(x), e => console.error(e));
	 *
	 * // Results in:
	 * // A
	 * // B
	 * // TypeError: x.toUpperCase is not a function
	 *
	 * @see {@link Notification}
	 * @see {@link materialize}
	 *
	 * @return {Observable} An Observable that emits items and notifications
	 * embedded in Notification objects emitted by the source Observable.
	 * @method dematerialize
	 * @owner Observable
	 */
	function dematerialize() {
	    return function dematerializeOperatorFunction(source) {
	        return source.lift(new DeMaterializeOperator());
	    };
	}
	exports.dematerialize = dematerialize;
	var DeMaterializeOperator = (function () {
	    function DeMaterializeOperator() {
	    }
	    DeMaterializeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DeMaterializeSubscriber(subscriber));
	    };
	    return DeMaterializeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DeMaterializeSubscriber = (function (_super) {
	    __extends(DeMaterializeSubscriber, _super);
	    function DeMaterializeSubscriber(destination) {
	        _super.call(this, destination);
	    }
	    DeMaterializeSubscriber.prototype._next = function (value) {
	        value.observe(this.destination);
	    };
	    return DeMaterializeSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	var Set_1 = __webpack_require__(4753);
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
	 *
	 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
	 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
	 * source observable directly with an equality check against previous values.
	 *
	 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
	 *
	 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
	 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
	 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
	 * that the internal `Set` can be "flushed", basically clearing it of values.
	 *
	 * @example <caption>A simple example with numbers</caption>
	 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
	 *   .distinct()
	 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
	 *
	 * @example <caption>An example using a keySelector function</caption>
	 * interface Person {
	 *    age: number,
	 *    name: string
	 * }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'})
	 *     .distinct((p: Person) => p.name)
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 *
	 * @see {@link distinctUntilChanged}
	 * @see {@link distinctUntilKeyChanged}
	 *
	 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
	 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
	 * @method distinct
	 * @owner Observable
	 */
	function distinct(keySelector, flushes) {
	    return function (source) { return source.lift(new DistinctOperator(keySelector, flushes)); };
	}
	exports.distinct = distinct;
	var DistinctOperator = (function () {
	    function DistinctOperator(keySelector, flushes) {
	        this.keySelector = keySelector;
	        this.flushes = flushes;
	    }
	    DistinctOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DistinctSubscriber(subscriber, this.keySelector, this.flushes));
	    };
	    return DistinctOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DistinctSubscriber = (function (_super) {
	    __extends(DistinctSubscriber, _super);
	    function DistinctSubscriber(destination, keySelector, flushes) {
	        _super.call(this, destination);
	        this.keySelector = keySelector;
	        this.values = new Set_1.Set();
	        if (flushes) {
	            this.add(subscribeToResult_1.subscribeToResult(this, flushes));
	        }
	    }
	    DistinctSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.values.clear();
	    };
	    DistinctSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    DistinctSubscriber.prototype._next = function (value) {
	        if (this.keySelector) {
	            this._useKeySelector(value);
	        }
	        else {
	            this._finalizeNext(value, value);
	        }
	    };
	    DistinctSubscriber.prototype._useKeySelector = function (value) {
	        var key;
	        var destination = this.destination;
	        try {
	            key = this.keySelector(value);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        this._finalizeNext(key, value);
	    };
	    DistinctSubscriber.prototype._finalizeNext = function (key, value) {
	        var values = this.values;
	        if (!values.has(key)) {
	            values.add(key);
	            this.destination.next(value);
	        }
	    };
	    return DistinctSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.DistinctSubscriber = DistinctSubscriber;
	//# sourceMappingURL=distinct.js.map

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var distinctUntilChanged_1 = __webpack_require__(513);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
	 * using a property accessed by using the key provided to check if the two items are distinct.
	 *
	 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
	 *
	 * If a comparator function is not provided, an equality check is used by default.
	 *
	 * @example <caption>An example comparing the name of persons</caption>
	 *
	 *  interface Person {
	 *     age: number,
	 *     name: string
	 *  }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'},
	 *     { age: 6, name: 'Foo'})
	 *     .distinctUntilKeyChanged('name')
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo' }
	 *
	 * @example <caption>An example comparing the first letters of the name</caption>
	 *
	 * interface Person {
	 *     age: number,
	 *     name: string
	 *  }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo1'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo2'},
	 *     { age: 6, name: 'Foo3'})
	 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo1' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo2' }
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilChanged}
	 *
	 * @param {string} key String key for object property lookup on each item.
	 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
	 * @method distinctUntilKeyChanged
	 * @owner Observable
	 */
	function distinctUntilKeyChanged(key, compare) {
	    return distinctUntilChanged_1.distinctUntilChanged(function (x, y) { return compare ? compare(x[key], y[key]) : x[key] === y[key]; });
	}
	exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
	//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var ArgumentOutOfRangeError_1 = __webpack_require__(271);
	/**
	 * Emits the single value at the specified `index` in a sequence of emissions
	 * from the source Observable.
	 *
	 * <span class="informal">Emits only the i-th value, then completes.</span>
	 *
	 * <img src="./img/elementAt.png" width="100%">
	 *
	 * `elementAt` returns an Observable that emits the item at the specified
	 * `index` in the source Observable, or a default value if that `index` is out
	 * of range and the `default` argument is provided. If the `default` argument is
	 * not given and the `index` is out of range, the output Observable will emit an
	 * `ArgumentOutOfRangeError` error.
	 *
	 * @example <caption>Emit only the third click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.elementAt(2);
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // click 1 = nothing
	 * // click 2 = nothing
	 * // click 3 = MouseEvent object logged to console
	 *
	 * @see {@link first}
	 * @see {@link last}
	 * @see {@link skip}
	 * @see {@link single}
	 * @see {@link take}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
	 * Observable has completed before emitting the i-th `next` notification.
	 *
	 * @param {number} index Is the number `i` for the i-th source emission that has
	 * happened since the subscription, starting from the number `0`.
	 * @param {T} [defaultValue] The default value returned for missing indices.
	 * @return {Observable} An Observable that emits a single item, if it is found.
	 * Otherwise, will emit the default value if given. If not, then emits an error.
	 * @method elementAt
	 * @owner Observable
	 */
	function elementAt(index, defaultValue) {
	    return function (source) { return source.lift(new ElementAtOperator(index, defaultValue)); };
	}
	exports.elementAt = elementAt;
	var ElementAtOperator = (function () {
	    function ElementAtOperator(index, defaultValue) {
	        this.index = index;
	        this.defaultValue = defaultValue;
	        if (index < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    ElementAtOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ElementAtSubscriber(subscriber, this.index, this.defaultValue));
	    };
	    return ElementAtOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ElementAtSubscriber = (function (_super) {
	    __extends(ElementAtSubscriber, _super);
	    function ElementAtSubscriber(destination, index, defaultValue) {
	        _super.call(this, destination);
	        this.index = index;
	        this.defaultValue = defaultValue;
	    }
	    ElementAtSubscriber.prototype._next = function (x) {
	        if (this.index-- === 0) {
	            this.destination.next(x);
	            this.destination.complete();
	        }
	    };
	    ElementAtSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (this.index >= 0) {
	            if (typeof this.defaultValue !== 'undefined') {
	                destination.next(this.defaultValue);
	            }
	            else {
	                destination.error(new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError);
	            }
	        }
	        destination.complete();
	    };
	    return ElementAtSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/**
	 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
	 *
	 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
	 *  Observable.of(1, 2, 3, 4, 5, 6)
	 *     .every(x => x < 5)
	 *     .subscribe(x => console.log(x)); // -> false
	 *
	 * @param {function} predicate A function for determining if an item meets a specified condition.
	 * @param {any} [thisArg] Optional object to use for `this` in the callback.
	 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
	 * @method every
	 * @owner Observable
	 */
	function every(predicate, thisArg) {
	    return function (source) { return source.lift(new EveryOperator(predicate, thisArg, source)); };
	}
	exports.every = every;
	var EveryOperator = (function () {
	    function EveryOperator(predicate, thisArg, source) {
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	        this.source = source;
	    }
	    EveryOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
	    };
	    return EveryOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var EverySubscriber = (function (_super) {
	    __extends(EverySubscriber, _super);
	    function EverySubscriber(destination, predicate, thisArg, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	        this.source = source;
	        this.index = 0;
	        this.thisArg = thisArg || this;
	    }
	    EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
	        this.destination.next(everyValueMatch);
	        this.destination.complete();
	    };
	    EverySubscriber.prototype._next = function (value) {
	        var result = false;
	        try {
	            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (!result) {
	            this.notifyComplete(false);
	        }
	    };
	    EverySubscriber.prototype._complete = function () {
	        this.notifyComplete(true);
	    };
	    return EverySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=every.js.map

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/**
	 * Converts a higher-order Observable into a first-order Observable by dropping
	 * inner Observables while the previous inner Observable has not yet completed.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by dropping the
	 * next inner Observables while the current inner is still executing.</span>
	 *
	 * <img src="./img/exhaust.png" width="100%">
	 *
	 * `exhaust` subscribes to an Observable that emits Observables, also known as a
	 * higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, the output Observable begins emitting the items emitted by that
	 * inner Observable. So far, it behaves like {@link mergeAll}. However,
	 * `exhaust` ignores every new inner Observable if the previous Observable has
	 * not yet completed. Once that one completes, it will accept and flatten the
	 * next inner Observable and repeat this process.
	 *
	 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
	 * var result = higherOrder.exhaust();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link switch}
	 * @see {@link mergeAll}
	 * @see {@link exhaustMap}
	 * @see {@link zipAll}
	 *
	 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
	 * exclusively until it completes before subscribing to the next.
	 * @method exhaust
	 * @owner Observable
	 */
	function exhaust() {
	    return function (source) { return source.lift(new SwitchFirstOperator()); };
	}
	exports.exhaust = exhaust;
	var SwitchFirstOperator = (function () {
	    function SwitchFirstOperator() {
	    }
	    SwitchFirstOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SwitchFirstSubscriber(subscriber));
	    };
	    return SwitchFirstOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchFirstSubscriber = (function (_super) {
	    __extends(SwitchFirstSubscriber, _super);
	    function SwitchFirstSubscriber(destination) {
	        _super.call(this, destination);
	        this.hasCompleted = false;
	        this.hasSubscription = false;
	    }
	    SwitchFirstSubscriber.prototype._next = function (value) {
	        if (!this.hasSubscription) {
	            this.hasSubscription = true;
	            this.add(subscribeToResult_1.subscribeToResult(this, value));
	        }
	    };
	    SwitchFirstSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (!this.hasSubscription) {
	            this.destination.complete();
	        }
	    };
	    SwitchFirstSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.remove(innerSub);
	        this.hasSubscription = false;
	        if (this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return SwitchFirstSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable only if the previous projected Observable has completed.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link exhaust}.</span>
	 *
	 * <img src="./img/exhaustMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. When it projects a source value to
	 * an Observable, the output Observable begins emitting the items emitted by
	 * that projected Observable. However, `exhaustMap` ignores every new projected
	 * Observable if the previous projected Observable has not yet completed. Once
	 * that one completes, it will accept and flatten the next projected Observable
	 * and repeat this process.
	 *
	 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaust}
	 * @see {@link mergeMap}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable containing projected Observables
	 * of each item of the source, ignoring projected Observables that start before
	 * their preceding Observable has completed.
	 * @method exhaustMap
	 * @owner Observable
	 */
	function exhaustMap(project, resultSelector) {
	    return function (source) { return source.lift(new SwitchFirstMapOperator(project, resultSelector)); };
	}
	exports.exhaustMap = exhaustMap;
	var SwitchFirstMapOperator = (function () {
	    function SwitchFirstMapOperator(project, resultSelector) {
	        this.project = project;
	        this.resultSelector = resultSelector;
	    }
	    SwitchFirstMapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SwitchFirstMapSubscriber(subscriber, this.project, this.resultSelector));
	    };
	    return SwitchFirstMapOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchFirstMapSubscriber = (function (_super) {
	    __extends(SwitchFirstMapSubscriber, _super);
	    function SwitchFirstMapSubscriber(destination, project, resultSelector) {
	        _super.call(this, destination);
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.hasSubscription = false;
	        this.hasCompleted = false;
	        this.index = 0;
	    }
	    SwitchFirstMapSubscriber.prototype._next = function (value) {
	        if (!this.hasSubscription) {
	            this.tryNext(value);
	        }
	    };
	    SwitchFirstMapSubscriber.prototype.tryNext = function (value) {
	        var index = this.index++;
	        var destination = this.destination;
	        try {
	            var result = this.project(value, index);
	            this.hasSubscription = true;
	            this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
	        }
	        catch (err) {
	            destination.error(err);
	        }
	    };
	    SwitchFirstMapSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (!this.hasSubscription) {
	            this.destination.complete();
	        }
	    };
	    SwitchFirstMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        if (resultSelector) {
	            this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            destination.next(innerValue);
	        }
	    };
	    SwitchFirstMapSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        try {
	            var result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	            destination.next(result);
	        }
	        catch (err) {
	            destination.error(err);
	        }
	    };
	    SwitchFirstMapSubscriber.prototype.notifyError = function (err) {
	        this.destination.error(err);
	    };
	    SwitchFirstMapSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.remove(innerSub);
	        this.hasSubscription = false;
	        if (this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return SwitchFirstMapSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var tryCatch_1 = __webpack_require__(34);
	var errorObject_1 = __webpack_require__(32);
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/* tslint:enable:max-line-length */
	/**
	 * Recursively projects each source value to an Observable which is merged in
	 * the output Observable.
	 *
	 * <span class="informal">It's similar to {@link mergeMap}, but applies the
	 * projection function to every source value as well as every output value.
	 * It's recursive.</span>
	 *
	 * <img src="./img/expand.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an Observable, and then merging those resulting Observables and
	 * emitting the results of this merger. *Expand* will re-emit on the output
	 * Observable every source value. Then, each output value is given to the
	 * `project` function which returns an inner Observable to be merged on the
	 * output Observable. Those output values resulting from the projection are also
	 * given to the `project` function to produce new output values. This is how
	 * *expand* behaves recursively.
	 *
	 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var powersOfTwo = clicks
	 *   .mapTo(1)
	 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
	 *   .take(10);
	 * powersOfTwo.subscribe(x => console.log(x));
	 *
	 * @see {@link mergeMap}
	 * @see {@link mergeScan}
	 *
	 * @param {function(value: T, index: number) => Observable} project A function
	 * that, when applied to an item emitted by the source or the output Observable,
	 * returns an Observable.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
	 * each projected inner Observable.
	 * @return {Observable} An Observable that emits the source values and also
	 * result of applying the projection function to each value emitted on the
	 * output Observable and and merging the results of the Observables obtained
	 * from this transformation.
	 * @method expand
	 * @owner Observable
	 */
	function expand(project, concurrent, scheduler) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    if (scheduler === void 0) { scheduler = undefined; }
	    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
	    return function (source) { return source.lift(new ExpandOperator(project, concurrent, scheduler)); };
	}
	exports.expand = expand;
	var ExpandOperator = (function () {
	    function ExpandOperator(project, concurrent, scheduler) {
	        this.project = project;
	        this.concurrent = concurrent;
	        this.scheduler = scheduler;
	    }
	    ExpandOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
	    };
	    return ExpandOperator;
	}());
	exports.ExpandOperator = ExpandOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ExpandSubscriber = (function (_super) {
	    __extends(ExpandSubscriber, _super);
	    function ExpandSubscriber(destination, project, concurrent, scheduler) {
	        _super.call(this, destination);
	        this.project = project;
	        this.concurrent = concurrent;
	        this.scheduler = scheduler;
	        this.index = 0;
	        this.active = 0;
	        this.hasCompleted = false;
	        if (concurrent < Number.POSITIVE_INFINITY) {
	            this.buffer = [];
	        }
	    }
	    ExpandSubscriber.dispatch = function (arg) {
	        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
	        subscriber.subscribeToProjection(result, value, index);
	    };
	    ExpandSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        if (destination.closed) {
	            this._complete();
	            return;
	        }
	        var index = this.index++;
	        if (this.active < this.concurrent) {
	            destination.next(value);
	            var result = tryCatch_1.tryCatch(this.project)(value, index);
	            if (result === errorObject_1.errorObject) {
	                destination.error(errorObject_1.errorObject.e);
	            }
	            else if (!this.scheduler) {
	                this.subscribeToProjection(result, value, index);
	            }
	            else {
	                var state = { subscriber: this, result: result, value: value, index: index };
	                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
	            }
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
	        this.active++;
	        this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
	    };
	    ExpandSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.hasCompleted && this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    ExpandSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this._next(innerValue);
	    };
	    ExpandSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer && buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        if (this.hasCompleted && this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    return ExpandSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.ExpandSubscriber = ExpandSubscriber;
	//# sourceMappingURL=expand.js.map

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var Subscription_1 = __webpack_require__(31);
	/**
	 * Returns an Observable that mirrors the source Observable, but will call a specified function when
	 * the source terminates on complete or error.
	 * @param {function} callback Function to be called when source terminates.
	 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
	 * @method finally
	 * @owner Observable
	 */
	function finalize(callback) {
	    return function (source) { return source.lift(new FinallyOperator(callback)); };
	}
	exports.finalize = finalize;
	var FinallyOperator = (function () {
	    function FinallyOperator(callback) {
	        this.callback = callback;
	    }
	    FinallyOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new FinallySubscriber(subscriber, this.callback));
	    };
	    return FinallyOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var FinallySubscriber = (function (_super) {
	    __extends(FinallySubscriber, _super);
	    function FinallySubscriber(destination, callback) {
	        _super.call(this, destination);
	        this.add(new Subscription_1.Subscription(callback));
	    }
	    return FinallySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=finalize.js.map

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var find_1 = __webpack_require__(514);
	/**
	 * Emits only the index of the first value emitted by the source Observable that
	 * meets some condition.
	 *
	 * <span class="informal">It's like {@link find}, but emits the index of the
	 * found value, not the value itself.</span>
	 *
	 * <img src="./img/findIndex.png" width="100%">
	 *
	 * `findIndex` searches for the first item in the source Observable that matches
	 * the specified condition embodied by the `predicate`, and returns the
	 * (zero-based) index of the first occurrence in the source. Unlike
	 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
	 * an error if a valid value is not found.
	 *
	 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link find}
	 * @see {@link first}
	 * @see {@link take}
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
	 * A function called with each item to test for condition matching.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable} An Observable of the index of the first item that
	 * matches the condition.
	 * @method find
	 * @owner Observable
	 */
	function findIndex(predicate, thisArg) {
	    return function (source) { return source.lift(new find_1.FindValueOperator(predicate, source, true, thisArg)); };
	}
	exports.findIndex = findIndex;
	//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var EmptyError_1 = __webpack_require__(357);
	/**
	 * Emits only the first value (or the first value that meets some condition)
	 * emitted by the source Observable.
	 *
	 * <span class="informal">Emits only the first value. Or emits only the first
	 * value that passes some test.</span>
	 *
	 * <img src="./img/first.png" width="100%">
	 *
	 * If called with no arguments, `first` emits the first value of the source
	 * Observable, then completes. If called with a `predicate` function, `first`
	 * emits the first value of the source that matches the specified condition. It
	 * may also take a `resultSelector` function to produce the output value from
	 * the input value, and a `defaultValue` to emit in case the source completes
	 * before it is able to emit a valid value. Throws an error if `defaultValue`
	 * was not provided and a matching element is not found.
	 *
	 * @example <caption>Emit only the first click that happens on the DOM</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.first();
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Emits the first click that happens on a DIV</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link find}
	 * @see {@link take}
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
	 * An optional function called with each item to test for condition matching.
	 * @param {function(value: T, index: number): R} [resultSelector] A function to
	 * produce the value on the output Observable based on the values
	 * and the indices of the source Observable. The arguments passed to this
	 * function are:
	 * - `value`: the value that was emitted on the source.
	 * - `index`: the "index" of the value from the source.
	 * @param {R} [defaultValue] The default value emitted in case no valid value
	 * was found on the source.
	 * @return {Observable<T|R>} An Observable of the first item that matches the
	 * condition.
	 * @method first
	 * @owner Observable
	 */
	function first(predicate, resultSelector, defaultValue) {
	    return function (source) { return source.lift(new FirstOperator(predicate, resultSelector, defaultValue, source)); };
	}
	exports.first = first;
	var FirstOperator = (function () {
	    function FirstOperator(predicate, resultSelector, defaultValue, source) {
	        this.predicate = predicate;
	        this.resultSelector = resultSelector;
	        this.defaultValue = defaultValue;
	        this.source = source;
	    }
	    FirstOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new FirstSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
	    };
	    return FirstOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var FirstSubscriber = (function (_super) {
	    __extends(FirstSubscriber, _super);
	    function FirstSubscriber(destination, predicate, resultSelector, defaultValue, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.resultSelector = resultSelector;
	        this.defaultValue = defaultValue;
	        this.source = source;
	        this.index = 0;
	        this.hasCompleted = false;
	        this._emitted = false;
	    }
	    FirstSubscriber.prototype._next = function (value) {
	        var index = this.index++;
	        if (this.predicate) {
	            this._tryPredicate(value, index);
	        }
	        else {
	            this._emit(value, index);
	        }
	    };
	    FirstSubscriber.prototype._tryPredicate = function (value, index) {
	        var result;
	        try {
	            result = this.predicate(value, index, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            this._emit(value, index);
	        }
	    };
	    FirstSubscriber.prototype._emit = function (value, index) {
	        if (this.resultSelector) {
	            this._tryResultSelector(value, index);
	            return;
	        }
	        this._emitFinal(value);
	    };
	    FirstSubscriber.prototype._tryResultSelector = function (value, index) {
	        var result;
	        try {
	            result = this.resultSelector(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this._emitFinal(result);
	    };
	    FirstSubscriber.prototype._emitFinal = function (value) {
	        var destination = this.destination;
	        if (!this._emitted) {
	            this._emitted = true;
	            destination.next(value);
	            destination.complete();
	            this.hasCompleted = true;
	        }
	    };
	    FirstSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (!this.hasCompleted && typeof this.defaultValue !== 'undefined') {
	            destination.next(this.defaultValue);
	            destination.complete();
	        }
	        else if (!this.hasCompleted) {
	            destination.error(new EmptyError_1.EmptyError);
	        }
	    };
	    return FirstSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=first.js.map

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var Subscription_1 = __webpack_require__(31);
	var Observable_1 = __webpack_require__(4);
	var Subject_1 = __webpack_require__(30);
	var Map_1 = __webpack_require__(4751);
	var FastMap_1 = __webpack_require__(4749);
	/* tslint:enable:max-line-length */
	/**
	 * Groups the items emitted by an Observable according to a specified criterion,
	 * and emits these grouped items as `GroupedObservables`, one
	 * {@link GroupedObservable} per group.
	 *
	 * <img src="./img/groupBy.png" width="100%">
	 *
	 * @example <caption>Group objects by id and return as array</caption>
	 * Observable.of<Obj>({id: 1, name: 'aze1'},
	 *                    {id: 2, name: 'sf2'},
	 *                    {id: 2, name: 'dg2'},
	 *                    {id: 1, name: 'erg1'},
	 *                    {id: 1, name: 'df1'},
	 *                    {id: 2, name: 'sfqfb2'},
	 *                    {id: 3, name: 'qfs3'},
	 *                    {id: 2, name: 'qsgqsfg2'}
	 *     )
	 *     .groupBy(p => p.id)
	 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
	 *     .subscribe(p => console.log(p));
	 *
	 * // displays:
	 * // [ { id: 1, name: 'aze1' },
	 * //   { id: 1, name: 'erg1' },
	 * //   { id: 1, name: 'df1' } ]
	 * //
	 * // [ { id: 2, name: 'sf2' },
	 * //   { id: 2, name: 'dg2' },
	 * //   { id: 2, name: 'sfqfb2' },
	 * //   { id: 2, name: 'qsgqsfg2' } ]
	 * //
	 * // [ { id: 3, name: 'qfs3' } ]
	 *
	 * @example <caption>Pivot data on the id field</caption>
	 * Observable.of<Obj>({id: 1, name: 'aze1'},
	 *                    {id: 2, name: 'sf2'},
	 *                    {id: 2, name: 'dg2'},
	 *                    {id: 1, name: 'erg1'},
	 *                    {id: 1, name: 'df1'},
	 *                    {id: 2, name: 'sfqfb2'},
	 *                    {id: 3, name: 'qfs1'},
	 *                    {id: 2, name: 'qsgqsfg2'}
	 *                   )
	 *     .groupBy(p => p.id, p => p.name)
	 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
	 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
	 *     .subscribe(p => console.log(p));
	 *
	 * // displays:
	 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
	 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
	 * // { id: 3, values: [ 'qfs1' ] }
	 *
	 * @param {function(value: T): K} keySelector A function that extracts the key
	 * for each item.
	 * @param {function(value: T): R} [elementSelector] A function that extracts the
	 * return element for each item.
	 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
	 * A function that returns an Observable to determine how long each group should
	 * exist.
	 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
	 * GroupedObservables, each of which corresponds to a unique key value and each
	 * of which emits those items from the source Observable that share that key
	 * value.
	 * @method groupBy
	 * @owner Observable
	 */
	function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
	    return function (source) {
	        return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
	    };
	}
	exports.groupBy = groupBy;
	var GroupByOperator = (function () {
	    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
	        this.keySelector = keySelector;
	        this.elementSelector = elementSelector;
	        this.durationSelector = durationSelector;
	        this.subjectSelector = subjectSelector;
	    }
	    GroupByOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
	    };
	    return GroupByOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var GroupBySubscriber = (function (_super) {
	    __extends(GroupBySubscriber, _super);
	    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
	        _super.call(this, destination);
	        this.keySelector = keySelector;
	        this.elementSelector = elementSelector;
	        this.durationSelector = durationSelector;
	        this.subjectSelector = subjectSelector;
	        this.groups = null;
	        this.attemptedToUnsubscribe = false;
	        this.count = 0;
	    }
	    GroupBySubscriber.prototype._next = function (value) {
	        var key;
	        try {
	            key = this.keySelector(value);
	        }
	        catch (err) {
	            this.error(err);
	            return;
	        }
	        this._group(value, key);
	    };
	    GroupBySubscriber.prototype._group = function (value, key) {
	        var groups = this.groups;
	        if (!groups) {
	            groups = this.groups = typeof key === 'string' ? new FastMap_1.FastMap() : new Map_1.Map();
	        }
	        var group = groups.get(key);
	        var element;
	        if (this.elementSelector) {
	            try {
	                element = this.elementSelector(value);
	            }
	            catch (err) {
	                this.error(err);
	            }
	        }
	        else {
	            element = value;
	        }
	        if (!group) {
	            group = this.subjectSelector ? this.subjectSelector() : new Subject_1.Subject();
	            groups.set(key, group);
	            var groupedObservable = new GroupedObservable(key, group, this);
	            this.destination.next(groupedObservable);
	            if (this.durationSelector) {
	                var duration = void 0;
	                try {
	                    duration = this.durationSelector(new GroupedObservable(key, group));
	                }
	                catch (err) {
	                    this.error(err);
	                    return;
	                }
	                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
	            }
	        }
	        if (!group.closed) {
	            group.next(element);
	        }
	    };
	    GroupBySubscriber.prototype._error = function (err) {
	        var groups = this.groups;
	        if (groups) {
	            groups.forEach(function (group, key) {
	                group.error(err);
	            });
	            groups.clear();
	        }
	        this.destination.error(err);
	    };
	    GroupBySubscriber.prototype._complete = function () {
	        var groups = this.groups;
	        if (groups) {
	            groups.forEach(function (group, key) {
	                group.complete();
	            });
	            groups.clear();
	        }
	        this.destination.complete();
	    };
	    GroupBySubscriber.prototype.removeGroup = function (key) {
	        this.groups.delete(key);
	    };
	    GroupBySubscriber.prototype.unsubscribe = function () {
	        if (!this.closed) {
	            this.attemptedToUnsubscribe = true;
	            if (this.count === 0) {
	                _super.prototype.unsubscribe.call(this);
	            }
	        }
	    };
	    return GroupBySubscriber;
	}(Subscriber_1.Subscriber));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var GroupDurationSubscriber = (function (_super) {
	    __extends(GroupDurationSubscriber, _super);
	    function GroupDurationSubscriber(key, group, parent) {
	        _super.call(this, group);
	        this.key = key;
	        this.group = group;
	        this.parent = parent;
	    }
	    GroupDurationSubscriber.prototype._next = function (value) {
	        this.complete();
	    };
	    GroupDurationSubscriber.prototype._unsubscribe = function () {
	        var _a = this, parent = _a.parent, key = _a.key;
	        this.key = this.parent = null;
	        if (parent) {
	            parent.removeGroup(key);
	        }
	    };
	    return GroupDurationSubscriber;
	}(Subscriber_1.Subscriber));
	/**
	 * An Observable representing values belonging to the same group represented by
	 * a common key. The values emitted by a GroupedObservable come from the source
	 * Observable. The common key is available as the field `key` on a
	 * GroupedObservable instance.
	 *
	 * @class GroupedObservable<K, T>
	 */
	var GroupedObservable = (function (_super) {
	    __extends(GroupedObservable, _super);
	    function GroupedObservable(key, groupSubject, refCountSubscription) {
	        _super.call(this);
	        this.key = key;
	        this.groupSubject = groupSubject;
	        this.refCountSubscription = refCountSubscription;
	    }
	    GroupedObservable.prototype._subscribe = function (subscriber) {
	        var subscription = new Subscription_1.Subscription();
	        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
	        if (refCountSubscription && !refCountSubscription.closed) {
	            subscription.add(new InnerRefCountSubscription(refCountSubscription));
	        }
	        subscription.add(groupSubject.subscribe(subscriber));
	        return subscription;
	    };
	    return GroupedObservable;
	}(Observable_1.Observable));
	exports.GroupedObservable = GroupedObservable;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var InnerRefCountSubscription = (function (_super) {
	    __extends(InnerRefCountSubscription, _super);
	    function InnerRefCountSubscription(parent) {
	        _super.call(this);
	        this.parent = parent;
	        parent.count++;
	    }
	    InnerRefCountSubscription.prototype.unsubscribe = function () {
	        var parent = this.parent;
	        if (!parent.closed && !this.closed) {
	            _super.prototype.unsubscribe.call(this);
	            parent.count -= 1;
	            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
	                parent.unsubscribe();
	            }
	        }
	    };
	    return InnerRefCountSubscription;
	}(Subscription_1.Subscription));
	//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	function isEmpty() {
	    return function (source) { return source.lift(new IsEmptyOperator()); };
	}
	exports.isEmpty = isEmpty;
	var IsEmptyOperator = (function () {
	    function IsEmptyOperator() {
	    }
	    IsEmptyOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new IsEmptySubscriber(observer));
	    };
	    return IsEmptyOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var IsEmptySubscriber = (function (_super) {
	    __extends(IsEmptySubscriber, _super);
	    function IsEmptySubscriber(destination) {
	        _super.call(this, destination);
	    }
	    IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
	        var destination = this.destination;
	        destination.next(isEmpty);
	        destination.complete();
	    };
	    IsEmptySubscriber.prototype._next = function (value) {
	        this.notifyComplete(false);
	    };
	    IsEmptySubscriber.prototype._complete = function () {
	        this.notifyComplete(true);
	    };
	    return IsEmptySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var EmptyError_1 = __webpack_require__(357);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits only the last item emitted by the source Observable.
	 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
	 * the last item from the source Observable, the resulting Observable will emit the last item
	 * from the source Observable that satisfies the predicate.
	 *
	 * <img src="./img/last.png" width="100%">
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 * @param {function} predicate - The condition any source emitted item has to satisfy.
	 * @return {Observable} An Observable that emits only the last item satisfying the given condition
	 * from the source, or an NoSuchElementException if no such items are emitted.
	 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
	 * @method last
	 * @owner Observable
	 */
	function last(predicate, resultSelector, defaultValue) {
	    return function (source) { return source.lift(new LastOperator(predicate, resultSelector, defaultValue, source)); };
	}
	exports.last = last;
	var LastOperator = (function () {
	    function LastOperator(predicate, resultSelector, defaultValue, source) {
	        this.predicate = predicate;
	        this.resultSelector = resultSelector;
	        this.defaultValue = defaultValue;
	        this.source = source;
	    }
	    LastOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new LastSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
	    };
	    return LastOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var LastSubscriber = (function (_super) {
	    __extends(LastSubscriber, _super);
	    function LastSubscriber(destination, predicate, resultSelector, defaultValue, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.resultSelector = resultSelector;
	        this.defaultValue = defaultValue;
	        this.source = source;
	        this.hasValue = false;
	        this.index = 0;
	        if (typeof defaultValue !== 'undefined') {
	            this.lastValue = defaultValue;
	            this.hasValue = true;
	        }
	    }
	    LastSubscriber.prototype._next = function (value) {
	        var index = this.index++;
	        if (this.predicate) {
	            this._tryPredicate(value, index);
	        }
	        else {
	            if (this.resultSelector) {
	                this._tryResultSelector(value, index);
	                return;
	            }
	            this.lastValue = value;
	            this.hasValue = true;
	        }
	    };
	    LastSubscriber.prototype._tryPredicate = function (value, index) {
	        var result;
	        try {
	            result = this.predicate(value, index, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            if (this.resultSelector) {
	                this._tryResultSelector(value, index);
	                return;
	            }
	            this.lastValue = value;
	            this.hasValue = true;
	        }
	    };
	    LastSubscriber.prototype._tryResultSelector = function (value, index) {
	        var result;
	        try {
	            result = this.resultSelector(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.lastValue = result;
	        this.hasValue = true;
	    };
	    LastSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (this.hasValue) {
	            destination.next(this.lastValue);
	            destination.complete();
	        }
	        else {
	            destination.error(new EmptyError_1.EmptyError);
	        }
	    };
	    return LastSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=last.js.map

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var Notification_1 = __webpack_require__(264);
	/**
	 * Represents all of the notifications from the source Observable as `next`
	 * emissions marked with their original types within {@link Notification}
	 * objects.
	 *
	 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
	 * {@link Notification} objects, emitted as `next` on the output Observable.
	 * </span>
	 *
	 * <img src="./img/materialize.png" width="100%">
	 *
	 * `materialize` returns an Observable that emits a `next` notification for each
	 * `next`, `error`, or `complete` emission of the source Observable. When the
	 * source Observable emits `complete`, the output Observable will emit `next` as
	 * a Notification of type "complete", and then it will emit `complete` as well.
	 * When the source Observable emits `error`, the output will emit `next` as a
	 * Notification of type "error", and then `complete`.
	 *
	 * This operator is useful for producing metadata of the source Observable, to
	 * be consumed as `next` emissions. Use it in conjunction with
	 * {@link dematerialize}.
	 *
	 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
	 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
	 * var upperCase = letters.map(x => x.toUpperCase());
	 * var materialized = upperCase.materialize();
	 * materialized.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
	 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
	 * // - Notification {kind: "E", value: undefined, error: TypeError:
	 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
	 * //   [as project] (http://1…, hasValue: false}
	 *
	 * @see {@link Notification}
	 * @see {@link dematerialize}
	 *
	 * @return {Observable<Notification<T>>} An Observable that emits
	 * {@link Notification} objects that wrap the original emissions from the source
	 * Observable with metadata.
	 * @method materialize
	 * @owner Observable
	 */
	function materialize() {
	    return function materializeOperatorFunction(source) {
	        return source.lift(new MaterializeOperator());
	    };
	}
	exports.materialize = materialize;
	var MaterializeOperator = (function () {
	    function MaterializeOperator() {
	    }
	    MaterializeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MaterializeSubscriber(subscriber));
	    };
	    return MaterializeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MaterializeSubscriber = (function (_super) {
	    __extends(MaterializeSubscriber, _super);
	    function MaterializeSubscriber(destination) {
	        _super.call(this, destination);
	    }
	    MaterializeSubscriber.prototype._next = function (value) {
	        this.destination.next(Notification_1.Notification.createNext(value));
	    };
	    MaterializeSubscriber.prototype._error = function (err) {
	        var destination = this.destination;
	        destination.next(Notification_1.Notification.createError(err));
	        destination.complete();
	    };
	    MaterializeSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        destination.next(Notification_1.Notification.createComplete());
	        destination.complete();
	    };
	    return MaterializeSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=materialize.js.map

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var reduce_1 = __webpack_require__(267);
	/**
	 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
	 * and when source Observable completes it emits a single item: the item with the largest value.
	 *
	 * <img src="./img/max.png" width="100%">
	 *
	 * @example <caption>Get the maximal value of a series of numbers</caption>
	 * Rx.Observable.of(5, 4, 7, 2, 8)
	 *   .max()
	 *   .subscribe(x => console.log(x)); // -> 8
	 *
	 * @example <caption>Use a comparer function to get the maximal item</caption>
	 * interface Person {
	 *   age: number,
	 *   name: string
	 * }
	 * Observable.of<Person>({age: 7, name: 'Foo'},
	 *                       {age: 5, name: 'Bar'},
	 *                       {age: 9, name: 'Beer'})
	 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
	 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
	 * }
	 *
	 * @see {@link min}
	 *
	 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
	 * value of two items.
	 * @return {Observable} An Observable that emits item with the largest value.
	 * @method max
	 * @owner Observable
	 */
	function max(comparer) {
	    var max = (typeof comparer === 'function')
	        ? function (x, y) { return comparer(x, y) > 0 ? x : y; }
	        : function (x, y) { return x > y ? x : y; };
	    return reduce_1.reduce(max);
	}
	exports.max = max;
	//# sourceMappingURL=max.js.map

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var merge_1 = __webpack_require__(162);
	var merge_2 = __webpack_require__(162);
	exports.mergeStatic = merge_2.merge;
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which concurrently emits all values from every
	 * given input Observable.
	 *
	 * <span class="informal">Flattens multiple Observables together by blending
	 * their values into one Observable.</span>
	 *
	 * <img src="./img/merge.png" width="100%">
	 *
	 * `merge` subscribes to each given input Observable (either the source or an
	 * Observable given as argument), and simply forwards (without doing any
	 * transformation) all the values from all the input Observables to the output
	 * Observable. The output Observable only completes once all input Observables
	 * have completed. Any error delivered by an input Observable will be immediately
	 * emitted on the output Observable.
	 *
	 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var clicksOrTimer = clicks.merge(timer);
	 * clicksOrTimer.subscribe(x => console.log(x));
	 *
	 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var concurrent = 2; // the argument
	 * var merged = timer1.merge(timer2, timer3, concurrent);
	 * merged.subscribe(x => console.log(x));
	 *
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 *
	 * @param {ObservableInput} other An input Observable to merge with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
	 * concurrency of input Observables.
	 * @return {Observable} An Observable that emits items that are the result of
	 * every input Observable.
	 * @method merge
	 * @owner Observable
	 */
	function merge() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return function (source) { return source.lift.call(merge_1.merge.apply(void 0, [source].concat(observables))); };
	}
	exports.merge = merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is merged multiple
	 * times in the output Observable.
	 *
	 * <span class="informal">It's like {@link mergeMap}, but maps each value always
	 * to the same inner Observable.</span>
	 *
	 * <img src="./img/mergeMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then merges those resulting Observables into one
	 * single Observable, which is the output Observable.
	 *
	 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMapTo}
	 * @see {@link merge}
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeScan}
	 * @see {@link switchMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits items from the given
	 * `innerObservable` (and optionally transformed through `resultSelector`) every
	 * time a value is emitted on the source Observable.
	 * @method mergeMapTo
	 * @owner Observable
	 */
	function mergeMapTo(innerObservable, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    if (typeof resultSelector === 'number') {
	        concurrent = resultSelector;
	        resultSelector = null;
	    }
	    return function (source) { return source.lift(new MergeMapToOperator(innerObservable, resultSelector, concurrent)); };
	}
	exports.mergeMapTo = mergeMapTo;
	// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
	//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
	var MergeMapToOperator = (function () {
	    function MergeMapToOperator(ish, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        this.ish = ish;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	    }
	    MergeMapToOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
	    };
	    return MergeMapToOperator;
	}());
	exports.MergeMapToOperator = MergeMapToOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MergeMapToSubscriber = (function (_super) {
	    __extends(MergeMapToSubscriber, _super);
	    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        _super.call(this, destination);
	        this.ish = ish;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	        this.hasCompleted = false;
	        this.buffer = [];
	        this.active = 0;
	        this.index = 0;
	    }
	    MergeMapToSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            var resultSelector = this.resultSelector;
	            var index = this.index++;
	            var ish = this.ish;
	            var destination = this.destination;
	            this.active++;
	            this._innerSub(ish, destination, resultSelector, value, index);
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeMapToSubscriber.prototype._innerSub = function (ish, destination, resultSelector, value, index) {
	        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
	    };
	    MergeMapToSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            this.destination.complete();
	        }
	    };
	    MergeMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        if (resultSelector) {
	            this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            destination.next(innerValue);
	        }
	    };
	    MergeMapToSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        var result;
	        try {
	            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        destination.next(result);
	    };
	    MergeMapToSubscriber.prototype.notifyError = function (err) {
	        this.destination.error(err);
	    };
	    MergeMapToSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return MergeMapToSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.MergeMapToSubscriber = MergeMapToSubscriber;
	//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var tryCatch_1 = __webpack_require__(34);
	var errorObject_1 = __webpack_require__(32);
	var subscribeToResult_1 = __webpack_require__(17);
	var OuterSubscriber_1 = __webpack_require__(16);
	/**
	 * Applies an accumulator function over the source Observable where the
	 * accumulator function itself returns an Observable, then each intermediate
	 * Observable returned is merged into the output Observable.
	 *
	 * <span class="informal">It's like {@link scan}, but the Observables returned
	 * by the accumulator are merged into the outer Observable.</span>
	 *
	 * @example <caption>Count the number of click events</caption>
	 * const click$ = Rx.Observable.fromEvent(document, 'click');
	 * const one$ = click$.mapTo(1);
	 * const seed = 0;
	 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
	 * count$.subscribe(x => console.log(x));
	 *
	 * // Results:
	 * 1
	 * 2
	 * 3
	 * 4
	 * // ...and so on for each click
	 *
	 * @param {function(acc: R, value: T): Observable<R>} accumulator
	 * The accumulator function called on each source value.
	 * @param seed The initial accumulation value.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
	 * input Observables being subscribed to concurrently.
	 * @return {Observable<R>} An observable of the accumulated values.
	 * @method mergeScan
	 * @owner Observable
	 */
	function mergeScan(accumulator, seed, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return function (source) { return source.lift(new MergeScanOperator(accumulator, seed, concurrent)); };
	}
	exports.mergeScan = mergeScan;
	var MergeScanOperator = (function () {
	    function MergeScanOperator(accumulator, seed, concurrent) {
	        this.accumulator = accumulator;
	        this.seed = seed;
	        this.concurrent = concurrent;
	    }
	    MergeScanOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
	    };
	    return MergeScanOperator;
	}());
	exports.MergeScanOperator = MergeScanOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MergeScanSubscriber = (function (_super) {
	    __extends(MergeScanSubscriber, _super);
	    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
	        _super.call(this, destination);
	        this.accumulator = accumulator;
	        this.acc = acc;
	        this.concurrent = concurrent;
	        this.hasValue = false;
	        this.hasCompleted = false;
	        this.buffer = [];
	        this.active = 0;
	        this.index = 0;
	    }
	    MergeScanSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            var index = this.index++;
	            var ish = tryCatch_1.tryCatch(this.accumulator)(this.acc, value);
	            var destination = this.destination;
	            if (ish === errorObject_1.errorObject) {
	                destination.error(errorObject_1.errorObject.e);
	            }
	            else {
	                this.active++;
	                this._innerSub(ish, value, index);
	            }
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeScanSubscriber.prototype._innerSub = function (ish, value, index) {
	        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
	    };
	    MergeScanSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            if (this.hasValue === false) {
	                this.destination.next(this.acc);
	            }
	            this.destination.complete();
	        }
	    };
	    MergeScanSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var destination = this.destination;
	        this.acc = innerValue;
	        this.hasValue = true;
	        destination.next(innerValue);
	    };
	    MergeScanSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            if (this.hasValue === false) {
	                this.destination.next(this.acc);
	            }
	            this.destination.complete();
	        }
	    };
	    return MergeScanSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.MergeScanSubscriber = MergeScanSubscriber;
	//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var reduce_1 = __webpack_require__(267);
	/**
	 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
	 * and when source Observable completes it emits a single item: the item with the smallest value.
	 *
	 * <img src="./img/min.png" width="100%">
	 *
	 * @example <caption>Get the minimal value of a series of numbers</caption>
	 * Rx.Observable.of(5, 4, 7, 2, 8)
	 *   .min()
	 *   .subscribe(x => console.log(x)); // -> 2
	 *
	 * @example <caption>Use a comparer function to get the minimal item</caption>
	 * interface Person {
	 *   age: number,
	 *   name: string
	 * }
	 * Observable.of<Person>({age: 7, name: 'Foo'},
	 *                       {age: 5, name: 'Bar'},
	 *                       {age: 9, name: 'Beer'})
	 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
	 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
	 * }
	 *
	 * @see {@link max}
	 *
	 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
	 * value of two items.
	 * @return {Observable<R>} An Observable that emits item with the smallest value.
	 * @method min
	 * @owner Observable
	 */
	function min(comparer) {
	    var min = (typeof comparer === 'function')
	        ? function (x, y) { return comparer(x, y) < 0 ? x : y; }
	        : function (x, y) { return x < y ? x : y; };
	    return reduce_1.reduce(min);
	}
	exports.min = min;
	//# sourceMappingURL=min.js.map

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/**
	 * Groups pairs of consecutive emissions together and emits them as an array of
	 * two values.
	 *
	 * <span class="informal">Puts the current value and previous value together as
	 * an array, and emits that.</span>
	 *
	 * <img src="./img/pairwise.png" width="100%">
	 *
	 * The Nth emission from the source Observable will cause the output Observable
	 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
	 * pair. For this reason, `pairwise` emits on the second and subsequent
	 * emissions from the source Observable, but not on the first emission, because
	 * there is no previous value in that case.
	 *
	 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var pairs = clicks.pairwise();
	 * var distance = pairs.map(pair => {
	 *   var x0 = pair[0].clientX;
	 *   var y0 = pair[0].clientY;
	 *   var x1 = pair[1].clientX;
	 *   var y1 = pair[1].clientY;
	 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
	 * });
	 * distance.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 *
	 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
	 * consecutive values from the source Observable.
	 * @method pairwise
	 * @owner Observable
	 */
	function pairwise() {
	    return function (source) { return source.lift(new PairwiseOperator()); };
	}
	exports.pairwise = pairwise;
	var PairwiseOperator = (function () {
	    function PairwiseOperator() {
	    }
	    PairwiseOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new PairwiseSubscriber(subscriber));
	    };
	    return PairwiseOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var PairwiseSubscriber = (function (_super) {
	    __extends(PairwiseSubscriber, _super);
	    function PairwiseSubscriber(destination) {
	        _super.call(this, destination);
	        this.hasPrev = false;
	    }
	    PairwiseSubscriber.prototype._next = function (value) {
	        if (this.hasPrev) {
	            this.destination.next([this.prev, value]);
	        }
	        else {
	            this.hasPrev = true;
	        }
	        this.prev = value;
	    };
	    return PairwiseSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var not_1 = __webpack_require__(4755);
	var filter_1 = __webpack_require__(348);
	/**
	 * Splits the source Observable into two, one with values that satisfy a
	 * predicate, and another with values that don't satisfy the predicate.
	 *
	 * <span class="informal">It's like {@link filter}, but returns two Observables:
	 * one like the output of {@link filter}, and the other with values that did not
	 * pass the condition.</span>
	 *
	 * <img src="./img/partition.png" width="100%">
	 *
	 * `partition` outputs an array with two Observables that partition the values
	 * from the source Observable through the given `predicate` function. The first
	 * Observable in that array emits source values for which the predicate argument
	 * returns true. The second Observable emits source values for which the
	 * predicate returns false. The first behaves like {@link filter} and the second
	 * behaves like {@link filter} with the predicate negated.
	 *
	 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
	 * var clicksOnDivs = parts[0];
	 * var clicksElsewhere = parts[1];
	 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
	 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
	 *
	 * @see {@link filter}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates each value emitted by the source Observable. If it returns `true`,
	 * the value is emitted on the first Observable in the returned array, if
	 * `false` the value is emitted on the second Observable in the array. The
	 * `index` parameter is the number `i` for the i-th source emission that has
	 * happened since the subscription, starting from the number `0`.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
	 * with values that passed the predicate, and another with values that did not
	 * pass the predicate.
	 * @method partition
	 * @owner Observable
	 */
	function partition(predicate, thisArg) {
	    return function (source) { return [
	        filter_1.filter(predicate, thisArg)(source),
	        filter_1.filter(not_1.not(predicate, thisArg))(source)
	    ]; };
	}
	exports.partition = partition;
	//# sourceMappingURL=partition.js.map

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var map_1 = __webpack_require__(163);
	/**
	 * Maps each source value (an object) to its specified nested property.
	 *
	 * <span class="informal">Like {@link map}, but meant only for picking one of
	 * the nested properties of every emitted object.</span>
	 *
	 * <img src="./img/pluck.png" width="100%">
	 *
	 * Given a list of strings describing a path to an object property, retrieves
	 * the value of a specified nested property from all values in the source
	 * Observable. If a property can't be resolved, it will return `undefined` for
	 * that value.
	 *
	 * @example <caption>Map every click to the tagName of the clicked target element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var tagNames = clicks.pluck('target', 'tagName');
	 * tagNames.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 *
	 * @param {...string} properties The nested properties to pluck from each source
	 * value (an object).
	 * @return {Observable} A new Observable of property values from the source values.
	 * @method pluck
	 * @owner Observable
	 */
	function pluck() {
	    var properties = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        properties[_i - 0] = arguments[_i];
	    }
	    var length = properties.length;
	    if (length === 0) {
	        throw new Error('list of properties cannot be empty.');
	    }
	    return function (source) { return map_1.map(plucker(properties, length))(source); };
	}
	exports.pluck = pluck;
	function plucker(props, length) {
	    var mapper = function (x) {
	        var currentProp = x;
	        for (var i = 0; i < length; i++) {
	            var p = currentProp[props[i]];
	            if (typeof p !== 'undefined') {
	                currentProp = p;
	            }
	            else {
	                return undefined;
	            }
	        }
	        return currentProp;
	    };
	    return mapper;
	}
	//# sourceMappingURL=pluck.js.map

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Subject_1 = __webpack_require__(30);
	var multicast_1 = __webpack_require__(164);
	/* tslint:enable:max-line-length */
	/**
	 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
	 * before it begins emitting items to those Observers that have subscribed to it.
	 *
	 * <img src="./img/publish.png" width="100%">
	 *
	 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
	 * as needed, without causing multiple subscriptions to the source sequence.
	 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
	 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
	 * @method publish
	 * @owner Observable
	 */
	function publish(selector) {
	    return selector ?
	        multicast_1.multicast(function () { return new Subject_1.Subject(); }, selector) :
	        multicast_1.multicast(new Subject_1.Subject());
	}
	exports.publish = publish;
	//# sourceMappingURL=publish.js.map

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var BehaviorSubject_1 = __webpack_require__(759);
	var multicast_1 = __webpack_require__(164);
	/**
	 * @param value
	 * @return {ConnectableObservable<T>}
	 * @method publishBehavior
	 * @owner Observable
	 */
	function publishBehavior(value) {
	    return function (source) { return multicast_1.multicast(new BehaviorSubject_1.BehaviorSubject(value))(source); };
	}
	exports.publishBehavior = publishBehavior;
	//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var AsyncSubject_1 = __webpack_require__(344);
	var multicast_1 = __webpack_require__(164);
	function publishLast() {
	    return function (source) { return multicast_1.multicast(new AsyncSubject_1.AsyncSubject())(source); };
	}
	exports.publishLast = publishLast;
	//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ReplaySubject_1 = __webpack_require__(345);
	var multicast_1 = __webpack_require__(164);
	/* tslint:enable:max-line-length */
	function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
	    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') {
	        scheduler = selectorOrScheduler;
	    }
	    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
	    var subject = new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler);
	    return function (source) { return multicast_1.multicast(function () { return subject; }, selector)(source); };
	}
	exports.publishReplay = publishReplay;
	//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isArray_1 = __webpack_require__(81);
	var race_1 = __webpack_require__(508);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that mirrors the first source Observable to emit an item
	 * from the combination of this Observable and supplied Observables.
	 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
	 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
	 * @method race
	 * @owner Observable
	 */
	function race() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return function raceOperatorFunction(source) {
	        // if the only argument is an array, it was most likely called with
	        // `pair([obs1, obs2, ...])`
	        if (observables.length === 1 && isArray_1.isArray(observables[0])) {
	            observables = observables[0];
	        }
	        return source.lift.call(race_1.race.apply(void 0, [source].concat(observables)));
	    };
	}
	exports.race = race;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var EmptyObservable_1 = __webpack_require__(119);
	/**
	 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
	 *
	 * <img src="./img/repeat.png" width="100%">
	 *
	 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
	 * an empty Observable.
	 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
	 * count times.
	 * @method repeat
	 * @owner Observable
	 */
	function repeat(count) {
	    if (count === void 0) { count = -1; }
	    return function (source) {
	        if (count === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        else if (count < 0) {
	            return source.lift(new RepeatOperator(-1, source));
	        }
	        else {
	            return source.lift(new RepeatOperator(count - 1, source));
	        }
	    };
	}
	exports.repeat = repeat;
	var RepeatOperator = (function () {
	    function RepeatOperator(count, source) {
	        this.count = count;
	        this.source = source;
	    }
	    RepeatOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
	    };
	    return RepeatOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RepeatSubscriber = (function (_super) {
	    __extends(RepeatSubscriber, _super);
	    function RepeatSubscriber(destination, count, source) {
	        _super.call(this, destination);
	        this.count = count;
	        this.source = source;
	    }
	    RepeatSubscriber.prototype.complete = function () {
	        if (!this.isStopped) {
	            var _a = this, source = _a.source, count = _a.count;
	            if (count === 0) {
	                return _super.prototype.complete.call(this);
	            }
	            else if (count > -1) {
	                this.count = count - 1;
	            }
	            source.subscribe(this._unsubscribeAndRecycle());
	        }
	    };
	    return RepeatSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=repeat.js.map

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(30);
	var tryCatch_1 = __webpack_require__(34);
	var errorObject_1 = __webpack_require__(32);
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
	 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
	 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
	 * this method will resubscribe to the source Observable.
	 *
	 * <img src="./img/repeatWhen.png" width="100%">
	 *
	 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
	 * which a user can `complete` or `error`, aborting the repetition.
	 * @return {Observable} The source Observable modified with repeat logic.
	 * @method repeatWhen
	 * @owner Observable
	 */
	function repeatWhen(notifier) {
	    return function (source) { return source.lift(new RepeatWhenOperator(notifier)); };
	}
	exports.repeatWhen = repeatWhen;
	var RepeatWhenOperator = (function () {
	    function RepeatWhenOperator(notifier) {
	        this.notifier = notifier;
	    }
	    RepeatWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RepeatWhenSubscriber(subscriber, this.notifier, source));
	    };
	    return RepeatWhenOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RepeatWhenSubscriber = (function (_super) {
	    __extends(RepeatWhenSubscriber, _super);
	    function RepeatWhenSubscriber(destination, notifier, source) {
	        _super.call(this, destination);
	        this.notifier = notifier;
	        this.source = source;
	        this.sourceIsBeingSubscribedTo = true;
	    }
	    RepeatWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.sourceIsBeingSubscribedTo = true;
	        this.source.subscribe(this);
	    };
	    RepeatWhenSubscriber.prototype.notifyComplete = function (innerSub) {
	        if (this.sourceIsBeingSubscribedTo === false) {
	            return _super.prototype.complete.call(this);
	        }
	    };
	    RepeatWhenSubscriber.prototype.complete = function () {
	        this.sourceIsBeingSubscribedTo = false;
	        if (!this.isStopped) {
	            if (!this.retries) {
	                this.subscribeToRetries();
	            }
	            else if (this.retriesSubscription.closed) {
	                return _super.prototype.complete.call(this);
	            }
	            this._unsubscribeAndRecycle();
	            this.notifications.next();
	        }
	    };
	    RepeatWhenSubscriber.prototype._unsubscribe = function () {
	        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
	        if (notifications) {
	            notifications.unsubscribe();
	            this.notifications = null;
	        }
	        if (retriesSubscription) {
	            retriesSubscription.unsubscribe();
	            this.retriesSubscription = null;
	        }
	        this.retries = null;
	    };
	    RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function () {
	        var _a = this, notifications = _a.notifications, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
	        this.notifications = null;
	        this.retries = null;
	        this.retriesSubscription = null;
	        _super.prototype._unsubscribeAndRecycle.call(this);
	        this.notifications = notifications;
	        this.retries = retries;
	        this.retriesSubscription = retriesSubscription;
	        return this;
	    };
	    RepeatWhenSubscriber.prototype.subscribeToRetries = function () {
	        this.notifications = new Subject_1.Subject();
	        var retries = tryCatch_1.tryCatch(this.notifier)(this.notifications);
	        if (retries === errorObject_1.errorObject) {
	            return _super.prototype.complete.call(this);
	        }
	        this.retries = retries;
	        this.retriesSubscription = subscribeToResult_1.subscribeToResult(this, retries);
	    };
	    return RepeatWhenSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
	 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
	 * as a number parameter) rather than propagating the `error` call.
	 *
	 * <img src="./img/retry.png" width="100%">
	 *
	 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
	 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
	 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
	 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
	 * @param {number} count - Number of retry attempts before failing.
	 * @return {Observable} The source Observable modified with the retry logic.
	 * @method retry
	 * @owner Observable
	 */
	function retry(count) {
	    if (count === void 0) { count = -1; }
	    return function (source) { return source.lift(new RetryOperator(count, source)); };
	}
	exports.retry = retry;
	var RetryOperator = (function () {
	    function RetryOperator(count, source) {
	        this.count = count;
	        this.source = source;
	    }
	    RetryOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RetrySubscriber(subscriber, this.count, this.source));
	    };
	    return RetryOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RetrySubscriber = (function (_super) {
	    __extends(RetrySubscriber, _super);
	    function RetrySubscriber(destination, count, source) {
	        _super.call(this, destination);
	        this.count = count;
	        this.source = source;
	    }
	    RetrySubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var _a = this, source = _a.source, count = _a.count;
	            if (count === 0) {
	                return _super.prototype.error.call(this, err);
	            }
	            else if (count > -1) {
	                this.count = count - 1;
	            }
	            source.subscribe(this._unsubscribeAndRecycle());
	        }
	    };
	    return RetrySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=retry.js.map

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(30);
	var tryCatch_1 = __webpack_require__(34);
	var errorObject_1 = __webpack_require__(32);
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
	 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
	 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
	 * subscription. Otherwise this method will resubscribe to the source Observable.
	 *
	 * <img src="./img/retryWhen.png" width="100%">
	 *
	 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
	 * user can `complete` or `error`, aborting the retry.
	 * @return {Observable} The source Observable modified with retry logic.
	 * @method retryWhen
	 * @owner Observable
	 */
	function retryWhen(notifier) {
	    return function (source) { return source.lift(new RetryWhenOperator(notifier, source)); };
	}
	exports.retryWhen = retryWhen;
	var RetryWhenOperator = (function () {
	    function RetryWhenOperator(notifier, source) {
	        this.notifier = notifier;
	        this.source = source;
	    }
	    RetryWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RetryWhenSubscriber(subscriber, this.notifier, this.source));
	    };
	    return RetryWhenOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RetryWhenSubscriber = (function (_super) {
	    __extends(RetryWhenSubscriber, _super);
	    function RetryWhenSubscriber(destination, notifier, source) {
	        _super.call(this, destination);
	        this.notifier = notifier;
	        this.source = source;
	    }
	    RetryWhenSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var errors = this.errors;
	            var retries = this.retries;
	            var retriesSubscription = this.retriesSubscription;
	            if (!retries) {
	                errors = new Subject_1.Subject();
	                retries = tryCatch_1.tryCatch(this.notifier)(errors);
	                if (retries === errorObject_1.errorObject) {
	                    return _super.prototype.error.call(this, errorObject_1.errorObject.e);
	                }
	                retriesSubscription = subscribeToResult_1.subscribeToResult(this, retries);
	            }
	            else {
	                this.errors = null;
	                this.retriesSubscription = null;
	            }
	            this._unsubscribeAndRecycle();
	            this.errors = errors;
	            this.retries = retries;
	            this.retriesSubscription = retriesSubscription;
	            errors.next(err);
	        }
	    };
	    RetryWhenSubscriber.prototype._unsubscribe = function () {
	        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
	        if (errors) {
	            errors.unsubscribe();
	            this.errors = null;
	        }
	        if (retriesSubscription) {
	            retriesSubscription.unsubscribe();
	            this.retriesSubscription = null;
	        }
	        this.retries = null;
	    };
	    RetryWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var _a = this, errors = _a.errors, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
	        this.errors = null;
	        this.retries = null;
	        this.retriesSubscription = null;
	        this._unsubscribeAndRecycle();
	        this.errors = errors;
	        this.retries = retries;
	        this.retriesSubscription = retriesSubscription;
	        this.source.subscribe(this);
	    };
	    return RetryWhenSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=retryWhen.js.map

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/**
	 * Emits the most recently emitted value from the source Observable whenever
	 * another Observable, the `notifier`, emits.
	 *
	 * <span class="informal">It's like {@link sampleTime}, but samples whenever
	 * the `notifier` Observable emits something.</span>
	 *
	 * <img src="./img/sample.png" width="100%">
	 *
	 * Whenever the `notifier` Observable emits a value or completes, `sample`
	 * looks at the source Observable and emits whichever value it has most recently
	 * emitted since the previous sampling, unless the source has not emitted
	 * anything since the previous sampling. The `notifier` is subscribed to as soon
	 * as the output Observable is subscribed.
	 *
	 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
	 * var seconds = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = seconds.sample(clicks);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounce}
	 * @see {@link sampleTime}
	 * @see {@link throttle}
	 *
	 * @param {Observable<any>} notifier The Observable to use for sampling the
	 * source Observable.
	 * @return {Observable<T>} An Observable that emits the results of sampling the
	 * values emitted by the source Observable whenever the notifier Observable
	 * emits value or completes.
	 * @method sample
	 * @owner Observable
	 */
	function sample(notifier) {
	    return function (source) { return source.lift(new SampleOperator(notifier)); };
	}
	exports.sample = sample;
	var SampleOperator = (function () {
	    function SampleOperator(notifier) {
	        this.notifier = notifier;
	    }
	    SampleOperator.prototype.call = function (subscriber, source) {
	        var sampleSubscriber = new SampleSubscriber(subscriber);
	        var subscription = source.subscribe(sampleSubscriber);
	        subscription.add(subscribeToResult_1.subscribeToResult(sampleSubscriber, this.notifier));
	        return subscription;
	    };
	    return SampleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SampleSubscriber = (function (_super) {
	    __extends(SampleSubscriber, _super);
	    function SampleSubscriber() {
	        _super.apply(this, arguments);
	        this.hasValue = false;
	    }
	    SampleSubscriber.prototype._next = function (value) {
	        this.value = value;
	        this.hasValue = true;
	    };
	    SampleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.emitValue();
	    };
	    SampleSubscriber.prototype.notifyComplete = function () {
	        this.emitValue();
	    };
	    SampleSubscriber.prototype.emitValue = function () {
	        if (this.hasValue) {
	            this.hasValue = false;
	            this.destination.next(this.value);
	        }
	    };
	    return SampleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=sample.js.map

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var async_1 = __webpack_require__(23);
	/**
	 * Emits the most recently emitted value from the source Observable within
	 * periodic time intervals.
	 *
	 * <span class="informal">Samples the source Observable at periodic time
	 * intervals, emitting what it samples.</span>
	 *
	 * <img src="./img/sampleTime.png" width="100%">
	 *
	 * `sampleTime` periodically looks at the source Observable and emits whichever
	 * value it has most recently emitted since the previous sampling, unless the
	 * source has not emitted anything since the previous sampling. The sampling
	 * happens periodically in time every `period` milliseconds (or the time unit
	 * defined by the optional `scheduler` argument). The sampling starts as soon as
	 * the output Observable is subscribed.
	 *
	 * @example <caption>Every second, emit the most recent click at most once</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.sampleTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sample}
	 * @see {@link throttleTime}
	 *
	 * @param {number} period The sampling period expressed in milliseconds or the
	 * time unit determined internally by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the sampling.
	 * @return {Observable<T>} An Observable that emits the results of sampling the
	 * values emitted by the source Observable at the specified time interval.
	 * @method sampleTime
	 * @owner Observable
	 */
	function sampleTime(period, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return function (source) { return source.lift(new SampleTimeOperator(period, scheduler)); };
	}
	exports.sampleTime = sampleTime;
	var SampleTimeOperator = (function () {
	    function SampleTimeOperator(period, scheduler) {
	        this.period = period;
	        this.scheduler = scheduler;
	    }
	    SampleTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
	    };
	    return SampleTimeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SampleTimeSubscriber = (function (_super) {
	    __extends(SampleTimeSubscriber, _super);
	    function SampleTimeSubscriber(destination, period, scheduler) {
	        _super.call(this, destination);
	        this.period = period;
	        this.scheduler = scheduler;
	        this.hasValue = false;
	        this.add(scheduler.schedule(dispatchNotification, period, { subscriber: this, period: period }));
	    }
	    SampleTimeSubscriber.prototype._next = function (value) {
	        this.lastValue = value;
	        this.hasValue = true;
	    };
	    SampleTimeSubscriber.prototype.notifyNext = function () {
	        if (this.hasValue) {
	            this.hasValue = false;
	            this.destination.next(this.lastValue);
	        }
	    };
	    return SampleTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchNotification(state) {
	    var subscriber = state.subscriber, period = state.period;
	    subscriber.notifyNext();
	    this.schedule(state, period);
	}
	//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var tryCatch_1 = __webpack_require__(34);
	var errorObject_1 = __webpack_require__(32);
	/**
	 * Compares all values of two observables in sequence using an optional comparor function
	 * and returns an observable of a single boolean value representing whether or not the two sequences
	 * are equal.
	 *
	 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
	 *
	 * <img src="./img/sequenceEqual.png" width="100%">
	 *
	 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
	 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
	 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
	 * observables completes, the operator will wait for the other observable to complete; If the other
	 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
	 * completes or emits after the other complets, the returned observable will never complete.
	 *
	 * @example <caption>figure out if the Konami code matches</caption>
	 * var code = Rx.Observable.from([
	 *  "ArrowUp",
	 *  "ArrowUp",
	 *  "ArrowDown",
	 *  "ArrowDown",
	 *  "ArrowLeft",
	 *  "ArrowRight",
	 *  "ArrowLeft",
	 *  "ArrowRight",
	 *  "KeyB",
	 *  "KeyA",
	 *  "Enter" // no start key, clearly.
	 * ]);
	 *
	 * var keys = Rx.Observable.fromEvent(document, 'keyup')
	 *  .map(e => e.code);
	 * var matches = keys.bufferCount(11, 1)
	 *  .mergeMap(
	 *    last11 =>
	 *      Rx.Observable.from(last11)
	 *        .sequenceEqual(code)
	 *   );
	 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
	 *
	 * @see {@link combineLatest}
	 * @see {@link zip}
	 * @see {@link withLatestFrom}
	 *
	 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
	 * @param {function} [comparor] An optional function to compare each value pair
	 * @return {Observable} An Observable of a single boolean value representing whether or not
	 * the values emitted by both observables were equal in sequence.
	 * @method sequenceEqual
	 * @owner Observable
	 */
	function sequenceEqual(compareTo, comparor) {
	    return function (source) { return source.lift(new SequenceEqualOperator(compareTo, comparor)); };
	}
	exports.sequenceEqual = sequenceEqual;
	var SequenceEqualOperator = (function () {
	    function SequenceEqualOperator(compareTo, comparor) {
	        this.compareTo = compareTo;
	        this.comparor = comparor;
	    }
	    SequenceEqualOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
	    };
	    return SequenceEqualOperator;
	}());
	exports.SequenceEqualOperator = SequenceEqualOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SequenceEqualSubscriber = (function (_super) {
	    __extends(SequenceEqualSubscriber, _super);
	    function SequenceEqualSubscriber(destination, compareTo, comparor) {
	        _super.call(this, destination);
	        this.compareTo = compareTo;
	        this.comparor = comparor;
	        this._a = [];
	        this._b = [];
	        this._oneComplete = false;
	        this.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, this)));
	    }
	    SequenceEqualSubscriber.prototype._next = function (value) {
	        if (this._oneComplete && this._b.length === 0) {
	            this.emit(false);
	        }
	        else {
	            this._a.push(value);
	            this.checkValues();
	        }
	    };
	    SequenceEqualSubscriber.prototype._complete = function () {
	        if (this._oneComplete) {
	            this.emit(this._a.length === 0 && this._b.length === 0);
	        }
	        else {
	            this._oneComplete = true;
	        }
	    };
	    SequenceEqualSubscriber.prototype.checkValues = function () {
	        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
	        while (_a.length > 0 && _b.length > 0) {
	            var a = _a.shift();
	            var b = _b.shift();
	            var areEqual = false;
	            if (comparor) {
	                areEqual = tryCatch_1.tryCatch(comparor)(a, b);
	                if (areEqual === errorObject_1.errorObject) {
	                    this.destination.error(errorObject_1.errorObject.e);
	                }
	            }
	            else {
	                areEqual = a === b;
	            }
	            if (!areEqual) {
	                this.emit(false);
	            }
	        }
	    };
	    SequenceEqualSubscriber.prototype.emit = function (value) {
	        var destination = this.destination;
	        destination.next(value);
	        destination.complete();
	    };
	    SequenceEqualSubscriber.prototype.nextB = function (value) {
	        if (this._oneComplete && this._a.length === 0) {
	            this.emit(false);
	        }
	        else {
	            this._b.push(value);
	            this.checkValues();
	        }
	    };
	    return SequenceEqualSubscriber;
	}(Subscriber_1.Subscriber));
	exports.SequenceEqualSubscriber = SequenceEqualSubscriber;
	var SequenceEqualCompareToSubscriber = (function (_super) {
	    __extends(SequenceEqualCompareToSubscriber, _super);
	    function SequenceEqualCompareToSubscriber(destination, parent) {
	        _super.call(this, destination);
	        this.parent = parent;
	    }
	    SequenceEqualCompareToSubscriber.prototype._next = function (value) {
	        this.parent.nextB(value);
	    };
	    SequenceEqualCompareToSubscriber.prototype._error = function (err) {
	        this.parent.error(err);
	    };
	    SequenceEqualCompareToSubscriber.prototype._complete = function () {
	        this.parent._complete();
	    };
	    return SequenceEqualCompareToSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var multicast_1 = __webpack_require__(164);
	var refCount_1 = __webpack_require__(518);
	var Subject_1 = __webpack_require__(30);
	function shareSubjectFactory() {
	    return new Subject_1.Subject();
	}
	/**
	 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
	 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
	 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
	 * This is an alias for .multicast(() => new Subject()).refCount().
	 *
	 * <img src="./img/share.png" width="100%">
	 *
	 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
	 * @method share
	 * @owner Observable
	 */
	function share() {
	    return function (source) { return refCount_1.refCount()(multicast_1.multicast(shareSubjectFactory)(source)); };
	}
	exports.share = share;
	;
	//# sourceMappingURL=share.js.map

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ReplaySubject_1 = __webpack_require__(345);
	/**
	 * @method shareReplay
	 * @owner Observable
	 */
	function shareReplay(bufferSize, windowTime, scheduler) {
	    return function (source) { return source.lift(shareReplayOperator(bufferSize, windowTime, scheduler)); };
	}
	exports.shareReplay = shareReplay;
	function shareReplayOperator(bufferSize, windowTime, scheduler) {
	    var subject;
	    var refCount = 0;
	    var subscription;
	    var hasError = false;
	    var isComplete = false;
	    return function shareReplayOperation(source) {
	        refCount++;
	        if (!subject || hasError) {
	            hasError = false;
	            subject = new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler);
	            subscription = source.subscribe({
	                next: function (value) { subject.next(value); },
	                error: function (err) {
	                    hasError = true;
	                    subject.error(err);
	                },
	                complete: function () {
	                    isComplete = true;
	                    subject.complete();
	                },
	            });
	        }
	        var innerSub = subject.subscribe(this);
	        return function () {
	            refCount--;
	            innerSub.unsubscribe();
	            if (subscription && refCount === 0 && isComplete) {
	                subscription.unsubscribe();
	            }
	        };
	    };
	}
	;
	//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var EmptyError_1 = __webpack_require__(357);
	/**
	 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
	 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
	 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
	 *
	 * <img src="./img/single.png" width="100%">
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
	 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
	 * the predicate.
	 .
	 * @method single
	 * @owner Observable
	 */
	function single(predicate) {
	    return function (source) { return source.lift(new SingleOperator(predicate, source)); };
	}
	exports.single = single;
	var SingleOperator = (function () {
	    function SingleOperator(predicate, source) {
	        this.predicate = predicate;
	        this.source = source;
	    }
	    SingleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
	    };
	    return SingleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SingleSubscriber = (function (_super) {
	    __extends(SingleSubscriber, _super);
	    function SingleSubscriber(destination, predicate, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.source = source;
	        this.seenValue = false;
	        this.index = 0;
	    }
	    SingleSubscriber.prototype.applySingleValue = function (value) {
	        if (this.seenValue) {
	            this.destination.error('Sequence contains more than one element');
	        }
	        else {
	            this.seenValue = true;
	            this.singleValue = value;
	        }
	    };
	    SingleSubscriber.prototype._next = function (value) {
	        var index = this.index++;
	        if (this.predicate) {
	            this.tryNext(value, index);
	        }
	        else {
	            this.applySingleValue(value);
	        }
	    };
	    SingleSubscriber.prototype.tryNext = function (value, index) {
	        try {
	            if (this.predicate(value, index, this.source)) {
	                this.applySingleValue(value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    SingleSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (this.index > 0) {
	            destination.next(this.seenValue ? this.singleValue : undefined);
	            destination.complete();
	        }
	        else {
	            destination.error(new EmptyError_1.EmptyError);
	        }
	    };
	    return SingleSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=single.js.map

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/**
	 * Returns an Observable that skips the first `count` items emitted by the source Observable.
	 *
	 * <img src="./img/skip.png" width="100%">
	 *
	 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
	 * @return {Observable} An Observable that skips values emitted by the source Observable.
	 *
	 * @method skip
	 * @owner Observable
	 */
	function skip(count) {
	    return function (source) { return source.lift(new SkipOperator(count)); };
	}
	exports.skip = skip;
	var SkipOperator = (function () {
	    function SkipOperator(total) {
	        this.total = total;
	    }
	    SkipOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SkipSubscriber(subscriber, this.total));
	    };
	    return SkipOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SkipSubscriber = (function (_super) {
	    __extends(SkipSubscriber, _super);
	    function SkipSubscriber(destination, total) {
	        _super.call(this, destination);
	        this.total = total;
	        this.count = 0;
	    }
	    SkipSubscriber.prototype._next = function (x) {
	        if (++this.count > this.total) {
	            this.destination.next(x);
	        }
	    };
	    return SkipSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=skip.js.map

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var ArgumentOutOfRangeError_1 = __webpack_require__(271);
	/**
	 * Skip the last `count` values emitted by the source Observable.
	 *
	 * <img src="./img/skipLast.png" width="100%">
	 *
	 * `skipLast` returns an Observable that accumulates a queue with a length
	 * enough to store the first `count` values. As more values are received,
	 * values are taken from the front of the queue and produced on the result
	 * sequence. This causes values to be delayed.
	 *
	 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
	 * var many = Rx.Observable.range(1, 5);
	 * var skipLastTwo = many.skipLast(2);
	 * skipLastTwo.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // 1 2 3
	 *
	 * @see {@link skip}
	 * @see {@link skipUntil}
	 * @see {@link skipWhile}
	 * @see {@link take}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
	 * ArgumentOutOrRangeError if `i < 0`.
	 *
	 * @param {number} count Number of elements to skip from the end of the source Observable.
	 * @returns {Observable<T>} An Observable that skips the last count values
	 * emitted by the source Observable.
	 * @method skipLast
	 * @owner Observable
	 */
	function skipLast(count) {
	    return function (source) { return source.lift(new SkipLastOperator(count)); };
	}
	exports.skipLast = skipLast;
	var SkipLastOperator = (function () {
	    function SkipLastOperator(_skipCount) {
	        this._skipCount = _skipCount;
	        if (this._skipCount < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    SkipLastOperator.prototype.call = function (subscriber, source) {
	        if (this._skipCount === 0) {
	            // If we don't want to skip any values then just subscribe
	            // to Subscriber without any further logic.
	            return source.subscribe(new Subscriber_1.Subscriber(subscriber));
	        }
	        else {
	            return source.subscribe(new SkipLastSubscriber(subscriber, this._skipCount));
	        }
	    };
	    return SkipLastOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SkipLastSubscriber = (function (_super) {
	    __extends(SkipLastSubscriber, _super);
	    function SkipLastSubscriber(destination, _skipCount) {
	        _super.call(this, destination);
	        this._skipCount = _skipCount;
	        this._count = 0;
	        this._ring = new Array(_skipCount);
	    }
	    SkipLastSubscriber.prototype._next = function (value) {
	        var skipCount = this._skipCount;
	        var count = this._count++;
	        if (count < skipCount) {
	            this._ring[count] = value;
	        }
	        else {
	            var currentIndex = count % skipCount;
	            var ring = this._ring;
	            var oldValue = ring[currentIndex];
	            ring[currentIndex] = value;
	            this.destination.next(oldValue);
	        }
	    };
	    return SkipLastSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/**
	 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
	 *
	 * <img src="./img/skipUntil.png" width="100%">
	 *
	 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
	 * be mirrored by the resulting Observable.
	 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
	 * an item, then emits the remaining items.
	 * @method skipUntil
	 * @owner Observable
	 */
	function skipUntil(notifier) {
	    return function (source) { return source.lift(new SkipUntilOperator(notifier)); };
	}
	exports.skipUntil = skipUntil;
	var SkipUntilOperator = (function () {
	    function SkipUntilOperator(notifier) {
	        this.notifier = notifier;
	    }
	    SkipUntilOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SkipUntilSubscriber(subscriber, this.notifier));
	    };
	    return SkipUntilOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SkipUntilSubscriber = (function (_super) {
	    __extends(SkipUntilSubscriber, _super);
	    function SkipUntilSubscriber(destination, notifier) {
	        _super.call(this, destination);
	        this.hasValue = false;
	        this.isInnerStopped = false;
	        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
	    }
	    SkipUntilSubscriber.prototype._next = function (value) {
	        if (this.hasValue) {
	            _super.prototype._next.call(this, value);
	        }
	    };
	    SkipUntilSubscriber.prototype._complete = function () {
	        if (this.isInnerStopped) {
	            _super.prototype._complete.call(this);
	        }
	        else {
	            this.unsubscribe();
	        }
	    };
	    SkipUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.hasValue = true;
	    };
	    SkipUntilSubscriber.prototype.notifyComplete = function () {
	        this.isInnerStopped = true;
	        if (this.isStopped) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    return SkipUntilSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/**
	 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
	 * true, but emits all further source items as soon as the condition becomes false.
	 *
	 * <img src="./img/skipWhile.png" width="100%">
	 *
	 * @param {Function} predicate - A function to test each item emitted from the source Observable.
	 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
	 * specified predicate becomes false.
	 * @method skipWhile
	 * @owner Observable
	 */
	function skipWhile(predicate) {
	    return function (source) { return source.lift(new SkipWhileOperator(predicate)); };
	}
	exports.skipWhile = skipWhile;
	var SkipWhileOperator = (function () {
	    function SkipWhileOperator(predicate) {
	        this.predicate = predicate;
	    }
	    SkipWhileOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
	    };
	    return SkipWhileOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SkipWhileSubscriber = (function (_super) {
	    __extends(SkipWhileSubscriber, _super);
	    function SkipWhileSubscriber(destination, predicate) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.skipping = true;
	        this.index = 0;
	    }
	    SkipWhileSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        if (this.skipping) {
	            this.tryCallPredicate(value);
	        }
	        if (!this.skipping) {
	            destination.next(value);
	        }
	    };
	    SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
	        try {
	            var result = this.predicate(value, this.index++);
	            this.skipping = Boolean(result);
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    return SkipWhileSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ArrayObservable_1 = __webpack_require__(118);
	var ScalarObservable_1 = __webpack_require__(506);
	var EmptyObservable_1 = __webpack_require__(119);
	var concat_1 = __webpack_require__(265);
	var isScheduler_1 = __webpack_require__(65);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits the items you specify as arguments before it begins to emit
	 * items emitted by the source Observable.
	 *
	 * <img src="./img/startWith.png" width="100%">
	 *
	 * @param {...T} values - Items you want the modified Observable to emit first.
	 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
	 * the emissions of the `next` notifications.
	 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
	 * emitted by the source Observable.
	 * @method startWith
	 * @owner Observable
	 */
	function startWith() {
	    var array = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        array[_i - 0] = arguments[_i];
	    }
	    return function (source) {
	        var scheduler = array[array.length - 1];
	        if (isScheduler_1.isScheduler(scheduler)) {
	            array.pop();
	        }
	        else {
	            scheduler = null;
	        }
	        var len = array.length;
	        if (len === 1) {
	            return concat_1.concat(new ScalarObservable_1.ScalarObservable(array[0], scheduler), source);
	        }
	        else if (len > 1) {
	            return concat_1.concat(new ArrayObservable_1.ArrayObservable(array, scheduler), source);
	        }
	        else {
	            return concat_1.concat(new EmptyObservable_1.EmptyObservable(scheduler), source);
	        }
	    };
	}
	exports.startWith = startWith;
	//# sourceMappingURL=startWith.js.map

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var switchMap_1 = __webpack_require__(351);
	var identity_1 = __webpack_require__(855);
	function switchAll() {
	    return switchMap_1.switchMap(identity_1.identity);
	}
	exports.switchAll = switchAll;
	//# sourceMappingURL=switchAll.js.map

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is flattened multiple
	 * times with {@link switch} in the output Observable.
	 *
	 * <span class="informal">It's like {@link switchMap}, but maps each value
	 * always to the same inner Observable.</span>
	 *
	 * <img src="./img/switchMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then flattens those resulting Observables into one
	 * single Observable, which is the output Observable. The output Observables
	 * emits values only from the most recently emitted instance of
	 * `innerObservable`.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMapTo}
	 * @see {@link switch}
	 * @see {@link switchMap}
	 * @see {@link mergeMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits items from the given
	 * `innerObservable` (and optionally transformed through `resultSelector`) every
	 * time a value is emitted on the source Observable, and taking only the values
	 * from the most recently projected inner Observable.
	 * @method switchMapTo
	 * @owner Observable
	 */
	function switchMapTo(innerObservable, resultSelector) {
	    return function (source) { return source.lift(new SwitchMapToOperator(innerObservable, resultSelector)); };
	}
	exports.switchMapTo = switchMapTo;
	var SwitchMapToOperator = (function () {
	    function SwitchMapToOperator(observable, resultSelector) {
	        this.observable = observable;
	        this.resultSelector = resultSelector;
	    }
	    SwitchMapToOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SwitchMapToSubscriber(subscriber, this.observable, this.resultSelector));
	    };
	    return SwitchMapToOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchMapToSubscriber = (function (_super) {
	    __extends(SwitchMapToSubscriber, _super);
	    function SwitchMapToSubscriber(destination, inner, resultSelector) {
	        _super.call(this, destination);
	        this.inner = inner;
	        this.resultSelector = resultSelector;
	        this.index = 0;
	    }
	    SwitchMapToSubscriber.prototype._next = function (value) {
	        var innerSubscription = this.innerSubscription;
	        if (innerSubscription) {
	            innerSubscription.unsubscribe();
	        }
	        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, this.inner, value, this.index++));
	    };
	    SwitchMapToSubscriber.prototype._complete = function () {
	        var innerSubscription = this.innerSubscription;
	        if (!innerSubscription || innerSubscription.closed) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    SwitchMapToSubscriber.prototype._unsubscribe = function () {
	        this.innerSubscription = null;
	    };
	    SwitchMapToSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.remove(innerSub);
	        this.innerSubscription = null;
	        if (this.isStopped) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    SwitchMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        if (resultSelector) {
	            this.tryResultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            destination.next(innerValue);
	        }
	    };
	    SwitchMapToSubscriber.prototype.tryResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        var result;
	        try {
	            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        destination.next(result);
	    };
	    return SwitchMapToSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var ArgumentOutOfRangeError_1 = __webpack_require__(271);
	var EmptyObservable_1 = __webpack_require__(119);
	/**
	 * Emits only the first `count` values emitted by the source Observable.
	 *
	 * <span class="informal">Takes the first `count` values from the source, then
	 * completes.</span>
	 *
	 * <img src="./img/take.png" width="100%">
	 *
	 * `take` returns an Observable that emits only the first `count` values emitted
	 * by the source Observable. If the source emits fewer than `count` values then
	 * all of its values are emitted. After that, it completes, regardless if the
	 * source completes.
	 *
	 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
	 * var interval = Rx.Observable.interval(1000);
	 * var five = interval.take(5);
	 * five.subscribe(x => console.log(x));
	 *
	 * @see {@link takeLast}
	 * @see {@link takeUntil}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
	 *
	 * @param {number} count The maximum number of `next` values to emit.
	 * @return {Observable<T>} An Observable that emits only the first `count`
	 * values emitted by the source Observable, or all of the values from the source
	 * if the source emits fewer than `count` values.
	 * @method take
	 * @owner Observable
	 */
	function take(count) {
	    return function (source) {
	        if (count === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        else {
	            return source.lift(new TakeOperator(count));
	        }
	    };
	}
	exports.take = take;
	var TakeOperator = (function () {
	    function TakeOperator(total) {
	        this.total = total;
	        if (this.total < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    TakeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeSubscriber(subscriber, this.total));
	    };
	    return TakeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TakeSubscriber = (function (_super) {
	    __extends(TakeSubscriber, _super);
	    function TakeSubscriber(destination, total) {
	        _super.call(this, destination);
	        this.total = total;
	        this.count = 0;
	    }
	    TakeSubscriber.prototype._next = function (value) {
	        var total = this.total;
	        var count = ++this.count;
	        if (count <= total) {
	            this.destination.next(value);
	            if (count === total) {
	                this.destination.complete();
	                this.unsubscribe();
	            }
	        }
	    };
	    return TakeSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=take.js.map

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/**
	 * Emits the values emitted by the source Observable until a `notifier`
	 * Observable emits a value.
	 *
	 * <span class="informal">Lets values pass until a second Observable,
	 * `notifier`, emits something. Then, it completes.</span>
	 *
	 * <img src="./img/takeUntil.png" width="100%">
	 *
	 * `takeUntil` subscribes and begins mirroring the source Observable. It also
	 * monitors a second Observable, `notifier` that you provide. If the `notifier`
	 * emits a value or a complete notification, the output Observable stops
	 * mirroring the source Observable and completes.
	 *
	 * @example <caption>Tick every second until the first click happens</caption>
	 * var interval = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = interval.takeUntil(clicks);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeLast}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @param {Observable} notifier The Observable whose first emitted value will
	 * cause the output Observable of `takeUntil` to stop emitting values from the
	 * source Observable.
	 * @return {Observable<T>} An Observable that emits the values from the source
	 * Observable until such time as `notifier` emits its first value.
	 * @method takeUntil
	 * @owner Observable
	 */
	function takeUntil(notifier) {
	    return function (source) { return source.lift(new TakeUntilOperator(notifier)); };
	}
	exports.takeUntil = takeUntil;
	var TakeUntilOperator = (function () {
	    function TakeUntilOperator(notifier) {
	        this.notifier = notifier;
	    }
	    TakeUntilOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeUntilSubscriber(subscriber, this.notifier));
	    };
	    return TakeUntilOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TakeUntilSubscriber = (function (_super) {
	    __extends(TakeUntilSubscriber, _super);
	    function TakeUntilSubscriber(destination, notifier) {
	        _super.call(this, destination);
	        this.notifier = notifier;
	        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
	    }
	    TakeUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.complete();
	    };
	    TakeUntilSubscriber.prototype.notifyComplete = function () {
	        // noop
	    };
	    return TakeUntilSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/**
	 * Emits values emitted by the source Observable so long as each value satisfies
	 * the given `predicate`, and then completes as soon as this `predicate` is not
	 * satisfied.
	 *
	 * <span class="informal">Takes values from the source only while they pass the
	 * condition given. When the first value does not satisfy, it completes.</span>
	 *
	 * <img src="./img/takeWhile.png" width="100%">
	 *
	 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
	 * emitted on the source is given to the `predicate` function which returns a
	 * boolean, representing a condition to be satisfied by the source values. The
	 * output Observable emits the source values until such time as the `predicate`
	 * returns false, at which point `takeWhile` stops mirroring the source
	 * Observable and completes the output Observable.
	 *
	 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.takeWhile(ev => ev.clientX > 200);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeLast}
	 * @see {@link takeUntil}
	 * @see {@link skip}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates a value emitted by the source Observable and returns a boolean.
	 * Also takes the (zero-based) index as the second argument.
	 * @return {Observable<T>} An Observable that emits the values from the source
	 * Observable so long as each value satisfies the condition defined by the
	 * `predicate`, then completes.
	 * @method takeWhile
	 * @owner Observable
	 */
	function takeWhile(predicate) {
	    return function (source) { return source.lift(new TakeWhileOperator(predicate)); };
	}
	exports.takeWhile = takeWhile;
	var TakeWhileOperator = (function () {
	    function TakeWhileOperator(predicate) {
	        this.predicate = predicate;
	    }
	    TakeWhileOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate));
	    };
	    return TakeWhileOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TakeWhileSubscriber = (function (_super) {
	    __extends(TakeWhileSubscriber, _super);
	    function TakeWhileSubscriber(destination, predicate) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.index = 0;
	    }
	    TakeWhileSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        var result;
	        try {
	            result = this.predicate(value, this.index++);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        this.nextOrComplete(value, result);
	    };
	    TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
	        var destination = this.destination;
	        if (Boolean(predicateResult)) {
	            destination.next(value);
	        }
	        else {
	            destination.complete();
	        }
	    };
	    return TakeWhileSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var async_1 = __webpack_require__(23);
	var throttle_1 = __webpack_require__(353);
	/**
	 * Emits a value from the source Observable, then ignores subsequent source
	 * values for `duration` milliseconds, then repeats this process.
	 *
	 * <span class="informal">Lets a value pass, then ignores source values for the
	 * next `duration` milliseconds.</span>
	 *
	 * <img src="./img/throttleTime.png" width="100%">
	 *
	 * `throttleTime` emits the source Observable values on the output Observable
	 * when its internal timer is disabled, and ignores source values when the timer
	 * is enabled. Initially, the timer is disabled. As soon as the first source
	 * value arrives, it is forwarded to the output Observable, and then the timer
	 * is enabled. After `duration` milliseconds (or the time unit determined
	 * internally by the optional `scheduler`) has passed, the timer is disabled,
	 * and this process repeats for the next source value. Optionally takes a
	 * {@link IScheduler} for managing timers.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.throttleTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttle}
	 *
	 * @param {number} duration Time to wait before emitting another value after
	 * emitting the last value, measured in milliseconds or the time unit determined
	 * internally by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the throttling.
	 * @return {Observable<T>} An Observable that performs the throttle operation to
	 * limit the rate of emissions from the source.
	 * @method throttleTime
	 * @owner Observable
	 */
	function throttleTime(duration, scheduler, config) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
	    return function (source) { return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing)); };
	}
	exports.throttleTime = throttleTime;
	var ThrottleTimeOperator = (function () {
	    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
	        this.duration = duration;
	        this.scheduler = scheduler;
	        this.leading = leading;
	        this.trailing = trailing;
	    }
	    ThrottleTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
	    };
	    return ThrottleTimeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ThrottleTimeSubscriber = (function (_super) {
	    __extends(ThrottleTimeSubscriber, _super);
	    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
	        _super.call(this, destination);
	        this.duration = duration;
	        this.scheduler = scheduler;
	        this.leading = leading;
	        this.trailing = trailing;
	        this._hasTrailingValue = false;
	        this._trailingValue = null;
	    }
	    ThrottleTimeSubscriber.prototype._next = function (value) {
	        if (this.throttled) {
	            if (this.trailing) {
	                this._trailingValue = value;
	                this._hasTrailingValue = true;
	            }
	        }
	        else {
	            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, { subscriber: this }));
	            if (this.leading) {
	                this.destination.next(value);
	            }
	        }
	    };
	    ThrottleTimeSubscriber.prototype.clearThrottle = function () {
	        var throttled = this.throttled;
	        if (throttled) {
	            if (this.trailing && this._hasTrailingValue) {
	                this.destination.next(this._trailingValue);
	                this._trailingValue = null;
	                this._hasTrailingValue = false;
	            }
	            throttled.unsubscribe();
	            this.remove(throttled);
	            this.throttled = null;
	        }
	    };
	    return ThrottleTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchNext(arg) {
	    var subscriber = arg.subscriber;
	    subscriber.clearThrottle();
	}
	//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var async_1 = __webpack_require__(23);
	function timeInterval(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return function (source) { return source.lift(new TimeIntervalOperator(scheduler)); };
	}
	exports.timeInterval = timeInterval;
	var TimeInterval = (function () {
	    function TimeInterval(value, interval) {
	        this.value = value;
	        this.interval = interval;
	    }
	    return TimeInterval;
	}());
	exports.TimeInterval = TimeInterval;
	;
	var TimeIntervalOperator = (function () {
	    function TimeIntervalOperator(scheduler) {
	        this.scheduler = scheduler;
	    }
	    TimeIntervalOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new TimeIntervalSubscriber(observer, this.scheduler));
	    };
	    return TimeIntervalOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TimeIntervalSubscriber = (function (_super) {
	    __extends(TimeIntervalSubscriber, _super);
	    function TimeIntervalSubscriber(destination, scheduler) {
	        _super.call(this, destination);
	        this.scheduler = scheduler;
	        this.lastTime = 0;
	        this.lastTime = scheduler.now();
	    }
	    TimeIntervalSubscriber.prototype._next = function (value) {
	        var now = this.scheduler.now();
	        var span = now - this.lastTime;
	        this.lastTime = now;
	        this.destination.next(new TimeInterval(value, span));
	    };
	    return TimeIntervalSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var async_1 = __webpack_require__(23);
	var isDate_1 = __webpack_require__(359);
	var Subscriber_1 = __webpack_require__(11);
	var TimeoutError_1 = __webpack_require__(852);
	/**
	 *
	 * Errors if Observable does not emit a value in given time span.
	 *
	 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
	 *
	 * <img src="./img/timeout.png" width="100%">
	 *
	 * `timeout` operator accepts as an argument either a number or a Date.
	 *
	 * If number was provided, it returns an Observable that behaves like a source
	 * Observable, unless there is a period of time where there is no value emitted.
	 * So if you provide `100` as argument and first value comes after 50ms from
	 * the moment of subscription, this value will be simply re-emitted by the resulting
	 * Observable. If however after that 100ms passes without a second value being emitted,
	 * stream will end with an error and source Observable will be unsubscribed.
	 * These checks are performed throughout whole lifecycle of Observable - from the moment
	 * it was subscribed to, until it completes or errors itself. Thus every value must be
	 * emitted within specified period since previous value.
	 *
	 * If provided argument was Date, returned Observable behaves differently. It throws
	 * if Observable did not complete before provided Date. This means that periods between
	 * emission of particular values do not matter in this case. If Observable did not complete
	 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
	 * stream behaves just as source Observable.
	 *
	 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
	 * when returned Observable will check if source stream emitted value or completed.
	 *
	 * @example <caption>Check if ticks are emitted within certain timespan</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 *
	 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
	 *                       // since `interval` might fire a bit later then scheduled.
	 * .subscribe(
	 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
	 *     err => console.log(err) // Will never be called.
	 * );
	 *
	 * seconds.timeout(900).subscribe(
	 *     value => console.log(value), // Will never be called.
	 *     err => console.log(err) // Will emit error before even first value is emitted,
	 *                             // since it did not arrive within 900ms period.
	 * );
	 *
	 * @example <caption>Use Date to check if Observable completed</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 *
	 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
	 * .subscribe(
	 *     value => console.log(value), // Will emit values as regular `interval` would
	 *                                  // until December 17, 2020 at 03:24:00.
	 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
	 *                             // since Observable did not complete by then.
	 * );
	 *
	 * @see {@link timeoutWith}
	 *
	 * @param {number|Date} due Number specifying period within which Observable must emit values
	 *                          or Date specifying before when Observable should complete
	 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
	 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
	 * @method timeout
	 * @owner Observable
	 */
	function timeout(due, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    var absoluteTimeout = isDate_1.isDate(due);
	    var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
	    return function (source) { return source.lift(new TimeoutOperator(waitFor, absoluteTimeout, scheduler, new TimeoutError_1.TimeoutError())); };
	}
	exports.timeout = timeout;
	var TimeoutOperator = (function () {
	    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
	        this.waitFor = waitFor;
	        this.absoluteTimeout = absoluteTimeout;
	        this.scheduler = scheduler;
	        this.errorInstance = errorInstance;
	    }
	    TimeoutOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
	    };
	    return TimeoutOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TimeoutSubscriber = (function (_super) {
	    __extends(TimeoutSubscriber, _super);
	    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
	        _super.call(this, destination);
	        this.absoluteTimeout = absoluteTimeout;
	        this.waitFor = waitFor;
	        this.scheduler = scheduler;
	        this.errorInstance = errorInstance;
	        this.action = null;
	        this.scheduleTimeout();
	    }
	    TimeoutSubscriber.dispatchTimeout = function (subscriber) {
	        subscriber.error(subscriber.errorInstance);
	    };
	    TimeoutSubscriber.prototype.scheduleTimeout = function () {
	        var action = this.action;
	        if (action) {
	            // Recycle the action if we've already scheduled one. All the production
	            // Scheduler Actions mutate their state/delay time and return themeselves.
	            // VirtualActions are immutable, so they create and return a clone. In this
	            // case, we need to set the action reference to the most recent VirtualAction,
	            // to ensure that's the one we clone from next time.
	            this.action = action.schedule(this, this.waitFor);
	        }
	        else {
	            this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
	        }
	    };
	    TimeoutSubscriber.prototype._next = function (value) {
	        if (!this.absoluteTimeout) {
	            this.scheduleTimeout();
	        }
	        _super.prototype._next.call(this, value);
	    };
	    TimeoutSubscriber.prototype._unsubscribe = function () {
	        this.action = null;
	        this.scheduler = null;
	        this.errorInstance = null;
	    };
	    return TimeoutSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=timeout.js.map

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var async_1 = __webpack_require__(23);
	var isDate_1 = __webpack_require__(359);
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/* tslint:enable:max-line-length */
	/**
	 *
	 * Errors if Observable does not emit a value in given time span, in case of which
	 * subscribes to the second Observable.
	 *
	 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
	 *
	 * <img src="./img/timeoutWith.png" width="100%">
	 *
	 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
	 * still accepting as a first argument either a number or a Date, which control - respectively -
	 * when values of source Observable should be emitted or when it should complete.
	 *
	 * The only difference is that it accepts a second, required parameter. This parameter
	 * should be an Observable which will be subscribed when source Observable fails any timeout check.
	 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
	 * values from second Observable. Note that this fallback Observable is not checked for timeouts
	 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
	 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
	 * stream completes, it completes as well.
	 *
	 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
	 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
	 * as a consequence - when second Observable will be subscribed, since subscription happens
	 * immediately after failing check.
	 *
	 * @example <caption>Add fallback observable</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 * const minutes = Rx.Observable.interval(60 * 1000);
	 *
	 * seconds.timeoutWith(900, minutes)
	 *     .subscribe(
	 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
	 *                                      // since first value of `seconds` will not arrive fast enough.
	 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
	 *                                 // but here will never be called.
	 *     );
	 *
	 * @param {number|Date} due Number specifying period within which Observable must emit values
	 *                          or Date specifying before when Observable should complete
	 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
	 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
	 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
	 *                          passed as a second parameter.
	 * @method timeoutWith
	 * @owner Observable
	 */
	function timeoutWith(due, withObservable, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return function (source) {
	        var absoluteTimeout = isDate_1.isDate(due);
	        var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
	        return source.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
	    };
	}
	exports.timeoutWith = timeoutWith;
	var TimeoutWithOperator = (function () {
	    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
	        this.waitFor = waitFor;
	        this.absoluteTimeout = absoluteTimeout;
	        this.withObservable = withObservable;
	        this.scheduler = scheduler;
	    }
	    TimeoutWithOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
	    };
	    return TimeoutWithOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TimeoutWithSubscriber = (function (_super) {
	    __extends(TimeoutWithSubscriber, _super);
	    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
	        _super.call(this, destination);
	        this.absoluteTimeout = absoluteTimeout;
	        this.waitFor = waitFor;
	        this.withObservable = withObservable;
	        this.scheduler = scheduler;
	        this.action = null;
	        this.scheduleTimeout();
	    }
	    TimeoutWithSubscriber.dispatchTimeout = function (subscriber) {
	        var withObservable = subscriber.withObservable;
	        subscriber._unsubscribeAndRecycle();
	        subscriber.add(subscribeToResult_1.subscribeToResult(subscriber, withObservable));
	    };
	    TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
	        var action = this.action;
	        if (action) {
	            // Recycle the action if we've already scheduled one. All the production
	            // Scheduler Actions mutate their state/delay time and return themeselves.
	            // VirtualActions are immutable, so they create and return a clone. In this
	            // case, we need to set the action reference to the most recent VirtualAction,
	            // to ensure that's the one we clone from next time.
	            this.action = action.schedule(this, this.waitFor);
	        }
	        else {
	            this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
	        }
	    };
	    TimeoutWithSubscriber.prototype._next = function (value) {
	        if (!this.absoluteTimeout) {
	            this.scheduleTimeout();
	        }
	        _super.prototype._next.call(this, value);
	    };
	    TimeoutWithSubscriber.prototype._unsubscribe = function () {
	        this.action = null;
	        this.scheduler = null;
	        this.withObservable = null;
	    };
	    return TimeoutWithSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var reduce_1 = __webpack_require__(267);
	function toArrayReducer(arr, item, index) {
	    if (index === 0) {
	        return [item];
	    }
	    arr.push(item);
	    return arr;
	}
	function toArray() {
	    return reduce_1.reduce(toArrayReducer, []);
	}
	exports.toArray = toArray;
	//# sourceMappingURL=toArray.js.map

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(30);
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/**
	 * Branch out the source Observable values as a nested Observable whenever
	 * `windowBoundaries` emits.
	 *
	 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
	 * instead of an array.</span>
	 *
	 * <img src="./img/window.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits connected, non-overlapping
	 * windows. It emits the current window and opens a new one whenever the
	 * Observable `windowBoundaries` emits an item. Because each window is an
	 * Observable, the output is a higher-order Observable.
	 *
	 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var interval = Rx.Observable.interval(1000);
	 * var result = clicks.window(interval)
	 *   .map(win => win.take(2)) // each window has at most 2 emissions
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link windowWhen}
	 * @see {@link buffer}
	 *
	 * @param {Observable<any>} windowBoundaries An Observable that completes the
	 * previous window and starts a new window.
	 * @return {Observable<Observable<T>>} An Observable of windows, which are
	 * Observables emitting values of the source Observable.
	 * @method window
	 * @owner Observable
	 */
	function window(windowBoundaries) {
	    return function windowOperatorFunction(source) {
	        return source.lift(new WindowOperator(windowBoundaries));
	    };
	}
	exports.window = window;
	var WindowOperator = (function () {
	    function WindowOperator(windowBoundaries) {
	        this.windowBoundaries = windowBoundaries;
	    }
	    WindowOperator.prototype.call = function (subscriber, source) {
	        var windowSubscriber = new WindowSubscriber(subscriber);
	        var sourceSubscription = source.subscribe(windowSubscriber);
	        if (!sourceSubscription.closed) {
	            windowSubscriber.add(subscribeToResult_1.subscribeToResult(windowSubscriber, this.windowBoundaries));
	        }
	        return sourceSubscription;
	    };
	    return WindowOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowSubscriber = (function (_super) {
	    __extends(WindowSubscriber, _super);
	    function WindowSubscriber(destination) {
	        _super.call(this, destination);
	        this.window = new Subject_1.Subject();
	        destination.next(this.window);
	    }
	    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.openWindow();
	    };
	    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
	        this._complete();
	    };
	    WindowSubscriber.prototype._next = function (value) {
	        this.window.next(value);
	    };
	    WindowSubscriber.prototype._error = function (err) {
	        this.window.error(err);
	        this.destination.error(err);
	    };
	    WindowSubscriber.prototype._complete = function () {
	        this.window.complete();
	        this.destination.complete();
	    };
	    WindowSubscriber.prototype._unsubscribe = function () {
	        this.window = null;
	    };
	    WindowSubscriber.prototype.openWindow = function () {
	        var prevWindow = this.window;
	        if (prevWindow) {
	            prevWindow.complete();
	        }
	        var destination = this.destination;
	        var newWindow = this.window = new Subject_1.Subject();
	        destination.next(newWindow);
	    };
	    return WindowSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=window.js.map

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	var Subject_1 = __webpack_require__(30);
	/**
	 * Branch out the source Observable values as a nested Observable with each
	 * nested Observable emitting at most `windowSize` values.
	 *
	 * <span class="informal">It's like {@link bufferCount}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowCount.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits windows every `startWindowEvery`
	 * items, each containing no more than `windowSize` items. When the source
	 * Observable completes or encounters an error, the output Observable emits
	 * the current window and propagates the notification from the source
	 * Observable. If `startWindowEvery` is not provided, then new windows are
	 * started immediately at the start of the source and when each window completes
	 * with size `windowSize`.
	 *
	 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.windowCount(3)
	 *   .map(win => win.skip(1)) // skip first of every 3 clicks
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.windowCount(2, 3)
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link windowWhen}
	 * @see {@link bufferCount}
	 *
	 * @param {number} windowSize The maximum number of values emitted by each
	 * window.
	 * @param {number} [startWindowEvery] Interval at which to start a new window.
	 * For example if `startWindowEvery` is `2`, then a new window will be started
	 * on every other value from the source. A new window is started at the
	 * beginning of the source by default.
	 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
	 * are Observable of values.
	 * @method windowCount
	 * @owner Observable
	 */
	function windowCount(windowSize, startWindowEvery) {
	    if (startWindowEvery === void 0) { startWindowEvery = 0; }
	    return function windowCountOperatorFunction(source) {
	        return source.lift(new WindowCountOperator(windowSize, startWindowEvery));
	    };
	}
	exports.windowCount = windowCount;
	var WindowCountOperator = (function () {
	    function WindowCountOperator(windowSize, startWindowEvery) {
	        this.windowSize = windowSize;
	        this.startWindowEvery = startWindowEvery;
	    }
	    WindowCountOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
	    };
	    return WindowCountOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowCountSubscriber = (function (_super) {
	    __extends(WindowCountSubscriber, _super);
	    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.windowSize = windowSize;
	        this.startWindowEvery = startWindowEvery;
	        this.windows = [new Subject_1.Subject()];
	        this.count = 0;
	        destination.next(this.windows[0]);
	    }
	    WindowCountSubscriber.prototype._next = function (value) {
	        var startWindowEvery = (this.startWindowEvery > 0) ? this.startWindowEvery : this.windowSize;
	        var destination = this.destination;
	        var windowSize = this.windowSize;
	        var windows = this.windows;
	        var len = windows.length;
	        for (var i = 0; i < len && !this.closed; i++) {
	            windows[i].next(value);
	        }
	        var c = this.count - windowSize + 1;
	        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
	            windows.shift().complete();
	        }
	        if (++this.count % startWindowEvery === 0 && !this.closed) {
	            var window_1 = new Subject_1.Subject();
	            windows.push(window_1);
	            destination.next(window_1);
	        }
	    };
	    WindowCountSubscriber.prototype._error = function (err) {
	        var windows = this.windows;
	        if (windows) {
	            while (windows.length > 0 && !this.closed) {
	                windows.shift().error(err);
	            }
	        }
	        this.destination.error(err);
	    };
	    WindowCountSubscriber.prototype._complete = function () {
	        var windows = this.windows;
	        if (windows) {
	            while (windows.length > 0 && !this.closed) {
	                windows.shift().complete();
	            }
	        }
	        this.destination.complete();
	    };
	    WindowCountSubscriber.prototype._unsubscribe = function () {
	        this.count = 0;
	        this.windows = null;
	    };
	    return WindowCountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(30);
	var async_1 = __webpack_require__(23);
	var Subscriber_1 = __webpack_require__(11);
	var isNumeric_1 = __webpack_require__(272);
	var isScheduler_1 = __webpack_require__(65);
	function windowTime(windowTimeSpan) {
	    var scheduler = async_1.async;
	    var windowCreationInterval = null;
	    var maxWindowSize = Number.POSITIVE_INFINITY;
	    if (isScheduler_1.isScheduler(arguments[3])) {
	        scheduler = arguments[3];
	    }
	    if (isScheduler_1.isScheduler(arguments[2])) {
	        scheduler = arguments[2];
	    }
	    else if (isNumeric_1.isNumeric(arguments[2])) {
	        maxWindowSize = arguments[2];
	    }
	    if (isScheduler_1.isScheduler(arguments[1])) {
	        scheduler = arguments[1];
	    }
	    else if (isNumeric_1.isNumeric(arguments[1])) {
	        windowCreationInterval = arguments[1];
	    }
	    return function windowTimeOperatorFunction(source) {
	        return source.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
	    };
	}
	exports.windowTime = windowTime;
	var WindowTimeOperator = (function () {
	    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
	        this.windowTimeSpan = windowTimeSpan;
	        this.windowCreationInterval = windowCreationInterval;
	        this.maxWindowSize = maxWindowSize;
	        this.scheduler = scheduler;
	    }
	    WindowTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
	    };
	    return WindowTimeOperator;
	}());
	var CountedSubject = (function (_super) {
	    __extends(CountedSubject, _super);
	    function CountedSubject() {
	        _super.apply(this, arguments);
	        this._numberOfNextedValues = 0;
	    }
	    CountedSubject.prototype.next = function (value) {
	        this._numberOfNextedValues++;
	        _super.prototype.next.call(this, value);
	    };
	    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
	        get: function () {
	            return this._numberOfNextedValues;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return CountedSubject;
	}(Subject_1.Subject));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowTimeSubscriber = (function (_super) {
	    __extends(WindowTimeSubscriber, _super);
	    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.windowTimeSpan = windowTimeSpan;
	        this.windowCreationInterval = windowCreationInterval;
	        this.maxWindowSize = maxWindowSize;
	        this.scheduler = scheduler;
	        this.windows = [];
	        var window = this.openWindow();
	        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
	            var closeState = { subscriber: this, window: window, context: null };
	            var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: this, scheduler: scheduler };
	            this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
	            this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
	        }
	        else {
	            var timeSpanOnlyState = { subscriber: this, window: window, windowTimeSpan: windowTimeSpan };
	            this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
	        }
	    }
	    WindowTimeSubscriber.prototype._next = function (value) {
	        var windows = this.windows;
	        var len = windows.length;
	        for (var i = 0; i < len; i++) {
	            var window_1 = windows[i];
	            if (!window_1.closed) {
	                window_1.next(value);
	                if (window_1.numberOfNextedValues >= this.maxWindowSize) {
	                    this.closeWindow(window_1);
	                }
	            }
	        }
	    };
	    WindowTimeSubscriber.prototype._error = function (err) {
	        var windows = this.windows;
	        while (windows.length > 0) {
	            windows.shift().error(err);
	        }
	        this.destination.error(err);
	    };
	    WindowTimeSubscriber.prototype._complete = function () {
	        var windows = this.windows;
	        while (windows.length > 0) {
	            var window_2 = windows.shift();
	            if (!window_2.closed) {
	                window_2.complete();
	            }
	        }
	        this.destination.complete();
	    };
	    WindowTimeSubscriber.prototype.openWindow = function () {
	        var window = new CountedSubject();
	        this.windows.push(window);
	        var destination = this.destination;
	        destination.next(window);
	        return window;
	    };
	    WindowTimeSubscriber.prototype.closeWindow = function (window) {
	        window.complete();
	        var windows = this.windows;
	        windows.splice(windows.indexOf(window), 1);
	    };
	    return WindowTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchWindowTimeSpanOnly(state) {
	    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
	    if (window) {
	        subscriber.closeWindow(window);
	    }
	    state.window = subscriber.openWindow();
	    this.schedule(state, windowTimeSpan);
	}
	function dispatchWindowCreation(state) {
	    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
	    var window = subscriber.openWindow();
	    var action = this;
	    var context = { action: action, subscription: null };
	    var timeSpanState = { subscriber: subscriber, window: window, context: context };
	    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
	    action.add(context.subscription);
	    action.schedule(state, windowCreationInterval);
	}
	function dispatchWindowClose(state) {
	    var subscriber = state.subscriber, window = state.window, context = state.context;
	    if (context && context.action && context.subscription) {
	        context.action.remove(context.subscription);
	    }
	    subscriber.closeWindow(window);
	}
	//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(30);
	var Subscription_1 = __webpack_require__(31);
	var tryCatch_1 = __webpack_require__(34);
	var errorObject_1 = __webpack_require__(32);
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/**
	 * Branch out the source Observable values as a nested Observable starting from
	 * an emission from `openings` and ending when the output of `closingSelector`
	 * emits.
	 *
	 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowToggle.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits windows that contain those items
	 * emitted by the source Observable between the time when the `openings`
	 * Observable emits an item and when the Observable returned by
	 * `closingSelector` emits an item.
	 *
	 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var openings = Rx.Observable.interval(1000);
	 * var result = clicks.windowToggle(openings, i =>
	 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
	 * ).mergeAll();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowWhen}
	 * @see {@link bufferToggle}
	 *
	 * @param {Observable<O>} openings An observable of notifications to start new
	 * windows.
	 * @param {function(value: O): Observable} closingSelector A function that takes
	 * the value emitted by the `openings` observable and returns an Observable,
	 * which, when it emits (either `next` or `complete`), signals that the
	 * associated window should complete.
	 * @return {Observable<Observable<T>>} An observable of windows, which in turn
	 * are Observables.
	 * @method windowToggle
	 * @owner Observable
	 */
	function windowToggle(openings, closingSelector) {
	    return function (source) { return source.lift(new WindowToggleOperator(openings, closingSelector)); };
	}
	exports.windowToggle = windowToggle;
	var WindowToggleOperator = (function () {
	    function WindowToggleOperator(openings, closingSelector) {
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	    }
	    WindowToggleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
	    };
	    return WindowToggleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowToggleSubscriber = (function (_super) {
	    __extends(WindowToggleSubscriber, _super);
	    function WindowToggleSubscriber(destination, openings, closingSelector) {
	        _super.call(this, destination);
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	        this.contexts = [];
	        this.add(this.openSubscription = subscribeToResult_1.subscribeToResult(this, openings, openings));
	    }
	    WindowToggleSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        if (contexts) {
	            var len = contexts.length;
	            for (var i = 0; i < len; i++) {
	                contexts[i].window.next(value);
	            }
	        }
	    };
	    WindowToggleSubscriber.prototype._error = function (err) {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context = contexts[index];
	                context.window.error(err);
	                context.subscription.unsubscribe();
	            }
	        }
	        _super.prototype._error.call(this, err);
	    };
	    WindowToggleSubscriber.prototype._complete = function () {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context = contexts[index];
	                context.window.complete();
	                context.subscription.unsubscribe();
	            }
	        }
	        _super.prototype._complete.call(this);
	    };
	    WindowToggleSubscriber.prototype._unsubscribe = function () {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context = contexts[index];
	                context.window.unsubscribe();
	                context.subscription.unsubscribe();
	            }
	        }
	    };
	    WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (outerValue === this.openings) {
	            var closingSelector = this.closingSelector;
	            var closingNotifier = tryCatch_1.tryCatch(closingSelector)(innerValue);
	            if (closingNotifier === errorObject_1.errorObject) {
	                return this.error(errorObject_1.errorObject.e);
	            }
	            else {
	                var window_1 = new Subject_1.Subject();
	                var subscription = new Subscription_1.Subscription();
	                var context = { window: window_1, subscription: subscription };
	                this.contexts.push(context);
	                var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
	                if (innerSubscription.closed) {
	                    this.closeWindow(this.contexts.length - 1);
	                }
	                else {
	                    innerSubscription.context = context;
	                    subscription.add(innerSubscription);
	                }
	                this.destination.next(window_1);
	            }
	        }
	        else {
	            this.closeWindow(this.contexts.indexOf(outerValue));
	        }
	    };
	    WindowToggleSubscriber.prototype.notifyError = function (err) {
	        this.error(err);
	    };
	    WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
	        if (inner !== this.openSubscription) {
	            this.closeWindow(this.contexts.indexOf(inner.context));
	        }
	    };
	    WindowToggleSubscriber.prototype.closeWindow = function (index) {
	        if (index === -1) {
	            return;
	        }
	        var contexts = this.contexts;
	        var context = contexts[index];
	        var window = context.window, subscription = context.subscription;
	        contexts.splice(index, 1);
	        window.complete();
	        subscription.unsubscribe();
	    };
	    return WindowToggleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(30);
	var tryCatch_1 = __webpack_require__(34);
	var errorObject_1 = __webpack_require__(32);
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/**
	 * Branch out the source Observable values as a nested Observable using a
	 * factory function of closing Observables to determine when to start a new
	 * window.
	 *
	 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowWhen.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits connected, non-overlapping windows.
	 * It emits the current window and opens a new one whenever the Observable
	 * produced by the specified `closingSelector` function emits an item. The first
	 * window is opened immediately when subscribing to the output Observable.
	 *
	 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks
	 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
	 *   .map(win => win.take(2)) // each window has at most 2 emissions
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link bufferWhen}
	 *
	 * @param {function(): Observable} closingSelector A function that takes no
	 * arguments and returns an Observable that signals (on either `next` or
	 * `complete`) when to close the previous window and start a new one.
	 * @return {Observable<Observable<T>>} An observable of windows, which in turn
	 * are Observables.
	 * @method windowWhen
	 * @owner Observable
	 */
	function windowWhen(closingSelector) {
	    return function windowWhenOperatorFunction(source) {
	        return source.lift(new WindowOperator(closingSelector));
	    };
	}
	exports.windowWhen = windowWhen;
	var WindowOperator = (function () {
	    function WindowOperator(closingSelector) {
	        this.closingSelector = closingSelector;
	    }
	    WindowOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowSubscriber(subscriber, this.closingSelector));
	    };
	    return WindowOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowSubscriber = (function (_super) {
	    __extends(WindowSubscriber, _super);
	    function WindowSubscriber(destination, closingSelector) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.closingSelector = closingSelector;
	        this.openWindow();
	    }
	    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.openWindow(innerSub);
	    };
	    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.openWindow(innerSub);
	    };
	    WindowSubscriber.prototype._next = function (value) {
	        this.window.next(value);
	    };
	    WindowSubscriber.prototype._error = function (err) {
	        this.window.error(err);
	        this.destination.error(err);
	        this.unsubscribeClosingNotification();
	    };
	    WindowSubscriber.prototype._complete = function () {
	        this.window.complete();
	        this.destination.complete();
	        this.unsubscribeClosingNotification();
	    };
	    WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
	        if (this.closingNotification) {
	            this.closingNotification.unsubscribe();
	        }
	    };
	    WindowSubscriber.prototype.openWindow = function (innerSub) {
	        if (innerSub === void 0) { innerSub = null; }
	        if (innerSub) {
	            this.remove(innerSub);
	            innerSub.unsubscribe();
	        }
	        var prevWindow = this.window;
	        if (prevWindow) {
	            prevWindow.complete();
	        }
	        var window = this.window = new Subject_1.Subject();
	        this.destination.next(window);
	        var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
	        if (closingNotifier === errorObject_1.errorObject) {
	            var err = errorObject_1.errorObject.e;
	            this.destination.error(err);
	            this.window.error(err);
	        }
	        else {
	            this.add(this.closingNotification = subscribeToResult_1.subscribeToResult(this, closingNotifier));
	        }
	    };
	    return WindowSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(16);
	var subscribeToResult_1 = __webpack_require__(17);
	/* tslint:enable:max-line-length */
	/**
	 * Combines the source Observable with other Observables to create an Observable
	 * whose values are calculated from the latest values of each, only when the
	 * source emits.
	 *
	 * <span class="informal">Whenever the source Observable emits a value, it
	 * computes a formula using that value plus the latest values from other input
	 * Observables, then emits the output of that formula.</span>
	 *
	 * <img src="./img/withLatestFrom.png" width="100%">
	 *
	 * `withLatestFrom` combines each value from the source Observable (the
	 * instance) with the latest values from the other input Observables only when
	 * the source emits a value, optionally using a `project` function to determine
	 * the value to be emitted on the output Observable. All input Observables must
	 * emit at least one value before the output Observable will emit a value.
	 *
	 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var result = clicks.withLatestFrom(timer);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineLatest}
	 *
	 * @param {ObservableInput} other An input Observable to combine with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {Function} [project] Projection function for combining values
	 * together. Receives all values in order of the Observables passed, where the
	 * first parameter is a value from the source Observable. (e.g.
	 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
	 * passed, arrays will be emitted on the output Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @method withLatestFrom
	 * @owner Observable
	 */
	function withLatestFrom() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i - 0] = arguments[_i];
	    }
	    return function (source) {
	        var project;
	        if (typeof args[args.length - 1] === 'function') {
	            project = args.pop();
	        }
	        var observables = args;
	        return source.lift(new WithLatestFromOperator(observables, project));
	    };
	}
	exports.withLatestFrom = withLatestFrom;
	var WithLatestFromOperator = (function () {
	    function WithLatestFromOperator(observables, project) {
	        this.observables = observables;
	        this.project = project;
	    }
	    WithLatestFromOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
	    };
	    return WithLatestFromOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WithLatestFromSubscriber = (function (_super) {
	    __extends(WithLatestFromSubscriber, _super);
	    function WithLatestFromSubscriber(destination, observables, project) {
	        _super.call(this, destination);
	        this.observables = observables;
	        this.project = project;
	        this.toRespond = [];
	        var len = observables.length;
	        this.values = new Array(len);
	        for (var i = 0; i < len; i++) {
	            this.toRespond.push(i);
	        }
	        for (var i = 0; i < len; i++) {
	            var observable = observables[i];
	            this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
	        }
	    }
	    WithLatestFromSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.values[outerIndex] = innerValue;
	        var toRespond = this.toRespond;
	        if (toRespond.length > 0) {
	            var found = toRespond.indexOf(outerIndex);
	            if (found !== -1) {
	                toRespond.splice(found, 1);
	            }
	        }
	    };
	    WithLatestFromSubscriber.prototype.notifyComplete = function () {
	        // noop
	    };
	    WithLatestFromSubscriber.prototype._next = function (value) {
	        if (this.toRespond.length === 0) {
	            var args = [value].concat(this.values);
	            if (this.project) {
	                this._tryProject(args);
	            }
	            else {
	                this.destination.next(args);
	            }
	        }
	    };
	    WithLatestFromSubscriber.prototype._tryProject = function (args) {
	        var result;
	        try {
	            result = this.project.apply(this, args);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return WithLatestFromSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var zip_1 = __webpack_require__(354);
	function zipAll(project) {
	    return function (source) { return source.lift(new zip_1.ZipOperator(project)); };
	}
	exports.zipAll = zipAll;
	//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncAction_1 = __webpack_require__(268);
	var AsyncScheduler_1 = __webpack_require__(269);
	var VirtualTimeScheduler = (function (_super) {
	    __extends(VirtualTimeScheduler, _super);
	    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
	        var _this = this;
	        if (SchedulerAction === void 0) { SchedulerAction = VirtualAction; }
	        if (maxFrames === void 0) { maxFrames = Number.POSITIVE_INFINITY; }
	        _super.call(this, SchedulerAction, function () { return _this.frame; });
	        this.maxFrames = maxFrames;
	        this.frame = 0;
	        this.index = -1;
	    }
	    /**
	     * Prompt the Scheduler to execute all of its queued actions, therefore
	     * clearing its queue.
	     * @return {void}
	     */
	    VirtualTimeScheduler.prototype.flush = function () {
	        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
	        var error, action;
	        while ((action = actions.shift()) && (this.frame = action.delay) <= maxFrames) {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        }
	        if (error) {
	            while (action = actions.shift()) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    VirtualTimeScheduler.frameTimeFactor = 10;
	    return VirtualTimeScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.VirtualTimeScheduler = VirtualTimeScheduler;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var VirtualAction = (function (_super) {
	    __extends(VirtualAction, _super);
	    function VirtualAction(scheduler, work, index) {
	        if (index === void 0) { index = scheduler.index += 1; }
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	        this.index = index;
	        this.active = true;
	        this.index = scheduler.index = index;
	    }
	    VirtualAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (!this.id) {
	            return _super.prototype.schedule.call(this, state, delay);
	        }
	        this.active = false;
	        // If an action is rescheduled, we save allocations by mutating its state,
	        // pushing it to the end of the scheduler queue, and recycling the action.
	        // But since the VirtualTimeScheduler is used for testing, VirtualActions
	        // must be immutable so they can be inspected later.
	        var action = new VirtualAction(this.scheduler, this.work);
	        this.add(action);
	        return action.schedule(state, delay);
	    };
	    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        this.delay = scheduler.frame + delay;
	        var actions = scheduler.actions;
	        actions.push(this);
	        actions.sort(VirtualAction.sortActions);
	        return true;
	    };
	    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        return undefined;
	    };
	    VirtualAction.prototype._execute = function (state, delay) {
	        if (this.active === true) {
	            return _super.prototype._execute.call(this, state, delay);
	        }
	    };
	    VirtualAction.sortActions = function (a, b) {
	        if (a.delay === b.delay) {
	            if (a.index === b.index) {
	                return 0;
	            }
	            else if (a.index > b.index) {
	                return 1;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (a.delay > b.delay) {
	            return 1;
	        }
	        else {
	            return -1;
	        }
	    };
	    return VirtualAction;
	}(AsyncAction_1.AsyncAction));
	exports.VirtualAction = VirtualAction;
	//# sourceMappingURL=VirtualTimeScheduler.js.map

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var AsapAction_1 = __webpack_require__(4740);
	var AsapScheduler_1 = __webpack_require__(4741);
	/**
	 *
	 * Asap Scheduler
	 *
	 * <span class="informal">Perform task as fast as it can be performed asynchronously</span>
	 *
	 * `asap` scheduler behaves the same as {@link async} scheduler when you use it to delay task
	 * in time. If however you set delay to `0`, `asap` will wait for current synchronously executing
	 * code to end and then it will try to execute given task as fast as possible.
	 *
	 * `asap` scheduler will do its best to minimize time between end of currently executing code
	 * and start of scheduled task. This makes it best candidate for performing so called "deferring".
	 * Traditionally this was achieved by calling `setTimeout(deferredTask, 0)`, but that technique involves
	 * some (although minimal) unwanted delay.
	 *
	 * Note that using `asap` scheduler does not necessarily mean that your task will be first to process
	 * after currently executing code. In particular, if some task was also scheduled with `asap` before,
	 * that task will execute first. That being said, if you need to schedule task asynchronously, but
	 * as soon as possible, `asap` scheduler is your best bet.
	 *
	 * @example <caption>Compare async and asap scheduler</caption>
	 *
	 * Rx.Scheduler.async.schedule(() => console.log('async')); // scheduling 'async' first...
	 * Rx.Scheduler.asap.schedule(() => console.log('asap'));
	 *
	 * // Logs:
	 * // "asap"
	 * // "async"
	 * // ... but 'asap' goes first!
	 *
	 * @static true
	 * @name asap
	 * @owner Scheduler
	 */
	exports.asap = new AsapScheduler_1.AsapScheduler(AsapAction_1.AsapAction);
	//# sourceMappingURL=asap.js.map

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var QueueAction_1 = __webpack_require__(4742);
	var QueueScheduler_1 = __webpack_require__(4743);
	/**
	 *
	 * Queue Scheduler
	 *
	 * <span class="informal">Put every next task on a queue, instead of executing it immediately</span>
	 *
	 * `queue` scheduler, when used with delay, behaves the same as {@link async} scheduler.
	 *
	 * When used without delay, it schedules given task synchronously - executes it right when
	 * it is scheduled. However when called recursively, that is when inside the scheduled task,
	 * another task is scheduled with queue scheduler, instead of executing immediately as well,
	 * that task will be put on a queue and wait for current one to finish.
	 *
	 * This means that when you execute task with `queue` scheduler, you are sure it will end
	 * before any other task scheduled with that scheduler will start.
	 *
	 * @examples <caption>Schedule recursively first, then do something</caption>
	 *
	 * Rx.Scheduler.queue.schedule(() => {
	 *   Rx.Scheduler.queue.schedule(() => console.log('second')); // will not happen now, but will be put on a queue
	 *
	 *   console.log('first');
	 * });
	 *
	 * // Logs:
	 * // "first"
	 * // "second"
	 *
	 *
	 * @example <caption>Reschedule itself recursively</caption>
	 *
	 * Rx.Scheduler.queue.schedule(function(state) {
	 *   if (state !== 0) {
	 *     console.log('before', state);
	 *     this.schedule(state - 1); // `this` references currently executing Action,
	 *                               // which we reschedule with new state
	 *     console.log('after', state);
	 *   }
	 * }, 0, 3);
	 *
	 * // In scheduler that runs recursively, you would expect:
	 * // "before", 3
	 * // "before", 2
	 * // "before", 1
	 * // "after", 1
	 * // "after", 2
	 * // "after", 3
	 *
	 * // But with queue it logs:
	 * // "before", 3
	 * // "after", 3
	 * // "before", 2
	 * // "after", 2
	 * // "before", 1
	 * // "after", 1
	 *
	 *
	 * @static true
	 * @name queue
	 * @owner Scheduler
	 */
	exports.queue = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
	//# sourceMappingURL=queue.js.map

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	"use strict";
	var SubscriptionLog = (function () {
	    function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
	        if (unsubscribedFrame === void 0) { unsubscribedFrame = Number.POSITIVE_INFINITY; }
	        this.subscribedFrame = subscribedFrame;
	        this.unsubscribedFrame = unsubscribedFrame;
	    }
	    return SubscriptionLog;
	}());
	exports.SubscriptionLog = SubscriptionLog;
	//# sourceMappingURL=SubscriptionLog.js.map

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var SubscriptionLog_1 = __webpack_require__(850);
	var SubscriptionLoggable = (function () {
	    function SubscriptionLoggable() {
	        this.subscriptions = [];
	    }
	    SubscriptionLoggable.prototype.logSubscribedFrame = function () {
	        this.subscriptions.push(new SubscriptionLog_1.SubscriptionLog(this.scheduler.now()));
	        return this.subscriptions.length - 1;
	    };
	    SubscriptionLoggable.prototype.logUnsubscribedFrame = function (index) {
	        var subscriptionLogs = this.subscriptions;
	        var oldSubscriptionLog = subscriptionLogs[index];
	        subscriptionLogs[index] = new SubscriptionLog_1.SubscriptionLog(oldSubscriptionLog.subscribedFrame, this.scheduler.now());
	    };
	    return SubscriptionLoggable;
	}());
	exports.SubscriptionLoggable = SubscriptionLoggable;
	//# sourceMappingURL=SubscriptionLoggable.js.map

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when duetime elapses.
	 *
	 * @see {@link timeout}
	 *
	 * @class TimeoutError
	 */
	var TimeoutError = (function (_super) {
	    __extends(TimeoutError, _super);
	    function TimeoutError() {
	        var err = _super.call(this, 'Timeout has occurred');
	        this.name = err.name = 'TimeoutError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return TimeoutError;
	}(Error));
	exports.TimeoutError = TimeoutError;
	//# sourceMappingURL=TimeoutError.js.map

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when one or more errors have occurred during the
	 * `unsubscribe` of a {@link Subscription}.
	 */
	var UnsubscriptionError = (function (_super) {
	    __extends(UnsubscriptionError, _super);
	    function UnsubscriptionError(errors) {
	        _super.call(this);
	        this.errors = errors;
	        var err = Error.call(this, errors ?
	            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
	        this.name = err.name = 'UnsubscriptionError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return UnsubscriptionError;
	}(Error));
	exports.UnsubscriptionError = UnsubscriptionError;
	//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	"use strict";
	function applyMixins(derivedCtor, baseCtors) {
	    for (var i = 0, len = baseCtors.length; i < len; i++) {
	        var baseCtor = baseCtors[i];
	        var propertyKeys = Object.getOwnPropertyNames(baseCtor.prototype);
	        for (var j = 0, len2 = propertyKeys.length; j < len2; j++) {
	            var name_1 = propertyKeys[j];
	            derivedCtor.prototype[name_1] = baseCtor.prototype[name_1];
	        }
	    }
	}
	exports.applyMixins = applyMixins;
	//# sourceMappingURL=applyMixins.js.map

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	"use strict";
	function identity(x) {
	    return x;
	}
	exports.identity = identity;
	//# sourceMappingURL=identity.js.map

/***/ }),
/* 856 */
/***/ (function(module, exports) {

	"use strict";
	exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
	//# sourceMappingURL=isArrayLike.js.map

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	"use strict";
	function isObject(x) {
	    return x != null && typeof x === 'object';
	}
	exports.isObject = isObject;
	//# sourceMappingURL=isObject.js.map

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (rawLines, lineNumber, colNumber) {
	  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  colNumber = Math.max(colNumber, 0);
	
	  var highlighted = opts.highlightCode && _chalk2.default.supportsColor || opts.forceColor;
	  var chalk = _chalk2.default;
	  if (opts.forceColor) {
	    chalk = new _chalk2.default.constructor({ enabled: true });
	  }
	  var maybeHighlight = function maybeHighlight(chalkFn, string) {
	    return highlighted ? chalkFn(string) : string;
	  };
	  var defs = getDefs(chalk);
	  if (highlighted) rawLines = highlight(defs, rawLines);
	
	  var linesAbove = opts.linesAbove || 2;
	  var linesBelow = opts.linesBelow || 3;
	
	  var lines = rawLines.split(NEWLINE);
	  var start = Math.max(lineNumber - (linesAbove + 1), 0);
	  var end = Math.min(lines.length, lineNumber + linesBelow);
	
	  if (!lineNumber && !colNumber) {
	    start = 0;
	    end = lines.length;
	  }
	
	  var numberMaxWidth = String(end).length;
	
	  var frame = lines.slice(start, end).map(function (line, index) {
	    var number = start + 1 + index;
	    var paddedNumber = (" " + number).slice(-numberMaxWidth);
	    var gutter = " " + paddedNumber + " | ";
	    if (number === lineNumber) {
	      var markerLine = "";
	      if (colNumber) {
	        var markerSpacing = line.slice(0, colNumber - 1).replace(/[^\t]/g, " ");
	        markerLine = ["\n ", maybeHighlight(defs.gutter, gutter.replace(/\d/g, " ")), markerSpacing, maybeHighlight(defs.marker, "^")].join("");
	      }
	      return [maybeHighlight(defs.marker, ">"), maybeHighlight(defs.gutter, gutter), line, markerLine].join("");
	    } else {
	      return " " + maybeHighlight(defs.gutter, gutter) + line;
	    }
	  }).join("\n");
	
	  if (highlighted) {
	    return chalk.reset(frame);
	  } else {
	    return frame;
	  }
	};
	
	var _jsTokens = __webpack_require__(2737);
	
	var _jsTokens2 = _interopRequireDefault(_jsTokens);
	
	var _esutils = __webpack_require__(413);
	
	var _esutils2 = _interopRequireDefault(_esutils);
	
	var _chalk = __webpack_require__(871);
	
	var _chalk2 = _interopRequireDefault(_chalk);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDefs(chalk) {
	  return {
	    keyword: chalk.cyan,
	    capitalized: chalk.yellow,
	    jsx_tag: chalk.yellow,
	    punctuator: chalk.yellow,
	
	    number: chalk.magenta,
	    string: chalk.green,
	    regex: chalk.magenta,
	    comment: chalk.grey,
	    invalid: chalk.white.bgRed.bold,
	    gutter: chalk.grey,
	    marker: chalk.red.bold
	  };
	}
	
	var NEWLINE = /\r\n|[\n\r\u2028\u2029]/;
	
	var JSX_TAG = /^[a-z][\w-]*$/i;
	
	var BRACKET = /^[()\[\]{}]$/;
	
	function getTokenType(match) {
	  var _match$slice = match.slice(-2),
	      offset = _match$slice[0],
	      text = _match$slice[1];
	
	  var token = (0, _jsTokens.matchToToken)(match);
	
	  if (token.type === "name") {
	    if (_esutils2.default.keyword.isReservedWordES6(token.value)) {
	      return "keyword";
	    }
	
	    if (JSX_TAG.test(token.value) && (text[offset - 1] === "<" || text.substr(offset - 2, 2) == "</")) {
	      return "jsx_tag";
	    }
	
	    if (token.value[0] !== token.value[0].toLowerCase()) {
	      return "capitalized";
	    }
	  }
	
	  if (token.type === "punctuator" && BRACKET.test(token.value)) {
	    return "bracket";
	  }
	
	  return token.type;
	}
	
	function highlight(defs, text) {
	  return text.replace(_jsTokens2.default, function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var type = getTokenType(args);
	    var colorize = defs[type];
	    if (colorize) {
	      return args[0].split(NEWLINE).map(function (str) {
	        return colorize(str);
	      }).join("\n");
	    } else {
	      return args[0];
	    }
	  });
	}
	
	module.exports = exports["default"];

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (opts) {
	  var visitor = {};
	
	  visitor.JSXNamespacedName = function (path) {
	    throw path.buildCodeFrameError("Namespace tags are not supported. ReactJSX is not XML.");
	  };
	
	  visitor.JSXElement = {
	    exit: function exit(path, file) {
	      var callExpr = buildElementCall(path.get("openingElement"), file);
	
	      callExpr.arguments = callExpr.arguments.concat(path.node.children);
	
	      if (callExpr.arguments.length >= 3) {
	        callExpr._prettyCall = true;
	      }
	
	      path.replaceWith(t.inherits(callExpr, path.node));
	    }
	  };
	
	  return visitor;
	
	  function convertJSXIdentifier(node, parent) {
	    if (t.isJSXIdentifier(node)) {
	      if (node.name === "this" && t.isReferenced(node, parent)) {
	        return t.thisExpression();
	      } else if (_esutils2.default.keyword.isIdentifierNameES6(node.name)) {
	        node.type = "Identifier";
	      } else {
	        return t.stringLiteral(node.name);
	      }
	    } else if (t.isJSXMemberExpression(node)) {
	      return t.memberExpression(convertJSXIdentifier(node.object, node), convertJSXIdentifier(node.property, node));
	    }
	
	    return node;
	  }
	
	  function convertAttributeValue(node) {
	    if (t.isJSXExpressionContainer(node)) {
	      return node.expression;
	    } else {
	      return node;
	    }
	  }
	
	  function convertAttribute(node) {
	    var value = convertAttributeValue(node.value || t.booleanLiteral(true));
	
	    if (t.isStringLiteral(value) && !t.isJSXExpressionContainer(node.value)) {
	      value.value = value.value.replace(/\n\s+/g, " ");
	    }
	
	    if (t.isValidIdentifier(node.name.name)) {
	      node.name.type = "Identifier";
	    } else {
	      node.name = t.stringLiteral(node.name.name);
	    }
	
	    return t.inherits(t.objectProperty(node.name, value), node);
	  }
	
	  function buildElementCall(path, file) {
	    path.parent.children = t.react.buildChildren(path.parent);
	
	    var tagExpr = convertJSXIdentifier(path.node.name, path.node);
	    var args = [];
	
	    var tagName = void 0;
	    if (t.isIdentifier(tagExpr)) {
	      tagName = tagExpr.name;
	    } else if (t.isLiteral(tagExpr)) {
	      tagName = tagExpr.value;
	    }
	
	    var state = {
	      tagExpr: tagExpr,
	      tagName: tagName,
	      args: args
	    };
	
	    if (opts.pre) {
	      opts.pre(state, file);
	    }
	
	    var attribs = path.node.attributes;
	    if (attribs.length) {
	      attribs = buildOpeningElementAttributes(attribs, file);
	    } else {
	      attribs = t.nullLiteral();
	    }
	
	    args.push(attribs);
	
	    if (opts.post) {
	      opts.post(state, file);
	    }
	
	    return state.call || t.callExpression(state.callee, args);
	  }
	
	  function buildOpeningElementAttributes(attribs, file) {
	    var _props = [];
	    var objs = [];
	
	    var useBuiltIns = file.opts.useBuiltIns || false;
	    if (typeof useBuiltIns !== "boolean") {
	      throw new Error("transform-react-jsx currently only accepts a boolean option for " + "useBuiltIns (defaults to false)");
	    }
	
	    function pushProps() {
	      if (!_props.length) return;
	
	      objs.push(t.objectExpression(_props));
	      _props = [];
	    }
	
	    while (attribs.length) {
	      var prop = attribs.shift();
	      if (t.isJSXSpreadAttribute(prop)) {
	        pushProps();
	        objs.push(prop.argument);
	      } else {
	        _props.push(convertAttribute(prop));
	      }
	    }
	
	    pushProps();
	
	    if (objs.length === 1) {
	      attribs = objs[0];
	    } else {
	      if (!t.isObjectExpression(objs[0])) {
	        objs.unshift(t.objectExpression([]));
	      }
	
	      var helper = useBuiltIns ? t.memberExpression(t.identifier("Object"), t.identifier("assign")) : file.addHelper("extends");
	
	      attribs = t.callExpression(helper, objs);
	    }
	
	    return attribs;
	  }
	};
	
	var _esutils = __webpack_require__(413);
	
	var _esutils2 = _interopRequireDefault(_esutils);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (path) {
	  var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : path.scope;
	  var node = path.node;
	
	  var container = t.functionExpression(null, [], node.body, node.generator, node.async);
	
	  var callee = container;
	  var args = [];
	
	  (0, _babelHelperHoistVariables2.default)(path, function (id) {
	    return scope.push({ id: id });
	  });
	
	  var state = {
	    foundThis: false,
	    foundArguments: false
	  };
	
	  path.traverse(visitor, state);
	
	  if (state.foundArguments) {
	    callee = t.memberExpression(container, t.identifier("apply"));
	    args = [];
	
	    if (state.foundThis) {
	      args.push(t.thisExpression());
	    }
	
	    if (state.foundArguments) {
	      if (!state.foundThis) args.push(t.nullLiteral());
	      args.push(t.identifier("arguments"));
	    }
	  }
	
	  var call = t.callExpression(callee, args);
	  if (node.generator) call = t.yieldExpression(call, true);
	
	  return t.returnStatement(call);
	};
	
	var _babelHelperHoistVariables = __webpack_require__(536);
	
	var _babelHelperHoistVariables2 = _interopRequireDefault(_babelHelperHoistVariables);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var visitor = {
	  enter: function enter(path, state) {
	    if (path.isThisExpression()) {
	      state.foundThis = true;
	    }
	
	    if (path.isReferencedIdentifier({ name: "arguments" })) {
	      state.foundArguments = true;
	    }
	  },
	  Function: function Function(path) {
	    path.skip();
	  }
	};
	
	module.exports = exports["default"];

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _keys = __webpack_require__(90);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.push = push;
	exports.hasComputed = hasComputed;
	exports.toComputedObjectFromClass = toComputedObjectFromClass;
	exports.toClassObject = toClassObject;
	exports.toDefineObject = toDefineObject;
	
	var _babelHelperFunctionName = __webpack_require__(276);
	
	var _babelHelperFunctionName2 = _interopRequireDefault(_babelHelperFunctionName);
	
	var _has = __webpack_require__(684);
	
	var _has2 = _interopRequireDefault(_has);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toKind(node) {
	  if (t.isClassMethod(node) || t.isObjectMethod(node)) {
	    if (node.kind === "get" || node.kind === "set") {
	      return node.kind;
	    }
	  }
	
	  return "value";
	}
	
	function push(mutatorMap, node, kind, file, scope) {
	  var alias = t.toKeyAlias(node);
	
	  var map = {};
	  if ((0, _has2.default)(mutatorMap, alias)) map = mutatorMap[alias];
	  mutatorMap[alias] = map;
	
	  map._inherits = map._inherits || [];
	  map._inherits.push(node);
	
	  map._key = node.key;
	
	  if (node.computed) {
	    map._computed = true;
	  }
	
	  if (node.decorators) {
	    var decorators = map.decorators = map.decorators || t.arrayExpression([]);
	    decorators.elements = decorators.elements.concat(node.decorators.map(function (dec) {
	      return dec.expression;
	    }).reverse());
	  }
	
	  if (map.value || map.initializer) {
	    throw file.buildCodeFrameError(node, "Key conflict with sibling node");
	  }
	
	  var key = void 0,
	      value = void 0;
	
	  if (t.isObjectProperty(node) || t.isObjectMethod(node) || t.isClassMethod(node)) {
	    key = t.toComputedKey(node, node.key);
	  }
	
	  if (t.isObjectProperty(node) || t.isClassProperty(node)) {
	    value = node.value;
	  } else if (t.isObjectMethod(node) || t.isClassMethod(node)) {
	    value = t.functionExpression(null, node.params, node.body, node.generator, node.async);
	    value.returnType = node.returnType;
	  }
	
	  var inheritedKind = toKind(node);
	  if (!kind || inheritedKind !== "value") {
	    kind = inheritedKind;
	  }
	
	  if (scope && t.isStringLiteral(key) && (kind === "value" || kind === "initializer") && t.isFunctionExpression(value)) {
	    value = (0, _babelHelperFunctionName2.default)({ id: key, node: value, scope: scope });
	  }
	
	  if (value) {
	    t.inheritsComments(value, node);
	    map[kind] = value;
	  }
	
	  return map;
	}
	
	function hasComputed(mutatorMap) {
	  for (var key in mutatorMap) {
	    if (mutatorMap[key]._computed) {
	      return true;
	    }
	  }
	  return false;
	}
	
	function toComputedObjectFromClass(obj) {
	  var objExpr = t.arrayExpression([]);
	
	  for (var i = 0; i < obj.properties.length; i++) {
	    var prop = obj.properties[i];
	    var val = prop.value;
	    val.properties.unshift(t.objectProperty(t.identifier("key"), t.toComputedKey(prop)));
	    objExpr.elements.push(val);
	  }
	
	  return objExpr;
	}
	
	function toClassObject(mutatorMap) {
	  var objExpr = t.objectExpression([]);
	
	  (0, _keys2.default)(mutatorMap).forEach(function (mutatorMapKey) {
	    var map = mutatorMap[mutatorMapKey];
	    var mapNode = t.objectExpression([]);
	
	    var propNode = t.objectProperty(map._key, mapNode, map._computed);
	
	    (0, _keys2.default)(map).forEach(function (key) {
	      var node = map[key];
	      if (key[0] === "_") return;
	
	      var inheritNode = node;
	      if (t.isClassMethod(node) || t.isClassProperty(node)) node = node.value;
	
	      var prop = t.objectProperty(t.identifier(key), node);
	      t.inheritsComments(prop, inheritNode);
	      t.removeComments(inheritNode);
	
	      mapNode.properties.push(prop);
	    });
	
	    objExpr.properties.push(propNode);
	  });
	
	  return objExpr;
	}
	
	function toDefineObject(mutatorMap) {
	  (0, _keys2.default)(mutatorMap).forEach(function (key) {
	    var map = mutatorMap[key];
	    if (map.value) map.writable = t.booleanLiteral(true);
	    map.configurable = t.booleanLiteral(true);
	    map.enumerable = t.booleanLiteral(true);
	  });
	
	  return toClassObject(mutatorMap);
	}

/***/ }),
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var colorConvert = __webpack_require__(1030);
	
	var wrapAnsi16 = function wrapAnsi16(fn, offset) {
		return function () {
			var code = fn.apply(colorConvert, arguments);
			return '\x1B[' + (code + offset) + 'm';
		};
	};
	
	var wrapAnsi256 = function wrapAnsi256(fn, offset) {
		return function () {
			var code = fn.apply(colorConvert, arguments);
			return '\x1B[' + (38 + offset) + ';5;' + code + 'm';
		};
	};
	
	var wrapAnsi16m = function wrapAnsi16m(fn, offset) {
		return function () {
			var rgb = fn.apply(colorConvert, arguments);
			return '\x1B[' + (38 + offset) + ';2;' + rgb[0] + ';' + rgb[1] + ';' + rgb[2] + 'm';
		};
	};
	
	function assembleStyles() {
		var codes = new Map();
		var styles = {
			modifier: {
				reset: [0, 0],
				// 21 isn't widely supported and 22 does the same thing
				bold: [1, 22],
				dim: [2, 22],
				italic: [3, 23],
				underline: [4, 24],
				inverse: [7, 27],
				hidden: [8, 28],
				strikethrough: [9, 29]
			},
			color: {
				black: [30, 39],
				red: [31, 39],
				green: [32, 39],
				yellow: [33, 39],
				blue: [34, 39],
				magenta: [35, 39],
				cyan: [36, 39],
				white: [37, 39],
				gray: [90, 39],
	
				// Bright color
				redBright: [91, 39],
				greenBright: [92, 39],
				yellowBright: [93, 39],
				blueBright: [94, 39],
				magentaBright: [95, 39],
				cyanBright: [96, 39],
				whiteBright: [97, 39]
			},
			bgColor: {
				bgBlack: [40, 49],
				bgRed: [41, 49],
				bgGreen: [42, 49],
				bgYellow: [43, 49],
				bgBlue: [44, 49],
				bgMagenta: [45, 49],
				bgCyan: [46, 49],
				bgWhite: [47, 49],
	
				// Bright color
				bgBlackBright: [100, 49],
				bgRedBright: [101, 49],
				bgGreenBright: [102, 49],
				bgYellowBright: [103, 49],
				bgBlueBright: [104, 49],
				bgMagentaBright: [105, 49],
				bgCyanBright: [106, 49],
				bgWhiteBright: [107, 49]
			}
		};
	
		// Fix humans
		styles.color.grey = styles.color.gray;
	
		for (var _iterator = Object.keys(styles), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref;
	
			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}
	
			var groupName = _ref;
	
			var group = styles[groupName];
	
			for (var _iterator3 = Object.keys(group), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
				var _ref3;
	
				if (_isArray3) {
					if (_i3 >= _iterator3.length) break;
					_ref3 = _iterator3[_i3++];
				} else {
					_i3 = _iterator3.next();
					if (_i3.done) break;
					_ref3 = _i3.value;
				}
	
				var styleName = _ref3;
	
				var style = group[styleName];
	
				styles[styleName] = {
					open: '\x1B[' + style[0] + 'm',
					close: '\x1B[' + style[1] + 'm'
				};
	
				group[styleName] = styles[styleName];
	
				codes.set(style[0], style[1]);
			}
	
			Object.defineProperty(styles, groupName, {
				value: group,
				enumerable: false
			});
	
			Object.defineProperty(styles, 'codes', {
				value: codes,
				enumerable: false
			});
		}
	
		var ansi2ansi = function ansi2ansi(n) {
			return n;
		};
		var rgb2rgb = function rgb2rgb(r, g, b) {
			return [r, g, b];
		};
	
		styles.color.close = '\x1B[39m';
		styles.bgColor.close = '\x1B[49m';
	
		styles.color.ansi = {
			ansi: wrapAnsi16(ansi2ansi, 0)
		};
		styles.color.ansi256 = {
			ansi256: wrapAnsi256(ansi2ansi, 0)
		};
		styles.color.ansi16m = {
			rgb: wrapAnsi16m(rgb2rgb, 0)
		};
	
		styles.bgColor.ansi = {
			ansi: wrapAnsi16(ansi2ansi, 10)
		};
		styles.bgColor.ansi256 = {
			ansi256: wrapAnsi256(ansi2ansi, 10)
		};
		styles.bgColor.ansi16m = {
			rgb: wrapAnsi16m(rgb2rgb, 10)
		};
	
		for (var _iterator2 = Object.keys(colorConvert), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
			var _ref2;
	
			if (_isArray2) {
				if (_i2 >= _iterator2.length) break;
				_ref2 = _iterator2[_i2++];
			} else {
				_i2 = _iterator2.next();
				if (_i2.done) break;
				_ref2 = _i2.value;
			}
	
			var key = _ref2;
	
			if (_typeof(colorConvert[key]) !== 'object') {
				continue;
			}
	
			var suite = colorConvert[key];
	
			if (key === 'ansi16') {
				key = 'ansi';
			}
	
			if ('ansi16' in suite) {
				styles.color.ansi[key] = wrapAnsi16(suite.ansi16, 0);
				styles.bgColor.ansi[key] = wrapAnsi16(suite.ansi16, 10);
			}
	
			if ('ansi256' in suite) {
				styles.color.ansi256[key] = wrapAnsi256(suite.ansi256, 0);
				styles.bgColor.ansi256[key] = wrapAnsi256(suite.ansi256, 10);
			}
	
			if ('rgb' in suite) {
				styles.color.ansi16m[key] = wrapAnsi16m(suite.rgb, 0);
				styles.bgColor.ansi16m[key] = wrapAnsi16m(suite.rgb, 10);
			}
		}
	
		return styles;
	}
	
	// Make the export immutable
	Object.defineProperty(module, 'exports', {
		enumerable: true,
		get: assembleStyles
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)(module)))

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var escapeStringRegexp = __webpack_require__(1189);
	var ansiStyles = __webpack_require__(870);
	var stdoutColor = __webpack_require__(872).stdout;
	
	var template = __webpack_require__(873);
	
	var isSimpleWindowsTerm = process.platform === 'win32' && !(({"NODE_ENV":"production","PUBLIC_DIR":"/usr/share/nginx/html/learn-master_ch/public"}).TERM || '').toLowerCase().startsWith('xterm');
	
	// `supportsColor.level` → `ansiStyles.color[name]` mapping
	var levelMapping = ['ansi', 'ansi', 'ansi256', 'ansi16m'];
	
	// `color-convert` models to exclude from the Chalk API due to conflicts and such
	var skipModels = new Set(['gray']);
	
	var styles = Object.create(null);
	
	function applyOptions(obj, options) {
		options = options || {};
	
		// Detect level if not set manually
		var scLevel = stdoutColor ? stdoutColor.level : 0;
		obj.level = options.level === undefined ? scLevel : options.level;
		obj.enabled = 'enabled' in options ? options.enabled : obj.level > 0;
	}
	
	function Chalk(options) {
		// We check for this.template here since calling `chalk.constructor()`
		// by itself will have a `this` of a previously constructed chalk object
		if (!this || !(this instanceof Chalk) || this.template) {
			var chalk = {};
			applyOptions(chalk, options);
	
			chalk.template = function () {
				var args = [].slice.call(arguments);
				return chalkTag.apply(null, [chalk.template].concat(args));
			};
	
			Object.setPrototypeOf(chalk, Chalk.prototype);
			Object.setPrototypeOf(chalk.template, chalk);
	
			chalk.template.constructor = Chalk;
	
			return chalk.template;
		}
	
		applyOptions(this, options);
	}
	
	// Use bright blue on Windows as the normal blue color is illegible
	if (isSimpleWindowsTerm) {
		ansiStyles.blue.open = '\x1B[94m';
	}
	
	var _loop = function _loop(key) {
		ansiStyles[key].closeRe = new RegExp(escapeStringRegexp(ansiStyles[key].close), 'g');
	
		styles[key] = {
			get: function get() {
				var codes = ansiStyles[key];
				return build.call(this, this._styles ? this._styles.concat(codes) : [codes], this._empty, key);
			}
		};
	};
	
	for (var _iterator = Object.keys(ansiStyles), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		var _ref;
	
		if (_isArray) {
			if (_i >= _iterator.length) break;
			_ref = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) break;
			_ref = _i.value;
		}
	
		var key = _ref;
	
		_loop(key);
	}
	
	styles.visible = {
		get: function get() {
			return build.call(this, this._styles || [], true, 'visible');
		}
	};
	
	ansiStyles.color.closeRe = new RegExp(escapeStringRegexp(ansiStyles.color.close), 'g');
	
	var _loop2 = function _loop2(model) {
		if (skipModels.has(model)) {
			return 'continue';
		}
	
		styles[model] = {
			get: function get() {
				var level = this.level;
				return function () {
					var open = ansiStyles.color[levelMapping[level]][model].apply(null, arguments);
					var codes = {
						open: open,
						close: ansiStyles.color.close,
						closeRe: ansiStyles.color.closeRe
					};
					return build.call(this, this._styles ? this._styles.concat(codes) : [codes], this._empty, model);
				};
			}
		};
	};
	
	for (var _iterator2 = Object.keys(ansiStyles.color.ansi), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
		var _ref2;
	
		if (_isArray2) {
			if (_i2 >= _iterator2.length) break;
			_ref2 = _iterator2[_i2++];
		} else {
			_i2 = _iterator2.next();
			if (_i2.done) break;
			_ref2 = _i2.value;
		}
	
		var model = _ref2;
	
		var _ret2 = _loop2(model);
	
		if (_ret2 === 'continue') continue;
	}
	
	ansiStyles.bgColor.closeRe = new RegExp(escapeStringRegexp(ansiStyles.bgColor.close), 'g');
	
	var _loop3 = function _loop3(model) {
		if (skipModels.has(model)) {
			return 'continue';
		}
	
		var bgModel = 'bg' + model[0].toUpperCase() + model.slice(1);
		styles[bgModel] = {
			get: function get() {
				var level = this.level;
				return function () {
					var open = ansiStyles.bgColor[levelMapping[level]][model].apply(null, arguments);
					var codes = {
						open: open,
						close: ansiStyles.bgColor.close,
						closeRe: ansiStyles.bgColor.closeRe
					};
					return build.call(this, this._styles ? this._styles.concat(codes) : [codes], this._empty, model);
				};
			}
		};
	};
	
	for (var _iterator3 = Object.keys(ansiStyles.bgColor.ansi), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
		var _ref3;
	
		if (_isArray3) {
			if (_i3 >= _iterator3.length) break;
			_ref3 = _iterator3[_i3++];
		} else {
			_i3 = _iterator3.next();
			if (_i3.done) break;
			_ref3 = _i3.value;
		}
	
		var model = _ref3;
	
		var _ret3 = _loop3(model);
	
		if (_ret3 === 'continue') continue;
	}
	
	var proto = Object.defineProperties(function () {}, styles);
	
	function build(_styles, _empty, key) {
		var builder = function builder() {
			return applyStyle.apply(builder, arguments);
		};
	
		builder._styles = _styles;
		builder._empty = _empty;
	
		var self = this;
	
		Object.defineProperty(builder, 'level', {
			enumerable: true,
			get: function get() {
				return self.level;
			},
			set: function set(level) {
				self.level = level;
			}
		});
	
		Object.defineProperty(builder, 'enabled', {
			enumerable: true,
			get: function get() {
				return self.enabled;
			},
			set: function set(enabled) {
				self.enabled = enabled;
			}
		});
	
		// See below for fix regarding invisible grey/dim combination on Windows
		builder.hasGrey = this.hasGrey || key === 'gray' || key === 'grey';
	
		// `__proto__` is used because we must return a function, but there is
		// no way to create a function with a different prototype
		builder.__proto__ = proto; // eslint-disable-line no-proto
	
		return builder;
	}
	
	function applyStyle() {
		// Support varags, but simply cast to string in case there's only one arg
		var args = arguments;
		var argsLen = args.length;
		var str = String(arguments[0]);
	
		if (argsLen === 0) {
			return '';
		}
	
		if (argsLen > 1) {
			// Don't slice `arguments`, it prevents V8 optimizations
			for (var a = 1; a < argsLen; a++) {
				str += ' ' + args[a];
			}
		}
	
		if (!this.enabled || this.level <= 0 || !str) {
			return this._empty ? '' : str;
		}
	
		// Turns out that on Windows dimmed gray text becomes invisible in cmd.exe,
		// see https://github.com/chalk/chalk/issues/58
		// If we're on Windows and we're dealing with a gray color, temporarily make 'dim' a noop.
		var originalDim = ansiStyles.dim.open;
		if (isSimpleWindowsTerm && this.hasGrey) {
			ansiStyles.dim.open = '';
		}
	
		for (var _iterator4 = this._styles.slice().reverse(), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
			var _ref4;
	
			if (_isArray4) {
				if (_i4 >= _iterator4.length) break;
				_ref4 = _iterator4[_i4++];
			} else {
				_i4 = _iterator4.next();
				if (_i4.done) break;
				_ref4 = _i4.value;
			}
	
			var code = _ref4;
	
			// Replace any instances already present with a re-opening code
			// otherwise only the part of the string until said closing code
			// will be colored, and the rest will simply be 'plain'.
			str = code.open + str.replace(code.closeRe, code.open) + code.close;
	
			// Close the styling before a linebreak and reopen
			// after next line to fix a bleed issue on macOS
			// https://github.com/chalk/chalk/pull/92
			str = str.replace(/\r?\n/g, code.close + '$&' + code.open);
		}
	
		// Reset the original `dim` if we changed it to work around the Windows dimmed gray issue
		ansiStyles.dim.open = originalDim;
	
		return str;
	}
	
	function chalkTag(chalk, strings) {
		if (!Array.isArray(strings)) {
			// If chalk() was called by itself or with a string,
			// return the string itself as a string.
			return [].slice.call(arguments, 1).join(' ');
		}
	
		var args = [].slice.call(arguments, 2);
		var parts = [strings.raw[0]];
	
		for (var i = 1; i < strings.length; i++) {
			parts.push(String(args[i - 1]).replace(/[{}\\]/g, '\\$&'));
			parts.push(String(strings.raw[i]));
		}
	
		return template(chalk, parts.join(''));
	}
	
	Object.defineProperties(Chalk.prototype, styles);
	
	module.exports = Chalk(); // eslint-disable-line new-cap
	module.exports.supportsColor = stdoutColor;
	module.exports.default = module.exports; // For TypeScript
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78)))

/***/ }),
/* 872 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
		stdout: false,
		stderr: false
	};

/***/ }),
/* 873 */
/***/ (function(module, exports) {

	'use strict';
	
	var TEMPLATE_REGEX = /(?:\\(u[a-f\d]{4}|x[a-f\d]{2}|.))|(?:\{(~)?(\w+(?:\([^)]*\))?(?:\.\w+(?:\([^)]*\))?)*)(?:[ \t]|(?=\r?\n)))|(\})|((?:.|[\r\n\f])+?)/gi;
	var STYLE_REGEX = /(?:^|\.)(\w+)(?:\(([^)]*)\))?/g;
	var STRING_REGEX = /^(['"])((?:\\.|(?!\1)[^\\])*)\1$/;
	var ESCAPE_REGEX = /\\(u[a-f\d]{4}|x[a-f\d]{2}|.)|([^\\])/gi;
	
	var ESCAPES = new Map([['n', '\n'], ['r', '\r'], ['t', '\t'], ['b', '\b'], ['f', '\f'], ['v', '\v'], ['0', '\0'], ['\\', '\\'], ['e', '\x1B'], ['a', '\x07']]);
	
	function unescape(c) {
		if (c[0] === 'u' && c.length === 5 || c[0] === 'x' && c.length === 3) {
			return String.fromCharCode(parseInt(c.slice(1), 16));
		}
	
		return ESCAPES.get(c) || c;
	}
	
	function parseArguments(name, args) {
		var results = [];
		var chunks = args.trim().split(/\s*,\s*/g);
		var matches = void 0;
	
		for (var _iterator = chunks, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref;
	
			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}
	
			var chunk = _ref;
	
			if (!isNaN(chunk)) {
				results.push(Number(chunk));
			} else if (matches = chunk.match(STRING_REGEX)) {
				results.push(matches[2].replace(ESCAPE_REGEX, function (m, escape, chr) {
					return escape ? unescape(escape) : chr;
				}));
			} else {
				throw new Error('Invalid Chalk template style argument: ' + chunk + ' (in style \'' + name + '\')');
			}
		}
	
		return results;
	}
	
	function parseStyle(style) {
		STYLE_REGEX.lastIndex = 0;
	
		var results = [];
		var matches = void 0;
	
		while ((matches = STYLE_REGEX.exec(style)) !== null) {
			var name = matches[1];
	
			if (matches[2]) {
				var args = parseArguments(name, matches[2]);
				results.push([name].concat(args));
			} else {
				results.push([name]);
			}
		}
	
		return results;
	}
	
	function buildStyle(chalk, styles) {
		var enabled = {};
	
		for (var _iterator2 = styles, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
			var _ref2;
	
			if (_isArray2) {
				if (_i2 >= _iterator2.length) break;
				_ref2 = _iterator2[_i2++];
			} else {
				_i2 = _iterator2.next();
				if (_i2.done) break;
				_ref2 = _i2.value;
			}
	
			var layer = _ref2;
	
			for (var _iterator4 = layer.styles, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
				var _ref4;
	
				if (_isArray4) {
					if (_i4 >= _iterator4.length) break;
					_ref4 = _iterator4[_i4++];
				} else {
					_i4 = _iterator4.next();
					if (_i4.done) break;
					_ref4 = _i4.value;
				}
	
				var style = _ref4;
	
				enabled[style[0]] = layer.inverse ? null : style.slice(1);
			}
		}
	
		var current = chalk;
		for (var _iterator3 = Object.keys(enabled), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
			var _ref3;
	
			if (_isArray3) {
				if (_i3 >= _iterator3.length) break;
				_ref3 = _iterator3[_i3++];
			} else {
				_i3 = _iterator3.next();
				if (_i3.done) break;
				_ref3 = _i3.value;
			}
	
			var styleName = _ref3;
	
			if (Array.isArray(enabled[styleName])) {
				if (!(styleName in current)) {
					throw new Error('Unknown Chalk style: ' + styleName);
				}
	
				if (enabled[styleName].length > 0) {
					current = current[styleName].apply(current, enabled[styleName]);
				} else {
					current = current[styleName];
				}
			}
		}
	
		return current;
	}
	
	module.exports = function (chalk, tmp) {
		var styles = [];
		var chunks = [];
		var chunk = [];
	
		// eslint-disable-next-line max-params
		tmp.replace(TEMPLATE_REGEX, function (m, escapeChar, inverse, style, close, chr) {
			if (escapeChar) {
				chunk.push(unescape(escapeChar));
			} else if (style) {
				var str = chunk.join('');
				chunk = [];
				chunks.push(styles.length === 0 ? str : buildStyle(chalk, styles)(str));
				styles.push({ inverse: inverse, styles: parseStyle(style) });
			} else if (close) {
				if (styles.length === 0) {
					throw new Error('Found extraneous } in Chalk template literal');
				}
	
				chunks.push(buildStyle(chalk, styles)(chunk.join('')));
				chunk = [];
				styles.pop();
			} else {
				chunk.push(chr);
			}
		});
	
		chunks.push(chunk.join(''));
	
		if (styles.length > 0) {
			var errMsg = 'Chalk template literal is missing ' + styles.length + ' closing bracket' + (styles.length === 1 ? '' : 's') + ' (`}`)';
			throw new Error(errMsg);
		}
	
		return chunks.join('');
	};

/***/ }),
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _of = __webpack_require__(89);
	
	var _merge = __webpack_require__(162);
	
	var _reduxObservable = __webpack_require__(80);
	
	var _2 = __webpack_require__(56);
	
	var _operators = __webpack_require__(120);
	
	var _cookieVaules = __webpack_require__(279);
	
	/* global HOME_PATH */
	function fetchUserEpic(action$, _, _ref) {
	  var services = _ref.services;
	
	  var fetchUser = action$.pipe((0, _reduxObservable.ofType)(_2.types.fetchUser), (0, _operators.filter)(function () {
	    return !!_cookieVaules.jwt;
	  }), (0, _operators.switchMap)(function () {
	    return services.readService$({ service: 'user' }).pipe((0, _operators.filter)(function (_ref2) {
	      var entities = _ref2.entities,
	          result = _ref2.result;
	      return entities && !!result;
	    }), (0, _operators.map)(function (response) {
	      var user = response.entities.user,
	          result = response.result;
	
	      if (!user[result].emailVerified) {
	        return (0, _2.hardGoTo)(("http://localhost:3000"));
	      }
	      return (0, _2.fetchUserComplete)(response);
	    }), (0, _operators.defaultIfEmpty)((0, _2.noUserFound)()), (0, _operators.catchError)(function () {
	      return (0, _of.of)((0, _2.fetchUserError)());
	    }));
	  }));
	  var isLoadingRequired = action$.pipe((0, _reduxObservable.ofType)(_2.types.fetchUser), (0, _operators.filter)(function () {
	    return !_cookieVaules.jwt;
	  }), (0, _operators.mapTo)((0, _2.noUserFound)()));
	
	  return (0, _merge.merge)(fetchUser, isLoadingRequired);
	}
	
	exports.default = fetchUserEpic;
	module.exports = exports['default'];

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = hardGoToEpic;
	
	var _reduxObservable = __webpack_require__(80);
	
	var _operators = __webpack_require__(120);
	
	var _2 = __webpack_require__(56);
	
	function hardGoToEpic(action$, _, _ref) {
	  var location = _ref.location;
	
	  return action$.pipe((0, _reduxObservable.ofType)(_2.types.hardGoTo), (0, _operators.tap)(function (_ref2) {
	    var _ref2$payload = _ref2.payload,
	        payload = _ref2$payload === undefined ? ("http://localhost:3000") : _ref2$payload;
	
	    location.href = payload;
	  }), (0, _operators.ignoreElements)());
	} /* global HOME_PATH */
	module.exports = exports['default'];

/***/ }),
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.cssToHtml = exports.jsToHtml = undefined;
	exports.concatHtml = concatHtml;
	
	var _template2 = __webpack_require__(4343);
	
	var _template3 = _interopRequireDefault(_template2);
	
	var _rxjs = __webpack_require__(88);
	
	var _cond = __webpack_require__(468);
	
	var _cond2 = _interopRequireDefault(_cond);
	
	var _flow = __webpack_require__(471);
	
	var _flow2 = _interopRequireDefault(_flow);
	
	var _identity = __webpack_require__(53);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _matchesProperty = __webpack_require__(689);
	
	var _matchesProperty2 = _interopRequireDefault(_matchesProperty);
	
	var _partial = __webpack_require__(691);
	
	var _partial2 = _interopRequireDefault(_partial);
	
	var _stubTrue = __webpack_require__(476);
	
	var _stubTrue2 = _interopRequireDefault(_stubTrue);
	
	var _fetchAndCache = __webpack_require__(543);
	
	var _polyvinyl = __webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var htmlCatch = '\n<!--fcc-->\n';
	var jsCatch = '\n;/*fcc*/\n';
	
	var defaultTemplate = function defaultTemplate(_ref) {
	  var source = _ref.source;
	  return '\n  <body style=\'margin:8px;\'>\n    <!-- fcc-start-source -->\n      ' + source + '\n    <!-- fcc-end-source -->\n  </body>\n';
	};
	
	var wrapInScript = (0, _partial2.default)(_polyvinyl.transformContents, function (content) {
	  return htmlCatch + '<script>' + content + jsCatch + '</script>';
	});
	var wrapInStyle = (0, _partial2.default)(_polyvinyl.transformContents, function (content) {
	  return htmlCatch + '<style>' + content + '</style>';
	});
	var setExtToHTML = (0, _partial2.default)(_polyvinyl.setExt, 'html');
	var padContentWithJsCatch = (0, _partial2.default)(_polyvinyl.compileHeadTail, jsCatch);
	var padContentWithHTMLCatch = (0, _partial2.default)(_polyvinyl.compileHeadTail, htmlCatch);
	
	var jsToHtml = exports.jsToHtml = (0, _cond2.default)([[(0, _matchesProperty2.default)('ext', 'js'), (0, _flow2.default)(padContentWithJsCatch, wrapInScript, setExtToHTML)], [_stubTrue2.default, _identity2.default]]);
	
	var cssToHtml = exports.cssToHtml = (0, _cond2.default)([[(0, _matchesProperty2.default)('ext', 'css'), (0, _flow2.default)(padContentWithHTMLCatch, wrapInStyle, setExtToHTML)], [_stubTrue2.default, _identity2.default]]);
	
	// FileStream::concatHtml(
	//   required: [ ...Object ],
	//   template: String
	// ) => Observable[{ build: String, sources: Dictionary }]
	function concatHtml(required, template) {
	  var createBody = template ? (0, _template3.default)(template) : defaultTemplate;
	  var source = this.shareReplay();
	  var sourceMap = source.flatMap(function (files) {
	    return files.reduce(function (sources, file) {
	      sources[file.name] = file.source || file.contents;
	      return sources;
	    }, {});
	  });
	
	  var head = _rxjs.Observable.from(required).flatMap(function (required) {
	    if (required.src) {
	      return (0, _fetchAndCache.fetchScript)(required);
	    }
	    if (required.link) {
	      return (0, _fetchAndCache.fetchLink)(required);
	    }
	    return _rxjs.Observable.of('');
	  }).reduce(function (head, required) {
	    return head + required;
	  }, '').map(function (head) {
	    return '<head>' + head + '</head>';
	  });
	
	  var body = source.flatMap(function (file) {
	    return file.reduce(function (body, file) {
	      return body + file.contents + file.tail + htmlCatch;
	    }, '');
	  }).map(function (source) {
	    return { source: source };
	  }).map(createBody);
	
	  return _rxjs.Observable.combineLatest(head, body, (0, _fetchAndCache.fetchScript)({
	    src: '/js/frame-runner.js',
	    crossDomain: false,
	    cacheBreaker: true
	  }), sourceMap, function (head, body, frameRunner, sources) {
	    return {
	      build: head + body + frameRunner,
	      sources: sources
	    };
	  });
	}

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = validate;
	
	var _rxjs = __webpack_require__(88);
	
	var _cond = __webpack_require__(468);
	
	var _cond2 = _interopRequireDefault(_cond);
	
	var _identity = __webpack_require__(53);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _stubTrue = __webpack_require__(476);
	
	var _stubTrue2 = _interopRequireDefault(_stubTrue);
	
	var _conforms = __webpack_require__(4315);
	
	var _conforms2 = _interopRequireDefault(_conforms);
	
	var _polyvinyl = __webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HTML$JSReg = /html|js/;
	
	var testHTMLJS = (0, _conforms2.default)({ ext: function ext(_ext) {
	    return HTML$JSReg.test(_ext);
	  } });
	// const testJS = matchesProperty('ext', 'js');
	var passToNext = [_stubTrue2.default, _identity2.default];
	
	// Detect if a JS multi-line comment is left open
	var throwIfOpenComments = (0, _cond2.default)([[testHTMLJS, function _checkForComments(_ref) {
	  var contents = _ref.contents;
	
	  var openingComments = contents.match(/\/\*/gi);
	  var closingComments = contents.match(/\*\//gi);
	  if (openingComments && (!closingComments || openingComments.length > closingComments.length)) {
	    throw new SyntaxError('Unfinished multi-line comment');
	  }
	}], passToNext]);
	
	// Nested dollar sign calls breaks browsers
	var nestedJQCallReg = /\$\s*?\(\s*?\$\s*?\)/gi;
	var throwIfNestedJquery = (0, _cond2.default)([[testHTMLJS, function (_ref2) {
	  var contents = _ref2.contents;
	
	  if (nestedJQCallReg.test(contents)) {
	    throw new SyntaxError('Nested jQuery calls breaks browsers');
	  }
	}], passToNext]);
	
	var functionReg = /function/g;
	var functionCallReg = /function\s*?\(|function\s+\w+\s*?\(/gi;
	// lonely function keywords breaks browsers
	var ThrowIfUnfinishedFunction = (0, _cond2.default)([[testHTMLJS, function (_ref3) {
	  var contents = _ref3.contents;
	
	  if (functionReg.test(contents) && !functionCallReg.test(contents)) {
	    throw new SyntaxError('Unsafe or unfinished function declaration');
	  }
	}], passToNext]);
	
	// console call stops tests scripts from running
	var unsafeConsoleCallReg = /if\s\(null\)\sconsole\.log\(1\);/gi;
	var throwIfUnsafeConsoleCall = (0, _cond2.default)([[testHTMLJS, function (_ref4) {
	  var contents = _ref4.contents;
	
	  if (unsafeConsoleCallReg.test(contents)) {
	    throw new SyntaxError('`if (null) console.log(1)` detected. This will break tests');
	  }
	}], passToNext]);
	
	// Code with the URL hyperdev.com should not be allowed to run,
	var goMixReg = /glitch\.(com|me)/gi;
	var throwIfGomixDetected = (0, _cond2.default)([[testHTMLJS, function (_ref5) {
	  var contents = _ref5.contents;
	
	  if (goMixReg.test(contents)) {
	    throw new Error('Glitch.com or Glitch.me should not be in the code');
	  }
	}], passToNext]);
	
	var validators = [throwIfOpenComments, throwIfGomixDetected, throwIfNestedJquery, ThrowIfUnfinishedFunction, throwIfUnsafeConsoleCall];
	
	function validate(file) {
	  return validators.reduce(function (obs, validator) {
	    return obs.flatMap(function (file) {
	      try {
	        return (0, _polyvinyl.castToObservable)(validator(file));
	      } catch (err) {
	        return _rxjs.Observable.throw(err);
	      }
	    });
	  }, _rxjs.Observable.of(file))
	  // if no error has occured map to the original file
	  .switchMap(function () {
	    return _rxjs.Observable.of(file);
	  })
	  // if err add it to the file
	  // and return file
	  .catch(function (err) {
	    file.error = err;
	    return _rxjs.Observable.of(file);
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._transformers = exports.htmlSassTransformer = exports.babelTransformer = exports.replaceNBSP = exports.proxyLoggerTransformer = exports.testJS$JSX = undefined;
	exports.applyTransformers = applyTransformers;
	
	var _attempt = __webpack_require__(681);
	
	var _attempt2 = _interopRequireDefault(_attempt);
	
	var _cond = __webpack_require__(468);
	
	var _cond2 = _interopRequireDefault(_cond);
	
	var _flow = __webpack_require__(471);
	
	var _flow2 = _interopRequireDefault(_flow);
	
	var _identity = __webpack_require__(53);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _isError = __webpack_require__(472);
	
	var _isError2 = _interopRequireDefault(_isError);
	
	var _matchesProperty = __webpack_require__(689);
	
	var _matchesProperty2 = _interopRequireDefault(_matchesProperty);
	
	var _overSome = __webpack_require__(4334);
	
	var _overSome2 = _interopRequireDefault(_overSome);
	
	var _partial = __webpack_require__(691);
	
	var _partial2 = _interopRequireDefault(_partial);
	
	var _stubTrue = __webpack_require__(476);
	
	var _stubTrue2 = _interopRequireDefault(_stubTrue);
	
	var _babelStandalone = __webpack_require__(971);
	
	var Babel = _interopRequireWildcard(_babelStandalone);
	
	var _babelPresetEs = __webpack_require__(957);
	
	var _babelPresetEs2 = _interopRequireDefault(_babelPresetEs);
	
	var _babelPresetReact = __webpack_require__(959);
	
	var _babelPresetReact2 = _interopRequireDefault(_babelPresetReact);
	
	var _rxjs = __webpack_require__(88);
	
	var _loopProtect = __webpack_require__(697);
	
	var _loopProtect2 = _interopRequireDefault(_loopProtect);
	
	var _polyvinyl = __webpack_require__(167);
	
	var vinyl = _interopRequireWildcard(_polyvinyl);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var castToObservable = vinyl.castToObservable;
	
	
	var protectTimeout = 100;
	Babel.registerPlugin('loopProtection', (0, _loopProtect2.default)(protectTimeout));
	
	var babelOptions = {
	  plugins: ['loopProtection'],
	  presets: [_babelPresetEs2.default, _babelPresetReact2.default]
	};
	var babelTransformCode = function babelTransformCode(code) {
	  return Babel.transform(code, babelOptions).code;
	};
	
	// const sourceReg =
	//  /(<!-- fcc-start-source -->)([\s\S]*?)(?=<!-- fcc-end-source -->)/g;
	var console$logReg = /(?:\b)console(\.log\S+)/g;
	var NBSPReg = new RegExp(String.fromCharCode(160), 'g');
	
	var isJS = (0, _matchesProperty2.default)('ext', 'js');
	var testHTML = (0, _matchesProperty2.default)('ext', 'html');
	var testHTMLJS = (0, _overSome2.default)(isJS, testHTML);
	var testJS$JSX = exports.testJS$JSX = (0, _overSome2.default)(isJS, (0, _matchesProperty2.default)('ext', 'jsx'));
	
	// if shouldProxyConsole then we change instances of console log
	// to `window.__console.log`
	// this let's us tap into logging into the console.
	// currently we only do this to the main window and not the test window
	var proxyLoggerTransformer = exports.proxyLoggerTransformer = (0, _partial2.default)(vinyl.transformHeadTailAndContents, function (source) {
	  return source.replace(console$logReg, function (match, methodCall) {
	    return 'window.__console' + methodCall;
	  });
	});
	
	var replaceNBSP = exports.replaceNBSP = (0, _cond2.default)([[testHTMLJS, (0, _partial2.default)(vinyl.transformContents, function (contents) {
	  return contents.replace(NBSPReg, ' ');
	})], [_stubTrue2.default, _identity2.default]]);
	
	function tryTransform() {
	  var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _identity2.default;
	
	  return function transformWrappedPoly(source) {
	    var result = (0, _attempt2.default)(wrap, source);
	    if ((0, _isError2.default)(result)) {
	      console.error(result);
	      // note(Bouncey): Error thrown here to collapse the build pipeline
	      // At the minute, it will not bubble up
	      // We collapse the pipeline so the app doesn't fall over trying
	      // parse bad code (syntax/type errors etc...)
	      throw result;
	    }
	    return result;
	  };
	}
	
	var babelTransformer = exports.babelTransformer = (0, _cond2.default)([[testJS$JSX, (0, _flow2.default)((0, _partial2.default)(vinyl.transformHeadTailAndContents, tryTransform(babelTransformCode)), (0, _partial2.default)(vinyl.setExt, 'js'))], [_stubTrue2.default, _identity2.default]]);
	
	var htmlSassTransformCode = function htmlSassTransformCode(file) {
	  var doc = document.implementation.createHTMLDocument();
	  doc.body.innerHTML = file.contents;
	  var styleTags = [].filter.call(doc.querySelectorAll('style'), function (style) {
	    return style.type === 'text/sass';
	  });
	  if (styleTags.length === 0 || typeof Sass === 'undefined') {
	    return vinyl.transformContents(function () {
	      return doc.body.innerHTML;
	    }, file);
	  }
	  return styleTags.reduce(function (obs, style) {
	    return obs.flatMap(function (file) {
	      return new Promise(function (resolve) {
	        window.Sass.compile(style.innerHTML, function (result) {
	          style.type = 'text/css';
	          style.innerHTML = result.text;
	          resolve(vinyl.transformContents(function () {
	            return doc.body.innerHTML;
	          }, file));
	        });
	      });
	    });
	  }, _rxjs.Observable.of(file));
	};
	
	var htmlSassTransformer = exports.htmlSassTransformer = (0, _cond2.default)([[testHTML, htmlSassTransformCode], [_stubTrue2.default, _identity2.default]]);
	
	var _transformers = exports._transformers = [replaceNBSP, babelTransformer, htmlSassTransformer];
	
	function applyTransformers(file) {
	  var transformers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _transformers;
	
	  return transformers.reduce(function (obs, transformer) {
	    return obs.flatMap(function (file) {
	      return castToObservable(transformer(file));
	    });
	  }, _rxjs.Observable.of(file));
	}

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reduxObservable = __webpack_require__(80);
	
	var _operators = __webpack_require__(120);
	
	var _of = __webpack_require__(89);
	
	var _empty = __webpack_require__(507);
	
	var _ = __webpack_require__(19);
	
	function challengeModalEpic(action$) {
	  return action$.pipe((0, _reduxObservable.ofType)(_.types.updateTests), (0, _operators.switchMap)(function (_ref) {
	    var tests = _ref.payload;
	
	    var challengeComplete = tests.every(function (test) {
	      return test.pass && !test.err;
	    });
	    return challengeComplete ? (0, _of.of)((0, _.openModal)('completion')) : (0, _empty.empty)();
	  }));
	}
	
	exports.default = challengeModalEpic;
	module.exports = exports['default'];

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _map = __webpack_require__(163);
	
	var _reduxObservable = __webpack_require__(80);
	
	var _ = __webpack_require__(19);
	
	function codeLockEpic(action$) {
	  return action$.pipe((0, _reduxObservable.ofType)(_.types.executeChallenge), (0, _map.map)(_.unlockCode));
	}
	
	exports.default = codeLockEpic;
	module.exports = exports['default'];

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _of = __webpack_require__(89);
	
	var _filter = __webpack_require__(348);
	
	var _switchMap = __webpack_require__(351);
	
	var _tap = __webpack_require__(352);
	
	var _ignoreElements = __webpack_require__(515);
	
	var _reduxObservable = __webpack_require__(80);
	
	var _store = __webpack_require__(4762);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _ = __webpack_require__(19);
	
	var _polyvinyl = __webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var legacyPrefixes = ['Bonfire: ', 'Waypoint: ', 'Zipline: ', 'Basejump: ', 'Checkpoint: '];
	var legacyPostfix = 'Val';
	
	function getCode(id) {
	  var code = _store2.default.get(id);
	  return code ? code : null;
	}
	
	function getLegacyCode(legacy) {
	  var key = legacy + legacyPostfix;
	  var code = null;
	  var maybeCode = _store2.default.get(key);
	  if (maybeCode) {
	    code = '' + maybeCode;
	    _store2.default.remove(key);
	    return code;
	  }
	  return legacyPrefixes.reduce(function (code, prefix) {
	    if (code) {
	      return code;
	    }
	    return _store2.default.get(prefix + key);
	  }, null);
	}
	
	function legacyToFile(code, files, key) {
	  if (isFilesAllPoly(files)) {
	    var _ref;
	
	    return _ref = {}, _ref[key] = (0, _polyvinyl.setContent)(code, files[key]), _ref;
	  }
	  return false;
	}
	
	function isFilesAllPoly(files) {
	  return Object.keys(files).map(function (key) {
	    return files[key];
	  }).every(function (file) {
	    return (0, _polyvinyl.isPoly)(file);
	  });
	}
	
	function clearCodeEpic(action$, _ref2) {
	  var getState = _ref2.getState;
	
	  return action$.pipe((0, _reduxObservable.ofType)(_.types.submitComplete, _.types.resetChallenge), (0, _tap.tap)(function () {
	    var _challengeMetaSelecto = (0, _.challengeMetaSelector)(getState()),
	        id = _challengeMetaSelecto.id;
	
	    _store2.default.remove(id);
	  }), (0, _ignoreElements.ignoreElements)());
	}
	
	function saveCodeEpic(action$, _ref3) {
	  var getState = _ref3.getState;
	
	  return action$.pipe((0, _reduxObservable.ofType)(_.types.executeChallenge),
	  // do not save challenge if code is locked
	  (0, _filter.filter)(function () {
	    return !(0, _.isCodeLockedSelector)(getState());
	  }), (0, _tap.tap)(function () {
	    var state = getState();
	
	    var _challengeMetaSelecto2 = (0, _.challengeMetaSelector)(state),
	        id = _challengeMetaSelecto2.id;
	
	    var files = (0, _.challengeFilesSelector)(state);
	    _store2.default.set(id, files);
	  }), (0, _ignoreElements.ignoreElements)());
	}
	
	function loadCodeEpic(action$, _ref4) {
	  var getState = _ref4.getState;
	
	  return action$.pipe((0, _reduxObservable.ofType)(_.types.challengeMounted), (0, _switchMap.switchMap)(function (_ref5) {
	    var id = _ref5.payload;
	
	    var finalFiles = void 0;
	    var state = getState();
	    var challenge = (0, _.challengeMetaSelector)(state);
	    var files = (0, _.challengeFilesSelector)(state);
	    var fileKeys = Object.keys(files);
	    var invalidForLegacy = fileKeys.length > 1;
	    var legacyKey = challenge.title;
	
	
	    var codeFound = getCode(id);
	    if (codeFound && isFilesAllPoly(codeFound)) {
	      finalFiles = codeFound;
	    } else {
	      var legacyCode = getLegacyCode(legacyKey);
	      if (legacyCode && !invalidForLegacy) {
	        finalFiles = legacyToFile(legacyCode, files, fileKeys[0]);
	      }
	    }
	    if (finalFiles) {
	      return (0, _of.of)((0, _.storedCodeFound)(finalFiles));
	    }
	    return (0, _of.of)((0, _.noStoredCodeFound)());
	  }));
	}
	
	exports.default = (0, _reduxObservable.combineEpics)(saveCodeEpic, loadCodeEpic, clearCodeEpic);
	module.exports = exports['default'];

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = completionEpic;
	
	var _of = __webpack_require__(89);
	
	var _empty = __webpack_require__(507);
	
	var _operators = __webpack_require__(120);
	
	var _reduxObservable = __webpack_require__(80);
	
	var _reactRouterRedux = __webpack_require__(499);
	
	var _cookieVaules = __webpack_require__(279);
	
	var _ = __webpack_require__(19);
	
	var _app = __webpack_require__(56);
	
	var _ajaxStream = __webpack_require__(281);
	
	var _challengeTypes = __webpack_require__(282);
	
	function postChallenge(url, username, _csrf, challengeInfo) {
	  var body = _extends({}, challengeInfo, { _csrf: _csrf });
	  var saveChallenge = (0, _ajaxStream.postJSON$)(url, body).pipe((0, _operators.retry)(3), (0, _operators.map)(function (_ref) {
	    var points = _ref.points;
	    return (0, _.submitComplete)(_extends({
	      username: username,
	      points: points
	    }, challengeInfo));
	  }), (0, _operators.catchError)(function (err) {
	    console.error(err);
	    return (0, _of.of)({ type: 'here is an error' });
	  }));
	  return saveChallenge;
	}
	
	function submitModern(type, state) {
	  var tests = (0, _.challengeTestsSelector)(state);
	  if (tests.length > 0 && tests.every(function (test) {
	    return test.pass && !test.err;
	  })) {
	    if (type === _.types.checkChallenge) {
	      return (0, _of.of)({ type: 'this was a check challenge' });
	    }
	
	    if (type === _.types.submitChallenge) {
	      var _challengeMetaSelecto = (0, _.challengeMetaSelector)(state),
	          id = _challengeMetaSelecto.id;
	
	      var files = (0, _.challengeFilesSelector)(state);
	
	      var _userSelector = (0, _app.userSelector)(state),
	          username = _userSelector.username;
	
	      return postChallenge('/external/modern-challenge-completed', username, _cookieVaules._csrf, {
	        id: id,
	        files: files
	      });
	    }
	  }
	  return (0, _empty.empty)();
	}
	
	function submitProject(type, state) {
	  if (type === _.types.checkChallenge) {
	    return (0, _empty.empty)();
	  }
	
	  var _projectFormVaulesSel = (0, _.projectFormVaulesSelector)(state),
	      solution = _projectFormVaulesSel.solution,
	      githubLink = _projectFormVaulesSel.githubLink;
	
	  var _challengeMetaSelecto2 = (0, _.challengeMetaSelector)(state),
	      id = _challengeMetaSelecto2.id,
	      challengeType = _challengeMetaSelecto2.challengeType;
	
	  var _userSelector2 = (0, _app.userSelector)(state),
	      username = _userSelector2.username;
	
	  var challengeInfo = { id: id, challengeType: challengeType, solution: solution };
	  if (challengeType === _challengeTypes.challengeTypes.backEndProject) {
	    challengeInfo.githubLink = githubLink;
	  }
	  return postChallenge('/external/project-completed', username, _cookieVaules._csrf, challengeInfo);
	}
	
	function submitBackendChallenge(type, state) {
	  var tests = (0, _.challengeTestsSelector)(state);
	  if (tests.length > 0 && tests.every(function (test) {
	    return test.pass && !test.err;
	  })) {
	    if (type === _.types.submitChallenge) {
	      var _challengeMetaSelecto3 = (0, _.challengeMetaSelector)(state),
	          id = _challengeMetaSelecto3.id;
	
	      var _userSelector3 = (0, _app.userSelector)(state),
	          username = _userSelector3.username;
	
	      var _backendFormValuesSel = (0, _.backendFormValuesSelector)(state),
	          solution = _backendFormValuesSel.solution.value;
	
	      var challengeInfo = { id: id, solution: solution };
	      return postChallenge('/external/backend-challenge-completed', username, _cookieVaules._csrf, challengeInfo);
	    }
	  }
	  return (0, _empty.empty)();
	}
	
	var submitters = {
	  tests: submitModern,
	  backend: submitBackendChallenge,
	  'project.frontEnd': submitProject,
	  'project.backEnd': submitProject
	};
	
	function shouldShowDonate(state) {
	  return (0, _app.shouldShowDonationSelector)(state) ? (0, _of.of)((0, _app.openDonationModal)()) : (0, _empty.empty)();
	}
	
	function completionEpic(action$, _ref2) {
	  var getState = _ref2.getState;
	
	  return action$.pipe((0, _reduxObservable.ofType)(_.types.submitChallenge), (0, _operators.switchMap)(function (_ref3) {
	    var type = _ref3.type;
	
	    var state = getState();
	    var meta = (0, _.challengeMetaSelector)(state);
	
	    var _userSelector4 = (0, _app.userSelector)(state),
	        isDonating = _userSelector4.isDonating;
	
	    var nextChallengePath = meta.nextChallengePath,
	        introPath = meta.introPath,
	        challengeType = meta.challengeType;
	
	    var next = (0, _of.of)((0, _reactRouterRedux.push)(introPath ? introPath : nextChallengePath));
	    var showDonate = isDonating ? (0, _empty.empty)() : shouldShowDonate(state);
	    var closeChallengeModal = (0, _of.of)((0, _.closeModal)('completion'));
	    var submitter = function submitter() {
	      return (0, _of.of)({ type: 'no-user-signed-in' });
	    };
	    if (!(challengeType in _challengeTypes.submitTypes) || !(_challengeTypes.submitTypes[challengeType] in submitters)) {
	      throw new Error('Unable to find the correct submit function for challengeType ' + challengeType);
	    }
	    if ((0, _app.isSignedInSelector)(state)) {
	      submitter = submitters[_challengeTypes.submitTypes[challengeType]];
	    }
	
	    return submitter(type, state).pipe((0, _operators.concat)(next), (0, _operators.concat)(closeChallengeModal), (0, _operators.concat)(showDonate), (0, _operators.filter)(Boolean));
	  }));
	}
	module.exports = exports['default'];

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reduxObservable = __webpack_require__(80);
	
	var _redux = __webpack_require__(19);
	
	var _tap = __webpack_require__(352);
	
	var _mapTo = __webpack_require__(516);
	
	function filesToMarkdown() {
	  var files = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var moreThenOneFile = Object.keys(files).length > 1;
	  return Object.keys(files).reduce(function (fileString, key) {
	    var file = files[key];
	    if (!file) {
	      return fileString;
	    }
	    var fileName = moreThenOneFile ? '\\ file: ' + file.contents : '';
	    var fileType = file.ext;
	    return fileString + '```' + fileType + '\n' + fileName + '\n' + file.contents + '\n' + '```\n\n';
	  }, '\n');
	}
	
	function createQuestionEpic(action$, _ref, _ref2) {
	  var getState = _ref.getState;
	  var window = _ref2.window;
	
	  return action$.pipe((0, _reduxObservable.ofType)(_redux.types.createQuestion), (0, _tap.tap)(function () {
	    var state = getState();
	    var files = (0, _redux.challengeFilesSelector)(state);
	
	    var _challengeMetaSelecto = (0, _redux.challengeMetaSelector)(state),
	        challengeTitle = _challengeMetaSelecto.title,
	        challengeType = _challengeMetaSelecto.challengeType;
	
	    var userAgent = window.navigator.userAgent,
	        href = window.location.href;
	
	    var textMessage = ["**Tell us what's happening:**\n\n\n\n", '**Your code so far**\n', filesToMarkdown(files), '**Your browser information:**\n\n', 'User Agent is: <code>', userAgent, '</code>.\n\n', '**Link to the challenge:**\n', href].join('');
	    var categories = ['HTML-CSS', 'JavaScript'];
	    window.open('https://forum.freecodecamp.one/new-topic' + '?category=' + window.encodeURIComponent(categories[challengeType] || 'Help') + '&title=' + window.encodeURIComponent(challengeTitle) + '&body=' + window.encodeURIComponent(textMessage), '_blank');
	  }), (0, _mapTo.mapTo)((0, _redux.closeModal)('help')));
	}
	
	exports.default = createQuestionEpic;
	module.exports = exports['default'];

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reduxObservable = __webpack_require__(80);
	
	var _ = __webpack_require__(19);
	
	var _operators = __webpack_require__(120);
	
	var _app = __webpack_require__(56);
	
	var _ajaxStream = __webpack_require__(281);
	
	var _cookieVaules = __webpack_require__(279);
	
	var _of = __webpack_require__(89);
	
	function currentChallengeEpic(action$, _ref) {
	  var getState = _ref.getState;
	
	  return action$.pipe((0, _reduxObservable.ofType)(_.types.challengeMounted), (0, _operators.filter)(function () {
	    return (0, _app.isSignedInSelector)(getState());
	  }), (0, _operators.filter)(function (_ref2) {
	    var payload = _ref2.payload;
	    return payload !== (0, _app.currentChallengeIdSelector)(getState());
	  }), (0, _operators.switchMap)(function (_ref3) {
	    var payload = _ref3.payload;
	    return (0, _ajaxStream.postJSON$)('/external/update-my-current-challenge', {
	      currentChallengeId: payload,
	      _csrf: _cookieVaules._csrf
	    });
	  }), (0, _operators.mapTo)({ type: 'currentChallengeUpdateComplete' }), (0, _operators.catchError)(function () {
	    return (0, _of.of)({ type: 'current-challenge-update-error' });
	  }));
	}
	
	exports.default = currentChallengeEpic;
	module.exports = exports['default'];

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _rxjs = __webpack_require__(88);
	
	var _merge = __webpack_require__(162);
	
	var _of = __webpack_require__(89);
	
	var _from = __webpack_require__(346);
	
	var _operators = __webpack_require__(120);
	
	var _reduxObservable = __webpack_require__(80);
	
	var _overEvery = __webpack_require__(4333);
	
	var _overEvery2 = _interopRequireDefault(_overEvery);
	
	var _isString = __webpack_require__(332);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _ = __webpack_require__(19);
	
	var _build = __webpack_require__(920);
	
	var _frame = __webpack_require__(921);
	
	var _challengeTypes = __webpack_require__(282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var executeDebounceTimeout = 750;
	
	function updateMainEpic(actions, _ref, _ref2) {
	  var getState = _ref.getState;
	  var document = _ref2.document;
	
	  return (0, _of.of)(document).pipe((0, _operators.filter)(Boolean), (0, _operators.switchMap)(function () {
	    var proxyLogger = new _rxjs.Subject();
	    var frameMain = (0, _frame.createMainFramer)(document, getState, proxyLogger);
	    var buildAndFrameMain = actions.pipe((0, _reduxObservable.ofType)(_.types.updateFile, _.types.executeChallenge, _.types.challengeMounted), (0, _operators.debounceTime)(executeDebounceTimeout), (0, _operators.switchMap)(function () {
	      return (0, _build.buildFromFiles)(getState(), true).pipe((0, _operators.map)(frameMain), (0, _operators.ignoreElements)(), (0, _operators.catchError)(function (err) {
	        return (0, _of.of)((0, _.disableJSOnError)(err));
	      }));
	    }));
	    return (0, _merge.merge)(buildAndFrameMain, proxyLogger.map(_.updateConsole));
	  }));
	}
	
	function executeChallengeEpic(action$, _ref3, _ref4) {
	  var getState = _ref3.getState;
	  var document = _ref4.document;
	
	  return (0, _of.of)(document).pipe((0, _operators.filter)(Boolean), (0, _operators.switchMap)(function () {
	    var frameReady = new _rxjs.Subject();
	    var frameTests = (0, _frame.createTestFramer)(document, getState, frameReady);
	    var challengeResults = frameReady.pipe((0, _operators.pluck)('checkChallengePayload'), (0, _operators.map)(function (checkChallengePayload) {
	      return {
	        checkChallengePayload: checkChallengePayload,
	        tests: (0, _.challengeTestsSelector)(getState())
	      };
	    }), (0, _operators.switchMap)(function (_ref5) {
	      var checkChallengePayload = _ref5.checkChallengePayload,
	          tests = _ref5.tests;
	
	      var postTests = (0, _of.of)((0, _.updateConsole)('// tests completed'), (0, _.checkChallenge)(checkChallengePayload)).pipe((0, _operators.delay)(250));
	      return (0, _frame.runTestsInTestFrame)(document, tests).pipe((0, _operators.switchMap)(function (tests) {
	        return (0, _from.from)(tests).pipe((0, _operators.map)(function (_ref6) {
	          var message = _ref6.message;
	          return message;
	        }), (0, _operators.filter)((0, _overEvery2.default)(_isString2.default, Boolean)), (0, _operators.map)(_.updateConsole), (0, _operators.concat)((0, _of.of)((0, _.updateTests)(tests))));
	      }), (0, _operators.concat)(postTests));
	    }));
	    var buildAndFrameChallenge = action$.pipe((0, _reduxObservable.ofType)(_.types.executeChallenge), (0, _operators.debounceTime)(executeDebounceTimeout), (0, _operators.filter)(function () {
	      return (0, _.isJSEnabledSelector)(getState());
	    }), (0, _operators.switchMap)(function () {
	      var state = getState();
	
	      var _challengeMetaSelecto = (0, _.challengeMetaSelector)(state),
	          challengeType = _challengeMetaSelecto.challengeType;
	
	      if (challengeType === _challengeTypes.backend) {
	        return (0, _build.buildBackendChallenge)(state).pipe((0, _operators.tap)(frameTests), (0, _operators.ignoreElements)(), (0, _operators.startWith)((0, _.initConsole)('// running test')), (0, _operators.catchError)(function (err) {
	          return (0, _of.of)((0, _.disableJSOnError)(err));
	        }));
	      }
	      return (0, _build.buildFromFiles)(state, false).pipe((0, _operators.tap)(frameTests), (0, _operators.ignoreElements)(), (0, _operators.startWith)((0, _.initConsole)('// running test')), (0, _operators.catchError)(function (err) {
	        return (0, _of.of)((0, _.disableJSOnError)(err));
	      }));
	    }));
	    return (0, _merge.merge)(buildAndFrameChallenge, challengeResults);
	  }));
	}
	
	exports.default = (0, _reduxObservable.combineEpics)(updateMainEpic, executeChallengeEpic);
	module.exports = exports['default'];

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.buildFromFiles = buildFromFiles;
	exports.buildBackendChallenge = buildBackendChallenge;
	
	var _combineLatest = __webpack_require__(765);
	
	var _map = __webpack_require__(163);
	
	var _identity = __webpack_require__(53);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _fetchAndCache = __webpack_require__(543);
	
	var _throwers = __webpack_require__(911);
	
	var _throwers2 = _interopRequireDefault(_throwers);
	
	var _redux = __webpack_require__(19);
	
	var _transformers = __webpack_require__(912);
	
	var _builders = __webpack_require__(910);
	
	var _polyvinyl = __webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var jQuery = {
	  src: 'https://cdn.jsdelivr.net/npm/jquery@3.3.1/dist/jquery.min.js'
	};
	var frameRunner = {
	  src: '/js/frame-runner.js',
	  crossDomain: false,
	  cacheBreaker: true
	};
	var globalRequires = [{
	  link: 'https://cdnjs.cloudflare.com/' + 'ajax/libs/normalize/4.2.0/normalize.min.css'
	}, jQuery];
	
	function filterJSIfDisabled(state) {
	  var isJSEnabled = (0, _redux.isJSEnabledSelector)(state);
	  return function (file) {
	    return !((0, _transformers.testJS$JSX)(file) && !isJSEnabled);
	  };
	}
	
	function buildFromFiles(state, shouldProxyConsole) {
	  var _context;
	
	  var files = (0, _redux.challengeFilesSelector)(state);
	
	  var _challengeMetaSelecto = (0, _redux.challengeMetaSelector)(state),
	      required = _challengeMetaSelecto.required,
	      template = _challengeMetaSelecto.template;
	
	  var finalRequires = [].concat(globalRequires, required);
	  var requiredFiles = Object.keys(files).map(function (key) {
	    return files[key];
	  }).filter(filterJSIfDisabled(state)).filter(Boolean);
	  return (_context = (_context = (_context = (_context = (_context = (_context = (0, _polyvinyl.createFileStream)(requiredFiles), _polyvinyl.pipe).call(_context, _throwers2.default), _polyvinyl.pipe).call(_context, _transformers.applyTransformers), _polyvinyl.pipe).call(_context, shouldProxyConsole ? _transformers.proxyLoggerTransformer : _identity2.default), _polyvinyl.pipe).call(_context, _builders.jsToHtml), _polyvinyl.pipe).call(_context, _builders.cssToHtml), _builders.concatHtml).call(_context, finalRequires, template);
	}
	
	function buildBackendChallenge(state) {
	  var _backendFormValuesSel = (0, _redux.backendFormValuesSelector)(state),
	      url = _backendFormValuesSel.solution.value;
	
	  return (0, _combineLatest.combineLatest)((0, _fetchAndCache.fetchScript)(frameRunner), (0, _fetchAndCache.fetchScript)(jQuery)).pipe((0, _map.map)(function (_ref) {
	    var frameRunner = _ref[0],
	        jQuery = _ref[1];
	    return {
	      build: jQuery + frameRunner,
	      sources: { url: url },
	      checkChallengePayload: { solution: url }
	    };
	  }));
	}

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createTestFramer = exports.createMainFramer = exports.runTestsInTestFrame = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _toString = __webpack_require__(54);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	var _flow = __webpack_require__(471);
	
	var _flow2 = _interopRequireDefault(_flow);
	
	var _rxjs = __webpack_require__(88);
	
	var _rxjs2 = _interopRequireDefault(_rxjs);
	
	var _enzyme = __webpack_require__(607);
	
	var _enzymeAdapterReact = __webpack_require__(1174);
	
	var _enzymeAdapterReact2 = _interopRequireDefault(_enzymeAdapterReact);
	
	var _redux = __webpack_require__(19);
	
	__webpack_require__(1004);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// we use two different frames to make them all essentially pure functions
	// main iframe is responsible rendering the preview and is where we proxy the
	// console.log
	var mainId = 'fcc-main-frame';
	// the test frame is responsible for running the assert tests
	var testId = 'fcc-test-frame';
	
	// base tag here will force relative links
	// within iframe to point to '/' instead of
	// append to the current challenge url
	// if an error occurs during initialization
	// the __err prop will be set
	// This is then picked up in client/frame-runner.js during
	// runTestsInTestFrame below
	var createHeader = function createHeader() {
	  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mainId;
	  return '\n  <base href=\'/\' target=\'_blank\'/>\n  <script>\n    window.__frameId = \'' + id + '\';\n    window.onerror = function(msg, url, ln, col, err) {\n      window.__err = err;\n      return true;\n    };\n  </script>\n';
	};
	
	var runTestsInTestFrame = exports.runTestsInTestFrame = function runTestsInTestFrame(document, tests) {
	  return _rxjs.Observable.defer(function () {
	    var _document$getElementB = document.getElementById(testId),
	        frame = _document$getElementB.contentDocument;
	
	    return frame.__runTests(tests);
	  });
	};
	
	var createFrame = function createFrame(document, getState, id) {
	  return function (ctx) {
	    var isJSEnabled = (0, _redux.isJSEnabledSelector)(getState());
	    var frame = document.createElement('iframe');
	    frame.id = id;
	    if (!isJSEnabled) {
	      frame.sandbox = 'allow-same-origin';
	    }
	    return _extends({}, ctx, {
	      element: frame
	    });
	  };
	};
	
	var hiddenFrameClassname = 'hide-test-frame';
	var mountFrame = function mountFrame(document) {
	  return function (_ref) {
	    var element = _ref.element,
	        rest = _objectWithoutProperties(_ref, ['element']);
	
	    var oldFrame = document.getElementById(element.id);
	    if (oldFrame) {
	      element.className = oldFrame.className || hiddenFrameClassname;
	      oldFrame.parentNode.replaceChild(element, oldFrame);
	    } else {
	      element.className = hiddenFrameClassname;
	      document.body.appendChild(element);
	    }
	    return _extends({}, rest, {
	      element: element,
	      document: element.contentDocument,
	      window: element.contentWindow
	    });
	  };
	};
	
	var addDepsToDocument = function addDepsToDocument(ctx) {
	  ctx.document.Rx = _rxjs2.default;
	
	  // using require here prevents nodejs issues as loop-protect
	  // is added to the window object by webpack and not available to
	  // us server side.
	  /* eslint-disable import/no-unresolved */
	  ctx.document.loopProtect = __webpack_require__(697);
	  /* eslint-enable import/no-unresolved */
	  return ctx;
	};
	
	var buildProxyConsole = function buildProxyConsole(proxyLogger) {
	  return function (ctx) {
	    var oldLog = ctx.window.console.log.bind(ctx.window.console);
	    ctx.window.__console = {};
	    ctx.window.__console.log = function proxyConsole() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      proxyLogger.next(args);
	      return oldLog.apply(undefined, args);
	    };
	    return ctx;
	  };
	};
	
	var writeTestDepsToDocument = function writeTestDepsToDocument(frameReady) {
	  return function (ctx) {
	    var tests = ctx.document,
	        sources = ctx.sources,
	        checkChallengePayload = ctx.checkChallengePayload;
	    // add enzyme
	    // TODO: do programatically
	    // TODO: webpack lazyload this
	
	    tests.Enzyme = {
	      shallow: function shallow(node, options) {
	        return new _enzyme.ShallowWrapper(node, null, _extends({}, options, {
	          adapter: new _enzymeAdapterReact2.default()
	        }));
	      },
	      mount: function mount(node, options) {
	        return new _enzyme.ReactWrapper(node, null, _extends({}, options, {
	          adapter: new _enzymeAdapterReact2.default()
	        }));
	      }
	    };
	    // default for classic challenges
	    // should not be used for modern
	    tests.__source = sources && 'index' in sources ? sources['index'] : '';
	    // provide the file name and get the original source
	    tests.__getUserInput = function (fileName) {
	      return (0, _toString2.default)(sources[fileName]);
	    };
	    tests.__checkChallengePayload = checkChallengePayload;
	    tests.__frameReady = frameReady;
	    return ctx;
	  };
	};
	
	function writeToFrame(content, frame) {
	  frame.open();
	  frame.write(content);
	  frame.close();
	  return frame;
	}
	
	var writeContentToFrame = function writeContentToFrame(ctx) {
	  writeToFrame(createHeader(ctx.element.id) + ctx.build, ctx.document);
	  return ctx;
	};
	
	var createMainFramer = exports.createMainFramer = function createMainFramer(document, getState, proxyLogger) {
	  return (0, _flow2.default)(createFrame(document, getState, mainId), mountFrame(document), addDepsToDocument, buildProxyConsole(proxyLogger), writeContentToFrame);
	};
	
	var createTestFramer = exports.createTestFramer = function createTestFramer(document, getState, frameReady) {
	  return (0, _flow2.default)(createFrame(document, getState, testId), mountFrame(document), addDepsToDocument, writeTestDepsToDocument(frameReady), writeContentToFrame);
	};

/***/ }),
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = function (_ref) {
	  var messages = _ref.messages;
	
	  return {
	    visitor: {
	      Scope: function Scope(_ref2) {
	        var scope = _ref2.scope;
	
	        for (var name in scope.bindings) {
	          var binding = scope.bindings[name];
	          if (binding.kind !== "const" && binding.kind !== "module") continue;
	
	          for (var _iterator = binding.constantViolations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	            var _ref3;
	
	            if (_isArray) {
	              if (_i >= _iterator.length) break;
	              _ref3 = _iterator[_i++];
	            } else {
	              _i = _iterator.next();
	              if (_i.done) break;
	              _ref3 = _i.value;
	            }
	
	            var violation = _ref3;
	
	            throw violation.buildCodeFrameError(messages.get("readOnly", name));
	          }
	        }
	      }
	    }
	  };
	};
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 926 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  return {
	    manipulateOptions: function manipulateOptions(opts, parserOpts) {
	      parserOpts.plugins.push("flow");
	    }
	  };
	};
	
	module.exports = exports["default"];

/***/ }),
/* 927 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (_ref) {
	  var t = _ref.types;
	
	  return {
	    visitor: {
	      ArrowFunctionExpression: function ArrowFunctionExpression(path, state) {
	        if (state.opts.spec) {
	          var node = path.node;
	
	          if (node.shadow) return;
	
	          node.shadow = { this: false };
	          node.type = "FunctionExpression";
	
	          var boundThis = t.thisExpression();
	          boundThis._forceShadow = path;
	
	          path.ensureBlock();
	          path.get("body").unshiftContainer("body", t.expressionStatement(t.callExpression(state.addHelper("newArrowCheck"), [t.thisExpression(), boundThis])));
	
	          path.replaceWith(t.callExpression(t.memberExpression(node, t.identifier("bind")), [t.thisExpression()]));
	        } else {
	          path.arrowFunctionToShadowed();
	        }
	      }
	    }
	  };
	};
	
	module.exports = exports["default"];

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = function (_ref) {
	  var t = _ref.types;
	
	  function statementList(key, path) {
	    var paths = path.get(key);
	
	    for (var _iterator = paths, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	      var _ref2;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref2 = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref2 = _i.value;
	      }
	
	      var _path = _ref2;
	
	      var func = _path.node;
	      if (!_path.isFunctionDeclaration()) continue;
	
	      var declar = t.variableDeclaration("let", [t.variableDeclarator(func.id, t.toExpression(func))]);
	
	      declar._blockHoist = 2;
	
	      func.id = null;
	
	      _path.replaceWith(declar);
	    }
	  }
	
	  return {
	    visitor: {
	      BlockStatement: function BlockStatement(path) {
	        var node = path.node,
	            parent = path.parent;
	
	        if (t.isFunction(parent, { body: node }) || t.isExportDeclaration(parent)) {
	          return;
	        }
	
	        statementList("body", path);
	      },
	      SwitchCase: function SwitchCase(path) {
	        statementList("consequent", path);
	      }
	    }
	  };
	};
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _symbol = __webpack_require__(83);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _create = __webpack_require__(82);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	exports.default = function () {
	  return {
	    visitor: {
	      VariableDeclaration: function VariableDeclaration(path, file) {
	        var node = path.node,
	            parent = path.parent,
	            scope = path.scope;
	
	        if (!isBlockScoped(node)) return;
	        convertBlockScopedToVar(path, null, parent, scope, true);
	
	        if (node._tdzThis) {
	          var nodes = [node];
	
	          for (var i = 0; i < node.declarations.length; i++) {
	            var decl = node.declarations[i];
	            if (decl.init) {
	              var assign = t.assignmentExpression("=", decl.id, decl.init);
	              assign._ignoreBlockScopingTDZ = true;
	              nodes.push(t.expressionStatement(assign));
	            }
	            decl.init = file.addHelper("temporalUndefined");
	          }
	
	          node._blockHoist = 2;
	
	          if (path.isCompletionRecord()) {
	            nodes.push(t.expressionStatement(scope.buildUndefinedNode()));
	          }
	
	          path.replaceWithMultiple(nodes);
	        }
	      },
	      Loop: function Loop(path, file) {
	        var node = path.node,
	            parent = path.parent,
	            scope = path.scope;
	
	        t.ensureBlock(node);
	        var blockScoping = new BlockScoping(path, path.get("body"), parent, scope, file);
	        var replace = blockScoping.run();
	        if (replace) path.replaceWith(replace);
	      },
	      CatchClause: function CatchClause(path, file) {
	        var parent = path.parent,
	            scope = path.scope;
	
	        var blockScoping = new BlockScoping(null, path.get("body"), parent, scope, file);
	        blockScoping.run();
	      },
	      "BlockStatement|SwitchStatement|Program": function BlockStatementSwitchStatementProgram(path, file) {
	        if (!ignoreBlock(path)) {
	          var blockScoping = new BlockScoping(null, path, path.parent, path.scope, file);
	          blockScoping.run();
	        }
	      }
	    }
	  };
	};
	
	var _babelTraverse = __webpack_require__(91);
	
	var _babelTraverse2 = _interopRequireDefault(_babelTraverse);
	
	var _tdz = __webpack_require__(930);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	var _values = __webpack_require__(696);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extend = __webpack_require__(4318);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _babelTemplate = __webpack_require__(84);
	
	var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ignoreBlock(path) {
	  return t.isLoop(path.parent) || t.isCatchClause(path.parent);
	}
	
	var buildRetCheck = (0, _babelTemplate2.default)("\n  if (typeof RETURN === \"object\") return RETURN.v;\n");
	
	function isBlockScoped(node) {
	  if (!t.isVariableDeclaration(node)) return false;
	  if (node[t.BLOCK_SCOPED_SYMBOL]) return true;
	  if (node.kind !== "let" && node.kind !== "const") return false;
	  return true;
	}
	
	function convertBlockScopedToVar(path, node, parent, scope) {
	  var moveBindingsToParent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  if (!node) {
	    node = path.node;
	  }
	
	  if (!t.isFor(parent)) {
	    for (var i = 0; i < node.declarations.length; i++) {
	      var declar = node.declarations[i];
	      declar.init = declar.init || scope.buildUndefinedNode();
	    }
	  }
	
	  node[t.BLOCK_SCOPED_SYMBOL] = true;
	  node.kind = "var";
	
	  if (moveBindingsToParent) {
	    var parentScope = scope.getFunctionParent();
	    var ids = path.getBindingIdentifiers();
	    for (var name in ids) {
	      var binding = scope.getOwnBinding(name);
	      if (binding) binding.kind = "var";
	      scope.moveBindingTo(name, parentScope);
	    }
	  }
	}
	
	function isVar(node) {
	  return t.isVariableDeclaration(node, { kind: "var" }) && !isBlockScoped(node);
	}
	
	var letReferenceBlockVisitor = _babelTraverse2.default.visitors.merge([{
	  Loop: {
	    enter: function enter(path, state) {
	      state.loopDepth++;
	    },
	    exit: function exit(path, state) {
	      state.loopDepth--;
	    }
	  },
	  Function: function Function(path, state) {
	    if (state.loopDepth > 0) {
	      path.traverse(letReferenceFunctionVisitor, state);
	    }
	    return path.skip();
	  }
	}, _tdz.visitor]);
	
	var letReferenceFunctionVisitor = _babelTraverse2.default.visitors.merge([{
	  ReferencedIdentifier: function ReferencedIdentifier(path, state) {
	    var ref = state.letReferences[path.node.name];
	
	    if (!ref) return;
	
	    var localBinding = path.scope.getBindingIdentifier(path.node.name);
	    if (localBinding && localBinding !== ref) return;
	
	    state.closurify = true;
	  }
	}, _tdz.visitor]);
	
	var hoistVarDeclarationsVisitor = {
	  enter: function enter(path, self) {
	    var node = path.node,
	        parent = path.parent;
	
	
	    if (path.isForStatement()) {
	      if (isVar(node.init, node)) {
	        var nodes = self.pushDeclar(node.init);
	        if (nodes.length === 1) {
	          node.init = nodes[0];
	        } else {
	          node.init = t.sequenceExpression(nodes);
	        }
	      }
	    } else if (path.isFor()) {
	      if (isVar(node.left, node)) {
	        self.pushDeclar(node.left);
	        node.left = node.left.declarations[0].id;
	      }
	    } else if (isVar(node, parent)) {
	      path.replaceWithMultiple(self.pushDeclar(node).map(function (expr) {
	        return t.expressionStatement(expr);
	      }));
	    } else if (path.isFunction()) {
	      return path.skip();
	    }
	  }
	};
	
	var loopLabelVisitor = {
	  LabeledStatement: function LabeledStatement(_ref, state) {
	    var node = _ref.node;
	
	    state.innerLabels.push(node.label.name);
	  }
	};
	
	var continuationVisitor = {
	  enter: function enter(path, state) {
	    if (path.isAssignmentExpression() || path.isUpdateExpression()) {
	      var bindings = path.getBindingIdentifiers();
	      for (var name in bindings) {
	        if (state.outsideReferences[name] !== path.scope.getBindingIdentifier(name)) continue;
	        state.reassignments[name] = true;
	      }
	    }
	  }
	};
	
	function loopNodeTo(node) {
	  if (t.isBreakStatement(node)) {
	    return "break";
	  } else if (t.isContinueStatement(node)) {
	    return "continue";
	  }
	}
	
	var loopVisitor = {
	  Loop: function Loop(path, state) {
	    var oldIgnoreLabeless = state.ignoreLabeless;
	    state.ignoreLabeless = true;
	    path.traverse(loopVisitor, state);
	    state.ignoreLabeless = oldIgnoreLabeless;
	    path.skip();
	  },
	  Function: function Function(path) {
	    path.skip();
	  },
	  SwitchCase: function SwitchCase(path, state) {
	    var oldInSwitchCase = state.inSwitchCase;
	    state.inSwitchCase = true;
	    path.traverse(loopVisitor, state);
	    state.inSwitchCase = oldInSwitchCase;
	    path.skip();
	  },
	  "BreakStatement|ContinueStatement|ReturnStatement": function BreakStatementContinueStatementReturnStatement(path, state) {
	    var node = path.node,
	        parent = path.parent,
	        scope = path.scope;
	
	    if (node[this.LOOP_IGNORE]) return;
	
	    var replace = void 0;
	    var loopText = loopNodeTo(node);
	
	    if (loopText) {
	      if (node.label) {
	        if (state.innerLabels.indexOf(node.label.name) >= 0) {
	          return;
	        }
	
	        loopText = loopText + "|" + node.label.name;
	      } else {
	        if (state.ignoreLabeless) return;
	
	        if (state.inSwitchCase) return;
	
	        if (t.isBreakStatement(node) && t.isSwitchCase(parent)) return;
	      }
	
	      state.hasBreakContinue = true;
	      state.map[loopText] = node;
	      replace = t.stringLiteral(loopText);
	    }
	
	    if (path.isReturnStatement()) {
	      state.hasReturn = true;
	      replace = t.objectExpression([t.objectProperty(t.identifier("v"), node.argument || scope.buildUndefinedNode())]);
	    }
	
	    if (replace) {
	      replace = t.returnStatement(replace);
	      replace[this.LOOP_IGNORE] = true;
	      path.skip();
	      path.replaceWith(t.inherits(replace, node));
	    }
	  }
	};
	
	var BlockScoping = function () {
	  function BlockScoping(loopPath, blockPath, parent, scope, file) {
	    (0, _classCallCheck3.default)(this, BlockScoping);
	
	    this.parent = parent;
	    this.scope = scope;
	    this.file = file;
	
	    this.blockPath = blockPath;
	    this.block = blockPath.node;
	
	    this.outsideLetReferences = (0, _create2.default)(null);
	    this.hasLetReferences = false;
	    this.letReferences = (0, _create2.default)(null);
	    this.body = [];
	
	    if (loopPath) {
	      this.loopParent = loopPath.parent;
	      this.loopLabel = t.isLabeledStatement(this.loopParent) && this.loopParent.label;
	      this.loopPath = loopPath;
	      this.loop = loopPath.node;
	    }
	  }
	
	  BlockScoping.prototype.run = function run() {
	    var block = this.block;
	    if (block._letDone) return;
	    block._letDone = true;
	
	    var needsClosure = this.getLetReferences();
	
	    if (t.isFunction(this.parent) || t.isProgram(this.block)) {
	      this.updateScopeInfo();
	      return;
	    }
	
	    if (!this.hasLetReferences) return;
	
	    if (needsClosure) {
	      this.wrapClosure();
	    } else {
	      this.remap();
	    }
	
	    this.updateScopeInfo(needsClosure);
	
	    if (this.loopLabel && !t.isLabeledStatement(this.loopParent)) {
	      return t.labeledStatement(this.loopLabel, this.loop);
	    }
	  };
	
	  BlockScoping.prototype.updateScopeInfo = function updateScopeInfo(wrappedInClosure) {
	    var scope = this.scope;
	    var parentScope = scope.getFunctionParent();
	    var letRefs = this.letReferences;
	
	    for (var key in letRefs) {
	      var ref = letRefs[key];
	      var binding = scope.getBinding(ref.name);
	      if (!binding) continue;
	      if (binding.kind === "let" || binding.kind === "const") {
	        binding.kind = "var";
	
	        if (wrappedInClosure) {
	          scope.removeBinding(ref.name);
	        } else {
	          scope.moveBindingTo(ref.name, parentScope);
	        }
	      }
	    }
	  };
	
	  BlockScoping.prototype.remap = function remap() {
	    var letRefs = this.letReferences;
	    var scope = this.scope;
	
	    for (var key in letRefs) {
	      var ref = letRefs[key];
	
	      if (scope.parentHasBinding(key) || scope.hasGlobal(key)) {
	        if (scope.hasOwnBinding(key)) scope.rename(ref.name);
	
	        if (this.blockPath.scope.hasOwnBinding(key)) this.blockPath.scope.rename(ref.name);
	      }
	    }
	  };
	
	  BlockScoping.prototype.wrapClosure = function wrapClosure() {
	    if (this.file.opts.throwIfClosureRequired) {
	      throw this.blockPath.buildCodeFrameError("Compiling let/const in this block would add a closure " + "(throwIfClosureRequired).");
	    }
	    var block = this.block;
	
	    var outsideRefs = this.outsideLetReferences;
	
	    if (this.loop) {
	      for (var name in outsideRefs) {
	        var id = outsideRefs[name];
	
	        if (this.scope.hasGlobal(id.name) || this.scope.parentHasBinding(id.name)) {
	          delete outsideRefs[id.name];
	          delete this.letReferences[id.name];
	
	          this.scope.rename(id.name);
	
	          this.letReferences[id.name] = id;
	          outsideRefs[id.name] = id;
	        }
	      }
	    }
	
	    this.has = this.checkLoop();
	
	    this.hoistVarDeclarations();
	
	    var params = (0, _values2.default)(outsideRefs);
	    var args = (0, _values2.default)(outsideRefs);
	
	    var isSwitch = this.blockPath.isSwitchStatement();
	
	    var fn = t.functionExpression(null, params, t.blockStatement(isSwitch ? [block] : block.body));
	    fn.shadow = true;
	
	    this.addContinuations(fn);
	
	    var ref = fn;
	
	    if (this.loop) {
	      ref = this.scope.generateUidIdentifier("loop");
	      this.loopPath.insertBefore(t.variableDeclaration("var", [t.variableDeclarator(ref, fn)]));
	    }
	
	    var call = t.callExpression(ref, args);
	    var ret = this.scope.generateUidIdentifier("ret");
	
	    var hasYield = _babelTraverse2.default.hasType(fn.body, this.scope, "YieldExpression", t.FUNCTION_TYPES);
	    if (hasYield) {
	      fn.generator = true;
	      call = t.yieldExpression(call, true);
	    }
	
	    var hasAsync = _babelTraverse2.default.hasType(fn.body, this.scope, "AwaitExpression", t.FUNCTION_TYPES);
	    if (hasAsync) {
	      fn.async = true;
	      call = t.awaitExpression(call);
	    }
	
	    this.buildClosure(ret, call);
	
	    if (isSwitch) this.blockPath.replaceWithMultiple(this.body);else block.body = this.body;
	  };
	
	  BlockScoping.prototype.buildClosure = function buildClosure(ret, call) {
	    var has = this.has;
	    if (has.hasReturn || has.hasBreakContinue) {
	      this.buildHas(ret, call);
	    } else {
	      this.body.push(t.expressionStatement(call));
	    }
	  };
	
	  BlockScoping.prototype.addContinuations = function addContinuations(fn) {
	    var state = {
	      reassignments: {},
	      outsideReferences: this.outsideLetReferences
	    };
	
	    this.scope.traverse(fn, continuationVisitor, state);
	
	    for (var i = 0; i < fn.params.length; i++) {
	      var param = fn.params[i];
	      if (!state.reassignments[param.name]) continue;
	
	      var newParam = this.scope.generateUidIdentifier(param.name);
	      fn.params[i] = newParam;
	
	      this.scope.rename(param.name, newParam.name, fn);
	
	      fn.body.body.push(t.expressionStatement(t.assignmentExpression("=", param, newParam)));
	    }
	  };
	
	  BlockScoping.prototype.getLetReferences = function getLetReferences() {
	    var _this = this;
	
	    var block = this.block;
	
	    var declarators = [];
	
	    if (this.loop) {
	      var init = this.loop.left || this.loop.init;
	      if (isBlockScoped(init)) {
	        declarators.push(init);
	        (0, _extend2.default)(this.outsideLetReferences, t.getBindingIdentifiers(init));
	      }
	    }
	
	    var addDeclarationsFromChild = function addDeclarationsFromChild(path, node) {
	      node = node || path.node;
	      if (t.isClassDeclaration(node) || t.isFunctionDeclaration(node) || isBlockScoped(node)) {
	        if (isBlockScoped(node)) {
	          convertBlockScopedToVar(path, node, block, _this.scope);
	        }
	        declarators = declarators.concat(node.declarations || node);
	      }
	      if (t.isLabeledStatement(node)) {
	        addDeclarationsFromChild(path.get("body"), node.body);
	      }
	    };
	
	    if (block.body) {
	      for (var i = 0; i < block.body.length; i++) {
	        var declarPath = this.blockPath.get("body")[i];
	        addDeclarationsFromChild(declarPath);
	      }
	    }
	
	    if (block.cases) {
	      for (var _i = 0; _i < block.cases.length; _i++) {
	        var consequents = block.cases[_i].consequent;
	
	        for (var j = 0; j < consequents.length; j++) {
	          var _declarPath = this.blockPath.get("cases")[_i];
	          var declar = consequents[j];
	          addDeclarationsFromChild(_declarPath, declar);
	        }
	      }
	    }
	
	    for (var _i2 = 0; _i2 < declarators.length; _i2++) {
	      var _declar = declarators[_i2];
	
	      var keys = t.getBindingIdentifiers(_declar, false, true);
	      (0, _extend2.default)(this.letReferences, keys);
	      this.hasLetReferences = true;
	    }
	
	    if (!this.hasLetReferences) return;
	
	    var state = {
	      letReferences: this.letReferences,
	      closurify: false,
	      file: this.file,
	      loopDepth: 0
	    };
	
	    var loopOrFunctionParent = this.blockPath.find(function (path) {
	      return path.isLoop() || path.isFunction();
	    });
	    if (loopOrFunctionParent && loopOrFunctionParent.isLoop()) {
	      state.loopDepth++;
	    }
	
	    this.blockPath.traverse(letReferenceBlockVisitor, state);
	
	    return state.closurify;
	  };
	
	  BlockScoping.prototype.checkLoop = function checkLoop() {
	    var state = {
	      hasBreakContinue: false,
	      ignoreLabeless: false,
	      inSwitchCase: false,
	      innerLabels: [],
	      hasReturn: false,
	      isLoop: !!this.loop,
	      map: {},
	      LOOP_IGNORE: (0, _symbol2.default)()
	    };
	
	    this.blockPath.traverse(loopLabelVisitor, state);
	    this.blockPath.traverse(loopVisitor, state);
	
	    return state;
	  };
	
	  BlockScoping.prototype.hoistVarDeclarations = function hoistVarDeclarations() {
	    this.blockPath.traverse(hoistVarDeclarationsVisitor, this);
	  };
	
	  BlockScoping.prototype.pushDeclar = function pushDeclar(node) {
	    var declars = [];
	    var names = t.getBindingIdentifiers(node);
	    for (var name in names) {
	      declars.push(t.variableDeclarator(names[name]));
	    }
	
	    this.body.push(t.variableDeclaration(node.kind, declars));
	
	    var replace = [];
	
	    for (var i = 0; i < node.declarations.length; i++) {
	      var declar = node.declarations[i];
	      if (!declar.init) continue;
	
	      var expr = t.assignmentExpression("=", declar.id, declar.init);
	      replace.push(t.inherits(expr, declar));
	    }
	
	    return replace;
	  };
	
	  BlockScoping.prototype.buildHas = function buildHas(ret, call) {
	    var body = this.body;
	
	    body.push(t.variableDeclaration("var", [t.variableDeclarator(ret, call)]));
	
	    var retCheck = void 0;
	    var has = this.has;
	    var cases = [];
	
	    if (has.hasReturn) {
	      retCheck = buildRetCheck({
	        RETURN: ret
	      });
	    }
	
	    if (has.hasBreakContinue) {
	      for (var key in has.map) {
	        cases.push(t.switchCase(t.stringLiteral(key), [has.map[key]]));
	      }
	
	      if (has.hasReturn) {
	        cases.push(t.switchCase(null, [retCheck]));
	      }
	
	      if (cases.length === 1) {
	        var single = cases[0];
	        body.push(t.ifStatement(t.binaryExpression("===", ret, single.test), single.consequent[0]));
	      } else {
	        if (this.loop) {
	          for (var i = 0; i < cases.length; i++) {
	            var caseConsequent = cases[i].consequent[0];
	            if (t.isBreakStatement(caseConsequent) && !caseConsequent.label) {
	              caseConsequent.label = this.loopLabel = this.loopLabel || this.scope.generateUidIdentifier("loop");
	            }
	          }
	        }
	
	        body.push(t.switchStatement(ret, cases));
	      }
	    } else {
	      if (has.hasReturn) {
	        body.push(retCheck);
	      }
	    }
	  };
	
	  return BlockScoping;
	}();
	
	module.exports = exports["default"];

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.visitor = undefined;
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function getTDZStatus(refPath, bindingPath) {
	  var executionStatus = bindingPath._guessExecutionStatusRelativeTo(refPath);
	
	  if (executionStatus === "before") {
	    return "inside";
	  } else if (executionStatus === "after") {
	    return "outside";
	  } else {
	    return "maybe";
	  }
	}
	
	function buildTDZAssert(node, file) {
	  return t.callExpression(file.addHelper("temporalRef"), [node, t.stringLiteral(node.name), file.addHelper("temporalUndefined")]);
	}
	
	function isReference(node, scope, state) {
	  var declared = state.letReferences[node.name];
	  if (!declared) return false;
	
	  return scope.getBindingIdentifier(node.name) === declared;
	}
	
	var visitor = exports.visitor = {
	  ReferencedIdentifier: function ReferencedIdentifier(path, state) {
	    if (!this.file.opts.tdz) return;
	
	    var node = path.node,
	        parent = path.parent,
	        scope = path.scope;
	
	
	    if (path.parentPath.isFor({ left: node })) return;
	    if (!isReference(node, scope, state)) return;
	
	    var bindingPath = scope.getBinding(node.name).path;
	
	    var status = getTDZStatus(path, bindingPath);
	    if (status === "inside") return;
	
	    if (status === "maybe") {
	      var assert = buildTDZAssert(node, state.file);
	
	      bindingPath.parent._tdzThis = true;
	
	      path.skip();
	
	      if (path.parentPath.isUpdateExpression()) {
	        if (parent._ignoreBlockScopingTDZ) return;
	        path.parentPath.replaceWith(t.sequenceExpression([assert, parent]));
	      } else {
	        path.replaceWith(assert);
	      }
	    } else if (status === "outside") {
	      path.replaceWith(t.throwStatement(t.inherits(t.newExpression(t.identifier("ReferenceError"), [t.stringLiteral(node.name + " is not defined - temporal dead zone")]), node)));
	    }
	  },
	
	
	  AssignmentExpression: {
	    exit: function exit(path, state) {
	      if (!this.file.opts.tdz) return;
	
	      var node = path.node;
	
	      if (node._ignoreBlockScopingTDZ) return;
	
	      var nodes = [];
	      var ids = path.getBindingIdentifiers();
	
	      for (var name in ids) {
	        var id = ids[name];
	
	        if (isReference(id, path.scope, state)) {
	          nodes.push(buildTDZAssert(id, state.file));
	        }
	      }
	
	      if (nodes.length) {
	        node._ignoreBlockScopingTDZ = true;
	        nodes.push(node);
	        path.replaceWithMultiple(nodes.map(t.expressionStatement));
	      }
	    }
	  }
	};

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _symbol = __webpack_require__(83);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	exports.default = function (_ref) {
	  var t = _ref.types;
	
	  var VISITED = (0, _symbol2.default)();
	
	  return {
	    visitor: {
	      ExportDefaultDeclaration: function ExportDefaultDeclaration(path) {
	        if (!path.get("declaration").isClassDeclaration()) return;
	
	        var node = path.node;
	
	        var ref = node.declaration.id || path.scope.generateUidIdentifier("class");
	        node.declaration.id = ref;
	
	        path.replaceWith(node.declaration);
	        path.insertAfter(t.exportDefaultDeclaration(ref));
	      },
	      ClassDeclaration: function ClassDeclaration(path) {
	        var node = path.node;
	
	
	        var ref = node.id || path.scope.generateUidIdentifier("class");
	
	        path.replaceWith(t.variableDeclaration("let", [t.variableDeclarator(ref, t.toExpression(node))]));
	      },
	      ClassExpression: function ClassExpression(path, state) {
	        var node = path.node;
	
	        if (node[VISITED]) return;
	
	        var inferred = (0, _babelHelperFunctionName2.default)(path);
	        if (inferred && inferred !== node) return path.replaceWith(inferred);
	
	        node[VISITED] = true;
	
	        var Constructor = _vanilla2.default;
	        if (state.opts.loose) Constructor = _loose2.default;
	
	        path.replaceWith(new Constructor(path, state.file).run());
	      }
	    }
	  };
	};
	
	var _loose = __webpack_require__(932);
	
	var _loose2 = _interopRequireDefault(_loose);
	
	var _vanilla = __webpack_require__(545);
	
	var _vanilla2 = _interopRequireDefault(_vanilla);
	
	var _babelHelperFunctionName = __webpack_require__(276);
	
	var _babelHelperFunctionName2 = _interopRequireDefault(_babelHelperFunctionName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _babelHelperFunctionName = __webpack_require__(276);
	
	var _babelHelperFunctionName2 = _interopRequireDefault(_babelHelperFunctionName);
	
	var _vanilla = __webpack_require__(545);
	
	var _vanilla2 = _interopRequireDefault(_vanilla);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LooseClassTransformer = function (_VanillaTransformer) {
	  (0, _inherits3.default)(LooseClassTransformer, _VanillaTransformer);
	
	  function LooseClassTransformer() {
	    (0, _classCallCheck3.default)(this, LooseClassTransformer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _VanillaTransformer.apply(this, arguments));
	
	    _this.isLoose = true;
	    return _this;
	  }
	
	  LooseClassTransformer.prototype._processMethod = function _processMethod(node, scope) {
	    if (!node.decorators) {
	
	      var classRef = this.classRef;
	      if (!node.static) classRef = t.memberExpression(classRef, t.identifier("prototype"));
	      var methodName = t.memberExpression(classRef, node.key, node.computed || t.isLiteral(node.key));
	
	      var func = t.functionExpression(null, node.params, node.body, node.generator, node.async);
	      func.returnType = node.returnType;
	      var key = t.toComputedKey(node, node.key);
	      if (t.isStringLiteral(key)) {
	        func = (0, _babelHelperFunctionName2.default)({
	          node: func,
	          id: key,
	          scope: scope
	        });
	      }
	
	      var expr = t.expressionStatement(t.assignmentExpression("=", methodName, func));
	      t.inheritsComments(expr, node);
	      this.body.push(expr);
	      return true;
	    }
	  };
	
	  return LooseClassTransformer;
	}(_vanilla2.default);
	
	exports.default = LooseClassTransformer;
	module.exports = exports["default"];

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = function (_ref) {
	  var t = _ref.types,
	      template = _ref.template;
	
	  var buildMutatorMapAssign = template("\n    MUTATOR_MAP_REF[KEY] = MUTATOR_MAP_REF[KEY] || {};\n    MUTATOR_MAP_REF[KEY].KIND = VALUE;\n  ");
	
	  function getValue(prop) {
	    if (t.isObjectProperty(prop)) {
	      return prop.value;
	    } else if (t.isObjectMethod(prop)) {
	      return t.functionExpression(null, prop.params, prop.body, prop.generator, prop.async);
	    }
	  }
	
	  function pushAssign(objId, prop, body) {
	    if (prop.kind === "get" && prop.kind === "set") {
	      pushMutatorDefine(objId, prop, body);
	    } else {
	      body.push(t.expressionStatement(t.assignmentExpression("=", t.memberExpression(objId, prop.key, prop.computed || t.isLiteral(prop.key)), getValue(prop))));
	    }
	  }
	
	  function pushMutatorDefine(_ref2, prop) {
	    var objId = _ref2.objId,
	        body = _ref2.body,
	        getMutatorId = _ref2.getMutatorId,
	        scope = _ref2.scope;
	
	    var key = !prop.computed && t.isIdentifier(prop.key) ? t.stringLiteral(prop.key.name) : prop.key;
	
	    var maybeMemoise = scope.maybeGenerateMemoised(key);
	    if (maybeMemoise) {
	      body.push(t.expressionStatement(t.assignmentExpression("=", maybeMemoise, key)));
	      key = maybeMemoise;
	    }
	
	    body.push.apply(body, buildMutatorMapAssign({
	      MUTATOR_MAP_REF: getMutatorId(),
	      KEY: key,
	      VALUE: getValue(prop),
	      KIND: t.identifier(prop.kind)
	    }));
	  }
	
	  function loose(info) {
	    for (var _iterator = info.computedProps, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	      var _ref3;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref3 = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref3 = _i.value;
	      }
	
	      var prop = _ref3;
	
	      if (prop.kind === "get" || prop.kind === "set") {
	        pushMutatorDefine(info, prop);
	      } else {
	        pushAssign(info.objId, prop, info.body);
	      }
	    }
	  }
	
	  function spec(info) {
	    var objId = info.objId,
	        body = info.body,
	        computedProps = info.computedProps,
	        state = info.state;
	
	
	    for (var _iterator2 = computedProps, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	      var _ref4;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref4 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref4 = _i2.value;
	      }
	
	      var prop = _ref4;
	
	      var key = t.toComputedKey(prop);
	
	      if (prop.kind === "get" || prop.kind === "set") {
	        pushMutatorDefine(info, prop);
	      } else if (t.isStringLiteral(key, { value: "__proto__" })) {
	        pushAssign(objId, prop, body);
	      } else {
	        if (computedProps.length === 1) {
	          return t.callExpression(state.addHelper("defineProperty"), [info.initPropExpression, key, getValue(prop)]);
	        } else {
	          body.push(t.expressionStatement(t.callExpression(state.addHelper("defineProperty"), [objId, key, getValue(prop)])));
	        }
	      }
	    }
	  }
	
	  return {
	    visitor: {
	      ObjectExpression: {
	        exit: function exit(path, state) {
	          var node = path.node,
	              parent = path.parent,
	              scope = path.scope;
	
	          var hasComputed = false;
	          for (var _iterator3 = node.properties, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
	            var _ref5;
	
	            if (_isArray3) {
	              if (_i3 >= _iterator3.length) break;
	              _ref5 = _iterator3[_i3++];
	            } else {
	              _i3 = _iterator3.next();
	              if (_i3.done) break;
	              _ref5 = _i3.value;
	            }
	
	            var prop = _ref5;
	
	            hasComputed = prop.computed === true;
	            if (hasComputed) break;
	          }
	          if (!hasComputed) return;
	
	          var initProps = [];
	          var computedProps = [];
	          var foundComputed = false;
	
	          for (var _iterator4 = node.properties, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
	            var _ref6;
	
	            if (_isArray4) {
	              if (_i4 >= _iterator4.length) break;
	              _ref6 = _iterator4[_i4++];
	            } else {
	              _i4 = _iterator4.next();
	              if (_i4.done) break;
	              _ref6 = _i4.value;
	            }
	
	            var _prop = _ref6;
	
	            if (_prop.computed) {
	              foundComputed = true;
	            }
	
	            if (foundComputed) {
	              computedProps.push(_prop);
	            } else {
	              initProps.push(_prop);
	            }
	          }
	
	          var objId = scope.generateUidIdentifierBasedOnNode(parent);
	          var initPropExpression = t.objectExpression(initProps);
	          var body = [];
	
	          body.push(t.variableDeclaration("var", [t.variableDeclarator(objId, initPropExpression)]));
	
	          var callback = spec;
	          if (state.opts.loose) callback = loose;
	
	          var mutatorRef = void 0;
	
	          var getMutatorId = function getMutatorId() {
	            if (!mutatorRef) {
	              mutatorRef = scope.generateUidIdentifier("mutatorMap");
	
	              body.push(t.variableDeclaration("var", [t.variableDeclarator(mutatorRef, t.objectExpression([]))]));
	            }
	
	            return mutatorRef;
	          };
	
	          var single = callback({
	            scope: scope,
	            objId: objId,
	            body: body,
	            computedProps: computedProps,
	            initPropExpression: initPropExpression,
	            getMutatorId: getMutatorId,
	            state: state
	          });
	
	          if (mutatorRef) {
	            body.push(t.expressionStatement(t.callExpression(state.addHelper("defineEnumerableProperties"), [objId, mutatorRef])));
	          }
	
	          if (single) {
	            path.replaceWith(single);
	          } else {
	            body.push(t.expressionStatement(objId));
	            path.replaceWithMultiple(body);
	          }
	        }
	      }
	    }
	  };
	};
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = function (_ref) {
	  var t = _ref.types;
	
	
	  function variableDeclarationHasPattern(node) {
	    for (var _iterator = node.declarations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	      var _ref2;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref2 = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref2 = _i.value;
	      }
	
	      var declar = _ref2;
	
	      if (t.isPattern(declar.id)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  function hasRest(pattern) {
	    for (var _iterator2 = pattern.elements, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	      var _ref3;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref3 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref3 = _i2.value;
	      }
	
	      var elem = _ref3;
	
	      if (t.isRestElement(elem)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  var arrayUnpackVisitor = {
	    ReferencedIdentifier: function ReferencedIdentifier(path, state) {
	      if (state.bindings[path.node.name]) {
	        state.deopt = true;
	        path.stop();
	      }
	    }
	  };
	
	  var DestructuringTransformer = function () {
	    function DestructuringTransformer(opts) {
	      (0, _classCallCheck3.default)(this, DestructuringTransformer);
	
	      this.blockHoist = opts.blockHoist;
	      this.operator = opts.operator;
	      this.arrays = {};
	      this.nodes = opts.nodes || [];
	      this.scope = opts.scope;
	      this.file = opts.file;
	      this.kind = opts.kind;
	    }
	
	    DestructuringTransformer.prototype.buildVariableAssignment = function buildVariableAssignment(id, init) {
	      var op = this.operator;
	      if (t.isMemberExpression(id)) op = "=";
	
	      var node = void 0;
	
	      if (op) {
	        node = t.expressionStatement(t.assignmentExpression(op, id, init));
	      } else {
	        node = t.variableDeclaration(this.kind, [t.variableDeclarator(id, init)]);
	      }
	
	      node._blockHoist = this.blockHoist;
	
	      return node;
	    };
	
	    DestructuringTransformer.prototype.buildVariableDeclaration = function buildVariableDeclaration(id, init) {
	      var declar = t.variableDeclaration("var", [t.variableDeclarator(id, init)]);
	      declar._blockHoist = this.blockHoist;
	      return declar;
	    };
	
	    DestructuringTransformer.prototype.push = function push(id, init) {
	      if (t.isObjectPattern(id)) {
	        this.pushObjectPattern(id, init);
	      } else if (t.isArrayPattern(id)) {
	        this.pushArrayPattern(id, init);
	      } else if (t.isAssignmentPattern(id)) {
	        this.pushAssignmentPattern(id, init);
	      } else {
	        this.nodes.push(this.buildVariableAssignment(id, init));
	      }
	    };
	
	    DestructuringTransformer.prototype.toArray = function toArray(node, count) {
	      if (this.file.opts.loose || t.isIdentifier(node) && this.arrays[node.name]) {
	        return node;
	      } else {
	        return this.scope.toArray(node, count);
	      }
	    };
	
	    DestructuringTransformer.prototype.pushAssignmentPattern = function pushAssignmentPattern(pattern, valueRef) {
	
	      var tempValueRef = this.scope.generateUidIdentifierBasedOnNode(valueRef);
	
	      var declar = t.variableDeclaration("var", [t.variableDeclarator(tempValueRef, valueRef)]);
	      declar._blockHoist = this.blockHoist;
	      this.nodes.push(declar);
	
	      var tempConditional = t.conditionalExpression(t.binaryExpression("===", tempValueRef, t.identifier("undefined")), pattern.right, tempValueRef);
	
	      var left = pattern.left;
	      if (t.isPattern(left)) {
	        var tempValueDefault = t.expressionStatement(t.assignmentExpression("=", tempValueRef, tempConditional));
	        tempValueDefault._blockHoist = this.blockHoist;
	
	        this.nodes.push(tempValueDefault);
	        this.push(left, tempValueRef);
	      } else {
	        this.nodes.push(this.buildVariableAssignment(left, tempConditional));
	      }
	    };
	
	    DestructuringTransformer.prototype.pushObjectRest = function pushObjectRest(pattern, objRef, spreadProp, spreadPropIndex) {
	
	      var keys = [];
	
	      for (var i = 0; i < pattern.properties.length; i++) {
	        var prop = pattern.properties[i];
	
	        if (i >= spreadPropIndex) break;
	
	        if (t.isRestProperty(prop)) continue;
	
	        var key = prop.key;
	        if (t.isIdentifier(key) && !prop.computed) key = t.stringLiteral(prop.key.name);
	        keys.push(key);
	      }
	
	      keys = t.arrayExpression(keys);
	
	      var value = t.callExpression(this.file.addHelper("objectWithoutProperties"), [objRef, keys]);
	      this.nodes.push(this.buildVariableAssignment(spreadProp.argument, value));
	    };
	
	    DestructuringTransformer.prototype.pushObjectProperty = function pushObjectProperty(prop, propRef) {
	      if (t.isLiteral(prop.key)) prop.computed = true;
	
	      var pattern = prop.value;
	      var objRef = t.memberExpression(propRef, prop.key, prop.computed);
	
	      if (t.isPattern(pattern)) {
	        this.push(pattern, objRef);
	      } else {
	        this.nodes.push(this.buildVariableAssignment(pattern, objRef));
	      }
	    };
	
	    DestructuringTransformer.prototype.pushObjectPattern = function pushObjectPattern(pattern, objRef) {
	
	      if (!pattern.properties.length) {
	        this.nodes.push(t.expressionStatement(t.callExpression(this.file.addHelper("objectDestructuringEmpty"), [objRef])));
	      }
	
	      if (pattern.properties.length > 1 && !this.scope.isStatic(objRef)) {
	        var temp = this.scope.generateUidIdentifierBasedOnNode(objRef);
	        this.nodes.push(this.buildVariableDeclaration(temp, objRef));
	        objRef = temp;
	      }
	
	      for (var i = 0; i < pattern.properties.length; i++) {
	        var prop = pattern.properties[i];
	        if (t.isRestProperty(prop)) {
	          this.pushObjectRest(pattern, objRef, prop, i);
	        } else {
	          this.pushObjectProperty(prop, objRef);
	        }
	      }
	    };
	
	    DestructuringTransformer.prototype.canUnpackArrayPattern = function canUnpackArrayPattern(pattern, arr) {
	      if (!t.isArrayExpression(arr)) return false;
	
	      if (pattern.elements.length > arr.elements.length) return;
	      if (pattern.elements.length < arr.elements.length && !hasRest(pattern)) return false;
	
	      for (var _iterator3 = pattern.elements, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
	        var _ref4;
	
	        if (_isArray3) {
	          if (_i3 >= _iterator3.length) break;
	          _ref4 = _iterator3[_i3++];
	        } else {
	          _i3 = _iterator3.next();
	          if (_i3.done) break;
	          _ref4 = _i3.value;
	        }
	
	        var elem = _ref4;
	
	        if (!elem) return false;
	
	        if (t.isMemberExpression(elem)) return false;
	      }
	
	      for (var _iterator4 = arr.elements, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
	        var _ref5;
	
	        if (_isArray4) {
	          if (_i4 >= _iterator4.length) break;
	          _ref5 = _iterator4[_i4++];
	        } else {
	          _i4 = _iterator4.next();
	          if (_i4.done) break;
	          _ref5 = _i4.value;
	        }
	
	        var _elem = _ref5;
	
	        if (t.isSpreadElement(_elem)) return false;
	
	        if (t.isCallExpression(_elem)) return false;
	
	        if (t.isMemberExpression(_elem)) return false;
	      }
	
	      var bindings = t.getBindingIdentifiers(pattern);
	      var state = { deopt: false, bindings: bindings };
	      this.scope.traverse(arr, arrayUnpackVisitor, state);
	      return !state.deopt;
	    };
	
	    DestructuringTransformer.prototype.pushUnpackedArrayPattern = function pushUnpackedArrayPattern(pattern, arr) {
	      for (var i = 0; i < pattern.elements.length; i++) {
	        var elem = pattern.elements[i];
	        if (t.isRestElement(elem)) {
	          this.push(elem.argument, t.arrayExpression(arr.elements.slice(i)));
	        } else {
	          this.push(elem, arr.elements[i]);
	        }
	      }
	    };
	
	    DestructuringTransformer.prototype.pushArrayPattern = function pushArrayPattern(pattern, arrayRef) {
	      if (!pattern.elements) return;
	
	      if (this.canUnpackArrayPattern(pattern, arrayRef)) {
	        return this.pushUnpackedArrayPattern(pattern, arrayRef);
	      }
	
	      var count = !hasRest(pattern) && pattern.elements.length;
	
	      var toArray = this.toArray(arrayRef, count);
	
	      if (t.isIdentifier(toArray)) {
	        arrayRef = toArray;
	      } else {
	        arrayRef = this.scope.generateUidIdentifierBasedOnNode(arrayRef);
	        this.arrays[arrayRef.name] = true;
	        this.nodes.push(this.buildVariableDeclaration(arrayRef, toArray));
	      }
	
	      for (var i = 0; i < pattern.elements.length; i++) {
	        var elem = pattern.elements[i];
	
	        if (!elem) continue;
	
	        var elemRef = void 0;
	
	        if (t.isRestElement(elem)) {
	          elemRef = this.toArray(arrayRef);
	          elemRef = t.callExpression(t.memberExpression(elemRef, t.identifier("slice")), [t.numericLiteral(i)]);
	
	          elem = elem.argument;
	        } else {
	          elemRef = t.memberExpression(arrayRef, t.numericLiteral(i), true);
	        }
	
	        this.push(elem, elemRef);
	      }
	    };
	
	    DestructuringTransformer.prototype.init = function init(pattern, ref) {
	
	      if (!t.isArrayExpression(ref) && !t.isMemberExpression(ref)) {
	        var memo = this.scope.maybeGenerateMemoised(ref, true);
	        if (memo) {
	          this.nodes.push(this.buildVariableDeclaration(memo, ref));
	          ref = memo;
	        }
	      }
	
	      this.push(pattern, ref);
	
	      return this.nodes;
	    };
	
	    return DestructuringTransformer;
	  }();
	
	  return {
	    visitor: {
	      ExportNamedDeclaration: function ExportNamedDeclaration(path) {
	        var declaration = path.get("declaration");
	        if (!declaration.isVariableDeclaration()) return;
	        if (!variableDeclarationHasPattern(declaration.node)) return;
	
	        var specifiers = [];
	
	        for (var name in path.getOuterBindingIdentifiers(path)) {
	          var id = t.identifier(name);
	          specifiers.push(t.exportSpecifier(id, id));
	        }
	
	        path.replaceWith(declaration.node);
	        path.insertAfter(t.exportNamedDeclaration(null, specifiers));
	      },
	      ForXStatement: function ForXStatement(path, file) {
	        var node = path.node,
	            scope = path.scope;
	
	        var left = node.left;
	
	        if (t.isPattern(left)) {
	
	          var temp = scope.generateUidIdentifier("ref");
	
	          node.left = t.variableDeclaration("var", [t.variableDeclarator(temp)]);
	
	          path.ensureBlock();
	
	          node.body.body.unshift(t.variableDeclaration("var", [t.variableDeclarator(left, temp)]));
	
	          return;
	        }
	
	        if (!t.isVariableDeclaration(left)) return;
	
	        var pattern = left.declarations[0].id;
	        if (!t.isPattern(pattern)) return;
	
	        var key = scope.generateUidIdentifier("ref");
	        node.left = t.variableDeclaration(left.kind, [t.variableDeclarator(key, null)]);
	
	        var nodes = [];
	
	        var destructuring = new DestructuringTransformer({
	          kind: left.kind,
	          file: file,
	          scope: scope,
	          nodes: nodes
	        });
	
	        destructuring.init(pattern, key);
	
	        path.ensureBlock();
	
	        var block = node.body;
	        block.body = nodes.concat(block.body);
	      },
	      CatchClause: function CatchClause(_ref6, file) {
	        var node = _ref6.node,
	            scope = _ref6.scope;
	
	        var pattern = node.param;
	        if (!t.isPattern(pattern)) return;
	
	        var ref = scope.generateUidIdentifier("ref");
	        node.param = ref;
	
	        var nodes = [];
	
	        var destructuring = new DestructuringTransformer({
	          kind: "let",
	          file: file,
	          scope: scope,
	          nodes: nodes
	        });
	        destructuring.init(pattern, ref);
	
	        node.body.body = nodes.concat(node.body.body);
	      },
	      AssignmentExpression: function AssignmentExpression(path, file) {
	        var node = path.node,
	            scope = path.scope;
	
	        if (!t.isPattern(node.left)) return;
	
	        var nodes = [];
	
	        var destructuring = new DestructuringTransformer({
	          operator: node.operator,
	          file: file,
	          scope: scope,
	          nodes: nodes
	        });
	
	        var ref = void 0;
	        if (path.isCompletionRecord() || !path.parentPath.isExpressionStatement()) {
	          ref = scope.generateUidIdentifierBasedOnNode(node.right, "ref");
	
	          nodes.push(t.variableDeclaration("var", [t.variableDeclarator(ref, node.right)]));
	
	          if (t.isArrayExpression(node.right)) {
	            destructuring.arrays[ref.name] = true;
	          }
	        }
	
	        destructuring.init(node.left, ref || node.right);
	
	        if (ref) {
	          nodes.push(t.expressionStatement(ref));
	        }
	
	        path.replaceWithMultiple(nodes);
	      },
	      VariableDeclaration: function VariableDeclaration(path, file) {
	        var node = path.node,
	            scope = path.scope,
	            parent = path.parent;
	
	        if (t.isForXStatement(parent)) return;
	        if (!parent || !path.container) return;
	        if (!variableDeclarationHasPattern(node)) return;
	
	        var nodes = [];
	        var declar = void 0;
	
	        for (var i = 0; i < node.declarations.length; i++) {
	          declar = node.declarations[i];
	
	          var patternId = declar.init;
	          var pattern = declar.id;
	
	          var destructuring = new DestructuringTransformer({
	            blockHoist: node._blockHoist,
	            nodes: nodes,
	            scope: scope,
	            kind: node.kind,
	            file: file
	          });
	
	          if (t.isPattern(pattern)) {
	            destructuring.init(pattern, patternId);
	
	            if (+i !== node.declarations.length - 1) {
	              t.inherits(nodes[nodes.length - 1], declar);
	            }
	          } else {
	            nodes.push(t.inherits(destructuring.buildVariableAssignment(declar.id, declar.init), declar));
	          }
	        }
	
	        var nodesOut = [];
	        for (var _iterator5 = nodes, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : (0, _getIterator3.default)(_iterator5);;) {
	          var _ref7;
	
	          if (_isArray5) {
	            if (_i5 >= _iterator5.length) break;
	            _ref7 = _iterator5[_i5++];
	          } else {
	            _i5 = _iterator5.next();
	            if (_i5.done) break;
	            _ref7 = _i5.value;
	          }
	
	          var _node = _ref7;
	
	          var tail = nodesOut[nodesOut.length - 1];
	          if (tail && t.isVariableDeclaration(tail) && t.isVariableDeclaration(_node) && tail.kind === _node.kind) {
	            var _tail$declarations;
	
	            (_tail$declarations = tail.declarations).push.apply(_tail$declarations, _node.declarations);
	          } else {
	            nodesOut.push(_node);
	          }
	        }
	
	        for (var _iterator6 = nodesOut, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : (0, _getIterator3.default)(_iterator6);;) {
	          var _ref8;
	
	          if (_isArray6) {
	            if (_i6 >= _iterator6.length) break;
	            _ref8 = _iterator6[_i6++];
	          } else {
	            _i6 = _iterator6.next();
	            if (_i6.done) break;
	            _ref8 = _i6.value;
	          }
	
	          var nodeOut = _ref8;
	
	          if (!nodeOut.declarations) continue;
	          for (var _iterator7 = nodeOut.declarations, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : (0, _getIterator3.default)(_iterator7);;) {
	            var _ref9;
	
	            if (_isArray7) {
	              if (_i7 >= _iterator7.length) break;
	              _ref9 = _iterator7[_i7++];
	            } else {
	              _i7 = _iterator7.next();
	              if (_i7.done) break;
	              _ref9 = _i7.value;
	            }
	
	            var declaration = _ref9;
	            var name = declaration.id.name;
	
	            if (scope.bindings[name]) {
	              scope.bindings[name].kind = nodeOut.kind;
	            }
	          }
	        }
	
	        if (nodesOut.length === 1) {
	          path.replaceWith(nodesOut[0]);
	        } else {
	          path.replaceWithMultiple(nodesOut);
	        }
	      }
	    }
	  };
	};
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _create = __webpack_require__(82);
	
	var _create2 = _interopRequireDefault(_create);
	
	exports.default = function () {
	  return {
	    visitor: {
	      ObjectExpression: function ObjectExpression(path) {
	        var node = path.node;
	
	        var plainProps = node.properties.filter(function (prop) {
	          return !t.isSpreadProperty(prop) && !prop.computed;
	        });
	
	        var alreadySeenData = (0, _create2.default)(null);
	        var alreadySeenGetters = (0, _create2.default)(null);
	        var alreadySeenSetters = (0, _create2.default)(null);
	
	        for (var _iterator = plainProps, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	          var _ref;
	
	          if (_isArray) {
	            if (_i >= _iterator.length) break;
	            _ref = _iterator[_i++];
	          } else {
	            _i = _iterator.next();
	            if (_i.done) break;
	            _ref = _i.value;
	          }
	
	          var prop = _ref;
	
	          var name = getName(prop.key);
	          var isDuplicate = false;
	          switch (prop.kind) {
	            case "get":
	              if (alreadySeenData[name] || alreadySeenGetters[name]) {
	                isDuplicate = true;
	              }
	              alreadySeenGetters[name] = true;
	              break;
	            case "set":
	              if (alreadySeenData[name] || alreadySeenSetters[name]) {
	                isDuplicate = true;
	              }
	              alreadySeenSetters[name] = true;
	              break;
	            default:
	              if (alreadySeenData[name] || alreadySeenGetters[name] || alreadySeenSetters[name]) {
	                isDuplicate = true;
	              }
	              alreadySeenData[name] = true;
	          }
	
	          if (isDuplicate) {
	            prop.computed = true;
	            prop.key = t.stringLiteral(name);
	          }
	        }
	      }
	    }
	  };
	};
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getName(key) {
	  if (t.isIdentifier(key)) {
	    return key.name;
	  }
	  return key.value.toString();
	}
	
	module.exports = exports["default"];

/***/ }),
/* 936 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (_ref) {
	  var messages = _ref.messages,
	      template = _ref.template,
	      t = _ref.types;
	
	  var buildForOfArray = template("\n    for (var KEY = 0; KEY < ARR.length; KEY++) BODY;\n  ");
	
	  var buildForOfLoose = template("\n    for (var LOOP_OBJECT = OBJECT,\n             IS_ARRAY = Array.isArray(LOOP_OBJECT),\n             INDEX = 0,\n             LOOP_OBJECT = IS_ARRAY ? LOOP_OBJECT : LOOP_OBJECT[Symbol.iterator]();;) {\n      var ID;\n      if (IS_ARRAY) {\n        if (INDEX >= LOOP_OBJECT.length) break;\n        ID = LOOP_OBJECT[INDEX++];\n      } else {\n        INDEX = LOOP_OBJECT.next();\n        if (INDEX.done) break;\n        ID = INDEX.value;\n      }\n    }\n  ");
	
	  var buildForOf = template("\n    var ITERATOR_COMPLETION = true;\n    var ITERATOR_HAD_ERROR_KEY = false;\n    var ITERATOR_ERROR_KEY = undefined;\n    try {\n      for (var ITERATOR_KEY = OBJECT[Symbol.iterator](), STEP_KEY; !(ITERATOR_COMPLETION = (STEP_KEY = ITERATOR_KEY.next()).done); ITERATOR_COMPLETION = true) {\n      }\n    } catch (err) {\n      ITERATOR_HAD_ERROR_KEY = true;\n      ITERATOR_ERROR_KEY = err;\n    } finally {\n      try {\n        if (!ITERATOR_COMPLETION && ITERATOR_KEY.return) {\n          ITERATOR_KEY.return();\n        }\n      } finally {\n        if (ITERATOR_HAD_ERROR_KEY) {\n          throw ITERATOR_ERROR_KEY;\n        }\n      }\n    }\n  ");
	
	
	  function _ForOfStatementArray(path) {
	    var node = path.node,
	        scope = path.scope;
	
	    var nodes = [];
	    var right = node.right;
	
	    if (!t.isIdentifier(right) || !scope.hasBinding(right.name)) {
	      var uid = scope.generateUidIdentifier("arr");
	      nodes.push(t.variableDeclaration("var", [t.variableDeclarator(uid, right)]));
	      right = uid;
	    }
	
	    var iterationKey = scope.generateUidIdentifier("i");
	
	    var loop = buildForOfArray({
	      BODY: node.body,
	      KEY: iterationKey,
	      ARR: right
	    });
	
	    t.inherits(loop, node);
	    t.ensureBlock(loop);
	
	    var iterationValue = t.memberExpression(right, iterationKey, true);
	
	    var left = node.left;
	    if (t.isVariableDeclaration(left)) {
	      left.declarations[0].init = iterationValue;
	      loop.body.body.unshift(left);
	    } else {
	      loop.body.body.unshift(t.expressionStatement(t.assignmentExpression("=", left, iterationValue)));
	    }
	
	    if (path.parentPath.isLabeledStatement()) {
	      loop = t.labeledStatement(path.parentPath.node.label, loop);
	    }
	
	    nodes.push(loop);
	
	    return nodes;
	  }
	
	  return {
	    visitor: {
	      ForOfStatement: function ForOfStatement(path, state) {
	        if (path.get("right").isArrayExpression()) {
	          if (path.parentPath.isLabeledStatement()) {
	            return path.parentPath.replaceWithMultiple(_ForOfStatementArray(path));
	          } else {
	            return path.replaceWithMultiple(_ForOfStatementArray(path));
	          }
	        }
	
	        var callback = spec;
	        if (state.opts.loose) callback = loose;
	
	        var node = path.node;
	
	        var build = callback(path, state);
	        var declar = build.declar;
	        var loop = build.loop;
	        var block = loop.body;
	
	        path.ensureBlock();
	
	        if (declar) {
	          block.body.push(declar);
	        }
	
	        block.body = block.body.concat(node.body.body);
	
	        t.inherits(loop, node);
	        t.inherits(loop.body, node.body);
	
	        if (build.replaceParent) {
	          path.parentPath.replaceWithMultiple(build.node);
	          path.remove();
	        } else {
	          path.replaceWithMultiple(build.node);
	        }
	      }
	    }
	  };
	
	  function loose(path, file) {
	    var node = path.node,
	        scope = path.scope,
	        parent = path.parent;
	    var left = node.left;
	
	    var declar = void 0,
	        id = void 0;
	
	    if (t.isIdentifier(left) || t.isPattern(left) || t.isMemberExpression(left)) {
	      id = left;
	    } else if (t.isVariableDeclaration(left)) {
	      id = scope.generateUidIdentifier("ref");
	      declar = t.variableDeclaration(left.kind, [t.variableDeclarator(left.declarations[0].id, id)]);
	    } else {
	      throw file.buildCodeFrameError(left, messages.get("unknownForHead", left.type));
	    }
	
	    var iteratorKey = scope.generateUidIdentifier("iterator");
	    var isArrayKey = scope.generateUidIdentifier("isArray");
	
	    var loop = buildForOfLoose({
	      LOOP_OBJECT: iteratorKey,
	      IS_ARRAY: isArrayKey,
	      OBJECT: node.right,
	      INDEX: scope.generateUidIdentifier("i"),
	      ID: id
	    });
	
	    if (!declar) {
	      loop.body.body.shift();
	    }
	
	    var isLabeledParent = t.isLabeledStatement(parent);
	    var labeled = void 0;
	
	    if (isLabeledParent) {
	      labeled = t.labeledStatement(parent.label, loop);
	    }
	
	    return {
	      replaceParent: isLabeledParent,
	      declar: declar,
	      node: labeled || loop,
	      loop: loop
	    };
	  }
	
	  function spec(path, file) {
	    var node = path.node,
	        scope = path.scope,
	        parent = path.parent;
	
	    var left = node.left;
	    var declar = void 0;
	
	    var stepKey = scope.generateUidIdentifier("step");
	    var stepValue = t.memberExpression(stepKey, t.identifier("value"));
	
	    if (t.isIdentifier(left) || t.isPattern(left) || t.isMemberExpression(left)) {
	      declar = t.expressionStatement(t.assignmentExpression("=", left, stepValue));
	    } else if (t.isVariableDeclaration(left)) {
	      declar = t.variableDeclaration(left.kind, [t.variableDeclarator(left.declarations[0].id, stepValue)]);
	    } else {
	      throw file.buildCodeFrameError(left, messages.get("unknownForHead", left.type));
	    }
	
	    var iteratorKey = scope.generateUidIdentifier("iterator");
	
	    var template = buildForOf({
	      ITERATOR_HAD_ERROR_KEY: scope.generateUidIdentifier("didIteratorError"),
	      ITERATOR_COMPLETION: scope.generateUidIdentifier("iteratorNormalCompletion"),
	      ITERATOR_ERROR_KEY: scope.generateUidIdentifier("iteratorError"),
	      ITERATOR_KEY: iteratorKey,
	      STEP_KEY: stepKey,
	      OBJECT: node.right,
	      BODY: null
	    });
	
	    var isLabeledParent = t.isLabeledStatement(parent);
	
	    var tryBody = template[3].block.body;
	    var loop = tryBody[0];
	
	    if (isLabeledParent) {
	      tryBody[0] = t.labeledStatement(parent.label, loop);
	    }
	
	    return {
	      replaceParent: isLabeledParent,
	      declar: declar,
	      loop: loop,
	      node: template
	    };
	  }
	};
	
	module.exports = exports["default"];

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  return {
	    visitor: {
	      FunctionExpression: {
	        exit: function exit(path) {
	          if (path.key !== "value" && !path.parentPath.isObjectProperty()) {
	            var replacement = (0, _babelHelperFunctionName2.default)(path);
	            if (replacement) path.replaceWith(replacement);
	          }
	        }
	      },
	
	      ObjectProperty: function ObjectProperty(path) {
	        var value = path.get("value");
	        if (value.isFunction()) {
	          var newNode = (0, _babelHelperFunctionName2.default)(value);
	          if (newNode) value.replaceWith(newNode);
	        }
	      }
	    }
	  };
	};
	
	var _babelHelperFunctionName = __webpack_require__(276);
	
	var _babelHelperFunctionName2 = _interopRequireDefault(_babelHelperFunctionName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 938 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  return {
	    visitor: {
	      NumericLiteral: function NumericLiteral(_ref) {
	        var node = _ref.node;
	
	        if (node.extra && /^0[ob]/i.test(node.extra.raw)) {
	          node.extra = undefined;
	        }
	      },
	      StringLiteral: function StringLiteral(_ref2) {
	        var node = _ref2.node;
	
	        if (node.extra && /\\[u]/gi.test(node.extra.raw)) {
	          node.extra = undefined;
	        }
	      }
	    }
	  };
	};
	
	module.exports = exports["default"];

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _create = __webpack_require__(82);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _symbol = __webpack_require__(83);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	exports.default = function (_ref) {
	  var t = _ref.types;
	
	  var IGNORE_REASSIGNMENT_SYMBOL = (0, _symbol2.default)();
	
	  var reassignmentVisitor = {
	    "AssignmentExpression|UpdateExpression": function AssignmentExpressionUpdateExpression(path) {
	      if (path.node[IGNORE_REASSIGNMENT_SYMBOL]) return;
	      path.node[IGNORE_REASSIGNMENT_SYMBOL] = true;
	
	      var arg = path.get(path.isAssignmentExpression() ? "left" : "argument");
	      if (!arg.isIdentifier()) return;
	
	      var name = arg.node.name;
	
	      if (this.scope.getBinding(name) !== path.scope.getBinding(name)) return;
	
	      var exportedNames = this.exports[name];
	      if (!exportedNames) return;
	
	      var node = path.node;
	
	      var isPostUpdateExpression = path.isUpdateExpression() && !node.prefix;
	      if (isPostUpdateExpression) {
	        if (node.operator === "++") node = t.binaryExpression("+", node.argument, t.numericLiteral(1));else if (node.operator === "--") node = t.binaryExpression("-", node.argument, t.numericLiteral(1));else isPostUpdateExpression = false;
	      }
	
	      for (var _iterator = exportedNames, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	        var _ref2;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref2 = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref2 = _i.value;
	        }
	
	        var exportedName = _ref2;
	
	        node = this.buildCall(exportedName, node).expression;
	      }
	
	      if (isPostUpdateExpression) node = t.sequenceExpression([node, path.node]);
	
	      path.replaceWith(node);
	    }
	  };
	
	  return {
	    visitor: {
	      CallExpression: function CallExpression(path, state) {
	        if (path.node.callee.type === TYPE_IMPORT) {
	          var contextIdent = state.contextIdent;
	          path.replaceWith(t.callExpression(t.memberExpression(contextIdent, t.identifier("import")), path.node.arguments));
	        }
	      },
	      ReferencedIdentifier: function ReferencedIdentifier(path, state) {
	        if (path.node.name == "__moduleName" && !path.scope.hasBinding("__moduleName")) {
	          path.replaceWith(t.memberExpression(state.contextIdent, t.identifier("id")));
	        }
	      },
	
	
	      Program: {
	        enter: function enter(path, state) {
	          state.contextIdent = path.scope.generateUidIdentifier("context");
	        },
	        exit: function exit(path, state) {
	          var exportIdent = path.scope.generateUidIdentifier("export");
	          var contextIdent = state.contextIdent;
	
	          var exportNames = (0, _create2.default)(null);
	          var modules = [];
	
	          var beforeBody = [];
	          var setters = [];
	          var sources = [];
	          var variableIds = [];
	          var removedPaths = [];
	
	          function addExportName(key, val) {
	            exportNames[key] = exportNames[key] || [];
	            exportNames[key].push(val);
	          }
	
	          function pushModule(source, key, specifiers) {
	            var module = void 0;
	            modules.forEach(function (m) {
	              if (m.key === source) {
	                module = m;
	              }
	            });
	            if (!module) {
	              modules.push(module = { key: source, imports: [], exports: [] });
	            }
	            module[key] = module[key].concat(specifiers);
	          }
	
	          function buildExportCall(name, val) {
	            return t.expressionStatement(t.callExpression(exportIdent, [t.stringLiteral(name), val]));
	          }
	
	          var body = path.get("body");
	
	          var canHoist = true;
	          for (var _iterator2 = body, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	            var _ref3;
	
	            if (_isArray2) {
	              if (_i2 >= _iterator2.length) break;
	              _ref3 = _iterator2[_i2++];
	            } else {
	              _i2 = _iterator2.next();
	              if (_i2.done) break;
	              _ref3 = _i2.value;
	            }
	
	            var _path = _ref3;
	
	            if (_path.isExportDeclaration()) _path = _path.get("declaration");
	            if (_path.isVariableDeclaration() && _path.node.kind !== "var") {
	              canHoist = false;
	              break;
	            }
	          }
	
	          for (var _iterator3 = body, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
	            var _ref4;
	
	            if (_isArray3) {
	              if (_i3 >= _iterator3.length) break;
	              _ref4 = _iterator3[_i3++];
	            } else {
	              _i3 = _iterator3.next();
	              if (_i3.done) break;
	              _ref4 = _i3.value;
	            }
	
	            var _path2 = _ref4;
	
	            if (canHoist && _path2.isFunctionDeclaration()) {
	              beforeBody.push(_path2.node);
	              removedPaths.push(_path2);
	            } else if (_path2.isImportDeclaration()) {
	              var source = _path2.node.source.value;
	              pushModule(source, "imports", _path2.node.specifiers);
	              for (var name in _path2.getBindingIdentifiers()) {
	                _path2.scope.removeBinding(name);
	                variableIds.push(t.identifier(name));
	              }
	              _path2.remove();
	            } else if (_path2.isExportAllDeclaration()) {
	              pushModule(_path2.node.source.value, "exports", _path2.node);
	              _path2.remove();
	            } else if (_path2.isExportDefaultDeclaration()) {
	              var declar = _path2.get("declaration");
	              if (declar.isClassDeclaration() || declar.isFunctionDeclaration()) {
	                var id = declar.node.id;
	                var nodes = [];
	
	                if (id) {
	                  nodes.push(declar.node);
	                  nodes.push(buildExportCall("default", id));
	                  addExportName(id.name, "default");
	                } else {
	                  nodes.push(buildExportCall("default", t.toExpression(declar.node)));
	                }
	
	                if (!canHoist || declar.isClassDeclaration()) {
	                  _path2.replaceWithMultiple(nodes);
	                } else {
	                  beforeBody = beforeBody.concat(nodes);
	                  removedPaths.push(_path2);
	                }
	              } else {
	                _path2.replaceWith(buildExportCall("default", declar.node));
	              }
	            } else if (_path2.isExportNamedDeclaration()) {
	              var _declar = _path2.get("declaration");
	
	              if (_declar.node) {
	                _path2.replaceWith(_declar);
	
	                var _nodes = [];
	                var bindingIdentifiers = void 0;
	                if (_path2.isFunction()) {
	                  var node = _declar.node;
	                  var _name = node.id.name;
	                  if (canHoist) {
	                    addExportName(_name, _name);
	                    beforeBody.push(node);
	                    beforeBody.push(buildExportCall(_name, node.id));
	                    removedPaths.push(_path2);
	                  } else {
	                    var _bindingIdentifiers;
	
	                    bindingIdentifiers = (_bindingIdentifiers = {}, _bindingIdentifiers[_name] = node.id, _bindingIdentifiers);
	                  }
	                } else {
	                  bindingIdentifiers = _declar.getBindingIdentifiers();
	                }
	                for (var _name2 in bindingIdentifiers) {
	                  addExportName(_name2, _name2);
	                  _nodes.push(buildExportCall(_name2, t.identifier(_name2)));
	                }
	                _path2.insertAfter(_nodes);
	              } else {
	                var specifiers = _path2.node.specifiers;
	                if (specifiers && specifiers.length) {
	                  if (_path2.node.source) {
	                    pushModule(_path2.node.source.value, "exports", specifiers);
	                    _path2.remove();
	                  } else {
	                    var _nodes2 = [];
	
	                    for (var _iterator7 = specifiers, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : (0, _getIterator3.default)(_iterator7);;) {
	                      var _ref8;
	
	                      if (_isArray7) {
	                        if (_i7 >= _iterator7.length) break;
	                        _ref8 = _iterator7[_i7++];
	                      } else {
	                        _i7 = _iterator7.next();
	                        if (_i7.done) break;
	                        _ref8 = _i7.value;
	                      }
	
	                      var specifier = _ref8;
	
	                      _nodes2.push(buildExportCall(specifier.exported.name, specifier.local));
	                      addExportName(specifier.local.name, specifier.exported.name);
	                    }
	
	                    _path2.replaceWithMultiple(_nodes2);
	                  }
	                }
	              }
	            }
	          }
	
	          modules.forEach(function (specifiers) {
	            var setterBody = [];
	            var target = path.scope.generateUidIdentifier(specifiers.key);
	
	            for (var _iterator4 = specifiers.imports, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
	              var _ref5;
	
	              if (_isArray4) {
	                if (_i4 >= _iterator4.length) break;
	                _ref5 = _iterator4[_i4++];
	              } else {
	                _i4 = _iterator4.next();
	                if (_i4.done) break;
	                _ref5 = _i4.value;
	              }
	
	              var specifier = _ref5;
	
	              if (t.isImportNamespaceSpecifier(specifier)) {
	                setterBody.push(t.expressionStatement(t.assignmentExpression("=", specifier.local, target)));
	              } else if (t.isImportDefaultSpecifier(specifier)) {
	                specifier = t.importSpecifier(specifier.local, t.identifier("default"));
	              }
	
	              if (t.isImportSpecifier(specifier)) {
	                setterBody.push(t.expressionStatement(t.assignmentExpression("=", specifier.local, t.memberExpression(target, specifier.imported))));
	              }
	            }
	
	            if (specifiers.exports.length) {
	              var exportObjRef = path.scope.generateUidIdentifier("exportObj");
	
	              setterBody.push(t.variableDeclaration("var", [t.variableDeclarator(exportObjRef, t.objectExpression([]))]));
	
	              for (var _iterator5 = specifiers.exports, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : (0, _getIterator3.default)(_iterator5);;) {
	                var _ref6;
	
	                if (_isArray5) {
	                  if (_i5 >= _iterator5.length) break;
	                  _ref6 = _iterator5[_i5++];
	                } else {
	                  _i5 = _iterator5.next();
	                  if (_i5.done) break;
	                  _ref6 = _i5.value;
	                }
	
	                var node = _ref6;
	
	                if (t.isExportAllDeclaration(node)) {
	                  setterBody.push(buildExportAll({
	                    KEY: path.scope.generateUidIdentifier("key"),
	                    EXPORT_OBJ: exportObjRef,
	                    TARGET: target
	                  }));
	                } else if (t.isExportSpecifier(node)) {
	                  setterBody.push(t.expressionStatement(t.assignmentExpression("=", t.memberExpression(exportObjRef, node.exported), t.memberExpression(target, node.local))));
	                } else {}
	              }
	
	              setterBody.push(t.expressionStatement(t.callExpression(exportIdent, [exportObjRef])));
	            }
	
	            sources.push(t.stringLiteral(specifiers.key));
	            setters.push(t.functionExpression(null, [target], t.blockStatement(setterBody)));
	          });
	
	          var moduleName = this.getModuleName();
	          if (moduleName) moduleName = t.stringLiteral(moduleName);
	
	          if (canHoist) {
	            (0, _babelHelperHoistVariables2.default)(path, function (id) {
	              return variableIds.push(id);
	            });
	          }
	
	          if (variableIds.length) {
	            beforeBody.unshift(t.variableDeclaration("var", variableIds.map(function (id) {
	              return t.variableDeclarator(id);
	            })));
	          }
	
	          path.traverse(reassignmentVisitor, {
	            exports: exportNames,
	            buildCall: buildExportCall,
	            scope: path.scope
	          });
	
	          for (var _iterator6 = removedPaths, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : (0, _getIterator3.default)(_iterator6);;) {
	            var _ref7;
	
	            if (_isArray6) {
	              if (_i6 >= _iterator6.length) break;
	              _ref7 = _iterator6[_i6++];
	            } else {
	              _i6 = _iterator6.next();
	              if (_i6.done) break;
	              _ref7 = _i6.value;
	            }
	
	            var _path3 = _ref7;
	
	            _path3.remove();
	          }
	
	          path.node.body = [buildTemplate({
	            SYSTEM_REGISTER: t.memberExpression(t.identifier(state.opts.systemGlobal || "System"), t.identifier("register")),
	            BEFORE_BODY: beforeBody,
	            MODULE_NAME: moduleName,
	            SETTERS: setters,
	            SOURCES: sources,
	            BODY: path.node.body,
	            EXPORT_IDENTIFIER: exportIdent,
	            CONTEXT_IDENTIFIER: contextIdent
	          })];
	        }
	      }
	    }
	  };
	};
	
	var _babelHelperHoistVariables = __webpack_require__(536);
	
	var _babelHelperHoistVariables2 = _interopRequireDefault(_babelHelperHoistVariables);
	
	var _babelTemplate = __webpack_require__(84);
	
	var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buildTemplate = (0, _babelTemplate2.default)("\n  SYSTEM_REGISTER(MODULE_NAME, [SOURCES], function (EXPORT_IDENTIFIER, CONTEXT_IDENTIFIER) {\n    \"use strict\";\n    BEFORE_BODY;\n    return {\n      setters: [SETTERS],\n      execute: function () {\n        BODY;\n      }\n    };\n  });\n");
	
	var buildExportAll = (0, _babelTemplate2.default)("\n  for (var KEY in TARGET) {\n    if (KEY !== \"default\" && KEY !== \"__esModule\") EXPORT_OBJ[KEY] = TARGET[KEY];\n  }\n");
	
	var TYPE_IMPORT = "Import";
	
	module.exports = exports["default"];

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (_ref) {
	  var t = _ref.types;
	
	  function isValidDefine(path) {
	    if (!path.isExpressionStatement()) return;
	
	    var expr = path.get("expression");
	    if (!expr.isCallExpression()) return false;
	    if (!expr.get("callee").isIdentifier({ name: "define" })) return false;
	
	    var args = expr.get("arguments");
	    if (args.length === 3 && !args.shift().isStringLiteral()) return false;
	    if (args.length !== 2) return false;
	    if (!args.shift().isArrayExpression()) return false;
	    if (!args.shift().isFunctionExpression()) return false;
	
	    return true;
	  }
	
	  return {
	    inherits: __webpack_require__(546),
	
	    visitor: {
	      Program: {
	        exit: function exit(path, state) {
	          var last = path.get("body").pop();
	          if (!isValidDefine(last)) return;
	
	          var call = last.node.expression;
	          var args = call.arguments;
	
	          var moduleName = args.length === 3 ? args.shift() : null;
	          var amdArgs = call.arguments[0];
	          var func = call.arguments[1];
	          var browserGlobals = state.opts.globals || {};
	
	          var commonArgs = amdArgs.elements.map(function (arg) {
	            if (arg.value === "module" || arg.value === "exports") {
	              return t.identifier(arg.value);
	            } else {
	              return t.callExpression(t.identifier("require"), [arg]);
	            }
	          });
	
	          var browserArgs = amdArgs.elements.map(function (arg) {
	            if (arg.value === "module") {
	              return t.identifier("mod");
	            } else if (arg.value === "exports") {
	              return t.memberExpression(t.identifier("mod"), t.identifier("exports"));
	            } else {
	              var memberExpression = void 0;
	
	              if (state.opts.exactGlobals) {
	                var globalRef = browserGlobals[arg.value];
	                if (globalRef) {
	                  memberExpression = globalRef.split(".").reduce(function (accum, curr) {
	                    return t.memberExpression(accum, t.identifier(curr));
	                  }, t.identifier("global"));
	                } else {
	                  memberExpression = t.memberExpression(t.identifier("global"), t.identifier(t.toIdentifier(arg.value)));
	                }
	              } else {
	                var requireName = (0, _path.basename)(arg.value, (0, _path.extname)(arg.value));
	                var globalName = browserGlobals[requireName] || requireName;
	                memberExpression = t.memberExpression(t.identifier("global"), t.identifier(t.toIdentifier(globalName)));
	              }
	
	              return memberExpression;
	            }
	          });
	
	          var moduleNameOrBasename = moduleName ? moduleName.value : this.file.opts.basename;
	          var globalToAssign = t.memberExpression(t.identifier("global"), t.identifier(t.toIdentifier(moduleNameOrBasename)));
	          var prerequisiteAssignments = null;
	
	          if (state.opts.exactGlobals) {
	            var globalName = browserGlobals[moduleNameOrBasename];
	
	            if (globalName) {
	              prerequisiteAssignments = [];
	
	              var members = globalName.split(".");
	              globalToAssign = members.slice(1).reduce(function (accum, curr) {
	                prerequisiteAssignments.push(buildPrerequisiteAssignment({ GLOBAL_REFERENCE: accum }));
	                return t.memberExpression(accum, t.identifier(curr));
	              }, t.memberExpression(t.identifier("global"), t.identifier(members[0])));
	            }
	          }
	
	          var globalExport = buildGlobalExport({
	            BROWSER_ARGUMENTS: browserArgs,
	            PREREQUISITE_ASSIGNMENTS: prerequisiteAssignments,
	            GLOBAL_TO_ASSIGN: globalToAssign
	          });
	
	          last.replaceWith(buildWrapper({
	            MODULE_NAME: moduleName,
	            AMD_ARGUMENTS: amdArgs,
	            COMMON_ARGUMENTS: commonArgs,
	            GLOBAL_EXPORT: globalExport,
	            FUNC: func
	          }));
	        }
	      }
	    }
	  };
	};
	
	var _path = __webpack_require__(484);
	
	var _babelTemplate = __webpack_require__(84);
	
	var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buildPrerequisiteAssignment = (0, _babelTemplate2.default)("\n  GLOBAL_REFERENCE = GLOBAL_REFERENCE || {}\n");
	
	var buildGlobalExport = (0, _babelTemplate2.default)("\n  var mod = { exports: {} };\n  factory(BROWSER_ARGUMENTS);\n  PREREQUISITE_ASSIGNMENTS\n  GLOBAL_TO_ASSIGN = mod.exports;\n");
	
	var buildWrapper = (0, _babelTemplate2.default)("\n  (function (global, factory) {\n    if (typeof define === \"function\" && define.amd) {\n      define(MODULE_NAME, AMD_ARGUMENTS, factory);\n    } else if (typeof exports !== \"undefined\") {\n      factory(COMMON_ARGUMENTS);\n    } else {\n      GLOBAL_EXPORT\n    }\n  })(this, FUNC);\n");
	
	module.exports = exports["default"];

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _symbol = __webpack_require__(83);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	exports.default = function (_ref) {
	  var t = _ref.types;
	
	  function Property(path, node, scope, getObjectRef, file) {
	    var replaceSupers = new _babelHelperReplaceSupers2.default({
	      getObjectRef: getObjectRef,
	      methodNode: node,
	      methodPath: path,
	      isStatic: true,
	      scope: scope,
	      file: file
	    });
	
	    replaceSupers.replace();
	  }
	
	  var CONTAINS_SUPER = (0, _symbol2.default)();
	
	  return {
	    visitor: {
	      Super: function Super(path) {
	        var parentObj = path.findParent(function (path) {
	          return path.isObjectExpression();
	        });
	        if (parentObj) parentObj.node[CONTAINS_SUPER] = true;
	      },
	
	
	      ObjectExpression: {
	        exit: function exit(path, file) {
	          if (!path.node[CONTAINS_SUPER]) return;
	
	          var objectRef = void 0;
	          var getObjectRef = function getObjectRef() {
	            return objectRef = objectRef || path.scope.generateUidIdentifier("obj");
	          };
	
	          var propPaths = path.get("properties");
	          for (var _iterator = propPaths, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	            var _ref2;
	
	            if (_isArray) {
	              if (_i >= _iterator.length) break;
	              _ref2 = _iterator[_i++];
	            } else {
	              _i = _iterator.next();
	              if (_i.done) break;
	              _ref2 = _i.value;
	            }
	
	            var propPath = _ref2;
	
	            if (propPath.isObjectProperty()) propPath = propPath.get("value");
	            Property(propPath, propPath.node, path.scope, getObjectRef, file);
	          }
	
	          if (objectRef) {
	            path.scope.push({ id: objectRef });
	            path.replaceWith(t.assignmentExpression("=", objectRef, path.node));
	          }
	        }
	      }
	    }
	  };
	};
	
	var _babelHelperReplaceSupers = __webpack_require__(539);
	
	var _babelHelperReplaceSupers2 = _interopRequireDefault(_babelHelperReplaceSupers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.visitor = undefined;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _babelHelperGetFunctionArity = __webpack_require__(535);
	
	var _babelHelperGetFunctionArity2 = _interopRequireDefault(_babelHelperGetFunctionArity);
	
	var _babelHelperCallDelegate = __webpack_require__(860);
	
	var _babelHelperCallDelegate2 = _interopRequireDefault(_babelHelperCallDelegate);
	
	var _babelTemplate = __webpack_require__(84);
	
	var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buildDefaultParam = (0, _babelTemplate2.default)("\n  let VARIABLE_NAME =\n    ARGUMENTS.length > ARGUMENT_KEY && ARGUMENTS[ARGUMENT_KEY] !== undefined ?\n      ARGUMENTS[ARGUMENT_KEY]\n    :\n      DEFAULT_VALUE;\n");
	
	var buildCutOff = (0, _babelTemplate2.default)("\n  let $0 = $1[$2];\n");
	
	function hasDefaults(node) {
	  for (var _iterator = node.params, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var param = _ref;
	
	    if (!t.isIdentifier(param)) return true;
	  }
	  return false;
	}
	
	function isSafeBinding(scope, node) {
	  if (!scope.hasOwnBinding(node.name)) return true;
	
	  var _scope$getOwnBinding = scope.getOwnBinding(node.name),
	      kind = _scope$getOwnBinding.kind;
	
	  return kind === "param" || kind === "local";
	}
	
	var iifeVisitor = {
	  ReferencedIdentifier: function ReferencedIdentifier(path, state) {
	    var scope = path.scope,
	        node = path.node;
	
	    if (node.name === "eval" || !isSafeBinding(scope, node)) {
	      state.iife = true;
	      path.stop();
	    }
	  },
	  Scope: function Scope(path) {
	    path.skip();
	  }
	};
	
	var visitor = exports.visitor = {
	  Function: function Function(path) {
	    var node = path.node,
	        scope = path.scope;
	
	    if (!hasDefaults(node)) return;
	
	    path.ensureBlock();
	
	    var state = {
	      iife: false,
	      scope: scope
	    };
	
	    var body = [];
	
	    var argsIdentifier = t.identifier("arguments");
	    argsIdentifier._shadowedFunctionLiteral = path;
	
	    function pushDefNode(left, right, i) {
	      var defNode = buildDefaultParam({
	        VARIABLE_NAME: left,
	        DEFAULT_VALUE: right,
	        ARGUMENT_KEY: t.numericLiteral(i),
	        ARGUMENTS: argsIdentifier
	      });
	      defNode._blockHoist = node.params.length - i;
	      body.push(defNode);
	    }
	
	    var lastNonDefaultParam = (0, _babelHelperGetFunctionArity2.default)(node);
	
	    var params = path.get("params");
	    for (var i = 0; i < params.length; i++) {
	      var param = params[i];
	
	      if (!param.isAssignmentPattern()) {
	        if (!state.iife && !param.isIdentifier()) {
	          param.traverse(iifeVisitor, state);
	        }
	
	        continue;
	      }
	
	      var left = param.get("left");
	      var right = param.get("right");
	
	      if (i >= lastNonDefaultParam || left.isPattern()) {
	        var placeholder = scope.generateUidIdentifier("x");
	        placeholder._isDefaultPlaceholder = true;
	        node.params[i] = placeholder;
	      } else {
	        node.params[i] = left.node;
	      }
	
	      if (!state.iife) {
	        if (right.isIdentifier() && !isSafeBinding(scope, right.node)) {
	          state.iife = true;
	        } else {
	          right.traverse(iifeVisitor, state);
	        }
	      }
	
	      pushDefNode(left.node, right.node, i);
	    }
	
	    for (var _i2 = lastNonDefaultParam + 1; _i2 < node.params.length; _i2++) {
	      var _param = node.params[_i2];
	      if (_param._isDefaultPlaceholder) continue;
	
	      var declar = buildCutOff(_param, argsIdentifier, t.numericLiteral(_i2));
	      declar._blockHoist = node.params.length - _i2;
	      body.push(declar);
	    }
	
	    node.params = node.params.slice(0, lastNonDefaultParam);
	
	    if (state.iife) {
	      body.push((0, _babelHelperCallDelegate2.default)(path, scope));
	      path.set("body", t.blockStatement(body));
	    } else {
	      path.get("body").unshiftContainer("body", body);
	    }
	  }
	};

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.visitor = undefined;
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var visitor = exports.visitor = {
	  Function: function Function(path) {
	    var params = path.get("params");
	
	    var hoistTweak = t.isRestElement(params[params.length - 1]) ? 1 : 0;
	    var outputParamsLength = params.length - hoistTweak;
	
	    for (var i = 0; i < outputParamsLength; i++) {
	      var param = params[i];
	      if (param.isArrayPattern() || param.isObjectPattern()) {
	        var uid = path.scope.generateUidIdentifier("ref");
	
	        var declar = t.variableDeclaration("let", [t.variableDeclarator(param.node, uid)]);
	        declar._blockHoist = outputParamsLength - i;
	
	        path.ensureBlock();
	        path.get("body").unshiftContainer("body", declar);
	
	        param.replaceWith(uid);
	      }
	    }
	  }
	};

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = function () {
	  return {
	    visitor: _babelTraverse.visitors.merge([{
	      ArrowFunctionExpression: function ArrowFunctionExpression(path) {
	        var params = path.get("params");
	        for (var _iterator = params, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	          var _ref;
	
	          if (_isArray) {
	            if (_i >= _iterator.length) break;
	            _ref = _iterator[_i++];
	          } else {
	            _i = _iterator.next();
	            if (_i.done) break;
	            _ref = _i.value;
	          }
	
	          var param = _ref;
	
	          if (param.isRestElement() || param.isAssignmentPattern()) {
	            path.arrowFunctionToShadowed();
	            break;
	          }
	        }
	      }
	    }, destructuring.visitor, rest.visitor, def.visitor])
	  };
	};
	
	var _babelTraverse = __webpack_require__(91);
	
	var _destructuring = __webpack_require__(943);
	
	var destructuring = _interopRequireWildcard(_destructuring);
	
	var _default = __webpack_require__(942);
	
	var def = _interopRequireWildcard(_default);
	
	var _rest = __webpack_require__(945);
	
	var rest = _interopRequireWildcard(_rest);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.visitor = undefined;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _babelTemplate = __webpack_require__(84);
	
	var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buildRest = (0, _babelTemplate2.default)("\n  for (var LEN = ARGUMENTS.length,\n           ARRAY = Array(ARRAY_LEN),\n           KEY = START;\n       KEY < LEN;\n       KEY++) {\n    ARRAY[ARRAY_KEY] = ARGUMENTS[KEY];\n  }\n");
	
	var restIndex = (0, _babelTemplate2.default)("\n  ARGUMENTS.length <= INDEX ? undefined : ARGUMENTS[INDEX]\n");
	
	var restIndexImpure = (0, _babelTemplate2.default)("\n  REF = INDEX, ARGUMENTS.length <= REF ? undefined : ARGUMENTS[REF]\n");
	
	var restLength = (0, _babelTemplate2.default)("\n  ARGUMENTS.length <= OFFSET ? 0 : ARGUMENTS.length - OFFSET\n");
	
	var memberExpressionOptimisationVisitor = {
	  Scope: function Scope(path, state) {
	    if (!path.scope.bindingIdentifierEquals(state.name, state.outerBinding)) {
	      path.skip();
	    }
	  },
	  Flow: function Flow(path) {
	    if (path.isTypeCastExpression()) return;
	
	    path.skip();
	  },
	
	
	  "Function|ClassProperty": function FunctionClassProperty(path, state) {
	    var oldNoOptimise = state.noOptimise;
	    state.noOptimise = true;
	    path.traverse(memberExpressionOptimisationVisitor, state);
	    state.noOptimise = oldNoOptimise;
	
	    path.skip();
	  },
	
	  ReferencedIdentifier: function ReferencedIdentifier(path, state) {
	    var node = path.node;
	
	    if (node.name === "arguments") {
	      state.deopted = true;
	    }
	
	    if (node.name !== state.name) return;
	
	    if (state.noOptimise) {
	      state.deopted = true;
	    } else {
	      var parentPath = path.parentPath;
	
	      if (parentPath.listKey === "params" && parentPath.key < state.offset) {
	        return;
	      }
	
	      if (parentPath.isMemberExpression({ object: node })) {
	        var grandparentPath = parentPath.parentPath;
	
	        var argsOptEligible = !state.deopted && !(grandparentPath.isAssignmentExpression() && parentPath.node === grandparentPath.node.left || grandparentPath.isLVal() || grandparentPath.isForXStatement() || grandparentPath.isUpdateExpression() || grandparentPath.isUnaryExpression({ operator: "delete" }) || (grandparentPath.isCallExpression() || grandparentPath.isNewExpression()) && parentPath.node === grandparentPath.node.callee);
	
	        if (argsOptEligible) {
	          if (parentPath.node.computed) {
	            if (parentPath.get("property").isBaseType("number")) {
	              state.candidates.push({ cause: "indexGetter", path: path });
	              return;
	            }
	          } else if (parentPath.node.property.name === "length") {
	              state.candidates.push({ cause: "lengthGetter", path: path });
	              return;
	            }
	        }
	      }
	
	      if (state.offset === 0 && parentPath.isSpreadElement()) {
	        var call = parentPath.parentPath;
	        if (call.isCallExpression() && call.node.arguments.length === 1) {
	          state.candidates.push({ cause: "argSpread", path: path });
	          return;
	        }
	      }
	
	      state.references.push(path);
	    }
	  },
	  BindingIdentifier: function BindingIdentifier(_ref, state) {
	    var node = _ref.node;
	
	    if (node.name === state.name) {
	      state.deopted = true;
	    }
	  }
	};
	function hasRest(node) {
	  return t.isRestElement(node.params[node.params.length - 1]);
	}
	
	function optimiseIndexGetter(path, argsId, offset) {
	  var index = void 0;
	
	  if (t.isNumericLiteral(path.parent.property)) {
	    index = t.numericLiteral(path.parent.property.value + offset);
	  } else if (offset === 0) {
	    index = path.parent.property;
	  } else {
	    index = t.binaryExpression("+", path.parent.property, t.numericLiteral(offset));
	  }
	
	  var scope = path.scope;
	
	  if (!scope.isPure(index)) {
	    var temp = scope.generateUidIdentifierBasedOnNode(index);
	    scope.push({ id: temp, kind: "var" });
	    path.parentPath.replaceWith(restIndexImpure({
	      ARGUMENTS: argsId,
	      INDEX: index,
	      REF: temp
	    }));
	  } else {
	    path.parentPath.replaceWith(restIndex({
	      ARGUMENTS: argsId,
	      INDEX: index
	    }));
	  }
	}
	
	function optimiseLengthGetter(path, argsId, offset) {
	  if (offset) {
	    path.parentPath.replaceWith(restLength({
	      ARGUMENTS: argsId,
	      OFFSET: t.numericLiteral(offset)
	    }));
	  } else {
	    path.replaceWith(argsId);
	  }
	}
	
	var visitor = exports.visitor = {
	  Function: function Function(path) {
	    var node = path.node,
	        scope = path.scope;
	
	    if (!hasRest(node)) return;
	
	    var rest = node.params.pop().argument;
	
	    var argsId = t.identifier("arguments");
	
	    argsId._shadowedFunctionLiteral = path;
	
	    var state = {
	      references: [],
	      offset: node.params.length,
	
	      argumentsNode: argsId,
	      outerBinding: scope.getBindingIdentifier(rest.name),
	
	      candidates: [],
	
	      name: rest.name,
	
	      deopted: false
	    };
	
	    path.traverse(memberExpressionOptimisationVisitor, state);
	
	    if (!state.deopted && !state.references.length) {
	      for (var _iterator = state.candidates, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	        var _ref3;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref3 = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref3 = _i.value;
	        }
	
	        var _ref4 = _ref3;
	        var _path = _ref4.path,
	            cause = _ref4.cause;
	
	        switch (cause) {
	          case "indexGetter":
	            optimiseIndexGetter(_path, argsId, state.offset);
	            break;
	          case "lengthGetter":
	            optimiseLengthGetter(_path, argsId, state.offset);
	            break;
	          default:
	            _path.replaceWith(argsId);
	        }
	      }
	      return;
	    }
	
	    state.references = state.references.concat(state.candidates.map(function (_ref5) {
	      var path = _ref5.path;
	      return path;
	    }));
	
	    state.deopted = state.deopted || !!node.shadow;
	
	    var start = t.numericLiteral(node.params.length);
	    var key = scope.generateUidIdentifier("key");
	    var len = scope.generateUidIdentifier("len");
	
	    var arrKey = key;
	    var arrLen = len;
	    if (node.params.length) {
	      arrKey = t.binaryExpression("-", key, start);
	
	      arrLen = t.conditionalExpression(t.binaryExpression(">", len, start), t.binaryExpression("-", len, start), t.numericLiteral(0));
	    }
	
	    var loop = buildRest({
	      ARGUMENTS: argsId,
	      ARRAY_KEY: arrKey,
	      ARRAY_LEN: arrLen,
	      START: start,
	      ARRAY: rest,
	      KEY: key,
	      LEN: len
	    });
	
	    if (state.deopted) {
	      loop._blockHoist = node.params.length + 1;
	      node.body.body.unshift(loop);
	    } else {
	      loop._blockHoist = 1;
	
	      var target = path.getEarliestCommonAncestorFrom(state.references).getStatementParent();
	
	      target.findParent(function (path) {
	        if (path.isLoop()) {
	          target = path;
	        } else {
	          return path.isFunction();
	        }
	      });
	
	      target.insertBefore(loop);
	    }
	  }
	};

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  return {
	    visitor: {
	      ObjectMethod: function ObjectMethod(path) {
	        var node = path.node;
	
	        if (node.kind === "method") {
	          var func = t.functionExpression(null, node.params, node.body, node.generator, node.async);
	          func.returnType = node.returnType;
	
	          path.replaceWith(t.objectProperty(node.key, func, node.computed));
	        }
	      },
	      ObjectProperty: function ObjectProperty(_ref) {
	        var node = _ref.node;
	
	        if (node.shorthand) {
	          node.shorthand = false;
	        }
	      }
	    }
	  };
	};
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	module.exports = exports["default"];

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = function (_ref) {
	  var t = _ref.types;
	
	  function getSpreadLiteral(spread, scope, state) {
	    if (state.opts.loose && !t.isIdentifier(spread.argument, { name: "arguments" })) {
	      return spread.argument;
	    } else {
	      return scope.toArray(spread.argument, true);
	    }
	  }
	
	  function hasSpread(nodes) {
	    for (var i = 0; i < nodes.length; i++) {
	      if (t.isSpreadElement(nodes[i])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  function build(props, scope, state) {
	    var nodes = [];
	
	    var _props = [];
	
	    function push() {
	      if (!_props.length) return;
	      nodes.push(t.arrayExpression(_props));
	      _props = [];
	    }
	
	    for (var _iterator = props, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	      var _ref2;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref2 = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref2 = _i.value;
	      }
	
	      var prop = _ref2;
	
	      if (t.isSpreadElement(prop)) {
	        push();
	        nodes.push(getSpreadLiteral(prop, scope, state));
	      } else {
	        _props.push(prop);
	      }
	    }
	
	    push();
	
	    return nodes;
	  }
	
	  return {
	    visitor: {
	      ArrayExpression: function ArrayExpression(path, state) {
	        var node = path.node,
	            scope = path.scope;
	
	        var elements = node.elements;
	        if (!hasSpread(elements)) return;
	
	        var nodes = build(elements, scope, state);
	        var first = nodes.shift();
	
	        if (!t.isArrayExpression(first)) {
	          nodes.unshift(first);
	          first = t.arrayExpression([]);
	        }
	
	        path.replaceWith(t.callExpression(t.memberExpression(first, t.identifier("concat")), nodes));
	      },
	      CallExpression: function CallExpression(path, state) {
	        var node = path.node,
	            scope = path.scope;
	
	
	        var args = node.arguments;
	        if (!hasSpread(args)) return;
	
	        var calleePath = path.get("callee");
	        if (calleePath.isSuper()) return;
	
	        var contextLiteral = t.identifier("undefined");
	
	        node.arguments = [];
	
	        var nodes = void 0;
	        if (args.length === 1 && args[0].argument.name === "arguments") {
	          nodes = [args[0].argument];
	        } else {
	          nodes = build(args, scope, state);
	        }
	
	        var first = nodes.shift();
	        if (nodes.length) {
	          node.arguments.push(t.callExpression(t.memberExpression(first, t.identifier("concat")), nodes));
	        } else {
	          node.arguments.push(first);
	        }
	
	        var callee = node.callee;
	
	        if (calleePath.isMemberExpression()) {
	          var temp = scope.maybeGenerateMemoised(callee.object);
	          if (temp) {
	            callee.object = t.assignmentExpression("=", temp, callee.object);
	            contextLiteral = temp;
	          } else {
	            contextLiteral = callee.object;
	          }
	          t.appendToMemberExpression(callee, t.identifier("apply"));
	        } else {
	          node.callee = t.memberExpression(node.callee, t.identifier("apply"));
	        }
	
	        if (t.isSuper(contextLiteral)) {
	          contextLiteral = t.thisExpression();
	        }
	
	        node.arguments.unshift(contextLiteral);
	      },
	      NewExpression: function NewExpression(path, state) {
	        var node = path.node,
	            scope = path.scope;
	
	        var args = node.arguments;
	        if (!hasSpread(args)) return;
	
	        var nodes = build(args, scope, state);
	
	        var context = t.arrayExpression([t.nullLiteral()]);
	
	        args = t.callExpression(t.memberExpression(context, t.identifier("concat")), nodes);
	
	        path.replaceWith(t.newExpression(t.callExpression(t.memberExpression(t.memberExpression(t.memberExpression(t.identifier("Function"), t.identifier("prototype")), t.identifier("bind")), t.identifier("apply")), [node.callee, args]), []));
	      }
	    }
	  };
	};
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  return {
	    visitor: {
	      RegExpLiteral: function RegExpLiteral(path) {
	        var node = path.node;
	
	        if (!regex.is(node, "y")) return;
	
	        path.replaceWith(t.newExpression(t.identifier("RegExp"), [t.stringLiteral(node.pattern), t.stringLiteral(node.flags)]));
	      }
	    }
	  };
	};
	
	var _babelHelperRegex = __webpack_require__(538);
	
	var regex = _interopRequireWildcard(_babelHelperRegex);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	module.exports = exports["default"];

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = function (_ref) {
	  var t = _ref.types;
	
	  function isString(node) {
	    return t.isLiteral(node) && typeof node.value === "string";
	  }
	
	  function buildBinaryExpression(left, right) {
	    return t.binaryExpression("+", left, right);
	  }
	
	  return {
	    visitor: {
	      TaggedTemplateExpression: function TaggedTemplateExpression(path, state) {
	        var node = path.node;
	
	        var quasi = node.quasi;
	        var args = [];
	
	        var strings = [];
	        var raw = [];
	
	        for (var _iterator = quasi.quasis, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	          var _ref2;
	
	          if (_isArray) {
	            if (_i >= _iterator.length) break;
	            _ref2 = _iterator[_i++];
	          } else {
	            _i = _iterator.next();
	            if (_i.done) break;
	            _ref2 = _i.value;
	          }
	
	          var elem = _ref2;
	
	          strings.push(t.stringLiteral(elem.value.cooked));
	          raw.push(t.stringLiteral(elem.value.raw));
	        }
	
	        strings = t.arrayExpression(strings);
	        raw = t.arrayExpression(raw);
	
	        var templateName = "taggedTemplateLiteral";
	        if (state.opts.loose) templateName += "Loose";
	
	        var templateObject = state.file.addTemplateObject(templateName, strings, raw);
	        args.push(templateObject);
	
	        args = args.concat(quasi.expressions);
	
	        path.replaceWith(t.callExpression(node.tag, args));
	      },
	      TemplateLiteral: function TemplateLiteral(path, state) {
	        var nodes = [];
	
	        var expressions = path.get("expressions");
	
	        for (var _iterator2 = path.node.quasis, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	          var _ref3;
	
	          if (_isArray2) {
	            if (_i2 >= _iterator2.length) break;
	            _ref3 = _iterator2[_i2++];
	          } else {
	            _i2 = _iterator2.next();
	            if (_i2.done) break;
	            _ref3 = _i2.value;
	          }
	
	          var elem = _ref3;
	
	          nodes.push(t.stringLiteral(elem.value.cooked));
	
	          var expr = expressions.shift();
	          if (expr) {
	            if (state.opts.spec && !expr.isBaseType("string") && !expr.isBaseType("number")) {
	              nodes.push(t.callExpression(t.identifier("String"), [expr.node]));
	            } else {
	              nodes.push(expr.node);
	            }
	          }
	        }
	
	        nodes = nodes.filter(function (n) {
	          return !t.isLiteral(n, { value: "" });
	        });
	
	        if (!isString(nodes[0]) && !isString(nodes[1])) {
	          nodes.unshift(t.stringLiteral(""));
	        }
	
	        if (nodes.length > 1) {
	          var root = buildBinaryExpression(nodes.shift(), nodes.shift());
	
	          for (var _iterator3 = nodes, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
	            var _ref4;
	
	            if (_isArray3) {
	              if (_i3 >= _iterator3.length) break;
	              _ref4 = _iterator3[_i3++];
	            } else {
	              _i3 = _iterator3.next();
	              if (_i3.done) break;
	              _ref4 = _i3.value;
	            }
	
	            var node = _ref4;
	
	            root = buildBinaryExpression(root, node);
	          }
	
	          path.replaceWith(root);
	        } else {
	          path.replaceWith(nodes[0]);
	        }
	      }
	    }
	  };
	};
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _symbol = __webpack_require__(83);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	exports.default = function (_ref) {
	  var t = _ref.types;
	
	  var IGNORE = (0, _symbol2.default)();
	
	  return {
	    visitor: {
	      Scope: function Scope(_ref2) {
	        var scope = _ref2.scope;
	
	        if (!scope.getBinding("Symbol")) {
	          return;
	        }
	
	        scope.rename("Symbol");
	      },
	      UnaryExpression: function UnaryExpression(path) {
	        var node = path.node,
	            parent = path.parent;
	
	        if (node[IGNORE]) return;
	        if (path.find(function (path) {
	          return path.node && !!path.node._generated;
	        })) return;
	
	        if (path.parentPath.isBinaryExpression() && t.EQUALITY_BINARY_OPERATORS.indexOf(parent.operator) >= 0) {
	          var opposite = path.getOpposite();
	          if (opposite.isLiteral() && opposite.node.value !== "symbol" && opposite.node.value !== "object") {
	            return;
	          }
	        }
	
	        if (node.operator === "typeof") {
	          var call = t.callExpression(this.addHelper("typeof"), [node.argument]);
	          if (path.get("argument").isIdentifier()) {
	            var undefLiteral = t.stringLiteral("undefined");
	            var unary = t.unaryExpression("typeof", node.argument);
	            unary[IGNORE] = true;
	            path.replaceWith(t.conditionalExpression(t.binaryExpression("===", unary, undefLiteral), undefLiteral, call));
	          } else {
	            path.replaceWith(call);
	          }
	        }
	      }
	    }
	  };
	};
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  return {
	    visitor: {
	      RegExpLiteral: function RegExpLiteral(_ref) {
	        var node = _ref.node;
	
	        if (!regex.is(node, "u")) return;
	        node.pattern = (0, _regexpuCore2.default)(node.pattern, node.flags);
	        regex.pullFlag(node, "u");
	      }
	    }
	  };
	};
	
	var _regexpuCore = __webpack_require__(4461);
	
	var _regexpuCore2 = _interopRequireDefault(_regexpuCore);
	
	var _babelHelperRegex = __webpack_require__(538);
	
	var regex = _interopRequireWildcard(_babelHelperRegex);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = function (_ref) {
	  var t = _ref.types;
	
	  var FLOW_DIRECTIVE = "@flow";
	
	  return {
	    inherits: __webpack_require__(926),
	
	    visitor: {
	      Program: function Program(path, _ref2) {
	        var comments = _ref2.file.ast.comments;
	
	        for (var _iterator = comments, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	          var _ref3;
	
	          if (_isArray) {
	            if (_i >= _iterator.length) break;
	            _ref3 = _iterator[_i++];
	          } else {
	            _i = _iterator.next();
	            if (_i.done) break;
	            _ref3 = _i.value;
	          }
	
	          var comment = _ref3;
	
	          if (comment.value.indexOf(FLOW_DIRECTIVE) >= 0) {
	            comment.value = comment.value.replace(FLOW_DIRECTIVE, "");
	
	            if (!comment.value.replace(/\*/g, "").trim()) comment.ignore = true;
	          }
	        }
	      },
	      Flow: function Flow(path) {
	        path.remove();
	      },
	      ClassProperty: function ClassProperty(path) {
	        path.node.variance = null;
	        path.node.typeAnnotation = null;
	        if (!path.node.value) path.remove();
	      },
	      Class: function Class(path) {
	        path.node.implements = null;
	
	        path.get("body.body").forEach(function (child) {
	          if (child.isClassProperty()) {
	            child.node.typeAnnotation = null;
	            if (!child.node.value) child.remove();
	          }
	        });
	      },
	      AssignmentPattern: function AssignmentPattern(_ref4) {
	        var node = _ref4.node;
	
	        node.left.optional = false;
	      },
	      Function: function Function(_ref5) {
	        var node = _ref5.node;
	
	        for (var i = 0; i < node.params.length; i++) {
	          var param = node.params[i];
	          param.optional = false;
	        }
	      },
	      TypeCastExpression: function TypeCastExpression(path) {
	        var node = path.node;
	
	        do {
	          node = node.expression;
	        } while (t.isTypeCastExpression(node));
	        path.replaceWith(node);
	      }
	    }
	  };
	};
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (_ref) {
	  var t = _ref.types;
	
	  function addDisplayName(id, call) {
	    var props = call.arguments[0].properties;
	    var safe = true;
	
	    for (var i = 0; i < props.length; i++) {
	      var prop = props[i];
	      var key = t.toComputedKey(prop);
	      if (t.isLiteral(key, { value: "displayName" })) {
	        safe = false;
	        break;
	      }
	    }
	
	    if (safe) {
	      props.unshift(t.objectProperty(t.identifier("displayName"), t.stringLiteral(id)));
	    }
	  }
	
	  var isCreateClassCallExpression = t.buildMatchMemberExpression("React.createClass");
	  var isCreateClassAddon = function isCreateClassAddon(callee) {
	    return callee.name === "createReactClass";
	  };
	
	  function isCreateClass(node) {
	    if (!node || !t.isCallExpression(node)) return false;
	
	    if (!isCreateClassCallExpression(node.callee) && !isCreateClassAddon(node.callee)) return false;
	
	    var args = node.arguments;
	    if (args.length !== 1) return false;
	
	    var first = args[0];
	    if (!t.isObjectExpression(first)) return false;
	
	    return true;
	  }
	
	  return {
	    visitor: {
	      ExportDefaultDeclaration: function ExportDefaultDeclaration(_ref2, state) {
	        var node = _ref2.node;
	
	        if (isCreateClass(node.declaration)) {
	          var displayName = state.file.opts.basename;
	
	          if (displayName === "index") {
	            displayName = _path2.default.basename(_path2.default.dirname(state.file.opts.filename));
	          }
	
	          addDisplayName(displayName, node.declaration);
	        }
	      },
	      CallExpression: function CallExpression(path) {
	        var node = path.node;
	
	        if (!isCreateClass(node)) return;
	
	        var id = void 0;
	
	        path.find(function (path) {
	          if (path.isAssignmentExpression()) {
	            id = path.node.left;
	          } else if (path.isObjectProperty()) {
	            id = path.node.key;
	          } else if (path.isVariableDeclarator()) {
	            id = path.node.id;
	          } else if (path.isStatement()) {
	            return true;
	          }
	
	          if (id) return true;
	        });
	
	        if (!id) return;
	
	        if (t.isMemberExpression(id)) {
	          id = id.property;
	        }
	
	        if (t.isIdentifier(id)) {
	          addDisplayName(id.name, node);
	        }
	      }
	    }
	  };
	};
	
	var _path = __webpack_require__(484);
	
	var _path2 = _interopRequireDefault(_path);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = function (_ref) {
	  var t = _ref.types;
	
	  var JSX_ANNOTATION_REGEX = /\*?\s*@jsx\s+([^\s]+)/;
	
	  var visitor = (0, _babelHelperBuilderReactJsx2.default)({
	    pre: function pre(state) {
	      var tagName = state.tagName;
	      var args = state.args;
	      if (t.react.isCompatTag(tagName)) {
	        args.push(t.stringLiteral(tagName));
	      } else {
	        args.push(state.tagExpr);
	      }
	    },
	    post: function post(state, pass) {
	      state.callee = pass.get("jsxIdentifier")();
	    }
	  });
	
	  visitor.Program = function (path, state) {
	    var file = state.file;
	
	    var id = state.opts.pragma || "React.createElement";
	
	    for (var _iterator = file.ast.comments, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	      var _ref2;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref2 = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref2 = _i.value;
	      }
	
	      var comment = _ref2;
	
	      var matches = JSX_ANNOTATION_REGEX.exec(comment.value);
	      if (matches) {
	        id = matches[1];
	        if (id === "React.DOM") {
	          throw file.buildCodeFrameError(comment, "The @jsx React.DOM pragma has been deprecated as of React 0.12");
	        } else {
	          break;
	        }
	      }
	    }
	
	    state.set("jsxIdentifier", function () {
	      return id.split(".").map(function (name) {
	        return t.identifier(name);
	      }).reduce(function (object, property) {
	        return t.memberExpression(object, property);
	      });
	    });
	  };
	
	  return {
	    inherits: _babelPluginSyntaxJsx2.default,
	    visitor: visitor
	  };
	};
	
	var _babelPluginSyntaxJsx = __webpack_require__(544);
	
	var _babelPluginSyntaxJsx2 = _interopRequireDefault(_babelPluginSyntaxJsx);
	
	var _babelHelperBuilderReactJsx = __webpack_require__(859);
	
	var _babelHelperBuilderReactJsx2 = _interopRequireDefault(_babelHelperBuilderReactJsx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(4455);

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = function () {
	  return {
	    visitor: {
	      Program: function Program(path, state) {
	        if (state.opts.strict === false || state.opts.strictMode === false) return;
	
	        var node = path.node;
	
	
	        for (var _iterator = node.directives, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	          var _ref;
	
	          if (_isArray) {
	            if (_i >= _iterator.length) break;
	            _ref = _iterator[_i++];
	          } else {
	            _i = _iterator.next();
	            if (_i.done) break;
	            _ref = _i.value;
	          }
	
	          var directive = _ref;
	
	          if (directive.value.value === "use strict") return;
	        }
	
	        path.unshiftContainer("directives", t.directive(t.directiveLiteral("use strict")));
	      }
	    }
	  };
	};
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports["default"];

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _babelPluginTransformEs2015TemplateLiterals = __webpack_require__(949);
	
	var _babelPluginTransformEs2015TemplateLiterals2 = _interopRequireDefault(_babelPluginTransformEs2015TemplateLiterals);
	
	var _babelPluginTransformEs2015Literals = __webpack_require__(938);
	
	var _babelPluginTransformEs2015Literals2 = _interopRequireDefault(_babelPluginTransformEs2015Literals);
	
	var _babelPluginTransformEs2015FunctionName = __webpack_require__(937);
	
	var _babelPluginTransformEs2015FunctionName2 = _interopRequireDefault(_babelPluginTransformEs2015FunctionName);
	
	var _babelPluginTransformEs2015ArrowFunctions = __webpack_require__(927);
	
	var _babelPluginTransformEs2015ArrowFunctions2 = _interopRequireDefault(_babelPluginTransformEs2015ArrowFunctions);
	
	var _babelPluginTransformEs2015BlockScopedFunctions = __webpack_require__(928);
	
	var _babelPluginTransformEs2015BlockScopedFunctions2 = _interopRequireDefault(_babelPluginTransformEs2015BlockScopedFunctions);
	
	var _babelPluginTransformEs2015Classes = __webpack_require__(931);
	
	var _babelPluginTransformEs2015Classes2 = _interopRequireDefault(_babelPluginTransformEs2015Classes);
	
	var _babelPluginTransformEs2015ObjectSuper = __webpack_require__(941);
	
	var _babelPluginTransformEs2015ObjectSuper2 = _interopRequireDefault(_babelPluginTransformEs2015ObjectSuper);
	
	var _babelPluginTransformEs2015ShorthandProperties = __webpack_require__(946);
	
	var _babelPluginTransformEs2015ShorthandProperties2 = _interopRequireDefault(_babelPluginTransformEs2015ShorthandProperties);
	
	var _babelPluginTransformEs2015DuplicateKeys = __webpack_require__(935);
	
	var _babelPluginTransformEs2015DuplicateKeys2 = _interopRequireDefault(_babelPluginTransformEs2015DuplicateKeys);
	
	var _babelPluginTransformEs2015ComputedProperties = __webpack_require__(933);
	
	var _babelPluginTransformEs2015ComputedProperties2 = _interopRequireDefault(_babelPluginTransformEs2015ComputedProperties);
	
	var _babelPluginTransformEs2015ForOf = __webpack_require__(936);
	
	var _babelPluginTransformEs2015ForOf2 = _interopRequireDefault(_babelPluginTransformEs2015ForOf);
	
	var _babelPluginTransformEs2015StickyRegex = __webpack_require__(948);
	
	var _babelPluginTransformEs2015StickyRegex2 = _interopRequireDefault(_babelPluginTransformEs2015StickyRegex);
	
	var _babelPluginTransformEs2015UnicodeRegex = __webpack_require__(951);
	
	var _babelPluginTransformEs2015UnicodeRegex2 = _interopRequireDefault(_babelPluginTransformEs2015UnicodeRegex);
	
	var _babelPluginCheckEs2015Constants = __webpack_require__(925);
	
	var _babelPluginCheckEs2015Constants2 = _interopRequireDefault(_babelPluginCheckEs2015Constants);
	
	var _babelPluginTransformEs2015Spread = __webpack_require__(947);
	
	var _babelPluginTransformEs2015Spread2 = _interopRequireDefault(_babelPluginTransformEs2015Spread);
	
	var _babelPluginTransformEs2015Parameters = __webpack_require__(944);
	
	var _babelPluginTransformEs2015Parameters2 = _interopRequireDefault(_babelPluginTransformEs2015Parameters);
	
	var _babelPluginTransformEs2015Destructuring = __webpack_require__(934);
	
	var _babelPluginTransformEs2015Destructuring2 = _interopRequireDefault(_babelPluginTransformEs2015Destructuring);
	
	var _babelPluginTransformEs2015BlockScoping = __webpack_require__(929);
	
	var _babelPluginTransformEs2015BlockScoping2 = _interopRequireDefault(_babelPluginTransformEs2015BlockScoping);
	
	var _babelPluginTransformEs2015TypeofSymbol = __webpack_require__(950);
	
	var _babelPluginTransformEs2015TypeofSymbol2 = _interopRequireDefault(_babelPluginTransformEs2015TypeofSymbol);
	
	var _babelPluginTransformEs2015ModulesCommonjs = __webpack_require__(547);
	
	var _babelPluginTransformEs2015ModulesCommonjs2 = _interopRequireDefault(_babelPluginTransformEs2015ModulesCommonjs);
	
	var _babelPluginTransformEs2015ModulesSystemjs = __webpack_require__(939);
	
	var _babelPluginTransformEs2015ModulesSystemjs2 = _interopRequireDefault(_babelPluginTransformEs2015ModulesSystemjs);
	
	var _babelPluginTransformEs2015ModulesAmd = __webpack_require__(546);
	
	var _babelPluginTransformEs2015ModulesAmd2 = _interopRequireDefault(_babelPluginTransformEs2015ModulesAmd);
	
	var _babelPluginTransformEs2015ModulesUmd = __webpack_require__(940);
	
	var _babelPluginTransformEs2015ModulesUmd2 = _interopRequireDefault(_babelPluginTransformEs2015ModulesUmd);
	
	var _babelPluginTransformRegenerator = __webpack_require__(955);
	
	var _babelPluginTransformRegenerator2 = _interopRequireDefault(_babelPluginTransformRegenerator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function preset(context) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var moduleTypes = ["commonjs", "amd", "umd", "systemjs"];
	  var loose = false;
	  var modules = "commonjs";
	  var spec = false;
	
	  if (opts !== undefined) {
	    if (opts.loose !== undefined) loose = opts.loose;
	    if (opts.modules !== undefined) modules = opts.modules;
	    if (opts.spec !== undefined) spec = opts.spec;
	  }
	
	  if (typeof loose !== "boolean") throw new Error("Preset es2015 'loose' option must be a boolean.");
	  if (typeof spec !== "boolean") throw new Error("Preset es2015 'spec' option must be a boolean.");
	  if (modules !== false && moduleTypes.indexOf(modules) === -1) {
	    throw new Error("Preset es2015 'modules' option must be 'false' to indicate no modules\n" + "or a module type which be be one of: 'commonjs' (default), 'amd', 'umd', 'systemjs'");
	  }
	
	  var optsLoose = { loose: loose };
	
	  return {
	    plugins: [[_babelPluginTransformEs2015TemplateLiterals2.default, { loose: loose, spec: spec }], _babelPluginTransformEs2015Literals2.default, _babelPluginTransformEs2015FunctionName2.default, [_babelPluginTransformEs2015ArrowFunctions2.default, { spec: spec }], _babelPluginTransformEs2015BlockScopedFunctions2.default, [_babelPluginTransformEs2015Classes2.default, optsLoose], _babelPluginTransformEs2015ObjectSuper2.default, _babelPluginTransformEs2015ShorthandProperties2.default, _babelPluginTransformEs2015DuplicateKeys2.default, [_babelPluginTransformEs2015ComputedProperties2.default, optsLoose], [_babelPluginTransformEs2015ForOf2.default, optsLoose], _babelPluginTransformEs2015StickyRegex2.default, _babelPluginTransformEs2015UnicodeRegex2.default, _babelPluginCheckEs2015Constants2.default, [_babelPluginTransformEs2015Spread2.default, optsLoose], _babelPluginTransformEs2015Parameters2.default, [_babelPluginTransformEs2015Destructuring2.default, optsLoose], _babelPluginTransformEs2015BlockScoping2.default, _babelPluginTransformEs2015TypeofSymbol2.default, modules === "commonjs" && [_babelPluginTransformEs2015ModulesCommonjs2.default, optsLoose], modules === "systemjs" && [_babelPluginTransformEs2015ModulesSystemjs2.default, optsLoose], modules === "amd" && [_babelPluginTransformEs2015ModulesAmd2.default, optsLoose], modules === "umd" && [_babelPluginTransformEs2015ModulesUmd2.default, optsLoose], [_babelPluginTransformRegenerator2.default, { async: false, asyncGenerators: false }]].filter(Boolean) };
	}
	
	var oldConfig = preset({});
	
	exports.default = oldConfig;
	
	Object.defineProperty(oldConfig, "buildPreset", {
	  configurable: true,
	  writable: true,
	
	  enumerable: false,
	  value: preset
	});
	module.exports = exports["default"];

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _babelPluginTransformFlowStripTypes = __webpack_require__(952);
	
	var _babelPluginTransformFlowStripTypes2 = _interopRequireDefault(_babelPluginTransformFlowStripTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  plugins: [_babelPluginTransformFlowStripTypes2.default]
	};
	module.exports = exports["default"];

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _babelPresetFlow = __webpack_require__(958);
	
	var _babelPresetFlow2 = _interopRequireDefault(_babelPresetFlow);
	
	var _babelPluginTransformReactJsx = __webpack_require__(954);
	
	var _babelPluginTransformReactJsx2 = _interopRequireDefault(_babelPluginTransformReactJsx);
	
	var _babelPluginSyntaxJsx = __webpack_require__(544);
	
	var _babelPluginSyntaxJsx2 = _interopRequireDefault(_babelPluginSyntaxJsx);
	
	var _babelPluginTransformReactDisplayName = __webpack_require__(953);
	
	var _babelPluginTransformReactDisplayName2 = _interopRequireDefault(_babelPluginTransformReactDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  presets: [_babelPresetFlow2.default],
	  plugins: [_babelPluginTransformReactJsx2.default, _babelPluginSyntaxJsx2.default, _babelPluginTransformReactDisplayName2.default],
	  env: {
	    development: {
	      plugins: []
	    }
	  }
	};
	module.exports = exports["default"];

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1034), __esModule: true };

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1038), __esModule: true };

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1039), __esModule: true };

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1042), __esModule: true };

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1044), __esModule: true };

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1047), __esModule: true };

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1050), __esModule: true };

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1052), __esModule: true };

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1053), __esModule: true };

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(549);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4452);


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["Babel"] = factory();
		else
			root["Babel"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ((function(modules) {
		// Check all modules for deduplicated modules
		for(var i in modules) {
			if(Object.prototype.hasOwnProperty.call(modules, i)) {
				switch(typeof modules[i]) {
				case "function": break;
				case "object":
					// Module can be created from a template
					modules[i] = (function(_m) {
						var args = _m.slice(1), fn = modules[_m[0]];
						return function (a,b,c) {
							fn.apply(this, [a,b,c].concat(args));
						};
					}(modules[i]));
					break;
				default:
					// Module is a copy of another module
					modules[i] = modules[modules[i]];
					break;
				}
			}
		}
		return modules;
	}([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.version = exports.buildExternalHelpers = exports.availablePresets = exports.availablePlugins = undefined;
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		exports.transform = transform;
		exports.transformFromAst = transformFromAst;
		exports.registerPlugin = registerPlugin;
		exports.registerPlugins = registerPlugins;
		exports.registerPreset = registerPreset;
		exports.registerPresets = registerPresets;
		exports.transformScriptTags = transformScriptTags;
		exports.disableScriptTags = disableScriptTags;
	
		var _babelCore = __webpack_require__(290);
	
		var Babel = _interopRequireWildcard(_babelCore);
	
		var _transformScriptTags = __webpack_require__(629);
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
		var isArray = Array.isArray || function (arg) {
		  return Object.prototype.toString.call(arg) === '[object Array]';
		};
	
		/**
		 * Loads the given name (or [name, options] pair) from the given table object
		 * holding the available presets or plugins.
		 *
		 * Returns undefined if the preset or plugin is not available; passes through
		 * name unmodified if it (or the first element of the pair) is not a string.
		 */
		function loadBuiltin(builtinTable, name) {
		  if (isArray(name) && typeof name[0] === 'string') {
		    if (builtinTable.hasOwnProperty(name[0])) {
		      return [builtinTable[name[0]]].concat(name.slice(1));
		    }
		    return;
		  } else if (typeof name === 'string') {
		    return builtinTable[name];
		  }
		  // Could be an actual preset/plugin module
		  return name;
		}
	
		/**
		 * Parses plugin names and presets from the specified options.
		 */
		function processOptions(options) {
		  // Parse preset names
		  var presets = (options.presets || []).map(function (presetName) {
		    var preset = loadBuiltin(availablePresets, presetName);
	
		    if (preset) {
		      // workaround for babel issue
		      // at some point, babel copies the preset, losing the non-enumerable
		      // buildPreset key; convert it into an enumerable key.
		      if (isArray(preset) && _typeof(preset[0]) === 'object' && preset[0].hasOwnProperty('buildPreset')) {
		        preset[0] = _extends({}, preset[0], { buildPreset: preset[0].buildPreset });
		      }
		    } else {
		      throw new Error('Invalid preset specified in Babel options: "' + presetName + '"');
		    }
		    return preset;
		  });
	
		  // Parse plugin names
		  var plugins = (options.plugins || []).map(function (pluginName) {
		    var plugin = loadBuiltin(availablePlugins, pluginName);
	
		    if (!plugin) {
		      throw new Error('Invalid plugin specified in Babel options: "' + pluginName + '"');
		    }
		    return plugin;
		  });
	
		  return _extends({
		    babelrc: false
		  }, options, {
		    presets: presets,
		    plugins: plugins
		  });
		}
	
		function transform(code, options) {
		  return Babel.transform(code, processOptions(options));
		}
	
		function transformFromAst(ast, code, options) {
		  return Babel.transformFromAst(ast, code, processOptions(options));
		}
		var availablePlugins = exports.availablePlugins = {};
		var availablePresets = exports.availablePresets = {};
		var buildExternalHelpers = exports.buildExternalHelpers = Babel.buildExternalHelpers;
		/**
		 * Registers a named plugin for use with Babel.
		 */
		function registerPlugin(name, plugin) {
		  if (availablePlugins.hasOwnProperty(name)) {
		    console.warn('A plugin named "' + name + '" is already registered, it will be overridden');
		  }
		  availablePlugins[name] = plugin;
		}
		/**
		 * Registers multiple plugins for use with Babel. `newPlugins` should be an object where the key
		 * is the name of the plugin, and the value is the plugin itself.
		 */
		function registerPlugins(newPlugins) {
		  Object.keys(newPlugins).forEach(function (name) {
		    return registerPlugin(name, newPlugins[name]);
		  });
		}
	
		/**
		 * Registers a named preset for use with Babel.
		 */
		function registerPreset(name, preset) {
		  if (availablePresets.hasOwnProperty(name)) {
		    console.warn('A preset named "' + name + '" is already registered, it will be overridden');
		  }
		  availablePresets[name] = preset;
		}
		/**
		 * Registers multiple presets for use with Babel. `newPresets` should be an object where the key
		 * is the name of the preset, and the value is the preset itself.
		 */
		function registerPresets(newPresets) {
		  Object.keys(newPresets).forEach(function (name) {
		    return registerPreset(name, newPresets[name]);
		  });
		}
	
		// All the plugins we should bundle
		registerPlugins({
		  'check-es2015-constants': __webpack_require__(66),
		  'external-helpers': __webpack_require__(322),
		  'inline-replace-variables': __webpack_require__(323),
		  'syntax-async-functions': __webpack_require__(67),
		  'syntax-async-generators': __webpack_require__(195),
		  'syntax-class-constructor-call': __webpack_require__(196),
		  'syntax-class-properties': __webpack_require__(197),
		  'syntax-decorators': __webpack_require__(125),
		  'syntax-do-expressions': __webpack_require__(198),
		  'syntax-exponentiation-operator': __webpack_require__(199),
		  'syntax-export-extensions': __webpack_require__(200),
		  'syntax-flow': __webpack_require__(126),
		  'syntax-function-bind': __webpack_require__(201),
		  'syntax-function-sent': __webpack_require__(325),
		  'syntax-jsx': __webpack_require__(127),
		  'syntax-object-rest-spread': __webpack_require__(202),
		  'syntax-trailing-function-commas': __webpack_require__(128),
		  'transform-async-functions': __webpack_require__(326),
		  'transform-async-to-generator': __webpack_require__(129),
		  'transform-async-to-module-method': __webpack_require__(328),
		  'transform-class-constructor-call': __webpack_require__(203),
		  'transform-class-properties': __webpack_require__(204),
		  'transform-decorators': __webpack_require__(205),
		  'transform-decorators-legacy': __webpack_require__(329).default, // <- No clue. Nope.
		  'transform-do-expressions': __webpack_require__(206),
		  'transform-es2015-arrow-functions': __webpack_require__(68),
		  'transform-es2015-block-scoped-functions': __webpack_require__(69),
		  'transform-es2015-block-scoping': __webpack_require__(70),
		  'transform-es2015-classes': __webpack_require__(71),
		  'transform-es2015-computed-properties': __webpack_require__(72),
		  'transform-es2015-destructuring': __webpack_require__(73),
		  'transform-es2015-duplicate-keys': __webpack_require__(130),
		  'transform-es2015-for-of': __webpack_require__(74),
		  'transform-es2015-function-name': __webpack_require__(75),
		  'transform-es2015-instanceof': __webpack_require__(332),
		  'transform-es2015-literals': __webpack_require__(76),
		  'transform-es2015-modules-amd': __webpack_require__(131),
		  'transform-es2015-modules-commonjs': __webpack_require__(77),
		  'transform-es2015-modules-systemjs': __webpack_require__(208),
		  'transform-es2015-modules-umd': __webpack_require__(209),
		  'transform-es2015-object-super': __webpack_require__(78),
		  'transform-es2015-parameters': __webpack_require__(79),
		  'transform-es2015-shorthand-properties': __webpack_require__(80),
		  'transform-es2015-spread': __webpack_require__(81),
		  'transform-es2015-sticky-regex': __webpack_require__(82),
		  'transform-es2015-template-literals': __webpack_require__(83),
		  'transform-es2015-typeof-symbol': __webpack_require__(84),
		  'transform-es2015-unicode-regex': __webpack_require__(85),
		  'transform-es3-member-expression-literals': __webpack_require__(336),
		  'transform-es3-property-literals': __webpack_require__(337),
		  'transform-es5-property-mutators': __webpack_require__(338),
		  'transform-eval': __webpack_require__(339),
		  'transform-exponentiation-operator': __webpack_require__(132),
		  'transform-export-extensions': __webpack_require__(210),
		  'transform-flow-comments': __webpack_require__(340),
		  'transform-flow-strip-types': __webpack_require__(211),
		  'transform-function-bind': __webpack_require__(212),
		  'transform-jscript': __webpack_require__(341),
		  'transform-object-assign': __webpack_require__(342),
		  'transform-object-rest-spread': __webpack_require__(213),
		  'transform-object-set-prototype-of-to-assign': __webpack_require__(343),
		  'transform-proto-to-assign': __webpack_require__(344),
		  'transform-react-constant-elements': __webpack_require__(345),
		  'transform-react-display-name': __webpack_require__(214),
		  'transform-react-inline-elements': __webpack_require__(346),
		  'transform-react-jsx': __webpack_require__(215),
		  'transform-react-jsx-compat': __webpack_require__(347),
		  'transform-react-jsx-self': __webpack_require__(349),
		  'transform-react-jsx-source': __webpack_require__(350),
		  'transform-regenerator': __webpack_require__(86),
		  'transform-runtime': __webpack_require__(353),
		  'transform-strict-mode': __webpack_require__(216),
		  'undeclared-variables-check': __webpack_require__(354)
		});
	
		// All the presets we should bundle
		registerPresets({
		  es2015: __webpack_require__(217),
		  es2016: __webpack_require__(218),
		  es2017: __webpack_require__(219),
		  latest: __webpack_require__(356),
		  react: __webpack_require__(357),
		  'stage-0': __webpack_require__(358),
		  'stage-1': __webpack_require__(220),
		  'stage-2': __webpack_require__(221),
		  'stage-3': __webpack_require__(222),
	
		  // ES2015 preset with es2015-modules-commonjs removed
		  // Plugin list copied from babel-preset-es2015/index.js
		  'es2015-no-commonjs': {
		    plugins: [__webpack_require__(83), __webpack_require__(76), __webpack_require__(75), __webpack_require__(68), __webpack_require__(69), __webpack_require__(71), __webpack_require__(78), __webpack_require__(80), __webpack_require__(72), __webpack_require__(74), __webpack_require__(82), __webpack_require__(85), __webpack_require__(66), __webpack_require__(81), __webpack_require__(79), __webpack_require__(73), __webpack_require__(70), __webpack_require__(84), [__webpack_require__(86), { async: false, asyncGenerators: false }]]
		  },
	
		  // ES2015 preset with plugins set to loose mode.
		  // Based off https://github.com/bkonkle/babel-preset-es2015-loose/blob/master/index.js
		  'es2015-loose': {
		    plugins: [[__webpack_require__(83), { loose: true }], __webpack_require__(76), __webpack_require__(75), __webpack_require__(68), __webpack_require__(69), [__webpack_require__(71), { loose: true }], __webpack_require__(78), __webpack_require__(80), __webpack_require__(130), [__webpack_require__(72), { loose: true }], [__webpack_require__(74), { loose: true }], __webpack_require__(82), __webpack_require__(85), __webpack_require__(66), [__webpack_require__(81), { loose: true }], __webpack_require__(79), [__webpack_require__(73), { loose: true }], __webpack_require__(70), __webpack_require__(84), [__webpack_require__(77), { loose: true }], [__webpack_require__(86), { async: false, asyncGenerators: false }]]
		  }
		});
	
		var version = exports.version = ("6.26.0");
	
		// Listen for load event if we're in a browser and then kick off finding and
		// running of scripts with "text/babel" type.
		if (typeof window !== 'undefined' && window && window.addEventListener) {
		  window.addEventListener('DOMContentLoaded', function () {
		    return transformScriptTags();
		  }, false);
		}
	
		/**
		 * Transform <script> tags with "text/babel" type.
		 * @param {Array} scriptTags specify script tags to transform, transform all in the <head> if not given
		 */
		function transformScriptTags(scriptTags) {
		  (0, _transformScriptTags.runScripts)(transform, scriptTags);
		}
	
		/**
		 * Disables automatic transformation of <script> tags with "text/babel" type.
		 */
		function disableScriptTags() {
		  window.removeEventListener('DOMContentLoaded', transformScriptTags);
		}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.createTypeAnnotationBasedOnTypeof = exports.removeTypeDuplicates = exports.createUnionTypeAnnotation = exports.valueToNode = exports.toBlock = exports.toExpression = exports.toStatement = exports.toBindingIdentifierName = exports.toIdentifier = exports.toKeyAlias = exports.toSequenceExpression = exports.toComputedKey = exports.isNodesEquivalent = exports.isImmutable = exports.isScope = exports.isSpecifierDefault = exports.isVar = exports.isBlockScoped = exports.isLet = exports.isValidIdentifier = exports.isReferenced = exports.isBinding = exports.getOuterBindingIdentifiers = exports.getBindingIdentifiers = exports.TYPES = exports.react = exports.DEPRECATED_KEYS = exports.BUILDER_KEYS = exports.NODE_FIELDS = exports.ALIAS_KEYS = exports.VISITOR_KEYS = exports.NOT_LOCAL_BINDING = exports.BLOCK_SCOPED_SYMBOL = exports.INHERIT_KEYS = exports.UNARY_OPERATORS = exports.STRING_UNARY_OPERATORS = exports.NUMBER_UNARY_OPERATORS = exports.BOOLEAN_UNARY_OPERATORS = exports.BINARY_OPERATORS = exports.NUMBER_BINARY_OPERATORS = exports.BOOLEAN_BINARY_OPERATORS = exports.COMPARISON_BINARY_OPERATORS = exports.EQUALITY_BINARY_OPERATORS = exports.BOOLEAN_NUMBER_BINARY_OPERATORS = exports.UPDATE_OPERATORS = exports.LOGICAL_OPERATORS = exports.COMMENT_KEYS = exports.FOR_INIT_KEYS = exports.FLATTENABLE_KEYS = exports.STATEMENT_OR_BLOCK_KEYS = undefined;
	
		var _getOwnPropertySymbols = __webpack_require__(360);
	
		var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _keys = __webpack_require__(14);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _stringify = __webpack_require__(35);
	
		var _stringify2 = _interopRequireDefault(_stringify);
	
		var _constants = __webpack_require__(135);
	
		Object.defineProperty(exports, "STATEMENT_OR_BLOCK_KEYS", {
		  enumerable: true,
		  get: function get() {
		    return _constants.STATEMENT_OR_BLOCK_KEYS;
		  }
		});
		Object.defineProperty(exports, "FLATTENABLE_KEYS", {
		  enumerable: true,
		  get: function get() {
		    return _constants.FLATTENABLE_KEYS;
		  }
		});
		Object.defineProperty(exports, "FOR_INIT_KEYS", {
		  enumerable: true,
		  get: function get() {
		    return _constants.FOR_INIT_KEYS;
		  }
		});
		Object.defineProperty(exports, "COMMENT_KEYS", {
		  enumerable: true,
		  get: function get() {
		    return _constants.COMMENT_KEYS;
		  }
		});
		Object.defineProperty(exports, "LOGICAL_OPERATORS", {
		  enumerable: true,
		  get: function get() {
		    return _constants.LOGICAL_OPERATORS;
		  }
		});
		Object.defineProperty(exports, "UPDATE_OPERATORS", {
		  enumerable: true,
		  get: function get() {
		    return _constants.UPDATE_OPERATORS;
		  }
		});
		Object.defineProperty(exports, "BOOLEAN_NUMBER_BINARY_OPERATORS", {
		  enumerable: true,
		  get: function get() {
		    return _constants.BOOLEAN_NUMBER_BINARY_OPERATORS;
		  }
		});
		Object.defineProperty(exports, "EQUALITY_BINARY_OPERATORS", {
		  enumerable: true,
		  get: function get() {
		    return _constants.EQUALITY_BINARY_OPERATORS;
		  }
		});
		Object.defineProperty(exports, "COMPARISON_BINARY_OPERATORS", {
		  enumerable: true,
		  get: function get() {
		    return _constants.COMPARISON_BINARY_OPERATORS;
		  }
		});
		Object.defineProperty(exports, "BOOLEAN_BINARY_OPERATORS", {
		  enumerable: true,
		  get: function get() {
		    return _constants.BOOLEAN_BINARY_OPERATORS;
		  }
		});
		Object.defineProperty(exports, "NUMBER_BINARY_OPERATORS", {
		  enumerable: true,
		  get: function get() {
		    return _constants.NUMBER_BINARY_OPERATORS;
		  }
		});
		Object.defineProperty(exports, "BINARY_OPERATORS", {
		  enumerable: true,
		  get: function get() {
		    return _constants.BINARY_OPERATORS;
		  }
		});
		Object.defineProperty(exports, "BOOLEAN_UNARY_OPERATORS", {
		  enumerable: true,
		  get: function get() {
		    return _constants.BOOLEAN_UNARY_OPERATORS;
		  }
		});
		Object.defineProperty(exports, "NUMBER_UNARY_OPERATORS", {
		  enumerable: true,
		  get: function get() {
		    return _constants.NUMBER_UNARY_OPERATORS;
		  }
		});
		Object.defineProperty(exports, "STRING_UNARY_OPERATORS", {
		  enumerable: true,
		  get: function get() {
		    return _constants.STRING_UNARY_OPERATORS;
		  }
		});
		Object.defineProperty(exports, "UNARY_OPERATORS", {
		  enumerable: true,
		  get: function get() {
		    return _constants.UNARY_OPERATORS;
		  }
		});
		Object.defineProperty(exports, "INHERIT_KEYS", {
		  enumerable: true,
		  get: function get() {
		    return _constants.INHERIT_KEYS;
		  }
		});
		Object.defineProperty(exports, "BLOCK_SCOPED_SYMBOL", {
		  enumerable: true,
		  get: function get() {
		    return _constants.BLOCK_SCOPED_SYMBOL;
		  }
		});
		Object.defineProperty(exports, "NOT_LOCAL_BINDING", {
		  enumerable: true,
		  get: function get() {
		    return _constants.NOT_LOCAL_BINDING;
		  }
		});
		exports.is = is;
		exports.isType = isType;
		exports.validate = validate;
		exports.shallowEqual = shallowEqual;
		exports.appendToMemberExpression = appendToMemberExpression;
		exports.prependToMemberExpression = prependToMemberExpression;
		exports.ensureBlock = ensureBlock;
		exports.clone = clone;
		exports.cloneWithoutLoc = cloneWithoutLoc;
		exports.cloneDeep = cloneDeep;
		exports.buildMatchMemberExpression = buildMatchMemberExpression;
		exports.removeComments = removeComments;
		exports.inheritsComments = inheritsComments;
		exports.inheritTrailingComments = inheritTrailingComments;
		exports.inheritLeadingComments = inheritLeadingComments;
		exports.inheritInnerComments = inheritInnerComments;
		exports.inherits = inherits;
		exports.assertNode = assertNode;
		exports.isNode = isNode;
		exports.traverseFast = traverseFast;
		exports.removeProperties = removeProperties;
		exports.removePropertiesDeep = removePropertiesDeep;
	
		var _retrievers = __webpack_require__(226);
	
		Object.defineProperty(exports, "getBindingIdentifiers", {
		  enumerable: true,
		  get: function get() {
		    return _retrievers.getBindingIdentifiers;
		  }
		});
		Object.defineProperty(exports, "getOuterBindingIdentifiers", {
		  enumerable: true,
		  get: function get() {
		    return _retrievers.getOuterBindingIdentifiers;
		  }
		});
	
		var _validators = __webpack_require__(395);
	
		Object.defineProperty(exports, "isBinding", {
		  enumerable: true,
		  get: function get() {
		    return _validators.isBinding;
		  }
		});
		Object.defineProperty(exports, "isReferenced", {
		  enumerable: true,
		  get: function get() {
		    return _validators.isReferenced;
		  }
		});
		Object.defineProperty(exports, "isValidIdentifier", {
		  enumerable: true,
		  get: function get() {
		    return _validators.isValidIdentifier;
		  }
		});
		Object.defineProperty(exports, "isLet", {
		  enumerable: true,
		  get: function get() {
		    return _validators.isLet;
		  }
		});
		Object.defineProperty(exports, "isBlockScoped", {
		  enumerable: true,
		  get: function get() {
		    return _validators.isBlockScoped;
		  }
		});
		Object.defineProperty(exports, "isVar", {
		  enumerable: true,
		  get: function get() {
		    return _validators.isVar;
		  }
		});
		Object.defineProperty(exports, "isSpecifierDefault", {
		  enumerable: true,
		  get: function get() {
		    return _validators.isSpecifierDefault;
		  }
		});
		Object.defineProperty(exports, "isScope", {
		  enumerable: true,
		  get: function get() {
		    return _validators.isScope;
		  }
		});
		Object.defineProperty(exports, "isImmutable", {
		  enumerable: true,
		  get: function get() {
		    return _validators.isImmutable;
		  }
		});
		Object.defineProperty(exports, "isNodesEquivalent", {
		  enumerable: true,
		  get: function get() {
		    return _validators.isNodesEquivalent;
		  }
		});
	
		var _converters = __webpack_require__(385);
	
		Object.defineProperty(exports, "toComputedKey", {
		  enumerable: true,
		  get: function get() {
		    return _converters.toComputedKey;
		  }
		});
		Object.defineProperty(exports, "toSequenceExpression", {
		  enumerable: true,
		  get: function get() {
		    return _converters.toSequenceExpression;
		  }
		});
		Object.defineProperty(exports, "toKeyAlias", {
		  enumerable: true,
		  get: function get() {
		    return _converters.toKeyAlias;
		  }
		});
		Object.defineProperty(exports, "toIdentifier", {
		  enumerable: true,
		  get: function get() {
		    return _converters.toIdentifier;
		  }
		});
		Object.defineProperty(exports, "toBindingIdentifierName", {
		  enumerable: true,
		  get: function get() {
		    return _converters.toBindingIdentifierName;
		  }
		});
		Object.defineProperty(exports, "toStatement", {
		  enumerable: true,
		  get: function get() {
		    return _converters.toStatement;
		  }
		});
		Object.defineProperty(exports, "toExpression", {
		  enumerable: true,
		  get: function get() {
		    return _converters.toExpression;
		  }
		});
		Object.defineProperty(exports, "toBlock", {
		  enumerable: true,
		  get: function get() {
		    return _converters.toBlock;
		  }
		});
		Object.defineProperty(exports, "valueToNode", {
		  enumerable: true,
		  get: function get() {
		    return _converters.valueToNode;
		  }
		});
	
		var _flow = __webpack_require__(393);
	
		Object.defineProperty(exports, "createUnionTypeAnnotation", {
		  enumerable: true,
		  get: function get() {
		    return _flow.createUnionTypeAnnotation;
		  }
		});
		Object.defineProperty(exports, "removeTypeDuplicates", {
		  enumerable: true,
		  get: function get() {
		    return _flow.removeTypeDuplicates;
		  }
		});
		Object.defineProperty(exports, "createTypeAnnotationBasedOnTypeof", {
		  enumerable: true,
		  get: function get() {
		    return _flow.createTypeAnnotationBasedOnTypeof;
		  }
		});
	
		var _toFastProperties = __webpack_require__(624);
	
		var _toFastProperties2 = _interopRequireDefault(_toFastProperties);
	
		var _clone = __webpack_require__(109);
	
		var _clone2 = _interopRequireDefault(_clone);
	
		var _uniq = __webpack_require__(600);
	
		var _uniq2 = _interopRequireDefault(_uniq);
	
		__webpack_require__(390);
	
		var _definitions = __webpack_require__(26);
	
		var _react2 = __webpack_require__(394);
	
		var _react = _interopRequireWildcard(_react2);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var t = exports;
	
		function registerType(type) {
		  var is = t["is" + type];
		  if (!is) {
		    is = t["is" + type] = function (node, opts) {
		      return t.is(type, node, opts);
		    };
		  }
	
		  t["assert" + type] = function (node, opts) {
		    opts = opts || {};
		    if (!is(node, opts)) {
		      throw new Error("Expected type " + (0, _stringify2.default)(type) + " with option " + (0, _stringify2.default)(opts));
		    }
		  };
		}
	
		exports.VISITOR_KEYS = _definitions.VISITOR_KEYS;
		exports.ALIAS_KEYS = _definitions.ALIAS_KEYS;
		exports.NODE_FIELDS = _definitions.NODE_FIELDS;
		exports.BUILDER_KEYS = _definitions.BUILDER_KEYS;
		exports.DEPRECATED_KEYS = _definitions.DEPRECATED_KEYS;
		exports.react = _react;
	
		for (var type in t.VISITOR_KEYS) {
		  registerType(type);
		}
	
		t.FLIPPED_ALIAS_KEYS = {};
	
		(0, _keys2.default)(t.ALIAS_KEYS).forEach(function (type) {
		  t.ALIAS_KEYS[type].forEach(function (alias) {
		    var types = t.FLIPPED_ALIAS_KEYS[alias] = t.FLIPPED_ALIAS_KEYS[alias] || [];
		    types.push(type);
		  });
		});
	
		(0, _keys2.default)(t.FLIPPED_ALIAS_KEYS).forEach(function (type) {
		  t[type.toUpperCase() + "_TYPES"] = t.FLIPPED_ALIAS_KEYS[type];
		  registerType(type);
		});
	
		var TYPES = exports.TYPES = (0, _keys2.default)(t.VISITOR_KEYS).concat((0, _keys2.default)(t.FLIPPED_ALIAS_KEYS)).concat((0, _keys2.default)(t.DEPRECATED_KEYS));
	
		function is(type, node, opts) {
		  if (!node) return false;
	
		  var matches = isType(node.type, type);
		  if (!matches) return false;
	
		  if (typeof opts === "undefined") {
		    return true;
		  } else {
		    return t.shallowEqual(node, opts);
		  }
		}
	
		function isType(nodeType, targetType) {
		  if (nodeType === targetType) return true;
	
		  if (t.ALIAS_KEYS[targetType]) return false;
	
		  var aliases = t.FLIPPED_ALIAS_KEYS[targetType];
		  if (aliases) {
		    if (aliases[0] === nodeType) return true;
	
		    for (var _iterator = aliases, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var alias = _ref;
	
		      if (nodeType === alias) return true;
		    }
		  }
	
		  return false;
		}
	
		(0, _keys2.default)(t.BUILDER_KEYS).forEach(function (type) {
		  var keys = t.BUILDER_KEYS[type];
	
		  function builder() {
		    if (arguments.length > keys.length) {
		      throw new Error("t." + type + ": Too many arguments passed. Received " + arguments.length + " but can receive " + ("no more than " + keys.length));
		    }
	
		    var node = {};
		    node.type = type;
	
		    var i = 0;
	
		    for (var _iterator2 = keys, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		      var _ref2;
	
		      if (_isArray2) {
		        if (_i2 >= _iterator2.length) break;
		        _ref2 = _iterator2[_i2++];
		      } else {
		        _i2 = _iterator2.next();
		        if (_i2.done) break;
		        _ref2 = _i2.value;
		      }
	
		      var _key = _ref2;
	
		      var field = t.NODE_FIELDS[type][_key];
	
		      var arg = arguments[i++];
		      if (arg === undefined) arg = (0, _clone2.default)(field.default);
	
		      node[_key] = arg;
		    }
	
		    for (var key in node) {
		      validate(node, key, node[key]);
		    }
	
		    return node;
		  }
	
		  t[type] = builder;
		  t[type[0].toLowerCase() + type.slice(1)] = builder;
		});
	
		var _loop = function _loop(_type) {
		  var newType = t.DEPRECATED_KEYS[_type];
	
		  function proxy(fn) {
		    return function () {
		      console.trace("The node type " + _type + " has been renamed to " + newType);
		      return fn.apply(this, arguments);
		    };
		  }
	
		  t[_type] = t[_type[0].toLowerCase() + _type.slice(1)] = proxy(t[newType]);
		  t["is" + _type] = proxy(t["is" + newType]);
		  t["assert" + _type] = proxy(t["assert" + newType]);
		};
	
		for (var _type in t.DEPRECATED_KEYS) {
		  _loop(_type);
		}
	
		function validate(node, key, val) {
		  if (!node) return;
	
		  var fields = t.NODE_FIELDS[node.type];
		  if (!fields) return;
	
		  var field = fields[key];
		  if (!field || !field.validate) return;
		  if (field.optional && val == null) return;
	
		  field.validate(node, key, val);
		}
	
		function shallowEqual(actual, expected) {
		  var keys = (0, _keys2.default)(expected);
	
		  for (var _iterator3 = keys, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		    var _ref3;
	
		    if (_isArray3) {
		      if (_i3 >= _iterator3.length) break;
		      _ref3 = _iterator3[_i3++];
		    } else {
		      _i3 = _iterator3.next();
		      if (_i3.done) break;
		      _ref3 = _i3.value;
		    }
	
		    var key = _ref3;
	
		    if (actual[key] !== expected[key]) {
		      return false;
		    }
		  }
	
		  return true;
		}
	
		function appendToMemberExpression(member, append, computed) {
		  member.object = t.memberExpression(member.object, member.property, member.computed);
		  member.property = append;
		  member.computed = !!computed;
		  return member;
		}
	
		function prependToMemberExpression(member, prepend) {
		  member.object = t.memberExpression(prepend, member.object);
		  return member;
		}
	
		function ensureBlock(node) {
		  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "body";
	
		  return node[key] = t.toBlock(node[key], node);
		}
	
		function clone(node) {
		  if (!node) return node;
		  var newNode = {};
		  for (var key in node) {
		    if (key[0] === "_") continue;
		    newNode[key] = node[key];
		  }
		  return newNode;
		}
	
		function cloneWithoutLoc(node) {
		  var newNode = clone(node);
		  delete newNode.loc;
		  return newNode;
		}
	
		function cloneDeep(node) {
		  if (!node) return node;
		  var newNode = {};
	
		  for (var key in node) {
		    if (key[0] === "_") continue;
	
		    var val = node[key];
	
		    if (val) {
		      if (val.type) {
		        val = t.cloneDeep(val);
		      } else if (Array.isArray(val)) {
		        val = val.map(t.cloneDeep);
		      }
		    }
	
		    newNode[key] = val;
		  }
	
		  return newNode;
		}
	
		function buildMatchMemberExpression(match, allowPartial) {
		  var parts = match.split(".");
	
		  return function (member) {
		    if (!t.isMemberExpression(member)) return false;
	
		    var search = [member];
		    var i = 0;
	
		    while (search.length) {
		      var node = search.shift();
	
		      if (allowPartial && i === parts.length) {
		        return true;
		      }
	
		      if (t.isIdentifier(node)) {
		        if (parts[i] !== node.name) return false;
		      } else if (t.isStringLiteral(node)) {
		        if (parts[i] !== node.value) return false;
		      } else if (t.isMemberExpression(node)) {
		        if (node.computed && !t.isStringLiteral(node.property)) {
		          return false;
		        } else {
		          search.push(node.object);
		          search.push(node.property);
		          continue;
		        }
		      } else {
		        return false;
		      }
	
		      if (++i > parts.length) {
		        return false;
		      }
		    }
	
		    return true;
		  };
		}
	
		function removeComments(node) {
		  for (var _iterator4 = t.COMMENT_KEYS, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
		    var _ref4;
	
		    if (_isArray4) {
		      if (_i4 >= _iterator4.length) break;
		      _ref4 = _iterator4[_i4++];
		    } else {
		      _i4 = _iterator4.next();
		      if (_i4.done) break;
		      _ref4 = _i4.value;
		    }
	
		    var key = _ref4;
	
		    delete node[key];
		  }
		  return node;
		}
	
		function inheritsComments(child, parent) {
		  inheritTrailingComments(child, parent);
		  inheritLeadingComments(child, parent);
		  inheritInnerComments(child, parent);
		  return child;
		}
	
		function inheritTrailingComments(child, parent) {
		  _inheritComments("trailingComments", child, parent);
		}
	
		function inheritLeadingComments(child, parent) {
		  _inheritComments("leadingComments", child, parent);
		}
	
		function inheritInnerComments(child, parent) {
		  _inheritComments("innerComments", child, parent);
		}
	
		function _inheritComments(key, child, parent) {
		  if (child && parent) {
		    child[key] = (0, _uniq2.default)([].concat(child[key], parent[key]).filter(Boolean));
		  }
		}
	
		function inherits(child, parent) {
		  if (!child || !parent) return child;
	
		  for (var _iterator5 = t.INHERIT_KEYS.optional, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : (0, _getIterator3.default)(_iterator5);;) {
		    var _ref5;
	
		    if (_isArray5) {
		      if (_i5 >= _iterator5.length) break;
		      _ref5 = _iterator5[_i5++];
		    } else {
		      _i5 = _iterator5.next();
		      if (_i5.done) break;
		      _ref5 = _i5.value;
		    }
	
		    var _key2 = _ref5;
	
		    if (child[_key2] == null) {
		      child[_key2] = parent[_key2];
		    }
		  }
	
		  for (var key in parent) {
		    if (key[0] === "_") child[key] = parent[key];
		  }
	
		  for (var _iterator6 = t.INHERIT_KEYS.force, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : (0, _getIterator3.default)(_iterator6);;) {
		    var _ref6;
	
		    if (_isArray6) {
		      if (_i6 >= _iterator6.length) break;
		      _ref6 = _iterator6[_i6++];
		    } else {
		      _i6 = _iterator6.next();
		      if (_i6.done) break;
		      _ref6 = _i6.value;
		    }
	
		    var _key3 = _ref6;
	
		    child[_key3] = parent[_key3];
		  }
	
		  t.inheritsComments(child, parent);
	
		  return child;
		}
	
		function assertNode(node) {
		  if (!isNode(node)) {
		    throw new TypeError("Not a valid node " + (node && node.type));
		  }
		}
	
		function isNode(node) {
		  return !!(node && _definitions.VISITOR_KEYS[node.type]);
		}
	
		(0, _toFastProperties2.default)(t);
		(0, _toFastProperties2.default)(t.VISITOR_KEYS);
	
		function traverseFast(node, enter, opts) {
		  if (!node) return;
	
		  var keys = t.VISITOR_KEYS[node.type];
		  if (!keys) return;
	
		  opts = opts || {};
		  enter(node, opts);
	
		  for (var _iterator7 = keys, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : (0, _getIterator3.default)(_iterator7);;) {
		    var _ref7;
	
		    if (_isArray7) {
		      if (_i7 >= _iterator7.length) break;
		      _ref7 = _iterator7[_i7++];
		    } else {
		      _i7 = _iterator7.next();
		      if (_i7.done) break;
		      _ref7 = _i7.value;
		    }
	
		    var key = _ref7;
	
		    var subNode = node[key];
	
		    if (Array.isArray(subNode)) {
		      for (var _iterator8 = subNode, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : (0, _getIterator3.default)(_iterator8);;) {
		        var _ref8;
	
		        if (_isArray8) {
		          if (_i8 >= _iterator8.length) break;
		          _ref8 = _iterator8[_i8++];
		        } else {
		          _i8 = _iterator8.next();
		          if (_i8.done) break;
		          _ref8 = _i8.value;
		        }
	
		        var _node = _ref8;
	
		        traverseFast(_node, enter, opts);
		      }
		    } else {
		      traverseFast(subNode, enter, opts);
		    }
		  }
		}
	
		var CLEAR_KEYS = ["tokens", "start", "end", "loc", "raw", "rawValue"];
	
		var CLEAR_KEYS_PLUS_COMMENTS = t.COMMENT_KEYS.concat(["comments"]).concat(CLEAR_KEYS);
	
		function removeProperties(node, opts) {
		  opts = opts || {};
		  var map = opts.preserveComments ? CLEAR_KEYS : CLEAR_KEYS_PLUS_COMMENTS;
		  for (var _iterator9 = map, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : (0, _getIterator3.default)(_iterator9);;) {
		    var _ref9;
	
		    if (_isArray9) {
		      if (_i9 >= _iterator9.length) break;
		      _ref9 = _iterator9[_i9++];
		    } else {
		      _i9 = _iterator9.next();
		      if (_i9.done) break;
		      _ref9 = _i9.value;
		    }
	
		    var _key4 = _ref9;
	
		    if (node[_key4] != null) node[_key4] = undefined;
		  }
	
		  for (var key in node) {
		    if (key[0] === "_" && node[key] != null) node[key] = undefined;
		  }
	
		  var syms = (0, _getOwnPropertySymbols2.default)(node);
		  for (var _iterator10 = syms, _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : (0, _getIterator3.default)(_iterator10);;) {
		    var _ref10;
	
		    if (_isArray10) {
		      if (_i10 >= _iterator10.length) break;
		      _ref10 = _iterator10[_i10++];
		    } else {
		      _i10 = _iterator10.next();
		      if (_i10.done) break;
		      _ref10 = _i10.value;
		    }
	
		    var sym = _ref10;
	
		    node[sym] = null;
		  }
		}
	
		function removePropertiesDeep(tree, opts) {
		  traverseFast(tree, removeProperties, opts);
		  return tree;
		}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		module.exports = { "default": __webpack_require__(404), __esModule: true };
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		};
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _symbol = __webpack_require__(10);
	
		var _symbol2 = _interopRequireDefault(_symbol);
	
		exports.default = function (code, opts) {
		  var stack = void 0;
		  try {
		    throw new Error();
		  } catch (error) {
		    if (error.stack) {
		      stack = error.stack.split("\n").slice(1).join("\n");
		    }
		  }
	
		  opts = (0, _assign2.default)({
		    allowReturnOutsideFunction: true,
		    allowSuperOutsideMethod: true,
		    preserveComments: false
		  }, opts);
	
		  var _getAst = function getAst() {
		    var ast = void 0;
	
		    try {
		      ast = babylon.parse(code, opts);
	
		      ast = _babelTraverse2.default.removeProperties(ast, { preserveComments: opts.preserveComments });
	
		      _babelTraverse2.default.cheap(ast, function (node) {
		        node[FROM_TEMPLATE] = true;
		      });
		    } catch (err) {
		      err.stack = err.stack + "from\n" + stack;
		      throw err;
		    }
	
		    _getAst = function getAst() {
		      return ast;
		    };
	
		    return ast;
		  };
	
		  return function () {
		    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		      args[_key] = arguments[_key];
		    }
	
		    return useTemplate(_getAst(), args);
		  };
		};
	
		var _cloneDeep = __webpack_require__(574);
	
		var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
		var _assign = __webpack_require__(174);
	
		var _assign2 = _interopRequireDefault(_assign);
	
		var _has = __webpack_require__(274);
	
		var _has2 = _interopRequireDefault(_has);
	
		var _babelTraverse = __webpack_require__(7);
	
		var _babelTraverse2 = _interopRequireDefault(_babelTraverse);
	
		var _babylon = __webpack_require__(89);
	
		var babylon = _interopRequireWildcard(_babylon);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var FROM_TEMPLATE = "_fromTemplate";
		var TEMPLATE_SKIP = (0, _symbol2.default)();
	
		function useTemplate(ast, nodes) {
		  ast = (0, _cloneDeep2.default)(ast);
		  var _ast = ast,
		      program = _ast.program;
	
		  if (nodes.length) {
		    (0, _babelTraverse2.default)(ast, templateVisitor, null, nodes);
		  }
	
		  if (program.body.length > 1) {
		    return program.body;
		  } else {
		    return program.body[0];
		  }
		}
	
		var templateVisitor = {
		  noScope: true,
	
		  enter: function enter(path, args) {
		    var node = path.node;
	
		    if (node[TEMPLATE_SKIP]) return path.skip();
	
		    if (t.isExpressionStatement(node)) {
		      node = node.expression;
		    }
	
		    var replacement = void 0;
	
		    if (t.isIdentifier(node) && node[FROM_TEMPLATE]) {
		      if ((0, _has2.default)(args[0], node.name)) {
		        replacement = args[0][node.name];
		      } else if (node.name[0] === "$") {
		        var i = +node.name.slice(1);
		        if (args[i]) replacement = args[i];
		      }
		    }
	
		    if (replacement === null) {
		      path.remove();
		    }
	
		    if (replacement) {
		      replacement[TEMPLATE_SKIP] = true;
		      path.replaceInline(replacement);
		    }
		  },
		  exit: function exit(_ref) {
		    var node = _ref.node;
	
		    if (!node.loc) _babelTraverse2.default.clearNode(node);
		  }
		};
		module.exports = exports["default"];
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var core = module.exports = { version: '2.5.0' };
		if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(document.body.children);
		 * // => false
		 *
		 * _.isArray('abc');
		 * // => false
		 *
		 * _.isArray(_.noop);
		 * // => false
		 */
		var isArray = Array.isArray;
	
		module.exports = isArray;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.visitors = exports.Hub = exports.Scope = exports.NodePath = undefined;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _path = __webpack_require__(36);
	
		Object.defineProperty(exports, "NodePath", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_path).default;
		  }
		});
	
		var _scope = __webpack_require__(134);
	
		Object.defineProperty(exports, "Scope", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_scope).default;
		  }
		});
	
		var _hub = __webpack_require__(223);
	
		Object.defineProperty(exports, "Hub", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_hub).default;
		  }
		});
		exports.default = traverse;
	
		var _context = __webpack_require__(367);
	
		var _context2 = _interopRequireDefault(_context);
	
		var _visitors = __webpack_require__(384);
	
		var visitors = _interopRequireWildcard(_visitors);
	
		var _babelMessages = __webpack_require__(20);
	
		var messages = _interopRequireWildcard(_babelMessages);
	
		var _includes = __webpack_require__(111);
	
		var _includes2 = _interopRequireDefault(_includes);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		var _cache = __webpack_require__(88);
	
		var cache = _interopRequireWildcard(_cache);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		exports.visitors = visitors;
		function traverse(parent, opts, scope, state, parentPath) {
		  if (!parent) return;
		  if (!opts) opts = {};
	
		  if (!opts.noScope && !scope) {
		    if (parent.type !== "Program" && parent.type !== "File") {
		      throw new Error(messages.get("traverseNeedsParent", parent.type));
		    }
		  }
	
		  visitors.explode(opts);
	
		  traverse.node(parent, opts, scope, state, parentPath);
		}
	
		traverse.visitors = visitors;
		traverse.verify = visitors.verify;
		traverse.explode = visitors.explode;
	
		traverse.NodePath = __webpack_require__(36);
		traverse.Scope = __webpack_require__(134);
		traverse.Hub = __webpack_require__(223);
	
		traverse.cheap = function (node, enter) {
		  return t.traverseFast(node, enter);
		};
	
		traverse.node = function (node, opts, scope, state, parentPath, skipKeys) {
		  var keys = t.VISITOR_KEYS[node.type];
		  if (!keys) return;
	
		  var context = new _context2.default(scope, opts, state, parentPath);
		  for (var _iterator = keys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		    var _ref;
	
		    if (_isArray) {
		      if (_i >= _iterator.length) break;
		      _ref = _iterator[_i++];
		    } else {
		      _i = _iterator.next();
		      if (_i.done) break;
		      _ref = _i.value;
		    }
	
		    var key = _ref;
	
		    if (skipKeys && skipKeys[key]) continue;
		    if (context.visit(node, key)) return;
		  }
		};
	
		traverse.clearNode = function (node, opts) {
		  t.removeProperties(node, opts);
	
		  cache.path.delete(node);
		};
	
		traverse.removeProperties = function (tree, opts) {
		  t.traverseFast(tree, traverse.clearNode, opts);
		  return tree;
		};
	
		function hasBlacklistedType(path, state) {
		  if (path.node.type === state.type) {
		    state.has = true;
		    path.stop();
		  }
		}
	
		traverse.hasType = function (tree, scope, type, blacklistTypes) {
		  if ((0, _includes2.default)(blacklistTypes, tree.type)) return false;
	
		  if (tree.type === type) return true;
	
		  var state = {
		    has: false,
		    type: type
		  };
	
		  traverse(tree, {
		    blacklist: blacklistTypes,
		    enter: hasBlacklistedType
		  }, scope, state);
	
		  return state.has;
		};
	
		traverse.clearCache = function () {
		  cache.clear();
		};
	
		traverse.clearCache.clearPath = cache.clearPath;
		traverse.clearCache.clearScope = cache.clearScope;
	
		traverse.copyCache = function (source, destination) {
		  if (cache.path.has(source)) {
		    cache.path.set(destination, cache.path.get(source));
		  }
		};
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		// shim for using process in browser
		var process = module.exports = {};
	
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
	
		var cachedSetTimeout;
		var cachedClearTimeout;
	
		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout() {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		})();
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch (e) {
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch (e) {
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }
		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e) {
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e) {
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }
		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
	
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
	
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;
	
		    var len = queue.length;
		    while (len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}
	
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};
	
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
	
		function noop() {}
	
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		process.prependListener = noop;
		process.prependOnceListener = noop;
	
		process.listeners = function (name) {
		    return [];
		};
	
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
	
		process.cwd = function () {
		    return '/';
		};
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function () {
		    return 0;
		};
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		module.exports = { "default": __webpack_require__(409), __esModule: true };
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		module.exports = { "default": __webpack_require__(414), __esModule: true };
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		exports.__esModule = true;
	
		var _iterator = __webpack_require__(363);
	
		var _iterator2 = _interopRequireDefault(_iterator);
	
		var _symbol = __webpack_require__(10);
	
		var _symbol2 = _interopRequireDefault(_symbol);
	
		var _typeof = typeof _symbol2.default === "function" && _typeof2(_iterator2.default) === "symbol" ? function (obj) {
		  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
		} : function (obj) {
		  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
		};
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
		  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
		} : function (obj) {
		  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
		};
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var global = __webpack_require__(15);
		var core = __webpack_require__(5);
		var ctx = __webpack_require__(43);
		var hide = __webpack_require__(29);
		var PROTOTYPE = 'prototype';
	
		var $export = function $export(type, name, source) {
		  var IS_FORCED = type & $export.F;
		  var IS_GLOBAL = type & $export.G;
		  var IS_STATIC = type & $export.S;
		  var IS_PROTO = type & $export.P;
		  var IS_BIND = type & $export.B;
		  var IS_WRAP = type & $export.W;
		  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
		  var expProto = exports[PROTOTYPE];
		  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
		  var key, own, out;
		  if (IS_GLOBAL) source = name;
		  for (key in source) {
		    // contains in native
		    own = !IS_FORCED && target && target[key] !== undefined;
		    if (own && key in exports) continue;
		    // export native or passed
		    out = own ? target[key] : source[key];
		    // prevent global pollution for namespaces
		    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
		    // bind timers to global for call from export context
		    : IS_BIND && own ? ctx(out, global)
		    // wrap global constructors for prevent change them in library
		    : IS_WRAP && target[key] == out ? function (C) {
		      var F = function F(a, b, c) {
		        if (this instanceof C) {
		          switch (arguments.length) {
		            case 0:
		              return new C();
		            case 1:
		              return new C(a);
		            case 2:
		              return new C(a, b);
		          }return new C(a, b, c);
		        }return C.apply(this, arguments);
		      };
		      F[PROTOTYPE] = C[PROTOTYPE];
		      return F;
		      // make static versions for prototype methods
		    }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
		    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
		    if (IS_PROTO) {
		      (exports.virtual || (exports.virtual = {}))[key] = out;
		      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
		      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
		    }
		  }
		};
		// type bitmap
		$export.F = 1; // forced
		$export.G = 2; // global
		$export.S = 4; // static
		$export.P = 8; // proto
		$export.B = 16; // bind
		$export.W = 32; // wrap
		$export.U = 64; // safe
		$export.R = 128; // real proto method for `library`
		module.exports = $export;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var store = __webpack_require__(151)('wks');
		var uid = __webpack_require__(95);
		var _Symbol = __webpack_require__(15).Symbol;
		var USE_SYMBOL = typeof _Symbol == 'function';
	
		var $exports = module.exports = function (name) {
		  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
		};
	
		$exports.store = store;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		module.exports = { "default": __webpack_require__(411), __esModule: true };
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
		var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
		// eslint-disable-next-line no-new-func
		: Function('return this')();
		if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		module.exports = function (it) {
		  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
		};
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var freeGlobal = __webpack_require__(261);
	
		/** Detect free variable `self`. */
		var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;
	
		/** Used as a reference to the global object. */
		var root = freeGlobal || freeSelf || Function('return this')();
	
		module.exports = root;
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		/**
		 * Checks if `value` is the
		 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(_.noop);
		 * // => true
		 *
		 * _.isObject(null);
		 * // => false
		 */
		function isObject(value) {
		  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		  return value != null && (type == 'object' || type == 'function');
		}
	
		module.exports = isObject;
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
		// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
		// resolves . and .. elements in a path array with directory names there
		// must be no slashes, empty elements, or device names (c:\) in the array
		// (so also no leading and trailing slashes - it does not distinguish
		// relative and absolute paths)
		function normalizeArray(parts, allowAboveRoot) {
		  // if the path tries to go above the root, `up` ends up > 0
		  var up = 0;
		  for (var i = parts.length - 1; i >= 0; i--) {
		    var last = parts[i];
		    if (last === '.') {
		      parts.splice(i, 1);
		    } else if (last === '..') {
		      parts.splice(i, 1);
		      up++;
		    } else if (up) {
		      parts.splice(i, 1);
		      up--;
		    }
		  }
	
		  // if the path is allowed to go above the root, restore leading ..s
		  if (allowAboveRoot) {
		    for (; up--; up) {
		      parts.unshift('..');
		    }
		  }
	
		  return parts;
		}
	
		// Split a filename into [root, dir, basename, ext], unix version
		// 'root' is just a slash, or nothing.
		var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
		var splitPath = function splitPath(filename) {
		  return splitPathRe.exec(filename).slice(1);
		};
	
		// path.resolve([from ...], to)
		// posix version
		exports.resolve = function () {
		  var resolvedPath = '',
		      resolvedAbsolute = false;
	
		  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
		    var path = i >= 0 ? arguments[i] : process.cwd();
	
		    // Skip empty and invalid entries
		    if (typeof path !== 'string') {
		      throw new TypeError('Arguments to path.resolve must be strings');
		    } else if (!path) {
		      continue;
		    }
	
		    resolvedPath = path + '/' + resolvedPath;
		    resolvedAbsolute = path.charAt(0) === '/';
		  }
	
		  // At this point the path should be resolved to a full absolute path, but
		  // handle relative paths to be safe (might happen when process.cwd() fails)
	
		  // Normalize the path
		  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function (p) {
		    return !!p;
		  }), !resolvedAbsolute).join('/');
	
		  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
		};
	
		// path.normalize(path)
		// posix version
		exports.normalize = function (path) {
		  var isAbsolute = exports.isAbsolute(path),
		      trailingSlash = substr(path, -1) === '/';
	
		  // Normalize the path
		  path = normalizeArray(filter(path.split('/'), function (p) {
		    return !!p;
		  }), !isAbsolute).join('/');
	
		  if (!path && !isAbsolute) {
		    path = '.';
		  }
		  if (path && trailingSlash) {
		    path += '/';
		  }
	
		  return (isAbsolute ? '/' : '') + path;
		};
	
		// posix version
		exports.isAbsolute = function (path) {
		  return path.charAt(0) === '/';
		};
	
		// posix version
		exports.join = function () {
		  var paths = Array.prototype.slice.call(arguments, 0);
		  return exports.normalize(filter(paths, function (p, index) {
		    if (typeof p !== 'string') {
		      throw new TypeError('Arguments to path.join must be strings');
		    }
		    return p;
		  }).join('/'));
		};
	
		// path.relative(from, to)
		// posix version
		exports.relative = function (from, to) {
		  from = exports.resolve(from).substr(1);
		  to = exports.resolve(to).substr(1);
	
		  function trim(arr) {
		    var start = 0;
		    for (; start < arr.length; start++) {
		      if (arr[start] !== '') break;
		    }
	
		    var end = arr.length - 1;
		    for (; end >= 0; end--) {
		      if (arr[end] !== '') break;
		    }
	
		    if (start > end) return [];
		    return arr.slice(start, end - start + 1);
		  }
	
		  var fromParts = trim(from.split('/'));
		  var toParts = trim(to.split('/'));
	
		  var length = Math.min(fromParts.length, toParts.length);
		  var samePartsLength = length;
		  for (var i = 0; i < length; i++) {
		    if (fromParts[i] !== toParts[i]) {
		      samePartsLength = i;
		      break;
		    }
		  }
	
		  var outputParts = [];
		  for (var i = samePartsLength; i < fromParts.length; i++) {
		    outputParts.push('..');
		  }
	
		  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
		  return outputParts.join('/');
		};
	
		exports.sep = '/';
		exports.delimiter = ':';
	
		exports.dirname = function (path) {
		  var result = splitPath(path),
		      root = result[0],
		      dir = result[1];
	
		  if (!root && !dir) {
		    // No dirname whatsoever
		    return '.';
		  }
	
		  if (dir) {
		    // It has a dirname, strip trailing slash
		    dir = dir.substr(0, dir.length - 1);
		  }
	
		  return root + dir;
		};
	
		exports.basename = function (path, ext) {
		  var f = splitPath(path)[2];
		  // TODO: make this comparison case-insensitive on windows?
		  if (ext && f.substr(-1 * ext.length) === ext) {
		    f = f.substr(0, f.length - ext.length);
		  }
		  return f;
		};
	
		exports.extname = function (path) {
		  return splitPath(path)[3];
		};
	
		function filter(xs, f) {
		  if (xs.filter) return xs.filter(f);
		  var res = [];
		  for (var i = 0; i < xs.length; i++) {
		    if (f(xs[i], i, xs)) res.push(xs[i]);
		  }
		  return res;
		}
	
		// String.prototype.substr - negative index don't work in IE8
		var substr = 'ab'.substr(-1) === 'b' ? function (str, start, len) {
		  return str.substr(start, len);
		} : function (str, start, len) {
		  if (start < 0) start = str.length + start;
		  return str.substr(start, len);
		};
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.MESSAGES = undefined;
	
		var _stringify = __webpack_require__(35);
	
		var _stringify2 = _interopRequireDefault(_stringify);
	
		exports.get = get;
		exports.parseArgs = parseArgs;
	
		var _util = __webpack_require__(117);
	
		var util = _interopRequireWildcard(_util);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var MESSAGES = exports.MESSAGES = {
		  tailCallReassignmentDeopt: "Function reference has been reassigned, so it will probably be dereferenced, therefore we can't optimise this with confidence",
		  classesIllegalBareSuper: "Illegal use of bare super",
		  classesIllegalSuperCall: "Direct super call is illegal in non-constructor, use super.$1() instead",
		  scopeDuplicateDeclaration: "Duplicate declaration $1",
		  settersNoRest: "Setters aren't allowed to have a rest",
		  noAssignmentsInForHead: "No assignments allowed in for-in/of head",
		  expectedMemberExpressionOrIdentifier: "Expected type MemberExpression or Identifier",
		  invalidParentForThisNode: "We don't know how to handle this node within the current parent - please open an issue",
		  readOnly: "$1 is read-only",
		  unknownForHead: "Unknown node type $1 in ForStatement",
		  didYouMean: "Did you mean $1?",
		  codeGeneratorDeopt: "Note: The code generator has deoptimised the styling of $1 as it exceeds the max of $2.",
		  missingTemplatesDirectory: "no templates directory - this is most likely the result of a broken `npm publish`. Please report to https://github.com/babel/babel/issues",
		  unsupportedOutputType: "Unsupported output type $1",
		  illegalMethodName: "Illegal method name $1",
		  lostTrackNodePath: "We lost track of this node's position, likely because the AST was directly manipulated",
	
		  modulesIllegalExportName: "Illegal export $1",
		  modulesDuplicateDeclarations: "Duplicate module declarations with the same source but in different scopes",
	
		  undeclaredVariable: "Reference to undeclared variable $1",
		  undeclaredVariableType: "Referencing a type alias outside of a type annotation",
		  undeclaredVariableSuggestion: "Reference to undeclared variable $1 - did you mean $2?",
	
		  traverseNeedsParent: "You must pass a scope and parentPath unless traversing a Program/File. Instead of that you tried to traverse a $1 node without passing scope and parentPath.",
		  traverseVerifyRootFunction: "You passed `traverse()` a function when it expected a visitor object, are you sure you didn't mean `{ enter: Function }`?",
		  traverseVerifyVisitorProperty: "You passed `traverse()` a visitor object with the property $1 that has the invalid property $2",
		  traverseVerifyNodeType: "You gave us a visitor for the node type $1 but it's not a valid type",
	
		  pluginNotObject: "Plugin $2 specified in $1 was expected to return an object when invoked but returned $3",
		  pluginNotFunction: "Plugin $2 specified in $1 was expected to return a function but returned $3",
		  pluginUnknown: "Unknown plugin $1 specified in $2 at $3, attempted to resolve relative to $4",
		  pluginInvalidProperty: "Plugin $2 specified in $1 provided an invalid property of $3"
		};
	
		function get(key) {
		  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		    args[_key - 1] = arguments[_key];
		  }
	
		  var msg = MESSAGES[key];
		  if (!msg) throw new ReferenceError("Unknown message " + (0, _stringify2.default)(key));
	
		  args = parseArgs(args);
	
		  return msg.replace(/\$(\d+)/g, function (str, i) {
		    return args[i - 1];
		  });
		}
	
		function parseArgs(args) {
		  return args.map(function (val) {
		    if (val != null && val.inspect) {
		      return val.inspect();
		    } else {
		      try {
		        return (0, _stringify2.default)(val) || val + "";
		      } catch (e) {
		        return util.inspect(val);
		      }
		    }
		  });
		}
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isObject = __webpack_require__(16);
		module.exports = function (it) {
		  if (!isObject(it)) throw TypeError(it + ' is not an object!');
		  return it;
		};
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// Thank's IE8 for his funny defineProperty
		module.exports = !__webpack_require__(27)(function () {
		  return Object.defineProperty({}, 'a', { get: function get() {
		      return 7;
		    } }).a != 7;
		});
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var anObject = __webpack_require__(21);
		var IE8_DOM_DEFINE = __webpack_require__(231);
		var toPrimitive = __webpack_require__(154);
		var dP = Object.defineProperty;
	
		exports.f = __webpack_require__(22) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
		  anObject(O);
		  P = toPrimitive(P, true);
		  anObject(Attributes);
		  if (IE8_DOM_DEFINE) try {
		    return dP(O, P, Attributes);
		  } catch (e) {/* empty */}
		  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
		  if ('value' in Attributes) O[P] = Attributes.value;
		  return O;
		};
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isFunction = __webpack_require__(175),
		    isLength = __webpack_require__(176);
	
		/**
		 * Checks if `value` is array-like. A value is considered array-like if it's
		 * not a function and has a `value.length` that's an integer greater than or
		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 * @example
		 *
		 * _.isArrayLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLike(document.body.children);
		 * // => true
		 *
		 * _.isArrayLike('abc');
		 * // => true
		 *
		 * _.isArrayLike(_.noop);
		 * // => false
		 */
		function isArrayLike(value) {
		  return value != null && isLength(value.length) && !isFunction(value);
		}
	
		module.exports = isArrayLike;
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		/**
		 * Checks if `value` is object-like. A value is object-like if it's not `null`
		 * and has a `typeof` result of "object".
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 * @example
		 *
		 * _.isObjectLike({});
		 * // => true
		 *
		 * _.isObjectLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isObjectLike(_.noop);
		 * // => false
		 *
		 * _.isObjectLike(null);
		 * // => false
		 */
		function isObjectLike(value) {
		  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
		}
	
		module.exports = isObjectLike;
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.DEPRECATED_KEYS = exports.BUILDER_KEYS = exports.NODE_FIELDS = exports.ALIAS_KEYS = exports.VISITOR_KEYS = undefined;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _stringify = __webpack_require__(35);
	
		var _stringify2 = _interopRequireDefault(_stringify);
	
		var _typeof2 = __webpack_require__(11);
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		exports.assertEach = assertEach;
		exports.assertOneOf = assertOneOf;
		exports.assertNodeType = assertNodeType;
		exports.assertNodeOrValueType = assertNodeOrValueType;
		exports.assertValueType = assertValueType;
		exports.chain = chain;
		exports.default = defineType;
	
		var _index = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_index);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var VISITOR_KEYS = exports.VISITOR_KEYS = {};
		var ALIAS_KEYS = exports.ALIAS_KEYS = {};
		var NODE_FIELDS = exports.NODE_FIELDS = {};
		var BUILDER_KEYS = exports.BUILDER_KEYS = {};
		var DEPRECATED_KEYS = exports.DEPRECATED_KEYS = {};
	
		function getType(val) {
		  if (Array.isArray(val)) {
		    return "array";
		  } else if (val === null) {
		    return "null";
		  } else if (val === undefined) {
		    return "undefined";
		  } else {
		    return typeof val === "undefined" ? "undefined" : (0, _typeof3.default)(val);
		  }
		}
	
		function assertEach(callback) {
		  function validator(node, key, val) {
		    if (!Array.isArray(val)) return;
	
		    for (var i = 0; i < val.length; i++) {
		      callback(node, key + "[" + i + "]", val[i]);
		    }
		  }
		  validator.each = callback;
		  return validator;
		}
	
		function assertOneOf() {
		  for (var _len = arguments.length, vals = Array(_len), _key = 0; _key < _len; _key++) {
		    vals[_key] = arguments[_key];
		  }
	
		  function validate(node, key, val) {
		    if (vals.indexOf(val) < 0) {
		      throw new TypeError("Property " + key + " expected value to be one of " + (0, _stringify2.default)(vals) + " but got " + (0, _stringify2.default)(val));
		    }
		  }
	
		  validate.oneOf = vals;
	
		  return validate;
		}
	
		function assertNodeType() {
		  for (var _len2 = arguments.length, types = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		    types[_key2] = arguments[_key2];
		  }
	
		  function validate(node, key, val) {
		    var valid = false;
	
		    for (var _iterator = types, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var type = _ref;
	
		      if (t.is(type, val)) {
		        valid = true;
		        break;
		      }
		    }
	
		    if (!valid) {
		      throw new TypeError("Property " + key + " of " + node.type + " expected node to be of a type " + (0, _stringify2.default)(types) + " " + ("but instead got " + (0, _stringify2.default)(val && val.type)));
		    }
		  }
	
		  validate.oneOfNodeTypes = types;
	
		  return validate;
		}
	
		function assertNodeOrValueType() {
		  for (var _len3 = arguments.length, types = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
		    types[_key3] = arguments[_key3];
		  }
	
		  function validate(node, key, val) {
		    var valid = false;
	
		    for (var _iterator2 = types, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		      var _ref2;
	
		      if (_isArray2) {
		        if (_i2 >= _iterator2.length) break;
		        _ref2 = _iterator2[_i2++];
		      } else {
		        _i2 = _iterator2.next();
		        if (_i2.done) break;
		        _ref2 = _i2.value;
		      }
	
		      var type = _ref2;
	
		      if (getType(val) === type || t.is(type, val)) {
		        valid = true;
		        break;
		      }
		    }
	
		    if (!valid) {
		      throw new TypeError("Property " + key + " of " + node.type + " expected node to be of a type " + (0, _stringify2.default)(types) + " " + ("but instead got " + (0, _stringify2.default)(val && val.type)));
		    }
		  }
	
		  validate.oneOfNodeOrValueTypes = types;
	
		  return validate;
		}
	
		function assertValueType(type) {
		  function validate(node, key, val) {
		    var valid = getType(val) === type;
	
		    if (!valid) {
		      throw new TypeError("Property " + key + " expected type of " + type + " but got " + getType(val));
		    }
		  }
	
		  validate.type = type;
	
		  return validate;
		}
	
		function chain() {
		  for (var _len4 = arguments.length, fns = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
		    fns[_key4] = arguments[_key4];
		  }
	
		  function validate() {
		    for (var _iterator3 = fns, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		      var _ref3;
	
		      if (_isArray3) {
		        if (_i3 >= _iterator3.length) break;
		        _ref3 = _iterator3[_i3++];
		      } else {
		        _i3 = _iterator3.next();
		        if (_i3.done) break;
		        _ref3 = _i3.value;
		      }
	
		      var fn = _ref3;
	
		      fn.apply(undefined, arguments);
		    }
		  }
		  validate.chainOf = fns;
		  return validate;
		}
	
		function defineType(type) {
		  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		  var inherits = opts.inherits && store[opts.inherits] || {};
	
		  opts.fields = opts.fields || inherits.fields || {};
		  opts.visitor = opts.visitor || inherits.visitor || [];
		  opts.aliases = opts.aliases || inherits.aliases || [];
		  opts.builder = opts.builder || inherits.builder || opts.visitor || [];
	
		  if (opts.deprecatedAlias) {
		    DEPRECATED_KEYS[opts.deprecatedAlias] = type;
		  }
	
		  for (var _iterator4 = opts.visitor.concat(opts.builder), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
		    var _ref4;
	
		    if (_isArray4) {
		      if (_i4 >= _iterator4.length) break;
		      _ref4 = _iterator4[_i4++];
		    } else {
		      _i4 = _iterator4.next();
		      if (_i4.done) break;
		      _ref4 = _i4.value;
		    }
	
		    var _key5 = _ref4;
	
		    opts.fields[_key5] = opts.fields[_key5] || {};
		  }
	
		  for (var key in opts.fields) {
		    var field = opts.fields[key];
	
		    if (opts.builder.indexOf(key) === -1) {
		      field.optional = true;
		    }
		    if (field.default === undefined) {
		      field.default = null;
		    } else if (!field.validate) {
		      field.validate = assertValueType(getType(field.default));
		    }
		  }
	
		  VISITOR_KEYS[type] = opts.visitor;
		  BUILDER_KEYS[type] = opts.builder;
		  NODE_FIELDS[type] = opts.fields;
		  ALIAS_KEYS[type] = opts.aliases;
	
		  store[type] = opts;
		}
	
		var store = {};
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		module.exports = function (exec) {
		  try {
		    return !!exec();
		  } catch (e) {
		    return true;
		  }
		};
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		var hasOwnProperty = {}.hasOwnProperty;
		module.exports = function (it, key) {
		  return hasOwnProperty.call(it, key);
		};
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var dP = __webpack_require__(23);
		var createDesc = __webpack_require__(92);
		module.exports = __webpack_require__(22) ? function (object, key, value) {
		  return dP.f(object, key, createDesc(1, value));
		} : function (object, key, value) {
		  object[key] = value;
		  return object;
		};
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _Symbol = __webpack_require__(45),
		    getRawTag = __webpack_require__(534),
		    objectToString = __webpack_require__(559);
	
		/** `Object#toString` result references. */
		var nullTag = '[object Null]',
		    undefinedTag = '[object Undefined]';
	
		/** Built-in value references. */
		var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
	
		/**
		 * The base implementation of `getTag` without fallbacks for buggy environments.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		function baseGetTag(value) {
		    if (value == null) {
		        return value === undefined ? undefinedTag : nullTag;
		    }
		    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
		}
	
		module.exports = baseGetTag;
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var assignValue = __webpack_require__(162),
		    baseAssignValue = __webpack_require__(163);
	
		/**
		 * Copies properties of `source` to `object`.
		 *
		 * @private
		 * @param {Object} source The object to copy properties from.
		 * @param {Array} props The property identifiers to copy.
		 * @param {Object} [object={}] The object to copy properties to.
		 * @param {Function} [customizer] The function to customize copied values.
		 * @returns {Object} Returns `object`.
		 */
		function copyObject(source, props, object, customizer) {
		  var isNew = !object;
		  object || (object = {});
	
		  var index = -1,
		      length = props.length;
	
		  while (++index < length) {
		    var key = props[index];
	
		    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
	
		    if (newValue === undefined) {
		      newValue = source[key];
		    }
		    if (isNew) {
		      baseAssignValue(object, key, newValue);
		    } else {
		      assignValue(object, key, newValue);
		    }
		  }
		  return object;
		}
	
		module.exports = copyObject;
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var arrayLikeKeys = __webpack_require__(245),
		    baseKeys = __webpack_require__(500),
		    isArrayLike = __webpack_require__(24);
	
		/**
		 * Creates an array of the own enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects. See the
		 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * for more details.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keys(new Foo);
		 * // => ['a', 'b'] (iteration order is not guaranteed)
		 *
		 * _.keys('hi');
		 * // => ['0', '1']
		 */
		function keys(object) {
		  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
		}
	
		module.exports = keys;
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		module.exports = {
		  filename: {
		    type: "filename",
		    description: "filename to use when reading from stdin - this will be used in source-maps, errors etc",
		    default: "unknown",
		    shorthand: "f"
		  },
	
		  filenameRelative: {
		    hidden: true,
		    type: "string"
		  },
	
		  inputSourceMap: {
		    hidden: true
		  },
	
		  env: {
		    hidden: true,
		    default: {}
		  },
	
		  mode: {
		    description: "",
		    hidden: true
		  },
	
		  retainLines: {
		    type: "boolean",
		    default: false,
		    description: "retain line numbers - will result in really ugly code"
		  },
	
		  highlightCode: {
		    description: "enable/disable ANSI syntax highlighting of code frames (on by default)",
		    type: "boolean",
		    default: true
		  },
	
		  suppressDeprecationMessages: {
		    type: "boolean",
		    default: false,
		    hidden: true
		  },
	
		  presets: {
		    type: "list",
		    description: "",
		    default: []
		  },
	
		  plugins: {
		    type: "list",
		    default: [],
		    description: ""
		  },
	
		  ignore: {
		    type: "list",
		    description: "list of glob paths to **not** compile",
		    default: []
		  },
	
		  only: {
		    type: "list",
		    description: "list of glob paths to **only** compile"
		  },
	
		  code: {
		    hidden: true,
		    default: true,
		    type: "boolean"
		  },
	
		  metadata: {
		    hidden: true,
		    default: true,
		    type: "boolean"
		  },
	
		  ast: {
		    hidden: true,
		    default: true,
		    type: "boolean"
		  },
	
		  extends: {
		    type: "string",
		    hidden: true
		  },
	
		  comments: {
		    type: "boolean",
		    default: true,
		    description: "write comments to generated output (true by default)"
		  },
	
		  shouldPrintComment: {
		    hidden: true,
		    description: "optional callback to control whether a comment should be inserted, when this is used the comments option is ignored"
		  },
	
		  wrapPluginVisitorMethod: {
		    hidden: true,
		    description: "optional callback to wrap all visitor methods"
		  },
	
		  compact: {
		    type: "booleanString",
		    default: "auto",
		    description: "do not include superfluous whitespace characters and line terminators [true|false|auto]"
		  },
	
		  minified: {
		    type: "boolean",
		    default: false,
		    description: "save as much bytes when printing [true|false]"
		  },
	
		  sourceMap: {
		    alias: "sourceMaps",
		    hidden: true
		  },
	
		  sourceMaps: {
		    type: "booleanString",
		    description: "[true|false|inline]",
		    default: false,
		    shorthand: "s"
		  },
	
		  sourceMapTarget: {
		    type: "string",
		    description: "set `file` on returned source map"
		  },
	
		  sourceFileName: {
		    type: "string",
		    description: "set `sources[0]` on returned source map"
		  },
	
		  sourceRoot: {
		    type: "filename",
		    description: "the root from which all sources are relative"
		  },
	
		  babelrc: {
		    description: "Whether or not to look up .babelrc and .babelignore files",
		    type: "boolean",
		    default: true
		  },
	
		  sourceType: {
		    description: "",
		    default: "module"
		  },
	
		  auxiliaryCommentBefore: {
		    type: "string",
		    description: "print a comment before any injected non-user code"
		  },
	
		  auxiliaryCommentAfter: {
		    type: "string",
		    description: "print a comment after any injected non-user code"
		  },
	
		  resolveModuleSource: {
		    hidden: true
		  },
	
		  getModuleId: {
		    hidden: true
		  },
	
		  moduleRoot: {
		    type: "filename",
		    description: "optional prefix for the AMD module formatter that will be prepend to the filename on module definitions"
		  },
	
		  moduleIds: {
		    type: "boolean",
		    default: false,
		    shorthand: "M",
		    description: "insert an explicit id for modules"
		  },
	
		  moduleId: {
		    description: "specify a custom name for module ids",
		    type: "string"
		  },
	
		  passPerPreset: {
		    description: "Whether to spawn a traversal pass per a preset. By default all presets are merged.",
		    type: "boolean",
		    default: false,
		    hidden: true
		  },
	
		  parserOpts: {
		    description: "Options to pass into the parser, or to change parsers (parserOpts.parser)",
		    default: false
		  },
	
		  generatorOpts: {
		    description: "Options to pass into the generator, or to change generators (generatorOpts.generator)",
		    default: false
		  }
		};
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
		exports.__esModule = true;
	
		var _objectWithoutProperties2 = __webpack_require__(366);
	
		var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
		var _stringify = __webpack_require__(35);
	
		var _stringify2 = _interopRequireDefault(_stringify);
	
		var _assign = __webpack_require__(87);
	
		var _assign2 = _interopRequireDefault(_assign);
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _typeof2 = __webpack_require__(11);
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _node = __webpack_require__(182);
	
		var context = _interopRequireWildcard(_node);
	
		var _plugin2 = __webpack_require__(65);
	
		var _plugin3 = _interopRequireDefault(_plugin2);
	
		var _babelMessages = __webpack_require__(20);
	
		var messages = _interopRequireWildcard(_babelMessages);
	
		var _index = __webpack_require__(52);
	
		var _resolvePlugin = __webpack_require__(184);
	
		var _resolvePlugin2 = _interopRequireDefault(_resolvePlugin);
	
		var _resolvePreset = __webpack_require__(185);
	
		var _resolvePreset2 = _interopRequireDefault(_resolvePreset);
	
		var _cloneDeepWith = __webpack_require__(575);
	
		var _cloneDeepWith2 = _interopRequireDefault(_cloneDeepWith);
	
		var _clone = __webpack_require__(109);
	
		var _clone2 = _interopRequireDefault(_clone);
	
		var _merge = __webpack_require__(293);
	
		var _merge2 = _interopRequireDefault(_merge);
	
		var _config2 = __webpack_require__(33);
	
		var _config3 = _interopRequireDefault(_config2);
	
		var _removed = __webpack_require__(54);
	
		var _removed2 = _interopRequireDefault(_removed);
	
		var _buildConfigChain = __webpack_require__(51);
	
		var _buildConfigChain2 = _interopRequireDefault(_buildConfigChain);
	
		var _path = __webpack_require__(19);
	
		var _path2 = _interopRequireDefault(_path);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var OptionManager = function () {
		  function OptionManager(log) {
		    (0, _classCallCheck3.default)(this, OptionManager);
	
		    this.resolvedConfigs = [];
		    this.options = OptionManager.createBareOptions();
		    this.log = log;
		  }
	
		  OptionManager.memoisePluginContainer = function memoisePluginContainer(fn, loc, i, alias) {
		    for (var _iterator = OptionManager.memoisedPlugins, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var cache = _ref;
	
		      if (cache.container === fn) return cache.plugin;
		    }
	
		    var obj = void 0;
	
		    if (typeof fn === "function") {
		      obj = fn(context);
		    } else {
		      obj = fn;
		    }
	
		    if ((typeof obj === "undefined" ? "undefined" : (0, _typeof3.default)(obj)) === "object") {
		      var _plugin = new _plugin3.default(obj, alias);
		      OptionManager.memoisedPlugins.push({
		        container: fn,
		        plugin: _plugin
		      });
		      return _plugin;
		    } else {
		      throw new TypeError(messages.get("pluginNotObject", loc, i, typeof obj === "undefined" ? "undefined" : (0, _typeof3.default)(obj)) + loc + i);
		    }
		  };
	
		  OptionManager.createBareOptions = function createBareOptions() {
		    var opts = {};
	
		    for (var _key in _config3.default) {
		      var opt = _config3.default[_key];
		      opts[_key] = (0, _clone2.default)(opt.default);
		    }
	
		    return opts;
		  };
	
		  OptionManager.normalisePlugin = function normalisePlugin(plugin, loc, i, alias) {
		    plugin = plugin.__esModule ? plugin.default : plugin;
	
		    if (!(plugin instanceof _plugin3.default)) {
		      if (typeof plugin === "function" || (typeof plugin === "undefined" ? "undefined" : (0, _typeof3.default)(plugin)) === "object") {
		        plugin = OptionManager.memoisePluginContainer(plugin, loc, i, alias);
		      } else {
		        throw new TypeError(messages.get("pluginNotFunction", loc, i, typeof plugin === "undefined" ? "undefined" : (0, _typeof3.default)(plugin)));
		      }
		    }
	
		    plugin.init(loc, i);
	
		    return plugin;
		  };
	
		  OptionManager.normalisePlugins = function normalisePlugins(loc, dirname, plugins) {
		    return plugins.map(function (val, i) {
		      var plugin = void 0,
		          options = void 0;
	
		      if (!val) {
		        throw new TypeError("Falsy value found in plugins");
		      }
	
		      if (Array.isArray(val)) {
		        plugin = val[0];
		        options = val[1];
		      } else {
		        plugin = val;
		      }
	
		      var alias = typeof plugin === "string" ? plugin : loc + "$" + i;
	
		      if (typeof plugin === "string") {
		        var pluginLoc = (0, _resolvePlugin2.default)(plugin, dirname);
		        if (pluginLoc) {
		          plugin = __webpack_require__(179)(pluginLoc);
		        } else {
		          throw new ReferenceError(messages.get("pluginUnknown", plugin, loc, i, dirname));
		        }
		      }
	
		      plugin = OptionManager.normalisePlugin(plugin, loc, i, alias);
	
		      return [plugin, options];
		    });
		  };
	
		  OptionManager.prototype.mergeOptions = function mergeOptions(_ref2) {
		    var _this = this;
	
		    var rawOpts = _ref2.options,
		        extendingOpts = _ref2.extending,
		        alias = _ref2.alias,
		        loc = _ref2.loc,
		        dirname = _ref2.dirname;
	
		    alias = alias || "foreign";
		    if (!rawOpts) return;
	
		    if ((typeof rawOpts === "undefined" ? "undefined" : (0, _typeof3.default)(rawOpts)) !== "object" || Array.isArray(rawOpts)) {
		      this.log.error("Invalid options type for " + alias, TypeError);
		    }
	
		    var opts = (0, _cloneDeepWith2.default)(rawOpts, function (val) {
		      if (val instanceof _plugin3.default) {
		        return val;
		      }
		    });
	
		    dirname = dirname || process.cwd();
		    loc = loc || alias;
	
		    for (var _key2 in opts) {
		      var option = _config3.default[_key2];
	
		      if (!option && this.log) {
		        if (_removed2.default[_key2]) {
		          this.log.error("Using removed Babel 5 option: " + alias + "." + _key2 + " - " + _removed2.default[_key2].message, ReferenceError);
		        } else {
		          var unknownOptErr = "Unknown option: " + alias + "." + _key2 + ". Check out http://babeljs.io/docs/usage/options/ for more information about options.";
		          var presetConfigErr = "A common cause of this error is the presence of a configuration options object without the corresponding preset name. Example:\n\nInvalid:\n  `{ presets: [{option: value}] }`\nValid:\n  `{ presets: [['presetName', {option: value}]] }`\n\nFor more detailed information on preset configuration, please see http://babeljs.io/docs/plugins/#pluginpresets-options.";
	
		          this.log.error(unknownOptErr + "\n\n" + presetConfigErr, ReferenceError);
		        }
		      }
		    }
	
		    (0, _index.normaliseOptions)(opts);
	
		    if (opts.plugins) {
		      opts.plugins = OptionManager.normalisePlugins(loc, dirname, opts.plugins);
		    }
	
		    if (opts.presets) {
		      if (opts.passPerPreset) {
		        opts.presets = this.resolvePresets(opts.presets, dirname, function (preset, presetLoc) {
		          _this.mergeOptions({
		            options: preset,
		            extending: preset,
		            alias: presetLoc,
		            loc: presetLoc,
		            dirname: dirname
		          });
		        });
		      } else {
		        this.mergePresets(opts.presets, dirname);
		        delete opts.presets;
		      }
		    }
	
		    if (rawOpts === extendingOpts) {
		      (0, _assign2.default)(extendingOpts, opts);
		    } else {
		      (0, _merge2.default)(extendingOpts || this.options, opts);
		    }
		  };
	
		  OptionManager.prototype.mergePresets = function mergePresets(presets, dirname) {
		    var _this2 = this;
	
		    this.resolvePresets(presets, dirname, function (presetOpts, presetLoc) {
		      _this2.mergeOptions({
		        options: presetOpts,
		        alias: presetLoc,
		        loc: presetLoc,
		        dirname: _path2.default.dirname(presetLoc || "")
		      });
		    });
		  };
	
		  OptionManager.prototype.resolvePresets = function resolvePresets(presets, dirname, onResolve) {
		    return presets.map(function (val) {
		      var options = void 0;
		      if (Array.isArray(val)) {
		        if (val.length > 2) {
		          throw new Error("Unexpected extra options " + (0, _stringify2.default)(val.slice(2)) + " passed to preset.");
		        }
	
		        var _val = val;
		        val = _val[0];
		        options = _val[1];
		      }
	
		      var presetLoc = void 0;
		      try {
		        if (typeof val === "string") {
		          presetLoc = (0, _resolvePreset2.default)(val, dirname);
	
		          if (!presetLoc) {
		            throw new Error("Couldn't find preset " + (0, _stringify2.default)(val) + " relative to directory " + (0, _stringify2.default)(dirname));
		          }
	
		          val = __webpack_require__(179)(presetLoc);
		        }
	
		        if ((typeof val === "undefined" ? "undefined" : (0, _typeof3.default)(val)) === "object" && val.__esModule) {
		          if (val.default) {
		            val = val.default;
		          } else {
		            var _val2 = val,
		                __esModule = _val2.__esModule,
		                rest = (0, _objectWithoutProperties3.default)(_val2, ["__esModule"]);
	
		            val = rest;
		          }
		        }
	
		        if ((typeof val === "undefined" ? "undefined" : (0, _typeof3.default)(val)) === "object" && val.buildPreset) val = val.buildPreset;
	
		        if (typeof val !== "function" && options !== undefined) {
		          throw new Error("Options " + (0, _stringify2.default)(options) + " passed to " + (presetLoc || "a preset") + " which does not accept options.");
		        }
	
		        if (typeof val === "function") val = val(context, options, { dirname: dirname });
	
		        if ((typeof val === "undefined" ? "undefined" : (0, _typeof3.default)(val)) !== "object") {
		          throw new Error("Unsupported preset format: " + val + ".");
		        }
	
		        onResolve && onResolve(val, presetLoc);
		      } catch (e) {
		        if (presetLoc) {
		          e.message += " (While processing preset: " + (0, _stringify2.default)(presetLoc) + ")";
		        }
		        throw e;
		      }
		      return val;
		    });
		  };
	
		  OptionManager.prototype.normaliseOptions = function normaliseOptions() {
		    var opts = this.options;
	
		    for (var _key3 in _config3.default) {
		      var option = _config3.default[_key3];
		      var val = opts[_key3];
	
		      if (!val && option.optional) continue;
	
		      if (option.alias) {
		        opts[option.alias] = opts[option.alias] || val;
		      } else {
		        opts[_key3] = val;
		      }
		    }
		  };
	
		  OptionManager.prototype.init = function init() {
		    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
		    for (var _iterator2 = (0, _buildConfigChain2.default)(opts, this.log), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		      var _ref3;
	
		      if (_isArray2) {
		        if (_i2 >= _iterator2.length) break;
		        _ref3 = _iterator2[_i2++];
		      } else {
		        _i2 = _iterator2.next();
		        if (_i2.done) break;
		        _ref3 = _i2.value;
		      }
	
		      var _config = _ref3;
	
		      this.mergeOptions(_config);
		    }
	
		    this.normaliseOptions(opts);
	
		    return this.options;
		  };
	
		  return OptionManager;
		}();
	
		exports.default = OptionManager;
	
		OptionManager.memoisedPlugins = [];
		module.exports = exports["default"];
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		module.exports = { "default": __webpack_require__(405), __esModule: true };
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _virtualTypes = __webpack_require__(224);
	
		var virtualTypes = _interopRequireWildcard(_virtualTypes);
	
		var _debug2 = __webpack_require__(239);
	
		var _debug3 = _interopRequireDefault(_debug2);
	
		var _invariant = __webpack_require__(466);
	
		var _invariant2 = _interopRequireDefault(_invariant);
	
		var _index = __webpack_require__(7);
	
		var _index2 = _interopRequireDefault(_index);
	
		var _assign = __webpack_require__(174);
	
		var _assign2 = _interopRequireDefault(_assign);
	
		var _scope = __webpack_require__(134);
	
		var _scope2 = _interopRequireDefault(_scope);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		var _cache = __webpack_require__(88);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var _debug = (0, _debug3.default)("babel");
	
		var NodePath = function () {
		  function NodePath(hub, parent) {
		    (0, _classCallCheck3.default)(this, NodePath);
	
		    this.parent = parent;
		    this.hub = hub;
		    this.contexts = [];
		    this.data = {};
		    this.shouldSkip = false;
		    this.shouldStop = false;
		    this.removed = false;
		    this.state = null;
		    this.opts = null;
		    this.skipKeys = null;
		    this.parentPath = null;
		    this.context = null;
		    this.container = null;
		    this.listKey = null;
		    this.inList = false;
		    this.parentKey = null;
		    this.key = null;
		    this.node = null;
		    this.scope = null;
		    this.type = null;
		    this.typeAnnotation = null;
		  }
	
		  NodePath.get = function get(_ref) {
		    var hub = _ref.hub,
		        parentPath = _ref.parentPath,
		        parent = _ref.parent,
		        container = _ref.container,
		        listKey = _ref.listKey,
		        key = _ref.key;
	
		    if (!hub && parentPath) {
		      hub = parentPath.hub;
		    }
	
		    (0, _invariant2.default)(parent, "To get a node path the parent needs to exist");
	
		    var targetNode = container[key];
	
		    var paths = _cache.path.get(parent) || [];
		    if (!_cache.path.has(parent)) {
		      _cache.path.set(parent, paths);
		    }
	
		    var path = void 0;
	
		    for (var i = 0; i < paths.length; i++) {
		      var pathCheck = paths[i];
		      if (pathCheck.node === targetNode) {
		        path = pathCheck;
		        break;
		      }
		    }
	
		    if (!path) {
		      path = new NodePath(hub, parent);
		      paths.push(path);
		    }
	
		    path.setup(parentPath, container, listKey, key);
	
		    return path;
		  };
	
		  NodePath.prototype.getScope = function getScope(scope) {
		    var ourScope = scope;
	
		    if (this.isScope()) {
		      ourScope = new _scope2.default(this, scope);
		    }
	
		    return ourScope;
		  };
	
		  NodePath.prototype.setData = function setData(key, val) {
		    return this.data[key] = val;
		  };
	
		  NodePath.prototype.getData = function getData(key, def) {
		    var val = this.data[key];
		    if (!val && def) val = this.data[key] = def;
		    return val;
		  };
	
		  NodePath.prototype.buildCodeFrameError = function buildCodeFrameError(msg) {
		    var Error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SyntaxError;
	
		    return this.hub.file.buildCodeFrameError(this.node, msg, Error);
		  };
	
		  NodePath.prototype.traverse = function traverse(visitor, state) {
		    (0, _index2.default)(this.node, visitor, this.scope, state, this);
		  };
	
		  NodePath.prototype.mark = function mark(type, message) {
		    this.hub.file.metadata.marked.push({
		      type: type,
		      message: message,
		      loc: this.node.loc
		    });
		  };
	
		  NodePath.prototype.set = function set(key, node) {
		    t.validate(this.node, key, node);
		    this.node[key] = node;
		  };
	
		  NodePath.prototype.getPathLocation = function getPathLocation() {
		    var parts = [];
		    var path = this;
		    do {
		      var key = path.key;
		      if (path.inList) key = path.listKey + "[" + key + "]";
		      parts.unshift(key);
		    } while (path = path.parentPath);
		    return parts.join(".");
		  };
	
		  NodePath.prototype.debug = function debug(buildMessage) {
		    if (!_debug.enabled) return;
		    _debug(this.getPathLocation() + " " + this.type + ": " + buildMessage());
		  };
	
		  return NodePath;
		}();
	
		exports.default = NodePath;
	
		(0, _assign2.default)(NodePath.prototype, __webpack_require__(368));
		(0, _assign2.default)(NodePath.prototype, __webpack_require__(374));
		(0, _assign2.default)(NodePath.prototype, __webpack_require__(382));
		(0, _assign2.default)(NodePath.prototype, __webpack_require__(372));
		(0, _assign2.default)(NodePath.prototype, __webpack_require__(371));
		(0, _assign2.default)(NodePath.prototype, __webpack_require__(377));
		(0, _assign2.default)(NodePath.prototype, __webpack_require__(370));
		(0, _assign2.default)(NodePath.prototype, __webpack_require__(381));
		(0, _assign2.default)(NodePath.prototype, __webpack_require__(380));
		(0, _assign2.default)(NodePath.prototype, __webpack_require__(373));
		(0, _assign2.default)(NodePath.prototype, __webpack_require__(369));
	
		var _loop2 = function _loop2() {
		  if (_isArray) {
		    if (_i >= _iterator.length) return "break";
		    _ref2 = _iterator[_i++];
		  } else {
		    _i = _iterator.next();
		    if (_i.done) return "break";
		    _ref2 = _i.value;
		  }
	
		  var type = _ref2;
	
		  var typeKey = "is" + type;
		  NodePath.prototype[typeKey] = function (opts) {
		    return t[typeKey](this.node, opts);
		  };
	
		  NodePath.prototype["assert" + type] = function (opts) {
		    if (!this[typeKey](opts)) {
		      throw new TypeError("Expected node path of type " + type);
		    }
		  };
		};
	
		for (var _iterator = t.TYPES, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		  var _ref2;
	
		  var _ret2 = _loop2();
	
		  if (_ret2 === "break") break;
		}
	
		var _loop = function _loop(type) {
		  if (type[0] === "_") return "continue";
		  if (t.TYPES.indexOf(type) < 0) t.TYPES.push(type);
	
		  var virtualType = virtualTypes[type];
	
		  NodePath.prototype["is" + type] = function (opts) {
		    return virtualType.checkPath(this, opts);
		  };
		};
	
		for (var type in virtualTypes) {
		  var _ret = _loop(type);
	
		  if (_ret === "continue") continue;
		}
		module.exports = exports["default"];
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// to indexed object, toObject with fallback for non-array-like ES3 strings
		var IObject = __webpack_require__(142);
		var defined = __webpack_require__(140);
		module.exports = function (it) {
		  return IObject(defined(it));
		};
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseIsNative = __webpack_require__(497),
		    getValue = __webpack_require__(535);
	
		/**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */
		function getNative(object, key) {
		  var value = getValue(object, key);
		  return baseIsNative(value) ? value : undefined;
		}
	
		module.exports = getNative;
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		module.exports = function (module) {
			if (!module.webpackPolyfill) {
				module.deprecate = function () {};
				module.paths = [];
				// module.parent = undefined by default
				module.children = [];
				module.webpackPolyfill = 1;
			}
			return module;
		};
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var node = _ref.node,
		      parent = _ref.parent,
		      scope = _ref.scope,
		      id = _ref.id;
	
		  if (node.id) return;
	
		  if ((t.isObjectProperty(parent) || t.isObjectMethod(parent, { kind: "method" })) && (!parent.computed || t.isLiteral(parent.key))) {
		    id = parent.key;
		  } else if (t.isVariableDeclarator(parent)) {
		    id = parent.id;
	
		    if (t.isIdentifier(id)) {
		      var binding = scope.parent.getBinding(id.name);
		      if (binding && binding.constant && scope.getBinding(id.name) === binding) {
		        node.id = id;
		        node.id[t.NOT_LOCAL_BINDING] = true;
		        return;
		      }
		    }
		  } else if (t.isAssignmentExpression(parent)) {
		    id = parent.left;
		  } else if (!id) {
		    return;
		  }
	
		  var name = void 0;
		  if (id && t.isLiteral(id)) {
		    name = id.value;
		  } else if (id && t.isIdentifier(id)) {
		    name = id.name;
		  } else {
		    return;
		  }
	
		  name = t.toBindingIdentifierName(name);
		  id = t.identifier(name);
	
		  id[t.NOT_LOCAL_BINDING] = true;
	
		  var state = visit(node, name, scope);
		  return wrap(state, node, id, scope) || node;
		};
	
		var _babelHelperGetFunctionArity = __webpack_require__(189);
	
		var _babelHelperGetFunctionArity2 = _interopRequireDefault(_babelHelperGetFunctionArity);
	
		var _babelTemplate = __webpack_require__(4);
	
		var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var buildPropertyMethodAssignmentWrapper = (0, _babelTemplate2.default)("\n  (function (FUNCTION_KEY) {\n    function FUNCTION_ID() {\n      return FUNCTION_KEY.apply(this, arguments);\n    }\n\n    FUNCTION_ID.toString = function () {\n      return FUNCTION_KEY.toString();\n    }\n\n    return FUNCTION_ID;\n  })(FUNCTION)\n");
	
		var buildGeneratorPropertyMethodAssignmentWrapper = (0, _babelTemplate2.default)("\n  (function (FUNCTION_KEY) {\n    function* FUNCTION_ID() {\n      return yield* FUNCTION_KEY.apply(this, arguments);\n    }\n\n    FUNCTION_ID.toString = function () {\n      return FUNCTION_KEY.toString();\n    };\n\n    return FUNCTION_ID;\n  })(FUNCTION)\n");
	
		var visitor = {
		  "ReferencedIdentifier|BindingIdentifier": function ReferencedIdentifierBindingIdentifier(path, state) {
		    if (path.node.name !== state.name) return;
	
		    var localDeclar = path.scope.getBindingIdentifier(state.name);
		    if (localDeclar !== state.outerDeclar) return;
	
		    state.selfReference = true;
		    path.stop();
		  }
		};
	
		function wrap(state, method, id, scope) {
		  if (state.selfReference) {
		    if (scope.hasBinding(id.name) && !scope.hasGlobal(id.name)) {
		      scope.rename(id.name);
		    } else {
		      if (!t.isFunction(method)) return;
	
		      var build = buildPropertyMethodAssignmentWrapper;
		      if (method.generator) build = buildGeneratorPropertyMethodAssignmentWrapper;
		      var _template = build({
		        FUNCTION: method,
		        FUNCTION_ID: id,
		        FUNCTION_KEY: scope.generateUidIdentifier(id.name)
		      }).expression;
		      _template.callee._skipModulesRemap = true;
	
		      var params = _template.callee.body.body[0].params;
		      for (var i = 0, len = (0, _babelHelperGetFunctionArity2.default)(method); i < len; i++) {
		        params.push(scope.generateUidIdentifier("x"));
		      }
	
		      return _template;
		    }
		  }
	
		  method.id = id;
		  scope.getProgramParent().references[id.name] = true;
		}
	
		function visit(node, name, scope) {
		  var state = {
		    selfAssignment: false,
		    selfReference: false,
		    outerDeclar: scope.getBindingIdentifier(name),
		    references: [],
		    name: name
		  };
	
		  var binding = scope.getOwnBinding(name);
	
		  if (binding) {
		    if (binding.kind === "param") {
		      state.selfReference = true;
		    } else {}
		  } else if (state.outerDeclar || scope.hasGlobal(name)) {
		    scope.traverse(node, visitor, state);
		  }
	
		  return state;
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _setPrototypeOf = __webpack_require__(361);
	
		var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
		var _create = __webpack_require__(9);
	
		var _create2 = _interopRequireDefault(_create);
	
		var _typeof2 = __webpack_require__(11);
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		exports.default = function (subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
		  }
	
		  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
		    constructor: {
		      value: subClass,
		      enumerable: false,
		      writable: true,
		      configurable: true
		    }
		  });
		  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
		};
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _typeof2 = __webpack_require__(11);
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		exports.default = function (self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }
	
		  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
		};
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// optional / simple context binding
		var aFunction = __webpack_require__(227);
		module.exports = function (fn, that, length) {
		  aFunction(fn);
		  if (that === undefined) return fn;
		  switch (length) {
		    case 1:
		      return function (a) {
		        return fn.call(that, a);
		      };
		    case 2:
		      return function (a, b) {
		        return fn.call(that, a, b);
		      };
		    case 3:
		      return function (a, b, c) {
		        return fn.call(that, a, b, c);
		      };
		  }
		  return function () /* ...args */{
		    return fn.apply(that, arguments);
		  };
		};
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// 19.1.2.14 / 15.2.3.14 Object.keys(O)
		var $keys = __webpack_require__(237);
		var enumBugKeys = __webpack_require__(141);
	
		module.exports = Object.keys || function keys(O) {
		  return $keys(O, enumBugKeys);
		};
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var root = __webpack_require__(17);
	
		/** Built-in value references. */
		var _Symbol = root.Symbol;
	
		module.exports = _Symbol;
	
	/***/ }),
	/* 46 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Performs a
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * comparison between two values to determine if they are equivalent.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.eq(object, object);
		 * // => true
		 *
		 * _.eq(object, other);
		 * // => false
		 *
		 * _.eq('a', 'a');
		 * // => true
		 *
		 * _.eq('a', Object('a'));
		 * // => false
		 *
		 * _.eq(NaN, NaN);
		 * // => true
		 */
		function eq(value, other) {
		  return value === other || value !== value && other !== other;
		}
	
		module.exports = eq;
	
	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var arrayLikeKeys = __webpack_require__(245),
		    baseKeysIn = __webpack_require__(501),
		    isArrayLike = __webpack_require__(24);
	
		/**
		 * Creates an array of the own and inherited enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keysIn(new Foo);
		 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
		 */
		function keysIn(object) {
		  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
		}
	
		module.exports = keysIn;
	
	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var toFinite = __webpack_require__(597);
	
		/**
		 * Converts `value` to an integer.
		 *
		 * **Note:** This method is loosely based on
		 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to convert.
		 * @returns {number} Returns the converted integer.
		 * @example
		 *
		 * _.toInteger(3.2);
		 * // => 3
		 *
		 * _.toInteger(Number.MIN_VALUE);
		 * // => 0
		 *
		 * _.toInteger(Infinity);
		 * // => 1.7976931348623157e+308
		 *
		 * _.toInteger('3.2');
		 * // => 3
		 */
		function toInteger(value) {
		  var result = toFinite(value),
		      remainder = result % 1;
	
		  return result === result ? remainder ? result - remainder : result : 0;
		}
	
		module.exports = toInteger;
	
	/***/ }),
	/* 49 */
	/***/ (function(module, exports) {
	
		/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
		/* WEBPACK VAR INJECTION */}.call(exports, {}))
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
		exports.__esModule = true;
		exports.File = undefined;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _create = __webpack_require__(9);
	
		var _create2 = _interopRequireDefault(_create);
	
		var _assign = __webpack_require__(87);
	
		var _assign2 = _interopRequireDefault(_assign);
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(42);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(41);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		var _babelHelpers = __webpack_require__(194);
	
		var _babelHelpers2 = _interopRequireDefault(_babelHelpers);
	
		var _metadata = __webpack_require__(121);
	
		var metadataVisitor = _interopRequireWildcard(_metadata);
	
		var _convertSourceMap = __webpack_require__(403);
	
		var _convertSourceMap2 = _interopRequireDefault(_convertSourceMap);
	
		var _optionManager = __webpack_require__(34);
	
		var _optionManager2 = _interopRequireDefault(_optionManager);
	
		var _pluginPass = __webpack_require__(299);
	
		var _pluginPass2 = _interopRequireDefault(_pluginPass);
	
		var _babelTraverse = __webpack_require__(7);
	
		var _babelTraverse2 = _interopRequireDefault(_babelTraverse);
	
		var _sourceMap = __webpack_require__(288);
	
		var _sourceMap2 = _interopRequireDefault(_sourceMap);
	
		var _babelGenerator = __webpack_require__(186);
	
		var _babelGenerator2 = _interopRequireDefault(_babelGenerator);
	
		var _babelCodeFrame = __webpack_require__(181);
	
		var _babelCodeFrame2 = _interopRequireDefault(_babelCodeFrame);
	
		var _defaults = __webpack_require__(273);
	
		var _defaults2 = _interopRequireDefault(_defaults);
	
		var _logger = __webpack_require__(120);
	
		var _logger2 = _interopRequireDefault(_logger);
	
		var _store = __webpack_require__(119);
	
		var _store2 = _interopRequireDefault(_store);
	
		var _babylon = __webpack_require__(89);
	
		var _util = __webpack_require__(122);
	
		var util = _interopRequireWildcard(_util);
	
		var _path = __webpack_require__(19);
	
		var _path2 = _interopRequireDefault(_path);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		var _resolve = __webpack_require__(118);
	
		var _resolve2 = _interopRequireDefault(_resolve);
	
		var _blockHoist = __webpack_require__(296);
	
		var _blockHoist2 = _interopRequireDefault(_blockHoist);
	
		var _shadowFunctions = __webpack_require__(297);
	
		var _shadowFunctions2 = _interopRequireDefault(_shadowFunctions);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var shebangRegex = /^#!.*/;
	
		var INTERNAL_PLUGINS = [[_blockHoist2.default], [_shadowFunctions2.default]];
	
		var errorVisitor = {
		  enter: function enter(path, state) {
		    var loc = path.node.loc;
		    if (loc) {
		      state.loc = loc;
		      path.stop();
		    }
		  }
		};
	
		var File = function (_Store) {
		  (0, _inherits3.default)(File, _Store);
	
		  function File() {
		    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		    var pipeline = arguments[1];
		    (0, _classCallCheck3.default)(this, File);
	
		    var _this = (0, _possibleConstructorReturn3.default)(this, _Store.call(this));
	
		    _this.pipeline = pipeline;
	
		    _this.log = new _logger2.default(_this, opts.filename || "unknown");
		    _this.opts = _this.initOptions(opts);
	
		    _this.parserOpts = {
		      sourceType: _this.opts.sourceType,
		      sourceFileName: _this.opts.filename,
		      plugins: []
		    };
	
		    _this.pluginVisitors = [];
		    _this.pluginPasses = [];
	
		    _this.buildPluginsForOptions(_this.opts);
	
		    if (_this.opts.passPerPreset) {
		      _this.perPresetOpts = [];
		      _this.opts.presets.forEach(function (presetOpts) {
		        var perPresetOpts = (0, _assign2.default)((0, _create2.default)(_this.opts), presetOpts);
		        _this.perPresetOpts.push(perPresetOpts);
		        _this.buildPluginsForOptions(perPresetOpts);
		      });
		    }
	
		    _this.metadata = {
		      usedHelpers: [],
		      marked: [],
		      modules: {
		        imports: [],
		        exports: {
		          exported: [],
		          specifiers: []
		        }
		      }
		    };
	
		    _this.dynamicImportTypes = {};
		    _this.dynamicImportIds = {};
		    _this.dynamicImports = [];
		    _this.declarations = {};
		    _this.usedHelpers = {};
	
		    _this.path = null;
		    _this.ast = {};
	
		    _this.code = "";
		    _this.shebang = "";
	
		    _this.hub = new _babelTraverse.Hub(_this);
		    return _this;
		  }
	
		  File.prototype.getMetadata = function getMetadata() {
		    var has = false;
		    for (var _iterator = this.ast.program.body, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var node = _ref;
	
		      if (t.isModuleDeclaration(node)) {
		        has = true;
		        break;
		      }
		    }
		    if (has) {
		      this.path.traverse(metadataVisitor, this);
		    }
		  };
	
		  File.prototype.initOptions = function initOptions(opts) {
		    opts = new _optionManager2.default(this.log, this.pipeline).init(opts);
	
		    if (opts.inputSourceMap) {
		      opts.sourceMaps = true;
		    }
	
		    if (opts.moduleId) {
		      opts.moduleIds = true;
		    }
	
		    opts.basename = _path2.default.basename(opts.filename, _path2.default.extname(opts.filename));
	
		    opts.ignore = util.arrayify(opts.ignore, util.regexify);
	
		    if (opts.only) opts.only = util.arrayify(opts.only, util.regexify);
	
		    (0, _defaults2.default)(opts, {
		      moduleRoot: opts.sourceRoot
		    });
	
		    (0, _defaults2.default)(opts, {
		      sourceRoot: opts.moduleRoot
		    });
	
		    (0, _defaults2.default)(opts, {
		      filenameRelative: opts.filename
		    });
	
		    var basenameRelative = _path2.default.basename(opts.filenameRelative);
	
		    (0, _defaults2.default)(opts, {
		      sourceFileName: basenameRelative,
		      sourceMapTarget: basenameRelative
		    });
	
		    return opts;
		  };
	
		  File.prototype.buildPluginsForOptions = function buildPluginsForOptions(opts) {
		    if (!Array.isArray(opts.plugins)) {
		      return;
		    }
	
		    var plugins = opts.plugins.concat(INTERNAL_PLUGINS);
		    var currentPluginVisitors = [];
		    var currentPluginPasses = [];
	
		    for (var _iterator2 = plugins, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		      var _ref2;
	
		      if (_isArray2) {
		        if (_i2 >= _iterator2.length) break;
		        _ref2 = _iterator2[_i2++];
		      } else {
		        _i2 = _iterator2.next();
		        if (_i2.done) break;
		        _ref2 = _i2.value;
		      }
	
		      var ref = _ref2;
		      var plugin = ref[0],
		          pluginOpts = ref[1];
	
		      currentPluginVisitors.push(plugin.visitor);
		      currentPluginPasses.push(new _pluginPass2.default(this, plugin, pluginOpts));
	
		      if (plugin.manipulateOptions) {
		        plugin.manipulateOptions(opts, this.parserOpts, this);
		      }
		    }
	
		    this.pluginVisitors.push(currentPluginVisitors);
		    this.pluginPasses.push(currentPluginPasses);
		  };
	
		  File.prototype.getModuleName = function getModuleName() {
		    var opts = this.opts;
		    if (!opts.moduleIds) {
		      return null;
		    }
	
		    if (opts.moduleId != null && !opts.getModuleId) {
		      return opts.moduleId;
		    }
	
		    var filenameRelative = opts.filenameRelative;
		    var moduleName = "";
	
		    if (opts.moduleRoot != null) {
		      moduleName = opts.moduleRoot + "/";
		    }
	
		    if (!opts.filenameRelative) {
		      return moduleName + opts.filename.replace(/^\//, "");
		    }
	
		    if (opts.sourceRoot != null) {
		      var sourceRootRegEx = new RegExp("^" + opts.sourceRoot + "\/?");
		      filenameRelative = filenameRelative.replace(sourceRootRegEx, "");
		    }
	
		    filenameRelative = filenameRelative.replace(/\.(\w*?)$/, "");
	
		    moduleName += filenameRelative;
	
		    moduleName = moduleName.replace(/\\/g, "/");
	
		    if (opts.getModuleId) {
		      return opts.getModuleId(moduleName) || moduleName;
		    } else {
		      return moduleName;
		    }
		  };
	
		  File.prototype.resolveModuleSource = function resolveModuleSource(source) {
		    var resolveModuleSource = this.opts.resolveModuleSource;
		    if (resolveModuleSource) source = resolveModuleSource(source, this.opts.filename);
		    return source;
		  };
	
		  File.prototype.addImport = function addImport(source, imported) {
		    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : imported;
	
		    var alias = source + ":" + imported;
		    var id = this.dynamicImportIds[alias];
	
		    if (!id) {
		      source = this.resolveModuleSource(source);
		      id = this.dynamicImportIds[alias] = this.scope.generateUidIdentifier(name);
	
		      var specifiers = [];
	
		      if (imported === "*") {
		        specifiers.push(t.importNamespaceSpecifier(id));
		      } else if (imported === "default") {
		        specifiers.push(t.importDefaultSpecifier(id));
		      } else {
		        specifiers.push(t.importSpecifier(id, t.identifier(imported)));
		      }
	
		      var declar = t.importDeclaration(specifiers, t.stringLiteral(source));
		      declar._blockHoist = 3;
	
		      this.path.unshiftContainer("body", declar);
		    }
	
		    return id;
		  };
	
		  File.prototype.addHelper = function addHelper(name) {
		    var declar = this.declarations[name];
		    if (declar) return declar;
	
		    if (!this.usedHelpers[name]) {
		      this.metadata.usedHelpers.push(name);
		      this.usedHelpers[name] = true;
		    }
	
		    var generator = this.get("helperGenerator");
		    var runtime = this.get("helpersNamespace");
		    if (generator) {
		      var res = generator(name);
		      if (res) return res;
		    } else if (runtime) {
		      return t.memberExpression(runtime, t.identifier(name));
		    }
	
		    var ref = (0, _babelHelpers2.default)(name);
		    var uid = this.declarations[name] = this.scope.generateUidIdentifier(name);
	
		    if (t.isFunctionExpression(ref) && !ref.id) {
		      ref.body._compact = true;
		      ref._generated = true;
		      ref.id = uid;
		      ref.type = "FunctionDeclaration";
		      this.path.unshiftContainer("body", ref);
		    } else {
		      ref._compact = true;
		      this.scope.push({
		        id: uid,
		        init: ref,
		        unique: true
		      });
		    }
	
		    return uid;
		  };
	
		  File.prototype.addTemplateObject = function addTemplateObject(helperName, strings, raw) {
		    var stringIds = raw.elements.map(function (string) {
		      return string.value;
		    });
		    var name = helperName + "_" + raw.elements.length + "_" + stringIds.join(",");
	
		    var declar = this.declarations[name];
		    if (declar) return declar;
	
		    var uid = this.declarations[name] = this.scope.generateUidIdentifier("templateObject");
	
		    var helperId = this.addHelper(helperName);
		    var init = t.callExpression(helperId, [strings, raw]);
		    init._compact = true;
		    this.scope.push({
		      id: uid,
		      init: init,
		      _blockHoist: 1.9 });
		    return uid;
		  };
	
		  File.prototype.buildCodeFrameError = function buildCodeFrameError(node, msg) {
		    var Error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SyntaxError;
	
		    var loc = node && (node.loc || node._loc);
	
		    var err = new Error(msg);
	
		    if (loc) {
		      err.loc = loc.start;
		    } else {
		      (0, _babelTraverse2.default)(node, errorVisitor, this.scope, err);
	
		      err.message += " (This is an error on an internal node. Probably an internal error";
	
		      if (err.loc) {
		        err.message += ". Location has been estimated.";
		      }
	
		      err.message += ")";
		    }
	
		    return err;
		  };
	
		  File.prototype.mergeSourceMap = function mergeSourceMap(map) {
		    var inputMap = this.opts.inputSourceMap;
	
		    if (inputMap) {
		      var inputMapConsumer = new _sourceMap2.default.SourceMapConsumer(inputMap);
		      var outputMapConsumer = new _sourceMap2.default.SourceMapConsumer(map);
	
		      var mergedGenerator = new _sourceMap2.default.SourceMapGenerator({
		        file: inputMapConsumer.file,
		        sourceRoot: inputMapConsumer.sourceRoot
		      });
	
		      var source = outputMapConsumer.sources[0];
	
		      inputMapConsumer.eachMapping(function (mapping) {
		        var generatedPosition = outputMapConsumer.generatedPositionFor({
		          line: mapping.generatedLine,
		          column: mapping.generatedColumn,
		          source: source
		        });
		        if (generatedPosition.column != null) {
		          mergedGenerator.addMapping({
		            source: mapping.source,
	
		            original: mapping.source == null ? null : {
		              line: mapping.originalLine,
		              column: mapping.originalColumn
		            },
	
		            generated: generatedPosition
		          });
		        }
		      });
	
		      var mergedMap = mergedGenerator.toJSON();
		      inputMap.mappings = mergedMap.mappings;
		      return inputMap;
		    } else {
		      return map;
		    }
		  };
	
		  File.prototype.parse = function parse(code) {
		    var parseCode = _babylon.parse;
		    var parserOpts = this.opts.parserOpts;
	
		    if (parserOpts) {
		      parserOpts = (0, _assign2.default)({}, this.parserOpts, parserOpts);
	
		      if (parserOpts.parser) {
		        if (typeof parserOpts.parser === "string") {
		          var dirname = _path2.default.dirname(this.opts.filename) || process.cwd();
		          var parser = (0, _resolve2.default)(parserOpts.parser, dirname);
		          if (parser) {
		            parseCode = __webpack_require__(178)(parser).parse;
		          } else {
		            throw new Error("Couldn't find parser " + parserOpts.parser + " with \"parse\" method " + ("relative to directory " + dirname));
		          }
		        } else {
		          parseCode = parserOpts.parser;
		        }
	
		        parserOpts.parser = {
		          parse: function parse(source) {
		            return (0, _babylon.parse)(source, parserOpts);
		          }
		        };
		      }
		    }
	
		    this.log.debug("Parse start");
		    var ast = parseCode(code, parserOpts || this.parserOpts);
		    this.log.debug("Parse stop");
		    return ast;
		  };
	
		  File.prototype._addAst = function _addAst(ast) {
		    this.path = _babelTraverse.NodePath.get({
		      hub: this.hub,
		      parentPath: null,
		      parent: ast,
		      container: ast,
		      key: "program"
		    }).setContext();
		    this.scope = this.path.scope;
		    this.ast = ast;
		    this.getMetadata();
		  };
	
		  File.prototype.addAst = function addAst(ast) {
		    this.log.debug("Start set AST");
		    this._addAst(ast);
		    this.log.debug("End set AST");
		  };
	
		  File.prototype.transform = function transform() {
		    for (var i = 0; i < this.pluginPasses.length; i++) {
		      var pluginPasses = this.pluginPasses[i];
		      this.call("pre", pluginPasses);
		      this.log.debug("Start transform traverse");
	
		      var visitor = _babelTraverse2.default.visitors.merge(this.pluginVisitors[i], pluginPasses, this.opts.wrapPluginVisitorMethod);
		      (0, _babelTraverse2.default)(this.ast, visitor, this.scope);
	
		      this.log.debug("End transform traverse");
		      this.call("post", pluginPasses);
		    }
	
		    return this.generate();
		  };
	
		  File.prototype.wrap = function wrap(code, callback) {
		    code = code + "";
	
		    try {
		      if (this.shouldIgnore()) {
		        return this.makeResult({ code: code, ignored: true });
		      } else {
		        return callback();
		      }
		    } catch (err) {
		      if (err._babel) {
		        throw err;
		      } else {
		        err._babel = true;
		      }
	
		      var message = err.message = this.opts.filename + ": " + err.message;
	
		      var loc = err.loc;
		      if (loc) {
		        err.codeFrame = (0, _babelCodeFrame2.default)(code, loc.line, loc.column + 1, this.opts);
		        message += "\n" + err.codeFrame;
		      }
	
		      if (process.browser) {
		        err.message = message;
		      }
	
		      if (err.stack) {
		        var newStack = err.stack.replace(err.message, message);
		        err.stack = newStack;
		      }
	
		      throw err;
		    }
		  };
	
		  File.prototype.addCode = function addCode(code) {
		    code = (code || "") + "";
		    code = this.parseInputSourceMap(code);
		    this.code = code;
		  };
	
		  File.prototype.parseCode = function parseCode() {
		    this.parseShebang();
		    var ast = this.parse(this.code);
		    this.addAst(ast);
		  };
	
		  File.prototype.shouldIgnore = function shouldIgnore() {
		    var opts = this.opts;
		    return util.shouldIgnore(opts.filename, opts.ignore, opts.only);
		  };
	
		  File.prototype.call = function call(key, pluginPasses) {
		    for (var _iterator3 = pluginPasses, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		      var _ref3;
	
		      if (_isArray3) {
		        if (_i3 >= _iterator3.length) break;
		        _ref3 = _iterator3[_i3++];
		      } else {
		        _i3 = _iterator3.next();
		        if (_i3.done) break;
		        _ref3 = _i3.value;
		      }
	
		      var pass = _ref3;
	
		      var plugin = pass.plugin;
		      var fn = plugin[key];
		      if (fn) fn.call(pass, this);
		    }
		  };
	
		  File.prototype.parseInputSourceMap = function parseInputSourceMap(code) {
		    var opts = this.opts;
	
		    if (opts.inputSourceMap !== false) {
		      var inputMap = _convertSourceMap2.default.fromSource(code);
		      if (inputMap) {
		        opts.inputSourceMap = inputMap.toObject();
		        code = _convertSourceMap2.default.removeComments(code);
		      }
		    }
	
		    return code;
		  };
	
		  File.prototype.parseShebang = function parseShebang() {
		    var shebangMatch = shebangRegex.exec(this.code);
		    if (shebangMatch) {
		      this.shebang = shebangMatch[0];
		      this.code = this.code.replace(shebangRegex, "");
		    }
		  };
	
		  File.prototype.makeResult = function makeResult(_ref4) {
		    var code = _ref4.code,
		        map = _ref4.map,
		        ast = _ref4.ast,
		        ignored = _ref4.ignored;
	
		    var result = {
		      metadata: null,
		      options: this.opts,
		      ignored: !!ignored,
		      code: null,
		      ast: null,
		      map: map || null
		    };
	
		    if (this.opts.code) {
		      result.code = code;
		    }
	
		    if (this.opts.ast) {
		      result.ast = ast;
		    }
	
		    if (this.opts.metadata) {
		      result.metadata = this.metadata;
		    }
	
		    return result;
		  };
	
		  File.prototype.generate = function generate() {
		    var opts = this.opts;
		    var ast = this.ast;
	
		    var result = { ast: ast };
		    if (!opts.code) return this.makeResult(result);
	
		    var gen = _babelGenerator2.default;
		    if (opts.generatorOpts.generator) {
		      gen = opts.generatorOpts.generator;
	
		      if (typeof gen === "string") {
		        var dirname = _path2.default.dirname(this.opts.filename) || process.cwd();
		        var generator = (0, _resolve2.default)(gen, dirname);
		        if (generator) {
		          gen = __webpack_require__(178)(generator).print;
		        } else {
		          throw new Error("Couldn't find generator " + gen + " with \"print\" method relative " + ("to directory " + dirname));
		        }
		      }
		    }
	
		    this.log.debug("Generation start");
	
		    var _result = gen(ast, opts.generatorOpts ? (0, _assign2.default)(opts, opts.generatorOpts) : opts, this.code);
		    result.code = _result.code;
		    result.map = _result.map;
	
		    this.log.debug("Generation end");
	
		    if (this.shebang) {
		      result.code = this.shebang + "\n" + result.code;
		    }
	
		    if (result.map) {
		      result.map = this.mergeSourceMap(result.map);
		    }
	
		    if (opts.sourceMaps === "inline" || opts.sourceMaps === "both") {
		      result.code += "\n" + _convertSourceMap2.default.fromObject(result.map).toComment();
		    }
	
		    if (opts.sourceMaps === "inline") {
		      result.map = null;
		    }
	
		    return this.makeResult(result);
		  };
	
		  return File;
		}(_store2.default);
	
		exports.default = File;
		exports.File = File;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
		exports.__esModule = true;
	
		var _assign = __webpack_require__(87);
	
		var _assign2 = _interopRequireDefault(_assign);
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		exports.default = buildConfigChain;
	
		var _resolve = __webpack_require__(118);
	
		var _resolve2 = _interopRequireDefault(_resolve);
	
		var _json = __webpack_require__(470);
	
		var _json2 = _interopRequireDefault(_json);
	
		var _pathIsAbsolute = __webpack_require__(604);
	
		var _pathIsAbsolute2 = _interopRequireDefault(_pathIsAbsolute);
	
		var _path = __webpack_require__(19);
	
		var _path2 = _interopRequireDefault(_path);
	
		var _fs = __webpack_require__(115);
	
		var _fs2 = _interopRequireDefault(_fs);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var existsCache = {};
		var jsonCache = {};
	
		var BABELIGNORE_FILENAME = ".babelignore";
		var BABELRC_FILENAME = ".babelrc";
		var PACKAGE_FILENAME = "package.json";
	
		function exists(filename) {
		  var cached = existsCache[filename];
		  if (cached == null) {
		    return existsCache[filename] = _fs2.default.existsSync(filename);
		  } else {
		    return cached;
		  }
		}
	
		function buildConfigChain() {
		  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		  var log = arguments[1];
	
		  var filename = opts.filename;
		  var builder = new ConfigChainBuilder(log);
	
		  if (opts.babelrc !== false) {
		    builder.findConfigs(filename);
		  }
	
		  builder.mergeConfig({
		    options: opts,
		    alias: "base",
		    dirname: filename && _path2.default.dirname(filename)
		  });
	
		  return builder.configs;
		}
	
		var ConfigChainBuilder = function () {
		  function ConfigChainBuilder(log) {
		    (0, _classCallCheck3.default)(this, ConfigChainBuilder);
	
		    this.resolvedConfigs = [];
		    this.configs = [];
		    this.log = log;
		  }
	
		  ConfigChainBuilder.prototype.findConfigs = function findConfigs(loc) {
		    if (!loc) return;
	
		    if (!(0, _pathIsAbsolute2.default)(loc)) {
		      loc = _path2.default.join(process.cwd(), loc);
		    }
	
		    var foundConfig = false;
		    var foundIgnore = false;
	
		    while (loc !== (loc = _path2.default.dirname(loc))) {
		      if (!foundConfig) {
		        var configLoc = _path2.default.join(loc, BABELRC_FILENAME);
		        if (exists(configLoc)) {
		          this.addConfig(configLoc);
		          foundConfig = true;
		        }
	
		        var pkgLoc = _path2.default.join(loc, PACKAGE_FILENAME);
		        if (!foundConfig && exists(pkgLoc)) {
		          foundConfig = this.addConfig(pkgLoc, "babel", JSON);
		        }
		      }
	
		      if (!foundIgnore) {
		        var ignoreLoc = _path2.default.join(loc, BABELIGNORE_FILENAME);
		        if (exists(ignoreLoc)) {
		          this.addIgnoreConfig(ignoreLoc);
		          foundIgnore = true;
		        }
		      }
	
		      if (foundIgnore && foundConfig) return;
		    }
		  };
	
		  ConfigChainBuilder.prototype.addIgnoreConfig = function addIgnoreConfig(loc) {
		    var file = _fs2.default.readFileSync(loc, "utf8");
		    var lines = file.split("\n");
	
		    lines = lines.map(function (line) {
		      return line.replace(/#(.*?)$/, "").trim();
		    }).filter(function (line) {
		      return !!line;
		    });
	
		    if (lines.length) {
		      this.mergeConfig({
		        options: { ignore: lines },
		        alias: loc,
		        dirname: _path2.default.dirname(loc)
		      });
		    }
		  };
	
		  ConfigChainBuilder.prototype.addConfig = function addConfig(loc, key) {
		    var json = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _json2.default;
	
		    if (this.resolvedConfigs.indexOf(loc) >= 0) {
		      return false;
		    }
	
		    this.resolvedConfigs.push(loc);
	
		    var content = _fs2.default.readFileSync(loc, "utf8");
		    var options = void 0;
	
		    try {
		      options = jsonCache[content] = jsonCache[content] || json.parse(content);
		      if (key) options = options[key];
		    } catch (err) {
		      err.message = loc + ": Error while parsing JSON - " + err.message;
		      throw err;
		    }
	
		    this.mergeConfig({
		      options: options,
		      alias: loc,
		      dirname: _path2.default.dirname(loc)
		    });
	
		    return !!options;
		  };
	
		  ConfigChainBuilder.prototype.mergeConfig = function mergeConfig(_ref) {
		    var options = _ref.options,
		        alias = _ref.alias,
		        loc = _ref.loc,
		        dirname = _ref.dirname;
	
		    if (!options) {
		      return false;
		    }
	
		    options = (0, _assign2.default)({}, options);
	
		    dirname = dirname || process.cwd();
		    loc = loc || alias;
	
		    if (options.extends) {
		      var extendsLoc = (0, _resolve2.default)(options.extends, dirname);
		      if (extendsLoc) {
		        this.addConfig(extendsLoc);
		      } else {
		        if (this.log) this.log.error("Couldn't resolve extends clause of " + options.extends + " in " + alias);
		      }
		      delete options.extends;
		    }
	
		    this.configs.push({
		      options: options,
		      alias: alias,
		      loc: loc,
		      dirname: dirname
		    });
	
		    var envOpts = void 0;
		    var envKey = process.env.BABEL_ENV || ("production") || "development";
		    if (options.env) {
		      envOpts = options.env[envKey];
		      delete options.env;
		    }
	
		    this.mergeConfig({
		      options: envOpts,
		      alias: alias + ".env." + envKey,
		      dirname: dirname
		    });
		  };
	
		  return ConfigChainBuilder;
		}();
	
		module.exports = exports["default"];
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))
	
	/***/ }),
	/* 52 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.config = undefined;
		exports.normaliseOptions = normaliseOptions;
	
		var _parsers = __webpack_require__(53);
	
		var parsers = _interopRequireWildcard(_parsers);
	
		var _config = __webpack_require__(33);
	
		var _config2 = _interopRequireDefault(_config);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		exports.config = _config2.default;
		function normaliseOptions() {
		  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
		  for (var key in options) {
		    var val = options[key];
		    if (val == null) continue;
	
		    var opt = _config2.default[key];
		    if (opt && opt.alias) opt = _config2.default[opt.alias];
		    if (!opt) continue;
	
		    var parser = parsers[opt.type];
		    if (parser) val = parser(val);
	
		    options[key] = val;
		  }
	
		  return options;
		}
	
	/***/ }),
	/* 53 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.filename = undefined;
		exports.boolean = boolean;
		exports.booleanString = booleanString;
		exports.list = list;
	
		var _slash = __webpack_require__(284);
	
		var _slash2 = _interopRequireDefault(_slash);
	
		var _util = __webpack_require__(122);
	
		var util = _interopRequireWildcard(_util);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var filename = exports.filename = _slash2.default;
	
		function boolean(val) {
		  return !!val;
		}
	
		function booleanString(val) {
		  return util.booleanify(val);
		}
	
		function list(val) {
		  return util.list(val);
		}
	
	/***/ }),
	/* 54 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		module.exports = {
		  "auxiliaryComment": {
		    "message": "Use `auxiliaryCommentBefore` or `auxiliaryCommentAfter`"
		  },
		  "blacklist": {
		    "message": "Put the specific transforms you want in the `plugins` option"
		  },
		  "breakConfig": {
		    "message": "This is not a necessary option in Babel 6"
		  },
		  "experimental": {
		    "message": "Put the specific transforms you want in the `plugins` option"
		  },
		  "externalHelpers": {
		    "message": "Use the `external-helpers` plugin instead. Check out http://babeljs.io/docs/plugins/external-helpers/"
		  },
		  "extra": {
		    "message": ""
		  },
		  "jsxPragma": {
		    "message": "use the `pragma` option in the `react-jsx` plugin . Check out http://babeljs.io/docs/plugins/transform-react-jsx/"
		  },
	
		  "loose": {
		    "message": "Specify the `loose` option for the relevant plugin you are using or use a preset that sets the option."
		  },
		  "metadataUsedHelpers": {
		    "message": "Not required anymore as this is enabled by default"
		  },
		  "modules": {
		    "message": "Use the corresponding module transform plugin in the `plugins` option. Check out http://babeljs.io/docs/plugins/#modules"
		  },
		  "nonStandard": {
		    "message": "Use the `react-jsx` and `flow-strip-types` plugins to support JSX and Flow. Also check out the react preset http://babeljs.io/docs/plugins/preset-react/"
		  },
		  "optional": {
		    "message": "Put the specific transforms you want in the `plugins` option"
		  },
		  "sourceMapName": {
		    "message": "Use the `sourceMapTarget` option"
		  },
		  "stage": {
		    "message": "Check out the corresponding stage-x presets http://babeljs.io/docs/plugins/#presets"
		  },
		  "whitelist": {
		    "message": "Put the specific transforms you want in the `plugins` option"
		  }
		};
	
	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var ctx = __webpack_require__(43);
		var call = __webpack_require__(428);
		var isArrayIter = __webpack_require__(427);
		var anObject = __webpack_require__(21);
		var toLength = __webpack_require__(153);
		var getIterFn = __webpack_require__(238);
		var BREAK = {};
		var RETURN = {};
		var _exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
		  var iterFn = ITERATOR ? function () {
		    return iterable;
		  } : getIterFn(iterable);
		  var f = ctx(fn, that, entries ? 2 : 1);
		  var index = 0;
		  var length, step, iterator, result;
		  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
		  // fast case for arrays with default iterator
		  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
		    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
		    if (result === BREAK || result === RETURN) return result;
		  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
		    result = call(iterator, f, step.value, entries);
		    if (result === BREAK || result === RETURN) return result;
		  }
		};
		_exports.BREAK = BREAK;
		_exports.RETURN = RETURN;
	
	/***/ }),
	/* 56 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		module.exports = {};
	
	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var META = __webpack_require__(95)('meta');
		var isObject = __webpack_require__(16);
		var has = __webpack_require__(28);
		var setDesc = __webpack_require__(23).f;
		var id = 0;
		var isExtensible = Object.isExtensible || function () {
		  return true;
		};
		var FREEZE = !__webpack_require__(27)(function () {
		  return isExtensible(Object.preventExtensions({}));
		});
		var setMeta = function setMeta(it) {
		  setDesc(it, META, { value: {
		      i: 'O' + ++id, // object ID
		      w: {} // weak collections IDs
		    } });
		};
		var fastKey = function fastKey(it, create) {
		  // return primitive with prefix
		  if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
		  if (!has(it, META)) {
		    // can't set metadata to uncaught frozen object
		    if (!isExtensible(it)) return 'F';
		    // not necessary to add metadata
		    if (!create) return 'E';
		    // add missing metadata
		    setMeta(it);
		    // return object ID
		  }return it[META].i;
		};
		var getWeak = function getWeak(it, create) {
		  if (!has(it, META)) {
		    // can't set metadata to uncaught frozen object
		    if (!isExtensible(it)) return true;
		    // not necessary to add metadata
		    if (!create) return false;
		    // add missing metadata
		    setMeta(it);
		    // return hash weak collections IDs
		  }return it[META].w;
		};
		// add metadata on freeze-family methods calling
		var onFreeze = function onFreeze(it) {
		  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
		  return it;
		};
		var meta = module.exports = {
		  KEY: META,
		  NEED: false,
		  fastKey: fastKey,
		  getWeak: getWeak,
		  onFreeze: onFreeze
		};
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isObject = __webpack_require__(16);
		module.exports = function (it, TYPE) {
		  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
		  return it;
		};
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		__webpack_require__(440);
		var global = __webpack_require__(15);
		var hide = __webpack_require__(29);
		var Iterators = __webpack_require__(56);
		var TO_STRING_TAG = __webpack_require__(13)('toStringTag');
	
		var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');
	
		for (var i = 0; i < DOMIterables.length; i++) {
		  var NAME = DOMIterables[i];
		  var Collection = global[NAME];
		  var proto = Collection && Collection.prototype;
		  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
		  Iterators[NAME] = Iterators.Array;
		}
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * A specialized version of `_.map` for arrays without support for iteratee
		 * shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the new mapped array.
		 */
		function arrayMap(array, iteratee) {
		  var index = -1,
		      length = array == null ? 0 : array.length,
		      result = Array(length);
	
		  while (++index < length) {
		    result[index] = iteratee(array[index], index, array);
		  }
		  return result;
		}
	
		module.exports = arrayMap;
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var baseMatches = __webpack_require__(502),
		    baseMatchesProperty = __webpack_require__(503),
		    identity = __webpack_require__(110),
		    isArray = __webpack_require__(6),
		    property = __webpack_require__(592);
	
		/**
		 * The base implementation of `_.iteratee`.
		 *
		 * @private
		 * @param {*} [value=_.identity] The value to convert to an iteratee.
		 * @returns {Function} Returns the iteratee.
		 */
		function baseIteratee(value) {
		  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
		  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
		  if (typeof value == 'function') {
		    return value;
		  }
		  if (value == null) {
		    return identity;
		  }
		  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object') {
		    return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
		  }
		  return property(value);
		}
	
		module.exports = baseIteratee;
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var baseGetTag = __webpack_require__(30),
		    isObjectLike = __webpack_require__(25);
	
		/** `Object#toString` result references. */
		var symbolTag = '[object Symbol]';
	
		/**
		 * Checks if `value` is classified as a `Symbol` primitive or object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
		 * @example
		 *
		 * _.isSymbol(Symbol.iterator);
		 * // => true
		 *
		 * _.isSymbol('abc');
		 * // => false
		 */
		function isSymbol(value) {
		    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
		}
	
		module.exports = isSymbol;
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		/**
		 * This is a helper function for getting values from parameter/options
		 * objects.
		 *
		 * @param args The object we are extracting values from
		 * @param name The name of the property we are getting.
		 * @param defaultValue An optional value to return if the property is missing
		 * from the object. If this is not specified and the property is missing, an
		 * error will be thrown.
		 */
		function getArg(aArgs, aName, aDefaultValue) {
		  if (aName in aArgs) {
		    return aArgs[aName];
		  } else if (arguments.length === 3) {
		    return aDefaultValue;
		  } else {
		    throw new Error('"' + aName + '" is a required argument.');
		  }
		}
		exports.getArg = getArg;
	
		var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
		var dataUrlRegexp = /^data:.+\,.+$/;
	
		function urlParse(aUrl) {
		  var match = aUrl.match(urlRegexp);
		  if (!match) {
		    return null;
		  }
		  return {
		    scheme: match[1],
		    auth: match[2],
		    host: match[3],
		    port: match[4],
		    path: match[5]
		  };
		}
		exports.urlParse = urlParse;
	
		function urlGenerate(aParsedUrl) {
		  var url = '';
		  if (aParsedUrl.scheme) {
		    url += aParsedUrl.scheme + ':';
		  }
		  url += '//';
		  if (aParsedUrl.auth) {
		    url += aParsedUrl.auth + '@';
		  }
		  if (aParsedUrl.host) {
		    url += aParsedUrl.host;
		  }
		  if (aParsedUrl.port) {
		    url += ":" + aParsedUrl.port;
		  }
		  if (aParsedUrl.path) {
		    url += aParsedUrl.path;
		  }
		  return url;
		}
		exports.urlGenerate = urlGenerate;
	
		/**
		 * Normalizes a path, or the path portion of a URL:
		 *
		 * - Replaces consecutive slashes with one slash.
		 * - Removes unnecessary '.' parts.
		 * - Removes unnecessary '<dir>/..' parts.
		 *
		 * Based on code in the Node.js 'path' core module.
		 *
		 * @param aPath The path or url to normalize.
		 */
		function normalize(aPath) {
		  var path = aPath;
		  var url = urlParse(aPath);
		  if (url) {
		    if (!url.path) {
		      return aPath;
		    }
		    path = url.path;
		  }
		  var isAbsolute = exports.isAbsolute(path);
	
		  var parts = path.split(/\/+/);
		  for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
		    part = parts[i];
		    if (part === '.') {
		      parts.splice(i, 1);
		    } else if (part === '..') {
		      up++;
		    } else if (up > 0) {
		      if (part === '') {
		        // The first part is blank if the path is absolute. Trying to go
		        // above the root is a no-op. Therefore we can remove all '..' parts
		        // directly after the root.
		        parts.splice(i + 1, up);
		        up = 0;
		      } else {
		        parts.splice(i, 2);
		        up--;
		      }
		    }
		  }
		  path = parts.join('/');
	
		  if (path === '') {
		    path = isAbsolute ? '/' : '.';
		  }
	
		  if (url) {
		    url.path = path;
		    return urlGenerate(url);
		  }
		  return path;
		}
		exports.normalize = normalize;
	
		/**
		 * Joins two paths/URLs.
		 *
		 * @param aRoot The root path or URL.
		 * @param aPath The path or URL to be joined with the root.
		 *
		 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
		 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
		 *   first.
		 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
		 *   is updated with the result and aRoot is returned. Otherwise the result
		 *   is returned.
		 *   - If aPath is absolute, the result is aPath.
		 *   - Otherwise the two paths are joined with a slash.
		 * - Joining for example 'http://' and 'www.example.com' is also supported.
		 */
		function join(aRoot, aPath) {
		  if (aRoot === "") {
		    aRoot = ".";
		  }
		  if (aPath === "") {
		    aPath = ".";
		  }
		  var aPathUrl = urlParse(aPath);
		  var aRootUrl = urlParse(aRoot);
		  if (aRootUrl) {
		    aRoot = aRootUrl.path || '/';
		  }
	
		  // `join(foo, '//www.example.org')`
		  if (aPathUrl && !aPathUrl.scheme) {
		    if (aRootUrl) {
		      aPathUrl.scheme = aRootUrl.scheme;
		    }
		    return urlGenerate(aPathUrl);
		  }
	
		  if (aPathUrl || aPath.match(dataUrlRegexp)) {
		    return aPath;
		  }
	
		  // `join('http://', 'www.example.com')`
		  if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
		    aRootUrl.host = aPath;
		    return urlGenerate(aRootUrl);
		  }
	
		  var joined = aPath.charAt(0) === '/' ? aPath : normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);
	
		  if (aRootUrl) {
		    aRootUrl.path = joined;
		    return urlGenerate(aRootUrl);
		  }
		  return joined;
		}
		exports.join = join;
	
		exports.isAbsolute = function (aPath) {
		  return aPath.charAt(0) === '/' || !!aPath.match(urlRegexp);
		};
	
		/**
		 * Make a path relative to a URL or another path.
		 *
		 * @param aRoot The root path or URL.
		 * @param aPath The path or URL to be made relative to aRoot.
		 */
		function relative(aRoot, aPath) {
		  if (aRoot === "") {
		    aRoot = ".";
		  }
	
		  aRoot = aRoot.replace(/\/$/, '');
	
		  // It is possible for the path to be above the root. In this case, simply
		  // checking whether the root is a prefix of the path won't work. Instead, we
		  // need to remove components from the root one by one, until either we find
		  // a prefix that fits, or we run out of components to remove.
		  var level = 0;
		  while (aPath.indexOf(aRoot + '/') !== 0) {
		    var index = aRoot.lastIndexOf("/");
		    if (index < 0) {
		      return aPath;
		    }
	
		    // If the only part of the root that is left is the scheme (i.e. http://,
		    // file:///, etc.), one or more slashes (/), or simply nothing at all, we
		    // have exhausted all components, so the path is not relative to the root.
		    aRoot = aRoot.slice(0, index);
		    if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
		      return aPath;
		    }
	
		    ++level;
		  }
	
		  // Make sure we add a "../" for each component we removed from the root.
		  return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
		}
		exports.relative = relative;
	
		var supportsNullProto = function () {
		  var obj = Object.create(null);
		  return !('__proto__' in obj);
		}();
	
		function identity(s) {
		  return s;
		}
	
		/**
		 * Because behavior goes wacky when you set `__proto__` on objects, we
		 * have to prefix all the strings in our set with an arbitrary character.
		 *
		 * See https://github.com/mozilla/source-map/pull/31 and
		 * https://github.com/mozilla/source-map/issues/30
		 *
		 * @param String aStr
		 */
		function toSetString(aStr) {
		  if (isProtoString(aStr)) {
		    return '$' + aStr;
		  }
	
		  return aStr;
		}
		exports.toSetString = supportsNullProto ? identity : toSetString;
	
		function fromSetString(aStr) {
		  if (isProtoString(aStr)) {
		    return aStr.slice(1);
		  }
	
		  return aStr;
		}
		exports.fromSetString = supportsNullProto ? identity : fromSetString;
	
		function isProtoString(s) {
		  if (!s) {
		    return false;
		  }
	
		  var length = s.length;
	
		  if (length < 9 /* "__proto__".length */) {
		      return false;
		    }
	
		  if (s.charCodeAt(length - 1) !== 95 /* '_' */ || s.charCodeAt(length - 2) !== 95 /* '_' */ || s.charCodeAt(length - 3) !== 111 /* 'o' */ || s.charCodeAt(length - 4) !== 116 /* 't' */ || s.charCodeAt(length - 5) !== 111 /* 'o' */ || s.charCodeAt(length - 6) !== 114 /* 'r' */ || s.charCodeAt(length - 7) !== 112 /* 'p' */ || s.charCodeAt(length - 8) !== 95 /* '_' */ || s.charCodeAt(length - 9) !== 95 /* '_' */) {
		      return false;
		    }
	
		  for (var i = length - 10; i >= 0; i--) {
		    if (s.charCodeAt(i) !== 36 /* '$' */) {
		        return false;
		      }
		  }
	
		  return true;
		}
	
		/**
		 * Comparator between two mappings where the original positions are compared.
		 *
		 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
		 * mappings with the same original source/line/column, but different generated
		 * line and column the same. Useful when searching for a mapping with a
		 * stubbed out mapping.
		 */
		function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
		  var cmp = mappingA.source - mappingB.source;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalLine - mappingB.originalLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalColumn - mappingB.originalColumn;
		  if (cmp !== 0 || onlyCompareOriginal) {
		    return cmp;
		  }
	
		  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.generatedLine - mappingB.generatedLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  return mappingA.name - mappingB.name;
		}
		exports.compareByOriginalPositions = compareByOriginalPositions;
	
		/**
		 * Comparator between two mappings with deflated source and name indices where
		 * the generated positions are compared.
		 *
		 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
		 * mappings with the same generated line and column, but different
		 * source/name/original line and column the same. Useful when searching for a
		 * mapping with a stubbed out mapping.
		 */
		function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
		  var cmp = mappingA.generatedLine - mappingB.generatedLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
		  if (cmp !== 0 || onlyCompareGenerated) {
		    return cmp;
		  }
	
		  cmp = mappingA.source - mappingB.source;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalLine - mappingB.originalLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalColumn - mappingB.originalColumn;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  return mappingA.name - mappingB.name;
		}
		exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;
	
		function strcmp(aStr1, aStr2) {
		  if (aStr1 === aStr2) {
		    return 0;
		  }
	
		  if (aStr1 > aStr2) {
		    return 1;
		  }
	
		  return -1;
		}
	
		/**
		 * Comparator between two mappings with inflated source and name strings where
		 * the generated positions are compared.
		 */
		function compareByGeneratedPositionsInflated(mappingA, mappingB) {
		  var cmp = mappingA.generatedLine - mappingB.generatedLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = strcmp(mappingA.source, mappingB.source);
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalLine - mappingB.originalLine;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  cmp = mappingA.originalColumn - mappingB.originalColumn;
		  if (cmp !== 0) {
		    return cmp;
		  }
	
		  return strcmp(mappingA.name, mappingB.name);
		}
		exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
		// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
		// original notice:
	
		/*!
		 * The buffer module from node.js, for the browser.
		 *
		 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
		 * @license  MIT
		 */
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		function compare(a, b) {
		  if (a === b) {
		    return 0;
		  }
	
		  var x = a.length;
		  var y = b.length;
	
		  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
		    if (a[i] !== b[i]) {
		      x = a[i];
		      y = b[i];
		      break;
		    }
		  }
	
		  if (x < y) {
		    return -1;
		  }
		  if (y < x) {
		    return 1;
		  }
		  return 0;
		}
		function isBuffer(b) {
		  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
		    return global.Buffer.isBuffer(b);
		  }
		  return !!(b != null && b._isBuffer);
		}
	
		// based on node assert, original notice:
	
		// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
		//
		// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
		//
		// Originally from narwhal.js (http://narwhaljs.org)
		// Copyright (c) 2009 Thomas Robinson <280north.com>
		//
		// Permission is hereby granted, free of charge, to any person obtaining a copy
		// of this software and associated documentation files (the 'Software'), to
		// deal in the Software without restriction, including without limitation the
		// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
		// sell copies of the Software, and to permit persons to whom the Software is
		// furnished to do so, subject to the following conditions:
		//
		// The above copyright notice and this permission notice shall be included in
		// all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
		// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
		// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
		var util = __webpack_require__(117);
		var hasOwn = Object.prototype.hasOwnProperty;
		var pSlice = Array.prototype.slice;
		var functionsHaveNames = function () {
		  return function foo() {}.name === 'foo';
		}();
		function pToString(obj) {
		  return Object.prototype.toString.call(obj);
		}
		function isView(arrbuf) {
		  if (isBuffer(arrbuf)) {
		    return false;
		  }
		  if (typeof global.ArrayBuffer !== 'function') {
		    return false;
		  }
		  if (typeof ArrayBuffer.isView === 'function') {
		    return ArrayBuffer.isView(arrbuf);
		  }
		  if (!arrbuf) {
		    return false;
		  }
		  if (arrbuf instanceof DataView) {
		    return true;
		  }
		  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
		    return true;
		  }
		  return false;
		}
		// 1. The assert module provides functions that throw
		// AssertionError's when particular conditions are not met. The
		// assert module must conform to the following interface.
	
		var assert = module.exports = ok;
	
		// 2. The AssertionError is defined in assert.
		// new assert.AssertionError({ message: message,
		//                             actual: actual,
		//                             expected: expected })
	
		var regex = /\s*function\s+([^\(\s]*)\s*/;
		// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
		function getName(func) {
		  if (!util.isFunction(func)) {
		    return;
		  }
		  if (functionsHaveNames) {
		    return func.name;
		  }
		  var str = func.toString();
		  var match = str.match(regex);
		  return match && match[1];
		}
		assert.AssertionError = function AssertionError(options) {
		  this.name = 'AssertionError';
		  this.actual = options.actual;
		  this.expected = options.expected;
		  this.operator = options.operator;
		  if (options.message) {
		    this.message = options.message;
		    this.generatedMessage = false;
		  } else {
		    this.message = getMessage(this);
		    this.generatedMessage = true;
		  }
		  var stackStartFunction = options.stackStartFunction || fail;
		  if (Error.captureStackTrace) {
		    Error.captureStackTrace(this, stackStartFunction);
		  } else {
		    // non v8 browsers so we can have a stacktrace
		    var err = new Error();
		    if (err.stack) {
		      var out = err.stack;
	
		      // try to strip useless frames
		      var fn_name = getName(stackStartFunction);
		      var idx = out.indexOf('\n' + fn_name);
		      if (idx >= 0) {
		        // once we have located the function frame
		        // we need to strip out everything before it (and its line)
		        var next_line = out.indexOf('\n', idx + 1);
		        out = out.substring(next_line + 1);
		      }
	
		      this.stack = out;
		    }
		  }
		};
	
		// assert.AssertionError instanceof Error
		util.inherits(assert.AssertionError, Error);
	
		function truncate(s, n) {
		  if (typeof s === 'string') {
		    return s.length < n ? s : s.slice(0, n);
		  } else {
		    return s;
		  }
		}
		function inspect(something) {
		  if (functionsHaveNames || !util.isFunction(something)) {
		    return util.inspect(something);
		  }
		  var rawname = getName(something);
		  var name = rawname ? ': ' + rawname : '';
		  return '[Function' + name + ']';
		}
		function getMessage(self) {
		  return truncate(inspect(self.actual), 128) + ' ' + self.operator + ' ' + truncate(inspect(self.expected), 128);
		}
	
		// At present only the three keys mentioned above are used and
		// understood by the spec. Implementations or sub modules can pass
		// other keys to the AssertionError's constructor - they will be
		// ignored.
	
		// 3. All of the following functions must throw an AssertionError
		// when a corresponding condition is not met, with a message that
		// may be undefined if not provided.  All assertion methods provide
		// both the actual and expected values to the assertion error for
		// display purposes.
	
		function fail(actual, expected, message, operator, stackStartFunction) {
		  throw new assert.AssertionError({
		    message: message,
		    actual: actual,
		    expected: expected,
		    operator: operator,
		    stackStartFunction: stackStartFunction
		  });
		}
	
		// EXTENSION! allows for well behaved errors defined elsewhere.
		assert.fail = fail;
	
		// 4. Pure assertion tests whether a value is truthy, as determined
		// by !!guard.
		// assert.ok(guard, message_opt);
		// This statement is equivalent to assert.equal(true, !!guard,
		// message_opt);. To test strictly for the value true, use
		// assert.strictEqual(true, guard, message_opt);.
	
		function ok(value, message) {
		  if (!value) fail(value, true, message, '==', assert.ok);
		}
		assert.ok = ok;
	
		// 5. The equality assertion tests shallow, coercive equality with
		// ==.
		// assert.equal(actual, expected, message_opt);
	
		assert.equal = function equal(actual, expected, message) {
		  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
		};
	
		// 6. The non-equality assertion tests for whether two objects are not equal
		// with != assert.notEqual(actual, expected, message_opt);
	
		assert.notEqual = function notEqual(actual, expected, message) {
		  if (actual == expected) {
		    fail(actual, expected, message, '!=', assert.notEqual);
		  }
		};
	
		// 7. The equivalence assertion tests a deep equality relation.
		// assert.deepEqual(actual, expected, message_opt);
	
		assert.deepEqual = function deepEqual(actual, expected, message) {
		  if (!_deepEqual(actual, expected, false)) {
		    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
		  }
		};
	
		assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
		  if (!_deepEqual(actual, expected, true)) {
		    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
		  }
		};
	
		function _deepEqual(actual, expected, strict, memos) {
		  // 7.1. All identical values are equivalent, as determined by ===.
		  if (actual === expected) {
		    return true;
		  } else if (isBuffer(actual) && isBuffer(expected)) {
		    return compare(actual, expected) === 0;
	
		    // 7.2. If the expected value is a Date object, the actual value is
		    // equivalent if it is also a Date object that refers to the same time.
		  } else if (util.isDate(actual) && util.isDate(expected)) {
		    return actual.getTime() === expected.getTime();
	
		    // 7.3 If the expected value is a RegExp object, the actual value is
		    // equivalent if it is also a RegExp object with the same source and
		    // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
		  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
		    return actual.source === expected.source && actual.global === expected.global && actual.multiline === expected.multiline && actual.lastIndex === expected.lastIndex && actual.ignoreCase === expected.ignoreCase;
	
		    // 7.4. Other pairs that do not both pass typeof value == 'object',
		    // equivalence is determined by ==.
		  } else if ((actual === null || (typeof actual === 'undefined' ? 'undefined' : _typeof(actual)) !== 'object') && (expected === null || (typeof expected === 'undefined' ? 'undefined' : _typeof(expected)) !== 'object')) {
		    return strict ? actual === expected : actual == expected;
	
		    // If both values are instances of typed arrays, wrap their underlying
		    // ArrayBuffers in a Buffer each to increase performance
		    // This optimization requires the arrays to have the same type as checked by
		    // Object.prototype.toString (aka pToString). Never perform binary
		    // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
		    // bit patterns are not identical.
		  } else if (isView(actual) && isView(expected) && pToString(actual) === pToString(expected) && !(actual instanceof Float32Array || actual instanceof Float64Array)) {
		    return compare(new Uint8Array(actual.buffer), new Uint8Array(expected.buffer)) === 0;
	
		    // 7.5 For all other Object pairs, including Array objects, equivalence is
		    // determined by having the same number of owned properties (as verified
		    // with Object.prototype.hasOwnProperty.call), the same set of keys
		    // (although not necessarily the same order), equivalent values for every
		    // corresponding key, and an identical 'prototype' property. Note: this
		    // accounts for both named and indexed properties on Arrays.
		  } else if (isBuffer(actual) !== isBuffer(expected)) {
		    return false;
		  } else {
		    memos = memos || { actual: [], expected: [] };
	
		    var actualIndex = memos.actual.indexOf(actual);
		    if (actualIndex !== -1) {
		      if (actualIndex === memos.expected.indexOf(expected)) {
		        return true;
		      }
		    }
	
		    memos.actual.push(actual);
		    memos.expected.push(expected);
	
		    return objEquiv(actual, expected, strict, memos);
		  }
		}
	
		function isArguments(object) {
		  return Object.prototype.toString.call(object) == '[object Arguments]';
		}
	
		function objEquiv(a, b, strict, actualVisitedObjects) {
		  if (a === null || a === undefined || b === null || b === undefined) return false;
		  // if one is a primitive, the other must be same
		  if (util.isPrimitive(a) || util.isPrimitive(b)) return a === b;
		  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b)) return false;
		  var aIsArgs = isArguments(a);
		  var bIsArgs = isArguments(b);
		  if (aIsArgs && !bIsArgs || !aIsArgs && bIsArgs) return false;
		  if (aIsArgs) {
		    a = pSlice.call(a);
		    b = pSlice.call(b);
		    return _deepEqual(a, b, strict);
		  }
		  var ka = objectKeys(a);
		  var kb = objectKeys(b);
		  var key, i;
		  // having the same number of owned properties (keys incorporates
		  // hasOwnProperty)
		  if (ka.length !== kb.length) return false;
		  //the same set of keys (although not necessarily the same order),
		  ka.sort();
		  kb.sort();
		  //~~~cheap key test
		  for (i = ka.length - 1; i >= 0; i--) {
		    if (ka[i] !== kb[i]) return false;
		  }
		  //equivalent values for every corresponding key, and
		  //~~~possibly expensive deep test
		  for (i = ka.length - 1; i >= 0; i--) {
		    key = ka[i];
		    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects)) return false;
		  }
		  return true;
		}
	
		// 8. The non-equivalence assertion tests for any deep inequality.
		// assert.notDeepEqual(actual, expected, message_opt);
	
		assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
		  if (_deepEqual(actual, expected, false)) {
		    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
		  }
		};
	
		assert.notDeepStrictEqual = notDeepStrictEqual;
		function notDeepStrictEqual(actual, expected, message) {
		  if (_deepEqual(actual, expected, true)) {
		    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
		  }
		}
	
		// 9. The strict equality assertion tests strict equality, as determined by ===.
		// assert.strictEqual(actual, expected, message_opt);
	
		assert.strictEqual = function strictEqual(actual, expected, message) {
		  if (actual !== expected) {
		    fail(actual, expected, message, '===', assert.strictEqual);
		  }
		};
	
		// 10. The strict non-equality assertion tests for strict inequality, as
		// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
		assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
		  if (actual === expected) {
		    fail(actual, expected, message, '!==', assert.notStrictEqual);
		  }
		};
	
		function expectedException(actual, expected) {
		  if (!actual || !expected) {
		    return false;
		  }
	
		  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
		    return expected.test(actual);
		  }
	
		  try {
		    if (actual instanceof expected) {
		      return true;
		    }
		  } catch (e) {
		    // Ignore.  The instanceof check doesn't work for arrow functions.
		  }
	
		  if (Error.isPrototypeOf(expected)) {
		    return false;
		  }
	
		  return expected.call({}, actual) === true;
		}
	
		function _tryBlock(block) {
		  var error;
		  try {
		    block();
		  } catch (e) {
		    error = e;
		  }
		  return error;
		}
	
		function _throws(shouldThrow, block, expected, message) {
		  var actual;
	
		  if (typeof block !== 'function') {
		    throw new TypeError('"block" argument must be a function');
		  }
	
		  if (typeof expected === 'string') {
		    message = expected;
		    expected = null;
		  }
	
		  actual = _tryBlock(block);
	
		  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') + (message ? ' ' + message : '.');
	
		  if (shouldThrow && !actual) {
		    fail(actual, expected, 'Missing expected exception' + message);
		  }
	
		  var userProvidedMessage = typeof message === 'string';
		  var isUnwantedException = !shouldThrow && util.isError(actual);
		  var isUnexpectedException = !shouldThrow && actual && !expected;
	
		  if (isUnwantedException && userProvidedMessage && expectedException(actual, expected) || isUnexpectedException) {
		    fail(actual, expected, 'Got unwanted exception' + message);
		  }
	
		  if (shouldThrow && actual && expected && !expectedException(actual, expected) || !shouldThrow && actual) {
		    throw actual;
		  }
		}
	
		// 11. Expected to throw an error:
		// assert.throws(block, Error_opt, message_opt);
	
		assert.throws = function (block, /*optional*/error, /*optional*/message) {
		  _throws(true, block, error, message);
		};
	
		// EXTENSION! This is annoying to write outside this module.
		assert.doesNotThrow = function (block, /*optional*/error, /*optional*/message) {
		  _throws(false, block, error, message);
		};
	
		assert.ifError = function (err) {
		  if (err) throw err;
		};
	
		var objectKeys = Object.keys || function (obj) {
		  var keys = [];
		  for (var key in obj) {
		    if (hasOwn.call(obj, key)) keys.push(key);
		  }
		  return keys;
		};
		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(42);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(41);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		var _optionManager = __webpack_require__(34);
	
		var _optionManager2 = _interopRequireDefault(_optionManager);
	
		var _babelMessages = __webpack_require__(20);
	
		var messages = _interopRequireWildcard(_babelMessages);
	
		var _store = __webpack_require__(119);
	
		var _store2 = _interopRequireDefault(_store);
	
		var _babelTraverse = __webpack_require__(7);
	
		var _babelTraverse2 = _interopRequireDefault(_babelTraverse);
	
		var _assign = __webpack_require__(174);
	
		var _assign2 = _interopRequireDefault(_assign);
	
		var _clone = __webpack_require__(109);
	
		var _clone2 = _interopRequireDefault(_clone);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var GLOBAL_VISITOR_PROPS = ["enter", "exit"];
	
		var Plugin = function (_Store) {
		  (0, _inherits3.default)(Plugin, _Store);
	
		  function Plugin(plugin, key) {
		    (0, _classCallCheck3.default)(this, Plugin);
	
		    var _this = (0, _possibleConstructorReturn3.default)(this, _Store.call(this));
	
		    _this.initialized = false;
		    _this.raw = (0, _assign2.default)({}, plugin);
		    _this.key = _this.take("name") || key;
	
		    _this.manipulateOptions = _this.take("manipulateOptions");
		    _this.post = _this.take("post");
		    _this.pre = _this.take("pre");
		    _this.visitor = _this.normaliseVisitor((0, _clone2.default)(_this.take("visitor")) || {});
		    return _this;
		  }
	
		  Plugin.prototype.take = function take(key) {
		    var val = this.raw[key];
		    delete this.raw[key];
		    return val;
		  };
	
		  Plugin.prototype.chain = function chain(target, key) {
		    if (!target[key]) return this[key];
		    if (!this[key]) return target[key];
	
		    var fns = [target[key], this[key]];
	
		    return function () {
		      var val = void 0;
	
		      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		        args[_key] = arguments[_key];
		      }
	
		      for (var _iterator = fns, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		        var _ref;
	
		        if (_isArray) {
		          if (_i >= _iterator.length) break;
		          _ref = _iterator[_i++];
		        } else {
		          _i = _iterator.next();
		          if (_i.done) break;
		          _ref = _i.value;
		        }
	
		        var fn = _ref;
	
		        if (fn) {
		          var ret = fn.apply(this, args);
		          if (ret != null) val = ret;
		        }
		      }
		      return val;
		    };
		  };
	
		  Plugin.prototype.maybeInherit = function maybeInherit(loc) {
		    var inherits = this.take("inherits");
		    if (!inherits) return;
	
		    inherits = _optionManager2.default.normalisePlugin(inherits, loc, "inherits");
	
		    this.manipulateOptions = this.chain(inherits, "manipulateOptions");
		    this.post = this.chain(inherits, "post");
		    this.pre = this.chain(inherits, "pre");
		    this.visitor = _babelTraverse2.default.visitors.merge([inherits.visitor, this.visitor]);
		  };
	
		  Plugin.prototype.init = function init(loc, i) {
		    if (this.initialized) return;
		    this.initialized = true;
	
		    this.maybeInherit(loc);
	
		    for (var key in this.raw) {
		      throw new Error(messages.get("pluginInvalidProperty", loc, i, key));
		    }
		  };
	
		  Plugin.prototype.normaliseVisitor = function normaliseVisitor(visitor) {
		    for (var _iterator2 = GLOBAL_VISITOR_PROPS, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		      var _ref2;
	
		      if (_isArray2) {
		        if (_i2 >= _iterator2.length) break;
		        _ref2 = _iterator2[_i2++];
		      } else {
		        _i2 = _iterator2.next();
		        if (_i2.done) break;
		        _ref2 = _i2.value;
		      }
	
		      var key = _ref2;
	
		      if (visitor[key]) {
		        throw new Error("Plugins aren't allowed to specify catch-all enter/exit handlers. " + "Please target individual nodes.");
		      }
		    }
	
		    _babelTraverse2.default.explode(visitor);
		    return visitor;
		  };
	
		  return Plugin;
		}(_store2.default);
	
		exports.default = Plugin;
		module.exports = exports["default"];
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (_ref) {
		  var messages = _ref.messages;
	
		  return {
		    visitor: {
		      Scope: function Scope(_ref2) {
		        var scope = _ref2.scope;
	
		        for (var name in scope.bindings) {
		          var binding = scope.bindings[name];
		          if (binding.kind !== "const" && binding.kind !== "module") continue;
	
		          for (var _iterator = binding.constantViolations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		            var _ref3;
	
		            if (_isArray) {
		              if (_i >= _iterator.length) break;
		              _ref3 = _iterator[_i++];
		            } else {
		              _i = _iterator.next();
		              if (_i.done) break;
		              _ref3 = _i.value;
		            }
	
		            var violation = _ref3;
	
		            throw violation.buildCodeFrameError(messages.get("readOnly", name));
		          }
		        }
		      }
		    }
		  };
		};
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    manipulateOptions: function manipulateOptions(opts, parserOpts) {
		      parserOpts.plugins.push("asyncFunctions");
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  return {
		    visitor: {
		      ArrowFunctionExpression: function ArrowFunctionExpression(path, state) {
		        if (state.opts.spec) {
		          var node = path.node;
	
		          if (node.shadow) return;
	
		          node.shadow = { this: false };
		          node.type = "FunctionExpression";
	
		          var boundThis = t.thisExpression();
		          boundThis._forceShadow = path;
	
		          path.ensureBlock();
		          path.get("body").unshiftContainer("body", t.expressionStatement(t.callExpression(state.addHelper("newArrowCheck"), [t.thisExpression(), boundThis])));
	
		          path.replaceWith(t.callExpression(t.memberExpression(node, t.identifier("bind")), [t.thisExpression()]));
		        } else {
		          path.arrowFunctionToShadowed();
		        }
		      }
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 69 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  function statementList(key, path) {
		    var paths = path.get(key);
	
		    for (var _iterator = paths, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref2;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref2 = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref2 = _i.value;
		      }
	
		      var _path = _ref2;
	
		      var func = _path.node;
		      if (!_path.isFunctionDeclaration()) continue;
	
		      var declar = t.variableDeclaration("let", [t.variableDeclarator(func.id, t.toExpression(func))]);
	
		      declar._blockHoist = 2;
	
		      func.id = null;
	
		      _path.replaceWith(declar);
		    }
		  }
	
		  return {
		    visitor: {
		      BlockStatement: function BlockStatement(path) {
		        var node = path.node,
		            parent = path.parent;
	
		        if (t.isFunction(parent, { body: node }) || t.isExportDeclaration(parent)) {
		          return;
		        }
	
		        statementList("body", path);
		      },
		      SwitchCase: function SwitchCase(path) {
		        statementList("consequent", path);
		      }
		    }
		  };
		};
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 70 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _symbol = __webpack_require__(10);
	
		var _symbol2 = _interopRequireDefault(_symbol);
	
		var _create = __webpack_require__(9);
	
		var _create2 = _interopRequireDefault(_create);
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		exports.default = function () {
		  return {
		    visitor: {
		      VariableDeclaration: function VariableDeclaration(path, file) {
		        var node = path.node,
		            parent = path.parent,
		            scope = path.scope;
	
		        if (!isBlockScoped(node)) return;
		        convertBlockScopedToVar(path, null, parent, scope, true);
	
		        if (node._tdzThis) {
		          var nodes = [node];
	
		          for (var i = 0; i < node.declarations.length; i++) {
		            var decl = node.declarations[i];
		            if (decl.init) {
		              var assign = t.assignmentExpression("=", decl.id, decl.init);
		              assign._ignoreBlockScopingTDZ = true;
		              nodes.push(t.expressionStatement(assign));
		            }
		            decl.init = file.addHelper("temporalUndefined");
		          }
	
		          node._blockHoist = 2;
	
		          if (path.isCompletionRecord()) {
		            nodes.push(t.expressionStatement(scope.buildUndefinedNode()));
		          }
	
		          path.replaceWithMultiple(nodes);
		        }
		      },
		      Loop: function Loop(path, file) {
		        var node = path.node,
		            parent = path.parent,
		            scope = path.scope;
	
		        t.ensureBlock(node);
		        var blockScoping = new BlockScoping(path, path.get("body"), parent, scope, file);
		        var replace = blockScoping.run();
		        if (replace) path.replaceWith(replace);
		      },
		      CatchClause: function CatchClause(path, file) {
		        var parent = path.parent,
		            scope = path.scope;
	
		        var blockScoping = new BlockScoping(null, path.get("body"), parent, scope, file);
		        blockScoping.run();
		      },
		      "BlockStatement|SwitchStatement|Program": function BlockStatementSwitchStatementProgram(path, file) {
		        if (!ignoreBlock(path)) {
		          var blockScoping = new BlockScoping(null, path, path.parent, path.scope, file);
		          blockScoping.run();
		        }
		      }
		    }
		  };
		};
	
		var _babelTraverse = __webpack_require__(7);
	
		var _babelTraverse2 = _interopRequireDefault(_babelTraverse);
	
		var _tdz = __webpack_require__(330);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		var _values = __webpack_require__(280);
	
		var _values2 = _interopRequireDefault(_values);
	
		var _extend = __webpack_require__(578);
	
		var _extend2 = _interopRequireDefault(_extend);
	
		var _babelTemplate = __webpack_require__(4);
	
		var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function ignoreBlock(path) {
		  return t.isLoop(path.parent) || t.isCatchClause(path.parent);
		}
	
		var buildRetCheck = (0, _babelTemplate2.default)("\n  if (typeof RETURN === \"object\") return RETURN.v;\n");
	
		function isBlockScoped(node) {
		  if (!t.isVariableDeclaration(node)) return false;
		  if (node[t.BLOCK_SCOPED_SYMBOL]) return true;
		  if (node.kind !== "let" && node.kind !== "const") return false;
		  return true;
		}
	
		function convertBlockScopedToVar(path, node, parent, scope) {
		  var moveBindingsToParent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
		  if (!node) {
		    node = path.node;
		  }
	
		  if (!t.isFor(parent)) {
		    for (var i = 0; i < node.declarations.length; i++) {
		      var declar = node.declarations[i];
		      declar.init = declar.init || scope.buildUndefinedNode();
		    }
		  }
	
		  node[t.BLOCK_SCOPED_SYMBOL] = true;
		  node.kind = "var";
	
		  if (moveBindingsToParent) {
		    var parentScope = scope.getFunctionParent();
		    var ids = path.getBindingIdentifiers();
		    for (var name in ids) {
		      var binding = scope.getOwnBinding(name);
		      if (binding) binding.kind = "var";
		      scope.moveBindingTo(name, parentScope);
		    }
		  }
		}
	
		function isVar(node) {
		  return t.isVariableDeclaration(node, { kind: "var" }) && !isBlockScoped(node);
		}
	
		var letReferenceBlockVisitor = _babelTraverse2.default.visitors.merge([{
		  Loop: {
		    enter: function enter(path, state) {
		      state.loopDepth++;
		    },
		    exit: function exit(path, state) {
		      state.loopDepth--;
		    }
		  },
		  Function: function Function(path, state) {
		    if (state.loopDepth > 0) {
		      path.traverse(letReferenceFunctionVisitor, state);
		    }
		    return path.skip();
		  }
		}, _tdz.visitor]);
	
		var letReferenceFunctionVisitor = _babelTraverse2.default.visitors.merge([{
		  ReferencedIdentifier: function ReferencedIdentifier(path, state) {
		    var ref = state.letReferences[path.node.name];
	
		    if (!ref) return;
	
		    var localBinding = path.scope.getBindingIdentifier(path.node.name);
		    if (localBinding && localBinding !== ref) return;
	
		    state.closurify = true;
		  }
		}, _tdz.visitor]);
	
		var hoistVarDeclarationsVisitor = {
		  enter: function enter(path, self) {
		    var node = path.node,
		        parent = path.parent;
	
		    if (path.isForStatement()) {
		      if (isVar(node.init, node)) {
		        var nodes = self.pushDeclar(node.init);
		        if (nodes.length === 1) {
		          node.init = nodes[0];
		        } else {
		          node.init = t.sequenceExpression(nodes);
		        }
		      }
		    } else if (path.isFor()) {
		      if (isVar(node.left, node)) {
		        self.pushDeclar(node.left);
		        node.left = node.left.declarations[0].id;
		      }
		    } else if (isVar(node, parent)) {
		      path.replaceWithMultiple(self.pushDeclar(node).map(function (expr) {
		        return t.expressionStatement(expr);
		      }));
		    } else if (path.isFunction()) {
		      return path.skip();
		    }
		  }
		};
	
		var loopLabelVisitor = {
		  LabeledStatement: function LabeledStatement(_ref, state) {
		    var node = _ref.node;
	
		    state.innerLabels.push(node.label.name);
		  }
		};
	
		var continuationVisitor = {
		  enter: function enter(path, state) {
		    if (path.isAssignmentExpression() || path.isUpdateExpression()) {
		      var bindings = path.getBindingIdentifiers();
		      for (var name in bindings) {
		        if (state.outsideReferences[name] !== path.scope.getBindingIdentifier(name)) continue;
		        state.reassignments[name] = true;
		      }
		    }
		  }
		};
	
		function loopNodeTo(node) {
		  if (t.isBreakStatement(node)) {
		    return "break";
		  } else if (t.isContinueStatement(node)) {
		    return "continue";
		  }
		}
	
		var loopVisitor = {
		  Loop: function Loop(path, state) {
		    var oldIgnoreLabeless = state.ignoreLabeless;
		    state.ignoreLabeless = true;
		    path.traverse(loopVisitor, state);
		    state.ignoreLabeless = oldIgnoreLabeless;
		    path.skip();
		  },
		  Function: function Function(path) {
		    path.skip();
		  },
		  SwitchCase: function SwitchCase(path, state) {
		    var oldInSwitchCase = state.inSwitchCase;
		    state.inSwitchCase = true;
		    path.traverse(loopVisitor, state);
		    state.inSwitchCase = oldInSwitchCase;
		    path.skip();
		  },
		  "BreakStatement|ContinueStatement|ReturnStatement": function BreakStatementContinueStatementReturnStatement(path, state) {
		    var node = path.node,
		        parent = path.parent,
		        scope = path.scope;
	
		    if (node[this.LOOP_IGNORE]) return;
	
		    var replace = void 0;
		    var loopText = loopNodeTo(node);
	
		    if (loopText) {
		      if (node.label) {
		        if (state.innerLabels.indexOf(node.label.name) >= 0) {
		          return;
		        }
	
		        loopText = loopText + "|" + node.label.name;
		      } else {
		        if (state.ignoreLabeless) return;
	
		        if (state.inSwitchCase) return;
	
		        if (t.isBreakStatement(node) && t.isSwitchCase(parent)) return;
		      }
	
		      state.hasBreakContinue = true;
		      state.map[loopText] = node;
		      replace = t.stringLiteral(loopText);
		    }
	
		    if (path.isReturnStatement()) {
		      state.hasReturn = true;
		      replace = t.objectExpression([t.objectProperty(t.identifier("v"), node.argument || scope.buildUndefinedNode())]);
		    }
	
		    if (replace) {
		      replace = t.returnStatement(replace);
		      replace[this.LOOP_IGNORE] = true;
		      path.skip();
		      path.replaceWith(t.inherits(replace, node));
		    }
		  }
		};
	
		var BlockScoping = function () {
		  function BlockScoping(loopPath, blockPath, parent, scope, file) {
		    (0, _classCallCheck3.default)(this, BlockScoping);
	
		    this.parent = parent;
		    this.scope = scope;
		    this.file = file;
	
		    this.blockPath = blockPath;
		    this.block = blockPath.node;
	
		    this.outsideLetReferences = (0, _create2.default)(null);
		    this.hasLetReferences = false;
		    this.letReferences = (0, _create2.default)(null);
		    this.body = [];
	
		    if (loopPath) {
		      this.loopParent = loopPath.parent;
		      this.loopLabel = t.isLabeledStatement(this.loopParent) && this.loopParent.label;
		      this.loopPath = loopPath;
		      this.loop = loopPath.node;
		    }
		  }
	
		  BlockScoping.prototype.run = function run() {
		    var block = this.block;
		    if (block._letDone) return;
		    block._letDone = true;
	
		    var needsClosure = this.getLetReferences();
	
		    if (t.isFunction(this.parent) || t.isProgram(this.block)) {
		      this.updateScopeInfo();
		      return;
		    }
	
		    if (!this.hasLetReferences) return;
	
		    if (needsClosure) {
		      this.wrapClosure();
		    } else {
		      this.remap();
		    }
	
		    this.updateScopeInfo(needsClosure);
	
		    if (this.loopLabel && !t.isLabeledStatement(this.loopParent)) {
		      return t.labeledStatement(this.loopLabel, this.loop);
		    }
		  };
	
		  BlockScoping.prototype.updateScopeInfo = function updateScopeInfo(wrappedInClosure) {
		    var scope = this.scope;
		    var parentScope = scope.getFunctionParent();
		    var letRefs = this.letReferences;
	
		    for (var key in letRefs) {
		      var ref = letRefs[key];
		      var binding = scope.getBinding(ref.name);
		      if (!binding) continue;
		      if (binding.kind === "let" || binding.kind === "const") {
		        binding.kind = "var";
	
		        if (wrappedInClosure) {
		          scope.removeBinding(ref.name);
		        } else {
		          scope.moveBindingTo(ref.name, parentScope);
		        }
		      }
		    }
		  };
	
		  BlockScoping.prototype.remap = function remap() {
		    var letRefs = this.letReferences;
		    var scope = this.scope;
	
		    for (var key in letRefs) {
		      var ref = letRefs[key];
	
		      if (scope.parentHasBinding(key) || scope.hasGlobal(key)) {
		        if (scope.hasOwnBinding(key)) scope.rename(ref.name);
	
		        if (this.blockPath.scope.hasOwnBinding(key)) this.blockPath.scope.rename(ref.name);
		      }
		    }
		  };
	
		  BlockScoping.prototype.wrapClosure = function wrapClosure() {
		    if (this.file.opts.throwIfClosureRequired) {
		      throw this.blockPath.buildCodeFrameError("Compiling let/const in this block would add a closure " + "(throwIfClosureRequired).");
		    }
		    var block = this.block;
	
		    var outsideRefs = this.outsideLetReferences;
	
		    if (this.loop) {
		      for (var name in outsideRefs) {
		        var id = outsideRefs[name];
	
		        if (this.scope.hasGlobal(id.name) || this.scope.parentHasBinding(id.name)) {
		          delete outsideRefs[id.name];
		          delete this.letReferences[id.name];
	
		          this.scope.rename(id.name);
	
		          this.letReferences[id.name] = id;
		          outsideRefs[id.name] = id;
		        }
		      }
		    }
	
		    this.has = this.checkLoop();
	
		    this.hoistVarDeclarations();
	
		    var params = (0, _values2.default)(outsideRefs);
		    var args = (0, _values2.default)(outsideRefs);
	
		    var isSwitch = this.blockPath.isSwitchStatement();
	
		    var fn = t.functionExpression(null, params, t.blockStatement(isSwitch ? [block] : block.body));
		    fn.shadow = true;
	
		    this.addContinuations(fn);
	
		    var ref = fn;
	
		    if (this.loop) {
		      ref = this.scope.generateUidIdentifier("loop");
		      this.loopPath.insertBefore(t.variableDeclaration("var", [t.variableDeclarator(ref, fn)]));
		    }
	
		    var call = t.callExpression(ref, args);
		    var ret = this.scope.generateUidIdentifier("ret");
	
		    var hasYield = _babelTraverse2.default.hasType(fn.body, this.scope, "YieldExpression", t.FUNCTION_TYPES);
		    if (hasYield) {
		      fn.generator = true;
		      call = t.yieldExpression(call, true);
		    }
	
		    var hasAsync = _babelTraverse2.default.hasType(fn.body, this.scope, "AwaitExpression", t.FUNCTION_TYPES);
		    if (hasAsync) {
		      fn.async = true;
		      call = t.awaitExpression(call);
		    }
	
		    this.buildClosure(ret, call);
	
		    if (isSwitch) this.blockPath.replaceWithMultiple(this.body);else block.body = this.body;
		  };
	
		  BlockScoping.prototype.buildClosure = function buildClosure(ret, call) {
		    var has = this.has;
		    if (has.hasReturn || has.hasBreakContinue) {
		      this.buildHas(ret, call);
		    } else {
		      this.body.push(t.expressionStatement(call));
		    }
		  };
	
		  BlockScoping.prototype.addContinuations = function addContinuations(fn) {
		    var state = {
		      reassignments: {},
		      outsideReferences: this.outsideLetReferences
		    };
	
		    this.scope.traverse(fn, continuationVisitor, state);
	
		    for (var i = 0; i < fn.params.length; i++) {
		      var param = fn.params[i];
		      if (!state.reassignments[param.name]) continue;
	
		      var newParam = this.scope.generateUidIdentifier(param.name);
		      fn.params[i] = newParam;
	
		      this.scope.rename(param.name, newParam.name, fn);
	
		      fn.body.body.push(t.expressionStatement(t.assignmentExpression("=", param, newParam)));
		    }
		  };
	
		  BlockScoping.prototype.getLetReferences = function getLetReferences() {
		    var _this = this;
	
		    var block = this.block;
	
		    var declarators = [];
	
		    if (this.loop) {
		      var init = this.loop.left || this.loop.init;
		      if (isBlockScoped(init)) {
		        declarators.push(init);
		        (0, _extend2.default)(this.outsideLetReferences, t.getBindingIdentifiers(init));
		      }
		    }
	
		    var addDeclarationsFromChild = function addDeclarationsFromChild(path, node) {
		      node = node || path.node;
		      if (t.isClassDeclaration(node) || t.isFunctionDeclaration(node) || isBlockScoped(node)) {
		        if (isBlockScoped(node)) {
		          convertBlockScopedToVar(path, node, block, _this.scope);
		        }
		        declarators = declarators.concat(node.declarations || node);
		      }
		      if (t.isLabeledStatement(node)) {
		        addDeclarationsFromChild(path.get("body"), node.body);
		      }
		    };
	
		    if (block.body) {
		      for (var i = 0; i < block.body.length; i++) {
		        var declarPath = this.blockPath.get("body")[i];
		        addDeclarationsFromChild(declarPath);
		      }
		    }
	
		    if (block.cases) {
		      for (var _i = 0; _i < block.cases.length; _i++) {
		        var consequents = block.cases[_i].consequent;
	
		        for (var j = 0; j < consequents.length; j++) {
		          var _declarPath = this.blockPath.get("cases")[_i];
		          var declar = consequents[j];
		          addDeclarationsFromChild(_declarPath, declar);
		        }
		      }
		    }
	
		    for (var _i2 = 0; _i2 < declarators.length; _i2++) {
		      var _declar = declarators[_i2];
	
		      var keys = t.getBindingIdentifiers(_declar, false, true);
		      (0, _extend2.default)(this.letReferences, keys);
		      this.hasLetReferences = true;
		    }
	
		    if (!this.hasLetReferences) return;
	
		    var state = {
		      letReferences: this.letReferences,
		      closurify: false,
		      file: this.file,
		      loopDepth: 0
		    };
	
		    var loopOrFunctionParent = this.blockPath.find(function (path) {
		      return path.isLoop() || path.isFunction();
		    });
		    if (loopOrFunctionParent && loopOrFunctionParent.isLoop()) {
		      state.loopDepth++;
		    }
	
		    this.blockPath.traverse(letReferenceBlockVisitor, state);
	
		    return state.closurify;
		  };
	
		  BlockScoping.prototype.checkLoop = function checkLoop() {
		    var state = {
		      hasBreakContinue: false,
		      ignoreLabeless: false,
		      inSwitchCase: false,
		      innerLabels: [],
		      hasReturn: false,
		      isLoop: !!this.loop,
		      map: {},
		      LOOP_IGNORE: (0, _symbol2.default)()
		    };
	
		    this.blockPath.traverse(loopLabelVisitor, state);
		    this.blockPath.traverse(loopVisitor, state);
	
		    return state;
		  };
	
		  BlockScoping.prototype.hoistVarDeclarations = function hoistVarDeclarations() {
		    this.blockPath.traverse(hoistVarDeclarationsVisitor, this);
		  };
	
		  BlockScoping.prototype.pushDeclar = function pushDeclar(node) {
		    var declars = [];
		    var names = t.getBindingIdentifiers(node);
		    for (var name in names) {
		      declars.push(t.variableDeclarator(names[name]));
		    }
	
		    this.body.push(t.variableDeclaration(node.kind, declars));
	
		    var replace = [];
	
		    for (var i = 0; i < node.declarations.length; i++) {
		      var declar = node.declarations[i];
		      if (!declar.init) continue;
	
		      var expr = t.assignmentExpression("=", declar.id, declar.init);
		      replace.push(t.inherits(expr, declar));
		    }
	
		    return replace;
		  };
	
		  BlockScoping.prototype.buildHas = function buildHas(ret, call) {
		    var body = this.body;
	
		    body.push(t.variableDeclaration("var", [t.variableDeclarator(ret, call)]));
	
		    var retCheck = void 0;
		    var has = this.has;
		    var cases = [];
	
		    if (has.hasReturn) {
		      retCheck = buildRetCheck({
		        RETURN: ret
		      });
		    }
	
		    if (has.hasBreakContinue) {
		      for (var key in has.map) {
		        cases.push(t.switchCase(t.stringLiteral(key), [has.map[key]]));
		      }
	
		      if (has.hasReturn) {
		        cases.push(t.switchCase(null, [retCheck]));
		      }
	
		      if (cases.length === 1) {
		        var single = cases[0];
		        body.push(t.ifStatement(t.binaryExpression("===", ret, single.test), single.consequent[0]));
		      } else {
		        if (this.loop) {
		          for (var i = 0; i < cases.length; i++) {
		            var caseConsequent = cases[i].consequent[0];
		            if (t.isBreakStatement(caseConsequent) && !caseConsequent.label) {
		              caseConsequent.label = this.loopLabel = this.loopLabel || this.scope.generateUidIdentifier("loop");
		            }
		          }
		        }
	
		        body.push(t.switchStatement(ret, cases));
		      }
		    } else {
		      if (has.hasReturn) {
		        body.push(retCheck);
		      }
		    }
		  };
	
		  return BlockScoping;
		}();
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 71 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _symbol = __webpack_require__(10);
	
		var _symbol2 = _interopRequireDefault(_symbol);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  var VISITED = (0, _symbol2.default)();
	
		  return {
		    visitor: {
		      ExportDefaultDeclaration: function ExportDefaultDeclaration(path) {
		        if (!path.get("declaration").isClassDeclaration()) return;
	
		        var node = path.node;
	
		        var ref = node.declaration.id || path.scope.generateUidIdentifier("class");
		        node.declaration.id = ref;
	
		        path.replaceWith(node.declaration);
		        path.insertAfter(t.exportDefaultDeclaration(ref));
		      },
		      ClassDeclaration: function ClassDeclaration(path) {
		        var node = path.node;
	
		        var ref = node.id || path.scope.generateUidIdentifier("class");
	
		        path.replaceWith(t.variableDeclaration("let", [t.variableDeclarator(ref, t.toExpression(node))]));
		      },
		      ClassExpression: function ClassExpression(path, state) {
		        var node = path.node;
	
		        if (node[VISITED]) return;
	
		        var inferred = (0, _babelHelperFunctionName2.default)(path);
		        if (inferred && inferred !== node) return path.replaceWith(inferred);
	
		        node[VISITED] = true;
	
		        var Constructor = _vanilla2.default;
		        if (state.opts.loose) Constructor = _loose2.default;
	
		        path.replaceWith(new Constructor(path, state.file).run());
		      }
		    }
		  };
		};
	
		var _loose = __webpack_require__(331);
	
		var _loose2 = _interopRequireDefault(_loose);
	
		var _vanilla = __webpack_require__(207);
	
		var _vanilla2 = _interopRequireDefault(_vanilla);
	
		var _babelHelperFunctionName = __webpack_require__(40);
	
		var _babelHelperFunctionName2 = _interopRequireDefault(_babelHelperFunctionName);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 72 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (_ref) {
		  var t = _ref.types,
		      template = _ref.template;
	
		  var buildMutatorMapAssign = template("\n    MUTATOR_MAP_REF[KEY] = MUTATOR_MAP_REF[KEY] || {};\n    MUTATOR_MAP_REF[KEY].KIND = VALUE;\n  ");
	
		  function getValue(prop) {
		    if (t.isObjectProperty(prop)) {
		      return prop.value;
		    } else if (t.isObjectMethod(prop)) {
		      return t.functionExpression(null, prop.params, prop.body, prop.generator, prop.async);
		    }
		  }
	
		  function pushAssign(objId, prop, body) {
		    if (prop.kind === "get" && prop.kind === "set") {
		      pushMutatorDefine(objId, prop, body);
		    } else {
		      body.push(t.expressionStatement(t.assignmentExpression("=", t.memberExpression(objId, prop.key, prop.computed || t.isLiteral(prop.key)), getValue(prop))));
		    }
		  }
	
		  function pushMutatorDefine(_ref2, prop) {
		    var objId = _ref2.objId,
		        body = _ref2.body,
		        getMutatorId = _ref2.getMutatorId,
		        scope = _ref2.scope;
	
		    var key = !prop.computed && t.isIdentifier(prop.key) ? t.stringLiteral(prop.key.name) : prop.key;
	
		    var maybeMemoise = scope.maybeGenerateMemoised(key);
		    if (maybeMemoise) {
		      body.push(t.expressionStatement(t.assignmentExpression("=", maybeMemoise, key)));
		      key = maybeMemoise;
		    }
	
		    body.push.apply(body, buildMutatorMapAssign({
		      MUTATOR_MAP_REF: getMutatorId(),
		      KEY: key,
		      VALUE: getValue(prop),
		      KIND: t.identifier(prop.kind)
		    }));
		  }
	
		  function loose(info) {
		    for (var _iterator = info.computedProps, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref3;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref3 = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref3 = _i.value;
		      }
	
		      var prop = _ref3;
	
		      if (prop.kind === "get" || prop.kind === "set") {
		        pushMutatorDefine(info, prop);
		      } else {
		        pushAssign(info.objId, prop, info.body);
		      }
		    }
		  }
	
		  function spec(info) {
		    var objId = info.objId,
		        body = info.body,
		        computedProps = info.computedProps,
		        state = info.state;
	
		    for (var _iterator2 = computedProps, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		      var _ref4;
	
		      if (_isArray2) {
		        if (_i2 >= _iterator2.length) break;
		        _ref4 = _iterator2[_i2++];
		      } else {
		        _i2 = _iterator2.next();
		        if (_i2.done) break;
		        _ref4 = _i2.value;
		      }
	
		      var prop = _ref4;
	
		      var key = t.toComputedKey(prop);
	
		      if (prop.kind === "get" || prop.kind === "set") {
		        pushMutatorDefine(info, prop);
		      } else if (t.isStringLiteral(key, { value: "__proto__" })) {
		        pushAssign(objId, prop, body);
		      } else {
		        if (computedProps.length === 1) {
		          return t.callExpression(state.addHelper("defineProperty"), [info.initPropExpression, key, getValue(prop)]);
		        } else {
		          body.push(t.expressionStatement(t.callExpression(state.addHelper("defineProperty"), [objId, key, getValue(prop)])));
		        }
		      }
		    }
		  }
	
		  return {
		    visitor: {
		      ObjectExpression: {
		        exit: function exit(path, state) {
		          var node = path.node,
		              parent = path.parent,
		              scope = path.scope;
	
		          var hasComputed = false;
		          for (var _iterator3 = node.properties, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		            var _ref5;
	
		            if (_isArray3) {
		              if (_i3 >= _iterator3.length) break;
		              _ref5 = _iterator3[_i3++];
		            } else {
		              _i3 = _iterator3.next();
		              if (_i3.done) break;
		              _ref5 = _i3.value;
		            }
	
		            var prop = _ref5;
	
		            hasComputed = prop.computed === true;
		            if (hasComputed) break;
		          }
		          if (!hasComputed) return;
	
		          var initProps = [];
		          var computedProps = [];
		          var foundComputed = false;
	
		          for (var _iterator4 = node.properties, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
		            var _ref6;
	
		            if (_isArray4) {
		              if (_i4 >= _iterator4.length) break;
		              _ref6 = _iterator4[_i4++];
		            } else {
		              _i4 = _iterator4.next();
		              if (_i4.done) break;
		              _ref6 = _i4.value;
		            }
	
		            var _prop = _ref6;
	
		            if (_prop.computed) {
		              foundComputed = true;
		            }
	
		            if (foundComputed) {
		              computedProps.push(_prop);
		            } else {
		              initProps.push(_prop);
		            }
		          }
	
		          var objId = scope.generateUidIdentifierBasedOnNode(parent);
		          var initPropExpression = t.objectExpression(initProps);
		          var body = [];
	
		          body.push(t.variableDeclaration("var", [t.variableDeclarator(objId, initPropExpression)]));
	
		          var callback = spec;
		          if (state.opts.loose) callback = loose;
	
		          var mutatorRef = void 0;
	
		          var getMutatorId = function getMutatorId() {
		            if (!mutatorRef) {
		              mutatorRef = scope.generateUidIdentifier("mutatorMap");
	
		              body.push(t.variableDeclaration("var", [t.variableDeclarator(mutatorRef, t.objectExpression([]))]));
		            }
	
		            return mutatorRef;
		          };
	
		          var single = callback({
		            scope: scope,
		            objId: objId,
		            body: body,
		            computedProps: computedProps,
		            initPropExpression: initPropExpression,
		            getMutatorId: getMutatorId,
		            state: state
		          });
	
		          if (mutatorRef) {
		            body.push(t.expressionStatement(t.callExpression(state.addHelper("defineEnumerableProperties"), [objId, mutatorRef])));
		          }
	
		          if (single) {
		            path.replaceWith(single);
		          } else {
		            body.push(t.expressionStatement(objId));
		            path.replaceWithMultiple(body);
		          }
		        }
		      }
		    }
		  };
		};
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 73 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  function variableDeclarationHasPattern(node) {
		    for (var _iterator = node.declarations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref2;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref2 = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref2 = _i.value;
		      }
	
		      var declar = _ref2;
	
		      if (t.isPattern(declar.id)) {
		        return true;
		      }
		    }
		    return false;
		  }
	
		  function hasRest(pattern) {
		    for (var _iterator2 = pattern.elements, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		      var _ref3;
	
		      if (_isArray2) {
		        if (_i2 >= _iterator2.length) break;
		        _ref3 = _iterator2[_i2++];
		      } else {
		        _i2 = _iterator2.next();
		        if (_i2.done) break;
		        _ref3 = _i2.value;
		      }
	
		      var elem = _ref3;
	
		      if (t.isRestElement(elem)) {
		        return true;
		      }
		    }
		    return false;
		  }
	
		  var arrayUnpackVisitor = {
		    ReferencedIdentifier: function ReferencedIdentifier(path, state) {
		      if (state.bindings[path.node.name]) {
		        state.deopt = true;
		        path.stop();
		      }
		    }
		  };
	
		  var DestructuringTransformer = function () {
		    function DestructuringTransformer(opts) {
		      (0, _classCallCheck3.default)(this, DestructuringTransformer);
	
		      this.blockHoist = opts.blockHoist;
		      this.operator = opts.operator;
		      this.arrays = {};
		      this.nodes = opts.nodes || [];
		      this.scope = opts.scope;
		      this.file = opts.file;
		      this.kind = opts.kind;
		    }
	
		    DestructuringTransformer.prototype.buildVariableAssignment = function buildVariableAssignment(id, init) {
		      var op = this.operator;
		      if (t.isMemberExpression(id)) op = "=";
	
		      var node = void 0;
	
		      if (op) {
		        node = t.expressionStatement(t.assignmentExpression(op, id, init));
		      } else {
		        node = t.variableDeclaration(this.kind, [t.variableDeclarator(id, init)]);
		      }
	
		      node._blockHoist = this.blockHoist;
	
		      return node;
		    };
	
		    DestructuringTransformer.prototype.buildVariableDeclaration = function buildVariableDeclaration(id, init) {
		      var declar = t.variableDeclaration("var", [t.variableDeclarator(id, init)]);
		      declar._blockHoist = this.blockHoist;
		      return declar;
		    };
	
		    DestructuringTransformer.prototype.push = function push(id, init) {
		      if (t.isObjectPattern(id)) {
		        this.pushObjectPattern(id, init);
		      } else if (t.isArrayPattern(id)) {
		        this.pushArrayPattern(id, init);
		      } else if (t.isAssignmentPattern(id)) {
		        this.pushAssignmentPattern(id, init);
		      } else {
		        this.nodes.push(this.buildVariableAssignment(id, init));
		      }
		    };
	
		    DestructuringTransformer.prototype.toArray = function toArray(node, count) {
		      if (this.file.opts.loose || t.isIdentifier(node) && this.arrays[node.name]) {
		        return node;
		      } else {
		        return this.scope.toArray(node, count);
		      }
		    };
	
		    DestructuringTransformer.prototype.pushAssignmentPattern = function pushAssignmentPattern(pattern, valueRef) {
	
		      var tempValueRef = this.scope.generateUidIdentifierBasedOnNode(valueRef);
	
		      var declar = t.variableDeclaration("var", [t.variableDeclarator(tempValueRef, valueRef)]);
		      declar._blockHoist = this.blockHoist;
		      this.nodes.push(declar);
	
		      var tempConditional = t.conditionalExpression(t.binaryExpression("===", tempValueRef, t.identifier("undefined")), pattern.right, tempValueRef);
	
		      var left = pattern.left;
		      if (t.isPattern(left)) {
		        var tempValueDefault = t.expressionStatement(t.assignmentExpression("=", tempValueRef, tempConditional));
		        tempValueDefault._blockHoist = this.blockHoist;
	
		        this.nodes.push(tempValueDefault);
		        this.push(left, tempValueRef);
		      } else {
		        this.nodes.push(this.buildVariableAssignment(left, tempConditional));
		      }
		    };
	
		    DestructuringTransformer.prototype.pushObjectRest = function pushObjectRest(pattern, objRef, spreadProp, spreadPropIndex) {
	
		      var keys = [];
	
		      for (var i = 0; i < pattern.properties.length; i++) {
		        var prop = pattern.properties[i];
	
		        if (i >= spreadPropIndex) break;
	
		        if (t.isRestProperty(prop)) continue;
	
		        var key = prop.key;
		        if (t.isIdentifier(key) && !prop.computed) key = t.stringLiteral(prop.key.name);
		        keys.push(key);
		      }
	
		      keys = t.arrayExpression(keys);
	
		      var value = t.callExpression(this.file.addHelper("objectWithoutProperties"), [objRef, keys]);
		      this.nodes.push(this.buildVariableAssignment(spreadProp.argument, value));
		    };
	
		    DestructuringTransformer.prototype.pushObjectProperty = function pushObjectProperty(prop, propRef) {
		      if (t.isLiteral(prop.key)) prop.computed = true;
	
		      var pattern = prop.value;
		      var objRef = t.memberExpression(propRef, prop.key, prop.computed);
	
		      if (t.isPattern(pattern)) {
		        this.push(pattern, objRef);
		      } else {
		        this.nodes.push(this.buildVariableAssignment(pattern, objRef));
		      }
		    };
	
		    DestructuringTransformer.prototype.pushObjectPattern = function pushObjectPattern(pattern, objRef) {
	
		      if (!pattern.properties.length) {
		        this.nodes.push(t.expressionStatement(t.callExpression(this.file.addHelper("objectDestructuringEmpty"), [objRef])));
		      }
	
		      if (pattern.properties.length > 1 && !this.scope.isStatic(objRef)) {
		        var temp = this.scope.generateUidIdentifierBasedOnNode(objRef);
		        this.nodes.push(this.buildVariableDeclaration(temp, objRef));
		        objRef = temp;
		      }
	
		      for (var i = 0; i < pattern.properties.length; i++) {
		        var prop = pattern.properties[i];
		        if (t.isRestProperty(prop)) {
		          this.pushObjectRest(pattern, objRef, prop, i);
		        } else {
		          this.pushObjectProperty(prop, objRef);
		        }
		      }
		    };
	
		    DestructuringTransformer.prototype.canUnpackArrayPattern = function canUnpackArrayPattern(pattern, arr) {
		      if (!t.isArrayExpression(arr)) return false;
	
		      if (pattern.elements.length > arr.elements.length) return;
		      if (pattern.elements.length < arr.elements.length && !hasRest(pattern)) return false;
	
		      for (var _iterator3 = pattern.elements, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		        var _ref4;
	
		        if (_isArray3) {
		          if (_i3 >= _iterator3.length) break;
		          _ref4 = _iterator3[_i3++];
		        } else {
		          _i3 = _iterator3.next();
		          if (_i3.done) break;
		          _ref4 = _i3.value;
		        }
	
		        var elem = _ref4;
	
		        if (!elem) return false;
	
		        if (t.isMemberExpression(elem)) return false;
		      }
	
		      for (var _iterator4 = arr.elements, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
		        var _ref5;
	
		        if (_isArray4) {
		          if (_i4 >= _iterator4.length) break;
		          _ref5 = _iterator4[_i4++];
		        } else {
		          _i4 = _iterator4.next();
		          if (_i4.done) break;
		          _ref5 = _i4.value;
		        }
	
		        var _elem = _ref5;
	
		        if (t.isSpreadElement(_elem)) return false;
	
		        if (t.isCallExpression(_elem)) return false;
	
		        if (t.isMemberExpression(_elem)) return false;
		      }
	
		      var bindings = t.getBindingIdentifiers(pattern);
		      var state = { deopt: false, bindings: bindings };
		      this.scope.traverse(arr, arrayUnpackVisitor, state);
		      return !state.deopt;
		    };
	
		    DestructuringTransformer.prototype.pushUnpackedArrayPattern = function pushUnpackedArrayPattern(pattern, arr) {
		      for (var i = 0; i < pattern.elements.length; i++) {
		        var elem = pattern.elements[i];
		        if (t.isRestElement(elem)) {
		          this.push(elem.argument, t.arrayExpression(arr.elements.slice(i)));
		        } else {
		          this.push(elem, arr.elements[i]);
		        }
		      }
		    };
	
		    DestructuringTransformer.prototype.pushArrayPattern = function pushArrayPattern(pattern, arrayRef) {
		      if (!pattern.elements) return;
	
		      if (this.canUnpackArrayPattern(pattern, arrayRef)) {
		        return this.pushUnpackedArrayPattern(pattern, arrayRef);
		      }
	
		      var count = !hasRest(pattern) && pattern.elements.length;
	
		      var toArray = this.toArray(arrayRef, count);
	
		      if (t.isIdentifier(toArray)) {
		        arrayRef = toArray;
		      } else {
		        arrayRef = this.scope.generateUidIdentifierBasedOnNode(arrayRef);
		        this.arrays[arrayRef.name] = true;
		        this.nodes.push(this.buildVariableDeclaration(arrayRef, toArray));
		      }
	
		      for (var i = 0; i < pattern.elements.length; i++) {
		        var elem = pattern.elements[i];
	
		        if (!elem) continue;
	
		        var elemRef = void 0;
	
		        if (t.isRestElement(elem)) {
		          elemRef = this.toArray(arrayRef);
		          elemRef = t.callExpression(t.memberExpression(elemRef, t.identifier("slice")), [t.numericLiteral(i)]);
	
		          elem = elem.argument;
		        } else {
		          elemRef = t.memberExpression(arrayRef, t.numericLiteral(i), true);
		        }
	
		        this.push(elem, elemRef);
		      }
		    };
	
		    DestructuringTransformer.prototype.init = function init(pattern, ref) {
	
		      if (!t.isArrayExpression(ref) && !t.isMemberExpression(ref)) {
		        var memo = this.scope.maybeGenerateMemoised(ref, true);
		        if (memo) {
		          this.nodes.push(this.buildVariableDeclaration(memo, ref));
		          ref = memo;
		        }
		      }
	
		      this.push(pattern, ref);
	
		      return this.nodes;
		    };
	
		    return DestructuringTransformer;
		  }();
	
		  return {
		    visitor: {
		      ExportNamedDeclaration: function ExportNamedDeclaration(path) {
		        var declaration = path.get("declaration");
		        if (!declaration.isVariableDeclaration()) return;
		        if (!variableDeclarationHasPattern(declaration.node)) return;
	
		        var specifiers = [];
	
		        for (var name in path.getOuterBindingIdentifiers(path)) {
		          var id = t.identifier(name);
		          specifiers.push(t.exportSpecifier(id, id));
		        }
	
		        path.replaceWith(declaration.node);
		        path.insertAfter(t.exportNamedDeclaration(null, specifiers));
		      },
		      ForXStatement: function ForXStatement(path, file) {
		        var node = path.node,
		            scope = path.scope;
	
		        var left = node.left;
	
		        if (t.isPattern(left)) {
	
		          var temp = scope.generateUidIdentifier("ref");
	
		          node.left = t.variableDeclaration("var", [t.variableDeclarator(temp)]);
	
		          path.ensureBlock();
	
		          node.body.body.unshift(t.variableDeclaration("var", [t.variableDeclarator(left, temp)]));
	
		          return;
		        }
	
		        if (!t.isVariableDeclaration(left)) return;
	
		        var pattern = left.declarations[0].id;
		        if (!t.isPattern(pattern)) return;
	
		        var key = scope.generateUidIdentifier("ref");
		        node.left = t.variableDeclaration(left.kind, [t.variableDeclarator(key, null)]);
	
		        var nodes = [];
	
		        var destructuring = new DestructuringTransformer({
		          kind: left.kind,
		          file: file,
		          scope: scope,
		          nodes: nodes
		        });
	
		        destructuring.init(pattern, key);
	
		        path.ensureBlock();
	
		        var block = node.body;
		        block.body = nodes.concat(block.body);
		      },
		      CatchClause: function CatchClause(_ref6, file) {
		        var node = _ref6.node,
		            scope = _ref6.scope;
	
		        var pattern = node.param;
		        if (!t.isPattern(pattern)) return;
	
		        var ref = scope.generateUidIdentifier("ref");
		        node.param = ref;
	
		        var nodes = [];
	
		        var destructuring = new DestructuringTransformer({
		          kind: "let",
		          file: file,
		          scope: scope,
		          nodes: nodes
		        });
		        destructuring.init(pattern, ref);
	
		        node.body.body = nodes.concat(node.body.body);
		      },
		      AssignmentExpression: function AssignmentExpression(path, file) {
		        var node = path.node,
		            scope = path.scope;
	
		        if (!t.isPattern(node.left)) return;
	
		        var nodes = [];
	
		        var destructuring = new DestructuringTransformer({
		          operator: node.operator,
		          file: file,
		          scope: scope,
		          nodes: nodes
		        });
	
		        var ref = void 0;
		        if (path.isCompletionRecord() || !path.parentPath.isExpressionStatement()) {
		          ref = scope.generateUidIdentifierBasedOnNode(node.right, "ref");
	
		          nodes.push(t.variableDeclaration("var", [t.variableDeclarator(ref, node.right)]));
	
		          if (t.isArrayExpression(node.right)) {
		            destructuring.arrays[ref.name] = true;
		          }
		        }
	
		        destructuring.init(node.left, ref || node.right);
	
		        if (ref) {
		          nodes.push(t.expressionStatement(ref));
		        }
	
		        path.replaceWithMultiple(nodes);
		      },
		      VariableDeclaration: function VariableDeclaration(path, file) {
		        var node = path.node,
		            scope = path.scope,
		            parent = path.parent;
	
		        if (t.isForXStatement(parent)) return;
		        if (!parent || !path.container) return;
		        if (!variableDeclarationHasPattern(node)) return;
	
		        var nodes = [];
		        var declar = void 0;
	
		        for (var i = 0; i < node.declarations.length; i++) {
		          declar = node.declarations[i];
	
		          var patternId = declar.init;
		          var pattern = declar.id;
	
		          var destructuring = new DestructuringTransformer({
		            blockHoist: node._blockHoist,
		            nodes: nodes,
		            scope: scope,
		            kind: node.kind,
		            file: file
		          });
	
		          if (t.isPattern(pattern)) {
		            destructuring.init(pattern, patternId);
	
		            if (+i !== node.declarations.length - 1) {
		              t.inherits(nodes[nodes.length - 1], declar);
		            }
		          } else {
		            nodes.push(t.inherits(destructuring.buildVariableAssignment(declar.id, declar.init), declar));
		          }
		        }
	
		        var nodesOut = [];
		        for (var _iterator5 = nodes, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : (0, _getIterator3.default)(_iterator5);;) {
		          var _ref7;
	
		          if (_isArray5) {
		            if (_i5 >= _iterator5.length) break;
		            _ref7 = _iterator5[_i5++];
		          } else {
		            _i5 = _iterator5.next();
		            if (_i5.done) break;
		            _ref7 = _i5.value;
		          }
	
		          var _node = _ref7;
	
		          var tail = nodesOut[nodesOut.length - 1];
		          if (tail && t.isVariableDeclaration(tail) && t.isVariableDeclaration(_node) && tail.kind === _node.kind) {
		            var _tail$declarations;
	
		            (_tail$declarations = tail.declarations).push.apply(_tail$declarations, _node.declarations);
		          } else {
		            nodesOut.push(_node);
		          }
		        }
	
		        for (var _iterator6 = nodesOut, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : (0, _getIterator3.default)(_iterator6);;) {
		          var _ref8;
	
		          if (_isArray6) {
		            if (_i6 >= _iterator6.length) break;
		            _ref8 = _iterator6[_i6++];
		          } else {
		            _i6 = _iterator6.next();
		            if (_i6.done) break;
		            _ref8 = _i6.value;
		          }
	
		          var nodeOut = _ref8;
	
		          if (!nodeOut.declarations) continue;
		          for (var _iterator7 = nodeOut.declarations, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : (0, _getIterator3.default)(_iterator7);;) {
		            var _ref9;
	
		            if (_isArray7) {
		              if (_i7 >= _iterator7.length) break;
		              _ref9 = _iterator7[_i7++];
		            } else {
		              _i7 = _iterator7.next();
		              if (_i7.done) break;
		              _ref9 = _i7.value;
		            }
	
		            var declaration = _ref9;
		            var name = declaration.id.name;
	
		            if (scope.bindings[name]) {
		              scope.bindings[name].kind = nodeOut.kind;
		            }
		          }
		        }
	
		        if (nodesOut.length === 1) {
		          path.replaceWith(nodesOut[0]);
		        } else {
		          path.replaceWithMultiple(nodesOut);
		        }
		      }
		    }
		  };
		};
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 74 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var messages = _ref.messages,
		      template = _ref.template,
		      t = _ref.types;
	
		  var buildForOfArray = template("\n    for (var KEY = 0; KEY < ARR.length; KEY++) BODY;\n  ");
	
		  var buildForOfLoose = template("\n    for (var LOOP_OBJECT = OBJECT,\n             IS_ARRAY = Array.isArray(LOOP_OBJECT),\n             INDEX = 0,\n             LOOP_OBJECT = IS_ARRAY ? LOOP_OBJECT : LOOP_OBJECT[Symbol.iterator]();;) {\n      var ID;\n      if (IS_ARRAY) {\n        if (INDEX >= LOOP_OBJECT.length) break;\n        ID = LOOP_OBJECT[INDEX++];\n      } else {\n        INDEX = LOOP_OBJECT.next();\n        if (INDEX.done) break;\n        ID = INDEX.value;\n      }\n    }\n  ");
	
		  var buildForOf = template("\n    var ITERATOR_COMPLETION = true;\n    var ITERATOR_HAD_ERROR_KEY = false;\n    var ITERATOR_ERROR_KEY = undefined;\n    try {\n      for (var ITERATOR_KEY = OBJECT[Symbol.iterator](), STEP_KEY; !(ITERATOR_COMPLETION = (STEP_KEY = ITERATOR_KEY.next()).done); ITERATOR_COMPLETION = true) {\n      }\n    } catch (err) {\n      ITERATOR_HAD_ERROR_KEY = true;\n      ITERATOR_ERROR_KEY = err;\n    } finally {\n      try {\n        if (!ITERATOR_COMPLETION && ITERATOR_KEY.return) {\n          ITERATOR_KEY.return();\n        }\n      } finally {\n        if (ITERATOR_HAD_ERROR_KEY) {\n          throw ITERATOR_ERROR_KEY;\n        }\n      }\n    }\n  ");
	
		  function _ForOfStatementArray(path) {
		    var node = path.node,
		        scope = path.scope;
	
		    var nodes = [];
		    var right = node.right;
	
		    if (!t.isIdentifier(right) || !scope.hasBinding(right.name)) {
		      var uid = scope.generateUidIdentifier("arr");
		      nodes.push(t.variableDeclaration("var", [t.variableDeclarator(uid, right)]));
		      right = uid;
		    }
	
		    var iterationKey = scope.generateUidIdentifier("i");
	
		    var loop = buildForOfArray({
		      BODY: node.body,
		      KEY: iterationKey,
		      ARR: right
		    });
	
		    t.inherits(loop, node);
		    t.ensureBlock(loop);
	
		    var iterationValue = t.memberExpression(right, iterationKey, true);
	
		    var left = node.left;
		    if (t.isVariableDeclaration(left)) {
		      left.declarations[0].init = iterationValue;
		      loop.body.body.unshift(left);
		    } else {
		      loop.body.body.unshift(t.expressionStatement(t.assignmentExpression("=", left, iterationValue)));
		    }
	
		    if (path.parentPath.isLabeledStatement()) {
		      loop = t.labeledStatement(path.parentPath.node.label, loop);
		    }
	
		    nodes.push(loop);
	
		    return nodes;
		  }
	
		  return {
		    visitor: {
		      ForOfStatement: function ForOfStatement(path, state) {
		        if (path.get("right").isArrayExpression()) {
		          if (path.parentPath.isLabeledStatement()) {
		            return path.parentPath.replaceWithMultiple(_ForOfStatementArray(path));
		          } else {
		            return path.replaceWithMultiple(_ForOfStatementArray(path));
		          }
		        }
	
		        var callback = spec;
		        if (state.opts.loose) callback = loose;
	
		        var node = path.node;
	
		        var build = callback(path, state);
		        var declar = build.declar;
		        var loop = build.loop;
		        var block = loop.body;
	
		        path.ensureBlock();
	
		        if (declar) {
		          block.body.push(declar);
		        }
	
		        block.body = block.body.concat(node.body.body);
	
		        t.inherits(loop, node);
		        t.inherits(loop.body, node.body);
	
		        if (build.replaceParent) {
		          path.parentPath.replaceWithMultiple(build.node);
		          path.remove();
		        } else {
		          path.replaceWithMultiple(build.node);
		        }
		      }
		    }
		  };
	
		  function loose(path, file) {
		    var node = path.node,
		        scope = path.scope,
		        parent = path.parent;
		    var left = node.left;
	
		    var declar = void 0,
		        id = void 0;
	
		    if (t.isIdentifier(left) || t.isPattern(left) || t.isMemberExpression(left)) {
		      id = left;
		    } else if (t.isVariableDeclaration(left)) {
		      id = scope.generateUidIdentifier("ref");
		      declar = t.variableDeclaration(left.kind, [t.variableDeclarator(left.declarations[0].id, id)]);
		    } else {
		      throw file.buildCodeFrameError(left, messages.get("unknownForHead", left.type));
		    }
	
		    var iteratorKey = scope.generateUidIdentifier("iterator");
		    var isArrayKey = scope.generateUidIdentifier("isArray");
	
		    var loop = buildForOfLoose({
		      LOOP_OBJECT: iteratorKey,
		      IS_ARRAY: isArrayKey,
		      OBJECT: node.right,
		      INDEX: scope.generateUidIdentifier("i"),
		      ID: id
		    });
	
		    if (!declar) {
		      loop.body.body.shift();
		    }
	
		    var isLabeledParent = t.isLabeledStatement(parent);
		    var labeled = void 0;
	
		    if (isLabeledParent) {
		      labeled = t.labeledStatement(parent.label, loop);
		    }
	
		    return {
		      replaceParent: isLabeledParent,
		      declar: declar,
		      node: labeled || loop,
		      loop: loop
		    };
		  }
	
		  function spec(path, file) {
		    var node = path.node,
		        scope = path.scope,
		        parent = path.parent;
	
		    var left = node.left;
		    var declar = void 0;
	
		    var stepKey = scope.generateUidIdentifier("step");
		    var stepValue = t.memberExpression(stepKey, t.identifier("value"));
	
		    if (t.isIdentifier(left) || t.isPattern(left) || t.isMemberExpression(left)) {
		      declar = t.expressionStatement(t.assignmentExpression("=", left, stepValue));
		    } else if (t.isVariableDeclaration(left)) {
		      declar = t.variableDeclaration(left.kind, [t.variableDeclarator(left.declarations[0].id, stepValue)]);
		    } else {
		      throw file.buildCodeFrameError(left, messages.get("unknownForHead", left.type));
		    }
	
		    var iteratorKey = scope.generateUidIdentifier("iterator");
	
		    var template = buildForOf({
		      ITERATOR_HAD_ERROR_KEY: scope.generateUidIdentifier("didIteratorError"),
		      ITERATOR_COMPLETION: scope.generateUidIdentifier("iteratorNormalCompletion"),
		      ITERATOR_ERROR_KEY: scope.generateUidIdentifier("iteratorError"),
		      ITERATOR_KEY: iteratorKey,
		      STEP_KEY: stepKey,
		      OBJECT: node.right,
		      BODY: null
		    });
	
		    var isLabeledParent = t.isLabeledStatement(parent);
	
		    var tryBody = template[3].block.body;
		    var loop = tryBody[0];
	
		    if (isLabeledParent) {
		      tryBody[0] = t.labeledStatement(parent.label, loop);
		    }
	
		    return {
		      replaceParent: isLabeledParent,
		      declar: declar,
		      loop: loop,
		      node: template
		    };
		  }
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 75 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    visitor: {
		      FunctionExpression: {
		        exit: function exit(path) {
		          if (path.key !== "value" && !path.parentPath.isObjectProperty()) {
		            var replacement = (0, _babelHelperFunctionName2.default)(path);
		            if (replacement) path.replaceWith(replacement);
		          }
		        }
		      },
	
		      ObjectProperty: function ObjectProperty(path) {
		        var value = path.get("value");
		        if (value.isFunction()) {
		          var newNode = (0, _babelHelperFunctionName2.default)(value);
		          if (newNode) value.replaceWith(newNode);
		        }
		      }
		    }
		  };
		};
	
		var _babelHelperFunctionName = __webpack_require__(40);
	
		var _babelHelperFunctionName2 = _interopRequireDefault(_babelHelperFunctionName);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 76 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    visitor: {
		      NumericLiteral: function NumericLiteral(_ref) {
		        var node = _ref.node;
	
		        if (node.extra && /^0[ob]/i.test(node.extra.raw)) {
		          node.extra = undefined;
		        }
		      },
		      StringLiteral: function StringLiteral(_ref2) {
		        var node = _ref2.node;
	
		        if (node.extra && /\\[u]/gi.test(node.extra.raw)) {
		          node.extra = undefined;
		        }
		      }
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 77 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _keys = __webpack_require__(14);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _create = __webpack_require__(9);
	
		var _create2 = _interopRequireDefault(_create);
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _symbol = __webpack_require__(10);
	
		var _symbol2 = _interopRequireDefault(_symbol);
	
		exports.default = function () {
		  var REASSIGN_REMAP_SKIP = (0, _symbol2.default)();
	
		  var reassignmentVisitor = {
		    ReferencedIdentifier: function ReferencedIdentifier(path) {
		      var name = path.node.name;
		      var remap = this.remaps[name];
		      if (!remap) return;
	
		      if (this.scope.getBinding(name) !== path.scope.getBinding(name)) return;
	
		      if (path.parentPath.isCallExpression({ callee: path.node })) {
		        path.replaceWith(t.sequenceExpression([t.numericLiteral(0), remap]));
		      } else if (path.isJSXIdentifier() && t.isMemberExpression(remap)) {
		        var object = remap.object,
		            property = remap.property;
	
		        path.replaceWith(t.JSXMemberExpression(t.JSXIdentifier(object.name), t.JSXIdentifier(property.name)));
		      } else {
		        path.replaceWith(remap);
		      }
		      this.requeueInParent(path);
		    },
		    AssignmentExpression: function AssignmentExpression(path) {
		      var node = path.node;
		      if (node[REASSIGN_REMAP_SKIP]) return;
	
		      var left = path.get("left");
		      if (left.isIdentifier()) {
		        var name = left.node.name;
		        var exports = this.exports[name];
		        if (!exports) return;
	
		        if (this.scope.getBinding(name) !== path.scope.getBinding(name)) return;
	
		        node[REASSIGN_REMAP_SKIP] = true;
	
		        for (var _iterator = exports, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		          var _ref;
	
		          if (_isArray) {
		            if (_i >= _iterator.length) break;
		            _ref = _iterator[_i++];
		          } else {
		            _i = _iterator.next();
		            if (_i.done) break;
		            _ref = _i.value;
		          }
	
		          var reid = _ref;
	
		          node = buildExportsAssignment(reid, node).expression;
		        }
	
		        path.replaceWith(node);
		        this.requeueInParent(path);
		      } else if (left.isObjectPattern()) {
		        for (var _iterator2 = left.node.properties, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		          var _ref2;
	
		          if (_isArray2) {
		            if (_i2 >= _iterator2.length) break;
		            _ref2 = _iterator2[_i2++];
		          } else {
		            _i2 = _iterator2.next();
		            if (_i2.done) break;
		            _ref2 = _i2.value;
		          }
	
		          var property = _ref2;
	
		          var _name = property.value.name;
	
		          var _exports = this.exports[_name];
		          if (!_exports) continue;
	
		          if (this.scope.getBinding(_name) !== path.scope.getBinding(_name)) return;
	
		          node[REASSIGN_REMAP_SKIP] = true;
	
		          path.insertAfter(buildExportsAssignment(t.identifier(_name), t.identifier(_name)));
		        }
		      } else if (left.isArrayPattern()) {
		        for (var _iterator3 = left.node.elements, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		          var _ref3;
	
		          if (_isArray3) {
		            if (_i3 >= _iterator3.length) break;
		            _ref3 = _iterator3[_i3++];
		          } else {
		            _i3 = _iterator3.next();
		            if (_i3.done) break;
		            _ref3 = _i3.value;
		          }
	
		          var element = _ref3;
	
		          if (!element) continue;
		          var _name2 = element.name;
	
		          var _exports2 = this.exports[_name2];
		          if (!_exports2) continue;
	
		          if (this.scope.getBinding(_name2) !== path.scope.getBinding(_name2)) return;
	
		          node[REASSIGN_REMAP_SKIP] = true;
	
		          path.insertAfter(buildExportsAssignment(t.identifier(_name2), t.identifier(_name2)));
		        }
		      }
		    },
		    UpdateExpression: function UpdateExpression(path) {
		      var arg = path.get("argument");
		      if (!arg.isIdentifier()) return;
	
		      var name = arg.node.name;
		      var exports = this.exports[name];
		      if (!exports) return;
	
		      if (this.scope.getBinding(name) !== path.scope.getBinding(name)) return;
	
		      var node = t.assignmentExpression(path.node.operator[0] + "=", arg.node, t.numericLiteral(1));
	
		      if (path.parentPath.isExpressionStatement() && !path.isCompletionRecord() || path.node.prefix) {
		        path.replaceWith(node);
		        this.requeueInParent(path);
		        return;
		      }
	
		      var nodes = [];
		      nodes.push(node);
	
		      var operator = void 0;
		      if (path.node.operator === "--") {
		        operator = "+";
		      } else {
		        operator = "-";
		      }
		      nodes.push(t.binaryExpression(operator, arg.node, t.numericLiteral(1)));
	
		      path.replaceWithMultiple(t.sequenceExpression(nodes));
		    }
		  };
	
		  return {
		    inherits: _babelPluginTransformStrictMode2.default,
	
		    visitor: {
		      ThisExpression: function ThisExpression(path, state) {
		        if (this.ranCommonJS) return;
	
		        if (state.opts.allowTopLevelThis !== true && !path.findParent(function (path) {
		          return !path.is("shadow") && THIS_BREAK_KEYS.indexOf(path.type) >= 0;
		        })) {
		          path.replaceWith(t.identifier("undefined"));
		        }
		      },
	
		      Program: {
		        exit: function exit(path) {
		          this.ranCommonJS = true;
	
		          var strict = !!this.opts.strict;
		          var noInterop = !!this.opts.noInterop;
	
		          var scope = path.scope;
	
		          scope.rename("module");
		          scope.rename("exports");
		          scope.rename("require");
	
		          var hasExports = false;
		          var hasImports = false;
	
		          var body = path.get("body");
		          var imports = (0, _create2.default)(null);
		          var exports = (0, _create2.default)(null);
	
		          var nonHoistedExportNames = (0, _create2.default)(null);
	
		          var topNodes = [];
		          var remaps = (0, _create2.default)(null);
	
		          var requires = (0, _create2.default)(null);
	
		          function addRequire(source, blockHoist) {
		            var cached = requires[source];
		            if (cached) return cached;
	
		            var ref = path.scope.generateUidIdentifier((0, _path2.basename)(source, (0, _path2.extname)(source)));
	
		            var varDecl = t.variableDeclaration("var", [t.variableDeclarator(ref, buildRequire(t.stringLiteral(source)).expression)]);
	
		            if (imports[source]) {
		              varDecl.loc = imports[source].loc;
		            }
	
		            if (typeof blockHoist === "number" && blockHoist > 0) {
		              varDecl._blockHoist = blockHoist;
		            }
	
		            topNodes.push(varDecl);
	
		            return requires[source] = ref;
		          }
	
		          function addTo(obj, key, arr) {
		            var existing = obj[key] || [];
		            obj[key] = existing.concat(arr);
		          }
	
		          for (var _iterator4 = body, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
		            var _ref4;
	
		            if (_isArray4) {
		              if (_i4 >= _iterator4.length) break;
		              _ref4 = _iterator4[_i4++];
		            } else {
		              _i4 = _iterator4.next();
		              if (_i4.done) break;
		              _ref4 = _i4.value;
		            }
	
		            var _path = _ref4;
	
		            if (_path.isExportDeclaration()) {
		              hasExports = true;
	
		              var specifiers = [].concat(_path.get("declaration"), _path.get("specifiers"));
		              for (var _iterator6 = specifiers, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : (0, _getIterator3.default)(_iterator6);;) {
		                var _ref6;
	
		                if (_isArray6) {
		                  if (_i6 >= _iterator6.length) break;
		                  _ref6 = _iterator6[_i6++];
		                } else {
		                  _i6 = _iterator6.next();
		                  if (_i6.done) break;
		                  _ref6 = _i6.value;
		                }
	
		                var _specifier2 = _ref6;
	
		                var ids = _specifier2.getBindingIdentifiers();
		                if (ids.__esModule) {
		                  throw _specifier2.buildCodeFrameError("Illegal export \"__esModule\"");
		                }
		              }
		            }
	
		            if (_path.isImportDeclaration()) {
		              var _importsEntry$specifi;
	
		              hasImports = true;
	
		              var key = _path.node.source.value;
		              var importsEntry = imports[key] || {
		                specifiers: [],
		                maxBlockHoist: 0,
		                loc: _path.node.loc
		              };
	
		              (_importsEntry$specifi = importsEntry.specifiers).push.apply(_importsEntry$specifi, _path.node.specifiers);
	
		              if (typeof _path.node._blockHoist === "number") {
		                importsEntry.maxBlockHoist = Math.max(_path.node._blockHoist, importsEntry.maxBlockHoist);
		              }
	
		              imports[key] = importsEntry;
	
		              _path.remove();
		            } else if (_path.isExportDefaultDeclaration()) {
		              var declaration = _path.get("declaration");
		              if (declaration.isFunctionDeclaration()) {
		                var id = declaration.node.id;
		                var defNode = t.identifier("default");
		                if (id) {
		                  addTo(exports, id.name, defNode);
		                  topNodes.push(buildExportsAssignment(defNode, id));
		                  _path.replaceWith(declaration.node);
		                } else {
		                  topNodes.push(buildExportsAssignment(defNode, t.toExpression(declaration.node)));
		                  _path.remove();
		                }
		              } else if (declaration.isClassDeclaration()) {
		                var _id = declaration.node.id;
		                var _defNode = t.identifier("default");
		                if (_id) {
		                  addTo(exports, _id.name, _defNode);
		                  _path.replaceWithMultiple([declaration.node, buildExportsAssignment(_defNode, _id)]);
		                } else {
		                  _path.replaceWith(buildExportsAssignment(_defNode, t.toExpression(declaration.node)));
	
		                  _path.parentPath.requeue(_path.get("expression.left"));
		                }
		              } else {
		                _path.replaceWith(buildExportsAssignment(t.identifier("default"), declaration.node));
	
		                _path.parentPath.requeue(_path.get("expression.left"));
		              }
		            } else if (_path.isExportNamedDeclaration()) {
		              var _declaration = _path.get("declaration");
		              if (_declaration.node) {
		                if (_declaration.isFunctionDeclaration()) {
		                  var _id2 = _declaration.node.id;
		                  addTo(exports, _id2.name, _id2);
		                  topNodes.push(buildExportsAssignment(_id2, _id2));
		                  _path.replaceWith(_declaration.node);
		                } else if (_declaration.isClassDeclaration()) {
		                  var _id3 = _declaration.node.id;
		                  addTo(exports, _id3.name, _id3);
		                  _path.replaceWithMultiple([_declaration.node, buildExportsAssignment(_id3, _id3)]);
		                  nonHoistedExportNames[_id3.name] = true;
		                } else if (_declaration.isVariableDeclaration()) {
		                  var declarators = _declaration.get("declarations");
		                  for (var _iterator7 = declarators, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : (0, _getIterator3.default)(_iterator7);;) {
		                    var _ref7;
	
		                    if (_isArray7) {
		                      if (_i7 >= _iterator7.length) break;
		                      _ref7 = _iterator7[_i7++];
		                    } else {
		                      _i7 = _iterator7.next();
		                      if (_i7.done) break;
		                      _ref7 = _i7.value;
		                    }
	
		                    var decl = _ref7;
	
		                    var _id4 = decl.get("id");
	
		                    var init = decl.get("init");
		                    var exportsToInsert = [];
		                    if (!init.node) init.replaceWith(t.identifier("undefined"));
	
		                    if (_id4.isIdentifier()) {
		                      addTo(exports, _id4.node.name, _id4.node);
		                      init.replaceWith(buildExportsAssignment(_id4.node, init.node).expression);
		                      nonHoistedExportNames[_id4.node.name] = true;
		                    } else if (_id4.isObjectPattern()) {
		                      for (var _i8 = 0; _i8 < _id4.node.properties.length; _i8++) {
		                        var prop = _id4.node.properties[_i8];
		                        var propValue = prop.value;
		                        if (t.isAssignmentPattern(propValue)) {
		                          propValue = propValue.left;
		                        } else if (t.isRestProperty(prop)) {
		                          propValue = prop.argument;
		                        }
		                        addTo(exports, propValue.name, propValue);
		                        exportsToInsert.push(buildExportsAssignment(propValue, propValue));
		                        nonHoistedExportNames[propValue.name] = true;
		                      }
		                    } else if (_id4.isArrayPattern() && _id4.node.elements) {
		                      for (var _i9 = 0; _i9 < _id4.node.elements.length; _i9++) {
		                        var elem = _id4.node.elements[_i9];
		                        if (!elem) continue;
		                        if (t.isAssignmentPattern(elem)) {
		                          elem = elem.left;
		                        } else if (t.isRestElement(elem)) {
		                          elem = elem.argument;
		                        }
		                        var name = elem.name;
		                        addTo(exports, name, elem);
		                        exportsToInsert.push(buildExportsAssignment(elem, elem));
		                        nonHoistedExportNames[name] = true;
		                      }
		                    }
		                    _path.insertAfter(exportsToInsert);
		                  }
		                  _path.replaceWith(_declaration.node);
		                }
		                continue;
		              }
	
		              var _specifiers = _path.get("specifiers");
		              var nodes = [];
		              var _source = _path.node.source;
		              if (_source) {
		                var ref = addRequire(_source.value, _path.node._blockHoist);
	
		                for (var _iterator8 = _specifiers, _isArray8 = Array.isArray(_iterator8), _i10 = 0, _iterator8 = _isArray8 ? _iterator8 : (0, _getIterator3.default)(_iterator8);;) {
		                  var _ref8;
	
		                  if (_isArray8) {
		                    if (_i10 >= _iterator8.length) break;
		                    _ref8 = _iterator8[_i10++];
		                  } else {
		                    _i10 = _iterator8.next();
		                    if (_i10.done) break;
		                    _ref8 = _i10.value;
		                  }
	
		                  var _specifier3 = _ref8;
	
		                  if (_specifier3.isExportNamespaceSpecifier()) {} else if (_specifier3.isExportDefaultSpecifier()) {} else if (_specifier3.isExportSpecifier()) {
		                    if (!noInterop && _specifier3.node.local.name === "default") {
		                      topNodes.push(buildExportsFrom(t.stringLiteral(_specifier3.node.exported.name), t.memberExpression(t.callExpression(this.addHelper("interopRequireDefault"), [ref]), _specifier3.node.local)));
		                    } else {
		                      topNodes.push(buildExportsFrom(t.stringLiteral(_specifier3.node.exported.name), t.memberExpression(ref, _specifier3.node.local)));
		                    }
		                    nonHoistedExportNames[_specifier3.node.exported.name] = true;
		                  }
		                }
		              } else {
		                for (var _iterator9 = _specifiers, _isArray9 = Array.isArray(_iterator9), _i11 = 0, _iterator9 = _isArray9 ? _iterator9 : (0, _getIterator3.default)(_iterator9);;) {
		                  var _ref9;
	
		                  if (_isArray9) {
		                    if (_i11 >= _iterator9.length) break;
		                    _ref9 = _iterator9[_i11++];
		                  } else {
		                    _i11 = _iterator9.next();
		                    if (_i11.done) break;
		                    _ref9 = _i11.value;
		                  }
	
		                  var _specifier4 = _ref9;
	
		                  if (_specifier4.isExportSpecifier()) {
		                    addTo(exports, _specifier4.node.local.name, _specifier4.node.exported);
		                    nonHoistedExportNames[_specifier4.node.exported.name] = true;
		                    nodes.push(buildExportsAssignment(_specifier4.node.exported, _specifier4.node.local));
		                  }
		                }
		              }
		              _path.replaceWithMultiple(nodes);
		            } else if (_path.isExportAllDeclaration()) {
		              var exportNode = buildExportAll({
		                OBJECT: addRequire(_path.node.source.value, _path.node._blockHoist)
		              });
		              exportNode.loc = _path.node.loc;
		              topNodes.push(exportNode);
		              _path.remove();
		            }
		          }
	
		          for (var source in imports) {
		            var _imports$source = imports[source],
		                specifiers = _imports$source.specifiers,
		                maxBlockHoist = _imports$source.maxBlockHoist;
	
		            if (specifiers.length) {
		              var uid = addRequire(source, maxBlockHoist);
	
		              var wildcard = void 0;
	
		              for (var i = 0; i < specifiers.length; i++) {
		                var specifier = specifiers[i];
		                if (t.isImportNamespaceSpecifier(specifier)) {
		                  if (strict || noInterop) {
		                    remaps[specifier.local.name] = uid;
		                  } else {
		                    var varDecl = t.variableDeclaration("var", [t.variableDeclarator(specifier.local, t.callExpression(this.addHelper("interopRequireWildcard"), [uid]))]);
	
		                    if (maxBlockHoist > 0) {
		                      varDecl._blockHoist = maxBlockHoist;
		                    }
	
		                    topNodes.push(varDecl);
		                  }
		                  wildcard = specifier.local;
		                } else if (t.isImportDefaultSpecifier(specifier)) {
		                  specifiers[i] = t.importSpecifier(specifier.local, t.identifier("default"));
		                }
		              }
	
		              for (var _iterator5 = specifiers, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : (0, _getIterator3.default)(_iterator5);;) {
		                var _ref5;
	
		                if (_isArray5) {
		                  if (_i5 >= _iterator5.length) break;
		                  _ref5 = _iterator5[_i5++];
		                } else {
		                  _i5 = _iterator5.next();
		                  if (_i5.done) break;
		                  _ref5 = _i5.value;
		                }
	
		                var _specifier = _ref5;
	
		                if (t.isImportSpecifier(_specifier)) {
		                  var target = uid;
		                  if (_specifier.imported.name === "default") {
		                    if (wildcard) {
		                      target = wildcard;
		                    } else if (!noInterop) {
		                      target = wildcard = path.scope.generateUidIdentifier(uid.name);
		                      var _varDecl = t.variableDeclaration("var", [t.variableDeclarator(target, t.callExpression(this.addHelper("interopRequireDefault"), [uid]))]);
	
		                      if (maxBlockHoist > 0) {
		                        _varDecl._blockHoist = maxBlockHoist;
		                      }
	
		                      topNodes.push(_varDecl);
		                    }
		                  }
		                  remaps[_specifier.local.name] = t.memberExpression(target, t.cloneWithoutLoc(_specifier.imported));
		                }
		              }
		            } else {
		              var requireNode = buildRequire(t.stringLiteral(source));
		              requireNode.loc = imports[source].loc;
		              topNodes.push(requireNode);
		            }
		          }
	
		          if (hasImports && (0, _keys2.default)(nonHoistedExportNames).length) {
		            var maxHoistedExportsNodeAssignmentLength = 100;
		            var nonHoistedExportNamesArr = (0, _keys2.default)(nonHoistedExportNames);
	
		            var _loop = function _loop(currentExportsNodeAssignmentLength) {
		              var nonHoistedExportNamesChunk = nonHoistedExportNamesArr.slice(currentExportsNodeAssignmentLength, currentExportsNodeAssignmentLength + maxHoistedExportsNodeAssignmentLength);
	
		              var hoistedExportsNode = t.identifier("undefined");
	
		              nonHoistedExportNamesChunk.forEach(function (name) {
		                hoistedExportsNode = buildExportsAssignment(t.identifier(name), hoistedExportsNode).expression;
		              });
	
		              var node = t.expressionStatement(hoistedExportsNode);
		              node._blockHoist = 3;
	
		              topNodes.unshift(node);
		            };
	
		            for (var currentExportsNodeAssignmentLength = 0; currentExportsNodeAssignmentLength < nonHoistedExportNamesArr.length; currentExportsNodeAssignmentLength += maxHoistedExportsNodeAssignmentLength) {
		              _loop(currentExportsNodeAssignmentLength);
		            }
		          }
	
		          if (hasExports && !strict) {
		            var buildTemplate = buildExportsModuleDeclaration;
		            if (this.opts.loose) buildTemplate = buildLooseExportsModuleDeclaration;
	
		            var declar = buildTemplate();
		            declar._blockHoist = 3;
	
		            topNodes.unshift(declar);
		          }
	
		          path.unshiftContainer("body", topNodes);
		          path.traverse(reassignmentVisitor, {
		            remaps: remaps,
		            scope: scope,
		            exports: exports,
		            requeueInParent: function requeueInParent(newPath) {
		              return path.requeue(newPath);
		            }
		          });
		        }
		      }
		    }
		  };
		};
	
		var _path2 = __webpack_require__(19);
	
		var _babelTemplate = __webpack_require__(4);
	
		var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
		var _babelPluginTransformStrictMode = __webpack_require__(216);
	
		var _babelPluginTransformStrictMode2 = _interopRequireDefault(_babelPluginTransformStrictMode);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var buildRequire = (0, _babelTemplate2.default)("\n  require($0);\n");
	
		var buildExportsModuleDeclaration = (0, _babelTemplate2.default)("\n  Object.defineProperty(exports, \"__esModule\", {\n    value: true\n  });\n");
	
		var buildExportsFrom = (0, _babelTemplate2.default)("\n  Object.defineProperty(exports, $0, {\n    enumerable: true,\n    get: function () {\n      return $1;\n    }\n  });\n");
	
		var buildLooseExportsModuleDeclaration = (0, _babelTemplate2.default)("\n  exports.__esModule = true;\n");
	
		var buildExportsAssignment = (0, _babelTemplate2.default)("\n  exports.$0 = $1;\n");
	
		var buildExportAll = (0, _babelTemplate2.default)("\n  Object.keys(OBJECT).forEach(function (key) {\n    if (key === \"default\" || key === \"__esModule\") return;\n    Object.defineProperty(exports, key, {\n      enumerable: true,\n      get: function () {\n        return OBJECT[key];\n      }\n    });\n  });\n");
	
		var THIS_BREAK_KEYS = ["FunctionExpression", "FunctionDeclaration", "ClassProperty", "ClassMethod", "ObjectMethod"];
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 78 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _symbol = __webpack_require__(10);
	
		var _symbol2 = _interopRequireDefault(_symbol);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  function Property(path, node, scope, getObjectRef, file) {
		    var replaceSupers = new _babelHelperReplaceSupers2.default({
		      getObjectRef: getObjectRef,
		      methodNode: node,
		      methodPath: path,
		      isStatic: true,
		      scope: scope,
		      file: file
		    });
	
		    replaceSupers.replace();
		  }
	
		  var CONTAINS_SUPER = (0, _symbol2.default)();
	
		  return {
		    visitor: {
		      Super: function Super(path) {
		        var parentObj = path.findParent(function (path) {
		          return path.isObjectExpression();
		        });
		        if (parentObj) parentObj.node[CONTAINS_SUPER] = true;
		      },
	
		      ObjectExpression: {
		        exit: function exit(path, file) {
		          if (!path.node[CONTAINS_SUPER]) return;
	
		          var objectRef = void 0;
		          var getObjectRef = function getObjectRef() {
		            return objectRef = objectRef || path.scope.generateUidIdentifier("obj");
		          };
	
		          var propPaths = path.get("properties");
		          for (var _iterator = propPaths, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		            var _ref2;
	
		            if (_isArray) {
		              if (_i >= _iterator.length) break;
		              _ref2 = _iterator[_i++];
		            } else {
		              _i = _iterator.next();
		              if (_i.done) break;
		              _ref2 = _i.value;
		            }
	
		            var propPath = _ref2;
	
		            if (propPath.isObjectProperty()) propPath = propPath.get("value");
		            Property(propPath, propPath.node, path.scope, getObjectRef, file);
		          }
	
		          if (objectRef) {
		            path.scope.push({ id: objectRef });
		            path.replaceWith(t.assignmentExpression("=", objectRef, path.node));
		          }
		        }
		      }
		    }
		  };
		};
	
		var _babelHelperReplaceSupers = __webpack_require__(193);
	
		var _babelHelperReplaceSupers2 = _interopRequireDefault(_babelHelperReplaceSupers);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 79 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function () {
		  return {
		    visitor: _babelTraverse.visitors.merge([{
		      ArrowFunctionExpression: function ArrowFunctionExpression(path) {
		        var params = path.get("params");
		        for (var _iterator = params, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		          var _ref;
	
		          if (_isArray) {
		            if (_i >= _iterator.length) break;
		            _ref = _iterator[_i++];
		          } else {
		            _i = _iterator.next();
		            if (_i.done) break;
		            _ref = _i.value;
		          }
	
		          var param = _ref;
	
		          if (param.isRestElement() || param.isAssignmentPattern()) {
		            path.arrowFunctionToShadowed();
		            break;
		          }
		        }
		      }
		    }, destructuring.visitor, rest.visitor, def.visitor])
		  };
		};
	
		var _babelTraverse = __webpack_require__(7);
	
		var _destructuring = __webpack_require__(334);
	
		var destructuring = _interopRequireWildcard(_destructuring);
	
		var _default = __webpack_require__(333);
	
		var def = _interopRequireWildcard(_default);
	
		var _rest = __webpack_require__(335);
	
		var rest = _interopRequireWildcard(_rest);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 80 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    visitor: {
		      ObjectMethod: function ObjectMethod(path) {
		        var node = path.node;
	
		        if (node.kind === "method") {
		          var func = t.functionExpression(null, node.params, node.body, node.generator, node.async);
		          func.returnType = node.returnType;
	
		          path.replaceWith(t.objectProperty(node.key, func, node.computed));
		        }
		      },
		      ObjectProperty: function ObjectProperty(_ref) {
		        var node = _ref.node;
	
		        if (node.shorthand) {
		          node.shorthand = false;
		        }
		      }
		    }
		  };
		};
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 81 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  function getSpreadLiteral(spread, scope, state) {
		    if (state.opts.loose && !t.isIdentifier(spread.argument, { name: "arguments" })) {
		      return spread.argument;
		    } else {
		      return scope.toArray(spread.argument, true);
		    }
		  }
	
		  function hasSpread(nodes) {
		    for (var i = 0; i < nodes.length; i++) {
		      if (t.isSpreadElement(nodes[i])) {
		        return true;
		      }
		    }
		    return false;
		  }
	
		  function build(props, scope, state) {
		    var nodes = [];
	
		    var _props = [];
	
		    function push() {
		      if (!_props.length) return;
		      nodes.push(t.arrayExpression(_props));
		      _props = [];
		    }
	
		    for (var _iterator = props, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref2;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref2 = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref2 = _i.value;
		      }
	
		      var prop = _ref2;
	
		      if (t.isSpreadElement(prop)) {
		        push();
		        nodes.push(getSpreadLiteral(prop, scope, state));
		      } else {
		        _props.push(prop);
		      }
		    }
	
		    push();
	
		    return nodes;
		  }
	
		  return {
		    visitor: {
		      ArrayExpression: function ArrayExpression(path, state) {
		        var node = path.node,
		            scope = path.scope;
	
		        var elements = node.elements;
		        if (!hasSpread(elements)) return;
	
		        var nodes = build(elements, scope, state);
		        var first = nodes.shift();
	
		        if (!t.isArrayExpression(first)) {
		          nodes.unshift(first);
		          first = t.arrayExpression([]);
		        }
	
		        path.replaceWith(t.callExpression(t.memberExpression(first, t.identifier("concat")), nodes));
		      },
		      CallExpression: function CallExpression(path, state) {
		        var node = path.node,
		            scope = path.scope;
	
		        var args = node.arguments;
		        if (!hasSpread(args)) return;
	
		        var calleePath = path.get("callee");
		        if (calleePath.isSuper()) return;
	
		        var contextLiteral = t.identifier("undefined");
	
		        node.arguments = [];
	
		        var nodes = void 0;
		        if (args.length === 1 && args[0].argument.name === "arguments") {
		          nodes = [args[0].argument];
		        } else {
		          nodes = build(args, scope, state);
		        }
	
		        var first = nodes.shift();
		        if (nodes.length) {
		          node.arguments.push(t.callExpression(t.memberExpression(first, t.identifier("concat")), nodes));
		        } else {
		          node.arguments.push(first);
		        }
	
		        var callee = node.callee;
	
		        if (calleePath.isMemberExpression()) {
		          var temp = scope.maybeGenerateMemoised(callee.object);
		          if (temp) {
		            callee.object = t.assignmentExpression("=", temp, callee.object);
		            contextLiteral = temp;
		          } else {
		            contextLiteral = callee.object;
		          }
		          t.appendToMemberExpression(callee, t.identifier("apply"));
		        } else {
		          node.callee = t.memberExpression(node.callee, t.identifier("apply"));
		        }
	
		        if (t.isSuper(contextLiteral)) {
		          contextLiteral = t.thisExpression();
		        }
	
		        node.arguments.unshift(contextLiteral);
		      },
		      NewExpression: function NewExpression(path, state) {
		        var node = path.node,
		            scope = path.scope;
	
		        var args = node.arguments;
		        if (!hasSpread(args)) return;
	
		        var nodes = build(args, scope, state);
	
		        var context = t.arrayExpression([t.nullLiteral()]);
	
		        args = t.callExpression(t.memberExpression(context, t.identifier("concat")), nodes);
	
		        path.replaceWith(t.newExpression(t.callExpression(t.memberExpression(t.memberExpression(t.memberExpression(t.identifier("Function"), t.identifier("prototype")), t.identifier("bind")), t.identifier("apply")), [node.callee, args]), []));
		      }
		    }
		  };
		};
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 82 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    visitor: {
		      RegExpLiteral: function RegExpLiteral(path) {
		        var node = path.node;
	
		        if (!regex.is(node, "y")) return;
	
		        path.replaceWith(t.newExpression(t.identifier("RegExp"), [t.stringLiteral(node.pattern), t.stringLiteral(node.flags)]));
		      }
		    }
		  };
		};
	
		var _babelHelperRegex = __webpack_require__(192);
	
		var regex = _interopRequireWildcard(_babelHelperRegex);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 83 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  function isString(node) {
		    return t.isLiteral(node) && typeof node.value === "string";
		  }
	
		  function buildBinaryExpression(left, right) {
		    return t.binaryExpression("+", left, right);
		  }
	
		  return {
		    visitor: {
		      TaggedTemplateExpression: function TaggedTemplateExpression(path, state) {
		        var node = path.node;
	
		        var quasi = node.quasi;
		        var args = [];
	
		        var strings = [];
		        var raw = [];
	
		        for (var _iterator = quasi.quasis, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		          var _ref2;
	
		          if (_isArray) {
		            if (_i >= _iterator.length) break;
		            _ref2 = _iterator[_i++];
		          } else {
		            _i = _iterator.next();
		            if (_i.done) break;
		            _ref2 = _i.value;
		          }
	
		          var elem = _ref2;
	
		          strings.push(t.stringLiteral(elem.value.cooked));
		          raw.push(t.stringLiteral(elem.value.raw));
		        }
	
		        strings = t.arrayExpression(strings);
		        raw = t.arrayExpression(raw);
	
		        var templateName = "taggedTemplateLiteral";
		        if (state.opts.loose) templateName += "Loose";
	
		        var templateObject = state.file.addTemplateObject(templateName, strings, raw);
		        args.push(templateObject);
	
		        args = args.concat(quasi.expressions);
	
		        path.replaceWith(t.callExpression(node.tag, args));
		      },
		      TemplateLiteral: function TemplateLiteral(path, state) {
		        var nodes = [];
	
		        var expressions = path.get("expressions");
	
		        for (var _iterator2 = path.node.quasis, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		          var _ref3;
	
		          if (_isArray2) {
		            if (_i2 >= _iterator2.length) break;
		            _ref3 = _iterator2[_i2++];
		          } else {
		            _i2 = _iterator2.next();
		            if (_i2.done) break;
		            _ref3 = _i2.value;
		          }
	
		          var elem = _ref3;
	
		          nodes.push(t.stringLiteral(elem.value.cooked));
	
		          var expr = expressions.shift();
		          if (expr) {
		            if (state.opts.spec && !expr.isBaseType("string") && !expr.isBaseType("number")) {
		              nodes.push(t.callExpression(t.identifier("String"), [expr.node]));
		            } else {
		              nodes.push(expr.node);
		            }
		          }
		        }
	
		        nodes = nodes.filter(function (n) {
		          return !t.isLiteral(n, { value: "" });
		        });
	
		        if (!isString(nodes[0]) && !isString(nodes[1])) {
		          nodes.unshift(t.stringLiteral(""));
		        }
	
		        if (nodes.length > 1) {
		          var root = buildBinaryExpression(nodes.shift(), nodes.shift());
	
		          for (var _iterator3 = nodes, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		            var _ref4;
	
		            if (_isArray3) {
		              if (_i3 >= _iterator3.length) break;
		              _ref4 = _iterator3[_i3++];
		            } else {
		              _i3 = _iterator3.next();
		              if (_i3.done) break;
		              _ref4 = _i3.value;
		            }
	
		            var node = _ref4;
	
		            root = buildBinaryExpression(root, node);
		          }
	
		          path.replaceWith(root);
		        } else {
		          path.replaceWith(nodes[0]);
		        }
		      }
		    }
		  };
		};
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 84 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _symbol = __webpack_require__(10);
	
		var _symbol2 = _interopRequireDefault(_symbol);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  var IGNORE = (0, _symbol2.default)();
	
		  return {
		    visitor: {
		      Scope: function Scope(_ref2) {
		        var scope = _ref2.scope;
	
		        if (!scope.getBinding("Symbol")) {
		          return;
		        }
	
		        scope.rename("Symbol");
		      },
		      UnaryExpression: function UnaryExpression(path) {
		        var node = path.node,
		            parent = path.parent;
	
		        if (node[IGNORE]) return;
		        if (path.find(function (path) {
		          return path.node && !!path.node._generated;
		        })) return;
	
		        if (path.parentPath.isBinaryExpression() && t.EQUALITY_BINARY_OPERATORS.indexOf(parent.operator) >= 0) {
		          var opposite = path.getOpposite();
		          if (opposite.isLiteral() && opposite.node.value !== "symbol" && opposite.node.value !== "object") {
		            return;
		          }
		        }
	
		        if (node.operator === "typeof") {
		          var call = t.callExpression(this.addHelper("typeof"), [node.argument]);
		          if (path.get("argument").isIdentifier()) {
		            var undefLiteral = t.stringLiteral("undefined");
		            var unary = t.unaryExpression("typeof", node.argument);
		            unary[IGNORE] = true;
		            path.replaceWith(t.conditionalExpression(t.binaryExpression("===", unary, undefLiteral), undefLiteral, call));
		          } else {
		            path.replaceWith(call);
		          }
		        }
		      }
		    }
		  };
		};
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 85 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    visitor: {
		      RegExpLiteral: function RegExpLiteral(_ref) {
		        var node = _ref.node;
	
		        if (!regex.is(node, "u")) return;
		        node.pattern = (0, _regexpuCore2.default)(node.pattern, node.flags);
		        regex.pullFlag(node, "u");
		      }
		    }
		  };
		};
	
		var _regexpuCore = __webpack_require__(612);
	
		var _regexpuCore2 = _interopRequireDefault(_regexpuCore);
	
		var _babelHelperRegex = __webpack_require__(192);
	
		var regex = _interopRequireWildcard(_babelHelperRegex);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 86 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		module.exports = __webpack_require__(606);
	
	/***/ }),
	/* 87 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		module.exports = { "default": __webpack_require__(408), __esModule: true };
	
	/***/ }),
	/* 88 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.scope = exports.path = undefined;
	
		var _weakMap = __webpack_require__(364);
	
		var _weakMap2 = _interopRequireDefault(_weakMap);
	
		exports.clear = clear;
		exports.clearPath = clearPath;
		exports.clearScope = clearScope;
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var path = exports.path = new _weakMap2.default();
		var scope = exports.scope = new _weakMap2.default();
	
		function clear() {
		  clearPath();
		  clearScope();
		}
	
		function clearPath() {
		  exports.path = path = new _weakMap2.default();
		}
	
		function clearScope() {
		  exports.scope = scope = new _weakMap2.default();
		}
	
	/***/ }),
	/* 89 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, '__esModule', { value: true });
	
		/* eslint max-len: 0 */
	
		// This is a trick taken from Esprima. It turns out that, on
		// non-Chrome browsers, to check whether a string is in a set, a
		// predicate containing a big ugly `switch` statement is faster than
		// a regular expression, and on Chrome the two are about on par.
		// This function uses `eval` (non-lexical) to produce such a
		// predicate from a space-separated string of words.
		//
		// It starts by sorting the words by length.
	
		function makePredicate(words) {
		  words = words.split(" ");
		  return function (str) {
		    return words.indexOf(str) >= 0;
		  };
		}
	
		// Reserved word lists for various dialects of the language
	
		var reservedWords = {
		  6: makePredicate("enum await"),
		  strict: makePredicate("implements interface let package private protected public static yield"),
		  strictBind: makePredicate("eval arguments")
		};
	
		// And the keywords
	
		var isKeyword = makePredicate("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this let const class extends export import yield super");
	
		// ## Character categories
	
		// Big ugly regular expressions that match characters in the
		// whitespace, identifier, and identifier-start categories. These
		// are only applied when a character is found to actually have a
		// code point above 128.
		// Generated by `bin/generate-identifier-regex.js`.
	
		var nonASCIIidentifierStartChars = '\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC';
		var nonASCIIidentifierChars = '\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D4-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0D01-\u0D03\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFB-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA900-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F';
	
		var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
		var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");
	
		nonASCIIidentifierStartChars = nonASCIIidentifierChars = null;
	
		// These are a run-length and offset encoded representation of the
		// >0xffff code points that are a valid part of identifiers. The
		// offset starts at 0x10000, and each pair of numbers represents an
		// offset to the next range, and then a size of the range. They were
		// generated by `bin/generate-identifier-regex.js`.
		// eslint-disable-next-line comma-spacing
		var astralIdentifierStartCodes = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 17, 26, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 157, 310, 10, 21, 11, 7, 153, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 26, 45, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 785, 52, 76, 44, 33, 24, 27, 35, 42, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 85, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 54, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 86, 25, 391, 63, 32, 0, 449, 56, 264, 8, 2, 36, 18, 0, 50, 29, 881, 921, 103, 110, 18, 195, 2749, 1070, 4050, 582, 8634, 568, 8, 30, 114, 29, 19, 47, 17, 3, 32, 20, 6, 18, 881, 68, 12, 0, 67, 12, 65, 0, 32, 6124, 20, 754, 9486, 1, 3071, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 4149, 196, 60, 67, 1213, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42710, 42, 4148, 12, 221, 3, 5761, 10591, 541];
		// eslint-disable-next-line comma-spacing
		var astralIdentifierCodes = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 1306, 2, 54, 14, 32, 9, 16, 3, 46, 10, 54, 9, 7, 2, 37, 13, 2, 9, 52, 0, 13, 2, 49, 13, 10, 2, 4, 9, 83, 11, 7, 0, 161, 11, 6, 9, 7, 3, 57, 0, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 87, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 423, 9, 838, 7, 2, 7, 17, 9, 57, 21, 2, 13, 19882, 9, 135, 4, 60, 6, 26, 9, 1016, 45, 17, 3, 19723, 1, 5319, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 2214, 6, 110, 6, 6, 9, 792487, 239];
	
		// This has a complexity linear to the value of the code. The
		// assumption is that looking up astral identifier characters is
		// rare.
		function isInAstralSet(code, set) {
		  var pos = 0x10000;
		  for (var i = 0; i < set.length; i += 2) {
		    pos += set[i];
		    if (pos > code) return false;
	
		    pos += set[i + 1];
		    if (pos >= code) return true;
		  }
		}
	
		// Test whether a given character code starts an identifier.
	
		function isIdentifierStart(code) {
		  if (code < 65) return code === 36;
		  if (code < 91) return true;
		  if (code < 97) return code === 95;
		  if (code < 123) return true;
		  if (code <= 0xffff) return code >= 0xaa && nonASCIIidentifierStart.test(String.fromCharCode(code));
		  return isInAstralSet(code, astralIdentifierStartCodes);
		}
	
		// Test whether a given character is part of an identifier.
	
		function isIdentifierChar(code) {
		  if (code < 48) return code === 36;
		  if (code < 58) return true;
		  if (code < 65) return false;
		  if (code < 91) return true;
		  if (code < 97) return code === 95;
		  if (code < 123) return true;
		  if (code <= 0xffff) return code >= 0xaa && nonASCIIidentifier.test(String.fromCharCode(code));
		  return isInAstralSet(code, astralIdentifierStartCodes) || isInAstralSet(code, astralIdentifierCodes);
		}
	
		// A second optional argument can be given to further configure
		var defaultOptions = {
		  // Source type ("script" or "module") for different semantics
		  sourceType: "script",
		  // Source filename.
		  sourceFilename: undefined,
		  // Line from which to start counting source. Useful for
		  // integration with other tools.
		  startLine: 1,
		  // When enabled, a return at the top level is not considered an
		  // error.
		  allowReturnOutsideFunction: false,
		  // When enabled, import/export statements are not constrained to
		  // appearing at the top of the program.
		  allowImportExportEverywhere: false,
		  // TODO
		  allowSuperOutsideMethod: false,
		  // An array of plugins to enable
		  plugins: [],
		  // TODO
		  strictMode: null
		};
	
		// Interpret and default an options object
	
		function getOptions(opts) {
		  var options = {};
		  for (var key in defaultOptions) {
		    options[key] = opts && key in opts ? opts[key] : defaultOptions[key];
		  }
		  return options;
		}
	
		var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
		  return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
		} : function (obj) {
		  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
		};
	
		var classCallCheck = function classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		};
	
		var inherits = function inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
		  }
	
		  subClass.prototype = Object.create(superClass && superClass.prototype, {
		    constructor: {
		      value: subClass,
		      enumerable: false,
		      writable: true,
		      configurable: true
		    }
		  });
		  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		};
	
		var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }
	
		  return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
		};
	
		// ## Token types
	
		// The assignment of fine-grained, information-carrying type objects
		// allows the tokenizer to store the information it has about a
		// token in a way that is very cheap for the parser to look up.
	
		// All token type variables start with an underscore, to make them
		// easy to recognize.
	
		// The `beforeExpr` property is used to disambiguate between regular
		// expressions and divisions. It is set on all token types that can
		// be followed by an expression (thus, a slash after them would be a
		// regular expression).
		//
		// `isLoop` marks a keyword as starting a loop, which is important
		// to know when parsing a label, in order to allow or disallow
		// continue jumps to that label.
	
		var beforeExpr = true;
		var startsExpr = true;
		var isLoop = true;
		var isAssign = true;
		var prefix = true;
		var postfix = true;
	
		var TokenType = function TokenType(label) {
		  var conf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		  classCallCheck(this, TokenType);
	
		  this.label = label;
		  this.keyword = conf.keyword;
		  this.beforeExpr = !!conf.beforeExpr;
		  this.startsExpr = !!conf.startsExpr;
		  this.rightAssociative = !!conf.rightAssociative;
		  this.isLoop = !!conf.isLoop;
		  this.isAssign = !!conf.isAssign;
		  this.prefix = !!conf.prefix;
		  this.postfix = !!conf.postfix;
		  this.binop = conf.binop || null;
		  this.updateContext = null;
		};
	
		var KeywordTokenType = function (_TokenType) {
		  inherits(KeywordTokenType, _TokenType);
	
		  function KeywordTokenType(name) {
		    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		    classCallCheck(this, KeywordTokenType);
	
		    options.keyword = name;
	
		    return possibleConstructorReturn(this, _TokenType.call(this, name, options));
		  }
	
		  return KeywordTokenType;
		}(TokenType);
	
		var BinopTokenType = function (_TokenType2) {
		  inherits(BinopTokenType, _TokenType2);
	
		  function BinopTokenType(name, prec) {
		    classCallCheck(this, BinopTokenType);
		    return possibleConstructorReturn(this, _TokenType2.call(this, name, { beforeExpr: beforeExpr, binop: prec }));
		  }
	
		  return BinopTokenType;
		}(TokenType);
	
		var types = {
		  num: new TokenType("num", { startsExpr: startsExpr }),
		  regexp: new TokenType("regexp", { startsExpr: startsExpr }),
		  string: new TokenType("string", { startsExpr: startsExpr }),
		  name: new TokenType("name", { startsExpr: startsExpr }),
		  eof: new TokenType("eof"),
	
		  // Punctuation token types.
		  bracketL: new TokenType("[", { beforeExpr: beforeExpr, startsExpr: startsExpr }),
		  bracketR: new TokenType("]"),
		  braceL: new TokenType("{", { beforeExpr: beforeExpr, startsExpr: startsExpr }),
		  braceBarL: new TokenType("{|", { beforeExpr: beforeExpr, startsExpr: startsExpr }),
		  braceR: new TokenType("}"),
		  braceBarR: new TokenType("|}"),
		  parenL: new TokenType("(", { beforeExpr: beforeExpr, startsExpr: startsExpr }),
		  parenR: new TokenType(")"),
		  comma: new TokenType(",", { beforeExpr: beforeExpr }),
		  semi: new TokenType(";", { beforeExpr: beforeExpr }),
		  colon: new TokenType(":", { beforeExpr: beforeExpr }),
		  doubleColon: new TokenType("::", { beforeExpr: beforeExpr }),
		  dot: new TokenType("."),
		  question: new TokenType("?", { beforeExpr: beforeExpr }),
		  arrow: new TokenType("=>", { beforeExpr: beforeExpr }),
		  template: new TokenType("template"),
		  ellipsis: new TokenType("...", { beforeExpr: beforeExpr }),
		  backQuote: new TokenType("`", { startsExpr: startsExpr }),
		  dollarBraceL: new TokenType("${", { beforeExpr: beforeExpr, startsExpr: startsExpr }),
		  at: new TokenType("@"),
	
		  // Operators. These carry several kinds of properties to help the
		  // parser use them properly (the presence of these properties is
		  // what categorizes them as operators).
		  //
		  // `binop`, when present, specifies that this operator is a binary
		  // operator, and will refer to its precedence.
		  //
		  // `prefix` and `postfix` mark the operator as a prefix or postfix
		  // unary operator.
		  //
		  // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
		  // binary operators with a very low precedence, that should result
		  // in AssignmentExpression nodes.
	
		  eq: new TokenType("=", { beforeExpr: beforeExpr, isAssign: isAssign }),
		  assign: new TokenType("_=", { beforeExpr: beforeExpr, isAssign: isAssign }),
		  incDec: new TokenType("++/--", { prefix: prefix, postfix: postfix, startsExpr: startsExpr }),
		  prefix: new TokenType("prefix", { beforeExpr: beforeExpr, prefix: prefix, startsExpr: startsExpr }),
		  logicalOR: new BinopTokenType("||", 1),
		  logicalAND: new BinopTokenType("&&", 2),
		  bitwiseOR: new BinopTokenType("|", 3),
		  bitwiseXOR: new BinopTokenType("^", 4),
		  bitwiseAND: new BinopTokenType("&", 5),
		  equality: new BinopTokenType("==/!=", 6),
		  relational: new BinopTokenType("</>", 7),
		  bitShift: new BinopTokenType("<</>>", 8),
		  plusMin: new TokenType("+/-", { beforeExpr: beforeExpr, binop: 9, prefix: prefix, startsExpr: startsExpr }),
		  modulo: new BinopTokenType("%", 10),
		  star: new BinopTokenType("*", 10),
		  slash: new BinopTokenType("/", 10),
		  exponent: new TokenType("**", { beforeExpr: beforeExpr, binop: 11, rightAssociative: true })
		};
	
		var keywords = {
		  "break": new KeywordTokenType("break"),
		  "case": new KeywordTokenType("case", { beforeExpr: beforeExpr }),
		  "catch": new KeywordTokenType("catch"),
		  "continue": new KeywordTokenType("continue"),
		  "debugger": new KeywordTokenType("debugger"),
		  "default": new KeywordTokenType("default", { beforeExpr: beforeExpr }),
		  "do": new KeywordTokenType("do", { isLoop: isLoop, beforeExpr: beforeExpr }),
		  "else": new KeywordTokenType("else", { beforeExpr: beforeExpr }),
		  "finally": new KeywordTokenType("finally"),
		  "for": new KeywordTokenType("for", { isLoop: isLoop }),
		  "function": new KeywordTokenType("function", { startsExpr: startsExpr }),
		  "if": new KeywordTokenType("if"),
		  "return": new KeywordTokenType("return", { beforeExpr: beforeExpr }),
		  "switch": new KeywordTokenType("switch"),
		  "throw": new KeywordTokenType("throw", { beforeExpr: beforeExpr }),
		  "try": new KeywordTokenType("try"),
		  "var": new KeywordTokenType("var"),
		  "let": new KeywordTokenType("let"),
		  "const": new KeywordTokenType("const"),
		  "while": new KeywordTokenType("while", { isLoop: isLoop }),
		  "with": new KeywordTokenType("with"),
		  "new": new KeywordTokenType("new", { beforeExpr: beforeExpr, startsExpr: startsExpr }),
		  "this": new KeywordTokenType("this", { startsExpr: startsExpr }),
		  "super": new KeywordTokenType("super", { startsExpr: startsExpr }),
		  "class": new KeywordTokenType("class"),
		  "extends": new KeywordTokenType("extends", { beforeExpr: beforeExpr }),
		  "export": new KeywordTokenType("export"),
		  "import": new KeywordTokenType("import", { startsExpr: startsExpr }),
		  "yield": new KeywordTokenType("yield", { beforeExpr: beforeExpr, startsExpr: startsExpr }),
		  "null": new KeywordTokenType("null", { startsExpr: startsExpr }),
		  "true": new KeywordTokenType("true", { startsExpr: startsExpr }),
		  "false": new KeywordTokenType("false", { startsExpr: startsExpr }),
		  "in": new KeywordTokenType("in", { beforeExpr: beforeExpr, binop: 7 }),
		  "instanceof": new KeywordTokenType("instanceof", { beforeExpr: beforeExpr, binop: 7 }),
		  "typeof": new KeywordTokenType("typeof", { beforeExpr: beforeExpr, prefix: prefix, startsExpr: startsExpr }),
		  "void": new KeywordTokenType("void", { beforeExpr: beforeExpr, prefix: prefix, startsExpr: startsExpr }),
		  "delete": new KeywordTokenType("delete", { beforeExpr: beforeExpr, prefix: prefix, startsExpr: startsExpr })
		};
	
		// Map keyword names to token types.
		Object.keys(keywords).forEach(function (name) {
		  types["_" + name] = keywords[name];
		});
	
		// Matches a whole line break (where CRLF is considered a single
		// line break). Used to count lines.
	
		var lineBreak = /\r\n?|\n|\u2028|\u2029/;
		var lineBreakG = new RegExp(lineBreak.source, "g");
	
		function isNewLine(code) {
		  return code === 10 || code === 13 || code === 0x2028 || code === 0x2029;
		}
	
		var nonASCIIwhitespace = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/;
	
		// The algorithm used to determine whether a regexp can appear at a
		// given point in the program is loosely based on sweet.js' approach.
		// See https://github.com/mozilla/sweet.js/wiki/design
	
		var TokContext = function TokContext(token, isExpr, preserveSpace, override) {
		  classCallCheck(this, TokContext);
	
		  this.token = token;
		  this.isExpr = !!isExpr;
		  this.preserveSpace = !!preserveSpace;
		  this.override = override;
		};
	
		var types$1 = {
		  braceStatement: new TokContext("{", false),
		  braceExpression: new TokContext("{", true),
		  templateQuasi: new TokContext("${", true),
		  parenStatement: new TokContext("(", false),
		  parenExpression: new TokContext("(", true),
		  template: new TokContext("`", true, true, function (p) {
		    return p.readTmplToken();
		  }),
		  functionExpression: new TokContext("function", true)
		};
	
		// Token-specific context update code
	
		types.parenR.updateContext = types.braceR.updateContext = function () {
		  if (this.state.context.length === 1) {
		    this.state.exprAllowed = true;
		    return;
		  }
	
		  var out = this.state.context.pop();
		  if (out === types$1.braceStatement && this.curContext() === types$1.functionExpression) {
		    this.state.context.pop();
		    this.state.exprAllowed = false;
		  } else if (out === types$1.templateQuasi) {
		    this.state.exprAllowed = true;
		  } else {
		    this.state.exprAllowed = !out.isExpr;
		  }
		};
	
		types.name.updateContext = function (prevType) {
		  this.state.exprAllowed = false;
	
		  if (prevType === types._let || prevType === types._const || prevType === types._var) {
		    if (lineBreak.test(this.input.slice(this.state.end))) {
		      this.state.exprAllowed = true;
		    }
		  }
		};
	
		types.braceL.updateContext = function (prevType) {
		  this.state.context.push(this.braceIsBlock(prevType) ? types$1.braceStatement : types$1.braceExpression);
		  this.state.exprAllowed = true;
		};
	
		types.dollarBraceL.updateContext = function () {
		  this.state.context.push(types$1.templateQuasi);
		  this.state.exprAllowed = true;
		};
	
		types.parenL.updateContext = function (prevType) {
		  var statementParens = prevType === types._if || prevType === types._for || prevType === types._with || prevType === types._while;
		  this.state.context.push(statementParens ? types$1.parenStatement : types$1.parenExpression);
		  this.state.exprAllowed = true;
		};
	
		types.incDec.updateContext = function () {
		  // tokExprAllowed stays unchanged
		};
	
		types._function.updateContext = function () {
		  if (this.curContext() !== types$1.braceStatement) {
		    this.state.context.push(types$1.functionExpression);
		  }
	
		  this.state.exprAllowed = false;
		};
	
		types.backQuote.updateContext = function () {
		  if (this.curContext() === types$1.template) {
		    this.state.context.pop();
		  } else {
		    this.state.context.push(types$1.template);
		  }
		  this.state.exprAllowed = false;
		};
	
		// These are used when `options.locations` is on, for the
		// `startLoc` and `endLoc` properties.
	
		var Position = function Position(line, col) {
		  classCallCheck(this, Position);
	
		  this.line = line;
		  this.column = col;
		};
	
		var SourceLocation = function SourceLocation(start, end) {
		  classCallCheck(this, SourceLocation);
	
		  this.start = start;
		  this.end = end;
		};
	
		// The `getLineInfo` function is mostly useful when the
		// `locations` option is off (for performance reasons) and you
		// want to find the line/column position for a given character
		// offset. `input` should be the code string that the offset refers
		// into.
	
		function getLineInfo(input, offset) {
		  for (var line = 1, cur = 0;;) {
		    lineBreakG.lastIndex = cur;
		    var match = lineBreakG.exec(input);
		    if (match && match.index < offset) {
		      ++line;
		      cur = match.index + match[0].length;
		    } else {
		      return new Position(line, offset - cur);
		    }
		  }
		}
	
		var State = function () {
		  function State() {
		    classCallCheck(this, State);
		  }
	
		  State.prototype.init = function init(options, input) {
		    this.strict = options.strictMode === false ? false : options.sourceType === "module";
	
		    this.input = input;
	
		    this.potentialArrowAt = -1;
	
		    this.inMethod = this.inFunction = this.inGenerator = this.inAsync = this.inPropertyName = this.inType = this.inClassProperty = this.noAnonFunctionType = false;
	
		    this.labels = [];
	
		    this.decorators = [];
	
		    this.tokens = [];
	
		    this.comments = [];
	
		    this.trailingComments = [];
		    this.leadingComments = [];
		    this.commentStack = [];
	
		    this.pos = this.lineStart = 0;
		    this.curLine = options.startLine;
	
		    this.type = types.eof;
		    this.value = null;
		    this.start = this.end = this.pos;
		    this.startLoc = this.endLoc = this.curPosition();
	
		    this.lastTokEndLoc = this.lastTokStartLoc = null;
		    this.lastTokStart = this.lastTokEnd = this.pos;
	
		    this.context = [types$1.braceStatement];
		    this.exprAllowed = true;
	
		    this.containsEsc = this.containsOctal = false;
		    this.octalPosition = null;
	
		    this.invalidTemplateEscapePosition = null;
	
		    this.exportedIdentifiers = [];
	
		    return this;
		  };
	
		  // TODO
	
	
		  // TODO
	
	
		  // Used to signify the start of a potential arrow function
	
	
		  // Flags to track whether we are in a function, a generator.
	
	
		  // Labels in scope.
	
	
		  // Leading decorators.
	
	
		  // Token store.
	
	
		  // Comment store.
	
	
		  // Comment attachment store
	
	
		  // The current position of the tokenizer in the input.
	
	
		  // Properties of the current token:
		  // Its type
	
	
		  // For tokens that include more information than their type, the value
	
	
		  // Its start and end offset
	
	
		  // And, if locations are used, the {line, column} object
		  // corresponding to those offsets
	
	
		  // Position information for the previous token
	
	
		  // The context stack is used to superficially track syntactic
		  // context to predict whether a regular expression is allowed in a
		  // given position.
	
	
		  // Used to signal to callers of `readWord1` whether the word
		  // contained any escape sequences. This is needed because words with
		  // escape sequences must not be interpreted as keywords.
	
	
		  // TODO
	
	
		  // Names of exports store. `default` is stored as a name for both
		  // `export default foo;` and `export { foo as default };`.
	
	
		  State.prototype.curPosition = function curPosition() {
		    return new Position(this.curLine, this.pos - this.lineStart);
		  };
	
		  State.prototype.clone = function clone(skipArrays) {
		    var state = new State();
		    for (var key in this) {
		      var val = this[key];
	
		      if ((!skipArrays || key === "context") && Array.isArray(val)) {
		        val = val.slice();
		      }
	
		      state[key] = val;
		    }
		    return state;
		  };
	
		  return State;
		}();
	
		// Object type used to represent tokens. Note that normally, tokens
		// simply exist as properties on the parser object. This is only
		// used for the onToken callback and the external tokenizer.
	
		var Token = function Token(state) {
		  classCallCheck(this, Token);
	
		  this.type = state.type;
		  this.value = state.value;
		  this.start = state.start;
		  this.end = state.end;
		  this.loc = new SourceLocation(state.startLoc, state.endLoc);
		};
	
		// ## Tokenizer
	
		function codePointToString(code) {
		  // UTF-16 Decoding
		  if (code <= 0xFFFF) {
		    return String.fromCharCode(code);
		  } else {
		    return String.fromCharCode((code - 0x10000 >> 10) + 0xD800, (code - 0x10000 & 1023) + 0xDC00);
		  }
		}
	
		var Tokenizer = function () {
		  function Tokenizer(options, input) {
		    classCallCheck(this, Tokenizer);
	
		    this.state = new State();
		    this.state.init(options, input);
		  }
	
		  // Move to the next token
	
		  Tokenizer.prototype.next = function next() {
		    if (!this.isLookahead) {
		      this.state.tokens.push(new Token(this.state));
		    }
	
		    this.state.lastTokEnd = this.state.end;
		    this.state.lastTokStart = this.state.start;
		    this.state.lastTokEndLoc = this.state.endLoc;
		    this.state.lastTokStartLoc = this.state.startLoc;
		    this.nextToken();
		  };
	
		  // TODO
	
		  Tokenizer.prototype.eat = function eat(type) {
		    if (this.match(type)) {
		      this.next();
		      return true;
		    } else {
		      return false;
		    }
		  };
	
		  // TODO
	
		  Tokenizer.prototype.match = function match(type) {
		    return this.state.type === type;
		  };
	
		  // TODO
	
		  Tokenizer.prototype.isKeyword = function isKeyword$$1(word) {
		    return isKeyword(word);
		  };
	
		  // TODO
	
		  Tokenizer.prototype.lookahead = function lookahead() {
		    var old = this.state;
		    this.state = old.clone(true);
	
		    this.isLookahead = true;
		    this.next();
		    this.isLookahead = false;
	
		    var curr = this.state.clone(true);
		    this.state = old;
		    return curr;
		  };
	
		  // Toggle strict mode. Re-reads the next number or string to please
		  // pedantic tests (`"use strict"; 010;` should fail).
	
		  Tokenizer.prototype.setStrict = function setStrict(strict) {
		    this.state.strict = strict;
		    if (!this.match(types.num) && !this.match(types.string)) return;
		    this.state.pos = this.state.start;
		    while (this.state.pos < this.state.lineStart) {
		      this.state.lineStart = this.input.lastIndexOf("\n", this.state.lineStart - 2) + 1;
		      --this.state.curLine;
		    }
		    this.nextToken();
		  };
	
		  Tokenizer.prototype.curContext = function curContext() {
		    return this.state.context[this.state.context.length - 1];
		  };
	
		  // Read a single token, updating the parser object's token-related
		  // properties.
	
		  Tokenizer.prototype.nextToken = function nextToken() {
		    var curContext = this.curContext();
		    if (!curContext || !curContext.preserveSpace) this.skipSpace();
	
		    this.state.containsOctal = false;
		    this.state.octalPosition = null;
		    this.state.start = this.state.pos;
		    this.state.startLoc = this.state.curPosition();
		    if (this.state.pos >= this.input.length) return this.finishToken(types.eof);
	
		    if (curContext.override) {
		      return curContext.override(this);
		    } else {
		      return this.readToken(this.fullCharCodeAtPos());
		    }
		  };
	
		  Tokenizer.prototype.readToken = function readToken(code) {
		    // Identifier or keyword. '\uXXXX' sequences are allowed in
		    // identifiers, so '\' also dispatches to that.
		    if (isIdentifierStart(code) || code === 92 /* '\' */) {
		        return this.readWord();
		      } else {
		      return this.getTokenFromCode(code);
		    }
		  };
	
		  Tokenizer.prototype.fullCharCodeAtPos = function fullCharCodeAtPos() {
		    var code = this.input.charCodeAt(this.state.pos);
		    if (code <= 0xd7ff || code >= 0xe000) return code;
	
		    var next = this.input.charCodeAt(this.state.pos + 1);
		    return (code << 10) + next - 0x35fdc00;
		  };
	
		  Tokenizer.prototype.pushComment = function pushComment(block, text, start, end, startLoc, endLoc) {
		    var comment = {
		      type: block ? "CommentBlock" : "CommentLine",
		      value: text,
		      start: start,
		      end: end,
		      loc: new SourceLocation(startLoc, endLoc)
		    };
	
		    if (!this.isLookahead) {
		      this.state.tokens.push(comment);
		      this.state.comments.push(comment);
		      this.addComment(comment);
		    }
		  };
	
		  Tokenizer.prototype.skipBlockComment = function skipBlockComment() {
		    var startLoc = this.state.curPosition();
		    var start = this.state.pos;
		    var end = this.input.indexOf("*/", this.state.pos += 2);
		    if (end === -1) this.raise(this.state.pos - 2, "Unterminated comment");
	
		    this.state.pos = end + 2;
		    lineBreakG.lastIndex = start;
		    var match = void 0;
		    while ((match = lineBreakG.exec(this.input)) && match.index < this.state.pos) {
		      ++this.state.curLine;
		      this.state.lineStart = match.index + match[0].length;
		    }
	
		    this.pushComment(true, this.input.slice(start + 2, end), start, this.state.pos, startLoc, this.state.curPosition());
		  };
	
		  Tokenizer.prototype.skipLineComment = function skipLineComment(startSkip) {
		    var start = this.state.pos;
		    var startLoc = this.state.curPosition();
		    var ch = this.input.charCodeAt(this.state.pos += startSkip);
		    while (this.state.pos < this.input.length && ch !== 10 && ch !== 13 && ch !== 8232 && ch !== 8233) {
		      ++this.state.pos;
		      ch = this.input.charCodeAt(this.state.pos);
		    }
	
		    this.pushComment(false, this.input.slice(start + startSkip, this.state.pos), start, this.state.pos, startLoc, this.state.curPosition());
		  };
	
		  // Called at the start of the parse and after every token. Skips
		  // whitespace and comments, and.
	
		  Tokenizer.prototype.skipSpace = function skipSpace() {
		    loop: while (this.state.pos < this.input.length) {
		      var ch = this.input.charCodeAt(this.state.pos);
		      switch (ch) {
		        case 32:case 160:
		          // ' '
		          ++this.state.pos;
		          break;
	
		        case 13:
		          if (this.input.charCodeAt(this.state.pos + 1) === 10) {
		            ++this.state.pos;
		          }
	
		        case 10:case 8232:case 8233:
		          ++this.state.pos;
		          ++this.state.curLine;
		          this.state.lineStart = this.state.pos;
		          break;
	
		        case 47:
		          // '/'
		          switch (this.input.charCodeAt(this.state.pos + 1)) {
		            case 42:
		              // '*'
		              this.skipBlockComment();
		              break;
	
		            case 47:
		              this.skipLineComment(2);
		              break;
	
		            default:
		              break loop;
		          }
		          break;
	
		        default:
		          if (ch > 8 && ch < 14 || ch >= 5760 && nonASCIIwhitespace.test(String.fromCharCode(ch))) {
		            ++this.state.pos;
		          } else {
		            break loop;
		          }
		      }
		    }
		  };
	
		  // Called at the end of every token. Sets `end`, `val`, and
		  // maintains `context` and `exprAllowed`, and skips the space after
		  // the token, so that the next one's `start` will point at the
		  // right position.
	
		  Tokenizer.prototype.finishToken = function finishToken(type, val) {
		    this.state.end = this.state.pos;
		    this.state.endLoc = this.state.curPosition();
		    var prevType = this.state.type;
		    this.state.type = type;
		    this.state.value = val;
	
		    this.updateContext(prevType);
		  };
	
		  // ### Token reading
	
		  // This is the function that is called to fetch the next token. It
		  // is somewhat obscure, because it works in character codes rather
		  // than characters, and because operator parsing has been inlined
		  // into it.
		  //
		  // All in the name of speed.
		  //
	
	
		  Tokenizer.prototype.readToken_dot = function readToken_dot() {
		    var next = this.input.charCodeAt(this.state.pos + 1);
		    if (next >= 48 && next <= 57) {
		      return this.readNumber(true);
		    }
	
		    var next2 = this.input.charCodeAt(this.state.pos + 2);
		    if (next === 46 && next2 === 46) {
		      // 46 = dot '.'
		      this.state.pos += 3;
		      return this.finishToken(types.ellipsis);
		    } else {
		      ++this.state.pos;
		      return this.finishToken(types.dot);
		    }
		  };
	
		  Tokenizer.prototype.readToken_slash = function readToken_slash() {
		    // '/'
		    if (this.state.exprAllowed) {
		      ++this.state.pos;
		      return this.readRegexp();
		    }
	
		    var next = this.input.charCodeAt(this.state.pos + 1);
		    if (next === 61) {
		      return this.finishOp(types.assign, 2);
		    } else {
		      return this.finishOp(types.slash, 1);
		    }
		  };
	
		  Tokenizer.prototype.readToken_mult_modulo = function readToken_mult_modulo(code) {
		    // '%*'
		    var type = code === 42 ? types.star : types.modulo;
		    var width = 1;
		    var next = this.input.charCodeAt(this.state.pos + 1);
	
		    if (next === 42) {
		      // '*'
		      width++;
		      next = this.input.charCodeAt(this.state.pos + 2);
		      type = types.exponent;
		    }
	
		    if (next === 61) {
		      width++;
		      type = types.assign;
		    }
	
		    return this.finishOp(type, width);
		  };
	
		  Tokenizer.prototype.readToken_pipe_amp = function readToken_pipe_amp(code) {
		    // '|&'
		    var next = this.input.charCodeAt(this.state.pos + 1);
		    if (next === code) return this.finishOp(code === 124 ? types.logicalOR : types.logicalAND, 2);
		    if (next === 61) return this.finishOp(types.assign, 2);
		    if (code === 124 && next === 125 && this.hasPlugin("flow")) return this.finishOp(types.braceBarR, 2);
		    return this.finishOp(code === 124 ? types.bitwiseOR : types.bitwiseAND, 1);
		  };
	
		  Tokenizer.prototype.readToken_caret = function readToken_caret() {
		    // '^'
		    var next = this.input.charCodeAt(this.state.pos + 1);
		    if (next === 61) {
		      return this.finishOp(types.assign, 2);
		    } else {
		      return this.finishOp(types.bitwiseXOR, 1);
		    }
		  };
	
		  Tokenizer.prototype.readToken_plus_min = function readToken_plus_min(code) {
		    // '+-'
		    var next = this.input.charCodeAt(this.state.pos + 1);
	
		    if (next === code) {
		      if (next === 45 && this.input.charCodeAt(this.state.pos + 2) === 62 && lineBreak.test(this.input.slice(this.state.lastTokEnd, this.state.pos))) {
		        // A `-->` line comment
		        this.skipLineComment(3);
		        this.skipSpace();
		        return this.nextToken();
		      }
		      return this.finishOp(types.incDec, 2);
		    }
	
		    if (next === 61) {
		      return this.finishOp(types.assign, 2);
		    } else {
		      return this.finishOp(types.plusMin, 1);
		    }
		  };
	
		  Tokenizer.prototype.readToken_lt_gt = function readToken_lt_gt(code) {
		    // '<>'
		    var next = this.input.charCodeAt(this.state.pos + 1);
		    var size = 1;
	
		    if (next === code) {
		      size = code === 62 && this.input.charCodeAt(this.state.pos + 2) === 62 ? 3 : 2;
		      if (this.input.charCodeAt(this.state.pos + size) === 61) return this.finishOp(types.assign, size + 1);
		      return this.finishOp(types.bitShift, size);
		    }
	
		    if (next === 33 && code === 60 && this.input.charCodeAt(this.state.pos + 2) === 45 && this.input.charCodeAt(this.state.pos + 3) === 45) {
		      if (this.inModule) this.unexpected();
		      // `<!--`, an XML-style comment that should be interpreted as a line comment
		      this.skipLineComment(4);
		      this.skipSpace();
		      return this.nextToken();
		    }
	
		    if (next === 61) {
		      // <= | >=
		      size = 2;
		    }
	
		    return this.finishOp(types.relational, size);
		  };
	
		  Tokenizer.prototype.readToken_eq_excl = function readToken_eq_excl(code) {
		    // '=!'
		    var next = this.input.charCodeAt(this.state.pos + 1);
		    if (next === 61) return this.finishOp(types.equality, this.input.charCodeAt(this.state.pos + 2) === 61 ? 3 : 2);
		    if (code === 61 && next === 62) {
		      // '=>'
		      this.state.pos += 2;
		      return this.finishToken(types.arrow);
		    }
		    return this.finishOp(code === 61 ? types.eq : types.prefix, 1);
		  };
	
		  Tokenizer.prototype.getTokenFromCode = function getTokenFromCode(code) {
		    switch (code) {
		      // The interpretation of a dot depends on whether it is followed
		      // by a digit or another two dots.
		      case 46:
		        // '.'
		        return this.readToken_dot();
	
		      // Punctuation tokens.
		      case 40:
		        ++this.state.pos;return this.finishToken(types.parenL);
		      case 41:
		        ++this.state.pos;return this.finishToken(types.parenR);
		      case 59:
		        ++this.state.pos;return this.finishToken(types.semi);
		      case 44:
		        ++this.state.pos;return this.finishToken(types.comma);
		      case 91:
		        ++this.state.pos;return this.finishToken(types.bracketL);
		      case 93:
		        ++this.state.pos;return this.finishToken(types.bracketR);
	
		      case 123:
		        if (this.hasPlugin("flow") && this.input.charCodeAt(this.state.pos + 1) === 124) {
		          return this.finishOp(types.braceBarL, 2);
		        } else {
		          ++this.state.pos;
		          return this.finishToken(types.braceL);
		        }
	
		      case 125:
		        ++this.state.pos;return this.finishToken(types.braceR);
	
		      case 58:
		        if (this.hasPlugin("functionBind") && this.input.charCodeAt(this.state.pos + 1) === 58) {
		          return this.finishOp(types.doubleColon, 2);
		        } else {
		          ++this.state.pos;
		          return this.finishToken(types.colon);
		        }
	
		      case 63:
		        ++this.state.pos;return this.finishToken(types.question);
		      case 64:
		        ++this.state.pos;return this.finishToken(types.at);
	
		      case 96:
		        // '`'
		        ++this.state.pos;
		        return this.finishToken(types.backQuote);
	
		      case 48:
		        // '0'
		        var next = this.input.charCodeAt(this.state.pos + 1);
		        if (next === 120 || next === 88) return this.readRadixNumber(16); // '0x', '0X' - hex number
		        if (next === 111 || next === 79) return this.readRadixNumber(8); // '0o', '0O' - octal number
		        if (next === 98 || next === 66) return this.readRadixNumber(2); // '0b', '0B' - binary number
		      // Anything else beginning with a digit is an integer, octal
		      // number, or float.
		      case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:
		        // 1-9
		        return this.readNumber(false);
	
		      // Quotes produce strings.
		      case 34:case 39:
		        // '"', "'"
		        return this.readString(code);
	
		      // Operators are parsed inline in tiny state machines. '=' (61) is
		      // often referred to. `finishOp` simply skips the amount of
		      // characters it is given as second argument, and returns a token
		      // of the type given by its first argument.
	
		      case 47:
		        // '/'
		        return this.readToken_slash();
	
		      case 37:case 42:
		        // '%*'
		        return this.readToken_mult_modulo(code);
	
		      case 124:case 38:
		        // '|&'
		        return this.readToken_pipe_amp(code);
	
		      case 94:
		        // '^'
		        return this.readToken_caret();
	
		      case 43:case 45:
		        // '+-'
		        return this.readToken_plus_min(code);
	
		      case 60:case 62:
		        // '<>'
		        return this.readToken_lt_gt(code);
	
		      case 61:case 33:
		        // '=!'
		        return this.readToken_eq_excl(code);
	
		      case 126:
		        // '~'
		        return this.finishOp(types.prefix, 1);
		    }
	
		    this.raise(this.state.pos, "Unexpected character '" + codePointToString(code) + "'");
		  };
	
		  Tokenizer.prototype.finishOp = function finishOp(type, size) {
		    var str = this.input.slice(this.state.pos, this.state.pos + size);
		    this.state.pos += size;
		    return this.finishToken(type, str);
		  };
	
		  Tokenizer.prototype.readRegexp = function readRegexp() {
		    var start = this.state.pos;
		    var escaped = void 0,
		        inClass = void 0;
		    for (;;) {
		      if (this.state.pos >= this.input.length) this.raise(start, "Unterminated regular expression");
		      var ch = this.input.charAt(this.state.pos);
		      if (lineBreak.test(ch)) {
		        this.raise(start, "Unterminated regular expression");
		      }
		      if (escaped) {
		        escaped = false;
		      } else {
		        if (ch === "[") {
		          inClass = true;
		        } else if (ch === "]" && inClass) {
		          inClass = false;
		        } else if (ch === "/" && !inClass) {
		          break;
		        }
		        escaped = ch === "\\";
		      }
		      ++this.state.pos;
		    }
		    var content = this.input.slice(start, this.state.pos);
		    ++this.state.pos;
		    // Need to use `readWord1` because '\uXXXX' sequences are allowed
		    // here (don't ask).
		    var mods = this.readWord1();
		    if (mods) {
		      var validFlags = /^[gmsiyu]*$/;
		      if (!validFlags.test(mods)) this.raise(start, "Invalid regular expression flag");
		    }
		    return this.finishToken(types.regexp, {
		      pattern: content,
		      flags: mods
		    });
		  };
	
		  // Read an integer in the given radix. Return null if zero digits
		  // were read, the integer value otherwise. When `len` is given, this
		  // will return `null` unless the integer has exactly `len` digits.
	
		  Tokenizer.prototype.readInt = function readInt(radix, len) {
		    var start = this.state.pos;
		    var total = 0;
	
		    for (var i = 0, e = len == null ? Infinity : len; i < e; ++i) {
		      var code = this.input.charCodeAt(this.state.pos);
		      var val = void 0;
		      if (code >= 97) {
		        val = code - 97 + 10; // a
		      } else if (code >= 65) {
		        val = code - 65 + 10; // A
		      } else if (code >= 48 && code <= 57) {
		        val = code - 48; // 0-9
		      } else {
		        val = Infinity;
		      }
		      if (val >= radix) break;
		      ++this.state.pos;
		      total = total * radix + val;
		    }
		    if (this.state.pos === start || len != null && this.state.pos - start !== len) return null;
	
		    return total;
		  };
	
		  Tokenizer.prototype.readRadixNumber = function readRadixNumber(radix) {
		    this.state.pos += 2; // 0x
		    var val = this.readInt(radix);
		    if (val == null) this.raise(this.state.start + 2, "Expected number in radix " + radix);
		    if (isIdentifierStart(this.fullCharCodeAtPos())) this.raise(this.state.pos, "Identifier directly after number");
		    return this.finishToken(types.num, val);
		  };
	
		  // Read an integer, octal integer, or floating-point number.
	
		  Tokenizer.prototype.readNumber = function readNumber(startsWithDot) {
		    var start = this.state.pos;
		    var octal = this.input.charCodeAt(start) === 48; // '0'
		    var isFloat = false;
	
		    if (!startsWithDot && this.readInt(10) === null) this.raise(start, "Invalid number");
		    if (octal && this.state.pos == start + 1) octal = false; // number === 0
	
		    var next = this.input.charCodeAt(this.state.pos);
		    if (next === 46 && !octal) {
		      // '.'
		      ++this.state.pos;
		      this.readInt(10);
		      isFloat = true;
		      next = this.input.charCodeAt(this.state.pos);
		    }
	
		    if ((next === 69 || next === 101) && !octal) {
		      // 'eE'
		      next = this.input.charCodeAt(++this.state.pos);
		      if (next === 43 || next === 45) ++this.state.pos; // '+-'
		      if (this.readInt(10) === null) this.raise(start, "Invalid number");
		      isFloat = true;
		    }
	
		    if (isIdentifierStart(this.fullCharCodeAtPos())) this.raise(this.state.pos, "Identifier directly after number");
	
		    var str = this.input.slice(start, this.state.pos);
		    var val = void 0;
		    if (isFloat) {
		      val = parseFloat(str);
		    } else if (!octal || str.length === 1) {
		      val = parseInt(str, 10);
		    } else if (this.state.strict) {
		      this.raise(start, "Invalid number");
		    } else if (/[89]/.test(str)) {
		      val = parseInt(str, 10);
		    } else {
		      val = parseInt(str, 8);
		    }
		    return this.finishToken(types.num, val);
		  };
	
		  // Read a string value, interpreting backslash-escapes.
	
		  Tokenizer.prototype.readCodePoint = function readCodePoint(throwOnInvalid) {
		    var ch = this.input.charCodeAt(this.state.pos);
		    var code = void 0;
	
		    if (ch === 123) {
		      // '{'
		      var codePos = ++this.state.pos;
		      code = this.readHexChar(this.input.indexOf("}", this.state.pos) - this.state.pos, throwOnInvalid);
		      ++this.state.pos;
		      if (code === null) {
		        --this.state.invalidTemplateEscapePosition; // to point to the '\'' instead of the 'u'
		      } else if (code > 0x10FFFF) {
		        if (throwOnInvalid) {
		          this.raise(codePos, "Code point out of bounds");
		        } else {
		          this.state.invalidTemplateEscapePosition = codePos - 2;
		          return null;
		        }
		      }
		    } else {
		      code = this.readHexChar(4, throwOnInvalid);
		    }
		    return code;
		  };
	
		  Tokenizer.prototype.readString = function readString(quote) {
		    var out = "",
		        chunkStart = ++this.state.pos;
		    for (;;) {
		      if (this.state.pos >= this.input.length) this.raise(this.state.start, "Unterminated string constant");
		      var ch = this.input.charCodeAt(this.state.pos);
		      if (ch === quote) break;
		      if (ch === 92) {
		        // '\'
		        out += this.input.slice(chunkStart, this.state.pos);
		        out += this.readEscapedChar(false);
		        chunkStart = this.state.pos;
		      } else {
		        if (isNewLine(ch)) this.raise(this.state.start, "Unterminated string constant");
		        ++this.state.pos;
		      }
		    }
		    out += this.input.slice(chunkStart, this.state.pos++);
		    return this.finishToken(types.string, out);
		  };
	
		  // Reads template string tokens.
	
		  Tokenizer.prototype.readTmplToken = function readTmplToken() {
		    var out = "",
		        chunkStart = this.state.pos,
		        containsInvalid = false;
		    for (;;) {
		      if (this.state.pos >= this.input.length) this.raise(this.state.start, "Unterminated template");
		      var ch = this.input.charCodeAt(this.state.pos);
		      if (ch === 96 || ch === 36 && this.input.charCodeAt(this.state.pos + 1) === 123) {
		        // '`', '${'
		        if (this.state.pos === this.state.start && this.match(types.template)) {
		          if (ch === 36) {
		            this.state.pos += 2;
		            return this.finishToken(types.dollarBraceL);
		          } else {
		            ++this.state.pos;
		            return this.finishToken(types.backQuote);
		          }
		        }
		        out += this.input.slice(chunkStart, this.state.pos);
		        return this.finishToken(types.template, containsInvalid ? null : out);
		      }
		      if (ch === 92) {
		        // '\'
		        out += this.input.slice(chunkStart, this.state.pos);
		        var escaped = this.readEscapedChar(true);
		        if (escaped === null) {
		          containsInvalid = true;
		        } else {
		          out += escaped;
		        }
		        chunkStart = this.state.pos;
		      } else if (isNewLine(ch)) {
		        out += this.input.slice(chunkStart, this.state.pos);
		        ++this.state.pos;
		        switch (ch) {
		          case 13:
		            if (this.input.charCodeAt(this.state.pos) === 10) ++this.state.pos;
		          case 10:
		            out += "\n";
		            break;
		          default:
		            out += String.fromCharCode(ch);
		            break;
		        }
		        ++this.state.curLine;
		        this.state.lineStart = this.state.pos;
		        chunkStart = this.state.pos;
		      } else {
		        ++this.state.pos;
		      }
		    }
		  };
	
		  // Used to read escaped characters
	
		  Tokenizer.prototype.readEscapedChar = function readEscapedChar(inTemplate) {
		    var throwOnInvalid = !inTemplate;
		    var ch = this.input.charCodeAt(++this.state.pos);
		    ++this.state.pos;
		    switch (ch) {
		      case 110:
		        return "\n"; // 'n' -> '\n'
		      case 114:
		        return "\r"; // 'r' -> '\r'
		      case 120:
		        {
		          // 'x'
		          var code = this.readHexChar(2, throwOnInvalid);
		          return code === null ? null : String.fromCharCode(code);
		        }
		      case 117:
		        {
		          // 'u'
		          var _code = this.readCodePoint(throwOnInvalid);
		          return _code === null ? null : codePointToString(_code);
		        }
		      case 116:
		        return "\t"; // 't' -> '\t'
		      case 98:
		        return "\b"; // 'b' -> '\b'
		      case 118:
		        return "\x0B"; // 'v' -> '\u000b'
		      case 102:
		        return "\f"; // 'f' -> '\f'
		      case 13:
		        if (this.input.charCodeAt(this.state.pos) === 10) ++this.state.pos; // '\r\n'
		      case 10:
		        // ' \n'
		        this.state.lineStart = this.state.pos;
		        ++this.state.curLine;
		        return "";
		      default:
		        if (ch >= 48 && ch <= 55) {
		          var codePos = this.state.pos - 1;
		          var octalStr = this.input.substr(this.state.pos - 1, 3).match(/^[0-7]+/)[0];
		          var octal = parseInt(octalStr, 8);
		          if (octal > 255) {
		            octalStr = octalStr.slice(0, -1);
		            octal = parseInt(octalStr, 8);
		          }
		          if (octal > 0) {
		            if (inTemplate) {
		              this.state.invalidTemplateEscapePosition = codePos;
		              return null;
		            } else if (this.state.strict) {
		              this.raise(codePos, "Octal literal in strict mode");
		            } else if (!this.state.containsOctal) {
		              // These properties are only used to throw an error for an octal which occurs
		              // in a directive which occurs prior to a "use strict" directive.
		              this.state.containsOctal = true;
		              this.state.octalPosition = codePos;
		            }
		          }
		          this.state.pos += octalStr.length - 1;
		          return String.fromCharCode(octal);
		        }
		        return String.fromCharCode(ch);
		    }
		  };
	
		  // Used to read character escape sequences ('\x', '\u').
	
		  Tokenizer.prototype.readHexChar = function readHexChar(len, throwOnInvalid) {
		    var codePos = this.state.pos;
		    var n = this.readInt(16, len);
		    if (n === null) {
		      if (throwOnInvalid) {
		        this.raise(codePos, "Bad character escape sequence");
		      } else {
		        this.state.pos = codePos - 1;
		        this.state.invalidTemplateEscapePosition = codePos - 1;
		      }
		    }
		    return n;
		  };
	
		  // Read an identifier, and return it as a string. Sets `this.state.containsEsc`
		  // to whether the word contained a '\u' escape.
		  //
		  // Incrementally adds only escaped chars, adding other chunks as-is
		  // as a micro-optimization.
	
		  Tokenizer.prototype.readWord1 = function readWord1() {
		    this.state.containsEsc = false;
		    var word = "",
		        first = true,
		        chunkStart = this.state.pos;
		    while (this.state.pos < this.input.length) {
		      var ch = this.fullCharCodeAtPos();
		      if (isIdentifierChar(ch)) {
		        this.state.pos += ch <= 0xffff ? 1 : 2;
		      } else if (ch === 92) {
		        // "\"
		        this.state.containsEsc = true;
	
		        word += this.input.slice(chunkStart, this.state.pos);
		        var escStart = this.state.pos;
	
		        if (this.input.charCodeAt(++this.state.pos) !== 117) {
		          // "u"
		          this.raise(this.state.pos, 'Expecting Unicode escape sequence \\uXXXX');
		        }
	
		        ++this.state.pos;
		        var esc = this.readCodePoint(true);
		        if (!(first ? isIdentifierStart : isIdentifierChar)(esc, true)) {
		          this.raise(escStart, "Invalid Unicode escape");
		        }
	
		        word += codePointToString(esc);
		        chunkStart = this.state.pos;
		      } else {
		        break;
		      }
		      first = false;
		    }
		    return word + this.input.slice(chunkStart, this.state.pos);
		  };
	
		  // Read an identifier or keyword token. Will check for reserved
		  // words when necessary.
	
		  Tokenizer.prototype.readWord = function readWord() {
		    var word = this.readWord1();
		    var type = types.name;
		    if (!this.state.containsEsc && this.isKeyword(word)) {
		      type = keywords[word];
		    }
		    return this.finishToken(type, word);
		  };
	
		  Tokenizer.prototype.braceIsBlock = function braceIsBlock(prevType) {
		    if (prevType === types.colon) {
		      var parent = this.curContext();
		      if (parent === types$1.braceStatement || parent === types$1.braceExpression) {
		        return !parent.isExpr;
		      }
		    }
	
		    if (prevType === types._return) {
		      return lineBreak.test(this.input.slice(this.state.lastTokEnd, this.state.start));
		    }
	
		    if (prevType === types._else || prevType === types.semi || prevType === types.eof || prevType === types.parenR) {
		      return true;
		    }
	
		    if (prevType === types.braceL) {
		      return this.curContext() === types$1.braceStatement;
		    }
	
		    return !this.state.exprAllowed;
		  };
	
		  Tokenizer.prototype.updateContext = function updateContext(prevType) {
		    var type = this.state.type;
		    var update = void 0;
	
		    if (type.keyword && prevType === types.dot) {
		      this.state.exprAllowed = false;
		    } else if (update = type.updateContext) {
		      update.call(this, prevType);
		    } else {
		      this.state.exprAllowed = type.beforeExpr;
		    }
		  };
	
		  return Tokenizer;
		}();
	
		var plugins = {};
		var frozenDeprecatedWildcardPluginList = ["jsx", "doExpressions", "objectRestSpread", "decorators", "classProperties", "exportExtensions", "asyncGenerators", "functionBind", "functionSent", "dynamicImport", "flow"];
	
		var Parser = function (_Tokenizer) {
		  inherits(Parser, _Tokenizer);
	
		  function Parser(options, input) {
		    classCallCheck(this, Parser);
	
		    options = getOptions(options);
	
		    var _this = possibleConstructorReturn(this, _Tokenizer.call(this, options, input));
	
		    _this.options = options;
		    _this.inModule = _this.options.sourceType === "module";
		    _this.input = input;
		    _this.plugins = _this.loadPlugins(_this.options.plugins);
		    _this.filename = options.sourceFilename;
	
		    // If enabled, skip leading hashbang line.
		    if (_this.state.pos === 0 && _this.input[0] === "#" && _this.input[1] === "!") {
		      _this.skipLineComment(2);
		    }
		    return _this;
		  }
	
		  Parser.prototype.isReservedWord = function isReservedWord(word) {
		    if (word === "await") {
		      return this.inModule;
		    } else {
		      return reservedWords[6](word);
		    }
		  };
	
		  Parser.prototype.hasPlugin = function hasPlugin(name) {
		    if (this.plugins["*"] && frozenDeprecatedWildcardPluginList.indexOf(name) > -1) {
		      return true;
		    }
	
		    return !!this.plugins[name];
		  };
	
		  Parser.prototype.extend = function extend(name, f) {
		    this[name] = f(this[name]);
		  };
	
		  Parser.prototype.loadAllPlugins = function loadAllPlugins() {
		    var _this2 = this;
	
		    // ensure flow plugin loads last, also ensure estree is not loaded with *
		    var pluginNames = Object.keys(plugins).filter(function (name) {
		      return name !== "flow" && name !== "estree";
		    });
		    pluginNames.push("flow");
	
		    pluginNames.forEach(function (name) {
		      var plugin = plugins[name];
		      if (plugin) plugin(_this2);
		    });
		  };
	
		  Parser.prototype.loadPlugins = function loadPlugins(pluginList) {
		    // TODO: Deprecate "*" option in next major version of Babylon
		    if (pluginList.indexOf("*") >= 0) {
		      this.loadAllPlugins();
	
		      return { "*": true };
		    }
	
		    var pluginMap = {};
	
		    if (pluginList.indexOf("flow") >= 0) {
		      // ensure flow plugin loads last
		      pluginList = pluginList.filter(function (plugin) {
		        return plugin !== "flow";
		      });
		      pluginList.push("flow");
		    }
	
		    if (pluginList.indexOf("estree") >= 0) {
		      // ensure estree plugin loads first
		      pluginList = pluginList.filter(function (plugin) {
		        return plugin !== "estree";
		      });
		      pluginList.unshift("estree");
		    }
	
		    for (var _iterator = pluginList, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var name = _ref;
	
		      if (!pluginMap[name]) {
		        pluginMap[name] = true;
	
		        var plugin = plugins[name];
		        if (plugin) plugin(this);
		      }
		    }
	
		    return pluginMap;
		  };
	
		  Parser.prototype.parse = function parse() {
		    var file = this.startNode();
		    var program = this.startNode();
		    this.nextToken();
		    return this.parseTopLevel(file, program);
		  };
	
		  return Parser;
		}(Tokenizer);
	
		var pp = Parser.prototype;
	
		// ## Parser utilities
	
		// TODO
	
		pp.addExtra = function (node, key, val) {
		  if (!node) return;
	
		  var extra = node.extra = node.extra || {};
		  extra[key] = val;
		};
	
		// TODO
	
		pp.isRelational = function (op) {
		  return this.match(types.relational) && this.state.value === op;
		};
	
		// TODO
	
		pp.expectRelational = function (op) {
		  if (this.isRelational(op)) {
		    this.next();
		  } else {
		    this.unexpected(null, types.relational);
		  }
		};
	
		// Tests whether parsed token is a contextual keyword.
	
		pp.isContextual = function (name) {
		  return this.match(types.name) && this.state.value === name;
		};
	
		// Consumes contextual keyword if possible.
	
		pp.eatContextual = function (name) {
		  return this.state.value === name && this.eat(types.name);
		};
	
		// Asserts that following token is given contextual keyword.
	
		pp.expectContextual = function (name, message) {
		  if (!this.eatContextual(name)) this.unexpected(null, message);
		};
	
		// Test whether a semicolon can be inserted at the current position.
	
		pp.canInsertSemicolon = function () {
		  return this.match(types.eof) || this.match(types.braceR) || lineBreak.test(this.input.slice(this.state.lastTokEnd, this.state.start));
		};
	
		// TODO
	
		pp.isLineTerminator = function () {
		  return this.eat(types.semi) || this.canInsertSemicolon();
		};
	
		// Consume a semicolon, or, failing that, see if we are allowed to
		// pretend that there is a semicolon at this position.
	
		pp.semicolon = function () {
		  if (!this.isLineTerminator()) this.unexpected(null, types.semi);
		};
	
		// Expect a token of a given type. If found, consume it, otherwise,
		// raise an unexpected token error at given pos.
	
		pp.expect = function (type, pos) {
		  return this.eat(type) || this.unexpected(pos, type);
		};
	
		// Raise an unexpected token error. Can take the expected token type
		// instead of a message string.
	
		pp.unexpected = function (pos) {
		  var messageOrType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Unexpected token";
	
		  if (messageOrType && (typeof messageOrType === "undefined" ? "undefined" : _typeof(messageOrType)) === "object" && messageOrType.label) {
		    messageOrType = "Unexpected token, expected " + messageOrType.label;
		  }
		  this.raise(pos != null ? pos : this.state.start, messageOrType);
		};
	
		/* eslint max-len: 0 */
	
		var pp$1 = Parser.prototype;
	
		// ### Statement parsing
	
		// Parse a program. Initializes the parser, reads any number of
		// statements, and wraps them in a Program node.  Optionally takes a
		// `program` argument.  If present, the statements will be appended
		// to its body instead of creating a new node.
	
		pp$1.parseTopLevel = function (file, program) {
		  program.sourceType = this.options.sourceType;
	
		  this.parseBlockBody(program, true, true, types.eof);
	
		  file.program = this.finishNode(program, "Program");
		  file.comments = this.state.comments;
		  file.tokens = this.state.tokens;
	
		  return this.finishNode(file, "File");
		};
	
		var loopLabel = { kind: "loop" };
		var switchLabel = { kind: "switch" };
	
		// TODO
	
		pp$1.stmtToDirective = function (stmt) {
		  var expr = stmt.expression;
	
		  var directiveLiteral = this.startNodeAt(expr.start, expr.loc.start);
		  var directive = this.startNodeAt(stmt.start, stmt.loc.start);
	
		  var raw = this.input.slice(expr.start, expr.end);
		  var val = directiveLiteral.value = raw.slice(1, -1); // remove quotes
	
		  this.addExtra(directiveLiteral, "raw", raw);
		  this.addExtra(directiveLiteral, "rawValue", val);
	
		  directive.value = this.finishNodeAt(directiveLiteral, "DirectiveLiteral", expr.end, expr.loc.end);
	
		  return this.finishNodeAt(directive, "Directive", stmt.end, stmt.loc.end);
		};
	
		// Parse a single statement.
		//
		// If expecting a statement and finding a slash operator, parse a
		// regular expression literal. This is to handle cases like
		// `if (foo) /blah/.exec(foo)`, where looking at the previous token
		// does not help.
	
		pp$1.parseStatement = function (declaration, topLevel) {
		  if (this.match(types.at)) {
		    this.parseDecorators(true);
		  }
	
		  var starttype = this.state.type;
		  var node = this.startNode();
	
		  // Most types of statements are recognized by the keyword they
		  // start with. Many are trivial to parse, some require a bit of
		  // complexity.
	
		  switch (starttype) {
		    case types._break:case types._continue:
		      return this.parseBreakContinueStatement(node, starttype.keyword);
		    case types._debugger:
		      return this.parseDebuggerStatement(node);
		    case types._do:
		      return this.parseDoStatement(node);
		    case types._for:
		      return this.parseForStatement(node);
		    case types._function:
		      if (!declaration) this.unexpected();
		      return this.parseFunctionStatement(node);
	
		    case types._class:
		      if (!declaration) this.unexpected();
		      return this.parseClass(node, true);
	
		    case types._if:
		      return this.parseIfStatement(node);
		    case types._return:
		      return this.parseReturnStatement(node);
		    case types._switch:
		      return this.parseSwitchStatement(node);
		    case types._throw:
		      return this.parseThrowStatement(node);
		    case types._try:
		      return this.parseTryStatement(node);
	
		    case types._let:
		    case types._const:
		      if (!declaration) this.unexpected(); // NOTE: falls through to _var
	
		    case types._var:
		      return this.parseVarStatement(node, starttype);
	
		    case types._while:
		      return this.parseWhileStatement(node);
		    case types._with:
		      return this.parseWithStatement(node);
		    case types.braceL:
		      return this.parseBlock();
		    case types.semi:
		      return this.parseEmptyStatement(node);
		    case types._export:
		    case types._import:
		      if (this.hasPlugin("dynamicImport") && this.lookahead().type === types.parenL) break;
	
		      if (!this.options.allowImportExportEverywhere) {
		        if (!topLevel) {
		          this.raise(this.state.start, "'import' and 'export' may only appear at the top level");
		        }
	
		        if (!this.inModule) {
		          this.raise(this.state.start, "'import' and 'export' may appear only with 'sourceType: \"module\"'");
		        }
		      }
		      return starttype === types._import ? this.parseImport(node) : this.parseExport(node);
	
		    case types.name:
		      if (this.state.value === "async") {
		        // peek ahead and see if next token is a function
		        var state = this.state.clone();
		        this.next();
		        if (this.match(types._function) && !this.canInsertSemicolon()) {
		          this.expect(types._function);
		          return this.parseFunction(node, true, false, true);
		        } else {
		          this.state = state;
		        }
		      }
		  }
	
		  // If the statement does not start with a statement keyword or a
		  // brace, it's an ExpressionStatement or LabeledStatement. We
		  // simply start parsing an expression, and afterwards, if the
		  // next token is a colon and the expression was a simple
		  // Identifier node, we switch to interpreting it as a label.
		  var maybeName = this.state.value;
		  var expr = this.parseExpression();
	
		  if (starttype === types.name && expr.type === "Identifier" && this.eat(types.colon)) {
		    return this.parseLabeledStatement(node, maybeName, expr);
		  } else {
		    return this.parseExpressionStatement(node, expr);
		  }
		};
	
		pp$1.takeDecorators = function (node) {
		  if (this.state.decorators.length) {
		    node.decorators = this.state.decorators;
		    this.state.decorators = [];
		  }
		};
	
		pp$1.parseDecorators = function (allowExport) {
		  while (this.match(types.at)) {
		    var decorator = this.parseDecorator();
		    this.state.decorators.push(decorator);
		  }
	
		  if (allowExport && this.match(types._export)) {
		    return;
		  }
	
		  if (!this.match(types._class)) {
		    this.raise(this.state.start, "Leading decorators must be attached to a class declaration");
		  }
		};
	
		pp$1.parseDecorator = function () {
		  if (!this.hasPlugin("decorators")) {
		    this.unexpected();
		  }
		  var node = this.startNode();
		  this.next();
		  node.expression = this.parseMaybeAssign();
		  return this.finishNode(node, "Decorator");
		};
	
		pp$1.parseBreakContinueStatement = function (node, keyword) {
		  var isBreak = keyword === "break";
		  this.next();
	
		  if (this.isLineTerminator()) {
		    node.label = null;
		  } else if (!this.match(types.name)) {
		    this.unexpected();
		  } else {
		    node.label = this.parseIdentifier();
		    this.semicolon();
		  }
	
		  // Verify that there is an actual destination to break or
		  // continue to.
		  var i = void 0;
		  for (i = 0; i < this.state.labels.length; ++i) {
		    var lab = this.state.labels[i];
		    if (node.label == null || lab.name === node.label.name) {
		      if (lab.kind != null && (isBreak || lab.kind === "loop")) break;
		      if (node.label && isBreak) break;
		    }
		  }
		  if (i === this.state.labels.length) this.raise(node.start, "Unsyntactic " + keyword);
		  return this.finishNode(node, isBreak ? "BreakStatement" : "ContinueStatement");
		};
	
		pp$1.parseDebuggerStatement = function (node) {
		  this.next();
		  this.semicolon();
		  return this.finishNode(node, "DebuggerStatement");
		};
	
		pp$1.parseDoStatement = function (node) {
		  this.next();
		  this.state.labels.push(loopLabel);
		  node.body = this.parseStatement(false);
		  this.state.labels.pop();
		  this.expect(types._while);
		  node.test = this.parseParenExpression();
		  this.eat(types.semi);
		  return this.finishNode(node, "DoWhileStatement");
		};
	
		// Disambiguating between a `for` and a `for`/`in` or `for`/`of`
		// loop is non-trivial. Basically, we have to parse the init `var`
		// statement or expression, disallowing the `in` operator (see
		// the second parameter to `parseExpression`), and then check
		// whether the next token is `in` or `of`. When there is no init
		// part (semicolon immediately after the opening parenthesis), it
		// is a regular `for` loop.
	
		pp$1.parseForStatement = function (node) {
		  this.next();
		  this.state.labels.push(loopLabel);
	
		  var forAwait = false;
		  if (this.hasPlugin("asyncGenerators") && this.state.inAsync && this.isContextual("await")) {
		    forAwait = true;
		    this.next();
		  }
		  this.expect(types.parenL);
	
		  if (this.match(types.semi)) {
		    if (forAwait) {
		      this.unexpected();
		    }
		    return this.parseFor(node, null);
		  }
	
		  if (this.match(types._var) || this.match(types._let) || this.match(types._const)) {
		    var _init = this.startNode();
		    var varKind = this.state.type;
		    this.next();
		    this.parseVar(_init, true, varKind);
		    this.finishNode(_init, "VariableDeclaration");
	
		    if (this.match(types._in) || this.isContextual("of")) {
		      if (_init.declarations.length === 1 && !_init.declarations[0].init) {
		        return this.parseForIn(node, _init, forAwait);
		      }
		    }
		    if (forAwait) {
		      this.unexpected();
		    }
		    return this.parseFor(node, _init);
		  }
	
		  var refShorthandDefaultPos = { start: 0 };
		  var init = this.parseExpression(true, refShorthandDefaultPos);
		  if (this.match(types._in) || this.isContextual("of")) {
		    var description = this.isContextual("of") ? "for-of statement" : "for-in statement";
		    this.toAssignable(init, undefined, description);
		    this.checkLVal(init, undefined, undefined, description);
		    return this.parseForIn(node, init, forAwait);
		  } else if (refShorthandDefaultPos.start) {
		    this.unexpected(refShorthandDefaultPos.start);
		  }
		  if (forAwait) {
		    this.unexpected();
		  }
		  return this.parseFor(node, init);
		};
	
		pp$1.parseFunctionStatement = function (node) {
		  this.next();
		  return this.parseFunction(node, true);
		};
	
		pp$1.parseIfStatement = function (node) {
		  this.next();
		  node.test = this.parseParenExpression();
		  node.consequent = this.parseStatement(false);
		  node.alternate = this.eat(types._else) ? this.parseStatement(false) : null;
		  return this.finishNode(node, "IfStatement");
		};
	
		pp$1.parseReturnStatement = function (node) {
		  if (!this.state.inFunction && !this.options.allowReturnOutsideFunction) {
		    this.raise(this.state.start, "'return' outside of function");
		  }
	
		  this.next();
	
		  // In `return` (and `break`/`continue`), the keywords with
		  // optional arguments, we eagerly look for a semicolon or the
		  // possibility to insert one.
	
		  if (this.isLineTerminator()) {
		    node.argument = null;
		  } else {
		    node.argument = this.parseExpression();
		    this.semicolon();
		  }
	
		  return this.finishNode(node, "ReturnStatement");
		};
	
		pp$1.parseSwitchStatement = function (node) {
		  this.next();
		  node.discriminant = this.parseParenExpression();
		  node.cases = [];
		  this.expect(types.braceL);
		  this.state.labels.push(switchLabel);
	
		  // Statements under must be grouped (by label) in SwitchCase
		  // nodes. `cur` is used to keep the node that we are currently
		  // adding statements to.
	
		  var cur = void 0;
		  for (var sawDefault; !this.match(types.braceR);) {
		    if (this.match(types._case) || this.match(types._default)) {
		      var isCase = this.match(types._case);
		      if (cur) this.finishNode(cur, "SwitchCase");
		      node.cases.push(cur = this.startNode());
		      cur.consequent = [];
		      this.next();
		      if (isCase) {
		        cur.test = this.parseExpression();
		      } else {
		        if (sawDefault) this.raise(this.state.lastTokStart, "Multiple default clauses");
		        sawDefault = true;
		        cur.test = null;
		      }
		      this.expect(types.colon);
		    } else {
		      if (cur) {
		        cur.consequent.push(this.parseStatement(true));
		      } else {
		        this.unexpected();
		      }
		    }
		  }
		  if (cur) this.finishNode(cur, "SwitchCase");
		  this.next(); // Closing brace
		  this.state.labels.pop();
		  return this.finishNode(node, "SwitchStatement");
		};
	
		pp$1.parseThrowStatement = function (node) {
		  this.next();
		  if (lineBreak.test(this.input.slice(this.state.lastTokEnd, this.state.start))) this.raise(this.state.lastTokEnd, "Illegal newline after throw");
		  node.argument = this.parseExpression();
		  this.semicolon();
		  return this.finishNode(node, "ThrowStatement");
		};
	
		// Reused empty array added for node fields that are always empty.
	
		var empty = [];
	
		pp$1.parseTryStatement = function (node) {
		  this.next();
	
		  node.block = this.parseBlock();
		  node.handler = null;
	
		  if (this.match(types._catch)) {
		    var clause = this.startNode();
		    this.next();
	
		    this.expect(types.parenL);
		    clause.param = this.parseBindingAtom();
		    this.checkLVal(clause.param, true, Object.create(null), "catch clause");
		    this.expect(types.parenR);
	
		    clause.body = this.parseBlock();
		    node.handler = this.finishNode(clause, "CatchClause");
		  }
	
		  node.guardedHandlers = empty;
		  node.finalizer = this.eat(types._finally) ? this.parseBlock() : null;
	
		  if (!node.handler && !node.finalizer) {
		    this.raise(node.start, "Missing catch or finally clause");
		  }
	
		  return this.finishNode(node, "TryStatement");
		};
	
		pp$1.parseVarStatement = function (node, kind) {
		  this.next();
		  this.parseVar(node, false, kind);
		  this.semicolon();
		  return this.finishNode(node, "VariableDeclaration");
		};
	
		pp$1.parseWhileStatement = function (node) {
		  this.next();
		  node.test = this.parseParenExpression();
		  this.state.labels.push(loopLabel);
		  node.body = this.parseStatement(false);
		  this.state.labels.pop();
		  return this.finishNode(node, "WhileStatement");
		};
	
		pp$1.parseWithStatement = function (node) {
		  if (this.state.strict) this.raise(this.state.start, "'with' in strict mode");
		  this.next();
		  node.object = this.parseParenExpression();
		  node.body = this.parseStatement(false);
		  return this.finishNode(node, "WithStatement");
		};
	
		pp$1.parseEmptyStatement = function (node) {
		  this.next();
		  return this.finishNode(node, "EmptyStatement");
		};
	
		pp$1.parseLabeledStatement = function (node, maybeName, expr) {
		  for (var _iterator = this.state.labels, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		    var _ref;
	
		    if (_isArray) {
		      if (_i >= _iterator.length) break;
		      _ref = _iterator[_i++];
		    } else {
		      _i = _iterator.next();
		      if (_i.done) break;
		      _ref = _i.value;
		    }
	
		    var _label = _ref;
	
		    if (_label.name === maybeName) {
		      this.raise(expr.start, "Label '" + maybeName + "' is already declared");
		    }
		  }
	
		  var kind = this.state.type.isLoop ? "loop" : this.match(types._switch) ? "switch" : null;
		  for (var i = this.state.labels.length - 1; i >= 0; i--) {
		    var label = this.state.labels[i];
		    if (label.statementStart === node.start) {
		      label.statementStart = this.state.start;
		      label.kind = kind;
		    } else {
		      break;
		    }
		  }
	
		  this.state.labels.push({ name: maybeName, kind: kind, statementStart: this.state.start });
		  node.body = this.parseStatement(true);
		  this.state.labels.pop();
		  node.label = expr;
		  return this.finishNode(node, "LabeledStatement");
		};
	
		pp$1.parseExpressionStatement = function (node, expr) {
		  node.expression = expr;
		  this.semicolon();
		  return this.finishNode(node, "ExpressionStatement");
		};
	
		// Parse a semicolon-enclosed block of statements, handling `"use
		// strict"` declarations when `allowStrict` is true (used for
		// function bodies).
	
		pp$1.parseBlock = function (allowDirectives) {
		  var node = this.startNode();
		  this.expect(types.braceL);
		  this.parseBlockBody(node, allowDirectives, false, types.braceR);
		  return this.finishNode(node, "BlockStatement");
		};
	
		pp$1.isValidDirective = function (stmt) {
		  return stmt.type === "ExpressionStatement" && stmt.expression.type === "StringLiteral" && !stmt.expression.extra.parenthesized;
		};
	
		pp$1.parseBlockBody = function (node, allowDirectives, topLevel, end) {
		  node.body = [];
		  node.directives = [];
	
		  var parsedNonDirective = false;
		  var oldStrict = void 0;
		  var octalPosition = void 0;
	
		  while (!this.eat(end)) {
		    if (!parsedNonDirective && this.state.containsOctal && !octalPosition) {
		      octalPosition = this.state.octalPosition;
		    }
	
		    var stmt = this.parseStatement(true, topLevel);
	
		    if (allowDirectives && !parsedNonDirective && this.isValidDirective(stmt)) {
		      var directive = this.stmtToDirective(stmt);
		      node.directives.push(directive);
	
		      if (oldStrict === undefined && directive.value.value === "use strict") {
		        oldStrict = this.state.strict;
		        this.setStrict(true);
	
		        if (octalPosition) {
		          this.raise(octalPosition, "Octal literal in strict mode");
		        }
		      }
	
		      continue;
		    }
	
		    parsedNonDirective = true;
		    node.body.push(stmt);
		  }
	
		  if (oldStrict === false) {
		    this.setStrict(false);
		  }
		};
	
		// Parse a regular `for` loop. The disambiguation code in
		// `parseStatement` will already have parsed the init statement or
		// expression.
	
		pp$1.parseFor = function (node, init) {
		  node.init = init;
		  this.expect(types.semi);
		  node.test = this.match(types.semi) ? null : this.parseExpression();
		  this.expect(types.semi);
		  node.update = this.match(types.parenR) ? null : this.parseExpression();
		  this.expect(types.parenR);
		  node.body = this.parseStatement(false);
		  this.state.labels.pop();
		  return this.finishNode(node, "ForStatement");
		};
	
		// Parse a `for`/`in` and `for`/`of` loop, which are almost
		// same from parser's perspective.
	
		pp$1.parseForIn = function (node, init, forAwait) {
		  var type = void 0;
		  if (forAwait) {
		    this.eatContextual("of");
		    type = "ForAwaitStatement";
		  } else {
		    type = this.match(types._in) ? "ForInStatement" : "ForOfStatement";
		    this.next();
		  }
		  node.left = init;
		  node.right = this.parseExpression();
		  this.expect(types.parenR);
		  node.body = this.parseStatement(false);
		  this.state.labels.pop();
		  return this.finishNode(node, type);
		};
	
		// Parse a list of variable declarations.
	
		pp$1.parseVar = function (node, isFor, kind) {
		  node.declarations = [];
		  node.kind = kind.keyword;
		  for (;;) {
		    var decl = this.startNode();
		    this.parseVarHead(decl);
		    if (this.eat(types.eq)) {
		      decl.init = this.parseMaybeAssign(isFor);
		    } else if (kind === types._const && !(this.match(types._in) || this.isContextual("of"))) {
		      this.unexpected();
		    } else if (decl.id.type !== "Identifier" && !(isFor && (this.match(types._in) || this.isContextual("of")))) {
		      this.raise(this.state.lastTokEnd, "Complex binding patterns require an initialization value");
		    } else {
		      decl.init = null;
		    }
		    node.declarations.push(this.finishNode(decl, "VariableDeclarator"));
		    if (!this.eat(types.comma)) break;
		  }
		  return node;
		};
	
		pp$1.parseVarHead = function (decl) {
		  decl.id = this.parseBindingAtom();
		  this.checkLVal(decl.id, true, undefined, "variable declaration");
		};
	
		// Parse a function declaration or literal (depending on the
		// `isStatement` parameter).
	
		pp$1.parseFunction = function (node, isStatement, allowExpressionBody, isAsync, optionalId) {
		  var oldInMethod = this.state.inMethod;
		  this.state.inMethod = false;
	
		  this.initFunction(node, isAsync);
	
		  if (this.match(types.star)) {
		    if (node.async && !this.hasPlugin("asyncGenerators")) {
		      this.unexpected();
		    } else {
		      node.generator = true;
		      this.next();
		    }
		  }
	
		  if (isStatement && !optionalId && !this.match(types.name) && !this.match(types._yield)) {
		    this.unexpected();
		  }
	
		  if (this.match(types.name) || this.match(types._yield)) {
		    node.id = this.parseBindingIdentifier();
		  }
	
		  this.parseFunctionParams(node);
		  this.parseFunctionBody(node, allowExpressionBody);
	
		  this.state.inMethod = oldInMethod;
	
		  return this.finishNode(node, isStatement ? "FunctionDeclaration" : "FunctionExpression");
		};
	
		pp$1.parseFunctionParams = function (node) {
		  this.expect(types.parenL);
		  node.params = this.parseBindingList(types.parenR);
		};
	
		// Parse a class declaration or literal (depending on the
		// `isStatement` parameter).
	
		pp$1.parseClass = function (node, isStatement, optionalId) {
		  this.next();
		  this.takeDecorators(node);
		  this.parseClassId(node, isStatement, optionalId);
		  this.parseClassSuper(node);
		  this.parseClassBody(node);
		  return this.finishNode(node, isStatement ? "ClassDeclaration" : "ClassExpression");
		};
	
		pp$1.isClassProperty = function () {
		  return this.match(types.eq) || this.match(types.semi) || this.match(types.braceR);
		};
	
		pp$1.isClassMethod = function () {
		  return this.match(types.parenL);
		};
	
		pp$1.isNonstaticConstructor = function (method) {
		  return !method.computed && !method.static && (method.key.name === "constructor" || // Identifier
		  method.key.value === "constructor" // Literal
		  );
		};
	
		pp$1.parseClassBody = function (node) {
		  // class bodies are implicitly strict
		  var oldStrict = this.state.strict;
		  this.state.strict = true;
	
		  var hadConstructorCall = false;
		  var hadConstructor = false;
		  var decorators = [];
		  var classBody = this.startNode();
	
		  classBody.body = [];
	
		  this.expect(types.braceL);
	
		  while (!this.eat(types.braceR)) {
		    if (this.eat(types.semi)) {
		      if (decorators.length > 0) {
		        this.raise(this.state.lastTokEnd, "Decorators must not be followed by a semicolon");
		      }
		      continue;
		    }
	
		    if (this.match(types.at)) {
		      decorators.push(this.parseDecorator());
		      continue;
		    }
	
		    var method = this.startNode();
	
		    // steal the decorators if there are any
		    if (decorators.length) {
		      method.decorators = decorators;
		      decorators = [];
		    }
	
		    method.static = false;
		    if (this.match(types.name) && this.state.value === "static") {
		      var key = this.parseIdentifier(true); // eats 'static'
		      if (this.isClassMethod()) {
		        // a method named 'static'
		        method.kind = "method";
		        method.computed = false;
		        method.key = key;
		        this.parseClassMethod(classBody, method, false, false);
		        continue;
		      } else if (this.isClassProperty()) {
		        // a property named 'static'
		        method.computed = false;
		        method.key = key;
		        classBody.body.push(this.parseClassProperty(method));
		        continue;
		      }
		      // otherwise something static
		      method.static = true;
		    }
	
		    if (this.eat(types.star)) {
		      // a generator
		      method.kind = "method";
		      this.parsePropertyName(method);
		      if (this.isNonstaticConstructor(method)) {
		        this.raise(method.key.start, "Constructor can't be a generator");
		      }
		      if (!method.computed && method.static && (method.key.name === "prototype" || method.key.value === "prototype")) {
		        this.raise(method.key.start, "Classes may not have static property named prototype");
		      }
		      this.parseClassMethod(classBody, method, true, false);
		    } else {
		      var isSimple = this.match(types.name);
		      var _key = this.parsePropertyName(method);
		      if (!method.computed && method.static && (method.key.name === "prototype" || method.key.value === "prototype")) {
		        this.raise(method.key.start, "Classes may not have static property named prototype");
		      }
		      if (this.isClassMethod()) {
		        // a normal method
		        if (this.isNonstaticConstructor(method)) {
		          if (hadConstructor) {
		            this.raise(_key.start, "Duplicate constructor in the same class");
		          } else if (method.decorators) {
		            this.raise(method.start, "You can't attach decorators to a class constructor");
		          }
		          hadConstructor = true;
		          method.kind = "constructor";
		        } else {
		          method.kind = "method";
		        }
		        this.parseClassMethod(classBody, method, false, false);
		      } else if (this.isClassProperty()) {
		        // a normal property
		        if (this.isNonstaticConstructor(method)) {
		          this.raise(method.key.start, "Classes may not have a non-static field named 'constructor'");
		        }
		        classBody.body.push(this.parseClassProperty(method));
		      } else if (isSimple && _key.name === "async" && !this.isLineTerminator()) {
		        // an async method
		        var isGenerator = this.hasPlugin("asyncGenerators") && this.eat(types.star);
		        method.kind = "method";
		        this.parsePropertyName(method);
		        if (this.isNonstaticConstructor(method)) {
		          this.raise(method.key.start, "Constructor can't be an async function");
		        }
		        this.parseClassMethod(classBody, method, isGenerator, true);
		      } else if (isSimple && (_key.name === "get" || _key.name === "set") && !(this.isLineTerminator() && this.match(types.star))) {
		        // `get\n*` is an uninitialized property named 'get' followed by a generator.
		        // a getter or setter
		        method.kind = _key.name;
		        this.parsePropertyName(method);
		        if (this.isNonstaticConstructor(method)) {
		          this.raise(method.key.start, "Constructor can't have get/set modifier");
		        }
		        this.parseClassMethod(classBody, method, false, false);
		        this.checkGetterSetterParamCount(method);
		      } else if (this.hasPlugin("classConstructorCall") && isSimple && _key.name === "call" && this.match(types.name) && this.state.value === "constructor") {
		        // a (deprecated) call constructor
		        if (hadConstructorCall) {
		          this.raise(method.start, "Duplicate constructor call in the same class");
		        } else if (method.decorators) {
		          this.raise(method.start, "You can't attach decorators to a class constructor");
		        }
		        hadConstructorCall = true;
		        method.kind = "constructorCall";
		        this.parsePropertyName(method); // consume "constructor" and make it the method's name
		        this.parseClassMethod(classBody, method, false, false);
		      } else if (this.isLineTerminator()) {
		        // an uninitialized class property (due to ASI, since we don't otherwise recognize the next token)
		        if (this.isNonstaticConstructor(method)) {
		          this.raise(method.key.start, "Classes may not have a non-static field named 'constructor'");
		        }
		        classBody.body.push(this.parseClassProperty(method));
		      } else {
		        this.unexpected();
		      }
		    }
		  }
	
		  if (decorators.length) {
		    this.raise(this.state.start, "You have trailing decorators with no method");
		  }
	
		  node.body = this.finishNode(classBody, "ClassBody");
	
		  this.state.strict = oldStrict;
		};
	
		pp$1.parseClassProperty = function (node) {
		  this.state.inClassProperty = true;
		  if (this.match(types.eq)) {
		    if (!this.hasPlugin("classProperties")) this.unexpected();
		    this.next();
		    node.value = this.parseMaybeAssign();
		  } else {
		    node.value = null;
		  }
		  this.semicolon();
		  this.state.inClassProperty = false;
		  return this.finishNode(node, "ClassProperty");
		};
	
		pp$1.parseClassMethod = function (classBody, method, isGenerator, isAsync) {
		  this.parseMethod(method, isGenerator, isAsync);
		  classBody.body.push(this.finishNode(method, "ClassMethod"));
		};
	
		pp$1.parseClassId = function (node, isStatement, optionalId) {
		  if (this.match(types.name)) {
		    node.id = this.parseIdentifier();
		  } else {
		    if (optionalId || !isStatement) {
		      node.id = null;
		    } else {
		      this.unexpected();
		    }
		  }
		};
	
		pp$1.parseClassSuper = function (node) {
		  node.superClass = this.eat(types._extends) ? this.parseExprSubscripts() : null;
		};
	
		// Parses module export declaration.
	
		pp$1.parseExport = function (node) {
		  this.next();
		  // export * from '...'
		  if (this.match(types.star)) {
		    var specifier = this.startNode();
		    this.next();
		    if (this.hasPlugin("exportExtensions") && this.eatContextual("as")) {
		      specifier.exported = this.parseIdentifier();
		      node.specifiers = [this.finishNode(specifier, "ExportNamespaceSpecifier")];
		      this.parseExportSpecifiersMaybe(node);
		      this.parseExportFrom(node, true);
		    } else {
		      this.parseExportFrom(node, true);
		      return this.finishNode(node, "ExportAllDeclaration");
		    }
		  } else if (this.hasPlugin("exportExtensions") && this.isExportDefaultSpecifier()) {
		    var _specifier = this.startNode();
		    _specifier.exported = this.parseIdentifier(true);
		    node.specifiers = [this.finishNode(_specifier, "ExportDefaultSpecifier")];
		    if (this.match(types.comma) && this.lookahead().type === types.star) {
		      this.expect(types.comma);
		      var _specifier2 = this.startNode();
		      this.expect(types.star);
		      this.expectContextual("as");
		      _specifier2.exported = this.parseIdentifier();
		      node.specifiers.push(this.finishNode(_specifier2, "ExportNamespaceSpecifier"));
		    } else {
		      this.parseExportSpecifiersMaybe(node);
		    }
		    this.parseExportFrom(node, true);
		  } else if (this.eat(types._default)) {
		    // export default ...
		    var expr = this.startNode();
		    var needsSemi = false;
		    if (this.eat(types._function)) {
		      expr = this.parseFunction(expr, true, false, false, true);
		    } else if (this.match(types._class)) {
		      expr = this.parseClass(expr, true, true);
		    } else {
		      needsSemi = true;
		      expr = this.parseMaybeAssign();
		    }
		    node.declaration = expr;
		    if (needsSemi) this.semicolon();
		    this.checkExport(node, true, true);
		    return this.finishNode(node, "ExportDefaultDeclaration");
		  } else if (this.shouldParseExportDeclaration()) {
		    node.specifiers = [];
		    node.source = null;
		    node.declaration = this.parseExportDeclaration(node);
		  } else {
		    // export { x, y as z } [from '...']
		    node.declaration = null;
		    node.specifiers = this.parseExportSpecifiers();
		    this.parseExportFrom(node);
		  }
		  this.checkExport(node, true);
		  return this.finishNode(node, "ExportNamedDeclaration");
		};
	
		pp$1.parseExportDeclaration = function () {
		  return this.parseStatement(true);
		};
	
		pp$1.isExportDefaultSpecifier = function () {
		  if (this.match(types.name)) {
		    return this.state.value !== "async";
		  }
	
		  if (!this.match(types._default)) {
		    return false;
		  }
	
		  var lookahead = this.lookahead();
		  return lookahead.type === types.comma || lookahead.type === types.name && lookahead.value === "from";
		};
	
		pp$1.parseExportSpecifiersMaybe = function (node) {
		  if (this.eat(types.comma)) {
		    node.specifiers = node.specifiers.concat(this.parseExportSpecifiers());
		  }
		};
	
		pp$1.parseExportFrom = function (node, expect) {
		  if (this.eatContextual("from")) {
		    node.source = this.match(types.string) ? this.parseExprAtom() : this.unexpected();
		    this.checkExport(node);
		  } else {
		    if (expect) {
		      this.unexpected();
		    } else {
		      node.source = null;
		    }
		  }
	
		  this.semicolon();
		};
	
		pp$1.shouldParseExportDeclaration = function () {
		  return this.state.type.keyword === "var" || this.state.type.keyword === "const" || this.state.type.keyword === "let" || this.state.type.keyword === "function" || this.state.type.keyword === "class" || this.isContextual("async");
		};
	
		pp$1.checkExport = function (node, checkNames, isDefault) {
		  if (checkNames) {
		    // Check for duplicate exports
		    if (isDefault) {
		      // Default exports
		      this.checkDuplicateExports(node, "default");
		    } else if (node.specifiers && node.specifiers.length) {
		      // Named exports
		      for (var _iterator2 = node.specifiers, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
		        var _ref2;
	
		        if (_isArray2) {
		          if (_i2 >= _iterator2.length) break;
		          _ref2 = _iterator2[_i2++];
		        } else {
		          _i2 = _iterator2.next();
		          if (_i2.done) break;
		          _ref2 = _i2.value;
		        }
	
		        var specifier = _ref2;
	
		        this.checkDuplicateExports(specifier, specifier.exported.name);
		      }
		    } else if (node.declaration) {
		      // Exported declarations
		      if (node.declaration.type === "FunctionDeclaration" || node.declaration.type === "ClassDeclaration") {
		        this.checkDuplicateExports(node, node.declaration.id.name);
		      } else if (node.declaration.type === "VariableDeclaration") {
		        for (var _iterator3 = node.declaration.declarations, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
		          var _ref3;
	
		          if (_isArray3) {
		            if (_i3 >= _iterator3.length) break;
		            _ref3 = _iterator3[_i3++];
		          } else {
		            _i3 = _iterator3.next();
		            if (_i3.done) break;
		            _ref3 = _i3.value;
		          }
	
		          var declaration = _ref3;
	
		          this.checkDeclaration(declaration.id);
		        }
		      }
		    }
		  }
	
		  if (this.state.decorators.length) {
		    var isClass = node.declaration && (node.declaration.type === "ClassDeclaration" || node.declaration.type === "ClassExpression");
		    if (!node.declaration || !isClass) {
		      this.raise(node.start, "You can only use decorators on an export when exporting a class");
		    }
		    this.takeDecorators(node.declaration);
		  }
		};
	
		pp$1.checkDeclaration = function (node) {
		  if (node.type === "ObjectPattern") {
		    for (var _iterator4 = node.properties, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
		      var _ref4;
	
		      if (_isArray4) {
		        if (_i4 >= _iterator4.length) break;
		        _ref4 = _iterator4[_i4++];
		      } else {
		        _i4 = _iterator4.next();
		        if (_i4.done) break;
		        _ref4 = _i4.value;
		      }
	
		      var prop = _ref4;
	
		      this.checkDeclaration(prop);
		    }
		  } else if (node.type === "ArrayPattern") {
		    for (var _iterator5 = node.elements, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
		      var _ref5;
	
		      if (_isArray5) {
		        if (_i5 >= _iterator5.length) break;
		        _ref5 = _iterator5[_i5++];
		      } else {
		        _i5 = _iterator5.next();
		        if (_i5.done) break;
		        _ref5 = _i5.value;
		      }
	
		      var elem = _ref5;
	
		      if (elem) {
		        this.checkDeclaration(elem);
		      }
		    }
		  } else if (node.type === "ObjectProperty") {
		    this.checkDeclaration(node.value);
		  } else if (node.type === "RestElement" || node.type === "RestProperty") {
		    this.checkDeclaration(node.argument);
		  } else if (node.type === "Identifier") {
		    this.checkDuplicateExports(node, node.name);
		  }
		};
	
		pp$1.checkDuplicateExports = function (node, name) {
		  if (this.state.exportedIdentifiers.indexOf(name) > -1) {
		    this.raiseDuplicateExportError(node, name);
		  }
		  this.state.exportedIdentifiers.push(name);
		};
	
		pp$1.raiseDuplicateExportError = function (node, name) {
		  this.raise(node.start, name === "default" ? "Only one default export allowed per module." : "`" + name + "` has already been exported. Exported identifiers must be unique.");
		};
	
		// Parses a comma-separated list of module exports.
	
		pp$1.parseExportSpecifiers = function () {
		  var nodes = [];
		  var first = true;
		  var needsFrom = void 0;
	
		  // export { x, y as z } [from '...']
		  this.expect(types.braceL);
	
		  while (!this.eat(types.braceR)) {
		    if (first) {
		      first = false;
		    } else {
		      this.expect(types.comma);
		      if (this.eat(types.braceR)) break;
		    }
	
		    var isDefault = this.match(types._default);
		    if (isDefault && !needsFrom) needsFrom = true;
	
		    var node = this.startNode();
		    node.local = this.parseIdentifier(isDefault);
		    node.exported = this.eatContextual("as") ? this.parseIdentifier(true) : node.local.__clone();
		    nodes.push(this.finishNode(node, "ExportSpecifier"));
		  }
	
		  // https://github.com/ember-cli/ember-cli/pull/3739
		  if (needsFrom && !this.isContextual("from")) {
		    this.unexpected();
		  }
	
		  return nodes;
		};
	
		// Parses import declaration.
	
		pp$1.parseImport = function (node) {
		  this.eat(types._import);
	
		  // import '...'
		  if (this.match(types.string)) {
		    node.specifiers = [];
		    node.source = this.parseExprAtom();
		  } else {
		    node.specifiers = [];
		    this.parseImportSpecifiers(node);
		    this.expectContextual("from");
		    node.source = this.match(types.string) ? this.parseExprAtom() : this.unexpected();
		  }
		  this.semicolon();
		  return this.finishNode(node, "ImportDeclaration");
		};
	
		// Parses a comma-separated list of module imports.
	
		pp$1.parseImportSpecifiers = function (node) {
		  var first = true;
		  if (this.match(types.name)) {
		    // import defaultObj, { x, y as z } from '...'
		    var startPos = this.state.start;
		    var startLoc = this.state.startLoc;
		    node.specifiers.push(this.parseImportSpecifierDefault(this.parseIdentifier(), startPos, startLoc));
		    if (!this.eat(types.comma)) return;
		  }
	
		  if (this.match(types.star)) {
		    var specifier = this.startNode();
		    this.next();
		    this.expectContextual("as");
		    specifier.local = this.parseIdentifier();
		    this.checkLVal(specifier.local, true, undefined, "import namespace specifier");
		    node.specifiers.push(this.finishNode(specifier, "ImportNamespaceSpecifier"));
		    return;
		  }
	
		  this.expect(types.braceL);
		  while (!this.eat(types.braceR)) {
		    if (first) {
		      first = false;
		    } else {
		      // Detect an attempt to deep destructure
		      if (this.eat(types.colon)) {
		        this.unexpected(null, "ES2015 named imports do not destructure. Use another statement for destructuring after the import.");
		      }
	
		      this.expect(types.comma);
		      if (this.eat(types.braceR)) break;
		    }
	
		    this.parseImportSpecifier(node);
		  }
		};
	
		pp$1.parseImportSpecifier = function (node) {
		  var specifier = this.startNode();
		  specifier.imported = this.parseIdentifier(true);
		  if (this.eatContextual("as")) {
		    specifier.local = this.parseIdentifier();
		  } else {
		    this.checkReservedWord(specifier.imported.name, specifier.start, true, true);
		    specifier.local = specifier.imported.__clone();
		  }
		  this.checkLVal(specifier.local, true, undefined, "import specifier");
		  node.specifiers.push(this.finishNode(specifier, "ImportSpecifier"));
		};
	
		pp$1.parseImportSpecifierDefault = function (id, startPos, startLoc) {
		  var node = this.startNodeAt(startPos, startLoc);
		  node.local = id;
		  this.checkLVal(node.local, true, undefined, "default import specifier");
		  return this.finishNode(node, "ImportDefaultSpecifier");
		};
	
		var pp$2 = Parser.prototype;
	
		// Convert existing expression atom to assignable pattern
		// if possible.
	
		pp$2.toAssignable = function (node, isBinding, contextDescription) {
		  if (node) {
		    switch (node.type) {
		      case "Identifier":
		      case "ObjectPattern":
		      case "ArrayPattern":
		      case "AssignmentPattern":
		        break;
	
		      case "ObjectExpression":
		        node.type = "ObjectPattern";
		        for (var _iterator = node.properties, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		          var _ref;
	
		          if (_isArray) {
		            if (_i >= _iterator.length) break;
		            _ref = _iterator[_i++];
		          } else {
		            _i = _iterator.next();
		            if (_i.done) break;
		            _ref = _i.value;
		          }
	
		          var prop = _ref;
	
		          if (prop.type === "ObjectMethod") {
		            if (prop.kind === "get" || prop.kind === "set") {
		              this.raise(prop.key.start, "Object pattern can't contain getter or setter");
		            } else {
		              this.raise(prop.key.start, "Object pattern can't contain methods");
		            }
		          } else {
		            this.toAssignable(prop, isBinding, "object destructuring pattern");
		          }
		        }
		        break;
	
		      case "ObjectProperty":
		        this.toAssignable(node.value, isBinding, contextDescription);
		        break;
	
		      case "SpreadProperty":
		        node.type = "RestProperty";
		        var arg = node.argument;
		        this.toAssignable(arg, isBinding, contextDescription);
		        break;
	
		      case "ArrayExpression":
		        node.type = "ArrayPattern";
		        this.toAssignableList(node.elements, isBinding, contextDescription);
		        break;
	
		      case "AssignmentExpression":
		        if (node.operator === "=") {
		          node.type = "AssignmentPattern";
		          delete node.operator;
		        } else {
		          this.raise(node.left.end, "Only '=' operator can be used for specifying default value.");
		        }
		        break;
	
		      case "MemberExpression":
		        if (!isBinding) break;
	
		      default:
		        {
		          var message = "Invalid left-hand side" + (contextDescription ? " in " + contextDescription : /* istanbul ignore next */"expression");
		          this.raise(node.start, message);
		        }
		    }
		  }
		  return node;
		};
	
		// Convert list of expression atoms to binding list.
	
		pp$2.toAssignableList = function (exprList, isBinding, contextDescription) {
		  var end = exprList.length;
		  if (end) {
		    var last = exprList[end - 1];
		    if (last && last.type === "RestElement") {
		      --end;
		    } else if (last && last.type === "SpreadElement") {
		      last.type = "RestElement";
		      var arg = last.argument;
		      this.toAssignable(arg, isBinding, contextDescription);
		      if (arg.type !== "Identifier" && arg.type !== "MemberExpression" && arg.type !== "ArrayPattern") {
		        this.unexpected(arg.start);
		      }
		      --end;
		    }
		  }
		  for (var i = 0; i < end; i++) {
		    var elt = exprList[i];
		    if (elt) this.toAssignable(elt, isBinding, contextDescription);
		  }
		  return exprList;
		};
	
		// Convert list of expression atoms to a list of
	
		pp$2.toReferencedList = function (exprList) {
		  return exprList;
		};
	
		// Parses spread element.
	
		pp$2.parseSpread = function (refShorthandDefaultPos) {
		  var node = this.startNode();
		  this.next();
		  node.argument = this.parseMaybeAssign(false, refShorthandDefaultPos);
		  return this.finishNode(node, "SpreadElement");
		};
	
		pp$2.parseRest = function () {
		  var node = this.startNode();
		  this.next();
		  node.argument = this.parseBindingIdentifier();
		  return this.finishNode(node, "RestElement");
		};
	
		pp$2.shouldAllowYieldIdentifier = function () {
		  return this.match(types._yield) && !this.state.strict && !this.state.inGenerator;
		};
	
		pp$2.parseBindingIdentifier = function () {
		  return this.parseIdentifier(this.shouldAllowYieldIdentifier());
		};
	
		// Parses lvalue (assignable) atom.
	
		pp$2.parseBindingAtom = function () {
		  switch (this.state.type) {
		    case types._yield:
		      if (this.state.strict || this.state.inGenerator) this.unexpected();
		    // fall-through
		    case types.name:
		      return this.parseIdentifier(true);
	
		    case types.bracketL:
		      var node = this.startNode();
		      this.next();
		      node.elements = this.parseBindingList(types.bracketR, true);
		      return this.finishNode(node, "ArrayPattern");
	
		    case types.braceL:
		      return this.parseObj(true);
	
		    default:
		      this.unexpected();
		  }
		};
	
		pp$2.parseBindingList = function (close, allowEmpty) {
		  var elts = [];
		  var first = true;
		  while (!this.eat(close)) {
		    if (first) {
		      first = false;
		    } else {
		      this.expect(types.comma);
		    }
		    if (allowEmpty && this.match(types.comma)) {
		      elts.push(null);
		    } else if (this.eat(close)) {
		      break;
		    } else if (this.match(types.ellipsis)) {
		      elts.push(this.parseAssignableListItemTypes(this.parseRest()));
		      this.expect(close);
		      break;
		    } else {
		      var decorators = [];
		      while (this.match(types.at)) {
		        decorators.push(this.parseDecorator());
		      }
		      var left = this.parseMaybeDefault();
		      if (decorators.length) {
		        left.decorators = decorators;
		      }
		      this.parseAssignableListItemTypes(left);
		      elts.push(this.parseMaybeDefault(left.start, left.loc.start, left));
		    }
		  }
		  return elts;
		};
	
		pp$2.parseAssignableListItemTypes = function (param) {
		  return param;
		};
	
		// Parses assignment pattern around given atom if possible.
	
		pp$2.parseMaybeDefault = function (startPos, startLoc, left) {
		  startLoc = startLoc || this.state.startLoc;
		  startPos = startPos || this.state.start;
		  left = left || this.parseBindingAtom();
		  if (!this.eat(types.eq)) return left;
	
		  var node = this.startNodeAt(startPos, startLoc);
		  node.left = left;
		  node.right = this.parseMaybeAssign();
		  return this.finishNode(node, "AssignmentPattern");
		};
	
		// Verify that a node is an lval — something that can be assigned
		// to.
	
		pp$2.checkLVal = function (expr, isBinding, checkClashes, contextDescription) {
		  switch (expr.type) {
		    case "Identifier":
		      this.checkReservedWord(expr.name, expr.start, false, true);
	
		      if (checkClashes) {
		        // we need to prefix this with an underscore for the cases where we have a key of
		        // `__proto__`. there's a bug in old V8 where the following wouldn't work:
		        //
		        //   > var obj = Object.create(null);
		        //   undefined
		        //   > obj.__proto__
		        //   null
		        //   > obj.__proto__ = true;
		        //   true
		        //   > obj.__proto__
		        //   null
		        var key = "_" + expr.name;
	
		        if (checkClashes[key]) {
		          this.raise(expr.start, "Argument name clash in strict mode");
		        } else {
		          checkClashes[key] = true;
		        }
		      }
		      break;
	
		    case "MemberExpression":
		      if (isBinding) this.raise(expr.start, (isBinding ? "Binding" : "Assigning to") + " member expression");
		      break;
	
		    case "ObjectPattern":
		      for (var _iterator2 = expr.properties, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
		        var _ref2;
	
		        if (_isArray2) {
		          if (_i2 >= _iterator2.length) break;
		          _ref2 = _iterator2[_i2++];
		        } else {
		          _i2 = _iterator2.next();
		          if (_i2.done) break;
		          _ref2 = _i2.value;
		        }
	
		        var prop = _ref2;
	
		        if (prop.type === "ObjectProperty") prop = prop.value;
		        this.checkLVal(prop, isBinding, checkClashes, "object destructuring pattern");
		      }
		      break;
	
		    case "ArrayPattern":
		      for (var _iterator3 = expr.elements, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
		        var _ref3;
	
		        if (_isArray3) {
		          if (_i3 >= _iterator3.length) break;
		          _ref3 = _iterator3[_i3++];
		        } else {
		          _i3 = _iterator3.next();
		          if (_i3.done) break;
		          _ref3 = _i3.value;
		        }
	
		        var elem = _ref3;
	
		        if (elem) this.checkLVal(elem, isBinding, checkClashes, "array destructuring pattern");
		      }
		      break;
	
		    case "AssignmentPattern":
		      this.checkLVal(expr.left, isBinding, checkClashes, "assignment pattern");
		      break;
	
		    case "RestProperty":
		      this.checkLVal(expr.argument, isBinding, checkClashes, "rest property");
		      break;
	
		    case "RestElement":
		      this.checkLVal(expr.argument, isBinding, checkClashes, "rest element");
		      break;
	
		    default:
		      {
		        var message = (isBinding ? /* istanbul ignore next */"Binding invalid" : "Invalid") + " left-hand side" + (contextDescription ? " in " + contextDescription : /* istanbul ignore next */"expression");
		        this.raise(expr.start, message);
		      }
		  }
		};
	
		/* eslint max-len: 0 */
	
		// A recursive descent parser operates by defining functions for all
		// syntactic elements, and recursively calling those, each function
		// advancing the input stream and returning an AST node. Precedence
		// of constructs (for example, the fact that `!x[1]` means `!(x[1])`
		// instead of `(!x)[1]` is handled by the fact that the parser
		// function that parses unary prefix operators is called first, and
		// in turn calls the function that parses `[]` subscripts — that
		// way, it'll receive the node for `x[1]` already parsed, and wraps
		// *that* in the unary operator node.
		//
		// Acorn uses an [operator precedence parser][opp] to handle binary
		// operator precedence, because it is much more compact than using
		// the technique outlined above, which uses different, nesting
		// functions to specify precedence, for all of the ten binary
		// precedence levels that JavaScript defines.
		//
		// [opp]: http://en.wikipedia.org/wiki/Operator-precedence_parser
	
		var pp$3 = Parser.prototype;
	
		// Check if property name clashes with already added.
		// Object/class getters and setters are not allowed to clash —
		// either with each other or with an init property — and in
		// strict mode, init properties are also not allowed to be repeated.
	
		pp$3.checkPropClash = function (prop, propHash) {
		  if (prop.computed || prop.kind) return;
	
		  var key = prop.key;
		  // It is either an Identifier or a String/NumericLiteral
		  var name = key.type === "Identifier" ? key.name : String(key.value);
	
		  if (name === "__proto__") {
		    if (propHash.proto) this.raise(key.start, "Redefinition of __proto__ property");
		    propHash.proto = true;
		  }
		};
	
		// Convenience method to parse an Expression only
		pp$3.getExpression = function () {
		  this.nextToken();
		  var expr = this.parseExpression();
		  if (!this.match(types.eof)) {
		    this.unexpected();
		  }
		  return expr;
		};
	
		// ### Expression parsing
	
		// These nest, from the most general expression type at the top to
		// 'atomic', nondivisible expression types at the bottom. Most of
		// the functions will simply let the function (s) below them parse,
		// and, *if* the syntactic construct they handle is present, wrap
		// the AST node that the inner parser gave them in another node.
	
		// Parse a full expression. The optional arguments are used to
		// forbid the `in` operator (in for loops initialization expressions)
		// and provide reference for storing '=' operator inside shorthand
		// property assignment in contexts where both object expression
		// and object pattern might appear (so it's possible to raise
		// delayed syntax error at correct position).
	
		pp$3.parseExpression = function (noIn, refShorthandDefaultPos) {
		  var startPos = this.state.start;
		  var startLoc = this.state.startLoc;
		  var expr = this.parseMaybeAssign(noIn, refShorthandDefaultPos);
		  if (this.match(types.comma)) {
		    var node = this.startNodeAt(startPos, startLoc);
		    node.expressions = [expr];
		    while (this.eat(types.comma)) {
		      node.expressions.push(this.parseMaybeAssign(noIn, refShorthandDefaultPos));
		    }
		    this.toReferencedList(node.expressions);
		    return this.finishNode(node, "SequenceExpression");
		  }
		  return expr;
		};
	
		// Parse an assignment expression. This includes applications of
		// operators like `+=`.
	
		pp$3.parseMaybeAssign = function (noIn, refShorthandDefaultPos, afterLeftParse, refNeedsArrowPos) {
		  var startPos = this.state.start;
		  var startLoc = this.state.startLoc;
	
		  if (this.match(types._yield) && this.state.inGenerator) {
		    var _left = this.parseYield();
		    if (afterLeftParse) _left = afterLeftParse.call(this, _left, startPos, startLoc);
		    return _left;
		  }
	
		  var failOnShorthandAssign = void 0;
		  if (refShorthandDefaultPos) {
		    failOnShorthandAssign = false;
		  } else {
		    refShorthandDefaultPos = { start: 0 };
		    failOnShorthandAssign = true;
		  }
	
		  if (this.match(types.parenL) || this.match(types.name)) {
		    this.state.potentialArrowAt = this.state.start;
		  }
	
		  var left = this.parseMaybeConditional(noIn, refShorthandDefaultPos, refNeedsArrowPos);
		  if (afterLeftParse) left = afterLeftParse.call(this, left, startPos, startLoc);
		  if (this.state.type.isAssign) {
		    var node = this.startNodeAt(startPos, startLoc);
		    node.operator = this.state.value;
		    node.left = this.match(types.eq) ? this.toAssignable(left, undefined, "assignment expression") : left;
		    refShorthandDefaultPos.start = 0; // reset because shorthand default was used correctly
	
		    this.checkLVal(left, undefined, undefined, "assignment expression");
	
		    if (left.extra && left.extra.parenthesized) {
		      var errorMsg = void 0;
		      if (left.type === "ObjectPattern") {
		        errorMsg = "`({a}) = 0` use `({a} = 0)`";
		      } else if (left.type === "ArrayPattern") {
		        errorMsg = "`([a]) = 0` use `([a] = 0)`";
		      }
		      if (errorMsg) {
		        this.raise(left.start, "You're trying to assign to a parenthesized expression, eg. instead of " + errorMsg);
		      }
		    }
	
		    this.next();
		    node.right = this.parseMaybeAssign(noIn);
		    return this.finishNode(node, "AssignmentExpression");
		  } else if (failOnShorthandAssign && refShorthandDefaultPos.start) {
		    this.unexpected(refShorthandDefaultPos.start);
		  }
	
		  return left;
		};
	
		// Parse a ternary conditional (`?:`) operator.
	
		pp$3.parseMaybeConditional = function (noIn, refShorthandDefaultPos, refNeedsArrowPos) {
		  var startPos = this.state.start;
		  var startLoc = this.state.startLoc;
		  var expr = this.parseExprOps(noIn, refShorthandDefaultPos);
		  if (refShorthandDefaultPos && refShorthandDefaultPos.start) return expr;
	
		  return this.parseConditional(expr, noIn, startPos, startLoc, refNeedsArrowPos);
		};
	
		pp$3.parseConditional = function (expr, noIn, startPos, startLoc) {
		  if (this.eat(types.question)) {
		    var node = this.startNodeAt(startPos, startLoc);
		    node.test = expr;
		    node.consequent = this.parseMaybeAssign();
		    this.expect(types.colon);
		    node.alternate = this.parseMaybeAssign(noIn);
		    return this.finishNode(node, "ConditionalExpression");
		  }
		  return expr;
		};
	
		// Start the precedence parser.
	
		pp$3.parseExprOps = function (noIn, refShorthandDefaultPos) {
		  var startPos = this.state.start;
		  var startLoc = this.state.startLoc;
		  var expr = this.parseMaybeUnary(refShorthandDefaultPos);
		  if (refShorthandDefaultPos && refShorthandDefaultPos.start) {
		    return expr;
		  } else {
		    return this.parseExprOp(expr, startPos, startLoc, -1, noIn);
		  }
		};
	
		// Parse binary operators with the operator precedence parsing
		// algorithm. `left` is the left-hand side of the operator.
		// `minPrec` provides context that allows the function to stop and
		// defer further parser to one of its callers when it encounters an
		// operator that has a lower precedence than the set it is parsing.
	
		pp$3.parseExprOp = function (left, leftStartPos, leftStartLoc, minPrec, noIn) {
		  var prec = this.state.type.binop;
		  if (prec != null && (!noIn || !this.match(types._in))) {
		    if (prec > minPrec) {
		      var node = this.startNodeAt(leftStartPos, leftStartLoc);
		      node.left = left;
		      node.operator = this.state.value;
	
		      if (node.operator === "**" && left.type === "UnaryExpression" && left.extra && !left.extra.parenthesizedArgument && !left.extra.parenthesized) {
		        this.raise(left.argument.start, "Illegal expression. Wrap left hand side or entire exponentiation in parentheses.");
		      }
	
		      var op = this.state.type;
		      this.next();
	
		      var startPos = this.state.start;
		      var startLoc = this.state.startLoc;
		      node.right = this.parseExprOp(this.parseMaybeUnary(), startPos, startLoc, op.rightAssociative ? prec - 1 : prec, noIn);
	
		      this.finishNode(node, op === types.logicalOR || op === types.logicalAND ? "LogicalExpression" : "BinaryExpression");
		      return this.parseExprOp(node, leftStartPos, leftStartLoc, minPrec, noIn);
		    }
		  }
		  return left;
		};
	
		// Parse unary operators, both prefix and postfix.
	
		pp$3.parseMaybeUnary = function (refShorthandDefaultPos) {
		  if (this.state.type.prefix) {
		    var node = this.startNode();
		    var update = this.match(types.incDec);
		    node.operator = this.state.value;
		    node.prefix = true;
		    this.next();
	
		    var argType = this.state.type;
		    node.argument = this.parseMaybeUnary();
	
		    this.addExtra(node, "parenthesizedArgument", argType === types.parenL && (!node.argument.extra || !node.argument.extra.parenthesized));
	
		    if (refShorthandDefaultPos && refShorthandDefaultPos.start) {
		      this.unexpected(refShorthandDefaultPos.start);
		    }
	
		    if (update) {
		      this.checkLVal(node.argument, undefined, undefined, "prefix operation");
		    } else if (this.state.strict && node.operator === "delete" && node.argument.type === "Identifier") {
		      this.raise(node.start, "Deleting local variable in strict mode");
		    }
	
		    return this.finishNode(node, update ? "UpdateExpression" : "UnaryExpression");
		  }
	
		  var startPos = this.state.start;
		  var startLoc = this.state.startLoc;
		  var expr = this.parseExprSubscripts(refShorthandDefaultPos);
		  if (refShorthandDefaultPos && refShorthandDefaultPos.start) return expr;
		  while (this.state.type.postfix && !this.canInsertSemicolon()) {
		    var _node = this.startNodeAt(startPos, startLoc);
		    _node.operator = this.state.value;
		    _node.prefix = false;
		    _node.argument = expr;
		    this.checkLVal(expr, undefined, undefined, "postfix operation");
		    this.next();
		    expr = this.finishNode(_node, "UpdateExpression");
		  }
		  return expr;
		};
	
		// Parse call, dot, and `[]`-subscript expressions.
	
		pp$3.parseExprSubscripts = function (refShorthandDefaultPos) {
		  var startPos = this.state.start;
		  var startLoc = this.state.startLoc;
		  var potentialArrowAt = this.state.potentialArrowAt;
		  var expr = this.parseExprAtom(refShorthandDefaultPos);
	
		  if (expr.type === "ArrowFunctionExpression" && expr.start === potentialArrowAt) {
		    return expr;
		  }
	
		  if (refShorthandDefaultPos && refShorthandDefaultPos.start) {
		    return expr;
		  }
	
		  return this.parseSubscripts(expr, startPos, startLoc);
		};
	
		pp$3.parseSubscripts = function (base, startPos, startLoc, noCalls) {
		  for (;;) {
		    if (!noCalls && this.eat(types.doubleColon)) {
		      var node = this.startNodeAt(startPos, startLoc);
		      node.object = base;
		      node.callee = this.parseNoCallExpr();
		      return this.parseSubscripts(this.finishNode(node, "BindExpression"), startPos, startLoc, noCalls);
		    } else if (this.eat(types.dot)) {
		      var _node2 = this.startNodeAt(startPos, startLoc);
		      _node2.object = base;
		      _node2.property = this.parseIdentifier(true);
		      _node2.computed = false;
		      base = this.finishNode(_node2, "MemberExpression");
		    } else if (this.eat(types.bracketL)) {
		      var _node3 = this.startNodeAt(startPos, startLoc);
		      _node3.object = base;
		      _node3.property = this.parseExpression();
		      _node3.computed = true;
		      this.expect(types.bracketR);
		      base = this.finishNode(_node3, "MemberExpression");
		    } else if (!noCalls && this.match(types.parenL)) {
		      var possibleAsync = this.state.potentialArrowAt === base.start && base.type === "Identifier" && base.name === "async" && !this.canInsertSemicolon();
		      this.next();
	
		      var _node4 = this.startNodeAt(startPos, startLoc);
		      _node4.callee = base;
		      _node4.arguments = this.parseCallExpressionArguments(types.parenR, possibleAsync);
		      if (_node4.callee.type === "Import" && _node4.arguments.length !== 1) {
		        this.raise(_node4.start, "import() requires exactly one argument");
		      }
		      base = this.finishNode(_node4, "CallExpression");
	
		      if (possibleAsync && this.shouldParseAsyncArrow()) {
		        return this.parseAsyncArrowFromCallExpression(this.startNodeAt(startPos, startLoc), _node4);
		      } else {
		        this.toReferencedList(_node4.arguments);
		      }
		    } else if (this.match(types.backQuote)) {
		      var _node5 = this.startNodeAt(startPos, startLoc);
		      _node5.tag = base;
		      _node5.quasi = this.parseTemplate(true);
		      base = this.finishNode(_node5, "TaggedTemplateExpression");
		    } else {
		      return base;
		    }
		  }
		};
	
		pp$3.parseCallExpressionArguments = function (close, possibleAsyncArrow) {
		  var elts = [];
		  var innerParenStart = void 0;
		  var first = true;
	
		  while (!this.eat(close)) {
		    if (first) {
		      first = false;
		    } else {
		      this.expect(types.comma);
		      if (this.eat(close)) break;
		    }
	
		    // we need to make sure that if this is an async arrow functions, that we don't allow inner parens inside the params
		    if (this.match(types.parenL) && !innerParenStart) {
		      innerParenStart = this.state.start;
		    }
	
		    elts.push(this.parseExprListItem(false, possibleAsyncArrow ? { start: 0 } : undefined, possibleAsyncArrow ? { start: 0 } : undefined));
		  }
	
		  // we found an async arrow function so let's not allow any inner parens
		  if (possibleAsyncArrow && innerParenStart && this.shouldParseAsyncArrow()) {
		    this.unexpected();
		  }
	
		  return elts;
		};
	
		pp$3.shouldParseAsyncArrow = function () {
		  return this.match(types.arrow);
		};
	
		pp$3.parseAsyncArrowFromCallExpression = function (node, call) {
		  this.expect(types.arrow);
		  return this.parseArrowExpression(node, call.arguments, true);
		};
	
		// Parse a no-call expression (like argument of `new` or `::` operators).
	
		pp$3.parseNoCallExpr = function () {
		  var startPos = this.state.start;
		  var startLoc = this.state.startLoc;
		  return this.parseSubscripts(this.parseExprAtom(), startPos, startLoc, true);
		};
	
		// Parse an atomic expression — either a single token that is an
		// expression, an expression started by a keyword like `function` or
		// `new`, or an expression wrapped in punctuation like `()`, `[]`,
		// or `{}`.
	
		pp$3.parseExprAtom = function (refShorthandDefaultPos) {
		  var canBeArrow = this.state.potentialArrowAt === this.state.start;
		  var node = void 0;
	
		  switch (this.state.type) {
		    case types._super:
		      if (!this.state.inMethod && !this.state.inClassProperty && !this.options.allowSuperOutsideMethod) {
		        this.raise(this.state.start, "'super' outside of function or class");
		      }
	
		      node = this.startNode();
		      this.next();
		      if (!this.match(types.parenL) && !this.match(types.bracketL) && !this.match(types.dot)) {
		        this.unexpected();
		      }
		      if (this.match(types.parenL) && this.state.inMethod !== "constructor" && !this.options.allowSuperOutsideMethod) {
		        this.raise(node.start, "super() outside of class constructor");
		      }
		      return this.finishNode(node, "Super");
	
		    case types._import:
		      if (!this.hasPlugin("dynamicImport")) this.unexpected();
	
		      node = this.startNode();
		      this.next();
		      if (!this.match(types.parenL)) {
		        this.unexpected(null, types.parenL);
		      }
		      return this.finishNode(node, "Import");
	
		    case types._this:
		      node = this.startNode();
		      this.next();
		      return this.finishNode(node, "ThisExpression");
	
		    case types._yield:
		      if (this.state.inGenerator) this.unexpected();
	
		    case types.name:
		      node = this.startNode();
		      var allowAwait = this.state.value === "await" && this.state.inAsync;
		      var allowYield = this.shouldAllowYieldIdentifier();
		      var id = this.parseIdentifier(allowAwait || allowYield);
	
		      if (id.name === "await") {
		        if (this.state.inAsync || this.inModule) {
		          return this.parseAwait(node);
		        }
		      } else if (id.name === "async" && this.match(types._function) && !this.canInsertSemicolon()) {
		        this.next();
		        return this.parseFunction(node, false, false, true);
		      } else if (canBeArrow && id.name === "async" && this.match(types.name)) {
		        var params = [this.parseIdentifier()];
		        this.expect(types.arrow);
		        // let foo = bar => {};
		        return this.parseArrowExpression(node, params, true);
		      }
	
		      if (canBeArrow && !this.canInsertSemicolon() && this.eat(types.arrow)) {
		        return this.parseArrowExpression(node, [id]);
		      }
	
		      return id;
	
		    case types._do:
		      if (this.hasPlugin("doExpressions")) {
		        var _node6 = this.startNode();
		        this.next();
		        var oldInFunction = this.state.inFunction;
		        var oldLabels = this.state.labels;
		        this.state.labels = [];
		        this.state.inFunction = false;
		        _node6.body = this.parseBlock(false, true);
		        this.state.inFunction = oldInFunction;
		        this.state.labels = oldLabels;
		        return this.finishNode(_node6, "DoExpression");
		      }
	
		    case types.regexp:
		      var value = this.state.value;
		      node = this.parseLiteral(value.value, "RegExpLiteral");
		      node.pattern = value.pattern;
		      node.flags = value.flags;
		      return node;
	
		    case types.num:
		      return this.parseLiteral(this.state.value, "NumericLiteral");
	
		    case types.string:
		      return this.parseLiteral(this.state.value, "StringLiteral");
	
		    case types._null:
		      node = this.startNode();
		      this.next();
		      return this.finishNode(node, "NullLiteral");
	
		    case types._true:case types._false:
		      node = this.startNode();
		      node.value = this.match(types._true);
		      this.next();
		      return this.finishNode(node, "BooleanLiteral");
	
		    case types.parenL:
		      return this.parseParenAndDistinguishExpression(null, null, canBeArrow);
	
		    case types.bracketL:
		      node = this.startNode();
		      this.next();
		      node.elements = this.parseExprList(types.bracketR, true, refShorthandDefaultPos);
		      this.toReferencedList(node.elements);
		      return this.finishNode(node, "ArrayExpression");
	
		    case types.braceL:
		      return this.parseObj(false, refShorthandDefaultPos);
	
		    case types._function:
		      return this.parseFunctionExpression();
	
		    case types.at:
		      this.parseDecorators();
	
		    case types._class:
		      node = this.startNode();
		      this.takeDecorators(node);
		      return this.parseClass(node, false);
	
		    case types._new:
		      return this.parseNew();
	
		    case types.backQuote:
		      return this.parseTemplate(false);
	
		    case types.doubleColon:
		      node = this.startNode();
		      this.next();
		      node.object = null;
		      var callee = node.callee = this.parseNoCallExpr();
		      if (callee.type === "MemberExpression") {
		        return this.finishNode(node, "BindExpression");
		      } else {
		        this.raise(callee.start, "Binding should be performed on object property.");
		      }
	
		    default:
		      this.unexpected();
		  }
		};
	
		pp$3.parseFunctionExpression = function () {
		  var node = this.startNode();
		  var meta = this.parseIdentifier(true);
		  if (this.state.inGenerator && this.eat(types.dot) && this.hasPlugin("functionSent")) {
		    return this.parseMetaProperty(node, meta, "sent");
		  } else {
		    return this.parseFunction(node, false);
		  }
		};
	
		pp$3.parseMetaProperty = function (node, meta, propertyName) {
		  node.meta = meta;
		  node.property = this.parseIdentifier(true);
	
		  if (node.property.name !== propertyName) {
		    this.raise(node.property.start, "The only valid meta property for new is " + meta.name + "." + propertyName);
		  }
	
		  return this.finishNode(node, "MetaProperty");
		};
	
		pp$3.parseLiteral = function (value, type, startPos, startLoc) {
		  startPos = startPos || this.state.start;
		  startLoc = startLoc || this.state.startLoc;
	
		  var node = this.startNodeAt(startPos, startLoc);
		  this.addExtra(node, "rawValue", value);
		  this.addExtra(node, "raw", this.input.slice(startPos, this.state.end));
		  node.value = value;
		  this.next();
		  return this.finishNode(node, type);
		};
	
		pp$3.parseParenExpression = function () {
		  this.expect(types.parenL);
		  var val = this.parseExpression();
		  this.expect(types.parenR);
		  return val;
		};
	
		pp$3.parseParenAndDistinguishExpression = function (startPos, startLoc, canBeArrow) {
		  startPos = startPos || this.state.start;
		  startLoc = startLoc || this.state.startLoc;
	
		  var val = void 0;
		  this.expect(types.parenL);
	
		  var innerStartPos = this.state.start;
		  var innerStartLoc = this.state.startLoc;
		  var exprList = [];
		  var refShorthandDefaultPos = { start: 0 };
		  var refNeedsArrowPos = { start: 0 };
		  var first = true;
		  var spreadStart = void 0;
		  var optionalCommaStart = void 0;
	
		  while (!this.match(types.parenR)) {
		    if (first) {
		      first = false;
		    } else {
		      this.expect(types.comma, refNeedsArrowPos.start || null);
		      if (this.match(types.parenR)) {
		        optionalCommaStart = this.state.start;
		        break;
		      }
		    }
	
		    if (this.match(types.ellipsis)) {
		      var spreadNodeStartPos = this.state.start;
		      var spreadNodeStartLoc = this.state.startLoc;
		      spreadStart = this.state.start;
		      exprList.push(this.parseParenItem(this.parseRest(), spreadNodeStartPos, spreadNodeStartLoc));
		      break;
		    } else {
		      exprList.push(this.parseMaybeAssign(false, refShorthandDefaultPos, this.parseParenItem, refNeedsArrowPos));
		    }
		  }
	
		  var innerEndPos = this.state.start;
		  var innerEndLoc = this.state.startLoc;
		  this.expect(types.parenR);
	
		  var arrowNode = this.startNodeAt(startPos, startLoc);
		  if (canBeArrow && this.shouldParseArrow() && (arrowNode = this.parseArrow(arrowNode))) {
		    for (var _iterator = exprList, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var param = _ref;
	
		      if (param.extra && param.extra.parenthesized) this.unexpected(param.extra.parenStart);
		    }
	
		    return this.parseArrowExpression(arrowNode, exprList);
		  }
	
		  if (!exprList.length) {
		    this.unexpected(this.state.lastTokStart);
		  }
		  if (optionalCommaStart) this.unexpected(optionalCommaStart);
		  if (spreadStart) this.unexpected(spreadStart);
		  if (refShorthandDefaultPos.start) this.unexpected(refShorthandDefaultPos.start);
		  if (refNeedsArrowPos.start) this.unexpected(refNeedsArrowPos.start);
	
		  if (exprList.length > 1) {
		    val = this.startNodeAt(innerStartPos, innerStartLoc);
		    val.expressions = exprList;
		    this.toReferencedList(val.expressions);
		    this.finishNodeAt(val, "SequenceExpression", innerEndPos, innerEndLoc);
		  } else {
		    val = exprList[0];
		  }
	
		  this.addExtra(val, "parenthesized", true);
		  this.addExtra(val, "parenStart", startPos);
	
		  return val;
		};
	
		pp$3.shouldParseArrow = function () {
		  return !this.canInsertSemicolon();
		};
	
		pp$3.parseArrow = function (node) {
		  if (this.eat(types.arrow)) {
		    return node;
		  }
		};
	
		pp$3.parseParenItem = function (node) {
		  return node;
		};
	
		// New's precedence is slightly tricky. It must allow its argument
		// to be a `[]` or dot subscript expression, but not a call — at
		// least, not without wrapping it in parentheses. Thus, it uses the
	
		pp$3.parseNew = function () {
		  var node = this.startNode();
		  var meta = this.parseIdentifier(true);
	
		  if (this.eat(types.dot)) {
		    var metaProp = this.parseMetaProperty(node, meta, "target");
	
		    if (!this.state.inFunction) {
		      this.raise(metaProp.property.start, "new.target can only be used in functions");
		    }
	
		    return metaProp;
		  }
	
		  node.callee = this.parseNoCallExpr();
	
		  if (this.eat(types.parenL)) {
		    node.arguments = this.parseExprList(types.parenR);
		    this.toReferencedList(node.arguments);
		  } else {
		    node.arguments = [];
		  }
	
		  return this.finishNode(node, "NewExpression");
		};
	
		// Parse template expression.
	
		pp$3.parseTemplateElement = function (isTagged) {
		  var elem = this.startNode();
		  if (this.state.value === null) {
		    if (!isTagged || !this.hasPlugin("templateInvalidEscapes")) {
		      this.raise(this.state.invalidTemplateEscapePosition, "Invalid escape sequence in template");
		    } else {
		      this.state.invalidTemplateEscapePosition = null;
		    }
		  }
		  elem.value = {
		    raw: this.input.slice(this.state.start, this.state.end).replace(/\r\n?/g, "\n"),
		    cooked: this.state.value
		  };
		  this.next();
		  elem.tail = this.match(types.backQuote);
		  return this.finishNode(elem, "TemplateElement");
		};
	
		pp$3.parseTemplate = function (isTagged) {
		  var node = this.startNode();
		  this.next();
		  node.expressions = [];
		  var curElt = this.parseTemplateElement(isTagged);
		  node.quasis = [curElt];
		  while (!curElt.tail) {
		    this.expect(types.dollarBraceL);
		    node.expressions.push(this.parseExpression());
		    this.expect(types.braceR);
		    node.quasis.push(curElt = this.parseTemplateElement(isTagged));
		  }
		  this.next();
		  return this.finishNode(node, "TemplateLiteral");
		};
	
		// Parse an object literal or binding pattern.
	
		pp$3.parseObj = function (isPattern, refShorthandDefaultPos) {
		  var decorators = [];
		  var propHash = Object.create(null);
		  var first = true;
		  var node = this.startNode();
	
		  node.properties = [];
		  this.next();
	
		  var firstRestLocation = null;
	
		  while (!this.eat(types.braceR)) {
		    if (first) {
		      first = false;
		    } else {
		      this.expect(types.comma);
		      if (this.eat(types.braceR)) break;
		    }
	
		    while (this.match(types.at)) {
		      decorators.push(this.parseDecorator());
		    }
	
		    var prop = this.startNode(),
		        isGenerator = false,
		        isAsync = false,
		        startPos = void 0,
		        startLoc = void 0;
		    if (decorators.length) {
		      prop.decorators = decorators;
		      decorators = [];
		    }
	
		    if (this.hasPlugin("objectRestSpread") && this.match(types.ellipsis)) {
		      prop = this.parseSpread(isPattern ? { start: 0 } : undefined);
		      prop.type = isPattern ? "RestProperty" : "SpreadProperty";
		      if (isPattern) this.toAssignable(prop.argument, true, "object pattern");
		      node.properties.push(prop);
		      if (isPattern) {
		        var position = this.state.start;
		        if (firstRestLocation !== null) {
		          this.unexpected(firstRestLocation, "Cannot have multiple rest elements when destructuring");
		        } else if (this.eat(types.braceR)) {
		          break;
		        } else if (this.match(types.comma) && this.lookahead().type === types.braceR) {
		          // TODO: temporary rollback
		          // this.unexpected(position, "A trailing comma is not permitted after the rest element");
		          continue;
		        } else {
		          firstRestLocation = position;
		          continue;
		        }
		      } else {
		        continue;
		      }
		    }
	
		    prop.method = false;
		    prop.shorthand = false;
	
		    if (isPattern || refShorthandDefaultPos) {
		      startPos = this.state.start;
		      startLoc = this.state.startLoc;
		    }
	
		    if (!isPattern) {
		      isGenerator = this.eat(types.star);
		    }
	
		    if (!isPattern && this.isContextual("async")) {
		      if (isGenerator) this.unexpected();
	
		      var asyncId = this.parseIdentifier();
		      if (this.match(types.colon) || this.match(types.parenL) || this.match(types.braceR) || this.match(types.eq) || this.match(types.comma)) {
		        prop.key = asyncId;
		        prop.computed = false;
		      } else {
		        isAsync = true;
		        if (this.hasPlugin("asyncGenerators")) isGenerator = this.eat(types.star);
		        this.parsePropertyName(prop);
		      }
		    } else {
		      this.parsePropertyName(prop);
		    }
	
		    this.parseObjPropValue(prop, startPos, startLoc, isGenerator, isAsync, isPattern, refShorthandDefaultPos);
		    this.checkPropClash(prop, propHash);
	
		    if (prop.shorthand) {
		      this.addExtra(prop, "shorthand", true);
		    }
	
		    node.properties.push(prop);
		  }
	
		  if (firstRestLocation !== null) {
		    this.unexpected(firstRestLocation, "The rest element has to be the last element when destructuring");
		  }
	
		  if (decorators.length) {
		    this.raise(this.state.start, "You have trailing decorators with no property");
		  }
	
		  return this.finishNode(node, isPattern ? "ObjectPattern" : "ObjectExpression");
		};
	
		pp$3.isGetterOrSetterMethod = function (prop, isPattern) {
		  return !isPattern && !prop.computed && prop.key.type === "Identifier" && (prop.key.name === "get" || prop.key.name === "set") && (this.match(types.string) || // get "string"() {}
		  this.match(types.num) || // get 1() {}
		  this.match(types.bracketL) || // get ["string"]() {}
		  this.match(types.name) || // get foo() {}
		  this.state.type.keyword // get debugger() {}
		  );
		};
	
		// get methods aren't allowed to have any parameters
		// set methods must have exactly 1 parameter
		pp$3.checkGetterSetterParamCount = function (method) {
		  var paramCount = method.kind === "get" ? 0 : 1;
		  if (method.params.length !== paramCount) {
		    var start = method.start;
		    if (method.kind === "get") {
		      this.raise(start, "getter should have no params");
		    } else {
		      this.raise(start, "setter should have exactly one param");
		    }
		  }
		};
	
		pp$3.parseObjectMethod = function (prop, isGenerator, isAsync, isPattern) {
		  if (isAsync || isGenerator || this.match(types.parenL)) {
		    if (isPattern) this.unexpected();
		    prop.kind = "method";
		    prop.method = true;
		    this.parseMethod(prop, isGenerator, isAsync);
	
		    return this.finishNode(prop, "ObjectMethod");
		  }
	
		  if (this.isGetterOrSetterMethod(prop, isPattern)) {
		    if (isGenerator || isAsync) this.unexpected();
		    prop.kind = prop.key.name;
		    this.parsePropertyName(prop);
		    this.parseMethod(prop);
		    this.checkGetterSetterParamCount(prop);
	
		    return this.finishNode(prop, "ObjectMethod");
		  }
		};
	
		pp$3.parseObjectProperty = function (prop, startPos, startLoc, isPattern, refShorthandDefaultPos) {
		  if (this.eat(types.colon)) {
		    prop.value = isPattern ? this.parseMaybeDefault(this.state.start, this.state.startLoc) : this.parseMaybeAssign(false, refShorthandDefaultPos);
	
		    return this.finishNode(prop, "ObjectProperty");
		  }
	
		  if (!prop.computed && prop.key.type === "Identifier") {
		    this.checkReservedWord(prop.key.name, prop.key.start, true, true);
	
		    if (isPattern) {
		      prop.value = this.parseMaybeDefault(startPos, startLoc, prop.key.__clone());
		    } else if (this.match(types.eq) && refShorthandDefaultPos) {
		      if (!refShorthandDefaultPos.start) {
		        refShorthandDefaultPos.start = this.state.start;
		      }
		      prop.value = this.parseMaybeDefault(startPos, startLoc, prop.key.__clone());
		    } else {
		      prop.value = prop.key.__clone();
		    }
		    prop.shorthand = true;
	
		    return this.finishNode(prop, "ObjectProperty");
		  }
		};
	
		pp$3.parseObjPropValue = function (prop, startPos, startLoc, isGenerator, isAsync, isPattern, refShorthandDefaultPos) {
		  var node = this.parseObjectMethod(prop, isGenerator, isAsync, isPattern) || this.parseObjectProperty(prop, startPos, startLoc, isPattern, refShorthandDefaultPos);
	
		  if (!node) this.unexpected();
	
		  return node;
		};
	
		pp$3.parsePropertyName = function (prop) {
		  if (this.eat(types.bracketL)) {
		    prop.computed = true;
		    prop.key = this.parseMaybeAssign();
		    this.expect(types.bracketR);
		  } else {
		    prop.computed = false;
		    var oldInPropertyName = this.state.inPropertyName;
		    this.state.inPropertyName = true;
		    prop.key = this.match(types.num) || this.match(types.string) ? this.parseExprAtom() : this.parseIdentifier(true);
		    this.state.inPropertyName = oldInPropertyName;
		  }
		  return prop.key;
		};
	
		// Initialize empty function node.
	
		pp$3.initFunction = function (node, isAsync) {
		  node.id = null;
		  node.generator = false;
		  node.expression = false;
		  node.async = !!isAsync;
		};
	
		// Parse object or class method.
	
		pp$3.parseMethod = function (node, isGenerator, isAsync) {
		  var oldInMethod = this.state.inMethod;
		  this.state.inMethod = node.kind || true;
		  this.initFunction(node, isAsync);
		  this.expect(types.parenL);
		  node.params = this.parseBindingList(types.parenR);
		  node.generator = !!isGenerator;
		  this.parseFunctionBody(node);
		  this.state.inMethod = oldInMethod;
		  return node;
		};
	
		// Parse arrow function expression with given parameters.
	
		pp$3.parseArrowExpression = function (node, params, isAsync) {
		  this.initFunction(node, isAsync);
		  node.params = this.toAssignableList(params, true, "arrow function parameters");
		  this.parseFunctionBody(node, true);
		  return this.finishNode(node, "ArrowFunctionExpression");
		};
	
		pp$3.isStrictBody = function (node, isExpression) {
		  if (!isExpression && node.body.directives.length) {
		    for (var _iterator2 = node.body.directives, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
		      var _ref2;
	
		      if (_isArray2) {
		        if (_i2 >= _iterator2.length) break;
		        _ref2 = _iterator2[_i2++];
		      } else {
		        _i2 = _iterator2.next();
		        if (_i2.done) break;
		        _ref2 = _i2.value;
		      }
	
		      var directive = _ref2;
	
		      if (directive.value.value === "use strict") {
		        return true;
		      }
		    }
		  }
	
		  return false;
		};
	
		// Parse function body and check parameters.
		pp$3.parseFunctionBody = function (node, allowExpression) {
		  var isExpression = allowExpression && !this.match(types.braceL);
	
		  var oldInAsync = this.state.inAsync;
		  this.state.inAsync = node.async;
		  if (isExpression) {
		    node.body = this.parseMaybeAssign();
		    node.expression = true;
		  } else {
		    // Start a new scope with regard to labels and the `inFunction`
		    // flag (restore them to their old value afterwards).
		    var oldInFunc = this.state.inFunction;
		    var oldInGen = this.state.inGenerator;
		    var oldLabels = this.state.labels;
		    this.state.inFunction = true;this.state.inGenerator = node.generator;this.state.labels = [];
		    node.body = this.parseBlock(true);
		    node.expression = false;
		    this.state.inFunction = oldInFunc;this.state.inGenerator = oldInGen;this.state.labels = oldLabels;
		  }
		  this.state.inAsync = oldInAsync;
	
		  // If this is a strict mode function, verify that argument names
		  // are not repeated, and it does not try to bind the words `eval`
		  // or `arguments`.
		  var isStrict = this.isStrictBody(node, isExpression);
		  // Also check when allowExpression === true for arrow functions
		  var checkLVal = this.state.strict || allowExpression || isStrict;
	
		  if (isStrict && node.id && node.id.type === "Identifier" && node.id.name === "yield") {
		    this.raise(node.id.start, "Binding yield in strict mode");
		  }
	
		  if (checkLVal) {
		    var nameHash = Object.create(null);
		    var oldStrict = this.state.strict;
		    if (isStrict) this.state.strict = true;
		    if (node.id) {
		      this.checkLVal(node.id, true, undefined, "function name");
		    }
		    for (var _iterator3 = node.params, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
		      var _ref3;
	
		      if (_isArray3) {
		        if (_i3 >= _iterator3.length) break;
		        _ref3 = _iterator3[_i3++];
		      } else {
		        _i3 = _iterator3.next();
		        if (_i3.done) break;
		        _ref3 = _i3.value;
		      }
	
		      var param = _ref3;
	
		      if (isStrict && param.type !== "Identifier") {
		        this.raise(param.start, "Non-simple parameter in strict mode");
		      }
		      this.checkLVal(param, true, nameHash, "function parameter list");
		    }
		    this.state.strict = oldStrict;
		  }
		};
	
		// Parses a comma-separated list of expressions, and returns them as
		// an array. `close` is the token type that ends the list, and
		// `allowEmpty` can be turned on to allow subsequent commas with
		// nothing in between them to be parsed as `null` (which is needed
		// for array literals).
	
		pp$3.parseExprList = function (close, allowEmpty, refShorthandDefaultPos) {
		  var elts = [];
		  var first = true;
	
		  while (!this.eat(close)) {
		    if (first) {
		      first = false;
		    } else {
		      this.expect(types.comma);
		      if (this.eat(close)) break;
		    }
	
		    elts.push(this.parseExprListItem(allowEmpty, refShorthandDefaultPos));
		  }
		  return elts;
		};
	
		pp$3.parseExprListItem = function (allowEmpty, refShorthandDefaultPos, refNeedsArrowPos) {
		  var elt = void 0;
		  if (allowEmpty && this.match(types.comma)) {
		    elt = null;
		  } else if (this.match(types.ellipsis)) {
		    elt = this.parseSpread(refShorthandDefaultPos);
		  } else {
		    elt = this.parseMaybeAssign(false, refShorthandDefaultPos, this.parseParenItem, refNeedsArrowPos);
		  }
		  return elt;
		};
	
		// Parse the next token as an identifier. If `liberal` is true (used
		// when parsing properties), it will also convert keywords into
		// identifiers.
	
		pp$3.parseIdentifier = function (liberal) {
		  var node = this.startNode();
		  if (!liberal) {
		    this.checkReservedWord(this.state.value, this.state.start, !!this.state.type.keyword, false);
		  }
	
		  if (this.match(types.name)) {
		    node.name = this.state.value;
		  } else if (this.state.type.keyword) {
		    node.name = this.state.type.keyword;
		  } else {
		    this.unexpected();
		  }
	
		  if (!liberal && node.name === "await" && this.state.inAsync) {
		    this.raise(node.start, "invalid use of await inside of an async function");
		  }
	
		  node.loc.identifierName = node.name;
	
		  this.next();
		  return this.finishNode(node, "Identifier");
		};
	
		pp$3.checkReservedWord = function (word, startLoc, checkKeywords, isBinding) {
		  if (this.isReservedWord(word) || checkKeywords && this.isKeyword(word)) {
		    this.raise(startLoc, word + " is a reserved word");
		  }
	
		  if (this.state.strict && (reservedWords.strict(word) || isBinding && reservedWords.strictBind(word))) {
		    this.raise(startLoc, word + " is a reserved word in strict mode");
		  }
		};
	
		// Parses await expression inside async function.
	
		pp$3.parseAwait = function (node) {
		  // istanbul ignore next: this condition is checked at the call site so won't be hit here
		  if (!this.state.inAsync) {
		    this.unexpected();
		  }
		  if (this.match(types.star)) {
		    this.raise(node.start, "await* has been removed from the async functions proposal. Use Promise.all() instead.");
		  }
		  node.argument = this.parseMaybeUnary();
		  return this.finishNode(node, "AwaitExpression");
		};
	
		// Parses yield expression inside generator.
	
		pp$3.parseYield = function () {
		  var node = this.startNode();
		  this.next();
		  if (this.match(types.semi) || this.canInsertSemicolon() || !this.match(types.star) && !this.state.type.startsExpr) {
		    node.delegate = false;
		    node.argument = null;
		  } else {
		    node.delegate = this.eat(types.star);
		    node.argument = this.parseMaybeAssign();
		  }
		  return this.finishNode(node, "YieldExpression");
		};
	
		// Start an AST node, attaching a start offset.
	
		var pp$4 = Parser.prototype;
		var commentKeys = ["leadingComments", "trailingComments", "innerComments"];
	
		var Node = function () {
		  function Node(pos, loc, filename) {
		    classCallCheck(this, Node);
	
		    this.type = "";
		    this.start = pos;
		    this.end = 0;
		    this.loc = new SourceLocation(loc);
		    if (filename) this.loc.filename = filename;
		  }
	
		  Node.prototype.__clone = function __clone() {
		    var node2 = new Node();
		    for (var key in this) {
		      // Do not clone comments that are already attached to the node
		      if (commentKeys.indexOf(key) < 0) {
		        node2[key] = this[key];
		      }
		    }
	
		    return node2;
		  };
	
		  return Node;
		}();
	
		pp$4.startNode = function () {
		  return new Node(this.state.start, this.state.startLoc, this.filename);
		};
	
		pp$4.startNodeAt = function (pos, loc) {
		  return new Node(pos, loc, this.filename);
		};
	
		function finishNodeAt(node, type, pos, loc) {
		  node.type = type;
		  node.end = pos;
		  node.loc.end = loc;
		  this.processComment(node);
		  return node;
		}
	
		// Finish an AST node, adding `type` and `end` properties.
	
		pp$4.finishNode = function (node, type) {
		  return finishNodeAt.call(this, node, type, this.state.lastTokEnd, this.state.lastTokEndLoc);
		};
	
		// Finish node at given position
	
		pp$4.finishNodeAt = function (node, type, pos, loc) {
		  return finishNodeAt.call(this, node, type, pos, loc);
		};
	
		var pp$5 = Parser.prototype;
	
		// This function is used to raise exceptions on parse errors. It
		// takes an offset integer (into the current `input`) to indicate
		// the location of the error, attaches the position to the end
		// of the error message, and then raises a `SyntaxError` with that
		// message.
	
		pp$5.raise = function (pos, message) {
		  var loc = getLineInfo(this.input, pos);
		  message += " (" + loc.line + ":" + loc.column + ")";
		  var err = new SyntaxError(message);
		  err.pos = pos;
		  err.loc = loc;
		  throw err;
		};
	
		/* eslint max-len: 0 */
	
		/**
		 * Based on the comment attachment algorithm used in espree and estraverse.
		 *
		 * Redistribution and use in source and binary forms, with or without
		 * modification, are permitted provided that the following conditions are met:
		 *
		 * * Redistributions of source code must retain the above copyright
		 *   notice, this list of conditions and the following disclaimer.
		 * * Redistributions in binary form must reproduce the above copyright
		 *   notice, this list of conditions and the following disclaimer in the
		 *   documentation and/or other materials provided with the distribution.
		 *
		 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
		 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
		 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
		 * ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
		 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
		 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
		 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
		 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
		 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
		 * THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		 */
	
		function last(stack) {
		  return stack[stack.length - 1];
		}
	
		var pp$6 = Parser.prototype;
	
		pp$6.addComment = function (comment) {
		  if (this.filename) comment.loc.filename = this.filename;
		  this.state.trailingComments.push(comment);
		  this.state.leadingComments.push(comment);
		};
	
		pp$6.processComment = function (node) {
		  if (node.type === "Program" && node.body.length > 0) return;
	
		  var stack = this.state.commentStack;
	
		  var firstChild = void 0,
		      lastChild = void 0,
		      trailingComments = void 0,
		      i = void 0,
		      j = void 0;
	
		  if (this.state.trailingComments.length > 0) {
		    // If the first comment in trailingComments comes after the
		    // current node, then we're good - all comments in the array will
		    // come after the node and so it's safe to add them as official
		    // trailingComments.
		    if (this.state.trailingComments[0].start >= node.end) {
		      trailingComments = this.state.trailingComments;
		      this.state.trailingComments = [];
		    } else {
		      // Otherwise, if the first comment doesn't come after the
		      // current node, that means we have a mix of leading and trailing
		      // comments in the array and that leadingComments contains the
		      // same items as trailingComments. Reset trailingComments to
		      // zero items and we'll handle this by evaluating leadingComments
		      // later.
		      this.state.trailingComments.length = 0;
		    }
		  } else {
		    var lastInStack = last(stack);
		    if (stack.length > 0 && lastInStack.trailingComments && lastInStack.trailingComments[0].start >= node.end) {
		      trailingComments = lastInStack.trailingComments;
		      lastInStack.trailingComments = null;
		    }
		  }
	
		  // Eating the stack.
		  if (stack.length > 0 && last(stack).start >= node.start) {
		    firstChild = stack.pop();
		  }
	
		  while (stack.length > 0 && last(stack).start >= node.start) {
		    lastChild = stack.pop();
		  }
	
		  if (!lastChild && firstChild) lastChild = firstChild;
	
		  // Attach comments that follow a trailing comma on the last
		  // property in an object literal or a trailing comma in function arguments
		  // as trailing comments
		  if (firstChild && this.state.leadingComments.length > 0) {
		    var lastComment = last(this.state.leadingComments);
	
		    if (firstChild.type === "ObjectProperty") {
		      if (lastComment.start >= node.start) {
		        if (this.state.commentPreviousNode) {
		          for (j = 0; j < this.state.leadingComments.length; j++) {
		            if (this.state.leadingComments[j].end < this.state.commentPreviousNode.end) {
		              this.state.leadingComments.splice(j, 1);
		              j--;
		            }
		          }
	
		          if (this.state.leadingComments.length > 0) {
		            firstChild.trailingComments = this.state.leadingComments;
		            this.state.leadingComments = [];
		          }
		        }
		      }
		    } else if (node.type === "CallExpression" && node.arguments && node.arguments.length) {
		      var lastArg = last(node.arguments);
	
		      if (lastArg && lastComment.start >= lastArg.start && lastComment.end <= node.end) {
		        if (this.state.commentPreviousNode) {
		          if (this.state.leadingComments.length > 0) {
		            lastArg.trailingComments = this.state.leadingComments;
		            this.state.leadingComments = [];
		          }
		        }
		      }
		    }
		  }
	
		  if (lastChild) {
		    if (lastChild.leadingComments) {
		      if (lastChild !== node && last(lastChild.leadingComments).end <= node.start) {
		        node.leadingComments = lastChild.leadingComments;
		        lastChild.leadingComments = null;
		      } else {
		        // A leading comment for an anonymous class had been stolen by its first ClassMethod,
		        // so this takes back the leading comment.
		        // See also: https://github.com/eslint/espree/issues/158
		        for (i = lastChild.leadingComments.length - 2; i >= 0; --i) {
		          if (lastChild.leadingComments[i].end <= node.start) {
		            node.leadingComments = lastChild.leadingComments.splice(0, i + 1);
		            break;
		          }
		        }
		      }
		    }
		  } else if (this.state.leadingComments.length > 0) {
		    if (last(this.state.leadingComments).end <= node.start) {
		      if (this.state.commentPreviousNode) {
		        for (j = 0; j < this.state.leadingComments.length; j++) {
		          if (this.state.leadingComments[j].end < this.state.commentPreviousNode.end) {
		            this.state.leadingComments.splice(j, 1);
		            j--;
		          }
		        }
		      }
		      if (this.state.leadingComments.length > 0) {
		        node.leadingComments = this.state.leadingComments;
		        this.state.leadingComments = [];
		      }
		    } else {
		      // https://github.com/eslint/espree/issues/2
		      //
		      // In special cases, such as return (without a value) and
		      // debugger, all comments will end up as leadingComments and
		      // will otherwise be eliminated. This step runs when the
		      // commentStack is empty and there are comments left
		      // in leadingComments.
		      //
		      // This loop figures out the stopping point between the actual
		      // leading and trailing comments by finding the location of the
		      // first comment that comes after the given node.
		      for (i = 0; i < this.state.leadingComments.length; i++) {
		        if (this.state.leadingComments[i].end > node.start) {
		          break;
		        }
		      }
	
		      // Split the array based on the location of the first comment
		      // that comes after the node. Keep in mind that this could
		      // result in an empty array, and if so, the array must be
		      // deleted.
		      node.leadingComments = this.state.leadingComments.slice(0, i);
		      if (node.leadingComments.length === 0) {
		        node.leadingComments = null;
		      }
	
		      // Similarly, trailing comments are attached later. The variable
		      // must be reset to null if there are no trailing comments.
		      trailingComments = this.state.leadingComments.slice(i);
		      if (trailingComments.length === 0) {
		        trailingComments = null;
		      }
		    }
		  }
	
		  this.state.commentPreviousNode = node;
	
		  if (trailingComments) {
		    if (trailingComments.length && trailingComments[0].start >= node.start && last(trailingComments).end <= node.end) {
		      node.innerComments = trailingComments;
		    } else {
		      node.trailingComments = trailingComments;
		    }
		  }
	
		  stack.push(node);
		};
	
		var pp$7 = Parser.prototype;
	
		pp$7.estreeParseRegExpLiteral = function (_ref) {
		  var pattern = _ref.pattern,
		      flags = _ref.flags;
	
		  var regex = null;
		  try {
		    regex = new RegExp(pattern, flags);
		  } catch (e) {
		    // In environments that don't support these flags value will
		    // be null as the regex can't be represented natively.
		  }
		  var node = this.estreeParseLiteral(regex);
		  node.regex = { pattern: pattern, flags: flags };
	
		  return node;
		};
	
		pp$7.estreeParseLiteral = function (value) {
		  return this.parseLiteral(value, "Literal");
		};
	
		pp$7.directiveToStmt = function (directive) {
		  var directiveLiteral = directive.value;
	
		  var stmt = this.startNodeAt(directive.start, directive.loc.start);
		  var expression = this.startNodeAt(directiveLiteral.start, directiveLiteral.loc.start);
	
		  expression.value = directiveLiteral.value;
		  expression.raw = directiveLiteral.extra.raw;
	
		  stmt.expression = this.finishNodeAt(expression, "Literal", directiveLiteral.end, directiveLiteral.loc.end);
		  stmt.directive = directiveLiteral.extra.raw.slice(1, -1);
	
		  return this.finishNodeAt(stmt, "ExpressionStatement", directive.end, directive.loc.end);
		};
	
		function isSimpleProperty(node) {
		  return node && node.type === "Property" && node.kind === "init" && node.method === false;
		}
	
		var estreePlugin = function estreePlugin(instance) {
		  instance.extend("checkDeclaration", function (inner) {
		    return function (node) {
		      if (isSimpleProperty(node)) {
		        this.checkDeclaration(node.value);
		      } else {
		        inner.call(this, node);
		      }
		    };
		  });
	
		  instance.extend("checkGetterSetterParamCount", function () {
		    return function (prop) {
		      var paramCount = prop.kind === "get" ? 0 : 1;
		      if (prop.value.params.length !== paramCount) {
		        var start = prop.start;
		        if (prop.kind === "get") {
		          this.raise(start, "getter should have no params");
		        } else {
		          this.raise(start, "setter should have exactly one param");
		        }
		      }
		    };
		  });
	
		  instance.extend("checkLVal", function (inner) {
		    return function (expr, isBinding, checkClashes) {
		      var _this = this;
	
		      switch (expr.type) {
		        case "ObjectPattern":
		          expr.properties.forEach(function (prop) {
		            _this.checkLVal(prop.type === "Property" ? prop.value : prop, isBinding, checkClashes, "object destructuring pattern");
		          });
		          break;
		        default:
		          for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
		            args[_key - 3] = arguments[_key];
		          }
	
		          inner.call.apply(inner, [this, expr, isBinding, checkClashes].concat(args));
		      }
		    };
		  });
	
		  instance.extend("checkPropClash", function () {
		    return function (prop, propHash) {
		      if (prop.computed || !isSimpleProperty(prop)) return;
	
		      var key = prop.key;
		      // It is either an Identifier or a String/NumericLiteral
		      var name = key.type === "Identifier" ? key.name : String(key.value);
	
		      if (name === "__proto__") {
		        if (propHash.proto) this.raise(key.start, "Redefinition of __proto__ property");
		        propHash.proto = true;
		      }
		    };
		  });
	
		  instance.extend("isStrictBody", function () {
		    return function (node, isExpression) {
		      if (!isExpression && node.body.body.length > 0) {
		        for (var _iterator = node.body.body, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		          var _ref2;
	
		          if (_isArray) {
		            if (_i >= _iterator.length) break;
		            _ref2 = _iterator[_i++];
		          } else {
		            _i = _iterator.next();
		            if (_i.done) break;
		            _ref2 = _i.value;
		          }
	
		          var directive = _ref2;
	
		          if (directive.type === "ExpressionStatement" && directive.expression.type === "Literal") {
		            if (directive.expression.value === "use strict") return true;
		          } else {
		            // Break for the first non literal expression
		            break;
		          }
		        }
		      }
	
		      return false;
		    };
		  });
	
		  instance.extend("isValidDirective", function () {
		    return function (stmt) {
		      return stmt.type === "ExpressionStatement" && stmt.expression.type === "Literal" && typeof stmt.expression.value === "string" && (!stmt.expression.extra || !stmt.expression.extra.parenthesized);
		    };
		  });
	
		  instance.extend("stmtToDirective", function (inner) {
		    return function (stmt) {
		      var directive = inner.call(this, stmt);
		      var value = stmt.expression.value;
	
		      // Reset value to the actual value as in estree mode we want
		      // the stmt to have the real value and not the raw value
		      directive.value.value = value;
	
		      return directive;
		    };
		  });
	
		  instance.extend("parseBlockBody", function (inner) {
		    return function (node) {
		      var _this2 = this;
	
		      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
		        args[_key2 - 1] = arguments[_key2];
		      }
	
		      inner.call.apply(inner, [this, node].concat(args));
	
		      node.directives.reverse().forEach(function (directive) {
		        node.body.unshift(_this2.directiveToStmt(directive));
		      });
		      delete node.directives;
		    };
		  });
	
		  instance.extend("parseClassMethod", function () {
		    return function (classBody, method, isGenerator, isAsync) {
		      this.parseMethod(method, isGenerator, isAsync);
		      if (method.typeParameters) {
		        method.value.typeParameters = method.typeParameters;
		        delete method.typeParameters;
		      }
		      classBody.body.push(this.finishNode(method, "MethodDefinition"));
		    };
		  });
	
		  instance.extend("parseExprAtom", function (inner) {
		    return function () {
		      switch (this.state.type) {
		        case types.regexp:
		          return this.estreeParseRegExpLiteral(this.state.value);
	
		        case types.num:
		        case types.string:
		          return this.estreeParseLiteral(this.state.value);
	
		        case types._null:
		          return this.estreeParseLiteral(null);
	
		        case types._true:
		          return this.estreeParseLiteral(true);
	
		        case types._false:
		          return this.estreeParseLiteral(false);
	
		        default:
		          for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
		            args[_key3] = arguments[_key3];
		          }
	
		          return inner.call.apply(inner, [this].concat(args));
		      }
		    };
		  });
	
		  instance.extend("parseLiteral", function (inner) {
		    return function () {
		      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
		        args[_key4] = arguments[_key4];
		      }
	
		      var node = inner.call.apply(inner, [this].concat(args));
		      node.raw = node.extra.raw;
		      delete node.extra;
	
		      return node;
		    };
		  });
	
		  instance.extend("parseMethod", function (inner) {
		    return function (node) {
		      var funcNode = this.startNode();
		      funcNode.kind = node.kind; // provide kind, so inner method correctly sets state
	
		      for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
		        args[_key5 - 1] = arguments[_key5];
		      }
	
		      funcNode = inner.call.apply(inner, [this, funcNode].concat(args));
		      delete funcNode.kind;
		      node.value = this.finishNode(funcNode, "FunctionExpression");
	
		      return node;
		    };
		  });
	
		  instance.extend("parseObjectMethod", function (inner) {
		    return function () {
		      for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
		        args[_key6] = arguments[_key6];
		      }
	
		      var node = inner.call.apply(inner, [this].concat(args));
	
		      if (node) {
		        if (node.kind === "method") node.kind = "init";
		        node.type = "Property";
		      }
	
		      return node;
		    };
		  });
	
		  instance.extend("parseObjectProperty", function (inner) {
		    return function () {
		      for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
		        args[_key7] = arguments[_key7];
		      }
	
		      var node = inner.call.apply(inner, [this].concat(args));
	
		      if (node) {
		        node.kind = "init";
		        node.type = "Property";
		      }
	
		      return node;
		    };
		  });
	
		  instance.extend("toAssignable", function (inner) {
		    return function (node, isBinding) {
		      for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
		        args[_key8 - 2] = arguments[_key8];
		      }
	
		      if (isSimpleProperty(node)) {
		        this.toAssignable.apply(this, [node.value, isBinding].concat(args));
	
		        return node;
		      } else if (node.type === "ObjectExpression") {
		        node.type = "ObjectPattern";
		        for (var _iterator2 = node.properties, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
		          var _ref3;
	
		          if (_isArray2) {
		            if (_i2 >= _iterator2.length) break;
		            _ref3 = _iterator2[_i2++];
		          } else {
		            _i2 = _iterator2.next();
		            if (_i2.done) break;
		            _ref3 = _i2.value;
		          }
	
		          var prop = _ref3;
	
		          if (prop.kind === "get" || prop.kind === "set") {
		            this.raise(prop.key.start, "Object pattern can't contain getter or setter");
		          } else if (prop.method) {
		            this.raise(prop.key.start, "Object pattern can't contain methods");
		          } else {
		            this.toAssignable(prop, isBinding, "object destructuring pattern");
		          }
		        }
	
		        return node;
		      }
	
		      return inner.call.apply(inner, [this, node, isBinding].concat(args));
		    };
		  });
		};
	
		/* eslint max-len: 0 */
	
		var primitiveTypes = ["any", "mixed", "empty", "bool", "boolean", "number", "string", "void", "null"];
	
		var pp$8 = Parser.prototype;
	
		pp$8.flowParseTypeInitialiser = function (tok) {
		  var oldInType = this.state.inType;
		  this.state.inType = true;
		  this.expect(tok || types.colon);
	
		  var type = this.flowParseType();
		  this.state.inType = oldInType;
		  return type;
		};
	
		pp$8.flowParsePredicate = function () {
		  var node = this.startNode();
		  var moduloLoc = this.state.startLoc;
		  var moduloPos = this.state.start;
		  this.expect(types.modulo);
		  var checksLoc = this.state.startLoc;
		  this.expectContextual("checks");
		  // Force '%' and 'checks' to be adjacent
		  if (moduloLoc.line !== checksLoc.line || moduloLoc.column !== checksLoc.column - 1) {
		    this.raise(moduloPos, "Spaces between ´%´ and ´checks´ are not allowed here.");
		  }
		  if (this.eat(types.parenL)) {
		    node.expression = this.parseExpression();
		    this.expect(types.parenR);
		    return this.finishNode(node, "DeclaredPredicate");
		  } else {
		    return this.finishNode(node, "InferredPredicate");
		  }
		};
	
		pp$8.flowParseTypeAndPredicateInitialiser = function () {
		  var oldInType = this.state.inType;
		  this.state.inType = true;
		  this.expect(types.colon);
		  var type = null;
		  var predicate = null;
		  if (this.match(types.modulo)) {
		    this.state.inType = oldInType;
		    predicate = this.flowParsePredicate();
		  } else {
		    type = this.flowParseType();
		    this.state.inType = oldInType;
		    if (this.match(types.modulo)) {
		      predicate = this.flowParsePredicate();
		    }
		  }
		  return [type, predicate];
		};
	
		pp$8.flowParseDeclareClass = function (node) {
		  this.next();
		  this.flowParseInterfaceish(node, true);
		  return this.finishNode(node, "DeclareClass");
		};
	
		pp$8.flowParseDeclareFunction = function (node) {
		  this.next();
	
		  var id = node.id = this.parseIdentifier();
	
		  var typeNode = this.startNode();
		  var typeContainer = this.startNode();
	
		  if (this.isRelational("<")) {
		    typeNode.typeParameters = this.flowParseTypeParameterDeclaration();
		  } else {
		    typeNode.typeParameters = null;
		  }
	
		  this.expect(types.parenL);
		  var tmp = this.flowParseFunctionTypeParams();
		  typeNode.params = tmp.params;
		  typeNode.rest = tmp.rest;
		  this.expect(types.parenR);
		  var predicate = null;
	
		  var _flowParseTypeAndPred = this.flowParseTypeAndPredicateInitialiser();
	
		  typeNode.returnType = _flowParseTypeAndPred[0];
		  predicate = _flowParseTypeAndPred[1];
	
		  typeContainer.typeAnnotation = this.finishNode(typeNode, "FunctionTypeAnnotation");
		  typeContainer.predicate = predicate;
		  id.typeAnnotation = this.finishNode(typeContainer, "TypeAnnotation");
	
		  this.finishNode(id, id.type);
	
		  this.semicolon();
	
		  return this.finishNode(node, "DeclareFunction");
		};
	
		pp$8.flowParseDeclare = function (node) {
		  if (this.match(types._class)) {
		    return this.flowParseDeclareClass(node);
		  } else if (this.match(types._function)) {
		    return this.flowParseDeclareFunction(node);
		  } else if (this.match(types._var)) {
		    return this.flowParseDeclareVariable(node);
		  } else if (this.isContextual("module")) {
		    if (this.lookahead().type === types.dot) {
		      return this.flowParseDeclareModuleExports(node);
		    } else {
		      return this.flowParseDeclareModule(node);
		    }
		  } else if (this.isContextual("type")) {
		    return this.flowParseDeclareTypeAlias(node);
		  } else if (this.isContextual("opaque")) {
		    return this.flowParseDeclareOpaqueType(node);
		  } else if (this.isContextual("interface")) {
		    return this.flowParseDeclareInterface(node);
		  } else if (this.match(types._export)) {
		    return this.flowParseDeclareExportDeclaration(node);
		  } else {
		    this.unexpected();
		  }
		};
	
		pp$8.flowParseDeclareExportDeclaration = function (node) {
		  this.expect(types._export);
		  if (this.isContextual("opaque") // declare export opaque ...
		  ) {
		      node.declaration = this.flowParseDeclare(this.startNode());
		      node.default = false;
	
		      return this.finishNode(node, "DeclareExportDeclaration");
		    }
	
		  throw this.unexpected();
		};
	
		pp$8.flowParseDeclareVariable = function (node) {
		  this.next();
		  node.id = this.flowParseTypeAnnotatableIdentifier();
		  this.semicolon();
		  return this.finishNode(node, "DeclareVariable");
		};
	
		pp$8.flowParseDeclareModule = function (node) {
		  this.next();
	
		  if (this.match(types.string)) {
		    node.id = this.parseExprAtom();
		  } else {
		    node.id = this.parseIdentifier();
		  }
	
		  var bodyNode = node.body = this.startNode();
		  var body = bodyNode.body = [];
		  this.expect(types.braceL);
		  while (!this.match(types.braceR)) {
		    var _bodyNode = this.startNode();
	
		    if (this.match(types._import)) {
		      var lookahead = this.lookahead();
		      if (lookahead.value !== "type" && lookahead.value !== "typeof") {
		        this.unexpected(null, "Imports within a `declare module` body must always be `import type` or `import typeof`");
		      }
	
		      this.parseImport(_bodyNode);
		    } else {
		      this.expectContextual("declare", "Only declares and type imports are allowed inside declare module");
	
		      _bodyNode = this.flowParseDeclare(_bodyNode, true);
		    }
	
		    body.push(_bodyNode);
		  }
		  this.expect(types.braceR);
	
		  this.finishNode(bodyNode, "BlockStatement");
		  return this.finishNode(node, "DeclareModule");
		};
	
		pp$8.flowParseDeclareModuleExports = function (node) {
		  this.expectContextual("module");
		  this.expect(types.dot);
		  this.expectContextual("exports");
		  node.typeAnnotation = this.flowParseTypeAnnotation();
		  this.semicolon();
	
		  return this.finishNode(node, "DeclareModuleExports");
		};
	
		pp$8.flowParseDeclareTypeAlias = function (node) {
		  this.next();
		  this.flowParseTypeAlias(node);
		  return this.finishNode(node, "DeclareTypeAlias");
		};
	
		pp$8.flowParseDeclareOpaqueType = function (node) {
		  this.next();
		  this.flowParseOpaqueType(node, true);
		  return this.finishNode(node, "DeclareOpaqueType");
		};
	
		pp$8.flowParseDeclareInterface = function (node) {
		  this.next();
		  this.flowParseInterfaceish(node);
		  return this.finishNode(node, "DeclareInterface");
		};
	
		// Interfaces
	
		pp$8.flowParseInterfaceish = function (node) {
		  node.id = this.parseIdentifier();
	
		  if (this.isRelational("<")) {
		    node.typeParameters = this.flowParseTypeParameterDeclaration();
		  } else {
		    node.typeParameters = null;
		  }
	
		  node.extends = [];
		  node.mixins = [];
	
		  if (this.eat(types._extends)) {
		    do {
		      node.extends.push(this.flowParseInterfaceExtends());
		    } while (this.eat(types.comma));
		  }
	
		  if (this.isContextual("mixins")) {
		    this.next();
		    do {
		      node.mixins.push(this.flowParseInterfaceExtends());
		    } while (this.eat(types.comma));
		  }
	
		  node.body = this.flowParseObjectType(true, false, false);
		};
	
		pp$8.flowParseInterfaceExtends = function () {
		  var node = this.startNode();
	
		  node.id = this.flowParseQualifiedTypeIdentifier();
		  if (this.isRelational("<")) {
		    node.typeParameters = this.flowParseTypeParameterInstantiation();
		  } else {
		    node.typeParameters = null;
		  }
	
		  return this.finishNode(node, "InterfaceExtends");
		};
	
		pp$8.flowParseInterface = function (node) {
		  this.flowParseInterfaceish(node, false);
		  return this.finishNode(node, "InterfaceDeclaration");
		};
	
		pp$8.flowParseRestrictedIdentifier = function (liberal) {
		  if (primitiveTypes.indexOf(this.state.value) > -1) {
		    this.raise(this.state.start, "Cannot overwrite primitive type " + this.state.value);
		  }
	
		  return this.parseIdentifier(liberal);
		};
	
		// Type aliases
	
		pp$8.flowParseTypeAlias = function (node) {
		  node.id = this.flowParseRestrictedIdentifier();
	
		  if (this.isRelational("<")) {
		    node.typeParameters = this.flowParseTypeParameterDeclaration();
		  } else {
		    node.typeParameters = null;
		  }
	
		  node.right = this.flowParseTypeInitialiser(types.eq);
		  this.semicolon();
	
		  return this.finishNode(node, "TypeAlias");
		};
	
		// Opaque type aliases
	
		pp$8.flowParseOpaqueType = function (node, declare) {
		  this.expectContextual("type");
		  node.id = this.flowParseRestrictedIdentifier();
	
		  if (this.isRelational("<")) {
		    node.typeParameters = this.flowParseTypeParameterDeclaration();
		  } else {
		    node.typeParameters = null;
		  }
	
		  // Parse the supertype
		  node.supertype = null;
		  if (this.match(types.colon)) {
		    node.supertype = this.flowParseTypeInitialiser(types.colon);
		  }
	
		  node.impltype = null;
		  if (!declare) {
		    node.impltype = this.flowParseTypeInitialiser(types.eq);
		  }
		  this.semicolon();
	
		  return this.finishNode(node, "OpaqueType");
		};
	
		// Type annotations
	
		pp$8.flowParseTypeParameter = function () {
		  var node = this.startNode();
	
		  var variance = this.flowParseVariance();
	
		  var ident = this.flowParseTypeAnnotatableIdentifier();
		  node.name = ident.name;
		  node.variance = variance;
		  node.bound = ident.typeAnnotation;
	
		  if (this.match(types.eq)) {
		    this.eat(types.eq);
		    node.default = this.flowParseType();
		  }
	
		  return this.finishNode(node, "TypeParameter");
		};
	
		pp$8.flowParseTypeParameterDeclaration = function () {
		  var oldInType = this.state.inType;
		  var node = this.startNode();
		  node.params = [];
	
		  this.state.inType = true;
	
		  // istanbul ignore else: this condition is already checked at all call sites
		  if (this.isRelational("<") || this.match(types.jsxTagStart)) {
		    this.next();
		  } else {
		    this.unexpected();
		  }
	
		  do {
		    node.params.push(this.flowParseTypeParameter());
		    if (!this.isRelational(">")) {
		      this.expect(types.comma);
		    }
		  } while (!this.isRelational(">"));
		  this.expectRelational(">");
	
		  this.state.inType = oldInType;
	
		  return this.finishNode(node, "TypeParameterDeclaration");
		};
	
		pp$8.flowParseTypeParameterInstantiation = function () {
		  var node = this.startNode();
		  var oldInType = this.state.inType;
		  node.params = [];
	
		  this.state.inType = true;
	
		  this.expectRelational("<");
		  while (!this.isRelational(">")) {
		    node.params.push(this.flowParseType());
		    if (!this.isRelational(">")) {
		      this.expect(types.comma);
		    }
		  }
		  this.expectRelational(">");
	
		  this.state.inType = oldInType;
	
		  return this.finishNode(node, "TypeParameterInstantiation");
		};
	
		pp$8.flowParseObjectPropertyKey = function () {
		  return this.match(types.num) || this.match(types.string) ? this.parseExprAtom() : this.parseIdentifier(true);
		};
	
		pp$8.flowParseObjectTypeIndexer = function (node, isStatic, variance) {
		  node.static = isStatic;
	
		  this.expect(types.bracketL);
		  if (this.lookahead().type === types.colon) {
		    node.id = this.flowParseObjectPropertyKey();
		    node.key = this.flowParseTypeInitialiser();
		  } else {
		    node.id = null;
		    node.key = this.flowParseType();
		  }
		  this.expect(types.bracketR);
		  node.value = this.flowParseTypeInitialiser();
		  node.variance = variance;
	
		  this.flowObjectTypeSemicolon();
		  return this.finishNode(node, "ObjectTypeIndexer");
		};
	
		pp$8.flowParseObjectTypeMethodish = function (node) {
		  node.params = [];
		  node.rest = null;
		  node.typeParameters = null;
	
		  if (this.isRelational("<")) {
		    node.typeParameters = this.flowParseTypeParameterDeclaration();
		  }
	
		  this.expect(types.parenL);
		  while (!this.match(types.parenR) && !this.match(types.ellipsis)) {
		    node.params.push(this.flowParseFunctionTypeParam());
		    if (!this.match(types.parenR)) {
		      this.expect(types.comma);
		    }
		  }
	
		  if (this.eat(types.ellipsis)) {
		    node.rest = this.flowParseFunctionTypeParam();
		  }
		  this.expect(types.parenR);
		  node.returnType = this.flowParseTypeInitialiser();
	
		  return this.finishNode(node, "FunctionTypeAnnotation");
		};
	
		pp$8.flowParseObjectTypeMethod = function (startPos, startLoc, isStatic, key) {
		  var node = this.startNodeAt(startPos, startLoc);
		  node.value = this.flowParseObjectTypeMethodish(this.startNodeAt(startPos, startLoc));
		  node.static = isStatic;
		  node.key = key;
		  node.optional = false;
		  this.flowObjectTypeSemicolon();
		  return this.finishNode(node, "ObjectTypeProperty");
		};
	
		pp$8.flowParseObjectTypeCallProperty = function (node, isStatic) {
		  var valueNode = this.startNode();
		  node.static = isStatic;
		  node.value = this.flowParseObjectTypeMethodish(valueNode);
		  this.flowObjectTypeSemicolon();
		  return this.finishNode(node, "ObjectTypeCallProperty");
		};
	
		pp$8.flowParseObjectType = function (allowStatic, allowExact, allowSpread) {
		  var oldInType = this.state.inType;
		  this.state.inType = true;
	
		  var nodeStart = this.startNode();
		  var node = void 0;
		  var propertyKey = void 0;
		  var isStatic = false;
	
		  nodeStart.callProperties = [];
		  nodeStart.properties = [];
		  nodeStart.indexers = [];
	
		  var endDelim = void 0;
		  var exact = void 0;
		  if (allowExact && this.match(types.braceBarL)) {
		    this.expect(types.braceBarL);
		    endDelim = types.braceBarR;
		    exact = true;
		  } else {
		    this.expect(types.braceL);
		    endDelim = types.braceR;
		    exact = false;
		  }
	
		  nodeStart.exact = exact;
	
		  while (!this.match(endDelim)) {
		    var optional = false;
		    var startPos = this.state.start;
		    var startLoc = this.state.startLoc;
		    node = this.startNode();
		    if (allowStatic && this.isContextual("static") && this.lookahead().type !== types.colon) {
		      this.next();
		      isStatic = true;
		    }
	
		    var variancePos = this.state.start;
		    var variance = this.flowParseVariance();
	
		    if (this.match(types.bracketL)) {
		      nodeStart.indexers.push(this.flowParseObjectTypeIndexer(node, isStatic, variance));
		    } else if (this.match(types.parenL) || this.isRelational("<")) {
		      if (variance) {
		        this.unexpected(variancePos);
		      }
		      nodeStart.callProperties.push(this.flowParseObjectTypeCallProperty(node, isStatic));
		    } else {
		      if (this.match(types.ellipsis)) {
		        if (!allowSpread) {
		          this.unexpected(null, "Spread operator cannot appear in class or interface definitions");
		        }
		        if (variance) {
		          this.unexpected(variance.start, "Spread properties cannot have variance");
		        }
		        this.expect(types.ellipsis);
		        node.argument = this.flowParseType();
		        this.flowObjectTypeSemicolon();
		        nodeStart.properties.push(this.finishNode(node, "ObjectTypeSpreadProperty"));
		      } else {
		        propertyKey = this.flowParseObjectPropertyKey();
		        if (this.isRelational("<") || this.match(types.parenL)) {
		          // This is a method property
		          if (variance) {
		            this.unexpected(variance.start);
		          }
		          nodeStart.properties.push(this.flowParseObjectTypeMethod(startPos, startLoc, isStatic, propertyKey));
		        } else {
		          if (this.eat(types.question)) {
		            optional = true;
		          }
		          node.key = propertyKey;
		          node.value = this.flowParseTypeInitialiser();
		          node.optional = optional;
		          node.static = isStatic;
		          node.variance = variance;
		          this.flowObjectTypeSemicolon();
		          nodeStart.properties.push(this.finishNode(node, "ObjectTypeProperty"));
		        }
		      }
		    }
	
		    isStatic = false;
		  }
	
		  this.expect(endDelim);
	
		  var out = this.finishNode(nodeStart, "ObjectTypeAnnotation");
	
		  this.state.inType = oldInType;
	
		  return out;
		};
	
		pp$8.flowObjectTypeSemicolon = function () {
		  if (!this.eat(types.semi) && !this.eat(types.comma) && !this.match(types.braceR) && !this.match(types.braceBarR)) {
		    this.unexpected();
		  }
		};
	
		pp$8.flowParseQualifiedTypeIdentifier = function (startPos, startLoc, id) {
		  startPos = startPos || this.state.start;
		  startLoc = startLoc || this.state.startLoc;
		  var node = id || this.parseIdentifier();
	
		  while (this.eat(types.dot)) {
		    var node2 = this.startNodeAt(startPos, startLoc);
		    node2.qualification = node;
		    node2.id = this.parseIdentifier();
		    node = this.finishNode(node2, "QualifiedTypeIdentifier");
		  }
	
		  return node;
		};
	
		pp$8.flowParseGenericType = function (startPos, startLoc, id) {
		  var node = this.startNodeAt(startPos, startLoc);
	
		  node.typeParameters = null;
		  node.id = this.flowParseQualifiedTypeIdentifier(startPos, startLoc, id);
	
		  if (this.isRelational("<")) {
		    node.typeParameters = this.flowParseTypeParameterInstantiation();
		  }
	
		  return this.finishNode(node, "GenericTypeAnnotation");
		};
	
		pp$8.flowParseTypeofType = function () {
		  var node = this.startNode();
		  this.expect(types._typeof);
		  node.argument = this.flowParsePrimaryType();
		  return this.finishNode(node, "TypeofTypeAnnotation");
		};
	
		pp$8.flowParseTupleType = function () {
		  var node = this.startNode();
		  node.types = [];
		  this.expect(types.bracketL);
		  // We allow trailing commas
		  while (this.state.pos < this.input.length && !this.match(types.bracketR)) {
		    node.types.push(this.flowParseType());
		    if (this.match(types.bracketR)) break;
		    this.expect(types.comma);
		  }
		  this.expect(types.bracketR);
		  return this.finishNode(node, "TupleTypeAnnotation");
		};
	
		pp$8.flowParseFunctionTypeParam = function () {
		  var name = null;
		  var optional = false;
		  var typeAnnotation = null;
		  var node = this.startNode();
		  var lh = this.lookahead();
		  if (lh.type === types.colon || lh.type === types.question) {
		    name = this.parseIdentifier();
		    if (this.eat(types.question)) {
		      optional = true;
		    }
		    typeAnnotation = this.flowParseTypeInitialiser();
		  } else {
		    typeAnnotation = this.flowParseType();
		  }
		  node.name = name;
		  node.optional = optional;
		  node.typeAnnotation = typeAnnotation;
		  return this.finishNode(node, "FunctionTypeParam");
		};
	
		pp$8.reinterpretTypeAsFunctionTypeParam = function (type) {
		  var node = this.startNodeAt(type.start, type.loc.start);
		  node.name = null;
		  node.optional = false;
		  node.typeAnnotation = type;
		  return this.finishNode(node, "FunctionTypeParam");
		};
	
		pp$8.flowParseFunctionTypeParams = function () {
		  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
		  var ret = { params: params, rest: null };
		  while (!this.match(types.parenR) && !this.match(types.ellipsis)) {
		    ret.params.push(this.flowParseFunctionTypeParam());
		    if (!this.match(types.parenR)) {
		      this.expect(types.comma);
		    }
		  }
		  if (this.eat(types.ellipsis)) {
		    ret.rest = this.flowParseFunctionTypeParam();
		  }
		  return ret;
		};
	
		pp$8.flowIdentToTypeAnnotation = function (startPos, startLoc, node, id) {
		  switch (id.name) {
		    case "any":
		      return this.finishNode(node, "AnyTypeAnnotation");
	
		    case "void":
		      return this.finishNode(node, "VoidTypeAnnotation");
	
		    case "bool":
		    case "boolean":
		      return this.finishNode(node, "BooleanTypeAnnotation");
	
		    case "mixed":
		      return this.finishNode(node, "MixedTypeAnnotation");
	
		    case "empty":
		      return this.finishNode(node, "EmptyTypeAnnotation");
	
		    case "number":
		      return this.finishNode(node, "NumberTypeAnnotation");
	
		    case "string":
		      return this.finishNode(node, "StringTypeAnnotation");
	
		    default:
		      return this.flowParseGenericType(startPos, startLoc, id);
		  }
		};
	
		// The parsing of types roughly parallels the parsing of expressions, and
		// primary types are kind of like primary expressions...they're the
		// primitives with which other types are constructed.
		pp$8.flowParsePrimaryType = function () {
		  var startPos = this.state.start;
		  var startLoc = this.state.startLoc;
		  var node = this.startNode();
		  var tmp = void 0;
		  var type = void 0;
		  var isGroupedType = false;
		  var oldNoAnonFunctionType = this.state.noAnonFunctionType;
	
		  switch (this.state.type) {
		    case types.name:
		      return this.flowIdentToTypeAnnotation(startPos, startLoc, node, this.parseIdentifier());
	
		    case types.braceL:
		      return this.flowParseObjectType(false, false, true);
	
		    case types.braceBarL:
		      return this.flowParseObjectType(false, true, true);
	
		    case types.bracketL:
		      return this.flowParseTupleType();
	
		    case types.relational:
		      if (this.state.value === "<") {
		        node.typeParameters = this.flowParseTypeParameterDeclaration();
		        this.expect(types.parenL);
		        tmp = this.flowParseFunctionTypeParams();
		        node.params = tmp.params;
		        node.rest = tmp.rest;
		        this.expect(types.parenR);
	
		        this.expect(types.arrow);
	
		        node.returnType = this.flowParseType();
	
		        return this.finishNode(node, "FunctionTypeAnnotation");
		      }
		      break;
	
		    case types.parenL:
		      this.next();
	
		      // Check to see if this is actually a grouped type
		      if (!this.match(types.parenR) && !this.match(types.ellipsis)) {
		        if (this.match(types.name)) {
		          var token = this.lookahead().type;
		          isGroupedType = token !== types.question && token !== types.colon;
		        } else {
		          isGroupedType = true;
		        }
		      }
	
		      if (isGroupedType) {
		        this.state.noAnonFunctionType = false;
		        type = this.flowParseType();
		        this.state.noAnonFunctionType = oldNoAnonFunctionType;
	
		        // A `,` or a `) =>` means this is an anonymous function type
		        if (this.state.noAnonFunctionType || !(this.match(types.comma) || this.match(types.parenR) && this.lookahead().type === types.arrow)) {
		          this.expect(types.parenR);
		          return type;
		        } else {
		          // Eat a comma if there is one
		          this.eat(types.comma);
		        }
		      }
	
		      if (type) {
		        tmp = this.flowParseFunctionTypeParams([this.reinterpretTypeAsFunctionTypeParam(type)]);
		      } else {
		        tmp = this.flowParseFunctionTypeParams();
		      }
	
		      node.params = tmp.params;
		      node.rest = tmp.rest;
	
		      this.expect(types.parenR);
	
		      this.expect(types.arrow);
	
		      node.returnType = this.flowParseType();
	
		      node.typeParameters = null;
	
		      return this.finishNode(node, "FunctionTypeAnnotation");
	
		    case types.string:
		      return this.parseLiteral(this.state.value, "StringLiteralTypeAnnotation");
	
		    case types._true:case types._false:
		      node.value = this.match(types._true);
		      this.next();
		      return this.finishNode(node, "BooleanLiteralTypeAnnotation");
	
		    case types.plusMin:
		      if (this.state.value === "-") {
		        this.next();
		        if (!this.match(types.num)) this.unexpected(null, "Unexpected token, expected number");
	
		        return this.parseLiteral(-this.state.value, "NumericLiteralTypeAnnotation", node.start, node.loc.start);
		      }
	
		      this.unexpected();
		    case types.num:
		      return this.parseLiteral(this.state.value, "NumericLiteralTypeAnnotation");
	
		    case types._null:
		      node.value = this.match(types._null);
		      this.next();
		      return this.finishNode(node, "NullLiteralTypeAnnotation");
	
		    case types._this:
		      node.value = this.match(types._this);
		      this.next();
		      return this.finishNode(node, "ThisTypeAnnotation");
	
		    case types.star:
		      this.next();
		      return this.finishNode(node, "ExistentialTypeParam");
	
		    default:
		      if (this.state.type.keyword === "typeof") {
		        return this.flowParseTypeofType();
		      }
		  }
	
		  this.unexpected();
		};
	
		pp$8.flowParsePostfixType = function () {
		  var startPos = this.state.start,
		      startLoc = this.state.startLoc;
		  var type = this.flowParsePrimaryType();
		  while (!this.canInsertSemicolon() && this.match(types.bracketL)) {
		    var node = this.startNodeAt(startPos, startLoc);
		    node.elementType = type;
		    this.expect(types.bracketL);
		    this.expect(types.bracketR);
		    type = this.finishNode(node, "ArrayTypeAnnotation");
		  }
		  return type;
		};
	
		pp$8.flowParsePrefixType = function () {
		  var node = this.startNode();
		  if (this.eat(types.question)) {
		    node.typeAnnotation = this.flowParsePrefixType();
		    return this.finishNode(node, "NullableTypeAnnotation");
		  } else {
		    return this.flowParsePostfixType();
		  }
		};
	
		pp$8.flowParseAnonFunctionWithoutParens = function () {
		  var param = this.flowParsePrefixType();
		  if (!this.state.noAnonFunctionType && this.eat(types.arrow)) {
		    var node = this.startNodeAt(param.start, param.loc.start);
		    node.params = [this.reinterpretTypeAsFunctionTypeParam(param)];
		    node.rest = null;
		    node.returnType = this.flowParseType();
		    node.typeParameters = null;
		    return this.finishNode(node, "FunctionTypeAnnotation");
		  }
		  return param;
		};
	
		pp$8.flowParseIntersectionType = function () {
		  var node = this.startNode();
		  this.eat(types.bitwiseAND);
		  var type = this.flowParseAnonFunctionWithoutParens();
		  node.types = [type];
		  while (this.eat(types.bitwiseAND)) {
		    node.types.push(this.flowParseAnonFunctionWithoutParens());
		  }
		  return node.types.length === 1 ? type : this.finishNode(node, "IntersectionTypeAnnotation");
		};
	
		pp$8.flowParseUnionType = function () {
		  var node = this.startNode();
		  this.eat(types.bitwiseOR);
		  var type = this.flowParseIntersectionType();
		  node.types = [type];
		  while (this.eat(types.bitwiseOR)) {
		    node.types.push(this.flowParseIntersectionType());
		  }
		  return node.types.length === 1 ? type : this.finishNode(node, "UnionTypeAnnotation");
		};
	
		pp$8.flowParseType = function () {
		  var oldInType = this.state.inType;
		  this.state.inType = true;
		  var type = this.flowParseUnionType();
		  this.state.inType = oldInType;
		  return type;
		};
	
		pp$8.flowParseTypeAnnotation = function () {
		  var node = this.startNode();
		  node.typeAnnotation = this.flowParseTypeInitialiser();
		  return this.finishNode(node, "TypeAnnotation");
		};
	
		pp$8.flowParseTypeAndPredicateAnnotation = function () {
		  var node = this.startNode();
	
		  var _flowParseTypeAndPred2 = this.flowParseTypeAndPredicateInitialiser();
	
		  node.typeAnnotation = _flowParseTypeAndPred2[0];
		  node.predicate = _flowParseTypeAndPred2[1];
	
		  return this.finishNode(node, "TypeAnnotation");
		};
	
		pp$8.flowParseTypeAnnotatableIdentifier = function () {
		  var ident = this.flowParseRestrictedIdentifier();
		  if (this.match(types.colon)) {
		    ident.typeAnnotation = this.flowParseTypeAnnotation();
		    this.finishNode(ident, ident.type);
		  }
		  return ident;
		};
	
		pp$8.typeCastToParameter = function (node) {
		  node.expression.typeAnnotation = node.typeAnnotation;
	
		  return this.finishNodeAt(node.expression, node.expression.type, node.typeAnnotation.end, node.typeAnnotation.loc.end);
		};
	
		pp$8.flowParseVariance = function () {
		  var variance = null;
		  if (this.match(types.plusMin)) {
		    if (this.state.value === "+") {
		      variance = "plus";
		    } else if (this.state.value === "-") {
		      variance = "minus";
		    }
		    this.next();
		  }
		  return variance;
		};
	
		var flowPlugin = function flowPlugin(instance) {
		  // plain function return types: function name(): string {}
		  instance.extend("parseFunctionBody", function (inner) {
		    return function (node, allowExpression) {
		      if (this.match(types.colon) && !allowExpression) {
		        // if allowExpression is true then we're parsing an arrow function and if
		        // there's a return type then it's been handled elsewhere
		        node.returnType = this.flowParseTypeAndPredicateAnnotation();
		      }
	
		      return inner.call(this, node, allowExpression);
		    };
		  });
	
		  // interfaces
		  instance.extend("parseStatement", function (inner) {
		    return function (declaration, topLevel) {
		      // strict mode handling of `interface` since it's a reserved word
		      if (this.state.strict && this.match(types.name) && this.state.value === "interface") {
		        var node = this.startNode();
		        this.next();
		        return this.flowParseInterface(node);
		      } else {
		        return inner.call(this, declaration, topLevel);
		      }
		    };
		  });
	
		  // declares, interfaces and type aliases
		  instance.extend("parseExpressionStatement", function (inner) {
		    return function (node, expr) {
		      if (expr.type === "Identifier") {
		        if (expr.name === "declare") {
		          if (this.match(types._class) || this.match(types.name) || this.match(types._function) || this.match(types._var) || this.match(types._export)) {
		            return this.flowParseDeclare(node);
		          }
		        } else if (this.match(types.name)) {
		          if (expr.name === "interface") {
		            return this.flowParseInterface(node);
		          } else if (expr.name === "type") {
		            return this.flowParseTypeAlias(node);
		          } else if (expr.name === "opaque") {
		            return this.flowParseOpaqueType(node, false);
		          }
		        }
		      }
	
		      return inner.call(this, node, expr);
		    };
		  });
	
		  // export type
		  instance.extend("shouldParseExportDeclaration", function (inner) {
		    return function () {
		      return this.isContextual("type") || this.isContextual("interface") || this.isContextual("opaque") || inner.call(this);
		    };
		  });
	
		  instance.extend("isExportDefaultSpecifier", function (inner) {
		    return function () {
		      if (this.match(types.name) && (this.state.value === "type" || this.state.value === "interface" || this.state.value === "opaque")) {
		        return false;
		      }
	
		      return inner.call(this);
		    };
		  });
	
		  instance.extend("parseConditional", function (inner) {
		    return function (expr, noIn, startPos, startLoc, refNeedsArrowPos) {
		      // only do the expensive clone if there is a question mark
		      // and if we come from inside parens
		      if (refNeedsArrowPos && this.match(types.question)) {
		        var state = this.state.clone();
		        try {
		          return inner.call(this, expr, noIn, startPos, startLoc);
		        } catch (err) {
		          if (err instanceof SyntaxError) {
		            this.state = state;
		            refNeedsArrowPos.start = err.pos || this.state.start;
		            return expr;
		          } else {
		            // istanbul ignore next: no such error is expected
		            throw err;
		          }
		        }
		      }
	
		      return inner.call(this, expr, noIn, startPos, startLoc);
		    };
		  });
	
		  instance.extend("parseParenItem", function (inner) {
		    return function (node, startPos, startLoc) {
		      node = inner.call(this, node, startPos, startLoc);
		      if (this.eat(types.question)) {
		        node.optional = true;
		      }
	
		      if (this.match(types.colon)) {
		        var typeCastNode = this.startNodeAt(startPos, startLoc);
		        typeCastNode.expression = node;
		        typeCastNode.typeAnnotation = this.flowParseTypeAnnotation();
	
		        return this.finishNode(typeCastNode, "TypeCastExpression");
		      }
	
		      return node;
		    };
		  });
	
		  instance.extend("parseExport", function (inner) {
		    return function (node) {
		      node = inner.call(this, node);
		      if (node.type === "ExportNamedDeclaration") {
		        node.exportKind = node.exportKind || "value";
		      }
		      return node;
		    };
		  });
	
		  instance.extend("parseExportDeclaration", function (inner) {
		    return function (node) {
		      if (this.isContextual("type")) {
		        node.exportKind = "type";
	
		        var declarationNode = this.startNode();
		        this.next();
	
		        if (this.match(types.braceL)) {
		          // export type { foo, bar };
		          node.specifiers = this.parseExportSpecifiers();
		          this.parseExportFrom(node);
		          return null;
		        } else {
		          // export type Foo = Bar;
		          return this.flowParseTypeAlias(declarationNode);
		        }
		      } else if (this.isContextual("opaque")) {
		        node.exportKind = "type";
	
		        var _declarationNode = this.startNode();
		        this.next();
		        // export opaque type Foo = Bar;
		        return this.flowParseOpaqueType(_declarationNode, false);
		      } else if (this.isContextual("interface")) {
		        node.exportKind = "type";
		        var _declarationNode2 = this.startNode();
		        this.next();
		        return this.flowParseInterface(_declarationNode2);
		      } else {
		        return inner.call(this, node);
		      }
		    };
		  });
	
		  instance.extend("parseClassId", function (inner) {
		    return function (node) {
		      inner.apply(this, arguments);
		      if (this.isRelational("<")) {
		        node.typeParameters = this.flowParseTypeParameterDeclaration();
		      }
		    };
		  });
	
		  // don't consider `void` to be a keyword as then it'll use the void token type
		  // and set startExpr
		  instance.extend("isKeyword", function (inner) {
		    return function (name) {
		      if (this.state.inType && name === "void") {
		        return false;
		      } else {
		        return inner.call(this, name);
		      }
		    };
		  });
	
		  // ensure that inside flow types, we bypass the jsx parser plugin
		  instance.extend("readToken", function (inner) {
		    return function (code) {
		      if (this.state.inType && (code === 62 || code === 60)) {
		        return this.finishOp(types.relational, 1);
		      } else {
		        return inner.call(this, code);
		      }
		    };
		  });
	
		  // don't lex any token as a jsx one inside a flow type
		  instance.extend("jsx_readToken", function (inner) {
		    return function () {
		      if (!this.state.inType) return inner.call(this);
		    };
		  });
	
		  instance.extend("toAssignable", function (inner) {
		    return function (node, isBinding, contextDescription) {
		      if (node.type === "TypeCastExpression") {
		        return inner.call(this, this.typeCastToParameter(node), isBinding, contextDescription);
		      } else {
		        return inner.call(this, node, isBinding, contextDescription);
		      }
		    };
		  });
	
		  // turn type casts that we found in function parameter head into type annotated params
		  instance.extend("toAssignableList", function (inner) {
		    return function (exprList, isBinding, contextDescription) {
		      for (var i = 0; i < exprList.length; i++) {
		        var expr = exprList[i];
		        if (expr && expr.type === "TypeCastExpression") {
		          exprList[i] = this.typeCastToParameter(expr);
		        }
		      }
		      return inner.call(this, exprList, isBinding, contextDescription);
		    };
		  });
	
		  // this is a list of nodes, from something like a call expression, we need to filter the
		  // type casts that we've found that are illegal in this context
		  instance.extend("toReferencedList", function () {
		    return function (exprList) {
		      for (var i = 0; i < exprList.length; i++) {
		        var expr = exprList[i];
		        if (expr && expr._exprListItem && expr.type === "TypeCastExpression") {
		          this.raise(expr.start, "Unexpected type cast");
		        }
		      }
	
		      return exprList;
		    };
		  });
	
		  // parse an item inside a expression list eg. `(NODE, NODE)` where NODE represents
		  // the position where this function is called
		  instance.extend("parseExprListItem", function (inner) {
		    return function () {
		      var container = this.startNode();
	
		      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		        args[_key] = arguments[_key];
		      }
	
		      var node = inner.call.apply(inner, [this].concat(args));
		      if (this.match(types.colon)) {
		        container._exprListItem = true;
		        container.expression = node;
		        container.typeAnnotation = this.flowParseTypeAnnotation();
		        return this.finishNode(container, "TypeCastExpression");
		      } else {
		        return node;
		      }
		    };
		  });
	
		  instance.extend("checkLVal", function (inner) {
		    return function (node) {
		      if (node.type !== "TypeCastExpression") {
		        return inner.apply(this, arguments);
		      }
		    };
		  });
	
		  // parse class property type annotations
		  instance.extend("parseClassProperty", function (inner) {
		    return function (node) {
		      delete node.variancePos;
		      if (this.match(types.colon)) {
		        node.typeAnnotation = this.flowParseTypeAnnotation();
		      }
		      return inner.call(this, node);
		    };
		  });
	
		  // determine whether or not we're currently in the position where a class method would appear
		  instance.extend("isClassMethod", function (inner) {
		    return function () {
		      return this.isRelational("<") || inner.call(this);
		    };
		  });
	
		  // determine whether or not we're currently in the position where a class property would appear
		  instance.extend("isClassProperty", function (inner) {
		    return function () {
		      return this.match(types.colon) || inner.call(this);
		    };
		  });
	
		  instance.extend("isNonstaticConstructor", function (inner) {
		    return function (method) {
		      return !this.match(types.colon) && inner.call(this, method);
		    };
		  });
	
		  // parse type parameters for class methods
		  instance.extend("parseClassMethod", function (inner) {
		    return function (classBody, method) {
		      if (method.variance) {
		        this.unexpected(method.variancePos);
		      }
		      delete method.variance;
		      delete method.variancePos;
		      if (this.isRelational("<")) {
		        method.typeParameters = this.flowParseTypeParameterDeclaration();
		      }
	
		      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		        args[_key2 - 2] = arguments[_key2];
		      }
	
		      inner.call.apply(inner, [this, classBody, method].concat(args));
		    };
		  });
	
		  // parse a the super class type parameters and implements
		  instance.extend("parseClassSuper", function (inner) {
		    return function (node, isStatement) {
		      inner.call(this, node, isStatement);
		      if (node.superClass && this.isRelational("<")) {
		        node.superTypeParameters = this.flowParseTypeParameterInstantiation();
		      }
		      if (this.isContextual("implements")) {
		        this.next();
		        var implemented = node.implements = [];
		        do {
		          var _node = this.startNode();
		          _node.id = this.parseIdentifier();
		          if (this.isRelational("<")) {
		            _node.typeParameters = this.flowParseTypeParameterInstantiation();
		          } else {
		            _node.typeParameters = null;
		          }
		          implemented.push(this.finishNode(_node, "ClassImplements"));
		        } while (this.eat(types.comma));
		      }
		    };
		  });
	
		  instance.extend("parsePropertyName", function (inner) {
		    return function (node) {
		      var variancePos = this.state.start;
		      var variance = this.flowParseVariance();
		      var key = inner.call(this, node);
		      node.variance = variance;
		      node.variancePos = variancePos;
		      return key;
		    };
		  });
	
		  // parse type parameters for object method shorthand
		  instance.extend("parseObjPropValue", function (inner) {
		    return function (prop) {
		      if (prop.variance) {
		        this.unexpected(prop.variancePos);
		      }
		      delete prop.variance;
		      delete prop.variancePos;
	
		      var typeParameters = void 0;
	
		      // method shorthand
		      if (this.isRelational("<")) {
		        typeParameters = this.flowParseTypeParameterDeclaration();
		        if (!this.match(types.parenL)) this.unexpected();
		      }
	
		      inner.apply(this, arguments);
	
		      // add typeParameters if we found them
		      if (typeParameters) {
		        (prop.value || prop).typeParameters = typeParameters;
		      }
		    };
		  });
	
		  instance.extend("parseAssignableListItemTypes", function () {
		    return function (param) {
		      if (this.eat(types.question)) {
		        param.optional = true;
		      }
		      if (this.match(types.colon)) {
		        param.typeAnnotation = this.flowParseTypeAnnotation();
		      }
		      this.finishNode(param, param.type);
		      return param;
		    };
		  });
	
		  instance.extend("parseMaybeDefault", function (inner) {
		    return function () {
		      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
		        args[_key3] = arguments[_key3];
		      }
	
		      var node = inner.apply(this, args);
	
		      if (node.type === "AssignmentPattern" && node.typeAnnotation && node.right.start < node.typeAnnotation.start) {
		        this.raise(node.typeAnnotation.start, "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`");
		      }
	
		      return node;
		    };
		  });
	
		  // parse typeof and type imports
		  instance.extend("parseImportSpecifiers", function (inner) {
		    return function (node) {
		      node.importKind = "value";
	
		      var kind = null;
		      if (this.match(types._typeof)) {
		        kind = "typeof";
		      } else if (this.isContextual("type")) {
		        kind = "type";
		      }
		      if (kind) {
		        var lh = this.lookahead();
		        if (lh.type === types.name && lh.value !== "from" || lh.type === types.braceL || lh.type === types.star) {
		          this.next();
		          node.importKind = kind;
		        }
		      }
	
		      inner.call(this, node);
		    };
		  });
	
		  // parse import-type/typeof shorthand
		  instance.extend("parseImportSpecifier", function () {
		    return function (node) {
		      var specifier = this.startNode();
		      var firstIdentLoc = this.state.start;
		      var firstIdent = this.parseIdentifier(true);
	
		      var specifierTypeKind = null;
		      if (firstIdent.name === "type") {
		        specifierTypeKind = "type";
		      } else if (firstIdent.name === "typeof") {
		        specifierTypeKind = "typeof";
		      }
	
		      var isBinding = false;
		      if (this.isContextual("as")) {
		        var as_ident = this.parseIdentifier(true);
		        if (specifierTypeKind !== null && !this.match(types.name) && !this.state.type.keyword) {
		          // `import {type as ,` or `import {type as }`
		          specifier.imported = as_ident;
		          specifier.importKind = specifierTypeKind;
		          specifier.local = as_ident.__clone();
		        } else {
		          // `import {type as foo`
		          specifier.imported = firstIdent;
		          specifier.importKind = null;
		          specifier.local = this.parseIdentifier();
		        }
		      } else if (specifierTypeKind !== null && (this.match(types.name) || this.state.type.keyword)) {
		        // `import {type foo`
		        specifier.imported = this.parseIdentifier(true);
		        specifier.importKind = specifierTypeKind;
		        if (this.eatContextual("as")) {
		          specifier.local = this.parseIdentifier();
		        } else {
		          isBinding = true;
		          specifier.local = specifier.imported.__clone();
		        }
		      } else {
		        isBinding = true;
		        specifier.imported = firstIdent;
		        specifier.importKind = null;
		        specifier.local = specifier.imported.__clone();
		      }
	
		      if ((node.importKind === "type" || node.importKind === "typeof") && (specifier.importKind === "type" || specifier.importKind === "typeof")) {
		        this.raise(firstIdentLoc, "`The `type` and `typeof` keywords on named imports can only be used on regular `import` statements. It cannot be used with `import type` or `import typeof` statements`");
		      }
	
		      if (isBinding) this.checkReservedWord(specifier.local.name, specifier.start, true, true);
	
		      this.checkLVal(specifier.local, true, undefined, "import specifier");
		      node.specifiers.push(this.finishNode(specifier, "ImportSpecifier"));
		    };
		  });
	
		  // parse function type parameters - function foo<T>() {}
		  instance.extend("parseFunctionParams", function (inner) {
		    return function (node) {
		      if (this.isRelational("<")) {
		        node.typeParameters = this.flowParseTypeParameterDeclaration();
		      }
		      inner.call(this, node);
		    };
		  });
	
		  // parse flow type annotations on variable declarator heads - let foo: string = bar
		  instance.extend("parseVarHead", function (inner) {
		    return function (decl) {
		      inner.call(this, decl);
		      if (this.match(types.colon)) {
		        decl.id.typeAnnotation = this.flowParseTypeAnnotation();
		        this.finishNode(decl.id, decl.id.type);
		      }
		    };
		  });
	
		  // parse the return type of an async arrow function - let foo = (async (): number => {});
		  instance.extend("parseAsyncArrowFromCallExpression", function (inner) {
		    return function (node, call) {
		      if (this.match(types.colon)) {
		        var oldNoAnonFunctionType = this.state.noAnonFunctionType;
		        this.state.noAnonFunctionType = true;
		        node.returnType = this.flowParseTypeAnnotation();
		        this.state.noAnonFunctionType = oldNoAnonFunctionType;
		      }
	
		      return inner.call(this, node, call);
		    };
		  });
	
		  // todo description
		  instance.extend("shouldParseAsyncArrow", function (inner) {
		    return function () {
		      return this.match(types.colon) || inner.call(this);
		    };
		  });
	
		  // We need to support type parameter declarations for arrow functions. This
		  // is tricky. There are three situations we need to handle
		  //
		  // 1. This is either JSX or an arrow function. We'll try JSX first. If that
		  //    fails, we'll try an arrow function. If that fails, we'll throw the JSX
		  //    error.
		  // 2. This is an arrow function. We'll parse the type parameter declaration,
		  //    parse the rest, make sure the rest is an arrow function, and go from
		  //    there
		  // 3. This is neither. Just call the inner function
		  instance.extend("parseMaybeAssign", function (inner) {
		    return function () {
		      var jsxError = null;
	
		      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
		        args[_key4] = arguments[_key4];
		      }
	
		      if (types.jsxTagStart && this.match(types.jsxTagStart)) {
		        var state = this.state.clone();
		        try {
		          return inner.apply(this, args);
		        } catch (err) {
		          if (err instanceof SyntaxError) {
		            this.state = state;
	
		            // Remove `tc.j_expr` and `tc.j_oTag` from context added
		            // by parsing `jsxTagStart` to stop the JSX plugin from
		            // messing with the tokens
		            this.state.context.length -= 2;
	
		            jsxError = err;
		          } else {
		            // istanbul ignore next: no such error is expected
		            throw err;
		          }
		        }
		      }
	
		      if (jsxError != null || this.isRelational("<")) {
		        var arrowExpression = void 0;
		        var typeParameters = void 0;
		        try {
		          typeParameters = this.flowParseTypeParameterDeclaration();
	
		          arrowExpression = inner.apply(this, args);
		          arrowExpression.typeParameters = typeParameters;
		          arrowExpression.start = typeParameters.start;
		          arrowExpression.loc.start = typeParameters.loc.start;
		        } catch (err) {
		          throw jsxError || err;
		        }
	
		        if (arrowExpression.type === "ArrowFunctionExpression") {
		          return arrowExpression;
		        } else if (jsxError != null) {
		          throw jsxError;
		        } else {
		          this.raise(typeParameters.start, "Expected an arrow function after this type parameter declaration");
		        }
		      }
	
		      return inner.apply(this, args);
		    };
		  });
	
		  // handle return types for arrow functions
		  instance.extend("parseArrow", function (inner) {
		    return function (node) {
		      if (this.match(types.colon)) {
		        var state = this.state.clone();
		        try {
		          var oldNoAnonFunctionType = this.state.noAnonFunctionType;
		          this.state.noAnonFunctionType = true;
		          var returnType = this.flowParseTypeAndPredicateAnnotation();
		          this.state.noAnonFunctionType = oldNoAnonFunctionType;
	
		          if (this.canInsertSemicolon()) this.unexpected();
		          if (!this.match(types.arrow)) this.unexpected();
		          // assign after it is clear it is an arrow
		          node.returnType = returnType;
		        } catch (err) {
		          if (err instanceof SyntaxError) {
		            this.state = state;
		          } else {
		            // istanbul ignore next: no such error is expected
		            throw err;
		          }
		        }
		      }
	
		      return inner.call(this, node);
		    };
		  });
	
		  instance.extend("shouldParseArrow", function (inner) {
		    return function () {
		      return this.match(types.colon) || inner.call(this);
		    };
		  });
		};
	
		// Adapted from String.fromcodepoint to export the function without modifying String
		/*! https://mths.be/fromcodepoint v0.2.1 by @mathias */
	
		// The MIT License (MIT)
		// Copyright (c) Mathias Bynens
		//
		// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
		// associated documentation files (the "Software"), to deal in the Software without restriction,
		// including without limitation the rights to use, copy, modify, merge, publish, distribute,
		// sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is
		// furnished to do so, subject to the following conditions:
		//
		// The above copyright notice and this permission notice shall be included in all copies or
		// substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
		// NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
		// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
		var fromCodePoint = String.fromCodePoint;
	
		if (!fromCodePoint) {
		  var stringFromCharCode = String.fromCharCode;
		  var floor = Math.floor;
		  fromCodePoint = function fromCodePoint() {
		    var MAX_SIZE = 0x4000;
		    var codeUnits = [];
		    var highSurrogate = void 0;
		    var lowSurrogate = void 0;
		    var index = -1;
		    var length = arguments.length;
		    if (!length) {
		      return "";
		    }
		    var result = "";
		    while (++index < length) {
		      var codePoint = Number(arguments[index]);
		      if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
		      codePoint < 0 || // not a valid Unicode code point
		      codePoint > 0x10FFFF || // not a valid Unicode code point
		      floor(codePoint) != codePoint // not an integer
		      ) {
		          throw RangeError("Invalid code point: " + codePoint);
		        }
		      if (codePoint <= 0xFFFF) {
		        // BMP code point
		        codeUnits.push(codePoint);
		      } else {
		        // Astral code point; split in surrogate halves
		        // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
		        codePoint -= 0x10000;
		        highSurrogate = (codePoint >> 10) + 0xD800;
		        lowSurrogate = codePoint % 0x400 + 0xDC00;
		        codeUnits.push(highSurrogate, lowSurrogate);
		      }
		      if (index + 1 == length || codeUnits.length > MAX_SIZE) {
		        result += stringFromCharCode.apply(null, codeUnits);
		        codeUnits.length = 0;
		      }
		    }
		    return result;
		  };
		}
	
		var fromCodePoint$1 = fromCodePoint;
	
		var XHTMLEntities = {
		  quot: "\"",
		  amp: "&",
		  apos: "'",
		  lt: "<",
		  gt: ">",
		  nbsp: "\xA0",
		  iexcl: "\xA1",
		  cent: "\xA2",
		  pound: "\xA3",
		  curren: "\xA4",
		  yen: "\xA5",
		  brvbar: "\xA6",
		  sect: "\xA7",
		  uml: "\xA8",
		  copy: "\xA9",
		  ordf: "\xAA",
		  laquo: "\xAB",
		  not: "\xAC",
		  shy: "\xAD",
		  reg: "\xAE",
		  macr: "\xAF",
		  deg: "\xB0",
		  plusmn: "\xB1",
		  sup2: "\xB2",
		  sup3: "\xB3",
		  acute: "\xB4",
		  micro: "\xB5",
		  para: "\xB6",
		  middot: "\xB7",
		  cedil: "\xB8",
		  sup1: "\xB9",
		  ordm: "\xBA",
		  raquo: "\xBB",
		  frac14: "\xBC",
		  frac12: "\xBD",
		  frac34: "\xBE",
		  iquest: "\xBF",
		  Agrave: "\xC0",
		  Aacute: "\xC1",
		  Acirc: "\xC2",
		  Atilde: "\xC3",
		  Auml: "\xC4",
		  Aring: "\xC5",
		  AElig: "\xC6",
		  Ccedil: "\xC7",
		  Egrave: "\xC8",
		  Eacute: "\xC9",
		  Ecirc: "\xCA",
		  Euml: "\xCB",
		  Igrave: "\xCC",
		  Iacute: "\xCD",
		  Icirc: "\xCE",
		  Iuml: "\xCF",
		  ETH: "\xD0",
		  Ntilde: "\xD1",
		  Ograve: "\xD2",
		  Oacute: "\xD3",
		  Ocirc: "\xD4",
		  Otilde: "\xD5",
		  Ouml: "\xD6",
		  times: "\xD7",
		  Oslash: "\xD8",
		  Ugrave: "\xD9",
		  Uacute: "\xDA",
		  Ucirc: "\xDB",
		  Uuml: "\xDC",
		  Yacute: "\xDD",
		  THORN: "\xDE",
		  szlig: "\xDF",
		  agrave: "\xE0",
		  aacute: "\xE1",
		  acirc: "\xE2",
		  atilde: "\xE3",
		  auml: "\xE4",
		  aring: "\xE5",
		  aelig: "\xE6",
		  ccedil: "\xE7",
		  egrave: "\xE8",
		  eacute: "\xE9",
		  ecirc: "\xEA",
		  euml: "\xEB",
		  igrave: "\xEC",
		  iacute: "\xED",
		  icirc: "\xEE",
		  iuml: "\xEF",
		  eth: "\xF0",
		  ntilde: "\xF1",
		  ograve: "\xF2",
		  oacute: "\xF3",
		  ocirc: "\xF4",
		  otilde: "\xF5",
		  ouml: "\xF6",
		  divide: "\xF7",
		  oslash: "\xF8",
		  ugrave: "\xF9",
		  uacute: "\xFA",
		  ucirc: "\xFB",
		  uuml: "\xFC",
		  yacute: "\xFD",
		  thorn: "\xFE",
		  yuml: "\xFF",
		  OElig: '\u0152',
		  oelig: '\u0153',
		  Scaron: '\u0160',
		  scaron: '\u0161',
		  Yuml: '\u0178',
		  fnof: '\u0192',
		  circ: '\u02C6',
		  tilde: '\u02DC',
		  Alpha: '\u0391',
		  Beta: '\u0392',
		  Gamma: '\u0393',
		  Delta: '\u0394',
		  Epsilon: '\u0395',
		  Zeta: '\u0396',
		  Eta: '\u0397',
		  Theta: '\u0398',
		  Iota: '\u0399',
		  Kappa: '\u039A',
		  Lambda: '\u039B',
		  Mu: '\u039C',
		  Nu: '\u039D',
		  Xi: '\u039E',
		  Omicron: '\u039F',
		  Pi: '\u03A0',
		  Rho: '\u03A1',
		  Sigma: '\u03A3',
		  Tau: '\u03A4',
		  Upsilon: '\u03A5',
		  Phi: '\u03A6',
		  Chi: '\u03A7',
		  Psi: '\u03A8',
		  Omega: '\u03A9',
		  alpha: '\u03B1',
		  beta: '\u03B2',
		  gamma: '\u03B3',
		  delta: '\u03B4',
		  epsilon: '\u03B5',
		  zeta: '\u03B6',
		  eta: '\u03B7',
		  theta: '\u03B8',
		  iota: '\u03B9',
		  kappa: '\u03BA',
		  lambda: '\u03BB',
		  mu: '\u03BC',
		  nu: '\u03BD',
		  xi: '\u03BE',
		  omicron: '\u03BF',
		  pi: '\u03C0',
		  rho: '\u03C1',
		  sigmaf: '\u03C2',
		  sigma: '\u03C3',
		  tau: '\u03C4',
		  upsilon: '\u03C5',
		  phi: '\u03C6',
		  chi: '\u03C7',
		  psi: '\u03C8',
		  omega: '\u03C9',
		  thetasym: '\u03D1',
		  upsih: '\u03D2',
		  piv: '\u03D6',
		  ensp: '\u2002',
		  emsp: '\u2003',
		  thinsp: '\u2009',
		  zwnj: '\u200C',
		  zwj: '\u200D',
		  lrm: '\u200E',
		  rlm: '\u200F',
		  ndash: '\u2013',
		  mdash: '\u2014',
		  lsquo: '\u2018',
		  rsquo: '\u2019',
		  sbquo: '\u201A',
		  ldquo: '\u201C',
		  rdquo: '\u201D',
		  bdquo: '\u201E',
		  dagger: '\u2020',
		  Dagger: '\u2021',
		  bull: '\u2022',
		  hellip: '\u2026',
		  permil: '\u2030',
		  prime: '\u2032',
		  Prime: '\u2033',
		  lsaquo: '\u2039',
		  rsaquo: '\u203A',
		  oline: '\u203E',
		  frasl: '\u2044',
		  euro: '\u20AC',
		  image: '\u2111',
		  weierp: '\u2118',
		  real: '\u211C',
		  trade: '\u2122',
		  alefsym: '\u2135',
		  larr: '\u2190',
		  uarr: '\u2191',
		  rarr: '\u2192',
		  darr: '\u2193',
		  harr: '\u2194',
		  crarr: '\u21B5',
		  lArr: '\u21D0',
		  uArr: '\u21D1',
		  rArr: '\u21D2',
		  dArr: '\u21D3',
		  hArr: '\u21D4',
		  forall: '\u2200',
		  part: '\u2202',
		  exist: '\u2203',
		  empty: '\u2205',
		  nabla: '\u2207',
		  isin: '\u2208',
		  notin: '\u2209',
		  ni: '\u220B',
		  prod: '\u220F',
		  sum: '\u2211',
		  minus: '\u2212',
		  lowast: '\u2217',
		  radic: '\u221A',
		  prop: '\u221D',
		  infin: '\u221E',
		  ang: '\u2220',
		  and: '\u2227',
		  or: '\u2228',
		  cap: '\u2229',
		  cup: '\u222A',
		  "int": '\u222B',
		  there4: '\u2234',
		  sim: '\u223C',
		  cong: '\u2245',
		  asymp: '\u2248',
		  ne: '\u2260',
		  equiv: '\u2261',
		  le: '\u2264',
		  ge: '\u2265',
		  sub: '\u2282',
		  sup: '\u2283',
		  nsub: '\u2284',
		  sube: '\u2286',
		  supe: '\u2287',
		  oplus: '\u2295',
		  otimes: '\u2297',
		  perp: '\u22A5',
		  sdot: '\u22C5',
		  lceil: '\u2308',
		  rceil: '\u2309',
		  lfloor: '\u230A',
		  rfloor: '\u230B',
		  lang: '\u2329',
		  rang: '\u232A',
		  loz: '\u25CA',
		  spades: '\u2660',
		  clubs: '\u2663',
		  hearts: '\u2665',
		  diams: '\u2666'
		};
	
		var HEX_NUMBER = /^[\da-fA-F]+$/;
		var DECIMAL_NUMBER = /^\d+$/;
	
		types$1.j_oTag = new TokContext("<tag", false);
		types$1.j_cTag = new TokContext("</tag", false);
		types$1.j_expr = new TokContext("<tag>...</tag>", true, true);
	
		types.jsxName = new TokenType("jsxName");
		types.jsxText = new TokenType("jsxText", { beforeExpr: true });
		types.jsxTagStart = new TokenType("jsxTagStart", { startsExpr: true });
		types.jsxTagEnd = new TokenType("jsxTagEnd");
	
		types.jsxTagStart.updateContext = function () {
		  this.state.context.push(types$1.j_expr); // treat as beginning of JSX expression
		  this.state.context.push(types$1.j_oTag); // start opening tag context
		  this.state.exprAllowed = false;
		};
	
		types.jsxTagEnd.updateContext = function (prevType) {
		  var out = this.state.context.pop();
		  if (out === types$1.j_oTag && prevType === types.slash || out === types$1.j_cTag) {
		    this.state.context.pop();
		    this.state.exprAllowed = this.curContext() === types$1.j_expr;
		  } else {
		    this.state.exprAllowed = true;
		  }
		};
	
		var pp$9 = Parser.prototype;
	
		// Reads inline JSX contents token.
	
		pp$9.jsxReadToken = function () {
		  var out = "";
		  var chunkStart = this.state.pos;
		  for (;;) {
		    if (this.state.pos >= this.input.length) {
		      this.raise(this.state.start, "Unterminated JSX contents");
		    }
	
		    var ch = this.input.charCodeAt(this.state.pos);
	
		    switch (ch) {
		      case 60: // "<"
		      case 123:
		        // "{"
		        if (this.state.pos === this.state.start) {
		          if (ch === 60 && this.state.exprAllowed) {
		            ++this.state.pos;
		            return this.finishToken(types.jsxTagStart);
		          }
		          return this.getTokenFromCode(ch);
		        }
		        out += this.input.slice(chunkStart, this.state.pos);
		        return this.finishToken(types.jsxText, out);
	
		      case 38:
		        // "&"
		        out += this.input.slice(chunkStart, this.state.pos);
		        out += this.jsxReadEntity();
		        chunkStart = this.state.pos;
		        break;
	
		      default:
		        if (isNewLine(ch)) {
		          out += this.input.slice(chunkStart, this.state.pos);
		          out += this.jsxReadNewLine(true);
		          chunkStart = this.state.pos;
		        } else {
		          ++this.state.pos;
		        }
		    }
		  }
		};
	
		pp$9.jsxReadNewLine = function (normalizeCRLF) {
		  var ch = this.input.charCodeAt(this.state.pos);
		  var out = void 0;
		  ++this.state.pos;
		  if (ch === 13 && this.input.charCodeAt(this.state.pos) === 10) {
		    ++this.state.pos;
		    out = normalizeCRLF ? "\n" : "\r\n";
		  } else {
		    out = String.fromCharCode(ch);
		  }
		  ++this.state.curLine;
		  this.state.lineStart = this.state.pos;
	
		  return out;
		};
	
		pp$9.jsxReadString = function (quote) {
		  var out = "";
		  var chunkStart = ++this.state.pos;
		  for (;;) {
		    if (this.state.pos >= this.input.length) {
		      this.raise(this.state.start, "Unterminated string constant");
		    }
	
		    var ch = this.input.charCodeAt(this.state.pos);
		    if (ch === quote) break;
		    if (ch === 38) {
		      // "&"
		      out += this.input.slice(chunkStart, this.state.pos);
		      out += this.jsxReadEntity();
		      chunkStart = this.state.pos;
		    } else if (isNewLine(ch)) {
		      out += this.input.slice(chunkStart, this.state.pos);
		      out += this.jsxReadNewLine(false);
		      chunkStart = this.state.pos;
		    } else {
		      ++this.state.pos;
		    }
		  }
		  out += this.input.slice(chunkStart, this.state.pos++);
		  return this.finishToken(types.string, out);
		};
	
		pp$9.jsxReadEntity = function () {
		  var str = "";
		  var count = 0;
		  var entity = void 0;
		  var ch = this.input[this.state.pos];
	
		  var startPos = ++this.state.pos;
		  while (this.state.pos < this.input.length && count++ < 10) {
		    ch = this.input[this.state.pos++];
		    if (ch === ";") {
		      if (str[0] === "#") {
		        if (str[1] === "x") {
		          str = str.substr(2);
		          if (HEX_NUMBER.test(str)) entity = fromCodePoint$1(parseInt(str, 16));
		        } else {
		          str = str.substr(1);
		          if (DECIMAL_NUMBER.test(str)) entity = fromCodePoint$1(parseInt(str, 10));
		        }
		      } else {
		        entity = XHTMLEntities[str];
		      }
		      break;
		    }
		    str += ch;
		  }
		  if (!entity) {
		    this.state.pos = startPos;
		    return "&";
		  }
		  return entity;
		};
	
		// Read a JSX identifier (valid tag or attribute name).
		//
		// Optimized version since JSX identifiers can"t contain
		// escape characters and so can be read as single slice.
		// Also assumes that first character was already checked
		// by isIdentifierStart in readToken.
	
		pp$9.jsxReadWord = function () {
		  var ch = void 0;
		  var start = this.state.pos;
		  do {
		    ch = this.input.charCodeAt(++this.state.pos);
		  } while (isIdentifierChar(ch) || ch === 45); // "-"
		  return this.finishToken(types.jsxName, this.input.slice(start, this.state.pos));
		};
	
		// Transforms JSX element name to string.
	
		function getQualifiedJSXName(object) {
		  if (object.type === "JSXIdentifier") {
		    return object.name;
		  }
	
		  if (object.type === "JSXNamespacedName") {
		    return object.namespace.name + ":" + object.name.name;
		  }
	
		  if (object.type === "JSXMemberExpression") {
		    return getQualifiedJSXName(object.object) + "." + getQualifiedJSXName(object.property);
		  }
		}
	
		// Parse next token as JSX identifier
	
		pp$9.jsxParseIdentifier = function () {
		  var node = this.startNode();
		  if (this.match(types.jsxName)) {
		    node.name = this.state.value;
		  } else if (this.state.type.keyword) {
		    node.name = this.state.type.keyword;
		  } else {
		    this.unexpected();
		  }
		  this.next();
		  return this.finishNode(node, "JSXIdentifier");
		};
	
		// Parse namespaced identifier.
	
		pp$9.jsxParseNamespacedName = function () {
		  var startPos = this.state.start;
		  var startLoc = this.state.startLoc;
		  var name = this.jsxParseIdentifier();
		  if (!this.eat(types.colon)) return name;
	
		  var node = this.startNodeAt(startPos, startLoc);
		  node.namespace = name;
		  node.name = this.jsxParseIdentifier();
		  return this.finishNode(node, "JSXNamespacedName");
		};
	
		// Parses element name in any form - namespaced, member
		// or single identifier.
	
		pp$9.jsxParseElementName = function () {
		  var startPos = this.state.start;
		  var startLoc = this.state.startLoc;
		  var node = this.jsxParseNamespacedName();
		  while (this.eat(types.dot)) {
		    var newNode = this.startNodeAt(startPos, startLoc);
		    newNode.object = node;
		    newNode.property = this.jsxParseIdentifier();
		    node = this.finishNode(newNode, "JSXMemberExpression");
		  }
		  return node;
		};
	
		// Parses any type of JSX attribute value.
	
		pp$9.jsxParseAttributeValue = function () {
		  var node = void 0;
		  switch (this.state.type) {
		    case types.braceL:
		      node = this.jsxParseExpressionContainer();
		      if (node.expression.type === "JSXEmptyExpression") {
		        this.raise(node.start, "JSX attributes must only be assigned a non-empty expression");
		      } else {
		        return node;
		      }
	
		    case types.jsxTagStart:
		    case types.string:
		      node = this.parseExprAtom();
		      node.extra = null;
		      return node;
	
		    default:
		      this.raise(this.state.start, "JSX value should be either an expression or a quoted JSX text");
		  }
		};
	
		// JSXEmptyExpression is unique type since it doesn't actually parse anything,
		// and so it should start at the end of last read token (left brace) and finish
		// at the beginning of the next one (right brace).
	
		pp$9.jsxParseEmptyExpression = function () {
		  var node = this.startNodeAt(this.state.lastTokEnd, this.state.lastTokEndLoc);
		  return this.finishNodeAt(node, "JSXEmptyExpression", this.state.start, this.state.startLoc);
		};
	
		// Parse JSX spread child
	
		pp$9.jsxParseSpreadChild = function () {
		  var node = this.startNode();
		  this.expect(types.braceL);
		  this.expect(types.ellipsis);
		  node.expression = this.parseExpression();
		  this.expect(types.braceR);
	
		  return this.finishNode(node, "JSXSpreadChild");
		};
	
		// Parses JSX expression enclosed into curly brackets.
	
	
		pp$9.jsxParseExpressionContainer = function () {
		  var node = this.startNode();
		  this.next();
		  if (this.match(types.braceR)) {
		    node.expression = this.jsxParseEmptyExpression();
		  } else {
		    node.expression = this.parseExpression();
		  }
		  this.expect(types.braceR);
		  return this.finishNode(node, "JSXExpressionContainer");
		};
	
		// Parses following JSX attribute name-value pair.
	
		pp$9.jsxParseAttribute = function () {
		  var node = this.startNode();
		  if (this.eat(types.braceL)) {
		    this.expect(types.ellipsis);
		    node.argument = this.parseMaybeAssign();
		    this.expect(types.braceR);
		    return this.finishNode(node, "JSXSpreadAttribute");
		  }
		  node.name = this.jsxParseNamespacedName();
		  node.value = this.eat(types.eq) ? this.jsxParseAttributeValue() : null;
		  return this.finishNode(node, "JSXAttribute");
		};
	
		// Parses JSX opening tag starting after "<".
	
		pp$9.jsxParseOpeningElementAt = function (startPos, startLoc) {
		  var node = this.startNodeAt(startPos, startLoc);
		  node.attributes = [];
		  node.name = this.jsxParseElementName();
		  while (!this.match(types.slash) && !this.match(types.jsxTagEnd)) {
		    node.attributes.push(this.jsxParseAttribute());
		  }
		  node.selfClosing = this.eat(types.slash);
		  this.expect(types.jsxTagEnd);
		  return this.finishNode(node, "JSXOpeningElement");
		};
	
		// Parses JSX closing tag starting after "</".
	
		pp$9.jsxParseClosingElementAt = function (startPos, startLoc) {
		  var node = this.startNodeAt(startPos, startLoc);
		  node.name = this.jsxParseElementName();
		  this.expect(types.jsxTagEnd);
		  return this.finishNode(node, "JSXClosingElement");
		};
	
		// Parses entire JSX element, including it"s opening tag
		// (starting after "<"), attributes, contents and closing tag.
	
		pp$9.jsxParseElementAt = function (startPos, startLoc) {
		  var node = this.startNodeAt(startPos, startLoc);
		  var children = [];
		  var openingElement = this.jsxParseOpeningElementAt(startPos, startLoc);
		  var closingElement = null;
	
		  if (!openingElement.selfClosing) {
		    contents: for (;;) {
		      switch (this.state.type) {
		        case types.jsxTagStart:
		          startPos = this.state.start;startLoc = this.state.startLoc;
		          this.next();
		          if (this.eat(types.slash)) {
		            closingElement = this.jsxParseClosingElementAt(startPos, startLoc);
		            break contents;
		          }
		          children.push(this.jsxParseElementAt(startPos, startLoc));
		          break;
	
		        case types.jsxText:
		          children.push(this.parseExprAtom());
		          break;
	
		        case types.braceL:
		          if (this.lookahead().type === types.ellipsis) {
		            children.push(this.jsxParseSpreadChild());
		          } else {
		            children.push(this.jsxParseExpressionContainer());
		          }
	
		          break;
	
		        // istanbul ignore next - should never happen
		        default:
		          this.unexpected();
		      }
		    }
	
		    if (getQualifiedJSXName(closingElement.name) !== getQualifiedJSXName(openingElement.name)) {
		      this.raise(closingElement.start, "Expected corresponding JSX closing tag for <" + getQualifiedJSXName(openingElement.name) + ">");
		    }
		  }
	
		  node.openingElement = openingElement;
		  node.closingElement = closingElement;
		  node.children = children;
		  if (this.match(types.relational) && this.state.value === "<") {
		    this.raise(this.state.start, "Adjacent JSX elements must be wrapped in an enclosing tag");
		  }
		  return this.finishNode(node, "JSXElement");
		};
	
		// Parses entire JSX element from current position.
	
		pp$9.jsxParseElement = function () {
		  var startPos = this.state.start;
		  var startLoc = this.state.startLoc;
		  this.next();
		  return this.jsxParseElementAt(startPos, startLoc);
		};
	
		var jsxPlugin = function jsxPlugin(instance) {
		  instance.extend("parseExprAtom", function (inner) {
		    return function (refShortHandDefaultPos) {
		      if (this.match(types.jsxText)) {
		        var node = this.parseLiteral(this.state.value, "JSXText");
		        // https://github.com/babel/babel/issues/2078
		        node.extra = null;
		        return node;
		      } else if (this.match(types.jsxTagStart)) {
		        return this.jsxParseElement();
		      } else {
		        return inner.call(this, refShortHandDefaultPos);
		      }
		    };
		  });
	
		  instance.extend("readToken", function (inner) {
		    return function (code) {
		      if (this.state.inPropertyName) return inner.call(this, code);
	
		      var context = this.curContext();
	
		      if (context === types$1.j_expr) {
		        return this.jsxReadToken();
		      }
	
		      if (context === types$1.j_oTag || context === types$1.j_cTag) {
		        if (isIdentifierStart(code)) {
		          return this.jsxReadWord();
		        }
	
		        if (code === 62) {
		          ++this.state.pos;
		          return this.finishToken(types.jsxTagEnd);
		        }
	
		        if ((code === 34 || code === 39) && context === types$1.j_oTag) {
		          return this.jsxReadString(code);
		        }
		      }
	
		      if (code === 60 && this.state.exprAllowed) {
		        ++this.state.pos;
		        return this.finishToken(types.jsxTagStart);
		      }
	
		      return inner.call(this, code);
		    };
		  });
	
		  instance.extend("updateContext", function (inner) {
		    return function (prevType) {
		      if (this.match(types.braceL)) {
		        var curContext = this.curContext();
		        if (curContext === types$1.j_oTag) {
		          this.state.context.push(types$1.braceExpression);
		        } else if (curContext === types$1.j_expr) {
		          this.state.context.push(types$1.templateQuasi);
		        } else {
		          inner.call(this, prevType);
		        }
		        this.state.exprAllowed = true;
		      } else if (this.match(types.slash) && prevType === types.jsxTagStart) {
		        this.state.context.length -= 2; // do not consider JSX expr -> JSX open tag -> ... anymore
		        this.state.context.push(types$1.j_cTag); // reconsider as closing tag context
		        this.state.exprAllowed = false;
		      } else {
		        return inner.call(this, prevType);
		      }
		    };
		  });
		};
	
		plugins.estree = estreePlugin;
		plugins.flow = flowPlugin;
		plugins.jsx = jsxPlugin;
	
		function parse(input, options) {
		  return new Parser(options, input).parse();
		}
	
		function parseExpression(input, options) {
		  var parser = new Parser(options, input);
		  if (parser.options.strictMode) {
		    parser.state.strict = true;
		  }
		  return parser.getExpression();
		}
	
		exports.parse = parse;
		exports.parseExpression = parseExpression;
		exports.tokTypes = types;
	
	/***/ }),
	/* 90 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
		var anObject = __webpack_require__(21);
		var dPs = __webpack_require__(431);
		var enumBugKeys = __webpack_require__(141);
		var IE_PROTO = __webpack_require__(150)('IE_PROTO');
		var Empty = function Empty() {/* empty */};
		var PROTOTYPE = 'prototype';
	
		// Create object with fake `null` prototype: use iframe Object with cleared prototype
		var _createDict = function createDict() {
		  // Thrash, waste and sodomy: IE GC bug
		  var iframe = __webpack_require__(230)('iframe');
		  var i = enumBugKeys.length;
		  var lt = '<';
		  var gt = '>';
		  var iframeDocument;
		  iframe.style.display = 'none';
		  __webpack_require__(426).appendChild(iframe);
		  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
		  // createDict = iframe.contentWindow.Object;
		  // html.removeChild(iframe);
		  iframeDocument = iframe.contentWindow.document;
		  iframeDocument.open();
		  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
		  iframeDocument.close();
		  _createDict = iframeDocument.F;
		  while (i--) {
		    delete _createDict[PROTOTYPE][enumBugKeys[i]];
		  }return _createDict();
		};
	
		module.exports = Object.create || function create(O, Properties) {
		  var result;
		  if (O !== null) {
		    Empty[PROTOTYPE] = anObject(O);
		    result = new Empty();
		    Empty[PROTOTYPE] = null;
		    // add "__proto__" for Object.getPrototypeOf polyfill
		    result[IE_PROTO] = O;
		  } else result = _createDict();
		  return Properties === undefined ? result : dPs(result, Properties);
		};
	
	/***/ }),
	/* 91 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.f = {}.propertyIsEnumerable;
	
	/***/ }),
	/* 92 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		module.exports = function (bitmap, value) {
		  return {
		    enumerable: !(bitmap & 1),
		    configurable: !(bitmap & 2),
		    writable: !(bitmap & 4),
		    value: value
		  };
		};
	
	/***/ }),
	/* 93 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var def = __webpack_require__(23).f;
		var has = __webpack_require__(28);
		var TAG = __webpack_require__(13)('toStringTag');
	
		module.exports = function (it, tag, stat) {
		  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
		};
	
	/***/ }),
	/* 94 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// 7.1.13 ToObject(argument)
		var defined = __webpack_require__(140);
		module.exports = function (it) {
		  return Object(defined(it));
		};
	
	/***/ }),
	/* 95 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var id = 0;
		var px = Math.random();
		module.exports = function (key) {
		  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
		};
	
	/***/ }),
	/* 96 */
	/***/ (function(module, exports) {
	
		"use strict";
	
	/***/ }),
	/* 97 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		/*
		  Copyright (C) 2013 Yusuke Suzuki <utatane.tea@gmail.com>
	
		  Redistribution and use in source and binary forms, with or without
		  modification, are permitted provided that the following conditions are met:
	
		    * Redistributions of source code must retain the above copyright
		      notice, this list of conditions and the following disclaimer.
		    * Redistributions in binary form must reproduce the above copyright
		      notice, this list of conditions and the following disclaimer in the
		      documentation and/or other materials provided with the distribution.
	
		  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
		  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
		  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
		  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
		  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
		  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
		  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
		  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
		  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
		  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		*/
	
		(function () {
		  'use strict';
	
		  exports.ast = __webpack_require__(461);
		  exports.code = __webpack_require__(240);
		  exports.keyword = __webpack_require__(462);
		})();
		/* vim: set sw=4 ts=4 et tw=80 : */
	
	/***/ }),
	/* 98 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var listCacheClear = __webpack_require__(546),
		    listCacheDelete = __webpack_require__(547),
		    listCacheGet = __webpack_require__(548),
		    listCacheHas = __webpack_require__(549),
		    listCacheSet = __webpack_require__(550);
	
		/**
		 * Creates an list cache object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function ListCache(entries) {
		    var index = -1,
		        length = entries == null ? 0 : entries.length;
	
		    this.clear();
		    while (++index < length) {
		        var entry = entries[index];
		        this.set(entry[0], entry[1]);
		    }
		}
	
		// Add methods to `ListCache`.
		ListCache.prototype.clear = listCacheClear;
		ListCache.prototype['delete'] = listCacheDelete;
		ListCache.prototype.get = listCacheGet;
		ListCache.prototype.has = listCacheHas;
		ListCache.prototype.set = listCacheSet;
	
		module.exports = ListCache;
	
	/***/ }),
	/* 99 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var ListCache = __webpack_require__(98),
		    stackClear = __webpack_require__(565),
		    stackDelete = __webpack_require__(566),
		    stackGet = __webpack_require__(567),
		    stackHas = __webpack_require__(568),
		    stackSet = __webpack_require__(569);
	
		/**
		 * Creates a stack cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Stack(entries) {
		  var data = this.__data__ = new ListCache(entries);
		  this.size = data.size;
		}
	
		// Add methods to `Stack`.
		Stack.prototype.clear = stackClear;
		Stack.prototype['delete'] = stackDelete;
		Stack.prototype.get = stackGet;
		Stack.prototype.has = stackHas;
		Stack.prototype.set = stackSet;
	
		module.exports = Stack;
	
	/***/ }),
	/* 100 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var eq = __webpack_require__(46);
	
		/**
		 * Gets the index at which the `key` is found in `array` of key-value pairs.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} key The key to search for.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function assocIndexOf(array, key) {
		  var length = array.length;
		  while (length--) {
		    if (eq(array[length][0], key)) {
		      return length;
		    }
		  }
		  return -1;
		}
	
		module.exports = assocIndexOf;
	
	/***/ }),
	/* 101 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var identity = __webpack_require__(110),
		    overRest = __webpack_require__(560),
		    setToString = __webpack_require__(563);
	
		/**
		 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
		 *
		 * @private
		 * @param {Function} func The function to apply a rest parameter to.
		 * @param {number} [start=func.length-1] The start position of the rest parameter.
		 * @returns {Function} Returns the new function.
		 */
		function baseRest(func, start) {
		  return setToString(overRest(func, start, identity), func + '');
		}
	
		module.exports = baseRest;
	
	/***/ }),
	/* 102 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * The base implementation of `_.unary` without support for storing metadata.
		 *
		 * @private
		 * @param {Function} func The function to cap arguments for.
		 * @returns {Function} Returns the new capped function.
		 */
		function baseUnary(func) {
		  return function (value) {
		    return func(value);
		  };
		}
	
		module.exports = baseUnary;
	
	/***/ }),
	/* 103 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseRest = __webpack_require__(101),
		    isIterateeCall = __webpack_require__(172);
	
		/**
		 * Creates a function like `_.assign`.
		 *
		 * @private
		 * @param {Function} assigner The function to assign values.
		 * @returns {Function} Returns the new assigner function.
		 */
		function createAssigner(assigner) {
		  return baseRest(function (object, sources) {
		    var index = -1,
		        length = sources.length,
		        customizer = length > 1 ? sources[length - 1] : undefined,
		        guard = length > 2 ? sources[2] : undefined;
	
		    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
	
		    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
		      customizer = length < 3 ? undefined : customizer;
		      length = 1;
		    }
		    object = Object(object);
		    while (++index < length) {
		      var source = sources[index];
		      if (source) {
		        assigner(object, source, index, customizer);
		      }
		    }
		    return object;
		  });
		}
	
		module.exports = createAssigner;
	
	/***/ }),
	/* 104 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isKeyable = __webpack_require__(544);
	
		/**
		 * Gets the data for `map`.
		 *
		 * @private
		 * @param {Object} map The map to query.
		 * @param {string} key The reference key.
		 * @returns {*} Returns the map data.
		 */
		function getMapData(map, key) {
		  var data = map.__data__;
		  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
		}
	
		module.exports = getMapData;
	
	/***/ }),
	/* 105 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Checks if `value` is likely a prototype object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
		 */
		function isPrototype(value) {
		  var Ctor = value && value.constructor,
		      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
	
		  return value === proto;
		}
	
		module.exports = isPrototype;
	
	/***/ }),
	/* 106 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var getNative = __webpack_require__(38);
	
		/* Built-in method references that are verified to be native. */
		var nativeCreate = getNative(Object, 'create');
	
		module.exports = nativeCreate;
	
	/***/ }),
	/* 107 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Converts `set` to an array of its values.
		 *
		 * @private
		 * @param {Object} set The set to convert.
		 * @returns {Array} Returns the values.
		 */
		function setToArray(set) {
		  var index = -1,
		      result = Array(set.size);
	
		  set.forEach(function (value) {
		    result[++index] = value;
		  });
		  return result;
		}
	
		module.exports = setToArray;
	
	/***/ }),
	/* 108 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isSymbol = __webpack_require__(62);
	
		/** Used as references for various `Number` constants. */
		var INFINITY = 1 / 0;
	
		/**
		 * Converts `value` to a string key if it's not a string or symbol.
		 *
		 * @private
		 * @param {*} value The value to inspect.
		 * @returns {string|symbol} Returns the key.
		 */
		function toKey(value) {
		  if (typeof value == 'string' || isSymbol(value)) {
		    return value;
		  }
		  var result = value + '';
		  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
		}
	
		module.exports = toKey;
	
	/***/ }),
	/* 109 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseClone = __webpack_require__(164);
	
		/** Used to compose bitmasks for cloning. */
		var CLONE_SYMBOLS_FLAG = 4;
	
		/**
		 * Creates a shallow clone of `value`.
		 *
		 * **Note:** This method is loosely based on the
		 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
		 * and supports cloning arrays, array buffers, booleans, date objects, maps,
		 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
		 * arrays. The own enumerable properties of `arguments` objects are cloned
		 * as plain objects. An empty object is returned for uncloneable values such
		 * as error objects, functions, DOM nodes, and WeakMaps.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to clone.
		 * @returns {*} Returns the cloned value.
		 * @see _.cloneDeep
		 * @example
		 *
		 * var objects = [{ 'a': 1 }, { 'b': 2 }];
		 *
		 * var shallow = _.clone(objects);
		 * console.log(shallow[0] === objects[0]);
		 * // => true
		 */
		function clone(value) {
		  return baseClone(value, CLONE_SYMBOLS_FLAG);
		}
	
		module.exports = clone;
	
	/***/ }),
	/* 110 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * This method returns the first argument it receives.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Util
		 * @param {*} value Any value.
		 * @returns {*} Returns `value`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 *
		 * console.log(_.identity(object) === object);
		 * // => true
		 */
		function identity(value) {
		  return value;
		}
	
		module.exports = identity;
	
	/***/ }),
	/* 111 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseIndexOf = __webpack_require__(166),
		    isArrayLike = __webpack_require__(24),
		    isString = __webpack_require__(587),
		    toInteger = __webpack_require__(48),
		    values = __webpack_require__(280);
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeMax = Math.max;
	
		/**
		 * Checks if `value` is in `collection`. If `collection` is a string, it's
		 * checked for a substring of `value`, otherwise
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * is used for equality comparisons. If `fromIndex` is negative, it's used as
		 * the offset from the end of `collection`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Collection
		 * @param {Array|Object|string} collection The collection to inspect.
		 * @param {*} value The value to search for.
		 * @param {number} [fromIndex=0] The index to search from.
		 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
		 * @returns {boolean} Returns `true` if `value` is found, else `false`.
		 * @example
		 *
		 * _.includes([1, 2, 3], 1);
		 * // => true
		 *
		 * _.includes([1, 2, 3], 1, 2);
		 * // => false
		 *
		 * _.includes({ 'a': 1, 'b': 2 }, 1);
		 * // => true
		 *
		 * _.includes('abcd', 'bc');
		 * // => true
		 */
		function includes(collection, value, fromIndex, guard) {
		  collection = isArrayLike(collection) ? collection : values(collection);
		  fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
	
		  var length = collection.length;
		  if (fromIndex < 0) {
		    fromIndex = nativeMax(length + fromIndex, 0);
		  }
		  return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
		}
	
		module.exports = includes;
	
	/***/ }),
	/* 112 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseIsArguments = __webpack_require__(493),
		    isObjectLike = __webpack_require__(25);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Built-in value references. */
		var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
		/**
		 * Checks if `value` is likely an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */
		var isArguments = baseIsArguments(function () {
		    return arguments;
		}()) ? baseIsArguments : function (value) {
		    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
		};
	
		module.exports = isArguments;
	
	/***/ }),
	/* 113 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var root = __webpack_require__(17),
		    stubFalse = __webpack_require__(596);
	
		/** Detect free variable `exports`. */
		var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;
	
		/** Detect free variable `module`. */
		var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;
	
		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;
	
		/** Built-in value references. */
		var Buffer = moduleExports ? root.Buffer : undefined;
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
		/**
		 * Checks if `value` is a buffer.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.3.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
		 * @example
		 *
		 * _.isBuffer(new Buffer(2));
		 * // => true
		 *
		 * _.isBuffer(new Uint8Array(2));
		 * // => false
		 */
		var isBuffer = nativeIsBuffer || stubFalse;
	
		module.exports = isBuffer;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)(module)))
	
	/***/ }),
	/* 114 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseToString = __webpack_require__(253);
	
		/**
		 * Converts `value` to a string. An empty string is returned for `null`
		 * and `undefined` values. The sign of `-0` is preserved.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to convert.
		 * @returns {string} Returns the converted string.
		 * @example
		 *
		 * _.toString(null);
		 * // => ''
		 *
		 * _.toString(-0);
		 * // => '-0'
		 *
		 * _.toString([1, 2, 3]);
		 * // => '1,2,3'
		 */
		function toString(value) {
		  return value == null ? '' : baseToString(value);
		}
	
		module.exports = toString;
	
	/***/ }),
	/* 115 */
	96,
	/* 116 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.runtimeProperty = runtimeProperty;
		exports.isReference = isReference;
		exports.replaceWithOrRemove = replaceWithOrRemove;
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function runtimeProperty(name) {
		  return t.memberExpression(t.identifier("regeneratorRuntime"), t.identifier(name), false);
		} /**
		   * Copyright (c) 2014, Facebook, Inc.
		   * All rights reserved.
		   *
		   * This source code is licensed under the BSD-style license found in the
		   * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
		   * additional grant of patent rights can be found in the PATENTS file in
		   * the same directory.
		   */
	
		function isReference(path) {
		  return path.isReferenced() || path.parentPath.isAssignmentExpression({ left: path.node });
		}
	
		function replaceWithOrRemove(path, replacement) {
		  if (replacement) {
		    path.replaceWith(replacement);
		  } else {
		    path.remove();
		  }
		}
	
	/***/ }),
	/* 117 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(global, process) {'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
		var formatRegExp = /%[sdj%]/g;
		exports.format = function (f) {
		  if (!isString(f)) {
		    var objects = [];
		    for (var i = 0; i < arguments.length; i++) {
		      objects.push(inspect(arguments[i]));
		    }
		    return objects.join(' ');
		  }
	
		  var i = 1;
		  var args = arguments;
		  var len = args.length;
		  var str = String(f).replace(formatRegExp, function (x) {
		    if (x === '%%') return '%';
		    if (i >= len) return x;
		    switch (x) {
		      case '%s':
		        return String(args[i++]);
		      case '%d':
		        return Number(args[i++]);
		      case '%j':
		        try {
		          return JSON.stringify(args[i++]);
		        } catch (_) {
		          return '[Circular]';
		        }
		      default:
		        return x;
		    }
		  });
		  for (var x = args[i]; i < len; x = args[++i]) {
		    if (isNull(x) || !isObject(x)) {
		      str += ' ' + x;
		    } else {
		      str += ' ' + inspect(x);
		    }
		  }
		  return str;
		};
	
		// Mark that a method should not be used.
		// Returns a modified function which warns once by default.
		// If --no-deprecation is set, then it is a no-op.
		exports.deprecate = function (fn, msg) {
		  // Allow for deprecating things in the process of starting up.
		  if (isUndefined(global.process)) {
		    return function () {
		      return exports.deprecate(fn, msg).apply(this, arguments);
		    };
		  }
	
		  if (process.noDeprecation === true) {
		    return fn;
		  }
	
		  var warned = false;
		  function deprecated() {
		    if (!warned) {
		      if (process.throwDeprecation) {
		        throw new Error(msg);
		      } else if (process.traceDeprecation) {
		        console.trace(msg);
		      } else {
		        console.error(msg);
		      }
		      warned = true;
		    }
		    return fn.apply(this, arguments);
		  }
	
		  return deprecated;
		};
	
		var debugs = {};
		var debugEnviron;
		exports.debuglog = function (set) {
		  if (isUndefined(debugEnviron)) debugEnviron = process.env.NODE_DEBUG || '';
		  set = set.toUpperCase();
		  if (!debugs[set]) {
		    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
		      var pid = process.pid;
		      debugs[set] = function () {
		        var msg = exports.format.apply(exports, arguments);
		        console.error('%s %d: %s', set, pid, msg);
		      };
		    } else {
		      debugs[set] = function () {};
		    }
		  }
		  return debugs[set];
		};
	
		/**
		 * Echos the value of a value. Trys to print the value out
		 * in the best way possible given the different types.
		 *
		 * @param {Object} obj The object to print out.
		 * @param {Object} opts Optional options object that alters the output.
		 */
		/* legacy: obj, showHidden, depth, colors*/
		function inspect(obj, opts) {
		  // default options
		  var ctx = {
		    seen: [],
		    stylize: stylizeNoColor
		  };
		  // legacy...
		  if (arguments.length >= 3) ctx.depth = arguments[2];
		  if (arguments.length >= 4) ctx.colors = arguments[3];
		  if (isBoolean(opts)) {
		    // legacy...
		    ctx.showHidden = opts;
		  } else if (opts) {
		    // got an "options" object
		    exports._extend(ctx, opts);
		  }
		  // set default options
		  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
		  if (isUndefined(ctx.depth)) ctx.depth = 2;
		  if (isUndefined(ctx.colors)) ctx.colors = false;
		  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
		  if (ctx.colors) ctx.stylize = stylizeWithColor;
		  return formatValue(ctx, obj, ctx.depth);
		}
		exports.inspect = inspect;
	
		// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
		inspect.colors = {
		  'bold': [1, 22],
		  'italic': [3, 23],
		  'underline': [4, 24],
		  'inverse': [7, 27],
		  'white': [37, 39],
		  'grey': [90, 39],
		  'black': [30, 39],
		  'blue': [34, 39],
		  'cyan': [36, 39],
		  'green': [32, 39],
		  'magenta': [35, 39],
		  'red': [31, 39],
		  'yellow': [33, 39]
		};
	
		// Don't use 'blue' not visible on cmd.exe
		inspect.styles = {
		  'special': 'cyan',
		  'number': 'yellow',
		  'boolean': 'yellow',
		  'undefined': 'grey',
		  'null': 'bold',
		  'string': 'green',
		  'date': 'magenta',
		  // "name": intentionally not styling
		  'regexp': 'red'
		};
	
		function stylizeWithColor(str, styleType) {
		  var style = inspect.styles[styleType];
	
		  if (style) {
		    return '\x1B[' + inspect.colors[style][0] + 'm' + str + '\x1B[' + inspect.colors[style][1] + 'm';
		  } else {
		    return str;
		  }
		}
	
		function stylizeNoColor(str, styleType) {
		  return str;
		}
	
		function arrayToHash(array) {
		  var hash = {};
	
		  array.forEach(function (val, idx) {
		    hash[val] = true;
		  });
	
		  return hash;
		}
	
		function formatValue(ctx, value, recurseTimes) {
		  // Provide a hook for user-specified inspect functions.
		  // Check that value is an object with an inspect function on it
		  if (ctx.customInspect && value && isFunction(value.inspect) &&
		  // Filter out the util module, it's inspect function is special
		  value.inspect !== exports.inspect &&
		  // Also filter out any prototype objects using the circular check.
		  !(value.constructor && value.constructor.prototype === value)) {
		    var ret = value.inspect(recurseTimes, ctx);
		    if (!isString(ret)) {
		      ret = formatValue(ctx, ret, recurseTimes);
		    }
		    return ret;
		  }
	
		  // Primitive types cannot have properties
		  var primitive = formatPrimitive(ctx, value);
		  if (primitive) {
		    return primitive;
		  }
	
		  // Look up the keys of the object.
		  var keys = Object.keys(value);
		  var visibleKeys = arrayToHash(keys);
	
		  if (ctx.showHidden) {
		    keys = Object.getOwnPropertyNames(value);
		  }
	
		  // IE doesn't make error fields non-enumerable
		  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
		  if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
		    return formatError(value);
		  }
	
		  // Some type of object without properties can be shortcutted.
		  if (keys.length === 0) {
		    if (isFunction(value)) {
		      var name = value.name ? ': ' + value.name : '';
		      return ctx.stylize('[Function' + name + ']', 'special');
		    }
		    if (isRegExp(value)) {
		      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
		    }
		    if (isDate(value)) {
		      return ctx.stylize(Date.prototype.toString.call(value), 'date');
		    }
		    if (isError(value)) {
		      return formatError(value);
		    }
		  }
	
		  var base = '',
		      array = false,
		      braces = ['{', '}'];
	
		  // Make Array say that they are Array
		  if (isArray(value)) {
		    array = true;
		    braces = ['[', ']'];
		  }
	
		  // Make functions say that they are functions
		  if (isFunction(value)) {
		    var n = value.name ? ': ' + value.name : '';
		    base = ' [Function' + n + ']';
		  }
	
		  // Make RegExps say that they are RegExps
		  if (isRegExp(value)) {
		    base = ' ' + RegExp.prototype.toString.call(value);
		  }
	
		  // Make dates with properties first say the date
		  if (isDate(value)) {
		    base = ' ' + Date.prototype.toUTCString.call(value);
		  }
	
		  // Make error with message first say the error
		  if (isError(value)) {
		    base = ' ' + formatError(value);
		  }
	
		  if (keys.length === 0 && (!array || value.length == 0)) {
		    return braces[0] + base + braces[1];
		  }
	
		  if (recurseTimes < 0) {
		    if (isRegExp(value)) {
		      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
		    } else {
		      return ctx.stylize('[Object]', 'special');
		    }
		  }
	
		  ctx.seen.push(value);
	
		  var output;
		  if (array) {
		    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
		  } else {
		    output = keys.map(function (key) {
		      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
		    });
		  }
	
		  ctx.seen.pop();
	
		  return reduceToSingleString(output, base, braces);
		}
	
		function formatPrimitive(ctx, value) {
		  if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');
		  if (isString(value)) {
		    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
		    return ctx.stylize(simple, 'string');
		  }
		  if (isNumber(value)) return ctx.stylize('' + value, 'number');
		  if (isBoolean(value)) return ctx.stylize('' + value, 'boolean');
		  // For some reason typeof null is "object", so special case here.
		  if (isNull(value)) return ctx.stylize('null', 'null');
		}
	
		function formatError(value) {
		  return '[' + Error.prototype.toString.call(value) + ']';
		}
	
		function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
		  var output = [];
		  for (var i = 0, l = value.length; i < l; ++i) {
		    if (hasOwnProperty(value, String(i))) {
		      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
		    } else {
		      output.push('');
		    }
		  }
		  keys.forEach(function (key) {
		    if (!key.match(/^\d+$/)) {
		      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
		    }
		  });
		  return output;
		}
	
		function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
		  var name, str, desc;
		  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
		  if (desc.get) {
		    if (desc.set) {
		      str = ctx.stylize('[Getter/Setter]', 'special');
		    } else {
		      str = ctx.stylize('[Getter]', 'special');
		    }
		  } else {
		    if (desc.set) {
		      str = ctx.stylize('[Setter]', 'special');
		    }
		  }
		  if (!hasOwnProperty(visibleKeys, key)) {
		    name = '[' + key + ']';
		  }
		  if (!str) {
		    if (ctx.seen.indexOf(desc.value) < 0) {
		      if (isNull(recurseTimes)) {
		        str = formatValue(ctx, desc.value, null);
		      } else {
		        str = formatValue(ctx, desc.value, recurseTimes - 1);
		      }
		      if (str.indexOf('\n') > -1) {
		        if (array) {
		          str = str.split('\n').map(function (line) {
		            return '  ' + line;
		          }).join('\n').substr(2);
		        } else {
		          str = '\n' + str.split('\n').map(function (line) {
		            return '   ' + line;
		          }).join('\n');
		        }
		      }
		    } else {
		      str = ctx.stylize('[Circular]', 'special');
		    }
		  }
		  if (isUndefined(name)) {
		    if (array && key.match(/^\d+$/)) {
		      return str;
		    }
		    name = JSON.stringify('' + key);
		    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
		      name = name.substr(1, name.length - 2);
		      name = ctx.stylize(name, 'name');
		    } else {
		      name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
		      name = ctx.stylize(name, 'string');
		    }
		  }
	
		  return name + ': ' + str;
		}
	
		function reduceToSingleString(output, base, braces) {
		  var numLinesEst = 0;
		  var length = output.reduce(function (prev, cur) {
		    numLinesEst++;
		    if (cur.indexOf('\n') >= 0) numLinesEst++;
		    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
		  }, 0);
	
		  if (length > 60) {
		    return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
		  }
	
		  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
		}
	
		// NOTE: These type checking functions intentionally don't use `instanceof`
		// because it is fragile and can be easily faked with `Object.create()`.
		function isArray(ar) {
		  return Array.isArray(ar);
		}
		exports.isArray = isArray;
	
		function isBoolean(arg) {
		  return typeof arg === 'boolean';
		}
		exports.isBoolean = isBoolean;
	
		function isNull(arg) {
		  return arg === null;
		}
		exports.isNull = isNull;
	
		function isNullOrUndefined(arg) {
		  return arg == null;
		}
		exports.isNullOrUndefined = isNullOrUndefined;
	
		function isNumber(arg) {
		  return typeof arg === 'number';
		}
		exports.isNumber = isNumber;
	
		function isString(arg) {
		  return typeof arg === 'string';
		}
		exports.isString = isString;
	
		function isSymbol(arg) {
		  return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'symbol';
		}
		exports.isSymbol = isSymbol;
	
		function isUndefined(arg) {
		  return arg === void 0;
		}
		exports.isUndefined = isUndefined;
	
		function isRegExp(re) {
		  return isObject(re) && objectToString(re) === '[object RegExp]';
		}
		exports.isRegExp = isRegExp;
	
		function isObject(arg) {
		  return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null;
		}
		exports.isObject = isObject;
	
		function isDate(d) {
		  return isObject(d) && objectToString(d) === '[object Date]';
		}
		exports.isDate = isDate;
	
		function isError(e) {
		  return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
		}
		exports.isError = isError;
	
		function isFunction(arg) {
		  return typeof arg === 'function';
		}
		exports.isFunction = isFunction;
	
		function isPrimitive(arg) {
		  return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'symbol' || // ES6 symbol
		  typeof arg === 'undefined';
		}
		exports.isPrimitive = isPrimitive;
	
		exports.isBuffer = __webpack_require__(627);
	
		function objectToString(o) {
		  return Object.prototype.toString.call(o);
		}
	
		function pad(n) {
		  return n < 10 ? '0' + n.toString(10) : n.toString(10);
		}
	
		var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	
		// 26 Feb 16:19:34
		function timestamp() {
		  var d = new Date();
		  var time = [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
		  return [d.getDate(), months[d.getMonth()], time].join(' ');
		}
	
		// log is just a thin wrapper to console.log that prepends a timestamp
		exports.log = function () {
		  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
		};
	
		/**
		 * Inherit the prototype methods from one constructor into another.
		 *
		 * The Function.prototype.inherits from lang.js rewritten as a standalone
		 * function (not on Function.prototype). NOTE: If this file is to be loaded
		 * during bootstrapping this function needs to be rewritten using some native
		 * functions as prototype setup using normal JavaScript does not work as
		 * expected during bootstrapping (see mirror.js in r114903).
		 *
		 * @param {function} ctor Constructor function which needs to inherit the
		 *     prototype.
		 * @param {function} superCtor Constructor function to inherit prototype from.
		 */
		exports.inherits = __webpack_require__(626);
	
		exports._extend = function (origin, add) {
		  // Don't do anything if add isn't an object
		  if (!add || !isObject(add)) return origin;
	
		  var keys = Object.keys(add);
		  var i = keys.length;
		  while (i--) {
		    origin[keys[i]] = add[keys[i]];
		  }
		  return origin;
		};
	
		function hasOwnProperty(obj, prop) {
		  return Object.prototype.hasOwnProperty.call(obj, prop);
		}
		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(8)))
	
	/***/ }),
	/* 118 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
		exports.__esModule = true;
	
		var _typeof2 = __webpack_require__(11);
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		exports.default = function (loc) {
		  var relative = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : process.cwd();
	
		  if ((typeof _module2.default === "undefined" ? "undefined" : (0, _typeof3.default)(_module2.default)) === "object") return null;
	
		  var relativeMod = relativeModules[relative];
	
		  if (!relativeMod) {
		    relativeMod = new _module2.default();
	
		    var filename = _path2.default.join(relative, ".babelrc");
		    relativeMod.id = filename;
		    relativeMod.filename = filename;
	
		    relativeMod.paths = _module2.default._nodeModulePaths(relative);
		    relativeModules[relative] = relativeMod;
		  }
	
		  try {
		    return _module2.default._resolveFilename(loc, relativeMod);
		  } catch (err) {
		    return null;
		  }
		};
	
		var _module = __webpack_require__(115);
	
		var _module2 = _interopRequireDefault(_module);
	
		var _path = __webpack_require__(19);
	
		var _path2 = _interopRequireDefault(_path);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var relativeModules = {};
	
		module.exports = exports["default"];
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))
	
	/***/ }),
	/* 119 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _map = __webpack_require__(133);
	
		var _map2 = _interopRequireDefault(_map);
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(42);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(41);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var Store = function (_Map) {
		  (0, _inherits3.default)(Store, _Map);
	
		  function Store() {
		    (0, _classCallCheck3.default)(this, Store);
	
		    var _this = (0, _possibleConstructorReturn3.default)(this, _Map.call(this));
	
		    _this.dynamicData = {};
		    return _this;
		  }
	
		  Store.prototype.setDynamic = function setDynamic(key, fn) {
		    this.dynamicData[key] = fn;
		  };
	
		  Store.prototype.get = function get(key) {
		    if (this.has(key)) {
		      return _Map.prototype.get.call(this, key);
		    } else {
		      if (Object.prototype.hasOwnProperty.call(this.dynamicData, key)) {
		        var val = this.dynamicData[key]();
		        this.set(key, val);
		        return val;
		      }
		    }
		  };
	
		  return Store;
		}(_map2.default);
	
		exports.default = Store;
		module.exports = exports["default"];
	
	/***/ }),
	/* 120 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _node = __webpack_require__(239);
	
		var _node2 = _interopRequireDefault(_node);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var verboseDebug = (0, _node2.default)("babel:verbose");
		var generalDebug = (0, _node2.default)("babel");
	
		var seenDeprecatedMessages = [];
	
		var Logger = function () {
		  function Logger(file, filename) {
		    (0, _classCallCheck3.default)(this, Logger);
	
		    this.filename = filename;
		    this.file = file;
		  }
	
		  Logger.prototype._buildMessage = function _buildMessage(msg) {
		    var parts = "[BABEL] " + this.filename;
		    if (msg) parts += ": " + msg;
		    return parts;
		  };
	
		  Logger.prototype.warn = function warn(msg) {
		    console.warn(this._buildMessage(msg));
		  };
	
		  Logger.prototype.error = function error(msg) {
		    var Constructor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Error;
	
		    throw new Constructor(this._buildMessage(msg));
		  };
	
		  Logger.prototype.deprecate = function deprecate(msg) {
		    if (this.file.opts && this.file.opts.suppressDeprecationMessages) return;
	
		    msg = this._buildMessage(msg);
	
		    if (seenDeprecatedMessages.indexOf(msg) >= 0) return;
	
		    seenDeprecatedMessages.push(msg);
	
		    console.error(msg);
		  };
	
		  Logger.prototype.verbose = function verbose(msg) {
		    if (verboseDebug.enabled) verboseDebug(this._buildMessage(msg));
		  };
	
		  Logger.prototype.debug = function debug(msg) {
		    if (generalDebug.enabled) generalDebug(this._buildMessage(msg));
		  };
	
		  Logger.prototype.deopt = function deopt(node, msg) {
		    this.debug(msg);
		  };
	
		  return Logger;
		}();
	
		exports.default = Logger;
		module.exports = exports["default"];
	
	/***/ }),
	/* 121 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.ImportDeclaration = exports.ModuleDeclaration = undefined;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.ExportDeclaration = ExportDeclaration;
		exports.Scope = Scope;
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var ModuleDeclaration = exports.ModuleDeclaration = {
		  enter: function enter(path, file) {
		    var node = path.node;
	
		    if (node.source) {
		      node.source.value = file.resolveModuleSource(node.source.value);
		    }
		  }
		};
	
		var ImportDeclaration = exports.ImportDeclaration = {
		  exit: function exit(path, file) {
		    var node = path.node;
	
		    var specifiers = [];
		    var imported = [];
		    file.metadata.modules.imports.push({
		      source: node.source.value,
		      imported: imported,
		      specifiers: specifiers
		    });
	
		    for (var _iterator = path.get("specifiers"), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var specifier = _ref;
	
		      var local = specifier.node.local.name;
	
		      if (specifier.isImportDefaultSpecifier()) {
		        imported.push("default");
		        specifiers.push({
		          kind: "named",
		          imported: "default",
		          local: local
		        });
		      }
	
		      if (specifier.isImportSpecifier()) {
		        var importedName = specifier.node.imported.name;
		        imported.push(importedName);
		        specifiers.push({
		          kind: "named",
		          imported: importedName,
		          local: local
		        });
		      }
	
		      if (specifier.isImportNamespaceSpecifier()) {
		        imported.push("*");
		        specifiers.push({
		          kind: "namespace",
		          local: local
		        });
		      }
		    }
		  }
		};
	
		function ExportDeclaration(path, file) {
		  var node = path.node;
	
		  var source = node.source ? node.source.value : null;
		  var exports = file.metadata.modules.exports;
	
		  var declar = path.get("declaration");
		  if (declar.isStatement()) {
		    var bindings = declar.getBindingIdentifiers();
	
		    for (var name in bindings) {
		      exports.exported.push(name);
		      exports.specifiers.push({
		        kind: "local",
		        local: name,
		        exported: path.isExportDefaultDeclaration() ? "default" : name
		      });
		    }
		  }
	
		  if (path.isExportNamedDeclaration() && node.specifiers) {
		    for (var _iterator2 = node.specifiers, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		      var _ref2;
	
		      if (_isArray2) {
		        if (_i2 >= _iterator2.length) break;
		        _ref2 = _iterator2[_i2++];
		      } else {
		        _i2 = _iterator2.next();
		        if (_i2.done) break;
		        _ref2 = _i2.value;
		      }
	
		      var specifier = _ref2;
	
		      var exported = specifier.exported.name;
		      exports.exported.push(exported);
	
		      if (t.isExportDefaultSpecifier(specifier)) {
		        exports.specifiers.push({
		          kind: "external",
		          local: exported,
		          exported: exported,
		          source: source
		        });
		      }
	
		      if (t.isExportNamespaceSpecifier(specifier)) {
		        exports.specifiers.push({
		          kind: "external-namespace",
		          exported: exported,
		          source: source
		        });
		      }
	
		      var local = specifier.local;
		      if (!local) continue;
	
		      if (source) {
		        exports.specifiers.push({
		          kind: "external",
		          local: local.name,
		          exported: exported,
		          source: source
		        });
		      }
	
		      if (!source) {
		        exports.specifiers.push({
		          kind: "local",
		          local: local.name,
		          exported: exported
		        });
		      }
		    }
		  }
	
		  if (path.isExportAllDeclaration()) {
		    exports.specifiers.push({
		      kind: "external-all",
		      source: source
		    });
		  }
		}
	
		function Scope(path) {
		  path.skip();
		}
	
	/***/ }),
	/* 122 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.inspect = exports.inherits = undefined;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _util = __webpack_require__(117);
	
		Object.defineProperty(exports, "inherits", {
		  enumerable: true,
		  get: function get() {
		    return _util.inherits;
		  }
		});
		Object.defineProperty(exports, "inspect", {
		  enumerable: true,
		  get: function get() {
		    return _util.inspect;
		  }
		});
		exports.canCompile = canCompile;
		exports.list = list;
		exports.regexify = regexify;
		exports.arrayify = arrayify;
		exports.booleanify = booleanify;
		exports.shouldIgnore = shouldIgnore;
	
		var _escapeRegExp = __webpack_require__(577);
	
		var _escapeRegExp2 = _interopRequireDefault(_escapeRegExp);
	
		var _startsWith = __webpack_require__(595);
	
		var _startsWith2 = _interopRequireDefault(_startsWith);
	
		var _minimatch = __webpack_require__(601);
	
		var _minimatch2 = _interopRequireDefault(_minimatch);
	
		var _includes = __webpack_require__(111);
	
		var _includes2 = _interopRequireDefault(_includes);
	
		var _isRegExp = __webpack_require__(276);
	
		var _isRegExp2 = _interopRequireDefault(_isRegExp);
	
		var _path = __webpack_require__(19);
	
		var _path2 = _interopRequireDefault(_path);
	
		var _slash = __webpack_require__(284);
	
		var _slash2 = _interopRequireDefault(_slash);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function canCompile(filename, altExts) {
		  var exts = altExts || canCompile.EXTENSIONS;
		  var ext = _path2.default.extname(filename);
		  return (0, _includes2.default)(exts, ext);
		}
	
		canCompile.EXTENSIONS = [".js", ".jsx", ".es6", ".es"];
	
		function list(val) {
		  if (!val) {
		    return [];
		  } else if (Array.isArray(val)) {
		    return val;
		  } else if (typeof val === "string") {
		    return val.split(",");
		  } else {
		    return [val];
		  }
		}
	
		function regexify(val) {
		  if (!val) {
		    return new RegExp(/.^/);
		  }
	
		  if (Array.isArray(val)) {
		    val = new RegExp(val.map(_escapeRegExp2.default).join("|"), "i");
		  }
	
		  if (typeof val === "string") {
		    val = (0, _slash2.default)(val);
	
		    if ((0, _startsWith2.default)(val, "./") || (0, _startsWith2.default)(val, "*/")) val = val.slice(2);
		    if ((0, _startsWith2.default)(val, "**/")) val = val.slice(3);
	
		    var regex = _minimatch2.default.makeRe(val, { nocase: true });
		    return new RegExp(regex.source.slice(1, -1), "i");
		  }
	
		  if ((0, _isRegExp2.default)(val)) {
		    return val;
		  }
	
		  throw new TypeError("illegal type for regexify");
		}
	
		function arrayify(val, mapFn) {
		  if (!val) return [];
		  if (typeof val === "boolean") return arrayify([val], mapFn);
		  if (typeof val === "string") return arrayify(list(val), mapFn);
	
		  if (Array.isArray(val)) {
		    if (mapFn) val = val.map(mapFn);
		    return val;
		  }
	
		  return [val];
		}
	
		function booleanify(val) {
		  if (val === "true" || val == 1) {
		    return true;
		  }
	
		  if (val === "false" || val == 0 || !val) {
		    return false;
		  }
	
		  return val;
		}
	
		function shouldIgnore(filename) {
		  var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
		  var only = arguments[2];
	
		  filename = filename.replace(/\\/g, "/");
	
		  if (only) {
		    for (var _iterator = only, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var pattern = _ref;
	
		      if (_shouldIgnore(pattern, filename)) return false;
		    }
		    return true;
		  } else if (ignore.length) {
		    for (var _iterator2 = ignore, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		      var _ref2;
	
		      if (_isArray2) {
		        if (_i2 >= _iterator2.length) break;
		        _ref2 = _iterator2[_i2++];
		      } else {
		        _i2 = _iterator2.next();
		        if (_i2.done) break;
		        _ref2 = _i2.value;
		      }
	
		      var _pattern = _ref2;
	
		      if (_shouldIgnore(_pattern, filename)) return true;
		    }
		  }
	
		  return false;
		}
	
		function _shouldIgnore(pattern, filename) {
		  if (typeof pattern === "function") {
		    return pattern(filename);
		  } else {
		    return pattern.test(filename);
		  }
		}
	
	/***/ }),
	/* 123 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.ArrayPattern = exports.ObjectPattern = exports.RestProperty = exports.SpreadProperty = exports.SpreadElement = undefined;
		exports.Identifier = Identifier;
		exports.RestElement = RestElement;
		exports.ObjectExpression = ObjectExpression;
		exports.ObjectMethod = ObjectMethod;
		exports.ObjectProperty = ObjectProperty;
		exports.ArrayExpression = ArrayExpression;
		exports.RegExpLiteral = RegExpLiteral;
		exports.BooleanLiteral = BooleanLiteral;
		exports.NullLiteral = NullLiteral;
		exports.NumericLiteral = NumericLiteral;
		exports.StringLiteral = StringLiteral;
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		var _jsesc = __webpack_require__(469);
	
		var _jsesc2 = _interopRequireDefault(_jsesc);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function Identifier(node) {
		  if (node.variance) {
		    if (node.variance === "plus") {
		      this.token("+");
		    } else if (node.variance === "minus") {
		      this.token("-");
		    }
		  }
	
		  this.word(node.name);
		}
	
		function RestElement(node) {
		  this.token("...");
		  this.print(node.argument, node);
		}
	
		exports.SpreadElement = RestElement;
		exports.SpreadProperty = RestElement;
		exports.RestProperty = RestElement;
		function ObjectExpression(node) {
		  var props = node.properties;
	
		  this.token("{");
		  this.printInnerComments(node);
	
		  if (props.length) {
		    this.space();
		    this.printList(props, node, { indent: true, statement: true });
		    this.space();
		  }
	
		  this.token("}");
		}
	
		exports.ObjectPattern = ObjectExpression;
		function ObjectMethod(node) {
		  this.printJoin(node.decorators, node);
		  this._method(node);
		}
	
		function ObjectProperty(node) {
		  this.printJoin(node.decorators, node);
	
		  if (node.computed) {
		    this.token("[");
		    this.print(node.key, node);
		    this.token("]");
		  } else {
		    if (t.isAssignmentPattern(node.value) && t.isIdentifier(node.key) && node.key.name === node.value.left.name) {
		      this.print(node.value, node);
		      return;
		    }
	
		    this.print(node.key, node);
	
		    if (node.shorthand && t.isIdentifier(node.key) && t.isIdentifier(node.value) && node.key.name === node.value.name) {
		      return;
		    }
		  }
	
		  this.token(":");
		  this.space();
		  this.print(node.value, node);
		}
	
		function ArrayExpression(node) {
		  var elems = node.elements;
		  var len = elems.length;
	
		  this.token("[");
		  this.printInnerComments(node);
	
		  for (var i = 0; i < elems.length; i++) {
		    var elem = elems[i];
		    if (elem) {
		      if (i > 0) this.space();
		      this.print(elem, node);
		      if (i < len - 1) this.token(",");
		    } else {
		      this.token(",");
		    }
		  }
	
		  this.token("]");
		}
	
		exports.ArrayPattern = ArrayExpression;
		function RegExpLiteral(node) {
		  this.word("/" + node.pattern + "/" + node.flags);
		}
	
		function BooleanLiteral(node) {
		  this.word(node.value ? "true" : "false");
		}
	
		function NullLiteral() {
		  this.word("null");
		}
	
		function NumericLiteral(node) {
		  var raw = this.getPossibleRaw(node);
		  var value = node.value + "";
		  if (raw == null) {
		    this.number(value);
		  } else if (this.format.minified) {
		    this.number(raw.length < value.length ? raw : value);
		  } else {
		    this.number(raw);
		  }
		}
	
		function StringLiteral(node, parent) {
		  var raw = this.getPossibleRaw(node);
		  if (!this.format.minified && raw != null) {
		    this.token(raw);
		    return;
		  }
	
		  var opts = {
		    quotes: t.isJSX(parent) ? "double" : this.format.quotes,
		    wrap: true
		  };
		  if (this.format.jsonCompatibleStrings) {
		    opts.json = true;
		  }
		  var val = (0, _jsesc2.default)(node.value, opts);
	
		  return this.token(val);
		}
	
	/***/ }),
	/* 124 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (path, file, helpers) {
		  if (!helpers) {
		    helpers = { wrapAsync: file };
		    file = null;
		  }
		  path.traverse(awaitVisitor, {
		    file: file,
		    wrapAwait: helpers.wrapAwait
		  });
	
		  if (path.isClassMethod() || path.isObjectMethod()) {
		    classOrObjectMethod(path, helpers.wrapAsync);
		  } else {
		    plainFunction(path, helpers.wrapAsync);
		  }
		};
	
		var _babelHelperFunctionName = __webpack_require__(40);
	
		var _babelHelperFunctionName2 = _interopRequireDefault(_babelHelperFunctionName);
	
		var _babelTemplate = __webpack_require__(4);
	
		var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		var _forAwait = __webpack_require__(320);
	
		var _forAwait2 = _interopRequireDefault(_forAwait);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var buildWrapper = (0, _babelTemplate2.default)("\n  (() => {\n    var REF = FUNCTION;\n    return function NAME(PARAMS) {\n      return REF.apply(this, arguments);\n    };\n  })\n");
	
		var namedBuildWrapper = (0, _babelTemplate2.default)("\n  (() => {\n    var REF = FUNCTION;\n    function NAME(PARAMS) {\n      return REF.apply(this, arguments);\n    }\n    return NAME;\n  })\n");
	
		var awaitVisitor = {
		  Function: function Function(path) {
		    if (path.isArrowFunctionExpression() && !path.node.async) {
		      path.arrowFunctionToShadowed();
		      return;
		    }
		    path.skip();
		  },
		  AwaitExpression: function AwaitExpression(_ref, _ref2) {
		    var node = _ref.node;
		    var wrapAwait = _ref2.wrapAwait;
	
		    node.type = "YieldExpression";
		    if (wrapAwait) {
		      node.argument = t.callExpression(wrapAwait, [node.argument]);
		    }
		  },
		  ForAwaitStatement: function ForAwaitStatement(path, _ref3) {
		    var file = _ref3.file,
		        wrapAwait = _ref3.wrapAwait;
		    var node = path.node;
	
		    var build = (0, _forAwait2.default)(path, {
		      getAsyncIterator: file.addHelper("asyncIterator"),
		      wrapAwait: wrapAwait
		    });
	
		    var declar = build.declar,
		        loop = build.loop;
	
		    var block = loop.body;
	
		    path.ensureBlock();
	
		    if (declar) {
		      block.body.push(declar);
		    }
	
		    block.body = block.body.concat(node.body.body);
	
		    t.inherits(loop, node);
		    t.inherits(loop.body, node.body);
	
		    if (build.replaceParent) {
		      path.parentPath.replaceWithMultiple(build.node);
		      path.remove();
		    } else {
		      path.replaceWithMultiple(build.node);
		    }
		  }
		};
	
		function classOrObjectMethod(path, callId) {
		  var node = path.node;
		  var body = node.body;
	
		  node.async = false;
	
		  var container = t.functionExpression(null, [], t.blockStatement(body.body), true);
		  container.shadow = true;
		  body.body = [t.returnStatement(t.callExpression(t.callExpression(callId, [container]), []))];
	
		  node.generator = false;
		}
	
		function plainFunction(path, callId) {
		  var node = path.node;
		  var isDeclaration = path.isFunctionDeclaration();
		  var asyncFnId = node.id;
		  var wrapper = buildWrapper;
	
		  if (path.isArrowFunctionExpression()) {
		    path.arrowFunctionToShadowed();
		  } else if (!isDeclaration && asyncFnId) {
		    wrapper = namedBuildWrapper;
		  }
	
		  node.async = false;
		  node.generator = true;
	
		  node.id = null;
	
		  if (isDeclaration) {
		    node.type = "FunctionExpression";
		  }
	
		  var built = t.callExpression(callId, [node]);
		  var container = wrapper({
		    NAME: asyncFnId,
		    REF: path.scope.generateUidIdentifier("ref"),
		    FUNCTION: built,
		    PARAMS: node.params.reduce(function (acc, param) {
		      acc.done = acc.done || t.isAssignmentPattern(param) || t.isRestElement(param);
	
		      if (!acc.done) {
		        acc.params.push(path.scope.generateUidIdentifier("x"));
		      }
	
		      return acc;
		    }, {
		      params: [],
		      done: false
		    }).params
		  }).expression;
	
		  if (isDeclaration) {
		    var declar = t.variableDeclaration("let", [t.variableDeclarator(t.identifier(asyncFnId.name), t.callExpression(container, []))]);
		    declar._blockHoist = true;
	
		    path.replaceWith(declar);
		  } else {
		    var retFunction = container.body.body[1].argument;
		    if (!asyncFnId) {
		      (0, _babelHelperFunctionName2.default)({
		        node: retFunction,
		        parent: path.parent,
		        scope: path.scope
		      });
		    }
	
		    if (!retFunction || retFunction.id || node.params.length) {
		      path.replaceWith(t.callExpression(container, []));
		    } else {
		      path.replaceWith(built);
		    }
		  }
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 125 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    manipulateOptions: function manipulateOptions(opts, parserOpts) {
		      parserOpts.plugins.push("decorators");
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 126 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    manipulateOptions: function manipulateOptions(opts, parserOpts) {
		      parserOpts.plugins.push("flow");
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 127 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    manipulateOptions: function manipulateOptions(opts, parserOpts) {
		      parserOpts.plugins.push("jsx");
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 128 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    manipulateOptions: function manipulateOptions(opts, parserOpts) {
		      parserOpts.plugins.push("trailingFunctionCommas");
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 129 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    inherits: __webpack_require__(67),
	
		    visitor: {
		      Function: function Function(path, state) {
		        if (!path.node.async || path.node.generator) return;
	
		        (0, _babelHelperRemapAsyncToGenerator2.default)(path, state.file, {
		          wrapAsync: state.addHelper("asyncToGenerator")
		        });
		      }
		    }
		  };
		};
	
		var _babelHelperRemapAsyncToGenerator = __webpack_require__(124);
	
		var _babelHelperRemapAsyncToGenerator2 = _interopRequireDefault(_babelHelperRemapAsyncToGenerator);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 130 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _create = __webpack_require__(9);
	
		var _create2 = _interopRequireDefault(_create);
	
		exports.default = function () {
		  return {
		    visitor: {
		      ObjectExpression: function ObjectExpression(path) {
		        var node = path.node;
	
		        var plainProps = node.properties.filter(function (prop) {
		          return !t.isSpreadProperty(prop) && !prop.computed;
		        });
	
		        var alreadySeenData = (0, _create2.default)(null);
		        var alreadySeenGetters = (0, _create2.default)(null);
		        var alreadySeenSetters = (0, _create2.default)(null);
	
		        for (var _iterator = plainProps, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		          var _ref;
	
		          if (_isArray) {
		            if (_i >= _iterator.length) break;
		            _ref = _iterator[_i++];
		          } else {
		            _i = _iterator.next();
		            if (_i.done) break;
		            _ref = _i.value;
		          }
	
		          var prop = _ref;
	
		          var name = getName(prop.key);
		          var isDuplicate = false;
		          switch (prop.kind) {
		            case "get":
		              if (alreadySeenData[name] || alreadySeenGetters[name]) {
		                isDuplicate = true;
		              }
		              alreadySeenGetters[name] = true;
		              break;
		            case "set":
		              if (alreadySeenData[name] || alreadySeenSetters[name]) {
		                isDuplicate = true;
		              }
		              alreadySeenSetters[name] = true;
		              break;
		            default:
		              if (alreadySeenData[name] || alreadySeenGetters[name] || alreadySeenSetters[name]) {
		                isDuplicate = true;
		              }
		              alreadySeenData[name] = true;
		          }
	
		          if (isDuplicate) {
		            prop.computed = true;
		            prop.key = t.stringLiteral(name);
		          }
		        }
		      }
		    }
		  };
		};
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function getName(key) {
		  if (t.isIdentifier(key)) {
		    return key.name;
		  }
		  return key.value.toString();
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 131 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _create = __webpack_require__(9);
	
		var _create2 = _interopRequireDefault(_create);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  function isValidRequireCall(path) {
		    if (!path.isCallExpression()) return false;
		    if (!path.get("callee").isIdentifier({ name: "require" })) return false;
		    if (path.scope.getBinding("require")) return false;
	
		    var args = path.get("arguments");
		    if (args.length !== 1) return false;
	
		    var arg = args[0];
		    if (!arg.isStringLiteral()) return false;
	
		    return true;
		  }
	
		  var amdVisitor = {
		    ReferencedIdentifier: function ReferencedIdentifier(_ref2) {
		      var node = _ref2.node,
		          scope = _ref2.scope;
	
		      if (node.name === "exports" && !scope.getBinding("exports")) {
		        this.hasExports = true;
		      }
	
		      if (node.name === "module" && !scope.getBinding("module")) {
		        this.hasModule = true;
		      }
		    },
		    CallExpression: function CallExpression(path) {
		      if (!isValidRequireCall(path)) return;
		      this.bareSources.push(path.node.arguments[0]);
		      path.remove();
		    },
		    VariableDeclarator: function VariableDeclarator(path) {
		      var id = path.get("id");
		      if (!id.isIdentifier()) return;
	
		      var init = path.get("init");
		      if (!isValidRequireCall(init)) return;
	
		      var source = init.node.arguments[0];
		      this.sourceNames[source.value] = true;
		      this.sources.push([id.node, source]);
	
		      path.remove();
		    }
		  };
	
		  return {
		    inherits: __webpack_require__(77),
	
		    pre: function pre() {
		      this.sources = [];
		      this.sourceNames = (0, _create2.default)(null);
	
		      this.bareSources = [];
	
		      this.hasExports = false;
		      this.hasModule = false;
		    },
	
		    visitor: {
		      Program: {
		        exit: function exit(path) {
		          var _this = this;
	
		          if (this.ran) return;
		          this.ran = true;
	
		          path.traverse(amdVisitor, this);
	
		          var params = this.sources.map(function (source) {
		            return source[0];
		          });
		          var sources = this.sources.map(function (source) {
		            return source[1];
		          });
	
		          sources = sources.concat(this.bareSources.filter(function (str) {
		            return !_this.sourceNames[str.value];
		          }));
	
		          var moduleName = this.getModuleName();
		          if (moduleName) moduleName = t.stringLiteral(moduleName);
	
		          if (this.hasExports) {
		            sources.unshift(t.stringLiteral("exports"));
		            params.unshift(t.identifier("exports"));
		          }
	
		          if (this.hasModule) {
		            sources.unshift(t.stringLiteral("module"));
		            params.unshift(t.identifier("module"));
		          }
	
		          var node = path.node;
	
		          var factory = buildFactory({
		            PARAMS: params,
		            BODY: node.body
		          });
		          factory.expression.body.directives = node.directives;
		          node.directives = [];
	
		          node.body = [buildDefine({
		            MODULE_NAME: moduleName,
		            SOURCES: sources,
		            FACTORY: factory
		          })];
		        }
		      }
		    }
		  };
		};
	
		var _babelTemplate = __webpack_require__(4);
	
		var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var buildDefine = (0, _babelTemplate2.default)("\n  define(MODULE_NAME, [SOURCES], FACTORY);\n");
	
		var buildFactory = (0, _babelTemplate2.default)("\n  (function (PARAMS) {\n    BODY;\n  })\n");
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 132 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  return {
		    inherits: __webpack_require__(199),
	
		    visitor: (0, _babelHelperBuilderBinaryAssignmentOperatorVisitor2.default)({
		      operator: "**",
	
		      build: function build(left, right) {
		        return t.callExpression(t.memberExpression(t.identifier("Math"), t.identifier("pow")), [left, right]);
		      }
		    })
		  };
		};
	
		var _babelHelperBuilderBinaryAssignmentOperatorVisitor = __webpack_require__(316);
	
		var _babelHelperBuilderBinaryAssignmentOperatorVisitor2 = _interopRequireDefault(_babelHelperBuilderBinaryAssignmentOperatorVisitor);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 133 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		module.exports = { "default": __webpack_require__(406), __esModule: true };
	
	/***/ }),
	/* 134 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _keys = __webpack_require__(14);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _create = __webpack_require__(9);
	
		var _create2 = _interopRequireDefault(_create);
	
		var _map = __webpack_require__(133);
	
		var _map2 = _interopRequireDefault(_map);
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _includes = __webpack_require__(111);
	
		var _includes2 = _interopRequireDefault(_includes);
	
		var _repeat = __webpack_require__(278);
	
		var _repeat2 = _interopRequireDefault(_repeat);
	
		var _renamer = __webpack_require__(383);
	
		var _renamer2 = _interopRequireDefault(_renamer);
	
		var _index = __webpack_require__(7);
	
		var _index2 = _interopRequireDefault(_index);
	
		var _defaults = __webpack_require__(273);
	
		var _defaults2 = _interopRequireDefault(_defaults);
	
		var _babelMessages = __webpack_require__(20);
	
		var messages = _interopRequireWildcard(_babelMessages);
	
		var _binding2 = __webpack_require__(225);
	
		var _binding3 = _interopRequireDefault(_binding2);
	
		var _globals = __webpack_require__(463);
	
		var _globals2 = _interopRequireDefault(_globals);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		var _cache = __webpack_require__(88);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var _crawlCallsCount = 0;
	
		function getCache(path, parentScope, self) {
		  var scopes = _cache.scope.get(path.node) || [];
	
		  for (var _iterator = scopes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		    var _ref;
	
		    if (_isArray) {
		      if (_i >= _iterator.length) break;
		      _ref = _iterator[_i++];
		    } else {
		      _i = _iterator.next();
		      if (_i.done) break;
		      _ref = _i.value;
		    }
	
		    var scope = _ref;
	
		    if (scope.parent === parentScope && scope.path === path) return scope;
		  }
	
		  scopes.push(self);
	
		  if (!_cache.scope.has(path.node)) {
		    _cache.scope.set(path.node, scopes);
		  }
		}
	
		function gatherNodeParts(node, parts) {
		  if (t.isModuleDeclaration(node)) {
		    if (node.source) {
		      gatherNodeParts(node.source, parts);
		    } else if (node.specifiers && node.specifiers.length) {
		      for (var _iterator2 = node.specifiers, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		        var _ref2;
	
		        if (_isArray2) {
		          if (_i2 >= _iterator2.length) break;
		          _ref2 = _iterator2[_i2++];
		        } else {
		          _i2 = _iterator2.next();
		          if (_i2.done) break;
		          _ref2 = _i2.value;
		        }
	
		        var specifier = _ref2;
	
		        gatherNodeParts(specifier, parts);
		      }
		    } else if (node.declaration) {
		      gatherNodeParts(node.declaration, parts);
		    }
		  } else if (t.isModuleSpecifier(node)) {
		    gatherNodeParts(node.local, parts);
		  } else if (t.isMemberExpression(node)) {
		    gatherNodeParts(node.object, parts);
		    gatherNodeParts(node.property, parts);
		  } else if (t.isIdentifier(node)) {
		    parts.push(node.name);
		  } else if (t.isLiteral(node)) {
		    parts.push(node.value);
		  } else if (t.isCallExpression(node)) {
		    gatherNodeParts(node.callee, parts);
		  } else if (t.isObjectExpression(node) || t.isObjectPattern(node)) {
		    for (var _iterator3 = node.properties, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		      var _ref3;
	
		      if (_isArray3) {
		        if (_i3 >= _iterator3.length) break;
		        _ref3 = _iterator3[_i3++];
		      } else {
		        _i3 = _iterator3.next();
		        if (_i3.done) break;
		        _ref3 = _i3.value;
		      }
	
		      var prop = _ref3;
	
		      gatherNodeParts(prop.key || prop.argument, parts);
		    }
		  }
		}
	
		var collectorVisitor = {
		  For: function For(path) {
		    for (var _iterator4 = t.FOR_INIT_KEYS, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
		      var _ref4;
	
		      if (_isArray4) {
		        if (_i4 >= _iterator4.length) break;
		        _ref4 = _iterator4[_i4++];
		      } else {
		        _i4 = _iterator4.next();
		        if (_i4.done) break;
		        _ref4 = _i4.value;
		      }
	
		      var key = _ref4;
	
		      var declar = path.get(key);
		      if (declar.isVar()) path.scope.getFunctionParent().registerBinding("var", declar);
		    }
		  },
		  Declaration: function Declaration(path) {
		    if (path.isBlockScoped()) return;
	
		    if (path.isExportDeclaration() && path.get("declaration").isDeclaration()) return;
	
		    path.scope.getFunctionParent().registerDeclaration(path);
		  },
		  ReferencedIdentifier: function ReferencedIdentifier(path, state) {
		    state.references.push(path);
		  },
		  ForXStatement: function ForXStatement(path, state) {
		    var left = path.get("left");
		    if (left.isPattern() || left.isIdentifier()) {
		      state.constantViolations.push(left);
		    }
		  },
	
		  ExportDeclaration: {
		    exit: function exit(path) {
		      var node = path.node,
		          scope = path.scope;
	
		      var declar = node.declaration;
		      if (t.isClassDeclaration(declar) || t.isFunctionDeclaration(declar)) {
		        var _id = declar.id;
		        if (!_id) return;
	
		        var binding = scope.getBinding(_id.name);
		        if (binding) binding.reference(path);
		      } else if (t.isVariableDeclaration(declar)) {
		        for (var _iterator5 = declar.declarations, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : (0, _getIterator3.default)(_iterator5);;) {
		          var _ref5;
	
		          if (_isArray5) {
		            if (_i5 >= _iterator5.length) break;
		            _ref5 = _iterator5[_i5++];
		          } else {
		            _i5 = _iterator5.next();
		            if (_i5.done) break;
		            _ref5 = _i5.value;
		          }
	
		          var decl = _ref5;
	
		          var ids = t.getBindingIdentifiers(decl);
		          for (var name in ids) {
		            var _binding = scope.getBinding(name);
		            if (_binding) _binding.reference(path);
		          }
		        }
		      }
		    }
		  },
	
		  LabeledStatement: function LabeledStatement(path) {
		    path.scope.getProgramParent().addGlobal(path.node);
		    path.scope.getBlockParent().registerDeclaration(path);
		  },
		  AssignmentExpression: function AssignmentExpression(path, state) {
		    state.assignments.push(path);
		  },
		  UpdateExpression: function UpdateExpression(path, state) {
		    state.constantViolations.push(path.get("argument"));
		  },
		  UnaryExpression: function UnaryExpression(path, state) {
		    if (path.node.operator === "delete") {
		      state.constantViolations.push(path.get("argument"));
		    }
		  },
		  BlockScoped: function BlockScoped(path) {
		    var scope = path.scope;
		    if (scope.path === path) scope = scope.parent;
		    scope.getBlockParent().registerDeclaration(path);
		  },
		  ClassDeclaration: function ClassDeclaration(path) {
		    var id = path.node.id;
		    if (!id) return;
	
		    var name = id.name;
		    path.scope.bindings[name] = path.scope.getBinding(name);
		  },
		  Block: function Block(path) {
		    var paths = path.get("body");
		    for (var _iterator6 = paths, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : (0, _getIterator3.default)(_iterator6);;) {
		      var _ref6;
	
		      if (_isArray6) {
		        if (_i6 >= _iterator6.length) break;
		        _ref6 = _iterator6[_i6++];
		      } else {
		        _i6 = _iterator6.next();
		        if (_i6.done) break;
		        _ref6 = _i6.value;
		      }
	
		      var bodyPath = _ref6;
	
		      if (bodyPath.isFunctionDeclaration()) {
		        path.scope.getBlockParent().registerDeclaration(bodyPath);
		      }
		    }
		  }
		};
	
		var uid = 0;
	
		var Scope = function () {
		  function Scope(path, parentScope) {
		    (0, _classCallCheck3.default)(this, Scope);
	
		    if (parentScope && parentScope.block === path.node) {
		      return parentScope;
		    }
	
		    var cached = getCache(path, parentScope, this);
		    if (cached) return cached;
	
		    this.uid = uid++;
		    this.parent = parentScope;
		    this.hub = path.hub;
	
		    this.parentBlock = path.parent;
		    this.block = path.node;
		    this.path = path;
	
		    this.labels = new _map2.default();
		  }
	
		  Scope.prototype.traverse = function traverse(node, opts, state) {
		    (0, _index2.default)(node, opts, this, state, this.path);
		  };
	
		  Scope.prototype.generateDeclaredUidIdentifier = function generateDeclaredUidIdentifier() {
		    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "temp";
	
		    var id = this.generateUidIdentifier(name);
		    this.push({ id: id });
		    return id;
		  };
	
		  Scope.prototype.generateUidIdentifier = function generateUidIdentifier() {
		    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "temp";
	
		    return t.identifier(this.generateUid(name));
		  };
	
		  Scope.prototype.generateUid = function generateUid() {
		    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "temp";
	
		    name = t.toIdentifier(name).replace(/^_+/, "").replace(/[0-9]+$/g, "");
	
		    var uid = void 0;
		    var i = 0;
		    do {
		      uid = this._generateUid(name, i);
		      i++;
		    } while (this.hasLabel(uid) || this.hasBinding(uid) || this.hasGlobal(uid) || this.hasReference(uid));
	
		    var program = this.getProgramParent();
		    program.references[uid] = true;
		    program.uids[uid] = true;
	
		    return uid;
		  };
	
		  Scope.prototype._generateUid = function _generateUid(name, i) {
		    var id = name;
		    if (i > 1) id += i;
		    return "_" + id;
		  };
	
		  Scope.prototype.generateUidIdentifierBasedOnNode = function generateUidIdentifierBasedOnNode(parent, defaultName) {
		    var node = parent;
	
		    if (t.isAssignmentExpression(parent)) {
		      node = parent.left;
		    } else if (t.isVariableDeclarator(parent)) {
		      node = parent.id;
		    } else if (t.isObjectProperty(node) || t.isObjectMethod(node)) {
		      node = node.key;
		    }
	
		    var parts = [];
		    gatherNodeParts(node, parts);
	
		    var id = parts.join("$");
		    id = id.replace(/^_/, "") || defaultName || "ref";
	
		    return this.generateUidIdentifier(id.slice(0, 20));
		  };
	
		  Scope.prototype.isStatic = function isStatic(node) {
		    if (t.isThisExpression(node) || t.isSuper(node)) {
		      return true;
		    }
	
		    if (t.isIdentifier(node)) {
		      var binding = this.getBinding(node.name);
		      if (binding) {
		        return binding.constant;
		      } else {
		        return this.hasBinding(node.name);
		      }
		    }
	
		    return false;
		  };
	
		  Scope.prototype.maybeGenerateMemoised = function maybeGenerateMemoised(node, dontPush) {
		    if (this.isStatic(node)) {
		      return null;
		    } else {
		      var _id2 = this.generateUidIdentifierBasedOnNode(node);
		      if (!dontPush) this.push({ id: _id2 });
		      return _id2;
		    }
		  };
	
		  Scope.prototype.checkBlockScopedCollisions = function checkBlockScopedCollisions(local, kind, name, id) {
		    if (kind === "param") return;
	
		    if (kind === "hoisted" && local.kind === "let") return;
	
		    var duplicate = kind === "let" || local.kind === "let" || local.kind === "const" || local.kind === "module" || local.kind === "param" && (kind === "let" || kind === "const");
	
		    if (duplicate) {
		      throw this.hub.file.buildCodeFrameError(id, messages.get("scopeDuplicateDeclaration", name), TypeError);
		    }
		  };
	
		  Scope.prototype.rename = function rename(oldName, newName, block) {
		    var binding = this.getBinding(oldName);
		    if (binding) {
		      newName = newName || this.generateUidIdentifier(oldName).name;
		      return new _renamer2.default(binding, oldName, newName).rename(block);
		    }
		  };
	
		  Scope.prototype._renameFromMap = function _renameFromMap(map, oldName, newName, value) {
		    if (map[oldName]) {
		      map[newName] = value;
		      map[oldName] = null;
		    }
		  };
	
		  Scope.prototype.dump = function dump() {
		    var sep = (0, _repeat2.default)("-", 60);
		    console.log(sep);
		    var scope = this;
		    do {
		      console.log("#", scope.block.type);
		      for (var name in scope.bindings) {
		        var binding = scope.bindings[name];
		        console.log(" -", name, {
		          constant: binding.constant,
		          references: binding.references,
		          violations: binding.constantViolations.length,
		          kind: binding.kind
		        });
		      }
		    } while (scope = scope.parent);
		    console.log(sep);
		  };
	
		  Scope.prototype.toArray = function toArray(node, i) {
		    var file = this.hub.file;
	
		    if (t.isIdentifier(node)) {
		      var binding = this.getBinding(node.name);
		      if (binding && binding.constant && binding.path.isGenericType("Array")) return node;
		    }
	
		    if (t.isArrayExpression(node)) {
		      return node;
		    }
	
		    if (t.isIdentifier(node, { name: "arguments" })) {
		      return t.callExpression(t.memberExpression(t.memberExpression(t.memberExpression(t.identifier("Array"), t.identifier("prototype")), t.identifier("slice")), t.identifier("call")), [node]);
		    }
	
		    var helperName = "toArray";
		    var args = [node];
		    if (i === true) {
		      helperName = "toConsumableArray";
		    } else if (i) {
		      args.push(t.numericLiteral(i));
		      helperName = "slicedToArray";
		    }
		    return t.callExpression(file.addHelper(helperName), args);
		  };
	
		  Scope.prototype.hasLabel = function hasLabel(name) {
		    return !!this.getLabel(name);
		  };
	
		  Scope.prototype.getLabel = function getLabel(name) {
		    return this.labels.get(name);
		  };
	
		  Scope.prototype.registerLabel = function registerLabel(path) {
		    this.labels.set(path.node.label.name, path);
		  };
	
		  Scope.prototype.registerDeclaration = function registerDeclaration(path) {
		    if (path.isLabeledStatement()) {
		      this.registerLabel(path);
		    } else if (path.isFunctionDeclaration()) {
		      this.registerBinding("hoisted", path.get("id"), path);
		    } else if (path.isVariableDeclaration()) {
		      var declarations = path.get("declarations");
		      for (var _iterator7 = declarations, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : (0, _getIterator3.default)(_iterator7);;) {
		        var _ref7;
	
		        if (_isArray7) {
		          if (_i7 >= _iterator7.length) break;
		          _ref7 = _iterator7[_i7++];
		        } else {
		          _i7 = _iterator7.next();
		          if (_i7.done) break;
		          _ref7 = _i7.value;
		        }
	
		        var declar = _ref7;
	
		        this.registerBinding(path.node.kind, declar);
		      }
		    } else if (path.isClassDeclaration()) {
		      this.registerBinding("let", path);
		    } else if (path.isImportDeclaration()) {
		      var specifiers = path.get("specifiers");
		      for (var _iterator8 = specifiers, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : (0, _getIterator3.default)(_iterator8);;) {
		        var _ref8;
	
		        if (_isArray8) {
		          if (_i8 >= _iterator8.length) break;
		          _ref8 = _iterator8[_i8++];
		        } else {
		          _i8 = _iterator8.next();
		          if (_i8.done) break;
		          _ref8 = _i8.value;
		        }
	
		        var specifier = _ref8;
	
		        this.registerBinding("module", specifier);
		      }
		    } else if (path.isExportDeclaration()) {
		      var _declar = path.get("declaration");
		      if (_declar.isClassDeclaration() || _declar.isFunctionDeclaration() || _declar.isVariableDeclaration()) {
		        this.registerDeclaration(_declar);
		      }
		    } else {
		      this.registerBinding("unknown", path);
		    }
		  };
	
		  Scope.prototype.buildUndefinedNode = function buildUndefinedNode() {
		    if (this.hasBinding("undefined")) {
		      return t.unaryExpression("void", t.numericLiteral(0), true);
		    } else {
		      return t.identifier("undefined");
		    }
		  };
	
		  Scope.prototype.registerConstantViolation = function registerConstantViolation(path) {
		    var ids = path.getBindingIdentifiers();
		    for (var name in ids) {
		      var binding = this.getBinding(name);
		      if (binding) binding.reassign(path);
		    }
		  };
	
		  Scope.prototype.registerBinding = function registerBinding(kind, path) {
		    var bindingPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : path;
	
		    if (!kind) throw new ReferenceError("no `kind`");
	
		    if (path.isVariableDeclaration()) {
		      var declarators = path.get("declarations");
		      for (var _iterator9 = declarators, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : (0, _getIterator3.default)(_iterator9);;) {
		        var _ref9;
	
		        if (_isArray9) {
		          if (_i9 >= _iterator9.length) break;
		          _ref9 = _iterator9[_i9++];
		        } else {
		          _i9 = _iterator9.next();
		          if (_i9.done) break;
		          _ref9 = _i9.value;
		        }
	
		        var declar = _ref9;
	
		        this.registerBinding(kind, declar);
		      }
		      return;
		    }
	
		    var parent = this.getProgramParent();
		    var ids = path.getBindingIdentifiers(true);
	
		    for (var name in ids) {
		      for (var _iterator10 = ids[name], _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : (0, _getIterator3.default)(_iterator10);;) {
		        var _ref10;
	
		        if (_isArray10) {
		          if (_i10 >= _iterator10.length) break;
		          _ref10 = _iterator10[_i10++];
		        } else {
		          _i10 = _iterator10.next();
		          if (_i10.done) break;
		          _ref10 = _i10.value;
		        }
	
		        var _id3 = _ref10;
	
		        var local = this.getOwnBinding(name);
		        if (local) {
		          if (local.identifier === _id3) continue;
	
		          this.checkBlockScopedCollisions(local, kind, name, _id3);
		        }
	
		        if (local && local.path.isFlow()) local = null;
	
		        parent.references[name] = true;
	
		        this.bindings[name] = new _binding3.default({
		          identifier: _id3,
		          existing: local,
		          scope: this,
		          path: bindingPath,
		          kind: kind
		        });
		      }
		    }
		  };
	
		  Scope.prototype.addGlobal = function addGlobal(node) {
		    this.globals[node.name] = node;
		  };
	
		  Scope.prototype.hasUid = function hasUid(name) {
		    var scope = this;
	
		    do {
		      if (scope.uids[name]) return true;
		    } while (scope = scope.parent);
	
		    return false;
		  };
	
		  Scope.prototype.hasGlobal = function hasGlobal(name) {
		    var scope = this;
	
		    do {
		      if (scope.globals[name]) return true;
		    } while (scope = scope.parent);
	
		    return false;
		  };
	
		  Scope.prototype.hasReference = function hasReference(name) {
		    var scope = this;
	
		    do {
		      if (scope.references[name]) return true;
		    } while (scope = scope.parent);
	
		    return false;
		  };
	
		  Scope.prototype.isPure = function isPure(node, constantsOnly) {
		    if (t.isIdentifier(node)) {
		      var binding = this.getBinding(node.name);
		      if (!binding) return false;
		      if (constantsOnly) return binding.constant;
		      return true;
		    } else if (t.isClass(node)) {
		      if (node.superClass && !this.isPure(node.superClass, constantsOnly)) return false;
		      return this.isPure(node.body, constantsOnly);
		    } else if (t.isClassBody(node)) {
		      for (var _iterator11 = node.body, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : (0, _getIterator3.default)(_iterator11);;) {
		        var _ref11;
	
		        if (_isArray11) {
		          if (_i11 >= _iterator11.length) break;
		          _ref11 = _iterator11[_i11++];
		        } else {
		          _i11 = _iterator11.next();
		          if (_i11.done) break;
		          _ref11 = _i11.value;
		        }
	
		        var method = _ref11;
	
		        if (!this.isPure(method, constantsOnly)) return false;
		      }
		      return true;
		    } else if (t.isBinary(node)) {
		      return this.isPure(node.left, constantsOnly) && this.isPure(node.right, constantsOnly);
		    } else if (t.isArrayExpression(node)) {
		      for (var _iterator12 = node.elements, _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : (0, _getIterator3.default)(_iterator12);;) {
		        var _ref12;
	
		        if (_isArray12) {
		          if (_i12 >= _iterator12.length) break;
		          _ref12 = _iterator12[_i12++];
		        } else {
		          _i12 = _iterator12.next();
		          if (_i12.done) break;
		          _ref12 = _i12.value;
		        }
	
		        var elem = _ref12;
	
		        if (!this.isPure(elem, constantsOnly)) return false;
		      }
		      return true;
		    } else if (t.isObjectExpression(node)) {
		      for (var _iterator13 = node.properties, _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : (0, _getIterator3.default)(_iterator13);;) {
		        var _ref13;
	
		        if (_isArray13) {
		          if (_i13 >= _iterator13.length) break;
		          _ref13 = _iterator13[_i13++];
		        } else {
		          _i13 = _iterator13.next();
		          if (_i13.done) break;
		          _ref13 = _i13.value;
		        }
	
		        var prop = _ref13;
	
		        if (!this.isPure(prop, constantsOnly)) return false;
		      }
		      return true;
		    } else if (t.isClassMethod(node)) {
		      if (node.computed && !this.isPure(node.key, constantsOnly)) return false;
		      if (node.kind === "get" || node.kind === "set") return false;
		      return true;
		    } else if (t.isClassProperty(node) || t.isObjectProperty(node)) {
		      if (node.computed && !this.isPure(node.key, constantsOnly)) return false;
		      return this.isPure(node.value, constantsOnly);
		    } else if (t.isUnaryExpression(node)) {
		      return this.isPure(node.argument, constantsOnly);
		    } else {
		      return t.isPureish(node);
		    }
		  };
	
		  Scope.prototype.setData = function setData(key, val) {
		    return this.data[key] = val;
		  };
	
		  Scope.prototype.getData = function getData(key) {
		    var scope = this;
		    do {
		      var data = scope.data[key];
		      if (data != null) return data;
		    } while (scope = scope.parent);
		  };
	
		  Scope.prototype.removeData = function removeData(key) {
		    var scope = this;
		    do {
		      var data = scope.data[key];
		      if (data != null) scope.data[key] = null;
		    } while (scope = scope.parent);
		  };
	
		  Scope.prototype.init = function init() {
		    if (!this.references) this.crawl();
		  };
	
		  Scope.prototype.crawl = function crawl() {
		    _crawlCallsCount++;
		    this._crawl();
		    _crawlCallsCount--;
		  };
	
		  Scope.prototype._crawl = function _crawl() {
		    var path = this.path;
	
		    this.references = (0, _create2.default)(null);
		    this.bindings = (0, _create2.default)(null);
		    this.globals = (0, _create2.default)(null);
		    this.uids = (0, _create2.default)(null);
		    this.data = (0, _create2.default)(null);
	
		    if (path.isLoop()) {
		      for (var _iterator14 = t.FOR_INIT_KEYS, _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : (0, _getIterator3.default)(_iterator14);;) {
		        var _ref14;
	
		        if (_isArray14) {
		          if (_i14 >= _iterator14.length) break;
		          _ref14 = _iterator14[_i14++];
		        } else {
		          _i14 = _iterator14.next();
		          if (_i14.done) break;
		          _ref14 = _i14.value;
		        }
	
		        var key = _ref14;
	
		        var node = path.get(key);
		        if (node.isBlockScoped()) this.registerBinding(node.node.kind, node);
		      }
		    }
	
		    if (path.isFunctionExpression() && path.has("id")) {
		      if (!path.get("id").node[t.NOT_LOCAL_BINDING]) {
		        this.registerBinding("local", path.get("id"), path);
		      }
		    }
	
		    if (path.isClassExpression() && path.has("id")) {
		      if (!path.get("id").node[t.NOT_LOCAL_BINDING]) {
		        this.registerBinding("local", path);
		      }
		    }
	
		    if (path.isFunction()) {
		      var params = path.get("params");
		      for (var _iterator15 = params, _isArray15 = Array.isArray(_iterator15), _i15 = 0, _iterator15 = _isArray15 ? _iterator15 : (0, _getIterator3.default)(_iterator15);;) {
		        var _ref15;
	
		        if (_isArray15) {
		          if (_i15 >= _iterator15.length) break;
		          _ref15 = _iterator15[_i15++];
		        } else {
		          _i15 = _iterator15.next();
		          if (_i15.done) break;
		          _ref15 = _i15.value;
		        }
	
		        var param = _ref15;
	
		        this.registerBinding("param", param);
		      }
		    }
	
		    if (path.isCatchClause()) {
		      this.registerBinding("let", path);
		    }
	
		    var parent = this.getProgramParent();
		    if (parent.crawling) return;
	
		    var state = {
		      references: [],
		      constantViolations: [],
		      assignments: []
		    };
	
		    this.crawling = true;
		    path.traverse(collectorVisitor, state);
		    this.crawling = false;
	
		    for (var _iterator16 = state.assignments, _isArray16 = Array.isArray(_iterator16), _i16 = 0, _iterator16 = _isArray16 ? _iterator16 : (0, _getIterator3.default)(_iterator16);;) {
		      var _ref16;
	
		      if (_isArray16) {
		        if (_i16 >= _iterator16.length) break;
		        _ref16 = _iterator16[_i16++];
		      } else {
		        _i16 = _iterator16.next();
		        if (_i16.done) break;
		        _ref16 = _i16.value;
		      }
	
		      var _path = _ref16;
	
		      var ids = _path.getBindingIdentifiers();
		      var programParent = void 0;
		      for (var name in ids) {
		        if (_path.scope.getBinding(name)) continue;
	
		        programParent = programParent || _path.scope.getProgramParent();
		        programParent.addGlobal(ids[name]);
		      }
	
		      _path.scope.registerConstantViolation(_path);
		    }
	
		    for (var _iterator17 = state.references, _isArray17 = Array.isArray(_iterator17), _i17 = 0, _iterator17 = _isArray17 ? _iterator17 : (0, _getIterator3.default)(_iterator17);;) {
		      var _ref17;
	
		      if (_isArray17) {
		        if (_i17 >= _iterator17.length) break;
		        _ref17 = _iterator17[_i17++];
		      } else {
		        _i17 = _iterator17.next();
		        if (_i17.done) break;
		        _ref17 = _i17.value;
		      }
	
		      var ref = _ref17;
	
		      var binding = ref.scope.getBinding(ref.node.name);
		      if (binding) {
		        binding.reference(ref);
		      } else {
		        ref.scope.getProgramParent().addGlobal(ref.node);
		      }
		    }
	
		    for (var _iterator18 = state.constantViolations, _isArray18 = Array.isArray(_iterator18), _i18 = 0, _iterator18 = _isArray18 ? _iterator18 : (0, _getIterator3.default)(_iterator18);;) {
		      var _ref18;
	
		      if (_isArray18) {
		        if (_i18 >= _iterator18.length) break;
		        _ref18 = _iterator18[_i18++];
		      } else {
		        _i18 = _iterator18.next();
		        if (_i18.done) break;
		        _ref18 = _i18.value;
		      }
	
		      var _path2 = _ref18;
	
		      _path2.scope.registerConstantViolation(_path2);
		    }
		  };
	
		  Scope.prototype.push = function push(opts) {
		    var path = this.path;
	
		    if (!path.isBlockStatement() && !path.isProgram()) {
		      path = this.getBlockParent().path;
		    }
	
		    if (path.isSwitchStatement()) {
		      path = this.getFunctionParent().path;
		    }
	
		    if (path.isLoop() || path.isCatchClause() || path.isFunction()) {
		      t.ensureBlock(path.node);
		      path = path.get("body");
		    }
	
		    var unique = opts.unique;
		    var kind = opts.kind || "var";
		    var blockHoist = opts._blockHoist == null ? 2 : opts._blockHoist;
	
		    var dataKey = "declaration:" + kind + ":" + blockHoist;
		    var declarPath = !unique && path.getData(dataKey);
	
		    if (!declarPath) {
		      var declar = t.variableDeclaration(kind, []);
		      declar._generated = true;
		      declar._blockHoist = blockHoist;
	
		      var _path$unshiftContaine = path.unshiftContainer("body", [declar]);
	
		      declarPath = _path$unshiftContaine[0];
	
		      if (!unique) path.setData(dataKey, declarPath);
		    }
	
		    var declarator = t.variableDeclarator(opts.id, opts.init);
		    declarPath.node.declarations.push(declarator);
		    this.registerBinding(kind, declarPath.get("declarations").pop());
		  };
	
		  Scope.prototype.getProgramParent = function getProgramParent() {
		    var scope = this;
		    do {
		      if (scope.path.isProgram()) {
		        return scope;
		      }
		    } while (scope = scope.parent);
		    throw new Error("We couldn't find a Function or Program...");
		  };
	
		  Scope.prototype.getFunctionParent = function getFunctionParent() {
		    var scope = this;
		    do {
		      if (scope.path.isFunctionParent()) {
		        return scope;
		      }
		    } while (scope = scope.parent);
		    throw new Error("We couldn't find a Function or Program...");
		  };
	
		  Scope.prototype.getBlockParent = function getBlockParent() {
		    var scope = this;
		    do {
		      if (scope.path.isBlockParent()) {
		        return scope;
		      }
		    } while (scope = scope.parent);
		    throw new Error("We couldn't find a BlockStatement, For, Switch, Function, Loop or Program...");
		  };
	
		  Scope.prototype.getAllBindings = function getAllBindings() {
		    var ids = (0, _create2.default)(null);
	
		    var scope = this;
		    do {
		      (0, _defaults2.default)(ids, scope.bindings);
		      scope = scope.parent;
		    } while (scope);
	
		    return ids;
		  };
	
		  Scope.prototype.getAllBindingsOfKind = function getAllBindingsOfKind() {
		    var ids = (0, _create2.default)(null);
	
		    for (var _iterator19 = arguments, _isArray19 = Array.isArray(_iterator19), _i19 = 0, _iterator19 = _isArray19 ? _iterator19 : (0, _getIterator3.default)(_iterator19);;) {
		      var _ref19;
	
		      if (_isArray19) {
		        if (_i19 >= _iterator19.length) break;
		        _ref19 = _iterator19[_i19++];
		      } else {
		        _i19 = _iterator19.next();
		        if (_i19.done) break;
		        _ref19 = _i19.value;
		      }
	
		      var kind = _ref19;
	
		      var scope = this;
		      do {
		        for (var name in scope.bindings) {
		          var binding = scope.bindings[name];
		          if (binding.kind === kind) ids[name] = binding;
		        }
		        scope = scope.parent;
		      } while (scope);
		    }
	
		    return ids;
		  };
	
		  Scope.prototype.bindingIdentifierEquals = function bindingIdentifierEquals(name, node) {
		    return this.getBindingIdentifier(name) === node;
		  };
	
		  Scope.prototype.warnOnFlowBinding = function warnOnFlowBinding(binding) {
		    if (_crawlCallsCount === 0 && binding && binding.path.isFlow()) {
		      console.warn("\n        You or one of the Babel plugins you are using are using Flow declarations as bindings.\n        Support for this will be removed in version 7. To find out the caller, grep for this\n        message and change it to a `console.trace()`.\n      ");
		    }
		    return binding;
		  };
	
		  Scope.prototype.getBinding = function getBinding(name) {
		    var scope = this;
	
		    do {
		      var binding = scope.getOwnBinding(name);
		      if (binding) return this.warnOnFlowBinding(binding);
		    } while (scope = scope.parent);
		  };
	
		  Scope.prototype.getOwnBinding = function getOwnBinding(name) {
		    return this.warnOnFlowBinding(this.bindings[name]);
		  };
	
		  Scope.prototype.getBindingIdentifier = function getBindingIdentifier(name) {
		    var info = this.getBinding(name);
		    return info && info.identifier;
		  };
	
		  Scope.prototype.getOwnBindingIdentifier = function getOwnBindingIdentifier(name) {
		    var binding = this.bindings[name];
		    return binding && binding.identifier;
		  };
	
		  Scope.prototype.hasOwnBinding = function hasOwnBinding(name) {
		    return !!this.getOwnBinding(name);
		  };
	
		  Scope.prototype.hasBinding = function hasBinding(name, noGlobals) {
		    if (!name) return false;
		    if (this.hasOwnBinding(name)) return true;
		    if (this.parentHasBinding(name, noGlobals)) return true;
		    if (this.hasUid(name)) return true;
		    if (!noGlobals && (0, _includes2.default)(Scope.globals, name)) return true;
		    if (!noGlobals && (0, _includes2.default)(Scope.contextVariables, name)) return true;
		    return false;
		  };
	
		  Scope.prototype.parentHasBinding = function parentHasBinding(name, noGlobals) {
		    return this.parent && this.parent.hasBinding(name, noGlobals);
		  };
	
		  Scope.prototype.moveBindingTo = function moveBindingTo(name, scope) {
		    var info = this.getBinding(name);
		    if (info) {
		      info.scope.removeOwnBinding(name);
		      info.scope = scope;
		      scope.bindings[name] = info;
		    }
		  };
	
		  Scope.prototype.removeOwnBinding = function removeOwnBinding(name) {
		    delete this.bindings[name];
		  };
	
		  Scope.prototype.removeBinding = function removeBinding(name) {
		    var info = this.getBinding(name);
		    if (info) {
		      info.scope.removeOwnBinding(name);
		    }
	
		    var scope = this;
		    do {
		      if (scope.uids[name]) {
		        scope.uids[name] = false;
		      }
		    } while (scope = scope.parent);
		  };
	
		  return Scope;
		}();
	
		Scope.globals = (0, _keys2.default)(_globals2.default.builtin);
		Scope.contextVariables = ["arguments", "undefined", "Infinity", "NaN"];
		exports.default = Scope;
		module.exports = exports["default"];
	
	/***/ }),
	/* 135 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.NOT_LOCAL_BINDING = exports.BLOCK_SCOPED_SYMBOL = exports.INHERIT_KEYS = exports.UNARY_OPERATORS = exports.STRING_UNARY_OPERATORS = exports.NUMBER_UNARY_OPERATORS = exports.BOOLEAN_UNARY_OPERATORS = exports.BINARY_OPERATORS = exports.NUMBER_BINARY_OPERATORS = exports.BOOLEAN_BINARY_OPERATORS = exports.COMPARISON_BINARY_OPERATORS = exports.EQUALITY_BINARY_OPERATORS = exports.BOOLEAN_NUMBER_BINARY_OPERATORS = exports.UPDATE_OPERATORS = exports.LOGICAL_OPERATORS = exports.COMMENT_KEYS = exports.FOR_INIT_KEYS = exports.FLATTENABLE_KEYS = exports.STATEMENT_OR_BLOCK_KEYS = undefined;
	
		var _for = __webpack_require__(362);
	
		var _for2 = _interopRequireDefault(_for);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var STATEMENT_OR_BLOCK_KEYS = exports.STATEMENT_OR_BLOCK_KEYS = ["consequent", "body", "alternate"];
		var FLATTENABLE_KEYS = exports.FLATTENABLE_KEYS = ["body", "expressions"];
		var FOR_INIT_KEYS = exports.FOR_INIT_KEYS = ["left", "init"];
		var COMMENT_KEYS = exports.COMMENT_KEYS = ["leadingComments", "trailingComments", "innerComments"];
	
		var LOGICAL_OPERATORS = exports.LOGICAL_OPERATORS = ["||", "&&"];
		var UPDATE_OPERATORS = exports.UPDATE_OPERATORS = ["++", "--"];
	
		var BOOLEAN_NUMBER_BINARY_OPERATORS = exports.BOOLEAN_NUMBER_BINARY_OPERATORS = [">", "<", ">=", "<="];
		var EQUALITY_BINARY_OPERATORS = exports.EQUALITY_BINARY_OPERATORS = ["==", "===", "!=", "!=="];
		var COMPARISON_BINARY_OPERATORS = exports.COMPARISON_BINARY_OPERATORS = [].concat(EQUALITY_BINARY_OPERATORS, ["in", "instanceof"]);
		var BOOLEAN_BINARY_OPERATORS = exports.BOOLEAN_BINARY_OPERATORS = [].concat(COMPARISON_BINARY_OPERATORS, BOOLEAN_NUMBER_BINARY_OPERATORS);
		var NUMBER_BINARY_OPERATORS = exports.NUMBER_BINARY_OPERATORS = ["-", "/", "%", "*", "**", "&", "|", ">>", ">>>", "<<", "^"];
		var BINARY_OPERATORS = exports.BINARY_OPERATORS = ["+"].concat(NUMBER_BINARY_OPERATORS, BOOLEAN_BINARY_OPERATORS);
	
		var BOOLEAN_UNARY_OPERATORS = exports.BOOLEAN_UNARY_OPERATORS = ["delete", "!"];
		var NUMBER_UNARY_OPERATORS = exports.NUMBER_UNARY_OPERATORS = ["+", "-", "++", "--", "~"];
		var STRING_UNARY_OPERATORS = exports.STRING_UNARY_OPERATORS = ["typeof"];
		var UNARY_OPERATORS = exports.UNARY_OPERATORS = ["void"].concat(BOOLEAN_UNARY_OPERATORS, NUMBER_UNARY_OPERATORS, STRING_UNARY_OPERATORS);
	
		var INHERIT_KEYS = exports.INHERIT_KEYS = {
		  optional: ["typeAnnotation", "typeParameters", "returnType"],
		  force: ["start", "loc", "end"]
		};
	
		var BLOCK_SCOPED_SYMBOL = exports.BLOCK_SCOPED_SYMBOL = (0, _for2.default)("var used to be block scoped");
		var NOT_LOCAL_BINDING = exports.NOT_LOCAL_BINDING = (0, _for2.default)("should not be considered a local binding");
	
	/***/ }),
	/* 136 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		module.exports = function (it, Constructor, name, forbiddenField) {
		  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
		    throw TypeError(name + ': incorrect invocation!');
		  }return it;
		};
	
	/***/ }),
	/* 137 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// 0 -> Array#forEach
		// 1 -> Array#map
		// 2 -> Array#filter
		// 3 -> Array#some
		// 4 -> Array#every
		// 5 -> Array#find
		// 6 -> Array#findIndex
		var ctx = __webpack_require__(43);
		var IObject = __webpack_require__(142);
		var toObject = __webpack_require__(94);
		var toLength = __webpack_require__(153);
		var asc = __webpack_require__(422);
		module.exports = function (TYPE, $create) {
		  var IS_MAP = TYPE == 1;
		  var IS_FILTER = TYPE == 2;
		  var IS_SOME = TYPE == 3;
		  var IS_EVERY = TYPE == 4;
		  var IS_FIND_INDEX = TYPE == 6;
		  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
		  var create = $create || asc;
		  return function ($this, callbackfn, that) {
		    var O = toObject($this);
		    var self = IObject(O);
		    var f = ctx(callbackfn, that, 3);
		    var length = toLength(self.length);
		    var index = 0;
		    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
		    var val, res;
		    for (; length > index; index++) {
		      if (NO_HOLES || index in self) {
		        val = self[index];
		        res = f(val, index, O);
		        if (TYPE) {
		          if (IS_MAP) result[index] = res; // map
		          else if (res) switch (TYPE) {
		              case 3:
		                return true; // some
		              case 5:
		                return val; // find
		              case 6:
		                return index; // findIndex
		              case 2:
		                result.push(val); // filter
		            } else if (IS_EVERY) return false; // every
		        }
		      }
		    }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
		  };
		};
	
	/***/ }),
	/* 138 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		var toString = {}.toString;
	
		module.exports = function (it) {
		  return toString.call(it).slice(8, -1);
		};
	
	/***/ }),
	/* 139 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var global = __webpack_require__(15);
		var $export = __webpack_require__(12);
		var meta = __webpack_require__(57);
		var fails = __webpack_require__(27);
		var hide = __webpack_require__(29);
		var redefineAll = __webpack_require__(146);
		var forOf = __webpack_require__(55);
		var anInstance = __webpack_require__(136);
		var isObject = __webpack_require__(16);
		var setToStringTag = __webpack_require__(93);
		var dP = __webpack_require__(23).f;
		var each = __webpack_require__(137)(0);
		var DESCRIPTORS = __webpack_require__(22);
	
		module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
		  var Base = global[NAME];
		  var C = Base;
		  var ADDER = IS_MAP ? 'set' : 'add';
		  var proto = C && C.prototype;
		  var O = {};
		  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
		    new C().entries().next();
		  }))) {
		    // create collection constructor
		    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
		    redefineAll(C.prototype, methods);
		    meta.NEED = true;
		  } else {
		    C = wrapper(function (target, iterable) {
		      anInstance(target, C, NAME, '_c');
		      target._c = new Base();
		      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
		    });
		    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
		      var IS_ADDER = KEY == 'add' || KEY == 'set';
		      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
		        anInstance(this, C, KEY);
		        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
		        var result = this._c[KEY](a === 0 ? 0 : a, b);
		        return IS_ADDER ? this : result;
		      });
		    });
		    IS_WEAK || dP(C.prototype, 'size', {
		      get: function get() {
		        return this._c.size;
		      }
		    });
		  }
	
		  setToStringTag(C, NAME);
	
		  O[NAME] = C;
		  $export($export.G + $export.W + $export.F, O);
	
		  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
		  return C;
		};
	
	/***/ }),
	/* 140 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		// 7.2.1 RequireObjectCoercible(argument)
		module.exports = function (it) {
		  if (it == undefined) throw TypeError("Can't call method on  " + it);
		  return it;
		};
	
	/***/ }),
	/* 141 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		// IE 8- don't enum bug keys
		module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
	
	/***/ }),
	/* 142 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// fallback for non-array-like ES3 and non-enumerable old V8 strings
		var cof = __webpack_require__(138);
		// eslint-disable-next-line no-prototype-builtins
		module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
		  return cof(it) == 'String' ? it.split('') : Object(it);
		};
	
	/***/ }),
	/* 143 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var LIBRARY = __webpack_require__(144);
		var $export = __webpack_require__(12);
		var redefine = __webpack_require__(147);
		var hide = __webpack_require__(29);
		var has = __webpack_require__(28);
		var Iterators = __webpack_require__(56);
		var $iterCreate = __webpack_require__(429);
		var setToStringTag = __webpack_require__(93);
		var getPrototypeOf = __webpack_require__(433);
		var ITERATOR = __webpack_require__(13)('iterator');
		var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
		var FF_ITERATOR = '@@iterator';
		var KEYS = 'keys';
		var VALUES = 'values';
	
		var returnThis = function returnThis() {
		  return this;
		};
	
		module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
		  $iterCreate(Constructor, NAME, next);
		  var getMethod = function getMethod(kind) {
		    if (!BUGGY && kind in proto) return proto[kind];
		    switch (kind) {
		      case KEYS:
		        return function keys() {
		          return new Constructor(this, kind);
		        };
		      case VALUES:
		        return function values() {
		          return new Constructor(this, kind);
		        };
		    }return function entries() {
		      return new Constructor(this, kind);
		    };
		  };
		  var TAG = NAME + ' Iterator';
		  var DEF_VALUES = DEFAULT == VALUES;
		  var VALUES_BUG = false;
		  var proto = Base.prototype;
		  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
		  var $default = $native || getMethod(DEFAULT);
		  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
		  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
		  var methods, key, IteratorPrototype;
		  // Fix native
		  if ($anyNative) {
		    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
		    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
		      // Set @@toStringTag to native iterators
		      setToStringTag(IteratorPrototype, TAG, true);
		      // fix for some old engines
		      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
		    }
		  }
		  // fix Array#{values, @@iterator}.name in V8 / FF
		  if (DEF_VALUES && $native && $native.name !== VALUES) {
		    VALUES_BUG = true;
		    $default = function values() {
		      return $native.call(this);
		    };
		  }
		  // Define iterator
		  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
		    hide(proto, ITERATOR, $default);
		  }
		  // Plug for library
		  Iterators[NAME] = $default;
		  Iterators[TAG] = returnThis;
		  if (DEFAULT) {
		    methods = {
		      values: DEF_VALUES ? $default : getMethod(VALUES),
		      keys: IS_SET ? $default : getMethod(KEYS),
		      entries: $entries
		    };
		    if (FORCED) for (key in methods) {
		      if (!(key in proto)) redefine(proto, key, methods[key]);
		    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
		  }
		  return methods;
		};
	
	/***/ }),
	/* 144 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		module.exports = true;
	
	/***/ }),
	/* 145 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.f = Object.getOwnPropertySymbols;
	
	/***/ }),
	/* 146 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var hide = __webpack_require__(29);
		module.exports = function (target, src, safe) {
		  for (var key in src) {
		    if (safe && target[key]) target[key] = src[key];else hide(target, key, src[key]);
		  }return target;
		};
	
	/***/ }),
	/* 147 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = __webpack_require__(29);
	
	/***/ }),
	/* 148 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		// https://tc39.github.io/proposal-setmap-offrom/
	
		var $export = __webpack_require__(12);
		var aFunction = __webpack_require__(227);
		var ctx = __webpack_require__(43);
		var forOf = __webpack_require__(55);
	
		module.exports = function (COLLECTION) {
		  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
		      var mapFn = arguments[1];
		      var mapping, A, n, cb;
		      aFunction(this);
		      mapping = mapFn !== undefined;
		      if (mapping) aFunction(mapFn);
		      if (source == undefined) return new this();
		      A = [];
		      if (mapping) {
		        n = 0;
		        cb = ctx(mapFn, arguments[2], 2);
		        forOf(source, false, function (nextItem) {
		          A.push(cb(nextItem, n++));
		        });
		      } else {
		        forOf(source, false, A.push, A);
		      }
		      return new this(A);
		    } });
		};
	
	/***/ }),
	/* 149 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		// https://tc39.github.io/proposal-setmap-offrom/
	
		var $export = __webpack_require__(12);
	
		module.exports = function (COLLECTION) {
		  $export($export.S, COLLECTION, { of: function of() {
		      var length = arguments.length;
		      var A = Array(length);
		      while (length--) {
		        A[length] = arguments[length];
		      }return new this(A);
		    } });
		};
	
	/***/ }),
	/* 150 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var shared = __webpack_require__(151)('keys');
		var uid = __webpack_require__(95);
		module.exports = function (key) {
		  return shared[key] || (shared[key] = uid(key));
		};
	
	/***/ }),
	/* 151 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var global = __webpack_require__(15);
		var SHARED = '__core-js_shared__';
		var store = global[SHARED] || (global[SHARED] = {});
		module.exports = function (key) {
		  return store[key] || (store[key] = {});
		};
	
	/***/ }),
	/* 152 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		// 7.1.4 ToInteger
		var ceil = Math.ceil;
		var floor = Math.floor;
		module.exports = function (it) {
		  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
		};
	
	/***/ }),
	/* 153 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// 7.1.15 ToLength
		var toInteger = __webpack_require__(152);
		var min = Math.min;
		module.exports = function (it) {
		  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
		};
	
	/***/ }),
	/* 154 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// 7.1.1 ToPrimitive(input [, PreferredType])
		var isObject = __webpack_require__(16);
		// instead of the ES6 spec version, we didn't implement @@toPrimitive case
		// and the second argument - flag - preferred type is a string
		module.exports = function (it, S) {
		  if (!isObject(it)) return it;
		  var fn, val;
		  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
		  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
		  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
		  throw TypeError("Can't convert object to primitive value");
		};
	
	/***/ }),
	/* 155 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var global = __webpack_require__(15);
		var core = __webpack_require__(5);
		var LIBRARY = __webpack_require__(144);
		var wksExt = __webpack_require__(156);
		var defineProperty = __webpack_require__(23).f;
		module.exports = function (name) {
		  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
		  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
		};
	
	/***/ }),
	/* 156 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.f = __webpack_require__(13);
	
	/***/ }),
	/* 157 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var $at = __webpack_require__(437)(true);
	
		// 21.1.3.27 String.prototype[@@iterator]()
		__webpack_require__(143)(String, 'String', function (iterated) {
		  this._t = String(iterated); // target
		  this._i = 0; // next index
		  // 21.1.5.2.1 %StringIteratorPrototype%.next()
		}, function () {
		  var O = this._t;
		  var index = this._i;
		  var point;
		  if (index >= O.length) return { value: undefined, done: true };
		  point = $at(O, index);
		  this._i += point.length;
		  return { value: point, done: false };
		});
	
	/***/ }),
	/* 158 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		// ECMAScript 6 symbols shim
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var global = __webpack_require__(15);
		var has = __webpack_require__(28);
		var DESCRIPTORS = __webpack_require__(22);
		var $export = __webpack_require__(12);
		var redefine = __webpack_require__(147);
		var META = __webpack_require__(57).KEY;
		var $fails = __webpack_require__(27);
		var shared = __webpack_require__(151);
		var setToStringTag = __webpack_require__(93);
		var uid = __webpack_require__(95);
		var wks = __webpack_require__(13);
		var wksExt = __webpack_require__(156);
		var wksDefine = __webpack_require__(155);
		var keyOf = __webpack_require__(430);
		var enumKeys = __webpack_require__(425);
		var isArray = __webpack_require__(232);
		var anObject = __webpack_require__(21);
		var toIObject = __webpack_require__(37);
		var toPrimitive = __webpack_require__(154);
		var createDesc = __webpack_require__(92);
		var _create = __webpack_require__(90);
		var gOPNExt = __webpack_require__(432);
		var $GOPD = __webpack_require__(235);
		var $DP = __webpack_require__(23);
		var $keys = __webpack_require__(44);
		var gOPD = $GOPD.f;
		var dP = $DP.f;
		var gOPN = gOPNExt.f;
		var $Symbol = global.Symbol;
		var $JSON = global.JSON;
		var _stringify = $JSON && $JSON.stringify;
		var PROTOTYPE = 'prototype';
		var HIDDEN = wks('_hidden');
		var TO_PRIMITIVE = wks('toPrimitive');
		var isEnum = {}.propertyIsEnumerable;
		var SymbolRegistry = shared('symbol-registry');
		var AllSymbols = shared('symbols');
		var OPSymbols = shared('op-symbols');
		var ObjectProto = Object[PROTOTYPE];
		var USE_NATIVE = typeof $Symbol == 'function';
		var QObject = global.QObject;
		// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
		var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
		// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
		var setSymbolDesc = DESCRIPTORS && $fails(function () {
		  return _create(dP({}, 'a', {
		    get: function get() {
		      return dP(this, 'a', { value: 7 }).a;
		    }
		  })).a != 7;
		}) ? function (it, key, D) {
		  var protoDesc = gOPD(ObjectProto, key);
		  if (protoDesc) delete ObjectProto[key];
		  dP(it, key, D);
		  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
		} : dP;
	
		var wrap = function wrap(tag) {
		  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
		  sym._k = tag;
		  return sym;
		};
	
		var isSymbol = USE_NATIVE && _typeof($Symbol.iterator) == 'symbol' ? function (it) {
		  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol';
		} : function (it) {
		  return it instanceof $Symbol;
		};
	
		var $defineProperty = function defineProperty(it, key, D) {
		  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
		  anObject(it);
		  key = toPrimitive(key, true);
		  anObject(D);
		  if (has(AllSymbols, key)) {
		    if (!D.enumerable) {
		      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
		      it[HIDDEN][key] = true;
		    } else {
		      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
		      D = _create(D, { enumerable: createDesc(0, false) });
		    }return setSymbolDesc(it, key, D);
		  }return dP(it, key, D);
		};
		var $defineProperties = function defineProperties(it, P) {
		  anObject(it);
		  var keys = enumKeys(P = toIObject(P));
		  var i = 0;
		  var l = keys.length;
		  var key;
		  while (l > i) {
		    $defineProperty(it, key = keys[i++], P[key]);
		  }return it;
		};
		var $create = function create(it, P) {
		  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
		};
		var $propertyIsEnumerable = function propertyIsEnumerable(key) {
		  var E = isEnum.call(this, key = toPrimitive(key, true));
		  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
		  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
		};
		var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
		  it = toIObject(it);
		  key = toPrimitive(key, true);
		  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
		  var D = gOPD(it, key);
		  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
		  return D;
		};
		var $getOwnPropertyNames = function getOwnPropertyNames(it) {
		  var names = gOPN(toIObject(it));
		  var result = [];
		  var i = 0;
		  var key;
		  while (names.length > i) {
		    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
		  }return result;
		};
		var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
		  var IS_OP = it === ObjectProto;
		  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
		  var result = [];
		  var i = 0;
		  var key;
		  while (names.length > i) {
		    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
		  }return result;
		};
	
		// 19.4.1.1 Symbol([description])
		if (!USE_NATIVE) {
		  $Symbol = function _Symbol() {
		    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
		    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
		    var $set = function $set(value) {
		      if (this === ObjectProto) $set.call(OPSymbols, value);
		      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
		      setSymbolDesc(this, tag, createDesc(1, value));
		    };
		    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
		    return wrap(tag);
		  };
		  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
		    return this._k;
		  });
	
		  $GOPD.f = $getOwnPropertyDescriptor;
		  $DP.f = $defineProperty;
		  __webpack_require__(236).f = gOPNExt.f = $getOwnPropertyNames;
		  __webpack_require__(91).f = $propertyIsEnumerable;
		  __webpack_require__(145).f = $getOwnPropertySymbols;
	
		  if (DESCRIPTORS && !__webpack_require__(144)) {
		    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
		  }
	
		  wksExt.f = function (name) {
		    return wrap(wks(name));
		  };
		}
	
		$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
		for (var es6Symbols =
		// 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
		'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
		  wks(es6Symbols[j++]);
		}for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
		  wksDefine(wellKnownSymbols[k++]);
		}$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
		  // 19.4.2.1 Symbol.for(key)
		  'for': function _for(key) {
		    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
		  },
		  // 19.4.2.5 Symbol.keyFor(sym)
		  keyFor: function keyFor(key) {
		    if (isSymbol(key)) return keyOf(SymbolRegistry, key);
		    throw TypeError(key + ' is not a symbol!');
		  },
		  useSetter: function useSetter() {
		    setter = true;
		  },
		  useSimple: function useSimple() {
		    setter = false;
		  }
		});
	
		$export($export.S + $export.F * !USE_NATIVE, 'Object', {
		  // 19.1.2.2 Object.create(O [, Properties])
		  create: $create,
		  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
		  defineProperty: $defineProperty,
		  // 19.1.2.3 Object.defineProperties(O, Properties)
		  defineProperties: $defineProperties,
		  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
		  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
		  // 19.1.2.7 Object.getOwnPropertyNames(O)
		  getOwnPropertyNames: $getOwnPropertyNames,
		  // 19.1.2.8 Object.getOwnPropertySymbols(O)
		  getOwnPropertySymbols: $getOwnPropertySymbols
		});
	
		// 24.3.2 JSON.stringify(value [, replacer [, space]])
		$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
		  var S = $Symbol();
		  // MS Edge converts symbol values to JSON as {}
		  // WebKit converts symbol values to JSON as null
		  // V8 throws on boxed symbols
		  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
		})), 'JSON', {
		  stringify: function stringify(it) {
		    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
		    var args = [it];
		    var i = 1;
		    var replacer, $replacer;
		    while (arguments.length > i) {
		      args.push(arguments[i++]);
		    }replacer = args[1];
		    if (typeof replacer == 'function') $replacer = replacer;
		    if ($replacer || !isArray(replacer)) replacer = function replacer(key, value) {
		      if ($replacer) value = $replacer.call(this, key, value);
		      if (!isSymbol(value)) return value;
		    };
		    args[1] = replacer;
		    return _stringify.apply($JSON, args);
		  }
		});
	
		// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
		$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(29)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
		// 19.4.3.5 Symbol.prototype[@@toStringTag]
		setToStringTag($Symbol, 'Symbol');
		// 20.2.1.9 Math[@@toStringTag]
		setToStringTag(Math, 'Math', true);
		// 24.3.3 JSON[@@toStringTag]
		setToStringTag(global.JSON, 'JSON', true);
	
	/***/ }),
	/* 159 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var getNative = __webpack_require__(38),
		    root = __webpack_require__(17);
	
		/* Built-in method references that are verified to be native. */
		var Map = getNative(root, 'Map');
	
		module.exports = Map;
	
	/***/ }),
	/* 160 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var mapCacheClear = __webpack_require__(551),
		    mapCacheDelete = __webpack_require__(552),
		    mapCacheGet = __webpack_require__(553),
		    mapCacheHas = __webpack_require__(554),
		    mapCacheSet = __webpack_require__(555);
	
		/**
		 * Creates a map cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function MapCache(entries) {
		    var index = -1,
		        length = entries == null ? 0 : entries.length;
	
		    this.clear();
		    while (++index < length) {
		        var entry = entries[index];
		        this.set(entry[0], entry[1]);
		    }
		}
	
		// Add methods to `MapCache`.
		MapCache.prototype.clear = mapCacheClear;
		MapCache.prototype['delete'] = mapCacheDelete;
		MapCache.prototype.get = mapCacheGet;
		MapCache.prototype.has = mapCacheHas;
		MapCache.prototype.set = mapCacheSet;
	
		module.exports = MapCache;
	
	/***/ }),
	/* 161 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Appends the elements of `values` to `array`.
		 *
		 * @private
		 * @param {Array} array The array to modify.
		 * @param {Array} values The values to append.
		 * @returns {Array} Returns `array`.
		 */
		function arrayPush(array, values) {
		  var index = -1,
		      length = values.length,
		      offset = array.length;
	
		  while (++index < length) {
		    array[offset + index] = values[index];
		  }
		  return array;
		}
	
		module.exports = arrayPush;
	
	/***/ }),
	/* 162 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseAssignValue = __webpack_require__(163),
		    eq = __webpack_require__(46);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Assigns `value` to `key` of `object` if the existing value is not equivalent
		 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * for equality comparisons.
		 *
		 * @private
		 * @param {Object} object The object to modify.
		 * @param {string} key The key of the property to assign.
		 * @param {*} value The value to assign.
		 */
		function assignValue(object, key, value) {
		  var objValue = object[key];
		  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
		    baseAssignValue(object, key, value);
		  }
		}
	
		module.exports = assignValue;
	
	/***/ }),
	/* 163 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var defineProperty = __webpack_require__(259);
	
		/**
		 * The base implementation of `assignValue` and `assignMergeValue` without
		 * value checks.
		 *
		 * @private
		 * @param {Object} object The object to modify.
		 * @param {string} key The key of the property to assign.
		 * @param {*} value The value to assign.
		 */
		function baseAssignValue(object, key, value) {
		  if (key == '__proto__' && defineProperty) {
		    defineProperty(object, key, {
		      'configurable': true,
		      'enumerable': true,
		      'value': value,
		      'writable': true
		    });
		  } else {
		    object[key] = value;
		  }
		}
	
		module.exports = baseAssignValue;
	
	/***/ }),
	/* 164 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var Stack = __webpack_require__(99),
		    arrayEach = __webpack_require__(478),
		    assignValue = __webpack_require__(162),
		    baseAssign = __webpack_require__(483),
		    baseAssignIn = __webpack_require__(484),
		    cloneBuffer = __webpack_require__(256),
		    copyArray = __webpack_require__(168),
		    copySymbols = __webpack_require__(523),
		    copySymbolsIn = __webpack_require__(524),
		    getAllKeys = __webpack_require__(262),
		    getAllKeysIn = __webpack_require__(532),
		    getTag = __webpack_require__(264),
		    initCloneArray = __webpack_require__(541),
		    initCloneByTag = __webpack_require__(542),
		    initCloneObject = __webpack_require__(266),
		    isArray = __webpack_require__(6),
		    isBuffer = __webpack_require__(113),
		    isObject = __webpack_require__(18),
		    keys = __webpack_require__(32);
	
		/** Used to compose bitmasks for cloning. */
		var CLONE_DEEP_FLAG = 1,
		    CLONE_FLAT_FLAG = 2,
		    CLONE_SYMBOLS_FLAG = 4;
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    funcTag = '[object Function]',
		    genTag = '[object GeneratorFunction]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    objectTag = '[object Object]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    symbolTag = '[object Symbol]',
		    weakMapTag = '[object WeakMap]';
	
		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';
	
		/** Used to identify `toStringTag` values supported by `_.clone`. */
		var cloneableTags = {};
		cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
		cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
	
		/**
		 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
		 * traversed objects.
		 *
		 * @private
		 * @param {*} value The value to clone.
		 * @param {boolean} bitmask The bitmask flags.
		 *  1 - Deep clone
		 *  2 - Flatten inherited properties
		 *  4 - Clone symbols
		 * @param {Function} [customizer] The function to customize cloning.
		 * @param {string} [key] The key of `value`.
		 * @param {Object} [object] The parent object of `value`.
		 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
		 * @returns {*} Returns the cloned value.
		 */
		function baseClone(value, bitmask, customizer, key, object, stack) {
		  var result,
		      isDeep = bitmask & CLONE_DEEP_FLAG,
		      isFlat = bitmask & CLONE_FLAT_FLAG,
		      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
		  if (customizer) {
		    result = object ? customizer(value, key, object, stack) : customizer(value);
		  }
		  if (result !== undefined) {
		    return result;
		  }
		  if (!isObject(value)) {
		    return value;
		  }
		  var isArr = isArray(value);
		  if (isArr) {
		    result = initCloneArray(value);
		    if (!isDeep) {
		      return copyArray(value, result);
		    }
		  } else {
		    var tag = getTag(value),
		        isFunc = tag == funcTag || tag == genTag;
	
		    if (isBuffer(value)) {
		      return cloneBuffer(value, isDeep);
		    }
		    if (tag == objectTag || tag == argsTag || isFunc && !object) {
		      result = isFlat || isFunc ? {} : initCloneObject(value);
		      if (!isDeep) {
		        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
		      }
		    } else {
		      if (!cloneableTags[tag]) {
		        return object ? value : {};
		      }
		      result = initCloneByTag(value, tag, baseClone, isDeep);
		    }
		  }
		  // Check for circular references and return its corresponding clone.
		  stack || (stack = new Stack());
		  var stacked = stack.get(value);
		  if (stacked) {
		    return stacked;
		  }
		  stack.set(value, result);
	
		  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
	
		  var props = isArr ? undefined : keysFunc(value);
		  arrayEach(props || value, function (subValue, key) {
		    if (props) {
		      key = subValue;
		      subValue = value[key];
		    }
		    // Recursively populate clone (susceptible to call stack limits).
		    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
		  });
		  return result;
		}
	
		module.exports = baseClone;
	
	/***/ }),
	/* 165 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * The base implementation of `_.findIndex` and `_.findLastIndex` without
		 * support for iteratee shorthands.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {Function} predicate The function invoked per iteration.
		 * @param {number} fromIndex The index to search from.
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function baseFindIndex(array, predicate, fromIndex, fromRight) {
		  var length = array.length,
		      index = fromIndex + (fromRight ? 1 : -1);
	
		  while (fromRight ? index-- : ++index < length) {
		    if (predicate(array[index], index, array)) {
		      return index;
		    }
		  }
		  return -1;
		}
	
		module.exports = baseFindIndex;
	
	/***/ }),
	/* 166 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseFindIndex = __webpack_require__(165),
		    baseIsNaN = __webpack_require__(496),
		    strictIndexOf = __webpack_require__(570);
	
		/**
		 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} value The value to search for.
		 * @param {number} fromIndex The index to search from.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function baseIndexOf(array, value, fromIndex) {
		    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
		}
	
		module.exports = baseIndexOf;
	
	/***/ }),
	/* 167 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var Uint8Array = __webpack_require__(243);
	
		/**
		 * Creates a clone of `arrayBuffer`.
		 *
		 * @private
		 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
		 * @returns {ArrayBuffer} Returns the cloned array buffer.
		 */
		function cloneArrayBuffer(arrayBuffer) {
		  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
		  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
		  return result;
		}
	
		module.exports = cloneArrayBuffer;
	
	/***/ }),
	/* 168 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Copies the values of `source` to `array`.
		 *
		 * @private
		 * @param {Array} source The array to copy values from.
		 * @param {Array} [array=[]] The array to copy values to.
		 * @returns {Array} Returns `array`.
		 */
		function copyArray(source, array) {
		  var index = -1,
		      length = source.length;
	
		  array || (array = Array(length));
		  while (++index < length) {
		    array[index] = source[index];
		  }
		  return array;
		}
	
		module.exports = copyArray;
	
	/***/ }),
	/* 169 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var overArg = __webpack_require__(271);
	
		/** Built-in value references. */
		var getPrototype = overArg(Object.getPrototypeOf, Object);
	
		module.exports = getPrototype;
	
	/***/ }),
	/* 170 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var arrayFilter = __webpack_require__(479),
		    stubArray = __webpack_require__(279);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Built-in value references. */
		var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeGetSymbols = Object.getOwnPropertySymbols;
	
		/**
		 * Creates an array of the own enumerable symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of symbols.
		 */
		var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
		  if (object == null) {
		    return [];
		  }
		  object = Object(object);
		  return arrayFilter(nativeGetSymbols(object), function (symbol) {
		    return propertyIsEnumerable.call(object, symbol);
		  });
		};
	
		module.exports = getSymbols;
	
	/***/ }),
	/* 171 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;
	
		/** Used to detect unsigned integer values. */
		var reIsUint = /^(?:0|[1-9]\d*)$/;
	
		/**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */
		function isIndex(value, length) {
		  length = length == null ? MAX_SAFE_INTEGER : length;
		  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
		}
	
		module.exports = isIndex;
	
	/***/ }),
	/* 172 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var eq = __webpack_require__(46),
		    isArrayLike = __webpack_require__(24),
		    isIndex = __webpack_require__(171),
		    isObject = __webpack_require__(18);
	
		/**
		 * Checks if the given arguments are from an iteratee call.
		 *
		 * @private
		 * @param {*} value The potential iteratee value argument.
		 * @param {*} index The potential iteratee index or key argument.
		 * @param {*} object The potential iteratee object argument.
		 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
		 *  else `false`.
		 */
		function isIterateeCall(value, index, object) {
		  if (!isObject(object)) {
		    return false;
		  }
		  var type = typeof index === 'undefined' ? 'undefined' : _typeof(index);
		  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
		    return eq(object[index], value);
		  }
		  return false;
		}
	
		module.exports = isIterateeCall;
	
	/***/ }),
	/* 173 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var isArray = __webpack_require__(6),
		    isSymbol = __webpack_require__(62);
	
		/** Used to match property names within property paths. */
		var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
		    reIsPlainProp = /^\w*$/;
	
		/**
		 * Checks if `value` is a property name and not a property path.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {Object} [object] The object to query keys on.
		 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
		 */
		function isKey(value, object) {
		  if (isArray(value)) {
		    return false;
		  }
		  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
		    return true;
		  }
		  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
		}
	
		module.exports = isKey;
	
	/***/ }),
	/* 174 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var assignValue = __webpack_require__(162),
		    copyObject = __webpack_require__(31),
		    createAssigner = __webpack_require__(103),
		    isArrayLike = __webpack_require__(24),
		    isPrototype = __webpack_require__(105),
		    keys = __webpack_require__(32);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Assigns own enumerable string keyed properties of source objects to the
		 * destination object. Source objects are applied from left to right.
		 * Subsequent sources overwrite property assignments of previous sources.
		 *
		 * **Note:** This method mutates `object` and is loosely based on
		 * [`Object.assign`](https://mdn.io/Object/assign).
		 *
		 * @static
		 * @memberOf _
		 * @since 0.10.0
		 * @category Object
		 * @param {Object} object The destination object.
		 * @param {...Object} [sources] The source objects.
		 * @returns {Object} Returns `object`.
		 * @see _.assignIn
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 * }
		 *
		 * function Bar() {
		 *   this.c = 3;
		 * }
		 *
		 * Foo.prototype.b = 2;
		 * Bar.prototype.d = 4;
		 *
		 * _.assign({ 'a': 0 }, new Foo, new Bar);
		 * // => { 'a': 1, 'c': 3 }
		 */
		var assign = createAssigner(function (object, source) {
		  if (isPrototype(source) || isArrayLike(source)) {
		    copyObject(source, keys(source), object);
		    return;
		  }
		  for (var key in source) {
		    if (hasOwnProperty.call(source, key)) {
		      assignValue(object, key, source[key]);
		    }
		  }
		});
	
		module.exports = assign;
	
	/***/ }),
	/* 175 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseGetTag = __webpack_require__(30),
		    isObject = __webpack_require__(18);
	
		/** `Object#toString` result references. */
		var asyncTag = '[object AsyncFunction]',
		    funcTag = '[object Function]',
		    genTag = '[object GeneratorFunction]',
		    proxyTag = '[object Proxy]';
	
		/**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */
		function isFunction(value) {
		    if (!isObject(value)) {
		        return false;
		    }
		    // The use of `Object#toString` avoids issues with the `typeof` operator
		    // in Safari 9 which returns 'object' for typed arrays and other constructors.
		    var tag = baseGetTag(value);
		    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
		}
	
		module.exports = isFunction;
	
	/***/ }),
	/* 176 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;
	
		/**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This method is loosely based on
		 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
		 * @example
		 *
		 * _.isLength(3);
		 * // => true
		 *
		 * _.isLength(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isLength(Infinity);
		 * // => false
		 *
		 * _.isLength('3');
		 * // => false
		 */
		function isLength(value) {
		  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
		}
	
		module.exports = isLength;
	
	/***/ }),
	/* 177 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseIsTypedArray = __webpack_require__(499),
		    baseUnary = __webpack_require__(102),
		    nodeUtil = __webpack_require__(270);
	
		/* Node.js helper references. */
		var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
		/**
		 * Checks if `value` is classified as a typed array.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 * @example
		 *
		 * _.isTypedArray(new Uint8Array);
		 * // => true
		 *
		 * _.isTypedArray([]);
		 * // => false
		 */
		var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
		module.exports = isTypedArray;
	
	/***/ }),
	/* 178 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var map = {
			"./index": 50,
			"./index.js": 50,
			"./logger": 120,
			"./logger.js": 120,
			"./metadata": 121,
			"./metadata.js": 121,
			"./options/build-config-chain": 51,
			"./options/build-config-chain.js": 51,
			"./options/config": 33,
			"./options/config.js": 33,
			"./options/index": 52,
			"./options/index.js": 52,
			"./options/option-manager": 34,
			"./options/option-manager.js": 34,
			"./options/parsers": 53,
			"./options/parsers.js": 53,
			"./options/removed": 54,
			"./options/removed.js": 54
		};
		function webpackContext(req) {
			return __webpack_require__(webpackContextResolve(req));
		};
		function webpackContextResolve(req) {
			return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
		};
		webpackContext.keys = function webpackContextKeys() {
			return Object.keys(map);
		};
		webpackContext.resolve = webpackContextResolve;
		module.exports = webpackContext;
		webpackContext.id = 178;
	
	
	/***/ }),
	/* 179 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var map = {
			"./build-config-chain": 51,
			"./build-config-chain.js": 51,
			"./config": 33,
			"./config.js": 33,
			"./index": 52,
			"./index.js": 52,
			"./option-manager": 34,
			"./option-manager.js": 34,
			"./parsers": 53,
			"./parsers.js": 53,
			"./removed": 54,
			"./removed.js": 54
		};
		function webpackContext(req) {
			return __webpack_require__(webpackContextResolve(req));
		};
		function webpackContextResolve(req) {
			return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
		};
		webpackContext.keys = function webpackContextKeys() {
			return Object.keys(map);
		};
		webpackContext.resolve = webpackContextResolve;
		module.exports = webpackContext;
		webpackContext.id = 179;
	
	
	/***/ }),
	/* 180 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		module.exports = function () {
			return (/[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-PRZcf-nqry=><]/g
			);
		};
	
	/***/ }),
	/* 181 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (rawLines, lineNumber, colNumber) {
		  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
		  colNumber = Math.max(colNumber, 0);
	
		  var highlighted = opts.highlightCode && _chalk2.default.supportsColor || opts.forceColor;
		  var chalk = _chalk2.default;
		  if (opts.forceColor) {
		    chalk = new _chalk2.default.constructor({ enabled: true });
		  }
		  var maybeHighlight = function maybeHighlight(chalkFn, string) {
		    return highlighted ? chalkFn(string) : string;
		  };
		  var defs = getDefs(chalk);
		  if (highlighted) rawLines = highlight(defs, rawLines);
	
		  var linesAbove = opts.linesAbove || 2;
		  var linesBelow = opts.linesBelow || 3;
	
		  var lines = rawLines.split(NEWLINE);
		  var start = Math.max(lineNumber - (linesAbove + 1), 0);
		  var end = Math.min(lines.length, lineNumber + linesBelow);
	
		  if (!lineNumber && !colNumber) {
		    start = 0;
		    end = lines.length;
		  }
	
		  var numberMaxWidth = String(end).length;
	
		  var frame = lines.slice(start, end).map(function (line, index) {
		    var number = start + 1 + index;
		    var paddedNumber = (" " + number).slice(-numberMaxWidth);
		    var gutter = " " + paddedNumber + " | ";
		    if (number === lineNumber) {
		      var markerLine = "";
		      if (colNumber) {
		        var markerSpacing = line.slice(0, colNumber - 1).replace(/[^\t]/g, " ");
		        markerLine = ["\n ", maybeHighlight(defs.gutter, gutter.replace(/\d/g, " ")), markerSpacing, maybeHighlight(defs.marker, "^")].join("");
		      }
		      return [maybeHighlight(defs.marker, ">"), maybeHighlight(defs.gutter, gutter), line, markerLine].join("");
		    } else {
		      return " " + maybeHighlight(defs.gutter, gutter) + line;
		    }
		  }).join("\n");
	
		  if (highlighted) {
		    return chalk.reset(frame);
		  } else {
		    return frame;
		  }
		};
	
		var _jsTokens = __webpack_require__(468);
	
		var _jsTokens2 = _interopRequireDefault(_jsTokens);
	
		var _esutils = __webpack_require__(97);
	
		var _esutils2 = _interopRequireDefault(_esutils);
	
		var _chalk = __webpack_require__(401);
	
		var _chalk2 = _interopRequireDefault(_chalk);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function getDefs(chalk) {
		  return {
		    keyword: chalk.cyan,
		    capitalized: chalk.yellow,
		    jsx_tag: chalk.yellow,
		    punctuator: chalk.yellow,
	
		    number: chalk.magenta,
		    string: chalk.green,
		    regex: chalk.magenta,
		    comment: chalk.grey,
		    invalid: chalk.white.bgRed.bold,
		    gutter: chalk.grey,
		    marker: chalk.red.bold
		  };
		}
	
		var NEWLINE = /\r\n|[\n\r\u2028\u2029]/;
	
		var JSX_TAG = /^[a-z][\w-]*$/i;
	
		var BRACKET = /^[()\[\]{}]$/;
	
		function getTokenType(match) {
		  var _match$slice = match.slice(-2),
		      offset = _match$slice[0],
		      text = _match$slice[1];
	
		  var token = (0, _jsTokens.matchToToken)(match);
	
		  if (token.type === "name") {
		    if (_esutils2.default.keyword.isReservedWordES6(token.value)) {
		      return "keyword";
		    }
	
		    if (JSX_TAG.test(token.value) && (text[offset - 1] === "<" || text.substr(offset - 2, 2) == "</")) {
		      return "jsx_tag";
		    }
	
		    if (token.value[0] !== token.value[0].toLowerCase()) {
		      return "capitalized";
		    }
		  }
	
		  if (token.type === "punctuator" && BRACKET.test(token.value)) {
		    return "bracket";
		  }
	
		  return token.type;
		}
	
		function highlight(defs, text) {
		  return text.replace(_jsTokens2.default, function () {
		    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		      args[_key] = arguments[_key];
		    }
	
		    var type = getTokenType(args);
		    var colorize = defs[type];
		    if (colorize) {
		      return args[0].split(NEWLINE).map(function (str) {
		        return colorize(str);
		      }).join("\n");
		    } else {
		      return args[0];
		    }
		  });
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 182 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.transformFromAst = exports.transform = exports.analyse = exports.Pipeline = exports.OptionManager = exports.traverse = exports.types = exports.messages = exports.util = exports.version = exports.resolvePreset = exports.resolvePlugin = exports.template = exports.buildExternalHelpers = exports.options = exports.File = undefined;
	
		var _file = __webpack_require__(50);
	
		Object.defineProperty(exports, "File", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_file).default;
		  }
		});
	
		var _config = __webpack_require__(33);
	
		Object.defineProperty(exports, "options", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_config).default;
		  }
		});
	
		var _buildExternalHelpers = __webpack_require__(295);
	
		Object.defineProperty(exports, "buildExternalHelpers", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_buildExternalHelpers).default;
		  }
		});
	
		var _babelTemplate = __webpack_require__(4);
	
		Object.defineProperty(exports, "template", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_babelTemplate).default;
		  }
		});
	
		var _resolvePlugin = __webpack_require__(184);
	
		Object.defineProperty(exports, "resolvePlugin", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_resolvePlugin).default;
		  }
		});
	
		var _resolvePreset = __webpack_require__(185);
	
		Object.defineProperty(exports, "resolvePreset", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_resolvePreset).default;
		  }
		});
	
		var _package = __webpack_require__(628);
	
		Object.defineProperty(exports, "version", {
		  enumerable: true,
		  get: function get() {
		    return _package.version;
		  }
		});
		exports.Plugin = Plugin;
		exports.transformFile = transformFile;
		exports.transformFileSync = transformFileSync;
	
		var _fs = __webpack_require__(115);
	
		var _fs2 = _interopRequireDefault(_fs);
	
		var _util = __webpack_require__(122);
	
		var util = _interopRequireWildcard(_util);
	
		var _babelMessages = __webpack_require__(20);
	
		var messages = _interopRequireWildcard(_babelMessages);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		var _babelTraverse = __webpack_require__(7);
	
		var _babelTraverse2 = _interopRequireDefault(_babelTraverse);
	
		var _optionManager = __webpack_require__(34);
	
		var _optionManager2 = _interopRequireDefault(_optionManager);
	
		var _pipeline = __webpack_require__(298);
	
		var _pipeline2 = _interopRequireDefault(_pipeline);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		exports.util = util;
		exports.messages = messages;
		exports.types = t;
		exports.traverse = _babelTraverse2.default;
		exports.OptionManager = _optionManager2.default;
		function Plugin(alias) {
		  throw new Error("The (" + alias + ") Babel 5 plugin is being run with Babel 6.");
		}
	
		exports.Pipeline = _pipeline2.default;
	
		var pipeline = new _pipeline2.default();
		var analyse = exports.analyse = pipeline.analyse.bind(pipeline);
		var transform = exports.transform = pipeline.transform.bind(pipeline);
		var transformFromAst = exports.transformFromAst = pipeline.transformFromAst.bind(pipeline);
	
		function transformFile(filename, opts, callback) {
		  if (typeof opts === "function") {
		    callback = opts;
		    opts = {};
		  }
	
		  opts.filename = filename;
	
		  _fs2.default.readFile(filename, function (err, code) {
		    var result = void 0;
	
		    if (!err) {
		      try {
		        result = transform(code, opts);
		      } catch (_err) {
		        err = _err;
		      }
		    }
	
		    if (err) {
		      callback(err);
		    } else {
		      callback(null, result);
		    }
		  });
		}
	
		function transformFileSync(filename) {
		  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		  opts.filename = filename;
		  return transform(_fs2.default.readFileSync(filename, "utf8"), opts);
		}
	
	/***/ }),
	/* 183 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.default = resolveFromPossibleNames;
	
		var _resolve = __webpack_require__(118);
	
		var _resolve2 = _interopRequireDefault(_resolve);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function resolveFromPossibleNames(possibleNames, dirname) {
		  return possibleNames.reduce(function (accum, curr) {
		    return accum || (0, _resolve2.default)(curr, dirname);
		  }, null);
		}
		module.exports = exports["default"];
	
	/***/ }),
	/* 184 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
		exports.__esModule = true;
		exports.default = resolvePlugin;
	
		var _resolveFromPossibleNames = __webpack_require__(183);
	
		var _resolveFromPossibleNames2 = _interopRequireDefault(_resolveFromPossibleNames);
	
		var _getPossiblePluginNames = __webpack_require__(291);
	
		var _getPossiblePluginNames2 = _interopRequireDefault(_getPossiblePluginNames);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function resolvePlugin(pluginName) {
		  var dirname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : process.cwd();
	
		  return (0, _resolveFromPossibleNames2.default)((0, _getPossiblePluginNames2.default)(pluginName), dirname);
		}
		module.exports = exports["default"];
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))
	
	/***/ }),
	/* 185 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
		exports.__esModule = true;
		exports.default = resolvePreset;
	
		var _resolveFromPossibleNames = __webpack_require__(183);
	
		var _resolveFromPossibleNames2 = _interopRequireDefault(_resolveFromPossibleNames);
	
		var _getPossiblePresetNames = __webpack_require__(292);
	
		var _getPossiblePresetNames2 = _interopRequireDefault(_getPossiblePresetNames);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function resolvePreset(presetName) {
		  var dirname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : process.cwd();
	
		  return (0, _resolveFromPossibleNames2.default)((0, _getPossiblePresetNames2.default)(presetName), dirname);
		}
		module.exports = exports["default"];
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))
	
	/***/ }),
	/* 186 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.CodeGenerator = undefined;
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(42);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(41);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		exports.default = function (ast, opts, code) {
		  var gen = new Generator(ast, opts, code);
		  return gen.generate();
		};
	
		var _detectIndent = __webpack_require__(459);
	
		var _detectIndent2 = _interopRequireDefault(_detectIndent);
	
		var _sourceMap = __webpack_require__(313);
	
		var _sourceMap2 = _interopRequireDefault(_sourceMap);
	
		var _babelMessages = __webpack_require__(20);
	
		var messages = _interopRequireWildcard(_babelMessages);
	
		var _printer = __webpack_require__(312);
	
		var _printer2 = _interopRequireDefault(_printer);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var Generator = function (_Printer) {
		  (0, _inherits3.default)(Generator, _Printer);
	
		  function Generator(ast) {
		    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		    var code = arguments[2];
		    (0, _classCallCheck3.default)(this, Generator);
	
		    var tokens = ast.tokens || [];
		    var format = normalizeOptions(code, opts, tokens);
		    var map = opts.sourceMaps ? new _sourceMap2.default(opts, code) : null;
	
		    var _this = (0, _possibleConstructorReturn3.default)(this, _Printer.call(this, format, map, tokens));
	
		    _this.ast = ast;
		    return _this;
		  }
	
		  Generator.prototype.generate = function generate() {
		    return _Printer.prototype.generate.call(this, this.ast);
		  };
	
		  return Generator;
		}(_printer2.default);
	
		function normalizeOptions(code, opts, tokens) {
		  var style = "  ";
		  if (code && typeof code === "string") {
		    var indent = (0, _detectIndent2.default)(code).indent;
		    if (indent && indent !== " ") style = indent;
		  }
	
		  var format = {
		    auxiliaryCommentBefore: opts.auxiliaryCommentBefore,
		    auxiliaryCommentAfter: opts.auxiliaryCommentAfter,
		    shouldPrintComment: opts.shouldPrintComment,
		    retainLines: opts.retainLines,
		    retainFunctionParens: opts.retainFunctionParens,
		    comments: opts.comments == null || opts.comments,
		    compact: opts.compact,
		    minified: opts.minified,
		    concise: opts.concise,
		    quotes: opts.quotes || findCommonStringDelimiter(code, tokens),
		    jsonCompatibleStrings: opts.jsonCompatibleStrings,
		    indent: {
		      adjustMultilineComment: true,
		      style: style,
		      base: 0
		    },
		    flowCommaSeparator: opts.flowCommaSeparator
		  };
	
		  if (format.minified) {
		    format.compact = true;
	
		    format.shouldPrintComment = format.shouldPrintComment || function () {
		      return format.comments;
		    };
		  } else {
		    format.shouldPrintComment = format.shouldPrintComment || function (value) {
		      return format.comments || value.indexOf("@license") >= 0 || value.indexOf("@preserve") >= 0;
		    };
		  }
	
		  if (format.compact === "auto") {
		    format.compact = code.length > 500000;
	
		    if (format.compact) {
		      console.error("[BABEL] " + messages.get("codeGeneratorDeopt", opts.filename, "500KB"));
		    }
		  }
	
		  if (format.compact) {
		    format.indent.adjustMultilineComment = false;
		  }
	
		  return format;
		}
	
		function findCommonStringDelimiter(code, tokens) {
		  var DEFAULT_STRING_DELIMITER = "double";
		  if (!code) {
		    return DEFAULT_STRING_DELIMITER;
		  }
	
		  var occurrences = {
		    single: 0,
		    double: 0
		  };
	
		  var checked = 0;
	
		  for (var i = 0; i < tokens.length; i++) {
		    var token = tokens[i];
		    if (token.type.label !== "string") continue;
	
		    var raw = code.slice(token.start, token.end);
		    if (raw[0] === "'") {
		      occurrences.single++;
		    } else {
		      occurrences.double++;
		    }
	
		    checked++;
		    if (checked >= 3) break;
		  }
		  if (occurrences.single > occurrences.double) {
		    return "single";
		  } else {
		    return "double";
		  }
		}
	
		var CodeGenerator = exports.CodeGenerator = function () {
		  function CodeGenerator(ast, opts, code) {
		    (0, _classCallCheck3.default)(this, CodeGenerator);
	
		    this._generator = new Generator(ast, opts, code);
		  }
	
		  CodeGenerator.prototype.generate = function generate() {
		    return this._generator.generate();
		  };
	
		  return CodeGenerator;
		}();
	
	/***/ }),
	/* 187 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _keys = __webpack_require__(14);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		exports.needsWhitespace = needsWhitespace;
		exports.needsWhitespaceBefore = needsWhitespaceBefore;
		exports.needsWhitespaceAfter = needsWhitespaceAfter;
		exports.needsParens = needsParens;
	
		var _whitespace = __webpack_require__(311);
	
		var _whitespace2 = _interopRequireDefault(_whitespace);
	
		var _parentheses = __webpack_require__(310);
	
		var parens = _interopRequireWildcard(_parentheses);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function expandAliases(obj) {
		  var newObj = {};
	
		  function add(type, func) {
		    var fn = newObj[type];
		    newObj[type] = fn ? function (node, parent, stack) {
		      var result = fn(node, parent, stack);
	
		      return result == null ? func(node, parent, stack) : result;
		    } : func;
		  }
	
		  for (var _iterator = (0, _keys2.default)(obj), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		    var _ref;
	
		    if (_isArray) {
		      if (_i >= _iterator.length) break;
		      _ref = _iterator[_i++];
		    } else {
		      _i = _iterator.next();
		      if (_i.done) break;
		      _ref = _i.value;
		    }
	
		    var type = _ref;
	
		    var aliases = t.FLIPPED_ALIAS_KEYS[type];
		    if (aliases) {
		      for (var _iterator2 = aliases, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		        var _ref2;
	
		        if (_isArray2) {
		          if (_i2 >= _iterator2.length) break;
		          _ref2 = _iterator2[_i2++];
		        } else {
		          _i2 = _iterator2.next();
		          if (_i2.done) break;
		          _ref2 = _i2.value;
		        }
	
		        var alias = _ref2;
	
		        add(alias, obj[type]);
		      }
		    } else {
		      add(type, obj[type]);
		    }
		  }
	
		  return newObj;
		}
	
		var expandedParens = expandAliases(parens);
		var expandedWhitespaceNodes = expandAliases(_whitespace2.default.nodes);
		var expandedWhitespaceList = expandAliases(_whitespace2.default.list);
	
		function find(obj, node, parent, printStack) {
		  var fn = obj[node.type];
		  return fn ? fn(node, parent, printStack) : null;
		}
	
		function isOrHasCallExpression(node) {
		  if (t.isCallExpression(node)) {
		    return true;
		  }
	
		  if (t.isMemberExpression(node)) {
		    return isOrHasCallExpression(node.object) || !node.computed && isOrHasCallExpression(node.property);
		  } else {
		    return false;
		  }
		}
	
		function needsWhitespace(node, parent, type) {
		  if (!node) return 0;
	
		  if (t.isExpressionStatement(node)) {
		    node = node.expression;
		  }
	
		  var linesInfo = find(expandedWhitespaceNodes, node, parent);
	
		  if (!linesInfo) {
		    var items = find(expandedWhitespaceList, node, parent);
		    if (items) {
		      for (var i = 0; i < items.length; i++) {
		        linesInfo = needsWhitespace(items[i], node, type);
		        if (linesInfo) break;
		      }
		    }
		  }
	
		  return linesInfo && linesInfo[type] || 0;
		}
	
		function needsWhitespaceBefore(node, parent) {
		  return needsWhitespace(node, parent, "before");
		}
	
		function needsWhitespaceAfter(node, parent) {
		  return needsWhitespace(node, parent, "after");
		}
	
		function needsParens(node, parent, printStack) {
		  if (!parent) return false;
	
		  if (t.isNewExpression(parent) && parent.callee === node) {
		    if (isOrHasCallExpression(node)) return true;
		  }
	
		  return find(expandedParens, node, parent, printStack);
		}
	
	/***/ }),
	/* 188 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _keys = __webpack_require__(14);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		exports.push = push;
		exports.hasComputed = hasComputed;
		exports.toComputedObjectFromClass = toComputedObjectFromClass;
		exports.toClassObject = toClassObject;
		exports.toDefineObject = toDefineObject;
	
		var _babelHelperFunctionName = __webpack_require__(40);
	
		var _babelHelperFunctionName2 = _interopRequireDefault(_babelHelperFunctionName);
	
		var _has = __webpack_require__(274);
	
		var _has2 = _interopRequireDefault(_has);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function toKind(node) {
		  if (t.isClassMethod(node) || t.isObjectMethod(node)) {
		    if (node.kind === "get" || node.kind === "set") {
		      return node.kind;
		    }
		  }
	
		  return "value";
		}
	
		function push(mutatorMap, node, kind, file, scope) {
		  var alias = t.toKeyAlias(node);
	
		  var map = {};
		  if ((0, _has2.default)(mutatorMap, alias)) map = mutatorMap[alias];
		  mutatorMap[alias] = map;
	
		  map._inherits = map._inherits || [];
		  map._inherits.push(node);
	
		  map._key = node.key;
	
		  if (node.computed) {
		    map._computed = true;
		  }
	
		  if (node.decorators) {
		    var decorators = map.decorators = map.decorators || t.arrayExpression([]);
		    decorators.elements = decorators.elements.concat(node.decorators.map(function (dec) {
		      return dec.expression;
		    }).reverse());
		  }
	
		  if (map.value || map.initializer) {
		    throw file.buildCodeFrameError(node, "Key conflict with sibling node");
		  }
	
		  var key = void 0,
		      value = void 0;
	
		  if (t.isObjectProperty(node) || t.isObjectMethod(node) || t.isClassMethod(node)) {
		    key = t.toComputedKey(node, node.key);
		  }
	
		  if (t.isObjectProperty(node) || t.isClassProperty(node)) {
		    value = node.value;
		  } else if (t.isObjectMethod(node) || t.isClassMethod(node)) {
		    value = t.functionExpression(null, node.params, node.body, node.generator, node.async);
		    value.returnType = node.returnType;
		  }
	
		  var inheritedKind = toKind(node);
		  if (!kind || inheritedKind !== "value") {
		    kind = inheritedKind;
		  }
	
		  if (scope && t.isStringLiteral(key) && (kind === "value" || kind === "initializer") && t.isFunctionExpression(value)) {
		    value = (0, _babelHelperFunctionName2.default)({ id: key, node: value, scope: scope });
		  }
	
		  if (value) {
		    t.inheritsComments(value, node);
		    map[kind] = value;
		  }
	
		  return map;
		}
	
		function hasComputed(mutatorMap) {
		  for (var key in mutatorMap) {
		    if (mutatorMap[key]._computed) {
		      return true;
		    }
		  }
		  return false;
		}
	
		function toComputedObjectFromClass(obj) {
		  var objExpr = t.arrayExpression([]);
	
		  for (var i = 0; i < obj.properties.length; i++) {
		    var prop = obj.properties[i];
		    var val = prop.value;
		    val.properties.unshift(t.objectProperty(t.identifier("key"), t.toComputedKey(prop)));
		    objExpr.elements.push(val);
		  }
	
		  return objExpr;
		}
	
		function toClassObject(mutatorMap) {
		  var objExpr = t.objectExpression([]);
	
		  (0, _keys2.default)(mutatorMap).forEach(function (mutatorMapKey) {
		    var map = mutatorMap[mutatorMapKey];
		    var mapNode = t.objectExpression([]);
	
		    var propNode = t.objectProperty(map._key, mapNode, map._computed);
	
		    (0, _keys2.default)(map).forEach(function (key) {
		      var node = map[key];
		      if (key[0] === "_") return;
	
		      var inheritNode = node;
		      if (t.isClassMethod(node) || t.isClassProperty(node)) node = node.value;
	
		      var prop = t.objectProperty(t.identifier(key), node);
		      t.inheritsComments(prop, inheritNode);
		      t.removeComments(inheritNode);
	
		      mapNode.properties.push(prop);
		    });
	
		    objExpr.properties.push(propNode);
		  });
	
		  return objExpr;
		}
	
		function toDefineObject(mutatorMap) {
		  (0, _keys2.default)(mutatorMap).forEach(function (key) {
		    var map = mutatorMap[key];
		    if (map.value) map.writable = t.booleanLiteral(true);
		    map.configurable = t.booleanLiteral(true);
		    map.enumerable = t.booleanLiteral(true);
		  });
	
		  return toClassObject(mutatorMap);
		}
	
	/***/ }),
	/* 189 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (node) {
		  var params = node.params;
		  for (var i = 0; i < params.length; i++) {
		    var param = params[i];
		    if (t.isAssignmentPattern(param) || t.isRestElement(param)) {
		      return i;
		    }
		  }
		  return params.length;
		};
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 190 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (path, emit) {
		  var kind = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "var";
	
		  path.traverse(visitor, { kind: kind, emit: emit });
		};
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var visitor = {
		  Scope: function Scope(path, state) {
		    if (state.kind === "let") path.skip();
		  },
		  Function: function Function(path) {
		    path.skip();
		  },
		  VariableDeclaration: function VariableDeclaration(path, state) {
		    if (state.kind && path.node.kind !== state.kind) return;
	
		    var nodes = [];
	
		    var declarations = path.get("declarations");
		    var firstId = void 0;
	
		    for (var _iterator = declarations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var declar = _ref;
	
		      firstId = declar.node.id;
	
		      if (declar.node.init) {
		        nodes.push(t.expressionStatement(t.assignmentExpression("=", declar.node.id, declar.node.init)));
		      }
	
		      for (var name in declar.getBindingIdentifiers()) {
		        state.emit(t.identifier(name), name);
		      }
		    }
	
		    if (path.parentPath.isFor({ left: path.node })) {
		      path.replaceWith(firstId);
		    } else {
		      path.replaceWithMultiple(nodes);
		    }
		  }
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 191 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (callee, thisNode, args) {
		  if (args.length === 1 && t.isSpreadElement(args[0]) && t.isIdentifier(args[0].argument, { name: "arguments" })) {
		    return t.callExpression(t.memberExpression(callee, t.identifier("apply")), [thisNode, args[0].argument]);
		  } else {
		    return t.callExpression(t.memberExpression(callee, t.identifier("call")), [thisNode].concat(args));
		  }
		};
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 192 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.is = is;
		exports.pullFlag = pullFlag;
	
		var _pull = __webpack_require__(277);
	
		var _pull2 = _interopRequireDefault(_pull);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function is(node, flag) {
		  return t.isRegExpLiteral(node) && node.flags.indexOf(flag) >= 0;
		}
	
		function pullFlag(node, flag) {
		  var flags = node.flags.split("");
		  if (node.flags.indexOf(flag) < 0) return;
		  (0, _pull2.default)(flags, flag);
		  node.flags = flags.join("");
		}
	
	/***/ }),
	/* 193 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _symbol = __webpack_require__(10);
	
		var _symbol2 = _interopRequireDefault(_symbol);
	
		var _babelHelperOptimiseCallExpression = __webpack_require__(191);
	
		var _babelHelperOptimiseCallExpression2 = _interopRequireDefault(_babelHelperOptimiseCallExpression);
	
		var _babelMessages = __webpack_require__(20);
	
		var messages = _interopRequireWildcard(_babelMessages);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var HARDCORE_THIS_REF = (0, _symbol2.default)();
	
		function isIllegalBareSuper(node, parent) {
		  if (!t.isSuper(node)) return false;
		  if (t.isMemberExpression(parent, { computed: false })) return false;
		  if (t.isCallExpression(parent, { callee: node })) return false;
		  return true;
		}
	
		function isMemberExpressionSuper(node) {
		  return t.isMemberExpression(node) && t.isSuper(node.object);
		}
	
		function getPrototypeOfExpression(objectRef, isStatic) {
		  var targetRef = isStatic ? objectRef : t.memberExpression(objectRef, t.identifier("prototype"));
	
		  return t.logicalExpression("||", t.memberExpression(targetRef, t.identifier("__proto__")), t.callExpression(t.memberExpression(t.identifier("Object"), t.identifier("getPrototypeOf")), [targetRef]));
		}
	
		var visitor = {
		  Function: function Function(path) {
		    if (!path.inShadow("this")) {
		      path.skip();
		    }
		  },
		  ReturnStatement: function ReturnStatement(path, state) {
		    if (!path.inShadow("this")) {
		      state.returns.push(path);
		    }
		  },
		  ThisExpression: function ThisExpression(path, state) {
		    if (!path.node[HARDCORE_THIS_REF]) {
		      state.thises.push(path);
		    }
		  },
		  enter: function enter(path, state) {
		    var callback = state.specHandle;
		    if (state.isLoose) callback = state.looseHandle;
	
		    var isBareSuper = path.isCallExpression() && path.get("callee").isSuper();
	
		    var result = callback.call(state, path);
	
		    if (result) {
		      state.hasSuper = true;
		    }
	
		    if (isBareSuper) {
		      state.bareSupers.push(path);
		    }
	
		    if (result === true) {
		      path.requeue();
		    }
	
		    if (result !== true && result) {
		      if (Array.isArray(result)) {
		        path.replaceWithMultiple(result);
		      } else {
		        path.replaceWith(result);
		      }
		    }
		  }
		};
	
		var ReplaceSupers = function () {
		  function ReplaceSupers(opts) {
		    var inClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
		    (0, _classCallCheck3.default)(this, ReplaceSupers);
	
		    this.forceSuperMemoisation = opts.forceSuperMemoisation;
		    this.methodPath = opts.methodPath;
		    this.methodNode = opts.methodNode;
		    this.superRef = opts.superRef;
		    this.isStatic = opts.isStatic;
		    this.hasSuper = false;
		    this.inClass = inClass;
		    this.isLoose = opts.isLoose;
		    this.scope = this.methodPath.scope;
		    this.file = opts.file;
		    this.opts = opts;
	
		    this.bareSupers = [];
		    this.returns = [];
		    this.thises = [];
		  }
	
		  ReplaceSupers.prototype.getObjectRef = function getObjectRef() {
		    return this.opts.objectRef || this.opts.getObjectRef();
		  };
	
		  ReplaceSupers.prototype.setSuperProperty = function setSuperProperty(property, value, isComputed) {
		    return t.callExpression(this.file.addHelper("set"), [getPrototypeOfExpression(this.getObjectRef(), this.isStatic), isComputed ? property : t.stringLiteral(property.name), value, t.thisExpression()]);
		  };
	
		  ReplaceSupers.prototype.getSuperProperty = function getSuperProperty(property, isComputed) {
		    return t.callExpression(this.file.addHelper("get"), [getPrototypeOfExpression(this.getObjectRef(), this.isStatic), isComputed ? property : t.stringLiteral(property.name), t.thisExpression()]);
		  };
	
		  ReplaceSupers.prototype.replace = function replace() {
		    this.methodPath.traverse(visitor, this);
		  };
	
		  ReplaceSupers.prototype.getLooseSuperProperty = function getLooseSuperProperty(id, parent) {
		    var methodNode = this.methodNode;
		    var superRef = this.superRef || t.identifier("Function");
	
		    if (parent.property === id) {
		      return;
		    } else if (t.isCallExpression(parent, { callee: id })) {
		      return;
		    } else if (t.isMemberExpression(parent) && !methodNode.static) {
		      return t.memberExpression(superRef, t.identifier("prototype"));
		    } else {
		      return superRef;
		    }
		  };
	
		  ReplaceSupers.prototype.looseHandle = function looseHandle(path) {
		    var node = path.node;
		    if (path.isSuper()) {
		      return this.getLooseSuperProperty(node, path.parent);
		    } else if (path.isCallExpression()) {
		      var callee = node.callee;
		      if (!t.isMemberExpression(callee)) return;
		      if (!t.isSuper(callee.object)) return;
	
		      t.appendToMemberExpression(callee, t.identifier("call"));
		      node.arguments.unshift(t.thisExpression());
		      return true;
		    }
		  };
	
		  ReplaceSupers.prototype.specHandleAssignmentExpression = function specHandleAssignmentExpression(ref, path, node) {
		    if (node.operator === "=") {
		      return this.setSuperProperty(node.left.property, node.right, node.left.computed);
		    } else {
		      ref = ref || path.scope.generateUidIdentifier("ref");
		      return [t.variableDeclaration("var", [t.variableDeclarator(ref, node.left)]), t.expressionStatement(t.assignmentExpression("=", node.left, t.binaryExpression(node.operator[0], ref, node.right)))];
		    }
		  };
	
		  ReplaceSupers.prototype.specHandle = function specHandle(path) {
		    var property = void 0;
		    var computed = void 0;
		    var args = void 0;
	
		    var parent = path.parent;
		    var node = path.node;
	
		    if (isIllegalBareSuper(node, parent)) {
		      throw path.buildCodeFrameError(messages.get("classesIllegalBareSuper"));
		    }
	
		    if (t.isCallExpression(node)) {
		      var callee = node.callee;
		      if (t.isSuper(callee)) {
		        return;
		      } else if (isMemberExpressionSuper(callee)) {
		        property = callee.property;
		        computed = callee.computed;
		        args = node.arguments;
		      }
		    } else if (t.isMemberExpression(node) && t.isSuper(node.object)) {
		      property = node.property;
		      computed = node.computed;
		    } else if (t.isUpdateExpression(node) && isMemberExpressionSuper(node.argument)) {
		      var binary = t.binaryExpression(node.operator[0], node.argument, t.numericLiteral(1));
		      if (node.prefix) {
		        return this.specHandleAssignmentExpression(null, path, binary);
		      } else {
		        var ref = path.scope.generateUidIdentifier("ref");
		        return this.specHandleAssignmentExpression(ref, path, binary).concat(t.expressionStatement(ref));
		      }
		    } else if (t.isAssignmentExpression(node) && isMemberExpressionSuper(node.left)) {
		      return this.specHandleAssignmentExpression(null, path, node);
		    }
	
		    if (!property) return;
	
		    var superProperty = this.getSuperProperty(property, computed);
	
		    if (args) {
		      return this.optimiseCall(superProperty, args);
		    } else {
		      return superProperty;
		    }
		  };
	
		  ReplaceSupers.prototype.optimiseCall = function optimiseCall(callee, args) {
		    var thisNode = t.thisExpression();
		    thisNode[HARDCORE_THIS_REF] = true;
		    return (0, _babelHelperOptimiseCallExpression2.default)(callee, thisNode, args);
		  };
	
		  return ReplaceSupers;
		}();
	
		exports.default = ReplaceSupers;
		module.exports = exports["default"];
	
	/***/ }),
	/* 194 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.list = undefined;
	
		var _keys = __webpack_require__(14);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		exports.get = get;
	
		var _helpers = __webpack_require__(321);
	
		var _helpers2 = _interopRequireDefault(_helpers);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function get(name) {
		  var fn = _helpers2.default[name];
		  if (!fn) throw new ReferenceError("Unknown helper " + name);
	
		  return fn().expression;
		}
	
		var list = exports.list = (0, _keys2.default)(_helpers2.default).map(function (name) {
		  return name.replace(/^_/, "");
		}).filter(function (name) {
		  return name !== "__esModule";
		});
	
		exports.default = get;
	
	/***/ }),
	/* 195 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    manipulateOptions: function manipulateOptions(opts, parserOpts) {
		      parserOpts.plugins.push("asyncGenerators");
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 196 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    manipulateOptions: function manipulateOptions(opts, parserOpts) {
		      parserOpts.plugins.push("classConstructorCall");
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 197 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    manipulateOptions: function manipulateOptions(opts, parserOpts) {
		      parserOpts.plugins.push("classProperties");
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 198 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    manipulateOptions: function manipulateOptions(opts, parserOpts) {
		      parserOpts.plugins.push("doExpressions");
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 199 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    manipulateOptions: function manipulateOptions(opts, parserOpts) {
		      parserOpts.plugins.push("exponentiationOperator");
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 200 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    manipulateOptions: function manipulateOptions(opts, parserOpts) {
		      parserOpts.plugins.push("exportExtensions");
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 201 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    manipulateOptions: function manipulateOptions(opts, parserOpts) {
		      parserOpts.plugins.push("functionBind");
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 202 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    manipulateOptions: function manipulateOptions(opts, parserOpts) {
		      parserOpts.plugins.push("objectRestSpread");
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 203 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _symbol = __webpack_require__(10);
	
		var _symbol2 = _interopRequireDefault(_symbol);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  var ALREADY_VISITED = (0, _symbol2.default)();
	
		  function findConstructorCall(path) {
		    var methods = path.get("body.body");
	
		    for (var _iterator = methods, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref2;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref2 = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref2 = _i.value;
		      }
	
		      var method = _ref2;
	
		      if (method.node.kind === "constructorCall") {
		        return method;
		      }
		    }
	
		    return null;
		  }
	
		  function handleClassWithCall(constructorCall, classPath) {
		    var _classPath = classPath,
		        node = _classPath.node;
	
		    var ref = node.id || classPath.scope.generateUidIdentifier("class");
	
		    if (classPath.parentPath.isExportDefaultDeclaration()) {
		      classPath = classPath.parentPath;
		      classPath.insertAfter(t.exportDefaultDeclaration(ref));
		    }
	
		    classPath.replaceWithMultiple(buildWrapper({
		      CLASS_REF: classPath.scope.generateUidIdentifier(ref.name),
		      CALL_REF: classPath.scope.generateUidIdentifier(ref.name + "Call"),
		      CALL: t.functionExpression(null, constructorCall.node.params, constructorCall.node.body),
		      CLASS: t.toExpression(node),
		      WRAPPER_REF: ref
		    }));
	
		    constructorCall.remove();
		  }
	
		  return {
		    inherits: __webpack_require__(196),
	
		    visitor: {
		      Class: function Class(path) {
		        if (path.node[ALREADY_VISITED]) return;
		        path.node[ALREADY_VISITED] = true;
	
		        var constructorCall = findConstructorCall(path);
	
		        if (constructorCall) {
		          handleClassWithCall(constructorCall, path);
		        } else {
		          return;
		        }
		      }
		    }
		  };
		};
	
		var _babelTemplate = __webpack_require__(4);
	
		var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var buildWrapper = (0, _babelTemplate2.default)("\n  let CLASS_REF = CLASS;\n  var CALL_REF = CALL;\n  var WRAPPER_REF = function (...args) {\n    if (this instanceof WRAPPER_REF) {\n      return Reflect.construct(CLASS_REF, args);\n    } else {\n      return CALL_REF.apply(this, args);\n    }\n  };\n  WRAPPER_REF.__proto__ = CLASS_REF;\n  WRAPPER_REF;\n");
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 204 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  var findBareSupers = {
		    Super: function Super(path) {
		      if (path.parentPath.isCallExpression({ callee: path.node })) {
		        this.push(path.parentPath);
		      }
		    }
		  };
	
		  var referenceVisitor = {
		    ReferencedIdentifier: function ReferencedIdentifier(path) {
		      if (this.scope.hasOwnBinding(path.node.name)) {
		        this.collision = true;
		        path.skip();
		      }
		    }
		  };
	
		  var buildObjectDefineProperty = (0, _babelTemplate2.default)("\n    Object.defineProperty(REF, KEY, {\n      // configurable is false by default\n      enumerable: true,\n      writable: true,\n      value: VALUE\n    });\n  ");
	
		  var buildClassPropertySpec = function buildClassPropertySpec(ref, _ref2) {
		    var key = _ref2.key,
		        value = _ref2.value,
		        computed = _ref2.computed;
		    return buildObjectDefineProperty({
		      REF: ref,
		      KEY: t.isIdentifier(key) && !computed ? t.stringLiteral(key.name) : key,
		      VALUE: value ? value : t.identifier("undefined")
		    });
		  };
	
		  var buildClassPropertyNonSpec = function buildClassPropertyNonSpec(ref, _ref3) {
		    var key = _ref3.key,
		        value = _ref3.value,
		        computed = _ref3.computed;
		    return t.expressionStatement(t.assignmentExpression("=", t.memberExpression(ref, key, computed || t.isLiteral(key)), value));
		  };
	
		  return {
		    inherits: __webpack_require__(197),
	
		    visitor: {
		      Class: function Class(path, state) {
		        var buildClassProperty = state.opts.spec ? buildClassPropertySpec : buildClassPropertyNonSpec;
		        var isDerived = !!path.node.superClass;
		        var constructor = void 0;
		        var props = [];
		        var body = path.get("body");
	
		        for (var _iterator = body.get("body"), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		          var _ref4;
	
		          if (_isArray) {
		            if (_i >= _iterator.length) break;
		            _ref4 = _iterator[_i++];
		          } else {
		            _i = _iterator.next();
		            if (_i.done) break;
		            _ref4 = _i.value;
		          }
	
		          var _path = _ref4;
	
		          if (_path.isClassProperty()) {
		            props.push(_path);
		          } else if (_path.isClassMethod({ kind: "constructor" })) {
		            constructor = _path;
		          }
		        }
	
		        if (!props.length) return;
	
		        var nodes = [];
		        var ref = void 0;
	
		        if (path.isClassExpression() || !path.node.id) {
		          (0, _babelHelperFunctionName2.default)(path);
		          ref = path.scope.generateUidIdentifier("class");
		        } else {
		          ref = path.node.id;
		        }
	
		        var instanceBody = [];
	
		        for (var _iterator2 = props, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		          var _ref5;
	
		          if (_isArray2) {
		            if (_i2 >= _iterator2.length) break;
		            _ref5 = _iterator2[_i2++];
		          } else {
		            _i2 = _iterator2.next();
		            if (_i2.done) break;
		            _ref5 = _i2.value;
		          }
	
		          var _prop = _ref5;
	
		          var propNode = _prop.node;
		          if (propNode.decorators && propNode.decorators.length > 0) continue;
	
		          if (!state.opts.spec && !propNode.value) continue;
	
		          var isStatic = propNode.static;
	
		          if (isStatic) {
		            nodes.push(buildClassProperty(ref, propNode));
		          } else {
		            if (!propNode.value) continue;
		            instanceBody.push(buildClassProperty(t.thisExpression(), propNode));
		          }
		        }
	
		        if (instanceBody.length) {
		          if (!constructor) {
		            var newConstructor = t.classMethod("constructor", t.identifier("constructor"), [], t.blockStatement([]));
		            if (isDerived) {
		              newConstructor.params = [t.restElement(t.identifier("args"))];
		              newConstructor.body.body.push(t.returnStatement(t.callExpression(t.super(), [t.spreadElement(t.identifier("args"))])));
		            }
	
		            var _body$unshiftContaine = body.unshiftContainer("body", newConstructor);
	
		            constructor = _body$unshiftContaine[0];
		          }
	
		          var collisionState = {
		            collision: false,
		            scope: constructor.scope
		          };
	
		          for (var _iterator3 = props, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		            var _ref6;
	
		            if (_isArray3) {
		              if (_i3 >= _iterator3.length) break;
		              _ref6 = _iterator3[_i3++];
		            } else {
		              _i3 = _iterator3.next();
		              if (_i3.done) break;
		              _ref6 = _i3.value;
		            }
	
		            var prop = _ref6;
	
		            prop.traverse(referenceVisitor, collisionState);
		            if (collisionState.collision) break;
		          }
	
		          if (collisionState.collision) {
		            var initialisePropsRef = path.scope.generateUidIdentifier("initialiseProps");
	
		            nodes.push(t.variableDeclaration("var", [t.variableDeclarator(initialisePropsRef, t.functionExpression(null, [], t.blockStatement(instanceBody)))]));
	
		            instanceBody = [t.expressionStatement(t.callExpression(t.memberExpression(initialisePropsRef, t.identifier("call")), [t.thisExpression()]))];
		          }
	
		          if (isDerived) {
		            var bareSupers = [];
		            constructor.traverse(findBareSupers, bareSupers);
		            for (var _iterator4 = bareSupers, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
		              var _ref7;
	
		              if (_isArray4) {
		                if (_i4 >= _iterator4.length) break;
		                _ref7 = _iterator4[_i4++];
		              } else {
		                _i4 = _iterator4.next();
		                if (_i4.done) break;
		                _ref7 = _i4.value;
		              }
	
		              var bareSuper = _ref7;
	
		              bareSuper.insertAfter(instanceBody);
		            }
		          } else {
		            constructor.get("body").unshiftContainer("body", instanceBody);
		          }
		        }
	
		        for (var _iterator5 = props, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : (0, _getIterator3.default)(_iterator5);;) {
		          var _ref8;
	
		          if (_isArray5) {
		            if (_i5 >= _iterator5.length) break;
		            _ref8 = _iterator5[_i5++];
		          } else {
		            _i5 = _iterator5.next();
		            if (_i5.done) break;
		            _ref8 = _i5.value;
		          }
	
		          var _prop2 = _ref8;
	
		          _prop2.remove();
		        }
	
		        if (!nodes.length) return;
	
		        if (path.isClassExpression()) {
		          path.scope.push({ id: ref });
		          path.replaceWith(t.assignmentExpression("=", ref, path.node));
		        } else {
		          if (!path.node.id) {
		            path.node.id = ref;
		          }
	
		          if (path.parentPath.isExportDeclaration()) {
		            path = path.parentPath;
		          }
		        }
	
		        path.insertAfter(nodes);
		      },
		      ArrowFunctionExpression: function ArrowFunctionExpression(path) {
		        var classExp = path.get("body");
		        if (!classExp.isClassExpression()) return;
	
		        var body = classExp.get("body");
		        var members = body.get("body");
		        if (members.some(function (member) {
		          return member.isClassProperty();
		        })) {
		          path.ensureBlock();
		        }
		      }
		    }
		  };
		};
	
		var _babelHelperFunctionName = __webpack_require__(40);
	
		var _babelHelperFunctionName2 = _interopRequireDefault(_babelHelperFunctionName);
	
		var _babelTemplate = __webpack_require__(4);
	
		var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 205 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _create = __webpack_require__(9);
	
		var _create2 = _interopRequireDefault(_create);
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  function cleanDecorators(decorators) {
		    return decorators.reverse().map(function (dec) {
		      return dec.expression;
		    });
		  }
	
		  function transformClass(path, ref, state) {
		    var nodes = [];
	
		    state;
	
		    var classDecorators = path.node.decorators;
		    if (classDecorators) {
		      path.node.decorators = null;
		      classDecorators = cleanDecorators(classDecorators);
	
		      for (var _iterator = classDecorators, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		        var _ref2;
	
		        if (_isArray) {
		          if (_i >= _iterator.length) break;
		          _ref2 = _iterator[_i++];
		        } else {
		          _i = _iterator.next();
		          if (_i.done) break;
		          _ref2 = _i.value;
		        }
	
		        var decorator = _ref2;
	
		        nodes.push(buildClassDecorator({
		          CLASS_REF: ref,
		          DECORATOR: decorator
		        }));
		      }
		    }
	
		    var map = (0, _create2.default)(null);
	
		    for (var _iterator2 = path.get("body.body"), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		      var _ref3;
	
		      if (_isArray2) {
		        if (_i2 >= _iterator2.length) break;
		        _ref3 = _iterator2[_i2++];
		      } else {
		        _i2 = _iterator2.next();
		        if (_i2.done) break;
		        _ref3 = _i2.value;
		      }
	
		      var method = _ref3;
	
		      var decorators = method.node.decorators;
		      if (!decorators) continue;
	
		      var _alias = t.toKeyAlias(method.node);
		      map[_alias] = map[_alias] || [];
		      map[_alias].push(method.node);
	
		      method.remove();
		    }
	
		    for (var alias in map) {
		      var items = map[alias];
	
		      items;
		    }
	
		    return nodes;
		  }
	
		  function hasDecorators(path) {
		    if (path.isClass()) {
		      if (path.node.decorators) return true;
	
		      for (var _iterator3 = path.node.body.body, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		        var _ref4;
	
		        if (_isArray3) {
		          if (_i3 >= _iterator3.length) break;
		          _ref4 = _iterator3[_i3++];
		        } else {
		          _i3 = _iterator3.next();
		          if (_i3.done) break;
		          _ref4 = _i3.value;
		        }
	
		        var method = _ref4;
	
		        if (method.decorators) {
		          return true;
		        }
		      }
		    } else if (path.isObjectExpression()) {
		      for (var _iterator4 = path.node.properties, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
		        var _ref5;
	
		        if (_isArray4) {
		          if (_i4 >= _iterator4.length) break;
		          _ref5 = _iterator4[_i4++];
		        } else {
		          _i4 = _iterator4.next();
		          if (_i4.done) break;
		          _ref5 = _i4.value;
		        }
	
		        var prop = _ref5;
	
		        if (prop.decorators) {
		          return true;
		        }
		      }
		    }
	
		    return false;
		  }
	
		  function doError(path) {
		    throw path.buildCodeFrameError("Decorators are not officially supported yet in 6.x pending a proposal update.\nHowever, if you need to use them you can install the legacy decorators transform with:\n\nnpm install babel-plugin-transform-decorators-legacy --save-dev\n\nand add the following line to your .babelrc file:\n\n{\n  \"plugins\": [\"transform-decorators-legacy\"]\n}\n\nThe repo url is: https://github.com/loganfsmyth/babel-plugin-transform-decorators-legacy.\n    ");
		  }
	
		  return {
		    inherits: __webpack_require__(125),
	
		    visitor: {
		      ClassExpression: function ClassExpression(path) {
		        if (!hasDecorators(path)) return;
		        doError(path);
	
		        (0, _babelHelperExplodeClass2.default)(path);
	
		        var ref = path.scope.generateDeclaredUidIdentifier("ref");
		        var nodes = [];
	
		        nodes.push(t.assignmentExpression("=", ref, path.node));
	
		        nodes = nodes.concat(transformClass(path, ref, this));
	
		        nodes.push(ref);
	
		        path.replaceWith(t.sequenceExpression(nodes));
		      },
		      ClassDeclaration: function ClassDeclaration(path) {
		        if (!hasDecorators(path)) return;
		        doError(path);
		        (0, _babelHelperExplodeClass2.default)(path);
	
		        var ref = path.node.id;
		        var nodes = [];
	
		        nodes = nodes.concat(transformClass(path, ref, this).map(function (expr) {
		          return t.expressionStatement(expr);
		        }));
		        nodes.push(t.expressionStatement(ref));
	
		        path.insertAfter(nodes);
		      },
		      ObjectExpression: function ObjectExpression(path) {
		        if (!hasDecorators(path)) return;
		        doError(path);
		      }
		    }
		  };
		};
	
		var _babelTemplate = __webpack_require__(4);
	
		var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
		var _babelHelperExplodeClass = __webpack_require__(319);
	
		var _babelHelperExplodeClass2 = _interopRequireDefault(_babelHelperExplodeClass);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var buildClassDecorator = (0, _babelTemplate2.default)("\n  CLASS_REF = DECORATOR(CLASS_REF) || CLASS_REF;\n");
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 206 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    inherits: __webpack_require__(198),
	
		    visitor: {
		      DoExpression: function DoExpression(path) {
		        var body = path.node.body.body;
		        if (body.length) {
		          path.replaceWithMultiple(body);
		        } else {
		          path.replaceWith(path.scope.buildUndefinedNode());
		        }
		      }
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 207 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _babelTraverse = __webpack_require__(7);
	
		var _babelHelperReplaceSupers = __webpack_require__(193);
	
		var _babelHelperReplaceSupers2 = _interopRequireDefault(_babelHelperReplaceSupers);
	
		var _babelHelperOptimiseCallExpression = __webpack_require__(191);
	
		var _babelHelperOptimiseCallExpression2 = _interopRequireDefault(_babelHelperOptimiseCallExpression);
	
		var _babelHelperDefineMap = __webpack_require__(188);
	
		var defineMap = _interopRequireWildcard(_babelHelperDefineMap);
	
		var _babelTemplate = __webpack_require__(4);
	
		var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var buildDerivedConstructor = (0, _babelTemplate2.default)("\n  (function () {\n    super(...arguments);\n  })\n");
	
		var noMethodVisitor = {
		  "FunctionExpression|FunctionDeclaration": function FunctionExpressionFunctionDeclaration(path) {
		    if (!path.is("shadow")) {
		      path.skip();
		    }
		  },
		  Method: function Method(path) {
		    path.skip();
		  }
		};
	
		var verifyConstructorVisitor = _babelTraverse.visitors.merge([noMethodVisitor, {
		  Super: function Super(path) {
		    if (this.isDerived && !this.hasBareSuper && !path.parentPath.isCallExpression({ callee: path.node })) {
		      throw path.buildCodeFrameError("'super.*' is not allowed before super()");
		    }
		  },
	
		  CallExpression: {
		    exit: function exit(path) {
		      if (path.get("callee").isSuper()) {
		        this.hasBareSuper = true;
	
		        if (!this.isDerived) {
		          throw path.buildCodeFrameError("super() is only allowed in a derived constructor");
		        }
		      }
		    }
		  },
	
		  ThisExpression: function ThisExpression(path) {
		    if (this.isDerived && !this.hasBareSuper) {
		      if (!path.inShadow("this")) {
		        throw path.buildCodeFrameError("'this' is not allowed before super()");
		      }
		    }
		  }
		}]);
	
		var findThisesVisitor = _babelTraverse.visitors.merge([noMethodVisitor, {
		  ThisExpression: function ThisExpression(path) {
		    this.superThises.push(path);
		  }
		}]);
	
		var ClassTransformer = function () {
		  function ClassTransformer(path, file) {
		    (0, _classCallCheck3.default)(this, ClassTransformer);
	
		    this.parent = path.parent;
		    this.scope = path.scope;
		    this.node = path.node;
		    this.path = path;
		    this.file = file;
	
		    this.clearDescriptors();
	
		    this.instancePropBody = [];
		    this.instancePropRefs = {};
		    this.staticPropBody = [];
		    this.body = [];
	
		    this.bareSuperAfter = [];
		    this.bareSupers = [];
	
		    this.pushedConstructor = false;
		    this.pushedInherits = false;
		    this.isLoose = false;
	
		    this.superThises = [];
	
		    this.classId = this.node.id;
	
		    this.classRef = this.node.id ? t.identifier(this.node.id.name) : this.scope.generateUidIdentifier("class");
	
		    this.superName = this.node.superClass || t.identifier("Function");
		    this.isDerived = !!this.node.superClass;
		  }
	
		  ClassTransformer.prototype.run = function run() {
		    var _this = this;
	
		    var superName = this.superName;
		    var file = this.file;
		    var body = this.body;
	
		    var constructorBody = this.constructorBody = t.blockStatement([]);
		    this.constructor = this.buildConstructor();
	
		    var closureParams = [];
		    var closureArgs = [];
	
		    if (this.isDerived) {
		      closureArgs.push(superName);
	
		      superName = this.scope.generateUidIdentifierBasedOnNode(superName);
		      closureParams.push(superName);
	
		      this.superName = superName;
		    }
	
		    this.buildBody();
	
		    constructorBody.body.unshift(t.expressionStatement(t.callExpression(file.addHelper("classCallCheck"), [t.thisExpression(), this.classRef])));
	
		    body = body.concat(this.staticPropBody.map(function (fn) {
		      return fn(_this.classRef);
		    }));
	
		    if (this.classId) {
		      if (body.length === 1) return t.toExpression(body[0]);
		    }
	
		    body.push(t.returnStatement(this.classRef));
	
		    var container = t.functionExpression(null, closureParams, t.blockStatement(body));
		    container.shadow = true;
		    return t.callExpression(container, closureArgs);
		  };
	
		  ClassTransformer.prototype.buildConstructor = function buildConstructor() {
		    var func = t.functionDeclaration(this.classRef, [], this.constructorBody);
		    t.inherits(func, this.node);
		    return func;
		  };
	
		  ClassTransformer.prototype.pushToMap = function pushToMap(node, enumerable) {
		    var kind = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "value";
		    var scope = arguments[3];
	
		    var mutatorMap = void 0;
		    if (node.static) {
		      this.hasStaticDescriptors = true;
		      mutatorMap = this.staticMutatorMap;
		    } else {
		      this.hasInstanceDescriptors = true;
		      mutatorMap = this.instanceMutatorMap;
		    }
	
		    var map = defineMap.push(mutatorMap, node, kind, this.file, scope);
	
		    if (enumerable) {
		      map.enumerable = t.booleanLiteral(true);
		    }
	
		    return map;
		  };
	
		  ClassTransformer.prototype.constructorMeMaybe = function constructorMeMaybe() {
		    var hasConstructor = false;
		    var paths = this.path.get("body.body");
		    for (var _iterator = paths, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var path = _ref;
	
		      hasConstructor = path.equals("kind", "constructor");
		      if (hasConstructor) break;
		    }
		    if (hasConstructor) return;
	
		    var params = void 0,
		        body = void 0;
	
		    if (this.isDerived) {
		      var _constructor = buildDerivedConstructor().expression;
		      params = _constructor.params;
		      body = _constructor.body;
		    } else {
		      params = [];
		      body = t.blockStatement([]);
		    }
	
		    this.path.get("body").unshiftContainer("body", t.classMethod("constructor", t.identifier("constructor"), params, body));
		  };
	
		  ClassTransformer.prototype.buildBody = function buildBody() {
		    this.constructorMeMaybe();
		    this.pushBody();
		    this.verifyConstructor();
	
		    if (this.userConstructor) {
		      var constructorBody = this.constructorBody;
		      constructorBody.body = constructorBody.body.concat(this.userConstructor.body.body);
		      t.inherits(this.constructor, this.userConstructor);
		      t.inherits(constructorBody, this.userConstructor.body);
		    }
	
		    this.pushDescriptors();
		  };
	
		  ClassTransformer.prototype.pushBody = function pushBody() {
		    var classBodyPaths = this.path.get("body.body");
	
		    for (var _iterator2 = classBodyPaths, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		      var _ref2;
	
		      if (_isArray2) {
		        if (_i2 >= _iterator2.length) break;
		        _ref2 = _iterator2[_i2++];
		      } else {
		        _i2 = _iterator2.next();
		        if (_i2.done) break;
		        _ref2 = _i2.value;
		      }
	
		      var path = _ref2;
	
		      var node = path.node;
	
		      if (path.isClassProperty()) {
		        throw path.buildCodeFrameError("Missing class properties transform.");
		      }
	
		      if (node.decorators) {
		        throw path.buildCodeFrameError("Method has decorators, put the decorator plugin before the classes one.");
		      }
	
		      if (t.isClassMethod(node)) {
		        var isConstructor = node.kind === "constructor";
	
		        if (isConstructor) {
		          path.traverse(verifyConstructorVisitor, this);
	
		          if (!this.hasBareSuper && this.isDerived) {
		            throw path.buildCodeFrameError("missing super() call in constructor");
		          }
		        }
	
		        var replaceSupers = new _babelHelperReplaceSupers2.default({
		          forceSuperMemoisation: isConstructor,
		          methodPath: path,
		          methodNode: node,
		          objectRef: this.classRef,
		          superRef: this.superName,
		          isStatic: node.static,
		          isLoose: this.isLoose,
		          scope: this.scope,
		          file: this.file
		        }, true);
	
		        replaceSupers.replace();
	
		        if (isConstructor) {
		          this.pushConstructor(replaceSupers, node, path);
		        } else {
		          this.pushMethod(node, path);
		        }
		      }
		    }
		  };
	
		  ClassTransformer.prototype.clearDescriptors = function clearDescriptors() {
		    this.hasInstanceDescriptors = false;
		    this.hasStaticDescriptors = false;
	
		    this.instanceMutatorMap = {};
		    this.staticMutatorMap = {};
		  };
	
		  ClassTransformer.prototype.pushDescriptors = function pushDescriptors() {
		    this.pushInherits();
	
		    var body = this.body;
	
		    var instanceProps = void 0;
		    var staticProps = void 0;
	
		    if (this.hasInstanceDescriptors) {
		      instanceProps = defineMap.toClassObject(this.instanceMutatorMap);
		    }
	
		    if (this.hasStaticDescriptors) {
		      staticProps = defineMap.toClassObject(this.staticMutatorMap);
		    }
	
		    if (instanceProps || staticProps) {
		      if (instanceProps) instanceProps = defineMap.toComputedObjectFromClass(instanceProps);
		      if (staticProps) staticProps = defineMap.toComputedObjectFromClass(staticProps);
	
		      var nullNode = t.nullLiteral();
	
		      var args = [this.classRef, nullNode, nullNode, nullNode, nullNode];
	
		      if (instanceProps) args[1] = instanceProps;
		      if (staticProps) args[2] = staticProps;
	
		      if (this.instanceInitializersId) {
		        args[3] = this.instanceInitializersId;
		        body.unshift(this.buildObjectAssignment(this.instanceInitializersId));
		      }
	
		      if (this.staticInitializersId) {
		        args[4] = this.staticInitializersId;
		        body.unshift(this.buildObjectAssignment(this.staticInitializersId));
		      }
	
		      var lastNonNullIndex = 0;
		      for (var i = 0; i < args.length; i++) {
		        if (args[i] !== nullNode) lastNonNullIndex = i;
		      }
		      args = args.slice(0, lastNonNullIndex + 1);
	
		      body.push(t.expressionStatement(t.callExpression(this.file.addHelper("createClass"), args)));
		    }
	
		    this.clearDescriptors();
		  };
	
		  ClassTransformer.prototype.buildObjectAssignment = function buildObjectAssignment(id) {
		    return t.variableDeclaration("var", [t.variableDeclarator(id, t.objectExpression([]))]);
		  };
	
		  ClassTransformer.prototype.wrapSuperCall = function wrapSuperCall(bareSuper, superRef, thisRef, body) {
		    var bareSuperNode = bareSuper.node;
	
		    if (this.isLoose) {
		      bareSuperNode.arguments.unshift(t.thisExpression());
		      if (bareSuperNode.arguments.length === 2 && t.isSpreadElement(bareSuperNode.arguments[1]) && t.isIdentifier(bareSuperNode.arguments[1].argument, { name: "arguments" })) {
		        bareSuperNode.arguments[1] = bareSuperNode.arguments[1].argument;
		        bareSuperNode.callee = t.memberExpression(superRef, t.identifier("apply"));
		      } else {
		        bareSuperNode.callee = t.memberExpression(superRef, t.identifier("call"));
		      }
		    } else {
		      bareSuperNode = (0, _babelHelperOptimiseCallExpression2.default)(t.logicalExpression("||", t.memberExpression(this.classRef, t.identifier("__proto__")), t.callExpression(t.memberExpression(t.identifier("Object"), t.identifier("getPrototypeOf")), [this.classRef])), t.thisExpression(), bareSuperNode.arguments);
		    }
	
		    var call = t.callExpression(this.file.addHelper("possibleConstructorReturn"), [t.thisExpression(), bareSuperNode]);
	
		    var bareSuperAfter = this.bareSuperAfter.map(function (fn) {
		      return fn(thisRef);
		    });
	
		    if (bareSuper.parentPath.isExpressionStatement() && bareSuper.parentPath.container === body.node.body && body.node.body.length - 1 === bareSuper.parentPath.key) {
	
		      if (this.superThises.length || bareSuperAfter.length) {
		        bareSuper.scope.push({ id: thisRef });
		        call = t.assignmentExpression("=", thisRef, call);
		      }
	
		      if (bareSuperAfter.length) {
		        call = t.toSequenceExpression([call].concat(bareSuperAfter, [thisRef]));
		      }
	
		      bareSuper.parentPath.replaceWith(t.returnStatement(call));
		    } else {
		      bareSuper.replaceWithMultiple([t.variableDeclaration("var", [t.variableDeclarator(thisRef, call)])].concat(bareSuperAfter, [t.expressionStatement(thisRef)]));
		    }
		  };
	
		  ClassTransformer.prototype.verifyConstructor = function verifyConstructor() {
		    var _this2 = this;
	
		    if (!this.isDerived) return;
	
		    var path = this.userConstructorPath;
		    var body = path.get("body");
	
		    path.traverse(findThisesVisitor, this);
	
		    var guaranteedSuperBeforeFinish = !!this.bareSupers.length;
	
		    var superRef = this.superName || t.identifier("Function");
		    var thisRef = path.scope.generateUidIdentifier("this");
	
		    for (var _iterator3 = this.bareSupers, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		      var _ref3;
	
		      if (_isArray3) {
		        if (_i3 >= _iterator3.length) break;
		        _ref3 = _iterator3[_i3++];
		      } else {
		        _i3 = _iterator3.next();
		        if (_i3.done) break;
		        _ref3 = _i3.value;
		      }
	
		      var bareSuper = _ref3;
	
		      this.wrapSuperCall(bareSuper, superRef, thisRef, body);
	
		      if (guaranteedSuperBeforeFinish) {
		        bareSuper.find(function (parentPath) {
		          if (parentPath === path) {
		            return true;
		          }
	
		          if (parentPath.isLoop() || parentPath.isConditional()) {
		            guaranteedSuperBeforeFinish = false;
		            return true;
		          }
		        });
		      }
		    }
	
		    for (var _iterator4 = this.superThises, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
		      var _ref4;
	
		      if (_isArray4) {
		        if (_i4 >= _iterator4.length) break;
		        _ref4 = _iterator4[_i4++];
		      } else {
		        _i4 = _iterator4.next();
		        if (_i4.done) break;
		        _ref4 = _i4.value;
		      }
	
		      var thisPath = _ref4;
	
		      thisPath.replaceWith(thisRef);
		    }
	
		    var wrapReturn = function wrapReturn(returnArg) {
		      return t.callExpression(_this2.file.addHelper("possibleConstructorReturn"), [thisRef].concat(returnArg || []));
		    };
	
		    var bodyPaths = body.get("body");
		    if (bodyPaths.length && !bodyPaths.pop().isReturnStatement()) {
		      body.pushContainer("body", t.returnStatement(guaranteedSuperBeforeFinish ? thisRef : wrapReturn()));
		    }
	
		    for (var _iterator5 = this.superReturns, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : (0, _getIterator3.default)(_iterator5);;) {
		      var _ref5;
	
		      if (_isArray5) {
		        if (_i5 >= _iterator5.length) break;
		        _ref5 = _iterator5[_i5++];
		      } else {
		        _i5 = _iterator5.next();
		        if (_i5.done) break;
		        _ref5 = _i5.value;
		      }
	
		      var returnPath = _ref5;
	
		      if (returnPath.node.argument) {
		        var ref = returnPath.scope.generateDeclaredUidIdentifier("ret");
		        returnPath.get("argument").replaceWithMultiple([t.assignmentExpression("=", ref, returnPath.node.argument), wrapReturn(ref)]);
		      } else {
		        returnPath.get("argument").replaceWith(wrapReturn());
		      }
		    }
		  };
	
		  ClassTransformer.prototype.pushMethod = function pushMethod(node, path) {
		    var scope = path ? path.scope : this.scope;
	
		    if (node.kind === "method") {
		      if (this._processMethod(node, scope)) return;
		    }
	
		    this.pushToMap(node, false, null, scope);
		  };
	
		  ClassTransformer.prototype._processMethod = function _processMethod() {
		    return false;
		  };
	
		  ClassTransformer.prototype.pushConstructor = function pushConstructor(replaceSupers, method, path) {
		    this.bareSupers = replaceSupers.bareSupers;
		    this.superReturns = replaceSupers.returns;
	
		    if (path.scope.hasOwnBinding(this.classRef.name)) {
		      path.scope.rename(this.classRef.name);
		    }
	
		    var construct = this.constructor;
	
		    this.userConstructorPath = path;
		    this.userConstructor = method;
		    this.hasConstructor = true;
	
		    t.inheritsComments(construct, method);
	
		    construct._ignoreUserWhitespace = true;
		    construct.params = method.params;
	
		    t.inherits(construct.body, method.body);
		    construct.body.directives = method.body.directives;
	
		    this._pushConstructor();
		  };
	
		  ClassTransformer.prototype._pushConstructor = function _pushConstructor() {
		    if (this.pushedConstructor) return;
		    this.pushedConstructor = true;
	
		    if (this.hasInstanceDescriptors || this.hasStaticDescriptors) {
		      this.pushDescriptors();
		    }
	
		    this.body.push(this.constructor);
	
		    this.pushInherits();
		  };
	
		  ClassTransformer.prototype.pushInherits = function pushInherits() {
		    if (!this.isDerived || this.pushedInherits) return;
	
		    this.pushedInherits = true;
		    this.body.unshift(t.expressionStatement(t.callExpression(this.file.addHelper("inherits"), [this.classRef, this.superName])));
		  };
	
		  return ClassTransformer;
		}();
	
		exports.default = ClassTransformer;
		module.exports = exports["default"];
	
	/***/ }),
	/* 208 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _create = __webpack_require__(9);
	
		var _create2 = _interopRequireDefault(_create);
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _symbol = __webpack_require__(10);
	
		var _symbol2 = _interopRequireDefault(_symbol);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  var IGNORE_REASSIGNMENT_SYMBOL = (0, _symbol2.default)();
	
		  var reassignmentVisitor = {
		    "AssignmentExpression|UpdateExpression": function AssignmentExpressionUpdateExpression(path) {
		      if (path.node[IGNORE_REASSIGNMENT_SYMBOL]) return;
		      path.node[IGNORE_REASSIGNMENT_SYMBOL] = true;
	
		      var arg = path.get(path.isAssignmentExpression() ? "left" : "argument");
		      if (!arg.isIdentifier()) return;
	
		      var name = arg.node.name;
	
		      if (this.scope.getBinding(name) !== path.scope.getBinding(name)) return;
	
		      var exportedNames = this.exports[name];
		      if (!exportedNames) return;
	
		      var node = path.node;
	
		      var isPostUpdateExpression = path.isUpdateExpression() && !node.prefix;
		      if (isPostUpdateExpression) {
		        if (node.operator === "++") node = t.binaryExpression("+", node.argument, t.numericLiteral(1));else if (node.operator === "--") node = t.binaryExpression("-", node.argument, t.numericLiteral(1));else isPostUpdateExpression = false;
		      }
	
		      for (var _iterator = exportedNames, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		        var _ref2;
	
		        if (_isArray) {
		          if (_i >= _iterator.length) break;
		          _ref2 = _iterator[_i++];
		        } else {
		          _i = _iterator.next();
		          if (_i.done) break;
		          _ref2 = _i.value;
		        }
	
		        var exportedName = _ref2;
	
		        node = this.buildCall(exportedName, node).expression;
		      }
	
		      if (isPostUpdateExpression) node = t.sequenceExpression([node, path.node]);
	
		      path.replaceWith(node);
		    }
		  };
	
		  return {
		    visitor: {
		      CallExpression: function CallExpression(path, state) {
		        if (path.node.callee.type === TYPE_IMPORT) {
		          var contextIdent = state.contextIdent;
		          path.replaceWith(t.callExpression(t.memberExpression(contextIdent, t.identifier("import")), path.node.arguments));
		        }
		      },
		      ReferencedIdentifier: function ReferencedIdentifier(path, state) {
		        if (path.node.name == "__moduleName" && !path.scope.hasBinding("__moduleName")) {
		          path.replaceWith(t.memberExpression(state.contextIdent, t.identifier("id")));
		        }
		      },
	
		      Program: {
		        enter: function enter(path, state) {
		          state.contextIdent = path.scope.generateUidIdentifier("context");
		        },
		        exit: function exit(path, state) {
		          var exportIdent = path.scope.generateUidIdentifier("export");
		          var contextIdent = state.contextIdent;
	
		          var exportNames = (0, _create2.default)(null);
		          var modules = [];
	
		          var beforeBody = [];
		          var setters = [];
		          var sources = [];
		          var variableIds = [];
		          var removedPaths = [];
	
		          function addExportName(key, val) {
		            exportNames[key] = exportNames[key] || [];
		            exportNames[key].push(val);
		          }
	
		          function pushModule(source, key, specifiers) {
		            var module = void 0;
		            modules.forEach(function (m) {
		              if (m.key === source) {
		                module = m;
		              }
		            });
		            if (!module) {
		              modules.push(module = { key: source, imports: [], exports: [] });
		            }
		            module[key] = module[key].concat(specifiers);
		          }
	
		          function buildExportCall(name, val) {
		            return t.expressionStatement(t.callExpression(exportIdent, [t.stringLiteral(name), val]));
		          }
	
		          var body = path.get("body");
	
		          var canHoist = true;
		          for (var _iterator2 = body, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		            var _ref3;
	
		            if (_isArray2) {
		              if (_i2 >= _iterator2.length) break;
		              _ref3 = _iterator2[_i2++];
		            } else {
		              _i2 = _iterator2.next();
		              if (_i2.done) break;
		              _ref3 = _i2.value;
		            }
	
		            var _path = _ref3;
	
		            if (_path.isExportDeclaration()) _path = _path.get("declaration");
		            if (_path.isVariableDeclaration() && _path.node.kind !== "var") {
		              canHoist = false;
		              break;
		            }
		          }
	
		          for (var _iterator3 = body, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		            var _ref4;
	
		            if (_isArray3) {
		              if (_i3 >= _iterator3.length) break;
		              _ref4 = _iterator3[_i3++];
		            } else {
		              _i3 = _iterator3.next();
		              if (_i3.done) break;
		              _ref4 = _i3.value;
		            }
	
		            var _path2 = _ref4;
	
		            if (canHoist && _path2.isFunctionDeclaration()) {
		              beforeBody.push(_path2.node);
		              removedPaths.push(_path2);
		            } else if (_path2.isImportDeclaration()) {
		              var source = _path2.node.source.value;
		              pushModule(source, "imports", _path2.node.specifiers);
		              for (var name in _path2.getBindingIdentifiers()) {
		                _path2.scope.removeBinding(name);
		                variableIds.push(t.identifier(name));
		              }
		              _path2.remove();
		            } else if (_path2.isExportAllDeclaration()) {
		              pushModule(_path2.node.source.value, "exports", _path2.node);
		              _path2.remove();
		            } else if (_path2.isExportDefaultDeclaration()) {
		              var declar = _path2.get("declaration");
		              if (declar.isClassDeclaration() || declar.isFunctionDeclaration()) {
		                var id = declar.node.id;
		                var nodes = [];
	
		                if (id) {
		                  nodes.push(declar.node);
		                  nodes.push(buildExportCall("default", id));
		                  addExportName(id.name, "default");
		                } else {
		                  nodes.push(buildExportCall("default", t.toExpression(declar.node)));
		                }
	
		                if (!canHoist || declar.isClassDeclaration()) {
		                  _path2.replaceWithMultiple(nodes);
		                } else {
		                  beforeBody = beforeBody.concat(nodes);
		                  removedPaths.push(_path2);
		                }
		              } else {
		                _path2.replaceWith(buildExportCall("default", declar.node));
		              }
		            } else if (_path2.isExportNamedDeclaration()) {
		              var _declar = _path2.get("declaration");
	
		              if (_declar.node) {
		                _path2.replaceWith(_declar);
	
		                var _nodes = [];
		                var bindingIdentifiers = void 0;
		                if (_path2.isFunction()) {
		                  var node = _declar.node;
		                  var _name = node.id.name;
		                  if (canHoist) {
		                    addExportName(_name, _name);
		                    beforeBody.push(node);
		                    beforeBody.push(buildExportCall(_name, node.id));
		                    removedPaths.push(_path2);
		                  } else {
		                    var _bindingIdentifiers;
	
		                    bindingIdentifiers = (_bindingIdentifiers = {}, _bindingIdentifiers[_name] = node.id, _bindingIdentifiers);
		                  }
		                } else {
		                  bindingIdentifiers = _declar.getBindingIdentifiers();
		                }
		                for (var _name2 in bindingIdentifiers) {
		                  addExportName(_name2, _name2);
		                  _nodes.push(buildExportCall(_name2, t.identifier(_name2)));
		                }
		                _path2.insertAfter(_nodes);
		              } else {
		                var specifiers = _path2.node.specifiers;
		                if (specifiers && specifiers.length) {
		                  if (_path2.node.source) {
		                    pushModule(_path2.node.source.value, "exports", specifiers);
		                    _path2.remove();
		                  } else {
		                    var _nodes2 = [];
	
		                    for (var _iterator7 = specifiers, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : (0, _getIterator3.default)(_iterator7);;) {
		                      var _ref8;
	
		                      if (_isArray7) {
		                        if (_i7 >= _iterator7.length) break;
		                        _ref8 = _iterator7[_i7++];
		                      } else {
		                        _i7 = _iterator7.next();
		                        if (_i7.done) break;
		                        _ref8 = _i7.value;
		                      }
	
		                      var specifier = _ref8;
	
		                      _nodes2.push(buildExportCall(specifier.exported.name, specifier.local));
		                      addExportName(specifier.local.name, specifier.exported.name);
		                    }
	
		                    _path2.replaceWithMultiple(_nodes2);
		                  }
		                }
		              }
		            }
		          }
	
		          modules.forEach(function (specifiers) {
		            var setterBody = [];
		            var target = path.scope.generateUidIdentifier(specifiers.key);
	
		            for (var _iterator4 = specifiers.imports, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
		              var _ref5;
	
		              if (_isArray4) {
		                if (_i4 >= _iterator4.length) break;
		                _ref5 = _iterator4[_i4++];
		              } else {
		                _i4 = _iterator4.next();
		                if (_i4.done) break;
		                _ref5 = _i4.value;
		              }
	
		              var specifier = _ref5;
	
		              if (t.isImportNamespaceSpecifier(specifier)) {
		                setterBody.push(t.expressionStatement(t.assignmentExpression("=", specifier.local, target)));
		              } else if (t.isImportDefaultSpecifier(specifier)) {
		                specifier = t.importSpecifier(specifier.local, t.identifier("default"));
		              }
	
		              if (t.isImportSpecifier(specifier)) {
		                setterBody.push(t.expressionStatement(t.assignmentExpression("=", specifier.local, t.memberExpression(target, specifier.imported))));
		              }
		            }
	
		            if (specifiers.exports.length) {
		              var exportObjRef = path.scope.generateUidIdentifier("exportObj");
	
		              setterBody.push(t.variableDeclaration("var", [t.variableDeclarator(exportObjRef, t.objectExpression([]))]));
	
		              for (var _iterator5 = specifiers.exports, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : (0, _getIterator3.default)(_iterator5);;) {
		                var _ref6;
	
		                if (_isArray5) {
		                  if (_i5 >= _iterator5.length) break;
		                  _ref6 = _iterator5[_i5++];
		                } else {
		                  _i5 = _iterator5.next();
		                  if (_i5.done) break;
		                  _ref6 = _i5.value;
		                }
	
		                var node = _ref6;
	
		                if (t.isExportAllDeclaration(node)) {
		                  setterBody.push(buildExportAll({
		                    KEY: path.scope.generateUidIdentifier("key"),
		                    EXPORT_OBJ: exportObjRef,
		                    TARGET: target
		                  }));
		                } else if (t.isExportSpecifier(node)) {
		                  setterBody.push(t.expressionStatement(t.assignmentExpression("=", t.memberExpression(exportObjRef, node.exported), t.memberExpression(target, node.local))));
		                } else {}
		              }
	
		              setterBody.push(t.expressionStatement(t.callExpression(exportIdent, [exportObjRef])));
		            }
	
		            sources.push(t.stringLiteral(specifiers.key));
		            setters.push(t.functionExpression(null, [target], t.blockStatement(setterBody)));
		          });
	
		          var moduleName = this.getModuleName();
		          if (moduleName) moduleName = t.stringLiteral(moduleName);
	
		          if (canHoist) {
		            (0, _babelHelperHoistVariables2.default)(path, function (id) {
		              return variableIds.push(id);
		            });
		          }
	
		          if (variableIds.length) {
		            beforeBody.unshift(t.variableDeclaration("var", variableIds.map(function (id) {
		              return t.variableDeclarator(id);
		            })));
		          }
	
		          path.traverse(reassignmentVisitor, {
		            exports: exportNames,
		            buildCall: buildExportCall,
		            scope: path.scope
		          });
	
		          for (var _iterator6 = removedPaths, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : (0, _getIterator3.default)(_iterator6);;) {
		            var _ref7;
	
		            if (_isArray6) {
		              if (_i6 >= _iterator6.length) break;
		              _ref7 = _iterator6[_i6++];
		            } else {
		              _i6 = _iterator6.next();
		              if (_i6.done) break;
		              _ref7 = _i6.value;
		            }
	
		            var _path3 = _ref7;
	
		            _path3.remove();
		          }
	
		          path.node.body = [buildTemplate({
		            SYSTEM_REGISTER: t.memberExpression(t.identifier(state.opts.systemGlobal || "System"), t.identifier("register")),
		            BEFORE_BODY: beforeBody,
		            MODULE_NAME: moduleName,
		            SETTERS: setters,
		            SOURCES: sources,
		            BODY: path.node.body,
		            EXPORT_IDENTIFIER: exportIdent,
		            CONTEXT_IDENTIFIER: contextIdent
		          })];
		        }
		      }
		    }
		  };
		};
	
		var _babelHelperHoistVariables = __webpack_require__(190);
	
		var _babelHelperHoistVariables2 = _interopRequireDefault(_babelHelperHoistVariables);
	
		var _babelTemplate = __webpack_require__(4);
	
		var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var buildTemplate = (0, _babelTemplate2.default)("\n  SYSTEM_REGISTER(MODULE_NAME, [SOURCES], function (EXPORT_IDENTIFIER, CONTEXT_IDENTIFIER) {\n    \"use strict\";\n    BEFORE_BODY;\n    return {\n      setters: [SETTERS],\n      execute: function () {\n        BODY;\n      }\n    };\n  });\n");
	
		var buildExportAll = (0, _babelTemplate2.default)("\n  for (var KEY in TARGET) {\n    if (KEY !== \"default\" && KEY !== \"__esModule\") EXPORT_OBJ[KEY] = TARGET[KEY];\n  }\n");
	
		var TYPE_IMPORT = "Import";
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 209 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  function isValidDefine(path) {
		    if (!path.isExpressionStatement()) return;
	
		    var expr = path.get("expression");
		    if (!expr.isCallExpression()) return false;
		    if (!expr.get("callee").isIdentifier({ name: "define" })) return false;
	
		    var args = expr.get("arguments");
		    if (args.length === 3 && !args.shift().isStringLiteral()) return false;
		    if (args.length !== 2) return false;
		    if (!args.shift().isArrayExpression()) return false;
		    if (!args.shift().isFunctionExpression()) return false;
	
		    return true;
		  }
	
		  return {
		    inherits: __webpack_require__(131),
	
		    visitor: {
		      Program: {
		        exit: function exit(path, state) {
		          var last = path.get("body").pop();
		          if (!isValidDefine(last)) return;
	
		          var call = last.node.expression;
		          var args = call.arguments;
	
		          var moduleName = args.length === 3 ? args.shift() : null;
		          var amdArgs = call.arguments[0];
		          var func = call.arguments[1];
		          var browserGlobals = state.opts.globals || {};
	
		          var commonArgs = amdArgs.elements.map(function (arg) {
		            if (arg.value === "module" || arg.value === "exports") {
		              return t.identifier(arg.value);
		            } else {
		              return t.callExpression(t.identifier("require"), [arg]);
		            }
		          });
	
		          var browserArgs = amdArgs.elements.map(function (arg) {
		            if (arg.value === "module") {
		              return t.identifier("mod");
		            } else if (arg.value === "exports") {
		              return t.memberExpression(t.identifier("mod"), t.identifier("exports"));
		            } else {
		              var memberExpression = void 0;
	
		              if (state.opts.exactGlobals) {
		                var globalRef = browserGlobals[arg.value];
		                if (globalRef) {
		                  memberExpression = globalRef.split(".").reduce(function (accum, curr) {
		                    return t.memberExpression(accum, t.identifier(curr));
		                  }, t.identifier("global"));
		                } else {
		                  memberExpression = t.memberExpression(t.identifier("global"), t.identifier(t.toIdentifier(arg.value)));
		                }
		              } else {
		                var requireName = (0, _path.basename)(arg.value, (0, _path.extname)(arg.value));
		                var globalName = browserGlobals[requireName] || requireName;
		                memberExpression = t.memberExpression(t.identifier("global"), t.identifier(t.toIdentifier(globalName)));
		              }
	
		              return memberExpression;
		            }
		          });
	
		          var moduleNameOrBasename = moduleName ? moduleName.value : this.file.opts.basename;
		          var globalToAssign = t.memberExpression(t.identifier("global"), t.identifier(t.toIdentifier(moduleNameOrBasename)));
		          var prerequisiteAssignments = null;
	
		          if (state.opts.exactGlobals) {
		            var globalName = browserGlobals[moduleNameOrBasename];
	
		            if (globalName) {
		              prerequisiteAssignments = [];
	
		              var members = globalName.split(".");
		              globalToAssign = members.slice(1).reduce(function (accum, curr) {
		                prerequisiteAssignments.push(buildPrerequisiteAssignment({ GLOBAL_REFERENCE: accum }));
		                return t.memberExpression(accum, t.identifier(curr));
		              }, t.memberExpression(t.identifier("global"), t.identifier(members[0])));
		            }
		          }
	
		          var globalExport = buildGlobalExport({
		            BROWSER_ARGUMENTS: browserArgs,
		            PREREQUISITE_ASSIGNMENTS: prerequisiteAssignments,
		            GLOBAL_TO_ASSIGN: globalToAssign
		          });
	
		          last.replaceWith(buildWrapper({
		            MODULE_NAME: moduleName,
		            AMD_ARGUMENTS: amdArgs,
		            COMMON_ARGUMENTS: commonArgs,
		            GLOBAL_EXPORT: globalExport,
		            FUNC: func
		          }));
		        }
		      }
		    }
		  };
		};
	
		var _path = __webpack_require__(19);
	
		var _babelTemplate = __webpack_require__(4);
	
		var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var buildPrerequisiteAssignment = (0, _babelTemplate2.default)("\n  GLOBAL_REFERENCE = GLOBAL_REFERENCE || {}\n");
	
		var buildGlobalExport = (0, _babelTemplate2.default)("\n  var mod = { exports: {} };\n  factory(BROWSER_ARGUMENTS);\n  PREREQUISITE_ASSIGNMENTS\n  GLOBAL_TO_ASSIGN = mod.exports;\n");
	
		var buildWrapper = (0, _babelTemplate2.default)("\n  (function (global, factory) {\n    if (typeof define === \"function\" && define.amd) {\n      define(MODULE_NAME, AMD_ARGUMENTS, factory);\n    } else if (typeof exports !== \"undefined\") {\n      factory(COMMON_ARGUMENTS);\n    } else {\n      GLOBAL_EXPORT\n    }\n  })(this, FUNC);\n");
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 210 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  function build(node, nodes, scope) {
		    var first = node.specifiers[0];
		    if (!t.isExportNamespaceSpecifier(first) && !t.isExportDefaultSpecifier(first)) return;
	
		    var specifier = node.specifiers.shift();
		    var uid = scope.generateUidIdentifier(specifier.exported.name);
	
		    var newSpecifier = void 0;
		    if (t.isExportNamespaceSpecifier(specifier)) {
		      newSpecifier = t.importNamespaceSpecifier(uid);
		    } else {
		      newSpecifier = t.importDefaultSpecifier(uid);
		    }
	
		    nodes.push(t.importDeclaration([newSpecifier], node.source));
		    nodes.push(t.exportNamedDeclaration(null, [t.exportSpecifier(uid, specifier.exported)]));
	
		    build(node, nodes, scope);
		  }
	
		  return {
		    inherits: __webpack_require__(200),
	
		    visitor: {
		      ExportNamedDeclaration: function ExportNamedDeclaration(path) {
		        var node = path.node,
		            scope = path.scope;
	
		        var nodes = [];
		        build(node, nodes, scope);
		        if (!nodes.length) return;
	
		        if (node.specifiers.length >= 1) {
		          nodes.push(node);
		        }
		        path.replaceWithMultiple(nodes);
		      }
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 211 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  var FLOW_DIRECTIVE = "@flow";
	
		  return {
		    inherits: __webpack_require__(126),
	
		    visitor: {
		      Program: function Program(path, _ref2) {
		        var comments = _ref2.file.ast.comments;
	
		        for (var _iterator = comments, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		          var _ref3;
	
		          if (_isArray) {
		            if (_i >= _iterator.length) break;
		            _ref3 = _iterator[_i++];
		          } else {
		            _i = _iterator.next();
		            if (_i.done) break;
		            _ref3 = _i.value;
		          }
	
		          var comment = _ref3;
	
		          if (comment.value.indexOf(FLOW_DIRECTIVE) >= 0) {
		            comment.value = comment.value.replace(FLOW_DIRECTIVE, "");
	
		            if (!comment.value.replace(/\*/g, "").trim()) comment.ignore = true;
		          }
		        }
		      },
		      Flow: function Flow(path) {
		        path.remove();
		      },
		      ClassProperty: function ClassProperty(path) {
		        path.node.variance = null;
		        path.node.typeAnnotation = null;
		        if (!path.node.value) path.remove();
		      },
		      Class: function Class(path) {
		        path.node.implements = null;
	
		        path.get("body.body").forEach(function (child) {
		          if (child.isClassProperty()) {
		            child.node.typeAnnotation = null;
		            if (!child.node.value) child.remove();
		          }
		        });
		      },
		      AssignmentPattern: function AssignmentPattern(_ref4) {
		        var node = _ref4.node;
	
		        node.left.optional = false;
		      },
		      Function: function Function(_ref5) {
		        var node = _ref5.node;
	
		        for (var i = 0; i < node.params.length; i++) {
		          var param = node.params[i];
		          param.optional = false;
		        }
		      },
		      TypeCastExpression: function TypeCastExpression(path) {
		        var node = path.node;
	
		        do {
		          node = node.expression;
		        } while (t.isTypeCastExpression(node));
		        path.replaceWith(node);
		      }
		    }
		  };
		};
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 212 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  function getTempId(scope) {
		    var id = scope.path.getData("functionBind");
		    if (id) return id;
	
		    id = scope.generateDeclaredUidIdentifier("context");
		    return scope.path.setData("functionBind", id);
		  }
	
		  function getStaticContext(bind, scope) {
		    var object = bind.object || bind.callee.object;
		    return scope.isStatic(object) && object;
		  }
	
		  function inferBindContext(bind, scope) {
		    var staticContext = getStaticContext(bind, scope);
		    if (staticContext) return staticContext;
	
		    var tempId = getTempId(scope);
		    if (bind.object) {
		      bind.callee = t.sequenceExpression([t.assignmentExpression("=", tempId, bind.object), bind.callee]);
		    } else {
		      bind.callee.object = t.assignmentExpression("=", tempId, bind.callee.object);
		    }
		    return tempId;
		  }
	
		  return {
		    inherits: __webpack_require__(201),
	
		    visitor: {
		      CallExpression: function CallExpression(_ref2) {
		        var node = _ref2.node,
		            scope = _ref2.scope;
	
		        var bind = node.callee;
		        if (!t.isBindExpression(bind)) return;
	
		        var context = inferBindContext(bind, scope);
		        node.callee = t.memberExpression(bind.callee, t.identifier("call"));
		        node.arguments.unshift(context);
		      },
		      BindExpression: function BindExpression(path) {
		        var node = path.node,
		            scope = path.scope;
	
		        var context = inferBindContext(node, scope);
		        path.replaceWith(t.callExpression(t.memberExpression(node.callee, t.identifier("bind")), [context]));
		      }
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 213 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  function hasRestProperty(path) {
		    var foundRestProperty = false;
		    path.traverse({
		      RestProperty: function RestProperty() {
		        foundRestProperty = true;
		        path.stop();
		      }
		    });
		    return foundRestProperty;
		  }
	
		  function hasSpread(node) {
		    for (var _iterator = node.properties, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref2;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref2 = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref2 = _i.value;
		      }
	
		      var prop = _ref2;
	
		      if (t.isSpreadProperty(prop)) {
		        return true;
		      }
		    }
		    return false;
		  }
	
		  function createObjectSpread(file, props, objRef) {
		    var restProperty = props.pop();
	
		    var keys = [];
		    for (var _iterator2 = props, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		      var _ref3;
	
		      if (_isArray2) {
		        if (_i2 >= _iterator2.length) break;
		        _ref3 = _iterator2[_i2++];
		      } else {
		        _i2 = _iterator2.next();
		        if (_i2.done) break;
		        _ref3 = _i2.value;
		      }
	
		      var prop = _ref3;
	
		      var key = prop.key;
		      if (t.isIdentifier(key) && !prop.computed) {
		        key = t.stringLiteral(prop.key.name);
		      }
		      keys.push(key);
		    }
	
		    return [restProperty.argument, t.callExpression(file.addHelper("objectWithoutProperties"), [objRef, t.arrayExpression(keys)])];
		  }
	
		  function replaceRestProperty(parentPath, paramPath, i, numParams) {
		    if (paramPath.isAssignmentPattern()) {
		      replaceRestProperty(parentPath, paramPath.get("left"), i, numParams);
		      return;
		    }
	
		    if (paramPath.isObjectPattern() && hasRestProperty(paramPath)) {
		      var uid = parentPath.scope.generateUidIdentifier("ref");
	
		      var declar = t.variableDeclaration("let", [t.variableDeclarator(paramPath.node, uid)]);
		      declar._blockHoist = i ? numParams - i : 1;
	
		      parentPath.ensureBlock();
		      parentPath.get("body").unshiftContainer("body", declar);
		      paramPath.replaceWith(uid);
		    }
		  }
	
		  return {
		    inherits: __webpack_require__(202),
	
		    visitor: {
		      Function: function Function(path) {
		        var params = path.get("params");
		        for (var i = 0; i < params.length; i++) {
		          replaceRestProperty(params[i].parentPath, params[i], i, params.length);
		        }
		      },
		      VariableDeclarator: function VariableDeclarator(path, file) {
		        if (!path.get("id").isObjectPattern()) {
		          return;
		        }
	
		        var insertionPath = path;
	
		        path.get("id").traverse({
		          RestProperty: function RestProperty(path) {
		            if (this.originalPath.node.id.properties.length > 1 && !t.isIdentifier(this.originalPath.node.init)) {
		              var initRef = path.scope.generateUidIdentifierBasedOnNode(this.originalPath.node.init, "ref");
	
		              this.originalPath.insertBefore(t.variableDeclarator(initRef, this.originalPath.node.init));
	
		              this.originalPath.replaceWith(t.variableDeclarator(this.originalPath.node.id, initRef));
	
		              return;
		            }
	
		            var ref = this.originalPath.node.init;
		            var refPropertyPath = [];
	
		            path.findParent(function (path) {
		              if (path.isObjectProperty()) {
		                refPropertyPath.unshift(path.node.key.name);
		              } else if (path.isVariableDeclarator()) {
		                return true;
		              }
		            });
	
		            if (refPropertyPath.length) {
		              refPropertyPath.forEach(function (prop) {
		                ref = t.memberExpression(ref, t.identifier(prop));
		              });
		            }
	
		            var _createObjectSpread = createObjectSpread(file, path.parentPath.node.properties, ref),
		                argument = _createObjectSpread[0],
		                callExpression = _createObjectSpread[1];
	
		            insertionPath.insertAfter(t.variableDeclarator(argument, callExpression));
	
		            insertionPath = insertionPath.getSibling(insertionPath.key + 1);
	
		            if (path.parentPath.node.properties.length === 0) {
		              path.findParent(function (path) {
		                return path.isObjectProperty() || path.isVariableDeclarator();
		              }).remove();
		            }
		          }
		        }, {
		          originalPath: path
		        });
		      },
		      ExportNamedDeclaration: function ExportNamedDeclaration(path) {
		        var declaration = path.get("declaration");
		        if (!declaration.isVariableDeclaration()) return;
		        if (!hasRestProperty(declaration)) return;
	
		        var specifiers = [];
	
		        for (var name in path.getOuterBindingIdentifiers(path)) {
		          var id = t.identifier(name);
		          specifiers.push(t.exportSpecifier(id, id));
		        }
	
		        path.replaceWith(declaration.node);
		        path.insertAfter(t.exportNamedDeclaration(null, specifiers));
		      },
		      CatchClause: function CatchClause(path) {
		        var paramPath = path.get("param");
		        replaceRestProperty(paramPath.parentPath, paramPath);
		      },
		      AssignmentExpression: function AssignmentExpression(path, file) {
		        var leftPath = path.get("left");
		        if (leftPath.isObjectPattern() && hasRestProperty(leftPath)) {
		          var nodes = [];
	
		          var ref = void 0;
		          if (path.isCompletionRecord() || path.parentPath.isExpressionStatement()) {
		            ref = path.scope.generateUidIdentifierBasedOnNode(path.node.right, "ref");
	
		            nodes.push(t.variableDeclaration("var", [t.variableDeclarator(ref, path.node.right)]));
		          }
	
		          var _createObjectSpread2 = createObjectSpread(file, path.node.left.properties, ref),
		              argument = _createObjectSpread2[0],
		              callExpression = _createObjectSpread2[1];
	
		          var nodeWithoutSpread = t.clone(path.node);
		          nodeWithoutSpread.right = ref;
		          nodes.push(t.expressionStatement(nodeWithoutSpread));
		          nodes.push(t.toStatement(t.assignmentExpression("=", argument, callExpression)));
	
		          if (ref) {
		            nodes.push(t.expressionStatement(ref));
		          }
	
		          path.replaceWithMultiple(nodes);
		        }
		      },
		      ForXStatement: function ForXStatement(path) {
		        var node = path.node,
		            scope = path.scope;
	
		        var leftPath = path.get("left");
		        var left = node.left;
	
		        if (t.isObjectPattern(left) && hasRestProperty(leftPath)) {
		          var temp = scope.generateUidIdentifier("ref");
	
		          node.left = t.variableDeclaration("var", [t.variableDeclarator(temp)]);
	
		          path.ensureBlock();
	
		          node.body.body.unshift(t.variableDeclaration("var", [t.variableDeclarator(left, temp)]));
	
		          return;
		        }
	
		        if (!t.isVariableDeclaration(left)) return;
	
		        var pattern = left.declarations[0].id;
		        if (!t.isObjectPattern(pattern)) return;
	
		        var key = scope.generateUidIdentifier("ref");
		        node.left = t.variableDeclaration(left.kind, [t.variableDeclarator(key, null)]);
	
		        path.ensureBlock();
	
		        node.body.body.unshift(t.variableDeclaration(node.left.kind, [t.variableDeclarator(pattern, key)]));
		      },
		      ObjectExpression: function ObjectExpression(path, file) {
		        if (!hasSpread(path.node)) return;
	
		        var useBuiltIns = file.opts.useBuiltIns || false;
		        if (typeof useBuiltIns !== "boolean") {
		          throw new Error("transform-object-rest-spread currently only accepts a boolean " + "option for useBuiltIns (defaults to false)");
		        }
	
		        var args = [];
		        var props = [];
	
		        function push() {
		          if (!props.length) return;
		          args.push(t.objectExpression(props));
		          props = [];
		        }
	
		        for (var _iterator3 = path.node.properties, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		          var _ref4;
	
		          if (_isArray3) {
		            if (_i3 >= _iterator3.length) break;
		            _ref4 = _iterator3[_i3++];
		          } else {
		            _i3 = _iterator3.next();
		            if (_i3.done) break;
		            _ref4 = _i3.value;
		          }
	
		          var prop = _ref4;
	
		          if (t.isSpreadProperty(prop)) {
		            push();
		            args.push(prop.argument);
		          } else {
		            props.push(prop);
		          }
		        }
	
		        push();
	
		        if (!t.isObjectExpression(args[0])) {
		          args.unshift(t.objectExpression([]));
		        }
	
		        var helper = useBuiltIns ? t.memberExpression(t.identifier("Object"), t.identifier("assign")) : file.addHelper("extends");
	
		        path.replaceWith(t.callExpression(helper, args));
		      }
		    }
		  };
		};
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 214 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  function addDisplayName(id, call) {
		    var props = call.arguments[0].properties;
		    var safe = true;
	
		    for (var i = 0; i < props.length; i++) {
		      var prop = props[i];
		      var key = t.toComputedKey(prop);
		      if (t.isLiteral(key, { value: "displayName" })) {
		        safe = false;
		        break;
		      }
		    }
	
		    if (safe) {
		      props.unshift(t.objectProperty(t.identifier("displayName"), t.stringLiteral(id)));
		    }
		  }
	
		  var isCreateClassCallExpression = t.buildMatchMemberExpression("React.createClass");
		  var isCreateClassAddon = function isCreateClassAddon(callee) {
		    return callee.name === "createReactClass";
		  };
	
		  function isCreateClass(node) {
		    if (!node || !t.isCallExpression(node)) return false;
	
		    if (!isCreateClassCallExpression(node.callee) && !isCreateClassAddon(node.callee)) return false;
	
		    var args = node.arguments;
		    if (args.length !== 1) return false;
	
		    var first = args[0];
		    if (!t.isObjectExpression(first)) return false;
	
		    return true;
		  }
	
		  return {
		    visitor: {
		      ExportDefaultDeclaration: function ExportDefaultDeclaration(_ref2, state) {
		        var node = _ref2.node;
	
		        if (isCreateClass(node.declaration)) {
		          var displayName = state.file.opts.basename;
	
		          if (displayName === "index") {
		            displayName = _path2.default.basename(_path2.default.dirname(state.file.opts.filename));
		          }
	
		          addDisplayName(displayName, node.declaration);
		        }
		      },
		      CallExpression: function CallExpression(path) {
		        var node = path.node;
	
		        if (!isCreateClass(node)) return;
	
		        var id = void 0;
	
		        path.find(function (path) {
		          if (path.isAssignmentExpression()) {
		            id = path.node.left;
		          } else if (path.isObjectProperty()) {
		            id = path.node.key;
		          } else if (path.isVariableDeclarator()) {
		            id = path.node.id;
		          } else if (path.isStatement()) {
		            return true;
		          }
	
		          if (id) return true;
		        });
	
		        if (!id) return;
	
		        if (t.isMemberExpression(id)) {
		          id = id.property;
		        }
	
		        if (t.isIdentifier(id)) {
		          addDisplayName(id.name, node);
		        }
		      }
		    }
		  };
		};
	
		var _path = __webpack_require__(19);
	
		var _path2 = _interopRequireDefault(_path);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 215 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  var JSX_ANNOTATION_REGEX = /\*?\s*@jsx\s+([^\s]+)/;
	
		  var visitor = (0, _babelHelperBuilderReactJsx2.default)({
		    pre: function pre(state) {
		      var tagName = state.tagName;
		      var args = state.args;
		      if (t.react.isCompatTag(tagName)) {
		        args.push(t.stringLiteral(tagName));
		      } else {
		        args.push(state.tagExpr);
		      }
		    },
		    post: function post(state, pass) {
		      state.callee = pass.get("jsxIdentifier")();
		    }
		  });
	
		  visitor.Program = function (path, state) {
		    var file = state.file;
	
		    var id = state.opts.pragma || "React.createElement";
	
		    for (var _iterator = file.ast.comments, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref2;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref2 = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref2 = _i.value;
		      }
	
		      var comment = _ref2;
	
		      var matches = JSX_ANNOTATION_REGEX.exec(comment.value);
		      if (matches) {
		        id = matches[1];
		        if (id === "React.DOM") {
		          throw file.buildCodeFrameError(comment, "The @jsx React.DOM pragma has been deprecated as of React 0.12");
		        } else {
		          break;
		        }
		      }
		    }
	
		    state.set("jsxIdentifier", function () {
		      return id.split(".").map(function (name) {
		        return t.identifier(name);
		      }).reduce(function (object, property) {
		        return t.memberExpression(object, property);
		      });
		    });
		  };
	
		  return {
		    inherits: _babelPluginSyntaxJsx2.default,
		    visitor: visitor
		  };
		};
	
		var _babelPluginSyntaxJsx = __webpack_require__(127);
	
		var _babelPluginSyntaxJsx2 = _interopRequireDefault(_babelPluginSyntaxJsx);
	
		var _babelHelperBuilderReactJsx = __webpack_require__(351);
	
		var _babelHelperBuilderReactJsx2 = _interopRequireDefault(_babelHelperBuilderReactJsx);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 216 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function () {
		  return {
		    visitor: {
		      Program: function Program(path, state) {
		        if (state.opts.strict === false || state.opts.strictMode === false) return;
	
		        var node = path.node;
	
		        for (var _iterator = node.directives, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		          var _ref;
	
		          if (_isArray) {
		            if (_i >= _iterator.length) break;
		            _ref = _iterator[_i++];
		          } else {
		            _i = _iterator.next();
		            if (_i.done) break;
		            _ref = _i.value;
		          }
	
		          var directive = _ref;
	
		          if (directive.value.value === "use strict") return;
		        }
	
		        path.unshiftContainer("directives", t.directive(t.directiveLiteral("use strict")));
		      }
		    }
		  };
		};
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 217 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _babelPluginTransformEs2015TemplateLiterals = __webpack_require__(83);
	
		var _babelPluginTransformEs2015TemplateLiterals2 = _interopRequireDefault(_babelPluginTransformEs2015TemplateLiterals);
	
		var _babelPluginTransformEs2015Literals = __webpack_require__(76);
	
		var _babelPluginTransformEs2015Literals2 = _interopRequireDefault(_babelPluginTransformEs2015Literals);
	
		var _babelPluginTransformEs2015FunctionName = __webpack_require__(75);
	
		var _babelPluginTransformEs2015FunctionName2 = _interopRequireDefault(_babelPluginTransformEs2015FunctionName);
	
		var _babelPluginTransformEs2015ArrowFunctions = __webpack_require__(68);
	
		var _babelPluginTransformEs2015ArrowFunctions2 = _interopRequireDefault(_babelPluginTransformEs2015ArrowFunctions);
	
		var _babelPluginTransformEs2015BlockScopedFunctions = __webpack_require__(69);
	
		var _babelPluginTransformEs2015BlockScopedFunctions2 = _interopRequireDefault(_babelPluginTransformEs2015BlockScopedFunctions);
	
		var _babelPluginTransformEs2015Classes = __webpack_require__(71);
	
		var _babelPluginTransformEs2015Classes2 = _interopRequireDefault(_babelPluginTransformEs2015Classes);
	
		var _babelPluginTransformEs2015ObjectSuper = __webpack_require__(78);
	
		var _babelPluginTransformEs2015ObjectSuper2 = _interopRequireDefault(_babelPluginTransformEs2015ObjectSuper);
	
		var _babelPluginTransformEs2015ShorthandProperties = __webpack_require__(80);
	
		var _babelPluginTransformEs2015ShorthandProperties2 = _interopRequireDefault(_babelPluginTransformEs2015ShorthandProperties);
	
		var _babelPluginTransformEs2015DuplicateKeys = __webpack_require__(130);
	
		var _babelPluginTransformEs2015DuplicateKeys2 = _interopRequireDefault(_babelPluginTransformEs2015DuplicateKeys);
	
		var _babelPluginTransformEs2015ComputedProperties = __webpack_require__(72);
	
		var _babelPluginTransformEs2015ComputedProperties2 = _interopRequireDefault(_babelPluginTransformEs2015ComputedProperties);
	
		var _babelPluginTransformEs2015ForOf = __webpack_require__(74);
	
		var _babelPluginTransformEs2015ForOf2 = _interopRequireDefault(_babelPluginTransformEs2015ForOf);
	
		var _babelPluginTransformEs2015StickyRegex = __webpack_require__(82);
	
		var _babelPluginTransformEs2015StickyRegex2 = _interopRequireDefault(_babelPluginTransformEs2015StickyRegex);
	
		var _babelPluginTransformEs2015UnicodeRegex = __webpack_require__(85);
	
		var _babelPluginTransformEs2015UnicodeRegex2 = _interopRequireDefault(_babelPluginTransformEs2015UnicodeRegex);
	
		var _babelPluginCheckEs2015Constants = __webpack_require__(66);
	
		var _babelPluginCheckEs2015Constants2 = _interopRequireDefault(_babelPluginCheckEs2015Constants);
	
		var _babelPluginTransformEs2015Spread = __webpack_require__(81);
	
		var _babelPluginTransformEs2015Spread2 = _interopRequireDefault(_babelPluginTransformEs2015Spread);
	
		var _babelPluginTransformEs2015Parameters = __webpack_require__(79);
	
		var _babelPluginTransformEs2015Parameters2 = _interopRequireDefault(_babelPluginTransformEs2015Parameters);
	
		var _babelPluginTransformEs2015Destructuring = __webpack_require__(73);
	
		var _babelPluginTransformEs2015Destructuring2 = _interopRequireDefault(_babelPluginTransformEs2015Destructuring);
	
		var _babelPluginTransformEs2015BlockScoping = __webpack_require__(70);
	
		var _babelPluginTransformEs2015BlockScoping2 = _interopRequireDefault(_babelPluginTransformEs2015BlockScoping);
	
		var _babelPluginTransformEs2015TypeofSymbol = __webpack_require__(84);
	
		var _babelPluginTransformEs2015TypeofSymbol2 = _interopRequireDefault(_babelPluginTransformEs2015TypeofSymbol);
	
		var _babelPluginTransformEs2015ModulesCommonjs = __webpack_require__(77);
	
		var _babelPluginTransformEs2015ModulesCommonjs2 = _interopRequireDefault(_babelPluginTransformEs2015ModulesCommonjs);
	
		var _babelPluginTransformEs2015ModulesSystemjs = __webpack_require__(208);
	
		var _babelPluginTransformEs2015ModulesSystemjs2 = _interopRequireDefault(_babelPluginTransformEs2015ModulesSystemjs);
	
		var _babelPluginTransformEs2015ModulesAmd = __webpack_require__(131);
	
		var _babelPluginTransformEs2015ModulesAmd2 = _interopRequireDefault(_babelPluginTransformEs2015ModulesAmd);
	
		var _babelPluginTransformEs2015ModulesUmd = __webpack_require__(209);
	
		var _babelPluginTransformEs2015ModulesUmd2 = _interopRequireDefault(_babelPluginTransformEs2015ModulesUmd);
	
		var _babelPluginTransformRegenerator = __webpack_require__(86);
	
		var _babelPluginTransformRegenerator2 = _interopRequireDefault(_babelPluginTransformRegenerator);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function preset(context) {
		  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		  var moduleTypes = ["commonjs", "amd", "umd", "systemjs"];
		  var loose = false;
		  var modules = "commonjs";
		  var spec = false;
	
		  if (opts !== undefined) {
		    if (opts.loose !== undefined) loose = opts.loose;
		    if (opts.modules !== undefined) modules = opts.modules;
		    if (opts.spec !== undefined) spec = opts.spec;
		  }
	
		  if (typeof loose !== "boolean") throw new Error("Preset es2015 'loose' option must be a boolean.");
		  if (typeof spec !== "boolean") throw new Error("Preset es2015 'spec' option must be a boolean.");
		  if (modules !== false && moduleTypes.indexOf(modules) === -1) {
		    throw new Error("Preset es2015 'modules' option must be 'false' to indicate no modules\n" + "or a module type which be be one of: 'commonjs' (default), 'amd', 'umd', 'systemjs'");
		  }
	
		  var optsLoose = { loose: loose };
	
		  return {
		    plugins: [[_babelPluginTransformEs2015TemplateLiterals2.default, { loose: loose, spec: spec }], _babelPluginTransformEs2015Literals2.default, _babelPluginTransformEs2015FunctionName2.default, [_babelPluginTransformEs2015ArrowFunctions2.default, { spec: spec }], _babelPluginTransformEs2015BlockScopedFunctions2.default, [_babelPluginTransformEs2015Classes2.default, optsLoose], _babelPluginTransformEs2015ObjectSuper2.default, _babelPluginTransformEs2015ShorthandProperties2.default, _babelPluginTransformEs2015DuplicateKeys2.default, [_babelPluginTransformEs2015ComputedProperties2.default, optsLoose], [_babelPluginTransformEs2015ForOf2.default, optsLoose], _babelPluginTransformEs2015StickyRegex2.default, _babelPluginTransformEs2015UnicodeRegex2.default, _babelPluginCheckEs2015Constants2.default, [_babelPluginTransformEs2015Spread2.default, optsLoose], _babelPluginTransformEs2015Parameters2.default, [_babelPluginTransformEs2015Destructuring2.default, optsLoose], _babelPluginTransformEs2015BlockScoping2.default, _babelPluginTransformEs2015TypeofSymbol2.default, modules === "commonjs" && [_babelPluginTransformEs2015ModulesCommonjs2.default, optsLoose], modules === "systemjs" && [_babelPluginTransformEs2015ModulesSystemjs2.default, optsLoose], modules === "amd" && [_babelPluginTransformEs2015ModulesAmd2.default, optsLoose], modules === "umd" && [_babelPluginTransformEs2015ModulesUmd2.default, optsLoose], [_babelPluginTransformRegenerator2.default, { async: false, asyncGenerators: false }]].filter(Boolean) };
		}
	
		var oldConfig = preset({});
	
		exports.default = oldConfig;
	
		Object.defineProperty(oldConfig, "buildPreset", {
		  configurable: true,
		  writable: true,
	
		  enumerable: false,
		  value: preset
		});
		module.exports = exports["default"];
	
	/***/ }),
	/* 218 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _babelPluginTransformExponentiationOperator = __webpack_require__(132);
	
		var _babelPluginTransformExponentiationOperator2 = _interopRequireDefault(_babelPluginTransformExponentiationOperator);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		exports.default = {
		  plugins: [_babelPluginTransformExponentiationOperator2.default]
		};
		module.exports = exports["default"];
	
	/***/ }),
	/* 219 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _babelPluginSyntaxTrailingFunctionCommas = __webpack_require__(128);
	
		var _babelPluginSyntaxTrailingFunctionCommas2 = _interopRequireDefault(_babelPluginSyntaxTrailingFunctionCommas);
	
		var _babelPluginTransformAsyncToGenerator = __webpack_require__(129);
	
		var _babelPluginTransformAsyncToGenerator2 = _interopRequireDefault(_babelPluginTransformAsyncToGenerator);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		exports.default = {
		  plugins: [_babelPluginSyntaxTrailingFunctionCommas2.default, _babelPluginTransformAsyncToGenerator2.default]
		};
		module.exports = exports["default"];
	
	/***/ }),
	/* 220 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _babelPresetStage = __webpack_require__(221);
	
		var _babelPresetStage2 = _interopRequireDefault(_babelPresetStage);
	
		var _babelPluginTransformClassConstructorCall = __webpack_require__(203);
	
		var _babelPluginTransformClassConstructorCall2 = _interopRequireDefault(_babelPluginTransformClassConstructorCall);
	
		var _babelPluginTransformExportExtensions = __webpack_require__(210);
	
		var _babelPluginTransformExportExtensions2 = _interopRequireDefault(_babelPluginTransformExportExtensions);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		exports.default = {
		  presets: [_babelPresetStage2.default],
		  plugins: [_babelPluginTransformClassConstructorCall2.default, _babelPluginTransformExportExtensions2.default]
		};
		module.exports = exports["default"];
	
	/***/ }),
	/* 221 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _babelPresetStage = __webpack_require__(222);
	
		var _babelPresetStage2 = _interopRequireDefault(_babelPresetStage);
	
		var _babelPluginTransformClassProperties = __webpack_require__(204);
	
		var _babelPluginTransformClassProperties2 = _interopRequireDefault(_babelPluginTransformClassProperties);
	
		var _babelPluginTransformDecorators = __webpack_require__(205);
	
		var _babelPluginTransformDecorators2 = _interopRequireDefault(_babelPluginTransformDecorators);
	
		var _babelPluginSyntaxDynamicImport = __webpack_require__(324);
	
		var _babelPluginSyntaxDynamicImport2 = _interopRequireDefault(_babelPluginSyntaxDynamicImport);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		exports.default = {
		  presets: [_babelPresetStage2.default],
		  plugins: [_babelPluginSyntaxDynamicImport2.default, _babelPluginTransformClassProperties2.default, _babelPluginTransformDecorators2.default]
		};
		module.exports = exports["default"];
	
	/***/ }),
	/* 222 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _babelPluginSyntaxTrailingFunctionCommas = __webpack_require__(128);
	
		var _babelPluginSyntaxTrailingFunctionCommas2 = _interopRequireDefault(_babelPluginSyntaxTrailingFunctionCommas);
	
		var _babelPluginTransformAsyncToGenerator = __webpack_require__(129);
	
		var _babelPluginTransformAsyncToGenerator2 = _interopRequireDefault(_babelPluginTransformAsyncToGenerator);
	
		var _babelPluginTransformExponentiationOperator = __webpack_require__(132);
	
		var _babelPluginTransformExponentiationOperator2 = _interopRequireDefault(_babelPluginTransformExponentiationOperator);
	
		var _babelPluginTransformObjectRestSpread = __webpack_require__(213);
	
		var _babelPluginTransformObjectRestSpread2 = _interopRequireDefault(_babelPluginTransformObjectRestSpread);
	
		var _babelPluginTransformAsyncGeneratorFunctions = __webpack_require__(327);
	
		var _babelPluginTransformAsyncGeneratorFunctions2 = _interopRequireDefault(_babelPluginTransformAsyncGeneratorFunctions);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		exports.default = {
		  plugins: [_babelPluginSyntaxTrailingFunctionCommas2.default, _babelPluginTransformAsyncToGenerator2.default, _babelPluginTransformExponentiationOperator2.default, _babelPluginTransformAsyncGeneratorFunctions2.default, _babelPluginTransformObjectRestSpread2.default]
		};
		module.exports = exports["default"];
	
	/***/ }),
	/* 223 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var Hub = function Hub(file, options) {
		  (0, _classCallCheck3.default)(this, Hub);
	
		  this.file = file;
		  this.options = options;
		};
	
		exports.default = Hub;
		module.exports = exports["default"];
	
	/***/ }),
	/* 224 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.Flow = exports.Pure = exports.Generated = exports.User = exports.Var = exports.BlockScoped = exports.Referenced = exports.Scope = exports.Expression = exports.Statement = exports.BindingIdentifier = exports.ReferencedMemberExpression = exports.ReferencedIdentifier = undefined;
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		var ReferencedIdentifier = exports.ReferencedIdentifier = {
		  types: ["Identifier", "JSXIdentifier"],
		  checkPath: function checkPath(_ref, opts) {
		    var node = _ref.node,
		        parent = _ref.parent;
	
		    if (!t.isIdentifier(node, opts) && !t.isJSXMemberExpression(parent, opts)) {
		      if (t.isJSXIdentifier(node, opts)) {
		        if (_babelTypes.react.isCompatTag(node.name)) return false;
		      } else {
		        return false;
		      }
		    }
	
		    return t.isReferenced(node, parent);
		  }
		};
	
		var ReferencedMemberExpression = exports.ReferencedMemberExpression = {
		  types: ["MemberExpression"],
		  checkPath: function checkPath(_ref2) {
		    var node = _ref2.node,
		        parent = _ref2.parent;
	
		    return t.isMemberExpression(node) && t.isReferenced(node, parent);
		  }
		};
	
		var BindingIdentifier = exports.BindingIdentifier = {
		  types: ["Identifier"],
		  checkPath: function checkPath(_ref3) {
		    var node = _ref3.node,
		        parent = _ref3.parent;
	
		    return t.isIdentifier(node) && t.isBinding(node, parent);
		  }
		};
	
		var Statement = exports.Statement = {
		  types: ["Statement"],
		  checkPath: function checkPath(_ref4) {
		    var node = _ref4.node,
		        parent = _ref4.parent;
	
		    if (t.isStatement(node)) {
		      if (t.isVariableDeclaration(node)) {
		        if (t.isForXStatement(parent, { left: node })) return false;
		        if (t.isForStatement(parent, { init: node })) return false;
		      }
	
		      return true;
		    } else {
		      return false;
		    }
		  }
		};
	
		var Expression = exports.Expression = {
		  types: ["Expression"],
		  checkPath: function checkPath(path) {
		    if (path.isIdentifier()) {
		      return path.isReferencedIdentifier();
		    } else {
		      return t.isExpression(path.node);
		    }
		  }
		};
	
		var Scope = exports.Scope = {
		  types: ["Scopable"],
		  checkPath: function checkPath(path) {
		    return t.isScope(path.node, path.parent);
		  }
		};
	
		var Referenced = exports.Referenced = {
		  checkPath: function checkPath(path) {
		    return t.isReferenced(path.node, path.parent);
		  }
		};
	
		var BlockScoped = exports.BlockScoped = {
		  checkPath: function checkPath(path) {
		    return t.isBlockScoped(path.node);
		  }
		};
	
		var Var = exports.Var = {
		  types: ["VariableDeclaration"],
		  checkPath: function checkPath(path) {
		    return t.isVar(path.node);
		  }
		};
	
		var User = exports.User = {
		  checkPath: function checkPath(path) {
		    return path.node && !!path.node.loc;
		  }
		};
	
		var Generated = exports.Generated = {
		  checkPath: function checkPath(path) {
		    return !path.isUser();
		  }
		};
	
		var Pure = exports.Pure = {
		  checkPath: function checkPath(path, opts) {
		    return path.scope.isPure(path.node, opts);
		  }
		};
	
		var Flow = exports.Flow = {
		  types: ["Flow", "ImportDeclaration", "ExportDeclaration", "ImportSpecifier"],
		  checkPath: function checkPath(_ref5) {
		    var node = _ref5.node;
	
		    if (t.isFlow(node)) {
		      return true;
		    } else if (t.isImportDeclaration(node)) {
		      return node.importKind === "type" || node.importKind === "typeof";
		    } else if (t.isExportDeclaration(node)) {
		      return node.exportKind === "type";
		    } else if (t.isImportSpecifier(node)) {
		      return node.importKind === "type" || node.importKind === "typeof";
		    } else {
		      return false;
		    }
		  }
		};
	
	/***/ }),
	/* 225 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var Binding = function () {
		  function Binding(_ref) {
		    var existing = _ref.existing,
		        identifier = _ref.identifier,
		        scope = _ref.scope,
		        path = _ref.path,
		        kind = _ref.kind;
		    (0, _classCallCheck3.default)(this, Binding);
	
		    this.identifier = identifier;
		    this.scope = scope;
		    this.path = path;
		    this.kind = kind;
	
		    this.constantViolations = [];
		    this.constant = true;
	
		    this.referencePaths = [];
		    this.referenced = false;
		    this.references = 0;
	
		    this.clearValue();
	
		    if (existing) {
		      this.constantViolations = [].concat(existing.path, existing.constantViolations, this.constantViolations);
		    }
		  }
	
		  Binding.prototype.deoptValue = function deoptValue() {
		    this.clearValue();
		    this.hasDeoptedValue = true;
		  };
	
		  Binding.prototype.setValue = function setValue(value) {
		    if (this.hasDeoptedValue) return;
		    this.hasValue = true;
		    this.value = value;
		  };
	
		  Binding.prototype.clearValue = function clearValue() {
		    this.hasDeoptedValue = false;
		    this.hasValue = false;
		    this.value = null;
		  };
	
		  Binding.prototype.reassign = function reassign(path) {
		    this.constant = false;
		    if (this.constantViolations.indexOf(path) !== -1) {
		      return;
		    }
		    this.constantViolations.push(path);
		  };
	
		  Binding.prototype.reference = function reference(path) {
		    if (this.referencePaths.indexOf(path) !== -1) {
		      return;
		    }
		    this.referenced = true;
		    this.references++;
		    this.referencePaths.push(path);
		  };
	
		  Binding.prototype.dereference = function dereference() {
		    this.references--;
		    this.referenced = !!this.references;
		  };
	
		  return Binding;
		}();
	
		exports.default = Binding;
		module.exports = exports["default"];
	
	/***/ }),
	/* 226 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _create = __webpack_require__(9);
	
		var _create2 = _interopRequireDefault(_create);
	
		exports.getBindingIdentifiers = getBindingIdentifiers;
		exports.getOuterBindingIdentifiers = getOuterBindingIdentifiers;
	
		var _index = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_index);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function getBindingIdentifiers(node, duplicates, outerOnly) {
		  var search = [].concat(node);
		  var ids = (0, _create2.default)(null);
	
		  while (search.length) {
		    var id = search.shift();
		    if (!id) continue;
	
		    var keys = t.getBindingIdentifiers.keys[id.type];
	
		    if (t.isIdentifier(id)) {
		      if (duplicates) {
		        var _ids = ids[id.name] = ids[id.name] || [];
		        _ids.push(id);
		      } else {
		        ids[id.name] = id;
		      }
		      continue;
		    }
	
		    if (t.isExportDeclaration(id)) {
		      if (t.isDeclaration(id.declaration)) {
		        search.push(id.declaration);
		      }
		      continue;
		    }
	
		    if (outerOnly) {
		      if (t.isFunctionDeclaration(id)) {
		        search.push(id.id);
		        continue;
		      }
	
		      if (t.isFunctionExpression(id)) {
		        continue;
		      }
		    }
	
		    if (keys) {
		      for (var i = 0; i < keys.length; i++) {
		        var key = keys[i];
		        if (id[key]) {
		          search = search.concat(id[key]);
		        }
		      }
		    }
		  }
	
		  return ids;
		}
	
		getBindingIdentifiers.keys = {
		  DeclareClass: ["id"],
		  DeclareFunction: ["id"],
		  DeclareModule: ["id"],
		  DeclareVariable: ["id"],
		  InterfaceDeclaration: ["id"],
		  TypeAlias: ["id"],
		  OpaqueType: ["id"],
	
		  CatchClause: ["param"],
		  LabeledStatement: ["label"],
		  UnaryExpression: ["argument"],
		  AssignmentExpression: ["left"],
	
		  ImportSpecifier: ["local"],
		  ImportNamespaceSpecifier: ["local"],
		  ImportDefaultSpecifier: ["local"],
		  ImportDeclaration: ["specifiers"],
	
		  ExportSpecifier: ["exported"],
		  ExportNamespaceSpecifier: ["exported"],
		  ExportDefaultSpecifier: ["exported"],
	
		  FunctionDeclaration: ["id", "params"],
		  FunctionExpression: ["id", "params"],
	
		  ClassDeclaration: ["id"],
		  ClassExpression: ["id"],
	
		  RestElement: ["argument"],
		  UpdateExpression: ["argument"],
	
		  RestProperty: ["argument"],
		  ObjectProperty: ["value"],
	
		  AssignmentPattern: ["left"],
		  ArrayPattern: ["elements"],
		  ObjectPattern: ["properties"],
	
		  VariableDeclaration: ["declarations"],
		  VariableDeclarator: ["id"]
		};
	
		function getOuterBindingIdentifiers(node, duplicates) {
		  return getBindingIdentifiers(node, duplicates, true);
		}
	
	/***/ }),
	/* 227 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		module.exports = function (it) {
		  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
		  return it;
		};
	
	/***/ }),
	/* 228 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// getting tag from 19.1.3.6 Object.prototype.toString()
		var cof = __webpack_require__(138);
		var TAG = __webpack_require__(13)('toStringTag');
		// ES3 wrong here
		var ARG = cof(function () {
		  return arguments;
		}()) == 'Arguments';
	
		// fallback for IE11 Script Access Denied error
		var tryGet = function tryGet(it, key) {
		  try {
		    return it[key];
		  } catch (e) {/* empty */}
		};
	
		module.exports = function (it) {
		  var O, T, B;
		  return it === undefined ? 'Undefined' : it === null ? 'Null'
		  // @@toStringTag case
		  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
		  // builtinTag case
		  : ARG ? cof(O)
		  // ES3 arguments fallback
		  : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
		};
	
	/***/ }),
	/* 229 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var redefineAll = __webpack_require__(146);
		var getWeak = __webpack_require__(57).getWeak;
		var anObject = __webpack_require__(21);
		var isObject = __webpack_require__(16);
		var anInstance = __webpack_require__(136);
		var forOf = __webpack_require__(55);
		var createArrayMethod = __webpack_require__(137);
		var $has = __webpack_require__(28);
		var validate = __webpack_require__(58);
		var arrayFind = createArrayMethod(5);
		var arrayFindIndex = createArrayMethod(6);
		var id = 0;
	
		// fallback for uncaught frozen keys
		var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
		  return that._l || (that._l = new UncaughtFrozenStore());
		};
		var UncaughtFrozenStore = function UncaughtFrozenStore() {
		  this.a = [];
		};
		var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
		  return arrayFind(store.a, function (it) {
		    return it[0] === key;
		  });
		};
		UncaughtFrozenStore.prototype = {
		  get: function get(key) {
		    var entry = findUncaughtFrozen(this, key);
		    if (entry) return entry[1];
		  },
		  has: function has(key) {
		    return !!findUncaughtFrozen(this, key);
		  },
		  set: function set(key, value) {
		    var entry = findUncaughtFrozen(this, key);
		    if (entry) entry[1] = value;else this.a.push([key, value]);
		  },
		  'delete': function _delete(key) {
		    var index = arrayFindIndex(this.a, function (it) {
		      return it[0] === key;
		    });
		    if (~index) this.a.splice(index, 1);
		    return !!~index;
		  }
		};
	
		module.exports = {
		  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
		    var C = wrapper(function (that, iterable) {
		      anInstance(that, C, NAME, '_i');
		      that._t = NAME; // collection type
		      that._i = id++; // collection id
		      that._l = undefined; // leak store for uncaught frozen objects
		      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
		    });
		    redefineAll(C.prototype, {
		      // 23.3.3.2 WeakMap.prototype.delete(key)
		      // 23.4.3.3 WeakSet.prototype.delete(value)
		      'delete': function _delete(key) {
		        if (!isObject(key)) return false;
		        var data = getWeak(key);
		        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
		        return data && $has(data, this._i) && delete data[this._i];
		      },
		      // 23.3.3.4 WeakMap.prototype.has(key)
		      // 23.4.3.4 WeakSet.prototype.has(value)
		      has: function has(key) {
		        if (!isObject(key)) return false;
		        var data = getWeak(key);
		        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
		        return data && $has(data, this._i);
		      }
		    });
		    return C;
		  },
		  def: function def(that, key, value) {
		    var data = getWeak(anObject(key), true);
		    if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
		    return that;
		  },
		  ufstore: uncaughtFrozenStore
		};
	
	/***/ }),
	/* 230 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isObject = __webpack_require__(16);
		var document = __webpack_require__(15).document;
		// typeof document.createElement is 'object' in old IE
		var is = isObject(document) && isObject(document.createElement);
		module.exports = function (it) {
		  return is ? document.createElement(it) : {};
		};
	
	/***/ }),
	/* 231 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = !__webpack_require__(22) && !__webpack_require__(27)(function () {
		  return Object.defineProperty(__webpack_require__(230)('div'), 'a', { get: function get() {
		      return 7;
		    } }).a != 7;
		});
	
	/***/ }),
	/* 232 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// 7.2.2 IsArray(argument)
		var cof = __webpack_require__(138);
		module.exports = Array.isArray || function isArray(arg) {
		  return cof(arg) == 'Array';
		};
	
	/***/ }),
	/* 233 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		module.exports = function (done, value) {
		  return { value: value, done: !!done };
		};
	
	/***/ }),
	/* 234 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		// 19.1.2.1 Object.assign(target, source, ...)
	
		var getKeys = __webpack_require__(44);
		var gOPS = __webpack_require__(145);
		var pIE = __webpack_require__(91);
		var toObject = __webpack_require__(94);
		var IObject = __webpack_require__(142);
		var $assign = Object.assign;
	
		// should work with symbols and should have deterministic property order (V8 bug)
		module.exports = !$assign || __webpack_require__(27)(function () {
		  var A = {};
		  var B = {};
		  // eslint-disable-next-line no-undef
		  var S = Symbol();
		  var K = 'abcdefghijklmnopqrst';
		  A[S] = 7;
		  K.split('').forEach(function (k) {
		    B[k] = k;
		  });
		  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
		}) ? function assign(target, source) {
		  // eslint-disable-line no-unused-vars
		  var T = toObject(target);
		  var aLen = arguments.length;
		  var index = 1;
		  var getSymbols = gOPS.f;
		  var isEnum = pIE.f;
		  while (aLen > index) {
		    var S = IObject(arguments[index++]);
		    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
		    var length = keys.length;
		    var j = 0;
		    var key;
		    while (length > j) {
		      if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
		    }
		  }return T;
		} : $assign;
	
	/***/ }),
	/* 235 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var pIE = __webpack_require__(91);
		var createDesc = __webpack_require__(92);
		var toIObject = __webpack_require__(37);
		var toPrimitive = __webpack_require__(154);
		var has = __webpack_require__(28);
		var IE8_DOM_DEFINE = __webpack_require__(231);
		var gOPD = Object.getOwnPropertyDescriptor;
	
		exports.f = __webpack_require__(22) ? gOPD : function getOwnPropertyDescriptor(O, P) {
		  O = toIObject(O);
		  P = toPrimitive(P, true);
		  if (IE8_DOM_DEFINE) try {
		    return gOPD(O, P);
		  } catch (e) {/* empty */}
		  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
		};
	
	/***/ }),
	/* 236 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
		var $keys = __webpack_require__(237);
		var hiddenKeys = __webpack_require__(141).concat('length', 'prototype');
	
		exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
		  return $keys(O, hiddenKeys);
		};
	
	/***/ }),
	/* 237 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var has = __webpack_require__(28);
		var toIObject = __webpack_require__(37);
		var arrayIndexOf = __webpack_require__(420)(false);
		var IE_PROTO = __webpack_require__(150)('IE_PROTO');
	
		module.exports = function (object, names) {
		  var O = toIObject(object);
		  var i = 0;
		  var result = [];
		  var key;
		  for (key in O) {
		    if (key != IE_PROTO) has(O, key) && result.push(key);
		  } // Don't enum bug & hidden keys
		  while (names.length > i) {
		    if (has(O, key = names[i++])) {
		      ~arrayIndexOf(result, key) || result.push(key);
		    }
		  }return result;
		};
	
	/***/ }),
	/* 238 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var classof = __webpack_require__(228);
		var ITERATOR = __webpack_require__(13)('iterator');
		var Iterators = __webpack_require__(56);
		module.exports = __webpack_require__(5).getIteratorMethod = function (it) {
		  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
		};
	
	/***/ }),
	/* 239 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		/**
		 * This is the web browser implementation of `debug()`.
		 *
		 * Expose `debug()` as the module.
		 */
	
		exports = module.exports = __webpack_require__(458);
		exports.log = log;
		exports.formatArgs = formatArgs;
		exports.save = save;
		exports.load = load;
		exports.useColors = useColors;
		exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
	
		/**
		 * Colors.
		 */
	
		exports.colors = ['lightseagreen', 'forestgreen', 'goldenrod', 'dodgerblue', 'darkorchid', 'crimson'];
	
		/**
		 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
		 * and the Firebug extension (any Firefox version) are known
		 * to support "%c" CSS customizations.
		 *
		 * TODO: add a `localStorage` variable to explicitly enable/disable colors
		 */
	
		function useColors() {
		  // NB: In an Electron preload script, document will be defined but not fully
		  // initialized. Since we know we're in Chrome, we'll just detect this case
		  // explicitly
		  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
		    return true;
		  }
	
		  // is webkit? http://stackoverflow.com/a/16459606/376773
		  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
		  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance ||
		  // is firebug? http://stackoverflow.com/a/398120/376773
		  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) ||
		  // is firefox >= v31?
		  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
		  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 ||
		  // double check webkit in userAgent just in case we are in a worker
		  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
		}
	
		/**
		 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
		 */
	
		exports.formatters.j = function (v) {
		  try {
		    return JSON.stringify(v);
		  } catch (err) {
		    return '[UnexpectedJSONParseError]: ' + err.message;
		  }
		};
	
		/**
		 * Colorize log arguments if enabled.
		 *
		 * @api public
		 */
	
		function formatArgs(args) {
		  var useColors = this.useColors;
	
		  args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
	
		  if (!useColors) return;
	
		  var c = 'color: ' + this.color;
		  args.splice(1, 0, c, 'color: inherit');
	
		  // the final "%c" is somewhat tricky, because there could be other
		  // arguments passed either before or after the %c, so we need to
		  // figure out the correct index to insert the CSS into
		  var index = 0;
		  var lastC = 0;
		  args[0].replace(/%[a-zA-Z%]/g, function (match) {
		    if ('%%' === match) return;
		    index++;
		    if ('%c' === match) {
		      // we only are interested in the *last* %c
		      // (the user may have provided their own)
		      lastC = index;
		    }
		  });
	
		  args.splice(lastC, 0, c);
		}
	
		/**
		 * Invokes `console.log()` when available.
		 * No-op when `console.log` is not a "function".
		 *
		 * @api public
		 */
	
		function log() {
		  // this hackery is required for IE8/9, where
		  // the `console.log` function doesn't have 'apply'
		  return 'object' === (typeof console === 'undefined' ? 'undefined' : _typeof(console)) && console.log && Function.prototype.apply.call(console.log, console, arguments);
		}
	
		/**
		 * Save `namespaces`.
		 *
		 * @param {String} namespaces
		 * @api private
		 */
	
		function save(namespaces) {
		  try {
		    if (null == namespaces) {
		      exports.storage.removeItem('debug');
		    } else {
		      exports.storage.debug = namespaces;
		    }
		  } catch (e) {}
		}
	
		/**
		 * Load `namespaces`.
		 *
		 * @return {String} returns the previously persisted debug modes
		 * @api private
		 */
	
		function load() {
		  var r;
		  try {
		    r = exports.storage.debug;
		  } catch (e) {}
	
		  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
		  if (!r && typeof process !== 'undefined' && 'env' in process) {
		    r = process.env.DEBUG;
		  }
	
		  return r;
		}
	
		/**
		 * Enable namespaces listed in `localStorage.debug` initially.
		 */
	
		exports.enable(load());
	
		/**
		 * Localstorage attempts to return the localstorage.
		 *
		 * This is necessary because safari throws
		 * when a user disables cookies/localstorage
		 * and you attempt to access it.
		 *
		 * @return {LocalStorage}
		 * @api private
		 */
	
		function localstorage() {
		  try {
		    return window.localStorage;
		  } catch (e) {}
		}
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))
	
	/***/ }),
	/* 240 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		/*
		  Copyright (C) 2013-2014 Yusuke Suzuki <utatane.tea@gmail.com>
		  Copyright (C) 2014 Ivan Nikulin <ifaaan@gmail.com>
	
		  Redistribution and use in source and binary forms, with or without
		  modification, are permitted provided that the following conditions are met:
	
		    * Redistributions of source code must retain the above copyright
		      notice, this list of conditions and the following disclaimer.
		    * Redistributions in binary form must reproduce the above copyright
		      notice, this list of conditions and the following disclaimer in the
		      documentation and/or other materials provided with the distribution.
	
		  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
		  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
		  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
		  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
		  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
		  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
		  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
		  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
		  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
		  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		*/
	
		(function () {
		    'use strict';
	
		    var ES6Regex, ES5Regex, NON_ASCII_WHITESPACES, IDENTIFIER_START, IDENTIFIER_PART, ch;
	
		    // See `tools/generate-identifier-regex.js`.
		    ES5Regex = {
		        // ECMAScript 5.1/Unicode v7.0.0 NonAsciiIdentifierStart:
		        NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B2\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
		        // ECMAScript 5.1/Unicode v7.0.0 NonAsciiIdentifierPart:
		        NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B2\u08E4-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58\u0C59\u0C60-\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D60-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFC-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA69D\uA69F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C4\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2D\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/
		    };
	
		    ES6Regex = {
		        // ECMAScript 6/Unicode v7.0.0 NonAsciiIdentifierStart:
		        NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B2\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDE00-\uDE11\uDE13-\uDE2B\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF5D-\uDF61]|\uD805[\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDE00-\uDE2F\uDE44\uDE80-\uDEAA]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF98]|\uD809[\uDC00-\uDC6E]|[\uD80C\uD840-\uD868\uD86A-\uD86C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D]|\uD87E[\uDC00-\uDE1D]/,
		        // ECMAScript 6/Unicode v7.0.0 NonAsciiIdentifierPart:
		        NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B2\u08E4-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58\u0C59\u0C60-\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D60-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFC-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA69D\uA69F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C4\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2D\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDD0-\uDDDA\uDE00-\uDE11\uDE13-\uDE37\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF01-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD808[\uDC00-\uDF98]|\uD809[\uDC00-\uDC6E]|[\uD80C\uD840-\uD868\uD86A-\uD86C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
		    };
	
		    function isDecimalDigit(ch) {
		        return 0x30 <= ch && ch <= 0x39; // 0..9
		    }
	
		    function isHexDigit(ch) {
		        return 0x30 <= ch && ch <= 0x39 || // 0..9
		        0x61 <= ch && ch <= 0x66 || // a..f
		        0x41 <= ch && ch <= 0x46; // A..F
		    }
	
		    function isOctalDigit(ch) {
		        return ch >= 0x30 && ch <= 0x37; // 0..7
		    }
	
		    // 7.2 White Space
	
		    NON_ASCII_WHITESPACES = [0x1680, 0x180E, 0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006, 0x2007, 0x2008, 0x2009, 0x200A, 0x202F, 0x205F, 0x3000, 0xFEFF];
	
		    function isWhiteSpace(ch) {
		        return ch === 0x20 || ch === 0x09 || ch === 0x0B || ch === 0x0C || ch === 0xA0 || ch >= 0x1680 && NON_ASCII_WHITESPACES.indexOf(ch) >= 0;
		    }
	
		    // 7.3 Line Terminators
	
		    function isLineTerminator(ch) {
		        return ch === 0x0A || ch === 0x0D || ch === 0x2028 || ch === 0x2029;
		    }
	
		    // 7.6 Identifier Names and Identifiers
	
		    function fromCodePoint(cp) {
		        if (cp <= 0xFFFF) {
		            return String.fromCharCode(cp);
		        }
		        var cu1 = String.fromCharCode(Math.floor((cp - 0x10000) / 0x400) + 0xD800);
		        var cu2 = String.fromCharCode((cp - 0x10000) % 0x400 + 0xDC00);
		        return cu1 + cu2;
		    }
	
		    IDENTIFIER_START = new Array(0x80);
		    for (ch = 0; ch < 0x80; ++ch) {
		        IDENTIFIER_START[ch] = ch >= 0x61 && ch <= 0x7A || // a..z
		        ch >= 0x41 && ch <= 0x5A || // A..Z
		        ch === 0x24 || ch === 0x5F; // $ (dollar) and _ (underscore)
		    }
	
		    IDENTIFIER_PART = new Array(0x80);
		    for (ch = 0; ch < 0x80; ++ch) {
		        IDENTIFIER_PART[ch] = ch >= 0x61 && ch <= 0x7A || // a..z
		        ch >= 0x41 && ch <= 0x5A || // A..Z
		        ch >= 0x30 && ch <= 0x39 || // 0..9
		        ch === 0x24 || ch === 0x5F; // $ (dollar) and _ (underscore)
		    }
	
		    function isIdentifierStartES5(ch) {
		        return ch < 0x80 ? IDENTIFIER_START[ch] : ES5Regex.NonAsciiIdentifierStart.test(fromCodePoint(ch));
		    }
	
		    function isIdentifierPartES5(ch) {
		        return ch < 0x80 ? IDENTIFIER_PART[ch] : ES5Regex.NonAsciiIdentifierPart.test(fromCodePoint(ch));
		    }
	
		    function isIdentifierStartES6(ch) {
		        return ch < 0x80 ? IDENTIFIER_START[ch] : ES6Regex.NonAsciiIdentifierStart.test(fromCodePoint(ch));
		    }
	
		    function isIdentifierPartES6(ch) {
		        return ch < 0x80 ? IDENTIFIER_PART[ch] : ES6Regex.NonAsciiIdentifierPart.test(fromCodePoint(ch));
		    }
	
		    module.exports = {
		        isDecimalDigit: isDecimalDigit,
		        isHexDigit: isHexDigit,
		        isOctalDigit: isOctalDigit,
		        isWhiteSpace: isWhiteSpace,
		        isLineTerminator: isLineTerminator,
		        isIdentifierStartES5: isIdentifierStartES5,
		        isIdentifierPartES5: isIdentifierPartES5,
		        isIdentifierStartES6: isIdentifierStartES6,
		        isIdentifierPartES6: isIdentifierPartES6
		    };
		})();
		/* vim: set sw=4 ts=4 et tw=80 : */
	
	/***/ }),
	/* 241 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var getNative = __webpack_require__(38),
		    root = __webpack_require__(17);
	
		/* Built-in method references that are verified to be native. */
		var Set = getNative(root, 'Set');
	
		module.exports = Set;
	
	/***/ }),
	/* 242 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var MapCache = __webpack_require__(160),
		    setCacheAdd = __webpack_require__(561),
		    setCacheHas = __webpack_require__(562);
	
		/**
		 *
		 * Creates an array cache object to store unique values.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [values] The values to cache.
		 */
		function SetCache(values) {
		    var index = -1,
		        length = values == null ? 0 : values.length;
	
		    this.__data__ = new MapCache();
		    while (++index < length) {
		        this.add(values[index]);
		    }
		}
	
		// Add methods to `SetCache`.
		SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
		SetCache.prototype.has = setCacheHas;
	
		module.exports = SetCache;
	
	/***/ }),
	/* 243 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var root = __webpack_require__(17);
	
		/** Built-in value references. */
		var Uint8Array = root.Uint8Array;
	
		module.exports = Uint8Array;
	
	/***/ }),
	/* 244 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * A faster alternative to `Function#apply`, this function invokes `func`
		 * with the `this` binding of `thisArg` and the arguments of `args`.
		 *
		 * @private
		 * @param {Function} func The function to invoke.
		 * @param {*} thisArg The `this` binding of `func`.
		 * @param {Array} args The arguments to invoke `func` with.
		 * @returns {*} Returns the result of `func`.
		 */
		function apply(func, thisArg, args) {
		  switch (args.length) {
		    case 0:
		      return func.call(thisArg);
		    case 1:
		      return func.call(thisArg, args[0]);
		    case 2:
		      return func.call(thisArg, args[0], args[1]);
		    case 3:
		      return func.call(thisArg, args[0], args[1], args[2]);
		  }
		  return func.apply(thisArg, args);
		}
	
		module.exports = apply;
	
	/***/ }),
	/* 245 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseTimes = __webpack_require__(513),
		    isArguments = __webpack_require__(112),
		    isArray = __webpack_require__(6),
		    isBuffer = __webpack_require__(113),
		    isIndex = __webpack_require__(171),
		    isTypedArray = __webpack_require__(177);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Creates an array of the enumerable property names of the array-like `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @param {boolean} inherited Specify returning inherited property names.
		 * @returns {Array} Returns the array of property names.
		 */
		function arrayLikeKeys(value, inherited) {
		  var isArr = isArray(value),
		      isArg = !isArr && isArguments(value),
		      isBuff = !isArr && !isArg && isBuffer(value),
		      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
		      skipIndexes = isArr || isArg || isBuff || isType,
		      result = skipIndexes ? baseTimes(value.length, String) : [],
		      length = result.length;
	
		  for (var key in value) {
		    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
		    // Safari 9 has enumerable `arguments.length` in strict mode.
		    key == 'length' ||
		    // Node.js 0.10 has enumerable non-index properties on buffers.
		    isBuff && (key == 'offset' || key == 'parent') ||
		    // PhantomJS 2 has enumerable non-index properties on typed arrays.
		    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
		    // Skip index properties.
		    isIndex(key, length)))) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		module.exports = arrayLikeKeys;
	
	/***/ }),
	/* 246 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * A specialized version of `_.reduce` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @param {*} [accumulator] The initial value.
		 * @param {boolean} [initAccum] Specify using the first element of `array` as
		 *  the initial value.
		 * @returns {*} Returns the accumulated value.
		 */
		function arrayReduce(array, iteratee, accumulator, initAccum) {
		  var index = -1,
		      length = array == null ? 0 : array.length;
	
		  if (initAccum && length) {
		    accumulator = array[++index];
		  }
		  while (++index < length) {
		    accumulator = iteratee(accumulator, array[index], index, array);
		  }
		  return accumulator;
		}
	
		module.exports = arrayReduce;
	
	/***/ }),
	/* 247 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseAssignValue = __webpack_require__(163),
		    eq = __webpack_require__(46);
	
		/**
		 * This function is like `assignValue` except that it doesn't assign
		 * `undefined` values.
		 *
		 * @private
		 * @param {Object} object The object to modify.
		 * @param {string} key The key of the property to assign.
		 * @param {*} value The value to assign.
		 */
		function assignMergeValue(object, key, value) {
		  if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
		    baseAssignValue(object, key, value);
		  }
		}
	
		module.exports = assignMergeValue;
	
	/***/ }),
	/* 248 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var createBaseFor = __webpack_require__(527);
	
		/**
		 * The base implementation of `baseForOwn` which iterates over `object`
		 * properties returned by `keysFunc` and invokes `iteratee` for each property.
		 * Iteratee functions may exit iteration early by explicitly returning `false`.
		 *
		 * @private
		 * @param {Object} object The object to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @returns {Object} Returns `object`.
		 */
		var baseFor = createBaseFor();
	
		module.exports = baseFor;
	
	/***/ }),
	/* 249 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var castPath = __webpack_require__(255),
		    toKey = __webpack_require__(108);
	
		/**
		 * The base implementation of `_.get` without support for default values.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path of the property to get.
		 * @returns {*} Returns the resolved value.
		 */
		function baseGet(object, path) {
		  path = castPath(path, object);
	
		  var index = 0,
		      length = path.length;
	
		  while (object != null && index < length) {
		    object = object[toKey(path[index++])];
		  }
		  return index && index == length ? object : undefined;
		}
	
		module.exports = baseGet;
	
	/***/ }),
	/* 250 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var arrayPush = __webpack_require__(161),
		    isArray = __webpack_require__(6);
	
		/**
		 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
		 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
		 * symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @param {Function} symbolsFunc The function to get the symbols of `object`.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function baseGetAllKeys(object, keysFunc, symbolsFunc) {
		  var result = keysFunc(object);
		  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
		}
	
		module.exports = baseGetAllKeys;
	
	/***/ }),
	/* 251 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseIsEqualDeep = __webpack_require__(494),
		    isObjectLike = __webpack_require__(25);
	
		/**
		 * The base implementation of `_.isEqual` which supports partial comparisons
		 * and tracks traversed objects.
		 *
		 * @private
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @param {boolean} bitmask The bitmask flags.
		 *  1 - Unordered comparison
		 *  2 - Partial comparison
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 */
		function baseIsEqual(value, other, bitmask, customizer, stack) {
		  if (value === other) {
		    return true;
		  }
		  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
		    return value !== value && other !== other;
		  }
		  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
		}
	
		module.exports = baseIsEqual;
	
	/***/ }),
	/* 252 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseEach = __webpack_require__(487),
		    isArrayLike = __webpack_require__(24);
	
		/**
		 * The base implementation of `_.map` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Array|Object} collection The collection to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the new mapped array.
		 */
		function baseMap(collection, iteratee) {
		  var index = -1,
		      result = isArrayLike(collection) ? Array(collection.length) : [];
	
		  baseEach(collection, function (value, key, collection) {
		    result[++index] = iteratee(value, key, collection);
		  });
		  return result;
		}
	
		module.exports = baseMap;
	
	/***/ }),
	/* 253 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _Symbol = __webpack_require__(45),
		    arrayMap = __webpack_require__(60),
		    isArray = __webpack_require__(6),
		    isSymbol = __webpack_require__(62);
	
		/** Used as references for various `Number` constants. */
		var INFINITY = 1 / 0;
	
		/** Used to convert symbols to primitives and strings. */
		var symbolProto = _Symbol ? _Symbol.prototype : undefined,
		    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
		/**
		 * The base implementation of `_.toString` which doesn't convert nullish
		 * values to empty strings.
		 *
		 * @private
		 * @param {*} value The value to process.
		 * @returns {string} Returns the string.
		 */
		function baseToString(value) {
		  // Exit early for strings to avoid a performance hit in some environments.
		  if (typeof value == 'string') {
		    return value;
		  }
		  if (isArray(value)) {
		    // Recursively convert values (susceptible to call stack limits).
		    return arrayMap(value, baseToString) + '';
		  }
		  if (isSymbol(value)) {
		    return symbolToString ? symbolToString.call(value) : '';
		  }
		  var result = value + '';
		  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
		}
	
		module.exports = baseToString;
	
	/***/ }),
	/* 254 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Checks if a `cache` value for `key` exists.
		 *
		 * @private
		 * @param {Object} cache The cache to query.
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function cacheHas(cache, key) {
		  return cache.has(key);
		}
	
		module.exports = cacheHas;
	
	/***/ }),
	/* 255 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isArray = __webpack_require__(6),
		    isKey = __webpack_require__(173),
		    stringToPath = __webpack_require__(571),
		    toString = __webpack_require__(114);
	
		/**
		 * Casts `value` to a path array if it's not one.
		 *
		 * @private
		 * @param {*} value The value to inspect.
		 * @param {Object} [object] The object to query keys on.
		 * @returns {Array} Returns the cast property path array.
		 */
		function castPath(value, object) {
		  if (isArray(value)) {
		    return value;
		  }
		  return isKey(value, object) ? [value] : stringToPath(toString(value));
		}
	
		module.exports = castPath;
	
	/***/ }),
	/* 256 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var root = __webpack_require__(17);
	
		/** Detect free variable `exports`. */
		var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;
	
		/** Detect free variable `module`. */
		var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;
	
		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;
	
		/** Built-in value references. */
		var Buffer = moduleExports ? root.Buffer : undefined,
		    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
		/**
		 * Creates a clone of  `buffer`.
		 *
		 * @private
		 * @param {Buffer} buffer The buffer to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Buffer} Returns the cloned buffer.
		 */
		function cloneBuffer(buffer, isDeep) {
		  if (isDeep) {
		    return buffer.slice();
		  }
		  var length = buffer.length,
		      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
		  buffer.copy(result);
		  return result;
		}
	
		module.exports = cloneBuffer;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)(module)))
	
	/***/ }),
	/* 257 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var cloneArrayBuffer = __webpack_require__(167);
	
		/**
		 * Creates a clone of `typedArray`.
		 *
		 * @private
		 * @param {Object} typedArray The typed array to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned typed array.
		 */
		function cloneTypedArray(typedArray, isDeep) {
		  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
		  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
		}
	
		module.exports = cloneTypedArray;
	
	/***/ }),
	/* 258 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseIteratee = __webpack_require__(61),
		    isArrayLike = __webpack_require__(24),
		    keys = __webpack_require__(32);
	
		/**
		 * Creates a `_.find` or `_.findLast` function.
		 *
		 * @private
		 * @param {Function} findIndexFunc The function to find the collection index.
		 * @returns {Function} Returns the new find function.
		 */
		function createFind(findIndexFunc) {
		  return function (collection, predicate, fromIndex) {
		    var iterable = Object(collection);
		    if (!isArrayLike(collection)) {
		      var iteratee = baseIteratee(predicate, 3);
		      collection = keys(collection);
		      predicate = function predicate(key) {
		        return iteratee(iterable[key], key, iterable);
		      };
		    }
		    var index = findIndexFunc(collection, predicate, fromIndex);
		    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
		  };
		}
	
		module.exports = createFind;
	
	/***/ }),
	/* 259 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var getNative = __webpack_require__(38);
	
		var defineProperty = function () {
		  try {
		    var func = getNative(Object, 'defineProperty');
		    func({}, '', {});
		    return func;
		  } catch (e) {}
		}();
	
		module.exports = defineProperty;
	
	/***/ }),
	/* 260 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var SetCache = __webpack_require__(242),
		    arraySome = __webpack_require__(482),
		    cacheHas = __webpack_require__(254);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1,
		    COMPARE_UNORDERED_FLAG = 2;
	
		/**
		 * A specialized version of `baseIsEqualDeep` for arrays with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Array} array The array to compare.
		 * @param {Array} other The other array to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `array` and `other` objects.
		 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
		 */
		function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
		  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
		      arrLength = array.length,
		      othLength = other.length;
	
		  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
		    return false;
		  }
		  // Assume cyclic values are equal.
		  var stacked = stack.get(array);
		  if (stacked && stack.get(other)) {
		    return stacked == other;
		  }
		  var index = -1,
		      result = true,
		      seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
	
		  stack.set(array, other);
		  stack.set(other, array);
	
		  // Ignore non-index properties.
		  while (++index < arrLength) {
		    var arrValue = array[index],
		        othValue = other[index];
	
		    if (customizer) {
		      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
		    }
		    if (compared !== undefined) {
		      if (compared) {
		        continue;
		      }
		      result = false;
		      break;
		    }
		    // Recursively compare arrays (susceptible to call stack limits).
		    if (seen) {
		      if (!arraySome(other, function (othValue, othIndex) {
		        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
		          return seen.push(othIndex);
		        }
		      })) {
		        result = false;
		        break;
		      }
		    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
		      result = false;
		      break;
		    }
		  }
		  stack['delete'](array);
		  stack['delete'](other);
		  return result;
		}
	
		module.exports = equalArrays;
	
	/***/ }),
	/* 261 */
	/***/ (function(module, exports) {
	
		/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		/** Detect free variable `global` from Node.js. */
		var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;
	
		module.exports = freeGlobal;
		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))
	
	/***/ }),
	/* 262 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseGetAllKeys = __webpack_require__(250),
		    getSymbols = __webpack_require__(170),
		    keys = __webpack_require__(32);
	
		/**
		 * Creates an array of own enumerable property names and symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function getAllKeys(object) {
		  return baseGetAllKeys(object, keys, getSymbols);
		}
	
		module.exports = getAllKeys;
	
	/***/ }),
	/* 263 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var arrayPush = __webpack_require__(161),
		    getPrototype = __webpack_require__(169),
		    getSymbols = __webpack_require__(170),
		    stubArray = __webpack_require__(279);
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeGetSymbols = Object.getOwnPropertySymbols;
	
		/**
		 * Creates an array of the own and inherited enumerable symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of symbols.
		 */
		var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
		  var result = [];
		  while (object) {
		    arrayPush(result, getSymbols(object));
		    object = getPrototype(object);
		  }
		  return result;
		};
	
		module.exports = getSymbolsIn;
	
	/***/ }),
	/* 264 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var DataView = __webpack_require__(472),
		    Map = __webpack_require__(159),
		    Promise = __webpack_require__(474),
		    Set = __webpack_require__(241),
		    WeakMap = __webpack_require__(475),
		    baseGetTag = __webpack_require__(30),
		    toSource = __webpack_require__(272);
	
		/** `Object#toString` result references. */
		var mapTag = '[object Map]',
		    objectTag = '[object Object]',
		    promiseTag = '[object Promise]',
		    setTag = '[object Set]',
		    weakMapTag = '[object WeakMap]';
	
		var dataViewTag = '[object DataView]';
	
		/** Used to detect maps, sets, and weakmaps. */
		var dataViewCtorString = toSource(DataView),
		    mapCtorString = toSource(Map),
		    promiseCtorString = toSource(Promise),
		    setCtorString = toSource(Set),
		    weakMapCtorString = toSource(WeakMap);
	
		/**
		 * Gets the `toStringTag` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		var getTag = baseGetTag;
	
		// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
		if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
		    getTag = function getTag(value) {
		        var result = baseGetTag(value),
		            Ctor = result == objectTag ? value.constructor : undefined,
		            ctorString = Ctor ? toSource(Ctor) : '';
	
		        if (ctorString) {
		            switch (ctorString) {
		                case dataViewCtorString:
		                    return dataViewTag;
		                case mapCtorString:
		                    return mapTag;
		                case promiseCtorString:
		                    return promiseTag;
		                case setCtorString:
		                    return setTag;
		                case weakMapCtorString:
		                    return weakMapTag;
		            }
		        }
		        return result;
		    };
		}
	
		module.exports = getTag;
	
	/***/ }),
	/* 265 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var castPath = __webpack_require__(255),
		    isArguments = __webpack_require__(112),
		    isArray = __webpack_require__(6),
		    isIndex = __webpack_require__(171),
		    isLength = __webpack_require__(176),
		    toKey = __webpack_require__(108);
	
		/**
		 * Checks if `path` exists on `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path to check.
		 * @param {Function} hasFunc The function to check properties.
		 * @returns {boolean} Returns `true` if `path` exists, else `false`.
		 */
		function hasPath(object, path, hasFunc) {
		  path = castPath(path, object);
	
		  var index = -1,
		      length = path.length,
		      result = false;
	
		  while (++index < length) {
		    var key = toKey(path[index]);
		    if (!(result = object != null && hasFunc(object, key))) {
		      break;
		    }
		    object = object[key];
		  }
		  if (result || ++index != length) {
		    return result;
		  }
		  length = object == null ? 0 : object.length;
		  return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
		}
	
		module.exports = hasPath;
	
	/***/ }),
	/* 266 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseCreate = __webpack_require__(486),
		    getPrototype = __webpack_require__(169),
		    isPrototype = __webpack_require__(105);
	
		/**
		 * Initializes an object clone.
		 *
		 * @private
		 * @param {Object} object The object to clone.
		 * @returns {Object} Returns the initialized clone.
		 */
		function initCloneObject(object) {
		    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
		}
	
		module.exports = initCloneObject;
	
	/***/ }),
	/* 267 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isObject = __webpack_require__(18);
	
		/**
		 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` if suitable for strict
		 *  equality comparisons, else `false`.
		 */
		function isStrictComparable(value) {
		  return value === value && !isObject(value);
		}
	
		module.exports = isStrictComparable;
	
	/***/ }),
	/* 268 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Converts `map` to its key-value pairs.
		 *
		 * @private
		 * @param {Object} map The map to convert.
		 * @returns {Array} Returns the key-value pairs.
		 */
		function mapToArray(map) {
		  var index = -1,
		      result = Array(map.size);
	
		  map.forEach(function (value, key) {
		    result[++index] = [key, value];
		  });
		  return result;
		}
	
		module.exports = mapToArray;
	
	/***/ }),
	/* 269 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * A specialized version of `matchesProperty` for source values suitable
		 * for strict equality comparisons, i.e. `===`.
		 *
		 * @private
		 * @param {string} key The key of the property to get.
		 * @param {*} srcValue The value to match.
		 * @returns {Function} Returns the new spec function.
		 */
		function matchesStrictComparable(key, srcValue) {
		  return function (object) {
		    if (object == null) {
		      return false;
		    }
		    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
		  };
		}
	
		module.exports = matchesStrictComparable;
	
	/***/ }),
	/* 270 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var freeGlobal = __webpack_require__(261);
	
		/** Detect free variable `exports`. */
		var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;
	
		/** Detect free variable `module`. */
		var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;
	
		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;
	
		/** Detect free variable `process` from Node.js. */
		var freeProcess = moduleExports && freeGlobal.process;
	
		/** Used to access faster Node.js helpers. */
		var nodeUtil = function () {
		  try {
		    return freeProcess && freeProcess.binding && freeProcess.binding('util');
		  } catch (e) {}
		}();
	
		module.exports = nodeUtil;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)(module)))
	
	/***/ }),
	/* 271 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Creates a unary function that invokes `func` with its argument transformed.
		 *
		 * @private
		 * @param {Function} func The function to wrap.
		 * @param {Function} transform The argument transform.
		 * @returns {Function} Returns the new function.
		 */
		function overArg(func, transform) {
		  return function (arg) {
		    return func(transform(arg));
		  };
		}
	
		module.exports = overArg;
	
	/***/ }),
	/* 272 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		/** Used for built-in method references. */
		var funcProto = Function.prototype;
	
		/** Used to resolve the decompiled source of functions. */
		var funcToString = funcProto.toString;
	
		/**
		 * Converts `func` to its source code.
		 *
		 * @private
		 * @param {Function} func The function to convert.
		 * @returns {string} Returns the source code.
		 */
		function toSource(func) {
		  if (func != null) {
		    try {
		      return funcToString.call(func);
		    } catch (e) {}
		    try {
		      return func + '';
		    } catch (e) {}
		  }
		  return '';
		}
	
		module.exports = toSource;
	
	/***/ }),
	/* 273 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var apply = __webpack_require__(244),
		    assignInWith = __webpack_require__(573),
		    baseRest = __webpack_require__(101),
		    customDefaultsAssignIn = __webpack_require__(529);
	
		/**
		 * Assigns own and inherited enumerable string keyed properties of source
		 * objects to the destination object for all destination properties that
		 * resolve to `undefined`. Source objects are applied from left to right.
		 * Once a property is set, additional values of the same property are ignored.
		 *
		 * **Note:** This method mutates `object`.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The destination object.
		 * @param {...Object} [sources] The source objects.
		 * @returns {Object} Returns `object`.
		 * @see _.defaultsDeep
		 * @example
		 *
		 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
		 * // => { 'a': 1, 'b': 2 }
		 */
		var defaults = baseRest(function (args) {
		  args.push(undefined, customDefaultsAssignIn);
		  return apply(assignInWith, undefined, args);
		});
	
		module.exports = defaults;
	
	/***/ }),
	/* 274 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseHas = __webpack_require__(490),
		    hasPath = __webpack_require__(265);
	
		/**
		 * Checks if `path` is a direct property of `object`.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path to check.
		 * @returns {boolean} Returns `true` if `path` exists, else `false`.
		 * @example
		 *
		 * var object = { 'a': { 'b': 2 } };
		 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
		 *
		 * _.has(object, 'a');
		 * // => true
		 *
		 * _.has(object, 'a.b');
		 * // => true
		 *
		 * _.has(object, ['a', 'b']);
		 * // => true
		 *
		 * _.has(other, 'a');
		 * // => false
		 */
		function has(object, path) {
		  return object != null && hasPath(object, path, baseHas);
		}
	
		module.exports = has;
	
	/***/ }),
	/* 275 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseGetTag = __webpack_require__(30),
		    getPrototype = __webpack_require__(169),
		    isObjectLike = __webpack_require__(25);
	
		/** `Object#toString` result references. */
		var objectTag = '[object Object]';
	
		/** Used for built-in method references. */
		var funcProto = Function.prototype,
		    objectProto = Object.prototype;
	
		/** Used to resolve the decompiled source of functions. */
		var funcToString = funcProto.toString;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Used to infer the `Object` constructor. */
		var objectCtorString = funcToString.call(Object);
	
		/**
		 * Checks if `value` is a plain object, that is, an object created by the
		 * `Object` constructor or one with a `[[Prototype]]` of `null`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.8.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 * }
		 *
		 * _.isPlainObject(new Foo);
		 * // => false
		 *
		 * _.isPlainObject([1, 2, 3]);
		 * // => false
		 *
		 * _.isPlainObject({ 'x': 0, 'y': 0 });
		 * // => true
		 *
		 * _.isPlainObject(Object.create(null));
		 * // => true
		 */
		function isPlainObject(value) {
		  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
		    return false;
		  }
		  var proto = getPrototype(value);
		  if (proto === null) {
		    return true;
		  }
		  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
		  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
		}
	
		module.exports = isPlainObject;
	
	/***/ }),
	/* 276 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseIsRegExp = __webpack_require__(498),
		    baseUnary = __webpack_require__(102),
		    nodeUtil = __webpack_require__(270);
	
		/* Node.js helper references. */
		var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;
	
		/**
		 * Checks if `value` is classified as a `RegExp` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
		 * @example
		 *
		 * _.isRegExp(/abc/);
		 * // => true
		 *
		 * _.isRegExp('/abc/');
		 * // => false
		 */
		var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
		module.exports = isRegExp;
	
	/***/ }),
	/* 277 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseRest = __webpack_require__(101),
		    pullAll = __webpack_require__(593);
	
		/**
		 * Removes all given values from `array` using
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * for equality comparisons.
		 *
		 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
		 * to remove elements from an array by predicate.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.0.0
		 * @category Array
		 * @param {Array} array The array to modify.
		 * @param {...*} [values] The values to remove.
		 * @returns {Array} Returns `array`.
		 * @example
		 *
		 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
		 *
		 * _.pull(array, 'a', 'c');
		 * console.log(array);
		 * // => ['b', 'b']
		 */
		var pull = baseRest(pullAll);
	
		module.exports = pull;
	
	/***/ }),
	/* 278 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseRepeat = __webpack_require__(510),
		    isIterateeCall = __webpack_require__(172),
		    toInteger = __webpack_require__(48),
		    toString = __webpack_require__(114);
	
		/**
		 * Repeats the given string `n` times.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category String
		 * @param {string} [string=''] The string to repeat.
		 * @param {number} [n=1] The number of times to repeat the string.
		 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
		 * @returns {string} Returns the repeated string.
		 * @example
		 *
		 * _.repeat('*', 3);
		 * // => '***'
		 *
		 * _.repeat('abc', 2);
		 * // => 'abcabc'
		 *
		 * _.repeat('abc', 0);
		 * // => ''
		 */
		function repeat(string, n, guard) {
		  if (guard ? isIterateeCall(string, n, guard) : n === undefined) {
		    n = 1;
		  } else {
		    n = toInteger(n);
		  }
		  return baseRepeat(toString(string), n);
		}
	
		module.exports = repeat;
	
	/***/ }),
	/* 279 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * This method returns a new empty array.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {Array} Returns the new empty array.
		 * @example
		 *
		 * var arrays = _.times(2, _.stubArray);
		 *
		 * console.log(arrays);
		 * // => [[], []]
		 *
		 * console.log(arrays[0] === arrays[1]);
		 * // => false
		 */
		function stubArray() {
		  return [];
		}
	
		module.exports = stubArray;
	
	/***/ }),
	/* 280 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseValues = __webpack_require__(515),
		    keys = __webpack_require__(32);
	
		/**
		 * Creates an array of the own enumerable string keyed property values of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property values.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.values(new Foo);
		 * // => [1, 2] (iteration order is not guaranteed)
		 *
		 * _.values('hi');
		 * // => ['h', 'i']
		 */
		function values(object) {
		  return object == null ? [] : baseValues(object, keys(object));
		}
	
		module.exports = values;
	
	/***/ }),
	/* 281 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		var originalObject = Object;
		var originalDefProp = Object.defineProperty;
		var originalCreate = Object.create;
	
		function defProp(obj, name, value) {
		  if (originalDefProp) try {
		    originalDefProp.call(originalObject, obj, name, { value: value });
		  } catch (definePropertyIsBrokenInIE8) {
		    obj[name] = value;
		  } else {
		    obj[name] = value;
		  }
		}
	
		// For functions that will be invoked using .call or .apply, we need to
		// define those methods on the function objects themselves, rather than
		// inheriting them from Function.prototype, so that a malicious or clumsy
		// third party cannot interfere with the functionality of this module by
		// redefining Function.prototype.call or .apply.
		function makeSafeToCall(fun) {
		  if (fun) {
		    defProp(fun, "call", fun.call);
		    defProp(fun, "apply", fun.apply);
		  }
		  return fun;
		}
	
		makeSafeToCall(originalDefProp);
		makeSafeToCall(originalCreate);
	
		var hasOwn = makeSafeToCall(Object.prototype.hasOwnProperty);
		var numToStr = makeSafeToCall(Number.prototype.toString);
		var strSlice = makeSafeToCall(String.prototype.slice);
	
		var cloner = function cloner() {};
		function create(prototype) {
		  if (originalCreate) {
		    return originalCreate.call(originalObject, prototype);
		  }
		  cloner.prototype = prototype || null;
		  return new cloner();
		}
	
		var rand = Math.random;
		var uniqueKeys = create(null);
	
		function makeUniqueKey() {
		  // Collisions are highly unlikely, but this module is in the business of
		  // making guarantees rather than safe bets.
		  do {
		    var uniqueKey = internString(strSlice.call(numToStr.call(rand(), 36), 2));
		  } while (hasOwn.call(uniqueKeys, uniqueKey));
		  return uniqueKeys[uniqueKey] = uniqueKey;
		}
	
		function internString(str) {
		  var obj = {};
		  obj[str] = true;
		  return Object.keys(obj)[0];
		}
	
		// External users might find this function useful, but it is not necessary
		// for the typical use of this module.
		exports.makeUniqueKey = makeUniqueKey;
	
		// Object.getOwnPropertyNames is the only way to enumerate non-enumerable
		// properties, so if we wrap it to ignore our secret keys, there should be
		// no way (except guessing) to access those properties.
		var originalGetOPNs = Object.getOwnPropertyNames;
		Object.getOwnPropertyNames = function getOwnPropertyNames(object) {
		  for (var names = originalGetOPNs(object), src = 0, dst = 0, len = names.length; src < len; ++src) {
		    if (!hasOwn.call(uniqueKeys, names[src])) {
		      if (src > dst) {
		        names[dst] = names[src];
		      }
		      ++dst;
		    }
		  }
		  names.length = dst;
		  return names;
		};
	
		function defaultCreatorFn(object) {
		  return create(null);
		}
	
		function makeAccessor(secretCreatorFn) {
		  var brand = makeUniqueKey();
		  var passkey = create(null);
	
		  secretCreatorFn = secretCreatorFn || defaultCreatorFn;
	
		  function register(object) {
		    var secret; // Created lazily.
	
		    function vault(key, forget) {
		      // Only code that has access to the passkey can retrieve (or forget)
		      // the secret object.
		      if (key === passkey) {
		        return forget ? secret = null : secret || (secret = secretCreatorFn(object));
		      }
		    }
	
		    defProp(object, brand, vault);
		  }
	
		  function accessor(object) {
		    if (!hasOwn.call(object, brand)) register(object);
		    return object[brand](passkey);
		  }
	
		  accessor.forget = function (object) {
		    if (hasOwn.call(object, brand)) object[brand](passkey, true);
		  };
	
		  return accessor;
		}
	
		exports.makeAccessor = makeAccessor;
	
	/***/ }),
	/* 282 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		/*! https://mths.be/regenerate v1.3.2 by @mathias | MIT license */
		;(function (root) {
	
			// Detect free variables `exports`.
			var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports;
	
			// Detect free variable `module`.
			var freeModule = ( false ? 'undefined' : _typeof(module)) == 'object' && module && module.exports == freeExports && module;
	
			// Detect free variable `global`, from Node.js/io.js or Browserified code,
			// and use it as `root`.
			var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global;
			if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
				root = freeGlobal;
			}
	
			/*--------------------------------------------------------------------------*/
	
			var ERRORS = {
				'rangeOrder': 'A range\u2019s `stop` value must be greater than or equal ' + 'to the `start` value.',
				'codePointRange': 'Invalid code point value. Code points range from ' + 'U+000000 to U+10FFFF.'
			};
	
			// https://mathiasbynens.be/notes/javascript-encoding#surrogate-pairs
			var HIGH_SURROGATE_MIN = 0xD800;
			var HIGH_SURROGATE_MAX = 0xDBFF;
			var LOW_SURROGATE_MIN = 0xDC00;
			var LOW_SURROGATE_MAX = 0xDFFF;
	
			// In Regenerate output, `\0` is never preceded by `\` because we sort by
			// code point value, so let’s keep this regular expression simple.
			var regexNull = /\\x00([^0123456789]|$)/g;
	
			var object = {};
			var hasOwnProperty = object.hasOwnProperty;
			var extend = function extend(destination, source) {
				var key;
				for (key in source) {
					if (hasOwnProperty.call(source, key)) {
						destination[key] = source[key];
					}
				}
				return destination;
			};
	
			var forEach = function forEach(array, callback) {
				var index = -1;
				var length = array.length;
				while (++index < length) {
					callback(array[index], index);
				}
			};
	
			var toString = object.toString;
			var isArray = function isArray(value) {
				return toString.call(value) == '[object Array]';
			};
			var isNumber = function isNumber(value) {
				return typeof value == 'number' || toString.call(value) == '[object Number]';
			};
	
			// This assumes that `number` is a positive integer that `toString()`s nicely
			// (which is the case for all code point values).
			var zeroes = '0000';
			var pad = function pad(number, totalCharacters) {
				var string = String(number);
				return string.length < totalCharacters ? (zeroes + string).slice(-totalCharacters) : string;
			};
	
			var hex = function hex(number) {
				return Number(number).toString(16).toUpperCase();
			};
	
			var slice = [].slice;
	
			/*--------------------------------------------------------------------------*/
	
			var dataFromCodePoints = function dataFromCodePoints(codePoints) {
				var index = -1;
				var length = codePoints.length;
				var max = length - 1;
				var result = [];
				var isStart = true;
				var tmp;
				var previous = 0;
				while (++index < length) {
					tmp = codePoints[index];
					if (isStart) {
						result.push(tmp);
						previous = tmp;
						isStart = false;
					} else {
						if (tmp == previous + 1) {
							if (index != max) {
								previous = tmp;
								continue;
							} else {
								isStart = true;
								result.push(tmp + 1);
							}
						} else {
							// End the previous range and start a new one.
							result.push(previous + 1, tmp);
							previous = tmp;
						}
					}
				}
				if (!isStart) {
					result.push(tmp + 1);
				}
				return result;
			};
	
			var dataRemove = function dataRemove(data, codePoint) {
				// Iterate over the data per `(start, end)` pair.
				var index = 0;
				var start;
				var end;
				var length = data.length;
				while (index < length) {
					start = data[index];
					end = data[index + 1];
					if (codePoint >= start && codePoint < end) {
						// Modify this pair.
						if (codePoint == start) {
							if (end == start + 1) {
								// Just remove `start` and `end`.
								data.splice(index, 2);
								return data;
							} else {
								// Just replace `start` with a new value.
								data[index] = codePoint + 1;
								return data;
							}
						} else if (codePoint == end - 1) {
							// Just replace `end` with a new value.
							data[index + 1] = codePoint;
							return data;
						} else {
							// Replace `[start, end]` with `[startA, endA, startB, endB]`.
							data.splice(index, 2, start, codePoint, codePoint + 1, end);
							return data;
						}
					}
					index += 2;
				}
				return data;
			};
	
			var dataRemoveRange = function dataRemoveRange(data, rangeStart, rangeEnd) {
				if (rangeEnd < rangeStart) {
					throw Error(ERRORS.rangeOrder);
				}
				// Iterate over the data per `(start, end)` pair.
				var index = 0;
				var start;
				var end;
				while (index < data.length) {
					start = data[index];
					end = data[index + 1] - 1; // Note: the `- 1` makes `end` inclusive.
	
					// Exit as soon as no more matching pairs can be found.
					if (start > rangeEnd) {
						return data;
					}
	
					// Check if this range pair is equal to, or forms a subset of, the range
					// to be removed.
					// E.g. we have `[0, 11, 40, 51]` and want to remove 0-10 → `[40, 51]`.
					// E.g. we have `[40, 51]` and want to remove 0-100 → `[]`.
					if (rangeStart <= start && rangeEnd >= end) {
						// Remove this pair.
						data.splice(index, 2);
						continue;
					}
	
					// Check if both `rangeStart` and `rangeEnd` are within the bounds of
					// this pair.
					// E.g. we have `[0, 11]` and want to remove 4-6 → `[0, 4, 7, 11]`.
					if (rangeStart >= start && rangeEnd < end) {
						if (rangeStart == start) {
							// Replace `[start, end]` with `[startB, endB]`.
							data[index] = rangeEnd + 1;
							data[index + 1] = end + 1;
							return data;
						}
						// Replace `[start, end]` with `[startA, endA, startB, endB]`.
						data.splice(index, 2, start, rangeStart, rangeEnd + 1, end + 1);
						return data;
					}
	
					// Check if only `rangeStart` is within the bounds of this pair.
					// E.g. we have `[0, 11]` and want to remove 4-20 → `[0, 4]`.
					if (rangeStart >= start && rangeStart <= end) {
						// Replace `end` with `rangeStart`.
						data[index + 1] = rangeStart;
						// Note: we cannot `return` just yet, in case any following pairs still
						// contain matching code points.
						// E.g. we have `[0, 11, 14, 31]` and want to remove 4-20
						// → `[0, 4, 21, 31]`.
					}
	
					// Check if only `rangeEnd` is within the bounds of this pair.
					// E.g. we have `[14, 31]` and want to remove 4-20 → `[21, 31]`.
					else if (rangeEnd >= start && rangeEnd <= end) {
							// Just replace `start`.
							data[index] = rangeEnd + 1;
							return data;
						}
	
					index += 2;
				}
				return data;
			};
	
			var dataAdd = function dataAdd(data, codePoint) {
				// Iterate over the data per `(start, end)` pair.
				var index = 0;
				var start;
				var end;
				var lastIndex = null;
				var length = data.length;
				if (codePoint < 0x0 || codePoint > 0x10FFFF) {
					throw RangeError(ERRORS.codePointRange);
				}
				while (index < length) {
					start = data[index];
					end = data[index + 1];
	
					// Check if the code point is already in the set.
					if (codePoint >= start && codePoint < end) {
						return data;
					}
	
					if (codePoint == start - 1) {
						// Just replace `start` with a new value.
						data[index] = codePoint;
						return data;
					}
	
					// At this point, if `start` is `greater` than `codePoint`, insert a new
					// `[start, end]` pair before the current pair, or after the current pair
					// if there is a known `lastIndex`.
					if (start > codePoint) {
						data.splice(lastIndex != null ? lastIndex + 2 : 0, 0, codePoint, codePoint + 1);
						return data;
					}
	
					if (codePoint == end) {
						// Check if adding this code point causes two separate ranges to become
						// a single range, e.g. `dataAdd([0, 4, 5, 10], 4)` → `[0, 10]`.
						if (codePoint + 1 == data[index + 2]) {
							data.splice(index, 4, start, data[index + 3]);
							return data;
						}
						// Else, just replace `end` with a new value.
						data[index + 1] = codePoint + 1;
						return data;
					}
					lastIndex = index;
					index += 2;
				}
				// The loop has finished; add the new pair to the end of the data set.
				data.push(codePoint, codePoint + 1);
				return data;
			};
	
			var dataAddData = function dataAddData(dataA, dataB) {
				// Iterate over the data per `(start, end)` pair.
				var index = 0;
				var start;
				var end;
				var data = dataA.slice();
				var length = dataB.length;
				while (index < length) {
					start = dataB[index];
					end = dataB[index + 1] - 1;
					if (start == end) {
						data = dataAdd(data, start);
					} else {
						data = dataAddRange(data, start, end);
					}
					index += 2;
				}
				return data;
			};
	
			var dataRemoveData = function dataRemoveData(dataA, dataB) {
				// Iterate over the data per `(start, end)` pair.
				var index = 0;
				var start;
				var end;
				var data = dataA.slice();
				var length = dataB.length;
				while (index < length) {
					start = dataB[index];
					end = dataB[index + 1] - 1;
					if (start == end) {
						data = dataRemove(data, start);
					} else {
						data = dataRemoveRange(data, start, end);
					}
					index += 2;
				}
				return data;
			};
	
			var dataAddRange = function dataAddRange(data, rangeStart, rangeEnd) {
				if (rangeEnd < rangeStart) {
					throw Error(ERRORS.rangeOrder);
				}
				if (rangeStart < 0x0 || rangeStart > 0x10FFFF || rangeEnd < 0x0 || rangeEnd > 0x10FFFF) {
					throw RangeError(ERRORS.codePointRange);
				}
				// Iterate over the data per `(start, end)` pair.
				var index = 0;
				var start;
				var end;
				var added = false;
				var length = data.length;
				while (index < length) {
					start = data[index];
					end = data[index + 1];
	
					if (added) {
						// The range has already been added to the set; at this point, we just
						// need to get rid of the following ranges in case they overlap.
	
						// Check if this range can be combined with the previous range.
						if (start == rangeEnd + 1) {
							data.splice(index - 1, 2);
							return data;
						}
	
						// Exit as soon as no more possibly overlapping pairs can be found.
						if (start > rangeEnd) {
							return data;
						}
	
						// E.g. `[0, 11, 12, 16]` and we’ve added 5-15, so we now have
						// `[0, 16, 12, 16]`. Remove the `12,16` part, as it lies within the
						// `0,16` range that was previously added.
						if (start >= rangeStart && start <= rangeEnd) {
							// `start` lies within the range that was previously added.
	
							if (end > rangeStart && end - 1 <= rangeEnd) {
								// `end` lies within the range that was previously added as well,
								// so remove this pair.
								data.splice(index, 2);
								index -= 2;
								// Note: we cannot `return` just yet, as there may still be other
								// overlapping pairs.
							} else {
								// `start` lies within the range that was previously added, but
								// `end` doesn’t. E.g. `[0, 11, 12, 31]` and we’ve added 5-15, so
								// now we have `[0, 16, 12, 31]`. This must be written as `[0, 31]`.
								// Remove the previously added `end` and the current `start`.
								data.splice(index - 1, 2);
								index -= 2;
							}
	
							// Note: we cannot return yet.
						}
					} else if (start == rangeEnd + 1) {
						data[index] = rangeStart;
						return data;
					}
	
					// Check if a new pair must be inserted *before* the current one.
					else if (start > rangeEnd) {
							data.splice(index, 0, rangeStart, rangeEnd + 1);
							return data;
						} else if (rangeStart >= start && rangeStart < end && rangeEnd + 1 <= end) {
							// The new range lies entirely within an existing range pair. No action
							// needed.
							return data;
						} else if (
						// E.g. `[0, 11]` and you add 5-15 → `[0, 16]`.
						rangeStart >= start && rangeStart < end ||
						// E.g. `[0, 3]` and you add 3-6 → `[0, 7]`.
						end == rangeStart) {
							// Replace `end` with the new value.
							data[index + 1] = rangeEnd + 1;
							// Make sure the next range pair doesn’t overlap, e.g. `[0, 11, 12, 14]`
							// and you add 5-15 → `[0, 16]`, i.e. remove the `12,14` part.
							added = true;
							// Note: we cannot `return` just yet.
						} else if (rangeStart <= start && rangeEnd + 1 >= end) {
							// The new range is a superset of the old range.
							data[index] = rangeStart;
							data[index + 1] = rangeEnd + 1;
							added = true;
						}
	
					index += 2;
				}
				// The loop has finished without doing anything; add the new pair to the end
				// of the data set.
				if (!added) {
					data.push(rangeStart, rangeEnd + 1);
				}
				return data;
			};
	
			var dataContains = function dataContains(data, codePoint) {
				var index = 0;
				var length = data.length;
				// Exit early if `codePoint` is not within `data`’s overall range.
				var start = data[index];
				var end = data[length - 1];
				if (length >= 2) {
					if (codePoint < start || codePoint > end) {
						return false;
					}
				}
				// Iterate over the data per `(start, end)` pair.
				while (index < length) {
					start = data[index];
					end = data[index + 1];
					if (codePoint >= start && codePoint < end) {
						return true;
					}
					index += 2;
				}
				return false;
			};
	
			var dataIntersection = function dataIntersection(data, codePoints) {
				var index = 0;
				var length = codePoints.length;
				var codePoint;
				var result = [];
				while (index < length) {
					codePoint = codePoints[index];
					if (dataContains(data, codePoint)) {
						result.push(codePoint);
					}
					++index;
				}
				return dataFromCodePoints(result);
			};
	
			var dataIsEmpty = function dataIsEmpty(data) {
				return !data.length;
			};
	
			var dataIsSingleton = function dataIsSingleton(data) {
				// Check if the set only represents a single code point.
				return data.length == 2 && data[0] + 1 == data[1];
			};
	
			var dataToArray = function dataToArray(data) {
				// Iterate over the data per `(start, end)` pair.
				var index = 0;
				var start;
				var end;
				var result = [];
				var length = data.length;
				while (index < length) {
					start = data[index];
					end = data[index + 1];
					while (start < end) {
						result.push(start);
						++start;
					}
					index += 2;
				}
				return result;
			};
	
			/*--------------------------------------------------------------------------*/
	
			// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
			var floor = Math.floor;
			var highSurrogate = function highSurrogate(codePoint) {
				return parseInt(floor((codePoint - 0x10000) / 0x400) + HIGH_SURROGATE_MIN, 10);
			};
	
			var lowSurrogate = function lowSurrogate(codePoint) {
				return parseInt((codePoint - 0x10000) % 0x400 + LOW_SURROGATE_MIN, 10);
			};
	
			var stringFromCharCode = String.fromCharCode;
			var codePointToString = function codePointToString(codePoint) {
				var string;
				// https://mathiasbynens.be/notes/javascript-escapes#single
				// Note: the `\b` escape sequence for U+0008 BACKSPACE in strings has a
				// different meaning in regular expressions (word boundary), so it cannot
				// be used here.
				if (codePoint == 0x09) {
					string = '\\t';
				}
				// Note: IE < 9 treats `'\v'` as `'v'`, so avoid using it.
				// else if (codePoint == 0x0B) {
				// 	string = '\\v';
				// }
				else if (codePoint == 0x0A) {
						string = '\\n';
					} else if (codePoint == 0x0C) {
						string = '\\f';
					} else if (codePoint == 0x0D) {
						string = '\\r';
					} else if (codePoint == 0x5C) {
						string = '\\\\';
					} else if (codePoint == 0x24 || codePoint >= 0x28 && codePoint <= 0x2B || codePoint == 0x2D || codePoint == 0x2E || codePoint == 0x3F || codePoint >= 0x5B && codePoint <= 0x5E || codePoint >= 0x7B && codePoint <= 0x7D) {
						// The code point maps to an unsafe printable ASCII character;
						// backslash-escape it. Here’s the list of those symbols:
						//
						//     $()*+-.?[\]^{|}
						//
						// See #7 for more info.
						string = '\\' + stringFromCharCode(codePoint);
					} else if (codePoint >= 0x20 && codePoint <= 0x7E) {
						// The code point maps to one of these printable ASCII symbols
						// (including the space character):
						//
						//      !"#%&',/0123456789:;<=>@ABCDEFGHIJKLMNO
						//     PQRSTUVWXYZ_`abcdefghijklmnopqrstuvwxyz~
						//
						// These can safely be used directly.
						string = stringFromCharCode(codePoint);
					} else if (codePoint <= 0xFF) {
						// https://mathiasbynens.be/notes/javascript-escapes#hexadecimal
						string = '\\x' + pad(hex(codePoint), 2);
					} else {
						// `codePoint <= 0xFFFF` holds true.
						// https://mathiasbynens.be/notes/javascript-escapes#unicode
						string = '\\u' + pad(hex(codePoint), 4);
					}
	
				// There’s no need to account for astral symbols / surrogate pairs here,
				// since `codePointToString` is private and only used for BMP code points.
				// But if that’s what you need, just add an `else` block with this code:
				//
				//     string = '\\u' + pad(hex(highSurrogate(codePoint)), 4)
				//     	+ '\\u' + pad(hex(lowSurrogate(codePoint)), 4);
	
				return string;
			};
	
			var codePointToStringUnicode = function codePointToStringUnicode(codePoint) {
				if (codePoint <= 0xFFFF) {
					return codePointToString(codePoint);
				}
				return '\\u{' + codePoint.toString(16).toUpperCase() + '}';
			};
	
			var symbolToCodePoint = function symbolToCodePoint(symbol) {
				var length = symbol.length;
				var first = symbol.charCodeAt(0);
				var second;
				if (first >= HIGH_SURROGATE_MIN && first <= HIGH_SURROGATE_MAX && length > 1 // There is a next code unit.
				) {
						// `first` is a high surrogate, and there is a next character. Assume
						// it’s a low surrogate (else it’s invalid usage of Regenerate anyway).
						second = symbol.charCodeAt(1);
						// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
						return (first - HIGH_SURROGATE_MIN) * 0x400 + second - LOW_SURROGATE_MIN + 0x10000;
					}
				return first;
			};
	
			var createBMPCharacterClasses = function createBMPCharacterClasses(data) {
				// Iterate over the data per `(start, end)` pair.
				var result = '';
				var index = 0;
				var start;
				var end;
				var length = data.length;
				if (dataIsSingleton(data)) {
					return codePointToString(data[0]);
				}
				while (index < length) {
					start = data[index];
					end = data[index + 1] - 1; // Note: the `- 1` makes `end` inclusive.
					if (start == end) {
						result += codePointToString(start);
					} else if (start + 1 == end) {
						result += codePointToString(start) + codePointToString(end);
					} else {
						result += codePointToString(start) + '-' + codePointToString(end);
					}
					index += 2;
				}
				return '[' + result + ']';
			};
	
			var createUnicodeCharacterClasses = function createUnicodeCharacterClasses(data) {
				// Iterate over the data per `(start, end)` pair.
				var result = '';
				var index = 0;
				var start;
				var end;
				var length = data.length;
				if (dataIsSingleton(data)) {
					return codePointToStringUnicode(data[0]);
				}
				while (index < length) {
					start = data[index];
					end = data[index + 1] - 1; // Note: the `- 1` makes `end` inclusive.
					if (start == end) {
						result += codePointToStringUnicode(start);
					} else if (start + 1 == end) {
						result += codePointToStringUnicode(start) + codePointToStringUnicode(end);
					} else {
						result += codePointToStringUnicode(start) + '-' + codePointToStringUnicode(end);
					}
					index += 2;
				}
				return '[' + result + ']';
			};
	
			var splitAtBMP = function splitAtBMP(data) {
				// Iterate over the data per `(start, end)` pair.
				var loneHighSurrogates = [];
				var loneLowSurrogates = [];
				var bmp = [];
				var astral = [];
				var index = 0;
				var start;
				var end;
				var length = data.length;
				while (index < length) {
					start = data[index];
					end = data[index + 1] - 1; // Note: the `- 1` makes `end` inclusive.
	
					if (start < HIGH_SURROGATE_MIN) {
	
						// The range starts and ends before the high surrogate range.
						// E.g. (0, 0x10).
						if (end < HIGH_SURROGATE_MIN) {
							bmp.push(start, end + 1);
						}
	
						// The range starts before the high surrogate range and ends within it.
						// E.g. (0, 0xD855).
						if (end >= HIGH_SURROGATE_MIN && end <= HIGH_SURROGATE_MAX) {
							bmp.push(start, HIGH_SURROGATE_MIN);
							loneHighSurrogates.push(HIGH_SURROGATE_MIN, end + 1);
						}
	
						// The range starts before the high surrogate range and ends in the low
						// surrogate range. E.g. (0, 0xDCFF).
						if (end >= LOW_SURROGATE_MIN && end <= LOW_SURROGATE_MAX) {
							bmp.push(start, HIGH_SURROGATE_MIN);
							loneHighSurrogates.push(HIGH_SURROGATE_MIN, HIGH_SURROGATE_MAX + 1);
							loneLowSurrogates.push(LOW_SURROGATE_MIN, end + 1);
						}
	
						// The range starts before the high surrogate range and ends after the
						// low surrogate range. E.g. (0, 0x10FFFF).
						if (end > LOW_SURROGATE_MAX) {
							bmp.push(start, HIGH_SURROGATE_MIN);
							loneHighSurrogates.push(HIGH_SURROGATE_MIN, HIGH_SURROGATE_MAX + 1);
							loneLowSurrogates.push(LOW_SURROGATE_MIN, LOW_SURROGATE_MAX + 1);
							if (end <= 0xFFFF) {
								bmp.push(LOW_SURROGATE_MAX + 1, end + 1);
							} else {
								bmp.push(LOW_SURROGATE_MAX + 1, 0xFFFF + 1);
								astral.push(0xFFFF + 1, end + 1);
							}
						}
					} else if (start >= HIGH_SURROGATE_MIN && start <= HIGH_SURROGATE_MAX) {
	
						// The range starts and ends in the high surrogate range.
						// E.g. (0xD855, 0xD866).
						if (end >= HIGH_SURROGATE_MIN && end <= HIGH_SURROGATE_MAX) {
							loneHighSurrogates.push(start, end + 1);
						}
	
						// The range starts in the high surrogate range and ends in the low
						// surrogate range. E.g. (0xD855, 0xDCFF).
						if (end >= LOW_SURROGATE_MIN && end <= LOW_SURROGATE_MAX) {
							loneHighSurrogates.push(start, HIGH_SURROGATE_MAX + 1);
							loneLowSurrogates.push(LOW_SURROGATE_MIN, end + 1);
						}
	
						// The range starts in the high surrogate range and ends after the low
						// surrogate range. E.g. (0xD855, 0x10FFFF).
						if (end > LOW_SURROGATE_MAX) {
							loneHighSurrogates.push(start, HIGH_SURROGATE_MAX + 1);
							loneLowSurrogates.push(LOW_SURROGATE_MIN, LOW_SURROGATE_MAX + 1);
							if (end <= 0xFFFF) {
								bmp.push(LOW_SURROGATE_MAX + 1, end + 1);
							} else {
								bmp.push(LOW_SURROGATE_MAX + 1, 0xFFFF + 1);
								astral.push(0xFFFF + 1, end + 1);
							}
						}
					} else if (start >= LOW_SURROGATE_MIN && start <= LOW_SURROGATE_MAX) {
	
						// The range starts and ends in the low surrogate range.
						// E.g. (0xDCFF, 0xDDFF).
						if (end >= LOW_SURROGATE_MIN && end <= LOW_SURROGATE_MAX) {
							loneLowSurrogates.push(start, end + 1);
						}
	
						// The range starts in the low surrogate range and ends after the low
						// surrogate range. E.g. (0xDCFF, 0x10FFFF).
						if (end > LOW_SURROGATE_MAX) {
							loneLowSurrogates.push(start, LOW_SURROGATE_MAX + 1);
							if (end <= 0xFFFF) {
								bmp.push(LOW_SURROGATE_MAX + 1, end + 1);
							} else {
								bmp.push(LOW_SURROGATE_MAX + 1, 0xFFFF + 1);
								astral.push(0xFFFF + 1, end + 1);
							}
						}
					} else if (start > LOW_SURROGATE_MAX && start <= 0xFFFF) {
	
						// The range starts and ends after the low surrogate range.
						// E.g. (0xFFAA, 0x10FFFF).
						if (end <= 0xFFFF) {
							bmp.push(start, end + 1);
						} else {
							bmp.push(start, 0xFFFF + 1);
							astral.push(0xFFFF + 1, end + 1);
						}
					} else {
	
						// The range starts and ends in the astral range.
						astral.push(start, end + 1);
					}
	
					index += 2;
				}
				return {
					'loneHighSurrogates': loneHighSurrogates,
					'loneLowSurrogates': loneLowSurrogates,
					'bmp': bmp,
					'astral': astral
				};
			};
	
			var optimizeSurrogateMappings = function optimizeSurrogateMappings(surrogateMappings) {
				var result = [];
				var tmpLow = [];
				var addLow = false;
				var mapping;
				var nextMapping;
				var highSurrogates;
				var lowSurrogates;
				var nextHighSurrogates;
				var nextLowSurrogates;
				var index = -1;
				var length = surrogateMappings.length;
				while (++index < length) {
					mapping = surrogateMappings[index];
					nextMapping = surrogateMappings[index + 1];
					if (!nextMapping) {
						result.push(mapping);
						continue;
					}
					highSurrogates = mapping[0];
					lowSurrogates = mapping[1];
					nextHighSurrogates = nextMapping[0];
					nextLowSurrogates = nextMapping[1];
	
					// Check for identical high surrogate ranges.
					tmpLow = lowSurrogates;
					while (nextHighSurrogates && highSurrogates[0] == nextHighSurrogates[0] && highSurrogates[1] == nextHighSurrogates[1]) {
						// Merge with the next item.
						if (dataIsSingleton(nextLowSurrogates)) {
							tmpLow = dataAdd(tmpLow, nextLowSurrogates[0]);
						} else {
							tmpLow = dataAddRange(tmpLow, nextLowSurrogates[0], nextLowSurrogates[1] - 1);
						}
						++index;
						mapping = surrogateMappings[index];
						highSurrogates = mapping[0];
						lowSurrogates = mapping[1];
						nextMapping = surrogateMappings[index + 1];
						nextHighSurrogates = nextMapping && nextMapping[0];
						nextLowSurrogates = nextMapping && nextMapping[1];
						addLow = true;
					}
					result.push([highSurrogates, addLow ? tmpLow : lowSurrogates]);
					addLow = false;
				}
				return optimizeByLowSurrogates(result);
			};
	
			var optimizeByLowSurrogates = function optimizeByLowSurrogates(surrogateMappings) {
				if (surrogateMappings.length == 1) {
					return surrogateMappings;
				}
				var index = -1;
				var innerIndex = -1;
				while (++index < surrogateMappings.length) {
					var mapping = surrogateMappings[index];
					var lowSurrogates = mapping[1];
					var lowSurrogateStart = lowSurrogates[0];
					var lowSurrogateEnd = lowSurrogates[1];
					innerIndex = index; // Note: the loop starts at the next index.
					while (++innerIndex < surrogateMappings.length) {
						var otherMapping = surrogateMappings[innerIndex];
						var otherLowSurrogates = otherMapping[1];
						var otherLowSurrogateStart = otherLowSurrogates[0];
						var otherLowSurrogateEnd = otherLowSurrogates[1];
						if (lowSurrogateStart == otherLowSurrogateStart && lowSurrogateEnd == otherLowSurrogateEnd) {
							// Add the code points in the other item to this one.
							if (dataIsSingleton(otherMapping[0])) {
								mapping[0] = dataAdd(mapping[0], otherMapping[0][0]);
							} else {
								mapping[0] = dataAddRange(mapping[0], otherMapping[0][0], otherMapping[0][1] - 1);
							}
							// Remove the other, now redundant, item.
							surrogateMappings.splice(innerIndex, 1);
							--innerIndex;
						}
					}
				}
				return surrogateMappings;
			};
	
			var surrogateSet = function surrogateSet(data) {
				// Exit early if `data` is an empty set.
				if (!data.length) {
					return [];
				}
	
				// Iterate over the data per `(start, end)` pair.
				var index = 0;
				var start;
				var end;
				var startHigh;
				var startLow;
				var endHigh;
				var endLow;
				var surrogateMappings = [];
				var length = data.length;
				while (index < length) {
					start = data[index];
					end = data[index + 1] - 1;
	
					startHigh = highSurrogate(start);
					startLow = lowSurrogate(start);
					endHigh = highSurrogate(end);
					endLow = lowSurrogate(end);
	
					var startsWithLowestLowSurrogate = startLow == LOW_SURROGATE_MIN;
					var endsWithHighestLowSurrogate = endLow == LOW_SURROGATE_MAX;
					var complete = false;
	
					// Append the previous high-surrogate-to-low-surrogate mappings.
					// Step 1: `(startHigh, startLow)` to `(startHigh, LOW_SURROGATE_MAX)`.
					if (startHigh == endHigh || startsWithLowestLowSurrogate && endsWithHighestLowSurrogate) {
						surrogateMappings.push([[startHigh, endHigh + 1], [startLow, endLow + 1]]);
						complete = true;
					} else {
						surrogateMappings.push([[startHigh, startHigh + 1], [startLow, LOW_SURROGATE_MAX + 1]]);
					}
	
					// Step 2: `(startHigh + 1, LOW_SURROGATE_MIN)` to
					// `(endHigh - 1, LOW_SURROGATE_MAX)`.
					if (!complete && startHigh + 1 < endHigh) {
						if (endsWithHighestLowSurrogate) {
							// Combine step 2 and step 3.
							surrogateMappings.push([[startHigh + 1, endHigh + 1], [LOW_SURROGATE_MIN, endLow + 1]]);
							complete = true;
						} else {
							surrogateMappings.push([[startHigh + 1, endHigh], [LOW_SURROGATE_MIN, LOW_SURROGATE_MAX + 1]]);
						}
					}
	
					// Step 3. `(endHigh, LOW_SURROGATE_MIN)` to `(endHigh, endLow)`.
					if (!complete) {
						surrogateMappings.push([[endHigh, endHigh + 1], [LOW_SURROGATE_MIN, endLow + 1]]);
					}
	
					index += 2;
				}
	
				// The format of `surrogateMappings` is as follows:
				//
				//     [ surrogateMapping1, surrogateMapping2 ]
				//
				// i.e.:
				//
				//     [
				//       [ highSurrogates1, lowSurrogates1 ],
				//       [ highSurrogates2, lowSurrogates2 ]
				//     ]
				return optimizeSurrogateMappings(surrogateMappings);
			};
	
			var createSurrogateCharacterClasses = function createSurrogateCharacterClasses(surrogateMappings) {
				var result = [];
				forEach(surrogateMappings, function (surrogateMapping) {
					var highSurrogates = surrogateMapping[0];
					var lowSurrogates = surrogateMapping[1];
					result.push(createBMPCharacterClasses(highSurrogates) + createBMPCharacterClasses(lowSurrogates));
				});
				return result.join('|');
			};
	
			var createCharacterClassesFromData = function createCharacterClassesFromData(data, bmpOnly, hasUnicodeFlag) {
				if (hasUnicodeFlag) {
					return createUnicodeCharacterClasses(data);
				}
				var result = [];
	
				var parts = splitAtBMP(data);
				var loneHighSurrogates = parts.loneHighSurrogates;
				var loneLowSurrogates = parts.loneLowSurrogates;
				var bmp = parts.bmp;
				var astral = parts.astral;
				var hasLoneHighSurrogates = !dataIsEmpty(loneHighSurrogates);
				var hasLoneLowSurrogates = !dataIsEmpty(loneLowSurrogates);
	
				var surrogateMappings = surrogateSet(astral);
	
				if (bmpOnly) {
					bmp = dataAddData(bmp, loneHighSurrogates);
					hasLoneHighSurrogates = false;
					bmp = dataAddData(bmp, loneLowSurrogates);
					hasLoneLowSurrogates = false;
				}
	
				if (!dataIsEmpty(bmp)) {
					// The data set contains BMP code points that are not high surrogates
					// needed for astral code points in the set.
					result.push(createBMPCharacterClasses(bmp));
				}
				if (surrogateMappings.length) {
					// The data set contains astral code points; append character classes
					// based on their surrogate pairs.
					result.push(createSurrogateCharacterClasses(surrogateMappings));
				}
				// https://gist.github.com/mathiasbynens/bbe7f870208abcfec860
				if (hasLoneHighSurrogates) {
					result.push(createBMPCharacterClasses(loneHighSurrogates) +
					// Make sure the high surrogates aren’t part of a surrogate pair.
					'(?![\\uDC00-\\uDFFF])');
				}
				if (hasLoneLowSurrogates) {
					result.push(
					// It is not possible to accurately assert the low surrogates aren’t
					// part of a surrogate pair, since JavaScript regular expressions do
					// not support lookbehind.
					'(?:[^\\uD800-\\uDBFF]|^)' + createBMPCharacterClasses(loneLowSurrogates));
				}
				return result.join('|');
			};
	
			/*--------------------------------------------------------------------------*/
	
			// `regenerate` can be used as a constructor (and new methods can be added to
			// its prototype) but also as a regular function, the latter of which is the
			// documented and most common usage. For that reason, it’s not capitalized.
			var regenerate = function regenerate(value) {
				if (arguments.length > 1) {
					value = slice.call(arguments);
				}
				if (this instanceof regenerate) {
					this.data = [];
					return value ? this.add(value) : this;
				}
				return new regenerate().add(value);
			};
	
			regenerate.version = '1.3.2';
	
			var proto = regenerate.prototype;
			extend(proto, {
				'add': function add(value) {
					var $this = this;
					if (value == null) {
						return $this;
					}
					if (value instanceof regenerate) {
						// Allow passing other Regenerate instances.
						$this.data = dataAddData($this.data, value.data);
						return $this;
					}
					if (arguments.length > 1) {
						value = slice.call(arguments);
					}
					if (isArray(value)) {
						forEach(value, function (item) {
							$this.add(item);
						});
						return $this;
					}
					$this.data = dataAdd($this.data, isNumber(value) ? value : symbolToCodePoint(value));
					return $this;
				},
				'remove': function remove(value) {
					var $this = this;
					if (value == null) {
						return $this;
					}
					if (value instanceof regenerate) {
						// Allow passing other Regenerate instances.
						$this.data = dataRemoveData($this.data, value.data);
						return $this;
					}
					if (arguments.length > 1) {
						value = slice.call(arguments);
					}
					if (isArray(value)) {
						forEach(value, function (item) {
							$this.remove(item);
						});
						return $this;
					}
					$this.data = dataRemove($this.data, isNumber(value) ? value : symbolToCodePoint(value));
					return $this;
				},
				'addRange': function addRange(start, end) {
					var $this = this;
					$this.data = dataAddRange($this.data, isNumber(start) ? start : symbolToCodePoint(start), isNumber(end) ? end : symbolToCodePoint(end));
					return $this;
				},
				'removeRange': function removeRange(start, end) {
					var $this = this;
					var startCodePoint = isNumber(start) ? start : symbolToCodePoint(start);
					var endCodePoint = isNumber(end) ? end : symbolToCodePoint(end);
					$this.data = dataRemoveRange($this.data, startCodePoint, endCodePoint);
					return $this;
				},
				'intersection': function intersection(argument) {
					var $this = this;
					// Allow passing other Regenerate instances.
					// TODO: Optimize this by writing and using `dataIntersectionData()`.
					var array = argument instanceof regenerate ? dataToArray(argument.data) : argument;
					$this.data = dataIntersection($this.data, array);
					return $this;
				},
				'contains': function contains(codePoint) {
					return dataContains(this.data, isNumber(codePoint) ? codePoint : symbolToCodePoint(codePoint));
				},
				'clone': function clone() {
					var set = new regenerate();
					set.data = this.data.slice(0);
					return set;
				},
				'toString': function toString(options) {
					var result = createCharacterClassesFromData(this.data, options ? options.bmpOnly : false, options ? options.hasUnicodeFlag : false);
					if (!result) {
						// For an empty set, return something that can be inserted `/here/` to
						// form a valid regular expression. Avoid `(?:)` since that matches the
						// empty string.
						return '[]';
					}
					// Use `\0` instead of `\x00` where possible.
					return result.replace(regexNull, '\\0$1');
				},
				'toRegExp': function toRegExp(flags) {
					var pattern = this.toString(flags && flags.indexOf('u') != -1 ? { 'hasUnicodeFlag': true } : null);
					return RegExp(pattern, flags || '');
				},
				'valueOf': function valueOf() {
					// Note: `valueOf` is aliased as `toArray`.
					return dataToArray(this.data);
				}
			});
	
			proto.toArray = proto.valueOf;
	
			// Some AMD build optimizers, like r.js, check for specific condition patterns
			// like the following:
			if ("function" == 'function' && _typeof(__webpack_require__(49)) == 'object' && __webpack_require__(49)) {
				!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
					return regenerate;
				}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			} else if (freeExports && !freeExports.nodeType) {
				if (freeModule) {
					// in Node.js, io.js, or RingoJS v0.8.0+
					freeModule.exports = regenerate;
				} else {
					// in Narwhal or RingoJS v0.7.0-
					freeExports.regenerate = regenerate;
				}
			} else {
				// in Rhino or a web browser
				root.regenerate = regenerate;
			}
		})(undefined);
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)(module), (function() { return this; }())))
	
	/***/ }),
	/* 283 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _stringify = __webpack_require__(35);
	
		var _stringify2 = _interopRequireDefault(_stringify);
	
		var _assert = __webpack_require__(64);
	
		var _assert2 = _interopRequireDefault(_assert);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		var _leap = __webpack_require__(607);
	
		var leap = _interopRequireWildcard(_leap);
	
		var _meta = __webpack_require__(608);
	
		var meta = _interopRequireWildcard(_meta);
	
		var _util = __webpack_require__(116);
	
		var util = _interopRequireWildcard(_util);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var hasOwn = Object.prototype.hasOwnProperty; /**
		                                               * Copyright (c) 2014, Facebook, Inc.
		                                               * All rights reserved.
		                                               *
		                                               * This source code is licensed under the BSD-style license found in the
		                                               * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
		                                               * additional grant of patent rights can be found in the PATENTS file in
		                                               * the same directory.
		                                               */
	
		function Emitter(contextId) {
		  _assert2.default.ok(this instanceof Emitter);
		  t.assertIdentifier(contextId);
	
		  // Used to generate unique temporary names.
		  this.nextTempId = 0;
	
		  // In order to make sure the context object does not collide with
		  // anything in the local scope, we might have to rename it, so we
		  // refer to it symbolically instead of just assuming that it will be
		  // called "context".
		  this.contextId = contextId;
	
		  // An append-only list of Statements that grows each time this.emit is
		  // called.
		  this.listing = [];
	
		  // A sparse array whose keys correspond to locations in this.listing
		  // that have been marked as branch/jump targets.
		  this.marked = [true];
	
		  // The last location will be marked when this.getDispatchLoop is
		  // called.
		  this.finalLoc = loc();
	
		  // A list of all leap.TryEntry statements emitted.
		  this.tryEntries = [];
	
		  // Each time we evaluate the body of a loop, we tell this.leapManager
		  // to enter a nested loop context that determines the meaning of break
		  // and continue statements therein.
		  this.leapManager = new leap.LeapManager(this);
		}
	
		var Ep = Emitter.prototype;
		exports.Emitter = Emitter;
	
		// Offsets into this.listing that could be used as targets for branches or
		// jumps are represented as numeric Literal nodes. This representation has
		// the amazingly convenient benefit of allowing the exact value of the
		// location to be determined at any time, even after generating code that
		// refers to the location.
		function loc() {
		  return t.numericLiteral(-1);
		}
	
		// Sets the exact value of the given location to the offset of the next
		// Statement emitted.
		Ep.mark = function (loc) {
		  t.assertLiteral(loc);
		  var index = this.listing.length;
		  if (loc.value === -1) {
		    loc.value = index;
		  } else {
		    // Locations can be marked redundantly, but their values cannot change
		    // once set the first time.
		    _assert2.default.strictEqual(loc.value, index);
		  }
		  this.marked[index] = true;
		  return loc;
		};
	
		Ep.emit = function (node) {
		  if (t.isExpression(node)) {
		    node = t.expressionStatement(node);
		  }
	
		  t.assertStatement(node);
		  this.listing.push(node);
		};
	
		// Shorthand for emitting assignment statements. This will come in handy
		// for assignments to temporary variables.
		Ep.emitAssign = function (lhs, rhs) {
		  this.emit(this.assign(lhs, rhs));
		  return lhs;
		};
	
		// Shorthand for an assignment statement.
		Ep.assign = function (lhs, rhs) {
		  return t.expressionStatement(t.assignmentExpression("=", lhs, rhs));
		};
	
		// Convenience function for generating expressions like context.next,
		// context.sent, and context.rval.
		Ep.contextProperty = function (name, computed) {
		  return t.memberExpression(this.contextId, computed ? t.stringLiteral(name) : t.identifier(name), !!computed);
		};
	
		// Shorthand for setting context.rval and jumping to `context.stop()`.
		Ep.stop = function (rval) {
		  if (rval) {
		    this.setReturnValue(rval);
		  }
	
		  this.jump(this.finalLoc);
		};
	
		Ep.setReturnValue = function (valuePath) {
		  t.assertExpression(valuePath.value);
	
		  this.emitAssign(this.contextProperty("rval"), this.explodeExpression(valuePath));
		};
	
		Ep.clearPendingException = function (tryLoc, assignee) {
		  t.assertLiteral(tryLoc);
	
		  var catchCall = t.callExpression(this.contextProperty("catch", true), [tryLoc]);
	
		  if (assignee) {
		    this.emitAssign(assignee, catchCall);
		  } else {
		    this.emit(catchCall);
		  }
		};
	
		// Emits code for an unconditional jump to the given location, even if the
		// exact value of the location is not yet known.
		Ep.jump = function (toLoc) {
		  this.emitAssign(this.contextProperty("next"), toLoc);
		  this.emit(t.breakStatement());
		};
	
		// Conditional jump.
		Ep.jumpIf = function (test, toLoc) {
		  t.assertExpression(test);
		  t.assertLiteral(toLoc);
	
		  this.emit(t.ifStatement(test, t.blockStatement([this.assign(this.contextProperty("next"), toLoc), t.breakStatement()])));
		};
	
		// Conditional jump, with the condition negated.
		Ep.jumpIfNot = function (test, toLoc) {
		  t.assertExpression(test);
		  t.assertLiteral(toLoc);
	
		  var negatedTest = void 0;
		  if (t.isUnaryExpression(test) && test.operator === "!") {
		    // Avoid double negation.
		    negatedTest = test.argument;
		  } else {
		    negatedTest = t.unaryExpression("!", test);
		  }
	
		  this.emit(t.ifStatement(negatedTest, t.blockStatement([this.assign(this.contextProperty("next"), toLoc), t.breakStatement()])));
		};
	
		// Returns a unique MemberExpression that can be used to store and
		// retrieve temporary values. Since the object of the member expression is
		// the context object, which is presumed to coexist peacefully with all
		// other local variables, and since we just increment `nextTempId`
		// monotonically, uniqueness is assured.
		Ep.makeTempVar = function () {
		  return this.contextProperty("t" + this.nextTempId++);
		};
	
		Ep.getContextFunction = function (id) {
		  return t.functionExpression(id || null /*Anonymous*/
		  , [this.contextId], t.blockStatement([this.getDispatchLoop()]), false, // Not a generator anymore!
		  false // Nor an expression.
		  );
		};
	
		// Turns this.listing into a loop of the form
		//
		//   while (1) switch (context.next) {
		//   case 0:
		//   ...
		//   case n:
		//     return context.stop();
		//   }
		//
		// Each marked location in this.listing will correspond to one generated
		// case statement.
		Ep.getDispatchLoop = function () {
		  var self = this;
		  var cases = [];
		  var current = void 0;
	
		  // If we encounter a break, continue, or return statement in a switch
		  // case, we can skip the rest of the statements until the next case.
		  var alreadyEnded = false;
	
		  self.listing.forEach(function (stmt, i) {
		    if (self.marked.hasOwnProperty(i)) {
		      cases.push(t.switchCase(t.numericLiteral(i), current = []));
		      alreadyEnded = false;
		    }
	
		    if (!alreadyEnded) {
		      current.push(stmt);
		      if (t.isCompletionStatement(stmt)) alreadyEnded = true;
		    }
		  });
	
		  // Now that we know how many statements there will be in this.listing,
		  // we can finally resolve this.finalLoc.value.
		  this.finalLoc.value = this.listing.length;
	
		  cases.push(t.switchCase(this.finalLoc, [
		    // Intentionally fall through to the "end" case...
		  ]),
	
		  // So that the runtime can jump to the final location without having
		  // to know its offset, we provide the "end" case as a synonym.
		  t.switchCase(t.stringLiteral("end"), [
		  // This will check/clear both context.thrown and context.rval.
		  t.returnStatement(t.callExpression(this.contextProperty("stop"), []))]));
	
		  return t.whileStatement(t.numericLiteral(1), t.switchStatement(t.assignmentExpression("=", this.contextProperty("prev"), this.contextProperty("next")), cases));
		};
	
		Ep.getTryLocsList = function () {
		  if (this.tryEntries.length === 0) {
		    // To avoid adding a needless [] to the majority of runtime.wrap
		    // argument lists, force the caller to handle this case specially.
		    return null;
		  }
	
		  var lastLocValue = 0;
	
		  return t.arrayExpression(this.tryEntries.map(function (tryEntry) {
		    var thisLocValue = tryEntry.firstLoc.value;
		    _assert2.default.ok(thisLocValue >= lastLocValue, "try entries out of order");
		    lastLocValue = thisLocValue;
	
		    var ce = tryEntry.catchEntry;
		    var fe = tryEntry.finallyEntry;
	
		    var locs = [tryEntry.firstLoc,
		    // The null here makes a hole in the array.
		    ce ? ce.firstLoc : null];
	
		    if (fe) {
		      locs[2] = fe.firstLoc;
		      locs[3] = fe.afterLoc;
		    }
	
		    return t.arrayExpression(locs);
		  }));
		};
	
		// All side effects must be realized in order.
	
		// If any subexpression harbors a leap, all subexpressions must be
		// neutered of side effects.
	
		// No destructive modification of AST nodes.
	
		Ep.explode = function (path, ignoreResult) {
		  var node = path.node;
		  var self = this;
	
		  t.assertNode(node);
	
		  if (t.isDeclaration(node)) throw getDeclError(node);
	
		  if (t.isStatement(node)) return self.explodeStatement(path);
	
		  if (t.isExpression(node)) return self.explodeExpression(path, ignoreResult);
	
		  switch (node.type) {
		    case "Program":
		      return path.get("body").map(self.explodeStatement, self);
	
		    case "VariableDeclarator":
		      throw getDeclError(node);
	
		    // These node types should be handled by their parent nodes
		    // (ObjectExpression, SwitchStatement, and TryStatement, respectively).
		    case "Property":
		    case "SwitchCase":
		    case "CatchClause":
		      throw new Error(node.type + " nodes should be handled by their parents");
	
		    default:
		      throw new Error("unknown Node of type " + (0, _stringify2.default)(node.type));
		  }
		};
	
		function getDeclError(node) {
		  return new Error("all declarations should have been transformed into " + "assignments before the Exploder began its work: " + (0, _stringify2.default)(node));
		}
	
		Ep.explodeStatement = function (path, labelId) {
		  var stmt = path.node;
		  var self = this;
		  var before = void 0,
		      after = void 0,
		      head = void 0;
	
		  t.assertStatement(stmt);
	
		  if (labelId) {
		    t.assertIdentifier(labelId);
		  } else {
		    labelId = null;
		  }
	
		  // Explode BlockStatement nodes even if they do not contain a yield,
		  // because we don't want or need the curly braces.
		  if (t.isBlockStatement(stmt)) {
		    path.get("body").forEach(function (path) {
		      self.explodeStatement(path);
		    });
		    return;
		  }
	
		  if (!meta.containsLeap(stmt)) {
		    // Technically we should be able to avoid emitting the statement
		    // altogether if !meta.hasSideEffects(stmt), but that leads to
		    // confusing generated code (for instance, `while (true) {}` just
		    // disappears) and is probably a more appropriate job for a dedicated
		    // dead code elimination pass.
		    self.emit(stmt);
		    return;
		  }
	
		  switch (stmt.type) {
		    case "ExpressionStatement":
		      self.explodeExpression(path.get("expression"), true);
		      break;
	
		    case "LabeledStatement":
		      after = loc();
	
		      // Did you know you can break from any labeled block statement or
		      // control structure? Well, you can! Note: when a labeled loop is
		      // encountered, the leap.LabeledEntry created here will immediately
		      // enclose a leap.LoopEntry on the leap manager's stack, and both
		      // entries will have the same label. Though this works just fine, it
		      // may seem a bit redundant. In theory, we could check here to
		      // determine if stmt knows how to handle its own label; for example,
		      // stmt happens to be a WhileStatement and so we know it's going to
		      // establish its own LoopEntry when we explode it (below). Then this
		      // LabeledEntry would be unnecessary. Alternatively, we might be
		      // tempted not to pass stmt.label down into self.explodeStatement,
		      // because we've handled the label here, but that's a mistake because
		      // labeled loops may contain labeled continue statements, which is not
		      // something we can handle in this generic case. All in all, I think a
		      // little redundancy greatly simplifies the logic of this case, since
		      // it's clear that we handle all possible LabeledStatements correctly
		      // here, regardless of whether they interact with the leap manager
		      // themselves. Also remember that labels and break/continue-to-label
		      // statements are rare, and all of this logic happens at transform
		      // time, so it has no additional runtime cost.
		      self.leapManager.withEntry(new leap.LabeledEntry(after, stmt.label), function () {
		        self.explodeStatement(path.get("body"), stmt.label);
		      });
	
		      self.mark(after);
	
		      break;
	
		    case "WhileStatement":
		      before = loc();
		      after = loc();
	
		      self.mark(before);
		      self.jumpIfNot(self.explodeExpression(path.get("test")), after);
		      self.leapManager.withEntry(new leap.LoopEntry(after, before, labelId), function () {
		        self.explodeStatement(path.get("body"));
		      });
		      self.jump(before);
		      self.mark(after);
	
		      break;
	
		    case "DoWhileStatement":
		      var first = loc();
		      var test = loc();
		      after = loc();
	
		      self.mark(first);
		      self.leapManager.withEntry(new leap.LoopEntry(after, test, labelId), function () {
		        self.explode(path.get("body"));
		      });
		      self.mark(test);
		      self.jumpIf(self.explodeExpression(path.get("test")), first);
		      self.mark(after);
	
		      break;
	
		    case "ForStatement":
		      head = loc();
		      var update = loc();
		      after = loc();
	
		      if (stmt.init) {
		        // We pass true here to indicate that if stmt.init is an expression
		        // then we do not care about its result.
		        self.explode(path.get("init"), true);
		      }
	
		      self.mark(head);
	
		      if (stmt.test) {
		        self.jumpIfNot(self.explodeExpression(path.get("test")), after);
		      } else {
		        // No test means continue unconditionally.
		      }
	
		      self.leapManager.withEntry(new leap.LoopEntry(after, update, labelId), function () {
		        self.explodeStatement(path.get("body"));
		      });
	
		      self.mark(update);
	
		      if (stmt.update) {
		        // We pass true here to indicate that if stmt.update is an
		        // expression then we do not care about its result.
		        self.explode(path.get("update"), true);
		      }
	
		      self.jump(head);
	
		      self.mark(after);
	
		      break;
	
		    case "TypeCastExpression":
		      return self.explodeExpression(path.get("expression"));
	
		    case "ForInStatement":
		      head = loc();
		      after = loc();
	
		      var keyIterNextFn = self.makeTempVar();
		      self.emitAssign(keyIterNextFn, t.callExpression(util.runtimeProperty("keys"), [self.explodeExpression(path.get("right"))]));
	
		      self.mark(head);
	
		      var keyInfoTmpVar = self.makeTempVar();
		      self.jumpIf(t.memberExpression(t.assignmentExpression("=", keyInfoTmpVar, t.callExpression(keyIterNextFn, [])), t.identifier("done"), false), after);
	
		      self.emitAssign(stmt.left, t.memberExpression(keyInfoTmpVar, t.identifier("value"), false));
	
		      self.leapManager.withEntry(new leap.LoopEntry(after, head, labelId), function () {
		        self.explodeStatement(path.get("body"));
		      });
	
		      self.jump(head);
	
		      self.mark(after);
	
		      break;
	
		    case "BreakStatement":
		      self.emitAbruptCompletion({
		        type: "break",
		        target: self.leapManager.getBreakLoc(stmt.label)
		      });
	
		      break;
	
		    case "ContinueStatement":
		      self.emitAbruptCompletion({
		        type: "continue",
		        target: self.leapManager.getContinueLoc(stmt.label)
		      });
	
		      break;
	
		    case "SwitchStatement":
		      // Always save the discriminant into a temporary variable in case the
		      // test expressions overwrite values like context.sent.
		      var disc = self.emitAssign(self.makeTempVar(), self.explodeExpression(path.get("discriminant")));
	
		      after = loc();
		      var defaultLoc = loc();
		      var condition = defaultLoc;
		      var caseLocs = [];
	
		      // If there are no cases, .cases might be undefined.
		      var cases = stmt.cases || [];
	
		      for (var i = cases.length - 1; i >= 0; --i) {
		        var c = cases[i];
		        t.assertSwitchCase(c);
	
		        if (c.test) {
		          condition = t.conditionalExpression(t.binaryExpression("===", disc, c.test), caseLocs[i] = loc(), condition);
		        } else {
		          caseLocs[i] = defaultLoc;
		        }
		      }
	
		      var discriminant = path.get("discriminant");
		      util.replaceWithOrRemove(discriminant, condition);
		      self.jump(self.explodeExpression(discriminant));
	
		      self.leapManager.withEntry(new leap.SwitchEntry(after), function () {
		        path.get("cases").forEach(function (casePath) {
		          var i = casePath.key;
		          self.mark(caseLocs[i]);
	
		          casePath.get("consequent").forEach(function (path) {
		            self.explodeStatement(path);
		          });
		        });
		      });
	
		      self.mark(after);
		      if (defaultLoc.value === -1) {
		        self.mark(defaultLoc);
		        _assert2.default.strictEqual(after.value, defaultLoc.value);
		      }
	
		      break;
	
		    case "IfStatement":
		      var elseLoc = stmt.alternate && loc();
		      after = loc();
	
		      self.jumpIfNot(self.explodeExpression(path.get("test")), elseLoc || after);
	
		      self.explodeStatement(path.get("consequent"));
	
		      if (elseLoc) {
		        self.jump(after);
		        self.mark(elseLoc);
		        self.explodeStatement(path.get("alternate"));
		      }
	
		      self.mark(after);
	
		      break;
	
		    case "ReturnStatement":
		      self.emitAbruptCompletion({
		        type: "return",
		        value: self.explodeExpression(path.get("argument"))
		      });
	
		      break;
	
		    case "WithStatement":
		      throw new Error("WithStatement not supported in generator functions.");
	
		    case "TryStatement":
		      after = loc();
	
		      var handler = stmt.handler;
	
		      var catchLoc = handler && loc();
		      var catchEntry = catchLoc && new leap.CatchEntry(catchLoc, handler.param);
	
		      var finallyLoc = stmt.finalizer && loc();
		      var finallyEntry = finallyLoc && new leap.FinallyEntry(finallyLoc, after);
	
		      var tryEntry = new leap.TryEntry(self.getUnmarkedCurrentLoc(), catchEntry, finallyEntry);
	
		      self.tryEntries.push(tryEntry);
		      self.updateContextPrevLoc(tryEntry.firstLoc);
	
		      self.leapManager.withEntry(tryEntry, function () {
		        self.explodeStatement(path.get("block"));
	
		        if (catchLoc) {
		          if (finallyLoc) {
		            // If we have both a catch block and a finally block, then
		            // because we emit the catch block first, we need to jump over
		            // it to the finally block.
		            self.jump(finallyLoc);
		          } else {
		            // If there is no finally block, then we need to jump over the
		            // catch block to the fall-through location.
		            self.jump(after);
		          }
	
		          self.updateContextPrevLoc(self.mark(catchLoc));
	
		          var bodyPath = path.get("handler.body");
		          var safeParam = self.makeTempVar();
		          self.clearPendingException(tryEntry.firstLoc, safeParam);
	
		          bodyPath.traverse(catchParamVisitor, {
		            safeParam: safeParam,
		            catchParamName: handler.param.name
		          });
	
		          self.leapManager.withEntry(catchEntry, function () {
		            self.explodeStatement(bodyPath);
		          });
		        }
	
		        if (finallyLoc) {
		          self.updateContextPrevLoc(self.mark(finallyLoc));
	
		          self.leapManager.withEntry(finallyEntry, function () {
		            self.explodeStatement(path.get("finalizer"));
		          });
	
		          self.emit(t.returnStatement(t.callExpression(self.contextProperty("finish"), [finallyEntry.firstLoc])));
		        }
		      });
	
		      self.mark(after);
	
		      break;
	
		    case "ThrowStatement":
		      self.emit(t.throwStatement(self.explodeExpression(path.get("argument"))));
	
		      break;
	
		    default:
		      throw new Error("unknown Statement of type " + (0, _stringify2.default)(stmt.type));
		  }
		};
	
		var catchParamVisitor = {
		  Identifier: function Identifier(path, state) {
		    if (path.node.name === state.catchParamName && util.isReference(path)) {
		      util.replaceWithOrRemove(path, state.safeParam);
		    }
		  },
	
		  Scope: function Scope(path, state) {
		    if (path.scope.hasOwnBinding(state.catchParamName)) {
		      // Don't descend into nested scopes that shadow the catch
		      // parameter with their own declarations.
		      path.skip();
		    }
		  }
		};
	
		Ep.emitAbruptCompletion = function (record) {
		  if (!isValidCompletion(record)) {
		    _assert2.default.ok(false, "invalid completion record: " + (0, _stringify2.default)(record));
		  }
	
		  _assert2.default.notStrictEqual(record.type, "normal", "normal completions are not abrupt");
	
		  var abruptArgs = [t.stringLiteral(record.type)];
	
		  if (record.type === "break" || record.type === "continue") {
		    t.assertLiteral(record.target);
		    abruptArgs[1] = record.target;
		  } else if (record.type === "return" || record.type === "throw") {
		    if (record.value) {
		      t.assertExpression(record.value);
		      abruptArgs[1] = record.value;
		    }
		  }
	
		  this.emit(t.returnStatement(t.callExpression(this.contextProperty("abrupt"), abruptArgs)));
		};
	
		function isValidCompletion(record) {
		  var type = record.type;
	
		  if (type === "normal") {
		    return !hasOwn.call(record, "target");
		  }
	
		  if (type === "break" || type === "continue") {
		    return !hasOwn.call(record, "value") && t.isLiteral(record.target);
		  }
	
		  if (type === "return" || type === "throw") {
		    return hasOwn.call(record, "value") && !hasOwn.call(record, "target");
		  }
	
		  return false;
		}
	
		// Not all offsets into emitter.listing are potential jump targets. For
		// example, execution typically falls into the beginning of a try block
		// without jumping directly there. This method returns the current offset
		// without marking it, so that a switch case will not necessarily be
		// generated for this offset (I say "not necessarily" because the same
		// location might end up being marked in the process of emitting other
		// statements). There's no logical harm in marking such locations as jump
		// targets, but minimizing the number of switch cases keeps the generated
		// code shorter.
		Ep.getUnmarkedCurrentLoc = function () {
		  return t.numericLiteral(this.listing.length);
		};
	
		// The context.prev property takes the value of context.next whenever we
		// evaluate the switch statement discriminant, which is generally good
		// enough for tracking the last location we jumped to, but sometimes
		// context.prev needs to be more precise, such as when we fall
		// successfully out of a try block and into a finally block without
		// jumping. This method exists to update context.prev to the freshest
		// available location. If we were implementing a full interpreter, we
		// would know the location of the current instruction with complete
		// precision at all times, but we don't have that luxury here, as it would
		// be costly and verbose to set context.prev before every statement.
		Ep.updateContextPrevLoc = function (loc) {
		  if (loc) {
		    t.assertLiteral(loc);
	
		    if (loc.value === -1) {
		      // If an uninitialized location literal was passed in, set its value
		      // to the current this.listing.length.
		      loc.value = this.listing.length;
		    } else {
		      // Otherwise assert that the location matches the current offset.
		      _assert2.default.strictEqual(loc.value, this.listing.length);
		    }
		  } else {
		    loc = this.getUnmarkedCurrentLoc();
		  }
	
		  // Make sure context.prev is up to date in case we fell into this try
		  // statement without jumping to it. TODO Consider avoiding this
		  // assignment when we know control must have jumped here.
		  this.emitAssign(this.contextProperty("prev"), loc);
		};
	
		Ep.explodeExpression = function (path, ignoreResult) {
		  var expr = path.node;
		  if (expr) {
		    t.assertExpression(expr);
		  } else {
		    return expr;
		  }
	
		  var self = this;
		  var result = void 0; // Used optionally by several cases below.
		  var after = void 0;
	
		  function finish(expr) {
		    t.assertExpression(expr);
		    if (ignoreResult) {
		      self.emit(expr);
		    } else {
		      return expr;
		    }
		  }
	
		  // If the expression does not contain a leap, then we either emit the
		  // expression as a standalone statement or return it whole.
		  if (!meta.containsLeap(expr)) {
		    return finish(expr);
		  }
	
		  // If any child contains a leap (such as a yield or labeled continue or
		  // break statement), then any sibling subexpressions will almost
		  // certainly have to be exploded in order to maintain the order of their
		  // side effects relative to the leaping child(ren).
		  var hasLeapingChildren = meta.containsLeap.onlyChildren(expr);
	
		  // In order to save the rest of explodeExpression from a combinatorial
		  // trainwreck of special cases, explodeViaTempVar is responsible for
		  // deciding when a subexpression needs to be "exploded," which is my
		  // very technical term for emitting the subexpression as an assignment
		  // to a temporary variable and the substituting the temporary variable
		  // for the original subexpression. Think of exploded view diagrams, not
		  // Michael Bay movies. The point of exploding subexpressions is to
		  // control the precise order in which the generated code realizes the
		  // side effects of those subexpressions.
		  function explodeViaTempVar(tempVar, childPath, ignoreChildResult) {
		    _assert2.default.ok(!ignoreChildResult || !tempVar, "Ignoring the result of a child expression but forcing it to " + "be assigned to a temporary variable?");
	
		    var result = self.explodeExpression(childPath, ignoreChildResult);
	
		    if (ignoreChildResult) {
		      // Side effects already emitted above.
	
		    } else if (tempVar || hasLeapingChildren && !t.isLiteral(result)) {
		      // If tempVar was provided, then the result will always be assigned
		      // to it, even if the result does not otherwise need to be assigned
		      // to a temporary variable.  When no tempVar is provided, we have
		      // the flexibility to decide whether a temporary variable is really
		      // necessary.  Unfortunately, in general, a temporary variable is
		      // required whenever any child contains a yield expression, since it
		      // is difficult to prove (at all, let alone efficiently) whether
		      // this result would evaluate to the same value before and after the
		      // yield (see #206).  One narrow case where we can prove it doesn't
		      // matter (and thus we do not need a temporary variable) is when the
		      // result in question is a Literal value.
		      result = self.emitAssign(tempVar || self.makeTempVar(), result);
		    }
		    return result;
		  }
	
		  // If ignoreResult is true, then we must take full responsibility for
		  // emitting the expression with all its side effects, and we should not
		  // return a result.
	
		  switch (expr.type) {
		    case "MemberExpression":
		      return finish(t.memberExpression(self.explodeExpression(path.get("object")), expr.computed ? explodeViaTempVar(null, path.get("property")) : expr.property, expr.computed));
	
		    case "CallExpression":
		      var calleePath = path.get("callee");
		      var argsPath = path.get("arguments");
	
		      var newCallee = void 0;
		      var newArgs = [];
	
		      var hasLeapingArgs = false;
		      argsPath.forEach(function (argPath) {
		        hasLeapingArgs = hasLeapingArgs || meta.containsLeap(argPath.node);
		      });
	
		      if (t.isMemberExpression(calleePath.node)) {
		        if (hasLeapingArgs) {
		          // If the arguments of the CallExpression contained any yield
		          // expressions, then we need to be sure to evaluate the callee
		          // before evaluating the arguments, but if the callee was a member
		          // expression, then we must be careful that the object of the
		          // member expression still gets bound to `this` for the call.
	
		          var newObject = explodeViaTempVar(
		          // Assign the exploded callee.object expression to a temporary
		          // variable so that we can use it twice without reevaluating it.
		          self.makeTempVar(), calleePath.get("object"));
	
		          var newProperty = calleePath.node.computed ? explodeViaTempVar(null, calleePath.get("property")) : calleePath.node.property;
	
		          newArgs.unshift(newObject);
	
		          newCallee = t.memberExpression(t.memberExpression(newObject, newProperty, calleePath.node.computed), t.identifier("call"), false);
		        } else {
		          newCallee = self.explodeExpression(calleePath);
		        }
		      } else {
		        newCallee = explodeViaTempVar(null, calleePath);
	
		        if (t.isMemberExpression(newCallee)) {
		          // If the callee was not previously a MemberExpression, then the
		          // CallExpression was "unqualified," meaning its `this` object
		          // should be the global object. If the exploded expression has
		          // become a MemberExpression (e.g. a context property, probably a
		          // temporary variable), then we need to force it to be unqualified
		          // by using the (0, object.property)(...) trick; otherwise, it
		          // will receive the object of the MemberExpression as its `this`
		          // object.
		          newCallee = t.sequenceExpression([t.numericLiteral(0), newCallee]);
		        }
		      }
	
		      argsPath.forEach(function (argPath) {
		        newArgs.push(explodeViaTempVar(null, argPath));
		      });
	
		      return finish(t.callExpression(newCallee, newArgs));
	
		    case "NewExpression":
		      return finish(t.newExpression(explodeViaTempVar(null, path.get("callee")), path.get("arguments").map(function (argPath) {
		        return explodeViaTempVar(null, argPath);
		      })));
	
		    case "ObjectExpression":
		      return finish(t.objectExpression(path.get("properties").map(function (propPath) {
		        if (propPath.isObjectProperty()) {
		          return t.objectProperty(propPath.node.key, explodeViaTempVar(null, propPath.get("value")), propPath.node.computed);
		        } else {
		          return propPath.node;
		        }
		      })));
	
		    case "ArrayExpression":
		      return finish(t.arrayExpression(path.get("elements").map(function (elemPath) {
		        return explodeViaTempVar(null, elemPath);
		      })));
	
		    case "SequenceExpression":
		      var lastIndex = expr.expressions.length - 1;
	
		      path.get("expressions").forEach(function (exprPath) {
		        if (exprPath.key === lastIndex) {
		          result = self.explodeExpression(exprPath, ignoreResult);
		        } else {
		          self.explodeExpression(exprPath, true);
		        }
		      });
	
		      return result;
	
		    case "LogicalExpression":
		      after = loc();
	
		      if (!ignoreResult) {
		        result = self.makeTempVar();
		      }
	
		      var left = explodeViaTempVar(result, path.get("left"));
	
		      if (expr.operator === "&&") {
		        self.jumpIfNot(left, after);
		      } else {
		        _assert2.default.strictEqual(expr.operator, "||");
		        self.jumpIf(left, after);
		      }
	
		      explodeViaTempVar(result, path.get("right"), ignoreResult);
	
		      self.mark(after);
	
		      return result;
	
		    case "ConditionalExpression":
		      var elseLoc = loc();
		      after = loc();
		      var test = self.explodeExpression(path.get("test"));
	
		      self.jumpIfNot(test, elseLoc);
	
		      if (!ignoreResult) {
		        result = self.makeTempVar();
		      }
	
		      explodeViaTempVar(result, path.get("consequent"), ignoreResult);
		      self.jump(after);
	
		      self.mark(elseLoc);
		      explodeViaTempVar(result, path.get("alternate"), ignoreResult);
	
		      self.mark(after);
	
		      return result;
	
		    case "UnaryExpression":
		      return finish(t.unaryExpression(expr.operator,
		      // Can't (and don't need to) break up the syntax of the argument.
		      // Think about delete a[b].
		      self.explodeExpression(path.get("argument")), !!expr.prefix));
	
		    case "BinaryExpression":
		      return finish(t.binaryExpression(expr.operator, explodeViaTempVar(null, path.get("left")), explodeViaTempVar(null, path.get("right"))));
	
		    case "AssignmentExpression":
		      return finish(t.assignmentExpression(expr.operator, self.explodeExpression(path.get("left")), self.explodeExpression(path.get("right"))));
	
		    case "UpdateExpression":
		      return finish(t.updateExpression(expr.operator, self.explodeExpression(path.get("argument")), expr.prefix));
	
		    case "YieldExpression":
		      after = loc();
		      var arg = expr.argument && self.explodeExpression(path.get("argument"));
	
		      if (arg && expr.delegate) {
		        var _result = self.makeTempVar();
	
		        self.emit(t.returnStatement(t.callExpression(self.contextProperty("delegateYield"), [arg, t.stringLiteral(_result.property.name), after])));
	
		        self.mark(after);
	
		        return _result;
		      }
	
		      self.emitAssign(self.contextProperty("next"), after);
		      self.emit(t.returnStatement(arg || null));
		      self.mark(after);
	
		      return self.contextProperty("sent");
	
		    default:
		      throw new Error("unknown Expression of type " + (0, _stringify2.default)(expr.type));
		  }
		};
	
	/***/ }),
	/* 284 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		module.exports = function (str) {
			var isExtendedLengthPath = /^\\\\\?\\/.test(str);
			var hasNonAscii = /[^\x00-\x80]+/.test(str);
	
			if (isExtendedLengthPath || hasNonAscii) {
				return str;
			}
	
			return str.replace(/\\/g, '/');
		};
	
	/***/ }),
	/* 285 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		var util = __webpack_require__(63);
		var has = Object.prototype.hasOwnProperty;
	
		/**
		 * A data structure which is a combination of an array and a set. Adding a new
		 * member is O(1), testing for membership is O(1), and finding the index of an
		 * element is O(1). Removing elements from the set is not supported. Only
		 * strings are supported for membership.
		 */
		function ArraySet() {
		  this._array = [];
		  this._set = Object.create(null);
		}
	
		/**
		 * Static method for creating ArraySet instances from an existing array.
		 */
		ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
		  var set = new ArraySet();
		  for (var i = 0, len = aArray.length; i < len; i++) {
		    set.add(aArray[i], aAllowDuplicates);
		  }
		  return set;
		};
	
		/**
		 * Return how many unique items are in this ArraySet. If duplicates have been
		 * added, than those do not count towards the size.
		 *
		 * @returns Number
		 */
		ArraySet.prototype.size = function ArraySet_size() {
		  return Object.getOwnPropertyNames(this._set).length;
		};
	
		/**
		 * Add the given string to this set.
		 *
		 * @param String aStr
		 */
		ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
		  var sStr = util.toSetString(aStr);
		  var isDuplicate = has.call(this._set, sStr);
		  var idx = this._array.length;
		  if (!isDuplicate || aAllowDuplicates) {
		    this._array.push(aStr);
		  }
		  if (!isDuplicate) {
		    this._set[sStr] = idx;
		  }
		};
	
		/**
		 * Is the given string a member of this set?
		 *
		 * @param String aStr
		 */
		ArraySet.prototype.has = function ArraySet_has(aStr) {
		  var sStr = util.toSetString(aStr);
		  return has.call(this._set, sStr);
		};
	
		/**
		 * What is the index of the given string in the array?
		 *
		 * @param String aStr
		 */
		ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
		  var sStr = util.toSetString(aStr);
		  if (has.call(this._set, sStr)) {
		    return this._set[sStr];
		  }
		  throw new Error('"' + aStr + '" is not in the set.');
		};
	
		/**
		 * What is the element at the given index?
		 *
		 * @param Number aIdx
		 */
		ArraySet.prototype.at = function ArraySet_at(aIdx) {
		  if (aIdx >= 0 && aIdx < this._array.length) {
		    return this._array[aIdx];
		  }
		  throw new Error('No element indexed by ' + aIdx);
		};
	
		/**
		 * Returns the array representation of this set (which has the proper indices
		 * indicated by indexOf). Note that this is a copy of the internal array used
		 * for storing the members so that no one can mess with internal state.
		 */
		ArraySet.prototype.toArray = function ArraySet_toArray() {
		  return this._array.slice();
		};
	
		exports.ArraySet = ArraySet;
	
	/***/ }),
	/* 286 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 *
		 * Based on the Base 64 VLQ implementation in Closure Compiler:
		 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
		 *
		 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
		 * Redistribution and use in source and binary forms, with or without
		 * modification, are permitted provided that the following conditions are
		 * met:
		 *
		 *  * Redistributions of source code must retain the above copyright
		 *    notice, this list of conditions and the following disclaimer.
		 *  * Redistributions in binary form must reproduce the above
		 *    copyright notice, this list of conditions and the following
		 *    disclaimer in the documentation and/or other materials provided
		 *    with the distribution.
		 *  * Neither the name of Google Inc. nor the names of its
		 *    contributors may be used to endorse or promote products derived
		 *    from this software without specific prior written permission.
		 *
		 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
		 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
		 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
		 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
		 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
		 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
		 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
		 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
		 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
		 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
		 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		 */
	
		var base64 = __webpack_require__(616);
	
		// A single base 64 digit can contain 6 bits of data. For the base 64 variable
		// length quantities we use in the source map spec, the first bit is the sign,
		// the next four bits are the actual value, and the 6th bit is the
		// continuation bit. The continuation bit tells us whether there are more
		// digits in this value following this digit.
		//
		//   Continuation
		//   |    Sign
		//   |    |
		//   V    V
		//   101011
	
		var VLQ_BASE_SHIFT = 5;
	
		// binary: 100000
		var VLQ_BASE = 1 << VLQ_BASE_SHIFT;
	
		// binary: 011111
		var VLQ_BASE_MASK = VLQ_BASE - 1;
	
		// binary: 100000
		var VLQ_CONTINUATION_BIT = VLQ_BASE;
	
		/**
		 * Converts from a two-complement value to a value where the sign bit is
		 * placed in the least significant bit.  For example, as decimals:
		 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
		 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
		 */
		function toVLQSigned(aValue) {
		  return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
		}
	
		/**
		 * Converts to a two-complement value from a value where the sign bit is
		 * placed in the least significant bit.  For example, as decimals:
		 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
		 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
		 */
		function fromVLQSigned(aValue) {
		  var isNegative = (aValue & 1) === 1;
		  var shifted = aValue >> 1;
		  return isNegative ? -shifted : shifted;
		}
	
		/**
		 * Returns the base 64 VLQ encoded value.
		 */
		exports.encode = function base64VLQ_encode(aValue) {
		  var encoded = "";
		  var digit;
	
		  var vlq = toVLQSigned(aValue);
	
		  do {
		    digit = vlq & VLQ_BASE_MASK;
		    vlq >>>= VLQ_BASE_SHIFT;
		    if (vlq > 0) {
		      // There are still more digits in this value, so we must make sure the
		      // continuation bit is marked.
		      digit |= VLQ_CONTINUATION_BIT;
		    }
		    encoded += base64.encode(digit);
		  } while (vlq > 0);
	
		  return encoded;
		};
	
		/**
		 * Decodes the next base 64 VLQ value from the given string and returns the
		 * value and the rest of the string via the out parameter.
		 */
		exports.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
		  var strLen = aStr.length;
		  var result = 0;
		  var shift = 0;
		  var continuation, digit;
	
		  do {
		    if (aIndex >= strLen) {
		      throw new Error("Expected more digits in base 64 VLQ value.");
		    }
	
		    digit = base64.decode(aStr.charCodeAt(aIndex++));
		    if (digit === -1) {
		      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
		    }
	
		    continuation = !!(digit & VLQ_CONTINUATION_BIT);
		    digit &= VLQ_BASE_MASK;
		    result = result + (digit << shift);
		    shift += VLQ_BASE_SHIFT;
		  } while (continuation);
	
		  aOutParam.value = fromVLQSigned(result);
		  aOutParam.rest = aIndex;
		};
	
	/***/ }),
	/* 287 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		var base64VLQ = __webpack_require__(286);
		var util = __webpack_require__(63);
		var ArraySet = __webpack_require__(285).ArraySet;
		var MappingList = __webpack_require__(618).MappingList;
	
		/**
		 * An instance of the SourceMapGenerator represents a source map which is
		 * being built incrementally. You may pass an object with the following
		 * properties:
		 *
		 *   - file: The filename of the generated source.
		 *   - sourceRoot: A root for all relative URLs in this source map.
		 */
		function SourceMapGenerator(aArgs) {
		  if (!aArgs) {
		    aArgs = {};
		  }
		  this._file = util.getArg(aArgs, 'file', null);
		  this._sourceRoot = util.getArg(aArgs, 'sourceRoot', null);
		  this._skipValidation = util.getArg(aArgs, 'skipValidation', false);
		  this._sources = new ArraySet();
		  this._names = new ArraySet();
		  this._mappings = new MappingList();
		  this._sourcesContents = null;
		}
	
		SourceMapGenerator.prototype._version = 3;
	
		/**
		 * Creates a new SourceMapGenerator based on a SourceMapConsumer
		 *
		 * @param aSourceMapConsumer The SourceMap.
		 */
		SourceMapGenerator.fromSourceMap = function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
		  var sourceRoot = aSourceMapConsumer.sourceRoot;
		  var generator = new SourceMapGenerator({
		    file: aSourceMapConsumer.file,
		    sourceRoot: sourceRoot
		  });
		  aSourceMapConsumer.eachMapping(function (mapping) {
		    var newMapping = {
		      generated: {
		        line: mapping.generatedLine,
		        column: mapping.generatedColumn
		      }
		    };
	
		    if (mapping.source != null) {
		      newMapping.source = mapping.source;
		      if (sourceRoot != null) {
		        newMapping.source = util.relative(sourceRoot, newMapping.source);
		      }
	
		      newMapping.original = {
		        line: mapping.originalLine,
		        column: mapping.originalColumn
		      };
	
		      if (mapping.name != null) {
		        newMapping.name = mapping.name;
		      }
		    }
	
		    generator.addMapping(newMapping);
		  });
		  aSourceMapConsumer.sources.forEach(function (sourceFile) {
		    var content = aSourceMapConsumer.sourceContentFor(sourceFile);
		    if (content != null) {
		      generator.setSourceContent(sourceFile, content);
		    }
		  });
		  return generator;
		};
	
		/**
		 * Add a single mapping from original source line and column to the generated
		 * source's line and column for this source map being created. The mapping
		 * object should have the following properties:
		 *
		 *   - generated: An object with the generated line and column positions.
		 *   - original: An object with the original line and column positions.
		 *   - source: The original source file (relative to the sourceRoot).
		 *   - name: An optional original token name for this mapping.
		 */
		SourceMapGenerator.prototype.addMapping = function SourceMapGenerator_addMapping(aArgs) {
		  var generated = util.getArg(aArgs, 'generated');
		  var original = util.getArg(aArgs, 'original', null);
		  var source = util.getArg(aArgs, 'source', null);
		  var name = util.getArg(aArgs, 'name', null);
	
		  if (!this._skipValidation) {
		    this._validateMapping(generated, original, source, name);
		  }
	
		  if (source != null) {
		    source = String(source);
		    if (!this._sources.has(source)) {
		      this._sources.add(source);
		    }
		  }
	
		  if (name != null) {
		    name = String(name);
		    if (!this._names.has(name)) {
		      this._names.add(name);
		    }
		  }
	
		  this._mappings.add({
		    generatedLine: generated.line,
		    generatedColumn: generated.column,
		    originalLine: original != null && original.line,
		    originalColumn: original != null && original.column,
		    source: source,
		    name: name
		  });
		};
	
		/**
		 * Set the source content for a source file.
		 */
		SourceMapGenerator.prototype.setSourceContent = function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
		  var source = aSourceFile;
		  if (this._sourceRoot != null) {
		    source = util.relative(this._sourceRoot, source);
		  }
	
		  if (aSourceContent != null) {
		    // Add the source content to the _sourcesContents map.
		    // Create a new _sourcesContents map if the property is null.
		    if (!this._sourcesContents) {
		      this._sourcesContents = Object.create(null);
		    }
		    this._sourcesContents[util.toSetString(source)] = aSourceContent;
		  } else if (this._sourcesContents) {
		    // Remove the source file from the _sourcesContents map.
		    // If the _sourcesContents map is empty, set the property to null.
		    delete this._sourcesContents[util.toSetString(source)];
		    if (Object.keys(this._sourcesContents).length === 0) {
		      this._sourcesContents = null;
		    }
		  }
		};
	
		/**
		 * Applies the mappings of a sub-source-map for a specific source file to the
		 * source map being generated. Each mapping to the supplied source file is
		 * rewritten using the supplied source map. Note: The resolution for the
		 * resulting mappings is the minimium of this map and the supplied map.
		 *
		 * @param aSourceMapConsumer The source map to be applied.
		 * @param aSourceFile Optional. The filename of the source file.
		 *        If omitted, SourceMapConsumer's file property will be used.
		 * @param aSourceMapPath Optional. The dirname of the path to the source map
		 *        to be applied. If relative, it is relative to the SourceMapConsumer.
		 *        This parameter is needed when the two source maps aren't in the same
		 *        directory, and the source map to be applied contains relative source
		 *        paths. If so, those relative source paths need to be rewritten
		 *        relative to the SourceMapGenerator.
		 */
		SourceMapGenerator.prototype.applySourceMap = function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
		  var sourceFile = aSourceFile;
		  // If aSourceFile is omitted, we will use the file property of the SourceMap
		  if (aSourceFile == null) {
		    if (aSourceMapConsumer.file == null) {
		      throw new Error('SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, ' + 'or the source map\'s "file" property. Both were omitted.');
		    }
		    sourceFile = aSourceMapConsumer.file;
		  }
		  var sourceRoot = this._sourceRoot;
		  // Make "sourceFile" relative if an absolute Url is passed.
		  if (sourceRoot != null) {
		    sourceFile = util.relative(sourceRoot, sourceFile);
		  }
		  // Applying the SourceMap can add and remove items from the sources and
		  // the names array.
		  var newSources = new ArraySet();
		  var newNames = new ArraySet();
	
		  // Find mappings for the "sourceFile"
		  this._mappings.unsortedForEach(function (mapping) {
		    if (mapping.source === sourceFile && mapping.originalLine != null) {
		      // Check if it can be mapped by the source map, then update the mapping.
		      var original = aSourceMapConsumer.originalPositionFor({
		        line: mapping.originalLine,
		        column: mapping.originalColumn
		      });
		      if (original.source != null) {
		        // Copy mapping
		        mapping.source = original.source;
		        if (aSourceMapPath != null) {
		          mapping.source = util.join(aSourceMapPath, mapping.source);
		        }
		        if (sourceRoot != null) {
		          mapping.source = util.relative(sourceRoot, mapping.source);
		        }
		        mapping.originalLine = original.line;
		        mapping.originalColumn = original.column;
		        if (original.name != null) {
		          mapping.name = original.name;
		        }
		      }
		    }
	
		    var source = mapping.source;
		    if (source != null && !newSources.has(source)) {
		      newSources.add(source);
		    }
	
		    var name = mapping.name;
		    if (name != null && !newNames.has(name)) {
		      newNames.add(name);
		    }
		  }, this);
		  this._sources = newSources;
		  this._names = newNames;
	
		  // Copy sourcesContents of applied map.
		  aSourceMapConsumer.sources.forEach(function (sourceFile) {
		    var content = aSourceMapConsumer.sourceContentFor(sourceFile);
		    if (content != null) {
		      if (aSourceMapPath != null) {
		        sourceFile = util.join(aSourceMapPath, sourceFile);
		      }
		      if (sourceRoot != null) {
		        sourceFile = util.relative(sourceRoot, sourceFile);
		      }
		      this.setSourceContent(sourceFile, content);
		    }
		  }, this);
		};
	
		/**
		 * A mapping can have one of the three levels of data:
		 *
		 *   1. Just the generated position.
		 *   2. The Generated position, original position, and original source.
		 *   3. Generated and original position, original source, as well as a name
		 *      token.
		 *
		 * To maintain consistency, we validate that any new mapping being added falls
		 * in to one of these categories.
		 */
		SourceMapGenerator.prototype._validateMapping = function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource, aName) {
		  if (aGenerated && 'line' in aGenerated && 'column' in aGenerated && aGenerated.line > 0 && aGenerated.column >= 0 && !aOriginal && !aSource && !aName) {
		    // Case 1.
		    return;
		  } else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated && aOriginal && 'line' in aOriginal && 'column' in aOriginal && aGenerated.line > 0 && aGenerated.column >= 0 && aOriginal.line > 0 && aOriginal.column >= 0 && aSource) {
		    // Cases 2 and 3.
		    return;
		  } else {
		    throw new Error('Invalid mapping: ' + JSON.stringify({
		      generated: aGenerated,
		      source: aSource,
		      original: aOriginal,
		      name: aName
		    }));
		  }
		};
	
		/**
		 * Serialize the accumulated mappings in to the stream of base 64 VLQs
		 * specified by the source map format.
		 */
		SourceMapGenerator.prototype._serializeMappings = function SourceMapGenerator_serializeMappings() {
		  var previousGeneratedColumn = 0;
		  var previousGeneratedLine = 1;
		  var previousOriginalColumn = 0;
		  var previousOriginalLine = 0;
		  var previousName = 0;
		  var previousSource = 0;
		  var result = '';
		  var next;
		  var mapping;
		  var nameIdx;
		  var sourceIdx;
	
		  var mappings = this._mappings.toArray();
		  for (var i = 0, len = mappings.length; i < len; i++) {
		    mapping = mappings[i];
		    next = '';
	
		    if (mapping.generatedLine !== previousGeneratedLine) {
		      previousGeneratedColumn = 0;
		      while (mapping.generatedLine !== previousGeneratedLine) {
		        next += ';';
		        previousGeneratedLine++;
		      }
		    } else {
		      if (i > 0) {
		        if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
		          continue;
		        }
		        next += ',';
		      }
		    }
	
		    next += base64VLQ.encode(mapping.generatedColumn - previousGeneratedColumn);
		    previousGeneratedColumn = mapping.generatedColumn;
	
		    if (mapping.source != null) {
		      sourceIdx = this._sources.indexOf(mapping.source);
		      next += base64VLQ.encode(sourceIdx - previousSource);
		      previousSource = sourceIdx;
	
		      // lines are stored 0-based in SourceMap spec version 3
		      next += base64VLQ.encode(mapping.originalLine - 1 - previousOriginalLine);
		      previousOriginalLine = mapping.originalLine - 1;
	
		      next += base64VLQ.encode(mapping.originalColumn - previousOriginalColumn);
		      previousOriginalColumn = mapping.originalColumn;
	
		      if (mapping.name != null) {
		        nameIdx = this._names.indexOf(mapping.name);
		        next += base64VLQ.encode(nameIdx - previousName);
		        previousName = nameIdx;
		      }
		    }
	
		    result += next;
		  }
	
		  return result;
		};
	
		SourceMapGenerator.prototype._generateSourcesContent = function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
		  return aSources.map(function (source) {
		    if (!this._sourcesContents) {
		      return null;
		    }
		    if (aSourceRoot != null) {
		      source = util.relative(aSourceRoot, source);
		    }
		    var key = util.toSetString(source);
		    return Object.prototype.hasOwnProperty.call(this._sourcesContents, key) ? this._sourcesContents[key] : null;
		  }, this);
		};
	
		/**
		 * Externalize the source map.
		 */
		SourceMapGenerator.prototype.toJSON = function SourceMapGenerator_toJSON() {
		  var map = {
		    version: this._version,
		    sources: this._sources.toArray(),
		    names: this._names.toArray(),
		    mappings: this._serializeMappings()
		  };
		  if (this._file != null) {
		    map.file = this._file;
		  }
		  if (this._sourceRoot != null) {
		    map.sourceRoot = this._sourceRoot;
		  }
		  if (this._sourcesContents) {
		    map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
		  }
	
		  return map;
		};
	
		/**
		 * Render the source map being generated to a string.
		 */
		SourceMapGenerator.prototype.toString = function SourceMapGenerator_toString() {
		  return JSON.stringify(this.toJSON());
		};
	
		exports.SourceMapGenerator = SourceMapGenerator;
	
	/***/ }),
	/* 288 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		/*
		 * Copyright 2009-2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE.txt or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
		exports.SourceMapGenerator = __webpack_require__(287).SourceMapGenerator;
		exports.SourceMapConsumer = __webpack_require__(620).SourceMapConsumer;
		exports.SourceNode = __webpack_require__(621).SourceNode;
	
	/***/ }),
	/* 289 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
		function assembleStyles() {
			var styles = {
				modifiers: {
					reset: [0, 0],
					bold: [1, 22], // 21 isn't widely supported and 22 does the same thing
					dim: [2, 22],
					italic: [3, 23],
					underline: [4, 24],
					inverse: [7, 27],
					hidden: [8, 28],
					strikethrough: [9, 29]
				},
				colors: {
					black: [30, 39],
					red: [31, 39],
					green: [32, 39],
					yellow: [33, 39],
					blue: [34, 39],
					magenta: [35, 39],
					cyan: [36, 39],
					white: [37, 39],
					gray: [90, 39]
				},
				bgColors: {
					bgBlack: [40, 49],
					bgRed: [41, 49],
					bgGreen: [42, 49],
					bgYellow: [43, 49],
					bgBlue: [44, 49],
					bgMagenta: [45, 49],
					bgCyan: [46, 49],
					bgWhite: [47, 49]
				}
			};
	
			// fix humans
			styles.colors.grey = styles.colors.gray;
	
			Object.keys(styles).forEach(function (groupName) {
				var group = styles[groupName];
	
				Object.keys(group).forEach(function (styleName) {
					var style = group[styleName];
	
					styles[styleName] = group[styleName] = {
						open: '\x1B[' + style[0] + 'm',
						close: '\x1B[' + style[1] + 'm'
					};
				});
	
				Object.defineProperty(styles, groupName, {
					value: group,
					enumerable: false
				});
			});
	
			return styles;
		}
	
		Object.defineProperty(module, 'exports', {
			enumerable: true,
			get: assembleStyles
		});
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)(module)))
	
	/***/ }),
	/* 290 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		module.exports = __webpack_require__(182);
	
	/***/ }),
	/* 291 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.default = getPossiblePluginNames;
		function getPossiblePluginNames(pluginName) {
		  return ["babel-plugin-" + pluginName, pluginName];
		}
		module.exports = exports["default"];
	
	/***/ }),
	/* 292 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.default = getPossiblePresetNames;
		function getPossiblePresetNames(presetName) {
		  var possibleNames = ["babel-preset-" + presetName, presetName];
	
		  var matches = presetName.match(/^(@[^/]+)\/(.+)$/);
		  if (matches) {
		    var orgName = matches[1],
		        presetPath = matches[2];
	
		    possibleNames.push(orgName + "/babel-preset-" + presetPath);
		  }
	
		  return possibleNames;
		}
		module.exports = exports["default"];
	
	/***/ }),
	/* 293 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (dest, src) {
		  if (!dest || !src) return;
	
		  return (0, _mergeWith2.default)(dest, src, function (a, b) {
		    if (b && Array.isArray(a)) {
		      var newArray = b.slice(0);
	
		      for (var _iterator = a, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		        var _ref;
	
		        if (_isArray) {
		          if (_i >= _iterator.length) break;
		          _ref = _iterator[_i++];
		        } else {
		          _i = _iterator.next();
		          if (_i.done) break;
		          _ref = _i.value;
		        }
	
		        var item = _ref;
	
		        if (newArray.indexOf(item) < 0) {
		          newArray.push(item);
		        }
		      }
	
		      return newArray;
		    }
		  });
		};
	
		var _mergeWith = __webpack_require__(590);
	
		var _mergeWith2 = _interopRequireDefault(_mergeWith);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 294 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (ast, comments, tokens) {
		  if (ast) {
		    if (ast.type === "Program") {
		      return t.file(ast, comments || [], tokens || []);
		    } else if (ast.type === "File") {
		      return ast;
		    }
		  }
	
		  throw new Error("Not a valid ast?");
		};
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 295 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (whitelist) {
		  var outputType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "global";
	
		  var namespace = t.identifier("babelHelpers");
	
		  var builder = function builder(body) {
		    return buildHelpers(body, namespace, whitelist);
		  };
	
		  var tree = void 0;
	
		  var build = {
		    global: buildGlobal,
		    umd: buildUmd,
		    var: buildVar
		  }[outputType];
	
		  if (build) {
		    tree = build(namespace, builder);
		  } else {
		    throw new Error(messages.get("unsupportedOutputType", outputType));
		  }
	
		  return (0, _babelGenerator2.default)(tree).code;
		};
	
		var _babelHelpers = __webpack_require__(194);
	
		var helpers = _interopRequireWildcard(_babelHelpers);
	
		var _babelGenerator = __webpack_require__(186);
	
		var _babelGenerator2 = _interopRequireDefault(_babelGenerator);
	
		var _babelMessages = __webpack_require__(20);
	
		var messages = _interopRequireWildcard(_babelMessages);
	
		var _babelTemplate = __webpack_require__(4);
	
		var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		var buildUmdWrapper = (0, _babelTemplate2.default)("\n  (function (root, factory) {\n    if (typeof define === \"function\" && define.amd) {\n      define(AMD_ARGUMENTS, factory);\n    } else if (typeof exports === \"object\") {\n      factory(COMMON_ARGUMENTS);\n    } else {\n      factory(BROWSER_ARGUMENTS);\n    }\n  })(UMD_ROOT, function (FACTORY_PARAMETERS) {\n    FACTORY_BODY\n  });\n");
	
		function buildGlobal(namespace, builder) {
		  var body = [];
		  var container = t.functionExpression(null, [t.identifier("global")], t.blockStatement(body));
		  var tree = t.program([t.expressionStatement(t.callExpression(container, [helpers.get("selfGlobal")]))]);
	
		  body.push(t.variableDeclaration("var", [t.variableDeclarator(namespace, t.assignmentExpression("=", t.memberExpression(t.identifier("global"), namespace), t.objectExpression([])))]));
	
		  builder(body);
	
		  return tree;
		}
	
		function buildUmd(namespace, builder) {
		  var body = [];
		  body.push(t.variableDeclaration("var", [t.variableDeclarator(namespace, t.identifier("global"))]));
	
		  builder(body);
	
		  return t.program([buildUmdWrapper({
		    FACTORY_PARAMETERS: t.identifier("global"),
		    BROWSER_ARGUMENTS: t.assignmentExpression("=", t.memberExpression(t.identifier("root"), namespace), t.objectExpression([])),
		    COMMON_ARGUMENTS: t.identifier("exports"),
		    AMD_ARGUMENTS: t.arrayExpression([t.stringLiteral("exports")]),
		    FACTORY_BODY: body,
		    UMD_ROOT: t.identifier("this")
		  })]);
		}
	
		function buildVar(namespace, builder) {
		  var body = [];
		  body.push(t.variableDeclaration("var", [t.variableDeclarator(namespace, t.objectExpression([]))]));
		  builder(body);
		  body.push(t.expressionStatement(namespace));
		  return t.program(body);
		}
	
		function buildHelpers(body, namespace, whitelist) {
		  helpers.list.forEach(function (name) {
		    if (whitelist && whitelist.indexOf(name) < 0) return;
	
		    var key = t.identifier(name);
		    body.push(t.expressionStatement(t.assignmentExpression("=", t.memberExpression(namespace, key), helpers.get(name))));
		  });
		}
		module.exports = exports["default"];
	
	/***/ }),
	/* 296 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _plugin = __webpack_require__(65);
	
		var _plugin2 = _interopRequireDefault(_plugin);
	
		var _sortBy = __webpack_require__(594);
	
		var _sortBy2 = _interopRequireDefault(_sortBy);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		exports.default = new _plugin2.default({
	
		  name: "internal.blockHoist",
	
		  visitor: {
		    Block: {
		      exit: function exit(_ref) {
		        var node = _ref.node;
	
		        var hasChange = false;
		        for (var i = 0; i < node.body.length; i++) {
		          var bodyNode = node.body[i];
		          if (bodyNode && bodyNode._blockHoist != null) {
		            hasChange = true;
		            break;
		          }
		        }
		        if (!hasChange) return;
	
		        node.body = (0, _sortBy2.default)(node.body, function (bodyNode) {
		          var priority = bodyNode && bodyNode._blockHoist;
		          if (priority == null) priority = 1;
		          if (priority === true) priority = 2;
	
		          return -1 * priority;
		        });
		      }
		    }
		  }
		});
		module.exports = exports["default"];
	
	/***/ }),
	/* 297 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _symbol = __webpack_require__(10);
	
		var _symbol2 = _interopRequireDefault(_symbol);
	
		var _plugin = __webpack_require__(65);
	
		var _plugin2 = _interopRequireDefault(_plugin);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var SUPER_THIS_BOUND = (0, _symbol2.default)("super this bound");
	
		var superVisitor = {
		  CallExpression: function CallExpression(path) {
		    if (!path.get("callee").isSuper()) return;
	
		    var node = path.node;
	
		    if (node[SUPER_THIS_BOUND]) return;
		    node[SUPER_THIS_BOUND] = true;
	
		    path.replaceWith(t.assignmentExpression("=", this.id, node));
		  }
		};
	
		exports.default = new _plugin2.default({
		  name: "internal.shadowFunctions",
	
		  visitor: {
		    ThisExpression: function ThisExpression(path) {
		      remap(path, "this");
		    },
		    ReferencedIdentifier: function ReferencedIdentifier(path) {
		      if (path.node.name === "arguments") {
		        remap(path, "arguments");
		      }
		    }
		  }
		});
	
		function shouldShadow(path, shadowPath) {
		  if (path.is("_forceShadow")) {
		    return true;
		  } else {
		    return shadowPath;
		  }
		}
	
		function remap(path, key) {
		  var shadowPath = path.inShadow(key);
		  if (!shouldShadow(path, shadowPath)) return;
	
		  var shadowFunction = path.node._shadowedFunctionLiteral;
	
		  var currentFunction = void 0;
		  var passedShadowFunction = false;
	
		  var fnPath = path.find(function (innerPath) {
		    if (innerPath.parentPath && innerPath.parentPath.isClassProperty() && innerPath.key === "value") {
		      return true;
		    }
		    if (path === innerPath) return false;
		    if (innerPath.isProgram() || innerPath.isFunction()) {
		      currentFunction = currentFunction || innerPath;
		    }
	
		    if (innerPath.isProgram()) {
		      passedShadowFunction = true;
	
		      return true;
		    } else if (innerPath.isFunction() && !innerPath.isArrowFunctionExpression()) {
		      if (shadowFunction) {
		        if (innerPath === shadowFunction || innerPath.node === shadowFunction.node) return true;
		      } else {
		        if (!innerPath.is("shadow")) return true;
		      }
	
		      passedShadowFunction = true;
		      return false;
		    }
	
		    return false;
		  });
	
		  if (shadowFunction && fnPath.isProgram() && !shadowFunction.isProgram()) {
		    fnPath = path.findParent(function (p) {
		      return p.isProgram() || p.isFunction();
		    });
		  }
	
		  if (fnPath === currentFunction) return;
	
		  if (!passedShadowFunction) return;
	
		  var cached = fnPath.getData(key);
		  if (cached) return path.replaceWith(cached);
	
		  var id = path.scope.generateUidIdentifier(key);
	
		  fnPath.setData(key, id);
	
		  var classPath = fnPath.findParent(function (p) {
		    return p.isClass();
		  });
		  var hasSuperClass = !!(classPath && classPath.node && classPath.node.superClass);
	
		  if (key === "this" && fnPath.isMethod({ kind: "constructor" }) && hasSuperClass) {
		    fnPath.scope.push({ id: id });
	
		    fnPath.traverse(superVisitor, { id: id });
		  } else {
		    var init = key === "this" ? t.thisExpression() : t.identifier(key);
	
		    if (shadowFunction) init._shadowedFunctionLiteral = shadowFunction;
	
		    fnPath.scope.push({ id: id, init: init });
		  }
	
		  return path.replaceWith(id);
		}
		module.exports = exports["default"];
	
	/***/ }),
	/* 298 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _normalizeAst = __webpack_require__(294);
	
		var _normalizeAst2 = _interopRequireDefault(_normalizeAst);
	
		var _plugin = __webpack_require__(65);
	
		var _plugin2 = _interopRequireDefault(_plugin);
	
		var _file = __webpack_require__(50);
	
		var _file2 = _interopRequireDefault(_file);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var Pipeline = function () {
		  function Pipeline() {
		    (0, _classCallCheck3.default)(this, Pipeline);
		  }
	
		  Pipeline.prototype.lint = function lint(code) {
		    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		    opts.code = false;
		    opts.mode = "lint";
		    return this.transform(code, opts);
		  };
	
		  Pipeline.prototype.pretransform = function pretransform(code, opts) {
		    var file = new _file2.default(opts, this);
		    return file.wrap(code, function () {
		      file.addCode(code);
		      file.parseCode(code);
		      return file;
		    });
		  };
	
		  Pipeline.prototype.transform = function transform(code, opts) {
		    var file = new _file2.default(opts, this);
		    return file.wrap(code, function () {
		      file.addCode(code);
		      file.parseCode(code);
		      return file.transform();
		    });
		  };
	
		  Pipeline.prototype.analyse = function analyse(code) {
		    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		    var visitor = arguments[2];
	
		    opts.code = false;
		    if (visitor) {
		      opts.plugins = opts.plugins || [];
		      opts.plugins.push(new _plugin2.default({ visitor: visitor }));
		    }
		    return this.transform(code, opts).metadata;
		  };
	
		  Pipeline.prototype.transformFromAst = function transformFromAst(ast, code, opts) {
		    ast = (0, _normalizeAst2.default)(ast);
	
		    var file = new _file2.default(opts, this);
		    return file.wrap(code, function () {
		      file.addCode(code);
		      file.addAst(ast);
		      return file.transform();
		    });
		  };
	
		  return Pipeline;
		}();
	
		exports.default = Pipeline;
		module.exports = exports["default"];
	
	/***/ }),
	/* 299 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(42);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(41);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		var _store = __webpack_require__(119);
	
		var _store2 = _interopRequireDefault(_store);
	
		var _file5 = __webpack_require__(50);
	
		var _file6 = _interopRequireDefault(_file5);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var PluginPass = function (_Store) {
		  (0, _inherits3.default)(PluginPass, _Store);
	
		  function PluginPass(file, plugin) {
		    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
		    (0, _classCallCheck3.default)(this, PluginPass);
	
		    var _this = (0, _possibleConstructorReturn3.default)(this, _Store.call(this));
	
		    _this.plugin = plugin;
		    _this.key = plugin.key;
		    _this.file = file;
		    _this.opts = options;
		    return _this;
		  }
	
		  PluginPass.prototype.addHelper = function addHelper() {
		    var _file;
	
		    return (_file = this.file).addHelper.apply(_file, arguments);
		  };
	
		  PluginPass.prototype.addImport = function addImport() {
		    var _file2;
	
		    return (_file2 = this.file).addImport.apply(_file2, arguments);
		  };
	
		  PluginPass.prototype.getModuleName = function getModuleName() {
		    var _file3;
	
		    return (_file3 = this.file).getModuleName.apply(_file3, arguments);
		  };
	
		  PluginPass.prototype.buildCodeFrameError = function buildCodeFrameError() {
		    var _file4;
	
		    return (_file4 = this.file).buildCodeFrameError.apply(_file4, arguments);
		  };
	
		  return PluginPass;
		}(_store2.default);
	
		exports.default = PluginPass;
		module.exports = exports["default"];
	
	/***/ }),
	/* 300 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _trimRight = __webpack_require__(625);
	
		var _trimRight2 = _interopRequireDefault(_trimRight);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var SPACES_RE = /^[ \t]+$/;
	
		var Buffer = function () {
		  function Buffer(map) {
		    (0, _classCallCheck3.default)(this, Buffer);
		    this._map = null;
		    this._buf = [];
		    this._last = "";
		    this._queue = [];
		    this._position = {
		      line: 1,
		      column: 0
		    };
		    this._sourcePosition = {
		      identifierName: null,
		      line: null,
		      column: null,
		      filename: null
		    };
	
		    this._map = map;
		  }
	
		  Buffer.prototype.get = function get() {
		    this._flush();
	
		    var map = this._map;
		    var result = {
		      code: (0, _trimRight2.default)(this._buf.join("")),
		      map: null,
		      rawMappings: map && map.getRawMappings()
		    };
	
		    if (map) {
		      Object.defineProperty(result, "map", {
		        configurable: true,
		        enumerable: true,
		        get: function get() {
		          return this.map = map.get();
		        },
		        set: function set(value) {
		          Object.defineProperty(this, "map", { value: value, writable: true });
		        }
		      });
		    }
	
		    return result;
		  };
	
		  Buffer.prototype.append = function append(str) {
		    this._flush();
		    var _sourcePosition = this._sourcePosition,
		        line = _sourcePosition.line,
		        column = _sourcePosition.column,
		        filename = _sourcePosition.filename,
		        identifierName = _sourcePosition.identifierName;
	
		    this._append(str, line, column, identifierName, filename);
		  };
	
		  Buffer.prototype.queue = function queue(str) {
		    if (str === "\n") while (this._queue.length > 0 && SPACES_RE.test(this._queue[0][0])) {
		      this._queue.shift();
		    }var _sourcePosition2 = this._sourcePosition,
		        line = _sourcePosition2.line,
		        column = _sourcePosition2.column,
		        filename = _sourcePosition2.filename,
		        identifierName = _sourcePosition2.identifierName;
	
		    this._queue.unshift([str, line, column, identifierName, filename]);
		  };
	
		  Buffer.prototype._flush = function _flush() {
		    var item = void 0;
		    while (item = this._queue.pop()) {
		      this._append.apply(this, item);
		    }
		  };
	
		  Buffer.prototype._append = function _append(str, line, column, identifierName, filename) {
		    if (this._map && str[0] !== "\n") {
		      this._map.mark(this._position.line, this._position.column, line, column, identifierName, filename);
		    }
	
		    this._buf.push(str);
		    this._last = str[str.length - 1];
	
		    for (var i = 0; i < str.length; i++) {
		      if (str[i] === "\n") {
		        this._position.line++;
		        this._position.column = 0;
		      } else {
		        this._position.column++;
		      }
		    }
		  };
	
		  Buffer.prototype.removeTrailingNewline = function removeTrailingNewline() {
		    if (this._queue.length > 0 && this._queue[0][0] === "\n") this._queue.shift();
		  };
	
		  Buffer.prototype.removeLastSemicolon = function removeLastSemicolon() {
		    if (this._queue.length > 0 && this._queue[0][0] === ";") this._queue.shift();
		  };
	
		  Buffer.prototype.endsWith = function endsWith(suffix) {
		    if (suffix.length === 1) {
		      var last = void 0;
		      if (this._queue.length > 0) {
		        var str = this._queue[0][0];
		        last = str[str.length - 1];
		      } else {
		        last = this._last;
		      }
	
		      return last === suffix;
		    }
	
		    var end = this._last + this._queue.reduce(function (acc, item) {
		      return item[0] + acc;
		    }, "");
		    if (suffix.length <= end.length) {
		      return end.slice(-suffix.length) === suffix;
		    }
	
		    return false;
		  };
	
		  Buffer.prototype.hasContent = function hasContent() {
		    return this._queue.length > 0 || !!this._last;
		  };
	
		  Buffer.prototype.source = function source(prop, loc) {
		    if (prop && !loc) return;
	
		    var pos = loc ? loc[prop] : null;
	
		    this._sourcePosition.identifierName = loc && loc.identifierName || null;
		    this._sourcePosition.line = pos ? pos.line : null;
		    this._sourcePosition.column = pos ? pos.column : null;
		    this._sourcePosition.filename = loc && loc.filename || null;
		  };
	
		  Buffer.prototype.withSource = function withSource(prop, loc, cb) {
		    if (!this._map) return cb();
	
		    var originalLine = this._sourcePosition.line;
		    var originalColumn = this._sourcePosition.column;
		    var originalFilename = this._sourcePosition.filename;
		    var originalIdentifierName = this._sourcePosition.identifierName;
	
		    this.source(prop, loc);
	
		    cb();
	
		    this._sourcePosition.line = originalLine;
		    this._sourcePosition.column = originalColumn;
		    this._sourcePosition.filename = originalFilename;
		    this._sourcePosition.identifierName = originalIdentifierName;
		  };
	
		  Buffer.prototype.getCurrentColumn = function getCurrentColumn() {
		    var extra = this._queue.reduce(function (acc, item) {
		      return item[0] + acc;
		    }, "");
		    var lastIndex = extra.lastIndexOf("\n");
	
		    return lastIndex === -1 ? this._position.column + extra.length : extra.length - 1 - lastIndex;
		  };
	
		  Buffer.prototype.getCurrentLine = function getCurrentLine() {
		    var extra = this._queue.reduce(function (acc, item) {
		      return item[0] + acc;
		    }, "");
	
		    var count = 0;
		    for (var i = 0; i < extra.length; i++) {
		      if (extra[i] === "\n") count++;
		    }
	
		    return this._position.line + count;
		  };
	
		  return Buffer;
		}();
	
		exports.default = Buffer;
		module.exports = exports["default"];
	
	/***/ }),
	/* 301 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.File = File;
		exports.Program = Program;
		exports.BlockStatement = BlockStatement;
		exports.Noop = Noop;
		exports.Directive = Directive;
	
		var _types = __webpack_require__(123);
	
		Object.defineProperty(exports, "DirectiveLiteral", {
		  enumerable: true,
		  get: function get() {
		    return _types.StringLiteral;
		  }
		});
		function File(node) {
		  this.print(node.program, node);
		}
	
		function Program(node) {
		  this.printInnerComments(node, false);
	
		  this.printSequence(node.directives, node);
		  if (node.directives && node.directives.length) this.newline();
	
		  this.printSequence(node.body, node);
		}
	
		function BlockStatement(node) {
		  this.token("{");
		  this.printInnerComments(node);
	
		  var hasDirectives = node.directives && node.directives.length;
	
		  if (node.body.length || hasDirectives) {
		    this.newline();
	
		    this.printSequence(node.directives, node, { indent: true });
		    if (hasDirectives) this.newline();
	
		    this.printSequence(node.body, node, { indent: true });
		    this.removeTrailingNewline();
	
		    this.source("end", node.loc);
	
		    if (!this.endsWith("\n")) this.newline();
	
		    this.rightBrace();
		  } else {
		    this.source("end", node.loc);
		    this.token("}");
		  }
		}
	
		function Noop() {}
	
		function Directive(node) {
		  this.print(node.value, node);
		  this.semicolon();
		}
	
	/***/ }),
	/* 302 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.ClassDeclaration = ClassDeclaration;
		exports.ClassBody = ClassBody;
		exports.ClassProperty = ClassProperty;
		exports.ClassMethod = ClassMethod;
		function ClassDeclaration(node) {
		  this.printJoin(node.decorators, node);
		  this.word("class");
	
		  if (node.id) {
		    this.space();
		    this.print(node.id, node);
		  }
	
		  this.print(node.typeParameters, node);
	
		  if (node.superClass) {
		    this.space();
		    this.word("extends");
		    this.space();
		    this.print(node.superClass, node);
		    this.print(node.superTypeParameters, node);
		  }
	
		  if (node.implements) {
		    this.space();
		    this.word("implements");
		    this.space();
		    this.printList(node.implements, node);
		  }
	
		  this.space();
		  this.print(node.body, node);
		}
	
		exports.ClassExpression = ClassDeclaration;
		function ClassBody(node) {
		  this.token("{");
		  this.printInnerComments(node);
		  if (node.body.length === 0) {
		    this.token("}");
		  } else {
		    this.newline();
	
		    this.indent();
		    this.printSequence(node.body, node);
		    this.dedent();
	
		    if (!this.endsWith("\n")) this.newline();
	
		    this.rightBrace();
		  }
		}
	
		function ClassProperty(node) {
		  this.printJoin(node.decorators, node);
	
		  if (node.static) {
		    this.word("static");
		    this.space();
		  }
		  if (node.computed) {
		    this.token("[");
		    this.print(node.key, node);
		    this.token("]");
		  } else {
		    this._variance(node);
		    this.print(node.key, node);
		  }
		  this.print(node.typeAnnotation, node);
		  if (node.value) {
		    this.space();
		    this.token("=");
		    this.space();
		    this.print(node.value, node);
		  }
		  this.semicolon();
		}
	
		function ClassMethod(node) {
		  this.printJoin(node.decorators, node);
	
		  if (node.static) {
		    this.word("static");
		    this.space();
		  }
	
		  if (node.kind === "constructorCall") {
		    this.word("call");
		    this.space();
		  }
	
		  this._method(node);
		}
	
	/***/ }),
	/* 303 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.LogicalExpression = exports.BinaryExpression = exports.AwaitExpression = exports.YieldExpression = undefined;
		exports.UnaryExpression = UnaryExpression;
		exports.DoExpression = DoExpression;
		exports.ParenthesizedExpression = ParenthesizedExpression;
		exports.UpdateExpression = UpdateExpression;
		exports.ConditionalExpression = ConditionalExpression;
		exports.NewExpression = NewExpression;
		exports.SequenceExpression = SequenceExpression;
		exports.ThisExpression = ThisExpression;
		exports.Super = Super;
		exports.Decorator = Decorator;
		exports.CallExpression = CallExpression;
		exports.Import = Import;
		exports.EmptyStatement = EmptyStatement;
		exports.ExpressionStatement = ExpressionStatement;
		exports.AssignmentPattern = AssignmentPattern;
		exports.AssignmentExpression = AssignmentExpression;
		exports.BindExpression = BindExpression;
		exports.MemberExpression = MemberExpression;
		exports.MetaProperty = MetaProperty;
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		var _node = __webpack_require__(187);
	
		var n = _interopRequireWildcard(_node);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function UnaryExpression(node) {
		  if (node.operator === "void" || node.operator === "delete" || node.operator === "typeof") {
		    this.word(node.operator);
		    this.space();
		  } else {
		    this.token(node.operator);
		  }
	
		  this.print(node.argument, node);
		}
	
		function DoExpression(node) {
		  this.word("do");
		  this.space();
		  this.print(node.body, node);
		}
	
		function ParenthesizedExpression(node) {
		  this.token("(");
		  this.print(node.expression, node);
		  this.token(")");
		}
	
		function UpdateExpression(node) {
		  if (node.prefix) {
		    this.token(node.operator);
		    this.print(node.argument, node);
		  } else {
		    this.print(node.argument, node);
		    this.token(node.operator);
		  }
		}
	
		function ConditionalExpression(node) {
		  this.print(node.test, node);
		  this.space();
		  this.token("?");
		  this.space();
		  this.print(node.consequent, node);
		  this.space();
		  this.token(":");
		  this.space();
		  this.print(node.alternate, node);
		}
	
		function NewExpression(node, parent) {
		  this.word("new");
		  this.space();
		  this.print(node.callee, node);
		  if (node.arguments.length === 0 && this.format.minified && !t.isCallExpression(parent, { callee: node }) && !t.isMemberExpression(parent) && !t.isNewExpression(parent)) return;
	
		  this.token("(");
		  this.printList(node.arguments, node);
		  this.token(")");
		}
	
		function SequenceExpression(node) {
		  this.printList(node.expressions, node);
		}
	
		function ThisExpression() {
		  this.word("this");
		}
	
		function Super() {
		  this.word("super");
		}
	
		function Decorator(node) {
		  this.token("@");
		  this.print(node.expression, node);
		  this.newline();
		}
	
		function commaSeparatorNewline() {
		  this.token(",");
		  this.newline();
	
		  if (!this.endsWith("\n")) this.space();
		}
	
		function CallExpression(node) {
		  this.print(node.callee, node);
	
		  this.token("(");
	
		  var isPrettyCall = node._prettyCall;
	
		  var separator = void 0;
		  if (isPrettyCall) {
		    separator = commaSeparatorNewline;
		    this.newline();
		    this.indent();
		  }
	
		  this.printList(node.arguments, node, { separator: separator });
	
		  if (isPrettyCall) {
		    this.newline();
		    this.dedent();
		  }
	
		  this.token(")");
		}
	
		function Import() {
		  this.word("import");
		}
	
		function buildYieldAwait(keyword) {
		  return function (node) {
		    this.word(keyword);
	
		    if (node.delegate) {
		      this.token("*");
		    }
	
		    if (node.argument) {
		      this.space();
		      var terminatorState = this.startTerminatorless();
		      this.print(node.argument, node);
		      this.endTerminatorless(terminatorState);
		    }
		  };
		}
	
		var YieldExpression = exports.YieldExpression = buildYieldAwait("yield");
		var AwaitExpression = exports.AwaitExpression = buildYieldAwait("await");
	
		function EmptyStatement() {
		  this.semicolon(true);
		}
	
		function ExpressionStatement(node) {
		  this.print(node.expression, node);
		  this.semicolon();
		}
	
		function AssignmentPattern(node) {
		  this.print(node.left, node);
		  if (node.left.optional) this.token("?");
		  this.print(node.left.typeAnnotation, node);
		  this.space();
		  this.token("=");
		  this.space();
		  this.print(node.right, node);
		}
	
		function AssignmentExpression(node, parent) {
		  var parens = this.inForStatementInitCounter && node.operator === "in" && !n.needsParens(node, parent);
	
		  if (parens) {
		    this.token("(");
		  }
	
		  this.print(node.left, node);
	
		  this.space();
		  if (node.operator === "in" || node.operator === "instanceof") {
		    this.word(node.operator);
		  } else {
		    this.token(node.operator);
		  }
		  this.space();
	
		  this.print(node.right, node);
	
		  if (parens) {
		    this.token(")");
		  }
		}
	
		function BindExpression(node) {
		  this.print(node.object, node);
		  this.token("::");
		  this.print(node.callee, node);
		}
	
		exports.BinaryExpression = AssignmentExpression;
		exports.LogicalExpression = AssignmentExpression;
		function MemberExpression(node) {
		  this.print(node.object, node);
	
		  if (!node.computed && t.isMemberExpression(node.property)) {
		    throw new TypeError("Got a MemberExpression for MemberExpression property");
		  }
	
		  var computed = node.computed;
		  if (t.isLiteral(node.property) && typeof node.property.value === "number") {
		    computed = true;
		  }
	
		  if (computed) {
		    this.token("[");
		    this.print(node.property, node);
		    this.token("]");
		  } else {
		    this.token(".");
		    this.print(node.property, node);
		  }
		}
	
		function MetaProperty(node) {
		  this.print(node.meta, node);
		  this.token(".");
		  this.print(node.property, node);
		}
	
	/***/ }),
	/* 304 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.TypeParameterDeclaration = exports.StringLiteralTypeAnnotation = exports.NumericLiteralTypeAnnotation = exports.GenericTypeAnnotation = exports.ClassImplements = undefined;
		exports.AnyTypeAnnotation = AnyTypeAnnotation;
		exports.ArrayTypeAnnotation = ArrayTypeAnnotation;
		exports.BooleanTypeAnnotation = BooleanTypeAnnotation;
		exports.BooleanLiteralTypeAnnotation = BooleanLiteralTypeAnnotation;
		exports.NullLiteralTypeAnnotation = NullLiteralTypeAnnotation;
		exports.DeclareClass = DeclareClass;
		exports.DeclareFunction = DeclareFunction;
		exports.DeclareInterface = DeclareInterface;
		exports.DeclareModule = DeclareModule;
		exports.DeclareModuleExports = DeclareModuleExports;
		exports.DeclareTypeAlias = DeclareTypeAlias;
		exports.DeclareOpaqueType = DeclareOpaqueType;
		exports.DeclareVariable = DeclareVariable;
		exports.DeclareExportDeclaration = DeclareExportDeclaration;
		exports.ExistentialTypeParam = ExistentialTypeParam;
		exports.FunctionTypeAnnotation = FunctionTypeAnnotation;
		exports.FunctionTypeParam = FunctionTypeParam;
		exports.InterfaceExtends = InterfaceExtends;
		exports._interfaceish = _interfaceish;
		exports._variance = _variance;
		exports.InterfaceDeclaration = InterfaceDeclaration;
		exports.IntersectionTypeAnnotation = IntersectionTypeAnnotation;
		exports.MixedTypeAnnotation = MixedTypeAnnotation;
		exports.EmptyTypeAnnotation = EmptyTypeAnnotation;
		exports.NullableTypeAnnotation = NullableTypeAnnotation;
	
		var _types = __webpack_require__(123);
	
		Object.defineProperty(exports, "NumericLiteralTypeAnnotation", {
		  enumerable: true,
		  get: function get() {
		    return _types.NumericLiteral;
		  }
		});
		Object.defineProperty(exports, "StringLiteralTypeAnnotation", {
		  enumerable: true,
		  get: function get() {
		    return _types.StringLiteral;
		  }
		});
		exports.NumberTypeAnnotation = NumberTypeAnnotation;
		exports.StringTypeAnnotation = StringTypeAnnotation;
		exports.ThisTypeAnnotation = ThisTypeAnnotation;
		exports.TupleTypeAnnotation = TupleTypeAnnotation;
		exports.TypeofTypeAnnotation = TypeofTypeAnnotation;
		exports.TypeAlias = TypeAlias;
		exports.OpaqueType = OpaqueType;
		exports.TypeAnnotation = TypeAnnotation;
		exports.TypeParameter = TypeParameter;
		exports.TypeParameterInstantiation = TypeParameterInstantiation;
		exports.ObjectTypeAnnotation = ObjectTypeAnnotation;
		exports.ObjectTypeCallProperty = ObjectTypeCallProperty;
		exports.ObjectTypeIndexer = ObjectTypeIndexer;
		exports.ObjectTypeProperty = ObjectTypeProperty;
		exports.ObjectTypeSpreadProperty = ObjectTypeSpreadProperty;
		exports.QualifiedTypeIdentifier = QualifiedTypeIdentifier;
		exports.UnionTypeAnnotation = UnionTypeAnnotation;
		exports.TypeCastExpression = TypeCastExpression;
		exports.VoidTypeAnnotation = VoidTypeAnnotation;
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function AnyTypeAnnotation() {
		  this.word("any");
		}
	
		function ArrayTypeAnnotation(node) {
		  this.print(node.elementType, node);
		  this.token("[");
		  this.token("]");
		}
	
		function BooleanTypeAnnotation() {
		  this.word("boolean");
		}
	
		function BooleanLiteralTypeAnnotation(node) {
		  this.word(node.value ? "true" : "false");
		}
	
		function NullLiteralTypeAnnotation() {
		  this.word("null");
		}
	
		function DeclareClass(node, parent) {
		  if (!t.isDeclareExportDeclaration(parent)) {
		    this.word("declare");
		    this.space();
		  }
		  this.word("class");
		  this.space();
		  this._interfaceish(node);
		}
	
		function DeclareFunction(node, parent) {
		  if (!t.isDeclareExportDeclaration(parent)) {
		    this.word("declare");
		    this.space();
		  }
		  this.word("function");
		  this.space();
		  this.print(node.id, node);
		  this.print(node.id.typeAnnotation.typeAnnotation, node);
		  this.semicolon();
		}
	
		function DeclareInterface(node) {
		  this.word("declare");
		  this.space();
		  this.InterfaceDeclaration(node);
		}
	
		function DeclareModule(node) {
		  this.word("declare");
		  this.space();
		  this.word("module");
		  this.space();
		  this.print(node.id, node);
		  this.space();
		  this.print(node.body, node);
		}
	
		function DeclareModuleExports(node) {
		  this.word("declare");
		  this.space();
		  this.word("module");
		  this.token(".");
		  this.word("exports");
		  this.print(node.typeAnnotation, node);
		}
	
		function DeclareTypeAlias(node) {
		  this.word("declare");
		  this.space();
		  this.TypeAlias(node);
		}
	
		function DeclareOpaqueType(node, parent) {
		  if (!t.isDeclareExportDeclaration(parent)) {
		    this.word("declare");
		    this.space();
		  }
		  this.OpaqueType(node);
		}
	
		function DeclareVariable(node, parent) {
		  if (!t.isDeclareExportDeclaration(parent)) {
		    this.word("declare");
		    this.space();
		  }
		  this.word("var");
		  this.space();
		  this.print(node.id, node);
		  this.print(node.id.typeAnnotation, node);
		  this.semicolon();
		}
	
		function DeclareExportDeclaration(node) {
		  this.word("declare");
		  this.space();
		  this.word("export");
		  this.space();
		  if (node.default) {
		    this.word("default");
		    this.space();
		  }
	
		  FlowExportDeclaration.apply(this, arguments);
		}
	
		function FlowExportDeclaration(node) {
		  if (node.declaration) {
		    var declar = node.declaration;
		    this.print(declar, node);
		    if (!t.isStatement(declar)) this.semicolon();
		  } else {
		    this.token("{");
		    if (node.specifiers.length) {
		      this.space();
		      this.printList(node.specifiers, node);
		      this.space();
		    }
		    this.token("}");
	
		    if (node.source) {
		      this.space();
		      this.word("from");
		      this.space();
		      this.print(node.source, node);
		    }
	
		    this.semicolon();
		  }
		}
	
		function ExistentialTypeParam() {
		  this.token("*");
		}
	
		function FunctionTypeAnnotation(node, parent) {
		  this.print(node.typeParameters, node);
		  this.token("(");
		  this.printList(node.params, node);
	
		  if (node.rest) {
		    if (node.params.length) {
		      this.token(",");
		      this.space();
		    }
		    this.token("...");
		    this.print(node.rest, node);
		  }
	
		  this.token(")");
	
		  if (parent.type === "ObjectTypeCallProperty" || parent.type === "DeclareFunction") {
		    this.token(":");
		  } else {
		    this.space();
		    this.token("=>");
		  }
	
		  this.space();
		  this.print(node.returnType, node);
		}
	
		function FunctionTypeParam(node) {
		  this.print(node.name, node);
		  if (node.optional) this.token("?");
		  this.token(":");
		  this.space();
		  this.print(node.typeAnnotation, node);
		}
	
		function InterfaceExtends(node) {
		  this.print(node.id, node);
		  this.print(node.typeParameters, node);
		}
	
		exports.ClassImplements = InterfaceExtends;
		exports.GenericTypeAnnotation = InterfaceExtends;
		function _interfaceish(node) {
		  this.print(node.id, node);
		  this.print(node.typeParameters, node);
		  if (node.extends.length) {
		    this.space();
		    this.word("extends");
		    this.space();
		    this.printList(node.extends, node);
		  }
		  if (node.mixins && node.mixins.length) {
		    this.space();
		    this.word("mixins");
		    this.space();
		    this.printList(node.mixins, node);
		  }
		  this.space();
		  this.print(node.body, node);
		}
	
		function _variance(node) {
		  if (node.variance === "plus") {
		    this.token("+");
		  } else if (node.variance === "minus") {
		    this.token("-");
		  }
		}
	
		function InterfaceDeclaration(node) {
		  this.word("interface");
		  this.space();
		  this._interfaceish(node);
		}
	
		function andSeparator() {
		  this.space();
		  this.token("&");
		  this.space();
		}
	
		function IntersectionTypeAnnotation(node) {
		  this.printJoin(node.types, node, { separator: andSeparator });
		}
	
		function MixedTypeAnnotation() {
		  this.word("mixed");
		}
	
		function EmptyTypeAnnotation() {
		  this.word("empty");
		}
	
		function NullableTypeAnnotation(node) {
		  this.token("?");
		  this.print(node.typeAnnotation, node);
		}
	
		function NumberTypeAnnotation() {
		  this.word("number");
		}
	
		function StringTypeAnnotation() {
		  this.word("string");
		}
	
		function ThisTypeAnnotation() {
		  this.word("this");
		}
	
		function TupleTypeAnnotation(node) {
		  this.token("[");
		  this.printList(node.types, node);
		  this.token("]");
		}
	
		function TypeofTypeAnnotation(node) {
		  this.word("typeof");
		  this.space();
		  this.print(node.argument, node);
		}
	
		function TypeAlias(node) {
		  this.word("type");
		  this.space();
		  this.print(node.id, node);
		  this.print(node.typeParameters, node);
		  this.space();
		  this.token("=");
		  this.space();
		  this.print(node.right, node);
		  this.semicolon();
		}
		function OpaqueType(node) {
		  this.word("opaque");
		  this.space();
		  this.word("type");
		  this.space();
		  this.print(node.id, node);
		  this.print(node.typeParameters, node);
		  if (node.supertype) {
		    this.token(":");
		    this.space();
		    this.print(node.supertype, node);
		  }
		  if (node.impltype) {
		    this.space();
		    this.token("=");
		    this.space();
		    this.print(node.impltype, node);
		  }
		  this.semicolon();
		}
	
		function TypeAnnotation(node) {
		  this.token(":");
		  this.space();
		  if (node.optional) this.token("?");
		  this.print(node.typeAnnotation, node);
		}
	
		function TypeParameter(node) {
		  this._variance(node);
	
		  this.word(node.name);
	
		  if (node.bound) {
		    this.print(node.bound, node);
		  }
	
		  if (node.default) {
		    this.space();
		    this.token("=");
		    this.space();
		    this.print(node.default, node);
		  }
		}
	
		function TypeParameterInstantiation(node) {
		  this.token("<");
		  this.printList(node.params, node, {});
		  this.token(">");
		}
	
		exports.TypeParameterDeclaration = TypeParameterInstantiation;
		function ObjectTypeAnnotation(node) {
		  var _this = this;
	
		  if (node.exact) {
		    this.token("{|");
		  } else {
		    this.token("{");
		  }
	
		  var props = node.properties.concat(node.callProperties, node.indexers);
	
		  if (props.length) {
		    this.space();
	
		    this.printJoin(props, node, {
		      addNewlines: function addNewlines(leading) {
		        if (leading && !props[0]) return 1;
		      },
	
		      indent: true,
		      statement: true,
		      iterator: function iterator() {
		        if (props.length !== 1) {
		          if (_this.format.flowCommaSeparator) {
		            _this.token(",");
		          } else {
		            _this.semicolon();
		          }
		          _this.space();
		        }
		      }
		    });
	
		    this.space();
		  }
	
		  if (node.exact) {
		    this.token("|}");
		  } else {
		    this.token("}");
		  }
		}
	
		function ObjectTypeCallProperty(node) {
		  if (node.static) {
		    this.word("static");
		    this.space();
		  }
		  this.print(node.value, node);
		}
	
		function ObjectTypeIndexer(node) {
		  if (node.static) {
		    this.word("static");
		    this.space();
		  }
		  this._variance(node);
		  this.token("[");
		  this.print(node.id, node);
		  this.token(":");
		  this.space();
		  this.print(node.key, node);
		  this.token("]");
		  this.token(":");
		  this.space();
		  this.print(node.value, node);
		}
	
		function ObjectTypeProperty(node) {
		  if (node.static) {
		    this.word("static");
		    this.space();
		  }
		  this._variance(node);
		  this.print(node.key, node);
		  if (node.optional) this.token("?");
		  this.token(":");
		  this.space();
		  this.print(node.value, node);
		}
	
		function ObjectTypeSpreadProperty(node) {
		  this.token("...");
		  this.print(node.argument, node);
		}
	
		function QualifiedTypeIdentifier(node) {
		  this.print(node.qualification, node);
		  this.token(".");
		  this.print(node.id, node);
		}
	
		function orSeparator() {
		  this.space();
		  this.token("|");
		  this.space();
		}
	
		function UnionTypeAnnotation(node) {
		  this.printJoin(node.types, node, { separator: orSeparator });
		}
	
		function TypeCastExpression(node) {
		  this.token("(");
		  this.print(node.expression, node);
		  this.print(node.typeAnnotation, node);
		  this.token(")");
		}
	
		function VoidTypeAnnotation() {
		  this.word("void");
		}
	
	/***/ }),
	/* 305 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.JSXAttribute = JSXAttribute;
		exports.JSXIdentifier = JSXIdentifier;
		exports.JSXNamespacedName = JSXNamespacedName;
		exports.JSXMemberExpression = JSXMemberExpression;
		exports.JSXSpreadAttribute = JSXSpreadAttribute;
		exports.JSXExpressionContainer = JSXExpressionContainer;
		exports.JSXSpreadChild = JSXSpreadChild;
		exports.JSXText = JSXText;
		exports.JSXElement = JSXElement;
		exports.JSXOpeningElement = JSXOpeningElement;
		exports.JSXClosingElement = JSXClosingElement;
		exports.JSXEmptyExpression = JSXEmptyExpression;
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function JSXAttribute(node) {
		  this.print(node.name, node);
		  if (node.value) {
		    this.token("=");
		    this.print(node.value, node);
		  }
		}
	
		function JSXIdentifier(node) {
		  this.word(node.name);
		}
	
		function JSXNamespacedName(node) {
		  this.print(node.namespace, node);
		  this.token(":");
		  this.print(node.name, node);
		}
	
		function JSXMemberExpression(node) {
		  this.print(node.object, node);
		  this.token(".");
		  this.print(node.property, node);
		}
	
		function JSXSpreadAttribute(node) {
		  this.token("{");
		  this.token("...");
		  this.print(node.argument, node);
		  this.token("}");
		}
	
		function JSXExpressionContainer(node) {
		  this.token("{");
		  this.print(node.expression, node);
		  this.token("}");
		}
	
		function JSXSpreadChild(node) {
		  this.token("{");
		  this.token("...");
		  this.print(node.expression, node);
		  this.token("}");
		}
	
		function JSXText(node) {
		  this.token(node.value);
		}
	
		function JSXElement(node) {
		  var open = node.openingElement;
		  this.print(open, node);
		  if (open.selfClosing) return;
	
		  this.indent();
		  for (var _iterator = node.children, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		    var _ref;
	
		    if (_isArray) {
		      if (_i >= _iterator.length) break;
		      _ref = _iterator[_i++];
		    } else {
		      _i = _iterator.next();
		      if (_i.done) break;
		      _ref = _i.value;
		    }
	
		    var child = _ref;
	
		    this.print(child, node);
		  }
		  this.dedent();
	
		  this.print(node.closingElement, node);
		}
	
		function spaceSeparator() {
		  this.space();
		}
	
		function JSXOpeningElement(node) {
		  this.token("<");
		  this.print(node.name, node);
		  if (node.attributes.length > 0) {
		    this.space();
		    this.printJoin(node.attributes, node, { separator: spaceSeparator });
		  }
		  if (node.selfClosing) {
		    this.space();
		    this.token("/>");
		  } else {
		    this.token(">");
		  }
		}
	
		function JSXClosingElement(node) {
		  this.token("</");
		  this.print(node.name, node);
		  this.token(">");
		}
	
		function JSXEmptyExpression() {}
	
	/***/ }),
	/* 306 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.FunctionDeclaration = undefined;
		exports._params = _params;
		exports._method = _method;
		exports.FunctionExpression = FunctionExpression;
		exports.ArrowFunctionExpression = ArrowFunctionExpression;
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _params(node) {
		  var _this = this;
	
		  this.print(node.typeParameters, node);
		  this.token("(");
		  this.printList(node.params, node, {
		    iterator: function iterator(node) {
		      if (node.optional) _this.token("?");
		      _this.print(node.typeAnnotation, node);
		    }
		  });
		  this.token(")");
	
		  if (node.returnType) {
		    this.print(node.returnType, node);
		  }
		}
	
		function _method(node) {
		  var kind = node.kind;
		  var key = node.key;
	
		  if (kind === "method" || kind === "init") {
		    if (node.generator) {
		      this.token("*");
		    }
		  }
	
		  if (kind === "get" || kind === "set") {
		    this.word(kind);
		    this.space();
		  }
	
		  if (node.async) {
		    this.word("async");
		    this.space();
		  }
	
		  if (node.computed) {
		    this.token("[");
		    this.print(key, node);
		    this.token("]");
		  } else {
		    this.print(key, node);
		  }
	
		  this._params(node);
		  this.space();
		  this.print(node.body, node);
		}
	
		function FunctionExpression(node) {
		  if (node.async) {
		    this.word("async");
		    this.space();
		  }
		  this.word("function");
		  if (node.generator) this.token("*");
	
		  if (node.id) {
		    this.space();
		    this.print(node.id, node);
		  } else {
		    this.space();
		  }
	
		  this._params(node);
		  this.space();
		  this.print(node.body, node);
		}
	
		exports.FunctionDeclaration = FunctionExpression;
		function ArrowFunctionExpression(node) {
		  if (node.async) {
		    this.word("async");
		    this.space();
		  }
	
		  var firstParam = node.params[0];
	
		  if (node.params.length === 1 && t.isIdentifier(firstParam) && !hasTypes(node, firstParam)) {
		    this.print(firstParam, node);
		  } else {
		    this._params(node);
		  }
	
		  this.space();
		  this.token("=>");
		  this.space();
	
		  this.print(node.body, node);
		}
	
		function hasTypes(node, param) {
		  return node.typeParameters || node.returnType || param.typeAnnotation || param.optional || param.trailingComments;
		}
	
	/***/ }),
	/* 307 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.ImportSpecifier = ImportSpecifier;
		exports.ImportDefaultSpecifier = ImportDefaultSpecifier;
		exports.ExportDefaultSpecifier = ExportDefaultSpecifier;
		exports.ExportSpecifier = ExportSpecifier;
		exports.ExportNamespaceSpecifier = ExportNamespaceSpecifier;
		exports.ExportAllDeclaration = ExportAllDeclaration;
		exports.ExportNamedDeclaration = ExportNamedDeclaration;
		exports.ExportDefaultDeclaration = ExportDefaultDeclaration;
		exports.ImportDeclaration = ImportDeclaration;
		exports.ImportNamespaceSpecifier = ImportNamespaceSpecifier;
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function ImportSpecifier(node) {
		  if (node.importKind === "type" || node.importKind === "typeof") {
		    this.word(node.importKind);
		    this.space();
		  }
	
		  this.print(node.imported, node);
		  if (node.local && node.local.name !== node.imported.name) {
		    this.space();
		    this.word("as");
		    this.space();
		    this.print(node.local, node);
		  }
		}
	
		function ImportDefaultSpecifier(node) {
		  this.print(node.local, node);
		}
	
		function ExportDefaultSpecifier(node) {
		  this.print(node.exported, node);
		}
	
		function ExportSpecifier(node) {
		  this.print(node.local, node);
		  if (node.exported && node.local.name !== node.exported.name) {
		    this.space();
		    this.word("as");
		    this.space();
		    this.print(node.exported, node);
		  }
		}
	
		function ExportNamespaceSpecifier(node) {
		  this.token("*");
		  this.space();
		  this.word("as");
		  this.space();
		  this.print(node.exported, node);
		}
	
		function ExportAllDeclaration(node) {
		  this.word("export");
		  this.space();
		  this.token("*");
		  this.space();
		  this.word("from");
		  this.space();
		  this.print(node.source, node);
		  this.semicolon();
		}
	
		function ExportNamedDeclaration() {
		  this.word("export");
		  this.space();
		  ExportDeclaration.apply(this, arguments);
		}
	
		function ExportDefaultDeclaration() {
		  this.word("export");
		  this.space();
		  this.word("default");
		  this.space();
		  ExportDeclaration.apply(this, arguments);
		}
	
		function ExportDeclaration(node) {
		  if (node.declaration) {
		    var declar = node.declaration;
		    this.print(declar, node);
		    if (!t.isStatement(declar)) this.semicolon();
		  } else {
		    if (node.exportKind === "type") {
		      this.word("type");
		      this.space();
		    }
	
		    var specifiers = node.specifiers.slice(0);
	
		    var hasSpecial = false;
		    while (true) {
		      var first = specifiers[0];
		      if (t.isExportDefaultSpecifier(first) || t.isExportNamespaceSpecifier(first)) {
		        hasSpecial = true;
		        this.print(specifiers.shift(), node);
		        if (specifiers.length) {
		          this.token(",");
		          this.space();
		        }
		      } else {
		        break;
		      }
		    }
	
		    if (specifiers.length || !specifiers.length && !hasSpecial) {
		      this.token("{");
		      if (specifiers.length) {
		        this.space();
		        this.printList(specifiers, node);
		        this.space();
		      }
		      this.token("}");
		    }
	
		    if (node.source) {
		      this.space();
		      this.word("from");
		      this.space();
		      this.print(node.source, node);
		    }
	
		    this.semicolon();
		  }
		}
	
		function ImportDeclaration(node) {
		  this.word("import");
		  this.space();
	
		  if (node.importKind === "type" || node.importKind === "typeof") {
		    this.word(node.importKind);
		    this.space();
		  }
	
		  var specifiers = node.specifiers.slice(0);
		  if (specifiers && specifiers.length) {
		    while (true) {
		      var first = specifiers[0];
		      if (t.isImportDefaultSpecifier(first) || t.isImportNamespaceSpecifier(first)) {
		        this.print(specifiers.shift(), node);
		        if (specifiers.length) {
		          this.token(",");
		          this.space();
		        }
		      } else {
		        break;
		      }
		    }
	
		    if (specifiers.length) {
		      this.token("{");
		      this.space();
		      this.printList(specifiers, node);
		      this.space();
		      this.token("}");
		    }
	
		    this.space();
		    this.word("from");
		    this.space();
		  }
	
		  this.print(node.source, node);
		  this.semicolon();
		}
	
		function ImportNamespaceSpecifier(node) {
		  this.token("*");
		  this.space();
		  this.word("as");
		  this.space();
		  this.print(node.local, node);
		}
	
	/***/ }),
	/* 308 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.ThrowStatement = exports.BreakStatement = exports.ReturnStatement = exports.ContinueStatement = exports.ForAwaitStatement = exports.ForOfStatement = exports.ForInStatement = undefined;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.WithStatement = WithStatement;
		exports.IfStatement = IfStatement;
		exports.ForStatement = ForStatement;
		exports.WhileStatement = WhileStatement;
		exports.DoWhileStatement = DoWhileStatement;
		exports.LabeledStatement = LabeledStatement;
		exports.TryStatement = TryStatement;
		exports.CatchClause = CatchClause;
		exports.SwitchStatement = SwitchStatement;
		exports.SwitchCase = SwitchCase;
		exports.DebuggerStatement = DebuggerStatement;
		exports.VariableDeclaration = VariableDeclaration;
		exports.VariableDeclarator = VariableDeclarator;
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function WithStatement(node) {
		  this.word("with");
		  this.space();
		  this.token("(");
		  this.print(node.object, node);
		  this.token(")");
		  this.printBlock(node);
		}
	
		function IfStatement(node) {
		  this.word("if");
		  this.space();
		  this.token("(");
		  this.print(node.test, node);
		  this.token(")");
		  this.space();
	
		  var needsBlock = node.alternate && t.isIfStatement(getLastStatement(node.consequent));
		  if (needsBlock) {
		    this.token("{");
		    this.newline();
		    this.indent();
		  }
	
		  this.printAndIndentOnComments(node.consequent, node);
	
		  if (needsBlock) {
		    this.dedent();
		    this.newline();
		    this.token("}");
		  }
	
		  if (node.alternate) {
		    if (this.endsWith("}")) this.space();
		    this.word("else");
		    this.space();
		    this.printAndIndentOnComments(node.alternate, node);
		  }
		}
	
		function getLastStatement(statement) {
		  if (!t.isStatement(statement.body)) return statement;
		  return getLastStatement(statement.body);
		}
	
		function ForStatement(node) {
		  this.word("for");
		  this.space();
		  this.token("(");
	
		  this.inForStatementInitCounter++;
		  this.print(node.init, node);
		  this.inForStatementInitCounter--;
		  this.token(";");
	
		  if (node.test) {
		    this.space();
		    this.print(node.test, node);
		  }
		  this.token(";");
	
		  if (node.update) {
		    this.space();
		    this.print(node.update, node);
		  }
	
		  this.token(")");
		  this.printBlock(node);
		}
	
		function WhileStatement(node) {
		  this.word("while");
		  this.space();
		  this.token("(");
		  this.print(node.test, node);
		  this.token(")");
		  this.printBlock(node);
		}
	
		var buildForXStatement = function buildForXStatement(op) {
		  return function (node) {
		    this.word("for");
		    this.space();
		    if (op === "await") {
		      this.word("await");
		      this.space();
		    }
		    this.token("(");
	
		    this.print(node.left, node);
		    this.space();
		    this.word(op === "await" ? "of" : op);
		    this.space();
		    this.print(node.right, node);
		    this.token(")");
		    this.printBlock(node);
		  };
		};
	
		var ForInStatement = exports.ForInStatement = buildForXStatement("in");
		var ForOfStatement = exports.ForOfStatement = buildForXStatement("of");
		var ForAwaitStatement = exports.ForAwaitStatement = buildForXStatement("await");
	
		function DoWhileStatement(node) {
		  this.word("do");
		  this.space();
		  this.print(node.body, node);
		  this.space();
		  this.word("while");
		  this.space();
		  this.token("(");
		  this.print(node.test, node);
		  this.token(")");
		  this.semicolon();
		}
	
		function buildLabelStatement(prefix) {
		  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "label";
	
		  return function (node) {
		    this.word(prefix);
	
		    var label = node[key];
		    if (label) {
		      this.space();
	
		      var terminatorState = this.startTerminatorless();
		      this.print(label, node);
		      this.endTerminatorless(terminatorState);
		    }
	
		    this.semicolon();
		  };
		}
	
		var ContinueStatement = exports.ContinueStatement = buildLabelStatement("continue");
		var ReturnStatement = exports.ReturnStatement = buildLabelStatement("return", "argument");
		var BreakStatement = exports.BreakStatement = buildLabelStatement("break");
		var ThrowStatement = exports.ThrowStatement = buildLabelStatement("throw", "argument");
	
		function LabeledStatement(node) {
		  this.print(node.label, node);
		  this.token(":");
		  this.space();
		  this.print(node.body, node);
		}
	
		function TryStatement(node) {
		  this.word("try");
		  this.space();
		  this.print(node.block, node);
		  this.space();
	
		  if (node.handlers) {
		    this.print(node.handlers[0], node);
		  } else {
		    this.print(node.handler, node);
		  }
	
		  if (node.finalizer) {
		    this.space();
		    this.word("finally");
		    this.space();
		    this.print(node.finalizer, node);
		  }
		}
	
		function CatchClause(node) {
		  this.word("catch");
		  this.space();
		  this.token("(");
		  this.print(node.param, node);
		  this.token(")");
		  this.space();
		  this.print(node.body, node);
		}
	
		function SwitchStatement(node) {
		  this.word("switch");
		  this.space();
		  this.token("(");
		  this.print(node.discriminant, node);
		  this.token(")");
		  this.space();
		  this.token("{");
	
		  this.printSequence(node.cases, node, {
		    indent: true,
		    addNewlines: function addNewlines(leading, cas) {
		      if (!leading && node.cases[node.cases.length - 1] === cas) return -1;
		    }
		  });
	
		  this.token("}");
		}
	
		function SwitchCase(node) {
		  if (node.test) {
		    this.word("case");
		    this.space();
		    this.print(node.test, node);
		    this.token(":");
		  } else {
		    this.word("default");
		    this.token(":");
		  }
	
		  if (node.consequent.length) {
		    this.newline();
		    this.printSequence(node.consequent, node, { indent: true });
		  }
		}
	
		function DebuggerStatement() {
		  this.word("debugger");
		  this.semicolon();
		}
	
		function variableDeclarationIdent() {
		  this.token(",");
		  this.newline();
		  if (this.endsWith("\n")) for (var i = 0; i < 4; i++) {
		    this.space(true);
		  }
		}
	
		function constDeclarationIdent() {
		  this.token(",");
		  this.newline();
		  if (this.endsWith("\n")) for (var i = 0; i < 6; i++) {
		    this.space(true);
		  }
		}
	
		function VariableDeclaration(node, parent) {
		  this.word(node.kind);
		  this.space();
	
		  var hasInits = false;
	
		  if (!t.isFor(parent)) {
		    for (var _iterator = node.declarations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var declar = _ref;
	
		      if (declar.init) {
		        hasInits = true;
		      }
		    }
		  }
	
		  var separator = void 0;
		  if (hasInits) {
		    separator = node.kind === "const" ? constDeclarationIdent : variableDeclarationIdent;
		  }
	
		  this.printList(node.declarations, node, { separator: separator });
	
		  if (t.isFor(parent)) {
		    if (parent.left === node || parent.init === node) return;
		  }
	
		  this.semicolon();
		}
	
		function VariableDeclarator(node) {
		  this.print(node.id, node);
		  this.print(node.id.typeAnnotation, node);
		  if (node.init) {
		    this.space();
		    this.token("=");
		    this.space();
		    this.print(node.init, node);
		  }
		}
	
	/***/ }),
	/* 309 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.TaggedTemplateExpression = TaggedTemplateExpression;
		exports.TemplateElement = TemplateElement;
		exports.TemplateLiteral = TemplateLiteral;
		function TaggedTemplateExpression(node) {
		  this.print(node.tag, node);
		  this.print(node.quasi, node);
		}
	
		function TemplateElement(node, parent) {
		  var isFirst = parent.quasis[0] === node;
		  var isLast = parent.quasis[parent.quasis.length - 1] === node;
	
		  var value = (isFirst ? "`" : "}") + node.value.raw + (isLast ? "`" : "${");
	
		  this.token(value);
		}
	
		function TemplateLiteral(node) {
		  var quasis = node.quasis;
	
		  for (var i = 0; i < quasis.length; i++) {
		    this.print(quasis[i], node);
	
		    if (i + 1 < quasis.length) {
		      this.print(node.expressions[i], node);
		    }
		  }
		}
	
	/***/ }),
	/* 310 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.AwaitExpression = exports.FunctionTypeAnnotation = undefined;
		exports.NullableTypeAnnotation = NullableTypeAnnotation;
		exports.UpdateExpression = UpdateExpression;
		exports.ObjectExpression = ObjectExpression;
		exports.DoExpression = DoExpression;
		exports.Binary = Binary;
		exports.BinaryExpression = BinaryExpression;
		exports.SequenceExpression = SequenceExpression;
		exports.YieldExpression = YieldExpression;
		exports.ClassExpression = ClassExpression;
		exports.UnaryLike = UnaryLike;
		exports.FunctionExpression = FunctionExpression;
		exports.ArrowFunctionExpression = ArrowFunctionExpression;
		exports.ConditionalExpression = ConditionalExpression;
		exports.AssignmentExpression = AssignmentExpression;
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		var PRECEDENCE = {
		  "||": 0,
		  "&&": 1,
		  "|": 2,
		  "^": 3,
		  "&": 4,
		  "==": 5,
		  "===": 5,
		  "!=": 5,
		  "!==": 5,
		  "<": 6,
		  ">": 6,
		  "<=": 6,
		  ">=": 6,
		  in: 6,
		  instanceof: 6,
		  ">>": 7,
		  "<<": 7,
		  ">>>": 7,
		  "+": 8,
		  "-": 8,
		  "*": 9,
		  "/": 9,
		  "%": 9,
		  "**": 10
		};
	
		function NullableTypeAnnotation(node, parent) {
		  return t.isArrayTypeAnnotation(parent);
		}
	
		exports.FunctionTypeAnnotation = NullableTypeAnnotation;
		function UpdateExpression(node, parent) {
		  return t.isMemberExpression(parent) && parent.object === node;
		}
	
		function ObjectExpression(node, parent, printStack) {
		  return isFirstInStatement(printStack, { considerArrow: true });
		}
	
		function DoExpression(node, parent, printStack) {
		  return isFirstInStatement(printStack);
		}
	
		function Binary(node, parent) {
		  if ((t.isCallExpression(parent) || t.isNewExpression(parent)) && parent.callee === node || t.isUnaryLike(parent) || t.isMemberExpression(parent) && parent.object === node || t.isAwaitExpression(parent)) {
		    return true;
		  }
	
		  if (t.isBinary(parent)) {
		    var parentOp = parent.operator;
		    var parentPos = PRECEDENCE[parentOp];
	
		    var nodeOp = node.operator;
		    var nodePos = PRECEDENCE[nodeOp];
	
		    if (parentPos === nodePos && parent.right === node && !t.isLogicalExpression(parent) || parentPos > nodePos) {
		      return true;
		    }
		  }
	
		  return false;
		}
	
		function BinaryExpression(node, parent) {
		  return node.operator === "in" && (t.isVariableDeclarator(parent) || t.isFor(parent));
		}
	
		function SequenceExpression(node, parent) {
	
		  if (t.isForStatement(parent) || t.isThrowStatement(parent) || t.isReturnStatement(parent) || t.isIfStatement(parent) && parent.test === node || t.isWhileStatement(parent) && parent.test === node || t.isForInStatement(parent) && parent.right === node || t.isSwitchStatement(parent) && parent.discriminant === node || t.isExpressionStatement(parent) && parent.expression === node) {
		    return false;
		  }
	
		  return true;
		}
	
		function YieldExpression(node, parent) {
		  return t.isBinary(parent) || t.isUnaryLike(parent) || t.isCallExpression(parent) || t.isMemberExpression(parent) || t.isNewExpression(parent) || t.isConditionalExpression(parent) && node === parent.test;
		}
	
		exports.AwaitExpression = YieldExpression;
		function ClassExpression(node, parent, printStack) {
		  return isFirstInStatement(printStack, { considerDefaultExports: true });
		}
	
		function UnaryLike(node, parent) {
		  return t.isMemberExpression(parent, { object: node }) || t.isCallExpression(parent, { callee: node }) || t.isNewExpression(parent, { callee: node });
		}
	
		function FunctionExpression(node, parent, printStack) {
		  return isFirstInStatement(printStack, { considerDefaultExports: true });
		}
	
		function ArrowFunctionExpression(node, parent) {
		  if (t.isExportDeclaration(parent) || t.isBinaryExpression(parent) || t.isLogicalExpression(parent) || t.isUnaryExpression(parent) || t.isTaggedTemplateExpression(parent)) {
		    return true;
		  }
	
		  return UnaryLike(node, parent);
		}
	
		function ConditionalExpression(node, parent) {
		  if (t.isUnaryLike(parent) || t.isBinary(parent) || t.isConditionalExpression(parent, { test: node }) || t.isAwaitExpression(parent)) {
		    return true;
		  }
	
		  return UnaryLike(node, parent);
		}
	
		function AssignmentExpression(node) {
		  if (t.isObjectPattern(node.left)) {
		    return true;
		  } else {
		    return ConditionalExpression.apply(undefined, arguments);
		  }
		}
	
		function isFirstInStatement(printStack) {
		  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
		      _ref$considerArrow = _ref.considerArrow,
		      considerArrow = _ref$considerArrow === undefined ? false : _ref$considerArrow,
		      _ref$considerDefaultE = _ref.considerDefaultExports,
		      considerDefaultExports = _ref$considerDefaultE === undefined ? false : _ref$considerDefaultE;
	
		  var i = printStack.length - 1;
		  var node = printStack[i];
		  i--;
		  var parent = printStack[i];
		  while (i > 0) {
		    if (t.isExpressionStatement(parent, { expression: node }) || t.isTaggedTemplateExpression(parent) || considerDefaultExports && t.isExportDefaultDeclaration(parent, { declaration: node }) || considerArrow && t.isArrowFunctionExpression(parent, { body: node })) {
		      return true;
		    }
	
		    if (t.isCallExpression(parent, { callee: node }) || t.isSequenceExpression(parent) && parent.expressions[0] === node || t.isMemberExpression(parent, { object: node }) || t.isConditional(parent, { test: node }) || t.isBinary(parent, { left: node }) || t.isAssignmentExpression(parent, { left: node })) {
		      node = parent;
		      i--;
		      parent = printStack[i];
		    } else {
		      return false;
		    }
		  }
	
		  return false;
		}
	
	/***/ }),
	/* 311 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _map = __webpack_require__(588);
	
		var _map2 = _interopRequireDefault(_map);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function crawl(node) {
		  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		  if (t.isMemberExpression(node)) {
		    crawl(node.object, state);
		    if (node.computed) crawl(node.property, state);
		  } else if (t.isBinary(node) || t.isAssignmentExpression(node)) {
		    crawl(node.left, state);
		    crawl(node.right, state);
		  } else if (t.isCallExpression(node)) {
		    state.hasCall = true;
		    crawl(node.callee, state);
		  } else if (t.isFunction(node)) {
		    state.hasFunction = true;
		  } else if (t.isIdentifier(node)) {
		    state.hasHelper = state.hasHelper || isHelper(node.callee);
		  }
	
		  return state;
		}
	
		function isHelper(node) {
		  if (t.isMemberExpression(node)) {
		    return isHelper(node.object) || isHelper(node.property);
		  } else if (t.isIdentifier(node)) {
		    return node.name === "require" || node.name[0] === "_";
		  } else if (t.isCallExpression(node)) {
		    return isHelper(node.callee);
		  } else if (t.isBinary(node) || t.isAssignmentExpression(node)) {
		    return t.isIdentifier(node.left) && isHelper(node.left) || isHelper(node.right);
		  } else {
		    return false;
		  }
		}
	
		function isType(node) {
		  return t.isLiteral(node) || t.isObjectExpression(node) || t.isArrayExpression(node) || t.isIdentifier(node) || t.isMemberExpression(node);
		}
	
		exports.nodes = {
		  AssignmentExpression: function AssignmentExpression(node) {
		    var state = crawl(node.right);
		    if (state.hasCall && state.hasHelper || state.hasFunction) {
		      return {
		        before: state.hasFunction,
		        after: true
		      };
		    }
		  },
		  SwitchCase: function SwitchCase(node, parent) {
		    return {
		      before: node.consequent.length || parent.cases[0] === node
		    };
		  },
		  LogicalExpression: function LogicalExpression(node) {
		    if (t.isFunction(node.left) || t.isFunction(node.right)) {
		      return {
		        after: true
		      };
		    }
		  },
		  Literal: function Literal(node) {
		    if (node.value === "use strict") {
		      return {
		        after: true
		      };
		    }
		  },
		  CallExpression: function CallExpression(node) {
		    if (t.isFunction(node.callee) || isHelper(node)) {
		      return {
		        before: true,
		        after: true
		      };
		    }
		  },
		  VariableDeclaration: function VariableDeclaration(node) {
		    for (var i = 0; i < node.declarations.length; i++) {
		      var declar = node.declarations[i];
	
		      var enabled = isHelper(declar.id) && !isType(declar.init);
		      if (!enabled) {
		        var state = crawl(declar.init);
		        enabled = isHelper(declar.init) && state.hasCall || state.hasFunction;
		      }
	
		      if (enabled) {
		        return {
		          before: true,
		          after: true
		        };
		      }
		    }
		  },
		  IfStatement: function IfStatement(node) {
		    if (t.isBlockStatement(node.consequent)) {
		      return {
		        before: true,
		        after: true
		      };
		    }
		  }
		};
	
		exports.nodes.ObjectProperty = exports.nodes.ObjectTypeProperty = exports.nodes.ObjectMethod = exports.nodes.SpreadProperty = function (node, parent) {
		  if (parent.properties[0] === node) {
		    return {
		      before: true
		    };
		  }
		};
	
		exports.list = {
		  VariableDeclaration: function VariableDeclaration(node) {
		    return (0, _map2.default)(node.declarations, "init");
		  },
		  ArrayExpression: function ArrayExpression(node) {
		    return node.elements;
		  },
		  ObjectExpression: function ObjectExpression(node) {
		    return node.properties;
		  }
		};
	
		[["Function", true], ["Class", true], ["Loop", true], ["LabeledStatement", true], ["SwitchStatement", true], ["TryStatement", true]].forEach(function (_ref) {
		  var type = _ref[0],
		      amounts = _ref[1];
	
		  if (typeof amounts === "boolean") {
		    amounts = { after: amounts, before: amounts };
		  }
		  [type].concat(t.FLIPPED_ALIAS_KEYS[type] || []).forEach(function (type) {
		    exports.nodes[type] = function () {
		      return amounts;
		    };
		  });
		});
	
	/***/ }),
	/* 312 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _assign = __webpack_require__(87);
	
		var _assign2 = _interopRequireDefault(_assign);
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _stringify = __webpack_require__(35);
	
		var _stringify2 = _interopRequireDefault(_stringify);
	
		var _weakSet = __webpack_require__(365);
	
		var _weakSet2 = _interopRequireDefault(_weakSet);
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _find = __webpack_require__(579);
	
		var _find2 = _interopRequireDefault(_find);
	
		var _findLast = __webpack_require__(581);
	
		var _findLast2 = _interopRequireDefault(_findLast);
	
		var _isInteger = __webpack_require__(586);
	
		var _isInteger2 = _interopRequireDefault(_isInteger);
	
		var _repeat = __webpack_require__(278);
	
		var _repeat2 = _interopRequireDefault(_repeat);
	
		var _buffer = __webpack_require__(300);
	
		var _buffer2 = _interopRequireDefault(_buffer);
	
		var _node = __webpack_require__(187);
	
		var n = _interopRequireWildcard(_node);
	
		var _whitespace = __webpack_require__(314);
	
		var _whitespace2 = _interopRequireDefault(_whitespace);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var SCIENTIFIC_NOTATION = /e/i;
		var ZERO_DECIMAL_INTEGER = /\.0+$/;
		var NON_DECIMAL_LITERAL = /^0[box]/;
	
		var Printer = function () {
		  function Printer(format, map, tokens) {
		    (0, _classCallCheck3.default)(this, Printer);
		    this.inForStatementInitCounter = 0;
		    this._printStack = [];
		    this._indent = 0;
		    this._insideAux = false;
		    this._printedCommentStarts = {};
		    this._parenPushNewlineState = null;
		    this._printAuxAfterOnNextUserNode = false;
		    this._printedComments = new _weakSet2.default();
		    this._endsWithInteger = false;
		    this._endsWithWord = false;
	
		    this.format = format || {};
		    this._buf = new _buffer2.default(map);
		    this._whitespace = tokens.length > 0 ? new _whitespace2.default(tokens) : null;
		  }
	
		  Printer.prototype.generate = function generate(ast) {
		    this.print(ast);
		    this._maybeAddAuxComment();
	
		    return this._buf.get();
		  };
	
		  Printer.prototype.indent = function indent() {
		    if (this.format.compact || this.format.concise) return;
	
		    this._indent++;
		  };
	
		  Printer.prototype.dedent = function dedent() {
		    if (this.format.compact || this.format.concise) return;
	
		    this._indent--;
		  };
	
		  Printer.prototype.semicolon = function semicolon() {
		    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
		    this._maybeAddAuxComment();
		    this._append(";", !force);
		  };
	
		  Printer.prototype.rightBrace = function rightBrace() {
		    if (this.format.minified) {
		      this._buf.removeLastSemicolon();
		    }
		    this.token("}");
		  };
	
		  Printer.prototype.space = function space() {
		    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
		    if (this.format.compact) return;
	
		    if (this._buf.hasContent() && !this.endsWith(" ") && !this.endsWith("\n") || force) {
		      this._space();
		    }
		  };
	
		  Printer.prototype.word = function word(str) {
		    if (this._endsWithWord) this._space();
	
		    this._maybeAddAuxComment();
		    this._append(str);
	
		    this._endsWithWord = true;
		  };
	
		  Printer.prototype.number = function number(str) {
		    this.word(str);
	
		    this._endsWithInteger = (0, _isInteger2.default)(+str) && !NON_DECIMAL_LITERAL.test(str) && !SCIENTIFIC_NOTATION.test(str) && !ZERO_DECIMAL_INTEGER.test(str) && str[str.length - 1] !== ".";
		  };
	
		  Printer.prototype.token = function token(str) {
		    if (str === "--" && this.endsWith("!") || str[0] === "+" && this.endsWith("+") || str[0] === "-" && this.endsWith("-") || str[0] === "." && this._endsWithInteger) {
		      this._space();
		    }
	
		    this._maybeAddAuxComment();
		    this._append(str);
		  };
	
		  Printer.prototype.newline = function newline(i) {
		    if (this.format.retainLines || this.format.compact) return;
	
		    if (this.format.concise) {
		      this.space();
		      return;
		    }
	
		    if (this.endsWith("\n\n")) return;
	
		    if (typeof i !== "number") i = 1;
	
		    i = Math.min(2, i);
		    if (this.endsWith("{\n") || this.endsWith(":\n")) i--;
		    if (i <= 0) return;
	
		    for (var j = 0; j < i; j++) {
		      this._newline();
		    }
		  };
	
		  Printer.prototype.endsWith = function endsWith(str) {
		    return this._buf.endsWith(str);
		  };
	
		  Printer.prototype.removeTrailingNewline = function removeTrailingNewline() {
		    this._buf.removeTrailingNewline();
		  };
	
		  Printer.prototype.source = function source(prop, loc) {
		    this._catchUp(prop, loc);
	
		    this._buf.source(prop, loc);
		  };
	
		  Printer.prototype.withSource = function withSource(prop, loc, cb) {
		    this._catchUp(prop, loc);
	
		    this._buf.withSource(prop, loc, cb);
		  };
	
		  Printer.prototype._space = function _space() {
		    this._append(" ", true);
		  };
	
		  Printer.prototype._newline = function _newline() {
		    this._append("\n", true);
		  };
	
		  Printer.prototype._append = function _append(str) {
		    var queue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
		    this._maybeAddParen(str);
		    this._maybeIndent(str);
	
		    if (queue) this._buf.queue(str);else this._buf.append(str);
	
		    this._endsWithWord = false;
		    this._endsWithInteger = false;
		  };
	
		  Printer.prototype._maybeIndent = function _maybeIndent(str) {
		    if (this._indent && this.endsWith("\n") && str[0] !== "\n") {
		      this._buf.queue(this._getIndent());
		    }
		  };
	
		  Printer.prototype._maybeAddParen = function _maybeAddParen(str) {
		    var parenPushNewlineState = this._parenPushNewlineState;
		    if (!parenPushNewlineState) return;
		    this._parenPushNewlineState = null;
	
		    var i = void 0;
		    for (i = 0; i < str.length && str[i] === " "; i++) {
		      continue;
		    }if (i === str.length) return;
	
		    var cha = str[i];
		    if (cha === "\n" || cha === "/") {
		      this.token("(");
		      this.indent();
		      parenPushNewlineState.printed = true;
		    }
		  };
	
		  Printer.prototype._catchUp = function _catchUp(prop, loc) {
		    if (!this.format.retainLines) return;
	
		    var pos = loc ? loc[prop] : null;
		    if (pos && pos.line !== null) {
		      var count = pos.line - this._buf.getCurrentLine();
	
		      for (var i = 0; i < count; i++) {
		        this._newline();
		      }
		    }
		  };
	
		  Printer.prototype._getIndent = function _getIndent() {
		    return (0, _repeat2.default)(this.format.indent.style, this._indent);
		  };
	
		  Printer.prototype.startTerminatorless = function startTerminatorless() {
		    return this._parenPushNewlineState = {
		      printed: false
		    };
		  };
	
		  Printer.prototype.endTerminatorless = function endTerminatorless(state) {
		    if (state.printed) {
		      this.dedent();
		      this.newline();
		      this.token(")");
		    }
		  };
	
		  Printer.prototype.print = function print(node, parent) {
		    var _this = this;
	
		    if (!node) return;
	
		    var oldConcise = this.format.concise;
		    if (node._compact) {
		      this.format.concise = true;
		    }
	
		    var printMethod = this[node.type];
		    if (!printMethod) {
		      throw new ReferenceError("unknown node of type " + (0, _stringify2.default)(node.type) + " with constructor " + (0, _stringify2.default)(node && node.constructor.name));
		    }
	
		    this._printStack.push(node);
	
		    var oldInAux = this._insideAux;
		    this._insideAux = !node.loc;
		    this._maybeAddAuxComment(this._insideAux && !oldInAux);
	
		    var needsParens = n.needsParens(node, parent, this._printStack);
		    if (this.format.retainFunctionParens && node.type === "FunctionExpression" && node.extra && node.extra.parenthesized) {
		      needsParens = true;
		    }
		    if (needsParens) this.token("(");
	
		    this._printLeadingComments(node, parent);
	
		    var loc = t.isProgram(node) || t.isFile(node) ? null : node.loc;
		    this.withSource("start", loc, function () {
		      _this[node.type](node, parent);
		    });
	
		    this._printTrailingComments(node, parent);
	
		    if (needsParens) this.token(")");
	
		    this._printStack.pop();
	
		    this.format.concise = oldConcise;
		    this._insideAux = oldInAux;
		  };
	
		  Printer.prototype._maybeAddAuxComment = function _maybeAddAuxComment(enteredPositionlessNode) {
		    if (enteredPositionlessNode) this._printAuxBeforeComment();
		    if (!this._insideAux) this._printAuxAfterComment();
		  };
	
		  Printer.prototype._printAuxBeforeComment = function _printAuxBeforeComment() {
		    if (this._printAuxAfterOnNextUserNode) return;
		    this._printAuxAfterOnNextUserNode = true;
	
		    var comment = this.format.auxiliaryCommentBefore;
		    if (comment) {
		      this._printComment({
		        type: "CommentBlock",
		        value: comment
		      });
		    }
		  };
	
		  Printer.prototype._printAuxAfterComment = function _printAuxAfterComment() {
		    if (!this._printAuxAfterOnNextUserNode) return;
		    this._printAuxAfterOnNextUserNode = false;
	
		    var comment = this.format.auxiliaryCommentAfter;
		    if (comment) {
		      this._printComment({
		        type: "CommentBlock",
		        value: comment
		      });
		    }
		  };
	
		  Printer.prototype.getPossibleRaw = function getPossibleRaw(node) {
		    var extra = node.extra;
		    if (extra && extra.raw != null && extra.rawValue != null && node.value === extra.rawValue) {
		      return extra.raw;
		    }
		  };
	
		  Printer.prototype.printJoin = function printJoin(nodes, parent) {
		    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
		    if (!nodes || !nodes.length) return;
	
		    if (opts.indent) this.indent();
	
		    var newlineOpts = {
		      addNewlines: opts.addNewlines
		    };
	
		    for (var i = 0; i < nodes.length; i++) {
		      var node = nodes[i];
		      if (!node) continue;
	
		      if (opts.statement) this._printNewline(true, node, parent, newlineOpts);
	
		      this.print(node, parent);
	
		      if (opts.iterator) {
		        opts.iterator(node, i);
		      }
	
		      if (opts.separator && i < nodes.length - 1) {
		        opts.separator.call(this);
		      }
	
		      if (opts.statement) this._printNewline(false, node, parent, newlineOpts);
		    }
	
		    if (opts.indent) this.dedent();
		  };
	
		  Printer.prototype.printAndIndentOnComments = function printAndIndentOnComments(node, parent) {
		    var indent = !!node.leadingComments;
		    if (indent) this.indent();
		    this.print(node, parent);
		    if (indent) this.dedent();
		  };
	
		  Printer.prototype.printBlock = function printBlock(parent) {
		    var node = parent.body;
	
		    if (!t.isEmptyStatement(node)) {
		      this.space();
		    }
	
		    this.print(node, parent);
		  };
	
		  Printer.prototype._printTrailingComments = function _printTrailingComments(node, parent) {
		    this._printComments(this._getComments(false, node, parent));
		  };
	
		  Printer.prototype._printLeadingComments = function _printLeadingComments(node, parent) {
		    this._printComments(this._getComments(true, node, parent));
		  };
	
		  Printer.prototype.printInnerComments = function printInnerComments(node) {
		    var indent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
		    if (!node.innerComments) return;
		    if (indent) this.indent();
		    this._printComments(node.innerComments);
		    if (indent) this.dedent();
		  };
	
		  Printer.prototype.printSequence = function printSequence(nodes, parent) {
		    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
		    opts.statement = true;
		    return this.printJoin(nodes, parent, opts);
		  };
	
		  Printer.prototype.printList = function printList(items, parent) {
		    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
		    if (opts.separator == null) {
		      opts.separator = commaSeparator;
		    }
	
		    return this.printJoin(items, parent, opts);
		  };
	
		  Printer.prototype._printNewline = function _printNewline(leading, node, parent, opts) {
		    var _this2 = this;
	
		    if (this.format.retainLines || this.format.compact) return;
	
		    if (this.format.concise) {
		      this.space();
		      return;
		    }
	
		    var lines = 0;
	
		    if (node.start != null && !node._ignoreUserWhitespace && this._whitespace) {
		      if (leading) {
		        var _comments = node.leadingComments;
		        var _comment = _comments && (0, _find2.default)(_comments, function (comment) {
		          return !!comment.loc && _this2.format.shouldPrintComment(comment.value);
		        });
	
		        lines = this._whitespace.getNewlinesBefore(_comment || node);
		      } else {
		        var _comments2 = node.trailingComments;
		        var _comment2 = _comments2 && (0, _findLast2.default)(_comments2, function (comment) {
		          return !!comment.loc && _this2.format.shouldPrintComment(comment.value);
		        });
	
		        lines = this._whitespace.getNewlinesAfter(_comment2 || node);
		      }
		    } else {
		      if (!leading) lines++;
		      if (opts.addNewlines) lines += opts.addNewlines(leading, node) || 0;
	
		      var needs = n.needsWhitespaceAfter;
		      if (leading) needs = n.needsWhitespaceBefore;
		      if (needs(node, parent)) lines++;
	
		      if (!this._buf.hasContent()) lines = 0;
		    }
	
		    this.newline(lines);
		  };
	
		  Printer.prototype._getComments = function _getComments(leading, node) {
		    return node && (leading ? node.leadingComments : node.trailingComments) || [];
		  };
	
		  Printer.prototype._printComment = function _printComment(comment) {
		    var _this3 = this;
	
		    if (!this.format.shouldPrintComment(comment.value)) return;
	
		    if (comment.ignore) return;
	
		    if (this._printedComments.has(comment)) return;
		    this._printedComments.add(comment);
	
		    if (comment.start != null) {
		      if (this._printedCommentStarts[comment.start]) return;
		      this._printedCommentStarts[comment.start] = true;
		    }
	
		    this.newline(this._whitespace ? this._whitespace.getNewlinesBefore(comment) : 0);
	
		    if (!this.endsWith("[") && !this.endsWith("{")) this.space();
	
		    var val = comment.type === "CommentLine" ? "//" + comment.value + "\n" : "/*" + comment.value + "*/";
	
		    if (comment.type === "CommentBlock" && this.format.indent.adjustMultilineComment) {
		      var offset = comment.loc && comment.loc.start.column;
		      if (offset) {
		        var newlineRegex = new RegExp("\\n\\s{1," + offset + "}", "g");
		        val = val.replace(newlineRegex, "\n");
		      }
	
		      var indentSize = Math.max(this._getIndent().length, this._buf.getCurrentColumn());
		      val = val.replace(/\n(?!$)/g, "\n" + (0, _repeat2.default)(" ", indentSize));
		    }
	
		    this.withSource("start", comment.loc, function () {
		      _this3._append(val);
		    });
	
		    this.newline((this._whitespace ? this._whitespace.getNewlinesAfter(comment) : 0) + (comment.type === "CommentLine" ? -1 : 0));
		  };
	
		  Printer.prototype._printComments = function _printComments(comments) {
		    if (!comments || !comments.length) return;
	
		    for (var _iterator = comments, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var _comment3 = _ref;
	
		      this._printComment(_comment3);
		    }
		  };
	
		  return Printer;
		}();
	
		exports.default = Printer;
	
		function commaSeparator() {
		  this.token(",");
		  this.space();
		}
	
		var _arr = [__webpack_require__(309), __webpack_require__(303), __webpack_require__(308), __webpack_require__(302), __webpack_require__(306), __webpack_require__(307), __webpack_require__(123), __webpack_require__(304), __webpack_require__(301), __webpack_require__(305)];
		for (var _i2 = 0; _i2 < _arr.length; _i2++) {
		  var generator = _arr[_i2];
		  (0, _assign2.default)(Printer.prototype, generator);
		}
		module.exports = exports["default"];
	
	/***/ }),
	/* 313 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _keys = __webpack_require__(14);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _typeof2 = __webpack_require__(11);
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _sourceMap = __webpack_require__(288);
	
		var _sourceMap2 = _interopRequireDefault(_sourceMap);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var SourceMap = function () {
		  function SourceMap(opts, code) {
		    (0, _classCallCheck3.default)(this, SourceMap);
	
		    this._cachedMap = null;
		    this._code = code;
		    this._opts = opts;
		    this._rawMappings = [];
		  }
	
		  SourceMap.prototype.get = function get() {
		    if (!this._cachedMap) {
		      var map = this._cachedMap = new _sourceMap2.default.SourceMapGenerator({
		        file: this._opts.sourceMapTarget,
		        sourceRoot: this._opts.sourceRoot
		      });
	
		      var code = this._code;
		      if (typeof code === "string") {
		        map.setSourceContent(this._opts.sourceFileName, code);
		      } else if ((typeof code === "undefined" ? "undefined" : (0, _typeof3.default)(code)) === "object") {
		        (0, _keys2.default)(code).forEach(function (sourceFileName) {
		          map.setSourceContent(sourceFileName, code[sourceFileName]);
		        });
		      }
	
		      this._rawMappings.forEach(map.addMapping, map);
		    }
	
		    return this._cachedMap.toJSON();
		  };
	
		  SourceMap.prototype.getRawMappings = function getRawMappings() {
		    return this._rawMappings.slice();
		  };
	
		  SourceMap.prototype.mark = function mark(generatedLine, generatedColumn, line, column, identifierName, filename) {
		    if (this._lastGenLine !== generatedLine && line === null) return;
	
		    if (this._lastGenLine === generatedLine && this._lastSourceLine === line && this._lastSourceColumn === column) {
		      return;
		    }
	
		    this._cachedMap = null;
		    this._lastGenLine = generatedLine;
		    this._lastSourceLine = line;
		    this._lastSourceColumn = column;
	
		    this._rawMappings.push({
		      name: identifierName || undefined,
		      generated: {
		        line: generatedLine,
		        column: generatedColumn
		      },
		      source: line == null ? undefined : filename || this._opts.sourceFileName,
		      original: line == null ? undefined : {
		        line: line,
		        column: column
		      }
		    });
		  };
	
		  return SourceMap;
		}();
	
		exports.default = SourceMap;
		module.exports = exports["default"];
	
	/***/ }),
	/* 314 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var Whitespace = function () {
		  function Whitespace(tokens) {
		    (0, _classCallCheck3.default)(this, Whitespace);
	
		    this.tokens = tokens;
		    this.used = {};
		  }
	
		  Whitespace.prototype.getNewlinesBefore = function getNewlinesBefore(node) {
		    var startToken = void 0;
		    var endToken = void 0;
		    var tokens = this.tokens;
	
		    var index = this._findToken(function (token) {
		      return token.start - node.start;
		    }, 0, tokens.length);
		    if (index >= 0) {
		      while (index && node.start === tokens[index - 1].start) {
		        --index;
		      }startToken = tokens[index - 1];
		      endToken = tokens[index];
		    }
	
		    return this._getNewlinesBetween(startToken, endToken);
		  };
	
		  Whitespace.prototype.getNewlinesAfter = function getNewlinesAfter(node) {
		    var startToken = void 0;
		    var endToken = void 0;
		    var tokens = this.tokens;
	
		    var index = this._findToken(function (token) {
		      return token.end - node.end;
		    }, 0, tokens.length);
		    if (index >= 0) {
		      while (index && node.end === tokens[index - 1].end) {
		        --index;
		      }startToken = tokens[index];
		      endToken = tokens[index + 1];
		      if (endToken.type.label === ",") endToken = tokens[index + 2];
		    }
	
		    if (endToken && endToken.type.label === "eof") {
		      return 1;
		    } else {
		      return this._getNewlinesBetween(startToken, endToken);
		    }
		  };
	
		  Whitespace.prototype._getNewlinesBetween = function _getNewlinesBetween(startToken, endToken) {
		    if (!endToken || !endToken.loc) return 0;
	
		    var start = startToken ? startToken.loc.end.line : 1;
		    var end = endToken.loc.start.line;
		    var lines = 0;
	
		    for (var line = start; line < end; line++) {
		      if (typeof this.used[line] === "undefined") {
		        this.used[line] = true;
		        lines++;
		      }
		    }
	
		    return lines;
		  };
	
		  Whitespace.prototype._findToken = function _findToken(test, start, end) {
		    if (start >= end) return -1;
		    var middle = start + end >>> 1;
		    var match = test(this.tokens[middle]);
		    if (match < 0) {
		      return this._findToken(test, middle + 1, end);
		    } else if (match > 0) {
		      return this._findToken(test, start, middle);
		    } else if (match === 0) {
		      return middle;
		    }
		    return -1;
		  };
	
		  return Whitespace;
		}();
	
		exports.default = Whitespace;
		module.exports = exports["default"];
	
	/***/ }),
	/* 315 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = bindifyDecorators;
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function bindifyDecorators(decorators) {
		  for (var _iterator = decorators, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		    var _ref;
	
		    if (_isArray) {
		      if (_i >= _iterator.length) break;
		      _ref = _iterator[_i++];
		    } else {
		      _i = _iterator.next();
		      if (_i.done) break;
		      _ref = _i.value;
		    }
	
		    var decoratorPath = _ref;
	
		    var decorator = decoratorPath.node;
		    var expression = decorator.expression;
		    if (!t.isMemberExpression(expression)) continue;
	
		    var temp = decoratorPath.scope.maybeGenerateMemoised(expression.object);
		    var ref = void 0;
	
		    var nodes = [];
	
		    if (temp) {
		      ref = temp;
		      nodes.push(t.assignmentExpression("=", temp, expression.object));
		    } else {
		      ref = expression.object;
		    }
	
		    nodes.push(t.callExpression(t.memberExpression(t.memberExpression(ref, expression.property, expression.computed), t.identifier("bind")), [ref]));
	
		    if (nodes.length === 1) {
		      decorator.expression = nodes[0];
		    } else {
		      decorator.expression = t.sequenceExpression(nodes);
		    }
		  }
		}
		module.exports = exports["default"];
	
	/***/ }),
	/* 316 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (opts) {
		  var visitor = {};
	
		  function isAssignment(node) {
		    return node && node.operator === opts.operator + "=";
		  }
	
		  function buildAssignment(left, right) {
		    return t.assignmentExpression("=", left, right);
		  }
	
		  visitor.ExpressionStatement = function (path, file) {
		    if (path.isCompletionRecord()) return;
	
		    var expr = path.node.expression;
		    if (!isAssignment(expr)) return;
	
		    var nodes = [];
		    var exploded = (0, _babelHelperExplodeAssignableExpression2.default)(expr.left, nodes, file, path.scope, true);
	
		    nodes.push(t.expressionStatement(buildAssignment(exploded.ref, opts.build(exploded.uid, expr.right))));
	
		    path.replaceWithMultiple(nodes);
		  };
	
		  visitor.AssignmentExpression = function (path, file) {
		    var node = path.node,
		        scope = path.scope;
	
		    if (!isAssignment(node)) return;
	
		    var nodes = [];
		    var exploded = (0, _babelHelperExplodeAssignableExpression2.default)(node.left, nodes, file, scope);
		    nodes.push(buildAssignment(exploded.ref, opts.build(exploded.uid, node.right)));
		    path.replaceWithMultiple(nodes);
		  };
	
		  visitor.BinaryExpression = function (path) {
		    var node = path.node;
	
		    if (node.operator === opts.operator) {
		      path.replaceWith(opts.build(node.left, node.right));
		    }
		  };
	
		  return visitor;
		};
	
		var _babelHelperExplodeAssignableExpression = __webpack_require__(318);
	
		var _babelHelperExplodeAssignableExpression2 = _interopRequireDefault(_babelHelperExplodeAssignableExpression);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 317 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (path) {
		  var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : path.scope;
		  var node = path.node;
	
		  var container = t.functionExpression(null, [], node.body, node.generator, node.async);
	
		  var callee = container;
		  var args = [];
	
		  (0, _babelHelperHoistVariables2.default)(path, function (id) {
		    return scope.push({ id: id });
		  });
	
		  var state = {
		    foundThis: false,
		    foundArguments: false
		  };
	
		  path.traverse(visitor, state);
	
		  if (state.foundArguments) {
		    callee = t.memberExpression(container, t.identifier("apply"));
		    args = [];
	
		    if (state.foundThis) {
		      args.push(t.thisExpression());
		    }
	
		    if (state.foundArguments) {
		      if (!state.foundThis) args.push(t.nullLiteral());
		      args.push(t.identifier("arguments"));
		    }
		  }
	
		  var call = t.callExpression(callee, args);
		  if (node.generator) call = t.yieldExpression(call, true);
	
		  return t.returnStatement(call);
		};
	
		var _babelHelperHoistVariables = __webpack_require__(190);
	
		var _babelHelperHoistVariables2 = _interopRequireDefault(_babelHelperHoistVariables);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var visitor = {
		  enter: function enter(path, state) {
		    if (path.isThisExpression()) {
		      state.foundThis = true;
		    }
	
		    if (path.isReferencedIdentifier({ name: "arguments" })) {
		      state.foundArguments = true;
		    }
		  },
		  Function: function Function(path) {
		    path.skip();
		  }
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 318 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (node, nodes, file, scope, allowedSingleIdent) {
		  var obj = void 0;
		  if (t.isIdentifier(node) && allowedSingleIdent) {
		    obj = node;
		  } else {
		    obj = getObjRef(node, nodes, file, scope);
		  }
	
		  var ref = void 0,
		      uid = void 0;
	
		  if (t.isIdentifier(node)) {
		    ref = node;
		    uid = obj;
		  } else {
		    var prop = getPropRef(node, nodes, file, scope);
		    var computed = node.computed || t.isLiteral(prop);
		    uid = ref = t.memberExpression(obj, prop, computed);
		  }
	
		  return {
		    uid: uid,
		    ref: ref
		  };
		};
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function getObjRef(node, nodes, file, scope) {
		  var ref = void 0;
		  if (t.isSuper(node)) {
		    return node;
		  } else if (t.isIdentifier(node)) {
		    if (scope.hasBinding(node.name)) {
		      return node;
		    } else {
		      ref = node;
		    }
		  } else if (t.isMemberExpression(node)) {
		    ref = node.object;
	
		    if (t.isSuper(ref) || t.isIdentifier(ref) && scope.hasBinding(ref.name)) {
		      return ref;
		    }
		  } else {
		    throw new Error("We can't explode this node type " + node.type);
		  }
	
		  var temp = scope.generateUidIdentifierBasedOnNode(ref);
		  nodes.push(t.variableDeclaration("var", [t.variableDeclarator(temp, ref)]));
		  return temp;
		}
	
		function getPropRef(node, nodes, file, scope) {
		  var prop = node.property;
		  var key = t.toComputedKey(node, prop);
		  if (t.isLiteral(key) && t.isPureish(key)) return key;
	
		  var temp = scope.generateUidIdentifierBasedOnNode(prop);
		  nodes.push(t.variableDeclaration("var", [t.variableDeclarator(temp, prop)]));
		  return temp;
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 319 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (classPath) {
		  classPath.assertClass();
	
		  var memoisedExpressions = [];
	
		  function maybeMemoise(path) {
		    if (!path.node || path.isPure()) return;
	
		    var uid = classPath.scope.generateDeclaredUidIdentifier();
		    memoisedExpressions.push(t.assignmentExpression("=", uid, path.node));
		    path.replaceWith(uid);
		  }
	
		  function memoiseDecorators(paths) {
		    if (!Array.isArray(paths) || !paths.length) return;
	
		    paths = paths.reverse();
	
		    (0, _babelHelperBindifyDecorators2.default)(paths);
	
		    for (var _iterator = paths, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var path = _ref;
	
		      maybeMemoise(path);
		    }
		  }
	
		  maybeMemoise(classPath.get("superClass"));
		  memoiseDecorators(classPath.get("decorators"), true);
	
		  var methods = classPath.get("body.body");
		  for (var _iterator2 = methods, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		    var _ref2;
	
		    if (_isArray2) {
		      if (_i2 >= _iterator2.length) break;
		      _ref2 = _iterator2[_i2++];
		    } else {
		      _i2 = _iterator2.next();
		      if (_i2.done) break;
		      _ref2 = _i2.value;
		    }
	
		    var methodPath = _ref2;
	
		    if (methodPath.is("computed")) {
		      maybeMemoise(methodPath.get("key"));
		    }
	
		    if (methodPath.has("decorators")) {
		      memoiseDecorators(classPath.get("decorators"));
		    }
		  }
	
		  if (memoisedExpressions) {
		    classPath.insertBefore(memoisedExpressions.map(function (expr) {
		      return t.expressionStatement(expr);
		    }));
		  }
		};
	
		var _babelHelperBindifyDecorators = __webpack_require__(315);
	
		var _babelHelperBindifyDecorators2 = _interopRequireDefault(_babelHelperBindifyDecorators);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 320 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (path, helpers) {
		  var node = path.node,
		      scope = path.scope,
		      parent = path.parent;
	
		  var stepKey = scope.generateUidIdentifier("step");
		  var stepValue = scope.generateUidIdentifier("value");
		  var left = node.left;
		  var declar = void 0;
	
		  if (t.isIdentifier(left) || t.isPattern(left) || t.isMemberExpression(left)) {
		    declar = t.expressionStatement(t.assignmentExpression("=", left, stepValue));
		  } else if (t.isVariableDeclaration(left)) {
		    declar = t.variableDeclaration(left.kind, [t.variableDeclarator(left.declarations[0].id, stepValue)]);
		  }
	
		  var template = buildForAwait();
	
		  (0, _babelTraverse2.default)(template, forAwaitVisitor, null, {
		    ITERATOR_HAD_ERROR_KEY: scope.generateUidIdentifier("didIteratorError"),
		    ITERATOR_COMPLETION: scope.generateUidIdentifier("iteratorNormalCompletion"),
		    ITERATOR_ERROR_KEY: scope.generateUidIdentifier("iteratorError"),
		    ITERATOR_KEY: scope.generateUidIdentifier("iterator"),
		    GET_ITERATOR: helpers.getAsyncIterator,
		    OBJECT: node.right,
		    STEP_VALUE: stepValue,
		    STEP_KEY: stepKey,
		    AWAIT: helpers.wrapAwait
		  });
	
		  template = template.body.body;
	
		  var isLabeledParent = t.isLabeledStatement(parent);
		  var tryBody = template[3].block.body;
		  var loop = tryBody[0];
	
		  if (isLabeledParent) {
		    tryBody[0] = t.labeledStatement(parent.label, loop);
		  }
	
		  return {
		    replaceParent: isLabeledParent,
		    node: template,
		    declar: declar,
		    loop: loop
		  };
		};
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		var _babelTemplate = __webpack_require__(4);
	
		var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
		var _babelTraverse = __webpack_require__(7);
	
		var _babelTraverse2 = _interopRequireDefault(_babelTraverse);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		var buildForAwait = (0, _babelTemplate2.default)("\n  function* wrapper() {\n    var ITERATOR_COMPLETION = true;\n    var ITERATOR_HAD_ERROR_KEY = false;\n    var ITERATOR_ERROR_KEY = undefined;\n    try {\n      for (\n        var ITERATOR_KEY = GET_ITERATOR(OBJECT), STEP_KEY, STEP_VALUE;\n        (\n          STEP_KEY = yield AWAIT(ITERATOR_KEY.next()),\n          ITERATOR_COMPLETION = STEP_KEY.done,\n          STEP_VALUE = yield AWAIT(STEP_KEY.value),\n          !ITERATOR_COMPLETION\n        );\n        ITERATOR_COMPLETION = true) {\n      }\n    } catch (err) {\n      ITERATOR_HAD_ERROR_KEY = true;\n      ITERATOR_ERROR_KEY = err;\n    } finally {\n      try {\n        if (!ITERATOR_COMPLETION && ITERATOR_KEY.return) {\n          yield AWAIT(ITERATOR_KEY.return());\n        }\n      } finally {\n        if (ITERATOR_HAD_ERROR_KEY) {\n          throw ITERATOR_ERROR_KEY;\n        }\n      }\n    }\n  }\n");
	
		var forAwaitVisitor = {
		  noScope: true,
	
		  Identifier: function Identifier(path, replacements) {
		    if (path.node.name in replacements) {
		      path.replaceInline(replacements[path.node.name]);
		    }
		  },
		  CallExpression: function CallExpression(path, replacements) {
		    var callee = path.node.callee;
	
		    if (t.isIdentifier(callee) && callee.name === "AWAIT" && !replacements.AWAIT) {
		      path.replaceWith(path.node.arguments[0]);
		    }
		  }
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 321 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _babelTemplate = __webpack_require__(4);
	
		var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var helpers = {};
		exports.default = helpers;
	
		helpers.typeof = (0, _babelTemplate2.default)("\n  (typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\")\n    ? function (obj) { return typeof obj; }\n    : function (obj) {\n        return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype\n          ? \"symbol\"\n          : typeof obj;\n      };\n");
	
		helpers.jsx = (0, _babelTemplate2.default)("\n  (function () {\n    var REACT_ELEMENT_TYPE = (typeof Symbol === \"function\" && Symbol.for && Symbol.for(\"react.element\")) || 0xeac7;\n\n    return function createRawReactElement (type, props, key, children) {\n      var defaultProps = type && type.defaultProps;\n      var childrenLength = arguments.length - 3;\n\n      if (!props && childrenLength !== 0) {\n        // If we're going to assign props.children, we create a new object now\n        // to avoid mutating defaultProps.\n        props = {};\n      }\n      if (props && defaultProps) {\n        for (var propName in defaultProps) {\n          if (props[propName] === void 0) {\n            props[propName] = defaultProps[propName];\n          }\n        }\n      } else if (!props) {\n        props = defaultProps || {};\n      }\n\n      if (childrenLength === 1) {\n        props.children = children;\n      } else if (childrenLength > 1) {\n        var childArray = Array(childrenLength);\n        for (var i = 0; i < childrenLength; i++) {\n          childArray[i] = arguments[i + 3];\n        }\n        props.children = childArray;\n      }\n\n      return {\n        $$typeof: REACT_ELEMENT_TYPE,\n        type: type,\n        key: key === undefined ? null : '' + key,\n        ref: null,\n        props: props,\n        _owner: null,\n      };\n    };\n\n  })()\n");
	
		helpers.asyncIterator = (0, _babelTemplate2.default)("\n  (function (iterable) {\n    if (typeof Symbol === \"function\") {\n      if (Symbol.asyncIterator) {\n        var method = iterable[Symbol.asyncIterator];\n        if (method != null) return method.call(iterable);\n      }\n      if (Symbol.iterator) {\n        return iterable[Symbol.iterator]();\n      }\n    }\n    throw new TypeError(\"Object is not async iterable\");\n  })\n");
	
		helpers.asyncGenerator = (0, _babelTemplate2.default)("\n  (function () {\n    function AwaitValue(value) {\n      this.value = value;\n    }\n\n    function AsyncGenerator(gen) {\n      var front, back;\n\n      function send(key, arg) {\n        return new Promise(function (resolve, reject) {\n          var request = {\n            key: key,\n            arg: arg,\n            resolve: resolve,\n            reject: reject,\n            next: null\n          };\n\n          if (back) {\n            back = back.next = request;\n          } else {\n            front = back = request;\n            resume(key, arg);\n          }\n        });\n      }\n\n      function resume(key, arg) {\n        try {\n          var result = gen[key](arg)\n          var value = result.value;\n          if (value instanceof AwaitValue) {\n            Promise.resolve(value.value).then(\n              function (arg) { resume(\"next\", arg); },\n              function (arg) { resume(\"throw\", arg); });\n          } else {\n            settle(result.done ? \"return\" : \"normal\", result.value);\n          }\n        } catch (err) {\n          settle(\"throw\", err);\n        }\n      }\n\n      function settle(type, value) {\n        switch (type) {\n          case \"return\":\n            front.resolve({ value: value, done: true });\n            break;\n          case \"throw\":\n            front.reject(value);\n            break;\n          default:\n            front.resolve({ value: value, done: false });\n            break;\n        }\n\n        front = front.next;\n        if (front) {\n          resume(front.key, front.arg);\n        } else {\n          back = null;\n        }\n      }\n\n      this._invoke = send;\n\n      // Hide \"return\" method if generator return is not supported\n      if (typeof gen.return !== \"function\") {\n        this.return = undefined;\n      }\n    }\n\n    if (typeof Symbol === \"function\" && Symbol.asyncIterator) {\n      AsyncGenerator.prototype[Symbol.asyncIterator] = function () { return this; };\n    }\n\n    AsyncGenerator.prototype.next = function (arg) { return this._invoke(\"next\", arg); };\n    AsyncGenerator.prototype.throw = function (arg) { return this._invoke(\"throw\", arg); };\n    AsyncGenerator.prototype.return = function (arg) { return this._invoke(\"return\", arg); };\n\n    return {\n      wrap: function (fn) {\n        return function () {\n          return new AsyncGenerator(fn.apply(this, arguments));\n        };\n      },\n      await: function (value) {\n        return new AwaitValue(value);\n      }\n    };\n\n  })()\n");
	
		helpers.asyncGeneratorDelegate = (0, _babelTemplate2.default)("\n  (function (inner, awaitWrap) {\n    var iter = {}, waiting = false;\n\n    function pump(key, value) {\n      waiting = true;\n      value = new Promise(function (resolve) { resolve(inner[key](value)); });\n      return { done: false, value: awaitWrap(value) };\n    };\n\n    if (typeof Symbol === \"function\" && Symbol.iterator) {\n      iter[Symbol.iterator] = function () { return this; };\n    }\n\n    iter.next = function (value) {\n      if (waiting) {\n        waiting = false;\n        return value;\n      }\n      return pump(\"next\", value);\n    };\n\n    if (typeof inner.throw === \"function\") {\n      iter.throw = function (value) {\n        if (waiting) {\n          waiting = false;\n          throw value;\n        }\n        return pump(\"throw\", value);\n      };\n    }\n\n    if (typeof inner.return === \"function\") {\n      iter.return = function (value) {\n        return pump(\"return\", value);\n      };\n    }\n\n    return iter;\n  })\n");
	
		helpers.asyncToGenerator = (0, _babelTemplate2.default)("\n  (function (fn) {\n    return function () {\n      var gen = fn.apply(this, arguments);\n      return new Promise(function (resolve, reject) {\n        function step(key, arg) {\n          try {\n            var info = gen[key](arg);\n            var value = info.value;\n          } catch (error) {\n            reject(error);\n            return;\n          }\n\n          if (info.done) {\n            resolve(value);\n          } else {\n            return Promise.resolve(value).then(function (value) {\n              step(\"next\", value);\n            }, function (err) {\n              step(\"throw\", err);\n            });\n          }\n        }\n\n        return step(\"next\");\n      });\n    };\n  })\n");
	
		helpers.classCallCheck = (0, _babelTemplate2.default)("\n  (function (instance, Constructor) {\n    if (!(instance instanceof Constructor)) {\n      throw new TypeError(\"Cannot call a class as a function\");\n    }\n  });\n");
	
		helpers.createClass = (0, _babelTemplate2.default)("\n  (function() {\n    function defineProperties(target, props) {\n      for (var i = 0; i < props.length; i ++) {\n        var descriptor = props[i];\n        descriptor.enumerable = descriptor.enumerable || false;\n        descriptor.configurable = true;\n        if (\"value\" in descriptor) descriptor.writable = true;\n        Object.defineProperty(target, descriptor.key, descriptor);\n      }\n    }\n\n    return function (Constructor, protoProps, staticProps) {\n      if (protoProps) defineProperties(Constructor.prototype, protoProps);\n      if (staticProps) defineProperties(Constructor, staticProps);\n      return Constructor;\n    };\n  })()\n");
	
		helpers.defineEnumerableProperties = (0, _babelTemplate2.default)("\n  (function (obj, descs) {\n    for (var key in descs) {\n      var desc = descs[key];\n      desc.configurable = desc.enumerable = true;\n      if (\"value\" in desc) desc.writable = true;\n      Object.defineProperty(obj, key, desc);\n    }\n    return obj;\n  })\n");
	
		helpers.defaults = (0, _babelTemplate2.default)("\n  (function (obj, defaults) {\n    var keys = Object.getOwnPropertyNames(defaults);\n    for (var i = 0; i < keys.length; i++) {\n      var key = keys[i];\n      var value = Object.getOwnPropertyDescriptor(defaults, key);\n      if (value && value.configurable && obj[key] === undefined) {\n        Object.defineProperty(obj, key, value);\n      }\n    }\n    return obj;\n  })\n");
	
		helpers.defineProperty = (0, _babelTemplate2.default)("\n  (function (obj, key, value) {\n    // Shortcircuit the slow defineProperty path when possible.\n    // We are trying to avoid issues where setters defined on the\n    // prototype cause side effects under the fast path of simple\n    // assignment. By checking for existence of the property with\n    // the in operator, we can optimize most of this overhead away.\n    if (key in obj) {\n      Object.defineProperty(obj, key, {\n        value: value,\n        enumerable: true,\n        configurable: true,\n        writable: true\n      });\n    } else {\n      obj[key] = value;\n    }\n    return obj;\n  });\n");
	
		helpers.extends = (0, _babelTemplate2.default)("\n  Object.assign || (function (target) {\n    for (var i = 1; i < arguments.length; i++) {\n      var source = arguments[i];\n      for (var key in source) {\n        if (Object.prototype.hasOwnProperty.call(source, key)) {\n          target[key] = source[key];\n        }\n      }\n    }\n    return target;\n  })\n");
	
		helpers.get = (0, _babelTemplate2.default)("\n  (function get(object, property, receiver) {\n    if (object === null) object = Function.prototype;\n\n    var desc = Object.getOwnPropertyDescriptor(object, property);\n\n    if (desc === undefined) {\n      var parent = Object.getPrototypeOf(object);\n\n      if (parent === null) {\n        return undefined;\n      } else {\n        return get(parent, property, receiver);\n      }\n    } else if (\"value\" in desc) {\n      return desc.value;\n    } else {\n      var getter = desc.get;\n\n      if (getter === undefined) {\n        return undefined;\n      }\n\n      return getter.call(receiver);\n    }\n  });\n");
	
		helpers.inherits = (0, _babelTemplate2.default)("\n  (function (subClass, superClass) {\n    if (typeof superClass !== \"function\" && superClass !== null) {\n      throw new TypeError(\"Super expression must either be null or a function, not \" + typeof superClass);\n    }\n    subClass.prototype = Object.create(superClass && superClass.prototype, {\n      constructor: {\n        value: subClass,\n        enumerable: false,\n        writable: true,\n        configurable: true\n      }\n    });\n    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;\n  })\n");
	
		helpers.instanceof = (0, _babelTemplate2.default)("\n  (function (left, right) {\n    if (right != null && typeof Symbol !== \"undefined\" && right[Symbol.hasInstance]) {\n      return right[Symbol.hasInstance](left);\n    } else {\n      return left instanceof right;\n    }\n  });\n");
	
		helpers.interopRequireDefault = (0, _babelTemplate2.default)("\n  (function (obj) {\n    return obj && obj.__esModule ? obj : { default: obj };\n  })\n");
	
		helpers.interopRequireWildcard = (0, _babelTemplate2.default)("\n  (function (obj) {\n    if (obj && obj.__esModule) {\n      return obj;\n    } else {\n      var newObj = {};\n      if (obj != null) {\n        for (var key in obj) {\n          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];\n        }\n      }\n      newObj.default = obj;\n      return newObj;\n    }\n  })\n");
	
		helpers.newArrowCheck = (0, _babelTemplate2.default)("\n  (function (innerThis, boundThis) {\n    if (innerThis !== boundThis) {\n      throw new TypeError(\"Cannot instantiate an arrow function\");\n    }\n  });\n");
	
		helpers.objectDestructuringEmpty = (0, _babelTemplate2.default)("\n  (function (obj) {\n    if (obj == null) throw new TypeError(\"Cannot destructure undefined\");\n  });\n");
	
		helpers.objectWithoutProperties = (0, _babelTemplate2.default)("\n  (function (obj, keys) {\n    var target = {};\n    for (var i in obj) {\n      if (keys.indexOf(i) >= 0) continue;\n      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;\n      target[i] = obj[i];\n    }\n    return target;\n  })\n");
	
		helpers.possibleConstructorReturn = (0, _babelTemplate2.default)("\n  (function (self, call) {\n    if (!self) {\n      throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");\n    }\n    return call && (typeof call === \"object\" || typeof call === \"function\") ? call : self;\n  });\n");
	
		helpers.selfGlobal = (0, _babelTemplate2.default)("\n  typeof global === \"undefined\" ? self : global\n");
	
		helpers.set = (0, _babelTemplate2.default)("\n  (function set(object, property, value, receiver) {\n    var desc = Object.getOwnPropertyDescriptor(object, property);\n\n    if (desc === undefined) {\n      var parent = Object.getPrototypeOf(object);\n\n      if (parent !== null) {\n        set(parent, property, value, receiver);\n      }\n    } else if (\"value\" in desc && desc.writable) {\n      desc.value = value;\n    } else {\n      var setter = desc.set;\n\n      if (setter !== undefined) {\n        setter.call(receiver, value);\n      }\n    }\n\n    return value;\n  });\n");
	
		helpers.slicedToArray = (0, _babelTemplate2.default)("\n  (function () {\n    // Broken out into a separate function to avoid deoptimizations due to the try/catch for the\n    // array iterator case.\n    function sliceIterator(arr, i) {\n      // this is an expanded form of `for...of` that properly supports abrupt completions of\n      // iterators etc. variable names have been minimised to reduce the size of this massive\n      // helper. sometimes spec compliancy is annoying :(\n      //\n      // _n = _iteratorNormalCompletion\n      // _d = _didIteratorError\n      // _e = _iteratorError\n      // _i = _iterator\n      // _s = _step\n\n      var _arr = [];\n      var _n = true;\n      var _d = false;\n      var _e = undefined;\n      try {\n        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {\n          _arr.push(_s.value);\n          if (i && _arr.length === i) break;\n        }\n      } catch (err) {\n        _d = true;\n        _e = err;\n      } finally {\n        try {\n          if (!_n && _i[\"return\"]) _i[\"return\"]();\n        } finally {\n          if (_d) throw _e;\n        }\n      }\n      return _arr;\n    }\n\n    return function (arr, i) {\n      if (Array.isArray(arr)) {\n        return arr;\n      } else if (Symbol.iterator in Object(arr)) {\n        return sliceIterator(arr, i);\n      } else {\n        throw new TypeError(\"Invalid attempt to destructure non-iterable instance\");\n      }\n    };\n  })();\n");
	
		helpers.slicedToArrayLoose = (0, _babelTemplate2.default)("\n  (function (arr, i) {\n    if (Array.isArray(arr)) {\n      return arr;\n    } else if (Symbol.iterator in Object(arr)) {\n      var _arr = [];\n      for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {\n        _arr.push(_step.value);\n        if (i && _arr.length === i) break;\n      }\n      return _arr;\n    } else {\n      throw new TypeError(\"Invalid attempt to destructure non-iterable instance\");\n    }\n  });\n");
	
		helpers.taggedTemplateLiteral = (0, _babelTemplate2.default)("\n  (function (strings, raw) {\n    return Object.freeze(Object.defineProperties(strings, {\n        raw: { value: Object.freeze(raw) }\n    }));\n  });\n");
	
		helpers.taggedTemplateLiteralLoose = (0, _babelTemplate2.default)("\n  (function (strings, raw) {\n    strings.raw = raw;\n    return strings;\n  });\n");
	
		helpers.temporalRef = (0, _babelTemplate2.default)("\n  (function (val, name, undef) {\n    if (val === undef) {\n      throw new ReferenceError(name + \" is not defined - temporal dead zone\");\n    } else {\n      return val;\n    }\n  })\n");
	
		helpers.temporalUndefined = (0, _babelTemplate2.default)("\n  ({})\n");
	
		helpers.toArray = (0, _babelTemplate2.default)("\n  (function (arr) {\n    return Array.isArray(arr) ? arr : Array.from(arr);\n  });\n");
	
		helpers.toConsumableArray = (0, _babelTemplate2.default)("\n  (function (arr) {\n    if (Array.isArray(arr)) {\n      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];\n      return arr2;\n    } else {\n      return Array.from(arr);\n    }\n  });\n");
		module.exports = exports["default"];
	
	/***/ }),
	/* 322 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  return {
		    pre: function pre(file) {
		      file.set("helpersNamespace", t.identifier("babelHelpers"));
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 323 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Created at 16/5/18.
		 * @Author Ling.
		 * @Email i@zeroling.com
		 */
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		var babylon = __webpack_require__(89);
	
		module.exports = function (babel) {
		  var t = babel.types;
		  // cache for performance
		  var parseMap = {};
	
		  return {
		    visitor: {
		      Identifier: function Identifier(path, state) {
		        if (path.parent.type === 'MemberExpression') {
		          return;
		        }
		        if (path.parent.type === 'ClassMethod') {
		          return;
		        }
		        if (path.isPure()) {
		          return;
		        }
		        if (!state.opts.hasOwnProperty(path.node.name)) {
		          return;
		        }
		        var replacementDescriptor = state.opts[path.node.name];
		        if (replacementDescriptor === undefined || replacementDescriptor === null) {
		          replacementDescriptor = t.identifier(String(replacementDescriptor));
		        }
	
		        var type = typeof replacementDescriptor === 'undefined' ? 'undefined' : _typeof(replacementDescriptor);
		        if (type === 'string' || type === 'boolean') {
		          replacementDescriptor = {
		            type: type,
		            replacement: replacementDescriptor
		          };
		        } else if (t.isNode(replacementDescriptor)) {
		          replacementDescriptor = {
		            type: 'node',
		            replacement: replacementDescriptor
		          };
		        } else if (type === 'object' && replacementDescriptor.type === 'node' && typeof replacementDescriptor.replacement === 'string') {
		          replacementDescriptor.replacement = parseMap[replacementDescriptor.replacement] ? parseMap[replacementDescriptor.replacement] : babylon.parseExpression(replacementDescriptor.replacement);
		        }
	
		        var replacement = replacementDescriptor.replacement;
		        switch (replacementDescriptor.type) {
		          case 'boolean':
		            path.replaceWith(t.booleanLiteral(replacement));
		            break;
		          case 'node':
		            if (t.isNode(replacement)) {
		              path.replaceWith(replacement);
		            }
		            break;
		          default:
		            // treat as string
		            var str = String(replacement);
		            path.replaceWith(t.stringLiteral(str));
		            break;
		        }
		      }
		    }
		  };
		};
	
	/***/ }),
	/* 324 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    manipulateOptions: function manipulateOptions(opts, parserOpts) {
		      parserOpts.plugins.push("dynamicImport");
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 325 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    manipulateOptions: function manipulateOptions(opts, parserOpts) {
		      parserOpts.plugins.push("functionSent");
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 326 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    inherits: __webpack_require__(67)
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 327 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  var yieldStarVisitor = {
		    Function: function Function(path) {
		      path.skip();
		    },
		    YieldExpression: function YieldExpression(_ref2, state) {
		      var node = _ref2.node;
	
		      if (!node.delegate) return;
		      var callee = state.addHelper("asyncGeneratorDelegate");
		      node.argument = t.callExpression(callee, [t.callExpression(state.addHelper("asyncIterator"), [node.argument]), t.memberExpression(state.addHelper("asyncGenerator"), t.identifier("await"))]);
		    }
		  };
	
		  return {
		    inherits: __webpack_require__(195),
		    visitor: {
		      Function: function Function(path, state) {
		        if (!path.node.async || !path.node.generator) return;
	
		        path.traverse(yieldStarVisitor, state);
	
		        (0, _babelHelperRemapAsyncToGenerator2.default)(path, state.file, {
		          wrapAsync: t.memberExpression(state.addHelper("asyncGenerator"), t.identifier("wrap")),
		          wrapAwait: t.memberExpression(state.addHelper("asyncGenerator"), t.identifier("await"))
		        });
		      }
		    }
		  };
		};
	
		var _babelHelperRemapAsyncToGenerator = __webpack_require__(124);
	
		var _babelHelperRemapAsyncToGenerator2 = _interopRequireDefault(_babelHelperRemapAsyncToGenerator);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 328 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    inherits: __webpack_require__(67),
	
		    visitor: {
		      Function: function Function(path, state) {
		        if (!path.node.async || path.node.generator) return;
	
		        (0, _babelHelperRemapAsyncToGenerator2.default)(path, state.file, {
		          wrapAsync: state.addImport(state.opts.module, state.opts.method)
		        });
		      }
		    }
		  };
		};
	
		var _babelHelperRemapAsyncToGenerator = __webpack_require__(124);
	
		var _babelHelperRemapAsyncToGenerator2 = _interopRequireDefault(_babelHelperRemapAsyncToGenerator);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 329 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
	
		exports.default = function (_ref) {
		    var t = _ref.types;
	
		    /**
		     * Add a helper to take an initial descriptor, apply some decorators to it, and optionally
		     * define the property.
		     */
		    function ensureApplyDecoratedDescriptorHelper(path, state) {
		        if (!state.applyDecoratedDescriptor) {
		            state.applyDecoratedDescriptor = path.scope.generateUidIdentifier('applyDecoratedDescriptor');
		            var helper = buildApplyDecoratedDescriptor({
		                NAME: state.applyDecoratedDescriptor
		            });
		            path.scope.getProgramParent().path.unshiftContainer('body', helper);
		        }
	
		        return state.applyDecoratedDescriptor;
		    }
	
		    /**
		     * Add a helper to call as a replacement for class property definition.
		     */
		    function ensureInitializerDefineProp(path, state) {
		        if (!state.initializerDefineProp) {
		            state.initializerDefineProp = path.scope.generateUidIdentifier('initDefineProp');
		            var helper = buildInitializerDefineProperty({
		                NAME: state.initializerDefineProp
		            });
		            path.scope.getProgramParent().path.unshiftContainer('body', helper);
		        }
	
		        return state.initializerDefineProp;
		    }
	
		    /**
		     * Add a helper that will throw a useful error if the transform fails to detect the class
		     * property assignment, so users know something failed.
		     */
		    function ensureInitializerWarning(path, state) {
		        if (!state.initializerWarningHelper) {
		            state.initializerWarningHelper = path.scope.generateUidIdentifier('initializerWarningHelper');
		            var helper = buildInitializerWarningHelper({
		                NAME: state.initializerWarningHelper
		            });
		            path.scope.getProgramParent().path.unshiftContainer('body', helper);
		        }
	
		        return state.initializerWarningHelper;
		    }
	
		    /**
		     * If the decorator expressions are non-identifiers, hoist them to before the class so we can be sure
		     * that they are evaluated in order.
		     */
		    function applyEnsureOrdering(path) {
		        // TODO: This should probably also hoist computed properties.
		        var decorators = (path.isClass() ? [path].concat(path.get('body.body')) : path.get('properties')).reduce(function (acc, prop) {
		            return acc.concat(prop.node.decorators || []);
		        }, []);
	
		        var identDecorators = decorators.filter(function (decorator) {
		            return !t.isIdentifier(decorator.expression);
		        });
		        if (identDecorators.length === 0) return;
	
		        return t.sequenceExpression(identDecorators.map(function (decorator) {
		            var expression = decorator.expression;
		            var id = decorator.expression = path.scope.generateDeclaredUidIdentifier('dec');
		            return t.assignmentExpression('=', id, expression);
		        }).concat([path.node]));
		    }
	
		    /**
		     * Given a class expression with class-level decorators, create a new expression
		     * with the proper decorated behavior.
		     */
		    function applyClassDecorators(classPath, state) {
		        var decorators = classPath.node.decorators || [];
		        classPath.node.decorators = null;
	
		        if (decorators.length === 0) return;
	
		        var name = classPath.scope.generateDeclaredUidIdentifier('class');
	
		        return decorators.map(function (dec) {
		            return dec.expression;
		        }).reverse().reduce(function (acc, decorator) {
		            return buildClassDecorator({
		                CLASS_REF: name,
		                DECORATOR: decorator,
		                INNER: acc
		            }).expression;
		        }, classPath.node);
		    }
	
		    /**
		     * Given a class expression with method-level decorators, create a new expression
		     * with the proper decorated behavior.
		     */
		    function applyMethodDecorators(path, state) {
		        var hasMethodDecorators = path.node.body.body.some(function (node) {
		            return (node.decorators || []).length > 0;
		        });
	
		        if (!hasMethodDecorators) return;
	
		        return applyTargetDecorators(path, state, path.node.body.body);
		    }
	
		    /**
		     * Given an object expression with property decorators, create a new expression
		     * with the proper decorated behavior.
		     */
		    function applyObjectDecorators(path, state) {
		        var hasMethodDecorators = path.node.properties.some(function (node) {
		            return (node.decorators || []).length > 0;
		        });
	
		        if (!hasMethodDecorators) return;
	
		        return applyTargetDecorators(path, state, path.node.properties);
		    }
	
		    /**
		     * A helper to pull out property decorators into a sequence expression.
		     */
		    function applyTargetDecorators(path, state, decoratedProps) {
		        var descName = path.scope.generateDeclaredUidIdentifier('desc');
		        var valueTemp = path.scope.generateDeclaredUidIdentifier('value');
	
		        var name = path.scope.generateDeclaredUidIdentifier(path.isClass() ? 'class' : 'obj');
	
		        var exprs = decoratedProps.reduce(function (acc, node) {
		            var decorators = node.decorators || [];
		            node.decorators = null;
	
		            if (decorators.length === 0) return acc;
	
		            if (node.computed) {
		                throw path.buildCodeFrameError('Computed method/property decorators are not yet supported.');
		            }
	
		            var property = t.isLiteral(node.key) ? node.key : t.stringLiteral(node.key.name);
	
		            var target = path.isClass() && !node.static ? buildClassPrototype({
		                CLASS_REF: name
		            }).expression : name;
	
		            if (t.isClassProperty(node, { static: false })) {
		                var descriptor = path.scope.generateDeclaredUidIdentifier('descriptor');
	
		                var initializer = node.value ? t.functionExpression(null, [], t.blockStatement([t.returnStatement(node.value)])) : t.nullLiteral();
		                node.value = t.callExpression(ensureInitializerWarning(path, state), [descriptor, t.thisExpression()]);
	
		                acc = acc.concat([t.assignmentExpression('=', descriptor, t.callExpression(ensureApplyDecoratedDescriptorHelper(path, state), [target, property, t.arrayExpression(decorators.map(function (dec) {
		                    return dec.expression;
		                })), t.objectExpression([t.objectProperty(t.identifier('enumerable'), t.booleanLiteral(true)), t.objectProperty(t.identifier('initializer'), initializer)])]))]);
		            } else {
		                acc = acc.concat(t.callExpression(ensureApplyDecoratedDescriptorHelper(path, state), [target, property, t.arrayExpression(decorators.map(function (dec) {
		                    return dec.expression;
		                })), t.isObjectProperty(node) || t.isClassProperty(node, { static: true }) ? buildGetObjectInitializer({
		                    TEMP: path.scope.generateDeclaredUidIdentifier('init'),
		                    TARGET: target,
		                    PROPERTY: property
		                }).expression : buildGetDescriptor({
		                    TARGET: target,
		                    PROPERTY: property
		                }).expression, target]));
		            }
	
		            return acc;
		        }, []);
	
		        return t.sequenceExpression([t.assignmentExpression('=', name, path.node), t.sequenceExpression(exprs), name]);
		    }
	
		    return {
		        inherits: __webpack_require__(125),
	
		        visitor: {
		            ExportDefaultDeclaration: function ExportDefaultDeclaration(path) {
		                if (!path.get("declaration").isClassDeclaration()) return;
	
		                var node = path.node;
	
		                var ref = node.declaration.id || path.scope.generateUidIdentifier("default");
		                node.declaration.id = ref;
	
		                // Split the class declaration and the export into two separate statements.
		                path.replaceWith(node.declaration);
		                path.insertAfter(t.exportNamedDeclaration(null, [t.exportSpecifier(ref, t.identifier('default'))]));
		            },
		            ClassDeclaration: function ClassDeclaration(path) {
		                var node = path.node;
	
		                var ref = node.id || path.scope.generateUidIdentifier("class");
	
		                path.replaceWith(t.variableDeclaration("let", [t.variableDeclarator(ref, t.toExpression(node))]));
		            },
		            ClassExpression: function ClassExpression(path, state) {
		                // Create a replacement for the class node if there is one. We do one pass to replace classes with
		                // class decorators, and a second pass to process method decorators.
		                var decoratedClass = applyEnsureOrdering(path) || applyClassDecorators(path, state) || applyMethodDecorators(path, state);
	
		                if (decoratedClass) path.replaceWith(decoratedClass);
		            },
		            ObjectExpression: function ObjectExpression(path, state) {
		                var decoratedObject = applyEnsureOrdering(path) || applyObjectDecorators(path, state);
	
		                if (decoratedObject) path.replaceWith(decoratedObject);
		            },
		            AssignmentExpression: function AssignmentExpression(path, state) {
		                if (!state.initializerWarningHelper) return;
	
		                if (!path.get('left').isMemberExpression()) return;
		                if (!path.get('left.property').isIdentifier()) return;
		                if (!path.get('right').isCallExpression()) return;
		                if (!path.get('right.callee').isIdentifier({ name: state.initializerWarningHelper.name })) return;
	
		                path.replaceWith(t.callExpression(ensureInitializerDefineProp(path, state), [path.get('left.object').node, t.stringLiteral(path.get('left.property').node.name), path.get('right.arguments')[0].node, path.get('right.arguments')[1].node]));
		            }
		        }
		    };
		};
	
		var _babelTemplate = __webpack_require__(4);
	
		var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
		function _interopRequireDefault(obj) {
		    return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var buildClassDecorator = (0, _babelTemplate2.default)('\n  DECORATOR(CLASS_REF = INNER) || CLASS_REF;\n');
	
		var buildClassPrototype = (0, _babelTemplate2.default)('\n  CLASS_REF.prototype;\n');
	
		var buildGetDescriptor = (0, _babelTemplate2.default)('\n    Object.getOwnPropertyDescriptor(TARGET, PROPERTY);\n');
	
		var buildGetObjectInitializer = (0, _babelTemplate2.default)('\n    (TEMP = Object.getOwnPropertyDescriptor(TARGET, PROPERTY), (TEMP = TEMP ? TEMP.value : undefined), {\n        enumerable: true,\n        configurable: true,\n        writable: true,\n        initializer: function(){\n            return TEMP;\n        }\n    })\n');
	
		var buildInitializerWarningHelper = (0, _babelTemplate2.default)('\n    function NAME(descriptor, context){\n        throw new Error(\'Decorating class property failed. Please ensure that transform-class-properties is enabled.\');\n    }\n');
	
		var buildInitializerDefineProperty = (0, _babelTemplate2.default)('\n    function NAME(target, property, descriptor, context){\n        if (!descriptor) return;\n\n        Object.defineProperty(target, property, {\n            enumerable: descriptor.enumerable,\n            configurable: descriptor.configurable,\n            writable: descriptor.writable,\n            value: descriptor.initializer ? descriptor.initializer.call(context) : void 0,\n        });\n    }\n');
	
		var buildApplyDecoratedDescriptor = (0, _babelTemplate2.default)('\n    function NAME(target, property, decorators, descriptor, context){\n        var desc = {};\n        Object[\'ke\' + \'ys\'](descriptor).forEach(function(key){\n            desc[key] = descriptor[key];\n        });\n        desc.enumerable = !!desc.enumerable;\n        desc.configurable = !!desc.configurable;\n        if (\'value\' in desc || desc.initializer){\n            desc.writable = true;\n        }\n\n        desc = decorators.slice().reverse().reduce(function(desc, decorator){\n            return decorator(target, property, desc) || desc;\n        }, desc);\n\n        if (context && desc.initializer !== void 0){\n            desc.value = desc.initializer ? desc.initializer.call(context) : void 0;\n            desc.initializer = undefined;\n        }\n\n        if (desc.initializer === void 0){\n            // This is a hack to avoid this being processed by \'transform-runtime\'.\n            // See issue #9.\n            Object[\'define\' + \'Property\'](target, property, desc);\n            desc = null;\n        }\n\n        return desc;\n    }\n');
	
		;
	
	/***/ }),
	/* 330 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.visitor = undefined;
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function getTDZStatus(refPath, bindingPath) {
		  var executionStatus = bindingPath._guessExecutionStatusRelativeTo(refPath);
	
		  if (executionStatus === "before") {
		    return "inside";
		  } else if (executionStatus === "after") {
		    return "outside";
		  } else {
		    return "maybe";
		  }
		}
	
		function buildTDZAssert(node, file) {
		  return t.callExpression(file.addHelper("temporalRef"), [node, t.stringLiteral(node.name), file.addHelper("temporalUndefined")]);
		}
	
		function isReference(node, scope, state) {
		  var declared = state.letReferences[node.name];
		  if (!declared) return false;
	
		  return scope.getBindingIdentifier(node.name) === declared;
		}
	
		var visitor = exports.visitor = {
		  ReferencedIdentifier: function ReferencedIdentifier(path, state) {
		    if (!this.file.opts.tdz) return;
	
		    var node = path.node,
		        parent = path.parent,
		        scope = path.scope;
	
		    if (path.parentPath.isFor({ left: node })) return;
		    if (!isReference(node, scope, state)) return;
	
		    var bindingPath = scope.getBinding(node.name).path;
	
		    var status = getTDZStatus(path, bindingPath);
		    if (status === "inside") return;
	
		    if (status === "maybe") {
		      var assert = buildTDZAssert(node, state.file);
	
		      bindingPath.parent._tdzThis = true;
	
		      path.skip();
	
		      if (path.parentPath.isUpdateExpression()) {
		        if (parent._ignoreBlockScopingTDZ) return;
		        path.parentPath.replaceWith(t.sequenceExpression([assert, parent]));
		      } else {
		        path.replaceWith(assert);
		      }
		    } else if (status === "outside") {
		      path.replaceWith(t.throwStatement(t.inherits(t.newExpression(t.identifier("ReferenceError"), [t.stringLiteral(node.name + " is not defined - temporal dead zone")]), node)));
		    }
		  },
	
		  AssignmentExpression: {
		    exit: function exit(path, state) {
		      if (!this.file.opts.tdz) return;
	
		      var node = path.node;
	
		      if (node._ignoreBlockScopingTDZ) return;
	
		      var nodes = [];
		      var ids = path.getBindingIdentifiers();
	
		      for (var name in ids) {
		        var id = ids[name];
	
		        if (isReference(id, path.scope, state)) {
		          nodes.push(buildTDZAssert(id, state.file));
		        }
		      }
	
		      if (nodes.length) {
		        node._ignoreBlockScopingTDZ = true;
		        nodes.push(node);
		        path.replaceWithMultiple(nodes.map(t.expressionStatement));
		      }
		    }
		  }
		};
	
	/***/ }),
	/* 331 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _possibleConstructorReturn2 = __webpack_require__(42);
	
		var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
		var _inherits2 = __webpack_require__(41);
	
		var _inherits3 = _interopRequireDefault(_inherits2);
	
		var _babelHelperFunctionName = __webpack_require__(40);
	
		var _babelHelperFunctionName2 = _interopRequireDefault(_babelHelperFunctionName);
	
		var _vanilla = __webpack_require__(207);
	
		var _vanilla2 = _interopRequireDefault(_vanilla);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var LooseClassTransformer = function (_VanillaTransformer) {
		  (0, _inherits3.default)(LooseClassTransformer, _VanillaTransformer);
	
		  function LooseClassTransformer() {
		    (0, _classCallCheck3.default)(this, LooseClassTransformer);
	
		    var _this = (0, _possibleConstructorReturn3.default)(this, _VanillaTransformer.apply(this, arguments));
	
		    _this.isLoose = true;
		    return _this;
		  }
	
		  LooseClassTransformer.prototype._processMethod = function _processMethod(node, scope) {
		    if (!node.decorators) {
	
		      var classRef = this.classRef;
		      if (!node.static) classRef = t.memberExpression(classRef, t.identifier("prototype"));
		      var methodName = t.memberExpression(classRef, node.key, node.computed || t.isLiteral(node.key));
	
		      var func = t.functionExpression(null, node.params, node.body, node.generator, node.async);
		      func.returnType = node.returnType;
		      var key = t.toComputedKey(node, node.key);
		      if (t.isStringLiteral(key)) {
		        func = (0, _babelHelperFunctionName2.default)({
		          node: func,
		          id: key,
		          scope: scope
		        });
		      }
	
		      var expr = t.expressionStatement(t.assignmentExpression("=", methodName, func));
		      t.inheritsComments(expr, node);
		      this.body.push(expr);
		      return true;
		    }
		  };
	
		  return LooseClassTransformer;
		}(_vanilla2.default);
	
		exports.default = LooseClassTransformer;
		module.exports = exports["default"];
	
	/***/ }),
	/* 332 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  return {
		    visitor: {
		      BinaryExpression: function BinaryExpression(path) {
		        var node = path.node;
	
		        if (node.operator === "instanceof") {
		          path.replaceWith(t.callExpression(this.addHelper("instanceof"), [node.left, node.right]));
		        }
		      }
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 333 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.visitor = undefined;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _babelHelperGetFunctionArity = __webpack_require__(189);
	
		var _babelHelperGetFunctionArity2 = _interopRequireDefault(_babelHelperGetFunctionArity);
	
		var _babelHelperCallDelegate = __webpack_require__(317);
	
		var _babelHelperCallDelegate2 = _interopRequireDefault(_babelHelperCallDelegate);
	
		var _babelTemplate = __webpack_require__(4);
	
		var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var buildDefaultParam = (0, _babelTemplate2.default)("\n  let VARIABLE_NAME =\n    ARGUMENTS.length > ARGUMENT_KEY && ARGUMENTS[ARGUMENT_KEY] !== undefined ?\n      ARGUMENTS[ARGUMENT_KEY]\n    :\n      DEFAULT_VALUE;\n");
	
		var buildCutOff = (0, _babelTemplate2.default)("\n  let $0 = $1[$2];\n");
	
		function hasDefaults(node) {
		  for (var _iterator = node.params, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		    var _ref;
	
		    if (_isArray) {
		      if (_i >= _iterator.length) break;
		      _ref = _iterator[_i++];
		    } else {
		      _i = _iterator.next();
		      if (_i.done) break;
		      _ref = _i.value;
		    }
	
		    var param = _ref;
	
		    if (!t.isIdentifier(param)) return true;
		  }
		  return false;
		}
	
		function isSafeBinding(scope, node) {
		  if (!scope.hasOwnBinding(node.name)) return true;
	
		  var _scope$getOwnBinding = scope.getOwnBinding(node.name),
		      kind = _scope$getOwnBinding.kind;
	
		  return kind === "param" || kind === "local";
		}
	
		var iifeVisitor = {
		  ReferencedIdentifier: function ReferencedIdentifier(path, state) {
		    var scope = path.scope,
		        node = path.node;
	
		    if (node.name === "eval" || !isSafeBinding(scope, node)) {
		      state.iife = true;
		      path.stop();
		    }
		  },
		  Scope: function Scope(path) {
		    path.skip();
		  }
		};
	
		var visitor = exports.visitor = {
		  Function: function Function(path) {
		    var node = path.node,
		        scope = path.scope;
	
		    if (!hasDefaults(node)) return;
	
		    path.ensureBlock();
	
		    var state = {
		      iife: false,
		      scope: scope
		    };
	
		    var body = [];
	
		    var argsIdentifier = t.identifier("arguments");
		    argsIdentifier._shadowedFunctionLiteral = path;
	
		    function pushDefNode(left, right, i) {
		      var defNode = buildDefaultParam({
		        VARIABLE_NAME: left,
		        DEFAULT_VALUE: right,
		        ARGUMENT_KEY: t.numericLiteral(i),
		        ARGUMENTS: argsIdentifier
		      });
		      defNode._blockHoist = node.params.length - i;
		      body.push(defNode);
		    }
	
		    var lastNonDefaultParam = (0, _babelHelperGetFunctionArity2.default)(node);
	
		    var params = path.get("params");
		    for (var i = 0; i < params.length; i++) {
		      var param = params[i];
	
		      if (!param.isAssignmentPattern()) {
		        if (!state.iife && !param.isIdentifier()) {
		          param.traverse(iifeVisitor, state);
		        }
	
		        continue;
		      }
	
		      var left = param.get("left");
		      var right = param.get("right");
	
		      if (i >= lastNonDefaultParam || left.isPattern()) {
		        var placeholder = scope.generateUidIdentifier("x");
		        placeholder._isDefaultPlaceholder = true;
		        node.params[i] = placeholder;
		      } else {
		        node.params[i] = left.node;
		      }
	
		      if (!state.iife) {
		        if (right.isIdentifier() && !isSafeBinding(scope, right.node)) {
		          state.iife = true;
		        } else {
		          right.traverse(iifeVisitor, state);
		        }
		      }
	
		      pushDefNode(left.node, right.node, i);
		    }
	
		    for (var _i2 = lastNonDefaultParam + 1; _i2 < node.params.length; _i2++) {
		      var _param = node.params[_i2];
		      if (_param._isDefaultPlaceholder) continue;
	
		      var declar = buildCutOff(_param, argsIdentifier, t.numericLiteral(_i2));
		      declar._blockHoist = node.params.length - _i2;
		      body.push(declar);
		    }
	
		    node.params = node.params.slice(0, lastNonDefaultParam);
	
		    if (state.iife) {
		      body.push((0, _babelHelperCallDelegate2.default)(path, scope));
		      path.set("body", t.blockStatement(body));
		    } else {
		      path.get("body").unshiftContainer("body", body);
		    }
		  }
		};
	
	/***/ }),
	/* 334 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.visitor = undefined;
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		var visitor = exports.visitor = {
		  Function: function Function(path) {
		    var params = path.get("params");
	
		    var hoistTweak = t.isRestElement(params[params.length - 1]) ? 1 : 0;
		    var outputParamsLength = params.length - hoistTweak;
	
		    for (var i = 0; i < outputParamsLength; i++) {
		      var param = params[i];
		      if (param.isArrayPattern() || param.isObjectPattern()) {
		        var uid = path.scope.generateUidIdentifier("ref");
	
		        var declar = t.variableDeclaration("let", [t.variableDeclarator(param.node, uid)]);
		        declar._blockHoist = outputParamsLength - i;
	
		        path.ensureBlock();
		        path.get("body").unshiftContainer("body", declar);
	
		        param.replaceWith(uid);
		      }
		    }
		  }
		};
	
	/***/ }),
	/* 335 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.visitor = undefined;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _babelTemplate = __webpack_require__(4);
	
		var _babelTemplate2 = _interopRequireDefault(_babelTemplate);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var buildRest = (0, _babelTemplate2.default)("\n  for (var LEN = ARGUMENTS.length,\n           ARRAY = Array(ARRAY_LEN),\n           KEY = START;\n       KEY < LEN;\n       KEY++) {\n    ARRAY[ARRAY_KEY] = ARGUMENTS[KEY];\n  }\n");
	
		var restIndex = (0, _babelTemplate2.default)("\n  ARGUMENTS.length <= INDEX ? undefined : ARGUMENTS[INDEX]\n");
	
		var restIndexImpure = (0, _babelTemplate2.default)("\n  REF = INDEX, ARGUMENTS.length <= REF ? undefined : ARGUMENTS[REF]\n");
	
		var restLength = (0, _babelTemplate2.default)("\n  ARGUMENTS.length <= OFFSET ? 0 : ARGUMENTS.length - OFFSET\n");
	
		var memberExpressionOptimisationVisitor = {
		  Scope: function Scope(path, state) {
		    if (!path.scope.bindingIdentifierEquals(state.name, state.outerBinding)) {
		      path.skip();
		    }
		  },
		  Flow: function Flow(path) {
		    if (path.isTypeCastExpression()) return;
	
		    path.skip();
		  },
	
		  "Function|ClassProperty": function FunctionClassProperty(path, state) {
		    var oldNoOptimise = state.noOptimise;
		    state.noOptimise = true;
		    path.traverse(memberExpressionOptimisationVisitor, state);
		    state.noOptimise = oldNoOptimise;
	
		    path.skip();
		  },
	
		  ReferencedIdentifier: function ReferencedIdentifier(path, state) {
		    var node = path.node;
	
		    if (node.name === "arguments") {
		      state.deopted = true;
		    }
	
		    if (node.name !== state.name) return;
	
		    if (state.noOptimise) {
		      state.deopted = true;
		    } else {
		      var parentPath = path.parentPath;
	
		      if (parentPath.listKey === "params" && parentPath.key < state.offset) {
		        return;
		      }
	
		      if (parentPath.isMemberExpression({ object: node })) {
		        var grandparentPath = parentPath.parentPath;
	
		        var argsOptEligible = !state.deopted && !(grandparentPath.isAssignmentExpression() && parentPath.node === grandparentPath.node.left || grandparentPath.isLVal() || grandparentPath.isForXStatement() || grandparentPath.isUpdateExpression() || grandparentPath.isUnaryExpression({ operator: "delete" }) || (grandparentPath.isCallExpression() || grandparentPath.isNewExpression()) && parentPath.node === grandparentPath.node.callee);
	
		        if (argsOptEligible) {
		          if (parentPath.node.computed) {
		            if (parentPath.get("property").isBaseType("number")) {
		              state.candidates.push({ cause: "indexGetter", path: path });
		              return;
		            }
		          } else if (parentPath.node.property.name === "length") {
		            state.candidates.push({ cause: "lengthGetter", path: path });
		            return;
		          }
		        }
		      }
	
		      if (state.offset === 0 && parentPath.isSpreadElement()) {
		        var call = parentPath.parentPath;
		        if (call.isCallExpression() && call.node.arguments.length === 1) {
		          state.candidates.push({ cause: "argSpread", path: path });
		          return;
		        }
		      }
	
		      state.references.push(path);
		    }
		  },
		  BindingIdentifier: function BindingIdentifier(_ref, state) {
		    var node = _ref.node;
	
		    if (node.name === state.name) {
		      state.deopted = true;
		    }
		  }
		};
		function hasRest(node) {
		  return t.isRestElement(node.params[node.params.length - 1]);
		}
	
		function optimiseIndexGetter(path, argsId, offset) {
		  var index = void 0;
	
		  if (t.isNumericLiteral(path.parent.property)) {
		    index = t.numericLiteral(path.parent.property.value + offset);
		  } else if (offset === 0) {
		    index = path.parent.property;
		  } else {
		    index = t.binaryExpression("+", path.parent.property, t.numericLiteral(offset));
		  }
	
		  var scope = path.scope;
	
		  if (!scope.isPure(index)) {
		    var temp = scope.generateUidIdentifierBasedOnNode(index);
		    scope.push({ id: temp, kind: "var" });
		    path.parentPath.replaceWith(restIndexImpure({
		      ARGUMENTS: argsId,
		      INDEX: index,
		      REF: temp
		    }));
		  } else {
		    path.parentPath.replaceWith(restIndex({
		      ARGUMENTS: argsId,
		      INDEX: index
		    }));
		  }
		}
	
		function optimiseLengthGetter(path, argsId, offset) {
		  if (offset) {
		    path.parentPath.replaceWith(restLength({
		      ARGUMENTS: argsId,
		      OFFSET: t.numericLiteral(offset)
		    }));
		  } else {
		    path.replaceWith(argsId);
		  }
		}
	
		var visitor = exports.visitor = {
		  Function: function Function(path) {
		    var node = path.node,
		        scope = path.scope;
	
		    if (!hasRest(node)) return;
	
		    var rest = node.params.pop().argument;
	
		    var argsId = t.identifier("arguments");
	
		    argsId._shadowedFunctionLiteral = path;
	
		    var state = {
		      references: [],
		      offset: node.params.length,
	
		      argumentsNode: argsId,
		      outerBinding: scope.getBindingIdentifier(rest.name),
	
		      candidates: [],
	
		      name: rest.name,
	
		      deopted: false
		    };
	
		    path.traverse(memberExpressionOptimisationVisitor, state);
	
		    if (!state.deopted && !state.references.length) {
		      for (var _iterator = state.candidates, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		        var _ref3;
	
		        if (_isArray) {
		          if (_i >= _iterator.length) break;
		          _ref3 = _iterator[_i++];
		        } else {
		          _i = _iterator.next();
		          if (_i.done) break;
		          _ref3 = _i.value;
		        }
	
		        var _ref4 = _ref3;
		        var _path = _ref4.path,
		            cause = _ref4.cause;
	
		        switch (cause) {
		          case "indexGetter":
		            optimiseIndexGetter(_path, argsId, state.offset);
		            break;
		          case "lengthGetter":
		            optimiseLengthGetter(_path, argsId, state.offset);
		            break;
		          default:
		            _path.replaceWith(argsId);
		        }
		      }
		      return;
		    }
	
		    state.references = state.references.concat(state.candidates.map(function (_ref5) {
		      var path = _ref5.path;
		      return path;
		    }));
	
		    state.deopted = state.deopted || !!node.shadow;
	
		    var start = t.numericLiteral(node.params.length);
		    var key = scope.generateUidIdentifier("key");
		    var len = scope.generateUidIdentifier("len");
	
		    var arrKey = key;
		    var arrLen = len;
		    if (node.params.length) {
		      arrKey = t.binaryExpression("-", key, start);
	
		      arrLen = t.conditionalExpression(t.binaryExpression(">", len, start), t.binaryExpression("-", len, start), t.numericLiteral(0));
		    }
	
		    var loop = buildRest({
		      ARGUMENTS: argsId,
		      ARRAY_KEY: arrKey,
		      ARRAY_LEN: arrLen,
		      START: start,
		      ARRAY: rest,
		      KEY: key,
		      LEN: len
		    });
	
		    if (state.deopted) {
		      loop._blockHoist = node.params.length + 1;
		      node.body.body.unshift(loop);
		    } else {
		      loop._blockHoist = 1;
	
		      var target = path.getEarliestCommonAncestorFrom(state.references).getStatementParent();
	
		      target.findParent(function (path) {
		        if (path.isLoop()) {
		          target = path;
		        } else {
		          return path.isFunction();
		        }
		      });
	
		      target.insertBefore(loop);
		    }
		  }
		};
	
	/***/ }),
	/* 336 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  return {
		    visitor: {
		      MemberExpression: {
		        exit: function exit(_ref2) {
		          var node = _ref2.node;
	
		          var prop = node.property;
		          if (!node.computed && t.isIdentifier(prop) && !t.isValidIdentifier(prop.name)) {
		            node.property = t.stringLiteral(prop.name);
		            node.computed = true;
		          }
		        }
		      }
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 337 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  return {
		    visitor: {
		      ObjectProperty: {
		        exit: function exit(_ref2) {
		          var node = _ref2.node;
	
		          var key = node.key;
		          if (!node.computed && t.isIdentifier(key) && !t.isValidIdentifier(key.name)) {
		            node.key = t.stringLiteral(key.name);
		          }
		        }
		      }
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 338 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  return {
		    visitor: {
		      ObjectExpression: function ObjectExpression(path, file) {
		        var node = path.node;
	
		        var hasAny = false;
		        for (var _iterator = node.properties, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		          var _ref2;
	
		          if (_isArray) {
		            if (_i >= _iterator.length) break;
		            _ref2 = _iterator[_i++];
		          } else {
		            _i = _iterator.next();
		            if (_i.done) break;
		            _ref2 = _i.value;
		          }
	
		          var prop = _ref2;
	
		          if (prop.kind === "get" || prop.kind === "set") {
		            hasAny = true;
		            break;
		          }
		        }
		        if (!hasAny) return;
	
		        var mutatorMap = {};
	
		        node.properties = node.properties.filter(function (prop) {
		          if (!prop.computed && (prop.kind === "get" || prop.kind === "set")) {
		            defineMap.push(mutatorMap, prop, null, file);
		            return false;
		          } else {
		            return true;
		          }
		        });
	
		        path.replaceWith(t.callExpression(t.memberExpression(t.identifier("Object"), t.identifier("defineProperties")), [node, defineMap.toDefineObject(mutatorMap)]));
		      }
		    }
		  };
		};
	
		var _babelHelperDefineMap = __webpack_require__(188);
	
		var defineMap = _interopRequireWildcard(_babelHelperDefineMap);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 339 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var parse = _ref.parse,
		      traverse = _ref.traverse;
	
		  return {
		    visitor: {
		      CallExpression: function CallExpression(path) {
		        if (path.get("callee").isIdentifier({ name: "eval" }) && path.node.arguments.length === 1) {
		          var evaluate = path.get("arguments")[0].evaluate();
		          if (!evaluate.confident) return;
	
		          var code = evaluate.value;
		          if (typeof code !== "string") return;
	
		          var ast = parse(code);
		          traverse.removeProperties(ast);
		          return ast.program;
		        }
		      }
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 340 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  function wrapInFlowComment(path, parent) {
		    path.addComment("trailing", generateComment(path, parent));
		    path.replaceWith(t.noop());
		  }
	
		  function generateComment(path, parent) {
		    var comment = path.getSource().replace(/\*-\//g, "*-ESCAPED/").replace(/\*\//g, "*-/");
		    if (parent && parent.optional) comment = "?" + comment;
		    if (comment[0] !== ":") comment = ":: " + comment;
		    return comment;
		  }
	
		  return {
		    inherits: __webpack_require__(126),
	
		    visitor: {
		      TypeCastExpression: function TypeCastExpression(path) {
		        var node = path.node;
	
		        path.get("expression").addComment("trailing", generateComment(path.get("typeAnnotation")));
		        path.replaceWith(t.parenthesizedExpression(node.expression));
		      },
		      Identifier: function Identifier(path) {
		        var node = path.node;
	
		        if (!node.optional || node.typeAnnotation) {
		          return;
		        }
		        path.addComment("trailing", ":: ?");
		      },
	
		      AssignmentPattern: {
		        exit: function exit(_ref2) {
		          var node = _ref2.node;
	
		          node.left.optional = false;
		        }
		      },
	
		      Function: {
		        exit: function exit(_ref3) {
		          var node = _ref3.node;
	
		          node.params.forEach(function (param) {
		            return param.optional = false;
		          });
		        }
		      },
	
		      ClassProperty: function ClassProperty(path) {
		        var node = path.node,
		            parent = path.parent;
	
		        if (!node.value) wrapInFlowComment(path, parent);
		      },
		      "ExportNamedDeclaration|Flow": function ExportNamedDeclarationFlow(path) {
		        var node = path.node,
		            parent = path.parent;
	
		        if (t.isExportNamedDeclaration(node) && !t.isFlow(node.declaration)) {
		          return;
		        }
		        wrapInFlowComment(path, parent);
		      },
		      ImportDeclaration: function ImportDeclaration(path) {
		        var node = path.node,
		            parent = path.parent;
	
		        if (t.isImportDeclaration(node) && node.importKind !== "type" && node.importKind !== "typeof") {
		          return;
		        }
		        wrapInFlowComment(path, parent);
		      }
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 341 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  return {
		    visitor: {
		      FunctionExpression: {
		        exit: function exit(path) {
		          var node = path.node;
	
		          if (!node.id) return;
		          node._ignoreUserWhitespace = true;
	
		          path.replaceWith(t.callExpression(t.functionExpression(null, [], t.blockStatement([t.toStatement(node), t.returnStatement(node.id)])), []));
		        }
		      }
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 342 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    visitor: {
		      CallExpression: function CallExpression(path, file) {
		        if (path.get("callee").matchesPattern("Object.assign")) {
		          path.node.callee = file.addHelper("extends");
		        }
		      }
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 343 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return {
		    visitor: {
		      CallExpression: function CallExpression(path, file) {
		        if (path.get("callee").matchesPattern("Object.setPrototypeOf")) {
		          path.node.callee = file.addHelper("defaults");
		        }
		      }
		    }
		  };
		};
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 344 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  function isProtoKey(node) {
		    return t.isLiteral(t.toComputedKey(node, node.key), { value: "__proto__" });
		  }
	
		  function isProtoAssignmentExpression(node) {
		    var left = node.left;
		    return t.isMemberExpression(left) && t.isLiteral(t.toComputedKey(left, left.property), { value: "__proto__" });
		  }
	
		  function buildDefaultsCallExpression(expr, ref, file) {
		    return t.expressionStatement(t.callExpression(file.addHelper("defaults"), [ref, expr.right]));
		  }
	
		  return {
		    visitor: {
		      AssignmentExpression: function AssignmentExpression(path, file) {
		        if (!isProtoAssignmentExpression(path.node)) return;
	
		        var nodes = [];
		        var left = path.node.left.object;
		        var temp = path.scope.maybeGenerateMemoised(left);
	
		        if (temp) nodes.push(t.expressionStatement(t.assignmentExpression("=", temp, left)));
		        nodes.push(buildDefaultsCallExpression(path.node, temp || left, file));
		        if (temp) nodes.push(temp);
	
		        path.replaceWithMultiple(nodes);
		      },
		      ExpressionStatement: function ExpressionStatement(path, file) {
		        var expr = path.node.expression;
		        if (!t.isAssignmentExpression(expr, { operator: "=" })) return;
	
		        if (isProtoAssignmentExpression(expr)) {
		          path.replaceWith(buildDefaultsCallExpression(expr, expr.left.object, file));
		        }
		      },
		      ObjectExpression: function ObjectExpression(path, file) {
		        var proto = void 0;
		        var node = path.node;
	
		        for (var _iterator = node.properties, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		          var _ref2;
	
		          if (_isArray) {
		            if (_i >= _iterator.length) break;
		            _ref2 = _iterator[_i++];
		          } else {
		            _i = _iterator.next();
		            if (_i.done) break;
		            _ref2 = _i.value;
		          }
	
		          var prop = _ref2;
	
		          if (isProtoKey(prop)) {
		            proto = prop.value;
		            (0, _pull2.default)(node.properties, prop);
		          }
		        }
	
		        if (proto) {
		          var args = [t.objectExpression([]), proto];
		          if (node.properties.length) args.push(node);
		          path.replaceWith(t.callExpression(file.addHelper("extends"), args));
		        }
		      }
		    }
		  };
		};
	
		var _pull = __webpack_require__(277);
	
		var _pull2 = _interopRequireDefault(_pull);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 345 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _typeof2 = __webpack_require__(11);
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  var immutabilityVisitor = {
		    enter: function enter(path, state) {
		      var stop = function stop() {
		        state.isImmutable = false;
		        path.stop();
		      };
	
		      if (path.isJSXClosingElement()) {
		        path.skip();
		        return;
		      }
	
		      if (path.isJSXIdentifier({ name: "ref" }) && path.parentPath.isJSXAttribute({ name: path.node })) {
		        return stop();
		      }
	
		      if (path.isJSXIdentifier() || path.isIdentifier() || path.isJSXMemberExpression()) {
		        return;
		      }
	
		      if (!path.isImmutable()) {
		        if (path.isPure()) {
		          var expressionResult = path.evaluate();
		          if (expressionResult.confident) {
		            var value = expressionResult.value;
	
		            var isMutable = value && (typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value)) === "object" || typeof value === "function";
		            if (!isMutable) {
		              return;
		            }
		          } else if (t.isIdentifier(expressionResult.deopt)) {
		            return;
		          }
		        }
		        stop();
		      }
		    }
		  };
	
		  return {
		    visitor: {
		      JSXElement: function JSXElement(path) {
		        if (path.node._hoisted) return;
	
		        var state = { isImmutable: true };
		        path.traverse(immutabilityVisitor, state);
	
		        if (state.isImmutable) {
		          path.hoist();
		        } else {
		          path.node._hoisted = true;
		        }
		      }
		    }
		  };
		};
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 346 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  function hasRefOrSpread(attrs) {
		    for (var i = 0; i < attrs.length; i++) {
		      var attr = attrs[i];
		      if (t.isJSXSpreadAttribute(attr)) return true;
		      if (isJSXAttributeOfName(attr, "ref")) return true;
		    }
		    return false;
		  }
	
		  function isJSXAttributeOfName(attr, name) {
		    return t.isJSXAttribute(attr) && t.isJSXIdentifier(attr.name, { name: name });
		  }
	
		  function getAttributeValue(attr) {
		    var value = attr.value;
		    if (!value) return t.identifier("true");
		    if (t.isJSXExpressionContainer(value)) value = value.expression;
		    return value;
		  }
	
		  return {
		    visitor: {
		      JSXElement: function JSXElement(path, file) {
		        var node = path.node;
	
		        var open = node.openingElement;
		        if (hasRefOrSpread(open.attributes)) return;
	
		        var props = t.objectExpression([]);
		        var key = null;
		        var type = open.name;
	
		        if (t.isJSXIdentifier(type) && t.react.isCompatTag(type.name)) {
		          type = t.stringLiteral(type.name);
		        }
	
		        function pushProp(objProps, key, value) {
		          objProps.push(t.objectProperty(key, value));
		        }
	
		        for (var _iterator = open.attributes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		          var _ref2;
	
		          if (_isArray) {
		            if (_i >= _iterator.length) break;
		            _ref2 = _iterator[_i++];
		          } else {
		            _i = _iterator.next();
		            if (_i.done) break;
		            _ref2 = _i.value;
		          }
	
		          var attr = _ref2;
	
		          if (isJSXAttributeOfName(attr, "key")) {
		            key = getAttributeValue(attr);
		          } else {
		            var name = attr.name.name;
		            var propertyKey = t.isValidIdentifier(name) ? t.identifier(name) : t.stringLiteral(name);
		            pushProp(props.properties, propertyKey, getAttributeValue(attr));
		          }
		        }
	
		        var args = [type, props];
		        if (key || node.children.length) {
		          var children = t.react.buildChildren(node);
		          args.push.apply(args, [key || t.unaryExpression("void", t.numericLiteral(0), true)].concat(children));
		        }
	
		        var el = t.callExpression(file.addHelper("jsx"), args);
		        path.replaceWith(el);
		      }
		    }
		  };
		};
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 347 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  return {
		    manipulateOptions: function manipulateOptions(opts, parserOpts) {
		      parserOpts.plugins.push("jsx");
		    },
	
		    visitor: (0, _babelHelperBuilderReactJsx2.default)({
		      pre: function pre(state) {
		        state.callee = state.tagExpr;
		      },
		      post: function post(state) {
		        if (t.react.isCompatTag(state.tagName)) {
		          state.call = t.callExpression(t.memberExpression(t.memberExpression(t.identifier("React"), t.identifier("DOM")), state.tagExpr, t.isLiteral(state.tagExpr)), state.args);
		        }
		      }
		    })
		  };
		};
	
		var _babelHelperBuilderReactJsx = __webpack_require__(348);
	
		var _babelHelperBuilderReactJsx2 = _interopRequireDefault(_babelHelperBuilderReactJsx);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 348 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (opts) {
		  var visitor = {};
	
		  visitor.JSXNamespacedName = function (path) {
		    throw path.buildCodeFrameError("Namespace tags are not supported. ReactJSX is not XML.");
		  };
	
		  visitor.JSXElement = {
		    exit: function exit(path, file) {
		      var callExpr = buildElementCall(path.get("openingElement"), file);
	
		      callExpr.arguments = callExpr.arguments.concat(path.node.children);
	
		      if (callExpr.arguments.length >= 3) {
		        callExpr._prettyCall = true;
		      }
	
		      path.replaceWith(t.inherits(callExpr, path.node));
		    }
		  };
	
		  return visitor;
	
		  function convertJSXIdentifier(node, parent) {
		    if (t.isJSXIdentifier(node)) {
		      if (node.name === "this" && t.isReferenced(node, parent)) {
		        return t.thisExpression();
		      } else if (_esutils2.default.keyword.isIdentifierNameES6(node.name)) {
		        node.type = "Identifier";
		      } else {
		        return t.stringLiteral(node.name);
		      }
		    } else if (t.isJSXMemberExpression(node)) {
		      return t.memberExpression(convertJSXIdentifier(node.object, node), convertJSXIdentifier(node.property, node));
		    }
	
		    return node;
		  }
	
		  function convertAttributeValue(node) {
		    if (t.isJSXExpressionContainer(node)) {
		      return node.expression;
		    } else {
		      return node;
		    }
		  }
	
		  function convertAttribute(node) {
		    var value = convertAttributeValue(node.value || t.booleanLiteral(true));
	
		    if (t.isStringLiteral(value) && !t.isJSXExpressionContainer(node.value)) {
		      value.value = value.value.replace(/\n\s+/g, " ");
		    }
	
		    if (t.isValidIdentifier(node.name.name)) {
		      node.name.type = "Identifier";
		    } else {
		      node.name = t.stringLiteral(node.name.name);
		    }
	
		    return t.inherits(t.objectProperty(node.name, value), node);
		  }
	
		  function buildElementCall(path, file) {
		    path.parent.children = t.react.buildChildren(path.parent);
	
		    var tagExpr = convertJSXIdentifier(path.node.name, path.node);
		    var args = [];
	
		    var tagName = void 0;
		    if (t.isIdentifier(tagExpr)) {
		      tagName = tagExpr.name;
		    } else if (t.isLiteral(tagExpr)) {
		      tagName = tagExpr.value;
		    }
	
		    var state = {
		      tagExpr: tagExpr,
		      tagName: tagName,
		      args: args
		    };
	
		    if (opts.pre) {
		      opts.pre(state, file);
		    }
	
		    var attribs = path.node.attributes;
		    if (attribs.length) {
		      attribs = buildOpeningElementAttributes(attribs, file);
		    } else {
		      attribs = t.nullLiteral();
		    }
	
		    args.push(attribs);
	
		    if (opts.post) {
		      opts.post(state, file);
		    }
	
		    return state.call || t.callExpression(state.callee, args);
		  }
	
		  function buildOpeningElementAttributes(attribs, file) {
		    var _props = [];
		    var objs = [];
	
		    var useBuiltIns = file.opts.useBuiltIns || false;
		    if (typeof useBuiltIns !== "boolean") {
		      throw new Error("transform-react-jsx currently only accepts a boolean option for " + "useBuiltIns (defaults to false)");
		    }
	
		    function pushProps() {
		      if (!_props.length) return;
	
		      objs.push(t.objectExpression(_props));
		      _props = [];
		    }
	
		    while (attribs.length) {
		      var prop = attribs.shift();
		      if (t.isJSXSpreadAttribute(prop)) {
		        pushProps();
		        objs.push(prop.argument);
		      } else {
		        _props.push(convertAttribute(prop));
		      }
		    }
	
		    pushProps();
	
		    if (objs.length === 1) {
		      attribs = objs[0];
		    } else {
		      if (!t.isObjectExpression(objs[0])) {
		        objs.unshift(t.objectExpression([]));
		      }
	
		      var helper = useBuiltIns ? t.memberExpression(t.identifier("Object"), t.identifier("assign")) : file.addHelper("extends");
	
		      attribs = t.callExpression(helper, objs);
		    }
	
		    return attribs;
		  }
		};
	
		var _esutils = __webpack_require__(97);
	
		var _esutils2 = _interopRequireDefault(_esutils);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 349 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  var visitor = {
		    JSXOpeningElement: function JSXOpeningElement(_ref2) {
		      var node = _ref2.node;
	
		      var id = t.jSXIdentifier(TRACE_ID);
		      var trace = t.thisExpression();
	
		      node.attributes.push(t.jSXAttribute(id, t.jSXExpressionContainer(trace)));
		    }
		  };
	
		  return {
		    visitor: visitor
		  };
		};
	
		var TRACE_ID = "__self";
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 350 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  function makeTrace(fileNameIdentifier, lineNumber) {
		    var fileLineLiteral = lineNumber != null ? t.numericLiteral(lineNumber) : t.nullLiteral();
		    var fileNameProperty = t.objectProperty(t.identifier("fileName"), fileNameIdentifier);
		    var lineNumberProperty = t.objectProperty(t.identifier("lineNumber"), fileLineLiteral);
		    return t.objectExpression([fileNameProperty, lineNumberProperty]);
		  }
	
		  var visitor = {
		    JSXOpeningElement: function JSXOpeningElement(path, state) {
		      var id = t.jSXIdentifier(TRACE_ID);
		      var location = path.container.openingElement.loc;
		      if (!location) {
		        return;
		      }
	
		      var attributes = path.container.openingElement.attributes;
		      for (var i = 0; i < attributes.length; i++) {
		        var name = attributes[i].name;
		        if (name && name.name === TRACE_ID) {
		          return;
		        }
		      }
	
		      if (!state.fileNameIdentifier) {
		        var fileName = state.file.log.filename !== "unknown" ? state.file.log.filename : null;
	
		        var fileNameIdentifier = path.scope.generateUidIdentifier(FILE_NAME_VAR);
		        path.hub.file.scope.push({ id: fileNameIdentifier, init: t.stringLiteral(fileName) });
		        state.fileNameIdentifier = fileNameIdentifier;
		      }
	
		      var trace = makeTrace(state.fileNameIdentifier, location.start.line);
		      attributes.push(t.jSXAttribute(id, t.jSXExpressionContainer(trace)));
		    }
		  };
	
		  return {
		    visitor: visitor
		  };
		};
	
		var TRACE_ID = "__source";
		var FILE_NAME_VAR = "_jsxFileName";
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 351 */
	348,
	/* 352 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		module.exports = {
		  builtins: {
		    Symbol: "symbol",
		    Promise: "promise",
		    Map: "map",
		    WeakMap: "weak-map",
		    Set: "set",
		    WeakSet: "weak-set",
		    Observable: "observable",
		    setImmediate: "set-immediate",
		    clearImmediate: "clear-immediate",
		    asap: "asap"
		  },
	
		  methods: {
		    Array: {
		      concat: "array/concat",
		      copyWithin: "array/copy-within",
		      entries: "array/entries",
		      every: "array/every",
		      fill: "array/fill",
		      filter: "array/filter",
		      findIndex: "array/find-index",
		      find: "array/find",
		      forEach: "array/for-each",
		      from: "array/from",
		      includes: "array/includes",
		      indexOf: "array/index-of",
	
		      join: "array/join",
		      keys: "array/keys",
		      lastIndexOf: "array/last-index-of",
		      map: "array/map",
		      of: "array/of",
		      pop: "array/pop",
		      push: "array/push",
		      reduceRight: "array/reduce-right",
		      reduce: "array/reduce",
		      reverse: "array/reverse",
		      shift: "array/shift",
		      slice: "array/slice",
		      some: "array/some",
		      sort: "array/sort",
		      splice: "array/splice",
		      unshift: "array/unshift",
		      values: "array/values"
		    },
	
		    JSON: {
		      stringify: "json/stringify"
		    },
	
		    Object: {
		      assign: "object/assign",
		      create: "object/create",
		      defineProperties: "object/define-properties",
		      defineProperty: "object/define-property",
		      entries: "object/entries",
		      freeze: "object/freeze",
		      getOwnPropertyDescriptor: "object/get-own-property-descriptor",
		      getOwnPropertyDescriptors: "object/get-own-property-descriptors",
		      getOwnPropertyNames: "object/get-own-property-names",
		      getOwnPropertySymbols: "object/get-own-property-symbols",
		      getPrototypeOf: "object/get-prototype-of",
		      isExtensible: "object/is-extensible",
		      isFrozen: "object/is-frozen",
		      isSealed: "object/is-sealed",
		      is: "object/is",
		      keys: "object/keys",
		      preventExtensions: "object/prevent-extensions",
		      seal: "object/seal",
		      setPrototypeOf: "object/set-prototype-of",
		      values: "object/values"
		    },
	
		    RegExp: {
		      escape: "regexp/escape" },
	
		    Math: {
		      acosh: "math/acosh",
		      asinh: "math/asinh",
		      atanh: "math/atanh",
		      cbrt: "math/cbrt",
		      clz32: "math/clz32",
		      cosh: "math/cosh",
		      expm1: "math/expm1",
		      fround: "math/fround",
		      hypot: "math/hypot",
		      imul: "math/imul",
		      log10: "math/log10",
		      log1p: "math/log1p",
		      log2: "math/log2",
		      sign: "math/sign",
		      sinh: "math/sinh",
		      tanh: "math/tanh",
		      trunc: "math/trunc",
		      iaddh: "math/iaddh",
		      isubh: "math/isubh",
		      imulh: "math/imulh",
		      umulh: "math/umulh"
		    },
	
		    Symbol: {
		      for: "symbol/for",
		      hasInstance: "symbol/has-instance",
		      isConcatSpreadable: "symbol/is-concat-spreadable",
		      iterator: "symbol/iterator",
		      keyFor: "symbol/key-for",
		      match: "symbol/match",
		      replace: "symbol/replace",
		      search: "symbol/search",
		      species: "symbol/species",
		      split: "symbol/split",
		      toPrimitive: "symbol/to-primitive",
		      toStringTag: "symbol/to-string-tag",
		      unscopables: "symbol/unscopables"
		    },
	
		    String: {
		      at: "string/at",
		      codePointAt: "string/code-point-at",
		      endsWith: "string/ends-with",
		      fromCodePoint: "string/from-code-point",
		      includes: "string/includes",
		      matchAll: "string/match-all",
		      padLeft: "string/pad-left",
		      padRight: "string/pad-right",
		      padStart: "string/pad-start",
		      padEnd: "string/pad-end",
		      raw: "string/raw",
		      repeat: "string/repeat",
		      startsWith: "string/starts-with",
		      trim: "string/trim",
		      trimLeft: "string/trim-left",
		      trimRight: "string/trim-right",
		      trimStart: "string/trim-start",
		      trimEnd: "string/trim-end"
		    },
	
		    Number: {
		      EPSILON: "number/epsilon",
		      isFinite: "number/is-finite",
		      isInteger: "number/is-integer",
		      isNaN: "number/is-nan",
		      isSafeInteger: "number/is-safe-integer",
		      MAX_SAFE_INTEGER: "number/max-safe-integer",
		      MIN_SAFE_INTEGER: "number/min-safe-integer",
		      parseFloat: "number/parse-float",
		      parseInt: "number/parse-int"
		    },
	
		    Reflect: {
		      apply: "reflect/apply",
		      construct: "reflect/construct",
		      defineProperty: "reflect/define-property",
		      deleteProperty: "reflect/delete-property",
		      enumerate: "reflect/enumerate",
		      getOwnPropertyDescriptor: "reflect/get-own-property-descriptor",
		      getPrototypeOf: "reflect/get-prototype-of",
		      get: "reflect/get",
		      has: "reflect/has",
		      isExtensible: "reflect/is-extensible",
		      ownKeys: "reflect/own-keys",
		      preventExtensions: "reflect/prevent-extensions",
		      setPrototypeOf: "reflect/set-prototype-of",
		      set: "reflect/set",
		      defineMetadata: "reflect/define-metadata",
		      deleteMetadata: "reflect/delete-metadata",
		      getMetadata: "reflect/get-metadata",
		      getMetadataKeys: "reflect/get-metadata-keys",
		      getOwnMetadata: "reflect/get-own-metadata",
		      getOwnMetadataKeys: "reflect/get-own-metadata-keys",
		      hasMetadata: "reflect/has-metadata",
		      hasOwnMetadata: "reflect/has-own-metadata",
		      metadata: "reflect/metadata"
		    },
	
		    System: {
		      global: "system/global"
		    },
	
		    Error: {
		      isError: "error/is-error" },
	
		    Date: {},
	
		    Function: {}
		  }
		};
	
	/***/ }),
	/* 353 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.definitions = undefined;
	
		exports.default = function (_ref) {
		  var t = _ref.types;
	
		  function getRuntimeModuleName(opts) {
		    return opts.moduleName || "babel-runtime";
		  }
	
		  function has(obj, key) {
		    return Object.prototype.hasOwnProperty.call(obj, key);
		  }
	
		  var HELPER_BLACKLIST = ["interopRequireWildcard", "interopRequireDefault"];
	
		  return {
		    pre: function pre(file) {
		      var moduleName = getRuntimeModuleName(this.opts);
	
		      if (this.opts.helpers !== false) {
		        file.set("helperGenerator", function (name) {
		          if (HELPER_BLACKLIST.indexOf(name) < 0) {
		            return file.addImport(moduleName + "/helpers/" + name, "default", name);
		          }
		        });
		      }
	
		      this.setDynamic("regeneratorIdentifier", function () {
		        return file.addImport(moduleName + "/regenerator", "default", "regeneratorRuntime");
		      });
		    },
	
		    visitor: {
		      ReferencedIdentifier: function ReferencedIdentifier(path, state) {
		        var node = path.node,
		            parent = path.parent,
		            scope = path.scope;
	
		        if (node.name === "regeneratorRuntime" && state.opts.regenerator !== false) {
		          path.replaceWith(state.get("regeneratorIdentifier"));
		          return;
		        }
	
		        if (state.opts.polyfill === false) return;
	
		        if (t.isMemberExpression(parent)) return;
		        if (!has(_definitions2.default.builtins, node.name)) return;
		        if (scope.getBindingIdentifier(node.name)) return;
	
		        var moduleName = getRuntimeModuleName(state.opts);
		        path.replaceWith(state.addImport(moduleName + "/core-js/" + _definitions2.default.builtins[node.name], "default", node.name));
		      },
		      CallExpression: function CallExpression(path, state) {
		        if (state.opts.polyfill === false) return;
	
		        if (path.node.arguments.length) return;
	
		        var callee = path.node.callee;
		        if (!t.isMemberExpression(callee)) return;
		        if (!callee.computed) return;
		        if (!path.get("callee.property").matchesPattern("Symbol.iterator")) return;
	
		        var moduleName = getRuntimeModuleName(state.opts);
		        path.replaceWith(t.callExpression(state.addImport(moduleName + "/core-js/get-iterator", "default", "getIterator"), [callee.object]));
		      },
		      BinaryExpression: function BinaryExpression(path, state) {
		        if (state.opts.polyfill === false) return;
	
		        if (path.node.operator !== "in") return;
		        if (!path.get("left").matchesPattern("Symbol.iterator")) return;
	
		        var moduleName = getRuntimeModuleName(state.opts);
		        path.replaceWith(t.callExpression(state.addImport(moduleName + "/core-js/is-iterable", "default", "isIterable"), [path.node.right]));
		      },
	
		      MemberExpression: {
		        enter: function enter(path, state) {
		          if (state.opts.polyfill === false) return;
		          if (!path.isReferenced()) return;
	
		          var node = path.node;
	
		          var obj = node.object;
		          var prop = node.property;
	
		          if (!t.isReferenced(obj, node)) return;
		          if (node.computed) return;
		          if (!has(_definitions2.default.methods, obj.name)) return;
	
		          var methods = _definitions2.default.methods[obj.name];
		          if (!has(methods, prop.name)) return;
	
		          if (path.scope.getBindingIdentifier(obj.name)) return;
	
		          if (obj.name === "Object" && prop.name === "defineProperty" && path.parentPath.isCallExpression()) {
		            var call = path.parentPath.node;
		            if (call.arguments.length === 3 && t.isLiteral(call.arguments[1])) return;
		          }
	
		          var moduleName = getRuntimeModuleName(state.opts);
		          path.replaceWith(state.addImport(moduleName + "/core-js/" + methods[prop.name], "default", obj.name + "$" + prop.name));
		        },
		        exit: function exit(path, state) {
		          if (state.opts.polyfill === false) return;
		          if (!path.isReferenced()) return;
	
		          var node = path.node;
	
		          var obj = node.object;
	
		          if (!has(_definitions2.default.builtins, obj.name)) return;
		          if (path.scope.getBindingIdentifier(obj.name)) return;
	
		          var moduleName = getRuntimeModuleName(state.opts);
		          path.replaceWith(t.memberExpression(state.addImport(moduleName + "/core-js/" + _definitions2.default.builtins[obj.name], "default", obj.name), node.property, node.computed));
		        }
		      }
		    }
		  };
		};
	
		var _definitions = __webpack_require__(352);
	
		var _definitions2 = _interopRequireDefault(_definitions);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		exports.definitions = _definitions2.default;
	
	/***/ }),
	/* 354 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (_ref) {
		  var messages = _ref.messages;
	
		  return {
		    visitor: {
		      ReferencedIdentifier: function ReferencedIdentifier(path) {
		        var node = path.node,
		            scope = path.scope;
	
		        var binding = scope.getBinding(node.name);
		        if (binding && binding.kind === "type" && !path.parentPath.isFlow()) {
		          throw path.buildCodeFrameError(messages.get("undeclaredVariableType", node.name), ReferenceError);
		        }
	
		        if (scope.hasBinding(node.name)) return;
	
		        var bindings = scope.getAllBindings();
	
		        var closest = void 0;
		        var shortest = -1;
	
		        for (var name in bindings) {
		          var distance = (0, _leven2.default)(node.name, name);
		          if (distance <= 0 || distance > 3) continue;
		          if (distance <= shortest) continue;
	
		          closest = name;
		          shortest = distance;
		        }
	
		        var msg = void 0;
		        if (closest) {
		          msg = messages.get("undeclaredVariableSuggestion", node.name, closest);
		        } else {
		          msg = messages.get("undeclaredVariable", node.name);
		        }
	
		        throw path.buildCodeFrameError(msg, ReferenceError);
		      }
		    }
		  };
		};
	
		var _leven = __webpack_require__(471);
	
		var _leven2 = _interopRequireDefault(_leven);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 355 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _babelPluginTransformFlowStripTypes = __webpack_require__(211);
	
		var _babelPluginTransformFlowStripTypes2 = _interopRequireDefault(_babelPluginTransformFlowStripTypes);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		exports.default = {
		  plugins: [_babelPluginTransformFlowStripTypes2.default]
		};
		module.exports = exports["default"];
	
	/***/ }),
	/* 356 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (context) {
		  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		  return {
		    presets: [opts.es2015 !== false && [_babelPresetEs2.default.buildPreset, opts.es2015], opts.es2016 !== false && _babelPresetEs4.default, opts.es2017 !== false && _babelPresetEs6.default].filter(Boolean) };
		};
	
		var _babelPresetEs = __webpack_require__(217);
	
		var _babelPresetEs2 = _interopRequireDefault(_babelPresetEs);
	
		var _babelPresetEs3 = __webpack_require__(218);
	
		var _babelPresetEs4 = _interopRequireDefault(_babelPresetEs3);
	
		var _babelPresetEs5 = __webpack_require__(219);
	
		var _babelPresetEs6 = _interopRequireDefault(_babelPresetEs5);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		module.exports = exports["default"];
	
	/***/ }),
	/* 357 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _babelPresetFlow = __webpack_require__(355);
	
		var _babelPresetFlow2 = _interopRequireDefault(_babelPresetFlow);
	
		var _babelPluginTransformReactJsx = __webpack_require__(215);
	
		var _babelPluginTransformReactJsx2 = _interopRequireDefault(_babelPluginTransformReactJsx);
	
		var _babelPluginSyntaxJsx = __webpack_require__(127);
	
		var _babelPluginSyntaxJsx2 = _interopRequireDefault(_babelPluginSyntaxJsx);
	
		var _babelPluginTransformReactDisplayName = __webpack_require__(214);
	
		var _babelPluginTransformReactDisplayName2 = _interopRequireDefault(_babelPluginTransformReactDisplayName);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		exports.default = {
		  presets: [_babelPresetFlow2.default],
		  plugins: [_babelPluginTransformReactJsx2.default, _babelPluginSyntaxJsx2.default, _babelPluginTransformReactDisplayName2.default],
		  env: {
		    development: {
		      plugins: []
		    }
		  }
		};
		module.exports = exports["default"];
	
	/***/ }),
	/* 358 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _babelPresetStage = __webpack_require__(220);
	
		var _babelPresetStage2 = _interopRequireDefault(_babelPresetStage);
	
		var _babelPluginTransformDoExpressions = __webpack_require__(206);
	
		var _babelPluginTransformDoExpressions2 = _interopRequireDefault(_babelPluginTransformDoExpressions);
	
		var _babelPluginTransformFunctionBind = __webpack_require__(212);
	
		var _babelPluginTransformFunctionBind2 = _interopRequireDefault(_babelPluginTransformFunctionBind);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		exports.default = {
		  presets: [_babelPresetStage2.default],
		  plugins: [_babelPluginTransformDoExpressions2.default, _babelPluginTransformFunctionBind2.default]
		};
		module.exports = exports["default"];
	
	/***/ }),
	/* 359 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		module.exports = { "default": __webpack_require__(407), __esModule: true };
	
	/***/ }),
	/* 360 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		module.exports = { "default": __webpack_require__(410), __esModule: true };
	
	/***/ }),
	/* 361 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		module.exports = { "default": __webpack_require__(412), __esModule: true };
	
	/***/ }),
	/* 362 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		module.exports = { "default": __webpack_require__(413), __esModule: true };
	
	/***/ }),
	/* 363 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		module.exports = { "default": __webpack_require__(415), __esModule: true };
	
	/***/ }),
	/* 364 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		module.exports = { "default": __webpack_require__(416), __esModule: true };
	
	/***/ }),
	/* 365 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		module.exports = { "default": __webpack_require__(417), __esModule: true };
	
	/***/ }),
	/* 366 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (obj, keys) {
		  var target = {};
	
		  for (var i in obj) {
		    if (keys.indexOf(i) >= 0) continue;
		    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
		    target[i] = obj[i];
		  }
	
		  return target;
		};
	
	/***/ }),
	/* 367 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _path2 = __webpack_require__(36);
	
		var _path3 = _interopRequireDefault(_path2);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var testing = ("production") === "test";
	
		var TraversalContext = function () {
		  function TraversalContext(scope, opts, state, parentPath) {
		    (0, _classCallCheck3.default)(this, TraversalContext);
		    this.queue = null;
	
		    this.parentPath = parentPath;
		    this.scope = scope;
		    this.state = state;
		    this.opts = opts;
		  }
	
		  TraversalContext.prototype.shouldVisit = function shouldVisit(node) {
		    var opts = this.opts;
		    if (opts.enter || opts.exit) return true;
	
		    if (opts[node.type]) return true;
	
		    var keys = t.VISITOR_KEYS[node.type];
		    if (!keys || !keys.length) return false;
	
		    for (var _iterator = keys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var key = _ref;
	
		      if (node[key]) return true;
		    }
	
		    return false;
		  };
	
		  TraversalContext.prototype.create = function create(node, obj, key, listKey) {
		    return _path3.default.get({
		      parentPath: this.parentPath,
		      parent: node,
		      container: obj,
		      key: key,
		      listKey: listKey
		    });
		  };
	
		  TraversalContext.prototype.maybeQueue = function maybeQueue(path, notPriority) {
		    if (this.trap) {
		      throw new Error("Infinite cycle detected");
		    }
	
		    if (this.queue) {
		      if (notPriority) {
		        this.queue.push(path);
		      } else {
		        this.priorityQueue.push(path);
		      }
		    }
		  };
	
		  TraversalContext.prototype.visitMultiple = function visitMultiple(container, parent, listKey) {
		    if (container.length === 0) return false;
	
		    var queue = [];
	
		    for (var key = 0; key < container.length; key++) {
		      var node = container[key];
		      if (node && this.shouldVisit(node)) {
		        queue.push(this.create(parent, container, key, listKey));
		      }
		    }
	
		    return this.visitQueue(queue);
		  };
	
		  TraversalContext.prototype.visitSingle = function visitSingle(node, key) {
		    if (this.shouldVisit(node[key])) {
		      return this.visitQueue([this.create(node, node, key)]);
		    } else {
		      return false;
		    }
		  };
	
		  TraversalContext.prototype.visitQueue = function visitQueue(queue) {
		    this.queue = queue;
		    this.priorityQueue = [];
	
		    var visited = [];
		    var stop = false;
	
		    for (var _iterator2 = queue, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		      var _ref2;
	
		      if (_isArray2) {
		        if (_i2 >= _iterator2.length) break;
		        _ref2 = _iterator2[_i2++];
		      } else {
		        _i2 = _iterator2.next();
		        if (_i2.done) break;
		        _ref2 = _i2.value;
		      }
	
		      var path = _ref2;
	
		      path.resync();
	
		      if (path.contexts.length === 0 || path.contexts[path.contexts.length - 1] !== this) {
		        path.pushContext(this);
		      }
	
		      if (path.key === null) continue;
	
		      if (testing && queue.length >= 10000) {
		        this.trap = true;
		      }
	
		      if (visited.indexOf(path.node) >= 0) continue;
		      visited.push(path.node);
	
		      if (path.visit()) {
		        stop = true;
		        break;
		      }
	
		      if (this.priorityQueue.length) {
		        stop = this.visitQueue(this.priorityQueue);
		        this.priorityQueue = [];
		        this.queue = queue;
		        if (stop) break;
		      }
		    }
	
		    for (var _iterator3 = queue, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		      var _ref3;
	
		      if (_isArray3) {
		        if (_i3 >= _iterator3.length) break;
		        _ref3 = _iterator3[_i3++];
		      } else {
		        _i3 = _iterator3.next();
		        if (_i3.done) break;
		        _ref3 = _i3.value;
		      }
	
		      var _path = _ref3;
	
		      _path.popContext();
		    }
	
		    this.queue = null;
	
		    return stop;
		  };
	
		  TraversalContext.prototype.visit = function visit(node, key) {
		    var nodes = node[key];
		    if (!nodes) return false;
	
		    if (Array.isArray(nodes)) {
		      return this.visitMultiple(nodes, node, key);
		    } else {
		      return this.visitSingle(node, key);
		    }
		  };
	
		  return TraversalContext;
		}();
	
		exports.default = TraversalContext;
		module.exports = exports["default"];
	
	/***/ }),
	/* 368 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.findParent = findParent;
		exports.find = find;
		exports.getFunctionParent = getFunctionParent;
		exports.getStatementParent = getStatementParent;
		exports.getEarliestCommonAncestorFrom = getEarliestCommonAncestorFrom;
		exports.getDeepestCommonAncestorFrom = getDeepestCommonAncestorFrom;
		exports.getAncestry = getAncestry;
		exports.isAncestor = isAncestor;
		exports.isDescendant = isDescendant;
		exports.inType = inType;
		exports.inShadow = inShadow;
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		var _index = __webpack_require__(36);
	
		var _index2 = _interopRequireDefault(_index);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function findParent(callback) {
		  var path = this;
		  while (path = path.parentPath) {
		    if (callback(path)) return path;
		  }
		  return null;
		}
	
		function find(callback) {
		  var path = this;
		  do {
		    if (callback(path)) return path;
		  } while (path = path.parentPath);
		  return null;
		}
	
		function getFunctionParent() {
		  return this.findParent(function (path) {
		    return path.isFunction() || path.isProgram();
		  });
		}
	
		function getStatementParent() {
		  var path = this;
		  do {
		    if (Array.isArray(path.container)) {
		      return path;
		    }
		  } while (path = path.parentPath);
		}
	
		function getEarliestCommonAncestorFrom(paths) {
		  return this.getDeepestCommonAncestorFrom(paths, function (deepest, i, ancestries) {
		    var earliest = void 0;
		    var keys = t.VISITOR_KEYS[deepest.type];
	
		    for (var _iterator = ancestries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var ancestry = _ref;
	
		      var path = ancestry[i + 1];
	
		      if (!earliest) {
		        earliest = path;
		        continue;
		      }
	
		      if (path.listKey && earliest.listKey === path.listKey) {
		        if (path.key < earliest.key) {
		          earliest = path;
		          continue;
		        }
		      }
	
		      var earliestKeyIndex = keys.indexOf(earliest.parentKey);
		      var currentKeyIndex = keys.indexOf(path.parentKey);
		      if (earliestKeyIndex > currentKeyIndex) {
		        earliest = path;
		      }
		    }
	
		    return earliest;
		  });
		}
	
		function getDeepestCommonAncestorFrom(paths, filter) {
		  var _this = this;
	
		  if (!paths.length) {
		    return this;
		  }
	
		  if (paths.length === 1) {
		    return paths[0];
		  }
	
		  var minDepth = Infinity;
	
		  var lastCommonIndex = void 0,
		      lastCommon = void 0;
	
		  var ancestries = paths.map(function (path) {
		    var ancestry = [];
	
		    do {
		      ancestry.unshift(path);
		    } while ((path = path.parentPath) && path !== _this);
	
		    if (ancestry.length < minDepth) {
		      minDepth = ancestry.length;
		    }
	
		    return ancestry;
		  });
	
		  var first = ancestries[0];
	
		  depthLoop: for (var i = 0; i < minDepth; i++) {
		    var shouldMatch = first[i];
	
		    for (var _iterator2 = ancestries, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		      var _ref2;
	
		      if (_isArray2) {
		        if (_i2 >= _iterator2.length) break;
		        _ref2 = _iterator2[_i2++];
		      } else {
		        _i2 = _iterator2.next();
		        if (_i2.done) break;
		        _ref2 = _i2.value;
		      }
	
		      var ancestry = _ref2;
	
		      if (ancestry[i] !== shouldMatch) {
		        break depthLoop;
		      }
		    }
	
		    lastCommonIndex = i;
		    lastCommon = shouldMatch;
		  }
	
		  if (lastCommon) {
		    if (filter) {
		      return filter(lastCommon, lastCommonIndex, ancestries);
		    } else {
		      return lastCommon;
		    }
		  } else {
		    throw new Error("Couldn't find intersection");
		  }
		}
	
		function getAncestry() {
		  var path = this;
		  var paths = [];
		  do {
		    paths.push(path);
		  } while (path = path.parentPath);
		  return paths;
		}
	
		function isAncestor(maybeDescendant) {
		  return maybeDescendant.isDescendant(this);
		}
	
		function isDescendant(maybeAncestor) {
		  return !!this.findParent(function (parent) {
		    return parent === maybeAncestor;
		  });
		}
	
		function inType() {
		  var path = this;
		  while (path) {
		    for (var _iterator3 = arguments, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		      var _ref3;
	
		      if (_isArray3) {
		        if (_i3 >= _iterator3.length) break;
		        _ref3 = _iterator3[_i3++];
		      } else {
		        _i3 = _iterator3.next();
		        if (_i3.done) break;
		        _ref3 = _i3.value;
		      }
	
		      var type = _ref3;
	
		      if (path.node.type === type) return true;
		    }
		    path = path.parentPath;
		  }
	
		  return false;
		}
	
		function inShadow(key) {
		  var parentFn = this.isFunction() ? this : this.findParent(function (p) {
		    return p.isFunction();
		  });
		  if (!parentFn) return;
	
		  if (parentFn.isFunctionExpression() || parentFn.isFunctionDeclaration()) {
		    var shadow = parentFn.node.shadow;
	
		    if (shadow && (!key || shadow[key] !== false)) {
		      return parentFn;
		    }
		  } else if (parentFn.isArrowFunctionExpression()) {
		    return parentFn;
		  }
	
		  return null;
		}
	
	/***/ }),
	/* 369 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.shareCommentsWithSiblings = shareCommentsWithSiblings;
		exports.addComment = addComment;
		exports.addComments = addComments;
		function shareCommentsWithSiblings() {
		  if (typeof this.key === "string") return;
	
		  var node = this.node;
		  if (!node) return;
	
		  var trailing = node.trailingComments;
		  var leading = node.leadingComments;
		  if (!trailing && !leading) return;
	
		  var prev = this.getSibling(this.key - 1);
		  var next = this.getSibling(this.key + 1);
	
		  if (!prev.node) prev = next;
		  if (!next.node) next = prev;
	
		  prev.addComments("trailing", leading);
		  next.addComments("leading", trailing);
		}
	
		function addComment(type, content, line) {
		  this.addComments(type, [{
		    type: line ? "CommentLine" : "CommentBlock",
		    value: content
		  }]);
		}
	
		function addComments(type, comments) {
		  if (!comments) return;
	
		  var node = this.node;
		  if (!node) return;
	
		  var key = type + "Comments";
	
		  if (node[key]) {
		    node[key] = node[key].concat(comments);
		  } else {
		    node[key] = comments;
		  }
		}
	
	/***/ }),
	/* 370 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.call = call;
		exports._call = _call;
		exports.isBlacklisted = isBlacklisted;
		exports.visit = visit;
		exports.skip = skip;
		exports.skipKey = skipKey;
		exports.stop = stop;
		exports.setScope = setScope;
		exports.setContext = setContext;
		exports.resync = resync;
		exports._resyncParent = _resyncParent;
		exports._resyncKey = _resyncKey;
		exports._resyncList = _resyncList;
		exports._resyncRemoved = _resyncRemoved;
		exports.popContext = popContext;
		exports.pushContext = pushContext;
		exports.setup = setup;
		exports.setKey = setKey;
		exports.requeue = requeue;
		exports._getQueueContexts = _getQueueContexts;
	
		var _index = __webpack_require__(7);
	
		var _index2 = _interopRequireDefault(_index);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function call(key) {
		  var opts = this.opts;
	
		  this.debug(function () {
		    return key;
		  });
	
		  if (this.node) {
		    if (this._call(opts[key])) return true;
		  }
	
		  if (this.node) {
		    return this._call(opts[this.node.type] && opts[this.node.type][key]);
		  }
	
		  return false;
		}
	
		function _call(fns) {
		  if (!fns) return false;
	
		  for (var _iterator = fns, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		    var _ref;
	
		    if (_isArray) {
		      if (_i >= _iterator.length) break;
		      _ref = _iterator[_i++];
		    } else {
		      _i = _iterator.next();
		      if (_i.done) break;
		      _ref = _i.value;
		    }
	
		    var fn = _ref;
	
		    if (!fn) continue;
	
		    var node = this.node;
		    if (!node) return true;
	
		    var ret = fn.call(this.state, this, this.state);
		    if (ret) throw new Error("Unexpected return value from visitor method " + fn);
	
		    if (this.node !== node) return true;
	
		    if (this.shouldStop || this.shouldSkip || this.removed) return true;
		  }
	
		  return false;
		}
	
		function isBlacklisted() {
		  var blacklist = this.opts.blacklist;
		  return blacklist && blacklist.indexOf(this.node.type) > -1;
		}
	
		function visit() {
		  if (!this.node) {
		    return false;
		  }
	
		  if (this.isBlacklisted()) {
		    return false;
		  }
	
		  if (this.opts.shouldSkip && this.opts.shouldSkip(this)) {
		    return false;
		  }
	
		  if (this.call("enter") || this.shouldSkip) {
		    this.debug(function () {
		      return "Skip...";
		    });
		    return this.shouldStop;
		  }
	
		  this.debug(function () {
		    return "Recursing into...";
		  });
		  _index2.default.node(this.node, this.opts, this.scope, this.state, this, this.skipKeys);
	
		  this.call("exit");
	
		  return this.shouldStop;
		}
	
		function skip() {
		  this.shouldSkip = true;
		}
	
		function skipKey(key) {
		  this.skipKeys[key] = true;
		}
	
		function stop() {
		  this.shouldStop = true;
		  this.shouldSkip = true;
		}
	
		function setScope() {
		  if (this.opts && this.opts.noScope) return;
	
		  var target = this.context && this.context.scope;
	
		  if (!target) {
		    var path = this.parentPath;
		    while (path && !target) {
		      if (path.opts && path.opts.noScope) return;
	
		      target = path.scope;
		      path = path.parentPath;
		    }
		  }
	
		  this.scope = this.getScope(target);
		  if (this.scope) this.scope.init();
		}
	
		function setContext(context) {
		  this.shouldSkip = false;
		  this.shouldStop = false;
		  this.removed = false;
		  this.skipKeys = {};
	
		  if (context) {
		    this.context = context;
		    this.state = context.state;
		    this.opts = context.opts;
		  }
	
		  this.setScope();
	
		  return this;
		}
	
		function resync() {
		  if (this.removed) return;
	
		  this._resyncParent();
		  this._resyncList();
		  this._resyncKey();
		}
	
		function _resyncParent() {
		  if (this.parentPath) {
		    this.parent = this.parentPath.node;
		  }
		}
	
		function _resyncKey() {
		  if (!this.container) return;
	
		  if (this.node === this.container[this.key]) return;
	
		  if (Array.isArray(this.container)) {
		    for (var i = 0; i < this.container.length; i++) {
		      if (this.container[i] === this.node) {
		        return this.setKey(i);
		      }
		    }
		  } else {
		    for (var key in this.container) {
		      if (this.container[key] === this.node) {
		        return this.setKey(key);
		      }
		    }
		  }
	
		  this.key = null;
		}
	
		function _resyncList() {
		  if (!this.parent || !this.inList) return;
	
		  var newContainer = this.parent[this.listKey];
		  if (this.container === newContainer) return;
	
		  this.container = newContainer || null;
		}
	
		function _resyncRemoved() {
		  if (this.key == null || !this.container || this.container[this.key] !== this.node) {
		    this._markRemoved();
		  }
		}
	
		function popContext() {
		  this.contexts.pop();
		  this.setContext(this.contexts[this.contexts.length - 1]);
		}
	
		function pushContext(context) {
		  this.contexts.push(context);
		  this.setContext(context);
		}
	
		function setup(parentPath, container, listKey, key) {
		  this.inList = !!listKey;
		  this.listKey = listKey;
		  this.parentKey = listKey || key;
		  this.container = container;
	
		  this.parentPath = parentPath || this.parentPath;
		  this.setKey(key);
		}
	
		function setKey(key) {
		  this.key = key;
		  this.node = this.container[this.key];
		  this.type = this.node && this.node.type;
		}
	
		function requeue() {
		  var pathToQueue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
	
		  if (pathToQueue.removed) return;
	
		  var contexts = this.contexts;
	
		  for (var _iterator2 = contexts, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		    var _ref2;
	
		    if (_isArray2) {
		      if (_i2 >= _iterator2.length) break;
		      _ref2 = _iterator2[_i2++];
		    } else {
		      _i2 = _iterator2.next();
		      if (_i2.done) break;
		      _ref2 = _i2.value;
		    }
	
		    var context = _ref2;
	
		    context.maybeQueue(pathToQueue);
		  }
		}
	
		function _getQueueContexts() {
		  var path = this;
		  var contexts = this.contexts;
		  while (!contexts.length) {
		    path = path.parentPath;
		    contexts = path.contexts;
		  }
		  return contexts;
		}
	
	/***/ }),
	/* 371 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.toComputedKey = toComputedKey;
		exports.ensureBlock = ensureBlock;
		exports.arrowFunctionToShadowed = arrowFunctionToShadowed;
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function toComputedKey() {
		  var node = this.node;
	
		  var key = void 0;
		  if (this.isMemberExpression()) {
		    key = node.property;
		  } else if (this.isProperty() || this.isMethod()) {
		    key = node.key;
		  } else {
		    throw new ReferenceError("todo");
		  }
	
		  if (!node.computed) {
		    if (t.isIdentifier(key)) key = t.stringLiteral(key.name);
		  }
	
		  return key;
		}
	
		function ensureBlock() {
		  return t.ensureBlock(this.node);
		}
	
		function arrowFunctionToShadowed() {
		  if (!this.isArrowFunctionExpression()) return;
	
		  this.ensureBlock();
	
		  var node = this.node;
	
		  node.expression = false;
		  node.type = "FunctionExpression";
		  node.shadow = node.shadow || true;
		}
	
	/***/ }),
	/* 372 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
		exports.__esModule = true;
	
		var _typeof2 = __webpack_require__(11);
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _map = __webpack_require__(133);
	
		var _map2 = _interopRequireDefault(_map);
	
		exports.evaluateTruthy = evaluateTruthy;
		exports.evaluate = evaluate;
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var VALID_CALLEES = ["String", "Number", "Math"];
		var INVALID_METHODS = ["random"];
	
		function evaluateTruthy() {
		  var res = this.evaluate();
		  if (res.confident) return !!res.value;
		}
	
		function evaluate() {
		  var confident = true;
		  var deoptPath = void 0;
		  var seen = new _map2.default();
	
		  function deopt(path) {
		    if (!confident) return;
		    deoptPath = path;
		    confident = false;
		  }
	
		  var value = evaluate(this);
		  if (!confident) value = undefined;
		  return {
		    confident: confident,
		    deopt: deoptPath,
		    value: value
		  };
	
		  function evaluate(path) {
		    var node = path.node;
	
		    if (seen.has(node)) {
		      var existing = seen.get(node);
		      if (existing.resolved) {
		        return existing.value;
		      } else {
		        deopt(path);
		        return;
		      }
		    } else {
		      var item = { resolved: false };
		      seen.set(node, item);
	
		      var val = _evaluate(path);
		      if (confident) {
		        item.resolved = true;
		        item.value = val;
		      }
		      return val;
		    }
		  }
	
		  function _evaluate(path) {
		    if (!confident) return;
	
		    var node = path.node;
	
		    if (path.isSequenceExpression()) {
		      var exprs = path.get("expressions");
		      return evaluate(exprs[exprs.length - 1]);
		    }
	
		    if (path.isStringLiteral() || path.isNumericLiteral() || path.isBooleanLiteral()) {
		      return node.value;
		    }
	
		    if (path.isNullLiteral()) {
		      return null;
		    }
	
		    if (path.isTemplateLiteral()) {
		      var str = "";
	
		      var i = 0;
		      var _exprs = path.get("expressions");
	
		      for (var _iterator = node.quasis, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		        var _ref;
	
		        if (_isArray) {
		          if (_i >= _iterator.length) break;
		          _ref = _iterator[_i++];
		        } else {
		          _i = _iterator.next();
		          if (_i.done) break;
		          _ref = _i.value;
		        }
	
		        var elem = _ref;
	
		        if (!confident) break;
	
		        str += elem.value.cooked;
	
		        var expr = _exprs[i++];
		        if (expr) str += String(evaluate(expr));
		      }
	
		      if (!confident) return;
		      return str;
		    }
	
		    if (path.isConditionalExpression()) {
		      var testResult = evaluate(path.get("test"));
		      if (!confident) return;
		      if (testResult) {
		        return evaluate(path.get("consequent"));
		      } else {
		        return evaluate(path.get("alternate"));
		      }
		    }
	
		    if (path.isExpressionWrapper()) {
		      return evaluate(path.get("expression"));
		    }
	
		    if (path.isMemberExpression() && !path.parentPath.isCallExpression({ callee: node })) {
		      var property = path.get("property");
		      var object = path.get("object");
	
		      if (object.isLiteral() && property.isIdentifier()) {
		        var _value = object.node.value;
		        var type = typeof _value === "undefined" ? "undefined" : (0, _typeof3.default)(_value);
		        if (type === "number" || type === "string") {
		          return _value[property.node.name];
		        }
		      }
		    }
	
		    if (path.isReferencedIdentifier()) {
		      var binding = path.scope.getBinding(node.name);
	
		      if (binding && binding.constantViolations.length > 0) {
		        return deopt(binding.path);
		      }
	
		      if (binding && path.node.start < binding.path.node.end) {
		        return deopt(binding.path);
		      }
	
		      if (binding && binding.hasValue) {
		        return binding.value;
		      } else {
		        if (node.name === "undefined") {
		          return binding ? deopt(binding.path) : undefined;
		        } else if (node.name === "Infinity") {
		          return binding ? deopt(binding.path) : Infinity;
		        } else if (node.name === "NaN") {
		          return binding ? deopt(binding.path) : NaN;
		        }
	
		        var resolved = path.resolve();
		        if (resolved === path) {
		          return deopt(path);
		        } else {
		          return evaluate(resolved);
		        }
		      }
		    }
	
		    if (path.isUnaryExpression({ prefix: true })) {
		      if (node.operator === "void") {
		        return undefined;
		      }
	
		      var argument = path.get("argument");
		      if (node.operator === "typeof" && (argument.isFunction() || argument.isClass())) {
		        return "function";
		      }
	
		      var arg = evaluate(argument);
		      if (!confident) return;
		      switch (node.operator) {
		        case "!":
		          return !arg;
		        case "+":
		          return +arg;
		        case "-":
		          return -arg;
		        case "~":
		          return ~arg;
		        case "typeof":
		          return typeof arg === "undefined" ? "undefined" : (0, _typeof3.default)(arg);
		      }
		    }
	
		    if (path.isArrayExpression()) {
		      var arr = [];
		      var elems = path.get("elements");
		      for (var _iterator2 = elems, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		        var _ref2;
	
		        if (_isArray2) {
		          if (_i2 >= _iterator2.length) break;
		          _ref2 = _iterator2[_i2++];
		        } else {
		          _i2 = _iterator2.next();
		          if (_i2.done) break;
		          _ref2 = _i2.value;
		        }
	
		        var _elem = _ref2;
	
		        _elem = _elem.evaluate();
	
		        if (_elem.confident) {
		          arr.push(_elem.value);
		        } else {
		          return deopt(_elem);
		        }
		      }
		      return arr;
		    }
	
		    if (path.isObjectExpression()) {
		      var obj = {};
		      var props = path.get("properties");
		      for (var _iterator3 = props, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		        var _ref3;
	
		        if (_isArray3) {
		          if (_i3 >= _iterator3.length) break;
		          _ref3 = _iterator3[_i3++];
		        } else {
		          _i3 = _iterator3.next();
		          if (_i3.done) break;
		          _ref3 = _i3.value;
		        }
	
		        var prop = _ref3;
	
		        if (prop.isObjectMethod() || prop.isSpreadProperty()) {
		          return deopt(prop);
		        }
		        var keyPath = prop.get("key");
		        var key = keyPath;
		        if (prop.node.computed) {
		          key = key.evaluate();
		          if (!key.confident) {
		            return deopt(keyPath);
		          }
		          key = key.value;
		        } else if (key.isIdentifier()) {
		          key = key.node.name;
		        } else {
		          key = key.node.value;
		        }
		        var valuePath = prop.get("value");
		        var _value2 = valuePath.evaluate();
		        if (!_value2.confident) {
		          return deopt(valuePath);
		        }
		        _value2 = _value2.value;
		        obj[key] = _value2;
		      }
		      return obj;
		    }
	
		    if (path.isLogicalExpression()) {
		      var wasConfident = confident;
		      var left = evaluate(path.get("left"));
		      var leftConfident = confident;
		      confident = wasConfident;
		      var right = evaluate(path.get("right"));
		      var rightConfident = confident;
		      confident = leftConfident && rightConfident;
	
		      switch (node.operator) {
		        case "||":
		          if (left && leftConfident) {
		            confident = true;
		            return left;
		          }
	
		          if (!confident) return;
	
		          return left || right;
		        case "&&":
		          if (!left && leftConfident || !right && rightConfident) {
		            confident = true;
		          }
	
		          if (!confident) return;
	
		          return left && right;
		      }
		    }
	
		    if (path.isBinaryExpression()) {
		      var _left = evaluate(path.get("left"));
		      if (!confident) return;
		      var _right = evaluate(path.get("right"));
		      if (!confident) return;
	
		      switch (node.operator) {
		        case "-":
		          return _left - _right;
		        case "+":
		          return _left + _right;
		        case "/":
		          return _left / _right;
		        case "*":
		          return _left * _right;
		        case "%":
		          return _left % _right;
		        case "**":
		          return Math.pow(_left, _right);
		        case "<":
		          return _left < _right;
		        case ">":
		          return _left > _right;
		        case "<=":
		          return _left <= _right;
		        case ">=":
		          return _left >= _right;
		        case "==":
		          return _left == _right;
		        case "!=":
		          return _left != _right;
		        case "===":
		          return _left === _right;
		        case "!==":
		          return _left !== _right;
		        case "|":
		          return _left | _right;
		        case "&":
		          return _left & _right;
		        case "^":
		          return _left ^ _right;
		        case "<<":
		          return _left << _right;
		        case ">>":
		          return _left >> _right;
		        case ">>>":
		          return _left >>> _right;
		      }
		    }
	
		    if (path.isCallExpression()) {
		      var callee = path.get("callee");
		      var context = void 0;
		      var func = void 0;
	
		      if (callee.isIdentifier() && !path.scope.getBinding(callee.node.name, true) && VALID_CALLEES.indexOf(callee.node.name) >= 0) {
		        func = global[node.callee.name];
		      }
	
		      if (callee.isMemberExpression()) {
		        var _object = callee.get("object");
		        var _property = callee.get("property");
	
		        if (_object.isIdentifier() && _property.isIdentifier() && VALID_CALLEES.indexOf(_object.node.name) >= 0 && INVALID_METHODS.indexOf(_property.node.name) < 0) {
		          context = global[_object.node.name];
		          func = context[_property.node.name];
		        }
	
		        if (_object.isLiteral() && _property.isIdentifier()) {
		          var _type = (0, _typeof3.default)(_object.node.value);
		          if (_type === "string" || _type === "number") {
		            context = _object.node.value;
		            func = context[_property.node.name];
		          }
		        }
		      }
	
		      if (func) {
		        var args = path.get("arguments").map(evaluate);
		        if (!confident) return;
	
		        return func.apply(context, args);
		      }
		    }
	
		    deopt(path);
		  }
		}
		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))
	
	/***/ }),
	/* 373 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _create = __webpack_require__(9);
	
		var _create2 = _interopRequireDefault(_create);
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.getStatementParent = getStatementParent;
		exports.getOpposite = getOpposite;
		exports.getCompletionRecords = getCompletionRecords;
		exports.getSibling = getSibling;
		exports.getPrevSibling = getPrevSibling;
		exports.getNextSibling = getNextSibling;
		exports.getAllNextSiblings = getAllNextSiblings;
		exports.getAllPrevSiblings = getAllPrevSiblings;
		exports.get = get;
		exports._getKey = _getKey;
		exports._getPattern = _getPattern;
		exports.getBindingIdentifiers = getBindingIdentifiers;
		exports.getOuterBindingIdentifiers = getOuterBindingIdentifiers;
		exports.getBindingIdentifierPaths = getBindingIdentifierPaths;
		exports.getOuterBindingIdentifierPaths = getOuterBindingIdentifierPaths;
	
		var _index = __webpack_require__(36);
	
		var _index2 = _interopRequireDefault(_index);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function getStatementParent() {
		  var path = this;
	
		  do {
		    if (!path.parentPath || Array.isArray(path.container) && path.isStatement()) {
		      break;
		    } else {
		      path = path.parentPath;
		    }
		  } while (path);
	
		  if (path && (path.isProgram() || path.isFile())) {
		    throw new Error("File/Program node, we can't possibly find a statement parent to this");
		  }
	
		  return path;
		}
	
		function getOpposite() {
		  if (this.key === "left") {
		    return this.getSibling("right");
		  } else if (this.key === "right") {
		    return this.getSibling("left");
		  }
		}
	
		function getCompletionRecords() {
		  var paths = [];
	
		  var add = function add(path) {
		    if (path) paths = paths.concat(path.getCompletionRecords());
		  };
	
		  if (this.isIfStatement()) {
		    add(this.get("consequent"));
		    add(this.get("alternate"));
		  } else if (this.isDoExpression() || this.isFor() || this.isWhile()) {
		    add(this.get("body"));
		  } else if (this.isProgram() || this.isBlockStatement()) {
		    add(this.get("body").pop());
		  } else if (this.isFunction()) {
		    return this.get("body").getCompletionRecords();
		  } else if (this.isTryStatement()) {
		    add(this.get("block"));
		    add(this.get("handler"));
		    add(this.get("finalizer"));
		  } else {
		    paths.push(this);
		  }
	
		  return paths;
		}
	
		function getSibling(key) {
		  return _index2.default.get({
		    parentPath: this.parentPath,
		    parent: this.parent,
		    container: this.container,
		    listKey: this.listKey,
		    key: key
		  });
		}
	
		function getPrevSibling() {
		  return this.getSibling(this.key - 1);
		}
	
		function getNextSibling() {
		  return this.getSibling(this.key + 1);
		}
	
		function getAllNextSiblings() {
		  var _key = this.key;
		  var sibling = this.getSibling(++_key);
		  var siblings = [];
		  while (sibling.node) {
		    siblings.push(sibling);
		    sibling = this.getSibling(++_key);
		  }
		  return siblings;
		}
	
		function getAllPrevSiblings() {
		  var _key = this.key;
		  var sibling = this.getSibling(--_key);
		  var siblings = [];
		  while (sibling.node) {
		    siblings.push(sibling);
		    sibling = this.getSibling(--_key);
		  }
		  return siblings;
		}
	
		function get(key, context) {
		  if (context === true) context = this.context;
		  var parts = key.split(".");
		  if (parts.length === 1) {
		    return this._getKey(key, context);
		  } else {
		    return this._getPattern(parts, context);
		  }
		}
	
		function _getKey(key, context) {
		  var _this = this;
	
		  var node = this.node;
		  var container = node[key];
	
		  if (Array.isArray(container)) {
		    return container.map(function (_, i) {
		      return _index2.default.get({
		        listKey: key,
		        parentPath: _this,
		        parent: node,
		        container: container,
		        key: i
		      }).setContext(context);
		    });
		  } else {
		    return _index2.default.get({
		      parentPath: this,
		      parent: node,
		      container: node,
		      key: key
		    }).setContext(context);
		  }
		}
	
		function _getPattern(parts, context) {
		  var path = this;
		  for (var _iterator = parts, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		    var _ref;
	
		    if (_isArray) {
		      if (_i >= _iterator.length) break;
		      _ref = _iterator[_i++];
		    } else {
		      _i = _iterator.next();
		      if (_i.done) break;
		      _ref = _i.value;
		    }
	
		    var part = _ref;
	
		    if (part === ".") {
		      path = path.parentPath;
		    } else {
		      if (Array.isArray(path)) {
		        path = path[part];
		      } else {
		        path = path.get(part, context);
		      }
		    }
		  }
		  return path;
		}
	
		function getBindingIdentifiers(duplicates) {
		  return t.getBindingIdentifiers(this.node, duplicates);
		}
	
		function getOuterBindingIdentifiers(duplicates) {
		  return t.getOuterBindingIdentifiers(this.node, duplicates);
		}
	
		function getBindingIdentifierPaths() {
		  var duplicates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
		  var outerOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
		  var path = this;
		  var search = [].concat(path);
		  var ids = (0, _create2.default)(null);
	
		  while (search.length) {
		    var id = search.shift();
		    if (!id) continue;
		    if (!id.node) continue;
	
		    var keys = t.getBindingIdentifiers.keys[id.node.type];
	
		    if (id.isIdentifier()) {
		      if (duplicates) {
		        var _ids = ids[id.node.name] = ids[id.node.name] || [];
		        _ids.push(id);
		      } else {
		        ids[id.node.name] = id;
		      }
		      continue;
		    }
	
		    if (id.isExportDeclaration()) {
		      var declaration = id.get("declaration");
		      if (declaration.isDeclaration()) {
		        search.push(declaration);
		      }
		      continue;
		    }
	
		    if (outerOnly) {
		      if (id.isFunctionDeclaration()) {
		        search.push(id.get("id"));
		        continue;
		      }
		      if (id.isFunctionExpression()) {
		        continue;
		      }
		    }
	
		    if (keys) {
		      for (var i = 0; i < keys.length; i++) {
		        var key = keys[i];
		        var child = id.get(key);
		        if (Array.isArray(child) || child.node) {
		          search = search.concat(child);
		        }
		      }
		    }
		  }
	
		  return ids;
		}
	
		function getOuterBindingIdentifierPaths(duplicates) {
		  return this.getBindingIdentifierPaths(duplicates, true);
		}
	
	/***/ }),
	/* 374 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.getTypeAnnotation = getTypeAnnotation;
		exports._getTypeAnnotation = _getTypeAnnotation;
		exports.isBaseType = isBaseType;
		exports.couldBeBaseType = couldBeBaseType;
		exports.baseTypeStrictlyMatches = baseTypeStrictlyMatches;
		exports.isGenericType = isGenericType;
	
		var _inferers = __webpack_require__(376);
	
		var inferers = _interopRequireWildcard(_inferers);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function getTypeAnnotation() {
		  if (this.typeAnnotation) return this.typeAnnotation;
	
		  var type = this._getTypeAnnotation() || t.anyTypeAnnotation();
		  if (t.isTypeAnnotation(type)) type = type.typeAnnotation;
		  return this.typeAnnotation = type;
		}
	
		function _getTypeAnnotation() {
		  var node = this.node;
	
		  if (!node) {
		    if (this.key === "init" && this.parentPath.isVariableDeclarator()) {
		      var declar = this.parentPath.parentPath;
		      var declarParent = declar.parentPath;
	
		      if (declar.key === "left" && declarParent.isForInStatement()) {
		        return t.stringTypeAnnotation();
		      }
	
		      if (declar.key === "left" && declarParent.isForOfStatement()) {
		        return t.anyTypeAnnotation();
		      }
	
		      return t.voidTypeAnnotation();
		    } else {
		      return;
		    }
		  }
	
		  if (node.typeAnnotation) {
		    return node.typeAnnotation;
		  }
	
		  var inferer = inferers[node.type];
		  if (inferer) {
		    return inferer.call(this, node);
		  }
	
		  inferer = inferers[this.parentPath.type];
		  if (inferer && inferer.validParent) {
		    return this.parentPath.getTypeAnnotation();
		  }
		}
	
		function isBaseType(baseName, soft) {
		  return _isBaseType(baseName, this.getTypeAnnotation(), soft);
		}
	
		function _isBaseType(baseName, type, soft) {
		  if (baseName === "string") {
		    return t.isStringTypeAnnotation(type);
		  } else if (baseName === "number") {
		    return t.isNumberTypeAnnotation(type);
		  } else if (baseName === "boolean") {
		    return t.isBooleanTypeAnnotation(type);
		  } else if (baseName === "any") {
		    return t.isAnyTypeAnnotation(type);
		  } else if (baseName === "mixed") {
		    return t.isMixedTypeAnnotation(type);
		  } else if (baseName === "empty") {
		    return t.isEmptyTypeAnnotation(type);
		  } else if (baseName === "void") {
		    return t.isVoidTypeAnnotation(type);
		  } else {
		    if (soft) {
		      return false;
		    } else {
		      throw new Error("Unknown base type " + baseName);
		    }
		  }
		}
	
		function couldBeBaseType(name) {
		  var type = this.getTypeAnnotation();
		  if (t.isAnyTypeAnnotation(type)) return true;
	
		  if (t.isUnionTypeAnnotation(type)) {
		    for (var _iterator = type.types, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var type2 = _ref;
	
		      if (t.isAnyTypeAnnotation(type2) || _isBaseType(name, type2, true)) {
		        return true;
		      }
		    }
		    return false;
		  } else {
		    return _isBaseType(name, type, true);
		  }
		}
	
		function baseTypeStrictlyMatches(right) {
		  var left = this.getTypeAnnotation();
		  right = right.getTypeAnnotation();
	
		  if (!t.isAnyTypeAnnotation(left) && t.isFlowBaseAnnotation(left)) {
		    return right.type === left.type;
		  }
		}
	
		function isGenericType(genericName) {
		  var type = this.getTypeAnnotation();
		  return t.isGenericTypeAnnotation(type) && t.isIdentifier(type.id, { name: genericName });
		}
	
	/***/ }),
	/* 375 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.default = function (node) {
		  if (!this.isReferenced()) return;
	
		  var binding = this.scope.getBinding(node.name);
		  if (binding) {
		    if (binding.identifier.typeAnnotation) {
		      return binding.identifier.typeAnnotation;
		    } else {
		      return getTypeAnnotationBindingConstantViolations(this, node.name);
		    }
		  }
	
		  if (node.name === "undefined") {
		    return t.voidTypeAnnotation();
		  } else if (node.name === "NaN" || node.name === "Infinity") {
		    return t.numberTypeAnnotation();
		  } else if (node.name === "arguments") {}
		};
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function getTypeAnnotationBindingConstantViolations(path, name) {
		  var binding = path.scope.getBinding(name);
	
		  var types = [];
		  path.typeAnnotation = t.unionTypeAnnotation(types);
	
		  var functionConstantViolations = [];
		  var constantViolations = getConstantViolationsBefore(binding, path, functionConstantViolations);
	
		  var testType = getConditionalAnnotation(path, name);
		  if (testType) {
		    var testConstantViolations = getConstantViolationsBefore(binding, testType.ifStatement);
	
		    constantViolations = constantViolations.filter(function (path) {
		      return testConstantViolations.indexOf(path) < 0;
		    });
	
		    types.push(testType.typeAnnotation);
		  }
	
		  if (constantViolations.length) {
		    constantViolations = constantViolations.concat(functionConstantViolations);
	
		    for (var _iterator = constantViolations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var violation = _ref;
	
		      types.push(violation.getTypeAnnotation());
		    }
		  }
	
		  if (types.length) {
		    return t.createUnionTypeAnnotation(types);
		  }
		}
	
		function getConstantViolationsBefore(binding, path, functions) {
		  var violations = binding.constantViolations.slice();
		  violations.unshift(binding.path);
		  return violations.filter(function (violation) {
		    violation = violation.resolve();
		    var status = violation._guessExecutionStatusRelativeTo(path);
		    if (functions && status === "function") functions.push(violation);
		    return status === "before";
		  });
		}
	
		function inferAnnotationFromBinaryExpression(name, path) {
		  var operator = path.node.operator;
	
		  var right = path.get("right").resolve();
		  var left = path.get("left").resolve();
	
		  var target = void 0;
		  if (left.isIdentifier({ name: name })) {
		    target = right;
		  } else if (right.isIdentifier({ name: name })) {
		    target = left;
		  }
		  if (target) {
		    if (operator === "===") {
		      return target.getTypeAnnotation();
		    } else if (t.BOOLEAN_NUMBER_BINARY_OPERATORS.indexOf(operator) >= 0) {
		      return t.numberTypeAnnotation();
		    } else {
		      return;
		    }
		  } else {
		    if (operator !== "===") return;
		  }
	
		  var typeofPath = void 0;
		  var typePath = void 0;
		  if (left.isUnaryExpression({ operator: "typeof" })) {
		    typeofPath = left;
		    typePath = right;
		  } else if (right.isUnaryExpression({ operator: "typeof" })) {
		    typeofPath = right;
		    typePath = left;
		  }
		  if (!typePath && !typeofPath) return;
	
		  typePath = typePath.resolve();
		  if (!typePath.isLiteral()) return;
	
		  var typeValue = typePath.node.value;
		  if (typeof typeValue !== "string") return;
	
		  if (!typeofPath.get("argument").isIdentifier({ name: name })) return;
	
		  return t.createTypeAnnotationBasedOnTypeof(typePath.node.value);
		}
	
		function getParentConditionalPath(path) {
		  var parentPath = void 0;
		  while (parentPath = path.parentPath) {
		    if (parentPath.isIfStatement() || parentPath.isConditionalExpression()) {
		      if (path.key === "test") {
		        return;
		      } else {
		        return parentPath;
		      }
		    } else {
		      path = parentPath;
		    }
		  }
		}
	
		function getConditionalAnnotation(path, name) {
		  var ifStatement = getParentConditionalPath(path);
		  if (!ifStatement) return;
	
		  var test = ifStatement.get("test");
		  var paths = [test];
		  var types = [];
	
		  do {
		    var _path = paths.shift().resolve();
	
		    if (_path.isLogicalExpression()) {
		      paths.push(_path.get("left"));
		      paths.push(_path.get("right"));
		    }
	
		    if (_path.isBinaryExpression()) {
		      var type = inferAnnotationFromBinaryExpression(name, _path);
		      if (type) types.push(type);
		    }
		  } while (paths.length);
	
		  if (types.length) {
		    return {
		      typeAnnotation: t.createUnionTypeAnnotation(types),
		      ifStatement: ifStatement
		    };
		  } else {
		    return getConditionalAnnotation(ifStatement, name);
		  }
		}
		module.exports = exports["default"];
	
	/***/ }),
	/* 376 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.ClassDeclaration = exports.ClassExpression = exports.FunctionDeclaration = exports.ArrowFunctionExpression = exports.FunctionExpression = exports.Identifier = undefined;
	
		var _infererReference = __webpack_require__(375);
	
		Object.defineProperty(exports, "Identifier", {
		  enumerable: true,
		  get: function get() {
		    return _interopRequireDefault(_infererReference).default;
		  }
		});
		exports.VariableDeclarator = VariableDeclarator;
		exports.TypeCastExpression = TypeCastExpression;
		exports.NewExpression = NewExpression;
		exports.TemplateLiteral = TemplateLiteral;
		exports.UnaryExpression = UnaryExpression;
		exports.BinaryExpression = BinaryExpression;
		exports.LogicalExpression = LogicalExpression;
		exports.ConditionalExpression = ConditionalExpression;
		exports.SequenceExpression = SequenceExpression;
		exports.AssignmentExpression = AssignmentExpression;
		exports.UpdateExpression = UpdateExpression;
		exports.StringLiteral = StringLiteral;
		exports.NumericLiteral = NumericLiteral;
		exports.BooleanLiteral = BooleanLiteral;
		exports.NullLiteral = NullLiteral;
		exports.RegExpLiteral = RegExpLiteral;
		exports.ObjectExpression = ObjectExpression;
		exports.ArrayExpression = ArrayExpression;
		exports.RestElement = RestElement;
		exports.CallExpression = CallExpression;
		exports.TaggedTemplateExpression = TaggedTemplateExpression;
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function VariableDeclarator() {
		  var id = this.get("id");
	
		  if (id.isIdentifier()) {
		    return this.get("init").getTypeAnnotation();
		  } else {
		    return;
		  }
		}
	
		function TypeCastExpression(node) {
		  return node.typeAnnotation;
		}
	
		TypeCastExpression.validParent = true;
	
		function NewExpression(node) {
		  if (this.get("callee").isIdentifier()) {
		    return t.genericTypeAnnotation(node.callee);
		  }
		}
	
		function TemplateLiteral() {
		  return t.stringTypeAnnotation();
		}
	
		function UnaryExpression(node) {
		  var operator = node.operator;
	
		  if (operator === "void") {
		    return t.voidTypeAnnotation();
		  } else if (t.NUMBER_UNARY_OPERATORS.indexOf(operator) >= 0) {
		    return t.numberTypeAnnotation();
		  } else if (t.STRING_UNARY_OPERATORS.indexOf(operator) >= 0) {
		    return t.stringTypeAnnotation();
		  } else if (t.BOOLEAN_UNARY_OPERATORS.indexOf(operator) >= 0) {
		    return t.booleanTypeAnnotation();
		  }
		}
	
		function BinaryExpression(node) {
		  var operator = node.operator;
	
		  if (t.NUMBER_BINARY_OPERATORS.indexOf(operator) >= 0) {
		    return t.numberTypeAnnotation();
		  } else if (t.BOOLEAN_BINARY_OPERATORS.indexOf(operator) >= 0) {
		    return t.booleanTypeAnnotation();
		  } else if (operator === "+") {
		    var right = this.get("right");
		    var left = this.get("left");
	
		    if (left.isBaseType("number") && right.isBaseType("number")) {
		      return t.numberTypeAnnotation();
		    } else if (left.isBaseType("string") || right.isBaseType("string")) {
		      return t.stringTypeAnnotation();
		    }
	
		    return t.unionTypeAnnotation([t.stringTypeAnnotation(), t.numberTypeAnnotation()]);
		  }
		}
	
		function LogicalExpression() {
		  return t.createUnionTypeAnnotation([this.get("left").getTypeAnnotation(), this.get("right").getTypeAnnotation()]);
		}
	
		function ConditionalExpression() {
		  return t.createUnionTypeAnnotation([this.get("consequent").getTypeAnnotation(), this.get("alternate").getTypeAnnotation()]);
		}
	
		function SequenceExpression() {
		  return this.get("expressions").pop().getTypeAnnotation();
		}
	
		function AssignmentExpression() {
		  return this.get("right").getTypeAnnotation();
		}
	
		function UpdateExpression(node) {
		  var operator = node.operator;
		  if (operator === "++" || operator === "--") {
		    return t.numberTypeAnnotation();
		  }
		}
	
		function StringLiteral() {
		  return t.stringTypeAnnotation();
		}
	
		function NumericLiteral() {
		  return t.numberTypeAnnotation();
		}
	
		function BooleanLiteral() {
		  return t.booleanTypeAnnotation();
		}
	
		function NullLiteral() {
		  return t.nullLiteralTypeAnnotation();
		}
	
		function RegExpLiteral() {
		  return t.genericTypeAnnotation(t.identifier("RegExp"));
		}
	
		function ObjectExpression() {
		  return t.genericTypeAnnotation(t.identifier("Object"));
		}
	
		function ArrayExpression() {
		  return t.genericTypeAnnotation(t.identifier("Array"));
		}
	
		function RestElement() {
		  return ArrayExpression();
		}
	
		RestElement.validParent = true;
	
		function Func() {
		  return t.genericTypeAnnotation(t.identifier("Function"));
		}
	
		exports.FunctionExpression = Func;
		exports.ArrowFunctionExpression = Func;
		exports.FunctionDeclaration = Func;
		exports.ClassExpression = Func;
		exports.ClassDeclaration = Func;
		function CallExpression() {
		  return resolveCall(this.get("callee"));
		}
	
		function TaggedTemplateExpression() {
		  return resolveCall(this.get("tag"));
		}
	
		function resolveCall(callee) {
		  callee = callee.resolve();
	
		  if (callee.isFunction()) {
		    if (callee.is("async")) {
		      if (callee.is("generator")) {
		        return t.genericTypeAnnotation(t.identifier("AsyncIterator"));
		      } else {
		        return t.genericTypeAnnotation(t.identifier("Promise"));
		      }
		    } else {
		      if (callee.node.returnType) {
		        return callee.node.returnType;
		      } else {}
		    }
		  }
		}
	
	/***/ }),
	/* 377 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.is = undefined;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.matchesPattern = matchesPattern;
		exports.has = has;
		exports.isStatic = isStatic;
		exports.isnt = isnt;
		exports.equals = equals;
		exports.isNodeType = isNodeType;
		exports.canHaveVariableDeclarationOrExpression = canHaveVariableDeclarationOrExpression;
		exports.canSwapBetweenExpressionAndStatement = canSwapBetweenExpressionAndStatement;
		exports.isCompletionRecord = isCompletionRecord;
		exports.isStatementOrBlock = isStatementOrBlock;
		exports.referencesImport = referencesImport;
		exports.getSource = getSource;
		exports.willIMaybeExecuteBefore = willIMaybeExecuteBefore;
		exports._guessExecutionStatusRelativeTo = _guessExecutionStatusRelativeTo;
		exports._guessExecutionStatusRelativeToDifferentFunctions = _guessExecutionStatusRelativeToDifferentFunctions;
		exports.resolve = resolve;
		exports._resolve = _resolve;
	
		var _includes = __webpack_require__(111);
	
		var _includes2 = _interopRequireDefault(_includes);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function matchesPattern(pattern, allowPartial) {
		  if (!this.isMemberExpression()) return false;
	
		  var parts = pattern.split(".");
		  var search = [this.node];
		  var i = 0;
	
		  function matches(name) {
		    var part = parts[i];
		    return part === "*" || name === part;
		  }
	
		  while (search.length) {
		    var node = search.shift();
	
		    if (allowPartial && i === parts.length) {
		      return true;
		    }
	
		    if (t.isIdentifier(node)) {
		      if (!matches(node.name)) return false;
		    } else if (t.isLiteral(node)) {
		      if (!matches(node.value)) return false;
		    } else if (t.isMemberExpression(node)) {
		      if (node.computed && !t.isLiteral(node.property)) {
		        return false;
		      } else {
		        search.unshift(node.property);
		        search.unshift(node.object);
		        continue;
		      }
		    } else if (t.isThisExpression(node)) {
		      if (!matches("this")) return false;
		    } else {
		      return false;
		    }
	
		    if (++i > parts.length) {
		      return false;
		    }
		  }
	
		  return i === parts.length;
		}
	
		function has(key) {
		  var val = this.node && this.node[key];
		  if (val && Array.isArray(val)) {
		    return !!val.length;
		  } else {
		    return !!val;
		  }
		}
	
		function isStatic() {
		  return this.scope.isStatic(this.node);
		}
	
		var is = exports.is = has;
	
		function isnt(key) {
		  return !this.has(key);
		}
	
		function equals(key, value) {
		  return this.node[key] === value;
		}
	
		function isNodeType(type) {
		  return t.isType(this.type, type);
		}
	
		function canHaveVariableDeclarationOrExpression() {
		  return (this.key === "init" || this.key === "left") && this.parentPath.isFor();
		}
	
		function canSwapBetweenExpressionAndStatement(replacement) {
		  if (this.key !== "body" || !this.parentPath.isArrowFunctionExpression()) {
		    return false;
		  }
	
		  if (this.isExpression()) {
		    return t.isBlockStatement(replacement);
		  } else if (this.isBlockStatement()) {
		    return t.isExpression(replacement);
		  }
	
		  return false;
		}
	
		function isCompletionRecord(allowInsideFunction) {
		  var path = this;
		  var first = true;
	
		  do {
		    var container = path.container;
	
		    if (path.isFunction() && !first) {
		      return !!allowInsideFunction;
		    }
	
		    first = false;
	
		    if (Array.isArray(container) && path.key !== container.length - 1) {
		      return false;
		    }
		  } while ((path = path.parentPath) && !path.isProgram());
	
		  return true;
		}
	
		function isStatementOrBlock() {
		  if (this.parentPath.isLabeledStatement() || t.isBlockStatement(this.container)) {
		    return false;
		  } else {
		    return (0, _includes2.default)(t.STATEMENT_OR_BLOCK_KEYS, this.key);
		  }
		}
	
		function referencesImport(moduleSource, importName) {
		  if (!this.isReferencedIdentifier()) return false;
	
		  var binding = this.scope.getBinding(this.node.name);
		  if (!binding || binding.kind !== "module") return false;
	
		  var path = binding.path;
		  var parent = path.parentPath;
		  if (!parent.isImportDeclaration()) return false;
	
		  if (parent.node.source.value === moduleSource) {
		    if (!importName) return true;
		  } else {
		    return false;
		  }
	
		  if (path.isImportDefaultSpecifier() && importName === "default") {
		    return true;
		  }
	
		  if (path.isImportNamespaceSpecifier() && importName === "*") {
		    return true;
		  }
	
		  if (path.isImportSpecifier() && path.node.imported.name === importName) {
		    return true;
		  }
	
		  return false;
		}
	
		function getSource() {
		  var node = this.node;
		  if (node.end) {
		    return this.hub.file.code.slice(node.start, node.end);
		  } else {
		    return "";
		  }
		}
	
		function willIMaybeExecuteBefore(target) {
		  return this._guessExecutionStatusRelativeTo(target) !== "after";
		}
	
		function _guessExecutionStatusRelativeTo(target) {
		  var targetFuncParent = target.scope.getFunctionParent();
		  var selfFuncParent = this.scope.getFunctionParent();
	
		  if (targetFuncParent.node !== selfFuncParent.node) {
		    var status = this._guessExecutionStatusRelativeToDifferentFunctions(targetFuncParent);
		    if (status) {
		      return status;
		    } else {
		      target = targetFuncParent.path;
		    }
		  }
	
		  var targetPaths = target.getAncestry();
		  if (targetPaths.indexOf(this) >= 0) return "after";
	
		  var selfPaths = this.getAncestry();
	
		  var commonPath = void 0;
		  var targetIndex = void 0;
		  var selfIndex = void 0;
		  for (selfIndex = 0; selfIndex < selfPaths.length; selfIndex++) {
		    var selfPath = selfPaths[selfIndex];
		    targetIndex = targetPaths.indexOf(selfPath);
		    if (targetIndex >= 0) {
		      commonPath = selfPath;
		      break;
		    }
		  }
		  if (!commonPath) {
		    return "before";
		  }
	
		  var targetRelationship = targetPaths[targetIndex - 1];
		  var selfRelationship = selfPaths[selfIndex - 1];
		  if (!targetRelationship || !selfRelationship) {
		    return "before";
		  }
	
		  if (targetRelationship.listKey && targetRelationship.container === selfRelationship.container) {
		    return targetRelationship.key > selfRelationship.key ? "before" : "after";
		  }
	
		  var targetKeyPosition = t.VISITOR_KEYS[targetRelationship.type].indexOf(targetRelationship.key);
		  var selfKeyPosition = t.VISITOR_KEYS[selfRelationship.type].indexOf(selfRelationship.key);
		  return targetKeyPosition > selfKeyPosition ? "before" : "after";
		}
	
		function _guessExecutionStatusRelativeToDifferentFunctions(targetFuncParent) {
		  var targetFuncPath = targetFuncParent.path;
		  if (!targetFuncPath.isFunctionDeclaration()) return;
	
		  var binding = targetFuncPath.scope.getBinding(targetFuncPath.node.id.name);
	
		  if (!binding.references) return "before";
	
		  var referencePaths = binding.referencePaths;
	
		  for (var _iterator = referencePaths, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		    var _ref;
	
		    if (_isArray) {
		      if (_i >= _iterator.length) break;
		      _ref = _iterator[_i++];
		    } else {
		      _i = _iterator.next();
		      if (_i.done) break;
		      _ref = _i.value;
		    }
	
		    var path = _ref;
	
		    if (path.key !== "callee" || !path.parentPath.isCallExpression()) {
		      return;
		    }
		  }
	
		  var allStatus = void 0;
	
		  for (var _iterator2 = referencePaths, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		    var _ref2;
	
		    if (_isArray2) {
		      if (_i2 >= _iterator2.length) break;
		      _ref2 = _iterator2[_i2++];
		    } else {
		      _i2 = _iterator2.next();
		      if (_i2.done) break;
		      _ref2 = _i2.value;
		    }
	
		    var _path = _ref2;
	
		    var childOfFunction = !!_path.find(function (path) {
		      return path.node === targetFuncPath.node;
		    });
		    if (childOfFunction) continue;
	
		    var status = this._guessExecutionStatusRelativeTo(_path);
	
		    if (allStatus) {
		      if (allStatus !== status) return;
		    } else {
		      allStatus = status;
		    }
		  }
	
		  return allStatus;
		}
	
		function resolve(dangerous, resolved) {
		  return this._resolve(dangerous, resolved) || this;
		}
	
		function _resolve(dangerous, resolved) {
		  if (resolved && resolved.indexOf(this) >= 0) return;
	
		  resolved = resolved || [];
		  resolved.push(this);
	
		  if (this.isVariableDeclarator()) {
		    if (this.get("id").isIdentifier()) {
		      return this.get("init").resolve(dangerous, resolved);
		    } else {}
		  } else if (this.isReferencedIdentifier()) {
		    var binding = this.scope.getBinding(this.node.name);
		    if (!binding) return;
	
		    if (!binding.constant) return;
	
		    if (binding.kind === "module") return;
	
		    if (binding.path !== this) {
		      var ret = binding.path.resolve(dangerous, resolved);
	
		      if (this.find(function (parent) {
		        return parent.node === ret.node;
		      })) return;
		      return ret;
		    }
		  } else if (this.isTypeCastExpression()) {
		    return this.get("expression").resolve(dangerous, resolved);
		  } else if (dangerous && this.isMemberExpression()) {
	
		    var targetKey = this.toComputedKey();
		    if (!t.isLiteral(targetKey)) return;
	
		    var targetName = targetKey.value;
	
		    var target = this.get("object").resolve(dangerous, resolved);
	
		    if (target.isObjectExpression()) {
		      var props = target.get("properties");
		      for (var _iterator3 = props, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		        var _ref3;
	
		        if (_isArray3) {
		          if (_i3 >= _iterator3.length) break;
		          _ref3 = _iterator3[_i3++];
		        } else {
		          _i3 = _iterator3.next();
		          if (_i3.done) break;
		          _ref3 = _i3.value;
		        }
	
		        var prop = _ref3;
	
		        if (!prop.isProperty()) continue;
	
		        var key = prop.get("key");
	
		        var match = prop.isnt("computed") && key.isIdentifier({ name: targetName });
	
		        match = match || key.isLiteral({ value: targetName });
	
		        if (match) return prop.get("value").resolve(dangerous, resolved);
		      }
		    } else if (target.isArrayExpression() && !isNaN(+targetName)) {
		      var elems = target.get("elements");
		      var elem = elems[targetName];
		      if (elem) return elem.resolve(dangerous, resolved);
		    }
		  }
		}
	
	/***/ }),
	/* 378 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var referenceVisitor = {
		  ReferencedIdentifier: function ReferencedIdentifier(path, state) {
		    if (path.isJSXIdentifier() && _babelTypes.react.isCompatTag(path.node.name) && !path.parentPath.isJSXMemberExpression()) {
		      return;
		    }
	
		    if (path.node.name === "this") {
		      var scope = path.scope;
		      do {
		        if (scope.path.isFunction() && !scope.path.isArrowFunctionExpression()) break;
		      } while (scope = scope.parent);
		      if (scope) state.breakOnScopePaths.push(scope.path);
		    }
	
		    var binding = path.scope.getBinding(path.node.name);
		    if (!binding) return;
	
		    if (binding !== state.scope.getBinding(path.node.name)) return;
	
		    state.bindings[path.node.name] = binding;
		  }
		};
	
		var PathHoister = function () {
		  function PathHoister(path, scope) {
		    (0, _classCallCheck3.default)(this, PathHoister);
	
		    this.breakOnScopePaths = [];
	
		    this.bindings = {};
	
		    this.scopes = [];
	
		    this.scope = scope;
		    this.path = path;
	
		    this.attachAfter = false;
		  }
	
		  PathHoister.prototype.isCompatibleScope = function isCompatibleScope(scope) {
		    for (var key in this.bindings) {
		      var binding = this.bindings[key];
		      if (!scope.bindingIdentifierEquals(key, binding.identifier)) {
		        return false;
		      }
		    }
	
		    return true;
		  };
	
		  PathHoister.prototype.getCompatibleScopes = function getCompatibleScopes() {
		    var scope = this.path.scope;
		    do {
		      if (this.isCompatibleScope(scope)) {
		        this.scopes.push(scope);
		      } else {
		        break;
		      }
	
		      if (this.breakOnScopePaths.indexOf(scope.path) >= 0) {
		        break;
		      }
		    } while (scope = scope.parent);
		  };
	
		  PathHoister.prototype.getAttachmentPath = function getAttachmentPath() {
		    var path = this._getAttachmentPath();
		    if (!path) return;
	
		    var targetScope = path.scope;
	
		    if (targetScope.path === path) {
		      targetScope = path.scope.parent;
		    }
	
		    if (targetScope.path.isProgram() || targetScope.path.isFunction()) {
		      for (var name in this.bindings) {
		        if (!targetScope.hasOwnBinding(name)) continue;
	
		        var binding = this.bindings[name];
	
		        if (binding.kind === "param") continue;
	
		        if (this.getAttachmentParentForPath(binding.path).key > path.key) {
		          this.attachAfter = true;
		          path = binding.path;
	
		          for (var _iterator = binding.constantViolations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		            var _ref;
	
		            if (_isArray) {
		              if (_i >= _iterator.length) break;
		              _ref = _iterator[_i++];
		            } else {
		              _i = _iterator.next();
		              if (_i.done) break;
		              _ref = _i.value;
		            }
	
		            var violationPath = _ref;
	
		            if (this.getAttachmentParentForPath(violationPath).key > path.key) {
		              path = violationPath;
		            }
		          }
		        }
		      }
		    }
	
		    if (path.parentPath.isExportDeclaration()) {
		      path = path.parentPath;
		    }
	
		    return path;
		  };
	
		  PathHoister.prototype._getAttachmentPath = function _getAttachmentPath() {
		    var scopes = this.scopes;
	
		    var scope = scopes.pop();
	
		    if (!scope) return;
	
		    if (scope.path.isFunction()) {
		      if (this.hasOwnParamBindings(scope)) {
		        if (this.scope === scope) return;
	
		        return scope.path.get("body").get("body")[0];
		      } else {
		        return this.getNextScopeAttachmentParent();
		      }
		    } else if (scope.path.isProgram()) {
		      return this.getNextScopeAttachmentParent();
		    }
		  };
	
		  PathHoister.prototype.getNextScopeAttachmentParent = function getNextScopeAttachmentParent() {
		    var scope = this.scopes.pop();
		    if (scope) return this.getAttachmentParentForPath(scope.path);
		  };
	
		  PathHoister.prototype.getAttachmentParentForPath = function getAttachmentParentForPath(path) {
		    do {
		      if (!path.parentPath || Array.isArray(path.container) && path.isStatement() || path.isVariableDeclarator() && path.parentPath.node !== null && path.parentPath.node.declarations.length > 1) return path;
		    } while (path = path.parentPath);
		  };
	
		  PathHoister.prototype.hasOwnParamBindings = function hasOwnParamBindings(scope) {
		    for (var name in this.bindings) {
		      if (!scope.hasOwnBinding(name)) continue;
	
		      var binding = this.bindings[name];
	
		      if (binding.kind === "param" && binding.constant) return true;
		    }
		    return false;
		  };
	
		  PathHoister.prototype.run = function run() {
		    var node = this.path.node;
		    if (node._hoisted) return;
		    node._hoisted = true;
	
		    this.path.traverse(referenceVisitor, this);
	
		    this.getCompatibleScopes();
	
		    var attachTo = this.getAttachmentPath();
		    if (!attachTo) return;
	
		    if (attachTo.getFunctionParent() === this.path.getFunctionParent()) return;
	
		    var uid = attachTo.scope.generateUidIdentifier("ref");
		    var declarator = t.variableDeclarator(uid, this.path.node);
	
		    var insertFn = this.attachAfter ? "insertAfter" : "insertBefore";
		    attachTo[insertFn]([attachTo.isVariableDeclarator() ? declarator : t.variableDeclaration("var", [declarator])]);
	
		    var parent = this.path.parentPath;
		    if (parent.isJSXElement() && this.path.container === parent.node.children) {
		      uid = t.JSXExpressionContainer(uid);
		    }
	
		    this.path.replaceWith(uid);
		  };
	
		  return PathHoister;
		}();
	
		exports.default = PathHoister;
		module.exports = exports["default"];
	
	/***/ }),
	/* 379 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.__esModule = true;
		var hooks = exports.hooks = [function (self, parent) {
		  var removeParent = self.key === "test" && (parent.isWhile() || parent.isSwitchCase()) || self.key === "declaration" && parent.isExportDeclaration() || self.key === "body" && parent.isLabeledStatement() || self.listKey === "declarations" && parent.isVariableDeclaration() && parent.node.declarations.length === 1 || self.key === "expression" && parent.isExpressionStatement();
	
		  if (removeParent) {
		    parent.remove();
		    return true;
		  }
		}, function (self, parent) {
		  if (parent.isSequenceExpression() && parent.node.expressions.length === 1) {
		    parent.replaceWith(parent.node.expressions[0]);
		    return true;
		  }
		}, function (self, parent) {
		  if (parent.isBinary()) {
		    if (self.key === "left") {
		      parent.replaceWith(parent.node.right);
		    } else {
		      parent.replaceWith(parent.node.left);
		    }
		    return true;
		  }
		}, function (self, parent) {
		  if (parent.isIfStatement() && (self.key === "consequent" || self.key === "alternate") || self.key === "body" && (parent.isLoop() || parent.isArrowFunctionExpression())) {
		    self.replaceWith({
		      type: "BlockStatement",
		      body: []
		    });
		    return true;
		  }
		}];
	
	/***/ }),
	/* 380 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _typeof2 = __webpack_require__(11);
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.insertBefore = insertBefore;
		exports._containerInsert = _containerInsert;
		exports._containerInsertBefore = _containerInsertBefore;
		exports._containerInsertAfter = _containerInsertAfter;
		exports._maybePopFromStatements = _maybePopFromStatements;
		exports.insertAfter = insertAfter;
		exports.updateSiblingKeys = updateSiblingKeys;
		exports._verifyNodeList = _verifyNodeList;
		exports.unshiftContainer = unshiftContainer;
		exports.pushContainer = pushContainer;
		exports.hoist = hoist;
	
		var _cache = __webpack_require__(88);
	
		var _hoister = __webpack_require__(378);
	
		var _hoister2 = _interopRequireDefault(_hoister);
	
		var _index = __webpack_require__(36);
	
		var _index2 = _interopRequireDefault(_index);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function insertBefore(nodes) {
		  this._assertUnremoved();
	
		  nodes = this._verifyNodeList(nodes);
	
		  if (this.parentPath.isExpressionStatement() || this.parentPath.isLabeledStatement()) {
		    return this.parentPath.insertBefore(nodes);
		  } else if (this.isNodeType("Expression") || this.parentPath.isForStatement() && this.key === "init") {
		    if (this.node) nodes.push(this.node);
		    this.replaceExpressionWithStatements(nodes);
		  } else {
		    this._maybePopFromStatements(nodes);
		    if (Array.isArray(this.container)) {
		      return this._containerInsertBefore(nodes);
		    } else if (this.isStatementOrBlock()) {
		      if (this.node) nodes.push(this.node);
		      this._replaceWith(t.blockStatement(nodes));
		    } else {
		      throw new Error("We don't know what to do with this node type. " + "We were previously a Statement but we can't fit in here?");
		    }
		  }
	
		  return [this];
		}
	
		function _containerInsert(from, nodes) {
		  this.updateSiblingKeys(from, nodes.length);
	
		  var paths = [];
	
		  for (var i = 0; i < nodes.length; i++) {
		    var to = from + i;
		    var node = nodes[i];
		    this.container.splice(to, 0, node);
	
		    if (this.context) {
		      var path = this.context.create(this.parent, this.container, to, this.listKey);
	
		      if (this.context.queue) path.pushContext(this.context);
		      paths.push(path);
		    } else {
		      paths.push(_index2.default.get({
		        parentPath: this.parentPath,
		        parent: this.parent,
		        container: this.container,
		        listKey: this.listKey,
		        key: to
		      }));
		    }
		  }
	
		  var contexts = this._getQueueContexts();
	
		  for (var _iterator = paths, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		    var _ref;
	
		    if (_isArray) {
		      if (_i >= _iterator.length) break;
		      _ref = _iterator[_i++];
		    } else {
		      _i = _iterator.next();
		      if (_i.done) break;
		      _ref = _i.value;
		    }
	
		    var _path = _ref;
	
		    _path.setScope();
		    _path.debug(function () {
		      return "Inserted.";
		    });
	
		    for (var _iterator2 = contexts, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		      var _ref2;
	
		      if (_isArray2) {
		        if (_i2 >= _iterator2.length) break;
		        _ref2 = _iterator2[_i2++];
		      } else {
		        _i2 = _iterator2.next();
		        if (_i2.done) break;
		        _ref2 = _i2.value;
		      }
	
		      var context = _ref2;
	
		      context.maybeQueue(_path, true);
		    }
		  }
	
		  return paths;
		}
	
		function _containerInsertBefore(nodes) {
		  return this._containerInsert(this.key, nodes);
		}
	
		function _containerInsertAfter(nodes) {
		  return this._containerInsert(this.key + 1, nodes);
		}
	
		function _maybePopFromStatements(nodes) {
		  var last = nodes[nodes.length - 1];
		  var isIdentifier = t.isIdentifier(last) || t.isExpressionStatement(last) && t.isIdentifier(last.expression);
	
		  if (isIdentifier && !this.isCompletionRecord()) {
		    nodes.pop();
		  }
		}
	
		function insertAfter(nodes) {
		  this._assertUnremoved();
	
		  nodes = this._verifyNodeList(nodes);
	
		  if (this.parentPath.isExpressionStatement() || this.parentPath.isLabeledStatement()) {
		    return this.parentPath.insertAfter(nodes);
		  } else if (this.isNodeType("Expression") || this.parentPath.isForStatement() && this.key === "init") {
		    if (this.node) {
		      var temp = this.scope.generateDeclaredUidIdentifier();
		      nodes.unshift(t.expressionStatement(t.assignmentExpression("=", temp, this.node)));
		      nodes.push(t.expressionStatement(temp));
		    }
		    this.replaceExpressionWithStatements(nodes);
		  } else {
		    this._maybePopFromStatements(nodes);
		    if (Array.isArray(this.container)) {
		      return this._containerInsertAfter(nodes);
		    } else if (this.isStatementOrBlock()) {
		      if (this.node) nodes.unshift(this.node);
		      this._replaceWith(t.blockStatement(nodes));
		    } else {
		      throw new Error("We don't know what to do with this node type. " + "We were previously a Statement but we can't fit in here?");
		    }
		  }
	
		  return [this];
		}
	
		function updateSiblingKeys(fromIndex, incrementBy) {
		  if (!this.parent) return;
	
		  var paths = _cache.path.get(this.parent);
		  for (var i = 0; i < paths.length; i++) {
		    var path = paths[i];
		    if (path.key >= fromIndex) {
		      path.key += incrementBy;
		    }
		  }
		}
	
		function _verifyNodeList(nodes) {
		  if (!nodes) {
		    return [];
		  }
	
		  if (nodes.constructor !== Array) {
		    nodes = [nodes];
		  }
	
		  for (var i = 0; i < nodes.length; i++) {
		    var node = nodes[i];
		    var msg = void 0;
	
		    if (!node) {
		      msg = "has falsy node";
		    } else if ((typeof node === "undefined" ? "undefined" : (0, _typeof3.default)(node)) !== "object") {
		      msg = "contains a non-object node";
		    } else if (!node.type) {
		      msg = "without a type";
		    } else if (node instanceof _index2.default) {
		      msg = "has a NodePath when it expected a raw object";
		    }
	
		    if (msg) {
		      var type = Array.isArray(node) ? "array" : typeof node === "undefined" ? "undefined" : (0, _typeof3.default)(node);
		      throw new Error("Node list " + msg + " with the index of " + i + " and type of " + type);
		    }
		  }
	
		  return nodes;
		}
	
		function unshiftContainer(listKey, nodes) {
		  this._assertUnremoved();
	
		  nodes = this._verifyNodeList(nodes);
	
		  var path = _index2.default.get({
		    parentPath: this,
		    parent: this.node,
		    container: this.node[listKey],
		    listKey: listKey,
		    key: 0
		  });
	
		  return path.insertBefore(nodes);
		}
	
		function pushContainer(listKey, nodes) {
		  this._assertUnremoved();
	
		  nodes = this._verifyNodeList(nodes);
	
		  var container = this.node[listKey];
		  var path = _index2.default.get({
		    parentPath: this,
		    parent: this.node,
		    container: container,
		    listKey: listKey,
		    key: container.length
		  });
	
		  return path.replaceWithMultiple(nodes);
		}
	
		function hoist() {
		  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.scope;
	
		  var hoister = new _hoister2.default(this, scope);
		  return hoister.run();
		}
	
	/***/ }),
	/* 381 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.remove = remove;
		exports._callRemovalHooks = _callRemovalHooks;
		exports._remove = _remove;
		exports._markRemoved = _markRemoved;
		exports._assertUnremoved = _assertUnremoved;
	
		var _removalHooks = __webpack_require__(379);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function remove() {
		  this._assertUnremoved();
	
		  this.resync();
	
		  if (this._callRemovalHooks()) {
		    this._markRemoved();
		    return;
		  }
	
		  this.shareCommentsWithSiblings();
		  this._remove();
		  this._markRemoved();
		}
	
		function _callRemovalHooks() {
		  for (var _iterator = _removalHooks.hooks, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		    var _ref;
	
		    if (_isArray) {
		      if (_i >= _iterator.length) break;
		      _ref = _iterator[_i++];
		    } else {
		      _i = _iterator.next();
		      if (_i.done) break;
		      _ref = _i.value;
		    }
	
		    var fn = _ref;
	
		    if (fn(this, this.parentPath)) return true;
		  }
		}
	
		function _remove() {
		  if (Array.isArray(this.container)) {
		    this.container.splice(this.key, 1);
		    this.updateSiblingKeys(this.key, -1);
		  } else {
		    this._replaceWith(null);
		  }
		}
	
		function _markRemoved() {
		  this.shouldSkip = true;
		  this.removed = true;
		  this.node = null;
		}
	
		function _assertUnremoved() {
		  if (this.removed) {
		    throw this.buildCodeFrameError("NodePath has been removed so is read-only.");
		  }
		}
	
	/***/ }),
	/* 382 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.replaceWithMultiple = replaceWithMultiple;
		exports.replaceWithSourceString = replaceWithSourceString;
		exports.replaceWith = replaceWith;
		exports._replaceWith = _replaceWith;
		exports.replaceExpressionWithStatements = replaceExpressionWithStatements;
		exports.replaceInline = replaceInline;
	
		var _babelCodeFrame = __webpack_require__(181);
	
		var _babelCodeFrame2 = _interopRequireDefault(_babelCodeFrame);
	
		var _index = __webpack_require__(7);
	
		var _index2 = _interopRequireDefault(_index);
	
		var _index3 = __webpack_require__(36);
	
		var _index4 = _interopRequireDefault(_index3);
	
		var _babylon = __webpack_require__(89);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var hoistVariablesVisitor = {
		  Function: function Function(path) {
		    path.skip();
		  },
		  VariableDeclaration: function VariableDeclaration(path) {
		    if (path.node.kind !== "var") return;
	
		    var bindings = path.getBindingIdentifiers();
		    for (var key in bindings) {
		      path.scope.push({ id: bindings[key] });
		    }
	
		    var exprs = [];
	
		    for (var _iterator = path.node.declarations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var declar = _ref;
	
		      if (declar.init) {
		        exprs.push(t.expressionStatement(t.assignmentExpression("=", declar.id, declar.init)));
		      }
		    }
	
		    path.replaceWithMultiple(exprs);
		  }
		};
	
		function replaceWithMultiple(nodes) {
		  this.resync();
	
		  nodes = this._verifyNodeList(nodes);
		  t.inheritLeadingComments(nodes[0], this.node);
		  t.inheritTrailingComments(nodes[nodes.length - 1], this.node);
		  this.node = this.container[this.key] = null;
		  this.insertAfter(nodes);
	
		  if (this.node) {
		    this.requeue();
		  } else {
		    this.remove();
		  }
		}
	
		function replaceWithSourceString(replacement) {
		  this.resync();
	
		  try {
		    replacement = "(" + replacement + ")";
		    replacement = (0, _babylon.parse)(replacement);
		  } catch (err) {
		    var loc = err.loc;
		    if (loc) {
		      err.message += " - make sure this is an expression.";
		      err.message += "\n" + (0, _babelCodeFrame2.default)(replacement, loc.line, loc.column + 1);
		    }
		    throw err;
		  }
	
		  replacement = replacement.program.body[0].expression;
		  _index2.default.removeProperties(replacement);
		  return this.replaceWith(replacement);
		}
	
		function replaceWith(replacement) {
		  this.resync();
	
		  if (this.removed) {
		    throw new Error("You can't replace this node, we've already removed it");
		  }
	
		  if (replacement instanceof _index4.default) {
		    replacement = replacement.node;
		  }
	
		  if (!replacement) {
		    throw new Error("You passed `path.replaceWith()` a falsy node, use `path.remove()` instead");
		  }
	
		  if (this.node === replacement) {
		    return;
		  }
	
		  if (this.isProgram() && !t.isProgram(replacement)) {
		    throw new Error("You can only replace a Program root node with another Program node");
		  }
	
		  if (Array.isArray(replacement)) {
		    throw new Error("Don't use `path.replaceWith()` with an array of nodes, use `path.replaceWithMultiple()`");
		  }
	
		  if (typeof replacement === "string") {
		    throw new Error("Don't use `path.replaceWith()` with a source string, use `path.replaceWithSourceString()`");
		  }
	
		  if (this.isNodeType("Statement") && t.isExpression(replacement)) {
		    if (!this.canHaveVariableDeclarationOrExpression() && !this.canSwapBetweenExpressionAndStatement(replacement) && !this.parentPath.isExportDefaultDeclaration()) {
		      replacement = t.expressionStatement(replacement);
		    }
		  }
	
		  if (this.isNodeType("Expression") && t.isStatement(replacement)) {
		    if (!this.canHaveVariableDeclarationOrExpression() && !this.canSwapBetweenExpressionAndStatement(replacement)) {
		      return this.replaceExpressionWithStatements([replacement]);
		    }
		  }
	
		  var oldNode = this.node;
		  if (oldNode) {
		    t.inheritsComments(replacement, oldNode);
		    t.removeComments(oldNode);
		  }
	
		  this._replaceWith(replacement);
		  this.type = replacement.type;
	
		  this.setScope();
	
		  this.requeue();
		}
	
		function _replaceWith(node) {
		  if (!this.container) {
		    throw new ReferenceError("Container is falsy");
		  }
	
		  if (this.inList) {
		    t.validate(this.parent, this.key, [node]);
		  } else {
		    t.validate(this.parent, this.key, node);
		  }
	
		  this.debug(function () {
		    return "Replace with " + (node && node.type);
		  });
	
		  this.node = this.container[this.key] = node;
		}
	
		function replaceExpressionWithStatements(nodes) {
		  this.resync();
	
		  var toSequenceExpression = t.toSequenceExpression(nodes, this.scope);
	
		  if (t.isSequenceExpression(toSequenceExpression)) {
		    var exprs = toSequenceExpression.expressions;
	
		    if (exprs.length >= 2 && this.parentPath.isExpressionStatement()) {
		      this._maybePopFromStatements(exprs);
		    }
	
		    if (exprs.length === 1) {
		      this.replaceWith(exprs[0]);
		    } else {
		      this.replaceWith(toSequenceExpression);
		    }
		  } else if (toSequenceExpression) {
		    this.replaceWith(toSequenceExpression);
		  } else {
		    var container = t.functionExpression(null, [], t.blockStatement(nodes));
		    container.shadow = true;
	
		    this.replaceWith(t.callExpression(container, []));
		    this.traverse(hoistVariablesVisitor);
	
		    var completionRecords = this.get("callee").getCompletionRecords();
		    for (var _iterator2 = completionRecords, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		      var _ref2;
	
		      if (_isArray2) {
		        if (_i2 >= _iterator2.length) break;
		        _ref2 = _iterator2[_i2++];
		      } else {
		        _i2 = _iterator2.next();
		        if (_i2.done) break;
		        _ref2 = _i2.value;
		      }
	
		      var path = _ref2;
	
		      if (!path.isExpressionStatement()) continue;
	
		      var loop = path.findParent(function (path) {
		        return path.isLoop();
		      });
		      if (loop) {
		        var uid = loop.getData("expressionReplacementReturnUid");
	
		        if (!uid) {
		          var callee = this.get("callee");
		          uid = callee.scope.generateDeclaredUidIdentifier("ret");
		          callee.get("body").pushContainer("body", t.returnStatement(uid));
		          loop.setData("expressionReplacementReturnUid", uid);
		        } else {
		          uid = t.identifier(uid.name);
		        }
	
		        path.get("expression").replaceWith(t.assignmentExpression("=", uid, path.node.expression));
		      } else {
		        path.replaceWith(t.returnStatement(path.node.expression));
		      }
		    }
	
		    return this.node;
		  }
		}
	
		function replaceInline(nodes) {
		  this.resync();
	
		  if (Array.isArray(nodes)) {
		    if (Array.isArray(this.container)) {
		      nodes = this._verifyNodeList(nodes);
		      this._containerInsertAfter(nodes);
		      return this.remove();
		    } else {
		      return this.replaceWithMultiple(nodes);
		    }
		  } else {
		    return this.replaceWith(nodes);
		  }
		}
	
	/***/ }),
	/* 383 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _classCallCheck2 = __webpack_require__(3);
	
		var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
		var _binding = __webpack_require__(225);
	
		var _binding2 = _interopRequireDefault(_binding);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var renameVisitor = {
		  ReferencedIdentifier: function ReferencedIdentifier(_ref, state) {
		    var node = _ref.node;
	
		    if (node.name === state.oldName) {
		      node.name = state.newName;
		    }
		  },
		  Scope: function Scope(path, state) {
		    if (!path.scope.bindingIdentifierEquals(state.oldName, state.binding.identifier)) {
		      path.skip();
		    }
		  },
		  "AssignmentExpression|Declaration": function AssignmentExpressionDeclaration(path, state) {
		    var ids = path.getOuterBindingIdentifiers();
	
		    for (var name in ids) {
		      if (name === state.oldName) ids[name].name = state.newName;
		    }
		  }
		};
	
		var Renamer = function () {
		  function Renamer(binding, oldName, newName) {
		    (0, _classCallCheck3.default)(this, Renamer);
	
		    this.newName = newName;
		    this.oldName = oldName;
		    this.binding = binding;
		  }
	
		  Renamer.prototype.maybeConvertFromExportDeclaration = function maybeConvertFromExportDeclaration(parentDeclar) {
		    var exportDeclar = parentDeclar.parentPath.isExportDeclaration() && parentDeclar.parentPath;
		    if (!exportDeclar) return;
	
		    var isDefault = exportDeclar.isExportDefaultDeclaration();
	
		    if (isDefault && (parentDeclar.isFunctionDeclaration() || parentDeclar.isClassDeclaration()) && !parentDeclar.node.id) {
		      parentDeclar.node.id = parentDeclar.scope.generateUidIdentifier("default");
		    }
	
		    var bindingIdentifiers = parentDeclar.getOuterBindingIdentifiers();
		    var specifiers = [];
	
		    for (var name in bindingIdentifiers) {
		      var localName = name === this.oldName ? this.newName : name;
		      var exportedName = isDefault ? "default" : name;
		      specifiers.push(t.exportSpecifier(t.identifier(localName), t.identifier(exportedName)));
		    }
	
		    if (specifiers.length) {
		      var aliasDeclar = t.exportNamedDeclaration(null, specifiers);
	
		      if (parentDeclar.isFunctionDeclaration()) {
		        aliasDeclar._blockHoist = 3;
		      }
	
		      exportDeclar.insertAfter(aliasDeclar);
		      exportDeclar.replaceWith(parentDeclar.node);
		    }
		  };
	
		  Renamer.prototype.rename = function rename(block) {
		    var binding = this.binding,
		        oldName = this.oldName,
		        newName = this.newName;
		    var scope = binding.scope,
		        path = binding.path;
	
		    var parentDeclar = path.find(function (path) {
		      return path.isDeclaration() || path.isFunctionExpression();
		    });
		    if (parentDeclar) {
		      this.maybeConvertFromExportDeclaration(parentDeclar);
		    }
	
		    scope.traverse(block || scope.block, renameVisitor, this);
	
		    if (!block) {
		      scope.removeOwnBinding(oldName);
		      scope.bindings[newName] = binding;
		      this.binding.identifier.name = newName;
		    }
	
		    if (binding.type === "hoisted") {}
		  };
	
		  return Renamer;
		}();
	
		exports.default = Renamer;
		module.exports = exports["default"];
	
	/***/ }),
	/* 384 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _typeof2 = __webpack_require__(11);
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		var _keys = __webpack_require__(14);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.explode = explode;
		exports.verify = verify;
		exports.merge = merge;
	
		var _virtualTypes = __webpack_require__(224);
	
		var virtualTypes = _interopRequireWildcard(_virtualTypes);
	
		var _babelMessages = __webpack_require__(20);
	
		var messages = _interopRequireWildcard(_babelMessages);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		var _clone = __webpack_require__(109);
	
		var _clone2 = _interopRequireDefault(_clone);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function explode(visitor) {
		  if (visitor._exploded) return visitor;
		  visitor._exploded = true;
	
		  for (var nodeType in visitor) {
		    if (shouldIgnoreKey(nodeType)) continue;
	
		    var parts = nodeType.split("|");
		    if (parts.length === 1) continue;
	
		    var fns = visitor[nodeType];
		    delete visitor[nodeType];
	
		    for (var _iterator = parts, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		      var _ref;
	
		      if (_isArray) {
		        if (_i >= _iterator.length) break;
		        _ref = _iterator[_i++];
		      } else {
		        _i = _iterator.next();
		        if (_i.done) break;
		        _ref = _i.value;
		      }
	
		      var part = _ref;
	
		      visitor[part] = fns;
		    }
		  }
	
		  verify(visitor);
	
		  delete visitor.__esModule;
	
		  ensureEntranceObjects(visitor);
	
		  ensureCallbackArrays(visitor);
	
		  for (var _iterator2 = (0, _keys2.default)(visitor), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		    var _ref2;
	
		    if (_isArray2) {
		      if (_i2 >= _iterator2.length) break;
		      _ref2 = _iterator2[_i2++];
		    } else {
		      _i2 = _iterator2.next();
		      if (_i2.done) break;
		      _ref2 = _i2.value;
		    }
	
		    var _nodeType3 = _ref2;
	
		    if (shouldIgnoreKey(_nodeType3)) continue;
	
		    var wrapper = virtualTypes[_nodeType3];
		    if (!wrapper) continue;
	
		    var _fns2 = visitor[_nodeType3];
		    for (var type in _fns2) {
		      _fns2[type] = wrapCheck(wrapper, _fns2[type]);
		    }
	
		    delete visitor[_nodeType3];
	
		    if (wrapper.types) {
		      for (var _iterator4 = wrapper.types, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
		        var _ref4;
	
		        if (_isArray4) {
		          if (_i4 >= _iterator4.length) break;
		          _ref4 = _iterator4[_i4++];
		        } else {
		          _i4 = _iterator4.next();
		          if (_i4.done) break;
		          _ref4 = _i4.value;
		        }
	
		        var _type = _ref4;
	
		        if (visitor[_type]) {
		          mergePair(visitor[_type], _fns2);
		        } else {
		          visitor[_type] = _fns2;
		        }
		      }
		    } else {
		      mergePair(visitor, _fns2);
		    }
		  }
	
		  for (var _nodeType in visitor) {
		    if (shouldIgnoreKey(_nodeType)) continue;
	
		    var _fns = visitor[_nodeType];
	
		    var aliases = t.FLIPPED_ALIAS_KEYS[_nodeType];
	
		    var deprecratedKey = t.DEPRECATED_KEYS[_nodeType];
		    if (deprecratedKey) {
		      console.trace("Visitor defined for " + _nodeType + " but it has been renamed to " + deprecratedKey);
		      aliases = [deprecratedKey];
		    }
	
		    if (!aliases) continue;
	
		    delete visitor[_nodeType];
	
		    for (var _iterator3 = aliases, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		      var _ref3;
	
		      if (_isArray3) {
		        if (_i3 >= _iterator3.length) break;
		        _ref3 = _iterator3[_i3++];
		      } else {
		        _i3 = _iterator3.next();
		        if (_i3.done) break;
		        _ref3 = _i3.value;
		      }
	
		      var alias = _ref3;
	
		      var existing = visitor[alias];
		      if (existing) {
		        mergePair(existing, _fns);
		      } else {
		        visitor[alias] = (0, _clone2.default)(_fns);
		      }
		    }
		  }
	
		  for (var _nodeType2 in visitor) {
		    if (shouldIgnoreKey(_nodeType2)) continue;
	
		    ensureCallbackArrays(visitor[_nodeType2]);
		  }
	
		  return visitor;
		}
	
		function verify(visitor) {
		  if (visitor._verified) return;
	
		  if (typeof visitor === "function") {
		    throw new Error(messages.get("traverseVerifyRootFunction"));
		  }
	
		  for (var nodeType in visitor) {
		    if (nodeType === "enter" || nodeType === "exit") {
		      validateVisitorMethods(nodeType, visitor[nodeType]);
		    }
	
		    if (shouldIgnoreKey(nodeType)) continue;
	
		    if (t.TYPES.indexOf(nodeType) < 0) {
		      throw new Error(messages.get("traverseVerifyNodeType", nodeType));
		    }
	
		    var visitors = visitor[nodeType];
		    if ((typeof visitors === "undefined" ? "undefined" : (0, _typeof3.default)(visitors)) === "object") {
		      for (var visitorKey in visitors) {
		        if (visitorKey === "enter" || visitorKey === "exit") {
		          validateVisitorMethods(nodeType + "." + visitorKey, visitors[visitorKey]);
		        } else {
		          throw new Error(messages.get("traverseVerifyVisitorProperty", nodeType, visitorKey));
		        }
		      }
		    }
		  }
	
		  visitor._verified = true;
		}
	
		function validateVisitorMethods(path, val) {
		  var fns = [].concat(val);
		  for (var _iterator5 = fns, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : (0, _getIterator3.default)(_iterator5);;) {
		    var _ref5;
	
		    if (_isArray5) {
		      if (_i5 >= _iterator5.length) break;
		      _ref5 = _iterator5[_i5++];
		    } else {
		      _i5 = _iterator5.next();
		      if (_i5.done) break;
		      _ref5 = _i5.value;
		    }
	
		    var fn = _ref5;
	
		    if (typeof fn !== "function") {
		      throw new TypeError("Non-function found defined in " + path + " with type " + (typeof fn === "undefined" ? "undefined" : (0, _typeof3.default)(fn)));
		    }
		  }
		}
	
		function merge(visitors) {
		  var states = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
		  var wrapper = arguments[2];
	
		  var rootVisitor = {};
	
		  for (var i = 0; i < visitors.length; i++) {
		    var visitor = visitors[i];
		    var state = states[i];
	
		    explode(visitor);
	
		    for (var type in visitor) {
		      var visitorType = visitor[type];
	
		      if (state || wrapper) {
		        visitorType = wrapWithStateOrWrapper(visitorType, state, wrapper);
		      }
	
		      var nodeVisitor = rootVisitor[type] = rootVisitor[type] || {};
		      mergePair(nodeVisitor, visitorType);
		    }
		  }
	
		  return rootVisitor;
		}
	
		function wrapWithStateOrWrapper(oldVisitor, state, wrapper) {
		  var newVisitor = {};
	
		  var _loop = function _loop(key) {
		    var fns = oldVisitor[key];
	
		    if (!Array.isArray(fns)) return "continue";
	
		    fns = fns.map(function (fn) {
		      var newFn = fn;
	
		      if (state) {
		        newFn = function newFn(path) {
		          return fn.call(state, path, state);
		        };
		      }
	
		      if (wrapper) {
		        newFn = wrapper(state.key, key, newFn);
		      }
	
		      return newFn;
		    });
	
		    newVisitor[key] = fns;
		  };
	
		  for (var key in oldVisitor) {
		    var _ret = _loop(key);
	
		    if (_ret === "continue") continue;
		  }
	
		  return newVisitor;
		}
	
		function ensureEntranceObjects(obj) {
		  for (var key in obj) {
		    if (shouldIgnoreKey(key)) continue;
	
		    var fns = obj[key];
		    if (typeof fns === "function") {
		      obj[key] = { enter: fns };
		    }
		  }
		}
	
		function ensureCallbackArrays(obj) {
		  if (obj.enter && !Array.isArray(obj.enter)) obj.enter = [obj.enter];
		  if (obj.exit && !Array.isArray(obj.exit)) obj.exit = [obj.exit];
		}
	
		function wrapCheck(wrapper, fn) {
		  var newFn = function newFn(path) {
		    if (wrapper.checkPath(path)) {
		      return fn.apply(this, arguments);
		    }
		  };
		  newFn.toString = function () {
		    return fn.toString();
		  };
		  return newFn;
		}
	
		function shouldIgnoreKey(key) {
		  if (key[0] === "_") return true;
	
		  if (key === "enter" || key === "exit" || key === "shouldSkip") return true;
	
		  if (key === "blacklist" || key === "noScope" || key === "skipKeys") return true;
	
		  return false;
		}
	
		function mergePair(dest, src) {
		  for (var key in src) {
		    dest[key] = [].concat(dest[key] || [], src[key]);
		  }
		}
	
	/***/ }),
	/* 385 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _maxSafeInteger = __webpack_require__(359);
	
		var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);
	
		var _stringify = __webpack_require__(35);
	
		var _stringify2 = _interopRequireDefault(_stringify);
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.toComputedKey = toComputedKey;
		exports.toSequenceExpression = toSequenceExpression;
		exports.toKeyAlias = toKeyAlias;
		exports.toIdentifier = toIdentifier;
		exports.toBindingIdentifierName = toBindingIdentifierName;
		exports.toStatement = toStatement;
		exports.toExpression = toExpression;
		exports.toBlock = toBlock;
		exports.valueToNode = valueToNode;
	
		var _isPlainObject = __webpack_require__(275);
	
		var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
		var _isRegExp = __webpack_require__(276);
	
		var _isRegExp2 = _interopRequireDefault(_isRegExp);
	
		var _index = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_index);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function toComputedKey(node) {
		  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : node.key || node.property;
	
		  if (!node.computed) {
		    if (t.isIdentifier(key)) key = t.stringLiteral(key.name);
		  }
		  return key;
		}
	
		function gatherSequenceExpressions(nodes, scope, declars) {
		  var exprs = [];
		  var ensureLastUndefined = true;
	
		  for (var _iterator = nodes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		    var _ref;
	
		    if (_isArray) {
		      if (_i >= _iterator.length) break;
		      _ref = _iterator[_i++];
		    } else {
		      _i = _iterator.next();
		      if (_i.done) break;
		      _ref = _i.value;
		    }
	
		    var node = _ref;
	
		    ensureLastUndefined = false;
	
		    if (t.isExpression(node)) {
		      exprs.push(node);
		    } else if (t.isExpressionStatement(node)) {
		      exprs.push(node.expression);
		    } else if (t.isVariableDeclaration(node)) {
		      if (node.kind !== "var") return;
	
		      for (var _iterator2 = node.declarations, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		        var _ref2;
	
		        if (_isArray2) {
		          if (_i2 >= _iterator2.length) break;
		          _ref2 = _iterator2[_i2++];
		        } else {
		          _i2 = _iterator2.next();
		          if (_i2.done) break;
		          _ref2 = _i2.value;
		        }
	
		        var declar = _ref2;
	
		        var bindings = t.getBindingIdentifiers(declar);
		        for (var key in bindings) {
		          declars.push({
		            kind: node.kind,
		            id: bindings[key]
		          });
		        }
	
		        if (declar.init) {
		          exprs.push(t.assignmentExpression("=", declar.id, declar.init));
		        }
		      }
	
		      ensureLastUndefined = true;
		    } else if (t.isIfStatement(node)) {
		      var consequent = node.consequent ? gatherSequenceExpressions([node.consequent], scope, declars) : scope.buildUndefinedNode();
		      var alternate = node.alternate ? gatherSequenceExpressions([node.alternate], scope, declars) : scope.buildUndefinedNode();
		      if (!consequent || !alternate) return;
	
		      exprs.push(t.conditionalExpression(node.test, consequent, alternate));
		    } else if (t.isBlockStatement(node)) {
		      var body = gatherSequenceExpressions(node.body, scope, declars);
		      if (!body) return;
	
		      exprs.push(body);
		    } else if (t.isEmptyStatement(node)) {
		      ensureLastUndefined = true;
		    } else {
		      return;
		    }
		  }
	
		  if (ensureLastUndefined) {
		    exprs.push(scope.buildUndefinedNode());
		  }
	
		  if (exprs.length === 1) {
		    return exprs[0];
		  } else {
		    return t.sequenceExpression(exprs);
		  }
		}
	
		function toSequenceExpression(nodes, scope) {
		  if (!nodes || !nodes.length) return;
	
		  var declars = [];
		  var result = gatherSequenceExpressions(nodes, scope, declars);
		  if (!result) return;
	
		  for (var _iterator3 = declars, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
		    var _ref3;
	
		    if (_isArray3) {
		      if (_i3 >= _iterator3.length) break;
		      _ref3 = _iterator3[_i3++];
		    } else {
		      _i3 = _iterator3.next();
		      if (_i3.done) break;
		      _ref3 = _i3.value;
		    }
	
		    var declar = _ref3;
	
		    scope.push(declar);
		  }
	
		  return result;
		}
	
		function toKeyAlias(node) {
		  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : node.key;
	
		  var alias = void 0;
	
		  if (node.kind === "method") {
		    return toKeyAlias.increment() + "";
		  } else if (t.isIdentifier(key)) {
		    alias = key.name;
		  } else if (t.isStringLiteral(key)) {
		    alias = (0, _stringify2.default)(key.value);
		  } else {
		    alias = (0, _stringify2.default)(t.removePropertiesDeep(t.cloneDeep(key)));
		  }
	
		  if (node.computed) {
		    alias = "[" + alias + "]";
		  }
	
		  if (node.static) {
		    alias = "static:" + alias;
		  }
	
		  return alias;
		}
	
		toKeyAlias.uid = 0;
	
		toKeyAlias.increment = function () {
		  if (toKeyAlias.uid >= _maxSafeInteger2.default) {
		    return toKeyAlias.uid = 0;
		  } else {
		    return toKeyAlias.uid++;
		  }
		};
	
		function toIdentifier(name) {
		  name = name + "";
	
		  name = name.replace(/[^a-zA-Z0-9$_]/g, "-");
	
		  name = name.replace(/^[-0-9]+/, "");
	
		  name = name.replace(/[-\s]+(.)?/g, function (match, c) {
		    return c ? c.toUpperCase() : "";
		  });
	
		  if (!t.isValidIdentifier(name)) {
		    name = "_" + name;
		  }
	
		  return name || "_";
		}
	
		function toBindingIdentifierName(name) {
		  name = toIdentifier(name);
		  if (name === "eval" || name === "arguments") name = "_" + name;
		  return name;
		}
	
		function toStatement(node, ignore) {
		  if (t.isStatement(node)) {
		    return node;
		  }
	
		  var mustHaveId = false;
		  var newType = void 0;
	
		  if (t.isClass(node)) {
		    mustHaveId = true;
		    newType = "ClassDeclaration";
		  } else if (t.isFunction(node)) {
		    mustHaveId = true;
		    newType = "FunctionDeclaration";
		  } else if (t.isAssignmentExpression(node)) {
		    return t.expressionStatement(node);
		  }
	
		  if (mustHaveId && !node.id) {
		    newType = false;
		  }
	
		  if (!newType) {
		    if (ignore) {
		      return false;
		    } else {
		      throw new Error("cannot turn " + node.type + " to a statement");
		    }
		  }
	
		  node.type = newType;
	
		  return node;
		}
	
		function toExpression(node) {
		  if (t.isExpressionStatement(node)) {
		    node = node.expression;
		  }
	
		  if (t.isExpression(node)) {
		    return node;
		  }
	
		  if (t.isClass(node)) {
		    node.type = "ClassExpression";
		  } else if (t.isFunction(node)) {
		    node.type = "FunctionExpression";
		  }
	
		  if (!t.isExpression(node)) {
		    throw new Error("cannot turn " + node.type + " to an expression");
		  }
	
		  return node;
		}
	
		function toBlock(node, parent) {
		  if (t.isBlockStatement(node)) {
		    return node;
		  }
	
		  if (t.isEmptyStatement(node)) {
		    node = [];
		  }
	
		  if (!Array.isArray(node)) {
		    if (!t.isStatement(node)) {
		      if (t.isFunction(parent)) {
		        node = t.returnStatement(node);
		      } else {
		        node = t.expressionStatement(node);
		      }
		    }
	
		    node = [node];
		  }
	
		  return t.blockStatement(node);
		}
	
		function valueToNode(value) {
		  if (value === undefined) {
		    return t.identifier("undefined");
		  }
	
		  if (value === true || value === false) {
		    return t.booleanLiteral(value);
		  }
	
		  if (value === null) {
		    return t.nullLiteral();
		  }
	
		  if (typeof value === "string") {
		    return t.stringLiteral(value);
		  }
	
		  if (typeof value === "number") {
		    return t.numericLiteral(value);
		  }
	
		  if ((0, _isRegExp2.default)(value)) {
		    var pattern = value.source;
		    var flags = value.toString().match(/\/([a-z]+|)$/)[1];
		    return t.regExpLiteral(pattern, flags);
		  }
	
		  if (Array.isArray(value)) {
		    return t.arrayExpression(value.map(t.valueToNode));
		  }
	
		  if ((0, _isPlainObject2.default)(value)) {
		    var props = [];
		    for (var key in value) {
		      var nodeKey = void 0;
		      if (t.isValidIdentifier(key)) {
		        nodeKey = t.identifier(key);
		      } else {
		        nodeKey = t.stringLiteral(key);
		      }
		      props.push(t.objectProperty(nodeKey, t.valueToNode(value[key])));
		    }
		    return t.objectExpression(props);
		  }
	
		  throw new Error("don't know how to turn this value into a node");
		}
	
	/***/ }),
	/* 386 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _index = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_index);
	
		var _constants = __webpack_require__(135);
	
		var _index2 = __webpack_require__(26);
	
		var _index3 = _interopRequireDefault(_index2);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		(0, _index3.default)("ArrayExpression", {
		  fields: {
		    elements: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeOrValueType)("null", "Expression", "SpreadElement"))),
		      default: []
		    }
		  },
		  visitor: ["elements"],
		  aliases: ["Expression"]
		});
	
		(0, _index3.default)("AssignmentExpression", {
		  fields: {
		    operator: {
		      validate: (0, _index2.assertValueType)("string")
		    },
		    left: {
		      validate: (0, _index2.assertNodeType)("LVal")
		    },
		    right: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    }
		  },
		  builder: ["operator", "left", "right"],
		  visitor: ["left", "right"],
		  aliases: ["Expression"]
		});
	
		(0, _index3.default)("BinaryExpression", {
		  builder: ["operator", "left", "right"],
		  fields: {
		    operator: {
		      validate: _index2.assertOneOf.apply(undefined, _constants.BINARY_OPERATORS)
		    },
		    left: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    },
		    right: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    }
		  },
		  visitor: ["left", "right"],
		  aliases: ["Binary", "Expression"]
		});
	
		(0, _index3.default)("Directive", {
		  visitor: ["value"],
		  fields: {
		    value: {
		      validate: (0, _index2.assertNodeType)("DirectiveLiteral")
		    }
		  }
		});
	
		(0, _index3.default)("DirectiveLiteral", {
		  builder: ["value"],
		  fields: {
		    value: {
		      validate: (0, _index2.assertValueType)("string")
		    }
		  }
		});
	
		(0, _index3.default)("BlockStatement", {
		  builder: ["body", "directives"],
		  visitor: ["directives", "body"],
		  fields: {
		    directives: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Directive"))),
		      default: []
		    },
		    body: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Statement")))
		    }
		  },
		  aliases: ["Scopable", "BlockParent", "Block", "Statement"]
		});
	
		(0, _index3.default)("BreakStatement", {
		  visitor: ["label"],
		  fields: {
		    label: {
		      validate: (0, _index2.assertNodeType)("Identifier"),
		      optional: true
		    }
		  },
		  aliases: ["Statement", "Terminatorless", "CompletionStatement"]
		});
	
		(0, _index3.default)("CallExpression", {
		  visitor: ["callee", "arguments"],
		  fields: {
		    callee: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    },
		    arguments: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Expression", "SpreadElement")))
		    }
		  },
		  aliases: ["Expression"]
		});
	
		(0, _index3.default)("CatchClause", {
		  visitor: ["param", "body"],
		  fields: {
		    param: {
		      validate: (0, _index2.assertNodeType)("Identifier")
		    },
		    body: {
		      validate: (0, _index2.assertNodeType)("BlockStatement")
		    }
		  },
		  aliases: ["Scopable"]
		});
	
		(0, _index3.default)("ConditionalExpression", {
		  visitor: ["test", "consequent", "alternate"],
		  fields: {
		    test: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    },
		    consequent: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    },
		    alternate: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    }
		  },
		  aliases: ["Expression", "Conditional"]
		});
	
		(0, _index3.default)("ContinueStatement", {
		  visitor: ["label"],
		  fields: {
		    label: {
		      validate: (0, _index2.assertNodeType)("Identifier"),
		      optional: true
		    }
		  },
		  aliases: ["Statement", "Terminatorless", "CompletionStatement"]
		});
	
		(0, _index3.default)("DebuggerStatement", {
		  aliases: ["Statement"]
		});
	
		(0, _index3.default)("DoWhileStatement", {
		  visitor: ["test", "body"],
		  fields: {
		    test: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    },
		    body: {
		      validate: (0, _index2.assertNodeType)("Statement")
		    }
		  },
		  aliases: ["Statement", "BlockParent", "Loop", "While", "Scopable"]
		});
	
		(0, _index3.default)("EmptyStatement", {
		  aliases: ["Statement"]
		});
	
		(0, _index3.default)("ExpressionStatement", {
		  visitor: ["expression"],
		  fields: {
		    expression: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    }
		  },
		  aliases: ["Statement", "ExpressionWrapper"]
		});
	
		(0, _index3.default)("File", {
		  builder: ["program", "comments", "tokens"],
		  visitor: ["program"],
		  fields: {
		    program: {
		      validate: (0, _index2.assertNodeType)("Program")
		    }
		  }
		});
	
		(0, _index3.default)("ForInStatement", {
		  visitor: ["left", "right", "body"],
		  aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop", "ForXStatement"],
		  fields: {
		    left: {
		      validate: (0, _index2.assertNodeType)("VariableDeclaration", "LVal")
		    },
		    right: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    },
		    body: {
		      validate: (0, _index2.assertNodeType)("Statement")
		    }
		  }
		});
	
		(0, _index3.default)("ForStatement", {
		  visitor: ["init", "test", "update", "body"],
		  aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop"],
		  fields: {
		    init: {
		      validate: (0, _index2.assertNodeType)("VariableDeclaration", "Expression"),
		      optional: true
		    },
		    test: {
		      validate: (0, _index2.assertNodeType)("Expression"),
		      optional: true
		    },
		    update: {
		      validate: (0, _index2.assertNodeType)("Expression"),
		      optional: true
		    },
		    body: {
		      validate: (0, _index2.assertNodeType)("Statement")
		    }
		  }
		});
	
		(0, _index3.default)("FunctionDeclaration", {
		  builder: ["id", "params", "body", "generator", "async"],
		  visitor: ["id", "params", "body", "returnType", "typeParameters"],
		  fields: {
		    id: {
		      validate: (0, _index2.assertNodeType)("Identifier")
		    },
		    params: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("LVal")))
		    },
		    body: {
		      validate: (0, _index2.assertNodeType)("BlockStatement")
		    },
		    generator: {
		      default: false,
		      validate: (0, _index2.assertValueType)("boolean")
		    },
		    async: {
		      default: false,
		      validate: (0, _index2.assertValueType)("boolean")
		    }
		  },
		  aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Statement", "Pureish", "Declaration"]
		});
	
		(0, _index3.default)("FunctionExpression", {
		  inherits: "FunctionDeclaration",
		  aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Expression", "Pureish"],
		  fields: {
		    id: {
		      validate: (0, _index2.assertNodeType)("Identifier"),
		      optional: true
		    },
		    params: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("LVal")))
		    },
		    body: {
		      validate: (0, _index2.assertNodeType)("BlockStatement")
		    },
		    generator: {
		      default: false,
		      validate: (0, _index2.assertValueType)("boolean")
		    },
		    async: {
		      default: false,
		      validate: (0, _index2.assertValueType)("boolean")
		    }
		  }
		});
	
		(0, _index3.default)("Identifier", {
		  builder: ["name"],
		  visitor: ["typeAnnotation"],
		  aliases: ["Expression", "LVal"],
		  fields: {
		    name: {
		      validate: function validate(node, key, val) {
		        if (!t.isValidIdentifier(val)) {}
		      }
		    },
		    decorators: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Decorator")))
		    }
		  }
		});
	
		(0, _index3.default)("IfStatement", {
		  visitor: ["test", "consequent", "alternate"],
		  aliases: ["Statement", "Conditional"],
		  fields: {
		    test: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    },
		    consequent: {
		      validate: (0, _index2.assertNodeType)("Statement")
		    },
		    alternate: {
		      optional: true,
		      validate: (0, _index2.assertNodeType)("Statement")
		    }
		  }
		});
	
		(0, _index3.default)("LabeledStatement", {
		  visitor: ["label", "body"],
		  aliases: ["Statement"],
		  fields: {
		    label: {
		      validate: (0, _index2.assertNodeType)("Identifier")
		    },
		    body: {
		      validate: (0, _index2.assertNodeType)("Statement")
		    }
		  }
		});
	
		(0, _index3.default)("StringLiteral", {
		  builder: ["value"],
		  fields: {
		    value: {
		      validate: (0, _index2.assertValueType)("string")
		    }
		  },
		  aliases: ["Expression", "Pureish", "Literal", "Immutable"]
		});
	
		(0, _index3.default)("NumericLiteral", {
		  builder: ["value"],
		  deprecatedAlias: "NumberLiteral",
		  fields: {
		    value: {
		      validate: (0, _index2.assertValueType)("number")
		    }
		  },
		  aliases: ["Expression", "Pureish", "Literal", "Immutable"]
		});
	
		(0, _index3.default)("NullLiteral", {
		  aliases: ["Expression", "Pureish", "Literal", "Immutable"]
		});
	
		(0, _index3.default)("BooleanLiteral", {
		  builder: ["value"],
		  fields: {
		    value: {
		      validate: (0, _index2.assertValueType)("boolean")
		    }
		  },
		  aliases: ["Expression", "Pureish", "Literal", "Immutable"]
		});
	
		(0, _index3.default)("RegExpLiteral", {
		  builder: ["pattern", "flags"],
		  deprecatedAlias: "RegexLiteral",
		  aliases: ["Expression", "Literal"],
		  fields: {
		    pattern: {
		      validate: (0, _index2.assertValueType)("string")
		    },
		    flags: {
		      validate: (0, _index2.assertValueType)("string"),
		      default: ""
		    }
		  }
		});
	
		(0, _index3.default)("LogicalExpression", {
		  builder: ["operator", "left", "right"],
		  visitor: ["left", "right"],
		  aliases: ["Binary", "Expression"],
		  fields: {
		    operator: {
		      validate: _index2.assertOneOf.apply(undefined, _constants.LOGICAL_OPERATORS)
		    },
		    left: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    },
		    right: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    }
		  }
		});
	
		(0, _index3.default)("MemberExpression", {
		  builder: ["object", "property", "computed"],
		  visitor: ["object", "property"],
		  aliases: ["Expression", "LVal"],
		  fields: {
		    object: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    },
		    property: {
		      validate: function validate(node, key, val) {
		        var expectedType = node.computed ? "Expression" : "Identifier";
		        (0, _index2.assertNodeType)(expectedType)(node, key, val);
		      }
		    },
		    computed: {
		      default: false
		    }
		  }
		});
	
		(0, _index3.default)("NewExpression", {
		  visitor: ["callee", "arguments"],
		  aliases: ["Expression"],
		  fields: {
		    callee: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    },
		    arguments: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Expression", "SpreadElement")))
		    }
		  }
		});
	
		(0, _index3.default)("Program", {
		  visitor: ["directives", "body"],
		  builder: ["body", "directives"],
		  fields: {
		    directives: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Directive"))),
		      default: []
		    },
		    body: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Statement")))
		    }
		  },
		  aliases: ["Scopable", "BlockParent", "Block", "FunctionParent"]
		});
	
		(0, _index3.default)("ObjectExpression", {
		  visitor: ["properties"],
		  aliases: ["Expression"],
		  fields: {
		    properties: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("ObjectMethod", "ObjectProperty", "SpreadProperty")))
		    }
		  }
		});
	
		(0, _index3.default)("ObjectMethod", {
		  builder: ["kind", "key", "params", "body", "computed"],
		  fields: {
		    kind: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("string"), (0, _index2.assertOneOf)("method", "get", "set")),
		      default: "method"
		    },
		    computed: {
		      validate: (0, _index2.assertValueType)("boolean"),
		      default: false
		    },
		    key: {
		      validate: function validate(node, key, val) {
		        var expectedTypes = node.computed ? ["Expression"] : ["Identifier", "StringLiteral", "NumericLiteral"];
		        _index2.assertNodeType.apply(undefined, expectedTypes)(node, key, val);
		      }
		    },
		    decorators: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Decorator")))
		    },
		    body: {
		      validate: (0, _index2.assertNodeType)("BlockStatement")
		    },
		    generator: {
		      default: false,
		      validate: (0, _index2.assertValueType)("boolean")
		    },
		    async: {
		      default: false,
		      validate: (0, _index2.assertValueType)("boolean")
		    }
		  },
		  visitor: ["key", "params", "body", "decorators", "returnType", "typeParameters"],
		  aliases: ["UserWhitespacable", "Function", "Scopable", "BlockParent", "FunctionParent", "Method", "ObjectMember"]
		});
	
		(0, _index3.default)("ObjectProperty", {
		  builder: ["key", "value", "computed", "shorthand", "decorators"],
		  fields: {
		    computed: {
		      validate: (0, _index2.assertValueType)("boolean"),
		      default: false
		    },
		    key: {
		      validate: function validate(node, key, val) {
		        var expectedTypes = node.computed ? ["Expression"] : ["Identifier", "StringLiteral", "NumericLiteral"];
		        _index2.assertNodeType.apply(undefined, expectedTypes)(node, key, val);
		      }
		    },
		    value: {
		      validate: (0, _index2.assertNodeType)("Expression", "Pattern", "RestElement")
		    },
		    shorthand: {
		      validate: (0, _index2.assertValueType)("boolean"),
		      default: false
		    },
		    decorators: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Decorator"))),
		      optional: true
		    }
		  },
		  visitor: ["key", "value", "decorators"],
		  aliases: ["UserWhitespacable", "Property", "ObjectMember"]
		});
	
		(0, _index3.default)("RestElement", {
		  visitor: ["argument", "typeAnnotation"],
		  aliases: ["LVal"],
		  fields: {
		    argument: {
		      validate: (0, _index2.assertNodeType)("LVal")
		    },
		    decorators: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Decorator")))
		    }
		  }
		});
	
		(0, _index3.default)("ReturnStatement", {
		  visitor: ["argument"],
		  aliases: ["Statement", "Terminatorless", "CompletionStatement"],
		  fields: {
		    argument: {
		      validate: (0, _index2.assertNodeType)("Expression"),
		      optional: true
		    }
		  }
		});
	
		(0, _index3.default)("SequenceExpression", {
		  visitor: ["expressions"],
		  fields: {
		    expressions: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Expression")))
		    }
		  },
		  aliases: ["Expression"]
		});
	
		(0, _index3.default)("SwitchCase", {
		  visitor: ["test", "consequent"],
		  fields: {
		    test: {
		      validate: (0, _index2.assertNodeType)("Expression"),
		      optional: true
		    },
		    consequent: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Statement")))
		    }
		  }
		});
	
		(0, _index3.default)("SwitchStatement", {
		  visitor: ["discriminant", "cases"],
		  aliases: ["Statement", "BlockParent", "Scopable"],
		  fields: {
		    discriminant: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    },
		    cases: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("SwitchCase")))
		    }
		  }
		});
	
		(0, _index3.default)("ThisExpression", {
		  aliases: ["Expression"]
		});
	
		(0, _index3.default)("ThrowStatement", {
		  visitor: ["argument"],
		  aliases: ["Statement", "Terminatorless", "CompletionStatement"],
		  fields: {
		    argument: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    }
		  }
		});
	
		(0, _index3.default)("TryStatement", {
		  visitor: ["block", "handler", "finalizer"],
		  aliases: ["Statement"],
		  fields: {
		    body: {
		      validate: (0, _index2.assertNodeType)("BlockStatement")
		    },
		    handler: {
		      optional: true,
		      handler: (0, _index2.assertNodeType)("BlockStatement")
		    },
		    finalizer: {
		      optional: true,
		      validate: (0, _index2.assertNodeType)("BlockStatement")
		    }
		  }
		});
	
		(0, _index3.default)("UnaryExpression", {
		  builder: ["operator", "argument", "prefix"],
		  fields: {
		    prefix: {
		      default: true
		    },
		    argument: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    },
		    operator: {
		      validate: _index2.assertOneOf.apply(undefined, _constants.UNARY_OPERATORS)
		    }
		  },
		  visitor: ["argument"],
		  aliases: ["UnaryLike", "Expression"]
		});
	
		(0, _index3.default)("UpdateExpression", {
		  builder: ["operator", "argument", "prefix"],
		  fields: {
		    prefix: {
		      default: false
		    },
		    argument: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    },
		    operator: {
		      validate: _index2.assertOneOf.apply(undefined, _constants.UPDATE_OPERATORS)
		    }
		  },
		  visitor: ["argument"],
		  aliases: ["Expression"]
		});
	
		(0, _index3.default)("VariableDeclaration", {
		  builder: ["kind", "declarations"],
		  visitor: ["declarations"],
		  aliases: ["Statement", "Declaration"],
		  fields: {
		    kind: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("string"), (0, _index2.assertOneOf)("var", "let", "const"))
		    },
		    declarations: {
		      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("VariableDeclarator")))
		    }
		  }
		});
	
		(0, _index3.default)("VariableDeclarator", {
		  visitor: ["id", "init"],
		  fields: {
		    id: {
		      validate: (0, _index2.assertNodeType)("LVal")
		    },
		    init: {
		      optional: true,
		      validate: (0, _index2.assertNodeType)("Expression")
		    }
		  }
		});
	
		(0, _index3.default)("WhileStatement", {
		  visitor: ["test", "body"],
		  aliases: ["Statement", "BlockParent", "Loop", "While", "Scopable"],
		  fields: {
		    test: {
		      validate: (0, _index2.assertNodeType)("Expression")
		    },
		    body: {
		      validate: (0, _index2.assertNodeType)("BlockStatement", "Statement")
		    }
		  }
		});
	
		(0, _index3.default)("WithStatement", {
		  visitor: ["object", "body"],
		  aliases: ["Statement"],
		  fields: {
		    object: {
		      object: (0, _index2.assertNodeType)("Expression")
		    },
		    body: {
		      validate: (0, _index2.assertNodeType)("BlockStatement", "Statement")
		    }
		  }
		});
	
	/***/ }),
	/* 387 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _index = __webpack_require__(26);
	
		var _index2 = _interopRequireDefault(_index);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		(0, _index2.default)("AssignmentPattern", {
		  visitor: ["left", "right"],
		  aliases: ["Pattern", "LVal"],
		  fields: {
		    left: {
		      validate: (0, _index.assertNodeType)("Identifier")
		    },
		    right: {
		      validate: (0, _index.assertNodeType)("Expression")
		    },
		    decorators: {
		      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("Decorator")))
		    }
		  }
		});
	
		(0, _index2.default)("ArrayPattern", {
		  visitor: ["elements", "typeAnnotation"],
		  aliases: ["Pattern", "LVal"],
		  fields: {
		    elements: {
		      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("Identifier", "Pattern", "RestElement")))
		    },
		    decorators: {
		      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("Decorator")))
		    }
		  }
		});
	
		(0, _index2.default)("ArrowFunctionExpression", {
		  builder: ["params", "body", "async"],
		  visitor: ["params", "body", "returnType", "typeParameters"],
		  aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Expression", "Pureish"],
		  fields: {
		    params: {
		      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("LVal")))
		    },
		    body: {
		      validate: (0, _index.assertNodeType)("BlockStatement", "Expression")
		    },
		    async: {
		      validate: (0, _index.assertValueType)("boolean"),
		      default: false
		    }
		  }
		});
	
		(0, _index2.default)("ClassBody", {
		  visitor: ["body"],
		  fields: {
		    body: {
		      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("ClassMethod", "ClassProperty")))
		    }
		  }
		});
	
		(0, _index2.default)("ClassDeclaration", {
		  builder: ["id", "superClass", "body", "decorators"],
		  visitor: ["id", "body", "superClass", "mixins", "typeParameters", "superTypeParameters", "implements", "decorators"],
		  aliases: ["Scopable", "Class", "Statement", "Declaration", "Pureish"],
		  fields: {
		    id: {
		      validate: (0, _index.assertNodeType)("Identifier")
		    },
		    body: {
		      validate: (0, _index.assertNodeType)("ClassBody")
		    },
		    superClass: {
		      optional: true,
		      validate: (0, _index.assertNodeType)("Expression")
		    },
		    decorators: {
		      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("Decorator")))
		    }
		  }
		});
	
		(0, _index2.default)("ClassExpression", {
		  inherits: "ClassDeclaration",
		  aliases: ["Scopable", "Class", "Expression", "Pureish"],
		  fields: {
		    id: {
		      optional: true,
		      validate: (0, _index.assertNodeType)("Identifier")
		    },
		    body: {
		      validate: (0, _index.assertNodeType)("ClassBody")
		    },
		    superClass: {
		      optional: true,
		      validate: (0, _index.assertNodeType)("Expression")
		    },
		    decorators: {
		      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("Decorator")))
		    }
		  }
		});
	
		(0, _index2.default)("ExportAllDeclaration", {
		  visitor: ["source"],
		  aliases: ["Statement", "Declaration", "ModuleDeclaration", "ExportDeclaration"],
		  fields: {
		    source: {
		      validate: (0, _index.assertNodeType)("StringLiteral")
		    }
		  }
		});
	
		(0, _index2.default)("ExportDefaultDeclaration", {
		  visitor: ["declaration"],
		  aliases: ["Statement", "Declaration", "ModuleDeclaration", "ExportDeclaration"],
		  fields: {
		    declaration: {
		      validate: (0, _index.assertNodeType)("FunctionDeclaration", "ClassDeclaration", "Expression")
		    }
		  }
		});
	
		(0, _index2.default)("ExportNamedDeclaration", {
		  visitor: ["declaration", "specifiers", "source"],
		  aliases: ["Statement", "Declaration", "ModuleDeclaration", "ExportDeclaration"],
		  fields: {
		    declaration: {
		      validate: (0, _index.assertNodeType)("Declaration"),
		      optional: true
		    },
		    specifiers: {
		      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("ExportSpecifier")))
		    },
		    source: {
		      validate: (0, _index.assertNodeType)("StringLiteral"),
		      optional: true
		    }
		  }
		});
	
		(0, _index2.default)("ExportSpecifier", {
		  visitor: ["local", "exported"],
		  aliases: ["ModuleSpecifier"],
		  fields: {
		    local: {
		      validate: (0, _index.assertNodeType)("Identifier")
		    },
		    exported: {
		      validate: (0, _index.assertNodeType)("Identifier")
		    }
		  }
		});
	
		(0, _index2.default)("ForOfStatement", {
		  visitor: ["left", "right", "body"],
		  aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop", "ForXStatement"],
		  fields: {
		    left: {
		      validate: (0, _index.assertNodeType)("VariableDeclaration", "LVal")
		    },
		    right: {
		      validate: (0, _index.assertNodeType)("Expression")
		    },
		    body: {
		      validate: (0, _index.assertNodeType)("Statement")
		    }
		  }
		});
	
		(0, _index2.default)("ImportDeclaration", {
		  visitor: ["specifiers", "source"],
		  aliases: ["Statement", "Declaration", "ModuleDeclaration"],
		  fields: {
		    specifiers: {
		      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("ImportSpecifier", "ImportDefaultSpecifier", "ImportNamespaceSpecifier")))
		    },
		    source: {
		      validate: (0, _index.assertNodeType)("StringLiteral")
		    }
		  }
		});
	
		(0, _index2.default)("ImportDefaultSpecifier", {
		  visitor: ["local"],
		  aliases: ["ModuleSpecifier"],
		  fields: {
		    local: {
		      validate: (0, _index.assertNodeType)("Identifier")
		    }
		  }
		});
	
		(0, _index2.default)("ImportNamespaceSpecifier", {
		  visitor: ["local"],
		  aliases: ["ModuleSpecifier"],
		  fields: {
		    local: {
		      validate: (0, _index.assertNodeType)("Identifier")
		    }
		  }
		});
	
		(0, _index2.default)("ImportSpecifier", {
		  visitor: ["local", "imported"],
		  aliases: ["ModuleSpecifier"],
		  fields: {
		    local: {
		      validate: (0, _index.assertNodeType)("Identifier")
		    },
		    imported: {
		      validate: (0, _index.assertNodeType)("Identifier")
		    },
		    importKind: {
		      validate: (0, _index.assertOneOf)(null, "type", "typeof")
		    }
		  }
		});
	
		(0, _index2.default)("MetaProperty", {
		  visitor: ["meta", "property"],
		  aliases: ["Expression"],
		  fields: {
		    meta: {
		      validate: (0, _index.assertValueType)("string")
		    },
		    property: {
		      validate: (0, _index.assertValueType)("string")
		    }
		  }
		});
	
		(0, _index2.default)("ClassMethod", {
		  aliases: ["Function", "Scopable", "BlockParent", "FunctionParent", "Method"],
		  builder: ["kind", "key", "params", "body", "computed", "static"],
		  visitor: ["key", "params", "body", "decorators", "returnType", "typeParameters"],
		  fields: {
		    kind: {
		      validate: (0, _index.chain)((0, _index.assertValueType)("string"), (0, _index.assertOneOf)("get", "set", "method", "constructor")),
		      default: "method"
		    },
		    computed: {
		      default: false,
		      validate: (0, _index.assertValueType)("boolean")
		    },
		    static: {
		      default: false,
		      validate: (0, _index.assertValueType)("boolean")
		    },
		    key: {
		      validate: function validate(node, key, val) {
		        var expectedTypes = node.computed ? ["Expression"] : ["Identifier", "StringLiteral", "NumericLiteral"];
		        _index.assertNodeType.apply(undefined, expectedTypes)(node, key, val);
		      }
		    },
		    params: {
		      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("LVal")))
		    },
		    body: {
		      validate: (0, _index.assertNodeType)("BlockStatement")
		    },
		    generator: {
		      default: false,
		      validate: (0, _index.assertValueType)("boolean")
		    },
		    async: {
		      default: false,
		      validate: (0, _index.assertValueType)("boolean")
		    }
		  }
		});
	
		(0, _index2.default)("ObjectPattern", {
		  visitor: ["properties", "typeAnnotation"],
		  aliases: ["Pattern", "LVal"],
		  fields: {
		    properties: {
		      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("RestProperty", "Property")))
		    },
		    decorators: {
		      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("Decorator")))
		    }
		  }
		});
	
		(0, _index2.default)("SpreadElement", {
		  visitor: ["argument"],
		  aliases: ["UnaryLike"],
		  fields: {
		    argument: {
		      validate: (0, _index.assertNodeType)("Expression")
		    }
		  }
		});
	
		(0, _index2.default)("Super", {
		  aliases: ["Expression"]
		});
	
		(0, _index2.default)("TaggedTemplateExpression", {
		  visitor: ["tag", "quasi"],
		  aliases: ["Expression"],
		  fields: {
		    tag: {
		      validate: (0, _index.assertNodeType)("Expression")
		    },
		    quasi: {
		      validate: (0, _index.assertNodeType)("TemplateLiteral")
		    }
		  }
		});
	
		(0, _index2.default)("TemplateElement", {
		  builder: ["value", "tail"],
		  fields: {
		    value: {},
		    tail: {
		      validate: (0, _index.assertValueType)("boolean"),
		      default: false
		    }
		  }
		});
	
		(0, _index2.default)("TemplateLiteral", {
		  visitor: ["quasis", "expressions"],
		  aliases: ["Expression", "Literal"],
		  fields: {
		    quasis: {
		      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("TemplateElement")))
		    },
		    expressions: {
		      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("Expression")))
		    }
		  }
		});
	
		(0, _index2.default)("YieldExpression", {
		  builder: ["argument", "delegate"],
		  visitor: ["argument"],
		  aliases: ["Expression", "Terminatorless"],
		  fields: {
		    delegate: {
		      validate: (0, _index.assertValueType)("boolean"),
		      default: false
		    },
		    argument: {
		      optional: true,
		      validate: (0, _index.assertNodeType)("Expression")
		    }
		  }
		});
	
	/***/ }),
	/* 388 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _index = __webpack_require__(26);
	
		var _index2 = _interopRequireDefault(_index);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		(0, _index2.default)("AwaitExpression", {
		  builder: ["argument"],
		  visitor: ["argument"],
		  aliases: ["Expression", "Terminatorless"],
		  fields: {
		    argument: {
		      validate: (0, _index.assertNodeType)("Expression")
		    }
		  }
		});
	
		(0, _index2.default)("ForAwaitStatement", {
		  visitor: ["left", "right", "body"],
		  aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop", "ForXStatement"],
		  fields: {
		    left: {
		      validate: (0, _index.assertNodeType)("VariableDeclaration", "LVal")
		    },
		    right: {
		      validate: (0, _index.assertNodeType)("Expression")
		    },
		    body: {
		      validate: (0, _index.assertNodeType)("Statement")
		    }
		  }
		});
	
		(0, _index2.default)("BindExpression", {
		  visitor: ["object", "callee"],
		  aliases: ["Expression"],
		  fields: {}
		});
	
		(0, _index2.default)("Import", {
		  aliases: ["Expression"]
		});
	
		(0, _index2.default)("Decorator", {
		  visitor: ["expression"],
		  fields: {
		    expression: {
		      validate: (0, _index.assertNodeType)("Expression")
		    }
		  }
		});
	
		(0, _index2.default)("DoExpression", {
		  visitor: ["body"],
		  aliases: ["Expression"],
		  fields: {
		    body: {
		      validate: (0, _index.assertNodeType)("BlockStatement")
		    }
		  }
		});
	
		(0, _index2.default)("ExportDefaultSpecifier", {
		  visitor: ["exported"],
		  aliases: ["ModuleSpecifier"],
		  fields: {
		    exported: {
		      validate: (0, _index.assertNodeType)("Identifier")
		    }
		  }
		});
	
		(0, _index2.default)("ExportNamespaceSpecifier", {
		  visitor: ["exported"],
		  aliases: ["ModuleSpecifier"],
		  fields: {
		    exported: {
		      validate: (0, _index.assertNodeType)("Identifier")
		    }
		  }
		});
	
		(0, _index2.default)("RestProperty", {
		  visitor: ["argument"],
		  aliases: ["UnaryLike"],
		  fields: {
		    argument: {
		      validate: (0, _index.assertNodeType)("LVal")
		    }
		  }
		});
	
		(0, _index2.default)("SpreadProperty", {
		  visitor: ["argument"],
		  aliases: ["UnaryLike"],
		  fields: {
		    argument: {
		      validate: (0, _index.assertNodeType)("Expression")
		    }
		  }
		});
	
	/***/ }),
	/* 389 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _index = __webpack_require__(26);
	
		var _index2 = _interopRequireDefault(_index);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		(0, _index2.default)("AnyTypeAnnotation", {
		  aliases: ["Flow", "FlowBaseAnnotation"],
		  fields: {}
		});
	
		(0, _index2.default)("ArrayTypeAnnotation", {
		  visitor: ["elementType"],
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("BooleanTypeAnnotation", {
		  aliases: ["Flow", "FlowBaseAnnotation"],
		  fields: {}
		});
	
		(0, _index2.default)("BooleanLiteralTypeAnnotation", {
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("NullLiteralTypeAnnotation", {
		  aliases: ["Flow", "FlowBaseAnnotation"],
		  fields: {}
		});
	
		(0, _index2.default)("ClassImplements", {
		  visitor: ["id", "typeParameters"],
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("ClassProperty", {
		  visitor: ["key", "value", "typeAnnotation", "decorators"],
		  builder: ["key", "value", "typeAnnotation", "decorators", "computed"],
		  aliases: ["Property"],
		  fields: {
		    computed: {
		      validate: (0, _index.assertValueType)("boolean"),
		      default: false
		    }
		  }
		});
	
		(0, _index2.default)("DeclareClass", {
		  visitor: ["id", "typeParameters", "extends", "body"],
		  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
		  fields: {}
		});
	
		(0, _index2.default)("DeclareFunction", {
		  visitor: ["id"],
		  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
		  fields: {}
		});
	
		(0, _index2.default)("DeclareInterface", {
		  visitor: ["id", "typeParameters", "extends", "body"],
		  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
		  fields: {}
		});
	
		(0, _index2.default)("DeclareModule", {
		  visitor: ["id", "body"],
		  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
		  fields: {}
		});
	
		(0, _index2.default)("DeclareModuleExports", {
		  visitor: ["typeAnnotation"],
		  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
		  fields: {}
		});
	
		(0, _index2.default)("DeclareTypeAlias", {
		  visitor: ["id", "typeParameters", "right"],
		  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
		  fields: {}
		});
	
		(0, _index2.default)("DeclareOpaqueType", {
		  visitor: ["id", "typeParameters", "supertype"],
		  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
		  fields: {}
		});
	
		(0, _index2.default)("DeclareVariable", {
		  visitor: ["id"],
		  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
		  fields: {}
		});
	
		(0, _index2.default)("DeclareExportDeclaration", {
		  visitor: ["declaration", "specifiers", "source"],
		  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
		  fields: {}
		});
	
		(0, _index2.default)("ExistentialTypeParam", {
		  aliases: ["Flow"]
		});
	
		(0, _index2.default)("FunctionTypeAnnotation", {
		  visitor: ["typeParameters", "params", "rest", "returnType"],
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("FunctionTypeParam", {
		  visitor: ["name", "typeAnnotation"],
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("GenericTypeAnnotation", {
		  visitor: ["id", "typeParameters"],
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("InterfaceExtends", {
		  visitor: ["id", "typeParameters"],
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("InterfaceDeclaration", {
		  visitor: ["id", "typeParameters", "extends", "body"],
		  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
		  fields: {}
		});
	
		(0, _index2.default)("IntersectionTypeAnnotation", {
		  visitor: ["types"],
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("MixedTypeAnnotation", {
		  aliases: ["Flow", "FlowBaseAnnotation"]
		});
	
		(0, _index2.default)("EmptyTypeAnnotation", {
		  aliases: ["Flow", "FlowBaseAnnotation"]
		});
	
		(0, _index2.default)("NullableTypeAnnotation", {
		  visitor: ["typeAnnotation"],
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("NumericLiteralTypeAnnotation", {
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("NumberTypeAnnotation", {
		  aliases: ["Flow", "FlowBaseAnnotation"],
		  fields: {}
		});
	
		(0, _index2.default)("StringLiteralTypeAnnotation", {
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("StringTypeAnnotation", {
		  aliases: ["Flow", "FlowBaseAnnotation"],
		  fields: {}
		});
	
		(0, _index2.default)("ThisTypeAnnotation", {
		  aliases: ["Flow", "FlowBaseAnnotation"],
		  fields: {}
		});
	
		(0, _index2.default)("TupleTypeAnnotation", {
		  visitor: ["types"],
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("TypeofTypeAnnotation", {
		  visitor: ["argument"],
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("TypeAlias", {
		  visitor: ["id", "typeParameters", "right"],
		  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
		  fields: {}
		});
	
		(0, _index2.default)("OpaqueType", {
		  visitor: ["id", "typeParameters", "impltype", "supertype"],
		  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
		  fields: {}
		});
	
		(0, _index2.default)("TypeAnnotation", {
		  visitor: ["typeAnnotation"],
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("TypeCastExpression", {
		  visitor: ["expression", "typeAnnotation"],
		  aliases: ["Flow", "ExpressionWrapper", "Expression"],
		  fields: {}
		});
	
		(0, _index2.default)("TypeParameter", {
		  visitor: ["bound"],
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("TypeParameterDeclaration", {
		  visitor: ["params"],
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("TypeParameterInstantiation", {
		  visitor: ["params"],
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("ObjectTypeAnnotation", {
		  visitor: ["properties", "indexers", "callProperties"],
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("ObjectTypeCallProperty", {
		  visitor: ["value"],
		  aliases: ["Flow", "UserWhitespacable"],
		  fields: {}
		});
	
		(0, _index2.default)("ObjectTypeIndexer", {
		  visitor: ["id", "key", "value"],
		  aliases: ["Flow", "UserWhitespacable"],
		  fields: {}
		});
	
		(0, _index2.default)("ObjectTypeProperty", {
		  visitor: ["key", "value"],
		  aliases: ["Flow", "UserWhitespacable"],
		  fields: {}
		});
	
		(0, _index2.default)("ObjectTypeSpreadProperty", {
		  visitor: ["argument"],
		  aliases: ["Flow", "UserWhitespacable"],
		  fields: {}
		});
	
		(0, _index2.default)("QualifiedTypeIdentifier", {
		  visitor: ["id", "qualification"],
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("UnionTypeAnnotation", {
		  visitor: ["types"],
		  aliases: ["Flow"],
		  fields: {}
		});
	
		(0, _index2.default)("VoidTypeAnnotation", {
		  aliases: ["Flow", "FlowBaseAnnotation"],
		  fields: {}
		});
	
	/***/ }),
	/* 390 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		__webpack_require__(26);
	
		__webpack_require__(386);
	
		__webpack_require__(387);
	
		__webpack_require__(389);
	
		__webpack_require__(391);
	
		__webpack_require__(392);
	
		__webpack_require__(388);
	
	/***/ }),
	/* 391 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _index = __webpack_require__(26);
	
		var _index2 = _interopRequireDefault(_index);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		(0, _index2.default)("JSXAttribute", {
		  visitor: ["name", "value"],
		  aliases: ["JSX", "Immutable"],
		  fields: {
		    name: {
		      validate: (0, _index.assertNodeType)("JSXIdentifier", "JSXNamespacedName")
		    },
		    value: {
		      optional: true,
		      validate: (0, _index.assertNodeType)("JSXElement", "StringLiteral", "JSXExpressionContainer")
		    }
		  }
		});
	
		(0, _index2.default)("JSXClosingElement", {
		  visitor: ["name"],
		  aliases: ["JSX", "Immutable"],
		  fields: {
		    name: {
		      validate: (0, _index.assertNodeType)("JSXIdentifier", "JSXMemberExpression")
		    }
		  }
		});
	
		(0, _index2.default)("JSXElement", {
		  builder: ["openingElement", "closingElement", "children", "selfClosing"],
		  visitor: ["openingElement", "children", "closingElement"],
		  aliases: ["JSX", "Immutable", "Expression"],
		  fields: {
		    openingElement: {
		      validate: (0, _index.assertNodeType)("JSXOpeningElement")
		    },
		    closingElement: {
		      optional: true,
		      validate: (0, _index.assertNodeType)("JSXClosingElement")
		    },
		    children: {
		      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("JSXText", "JSXExpressionContainer", "JSXSpreadChild", "JSXElement")))
		    }
		  }
		});
	
		(0, _index2.default)("JSXEmptyExpression", {
		  aliases: ["JSX", "Expression"]
		});
	
		(0, _index2.default)("JSXExpressionContainer", {
		  visitor: ["expression"],
		  aliases: ["JSX", "Immutable"],
		  fields: {
		    expression: {
		      validate: (0, _index.assertNodeType)("Expression")
		    }
		  }
		});
	
		(0, _index2.default)("JSXSpreadChild", {
		  visitor: ["expression"],
		  aliases: ["JSX", "Immutable"],
		  fields: {
		    expression: {
		      validate: (0, _index.assertNodeType)("Expression")
		    }
		  }
		});
	
		(0, _index2.default)("JSXIdentifier", {
		  builder: ["name"],
		  aliases: ["JSX", "Expression"],
		  fields: {
		    name: {
		      validate: (0, _index.assertValueType)("string")
		    }
		  }
		});
	
		(0, _index2.default)("JSXMemberExpression", {
		  visitor: ["object", "property"],
		  aliases: ["JSX", "Expression"],
		  fields: {
		    object: {
		      validate: (0, _index.assertNodeType)("JSXMemberExpression", "JSXIdentifier")
		    },
		    property: {
		      validate: (0, _index.assertNodeType)("JSXIdentifier")
		    }
		  }
		});
	
		(0, _index2.default)("JSXNamespacedName", {
		  visitor: ["namespace", "name"],
		  aliases: ["JSX"],
		  fields: {
		    namespace: {
		      validate: (0, _index.assertNodeType)("JSXIdentifier")
		    },
		    name: {
		      validate: (0, _index.assertNodeType)("JSXIdentifier")
		    }
		  }
		});
	
		(0, _index2.default)("JSXOpeningElement", {
		  builder: ["name", "attributes", "selfClosing"],
		  visitor: ["name", "attributes"],
		  aliases: ["JSX", "Immutable"],
		  fields: {
		    name: {
		      validate: (0, _index.assertNodeType)("JSXIdentifier", "JSXMemberExpression")
		    },
		    selfClosing: {
		      default: false,
		      validate: (0, _index.assertValueType)("boolean")
		    },
		    attributes: {
		      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("JSXAttribute", "JSXSpreadAttribute")))
		    }
		  }
		});
	
		(0, _index2.default)("JSXSpreadAttribute", {
		  visitor: ["argument"],
		  aliases: ["JSX"],
		  fields: {
		    argument: {
		      validate: (0, _index.assertNodeType)("Expression")
		    }
		  }
		});
	
		(0, _index2.default)("JSXText", {
		  aliases: ["JSX", "Immutable"],
		  builder: ["value"],
		  fields: {
		    value: {
		      validate: (0, _index.assertValueType)("string")
		    }
		  }
		});
	
	/***/ }),
	/* 392 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _index = __webpack_require__(26);
	
		var _index2 = _interopRequireDefault(_index);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		(0, _index2.default)("Noop", {
		  visitor: []
		});
	
		(0, _index2.default)("ParenthesizedExpression", {
		  visitor: ["expression"],
		  aliases: ["Expression", "ExpressionWrapper"],
		  fields: {
		    expression: {
		      validate: (0, _index.assertNodeType)("Expression")
		    }
		  }
		});
	
	/***/ }),
	/* 393 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.createUnionTypeAnnotation = createUnionTypeAnnotation;
		exports.removeTypeDuplicates = removeTypeDuplicates;
		exports.createTypeAnnotationBasedOnTypeof = createTypeAnnotationBasedOnTypeof;
	
		var _index = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_index);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function createUnionTypeAnnotation(types) {
		  var flattened = removeTypeDuplicates(types);
	
		  if (flattened.length === 1) {
		    return flattened[0];
		  } else {
		    return t.unionTypeAnnotation(flattened);
		  }
		}
	
		function removeTypeDuplicates(nodes) {
		  var generics = {};
		  var bases = {};
	
		  var typeGroups = [];
	
		  var types = [];
	
		  for (var i = 0; i < nodes.length; i++) {
		    var node = nodes[i];
		    if (!node) continue;
	
		    if (types.indexOf(node) >= 0) {
		      continue;
		    }
	
		    if (t.isAnyTypeAnnotation(node)) {
		      return [node];
		    }
	
		    if (t.isFlowBaseAnnotation(node)) {
		      bases[node.type] = node;
		      continue;
		    }
	
		    if (t.isUnionTypeAnnotation(node)) {
		      if (typeGroups.indexOf(node.types) < 0) {
		        nodes = nodes.concat(node.types);
		        typeGroups.push(node.types);
		      }
		      continue;
		    }
	
		    if (t.isGenericTypeAnnotation(node)) {
		      var name = node.id.name;
	
		      if (generics[name]) {
		        var existing = generics[name];
		        if (existing.typeParameters) {
		          if (node.typeParameters) {
		            existing.typeParameters.params = removeTypeDuplicates(existing.typeParameters.params.concat(node.typeParameters.params));
		          }
		        } else {
		          existing = node.typeParameters;
		        }
		      } else {
		        generics[name] = node;
		      }
	
		      continue;
		    }
	
		    types.push(node);
		  }
	
		  for (var type in bases) {
		    types.push(bases[type]);
		  }
	
		  for (var _name in generics) {
		    types.push(generics[_name]);
		  }
	
		  return types;
		}
	
		function createTypeAnnotationBasedOnTypeof(type) {
		  if (type === "string") {
		    return t.stringTypeAnnotation();
		  } else if (type === "number") {
		    return t.numberTypeAnnotation();
		  } else if (type === "undefined") {
		    return t.voidTypeAnnotation();
		  } else if (type === "boolean") {
		    return t.booleanTypeAnnotation();
		  } else if (type === "function") {
		    return t.genericTypeAnnotation(t.identifier("Function"));
		  } else if (type === "object") {
		    return t.genericTypeAnnotation(t.identifier("Object"));
		  } else if (type === "symbol") {
		    return t.genericTypeAnnotation(t.identifier("Symbol"));
		  } else {
		    throw new Error("Invalid typeof value");
		  }
		}
	
	/***/ }),
	/* 394 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.isReactComponent = undefined;
		exports.isCompatTag = isCompatTag;
		exports.buildChildren = buildChildren;
	
		var _index = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_index);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		var isReactComponent = exports.isReactComponent = t.buildMatchMemberExpression("React.Component");
	
		function isCompatTag(tagName) {
		  return !!tagName && /^[a-z]|\-/.test(tagName);
		}
	
		function cleanJSXElementLiteralChild(child, args) {
		  var lines = child.value.split(/\r\n|\n|\r/);
	
		  var lastNonEmptyLine = 0;
	
		  for (var i = 0; i < lines.length; i++) {
		    if (lines[i].match(/[^ \t]/)) {
		      lastNonEmptyLine = i;
		    }
		  }
	
		  var str = "";
	
		  for (var _i = 0; _i < lines.length; _i++) {
		    var line = lines[_i];
	
		    var isFirstLine = _i === 0;
		    var isLastLine = _i === lines.length - 1;
		    var isLastNonEmptyLine = _i === lastNonEmptyLine;
	
		    var trimmedLine = line.replace(/\t/g, " ");
	
		    if (!isFirstLine) {
		      trimmedLine = trimmedLine.replace(/^[ ]+/, "");
		    }
	
		    if (!isLastLine) {
		      trimmedLine = trimmedLine.replace(/[ ]+$/, "");
		    }
	
		    if (trimmedLine) {
		      if (!isLastNonEmptyLine) {
		        trimmedLine += " ";
		      }
	
		      str += trimmedLine;
		    }
		  }
	
		  if (str) args.push(t.stringLiteral(str));
		}
	
		function buildChildren(node) {
		  var elems = [];
	
		  for (var i = 0; i < node.children.length; i++) {
		    var child = node.children[i];
	
		    if (t.isJSXText(child)) {
		      cleanJSXElementLiteralChild(child, elems);
		      continue;
		    }
	
		    if (t.isJSXExpressionContainer(child)) child = child.expression;
		    if (t.isJSXEmptyExpression(child)) continue;
	
		    elems.push(child);
		  }
	
		  return elems;
		}
	
	/***/ }),
	/* 395 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		var _keys = __webpack_require__(14);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _typeof2 = __webpack_require__(11);
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		var _getIterator2 = __webpack_require__(2);
	
		var _getIterator3 = _interopRequireDefault(_getIterator2);
	
		exports.isBinding = isBinding;
		exports.isReferenced = isReferenced;
		exports.isValidIdentifier = isValidIdentifier;
		exports.isLet = isLet;
		exports.isBlockScoped = isBlockScoped;
		exports.isVar = isVar;
		exports.isSpecifierDefault = isSpecifierDefault;
		exports.isScope = isScope;
		exports.isImmutable = isImmutable;
		exports.isNodesEquivalent = isNodesEquivalent;
	
		var _retrievers = __webpack_require__(226);
	
		var _esutils = __webpack_require__(97);
	
		var _esutils2 = _interopRequireDefault(_esutils);
	
		var _index = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_index);
	
		var _constants = __webpack_require__(135);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function isBinding(node, parent) {
		  var keys = _retrievers.getBindingIdentifiers.keys[parent.type];
		  if (keys) {
		    for (var i = 0; i < keys.length; i++) {
		      var key = keys[i];
		      var val = parent[key];
		      if (Array.isArray(val)) {
		        if (val.indexOf(node) >= 0) return true;
		      } else {
		        if (val === node) return true;
		      }
		    }
		  }
	
		  return false;
		}
	
		function isReferenced(node, parent) {
		  switch (parent.type) {
		    case "BindExpression":
		      return parent.object === node || parent.callee === node;
	
		    case "MemberExpression":
		    case "JSXMemberExpression":
		      if (parent.property === node && parent.computed) {
		        return true;
		      } else if (parent.object === node) {
		        return true;
		      } else {
		        return false;
		      }
	
		    case "MetaProperty":
		      return false;
	
		    case "ObjectProperty":
		      if (parent.key === node) {
		        return parent.computed;
		      }
	
		    case "VariableDeclarator":
		      return parent.id !== node;
	
		    case "ArrowFunctionExpression":
		    case "FunctionDeclaration":
		    case "FunctionExpression":
		      for (var _iterator = parent.params, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		        var _ref;
	
		        if (_isArray) {
		          if (_i >= _iterator.length) break;
		          _ref = _iterator[_i++];
		        } else {
		          _i = _iterator.next();
		          if (_i.done) break;
		          _ref = _i.value;
		        }
	
		        var param = _ref;
	
		        if (param === node) return false;
		      }
	
		      return parent.id !== node;
	
		    case "ExportSpecifier":
		      if (parent.source) {
		        return false;
		      } else {
		        return parent.local === node;
		      }
	
		    case "ExportNamespaceSpecifier":
		    case "ExportDefaultSpecifier":
		      return false;
	
		    case "JSXAttribute":
		      return parent.name !== node;
	
		    case "ClassProperty":
		      if (parent.key === node) {
		        return parent.computed;
		      } else {
		        return parent.value === node;
		      }
	
		    case "ImportDefaultSpecifier":
		    case "ImportNamespaceSpecifier":
		    case "ImportSpecifier":
		      return false;
	
		    case "ClassDeclaration":
		    case "ClassExpression":
		      return parent.id !== node;
	
		    case "ClassMethod":
		    case "ObjectMethod":
		      return parent.key === node && parent.computed;
	
		    case "LabeledStatement":
		      return false;
	
		    case "CatchClause":
		      return parent.param !== node;
	
		    case "RestElement":
		      return false;
	
		    case "AssignmentExpression":
		      return parent.right === node;
	
		    case "AssignmentPattern":
		      return parent.right === node;
	
		    case "ObjectPattern":
		    case "ArrayPattern":
		      return false;
		  }
	
		  return true;
		}
	
		function isValidIdentifier(name) {
		  if (typeof name !== "string" || _esutils2.default.keyword.isReservedWordES6(name, true)) {
		    return false;
		  } else if (name === "await") {
		    return false;
		  } else {
		    return _esutils2.default.keyword.isIdentifierNameES6(name);
		  }
		}
	
		function isLet(node) {
		  return t.isVariableDeclaration(node) && (node.kind !== "var" || node[_constants.BLOCK_SCOPED_SYMBOL]);
		}
	
		function isBlockScoped(node) {
		  return t.isFunctionDeclaration(node) || t.isClassDeclaration(node) || t.isLet(node);
		}
	
		function isVar(node) {
		  return t.isVariableDeclaration(node, { kind: "var" }) && !node[_constants.BLOCK_SCOPED_SYMBOL];
		}
	
		function isSpecifierDefault(specifier) {
		  return t.isImportDefaultSpecifier(specifier) || t.isIdentifier(specifier.imported || specifier.exported, { name: "default" });
		}
	
		function isScope(node, parent) {
		  if (t.isBlockStatement(node) && t.isFunction(parent, { body: node })) {
		    return false;
		  }
	
		  return t.isScopable(node);
		}
	
		function isImmutable(node) {
		  if (t.isType(node.type, "Immutable")) return true;
	
		  if (t.isIdentifier(node)) {
		    if (node.name === "undefined") {
		      return true;
		    } else {
		      return false;
		    }
		  }
	
		  return false;
		}
	
		function isNodesEquivalent(a, b) {
		  if ((typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) !== "object" || (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) !== "object" || a == null || b == null) {
		    return a === b;
		  }
	
		  if (a.type !== b.type) {
		    return false;
		  }
	
		  var fields = (0, _keys2.default)(t.NODE_FIELDS[a.type] || a.type);
	
		  for (var _iterator2 = fields, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
		    var _ref2;
	
		    if (_isArray2) {
		      if (_i2 >= _iterator2.length) break;
		      _ref2 = _iterator2[_i2++];
		    } else {
		      _i2 = _iterator2.next();
		      if (_i2.done) break;
		      _ref2 = _i2.value;
		    }
	
		    var field = _ref2;
	
		    if ((0, _typeof3.default)(a[field]) !== (0, _typeof3.default)(b[field])) {
		      return false;
		    }
	
		    if (Array.isArray(a[field])) {
		      if (!Array.isArray(b[field])) {
		        return false;
		      }
		      if (a[field].length !== b[field].length) {
		        return false;
		      }
	
		      for (var i = 0; i < a[field].length; i++) {
		        if (!isNodesEquivalent(a[field][i], b[field][i])) {
		          return false;
		        }
		      }
		      continue;
		    }
	
		    if (!isNodesEquivalent(a[field], b[field])) {
		      return false;
		    }
		  }
	
		  return true;
		}
	
	/***/ }),
	/* 396 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		module.exports = balanced;
		function balanced(a, b, str) {
		  if (a instanceof RegExp) a = maybeMatch(a, str);
		  if (b instanceof RegExp) b = maybeMatch(b, str);
	
		  var r = range(a, b, str);
	
		  return r && {
		    start: r[0],
		    end: r[1],
		    pre: str.slice(0, r[0]),
		    body: str.slice(r[0] + a.length, r[1]),
		    post: str.slice(r[1] + b.length)
		  };
		}
	
		function maybeMatch(reg, str) {
		  var m = str.match(reg);
		  return m ? m[0] : null;
		}
	
		balanced.range = range;
		function range(a, b, str) {
		  var begs, beg, left, right, result;
		  var ai = str.indexOf(a);
		  var bi = str.indexOf(b, ai + 1);
		  var i = ai;
	
		  if (ai >= 0 && bi > 0) {
		    begs = [];
		    left = str.length;
	
		    while (i >= 0 && !result) {
		      if (i == ai) {
		        begs.push(i);
		        ai = str.indexOf(a, i + 1);
		      } else if (begs.length == 1) {
		        result = [begs.pop(), bi];
		      } else {
		        beg = begs.pop();
		        if (beg < left) {
		          left = beg;
		          right = bi;
		        }
	
		        bi = str.indexOf(b, i + 1);
		      }
	
		      i = ai < bi && ai >= 0 ? ai : bi;
		    }
	
		    if (begs.length) {
		      result = [left, right];
		    }
		  }
	
		  return result;
		}
	
	/***/ }),
	/* 397 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		exports.byteLength = byteLength;
		exports.toByteArray = toByteArray;
		exports.fromByteArray = fromByteArray;
	
		var lookup = [];
		var revLookup = [];
		var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
	
		var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
		for (var i = 0, len = code.length; i < len; ++i) {
		  lookup[i] = code[i];
		  revLookup[code.charCodeAt(i)] = i;
		}
	
		revLookup['-'.charCodeAt(0)] = 62;
		revLookup['_'.charCodeAt(0)] = 63;
	
		function placeHoldersCount(b64) {
		  var len = b64.length;
		  if (len % 4 > 0) {
		    throw new Error('Invalid string. Length must be a multiple of 4');
		  }
	
		  // the number of equal signs (place holders)
		  // if there are two placeholders, than the two characters before it
		  // represent one byte
		  // if there is only one, then the three characters before it represent 2 bytes
		  // this is just a cheap hack to not do indexOf twice
		  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;
		}
	
		function byteLength(b64) {
		  // base64 is 4/3 + up to two characters of the original data
		  return b64.length * 3 / 4 - placeHoldersCount(b64);
		}
	
		function toByteArray(b64) {
		  var i, l, tmp, placeHolders, arr;
		  var len = b64.length;
		  placeHolders = placeHoldersCount(b64);
	
		  arr = new Arr(len * 3 / 4 - placeHolders);
	
		  // if there are placeholders, only get up to the last complete 4 chars
		  l = placeHolders > 0 ? len - 4 : len;
	
		  var L = 0;
	
		  for (i = 0; i < l; i += 4) {
		    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
		    arr[L++] = tmp >> 16 & 0xFF;
		    arr[L++] = tmp >> 8 & 0xFF;
		    arr[L++] = tmp & 0xFF;
		  }
	
		  if (placeHolders === 2) {
		    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
		    arr[L++] = tmp & 0xFF;
		  } else if (placeHolders === 1) {
		    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
		    arr[L++] = tmp >> 8 & 0xFF;
		    arr[L++] = tmp & 0xFF;
		  }
	
		  return arr;
		}
	
		function tripletToBase64(num) {
		  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
		}
	
		function encodeChunk(uint8, start, end) {
		  var tmp;
		  var output = [];
		  for (var i = start; i < end; i += 3) {
		    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
		    output.push(tripletToBase64(tmp));
		  }
		  return output.join('');
		}
	
		function fromByteArray(uint8) {
		  var tmp;
		  var len = uint8.length;
		  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
		  var output = '';
		  var parts = [];
		  var maxChunkLength = 16383; // must be multiple of 3
	
		  // go through the array every three bytes, we'll deal with trailing stuff later
		  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
		    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
		  }
	
		  // pad the end with zeros, but make sure to not forget the extra bytes
		  if (extraBytes === 1) {
		    tmp = uint8[len - 1];
		    output += lookup[tmp >> 2];
		    output += lookup[tmp << 4 & 0x3F];
		    output += '==';
		  } else if (extraBytes === 2) {
		    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
		    output += lookup[tmp >> 10];
		    output += lookup[tmp >> 4 & 0x3F];
		    output += lookup[tmp << 2 & 0x3F];
		    output += '=';
		  }
	
		  parts.push(output);
	
		  return parts.join('');
		}
	
	/***/ }),
	/* 398 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var concatMap = __webpack_require__(402);
		var balanced = __webpack_require__(396);
	
		module.exports = expandTop;
	
		var escSlash = '\0SLASH' + Math.random() + '\0';
		var escOpen = '\0OPEN' + Math.random() + '\0';
		var escClose = '\0CLOSE' + Math.random() + '\0';
		var escComma = '\0COMMA' + Math.random() + '\0';
		var escPeriod = '\0PERIOD' + Math.random() + '\0';
	
		function numeric(str) {
		  return parseInt(str, 10) == str ? parseInt(str, 10) : str.charCodeAt(0);
		}
	
		function escapeBraces(str) {
		  return str.split('\\\\').join(escSlash).split('\\{').join(escOpen).split('\\}').join(escClose).split('\\,').join(escComma).split('\\.').join(escPeriod);
		}
	
		function unescapeBraces(str) {
		  return str.split(escSlash).join('\\').split(escOpen).join('{').split(escClose).join('}').split(escComma).join(',').split(escPeriod).join('.');
		}
	
		// Basically just str.split(","), but handling cases
		// where we have nested braced sections, which should be
		// treated as individual members, like {a,{b,c},d}
		function parseCommaParts(str) {
		  if (!str) return [''];
	
		  var parts = [];
		  var m = balanced('{', '}', str);
	
		  if (!m) return str.split(',');
	
		  var pre = m.pre;
		  var body = m.body;
		  var post = m.post;
		  var p = pre.split(',');
	
		  p[p.length - 1] += '{' + body + '}';
		  var postParts = parseCommaParts(post);
		  if (post.length) {
		    p[p.length - 1] += postParts.shift();
		    p.push.apply(p, postParts);
		  }
	
		  parts.push.apply(parts, p);
	
		  return parts;
		}
	
		function expandTop(str) {
		  if (!str) return [];
	
		  // I don't know why Bash 4.3 does this, but it does.
		  // Anything starting with {} will have the first two bytes preserved
		  // but *only* at the top level, so {},a}b will not expand to anything,
		  // but a{},b}c will be expanded to [a}c,abc].
		  // One could argue that this is a bug in Bash, but since the goal of
		  // this module is to match Bash's rules, we escape a leading {}
		  if (str.substr(0, 2) === '{}') {
		    str = '\\{\\}' + str.substr(2);
		  }
	
		  return expand(escapeBraces(str), true).map(unescapeBraces);
		}
	
		function identity(e) {
		  return e;
		}
	
		function embrace(str) {
		  return '{' + str + '}';
		}
		function isPadded(el) {
		  return (/^-?0\d/.test(el)
		  );
		}
	
		function lte(i, y) {
		  return i <= y;
		}
		function gte(i, y) {
		  return i >= y;
		}
	
		function expand(str, isTop) {
		  var expansions = [];
	
		  var m = balanced('{', '}', str);
		  if (!m || /\$$/.test(m.pre)) return [str];
	
		  var isNumericSequence = /^-?\d+\.\.-?\d+(?:\.\.-?\d+)?$/.test(m.body);
		  var isAlphaSequence = /^[a-zA-Z]\.\.[a-zA-Z](?:\.\.-?\d+)?$/.test(m.body);
		  var isSequence = isNumericSequence || isAlphaSequence;
		  var isOptions = m.body.indexOf(',') >= 0;
		  if (!isSequence && !isOptions) {
		    // {a},b}
		    if (m.post.match(/,.*\}/)) {
		      str = m.pre + '{' + m.body + escClose + m.post;
		      return expand(str);
		    }
		    return [str];
		  }
	
		  var n;
		  if (isSequence) {
		    n = m.body.split(/\.\./);
		  } else {
		    n = parseCommaParts(m.body);
		    if (n.length === 1) {
		      // x{{a,b}}y ==> x{a}y x{b}y
		      n = expand(n[0], false).map(embrace);
		      if (n.length === 1) {
		        var post = m.post.length ? expand(m.post, false) : [''];
		        return post.map(function (p) {
		          return m.pre + n[0] + p;
		        });
		      }
		    }
		  }
	
		  // at this point, n is the parts, and we know it's not a comma set
		  // with a single entry.
	
		  // no need to expand pre, since it is guaranteed to be free of brace-sets
		  var pre = m.pre;
		  var post = m.post.length ? expand(m.post, false) : [''];
	
		  var N;
	
		  if (isSequence) {
		    var x = numeric(n[0]);
		    var y = numeric(n[1]);
		    var width = Math.max(n[0].length, n[1].length);
		    var incr = n.length == 3 ? Math.abs(numeric(n[2])) : 1;
		    var test = lte;
		    var reverse = y < x;
		    if (reverse) {
		      incr *= -1;
		      test = gte;
		    }
		    var pad = n.some(isPadded);
	
		    N = [];
	
		    for (var i = x; test(i, y); i += incr) {
		      var c;
		      if (isAlphaSequence) {
		        c = String.fromCharCode(i);
		        if (c === '\\') c = '';
		      } else {
		        c = String(i);
		        if (pad) {
		          var need = width - c.length;
		          if (need > 0) {
		            var z = new Array(need + 1).join('0');
		            if (i < 0) c = '-' + z + c.slice(1);else c = z + c;
		          }
		        }
		      }
		      N.push(c);
		    }
		  } else {
		    N = concatMap(n, function (el) {
		      return expand(el, false);
		    });
		  }
	
		  for (var j = 0; j < N.length; j++) {
		    for (var k = 0; k < post.length; k++) {
		      var expansion = pre + N[j] + post[k];
		      if (!isTop || isSequence || expansion) expansions.push(expansion);
		    }
		  }
	
		  return expansions;
		}
	
	/***/ }),
	/* 399 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(global) {/*!
		 * The buffer module from node.js, for the browser.
		 *
		 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
		 * @license  MIT
		 */
		/* eslint-disable no-proto */
	
		'use strict';
	
		var base64 = __webpack_require__(397);
		var ieee754 = __webpack_require__(465);
		var isArray = __webpack_require__(400);
	
		exports.Buffer = Buffer;
		exports.SlowBuffer = SlowBuffer;
		exports.INSPECT_MAX_BYTES = 50;
	
		/**
		 * If `Buffer.TYPED_ARRAY_SUPPORT`:
		 *   === true    Use Uint8Array implementation (fastest)
		 *   === false   Use Object implementation (most compatible, even IE6)
		 *
		 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
		 * Opera 11.6+, iOS 4.2+.
		 *
		 * Due to various browser bugs, sometimes the Object implementation will be used even
		 * when the browser supports typed arrays.
		 *
		 * Note:
		 *
		 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
		 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
		 *
		 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
		 *
		 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
		 *     incorrect length in some situations.
	
		 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
		 * get the Object implementation, which is slower but behaves correctly.
		 */
		Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
	
		/*
		 * Export kMaxLength after typed array support is determined.
		 */
		exports.kMaxLength = kMaxLength();
	
		function typedArraySupport() {
		  try {
		    var arr = new Uint8Array(1);
		    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function foo() {
		        return 42;
		      } };
		    return arr.foo() === 42 && // typed array instances can be augmented
		    typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
		    arr.subarray(1, 1).byteLength === 0; // ie10 has broken `subarray`
		  } catch (e) {
		    return false;
		  }
		}
	
		function kMaxLength() {
		  return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
		}
	
		function createBuffer(that, length) {
		  if (kMaxLength() < length) {
		    throw new RangeError('Invalid typed array length');
		  }
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    // Return an augmented `Uint8Array` instance, for best performance
		    that = new Uint8Array(length);
		    that.__proto__ = Buffer.prototype;
		  } else {
		    // Fallback: Return an object instance of the Buffer class
		    if (that === null) {
		      that = new Buffer(length);
		    }
		    that.length = length;
		  }
	
		  return that;
		}
	
		/**
		 * The Buffer constructor returns instances of `Uint8Array` that have their
		 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
		 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
		 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
		 * returns a single octet.
		 *
		 * The `Uint8Array` prototype remains unmodified.
		 */
	
		function Buffer(arg, encodingOrOffset, length) {
		  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
		    return new Buffer(arg, encodingOrOffset, length);
		  }
	
		  // Common case.
		  if (typeof arg === 'number') {
		    if (typeof encodingOrOffset === 'string') {
		      throw new Error('If encoding is specified then the first argument must be a string');
		    }
		    return allocUnsafe(this, arg);
		  }
		  return from(this, arg, encodingOrOffset, length);
		}
	
		Buffer.poolSize = 8192; // not used by this implementation
	
		// TODO: Legacy, not needed anymore. Remove in next major version.
		Buffer._augment = function (arr) {
		  arr.__proto__ = Buffer.prototype;
		  return arr;
		};
	
		function from(that, value, encodingOrOffset, length) {
		  if (typeof value === 'number') {
		    throw new TypeError('"value" argument must not be a number');
		  }
	
		  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
		    return fromArrayBuffer(that, value, encodingOrOffset, length);
		  }
	
		  if (typeof value === 'string') {
		    return fromString(that, value, encodingOrOffset);
		  }
	
		  return fromObject(that, value);
		}
	
		/**
		 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
		 * if value is a number.
		 * Buffer.from(str[, encoding])
		 * Buffer.from(array)
		 * Buffer.from(buffer)
		 * Buffer.from(arrayBuffer[, byteOffset[, length]])
		 **/
		Buffer.from = function (value, encodingOrOffset, length) {
		  return from(null, value, encodingOrOffset, length);
		};
	
		if (Buffer.TYPED_ARRAY_SUPPORT) {
		  Buffer.prototype.__proto__ = Uint8Array.prototype;
		  Buffer.__proto__ = Uint8Array;
		  if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
		    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
		    Object.defineProperty(Buffer, Symbol.species, {
		      value: null,
		      configurable: true
		    });
		  }
		}
	
		function assertSize(size) {
		  if (typeof size !== 'number') {
		    throw new TypeError('"size" argument must be a number');
		  } else if (size < 0) {
		    throw new RangeError('"size" argument must not be negative');
		  }
		}
	
		function alloc(that, size, fill, encoding) {
		  assertSize(size);
		  if (size <= 0) {
		    return createBuffer(that, size);
		  }
		  if (fill !== undefined) {
		    // Only pay attention to encoding if it's a string. This
		    // prevents accidentally sending in a number that would
		    // be interpretted as a start offset.
		    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
		  }
		  return createBuffer(that, size);
		}
	
		/**
		 * Creates a new filled Buffer instance.
		 * alloc(size[, fill[, encoding]])
		 **/
		Buffer.alloc = function (size, fill, encoding) {
		  return alloc(null, size, fill, encoding);
		};
	
		function allocUnsafe(that, size) {
		  assertSize(size);
		  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
		  if (!Buffer.TYPED_ARRAY_SUPPORT) {
		    for (var i = 0; i < size; ++i) {
		      that[i] = 0;
		    }
		  }
		  return that;
		}
	
		/**
		 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
		 * */
		Buffer.allocUnsafe = function (size) {
		  return allocUnsafe(null, size);
		};
		/**
		 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
		 */
		Buffer.allocUnsafeSlow = function (size) {
		  return allocUnsafe(null, size);
		};
	
		function fromString(that, string, encoding) {
		  if (typeof encoding !== 'string' || encoding === '') {
		    encoding = 'utf8';
		  }
	
		  if (!Buffer.isEncoding(encoding)) {
		    throw new TypeError('"encoding" must be a valid string encoding');
		  }
	
		  var length = byteLength(string, encoding) | 0;
		  that = createBuffer(that, length);
	
		  var actual = that.write(string, encoding);
	
		  if (actual !== length) {
		    // Writing a hex string, for example, that contains invalid characters will
		    // cause everything after the first invalid character to be ignored. (e.g.
		    // 'abxxcd' will be treated as 'ab')
		    that = that.slice(0, actual);
		  }
	
		  return that;
		}
	
		function fromArrayLike(that, array) {
		  var length = array.length < 0 ? 0 : checked(array.length) | 0;
		  that = createBuffer(that, length);
		  for (var i = 0; i < length; i += 1) {
		    that[i] = array[i] & 255;
		  }
		  return that;
		}
	
		function fromArrayBuffer(that, array, byteOffset, length) {
		  array.byteLength; // this throws if `array` is not a valid ArrayBuffer
	
		  if (byteOffset < 0 || array.byteLength < byteOffset) {
		    throw new RangeError('\'offset\' is out of bounds');
		  }
	
		  if (array.byteLength < byteOffset + (length || 0)) {
		    throw new RangeError('\'length\' is out of bounds');
		  }
	
		  if (byteOffset === undefined && length === undefined) {
		    array = new Uint8Array(array);
		  } else if (length === undefined) {
		    array = new Uint8Array(array, byteOffset);
		  } else {
		    array = new Uint8Array(array, byteOffset, length);
		  }
	
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    // Return an augmented `Uint8Array` instance, for best performance
		    that = array;
		    that.__proto__ = Buffer.prototype;
		  } else {
		    // Fallback: Return an object instance of the Buffer class
		    that = fromArrayLike(that, array);
		  }
		  return that;
		}
	
		function fromObject(that, obj) {
		  if (Buffer.isBuffer(obj)) {
		    var len = checked(obj.length) | 0;
		    that = createBuffer(that, len);
	
		    if (that.length === 0) {
		      return that;
		    }
	
		    obj.copy(that, 0, 0, len);
		    return that;
		  }
	
		  if (obj) {
		    if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
		      if (typeof obj.length !== 'number' || isnan(obj.length)) {
		        return createBuffer(that, 0);
		      }
		      return fromArrayLike(that, obj);
		    }
	
		    if (obj.type === 'Buffer' && isArray(obj.data)) {
		      return fromArrayLike(that, obj.data);
		    }
		  }
	
		  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
		}
	
		function checked(length) {
		  // Note: cannot use `length < kMaxLength()` here because that fails when
		  // length is NaN (which is otherwise coerced to zero.)
		  if (length >= kMaxLength()) {
		    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
		  }
		  return length | 0;
		}
	
		function SlowBuffer(length) {
		  if (+length != length) {
		    // eslint-disable-line eqeqeq
		    length = 0;
		  }
		  return Buffer.alloc(+length);
		}
	
		Buffer.isBuffer = function isBuffer(b) {
		  return !!(b != null && b._isBuffer);
		};
	
		Buffer.compare = function compare(a, b) {
		  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
		    throw new TypeError('Arguments must be Buffers');
		  }
	
		  if (a === b) return 0;
	
		  var x = a.length;
		  var y = b.length;
	
		  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
		    if (a[i] !== b[i]) {
		      x = a[i];
		      y = b[i];
		      break;
		    }
		  }
	
		  if (x < y) return -1;
		  if (y < x) return 1;
		  return 0;
		};
	
		Buffer.isEncoding = function isEncoding(encoding) {
		  switch (String(encoding).toLowerCase()) {
		    case 'hex':
		    case 'utf8':
		    case 'utf-8':
		    case 'ascii':
		    case 'latin1':
		    case 'binary':
		    case 'base64':
		    case 'ucs2':
		    case 'ucs-2':
		    case 'utf16le':
		    case 'utf-16le':
		      return true;
		    default:
		      return false;
		  }
		};
	
		Buffer.concat = function concat(list, length) {
		  if (!isArray(list)) {
		    throw new TypeError('"list" argument must be an Array of Buffers');
		  }
	
		  if (list.length === 0) {
		    return Buffer.alloc(0);
		  }
	
		  var i;
		  if (length === undefined) {
		    length = 0;
		    for (i = 0; i < list.length; ++i) {
		      length += list[i].length;
		    }
		  }
	
		  var buffer = Buffer.allocUnsafe(length);
		  var pos = 0;
		  for (i = 0; i < list.length; ++i) {
		    var buf = list[i];
		    if (!Buffer.isBuffer(buf)) {
		      throw new TypeError('"list" argument must be an Array of Buffers');
		    }
		    buf.copy(buffer, pos);
		    pos += buf.length;
		  }
		  return buffer;
		};
	
		function byteLength(string, encoding) {
		  if (Buffer.isBuffer(string)) {
		    return string.length;
		  }
		  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
		    return string.byteLength;
		  }
		  if (typeof string !== 'string') {
		    string = '' + string;
		  }
	
		  var len = string.length;
		  if (len === 0) return 0;
	
		  // Use a for loop to avoid recursion
		  var loweredCase = false;
		  for (;;) {
		    switch (encoding) {
		      case 'ascii':
		      case 'latin1':
		      case 'binary':
		        return len;
		      case 'utf8':
		      case 'utf-8':
		      case undefined:
		        return utf8ToBytes(string).length;
		      case 'ucs2':
		      case 'ucs-2':
		      case 'utf16le':
		      case 'utf-16le':
		        return len * 2;
		      case 'hex':
		        return len >>> 1;
		      case 'base64':
		        return base64ToBytes(string).length;
		      default:
		        if (loweredCase) return utf8ToBytes(string).length; // assume utf8
		        encoding = ('' + encoding).toLowerCase();
		        loweredCase = true;
		    }
		  }
		}
		Buffer.byteLength = byteLength;
	
		function slowToString(encoding, start, end) {
		  var loweredCase = false;
	
		  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
		  // property of a typed array.
	
		  // This behaves neither like String nor Uint8Array in that we set start/end
		  // to their upper/lower bounds if the value passed is out of range.
		  // undefined is handled specially as per ECMA-262 6th Edition,
		  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
		  if (start === undefined || start < 0) {
		    start = 0;
		  }
		  // Return early if start > this.length. Done here to prevent potential uint32
		  // coercion fail below.
		  if (start > this.length) {
		    return '';
		  }
	
		  if (end === undefined || end > this.length) {
		    end = this.length;
		  }
	
		  if (end <= 0) {
		    return '';
		  }
	
		  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
		  end >>>= 0;
		  start >>>= 0;
	
		  if (end <= start) {
		    return '';
		  }
	
		  if (!encoding) encoding = 'utf8';
	
		  while (true) {
		    switch (encoding) {
		      case 'hex':
		        return hexSlice(this, start, end);
	
		      case 'utf8':
		      case 'utf-8':
		        return utf8Slice(this, start, end);
	
		      case 'ascii':
		        return asciiSlice(this, start, end);
	
		      case 'latin1':
		      case 'binary':
		        return latin1Slice(this, start, end);
	
		      case 'base64':
		        return base64Slice(this, start, end);
	
		      case 'ucs2':
		      case 'ucs-2':
		      case 'utf16le':
		      case 'utf-16le':
		        return utf16leSlice(this, start, end);
	
		      default:
		        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
		        encoding = (encoding + '').toLowerCase();
		        loweredCase = true;
		    }
		  }
		}
	
		// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
		// Buffer instances.
		Buffer.prototype._isBuffer = true;
	
		function swap(b, n, m) {
		  var i = b[n];
		  b[n] = b[m];
		  b[m] = i;
		}
	
		Buffer.prototype.swap16 = function swap16() {
		  var len = this.length;
		  if (len % 2 !== 0) {
		    throw new RangeError('Buffer size must be a multiple of 16-bits');
		  }
		  for (var i = 0; i < len; i += 2) {
		    swap(this, i, i + 1);
		  }
		  return this;
		};
	
		Buffer.prototype.swap32 = function swap32() {
		  var len = this.length;
		  if (len % 4 !== 0) {
		    throw new RangeError('Buffer size must be a multiple of 32-bits');
		  }
		  for (var i = 0; i < len; i += 4) {
		    swap(this, i, i + 3);
		    swap(this, i + 1, i + 2);
		  }
		  return this;
		};
	
		Buffer.prototype.swap64 = function swap64() {
		  var len = this.length;
		  if (len % 8 !== 0) {
		    throw new RangeError('Buffer size must be a multiple of 64-bits');
		  }
		  for (var i = 0; i < len; i += 8) {
		    swap(this, i, i + 7);
		    swap(this, i + 1, i + 6);
		    swap(this, i + 2, i + 5);
		    swap(this, i + 3, i + 4);
		  }
		  return this;
		};
	
		Buffer.prototype.toString = function toString() {
		  var length = this.length | 0;
		  if (length === 0) return '';
		  if (arguments.length === 0) return utf8Slice(this, 0, length);
		  return slowToString.apply(this, arguments);
		};
	
		Buffer.prototype.equals = function equals(b) {
		  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
		  if (this === b) return true;
		  return Buffer.compare(this, b) === 0;
		};
	
		Buffer.prototype.inspect = function inspect() {
		  var str = '';
		  var max = exports.INSPECT_MAX_BYTES;
		  if (this.length > 0) {
		    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
		    if (this.length > max) str += ' ... ';
		  }
		  return '<Buffer ' + str + '>';
		};
	
		Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
		  if (!Buffer.isBuffer(target)) {
		    throw new TypeError('Argument must be a Buffer');
		  }
	
		  if (start === undefined) {
		    start = 0;
		  }
		  if (end === undefined) {
		    end = target ? target.length : 0;
		  }
		  if (thisStart === undefined) {
		    thisStart = 0;
		  }
		  if (thisEnd === undefined) {
		    thisEnd = this.length;
		  }
	
		  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
		    throw new RangeError('out of range index');
		  }
	
		  if (thisStart >= thisEnd && start >= end) {
		    return 0;
		  }
		  if (thisStart >= thisEnd) {
		    return -1;
		  }
		  if (start >= end) {
		    return 1;
		  }
	
		  start >>>= 0;
		  end >>>= 0;
		  thisStart >>>= 0;
		  thisEnd >>>= 0;
	
		  if (this === target) return 0;
	
		  var x = thisEnd - thisStart;
		  var y = end - start;
		  var len = Math.min(x, y);
	
		  var thisCopy = this.slice(thisStart, thisEnd);
		  var targetCopy = target.slice(start, end);
	
		  for (var i = 0; i < len; ++i) {
		    if (thisCopy[i] !== targetCopy[i]) {
		      x = thisCopy[i];
		      y = targetCopy[i];
		      break;
		    }
		  }
	
		  if (x < y) return -1;
		  if (y < x) return 1;
		  return 0;
		};
	
		// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
		// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
		//
		// Arguments:
		// - buffer - a Buffer to search
		// - val - a string, Buffer, or number
		// - byteOffset - an index into `buffer`; will be clamped to an int32
		// - encoding - an optional encoding, relevant is val is a string
		// - dir - true for indexOf, false for lastIndexOf
		function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
		  // Empty buffer means no match
		  if (buffer.length === 0) return -1;
	
		  // Normalize byteOffset
		  if (typeof byteOffset === 'string') {
		    encoding = byteOffset;
		    byteOffset = 0;
		  } else if (byteOffset > 0x7fffffff) {
		    byteOffset = 0x7fffffff;
		  } else if (byteOffset < -0x80000000) {
		    byteOffset = -0x80000000;
		  }
		  byteOffset = +byteOffset; // Coerce to Number.
		  if (isNaN(byteOffset)) {
		    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
		    byteOffset = dir ? 0 : buffer.length - 1;
		  }
	
		  // Normalize byteOffset: negative offsets start from the end of the buffer
		  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
		  if (byteOffset >= buffer.length) {
		    if (dir) return -1;else byteOffset = buffer.length - 1;
		  } else if (byteOffset < 0) {
		    if (dir) byteOffset = 0;else return -1;
		  }
	
		  // Normalize val
		  if (typeof val === 'string') {
		    val = Buffer.from(val, encoding);
		  }
	
		  // Finally, search either indexOf (if dir is true) or lastIndexOf
		  if (Buffer.isBuffer(val)) {
		    // Special case: looking for empty string/buffer always fails
		    if (val.length === 0) {
		      return -1;
		    }
		    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
		  } else if (typeof val === 'number') {
		    val = val & 0xFF; // Search for a byte value [0-255]
		    if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
		      if (dir) {
		        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
		      } else {
		        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
		      }
		    }
		    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
		  }
	
		  throw new TypeError('val must be string, number or Buffer');
		}
	
		function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
		  var indexSize = 1;
		  var arrLength = arr.length;
		  var valLength = val.length;
	
		  if (encoding !== undefined) {
		    encoding = String(encoding).toLowerCase();
		    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
		      if (arr.length < 2 || val.length < 2) {
		        return -1;
		      }
		      indexSize = 2;
		      arrLength /= 2;
		      valLength /= 2;
		      byteOffset /= 2;
		    }
		  }
	
		  function read(buf, i) {
		    if (indexSize === 1) {
		      return buf[i];
		    } else {
		      return buf.readUInt16BE(i * indexSize);
		    }
		  }
	
		  var i;
		  if (dir) {
		    var foundIndex = -1;
		    for (i = byteOffset; i < arrLength; i++) {
		      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
		        if (foundIndex === -1) foundIndex = i;
		        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
		      } else {
		        if (foundIndex !== -1) i -= i - foundIndex;
		        foundIndex = -1;
		      }
		    }
		  } else {
		    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
		    for (i = byteOffset; i >= 0; i--) {
		      var found = true;
		      for (var j = 0; j < valLength; j++) {
		        if (read(arr, i + j) !== read(val, j)) {
		          found = false;
		          break;
		        }
		      }
		      if (found) return i;
		    }
		  }
	
		  return -1;
		}
	
		Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
		  return this.indexOf(val, byteOffset, encoding) !== -1;
		};
	
		Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
		  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
		};
	
		Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
		  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
		};
	
		function hexWrite(buf, string, offset, length) {
		  offset = Number(offset) || 0;
		  var remaining = buf.length - offset;
		  if (!length) {
		    length = remaining;
		  } else {
		    length = Number(length);
		    if (length > remaining) {
		      length = remaining;
		    }
		  }
	
		  // must be an even number of digits
		  var strLen = string.length;
		  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
	
		  if (length > strLen / 2) {
		    length = strLen / 2;
		  }
		  for (var i = 0; i < length; ++i) {
		    var parsed = parseInt(string.substr(i * 2, 2), 16);
		    if (isNaN(parsed)) return i;
		    buf[offset + i] = parsed;
		  }
		  return i;
		}
	
		function utf8Write(buf, string, offset, length) {
		  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
		}
	
		function asciiWrite(buf, string, offset, length) {
		  return blitBuffer(asciiToBytes(string), buf, offset, length);
		}
	
		function latin1Write(buf, string, offset, length) {
		  return asciiWrite(buf, string, offset, length);
		}
	
		function base64Write(buf, string, offset, length) {
		  return blitBuffer(base64ToBytes(string), buf, offset, length);
		}
	
		function ucs2Write(buf, string, offset, length) {
		  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
		}
	
		Buffer.prototype.write = function write(string, offset, length, encoding) {
		  // Buffer#write(string)
		  if (offset === undefined) {
		    encoding = 'utf8';
		    length = this.length;
		    offset = 0;
		    // Buffer#write(string, encoding)
		  } else if (length === undefined && typeof offset === 'string') {
		    encoding = offset;
		    length = this.length;
		    offset = 0;
		    // Buffer#write(string, offset[, length][, encoding])
		  } else if (isFinite(offset)) {
		    offset = offset | 0;
		    if (isFinite(length)) {
		      length = length | 0;
		      if (encoding === undefined) encoding = 'utf8';
		    } else {
		      encoding = length;
		      length = undefined;
		    }
		    // legacy write(string, encoding, offset, length) - remove in v0.13
		  } else {
		    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
		  }
	
		  var remaining = this.length - offset;
		  if (length === undefined || length > remaining) length = remaining;
	
		  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
		    throw new RangeError('Attempt to write outside buffer bounds');
		  }
	
		  if (!encoding) encoding = 'utf8';
	
		  var loweredCase = false;
		  for (;;) {
		    switch (encoding) {
		      case 'hex':
		        return hexWrite(this, string, offset, length);
	
		      case 'utf8':
		      case 'utf-8':
		        return utf8Write(this, string, offset, length);
	
		      case 'ascii':
		        return asciiWrite(this, string, offset, length);
	
		      case 'latin1':
		      case 'binary':
		        return latin1Write(this, string, offset, length);
	
		      case 'base64':
		        // Warning: maxLength not taken into account in base64Write
		        return base64Write(this, string, offset, length);
	
		      case 'ucs2':
		      case 'ucs-2':
		      case 'utf16le':
		      case 'utf-16le':
		        return ucs2Write(this, string, offset, length);
	
		      default:
		        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
		        encoding = ('' + encoding).toLowerCase();
		        loweredCase = true;
		    }
		  }
		};
	
		Buffer.prototype.toJSON = function toJSON() {
		  return {
		    type: 'Buffer',
		    data: Array.prototype.slice.call(this._arr || this, 0)
		  };
		};
	
		function base64Slice(buf, start, end) {
		  if (start === 0 && end === buf.length) {
		    return base64.fromByteArray(buf);
		  } else {
		    return base64.fromByteArray(buf.slice(start, end));
		  }
		}
	
		function utf8Slice(buf, start, end) {
		  end = Math.min(buf.length, end);
		  var res = [];
	
		  var i = start;
		  while (i < end) {
		    var firstByte = buf[i];
		    var codePoint = null;
		    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
	
		    if (i + bytesPerSequence <= end) {
		      var secondByte, thirdByte, fourthByte, tempCodePoint;
	
		      switch (bytesPerSequence) {
		        case 1:
		          if (firstByte < 0x80) {
		            codePoint = firstByte;
		          }
		          break;
		        case 2:
		          secondByte = buf[i + 1];
		          if ((secondByte & 0xC0) === 0x80) {
		            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
		            if (tempCodePoint > 0x7F) {
		              codePoint = tempCodePoint;
		            }
		          }
		          break;
		        case 3:
		          secondByte = buf[i + 1];
		          thirdByte = buf[i + 2];
		          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
		            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
		            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
		              codePoint = tempCodePoint;
		            }
		          }
		          break;
		        case 4:
		          secondByte = buf[i + 1];
		          thirdByte = buf[i + 2];
		          fourthByte = buf[i + 3];
		          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
		            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
		            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
		              codePoint = tempCodePoint;
		            }
		          }
		      }
		    }
	
		    if (codePoint === null) {
		      // we did not generate a valid codePoint so insert a
		      // replacement char (U+FFFD) and advance only 1 byte
		      codePoint = 0xFFFD;
		      bytesPerSequence = 1;
		    } else if (codePoint > 0xFFFF) {
		      // encode to utf16 (surrogate pair dance)
		      codePoint -= 0x10000;
		      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
		      codePoint = 0xDC00 | codePoint & 0x3FF;
		    }
	
		    res.push(codePoint);
		    i += bytesPerSequence;
		  }
	
		  return decodeCodePointsArray(res);
		}
	
		// Based on http://stackoverflow.com/a/22747272/680742, the browser with
		// the lowest limit is Chrome, with 0x10000 args.
		// We go 1 magnitude less, for safety
		var MAX_ARGUMENTS_LENGTH = 0x1000;
	
		function decodeCodePointsArray(codePoints) {
		  var len = codePoints.length;
		  if (len <= MAX_ARGUMENTS_LENGTH) {
		    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
		  }
	
		  // Decode in chunks to avoid "call stack size exceeded".
		  var res = '';
		  var i = 0;
		  while (i < len) {
		    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
		  }
		  return res;
		}
	
		function asciiSlice(buf, start, end) {
		  var ret = '';
		  end = Math.min(buf.length, end);
	
		  for (var i = start; i < end; ++i) {
		    ret += String.fromCharCode(buf[i] & 0x7F);
		  }
		  return ret;
		}
	
		function latin1Slice(buf, start, end) {
		  var ret = '';
		  end = Math.min(buf.length, end);
	
		  for (var i = start; i < end; ++i) {
		    ret += String.fromCharCode(buf[i]);
		  }
		  return ret;
		}
	
		function hexSlice(buf, start, end) {
		  var len = buf.length;
	
		  if (!start || start < 0) start = 0;
		  if (!end || end < 0 || end > len) end = len;
	
		  var out = '';
		  for (var i = start; i < end; ++i) {
		    out += toHex(buf[i]);
		  }
		  return out;
		}
	
		function utf16leSlice(buf, start, end) {
		  var bytes = buf.slice(start, end);
		  var res = '';
		  for (var i = 0; i < bytes.length; i += 2) {
		    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
		  }
		  return res;
		}
	
		Buffer.prototype.slice = function slice(start, end) {
		  var len = this.length;
		  start = ~~start;
		  end = end === undefined ? len : ~~end;
	
		  if (start < 0) {
		    start += len;
		    if (start < 0) start = 0;
		  } else if (start > len) {
		    start = len;
		  }
	
		  if (end < 0) {
		    end += len;
		    if (end < 0) end = 0;
		  } else if (end > len) {
		    end = len;
		  }
	
		  if (end < start) end = start;
	
		  var newBuf;
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    newBuf = this.subarray(start, end);
		    newBuf.__proto__ = Buffer.prototype;
		  } else {
		    var sliceLen = end - start;
		    newBuf = new Buffer(sliceLen, undefined);
		    for (var i = 0; i < sliceLen; ++i) {
		      newBuf[i] = this[i + start];
		    }
		  }
	
		  return newBuf;
		};
	
		/*
		 * Need to make sure that buffer isn't trying to write out of bounds.
		 */
		function checkOffset(offset, ext, length) {
		  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
		  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
		}
	
		Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
		  offset = offset | 0;
		  byteLength = byteLength | 0;
		  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
		  var val = this[offset];
		  var mul = 1;
		  var i = 0;
		  while (++i < byteLength && (mul *= 0x100)) {
		    val += this[offset + i] * mul;
		  }
	
		  return val;
		};
	
		Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
		  offset = offset | 0;
		  byteLength = byteLength | 0;
		  if (!noAssert) {
		    checkOffset(offset, byteLength, this.length);
		  }
	
		  var val = this[offset + --byteLength];
		  var mul = 1;
		  while (byteLength > 0 && (mul *= 0x100)) {
		    val += this[offset + --byteLength] * mul;
		  }
	
		  return val;
		};
	
		Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 1, this.length);
		  return this[offset];
		};
	
		Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 2, this.length);
		  return this[offset] | this[offset + 1] << 8;
		};
	
		Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 2, this.length);
		  return this[offset] << 8 | this[offset + 1];
		};
	
		Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 4, this.length);
	
		  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
		};
	
		Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 4, this.length);
	
		  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
		};
	
		Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
		  offset = offset | 0;
		  byteLength = byteLength | 0;
		  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
		  var val = this[offset];
		  var mul = 1;
		  var i = 0;
		  while (++i < byteLength && (mul *= 0x100)) {
		    val += this[offset + i] * mul;
		  }
		  mul *= 0x80;
	
		  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
		  return val;
		};
	
		Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
		  offset = offset | 0;
		  byteLength = byteLength | 0;
		  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
		  var i = byteLength;
		  var mul = 1;
		  var val = this[offset + --i];
		  while (i > 0 && (mul *= 0x100)) {
		    val += this[offset + --i] * mul;
		  }
		  mul *= 0x80;
	
		  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
		  return val;
		};
	
		Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 1, this.length);
		  if (!(this[offset] & 0x80)) return this[offset];
		  return (0xff - this[offset] + 1) * -1;
		};
	
		Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 2, this.length);
		  var val = this[offset] | this[offset + 1] << 8;
		  return val & 0x8000 ? val | 0xFFFF0000 : val;
		};
	
		Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 2, this.length);
		  var val = this[offset + 1] | this[offset] << 8;
		  return val & 0x8000 ? val | 0xFFFF0000 : val;
		};
	
		Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 4, this.length);
	
		  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
		};
	
		Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 4, this.length);
	
		  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
		};
	
		Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 4, this.length);
		  return ieee754.read(this, offset, true, 23, 4);
		};
	
		Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 4, this.length);
		  return ieee754.read(this, offset, false, 23, 4);
		};
	
		Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 8, this.length);
		  return ieee754.read(this, offset, true, 52, 8);
		};
	
		Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
		  if (!noAssert) checkOffset(offset, 8, this.length);
		  return ieee754.read(this, offset, false, 52, 8);
		};
	
		function checkInt(buf, value, offset, ext, max, min) {
		  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
		  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
		  if (offset + ext > buf.length) throw new RangeError('Index out of range');
		}
	
		Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
		  value = +value;
		  offset = offset | 0;
		  byteLength = byteLength | 0;
		  if (!noAssert) {
		    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
		    checkInt(this, value, offset, byteLength, maxBytes, 0);
		  }
	
		  var mul = 1;
		  var i = 0;
		  this[offset] = value & 0xFF;
		  while (++i < byteLength && (mul *= 0x100)) {
		    this[offset + i] = value / mul & 0xFF;
		  }
	
		  return offset + byteLength;
		};
	
		Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
		  value = +value;
		  offset = offset | 0;
		  byteLength = byteLength | 0;
		  if (!noAssert) {
		    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
		    checkInt(this, value, offset, byteLength, maxBytes, 0);
		  }
	
		  var i = byteLength - 1;
		  var mul = 1;
		  this[offset + i] = value & 0xFF;
		  while (--i >= 0 && (mul *= 0x100)) {
		    this[offset + i] = value / mul & 0xFF;
		  }
	
		  return offset + byteLength;
		};
	
		Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
		  value = +value;
		  offset = offset | 0;
		  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
		  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
		  this[offset] = value & 0xff;
		  return offset + 1;
		};
	
		function objectWriteUInt16(buf, value, offset, littleEndian) {
		  if (value < 0) value = 0xffff + value + 1;
		  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
		    buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
		  }
		}
	
		Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
		  value = +value;
		  offset = offset | 0;
		  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    this[offset] = value & 0xff;
		    this[offset + 1] = value >>> 8;
		  } else {
		    objectWriteUInt16(this, value, offset, true);
		  }
		  return offset + 2;
		};
	
		Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
		  value = +value;
		  offset = offset | 0;
		  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    this[offset] = value >>> 8;
		    this[offset + 1] = value & 0xff;
		  } else {
		    objectWriteUInt16(this, value, offset, false);
		  }
		  return offset + 2;
		};
	
		function objectWriteUInt32(buf, value, offset, littleEndian) {
		  if (value < 0) value = 0xffffffff + value + 1;
		  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
		    buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
		  }
		}
	
		Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
		  value = +value;
		  offset = offset | 0;
		  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    this[offset + 3] = value >>> 24;
		    this[offset + 2] = value >>> 16;
		    this[offset + 1] = value >>> 8;
		    this[offset] = value & 0xff;
		  } else {
		    objectWriteUInt32(this, value, offset, true);
		  }
		  return offset + 4;
		};
	
		Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
		  value = +value;
		  offset = offset | 0;
		  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    this[offset] = value >>> 24;
		    this[offset + 1] = value >>> 16;
		    this[offset + 2] = value >>> 8;
		    this[offset + 3] = value & 0xff;
		  } else {
		    objectWriteUInt32(this, value, offset, false);
		  }
		  return offset + 4;
		};
	
		Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
		  value = +value;
		  offset = offset | 0;
		  if (!noAssert) {
		    var limit = Math.pow(2, 8 * byteLength - 1);
	
		    checkInt(this, value, offset, byteLength, limit - 1, -limit);
		  }
	
		  var i = 0;
		  var mul = 1;
		  var sub = 0;
		  this[offset] = value & 0xFF;
		  while (++i < byteLength && (mul *= 0x100)) {
		    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
		      sub = 1;
		    }
		    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
		  }
	
		  return offset + byteLength;
		};
	
		Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
		  value = +value;
		  offset = offset | 0;
		  if (!noAssert) {
		    var limit = Math.pow(2, 8 * byteLength - 1);
	
		    checkInt(this, value, offset, byteLength, limit - 1, -limit);
		  }
	
		  var i = byteLength - 1;
		  var mul = 1;
		  var sub = 0;
		  this[offset + i] = value & 0xFF;
		  while (--i >= 0 && (mul *= 0x100)) {
		    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
		      sub = 1;
		    }
		    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
		  }
	
		  return offset + byteLength;
		};
	
		Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
		  value = +value;
		  offset = offset | 0;
		  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
		  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
		  if (value < 0) value = 0xff + value + 1;
		  this[offset] = value & 0xff;
		  return offset + 1;
		};
	
		Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
		  value = +value;
		  offset = offset | 0;
		  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    this[offset] = value & 0xff;
		    this[offset + 1] = value >>> 8;
		  } else {
		    objectWriteUInt16(this, value, offset, true);
		  }
		  return offset + 2;
		};
	
		Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
		  value = +value;
		  offset = offset | 0;
		  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    this[offset] = value >>> 8;
		    this[offset + 1] = value & 0xff;
		  } else {
		    objectWriteUInt16(this, value, offset, false);
		  }
		  return offset + 2;
		};
	
		Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
		  value = +value;
		  offset = offset | 0;
		  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    this[offset] = value & 0xff;
		    this[offset + 1] = value >>> 8;
		    this[offset + 2] = value >>> 16;
		    this[offset + 3] = value >>> 24;
		  } else {
		    objectWriteUInt32(this, value, offset, true);
		  }
		  return offset + 4;
		};
	
		Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
		  value = +value;
		  offset = offset | 0;
		  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
		  if (value < 0) value = 0xffffffff + value + 1;
		  if (Buffer.TYPED_ARRAY_SUPPORT) {
		    this[offset] = value >>> 24;
		    this[offset + 1] = value >>> 16;
		    this[offset + 2] = value >>> 8;
		    this[offset + 3] = value & 0xff;
		  } else {
		    objectWriteUInt32(this, value, offset, false);
		  }
		  return offset + 4;
		};
	
		function checkIEEE754(buf, value, offset, ext, max, min) {
		  if (offset + ext > buf.length) throw new RangeError('Index out of range');
		  if (offset < 0) throw new RangeError('Index out of range');
		}
	
		function writeFloat(buf, value, offset, littleEndian, noAssert) {
		  if (!noAssert) {
		    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
		  }
		  ieee754.write(buf, value, offset, littleEndian, 23, 4);
		  return offset + 4;
		}
	
		Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
		  return writeFloat(this, value, offset, true, noAssert);
		};
	
		Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
		  return writeFloat(this, value, offset, false, noAssert);
		};
	
		function writeDouble(buf, value, offset, littleEndian, noAssert) {
		  if (!noAssert) {
		    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
		  }
		  ieee754.write(buf, value, offset, littleEndian, 52, 8);
		  return offset + 8;
		}
	
		Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
		  return writeDouble(this, value, offset, true, noAssert);
		};
	
		Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
		  return writeDouble(this, value, offset, false, noAssert);
		};
	
		// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
		Buffer.prototype.copy = function copy(target, targetStart, start, end) {
		  if (!start) start = 0;
		  if (!end && end !== 0) end = this.length;
		  if (targetStart >= target.length) targetStart = target.length;
		  if (!targetStart) targetStart = 0;
		  if (end > 0 && end < start) end = start;
	
		  // Copy 0 bytes; we're done
		  if (end === start) return 0;
		  if (target.length === 0 || this.length === 0) return 0;
	
		  // Fatal error conditions
		  if (targetStart < 0) {
		    throw new RangeError('targetStart out of bounds');
		  }
		  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
		  if (end < 0) throw new RangeError('sourceEnd out of bounds');
	
		  // Are we oob?
		  if (end > this.length) end = this.length;
		  if (target.length - targetStart < end - start) {
		    end = target.length - targetStart + start;
		  }
	
		  var len = end - start;
		  var i;
	
		  if (this === target && start < targetStart && targetStart < end) {
		    // descending copy from end
		    for (i = len - 1; i >= 0; --i) {
		      target[i + targetStart] = this[i + start];
		    }
		  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
		    // ascending copy from start
		    for (i = 0; i < len; ++i) {
		      target[i + targetStart] = this[i + start];
		    }
		  } else {
		    Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
		  }
	
		  return len;
		};
	
		// Usage:
		//    buffer.fill(number[, offset[, end]])
		//    buffer.fill(buffer[, offset[, end]])
		//    buffer.fill(string[, offset[, end]][, encoding])
		Buffer.prototype.fill = function fill(val, start, end, encoding) {
		  // Handle string cases:
		  if (typeof val === 'string') {
		    if (typeof start === 'string') {
		      encoding = start;
		      start = 0;
		      end = this.length;
		    } else if (typeof end === 'string') {
		      encoding = end;
		      end = this.length;
		    }
		    if (val.length === 1) {
		      var code = val.charCodeAt(0);
		      if (code < 256) {
		        val = code;
		      }
		    }
		    if (encoding !== undefined && typeof encoding !== 'string') {
		      throw new TypeError('encoding must be a string');
		    }
		    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
		      throw new TypeError('Unknown encoding: ' + encoding);
		    }
		  } else if (typeof val === 'number') {
		    val = val & 255;
		  }
	
		  // Invalid ranges are not set to a default, so can range check early.
		  if (start < 0 || this.length < start || this.length < end) {
		    throw new RangeError('Out of range index');
		  }
	
		  if (end <= start) {
		    return this;
		  }
	
		  start = start >>> 0;
		  end = end === undefined ? this.length : end >>> 0;
	
		  if (!val) val = 0;
	
		  var i;
		  if (typeof val === 'number') {
		    for (i = start; i < end; ++i) {
		      this[i] = val;
		    }
		  } else {
		    var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
		    var len = bytes.length;
		    for (i = 0; i < end - start; ++i) {
		      this[i + start] = bytes[i % len];
		    }
		  }
	
		  return this;
		};
	
		// HELPER FUNCTIONS
		// ================
	
		var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
	
		function base64clean(str) {
		  // Node strips out invalid characters like \n and \t from the string, base64-js does not
		  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
		  // Node converts strings with length < 2 to ''
		  if (str.length < 2) return '';
		  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
		  while (str.length % 4 !== 0) {
		    str = str + '=';
		  }
		  return str;
		}
	
		function stringtrim(str) {
		  if (str.trim) return str.trim();
		  return str.replace(/^\s+|\s+$/g, '');
		}
	
		function toHex(n) {
		  if (n < 16) return '0' + n.toString(16);
		  return n.toString(16);
		}
	
		function utf8ToBytes(string, units) {
		  units = units || Infinity;
		  var codePoint;
		  var length = string.length;
		  var leadSurrogate = null;
		  var bytes = [];
	
		  for (var i = 0; i < length; ++i) {
		    codePoint = string.charCodeAt(i);
	
		    // is surrogate component
		    if (codePoint > 0xD7FF && codePoint < 0xE000) {
		      // last char was a lead
		      if (!leadSurrogate) {
		        // no lead yet
		        if (codePoint > 0xDBFF) {
		          // unexpected trail
		          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
		          continue;
		        } else if (i + 1 === length) {
		          // unpaired lead
		          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
		          continue;
		        }
	
		        // valid lead
		        leadSurrogate = codePoint;
	
		        continue;
		      }
	
		      // 2 leads in a row
		      if (codePoint < 0xDC00) {
		        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
		        leadSurrogate = codePoint;
		        continue;
		      }
	
		      // valid surrogate pair
		      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
		    } else if (leadSurrogate) {
		      // valid bmp char, but last char was a lead
		      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
		    }
	
		    leadSurrogate = null;
	
		    // encode utf8
		    if (codePoint < 0x80) {
		      if ((units -= 1) < 0) break;
		      bytes.push(codePoint);
		    } else if (codePoint < 0x800) {
		      if ((units -= 2) < 0) break;
		      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
		    } else if (codePoint < 0x10000) {
		      if ((units -= 3) < 0) break;
		      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
		    } else if (codePoint < 0x110000) {
		      if ((units -= 4) < 0) break;
		      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
		    } else {
		      throw new Error('Invalid code point');
		    }
		  }
	
		  return bytes;
		}
	
		function asciiToBytes(str) {
		  var byteArray = [];
		  for (var i = 0; i < str.length; ++i) {
		    // Node's code seems to be doing this and not & 0x7F..
		    byteArray.push(str.charCodeAt(i) & 0xFF);
		  }
		  return byteArray;
		}
	
		function utf16leToBytes(str, units) {
		  var c, hi, lo;
		  var byteArray = [];
		  for (var i = 0; i < str.length; ++i) {
		    if ((units -= 2) < 0) break;
	
		    c = str.charCodeAt(i);
		    hi = c >> 8;
		    lo = c % 256;
		    byteArray.push(lo);
		    byteArray.push(hi);
		  }
	
		  return byteArray;
		}
	
		function base64ToBytes(str) {
		  return base64.toByteArray(base64clean(str));
		}
	
		function blitBuffer(src, dst, offset, length) {
		  for (var i = 0; i < length; ++i) {
		    if (i + offset >= dst.length || i >= src.length) break;
		    dst[i + offset] = src[i];
		  }
		  return i;
		}
	
		function isnan(val) {
		  return val !== val; // eslint-disable-line no-self-compare
		}
		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))
	
	/***/ }),
	/* 400 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var toString = {}.toString;
	
		module.exports = Array.isArray || function (arr) {
		  return toString.call(arr) == '[object Array]';
		};
	
	/***/ }),
	/* 401 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
		var escapeStringRegexp = __webpack_require__(460);
		var ansiStyles = __webpack_require__(289);
		var stripAnsi = __webpack_require__(622);
		var hasAnsi = __webpack_require__(464);
		var supportsColor = __webpack_require__(623);
		var defineProps = Object.defineProperties;
		var isSimpleWindowsTerm = process.platform === 'win32' && !/^xterm/i.test(process.env.TERM);
	
		function Chalk(options) {
			// detect mode if not set manually
			this.enabled = !options || options.enabled === undefined ? supportsColor : options.enabled;
		}
	
		// use bright blue on Windows as the normal blue color is illegible
		if (isSimpleWindowsTerm) {
			ansiStyles.blue.open = '\x1B[94m';
		}
	
		var styles = function () {
			var ret = {};
	
			Object.keys(ansiStyles).forEach(function (key) {
				ansiStyles[key].closeRe = new RegExp(escapeStringRegexp(ansiStyles[key].close), 'g');
	
				ret[key] = {
					get: function get() {
						return build.call(this, this._styles.concat(key));
					}
				};
			});
	
			return ret;
		}();
	
		var proto = defineProps(function chalk() {}, styles);
	
		function build(_styles) {
			var builder = function builder() {
				return applyStyle.apply(builder, arguments);
			};
	
			builder._styles = _styles;
			builder.enabled = this.enabled;
			// __proto__ is used because we must return a function, but there is
			// no way to create a function with a different prototype.
			/* eslint-disable no-proto */
			builder.__proto__ = proto;
	
			return builder;
		}
	
		function applyStyle() {
			// support varags, but simply cast to string in case there's only one arg
			var args = arguments;
			var argsLen = args.length;
			var str = argsLen !== 0 && String(arguments[0]);
	
			if (argsLen > 1) {
				// don't slice `arguments`, it prevents v8 optimizations
				for (var a = 1; a < argsLen; a++) {
					str += ' ' + args[a];
				}
			}
	
			if (!this.enabled || !str) {
				return str;
			}
	
			var nestedStyles = this._styles;
			var i = nestedStyles.length;
	
			// Turns out that on Windows dimmed gray text becomes invisible in cmd.exe,
			// see https://github.com/chalk/chalk/issues/58
			// If we're on Windows and we're dealing with a gray color, temporarily make 'dim' a noop.
			var originalDim = ansiStyles.dim.open;
			if (isSimpleWindowsTerm && (nestedStyles.indexOf('gray') !== -1 || nestedStyles.indexOf('grey') !== -1)) {
				ansiStyles.dim.open = '';
			}
	
			while (i--) {
				var code = ansiStyles[nestedStyles[i]];
	
				// Replace any instances already present with a re-opening code
				// otherwise only the part of the string until said closing code
				// will be colored, and the rest will simply be 'plain'.
				str = code.open + str.replace(code.closeRe, code.open) + code.close;
			}
	
			// Reset the original 'dim' if we changed it to work around the Windows dimmed gray issue.
			ansiStyles.dim.open = originalDim;
	
			return str;
		}
	
		function init() {
			var ret = {};
	
			Object.keys(styles).forEach(function (name) {
				ret[name] = {
					get: function get() {
						return build.call(this, [name]);
					}
				};
			});
	
			return ret;
		}
	
		defineProps(Chalk.prototype, init());
	
		module.exports = new Chalk();
		module.exports.styles = ansiStyles;
		module.exports.hasColor = hasAnsi;
		module.exports.stripColor = stripAnsi;
		module.exports.supportsColor = supportsColor;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))
	
	/***/ }),
	/* 402 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		module.exports = function (xs, fn) {
		    var res = [];
		    for (var i = 0; i < xs.length; i++) {
		        var x = fn(xs[i], i);
		        if (isArray(x)) res.push.apply(res, x);else res.push(x);
		    }
		    return res;
		};
	
		var isArray = Array.isArray || function (xs) {
		    return Object.prototype.toString.call(xs) === '[object Array]';
		};
	
	/***/ }),
	/* 403 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
		var fs = __webpack_require__(115);
		var path = __webpack_require__(19);
	
		Object.defineProperty(exports, 'commentRegex', {
		  get: function getCommentRegex() {
		    return (/^\s*\/(?:\/|\*)[@#]\s+sourceMappingURL=data:(?:application|text)\/json;(?:charset[:=]\S+?;)?base64,(?:.*)$/mg
		    );
		  }
		});
	
		Object.defineProperty(exports, 'mapFileCommentRegex', {
		  get: function getMapFileCommentRegex() {
		    //Example (Extra space between slashes added to solve Safari bug. Exclude space in production):
		    //     / /# sourceMappingURL=foo.js.map           /*# sourceMappingURL=foo.js.map */
		    return (/(?:\/\/[@#][ \t]+sourceMappingURL=([^\s'"]+?)[ \t]*$)|(?:\/\*[@#][ \t]+sourceMappingURL=([^\*]+?)[ \t]*(?:\*\/){1}[ \t]*$)/mg
		    );
		  }
		});
	
		function decodeBase64(base64) {
		  return new Buffer(base64, 'base64').toString();
		}
	
		function stripComment(sm) {
		  return sm.split(',').pop();
		}
	
		function readFromFileMap(sm, dir) {
		  // NOTE: this will only work on the server since it attempts to read the map file
	
		  var r = exports.mapFileCommentRegex.exec(sm);
	
		  // for some odd reason //# .. captures in 1 and /* .. */ in 2
		  var filename = r[1] || r[2];
		  var filepath = path.resolve(dir, filename);
	
		  try {
		    return fs.readFileSync(filepath, 'utf8');
		  } catch (e) {
		    throw new Error('An error occurred while trying to read the map file at ' + filepath + '\n' + e);
		  }
		}
	
		function Converter(sm, opts) {
		  opts = opts || {};
	
		  if (opts.isFileComment) sm = readFromFileMap(sm, opts.commentFileDir);
		  if (opts.hasComment) sm = stripComment(sm);
		  if (opts.isEncoded) sm = decodeBase64(sm);
		  if (opts.isJSON || opts.isEncoded) sm = JSON.parse(sm);
	
		  this.sourcemap = sm;
		}
	
		Converter.prototype.toJSON = function (space) {
		  return JSON.stringify(this.sourcemap, null, space);
		};
	
		Converter.prototype.toBase64 = function () {
		  var json = this.toJSON();
		  return new Buffer(json).toString('base64');
		};
	
		Converter.prototype.toComment = function (options) {
		  var base64 = this.toBase64();
		  var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
		  return options && options.multiline ? '/*# ' + data + ' */' : '//# ' + data;
		};
	
		// returns copy instead of original
		Converter.prototype.toObject = function () {
		  return JSON.parse(this.toJSON());
		};
	
		Converter.prototype.addProperty = function (key, value) {
		  if (this.sourcemap.hasOwnProperty(key)) throw new Error('property %s already exists on the sourcemap, use set property instead');
		  return this.setProperty(key, value);
		};
	
		Converter.prototype.setProperty = function (key, value) {
		  this.sourcemap[key] = value;
		  return this;
		};
	
		Converter.prototype.getProperty = function (key) {
		  return this.sourcemap[key];
		};
	
		exports.fromObject = function (obj) {
		  return new Converter(obj);
		};
	
		exports.fromJSON = function (json) {
		  return new Converter(json, { isJSON: true });
		};
	
		exports.fromBase64 = function (base64) {
		  return new Converter(base64, { isEncoded: true });
		};
	
		exports.fromComment = function (comment) {
		  comment = comment.replace(/^\/\*/g, '//').replace(/\*\/$/g, '');
	
		  return new Converter(comment, { isEncoded: true, hasComment: true });
		};
	
		exports.fromMapFileComment = function (comment, dir) {
		  return new Converter(comment, { commentFileDir: dir, isFileComment: true, isJSON: true });
		};
	
		// Finds last sourcemap comment in file or returns null if none was found
		exports.fromSource = function (content) {
		  var m = content.match(exports.commentRegex);
		  return m ? exports.fromComment(m.pop()) : null;
		};
	
		// Finds last sourcemap comment in file or returns null if none was found
		exports.fromMapFileSource = function (content, dir) {
		  var m = content.match(exports.mapFileCommentRegex);
		  return m ? exports.fromMapFileComment(m.pop(), dir) : null;
		};
	
		exports.removeComments = function (src) {
		  return src.replace(exports.commentRegex, '');
		};
	
		exports.removeMapFileComments = function (src) {
		  return src.replace(exports.mapFileCommentRegex, '');
		};
	
		exports.generateMapFileComment = function (file, options) {
		  var data = 'sourceMappingURL=' + file;
		  return options && options.multiline ? '/*# ' + data + ' */' : '//# ' + data;
		};
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(399).Buffer))
	
	/***/ }),
	/* 404 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		__webpack_require__(59);
		__webpack_require__(157);
		module.exports = __webpack_require__(439);
	
	/***/ }),
	/* 405 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var core = __webpack_require__(5);
		var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
		module.exports = function stringify(it) {
		  // eslint-disable-line no-unused-vars
		  return $JSON.stringify.apply($JSON, arguments);
		};
	
	/***/ }),
	/* 406 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		__webpack_require__(96);
		__webpack_require__(157);
		__webpack_require__(59);
		__webpack_require__(441);
		__webpack_require__(451);
		__webpack_require__(450);
		__webpack_require__(449);
		module.exports = __webpack_require__(5).Map;
	
	/***/ }),
	/* 407 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		__webpack_require__(442);
		module.exports = 0x1fffffffffffff;
	
	/***/ }),
	/* 408 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		__webpack_require__(443);
		module.exports = __webpack_require__(5).Object.assign;
	
	/***/ }),
	/* 409 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		__webpack_require__(444);
		var $Object = __webpack_require__(5).Object;
		module.exports = function create(P, D) {
		  return $Object.create(P, D);
		};
	
	/***/ }),
	/* 410 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		__webpack_require__(158);
		module.exports = __webpack_require__(5).Object.getOwnPropertySymbols;
	
	/***/ }),
	/* 411 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		__webpack_require__(445);
		module.exports = __webpack_require__(5).Object.keys;
	
	/***/ }),
	/* 412 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		__webpack_require__(446);
		module.exports = __webpack_require__(5).Object.setPrototypeOf;
	
	/***/ }),
	/* 413 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		__webpack_require__(158);
		module.exports = __webpack_require__(5).Symbol['for'];
	
	/***/ }),
	/* 414 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		__webpack_require__(158);
		__webpack_require__(96);
		__webpack_require__(452);
		__webpack_require__(453);
		module.exports = __webpack_require__(5).Symbol;
	
	/***/ }),
	/* 415 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		__webpack_require__(157);
		__webpack_require__(59);
		module.exports = __webpack_require__(156).f('iterator');
	
	/***/ }),
	/* 416 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		__webpack_require__(96);
		__webpack_require__(59);
		__webpack_require__(447);
		__webpack_require__(455);
		__webpack_require__(454);
		module.exports = __webpack_require__(5).WeakMap;
	
	/***/ }),
	/* 417 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		__webpack_require__(96);
		__webpack_require__(59);
		__webpack_require__(448);
		__webpack_require__(457);
		__webpack_require__(456);
		module.exports = __webpack_require__(5).WeakSet;
	
	/***/ }),
	/* 418 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		module.exports = function () {/* empty */};
	
	/***/ }),
	/* 419 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var forOf = __webpack_require__(55);
	
		module.exports = function (iter, ITERATOR) {
		  var result = [];
		  forOf(iter, false, result.push, result, ITERATOR);
		  return result;
		};
	
	/***/ }),
	/* 420 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// false -> Array#indexOf
		// true  -> Array#includes
		var toIObject = __webpack_require__(37);
		var toLength = __webpack_require__(153);
		var toAbsoluteIndex = __webpack_require__(438);
		module.exports = function (IS_INCLUDES) {
		  return function ($this, el, fromIndex) {
		    var O = toIObject($this);
		    var length = toLength(O.length);
		    var index = toAbsoluteIndex(fromIndex, length);
		    var value;
		    // Array#includes uses SameValueZero equality algorithm
		    // eslint-disable-next-line no-self-compare
		    if (IS_INCLUDES && el != el) while (length > index) {
		      value = O[index++];
		      // eslint-disable-next-line no-self-compare
		      if (value != value) return true;
		      // Array#indexOf ignores holes, Array#includes - not
		    } else for (; length > index; index++) {
		      if (IS_INCLUDES || index in O) {
		        if (O[index] === el) return IS_INCLUDES || index || 0;
		      }
		    }return !IS_INCLUDES && -1;
		  };
		};
	
	/***/ }),
	/* 421 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isObject = __webpack_require__(16);
		var isArray = __webpack_require__(232);
		var SPECIES = __webpack_require__(13)('species');
	
		module.exports = function (original) {
		  var C;
		  if (isArray(original)) {
		    C = original.constructor;
		    // cross-realm fallback
		    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
		    if (isObject(C)) {
		      C = C[SPECIES];
		      if (C === null) C = undefined;
		    }
		  }return C === undefined ? Array : C;
		};
	
	/***/ }),
	/* 422 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
		var speciesConstructor = __webpack_require__(421);
	
		module.exports = function (original, length) {
		  return new (speciesConstructor(original))(length);
		};
	
	/***/ }),
	/* 423 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var dP = __webpack_require__(23).f;
		var create = __webpack_require__(90);
		var redefineAll = __webpack_require__(146);
		var ctx = __webpack_require__(43);
		var anInstance = __webpack_require__(136);
		var forOf = __webpack_require__(55);
		var $iterDefine = __webpack_require__(143);
		var step = __webpack_require__(233);
		var setSpecies = __webpack_require__(436);
		var DESCRIPTORS = __webpack_require__(22);
		var fastKey = __webpack_require__(57).fastKey;
		var validate = __webpack_require__(58);
		var SIZE = DESCRIPTORS ? '_s' : 'size';
	
		var getEntry = function getEntry(that, key) {
		  // fast case
		  var index = fastKey(key);
		  var entry;
		  if (index !== 'F') return that._i[index];
		  // frozen object case
		  for (entry = that._f; entry; entry = entry.n) {
		    if (entry.k == key) return entry;
		  }
		};
	
		module.exports = {
		  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
		    var C = wrapper(function (that, iterable) {
		      anInstance(that, C, NAME, '_i');
		      that._t = NAME; // collection type
		      that._i = create(null); // index
		      that._f = undefined; // first entry
		      that._l = undefined; // last entry
		      that[SIZE] = 0; // size
		      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
		    });
		    redefineAll(C.prototype, {
		      // 23.1.3.1 Map.prototype.clear()
		      // 23.2.3.2 Set.prototype.clear()
		      clear: function clear() {
		        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
		          entry.r = true;
		          if (entry.p) entry.p = entry.p.n = undefined;
		          delete data[entry.i];
		        }
		        that._f = that._l = undefined;
		        that[SIZE] = 0;
		      },
		      // 23.1.3.3 Map.prototype.delete(key)
		      // 23.2.3.4 Set.prototype.delete(value)
		      'delete': function _delete(key) {
		        var that = validate(this, NAME);
		        var entry = getEntry(that, key);
		        if (entry) {
		          var next = entry.n;
		          var prev = entry.p;
		          delete that._i[entry.i];
		          entry.r = true;
		          if (prev) prev.n = next;
		          if (next) next.p = prev;
		          if (that._f == entry) that._f = next;
		          if (that._l == entry) that._l = prev;
		          that[SIZE]--;
		        }return !!entry;
		      },
		      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
		      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
		      forEach: function forEach(callbackfn /* , that = undefined */) {
		        validate(this, NAME);
		        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
		        var entry;
		        while (entry = entry ? entry.n : this._f) {
		          f(entry.v, entry.k, this);
		          // revert to the last existing entry
		          while (entry && entry.r) {
		            entry = entry.p;
		          }
		        }
		      },
		      // 23.1.3.7 Map.prototype.has(key)
		      // 23.2.3.7 Set.prototype.has(value)
		      has: function has(key) {
		        return !!getEntry(validate(this, NAME), key);
		      }
		    });
		    if (DESCRIPTORS) dP(C.prototype, 'size', {
		      get: function get() {
		        return validate(this, NAME)[SIZE];
		      }
		    });
		    return C;
		  },
		  def: function def(that, key, value) {
		    var entry = getEntry(that, key);
		    var prev, index;
		    // change existing entry
		    if (entry) {
		      entry.v = value;
		      // create new entry
		    } else {
		      that._l = entry = {
		        i: index = fastKey(key, true), // <- index
		        k: key, // <- key
		        v: value, // <- value
		        p: prev = that._l, // <- previous entry
		        n: undefined, // <- next entry
		        r: false // <- removed
		      };
		      if (!that._f) that._f = entry;
		      if (prev) prev.n = entry;
		      that[SIZE]++;
		      // add to index
		      if (index !== 'F') that._i[index] = entry;
		    }return that;
		  },
		  getEntry: getEntry,
		  setStrong: function setStrong(C, NAME, IS_MAP) {
		    // add .keys, .values, .entries, [@@iterator]
		    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
		    $iterDefine(C, NAME, function (iterated, kind) {
		      this._t = validate(iterated, NAME); // target
		      this._k = kind; // kind
		      this._l = undefined; // previous
		    }, function () {
		      var that = this;
		      var kind = that._k;
		      var entry = that._l;
		      // revert to the last existing entry
		      while (entry && entry.r) {
		        entry = entry.p;
		      } // get next entry
		      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
		        // or finish the iteration
		        that._t = undefined;
		        return step(1);
		      }
		      // return step by kind
		      if (kind == 'keys') return step(0, entry.k);
		      if (kind == 'values') return step(0, entry.v);
		      return step(0, [entry.k, entry.v]);
		    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
		    // add [@@species], 23.1.2.2, 23.2.2.2
		    setSpecies(NAME);
		  }
		};
	
	/***/ }),
	/* 424 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// https://github.com/DavidBruant/Map-Set.prototype.toJSON
		var classof = __webpack_require__(228);
		var from = __webpack_require__(419);
		module.exports = function (NAME) {
		  return function toJSON() {
		    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
		    return from(this);
		  };
		};
	
	/***/ }),
	/* 425 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// all enumerable object keys, includes symbols
		var getKeys = __webpack_require__(44);
		var gOPS = __webpack_require__(145);
		var pIE = __webpack_require__(91);
		module.exports = function (it) {
		  var result = getKeys(it);
		  var getSymbols = gOPS.f;
		  if (getSymbols) {
		    var symbols = getSymbols(it);
		    var isEnum = pIE.f;
		    var i = 0;
		    var key;
		    while (symbols.length > i) {
		      if (isEnum.call(it, key = symbols[i++])) result.push(key);
		    }
		  }return result;
		};
	
	/***/ }),
	/* 426 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var document = __webpack_require__(15).document;
		module.exports = document && document.documentElement;
	
	/***/ }),
	/* 427 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// check on default Array iterator
		var Iterators = __webpack_require__(56);
		var ITERATOR = __webpack_require__(13)('iterator');
		var ArrayProto = Array.prototype;
	
		module.exports = function (it) {
		  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
		};
	
	/***/ }),
	/* 428 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// call something on iterator step with safe closing on error
		var anObject = __webpack_require__(21);
		module.exports = function (iterator, fn, value, entries) {
		  try {
		    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
		    // 7.4.6 IteratorClose(iterator, completion)
		  } catch (e) {
		    var ret = iterator['return'];
		    if (ret !== undefined) anObject(ret.call(iterator));
		    throw e;
		  }
		};
	
	/***/ }),
	/* 429 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var create = __webpack_require__(90);
		var descriptor = __webpack_require__(92);
		var setToStringTag = __webpack_require__(93);
		var IteratorPrototype = {};
	
		// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
		__webpack_require__(29)(IteratorPrototype, __webpack_require__(13)('iterator'), function () {
		  return this;
		});
	
		module.exports = function (Constructor, NAME, next) {
		  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
		  setToStringTag(Constructor, NAME + ' Iterator');
		};
	
	/***/ }),
	/* 430 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var getKeys = __webpack_require__(44);
		var toIObject = __webpack_require__(37);
		module.exports = function (object, el) {
		  var O = toIObject(object);
		  var keys = getKeys(O);
		  var length = keys.length;
		  var index = 0;
		  var key;
		  while (length > index) {
		    if (O[key = keys[index++]] === el) return key;
		  }
		};
	
	/***/ }),
	/* 431 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var dP = __webpack_require__(23);
		var anObject = __webpack_require__(21);
		var getKeys = __webpack_require__(44);
	
		module.exports = __webpack_require__(22) ? Object.defineProperties : function defineProperties(O, Properties) {
		  anObject(O);
		  var keys = getKeys(Properties);
		  var length = keys.length;
		  var i = 0;
		  var P;
		  while (length > i) {
		    dP.f(O, P = keys[i++], Properties[P]);
		  }return O;
		};
	
	/***/ }),
	/* 432 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
		var toIObject = __webpack_require__(37);
		var gOPN = __webpack_require__(236).f;
		var toString = {}.toString;
	
		var windowNames = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
	
		var getWindowNames = function getWindowNames(it) {
		  try {
		    return gOPN(it);
		  } catch (e) {
		    return windowNames.slice();
		  }
		};
	
		module.exports.f = function getOwnPropertyNames(it) {
		  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
		};
	
	/***/ }),
	/* 433 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
		var has = __webpack_require__(28);
		var toObject = __webpack_require__(94);
		var IE_PROTO = __webpack_require__(150)('IE_PROTO');
		var ObjectProto = Object.prototype;
	
		module.exports = Object.getPrototypeOf || function (O) {
		  O = toObject(O);
		  if (has(O, IE_PROTO)) return O[IE_PROTO];
		  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
		    return O.constructor.prototype;
		  }return O instanceof Object ? ObjectProto : null;
		};
	
	/***/ }),
	/* 434 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// most Object methods by ES6 should accept primitives
		var $export = __webpack_require__(12);
		var core = __webpack_require__(5);
		var fails = __webpack_require__(27);
		module.exports = function (KEY, exec) {
		  var fn = (core.Object || {})[KEY] || Object[KEY];
		  var exp = {};
		  exp[KEY] = exec(fn);
		  $export($export.S + $export.F * fails(function () {
		    fn(1);
		  }), 'Object', exp);
		};
	
	/***/ }),
	/* 435 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// Works with __proto__ only. Old v8 can't work with null proto objects.
		/* eslint-disable no-proto */
		var isObject = __webpack_require__(16);
		var anObject = __webpack_require__(21);
		var check = function check(O, proto) {
		  anObject(O);
		  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
		};
		module.exports = {
		  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
		  function (test, buggy, set) {
		    try {
		      set = __webpack_require__(43)(Function.call, __webpack_require__(235).f(Object.prototype, '__proto__').set, 2);
		      set(test, []);
		      buggy = !(test instanceof Array);
		    } catch (e) {
		      buggy = true;
		    }
		    return function setPrototypeOf(O, proto) {
		      check(O, proto);
		      if (buggy) O.__proto__ = proto;else set(O, proto);
		      return O;
		    };
		  }({}, false) : undefined),
		  check: check
		};
	
	/***/ }),
	/* 436 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var global = __webpack_require__(15);
		var core = __webpack_require__(5);
		var dP = __webpack_require__(23);
		var DESCRIPTORS = __webpack_require__(22);
		var SPECIES = __webpack_require__(13)('species');
	
		module.exports = function (KEY) {
		  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
		  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
		    configurable: true,
		    get: function get() {
		      return this;
		    }
		  });
		};
	
	/***/ }),
	/* 437 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var toInteger = __webpack_require__(152);
		var defined = __webpack_require__(140);
		// true  -> String#at
		// false -> String#codePointAt
		module.exports = function (TO_STRING) {
		  return function (that, pos) {
		    var s = String(defined(that));
		    var i = toInteger(pos);
		    var l = s.length;
		    var a, b;
		    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
		    a = s.charCodeAt(i);
		    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
		  };
		};
	
	/***/ }),
	/* 438 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var toInteger = __webpack_require__(152);
		var max = Math.max;
		var min = Math.min;
		module.exports = function (index, length) {
		  index = toInteger(index);
		  return index < 0 ? max(index + length, 0) : min(index, length);
		};
	
	/***/ }),
	/* 439 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var anObject = __webpack_require__(21);
		var get = __webpack_require__(238);
		module.exports = __webpack_require__(5).getIterator = function (it) {
		  var iterFn = get(it);
		  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
		  return anObject(iterFn.call(it));
		};
	
	/***/ }),
	/* 440 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var addToUnscopables = __webpack_require__(418);
		var step = __webpack_require__(233);
		var Iterators = __webpack_require__(56);
		var toIObject = __webpack_require__(37);
	
		// 22.1.3.4 Array.prototype.entries()
		// 22.1.3.13 Array.prototype.keys()
		// 22.1.3.29 Array.prototype.values()
		// 22.1.3.30 Array.prototype[@@iterator]()
		module.exports = __webpack_require__(143)(Array, 'Array', function (iterated, kind) {
		  this._t = toIObject(iterated); // target
		  this._i = 0; // next index
		  this._k = kind; // kind
		  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
		}, function () {
		  var O = this._t;
		  var kind = this._k;
		  var index = this._i++;
		  if (!O || index >= O.length) {
		    this._t = undefined;
		    return step(1);
		  }
		  if (kind == 'keys') return step(0, index);
		  if (kind == 'values') return step(0, O[index]);
		  return step(0, [index, O[index]]);
		}, 'values');
	
		// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
		Iterators.Arguments = Iterators.Array;
	
		addToUnscopables('keys');
		addToUnscopables('values');
		addToUnscopables('entries');
	
	/***/ }),
	/* 441 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var strong = __webpack_require__(423);
		var validate = __webpack_require__(58);
		var MAP = 'Map';
	
		// 23.1 Map Objects
		module.exports = __webpack_require__(139)(MAP, function (get) {
		  return function Map() {
		    return get(this, arguments.length > 0 ? arguments[0] : undefined);
		  };
		}, {
		  // 23.1.3.6 Map.prototype.get(key)
		  get: function get(key) {
		    var entry = strong.getEntry(validate(this, MAP), key);
		    return entry && entry.v;
		  },
		  // 23.1.3.9 Map.prototype.set(key, value)
		  set: function set(key, value) {
		    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
		  }
		}, strong, true);
	
	/***/ }),
	/* 442 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// 20.1.2.6 Number.MAX_SAFE_INTEGER
		var $export = __webpack_require__(12);
	
		$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });
	
	/***/ }),
	/* 443 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// 19.1.3.1 Object.assign(target, source)
		var $export = __webpack_require__(12);
	
		$export($export.S + $export.F, 'Object', { assign: __webpack_require__(234) });
	
	/***/ }),
	/* 444 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var $export = __webpack_require__(12);
		// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
		$export($export.S, 'Object', { create: __webpack_require__(90) });
	
	/***/ }),
	/* 445 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// 19.1.2.14 Object.keys(O)
		var toObject = __webpack_require__(94);
		var $keys = __webpack_require__(44);
	
		__webpack_require__(434)('keys', function () {
		  return function keys(it) {
		    return $keys(toObject(it));
		  };
		});
	
	/***/ }),
	/* 446 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// 19.1.3.19 Object.setPrototypeOf(O, proto)
		var $export = __webpack_require__(12);
		$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(435).set });
	
	/***/ }),
	/* 447 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var each = __webpack_require__(137)(0);
		var redefine = __webpack_require__(147);
		var meta = __webpack_require__(57);
		var assign = __webpack_require__(234);
		var weak = __webpack_require__(229);
		var isObject = __webpack_require__(16);
		var fails = __webpack_require__(27);
		var validate = __webpack_require__(58);
		var WEAK_MAP = 'WeakMap';
		var getWeak = meta.getWeak;
		var isExtensible = Object.isExtensible;
		var uncaughtFrozenStore = weak.ufstore;
		var tmp = {};
		var InternalMap;
	
		var wrapper = function wrapper(get) {
		  return function WeakMap() {
		    return get(this, arguments.length > 0 ? arguments[0] : undefined);
		  };
		};
	
		var methods = {
		  // 23.3.3.3 WeakMap.prototype.get(key)
		  get: function get(key) {
		    if (isObject(key)) {
		      var data = getWeak(key);
		      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
		      return data ? data[this._i] : undefined;
		    }
		  },
		  // 23.3.3.5 WeakMap.prototype.set(key, value)
		  set: function set(key, value) {
		    return weak.def(validate(this, WEAK_MAP), key, value);
		  }
		};
	
		// 23.3 WeakMap Objects
		var $WeakMap = module.exports = __webpack_require__(139)(WEAK_MAP, wrapper, methods, weak, true, true);
	
		// IE11 WeakMap frozen keys fix
		if (fails(function () {
		  return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7;
		})) {
		  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
		  assign(InternalMap.prototype, methods);
		  meta.NEED = true;
		  each(['delete', 'has', 'get', 'set'], function (key) {
		    var proto = $WeakMap.prototype;
		    var method = proto[key];
		    redefine(proto, key, function (a, b) {
		      // store frozen objects on internal weakmap shim
		      if (isObject(a) && !isExtensible(a)) {
		        if (!this._f) this._f = new InternalMap();
		        var result = this._f[key](a, b);
		        return key == 'set' ? this : result;
		        // store all the rest on native weakmap
		      }return method.call(this, a, b);
		    });
		  });
		}
	
	/***/ }),
	/* 448 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var weak = __webpack_require__(229);
		var validate = __webpack_require__(58);
		var WEAK_SET = 'WeakSet';
	
		// 23.4 WeakSet Objects
		__webpack_require__(139)(WEAK_SET, function (get) {
		  return function WeakSet() {
		    return get(this, arguments.length > 0 ? arguments[0] : undefined);
		  };
		}, {
		  // 23.4.3.1 WeakSet.prototype.add(value)
		  add: function add(value) {
		    return weak.def(validate(this, WEAK_SET), value, true);
		  }
		}, weak, false, true);
	
	/***/ }),
	/* 449 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
		__webpack_require__(148)('Map');
	
	/***/ }),
	/* 450 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
		__webpack_require__(149)('Map');
	
	/***/ }),
	/* 451 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// https://github.com/DavidBruant/Map-Set.prototype.toJSON
		var $export = __webpack_require__(12);
	
		$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(424)('Map') });
	
	/***/ }),
	/* 452 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		__webpack_require__(155)('asyncIterator');
	
	/***/ }),
	/* 453 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		__webpack_require__(155)('observable');
	
	/***/ }),
	/* 454 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
		__webpack_require__(148)('WeakMap');
	
	/***/ }),
	/* 455 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
		__webpack_require__(149)('WeakMap');
	
	/***/ }),
	/* 456 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
		__webpack_require__(148)('WeakSet');
	
	/***/ }),
	/* 457 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
		__webpack_require__(149)('WeakSet');
	
	/***/ }),
	/* 458 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		/**
		 * This is the common logic for both the Node.js and web browser
		 * implementations of `debug()`.
		 *
		 * Expose `debug()` as the module.
		 */
	
		exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
		exports.coerce = coerce;
		exports.disable = disable;
		exports.enable = enable;
		exports.enabled = enabled;
		exports.humanize = __webpack_require__(602);
	
		/**
		 * The currently active debug mode names, and names to skip.
		 */
	
		exports.names = [];
		exports.skips = [];
	
		/**
		 * Map of special "%n" handling functions, for the debug "format" argument.
		 *
		 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
		 */
	
		exports.formatters = {};
	
		/**
		 * Previous log timestamp.
		 */
	
		var prevTime;
	
		/**
		 * Select a color.
		 * @param {String} namespace
		 * @return {Number}
		 * @api private
		 */
	
		function selectColor(namespace) {
		  var hash = 0,
		      i;
	
		  for (i in namespace) {
		    hash = (hash << 5) - hash + namespace.charCodeAt(i);
		    hash |= 0; // Convert to 32bit integer
		  }
	
		  return exports.colors[Math.abs(hash) % exports.colors.length];
		}
	
		/**
		 * Create a debugger with the given `namespace`.
		 *
		 * @param {String} namespace
		 * @return {Function}
		 * @api public
		 */
	
		function createDebug(namespace) {
	
		  function debug() {
		    // disabled?
		    if (!debug.enabled) return;
	
		    var self = debug;
	
		    // set `diff` timestamp
		    var curr = +new Date();
		    var ms = curr - (prevTime || curr);
		    self.diff = ms;
		    self.prev = prevTime;
		    self.curr = curr;
		    prevTime = curr;
	
		    // turn the `arguments` into a proper Array
		    var args = new Array(arguments.length);
		    for (var i = 0; i < args.length; i++) {
		      args[i] = arguments[i];
		    }
	
		    args[0] = exports.coerce(args[0]);
	
		    if ('string' !== typeof args[0]) {
		      // anything else let's inspect with %O
		      args.unshift('%O');
		    }
	
		    // apply any `formatters` transformations
		    var index = 0;
		    args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
		      // if we encounter an escaped % then don't increase the array index
		      if (match === '%%') return match;
		      index++;
		      var formatter = exports.formatters[format];
		      if ('function' === typeof formatter) {
		        var val = args[index];
		        match = formatter.call(self, val);
	
		        // now we need to remove `args[index]` since it's inlined in the `format`
		        args.splice(index, 1);
		        index--;
		      }
		      return match;
		    });
	
		    // apply env-specific formatting (colors, etc.)
		    exports.formatArgs.call(self, args);
	
		    var logFn = debug.log || exports.log || console.log.bind(console);
		    logFn.apply(self, args);
		  }
	
		  debug.namespace = namespace;
		  debug.enabled = exports.enabled(namespace);
		  debug.useColors = exports.useColors();
		  debug.color = selectColor(namespace);
	
		  // env-specific initialization logic for debug instances
		  if ('function' === typeof exports.init) {
		    exports.init(debug);
		  }
	
		  return debug;
		}
	
		/**
		 * Enables a debug mode by namespaces. This can include modes
		 * separated by a colon and wildcards.
		 *
		 * @param {String} namespaces
		 * @api public
		 */
	
		function enable(namespaces) {
		  exports.save(namespaces);
	
		  exports.names = [];
		  exports.skips = [];
	
		  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
		  var len = split.length;
	
		  for (var i = 0; i < len; i++) {
		    if (!split[i]) continue; // ignore empty strings
		    namespaces = split[i].replace(/\*/g, '.*?');
		    if (namespaces[0] === '-') {
		      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
		    } else {
		      exports.names.push(new RegExp('^' + namespaces + '$'));
		    }
		  }
		}
	
		/**
		 * Disable debug output.
		 *
		 * @api public
		 */
	
		function disable() {
		  exports.enable('');
		}
	
		/**
		 * Returns true if the given mode name is enabled, false otherwise.
		 *
		 * @param {String} name
		 * @return {Boolean}
		 * @api public
		 */
	
		function enabled(name) {
		  var i, len;
		  for (i = 0, len = exports.skips.length; i < len; i++) {
		    if (exports.skips[i].test(name)) {
		      return false;
		    }
		  }
		  for (i = 0, len = exports.names.length; i < len; i++) {
		    if (exports.names[i].test(name)) {
		      return true;
		    }
		  }
		  return false;
		}
	
		/**
		 * Coerce `val`.
		 *
		 * @param {Mixed} val
		 * @return {Mixed}
		 * @api private
		 */
	
		function coerce(val) {
		  if (val instanceof Error) return val.stack || val.message;
		  return val;
		}
	
	/***/ }),
	/* 459 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* eslint-disable guard-for-in */
		'use strict';
	
		var repeating = __webpack_require__(615);
	
		// detect either spaces or tabs but not both to properly handle tabs
		// for indentation and spaces for alignment
		var INDENT_RE = /^(?:( )+|\t+)/;
	
		function getMostUsed(indents) {
			var result = 0;
			var maxUsed = 0;
			var maxWeight = 0;
	
			for (var n in indents) {
				var indent = indents[n];
				var u = indent[0];
				var w = indent[1];
	
				if (u > maxUsed || u === maxUsed && w > maxWeight) {
					maxUsed = u;
					maxWeight = w;
					result = Number(n);
				}
			}
	
			return result;
		}
	
		module.exports = function (str) {
			if (typeof str !== 'string') {
				throw new TypeError('Expected a string');
			}
	
			// used to see if tabs or spaces are the most used
			var tabs = 0;
			var spaces = 0;
	
			// remember the size of previous line's indentation
			var prev = 0;
	
			// remember how many indents/unindents as occurred for a given size
			// and how much lines follow a given indentation
			//
			// indents = {
			//    3: [1, 0],
			//    4: [1, 5],
			//    5: [1, 0],
			//   12: [1, 0],
			// }
			var indents = {};
	
			// pointer to the array of last used indent
			var current;
	
			// whether the last action was an indent (opposed to an unindent)
			var isIndent;
	
			str.split(/\n/g).forEach(function (line) {
				if (!line) {
					// ignore empty lines
					return;
				}
	
				var indent;
				var matches = line.match(INDENT_RE);
	
				if (!matches) {
					indent = 0;
				} else {
					indent = matches[0].length;
	
					if (matches[1]) {
						spaces++;
					} else {
						tabs++;
					}
				}
	
				var diff = indent - prev;
				prev = indent;
	
				if (diff) {
					// an indent or unindent has been detected
	
					isIndent = diff > 0;
	
					current = indents[isIndent ? diff : -diff];
	
					if (current) {
						current[0]++;
					} else {
						current = indents[diff] = [1, 0];
					}
				} else if (current) {
					// if the last action was an indent, increment the weight
					current[1] += Number(isIndent);
				}
			});
	
			var amount = getMostUsed(indents);
	
			var type;
			var actual;
			if (!amount) {
				type = null;
				actual = '';
			} else if (spaces >= tabs) {
				type = 'space';
				actual = repeating(' ', amount);
			} else {
				type = 'tab';
				actual = repeating('\t', amount);
			}
	
			return {
				amount: amount,
				type: type,
				indent: actual
			};
		};
	
	/***/ }),
	/* 460 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
	
		module.exports = function (str) {
			if (typeof str !== 'string') {
				throw new TypeError('Expected a string');
			}
	
			return str.replace(matchOperatorsRe, '\\$&');
		};
	
	/***/ }),
	/* 461 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		/*
		  Copyright (C) 2013 Yusuke Suzuki <utatane.tea@gmail.com>
	
		  Redistribution and use in source and binary forms, with or without
		  modification, are permitted provided that the following conditions are met:
	
		    * Redistributions of source code must retain the above copyright
		      notice, this list of conditions and the following disclaimer.
		    * Redistributions in binary form must reproduce the above copyright
		      notice, this list of conditions and the following disclaimer in the
		      documentation and/or other materials provided with the distribution.
	
		  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS'
		  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
		  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
		  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
		  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
		  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
		  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
		  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
		  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
		  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		*/
	
		(function () {
		    'use strict';
	
		    function isExpression(node) {
		        if (node == null) {
		            return false;
		        }
		        switch (node.type) {
		            case 'ArrayExpression':
		            case 'AssignmentExpression':
		            case 'BinaryExpression':
		            case 'CallExpression':
		            case 'ConditionalExpression':
		            case 'FunctionExpression':
		            case 'Identifier':
		            case 'Literal':
		            case 'LogicalExpression':
		            case 'MemberExpression':
		            case 'NewExpression':
		            case 'ObjectExpression':
		            case 'SequenceExpression':
		            case 'ThisExpression':
		            case 'UnaryExpression':
		            case 'UpdateExpression':
		                return true;
		        }
		        return false;
		    }
	
		    function isIterationStatement(node) {
		        if (node == null) {
		            return false;
		        }
		        switch (node.type) {
		            case 'DoWhileStatement':
		            case 'ForInStatement':
		            case 'ForStatement':
		            case 'WhileStatement':
		                return true;
		        }
		        return false;
		    }
	
		    function isStatement(node) {
		        if (node == null) {
		            return false;
		        }
		        switch (node.type) {
		            case 'BlockStatement':
		            case 'BreakStatement':
		            case 'ContinueStatement':
		            case 'DebuggerStatement':
		            case 'DoWhileStatement':
		            case 'EmptyStatement':
		            case 'ExpressionStatement':
		            case 'ForInStatement':
		            case 'ForStatement':
		            case 'IfStatement':
		            case 'LabeledStatement':
		            case 'ReturnStatement':
		            case 'SwitchStatement':
		            case 'ThrowStatement':
		            case 'TryStatement':
		            case 'VariableDeclaration':
		            case 'WhileStatement':
		            case 'WithStatement':
		                return true;
		        }
		        return false;
		    }
	
		    function isSourceElement(node) {
		        return isStatement(node) || node != null && node.type === 'FunctionDeclaration';
		    }
	
		    function trailingStatement(node) {
		        switch (node.type) {
		            case 'IfStatement':
		                if (node.alternate != null) {
		                    return node.alternate;
		                }
		                return node.consequent;
	
		            case 'LabeledStatement':
		            case 'ForStatement':
		            case 'ForInStatement':
		            case 'WhileStatement':
		            case 'WithStatement':
		                return node.body;
		        }
		        return null;
		    }
	
		    function isProblematicIfStatement(node) {
		        var current;
	
		        if (node.type !== 'IfStatement') {
		            return false;
		        }
		        if (node.alternate == null) {
		            return false;
		        }
		        current = node.consequent;
		        do {
		            if (current.type === 'IfStatement') {
		                if (current.alternate == null) {
		                    return true;
		                }
		            }
		            current = trailingStatement(current);
		        } while (current);
	
		        return false;
		    }
	
		    module.exports = {
		        isExpression: isExpression,
		        isStatement: isStatement,
		        isIterationStatement: isIterationStatement,
		        isSourceElement: isSourceElement,
		        isProblematicIfStatement: isProblematicIfStatement,
	
		        trailingStatement: trailingStatement
		    };
		})();
		/* vim: set sw=4 ts=4 et tw=80 : */
	
	/***/ }),
	/* 462 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		/*
		  Copyright (C) 2013 Yusuke Suzuki <utatane.tea@gmail.com>
	
		  Redistribution and use in source and binary forms, with or without
		  modification, are permitted provided that the following conditions are met:
	
		    * Redistributions of source code must retain the above copyright
		      notice, this list of conditions and the following disclaimer.
		    * Redistributions in binary form must reproduce the above copyright
		      notice, this list of conditions and the following disclaimer in the
		      documentation and/or other materials provided with the distribution.
	
		  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
		  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
		  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
		  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
		  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
		  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
		  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
		  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
		  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
		  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		*/
	
		(function () {
		    'use strict';
	
		    var code = __webpack_require__(240);
	
		    function isStrictModeReservedWordES6(id) {
		        switch (id) {
		            case 'implements':
		            case 'interface':
		            case 'package':
		            case 'private':
		            case 'protected':
		            case 'public':
		            case 'static':
		            case 'let':
		                return true;
		            default:
		                return false;
		        }
		    }
	
		    function isKeywordES5(id, strict) {
		        // yield should not be treated as keyword under non-strict mode.
		        if (!strict && id === 'yield') {
		            return false;
		        }
		        return isKeywordES6(id, strict);
		    }
	
		    function isKeywordES6(id, strict) {
		        if (strict && isStrictModeReservedWordES6(id)) {
		            return true;
		        }
	
		        switch (id.length) {
		            case 2:
		                return id === 'if' || id === 'in' || id === 'do';
		            case 3:
		                return id === 'var' || id === 'for' || id === 'new' || id === 'try';
		            case 4:
		                return id === 'this' || id === 'else' || id === 'case' || id === 'void' || id === 'with' || id === 'enum';
		            case 5:
		                return id === 'while' || id === 'break' || id === 'catch' || id === 'throw' || id === 'const' || id === 'yield' || id === 'class' || id === 'super';
		            case 6:
		                return id === 'return' || id === 'typeof' || id === 'delete' || id === 'switch' || id === 'export' || id === 'import';
		            case 7:
		                return id === 'default' || id === 'finally' || id === 'extends';
		            case 8:
		                return id === 'function' || id === 'continue' || id === 'debugger';
		            case 10:
		                return id === 'instanceof';
		            default:
		                return false;
		        }
		    }
	
		    function isReservedWordES5(id, strict) {
		        return id === 'null' || id === 'true' || id === 'false' || isKeywordES5(id, strict);
		    }
	
		    function isReservedWordES6(id, strict) {
		        return id === 'null' || id === 'true' || id === 'false' || isKeywordES6(id, strict);
		    }
	
		    function isRestrictedWord(id) {
		        return id === 'eval' || id === 'arguments';
		    }
	
		    function isIdentifierNameES5(id) {
		        var i, iz, ch;
	
		        if (id.length === 0) {
		            return false;
		        }
	
		        ch = id.charCodeAt(0);
		        if (!code.isIdentifierStartES5(ch)) {
		            return false;
		        }
	
		        for (i = 1, iz = id.length; i < iz; ++i) {
		            ch = id.charCodeAt(i);
		            if (!code.isIdentifierPartES5(ch)) {
		                return false;
		            }
		        }
		        return true;
		    }
	
		    function decodeUtf16(lead, trail) {
		        return (lead - 0xD800) * 0x400 + (trail - 0xDC00) + 0x10000;
		    }
	
		    function isIdentifierNameES6(id) {
		        var i, iz, ch, lowCh, check;
	
		        if (id.length === 0) {
		            return false;
		        }
	
		        check = code.isIdentifierStartES6;
		        for (i = 0, iz = id.length; i < iz; ++i) {
		            ch = id.charCodeAt(i);
		            if (0xD800 <= ch && ch <= 0xDBFF) {
		                ++i;
		                if (i >= iz) {
		                    return false;
		                }
		                lowCh = id.charCodeAt(i);
		                if (!(0xDC00 <= lowCh && lowCh <= 0xDFFF)) {
		                    return false;
		                }
		                ch = decodeUtf16(ch, lowCh);
		            }
		            if (!check(ch)) {
		                return false;
		            }
		            check = code.isIdentifierPartES6;
		        }
		        return true;
		    }
	
		    function isIdentifierES5(id, strict) {
		        return isIdentifierNameES5(id) && !isReservedWordES5(id, strict);
		    }
	
		    function isIdentifierES6(id, strict) {
		        return isIdentifierNameES6(id) && !isReservedWordES6(id, strict);
		    }
	
		    module.exports = {
		        isKeywordES5: isKeywordES5,
		        isKeywordES6: isKeywordES6,
		        isReservedWordES5: isReservedWordES5,
		        isReservedWordES6: isReservedWordES6,
		        isRestrictedWord: isRestrictedWord,
		        isIdentifierNameES5: isIdentifierNameES5,
		        isIdentifierNameES6: isIdentifierNameES6,
		        isIdentifierES5: isIdentifierES5,
		        isIdentifierES6: isIdentifierES6
		    };
		})();
		/* vim: set sw=4 ts=4 et tw=80 : */
	
	/***/ }),
	/* 463 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = __webpack_require__(630);
	
	/***/ }),
	/* 464 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var ansiRegex = __webpack_require__(180);
		var re = new RegExp(ansiRegex().source); // remove the `g` flag
		module.exports = re.test.bind(re);
	
	/***/ }),
	/* 465 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		exports.read = function (buffer, offset, isLE, mLen, nBytes) {
		  var e, m;
		  var eLen = nBytes * 8 - mLen - 1;
		  var eMax = (1 << eLen) - 1;
		  var eBias = eMax >> 1;
		  var nBits = -7;
		  var i = isLE ? nBytes - 1 : 0;
		  var d = isLE ? -1 : 1;
		  var s = buffer[offset + i];
	
		  i += d;
	
		  e = s & (1 << -nBits) - 1;
		  s >>= -nBits;
		  nBits += eLen;
		  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
		  m = e & (1 << -nBits) - 1;
		  e >>= -nBits;
		  nBits += mLen;
		  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
		  if (e === 0) {
		    e = 1 - eBias;
		  } else if (e === eMax) {
		    return m ? NaN : (s ? -1 : 1) * Infinity;
		  } else {
		    m = m + Math.pow(2, mLen);
		    e = e - eBias;
		  }
		  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
		};
	
		exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
		  var e, m, c;
		  var eLen = nBytes * 8 - mLen - 1;
		  var eMax = (1 << eLen) - 1;
		  var eBias = eMax >> 1;
		  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
		  var i = isLE ? 0 : nBytes - 1;
		  var d = isLE ? 1 : -1;
		  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	
		  value = Math.abs(value);
	
		  if (isNaN(value) || value === Infinity) {
		    m = isNaN(value) ? 1 : 0;
		    e = eMax;
		  } else {
		    e = Math.floor(Math.log(value) / Math.LN2);
		    if (value * (c = Math.pow(2, -e)) < 1) {
		      e--;
		      c *= 2;
		    }
		    if (e + eBias >= 1) {
		      value += rt / c;
		    } else {
		      value += rt * Math.pow(2, 1 - eBias);
		    }
		    if (value * c >= 2) {
		      e++;
		      c /= 2;
		    }
	
		    if (e + eBias >= eMax) {
		      m = 0;
		      e = eMax;
		    } else if (e + eBias >= 1) {
		      m = (value * c - 1) * Math.pow(2, mLen);
		      e = e + eBias;
		    } else {
		      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
		      e = 0;
		    }
		  }
	
		  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
		  e = e << mLen | m;
		  eLen += mLen;
		  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
		  buffer[offset + i - d] |= s * 128;
		};
	
	/***/ }),
	/* 466 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		var invariant = function invariant(condition, format, a, b, c, d, e, f) {
		  if (false) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  }
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		};
	
		module.exports = invariant;
	
	/***/ }),
	/* 467 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var numberIsNan = __webpack_require__(603);
	
		module.exports = Number.isFinite || function (val) {
			return !(typeof val !== 'number' || numberIsNan(val) || val === Infinity || val === -Infinity);
		};
	
	/***/ }),
	/* 468 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		// Copyright 2014, 2015, 2016, 2017 Simon Lydell
		// License: MIT. (See LICENSE.)
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		// This regex comes from regex.coffee, and is inserted here by generate-index.js
		// (run `npm run build`).
		exports.default = /((['"])(?:(?!\2|\\).|\\(?:\r\n|[\s\S]))*(\2)?|`(?:[^`\\$]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{[^}]*\}?)*\}?)*(`)?)|(\/\/.*)|(\/\*(?:[^*]|\*(?!\/))*(\*\/)?)|(\/(?!\*)(?:\[(?:(?![\]\\]).|\\.)*\]|(?![\/\]\\]).|\\.)+\/(?:(?!\s*(?:\b|[\u0080-\uFFFF$\\'"~({]|[+\-!](?!=)|\.?\d))|[gmiyu]{1,5}\b(?![\u0080-\uFFFF$\\]|\s*(?:[+\-*%&|^<>!=?({]|\/(?![\/*])))))|(0[xX][\da-fA-F]+|0[oO][0-7]+|0[bB][01]+|(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?)|((?!\d)(?:(?!\s)[$\w\u0080-\uFFFF]|\\u[\da-fA-F]{4}|\\u\{[\da-fA-F]+\})+)|(--|\+\+|&&|\|\||=>|\.{3}|(?:[+\-\/%&|^]|\*{1,2}|<{1,2}|>{1,3}|!=?|={1,2})=?|[?~.,:;[\](){}])|(\s+)|(^$|[\s\S])/g;
	
		exports.matchToToken = function (match) {
		  var token = { type: "invalid", value: match[0] };
		  if (match[1]) token.type = "string", token.closed = !!(match[3] || match[4]);else if (match[5]) token.type = "comment";else if (match[6]) token.type = "comment", token.closed = !!match[7];else if (match[8]) token.type = "regex";else if (match[9]) token.type = "number";else if (match[10]) token.type = "name";else if (match[11]) token.type = "punctuator";else if (match[12]) token.type = "whitespace";
		  return token;
		};
	
	/***/ }),
	/* 469 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		/*! https://mths.be/jsesc v1.3.0 by @mathias */
		;(function (root) {
	
			// Detect free variables `exports`
			var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports;
	
			// Detect free variable `module`
			var freeModule = ( false ? 'undefined' : _typeof(module)) == 'object' && module && module.exports == freeExports && module;
	
			// Detect free variable `global`, from Node.js or Browserified code,
			// and use it as `root`
			var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global;
			if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
				root = freeGlobal;
			}
	
			/*--------------------------------------------------------------------------*/
	
			var object = {};
			var hasOwnProperty = object.hasOwnProperty;
			var forOwn = function forOwn(object, callback) {
				var key;
				for (key in object) {
					if (hasOwnProperty.call(object, key)) {
						callback(key, object[key]);
					}
				}
			};
	
			var extend = function extend(destination, source) {
				if (!source) {
					return destination;
				}
				forOwn(source, function (key, value) {
					destination[key] = value;
				});
				return destination;
			};
	
			var forEach = function forEach(array, callback) {
				var length = array.length;
				var index = -1;
				while (++index < length) {
					callback(array[index]);
				}
			};
	
			var toString = object.toString;
			var isArray = function isArray(value) {
				return toString.call(value) == '[object Array]';
			};
			var isObject = function isObject(value) {
				// This is a very simple check, but it’s good enough for what we need.
				return toString.call(value) == '[object Object]';
			};
			var isString = function isString(value) {
				return typeof value == 'string' || toString.call(value) == '[object String]';
			};
			var isNumber = function isNumber(value) {
				return typeof value == 'number' || toString.call(value) == '[object Number]';
			};
			var isFunction = function isFunction(value) {
				// In a perfect world, the `typeof` check would be sufficient. However,
				// in Chrome 1–12, `typeof /x/ == 'object'`, and in IE 6–8
				// `typeof alert == 'object'` and similar for other host objects.
				return typeof value == 'function' || toString.call(value) == '[object Function]';
			};
			var isMap = function isMap(value) {
				return toString.call(value) == '[object Map]';
			};
			var isSet = function isSet(value) {
				return toString.call(value) == '[object Set]';
			};
	
			/*--------------------------------------------------------------------------*/
	
			// https://mathiasbynens.be/notes/javascript-escapes#single
			var singleEscapes = {
				'"': '\\"',
				'\'': '\\\'',
				'\\': '\\\\',
				'\b': '\\b',
				'\f': '\\f',
				'\n': '\\n',
				'\r': '\\r',
				'\t': '\\t'
				// `\v` is omitted intentionally, because in IE < 9, '\v' == 'v'.
				// '\v': '\\x0B'
			};
			var regexSingleEscape = /["'\\\b\f\n\r\t]/;
	
			var regexDigit = /[0-9]/;
			var regexWhitelist = /[ !#-&\(-\[\]-~]/;
	
			var jsesc = function jsesc(argument, options) {
				// Handle options
				var defaults = {
					'escapeEverything': false,
					'escapeEtago': false,
					'quotes': 'single',
					'wrap': false,
					'es6': false,
					'json': false,
					'compact': true,
					'lowercaseHex': false,
					'numbers': 'decimal',
					'indent': '\t',
					'__indent__': '',
					'__inline1__': false,
					'__inline2__': false
				};
				var json = options && options.json;
				if (json) {
					defaults.quotes = 'double';
					defaults.wrap = true;
				}
				options = extend(defaults, options);
				if (options.quotes != 'single' && options.quotes != 'double') {
					options.quotes = 'single';
				}
				var quote = options.quotes == 'double' ? '"' : '\'';
				var compact = options.compact;
				var indent = options.indent;
				var lowercaseHex = options.lowercaseHex;
				var oldIndent = '';
				var inline1 = options.__inline1__;
				var inline2 = options.__inline2__;
				var newLine = compact ? '' : '\n';
				var result;
				var isEmpty = true;
				var useBinNumbers = options.numbers == 'binary';
				var useOctNumbers = options.numbers == 'octal';
				var useDecNumbers = options.numbers == 'decimal';
				var useHexNumbers = options.numbers == 'hexadecimal';
	
				if (json && argument && isFunction(argument.toJSON)) {
					argument = argument.toJSON();
				}
	
				if (!isString(argument)) {
					if (isMap(argument)) {
						if (argument.size == 0) {
							return 'new Map()';
						}
						if (!compact) {
							options.__inline1__ = true;
						}
						return 'new Map(' + jsesc(Array.from(argument), options) + ')';
					}
					if (isSet(argument)) {
						if (argument.size == 0) {
							return 'new Set()';
						}
						return 'new Set(' + jsesc(Array.from(argument), options) + ')';
					}
					if (isArray(argument)) {
						result = [];
						options.wrap = true;
						if (inline1) {
							options.__inline1__ = false;
							options.__inline2__ = true;
						} else {
							oldIndent = options.__indent__;
							indent += oldIndent;
							options.__indent__ = indent;
						}
						forEach(argument, function (value) {
							isEmpty = false;
							if (inline2) {
								options.__inline2__ = false;
							}
							result.push((compact || inline2 ? '' : indent) + jsesc(value, options));
						});
						if (isEmpty) {
							return '[]';
						}
						if (inline2) {
							return '[' + result.join(', ') + ']';
						}
						return '[' + newLine + result.join(',' + newLine) + newLine + (compact ? '' : oldIndent) + ']';
					} else if (isNumber(argument)) {
						if (json) {
							// Some number values (e.g. `Infinity`) cannot be represented in JSON.
							return JSON.stringify(argument);
						}
						if (useDecNumbers) {
							return String(argument);
						}
						if (useHexNumbers) {
							var tmp = argument.toString(16);
							if (!lowercaseHex) {
								tmp = tmp.toUpperCase();
							}
							return '0x' + tmp;
						}
						if (useBinNumbers) {
							return '0b' + argument.toString(2);
						}
						if (useOctNumbers) {
							return '0o' + argument.toString(8);
						}
					} else if (!isObject(argument)) {
						if (json) {
							// For some values (e.g. `undefined`, `function` objects),
							// `JSON.stringify(value)` returns `undefined` (which isn’t valid
							// JSON) instead of `'null'`.
							return JSON.stringify(argument) || 'null';
						}
						return String(argument);
					} else {
						// it’s an object
						result = [];
						options.wrap = true;
						oldIndent = options.__indent__;
						indent += oldIndent;
						options.__indent__ = indent;
						forOwn(argument, function (key, value) {
							isEmpty = false;
							result.push((compact ? '' : indent) + jsesc(key, options) + ':' + (compact ? '' : ' ') + jsesc(value, options));
						});
						if (isEmpty) {
							return '{}';
						}
						return '{' + newLine + result.join(',' + newLine) + newLine + (compact ? '' : oldIndent) + '}';
					}
				}
	
				var string = argument;
				// Loop over each code unit in the string and escape it
				var index = -1;
				var length = string.length;
				var first;
				var second;
				var codePoint;
				result = '';
				while (++index < length) {
					var character = string.charAt(index);
					if (options.es6) {
						first = string.charCodeAt(index);
						if ( // check if it’s the start of a surrogate pair
						first >= 0xD800 && first <= 0xDBFF && // high surrogate
						length > index + 1 // there is a next code unit
						) {
								second = string.charCodeAt(index + 1);
								if (second >= 0xDC00 && second <= 0xDFFF) {
									// low surrogate
									// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
									codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
									var hexadecimal = codePoint.toString(16);
									if (!lowercaseHex) {
										hexadecimal = hexadecimal.toUpperCase();
									}
									result += '\\u{' + hexadecimal + '}';
									index++;
									continue;
								}
							}
					}
					if (!options.escapeEverything) {
						if (regexWhitelist.test(character)) {
							// It’s a printable ASCII character that is not `"`, `'` or `\`,
							// so don’t escape it.
							result += character;
							continue;
						}
						if (character == '"') {
							result += quote == character ? '\\"' : character;
							continue;
						}
						if (character == '\'') {
							result += quote == character ? '\\\'' : character;
							continue;
						}
					}
					if (character == '\0' && !json && !regexDigit.test(string.charAt(index + 1))) {
						result += '\\0';
						continue;
					}
					if (regexSingleEscape.test(character)) {
						// no need for a `hasOwnProperty` check here
						result += singleEscapes[character];
						continue;
					}
					var charCode = character.charCodeAt(0);
					var hexadecimal = charCode.toString(16);
					if (!lowercaseHex) {
						hexadecimal = hexadecimal.toUpperCase();
					}
					var longhand = hexadecimal.length > 2 || json;
					var escaped = '\\' + (longhand ? 'u' : 'x') + ('0000' + hexadecimal).slice(longhand ? -4 : -2);
					result += escaped;
					continue;
				}
				if (options.wrap) {
					result = quote + result + quote;
				}
				if (options.escapeEtago) {
					// https://mathiasbynens.be/notes/etago
					return result.replace(/<\/(script|style)/gi, '<\\/$1');
				}
				return result;
			};
	
			jsesc.version = '1.3.0';
	
			/*--------------------------------------------------------------------------*/
	
			// Some AMD build optimizers, like r.js, check for specific condition patterns
			// like the following:
			if ("function" == 'function' && _typeof(__webpack_require__(49)) == 'object' && __webpack_require__(49)) {
				!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
					return jsesc;
				}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			} else if (freeExports && !freeExports.nodeType) {
				if (freeModule) {
					// in Node.js or RingoJS v0.8.0+
					freeModule.exports = jsesc;
				} else {
					// in Narwhal or RingoJS v0.7.0-
					freeExports.jsesc = jsesc;
				}
			} else {
				// in Rhino or a web browser
				root.jsesc = jsesc;
			}
		})(undefined);
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)(module), (function() { return this; }())))
	
	/***/ }),
	/* 470 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		// json5.js
		// Modern JSON. See README.md for details.
		//
		// This file is based directly off of Douglas Crockford's json_parse.js:
		// https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
	
		var JSON5 = ( false ? "undefined" : _typeof(exports)) === 'object' ? exports : {};
	
		JSON5.parse = function () {
		    "use strict";
	
		    // This is a function that can parse a JSON5 text, producing a JavaScript
		    // data structure. It is a simple, recursive descent parser. It does not use
		    // eval or regular expressions, so it can be used as a model for implementing
		    // a JSON5 parser in other languages.
	
		    // We are defining the function inside of another function to avoid creating
		    // global variables.
	
		    var at,
		        // The index of the current character
		    lineNumber,
		        // The current line number
		    columnNumber,
		        // The current column number
		    ch,
		        // The current character
		    escapee = {
		        "'": "'",
		        '"': '"',
		        '\\': '\\',
		        '/': '/',
		        '\n': '', // Replace escaped newlines in strings w/ empty string
		        b: '\b',
		        f: '\f',
		        n: '\n',
		        r: '\r',
		        t: '\t'
		    },
		        ws = [' ', '\t', '\r', '\n', '\v', '\f', '\xA0', "\uFEFF"],
		        text,
		        renderChar = function renderChar(chr) {
		        return chr === '' ? 'EOF' : "'" + chr + "'";
		    },
		        error = function error(m) {
	
		        // Call error when something is wrong.
	
		        var error = new SyntaxError();
		        // beginning of message suffix to agree with that provided by Gecko - see https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/JSON/parse
		        error.message = m + " at line " + lineNumber + " column " + columnNumber + " of the JSON5 data. Still to read: " + JSON.stringify(text.substring(at - 1, at + 19));
		        error.at = at;
		        // These two property names have been chosen to agree with the ones in Gecko, the only popular
		        // environment which seems to supply this info on JSON.parse
		        error.lineNumber = lineNumber;
		        error.columnNumber = columnNumber;
		        throw error;
		    },
		        next = function next(c) {
	
		        // If a c parameter is provided, verify that it matches the current character.
	
		        if (c && c !== ch) {
		            error("Expected " + renderChar(c) + " instead of " + renderChar(ch));
		        }
	
		        // Get the next character. When there are no more characters,
		        // return the empty string.
	
		        ch = text.charAt(at);
		        at++;
		        columnNumber++;
		        if (ch === '\n' || ch === '\r' && peek() !== '\n') {
		            lineNumber++;
		            columnNumber = 0;
		        }
		        return ch;
		    },
		        peek = function peek() {
	
		        // Get the next character without consuming it or
		        // assigning it to the ch varaible.
	
		        return text.charAt(at);
		    },
		        identifier = function identifier() {
	
		        // Parse an identifier. Normally, reserved words are disallowed here, but we
		        // only use this for unquoted object keys, where reserved words are allowed,
		        // so we don't check for those here. References:
		        // - http://es5.github.com/#x7.6
		        // - https://developer.mozilla.org/en/Core_JavaScript_1.5_Guide/Core_Language_Features#Variables
		        // - http://docstore.mik.ua/orelly/webprog/jscript/ch02_07.htm
		        // TODO Identifiers can have Unicode "letters" in them; add support for those.
	
		        var key = ch;
	
		        // Identifiers must start with a letter, _ or $.
		        if (ch !== '_' && ch !== '$' && (ch < 'a' || ch > 'z') && (ch < 'A' || ch > 'Z')) {
		            error("Bad identifier as unquoted key");
		        }
	
		        // Subsequent characters can contain digits.
		        while (next() && (ch === '_' || ch === '$' || ch >= 'a' && ch <= 'z' || ch >= 'A' && ch <= 'Z' || ch >= '0' && ch <= '9')) {
		            key += ch;
		        }
	
		        return key;
		    },
		        number = function number() {
	
		        // Parse a number value.
	
		        var number,
		            sign = '',
		            string = '',
		            base = 10;
	
		        if (ch === '-' || ch === '+') {
		            sign = ch;
		            next(ch);
		        }
	
		        // support for Infinity (could tweak to allow other words):
		        if (ch === 'I') {
		            number = word();
		            if (typeof number !== 'number' || isNaN(number)) {
		                error('Unexpected word for number');
		            }
		            return sign === '-' ? -number : number;
		        }
	
		        // support for NaN
		        if (ch === 'N') {
		            number = word();
		            if (!isNaN(number)) {
		                error('expected word to be NaN');
		            }
		            // ignore sign as -NaN also is NaN
		            return number;
		        }
	
		        if (ch === '0') {
		            string += ch;
		            next();
		            if (ch === 'x' || ch === 'X') {
		                string += ch;
		                next();
		                base = 16;
		            } else if (ch >= '0' && ch <= '9') {
		                error('Octal literal');
		            }
		        }
	
		        switch (base) {
		            case 10:
		                while (ch >= '0' && ch <= '9') {
		                    string += ch;
		                    next();
		                }
		                if (ch === '.') {
		                    string += '.';
		                    while (next() && ch >= '0' && ch <= '9') {
		                        string += ch;
		                    }
		                }
		                if (ch === 'e' || ch === 'E') {
		                    string += ch;
		                    next();
		                    if (ch === '-' || ch === '+') {
		                        string += ch;
		                        next();
		                    }
		                    while (ch >= '0' && ch <= '9') {
		                        string += ch;
		                        next();
		                    }
		                }
		                break;
		            case 16:
		                while (ch >= '0' && ch <= '9' || ch >= 'A' && ch <= 'F' || ch >= 'a' && ch <= 'f') {
		                    string += ch;
		                    next();
		                }
		                break;
		        }
	
		        if (sign === '-') {
		            number = -string;
		        } else {
		            number = +string;
		        }
	
		        if (!isFinite(number)) {
		            error("Bad number");
		        } else {
		            return number;
		        }
		    },
		        string = function string() {
	
		        // Parse a string value.
	
		        var hex,
		            i,
		            string = '',
		            delim,
		            // double quote or single quote
		        uffff;
	
		        // When parsing for string values, we must look for ' or " and \ characters.
	
		        if (ch === '"' || ch === "'") {
		            delim = ch;
		            while (next()) {
		                if (ch === delim) {
		                    next();
		                    return string;
		                } else if (ch === '\\') {
		                    next();
		                    if (ch === 'u') {
		                        uffff = 0;
		                        for (i = 0; i < 4; i += 1) {
		                            hex = parseInt(next(), 16);
		                            if (!isFinite(hex)) {
		                                break;
		                            }
		                            uffff = uffff * 16 + hex;
		                        }
		                        string += String.fromCharCode(uffff);
		                    } else if (ch === '\r') {
		                        if (peek() === '\n') {
		                            next();
		                        }
		                    } else if (typeof escapee[ch] === 'string') {
		                        string += escapee[ch];
		                    } else {
		                        break;
		                    }
		                } else if (ch === '\n') {
		                    // unescaped newlines are invalid; see:
		                    // https://github.com/aseemk/json5/issues/24
		                    // TODO this feels special-cased; are there other
		                    // invalid unescaped chars?
		                    break;
		                } else {
		                    string += ch;
		                }
		            }
		        }
		        error("Bad string");
		    },
		        inlineComment = function inlineComment() {
	
		        // Skip an inline comment, assuming this is one. The current character should
		        // be the second / character in the // pair that begins this inline comment.
		        // To finish the inline comment, we look for a newline or the end of the text.
	
		        if (ch !== '/') {
		            error("Not an inline comment");
		        }
	
		        do {
		            next();
		            if (ch === '\n' || ch === '\r') {
		                next();
		                return;
		            }
		        } while (ch);
		    },
		        blockComment = function blockComment() {
	
		        // Skip a block comment, assuming this is one. The current character should be
		        // the * character in the /* pair that begins this block comment.
		        // To finish the block comment, we look for an ending */ pair of characters,
		        // but we also watch for the end of text before the comment is terminated.
	
		        if (ch !== '*') {
		            error("Not a block comment");
		        }
	
		        do {
		            next();
		            while (ch === '*') {
		                next('*');
		                if (ch === '/') {
		                    next('/');
		                    return;
		                }
		            }
		        } while (ch);
	
		        error("Unterminated block comment");
		    },
		        comment = function comment() {
	
		        // Skip a comment, whether inline or block-level, assuming this is one.
		        // Comments always begin with a / character.
	
		        if (ch !== '/') {
		            error("Not a comment");
		        }
	
		        next('/');
	
		        if (ch === '/') {
		            inlineComment();
		        } else if (ch === '*') {
		            blockComment();
		        } else {
		            error("Unrecognized comment");
		        }
		    },
		        white = function white() {
	
		        // Skip whitespace and comments.
		        // Note that we're detecting comments by only a single / character.
		        // This works since regular expressions are not valid JSON(5), but this will
		        // break if there are other valid values that begin with a / character!
	
		        while (ch) {
		            if (ch === '/') {
		                comment();
		            } else if (ws.indexOf(ch) >= 0) {
		                next();
		            } else {
		                return;
		            }
		        }
		    },
		        word = function word() {
	
		        // true, false, or null.
	
		        switch (ch) {
		            case 't':
		                next('t');
		                next('r');
		                next('u');
		                next('e');
		                return true;
		            case 'f':
		                next('f');
		                next('a');
		                next('l');
		                next('s');
		                next('e');
		                return false;
		            case 'n':
		                next('n');
		                next('u');
		                next('l');
		                next('l');
		                return null;
		            case 'I':
		                next('I');
		                next('n');
		                next('f');
		                next('i');
		                next('n');
		                next('i');
		                next('t');
		                next('y');
		                return Infinity;
		            case 'N':
		                next('N');
		                next('a');
		                next('N');
		                return NaN;
		        }
		        error("Unexpected " + renderChar(ch));
		    },
		        value,
		        // Place holder for the value function.
	
		    array = function array() {
	
		        // Parse an array value.
	
		        var array = [];
	
		        if (ch === '[') {
		            next('[');
		            white();
		            while (ch) {
		                if (ch === ']') {
		                    next(']');
		                    return array; // Potentially empty array
		                }
		                // ES5 allows omitting elements in arrays, e.g. [,] and
		                // [,null]. We don't allow this in JSON5.
		                if (ch === ',') {
		                    error("Missing array element");
		                } else {
		                    array.push(value());
		                }
		                white();
		                // If there's no comma after this value, this needs to
		                // be the end of the array.
		                if (ch !== ',') {
		                    next(']');
		                    return array;
		                }
		                next(',');
		                white();
		            }
		        }
		        error("Bad array");
		    },
		        object = function object() {
	
		        // Parse an object value.
	
		        var key,
		            object = {};
	
		        if (ch === '{') {
		            next('{');
		            white();
		            while (ch) {
		                if (ch === '}') {
		                    next('}');
		                    return object; // Potentially empty object
		                }
	
		                // Keys can be unquoted. If they are, they need to be
		                // valid JS identifiers.
		                if (ch === '"' || ch === "'") {
		                    key = string();
		                } else {
		                    key = identifier();
		                }
	
		                white();
		                next(':');
		                object[key] = value();
		                white();
		                // If there's no comma after this pair, this needs to be
		                // the end of the object.
		                if (ch !== ',') {
		                    next('}');
		                    return object;
		                }
		                next(',');
		                white();
		            }
		        }
		        error("Bad object");
		    };
	
		    value = function value() {
	
		        // Parse a JSON value. It could be an object, an array, a string, a number,
		        // or a word.
	
		        white();
		        switch (ch) {
		            case '{':
		                return object();
		            case '[':
		                return array();
		            case '"':
		            case "'":
		                return string();
		            case '-':
		            case '+':
		            case '.':
		                return number();
		            default:
		                return ch >= '0' && ch <= '9' ? number() : word();
		        }
		    };
	
		    // Return the json_parse function. It will have access to all of the above
		    // functions and variables.
	
		    return function (source, reviver) {
		        var result;
	
		        text = String(source);
		        at = 0;
		        lineNumber = 1;
		        columnNumber = 1;
		        ch = ' ';
		        result = value();
		        white();
		        if (ch) {
		            error("Syntax error");
		        }
	
		        // If there is a reviver function, we recursively walk the new structure,
		        // passing each name/value pair to the reviver function for possible
		        // transformation, starting with a temporary root object that holds the result
		        // in an empty key. If there is not a reviver function, we simply return the
		        // result.
	
		        return typeof reviver === 'function' ? function walk(holder, key) {
		            var k,
		                v,
		                value = holder[key];
		            if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object') {
		                for (k in value) {
		                    if (Object.prototype.hasOwnProperty.call(value, k)) {
		                        v = walk(value, k);
		                        if (v !== undefined) {
		                            value[k] = v;
		                        } else {
		                            delete value[k];
		                        }
		                    }
		                }
		            }
		            return reviver.call(holder, key, value);
		        }({ '': result }, '') : result;
		    };
		}();
	
		// JSON5 stringify will not quote keys where appropriate
		JSON5.stringify = function (obj, replacer, space) {
		    if (replacer && typeof replacer !== "function" && !isArray(replacer)) {
		        throw new Error('Replacer must be a function or an array');
		    }
		    var getReplacedValueOrUndefined = function getReplacedValueOrUndefined(holder, key, isTopLevel) {
		        var value = holder[key];
	
		        // Replace the value with its toJSON value first, if possible
		        if (value && value.toJSON && typeof value.toJSON === "function") {
		            value = value.toJSON();
		        }
	
		        // If the user-supplied replacer if a function, call it. If it's an array, check objects' string keys for
		        // presence in the array (removing the key/value pair from the resulting JSON if the key is missing).
		        if (typeof replacer === "function") {
		            return replacer.call(holder, key, value);
		        } else if (replacer) {
		            if (isTopLevel || isArray(holder) || replacer.indexOf(key) >= 0) {
		                return value;
		            } else {
		                return undefined;
		            }
		        } else {
		            return value;
		        }
		    };
	
		    function isWordChar(c) {
		        return c >= 'a' && c <= 'z' || c >= 'A' && c <= 'Z' || c >= '0' && c <= '9' || c === '_' || c === '$';
		    }
	
		    function isWordStart(c) {
		        return c >= 'a' && c <= 'z' || c >= 'A' && c <= 'Z' || c === '_' || c === '$';
		    }
	
		    function isWord(key) {
		        if (typeof key !== 'string') {
		            return false;
		        }
		        if (!isWordStart(key[0])) {
		            return false;
		        }
		        var i = 1,
		            length = key.length;
		        while (i < length) {
		            if (!isWordChar(key[i])) {
		                return false;
		            }
		            i++;
		        }
		        return true;
		    }
	
		    // export for use in tests
		    JSON5.isWord = isWord;
	
		    // polyfills
		    function isArray(obj) {
		        if (Array.isArray) {
		            return Array.isArray(obj);
		        } else {
		            return Object.prototype.toString.call(obj) === '[object Array]';
		        }
		    }
	
		    function isDate(obj) {
		        return Object.prototype.toString.call(obj) === '[object Date]';
		    }
	
		    var objStack = [];
		    function checkForCircular(obj) {
		        for (var i = 0; i < objStack.length; i++) {
		            if (objStack[i] === obj) {
		                throw new TypeError("Converting circular structure to JSON");
		            }
		        }
		    }
	
		    function makeIndent(str, num, noNewLine) {
		        if (!str) {
		            return "";
		        }
		        // indentation no more than 10 chars
		        if (str.length > 10) {
		            str = str.substring(0, 10);
		        }
	
		        var indent = noNewLine ? "" : "\n";
		        for (var i = 0; i < num; i++) {
		            indent += str;
		        }
	
		        return indent;
		    }
	
		    var indentStr;
		    if (space) {
		        if (typeof space === "string") {
		            indentStr = space;
		        } else if (typeof space === "number" && space >= 0) {
		            indentStr = makeIndent(" ", space, true);
		        } else {
		            // ignore space parameter
		        }
		    }
	
		    // Copied from Crokford's implementation of JSON
		    // See https://github.com/douglascrockford/JSON-js/blob/e39db4b7e6249f04a195e7dd0840e610cc9e941e/json2.js#L195
		    // Begin
		    var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
		        escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
		        meta = { // table of character substitutions
		        '\b': '\\b',
		        '\t': '\\t',
		        '\n': '\\n',
		        '\f': '\\f',
		        '\r': '\\r',
		        '"': '\\"',
		        '\\': '\\\\'
		    };
		    function escapeString(string) {
	
		        // If the string contains no control characters, no quote characters, and no
		        // backslash characters, then we can safely slap some quotes around it.
		        // Otherwise we must also replace the offending characters with safe escape
		        // sequences.
		        escapable.lastIndex = 0;
		        return escapable.test(string) ? '"' + string.replace(escapable, function (a) {
		            var c = meta[a];
		            return typeof c === 'string' ? c : "\\u" + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
		        }) + '"' : '"' + string + '"';
		    }
		    // End
	
		    function internalStringify(holder, key, isTopLevel) {
		        var buffer, res;
	
		        // Replace the value, if necessary
		        var obj_part = getReplacedValueOrUndefined(holder, key, isTopLevel);
	
		        if (obj_part && !isDate(obj_part)) {
		            // unbox objects
		            // don't unbox dates, since will turn it into number
		            obj_part = obj_part.valueOf();
		        }
		        switch (typeof obj_part === "undefined" ? "undefined" : _typeof(obj_part)) {
		            case "boolean":
		                return obj_part.toString();
	
		            case "number":
		                if (isNaN(obj_part) || !isFinite(obj_part)) {
		                    return "null";
		                }
		                return obj_part.toString();
	
		            case "string":
		                return escapeString(obj_part.toString());
	
		            case "object":
		                if (obj_part === null) {
		                    return "null";
		                } else if (isArray(obj_part)) {
		                    checkForCircular(obj_part);
		                    buffer = "[";
		                    objStack.push(obj_part);
	
		                    for (var i = 0; i < obj_part.length; i++) {
		                        res = internalStringify(obj_part, i, false);
		                        buffer += makeIndent(indentStr, objStack.length);
		                        if (res === null || typeof res === "undefined") {
		                            buffer += "null";
		                        } else {
		                            buffer += res;
		                        }
		                        if (i < obj_part.length - 1) {
		                            buffer += ",";
		                        } else if (indentStr) {
		                            buffer += "\n";
		                        }
		                    }
		                    objStack.pop();
		                    if (obj_part.length) {
		                        buffer += makeIndent(indentStr, objStack.length, true);
		                    }
		                    buffer += "]";
		                } else {
		                    checkForCircular(obj_part);
		                    buffer = "{";
		                    var nonEmpty = false;
		                    objStack.push(obj_part);
		                    for (var prop in obj_part) {
		                        if (obj_part.hasOwnProperty(prop)) {
		                            var value = internalStringify(obj_part, prop, false);
		                            isTopLevel = false;
		                            if (typeof value !== "undefined" && value !== null) {
		                                buffer += makeIndent(indentStr, objStack.length);
		                                nonEmpty = true;
		                                key = isWord(prop) ? prop : escapeString(prop);
		                                buffer += key + ":" + (indentStr ? ' ' : '') + value + ",";
		                            }
		                        }
		                    }
		                    objStack.pop();
		                    if (nonEmpty) {
		                        buffer = buffer.substring(0, buffer.length - 1) + makeIndent(indentStr, objStack.length) + "}";
		                    } else {
		                        buffer = '{}';
		                    }
		                }
		                return buffer;
		            default:
		                // functions and undefined should be ignored
		                return undefined;
		        }
		    }
	
		    // special case...when undefined is used inside of
		    // a compound object/array, return null.
		    // but when top-level, return undefined
		    var topLevelHolder = { "": obj };
		    if (obj === undefined) {
		        return getReplacedValueOrUndefined(topLevelHolder, '', true);
		    }
		    return internalStringify(topLevelHolder, '', true);
		};
	
	/***/ }),
	/* 471 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var arr = [];
		var charCodeCache = [];
	
		module.exports = function (a, b) {
			if (a === b) {
				return 0;
			}
	
			var aLen = a.length;
			var bLen = b.length;
	
			if (aLen === 0) {
				return bLen;
			}
	
			if (bLen === 0) {
				return aLen;
			}
	
			var bCharCode;
			var ret;
			var tmp;
			var tmp2;
			var i = 0;
			var j = 0;
	
			while (i < aLen) {
				charCodeCache[i] = a.charCodeAt(i);
				arr[i] = ++i;
			}
	
			while (j < bLen) {
				bCharCode = b.charCodeAt(j);
				tmp = j++;
				ret = j;
	
				for (i = 0; i < aLen; i++) {
					tmp2 = bCharCode === charCodeCache[i] ? tmp : tmp + 1;
					tmp = arr[i];
					ret = arr[i] = tmp > ret ? tmp2 > ret ? ret + 1 : tmp2 : tmp2 > tmp ? tmp + 1 : tmp2;
				}
			}
	
			return ret;
		};
	
	/***/ }),
	/* 472 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var getNative = __webpack_require__(38),
		    root = __webpack_require__(17);
	
		/* Built-in method references that are verified to be native. */
		var DataView = getNative(root, 'DataView');
	
		module.exports = DataView;
	
	/***/ }),
	/* 473 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var hashClear = __webpack_require__(536),
		    hashDelete = __webpack_require__(537),
		    hashGet = __webpack_require__(538),
		    hashHas = __webpack_require__(539),
		    hashSet = __webpack_require__(540);
	
		/**
		 * Creates a hash object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Hash(entries) {
		    var index = -1,
		        length = entries == null ? 0 : entries.length;
	
		    this.clear();
		    while (++index < length) {
		        var entry = entries[index];
		        this.set(entry[0], entry[1]);
		    }
		}
	
		// Add methods to `Hash`.
		Hash.prototype.clear = hashClear;
		Hash.prototype['delete'] = hashDelete;
		Hash.prototype.get = hashGet;
		Hash.prototype.has = hashHas;
		Hash.prototype.set = hashSet;
	
		module.exports = Hash;
	
	/***/ }),
	/* 474 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var getNative = __webpack_require__(38),
		    root = __webpack_require__(17);
	
		/* Built-in method references that are verified to be native. */
		var Promise = getNative(root, 'Promise');
	
		module.exports = Promise;
	
	/***/ }),
	/* 475 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var getNative = __webpack_require__(38),
		    root = __webpack_require__(17);
	
		/* Built-in method references that are verified to be native. */
		var WeakMap = getNative(root, 'WeakMap');
	
		module.exports = WeakMap;
	
	/***/ }),
	/* 476 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Adds the key-value `pair` to `map`.
		 *
		 * @private
		 * @param {Object} map The map to modify.
		 * @param {Array} pair The key-value pair to add.
		 * @returns {Object} Returns `map`.
		 */
		function addMapEntry(map, pair) {
		  // Don't return `map.set` because it's not chainable in IE 11.
		  map.set(pair[0], pair[1]);
		  return map;
		}
	
		module.exports = addMapEntry;
	
	/***/ }),
	/* 477 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Adds `value` to `set`.
		 *
		 * @private
		 * @param {Object} set The set to modify.
		 * @param {*} value The value to add.
		 * @returns {Object} Returns `set`.
		 */
		function addSetEntry(set, value) {
		  // Don't return `set.add` because it's not chainable in IE 11.
		  set.add(value);
		  return set;
		}
	
		module.exports = addSetEntry;
	
	/***/ }),
	/* 478 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * A specialized version of `_.forEach` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns `array`.
		 */
		function arrayEach(array, iteratee) {
		  var index = -1,
		      length = array == null ? 0 : array.length;
	
		  while (++index < length) {
		    if (iteratee(array[index], index, array) === false) {
		      break;
		    }
		  }
		  return array;
		}
	
		module.exports = arrayEach;
	
	/***/ }),
	/* 479 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * A specialized version of `_.filter` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {Array} Returns the new filtered array.
		 */
		function arrayFilter(array, predicate) {
		  var index = -1,
		      length = array == null ? 0 : array.length,
		      resIndex = 0,
		      result = [];
	
		  while (++index < length) {
		    var value = array[index];
		    if (predicate(value, index, array)) {
		      result[resIndex++] = value;
		    }
		  }
		  return result;
		}
	
		module.exports = arrayFilter;
	
	/***/ }),
	/* 480 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseIndexOf = __webpack_require__(166);
	
		/**
		 * A specialized version of `_.includes` for arrays without support for
		 * specifying an index to search from.
		 *
		 * @private
		 * @param {Array} [array] The array to inspect.
		 * @param {*} target The value to search for.
		 * @returns {boolean} Returns `true` if `target` is found, else `false`.
		 */
		function arrayIncludes(array, value) {
		  var length = array == null ? 0 : array.length;
		  return !!length && baseIndexOf(array, value, 0) > -1;
		}
	
		module.exports = arrayIncludes;
	
	/***/ }),
	/* 481 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * This function is like `arrayIncludes` except that it accepts a comparator.
		 *
		 * @private
		 * @param {Array} [array] The array to inspect.
		 * @param {*} target The value to search for.
		 * @param {Function} comparator The comparator invoked per element.
		 * @returns {boolean} Returns `true` if `target` is found, else `false`.
		 */
		function arrayIncludesWith(array, value, comparator) {
		  var index = -1,
		      length = array == null ? 0 : array.length;
	
		  while (++index < length) {
		    if (comparator(value, array[index])) {
		      return true;
		    }
		  }
		  return false;
		}
	
		module.exports = arrayIncludesWith;
	
	/***/ }),
	/* 482 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * A specialized version of `_.some` for arrays without support for iteratee
		 * shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {boolean} Returns `true` if any element passes the predicate check,
		 *  else `false`.
		 */
		function arraySome(array, predicate) {
		  var index = -1,
		      length = array == null ? 0 : array.length;
	
		  while (++index < length) {
		    if (predicate(array[index], index, array)) {
		      return true;
		    }
		  }
		  return false;
		}
	
		module.exports = arraySome;
	
	/***/ }),
	/* 483 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var copyObject = __webpack_require__(31),
		    keys = __webpack_require__(32);
	
		/**
		 * The base implementation of `_.assign` without support for multiple sources
		 * or `customizer` functions.
		 *
		 * @private
		 * @param {Object} object The destination object.
		 * @param {Object} source The source object.
		 * @returns {Object} Returns `object`.
		 */
		function baseAssign(object, source) {
		  return object && copyObject(source, keys(source), object);
		}
	
		module.exports = baseAssign;
	
	/***/ }),
	/* 484 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var copyObject = __webpack_require__(31),
		    keysIn = __webpack_require__(47);
	
		/**
		 * The base implementation of `_.assignIn` without support for multiple sources
		 * or `customizer` functions.
		 *
		 * @private
		 * @param {Object} object The destination object.
		 * @param {Object} source The source object.
		 * @returns {Object} Returns `object`.
		 */
		function baseAssignIn(object, source) {
		  return object && copyObject(source, keysIn(source), object);
		}
	
		module.exports = baseAssignIn;
	
	/***/ }),
	/* 485 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * The base implementation of `_.clamp` which doesn't coerce arguments.
		 *
		 * @private
		 * @param {number} number The number to clamp.
		 * @param {number} [lower] The lower bound.
		 * @param {number} upper The upper bound.
		 * @returns {number} Returns the clamped number.
		 */
		function baseClamp(number, lower, upper) {
		  if (number === number) {
		    if (upper !== undefined) {
		      number = number <= upper ? number : upper;
		    }
		    if (lower !== undefined) {
		      number = number >= lower ? number : lower;
		    }
		  }
		  return number;
		}
	
		module.exports = baseClamp;
	
	/***/ }),
	/* 486 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isObject = __webpack_require__(18);
	
		/** Built-in value references. */
		var objectCreate = Object.create;
	
		/**
		 * The base implementation of `_.create` without support for assigning
		 * properties to the created object.
		 *
		 * @private
		 * @param {Object} proto The object to inherit from.
		 * @returns {Object} Returns the new object.
		 */
		var baseCreate = function () {
		  function object() {}
		  return function (proto) {
		    if (!isObject(proto)) {
		      return {};
		    }
		    if (objectCreate) {
		      return objectCreate(proto);
		    }
		    object.prototype = proto;
		    var result = new object();
		    object.prototype = undefined;
		    return result;
		  };
		}();
	
		module.exports = baseCreate;
	
	/***/ }),
	/* 487 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseForOwn = __webpack_require__(489),
		    createBaseEach = __webpack_require__(526);
	
		/**
		 * The base implementation of `_.forEach` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Array|Object} collection The collection to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array|Object} Returns `collection`.
		 */
		var baseEach = createBaseEach(baseForOwn);
	
		module.exports = baseEach;
	
	/***/ }),
	/* 488 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var arrayPush = __webpack_require__(161),
		    isFlattenable = __webpack_require__(543);
	
		/**
		 * The base implementation of `_.flatten` with support for restricting flattening.
		 *
		 * @private
		 * @param {Array} array The array to flatten.
		 * @param {number} depth The maximum recursion depth.
		 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
		 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
		 * @param {Array} [result=[]] The initial result value.
		 * @returns {Array} Returns the new flattened array.
		 */
		function baseFlatten(array, depth, predicate, isStrict, result) {
		  var index = -1,
		      length = array.length;
	
		  predicate || (predicate = isFlattenable);
		  result || (result = []);
	
		  while (++index < length) {
		    var value = array[index];
		    if (depth > 0 && predicate(value)) {
		      if (depth > 1) {
		        // Recursively flatten arrays (susceptible to call stack limits).
		        baseFlatten(value, depth - 1, predicate, isStrict, result);
		      } else {
		        arrayPush(result, value);
		      }
		    } else if (!isStrict) {
		      result[result.length] = value;
		    }
		  }
		  return result;
		}
	
		module.exports = baseFlatten;
	
	/***/ }),
	/* 489 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseFor = __webpack_require__(248),
		    keys = __webpack_require__(32);
	
		/**
		 * The base implementation of `_.forOwn` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Object} object The object to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Object} Returns `object`.
		 */
		function baseForOwn(object, iteratee) {
		  return object && baseFor(object, iteratee, keys);
		}
	
		module.exports = baseForOwn;
	
	/***/ }),
	/* 490 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * The base implementation of `_.has` without support for deep paths.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {Array|string} key The key to check.
		 * @returns {boolean} Returns `true` if `key` exists, else `false`.
		 */
		function baseHas(object, key) {
		  return object != null && hasOwnProperty.call(object, key);
		}
	
		module.exports = baseHas;
	
	/***/ }),
	/* 491 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * The base implementation of `_.hasIn` without support for deep paths.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {Array|string} key The key to check.
		 * @returns {boolean} Returns `true` if `key` exists, else `false`.
		 */
		function baseHasIn(object, key) {
		  return object != null && key in Object(object);
		}
	
		module.exports = baseHasIn;
	
	/***/ }),
	/* 492 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * This function is like `baseIndexOf` except that it accepts a comparator.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} value The value to search for.
		 * @param {number} fromIndex The index to search from.
		 * @param {Function} comparator The comparator invoked per element.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function baseIndexOfWith(array, value, fromIndex, comparator) {
		  var index = fromIndex - 1,
		      length = array.length;
	
		  while (++index < length) {
		    if (comparator(array[index], value)) {
		      return index;
		    }
		  }
		  return -1;
		}
	
		module.exports = baseIndexOfWith;
	
	/***/ }),
	/* 493 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseGetTag = __webpack_require__(30),
		    isObjectLike = __webpack_require__(25);
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]';
	
		/**
		 * The base implementation of `_.isArguments`.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 */
		function baseIsArguments(value) {
		  return isObjectLike(value) && baseGetTag(value) == argsTag;
		}
	
		module.exports = baseIsArguments;
	
	/***/ }),
	/* 494 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var Stack = __webpack_require__(99),
		    equalArrays = __webpack_require__(260),
		    equalByTag = __webpack_require__(530),
		    equalObjects = __webpack_require__(531),
		    getTag = __webpack_require__(264),
		    isArray = __webpack_require__(6),
		    isBuffer = __webpack_require__(113),
		    isTypedArray = __webpack_require__(177);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1;
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    objectTag = '[object Object]';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * A specialized version of `baseIsEqual` for arrays and objects which performs
		 * deep comparisons and tracks traversed objects enabling objects with circular
		 * references to be compared.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
		  var objIsArr = isArray(object),
		      othIsArr = isArray(other),
		      objTag = objIsArr ? arrayTag : getTag(object),
		      othTag = othIsArr ? arrayTag : getTag(other);
	
		  objTag = objTag == argsTag ? objectTag : objTag;
		  othTag = othTag == argsTag ? objectTag : othTag;
	
		  var objIsObj = objTag == objectTag,
		      othIsObj = othTag == objectTag,
		      isSameTag = objTag == othTag;
	
		  if (isSameTag && isBuffer(object)) {
		    if (!isBuffer(other)) {
		      return false;
		    }
		    objIsArr = true;
		    objIsObj = false;
		  }
		  if (isSameTag && !objIsObj) {
		    stack || (stack = new Stack());
		    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
		  }
		  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
		    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
		        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
		    if (objIsWrapped || othIsWrapped) {
		      var objUnwrapped = objIsWrapped ? object.value() : object,
		          othUnwrapped = othIsWrapped ? other.value() : other;
	
		      stack || (stack = new Stack());
		      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
		    }
		  }
		  if (!isSameTag) {
		    return false;
		  }
		  stack || (stack = new Stack());
		  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
		}
	
		module.exports = baseIsEqualDeep;
	
	/***/ }),
	/* 495 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var Stack = __webpack_require__(99),
		    baseIsEqual = __webpack_require__(251);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1,
		    COMPARE_UNORDERED_FLAG = 2;
	
		/**
		 * The base implementation of `_.isMatch` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Object} object The object to inspect.
		 * @param {Object} source The object of property values to match.
		 * @param {Array} matchData The property names, values, and compare flags to match.
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
		 */
		function baseIsMatch(object, source, matchData, customizer) {
		  var index = matchData.length,
		      length = index,
		      noCustomizer = !customizer;
	
		  if (object == null) {
		    return !length;
		  }
		  object = Object(object);
		  while (index--) {
		    var data = matchData[index];
		    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
		      return false;
		    }
		  }
		  while (++index < length) {
		    data = matchData[index];
		    var key = data[0],
		        objValue = object[key],
		        srcValue = data[1];
	
		    if (noCustomizer && data[2]) {
		      if (objValue === undefined && !(key in object)) {
		        return false;
		      }
		    } else {
		      var stack = new Stack();
		      if (customizer) {
		        var result = customizer(objValue, srcValue, key, object, source, stack);
		      }
		      if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
		        return false;
		      }
		    }
		  }
		  return true;
		}
	
		module.exports = baseIsMatch;
	
	/***/ }),
	/* 496 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * The base implementation of `_.isNaN` without support for number objects.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
		 */
		function baseIsNaN(value) {
		  return value !== value;
		}
	
		module.exports = baseIsNaN;
	
	/***/ }),
	/* 497 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isFunction = __webpack_require__(175),
		    isMasked = __webpack_require__(545),
		    isObject = __webpack_require__(18),
		    toSource = __webpack_require__(272);
	
		/**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
		 */
		var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
		/** Used to detect host constructors (Safari). */
		var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
		/** Used for built-in method references. */
		var funcProto = Function.prototype,
		    objectProto = Object.prototype;
	
		/** Used to resolve the decompiled source of functions. */
		var funcToString = funcProto.toString;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Used to detect if a method is native. */
		var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	
		/**
		 * The base implementation of `_.isNative` without bad shim checks.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function,
		 *  else `false`.
		 */
		function baseIsNative(value) {
		  if (!isObject(value) || isMasked(value)) {
		    return false;
		  }
		  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
		  return pattern.test(toSource(value));
		}
	
		module.exports = baseIsNative;
	
	/***/ }),
	/* 498 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseGetTag = __webpack_require__(30),
		    isObjectLike = __webpack_require__(25);
	
		/** `Object#toString` result references. */
		var regexpTag = '[object RegExp]';
	
		/**
		 * The base implementation of `_.isRegExp` without Node.js optimizations.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
		 */
		function baseIsRegExp(value) {
		  return isObjectLike(value) && baseGetTag(value) == regexpTag;
		}
	
		module.exports = baseIsRegExp;
	
	/***/ }),
	/* 499 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseGetTag = __webpack_require__(30),
		    isLength = __webpack_require__(176),
		    isObjectLike = __webpack_require__(25);
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    funcTag = '[object Function]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    objectTag = '[object Object]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    weakMapTag = '[object WeakMap]';
	
		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';
	
		/** Used to identify `toStringTag` values of typed arrays. */
		var typedArrayTags = {};
		typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
		typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
		/**
		 * The base implementation of `_.isTypedArray` without Node.js optimizations.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 */
		function baseIsTypedArray(value) {
		    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
		}
	
		module.exports = baseIsTypedArray;
	
	/***/ }),
	/* 500 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isPrototype = __webpack_require__(105),
		    nativeKeys = __webpack_require__(557);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeys(object) {
		  if (!isPrototype(object)) {
		    return nativeKeys(object);
		  }
		  var result = [];
		  for (var key in Object(object)) {
		    if (hasOwnProperty.call(object, key) && key != 'constructor') {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		module.exports = baseKeys;
	
	/***/ }),
	/* 501 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isObject = __webpack_require__(18),
		    isPrototype = __webpack_require__(105),
		    nativeKeysIn = __webpack_require__(558);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeysIn(object) {
		  if (!isObject(object)) {
		    return nativeKeysIn(object);
		  }
		  var isProto = isPrototype(object),
		      result = [];
	
		  for (var key in object) {
		    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		module.exports = baseKeysIn;
	
	/***/ }),
	/* 502 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseIsMatch = __webpack_require__(495),
		    getMatchData = __webpack_require__(533),
		    matchesStrictComparable = __webpack_require__(269);
	
		/**
		 * The base implementation of `_.matches` which doesn't clone `source`.
		 *
		 * @private
		 * @param {Object} source The object of property values to match.
		 * @returns {Function} Returns the new spec function.
		 */
		function baseMatches(source) {
		  var matchData = getMatchData(source);
		  if (matchData.length == 1 && matchData[0][2]) {
		    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
		  }
		  return function (object) {
		    return object === source || baseIsMatch(object, source, matchData);
		  };
		}
	
		module.exports = baseMatches;
	
	/***/ }),
	/* 503 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseIsEqual = __webpack_require__(251),
		    get = __webpack_require__(583),
		    hasIn = __webpack_require__(584),
		    isKey = __webpack_require__(173),
		    isStrictComparable = __webpack_require__(267),
		    matchesStrictComparable = __webpack_require__(269),
		    toKey = __webpack_require__(108);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1,
		    COMPARE_UNORDERED_FLAG = 2;
	
		/**
		 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
		 *
		 * @private
		 * @param {string} path The path of the property to get.
		 * @param {*} srcValue The value to match.
		 * @returns {Function} Returns the new spec function.
		 */
		function baseMatchesProperty(path, srcValue) {
		  if (isKey(path) && isStrictComparable(srcValue)) {
		    return matchesStrictComparable(toKey(path), srcValue);
		  }
		  return function (object) {
		    var objValue = get(object, path);
		    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
		  };
		}
	
		module.exports = baseMatchesProperty;
	
	/***/ }),
	/* 504 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var Stack = __webpack_require__(99),
		    assignMergeValue = __webpack_require__(247),
		    baseFor = __webpack_require__(248),
		    baseMergeDeep = __webpack_require__(505),
		    isObject = __webpack_require__(18),
		    keysIn = __webpack_require__(47);
	
		/**
		 * The base implementation of `_.merge` without support for multiple sources.
		 *
		 * @private
		 * @param {Object} object The destination object.
		 * @param {Object} source The source object.
		 * @param {number} srcIndex The index of `source`.
		 * @param {Function} [customizer] The function to customize merged values.
		 * @param {Object} [stack] Tracks traversed source values and their merged
		 *  counterparts.
		 */
		function baseMerge(object, source, srcIndex, customizer, stack) {
		  if (object === source) {
		    return;
		  }
		  baseFor(source, function (srcValue, key) {
		    if (isObject(srcValue)) {
		      stack || (stack = new Stack());
		      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
		    } else {
		      var newValue = customizer ? customizer(object[key], srcValue, key + '', object, source, stack) : undefined;
	
		      if (newValue === undefined) {
		        newValue = srcValue;
		      }
		      assignMergeValue(object, key, newValue);
		    }
		  }, keysIn);
		}
	
		module.exports = baseMerge;
	
	/***/ }),
	/* 505 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var assignMergeValue = __webpack_require__(247),
		    cloneBuffer = __webpack_require__(256),
		    cloneTypedArray = __webpack_require__(257),
		    copyArray = __webpack_require__(168),
		    initCloneObject = __webpack_require__(266),
		    isArguments = __webpack_require__(112),
		    isArray = __webpack_require__(6),
		    isArrayLikeObject = __webpack_require__(585),
		    isBuffer = __webpack_require__(113),
		    isFunction = __webpack_require__(175),
		    isObject = __webpack_require__(18),
		    isPlainObject = __webpack_require__(275),
		    isTypedArray = __webpack_require__(177),
		    toPlainObject = __webpack_require__(599);
	
		/**
		 * A specialized version of `baseMerge` for arrays and objects which performs
		 * deep merges and tracks traversed objects enabling objects with circular
		 * references to be merged.
		 *
		 * @private
		 * @param {Object} object The destination object.
		 * @param {Object} source The source object.
		 * @param {string} key The key of the value to merge.
		 * @param {number} srcIndex The index of `source`.
		 * @param {Function} mergeFunc The function to merge values.
		 * @param {Function} [customizer] The function to customize assigned values.
		 * @param {Object} [stack] Tracks traversed source values and their merged
		 *  counterparts.
		 */
		function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
		  var objValue = object[key],
		      srcValue = source[key],
		      stacked = stack.get(srcValue);
	
		  if (stacked) {
		    assignMergeValue(object, key, stacked);
		    return;
		  }
		  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
	
		  var isCommon = newValue === undefined;
	
		  if (isCommon) {
		    var isArr = isArray(srcValue),
		        isBuff = !isArr && isBuffer(srcValue),
		        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
		    newValue = srcValue;
		    if (isArr || isBuff || isTyped) {
		      if (isArray(objValue)) {
		        newValue = objValue;
		      } else if (isArrayLikeObject(objValue)) {
		        newValue = copyArray(objValue);
		      } else if (isBuff) {
		        isCommon = false;
		        newValue = cloneBuffer(srcValue, true);
		      } else if (isTyped) {
		        isCommon = false;
		        newValue = cloneTypedArray(srcValue, true);
		      } else {
		        newValue = [];
		      }
		    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
		      newValue = objValue;
		      if (isArguments(objValue)) {
		        newValue = toPlainObject(objValue);
		      } else if (!isObject(objValue) || srcIndex && isFunction(objValue)) {
		        newValue = initCloneObject(srcValue);
		      }
		    } else {
		      isCommon = false;
		    }
		  }
		  if (isCommon) {
		    // Recursively merge objects and arrays (susceptible to call stack limits).
		    stack.set(srcValue, newValue);
		    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
		    stack['delete'](srcValue);
		  }
		  assignMergeValue(object, key, newValue);
		}
	
		module.exports = baseMergeDeep;
	
	/***/ }),
	/* 506 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var arrayMap = __webpack_require__(60),
		    baseIteratee = __webpack_require__(61),
		    baseMap = __webpack_require__(252),
		    baseSortBy = __webpack_require__(512),
		    baseUnary = __webpack_require__(102),
		    compareMultiple = __webpack_require__(522),
		    identity = __webpack_require__(110);
	
		/**
		 * The base implementation of `_.orderBy` without param guards.
		 *
		 * @private
		 * @param {Array|Object} collection The collection to iterate over.
		 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
		 * @param {string[]} orders The sort orders of `iteratees`.
		 * @returns {Array} Returns the new sorted array.
		 */
		function baseOrderBy(collection, iteratees, orders) {
		  var index = -1;
		  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
		  var result = baseMap(collection, function (value, key, collection) {
		    var criteria = arrayMap(iteratees, function (iteratee) {
		      return iteratee(value);
		    });
		    return { 'criteria': criteria, 'index': ++index, 'value': value };
		  });
	
		  return baseSortBy(result, function (object, other) {
		    return compareMultiple(object, other, orders);
		  });
		}
	
		module.exports = baseOrderBy;
	
	/***/ }),
	/* 507 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * The base implementation of `_.property` without support for deep paths.
		 *
		 * @private
		 * @param {string} key The key of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 */
		function baseProperty(key) {
		  return function (object) {
		    return object == null ? undefined : object[key];
		  };
		}
	
		module.exports = baseProperty;
	
	/***/ }),
	/* 508 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseGet = __webpack_require__(249);
	
		/**
		 * A specialized version of `baseProperty` which supports deep paths.
		 *
		 * @private
		 * @param {Array|string} path The path of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 */
		function basePropertyDeep(path) {
		  return function (object) {
		    return baseGet(object, path);
		  };
		}
	
		module.exports = basePropertyDeep;
	
	/***/ }),
	/* 509 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var arrayMap = __webpack_require__(60),
		    baseIndexOf = __webpack_require__(166),
		    baseIndexOfWith = __webpack_require__(492),
		    baseUnary = __webpack_require__(102),
		    copyArray = __webpack_require__(168);
	
		/** Used for built-in method references. */
		var arrayProto = Array.prototype;
	
		/** Built-in value references. */
		var splice = arrayProto.splice;
	
		/**
		 * The base implementation of `_.pullAllBy` without support for iteratee
		 * shorthands.
		 *
		 * @private
		 * @param {Array} array The array to modify.
		 * @param {Array} values The values to remove.
		 * @param {Function} [iteratee] The iteratee invoked per element.
		 * @param {Function} [comparator] The comparator invoked per element.
		 * @returns {Array} Returns `array`.
		 */
		function basePullAll(array, values, iteratee, comparator) {
		  var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
		      index = -1,
		      length = values.length,
		      seen = array;
	
		  if (array === values) {
		    values = copyArray(values);
		  }
		  if (iteratee) {
		    seen = arrayMap(array, baseUnary(iteratee));
		  }
		  while (++index < length) {
		    var fromIndex = 0,
		        value = values[index],
		        computed = iteratee ? iteratee(value) : value;
	
		    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
		      if (seen !== array) {
		        splice.call(seen, fromIndex, 1);
		      }
		      splice.call(array, fromIndex, 1);
		    }
		  }
		  return array;
		}
	
		module.exports = basePullAll;
	
	/***/ }),
	/* 510 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeFloor = Math.floor;
	
		/**
		 * The base implementation of `_.repeat` which doesn't coerce arguments.
		 *
		 * @private
		 * @param {string} string The string to repeat.
		 * @param {number} n The number of times to repeat the string.
		 * @returns {string} Returns the repeated string.
		 */
		function baseRepeat(string, n) {
		  var result = '';
		  if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
		    return result;
		  }
		  // Leverage the exponentiation by squaring algorithm for a faster repeat.
		  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
		  do {
		    if (n % 2) {
		      result += string;
		    }
		    n = nativeFloor(n / 2);
		    if (n) {
		      string += string;
		    }
		  } while (n);
	
		  return result;
		}
	
		module.exports = baseRepeat;
	
	/***/ }),
	/* 511 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var constant = __webpack_require__(576),
		    defineProperty = __webpack_require__(259),
		    identity = __webpack_require__(110);
	
		/**
		 * The base implementation of `setToString` without support for hot loop shorting.
		 *
		 * @private
		 * @param {Function} func The function to modify.
		 * @param {Function} string The `toString` result.
		 * @returns {Function} Returns `func`.
		 */
		var baseSetToString = !defineProperty ? identity : function (func, string) {
		  return defineProperty(func, 'toString', {
		    'configurable': true,
		    'enumerable': false,
		    'value': constant(string),
		    'writable': true
		  });
		};
	
		module.exports = baseSetToString;
	
	/***/ }),
	/* 512 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * The base implementation of `_.sortBy` which uses `comparer` to define the
		 * sort order of `array` and replaces criteria objects with their corresponding
		 * values.
		 *
		 * @private
		 * @param {Array} array The array to sort.
		 * @param {Function} comparer The function to define sort order.
		 * @returns {Array} Returns `array`.
		 */
		function baseSortBy(array, comparer) {
		  var length = array.length;
	
		  array.sort(comparer);
		  while (length--) {
		    array[length] = array[length].value;
		  }
		  return array;
		}
	
		module.exports = baseSortBy;
	
	/***/ }),
	/* 513 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * The base implementation of `_.times` without support for iteratee shorthands
		 * or max array length checks.
		 *
		 * @private
		 * @param {number} n The number of times to invoke `iteratee`.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the array of results.
		 */
		function baseTimes(n, iteratee) {
		  var index = -1,
		      result = Array(n);
	
		  while (++index < n) {
		    result[index] = iteratee(index);
		  }
		  return result;
		}
	
		module.exports = baseTimes;
	
	/***/ }),
	/* 514 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var SetCache = __webpack_require__(242),
		    arrayIncludes = __webpack_require__(480),
		    arrayIncludesWith = __webpack_require__(481),
		    cacheHas = __webpack_require__(254),
		    createSet = __webpack_require__(528),
		    setToArray = __webpack_require__(107);
	
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;
	
		/**
		 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {Function} [iteratee] The iteratee invoked per element.
		 * @param {Function} [comparator] The comparator invoked per element.
		 * @returns {Array} Returns the new duplicate free array.
		 */
		function baseUniq(array, iteratee, comparator) {
		  var index = -1,
		      includes = arrayIncludes,
		      length = array.length,
		      isCommon = true,
		      result = [],
		      seen = result;
	
		  if (comparator) {
		    isCommon = false;
		    includes = arrayIncludesWith;
		  } else if (length >= LARGE_ARRAY_SIZE) {
		    var set = iteratee ? null : createSet(array);
		    if (set) {
		      return setToArray(set);
		    }
		    isCommon = false;
		    includes = cacheHas;
		    seen = new SetCache();
		  } else {
		    seen = iteratee ? [] : result;
		  }
		  outer: while (++index < length) {
		    var value = array[index],
		        computed = iteratee ? iteratee(value) : value;
	
		    value = comparator || value !== 0 ? value : 0;
		    if (isCommon && computed === computed) {
		      var seenIndex = seen.length;
		      while (seenIndex--) {
		        if (seen[seenIndex] === computed) {
		          continue outer;
		        }
		      }
		      if (iteratee) {
		        seen.push(computed);
		      }
		      result.push(value);
		    } else if (!includes(seen, computed, comparator)) {
		      if (seen !== result) {
		        seen.push(computed);
		      }
		      result.push(value);
		    }
		  }
		  return result;
		}
	
		module.exports = baseUniq;
	
	/***/ }),
	/* 515 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var arrayMap = __webpack_require__(60);
	
		/**
		 * The base implementation of `_.values` and `_.valuesIn` which creates an
		 * array of `object` property values corresponding to the property names
		 * of `props`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Array} props The property names to get values for.
		 * @returns {Object} Returns the array of property values.
		 */
		function baseValues(object, props) {
		  return arrayMap(props, function (key) {
		    return object[key];
		  });
		}
	
		module.exports = baseValues;
	
	/***/ }),
	/* 516 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var cloneArrayBuffer = __webpack_require__(167);
	
		/**
		 * Creates a clone of `dataView`.
		 *
		 * @private
		 * @param {Object} dataView The data view to clone.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned data view.
		 */
		function cloneDataView(dataView, isDeep) {
		  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
		  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
		}
	
		module.exports = cloneDataView;
	
	/***/ }),
	/* 517 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var addMapEntry = __webpack_require__(476),
		    arrayReduce = __webpack_require__(246),
		    mapToArray = __webpack_require__(268);
	
		/** Used to compose bitmasks for cloning. */
		var CLONE_DEEP_FLAG = 1;
	
		/**
		 * Creates a clone of `map`.
		 *
		 * @private
		 * @param {Object} map The map to clone.
		 * @param {Function} cloneFunc The function to clone values.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned map.
		 */
		function cloneMap(map, isDeep, cloneFunc) {
		  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
		  return arrayReduce(array, addMapEntry, new map.constructor());
		}
	
		module.exports = cloneMap;
	
	/***/ }),
	/* 518 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/** Used to match `RegExp` flags from their coerced string values. */
		var reFlags = /\w*$/;
	
		/**
		 * Creates a clone of `regexp`.
		 *
		 * @private
		 * @param {Object} regexp The regexp to clone.
		 * @returns {Object} Returns the cloned regexp.
		 */
		function cloneRegExp(regexp) {
		  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
		  result.lastIndex = regexp.lastIndex;
		  return result;
		}
	
		module.exports = cloneRegExp;
	
	/***/ }),
	/* 519 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var addSetEntry = __webpack_require__(477),
		    arrayReduce = __webpack_require__(246),
		    setToArray = __webpack_require__(107);
	
		/** Used to compose bitmasks for cloning. */
		var CLONE_DEEP_FLAG = 1;
	
		/**
		 * Creates a clone of `set`.
		 *
		 * @private
		 * @param {Object} set The set to clone.
		 * @param {Function} cloneFunc The function to clone values.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the cloned set.
		 */
		function cloneSet(set, isDeep, cloneFunc) {
		  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
		  return arrayReduce(array, addSetEntry, new set.constructor());
		}
	
		module.exports = cloneSet;
	
	/***/ }),
	/* 520 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _Symbol = __webpack_require__(45);
	
		/** Used to convert symbols to primitives and strings. */
		var symbolProto = _Symbol ? _Symbol.prototype : undefined,
		    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
		/**
		 * Creates a clone of the `symbol` object.
		 *
		 * @private
		 * @param {Object} symbol The symbol object to clone.
		 * @returns {Object} Returns the cloned symbol object.
		 */
		function cloneSymbol(symbol) {
		  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
		}
	
		module.exports = cloneSymbol;
	
	/***/ }),
	/* 521 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isSymbol = __webpack_require__(62);
	
		/**
		 * Compares values to sort them in ascending order.
		 *
		 * @private
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {number} Returns the sort order indicator for `value`.
		 */
		function compareAscending(value, other) {
		  if (value !== other) {
		    var valIsDefined = value !== undefined,
		        valIsNull = value === null,
		        valIsReflexive = value === value,
		        valIsSymbol = isSymbol(value);
	
		    var othIsDefined = other !== undefined,
		        othIsNull = other === null,
		        othIsReflexive = other === other,
		        othIsSymbol = isSymbol(other);
	
		    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
		      return 1;
		    }
		    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
		      return -1;
		    }
		  }
		  return 0;
		}
	
		module.exports = compareAscending;
	
	/***/ }),
	/* 522 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var compareAscending = __webpack_require__(521);
	
		/**
		 * Used by `_.orderBy` to compare multiple properties of a value to another
		 * and stable sort them.
		 *
		 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
		 * specify an order of "desc" for descending or "asc" for ascending sort order
		 * of corresponding values.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {boolean[]|string[]} orders The order to sort by for each property.
		 * @returns {number} Returns the sort order indicator for `object`.
		 */
		function compareMultiple(object, other, orders) {
		  var index = -1,
		      objCriteria = object.criteria,
		      othCriteria = other.criteria,
		      length = objCriteria.length,
		      ordersLength = orders.length;
	
		  while (++index < length) {
		    var result = compareAscending(objCriteria[index], othCriteria[index]);
		    if (result) {
		      if (index >= ordersLength) {
		        return result;
		      }
		      var order = orders[index];
		      return result * (order == 'desc' ? -1 : 1);
		    }
		  }
		  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
		  // that causes it, under certain circumstances, to provide the same value for
		  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
		  // for more details.
		  //
		  // This also ensures a stable sort in V8 and other engines.
		  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
		  return object.index - other.index;
		}
	
		module.exports = compareMultiple;
	
	/***/ }),
	/* 523 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var copyObject = __webpack_require__(31),
		    getSymbols = __webpack_require__(170);
	
		/**
		 * Copies own symbols of `source` to `object`.
		 *
		 * @private
		 * @param {Object} source The object to copy symbols from.
		 * @param {Object} [object={}] The object to copy symbols to.
		 * @returns {Object} Returns `object`.
		 */
		function copySymbols(source, object) {
		  return copyObject(source, getSymbols(source), object);
		}
	
		module.exports = copySymbols;
	
	/***/ }),
	/* 524 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var copyObject = __webpack_require__(31),
		    getSymbolsIn = __webpack_require__(263);
	
		/**
		 * Copies own and inherited symbols of `source` to `object`.
		 *
		 * @private
		 * @param {Object} source The object to copy symbols from.
		 * @param {Object} [object={}] The object to copy symbols to.
		 * @returns {Object} Returns `object`.
		 */
		function copySymbolsIn(source, object) {
		  return copyObject(source, getSymbolsIn(source), object);
		}
	
		module.exports = copySymbolsIn;
	
	/***/ }),
	/* 525 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var root = __webpack_require__(17);
	
		/** Used to detect overreaching core-js shims. */
		var coreJsData = root['__core-js_shared__'];
	
		module.exports = coreJsData;
	
	/***/ }),
	/* 526 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isArrayLike = __webpack_require__(24);
	
		/**
		 * Creates a `baseEach` or `baseEachRight` function.
		 *
		 * @private
		 * @param {Function} eachFunc The function to iterate over a collection.
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {Function} Returns the new base function.
		 */
		function createBaseEach(eachFunc, fromRight) {
		  return function (collection, iteratee) {
		    if (collection == null) {
		      return collection;
		    }
		    if (!isArrayLike(collection)) {
		      return eachFunc(collection, iteratee);
		    }
		    var length = collection.length,
		        index = fromRight ? length : -1,
		        iterable = Object(collection);
	
		    while (fromRight ? index-- : ++index < length) {
		      if (iteratee(iterable[index], index, iterable) === false) {
		        break;
		      }
		    }
		    return collection;
		  };
		}
	
		module.exports = createBaseEach;
	
	/***/ }),
	/* 527 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
		 *
		 * @private
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {Function} Returns the new base function.
		 */
		function createBaseFor(fromRight) {
		  return function (object, iteratee, keysFunc) {
		    var index = -1,
		        iterable = Object(object),
		        props = keysFunc(object),
		        length = props.length;
	
		    while (length--) {
		      var key = props[fromRight ? length : ++index];
		      if (iteratee(iterable[key], key, iterable) === false) {
		        break;
		      }
		    }
		    return object;
		  };
		}
	
		module.exports = createBaseFor;
	
	/***/ }),
	/* 528 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var Set = __webpack_require__(241),
		    noop = __webpack_require__(591),
		    setToArray = __webpack_require__(107);
	
		/** Used as references for various `Number` constants. */
		var INFINITY = 1 / 0;
	
		/**
		 * Creates a set object of `values`.
		 *
		 * @private
		 * @param {Array} values The values to add to the set.
		 * @returns {Object} Returns the new set.
		 */
		var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
		  return new Set(values);
		};
	
		module.exports = createSet;
	
	/***/ }),
	/* 529 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var eq = __webpack_require__(46);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
		 * of source objects to the destination object for all destination properties
		 * that resolve to `undefined`.
		 *
		 * @private
		 * @param {*} objValue The destination value.
		 * @param {*} srcValue The source value.
		 * @param {string} key The key of the property to assign.
		 * @param {Object} object The parent object of `objValue`.
		 * @returns {*} Returns the value to assign.
		 */
		function customDefaultsAssignIn(objValue, srcValue, key, object) {
		  if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
		    return srcValue;
		  }
		  return objValue;
		}
	
		module.exports = customDefaultsAssignIn;
	
	/***/ }),
	/* 530 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _Symbol = __webpack_require__(45),
		    Uint8Array = __webpack_require__(243),
		    eq = __webpack_require__(46),
		    equalArrays = __webpack_require__(260),
		    mapToArray = __webpack_require__(268),
		    setToArray = __webpack_require__(107);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1,
		    COMPARE_UNORDERED_FLAG = 2;
	
		/** `Object#toString` result references. */
		var boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    symbolTag = '[object Symbol]';
	
		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]';
	
		/** Used to convert symbols to primitives and strings. */
		var symbolProto = _Symbol ? _Symbol.prototype : undefined,
		    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
		/**
		 * A specialized version of `baseIsEqualDeep` for comparing objects of
		 * the same `toStringTag`.
		 *
		 * **Note:** This function only supports comparing values with tags of
		 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {string} tag The `toStringTag` of the objects to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
		  switch (tag) {
		    case dataViewTag:
		      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
		        return false;
		      }
		      object = object.buffer;
		      other = other.buffer;
	
		    case arrayBufferTag:
		      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
		        return false;
		      }
		      return true;
	
		    case boolTag:
		    case dateTag:
		    case numberTag:
		      // Coerce booleans to `1` or `0` and dates to milliseconds.
		      // Invalid dates are coerced to `NaN`.
		      return eq(+object, +other);
	
		    case errorTag:
		      return object.name == other.name && object.message == other.message;
	
		    case regexpTag:
		    case stringTag:
		      // Coerce regexes to strings and treat strings, primitives and objects,
		      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
		      // for more details.
		      return object == other + '';
	
		    case mapTag:
		      var convert = mapToArray;
	
		    case setTag:
		      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
		      convert || (convert = setToArray);
	
		      if (object.size != other.size && !isPartial) {
		        return false;
		      }
		      // Assume cyclic values are equal.
		      var stacked = stack.get(object);
		      if (stacked) {
		        return stacked == other;
		      }
		      bitmask |= COMPARE_UNORDERED_FLAG;
	
		      // Recursively compare objects (susceptible to call stack limits).
		      stack.set(object, other);
		      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
		      stack['delete'](object);
		      return result;
	
		    case symbolTag:
		      if (symbolValueOf) {
		        return symbolValueOf.call(object) == symbolValueOf.call(other);
		      }
		  }
		  return false;
		}
	
		module.exports = equalByTag;
	
	/***/ }),
	/* 531 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var getAllKeys = __webpack_require__(262);
	
		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1;
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * A specialized version of `baseIsEqualDeep` for objects with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
		  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
		      objProps = getAllKeys(object),
		      objLength = objProps.length,
		      othProps = getAllKeys(other),
		      othLength = othProps.length;
	
		  if (objLength != othLength && !isPartial) {
		    return false;
		  }
		  var index = objLength;
		  while (index--) {
		    var key = objProps[index];
		    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
		      return false;
		    }
		  }
		  // Assume cyclic values are equal.
		  var stacked = stack.get(object);
		  if (stacked && stack.get(other)) {
		    return stacked == other;
		  }
		  var result = true;
		  stack.set(object, other);
		  stack.set(other, object);
	
		  var skipCtor = isPartial;
		  while (++index < objLength) {
		    key = objProps[index];
		    var objValue = object[key],
		        othValue = other[key];
	
		    if (customizer) {
		      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
		    }
		    // Recursively compare objects (susceptible to call stack limits).
		    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
		      result = false;
		      break;
		    }
		    skipCtor || (skipCtor = key == 'constructor');
		  }
		  if (result && !skipCtor) {
		    var objCtor = object.constructor,
		        othCtor = other.constructor;
	
		    // Non `Object` object instances with different constructors are not equal.
		    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
		      result = false;
		    }
		  }
		  stack['delete'](object);
		  stack['delete'](other);
		  return result;
		}
	
		module.exports = equalObjects;
	
	/***/ }),
	/* 532 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseGetAllKeys = __webpack_require__(250),
		    getSymbolsIn = __webpack_require__(263),
		    keysIn = __webpack_require__(47);
	
		/**
		 * Creates an array of own and inherited enumerable property names and
		 * symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function getAllKeysIn(object) {
		  return baseGetAllKeys(object, keysIn, getSymbolsIn);
		}
	
		module.exports = getAllKeysIn;
	
	/***/ }),
	/* 533 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isStrictComparable = __webpack_require__(267),
		    keys = __webpack_require__(32);
	
		/**
		 * Gets the property names, values, and compare flags of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the match data of `object`.
		 */
		function getMatchData(object) {
		    var result = keys(object),
		        length = result.length;
	
		    while (length--) {
		        var key = result[length],
		            value = object[key];
	
		        result[length] = [key, value, isStrictComparable(value)];
		    }
		    return result;
		}
	
		module.exports = getMatchData;
	
	/***/ }),
	/* 534 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _Symbol = __webpack_require__(45);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var nativeObjectToString = objectProto.toString;
	
		/** Built-in value references. */
		var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
	
		/**
		 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the raw `toStringTag`.
		 */
		function getRawTag(value) {
		  var isOwn = hasOwnProperty.call(value, symToStringTag),
		      tag = value[symToStringTag];
	
		  try {
		    value[symToStringTag] = undefined;
		    var unmasked = true;
		  } catch (e) {}
	
		  var result = nativeObjectToString.call(value);
		  if (unmasked) {
		    if (isOwn) {
		      value[symToStringTag] = tag;
		    } else {
		      delete value[symToStringTag];
		    }
		  }
		  return result;
		}
	
		module.exports = getRawTag;
	
	/***/ }),
	/* 535 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Gets the value at `key` of `object`.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */
		function getValue(object, key) {
		  return object == null ? undefined : object[key];
		}
	
		module.exports = getValue;
	
	/***/ }),
	/* 536 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var nativeCreate = __webpack_require__(106);
	
		/**
		 * Removes all key-value entries from the hash.
		 *
		 * @private
		 * @name clear
		 * @memberOf Hash
		 */
		function hashClear() {
		  this.__data__ = nativeCreate ? nativeCreate(null) : {};
		  this.size = 0;
		}
	
		module.exports = hashClear;
	
	/***/ }),
	/* 537 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Removes `key` and its value from the hash.
		 *
		 * @private
		 * @name delete
		 * @memberOf Hash
		 * @param {Object} hash The hash to modify.
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function hashDelete(key) {
		  var result = this.has(key) && delete this.__data__[key];
		  this.size -= result ? 1 : 0;
		  return result;
		}
	
		module.exports = hashDelete;
	
	/***/ }),
	/* 538 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var nativeCreate = __webpack_require__(106);
	
		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Gets the hash value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Hash
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function hashGet(key) {
		  var data = this.__data__;
		  if (nativeCreate) {
		    var result = data[key];
		    return result === HASH_UNDEFINED ? undefined : result;
		  }
		  return hasOwnProperty.call(data, key) ? data[key] : undefined;
		}
	
		module.exports = hashGet;
	
	/***/ }),
	/* 539 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var nativeCreate = __webpack_require__(106);
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Checks if a hash value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Hash
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function hashHas(key) {
		  var data = this.__data__;
		  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
		}
	
		module.exports = hashHas;
	
	/***/ }),
	/* 540 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var nativeCreate = __webpack_require__(106);
	
		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
		/**
		 * Sets the hash `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Hash
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the hash instance.
		 */
		function hashSet(key, value) {
		  var data = this.__data__;
		  this.size += this.has(key) ? 0 : 1;
		  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
		  return this;
		}
	
		module.exports = hashSet;
	
	/***/ }),
	/* 541 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Initializes an array clone.
		 *
		 * @private
		 * @param {Array} array The array to clone.
		 * @returns {Array} Returns the initialized clone.
		 */
		function initCloneArray(array) {
		  var length = array.length,
		      result = array.constructor(length);
	
		  // Add properties assigned by `RegExp#exec`.
		  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
		    result.index = array.index;
		    result.input = array.input;
		  }
		  return result;
		}
	
		module.exports = initCloneArray;
	
	/***/ }),
	/* 542 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var cloneArrayBuffer = __webpack_require__(167),
		    cloneDataView = __webpack_require__(516),
		    cloneMap = __webpack_require__(517),
		    cloneRegExp = __webpack_require__(518),
		    cloneSet = __webpack_require__(519),
		    cloneSymbol = __webpack_require__(520),
		    cloneTypedArray = __webpack_require__(257);
	
		/** `Object#toString` result references. */
		var boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    symbolTag = '[object Symbol]';
	
		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';
	
		/**
		 * Initializes an object clone based on its `toStringTag`.
		 *
		 * **Note:** This function only supports cloning values with tags of
		 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
		 *
		 * @private
		 * @param {Object} object The object to clone.
		 * @param {string} tag The `toStringTag` of the object to clone.
		 * @param {Function} cloneFunc The function to clone values.
		 * @param {boolean} [isDeep] Specify a deep clone.
		 * @returns {Object} Returns the initialized clone.
		 */
		function initCloneByTag(object, tag, cloneFunc, isDeep) {
		  var Ctor = object.constructor;
		  switch (tag) {
		    case arrayBufferTag:
		      return cloneArrayBuffer(object);
	
		    case boolTag:
		    case dateTag:
		      return new Ctor(+object);
	
		    case dataViewTag:
		      return cloneDataView(object, isDeep);
	
		    case float32Tag:case float64Tag:
		    case int8Tag:case int16Tag:case int32Tag:
		    case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:
		      return cloneTypedArray(object, isDeep);
	
		    case mapTag:
		      return cloneMap(object, isDeep, cloneFunc);
	
		    case numberTag:
		    case stringTag:
		      return new Ctor(object);
	
		    case regexpTag:
		      return cloneRegExp(object);
	
		    case setTag:
		      return cloneSet(object, isDeep, cloneFunc);
	
		    case symbolTag:
		      return cloneSymbol(object);
		  }
		}
	
		module.exports = initCloneByTag;
	
	/***/ }),
	/* 543 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _Symbol = __webpack_require__(45),
		    isArguments = __webpack_require__(112),
		    isArray = __webpack_require__(6);
	
		/** Built-in value references. */
		var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;
	
		/**
		 * Checks if `value` is a flattenable `arguments` object or array.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
		 */
		function isFlattenable(value) {
		    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
		}
	
		module.exports = isFlattenable;
	
	/***/ }),
	/* 544 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		/**
		 * Checks if `value` is suitable for use as unique object key.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
		 */
		function isKeyable(value) {
		  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
		}
	
		module.exports = isKeyable;
	
	/***/ }),
	/* 545 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var coreJsData = __webpack_require__(525);
	
		/** Used to detect methods masquerading as native. */
		var maskSrcKey = function () {
		  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
		  return uid ? 'Symbol(src)_1.' + uid : '';
		}();
	
		/**
		 * Checks if `func` has its source masked.
		 *
		 * @private
		 * @param {Function} func The function to check.
		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
		 */
		function isMasked(func) {
		  return !!maskSrcKey && maskSrcKey in func;
		}
	
		module.exports = isMasked;
	
	/***/ }),
	/* 546 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Removes all key-value entries from the list cache.
		 *
		 * @private
		 * @name clear
		 * @memberOf ListCache
		 */
		function listCacheClear() {
		  this.__data__ = [];
		  this.size = 0;
		}
	
		module.exports = listCacheClear;
	
	/***/ }),
	/* 547 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var assocIndexOf = __webpack_require__(100);
	
		/** Used for built-in method references. */
		var arrayProto = Array.prototype;
	
		/** Built-in value references. */
		var splice = arrayProto.splice;
	
		/**
		 * Removes `key` and its value from the list cache.
		 *
		 * @private
		 * @name delete
		 * @memberOf ListCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function listCacheDelete(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  if (index < 0) {
		    return false;
		  }
		  var lastIndex = data.length - 1;
		  if (index == lastIndex) {
		    data.pop();
		  } else {
		    splice.call(data, index, 1);
		  }
		  --this.size;
		  return true;
		}
	
		module.exports = listCacheDelete;
	
	/***/ }),
	/* 548 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var assocIndexOf = __webpack_require__(100);
	
		/**
		 * Gets the list cache value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf ListCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function listCacheGet(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  return index < 0 ? undefined : data[index][1];
		}
	
		module.exports = listCacheGet;
	
	/***/ }),
	/* 549 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var assocIndexOf = __webpack_require__(100);
	
		/**
		 * Checks if a list cache value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf ListCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function listCacheHas(key) {
		  return assocIndexOf(this.__data__, key) > -1;
		}
	
		module.exports = listCacheHas;
	
	/***/ }),
	/* 550 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var assocIndexOf = __webpack_require__(100);
	
		/**
		 * Sets the list cache `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf ListCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the list cache instance.
		 */
		function listCacheSet(key, value) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);
	
		  if (index < 0) {
		    ++this.size;
		    data.push([key, value]);
		  } else {
		    data[index][1] = value;
		  }
		  return this;
		}
	
		module.exports = listCacheSet;
	
	/***/ }),
	/* 551 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var Hash = __webpack_require__(473),
		    ListCache = __webpack_require__(98),
		    Map = __webpack_require__(159);
	
		/**
		 * Removes all key-value entries from the map.
		 *
		 * @private
		 * @name clear
		 * @memberOf MapCache
		 */
		function mapCacheClear() {
		  this.size = 0;
		  this.__data__ = {
		    'hash': new Hash(),
		    'map': new (Map || ListCache)(),
		    'string': new Hash()
		  };
		}
	
		module.exports = mapCacheClear;
	
	/***/ }),
	/* 552 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var getMapData = __webpack_require__(104);
	
		/**
		 * Removes `key` and its value from the map.
		 *
		 * @private
		 * @name delete
		 * @memberOf MapCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function mapCacheDelete(key) {
		  var result = getMapData(this, key)['delete'](key);
		  this.size -= result ? 1 : 0;
		  return result;
		}
	
		module.exports = mapCacheDelete;
	
	/***/ }),
	/* 553 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var getMapData = __webpack_require__(104);
	
		/**
		 * Gets the map value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf MapCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function mapCacheGet(key) {
		  return getMapData(this, key).get(key);
		}
	
		module.exports = mapCacheGet;
	
	/***/ }),
	/* 554 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var getMapData = __webpack_require__(104);
	
		/**
		 * Checks if a map value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf MapCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function mapCacheHas(key) {
		  return getMapData(this, key).has(key);
		}
	
		module.exports = mapCacheHas;
	
	/***/ }),
	/* 555 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var getMapData = __webpack_require__(104);
	
		/**
		 * Sets the map `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf MapCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the map cache instance.
		 */
		function mapCacheSet(key, value) {
		  var data = getMapData(this, key),
		      size = data.size;
	
		  data.set(key, value);
		  this.size += data.size == size ? 0 : 1;
		  return this;
		}
	
		module.exports = mapCacheSet;
	
	/***/ }),
	/* 556 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var memoize = __webpack_require__(589);
	
		/** Used as the maximum memoize cache size. */
		var MAX_MEMOIZE_SIZE = 500;
	
		/**
		 * A specialized version of `_.memoize` which clears the memoized function's
		 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
		 *
		 * @private
		 * @param {Function} func The function to have its output memoized.
		 * @returns {Function} Returns the new memoized function.
		 */
		function memoizeCapped(func) {
		  var result = memoize(func, function (key) {
		    if (cache.size === MAX_MEMOIZE_SIZE) {
		      cache.clear();
		    }
		    return key;
		  });
	
		  var cache = result.cache;
		  return result;
		}
	
		module.exports = memoizeCapped;
	
	/***/ }),
	/* 557 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var overArg = __webpack_require__(271);
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeKeys = overArg(Object.keys, Object);
	
		module.exports = nativeKeys;
	
	/***/ }),
	/* 558 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * This function is like
		 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * except that it includes inherited enumerable properties.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function nativeKeysIn(object) {
		  var result = [];
		  if (object != null) {
		    for (var key in Object(object)) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		module.exports = nativeKeysIn;
	
	/***/ }),
	/* 559 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var nativeObjectToString = objectProto.toString;
	
		/**
		 * Converts `value` to a string using `Object.prototype.toString`.
		 *
		 * @private
		 * @param {*} value The value to convert.
		 * @returns {string} Returns the converted string.
		 */
		function objectToString(value) {
		  return nativeObjectToString.call(value);
		}
	
		module.exports = objectToString;
	
	/***/ }),
	/* 560 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var apply = __webpack_require__(244);
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeMax = Math.max;
	
		/**
		 * A specialized version of `baseRest` which transforms the rest array.
		 *
		 * @private
		 * @param {Function} func The function to apply a rest parameter to.
		 * @param {number} [start=func.length-1] The start position of the rest parameter.
		 * @param {Function} transform The rest array transform.
		 * @returns {Function} Returns the new function.
		 */
		function overRest(func, start, transform) {
		  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
		  return function () {
		    var args = arguments,
		        index = -1,
		        length = nativeMax(args.length - start, 0),
		        array = Array(length);
	
		    while (++index < length) {
		      array[index] = args[start + index];
		    }
		    index = -1;
		    var otherArgs = Array(start + 1);
		    while (++index < start) {
		      otherArgs[index] = args[index];
		    }
		    otherArgs[start] = transform(array);
		    return apply(func, this, otherArgs);
		  };
		}
	
		module.exports = overRest;
	
	/***/ }),
	/* 561 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
		/**
		 * Adds `value` to the array cache.
		 *
		 * @private
		 * @name add
		 * @memberOf SetCache
		 * @alias push
		 * @param {*} value The value to cache.
		 * @returns {Object} Returns the cache instance.
		 */
		function setCacheAdd(value) {
		  this.__data__.set(value, HASH_UNDEFINED);
		  return this;
		}
	
		module.exports = setCacheAdd;
	
	/***/ }),
	/* 562 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Checks if `value` is in the array cache.
		 *
		 * @private
		 * @name has
		 * @memberOf SetCache
		 * @param {*} value The value to search for.
		 * @returns {number} Returns `true` if `value` is found, else `false`.
		 */
		function setCacheHas(value) {
		  return this.__data__.has(value);
		}
	
		module.exports = setCacheHas;
	
	/***/ }),
	/* 563 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseSetToString = __webpack_require__(511),
		    shortOut = __webpack_require__(564);
	
		/**
		 * Sets the `toString` method of `func` to return `string`.
		 *
		 * @private
		 * @param {Function} func The function to modify.
		 * @param {Function} string The `toString` result.
		 * @returns {Function} Returns `func`.
		 */
		var setToString = shortOut(baseSetToString);
	
		module.exports = setToString;
	
	/***/ }),
	/* 564 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/** Used to detect hot functions by number of calls within a span of milliseconds. */
		var HOT_COUNT = 800,
		    HOT_SPAN = 16;
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeNow = Date.now;
	
		/**
		 * Creates a function that'll short out and invoke `identity` instead
		 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
		 * milliseconds.
		 *
		 * @private
		 * @param {Function} func The function to restrict.
		 * @returns {Function} Returns the new shortable function.
		 */
		function shortOut(func) {
		  var count = 0,
		      lastCalled = 0;
	
		  return function () {
		    var stamp = nativeNow(),
		        remaining = HOT_SPAN - (stamp - lastCalled);
	
		    lastCalled = stamp;
		    if (remaining > 0) {
		      if (++count >= HOT_COUNT) {
		        return arguments[0];
		      }
		    } else {
		      count = 0;
		    }
		    return func.apply(undefined, arguments);
		  };
		}
	
		module.exports = shortOut;
	
	/***/ }),
	/* 565 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var ListCache = __webpack_require__(98);
	
		/**
		 * Removes all key-value entries from the stack.
		 *
		 * @private
		 * @name clear
		 * @memberOf Stack
		 */
		function stackClear() {
		  this.__data__ = new ListCache();
		  this.size = 0;
		}
	
		module.exports = stackClear;
	
	/***/ }),
	/* 566 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		/**
		 * Removes `key` and its value from the stack.
		 *
		 * @private
		 * @name delete
		 * @memberOf Stack
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function stackDelete(key) {
		  var data = this.__data__,
		      result = data['delete'](key);
	
		  this.size = data.size;
		  return result;
		}
	
		module.exports = stackDelete;
	
	/***/ }),
	/* 567 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Gets the stack value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Stack
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function stackGet(key) {
		  return this.__data__.get(key);
		}
	
		module.exports = stackGet;
	
	/***/ }),
	/* 568 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Checks if a stack value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Stack
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function stackHas(key) {
		  return this.__data__.has(key);
		}
	
		module.exports = stackHas;
	
	/***/ }),
	/* 569 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var ListCache = __webpack_require__(98),
		    Map = __webpack_require__(159),
		    MapCache = __webpack_require__(160);
	
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;
	
		/**
		 * Sets the stack `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Stack
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the stack cache instance.
		 */
		function stackSet(key, value) {
		  var data = this.__data__;
		  if (data instanceof ListCache) {
		    var pairs = data.__data__;
		    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
		      pairs.push([key, value]);
		      this.size = ++data.size;
		      return this;
		    }
		    data = this.__data__ = new MapCache(pairs);
		  }
		  data.set(key, value);
		  this.size = data.size;
		  return this;
		}
	
		module.exports = stackSet;
	
	/***/ }),
	/* 570 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * A specialized version of `_.indexOf` which performs strict equality
		 * comparisons of values, i.e. `===`.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} value The value to search for.
		 * @param {number} fromIndex The index to search from.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function strictIndexOf(array, value, fromIndex) {
		  var index = fromIndex - 1,
		      length = array.length;
	
		  while (++index < length) {
		    if (array[index] === value) {
		      return index;
		    }
		  }
		  return -1;
		}
	
		module.exports = strictIndexOf;
	
	/***/ }),
	/* 571 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var memoizeCapped = __webpack_require__(556);
	
		/** Used to match property names within property paths. */
		var reLeadingDot = /^\./,
		    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
		/** Used to match backslashes in property paths. */
		var reEscapeChar = /\\(\\)?/g;
	
		/**
		 * Converts `string` to a property path array.
		 *
		 * @private
		 * @param {string} string The string to convert.
		 * @returns {Array} Returns the property path array.
		 */
		var stringToPath = memoizeCapped(function (string) {
		  var result = [];
		  if (reLeadingDot.test(string)) {
		    result.push('');
		  }
		  string.replace(rePropName, function (match, number, quote, string) {
		    result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
		  });
		  return result;
		});
	
		module.exports = stringToPath;
	
	/***/ }),
	/* 572 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var copyObject = __webpack_require__(31),
		    createAssigner = __webpack_require__(103),
		    keysIn = __webpack_require__(47);
	
		/**
		 * This method is like `_.assign` except that it iterates over own and
		 * inherited source properties.
		 *
		 * **Note:** This method mutates `object`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @alias extend
		 * @category Object
		 * @param {Object} object The destination object.
		 * @param {...Object} [sources] The source objects.
		 * @returns {Object} Returns `object`.
		 * @see _.assign
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 * }
		 *
		 * function Bar() {
		 *   this.c = 3;
		 * }
		 *
		 * Foo.prototype.b = 2;
		 * Bar.prototype.d = 4;
		 *
		 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
		 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
		 */
		var assignIn = createAssigner(function (object, source) {
		  copyObject(source, keysIn(source), object);
		});
	
		module.exports = assignIn;
	
	/***/ }),
	/* 573 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var copyObject = __webpack_require__(31),
		    createAssigner = __webpack_require__(103),
		    keysIn = __webpack_require__(47);
	
		/**
		 * This method is like `_.assignIn` except that it accepts `customizer`
		 * which is invoked to produce the assigned values. If `customizer` returns
		 * `undefined`, assignment is handled by the method instead. The `customizer`
		 * is invoked with five arguments: (objValue, srcValue, key, object, source).
		 *
		 * **Note:** This method mutates `object`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @alias extendWith
		 * @category Object
		 * @param {Object} object The destination object.
		 * @param {...Object} sources The source objects.
		 * @param {Function} [customizer] The function to customize assigned values.
		 * @returns {Object} Returns `object`.
		 * @see _.assignWith
		 * @example
		 *
		 * function customizer(objValue, srcValue) {
		 *   return _.isUndefined(objValue) ? srcValue : objValue;
		 * }
		 *
		 * var defaults = _.partialRight(_.assignInWith, customizer);
		 *
		 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
		 * // => { 'a': 1, 'b': 2 }
		 */
		var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
		  copyObject(source, keysIn(source), object, customizer);
		});
	
		module.exports = assignInWith;
	
	/***/ }),
	/* 574 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseClone = __webpack_require__(164);
	
		/** Used to compose bitmasks for cloning. */
		var CLONE_DEEP_FLAG = 1,
		    CLONE_SYMBOLS_FLAG = 4;
	
		/**
		 * This method is like `_.clone` except that it recursively clones `value`.
		 *
		 * @static
		 * @memberOf _
		 * @since 1.0.0
		 * @category Lang
		 * @param {*} value The value to recursively clone.
		 * @returns {*} Returns the deep cloned value.
		 * @see _.clone
		 * @example
		 *
		 * var objects = [{ 'a': 1 }, { 'b': 2 }];
		 *
		 * var deep = _.cloneDeep(objects);
		 * console.log(deep[0] === objects[0]);
		 * // => false
		 */
		function cloneDeep(value) {
		  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
		}
	
		module.exports = cloneDeep;
	
	/***/ }),
	/* 575 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseClone = __webpack_require__(164);
	
		/** Used to compose bitmasks for cloning. */
		var CLONE_DEEP_FLAG = 1,
		    CLONE_SYMBOLS_FLAG = 4;
	
		/**
		 * This method is like `_.cloneWith` except that it recursively clones `value`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to recursively clone.
		 * @param {Function} [customizer] The function to customize cloning.
		 * @returns {*} Returns the deep cloned value.
		 * @see _.cloneWith
		 * @example
		 *
		 * function customizer(value) {
		 *   if (_.isElement(value)) {
		 *     return value.cloneNode(true);
		 *   }
		 * }
		 *
		 * var el = _.cloneDeepWith(document.body, customizer);
		 *
		 * console.log(el === document.body);
		 * // => false
		 * console.log(el.nodeName);
		 * // => 'BODY'
		 * console.log(el.childNodes.length);
		 * // => 20
		 */
		function cloneDeepWith(value, customizer) {
		  customizer = typeof customizer == 'function' ? customizer : undefined;
		  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
		}
	
		module.exports = cloneDeepWith;
	
	/***/ }),
	/* 576 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Creates a function that returns `value`.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.4.0
		 * @category Util
		 * @param {*} value The value to return from the new function.
		 * @returns {Function} Returns the new constant function.
		 * @example
		 *
		 * var objects = _.times(2, _.constant({ 'a': 1 }));
		 *
		 * console.log(objects);
		 * // => [{ 'a': 1 }, { 'a': 1 }]
		 *
		 * console.log(objects[0] === objects[1]);
		 * // => true
		 */
		function constant(value) {
		  return function () {
		    return value;
		  };
		}
	
		module.exports = constant;
	
	/***/ }),
	/* 577 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var toString = __webpack_require__(114);
	
		/**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
		 */
		var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
		    reHasRegExpChar = RegExp(reRegExpChar.source);
	
		/**
		 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
		 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category String
		 * @param {string} [string=''] The string to escape.
		 * @returns {string} Returns the escaped string.
		 * @example
		 *
		 * _.escapeRegExp('[lodash](https://lodash.com/)');
		 * // => '\[lodash\]\(https://lodash\.com/\)'
		 */
		function escapeRegExp(string) {
		  string = toString(string);
		  return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
		}
	
		module.exports = escapeRegExp;
	
	/***/ }),
	/* 578 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = __webpack_require__(572);
	
	/***/ }),
	/* 579 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var createFind = __webpack_require__(258),
		    findIndex = __webpack_require__(580);
	
		/**
		 * Iterates over elements of `collection`, returning the first element
		 * `predicate` returns truthy for. The predicate is invoked with three
		 * arguments: (value, index|key, collection).
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Collection
		 * @param {Array|Object} collection The collection to inspect.
		 * @param {Function} [predicate=_.identity] The function invoked per iteration.
		 * @param {number} [fromIndex=0] The index to search from.
		 * @returns {*} Returns the matched element, else `undefined`.
		 * @example
		 *
		 * var users = [
		 *   { 'user': 'barney',  'age': 36, 'active': true },
		 *   { 'user': 'fred',    'age': 40, 'active': false },
		 *   { 'user': 'pebbles', 'age': 1,  'active': true }
		 * ];
		 *
		 * _.find(users, function(o) { return o.age < 40; });
		 * // => object for 'barney'
		 *
		 * // The `_.matches` iteratee shorthand.
		 * _.find(users, { 'age': 1, 'active': true });
		 * // => object for 'pebbles'
		 *
		 * // The `_.matchesProperty` iteratee shorthand.
		 * _.find(users, ['active', false]);
		 * // => object for 'fred'
		 *
		 * // The `_.property` iteratee shorthand.
		 * _.find(users, 'active');
		 * // => object for 'barney'
		 */
		var find = createFind(findIndex);
	
		module.exports = find;
	
	/***/ }),
	/* 580 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseFindIndex = __webpack_require__(165),
		    baseIteratee = __webpack_require__(61),
		    toInteger = __webpack_require__(48);
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeMax = Math.max;
	
		/**
		 * This method is like `_.find` except that it returns the index of the first
		 * element `predicate` returns truthy for instead of the element itself.
		 *
		 * @static
		 * @memberOf _
		 * @since 1.1.0
		 * @category Array
		 * @param {Array} array The array to inspect.
		 * @param {Function} [predicate=_.identity] The function invoked per iteration.
		 * @param {number} [fromIndex=0] The index to search from.
		 * @returns {number} Returns the index of the found element, else `-1`.
		 * @example
		 *
		 * var users = [
		 *   { 'user': 'barney',  'active': false },
		 *   { 'user': 'fred',    'active': false },
		 *   { 'user': 'pebbles', 'active': true }
		 * ];
		 *
		 * _.findIndex(users, function(o) { return o.user == 'barney'; });
		 * // => 0
		 *
		 * // The `_.matches` iteratee shorthand.
		 * _.findIndex(users, { 'user': 'fred', 'active': false });
		 * // => 1
		 *
		 * // The `_.matchesProperty` iteratee shorthand.
		 * _.findIndex(users, ['active', false]);
		 * // => 0
		 *
		 * // The `_.property` iteratee shorthand.
		 * _.findIndex(users, 'active');
		 * // => 2
		 */
		function findIndex(array, predicate, fromIndex) {
		  var length = array == null ? 0 : array.length;
		  if (!length) {
		    return -1;
		  }
		  var index = fromIndex == null ? 0 : toInteger(fromIndex);
		  if (index < 0) {
		    index = nativeMax(length + index, 0);
		  }
		  return baseFindIndex(array, baseIteratee(predicate, 3), index);
		}
	
		module.exports = findIndex;
	
	/***/ }),
	/* 581 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var createFind = __webpack_require__(258),
		    findLastIndex = __webpack_require__(582);
	
		/**
		 * This method is like `_.find` except that it iterates over elements of
		 * `collection` from right to left.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.0.0
		 * @category Collection
		 * @param {Array|Object} collection The collection to inspect.
		 * @param {Function} [predicate=_.identity] The function invoked per iteration.
		 * @param {number} [fromIndex=collection.length-1] The index to search from.
		 * @returns {*} Returns the matched element, else `undefined`.
		 * @example
		 *
		 * _.findLast([1, 2, 3, 4], function(n) {
		 *   return n % 2 == 1;
		 * });
		 * // => 3
		 */
		var findLast = createFind(findLastIndex);
	
		module.exports = findLast;
	
	/***/ }),
	/* 582 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseFindIndex = __webpack_require__(165),
		    baseIteratee = __webpack_require__(61),
		    toInteger = __webpack_require__(48);
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeMax = Math.max,
		    nativeMin = Math.min;
	
		/**
		 * This method is like `_.findIndex` except that it iterates over elements
		 * of `collection` from right to left.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.0.0
		 * @category Array
		 * @param {Array} array The array to inspect.
		 * @param {Function} [predicate=_.identity] The function invoked per iteration.
		 * @param {number} [fromIndex=array.length-1] The index to search from.
		 * @returns {number} Returns the index of the found element, else `-1`.
		 * @example
		 *
		 * var users = [
		 *   { 'user': 'barney',  'active': true },
		 *   { 'user': 'fred',    'active': false },
		 *   { 'user': 'pebbles', 'active': false }
		 * ];
		 *
		 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
		 * // => 2
		 *
		 * // The `_.matches` iteratee shorthand.
		 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
		 * // => 0
		 *
		 * // The `_.matchesProperty` iteratee shorthand.
		 * _.findLastIndex(users, ['active', false]);
		 * // => 2
		 *
		 * // The `_.property` iteratee shorthand.
		 * _.findLastIndex(users, 'active');
		 * // => 0
		 */
		function findLastIndex(array, predicate, fromIndex) {
		  var length = array == null ? 0 : array.length;
		  if (!length) {
		    return -1;
		  }
		  var index = length - 1;
		  if (fromIndex !== undefined) {
		    index = toInteger(fromIndex);
		    index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
		  }
		  return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
		}
	
		module.exports = findLastIndex;
	
	/***/ }),
	/* 583 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseGet = __webpack_require__(249);
	
		/**
		 * Gets the value at `path` of `object`. If the resolved value is
		 * `undefined`, the `defaultValue` is returned in its place.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.7.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path of the property to get.
		 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
		 * @returns {*} Returns the resolved value.
		 * @example
		 *
		 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
		 *
		 * _.get(object, 'a[0].b.c');
		 * // => 3
		 *
		 * _.get(object, ['a', '0', 'b', 'c']);
		 * // => 3
		 *
		 * _.get(object, 'a.b.c', 'default');
		 * // => 'default'
		 */
		function get(object, path, defaultValue) {
		  var result = object == null ? undefined : baseGet(object, path);
		  return result === undefined ? defaultValue : result;
		}
	
		module.exports = get;
	
	/***/ }),
	/* 584 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseHasIn = __webpack_require__(491),
		    hasPath = __webpack_require__(265);
	
		/**
		 * Checks if `path` is a direct or inherited property of `object`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path to check.
		 * @returns {boolean} Returns `true` if `path` exists, else `false`.
		 * @example
		 *
		 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
		 *
		 * _.hasIn(object, 'a');
		 * // => true
		 *
		 * _.hasIn(object, 'a.b');
		 * // => true
		 *
		 * _.hasIn(object, ['a', 'b']);
		 * // => true
		 *
		 * _.hasIn(object, 'b');
		 * // => false
		 */
		function hasIn(object, path) {
		  return object != null && hasPath(object, path, baseHasIn);
		}
	
		module.exports = hasIn;
	
	/***/ }),
	/* 585 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isArrayLike = __webpack_require__(24),
		    isObjectLike = __webpack_require__(25);
	
		/**
		 * This method is like `_.isArrayLike` except that it also checks if `value`
		 * is an object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array-like object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArrayLikeObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLikeObject(document.body.children);
		 * // => true
		 *
		 * _.isArrayLikeObject('abc');
		 * // => false
		 *
		 * _.isArrayLikeObject(_.noop);
		 * // => false
		 */
		function isArrayLikeObject(value) {
		  return isObjectLike(value) && isArrayLike(value);
		}
	
		module.exports = isArrayLikeObject;
	
	/***/ }),
	/* 586 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var toInteger = __webpack_require__(48);
	
		/**
		 * Checks if `value` is an integer.
		 *
		 * **Note:** This method is based on
		 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
		 * @example
		 *
		 * _.isInteger(3);
		 * // => true
		 *
		 * _.isInteger(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isInteger(Infinity);
		 * // => false
		 *
		 * _.isInteger('3');
		 * // => false
		 */
		function isInteger(value) {
		  return typeof value == 'number' && value == toInteger(value);
		}
	
		module.exports = isInteger;
	
	/***/ }),
	/* 587 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseGetTag = __webpack_require__(30),
		    isArray = __webpack_require__(6),
		    isObjectLike = __webpack_require__(25);
	
		/** `Object#toString` result references. */
		var stringTag = '[object String]';
	
		/**
		 * Checks if `value` is classified as a `String` primitive or object.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
		 * @example
		 *
		 * _.isString('abc');
		 * // => true
		 *
		 * _.isString(1);
		 * // => false
		 */
		function isString(value) {
		    return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
		}
	
		module.exports = isString;
	
	/***/ }),
	/* 588 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var arrayMap = __webpack_require__(60),
		    baseIteratee = __webpack_require__(61),
		    baseMap = __webpack_require__(252),
		    isArray = __webpack_require__(6);
	
		/**
		 * Creates an array of values by running each element in `collection` thru
		 * `iteratee`. The iteratee is invoked with three arguments:
		 * (value, index|key, collection).
		 *
		 * Many lodash methods are guarded to work as iteratees for methods like
		 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
		 *
		 * The guarded methods are:
		 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
		 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
		 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
		 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Collection
		 * @param {Array|Object} collection The collection to iterate over.
		 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
		 * @returns {Array} Returns the new mapped array.
		 * @example
		 *
		 * function square(n) {
		 *   return n * n;
		 * }
		 *
		 * _.map([4, 8], square);
		 * // => [16, 64]
		 *
		 * _.map({ 'a': 4, 'b': 8 }, square);
		 * // => [16, 64] (iteration order is not guaranteed)
		 *
		 * var users = [
		 *   { 'user': 'barney' },
		 *   { 'user': 'fred' }
		 * ];
		 *
		 * // The `_.property` iteratee shorthand.
		 * _.map(users, 'user');
		 * // => ['barney', 'fred']
		 */
		function map(collection, iteratee) {
		  var func = isArray(collection) ? arrayMap : baseMap;
		  return func(collection, baseIteratee(iteratee, 3));
		}
	
		module.exports = map;
	
	/***/ }),
	/* 589 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var MapCache = __webpack_require__(160);
	
		/** Error message constants. */
		var FUNC_ERROR_TEXT = 'Expected a function';
	
		/**
		 * Creates a function that memoizes the result of `func`. If `resolver` is
		 * provided, it determines the cache key for storing the result based on the
		 * arguments provided to the memoized function. By default, the first argument
		 * provided to the memoized function is used as the map cache key. The `func`
		 * is invoked with the `this` binding of the memoized function.
		 *
		 * **Note:** The cache is exposed as the `cache` property on the memoized
		 * function. Its creation may be customized by replacing the `_.memoize.Cache`
		 * constructor with one whose instances implement the
		 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
		 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Function
		 * @param {Function} func The function to have its output memoized.
		 * @param {Function} [resolver] The function to resolve the cache key.
		 * @returns {Function} Returns the new memoized function.
		 * @example
		 *
		 * var object = { 'a': 1, 'b': 2 };
		 * var other = { 'c': 3, 'd': 4 };
		 *
		 * var values = _.memoize(_.values);
		 * values(object);
		 * // => [1, 2]
		 *
		 * values(other);
		 * // => [3, 4]
		 *
		 * object.a = 2;
		 * values(object);
		 * // => [1, 2]
		 *
		 * // Modify the result cache.
		 * values.cache.set(object, ['a', 'b']);
		 * values(object);
		 * // => ['a', 'b']
		 *
		 * // Replace `_.memoize.Cache`.
		 * _.memoize.Cache = WeakMap;
		 */
		function memoize(func, resolver) {
		  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
		    throw new TypeError(FUNC_ERROR_TEXT);
		  }
		  var memoized = function memoized() {
		    var args = arguments,
		        key = resolver ? resolver.apply(this, args) : args[0],
		        cache = memoized.cache;
	
		    if (cache.has(key)) {
		      return cache.get(key);
		    }
		    var result = func.apply(this, args);
		    memoized.cache = cache.set(key, result) || cache;
		    return result;
		  };
		  memoized.cache = new (memoize.Cache || MapCache)();
		  return memoized;
		}
	
		// Expose `MapCache`.
		memoize.Cache = MapCache;
	
		module.exports = memoize;
	
	/***/ }),
	/* 590 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseMerge = __webpack_require__(504),
		    createAssigner = __webpack_require__(103);
	
		/**
		 * This method is like `_.merge` except that it accepts `customizer` which
		 * is invoked to produce the merged values of the destination and source
		 * properties. If `customizer` returns `undefined`, merging is handled by the
		 * method instead. The `customizer` is invoked with six arguments:
		 * (objValue, srcValue, key, object, source, stack).
		 *
		 * **Note:** This method mutates `object`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Object
		 * @param {Object} object The destination object.
		 * @param {...Object} sources The source objects.
		 * @param {Function} customizer The function to customize assigned values.
		 * @returns {Object} Returns `object`.
		 * @example
		 *
		 * function customizer(objValue, srcValue) {
		 *   if (_.isArray(objValue)) {
		 *     return objValue.concat(srcValue);
		 *   }
		 * }
		 *
		 * var object = { 'a': [1], 'b': [2] };
		 * var other = { 'a': [3], 'b': [4] };
		 *
		 * _.mergeWith(object, other, customizer);
		 * // => { 'a': [1, 3], 'b': [2, 4] }
		 */
		var mergeWith = createAssigner(function (object, source, srcIndex, customizer) {
		  baseMerge(object, source, srcIndex, customizer);
		});
	
		module.exports = mergeWith;
	
	/***/ }),
	/* 591 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * This method returns `undefined`.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.3.0
		 * @category Util
		 * @example
		 *
		 * _.times(2, _.noop);
		 * // => [undefined, undefined]
		 */
		function noop() {
		  // No operation performed.
		}
	
		module.exports = noop;
	
	/***/ }),
	/* 592 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseProperty = __webpack_require__(507),
		    basePropertyDeep = __webpack_require__(508),
		    isKey = __webpack_require__(173),
		    toKey = __webpack_require__(108);
	
		/**
		 * Creates a function that returns the value at `path` of a given object.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.4.0
		 * @category Util
		 * @param {Array|string} path The path of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 * @example
		 *
		 * var objects = [
		 *   { 'a': { 'b': 2 } },
		 *   { 'a': { 'b': 1 } }
		 * ];
		 *
		 * _.map(objects, _.property('a.b'));
		 * // => [2, 1]
		 *
		 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
		 * // => [1, 2]
		 */
		function property(path) {
		  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
		}
	
		module.exports = property;
	
	/***/ }),
	/* 593 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var basePullAll = __webpack_require__(509);
	
		/**
		 * This method is like `_.pull` except that it accepts an array of values to remove.
		 *
		 * **Note:** Unlike `_.difference`, this method mutates `array`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Array
		 * @param {Array} array The array to modify.
		 * @param {Array} values The values to remove.
		 * @returns {Array} Returns `array`.
		 * @example
		 *
		 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
		 *
		 * _.pullAll(array, ['a', 'c']);
		 * console.log(array);
		 * // => ['b', 'b']
		 */
		function pullAll(array, values) {
		  return array && array.length && values && values.length ? basePullAll(array, values) : array;
		}
	
		module.exports = pullAll;
	
	/***/ }),
	/* 594 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseFlatten = __webpack_require__(488),
		    baseOrderBy = __webpack_require__(506),
		    baseRest = __webpack_require__(101),
		    isIterateeCall = __webpack_require__(172);
	
		/**
		 * Creates an array of elements, sorted in ascending order by the results of
		 * running each element in a collection thru each iteratee. This method
		 * performs a stable sort, that is, it preserves the original sort order of
		 * equal elements. The iteratees are invoked with one argument: (value).
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Collection
		 * @param {Array|Object} collection The collection to iterate over.
		 * @param {...(Function|Function[])} [iteratees=[_.identity]]
		 *  The iteratees to sort by.
		 * @returns {Array} Returns the new sorted array.
		 * @example
		 *
		 * var users = [
		 *   { 'user': 'fred',   'age': 48 },
		 *   { 'user': 'barney', 'age': 36 },
		 *   { 'user': 'fred',   'age': 40 },
		 *   { 'user': 'barney', 'age': 34 }
		 * ];
		 *
		 * _.sortBy(users, [function(o) { return o.user; }]);
		 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
		 *
		 * _.sortBy(users, ['user', 'age']);
		 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
		 */
		var sortBy = baseRest(function (collection, iteratees) {
		  if (collection == null) {
		    return [];
		  }
		  var length = iteratees.length;
		  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
		    iteratees = [];
		  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
		    iteratees = [iteratees[0]];
		  }
		  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
		});
	
		module.exports = sortBy;
	
	/***/ }),
	/* 595 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseClamp = __webpack_require__(485),
		    baseToString = __webpack_require__(253),
		    toInteger = __webpack_require__(48),
		    toString = __webpack_require__(114);
	
		/**
		 * Checks if `string` starts with the given target string.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category String
		 * @param {string} [string=''] The string to inspect.
		 * @param {string} [target] The string to search for.
		 * @param {number} [position=0] The position to search from.
		 * @returns {boolean} Returns `true` if `string` starts with `target`,
		 *  else `false`.
		 * @example
		 *
		 * _.startsWith('abc', 'a');
		 * // => true
		 *
		 * _.startsWith('abc', 'b');
		 * // => false
		 *
		 * _.startsWith('abc', 'b', 1);
		 * // => true
		 */
		function startsWith(string, target, position) {
		  string = toString(string);
		  position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
	
		  target = baseToString(target);
		  return string.slice(position, position + target.length) == target;
		}
	
		module.exports = startsWith;
	
	/***/ }),
	/* 596 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * This method returns `false`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {boolean} Returns `false`.
		 * @example
		 *
		 * _.times(2, _.stubFalse);
		 * // => [false, false]
		 */
		function stubFalse() {
		  return false;
		}
	
		module.exports = stubFalse;
	
	/***/ }),
	/* 597 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var toNumber = __webpack_require__(598);
	
		/** Used as references for various `Number` constants. */
		var INFINITY = 1 / 0,
		    MAX_INTEGER = 1.7976931348623157e+308;
	
		/**
		 * Converts `value` to a finite number.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.12.0
		 * @category Lang
		 * @param {*} value The value to convert.
		 * @returns {number} Returns the converted number.
		 * @example
		 *
		 * _.toFinite(3.2);
		 * // => 3.2
		 *
		 * _.toFinite(Number.MIN_VALUE);
		 * // => 5e-324
		 *
		 * _.toFinite(Infinity);
		 * // => 1.7976931348623157e+308
		 *
		 * _.toFinite('3.2');
		 * // => 3.2
		 */
		function toFinite(value) {
		  if (!value) {
		    return value === 0 ? value : 0;
		  }
		  value = toNumber(value);
		  if (value === INFINITY || value === -INFINITY) {
		    var sign = value < 0 ? -1 : 1;
		    return sign * MAX_INTEGER;
		  }
		  return value === value ? value : 0;
		}
	
		module.exports = toFinite;
	
	/***/ }),
	/* 598 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isObject = __webpack_require__(18),
		    isSymbol = __webpack_require__(62);
	
		/** Used as references for various `Number` constants. */
		var NAN = 0 / 0;
	
		/** Used to match leading and trailing whitespace. */
		var reTrim = /^\s+|\s+$/g;
	
		/** Used to detect bad signed hexadecimal string values. */
		var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
		/** Used to detect binary string values. */
		var reIsBinary = /^0b[01]+$/i;
	
		/** Used to detect octal string values. */
		var reIsOctal = /^0o[0-7]+$/i;
	
		/** Built-in method references without a dependency on `root`. */
		var freeParseInt = parseInt;
	
		/**
		 * Converts `value` to a number.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to process.
		 * @returns {number} Returns the number.
		 * @example
		 *
		 * _.toNumber(3.2);
		 * // => 3.2
		 *
		 * _.toNumber(Number.MIN_VALUE);
		 * // => 5e-324
		 *
		 * _.toNumber(Infinity);
		 * // => Infinity
		 *
		 * _.toNumber('3.2');
		 * // => 3.2
		 */
		function toNumber(value) {
		  if (typeof value == 'number') {
		    return value;
		  }
		  if (isSymbol(value)) {
		    return NAN;
		  }
		  if (isObject(value)) {
		    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
		    value = isObject(other) ? other + '' : other;
		  }
		  if (typeof value != 'string') {
		    return value === 0 ? value : +value;
		  }
		  value = value.replace(reTrim, '');
		  var isBinary = reIsBinary.test(value);
		  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
		}
	
		module.exports = toNumber;
	
	/***/ }),
	/* 599 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var copyObject = __webpack_require__(31),
		    keysIn = __webpack_require__(47);
	
		/**
		 * Converts `value` to a plain object flattening inherited enumerable string
		 * keyed properties of `value` to own properties of the plain object.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to convert.
		 * @returns {Object} Returns the converted plain object.
		 * @example
		 *
		 * function Foo() {
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.assign({ 'a': 1 }, new Foo);
		 * // => { 'a': 1, 'b': 2 }
		 *
		 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
		 * // => { 'a': 1, 'b': 2, 'c': 3 }
		 */
		function toPlainObject(value) {
		  return copyObject(value, keysIn(value));
		}
	
		module.exports = toPlainObject;
	
	/***/ }),
	/* 600 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var baseUniq = __webpack_require__(514);
	
		/**
		 * Creates a duplicate-free version of an array, using
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * for equality comparisons, in which only the first occurrence of each element
		 * is kept. The order of result values is determined by the order they occur
		 * in the array.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Array
		 * @param {Array} array The array to inspect.
		 * @returns {Array} Returns the new duplicate free array.
		 * @example
		 *
		 * _.uniq([2, 1, 2]);
		 * // => [2, 1]
		 */
		function uniq(array) {
		  return array && array.length ? baseUniq(array) : [];
		}
	
		module.exports = uniq;
	
	/***/ }),
	/* 601 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = minimatch;
		minimatch.Minimatch = Minimatch;
	
		var path = { sep: '/' };
		try {
		  path = __webpack_require__(19);
		} catch (er) {}
	
		var GLOBSTAR = minimatch.GLOBSTAR = Minimatch.GLOBSTAR = {};
		var expand = __webpack_require__(398);
	
		var plTypes = {
		  '!': { open: '(?:(?!(?:', close: '))[^/]*?)' },
		  '?': { open: '(?:', close: ')?' },
		  '+': { open: '(?:', close: ')+' },
		  '*': { open: '(?:', close: ')*' },
		  '@': { open: '(?:', close: ')' }
	
		  // any single thing other than /
		  // don't need to escape / when using new RegExp()
		};var qmark = '[^/]';
	
		// * => any number of characters
		var star = qmark + '*?';
	
		// ** when dots are allowed.  Anything goes, except .. and .
		// not (^ or / followed by one or two dots followed by $ or /),
		// followed by anything, any number of times.
		var twoStarDot = '(?:(?!(?:\\\/|^)(?:\\.{1,2})($|\\\/)).)*?';
	
		// not a ^ or / followed by a dot,
		// followed by anything, any number of times.
		var twoStarNoDot = '(?:(?!(?:\\\/|^)\\.).)*?';
	
		// characters that need to be escaped in RegExp.
		var reSpecials = charSet('().*{}+?[]^$\\!');
	
		// "abc" -> { a:true, b:true, c:true }
		function charSet(s) {
		  return s.split('').reduce(function (set, c) {
		    set[c] = true;
		    return set;
		  }, {});
		}
	
		// normalizes slashes.
		var slashSplit = /\/+/;
	
		minimatch.filter = filter;
		function filter(pattern, options) {
		  options = options || {};
		  return function (p, i, list) {
		    return minimatch(p, pattern, options);
		  };
		}
	
		function ext(a, b) {
		  a = a || {};
		  b = b || {};
		  var t = {};
		  Object.keys(b).forEach(function (k) {
		    t[k] = b[k];
		  });
		  Object.keys(a).forEach(function (k) {
		    t[k] = a[k];
		  });
		  return t;
		}
	
		minimatch.defaults = function (def) {
		  if (!def || !Object.keys(def).length) return minimatch;
	
		  var orig = minimatch;
	
		  var m = function minimatch(p, pattern, options) {
		    return orig.minimatch(p, pattern, ext(def, options));
		  };
	
		  m.Minimatch = function Minimatch(pattern, options) {
		    return new orig.Minimatch(pattern, ext(def, options));
		  };
	
		  return m;
		};
	
		Minimatch.defaults = function (def) {
		  if (!def || !Object.keys(def).length) return Minimatch;
		  return minimatch.defaults(def).Minimatch;
		};
	
		function minimatch(p, pattern, options) {
		  if (typeof pattern !== 'string') {
		    throw new TypeError('glob pattern string required');
		  }
	
		  if (!options) options = {};
	
		  // shortcut: comments match nothing.
		  if (!options.nocomment && pattern.charAt(0) === '#') {
		    return false;
		  }
	
		  // "" only matches ""
		  if (pattern.trim() === '') return p === '';
	
		  return new Minimatch(pattern, options).match(p);
		}
	
		function Minimatch(pattern, options) {
		  if (!(this instanceof Minimatch)) {
		    return new Minimatch(pattern, options);
		  }
	
		  if (typeof pattern !== 'string') {
		    throw new TypeError('glob pattern string required');
		  }
	
		  if (!options) options = {};
		  pattern = pattern.trim();
	
		  // windows support: need to use /, not \
		  if (path.sep !== '/') {
		    pattern = pattern.split(path.sep).join('/');
		  }
	
		  this.options = options;
		  this.set = [];
		  this.pattern = pattern;
		  this.regexp = null;
		  this.negate = false;
		  this.comment = false;
		  this.empty = false;
	
		  // make the set of regexps etc.
		  this.make();
		}
	
		Minimatch.prototype.debug = function () {};
	
		Minimatch.prototype.make = make;
		function make() {
		  // don't do it more than once.
		  if (this._made) return;
	
		  var pattern = this.pattern;
		  var options = this.options;
	
		  // empty patterns and comments match nothing.
		  if (!options.nocomment && pattern.charAt(0) === '#') {
		    this.comment = true;
		    return;
		  }
		  if (!pattern) {
		    this.empty = true;
		    return;
		  }
	
		  // step 1: figure out negation, etc.
		  this.parseNegate();
	
		  // step 2: expand braces
		  var set = this.globSet = this.braceExpand();
	
		  if (options.debug) this.debug = console.error;
	
		  this.debug(this.pattern, set);
	
		  // step 3: now we have a set, so turn each one into a series of path-portion
		  // matching patterns.
		  // These will be regexps, except in the case of "**", which is
		  // set to the GLOBSTAR object for globstar behavior,
		  // and will not contain any / characters
		  set = this.globParts = set.map(function (s) {
		    return s.split(slashSplit);
		  });
	
		  this.debug(this.pattern, set);
	
		  // glob --> regexps
		  set = set.map(function (s, si, set) {
		    return s.map(this.parse, this);
		  }, this);
	
		  this.debug(this.pattern, set);
	
		  // filter out everything that didn't compile properly.
		  set = set.filter(function (s) {
		    return s.indexOf(false) === -1;
		  });
	
		  this.debug(this.pattern, set);
	
		  this.set = set;
		}
	
		Minimatch.prototype.parseNegate = parseNegate;
		function parseNegate() {
		  var pattern = this.pattern;
		  var negate = false;
		  var options = this.options;
		  var negateOffset = 0;
	
		  if (options.nonegate) return;
	
		  for (var i = 0, l = pattern.length; i < l && pattern.charAt(i) === '!'; i++) {
		    negate = !negate;
		    negateOffset++;
		  }
	
		  if (negateOffset) this.pattern = pattern.substr(negateOffset);
		  this.negate = negate;
		}
	
		// Brace expansion:
		// a{b,c}d -> abd acd
		// a{b,}c -> abc ac
		// a{0..3}d -> a0d a1d a2d a3d
		// a{b,c{d,e}f}g -> abg acdfg acefg
		// a{b,c}d{e,f}g -> abdeg acdeg abdeg abdfg
		//
		// Invalid sets are not expanded.
		// a{2..}b -> a{2..}b
		// a{b}c -> a{b}c
		minimatch.braceExpand = function (pattern, options) {
		  return braceExpand(pattern, options);
		};
	
		Minimatch.prototype.braceExpand = braceExpand;
	
		function braceExpand(pattern, options) {
		  if (!options) {
		    if (this instanceof Minimatch) {
		      options = this.options;
		    } else {
		      options = {};
		    }
		  }
	
		  pattern = typeof pattern === 'undefined' ? this.pattern : pattern;
	
		  if (typeof pattern === 'undefined') {
		    throw new TypeError('undefined pattern');
		  }
	
		  if (options.nobrace || !pattern.match(/\{.*\}/)) {
		    // shortcut. no need to expand.
		    return [pattern];
		  }
	
		  return expand(pattern);
		}
	
		// parse a component of the expanded set.
		// At this point, no pattern may contain "/" in it
		// so we're going to return a 2d array, where each entry is the full
		// pattern, split on '/', and then turned into a regular expression.
		// A regexp is made at the end which joins each array with an
		// escaped /, and another full one which joins each regexp with |.
		//
		// Following the lead of Bash 4.1, note that "**" only has special meaning
		// when it is the *only* thing in a path portion.  Otherwise, any series
		// of * is equivalent to a single *.  Globstar behavior is enabled by
		// default, and can be disabled by setting options.noglobstar.
		Minimatch.prototype.parse = parse;
		var SUBPARSE = {};
		function parse(pattern, isSub) {
		  if (pattern.length > 1024 * 64) {
		    throw new TypeError('pattern is too long');
		  }
	
		  var options = this.options;
	
		  // shortcuts
		  if (!options.noglobstar && pattern === '**') return GLOBSTAR;
		  if (pattern === '') return '';
	
		  var re = '';
		  var hasMagic = !!options.nocase;
		  var escaping = false;
		  // ? => one single character
		  var patternListStack = [];
		  var negativeLists = [];
		  var stateChar;
		  var inClass = false;
		  var reClassStart = -1;
		  var classStart = -1;
		  // . and .. never match anything that doesn't start with .,
		  // even when options.dot is set.
		  var patternStart = pattern.charAt(0) === '.' ? '' // anything
		  // not (start or / followed by . or .. followed by / or end)
		  : options.dot ? '(?!(?:^|\\\/)\\.{1,2}(?:$|\\\/))' : '(?!\\.)';
		  var self = this;
	
		  function clearStateChar() {
		    if (stateChar) {
		      // we had some state-tracking character
		      // that wasn't consumed by this pass.
		      switch (stateChar) {
		        case '*':
		          re += star;
		          hasMagic = true;
		          break;
		        case '?':
		          re += qmark;
		          hasMagic = true;
		          break;
		        default:
		          re += '\\' + stateChar;
		          break;
		      }
		      self.debug('clearStateChar %j %j', stateChar, re);
		      stateChar = false;
		    }
		  }
	
		  for (var i = 0, len = pattern.length, c; i < len && (c = pattern.charAt(i)); i++) {
		    this.debug('%s\t%s %s %j', pattern, i, re, c);
	
		    // skip over any that are escaped.
		    if (escaping && reSpecials[c]) {
		      re += '\\' + c;
		      escaping = false;
		      continue;
		    }
	
		    switch (c) {
		      case '/':
		        // completely not allowed, even escaped.
		        // Should already be path-split by now.
		        return false;
	
		      case '\\':
		        clearStateChar();
		        escaping = true;
		        continue;
	
		      // the various stateChar values
		      // for the "extglob" stuff.
		      case '?':
		      case '*':
		      case '+':
		      case '@':
		      case '!':
		        this.debug('%s\t%s %s %j <-- stateChar', pattern, i, re, c);
	
		        // all of those are literals inside a class, except that
		        // the glob [!a] means [^a] in regexp
		        if (inClass) {
		          this.debug('  in class');
		          if (c === '!' && i === classStart + 1) c = '^';
		          re += c;
		          continue;
		        }
	
		        // if we already have a stateChar, then it means
		        // that there was something like ** or +? in there.
		        // Handle the stateChar, then proceed with this one.
		        self.debug('call clearStateChar %j', stateChar);
		        clearStateChar();
		        stateChar = c;
		        // if extglob is disabled, then +(asdf|foo) isn't a thing.
		        // just clear the statechar *now*, rather than even diving into
		        // the patternList stuff.
		        if (options.noext) clearStateChar();
		        continue;
	
		      case '(':
		        if (inClass) {
		          re += '(';
		          continue;
		        }
	
		        if (!stateChar) {
		          re += '\\(';
		          continue;
		        }
	
		        patternListStack.push({
		          type: stateChar,
		          start: i - 1,
		          reStart: re.length,
		          open: plTypes[stateChar].open,
		          close: plTypes[stateChar].close
		        });
		        // negation is (?:(?!js)[^/]*)
		        re += stateChar === '!' ? '(?:(?!(?:' : '(?:';
		        this.debug('plType %j %j', stateChar, re);
		        stateChar = false;
		        continue;
	
		      case ')':
		        if (inClass || !patternListStack.length) {
		          re += '\\)';
		          continue;
		        }
	
		        clearStateChar();
		        hasMagic = true;
		        var pl = patternListStack.pop();
		        // negation is (?:(?!js)[^/]*)
		        // The others are (?:<pattern>)<type>
		        re += pl.close;
		        if (pl.type === '!') {
		          negativeLists.push(pl);
		        }
		        pl.reEnd = re.length;
		        continue;
	
		      case '|':
		        if (inClass || !patternListStack.length || escaping) {
		          re += '\\|';
		          escaping = false;
		          continue;
		        }
	
		        clearStateChar();
		        re += '|';
		        continue;
	
		      // these are mostly the same in regexp and glob
		      case '[':
		        // swallow any state-tracking char before the [
		        clearStateChar();
	
		        if (inClass) {
		          re += '\\' + c;
		          continue;
		        }
	
		        inClass = true;
		        classStart = i;
		        reClassStart = re.length;
		        re += c;
		        continue;
	
		      case ']':
		        //  a right bracket shall lose its special
		        //  meaning and represent itself in
		        //  a bracket expression if it occurs
		        //  first in the list.  -- POSIX.2 2.8.3.2
		        if (i === classStart + 1 || !inClass) {
		          re += '\\' + c;
		          escaping = false;
		          continue;
		        }
	
		        // handle the case where we left a class open.
		        // "[z-a]" is valid, equivalent to "\[z-a\]"
		        if (inClass) {
		          // split where the last [ was, make sure we don't have
		          // an invalid re. if so, re-walk the contents of the
		          // would-be class to re-translate any characters that
		          // were passed through as-is
		          // TODO: It would probably be faster to determine this
		          // without a try/catch and a new RegExp, but it's tricky
		          // to do safely.  For now, this is safe and works.
		          var cs = pattern.substring(classStart + 1, i);
		          try {
		            RegExp('[' + cs + ']');
		          } catch (er) {
		            // not a valid class!
		            var sp = this.parse(cs, SUBPARSE);
		            re = re.substr(0, reClassStart) + '\\[' + sp[0] + '\\]';
		            hasMagic = hasMagic || sp[1];
		            inClass = false;
		            continue;
		          }
		        }
	
		        // finish up the class.
		        hasMagic = true;
		        inClass = false;
		        re += c;
		        continue;
	
		      default:
		        // swallow any state char that wasn't consumed
		        clearStateChar();
	
		        if (escaping) {
		          // no need
		          escaping = false;
		        } else if (reSpecials[c] && !(c === '^' && inClass)) {
		          re += '\\';
		        }
	
		        re += c;
	
		    } // switch
		  } // for
	
		  // handle the case where we left a class open.
		  // "[abc" is valid, equivalent to "\[abc"
		  if (inClass) {
		    // split where the last [ was, and escape it
		    // this is a huge pita.  We now have to re-walk
		    // the contents of the would-be class to re-translate
		    // any characters that were passed through as-is
		    cs = pattern.substr(classStart + 1);
		    sp = this.parse(cs, SUBPARSE);
		    re = re.substr(0, reClassStart) + '\\[' + sp[0];
		    hasMagic = hasMagic || sp[1];
		  }
	
		  // handle the case where we had a +( thing at the *end*
		  // of the pattern.
		  // each pattern list stack adds 3 chars, and we need to go through
		  // and escape any | chars that were passed through as-is for the regexp.
		  // Go through and escape them, taking care not to double-escape any
		  // | chars that were already escaped.
		  for (pl = patternListStack.pop(); pl; pl = patternListStack.pop()) {
		    var tail = re.slice(pl.reStart + pl.open.length);
		    this.debug('setting tail', re, pl);
		    // maybe some even number of \, then maybe 1 \, followed by a |
		    tail = tail.replace(/((?:\\{2}){0,64})(\\?)\|/g, function (_, $1, $2) {
		      if (!$2) {
		        // the | isn't already escaped, so escape it.
		        $2 = '\\';
		      }
	
		      // need to escape all those slashes *again*, without escaping the
		      // one that we need for escaping the | character.  As it works out,
		      // escaping an even number of slashes can be done by simply repeating
		      // it exactly after itself.  That's why this trick works.
		      //
		      // I am sorry that you have to see this.
		      return $1 + $1 + $2 + '|';
		    });
	
		    this.debug('tail=%j\n   %s', tail, tail, pl, re);
		    var t = pl.type === '*' ? star : pl.type === '?' ? qmark : '\\' + pl.type;
	
		    hasMagic = true;
		    re = re.slice(0, pl.reStart) + t + '\\(' + tail;
		  }
	
		  // handle trailing things that only matter at the very end.
		  clearStateChar();
		  if (escaping) {
		    // trailing \\
		    re += '\\\\';
		  }
	
		  // only need to apply the nodot start if the re starts with
		  // something that could conceivably capture a dot
		  var addPatternStart = false;
		  switch (re.charAt(0)) {
		    case '.':
		    case '[':
		    case '(':
		      addPatternStart = true;
		  }
	
		  // Hack to work around lack of negative lookbehind in JS
		  // A pattern like: *.!(x).!(y|z) needs to ensure that a name
		  // like 'a.xyz.yz' doesn't match.  So, the first negative
		  // lookahead, has to look ALL the way ahead, to the end of
		  // the pattern.
		  for (var n = negativeLists.length - 1; n > -1; n--) {
		    var nl = negativeLists[n];
	
		    var nlBefore = re.slice(0, nl.reStart);
		    var nlFirst = re.slice(nl.reStart, nl.reEnd - 8);
		    var nlLast = re.slice(nl.reEnd - 8, nl.reEnd);
		    var nlAfter = re.slice(nl.reEnd);
	
		    nlLast += nlAfter;
	
		    // Handle nested stuff like *(*.js|!(*.json)), where open parens
		    // mean that we should *not* include the ) in the bit that is considered
		    // "after" the negated section.
		    var openParensBefore = nlBefore.split('(').length - 1;
		    var cleanAfter = nlAfter;
		    for (i = 0; i < openParensBefore; i++) {
		      cleanAfter = cleanAfter.replace(/\)[+*?]?/, '');
		    }
		    nlAfter = cleanAfter;
	
		    var dollar = '';
		    if (nlAfter === '' && isSub !== SUBPARSE) {
		      dollar = '$';
		    }
		    var newRe = nlBefore + nlFirst + nlAfter + dollar + nlLast;
		    re = newRe;
		  }
	
		  // if the re is not "" at this point, then we need to make sure
		  // it doesn't match against an empty path part.
		  // Otherwise a/* will match a/, which it should not.
		  if (re !== '' && hasMagic) {
		    re = '(?=.)' + re;
		  }
	
		  if (addPatternStart) {
		    re = patternStart + re;
		  }
	
		  // parsing just a piece of a larger pattern.
		  if (isSub === SUBPARSE) {
		    return [re, hasMagic];
		  }
	
		  // skip the regexp for non-magical patterns
		  // unescape anything in it, though, so that it'll be
		  // an exact match against a file etc.
		  if (!hasMagic) {
		    return globUnescape(pattern);
		  }
	
		  var flags = options.nocase ? 'i' : '';
		  try {
		    var regExp = new RegExp('^' + re + '$', flags);
		  } catch (er) {
		    // If it was an invalid regular expression, then it can't match
		    // anything.  This trick looks for a character after the end of
		    // the string, which is of course impossible, except in multi-line
		    // mode, but it's not a /m regex.
		    return new RegExp('$.');
		  }
	
		  regExp._glob = pattern;
		  regExp._src = re;
	
		  return regExp;
		}
	
		minimatch.makeRe = function (pattern, options) {
		  return new Minimatch(pattern, options || {}).makeRe();
		};
	
		Minimatch.prototype.makeRe = makeRe;
		function makeRe() {
		  if (this.regexp || this.regexp === false) return this.regexp;
	
		  // at this point, this.set is a 2d array of partial
		  // pattern strings, or "**".
		  //
		  // It's better to use .match().  This function shouldn't
		  // be used, really, but it's pretty convenient sometimes,
		  // when you just want to work with a regex.
		  var set = this.set;
	
		  if (!set.length) {
		    this.regexp = false;
		    return this.regexp;
		  }
		  var options = this.options;
	
		  var twoStar = options.noglobstar ? star : options.dot ? twoStarDot : twoStarNoDot;
		  var flags = options.nocase ? 'i' : '';
	
		  var re = set.map(function (pattern) {
		    return pattern.map(function (p) {
		      return p === GLOBSTAR ? twoStar : typeof p === 'string' ? regExpEscape(p) : p._src;
		    }).join('\\\/');
		  }).join('|');
	
		  // must match entire pattern
		  // ending in a * or ** will make it less strict.
		  re = '^(?:' + re + ')$';
	
		  // can match anything, as long as it's not this.
		  if (this.negate) re = '^(?!' + re + ').*$';
	
		  try {
		    this.regexp = new RegExp(re, flags);
		  } catch (ex) {
		    this.regexp = false;
		  }
		  return this.regexp;
		}
	
		minimatch.match = function (list, pattern, options) {
		  options = options || {};
		  var mm = new Minimatch(pattern, options);
		  list = list.filter(function (f) {
		    return mm.match(f);
		  });
		  if (mm.options.nonull && !list.length) {
		    list.push(pattern);
		  }
		  return list;
		};
	
		Minimatch.prototype.match = match;
		function match(f, partial) {
		  this.debug('match', f, this.pattern);
		  // short-circuit in the case of busted things.
		  // comments, etc.
		  if (this.comment) return false;
		  if (this.empty) return f === '';
	
		  if (f === '/' && partial) return true;
	
		  var options = this.options;
	
		  // windows: need to use /, not \
		  if (path.sep !== '/') {
		    f = f.split(path.sep).join('/');
		  }
	
		  // treat the test path as a set of pathparts.
		  f = f.split(slashSplit);
		  this.debug(this.pattern, 'split', f);
	
		  // just ONE of the pattern sets in this.set needs to match
		  // in order for it to be valid.  If negating, then just one
		  // match means that we have failed.
		  // Either way, return on the first hit.
	
		  var set = this.set;
		  this.debug(this.pattern, 'set', set);
	
		  // Find the basename of the path by looking for the last non-empty segment
		  var filename;
		  var i;
		  for (i = f.length - 1; i >= 0; i--) {
		    filename = f[i];
		    if (filename) break;
		  }
	
		  for (i = 0; i < set.length; i++) {
		    var pattern = set[i];
		    var file = f;
		    if (options.matchBase && pattern.length === 1) {
		      file = [filename];
		    }
		    var hit = this.matchOne(file, pattern, partial);
		    if (hit) {
		      if (options.flipNegate) return true;
		      return !this.negate;
		    }
		  }
	
		  // didn't get any hits.  this is success if it's a negative
		  // pattern, failure otherwise.
		  if (options.flipNegate) return false;
		  return this.negate;
		}
	
		// set partial to true to test if, for example,
		// "/a/b" matches the start of "/*/b/*/d"
		// Partial means, if you run out of file before you run
		// out of pattern, then that's fine, as long as all
		// the parts match.
		Minimatch.prototype.matchOne = function (file, pattern, partial) {
		  var options = this.options;
	
		  this.debug('matchOne', { 'this': this, file: file, pattern: pattern });
	
		  this.debug('matchOne', file.length, pattern.length);
	
		  for (var fi = 0, pi = 0, fl = file.length, pl = pattern.length; fi < fl && pi < pl; fi++, pi++) {
		    this.debug('matchOne loop');
		    var p = pattern[pi];
		    var f = file[fi];
	
		    this.debug(pattern, p, f);
	
		    // should be impossible.
		    // some invalid regexp stuff in the set.
		    if (p === false) return false;
	
		    if (p === GLOBSTAR) {
		      this.debug('GLOBSTAR', [pattern, p, f]);
	
		      // "**"
		      // a/**/b/**/c would match the following:
		      // a/b/x/y/z/c
		      // a/x/y/z/b/c
		      // a/b/x/b/x/c
		      // a/b/c
		      // To do this, take the rest of the pattern after
		      // the **, and see if it would match the file remainder.
		      // If so, return success.
		      // If not, the ** "swallows" a segment, and try again.
		      // This is recursively awful.
		      //
		      // a/**/b/**/c matching a/b/x/y/z/c
		      // - a matches a
		      // - doublestar
		      //   - matchOne(b/x/y/z/c, b/**/c)
		      //     - b matches b
		      //     - doublestar
		      //       - matchOne(x/y/z/c, c) -> no
		      //       - matchOne(y/z/c, c) -> no
		      //       - matchOne(z/c, c) -> no
		      //       - matchOne(c, c) yes, hit
		      var fr = fi;
		      var pr = pi + 1;
		      if (pr === pl) {
		        this.debug('** at the end');
		        // a ** at the end will just swallow the rest.
		        // We have found a match.
		        // however, it will not swallow /.x, unless
		        // options.dot is set.
		        // . and .. are *never* matched by **, for explosively
		        // exponential reasons.
		        for (; fi < fl; fi++) {
		          if (file[fi] === '.' || file[fi] === '..' || !options.dot && file[fi].charAt(0) === '.') return false;
		        }
		        return true;
		      }
	
		      // ok, let's see if we can swallow whatever we can.
		      while (fr < fl) {
		        var swallowee = file[fr];
	
		        this.debug('\nglobstar while', file, fr, pattern, pr, swallowee);
	
		        // XXX remove this slice.  Just pass the start index.
		        if (this.matchOne(file.slice(fr), pattern.slice(pr), partial)) {
		          this.debug('globstar found match!', fr, fl, swallowee);
		          // found a match.
		          return true;
		        } else {
		          // can't swallow "." or ".." ever.
		          // can only swallow ".foo" when explicitly asked.
		          if (swallowee === '.' || swallowee === '..' || !options.dot && swallowee.charAt(0) === '.') {
		            this.debug('dot detected!', file, fr, pattern, pr);
		            break;
		          }
	
		          // ** swallows a segment, and continue.
		          this.debug('globstar swallow a segment, and continue');
		          fr++;
		        }
		      }
	
		      // no match was found.
		      // However, in partial mode, we can't say this is necessarily over.
		      // If there's more *pattern* left, then
		      if (partial) {
		        // ran out of file
		        this.debug('\n>>> no match, partial?', file, fr, pattern, pr);
		        if (fr === fl) return true;
		      }
		      return false;
		    }
	
		    // something other than **
		    // non-magic patterns just have to match exactly
		    // patterns with magic have been turned into regexps.
		    var hit;
		    if (typeof p === 'string') {
		      if (options.nocase) {
		        hit = f.toLowerCase() === p.toLowerCase();
		      } else {
		        hit = f === p;
		      }
		      this.debug('string match', p, f, hit);
		    } else {
		      hit = f.match(p);
		      this.debug('pattern match', p, f, hit);
		    }
	
		    if (!hit) return false;
		  }
	
		  // Note: ending in / means that we'll get a final ""
		  // at the end of the pattern.  This can only match a
		  // corresponding "" at the end of the file.
		  // If the file ends in /, then it can only match a
		  // a pattern that ends in /, unless the pattern just
		  // doesn't have any more for it. But, a/b/ should *not*
		  // match "a/b/*", even though "" matches against the
		  // [^/]*? pattern, except in partial mode, where it might
		  // simply not be reached yet.
		  // However, a/b/ should still satisfy a/*
	
		  // now either we fell off the end of the pattern, or we're done.
		  if (fi === fl && pi === pl) {
		    // ran out of pattern and filename at the same time.
		    // an exact hit!
		    return true;
		  } else if (fi === fl) {
		    // ran out of file, but still had pattern left.
		    // this is ok if we're doing the match as part of
		    // a glob fs traversal.
		    return partial;
		  } else if (pi === pl) {
		    // ran out of pattern, still have file left.
		    // this is only acceptable if we're on the very last
		    // empty segment of a file with a trailing slash.
		    // a/* should match a/b/
		    var emptyFileEnd = fi === fl - 1 && file[fi] === '';
		    return emptyFileEnd;
		  }
	
		  // should be unreachable.
		  throw new Error('wtf?');
		};
	
		// replace stuff like \* with *
		function globUnescape(s) {
		  return s.replace(/\\(.)/g, '$1');
		}
	
		function regExpEscape(s) {
		  return s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
		}
	
	/***/ }),
	/* 602 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		/**
		 * Helpers.
		 */
	
		var s = 1000;
		var m = s * 60;
		var h = m * 60;
		var d = h * 24;
		var y = d * 365.25;
	
		/**
		 * Parse or format the given `val`.
		 *
		 * Options:
		 *
		 *  - `long` verbose formatting [false]
		 *
		 * @param {String|Number} val
		 * @param {Object} [options]
		 * @throws {Error} throw an error if val is not a non-empty string or a number
		 * @return {String|Number}
		 * @api public
		 */
	
		module.exports = function (val, options) {
		  options = options || {};
		  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
		  if (type === 'string' && val.length > 0) {
		    return parse(val);
		  } else if (type === 'number' && isNaN(val) === false) {
		    return options.long ? fmtLong(val) : fmtShort(val);
		  }
		  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
		};
	
		/**
		 * Parse the given `str` and return milliseconds.
		 *
		 * @param {String} str
		 * @return {Number}
		 * @api private
		 */
	
		function parse(str) {
		  str = String(str);
		  if (str.length > 100) {
		    return;
		  }
		  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
		  if (!match) {
		    return;
		  }
		  var n = parseFloat(match[1]);
		  var type = (match[2] || 'ms').toLowerCase();
		  switch (type) {
		    case 'years':
		    case 'year':
		    case 'yrs':
		    case 'yr':
		    case 'y':
		      return n * y;
		    case 'days':
		    case 'day':
		    case 'd':
		      return n * d;
		    case 'hours':
		    case 'hour':
		    case 'hrs':
		    case 'hr':
		    case 'h':
		      return n * h;
		    case 'minutes':
		    case 'minute':
		    case 'mins':
		    case 'min':
		    case 'm':
		      return n * m;
		    case 'seconds':
		    case 'second':
		    case 'secs':
		    case 'sec':
		    case 's':
		      return n * s;
		    case 'milliseconds':
		    case 'millisecond':
		    case 'msecs':
		    case 'msec':
		    case 'ms':
		      return n;
		    default:
		      return undefined;
		  }
		}
	
		/**
		 * Short format for `ms`.
		 *
		 * @param {Number} ms
		 * @return {String}
		 * @api private
		 */
	
		function fmtShort(ms) {
		  if (ms >= d) {
		    return Math.round(ms / d) + 'd';
		  }
		  if (ms >= h) {
		    return Math.round(ms / h) + 'h';
		  }
		  if (ms >= m) {
		    return Math.round(ms / m) + 'm';
		  }
		  if (ms >= s) {
		    return Math.round(ms / s) + 's';
		  }
		  return ms + 'ms';
		}
	
		/**
		 * Long format for `ms`.
		 *
		 * @param {Number} ms
		 * @return {String}
		 * @api private
		 */
	
		function fmtLong(ms) {
		  return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
		}
	
		/**
		 * Pluralization helper.
		 */
	
		function plural(ms, n, name) {
		  if (ms < n) {
		    return;
		  }
		  if (ms < n * 1.5) {
		    return Math.floor(ms / n) + ' ' + name;
		  }
		  return Math.ceil(ms / n) + ' ' + name + 's';
		}
	
	/***/ }),
	/* 603 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		module.exports = Number.isNaN || function (x) {
			return x !== x;
		};
	
	/***/ }),
	/* 604 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
		function posix(path) {
			return path.charAt(0) === '/';
		}
	
		function win32(path) {
			// https://github.com/nodejs/node/blob/b3fcc245fb25539909ef1d5eaa01dbf92e168633/lib/path.js#L56
			var splitDeviceRe = /^([a-zA-Z]:|[\\\/]{2}[^\\\/]+[\\\/]+[^\\\/]+)?([\\\/])?([\s\S]*?)$/;
			var result = splitDeviceRe.exec(path);
			var device = result[1] || '';
			var isUnc = Boolean(device && device.charAt(1) !== ':');
	
			// UNC paths are always absolute
			return Boolean(result[2] || isUnc);
		}
	
		module.exports = process.platform === 'win32' ? win32 : posix;
		module.exports.posix = posix;
		module.exports.win32 = win32;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))
	
	/***/ }),
	/* 605 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _keys = __webpack_require__(14);
	
		var _keys2 = _interopRequireDefault(_keys);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		var _util = __webpack_require__(116);
	
		var util = _interopRequireWildcard(_util);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		/**
		 * Copyright (c) 2014, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
		 * additional grant of patent rights can be found in the PATENTS file in
		 * the same directory.
		 */
	
		var hasOwn = Object.prototype.hasOwnProperty;
	
		// The hoist function takes a FunctionExpression or FunctionDeclaration
		// and replaces any Declaration nodes in its body with assignments, then
		// returns a VariableDeclaration containing just the names of the removed
		// declarations.
		exports.hoist = function (funPath) {
		  t.assertFunction(funPath.node);
	
		  var vars = {};
	
		  function varDeclToExpr(vdec, includeIdentifiers) {
		    t.assertVariableDeclaration(vdec);
		    // TODO assert.equal(vdec.kind, "var");
		    var exprs = [];
	
		    vdec.declarations.forEach(function (dec) {
		      // Note: We duplicate 'dec.id' here to ensure that the variable declaration IDs don't
		      // have the same 'loc' value, since that can make sourcemaps and retainLines behave poorly.
		      vars[dec.id.name] = t.identifier(dec.id.name);
	
		      if (dec.init) {
		        exprs.push(t.assignmentExpression("=", dec.id, dec.init));
		      } else if (includeIdentifiers) {
		        exprs.push(dec.id);
		      }
		    });
	
		    if (exprs.length === 0) return null;
	
		    if (exprs.length === 1) return exprs[0];
	
		    return t.sequenceExpression(exprs);
		  }
	
		  funPath.get("body").traverse({
		    VariableDeclaration: {
		      exit: function exit(path) {
		        var expr = varDeclToExpr(path.node, false);
		        if (expr === null) {
		          path.remove();
		        } else {
		          // We don't need to traverse this expression any further because
		          // there can't be any new declarations inside an expression.
		          util.replaceWithOrRemove(path, t.expressionStatement(expr));
		        }
	
		        // Since the original node has been either removed or replaced,
		        // avoid traversing it any further.
		        path.skip();
		      }
		    },
	
		    ForStatement: function ForStatement(path) {
		      var init = path.node.init;
		      if (t.isVariableDeclaration(init)) {
		        util.replaceWithOrRemove(path.get("init"), varDeclToExpr(init, false));
		      }
		    },
	
		    ForXStatement: function ForXStatement(path) {
		      var left = path.get("left");
		      if (left.isVariableDeclaration()) {
		        util.replaceWithOrRemove(left, varDeclToExpr(left.node, true));
		      }
		    },
	
		    FunctionDeclaration: function FunctionDeclaration(path) {
		      var node = path.node;
		      vars[node.id.name] = node.id;
	
		      var assignment = t.expressionStatement(t.assignmentExpression("=", node.id, t.functionExpression(node.id, node.params, node.body, node.generator, node.expression)));
	
		      if (path.parentPath.isBlockStatement()) {
		        // Insert the assignment form before the first statement in the
		        // enclosing block.
		        path.parentPath.unshiftContainer("body", assignment);
	
		        // Remove the function declaration now that we've inserted the
		        // equivalent assignment form at the beginning of the block.
		        path.remove();
		      } else {
		        // If the parent node is not a block statement, then we can just
		        // replace the declaration with the equivalent assignment form
		        // without worrying about hoisting it.
		        util.replaceWithOrRemove(path, assignment);
		      }
	
		      // Don't hoist variables out of inner functions.
		      path.skip();
		    },
	
		    FunctionExpression: function FunctionExpression(path) {
		      // Don't descend into nested function expressions.
		      path.skip();
		    }
		  });
	
		  var paramNames = {};
		  funPath.get("params").forEach(function (paramPath) {
		    var param = paramPath.node;
		    if (t.isIdentifier(param)) {
		      paramNames[param.name] = param;
		    } else {
		      // Variables declared by destructuring parameter patterns will be
		      // harmlessly re-declared.
		    }
		  });
	
		  var declarations = [];
	
		  (0, _keys2.default)(vars).forEach(function (name) {
		    if (!hasOwn.call(paramNames, name)) {
		      declarations.push(t.variableDeclarator(vars[name], null));
		    }
		  });
	
		  if (declarations.length === 0) {
		    return null; // Be sure to handle this case!
		  }
	
		  return t.variableDeclaration("var", declarations);
		};
	
	/***/ }),
	/* 606 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function () {
		  return __webpack_require__(610);
		};
	
	/***/ }),
	/* 607 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _assert = __webpack_require__(64);
	
		var _assert2 = _interopRequireDefault(_assert);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		var _util = __webpack_require__(117);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		function Entry() {
		  _assert2.default.ok(this instanceof Entry);
		} /**
		   * Copyright (c) 2014, Facebook, Inc.
		   * All rights reserved.
		   *
		   * This source code is licensed under the BSD-style license found in the
		   * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
		   * additional grant of patent rights can be found in the PATENTS file in
		   * the same directory.
		   */
	
		function FunctionEntry(returnLoc) {
		  Entry.call(this);
		  t.assertLiteral(returnLoc);
		  this.returnLoc = returnLoc;
		}
	
		(0, _util.inherits)(FunctionEntry, Entry);
		exports.FunctionEntry = FunctionEntry;
	
		function LoopEntry(breakLoc, continueLoc, label) {
		  Entry.call(this);
	
		  t.assertLiteral(breakLoc);
		  t.assertLiteral(continueLoc);
	
		  if (label) {
		    t.assertIdentifier(label);
		  } else {
		    label = null;
		  }
	
		  this.breakLoc = breakLoc;
		  this.continueLoc = continueLoc;
		  this.label = label;
		}
	
		(0, _util.inherits)(LoopEntry, Entry);
		exports.LoopEntry = LoopEntry;
	
		function SwitchEntry(breakLoc) {
		  Entry.call(this);
		  t.assertLiteral(breakLoc);
		  this.breakLoc = breakLoc;
		}
	
		(0, _util.inherits)(SwitchEntry, Entry);
		exports.SwitchEntry = SwitchEntry;
	
		function TryEntry(firstLoc, catchEntry, finallyEntry) {
		  Entry.call(this);
	
		  t.assertLiteral(firstLoc);
	
		  if (catchEntry) {
		    _assert2.default.ok(catchEntry instanceof CatchEntry);
		  } else {
		    catchEntry = null;
		  }
	
		  if (finallyEntry) {
		    _assert2.default.ok(finallyEntry instanceof FinallyEntry);
		  } else {
		    finallyEntry = null;
		  }
	
		  // Have to have one or the other (or both).
		  _assert2.default.ok(catchEntry || finallyEntry);
	
		  this.firstLoc = firstLoc;
		  this.catchEntry = catchEntry;
		  this.finallyEntry = finallyEntry;
		}
	
		(0, _util.inherits)(TryEntry, Entry);
		exports.TryEntry = TryEntry;
	
		function CatchEntry(firstLoc, paramId) {
		  Entry.call(this);
	
		  t.assertLiteral(firstLoc);
		  t.assertIdentifier(paramId);
	
		  this.firstLoc = firstLoc;
		  this.paramId = paramId;
		}
	
		(0, _util.inherits)(CatchEntry, Entry);
		exports.CatchEntry = CatchEntry;
	
		function FinallyEntry(firstLoc, afterLoc) {
		  Entry.call(this);
		  t.assertLiteral(firstLoc);
		  t.assertLiteral(afterLoc);
		  this.firstLoc = firstLoc;
		  this.afterLoc = afterLoc;
		}
	
		(0, _util.inherits)(FinallyEntry, Entry);
		exports.FinallyEntry = FinallyEntry;
	
		function LabeledEntry(breakLoc, label) {
		  Entry.call(this);
	
		  t.assertLiteral(breakLoc);
		  t.assertIdentifier(label);
	
		  this.breakLoc = breakLoc;
		  this.label = label;
		}
	
		(0, _util.inherits)(LabeledEntry, Entry);
		exports.LabeledEntry = LabeledEntry;
	
		function LeapManager(emitter) {
		  _assert2.default.ok(this instanceof LeapManager);
	
		  var Emitter = __webpack_require__(283).Emitter;
		  _assert2.default.ok(emitter instanceof Emitter);
	
		  this.emitter = emitter;
		  this.entryStack = [new FunctionEntry(emitter.finalLoc)];
		}
	
		var LMp = LeapManager.prototype;
		exports.LeapManager = LeapManager;
	
		LMp.withEntry = function (entry, callback) {
		  _assert2.default.ok(entry instanceof Entry);
		  this.entryStack.push(entry);
		  try {
		    callback.call(this.emitter);
		  } finally {
		    var popped = this.entryStack.pop();
		    _assert2.default.strictEqual(popped, entry);
		  }
		};
	
		LMp._findLeapLocation = function (property, label) {
		  for (var i = this.entryStack.length - 1; i >= 0; --i) {
		    var entry = this.entryStack[i];
		    var loc = entry[property];
		    if (loc) {
		      if (label) {
		        if (entry.label && entry.label.name === label.name) {
		          return loc;
		        }
		      } else if (entry instanceof LabeledEntry) {
		        // Ignore LabeledEntry entries unless we are actually breaking to
		        // a label.
		      } else {
		        return loc;
		      }
		    }
		  }
	
		  return null;
		};
	
		LMp.getBreakLoc = function (label) {
		  return this._findLeapLocation("breakLoc", label);
		};
	
		LMp.getContinueLoc = function (label) {
		  return this._findLeapLocation("continueLoc", label);
		};
	
	/***/ }),
	/* 608 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		var _assert = __webpack_require__(64);
	
		var _assert2 = _interopRequireDefault(_assert);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		var m = __webpack_require__(281).makeAccessor(); /**
		                                            * Copyright (c) 2014, Facebook, Inc.
		                                            * All rights reserved.
		                                            *
		                                            * This source code is licensed under the BSD-style license found in the
		                                            * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
		                                            * additional grant of patent rights can be found in the PATENTS file in
		                                            * the same directory.
		                                            */
	
		var hasOwn = Object.prototype.hasOwnProperty;
	
		function makePredicate(propertyName, knownTypes) {
		  function onlyChildren(node) {
		    t.assertNode(node);
	
		    // Assume no side effects until we find out otherwise.
		    var result = false;
	
		    function check(child) {
		      if (result) {
		        // Do nothing.
		      } else if (Array.isArray(child)) {
		        child.some(check);
		      } else if (t.isNode(child)) {
		        _assert2.default.strictEqual(result, false);
		        result = predicate(child);
		      }
		      return result;
		    }
	
		    var keys = t.VISITOR_KEYS[node.type];
		    if (keys) {
		      for (var i = 0; i < keys.length; i++) {
		        var key = keys[i];
		        var child = node[key];
		        check(child);
		      }
		    }
	
		    return result;
		  }
	
		  function predicate(node) {
		    t.assertNode(node);
	
		    var meta = m(node);
		    if (hasOwn.call(meta, propertyName)) return meta[propertyName];
	
		    // Certain types are "opaque," which means they have no side
		    // effects or leaps and we don't care about their subexpressions.
		    if (hasOwn.call(opaqueTypes, node.type)) return meta[propertyName] = false;
	
		    if (hasOwn.call(knownTypes, node.type)) return meta[propertyName] = true;
	
		    return meta[propertyName] = onlyChildren(node);
		  }
	
		  predicate.onlyChildren = onlyChildren;
	
		  return predicate;
		}
	
		var opaqueTypes = {
		  FunctionExpression: true,
		  ArrowFunctionExpression: true
		};
	
		// These types potentially have side effects regardless of what side
		// effects their subexpressions have.
		var sideEffectTypes = {
		  CallExpression: true, // Anything could happen!
		  ForInStatement: true, // Modifies the key variable.
		  UnaryExpression: true, // Think delete.
		  BinaryExpression: true, // Might invoke .toString() or .valueOf().
		  AssignmentExpression: true, // Side-effecting by definition.
		  UpdateExpression: true, // Updates are essentially assignments.
		  NewExpression: true // Similar to CallExpression.
		};
	
		// These types are the direct cause of all leaps in control flow.
		var leapTypes = {
		  YieldExpression: true,
		  BreakStatement: true,
		  ContinueStatement: true,
		  ReturnStatement: true,
		  ThrowStatement: true
		};
	
		// All leap types are also side effect types.
		for (var type in leapTypes) {
		  if (hasOwn.call(leapTypes, type)) {
		    sideEffectTypes[type] = leapTypes[type];
		  }
		}
	
		exports.hasSideEffects = makePredicate("hasSideEffects", sideEffectTypes);
		exports.containsLeap = makePredicate("containsLeap", leapTypes);
	
	/***/ }),
	/* 609 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		exports.__esModule = true;
		exports.default = replaceShorthandObjectMethod;
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		var _util = __webpack_require__(116);
	
		var util = _interopRequireWildcard(_util);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		// this function converts a shorthand object generator method into a normal
		// (non-shorthand) object property which is a generator function expression. for
		// example, this:
		//
		//  var foo = {
		//    *bar(baz) { return 5; }
		//  }
		//
		// should be replaced with:
		//
		//  var foo = {
		//    bar: function*(baz) { return 5; }
		//  }
		//
		// to do this, it clones the parameter array and the body of the object generator
		// method into a new FunctionExpression.
		//
		// this method can be passed any Function AST node path, and it will return
		// either:
		//   a) the path that was passed in (iff the path did not need to be replaced) or
		//   b) the path of the new FunctionExpression that was created as a replacement
		//     (iff the path did need to be replaced)
		//
		// In either case, though, the caller can count on the fact that the return value
		// is a Function AST node path.
		//
		// If this function is called with an AST node path that is not a Function (or with an
		// argument that isn't an AST node path), it will throw an error.
		function replaceShorthandObjectMethod(path) {
		  if (!path.node || !t.isFunction(path.node)) {
		    throw new Error("replaceShorthandObjectMethod can only be called on Function AST node paths.");
		  }
	
		  // this function only replaces shorthand object methods (called ObjectMethod
		  // in Babel-speak).
		  if (!t.isObjectMethod(path.node)) {
		    return path;
		  }
	
		  // this function only replaces generators.
		  if (!path.node.generator) {
		    return path;
		  }
	
		  var parameters = path.node.params.map(function (param) {
		    return t.cloneDeep(param);
		  });
	
		  var functionExpression = t.functionExpression(null, // id
		  parameters, // params
		  t.cloneDeep(path.node.body), // body
		  path.node.generator, path.node.async);
	
		  util.replaceWithOrRemove(path, t.objectProperty(t.cloneDeep(path.node.key), // key
		  functionExpression, //value
		  path.node.computed, // computed
		  false // shorthand
		  ));
	
		  // path now refers to the ObjectProperty AST node path, but we want to return a
		  // Function AST node path for the function expression we created. we know that
		  // the FunctionExpression we just created is the value of the ObjectProperty,
		  // so return the "value" path off of this path.
		  return path.get("value");
		}
	
	/***/ }),
	/* 610 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2014, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
		 * additional grant of patent rights can be found in the PATENTS file in
		 * the same directory.
		 */
	
		"use strict";
	
		var _assert = __webpack_require__(64);
	
		var _assert2 = _interopRequireDefault(_assert);
	
		var _babelTypes = __webpack_require__(1);
	
		var t = _interopRequireWildcard(_babelTypes);
	
		var _hoist = __webpack_require__(605);
	
		var _emit = __webpack_require__(283);
	
		var _replaceShorthandObjectMethod = __webpack_require__(609);
	
		var _replaceShorthandObjectMethod2 = _interopRequireDefault(_replaceShorthandObjectMethod);
	
		var _util = __webpack_require__(116);
	
		var util = _interopRequireWildcard(_util);
	
		function _interopRequireWildcard(obj) {
		  if (obj && obj.__esModule) {
		    return obj;
		  } else {
		    var newObj = {};if (obj != null) {
		      for (var key in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
		      }
		    }newObj.default = obj;return newObj;
		  }
		}
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { default: obj };
		}
	
		exports.name = "regenerator-transform";
	
		exports.visitor = {
		  Function: {
		    exit: function exit(path, state) {
		      var node = path.node;
	
		      if (node.generator) {
		        if (node.async) {
		          // Async generator
		          if (state.opts.asyncGenerators === false) return;
		        } else {
		          // Plain generator
		          if (state.opts.generators === false) return;
		        }
		      } else if (node.async) {
		        // Async function
		        if (state.opts.async === false) return;
		      } else {
		        // Not a generator or async function.
		        return;
		      }
	
		      // if this is an ObjectMethod, we need to convert it to an ObjectProperty
		      path = (0, _replaceShorthandObjectMethod2.default)(path);
		      node = path.node;
	
		      var contextId = path.scope.generateUidIdentifier("context");
		      var argsId = path.scope.generateUidIdentifier("args");
	
		      path.ensureBlock();
		      var bodyBlockPath = path.get("body");
	
		      if (node.async) {
		        bodyBlockPath.traverse(awaitVisitor);
		      }
	
		      bodyBlockPath.traverse(functionSentVisitor, {
		        context: contextId
		      });
	
		      var outerBody = [];
		      var innerBody = [];
	
		      bodyBlockPath.get("body").forEach(function (childPath) {
		        var node = childPath.node;
		        if (t.isExpressionStatement(node) && t.isStringLiteral(node.expression)) {
		          // Babylon represents directives like "use strict" as elements
		          // of a bodyBlockPath.node.directives array, but they could just
		          // as easily be represented (by other parsers) as traditional
		          // string-literal-valued expression statements, so we need to
		          // handle that here. (#248)
		          outerBody.push(node);
		        } else if (node && node._blockHoist != null) {
		          outerBody.push(node);
		        } else {
		          innerBody.push(node);
		        }
		      });
	
		      if (outerBody.length > 0) {
		        // Only replace the inner body if we actually hoisted any statements
		        // to the outer body.
		        bodyBlockPath.node.body = innerBody;
		      }
	
		      var outerFnExpr = getOuterFnExpr(path);
		      // Note that getOuterFnExpr has the side-effect of ensuring that the
		      // function has a name (so node.id will always be an Identifier), even
		      // if a temporary name has to be synthesized.
		      t.assertIdentifier(node.id);
		      var innerFnId = t.identifier(node.id.name + "$");
	
		      // Turn all declarations into vars, and replace the original
		      // declarations with equivalent assignment expressions.
		      var vars = (0, _hoist.hoist)(path);
	
		      var didRenameArguments = renameArguments(path, argsId);
		      if (didRenameArguments) {
		        vars = vars || t.variableDeclaration("var", []);
		        var argumentIdentifier = t.identifier("arguments");
		        // we need to do this as otherwise arguments in arrow functions gets hoisted
		        argumentIdentifier._shadowedFunctionLiteral = path;
		        vars.declarations.push(t.variableDeclarator(argsId, argumentIdentifier));
		      }
	
		      var emitter = new _emit.Emitter(contextId);
		      emitter.explode(path.get("body"));
	
		      if (vars && vars.declarations.length > 0) {
		        outerBody.push(vars);
		      }
	
		      var wrapArgs = [emitter.getContextFunction(innerFnId),
		      // Async functions that are not generators don't care about the
		      // outer function because they don't need it to be marked and don't
		      // inherit from its .prototype.
		      node.generator ? outerFnExpr : t.nullLiteral(), t.thisExpression()];
	
		      var tryLocsList = emitter.getTryLocsList();
		      if (tryLocsList) {
		        wrapArgs.push(tryLocsList);
		      }
	
		      var wrapCall = t.callExpression(util.runtimeProperty(node.async ? "async" : "wrap"), wrapArgs);
	
		      outerBody.push(t.returnStatement(wrapCall));
		      node.body = t.blockStatement(outerBody);
	
		      var oldDirectives = bodyBlockPath.node.directives;
		      if (oldDirectives) {
		        // Babylon represents directives like "use strict" as elements of
		        // a bodyBlockPath.node.directives array. (#248)
		        node.body.directives = oldDirectives;
		      }
	
		      var wasGeneratorFunction = node.generator;
		      if (wasGeneratorFunction) {
		        node.generator = false;
		      }
	
		      if (node.async) {
		        node.async = false;
		      }
	
		      if (wasGeneratorFunction && t.isExpression(node)) {
		        util.replaceWithOrRemove(path, t.callExpression(util.runtimeProperty("mark"), [node]));
		        path.addComment("leading", "#__PURE__");
		      }
	
		      // Generators are processed in 'exit' handlers so that regenerator only has to run on
		      // an ES5 AST, but that means traversal will not pick up newly inserted references
		      // to things like 'regeneratorRuntime'. To avoid this, we explicitly requeue.
		      path.requeue();
		    }
		  }
		};
	
		// Given a NodePath for a Function, return an Expression node that can be
		// used to refer reliably to the function object from inside the function.
		// This expression is essentially a replacement for arguments.callee, with
		// the key advantage that it works in strict mode.
		function getOuterFnExpr(funPath) {
		  var node = funPath.node;
		  t.assertFunction(node);
	
		  if (!node.id) {
		    // Default-exported function declarations, and function expressions may not
		    // have a name to reference, so we explicitly add one.
		    node.id = funPath.scope.parent.generateUidIdentifier("callee");
		  }
	
		  if (node.generator && // Non-generator functions don't need to be marked.
		  t.isFunctionDeclaration(node)) {
		    // Return the identifier returned by runtime.mark(<node.id>).
		    return getMarkedFunctionId(funPath);
		  }
	
		  return node.id;
		}
	
		var getMarkInfo = __webpack_require__(281).makeAccessor();
	
		function getMarkedFunctionId(funPath) {
		  var node = funPath.node;
		  t.assertIdentifier(node.id);
	
		  var blockPath = funPath.findParent(function (path) {
		    return path.isProgram() || path.isBlockStatement();
		  });
	
		  if (!blockPath) {
		    return node.id;
		  }
	
		  var block = blockPath.node;
		  _assert2.default.ok(Array.isArray(block.body));
	
		  var info = getMarkInfo(block);
		  if (!info.decl) {
		    info.decl = t.variableDeclaration("var", []);
		    blockPath.unshiftContainer("body", info.decl);
		    info.declPath = blockPath.get("body.0");
		  }
	
		  _assert2.default.strictEqual(info.declPath.node, info.decl);
	
		  // Get a new unique identifier for our marked variable.
		  var markedId = blockPath.scope.generateUidIdentifier("marked");
		  var markCallExp = t.callExpression(util.runtimeProperty("mark"), [node.id]);
	
		  var index = info.decl.declarations.push(t.variableDeclarator(markedId, markCallExp)) - 1;
	
		  var markCallExpPath = info.declPath.get("declarations." + index + ".init");
	
		  _assert2.default.strictEqual(markCallExpPath.node, markCallExp);
	
		  markCallExpPath.addComment("leading", "#__PURE__");
	
		  return markedId;
		}
	
		function renameArguments(funcPath, argsId) {
		  var state = {
		    didRenameArguments: false,
		    argsId: argsId
		  };
	
		  funcPath.traverse(argumentsVisitor, state);
	
		  // If the traversal replaced any arguments references, then we need to
		  // alias the outer function's arguments binding (be it the implicit
		  // arguments object or some other parameter or variable) to the variable
		  // named by argsId.
		  return state.didRenameArguments;
		}
	
		var argumentsVisitor = {
		  "FunctionExpression|FunctionDeclaration": function FunctionExpressionFunctionDeclaration(path) {
		    path.skip();
		  },
	
		  Identifier: function Identifier(path, state) {
		    if (path.node.name === "arguments" && util.isReference(path)) {
		      util.replaceWithOrRemove(path, state.argsId);
		      state.didRenameArguments = true;
		    }
		  }
		};
	
		var functionSentVisitor = {
		  MetaProperty: function MetaProperty(path) {
		    var node = path.node;
	
		    if (node.meta.name === "function" && node.property.name === "sent") {
		      util.replaceWithOrRemove(path, t.memberExpression(this.context, t.identifier("_sent")));
		    }
		  }
		};
	
		var awaitVisitor = {
		  Function: function Function(path) {
		    path.skip(); // Don't descend into nested function scopes.
		  },
	
		  AwaitExpression: function AwaitExpression(path) {
		    // Convert await expressions to yield expressions.
		    var argument = path.node.argument;
	
		    // Transforming `await x` to `yield regeneratorRuntime.awrap(x)`
		    // causes the argument to be wrapped in such a way that the runtime
		    // can distinguish between awaited and merely yielded values.
		    util.replaceWithOrRemove(path, t.yieldExpression(t.callExpression(util.runtimeProperty("awrap"), [argument]), false));
		  }
		};
	
	/***/ }),
	/* 611 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		// Generated by `/scripts/character-class-escape-sets.js`. Do not edit.
		var regenerate = __webpack_require__(282);
	
		exports.REGULAR = {
			'd': regenerate().addRange(0x30, 0x39),
			'D': regenerate().addRange(0x0, 0x2F).addRange(0x3A, 0xFFFF),
			's': regenerate(0x20, 0xA0, 0x1680, 0x202F, 0x205F, 0x3000, 0xFEFF).addRange(0x9, 0xD).addRange(0x2000, 0x200A).addRange(0x2028, 0x2029),
			'S': regenerate().addRange(0x0, 0x8).addRange(0xE, 0x1F).addRange(0x21, 0x9F).addRange(0xA1, 0x167F).addRange(0x1681, 0x1FFF).addRange(0x200B, 0x2027).addRange(0x202A, 0x202E).addRange(0x2030, 0x205E).addRange(0x2060, 0x2FFF).addRange(0x3001, 0xFEFE).addRange(0xFF00, 0xFFFF),
			'w': regenerate(0x5F).addRange(0x30, 0x39).addRange(0x41, 0x5A).addRange(0x61, 0x7A),
			'W': regenerate(0x60).addRange(0x0, 0x2F).addRange(0x3A, 0x40).addRange(0x5B, 0x5E).addRange(0x7B, 0xFFFF)
		};
	
		exports.UNICODE = {
			'd': regenerate().addRange(0x30, 0x39),
			'D': regenerate().addRange(0x0, 0x2F).addRange(0x3A, 0x10FFFF),
			's': regenerate(0x20, 0xA0, 0x1680, 0x202F, 0x205F, 0x3000, 0xFEFF).addRange(0x9, 0xD).addRange(0x2000, 0x200A).addRange(0x2028, 0x2029),
			'S': regenerate().addRange(0x0, 0x8).addRange(0xE, 0x1F).addRange(0x21, 0x9F).addRange(0xA1, 0x167F).addRange(0x1681, 0x1FFF).addRange(0x200B, 0x2027).addRange(0x202A, 0x202E).addRange(0x2030, 0x205E).addRange(0x2060, 0x2FFF).addRange(0x3001, 0xFEFE).addRange(0xFF00, 0x10FFFF),
			'w': regenerate(0x5F).addRange(0x30, 0x39).addRange(0x41, 0x5A).addRange(0x61, 0x7A),
			'W': regenerate(0x60).addRange(0x0, 0x2F).addRange(0x3A, 0x40).addRange(0x5B, 0x5E).addRange(0x7B, 0x10FFFF)
		};
	
		exports.UNICODE_IGNORE_CASE = {
			'd': regenerate().addRange(0x30, 0x39),
			'D': regenerate().addRange(0x0, 0x2F).addRange(0x3A, 0x10FFFF),
			's': regenerate(0x20, 0xA0, 0x1680, 0x202F, 0x205F, 0x3000, 0xFEFF).addRange(0x9, 0xD).addRange(0x2000, 0x200A).addRange(0x2028, 0x2029),
			'S': regenerate().addRange(0x0, 0x8).addRange(0xE, 0x1F).addRange(0x21, 0x9F).addRange(0xA1, 0x167F).addRange(0x1681, 0x1FFF).addRange(0x200B, 0x2027).addRange(0x202A, 0x202E).addRange(0x2030, 0x205E).addRange(0x2060, 0x2FFF).addRange(0x3001, 0xFEFE).addRange(0xFF00, 0x10FFFF),
			'w': regenerate(0x5F, 0x17F, 0x212A).addRange(0x30, 0x39).addRange(0x41, 0x5A).addRange(0x61, 0x7A),
			'W': regenerate(0x4B, 0x53, 0x60).addRange(0x0, 0x2F).addRange(0x3A, 0x40).addRange(0x5B, 0x5E).addRange(0x7B, 0x10FFFF)
		};
	
	/***/ }),
	/* 612 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var generate = __webpack_require__(613).generate;
		var parse = __webpack_require__(614).parse;
		var regenerate = __webpack_require__(282);
		var iuMappings = __webpack_require__(631);
		var ESCAPE_SETS = __webpack_require__(611);
	
		function getCharacterClassEscapeSet(character) {
			if (unicode) {
				if (ignoreCase) {
					return ESCAPE_SETS.UNICODE_IGNORE_CASE[character];
				}
				return ESCAPE_SETS.UNICODE[character];
			}
			return ESCAPE_SETS.REGULAR[character];
		}
	
		var object = {};
		var hasOwnProperty = object.hasOwnProperty;
		function has(object, property) {
			return hasOwnProperty.call(object, property);
		}
	
		// Prepare a Regenerate set containing all code points, used for negative
		// character classes (if any).
		var UNICODE_SET = regenerate().addRange(0x0, 0x10FFFF);
		// Without the `u` flag, the range stops at 0xFFFF.
		// https://mths.be/es6#sec-pattern-semantics
		var BMP_SET = regenerate().addRange(0x0, 0xFFFF);
	
		// Prepare a Regenerate set containing all code points that are supposed to be
		// matched by `/./u`. https://mths.be/es6#sec-atom
		var DOT_SET_UNICODE = UNICODE_SET.clone() // all Unicode code points
		.remove(
		// minus `LineTerminator`s (https://mths.be/es6#sec-line-terminators):
		0x000A, // Line Feed <LF>
		0x000D, // Carriage Return <CR>
		0x2028, // Line Separator <LS>
		0x2029 // Paragraph Separator <PS>
		);
		// Prepare a Regenerate set containing all code points that are supposed to be
		// matched by `/./` (only BMP code points).
		var DOT_SET = DOT_SET_UNICODE.clone().intersection(BMP_SET);
	
		// Add a range of code points + any case-folded code points in that range to a
		// set.
		regenerate.prototype.iuAddRange = function (min, max) {
			var $this = this;
			do {
				var folded = caseFold(min);
				if (folded) {
					$this.add(folded);
				}
			} while (++min <= max);
			return $this;
		};
	
		function assign(target, source) {
			for (var key in source) {
				// Note: `hasOwnProperty` is not needed here.
				target[key] = source[key];
			}
		}
	
		function update(item, pattern) {
			// TODO: Test if memoizing `pattern` here is worth the effort.
			if (!pattern) {
				return;
			}
			var tree = parse(pattern, '');
			switch (tree.type) {
				case 'characterClass':
				case 'group':
				case 'value':
					// No wrapping needed.
					break;
				default:
					// Wrap the pattern in a non-capturing group.
					tree = wrap(tree, pattern);
			}
			assign(item, tree);
		}
	
		function wrap(tree, pattern) {
			// Wrap the pattern in a non-capturing group.
			return {
				'type': 'group',
				'behavior': 'ignore',
				'body': [tree],
				'raw': '(?:' + pattern + ')'
			};
		}
	
		function caseFold(codePoint) {
			return has(iuMappings, codePoint) ? iuMappings[codePoint] : false;
		}
	
		var ignoreCase = false;
		var unicode = false;
		function processCharacterClass(characterClassItem) {
			var set = regenerate();
			var body = characterClassItem.body.forEach(function (item) {
				switch (item.type) {
					case 'value':
						set.add(item.codePoint);
						if (ignoreCase && unicode) {
							var folded = caseFold(item.codePoint);
							if (folded) {
								set.add(folded);
							}
						}
						break;
					case 'characterClassRange':
						var min = item.min.codePoint;
						var max = item.max.codePoint;
						set.addRange(min, max);
						if (ignoreCase && unicode) {
							set.iuAddRange(min, max);
						}
						break;
					case 'characterClassEscape':
						set.add(getCharacterClassEscapeSet(item.value));
						break;
					// The `default` clause is only here as a safeguard; it should never be
					// reached. Code coverage tools should ignore it.
					/* istanbul ignore next */
					default:
						throw Error('Unknown term type: ' + item.type);
				}
			});
			if (characterClassItem.negative) {
				set = (unicode ? UNICODE_SET : BMP_SET).clone().remove(set);
			}
			update(characterClassItem, set.toString());
			return characterClassItem;
		}
	
		function processTerm(item) {
			switch (item.type) {
				case 'dot':
					update(item, (unicode ? DOT_SET_UNICODE : DOT_SET).toString());
					break;
				case 'characterClass':
					item = processCharacterClass(item);
					break;
				case 'characterClassEscape':
					update(item, getCharacterClassEscapeSet(item.value).toString());
					break;
				case 'alternative':
				case 'disjunction':
				case 'group':
				case 'quantifier':
					item.body = item.body.map(processTerm);
					break;
				case 'value':
					var codePoint = item.codePoint;
					var set = regenerate(codePoint);
					if (ignoreCase && unicode) {
						var folded = caseFold(codePoint);
						if (folded) {
							set.add(folded);
						}
					}
					update(item, set.toString());
					break;
				case 'anchor':
				case 'empty':
				case 'group':
				case 'reference':
					// Nothing to do here.
					break;
				// The `default` clause is only here as a safeguard; it should never be
				// reached. Code coverage tools should ignore it.
				/* istanbul ignore next */
				default:
					throw Error('Unknown term type: ' + item.type);
			}
			return item;
		};
	
		module.exports = function (pattern, flags) {
			var tree = parse(pattern, flags);
			ignoreCase = flags ? flags.indexOf('i') > -1 : false;
			unicode = flags ? flags.indexOf('u') > -1 : false;
			assign(tree, processTerm(tree));
			return generate(tree);
		};
	
	/***/ }),
	/* 613 */
	/***/ (function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		/*!
		 * RegJSGen
		 * Copyright 2014 Benjamin Tan <https://d10.github.io/>
		 * Available under MIT license <http://d10.mit-license.org/>
		 */
		;(function () {
		  'use strict';
	
		  /** Used to determine if values are of the language type `Object` */
	
		  var objectTypes = {
		    'function': true,
		    'object': true
		  };
	
		  /** Used as a reference to the global object */
		  var root = objectTypes[typeof window === 'undefined' ? 'undefined' : _typeof(window)] && window || this;
	
		  /** Backup possible global object */
		  var oldRoot = root;
	
		  /** Detect free variable `exports` */
		  var freeExports = objectTypes[ false ? 'undefined' : _typeof(exports)] && exports;
	
		  /** Detect free variable `module` */
		  var freeModule = objectTypes[ false ? 'undefined' : _typeof(module)] && module && !module.nodeType && module;
	
		  /** Detect free variable `global` from Node.js or Browserified code and use it as `root` */
		  var freeGlobal = freeExports && freeModule && (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global;
		  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
		    root = freeGlobal;
		  }
	
		  /*--------------------------------------------------------------------------*/
	
		  /*! Based on https://mths.be/fromcodepoint v0.2.0 by @mathias */
	
		  var stringFromCharCode = String.fromCharCode;
		  var floor = Math.floor;
		  function fromCodePoint() {
		    var MAX_SIZE = 0x4000;
		    var codeUnits = [];
		    var highSurrogate;
		    var lowSurrogate;
		    var index = -1;
		    var length = arguments.length;
		    if (!length) {
		      return '';
		    }
		    var result = '';
		    while (++index < length) {
		      var codePoint = Number(arguments[index]);
		      if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
		      codePoint < 0 || // not a valid Unicode code point
		      codePoint > 0x10FFFF || // not a valid Unicode code point
		      floor(codePoint) != codePoint // not an integer
		      ) {
		          throw RangeError('Invalid code point: ' + codePoint);
		        }
		      if (codePoint <= 0xFFFF) {
		        // BMP code point
		        codeUnits.push(codePoint);
		      } else {
		        // Astral code point; split in surrogate halves
		        // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
		        codePoint -= 0x10000;
		        highSurrogate = (codePoint >> 10) + 0xD800;
		        lowSurrogate = codePoint % 0x400 + 0xDC00;
		        codeUnits.push(highSurrogate, lowSurrogate);
		      }
		      if (index + 1 == length || codeUnits.length > MAX_SIZE) {
		        result += stringFromCharCode.apply(null, codeUnits);
		        codeUnits.length = 0;
		      }
		    }
		    return result;
		  }
	
		  function assertType(type, expected) {
		    if (expected.indexOf('|') == -1) {
		      if (type == expected) {
		        return;
		      }
	
		      throw Error('Invalid node type: ' + type);
		    }
	
		    expected = assertType.hasOwnProperty(expected) ? assertType[expected] : assertType[expected] = RegExp('^(?:' + expected + ')$');
	
		    if (expected.test(type)) {
		      return;
		    }
	
		    throw Error('Invalid node type: ' + type);
		  }
	
		  /*--------------------------------------------------------------------------*/
	
		  function generate(node) {
		    var type = node.type;
	
		    if (generate.hasOwnProperty(type) && typeof generate[type] == 'function') {
		      return generate[type](node);
		    }
	
		    throw Error('Invalid node type: ' + type);
		  }
	
		  /*--------------------------------------------------------------------------*/
	
		  function generateAlternative(node) {
		    assertType(node.type, 'alternative');
	
		    var terms = node.body,
		        length = terms ? terms.length : 0;
	
		    if (length == 1) {
		      return generateTerm(terms[0]);
		    } else {
		      var i = -1,
		          result = '';
	
		      while (++i < length) {
		        result += generateTerm(terms[i]);
		      }
	
		      return result;
		    }
		  }
	
		  function generateAnchor(node) {
		    assertType(node.type, 'anchor');
	
		    switch (node.kind) {
		      case 'start':
		        return '^';
		      case 'end':
		        return '$';
		      case 'boundary':
		        return '\\b';
		      case 'not-boundary':
		        return '\\B';
		      default:
		        throw Error('Invalid assertion');
		    }
		  }
	
		  function generateAtom(node) {
		    assertType(node.type, 'anchor|characterClass|characterClassEscape|dot|group|reference|value');
	
		    return generate(node);
		  }
	
		  function generateCharacterClass(node) {
		    assertType(node.type, 'characterClass');
	
		    var classRanges = node.body,
		        length = classRanges ? classRanges.length : 0;
	
		    var i = -1,
		        result = '[';
	
		    if (node.negative) {
		      result += '^';
		    }
	
		    while (++i < length) {
		      result += generateClassAtom(classRanges[i]);
		    }
	
		    result += ']';
	
		    return result;
		  }
	
		  function generateCharacterClassEscape(node) {
		    assertType(node.type, 'characterClassEscape');
	
		    return '\\' + node.value;
		  }
	
		  function generateCharacterClassRange(node) {
		    assertType(node.type, 'characterClassRange');
	
		    var min = node.min,
		        max = node.max;
	
		    if (min.type == 'characterClassRange' || max.type == 'characterClassRange') {
		      throw Error('Invalid character class range');
		    }
	
		    return generateClassAtom(min) + '-' + generateClassAtom(max);
		  }
	
		  function generateClassAtom(node) {
		    assertType(node.type, 'anchor|characterClassEscape|characterClassRange|dot|value');
	
		    return generate(node);
		  }
	
		  function generateDisjunction(node) {
		    assertType(node.type, 'disjunction');
	
		    var body = node.body,
		        length = body ? body.length : 0;
	
		    if (length == 0) {
		      throw Error('No body');
		    } else if (length == 1) {
		      return generate(body[0]);
		    } else {
		      var i = -1,
		          result = '';
	
		      while (++i < length) {
		        if (i != 0) {
		          result += '|';
		        }
		        result += generate(body[i]);
		      }
	
		      return result;
		    }
		  }
	
		  function generateDot(node) {
		    assertType(node.type, 'dot');
	
		    return '.';
		  }
	
		  function generateGroup(node) {
		    assertType(node.type, 'group');
	
		    var result = '(';
	
		    switch (node.behavior) {
		      case 'normal':
		        break;
		      case 'ignore':
		        result += '?:';
		        break;
		      case 'lookahead':
		        result += '?=';
		        break;
		      case 'negativeLookahead':
		        result += '?!';
		        break;
		      default:
		        throw Error('Invalid behaviour: ' + node.behaviour);
		    }
	
		    var body = node.body,
		        length = body ? body.length : 0;
	
		    if (length == 1) {
		      result += generate(body[0]);
		    } else {
		      var i = -1;
	
		      while (++i < length) {
		        result += generate(body[i]);
		      }
		    }
	
		    result += ')';
	
		    return result;
		  }
	
		  function generateQuantifier(node) {
		    assertType(node.type, 'quantifier');
	
		    var quantifier = '',
		        min = node.min,
		        max = node.max;
	
		    switch (max) {
		      case undefined:
		      case null:
		        switch (min) {
		          case 0:
		            quantifier = '*';
		            break;
		          case 1:
		            quantifier = '+';
		            break;
		          default:
		            quantifier = '{' + min + ',}';
		            break;
		        }
		        break;
		      default:
		        if (min == max) {
		          quantifier = '{' + min + '}';
		        } else if (min == 0 && max == 1) {
		          quantifier = '?';
		        } else {
		          quantifier = '{' + min + ',' + max + '}';
		        }
		        break;
		    }
	
		    if (!node.greedy) {
		      quantifier += '?';
		    }
	
		    return generateAtom(node.body[0]) + quantifier;
		  }
	
		  function generateReference(node) {
		    assertType(node.type, 'reference');
	
		    return '\\' + node.matchIndex;
		  }
	
		  function generateTerm(node) {
		    assertType(node.type, 'anchor|characterClass|characterClassEscape|empty|group|quantifier|reference|value');
	
		    return generate(node);
		  }
	
		  function generateValue(node) {
		    assertType(node.type, 'value');
	
		    var kind = node.kind,
		        codePoint = node.codePoint;
	
		    switch (kind) {
		      case 'controlLetter':
		        return '\\c' + fromCodePoint(codePoint + 64);
		      case 'hexadecimalEscape':
		        return '\\x' + ('00' + codePoint.toString(16).toUpperCase()).slice(-2);
		      case 'identifier':
		        return '\\' + fromCodePoint(codePoint);
		      case 'null':
		        return '\\' + codePoint;
		      case 'octal':
		        return '\\' + codePoint.toString(8);
		      case 'singleEscape':
		        switch (codePoint) {
		          case 0x0008:
		            return '\\b';
		          case 0x009:
		            return '\\t';
		          case 0x00A:
		            return '\\n';
		          case 0x00B:
		            return '\\v';
		          case 0x00C:
		            return '\\f';
		          case 0x00D:
		            return '\\r';
		          default:
		            throw Error('Invalid codepoint: ' + codePoint);
		        }
		      case 'symbol':
		        return fromCodePoint(codePoint);
		      case 'unicodeEscape':
		        return '\\u' + ('0000' + codePoint.toString(16).toUpperCase()).slice(-4);
		      case 'unicodeCodePointEscape':
		        return '\\u{' + codePoint.toString(16).toUpperCase() + '}';
		      default:
		        throw Error('Unsupported node kind: ' + kind);
		    }
		  }
	
		  /*--------------------------------------------------------------------------*/
	
		  generate.alternative = generateAlternative;
		  generate.anchor = generateAnchor;
		  generate.characterClass = generateCharacterClass;
		  generate.characterClassEscape = generateCharacterClassEscape;
		  generate.characterClassRange = generateCharacterClassRange;
		  generate.disjunction = generateDisjunction;
		  generate.dot = generateDot;
		  generate.group = generateGroup;
		  generate.quantifier = generateQuantifier;
		  generate.reference = generateReference;
		  generate.value = generateValue;
	
		  /*--------------------------------------------------------------------------*/
	
		  // export regjsgen
		  // some AMD build optimizers, like r.js, check for condition patterns like the following:
		  if ("function" == 'function' && _typeof(__webpack_require__(49)) == 'object' && __webpack_require__(49)) {
		    // define as an anonymous module so, through path mapping, it can be aliased
		    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
		      return {
		        'generate': generate
		      };
		    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		  }
		  // check for `exports` after `define` in case a build optimizer adds an `exports` object
		  else if (freeExports && freeModule) {
		      // in Narwhal, Node.js, Rhino -require, or RingoJS
		      freeExports.generate = generate;
		    }
		    // in a browser or Rhino
		    else {
		        root.regjsgen = {
		          'generate': generate
		        };
		      }
		}).call(undefined);
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)(module), (function() { return this; }())))
	
	/***/ }),
	/* 614 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		// regjsparser
		//
		// ==================================================================
		//
		// See ECMA-262 Standard: 15.10.1
		//
		// NOTE: The ECMA-262 standard uses the term "Assertion" for /^/. Here the
		//   term "Anchor" is used.
		//
		// Pattern ::
		//      Disjunction
		//
		// Disjunction ::
		//      Alternative
		//      Alternative | Disjunction
		//
		// Alternative ::
		//      [empty]
		//      Alternative Term
		//
		// Term ::
		//      Anchor
		//      Atom
		//      Atom Quantifier
		//
		// Anchor ::
		//      ^
		//      $
		//      \ b
		//      \ B
		//      ( ? = Disjunction )
		//      ( ? ! Disjunction )
		//
		// Quantifier ::
		//      QuantifierPrefix
		//      QuantifierPrefix ?
		//
		// QuantifierPrefix ::
		//      *
		//      +
		//      ?
		//      { DecimalDigits }
		//      { DecimalDigits , }
		//      { DecimalDigits , DecimalDigits }
		//
		// Atom ::
		//      PatternCharacter
		//      .
		//      \ AtomEscape
		//      CharacterClass
		//      ( Disjunction )
		//      ( ? : Disjunction )
		//
		// PatternCharacter ::
		//      SourceCharacter but not any of: ^ $ \ . * + ? ( ) [ ] { } |
		//
		// AtomEscape ::
		//      DecimalEscape
		//      CharacterEscape
		//      CharacterClassEscape
		//
		// CharacterEscape[U] ::
		//      ControlEscape
		//      c ControlLetter
		//      HexEscapeSequence
		//      RegExpUnicodeEscapeSequence[?U] (ES6)
		//      IdentityEscape[?U]
		//
		// ControlEscape ::
		//      one of f n r t v
		// ControlLetter ::
		//      one of
		//          a b c d e f g h i j k l m n o p q r s t u v w x y z
		//          A B C D E F G H I J K L M N O P Q R S T U V W X Y Z
		//
		// IdentityEscape ::
		//      SourceCharacter but not IdentifierPart
		//      <ZWJ>
		//      <ZWNJ>
		//
		// DecimalEscape ::
		//      DecimalIntegerLiteral [lookahead ∉ DecimalDigit]
		//
		// CharacterClassEscape ::
		//      one of d D s S w W
		//
		// CharacterClass ::
		//      [ [lookahead ∉ {^}] ClassRanges ]
		//      [ ^ ClassRanges ]
		//
		// ClassRanges ::
		//      [empty]
		//      NonemptyClassRanges
		//
		// NonemptyClassRanges ::
		//      ClassAtom
		//      ClassAtom NonemptyClassRangesNoDash
		//      ClassAtom - ClassAtom ClassRanges
		//
		// NonemptyClassRangesNoDash ::
		//      ClassAtom
		//      ClassAtomNoDash NonemptyClassRangesNoDash
		//      ClassAtomNoDash - ClassAtom ClassRanges
		//
		// ClassAtom ::
		//      -
		//      ClassAtomNoDash
		//
		// ClassAtomNoDash ::
		//      SourceCharacter but not one of \ or ] or -
		//      \ ClassEscape
		//
		// ClassEscape ::
		//      DecimalEscape
		//      b
		//      CharacterEscape
		//      CharacterClassEscape
	
		(function () {
	
		  function parse(str, flags) {
		    function addRaw(node) {
		      node.raw = str.substring(node.range[0], node.range[1]);
		      return node;
		    }
	
		    function updateRawStart(node, start) {
		      node.range[0] = start;
		      return addRaw(node);
		    }
	
		    function createAnchor(kind, rawLength) {
		      return addRaw({
		        type: 'anchor',
		        kind: kind,
		        range: [pos - rawLength, pos]
		      });
		    }
	
		    function createValue(kind, codePoint, from, to) {
		      return addRaw({
		        type: 'value',
		        kind: kind,
		        codePoint: codePoint,
		        range: [from, to]
		      });
		    }
	
		    function createEscaped(kind, codePoint, value, fromOffset) {
		      fromOffset = fromOffset || 0;
		      return createValue(kind, codePoint, pos - (value.length + fromOffset), pos);
		    }
	
		    function createCharacter(matches) {
		      var _char = matches[0];
		      var first = _char.charCodeAt(0);
		      if (hasUnicodeFlag) {
		        var second;
		        if (_char.length === 1 && first >= 0xD800 && first <= 0xDBFF) {
		          second = lookahead().charCodeAt(0);
		          if (second >= 0xDC00 && second <= 0xDFFF) {
		            // Unicode surrogate pair
		            pos++;
		            return createValue('symbol', (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000, pos - 2, pos);
		          }
		        }
		      }
		      return createValue('symbol', first, pos - 1, pos);
		    }
	
		    function createDisjunction(alternatives, from, to) {
		      return addRaw({
		        type: 'disjunction',
		        body: alternatives,
		        range: [from, to]
		      });
		    }
	
		    function createDot() {
		      return addRaw({
		        type: 'dot',
		        range: [pos - 1, pos]
		      });
		    }
	
		    function createCharacterClassEscape(value) {
		      return addRaw({
		        type: 'characterClassEscape',
		        value: value,
		        range: [pos - 2, pos]
		      });
		    }
	
		    function createReference(matchIndex) {
		      return addRaw({
		        type: 'reference',
		        matchIndex: parseInt(matchIndex, 10),
		        range: [pos - 1 - matchIndex.length, pos]
		      });
		    }
	
		    function createGroup(behavior, disjunction, from, to) {
		      return addRaw({
		        type: 'group',
		        behavior: behavior,
		        body: disjunction,
		        range: [from, to]
		      });
		    }
	
		    function createQuantifier(min, max, from, to) {
		      if (to == null) {
		        from = pos - 1;
		        to = pos;
		      }
	
		      return addRaw({
		        type: 'quantifier',
		        min: min,
		        max: max,
		        greedy: true,
		        body: null, // set later on
		        range: [from, to]
		      });
		    }
	
		    function createAlternative(terms, from, to) {
		      return addRaw({
		        type: 'alternative',
		        body: terms,
		        range: [from, to]
		      });
		    }
	
		    function createCharacterClass(classRanges, negative, from, to) {
		      return addRaw({
		        type: 'characterClass',
		        body: classRanges,
		        negative: negative,
		        range: [from, to]
		      });
		    }
	
		    function createClassRange(min, max, from, to) {
		      // See 15.10.2.15:
		      if (min.codePoint > max.codePoint) {
		        bail('invalid range in character class', min.raw + '-' + max.raw, from, to);
		      }
	
		      return addRaw({
		        type: 'characterClassRange',
		        min: min,
		        max: max,
		        range: [from, to]
		      });
		    }
	
		    function flattenBody(body) {
		      if (body.type === 'alternative') {
		        return body.body;
		      } else {
		        return [body];
		      }
		    }
	
		    function isEmpty(obj) {
		      return obj.type === 'empty';
		    }
	
		    function incr(amount) {
		      amount = amount || 1;
		      var res = str.substring(pos, pos + amount);
		      pos += amount || 1;
		      return res;
		    }
	
		    function skip(value) {
		      if (!match(value)) {
		        bail('character', value);
		      }
		    }
	
		    function match(value) {
		      if (str.indexOf(value, pos) === pos) {
		        return incr(value.length);
		      }
		    }
	
		    function lookahead() {
		      return str[pos];
		    }
	
		    function current(value) {
		      return str.indexOf(value, pos) === pos;
		    }
	
		    function next(value) {
		      return str[pos + 1] === value;
		    }
	
		    function matchReg(regExp) {
		      var subStr = str.substring(pos);
		      var res = subStr.match(regExp);
		      if (res) {
		        res.range = [];
		        res.range[0] = pos;
		        incr(res[0].length);
		        res.range[1] = pos;
		      }
		      return res;
		    }
	
		    function parseDisjunction() {
		      // Disjunction ::
		      //      Alternative
		      //      Alternative | Disjunction
		      var res = [],
		          from = pos;
		      res.push(parseAlternative());
	
		      while (match('|')) {
		        res.push(parseAlternative());
		      }
	
		      if (res.length === 1) {
		        return res[0];
		      }
	
		      return createDisjunction(res, from, pos);
		    }
	
		    function parseAlternative() {
		      var res = [],
		          from = pos;
		      var term;
	
		      // Alternative ::
		      //      [empty]
		      //      Alternative Term
		      while (term = parseTerm()) {
		        res.push(term);
		      }
	
		      if (res.length === 1) {
		        return res[0];
		      }
	
		      return createAlternative(res, from, pos);
		    }
	
		    function parseTerm() {
		      // Term ::
		      //      Anchor
		      //      Atom
		      //      Atom Quantifier
	
		      if (pos >= str.length || current('|') || current(')')) {
		        return null; /* Means: The term is empty */
		      }
	
		      var anchor = parseAnchor();
	
		      if (anchor) {
		        return anchor;
		      }
	
		      var atom = parseAtom();
		      if (!atom) {
		        bail('Expected atom');
		      }
		      var quantifier = parseQuantifier() || false;
		      if (quantifier) {
		        quantifier.body = flattenBody(atom);
		        // The quantifier contains the atom. Therefore, the beginning of the
		        // quantifier range is given by the beginning of the atom.
		        updateRawStart(quantifier, atom.range[0]);
		        return quantifier;
		      }
		      return atom;
		    }
	
		    function parseGroup(matchA, typeA, matchB, typeB) {
		      var type = null,
		          from = pos;
	
		      if (match(matchA)) {
		        type = typeA;
		      } else if (match(matchB)) {
		        type = typeB;
		      } else {
		        return false;
		      }
	
		      var body = parseDisjunction();
		      if (!body) {
		        bail('Expected disjunction');
		      }
		      skip(')');
		      var group = createGroup(type, flattenBody(body), from, pos);
	
		      if (type == 'normal') {
		        // Keep track of the number of closed groups. This is required for
		        // parseDecimalEscape(). In case the string is parsed a second time the
		        // value already holds the total count and no incrementation is required.
		        if (firstIteration) {
		          closedCaptureCounter++;
		        }
		      }
		      return group;
		    }
	
		    function parseAnchor() {
		      // Anchor ::
		      //      ^
		      //      $
		      //      \ b
		      //      \ B
		      //      ( ? = Disjunction )
		      //      ( ? ! Disjunction )
		      var res,
		          from = pos;
	
		      if (match('^')) {
		        return createAnchor('start', 1 /* rawLength */);
		      } else if (match('$')) {
		        return createAnchor('end', 1 /* rawLength */);
		      } else if (match('\\b')) {
		        return createAnchor('boundary', 2 /* rawLength */);
		      } else if (match('\\B')) {
		        return createAnchor('not-boundary', 2 /* rawLength */);
		      } else {
		        return parseGroup('(?=', 'lookahead', '(?!', 'negativeLookahead');
		      }
		    }
	
		    function parseQuantifier() {
		      // Quantifier ::
		      //      QuantifierPrefix
		      //      QuantifierPrefix ?
		      //
		      // QuantifierPrefix ::
		      //      *
		      //      +
		      //      ?
		      //      { DecimalDigits }
		      //      { DecimalDigits , }
		      //      { DecimalDigits , DecimalDigits }
	
		      var res,
		          from = pos;
		      var quantifier;
		      var min, max;
	
		      if (match('*')) {
		        quantifier = createQuantifier(0);
		      } else if (match('+')) {
		        quantifier = createQuantifier(1);
		      } else if (match('?')) {
		        quantifier = createQuantifier(0, 1);
		      } else if (res = matchReg(/^\{([0-9]+)\}/)) {
		        min = parseInt(res[1], 10);
		        quantifier = createQuantifier(min, min, res.range[0], res.range[1]);
		      } else if (res = matchReg(/^\{([0-9]+),\}/)) {
		        min = parseInt(res[1], 10);
		        quantifier = createQuantifier(min, undefined, res.range[0], res.range[1]);
		      } else if (res = matchReg(/^\{([0-9]+),([0-9]+)\}/)) {
		        min = parseInt(res[1], 10);
		        max = parseInt(res[2], 10);
		        if (min > max) {
		          bail('numbers out of order in {} quantifier', '', from, pos);
		        }
		        quantifier = createQuantifier(min, max, res.range[0], res.range[1]);
		      }
	
		      if (quantifier) {
		        if (match('?')) {
		          quantifier.greedy = false;
		          quantifier.range[1] += 1;
		        }
		      }
	
		      return quantifier;
		    }
	
		    function parseAtom() {
		      // Atom ::
		      //      PatternCharacter
		      //      .
		      //      \ AtomEscape
		      //      CharacterClass
		      //      ( Disjunction )
		      //      ( ? : Disjunction )
	
		      var res;
	
		      // jviereck: allow ']', '}' here as well to be compatible with browser's
		      //   implementations: ']'.match(/]/);
		      // if (res = matchReg(/^[^^$\\.*+?()[\]{}|]/)) {
		      if (res = matchReg(/^[^^$\\.*+?(){[|]/)) {
		        //      PatternCharacter
		        return createCharacter(res);
		      } else if (match('.')) {
		        //      .
		        return createDot();
		      } else if (match('\\')) {
		        //      \ AtomEscape
		        res = parseAtomEscape();
		        if (!res) {
		          bail('atomEscape');
		        }
		        return res;
		      } else if (res = parseCharacterClass()) {
		        return res;
		      } else {
		        //      ( Disjunction )
		        //      ( ? : Disjunction )
		        return parseGroup('(?:', 'ignore', '(', 'normal');
		      }
		    }
	
		    function parseUnicodeSurrogatePairEscape(firstEscape) {
		      if (hasUnicodeFlag) {
		        var first, second;
		        if (firstEscape.kind == 'unicodeEscape' && (first = firstEscape.codePoint) >= 0xD800 && first <= 0xDBFF && current('\\') && next('u')) {
		          var prevPos = pos;
		          pos++;
		          var secondEscape = parseClassEscape();
		          if (secondEscape.kind == 'unicodeEscape' && (second = secondEscape.codePoint) >= 0xDC00 && second <= 0xDFFF) {
		            // Unicode surrogate pair
		            firstEscape.range[1] = secondEscape.range[1];
		            firstEscape.codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
		            firstEscape.type = 'value';
		            firstEscape.kind = 'unicodeCodePointEscape';
		            addRaw(firstEscape);
		          } else {
		            pos = prevPos;
		          }
		        }
		      }
		      return firstEscape;
		    }
	
		    function parseClassEscape() {
		      return parseAtomEscape(true);
		    }
	
		    function parseAtomEscape(insideCharacterClass) {
		      // AtomEscape ::
		      //      DecimalEscape
		      //      CharacterEscape
		      //      CharacterClassEscape
	
		      var res,
		          from = pos;
	
		      res = parseDecimalEscape();
		      if (res) {
		        return res;
		      }
	
		      // For ClassEscape
		      if (insideCharacterClass) {
		        if (match('b')) {
		          // 15.10.2.19
		          // The production ClassEscape :: b evaluates by returning the
		          // CharSet containing the one character <BS> (Unicode value 0008).
		          return createEscaped('singleEscape', 0x0008, '\\b');
		        } else if (match('B')) {
		          bail('\\B not possible inside of CharacterClass', '', from);
		        }
		      }
	
		      res = parseCharacterEscape();
	
		      return res;
		    }
	
		    function parseDecimalEscape() {
		      // DecimalEscape ::
		      //      DecimalIntegerLiteral [lookahead ∉ DecimalDigit]
		      //      CharacterClassEscape :: one of d D s S w W
	
		      var res, match;
	
		      if (res = matchReg(/^(?!0)\d+/)) {
		        match = res[0];
		        var refIdx = parseInt(res[0], 10);
		        if (refIdx <= closedCaptureCounter) {
		          // If the number is smaller than the normal-groups found so
		          // far, then it is a reference...
		          return createReference(res[0]);
		        } else {
		          // ... otherwise it needs to be interpreted as a octal (if the
		          // number is in an octal format). If it is NOT octal format,
		          // then the slash is ignored and the number is matched later
		          // as normal characters.
	
		          // Recall the negative decision to decide if the input must be parsed
		          // a second time with the total normal-groups.
		          backrefDenied.push(refIdx);
	
		          // Reset the position again, as maybe only parts of the previous
		          // matched numbers are actual octal numbers. E.g. in '019' only
		          // the '01' should be matched.
		          incr(-res[0].length);
		          if (res = matchReg(/^[0-7]{1,3}/)) {
		            return createEscaped('octal', parseInt(res[0], 8), res[0], 1);
		          } else {
		            // If we end up here, we have a case like /\91/. Then the
		            // first slash is to be ignored and the 9 & 1 to be treated
		            // like ordinary characters. Create a character for the
		            // first number only here - other number-characters
		            // (if available) will be matched later.
		            res = createCharacter(matchReg(/^[89]/));
		            return updateRawStart(res, res.range[0] - 1);
		          }
		        }
		      }
		      // Only allow octal numbers in the following. All matched numbers start
		      // with a zero (if the do not, the previous if-branch is executed).
		      // If the number is not octal format and starts with zero (e.g. `091`)
		      // then only the zeros `0` is treated here and the `91` are ordinary
		      // characters.
		      // Example:
		      //   /\091/.exec('\091')[0].length === 3
		      else if (res = matchReg(/^[0-7]{1,3}/)) {
		          match = res[0];
		          if (/^0{1,3}$/.test(match)) {
		            // If they are all zeros, then only take the first one.
		            return createEscaped('null', 0x0000, '0', match.length + 1);
		          } else {
		            return createEscaped('octal', parseInt(match, 8), match, 1);
		          }
		        } else if (res = matchReg(/^[dDsSwW]/)) {
		          return createCharacterClassEscape(res[0]);
		        }
		      return false;
		    }
	
		    function parseCharacterEscape() {
		      // CharacterEscape ::
		      //      ControlEscape
		      //      c ControlLetter
		      //      HexEscapeSequence
		      //      UnicodeEscapeSequence
		      //      IdentityEscape
	
		      var res;
		      if (res = matchReg(/^[fnrtv]/)) {
		        // ControlEscape
		        var codePoint = 0;
		        switch (res[0]) {
		          case 't':
		            codePoint = 0x009;break;
		          case 'n':
		            codePoint = 0x00A;break;
		          case 'v':
		            codePoint = 0x00B;break;
		          case 'f':
		            codePoint = 0x00C;break;
		          case 'r':
		            codePoint = 0x00D;break;
		        }
		        return createEscaped('singleEscape', codePoint, '\\' + res[0]);
		      } else if (res = matchReg(/^c([a-zA-Z])/)) {
		        // c ControlLetter
		        return createEscaped('controlLetter', res[1].charCodeAt(0) % 32, res[1], 2);
		      } else if (res = matchReg(/^x([0-9a-fA-F]{2})/)) {
		        // HexEscapeSequence
		        return createEscaped('hexadecimalEscape', parseInt(res[1], 16), res[1], 2);
		      } else if (res = matchReg(/^u([0-9a-fA-F]{4})/)) {
		        // UnicodeEscapeSequence
		        return parseUnicodeSurrogatePairEscape(createEscaped('unicodeEscape', parseInt(res[1], 16), res[1], 2));
		      } else if (hasUnicodeFlag && (res = matchReg(/^u\{([0-9a-fA-F]+)\}/))) {
		        // RegExpUnicodeEscapeSequence (ES6 Unicode code point escape)
		        return createEscaped('unicodeCodePointEscape', parseInt(res[1], 16), res[1], 4);
		      } else {
		        // IdentityEscape
		        return parseIdentityEscape();
		      }
		    }
	
		    // Taken from the Esprima parser.
		    function isIdentifierPart(ch) {
		      // Generated by `tools/generate-identifier-regex.js`.
		      var NonAsciiIdentifierPart = new RegExp('[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B2\u08E4-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58\u0C59\u0C60-\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D60-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFC-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA69D\uA69F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C4\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2D\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]');
	
		      return ch === 36 || ch === 95 || // $ (dollar) and _ (underscore)
		      ch >= 65 && ch <= 90 || // A..Z
		      ch >= 97 && ch <= 122 || // a..z
		      ch >= 48 && ch <= 57 || // 0..9
		      ch === 92 || // \ (backslash)
		      ch >= 0x80 && NonAsciiIdentifierPart.test(String.fromCharCode(ch));
		    }
	
		    function parseIdentityEscape() {
		      // IdentityEscape ::
		      //      SourceCharacter but not IdentifierPart
		      //      <ZWJ>
		      //      <ZWNJ>
	
		      var ZWJ = '\u200C';
		      var ZWNJ = '\u200D';
	
		      var tmp;
	
		      if (!isIdentifierPart(lookahead())) {
		        tmp = incr();
		        return createEscaped('identifier', tmp.charCodeAt(0), tmp, 1);
		      }
	
		      if (match(ZWJ)) {
		        // <ZWJ>
		        return createEscaped('identifier', 0x200C, ZWJ);
		      } else if (match(ZWNJ)) {
		        // <ZWNJ>
		        return createEscaped('identifier', 0x200D, ZWNJ);
		      }
	
		      return null;
		    }
	
		    function parseCharacterClass() {
		      // CharacterClass ::
		      //      [ [lookahead ∉ {^}] ClassRanges ]
		      //      [ ^ ClassRanges ]
	
		      var res,
		          from = pos;
		      if (res = matchReg(/^\[\^/)) {
		        res = parseClassRanges();
		        skip(']');
		        return createCharacterClass(res, true, from, pos);
		      } else if (match('[')) {
		        res = parseClassRanges();
		        skip(']');
		        return createCharacterClass(res, false, from, pos);
		      }
	
		      return null;
		    }
	
		    function parseClassRanges() {
		      // ClassRanges ::
		      //      [empty]
		      //      NonemptyClassRanges
	
		      var res;
		      if (current(']')) {
		        // Empty array means nothing insinde of the ClassRange.
		        return [];
		      } else {
		        res = parseNonemptyClassRanges();
		        if (!res) {
		          bail('nonEmptyClassRanges');
		        }
		        return res;
		      }
		    }
	
		    function parseHelperClassRanges(atom) {
		      var from, to, res;
		      if (current('-') && !next(']')) {
		        // ClassAtom - ClassAtom ClassRanges
		        skip('-');
	
		        res = parseClassAtom();
		        if (!res) {
		          bail('classAtom');
		        }
		        to = pos;
		        var classRanges = parseClassRanges();
		        if (!classRanges) {
		          bail('classRanges');
		        }
		        from = atom.range[0];
		        if (classRanges.type === 'empty') {
		          return [createClassRange(atom, res, from, to)];
		        }
		        return [createClassRange(atom, res, from, to)].concat(classRanges);
		      }
	
		      res = parseNonemptyClassRangesNoDash();
		      if (!res) {
		        bail('nonEmptyClassRangesNoDash');
		      }
	
		      return [atom].concat(res);
		    }
	
		    function parseNonemptyClassRanges() {
		      // NonemptyClassRanges ::
		      //      ClassAtom
		      //      ClassAtom NonemptyClassRangesNoDash
		      //      ClassAtom - ClassAtom ClassRanges
	
		      var atom = parseClassAtom();
		      if (!atom) {
		        bail('classAtom');
		      }
	
		      if (current(']')) {
		        // ClassAtom
		        return [atom];
		      }
	
		      // ClassAtom NonemptyClassRangesNoDash
		      // ClassAtom - ClassAtom ClassRanges
		      return parseHelperClassRanges(atom);
		    }
	
		    function parseNonemptyClassRangesNoDash() {
		      // NonemptyClassRangesNoDash ::
		      //      ClassAtom
		      //      ClassAtomNoDash NonemptyClassRangesNoDash
		      //      ClassAtomNoDash - ClassAtom ClassRanges
	
		      var res = parseClassAtom();
		      if (!res) {
		        bail('classAtom');
		      }
		      if (current(']')) {
		        //      ClassAtom
		        return res;
		      }
	
		      // ClassAtomNoDash NonemptyClassRangesNoDash
		      // ClassAtomNoDash - ClassAtom ClassRanges
		      return parseHelperClassRanges(res);
		    }
	
		    function parseClassAtom() {
		      // ClassAtom ::
		      //      -
		      //      ClassAtomNoDash
		      if (match('-')) {
		        return createCharacter('-');
		      } else {
		        return parseClassAtomNoDash();
		      }
		    }
	
		    function parseClassAtomNoDash() {
		      // ClassAtomNoDash ::
		      //      SourceCharacter but not one of \ or ] or -
		      //      \ ClassEscape
	
		      var res;
		      if (res = matchReg(/^[^\\\]-]/)) {
		        return createCharacter(res[0]);
		      } else if (match('\\')) {
		        res = parseClassEscape();
		        if (!res) {
		          bail('classEscape');
		        }
	
		        return parseUnicodeSurrogatePairEscape(res);
		      }
		    }
	
		    function bail(message, details, from, to) {
		      from = from == null ? pos : from;
		      to = to == null ? from : to;
	
		      var contextStart = Math.max(0, from - 10);
		      var contextEnd = Math.min(to + 10, str.length);
	
		      // Output a bit of context and a line pointing to where our error is.
		      //
		      // We are assuming that there are no actual newlines in the content as this is a regular expression.
		      var context = '    ' + str.substring(contextStart, contextEnd);
		      var pointer = '    ' + new Array(from - contextStart + 1).join(' ') + '^';
	
		      throw SyntaxError(message + ' at position ' + from + (details ? ': ' + details : '') + '\n' + context + '\n' + pointer);
		    }
	
		    var backrefDenied = [];
		    var closedCaptureCounter = 0;
		    var firstIteration = true;
		    var hasUnicodeFlag = (flags || "").indexOf("u") !== -1;
		    var pos = 0;
	
		    // Convert the input to a string and treat the empty string special.
		    str = String(str);
		    if (str === '') {
		      str = '(?:)';
		    }
	
		    var result = parseDisjunction();
	
		    if (result.range[1] !== str.length) {
		      bail('Could not parse entire input - got stuck', '', result.range[1]);
		    }
	
		    // The spec requires to interpret the `\2` in `/\2()()/` as backreference.
		    // As the parser collects the number of capture groups as the string is
		    // parsed it is impossible to make these decisions at the point when the
		    // `\2` is handled. In case the local decision turns out to be wrong after
		    // the parsing has finished, the input string is parsed a second time with
		    // the total number of capture groups set.
		    //
		    // SEE: https://github.com/jviereck/regjsparser/issues/70
		    for (var i = 0; i < backrefDenied.length; i++) {
		      if (backrefDenied[i] <= closedCaptureCounter) {
		        // Parse the input a second time.
		        pos = 0;
		        firstIteration = false;
		        return parseDisjunction();
		      }
		    }
	
		    return result;
		  }
	
		  var regjsparser = {
		    parse: parse
		  };
	
		  if (typeof module !== 'undefined' && module.exports) {
		    module.exports = regjsparser;
		  } else {
		    window.regjsparser = regjsparser;
		  }
		})();
	
	/***/ }),
	/* 615 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var isFinite = __webpack_require__(467);
	
		module.exports = function (str, n) {
			if (typeof str !== 'string') {
				throw new TypeError('Expected `input` to be a string');
			}
	
			if (n < 0 || !isFinite(n)) {
				throw new TypeError('Expected `count` to be a positive finite number');
			}
	
			var ret = '';
	
			do {
				if (n & 1) {
					ret += str;
				}
	
				str += str;
			} while (n >>= 1);
	
			return ret;
		};
	
	/***/ }),
	/* 616 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
	
		/**
		 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
		 */
		exports.encode = function (number) {
		  if (0 <= number && number < intToCharMap.length) {
		    return intToCharMap[number];
		  }
		  throw new TypeError("Must be between 0 and 63: " + number);
		};
	
		/**
		 * Decode a single base 64 character code digit to an integer. Returns -1 on
		 * failure.
		 */
		exports.decode = function (charCode) {
		  var bigA = 65; // 'A'
		  var bigZ = 90; // 'Z'
	
		  var littleA = 97; // 'a'
		  var littleZ = 122; // 'z'
	
		  var zero = 48; // '0'
		  var nine = 57; // '9'
	
		  var plus = 43; // '+'
		  var slash = 47; // '/'
	
		  var littleOffset = 26;
		  var numberOffset = 52;
	
		  // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
		  if (bigA <= charCode && charCode <= bigZ) {
		    return charCode - bigA;
		  }
	
		  // 26 - 51: abcdefghijklmnopqrstuvwxyz
		  if (littleA <= charCode && charCode <= littleZ) {
		    return charCode - littleA + littleOffset;
		  }
	
		  // 52 - 61: 0123456789
		  if (zero <= charCode && charCode <= nine) {
		    return charCode - zero + numberOffset;
		  }
	
		  // 62: +
		  if (charCode == plus) {
		    return 62;
		  }
	
		  // 63: /
		  if (charCode == slash) {
		    return 63;
		  }
	
		  // Invalid base64 digit.
		  return -1;
		};
	
	/***/ }),
	/* 617 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		exports.GREATEST_LOWER_BOUND = 1;
		exports.LEAST_UPPER_BOUND = 2;
	
		/**
		 * Recursive implementation of binary search.
		 *
		 * @param aLow Indices here and lower do not contain the needle.
		 * @param aHigh Indices here and higher do not contain the needle.
		 * @param aNeedle The element being searched for.
		 * @param aHaystack The non-empty array being searched.
		 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
		 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
		 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
		 *     closest element that is smaller than or greater than the one we are
		 *     searching for, respectively, if the exact element cannot be found.
		 */
		function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
		  // This function terminates when one of the following is true:
		  //
		  //   1. We find the exact element we are looking for.
		  //
		  //   2. We did not find the exact element, but we can return the index of
		  //      the next-closest element.
		  //
		  //   3. We did not find the exact element, and there is no next-closest
		  //      element than the one we are searching for, so we return -1.
		  var mid = Math.floor((aHigh - aLow) / 2) + aLow;
		  var cmp = aCompare(aNeedle, aHaystack[mid], true);
		  if (cmp === 0) {
		    // Found the element we are looking for.
		    return mid;
		  } else if (cmp > 0) {
		    // Our needle is greater than aHaystack[mid].
		    if (aHigh - mid > 1) {
		      // The element is in the upper half.
		      return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
		    }
	
		    // The exact needle element was not found in this haystack. Determine if
		    // we are in termination case (3) or (2) and return the appropriate thing.
		    if (aBias == exports.LEAST_UPPER_BOUND) {
		      return aHigh < aHaystack.length ? aHigh : -1;
		    } else {
		      return mid;
		    }
		  } else {
		    // Our needle is less than aHaystack[mid].
		    if (mid - aLow > 1) {
		      // The element is in the lower half.
		      return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
		    }
	
		    // we are in termination case (3) or (2) and return the appropriate thing.
		    if (aBias == exports.LEAST_UPPER_BOUND) {
		      return mid;
		    } else {
		      return aLow < 0 ? -1 : aLow;
		    }
		  }
		}
	
		/**
		 * This is an implementation of binary search which will always try and return
		 * the index of the closest element if there is no exact hit. This is because
		 * mappings between original and generated line/col pairs are single points,
		 * and there is an implicit region between each of them, so a miss just means
		 * that you aren't on the very start of a region.
		 *
		 * @param aNeedle The element you are looking for.
		 * @param aHaystack The array that is being searched.
		 * @param aCompare A function which takes the needle and an element in the
		 *     array and returns -1, 0, or 1 depending on whether the needle is less
		 *     than, equal to, or greater than the element, respectively.
		 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
		 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
		 *     closest element that is smaller than or greater than the one we are
		 *     searching for, respectively, if the exact element cannot be found.
		 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
		 */
		exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
		  if (aHaystack.length === 0) {
		    return -1;
		  }
	
		  var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack, aCompare, aBias || exports.GREATEST_LOWER_BOUND);
		  if (index < 0) {
		    return -1;
		  }
	
		  // We have found either the exact element, or the next-closest element than
		  // the one we are searching for. However, there may be more than one such
		  // element. Make sure we always return the smallest of these.
		  while (index - 1 >= 0) {
		    if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
		      break;
		    }
		    --index;
		  }
	
		  return index;
		};
	
	/***/ }),
	/* 618 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2014 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		var util = __webpack_require__(63);
	
		/**
		 * Determine whether mappingB is after mappingA with respect to generated
		 * position.
		 */
		function generatedPositionAfter(mappingA, mappingB) {
		  // Optimized for most common case
		  var lineA = mappingA.generatedLine;
		  var lineB = mappingB.generatedLine;
		  var columnA = mappingA.generatedColumn;
		  var columnB = mappingB.generatedColumn;
		  return lineB > lineA || lineB == lineA && columnB >= columnA || util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
		}
	
		/**
		 * A data structure to provide a sorted view of accumulated mappings in a
		 * performance conscious manner. It trades a neglibable overhead in general
		 * case for a large speedup in case of mappings being added in order.
		 */
		function MappingList() {
		  this._array = [];
		  this._sorted = true;
		  // Serves as infimum
		  this._last = { generatedLine: -1, generatedColumn: 0 };
		}
	
		/**
		 * Iterate through internal items. This method takes the same arguments that
		 * `Array.prototype.forEach` takes.
		 *
		 * NOTE: The order of the mappings is NOT guaranteed.
		 */
		MappingList.prototype.unsortedForEach = function MappingList_forEach(aCallback, aThisArg) {
		  this._array.forEach(aCallback, aThisArg);
		};
	
		/**
		 * Add the given source mapping.
		 *
		 * @param Object aMapping
		 */
		MappingList.prototype.add = function MappingList_add(aMapping) {
		  if (generatedPositionAfter(this._last, aMapping)) {
		    this._last = aMapping;
		    this._array.push(aMapping);
		  } else {
		    this._sorted = false;
		    this._array.push(aMapping);
		  }
		};
	
		/**
		 * Returns the flat, sorted array of mappings. The mappings are sorted by
		 * generated position.
		 *
		 * WARNING: This method returns internal data without copying, for
		 * performance. The return value must NOT be mutated, and should be treated as
		 * an immutable borrow. If you want to take ownership, you must make your own
		 * copy.
		 */
		MappingList.prototype.toArray = function MappingList_toArray() {
		  if (!this._sorted) {
		    this._array.sort(util.compareByGeneratedPositionsInflated);
		    this._sorted = true;
		  }
		  return this._array;
		};
	
		exports.MappingList = MappingList;
	
	/***/ }),
	/* 619 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		// It turns out that some (most?) JavaScript engines don't self-host
		// `Array.prototype.sort`. This makes sense because C++ will likely remain
		// faster than JS when doing raw CPU-intensive sorting. However, when using a
		// custom comparator function, calling back and forth between the VM's C++ and
		// JIT'd JS is rather slow *and* loses JIT type information, resulting in
		// worse generated code for the comparator function than would be optimal. In
		// fact, when sorting with a comparator, these costs outweigh the benefits of
		// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
		// a ~3500ms mean speed-up in `bench/bench.html`.
	
		/**
		 * Swap the elements indexed by `x` and `y` in the array `ary`.
		 *
		 * @param {Array} ary
		 *        The array.
		 * @param {Number} x
		 *        The index of the first item.
		 * @param {Number} y
		 *        The index of the second item.
		 */
		function swap(ary, x, y) {
		  var temp = ary[x];
		  ary[x] = ary[y];
		  ary[y] = temp;
		}
	
		/**
		 * Returns a random integer within the range `low .. high` inclusive.
		 *
		 * @param {Number} low
		 *        The lower bound on the range.
		 * @param {Number} high
		 *        The upper bound on the range.
		 */
		function randomIntInRange(low, high) {
		  return Math.round(low + Math.random() * (high - low));
		}
	
		/**
		 * The Quick Sort algorithm.
		 *
		 * @param {Array} ary
		 *        An array to sort.
		 * @param {function} comparator
		 *        Function to use to compare two items.
		 * @param {Number} p
		 *        Start index of the array
		 * @param {Number} r
		 *        End index of the array
		 */
		function doQuickSort(ary, comparator, p, r) {
		  // If our lower bound is less than our upper bound, we (1) partition the
		  // array into two pieces and (2) recurse on each half. If it is not, this is
		  // the empty array and our base case.
	
		  if (p < r) {
		    // (1) Partitioning.
		    //
		    // The partitioning chooses a pivot between `p` and `r` and moves all
		    // elements that are less than or equal to the pivot to the before it, and
		    // all the elements that are greater than it after it. The effect is that
		    // once partition is done, the pivot is in the exact place it will be when
		    // the array is put in sorted order, and it will not need to be moved
		    // again. This runs in O(n) time.
	
		    // Always choose a random pivot so that an input array which is reverse
		    // sorted does not cause O(n^2) running time.
		    var pivotIndex = randomIntInRange(p, r);
		    var i = p - 1;
	
		    swap(ary, pivotIndex, r);
		    var pivot = ary[r];
	
		    // Immediately after `j` is incremented in this loop, the following hold
		    // true:
		    //
		    //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
		    //
		    //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
		    for (var j = p; j < r; j++) {
		      if (comparator(ary[j], pivot) <= 0) {
		        i += 1;
		        swap(ary, i, j);
		      }
		    }
	
		    swap(ary, i + 1, j);
		    var q = i + 1;
	
		    // (2) Recurse on each half.
	
		    doQuickSort(ary, comparator, p, q - 1);
		    doQuickSort(ary, comparator, q + 1, r);
		  }
		}
	
		/**
		 * Sort the given array in-place with the given comparator function.
		 *
		 * @param {Array} ary
		 *        An array to sort.
		 * @param {function} comparator
		 *        Function to use to compare two items.
		 */
		exports.quickSort = function (ary, comparator) {
		  doQuickSort(ary, comparator, 0, ary.length - 1);
		};
	
	/***/ }),
	/* 620 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		var util = __webpack_require__(63);
		var binarySearch = __webpack_require__(617);
		var ArraySet = __webpack_require__(285).ArraySet;
		var base64VLQ = __webpack_require__(286);
		var quickSort = __webpack_require__(619).quickSort;
	
		function SourceMapConsumer(aSourceMap) {
		  var sourceMap = aSourceMap;
		  if (typeof aSourceMap === 'string') {
		    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
		  }
	
		  return sourceMap.sections != null ? new IndexedSourceMapConsumer(sourceMap) : new BasicSourceMapConsumer(sourceMap);
		}
	
		SourceMapConsumer.fromSourceMap = function (aSourceMap) {
		  return BasicSourceMapConsumer.fromSourceMap(aSourceMap);
		};
	
		/**
		 * The version of the source mapping spec that we are consuming.
		 */
		SourceMapConsumer.prototype._version = 3;
	
		// `__generatedMappings` and `__originalMappings` are arrays that hold the
		// parsed mapping coordinates from the source map's "mappings" attribute. They
		// are lazily instantiated, accessed via the `_generatedMappings` and
		// `_originalMappings` getters respectively, and we only parse the mappings
		// and create these arrays once queried for a source location. We jump through
		// these hoops because there can be many thousands of mappings, and parsing
		// them is expensive, so we only want to do it if we must.
		//
		// Each object in the arrays is of the form:
		//
		//     {
		//       generatedLine: The line number in the generated code,
		//       generatedColumn: The column number in the generated code,
		//       source: The path to the original source file that generated this
		//               chunk of code,
		//       originalLine: The line number in the original source that
		//                     corresponds to this chunk of generated code,
		//       originalColumn: The column number in the original source that
		//                       corresponds to this chunk of generated code,
		//       name: The name of the original symbol which generated this chunk of
		//             code.
		//     }
		//
		// All properties except for `generatedLine` and `generatedColumn` can be
		// `null`.
		//
		// `_generatedMappings` is ordered by the generated positions.
		//
		// `_originalMappings` is ordered by the original positions.
	
		SourceMapConsumer.prototype.__generatedMappings = null;
		Object.defineProperty(SourceMapConsumer.prototype, '_generatedMappings', {
		  get: function get() {
		    if (!this.__generatedMappings) {
		      this._parseMappings(this._mappings, this.sourceRoot);
		    }
	
		    return this.__generatedMappings;
		  }
		});
	
		SourceMapConsumer.prototype.__originalMappings = null;
		Object.defineProperty(SourceMapConsumer.prototype, '_originalMappings', {
		  get: function get() {
		    if (!this.__originalMappings) {
		      this._parseMappings(this._mappings, this.sourceRoot);
		    }
	
		    return this.__originalMappings;
		  }
		});
	
		SourceMapConsumer.prototype._charIsMappingSeparator = function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
		  var c = aStr.charAt(index);
		  return c === ";" || c === ",";
		};
	
		/**
		 * Parse the mappings in a string in to a data structure which we can easily
		 * query (the ordered arrays in the `this.__generatedMappings` and
		 * `this.__originalMappings` properties).
		 */
		SourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
		  throw new Error("Subclasses must implement _parseMappings");
		};
	
		SourceMapConsumer.GENERATED_ORDER = 1;
		SourceMapConsumer.ORIGINAL_ORDER = 2;
	
		SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
		SourceMapConsumer.LEAST_UPPER_BOUND = 2;
	
		/**
		 * Iterate over each mapping between an original source/line/column and a
		 * generated line/column in this source map.
		 *
		 * @param Function aCallback
		 *        The function that is called with each mapping.
		 * @param Object aContext
		 *        Optional. If specified, this object will be the value of `this` every
		 *        time that `aCallback` is called.
		 * @param aOrder
		 *        Either `SourceMapConsumer.GENERATED_ORDER` or
		 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
		 *        iterate over the mappings sorted by the generated file's line/column
		 *        order or the original's source/line/column order, respectively. Defaults to
		 *        `SourceMapConsumer.GENERATED_ORDER`.
		 */
		SourceMapConsumer.prototype.eachMapping = function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
		  var context = aContext || null;
		  var order = aOrder || SourceMapConsumer.GENERATED_ORDER;
	
		  var mappings;
		  switch (order) {
		    case SourceMapConsumer.GENERATED_ORDER:
		      mappings = this._generatedMappings;
		      break;
		    case SourceMapConsumer.ORIGINAL_ORDER:
		      mappings = this._originalMappings;
		      break;
		    default:
		      throw new Error("Unknown order of iteration.");
		  }
	
		  var sourceRoot = this.sourceRoot;
		  mappings.map(function (mapping) {
		    var source = mapping.source === null ? null : this._sources.at(mapping.source);
		    if (source != null && sourceRoot != null) {
		      source = util.join(sourceRoot, source);
		    }
		    return {
		      source: source,
		      generatedLine: mapping.generatedLine,
		      generatedColumn: mapping.generatedColumn,
		      originalLine: mapping.originalLine,
		      originalColumn: mapping.originalColumn,
		      name: mapping.name === null ? null : this._names.at(mapping.name)
		    };
		  }, this).forEach(aCallback, context);
		};
	
		/**
		 * Returns all generated line and column information for the original source,
		 * line, and column provided. If no column is provided, returns all mappings
		 * corresponding to a either the line we are searching for or the next
		 * closest line that has any mappings. Otherwise, returns all mappings
		 * corresponding to the given line and either the column we are searching for
		 * or the next closest column that has any offsets.
		 *
		 * The only argument is an object with the following properties:
		 *
		 *   - source: The filename of the original source.
		 *   - line: The line number in the original source.
		 *   - column: Optional. the column number in the original source.
		 *
		 * and an array of objects is returned, each with the following properties:
		 *
		 *   - line: The line number in the generated source, or null.
		 *   - column: The column number in the generated source, or null.
		 */
		SourceMapConsumer.prototype.allGeneratedPositionsFor = function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
		  var line = util.getArg(aArgs, 'line');
	
		  // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
		  // returns the index of the closest mapping less than the needle. By
		  // setting needle.originalColumn to 0, we thus find the last mapping for
		  // the given line, provided such a mapping exists.
		  var needle = {
		    source: util.getArg(aArgs, 'source'),
		    originalLine: line,
		    originalColumn: util.getArg(aArgs, 'column', 0)
		  };
	
		  if (this.sourceRoot != null) {
		    needle.source = util.relative(this.sourceRoot, needle.source);
		  }
		  if (!this._sources.has(needle.source)) {
		    return [];
		  }
		  needle.source = this._sources.indexOf(needle.source);
	
		  var mappings = [];
	
		  var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", util.compareByOriginalPositions, binarySearch.LEAST_UPPER_BOUND);
		  if (index >= 0) {
		    var mapping = this._originalMappings[index];
	
		    if (aArgs.column === undefined) {
		      var originalLine = mapping.originalLine;
	
		      // Iterate until either we run out of mappings, or we run into
		      // a mapping for a different line than the one we found. Since
		      // mappings are sorted, this is guaranteed to find all mappings for
		      // the line we found.
		      while (mapping && mapping.originalLine === originalLine) {
		        mappings.push({
		          line: util.getArg(mapping, 'generatedLine', null),
		          column: util.getArg(mapping, 'generatedColumn', null),
		          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
		        });
	
		        mapping = this._originalMappings[++index];
		      }
		    } else {
		      var originalColumn = mapping.originalColumn;
	
		      // Iterate until either we run out of mappings, or we run into
		      // a mapping for a different line than the one we were searching for.
		      // Since mappings are sorted, this is guaranteed to find all mappings for
		      // the line we are searching for.
		      while (mapping && mapping.originalLine === line && mapping.originalColumn == originalColumn) {
		        mappings.push({
		          line: util.getArg(mapping, 'generatedLine', null),
		          column: util.getArg(mapping, 'generatedColumn', null),
		          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
		        });
	
		        mapping = this._originalMappings[++index];
		      }
		    }
		  }
	
		  return mappings;
		};
	
		exports.SourceMapConsumer = SourceMapConsumer;
	
		/**
		 * A BasicSourceMapConsumer instance represents a parsed source map which we can
		 * query for information about the original file positions by giving it a file
		 * position in the generated source.
		 *
		 * The only parameter is the raw source map (either as a JSON string, or
		 * already parsed to an object). According to the spec, source maps have the
		 * following attributes:
		 *
		 *   - version: Which version of the source map spec this map is following.
		 *   - sources: An array of URLs to the original source files.
		 *   - names: An array of identifiers which can be referrenced by individual mappings.
		 *   - sourceRoot: Optional. The URL root from which all sources are relative.
		 *   - sourcesContent: Optional. An array of contents of the original source files.
		 *   - mappings: A string of base64 VLQs which contain the actual mappings.
		 *   - file: Optional. The generated file this source map is associated with.
		 *
		 * Here is an example source map, taken from the source map spec[0]:
		 *
		 *     {
		 *       version : 3,
		 *       file: "out.js",
		 *       sourceRoot : "",
		 *       sources: ["foo.js", "bar.js"],
		 *       names: ["src", "maps", "are", "fun"],
		 *       mappings: "AA,AB;;ABCDE;"
		 *     }
		 *
		 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
		 */
		function BasicSourceMapConsumer(aSourceMap) {
		  var sourceMap = aSourceMap;
		  if (typeof aSourceMap === 'string') {
		    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
		  }
	
		  var version = util.getArg(sourceMap, 'version');
		  var sources = util.getArg(sourceMap, 'sources');
		  // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
		  // requires the array) to play nice here.
		  var names = util.getArg(sourceMap, 'names', []);
		  var sourceRoot = util.getArg(sourceMap, 'sourceRoot', null);
		  var sourcesContent = util.getArg(sourceMap, 'sourcesContent', null);
		  var mappings = util.getArg(sourceMap, 'mappings');
		  var file = util.getArg(sourceMap, 'file', null);
	
		  // Once again, Sass deviates from the spec and supplies the version as a
		  // string rather than a number, so we use loose equality checking here.
		  if (version != this._version) {
		    throw new Error('Unsupported version: ' + version);
		  }
	
		  sources = sources.map(String)
		  // Some source maps produce relative source paths like "./foo.js" instead of
		  // "foo.js".  Normalize these first so that future comparisons will succeed.
		  // See bugzil.la/1090768.
		  .map(util.normalize)
		  // Always ensure that absolute sources are internally stored relative to
		  // the source root, if the source root is absolute. Not doing this would
		  // be particularly problematic when the source root is a prefix of the
		  // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
		  .map(function (source) {
		    return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source) ? util.relative(sourceRoot, source) : source;
		  });
	
		  // Pass `true` below to allow duplicate names and sources. While source maps
		  // are intended to be compressed and deduplicated, the TypeScript compiler
		  // sometimes generates source maps with duplicates in them. See Github issue
		  // #72 and bugzil.la/889492.
		  this._names = ArraySet.fromArray(names.map(String), true);
		  this._sources = ArraySet.fromArray(sources, true);
	
		  this.sourceRoot = sourceRoot;
		  this.sourcesContent = sourcesContent;
		  this._mappings = mappings;
		  this.file = file;
		}
	
		BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
		BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;
	
		/**
		 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
		 *
		 * @param SourceMapGenerator aSourceMap
		 *        The source map that will be consumed.
		 * @returns BasicSourceMapConsumer
		 */
		BasicSourceMapConsumer.fromSourceMap = function SourceMapConsumer_fromSourceMap(aSourceMap) {
		  var smc = Object.create(BasicSourceMapConsumer.prototype);
	
		  var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
		  var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
		  smc.sourceRoot = aSourceMap._sourceRoot;
		  smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(), smc.sourceRoot);
		  smc.file = aSourceMap._file;
	
		  // Because we are modifying the entries (by converting string sources and
		  // names to indices into the sources and names ArraySets), we have to make
		  // a copy of the entry or else bad things happen. Shared mutable state
		  // strikes again! See github issue #191.
	
		  var generatedMappings = aSourceMap._mappings.toArray().slice();
		  var destGeneratedMappings = smc.__generatedMappings = [];
		  var destOriginalMappings = smc.__originalMappings = [];
	
		  for (var i = 0, length = generatedMappings.length; i < length; i++) {
		    var srcMapping = generatedMappings[i];
		    var destMapping = new Mapping();
		    destMapping.generatedLine = srcMapping.generatedLine;
		    destMapping.generatedColumn = srcMapping.generatedColumn;
	
		    if (srcMapping.source) {
		      destMapping.source = sources.indexOf(srcMapping.source);
		      destMapping.originalLine = srcMapping.originalLine;
		      destMapping.originalColumn = srcMapping.originalColumn;
	
		      if (srcMapping.name) {
		        destMapping.name = names.indexOf(srcMapping.name);
		      }
	
		      destOriginalMappings.push(destMapping);
		    }
	
		    destGeneratedMappings.push(destMapping);
		  }
	
		  quickSort(smc.__originalMappings, util.compareByOriginalPositions);
	
		  return smc;
		};
	
		/**
		 * The version of the source mapping spec that we are consuming.
		 */
		BasicSourceMapConsumer.prototype._version = 3;
	
		/**
		 * The list of original sources.
		 */
		Object.defineProperty(BasicSourceMapConsumer.prototype, 'sources', {
		  get: function get() {
		    return this._sources.toArray().map(function (s) {
		      return this.sourceRoot != null ? util.join(this.sourceRoot, s) : s;
		    }, this);
		  }
		});
	
		/**
		 * Provide the JIT with a nice shape / hidden class.
		 */
		function Mapping() {
		  this.generatedLine = 0;
		  this.generatedColumn = 0;
		  this.source = null;
		  this.originalLine = null;
		  this.originalColumn = null;
		  this.name = null;
		}
	
		/**
		 * Parse the mappings in a string in to a data structure which we can easily
		 * query (the ordered arrays in the `this.__generatedMappings` and
		 * `this.__originalMappings` properties).
		 */
		BasicSourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
		  var generatedLine = 1;
		  var previousGeneratedColumn = 0;
		  var previousOriginalLine = 0;
		  var previousOriginalColumn = 0;
		  var previousSource = 0;
		  var previousName = 0;
		  var length = aStr.length;
		  var index = 0;
		  var cachedSegments = {};
		  var temp = {};
		  var originalMappings = [];
		  var generatedMappings = [];
		  var mapping, str, segment, end, value;
	
		  while (index < length) {
		    if (aStr.charAt(index) === ';') {
		      generatedLine++;
		      index++;
		      previousGeneratedColumn = 0;
		    } else if (aStr.charAt(index) === ',') {
		      index++;
		    } else {
		      mapping = new Mapping();
		      mapping.generatedLine = generatedLine;
	
		      // Because each offset is encoded relative to the previous one,
		      // many segments often have the same encoding. We can exploit this
		      // fact by caching the parsed variable length fields of each segment,
		      // allowing us to avoid a second parse if we encounter the same
		      // segment again.
		      for (end = index; end < length; end++) {
		        if (this._charIsMappingSeparator(aStr, end)) {
		          break;
		        }
		      }
		      str = aStr.slice(index, end);
	
		      segment = cachedSegments[str];
		      if (segment) {
		        index += str.length;
		      } else {
		        segment = [];
		        while (index < end) {
		          base64VLQ.decode(aStr, index, temp);
		          value = temp.value;
		          index = temp.rest;
		          segment.push(value);
		        }
	
		        if (segment.length === 2) {
		          throw new Error('Found a source, but no line and column');
		        }
	
		        if (segment.length === 3) {
		          throw new Error('Found a source and line, but no column');
		        }
	
		        cachedSegments[str] = segment;
		      }
	
		      // Generated column.
		      mapping.generatedColumn = previousGeneratedColumn + segment[0];
		      previousGeneratedColumn = mapping.generatedColumn;
	
		      if (segment.length > 1) {
		        // Original source.
		        mapping.source = previousSource + segment[1];
		        previousSource += segment[1];
	
		        // Original line.
		        mapping.originalLine = previousOriginalLine + segment[2];
		        previousOriginalLine = mapping.originalLine;
		        // Lines are stored 0-based
		        mapping.originalLine += 1;
	
		        // Original column.
		        mapping.originalColumn = previousOriginalColumn + segment[3];
		        previousOriginalColumn = mapping.originalColumn;
	
		        if (segment.length > 4) {
		          // Original name.
		          mapping.name = previousName + segment[4];
		          previousName += segment[4];
		        }
		      }
	
		      generatedMappings.push(mapping);
		      if (typeof mapping.originalLine === 'number') {
		        originalMappings.push(mapping);
		      }
		    }
		  }
	
		  quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
		  this.__generatedMappings = generatedMappings;
	
		  quickSort(originalMappings, util.compareByOriginalPositions);
		  this.__originalMappings = originalMappings;
		};
	
		/**
		 * Find the mapping that best matches the hypothetical "needle" mapping that
		 * we are searching for in the given "haystack" of mappings.
		 */
		BasicSourceMapConsumer.prototype._findMapping = function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName, aColumnName, aComparator, aBias) {
		  // To return the position we are searching for, we must first find the
		  // mapping for the given position and then return the opposite position it
		  // points to. Because the mappings are sorted, we can use binary search to
		  // find the best mapping.
	
		  if (aNeedle[aLineName] <= 0) {
		    throw new TypeError('Line must be greater than or equal to 1, got ' + aNeedle[aLineName]);
		  }
		  if (aNeedle[aColumnName] < 0) {
		    throw new TypeError('Column must be greater than or equal to 0, got ' + aNeedle[aColumnName]);
		  }
	
		  return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
		};
	
		/**
		 * Compute the last column for each generated mapping. The last column is
		 * inclusive.
		 */
		BasicSourceMapConsumer.prototype.computeColumnSpans = function SourceMapConsumer_computeColumnSpans() {
		  for (var index = 0; index < this._generatedMappings.length; ++index) {
		    var mapping = this._generatedMappings[index];
	
		    // Mappings do not contain a field for the last generated columnt. We
		    // can come up with an optimistic estimate, however, by assuming that
		    // mappings are contiguous (i.e. given two consecutive mappings, the
		    // first mapping ends where the second one starts).
		    if (index + 1 < this._generatedMappings.length) {
		      var nextMapping = this._generatedMappings[index + 1];
	
		      if (mapping.generatedLine === nextMapping.generatedLine) {
		        mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
		        continue;
		      }
		    }
	
		    // The last mapping for each line spans the entire line.
		    mapping.lastGeneratedColumn = Infinity;
		  }
		};
	
		/**
		 * Returns the original source, line, and column information for the generated
		 * source's line and column positions provided. The only argument is an object
		 * with the following properties:
		 *
		 *   - line: The line number in the generated source.
		 *   - column: The column number in the generated source.
		 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
		 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
		 *     closest element that is smaller than or greater than the one we are
		 *     searching for, respectively, if the exact element cannot be found.
		 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
		 *
		 * and an object is returned with the following properties:
		 *
		 *   - source: The original source file, or null.
		 *   - line: The line number in the original source, or null.
		 *   - column: The column number in the original source, or null.
		 *   - name: The original identifier, or null.
		 */
		BasicSourceMapConsumer.prototype.originalPositionFor = function SourceMapConsumer_originalPositionFor(aArgs) {
		  var needle = {
		    generatedLine: util.getArg(aArgs, 'line'),
		    generatedColumn: util.getArg(aArgs, 'column')
		  };
	
		  var index = this._findMapping(needle, this._generatedMappings, "generatedLine", "generatedColumn", util.compareByGeneratedPositionsDeflated, util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND));
	
		  if (index >= 0) {
		    var mapping = this._generatedMappings[index];
	
		    if (mapping.generatedLine === needle.generatedLine) {
		      var source = util.getArg(mapping, 'source', null);
		      if (source !== null) {
		        source = this._sources.at(source);
		        if (this.sourceRoot != null) {
		          source = util.join(this.sourceRoot, source);
		        }
		      }
		      var name = util.getArg(mapping, 'name', null);
		      if (name !== null) {
		        name = this._names.at(name);
		      }
		      return {
		        source: source,
		        line: util.getArg(mapping, 'originalLine', null),
		        column: util.getArg(mapping, 'originalColumn', null),
		        name: name
		      };
		    }
		  }
	
		  return {
		    source: null,
		    line: null,
		    column: null,
		    name: null
		  };
		};
	
		/**
		 * Return true if we have the source content for every source in the source
		 * map, false otherwise.
		 */
		BasicSourceMapConsumer.prototype.hasContentsOfAllSources = function BasicSourceMapConsumer_hasContentsOfAllSources() {
		  if (!this.sourcesContent) {
		    return false;
		  }
		  return this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function (sc) {
		    return sc == null;
		  });
		};
	
		/**
		 * Returns the original source content. The only argument is the url of the
		 * original source file. Returns null if no original source content is
		 * available.
		 */
		BasicSourceMapConsumer.prototype.sourceContentFor = function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
		  if (!this.sourcesContent) {
		    return null;
		  }
	
		  if (this.sourceRoot != null) {
		    aSource = util.relative(this.sourceRoot, aSource);
		  }
	
		  if (this._sources.has(aSource)) {
		    return this.sourcesContent[this._sources.indexOf(aSource)];
		  }
	
		  var url;
		  if (this.sourceRoot != null && (url = util.urlParse(this.sourceRoot))) {
		    // XXX: file:// URIs and absolute paths lead to unexpected behavior for
		    // many users. We can help them out when they expect file:// URIs to
		    // behave like it would if they were running a local HTTP server. See
		    // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
		    var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
		    if (url.scheme == "file" && this._sources.has(fileUriAbsPath)) {
		      return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)];
		    }
	
		    if ((!url.path || url.path == "/") && this._sources.has("/" + aSource)) {
		      return this.sourcesContent[this._sources.indexOf("/" + aSource)];
		    }
		  }
	
		  // This function is used recursively from
		  // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
		  // don't want to throw if we can't find the source - we just want to
		  // return null, so we provide a flag to exit gracefully.
		  if (nullOnMissing) {
		    return null;
		  } else {
		    throw new Error('"' + aSource + '" is not in the SourceMap.');
		  }
		};
	
		/**
		 * Returns the generated line and column information for the original source,
		 * line, and column positions provided. The only argument is an object with
		 * the following properties:
		 *
		 *   - source: The filename of the original source.
		 *   - line: The line number in the original source.
		 *   - column: The column number in the original source.
		 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
		 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
		 *     closest element that is smaller than or greater than the one we are
		 *     searching for, respectively, if the exact element cannot be found.
		 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
		 *
		 * and an object is returned with the following properties:
		 *
		 *   - line: The line number in the generated source, or null.
		 *   - column: The column number in the generated source, or null.
		 */
		BasicSourceMapConsumer.prototype.generatedPositionFor = function SourceMapConsumer_generatedPositionFor(aArgs) {
		  var source = util.getArg(aArgs, 'source');
		  if (this.sourceRoot != null) {
		    source = util.relative(this.sourceRoot, source);
		  }
		  if (!this._sources.has(source)) {
		    return {
		      line: null,
		      column: null,
		      lastColumn: null
		    };
		  }
		  source = this._sources.indexOf(source);
	
		  var needle = {
		    source: source,
		    originalLine: util.getArg(aArgs, 'line'),
		    originalColumn: util.getArg(aArgs, 'column')
		  };
	
		  var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", util.compareByOriginalPositions, util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND));
	
		  if (index >= 0) {
		    var mapping = this._originalMappings[index];
	
		    if (mapping.source === needle.source) {
		      return {
		        line: util.getArg(mapping, 'generatedLine', null),
		        column: util.getArg(mapping, 'generatedColumn', null),
		        lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
		      };
		    }
		  }
	
		  return {
		    line: null,
		    column: null,
		    lastColumn: null
		  };
		};
	
		exports.BasicSourceMapConsumer = BasicSourceMapConsumer;
	
		/**
		 * An IndexedSourceMapConsumer instance represents a parsed source map which
		 * we can query for information. It differs from BasicSourceMapConsumer in
		 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
		 * input.
		 *
		 * The only parameter is a raw source map (either as a JSON string, or already
		 * parsed to an object). According to the spec for indexed source maps, they
		 * have the following attributes:
		 *
		 *   - version: Which version of the source map spec this map is following.
		 *   - file: Optional. The generated file this source map is associated with.
		 *   - sections: A list of section definitions.
		 *
		 * Each value under the "sections" field has two fields:
		 *   - offset: The offset into the original specified at which this section
		 *       begins to apply, defined as an object with a "line" and "column"
		 *       field.
		 *   - map: A source map definition. This source map could also be indexed,
		 *       but doesn't have to be.
		 *
		 * Instead of the "map" field, it's also possible to have a "url" field
		 * specifying a URL to retrieve a source map from, but that's currently
		 * unsupported.
		 *
		 * Here's an example source map, taken from the source map spec[0], but
		 * modified to omit a section which uses the "url" field.
		 *
		 *  {
		 *    version : 3,
		 *    file: "app.js",
		 *    sections: [{
		 *      offset: {line:100, column:10},
		 *      map: {
		 *        version : 3,
		 *        file: "section.js",
		 *        sources: ["foo.js", "bar.js"],
		 *        names: ["src", "maps", "are", "fun"],
		 *        mappings: "AAAA,E;;ABCDE;"
		 *      }
		 *    }],
		 *  }
		 *
		 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
		 */
		function IndexedSourceMapConsumer(aSourceMap) {
		  var sourceMap = aSourceMap;
		  if (typeof aSourceMap === 'string') {
		    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
		  }
	
		  var version = util.getArg(sourceMap, 'version');
		  var sections = util.getArg(sourceMap, 'sections');
	
		  if (version != this._version) {
		    throw new Error('Unsupported version: ' + version);
		  }
	
		  this._sources = new ArraySet();
		  this._names = new ArraySet();
	
		  var lastOffset = {
		    line: -1,
		    column: 0
		  };
		  this._sections = sections.map(function (s) {
		    if (s.url) {
		      // The url field will require support for asynchronicity.
		      // See https://github.com/mozilla/source-map/issues/16
		      throw new Error('Support for url field in sections not implemented.');
		    }
		    var offset = util.getArg(s, 'offset');
		    var offsetLine = util.getArg(offset, 'line');
		    var offsetColumn = util.getArg(offset, 'column');
	
		    if (offsetLine < lastOffset.line || offsetLine === lastOffset.line && offsetColumn < lastOffset.column) {
		      throw new Error('Section offsets must be ordered and non-overlapping.');
		    }
		    lastOffset = offset;
	
		    return {
		      generatedOffset: {
		        // The offset fields are 0-based, but we use 1-based indices when
		        // encoding/decoding from VLQ.
		        generatedLine: offsetLine + 1,
		        generatedColumn: offsetColumn + 1
		      },
		      consumer: new SourceMapConsumer(util.getArg(s, 'map'))
		    };
		  });
		}
	
		IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
		IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;
	
		/**
		 * The version of the source mapping spec that we are consuming.
		 */
		IndexedSourceMapConsumer.prototype._version = 3;
	
		/**
		 * The list of original sources.
		 */
		Object.defineProperty(IndexedSourceMapConsumer.prototype, 'sources', {
		  get: function get() {
		    var sources = [];
		    for (var i = 0; i < this._sections.length; i++) {
		      for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
		        sources.push(this._sections[i].consumer.sources[j]);
		      }
		    }
		    return sources;
		  }
		});
	
		/**
		 * Returns the original source, line, and column information for the generated
		 * source's line and column positions provided. The only argument is an object
		 * with the following properties:
		 *
		 *   - line: The line number in the generated source.
		 *   - column: The column number in the generated source.
		 *
		 * and an object is returned with the following properties:
		 *
		 *   - source: The original source file, or null.
		 *   - line: The line number in the original source, or null.
		 *   - column: The column number in the original source, or null.
		 *   - name: The original identifier, or null.
		 */
		IndexedSourceMapConsumer.prototype.originalPositionFor = function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
		  var needle = {
		    generatedLine: util.getArg(aArgs, 'line'),
		    generatedColumn: util.getArg(aArgs, 'column')
		  };
	
		  // Find the section containing the generated position we're trying to map
		  // to an original position.
		  var sectionIndex = binarySearch.search(needle, this._sections, function (needle, section) {
		    var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
		    if (cmp) {
		      return cmp;
		    }
	
		    return needle.generatedColumn - section.generatedOffset.generatedColumn;
		  });
		  var section = this._sections[sectionIndex];
	
		  if (!section) {
		    return {
		      source: null,
		      line: null,
		      column: null,
		      name: null
		    };
		  }
	
		  return section.consumer.originalPositionFor({
		    line: needle.generatedLine - (section.generatedOffset.generatedLine - 1),
		    column: needle.generatedColumn - (section.generatedOffset.generatedLine === needle.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
		    bias: aArgs.bias
		  });
		};
	
		/**
		 * Return true if we have the source content for every source in the source
		 * map, false otherwise.
		 */
		IndexedSourceMapConsumer.prototype.hasContentsOfAllSources = function IndexedSourceMapConsumer_hasContentsOfAllSources() {
		  return this._sections.every(function (s) {
		    return s.consumer.hasContentsOfAllSources();
		  });
		};
	
		/**
		 * Returns the original source content. The only argument is the url of the
		 * original source file. Returns null if no original source content is
		 * available.
		 */
		IndexedSourceMapConsumer.prototype.sourceContentFor = function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
		  for (var i = 0; i < this._sections.length; i++) {
		    var section = this._sections[i];
	
		    var content = section.consumer.sourceContentFor(aSource, true);
		    if (content) {
		      return content;
		    }
		  }
		  if (nullOnMissing) {
		    return null;
		  } else {
		    throw new Error('"' + aSource + '" is not in the SourceMap.');
		  }
		};
	
		/**
		 * Returns the generated line and column information for the original source,
		 * line, and column positions provided. The only argument is an object with
		 * the following properties:
		 *
		 *   - source: The filename of the original source.
		 *   - line: The line number in the original source.
		 *   - column: The column number in the original source.
		 *
		 * and an object is returned with the following properties:
		 *
		 *   - line: The line number in the generated source, or null.
		 *   - column: The column number in the generated source, or null.
		 */
		IndexedSourceMapConsumer.prototype.generatedPositionFor = function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
		  for (var i = 0; i < this._sections.length; i++) {
		    var section = this._sections[i];
	
		    // Only consider this section if the requested source is in the list of
		    // sources of the consumer.
		    if (section.consumer.sources.indexOf(util.getArg(aArgs, 'source')) === -1) {
		      continue;
		    }
		    var generatedPosition = section.consumer.generatedPositionFor(aArgs);
		    if (generatedPosition) {
		      var ret = {
		        line: generatedPosition.line + (section.generatedOffset.generatedLine - 1),
		        column: generatedPosition.column + (section.generatedOffset.generatedLine === generatedPosition.line ? section.generatedOffset.generatedColumn - 1 : 0)
		      };
		      return ret;
		    }
		  }
	
		  return {
		    line: null,
		    column: null
		  };
		};
	
		/**
		 * Parse the mappings in a string in to a data structure which we can easily
		 * query (the ordered arrays in the `this.__generatedMappings` and
		 * `this.__originalMappings` properties).
		 */
		IndexedSourceMapConsumer.prototype._parseMappings = function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
		  this.__generatedMappings = [];
		  this.__originalMappings = [];
		  for (var i = 0; i < this._sections.length; i++) {
		    var section = this._sections[i];
		    var sectionMappings = section.consumer._generatedMappings;
		    for (var j = 0; j < sectionMappings.length; j++) {
		      var mapping = sectionMappings[j];
	
		      var source = section.consumer._sources.at(mapping.source);
		      if (section.consumer.sourceRoot !== null) {
		        source = util.join(section.consumer.sourceRoot, source);
		      }
		      this._sources.add(source);
		      source = this._sources.indexOf(source);
	
		      var name = section.consumer._names.at(mapping.name);
		      this._names.add(name);
		      name = this._names.indexOf(name);
	
		      // The mappings coming from the consumer for the section have
		      // generated positions relative to the start of the section, so we
		      // need to offset them to be relative to the start of the concatenated
		      // generated file.
		      var adjustedMapping = {
		        source: source,
		        generatedLine: mapping.generatedLine + (section.generatedOffset.generatedLine - 1),
		        generatedColumn: mapping.generatedColumn + (section.generatedOffset.generatedLine === mapping.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
		        originalLine: mapping.originalLine,
		        originalColumn: mapping.originalColumn,
		        name: name
		      };
	
		      this.__generatedMappings.push(adjustedMapping);
		      if (typeof adjustedMapping.originalLine === 'number') {
		        this.__originalMappings.push(adjustedMapping);
		      }
		    }
		  }
	
		  quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
		  quickSort(this.__originalMappings, util.compareByOriginalPositions);
		};
	
		exports.IndexedSourceMapConsumer = IndexedSourceMapConsumer;
	
	/***/ }),
	/* 621 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		/* -*- Mode: js; js-indent-level: 2; -*- */
		/*
		 * Copyright 2011 Mozilla Foundation and contributors
		 * Licensed under the New BSD license. See LICENSE or:
		 * http://opensource.org/licenses/BSD-3-Clause
		 */
	
		var SourceMapGenerator = __webpack_require__(287).SourceMapGenerator;
		var util = __webpack_require__(63);
	
		// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
		// operating systems these days (capturing the result).
		var REGEX_NEWLINE = /(\r?\n)/;
	
		// Newline character code for charCodeAt() comparisons
		var NEWLINE_CODE = 10;
	
		// Private symbol for identifying `SourceNode`s when multiple versions of
		// the source-map library are loaded. This MUST NOT CHANGE across
		// versions!
		var isSourceNode = "$$$isSourceNode$$$";
	
		/**
		 * SourceNodes provide a way to abstract over interpolating/concatenating
		 * snippets of generated JavaScript source code while maintaining the line and
		 * column information associated with the original source code.
		 *
		 * @param aLine The original line number.
		 * @param aColumn The original column number.
		 * @param aSource The original source's filename.
		 * @param aChunks Optional. An array of strings which are snippets of
		 *        generated JS, or other SourceNodes.
		 * @param aName The original identifier.
		 */
		function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
		  this.children = [];
		  this.sourceContents = {};
		  this.line = aLine == null ? null : aLine;
		  this.column = aColumn == null ? null : aColumn;
		  this.source = aSource == null ? null : aSource;
		  this.name = aName == null ? null : aName;
		  this[isSourceNode] = true;
		  if (aChunks != null) this.add(aChunks);
		}
	
		/**
		 * Creates a SourceNode from generated code and a SourceMapConsumer.
		 *
		 * @param aGeneratedCode The generated code
		 * @param aSourceMapConsumer The SourceMap for the generated code
		 * @param aRelativePath Optional. The path that relative sources in the
		 *        SourceMapConsumer should be relative to.
		 */
		SourceNode.fromStringWithSourceMap = function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
		  // The SourceNode we want to fill with the generated code
		  // and the SourceMap
		  var node = new SourceNode();
	
		  // All even indices of this array are one line of the generated code,
		  // while all odd indices are the newlines between two adjacent lines
		  // (since `REGEX_NEWLINE` captures its match).
		  // Processed fragments are removed from this array, by calling `shiftNextLine`.
		  var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
		  var shiftNextLine = function shiftNextLine() {
		    var lineContents = remainingLines.shift();
		    // The last line of a file might not have a newline.
		    var newLine = remainingLines.shift() || "";
		    return lineContents + newLine;
		  };
	
		  // We need to remember the position of "remainingLines"
		  var lastGeneratedLine = 1,
		      lastGeneratedColumn = 0;
	
		  // The generate SourceNodes we need a code range.
		  // To extract it current and last mapping is used.
		  // Here we store the last mapping.
		  var lastMapping = null;
	
		  aSourceMapConsumer.eachMapping(function (mapping) {
		    if (lastMapping !== null) {
		      // We add the code from "lastMapping" to "mapping":
		      // First check if there is a new line in between.
		      if (lastGeneratedLine < mapping.generatedLine) {
		        // Associate first line with "lastMapping"
		        addMappingWithCode(lastMapping, shiftNextLine());
		        lastGeneratedLine++;
		        lastGeneratedColumn = 0;
		        // The remaining code is added without mapping
		      } else {
		        // There is no new line in between.
		        // Associate the code between "lastGeneratedColumn" and
		        // "mapping.generatedColumn" with "lastMapping"
		        var nextLine = remainingLines[0];
		        var code = nextLine.substr(0, mapping.generatedColumn - lastGeneratedColumn);
		        remainingLines[0] = nextLine.substr(mapping.generatedColumn - lastGeneratedColumn);
		        lastGeneratedColumn = mapping.generatedColumn;
		        addMappingWithCode(lastMapping, code);
		        // No more remaining code, continue
		        lastMapping = mapping;
		        return;
		      }
		    }
		    // We add the generated code until the first mapping
		    // to the SourceNode without any mapping.
		    // Each line is added as separate string.
		    while (lastGeneratedLine < mapping.generatedLine) {
		      node.add(shiftNextLine());
		      lastGeneratedLine++;
		    }
		    if (lastGeneratedColumn < mapping.generatedColumn) {
		      var nextLine = remainingLines[0];
		      node.add(nextLine.substr(0, mapping.generatedColumn));
		      remainingLines[0] = nextLine.substr(mapping.generatedColumn);
		      lastGeneratedColumn = mapping.generatedColumn;
		    }
		    lastMapping = mapping;
		  }, this);
		  // We have processed all mappings.
		  if (remainingLines.length > 0) {
		    if (lastMapping) {
		      // Associate the remaining code in the current line with "lastMapping"
		      addMappingWithCode(lastMapping, shiftNextLine());
		    }
		    // and add the remaining lines without any mapping
		    node.add(remainingLines.join(""));
		  }
	
		  // Copy sourcesContent into SourceNode
		  aSourceMapConsumer.sources.forEach(function (sourceFile) {
		    var content = aSourceMapConsumer.sourceContentFor(sourceFile);
		    if (content != null) {
		      if (aRelativePath != null) {
		        sourceFile = util.join(aRelativePath, sourceFile);
		      }
		      node.setSourceContent(sourceFile, content);
		    }
		  });
	
		  return node;
	
		  function addMappingWithCode(mapping, code) {
		    if (mapping === null || mapping.source === undefined) {
		      node.add(code);
		    } else {
		      var source = aRelativePath ? util.join(aRelativePath, mapping.source) : mapping.source;
		      node.add(new SourceNode(mapping.originalLine, mapping.originalColumn, source, code, mapping.name));
		    }
		  }
		};
	
		/**
		 * Add a chunk of generated JS to this source node.
		 *
		 * @param aChunk A string snippet of generated JS code, another instance of
		 *        SourceNode, or an array where each member is one of those things.
		 */
		SourceNode.prototype.add = function SourceNode_add(aChunk) {
		  if (Array.isArray(aChunk)) {
		    aChunk.forEach(function (chunk) {
		      this.add(chunk);
		    }, this);
		  } else if (aChunk[isSourceNode] || typeof aChunk === "string") {
		    if (aChunk) {
		      this.children.push(aChunk);
		    }
		  } else {
		    throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
		  }
		  return this;
		};
	
		/**
		 * Add a chunk of generated JS to the beginning of this source node.
		 *
		 * @param aChunk A string snippet of generated JS code, another instance of
		 *        SourceNode, or an array where each member is one of those things.
		 */
		SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
		  if (Array.isArray(aChunk)) {
		    for (var i = aChunk.length - 1; i >= 0; i--) {
		      this.prepend(aChunk[i]);
		    }
		  } else if (aChunk[isSourceNode] || typeof aChunk === "string") {
		    this.children.unshift(aChunk);
		  } else {
		    throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
		  }
		  return this;
		};
	
		/**
		 * Walk over the tree of JS snippets in this node and its children. The
		 * walking function is called once for each snippet of JS and is passed that
		 * snippet and the its original associated source's line/column location.
		 *
		 * @param aFn The traversal function.
		 */
		SourceNode.prototype.walk = function SourceNode_walk(aFn) {
		  var chunk;
		  for (var i = 0, len = this.children.length; i < len; i++) {
		    chunk = this.children[i];
		    if (chunk[isSourceNode]) {
		      chunk.walk(aFn);
		    } else {
		      if (chunk !== '') {
		        aFn(chunk, { source: this.source,
		          line: this.line,
		          column: this.column,
		          name: this.name });
		      }
		    }
		  }
		};
	
		/**
		 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
		 * each of `this.children`.
		 *
		 * @param aSep The separator.
		 */
		SourceNode.prototype.join = function SourceNode_join(aSep) {
		  var newChildren;
		  var i;
		  var len = this.children.length;
		  if (len > 0) {
		    newChildren = [];
		    for (i = 0; i < len - 1; i++) {
		      newChildren.push(this.children[i]);
		      newChildren.push(aSep);
		    }
		    newChildren.push(this.children[i]);
		    this.children = newChildren;
		  }
		  return this;
		};
	
		/**
		 * Call String.prototype.replace on the very right-most source snippet. Useful
		 * for trimming whitespace from the end of a source node, etc.
		 *
		 * @param aPattern The pattern to replace.
		 * @param aReplacement The thing to replace the pattern with.
		 */
		SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
		  var lastChild = this.children[this.children.length - 1];
		  if (lastChild[isSourceNode]) {
		    lastChild.replaceRight(aPattern, aReplacement);
		  } else if (typeof lastChild === 'string') {
		    this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
		  } else {
		    this.children.push(''.replace(aPattern, aReplacement));
		  }
		  return this;
		};
	
		/**
		 * Set the source content for a source file. This will be added to the SourceMapGenerator
		 * in the sourcesContent field.
		 *
		 * @param aSourceFile The filename of the source file
		 * @param aSourceContent The content of the source file
		 */
		SourceNode.prototype.setSourceContent = function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
		  this.sourceContents[util.toSetString(aSourceFile)] = aSourceContent;
		};
	
		/**
		 * Walk over the tree of SourceNodes. The walking function is called for each
		 * source file content and is passed the filename and source content.
		 *
		 * @param aFn The traversal function.
		 */
		SourceNode.prototype.walkSourceContents = function SourceNode_walkSourceContents(aFn) {
		  for (var i = 0, len = this.children.length; i < len; i++) {
		    if (this.children[i][isSourceNode]) {
		      this.children[i].walkSourceContents(aFn);
		    }
		  }
	
		  var sources = Object.keys(this.sourceContents);
		  for (var i = 0, len = sources.length; i < len; i++) {
		    aFn(util.fromSetString(sources[i]), this.sourceContents[sources[i]]);
		  }
		};
	
		/**
		 * Return the string representation of this source node. Walks over the tree
		 * and concatenates all the various snippets together to one string.
		 */
		SourceNode.prototype.toString = function SourceNode_toString() {
		  var str = "";
		  this.walk(function (chunk) {
		    str += chunk;
		  });
		  return str;
		};
	
		/**
		 * Returns the string representation of this source node along with a source
		 * map.
		 */
		SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
		  var generated = {
		    code: "",
		    line: 1,
		    column: 0
		  };
		  var map = new SourceMapGenerator(aArgs);
		  var sourceMappingActive = false;
		  var lastOriginalSource = null;
		  var lastOriginalLine = null;
		  var lastOriginalColumn = null;
		  var lastOriginalName = null;
		  this.walk(function (chunk, original) {
		    generated.code += chunk;
		    if (original.source !== null && original.line !== null && original.column !== null) {
		      if (lastOriginalSource !== original.source || lastOriginalLine !== original.line || lastOriginalColumn !== original.column || lastOriginalName !== original.name) {
		        map.addMapping({
		          source: original.source,
		          original: {
		            line: original.line,
		            column: original.column
		          },
		          generated: {
		            line: generated.line,
		            column: generated.column
		          },
		          name: original.name
		        });
		      }
		      lastOriginalSource = original.source;
		      lastOriginalLine = original.line;
		      lastOriginalColumn = original.column;
		      lastOriginalName = original.name;
		      sourceMappingActive = true;
		    } else if (sourceMappingActive) {
		      map.addMapping({
		        generated: {
		          line: generated.line,
		          column: generated.column
		        }
		      });
		      lastOriginalSource = null;
		      sourceMappingActive = false;
		    }
		    for (var idx = 0, length = chunk.length; idx < length; idx++) {
		      if (chunk.charCodeAt(idx) === NEWLINE_CODE) {
		        generated.line++;
		        generated.column = 0;
		        // Mappings end at eol
		        if (idx + 1 === length) {
		          lastOriginalSource = null;
		          sourceMappingActive = false;
		        } else if (sourceMappingActive) {
		          map.addMapping({
		            source: original.source,
		            original: {
		              line: original.line,
		              column: original.column
		            },
		            generated: {
		              line: generated.line,
		              column: generated.column
		            },
		            name: original.name
		          });
		        }
		      } else {
		        generated.column++;
		      }
		    }
		  });
		  this.walkSourceContents(function (sourceFile, sourceContent) {
		    map.setSourceContent(sourceFile, sourceContent);
		  });
	
		  return { code: generated.code, map: map };
		};
	
		exports.SourceNode = SourceNode;
	
	/***/ }),
	/* 622 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var ansiRegex = __webpack_require__(180)();
	
		module.exports = function (str) {
			return typeof str === 'string' ? str.replace(ansiRegex, '') : str;
		};
	
	/***/ }),
	/* 623 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
		var argv = process.argv;
	
		var terminator = argv.indexOf('--');
		var hasFlag = function hasFlag(flag) {
			flag = '--' + flag;
			var pos = argv.indexOf(flag);
			return pos !== -1 && (terminator !== -1 ? pos < terminator : true);
		};
	
		module.exports = function () {
			if ('FORCE_COLOR' in process.env) {
				return true;
			}
	
			if (hasFlag('no-color') || hasFlag('no-colors') || hasFlag('color=false')) {
				return false;
			}
	
			if (hasFlag('color') || hasFlag('colors') || hasFlag('color=true') || hasFlag('color=always')) {
				return true;
			}
	
			if (process.stdout && !process.stdout.isTTY) {
				return false;
			}
	
			if (process.platform === 'win32') {
				return true;
			}
	
			if ('COLORTERM' in process.env) {
				return true;
			}
	
			if (process.env.TERM === 'dumb') {
				return false;
			}
	
			if (/^screen|^xterm|^vt100|color|ansi|cygwin|linux/i.test(process.env.TERM)) {
				return true;
			}
	
			return false;
		}();
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))
	
	/***/ }),
	/* 624 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		module.exports = function toFastproperties(o) {
			function Sub() {}
			Sub.prototype = o;
			var receiver = new Sub(); // create an instance
			function ic() {
				return _typeof(receiver.foo);
			} // perform access
			ic();
			ic();
			return o;
			eval("o" + o); // ensure no dead code elimination
		};
	
	/***/ }),
	/* 625 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		module.exports = function (str) {
			var tail = str.length;
	
			while (/[\s\uFEFF\u00A0]/.test(str[tail - 1])) {
				tail--;
			}
	
			return str.slice(0, tail);
		};
	
	/***/ }),
	/* 626 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		if (typeof Object.create === 'function') {
		  // implementation from standard node.js 'util' module
		  module.exports = function inherits(ctor, superCtor) {
		    ctor.super_ = superCtor;
		    ctor.prototype = Object.create(superCtor.prototype, {
		      constructor: {
		        value: ctor,
		        enumerable: false,
		        writable: true,
		        configurable: true
		      }
		    });
		  };
		} else {
		  // old school shim for old browsers
		  module.exports = function inherits(ctor, superCtor) {
		    ctor.super_ = superCtor;
		    var TempCtor = function TempCtor() {};
		    TempCtor.prototype = superCtor.prototype;
		    ctor.prototype = new TempCtor();
		    ctor.prototype.constructor = ctor;
		  };
		}
	
	/***/ }),
	/* 627 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		module.exports = function isBuffer(arg) {
		  return arg && (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
		};
	
	/***/ }),
	/* 628 */
	/***/ (function(module, exports, __webpack_require__) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		/**
		 * A shim that replaces Babel's require('package.json') statement.
		 * Babel requires the entire package.json file just to get the version number.
		 */
		var version = exports.version = ("6.26.0");
	
	/***/ }),
	/* 629 */
	/***/ (function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		exports.runScripts = runScripts;
		/**
		 * Copyright 2013-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of the React source tree. An additional
		 * grant of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		var scriptTypes = ['text/jsx', 'text/babel'];
	
		var headEl = void 0;
		var inlineScriptCount = 0;
	
		/**
		 * Actually transform the code.
		 */
		function transformCode(transformFn, script) {
		  var source = void 0;
		  if (script.url != null) {
		    source = script.url;
		  } else {
		    source = 'Inline Babel script';
		    inlineScriptCount++;
		    if (inlineScriptCount > 1) {
		      source += ' (' + inlineScriptCount + ')';
		    }
		  }
	
		  return transformFn(script.content, _extends({
		    filename: source
		  }, buildBabelOptions(script))).code;
		}
	
		/**
		 * Builds the Babel options for transforming the specified script, using some
		 * sensible default presets and plugins if none were explicitly provided.
		 */
		function buildBabelOptions(script) {
		  return {
		    presets: script.presets || ['react', 'es2015'],
		    plugins: script.plugins || ['transform-class-properties', 'transform-object-rest-spread', 'transform-flow-strip-types'],
		    sourceMaps: 'inline'
		  };
		}
	
		/**
		 * Appends a script element at the end of the <head> with the content of code,
		 * after transforming it.
		 */
		function run(transformFn, script) {
		  var scriptEl = document.createElement('script');
		  scriptEl.text = transformCode(transformFn, script);
		  headEl.appendChild(scriptEl);
		}
	
		/**
		 * Load script from the provided url and pass the content to the callback.
		 */
		function load(url, successCallback, errorCallback) {
		  var xhr = new XMLHttpRequest();
	
		  // async, however scripts will be executed in the order they are in the
		  // DOM to mirror normal script loading.
		  xhr.open('GET', url, true);
		  if ('overrideMimeType' in xhr) {
		    xhr.overrideMimeType('text/plain');
		  }
		  xhr.onreadystatechange = function () {
		    if (xhr.readyState === 4) {
		      if (xhr.status === 0 || xhr.status === 200) {
		        successCallback(xhr.responseText);
		      } else {
		        errorCallback();
		        throw new Error('Could not load ' + url);
		      }
		    }
		  };
		  return xhr.send(null);
		}
	
		/**
		 * Converts a comma-separated data attribute string into an array of values. If
		 * the string is empty, returns an empty array. If the string is not defined,
		 * returns null.
		 */
		function getPluginsOrPresetsFromScript(script, attributeName) {
		  var rawValue = script.getAttribute(attributeName);
		  if (rawValue === '') {
		    // Empty string means to not load ANY presets or plugins
		    return [];
		  }
		  if (!rawValue) {
		    // Any other falsy value (null, undefined) means we're not overriding this
		    // setting, and should use the default.
		    return null;
		  }
		  return rawValue.split(',').map(function (item) {
		    return item.trim();
		  });
		}
	
		/**
		 * Loop over provided script tags and get the content, via innerHTML if an
		 * inline script, or by using XHR. Transforms are applied if needed. The scripts
		 * are executed in the order they are found on the page.
		 */
		function loadScripts(transformFn, scripts) {
		  var result = [];
		  var count = scripts.length;
	
		  function check() {
		    var script, i;
	
		    for (i = 0; i < count; i++) {
		      script = result[i];
	
		      if (script.loaded && !script.executed) {
		        script.executed = true;
		        run(transformFn, script);
		      } else if (!script.loaded && !script.error && !script.async) {
		        break;
		      }
		    }
		  }
	
		  scripts.forEach(function (script, i) {
		    var scriptData = {
		      // script.async is always true for non-JavaScript script tags
		      async: script.hasAttribute('async'),
		      error: false,
		      executed: false,
		      plugins: getPluginsOrPresetsFromScript(script, 'data-plugins'),
		      presets: getPluginsOrPresetsFromScript(script, 'data-presets')
		    };
	
		    if (script.src) {
		      result[i] = _extends({}, scriptData, {
		        content: null,
		        loaded: false,
		        url: script.src
		      });
	
		      load(script.src, function (content) {
		        result[i].loaded = true;
		        result[i].content = content;
		        check();
		      }, function () {
		        result[i].error = true;
		        check();
		      });
		    } else {
		      result[i] = _extends({}, scriptData, {
		        content: script.innerHTML,
		        loaded: true,
		        url: null
		      });
		    }
		  });
	
		  check();
		}
	
		/**
		 * Run script tags with type="text/jsx".
		 * @param {Array} scriptTags specify script tags to run, run all in the <head> if not given
		 */
		function runScripts(transformFn, scripts) {
		  headEl = document.getElementsByTagName('head')[0];
		  if (!scripts) {
		    scripts = document.getElementsByTagName('script');
		  }
	
		  // Array.prototype.slice cannot be used on NodeList on IE8
		  var jsxScripts = [];
		  for (var i = 0; i < scripts.length; i++) {
		    var script = scripts.item(i);
		    // Support the old type="text/jsx;harmony=true"
		    var type = script.type.split(';')[0];
		    if (scriptTypes.indexOf(type) !== -1) {
		      jsxScripts.push(script);
		    }
		  }
	
		  if (jsxScripts.length === 0) {
		    return;
		  }
	
		  console.warn('You are using the in-browser Babel transformer. Be sure to precompile ' + 'your scripts for production - https://babeljs.io/docs/setup/');
	
		  loadScripts(transformFn, jsxScripts);
		}
	
	/***/ }),
	/* 630 */
	/***/ (function(module, exports) {
	
		module.exports = {"builtin":{"Array":false,"ArrayBuffer":false,"Boolean":false,"constructor":false,"DataView":false,"Date":false,"decodeURI":false,"decodeURIComponent":false,"encodeURI":false,"encodeURIComponent":false,"Error":false,"escape":false,"eval":false,"EvalError":false,"Float32Array":false,"Float64Array":false,"Function":false,"hasOwnProperty":false,"Infinity":false,"Int16Array":false,"Int32Array":false,"Int8Array":false,"isFinite":false,"isNaN":false,"isPrototypeOf":false,"JSON":false,"Map":false,"Math":false,"NaN":false,"Number":false,"Object":false,"parseFloat":false,"parseInt":false,"Promise":false,"propertyIsEnumerable":false,"Proxy":false,"RangeError":false,"ReferenceError":false,"Reflect":false,"RegExp":false,"Set":false,"String":false,"Symbol":false,"SyntaxError":false,"System":false,"toLocaleString":false,"toString":false,"TypeError":false,"Uint16Array":false,"Uint32Array":false,"Uint8Array":false,"Uint8ClampedArray":false,"undefined":false,"unescape":false,"URIError":false,"valueOf":false,"WeakMap":false,"WeakSet":false},"es5":{"Array":false,"Boolean":false,"constructor":false,"Date":false,"decodeURI":false,"decodeURIComponent":false,"encodeURI":false,"encodeURIComponent":false,"Error":false,"escape":false,"eval":false,"EvalError":false,"Function":false,"hasOwnProperty":false,"Infinity":false,"isFinite":false,"isNaN":false,"isPrototypeOf":false,"JSON":false,"Math":false,"NaN":false,"Number":false,"Object":false,"parseFloat":false,"parseInt":false,"propertyIsEnumerable":false,"RangeError":false,"ReferenceError":false,"RegExp":false,"String":false,"SyntaxError":false,"toLocaleString":false,"toString":false,"TypeError":false,"undefined":false,"unescape":false,"URIError":false,"valueOf":false},"es6":{"Array":false,"ArrayBuffer":false,"Boolean":false,"constructor":false,"DataView":false,"Date":false,"decodeURI":false,"decodeURIComponent":false,"encodeURI":false,"encodeURIComponent":false,"Error":false,"escape":false,"eval":false,"EvalError":false,"Float32Array":false,"Float64Array":false,"Function":false,"hasOwnProperty":false,"Infinity":false,"Int16Array":false,"Int32Array":false,"Int8Array":false,"isFinite":false,"isNaN":false,"isPrototypeOf":false,"JSON":false,"Map":false,"Math":false,"NaN":false,"Number":false,"Object":false,"parseFloat":false,"parseInt":false,"Promise":false,"propertyIsEnumerable":false,"Proxy":false,"RangeError":false,"ReferenceError":false,"Reflect":false,"RegExp":false,"Set":false,"String":false,"Symbol":false,"SyntaxError":false,"System":false,"toLocaleString":false,"toString":false,"TypeError":false,"Uint16Array":false,"Uint32Array":false,"Uint8Array":false,"Uint8ClampedArray":false,"undefined":false,"unescape":false,"URIError":false,"valueOf":false,"WeakMap":false,"WeakSet":false},"browser":{"addEventListener":false,"alert":false,"AnalyserNode":false,"Animation":false,"AnimationEffectReadOnly":false,"AnimationEffectTiming":false,"AnimationEffectTimingReadOnly":false,"AnimationEvent":false,"AnimationPlaybackEvent":false,"AnimationTimeline":false,"applicationCache":false,"ApplicationCache":false,"ApplicationCacheErrorEvent":false,"atob":false,"Attr":false,"Audio":false,"AudioBuffer":false,"AudioBufferSourceNode":false,"AudioContext":false,"AudioDestinationNode":false,"AudioListener":false,"AudioNode":false,"AudioParam":false,"AudioProcessingEvent":false,"AutocompleteErrorEvent":false,"BarProp":false,"BatteryManager":false,"BeforeUnloadEvent":false,"BiquadFilterNode":false,"Blob":false,"blur":false,"btoa":false,"Cache":false,"caches":false,"CacheStorage":false,"cancelAnimationFrame":false,"cancelIdleCallback":false,"CanvasGradient":false,"CanvasPattern":false,"CanvasRenderingContext2D":false,"CDATASection":false,"ChannelMergerNode":false,"ChannelSplitterNode":false,"CharacterData":false,"clearInterval":false,"clearTimeout":false,"clientInformation":false,"ClientRect":false,"ClientRectList":false,"ClipboardEvent":false,"close":false,"closed":false,"CloseEvent":false,"Comment":false,"CompositionEvent":false,"confirm":false,"console":false,"ConvolverNode":false,"createImageBitmap":false,"Credential":false,"CredentialsContainer":false,"crypto":false,"Crypto":false,"CryptoKey":false,"CSS":false,"CSSAnimation":false,"CSSFontFaceRule":false,"CSSImportRule":false,"CSSKeyframeRule":false,"CSSKeyframesRule":false,"CSSMediaRule":false,"CSSPageRule":false,"CSSRule":false,"CSSRuleList":false,"CSSStyleDeclaration":false,"CSSStyleRule":false,"CSSStyleSheet":false,"CSSSupportsRule":false,"CSSTransition":false,"CSSUnknownRule":false,"CSSViewportRule":false,"customElements":false,"CustomEvent":false,"DataTransfer":false,"DataTransferItem":false,"DataTransferItemList":false,"Debug":false,"defaultStatus":false,"defaultstatus":false,"DelayNode":false,"DeviceMotionEvent":false,"DeviceOrientationEvent":false,"devicePixelRatio":false,"dispatchEvent":false,"document":false,"Document":false,"DocumentFragment":false,"DocumentTimeline":false,"DocumentType":false,"DOMError":false,"DOMException":false,"DOMImplementation":false,"DOMParser":false,"DOMSettableTokenList":false,"DOMStringList":false,"DOMStringMap":false,"DOMTokenList":false,"DragEvent":false,"DynamicsCompressorNode":false,"Element":false,"ElementTimeControl":false,"ErrorEvent":false,"event":false,"Event":false,"EventSource":false,"EventTarget":false,"external":false,"FederatedCredential":false,"fetch":false,"File":false,"FileError":false,"FileList":false,"FileReader":false,"find":false,"focus":false,"FocusEvent":false,"FontFace":false,"FormData":false,"frameElement":false,"frames":false,"GainNode":false,"Gamepad":false,"GamepadButton":false,"GamepadEvent":false,"getComputedStyle":false,"getSelection":false,"HashChangeEvent":false,"Headers":false,"history":false,"History":false,"HTMLAllCollection":false,"HTMLAnchorElement":false,"HTMLAppletElement":false,"HTMLAreaElement":false,"HTMLAudioElement":false,"HTMLBaseElement":false,"HTMLBlockquoteElement":false,"HTMLBodyElement":false,"HTMLBRElement":false,"HTMLButtonElement":false,"HTMLCanvasElement":false,"HTMLCollection":false,"HTMLContentElement":false,"HTMLDataListElement":false,"HTMLDetailsElement":false,"HTMLDialogElement":false,"HTMLDirectoryElement":false,"HTMLDivElement":false,"HTMLDListElement":false,"HTMLDocument":false,"HTMLElement":false,"HTMLEmbedElement":false,"HTMLFieldSetElement":false,"HTMLFontElement":false,"HTMLFormControlsCollection":false,"HTMLFormElement":false,"HTMLFrameElement":false,"HTMLFrameSetElement":false,"HTMLHeadElement":false,"HTMLHeadingElement":false,"HTMLHRElement":false,"HTMLHtmlElement":false,"HTMLIFrameElement":false,"HTMLImageElement":false,"HTMLInputElement":false,"HTMLIsIndexElement":false,"HTMLKeygenElement":false,"HTMLLabelElement":false,"HTMLLayerElement":false,"HTMLLegendElement":false,"HTMLLIElement":false,"HTMLLinkElement":false,"HTMLMapElement":false,"HTMLMarqueeElement":false,"HTMLMediaElement":false,"HTMLMenuElement":false,"HTMLMetaElement":false,"HTMLMeterElement":false,"HTMLModElement":false,"HTMLObjectElement":false,"HTMLOListElement":false,"HTMLOptGroupElement":false,"HTMLOptionElement":false,"HTMLOptionsCollection":false,"HTMLOutputElement":false,"HTMLParagraphElement":false,"HTMLParamElement":false,"HTMLPictureElement":false,"HTMLPreElement":false,"HTMLProgressElement":false,"HTMLQuoteElement":false,"HTMLScriptElement":false,"HTMLSelectElement":false,"HTMLShadowElement":false,"HTMLSourceElement":false,"HTMLSpanElement":false,"HTMLStyleElement":false,"HTMLTableCaptionElement":false,"HTMLTableCellElement":false,"HTMLTableColElement":false,"HTMLTableElement":false,"HTMLTableRowElement":false,"HTMLTableSectionElement":false,"HTMLTemplateElement":false,"HTMLTextAreaElement":false,"HTMLTitleElement":false,"HTMLTrackElement":false,"HTMLUListElement":false,"HTMLUnknownElement":false,"HTMLVideoElement":false,"IDBCursor":false,"IDBCursorWithValue":false,"IDBDatabase":false,"IDBEnvironment":false,"IDBFactory":false,"IDBIndex":false,"IDBKeyRange":false,"IDBObjectStore":false,"IDBOpenDBRequest":false,"IDBRequest":false,"IDBTransaction":false,"IDBVersionChangeEvent":false,"Image":false,"ImageBitmap":false,"ImageData":false,"indexedDB":false,"innerHeight":false,"innerWidth":false,"InputEvent":false,"InputMethodContext":false,"IntersectionObserver":false,"IntersectionObserverEntry":false,"Intl":false,"KeyboardEvent":false,"KeyframeEffect":false,"KeyframeEffectReadOnly":false,"length":false,"localStorage":false,"location":false,"Location":false,"locationbar":false,"matchMedia":false,"MediaElementAudioSourceNode":false,"MediaEncryptedEvent":false,"MediaError":false,"MediaKeyError":false,"MediaKeyEvent":false,"MediaKeyMessageEvent":false,"MediaKeys":false,"MediaKeySession":false,"MediaKeyStatusMap":false,"MediaKeySystemAccess":false,"MediaList":false,"MediaQueryList":false,"MediaQueryListEvent":false,"MediaSource":false,"MediaRecorder":false,"MediaStream":false,"MediaStreamAudioDestinationNode":false,"MediaStreamAudioSourceNode":false,"MediaStreamEvent":false,"MediaStreamTrack":false,"menubar":false,"MessageChannel":false,"MessageEvent":false,"MessagePort":false,"MIDIAccess":false,"MIDIConnectionEvent":false,"MIDIInput":false,"MIDIInputMap":false,"MIDIMessageEvent":false,"MIDIOutput":false,"MIDIOutputMap":false,"MIDIPort":false,"MimeType":false,"MimeTypeArray":false,"MouseEvent":false,"moveBy":false,"moveTo":false,"MutationEvent":false,"MutationObserver":false,"MutationRecord":false,"name":false,"NamedNodeMap":false,"navigator":false,"Navigator":false,"Node":false,"NodeFilter":false,"NodeIterator":false,"NodeList":false,"Notification":false,"OfflineAudioCompletionEvent":false,"OfflineAudioContext":false,"offscreenBuffering":false,"onbeforeunload":true,"onblur":true,"onerror":true,"onfocus":true,"onload":true,"onresize":true,"onunload":true,"open":false,"openDatabase":false,"opener":false,"opera":false,"Option":false,"OscillatorNode":false,"outerHeight":false,"outerWidth":false,"PageTransitionEvent":false,"pageXOffset":false,"pageYOffset":false,"parent":false,"PasswordCredential":false,"Path2D":false,"performance":false,"Performance":false,"PerformanceEntry":false,"PerformanceMark":false,"PerformanceMeasure":false,"PerformanceNavigation":false,"PerformanceResourceTiming":false,"PerformanceTiming":false,"PeriodicWave":false,"Permissions":false,"PermissionStatus":false,"personalbar":false,"Plugin":false,"PluginArray":false,"PopStateEvent":false,"postMessage":false,"print":false,"ProcessingInstruction":false,"ProgressEvent":false,"PromiseRejectionEvent":false,"prompt":false,"PushManager":false,"PushSubscription":false,"RadioNodeList":false,"Range":false,"ReadableByteStream":false,"ReadableStream":false,"removeEventListener":false,"Request":false,"requestAnimationFrame":false,"requestIdleCallback":false,"resizeBy":false,"resizeTo":false,"Response":false,"RTCIceCandidate":false,"RTCSessionDescription":false,"RTCPeerConnection":false,"screen":false,"Screen":false,"screenLeft":false,"ScreenOrientation":false,"screenTop":false,"screenX":false,"screenY":false,"ScriptProcessorNode":false,"scroll":false,"scrollbars":false,"scrollBy":false,"scrollTo":false,"scrollX":false,"scrollY":false,"SecurityPolicyViolationEvent":false,"Selection":false,"self":false,"ServiceWorker":false,"ServiceWorkerContainer":false,"ServiceWorkerRegistration":false,"sessionStorage":false,"setInterval":false,"setTimeout":false,"ShadowRoot":false,"SharedKeyframeList":false,"SharedWorker":false,"showModalDialog":false,"SiteBoundCredential":false,"speechSynthesis":false,"SpeechSynthesisEvent":false,"SpeechSynthesisUtterance":false,"status":false,"statusbar":false,"stop":false,"Storage":false,"StorageEvent":false,"styleMedia":false,"StyleSheet":false,"StyleSheetList":false,"SubtleCrypto":false,"SVGAElement":false,"SVGAltGlyphDefElement":false,"SVGAltGlyphElement":false,"SVGAltGlyphItemElement":false,"SVGAngle":false,"SVGAnimateColorElement":false,"SVGAnimatedAngle":false,"SVGAnimatedBoolean":false,"SVGAnimatedEnumeration":false,"SVGAnimatedInteger":false,"SVGAnimatedLength":false,"SVGAnimatedLengthList":false,"SVGAnimatedNumber":false,"SVGAnimatedNumberList":false,"SVGAnimatedPathData":false,"SVGAnimatedPoints":false,"SVGAnimatedPreserveAspectRatio":false,"SVGAnimatedRect":false,"SVGAnimatedString":false,"SVGAnimatedTransformList":false,"SVGAnimateElement":false,"SVGAnimateMotionElement":false,"SVGAnimateTransformElement":false,"SVGAnimationElement":false,"SVGCircleElement":false,"SVGClipPathElement":false,"SVGColor":false,"SVGColorProfileElement":false,"SVGColorProfileRule":false,"SVGComponentTransferFunctionElement":false,"SVGCSSRule":false,"SVGCursorElement":false,"SVGDefsElement":false,"SVGDescElement":false,"SVGDiscardElement":false,"SVGDocument":false,"SVGElement":false,"SVGElementInstance":false,"SVGElementInstanceList":false,"SVGEllipseElement":false,"SVGEvent":false,"SVGExternalResourcesRequired":false,"SVGFEBlendElement":false,"SVGFEColorMatrixElement":false,"SVGFEComponentTransferElement":false,"SVGFECompositeElement":false,"SVGFEConvolveMatrixElement":false,"SVGFEDiffuseLightingElement":false,"SVGFEDisplacementMapElement":false,"SVGFEDistantLightElement":false,"SVGFEDropShadowElement":false,"SVGFEFloodElement":false,"SVGFEFuncAElement":false,"SVGFEFuncBElement":false,"SVGFEFuncGElement":false,"SVGFEFuncRElement":false,"SVGFEGaussianBlurElement":false,"SVGFEImageElement":false,"SVGFEMergeElement":false,"SVGFEMergeNodeElement":false,"SVGFEMorphologyElement":false,"SVGFEOffsetElement":false,"SVGFEPointLightElement":false,"SVGFESpecularLightingElement":false,"SVGFESpotLightElement":false,"SVGFETileElement":false,"SVGFETurbulenceElement":false,"SVGFilterElement":false,"SVGFilterPrimitiveStandardAttributes":false,"SVGFitToViewBox":false,"SVGFontElement":false,"SVGFontFaceElement":false,"SVGFontFaceFormatElement":false,"SVGFontFaceNameElement":false,"SVGFontFaceSrcElement":false,"SVGFontFaceUriElement":false,"SVGForeignObjectElement":false,"SVGGElement":false,"SVGGeometryElement":false,"SVGGlyphElement":false,"SVGGlyphRefElement":false,"SVGGradientElement":false,"SVGGraphicsElement":false,"SVGHKernElement":false,"SVGICCColor":false,"SVGImageElement":false,"SVGLangSpace":false,"SVGLength":false,"SVGLengthList":false,"SVGLinearGradientElement":false,"SVGLineElement":false,"SVGLocatable":false,"SVGMarkerElement":false,"SVGMaskElement":false,"SVGMatrix":false,"SVGMetadataElement":false,"SVGMissingGlyphElement":false,"SVGMPathElement":false,"SVGNumber":false,"SVGNumberList":false,"SVGPaint":false,"SVGPathElement":false,"SVGPathSeg":false,"SVGPathSegArcAbs":false,"SVGPathSegArcRel":false,"SVGPathSegClosePath":false,"SVGPathSegCurvetoCubicAbs":false,"SVGPathSegCurvetoCubicRel":false,"SVGPathSegCurvetoCubicSmoothAbs":false,"SVGPathSegCurvetoCubicSmoothRel":false,"SVGPathSegCurvetoQuadraticAbs":false,"SVGPathSegCurvetoQuadraticRel":false,"SVGPathSegCurvetoQuadraticSmoothAbs":false,"SVGPathSegCurvetoQuadraticSmoothRel":false,"SVGPathSegLinetoAbs":false,"SVGPathSegLinetoHorizontalAbs":false,"SVGPathSegLinetoHorizontalRel":false,"SVGPathSegLinetoRel":false,"SVGPathSegLinetoVerticalAbs":false,"SVGPathSegLinetoVerticalRel":false,"SVGPathSegList":false,"SVGPathSegMovetoAbs":false,"SVGPathSegMovetoRel":false,"SVGPatternElement":false,"SVGPoint":false,"SVGPointList":false,"SVGPolygonElement":false,"SVGPolylineElement":false,"SVGPreserveAspectRatio":false,"SVGRadialGradientElement":false,"SVGRect":false,"SVGRectElement":false,"SVGRenderingIntent":false,"SVGScriptElement":false,"SVGSetElement":false,"SVGStopElement":false,"SVGStringList":false,"SVGStylable":false,"SVGStyleElement":false,"SVGSVGElement":false,"SVGSwitchElement":false,"SVGSymbolElement":false,"SVGTests":false,"SVGTextContentElement":false,"SVGTextElement":false,"SVGTextPathElement":false,"SVGTextPositioningElement":false,"SVGTitleElement":false,"SVGTransform":false,"SVGTransformable":false,"SVGTransformList":false,"SVGTRefElement":false,"SVGTSpanElement":false,"SVGUnitTypes":false,"SVGURIReference":false,"SVGUseElement":false,"SVGViewElement":false,"SVGViewSpec":false,"SVGVKernElement":false,"SVGZoomAndPan":false,"SVGZoomEvent":false,"Text":false,"TextDecoder":false,"TextEncoder":false,"TextEvent":false,"TextMetrics":false,"TextTrack":false,"TextTrackCue":false,"TextTrackCueList":false,"TextTrackList":false,"TimeEvent":false,"TimeRanges":false,"toolbar":false,"top":false,"Touch":false,"TouchEvent":false,"TouchList":false,"TrackEvent":false,"TransitionEvent":false,"TreeWalker":false,"UIEvent":false,"URL":false,"URLSearchParams":false,"ValidityState":false,"VTTCue":false,"WaveShaperNode":false,"WebGLActiveInfo":false,"WebGLBuffer":false,"WebGLContextEvent":false,"WebGLFramebuffer":false,"WebGLProgram":false,"WebGLRenderbuffer":false,"WebGLRenderingContext":false,"WebGLShader":false,"WebGLShaderPrecisionFormat":false,"WebGLTexture":false,"WebGLUniformLocation":false,"WebSocket":false,"WheelEvent":false,"window":false,"Window":false,"Worker":false,"XDomainRequest":false,"XMLDocument":false,"XMLHttpRequest":false,"XMLHttpRequestEventTarget":false,"XMLHttpRequestProgressEvent":false,"XMLHttpRequestUpload":false,"XMLSerializer":false,"XPathEvaluator":false,"XPathException":false,"XPathExpression":false,"XPathNamespace":false,"XPathNSResolver":false,"XPathResult":false,"XSLTProcessor":false},"worker":{"applicationCache":false,"atob":false,"Blob":false,"BroadcastChannel":false,"btoa":false,"Cache":false,"caches":false,"clearInterval":false,"clearTimeout":false,"close":true,"console":false,"fetch":false,"FileReaderSync":false,"FormData":false,"Headers":false,"IDBCursor":false,"IDBCursorWithValue":false,"IDBDatabase":false,"IDBFactory":false,"IDBIndex":false,"IDBKeyRange":false,"IDBObjectStore":false,"IDBOpenDBRequest":false,"IDBRequest":false,"IDBTransaction":false,"IDBVersionChangeEvent":false,"ImageData":false,"importScripts":true,"indexedDB":false,"location":false,"MessageChannel":false,"MessagePort":false,"name":false,"navigator":false,"Notification":false,"onclose":true,"onconnect":true,"onerror":true,"onlanguagechange":true,"onmessage":true,"onoffline":true,"ononline":true,"onrejectionhandled":true,"onunhandledrejection":true,"performance":false,"Performance":false,"PerformanceEntry":false,"PerformanceMark":false,"PerformanceMeasure":false,"PerformanceNavigation":false,"PerformanceResourceTiming":false,"PerformanceTiming":false,"postMessage":true,"Promise":false,"Request":false,"Response":false,"self":true,"ServiceWorkerRegistration":false,"setInterval":false,"setTimeout":false,"TextDecoder":false,"TextEncoder":false,"URL":false,"URLSearchParams":false,"WebSocket":false,"Worker":false,"XMLHttpRequest":false},"node":{"__dirname":false,"__filename":false,"arguments":false,"Buffer":false,"clearImmediate":false,"clearInterval":false,"clearTimeout":false,"console":false,"exports":true,"GLOBAL":false,"global":false,"Intl":false,"module":false,"process":false,"require":false,"root":false,"setImmediate":false,"setInterval":false,"setTimeout":false},"commonjs":{"exports":true,"module":false,"require":false,"global":false},"amd":{"define":false,"require":false},"mocha":{"after":false,"afterEach":false,"before":false,"beforeEach":false,"context":false,"describe":false,"it":false,"mocha":false,"run":false,"setup":false,"specify":false,"suite":false,"suiteSetup":false,"suiteTeardown":false,"teardown":false,"test":false,"xcontext":false,"xdescribe":false,"xit":false,"xspecify":false},"jasmine":{"afterAll":false,"afterEach":false,"beforeAll":false,"beforeEach":false,"describe":false,"expect":false,"fail":false,"fdescribe":false,"fit":false,"it":false,"jasmine":false,"pending":false,"runs":false,"spyOn":false,"spyOnProperty":false,"waits":false,"waitsFor":false,"xdescribe":false,"xit":false},"jest":{"afterAll":false,"afterEach":false,"beforeAll":false,"beforeEach":false,"check":false,"describe":false,"expect":false,"gen":false,"it":false,"fdescribe":false,"fit":false,"jest":false,"pit":false,"require":false,"test":false,"xdescribe":false,"xit":false,"xtest":false},"qunit":{"asyncTest":false,"deepEqual":false,"equal":false,"expect":false,"module":false,"notDeepEqual":false,"notEqual":false,"notOk":false,"notPropEqual":false,"notStrictEqual":false,"ok":false,"propEqual":false,"QUnit":false,"raises":false,"start":false,"stop":false,"strictEqual":false,"test":false,"throws":false},"phantomjs":{"console":true,"exports":true,"phantom":true,"require":true,"WebPage":true},"couch":{"emit":false,"exports":false,"getRow":false,"log":false,"module":false,"provides":false,"require":false,"respond":false,"send":false,"start":false,"sum":false},"rhino":{"defineClass":false,"deserialize":false,"gc":false,"help":false,"importClass":false,"importPackage":false,"java":false,"load":false,"loadClass":false,"Packages":false,"print":false,"quit":false,"readFile":false,"readUrl":false,"runCommand":false,"seal":false,"serialize":false,"spawn":false,"sync":false,"toint32":false,"version":false},"nashorn":{"__DIR__":false,"__FILE__":false,"__LINE__":false,"com":false,"edu":false,"exit":false,"Java":false,"java":false,"javafx":false,"JavaImporter":false,"javax":false,"JSAdapter":false,"load":false,"loadWithNewGlobal":false,"org":false,"Packages":false,"print":false,"quit":false},"wsh":{"ActiveXObject":true,"Enumerator":true,"GetObject":true,"ScriptEngine":true,"ScriptEngineBuildVersion":true,"ScriptEngineMajorVersion":true,"ScriptEngineMinorVersion":true,"VBArray":true,"WScript":true,"WSH":true,"XDomainRequest":true},"jquery":{"$":false,"jQuery":false},"yui":{"Y":false,"YUI":false,"YUI_config":false},"shelljs":{"cat":false,"cd":false,"chmod":false,"config":false,"cp":false,"dirs":false,"echo":false,"env":false,"error":false,"exec":false,"exit":false,"find":false,"grep":false,"ls":false,"ln":false,"mkdir":false,"mv":false,"popd":false,"pushd":false,"pwd":false,"rm":false,"sed":false,"set":false,"target":false,"tempdir":false,"test":false,"touch":false,"which":false},"prototypejs":{"$":false,"$$":false,"$A":false,"$break":false,"$continue":false,"$F":false,"$H":false,"$R":false,"$w":false,"Abstract":false,"Ajax":false,"Autocompleter":false,"Builder":false,"Class":false,"Control":false,"Draggable":false,"Draggables":false,"Droppables":false,"Effect":false,"Element":false,"Enumerable":false,"Event":false,"Field":false,"Form":false,"Hash":false,"Insertion":false,"ObjectRange":false,"PeriodicalExecuter":false,"Position":false,"Prototype":false,"Scriptaculous":false,"Selector":false,"Sortable":false,"SortableObserver":false,"Sound":false,"Template":false,"Toggle":false,"Try":false},"meteor":{"$":false,"_":false,"Accounts":false,"AccountsClient":false,"AccountsServer":false,"AccountsCommon":false,"App":false,"Assets":false,"Blaze":false,"check":false,"Cordova":false,"DDP":false,"DDPServer":false,"DDPRateLimiter":false,"Deps":false,"EJSON":false,"Email":false,"HTTP":false,"Log":false,"Match":false,"Meteor":false,"Mongo":false,"MongoInternals":false,"Npm":false,"Package":false,"Plugin":false,"process":false,"Random":false,"ReactiveDict":false,"ReactiveVar":false,"Router":false,"ServiceConfiguration":false,"Session":false,"share":false,"Spacebars":false,"Template":false,"Tinytest":false,"Tracker":false,"UI":false,"Utils":false,"WebApp":false,"WebAppInternals":false},"mongo":{"_isWindows":false,"_rand":false,"BulkWriteResult":false,"cat":false,"cd":false,"connect":false,"db":false,"getHostName":false,"getMemInfo":false,"hostname":false,"ISODate":false,"listFiles":false,"load":false,"ls":false,"md5sumFile":false,"mkdir":false,"Mongo":false,"NumberInt":false,"NumberLong":false,"ObjectId":false,"PlanCache":false,"print":false,"printjson":false,"pwd":false,"quit":false,"removeFile":false,"rs":false,"sh":false,"UUID":false,"version":false,"WriteResult":false},"applescript":{"$":false,"Application":false,"Automation":false,"console":false,"delay":false,"Library":false,"ObjC":false,"ObjectSpecifier":false,"Path":false,"Progress":false,"Ref":false},"serviceworker":{"caches":false,"Cache":false,"CacheStorage":false,"Client":false,"clients":false,"Clients":false,"ExtendableEvent":false,"ExtendableMessageEvent":false,"FetchEvent":false,"importScripts":false,"registration":false,"self":false,"ServiceWorker":false,"ServiceWorkerContainer":false,"ServiceWorkerGlobalScope":false,"ServiceWorkerMessageEvent":false,"ServiceWorkerRegistration":false,"skipWaiting":false,"WindowClient":false},"atomtest":{"advanceClock":false,"fakeClearInterval":false,"fakeClearTimeout":false,"fakeSetInterval":false,"fakeSetTimeout":false,"resetTimeouts":false,"waitsForPromise":false},"embertest":{"andThen":false,"click":false,"currentPath":false,"currentRouteName":false,"currentURL":false,"fillIn":false,"find":false,"findWithAssert":false,"keyEvent":false,"pauseTest":false,"resumeTest":false,"triggerEvent":false,"visit":false},"protractor":{"$":false,"$$":false,"browser":false,"By":false,"by":false,"DartObject":false,"element":false,"protractor":false},"shared-node-browser":{"clearInterval":false,"clearTimeout":false,"console":false,"setInterval":false,"setTimeout":false},"webextensions":{"browser":false,"chrome":false,"opr":false},"greasemonkey":{"GM_addStyle":false,"GM_deleteValue":false,"GM_getResourceText":false,"GM_getResourceURL":false,"GM_getValue":false,"GM_info":false,"GM_listValues":false,"GM_log":false,"GM_openInTab":false,"GM_registerMenuCommand":false,"GM_setClipboard":false,"GM_setValue":false,"GM_xmlhttpRequest":false,"unsafeWindow":false}}
	
	/***/ }),
	/* 631 */
	/***/ (function(module, exports) {
	
		module.exports = {"75":8490,"83":383,"107":8490,"115":383,"181":924,"197":8491,"383":83,"452":453,"453":452,"455":456,"456":455,"458":459,"459":458,"497":498,"498":497,"837":8126,"914":976,"917":1013,"920":1012,"921":8126,"922":1008,"924":181,"928":982,"929":1009,"931":962,"934":981,"937":8486,"962":931,"976":914,"977":1012,"981":934,"982":928,"1008":922,"1009":929,"1012":[920,977],"1013":917,"7776":7835,"7835":7776,"8126":[837,921],"8486":937,"8490":75,"8491":197,"66560":66600,"66561":66601,"66562":66602,"66563":66603,"66564":66604,"66565":66605,"66566":66606,"66567":66607,"66568":66608,"66569":66609,"66570":66610,"66571":66611,"66572":66612,"66573":66613,"66574":66614,"66575":66615,"66576":66616,"66577":66617,"66578":66618,"66579":66619,"66580":66620,"66581":66621,"66582":66622,"66583":66623,"66584":66624,"66585":66625,"66586":66626,"66587":66627,"66588":66628,"66589":66629,"66590":66630,"66591":66631,"66592":66632,"66593":66633,"66594":66634,"66595":66635,"66596":66636,"66597":66637,"66598":66638,"66599":66639,"66600":66560,"66601":66561,"66602":66562,"66603":66563,"66604":66564,"66605":66565,"66606":66566,"66607":66567,"66608":66568,"66609":66569,"66610":66570,"66611":66571,"66612":66572,"66613":66573,"66614":66574,"66615":66575,"66616":66576,"66617":66577,"66618":66578,"66619":66579,"66620":66580,"66621":66581,"66622":66582,"66623":66583,"66624":66584,"66625":66585,"66626":66586,"66627":66587,"66628":66588,"66629":66589,"66630":66590,"66631":66591,"66632":66592,"66633":66593,"66634":66594,"66635":66595,"66636":66596,"66637":66597,"66638":66598,"66639":66599,"68736":68800,"68737":68801,"68738":68802,"68739":68803,"68740":68804,"68741":68805,"68742":68806,"68743":68807,"68744":68808,"68745":68809,"68746":68810,"68747":68811,"68748":68812,"68749":68813,"68750":68814,"68751":68815,"68752":68816,"68753":68817,"68754":68818,"68755":68819,"68756":68820,"68757":68821,"68758":68822,"68759":68823,"68760":68824,"68761":68825,"68762":68826,"68763":68827,"68764":68828,"68765":68829,"68766":68830,"68767":68831,"68768":68832,"68769":68833,"68770":68834,"68771":68835,"68772":68836,"68773":68837,"68774":68838,"68775":68839,"68776":68840,"68777":68841,"68778":68842,"68779":68843,"68780":68844,"68781":68845,"68782":68846,"68783":68847,"68784":68848,"68785":68849,"68786":68850,"68800":68736,"68801":68737,"68802":68738,"68803":68739,"68804":68740,"68805":68741,"68806":68742,"68807":68743,"68808":68744,"68809":68745,"68810":68746,"68811":68747,"68812":68748,"68813":68749,"68814":68750,"68815":68751,"68816":68752,"68817":68753,"68818":68754,"68819":68755,"68820":68756,"68821":68757,"68822":68758,"68823":68759,"68824":68760,"68825":68761,"68826":68762,"68827":68763,"68828":68764,"68829":68765,"68830":68766,"68831":68767,"68832":68768,"68833":68769,"68834":68770,"68835":68771,"68836":68772,"68837":68773,"68838":68774,"68839":68775,"68840":68776,"68841":68777,"68842":68778,"68843":68779,"68844":68780,"68845":68781,"68846":68782,"68847":68783,"68848":68784,"68849":68785,"68850":68786,"71840":71872,"71841":71873,"71842":71874,"71843":71875,"71844":71876,"71845":71877,"71846":71878,"71847":71879,"71848":71880,"71849":71881,"71850":71882,"71851":71883,"71852":71884,"71853":71885,"71854":71886,"71855":71887,"71856":71888,"71857":71889,"71858":71890,"71859":71891,"71860":71892,"71861":71893,"71862":71894,"71863":71895,"71864":71896,"71865":71897,"71866":71898,"71867":71899,"71868":71900,"71869":71901,"71870":71902,"71871":71903,"71872":71840,"71873":71841,"71874":71842,"71875":71843,"71876":71844,"71877":71845,"71878":71846,"71879":71847,"71880":71848,"71881":71849,"71882":71850,"71883":71851,"71884":71852,"71885":71853,"71886":71854,"71887":71855,"71888":71856,"71889":71857,"71890":71858,"71891":71859,"71892":71860,"71893":71861,"71894":71862,"71895":71863,"71896":71864,"71897":71865,"71898":71866,"71899":71867,"71900":71868,"71901":71869,"71902":71870,"71903":71871}
	
	/***/ })
	/******/ ])))
	});
	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(169).Buffer))

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _path2 = __webpack_require__(125);
	
	var _path3 = _interopRequireDefault(_path2);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var testing = ("production") === "test";
	
	var TraversalContext = function () {
	  function TraversalContext(scope, opts, state, parentPath) {
	    (0, _classCallCheck3.default)(this, TraversalContext);
	    this.queue = null;
	
	    this.parentPath = parentPath;
	    this.scope = scope;
	    this.state = state;
	    this.opts = opts;
	  }
	
	  TraversalContext.prototype.shouldVisit = function shouldVisit(node) {
	    var opts = this.opts;
	    if (opts.enter || opts.exit) return true;
	
	    if (opts[node.type]) return true;
	
	    var keys = t.VISITOR_KEYS[node.type];
	    if (!keys || !keys.length) return false;
	
	    for (var _iterator = keys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var key = _ref;
	
	      if (node[key]) return true;
	    }
	
	    return false;
	  };
	
	  TraversalContext.prototype.create = function create(node, obj, key, listKey) {
	    return _path3.default.get({
	      parentPath: this.parentPath,
	      parent: node,
	      container: obj,
	      key: key,
	      listKey: listKey
	    });
	  };
	
	  TraversalContext.prototype.maybeQueue = function maybeQueue(path, notPriority) {
	    if (this.trap) {
	      throw new Error("Infinite cycle detected");
	    }
	
	    if (this.queue) {
	      if (notPriority) {
	        this.queue.push(path);
	      } else {
	        this.priorityQueue.push(path);
	      }
	    }
	  };
	
	  TraversalContext.prototype.visitMultiple = function visitMultiple(container, parent, listKey) {
	    if (container.length === 0) return false;
	
	    var queue = [];
	
	    for (var key = 0; key < container.length; key++) {
	      var node = container[key];
	      if (node && this.shouldVisit(node)) {
	        queue.push(this.create(parent, container, key, listKey));
	      }
	    }
	
	    return this.visitQueue(queue);
	  };
	
	  TraversalContext.prototype.visitSingle = function visitSingle(node, key) {
	    if (this.shouldVisit(node[key])) {
	      return this.visitQueue([this.create(node, node, key)]);
	    } else {
	      return false;
	    }
	  };
	
	  TraversalContext.prototype.visitQueue = function visitQueue(queue) {
	    this.queue = queue;
	    this.priorityQueue = [];
	
	    var visited = [];
	    var stop = false;
	
	    for (var _iterator2 = queue, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var path = _ref2;
	
	      path.resync();
	
	      if (path.contexts.length === 0 || path.contexts[path.contexts.length - 1] !== this) {
	        path.pushContext(this);
	      }
	
	      if (path.key === null) continue;
	
	      if (testing && queue.length >= 10000) {
	        this.trap = true;
	      }
	
	      if (visited.indexOf(path.node) >= 0) continue;
	      visited.push(path.node);
	
	      if (path.visit()) {
	        stop = true;
	        break;
	      }
	
	      if (this.priorityQueue.length) {
	        stop = this.visitQueue(this.priorityQueue);
	        this.priorityQueue = [];
	        this.queue = queue;
	        if (stop) break;
	      }
	    }
	
	    for (var _iterator3 = queue, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
	      var _ref3;
	
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }
	
	      var _path = _ref3;
	
	      _path.popContext();
	    }
	
	    this.queue = null;
	
	    return stop;
	  };
	
	  TraversalContext.prototype.visit = function visit(node, key) {
	    var nodes = node[key];
	    if (!nodes) return false;
	
	    if (Array.isArray(nodes)) {
	      return this.visitMultiple(nodes, node, key);
	    } else {
	      return this.visitSingle(node, key);
	    }
	  };
	
	  return TraversalContext;
	}();
	
	exports.default = TraversalContext;
	module.exports = exports["default"];

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.findParent = findParent;
	exports.find = find;
	exports.getFunctionParent = getFunctionParent;
	exports.getStatementParent = getStatementParent;
	exports.getEarliestCommonAncestorFrom = getEarliestCommonAncestorFrom;
	exports.getDeepestCommonAncestorFrom = getDeepestCommonAncestorFrom;
	exports.getAncestry = getAncestry;
	exports.isAncestor = isAncestor;
	exports.isDescendant = isDescendant;
	exports.inType = inType;
	exports.inShadow = inShadow;
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	var _index = __webpack_require__(125);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function findParent(callback) {
	  var path = this;
	  while (path = path.parentPath) {
	    if (callback(path)) return path;
	  }
	  return null;
	}
	
	function find(callback) {
	  var path = this;
	  do {
	    if (callback(path)) return path;
	  } while (path = path.parentPath);
	  return null;
	}
	
	function getFunctionParent() {
	  return this.findParent(function (path) {
	    return path.isFunction() || path.isProgram();
	  });
	}
	
	function getStatementParent() {
	  var path = this;
	  do {
	    if (Array.isArray(path.container)) {
	      return path;
	    }
	  } while (path = path.parentPath);
	}
	
	function getEarliestCommonAncestorFrom(paths) {
	  return this.getDeepestCommonAncestorFrom(paths, function (deepest, i, ancestries) {
	    var earliest = void 0;
	    var keys = t.VISITOR_KEYS[deepest.type];
	
	    for (var _iterator = ancestries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var ancestry = _ref;
	
	      var path = ancestry[i + 1];
	
	      if (!earliest) {
	        earliest = path;
	        continue;
	      }
	
	      if (path.listKey && earliest.listKey === path.listKey) {
	        if (path.key < earliest.key) {
	          earliest = path;
	          continue;
	        }
	      }
	
	      var earliestKeyIndex = keys.indexOf(earliest.parentKey);
	      var currentKeyIndex = keys.indexOf(path.parentKey);
	      if (earliestKeyIndex > currentKeyIndex) {
	        earliest = path;
	      }
	    }
	
	    return earliest;
	  });
	}
	
	function getDeepestCommonAncestorFrom(paths, filter) {
	  var _this = this;
	
	  if (!paths.length) {
	    return this;
	  }
	
	  if (paths.length === 1) {
	    return paths[0];
	  }
	
	  var minDepth = Infinity;
	
	  var lastCommonIndex = void 0,
	      lastCommon = void 0;
	
	  var ancestries = paths.map(function (path) {
	    var ancestry = [];
	
	    do {
	      ancestry.unshift(path);
	    } while ((path = path.parentPath) && path !== _this);
	
	    if (ancestry.length < minDepth) {
	      minDepth = ancestry.length;
	    }
	
	    return ancestry;
	  });
	
	  var first = ancestries[0];
	
	  depthLoop: for (var i = 0; i < minDepth; i++) {
	    var shouldMatch = first[i];
	
	    for (var _iterator2 = ancestries, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var ancestry = _ref2;
	
	      if (ancestry[i] !== shouldMatch) {
	        break depthLoop;
	      }
	    }
	
	    lastCommonIndex = i;
	    lastCommon = shouldMatch;
	  }
	
	  if (lastCommon) {
	    if (filter) {
	      return filter(lastCommon, lastCommonIndex, ancestries);
	    } else {
	      return lastCommon;
	    }
	  } else {
	    throw new Error("Couldn't find intersection");
	  }
	}
	
	function getAncestry() {
	  var path = this;
	  var paths = [];
	  do {
	    paths.push(path);
	  } while (path = path.parentPath);
	  return paths;
	}
	
	function isAncestor(maybeDescendant) {
	  return maybeDescendant.isDescendant(this);
	}
	
	function isDescendant(maybeAncestor) {
	  return !!this.findParent(function (parent) {
	    return parent === maybeAncestor;
	  });
	}
	
	function inType() {
	  var path = this;
	  while (path) {
	    for (var _iterator3 = arguments, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
	      var _ref3;
	
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }
	
	      var type = _ref3;
	
	      if (path.node.type === type) return true;
	    }
	    path = path.parentPath;
	  }
	
	  return false;
	}
	
	function inShadow(key) {
	  var parentFn = this.isFunction() ? this : this.findParent(function (p) {
	    return p.isFunction();
	  });
	  if (!parentFn) return;
	
	  if (parentFn.isFunctionExpression() || parentFn.isFunctionDeclaration()) {
	    var shadow = parentFn.node.shadow;
	
	    if (shadow && (!key || shadow[key] !== false)) {
	      return parentFn;
	    }
	  } else if (parentFn.isArrowFunctionExpression()) {
	    return parentFn;
	  }
	
	  return null;
	}

/***/ }),
/* 974 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.shareCommentsWithSiblings = shareCommentsWithSiblings;
	exports.addComment = addComment;
	exports.addComments = addComments;
	function shareCommentsWithSiblings() {
	  if (typeof this.key === "string") return;
	
	  var node = this.node;
	  if (!node) return;
	
	  var trailing = node.trailingComments;
	  var leading = node.leadingComments;
	  if (!trailing && !leading) return;
	
	  var prev = this.getSibling(this.key - 1);
	  var next = this.getSibling(this.key + 1);
	
	  if (!prev.node) prev = next;
	  if (!next.node) next = prev;
	
	  prev.addComments("trailing", leading);
	  next.addComments("leading", trailing);
	}
	
	function addComment(type, content, line) {
	  this.addComments(type, [{
	    type: line ? "CommentLine" : "CommentBlock",
	    value: content
	  }]);
	}
	
	function addComments(type, comments) {
	  if (!comments) return;
	
	  var node = this.node;
	  if (!node) return;
	
	  var key = type + "Comments";
	
	  if (node[key]) {
	    node[key] = node[key].concat(comments);
	  } else {
	    node[key] = comments;
	  }
	}

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.call = call;
	exports._call = _call;
	exports.isBlacklisted = isBlacklisted;
	exports.visit = visit;
	exports.skip = skip;
	exports.skipKey = skipKey;
	exports.stop = stop;
	exports.setScope = setScope;
	exports.setContext = setContext;
	exports.resync = resync;
	exports._resyncParent = _resyncParent;
	exports._resyncKey = _resyncKey;
	exports._resyncList = _resyncList;
	exports._resyncRemoved = _resyncRemoved;
	exports.popContext = popContext;
	exports.pushContext = pushContext;
	exports.setup = setup;
	exports.setKey = setKey;
	exports.requeue = requeue;
	exports._getQueueContexts = _getQueueContexts;
	
	var _index = __webpack_require__(91);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function call(key) {
	  var opts = this.opts;
	
	  this.debug(function () {
	    return key;
	  });
	
	  if (this.node) {
	    if (this._call(opts[key])) return true;
	  }
	
	  if (this.node) {
	    return this._call(opts[this.node.type] && opts[this.node.type][key]);
	  }
	
	  return false;
	}
	
	function _call(fns) {
	  if (!fns) return false;
	
	  for (var _iterator = fns, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var fn = _ref;
	
	    if (!fn) continue;
	
	    var node = this.node;
	    if (!node) return true;
	
	    var ret = fn.call(this.state, this, this.state);
	    if (ret) throw new Error("Unexpected return value from visitor method " + fn);
	
	    if (this.node !== node) return true;
	
	    if (this.shouldStop || this.shouldSkip || this.removed) return true;
	  }
	
	  return false;
	}
	
	function isBlacklisted() {
	  var blacklist = this.opts.blacklist;
	  return blacklist && blacklist.indexOf(this.node.type) > -1;
	}
	
	function visit() {
	  if (!this.node) {
	    return false;
	  }
	
	  if (this.isBlacklisted()) {
	    return false;
	  }
	
	  if (this.opts.shouldSkip && this.opts.shouldSkip(this)) {
	    return false;
	  }
	
	  if (this.call("enter") || this.shouldSkip) {
	    this.debug(function () {
	      return "Skip...";
	    });
	    return this.shouldStop;
	  }
	
	  this.debug(function () {
	    return "Recursing into...";
	  });
	  _index2.default.node(this.node, this.opts, this.scope, this.state, this, this.skipKeys);
	
	  this.call("exit");
	
	  return this.shouldStop;
	}
	
	function skip() {
	  this.shouldSkip = true;
	}
	
	function skipKey(key) {
	  this.skipKeys[key] = true;
	}
	
	function stop() {
	  this.shouldStop = true;
	  this.shouldSkip = true;
	}
	
	function setScope() {
	  if (this.opts && this.opts.noScope) return;
	
	  var target = this.context && this.context.scope;
	
	  if (!target) {
	    var path = this.parentPath;
	    while (path && !target) {
	      if (path.opts && path.opts.noScope) return;
	
	      target = path.scope;
	      path = path.parentPath;
	    }
	  }
	
	  this.scope = this.getScope(target);
	  if (this.scope) this.scope.init();
	}
	
	function setContext(context) {
	  this.shouldSkip = false;
	  this.shouldStop = false;
	  this.removed = false;
	  this.skipKeys = {};
	
	  if (context) {
	    this.context = context;
	    this.state = context.state;
	    this.opts = context.opts;
	  }
	
	  this.setScope();
	
	  return this;
	}
	
	function resync() {
	  if (this.removed) return;
	
	  this._resyncParent();
	  this._resyncList();
	  this._resyncKey();
	}
	
	function _resyncParent() {
	  if (this.parentPath) {
	    this.parent = this.parentPath.node;
	  }
	}
	
	function _resyncKey() {
	  if (!this.container) return;
	
	  if (this.node === this.container[this.key]) return;
	
	  if (Array.isArray(this.container)) {
	    for (var i = 0; i < this.container.length; i++) {
	      if (this.container[i] === this.node) {
	        return this.setKey(i);
	      }
	    }
	  } else {
	    for (var key in this.container) {
	      if (this.container[key] === this.node) {
	        return this.setKey(key);
	      }
	    }
	  }
	
	  this.key = null;
	}
	
	function _resyncList() {
	  if (!this.parent || !this.inList) return;
	
	  var newContainer = this.parent[this.listKey];
	  if (this.container === newContainer) return;
	
	  this.container = newContainer || null;
	}
	
	function _resyncRemoved() {
	  if (this.key == null || !this.container || this.container[this.key] !== this.node) {
	    this._markRemoved();
	  }
	}
	
	function popContext() {
	  this.contexts.pop();
	  this.setContext(this.contexts[this.contexts.length - 1]);
	}
	
	function pushContext(context) {
	  this.contexts.push(context);
	  this.setContext(context);
	}
	
	function setup(parentPath, container, listKey, key) {
	  this.inList = !!listKey;
	  this.listKey = listKey;
	  this.parentKey = listKey || key;
	  this.container = container;
	
	  this.parentPath = parentPath || this.parentPath;
	  this.setKey(key);
	}
	
	function setKey(key) {
	  this.key = key;
	  this.node = this.container[this.key];
	  this.type = this.node && this.node.type;
	}
	
	function requeue() {
	  var pathToQueue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
	
	  if (pathToQueue.removed) return;
	
	  var contexts = this.contexts;
	
	  for (var _iterator2 = contexts, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	    var _ref2;
	
	    if (_isArray2) {
	      if (_i2 >= _iterator2.length) break;
	      _ref2 = _iterator2[_i2++];
	    } else {
	      _i2 = _iterator2.next();
	      if (_i2.done) break;
	      _ref2 = _i2.value;
	    }
	
	    var context = _ref2;
	
	    context.maybeQueue(pathToQueue);
	  }
	}
	
	function _getQueueContexts() {
	  var path = this;
	  var contexts = this.contexts;
	  while (!contexts.length) {
	    path = path.parentPath;
	    contexts = path.contexts;
	  }
	  return contexts;
	}

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.toComputedKey = toComputedKey;
	exports.ensureBlock = ensureBlock;
	exports.arrowFunctionToShadowed = arrowFunctionToShadowed;
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function toComputedKey() {
	  var node = this.node;
	
	  var key = void 0;
	  if (this.isMemberExpression()) {
	    key = node.property;
	  } else if (this.isProperty() || this.isMethod()) {
	    key = node.key;
	  } else {
	    throw new ReferenceError("todo");
	  }
	
	  if (!node.computed) {
	    if (t.isIdentifier(key)) key = t.stringLiteral(key.name);
	  }
	
	  return key;
	}
	
	function ensureBlock() {
	  return t.ensureBlock(this.node);
	}
	
	function arrowFunctionToShadowed() {
	  if (!this.isArrowFunctionExpression()) return;
	
	  this.ensureBlock();
	
	  var node = this.node;
	
	  node.expression = false;
	  node.type = "FunctionExpression";
	  node.shadow = node.shadow || true;
	}

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(124);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _map = __webpack_require__(548);
	
	var _map2 = _interopRequireDefault(_map);
	
	exports.evaluateTruthy = evaluateTruthy;
	exports.evaluate = evaluate;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VALID_CALLEES = ["String", "Number", "Math"];
	var INVALID_METHODS = ["random"];
	
	function evaluateTruthy() {
	  var res = this.evaluate();
	  if (res.confident) return !!res.value;
	}
	
	function evaluate() {
	  var confident = true;
	  var deoptPath = void 0;
	  var seen = new _map2.default();
	
	  function deopt(path) {
	    if (!confident) return;
	    deoptPath = path;
	    confident = false;
	  }
	
	  var value = evaluate(this);
	  if (!confident) value = undefined;
	  return {
	    confident: confident,
	    deopt: deoptPath,
	    value: value
	  };
	
	  function evaluate(path) {
	    var node = path.node;
	
	
	    if (seen.has(node)) {
	      var existing = seen.get(node);
	      if (existing.resolved) {
	        return existing.value;
	      } else {
	        deopt(path);
	        return;
	      }
	    } else {
	      var item = { resolved: false };
	      seen.set(node, item);
	
	      var val = _evaluate(path);
	      if (confident) {
	        item.resolved = true;
	        item.value = val;
	      }
	      return val;
	    }
	  }
	
	  function _evaluate(path) {
	    if (!confident) return;
	
	    var node = path.node;
	
	
	    if (path.isSequenceExpression()) {
	      var exprs = path.get("expressions");
	      return evaluate(exprs[exprs.length - 1]);
	    }
	
	    if (path.isStringLiteral() || path.isNumericLiteral() || path.isBooleanLiteral()) {
	      return node.value;
	    }
	
	    if (path.isNullLiteral()) {
	      return null;
	    }
	
	    if (path.isTemplateLiteral()) {
	      var str = "";
	
	      var i = 0;
	      var _exprs = path.get("expressions");
	
	      for (var _iterator = node.quasis, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var elem = _ref;
	
	        if (!confident) break;
	
	        str += elem.value.cooked;
	
	        var expr = _exprs[i++];
	        if (expr) str += String(evaluate(expr));
	      }
	
	      if (!confident) return;
	      return str;
	    }
	
	    if (path.isConditionalExpression()) {
	      var testResult = evaluate(path.get("test"));
	      if (!confident) return;
	      if (testResult) {
	        return evaluate(path.get("consequent"));
	      } else {
	        return evaluate(path.get("alternate"));
	      }
	    }
	
	    if (path.isExpressionWrapper()) {
	      return evaluate(path.get("expression"));
	    }
	
	    if (path.isMemberExpression() && !path.parentPath.isCallExpression({ callee: node })) {
	      var property = path.get("property");
	      var object = path.get("object");
	
	      if (object.isLiteral() && property.isIdentifier()) {
	        var _value = object.node.value;
	        var type = typeof _value === "undefined" ? "undefined" : (0, _typeof3.default)(_value);
	        if (type === "number" || type === "string") {
	          return _value[property.node.name];
	        }
	      }
	    }
	
	    if (path.isReferencedIdentifier()) {
	      var binding = path.scope.getBinding(node.name);
	
	      if (binding && binding.constantViolations.length > 0) {
	        return deopt(binding.path);
	      }
	
	      if (binding && path.node.start < binding.path.node.end) {
	        return deopt(binding.path);
	      }
	
	      if (binding && binding.hasValue) {
	        return binding.value;
	      } else {
	        if (node.name === "undefined") {
	          return binding ? deopt(binding.path) : undefined;
	        } else if (node.name === "Infinity") {
	          return binding ? deopt(binding.path) : Infinity;
	        } else if (node.name === "NaN") {
	          return binding ? deopt(binding.path) : NaN;
	        }
	
	        var resolved = path.resolve();
	        if (resolved === path) {
	          return deopt(path);
	        } else {
	          return evaluate(resolved);
	        }
	      }
	    }
	
	    if (path.isUnaryExpression({ prefix: true })) {
	      if (node.operator === "void") {
	        return undefined;
	      }
	
	      var argument = path.get("argument");
	      if (node.operator === "typeof" && (argument.isFunction() || argument.isClass())) {
	        return "function";
	      }
	
	      var arg = evaluate(argument);
	      if (!confident) return;
	      switch (node.operator) {
	        case "!":
	          return !arg;
	        case "+":
	          return +arg;
	        case "-":
	          return -arg;
	        case "~":
	          return ~arg;
	        case "typeof":
	          return typeof arg === "undefined" ? "undefined" : (0, _typeof3.default)(arg);
	      }
	    }
	
	    if (path.isArrayExpression()) {
	      var arr = [];
	      var elems = path.get("elements");
	      for (var _iterator2 = elems, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	        var _ref2;
	
	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }
	
	        var _elem = _ref2;
	
	        _elem = _elem.evaluate();
	
	        if (_elem.confident) {
	          arr.push(_elem.value);
	        } else {
	          return deopt(_elem);
	        }
	      }
	      return arr;
	    }
	
	    if (path.isObjectExpression()) {
	      var obj = {};
	      var props = path.get("properties");
	      for (var _iterator3 = props, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
	        var _ref3;
	
	        if (_isArray3) {
	          if (_i3 >= _iterator3.length) break;
	          _ref3 = _iterator3[_i3++];
	        } else {
	          _i3 = _iterator3.next();
	          if (_i3.done) break;
	          _ref3 = _i3.value;
	        }
	
	        var prop = _ref3;
	
	        if (prop.isObjectMethod() || prop.isSpreadProperty()) {
	          return deopt(prop);
	        }
	        var keyPath = prop.get("key");
	        var key = keyPath;
	        if (prop.node.computed) {
	          key = key.evaluate();
	          if (!key.confident) {
	            return deopt(keyPath);
	          }
	          key = key.value;
	        } else if (key.isIdentifier()) {
	          key = key.node.name;
	        } else {
	          key = key.node.value;
	        }
	        var valuePath = prop.get("value");
	        var _value2 = valuePath.evaluate();
	        if (!_value2.confident) {
	          return deopt(valuePath);
	        }
	        _value2 = _value2.value;
	        obj[key] = _value2;
	      }
	      return obj;
	    }
	
	    if (path.isLogicalExpression()) {
	      var wasConfident = confident;
	      var left = evaluate(path.get("left"));
	      var leftConfident = confident;
	      confident = wasConfident;
	      var right = evaluate(path.get("right"));
	      var rightConfident = confident;
	      confident = leftConfident && rightConfident;
	
	      switch (node.operator) {
	        case "||":
	          if (left && leftConfident) {
	            confident = true;
	            return left;
	          }
	
	          if (!confident) return;
	
	          return left || right;
	        case "&&":
	          if (!left && leftConfident || !right && rightConfident) {
	            confident = true;
	          }
	
	          if (!confident) return;
	
	          return left && right;
	      }
	    }
	
	    if (path.isBinaryExpression()) {
	      var _left = evaluate(path.get("left"));
	      if (!confident) return;
	      var _right = evaluate(path.get("right"));
	      if (!confident) return;
	
	      switch (node.operator) {
	        case "-":
	          return _left - _right;
	        case "+":
	          return _left + _right;
	        case "/":
	          return _left / _right;
	        case "*":
	          return _left * _right;
	        case "%":
	          return _left % _right;
	        case "**":
	          return Math.pow(_left, _right);
	        case "<":
	          return _left < _right;
	        case ">":
	          return _left > _right;
	        case "<=":
	          return _left <= _right;
	        case ">=":
	          return _left >= _right;
	        case "==":
	          return _left == _right;
	        case "!=":
	          return _left != _right;
	        case "===":
	          return _left === _right;
	        case "!==":
	          return _left !== _right;
	        case "|":
	          return _left | _right;
	        case "&":
	          return _left & _right;
	        case "^":
	          return _left ^ _right;
	        case "<<":
	          return _left << _right;
	        case ">>":
	          return _left >> _right;
	        case ">>>":
	          return _left >>> _right;
	      }
	    }
	
	    if (path.isCallExpression()) {
	      var callee = path.get("callee");
	      var context = void 0;
	      var func = void 0;
	
	      if (callee.isIdentifier() && !path.scope.getBinding(callee.node.name, true) && VALID_CALLEES.indexOf(callee.node.name) >= 0) {
	        func = global[node.callee.name];
	      }
	
	      if (callee.isMemberExpression()) {
	        var _object = callee.get("object");
	        var _property = callee.get("property");
	
	        if (_object.isIdentifier() && _property.isIdentifier() && VALID_CALLEES.indexOf(_object.node.name) >= 0 && INVALID_METHODS.indexOf(_property.node.name) < 0) {
	          context = global[_object.node.name];
	          func = context[_property.node.name];
	        }
	
	        if (_object.isLiteral() && _property.isIdentifier()) {
	          var _type = (0, _typeof3.default)(_object.node.value);
	          if (_type === "string" || _type === "number") {
	            context = _object.node.value;
	            func = context[_property.node.name];
	          }
	        }
	      }
	
	      if (func) {
	        var args = path.get("arguments").map(evaluate);
	        if (!confident) return;
	
	        return func.apply(context, args);
	      }
	    }
	
	    deopt(path);
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _create = __webpack_require__(82);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.getStatementParent = getStatementParent;
	exports.getOpposite = getOpposite;
	exports.getCompletionRecords = getCompletionRecords;
	exports.getSibling = getSibling;
	exports.getPrevSibling = getPrevSibling;
	exports.getNextSibling = getNextSibling;
	exports.getAllNextSiblings = getAllNextSiblings;
	exports.getAllPrevSiblings = getAllPrevSiblings;
	exports.get = get;
	exports._getKey = _getKey;
	exports._getPattern = _getPattern;
	exports.getBindingIdentifiers = getBindingIdentifiers;
	exports.getOuterBindingIdentifiers = getOuterBindingIdentifiers;
	exports.getBindingIdentifierPaths = getBindingIdentifierPaths;
	exports.getOuterBindingIdentifierPaths = getOuterBindingIdentifierPaths;
	
	var _index = __webpack_require__(125);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStatementParent() {
	  var path = this;
	
	  do {
	    if (!path.parentPath || Array.isArray(path.container) && path.isStatement()) {
	      break;
	    } else {
	      path = path.parentPath;
	    }
	  } while (path);
	
	  if (path && (path.isProgram() || path.isFile())) {
	    throw new Error("File/Program node, we can't possibly find a statement parent to this");
	  }
	
	  return path;
	}
	
	function getOpposite() {
	  if (this.key === "left") {
	    return this.getSibling("right");
	  } else if (this.key === "right") {
	    return this.getSibling("left");
	  }
	}
	
	function getCompletionRecords() {
	  var paths = [];
	
	  var add = function add(path) {
	    if (path) paths = paths.concat(path.getCompletionRecords());
	  };
	
	  if (this.isIfStatement()) {
	    add(this.get("consequent"));
	    add(this.get("alternate"));
	  } else if (this.isDoExpression() || this.isFor() || this.isWhile()) {
	    add(this.get("body"));
	  } else if (this.isProgram() || this.isBlockStatement()) {
	    add(this.get("body").pop());
	  } else if (this.isFunction()) {
	    return this.get("body").getCompletionRecords();
	  } else if (this.isTryStatement()) {
	    add(this.get("block"));
	    add(this.get("handler"));
	    add(this.get("finalizer"));
	  } else {
	    paths.push(this);
	  }
	
	  return paths;
	}
	
	function getSibling(key) {
	  return _index2.default.get({
	    parentPath: this.parentPath,
	    parent: this.parent,
	    container: this.container,
	    listKey: this.listKey,
	    key: key
	  });
	}
	
	function getPrevSibling() {
	  return this.getSibling(this.key - 1);
	}
	
	function getNextSibling() {
	  return this.getSibling(this.key + 1);
	}
	
	function getAllNextSiblings() {
	  var _key = this.key;
	  var sibling = this.getSibling(++_key);
	  var siblings = [];
	  while (sibling.node) {
	    siblings.push(sibling);
	    sibling = this.getSibling(++_key);
	  }
	  return siblings;
	}
	
	function getAllPrevSiblings() {
	  var _key = this.key;
	  var sibling = this.getSibling(--_key);
	  var siblings = [];
	  while (sibling.node) {
	    siblings.push(sibling);
	    sibling = this.getSibling(--_key);
	  }
	  return siblings;
	}
	
	function get(key, context) {
	  if (context === true) context = this.context;
	  var parts = key.split(".");
	  if (parts.length === 1) {
	    return this._getKey(key, context);
	  } else {
	    return this._getPattern(parts, context);
	  }
	}
	
	function _getKey(key, context) {
	  var _this = this;
	
	  var node = this.node;
	  var container = node[key];
	
	  if (Array.isArray(container)) {
	    return container.map(function (_, i) {
	      return _index2.default.get({
	        listKey: key,
	        parentPath: _this,
	        parent: node,
	        container: container,
	        key: i
	      }).setContext(context);
	    });
	  } else {
	    return _index2.default.get({
	      parentPath: this,
	      parent: node,
	      container: node,
	      key: key
	    }).setContext(context);
	  }
	}
	
	function _getPattern(parts, context) {
	  var path = this;
	  for (var _iterator = parts, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var part = _ref;
	
	    if (part === ".") {
	      path = path.parentPath;
	    } else {
	      if (Array.isArray(path)) {
	        path = path[part];
	      } else {
	        path = path.get(part, context);
	      }
	    }
	  }
	  return path;
	}
	
	function getBindingIdentifiers(duplicates) {
	  return t.getBindingIdentifiers(this.node, duplicates);
	}
	
	function getOuterBindingIdentifiers(duplicates) {
	  return t.getOuterBindingIdentifiers(this.node, duplicates);
	}
	
	function getBindingIdentifierPaths() {
	  var duplicates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	  var outerOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var path = this;
	  var search = [].concat(path);
	  var ids = (0, _create2.default)(null);
	
	  while (search.length) {
	    var id = search.shift();
	    if (!id) continue;
	    if (!id.node) continue;
	
	    var keys = t.getBindingIdentifiers.keys[id.node.type];
	
	    if (id.isIdentifier()) {
	      if (duplicates) {
	        var _ids = ids[id.node.name] = ids[id.node.name] || [];
	        _ids.push(id);
	      } else {
	        ids[id.node.name] = id;
	      }
	      continue;
	    }
	
	    if (id.isExportDeclaration()) {
	      var declaration = id.get("declaration");
	      if (declaration.isDeclaration()) {
	        search.push(declaration);
	      }
	      continue;
	    }
	
	    if (outerOnly) {
	      if (id.isFunctionDeclaration()) {
	        search.push(id.get("id"));
	        continue;
	      }
	      if (id.isFunctionExpression()) {
	        continue;
	      }
	    }
	
	    if (keys) {
	      for (var i = 0; i < keys.length; i++) {
	        var key = keys[i];
	        var child = id.get(key);
	        if (Array.isArray(child) || child.node) {
	          search = search.concat(child);
	        }
	      }
	    }
	  }
	
	  return ids;
	}
	
	function getOuterBindingIdentifierPaths(duplicates) {
	  return this.getBindingIdentifierPaths(duplicates, true);
	}

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.getTypeAnnotation = getTypeAnnotation;
	exports._getTypeAnnotation = _getTypeAnnotation;
	exports.isBaseType = isBaseType;
	exports.couldBeBaseType = couldBeBaseType;
	exports.baseTypeStrictlyMatches = baseTypeStrictlyMatches;
	exports.isGenericType = isGenericType;
	
	var _inferers = __webpack_require__(981);
	
	var inferers = _interopRequireWildcard(_inferers);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTypeAnnotation() {
	  if (this.typeAnnotation) return this.typeAnnotation;
	
	  var type = this._getTypeAnnotation() || t.anyTypeAnnotation();
	  if (t.isTypeAnnotation(type)) type = type.typeAnnotation;
	  return this.typeAnnotation = type;
	}
	
	function _getTypeAnnotation() {
	  var node = this.node;
	
	  if (!node) {
	    if (this.key === "init" && this.parentPath.isVariableDeclarator()) {
	      var declar = this.parentPath.parentPath;
	      var declarParent = declar.parentPath;
	
	      if (declar.key === "left" && declarParent.isForInStatement()) {
	        return t.stringTypeAnnotation();
	      }
	
	      if (declar.key === "left" && declarParent.isForOfStatement()) {
	        return t.anyTypeAnnotation();
	      }
	
	      return t.voidTypeAnnotation();
	    } else {
	      return;
	    }
	  }
	
	  if (node.typeAnnotation) {
	    return node.typeAnnotation;
	  }
	
	  var inferer = inferers[node.type];
	  if (inferer) {
	    return inferer.call(this, node);
	  }
	
	  inferer = inferers[this.parentPath.type];
	  if (inferer && inferer.validParent) {
	    return this.parentPath.getTypeAnnotation();
	  }
	}
	
	function isBaseType(baseName, soft) {
	  return _isBaseType(baseName, this.getTypeAnnotation(), soft);
	}
	
	function _isBaseType(baseName, type, soft) {
	  if (baseName === "string") {
	    return t.isStringTypeAnnotation(type);
	  } else if (baseName === "number") {
	    return t.isNumberTypeAnnotation(type);
	  } else if (baseName === "boolean") {
	    return t.isBooleanTypeAnnotation(type);
	  } else if (baseName === "any") {
	    return t.isAnyTypeAnnotation(type);
	  } else if (baseName === "mixed") {
	    return t.isMixedTypeAnnotation(type);
	  } else if (baseName === "empty") {
	    return t.isEmptyTypeAnnotation(type);
	  } else if (baseName === "void") {
	    return t.isVoidTypeAnnotation(type);
	  } else {
	    if (soft) {
	      return false;
	    } else {
	      throw new Error("Unknown base type " + baseName);
	    }
	  }
	}
	
	function couldBeBaseType(name) {
	  var type = this.getTypeAnnotation();
	  if (t.isAnyTypeAnnotation(type)) return true;
	
	  if (t.isUnionTypeAnnotation(type)) {
	    for (var _iterator = type.types, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var type2 = _ref;
	
	      if (t.isAnyTypeAnnotation(type2) || _isBaseType(name, type2, true)) {
	        return true;
	      }
	    }
	    return false;
	  } else {
	    return _isBaseType(name, type, true);
	  }
	}
	
	function baseTypeStrictlyMatches(right) {
	  var left = this.getTypeAnnotation();
	  right = right.getTypeAnnotation();
	
	  if (!t.isAnyTypeAnnotation(left) && t.isFlowBaseAnnotation(left)) {
	    return right.type === left.type;
	  }
	}
	
	function isGenericType(genericName) {
	  var type = this.getTypeAnnotation();
	  return t.isGenericTypeAnnotation(type) && t.isIdentifier(type.id, { name: genericName });
	}

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = function (node) {
	  if (!this.isReferenced()) return;
	
	  var binding = this.scope.getBinding(node.name);
	  if (binding) {
	    if (binding.identifier.typeAnnotation) {
	      return binding.identifier.typeAnnotation;
	    } else {
	      return getTypeAnnotationBindingConstantViolations(this, node.name);
	    }
	  }
	
	  if (node.name === "undefined") {
	    return t.voidTypeAnnotation();
	  } else if (node.name === "NaN" || node.name === "Infinity") {
	    return t.numberTypeAnnotation();
	  } else if (node.name === "arguments") {}
	};
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTypeAnnotationBindingConstantViolations(path, name) {
	  var binding = path.scope.getBinding(name);
	
	  var types = [];
	  path.typeAnnotation = t.unionTypeAnnotation(types);
	
	  var functionConstantViolations = [];
	  var constantViolations = getConstantViolationsBefore(binding, path, functionConstantViolations);
	
	  var testType = getConditionalAnnotation(path, name);
	  if (testType) {
	    var testConstantViolations = getConstantViolationsBefore(binding, testType.ifStatement);
	
	    constantViolations = constantViolations.filter(function (path) {
	      return testConstantViolations.indexOf(path) < 0;
	    });
	
	    types.push(testType.typeAnnotation);
	  }
	
	  if (constantViolations.length) {
	    constantViolations = constantViolations.concat(functionConstantViolations);
	
	    for (var _iterator = constantViolations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var violation = _ref;
	
	      types.push(violation.getTypeAnnotation());
	    }
	  }
	
	  if (types.length) {
	    return t.createUnionTypeAnnotation(types);
	  }
	}
	
	function getConstantViolationsBefore(binding, path, functions) {
	  var violations = binding.constantViolations.slice();
	  violations.unshift(binding.path);
	  return violations.filter(function (violation) {
	    violation = violation.resolve();
	    var status = violation._guessExecutionStatusRelativeTo(path);
	    if (functions && status === "function") functions.push(violation);
	    return status === "before";
	  });
	}
	
	function inferAnnotationFromBinaryExpression(name, path) {
	  var operator = path.node.operator;
	
	  var right = path.get("right").resolve();
	  var left = path.get("left").resolve();
	
	  var target = void 0;
	  if (left.isIdentifier({ name: name })) {
	    target = right;
	  } else if (right.isIdentifier({ name: name })) {
	    target = left;
	  }
	  if (target) {
	    if (operator === "===") {
	      return target.getTypeAnnotation();
	    } else if (t.BOOLEAN_NUMBER_BINARY_OPERATORS.indexOf(operator) >= 0) {
	      return t.numberTypeAnnotation();
	    } else {
	      return;
	    }
	  } else {
	    if (operator !== "===") return;
	  }
	
	  var typeofPath = void 0;
	  var typePath = void 0;
	  if (left.isUnaryExpression({ operator: "typeof" })) {
	    typeofPath = left;
	    typePath = right;
	  } else if (right.isUnaryExpression({ operator: "typeof" })) {
	    typeofPath = right;
	    typePath = left;
	  }
	  if (!typePath && !typeofPath) return;
	
	  typePath = typePath.resolve();
	  if (!typePath.isLiteral()) return;
	
	  var typeValue = typePath.node.value;
	  if (typeof typeValue !== "string") return;
	
	  if (!typeofPath.get("argument").isIdentifier({ name: name })) return;
	
	  return t.createTypeAnnotationBasedOnTypeof(typePath.node.value);
	}
	
	function getParentConditionalPath(path) {
	  var parentPath = void 0;
	  while (parentPath = path.parentPath) {
	    if (parentPath.isIfStatement() || parentPath.isConditionalExpression()) {
	      if (path.key === "test") {
	        return;
	      } else {
	        return parentPath;
	      }
	    } else {
	      path = parentPath;
	    }
	  }
	}
	
	function getConditionalAnnotation(path, name) {
	  var ifStatement = getParentConditionalPath(path);
	  if (!ifStatement) return;
	
	  var test = ifStatement.get("test");
	  var paths = [test];
	  var types = [];
	
	  do {
	    var _path = paths.shift().resolve();
	
	    if (_path.isLogicalExpression()) {
	      paths.push(_path.get("left"));
	      paths.push(_path.get("right"));
	    }
	
	    if (_path.isBinaryExpression()) {
	      var type = inferAnnotationFromBinaryExpression(name, _path);
	      if (type) types.push(type);
	    }
	  } while (paths.length);
	
	  if (types.length) {
	    return {
	      typeAnnotation: t.createUnionTypeAnnotation(types),
	      ifStatement: ifStatement
	    };
	  } else {
	    return getConditionalAnnotation(ifStatement, name);
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.ClassDeclaration = exports.ClassExpression = exports.FunctionDeclaration = exports.ArrowFunctionExpression = exports.FunctionExpression = exports.Identifier = undefined;
	
	var _infererReference = __webpack_require__(980);
	
	Object.defineProperty(exports, "Identifier", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_infererReference).default;
	  }
	});
	exports.VariableDeclarator = VariableDeclarator;
	exports.TypeCastExpression = TypeCastExpression;
	exports.NewExpression = NewExpression;
	exports.TemplateLiteral = TemplateLiteral;
	exports.UnaryExpression = UnaryExpression;
	exports.BinaryExpression = BinaryExpression;
	exports.LogicalExpression = LogicalExpression;
	exports.ConditionalExpression = ConditionalExpression;
	exports.SequenceExpression = SequenceExpression;
	exports.AssignmentExpression = AssignmentExpression;
	exports.UpdateExpression = UpdateExpression;
	exports.StringLiteral = StringLiteral;
	exports.NumericLiteral = NumericLiteral;
	exports.BooleanLiteral = BooleanLiteral;
	exports.NullLiteral = NullLiteral;
	exports.RegExpLiteral = RegExpLiteral;
	exports.ObjectExpression = ObjectExpression;
	exports.ArrayExpression = ArrayExpression;
	exports.RestElement = RestElement;
	exports.CallExpression = CallExpression;
	exports.TaggedTemplateExpression = TaggedTemplateExpression;
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VariableDeclarator() {
	  var id = this.get("id");
	
	  if (id.isIdentifier()) {
	    return this.get("init").getTypeAnnotation();
	  } else {
	    return;
	  }
	}
	
	function TypeCastExpression(node) {
	  return node.typeAnnotation;
	}
	
	TypeCastExpression.validParent = true;
	
	function NewExpression(node) {
	  if (this.get("callee").isIdentifier()) {
	    return t.genericTypeAnnotation(node.callee);
	  }
	}
	
	function TemplateLiteral() {
	  return t.stringTypeAnnotation();
	}
	
	function UnaryExpression(node) {
	  var operator = node.operator;
	
	  if (operator === "void") {
	    return t.voidTypeAnnotation();
	  } else if (t.NUMBER_UNARY_OPERATORS.indexOf(operator) >= 0) {
	    return t.numberTypeAnnotation();
	  } else if (t.STRING_UNARY_OPERATORS.indexOf(operator) >= 0) {
	    return t.stringTypeAnnotation();
	  } else if (t.BOOLEAN_UNARY_OPERATORS.indexOf(operator) >= 0) {
	    return t.booleanTypeAnnotation();
	  }
	}
	
	function BinaryExpression(node) {
	  var operator = node.operator;
	
	  if (t.NUMBER_BINARY_OPERATORS.indexOf(operator) >= 0) {
	    return t.numberTypeAnnotation();
	  } else if (t.BOOLEAN_BINARY_OPERATORS.indexOf(operator) >= 0) {
	    return t.booleanTypeAnnotation();
	  } else if (operator === "+") {
	    var right = this.get("right");
	    var left = this.get("left");
	
	    if (left.isBaseType("number") && right.isBaseType("number")) {
	      return t.numberTypeAnnotation();
	    } else if (left.isBaseType("string") || right.isBaseType("string")) {
	      return t.stringTypeAnnotation();
	    }
	
	    return t.unionTypeAnnotation([t.stringTypeAnnotation(), t.numberTypeAnnotation()]);
	  }
	}
	
	function LogicalExpression() {
	  return t.createUnionTypeAnnotation([this.get("left").getTypeAnnotation(), this.get("right").getTypeAnnotation()]);
	}
	
	function ConditionalExpression() {
	  return t.createUnionTypeAnnotation([this.get("consequent").getTypeAnnotation(), this.get("alternate").getTypeAnnotation()]);
	}
	
	function SequenceExpression() {
	  return this.get("expressions").pop().getTypeAnnotation();
	}
	
	function AssignmentExpression() {
	  return this.get("right").getTypeAnnotation();
	}
	
	function UpdateExpression(node) {
	  var operator = node.operator;
	  if (operator === "++" || operator === "--") {
	    return t.numberTypeAnnotation();
	  }
	}
	
	function StringLiteral() {
	  return t.stringTypeAnnotation();
	}
	
	function NumericLiteral() {
	  return t.numberTypeAnnotation();
	}
	
	function BooleanLiteral() {
	  return t.booleanTypeAnnotation();
	}
	
	function NullLiteral() {
	  return t.nullLiteralTypeAnnotation();
	}
	
	function RegExpLiteral() {
	  return t.genericTypeAnnotation(t.identifier("RegExp"));
	}
	
	function ObjectExpression() {
	  return t.genericTypeAnnotation(t.identifier("Object"));
	}
	
	function ArrayExpression() {
	  return t.genericTypeAnnotation(t.identifier("Array"));
	}
	
	function RestElement() {
	  return ArrayExpression();
	}
	
	RestElement.validParent = true;
	
	function Func() {
	  return t.genericTypeAnnotation(t.identifier("Function"));
	}
	
	exports.FunctionExpression = Func;
	exports.ArrowFunctionExpression = Func;
	exports.FunctionDeclaration = Func;
	exports.ClassExpression = Func;
	exports.ClassDeclaration = Func;
	function CallExpression() {
	  return resolveCall(this.get("callee"));
	}
	
	function TaggedTemplateExpression() {
	  return resolveCall(this.get("tag"));
	}
	
	function resolveCall(callee) {
	  callee = callee.resolve();
	
	  if (callee.isFunction()) {
	    if (callee.is("async")) {
	      if (callee.is("generator")) {
	        return t.genericTypeAnnotation(t.identifier("AsyncIterator"));
	      } else {
	        return t.genericTypeAnnotation(t.identifier("Promise"));
	      }
	    } else {
	      if (callee.node.returnType) {
	        return callee.node.returnType;
	      } else {}
	    }
	  }
	}

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.is = undefined;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.matchesPattern = matchesPattern;
	exports.has = has;
	exports.isStatic = isStatic;
	exports.isnt = isnt;
	exports.equals = equals;
	exports.isNodeType = isNodeType;
	exports.canHaveVariableDeclarationOrExpression = canHaveVariableDeclarationOrExpression;
	exports.canSwapBetweenExpressionAndStatement = canSwapBetweenExpressionAndStatement;
	exports.isCompletionRecord = isCompletionRecord;
	exports.isStatementOrBlock = isStatementOrBlock;
	exports.referencesImport = referencesImport;
	exports.getSource = getSource;
	exports.willIMaybeExecuteBefore = willIMaybeExecuteBefore;
	exports._guessExecutionStatusRelativeTo = _guessExecutionStatusRelativeTo;
	exports._guessExecutionStatusRelativeToDifferentFunctions = _guessExecutionStatusRelativeToDifferentFunctions;
	exports.resolve = resolve;
	exports._resolve = _resolve;
	
	var _includes = __webpack_require__(330);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function matchesPattern(pattern, allowPartial) {
	  if (!this.isMemberExpression()) return false;
	
	  var parts = pattern.split(".");
	  var search = [this.node];
	  var i = 0;
	
	  function matches(name) {
	    var part = parts[i];
	    return part === "*" || name === part;
	  }
	
	  while (search.length) {
	    var node = search.shift();
	
	    if (allowPartial && i === parts.length) {
	      return true;
	    }
	
	    if (t.isIdentifier(node)) {
	      if (!matches(node.name)) return false;
	    } else if (t.isLiteral(node)) {
	      if (!matches(node.value)) return false;
	    } else if (t.isMemberExpression(node)) {
	      if (node.computed && !t.isLiteral(node.property)) {
	        return false;
	      } else {
	        search.unshift(node.property);
	        search.unshift(node.object);
	        continue;
	      }
	    } else if (t.isThisExpression(node)) {
	      if (!matches("this")) return false;
	    } else {
	      return false;
	    }
	
	    if (++i > parts.length) {
	      return false;
	    }
	  }
	
	  return i === parts.length;
	}
	
	function has(key) {
	  var val = this.node && this.node[key];
	  if (val && Array.isArray(val)) {
	    return !!val.length;
	  } else {
	    return !!val;
	  }
	}
	
	function isStatic() {
	  return this.scope.isStatic(this.node);
	}
	
	var is = exports.is = has;
	
	function isnt(key) {
	  return !this.has(key);
	}
	
	function equals(key, value) {
	  return this.node[key] === value;
	}
	
	function isNodeType(type) {
	  return t.isType(this.type, type);
	}
	
	function canHaveVariableDeclarationOrExpression() {
	  return (this.key === "init" || this.key === "left") && this.parentPath.isFor();
	}
	
	function canSwapBetweenExpressionAndStatement(replacement) {
	  if (this.key !== "body" || !this.parentPath.isArrowFunctionExpression()) {
	    return false;
	  }
	
	  if (this.isExpression()) {
	    return t.isBlockStatement(replacement);
	  } else if (this.isBlockStatement()) {
	    return t.isExpression(replacement);
	  }
	
	  return false;
	}
	
	function isCompletionRecord(allowInsideFunction) {
	  var path = this;
	  var first = true;
	
	  do {
	    var container = path.container;
	
	    if (path.isFunction() && !first) {
	      return !!allowInsideFunction;
	    }
	
	    first = false;
	
	    if (Array.isArray(container) && path.key !== container.length - 1) {
	      return false;
	    }
	  } while ((path = path.parentPath) && !path.isProgram());
	
	  return true;
	}
	
	function isStatementOrBlock() {
	  if (this.parentPath.isLabeledStatement() || t.isBlockStatement(this.container)) {
	    return false;
	  } else {
	    return (0, _includes2.default)(t.STATEMENT_OR_BLOCK_KEYS, this.key);
	  }
	}
	
	function referencesImport(moduleSource, importName) {
	  if (!this.isReferencedIdentifier()) return false;
	
	  var binding = this.scope.getBinding(this.node.name);
	  if (!binding || binding.kind !== "module") return false;
	
	  var path = binding.path;
	  var parent = path.parentPath;
	  if (!parent.isImportDeclaration()) return false;
	
	  if (parent.node.source.value === moduleSource) {
	    if (!importName) return true;
	  } else {
	    return false;
	  }
	
	  if (path.isImportDefaultSpecifier() && importName === "default") {
	    return true;
	  }
	
	  if (path.isImportNamespaceSpecifier() && importName === "*") {
	    return true;
	  }
	
	  if (path.isImportSpecifier() && path.node.imported.name === importName) {
	    return true;
	  }
	
	  return false;
	}
	
	function getSource() {
	  var node = this.node;
	  if (node.end) {
	    return this.hub.file.code.slice(node.start, node.end);
	  } else {
	    return "";
	  }
	}
	
	function willIMaybeExecuteBefore(target) {
	  return this._guessExecutionStatusRelativeTo(target) !== "after";
	}
	
	function _guessExecutionStatusRelativeTo(target) {
	  var targetFuncParent = target.scope.getFunctionParent();
	  var selfFuncParent = this.scope.getFunctionParent();
	
	  if (targetFuncParent.node !== selfFuncParent.node) {
	    var status = this._guessExecutionStatusRelativeToDifferentFunctions(targetFuncParent);
	    if (status) {
	      return status;
	    } else {
	      target = targetFuncParent.path;
	    }
	  }
	
	  var targetPaths = target.getAncestry();
	  if (targetPaths.indexOf(this) >= 0) return "after";
	
	  var selfPaths = this.getAncestry();
	
	  var commonPath = void 0;
	  var targetIndex = void 0;
	  var selfIndex = void 0;
	  for (selfIndex = 0; selfIndex < selfPaths.length; selfIndex++) {
	    var selfPath = selfPaths[selfIndex];
	    targetIndex = targetPaths.indexOf(selfPath);
	    if (targetIndex >= 0) {
	      commonPath = selfPath;
	      break;
	    }
	  }
	  if (!commonPath) {
	    return "before";
	  }
	
	  var targetRelationship = targetPaths[targetIndex - 1];
	  var selfRelationship = selfPaths[selfIndex - 1];
	  if (!targetRelationship || !selfRelationship) {
	    return "before";
	  }
	
	  if (targetRelationship.listKey && targetRelationship.container === selfRelationship.container) {
	    return targetRelationship.key > selfRelationship.key ? "before" : "after";
	  }
	
	  var targetKeyPosition = t.VISITOR_KEYS[targetRelationship.type].indexOf(targetRelationship.key);
	  var selfKeyPosition = t.VISITOR_KEYS[selfRelationship.type].indexOf(selfRelationship.key);
	  return targetKeyPosition > selfKeyPosition ? "before" : "after";
	}
	
	function _guessExecutionStatusRelativeToDifferentFunctions(targetFuncParent) {
	  var targetFuncPath = targetFuncParent.path;
	  if (!targetFuncPath.isFunctionDeclaration()) return;
	
	  var binding = targetFuncPath.scope.getBinding(targetFuncPath.node.id.name);
	
	  if (!binding.references) return "before";
	
	  var referencePaths = binding.referencePaths;
	
	  for (var _iterator = referencePaths, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var path = _ref;
	
	    if (path.key !== "callee" || !path.parentPath.isCallExpression()) {
	      return;
	    }
	  }
	
	  var allStatus = void 0;
	
	  for (var _iterator2 = referencePaths, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	    var _ref2;
	
	    if (_isArray2) {
	      if (_i2 >= _iterator2.length) break;
	      _ref2 = _iterator2[_i2++];
	    } else {
	      _i2 = _iterator2.next();
	      if (_i2.done) break;
	      _ref2 = _i2.value;
	    }
	
	    var _path = _ref2;
	
	    var childOfFunction = !!_path.find(function (path) {
	      return path.node === targetFuncPath.node;
	    });
	    if (childOfFunction) continue;
	
	    var status = this._guessExecutionStatusRelativeTo(_path);
	
	    if (allStatus) {
	      if (allStatus !== status) return;
	    } else {
	      allStatus = status;
	    }
	  }
	
	  return allStatus;
	}
	
	function resolve(dangerous, resolved) {
	  return this._resolve(dangerous, resolved) || this;
	}
	
	function _resolve(dangerous, resolved) {
	  if (resolved && resolved.indexOf(this) >= 0) return;
	
	  resolved = resolved || [];
	  resolved.push(this);
	
	  if (this.isVariableDeclarator()) {
	    if (this.get("id").isIdentifier()) {
	      return this.get("init").resolve(dangerous, resolved);
	    } else {}
	  } else if (this.isReferencedIdentifier()) {
	    var binding = this.scope.getBinding(this.node.name);
	    if (!binding) return;
	
	    if (!binding.constant) return;
	
	    if (binding.kind === "module") return;
	
	    if (binding.path !== this) {
	      var ret = binding.path.resolve(dangerous, resolved);
	
	      if (this.find(function (parent) {
	        return parent.node === ret.node;
	      })) return;
	      return ret;
	    }
	  } else if (this.isTypeCastExpression()) {
	    return this.get("expression").resolve(dangerous, resolved);
	  } else if (dangerous && this.isMemberExpression()) {
	
	    var targetKey = this.toComputedKey();
	    if (!t.isLiteral(targetKey)) return;
	
	    var targetName = targetKey.value;
	
	    var target = this.get("object").resolve(dangerous, resolved);
	
	    if (target.isObjectExpression()) {
	      var props = target.get("properties");
	      for (var _iterator3 = props, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
	        var _ref3;
	
	        if (_isArray3) {
	          if (_i3 >= _iterator3.length) break;
	          _ref3 = _iterator3[_i3++];
	        } else {
	          _i3 = _iterator3.next();
	          if (_i3.done) break;
	          _ref3 = _i3.value;
	        }
	
	        var prop = _ref3;
	
	        if (!prop.isProperty()) continue;
	
	        var key = prop.get("key");
	
	        var match = prop.isnt("computed") && key.isIdentifier({ name: targetName });
	
	        match = match || key.isLiteral({ value: targetName });
	
	        if (match) return prop.get("value").resolve(dangerous, resolved);
	      }
	    } else if (target.isArrayExpression() && !isNaN(+targetName)) {
	      var elems = target.get("elements");
	      var elem = elems[targetName];
	      if (elem) return elem.resolve(dangerous, resolved);
	    }
	  }
	}

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var referenceVisitor = {
	  ReferencedIdentifier: function ReferencedIdentifier(path, state) {
	    if (path.isJSXIdentifier() && _babelTypes.react.isCompatTag(path.node.name) && !path.parentPath.isJSXMemberExpression()) {
	      return;
	    }
	
	    if (path.node.name === "this") {
	      var scope = path.scope;
	      do {
	        if (scope.path.isFunction() && !scope.path.isArrowFunctionExpression()) break;
	      } while (scope = scope.parent);
	      if (scope) state.breakOnScopePaths.push(scope.path);
	    }
	
	    var binding = path.scope.getBinding(path.node.name);
	    if (!binding) return;
	
	    if (binding !== state.scope.getBinding(path.node.name)) return;
	
	    state.bindings[path.node.name] = binding;
	  }
	};
	
	var PathHoister = function () {
	  function PathHoister(path, scope) {
	    (0, _classCallCheck3.default)(this, PathHoister);
	
	    this.breakOnScopePaths = [];
	
	    this.bindings = {};
	
	    this.scopes = [];
	
	    this.scope = scope;
	    this.path = path;
	
	    this.attachAfter = false;
	  }
	
	  PathHoister.prototype.isCompatibleScope = function isCompatibleScope(scope) {
	    for (var key in this.bindings) {
	      var binding = this.bindings[key];
	      if (!scope.bindingIdentifierEquals(key, binding.identifier)) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  PathHoister.prototype.getCompatibleScopes = function getCompatibleScopes() {
	    var scope = this.path.scope;
	    do {
	      if (this.isCompatibleScope(scope)) {
	        this.scopes.push(scope);
	      } else {
	        break;
	      }
	
	      if (this.breakOnScopePaths.indexOf(scope.path) >= 0) {
	        break;
	      }
	    } while (scope = scope.parent);
	  };
	
	  PathHoister.prototype.getAttachmentPath = function getAttachmentPath() {
	    var path = this._getAttachmentPath();
	    if (!path) return;
	
	    var targetScope = path.scope;
	
	    if (targetScope.path === path) {
	      targetScope = path.scope.parent;
	    }
	
	    if (targetScope.path.isProgram() || targetScope.path.isFunction()) {
	      for (var name in this.bindings) {
	        if (!targetScope.hasOwnBinding(name)) continue;
	
	        var binding = this.bindings[name];
	
	        if (binding.kind === "param") continue;
	
	        if (this.getAttachmentParentForPath(binding.path).key > path.key) {
	          this.attachAfter = true;
	          path = binding.path;
	
	          for (var _iterator = binding.constantViolations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	            var _ref;
	
	            if (_isArray) {
	              if (_i >= _iterator.length) break;
	              _ref = _iterator[_i++];
	            } else {
	              _i = _iterator.next();
	              if (_i.done) break;
	              _ref = _i.value;
	            }
	
	            var violationPath = _ref;
	
	            if (this.getAttachmentParentForPath(violationPath).key > path.key) {
	              path = violationPath;
	            }
	          }
	        }
	      }
	    }
	
	    if (path.parentPath.isExportDeclaration()) {
	      path = path.parentPath;
	    }
	
	    return path;
	  };
	
	  PathHoister.prototype._getAttachmentPath = function _getAttachmentPath() {
	    var scopes = this.scopes;
	
	    var scope = scopes.pop();
	
	    if (!scope) return;
	
	    if (scope.path.isFunction()) {
	      if (this.hasOwnParamBindings(scope)) {
	        if (this.scope === scope) return;
	
	        return scope.path.get("body").get("body")[0];
	      } else {
	        return this.getNextScopeAttachmentParent();
	      }
	    } else if (scope.path.isProgram()) {
	      return this.getNextScopeAttachmentParent();
	    }
	  };
	
	  PathHoister.prototype.getNextScopeAttachmentParent = function getNextScopeAttachmentParent() {
	    var scope = this.scopes.pop();
	    if (scope) return this.getAttachmentParentForPath(scope.path);
	  };
	
	  PathHoister.prototype.getAttachmentParentForPath = function getAttachmentParentForPath(path) {
	    do {
	      if (!path.parentPath || Array.isArray(path.container) && path.isStatement() || path.isVariableDeclarator() && path.parentPath.node !== null && path.parentPath.node.declarations.length > 1) return path;
	    } while (path = path.parentPath);
	  };
	
	  PathHoister.prototype.hasOwnParamBindings = function hasOwnParamBindings(scope) {
	    for (var name in this.bindings) {
	      if (!scope.hasOwnBinding(name)) continue;
	
	      var binding = this.bindings[name];
	
	      if (binding.kind === "param" && binding.constant) return true;
	    }
	    return false;
	  };
	
	  PathHoister.prototype.run = function run() {
	    var node = this.path.node;
	    if (node._hoisted) return;
	    node._hoisted = true;
	
	    this.path.traverse(referenceVisitor, this);
	
	    this.getCompatibleScopes();
	
	    var attachTo = this.getAttachmentPath();
	    if (!attachTo) return;
	
	    if (attachTo.getFunctionParent() === this.path.getFunctionParent()) return;
	
	    var uid = attachTo.scope.generateUidIdentifier("ref");
	    var declarator = t.variableDeclarator(uid, this.path.node);
	
	    var insertFn = this.attachAfter ? "insertAfter" : "insertBefore";
	    attachTo[insertFn]([attachTo.isVariableDeclarator() ? declarator : t.variableDeclaration("var", [declarator])]);
	
	    var parent = this.path.parentPath;
	    if (parent.isJSXElement() && this.path.container === parent.node.children) {
	      uid = t.JSXExpressionContainer(uid);
	    }
	
	    this.path.replaceWith(uid);
	  };
	
	  return PathHoister;
	}();
	
	exports.default = PathHoister;
	module.exports = exports["default"];

/***/ }),
/* 984 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var hooks = exports.hooks = [function (self, parent) {
	  var removeParent = self.key === "test" && (parent.isWhile() || parent.isSwitchCase()) || self.key === "declaration" && parent.isExportDeclaration() || self.key === "body" && parent.isLabeledStatement() || self.listKey === "declarations" && parent.isVariableDeclaration() && parent.node.declarations.length === 1 || self.key === "expression" && parent.isExpressionStatement();
	
	  if (removeParent) {
	    parent.remove();
	    return true;
	  }
	}, function (self, parent) {
	  if (parent.isSequenceExpression() && parent.node.expressions.length === 1) {
	    parent.replaceWith(parent.node.expressions[0]);
	    return true;
	  }
	}, function (self, parent) {
	  if (parent.isBinary()) {
	    if (self.key === "left") {
	      parent.replaceWith(parent.node.right);
	    } else {
	      parent.replaceWith(parent.node.left);
	    }
	    return true;
	  }
	}, function (self, parent) {
	  if (parent.isIfStatement() && (self.key === "consequent" || self.key === "alternate") || self.key === "body" && (parent.isLoop() || parent.isArrowFunctionExpression())) {
	    self.replaceWith({
	      type: "BlockStatement",
	      body: []
	    });
	    return true;
	  }
	}];

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(124);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.insertBefore = insertBefore;
	exports._containerInsert = _containerInsert;
	exports._containerInsertBefore = _containerInsertBefore;
	exports._containerInsertAfter = _containerInsertAfter;
	exports._maybePopFromStatements = _maybePopFromStatements;
	exports.insertAfter = insertAfter;
	exports.updateSiblingKeys = updateSiblingKeys;
	exports._verifyNodeList = _verifyNodeList;
	exports.unshiftContainer = unshiftContainer;
	exports.pushContainer = pushContainer;
	exports.hoist = hoist;
	
	var _cache = __webpack_require__(285);
	
	var _hoister = __webpack_require__(983);
	
	var _hoister2 = _interopRequireDefault(_hoister);
	
	var _index = __webpack_require__(125);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function insertBefore(nodes) {
	  this._assertUnremoved();
	
	  nodes = this._verifyNodeList(nodes);
	
	  if (this.parentPath.isExpressionStatement() || this.parentPath.isLabeledStatement()) {
	    return this.parentPath.insertBefore(nodes);
	  } else if (this.isNodeType("Expression") || this.parentPath.isForStatement() && this.key === "init") {
	    if (this.node) nodes.push(this.node);
	    this.replaceExpressionWithStatements(nodes);
	  } else {
	    this._maybePopFromStatements(nodes);
	    if (Array.isArray(this.container)) {
	      return this._containerInsertBefore(nodes);
	    } else if (this.isStatementOrBlock()) {
	      if (this.node) nodes.push(this.node);
	      this._replaceWith(t.blockStatement(nodes));
	    } else {
	      throw new Error("We don't know what to do with this node type. " + "We were previously a Statement but we can't fit in here?");
	    }
	  }
	
	  return [this];
	}
	
	function _containerInsert(from, nodes) {
	  this.updateSiblingKeys(from, nodes.length);
	
	  var paths = [];
	
	  for (var i = 0; i < nodes.length; i++) {
	    var to = from + i;
	    var node = nodes[i];
	    this.container.splice(to, 0, node);
	
	    if (this.context) {
	      var path = this.context.create(this.parent, this.container, to, this.listKey);
	
	      if (this.context.queue) path.pushContext(this.context);
	      paths.push(path);
	    } else {
	      paths.push(_index2.default.get({
	        parentPath: this.parentPath,
	        parent: this.parent,
	        container: this.container,
	        listKey: this.listKey,
	        key: to
	      }));
	    }
	  }
	
	  var contexts = this._getQueueContexts();
	
	  for (var _iterator = paths, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var _path = _ref;
	
	    _path.setScope();
	    _path.debug(function () {
	      return "Inserted.";
	    });
	
	    for (var _iterator2 = contexts, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var context = _ref2;
	
	      context.maybeQueue(_path, true);
	    }
	  }
	
	  return paths;
	}
	
	function _containerInsertBefore(nodes) {
	  return this._containerInsert(this.key, nodes);
	}
	
	function _containerInsertAfter(nodes) {
	  return this._containerInsert(this.key + 1, nodes);
	}
	
	function _maybePopFromStatements(nodes) {
	  var last = nodes[nodes.length - 1];
	  var isIdentifier = t.isIdentifier(last) || t.isExpressionStatement(last) && t.isIdentifier(last.expression);
	
	  if (isIdentifier && !this.isCompletionRecord()) {
	    nodes.pop();
	  }
	}
	
	function insertAfter(nodes) {
	  this._assertUnremoved();
	
	  nodes = this._verifyNodeList(nodes);
	
	  if (this.parentPath.isExpressionStatement() || this.parentPath.isLabeledStatement()) {
	    return this.parentPath.insertAfter(nodes);
	  } else if (this.isNodeType("Expression") || this.parentPath.isForStatement() && this.key === "init") {
	    if (this.node) {
	      var temp = this.scope.generateDeclaredUidIdentifier();
	      nodes.unshift(t.expressionStatement(t.assignmentExpression("=", temp, this.node)));
	      nodes.push(t.expressionStatement(temp));
	    }
	    this.replaceExpressionWithStatements(nodes);
	  } else {
	    this._maybePopFromStatements(nodes);
	    if (Array.isArray(this.container)) {
	      return this._containerInsertAfter(nodes);
	    } else if (this.isStatementOrBlock()) {
	      if (this.node) nodes.unshift(this.node);
	      this._replaceWith(t.blockStatement(nodes));
	    } else {
	      throw new Error("We don't know what to do with this node type. " + "We were previously a Statement but we can't fit in here?");
	    }
	  }
	
	  return [this];
	}
	
	function updateSiblingKeys(fromIndex, incrementBy) {
	  if (!this.parent) return;
	
	  var paths = _cache.path.get(this.parent);
	  for (var i = 0; i < paths.length; i++) {
	    var path = paths[i];
	    if (path.key >= fromIndex) {
	      path.key += incrementBy;
	    }
	  }
	}
	
	function _verifyNodeList(nodes) {
	  if (!nodes) {
	    return [];
	  }
	
	  if (nodes.constructor !== Array) {
	    nodes = [nodes];
	  }
	
	  for (var i = 0; i < nodes.length; i++) {
	    var node = nodes[i];
	    var msg = void 0;
	
	    if (!node) {
	      msg = "has falsy node";
	    } else if ((typeof node === "undefined" ? "undefined" : (0, _typeof3.default)(node)) !== "object") {
	      msg = "contains a non-object node";
	    } else if (!node.type) {
	      msg = "without a type";
	    } else if (node instanceof _index2.default) {
	      msg = "has a NodePath when it expected a raw object";
	    }
	
	    if (msg) {
	      var type = Array.isArray(node) ? "array" : typeof node === "undefined" ? "undefined" : (0, _typeof3.default)(node);
	      throw new Error("Node list " + msg + " with the index of " + i + " and type of " + type);
	    }
	  }
	
	  return nodes;
	}
	
	function unshiftContainer(listKey, nodes) {
	  this._assertUnremoved();
	
	  nodes = this._verifyNodeList(nodes);
	
	  var path = _index2.default.get({
	    parentPath: this,
	    parent: this.node,
	    container: this.node[listKey],
	    listKey: listKey,
	    key: 0
	  });
	
	  return path.insertBefore(nodes);
	}
	
	function pushContainer(listKey, nodes) {
	  this._assertUnremoved();
	
	  nodes = this._verifyNodeList(nodes);
	
	  var container = this.node[listKey];
	  var path = _index2.default.get({
	    parentPath: this,
	    parent: this.node,
	    container: container,
	    listKey: listKey,
	    key: container.length
	  });
	
	  return path.replaceWithMultiple(nodes);
	}
	
	function hoist() {
	  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.scope;
	
	  var hoister = new _hoister2.default(this, scope);
	  return hoister.run();
	}

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.remove = remove;
	exports._callRemovalHooks = _callRemovalHooks;
	exports._remove = _remove;
	exports._markRemoved = _markRemoved;
	exports._assertUnremoved = _assertUnremoved;
	
	var _removalHooks = __webpack_require__(984);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function remove() {
	  this._assertUnremoved();
	
	  this.resync();
	
	  if (this._callRemovalHooks()) {
	    this._markRemoved();
	    return;
	  }
	
	  this.shareCommentsWithSiblings();
	  this._remove();
	  this._markRemoved();
	}
	
	function _callRemovalHooks() {
	  for (var _iterator = _removalHooks.hooks, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var fn = _ref;
	
	    if (fn(this, this.parentPath)) return true;
	  }
	}
	
	function _remove() {
	  if (Array.isArray(this.container)) {
	    this.container.splice(this.key, 1);
	    this.updateSiblingKeys(this.key, -1);
	  } else {
	    this._replaceWith(null);
	  }
	}
	
	function _markRemoved() {
	  this.shouldSkip = true;
	  this.removed = true;
	  this.node = null;
	}
	
	function _assertUnremoved() {
	  if (this.removed) {
	    throw this.buildCodeFrameError("NodePath has been removed so is read-only.");
	  }
	}

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.replaceWithMultiple = replaceWithMultiple;
	exports.replaceWithSourceString = replaceWithSourceString;
	exports.replaceWith = replaceWith;
	exports._replaceWith = _replaceWith;
	exports.replaceExpressionWithStatements = replaceExpressionWithStatements;
	exports.replaceInline = replaceInline;
	
	var _babelCodeFrame = __webpack_require__(858);
	
	var _babelCodeFrame2 = _interopRequireDefault(_babelCodeFrame);
	
	var _index = __webpack_require__(91);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(125);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _babylon = __webpack_require__(554);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hoistVariablesVisitor = {
	  Function: function Function(path) {
	    path.skip();
	  },
	  VariableDeclaration: function VariableDeclaration(path) {
	    if (path.node.kind !== "var") return;
	
	    var bindings = path.getBindingIdentifiers();
	    for (var key in bindings) {
	      path.scope.push({ id: bindings[key] });
	    }
	
	    var exprs = [];
	
	    for (var _iterator = path.node.declarations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var declar = _ref;
	
	      if (declar.init) {
	        exprs.push(t.expressionStatement(t.assignmentExpression("=", declar.id, declar.init)));
	      }
	    }
	
	    path.replaceWithMultiple(exprs);
	  }
	};
	
	function replaceWithMultiple(nodes) {
	  this.resync();
	
	  nodes = this._verifyNodeList(nodes);
	  t.inheritLeadingComments(nodes[0], this.node);
	  t.inheritTrailingComments(nodes[nodes.length - 1], this.node);
	  this.node = this.container[this.key] = null;
	  this.insertAfter(nodes);
	
	  if (this.node) {
	    this.requeue();
	  } else {
	    this.remove();
	  }
	}
	
	function replaceWithSourceString(replacement) {
	  this.resync();
	
	  try {
	    replacement = "(" + replacement + ")";
	    replacement = (0, _babylon.parse)(replacement);
	  } catch (err) {
	    var loc = err.loc;
	    if (loc) {
	      err.message += " - make sure this is an expression.";
	      err.message += "\n" + (0, _babelCodeFrame2.default)(replacement, loc.line, loc.column + 1);
	    }
	    throw err;
	  }
	
	  replacement = replacement.program.body[0].expression;
	  _index2.default.removeProperties(replacement);
	  return this.replaceWith(replacement);
	}
	
	function replaceWith(replacement) {
	  this.resync();
	
	  if (this.removed) {
	    throw new Error("You can't replace this node, we've already removed it");
	  }
	
	  if (replacement instanceof _index4.default) {
	    replacement = replacement.node;
	  }
	
	  if (!replacement) {
	    throw new Error("You passed `path.replaceWith()` a falsy node, use `path.remove()` instead");
	  }
	
	  if (this.node === replacement) {
	    return;
	  }
	
	  if (this.isProgram() && !t.isProgram(replacement)) {
	    throw new Error("You can only replace a Program root node with another Program node");
	  }
	
	  if (Array.isArray(replacement)) {
	    throw new Error("Don't use `path.replaceWith()` with an array of nodes, use `path.replaceWithMultiple()`");
	  }
	
	  if (typeof replacement === "string") {
	    throw new Error("Don't use `path.replaceWith()` with a source string, use `path.replaceWithSourceString()`");
	  }
	
	  if (this.isNodeType("Statement") && t.isExpression(replacement)) {
	    if (!this.canHaveVariableDeclarationOrExpression() && !this.canSwapBetweenExpressionAndStatement(replacement) && !this.parentPath.isExportDefaultDeclaration()) {
	      replacement = t.expressionStatement(replacement);
	    }
	  }
	
	  if (this.isNodeType("Expression") && t.isStatement(replacement)) {
	    if (!this.canHaveVariableDeclarationOrExpression() && !this.canSwapBetweenExpressionAndStatement(replacement)) {
	      return this.replaceExpressionWithStatements([replacement]);
	    }
	  }
	
	  var oldNode = this.node;
	  if (oldNode) {
	    t.inheritsComments(replacement, oldNode);
	    t.removeComments(oldNode);
	  }
	
	  this._replaceWith(replacement);
	  this.type = replacement.type;
	
	  this.setScope();
	
	  this.requeue();
	}
	
	function _replaceWith(node) {
	  if (!this.container) {
	    throw new ReferenceError("Container is falsy");
	  }
	
	  if (this.inList) {
	    t.validate(this.parent, this.key, [node]);
	  } else {
	    t.validate(this.parent, this.key, node);
	  }
	
	  this.debug(function () {
	    return "Replace with " + (node && node.type);
	  });
	
	  this.node = this.container[this.key] = node;
	}
	
	function replaceExpressionWithStatements(nodes) {
	  this.resync();
	
	  var toSequenceExpression = t.toSequenceExpression(nodes, this.scope);
	
	  if (t.isSequenceExpression(toSequenceExpression)) {
	    var exprs = toSequenceExpression.expressions;
	
	    if (exprs.length >= 2 && this.parentPath.isExpressionStatement()) {
	      this._maybePopFromStatements(exprs);
	    }
	
	    if (exprs.length === 1) {
	      this.replaceWith(exprs[0]);
	    } else {
	      this.replaceWith(toSequenceExpression);
	    }
	  } else if (toSequenceExpression) {
	    this.replaceWith(toSequenceExpression);
	  } else {
	    var container = t.functionExpression(null, [], t.blockStatement(nodes));
	    container.shadow = true;
	
	    this.replaceWith(t.callExpression(container, []));
	    this.traverse(hoistVariablesVisitor);
	
	    var completionRecords = this.get("callee").getCompletionRecords();
	    for (var _iterator2 = completionRecords, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	      var _ref2;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }
	
	      var path = _ref2;
	
	      if (!path.isExpressionStatement()) continue;
	
	      var loop = path.findParent(function (path) {
	        return path.isLoop();
	      });
	      if (loop) {
	        var uid = loop.getData("expressionReplacementReturnUid");
	
	        if (!uid) {
	          var callee = this.get("callee");
	          uid = callee.scope.generateDeclaredUidIdentifier("ret");
	          callee.get("body").pushContainer("body", t.returnStatement(uid));
	          loop.setData("expressionReplacementReturnUid", uid);
	        } else {
	          uid = t.identifier(uid.name);
	        }
	
	        path.get("expression").replaceWith(t.assignmentExpression("=", uid, path.node.expression));
	      } else {
	        path.replaceWith(t.returnStatement(path.node.expression));
	      }
	    }
	
	    return this.node;
	  }
	}
	
	function replaceInline(nodes) {
	  this.resync();
	
	  if (Array.isArray(nodes)) {
	    if (Array.isArray(this.container)) {
	      nodes = this._verifyNodeList(nodes);
	      this._containerInsertAfter(nodes);
	      return this.remove();
	    } else {
	      return this.replaceWithMultiple(nodes);
	    }
	  } else {
	    return this.replaceWith(nodes);
	  }
	}

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _binding = __webpack_require__(552);
	
	var _binding2 = _interopRequireDefault(_binding);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renameVisitor = {
	  ReferencedIdentifier: function ReferencedIdentifier(_ref, state) {
	    var node = _ref.node;
	
	    if (node.name === state.oldName) {
	      node.name = state.newName;
	    }
	  },
	  Scope: function Scope(path, state) {
	    if (!path.scope.bindingIdentifierEquals(state.oldName, state.binding.identifier)) {
	      path.skip();
	    }
	  },
	  "AssignmentExpression|Declaration": function AssignmentExpressionDeclaration(path, state) {
	    var ids = path.getOuterBindingIdentifiers();
	
	    for (var name in ids) {
	      if (name === state.oldName) ids[name].name = state.newName;
	    }
	  }
	};
	
	var Renamer = function () {
	  function Renamer(binding, oldName, newName) {
	    (0, _classCallCheck3.default)(this, Renamer);
	
	    this.newName = newName;
	    this.oldName = oldName;
	    this.binding = binding;
	  }
	
	  Renamer.prototype.maybeConvertFromExportDeclaration = function maybeConvertFromExportDeclaration(parentDeclar) {
	    var exportDeclar = parentDeclar.parentPath.isExportDeclaration() && parentDeclar.parentPath;
	    if (!exportDeclar) return;
	
	    var isDefault = exportDeclar.isExportDefaultDeclaration();
	
	    if (isDefault && (parentDeclar.isFunctionDeclaration() || parentDeclar.isClassDeclaration()) && !parentDeclar.node.id) {
	      parentDeclar.node.id = parentDeclar.scope.generateUidIdentifier("default");
	    }
	
	    var bindingIdentifiers = parentDeclar.getOuterBindingIdentifiers();
	    var specifiers = [];
	
	    for (var name in bindingIdentifiers) {
	      var localName = name === this.oldName ? this.newName : name;
	      var exportedName = isDefault ? "default" : name;
	      specifiers.push(t.exportSpecifier(t.identifier(localName), t.identifier(exportedName)));
	    }
	
	    if (specifiers.length) {
	      var aliasDeclar = t.exportNamedDeclaration(null, specifiers);
	
	      if (parentDeclar.isFunctionDeclaration()) {
	        aliasDeclar._blockHoist = 3;
	      }
	
	      exportDeclar.insertAfter(aliasDeclar);
	      exportDeclar.replaceWith(parentDeclar.node);
	    }
	  };
	
	  Renamer.prototype.rename = function rename(block) {
	    var binding = this.binding,
	        oldName = this.oldName,
	        newName = this.newName;
	    var scope = binding.scope,
	        path = binding.path;
	
	
	    var parentDeclar = path.find(function (path) {
	      return path.isDeclaration() || path.isFunctionExpression();
	    });
	    if (parentDeclar) {
	      this.maybeConvertFromExportDeclaration(parentDeclar);
	    }
	
	    scope.traverse(block || scope.block, renameVisitor, this);
	
	    if (!block) {
	      scope.removeOwnBinding(oldName);
	      scope.bindings[newName] = binding;
	      this.binding.identifier.name = newName;
	    }
	
	    if (binding.type === "hoisted") {}
	  };
	
	  return Renamer;
	}();
	
	exports.default = Renamer;
	module.exports = exports["default"];

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(124);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(90);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.explode = explode;
	exports.verify = verify;
	exports.merge = merge;
	
	var _virtualTypes = __webpack_require__(551);
	
	var virtualTypes = _interopRequireWildcard(_virtualTypes);
	
	var _babelMessages = __webpack_require__(284);
	
	var messages = _interopRequireWildcard(_babelMessages);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	var _clone = __webpack_require__(682);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function explode(visitor) {
	  if (visitor._exploded) return visitor;
	  visitor._exploded = true;
	
	  for (var nodeType in visitor) {
	    if (shouldIgnoreKey(nodeType)) continue;
	
	    var parts = nodeType.split("|");
	    if (parts.length === 1) continue;
	
	    var fns = visitor[nodeType];
	    delete visitor[nodeType];
	
	    for (var _iterator = parts, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var part = _ref;
	
	      visitor[part] = fns;
	    }
	  }
	
	  verify(visitor);
	
	  delete visitor.__esModule;
	
	  ensureEntranceObjects(visitor);
	
	  ensureCallbackArrays(visitor);
	
	  for (var _iterator2 = (0, _keys2.default)(visitor), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	    var _ref2;
	
	    if (_isArray2) {
	      if (_i2 >= _iterator2.length) break;
	      _ref2 = _iterator2[_i2++];
	    } else {
	      _i2 = _iterator2.next();
	      if (_i2.done) break;
	      _ref2 = _i2.value;
	    }
	
	    var _nodeType3 = _ref2;
	
	    if (shouldIgnoreKey(_nodeType3)) continue;
	
	    var wrapper = virtualTypes[_nodeType3];
	    if (!wrapper) continue;
	
	    var _fns2 = visitor[_nodeType3];
	    for (var type in _fns2) {
	      _fns2[type] = wrapCheck(wrapper, _fns2[type]);
	    }
	
	    delete visitor[_nodeType3];
	
	    if (wrapper.types) {
	      for (var _iterator4 = wrapper.types, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : (0, _getIterator3.default)(_iterator4);;) {
	        var _ref4;
	
	        if (_isArray4) {
	          if (_i4 >= _iterator4.length) break;
	          _ref4 = _iterator4[_i4++];
	        } else {
	          _i4 = _iterator4.next();
	          if (_i4.done) break;
	          _ref4 = _i4.value;
	        }
	
	        var _type = _ref4;
	
	        if (visitor[_type]) {
	          mergePair(visitor[_type], _fns2);
	        } else {
	          visitor[_type] = _fns2;
	        }
	      }
	    } else {
	      mergePair(visitor, _fns2);
	    }
	  }
	
	  for (var _nodeType in visitor) {
	    if (shouldIgnoreKey(_nodeType)) continue;
	
	    var _fns = visitor[_nodeType];
	
	    var aliases = t.FLIPPED_ALIAS_KEYS[_nodeType];
	
	    var deprecratedKey = t.DEPRECATED_KEYS[_nodeType];
	    if (deprecratedKey) {
	      console.trace("Visitor defined for " + _nodeType + " but it has been renamed to " + deprecratedKey);
	      aliases = [deprecratedKey];
	    }
	
	    if (!aliases) continue;
	
	    delete visitor[_nodeType];
	
	    for (var _iterator3 = aliases, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
	      var _ref3;
	
	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }
	
	      var alias = _ref3;
	
	      var existing = visitor[alias];
	      if (existing) {
	        mergePair(existing, _fns);
	      } else {
	        visitor[alias] = (0, _clone2.default)(_fns);
	      }
	    }
	  }
	
	  for (var _nodeType2 in visitor) {
	    if (shouldIgnoreKey(_nodeType2)) continue;
	
	    ensureCallbackArrays(visitor[_nodeType2]);
	  }
	
	  return visitor;
	}
	
	function verify(visitor) {
	  if (visitor._verified) return;
	
	  if (typeof visitor === "function") {
	    throw new Error(messages.get("traverseVerifyRootFunction"));
	  }
	
	  for (var nodeType in visitor) {
	    if (nodeType === "enter" || nodeType === "exit") {
	      validateVisitorMethods(nodeType, visitor[nodeType]);
	    }
	
	    if (shouldIgnoreKey(nodeType)) continue;
	
	    if (t.TYPES.indexOf(nodeType) < 0) {
	      throw new Error(messages.get("traverseVerifyNodeType", nodeType));
	    }
	
	    var visitors = visitor[nodeType];
	    if ((typeof visitors === "undefined" ? "undefined" : (0, _typeof3.default)(visitors)) === "object") {
	      for (var visitorKey in visitors) {
	        if (visitorKey === "enter" || visitorKey === "exit") {
	          validateVisitorMethods(nodeType + "." + visitorKey, visitors[visitorKey]);
	        } else {
	          throw new Error(messages.get("traverseVerifyVisitorProperty", nodeType, visitorKey));
	        }
	      }
	    }
	  }
	
	  visitor._verified = true;
	}
	
	function validateVisitorMethods(path, val) {
	  var fns = [].concat(val);
	  for (var _iterator5 = fns, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : (0, _getIterator3.default)(_iterator5);;) {
	    var _ref5;
	
	    if (_isArray5) {
	      if (_i5 >= _iterator5.length) break;
	      _ref5 = _iterator5[_i5++];
	    } else {
	      _i5 = _iterator5.next();
	      if (_i5.done) break;
	      _ref5 = _i5.value;
	    }
	
	    var fn = _ref5;
	
	    if (typeof fn !== "function") {
	      throw new TypeError("Non-function found defined in " + path + " with type " + (typeof fn === "undefined" ? "undefined" : (0, _typeof3.default)(fn)));
	    }
	  }
	}
	
	function merge(visitors) {
	  var states = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var wrapper = arguments[2];
	
	  var rootVisitor = {};
	
	  for (var i = 0; i < visitors.length; i++) {
	    var visitor = visitors[i];
	    var state = states[i];
	
	    explode(visitor);
	
	    for (var type in visitor) {
	      var visitorType = visitor[type];
	
	      if (state || wrapper) {
	        visitorType = wrapWithStateOrWrapper(visitorType, state, wrapper);
	      }
	
	      var nodeVisitor = rootVisitor[type] = rootVisitor[type] || {};
	      mergePair(nodeVisitor, visitorType);
	    }
	  }
	
	  return rootVisitor;
	}
	
	function wrapWithStateOrWrapper(oldVisitor, state, wrapper) {
	  var newVisitor = {};
	
	  var _loop = function _loop(key) {
	    var fns = oldVisitor[key];
	
	    if (!Array.isArray(fns)) return "continue";
	
	    fns = fns.map(function (fn) {
	      var newFn = fn;
	
	      if (state) {
	        newFn = function newFn(path) {
	          return fn.call(state, path, state);
	        };
	      }
	
	      if (wrapper) {
	        newFn = wrapper(state.key, key, newFn);
	      }
	
	      return newFn;
	    });
	
	    newVisitor[key] = fns;
	  };
	
	  for (var key in oldVisitor) {
	    var _ret = _loop(key);
	
	    if (_ret === "continue") continue;
	  }
	
	  return newVisitor;
	}
	
	function ensureEntranceObjects(obj) {
	  for (var key in obj) {
	    if (shouldIgnoreKey(key)) continue;
	
	    var fns = obj[key];
	    if (typeof fns === "function") {
	      obj[key] = { enter: fns };
	    }
	  }
	}
	
	function ensureCallbackArrays(obj) {
	  if (obj.enter && !Array.isArray(obj.enter)) obj.enter = [obj.enter];
	  if (obj.exit && !Array.isArray(obj.exit)) obj.exit = [obj.exit];
	}
	
	function wrapCheck(wrapper, fn) {
	  var newFn = function newFn(path) {
	    if (wrapper.checkPath(path)) {
	      return fn.apply(this, arguments);
	    }
	  };
	  newFn.toString = function () {
	    return fn.toString();
	  };
	  return newFn;
	}
	
	function shouldIgnoreKey(key) {
	  if (key[0] === "_") return true;
	
	  if (key === "enter" || key === "exit" || key === "shouldSkip") return true;
	
	  if (key === "blacklist" || key === "noScope" || key === "skipKeys") return true;
	
	  return false;
	}
	
	function mergePair(dest, src) {
	  for (var key in src) {
	    dest[key] = [].concat(dest[key] || [], src[key]);
	  }
	}

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _maxSafeInteger = __webpack_require__(962);
	
	var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);
	
	var _stringify = __webpack_require__(168);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.toComputedKey = toComputedKey;
	exports.toSequenceExpression = toSequenceExpression;
	exports.toKeyAlias = toKeyAlias;
	exports.toIdentifier = toIdentifier;
	exports.toBindingIdentifierName = toBindingIdentifierName;
	exports.toStatement = toStatement;
	exports.toExpression = toExpression;
	exports.toBlock = toBlock;
	exports.valueToNode = valueToNode;
	
	var _isPlainObject = __webpack_require__(75);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isRegExp = __webpack_require__(4326);
	
	var _isRegExp2 = _interopRequireDefault(_isRegExp);
	
	var _index = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toComputedKey(node) {
	  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : node.key || node.property;
	
	  if (!node.computed) {
	    if (t.isIdentifier(key)) key = t.stringLiteral(key.name);
	  }
	  return key;
	}
	
	function gatherSequenceExpressions(nodes, scope, declars) {
	  var exprs = [];
	  var ensureLastUndefined = true;
	
	  for (var _iterator = nodes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var node = _ref;
	
	    ensureLastUndefined = false;
	
	    if (t.isExpression(node)) {
	      exprs.push(node);
	    } else if (t.isExpressionStatement(node)) {
	      exprs.push(node.expression);
	    } else if (t.isVariableDeclaration(node)) {
	      if (node.kind !== "var") return;
	
	      for (var _iterator2 = node.declarations, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	        var _ref2;
	
	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }
	
	        var declar = _ref2;
	
	        var bindings = t.getBindingIdentifiers(declar);
	        for (var key in bindings) {
	          declars.push({
	            kind: node.kind,
	            id: bindings[key]
	          });
	        }
	
	        if (declar.init) {
	          exprs.push(t.assignmentExpression("=", declar.id, declar.init));
	        }
	      }
	
	      ensureLastUndefined = true;
	    } else if (t.isIfStatement(node)) {
	      var consequent = node.consequent ? gatherSequenceExpressions([node.consequent], scope, declars) : scope.buildUndefinedNode();
	      var alternate = node.alternate ? gatherSequenceExpressions([node.alternate], scope, declars) : scope.buildUndefinedNode();
	      if (!consequent || !alternate) return;
	
	      exprs.push(t.conditionalExpression(node.test, consequent, alternate));
	    } else if (t.isBlockStatement(node)) {
	      var body = gatherSequenceExpressions(node.body, scope, declars);
	      if (!body) return;
	
	      exprs.push(body);
	    } else if (t.isEmptyStatement(node)) {
	      ensureLastUndefined = true;
	    } else {
	      return;
	    }
	  }
	
	  if (ensureLastUndefined) {
	    exprs.push(scope.buildUndefinedNode());
	  }
	
	  if (exprs.length === 1) {
	    return exprs[0];
	  } else {
	    return t.sequenceExpression(exprs);
	  }
	}
	
	function toSequenceExpression(nodes, scope) {
	  if (!nodes || !nodes.length) return;
	
	  var declars = [];
	  var result = gatherSequenceExpressions(nodes, scope, declars);
	  if (!result) return;
	
	  for (var _iterator3 = declars, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
	    var _ref3;
	
	    if (_isArray3) {
	      if (_i3 >= _iterator3.length) break;
	      _ref3 = _iterator3[_i3++];
	    } else {
	      _i3 = _iterator3.next();
	      if (_i3.done) break;
	      _ref3 = _i3.value;
	    }
	
	    var declar = _ref3;
	
	    scope.push(declar);
	  }
	
	  return result;
	}
	
	function toKeyAlias(node) {
	  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : node.key;
	
	  var alias = void 0;
	
	  if (node.kind === "method") {
	    return toKeyAlias.increment() + "";
	  } else if (t.isIdentifier(key)) {
	    alias = key.name;
	  } else if (t.isStringLiteral(key)) {
	    alias = (0, _stringify2.default)(key.value);
	  } else {
	    alias = (0, _stringify2.default)(t.removePropertiesDeep(t.cloneDeep(key)));
	  }
	
	  if (node.computed) {
	    alias = "[" + alias + "]";
	  }
	
	  if (node.static) {
	    alias = "static:" + alias;
	  }
	
	  return alias;
	}
	
	toKeyAlias.uid = 0;
	
	toKeyAlias.increment = function () {
	  if (toKeyAlias.uid >= _maxSafeInteger2.default) {
	    return toKeyAlias.uid = 0;
	  } else {
	    return toKeyAlias.uid++;
	  }
	};
	
	function toIdentifier(name) {
	  name = name + "";
	
	  name = name.replace(/[^a-zA-Z0-9$_]/g, "-");
	
	  name = name.replace(/^[-0-9]+/, "");
	
	  name = name.replace(/[-\s]+(.)?/g, function (match, c) {
	    return c ? c.toUpperCase() : "";
	  });
	
	  if (!t.isValidIdentifier(name)) {
	    name = "_" + name;
	  }
	
	  return name || "_";
	}
	
	function toBindingIdentifierName(name) {
	  name = toIdentifier(name);
	  if (name === "eval" || name === "arguments") name = "_" + name;
	  return name;
	}
	
	function toStatement(node, ignore) {
	  if (t.isStatement(node)) {
	    return node;
	  }
	
	  var mustHaveId = false;
	  var newType = void 0;
	
	  if (t.isClass(node)) {
	    mustHaveId = true;
	    newType = "ClassDeclaration";
	  } else if (t.isFunction(node)) {
	    mustHaveId = true;
	    newType = "FunctionDeclaration";
	  } else if (t.isAssignmentExpression(node)) {
	    return t.expressionStatement(node);
	  }
	
	  if (mustHaveId && !node.id) {
	    newType = false;
	  }
	
	  if (!newType) {
	    if (ignore) {
	      return false;
	    } else {
	      throw new Error("cannot turn " + node.type + " to a statement");
	    }
	  }
	
	  node.type = newType;
	
	  return node;
	}
	
	function toExpression(node) {
	  if (t.isExpressionStatement(node)) {
	    node = node.expression;
	  }
	
	  if (t.isExpression(node)) {
	    return node;
	  }
	
	  if (t.isClass(node)) {
	    node.type = "ClassExpression";
	  } else if (t.isFunction(node)) {
	    node.type = "FunctionExpression";
	  }
	
	  if (!t.isExpression(node)) {
	    throw new Error("cannot turn " + node.type + " to an expression");
	  }
	
	  return node;
	}
	
	function toBlock(node, parent) {
	  if (t.isBlockStatement(node)) {
	    return node;
	  }
	
	  if (t.isEmptyStatement(node)) {
	    node = [];
	  }
	
	  if (!Array.isArray(node)) {
	    if (!t.isStatement(node)) {
	      if (t.isFunction(parent)) {
	        node = t.returnStatement(node);
	      } else {
	        node = t.expressionStatement(node);
	      }
	    }
	
	    node = [node];
	  }
	
	  return t.blockStatement(node);
	}
	
	function valueToNode(value) {
	  if (value === undefined) {
	    return t.identifier("undefined");
	  }
	
	  if (value === true || value === false) {
	    return t.booleanLiteral(value);
	  }
	
	  if (value === null) {
	    return t.nullLiteral();
	  }
	
	  if (typeof value === "string") {
	    return t.stringLiteral(value);
	  }
	
	  if (typeof value === "number") {
	    return t.numericLiteral(value);
	  }
	
	  if ((0, _isRegExp2.default)(value)) {
	    var pattern = value.source;
	    var flags = value.toString().match(/\/([a-z]+|)$/)[1];
	    return t.regExpLiteral(pattern, flags);
	  }
	
	  if (Array.isArray(value)) {
	    return t.arrayExpression(value.map(t.valueToNode));
	  }
	
	  if ((0, _isPlainObject2.default)(value)) {
	    var props = [];
	    for (var key in value) {
	      var nodeKey = void 0;
	      if (t.isValidIdentifier(key)) {
	        nodeKey = t.identifier(key);
	      } else {
	        nodeKey = t.stringLiteral(key);
	      }
	      props.push(t.objectProperty(nodeKey, t.valueToNode(value[key])));
	    }
	    return t.objectExpression(props);
	  }
	
	  throw new Error("don't know how to turn this value into a node");
	}

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _index = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_index);
	
	var _constants = __webpack_require__(382);
	
	var _index2 = __webpack_require__(92);
	
	var _index3 = _interopRequireDefault(_index2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	(0, _index3.default)("ArrayExpression", {
	  fields: {
	    elements: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeOrValueType)("null", "Expression", "SpreadElement"))),
	      default: []
	    }
	  },
	  visitor: ["elements"],
	  aliases: ["Expression"]
	});
	
	(0, _index3.default)("AssignmentExpression", {
	  fields: {
	    operator: {
	      validate: (0, _index2.assertValueType)("string")
	    },
	    left: {
	      validate: (0, _index2.assertNodeType)("LVal")
	    },
	    right: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    }
	  },
	  builder: ["operator", "left", "right"],
	  visitor: ["left", "right"],
	  aliases: ["Expression"]
	});
	
	(0, _index3.default)("BinaryExpression", {
	  builder: ["operator", "left", "right"],
	  fields: {
	    operator: {
	      validate: _index2.assertOneOf.apply(undefined, _constants.BINARY_OPERATORS)
	    },
	    left: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    },
	    right: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    }
	  },
	  visitor: ["left", "right"],
	  aliases: ["Binary", "Expression"]
	});
	
	(0, _index3.default)("Directive", {
	  visitor: ["value"],
	  fields: {
	    value: {
	      validate: (0, _index2.assertNodeType)("DirectiveLiteral")
	    }
	  }
	});
	
	(0, _index3.default)("DirectiveLiteral", {
	  builder: ["value"],
	  fields: {
	    value: {
	      validate: (0, _index2.assertValueType)("string")
	    }
	  }
	});
	
	(0, _index3.default)("BlockStatement", {
	  builder: ["body", "directives"],
	  visitor: ["directives", "body"],
	  fields: {
	    directives: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Directive"))),
	      default: []
	    },
	    body: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Statement")))
	    }
	  },
	  aliases: ["Scopable", "BlockParent", "Block", "Statement"]
	});
	
	(0, _index3.default)("BreakStatement", {
	  visitor: ["label"],
	  fields: {
	    label: {
	      validate: (0, _index2.assertNodeType)("Identifier"),
	      optional: true
	    }
	  },
	  aliases: ["Statement", "Terminatorless", "CompletionStatement"]
	});
	
	(0, _index3.default)("CallExpression", {
	  visitor: ["callee", "arguments"],
	  fields: {
	    callee: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    },
	    arguments: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Expression", "SpreadElement")))
	    }
	  },
	  aliases: ["Expression"]
	});
	
	(0, _index3.default)("CatchClause", {
	  visitor: ["param", "body"],
	  fields: {
	    param: {
	      validate: (0, _index2.assertNodeType)("Identifier")
	    },
	    body: {
	      validate: (0, _index2.assertNodeType)("BlockStatement")
	    }
	  },
	  aliases: ["Scopable"]
	});
	
	(0, _index3.default)("ConditionalExpression", {
	  visitor: ["test", "consequent", "alternate"],
	  fields: {
	    test: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    },
	    consequent: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    },
	    alternate: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    }
	  },
	  aliases: ["Expression", "Conditional"]
	});
	
	(0, _index3.default)("ContinueStatement", {
	  visitor: ["label"],
	  fields: {
	    label: {
	      validate: (0, _index2.assertNodeType)("Identifier"),
	      optional: true
	    }
	  },
	  aliases: ["Statement", "Terminatorless", "CompletionStatement"]
	});
	
	(0, _index3.default)("DebuggerStatement", {
	  aliases: ["Statement"]
	});
	
	(0, _index3.default)("DoWhileStatement", {
	  visitor: ["test", "body"],
	  fields: {
	    test: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    },
	    body: {
	      validate: (0, _index2.assertNodeType)("Statement")
	    }
	  },
	  aliases: ["Statement", "BlockParent", "Loop", "While", "Scopable"]
	});
	
	(0, _index3.default)("EmptyStatement", {
	  aliases: ["Statement"]
	});
	
	(0, _index3.default)("ExpressionStatement", {
	  visitor: ["expression"],
	  fields: {
	    expression: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    }
	  },
	  aliases: ["Statement", "ExpressionWrapper"]
	});
	
	(0, _index3.default)("File", {
	  builder: ["program", "comments", "tokens"],
	  visitor: ["program"],
	  fields: {
	    program: {
	      validate: (0, _index2.assertNodeType)("Program")
	    }
	  }
	});
	
	(0, _index3.default)("ForInStatement", {
	  visitor: ["left", "right", "body"],
	  aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop", "ForXStatement"],
	  fields: {
	    left: {
	      validate: (0, _index2.assertNodeType)("VariableDeclaration", "LVal")
	    },
	    right: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    },
	    body: {
	      validate: (0, _index2.assertNodeType)("Statement")
	    }
	  }
	});
	
	(0, _index3.default)("ForStatement", {
	  visitor: ["init", "test", "update", "body"],
	  aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop"],
	  fields: {
	    init: {
	      validate: (0, _index2.assertNodeType)("VariableDeclaration", "Expression"),
	      optional: true
	    },
	    test: {
	      validate: (0, _index2.assertNodeType)("Expression"),
	      optional: true
	    },
	    update: {
	      validate: (0, _index2.assertNodeType)("Expression"),
	      optional: true
	    },
	    body: {
	      validate: (0, _index2.assertNodeType)("Statement")
	    }
	  }
	});
	
	(0, _index3.default)("FunctionDeclaration", {
	  builder: ["id", "params", "body", "generator", "async"],
	  visitor: ["id", "params", "body", "returnType", "typeParameters"],
	  fields: {
	    id: {
	      validate: (0, _index2.assertNodeType)("Identifier")
	    },
	    params: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("LVal")))
	    },
	    body: {
	      validate: (0, _index2.assertNodeType)("BlockStatement")
	    },
	    generator: {
	      default: false,
	      validate: (0, _index2.assertValueType)("boolean")
	    },
	    async: {
	      default: false,
	      validate: (0, _index2.assertValueType)("boolean")
	    }
	  },
	  aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Statement", "Pureish", "Declaration"]
	});
	
	(0, _index3.default)("FunctionExpression", {
	  inherits: "FunctionDeclaration",
	  aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Expression", "Pureish"],
	  fields: {
	    id: {
	      validate: (0, _index2.assertNodeType)("Identifier"),
	      optional: true
	    },
	    params: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("LVal")))
	    },
	    body: {
	      validate: (0, _index2.assertNodeType)("BlockStatement")
	    },
	    generator: {
	      default: false,
	      validate: (0, _index2.assertValueType)("boolean")
	    },
	    async: {
	      default: false,
	      validate: (0, _index2.assertValueType)("boolean")
	    }
	  }
	});
	
	(0, _index3.default)("Identifier", {
	  builder: ["name"],
	  visitor: ["typeAnnotation"],
	  aliases: ["Expression", "LVal"],
	  fields: {
	    name: {
	      validate: function validate(node, key, val) {
	        if (!t.isValidIdentifier(val)) {}
	      }
	    },
	    decorators: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Decorator")))
	    }
	  }
	});
	
	(0, _index3.default)("IfStatement", {
	  visitor: ["test", "consequent", "alternate"],
	  aliases: ["Statement", "Conditional"],
	  fields: {
	    test: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    },
	    consequent: {
	      validate: (0, _index2.assertNodeType)("Statement")
	    },
	    alternate: {
	      optional: true,
	      validate: (0, _index2.assertNodeType)("Statement")
	    }
	  }
	});
	
	(0, _index3.default)("LabeledStatement", {
	  visitor: ["label", "body"],
	  aliases: ["Statement"],
	  fields: {
	    label: {
	      validate: (0, _index2.assertNodeType)("Identifier")
	    },
	    body: {
	      validate: (0, _index2.assertNodeType)("Statement")
	    }
	  }
	});
	
	(0, _index3.default)("StringLiteral", {
	  builder: ["value"],
	  fields: {
	    value: {
	      validate: (0, _index2.assertValueType)("string")
	    }
	  },
	  aliases: ["Expression", "Pureish", "Literal", "Immutable"]
	});
	
	(0, _index3.default)("NumericLiteral", {
	  builder: ["value"],
	  deprecatedAlias: "NumberLiteral",
	  fields: {
	    value: {
	      validate: (0, _index2.assertValueType)("number")
	    }
	  },
	  aliases: ["Expression", "Pureish", "Literal", "Immutable"]
	});
	
	(0, _index3.default)("NullLiteral", {
	  aliases: ["Expression", "Pureish", "Literal", "Immutable"]
	});
	
	(0, _index3.default)("BooleanLiteral", {
	  builder: ["value"],
	  fields: {
	    value: {
	      validate: (0, _index2.assertValueType)("boolean")
	    }
	  },
	  aliases: ["Expression", "Pureish", "Literal", "Immutable"]
	});
	
	(0, _index3.default)("RegExpLiteral", {
	  builder: ["pattern", "flags"],
	  deprecatedAlias: "RegexLiteral",
	  aliases: ["Expression", "Literal"],
	  fields: {
	    pattern: {
	      validate: (0, _index2.assertValueType)("string")
	    },
	    flags: {
	      validate: (0, _index2.assertValueType)("string"),
	      default: ""
	    }
	  }
	});
	
	(0, _index3.default)("LogicalExpression", {
	  builder: ["operator", "left", "right"],
	  visitor: ["left", "right"],
	  aliases: ["Binary", "Expression"],
	  fields: {
	    operator: {
	      validate: _index2.assertOneOf.apply(undefined, _constants.LOGICAL_OPERATORS)
	    },
	    left: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    },
	    right: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    }
	  }
	});
	
	(0, _index3.default)("MemberExpression", {
	  builder: ["object", "property", "computed"],
	  visitor: ["object", "property"],
	  aliases: ["Expression", "LVal"],
	  fields: {
	    object: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    },
	    property: {
	      validate: function validate(node, key, val) {
	        var expectedType = node.computed ? "Expression" : "Identifier";
	        (0, _index2.assertNodeType)(expectedType)(node, key, val);
	      }
	    },
	    computed: {
	      default: false
	    }
	  }
	});
	
	(0, _index3.default)("NewExpression", {
	  visitor: ["callee", "arguments"],
	  aliases: ["Expression"],
	  fields: {
	    callee: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    },
	    arguments: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Expression", "SpreadElement")))
	    }
	  }
	});
	
	(0, _index3.default)("Program", {
	  visitor: ["directives", "body"],
	  builder: ["body", "directives"],
	  fields: {
	    directives: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Directive"))),
	      default: []
	    },
	    body: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Statement")))
	    }
	  },
	  aliases: ["Scopable", "BlockParent", "Block", "FunctionParent"]
	});
	
	(0, _index3.default)("ObjectExpression", {
	  visitor: ["properties"],
	  aliases: ["Expression"],
	  fields: {
	    properties: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("ObjectMethod", "ObjectProperty", "SpreadProperty")))
	    }
	  }
	});
	
	(0, _index3.default)("ObjectMethod", {
	  builder: ["kind", "key", "params", "body", "computed"],
	  fields: {
	    kind: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("string"), (0, _index2.assertOneOf)("method", "get", "set")),
	      default: "method"
	    },
	    computed: {
	      validate: (0, _index2.assertValueType)("boolean"),
	      default: false
	    },
	    key: {
	      validate: function validate(node, key, val) {
	        var expectedTypes = node.computed ? ["Expression"] : ["Identifier", "StringLiteral", "NumericLiteral"];
	        _index2.assertNodeType.apply(undefined, expectedTypes)(node, key, val);
	      }
	    },
	    decorators: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Decorator")))
	    },
	    body: {
	      validate: (0, _index2.assertNodeType)("BlockStatement")
	    },
	    generator: {
	      default: false,
	      validate: (0, _index2.assertValueType)("boolean")
	    },
	    async: {
	      default: false,
	      validate: (0, _index2.assertValueType)("boolean")
	    }
	  },
	  visitor: ["key", "params", "body", "decorators", "returnType", "typeParameters"],
	  aliases: ["UserWhitespacable", "Function", "Scopable", "BlockParent", "FunctionParent", "Method", "ObjectMember"]
	});
	
	(0, _index3.default)("ObjectProperty", {
	  builder: ["key", "value", "computed", "shorthand", "decorators"],
	  fields: {
	    computed: {
	      validate: (0, _index2.assertValueType)("boolean"),
	      default: false
	    },
	    key: {
	      validate: function validate(node, key, val) {
	        var expectedTypes = node.computed ? ["Expression"] : ["Identifier", "StringLiteral", "NumericLiteral"];
	        _index2.assertNodeType.apply(undefined, expectedTypes)(node, key, val);
	      }
	    },
	    value: {
	      validate: (0, _index2.assertNodeType)("Expression", "Pattern", "RestElement")
	    },
	    shorthand: {
	      validate: (0, _index2.assertValueType)("boolean"),
	      default: false
	    },
	    decorators: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Decorator"))),
	      optional: true
	    }
	  },
	  visitor: ["key", "value", "decorators"],
	  aliases: ["UserWhitespacable", "Property", "ObjectMember"]
	});
	
	(0, _index3.default)("RestElement", {
	  visitor: ["argument", "typeAnnotation"],
	  aliases: ["LVal"],
	  fields: {
	    argument: {
	      validate: (0, _index2.assertNodeType)("LVal")
	    },
	    decorators: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Decorator")))
	    }
	  }
	});
	
	(0, _index3.default)("ReturnStatement", {
	  visitor: ["argument"],
	  aliases: ["Statement", "Terminatorless", "CompletionStatement"],
	  fields: {
	    argument: {
	      validate: (0, _index2.assertNodeType)("Expression"),
	      optional: true
	    }
	  }
	});
	
	(0, _index3.default)("SequenceExpression", {
	  visitor: ["expressions"],
	  fields: {
	    expressions: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Expression")))
	    }
	  },
	  aliases: ["Expression"]
	});
	
	(0, _index3.default)("SwitchCase", {
	  visitor: ["test", "consequent"],
	  fields: {
	    test: {
	      validate: (0, _index2.assertNodeType)("Expression"),
	      optional: true
	    },
	    consequent: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("Statement")))
	    }
	  }
	});
	
	(0, _index3.default)("SwitchStatement", {
	  visitor: ["discriminant", "cases"],
	  aliases: ["Statement", "BlockParent", "Scopable"],
	  fields: {
	    discriminant: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    },
	    cases: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("SwitchCase")))
	    }
	  }
	});
	
	(0, _index3.default)("ThisExpression", {
	  aliases: ["Expression"]
	});
	
	(0, _index3.default)("ThrowStatement", {
	  visitor: ["argument"],
	  aliases: ["Statement", "Terminatorless", "CompletionStatement"],
	  fields: {
	    argument: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    }
	  }
	});
	
	(0, _index3.default)("TryStatement", {
	  visitor: ["block", "handler", "finalizer"],
	  aliases: ["Statement"],
	  fields: {
	    body: {
	      validate: (0, _index2.assertNodeType)("BlockStatement")
	    },
	    handler: {
	      optional: true,
	      handler: (0, _index2.assertNodeType)("BlockStatement")
	    },
	    finalizer: {
	      optional: true,
	      validate: (0, _index2.assertNodeType)("BlockStatement")
	    }
	  }
	});
	
	(0, _index3.default)("UnaryExpression", {
	  builder: ["operator", "argument", "prefix"],
	  fields: {
	    prefix: {
	      default: true
	    },
	    argument: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    },
	    operator: {
	      validate: _index2.assertOneOf.apply(undefined, _constants.UNARY_OPERATORS)
	    }
	  },
	  visitor: ["argument"],
	  aliases: ["UnaryLike", "Expression"]
	});
	
	(0, _index3.default)("UpdateExpression", {
	  builder: ["operator", "argument", "prefix"],
	  fields: {
	    prefix: {
	      default: false
	    },
	    argument: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    },
	    operator: {
	      validate: _index2.assertOneOf.apply(undefined, _constants.UPDATE_OPERATORS)
	    }
	  },
	  visitor: ["argument"],
	  aliases: ["Expression"]
	});
	
	(0, _index3.default)("VariableDeclaration", {
	  builder: ["kind", "declarations"],
	  visitor: ["declarations"],
	  aliases: ["Statement", "Declaration"],
	  fields: {
	    kind: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("string"), (0, _index2.assertOneOf)("var", "let", "const"))
	    },
	    declarations: {
	      validate: (0, _index2.chain)((0, _index2.assertValueType)("array"), (0, _index2.assertEach)((0, _index2.assertNodeType)("VariableDeclarator")))
	    }
	  }
	});
	
	(0, _index3.default)("VariableDeclarator", {
	  visitor: ["id", "init"],
	  fields: {
	    id: {
	      validate: (0, _index2.assertNodeType)("LVal")
	    },
	    init: {
	      optional: true,
	      validate: (0, _index2.assertNodeType)("Expression")
	    }
	  }
	});
	
	(0, _index3.default)("WhileStatement", {
	  visitor: ["test", "body"],
	  aliases: ["Statement", "BlockParent", "Loop", "While", "Scopable"],
	  fields: {
	    test: {
	      validate: (0, _index2.assertNodeType)("Expression")
	    },
	    body: {
	      validate: (0, _index2.assertNodeType)("BlockStatement", "Statement")
	    }
	  }
	});
	
	(0, _index3.default)("WithStatement", {
	  visitor: ["object", "body"],
	  aliases: ["Statement"],
	  fields: {
	    object: {
	      object: (0, _index2.assertNodeType)("Expression")
	    },
	    body: {
	      validate: (0, _index2.assertNodeType)("BlockStatement", "Statement")
	    }
	  }
	});

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _index = __webpack_require__(92);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _index2.default)("AssignmentPattern", {
	  visitor: ["left", "right"],
	  aliases: ["Pattern", "LVal"],
	  fields: {
	    left: {
	      validate: (0, _index.assertNodeType)("Identifier")
	    },
	    right: {
	      validate: (0, _index.assertNodeType)("Expression")
	    },
	    decorators: {
	      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("Decorator")))
	    }
	  }
	});
	
	(0, _index2.default)("ArrayPattern", {
	  visitor: ["elements", "typeAnnotation"],
	  aliases: ["Pattern", "LVal"],
	  fields: {
	    elements: {
	      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("Identifier", "Pattern", "RestElement")))
	    },
	    decorators: {
	      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("Decorator")))
	    }
	  }
	});
	
	(0, _index2.default)("ArrowFunctionExpression", {
	  builder: ["params", "body", "async"],
	  visitor: ["params", "body", "returnType", "typeParameters"],
	  aliases: ["Scopable", "Function", "BlockParent", "FunctionParent", "Expression", "Pureish"],
	  fields: {
	    params: {
	      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("LVal")))
	    },
	    body: {
	      validate: (0, _index.assertNodeType)("BlockStatement", "Expression")
	    },
	    async: {
	      validate: (0, _index.assertValueType)("boolean"),
	      default: false
	    }
	  }
	});
	
	(0, _index2.default)("ClassBody", {
	  visitor: ["body"],
	  fields: {
	    body: {
	      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("ClassMethod", "ClassProperty")))
	    }
	  }
	});
	
	(0, _index2.default)("ClassDeclaration", {
	  builder: ["id", "superClass", "body", "decorators"],
	  visitor: ["id", "body", "superClass", "mixins", "typeParameters", "superTypeParameters", "implements", "decorators"],
	  aliases: ["Scopable", "Class", "Statement", "Declaration", "Pureish"],
	  fields: {
	    id: {
	      validate: (0, _index.assertNodeType)("Identifier")
	    },
	    body: {
	      validate: (0, _index.assertNodeType)("ClassBody")
	    },
	    superClass: {
	      optional: true,
	      validate: (0, _index.assertNodeType)("Expression")
	    },
	    decorators: {
	      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("Decorator")))
	    }
	  }
	});
	
	(0, _index2.default)("ClassExpression", {
	  inherits: "ClassDeclaration",
	  aliases: ["Scopable", "Class", "Expression", "Pureish"],
	  fields: {
	    id: {
	      optional: true,
	      validate: (0, _index.assertNodeType)("Identifier")
	    },
	    body: {
	      validate: (0, _index.assertNodeType)("ClassBody")
	    },
	    superClass: {
	      optional: true,
	      validate: (0, _index.assertNodeType)("Expression")
	    },
	    decorators: {
	      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("Decorator")))
	    }
	  }
	});
	
	(0, _index2.default)("ExportAllDeclaration", {
	  visitor: ["source"],
	  aliases: ["Statement", "Declaration", "ModuleDeclaration", "ExportDeclaration"],
	  fields: {
	    source: {
	      validate: (0, _index.assertNodeType)("StringLiteral")
	    }
	  }
	});
	
	(0, _index2.default)("ExportDefaultDeclaration", {
	  visitor: ["declaration"],
	  aliases: ["Statement", "Declaration", "ModuleDeclaration", "ExportDeclaration"],
	  fields: {
	    declaration: {
	      validate: (0, _index.assertNodeType)("FunctionDeclaration", "ClassDeclaration", "Expression")
	    }
	  }
	});
	
	(0, _index2.default)("ExportNamedDeclaration", {
	  visitor: ["declaration", "specifiers", "source"],
	  aliases: ["Statement", "Declaration", "ModuleDeclaration", "ExportDeclaration"],
	  fields: {
	    declaration: {
	      validate: (0, _index.assertNodeType)("Declaration"),
	      optional: true
	    },
	    specifiers: {
	      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("ExportSpecifier")))
	    },
	    source: {
	      validate: (0, _index.assertNodeType)("StringLiteral"),
	      optional: true
	    }
	  }
	});
	
	(0, _index2.default)("ExportSpecifier", {
	  visitor: ["local", "exported"],
	  aliases: ["ModuleSpecifier"],
	  fields: {
	    local: {
	      validate: (0, _index.assertNodeType)("Identifier")
	    },
	    exported: {
	      validate: (0, _index.assertNodeType)("Identifier")
	    }
	  }
	});
	
	(0, _index2.default)("ForOfStatement", {
	  visitor: ["left", "right", "body"],
	  aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop", "ForXStatement"],
	  fields: {
	    left: {
	      validate: (0, _index.assertNodeType)("VariableDeclaration", "LVal")
	    },
	    right: {
	      validate: (0, _index.assertNodeType)("Expression")
	    },
	    body: {
	      validate: (0, _index.assertNodeType)("Statement")
	    }
	  }
	});
	
	(0, _index2.default)("ImportDeclaration", {
	  visitor: ["specifiers", "source"],
	  aliases: ["Statement", "Declaration", "ModuleDeclaration"],
	  fields: {
	    specifiers: {
	      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("ImportSpecifier", "ImportDefaultSpecifier", "ImportNamespaceSpecifier")))
	    },
	    source: {
	      validate: (0, _index.assertNodeType)("StringLiteral")
	    }
	  }
	});
	
	(0, _index2.default)("ImportDefaultSpecifier", {
	  visitor: ["local"],
	  aliases: ["ModuleSpecifier"],
	  fields: {
	    local: {
	      validate: (0, _index.assertNodeType)("Identifier")
	    }
	  }
	});
	
	(0, _index2.default)("ImportNamespaceSpecifier", {
	  visitor: ["local"],
	  aliases: ["ModuleSpecifier"],
	  fields: {
	    local: {
	      validate: (0, _index.assertNodeType)("Identifier")
	    }
	  }
	});
	
	(0, _index2.default)("ImportSpecifier", {
	  visitor: ["local", "imported"],
	  aliases: ["ModuleSpecifier"],
	  fields: {
	    local: {
	      validate: (0, _index.assertNodeType)("Identifier")
	    },
	    imported: {
	      validate: (0, _index.assertNodeType)("Identifier")
	    },
	    importKind: {
	      validate: (0, _index.assertOneOf)(null, "type", "typeof")
	    }
	  }
	});
	
	(0, _index2.default)("MetaProperty", {
	  visitor: ["meta", "property"],
	  aliases: ["Expression"],
	  fields: {
	    meta: {
	      validate: (0, _index.assertValueType)("string")
	    },
	    property: {
	      validate: (0, _index.assertValueType)("string")
	    }
	  }
	});
	
	(0, _index2.default)("ClassMethod", {
	  aliases: ["Function", "Scopable", "BlockParent", "FunctionParent", "Method"],
	  builder: ["kind", "key", "params", "body", "computed", "static"],
	  visitor: ["key", "params", "body", "decorators", "returnType", "typeParameters"],
	  fields: {
	    kind: {
	      validate: (0, _index.chain)((0, _index.assertValueType)("string"), (0, _index.assertOneOf)("get", "set", "method", "constructor")),
	      default: "method"
	    },
	    computed: {
	      default: false,
	      validate: (0, _index.assertValueType)("boolean")
	    },
	    static: {
	      default: false,
	      validate: (0, _index.assertValueType)("boolean")
	    },
	    key: {
	      validate: function validate(node, key, val) {
	        var expectedTypes = node.computed ? ["Expression"] : ["Identifier", "StringLiteral", "NumericLiteral"];
	        _index.assertNodeType.apply(undefined, expectedTypes)(node, key, val);
	      }
	    },
	    params: {
	      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("LVal")))
	    },
	    body: {
	      validate: (0, _index.assertNodeType)("BlockStatement")
	    },
	    generator: {
	      default: false,
	      validate: (0, _index.assertValueType)("boolean")
	    },
	    async: {
	      default: false,
	      validate: (0, _index.assertValueType)("boolean")
	    }
	  }
	});
	
	(0, _index2.default)("ObjectPattern", {
	  visitor: ["properties", "typeAnnotation"],
	  aliases: ["Pattern", "LVal"],
	  fields: {
	    properties: {
	      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("RestProperty", "Property")))
	    },
	    decorators: {
	      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("Decorator")))
	    }
	  }
	});
	
	(0, _index2.default)("SpreadElement", {
	  visitor: ["argument"],
	  aliases: ["UnaryLike"],
	  fields: {
	    argument: {
	      validate: (0, _index.assertNodeType)("Expression")
	    }
	  }
	});
	
	(0, _index2.default)("Super", {
	  aliases: ["Expression"]
	});
	
	(0, _index2.default)("TaggedTemplateExpression", {
	  visitor: ["tag", "quasi"],
	  aliases: ["Expression"],
	  fields: {
	    tag: {
	      validate: (0, _index.assertNodeType)("Expression")
	    },
	    quasi: {
	      validate: (0, _index.assertNodeType)("TemplateLiteral")
	    }
	  }
	});
	
	(0, _index2.default)("TemplateElement", {
	  builder: ["value", "tail"],
	  fields: {
	    value: {},
	    tail: {
	      validate: (0, _index.assertValueType)("boolean"),
	      default: false
	    }
	  }
	});
	
	(0, _index2.default)("TemplateLiteral", {
	  visitor: ["quasis", "expressions"],
	  aliases: ["Expression", "Literal"],
	  fields: {
	    quasis: {
	      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("TemplateElement")))
	    },
	    expressions: {
	      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("Expression")))
	    }
	  }
	});
	
	(0, _index2.default)("YieldExpression", {
	  builder: ["argument", "delegate"],
	  visitor: ["argument"],
	  aliases: ["Expression", "Terminatorless"],
	  fields: {
	    delegate: {
	      validate: (0, _index.assertValueType)("boolean"),
	      default: false
	    },
	    argument: {
	      optional: true,
	      validate: (0, _index.assertNodeType)("Expression")
	    }
	  }
	});

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _index = __webpack_require__(92);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _index2.default)("AwaitExpression", {
	  builder: ["argument"],
	  visitor: ["argument"],
	  aliases: ["Expression", "Terminatorless"],
	  fields: {
	    argument: {
	      validate: (0, _index.assertNodeType)("Expression")
	    }
	  }
	});
	
	(0, _index2.default)("ForAwaitStatement", {
	  visitor: ["left", "right", "body"],
	  aliases: ["Scopable", "Statement", "For", "BlockParent", "Loop", "ForXStatement"],
	  fields: {
	    left: {
	      validate: (0, _index.assertNodeType)("VariableDeclaration", "LVal")
	    },
	    right: {
	      validate: (0, _index.assertNodeType)("Expression")
	    },
	    body: {
	      validate: (0, _index.assertNodeType)("Statement")
	    }
	  }
	});
	
	(0, _index2.default)("BindExpression", {
	  visitor: ["object", "callee"],
	  aliases: ["Expression"],
	  fields: {}
	});
	
	(0, _index2.default)("Import", {
	  aliases: ["Expression"]
	});
	
	(0, _index2.default)("Decorator", {
	  visitor: ["expression"],
	  fields: {
	    expression: {
	      validate: (0, _index.assertNodeType)("Expression")
	    }
	  }
	});
	
	(0, _index2.default)("DoExpression", {
	  visitor: ["body"],
	  aliases: ["Expression"],
	  fields: {
	    body: {
	      validate: (0, _index.assertNodeType)("BlockStatement")
	    }
	  }
	});
	
	(0, _index2.default)("ExportDefaultSpecifier", {
	  visitor: ["exported"],
	  aliases: ["ModuleSpecifier"],
	  fields: {
	    exported: {
	      validate: (0, _index.assertNodeType)("Identifier")
	    }
	  }
	});
	
	(0, _index2.default)("ExportNamespaceSpecifier", {
	  visitor: ["exported"],
	  aliases: ["ModuleSpecifier"],
	  fields: {
	    exported: {
	      validate: (0, _index.assertNodeType)("Identifier")
	    }
	  }
	});
	
	(0, _index2.default)("RestProperty", {
	  visitor: ["argument"],
	  aliases: ["UnaryLike"],
	  fields: {
	    argument: {
	      validate: (0, _index.assertNodeType)("LVal")
	    }
	  }
	});
	
	(0, _index2.default)("SpreadProperty", {
	  visitor: ["argument"],
	  aliases: ["UnaryLike"],
	  fields: {
	    argument: {
	      validate: (0, _index.assertNodeType)("Expression")
	    }
	  }
	});

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _index = __webpack_require__(92);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _index2.default)("AnyTypeAnnotation", {
	  aliases: ["Flow", "FlowBaseAnnotation"],
	  fields: {}
	});
	
	(0, _index2.default)("ArrayTypeAnnotation", {
	  visitor: ["elementType"],
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("BooleanTypeAnnotation", {
	  aliases: ["Flow", "FlowBaseAnnotation"],
	  fields: {}
	});
	
	(0, _index2.default)("BooleanLiteralTypeAnnotation", {
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("NullLiteralTypeAnnotation", {
	  aliases: ["Flow", "FlowBaseAnnotation"],
	  fields: {}
	});
	
	(0, _index2.default)("ClassImplements", {
	  visitor: ["id", "typeParameters"],
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("ClassProperty", {
	  visitor: ["key", "value", "typeAnnotation", "decorators"],
	  builder: ["key", "value", "typeAnnotation", "decorators", "computed"],
	  aliases: ["Property"],
	  fields: {
	    computed: {
	      validate: (0, _index.assertValueType)("boolean"),
	      default: false
	    }
	  }
	});
	
	(0, _index2.default)("DeclareClass", {
	  visitor: ["id", "typeParameters", "extends", "body"],
	  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
	  fields: {}
	});
	
	(0, _index2.default)("DeclareFunction", {
	  visitor: ["id"],
	  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
	  fields: {}
	});
	
	(0, _index2.default)("DeclareInterface", {
	  visitor: ["id", "typeParameters", "extends", "body"],
	  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
	  fields: {}
	});
	
	(0, _index2.default)("DeclareModule", {
	  visitor: ["id", "body"],
	  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
	  fields: {}
	});
	
	(0, _index2.default)("DeclareModuleExports", {
	  visitor: ["typeAnnotation"],
	  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
	  fields: {}
	});
	
	(0, _index2.default)("DeclareTypeAlias", {
	  visitor: ["id", "typeParameters", "right"],
	  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
	  fields: {}
	});
	
	(0, _index2.default)("DeclareOpaqueType", {
	  visitor: ["id", "typeParameters", "supertype"],
	  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
	  fields: {}
	});
	
	(0, _index2.default)("DeclareVariable", {
	  visitor: ["id"],
	  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
	  fields: {}
	});
	
	(0, _index2.default)("DeclareExportDeclaration", {
	  visitor: ["declaration", "specifiers", "source"],
	  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
	  fields: {}
	});
	
	(0, _index2.default)("ExistentialTypeParam", {
	  aliases: ["Flow"]
	});
	
	(0, _index2.default)("FunctionTypeAnnotation", {
	  visitor: ["typeParameters", "params", "rest", "returnType"],
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("FunctionTypeParam", {
	  visitor: ["name", "typeAnnotation"],
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("GenericTypeAnnotation", {
	  visitor: ["id", "typeParameters"],
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("InterfaceExtends", {
	  visitor: ["id", "typeParameters"],
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("InterfaceDeclaration", {
	  visitor: ["id", "typeParameters", "extends", "body"],
	  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
	  fields: {}
	});
	
	(0, _index2.default)("IntersectionTypeAnnotation", {
	  visitor: ["types"],
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("MixedTypeAnnotation", {
	  aliases: ["Flow", "FlowBaseAnnotation"]
	});
	
	(0, _index2.default)("EmptyTypeAnnotation", {
	  aliases: ["Flow", "FlowBaseAnnotation"]
	});
	
	(0, _index2.default)("NullableTypeAnnotation", {
	  visitor: ["typeAnnotation"],
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("NumericLiteralTypeAnnotation", {
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("NumberTypeAnnotation", {
	  aliases: ["Flow", "FlowBaseAnnotation"],
	  fields: {}
	});
	
	(0, _index2.default)("StringLiteralTypeAnnotation", {
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("StringTypeAnnotation", {
	  aliases: ["Flow", "FlowBaseAnnotation"],
	  fields: {}
	});
	
	(0, _index2.default)("ThisTypeAnnotation", {
	  aliases: ["Flow", "FlowBaseAnnotation"],
	  fields: {}
	});
	
	(0, _index2.default)("TupleTypeAnnotation", {
	  visitor: ["types"],
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("TypeofTypeAnnotation", {
	  visitor: ["argument"],
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("TypeAlias", {
	  visitor: ["id", "typeParameters", "right"],
	  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
	  fields: {}
	});
	
	(0, _index2.default)("OpaqueType", {
	  visitor: ["id", "typeParameters", "impltype", "supertype"],
	  aliases: ["Flow", "FlowDeclaration", "Statement", "Declaration"],
	  fields: {}
	});
	
	(0, _index2.default)("TypeAnnotation", {
	  visitor: ["typeAnnotation"],
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("TypeCastExpression", {
	  visitor: ["expression", "typeAnnotation"],
	  aliases: ["Flow", "ExpressionWrapper", "Expression"],
	  fields: {}
	});
	
	(0, _index2.default)("TypeParameter", {
	  visitor: ["bound"],
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("TypeParameterDeclaration", {
	  visitor: ["params"],
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("TypeParameterInstantiation", {
	  visitor: ["params"],
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("ObjectTypeAnnotation", {
	  visitor: ["properties", "indexers", "callProperties"],
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("ObjectTypeCallProperty", {
	  visitor: ["value"],
	  aliases: ["Flow", "UserWhitespacable"],
	  fields: {}
	});
	
	(0, _index2.default)("ObjectTypeIndexer", {
	  visitor: ["id", "key", "value"],
	  aliases: ["Flow", "UserWhitespacable"],
	  fields: {}
	});
	
	(0, _index2.default)("ObjectTypeProperty", {
	  visitor: ["key", "value"],
	  aliases: ["Flow", "UserWhitespacable"],
	  fields: {}
	});
	
	(0, _index2.default)("ObjectTypeSpreadProperty", {
	  visitor: ["argument"],
	  aliases: ["Flow", "UserWhitespacable"],
	  fields: {}
	});
	
	(0, _index2.default)("QualifiedTypeIdentifier", {
	  visitor: ["id", "qualification"],
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("UnionTypeAnnotation", {
	  visitor: ["types"],
	  aliases: ["Flow"],
	  fields: {}
	});
	
	(0, _index2.default)("VoidTypeAnnotation", {
	  aliases: ["Flow", "FlowBaseAnnotation"],
	  fields: {}
	});

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(92);
	
	__webpack_require__(991);
	
	__webpack_require__(992);
	
	__webpack_require__(994);
	
	__webpack_require__(996);
	
	__webpack_require__(997);
	
	__webpack_require__(993);

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _index = __webpack_require__(92);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _index2.default)("JSXAttribute", {
	  visitor: ["name", "value"],
	  aliases: ["JSX", "Immutable"],
	  fields: {
	    name: {
	      validate: (0, _index.assertNodeType)("JSXIdentifier", "JSXNamespacedName")
	    },
	    value: {
	      optional: true,
	      validate: (0, _index.assertNodeType)("JSXElement", "StringLiteral", "JSXExpressionContainer")
	    }
	  }
	});
	
	(0, _index2.default)("JSXClosingElement", {
	  visitor: ["name"],
	  aliases: ["JSX", "Immutable"],
	  fields: {
	    name: {
	      validate: (0, _index.assertNodeType)("JSXIdentifier", "JSXMemberExpression")
	    }
	  }
	});
	
	(0, _index2.default)("JSXElement", {
	  builder: ["openingElement", "closingElement", "children", "selfClosing"],
	  visitor: ["openingElement", "children", "closingElement"],
	  aliases: ["JSX", "Immutable", "Expression"],
	  fields: {
	    openingElement: {
	      validate: (0, _index.assertNodeType)("JSXOpeningElement")
	    },
	    closingElement: {
	      optional: true,
	      validate: (0, _index.assertNodeType)("JSXClosingElement")
	    },
	    children: {
	      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("JSXText", "JSXExpressionContainer", "JSXSpreadChild", "JSXElement")))
	    }
	  }
	});
	
	(0, _index2.default)("JSXEmptyExpression", {
	  aliases: ["JSX", "Expression"]
	});
	
	(0, _index2.default)("JSXExpressionContainer", {
	  visitor: ["expression"],
	  aliases: ["JSX", "Immutable"],
	  fields: {
	    expression: {
	      validate: (0, _index.assertNodeType)("Expression")
	    }
	  }
	});
	
	(0, _index2.default)("JSXSpreadChild", {
	  visitor: ["expression"],
	  aliases: ["JSX", "Immutable"],
	  fields: {
	    expression: {
	      validate: (0, _index.assertNodeType)("Expression")
	    }
	  }
	});
	
	(0, _index2.default)("JSXIdentifier", {
	  builder: ["name"],
	  aliases: ["JSX", "Expression"],
	  fields: {
	    name: {
	      validate: (0, _index.assertValueType)("string")
	    }
	  }
	});
	
	(0, _index2.default)("JSXMemberExpression", {
	  visitor: ["object", "property"],
	  aliases: ["JSX", "Expression"],
	  fields: {
	    object: {
	      validate: (0, _index.assertNodeType)("JSXMemberExpression", "JSXIdentifier")
	    },
	    property: {
	      validate: (0, _index.assertNodeType)("JSXIdentifier")
	    }
	  }
	});
	
	(0, _index2.default)("JSXNamespacedName", {
	  visitor: ["namespace", "name"],
	  aliases: ["JSX"],
	  fields: {
	    namespace: {
	      validate: (0, _index.assertNodeType)("JSXIdentifier")
	    },
	    name: {
	      validate: (0, _index.assertNodeType)("JSXIdentifier")
	    }
	  }
	});
	
	(0, _index2.default)("JSXOpeningElement", {
	  builder: ["name", "attributes", "selfClosing"],
	  visitor: ["name", "attributes"],
	  aliases: ["JSX", "Immutable"],
	  fields: {
	    name: {
	      validate: (0, _index.assertNodeType)("JSXIdentifier", "JSXMemberExpression")
	    },
	    selfClosing: {
	      default: false,
	      validate: (0, _index.assertValueType)("boolean")
	    },
	    attributes: {
	      validate: (0, _index.chain)((0, _index.assertValueType)("array"), (0, _index.assertEach)((0, _index.assertNodeType)("JSXAttribute", "JSXSpreadAttribute")))
	    }
	  }
	});
	
	(0, _index2.default)("JSXSpreadAttribute", {
	  visitor: ["argument"],
	  aliases: ["JSX"],
	  fields: {
	    argument: {
	      validate: (0, _index.assertNodeType)("Expression")
	    }
	  }
	});
	
	(0, _index2.default)("JSXText", {
	  aliases: ["JSX", "Immutable"],
	  builder: ["value"],
	  fields: {
	    value: {
	      validate: (0, _index.assertValueType)("string")
	    }
	  }
	});

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _index = __webpack_require__(92);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _index2.default)("Noop", {
	  visitor: []
	});
	
	(0, _index2.default)("ParenthesizedExpression", {
	  visitor: ["expression"],
	  aliases: ["Expression", "ExpressionWrapper"],
	  fields: {
	    expression: {
	      validate: (0, _index.assertNodeType)("Expression")
	    }
	  }
	});

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createUnionTypeAnnotation = createUnionTypeAnnotation;
	exports.removeTypeDuplicates = removeTypeDuplicates;
	exports.createTypeAnnotationBasedOnTypeof = createTypeAnnotationBasedOnTypeof;
	
	var _index = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function createUnionTypeAnnotation(types) {
	  var flattened = removeTypeDuplicates(types);
	
	  if (flattened.length === 1) {
	    return flattened[0];
	  } else {
	    return t.unionTypeAnnotation(flattened);
	  }
	}
	
	function removeTypeDuplicates(nodes) {
	  var generics = {};
	  var bases = {};
	
	  var typeGroups = [];
	
	  var types = [];
	
	  for (var i = 0; i < nodes.length; i++) {
	    var node = nodes[i];
	    if (!node) continue;
	
	    if (types.indexOf(node) >= 0) {
	      continue;
	    }
	
	    if (t.isAnyTypeAnnotation(node)) {
	      return [node];
	    }
	
	    if (t.isFlowBaseAnnotation(node)) {
	      bases[node.type] = node;
	      continue;
	    }
	
	    if (t.isUnionTypeAnnotation(node)) {
	      if (typeGroups.indexOf(node.types) < 0) {
	        nodes = nodes.concat(node.types);
	        typeGroups.push(node.types);
	      }
	      continue;
	    }
	
	    if (t.isGenericTypeAnnotation(node)) {
	      var name = node.id.name;
	
	      if (generics[name]) {
	        var existing = generics[name];
	        if (existing.typeParameters) {
	          if (node.typeParameters) {
	            existing.typeParameters.params = removeTypeDuplicates(existing.typeParameters.params.concat(node.typeParameters.params));
	          }
	        } else {
	          existing = node.typeParameters;
	        }
	      } else {
	        generics[name] = node;
	      }
	
	      continue;
	    }
	
	    types.push(node);
	  }
	
	  for (var type in bases) {
	    types.push(bases[type]);
	  }
	
	  for (var _name in generics) {
	    types.push(generics[_name]);
	  }
	
	  return types;
	}
	
	function createTypeAnnotationBasedOnTypeof(type) {
	  if (type === "string") {
	    return t.stringTypeAnnotation();
	  } else if (type === "number") {
	    return t.numberTypeAnnotation();
	  } else if (type === "undefined") {
	    return t.voidTypeAnnotation();
	  } else if (type === "boolean") {
	    return t.booleanTypeAnnotation();
	  } else if (type === "function") {
	    return t.genericTypeAnnotation(t.identifier("Function"));
	  } else if (type === "object") {
	    return t.genericTypeAnnotation(t.identifier("Object"));
	  } else if (type === "symbol") {
	    return t.genericTypeAnnotation(t.identifier("Symbol"));
	  } else {
	    throw new Error("Invalid typeof value");
	  }
	}

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.isReactComponent = undefined;
	exports.isCompatTag = isCompatTag;
	exports.buildChildren = buildChildren;
	
	var _index = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var isReactComponent = exports.isReactComponent = t.buildMatchMemberExpression("React.Component");
	
	function isCompatTag(tagName) {
	  return !!tagName && /^[a-z]|\-/.test(tagName);
	}
	
	function cleanJSXElementLiteralChild(child, args) {
	  var lines = child.value.split(/\r\n|\n|\r/);
	
	  var lastNonEmptyLine = 0;
	
	  for (var i = 0; i < lines.length; i++) {
	    if (lines[i].match(/[^ \t]/)) {
	      lastNonEmptyLine = i;
	    }
	  }
	
	  var str = "";
	
	  for (var _i = 0; _i < lines.length; _i++) {
	    var line = lines[_i];
	
	    var isFirstLine = _i === 0;
	    var isLastLine = _i === lines.length - 1;
	    var isLastNonEmptyLine = _i === lastNonEmptyLine;
	
	    var trimmedLine = line.replace(/\t/g, " ");
	
	    if (!isFirstLine) {
	      trimmedLine = trimmedLine.replace(/^[ ]+/, "");
	    }
	
	    if (!isLastLine) {
	      trimmedLine = trimmedLine.replace(/[ ]+$/, "");
	    }
	
	    if (trimmedLine) {
	      if (!isLastNonEmptyLine) {
	        trimmedLine += " ";
	      }
	
	      str += trimmedLine;
	    }
	  }
	
	  if (str) args.push(t.stringLiteral(str));
	}
	
	function buildChildren(node) {
	  var elems = [];
	
	  for (var i = 0; i < node.children.length; i++) {
	    var child = node.children[i];
	
	    if (t.isJSXText(child)) {
	      cleanJSXElementLiteralChild(child, elems);
	      continue;
	    }
	
	    if (t.isJSXExpressionContainer(child)) child = child.expression;
	    if (t.isJSXEmptyExpression(child)) continue;
	
	    elems.push(child);
	  }
	
	  return elems;
	}

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _keys = __webpack_require__(90);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(124);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.isBinding = isBinding;
	exports.isReferenced = isReferenced;
	exports.isValidIdentifier = isValidIdentifier;
	exports.isLet = isLet;
	exports.isBlockScoped = isBlockScoped;
	exports.isVar = isVar;
	exports.isSpecifierDefault = isSpecifierDefault;
	exports.isScope = isScope;
	exports.isImmutable = isImmutable;
	exports.isNodesEquivalent = isNodesEquivalent;
	
	var _retrievers = __webpack_require__(553);
	
	var _esutils = __webpack_require__(413);
	
	var _esutils2 = _interopRequireDefault(_esutils);
	
	var _index = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_index);
	
	var _constants = __webpack_require__(382);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBinding(node, parent) {
	  var keys = _retrievers.getBindingIdentifiers.keys[parent.type];
	  if (keys) {
	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];
	      var val = parent[key];
	      if (Array.isArray(val)) {
	        if (val.indexOf(node) >= 0) return true;
	      } else {
	        if (val === node) return true;
	      }
	    }
	  }
	
	  return false;
	}
	
	function isReferenced(node, parent) {
	  switch (parent.type) {
	    case "BindExpression":
	      return parent.object === node || parent.callee === node;
	
	    case "MemberExpression":
	    case "JSXMemberExpression":
	      if (parent.property === node && parent.computed) {
	        return true;
	      } else if (parent.object === node) {
	        return true;
	      } else {
	        return false;
	      }
	
	    case "MetaProperty":
	      return false;
	
	    case "ObjectProperty":
	      if (parent.key === node) {
	        return parent.computed;
	      }
	
	    case "VariableDeclarator":
	      return parent.id !== node;
	
	    case "ArrowFunctionExpression":
	    case "FunctionDeclaration":
	    case "FunctionExpression":
	      for (var _iterator = parent.params, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var param = _ref;
	
	        if (param === node) return false;
	      }
	
	      return parent.id !== node;
	
	    case "ExportSpecifier":
	      if (parent.source) {
	        return false;
	      } else {
	        return parent.local === node;
	      }
	
	    case "ExportNamespaceSpecifier":
	    case "ExportDefaultSpecifier":
	      return false;
	
	    case "JSXAttribute":
	      return parent.name !== node;
	
	    case "ClassProperty":
	      if (parent.key === node) {
	        return parent.computed;
	      } else {
	        return parent.value === node;
	      }
	
	    case "ImportDefaultSpecifier":
	    case "ImportNamespaceSpecifier":
	    case "ImportSpecifier":
	      return false;
	
	    case "ClassDeclaration":
	    case "ClassExpression":
	      return parent.id !== node;
	
	    case "ClassMethod":
	    case "ObjectMethod":
	      return parent.key === node && parent.computed;
	
	    case "LabeledStatement":
	      return false;
	
	    case "CatchClause":
	      return parent.param !== node;
	
	    case "RestElement":
	      return false;
	
	    case "AssignmentExpression":
	      return parent.right === node;
	
	    case "AssignmentPattern":
	      return parent.right === node;
	
	    case "ObjectPattern":
	    case "ArrayPattern":
	      return false;
	  }
	
	  return true;
	}
	
	function isValidIdentifier(name) {
	  if (typeof name !== "string" || _esutils2.default.keyword.isReservedWordES6(name, true)) {
	    return false;
	  } else if (name === "await") {
	    return false;
	  } else {
	    return _esutils2.default.keyword.isIdentifierNameES6(name);
	  }
	}
	
	function isLet(node) {
	  return t.isVariableDeclaration(node) && (node.kind !== "var" || node[_constants.BLOCK_SCOPED_SYMBOL]);
	}
	
	function isBlockScoped(node) {
	  return t.isFunctionDeclaration(node) || t.isClassDeclaration(node) || t.isLet(node);
	}
	
	function isVar(node) {
	  return t.isVariableDeclaration(node, { kind: "var" }) && !node[_constants.BLOCK_SCOPED_SYMBOL];
	}
	
	function isSpecifierDefault(specifier) {
	  return t.isImportDefaultSpecifier(specifier) || t.isIdentifier(specifier.imported || specifier.exported, { name: "default" });
	}
	
	function isScope(node, parent) {
	  if (t.isBlockStatement(node) && t.isFunction(parent, { body: node })) {
	    return false;
	  }
	
	  return t.isScopable(node);
	}
	
	function isImmutable(node) {
	  if (t.isType(node.type, "Immutable")) return true;
	
	  if (t.isIdentifier(node)) {
	    if (node.name === "undefined") {
	      return true;
	    } else {
	      return false;
	    }
	  }
	
	  return false;
	}
	
	function isNodesEquivalent(a, b) {
	  if ((typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) !== "object" || (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) !== "object" || a == null || b == null) {
	    return a === b;
	  }
	
	  if (a.type !== b.type) {
	    return false;
	  }
	
	  var fields = (0, _keys2.default)(t.NODE_FIELDS[a.type] || a.type);
	
	  for (var _iterator2 = fields, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
	    var _ref2;
	
	    if (_isArray2) {
	      if (_i2 >= _iterator2.length) break;
	      _ref2 = _iterator2[_i2++];
	    } else {
	      _i2 = _iterator2.next();
	      if (_i2.done) break;
	      _ref2 = _i2.value;
	    }
	
	    var field = _ref2;
	
	    if ((0, _typeof3.default)(a[field]) !== (0, _typeof3.default)(b[field])) {
	      return false;
	    }
	
	    if (Array.isArray(a[field])) {
	      if (!Array.isArray(b[field])) {
	        return false;
	      }
	      if (a[field].length !== b[field].length) {
	        return false;
	      }
	
	      for (var i = 0; i < a[field].length; i++) {
	        if (!isNodesEquivalent(a[field][i], b[field][i])) {
	          return false;
	        }
	      }
	      continue;
	    }
	
	    if (!isNodesEquivalent(a[field], b[field])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

	exports.defaults = {};
	
	exports.set = function(name, value, options) {
	  // Retrieve options and defaults
	  var opts = options || {};
	  var defaults = exports.defaults;
	
	  // Apply default value for unspecified options
	  var expires  = opts.expires  || defaults.expires;
	  var domain   = opts.domain   || defaults.domain;
	  var path     = opts.path     !== undefined ? opts.path     : (defaults.path !== undefined ? defaults.path : '/');
	  var secure   = opts.secure   !== undefined ? opts.secure   : defaults.secure;
	  var httponly = opts.httponly !== undefined ? opts.httponly : defaults.httponly;
	  var samesite = opts.samesite !== undefined ? opts.samesite : defaults.samesite;
	
	  // Determine cookie expiration date
	  // If succesful the result will be a valid Date, otherwise it will be an invalid Date or false(ish)
	  var expDate = expires ? new Date(
	      // in case expires is an integer, it should specify the number of days till the cookie expires
	      typeof expires === 'number' ? new Date().getTime() + (expires * 864e5) :
	      // else expires should be either a Date object or in a format recognized by Date.parse()
	      expires
	  ) : 0;
	
	  // Set cookie
	  document.cookie = name.replace(/[^+#$&^`|]/g, encodeURIComponent)                // Encode cookie name
	  .replace('(', '%28')
	  .replace(')', '%29') +
	  '=' + value.replace(/[^+#$&/:<-\[\]-}]/g, encodeURIComponent) +                  // Encode cookie value (RFC6265)
	  (expDate && expDate.getTime() >= 0 ? ';expires=' + expDate.toUTCString() : '') + // Add expiration date
	  (domain   ? ';domain=' + domain     : '') +                                      // Add domain
	  (path     ? ';path='   + path       : '') +                                      // Add path
	  (secure   ? ';secure'               : '') +                                      // Add secure option
	  (httponly ? ';httponly'             : '') +                                      // Add httponly option
	  (samesite ? ';samesite=' + samesite : '');                                       // Add samesite option
	};
	
	exports.get = function(name) {
	  var cookies = document.cookie.split(';');
	  
	  // Iterate all cookies
	  while(cookies.length) {
	    var cookie = cookies.pop();
	
	    // Determine separator index ("name=value")
	    var separatorIndex = cookie.indexOf('=');
	
	    // IE<11 emits the equal sign when the cookie value is empty
	    separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;
	
	    var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));
	
	    // Return cookie value if the name matches
	    if (cookie_name === name) {
	      return decodeURIComponent(cookie.slice(separatorIndex + 1));
	    }
	  }
	
	  // Return `null` as the cookie was not found
	  return null;
	};
	
	exports.erase = function(name, options) {
	  exports.set(name, '', {
	    expires:  -1,
	    domain:   options && options.domain,
	    path:     options && options.path,
	    secure:   0,
	    httponly: 0}
	  );
	};
	
	exports.all = function() {
	  var all = {};
	  var cookies = document.cookie.split(';');
	
	  // Iterate all cookies
	  while(cookies.length) {
	    var cookie = cookies.pop();
	
	    // Determine separator index ("name=value")
	    var separatorIndex = cookie.indexOf('=');
	
	    // IE<11 emits the equal sign when the cookie value is empty
	    separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;
	
	    // add the cookie name and value to the `all` object
	    var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));
	    all[cookie_name] = decodeURIComponent(cookie.slice(separatorIndex + 1));
	  }
	
	  return all;
	};


/***/ }),
/* 1002 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return (b64.length * 3 / 4) - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr((len * 3 / 4) - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0; i < l; i += 4) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = ((uint8[i] << 16) & 0xFF0000) + ((uint8[i + 1] << 8) & 0xFF00) + (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ }),
/* 1003 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(126);


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * chai
	 * http://chaijs.com
	 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	var config = __webpack_require__(127);
	
	module.exports = function (_chai, util) {
	  /*!
	   * Module dependencies.
	   */
	
	  var AssertionError = _chai.AssertionError
	    , flag = util.flag;
	
	  /*!
	   * Module export.
	   */
	
	  _chai.Assertion = Assertion;
	
	  /*!
	   * Assertion Constructor
	   *
	   * Creates object for chaining.
	   *
	   * `Assertion` objects contain metadata in the form of flags. Three flags can
	   * be assigned during instantiation by passing arguments to this constructor:
	   *
	   * - `object`: This flag contains the target of the assertion. For example, in
	   *   the assertion `expect(numKittens).to.equal(7);`, the `object` flag will
	   *   contain `numKittens` so that the `equal` assertion can reference it when
	   *   needed.
	   *
	   * - `message`: This flag contains an optional custom error message to be
	   *   prepended to the error message that's generated by the assertion when it
	   *   fails.
	   *
	   * - `ssfi`: This flag stands for "start stack function indicator". It
	   *   contains a function reference that serves as the starting point for
	   *   removing frames from the stack trace of the error that's created by the
	   *   assertion when it fails. The goal is to provide a cleaner stack trace to
	   *   end users by removing Chai's internal functions. Note that it only works
	   *   in environments that support `Error.captureStackTrace`, and only when
	   *   `Chai.config.includeStack` hasn't been set to `false`.
	   *
	   * - `lockSsfi`: This flag controls whether or not the given `ssfi` flag
	   *   should retain its current value, even as assertions are chained off of
	   *   this object. This is usually set to `true` when creating a new assertion
	   *   from within another assertion. It's also temporarily set to `true` before
	   *   an overwritten assertion gets called by the overwriting assertion.
	   *
	   * @param {Mixed} obj target of the assertion
	   * @param {String} msg (optional) custom error message
	   * @param {Function} ssfi (optional) starting point for removing stack frames
	   * @param {Boolean} lockSsfi (optional) whether or not the ssfi flag is locked
	   * @api private
	   */
	
	  function Assertion (obj, msg, ssfi, lockSsfi) {
	    flag(this, 'ssfi', ssfi || Assertion);
	    flag(this, 'lockSsfi', lockSsfi);
	    flag(this, 'object', obj);
	    flag(this, 'message', msg);
	
	    return util.proxify(this);
	  }
	
	  Object.defineProperty(Assertion, 'includeStack', {
	    get: function() {
	      console.warn('Assertion.includeStack is deprecated, use chai.config.includeStack instead.');
	      return config.includeStack;
	    },
	    set: function(value) {
	      console.warn('Assertion.includeStack is deprecated, use chai.config.includeStack instead.');
	      config.includeStack = value;
	    }
	  });
	
	  Object.defineProperty(Assertion, 'showDiff', {
	    get: function() {
	      console.warn('Assertion.showDiff is deprecated, use chai.config.showDiff instead.');
	      return config.showDiff;
	    },
	    set: function(value) {
	      console.warn('Assertion.showDiff is deprecated, use chai.config.showDiff instead.');
	      config.showDiff = value;
	    }
	  });
	
	  Assertion.addProperty = function (name, fn) {
	    util.addProperty(this.prototype, name, fn);
	  };
	
	  Assertion.addMethod = function (name, fn) {
	    util.addMethod(this.prototype, name, fn);
	  };
	
	  Assertion.addChainableMethod = function (name, fn, chainingBehavior) {
	    util.addChainableMethod(this.prototype, name, fn, chainingBehavior);
	  };
	
	  Assertion.overwriteProperty = function (name, fn) {
	    util.overwriteProperty(this.prototype, name, fn);
	  };
	
	  Assertion.overwriteMethod = function (name, fn) {
	    util.overwriteMethod(this.prototype, name, fn);
	  };
	
	  Assertion.overwriteChainableMethod = function (name, fn, chainingBehavior) {
	    util.overwriteChainableMethod(this.prototype, name, fn, chainingBehavior);
	  };
	
	  /**
	   * ### .assert(expression, message, negateMessage, expected, actual, showDiff)
	   *
	   * Executes an expression and check expectations. Throws AssertionError for reporting if test doesn't pass.
	   *
	   * @name assert
	   * @param {Philosophical} expression to be tested
	   * @param {String|Function} message or function that returns message to display if expression fails
	   * @param {String|Function} negatedMessage or function that returns negatedMessage to display if negated expression fails
	   * @param {Mixed} expected value (remember to check for negation)
	   * @param {Mixed} actual (optional) will default to `this.obj`
	   * @param {Boolean} showDiff (optional) when set to `true`, assert will display a diff in addition to the message if expression fails
	   * @api private
	   */
	
	  Assertion.prototype.assert = function (expr, msg, negateMsg, expected, _actual, showDiff) {
	    var ok = util.test(this, arguments);
	    if (false !== showDiff) showDiff = true;
	    if (undefined === expected && undefined === _actual) showDiff = false;
	    if (true !== config.showDiff) showDiff = false;
	
	    if (!ok) {
	      msg = util.getMessage(this, arguments);
	      var actual = util.getActual(this, arguments);
	      throw new AssertionError(msg, {
	          actual: actual
	        , expected: expected
	        , showDiff: showDiff
	      }, (config.includeStack) ? this.assert : flag(this, 'ssfi'));
	    }
	  };
	
	  /*!
	   * ### ._obj
	   *
	   * Quick reference to stored `actual` value for plugin developers.
	   *
	   * @api private
	   */
	
	  Object.defineProperty(Assertion.prototype, '_obj',
	    { get: function () {
	        return flag(this, 'object');
	      }
	    , set: function (val) {
	        flag(this, 'object', val);
	      }
	  });
	};


/***/ }),
/* 1006 */
/***/ (function(module, exports) {

	/*!
	 * chai
	 * http://chaijs.com
	 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	module.exports = function (chai, _) {
	  var Assertion = chai.Assertion
	    , AssertionError = chai.AssertionError
	    , flag = _.flag;
	
	  /**
	   * ### Language Chains
	   *
	   * The following are provided as chainable getters to improve the readability
	   * of your assertions.
	   *
	   * **Chains**
	   *
	   * - to
	   * - be
	   * - been
	   * - is
	   * - that
	   * - which
	   * - and
	   * - has
	   * - have
	   * - with
	   * - at
	   * - of
	   * - same
	   * - but
	   * - does
	   *
	   * @name language chains
	   * @namespace BDD
	   * @api public
	   */
	
	  [ 'to', 'be', 'been'
	  , 'is', 'and', 'has', 'have'
	  , 'with', 'that', 'which', 'at'
	  , 'of', 'same', 'but', 'does' ].forEach(function (chain) {
	    Assertion.addProperty(chain);
	  });
	
	  /**
	   * ### .not
	   *
	   * Negates all assertions that follow in the chain.
	   *
	   *     expect(function () {}).to.not.throw();
	   *     expect({a: 1}).to.not.have.property('b');
	   *     expect([1, 2]).to.be.an('array').that.does.not.include(3);
	   *
	   * Just because you can negate any assertion with `.not` doesn't mean you
	   * should. With great power comes great responsibility. It's often best to
	   * assert that the one expected output was produced, rather than asserting
	   * that one of countless unexpected outputs wasn't produced. See individual
	   * assertions for specific guidance.
	   *
	   *     expect(2).to.equal(2); // Recommended
	   *     expect(2).to.not.equal(1); // Not recommended
	   *
	   * @name not
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('not', function () {
	    flag(this, 'negate', true);
	  });
	
	  /**
	   * ### .deep
	   *
	   * Causes all `.equal`, `.include`, `.members`, `.keys`, and `.property`
	   * assertions that follow in the chain to use deep equality instead of strict
	   * (`===`) equality. See the `deep-eql` project page for info on the deep
	   * equality algorithm: https://github.com/chaijs/deep-eql.
	   *
	   *     // Target object deeply (but not strictly) equals `{a: 1}`
	   *     expect({a: 1}).to.deep.equal({a: 1});
	   *     expect({a: 1}).to.not.equal({a: 1});
	   *
	   *     // Target array deeply (but not strictly) includes `{a: 1}`
	   *     expect([{a: 1}]).to.deep.include({a: 1});
	   *     expect([{a: 1}]).to.not.include({a: 1});
	   *
	   *     // Target object deeply (but not strictly) includes `x: {a: 1}`
	   *     expect({x: {a: 1}}).to.deep.include({x: {a: 1}});
	   *     expect({x: {a: 1}}).to.not.include({x: {a: 1}});
	   *
	   *     // Target array deeply (but not strictly) has member `{a: 1}`
	   *     expect([{a: 1}]).to.have.deep.members([{a: 1}]);
	   *     expect([{a: 1}]).to.not.have.members([{a: 1}]);
	   *
	   *     // Target set deeply (but not strictly) has key `{a: 1}`
	   *     expect(new Set([{a: 1}])).to.have.deep.keys([{a: 1}]);
	   *     expect(new Set([{a: 1}])).to.not.have.keys([{a: 1}]);
	   *
	   *     // Target object deeply (but not strictly) has property `x: {a: 1}`
	   *     expect({x: {a: 1}}).to.have.deep.property('x', {a: 1});
	   *     expect({x: {a: 1}}).to.not.have.property('x', {a: 1});
	   *
	   * @name deep
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('deep', function () {
	    flag(this, 'deep', true);
	  });
	
	  /**
	   * ### .nested
	   *
	   * Enables dot- and bracket-notation in all `.property` and `.include`
	   * assertions that follow in the chain.
	   *
	   *     expect({a: {b: ['x', 'y']}}).to.have.nested.property('a.b[1]');
	   *     expect({a: {b: ['x', 'y']}}).to.nested.include({'a.b[1]': 'y'});
	   *
	   * If `.` or `[]` are part of an actual property name, they can be escaped by
	   * adding two backslashes before them.
	   *
	   *     expect({'.a': {'[b]': 'x'}}).to.have.nested.property('\\.a.\\[b\\]');
	   *     expect({'.a': {'[b]': 'x'}}).to.nested.include({'\\.a.\\[b\\]': 'x'});
	   *
	   * `.nested` cannot be combined with `.own`.
	   *
	   * @name nested
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('nested', function () {
	    flag(this, 'nested', true);
	  });
	
	  /**
	   * ### .own
	   *
	   * Causes all `.property` and `.include` assertions that follow in the chain
	   * to ignore inherited properties.
	   *
	   *     Object.prototype.b = 2;
	   *
	   *     expect({a: 1}).to.have.own.property('a');
	   *     expect({a: 1}).to.have.property('b').but.not.own.property('b'); 
	   *
	   *     expect({a: 1}).to.own.include({a: 1});
	   *     expect({a: 1}).to.include({b: 2}).but.not.own.include({b: 2});
	   *
	   * `.own` cannot be combined with `.nested`.
	   *
	   * @name own
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('own', function () {
	    flag(this, 'own', true);
	  });
	
	  /**
	   * ### .ordered
	   *
	   * Causes all `.members` assertions that follow in the chain to require that
	   * members be in the same order.
	   *
	   *     expect([1, 2]).to.have.ordered.members([1, 2])
	   *       .but.not.have.ordered.members([2, 1]);
	   *
	   * When `.include` and `.ordered` are combined, the ordering begins at the
	   * start of both arrays.
	   *
	   *     expect([1, 2, 3]).to.include.ordered.members([1, 2])
	   *       .but.not.include.ordered.members([2, 3]);
	   *
	   * @name ordered
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('ordered', function () {
	    flag(this, 'ordered', true);
	  });
	
	  /**
	   * ### .any
	   *
	   * Causes all `.keys` assertions that follow in the chain to only require that
	   * the target have at least one of the given keys. This is the opposite of
	   * `.all`, which requires that the target have all of the given keys.
	   *
	   *     expect({a: 1, b: 2}).to.not.have.any.keys('c', 'd');
	   *
	   * See the `.keys` doc for guidance on when to use `.any` or `.all`.
	   *
	   * @name any
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('any', function () {
	    flag(this, 'any', true);
	    flag(this, 'all', false);
	  });
	
	
	  /**
	   * ### .all
	   *
	   * Causes all `.keys` assertions that follow in the chain to require that the
	   * target have all of the given keys. This is the opposite of `.any`, which
	   * only requires that the target have at least one of the given keys.
	   *
	   *     expect({a: 1, b: 2}).to.have.all.keys('a', 'b');
	   *
	   * Note that `.all` is used by default when neither `.all` nor `.any` are
	   * added earlier in the chain. However, it's often best to add `.all` anyway
	   * because it improves readability.
	   *
	   * See the `.keys` doc for guidance on when to use `.any` or `.all`.
	   *
	   * @name all
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('all', function () {
	    flag(this, 'all', true);
	    flag(this, 'any', false);
	  });
	
	  /**
	   * ### .a(type[, msg])
	   *
	   * Asserts that the target's type is equal to the given string `type`. Types
	   * are case insensitive. See the `type-detect` project page for info on the
	   * type detection algorithm: https://github.com/chaijs/type-detect.
	   *
	   *     expect('foo').to.be.a('string');
	   *     expect({a: 1}).to.be.an('object');
	   *     expect(null).to.be.a('null');
	   *     expect(undefined).to.be.an('undefined');
	   *     expect(new Error).to.be.an('error');
	   *     expect(Promise.resolve()).to.be.a('promise');
	   *     expect(new Float32Array).to.be.a('float32array');
	   *     expect(Symbol()).to.be.a('symbol');
	   *
	   * `.a` supports objects that have a custom type set via `Symbol.toStringTag`.
	   *
	   *     var myObj = {
	   *       [Symbol.toStringTag]: 'myCustomType'
	   *     };
	   *
	   *     expect(myObj).to.be.a('myCustomType').but.not.an('object');
	   *
	   * It's often best to use `.a` to check a target's type before making more
	   * assertions on the same target. That way, you avoid unexpected behavior from
	   * any assertion that does different things based on the target's type.
	   *
	   *     expect([1, 2, 3]).to.be.an('array').that.includes(2);
	   *     expect([]).to.be.an('array').that.is.empty;
	   *
	   * Add `.not` earlier in the chain to negate `.a`. However, it's often best to
	   * assert that the target is the expected type, rather than asserting that it
	   * isn't one of many unexpected types.
	   *
	   *     expect('foo').to.be.a('string'); // Recommended
	   *     expect('foo').to.not.be.an('array'); // Not recommended
	   *
	   * `.a` accepts an optional `msg` argument which is a custom error message to
	   * show when the assertion fails. The message can also be given as the second
	   * argument to `expect`.
	   *
	   *     expect(1).to.be.a('string', 'nooo why fail??');
	   *     expect(1, 'nooo why fail??').to.be.a('string');
	   *
	   * `.a` can also be used as a language chain to improve the readability of
	   * your assertions. 
	   *
	   *     expect({b: 2}).to.have.a.property('b');
	   *
	   * The alias `.an` can be used interchangeably with `.a`.
	   *
	   * @name a
	   * @alias an
	   * @param {String} type
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function an (type, msg) {
	    if (msg) flag(this, 'message', msg);
	    type = type.toLowerCase();
	    var obj = flag(this, 'object')
	      , article = ~[ 'a', 'e', 'i', 'o', 'u' ].indexOf(type.charAt(0)) ? 'an ' : 'a ';
	
	    this.assert(
	        type === _.type(obj).toLowerCase()
	      , 'expected #{this} to be ' + article + type
	      , 'expected #{this} not to be ' + article + type
	    );
	  }
	
	  Assertion.addChainableMethod('an', an);
	  Assertion.addChainableMethod('a', an);
	
	  /**
	   * ### .include(val[, msg])
	   *
	   * When the target is a string, `.include` asserts that the given string `val`
	   * is a substring of the target.
	   *
	   *     expect('foobar').to.include('foo');
	   *
	   * When the target is an array, `.include` asserts that the given `val` is a
	   * member of the target.
	   *
	   *     expect([1, 2, 3]).to.include(2);
	   *
	   * When the target is an object, `.include` asserts that the given object
	   * `val`'s properties are a subset of the target's properties.
	   *
	   *     expect({a: 1, b: 2, c: 3}).to.include({a: 1, b: 2});
	   *
	   * When the target is a Set or WeakSet, `.include` asserts that the given `val` is a
	   * member of the target. SameValueZero equality algorithm is used.
	   *
	   *     expect(new Set([1, 2])).to.include(2);
	   *
	   * When the target is a Map, `.include` asserts that the given `val` is one of
	   * the values of the target. SameValueZero equality algorithm is used.
	   *
	   *     expect(new Map([['a', 1], ['b', 2]])).to.include(2);
	   *
	   * Because `.include` does different things based on the target's type, it's
	   * important to check the target's type before using `.include`. See the `.a`
	   * doc for info on testing a target's type.
	   *
	   *     expect([1, 2, 3]).to.be.an('array').that.includes(2);
	   *
	   * By default, strict (`===`) equality is used to compare array members and
	   * object properties. Add `.deep` earlier in the chain to use deep equality
	   * instead (WeakSet targets are not supported). See the `deep-eql` project
	   * page for info on the deep equality algorithm: https://github.com/chaijs/deep-eql.
	   *
	   *     // Target array deeply (but not strictly) includes `{a: 1}`
	   *     expect([{a: 1}]).to.deep.include({a: 1});
	   *     expect([{a: 1}]).to.not.include({a: 1});
	   *
	   *     // Target object deeply (but not strictly) includes `x: {a: 1}`
	   *     expect({x: {a: 1}}).to.deep.include({x: {a: 1}});
	   *     expect({x: {a: 1}}).to.not.include({x: {a: 1}});
	   *
	   * By default, all of the target's properties are searched when working with
	   * objects. This includes properties that are inherited and/or non-enumerable.
	   * Add `.own` earlier in the chain to exclude the target's inherited
	   * properties from the search.
	   *
	   *     Object.prototype.b = 2;
	   *
	   *     expect({a: 1}).to.own.include({a: 1});
	   *     expect({a: 1}).to.include({b: 2}).but.not.own.include({b: 2});
	   *
	   * Note that a target object is always only searched for `val`'s own
	   * enumerable properties.
	   *
	   * `.deep` and `.own` can be combined.
	   *
	   *     expect({a: {b: 2}}).to.deep.own.include({a: {b: 2}});
	   *
	   * Add `.nested` earlier in the chain to enable dot- and bracket-notation when
	   * referencing nested properties.
	   *
	   *     expect({a: {b: ['x', 'y']}}).to.nested.include({'a.b[1]': 'y'});
	   *
	   * If `.` or `[]` are part of an actual property name, they can be escaped by
	   * adding two backslashes before them.
	   *
	   *     expect({'.a': {'[b]': 2}}).to.nested.include({'\\.a.\\[b\\]': 2});
	   *
	   * `.deep` and `.nested` can be combined.
	   *
	   *     expect({a: {b: [{c: 3}]}}).to.deep.nested.include({'a.b[0]': {c: 3}});
	   *
	   * `.own` and `.nested` cannot be combined.
	   *
	   * Add `.not` earlier in the chain to negate `.include`.
	   *
	   *     expect('foobar').to.not.include('taco');
	   *     expect([1, 2, 3]).to.not.include(4);
	   * 
	   * However, it's dangerous to negate `.include` when the target is an object.
	   * The problem is that it creates uncertain expectations by asserting that the
	   * target object doesn't have all of `val`'s key/value pairs but may or may
	   * not have some of them. It's often best to identify the exact output that's
	   * expected, and then write an assertion that only accepts that exact output.
	   *
	   * When the target object isn't even expected to have `val`'s keys, it's
	   * often best to assert exactly that.
	   *
	   *     expect({c: 3}).to.not.have.any.keys('a', 'b'); // Recommended
	   *     expect({c: 3}).to.not.include({a: 1, b: 2}); // Not recommended
	   *
	   * When the target object is expected to have `val`'s keys, it's often best to
	   * assert that each of the properties has its expected value, rather than
	   * asserting that each property doesn't have one of many unexpected values.
	   *
	   *     expect({a: 3, b: 4}).to.include({a: 3, b: 4}); // Recommended
	   *     expect({a: 3, b: 4}).to.not.include({a: 1, b: 2}); // Not recommended
	   *
	   * `.include` accepts an optional `msg` argument which is a custom error
	   * message to show when the assertion fails. The message can also be given as
	   * the second argument to `expect`.
	   *
	   *     expect([1, 2, 3]).to.include(4, 'nooo why fail??');
	   *     expect([1, 2, 3], 'nooo why fail??').to.include(4);
	   *
	   * `.include` can also be used as a language chain, causing all `.members` and
	   * `.keys` assertions that follow in the chain to require the target to be a
	   * superset of the expected set, rather than an identical set. Note that
	   * `.members` ignores duplicates in the subset when `.include` is added.
	   *
	   *     // Target object's keys are a superset of ['a', 'b'] but not identical
	   *     expect({a: 1, b: 2, c: 3}).to.include.all.keys('a', 'b');
	   *     expect({a: 1, b: 2, c: 3}).to.not.have.all.keys('a', 'b');
	   *
	   *     // Target array is a superset of [1, 2] but not identical
	   *     expect([1, 2, 3]).to.include.members([1, 2]);
	   *     expect([1, 2, 3]).to.not.have.members([1, 2]);
	   *
	   *     // Duplicates in the subset are ignored
	   *     expect([1, 2, 3]).to.include.members([1, 2, 2, 2]);
	   *
	   * Note that adding `.any` earlier in the chain causes the `.keys` assertion
	   * to ignore `.include`.
	   *
	   *     // Both assertions are identical
	   *     expect({a: 1}).to.include.any.keys('a', 'b');
	   *     expect({a: 1}).to.have.any.keys('a', 'b');
	   *
	   * The aliases `.includes`, `.contain`, and `.contains` can be used
	   * interchangeably with `.include`.
	   *
	   * @name include
	   * @alias contain
	   * @alias includes
	   * @alias contains
	   * @param {Mixed} val
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function SameValueZero(a, b) {
	    return (_.isNaN(a) && _.isNaN(b)) || a === b;
	  }
	
	  function includeChainingBehavior () {
	    flag(this, 'contains', true);
	  }
	
	  function include (val, msg) {
	    if (msg) flag(this, 'message', msg);
	    
	    var obj = flag(this, 'object')
	      , objType = _.type(obj).toLowerCase()
	      , flagMsg = flag(this, 'message')
	      , negate = flag(this, 'negate')
	      , ssfi = flag(this, 'ssfi')
	      , isDeep = flag(this, 'deep')
	      , descriptor = isDeep ? 'deep ' : '';
	
	    flagMsg = flagMsg ? flagMsg + ': ' : '';
	
	    var included = false;
	
	    switch (objType) {
	      case 'string':
	        included = obj.indexOf(val) !== -1;
	        break;
	
	      case 'weakset':
	        if (isDeep) {
	          throw new AssertionError(
	            flagMsg + 'unable to use .deep.include with WeakSet',
	            undefined,
	            ssfi
	          );
	        }
	
	        included = obj.has(val);
	        break;
	
	      case 'map':
	        var isEql = isDeep ? _.eql : SameValueZero;
	        obj.forEach(function (item) {
	          included = included || isEql(item, val);
	        });
	        break;
	
	      case 'set':
	        if (isDeep) {
	          obj.forEach(function (item) {
	            included = included || _.eql(item, val);
	          });
	        } else {
	          included = obj.has(val);
	        }
	        break;
	
	      case 'array':
	        if (isDeep) {
	          included = obj.some(function (item) {
	            return _.eql(item, val);
	          })
	        } else {
	          included = obj.indexOf(val) !== -1;
	        }
	        break;
	
	      default:
	        // This block is for asserting a subset of properties in an object.
	        // `_.expectTypes` isn't used here because `.include` should work with
	        // objects with a custom `@@toStringTag`.
	        if (val !== Object(val)) {
	          throw new AssertionError(
	            flagMsg + 'object tested must be an array, a map, an object,'
	              + ' a set, a string, or a weakset, but ' + objType + ' given',
	            undefined,
	            ssfi
	          );
	        }
	
	        var props = Object.keys(val)
	          , firstErr = null
	          , numErrs = 0;
	  
	        props.forEach(function (prop) {
	          var propAssertion = new Assertion(obj);
	          _.transferFlags(this, propAssertion, true);
	          flag(propAssertion, 'lockSsfi', true);
	  
	          if (!negate || props.length === 1) {
	            propAssertion.property(prop, val[prop]);
	            return;
	          }
	  
	          try {
	            propAssertion.property(prop, val[prop]);
	          } catch (err) {
	            if (!_.checkError.compatibleConstructor(err, AssertionError)) {
	              throw err;
	            }
	            if (firstErr === null) firstErr = err;
	            numErrs++;
	          }
	        }, this);
	  
	        // When validating .not.include with multiple properties, we only want
	        // to throw an assertion error if all of the properties are included,
	        // in which case we throw the first property assertion error that we
	        // encountered.
	        if (negate && props.length > 1 && numErrs === props.length) {
	          throw firstErr;
	        }
	        return;
	    }
	
	    // Assert inclusion in collection or substring in a string.
	    this.assert(
	      included
	      , 'expected #{this} to ' + descriptor + 'include ' + _.inspect(val)
	      , 'expected #{this} to not ' + descriptor + 'include ' + _.inspect(val));
	  }
	
	  Assertion.addChainableMethod('include', include, includeChainingBehavior);
	  Assertion.addChainableMethod('contain', include, includeChainingBehavior);
	  Assertion.addChainableMethod('contains', include, includeChainingBehavior);
	  Assertion.addChainableMethod('includes', include, includeChainingBehavior);
	
	  /**
	   * ### .ok
	   *
	   * Asserts that the target is loosely (`==`) equal to `true`. However, it's
	   * often best to assert that the target is strictly (`===`) or deeply equal to
	   * its expected value.
	   *
	   *     expect(1).to.equal(1); // Recommended
	   *     expect(1).to.be.ok; // Not recommended
	   *
	   *     expect(true).to.be.true; // Recommended
	   *     expect(true).to.be.ok; // Not recommended
	   *
	   * Add `.not` earlier in the chain to negate `.ok`.
	   *
	   *     expect(0).to.equal(0); // Recommended
	   *     expect(0).to.not.be.ok; // Not recommended
	   *
	   *     expect(false).to.be.false; // Recommended
	   *     expect(false).to.not.be.ok; // Not recommended
	   *
	   *     expect(null).to.be.null; // Recommended
	   *     expect(null).to.not.be.ok; // Not recommended
	   *
	   *     expect(undefined).to.be.undefined; // Recommended
	   *     expect(undefined).to.not.be.ok; // Not recommended
	   *
	   * A custom error message can be given as the second argument to `expect`.
	   *
	   *     expect(false, 'nooo why fail??').to.be.ok;
	   *
	   * @name ok
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('ok', function () {
	    this.assert(
	        flag(this, 'object')
	      , 'expected #{this} to be truthy'
	      , 'expected #{this} to be falsy');
	  });
	
	  /**
	   * ### .true
	   *
	   * Asserts that the target is strictly (`===`) equal to `true`.
	   *
	   *     expect(true).to.be.true;
	   *
	   * Add `.not` earlier in the chain to negate `.true`. However, it's often best
	   * to assert that the target is equal to its expected value, rather than not
	   * equal to `true`.
	   *
	   *     expect(false).to.be.false; // Recommended
	   *     expect(false).to.not.be.true; // Not recommended
	   *
	   *     expect(1).to.equal(1); // Recommended
	   *     expect(1).to.not.be.true; // Not recommended
	   *
	   * A custom error message can be given as the second argument to `expect`.
	   *
	   *     expect(false, 'nooo why fail??').to.be.true;
	   *
	   * @name true
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('true', function () {
	    this.assert(
	        true === flag(this, 'object')
	      , 'expected #{this} to be true'
	      , 'expected #{this} to be false'
	      , flag(this, 'negate') ? false : true
	    );
	  });
	
	  /**
	   * ### .false
	   *
	   * Asserts that the target is strictly (`===`) equal to `false`.
	   *
	   *     expect(false).to.be.false;
	   *
	   * Add `.not` earlier in the chain to negate `.false`. However, it's often
	   * best to assert that the target is equal to its expected value, rather than
	   * not equal to `false`.
	   *
	   *     expect(true).to.be.true; // Recommended
	   *     expect(true).to.not.be.false; // Not recommended
	   *
	   *     expect(1).to.equal(1); // Recommended
	   *     expect(1).to.not.be.false; // Not recommended
	   *
	   * A custom error message can be given as the second argument to `expect`.
	   *
	   *     expect(true, 'nooo why fail??').to.be.false;
	   *
	   * @name false
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('false', function () {
	    this.assert(
	        false === flag(this, 'object')
	      , 'expected #{this} to be false'
	      , 'expected #{this} to be true'
	      , flag(this, 'negate') ? true : false
	    );
	  });
	
	  /**
	   * ### .null
	   *
	   * Asserts that the target is strictly (`===`) equal to `null`.
	   *
	   *     expect(null).to.be.null;
	   *
	   * Add `.not` earlier in the chain to negate `.null`. However, it's often best
	   * to assert that the target is equal to its expected value, rather than not
	   * equal to `null`.
	   *
	   *     expect(1).to.equal(1); // Recommended
	   *     expect(1).to.not.be.null; // Not recommended
	   *
	   * A custom error message can be given as the second argument to `expect`.
	   *
	   *     expect(42, 'nooo why fail??').to.be.null;
	   *
	   * @name null
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('null', function () {
	    this.assert(
	        null === flag(this, 'object')
	      , 'expected #{this} to be null'
	      , 'expected #{this} not to be null'
	    );
	  });
	
	  /**
	   * ### .undefined
	   *
	   * Asserts that the target is strictly (`===`) equal to `undefined`.
	   *
	   *     expect(undefined).to.be.undefined;
	   *
	   * Add `.not` earlier in the chain to negate `.undefined`. However, it's often
	   * best to assert that the target is equal to its expected value, rather than
	   * not equal to `undefined`.
	   *
	   *     expect(1).to.equal(1); // Recommended
	   *     expect(1).to.not.be.undefined; // Not recommended
	   *
	   * A custom error message can be given as the second argument to `expect`.
	   *
	   *     expect(42, 'nooo why fail??').to.be.undefined;
	   *
	   * @name undefined
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('undefined', function () {
	    this.assert(
	        undefined === flag(this, 'object')
	      , 'expected #{this} to be undefined'
	      , 'expected #{this} not to be undefined'
	    );
	  });
	
	  /**
	   * ### .NaN
	   *
	   * Asserts that the target is exactly `NaN`.
	   *
	   *     expect(NaN).to.be.NaN;
	   *
	   * Add `.not` earlier in the chain to negate `.NaN`. However, it's often best
	   * to assert that the target is equal to its expected value, rather than not
	   * equal to `NaN`.
	   *
	   *     expect('foo').to.equal('foo'); // Recommended
	   *     expect('foo').to.not.be.NaN; // Not recommended
	   *
	   * A custom error message can be given as the second argument to `expect`.
	   *
	   *     expect(42, 'nooo why fail??').to.be.NaN;
	   *
	   * @name NaN
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('NaN', function () {
	    this.assert(
	        _.isNaN(flag(this, 'object'))
	        , 'expected #{this} to be NaN'
	        , 'expected #{this} not to be NaN'
	    );
	  });
	
	  /**
	   * ### .exist
	   *
	   * Asserts that the target is not strictly (`===`) equal to either `null` or
	   * `undefined`. However, it's often best to assert that the target is equal to
	   * its expected value.
	   *
	   *     expect(1).to.equal(1); // Recommended
	   *     expect(1).to.exist; // Not recommended
	   *
	   *     expect(0).to.equal(0); // Recommended
	   *     expect(0).to.exist; // Not recommended
	   *
	   * Add `.not` earlier in the chain to negate `.exist`.
	   *
	   *     expect(null).to.be.null; // Recommended
	   *     expect(null).to.not.exist; // Not recommended
	   *
	   *     expect(undefined).to.be.undefined; // Recommended
	   *     expect(undefined).to.not.exist; // Not recommended
	   *
	   * A custom error message can be given as the second argument to `expect`.
	   *
	   *     expect(null, 'nooo why fail??').to.exist;
	   *
	   * @name exist
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('exist', function () {
	    var val = flag(this, 'object');
	    this.assert(
	        val !== null && val !== undefined
	      , 'expected #{this} to exist'
	      , 'expected #{this} to not exist'
	    );
	  });
	
	  /**
	   * ### .empty
	   *
	   * When the target is a string or array, `.empty` asserts that the target's
	   * `length` property is strictly (`===`) equal to `0`.
	   *
	   *     expect([]).to.be.empty;
	   *     expect('').to.be.empty;
	   *
	   * When the target is a map or set, `.empty` asserts that the target's `size`
	   * property is strictly equal to `0`.
	   *
	   *     expect(new Set()).to.be.empty;
	   *     expect(new Map()).to.be.empty;
	   *
	   * When the target is a non-function object, `.empty` asserts that the target
	   * doesn't have any own enumerable properties. Properties with Symbol-based
	   * keys are excluded from the count.
	   *
	   *     expect({}).to.be.empty;
	   *
	   * Because `.empty` does different things based on the target's type, it's
	   * important to check the target's type before using `.empty`. See the `.a`
	   * doc for info on testing a target's type.
	   *
	   *     expect([]).to.be.an('array').that.is.empty;
	   *
	   * Add `.not` earlier in the chain to negate `.empty`. However, it's often
	   * best to assert that the target contains its expected number of values,
	   * rather than asserting that it's not empty.
	   *
	   *     expect([1, 2, 3]).to.have.lengthOf(3); // Recommended
	   *     expect([1, 2, 3]).to.not.be.empty; // Not recommended
	   *
	   *     expect(new Set([1, 2, 3])).to.have.property('size', 3); // Recommended
	   *     expect(new Set([1, 2, 3])).to.not.be.empty; // Not recommended
	   *
	   *     expect(Object.keys({a: 1})).to.have.lengthOf(1); // Recommended
	   *     expect({a: 1}).to.not.be.empty; // Not recommended
	   *
	   * A custom error message can be given as the second argument to `expect`.
	   *
	   *     expect([1, 2, 3], 'nooo why fail??').to.be.empty;
	   *
	   * @name empty
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('empty', function () {
	    var val = flag(this, 'object')
	      , ssfi = flag(this, 'ssfi')
	      , flagMsg = flag(this, 'message')
	      , itemsCount;
	
	    flagMsg = flagMsg ? flagMsg + ': ' : '';
	
	    switch (_.type(val).toLowerCase()) {
	      case 'array':
	      case 'string':
	        itemsCount = val.length;
	        break;
	      case 'map':
	      case 'set':
	        itemsCount = val.size;
	        break;
	      case 'weakmap':
	      case 'weakset':
	        throw new AssertionError(
	          flagMsg + '.empty was passed a weak collection',
	          undefined,
	          ssfi
	        );
	      case 'function':
	        var msg = flagMsg + '.empty was passed a function ' + _.getName(val);
	        throw new AssertionError(msg.trim(), undefined, ssfi);
	      default:
	        if (val !== Object(val)) {
	          throw new AssertionError(
	            flagMsg + '.empty was passed non-string primitive ' + _.inspect(val),
	            undefined,
	            ssfi
	          );
	        }
	        itemsCount = Object.keys(val).length;
	    }
	
	    this.assert(
	        0 === itemsCount
	      , 'expected #{this} to be empty'
	      , 'expected #{this} not to be empty'
	    );
	  });
	
	  /**
	   * ### .arguments
	   *
	   * Asserts that the target is an `arguments` object.
	   *
	   *     function test () {
	   *       expect(arguments).to.be.arguments;
	   *     }
	   *
	   *     test();
	   *
	   * Add `.not` earlier in the chain to negate `.arguments`. However, it's often
	   * best to assert which type the target is expected to be, rather than
	   * asserting that its not an `arguments` object.
	   *
	   *     expect('foo').to.be.a('string'); // Recommended
	   *     expect('foo').to.not.be.arguments; // Not recommended
	   *
	   * A custom error message can be given as the second argument to `expect`.
	   *
	   *     expect({}, 'nooo why fail??').to.be.arguments;
	   *
	   * The alias `.Arguments` can be used interchangeably with `.arguments`.
	   *
	   * @name arguments
	   * @alias Arguments
	   * @namespace BDD
	   * @api public
	   */
	
	  function checkArguments () {
	    var obj = flag(this, 'object')
	      , type = _.type(obj);
	    this.assert(
	        'Arguments' === type
	      , 'expected #{this} to be arguments but got ' + type
	      , 'expected #{this} to not be arguments'
	    );
	  }
	
	  Assertion.addProperty('arguments', checkArguments);
	  Assertion.addProperty('Arguments', checkArguments);
	
	  /**
	   * ### .equal(val[, msg])
	   *
	   * Asserts that the target is strictly (`===`) equal to the given `val`.
	   *
	   *     expect(1).to.equal(1);
	   *     expect('foo').to.equal('foo');
	   * 
	   * Add `.deep` earlier in the chain to use deep equality instead. See the
	   * `deep-eql` project page for info on the deep equality algorithm:
	   * https://github.com/chaijs/deep-eql.
	   *
	   *     // Target object deeply (but not strictly) equals `{a: 1}`
	   *     expect({a: 1}).to.deep.equal({a: 1});
	   *     expect({a: 1}).to.not.equal({a: 1});
	   *
	   *     // Target array deeply (but not strictly) equals `[1, 2]`
	   *     expect([1, 2]).to.deep.equal([1, 2]);
	   *     expect([1, 2]).to.not.equal([1, 2]);
	   *
	   * Add `.not` earlier in the chain to negate `.equal`. However, it's often
	   * best to assert that the target is equal to its expected value, rather than
	   * not equal to one of countless unexpected values.
	   *
	   *     expect(1).to.equal(1); // Recommended
	   *     expect(1).to.not.equal(2); // Not recommended
	   *
	   * `.equal` accepts an optional `msg` argument which is a custom error message
	   * to show when the assertion fails. The message can also be given as the
	   * second argument to `expect`.
	   *
	   *     expect(1).to.equal(2, 'nooo why fail??');
	   *     expect(1, 'nooo why fail??').to.equal(2);
	   *
	   * The aliases `.equals` and `eq` can be used interchangeably with `.equal`.
	   *
	   * @name equal
	   * @alias equals
	   * @alias eq
	   * @param {Mixed} val
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function assertEqual (val, msg) {
	    if (msg) flag(this, 'message', msg);
	    var obj = flag(this, 'object');
	    if (flag(this, 'deep')) {
	      return this.eql(val);
	    } else {
	      this.assert(
	          val === obj
	        , 'expected #{this} to equal #{exp}'
	        , 'expected #{this} to not equal #{exp}'
	        , val
	        , this._obj
	        , true
	      );
	    }
	  }
	
	  Assertion.addMethod('equal', assertEqual);
	  Assertion.addMethod('equals', assertEqual);
	  Assertion.addMethod('eq', assertEqual);
	
	  /**
	   * ### .eql(obj[, msg])
	   *
	   * Asserts that the target is deeply equal to the given `obj`. See the
	   * `deep-eql` project page for info on the deep equality algorithm:
	   * https://github.com/chaijs/deep-eql.
	   *
	   *     // Target object is deeply (but not strictly) equal to {a: 1}
	   *     expect({a: 1}).to.eql({a: 1}).but.not.equal({a: 1});
	   *
	   *     // Target array is deeply (but not strictly) equal to [1, 2]
	   *     expect([1, 2]).to.eql([1, 2]).but.not.equal([1, 2]);
	   *
	   * Add `.not` earlier in the chain to negate `.eql`. However, it's often best
	   * to assert that the target is deeply equal to its expected value, rather
	   * than not deeply equal to one of countless unexpected values.
	   *
	   *     expect({a: 1}).to.eql({a: 1}); // Recommended
	   *     expect({a: 1}).to.not.eql({b: 2}); // Not recommended
	   *
	   * `.eql` accepts an optional `msg` argument which is a custom error message
	   * to show when the assertion fails. The message can also be given as the
	   * second argument to `expect`.
	   *
	   *     expect({a: 1}).to.eql({b: 2}, 'nooo why fail??');
	   *     expect({a: 1}, 'nooo why fail??').to.eql({b: 2});
	   *
	   * The alias `.eqls` can be used interchangeably with `.eql`.
	   *
	   * The `.deep.equal` assertion is almost identical to `.eql` but with one
	   * difference: `.deep.equal` causes deep equality comparisons to also be used
	   * for any other assertions that follow in the chain.
	   *
	   * @name eql
	   * @alias eqls
	   * @param {Mixed} obj
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function assertEql(obj, msg) {
	    if (msg) flag(this, 'message', msg);
	    this.assert(
	        _.eql(obj, flag(this, 'object'))
	      , 'expected #{this} to deeply equal #{exp}'
	      , 'expected #{this} to not deeply equal #{exp}'
	      , obj
	      , this._obj
	      , true
	    );
	  }
	
	  Assertion.addMethod('eql', assertEql);
	  Assertion.addMethod('eqls', assertEql);
	
	  /**
	   * ### .above(n[, msg])
	   *
	   * Asserts that the target is a number or a date greater than the given number or date `n` respectively.
	   * However, it's often best to assert that the target is equal to its expected
	   * value.
	   *
	   *     expect(2).to.equal(2); // Recommended
	   *     expect(2).to.be.above(1); // Not recommended
	   *
	   * Add `.lengthOf` earlier in the chain to assert that the value of the
	   * target's `length` property is greater than the given number `n`.
	   *
	   *     expect('foo').to.have.lengthOf(3); // Recommended
	   *     expect('foo').to.have.lengthOf.above(2); // Not recommended
	   *
	   *     expect([1, 2, 3]).to.have.lengthOf(3); // Recommended
	   *     expect([1, 2, 3]).to.have.lengthOf.above(2); // Not recommended
	   *
	   * Add `.not` earlier in the chain to negate `.above`.
	   *
	   *     expect(2).to.equal(2); // Recommended
	   *     expect(1).to.not.be.above(2); // Not recommended
	   *
	   * `.above` accepts an optional `msg` argument which is a custom error message
	   * to show when the assertion fails. The message can also be given as the
	   * second argument to `expect`.
	   *
	   *     expect(1).to.be.above(2, 'nooo why fail??');
	   *     expect(1, 'nooo why fail??').to.be.above(2);
	   *
	   * The aliases `.gt` and `.greaterThan` can be used interchangeably with
	   * `.above`.
	   *
	   * @name above
	   * @alias gt
	   * @alias greaterThan
	   * @param {Number} n
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function assertAbove (n, msg) {
	    if (msg) flag(this, 'message', msg);
	    var obj = flag(this, 'object')
	      , doLength = flag(this, 'doLength')
	      , flagMsg = flag(this, 'message')
	      , msgPrefix = ((flagMsg) ? flagMsg + ': ' : '')
	      , ssfi = flag(this, 'ssfi')
	      , objType = _.type(obj).toLowerCase()
	      , nType = _.type(n).toLowerCase()
	      , shouldThrow = true;
	
	    if (doLength) {
	      new Assertion(obj, flagMsg, ssfi, true).to.have.property('length');
	    }
	    
	    if (!doLength && (objType === 'date' && nType !== 'date')) {
	      errorMessage = msgPrefix + 'the argument to above must be a date';
	    } else if (nType !== 'number' && (doLength || objType === 'number')) {
	      errorMessage = msgPrefix + 'the argument to above must be a number';
	    } else if (!doLength && (objType !== 'date' && objType !== 'number')) {
	      var printObj = (objType === 'string') ? "'" + obj + "'" : obj;
	      errorMessage = msgPrefix + 'expected ' + printObj + ' to be a number or a date';
	    } else {
	      shouldThrow = false;
	    }
	
	    if (shouldThrow) {
	      throw new AssertionError(errorMessage, undefined, ssfi);
	    }
	
	    if (doLength) {
	      var len = obj.length;
	      this.assert(
	          len > n
	        , 'expected #{this} to have a length above #{exp} but got #{act}'
	        , 'expected #{this} to not have a length above #{exp}'
	        , n
	        , len
	      );
	    } else {
	      this.assert(
	          obj > n
	        , 'expected #{this} to be above #{exp}'
	        , 'expected #{this} to be at most #{exp}'
	        , n
	      );
	    }
	  }
	
	  Assertion.addMethod('above', assertAbove);
	  Assertion.addMethod('gt', assertAbove);
	  Assertion.addMethod('greaterThan', assertAbove);
	
	  /**
	   * ### .least(n[, msg])
	   *
	   * Asserts that the target is a number or a date greater than or equal to the given
	   * number or date `n` respectively. However, it's often best to assert that the target is equal to
	   * its expected value.
	   *
	   *     expect(2).to.equal(2); // Recommended
	   *     expect(2).to.be.at.least(1); // Not recommended
	   *     expect(2).to.be.at.least(2); // Not recommended
	   *
	   * Add `.lengthOf` earlier in the chain to assert that the value of the
	   * target's `length` property is greater than or equal to the given number
	   * `n`.
	   *
	   *     expect('foo').to.have.lengthOf(3); // Recommended
	   *     expect('foo').to.have.lengthOf.at.least(2); // Not recommended
	   *
	   *     expect([1, 2, 3]).to.have.lengthOf(3); // Recommended
	   *     expect([1, 2, 3]).to.have.lengthOf.at.least(2); // Not recommended
	   *
	   * Add `.not` earlier in the chain to negate `.least`.
	   *
	   *     expect(1).to.equal(1); // Recommended
	   *     expect(1).to.not.be.at.least(2); // Not recommended
	   *
	   * `.least` accepts an optional `msg` argument which is a custom error message
	   * to show when the assertion fails. The message can also be given as the
	   * second argument to `expect`.
	   *
	   *     expect(1).to.be.at.least(2, 'nooo why fail??');
	   *     expect(1, 'nooo why fail??').to.be.at.least(2);
	   *
	   * The alias `.gte` can be used interchangeably with `.least`.
	   *
	   * @name least
	   * @alias gte
	   * @param {Number} n
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function assertLeast (n, msg) {
	    if (msg) flag(this, 'message', msg);
	    var obj = flag(this, 'object')
	      , doLength = flag(this, 'doLength')
	      , flagMsg = flag(this, 'message')
	      , msgPrefix = ((flagMsg) ? flagMsg + ': ' : '')
	      , ssfi = flag(this, 'ssfi')
	      , objType = _.type(obj).toLowerCase()
	      , nType = _.type(n).toLowerCase()
	      , shouldThrow = true;
	
	    if (doLength) {
	      new Assertion(obj, flagMsg, ssfi, true).to.have.property('length');
	    }
	
	    if (!doLength && (objType === 'date' && nType !== 'date')) {
	      errorMessage = msgPrefix + 'the argument to least must be a date';
	    } else if (nType !== 'number' && (doLength || objType === 'number')) {
	      errorMessage = msgPrefix + 'the argument to least must be a number';
	    } else if (!doLength && (objType !== 'date' && objType !== 'number')) {
	      var printObj = (objType === 'string') ? "'" + obj + "'" : obj;
	      errorMessage = msgPrefix + 'expected ' + printObj + ' to be a number or a date';
	    } else {
	      shouldThrow = false;
	    }
	
	    if (shouldThrow) {
	      throw new AssertionError(errorMessage, undefined, ssfi);
	    }
	
	    if (doLength) {
	      var len = obj.length;
	      this.assert(
	          len >= n
	        , 'expected #{this} to have a length at least #{exp} but got #{act}'
	        , 'expected #{this} to have a length below #{exp}'
	        , n
	        , len
	      );
	    } else {
	      this.assert(
	          obj >= n
	        , 'expected #{this} to be at least #{exp}'
	        , 'expected #{this} to be below #{exp}'
	        , n
	      );
	    }
	  }
	
	  Assertion.addMethod('least', assertLeast);
	  Assertion.addMethod('gte', assertLeast);
	
	  /**
	   * ### .below(n[, msg])
	   *
	   * Asserts that the target is a number or a date less than the given number or date `n` respectively.
	   * However, it's often best to assert that the target is equal to its expected
	   * value.
	   *
	   *     expect(1).to.equal(1); // Recommended
	   *     expect(1).to.be.below(2); // Not recommended
	   *
	   * Add `.lengthOf` earlier in the chain to assert that the value of the
	   * target's `length` property is less than the given number `n`.
	   *
	   *     expect('foo').to.have.lengthOf(3); // Recommended
	   *     expect('foo').to.have.lengthOf.below(4); // Not recommended
	   *
	   *     expect([1, 2, 3]).to.have.length(3); // Recommended
	   *     expect([1, 2, 3]).to.have.lengthOf.below(4); // Not recommended
	   *
	   * Add `.not` earlier in the chain to negate `.below`.
	   *
	   *     expect(2).to.equal(2); // Recommended
	   *     expect(2).to.not.be.below(1); // Not recommended
	   *
	   * `.below` accepts an optional `msg` argument which is a custom error message
	   * to show when the assertion fails. The message can also be given as the
	   * second argument to `expect`.
	   *
	   *     expect(2).to.be.below(1, 'nooo why fail??');
	   *     expect(2, 'nooo why fail??').to.be.below(1);
	   *
	   * The aliases `.lt` and `.lessThan` can be used interchangeably with
	   * `.below`.
	   *
	   * @name below
	   * @alias lt
	   * @alias lessThan
	   * @param {Number} n
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function assertBelow (n, msg) {
	    if (msg) flag(this, 'message', msg);
	    var obj = flag(this, 'object')
	      , doLength = flag(this, 'doLength')
	      , flagMsg = flag(this, 'message')
	      , msgPrefix = ((flagMsg) ? flagMsg + ': ' : '')
	      , ssfi = flag(this, 'ssfi')
	      , objType = _.type(obj).toLowerCase()
	      , nType = _.type(n).toLowerCase()
	      , shouldThrow = true;
	
	    if (doLength) {
	      new Assertion(obj, flagMsg, ssfi, true).to.have.property('length');
	    }
	
	    if (!doLength && (objType === 'date' && nType !== 'date')) {
	      errorMessage = msgPrefix + 'the argument to below must be a date';
	    } else if (nType !== 'number' && (doLength || objType === 'number')) {
	      errorMessage = msgPrefix + 'the argument to below must be a number';
	    } else if (!doLength && (objType !== 'date' && objType !== 'number')) {
	      var printObj = (objType === 'string') ? "'" + obj + "'" : obj;
	      errorMessage = msgPrefix + 'expected ' + printObj + ' to be a number or a date';
	    } else {
	      shouldThrow = false;
	    }
	
	    if (shouldThrow) {
	      throw new AssertionError(errorMessage, undefined, ssfi);
	    }
	
	    if (doLength) {
	      var len = obj.length;
	      this.assert(
	          len < n
	        , 'expected #{this} to have a length below #{exp} but got #{act}'
	        , 'expected #{this} to not have a length below #{exp}'
	        , n
	        , len
	      );
	    } else {
	      this.assert(
	          obj < n
	        , 'expected #{this} to be below #{exp}'
	        , 'expected #{this} to be at least #{exp}'
	        , n
	      );
	    }
	  }
	
	  Assertion.addMethod('below', assertBelow);
	  Assertion.addMethod('lt', assertBelow);
	  Assertion.addMethod('lessThan', assertBelow);
	
	  /**
	   * ### .most(n[, msg])
	   *
	   * Asserts that the target is a number or a date less than or equal to the given number
	   * or date `n` respectively. However, it's often best to assert that the target is equal to its
	   * expected value.
	   *
	   *     expect(1).to.equal(1); // Recommended
	   *     expect(1).to.be.at.most(2); // Not recommended
	   *     expect(1).to.be.at.most(1); // Not recommended
	   *
	   * Add `.lengthOf` earlier in the chain to assert that the value of the
	   * target's `length` property is less than or equal to the given number `n`.
	   *
	   *     expect('foo').to.have.lengthOf(3); // Recommended
	   *     expect('foo').to.have.lengthOf.at.most(4); // Not recommended
	   *
	   *     expect([1, 2, 3]).to.have.lengthOf(3); // Recommended
	   *     expect([1, 2, 3]).to.have.lengthOf.at.most(4); // Not recommended
	   *
	   * Add `.not` earlier in the chain to negate `.most`.
	   *
	   *     expect(2).to.equal(2); // Recommended
	   *     expect(2).to.not.be.at.most(1); // Not recommended
	   *
	   * `.most` accepts an optional `msg` argument which is a custom error message
	   * to show when the assertion fails. The message can also be given as the
	   * second argument to `expect`.
	   *
	   *     expect(2).to.be.at.most(1, 'nooo why fail??');
	   *     expect(2, 'nooo why fail??').to.be.at.most(1);
	   *
	   * The alias `.lte` can be used interchangeably with `.most`.
	   *
	   * @name most
	   * @alias lte
	   * @param {Number} n
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function assertMost (n, msg) {
	    if (msg) flag(this, 'message', msg);
	    var obj = flag(this, 'object')
	      , doLength = flag(this, 'doLength')
	      , flagMsg = flag(this, 'message')
	      , msgPrefix = ((flagMsg) ? flagMsg + ': ' : '')
	      , ssfi = flag(this, 'ssfi')
	      , objType = _.type(obj).toLowerCase()
	      , nType = _.type(n).toLowerCase()
	      , shouldThrow = true;
	
	    if (doLength) {
	      new Assertion(obj, flagMsg, ssfi, true).to.have.property('length');
	    }
	    
	    if (!doLength && (objType === 'date' && nType !== 'date')) {
	      errorMessage = msgPrefix + 'the argument to most must be a date';
	    } else if (nType !== 'number' && (doLength || objType === 'number')) {
	      errorMessage = msgPrefix + 'the argument to most must be a number';
	    } else if (!doLength && (objType !== 'date' && objType !== 'number')) {
	      var printObj = (objType === 'string') ? "'" + obj + "'" : obj;
	      errorMessage = msgPrefix + 'expected ' + printObj + ' to be a number or a date';
	    } else {
	      shouldThrow = false;
	    }
	
	    if (shouldThrow) {
	      throw new AssertionError(errorMessage, undefined, ssfi);
	    }
	
	    if (doLength) {
	      var len = obj.length;
	      this.assert(
	          len <= n
	        , 'expected #{this} to have a length at most #{exp} but got #{act}'
	        , 'expected #{this} to have a length above #{exp}'
	        , n
	        , len
	      );
	    } else {
	      this.assert(
	          obj <= n
	        , 'expected #{this} to be at most #{exp}'
	        , 'expected #{this} to be above #{exp}'
	        , n
	      );
	    }
	  }
	
	  Assertion.addMethod('most', assertMost);
	  Assertion.addMethod('lte', assertMost);
	
	  /**
	   * ### .within(start, finish[, msg])
	   *
	   * Asserts that the target is a number or a date greater than or equal to the given
	   * number or date `start`, and less than or equal to the given number or date `finish` respectively.
	   * However, it's often best to assert that the target is equal to its expected
	   * value.
	   *
	   *     expect(2).to.equal(2); // Recommended
	   *     expect(2).to.be.within(1, 3); // Not recommended
	   *     expect(2).to.be.within(2, 3); // Not recommended
	   *     expect(2).to.be.within(1, 2); // Not recommended
	   *
	   * Add `.lengthOf` earlier in the chain to assert that the value of the
	   * target's `length` property is greater than or equal to the given number
	   * `start`, and less than or equal to the given number `finish`.
	   *
	   *     expect('foo').to.have.lengthOf(3); // Recommended
	   *     expect('foo').to.have.lengthOf.within(2, 4); // Not recommended
	   *
	   *     expect([1, 2, 3]).to.have.lengthOf(3); // Recommended
	   *     expect([1, 2, 3]).to.have.lengthOf.within(2, 4); // Not recommended
	   *
	   * Add `.not` earlier in the chain to negate `.within`.
	   *
	   *     expect(1).to.equal(1); // Recommended
	   *     expect(1).to.not.be.within(2, 4); // Not recommended
	   *
	   * `.within` accepts an optional `msg` argument which is a custom error
	   * message to show when the assertion fails. The message can also be given as
	   * the second argument to `expect`.
	   *
	   *     expect(4).to.be.within(1, 3, 'nooo why fail??');
	   *     expect(4, 'nooo why fail??').to.be.within(1, 3);
	   *
	   * @name within
	   * @param {Number} start lower bound inclusive
	   * @param {Number} finish upper bound inclusive
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addMethod('within', function (start, finish, msg) {
	    if (msg) flag(this, 'message', msg);
	    var obj = flag(this, 'object')
	      , doLength = flag(this, 'doLength')
	      , flagMsg = flag(this, 'message')
	      , msgPrefix = ((flagMsg) ? flagMsg + ': ' : '')
	      , ssfi = flag(this, 'ssfi')
	      , objType = _.type(obj).toLowerCase()
	      , startType = _.type(start).toLowerCase()
	      , finishType = _.type(finish).toLowerCase()
	      , shouldThrow = true
	      , range = (startType === 'date' && finishType === 'date')
	          ? start.toUTCString() + '..' + finish.toUTCString()
	          : start + '..' + finish;
	
	    if (doLength) {
	      new Assertion(obj, flagMsg, ssfi, true).to.have.property('length');
	    }
	
	    if (!doLength && (objType === 'date' && (startType !== 'date' || finishType !== 'date'))) {
	      errorMessage = msgPrefix + 'the arguments to within must be dates';
	    } else if ((startType !== 'number' || finishType !== 'number') && (doLength || objType === 'number')) {
	      errorMessage = msgPrefix + 'the arguments to within must be numbers';
	    } else if (!doLength && (objType !== 'date' && objType !== 'number')) {
	      var printObj = (objType === 'string') ? "'" + obj + "'" : obj;
	      errorMessage = msgPrefix + 'expected ' + printObj + ' to be a number or a date';
	    } else {
	      shouldThrow = false;
	    }
	
	    if (shouldThrow) {
	      throw new AssertionError(errorMessage, undefined, ssfi);
	    }
	
	    if (doLength) {
	      var len = obj.length;
	      this.assert(
	          len >= start && len <= finish
	        , 'expected #{this} to have a length within ' + range
	        , 'expected #{this} to not have a length within ' + range
	      );
	    } else {
	      this.assert(
	          obj >= start && obj <= finish
	        , 'expected #{this} to be within ' + range
	        , 'expected #{this} to not be within ' + range
	      );
	    }
	  });
	
	  /**
	   * ### .instanceof(constructor[, msg])
	   *
	   * Asserts that the target is an instance of the given `constructor`.
	   *
	   *     function Cat () { }
	   *
	   *     expect(new Cat()).to.be.an.instanceof(Cat);
	   *     expect([1, 2]).to.be.an.instanceof(Array);
	   *
	   * Add `.not` earlier in the chain to negate `.instanceof`.
	   *
	   *     expect({a: 1}).to.not.be.an.instanceof(Array);
	   *
	   * `.instanceof` accepts an optional `msg` argument which is a custom error
	   * message to show when the assertion fails. The message can also be given as
	   * the second argument to `expect`.
	   *
	   *     expect(1).to.be.an.instanceof(Array, 'nooo why fail??');
	   *     expect(1, 'nooo why fail??').to.be.an.instanceof(Array);
	   *
	   * Due to limitations in ES5, `.instanceof` may not always work as expected
	   * when using a transpiler such as Babel or TypeScript. In particular, it may
	   * produce unexpected results when subclassing built-in object such as
	   * `Array`, `Error`, and `Map`. See your transpiler's docs for details:
	   *
	   * - ([Babel](https://babeljs.io/docs/usage/caveats/#classes))
	   * - ([TypeScript](https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work))
	   *
	   * The alias `.instanceOf` can be used interchangeably with `.instanceof`.
	   *
	   * @name instanceof
	   * @param {Constructor} constructor
	   * @param {String} msg _optional_
	   * @alias instanceOf
	   * @namespace BDD
	   * @api public
	   */
	
	  function assertInstanceOf (constructor, msg) {
	    if (msg) flag(this, 'message', msg);
	
	    var target = flag(this, 'object')
	    var ssfi = flag(this, 'ssfi');
	    var flagMsg = flag(this, 'message');
	
	    try {
	      var isInstanceOf = target instanceof constructor;
	    } catch (err) {
	      if (err instanceof TypeError) {
	        flagMsg = flagMsg ? flagMsg + ': ' : '';
	        throw new AssertionError(
	          flagMsg + 'The instanceof assertion needs a constructor but '
	            + _.type(constructor) + ' was given.',
	          undefined,
	          ssfi
	        );
	      }
	      throw err;
	    }
	
	    var name = _.getName(constructor);
	    if (name === null) {
	      name = 'an unnamed constructor';
	    }
	
	    this.assert(
	        isInstanceOf
	      , 'expected #{this} to be an instance of ' + name
	      , 'expected #{this} to not be an instance of ' + name
	    );
	  };
	
	  Assertion.addMethod('instanceof', assertInstanceOf);
	  Assertion.addMethod('instanceOf', assertInstanceOf);
	
	  /**
	   * ### .property(name[, val[, msg]])
	   *
	   * Asserts that the target has a property with the given key `name`.
	   *
	   *     expect({a: 1}).to.have.property('a');
	   *
	   * When `val` is provided, `.property` also asserts that the property's value
	   * is equal to the given `val`.
	   *
	   *     expect({a: 1}).to.have.property('a', 1);
	   *
	   * By default, strict (`===`) equality is used. Add `.deep` earlier in the
	   * chain to use deep equality instead. See the `deep-eql` project page for
	   * info on the deep equality algorithm: https://github.com/chaijs/deep-eql.
	   *
	   *     // Target object deeply (but not strictly) has property `x: {a: 1}`
	   *     expect({x: {a: 1}}).to.have.deep.property('x', {a: 1});
	   *     expect({x: {a: 1}}).to.not.have.property('x', {a: 1});
	   *
	   * The target's enumerable and non-enumerable properties are always included
	   * in the search. By default, both own and inherited properties are included.
	   * Add `.own` earlier in the chain to exclude inherited properties from the
	   * search.
	   *
	   *     Object.prototype.b = 2;
	   *
	   *     expect({a: 1}).to.have.own.property('a');
	   *     expect({a: 1}).to.have.own.property('a', 1);
	   *     expect({a: 1}).to.have.property('b').but.not.own.property('b'); 
	   *
	   * `.deep` and `.own` can be combined.
	   *
	   *     expect({x: {a: 1}}).to.have.deep.own.property('x', {a: 1});
	   *
	   * Add `.nested` earlier in the chain to enable dot- and bracket-notation when
	   * referencing nested properties.
	   *
	   *     expect({a: {b: ['x', 'y']}}).to.have.nested.property('a.b[1]');
	   *     expect({a: {b: ['x', 'y']}}).to.have.nested.property('a.b[1]', 'y');
	   *
	   * If `.` or `[]` are part of an actual property name, they can be escaped by
	   * adding two backslashes before them.
	   *
	   *     expect({'.a': {'[b]': 'x'}}).to.have.nested.property('\\.a.\\[b\\]');
	   *
	   * `.deep` and `.nested` can be combined.
	   *
	   *     expect({a: {b: [{c: 3}]}})
	   *       .to.have.deep.nested.property('a.b[0]', {c: 3});
	   *
	   * `.own` and `.nested` cannot be combined.
	   *
	   * Add `.not` earlier in the chain to negate `.property`.
	   *
	   *     expect({a: 1}).to.not.have.property('b');
	   * 
	   * However, it's dangerous to negate `.property` when providing `val`. The
	   * problem is that it creates uncertain expectations by asserting that the
	   * target either doesn't have a property with the given key `name`, or that it
	   * does have a property with the given key `name` but its value isn't equal to
	   * the given `val`. It's often best to identify the exact output that's
	   * expected, and then write an assertion that only accepts that exact output.
	   *
	   * When the target isn't expected to have a property with the given key
	   * `name`, it's often best to assert exactly that.
	   *
	   *     expect({b: 2}).to.not.have.property('a'); // Recommended
	   *     expect({b: 2}).to.not.have.property('a', 1); // Not recommended
	   *
	   * When the target is expected to have a property with the given key `name`,
	   * it's often best to assert that the property has its expected value, rather
	   * than asserting that it doesn't have one of many unexpected values.
	   *
	   *     expect({a: 3}).to.have.property('a', 3); // Recommended
	   *     expect({a: 3}).to.not.have.property('a', 1); // Not recommended
	   *
	   * `.property` changes the target of any assertions that follow in the chain
	   * to be the value of the property from the original target object.
	   *
	   *     expect({a: 1}).to.have.property('a').that.is.a('number');
	   *
	   * `.property` accepts an optional `msg` argument which is a custom error
	   * message to show when the assertion fails. The message can also be given as
	   * the second argument to `expect`. When not providing `val`, only use the
	   * second form.
	   *
	   *     // Recommended
	   *     expect({a: 1}).to.have.property('a', 2, 'nooo why fail??');
	   *     expect({a: 1}, 'nooo why fail??').to.have.property('a', 2);
	   *     expect({a: 1}, 'nooo why fail??').to.have.property('b');
	   *
	   *     // Not recommended
	   *     expect({a: 1}).to.have.property('b', undefined, 'nooo why fail??');
	   * 
	   * The above assertion isn't the same thing as not providing `val`. Instead,
	   * it's asserting that the target object has a `b` property that's equal to
	   * `undefined`.
	   *
	   * The assertions `.ownProperty` and `.haveOwnProperty` can be used
	   * interchangeably with `.own.property`.
	   *
	   * @name property
	   * @param {String} name
	   * @param {Mixed} val (optional)
	   * @param {String} msg _optional_
	   * @returns value of property for chaining
	   * @namespace BDD
	   * @api public
	   */
	
	  function assertProperty (name, val, msg) {
	    if (msg) flag(this, 'message', msg);
	
	    var isNested = flag(this, 'nested')
	      , isOwn = flag(this, 'own')
	      , flagMsg = flag(this, 'message')
	      , obj = flag(this, 'object')
	      , ssfi = flag(this, 'ssfi');
	
	    if (isNested && isOwn) {
	      flagMsg = flagMsg ? flagMsg + ': ' : '';
	      throw new AssertionError(
	        flagMsg + 'The "nested" and "own" flags cannot be combined.',
	        undefined,
	        ssfi
	      );
	    }
	
	    if (obj === null || obj === undefined) {
	      flagMsg = flagMsg ? flagMsg + ': ' : '';
	      throw new AssertionError(
	        flagMsg + 'Target cannot be null or undefined.',
	        undefined,
	        ssfi
	      );
	    }
	
	    var isDeep = flag(this, 'deep')
	      , negate = flag(this, 'negate')
	      , pathInfo = isNested ? _.getPathInfo(obj, name) : null
	      , value = isNested ? pathInfo.value : obj[name];
	
	    var descriptor = '';
	    if (isDeep) descriptor += 'deep ';
	    if (isOwn) descriptor += 'own ';
	    if (isNested) descriptor += 'nested ';
	    descriptor += 'property ';
	
	    var hasProperty;
	    if (isOwn) hasProperty = Object.prototype.hasOwnProperty.call(obj, name);
	    else if (isNested) hasProperty = pathInfo.exists;
	    else hasProperty = _.hasProperty(obj, name);
	
	    // When performing a negated assertion for both name and val, merely having
	    // a property with the given name isn't enough to cause the assertion to
	    // fail. It must both have a property with the given name, and the value of
	    // that property must equal the given val. Therefore, skip this assertion in
	    // favor of the next.
	    if (!negate || arguments.length === 1) {
	      this.assert(
	          hasProperty
	        , 'expected #{this} to have ' + descriptor + _.inspect(name)
	        , 'expected #{this} to not have ' + descriptor + _.inspect(name));
	    }
	
	    if (arguments.length > 1) {
	      this.assert(
	          hasProperty && (isDeep ? _.eql(val, value) : val === value)
	        , 'expected #{this} to have ' + descriptor + _.inspect(name) + ' of #{exp}, but got #{act}'
	        , 'expected #{this} to not have ' + descriptor + _.inspect(name) + ' of #{act}'
	        , val
	        , value
	      );
	    }
	
	    flag(this, 'object', value);
	  }
	
	  Assertion.addMethod('property', assertProperty);
	
	  function assertOwnProperty (name, value, msg) {
	    flag(this, 'own', true);
	    assertProperty.apply(this, arguments);
	  }
	
	  Assertion.addMethod('ownProperty', assertOwnProperty);
	  Assertion.addMethod('haveOwnProperty', assertOwnProperty);
	
	  /**
	   * ### .ownPropertyDescriptor(name[, descriptor[, msg]])
	   *
	   * Asserts that the target has its own property descriptor with the given key
	   * `name`. Enumerable and non-enumerable properties are included in the
	   * search.
	   *
	   *     expect({a: 1}).to.have.ownPropertyDescriptor('a');
	   *
	   * When `descriptor` is provided, `.ownPropertyDescriptor` also asserts that
	   * the property's descriptor is deeply equal to the given `descriptor`. See
	   * the `deep-eql` project page for info on the deep equality algorithm:
	   * https://github.com/chaijs/deep-eql.
	   *
	   *     expect({a: 1}).to.have.ownPropertyDescriptor('a', {
	   *       configurable: true,
	   *       enumerable: true,
	   *       writable: true,
	   *       value: 1,
	   *     });
	   *
	   * Add `.not` earlier in the chain to negate `.ownPropertyDescriptor`.
	   *
	   *     expect({a: 1}).to.not.have.ownPropertyDescriptor('b');
	   * 
	   * However, it's dangerous to negate `.ownPropertyDescriptor` when providing
	   * a `descriptor`. The problem is that it creates uncertain expectations by
	   * asserting that the target either doesn't have a property descriptor with
	   * the given key `name`, or that it does have a property descriptor with the
	   * given key `name` but its not deeply equal to the given `descriptor`. It's
	   * often best to identify the exact output that's expected, and then write an
	   * assertion that only accepts that exact output.
	   *
	   * When the target isn't expected to have a property descriptor with the given
	   * key `name`, it's often best to assert exactly that.
	   *
	   *     // Recommended
	   *     expect({b: 2}).to.not.have.ownPropertyDescriptor('a');
	   *
	   *     // Not recommended
	   *     expect({b: 2}).to.not.have.ownPropertyDescriptor('a', {
	   *       configurable: true,
	   *       enumerable: true,
	   *       writable: true,
	   *       value: 1,
	   *     });
	   *
	   * When the target is expected to have a property descriptor with the given
	   * key `name`, it's often best to assert that the property has its expected
	   * descriptor, rather than asserting that it doesn't have one of many
	   * unexpected descriptors.
	   *
	   *     // Recommended
	   *     expect({a: 3}).to.have.ownPropertyDescriptor('a', {
	   *       configurable: true,
	   *       enumerable: true,
	   *       writable: true,
	   *       value: 3,
	   *     });
	   *
	   *     // Not recommended
	   *     expect({a: 3}).to.not.have.ownPropertyDescriptor('a', {
	   *       configurable: true,
	   *       enumerable: true,
	   *       writable: true,
	   *       value: 1,
	   *     });
	   *
	   * `.ownPropertyDescriptor` changes the target of any assertions that follow
	   * in the chain to be the value of the property descriptor from the original
	   * target object.
	   *
	   *     expect({a: 1}).to.have.ownPropertyDescriptor('a')
	   *       .that.has.property('enumerable', true);
	   *
	   * `.ownPropertyDescriptor` accepts an optional `msg` argument which is a
	   * custom error message to show when the assertion fails. The message can also
	   * be given as the second argument to `expect`. When not providing
	   * `descriptor`, only use the second form.
	   *
	   *     // Recommended
	   *     expect({a: 1}).to.have.ownPropertyDescriptor('a', {
	   *       configurable: true,
	   *       enumerable: true,
	   *       writable: true,
	   *       value: 2,
	   *     }, 'nooo why fail??');
	   *
	   *     // Recommended
	   *     expect({a: 1}, 'nooo why fail??').to.have.ownPropertyDescriptor('a', {
	   *       configurable: true,
	   *       enumerable: true,
	   *       writable: true,
	   *       value: 2,
	   *     });
	   * 
	   *     // Recommended
	   *     expect({a: 1}, 'nooo why fail??').to.have.ownPropertyDescriptor('b');
	   *
	   *     // Not recommended
	   *     expect({a: 1})
	   *       .to.have.ownPropertyDescriptor('b', undefined, 'nooo why fail??');
	   *
	   * The above assertion isn't the same thing as not providing `descriptor`.
	   * Instead, it's asserting that the target object has a `b` property
	   * descriptor that's deeply equal to `undefined`.
	   *
	   * The alias `.haveOwnPropertyDescriptor` can be used interchangeably with
	   * `.ownPropertyDescriptor`.
	   *
	   * @name ownPropertyDescriptor
	   * @alias haveOwnPropertyDescriptor
	   * @param {String} name
	   * @param {Object} descriptor _optional_
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function assertOwnPropertyDescriptor (name, descriptor, msg) {
	    if (typeof descriptor === 'string') {
	      msg = descriptor;
	      descriptor = null;
	    }
	    if (msg) flag(this, 'message', msg);
	    var obj = flag(this, 'object');
	    var actualDescriptor = Object.getOwnPropertyDescriptor(Object(obj), name);
	    if (actualDescriptor && descriptor) {
	      this.assert(
	          _.eql(descriptor, actualDescriptor)
	        , 'expected the own property descriptor for ' + _.inspect(name) + ' on #{this} to match ' + _.inspect(descriptor) + ', got ' + _.inspect(actualDescriptor)
	        , 'expected the own property descriptor for ' + _.inspect(name) + ' on #{this} to not match ' + _.inspect(descriptor)
	        , descriptor
	        , actualDescriptor
	        , true
	      );
	    } else {
	      this.assert(
	          actualDescriptor
	        , 'expected #{this} to have an own property descriptor for ' + _.inspect(name)
	        , 'expected #{this} to not have an own property descriptor for ' + _.inspect(name)
	      );
	    }
	    flag(this, 'object', actualDescriptor);
	  }
	
	  Assertion.addMethod('ownPropertyDescriptor', assertOwnPropertyDescriptor);
	  Assertion.addMethod('haveOwnPropertyDescriptor', assertOwnPropertyDescriptor);
	
	  /**
	   * ### .lengthOf(n[, msg])
	   *
	   * Asserts that the target's `length` property is equal to the given number
	   * `n`.
	   *
	   *     expect([1, 2, 3]).to.have.lengthOf(3);
	   *     expect('foo').to.have.lengthOf(3);
	   *
	   * Add `.not` earlier in the chain to negate `.lengthOf`. However, it's often
	   * best to assert that the target's `length` property is equal to its expected
	   * value, rather than not equal to one of many unexpected values.
	   *
	   *     expect('foo').to.have.lengthOf(3); // Recommended
	   *     expect('foo').to.not.have.lengthOf(4); // Not recommended
	   *
	   * `.lengthOf` accepts an optional `msg` argument which is a custom error
	   * message to show when the assertion fails. The message can also be given as
	   * the second argument to `expect`.
	   *
	   *     expect([1, 2, 3]).to.have.lengthOf(2, 'nooo why fail??');
	   *     expect([1, 2, 3], 'nooo why fail??').to.have.lengthOf(2);
	   *
	   * `.lengthOf` can also be used as a language chain, causing all `.above`,
	   * `.below`, `.least`, `.most`, and `.within` assertions that follow in the
	   * chain to use the target's `length` property as the target. However, it's
	   * often best to assert that the target's `length` property is equal to its
	   * expected length, rather than asserting that its `length` property falls
	   * within some range of values.
	   *
	   *     // Recommended
	   *     expect([1, 2, 3]).to.have.lengthOf(3);
	   *
	   *     // Not recommended
	   *     expect([1, 2, 3]).to.have.lengthOf.above(2);
	   *     expect([1, 2, 3]).to.have.lengthOf.below(4);
	   *     expect([1, 2, 3]).to.have.lengthOf.at.least(3);
	   *     expect([1, 2, 3]).to.have.lengthOf.at.most(3);
	   *     expect([1, 2, 3]).to.have.lengthOf.within(2,4);
	   *
	   * Due to a compatibility issue, the alias `.length` can't be chained directly
	   * off of an uninvoked method such as `.a`. Therefore, `.length` can't be used
	   * interchangeably with `.lengthOf` in every situation. It's recommended to
	   * always use `.lengthOf` instead of `.length`.
	   *
	   *     expect([1, 2, 3]).to.have.a.length(3); // incompatible; throws error
	   *     expect([1, 2, 3]).to.have.a.lengthOf(3);  // passes as expected
	   *
	   * @name lengthOf
	   * @alias length
	   * @param {Number} n
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function assertLengthChain () {
	    flag(this, 'doLength', true);
	  }
	
	  function assertLength (n, msg) {
	    if (msg) flag(this, 'message', msg);
	    var obj = flag(this, 'object')
	      , flagMsg = flag(this, 'message')
	      , ssfi = flag(this, 'ssfi');
	    new Assertion(obj, flagMsg, ssfi, true).to.have.property('length');
	    var len = obj.length;
	
	    this.assert(
	        len == n
	      , 'expected #{this} to have a length of #{exp} but got #{act}'
	      , 'expected #{this} to not have a length of #{act}'
	      , n
	      , len
	    );
	  }
	
	  Assertion.addChainableMethod('length', assertLength, assertLengthChain);
	  Assertion.addChainableMethod('lengthOf', assertLength, assertLengthChain);
	
	  /**
	   * ### .match(re[, msg])
	   *
	   * Asserts that the target matches the given regular expression `re`.
	   *
	   *     expect('foobar').to.match(/^foo/);
	   *
	   * Add `.not` earlier in the chain to negate `.match`.
	   *
	   *     expect('foobar').to.not.match(/taco/);
	   *
	   * `.match` accepts an optional `msg` argument which is a custom error message
	   * to show when the assertion fails. The message can also be given as the
	   * second argument to `expect`.
	   *
	   *     expect('foobar').to.match(/taco/, 'nooo why fail??');
	   *     expect('foobar', 'nooo why fail??').to.match(/taco/);
	   *
	   * The alias `.matches` can be used interchangeably with `.match`.
	   *
	   * @name match
	   * @alias matches
	   * @param {RegExp} re
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	  function assertMatch(re, msg) {
	    if (msg) flag(this, 'message', msg);
	    var obj = flag(this, 'object');
	    this.assert(
	        re.exec(obj)
	      , 'expected #{this} to match ' + re
	      , 'expected #{this} not to match ' + re
	    );
	  }
	
	  Assertion.addMethod('match', assertMatch);
	  Assertion.addMethod('matches', assertMatch);
	
	  /**
	   * ### .string(str[, msg])
	   *
	   * Asserts that the target string contains the given substring `str`.
	   *
	   *     expect('foobar').to.have.string('bar');
	   *
	   * Add `.not` earlier in the chain to negate `.string`.
	   *
	   *     expect('foobar').to.not.have.string('taco');
	   *
	   * `.string` accepts an optional `msg` argument which is a custom error
	   * message to show when the assertion fails. The message can also be given as
	   * the second argument to `expect`.
	   *
	   *     expect('foobar').to.have.string(/taco/, 'nooo why fail??');
	   *     expect('foobar', 'nooo why fail??').to.have.string(/taco/);
	   *
	   * @name string
	   * @param {String} str
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addMethod('string', function (str, msg) {
	    if (msg) flag(this, 'message', msg);
	    var obj = flag(this, 'object')
	      , flagMsg = flag(this, 'message')
	      , ssfi = flag(this, 'ssfi');
	    new Assertion(obj, flagMsg, ssfi, true).is.a('string');
	
	    this.assert(
	        ~obj.indexOf(str)
	      , 'expected #{this} to contain ' + _.inspect(str)
	      , 'expected #{this} to not contain ' + _.inspect(str)
	    );
	  });
	
	  /**
	   * ### .keys(key1[, key2[, ...]])
	   *
	   * Asserts that the target object, array, map, or set has the given keys. Only
	   * the target's own inherited properties are included in the search. 
	   *
	   * When the target is an object or array, keys can be provided as one or more
	   * string arguments, a single array argument, or a single object argument. In
	   * the latter case, only the keys in the given object matter; the values are
	   * ignored.
	   *
	   *     expect({a: 1, b: 2}).to.have.all.keys('a', 'b');
	   *     expect(['x', 'y']).to.have.all.keys(0, 1);
	   *
	   *     expect({a: 1, b: 2}).to.have.all.keys(['a', 'b']);
	   *     expect(['x', 'y']).to.have.all.keys([0, 1]);
	   *
	   *     expect({a: 1, b: 2}).to.have.all.keys({a: 4, b: 5}); // ignore 4 and 5
	   *     expect(['x', 'y']).to.have.all.keys({0: 4, 1: 5}); // ignore 4 and 5
	   *
	   * When the target is a map or set, each key must be provided as a separate
	   * argument.
	   *
	   *     expect(new Map([['a', 1], ['b', 2]])).to.have.all.keys('a', 'b');
	   *     expect(new Set(['a', 'b'])).to.have.all.keys('a', 'b');
	   *
	   * Because `.keys` does different things based on the target's type, it's
	   * important to check the target's type before using `.keys`. See the `.a` doc
	   * for info on testing a target's type.
	   *
	   *     expect({a: 1, b: 2}).to.be.an('object').that.has.all.keys('a', 'b');
	   *
	   * By default, strict (`===`) equality is used to compare keys of maps and
	   * sets. Add `.deep` earlier in the chain to use deep equality instead. See
	   * the `deep-eql` project page for info on the deep equality algorithm:
	   * https://github.com/chaijs/deep-eql.
	   *
	   *     // Target set deeply (but not strictly) has key `{a: 1}`
	   *     expect(new Set([{a: 1}])).to.have.all.deep.keys([{a: 1}]);
	   *     expect(new Set([{a: 1}])).to.not.have.all.keys([{a: 1}]);
	   *
	   * By default, the target must have all of the given keys and no more. Add
	   * `.any` earlier in the chain to only require that the target have at least
	   * one of the given keys. Also, add `.not` earlier in the chain to negate
	   * `.keys`. It's often best to add `.any` when negating `.keys`, and to use
	   * `.all` when asserting `.keys` without negation.
	   *
	   * When negating `.keys`, `.any` is preferred because `.not.any.keys` asserts
	   * exactly what's expected of the output, whereas `.not.all.keys` creates
	   * uncertain expectations.
	   *
	   *     // Recommended; asserts that target doesn't have any of the given keys
	   *     expect({a: 1, b: 2}).to.not.have.any.keys('c', 'd');
	   *
	   *     // Not recommended; asserts that target doesn't have all of the given
	   *     // keys but may or may not have some of them
	   *     expect({a: 1, b: 2}).to.not.have.all.keys('c', 'd');
	   *
	   * When asserting `.keys` without negation, `.all` is preferred because
	   * `.all.keys` asserts exactly what's expected of the output, whereas
	   * `.any.keys` creates uncertain expectations.
	   *
	   *     // Recommended; asserts that target has all the given keys
	   *     expect({a: 1, b: 2}).to.have.all.keys('a', 'b');
	   *
	   *     // Not recommended; asserts that target has at least one of the given
	   *     // keys but may or may not have more of them
	   *     expect({a: 1, b: 2}).to.have.any.keys('a', 'b');
	   *
	   * Note that `.all` is used by default when neither `.all` nor `.any` appear
	   * earlier in the chain. However, it's often best to add `.all` anyway because
	   * it improves readability.
	   *
	   *     // Both assertions are identical
	   *     expect({a: 1, b: 2}).to.have.all.keys('a', 'b'); // Recommended
	   *     expect({a: 1, b: 2}).to.have.keys('a', 'b'); // Not recommended
	   *
	   * Add `.include` earlier in the chain to require that the target's keys be a
	   * superset of the expected keys, rather than identical sets.
	   *
	   *     // Target object's keys are a superset of ['a', 'b'] but not identical
	   *     expect({a: 1, b: 2, c: 3}).to.include.all.keys('a', 'b');
	   *     expect({a: 1, b: 2, c: 3}).to.not.have.all.keys('a', 'b');
	   *
	   * However, if `.any` and `.include` are combined, only the `.any` takes
	   * effect. The `.include` is ignored in this case.
	   *
	   *     // Both assertions are identical
	   *     expect({a: 1}).to.have.any.keys('a', 'b');
	   *     expect({a: 1}).to.include.any.keys('a', 'b');
	   *
	   * A custom error message can be given as the second argument to `expect`.
	   *
	   *     expect({a: 1}, 'nooo why fail??').to.have.key('b');
	   *
	   * The alias `.key` can be used interchangeably with `.keys`.
	   *
	   * @name keys
	   * @alias key
	   * @param {...String|Array|Object} keys
	   * @namespace BDD
	   * @api public
	   */
	
	  function assertKeys (keys) {
	    var obj = flag(this, 'object')
	      , objType = _.type(obj)
	      , keysType = _.type(keys)
	      , ssfi = flag(this, 'ssfi')
	      , isDeep = flag(this, 'deep')
	      , str
	      , deepStr = ''
	      , ok = true
	      , flagMsg = flag(this, 'message');
	
	    flagMsg = flagMsg ? flagMsg + ': ' : '';
	    var mixedArgsMsg = flagMsg + 'when testing keys against an object or an array you must give a single Array|Object|String argument or multiple String arguments';
	
	    if (objType === 'Map' || objType === 'Set') {
	      deepStr = isDeep ? 'deeply ' : '';
	      actual = [];
	
	      // Map and Set '.keys' aren't supported in IE 11. Therefore, use .forEach.
	      obj.forEach(function (val, key) { actual.push(key) });
	
	      if (keysType !== 'Array') {
	        keys = Array.prototype.slice.call(arguments);
	      }
	
	    } else {
	      actual = _.getOwnEnumerableProperties(obj);
	
	      switch (keysType) {
	        case 'Array':
	          if (arguments.length > 1) {
	            throw new AssertionError(mixedArgsMsg, undefined, ssfi);
	          }
	          break;
	        case 'Object':
	          if (arguments.length > 1) {
	            throw new AssertionError(mixedArgsMsg, undefined, ssfi);
	          }
	          keys = Object.keys(keys);
	          break;
	        default:
	          keys = Array.prototype.slice.call(arguments);
	      }
	
	      // Only stringify non-Symbols because Symbols would become "Symbol()"
	      keys = keys.map(function (val) {
	        return typeof val === 'symbol' ? val : String(val);
	      });
	    }
	
	    if (!keys.length) {
	      throw new AssertionError(flagMsg + 'keys required', undefined, ssfi);
	    }
	
	    var len = keys.length
	      , any = flag(this, 'any')
	      , all = flag(this, 'all')
	      , expected = keys
	      , actual;
	
	    if (!any && !all) {
	      all = true;
	    }
	
	    // Has any
	    if (any) {
	      ok = expected.some(function(expectedKey) {
	        return actual.some(function(actualKey) {
	          if (isDeep) {
	            return _.eql(expectedKey, actualKey);
	          } else {
	            return expectedKey === actualKey;
	          }
	        });
	      });
	    }
	
	    // Has all
	    if (all) {
	      ok = expected.every(function(expectedKey) {
	        return actual.some(function(actualKey) {
	          if (isDeep) {
	            return _.eql(expectedKey, actualKey);
	          } else {
	            return expectedKey === actualKey;
	          }
	        });
	      });
	
	      if (!flag(this, 'contains')) {
	        ok = ok && keys.length == actual.length;
	      }
	    }
	
	    // Key string
	    if (len > 1) {
	      keys = keys.map(function(key) {
	        return _.inspect(key);
	      });
	      var last = keys.pop();
	      if (all) {
	        str = keys.join(', ') + ', and ' + last;
	      }
	      if (any) {
	        str = keys.join(', ') + ', or ' + last;
	      }
	    } else {
	      str = _.inspect(keys[0]);
	    }
	
	    // Form
	    str = (len > 1 ? 'keys ' : 'key ') + str;
	
	    // Have / include
	    str = (flag(this, 'contains') ? 'contain ' : 'have ') + str;
	
	    // Assertion
	    this.assert(
	        ok
	      , 'expected #{this} to ' + deepStr + str
	      , 'expected #{this} to not ' + deepStr + str
	      , expected.slice(0).sort(_.compareByInspect)
	      , actual.sort(_.compareByInspect)
	      , true
	    );
	  }
	
	  Assertion.addMethod('keys', assertKeys);
	  Assertion.addMethod('key', assertKeys);
	
	  /**
	   * ### .throw([errorLike], [errMsgMatcher], [msg])
	   *
	   * When no arguments are provided, `.throw` invokes the target function and
	   * asserts that an error is thrown.
	   * 
	   *     var badFn = function () { throw new TypeError('Illegal salmon!'); };
	   *
	   *     expect(badFn).to.throw();
	   *
	   * When one argument is provided, and it's an error constructor, `.throw`
	   * invokes the target function and asserts that an error is thrown that's an
	   * instance of that error constructor.
	   *
	   *     var badFn = function () { throw new TypeError('Illegal salmon!'); };
	   *
	   *     expect(badFn).to.throw(TypeError);
	   *
	   * When one argument is provided, and it's an error instance, `.throw` invokes
	   * the target function and asserts that an error is thrown that's strictly
	   * (`===`) equal to that error instance.
	   *
	   *     var err = new TypeError('Illegal salmon!');
	   *     var badFn = function () { throw err; };
	   *
	   *     expect(badFn).to.throw(err);
	   *
	   * When one argument is provided, and it's a string, `.throw` invokes the
	   * target function and asserts that an error is thrown with a message that
	   * contains that string.
	   *
	   *     var badFn = function () { throw new TypeError('Illegal salmon!'); };
	   *
	   *     expect(badFn).to.throw('salmon');
	   *
	   * When one argument is provided, and it's a regular expression, `.throw`
	   * invokes the target function and asserts that an error is thrown with a
	   * message that matches that regular expression.
	   *
	   *     var badFn = function () { throw new TypeError('Illegal salmon!'); };
	   *
	   *     expect(badFn).to.throw(/salmon/);
	   *
	   * When two arguments are provided, and the first is an error instance or
	   * constructor, and the second is a string or regular expression, `.throw`
	   * invokes the function and asserts that an error is thrown that fulfills both
	   * conditions as described above.
	   *
	   *     var err = new TypeError('Illegal salmon!');
	   *     var badFn = function () { throw err; };
	   *
	   *     expect(badFn).to.throw(TypeError, 'salmon');
	   *     expect(badFn).to.throw(TypeError, /salmon/);
	   *     expect(badFn).to.throw(err, 'salmon');
	   *     expect(badFn).to.throw(err, /salmon/);
	   *
	   * Add `.not` earlier in the chain to negate `.throw`.
	   *     
	   *     var goodFn = function () {};
	   *
	   *     expect(goodFn).to.not.throw();
	   * 
	   * However, it's dangerous to negate `.throw` when providing any arguments.
	   * The problem is that it creates uncertain expectations by asserting that the
	   * target either doesn't throw an error, or that it throws an error but of a
	   * different type than the given type, or that it throws an error of the given
	   * type but with a message that doesn't include the given string. It's often
	   * best to identify the exact output that's expected, and then write an
	   * assertion that only accepts that exact output.
	   *
	   * When the target isn't expected to throw an error, it's often best to assert
	   * exactly that.
	   *
	   *     var goodFn = function () {};
	   *
	   *     expect(goodFn).to.not.throw(); // Recommended
	   *     expect(goodFn).to.not.throw(ReferenceError, 'x'); // Not recommended
	   *
	   * When the target is expected to throw an error, it's often best to assert
	   * that the error is of its expected type, and has a message that includes an
	   * expected string, rather than asserting that it doesn't have one of many
	   * unexpected types, and doesn't have a message that includes some string.
	   *
	   *     var badFn = function () { throw new TypeError('Illegal salmon!'); };
	   *
	   *     expect(badFn).to.throw(TypeError, 'salmon'); // Recommended
	   *     expect(badFn).to.not.throw(ReferenceError, 'x'); // Not recommended
	   *
	   * `.throw` changes the target of any assertions that follow in the chain to
	   * be the error object that's thrown.
	   *
	   *     var err = new TypeError('Illegal salmon!');
	   *     err.code = 42;
	   *     var badFn = function () { throw err; };
	   *
	   *     expect(badFn).to.throw(TypeError).with.property('code', 42);
	   *
	   * `.throw` accepts an optional `msg` argument which is a custom error message
	   * to show when the assertion fails. The message can also be given as the
	   * second argument to `expect`. When not providing two arguments, always use
	   * the second form.
	   *
	   *     var goodFn = function () {};
	   *
	   *     expect(goodFn).to.throw(TypeError, 'x', 'nooo why fail??');
	   *     expect(goodFn, 'nooo why fail??').to.throw();
	   *
	   * Due to limitations in ES5, `.throw` may not always work as expected when
	   * using a transpiler such as Babel or TypeScript. In particular, it may
	   * produce unexpected results when subclassing the built-in `Error` object and
	   * then passing the subclassed constructor to `.throw`. See your transpiler's
	   * docs for details:
	   *
	   * - ([Babel](https://babeljs.io/docs/usage/caveats/#classes))
	   * - ([TypeScript](https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work))
	   *
	   * Beware of some common mistakes when using the `throw` assertion. One common
	   * mistake is to accidentally invoke the function yourself instead of letting
	   * the `throw` assertion invoke the function for you. For example, when
	   * testing if a function named `fn` throws, provide `fn` instead of `fn()` as
	   * the target for the assertion.
	   *
	   *     expect(fn).to.throw();     // Good! Tests `fn` as desired
	   *     expect(fn()).to.throw();   // Bad! Tests result of `fn()`, not `fn`
	   *
	   * If you need to assert that your function `fn` throws when passed certain
	   * arguments, then wrap a call to `fn` inside of another function.
	   *
	   *     expect(function () { fn(42); }).to.throw();  // Function expression
	   *     expect(() => fn(42)).to.throw();             // ES6 arrow function
	   *
	   * Another common mistake is to provide an object method (or any stand-alone
	   * function that relies on `this`) as the target of the assertion. Doing so is
	   * problematic because the `this` context will be lost when the function is
	   * invoked by `.throw`; there's no way for it to know what `this` is supposed
	   * to be. There are two ways around this problem. One solution is to wrap the
	   * method or function call inside of another function. Another solution is to
	   * use `bind`.
	   *
	   *     expect(function () { cat.meow(); }).to.throw();  // Function expression
	   *     expect(() => cat.meow()).to.throw();             // ES6 arrow function
	   *     expect(cat.meow.bind(cat)).to.throw();           // Bind
	   *
	   * Finally, it's worth mentioning that it's a best practice in JavaScript to
	   * only throw `Error` and derivatives of `Error` such as `ReferenceError`,
	   * `TypeError`, and user-defined objects that extend `Error`. No other type of
	   * value will generate a stack trace when initialized. With that said, the
	   * `throw` assertion does technically support any type of value being thrown,
	   * not just `Error` and its derivatives.
	   *
	   * The aliases `.throws` and `.Throw` can be used interchangeably with
	   * `.throw`.
	   *
	   * @name throw
	   * @alias throws
	   * @alias Throw
	   * @param {Error|ErrorConstructor} errorLike
	   * @param {String|RegExp} errMsgMatcher error message
	   * @param {String} msg _optional_
	   * @see https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Error#Error_types
	   * @returns error for chaining (null if no error)
	   * @namespace BDD
	   * @api public
	   */
	
	  function assertThrows (errorLike, errMsgMatcher, msg) {
	    if (msg) flag(this, 'message', msg);
	    var obj = flag(this, 'object')
	      , ssfi = flag(this, 'ssfi')
	      , flagMsg = flag(this, 'message')
	      , negate = flag(this, 'negate') || false;
	    new Assertion(obj, flagMsg, ssfi, true).is.a('function');
	
	    if (errorLike instanceof RegExp || typeof errorLike === 'string') {
	      errMsgMatcher = errorLike;
	      errorLike = null;
	    }
	
	    var caughtErr;
	    try {
	      obj();
	    } catch (err) {
	      caughtErr = err;
	    }
	
	    // If we have the negate flag enabled and at least one valid argument it means we do expect an error
	    // but we want it to match a given set of criteria
	    var everyArgIsUndefined = errorLike === undefined && errMsgMatcher === undefined;
	
	    // If we've got the negate flag enabled and both args, we should only fail if both aren't compatible
	    // See Issue #551 and PR #683@GitHub
	    var everyArgIsDefined = Boolean(errorLike && errMsgMatcher);
	    var errorLikeFail = false;
	    var errMsgMatcherFail = false;
	
	    // Checking if error was thrown
	    if (everyArgIsUndefined || !everyArgIsUndefined && !negate) {
	      // We need this to display results correctly according to their types
	      var errorLikeString = 'an error';
	      if (errorLike instanceof Error) {
	        errorLikeString = '#{exp}';
	      } else if (errorLike) {
	        errorLikeString = _.checkError.getConstructorName(errorLike);
	      }
	
	      this.assert(
	          caughtErr
	        , 'expected #{this} to throw ' + errorLikeString
	        , 'expected #{this} to not throw an error but #{act} was thrown'
	        , errorLike && errorLike.toString()
	        , (caughtErr instanceof Error ?
	            caughtErr.toString() : (typeof caughtErr === 'string' ? caughtErr : caughtErr &&
	                                    _.checkError.getConstructorName(caughtErr)))
	      );
	    }
	
	    if (errorLike && caughtErr) {
	      // We should compare instances only if `errorLike` is an instance of `Error`
	      if (errorLike instanceof Error) {
	        var isCompatibleInstance = _.checkError.compatibleInstance(caughtErr, errorLike);
	
	        if (isCompatibleInstance === negate) {
	          // These checks were created to ensure we won't fail too soon when we've got both args and a negate
	          // See Issue #551 and PR #683@GitHub
	          if (everyArgIsDefined && negate) {
	            errorLikeFail = true;
	          } else {
	            this.assert(
	                negate
	              , 'expected #{this} to throw #{exp} but #{act} was thrown'
	              , 'expected #{this} to not throw #{exp}' + (caughtErr && !negate ? ' but #{act} was thrown' : '')
	              , errorLike.toString()
	              , caughtErr.toString()
	            );
	          }
	        }
	      }
	
	      var isCompatibleConstructor = _.checkError.compatibleConstructor(caughtErr, errorLike);
	      if (isCompatibleConstructor === negate) {
	        if (everyArgIsDefined && negate) {
	            errorLikeFail = true;
	        } else {
	          this.assert(
	              negate
	            , 'expected #{this} to throw #{exp} but #{act} was thrown'
	            , 'expected #{this} to not throw #{exp}' + (caughtErr ? ' but #{act} was thrown' : '')
	            , (errorLike instanceof Error ? errorLike.toString() : errorLike && _.checkError.getConstructorName(errorLike))
	            , (caughtErr instanceof Error ? caughtErr.toString() : caughtErr && _.checkError.getConstructorName(caughtErr))
	          );
	        }
	      }
	    }
	
	    if (caughtErr && errMsgMatcher !== undefined && errMsgMatcher !== null) {
	      // Here we check compatible messages
	      var placeholder = 'including';
	      if (errMsgMatcher instanceof RegExp) {
	        placeholder = 'matching'
	      }
	
	      var isCompatibleMessage = _.checkError.compatibleMessage(caughtErr, errMsgMatcher);
	      if (isCompatibleMessage === negate) {
	        if (everyArgIsDefined && negate) {
	            errMsgMatcherFail = true;
	        } else {
	          this.assert(
	            negate
	            , 'expected #{this} to throw error ' + placeholder + ' #{exp} but got #{act}'
	            , 'expected #{this} to throw error not ' + placeholder + ' #{exp}'
	            ,  errMsgMatcher
	            ,  _.checkError.getMessage(caughtErr)
	          );
	        }
	      }
	    }
	
	    // If both assertions failed and both should've matched we throw an error
	    if (errorLikeFail && errMsgMatcherFail) {
	      this.assert(
	        negate
	        , 'expected #{this} to throw #{exp} but #{act} was thrown'
	        , 'expected #{this} to not throw #{exp}' + (caughtErr ? ' but #{act} was thrown' : '')
	        , (errorLike instanceof Error ? errorLike.toString() : errorLike && _.checkError.getConstructorName(errorLike))
	        , (caughtErr instanceof Error ? caughtErr.toString() : caughtErr && _.checkError.getConstructorName(caughtErr))
	      );
	    }
	
	    flag(this, 'object', caughtErr);
	  };
	
	  Assertion.addMethod('throw', assertThrows);
	  Assertion.addMethod('throws', assertThrows);
	  Assertion.addMethod('Throw', assertThrows);
	
	  /**
	   * ### .respondTo(method[, msg])
	   *
	   * When the target is a non-function object, `.respondTo` asserts that the
	   * target has a method with the given name `method`. The method can be own or
	   * inherited, and it can be enumerable or non-enumerable.
	   *
	   *     function Cat () {}
	   *     Cat.prototype.meow = function () {};
	   *
	   *     expect(new Cat()).to.respondTo('meow');
	   *
	   * When the target is a function, `.respondTo` asserts that the target's
	   * `prototype` property has a method with the given name `method`. Again, the
	   * method can be own or inherited, and it can be enumerable or non-enumerable.
	   *
	   *     function Cat () {}
	   *     Cat.prototype.meow = function () {};
	   *
	   *     expect(Cat).to.respondTo('meow');
	   *
	   * Add `.itself` earlier in the chain to force `.respondTo` to treat the
	   * target as a non-function object, even if it's a function. Thus, it asserts
	   * that the target has a method with the given name `method`, rather than
	   * asserting that the target's `prototype` property has a method with the
	   * given name `method`.
	   *
	   *     function Cat () {}
	   *     Cat.prototype.meow = function () {};
	   *     Cat.hiss = function () {};
	   *
	   *     expect(Cat).itself.to.respondTo('hiss').but.not.respondTo('meow');
	   *
	   * When not adding `.itself`, it's important to check the target's type before
	   * using `.respondTo`. See the `.a` doc for info on checking a target's type.
	   *
	   *     function Cat () {}
	   *     Cat.prototype.meow = function () {};
	   *
	   *     expect(new Cat()).to.be.an('object').that.respondsTo('meow');
	   *
	   * Add `.not` earlier in the chain to negate `.respondTo`.
	   *
	   *     function Dog () {}
	   *     Dog.prototype.bark = function () {};
	   *
	   *     expect(new Dog()).to.not.respondTo('meow');
	   *
	   * `.respondTo` accepts an optional `msg` argument which is a custom error
	   * message to show when the assertion fails. The message can also be given as
	   * the second argument to `expect`.
	   *
	   *     expect({}).to.respondTo('meow', 'nooo why fail??');
	   *     expect({}, 'nooo why fail??').to.respondTo('meow');
	   *
	   * The alias `.respondsTo` can be used interchangeably with `.respondTo`.
	   *
	   * @name respondTo
	   * @alias respondsTo
	   * @param {String} method
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function respondTo (method, msg) {
	    if (msg) flag(this, 'message', msg);
	    var obj = flag(this, 'object')
	      , itself = flag(this, 'itself')
	      , context = ('function' === typeof obj && !itself)
	        ? obj.prototype[method]
	        : obj[method];
	
	    this.assert(
	        'function' === typeof context
	      , 'expected #{this} to respond to ' + _.inspect(method)
	      , 'expected #{this} to not respond to ' + _.inspect(method)
	    );
	  }
	
	  Assertion.addMethod('respondTo', respondTo);
	  Assertion.addMethod('respondsTo', respondTo);
	
	  /**
	   * ### .itself
	   *
	   * Forces all `.respondTo` assertions that follow in the chain to behave as if
	   * the target is a non-function object, even if it's a function. Thus, it
	   * causes `.respondTo` to assert that the target has a method with the given
	   * name, rather than asserting that the target's `prototype` property has a
	   * method with the given name.
	   *
	   *     function Cat () {}
	   *     Cat.prototype.meow = function () {};
	   *     Cat.hiss = function () {};
	   *
	   *     expect(Cat).itself.to.respondTo('hiss').but.not.respondTo('meow');
	   *
	   * @name itself
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('itself', function () {
	    flag(this, 'itself', true);
	  });
	
	  /**
	   * ### .satisfy(matcher[, msg])
	   *
	   * Invokes the given `matcher` function with the target being passed as the
	   * first argument, and asserts that the value returned is truthy.
	   *
	   *     expect(1).to.satisfy(function(num) {
	   *       return num > 0; 
	   *     });
	   *
	   * Add `.not` earlier in the chain to negate `.satisfy`.
	   *
	   *     expect(1).to.not.satisfy(function(num) {
	   *       return num > 2;
	   *     });
	   *
	   * `.satisfy` accepts an optional `msg` argument which is a custom error
	   * message to show when the assertion fails. The message can also be given as
	   * the second argument to `expect`.
	   *
	   *     expect(1).to.satisfy(function(num) {
	   *       return num > 2;
	   *     }, 'nooo why fail??');
	   *
	   *     expect(1, 'nooo why fail??').to.satisfy(function(num) {
	   *       return num > 2;
	   *     });
	   *
	   * The alias `.satisfies` can be used interchangeably with `.satisfy`.
	   *
	   * @name satisfy
	   * @alias satisfies
	   * @param {Function} matcher
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function satisfy (matcher, msg) {
	    if (msg) flag(this, 'message', msg);
	    var obj = flag(this, 'object');
	    var result = matcher(obj);
	    this.assert(
	        result
	      , 'expected #{this} to satisfy ' + _.objDisplay(matcher)
	      , 'expected #{this} to not satisfy' + _.objDisplay(matcher)
	      , flag(this, 'negate') ? false : true
	      , result
	    );
	  }
	
	  Assertion.addMethod('satisfy', satisfy);
	  Assertion.addMethod('satisfies', satisfy);
	
	  /**
	   * ### .closeTo(expected, delta[, msg])
	   *
	   * Asserts that the target is a number that's within a given +/- `delta` range
	   * of the given number `expected`. However, it's often best to assert that the
	   * target is equal to its expected value.
	   *
	   *     // Recommended
	   *     expect(1.5).to.equal(1.5);
	   *
	   *     // Not recommended
	   *     expect(1.5).to.be.closeTo(1, 0.5);
	   *     expect(1.5).to.be.closeTo(2, 0.5);
	   *     expect(1.5).to.be.closeTo(1, 1);
	   *
	   * Add `.not` earlier in the chain to negate `.closeTo`.
	   *
	   *     expect(1.5).to.equal(1.5); // Recommended
	   *     expect(1.5).to.not.be.closeTo(3, 1); // Not recommended
	   *
	   * `.closeTo` accepts an optional `msg` argument which is a custom error
	   * message to show when the assertion fails. The message can also be given as
	   * the second argument to `expect`.
	   *
	   *     expect(1.5).to.be.closeTo(3, 1, 'nooo why fail??');
	   *     expect(1.5, 'nooo why fail??').to.be.closeTo(3, 1);
	   *
	   * The alias `.approximately` can be used interchangeably with `.closeTo`.
	   *
	   * @name closeTo
	   * @alias approximately
	   * @param {Number} expected
	   * @param {Number} delta
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function closeTo(expected, delta, msg) {
	    if (msg) flag(this, 'message', msg);
	    var obj = flag(this, 'object')
	      , flagMsg = flag(this, 'message')
	      , ssfi = flag(this, 'ssfi');
	
	    new Assertion(obj, flagMsg, ssfi, true).is.a('number');
	    if (typeof expected !== 'number' || typeof delta !== 'number') {
	      flagMsg = flagMsg ? flagMsg + ': ' : '';
	      throw new AssertionError(
	          flagMsg + 'the arguments to closeTo or approximately must be numbers',
	          undefined,
	          ssfi
	      );
	    }
	
	    this.assert(
	        Math.abs(obj - expected) <= delta
	      , 'expected #{this} to be close to ' + expected + ' +/- ' + delta
	      , 'expected #{this} not to be close to ' + expected + ' +/- ' + delta
	    );
	  }
	
	  Assertion.addMethod('closeTo', closeTo);
	  Assertion.addMethod('approximately', closeTo);
	
	  // Note: Duplicates are ignored if testing for inclusion instead of sameness.
	  function isSubsetOf(subset, superset, cmp, contains, ordered) {
	    if (!contains) {
	      if (subset.length !== superset.length) return false;
	      superset = superset.slice();
	    }
	
	    return subset.every(function(elem, idx) {
	      if (ordered) return cmp ? cmp(elem, superset[idx]) : elem === superset[idx];
	
	      if (!cmp) {
	        var matchIdx = superset.indexOf(elem);
	        if (matchIdx === -1) return false;
	
	        // Remove match from superset so not counted twice if duplicate in subset.
	        if (!contains) superset.splice(matchIdx, 1);
	        return true;
	      }
	
	      return superset.some(function(elem2, matchIdx) {
	        if (!cmp(elem, elem2)) return false;
	
	        // Remove match from superset so not counted twice if duplicate in subset.
	        if (!contains) superset.splice(matchIdx, 1);
	        return true;
	      });
	    });
	  }
	
	  /**
	   * ### .members(set[, msg])
	   *
	   * Asserts that the target array has the same members as the given array
	   * `set`.
	   *
	   *     expect([1, 2, 3]).to.have.members([2, 1, 3]);
	   *     expect([1, 2, 2]).to.have.members([2, 1, 2]);
	   *
	   * By default, members are compared using strict (`===`) equality. Add `.deep`
	   * earlier in the chain to use deep equality instead. See the `deep-eql`
	   * project page for info on the deep equality algorithm:
	   * https://github.com/chaijs/deep-eql.
	   *
	   *     // Target array deeply (but not strictly) has member `{a: 1}`
	   *     expect([{a: 1}]).to.have.deep.members([{a: 1}]);
	   *     expect([{a: 1}]).to.not.have.members([{a: 1}]);
	   *
	   * By default, order doesn't matter. Add `.ordered` earlier in the chain to
	   * require that members appear in the same order.
	   *
	   *     expect([1, 2, 3]).to.have.ordered.members([1, 2, 3]);
	   *     expect([1, 2, 3]).to.have.members([2, 1, 3])
	   *       .but.not.ordered.members([2, 1, 3]);
	   *
	   * By default, both arrays must be the same size. Add `.include` earlier in
	   * the chain to require that the target's members be a superset of the
	   * expected members. Note that duplicates are ignored in the subset when
	   * `.include` is added.
	   *
	   *     // Target array is a superset of [1, 2] but not identical
	   *     expect([1, 2, 3]).to.include.members([1, 2]);
	   *     expect([1, 2, 3]).to.not.have.members([1, 2]);
	   *
	   *     // Duplicates in the subset are ignored
	   *     expect([1, 2, 3]).to.include.members([1, 2, 2, 2]);
	   *
	   * `.deep`, `.ordered`, and `.include` can all be combined. However, if
	   * `.include` and `.ordered` are combined, the ordering begins at the start of
	   * both arrays.
	   *
	   *     expect([{a: 1}, {b: 2}, {c: 3}])
	   *       .to.include.deep.ordered.members([{a: 1}, {b: 2}])
	   *       .but.not.include.deep.ordered.members([{b: 2}, {c: 3}]);
	   *
	   * Add `.not` earlier in the chain to negate `.members`. However, it's
	   * dangerous to do so. The problem is that it creates uncertain expectations
	   * by asserting that the target array doesn't have all of the same members as
	   * the given array `set` but may or may not have some of them. It's often best
	   * to identify the exact output that's expected, and then write an assertion
	   * that only accepts that exact output.
	   *
	   *     expect([1, 2]).to.not.include(3).and.not.include(4); // Recommended
	   *     expect([1, 2]).to.not.have.members([3, 4]); // Not recommended
	   *
	   * `.members` accepts an optional `msg` argument which is a custom error
	   * message to show when the assertion fails. The message can also be given as
	   * the second argument to `expect`.
	   *
	   *     expect([1, 2]).to.have.members([1, 2, 3], 'nooo why fail??');
	   *     expect([1, 2], 'nooo why fail??').to.have.members([1, 2, 3]);
	   *
	   * @name members
	   * @param {Array} set
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addMethod('members', function (subset, msg) {
	    if (msg) flag(this, 'message', msg);
	    var obj = flag(this, 'object')
	      , flagMsg = flag(this, 'message')
	      , ssfi = flag(this, 'ssfi');
	
	    new Assertion(obj, flagMsg, ssfi, true).to.be.an('array');
	    new Assertion(subset, flagMsg, ssfi, true).to.be.an('array');
	
	    var contains = flag(this, 'contains');
	    var ordered = flag(this, 'ordered');
	
	    var subject, failMsg, failNegateMsg, lengthCheck;
	
	    if (contains) {
	      subject = ordered ? 'an ordered superset' : 'a superset';
	      failMsg = 'expected #{this} to be ' + subject + ' of #{exp}';
	      failNegateMsg = 'expected #{this} to not be ' + subject + ' of #{exp}';
	    } else {
	      subject = ordered ? 'ordered members' : 'members';
	      failMsg = 'expected #{this} to have the same ' + subject + ' as #{exp}';
	      failNegateMsg = 'expected #{this} to not have the same ' + subject + ' as #{exp}';
	    }
	
	    var cmp = flag(this, 'deep') ? _.eql : undefined;
	
	    this.assert(
	        isSubsetOf(subset, obj, cmp, contains, ordered)
	      , failMsg
	      , failNegateMsg
	      , subset
	      , obj
	      , true
	    );
	  });
	
	  /**
	   * ### .oneOf(list[, msg])
	   *
	   * Asserts that the target is a member of the given array `list`. However,
	   * it's often best to assert that the target is equal to its expected value.
	   *
	   *     expect(1).to.equal(1); // Recommended
	   *     expect(1).to.be.oneOf([1, 2, 3]); // Not recommended
	   *
	   * Comparisons are performed using strict (`===`) equality.
	   *
	   * Add `.not` earlier in the chain to negate `.oneOf`.
	   *
	   *     expect(1).to.equal(1); // Recommended
	   *     expect(1).to.not.be.oneOf([2, 3, 4]); // Not recommended
	   *
	   * `.oneOf` accepts an optional `msg` argument which is a custom error message
	   * to show when the assertion fails. The message can also be given as the
	   * second argument to `expect`.
	   *
	   *     expect(1).to.be.oneOf([2, 3, 4], 'nooo why fail??');
	   *     expect(1, 'nooo why fail??').to.be.oneOf([2, 3, 4]);
	   *
	   * @name oneOf
	   * @param {Array<*>} list
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function oneOf (list, msg) {
	    if (msg) flag(this, 'message', msg);
	    var expected = flag(this, 'object')
	      , flagMsg = flag(this, 'message')
	      , ssfi = flag(this, 'ssfi');
	    new Assertion(list, flagMsg, ssfi, true).to.be.an('array');
	
	    this.assert(
	        list.indexOf(expected) > -1
	      , 'expected #{this} to be one of #{exp}'
	      , 'expected #{this} to not be one of #{exp}'
	      , list
	      , expected
	    );
	  }
	
	  Assertion.addMethod('oneOf', oneOf);
	
	
	  /**
	   * ### .change(subject[, prop[, msg]])
	   *
	   * When one argument is provided, `.change` asserts that the given function
	   * `subject` returns a different value when it's invoked before the target
	   * function compared to when it's invoked afterward. However, it's often best
	   * to assert that `subject` is equal to its expected value.
	   *
	   *     var dots = ''
	   *       , addDot = function () { dots += '.'; }
	   *       , getDots = function () { return dots; };
	   *
	   *     // Recommended
	   *     expect(getDots()).to.equal('');
	   *     addDot();
	   *     expect(getDots()).to.equal('.');
	   *
	   *     // Not recommended
	   *     expect(addDot).to.change(getDots);
	   *
	   * When two arguments are provided, `.change` asserts that the value of the
	   * given object `subject`'s `prop` property is different before invoking the
	   * target function compared to afterward.
	   *
	   *     var myObj = {dots: ''}
	   *       , addDot = function () { myObj.dots += '.'; };
	   *
	   *     // Recommended
	   *     expect(myObj).to.have.property('dots', '');
	   *     addDot();
	   *     expect(myObj).to.have.property('dots', '.');
	   *
	   *     // Not recommended
	   *     expect(addDot).to.change(myObj, 'dots');
	   *
	   * Strict (`===`) equality is used to compare before and after values.
	   *
	   * Add `.not` earlier in the chain to negate `.change`.
	   *
	   *     var dots = ''
	   *       , noop = function () {}
	   *       , getDots = function () { return dots; };
	   *
	   *     expect(noop).to.not.change(getDots);
	   *
	   *     var myObj = {dots: ''}
	   *       , noop = function () {};
	   *
	   *     expect(noop).to.not.change(myObj, 'dots');
	   *
	   * `.change` accepts an optional `msg` argument which is a custom error
	   * message to show when the assertion fails. The message can also be given as
	   * the second argument to `expect`. When not providing two arguments, always
	   * use the second form.
	   *
	   *     var myObj = {dots: ''}
	   *       , addDot = function () { myObj.dots += '.'; };
	   *
	   *     expect(addDot).to.not.change(myObj, 'dots', 'nooo why fail??');
	   *
	   *     var dots = ''
	   *       , addDot = function () { dots += '.'; }
	   *       , getDots = function () { return dots; };
	   *
	   *     expect(addDot, 'nooo why fail??').to.not.change(getDots);
	   *
	   * `.change` also causes all `.by` assertions that follow in the chain to
	   * assert how much a numeric subject was increased or decreased by. However,
	   * it's dangerous to use `.change.by`. The problem is that it creates
	   * uncertain expectations by asserting that the subject either increases by
	   * the given delta, or that it decreases by the given delta. It's often best
	   * to identify the exact output that's expected, and then write an assertion
	   * that only accepts that exact output.
	   *
	   *     var myObj = {val: 1}
	   *       , addTwo = function () { myObj.val += 2; }
	   *       , subtractTwo = function () { myObj.val -= 2; };
	   *
	   *     expect(addTwo).to.increase(myObj, 'val').by(2); // Recommended
	   *     expect(addTwo).to.change(myObj, 'val').by(2); // Not recommended
	   *
	   *     expect(subtractTwo).to.decrease(myObj, 'val').by(2); // Recommended
	   *     expect(subtractTwo).to.change(myObj, 'val').by(2); // Not recommended
	   *
	   * The alias `.changes` can be used interchangeably with `.change`.
	   *
	   * @name change
	   * @alias changes
	   * @param {String} subject
	   * @param {String} prop name _optional_
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function assertChanges (subject, prop, msg) {
	    if (msg) flag(this, 'message', msg);
	    var fn = flag(this, 'object')
	      , flagMsg = flag(this, 'message')
	      , ssfi = flag(this, 'ssfi');
	    new Assertion(fn, flagMsg, ssfi, true).is.a('function');
	
	    var initial;
	    if (!prop) {
	      new Assertion(subject, flagMsg, ssfi, true).is.a('function');
	      initial = subject();
	    } else {
	      new Assertion(subject, flagMsg, ssfi, true).to.have.property(prop);
	      initial = subject[prop];
	    }
	
	    fn();
	
	    var final = prop === undefined || prop === null ? subject() : subject[prop];
	    var msgObj = prop === undefined || prop === null ? initial : '.' + prop;
	
	    // This gets flagged because of the .by(delta) assertion
	    flag(this, 'deltaMsgObj', msgObj);
	    flag(this, 'initialDeltaValue', initial);
	    flag(this, 'finalDeltaValue', final);
	    flag(this, 'deltaBehavior', 'change');
	    flag(this, 'realDelta', final !== initial);
	
	    this.assert(
	      initial !== final
	      , 'expected ' + msgObj + ' to change'
	      , 'expected ' + msgObj + ' to not change'
	    );
	  }
	
	  Assertion.addMethod('change', assertChanges);
	  Assertion.addMethod('changes', assertChanges);
	
	  /**
	   * ### .increase(subject[, prop[, msg]])
	   *
	   * When one argument is provided, `.increase` asserts that the given function
	   * `subject` returns a greater number when it's invoked after invoking the
	   * target function compared to when it's invoked beforehand. `.increase` also
	   * causes all `.by` assertions that follow in the chain to assert how much
	   * greater of a number is returned. It's often best to assert that the return
	   * value increased by the expected amount, rather than asserting it increased
	   * by any amount.
	   *
	   *     var val = 1
	   *       , addTwo = function () { val += 2; }
	   *       , getVal = function () { return val; };
	   *
	   *     expect(addTwo).to.increase(getVal).by(2); // Recommended
	   *     expect(addTwo).to.increase(getVal); // Not recommended
	   *
	   * When two arguments are provided, `.increase` asserts that the value of the
	   * given object `subject`'s `prop` property is greater after invoking the
	   * target function compared to beforehand.
	   *
	   *     var myObj = {val: 1}
	   *       , addTwo = function () { myObj.val += 2; };
	   *
	   *     expect(addTwo).to.increase(myObj, 'val').by(2); // Recommended
	   *     expect(addTwo).to.increase(myObj, 'val'); // Not recommended
	   *
	   * Add `.not` earlier in the chain to negate `.increase`. However, it's
	   * dangerous to do so. The problem is that it creates uncertain expectations
	   * by asserting that the subject either decreases, or that it stays the same.
	   * It's often best to identify the exact output that's expected, and then
	   * write an assertion that only accepts that exact output.
	   *
	   * When the subject is expected to decrease, it's often best to assert that it
	   * decreased by the expected amount.
	   *
	   *     var myObj = {val: 1}
	   *       , subtractTwo = function () { myObj.val -= 2; };
	   *
	   *     expect(subtractTwo).to.decrease(myObj, 'val').by(2); // Recommended
	   *     expect(subtractTwo).to.not.increase(myObj, 'val'); // Not recommended
	   * 
	   * When the subject is expected to stay the same, it's often best to assert
	   * exactly that.
	   *
	   *     var myObj = {val: 1}
	   *       , noop = function () {};
	   *
	   *     expect(noop).to.not.change(myObj, 'val'); // Recommended
	   *     expect(noop).to.not.increase(myObj, 'val'); // Not recommended
	   *
	   * `.increase` accepts an optional `msg` argument which is a custom error
	   * message to show when the assertion fails. The message can also be given as
	   * the second argument to `expect`. When not providing two arguments, always
	   * use the second form.
	   *
	   *     var myObj = {val: 1}
	   *       , noop = function () {};
	   *
	   *     expect(noop).to.increase(myObj, 'val', 'nooo why fail??');
	   *
	   *     var val = 1
	   *       , noop = function () {}
	   *       , getVal = function () { return val; };
	   *
	   *     expect(noop, 'nooo why fail??').to.increase(getVal);
	   *
	   * The alias `.increases` can be used interchangeably with `.increase`.
	   *
	   * @name increase
	   * @alias increases
	   * @param {String|Function} subject
	   * @param {String} prop name _optional_
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function assertIncreases (subject, prop, msg) {
	    if (msg) flag(this, 'message', msg);
	    var fn = flag(this, 'object')
	      , flagMsg = flag(this, 'message')
	      , ssfi = flag(this, 'ssfi');
	    new Assertion(fn, flagMsg, ssfi, true).is.a('function');
	
	    var initial;
	    if (!prop) {
	      new Assertion(subject, flagMsg, ssfi, true).is.a('function');
	      initial = subject();
	    } else {
	      new Assertion(subject, flagMsg, ssfi, true).to.have.property(prop);
	      initial = subject[prop];
	    }
	
	    // Make sure that the target is a number
	    new Assertion(initial, flagMsg, ssfi, true).is.a('number');
	
	    fn();
	
	    var final = prop === undefined || prop === null ? subject() : subject[prop];
	    var msgObj = prop === undefined || prop === null ? initial : '.' + prop;
	
	    flag(this, 'deltaMsgObj', msgObj);
	    flag(this, 'initialDeltaValue', initial);
	    flag(this, 'finalDeltaValue', final);
	    flag(this, 'deltaBehavior', 'increase');
	    flag(this, 'realDelta', final - initial);
	
	    this.assert(
	      final - initial > 0
	      , 'expected ' + msgObj + ' to increase'
	      , 'expected ' + msgObj + ' to not increase'
	    );
	  }
	
	  Assertion.addMethod('increase', assertIncreases);
	  Assertion.addMethod('increases', assertIncreases);
	
	  /**
	   * ### .decrease(subject[, prop[, msg]])
	   *
	   * When one argument is provided, `.decrease` asserts that the given function
	   * `subject` returns a lesser number when it's invoked after invoking the
	   * target function compared to when it's invoked beforehand. `.decrease` also
	   * causes all `.by` assertions that follow in the chain to assert how much
	   * lesser of a number is returned. It's often best to assert that the return
	   * value decreased by the expected amount, rather than asserting it decreased
	   * by any amount.
	   *
	   *     var val = 1
	   *       , subtractTwo = function () { val -= 2; }
	   *       , getVal = function () { return val; };
	   *
	   *     expect(subtractTwo).to.decrease(getVal).by(2); // Recommended
	   *     expect(subtractTwo).to.decrease(getVal); // Not recommended
	   *
	   * When two arguments are provided, `.decrease` asserts that the value of the
	   * given object `subject`'s `prop` property is lesser after invoking the
	   * target function compared to beforehand. 
	   *
	   *     var myObj = {val: 1}
	   *       , subtractTwo = function () { myObj.val -= 2; };
	   *
	   *     expect(subtractTwo).to.decrease(myObj, 'val').by(2); // Recommended
	   *     expect(subtractTwo).to.decrease(myObj, 'val'); // Not recommended
	   *
	   * Add `.not` earlier in the chain to negate `.decrease`. However, it's
	   * dangerous to do so. The problem is that it creates uncertain expectations
	   * by asserting that the subject either increases, or that it stays the same.
	   * It's often best to identify the exact output that's expected, and then
	   * write an assertion that only accepts that exact output.
	   *
	   * When the subject is expected to increase, it's often best to assert that it
	   * increased by the expected amount.
	   *
	   *     var myObj = {val: 1}
	   *       , addTwo = function () { myObj.val += 2; };
	   *
	   *     expect(addTwo).to.increase(myObj, 'val').by(2); // Recommended
	   *     expect(addTwo).to.not.decrease(myObj, 'val'); // Not recommended
	   * 
	   * When the subject is expected to stay the same, it's often best to assert
	   * exactly that.
	   *
	   *     var myObj = {val: 1}
	   *       , noop = function () {};
	   *
	   *     expect(noop).to.not.change(myObj, 'val'); // Recommended
	   *     expect(noop).to.not.decrease(myObj, 'val'); // Not recommended
	   *
	   * `.decrease` accepts an optional `msg` argument which is a custom error
	   * message to show when the assertion fails. The message can also be given as
	   * the second argument to `expect`. When not providing two arguments, always
	   * use the second form.
	   *
	   *     var myObj = {val: 1}
	   *       , noop = function () {};
	   *
	   *     expect(noop).to.decrease(myObj, 'val', 'nooo why fail??');
	   *
	   *     var val = 1
	   *       , noop = function () {}
	   *       , getVal = function () { return val; };
	   *
	   *     expect(noop, 'nooo why fail??').to.decrease(getVal);
	   *
	   * The alias `.decreases` can be used interchangeably with `.decrease`.
	   *
	   * @name decrease
	   * @alias decreases
	   * @param {String|Function} subject
	   * @param {String} prop name _optional_
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function assertDecreases (subject, prop, msg) {
	    if (msg) flag(this, 'message', msg);
	    var fn = flag(this, 'object')
	      , flagMsg = flag(this, 'message')
	      , ssfi = flag(this, 'ssfi');
	    new Assertion(fn, flagMsg, ssfi, true).is.a('function');
	
	    var initial;
	    if (!prop) {
	      new Assertion(subject, flagMsg, ssfi, true).is.a('function');
	      initial = subject();
	    } else {
	      new Assertion(subject, flagMsg, ssfi, true).to.have.property(prop);
	      initial = subject[prop];
	    }
	
	    // Make sure that the target is a number
	    new Assertion(initial, flagMsg, ssfi, true).is.a('number');
	
	    fn();
	
	    var final = prop === undefined || prop === null ? subject() : subject[prop];
	    var msgObj = prop === undefined || prop === null ? initial : '.' + prop;
	
	    flag(this, 'deltaMsgObj', msgObj);
	    flag(this, 'initialDeltaValue', initial);
	    flag(this, 'finalDeltaValue', final);
	    flag(this, 'deltaBehavior', 'decrease');
	    flag(this, 'realDelta', initial - final);
	
	    this.assert(
	      final - initial < 0
	      , 'expected ' + msgObj + ' to decrease'
	      , 'expected ' + msgObj + ' to not decrease'
	    );
	  }
	
	  Assertion.addMethod('decrease', assertDecreases);
	  Assertion.addMethod('decreases', assertDecreases);
	
	  /**
	   * ### .by(delta[, msg])
	   *
	   * When following an `.increase` assertion in the chain, `.by` asserts that
	   * the subject of the `.increase` assertion increased by the given `delta`.
	   *
	   *     var myObj = {val: 1}
	   *       , addTwo = function () { myObj.val += 2; };
	   *
	   *     expect(addTwo).to.increase(myObj, 'val').by(2);
	   *
	   * When following a `.decrease` assertion in the chain, `.by` asserts that the
	   * subject of the `.decrease` assertion decreased by the given `delta`.
	   *
	   *     var myObj = {val: 1}
	   *       , subtractTwo = function () { myObj.val -= 2; };
	   *
	   *     expect(subtractTwo).to.decrease(myObj, 'val').by(2);
	   *
	   * When following a `.change` assertion in the chain, `.by` asserts that the
	   * subject of the `.change` assertion either increased or decreased by the
	   * given `delta`. However, it's dangerous to use `.change.by`. The problem is
	   * that it creates uncertain expectations. It's often best to identify the
	   * exact output that's expected, and then write an assertion that only accepts
	   * that exact output.
	   *
	   *     var myObj = {val: 1}
	   *       , addTwo = function () { myObj.val += 2; }
	   *       , subtractTwo = function () { myObj.val -= 2; };
	   *
	   *     expect(addTwo).to.increase(myObj, 'val').by(2); // Recommended
	   *     expect(addTwo).to.change(myObj, 'val').by(2); // Not recommended
	   *
	   *     expect(subtractTwo).to.decrease(myObj, 'val').by(2); // Recommended
	   *     expect(subtractTwo).to.change(myObj, 'val').by(2); // Not recommended
	   *
	   * Add `.not` earlier in the chain to negate `.by`. However, it's often best
	   * to assert that the subject changed by its expected delta, rather than
	   * asserting that it didn't change by one of countless unexpected deltas.
	   *
	   *     var myObj = {val: 1}
	   *       , addTwo = function () { myObj.val += 2; };
	   *
	   *     // Recommended
	   *     expect(addTwo).to.increase(myObj, 'val').by(2);
	   *
	   *     // Not recommended
	   *     expect(addTwo).to.increase(myObj, 'val').but.not.by(3);
	   *
	   * `.by` accepts an optional `msg` argument which is a custom error message to
	   * show when the assertion fails. The message can also be given as the second
	   * argument to `expect`.
	   *
	   *     var myObj = {val: 1}
	   *       , addTwo = function () { myObj.val += 2; };
	   *
	   *     expect(addTwo).to.increase(myObj, 'val').by(3, 'nooo why fail??');
	   *     expect(addTwo, 'nooo why fail??').to.increase(myObj, 'val').by(3);
	   *
	   * @name by
	   * @param {Number} delta
	   * @param {String} msg _optional_
	   * @namespace BDD
	   * @api public
	   */
	
	  function assertDelta(delta, msg) {
	    if (msg) flag(this, 'message', msg);
	
	    var msgObj = flag(this, 'deltaMsgObj');
	    var initial = flag(this, 'initialDeltaValue');
	    var final = flag(this, 'finalDeltaValue');
	    var behavior = flag(this, 'deltaBehavior');
	    var realDelta = flag(this, 'realDelta');
	
	    var expression;
	    if (behavior === 'change') {
	      expression = Math.abs(final - initial) === Math.abs(delta);
	    } else {
	      expression = realDelta === Math.abs(delta);
	    }
	
	    this.assert(
	      expression
	      , 'expected ' + msgObj + ' to ' + behavior + ' by ' + delta
	      , 'expected ' + msgObj + ' to not ' + behavior + ' by ' + delta
	    );
	  }
	
	  Assertion.addMethod('by', assertDelta);
	
	  /**
	   * ### .extensible
	   *
	   * Asserts that the target is extensible, which means that new properties can
	   * be added to it. Primitives are never extensible.
	   *
	   *     expect({a: 1}).to.be.extensible;
	   *
	   * Add `.not` earlier in the chain to negate `.extensible`.
	   *
	   *     var nonExtensibleObject = Object.preventExtensions({})
	   *       , sealedObject = Object.seal({})
	   *       , frozenObject = Object.freeze({});
	   *
	   *     expect(nonExtensibleObject).to.not.be.extensible;
	   *     expect(sealedObject).to.not.be.extensible;
	   *     expect(frozenObject).to.not.be.extensible;
	   *     expect(1).to.not.be.extensible;
	   *
	   * A custom error message can be given as the second argument to `expect`.
	   *
	   *     expect(1, 'nooo why fail??').to.be.extensible;
	   *
	   * @name extensible
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('extensible', function() {
	    var obj = flag(this, 'object');
	
	    // In ES5, if the argument to this method is a primitive, then it will cause a TypeError.
	    // In ES6, a non-object argument will be treated as if it was a non-extensible ordinary object, simply return false.
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/isExtensible
	    // The following provides ES6 behavior for ES5 environments.
	
	    var isExtensible = obj === Object(obj) && Object.isExtensible(obj);
	
	    this.assert(
	      isExtensible
	      , 'expected #{this} to be extensible'
	      , 'expected #{this} to not be extensible'
	    );
	  });
	
	  /**
	   * ### .sealed
	   *
	   * Asserts that the target is sealed, which means that new properties can't be
	   * added to it, and its existing properties can't be reconfigured or deleted.
	   * However, it's possible that its existing properties can still be reassigned
	   * to different values. Primitives are always sealed.
	   *
	   *     var sealedObject = Object.seal({});
	   *     var frozenObject = Object.freeze({});
	   *
	   *     expect(sealedObject).to.be.sealed;
	   *     expect(frozenObject).to.be.sealed;
	   *     expect(1).to.be.sealed;
	   *
	   * Add `.not` earlier in the chain to negate `.sealed`.
	   *
	   *     expect({a: 1}).to.not.be.sealed;
	   *
	   * A custom error message can be given as the second argument to `expect`.
	   *
	   *     expect({a: 1}, 'nooo why fail??').to.be.sealed;
	   *
	   * @name sealed
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('sealed', function() {
	    var obj = flag(this, 'object');
	
	    // In ES5, if the argument to this method is a primitive, then it will cause a TypeError.
	    // In ES6, a non-object argument will be treated as if it was a sealed ordinary object, simply return true.
	    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/isSealed
	    // The following provides ES6 behavior for ES5 environments.
	
	    var isSealed = obj === Object(obj) ? Object.isSealed(obj) : true;
	
	    this.assert(
	      isSealed
	      , 'expected #{this} to be sealed'
	      , 'expected #{this} to not be sealed'
	    );
	  });
	
	  /**
	   * ### .frozen
	   *
	   * Asserts that the target is frozen, which means that new properties can't be
	   * added to it, and its existing properties can't be reassigned to different
	   * values, reconfigured, or deleted. Primitives are always frozen.
	   *
	   *     var frozenObject = Object.freeze({});
	   *
	   *     expect(frozenObject).to.be.frozen;
	   *     expect(1).to.be.frozen;
	   *
	   * Add `.not` earlier in the chain to negate `.frozen`.
	   *
	   *     expect({a: 1}).to.not.be.frozen;
	   *
	   * A custom error message can be given as the second argument to `expect`.
	   *
	   *     expect({a: 1}, 'nooo why fail??').to.be.frozen;
	   *
	   * @name frozen
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('frozen', function() {
	    var obj = flag(this, 'object');
	
	    // In ES5, if the argument to this method is a primitive, then it will cause a TypeError.
	    // In ES6, a non-object argument will be treated as if it was a frozen ordinary object, simply return true.
	    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/isFrozen
	    // The following provides ES6 behavior for ES5 environments.
	
	    var isFrozen = obj === Object(obj) ? Object.isFrozen(obj) : true;
	
	    this.assert(
	      isFrozen
	      , 'expected #{this} to be frozen'
	      , 'expected #{this} to not be frozen'
	    );
	  });
	
	  /**
	   * ### .finite
	   *
	   * Asserts that the target is a number, and isn't `NaN` or positive/negative
	   * `Infinity`.
	   *
	   *     expect(1).to.be.finite;
	   *
	   * Add `.not` earlier in the chain to negate `.finite`. However, it's
	   * dangerous to do so. The problem is that it creates uncertain expectations
	   * by asserting that the subject either isn't a number, or that it's `NaN`, or
	   * that it's positive `Infinity`, or that it's negative `Infinity`. It's often
	   * best to identify the exact output that's expected, and then write an
	   * assertion that only accepts that exact output.
	   *
	   * When the target isn't expected to be a number, it's often best to assert
	   * that it's the expected type, rather than asserting that it isn't one of
	   * many unexpected types.
	   *
	   *     expect('foo').to.be.a('string'); // Recommended
	   *     expect('foo').to.not.be.finite; // Not recommended
	   *
	   * When the target is expected to be `NaN`, it's often best to assert exactly
	   * that.
	   *
	   *     expect(NaN).to.be.NaN; // Recommended
	   *     expect(NaN).to.not.be.finite; // Not recommended
	   *
	   * When the target is expected to be positive infinity, it's often best to
	   * assert exactly that.
	   *
	   *     expect(Infinity).to.equal(Infinity); // Recommended
	   *     expect(Infinity).to.not.be.finite; // Not recommended
	   *
	   * When the target is expected to be negative infinity, it's often best to
	   * assert exactly that.
	   *
	   *     expect(-Infinity).to.equal(-Infinity); // Recommended
	   *     expect(-Infinity).to.not.be.finite; // Not recommended
	   *
	   * A custom error message can be given as the second argument to `expect`.
	   *
	   *     expect('foo', 'nooo why fail??').to.be.finite;
	   *
	   * @name finite
	   * @namespace BDD
	   * @api public
	   */
	
	  Assertion.addProperty('finite', function(msg) {
	    var obj = flag(this, 'object');
	
	    this.assert(
	        typeof obj === "number" && isFinite(obj)
	      , 'expected #{this} to be a finite number'
	      , 'expected #{this} to not be a finite number'
	    );
	  });
	};


/***/ }),
/* 1007 */
/***/ (function(module, exports) {

	/*!
	 * chai
	 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	
	module.exports = function (chai, util) {
	
	  /*!
	   * Chai dependencies.
	   */
	
	  var Assertion = chai.Assertion
	    , flag = util.flag;
	
	  /*!
	   * Module export.
	   */
	
	  /**
	   * ### assert(expression, message)
	   *
	   * Write your own test expressions.
	   *
	   *     assert('foo' !== 'bar', 'foo is not bar');
	   *     assert(Array.isArray([]), 'empty arrays are arrays');
	   *
	   * @param {Mixed} expression to test for truthiness
	   * @param {String} message to display on error
	   * @name assert
	   * @namespace Assert
	   * @api public
	   */
	
	  var assert = chai.assert = function (express, errmsg) {
	    var test = new Assertion(null, null, chai.assert, true);
	    test.assert(
	        express
	      , errmsg
	      , '[ negation message unavailable ]'
	    );
	  };
	
	  /**
	   * ### .fail(actual, expected, [message], [operator])
	   *
	   * Throw a failure. Node.js `assert` module-compatible.
	   *
	   * @name fail
	   * @param {Mixed} actual
	   * @param {Mixed} expected
	   * @param {String} message
	   * @param {String} operator
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.fail = function (actual, expected, message, operator) {
	    message = message || 'assert.fail()';
	    throw new chai.AssertionError(message, {
	        actual: actual
	      , expected: expected
	      , operator: operator
	    }, assert.fail);
	  };
	
	  /**
	   * ### .isOk(object, [message])
	   *
	   * Asserts that `object` is truthy.
	   *
	   *     assert.isOk('everything', 'everything is ok');
	   *     assert.isOk(false, 'this will fail');
	   *
	   * @name isOk
	   * @alias ok
	   * @param {Mixed} object to test
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isOk = function (val, msg) {
	    new Assertion(val, msg, assert.isOk, true).is.ok;
	  };
	
	  /**
	   * ### .isNotOk(object, [message])
	   *
	   * Asserts that `object` is falsy.
	   *
	   *     assert.isNotOk('everything', 'this will fail');
	   *     assert.isNotOk(false, 'this will pass');
	   *
	   * @name isNotOk
	   * @alias notOk
	   * @param {Mixed} object to test
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isNotOk = function (val, msg) {
	    new Assertion(val, msg, assert.isNotOk, true).is.not.ok;
	  };
	
	  /**
	   * ### .equal(actual, expected, [message])
	   *
	   * Asserts non-strict equality (`==`) of `actual` and `expected`.
	   *
	   *     assert.equal(3, '3', '== coerces values to strings');
	   *
	   * @name equal
	   * @param {Mixed} actual
	   * @param {Mixed} expected
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.equal = function (act, exp, msg) {
	    var test = new Assertion(act, msg, assert.equal, true);
	
	    test.assert(
	        exp == flag(test, 'object')
	      , 'expected #{this} to equal #{exp}'
	      , 'expected #{this} to not equal #{act}'
	      , exp
	      , act
	      , true
	    );
	  };
	
	  /**
	   * ### .notEqual(actual, expected, [message])
	   *
	   * Asserts non-strict inequality (`!=`) of `actual` and `expected`.
	   *
	   *     assert.notEqual(3, 4, 'these numbers are not equal');
	   *
	   * @name notEqual
	   * @param {Mixed} actual
	   * @param {Mixed} expected
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notEqual = function (act, exp, msg) {
	    var test = new Assertion(act, msg, assert.notEqual, true);
	
	    test.assert(
	        exp != flag(test, 'object')
	      , 'expected #{this} to not equal #{exp}'
	      , 'expected #{this} to equal #{act}'
	      , exp
	      , act
	      , true
	    );
	  };
	
	  /**
	   * ### .strictEqual(actual, expected, [message])
	   *
	   * Asserts strict equality (`===`) of `actual` and `expected`.
	   *
	   *     assert.strictEqual(true, true, 'these booleans are strictly equal');
	   *
	   * @name strictEqual
	   * @param {Mixed} actual
	   * @param {Mixed} expected
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.strictEqual = function (act, exp, msg) {
	    new Assertion(act, msg, assert.strictEqual, true).to.equal(exp);
	  };
	
	  /**
	   * ### .notStrictEqual(actual, expected, [message])
	   *
	   * Asserts strict inequality (`!==`) of `actual` and `expected`.
	   *
	   *     assert.notStrictEqual(3, '3', 'no coercion for strict equality');
	   *
	   * @name notStrictEqual
	   * @param {Mixed} actual
	   * @param {Mixed} expected
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notStrictEqual = function (act, exp, msg) {
	    new Assertion(act, msg, assert.notStrictEqual, true).to.not.equal(exp);
	  };
	
	  /**
	   * ### .deepEqual(actual, expected, [message])
	   *
	   * Asserts that `actual` is deeply equal to `expected`.
	   *
	   *     assert.deepEqual({ tea: 'green' }, { tea: 'green' });
	   *
	   * @name deepEqual
	   * @param {Mixed} actual
	   * @param {Mixed} expected
	   * @param {String} message
	   * @alias deepStrictEqual
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.deepEqual = assert.deepStrictEqual = function (act, exp, msg) {
	    new Assertion(act, msg, assert.deepEqual, true).to.eql(exp);
	  };
	
	  /**
	   * ### .notDeepEqual(actual, expected, [message])
	   *
	   * Assert that `actual` is not deeply equal to `expected`.
	   *
	   *     assert.notDeepEqual({ tea: 'green' }, { tea: 'jasmine' });
	   *
	   * @name notDeepEqual
	   * @param {Mixed} actual
	   * @param {Mixed} expected
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notDeepEqual = function (act, exp, msg) {
	    new Assertion(act, msg, assert.notDeepEqual, true).to.not.eql(exp);
	  };
	
	   /**
	   * ### .isAbove(valueToCheck, valueToBeAbove, [message])
	   *
	   * Asserts `valueToCheck` is strictly greater than (>) `valueToBeAbove`.
	   *
	   *     assert.isAbove(5, 2, '5 is strictly greater than 2');
	   *
	   * @name isAbove
	   * @param {Mixed} valueToCheck
	   * @param {Mixed} valueToBeAbove
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isAbove = function (val, abv, msg) {
	    new Assertion(val, msg, assert.isAbove, true).to.be.above(abv);
	  };
	
	   /**
	   * ### .isAtLeast(valueToCheck, valueToBeAtLeast, [message])
	   *
	   * Asserts `valueToCheck` is greater than or equal to (>=) `valueToBeAtLeast`.
	   *
	   *     assert.isAtLeast(5, 2, '5 is greater or equal to 2');
	   *     assert.isAtLeast(3, 3, '3 is greater or equal to 3');
	   *
	   * @name isAtLeast
	   * @param {Mixed} valueToCheck
	   * @param {Mixed} valueToBeAtLeast
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isAtLeast = function (val, atlst, msg) {
	    new Assertion(val, msg, assert.isAtLeast, true).to.be.least(atlst);
	  };
	
	   /**
	   * ### .isBelow(valueToCheck, valueToBeBelow, [message])
	   *
	   * Asserts `valueToCheck` is strictly less than (<) `valueToBeBelow`.
	   *
	   *     assert.isBelow(3, 6, '3 is strictly less than 6');
	   *
	   * @name isBelow
	   * @param {Mixed} valueToCheck
	   * @param {Mixed} valueToBeBelow
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isBelow = function (val, blw, msg) {
	    new Assertion(val, msg, assert.isBelow, true).to.be.below(blw);
	  };
	
	   /**
	   * ### .isAtMost(valueToCheck, valueToBeAtMost, [message])
	   *
	   * Asserts `valueToCheck` is less than or equal to (<=) `valueToBeAtMost`.
	   *
	   *     assert.isAtMost(3, 6, '3 is less than or equal to 6');
	   *     assert.isAtMost(4, 4, '4 is less than or equal to 4');
	   *
	   * @name isAtMost
	   * @param {Mixed} valueToCheck
	   * @param {Mixed} valueToBeAtMost
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isAtMost = function (val, atmst, msg) {
	    new Assertion(val, msg, assert.isAtMost, true).to.be.most(atmst);
	  };
	
	  /**
	   * ### .isTrue(value, [message])
	   *
	   * Asserts that `value` is true.
	   *
	   *     var teaServed = true;
	   *     assert.isTrue(teaServed, 'the tea has been served');
	   *
	   * @name isTrue
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isTrue = function (val, msg) {
	    new Assertion(val, msg, assert.isTrue, true).is['true'];
	  };
	
	  /**
	   * ### .isNotTrue(value, [message])
	   *
	   * Asserts that `value` is not true.
	   *
	   *     var tea = 'tasty chai';
	   *     assert.isNotTrue(tea, 'great, time for tea!');
	   *
	   * @name isNotTrue
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isNotTrue = function (val, msg) {
	    new Assertion(val, msg, assert.isNotTrue, true).to.not.equal(true);
	  };
	
	  /**
	   * ### .isFalse(value, [message])
	   *
	   * Asserts that `value` is false.
	   *
	   *     var teaServed = false;
	   *     assert.isFalse(teaServed, 'no tea yet? hmm...');
	   *
	   * @name isFalse
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isFalse = function (val, msg) {
	    new Assertion(val, msg, assert.isFalse, true).is['false'];
	  };
	
	  /**
	   * ### .isNotFalse(value, [message])
	   *
	   * Asserts that `value` is not false.
	   *
	   *     var tea = 'tasty chai';
	   *     assert.isNotFalse(tea, 'great, time for tea!');
	   *
	   * @name isNotFalse
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isNotFalse = function (val, msg) {
	    new Assertion(val, msg, assert.isNotFalse, true).to.not.equal(false);
	  };
	
	  /**
	   * ### .isNull(value, [message])
	   *
	   * Asserts that `value` is null.
	   *
	   *     assert.isNull(err, 'there was no error');
	   *
	   * @name isNull
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isNull = function (val, msg) {
	    new Assertion(val, msg, assert.isNull, true).to.equal(null);
	  };
	
	  /**
	   * ### .isNotNull(value, [message])
	   *
	   * Asserts that `value` is not null.
	   *
	   *     var tea = 'tasty chai';
	   *     assert.isNotNull(tea, 'great, time for tea!');
	   *
	   * @name isNotNull
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isNotNull = function (val, msg) {
	    new Assertion(val, msg, assert.isNotNull, true).to.not.equal(null);
	  };
	
	  /**
	   * ### .isNaN
	   *
	   * Asserts that value is NaN.
	   *
	   *     assert.isNaN(NaN, 'NaN is NaN');
	   *
	   * @name isNaN
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isNaN = function (val, msg) {
	    new Assertion(val, msg, assert.isNaN, true).to.be.NaN;
	  };
	
	  /**
	   * ### .isNotNaN
	   *
	   * Asserts that value is not NaN.
	   *
	   *     assert.isNotNaN(4, '4 is not NaN');
	   *
	   * @name isNotNaN
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	  assert.isNotNaN = function (val, msg) {
	    new Assertion(val, msg, assert.isNotNaN, true).not.to.be.NaN;
	  };
	
	  /**
	   * ### .exists
	   *
	   * Asserts that the target is neither `null` nor `undefined`.
	   *
	   *     var foo = 'hi';
	   *
	   *     assert.exists(foo, 'foo is neither `null` nor `undefined`');
	   *
	   * @name exists
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.exists = function (val, msg) {
	    new Assertion(val, msg, assert.exists, true).to.exist;
	  };
	
	  /**
	   * ### .notExists
	   *
	   * Asserts that the target is either `null` or `undefined`.
	   *
	   *     var bar = null
	   *       , baz;
	   *
	   *     assert.notExists(bar);
	   *     assert.notExists(baz, 'baz is either null or undefined');
	   *
	   * @name notExists
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notExists = function (val, msg) {
	    new Assertion(val, msg, assert.notExists, true).to.not.exist;
	  };
	
	  /**
	   * ### .isUndefined(value, [message])
	   *
	   * Asserts that `value` is `undefined`.
	   *
	   *     var tea;
	   *     assert.isUndefined(tea, 'no tea defined');
	   *
	   * @name isUndefined
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isUndefined = function (val, msg) {
	    new Assertion(val, msg, assert.isUndefined, true).to.equal(undefined);
	  };
	
	  /**
	   * ### .isDefined(value, [message])
	   *
	   * Asserts that `value` is not `undefined`.
	   *
	   *     var tea = 'cup of chai';
	   *     assert.isDefined(tea, 'tea has been defined');
	   *
	   * @name isDefined
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isDefined = function (val, msg) {
	    new Assertion(val, msg, assert.isDefined, true).to.not.equal(undefined);
	  };
	
	  /**
	   * ### .isFunction(value, [message])
	   *
	   * Asserts that `value` is a function.
	   *
	   *     function serveTea() { return 'cup of tea'; };
	   *     assert.isFunction(serveTea, 'great, we can have tea now');
	   *
	   * @name isFunction
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isFunction = function (val, msg) {
	    new Assertion(val, msg, assert.isFunction, true).to.be.a('function');
	  };
	
	  /**
	   * ### .isNotFunction(value, [message])
	   *
	   * Asserts that `value` is _not_ a function.
	   *
	   *     var serveTea = [ 'heat', 'pour', 'sip' ];
	   *     assert.isNotFunction(serveTea, 'great, we have listed the steps');
	   *
	   * @name isNotFunction
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isNotFunction = function (val, msg) {
	    new Assertion(val, msg, assert.isNotFunction, true).to.not.be.a('function');
	  };
	
	  /**
	   * ### .isObject(value, [message])
	   *
	   * Asserts that `value` is an object of type 'Object' (as revealed by `Object.prototype.toString`).
	   * _The assertion does not match subclassed objects._
	   *
	   *     var selection = { name: 'Chai', serve: 'with spices' };
	   *     assert.isObject(selection, 'tea selection is an object');
	   *
	   * @name isObject
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isObject = function (val, msg) {
	    new Assertion(val, msg, assert.isObject, true).to.be.a('object');
	  };
	
	  /**
	   * ### .isNotObject(value, [message])
	   *
	   * Asserts that `value` is _not_ an object of type 'Object' (as revealed by `Object.prototype.toString`).
	   *
	   *     var selection = 'chai'
	   *     assert.isNotObject(selection, 'tea selection is not an object');
	   *     assert.isNotObject(null, 'null is not an object');
	   *
	   * @name isNotObject
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isNotObject = function (val, msg) {
	    new Assertion(val, msg, assert.isNotObject, true).to.not.be.a('object');
	  };
	
	  /**
	   * ### .isArray(value, [message])
	   *
	   * Asserts that `value` is an array.
	   *
	   *     var menu = [ 'green', 'chai', 'oolong' ];
	   *     assert.isArray(menu, 'what kind of tea do we want?');
	   *
	   * @name isArray
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isArray = function (val, msg) {
	    new Assertion(val, msg, assert.isArray, true).to.be.an('array');
	  };
	
	  /**
	   * ### .isNotArray(value, [message])
	   *
	   * Asserts that `value` is _not_ an array.
	   *
	   *     var menu = 'green|chai|oolong';
	   *     assert.isNotArray(menu, 'what kind of tea do we want?');
	   *
	   * @name isNotArray
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isNotArray = function (val, msg) {
	    new Assertion(val, msg, assert.isNotArray, true).to.not.be.an('array');
	  };
	
	  /**
	   * ### .isString(value, [message])
	   *
	   * Asserts that `value` is a string.
	   *
	   *     var teaOrder = 'chai';
	   *     assert.isString(teaOrder, 'order placed');
	   *
	   * @name isString
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isString = function (val, msg) {
	    new Assertion(val, msg, assert.isString, true).to.be.a('string');
	  };
	
	  /**
	   * ### .isNotString(value, [message])
	   *
	   * Asserts that `value` is _not_ a string.
	   *
	   *     var teaOrder = 4;
	   *     assert.isNotString(teaOrder, 'order placed');
	   *
	   * @name isNotString
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isNotString = function (val, msg) {
	    new Assertion(val, msg, assert.isNotString, true).to.not.be.a('string');
	  };
	
	  /**
	   * ### .isNumber(value, [message])
	   *
	   * Asserts that `value` is a number.
	   *
	   *     var cups = 2;
	   *     assert.isNumber(cups, 'how many cups');
	   *
	   * @name isNumber
	   * @param {Number} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isNumber = function (val, msg) {
	    new Assertion(val, msg, assert.isNumber, true).to.be.a('number');
	  };
	
	  /**
	   * ### .isNotNumber(value, [message])
	   *
	   * Asserts that `value` is _not_ a number.
	   *
	   *     var cups = '2 cups please';
	   *     assert.isNotNumber(cups, 'how many cups');
	   *
	   * @name isNotNumber
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isNotNumber = function (val, msg) {
	    new Assertion(val, msg, assert.isNotNumber, true).to.not.be.a('number');
	  };
	
	   /**
	   * ### .isFinite(value, [message])
	   *
	   * Asserts that `value` is a finite number. Unlike `.isNumber`, this will fail for `NaN` and `Infinity`.
	   *
	   *     var cups = 2;
	   *     assert.isFinite(cups, 'how many cups');
	   *
	   *     assert.isFinite(NaN); // throws
	   *
	   * @name isFinite
	   * @param {Number} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isFinite = function (val, msg) {
	    new Assertion(val, msg, assert.isFinite, true).to.be.finite;
	  };
	
	  /**
	   * ### .isBoolean(value, [message])
	   *
	   * Asserts that `value` is a boolean.
	   *
	   *     var teaReady = true
	   *       , teaServed = false;
	   *
	   *     assert.isBoolean(teaReady, 'is the tea ready');
	   *     assert.isBoolean(teaServed, 'has tea been served');
	   *
	   * @name isBoolean
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isBoolean = function (val, msg) {
	    new Assertion(val, msg, assert.isBoolean, true).to.be.a('boolean');
	  };
	
	  /**
	   * ### .isNotBoolean(value, [message])
	   *
	   * Asserts that `value` is _not_ a boolean.
	   *
	   *     var teaReady = 'yep'
	   *       , teaServed = 'nope';
	   *
	   *     assert.isNotBoolean(teaReady, 'is the tea ready');
	   *     assert.isNotBoolean(teaServed, 'has tea been served');
	   *
	   * @name isNotBoolean
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isNotBoolean = function (val, msg) {
	    new Assertion(val, msg, assert.isNotBoolean, true).to.not.be.a('boolean');
	  };
	
	  /**
	   * ### .typeOf(value, name, [message])
	   *
	   * Asserts that `value`'s type is `name`, as determined by
	   * `Object.prototype.toString`.
	   *
	   *     assert.typeOf({ tea: 'chai' }, 'object', 'we have an object');
	   *     assert.typeOf(['chai', 'jasmine'], 'array', 'we have an array');
	   *     assert.typeOf('tea', 'string', 'we have a string');
	   *     assert.typeOf(/tea/, 'regexp', 'we have a regular expression');
	   *     assert.typeOf(null, 'null', 'we have a null');
	   *     assert.typeOf(undefined, 'undefined', 'we have an undefined');
	   *
	   * @name typeOf
	   * @param {Mixed} value
	   * @param {String} name
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.typeOf = function (val, type, msg) {
	    new Assertion(val, msg, assert.typeOf, true).to.be.a(type);
	  };
	
	  /**
	   * ### .notTypeOf(value, name, [message])
	   *
	   * Asserts that `value`'s type is _not_ `name`, as determined by
	   * `Object.prototype.toString`.
	   *
	   *     assert.notTypeOf('tea', 'number', 'strings are not numbers');
	   *
	   * @name notTypeOf
	   * @param {Mixed} value
	   * @param {String} typeof name
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notTypeOf = function (val, type, msg) {
	    new Assertion(val, msg, assert.notTypeOf, true).to.not.be.a(type);
	  };
	
	  /**
	   * ### .instanceOf(object, constructor, [message])
	   *
	   * Asserts that `value` is an instance of `constructor`.
	   *
	   *     var Tea = function (name) { this.name = name; }
	   *       , chai = new Tea('chai');
	   *
	   *     assert.instanceOf(chai, Tea, 'chai is an instance of tea');
	   *
	   * @name instanceOf
	   * @param {Object} object
	   * @param {Constructor} constructor
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.instanceOf = function (val, type, msg) {
	    new Assertion(val, msg, assert.instanceOf, true).to.be.instanceOf(type);
	  };
	
	  /**
	   * ### .notInstanceOf(object, constructor, [message])
	   *
	   * Asserts `value` is not an instance of `constructor`.
	   *
	   *     var Tea = function (name) { this.name = name; }
	   *       , chai = new String('chai');
	   *
	   *     assert.notInstanceOf(chai, Tea, 'chai is not an instance of tea');
	   *
	   * @name notInstanceOf
	   * @param {Object} object
	   * @param {Constructor} constructor
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notInstanceOf = function (val, type, msg) {
	    new Assertion(val, msg, assert.notInstanceOf, true)
	      .to.not.be.instanceOf(type);
	  };
	
	  /**
	   * ### .include(haystack, needle, [message])
	   *
	   * Asserts that `haystack` includes `needle`. Can be used to assert the
	   * inclusion of a value in an array, a substring in a string, or a subset of
	   * properties in an object.
	   *
	   *     assert.include([1,2,3], 2, 'array contains value');
	   *     assert.include('foobar', 'foo', 'string contains substring');
	   *     assert.include({ foo: 'bar', hello: 'universe' }, { foo: 'bar' }, 'object contains property');
	   *
	   * Strict equality (===) is used. When asserting the inclusion of a value in
	   * an array, the array is searched for an element that's strictly equal to the
	   * given value. When asserting a subset of properties in an object, the object
	   * is searched for the given property keys, checking that each one is present
	   * and stricty equal to the given property value. For instance:
	   *
	   *     var obj1 = {a: 1}
	   *       , obj2 = {b: 2};
	   *     assert.include([obj1, obj2], obj1);
	   *     assert.include({foo: obj1, bar: obj2}, {foo: obj1});
	   *     assert.include({foo: obj1, bar: obj2}, {foo: obj1, bar: obj2});
	   *
	   * @name include
	   * @param {Array|String} haystack
	   * @param {Mixed} needle
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.include = function (exp, inc, msg) {
	    new Assertion(exp, msg, assert.include, true).include(inc);
	  };
	
	  /**
	   * ### .notInclude(haystack, needle, [message])
	   *
	   * Asserts that `haystack` does not include `needle`. Can be used to assert
	   * the absence of a value in an array, a substring in a string, or a subset of
	   * properties in an object.
	   *
	   *     assert.notInclude([1,2,3], 4, 'array doesn't contain value');
	   *     assert.notInclude('foobar', 'baz', 'string doesn't contain substring');
	   *     assert.notInclude({ foo: 'bar', hello: 'universe' }, { foo: 'baz' }, 'object doesn't contain property');
	   *
	   * Strict equality (===) is used. When asserting the absence of a value in an
	   * array, the array is searched to confirm the absence of an element that's
	   * strictly equal to the given value. When asserting a subset of properties in
	   * an object, the object is searched to confirm that at least one of the given
	   * property keys is either not present or not strictly equal to the given
	   * property value. For instance:
	   *
	   *     var obj1 = {a: 1}
	   *       , obj2 = {b: 2};
	   *     assert.notInclude([obj1, obj2], {a: 1});
	   *     assert.notInclude({foo: obj1, bar: obj2}, {foo: {a: 1}});
	   *     assert.notInclude({foo: obj1, bar: obj2}, {foo: obj1, bar: {b: 2}});
	   *
	   * @name notInclude
	   * @param {Array|String} haystack
	   * @param {Mixed} needle
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notInclude = function (exp, inc, msg) {
	    new Assertion(exp, msg, assert.notInclude, true).not.include(inc);
	  };
	
	  /**
	   * ### .deepInclude(haystack, needle, [message])
	   *
	   * Asserts that `haystack` includes `needle`. Can be used to assert the
	   * inclusion of a value in an array or a subset of properties in an object.
	   * Deep equality is used.
	   *
	   *     var obj1 = {a: 1}
	   *       , obj2 = {b: 2};
	   *     assert.deepInclude([obj1, obj2], {a: 1});
	   *     assert.deepInclude({foo: obj1, bar: obj2}, {foo: {a: 1}});
	   *     assert.deepInclude({foo: obj1, bar: obj2}, {foo: {a: 1}, bar: {b: 2}});
	   *
	   * @name deepInclude
	   * @param {Array|String} haystack
	   * @param {Mixed} needle
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.deepInclude = function (exp, inc, msg) {
	    new Assertion(exp, msg, assert.deepInclude, true).deep.include(inc);
	  };
	
	  /**
	   * ### .notDeepInclude(haystack, needle, [message])
	   *
	   * Asserts that `haystack` does not include `needle`. Can be used to assert
	   * the absence of a value in an array or a subset of properties in an object.
	   * Deep equality is used.
	   *
	   *     var obj1 = {a: 1}
	   *       , obj2 = {b: 2};
	   *     assert.notDeepInclude([obj1, obj2], {a: 9});
	   *     assert.notDeepInclude({foo: obj1, bar: obj2}, {foo: {a: 9}});
	   *     assert.notDeepInclude({foo: obj1, bar: obj2}, {foo: {a: 1}, bar: {b: 9}});
	   *
	   * @name notDeepInclude
	   * @param {Array|String} haystack
	   * @param {Mixed} needle
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notDeepInclude = function (exp, inc, msg) {
	    new Assertion(exp, msg, assert.notDeepInclude, true).not.deep.include(inc);
	  };
	
	  /**
	   * ### .nestedInclude(haystack, needle, [message])
	   * 
	   * Asserts that 'haystack' includes 'needle'. 
	   * Can be used to assert the inclusion of a subset of properties in an 
	   * object.
	   * Enables the use of dot- and bracket-notation for referencing nested 
	   * properties.
	   * '[]' and '.' in property names can be escaped using double backslashes.
	   * 
	   *     assert.nestedInclude({'.a': {'b': 'x'}}, {'\\.a.[b]': 'x'});
	   *     assert.nestedInclude({'a': {'[b]': 'x'}}, {'a.\\[b\\]': 'x'});
	   * 
	   * @name nestedInclude
	   * @param {Object} haystack
	   * @param {Object} needle
	   * @param {String} message
	   * @namespace Assert
	   * @api public 
	   */ 
	
	  assert.nestedInclude = function (exp, inc, msg) {
	    new Assertion(exp, msg, assert.nestedInclude, true).nested.include(inc);
	  };
	
	  /**
	   * ### .notNestedInclude(haystack, needle, [message])
	   * 
	   * Asserts that 'haystack' does not include 'needle'. 
	   * Can be used to assert the absence of a subset of properties in an 
	   * object.
	   * Enables the use of dot- and bracket-notation for referencing nested 
	   * properties. 
	   * '[]' and '.' in property names can be escaped using double backslashes.
	   * 
	   *     assert.notNestedInclude({'.a': {'b': 'x'}}, {'\\.a.b': 'y'});
	   *     assert.notNestedInclude({'a': {'[b]': 'x'}}, {'a.\\[b\\]': 'y'});
	   * 
	   * @name notNestedInclude
	   * @param {Object} haystack
	   * @param {Object} needle
	   * @param {String} message
	   * @namespace Assert
	   * @api public 
	   */ 
	
	  assert.notNestedInclude = function (exp, inc, msg) {
	    new Assertion(exp, msg, assert.notNestedInclude, true)
	      .not.nested.include(inc);
	  };
	
	  /**
	   * ### .deepNestedInclude(haystack, needle, [message])
	   * 
	   * Asserts that 'haystack' includes 'needle'.
	   * Can be used to assert the inclusion of a subset of properties in an 
	   * object while checking for deep equality.
	   * Enables the use of dot- and bracket-notation for referencing nested 
	   * properties.
	   * '[]' and '.' in property names can be escaped using double backslashes.
	   * 
	   *     assert.deepNestedInclude({a: {b: [{x: 1}]}}, {'a.b[0]': {x: 1}});
	   *     assert.deepNestedInclude({'.a': {'[b]': {x: 1}}}, {'\\.a.\\[b\\]': {x: 1}});
	   *    
	   * @name deepNestedInclude
	   * @param {Object} haystack
	   * @param {Object} needle
	   * @param {String} message
	   * @namespace Assert
	   * @api public 
	   */
	
	  assert.deepNestedInclude = function(exp, inc, msg) {
	    new Assertion(exp, msg, assert.deepNestedInclude, true)
	      .deep.nested.include(inc);
	  };
	
	  /**
	   * ### .notDeepNestedInclude(haystack, needle, [message])
	   * 
	   * Asserts that 'haystack' does not include 'needle'.
	   * Can be used to assert the absence of a subset of properties in an 
	   * object while checking for deep equality.
	   * Enables the use of dot- and bracket-notation for referencing nested 
	   * properties.
	   * '[]' and '.' in property names can be escaped using double backslashes.
	   * 
	   *     assert.notDeepNestedInclude({a: {b: [{x: 1}]}}, {'a.b[0]': {y: 1}})
	   *     assert.notDeepNestedInclude({'.a': {'[b]': {x: 1}}}, {'\\.a.\\[b\\]': {y: 2}});
	   *    
	   * @name notDeepNestedInclude
	   * @param {Object} haystack
	   * @param {Object} needle
	   * @param {String} message
	   * @namespace Assert
	   * @api public 
	   */
	
	  assert.notDeepNestedInclude = function(exp, inc, msg) {
	    new Assertion(exp, msg, assert.notDeepNestedInclude, true)
	      .not.deep.nested.include(inc);
	  };
	
	  /**
	   * ### .ownInclude(haystack, needle, [message])
	   * 
	   * Asserts that 'haystack' includes 'needle'.
	   * Can be used to assert the inclusion of a subset of properties in an 
	   * object while ignoring inherited properties.
	   * 
	   *     assert.ownInclude({ a: 1 }, { a: 1 });
	   * 
	   * @name ownInclude
	   * @param {Object} haystack
	   * @param {Object} needle
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.ownInclude = function(exp, inc, msg) {
	    new Assertion(exp, msg, assert.ownInclude, true).own.include(inc);
	  };
	
	  /**
	   * ### .notOwnInclude(haystack, needle, [message])
	   * 
	   * Asserts that 'haystack' includes 'needle'.
	   * Can be used to assert the absence of a subset of properties in an 
	   * object while ignoring inherited properties.
	   * 
	   *     Object.prototype.b = 2;
	   * 
	   *     assert.notOwnInclude({ a: 1 }, { b: 2 });
	   * 
	   * @name notOwnInclude
	   * @param {Object} haystack
	   * @param {Object} needle
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notOwnInclude = function(exp, inc, msg) {
	    new Assertion(exp, msg, assert.notOwnInclude, true).not.own.include(inc);
	  };
	
	  /**
	   * ### .deepOwnInclude(haystack, needle, [message])
	   * 
	   * Asserts that 'haystack' includes 'needle'.
	   * Can be used to assert the inclusion of a subset of properties in an 
	   * object while ignoring inherited properties and checking for deep equality.
	   * 
	   *      assert.deepOwnInclude({a: {b: 2}}, {a: {b: 2}});
	   *      
	   * @name deepOwnInclude
	   * @param {Object} haystack
	   * @param {Object} needle
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.deepOwnInclude = function(exp, inc, msg) {
	    new Assertion(exp, msg, assert.deepOwnInclude, true)
	      .deep.own.include(inc);
	  };
	
	   /**
	   * ### .notDeepOwnInclude(haystack, needle, [message])
	   * 
	   * Asserts that 'haystack' includes 'needle'.
	   * Can be used to assert the absence of a subset of properties in an 
	   * object while ignoring inherited properties and checking for deep equality.
	   * 
	   *      assert.notDeepOwnInclude({a: {b: 2}}, {a: {c: 3}});
	   *      
	   * @name notDeepOwnInclude
	   * @param {Object} haystack
	   * @param {Object} needle
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notDeepOwnInclude = function(exp, inc, msg) {
	    new Assertion(exp, msg, assert.notDeepOwnInclude, true)
	      .not.deep.own.include(inc);
	  };
	
	  /**
	   * ### .match(value, regexp, [message])
	   *
	   * Asserts that `value` matches the regular expression `regexp`.
	   *
	   *     assert.match('foobar', /^foo/, 'regexp matches');
	   *
	   * @name match
	   * @param {Mixed} value
	   * @param {RegExp} regexp
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.match = function (exp, re, msg) {
	    new Assertion(exp, msg, assert.match, true).to.match(re);
	  };
	
	  /**
	   * ### .notMatch(value, regexp, [message])
	   *
	   * Asserts that `value` does not match the regular expression `regexp`.
	   *
	   *     assert.notMatch('foobar', /^foo/, 'regexp does not match');
	   *
	   * @name notMatch
	   * @param {Mixed} value
	   * @param {RegExp} regexp
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notMatch = function (exp, re, msg) {
	    new Assertion(exp, msg, assert.notMatch, true).to.not.match(re);
	  };
	
	  /**
	   * ### .property(object, property, [message])
	   *
	   * Asserts that `object` has a direct or inherited property named by
	   * `property`.
	   *
	   *     assert.property({ tea: { green: 'matcha' }}, 'tea');
	   *     assert.property({ tea: { green: 'matcha' }}, 'toString');
	   *
	   * @name property
	   * @param {Object} object
	   * @param {String} property
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.property = function (obj, prop, msg) {
	    new Assertion(obj, msg, assert.property, true).to.have.property(prop);
	  };
	
	  /**
	   * ### .notProperty(object, property, [message])
	   *
	   * Asserts that `object` does _not_ have a direct or inherited property named
	   * by `property`.
	   *
	   *     assert.notProperty({ tea: { green: 'matcha' }}, 'coffee');
	   *
	   * @name notProperty
	   * @param {Object} object
	   * @param {String} property
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notProperty = function (obj, prop, msg) {
	    new Assertion(obj, msg, assert.notProperty, true)
	      .to.not.have.property(prop);
	  };
	
	  /**
	   * ### .propertyVal(object, property, value, [message])
	   *
	   * Asserts that `object` has a direct or inherited property named by
	   * `property` with a value given by `value`. Uses a strict equality check
	   * (===).
	   *
	   *     assert.propertyVal({ tea: 'is good' }, 'tea', 'is good');
	   *
	   * @name propertyVal
	   * @param {Object} object
	   * @param {String} property
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.propertyVal = function (obj, prop, val, msg) {
	    new Assertion(obj, msg, assert.propertyVal, true)
	      .to.have.property(prop, val);
	  };
	
	  /**
	   * ### .notPropertyVal(object, property, value, [message])
	   *
	   * Asserts that `object` does _not_ have a direct or inherited property named
	   * by `property` with value given by `value`. Uses a strict equality check
	   * (===).
	   *
	   *     assert.notPropertyVal({ tea: 'is good' }, 'tea', 'is bad');
	   *     assert.notPropertyVal({ tea: 'is good' }, 'coffee', 'is good');
	   *
	   * @name notPropertyVal
	   * @param {Object} object
	   * @param {String} property
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notPropertyVal = function (obj, prop, val, msg) {
	    new Assertion(obj, msg, assert.notPropertyVal, true)
	      .to.not.have.property(prop, val);
	  };
	
	  /**
	   * ### .deepPropertyVal(object, property, value, [message])
	   *
	   * Asserts that `object` has a direct or inherited property named by
	   * `property` with a value given by `value`. Uses a deep equality check.
	   *
	   *     assert.deepPropertyVal({ tea: { green: 'matcha' } }, 'tea', { green: 'matcha' });
	   *
	   * @name deepPropertyVal
	   * @param {Object} object
	   * @param {String} property
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.deepPropertyVal = function (obj, prop, val, msg) {
	    new Assertion(obj, msg, assert.deepPropertyVal, true)
	      .to.have.deep.property(prop, val);
	  };
	
	  /**
	   * ### .notDeepPropertyVal(object, property, value, [message])
	   *
	   * Asserts that `object` does _not_ have a direct or inherited property named
	   * by `property` with value given by `value`. Uses a deep equality check.
	   *
	   *     assert.notDeepPropertyVal({ tea: { green: 'matcha' } }, 'tea', { black: 'matcha' });
	   *     assert.notDeepPropertyVal({ tea: { green: 'matcha' } }, 'tea', { green: 'oolong' });
	   *     assert.notDeepPropertyVal({ tea: { green: 'matcha' } }, 'coffee', { green: 'matcha' });
	   *
	   * @name notDeepPropertyVal
	   * @param {Object} object
	   * @param {String} property
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notDeepPropertyVal = function (obj, prop, val, msg) {
	    new Assertion(obj, msg, assert.notDeepPropertyVal, true)
	      .to.not.have.deep.property(prop, val);
	  };
	
	  /**
	   * ### .ownProperty(object, property, [message])
	   *
	   * Asserts that `object` has a direct property named by `property`. Inherited
	   * properties aren't checked.
	   *
	   *     assert.ownProperty({ tea: { green: 'matcha' }}, 'tea');
	   *
	   * @name ownProperty
	   * @param {Object} object
	   * @param {String} property
	   * @param {String} message
	   * @api public
	   */
	
	  assert.ownProperty = function (obj, prop, msg) {
	    new Assertion(obj, msg, assert.ownProperty, true)
	      .to.have.own.property(prop);
	  };
	
	  /**
	   * ### .notOwnProperty(object, property, [message])
	   *
	   * Asserts that `object` does _not_ have a direct property named by
	   * `property`. Inherited properties aren't checked.
	   *
	   *     assert.notOwnProperty({ tea: { green: 'matcha' }}, 'coffee');
	   *     assert.notOwnProperty({}, 'toString');
	   *
	   * @name notOwnProperty
	   * @param {Object} object
	   * @param {String} property
	   * @param {String} message
	   * @api public
	   */
	
	  assert.notOwnProperty = function (obj, prop, msg) {
	    new Assertion(obj, msg, assert.notOwnProperty, true)
	      .to.not.have.own.property(prop);
	  };
	
	  /**
	   * ### .ownPropertyVal(object, property, value, [message])
	   *
	   * Asserts that `object` has a direct property named by `property` and a value
	   * equal to the provided `value`. Uses a strict equality check (===).
	   * Inherited properties aren't checked.
	   *
	   *     assert.ownPropertyVal({ coffee: 'is good'}, 'coffee', 'is good');
	   *
	   * @name ownPropertyVal
	   * @param {Object} object
	   * @param {String} property
	   * @param {Mixed} value
	   * @param {String} message
	   * @api public
	   */
	
	  assert.ownPropertyVal = function (obj, prop, value, msg) {
	    new Assertion(obj, msg, assert.ownPropertyVal, true)
	      .to.have.own.property(prop, value);
	  };
	
	  /**
	   * ### .notOwnPropertyVal(object, property, value, [message])
	   *
	   * Asserts that `object` does _not_ have a direct property named by `property`
	   * with a value equal to the provided `value`. Uses a strict equality check
	   * (===). Inherited properties aren't checked.
	   *
	   *     assert.notOwnPropertyVal({ tea: 'is better'}, 'tea', 'is worse');
	   *     assert.notOwnPropertyVal({}, 'toString', Object.prototype.toString);
	   *
	   * @name notOwnPropertyVal
	   * @param {Object} object
	   * @param {String} property
	   * @param {Mixed} value
	   * @param {String} message
	   * @api public
	   */
	
	  assert.notOwnPropertyVal = function (obj, prop, value, msg) {
	    new Assertion(obj, msg, assert.notOwnPropertyVal, true)
	      .to.not.have.own.property(prop, value);
	  };
	
	  /**
	   * ### .deepOwnPropertyVal(object, property, value, [message])
	   *
	   * Asserts that `object` has a direct property named by `property` and a value
	   * equal to the provided `value`. Uses a deep equality check. Inherited
	   * properties aren't checked.
	   *
	   *     assert.deepOwnPropertyVal({ tea: { green: 'matcha' } }, 'tea', { green: 'matcha' });
	   *
	   * @name deepOwnPropertyVal
	   * @param {Object} object
	   * @param {String} property
	   * @param {Mixed} value
	   * @param {String} message
	   * @api public
	   */
	
	  assert.deepOwnPropertyVal = function (obj, prop, value, msg) {
	    new Assertion(obj, msg, assert.deepOwnPropertyVal, true)
	      .to.have.deep.own.property(prop, value);
	  };
	
	  /**
	   * ### .notDeepOwnPropertyVal(object, property, value, [message])
	   *
	   * Asserts that `object` does _not_ have a direct property named by `property`
	   * with a value equal to the provided `value`. Uses a deep equality check.
	   * Inherited properties aren't checked.
	   *
	   *     assert.notDeepOwnPropertyVal({ tea: { green: 'matcha' } }, 'tea', { black: 'matcha' });
	   *     assert.notDeepOwnPropertyVal({ tea: { green: 'matcha' } }, 'tea', { green: 'oolong' });
	   *     assert.notDeepOwnPropertyVal({ tea: { green: 'matcha' } }, 'coffee', { green: 'matcha' });
	   *     assert.notDeepOwnPropertyVal({}, 'toString', Object.prototype.toString);
	   *
	   * @name notDeepOwnPropertyVal
	   * @param {Object} object
	   * @param {String} property
	   * @param {Mixed} value
	   * @param {String} message
	   * @api public
	   */
	
	  assert.notDeepOwnPropertyVal = function (obj, prop, value, msg) {
	    new Assertion(obj, msg, assert.notDeepOwnPropertyVal, true)
	      .to.not.have.deep.own.property(prop, value);
	  };
	
	  /**
	   * ### .nestedProperty(object, property, [message])
	   *
	   * Asserts that `object` has a direct or inherited property named by
	   * `property`, which can be a string using dot- and bracket-notation for
	   * nested reference.
	   *
	   *     assert.nestedProperty({ tea: { green: 'matcha' }}, 'tea.green');
	   *
	   * @name nestedProperty
	   * @param {Object} object
	   * @param {String} property
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.nestedProperty = function (obj, prop, msg) {
	    new Assertion(obj, msg, assert.nestedProperty, true)
	      .to.have.nested.property(prop);
	  };
	
	  /**
	   * ### .notNestedProperty(object, property, [message])
	   *
	   * Asserts that `object` does _not_ have a property named by `property`, which
	   * can be a string using dot- and bracket-notation for nested reference. The
	   * property cannot exist on the object nor anywhere in its prototype chain.
	   *
	   *     assert.notNestedProperty({ tea: { green: 'matcha' }}, 'tea.oolong');
	   *
	   * @name notNestedProperty
	   * @param {Object} object
	   * @param {String} property
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notNestedProperty = function (obj, prop, msg) {
	    new Assertion(obj, msg, assert.notNestedProperty, true)
	      .to.not.have.nested.property(prop);
	  };
	
	  /**
	   * ### .nestedPropertyVal(object, property, value, [message])
	   *
	   * Asserts that `object` has a property named by `property` with value given
	   * by `value`. `property` can use dot- and bracket-notation for nested
	   * reference. Uses a strict equality check (===).
	   *
	   *     assert.nestedPropertyVal({ tea: { green: 'matcha' }}, 'tea.green', 'matcha');
	   *
	   * @name nestedPropertyVal
	   * @param {Object} object
	   * @param {String} property
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.nestedPropertyVal = function (obj, prop, val, msg) {
	    new Assertion(obj, msg, assert.nestedPropertyVal, true)
	      .to.have.nested.property(prop, val);
	  };
	
	  /**
	   * ### .notNestedPropertyVal(object, property, value, [message])
	   *
	   * Asserts that `object` does _not_ have a property named by `property` with
	   * value given by `value`. `property` can use dot- and bracket-notation for
	   * nested reference. Uses a strict equality check (===).
	   *
	   *     assert.notNestedPropertyVal({ tea: { green: 'matcha' }}, 'tea.green', 'konacha');
	   *     assert.notNestedPropertyVal({ tea: { green: 'matcha' }}, 'coffee.green', 'matcha');
	   *
	   * @name notNestedPropertyVal
	   * @param {Object} object
	   * @param {String} property
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notNestedPropertyVal = function (obj, prop, val, msg) {
	    new Assertion(obj, msg, assert.notNestedPropertyVal, true)
	      .to.not.have.nested.property(prop, val);
	  };
	
	  /**
	   * ### .deepNestedPropertyVal(object, property, value, [message])
	   *
	   * Asserts that `object` has a property named by `property` with a value given
	   * by `value`. `property` can use dot- and bracket-notation for nested
	   * reference. Uses a deep equality check.
	   *
	   *     assert.deepNestedPropertyVal({ tea: { green: { matcha: 'yum' } } }, 'tea.green', { matcha: 'yum' });
	   *
	   * @name deepNestedPropertyVal
	   * @param {Object} object
	   * @param {String} property
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.deepNestedPropertyVal = function (obj, prop, val, msg) {
	    new Assertion(obj, msg, assert.deepNestedPropertyVal, true)
	      .to.have.deep.nested.property(prop, val);
	  };
	
	  /**
	   * ### .notDeepNestedPropertyVal(object, property, value, [message])
	   *
	   * Asserts that `object` does _not_ have a property named by `property` with
	   * value given by `value`. `property` can use dot- and bracket-notation for
	   * nested reference. Uses a deep equality check.
	   *
	   *     assert.notDeepNestedPropertyVal({ tea: { green: { matcha: 'yum' } } }, 'tea.green', { oolong: 'yum' });
	   *     assert.notDeepNestedPropertyVal({ tea: { green: { matcha: 'yum' } } }, 'tea.green', { matcha: 'yuck' });
	   *     assert.notDeepNestedPropertyVal({ tea: { green: { matcha: 'yum' } } }, 'tea.black', { matcha: 'yum' });
	   *
	   * @name notDeepNestedPropertyVal
	   * @param {Object} object
	   * @param {String} property
	   * @param {Mixed} value
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notDeepNestedPropertyVal = function (obj, prop, val, msg) {
	    new Assertion(obj, msg, assert.notDeepNestedPropertyVal, true)
	      .to.not.have.deep.nested.property(prop, val);
	  }
	
	  /**
	   * ### .lengthOf(object, length, [message])
	   *
	   * Asserts that `object` has a `length` property with the expected value.
	   *
	   *     assert.lengthOf([1,2,3], 3, 'array has length of 3');
	   *     assert.lengthOf('foobar', 6, 'string has length of 6');
	   *
	   * @name lengthOf
	   * @param {Mixed} object
	   * @param {Number} length
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.lengthOf = function (exp, len, msg) {
	    new Assertion(exp, msg, assert.lengthOf, true).to.have.lengthOf(len);
	  };
	
	  /**
	   * ### .hasAnyKeys(object, [keys], [message])
	   *
	   * Asserts that `object` has at least one of the `keys` provided.
	   * You can also provide a single object instead of a `keys` array and its keys
	   * will be used as the expected set of keys.
	   *
	   *     assert.hasAnyKeys({foo: 1, bar: 2, baz: 3}, ['foo', 'iDontExist', 'baz']);
	   *     assert.hasAnyKeys({foo: 1, bar: 2, baz: 3}, {foo: 30, iDontExist: 99, baz: 1337});
	   *     assert.hasAnyKeys(new Map([[{foo: 1}, 'bar'], ['key', 'value']]), [{foo: 1}, 'key']);
	   *     assert.hasAnyKeys(new Set([{foo: 'bar'}, 'anotherKey']), [{foo: 'bar'}, 'anotherKey']);
	   *
	   * @name hasAnyKeys
	   * @param {Mixed} object
	   * @param {Array|Object} keys
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.hasAnyKeys = function (obj, keys, msg) {
	    new Assertion(obj, msg, assert.hasAnyKeys, true).to.have.any.keys(keys);
	  }
	
	  /**
	   * ### .hasAllKeys(object, [keys], [message])
	   *
	   * Asserts that `object` has all and only all of the `keys` provided.
	   * You can also provide a single object instead of a `keys` array and its keys
	   * will be used as the expected set of keys.
	   *
	   *     assert.hasAllKeys({foo: 1, bar: 2, baz: 3}, ['foo', 'bar', 'baz']);
	   *     assert.hasAllKeys({foo: 1, bar: 2, baz: 3}, {foo: 30, bar: 99, baz: 1337]);
	   *     assert.hasAllKeys(new Map([[{foo: 1}, 'bar'], ['key', 'value']]), [{foo: 1}, 'key']);
	   *     assert.hasAllKeys(new Set([{foo: 'bar'}, 'anotherKey'], [{foo: 'bar'}, 'anotherKey']);
	   *
	   * @name hasAllKeys
	   * @param {Mixed} object
	   * @param {String[]} keys
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.hasAllKeys = function (obj, keys, msg) {
	    new Assertion(obj, msg, assert.hasAllKeys, true).to.have.all.keys(keys);
	  }
	
	  /**
	   * ### .containsAllKeys(object, [keys], [message])
	   *
	   * Asserts that `object` has all of the `keys` provided but may have more keys not listed.
	   * You can also provide a single object instead of a `keys` array and its keys
	   * will be used as the expected set of keys.
	   *
	   *     assert.containsAllKeys({foo: 1, bar: 2, baz: 3}, ['foo', 'baz']);
	   *     assert.containsAllKeys({foo: 1, bar: 2, baz: 3}, ['foo', 'bar', 'baz']);
	   *     assert.containsAllKeys({foo: 1, bar: 2, baz: 3}, {foo: 30, baz: 1337});
	   *     assert.containsAllKeys({foo: 1, bar: 2, baz: 3}, {foo: 30, bar: 99, baz: 1337});
	   *     assert.containsAllKeys(new Map([[{foo: 1}, 'bar'], ['key', 'value']]), [{foo: 1}]);
	   *     assert.containsAllKeys(new Map([[{foo: 1}, 'bar'], ['key', 'value']]), [{foo: 1}, 'key']);
	   *     assert.containsAllKeys(new Set([{foo: 'bar'}, 'anotherKey'], [{foo: 'bar'}]);
	   *     assert.containsAllKeys(new Set([{foo: 'bar'}, 'anotherKey'], [{foo: 'bar'}, 'anotherKey']);
	   *
	   * @name containsAllKeys
	   * @param {Mixed} object
	   * @param {String[]} keys
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.containsAllKeys = function (obj, keys, msg) {
	    new Assertion(obj, msg, assert.containsAllKeys, true)
	      .to.contain.all.keys(keys);
	  }
	
	  /**
	   * ### .doesNotHaveAnyKeys(object, [keys], [message])
	   *
	   * Asserts that `object` has none of the `keys` provided.
	   * You can also provide a single object instead of a `keys` array and its keys
	   * will be used as the expected set of keys.
	   *
	   *     assert.doesNotHaveAnyKeys({foo: 1, bar: 2, baz: 3}, ['one', 'two', 'example']);
	   *     assert.doesNotHaveAnyKeys({foo: 1, bar: 2, baz: 3}, {one: 1, two: 2, example: 'foo'});
	   *     assert.doesNotHaveAnyKeys(new Map([[{foo: 1}, 'bar'], ['key', 'value']]), [{one: 'two'}, 'example']);
	   *     assert.doesNotHaveAnyKeys(new Set([{foo: 'bar'}, 'anotherKey'], [{one: 'two'}, 'example']);
	   *
	   * @name doesNotHaveAnyKeys
	   * @param {Mixed} object
	   * @param {String[]} keys
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.doesNotHaveAnyKeys = function (obj, keys, msg) {
	    new Assertion(obj, msg, assert.doesNotHaveAnyKeys, true)
	      .to.not.have.any.keys(keys);
	  }
	
	  /**
	   * ### .doesNotHaveAllKeys(object, [keys], [message])
	   *
	   * Asserts that `object` does not have at least one of the `keys` provided.
	   * You can also provide a single object instead of a `keys` array and its keys
	   * will be used as the expected set of keys.
	   *
	   *     assert.doesNotHaveAllKeys({foo: 1, bar: 2, baz: 3}, ['one', 'two', 'example']);
	   *     assert.doesNotHaveAllKeys({foo: 1, bar: 2, baz: 3}, {one: 1, two: 2, example: 'foo'});
	   *     assert.doesNotHaveAllKeys(new Map([[{foo: 1}, 'bar'], ['key', 'value']]), [{one: 'two'}, 'example']);
	   *     assert.doesNotHaveAllKeys(new Set([{foo: 'bar'}, 'anotherKey'], [{one: 'two'}, 'example']);
	   *
	   * @name doesNotHaveAllKeys
	   * @param {Mixed} object
	   * @param {String[]} keys
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.doesNotHaveAllKeys = function (obj, keys, msg) {
	    new Assertion(obj, msg, assert.doesNotHaveAllKeys, true)
	      .to.not.have.all.keys(keys);
	  }
	
	  /**
	   * ### .hasAnyDeepKeys(object, [keys], [message])
	   *
	   * Asserts that `object` has at least one of the `keys` provided.
	   * Since Sets and Maps can have objects as keys you can use this assertion to perform
	   * a deep comparison.
	   * You can also provide a single object instead of a `keys` array and its keys
	   * will be used as the expected set of keys.
	   *
	   *     assert.hasAnyDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [1, 2]]), {one: 'one'});
	   *     assert.hasAnyDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [1, 2]]), [{one: 'one'}, {two: 'two'}]);
	   *     assert.hasAnyDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [{two: 'two'}, 'valueTwo']]), [{one: 'one'}, {two: 'two'}]);
	   *     assert.hasAnyDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), {one: 'one'});
	   *     assert.hasAnyDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), [{one: 'one'}, {three: 'three'}]);
	   *     assert.hasAnyDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), [{one: 'one'}, {two: 'two'}]);
	   *
	   * @name doesNotHaveAllKeys
	   * @param {Mixed} object
	   * @param {Array|Object} keys
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.hasAnyDeepKeys = function (obj, keys, msg) {
	    new Assertion(obj, msg, assert.hasAnyDeepKeys, true)
	      .to.have.any.deep.keys(keys);
	  }
	
	 /**
	   * ### .hasAllDeepKeys(object, [keys], [message])
	   *
	   * Asserts that `object` has all and only all of the `keys` provided.
	   * Since Sets and Maps can have objects as keys you can use this assertion to perform
	   * a deep comparison.
	   * You can also provide a single object instead of a `keys` array and its keys
	   * will be used as the expected set of keys.
	   *
	   *     assert.hasAllDeepKeys(new Map([[{one: 'one'}, 'valueOne']]), {one: 'one'});
	   *     assert.hasAllDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [{two: 'two'}, 'valueTwo']]), [{one: 'one'}, {two: 'two'}]);
	   *     assert.hasAllDeepKeys(new Set([{one: 'one'}]), {one: 'one'});
	   *     assert.hasAllDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), [{one: 'one'}, {two: 'two'}]);
	   *
	   * @name hasAllDeepKeys
	   * @param {Mixed} object
	   * @param {Array|Object} keys
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.hasAllDeepKeys = function (obj, keys, msg) {
	    new Assertion(obj, msg, assert.hasAllDeepKeys, true)
	      .to.have.all.deep.keys(keys);
	  }
	
	 /**
	   * ### .containsAllDeepKeys(object, [keys], [message])
	   *
	   * Asserts that `object` contains all of the `keys` provided.
	   * Since Sets and Maps can have objects as keys you can use this assertion to perform
	   * a deep comparison.
	   * You can also provide a single object instead of a `keys` array and its keys
	   * will be used as the expected set of keys.
	   *
	   *     assert.containsAllDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [1, 2]]), {one: 'one'});
	   *     assert.containsAllDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [{two: 'two'}, 'valueTwo']]), [{one: 'one'}, {two: 'two'}]);
	   *     assert.containsAllDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), {one: 'one'});
	   *     assert.containsAllDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), [{one: 'one'}, {two: 'two'}]);
	   *
	   * @name containsAllDeepKeys
	   * @param {Mixed} object
	   * @param {Array|Object} keys
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.containsAllDeepKeys = function (obj, keys, msg) {
	    new Assertion(obj, msg, assert.containsAllDeepKeys, true)
	      .to.contain.all.deep.keys(keys);
	  }
	
	 /**
	   * ### .doesNotHaveAnyDeepKeys(object, [keys], [message])
	   *
	   * Asserts that `object` has none of the `keys` provided.
	   * Since Sets and Maps can have objects as keys you can use this assertion to perform
	   * a deep comparison.
	   * You can also provide a single object instead of a `keys` array and its keys
	   * will be used as the expected set of keys.
	   *
	   *     assert.doesNotHaveAnyDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [1, 2]]), {thisDoesNot: 'exist'});
	   *     assert.doesNotHaveAnyDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [{two: 'two'}, 'valueTwo']]), [{twenty: 'twenty'}, {fifty: 'fifty'}]);
	   *     assert.doesNotHaveAnyDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), {twenty: 'twenty'});
	   *     assert.doesNotHaveAnyDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), [{twenty: 'twenty'}, {fifty: 'fifty'}]);
	   *
	   * @name doesNotHaveAnyDeepKeys
	   * @param {Mixed} object
	   * @param {Array|Object} keys
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.doesNotHaveAnyDeepKeys = function (obj, keys, msg) {
	    new Assertion(obj, msg, assert.doesNotHaveAnyDeepKeys, true)
	      .to.not.have.any.deep.keys(keys);
	  }
	
	 /**
	   * ### .doesNotHaveAllDeepKeys(object, [keys], [message])
	   *
	   * Asserts that `object` does not have at least one of the `keys` provided.
	   * Since Sets and Maps can have objects as keys you can use this assertion to perform
	   * a deep comparison.
	   * You can also provide a single object instead of a `keys` array and its keys
	   * will be used as the expected set of keys.
	   *
	   *     assert.doesNotHaveAllDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [1, 2]]), {thisDoesNot: 'exist'});
	   *     assert.doesNotHaveAllDeepKeys(new Map([[{one: 'one'}, 'valueOne'], [{two: 'two'}, 'valueTwo']]), [{twenty: 'twenty'}, {one: 'one'}]);
	   *     assert.doesNotHaveAllDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), {twenty: 'twenty'});
	   *     assert.doesNotHaveAllDeepKeys(new Set([{one: 'one'}, {two: 'two'}]), [{one: 'one'}, {fifty: 'fifty'}]);
	   *
	   * @name doesNotHaveAllDeepKeys
	   * @param {Mixed} object
	   * @param {Array|Object} keys
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.doesNotHaveAllDeepKeys = function (obj, keys, msg) {
	    new Assertion(obj, msg, assert.doesNotHaveAllDeepKeys, true)
	      .to.not.have.all.deep.keys(keys);
	  }
	
	 /**
	   * ### .throws(fn, [errorLike/string/regexp], [string/regexp], [message])
	   *
	   * If `errorLike` is an `Error` constructor, asserts that `fn` will throw an error that is an
	   * instance of `errorLike`.
	   * If `errorLike` is an `Error` instance, asserts that the error thrown is the same
	   * instance as `errorLike`.
	   * If `errMsgMatcher` is provided, it also asserts that the error thrown will have a
	   * message matching `errMsgMatcher`.
	   *
	   *     assert.throws(fn, 'function throws a reference error');
	   *     assert.throws(fn, /function throws a reference error/);
	   *     assert.throws(fn, ReferenceError);
	   *     assert.throws(fn, errorInstance);
	   *     assert.throws(fn, ReferenceError, 'Error thrown must be a ReferenceError and have this msg');
	   *     assert.throws(fn, errorInstance, 'Error thrown must be the same errorInstance and have this msg');
	   *     assert.throws(fn, ReferenceError, /Error thrown must be a ReferenceError and match this/);
	   *     assert.throws(fn, errorInstance, /Error thrown must be the same errorInstance and match this/);
	   *
	   * @name throws
	   * @alias throw
	   * @alias Throw
	   * @param {Function} fn
	   * @param {ErrorConstructor|Error} errorLike
	   * @param {RegExp|String} errMsgMatcher
	   * @param {String} message
	   * @see https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Error#Error_types
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.throws = function (fn, errorLike, errMsgMatcher, msg) {
	    if ('string' === typeof errorLike || errorLike instanceof RegExp) {
	      errMsgMatcher = errorLike;
	      errorLike = null;
	    }
	
	    var assertErr = new Assertion(fn, msg, assert.throws, true)
	      .to.throw(errorLike, errMsgMatcher);
	    return flag(assertErr, 'object');
	  };
	
	  /**
	   * ### .doesNotThrow(fn, [errorLike/string/regexp], [string/regexp], [message])
	   *
	   * If `errorLike` is an `Error` constructor, asserts that `fn` will _not_ throw an error that is an
	   * instance of `errorLike`.
	   * If `errorLike` is an `Error` instance, asserts that the error thrown is _not_ the same
	   * instance as `errorLike`.
	   * If `errMsgMatcher` is provided, it also asserts that the error thrown will _not_ have a
	   * message matching `errMsgMatcher`.
	   *
	   *     assert.doesNotThrow(fn, 'Any Error thrown must not have this message');
	   *     assert.doesNotThrow(fn, /Any Error thrown must not match this/);
	   *     assert.doesNotThrow(fn, Error);
	   *     assert.doesNotThrow(fn, errorInstance);
	   *     assert.doesNotThrow(fn, Error, 'Error must not have this message');
	   *     assert.doesNotThrow(fn, errorInstance, 'Error must not have this message');
	   *     assert.doesNotThrow(fn, Error, /Error must not match this/);
	   *     assert.doesNotThrow(fn, errorInstance, /Error must not match this/);
	   *
	   * @name doesNotThrow
	   * @param {Function} fn
	   * @param {ErrorConstructor} errorLike
	   * @param {RegExp|String} errMsgMatcher
	   * @param {String} message
	   * @see https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Error#Error_types
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.doesNotThrow = function (fn, errorLike, errMsgMatcher, msg) {
	    if ('string' === typeof errorLike || errorLike instanceof RegExp) {
	      errMsgMatcher = errorLike;
	      errorLike = null;
	    }
	
	    new Assertion(fn, msg, assert.doesNotThrow, true)
	      .to.not.throw(errorLike, errMsgMatcher);
	  };
	
	  /**
	   * ### .operator(val1, operator, val2, [message])
	   *
	   * Compares two values using `operator`.
	   *
	   *     assert.operator(1, '<', 2, 'everything is ok');
	   *     assert.operator(1, '>', 2, 'this will fail');
	   *
	   * @name operator
	   * @param {Mixed} val1
	   * @param {String} operator
	   * @param {Mixed} val2
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.operator = function (val, operator, val2, msg) {
	    var ok;
	    switch(operator) {
	      case '==':
	        ok = val == val2;
	        break;
	      case '===':
	        ok = val === val2;
	        break;
	      case '>':
	        ok = val > val2;
	        break;
	      case '>=':
	        ok = val >= val2;
	        break;
	      case '<':
	        ok = val < val2;
	        break;
	      case '<=':
	        ok = val <= val2;
	        break;
	      case '!=':
	        ok = val != val2;
	        break;
	      case '!==':
	        ok = val !== val2;
	        break;
	      default:
	        msg = msg ? msg + ': ' : msg;
	        throw new chai.AssertionError(
	          msg + 'Invalid operator "' + operator + '"',
	          undefined,
	          assert.operator
	        );
	    }
	    var test = new Assertion(ok, msg, assert.operator, true);
	    test.assert(
	        true === flag(test, 'object')
	      , 'expected ' + util.inspect(val) + ' to be ' + operator + ' ' + util.inspect(val2)
	      , 'expected ' + util.inspect(val) + ' to not be ' + operator + ' ' + util.inspect(val2) );
	  };
	
	  /**
	   * ### .closeTo(actual, expected, delta, [message])
	   *
	   * Asserts that the target is equal `expected`, to within a +/- `delta` range.
	   *
	   *     assert.closeTo(1.5, 1, 0.5, 'numbers are close');
	   *
	   * @name closeTo
	   * @param {Number} actual
	   * @param {Number} expected
	   * @param {Number} delta
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.closeTo = function (act, exp, delta, msg) {
	    new Assertion(act, msg, assert.closeTo, true).to.be.closeTo(exp, delta);
	  };
	
	  /**
	   * ### .approximately(actual, expected, delta, [message])
	   *
	   * Asserts that the target is equal `expected`, to within a +/- `delta` range.
	   *
	   *     assert.approximately(1.5, 1, 0.5, 'numbers are close');
	   *
	   * @name approximately
	   * @param {Number} actual
	   * @param {Number} expected
	   * @param {Number} delta
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.approximately = function (act, exp, delta, msg) {
	    new Assertion(act, msg, assert.approximately, true)
	      .to.be.approximately(exp, delta);
	  };
	
	  /**
	   * ### .sameMembers(set1, set2, [message])
	   *
	   * Asserts that `set1` and `set2` have the same members in any order. Uses a
	   * strict equality check (===).
	   *
	   *     assert.sameMembers([ 1, 2, 3 ], [ 2, 1, 3 ], 'same members');
	   *
	   * @name sameMembers
	   * @param {Array} set1
	   * @param {Array} set2
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.sameMembers = function (set1, set2, msg) {
	    new Assertion(set1, msg, assert.sameMembers, true)
	      .to.have.same.members(set2);
	  }
	
	  /**
	   * ### .notSameMembers(set1, set2, [message])
	   *
	   * Asserts that `set1` and `set2` don't have the same members in any order.
	   * Uses a strict equality check (===).
	   *
	   *     assert.notSameMembers([ 1, 2, 3 ], [ 5, 1, 3 ], 'not same members');
	   *
	   * @name notSameMembers
	   * @param {Array} set1
	   * @param {Array} set2
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notSameMembers = function (set1, set2, msg) {
	    new Assertion(set1, msg, assert.notSameMembers, true)
	      .to.not.have.same.members(set2);
	  }
	
	  /**
	   * ### .sameDeepMembers(set1, set2, [message])
	   *
	   * Asserts that `set1` and `set2` have the same members in any order. Uses a
	   * deep equality check.
	   *
	   *     assert.sameDeepMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [{ b: 2 }, { a: 1 }, { c: 3 }], 'same deep members');
	   *
	   * @name sameDeepMembers
	   * @param {Array} set1
	   * @param {Array} set2
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.sameDeepMembers = function (set1, set2, msg) {
	    new Assertion(set1, msg, assert.sameDeepMembers, true)
	      .to.have.same.deep.members(set2);
	  }
	
	  /**
	   * ### .notSameDeepMembers(set1, set2, [message])
	   *
	   * Asserts that `set1` and `set2` don't have the same members in any order.
	   * Uses a deep equality check.
	   *
	   *     assert.notSameDeepMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [{ b: 2 }, { a: 1 }, { f: 5 }], 'not same deep members');
	   *
	   * @name notSameDeepMembers
	   * @param {Array} set1
	   * @param {Array} set2
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notSameDeepMembers = function (set1, set2, msg) {
	    new Assertion(set1, msg, assert.notSameDeepMembers, true)
	      .to.not.have.same.deep.members(set2);
	  }
	
	  /**
	   * ### .sameOrderedMembers(set1, set2, [message])
	   *
	   * Asserts that `set1` and `set2` have the same members in the same order.
	   * Uses a strict equality check (===).
	   *
	   *     assert.sameOrderedMembers([ 1, 2, 3 ], [ 1, 2, 3 ], 'same ordered members');
	   *
	   * @name sameOrderedMembers
	   * @param {Array} set1
	   * @param {Array} set2
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.sameOrderedMembers = function (set1, set2, msg) {
	    new Assertion(set1, msg, assert.sameOrderedMembers, true)
	      .to.have.same.ordered.members(set2);
	  }
	
	  /**
	   * ### .notSameOrderedMembers(set1, set2, [message])
	   *
	   * Asserts that `set1` and `set2` don't have the same members in the same
	   * order. Uses a strict equality check (===).
	   *
	   *     assert.notSameOrderedMembers([ 1, 2, 3 ], [ 2, 1, 3 ], 'not same ordered members');
	   *
	   * @name notSameOrderedMembers
	   * @param {Array} set1
	   * @param {Array} set2
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notSameOrderedMembers = function (set1, set2, msg) {
	    new Assertion(set1, msg, assert.notSameOrderedMembers, true)
	      .to.not.have.same.ordered.members(set2);
	  }
	
	  /**
	   * ### .sameDeepOrderedMembers(set1, set2, [message])
	   *
	   * Asserts that `set1` and `set2` have the same members in the same order.
	   * Uses a deep equality check.
	   *
	   * assert.sameDeepOrderedMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { a: 1 }, { b: 2 }, { c: 3 } ], 'same deep ordered members');
	   *
	   * @name sameDeepOrderedMembers
	   * @param {Array} set1
	   * @param {Array} set2
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.sameDeepOrderedMembers = function (set1, set2, msg) {
	    new Assertion(set1, msg, assert.sameDeepOrderedMembers, true)
	      .to.have.same.deep.ordered.members(set2);
	  }
	
	  /**
	   * ### .notSameDeepOrderedMembers(set1, set2, [message])
	   *
	   * Asserts that `set1` and `set2` don't have the same members in the same
	   * order. Uses a deep equality check.
	   *
	   * assert.notSameDeepOrderedMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { a: 1 }, { b: 2 }, { z: 5 } ], 'not same deep ordered members');
	   * assert.notSameDeepOrderedMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { b: 2 }, { a: 1 }, { c: 3 } ], 'not same deep ordered members');
	   *
	   * @name notSameDeepOrderedMembers
	   * @param {Array} set1
	   * @param {Array} set2
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notSameDeepOrderedMembers = function (set1, set2, msg) {
	    new Assertion(set1, msg, assert.notSameDeepOrderedMembers, true)
	      .to.not.have.same.deep.ordered.members(set2);
	  }
	
	  /**
	   * ### .includeMembers(superset, subset, [message])
	   *
	   * Asserts that `subset` is included in `superset` in any order. Uses a
	   * strict equality check (===). Duplicates are ignored.
	   *
	   *     assert.includeMembers([ 1, 2, 3 ], [ 2, 1, 2 ], 'include members');
	   *
	   * @name includeMembers
	   * @param {Array} superset
	   * @param {Array} subset
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.includeMembers = function (superset, subset, msg) {
	    new Assertion(superset, msg, assert.includeMembers, true)
	      .to.include.members(subset);
	  }
	
	  /**
	   * ### .notIncludeMembers(superset, subset, [message])
	   *
	   * Asserts that `subset` isn't included in `superset` in any order. Uses a
	   * strict equality check (===). Duplicates are ignored.
	   *
	   *     assert.notIncludeMembers([ 1, 2, 3 ], [ 5, 1 ], 'not include members');
	   *
	   * @name notIncludeMembers
	   * @param {Array} superset
	   * @param {Array} subset
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notIncludeMembers = function (superset, subset, msg) {
	    new Assertion(superset, msg, assert.notIncludeMembers, true)
	      .to.not.include.members(subset);
	  }
	
	  /**
	   * ### .includeDeepMembers(superset, subset, [message])
	   *
	   * Asserts that `subset` is included in `superset` in any order. Uses a deep
	   * equality check. Duplicates are ignored.
	   *
	   *     assert.includeDeepMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { b: 2 }, { a: 1 }, { b: 2 } ], 'include deep members');
	   *
	   * @name includeDeepMembers
	   * @param {Array} superset
	   * @param {Array} subset
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.includeDeepMembers = function (superset, subset, msg) {
	    new Assertion(superset, msg, assert.includeDeepMembers, true)
	      .to.include.deep.members(subset);
	  }
	
	  /**
	   * ### .notIncludeDeepMembers(superset, subset, [message])
	   *
	   * Asserts that `subset` isn't included in `superset` in any order. Uses a
	   * deep equality check. Duplicates are ignored.
	   *
	   *     assert.notIncludeDeepMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { b: 2 }, { f: 5 } ], 'not include deep members');
	   *
	   * @name notIncludeDeepMembers
	   * @param {Array} superset
	   * @param {Array} subset
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notIncludeDeepMembers = function (superset, subset, msg) {
	    new Assertion(superset, msg, assert.notIncludeDeepMembers, true)
	      .to.not.include.deep.members(subset);
	  }
	
	  /**
	   * ### .includeOrderedMembers(superset, subset, [message])
	   *
	   * Asserts that `subset` is included in `superset` in the same order
	   * beginning with the first element in `superset`. Uses a strict equality
	   * check (===).
	   *
	   *     assert.includeOrderedMembers([ 1, 2, 3 ], [ 1, 2 ], 'include ordered members');
	   *
	   * @name includeOrderedMembers
	   * @param {Array} superset
	   * @param {Array} subset
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.includeOrderedMembers = function (superset, subset, msg) {
	    new Assertion(superset, msg, assert.includeOrderedMembers, true)
	      .to.include.ordered.members(subset);
	  }
	
	  /**
	   * ### .notIncludeOrderedMembers(superset, subset, [message])
	   *
	   * Asserts that `subset` isn't included in `superset` in the same order
	   * beginning with the first element in `superset`. Uses a strict equality
	   * check (===).
	   *
	   *     assert.notIncludeOrderedMembers([ 1, 2, 3 ], [ 2, 1 ], 'not include ordered members');
	   *     assert.notIncludeOrderedMembers([ 1, 2, 3 ], [ 2, 3 ], 'not include ordered members');
	   *
	   * @name notIncludeOrderedMembers
	   * @param {Array} superset
	   * @param {Array} subset
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notIncludeOrderedMembers = function (superset, subset, msg) {
	    new Assertion(superset, msg, assert.notIncludeOrderedMembers, true)
	      .to.not.include.ordered.members(subset);
	  }
	
	  /**
	   * ### .includeDeepOrderedMembers(superset, subset, [message])
	   *
	   * Asserts that `subset` is included in `superset` in the same order
	   * beginning with the first element in `superset`. Uses a deep equality
	   * check.
	   *
	   *     assert.includeDeepOrderedMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { a: 1 }, { b: 2 } ], 'include deep ordered members');
	   *
	   * @name includeDeepOrderedMembers
	   * @param {Array} superset
	   * @param {Array} subset
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.includeDeepOrderedMembers = function (superset, subset, msg) {
	    new Assertion(superset, msg, assert.includeDeepOrderedMembers, true)
	      .to.include.deep.ordered.members(subset);
	  }
	
	  /**
	   * ### .notIncludeDeepOrderedMembers(superset, subset, [message])
	   *
	   * Asserts that `subset` isn't included in `superset` in the same order
	   * beginning with the first element in `superset`. Uses a deep equality
	   * check.
	   *
	   *     assert.notIncludeDeepOrderedMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { a: 1 }, { f: 5 } ], 'not include deep ordered members');
	   *     assert.notIncludeDeepOrderedMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { b: 2 }, { a: 1 } ], 'not include deep ordered members');
	   *     assert.notIncludeDeepOrderedMembers([ { a: 1 }, { b: 2 }, { c: 3 } ], [ { b: 2 }, { c: 3 } ], 'not include deep ordered members');
	   *
	   * @name notIncludeDeepOrderedMembers
	   * @param {Array} superset
	   * @param {Array} subset
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.notIncludeDeepOrderedMembers = function (superset, subset, msg) {
	    new Assertion(superset, msg, assert.notIncludeDeepOrderedMembers, true)
	      .to.not.include.deep.ordered.members(subset);
	  }
	
	  /**
	   * ### .oneOf(inList, list, [message])
	   *
	   * Asserts that non-object, non-array value `inList` appears in the flat array `list`.
	   *
	   *     assert.oneOf(1, [ 2, 1 ], 'Not found in list');
	   *
	   * @name oneOf
	   * @param {*} inList
	   * @param {Array<*>} list
	   * @param {String} message
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.oneOf = function (inList, list, msg) {
	    new Assertion(inList, msg, assert.oneOf, true).to.be.oneOf(list);
	  }
	
	  /**
	   * ### .changes(function, object, property, [message])
	   *
	   * Asserts that a function changes the value of a property.
	   *
	   *     var obj = { val: 10 };
	   *     var fn = function() { obj.val = 22 };
	   *     assert.changes(fn, obj, 'val');
	   *
	   * @name changes
	   * @param {Function} modifier function
	   * @param {Object} object or getter function
	   * @param {String} property name _optional_
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.changes = function (fn, obj, prop, msg) {
	    if (arguments.length === 3 && typeof obj === 'function') {
	      msg = prop;
	      prop = null;
	    }
	
	    new Assertion(fn, msg, assert.changes, true).to.change(obj, prop);
	  }
	
	   /**
	   * ### .changesBy(function, object, property, delta, [message])
	   *
	   * Asserts that a function changes the value of a property by an amount (delta).
	   *
	   *     var obj = { val: 10 };
	   *     var fn = function() { obj.val += 2 };
	   *     assert.changesBy(fn, obj, 'val', 2);
	   *
	   * @name changesBy
	   * @param {Function} modifier function
	   * @param {Object} object or getter function
	   * @param {String} property name _optional_
	   * @param {Number} change amount (delta)
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.changesBy = function (fn, obj, prop, delta, msg) {
	    if (arguments.length === 4 && typeof obj === 'function') {
	      var tmpMsg = delta;
	      delta = prop;
	      msg = tmpMsg;
	    } else if (arguments.length === 3) {
	      delta = prop;
	      prop = null;
	    }
	
	    new Assertion(fn, msg, assert.changesBy, true)
	      .to.change(obj, prop).by(delta);
	  }
	
	   /**
	   * ### .doesNotChange(function, object, property, [message])
	   *
	   * Asserts that a function does not change the value of a property.
	   *
	   *     var obj = { val: 10 };
	   *     var fn = function() { console.log('foo'); };
	   *     assert.doesNotChange(fn, obj, 'val');
	   *
	   * @name doesNotChange
	   * @param {Function} modifier function
	   * @param {Object} object or getter function
	   * @param {String} property name _optional_
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.doesNotChange = function (fn, obj, prop, msg) {
	    if (arguments.length === 3 && typeof obj === 'function') {
	      msg = prop;
	      prop = null;
	    }
	
	    return new Assertion(fn, msg, assert.doesNotChange, true)
	      .to.not.change(obj, prop);
	  }
	
	  /**
	   * ### .changesButNotBy(function, object, property, delta, [message])
	   *
	   * Asserts that a function does not change the value of a property or of a function's return value by an amount (delta)
	   *
	   *     var obj = { val: 10 };
	   *     var fn = function() { obj.val += 10 };
	   *     assert.changesButNotBy(fn, obj, 'val', 5);
	   *
	   * @name changesButNotBy
	   * @param {Function} modifier function
	   * @param {Object} object or getter function
	   * @param {String} property name _optional_
	   * @param {Number} change amount (delta)
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.changesButNotBy = function (fn, obj, prop, delta, msg) {
	    if (arguments.length === 4 && typeof obj === 'function') {
	      var tmpMsg = delta;
	      delta = prop;
	      msg = tmpMsg;
	    } else if (arguments.length === 3) {
	      delta = prop;
	      prop = null;
	    }
	
	    new Assertion(fn, msg, assert.changesButNotBy, true)
	      .to.change(obj, prop).but.not.by(delta);
	  }
	
	  /**
	   * ### .increases(function, object, property, [message])
	   *
	   * Asserts that a function increases a numeric object property.
	   *
	   *     var obj = { val: 10 };
	   *     var fn = function() { obj.val = 13 };
	   *     assert.increases(fn, obj, 'val');
	   *
	   * @name increases
	   * @param {Function} modifier function
	   * @param {Object} object or getter function
	   * @param {String} property name _optional_
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.increases = function (fn, obj, prop, msg) {
	    if (arguments.length === 3 && typeof obj === 'function') {
	      msg = prop;
	      prop = null;
	    }
	
	    return new Assertion(fn, msg, assert.increases, true)
	      .to.increase(obj, prop);
	  }
	
	  /**
	   * ### .increasesBy(function, object, property, delta, [message])
	   *
	   * Asserts that a function increases a numeric object property or a function's return value by an amount (delta).
	   *
	   *     var obj = { val: 10 };
	   *     var fn = function() { obj.val += 10 };
	   *     assert.increasesBy(fn, obj, 'val', 10);
	   *
	   * @name increasesBy
	   * @param {Function} modifier function
	   * @param {Object} object or getter function
	   * @param {String} property name _optional_
	   * @param {Number} change amount (delta)
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.increasesBy = function (fn, obj, prop, delta, msg) {
	    if (arguments.length === 4 && typeof obj === 'function') {
	      var tmpMsg = delta;
	      delta = prop;
	      msg = tmpMsg;
	    } else if (arguments.length === 3) {
	      delta = prop;
	      prop = null;
	    }
	
	    new Assertion(fn, msg, assert.increasesBy, true)
	      .to.increase(obj, prop).by(delta);
	  }
	
	  /**
	   * ### .doesNotIncrease(function, object, property, [message])
	   *
	   * Asserts that a function does not increase a numeric object property.
	   *
	   *     var obj = { val: 10 };
	   *     var fn = function() { obj.val = 8 };
	   *     assert.doesNotIncrease(fn, obj, 'val');
	   *
	   * @name doesNotIncrease
	   * @param {Function} modifier function
	   * @param {Object} object or getter function
	   * @param {String} property name _optional_
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.doesNotIncrease = function (fn, obj, prop, msg) {
	    if (arguments.length === 3 && typeof obj === 'function') {
	      msg = prop;
	      prop = null;
	    }
	
	    return new Assertion(fn, msg, assert.doesNotIncrease, true)
	      .to.not.increase(obj, prop);
	  }
	
	  /**
	   * ### .increasesButNotBy(function, object, property, [message])
	   *
	   * Asserts that a function does not increase a numeric object property or function's return value by an amount (delta).
	   *
	   *     var obj = { val: 10 };
	   *     var fn = function() { obj.val = 15 };
	   *     assert.increasesButNotBy(fn, obj, 'val', 10);
	   *
	   * @name increasesButNotBy
	   * @param {Function} modifier function
	   * @param {Object} object or getter function
	   * @param {String} property name _optional_
	   * @param {Number} change amount (delta)
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.increasesButNotBy = function (fn, obj, prop, delta, msg) {
	    if (arguments.length === 4 && typeof obj === 'function') {
	      var tmpMsg = delta;
	      delta = prop;
	      msg = tmpMsg;
	    } else if (arguments.length === 3) {
	      delta = prop;
	      prop = null;
	    }
	
	    new Assertion(fn, msg, assert.increasesButNotBy, true)
	      .to.increase(obj, prop).but.not.by(delta);
	  }
	
	  /**
	   * ### .decreases(function, object, property, [message])
	   *
	   * Asserts that a function decreases a numeric object property.
	   *
	   *     var obj = { val: 10 };
	   *     var fn = function() { obj.val = 5 };
	   *     assert.decreases(fn, obj, 'val');
	   *
	   * @name decreases
	   * @param {Function} modifier function
	   * @param {Object} object or getter function
	   * @param {String} property name _optional_
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.decreases = function (fn, obj, prop, msg) {
	    if (arguments.length === 3 && typeof obj === 'function') {
	      msg = prop;
	      prop = null;
	    }
	
	    return new Assertion(fn, msg, assert.decreases, true)
	      .to.decrease(obj, prop);
	  }
	
	  /**
	   * ### .decreasesBy(function, object, property, delta, [message])
	   *
	   * Asserts that a function decreases a numeric object property or a function's return value by an amount (delta)
	   *
	   *     var obj = { val: 10 };
	   *     var fn = function() { obj.val -= 5 };
	   *     assert.decreasesBy(fn, obj, 'val', 5);
	   *
	   * @name decreasesBy
	   * @param {Function} modifier function
	   * @param {Object} object or getter function
	   * @param {String} property name _optional_
	   * @param {Number} change amount (delta)
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.decreasesBy = function (fn, obj, prop, delta, msg) {
	    if (arguments.length === 4 && typeof obj === 'function') {
	      var tmpMsg = delta;
	      delta = prop;
	      msg = tmpMsg;
	    } else if (arguments.length === 3) {
	      delta = prop;
	      prop = null;
	    }
	
	    new Assertion(fn, msg, assert.decreasesBy, true)
	      .to.decrease(obj, prop).by(delta);
	  }
	
	  /**
	   * ### .doesNotDecrease(function, object, property, [message])
	   *
	   * Asserts that a function does not decreases a numeric object property.
	   *
	   *     var obj = { val: 10 };
	   *     var fn = function() { obj.val = 15 };
	   *     assert.doesNotDecrease(fn, obj, 'val');
	   *
	   * @name doesNotDecrease
	   * @param {Function} modifier function
	   * @param {Object} object or getter function
	   * @param {String} property name _optional_
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.doesNotDecrease = function (fn, obj, prop, msg) {
	    if (arguments.length === 3 && typeof obj === 'function') {
	      msg = prop;
	      prop = null;
	    }
	
	    return new Assertion(fn, msg, assert.doesNotDecrease, true)
	      .to.not.decrease(obj, prop);
	  }
	
	  /**
	   * ### .doesNotDecreaseBy(function, object, property, delta, [message])
	   *
	   * Asserts that a function does not decreases a numeric object property or a function's return value by an amount (delta)
	   *
	   *     var obj = { val: 10 };
	   *     var fn = function() { obj.val = 5 };
	   *     assert.doesNotDecreaseBy(fn, obj, 'val', 1);
	   *
	   * @name doesNotDecrease
	   * @param {Function} modifier function
	   * @param {Object} object or getter function
	   * @param {String} property name _optional_
	   * @param {Number} change amount (delta)
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.doesNotDecreaseBy = function (fn, obj, prop, delta, msg) {
	    if (arguments.length === 4 && typeof obj === 'function') {
	      var tmpMsg = delta;
	      delta = prop;
	      msg = tmpMsg;
	    } else if (arguments.length === 3) {
	      delta = prop;
	      prop = null;
	    }
	
	    return new Assertion(fn, msg, assert.doesNotDecreaseBy, true)
	      .to.not.decrease(obj, prop).by(delta);
	  }
	
	  /**
	   * ### .decreasesButNotBy(function, object, property, delta, [message])
	   *
	   * Asserts that a function does not decreases a numeric object property or a function's return value by an amount (delta)
	   *
	   *     var obj = { val: 10 };
	   *     var fn = function() { obj.val = 5 };
	   *     assert.decreasesButNotBy(fn, obj, 'val', 1);
	   *
	   * @name decreasesButNotBy
	   * @param {Function} modifier function
	   * @param {Object} object or getter function
	   * @param {String} property name _optional_
	   * @param {Number} change amount (delta)
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.decreasesButNotBy = function (fn, obj, prop, delta, msg) {
	    if (arguments.length === 4 && typeof obj === 'function') {
	      var tmpMsg = delta;
	      delta = prop;
	      msg = tmpMsg;
	    } else if (arguments.length === 3) {
	      delta = prop;
	      prop = null;
	    }
	
	    new Assertion(fn, msg, assert.decreasesButNotBy, true)
	      .to.decrease(obj, prop).but.not.by(delta);
	  }
	
	  /*!
	   * ### .ifError(object)
	   *
	   * Asserts if value is not a false value, and throws if it is a true value.
	   * This is added to allow for chai to be a drop-in replacement for Node's
	   * assert class.
	   *
	   *     var err = new Error('I am a custom error');
	   *     assert.ifError(err); // Rethrows err!
	   *
	   * @name ifError
	   * @param {Object} object
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.ifError = function (val) {
	    if (val) {
	      throw(val);
	    }
	  };
	
	  /**
	   * ### .isExtensible(object)
	   *
	   * Asserts that `object` is extensible (can have new properties added to it).
	   *
	   *     assert.isExtensible({});
	   *
	   * @name isExtensible
	   * @alias extensible
	   * @param {Object} object
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isExtensible = function (obj, msg) {
	    new Assertion(obj, msg, assert.isExtensible, true).to.be.extensible;
	  };
	
	  /**
	   * ### .isNotExtensible(object)
	   *
	   * Asserts that `object` is _not_ extensible.
	   *
	   *     var nonExtensibleObject = Object.preventExtensions({});
	   *     var sealedObject = Object.seal({});
	   *     var frozenObject = Object.freeze({});
	   *
	   *     assert.isNotExtensible(nonExtensibleObject);
	   *     assert.isNotExtensible(sealedObject);
	   *     assert.isNotExtensible(frozenObject);
	   *
	   * @name isNotExtensible
	   * @alias notExtensible
	   * @param {Object} object
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isNotExtensible = function (obj, msg) {
	    new Assertion(obj, msg, assert.isNotExtensible, true).to.not.be.extensible;
	  };
	
	  /**
	   * ### .isSealed(object)
	   *
	   * Asserts that `object` is sealed (cannot have new properties added to it
	   * and its existing properties cannot be removed).
	   *
	   *     var sealedObject = Object.seal({});
	   *     var frozenObject = Object.seal({});
	   *
	   *     assert.isSealed(sealedObject);
	   *     assert.isSealed(frozenObject);
	   *
	   * @name isSealed
	   * @alias sealed
	   * @param {Object} object
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isSealed = function (obj, msg) {
	    new Assertion(obj, msg, assert.isSealed, true).to.be.sealed;
	  };
	
	  /**
	   * ### .isNotSealed(object)
	   *
	   * Asserts that `object` is _not_ sealed.
	   *
	   *     assert.isNotSealed({});
	   *
	   * @name isNotSealed
	   * @alias notSealed
	   * @param {Object} object
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isNotSealed = function (obj, msg) {
	    new Assertion(obj, msg, assert.isNotSealed, true).to.not.be.sealed;
	  };
	
	  /**
	   * ### .isFrozen(object)
	   *
	   * Asserts that `object` is frozen (cannot have new properties added to it
	   * and its existing properties cannot be modified).
	   *
	   *     var frozenObject = Object.freeze({});
	   *     assert.frozen(frozenObject);
	   *
	   * @name isFrozen
	   * @alias frozen
	   * @param {Object} object
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isFrozen = function (obj, msg) {
	    new Assertion(obj, msg, assert.isFrozen, true).to.be.frozen;
	  };
	
	  /**
	   * ### .isNotFrozen(object)
	   *
	   * Asserts that `object` is _not_ frozen.
	   *
	   *     assert.isNotFrozen({});
	   *
	   * @name isNotFrozen
	   * @alias notFrozen
	   * @param {Object} object
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isNotFrozen = function (obj, msg) {
	    new Assertion(obj, msg, assert.isNotFrozen, true).to.not.be.frozen;
	  };
	
	  /**
	   * ### .isEmpty(target)
	   *
	   * Asserts that the target does not contain any values.
	   * For arrays and strings, it checks the `length` property.
	   * For `Map` and `Set` instances, it checks the `size` property.
	   * For non-function objects, it gets the count of own
	   * enumerable string keys.
	   *
	   *     assert.isEmpty([]);
	   *     assert.isEmpty('');
	   *     assert.isEmpty(new Map);
	   *     assert.isEmpty({});
	   *
	   * @name isEmpty
	   * @alias empty
	   * @param {Object|Array|String|Map|Set} target
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isEmpty = function(val, msg) {
	    new Assertion(val, msg, assert.isEmpty, true).to.be.empty;
	  };
	
	  /**
	   * ### .isNotEmpty(target)
	   *
	   * Asserts that the target contains values.
	   * For arrays and strings, it checks the `length` property.
	   * For `Map` and `Set` instances, it checks the `size` property.
	   * For non-function objects, it gets the count of own
	   * enumerable string keys.
	   *
	   *     assert.isNotEmpty([1, 2]);
	   *     assert.isNotEmpty('34');
	   *     assert.isNotEmpty(new Set([5, 6]));
	   *     assert.isNotEmpty({ key: 7 });
	   *
	   * @name isNotEmpty
	   * @alias notEmpty
	   * @param {Object|Array|String|Map|Set} target
	   * @param {String} message _optional_
	   * @namespace Assert
	   * @api public
	   */
	
	  assert.isNotEmpty = function(val, msg) {
	    new Assertion(val, msg, assert.isNotEmpty, true).to.not.be.empty;
	  };
	
	  /*!
	   * Aliases.
	   */
	
	  (function alias(name, as){
	    assert[as] = assert[name];
	    return alias;
	  })
	  ('isOk', 'ok')
	  ('isNotOk', 'notOk')
	  ('throws', 'throw')
	  ('throws', 'Throw')
	  ('isExtensible', 'extensible')
	  ('isNotExtensible', 'notExtensible')
	  ('isSealed', 'sealed')
	  ('isNotSealed', 'notSealed')
	  ('isFrozen', 'frozen')
	  ('isNotFrozen', 'notFrozen')
	  ('isEmpty', 'empty')
	  ('isNotEmpty', 'notEmpty');
	};


/***/ }),
/* 1008 */
/***/ (function(module, exports) {

	/*!
	 * chai
	 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	module.exports = function (chai, util) {
	  chai.expect = function (val, message) {
	    return new chai.Assertion(val, message);
	  };
	
	  /**
	   * ### .fail(actual, expected, [message], [operator])
	   *
	   * Throw a failure.
	   *
	   * @name fail
	   * @param {Mixed} actual
	   * @param {Mixed} expected
	   * @param {String} message
	   * @param {String} operator
	   * @namespace BDD
	   * @api public
	   */
	
	  chai.expect.fail = function (actual, expected, message, operator) {
	    message = message || 'expect.fail()';
	    throw new chai.AssertionError(message, {
	        actual: actual
	      , expected: expected
	      , operator: operator
	    }, chai.expect.fail);
	  };
	};


/***/ }),
/* 1009 */
/***/ (function(module, exports) {

	/*!
	 * chai
	 * Copyright(c) 2011-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	module.exports = function (chai, util) {
	  var Assertion = chai.Assertion;
	
	  function loadShould () {
	    // explicitly define this method as function as to have it's name to include as `ssfi`
	    function shouldGetter() {
	      if (this instanceof String
	          || this instanceof Number
	          || this instanceof Boolean
	          || typeof Symbol === 'function' && this instanceof Symbol) {
	        return new Assertion(this.valueOf(), null, shouldGetter);
	      }
	      return new Assertion(this, null, shouldGetter);
	    }
	    function shouldSetter(value) {
	      // See https://github.com/chaijs/chai/issues/86: this makes
	      // `whatever.should = someValue` actually set `someValue`, which is
	      // especially useful for `global.should = require('chai').should()`.
	      //
	      // Note that we have to use [[DefineProperty]] instead of [[Put]]
	      // since otherwise we would trigger this very setter!
	      Object.defineProperty(this, 'should', {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    }
	    // modify Object.prototype to have `should`
	    Object.defineProperty(Object.prototype, 'should', {
	      set: shouldSetter
	      , get: shouldGetter
	      , configurable: true
	    });
	
	    var should = {};
	
	    /**
	     * ### .fail(actual, expected, [message], [operator])
	     *
	     * Throw a failure.
	     *
	     * @name fail
	     * @param {Mixed} actual
	     * @param {Mixed} expected
	     * @param {String} message
	     * @param {String} operator
	     * @namespace BDD
	     * @api public
	     */
	
	    should.fail = function (actual, expected, message, operator) {
	      message = message || 'should.fail()';
	      throw new chai.AssertionError(message, {
	          actual: actual
	        , expected: expected
	        , operator: operator
	      }, should.fail);
	    };
	
	    /**
	     * ### .equal(actual, expected, [message])
	     *
	     * Asserts non-strict equality (`==`) of `actual` and `expected`.
	     *
	     *     should.equal(3, '3', '== coerces values to strings');
	     *
	     * @name equal
	     * @param {Mixed} actual
	     * @param {Mixed} expected
	     * @param {String} message
	     * @namespace Should
	     * @api public
	     */
	
	    should.equal = function (val1, val2, msg) {
	      new Assertion(val1, msg).to.equal(val2);
	    };
	
	    /**
	     * ### .throw(function, [constructor/string/regexp], [string/regexp], [message])
	     *
	     * Asserts that `function` will throw an error that is an instance of
	     * `constructor`, or alternately that it will throw an error with message
	     * matching `regexp`.
	     *
	     *     should.throw(fn, 'function throws a reference error');
	     *     should.throw(fn, /function throws a reference error/);
	     *     should.throw(fn, ReferenceError);
	     *     should.throw(fn, ReferenceError, 'function throws a reference error');
	     *     should.throw(fn, ReferenceError, /function throws a reference error/);
	     *
	     * @name throw
	     * @alias Throw
	     * @param {Function} function
	     * @param {ErrorConstructor} constructor
	     * @param {RegExp} regexp
	     * @param {String} message
	     * @see https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Error#Error_types
	     * @namespace Should
	     * @api public
	     */
	
	    should.Throw = function (fn, errt, errs, msg) {
	      new Assertion(fn, msg).to.Throw(errt, errs);
	    };
	
	    /**
	     * ### .exist
	     *
	     * Asserts that the target is neither `null` nor `undefined`.
	     *
	     *     var foo = 'hi';
	     *
	     *     should.exist(foo, 'foo exists');
	     *
	     * @name exist
	     * @namespace Should
	     * @api public
	     */
	
	    should.exist = function (val, msg) {
	      new Assertion(val, msg).to.exist;
	    }
	
	    // negation
	    should.not = {}
	
	    /**
	     * ### .not.equal(actual, expected, [message])
	     *
	     * Asserts non-strict inequality (`!=`) of `actual` and `expected`.
	     *
	     *     should.not.equal(3, 4, 'these numbers are not equal');
	     *
	     * @name not.equal
	     * @param {Mixed} actual
	     * @param {Mixed} expected
	     * @param {String} message
	     * @namespace Should
	     * @api public
	     */
	
	    should.not.equal = function (val1, val2, msg) {
	      new Assertion(val1, msg).to.not.equal(val2);
	    };
	
	    /**
	     * ### .throw(function, [constructor/regexp], [message])
	     *
	     * Asserts that `function` will _not_ throw an error that is an instance of
	     * `constructor`, or alternately that it will not throw an error with message
	     * matching `regexp`.
	     *
	     *     should.not.throw(fn, Error, 'function does not throw');
	     *
	     * @name not.throw
	     * @alias not.Throw
	     * @param {Function} function
	     * @param {ErrorConstructor} constructor
	     * @param {RegExp} regexp
	     * @param {String} message
	     * @see https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Error#Error_types
	     * @namespace Should
	     * @api public
	     */
	
	    should.not.Throw = function (fn, errt, errs, msg) {
	      new Assertion(fn, msg).to.not.Throw(errt, errs);
	    };
	
	    /**
	     * ### .not.exist
	     *
	     * Asserts that the target is neither `null` nor `undefined`.
	     *
	     *     var bar = null;
	     *
	     *     should.not.exist(bar, 'bar does not exist');
	     *
	     * @name not.exist
	     * @namespace Should
	     * @api public
	     */
	
	    should.not.exist = function (val, msg) {
	      new Assertion(val, msg).to.not.exist;
	    }
	
	    should['throw'] = should['Throw'];
	    should.not['throw'] = should.not['Throw'];
	
	    return should;
	  };
	
	  chai.should = loadShould;
	  chai.Should = loadShould;
	};


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Chai - addChainingMethod utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/*!
	 * Module dependencies
	 */
	
	var addLengthGuard = __webpack_require__(286);
	var chai = __webpack_require__(126);
	var flag = __webpack_require__(69);
	var proxify = __webpack_require__(289);
	var transferFlags = __webpack_require__(128);
	
	/*!
	 * Module variables
	 */
	
	// Check whether `Object.setPrototypeOf` is supported
	var canSetPrototype = typeof Object.setPrototypeOf === 'function';
	
	// Without `Object.setPrototypeOf` support, this module will need to add properties to a function.
	// However, some of functions' own props are not configurable and should be skipped.
	var testFn = function() {};
	var excludeNames = Object.getOwnPropertyNames(testFn).filter(function(name) {
	  var propDesc = Object.getOwnPropertyDescriptor(testFn, name);
	
	  // Note: PhantomJS 1.x includes `callee` as one of `testFn`'s own properties,
	  // but then returns `undefined` as the property descriptor for `callee`. As a
	  // workaround, we perform an otherwise unnecessary type-check for `propDesc`,
	  // and then filter it out if it's not an object as it should be.
	  if (typeof propDesc !== 'object')
	    return true;
	
	  return !propDesc.configurable;
	});
	
	// Cache `Function` properties
	var call  = Function.prototype.call,
	    apply = Function.prototype.apply;
	
	/**
	 * ### .addChainableMethod(ctx, name, method, chainingBehavior)
	 *
	 * Adds a method to an object, such that the method can also be chained.
	 *
	 *     utils.addChainableMethod(chai.Assertion.prototype, 'foo', function (str) {
	 *       var obj = utils.flag(this, 'object');
	 *       new chai.Assertion(obj).to.be.equal(str);
	 *     });
	 *
	 * Can also be accessed directly from `chai.Assertion`.
	 *
	 *     chai.Assertion.addChainableMethod('foo', fn, chainingBehavior);
	 *
	 * The result can then be used as both a method assertion, executing both `method` and
	 * `chainingBehavior`, or as a language chain, which only executes `chainingBehavior`.
	 *
	 *     expect(fooStr).to.be.foo('bar');
	 *     expect(fooStr).to.be.foo.equal('foo');
	 *
	 * @param {Object} ctx object to which the method is added
	 * @param {String} name of method to add
	 * @param {Function} method function to be used for `name`, when called
	 * @param {Function} chainingBehavior function to be called every time the property is accessed
	 * @namespace Utils
	 * @name addChainableMethod
	 * @api public
	 */
	
	module.exports = function addChainableMethod(ctx, name, method, chainingBehavior) {
	  if (typeof chainingBehavior !== 'function') {
	    chainingBehavior = function () { };
	  }
	
	  var chainableBehavior = {
	      method: method
	    , chainingBehavior: chainingBehavior
	  };
	
	  // save the methods so we can overwrite them later, if we need to.
	  if (!ctx.__methods) {
	    ctx.__methods = {};
	  }
	  ctx.__methods[name] = chainableBehavior;
	
	  Object.defineProperty(ctx, name,
	    { get: function chainableMethodGetter() {
	        chainableBehavior.chainingBehavior.call(this);
	
	        var chainableMethodWrapper = function () {
	          // Setting the `ssfi` flag to `chainableMethodWrapper` causes this
	          // function to be the starting point for removing implementation
	          // frames from the stack trace of a failed assertion.
	          //
	          // However, we only want to use this function as the starting point if
	          // the `lockSsfi` flag isn't set.
	          //
	          // If the `lockSsfi` flag is set, then this assertion is being
	          // invoked from inside of another assertion. In this case, the `ssfi`
	          // flag has already been set by the outer assertion.
	          //
	          // Note that overwriting a chainable method merely replaces the saved
	          // methods in `ctx.__methods` instead of completely replacing the
	          // overwritten assertion. Therefore, an overwriting assertion won't
	          // set the `ssfi` or `lockSsfi` flags.
	          if (!flag(this, 'lockSsfi')) {
	            flag(this, 'ssfi', chainableMethodWrapper);
	          }
	
	          var result = chainableBehavior.method.apply(this, arguments);
	          if (result !== undefined) {
	            return result;
	          }
	
	          var newAssertion = new chai.Assertion();
	          transferFlags(this, newAssertion);
	          return newAssertion;
	        };
	
	        addLengthGuard(chainableMethodWrapper, name, true);
	
	        // Use `Object.setPrototypeOf` if available
	        if (canSetPrototype) {
	          // Inherit all properties from the object by replacing the `Function` prototype
	          var prototype = Object.create(this);
	          // Restore the `call` and `apply` methods from `Function`
	          prototype.call = call;
	          prototype.apply = apply;
	          Object.setPrototypeOf(chainableMethodWrapper, prototype);
	        }
	        // Otherwise, redefine all properties (slow!)
	        else {
	          var asserterNames = Object.getOwnPropertyNames(ctx);
	          asserterNames.forEach(function (asserterName) {
	            if (excludeNames.indexOf(asserterName) !== -1) {
	              return;
	            }
	
	            var pd = Object.getOwnPropertyDescriptor(ctx, asserterName);
	            Object.defineProperty(chainableMethodWrapper, asserterName, pd);
	          });
	        }
	
	        transferFlags(this, chainableMethodWrapper);
	        return proxify(chainableMethodWrapper);
	      }
	    , configurable: true
	  });
	};


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Chai - addMethod utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	var addLengthGuard = __webpack_require__(286);
	var chai = __webpack_require__(126);
	var flag = __webpack_require__(69);
	var proxify = __webpack_require__(289);
	var transferFlags = __webpack_require__(128);
	
	/**
	 * ### .addMethod(ctx, name, method)
	 *
	 * Adds a method to the prototype of an object.
	 *
	 *     utils.addMethod(chai.Assertion.prototype, 'foo', function (str) {
	 *       var obj = utils.flag(this, 'object');
	 *       new chai.Assertion(obj).to.be.equal(str);
	 *     });
	 *
	 * Can also be accessed directly from `chai.Assertion`.
	 *
	 *     chai.Assertion.addMethod('foo', fn);
	 *
	 * Then can be used as any other assertion.
	 *
	 *     expect(fooStr).to.be.foo('bar');
	 *
	 * @param {Object} ctx object to which the method is added
	 * @param {String} name of method to add
	 * @param {Function} method function to be used for name
	 * @namespace Utils
	 * @name addMethod
	 * @api public
	 */
	
	module.exports = function addMethod(ctx, name, method) {
	  var methodWrapper = function () {
	    // Setting the `ssfi` flag to `methodWrapper` causes this function to be the
	    // starting point for removing implementation frames from the stack trace of
	    // a failed assertion.
	    //
	    // However, we only want to use this function as the starting point if the
	    // `lockSsfi` flag isn't set.
	    //
	    // If the `lockSsfi` flag is set, then either this assertion has been
	    // overwritten by another assertion, or this assertion is being invoked from
	    // inside of another assertion. In the first case, the `ssfi` flag has
	    // already been set by the overwriting assertion. In the second case, the
	    // `ssfi` flag has already been set by the outer assertion.
	    if (!flag(this, 'lockSsfi')) {
	      flag(this, 'ssfi', methodWrapper);
	    }
	
	    var result = method.apply(this, arguments);
	    if (result !== undefined)
	      return result;
	
	    var newAssertion = new chai.Assertion();
	    transferFlags(this, newAssertion);
	    return newAssertion;
	  };
	
	  addLengthGuard(methodWrapper, name, false);
	  ctx[name] = proxify(methodWrapper, name);
	};


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Chai - addProperty utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	var chai = __webpack_require__(126);
	var flag = __webpack_require__(69);
	var isProxyEnabled = __webpack_require__(288);
	var transferFlags = __webpack_require__(128);
	
	/**
	 * ### .addProperty(ctx, name, getter)
	 *
	 * Adds a property to the prototype of an object.
	 *
	 *     utils.addProperty(chai.Assertion.prototype, 'foo', function () {
	 *       var obj = utils.flag(this, 'object');
	 *       new chai.Assertion(obj).to.be.instanceof(Foo);
	 *     });
	 *
	 * Can also be accessed directly from `chai.Assertion`.
	 *
	 *     chai.Assertion.addProperty('foo', fn);
	 *
	 * Then can be used as any other assertion.
	 *
	 *     expect(myFoo).to.be.foo;
	 *
	 * @param {Object} ctx object to which the property is added
	 * @param {String} name of property to add
	 * @param {Function} getter function to be used for name
	 * @namespace Utils
	 * @name addProperty
	 * @api public
	 */
	
	module.exports = function addProperty(ctx, name, getter) {
	  getter = getter === undefined ? function () {} : getter;
	
	  Object.defineProperty(ctx, name,
	    { get: function propertyGetter() {
	        // Setting the `ssfi` flag to `propertyGetter` causes this function to
	        // be the starting point for removing implementation frames from the
	        // stack trace of a failed assertion.
	        //
	        // However, we only want to use this function as the starting point if
	        // the `lockSsfi` flag isn't set and proxy protection is disabled.
	        //
	        // If the `lockSsfi` flag is set, then either this assertion has been
	        // overwritten by another assertion, or this assertion is being invoked
	        // from inside of another assertion. In the first case, the `ssfi` flag
	        // has already been set by the overwriting assertion. In the second
	        // case, the `ssfi` flag has already been set by the outer assertion.
	        //
	        // If proxy protection is enabled, then the `ssfi` flag has already been
	        // set by the proxy getter.
	        if (!isProxyEnabled() && !flag(this, 'lockSsfi')) {
	          flag(this, 'ssfi', propertyGetter);
	        }
	
	        var result = getter.call(this);
	        if (result !== undefined)
	          return result;
	
	        var newAssertion = new chai.Assertion();
	        transferFlags(this, newAssertion);
	        return newAssertion;
	      }
	    , configurable: true
	  });
	};


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Chai - compareByInspect utility
	 * Copyright(c) 2011-2016 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/*!
	 * Module dependancies
	 */
	
	var inspect = __webpack_require__(287);
	
	/**
	 * ### .compareByInspect(mixed, mixed)
	 *
	 * To be used as a compareFunction with Array.prototype.sort. Compares elements
	 * using inspect instead of default behavior of using toString so that Symbols
	 * and objects with irregular/missing toString can still be sorted without a
	 * TypeError.
	 *
	 * @param {Mixed} first element to compare
	 * @param {Mixed} second element to compare
	 * @returns {Number} -1 if 'a' should come before 'b'; otherwise 1 
	 * @name compareByInspect
	 * @namespace Utils
	 * @api public
	 */
	
	module.exports = function compareByInspect(a, b) {
	  return inspect(a) < inspect(b) ? -1 : 1;
	};


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Chai - expectTypes utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/**
	 * ### .expectTypes(obj, types)
	 *
	 * Ensures that the object being tested against is of a valid type.
	 *
	 *     utils.expectTypes(this, ['array', 'object', 'string']);
	 *
	 * @param {Mixed} obj constructed Assertion
	 * @param {Array} type A list of allowed types for this assertion
	 * @namespace Utils
	 * @name expectTypes
	 * @api public
	 */
	
	var AssertionError = __webpack_require__(534);
	var flag = __webpack_require__(69);
	var type = __webpack_require__(528);
	
	module.exports = function expectTypes(obj, types) {
	  var flagMsg = flag(obj, 'message');
	  var ssfi = flag(obj, 'ssfi');
	
	  flagMsg = flagMsg ? flagMsg + ': ' : '';
	
	  obj = flag(obj, 'object');
	  types = types.map(function (t) { return t.toLowerCase(); });
	  types.sort();
	
	  // Transforms ['lorem', 'ipsum'] into 'a lorem, or an ipsum'
	  var str = types.map(function (t, index) {
	    var art = ~[ 'a', 'e', 'i', 'o', 'u' ].indexOf(t.charAt(0)) ? 'an' : 'a';
	    var or = types.length > 1 && index === types.length - 1 ? 'or ' : '';
	    return or + art + ' ' + t;
	  }).join(', ');
	
	  var objType = type(obj).toLowerCase();
	
	  if (!types.some(function (expected) { return objType === expected; })) {
	    throw new AssertionError(
	      flagMsg + 'object tested must be ' + str + ', but ' + objType + ' given',
	      undefined,
	      ssfi
	    );
	  }
	};


/***/ }),
/* 1015 */
/***/ (function(module, exports) {

	/*!
	 * Chai - getEnumerableProperties utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/**
	 * ### .getEnumerableProperties(object)
	 *
	 * This allows the retrieval of enumerable property names of an object,
	 * inherited or not.
	 *
	 * @param {Object} object
	 * @returns {Array}
	 * @namespace Utils
	 * @name getEnumerableProperties
	 * @api public
	 */
	
	module.exports = function getEnumerableProperties(object) {
	  var result = [];
	  for (var name in object) {
	    result.push(name);
	  }
	  return result;
	};


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Chai - message composition utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/*!
	 * Module dependancies
	 */
	
	var flag = __webpack_require__(69)
	  , getActual = __webpack_require__(555)
	  , inspect = __webpack_require__(287)
	  , objDisplay = __webpack_require__(558);
	
	/**
	 * ### .getMessage(object, message, negateMessage)
	 *
	 * Construct the error message based on flags
	 * and template tags. Template tags will return
	 * a stringified inspection of the object referenced.
	 *
	 * Message template tags:
	 * - `#{this}` current asserted object
	 * - `#{act}` actual value
	 * - `#{exp}` expected value
	 *
	 * @param {Object} object (constructed Assertion)
	 * @param {Arguments} chai.Assertion.prototype.assert arguments
	 * @namespace Utils
	 * @name getMessage
	 * @api public
	 */
	
	module.exports = function getMessage(obj, args) {
	  var negate = flag(obj, 'negate')
	    , val = flag(obj, 'object')
	    , expected = args[3]
	    , actual = getActual(obj, args)
	    , msg = negate ? args[2] : args[1]
	    , flagMsg = flag(obj, 'message');
	
	  if(typeof msg === "function") msg = msg();
	  msg = msg || '';
	  msg = msg
	    .replace(/#\{this\}/g, function () { return objDisplay(val); })
	    .replace(/#\{act\}/g, function () { return objDisplay(actual); })
	    .replace(/#\{exp\}/g, function () { return objDisplay(expected); });
	
	  return flagMsg ? flagMsg + ': ' + msg : msg;
	};


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Chai - getOwnEnumerableProperties utility
	 * Copyright(c) 2011-2016 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/*!
	 * Module dependancies
	 */
	
	var getOwnEnumerablePropertySymbols = __webpack_require__(556);
	
	/**
	 * ### .getOwnEnumerableProperties(object)
	 *
	 * This allows the retrieval of directly-owned enumerable property names and
	 * symbols of an object. This function is necessary because Object.keys only
	 * returns enumerable property names, not enumerable property symbols.
	 *
	 * @param {Object} object
	 * @returns {Array}
	 * @namespace Utils
	 * @name getOwnEnumerableProperties
	 * @api public
	 */
	
	module.exports = function getOwnEnumerableProperties(obj) {
	  return Object.keys(obj).concat(getOwnEnumerablePropertySymbols(obj));
	};


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * chai
	 * Copyright(c) 2011 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/*!
	 * Dependencies that are used for multiple exports are required here only once
	 */
	
	var pathval = __webpack_require__(4378);
	
	/*!
	 * test utility
	 */
	
	exports.test = __webpack_require__(1023);
	
	/*!
	 * type utility
	 */
	
	exports.type = __webpack_require__(528);
	
	/*!
	 * expectTypes utility
	 */
	exports.expectTypes = __webpack_require__(1014);
	
	/*!
	 * message utility
	 */
	
	exports.getMessage = __webpack_require__(1016);
	
	/*!
	 * actual utility
	 */
	
	exports.getActual = __webpack_require__(555);
	
	/*!
	 * Inspect util
	 */
	
	exports.inspect = __webpack_require__(287);
	
	/*!
	 * Object Display util
	 */
	
	exports.objDisplay = __webpack_require__(558);
	
	/*!
	 * Flag utility
	 */
	
	exports.flag = __webpack_require__(69);
	
	/*!
	 * Flag transferring utility
	 */
	
	exports.transferFlags = __webpack_require__(128);
	
	/*!
	 * Deep equal utility
	 */
	
	exports.eql = __webpack_require__(1142);
	
	/*!
	 * Deep path info
	 */
	
	exports.getPathInfo = pathval.getPathInfo;
	
	/*!
	 * Check if a property exists
	 */
	
	exports.hasProperty = pathval.hasProperty;
	
	/*!
	 * Function name
	 */
	
	exports.getName = __webpack_require__(625);
	
	/*!
	 * add Property
	 */
	
	exports.addProperty = __webpack_require__(1012);
	
	/*!
	 * add Method
	 */
	
	exports.addMethod = __webpack_require__(1011);
	
	/*!
	 * overwrite Property
	 */
	
	exports.overwriteProperty = __webpack_require__(1022);
	
	/*!
	 * overwrite Method
	 */
	
	exports.overwriteMethod = __webpack_require__(1021);
	
	/*!
	 * Add a chainable method
	 */
	
	exports.addChainableMethod = __webpack_require__(1010);
	
	/*!
	 * Overwrite chainable method
	 */
	
	exports.overwriteChainableMethod = __webpack_require__(1020);
	
	/*!
	 * Compare by inspect method
	 */
	
	exports.compareByInspect = __webpack_require__(1013);
	
	/*!
	 * Get own enumerable property symbols method
	 */
	
	exports.getOwnEnumerablePropertySymbols = __webpack_require__(556);
	
	/*!
	 * Get own enumerable properties method
	 */
	
	exports.getOwnEnumerableProperties = __webpack_require__(1017);
	
	/*!
	 * Checks error against a given set of criteria
	 */
	
	exports.checkError = __webpack_require__(1024);
	
	/*!
	 * Proxify util
	 */
	
	exports.proxify = __webpack_require__(289);
	
	/*!
	 * addLengthGuard util
	 */
	
	exports.addLengthGuard = __webpack_require__(286);
	
	/*!
	 * isProxyEnabled helper
	 */
	
	exports.isProxyEnabled = __webpack_require__(288);
	
	/*!
	 * isNaN method
	 */
	
	exports.isNaN = __webpack_require__(1019);


/***/ }),
/* 1019 */
/***/ (function(module, exports) {

	/*!
	 * Chai - isNaN utility
	 * Copyright(c) 2012-2015 Sakthipriyan Vairamani <thechargingvolcano@gmail.com>
	 * MIT Licensed
	 */
	
	/**
	 * ### .isNaN(value)
	 *
	 * Checks if the given value is NaN or not.
	 *
	 *     utils.isNaN(NaN); // true
	 *
	 * @param {Value} The value which has to be checked if it is NaN
	 * @name isNaN
	 * @api private
	 */
	
	function isNaN(value) {
	  // Refer http://www.ecma-international.org/ecma-262/6.0/#sec-isnan-number
	  // section's NOTE.
	  return value !== value;
	}
	
	// If ECMAScript 6's Number.isNaN is present, prefer that.
	module.exports = Number.isNaN || isNaN;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Chai - overwriteChainableMethod utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	var chai = __webpack_require__(126);
	var transferFlags = __webpack_require__(128);
	
	/**
	 * ### .overwriteChainableMethod(ctx, name, method, chainingBehavior)
	 *
	 * Overwites an already existing chainable method
	 * and provides access to the previous function or
	 * property.  Must return functions to be used for
	 * name.
	 *
	 *     utils.overwriteChainableMethod(chai.Assertion.prototype, 'lengthOf',
	 *       function (_super) {
	 *       }
	 *     , function (_super) {
	 *       }
	 *     );
	 *
	 * Can also be accessed directly from `chai.Assertion`.
	 *
	 *     chai.Assertion.overwriteChainableMethod('foo', fn, fn);
	 *
	 * Then can be used as any other assertion.
	 *
	 *     expect(myFoo).to.have.lengthOf(3);
	 *     expect(myFoo).to.have.lengthOf.above(3);
	 *
	 * @param {Object} ctx object whose method / property is to be overwritten
	 * @param {String} name of method / property to overwrite
	 * @param {Function} method function that returns a function to be used for name
	 * @param {Function} chainingBehavior function that returns a function to be used for property
	 * @namespace Utils
	 * @name overwriteChainableMethod
	 * @api public
	 */
	
	module.exports = function overwriteChainableMethod(ctx, name, method, chainingBehavior) {
	  var chainableBehavior = ctx.__methods[name];
	
	  var _chainingBehavior = chainableBehavior.chainingBehavior;
	  chainableBehavior.chainingBehavior = function overwritingChainableMethodGetter() {
	    var result = chainingBehavior(_chainingBehavior).call(this);
	    if (result !== undefined) {
	      return result;
	    }
	
	    var newAssertion = new chai.Assertion();
	    transferFlags(this, newAssertion);
	    return newAssertion;
	  };
	
	  var _method = chainableBehavior.method;
	  chainableBehavior.method = function overwritingChainableMethodWrapper() {
	    var result = method(_method).apply(this, arguments);
	    if (result !== undefined) {
	      return result;
	    }
	
	    var newAssertion = new chai.Assertion();
	    transferFlags(this, newAssertion);
	    return newAssertion;
	  };
	};


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Chai - overwriteMethod utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	var addLengthGuard = __webpack_require__(286);
	var chai = __webpack_require__(126);
	var flag = __webpack_require__(69);
	var proxify = __webpack_require__(289);
	var transferFlags = __webpack_require__(128);
	
	/**
	 * ### .overwriteMethod(ctx, name, fn)
	 *
	 * Overwites an already existing method and provides
	 * access to previous function. Must return function
	 * to be used for name.
	 *
	 *     utils.overwriteMethod(chai.Assertion.prototype, 'equal', function (_super) {
	 *       return function (str) {
	 *         var obj = utils.flag(this, 'object');
	 *         if (obj instanceof Foo) {
	 *           new chai.Assertion(obj.value).to.equal(str);
	 *         } else {
	 *           _super.apply(this, arguments);
	 *         }
	 *       }
	 *     });
	 *
	 * Can also be accessed directly from `chai.Assertion`.
	 *
	 *     chai.Assertion.overwriteMethod('foo', fn);
	 *
	 * Then can be used as any other assertion.
	 *
	 *     expect(myFoo).to.equal('bar');
	 *
	 * @param {Object} ctx object whose method is to be overwritten
	 * @param {String} name of method to overwrite
	 * @param {Function} method function that returns a function to be used for name
	 * @namespace Utils
	 * @name overwriteMethod
	 * @api public
	 */
	
	module.exports = function overwriteMethod(ctx, name, method) {
	  var _method = ctx[name]
	    , _super = function () {
	      throw new Error(name + ' is not a function');
	    };
	
	  if (_method && 'function' === typeof _method)
	    _super = _method;
	
	  var overwritingMethodWrapper = function () {
	    // Setting the `ssfi` flag to `overwritingMethodWrapper` causes this
	    // function to be the starting point for removing implementation frames from
	    // the stack trace of a failed assertion.
	    //
	    // However, we only want to use this function as the starting point if the
	    // `lockSsfi` flag isn't set.
	    //
	    // If the `lockSsfi` flag is set, then either this assertion has been
	    // overwritten by another assertion, or this assertion is being invoked from
	    // inside of another assertion. In the first case, the `ssfi` flag has
	    // already been set by the overwriting assertion. In the second case, the
	    // `ssfi` flag has already been set by the outer assertion.
	    if (!flag(this, 'lockSsfi')) {
	      flag(this, 'ssfi', overwritingMethodWrapper);
	    }
	
	    // Setting the `lockSsfi` flag to `true` prevents the overwritten assertion
	    // from changing the `ssfi` flag. By this point, the `ssfi` flag is already
	    // set to the correct starting point for this assertion.
	    var origLockSsfi = flag(this, 'lockSsfi');
	    flag(this, 'lockSsfi', true);
	    var result = method(_super).apply(this, arguments);
	    flag(this, 'lockSsfi', origLockSsfi);
	
	    if (result !== undefined) {
	      return result;
	    }
	
	    var newAssertion = new chai.Assertion();
	    transferFlags(this, newAssertion);
	    return newAssertion;
	  }
	
	  addLengthGuard(overwritingMethodWrapper, name, false);
	  ctx[name] = proxify(overwritingMethodWrapper, name);
	};


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Chai - overwriteProperty utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	var chai = __webpack_require__(126);
	var flag = __webpack_require__(69);
	var isProxyEnabled = __webpack_require__(288);
	var transferFlags = __webpack_require__(128);
	
	/**
	 * ### .overwriteProperty(ctx, name, fn)
	 *
	 * Overwites an already existing property getter and provides
	 * access to previous value. Must return function to use as getter.
	 *
	 *     utils.overwriteProperty(chai.Assertion.prototype, 'ok', function (_super) {
	 *       return function () {
	 *         var obj = utils.flag(this, 'object');
	 *         if (obj instanceof Foo) {
	 *           new chai.Assertion(obj.name).to.equal('bar');
	 *         } else {
	 *           _super.call(this);
	 *         }
	 *       }
	 *     });
	 *
	 *
	 * Can also be accessed directly from `chai.Assertion`.
	 *
	 *     chai.Assertion.overwriteProperty('foo', fn);
	 *
	 * Then can be used as any other assertion.
	 *
	 *     expect(myFoo).to.be.ok;
	 *
	 * @param {Object} ctx object whose property is to be overwritten
	 * @param {String} name of property to overwrite
	 * @param {Function} getter function that returns a getter function to be used for name
	 * @namespace Utils
	 * @name overwriteProperty
	 * @api public
	 */
	
	module.exports = function overwriteProperty(ctx, name, getter) {
	  var _get = Object.getOwnPropertyDescriptor(ctx, name)
	    , _super = function () {};
	
	  if (_get && 'function' === typeof _get.get)
	    _super = _get.get
	
	  Object.defineProperty(ctx, name,
	    { get: function overwritingPropertyGetter() {
	        // Setting the `ssfi` flag to `overwritingPropertyGetter` causes this
	        // function to be the starting point for removing implementation frames
	        // from the stack trace of a failed assertion.
	        //
	        // However, we only want to use this function as the starting point if
	        // the `lockSsfi` flag isn't set and proxy protection is disabled.
	        //
	        // If the `lockSsfi` flag is set, then either this assertion has been
	        // overwritten by another assertion, or this assertion is being invoked
	        // from inside of another assertion. In the first case, the `ssfi` flag
	        // has already been set by the overwriting assertion. In the second
	        // case, the `ssfi` flag has already been set by the outer assertion.
	        //
	        // If proxy protection is enabled, then the `ssfi` flag has already been
	        // set by the proxy getter.
	        if (!isProxyEnabled() && !flag(this, 'lockSsfi')) {
	          flag(this, 'ssfi', overwritingPropertyGetter);
	        }
	
	        // Setting the `lockSsfi` flag to `true` prevents the overwritten
	        // assertion from changing the `ssfi` flag. By this point, the `ssfi`
	        // flag is already set to the correct starting point for this assertion.
	        var origLockSsfi = flag(this, 'lockSsfi');
	        flag(this, 'lockSsfi', true);
	        var result = getter(_super).call(this);
	        flag(this, 'lockSsfi', origLockSsfi);
	
	        if (result !== undefined) {
	          return result;
	        }
	
	        var newAssertion = new chai.Assertion();
	        transferFlags(this, newAssertion);
	        return newAssertion;
	      }
	    , configurable: true
	  });
	};


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Chai - test utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/*!
	 * Module dependancies
	 */
	
	var flag = __webpack_require__(69);
	
	/**
	 * ### .test(object, expression)
	 *
	 * Test and object for expression.
	 *
	 * @param {Object} object (constructed Assertion)
	 * @param {Arguments} chai.Assertion.prototype.assert arguments
	 * @namespace Utils
	 * @name test
	 */
	
	module.exports = function test(obj, args) {
	  var negate = flag(obj, 'negate')
	    , expr = args[0];
	  return negate ? !expr : expr;
	};


/***/ }),
/* 1024 */
/***/ (function(module, exports) {

	'use strict';
	
	/* !
	 * Chai - checkError utility
	 * Copyright(c) 2012-2016 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	/**
	 * ### .checkError
	 *
	 * Checks that an error conforms to a given set of criteria and/or retrieves information about it.
	 *
	 * @api public
	 */
	
	/**
	 * ### .compatibleInstance(thrown, errorLike)
	 *
	 * Checks if two instances are compatible (strict equal).
	 * Returns false if errorLike is not an instance of Error, because instances
	 * can only be compatible if they're both error instances.
	 *
	 * @name compatibleInstance
	 * @param {Error} thrown error
	 * @param {Error|ErrorConstructor} errorLike object to compare against
	 * @namespace Utils
	 * @api public
	 */
	
	function compatibleInstance(thrown, errorLike) {
	  return errorLike instanceof Error && thrown === errorLike;
	}
	
	/**
	 * ### .compatibleConstructor(thrown, errorLike)
	 *
	 * Checks if two constructors are compatible.
	 * This function can receive either an error constructor or
	 * an error instance as the `errorLike` argument.
	 * Constructors are compatible if they're the same or if one is
	 * an instance of another.
	 *
	 * @name compatibleConstructor
	 * @param {Error} thrown error
	 * @param {Error|ErrorConstructor} errorLike object to compare against
	 * @namespace Utils
	 * @api public
	 */
	
	function compatibleConstructor(thrown, errorLike) {
	  if (errorLike instanceof Error) {
	    // If `errorLike` is an instance of any error we compare their constructors
	    return thrown.constructor === errorLike.constructor || thrown instanceof errorLike.constructor;
	  } else if (errorLike.prototype instanceof Error || errorLike === Error) {
	    // If `errorLike` is a constructor that inherits from Error, we compare `thrown` to `errorLike` directly
	    return thrown.constructor === errorLike || thrown instanceof errorLike;
	  }
	
	  return false;
	}
	
	/**
	 * ### .compatibleMessage(thrown, errMatcher)
	 *
	 * Checks if an error's message is compatible with a matcher (String or RegExp).
	 * If the message contains the String or passes the RegExp test,
	 * it is considered compatible.
	 *
	 * @name compatibleMessage
	 * @param {Error} thrown error
	 * @param {String|RegExp} errMatcher to look for into the message
	 * @namespace Utils
	 * @api public
	 */
	
	function compatibleMessage(thrown, errMatcher) {
	  var comparisonString = typeof thrown === 'string' ? thrown : thrown.message;
	  if (errMatcher instanceof RegExp) {
	    return errMatcher.test(comparisonString);
	  } else if (typeof errMatcher === 'string') {
	    return comparisonString.indexOf(errMatcher) !== -1; // eslint-disable-line no-magic-numbers
	  }
	
	  return false;
	}
	
	/**
	 * ### .getFunctionName(constructorFn)
	 *
	 * Returns the name of a function.
	 * This also includes a polyfill function if `constructorFn.name` is not defined.
	 *
	 * @name getFunctionName
	 * @param {Function} constructorFn
	 * @namespace Utils
	 * @api private
	 */
	
	var functionNameMatch = /\s*function(?:\s|\s*\/\*[^(?:*\/)]+\*\/\s*)*([^\(\/]+)/;
	function getFunctionName(constructorFn) {
	  var name = '';
	  if (typeof constructorFn.name === 'undefined') {
	    // Here we run a polyfill if constructorFn.name is not defined
	    var match = String(constructorFn).match(functionNameMatch);
	    if (match) {
	      name = match[1];
	    }
	  } else {
	    name = constructorFn.name;
	  }
	
	  return name;
	}
	
	/**
	 * ### .getConstructorName(errorLike)
	 *
	 * Gets the constructor name for an Error instance or constructor itself.
	 *
	 * @name getConstructorName
	 * @param {Error|ErrorConstructor} errorLike
	 * @namespace Utils
	 * @api public
	 */
	
	function getConstructorName(errorLike) {
	  var constructorName = errorLike;
	  if (errorLike instanceof Error) {
	    constructorName = getFunctionName(errorLike.constructor);
	  } else if (typeof errorLike === 'function') {
	    // If `err` is not an instance of Error it is an error constructor itself or another function.
	    // If we've got a common function we get its name, otherwise we may need to create a new instance
	    // of the error just in case it's a poorly-constructed error. Please see chaijs/chai/issues/45 to know more.
	    constructorName = getFunctionName(errorLike).trim() ||
	        getFunctionName(new errorLike()); // eslint-disable-line new-cap
	  }
	
	  return constructorName;
	}
	
	/**
	 * ### .getMessage(errorLike)
	 *
	 * Gets the error message from an error.
	 * If `err` is a String itself, we return it.
	 * If the error has no message, we return an empty string.
	 *
	 * @name getMessage
	 * @param {Error|String} errorLike
	 * @namespace Utils
	 * @api public
	 */
	
	function getMessage(errorLike) {
	  var msg = '';
	  if (errorLike && errorLike.message) {
	    msg = errorLike.message;
	  } else if (typeof errorLike === 'string') {
	    msg = errorLike;
	  }
	
	  return msg;
	}
	
	module.exports = {
	  compatibleInstance: compatibleInstance,
	  compatibleConstructor: compatibleConstructor,
	  compatibleMessage: compatibleMessage,
	  getMessage: getMessage,
	  getConstructorName: getConstructorName,
	};


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(384),
	    utils = __webpack_require__(198),
	    isTag = utils.isTag,
	    domEach = utils.domEach,
	    hasOwn = Object.prototype.hasOwnProperty,
	    camelCase = utils.camelCase,
	    cssCase = utils.cssCase,
	    rspace = /\s+/,
	    dataAttrPrefix = 'data-',
	    _ = {
	      forEach: __webpack_require__(139),
	      extend: __webpack_require__(465),
	      some: __webpack_require__(693)
	    },
	
	  // Lookup table for coercing string data-* attributes to their corresponding
	  // JavaScript primitives
	  primitives = {
	    null: null,
	    true: true,
	    false: false
	  },
	
	  // Attributes that are booleans
	  rboolean = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,
	  // Matches strings that look like JSON objects or arrays
	  rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/;
	
	
	var getAttr = function(elem, name) {
	  if (!elem || !isTag(elem)) return;
	
	  if (!elem.attribs) {
	    elem.attribs = {};
	  }
	
	  // Return the entire attribs object if no attribute specified
	  if (!name) {
	    return elem.attribs;
	  }
	
	  if (hasOwn.call(elem.attribs, name)) {
	    // Get the (decoded) attribute
	    return rboolean.test(name) ? name : elem.attribs[name];
	  }
	
	  // Mimic the DOM and return text content as value for `option's`
	  if (elem.name === 'option' && name === 'value') {
	    return $.text(elem.children);
	  }
	
	  // Mimic DOM with default value for radios/checkboxes
	  if (elem.name === 'input' &&
	      (elem.attribs.type === 'radio' || elem.attribs.type === 'checkbox') &&
	      name === 'value') {
	    return 'on';
	  }
	};
	
	var setAttr = function(el, name, value) {
	
	  if (value === null) {
	    removeAttribute(el, name);
	  } else {
	    el.attribs[name] = value+'';
	  }
	};
	
	exports.attr = function(name, value) {
	  // Set the value (with attr map support)
	  if (typeof name === 'object' || value !== undefined) {
	    if (typeof value === 'function') {
	      return domEach(this, function(i, el) {
	        setAttr(el, name, value.call(el, i, el.attribs[name]));
	      });
	    }
	    return domEach(this, function(i, el) {
	      if (!isTag(el)) return;
	
	      if (typeof name === 'object') {
	        _.forEach(name, function(objValue, objName) {
	          setAttr(el, objName, objValue);
	        });
	      } else {
	        setAttr(el, name, value);
	      }
	    });
	  }
	
	  return getAttr(this[0], name);
	};
	
	var getProp = function (el, name) {
	  if (!el || !isTag(el)) return;
	
	  return hasOwn.call(el, name)
	      ? el[name]
	      : rboolean.test(name)
	          ? getAttr(el, name) !== undefined
	          : getAttr(el, name);
	};
	
	var setProp = function (el, name, value) {
	  el[name] = rboolean.test(name) ? !!value : value;
	};
	
	exports.prop = function (name, value) {
	  var i = 0,
	      property;
	
	  if (typeof name === 'string' && value === undefined) {
	
	    switch (name) {
	      case 'style':
	        property = this.css();
	
	        _.forEach(property, function (v, p) {
	          property[i++] = p;
	        });
	
	        property.length = i;
	
	        break;
	      case 'tagName':
	      case 'nodeName':
	        property = this[0].name.toUpperCase();
	        break;
	      default:
	        property = getProp(this[0], name);
	    }
	
	    return property;
	  }
	
	  if (typeof name === 'object' || value !== undefined) {
	
	    if (typeof value === 'function') {
	      return domEach(this, function(j, el) {
	        setProp(el, name, value.call(el, j, getProp(el, name)));
	      });
	    }
	
	    return domEach(this, function(__, el) {
	      if (!isTag(el)) return;
	
	      if (typeof name === 'object') {
	
	        _.forEach(name, function(val, key) {
	          setProp(el, key, val);
	        });
	
	      } else {
	        setProp(el, name, value);
	      }
	    });
	
	  }
	};
	
	var setData = function(el, name, value) {
	  if (!el.data) {
	    el.data = {};
	  }
	
	  if (typeof name === 'object') return _.extend(el.data, name);
	  if (typeof name === 'string' && value !== undefined) {
	    el.data[name] = value;
	  }
	};
	
	// Read the specified attribute from the equivalent HTML5 `data-*` attribute,
	// and (if present) cache the value in the node's internal data store. If no
	// attribute name is specified, read *all* HTML5 `data-*` attributes in this
	// manner.
	var readData = function(el, name) {
	  var readAll = arguments.length === 1;
	  var domNames, domName, jsNames, jsName, value, idx, length;
	
	  if (readAll) {
	    domNames = Object.keys(el.attribs).filter(function(attrName) {
	      return attrName.slice(0, dataAttrPrefix.length) === dataAttrPrefix;
	    });
	    jsNames = domNames.map(function(_domName) {
	      return camelCase(_domName.slice(dataAttrPrefix.length));
	    });
	  } else {
	    domNames = [dataAttrPrefix + cssCase(name)];
	    jsNames = [name];
	  }
	
	  for (idx = 0, length = domNames.length; idx < length; ++idx) {
	    domName = domNames[idx];
	    jsName = jsNames[idx];
	    if (hasOwn.call(el.attribs, domName)) {
	      value = el.attribs[domName];
	
	      if (hasOwn.call(primitives, value)) {
	        value = primitives[value];
	      } else if (value === String(Number(value))) {
	        value = Number(value);
	      } else if (rbrace.test(value)) {
	        try {
	          value = JSON.parse(value);
	        } catch(e){ }
	      }
	
	      el.data[jsName] = value;
	    }
	  }
	
	  return readAll ? el.data : value;
	};
	
	exports.data = function(name, value) {
	  var elem = this[0];
	
	  if (!elem || !isTag(elem)) return;
	
	  if (!elem.data) {
	    elem.data = {};
	  }
	
	  // Return the entire data object if no data specified
	  if (!name) {
	    return readData(elem);
	  }
	
	  // Set the value (with attr map support)
	  if (typeof name === 'object' || value !== undefined) {
	    domEach(this, function(i, el) {
	      setData(el, name, value);
	    });
	    return this;
	  } else if (hasOwn.call(elem.data, name)) {
	    return elem.data[name];
	  }
	
	  return readData(elem, name);
	};
	
	/**
	 * Get the value of an element
	 */
	
	exports.val = function(value) {
	  var querying = arguments.length === 0,
	      element = this[0];
	
	  if(!element) return;
	
	  switch (element.name) {
	    case 'textarea':
	      return this.text(value);
	    case 'input':
	      switch (this.attr('type')) {
	        case 'radio':
	          if (querying) {
	            return this.attr('value');
	          } else {
	            this.attr('value', value);
	            return this;
	          }
	          break;
	        default:
	          return this.attr('value', value);
	      }
	      return;
	    case 'select':
	      var option = this.find('option:selected'),
	          returnValue;
	      if (option === undefined) return undefined;
	      if (!querying) {
	        if (!hasOwn.call(this.attr(), 'multiple') && typeof value == 'object') {
	          return this;
	        }
	        if (typeof value != 'object') {
	          value = [value];
	        }
	        this.find('option').removeAttr('selected');
	        for (var i = 0; i < value.length; i++) {
	          this.find('option[value="' + value[i] + '"]').attr('selected', '');
	        }
	        return this;
	      }
	      returnValue = option.attr('value');
	      if (hasOwn.call(this.attr(), 'multiple')) {
	        returnValue = [];
	        domEach(option, function(__, el) {
	          returnValue.push(getAttr(el, 'value'));
	        });
	      }
	      return returnValue;
	    case 'option':
	      if (!querying) {
	        this.attr('value', value);
	        return this;
	      }
	      return this.attr('value');
	  }
	};
	
	/**
	 * Remove an attribute
	 */
	
	var removeAttribute = function(elem, name) {
	  if (!elem.attribs || !hasOwn.call(elem.attribs, name))
	    return;
	
	  delete elem.attribs[name];
	};
	
	
	exports.removeAttr = function(name) {
	  domEach(this, function(i, elem) {
	    removeAttribute(elem, name);
	  });
	
	  return this;
	};
	
	exports.hasClass = function(className) {
	  return _.some(this, function(elem) {
	    var attrs = elem.attribs,
	        clazz = attrs && attrs['class'],
	        idx = -1,
	        end;
	
	    if (clazz && className.length) {
	      while ((idx = clazz.indexOf(className, idx+1)) > -1) {
	        end = idx + className.length;
	
	        if ((idx === 0 || rspace.test(clazz[idx-1]))
	            && (end === clazz.length || rspace.test(clazz[end]))) {
	          return true;
	        }
	      }
	    }
	  });
	};
	
	exports.addClass = function(value) {
	  // Support functions
	  if (typeof value === 'function') {
	    return domEach(this, function(i, el) {
	      var className = el.attribs['class'] || '';
	      exports.addClass.call([el], value.call(el, i, className));
	    });
	  }
	
	  // Return if no value or not a string or function
	  if (!value || typeof value !== 'string') return this;
	
	  var classNames = value.split(rspace),
	      numElements = this.length;
	
	
	  for (var i = 0; i < numElements; i++) {
	    // If selected element isn't a tag, move on
	    if (!isTag(this[i])) continue;
	
	    // If we don't already have classes
	    var className = getAttr(this[i], 'class'),
	        numClasses,
	        setClass;
	
	    if (!className) {
	      setAttr(this[i], 'class', classNames.join(' ').trim());
	    } else {
	      setClass = ' ' + className + ' ';
	      numClasses = classNames.length;
	
	      // Check if class already exists
	      for (var j = 0; j < numClasses; j++) {
	        var appendClass = classNames[j] + ' ';
	        if (setClass.indexOf(' ' + appendClass) < 0)
	          setClass += appendClass;
	      }
	
	      setAttr(this[i], 'class', setClass.trim());
	    }
	  }
	
	  return this;
	};
	
	var splitClass = function(className) {
	  return className ? className.trim().split(rspace) : [];
	};
	
	exports.removeClass = function(value) {
	  var classes,
	      numClasses,
	      removeAll;
	
	  // Handle if value is a function
	  if (typeof value === 'function') {
	    return domEach(this, function(i, el) {
	      exports.removeClass.call(
	        [el], value.call(el, i, el.attribs['class'] || '')
	      );
	    });
	  }
	
	  classes = splitClass(value);
	  numClasses = classes.length;
	  removeAll = arguments.length === 0;
	
	  return domEach(this, function(i, el) {
	    if (!isTag(el)) return;
	
	    if (removeAll) {
	      // Short circuit the remove all case as this is the nice one
	      el.attribs.class = '';
	    } else {
	      var elClasses = splitClass(el.attribs.class),
	          index,
	          changed;
	
	      for (var j = 0; j < numClasses; j++) {
	        index = elClasses.indexOf(classes[j]);
	
	        if (index >= 0) {
	          elClasses.splice(index, 1);
	          changed = true;
	
	          // We have to do another pass to ensure that there are not duplicate
	          // classes listed
	          j--;
	        }
	      }
	      if (changed) {
	        el.attribs.class = elClasses.join(' ');
	      }
	    }
	  });
	};
	
	exports.toggleClass = function(value, stateVal) {
	  // Support functions
	  if (typeof value === 'function') {
	    return domEach(this, function(i, el) {
	      exports.toggleClass.call(
	        [el],
	        value.call(el, i, el.attribs['class'] || '', stateVal),
	        stateVal
	      );
	    });
	  }
	
	  // Return if no value or not a string or function
	  if (!value || typeof value !== 'string') return this;
	
	  var classNames = value.split(rspace),
	    numClasses = classNames.length,
	    state = typeof stateVal === 'boolean' ? stateVal ? 1 : -1 : 0,
	    numElements = this.length,
	    elementClasses,
	    index;
	
	  for (var i = 0; i < numElements; i++) {
	    // If selected element isn't a tag, move on
	    if (!isTag(this[i])) continue;
	
	    elementClasses = splitClass(this[i].attribs.class);
	
	    // Check if class already exists
	    for (var j = 0; j < numClasses; j++) {
	      // Check if the class name is currently defined
	      index = elementClasses.indexOf(classNames[j]);
	
	      // Add if stateValue === true or we are toggling and there is no value
	      if (state >= 0 && index < 0) {
	        elementClasses.push(classNames[j]);
	      } else if (state <= 0 && index >= 0) {
	        // Otherwise remove but only if the item exists
	        elementClasses.splice(index, 1);
	      }
	    }
	
	    this[i].attribs.class = elementClasses.join(' ');
	  }
	
	  return this;
	};
	
	exports.is = function (selector) {
	  if (selector) {
	    return this.filter(selector).length > 0;
	  }
	  return false;
	};


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	var domEach = __webpack_require__(198).domEach,
	    _ = {
	      pick: __webpack_require__(692),
	    };
	
	var toString = Object.prototype.toString;
	
	/**
	 * Set / Get css.
	 *
	 * @param {String|Object} prop
	 * @param {String} val
	 * @return {self}
	 * @api public
	 */
	
	exports.css = function(prop, val) {
	  if (arguments.length === 2 ||
	    // When `prop` is a "plain" object
	    (toString.call(prop) === '[object Object]')) {
	    return domEach(this, function(idx, el) {
	      setCss(el, prop, val, idx);
	    });
	  } else {
	    return getCss(this[0], prop);
	  }
	};
	
	/**
	 * Set styles of all elements.
	 *
	 * @param {String|Object} prop
	 * @param {String} val
	 * @param {Number} idx - optional index within the selection
	 * @return {self}
	 * @api private
	 */
	
	function setCss(el, prop, val, idx) {
	  if ('string' == typeof prop) {
	    var styles = getCss(el);
	    if (typeof val === 'function') {
	      val = val.call(el, idx, styles[prop]);
	    }
	
	    if (val === '') {
	      delete styles[prop];
	    } else if (val != null) {
	      styles[prop] = val;
	    }
	
	    el.attribs.style = stringify(styles);
	  } else if ('object' == typeof prop) {
	    Object.keys(prop).forEach(function(k){
	      setCss(el, k, prop[k]);
	    });
	  }
	}
	
	/**
	 * Get parsed styles of the first element.
	 *
	 * @param {String} prop
	 * @return {Object}
	 * @api private
	 */
	
	function getCss(el, prop) {
	  var styles = parse(el.attribs.style);
	  if (typeof prop === 'string') {
	    return styles[prop];
	  } else if (Array.isArray(prop)) {
	    return _.pick(styles, prop);
	  } else {
	    return styles;
	  }
	}
	
	/**
	 * Stringify `obj` to styles.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function stringify(obj) {
	  return Object.keys(obj || {})
	    .reduce(function(str, prop){
	      return str += ''
	        + (str ? ' ' : '')
	        + prop
	        + ': '
	        + obj[prop]
	        + ';';
	    }, '');
	}
	
	/**
	 * Parse `styles`.
	 *
	 * @param {String} styles
	 * @return {Object}
	 * @api private
	 */
	
	function parse(styles) {
	  styles = (styles || '').trim();
	
	  if (!styles) return {};
	
	  return styles
	    .split(';')
	    .reduce(function(obj, str){
	      var n = str.indexOf(':');
	      // skip if there is no :, or if it is the first/last character
	      if (n < 1 || n === str.length-1) return obj;
	      obj[str.slice(0,n).trim()] = str.slice(n+1).trim();
	      return obj;
	    }, {});
	}


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/jquery/jquery/blob/2.1.3/src/manipulation/var/rcheckableType.js
	// https://github.com/jquery/jquery/blob/2.1.3/src/serialize.js
	var submittableSelector = 'input,select,textarea,keygen',
	    r20 = /%20/g,
	    rCRLF = /\r?\n/g,
	    _ = {
	      map: __webpack_require__(4330)
	    };
	
	exports.serialize = function() {
	  // Convert form elements into name/value objects
	  var arr = this.serializeArray();
	
	  // Serialize each element into a key/value string
	  var retArr = _.map(arr, function(data) {
	    return encodeURIComponent(data.name) + '=' + encodeURIComponent(data.value);
	  });
	
	  // Return the resulting serialization
	  return retArr.join('&').replace(r20, '+');
	};
	
	exports.serializeArray = function() {
	  // Resolve all form elements from either forms or collections of form elements
	  var Cheerio = this.constructor;
	  return this.map(function() {
	      var elem = this;
	      var $elem = Cheerio(elem);
	      if (elem.name === 'form') {
	        return $elem.find(submittableSelector).toArray();
	      } else {
	        return $elem.filter(submittableSelector).toArray();
	      }
	    }).filter(
	        // Verify elements have a name (`attr.name`) and are not disabled (`:disabled`)
	        '[name!=""]:not(:disabled)'
	        // and cannot be clicked (`[type=submit]`) or are used in `x-www-form-urlencoded` (`[type=file]`)
	        + ':not(:submit, :button, :image, :reset, :file)'
	        // and are either checked/don't have a checkable state
	        + ':matches([checked], :not(:checkbox, :radio))'
	    // Convert each of the elements to its value(s)
	    ).map(function(i, elem) {
	      var $elem = Cheerio(elem);
	      var name = $elem.attr('name');
	      var value = $elem.val();
	
	      // If there is no value set (e.g. `undefined`, `null`), then default value to empty
	      if (value == null) {
	        value = '';
	      }
	
	      // If we have an array of values (e.g. `<select multiple>`), return an array of key/value pairs
	      if (Array.isArray(value)) {
	        return _.map(value, function(val) {
	          // We trim replace any line endings (e.g. `\r` or `\r\n` with `\r\n`) to guarantee consistency across platforms
	          //   These can occur inside of `<textarea>'s`
	          return {name: name, value: val.replace( rCRLF, '\r\n' )};
	        });
	      // Otherwise (e.g. `<input type="text">`, return only one key/value pair
	      } else {
	        return {name: name, value: value.replace( rCRLF, '\r\n' )};
	      }
	    // Convert our result to an array
	    }).get();
	};


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(291),
	    $ = __webpack_require__(384),
	    updateDOM = parse.update,
	    evaluate = parse.evaluate,
	    utils = __webpack_require__(198),
	    domEach = utils.domEach,
	    cloneDom = utils.cloneDom,
	    isHtml = utils.isHtml,
	    slice = Array.prototype.slice,
	    _ = {
	      flatten: __webpack_require__(183),
	      bind: __webpack_require__(466),
	      forEach: __webpack_require__(139)
	    };
	
	// Create an array of nodes, recursing into arrays and parsing strings if
	// necessary
	exports._makeDomArray = function makeDomArray(elem, clone) {
	  if (elem == null) {
	    return [];
	  } else if (elem.cheerio) {
	    return clone ? cloneDom(elem.get(), elem.options) : elem.get();
	  } else if (Array.isArray(elem)) {
	    return _.flatten(elem.map(function(el) {
	      return this._makeDomArray(el, clone);
	    }, this));
	  } else if (typeof elem === 'string') {
	    return evaluate(elem, this.options, false);
	  } else {
	    return clone ? cloneDom([elem]) : [elem];
	  }
	};
	
	var _insert = function(concatenator) {
	  return function() {
	    var elems = slice.call(arguments),
	        lastIdx = this.length - 1;
	
	    return domEach(this, function(i, el) {
	      var dom, domSrc;
	
	      if (typeof elems[0] === 'function') {
	        domSrc = elems[0].call(el, i, $.html(el.children));
	      } else {
	        domSrc = elems;
	      }
	
	      dom = this._makeDomArray(domSrc, i < lastIdx);
	      concatenator(dom, el.children, el);
	    });
	  };
	};
	
	/*
	 * Modify an array in-place, removing some number of elements and adding new
	 * elements directly following them.
	 *
	 * @param {Array} array Target array to splice.
	 * @param {Number} spliceIdx Index at which to begin changing the array.
	 * @param {Number} spliceCount Number of elements to remove from the array.
	 * @param {Array} newElems Elements to insert into the array.
	 *
	 * @api private
	 */
	var uniqueSplice = function(array, spliceIdx, spliceCount, newElems, parent) {
	  var spliceArgs = [spliceIdx, spliceCount].concat(newElems),
	      prev = array[spliceIdx - 1] || null,
	      next = array[spliceIdx] || null;
	  var idx, len, prevIdx, node, oldParent;
	
	  // Before splicing in new elements, ensure they do not already appear in the
	  // current array.
	  for (idx = 0, len = newElems.length; idx < len; ++idx) {
	    node = newElems[idx];
	    oldParent = node.parent || node.root;
	    prevIdx = oldParent && oldParent.children.indexOf(newElems[idx]);
	
	    if (oldParent && prevIdx > -1) {
	      oldParent.children.splice(prevIdx, 1);
	      if (parent === oldParent && spliceIdx > prevIdx) {
	        spliceArgs[0]--;
	      }
	    }
	
	    node.root = null;
	    node.parent = parent;
	
	    if (node.prev) {
	      node.prev.next = node.next || null;
	    }
	
	    if (node.next) {
	      node.next.prev = node.prev || null;
	    }
	
	    node.prev = newElems[idx - 1] || prev;
	    node.next = newElems[idx + 1] || next;
	  }
	
	  if (prev) {
	    prev.next = newElems[0];
	  }
	  if (next) {
	    next.prev = newElems[newElems.length - 1];
	  }
	  return array.splice.apply(array, spliceArgs);
	};
	
	exports.appendTo = function(target) {
	  if (!target.cheerio) {
	    target = this.constructor.call(this.constructor, target, null, this._originalRoot);
	  }
	
	  target.append(this);
	
	  return this;
	};
	
	exports.prependTo = function(target) {
	  if (!target.cheerio) {
	    target = this.constructor.call(this.constructor, target, null, this._originalRoot);
	  }
	
	  target.prepend(this);
	
	  return this;
	};
	
	exports.append = _insert(function(dom, children, parent) {
	  uniqueSplice(children, children.length, 0, dom, parent);
	});
	
	exports.prepend = _insert(function(dom, children, parent) {
	  uniqueSplice(children, 0, 0, dom, parent);
	});
	
	exports.wrap = function(wrapper) {
	  var wrapperFn = typeof wrapper === 'function' && wrapper,
	      lastIdx = this.length - 1;
	
	  _.forEach(this, _.bind(function(el, i) {
	    var parent = el.parent || el.root,
	        siblings = parent.children,
	        wrapperDom, elInsertLocation, j, index;
	
	    if (!parent) {
	      return;
	    }
	
	    if (wrapperFn) {
	      wrapper = wrapperFn.call(el, i);
	    }
	
	    if (typeof wrapper === 'string' && !isHtml(wrapper)) {
	      wrapper = this.parents().last().find(wrapper).clone();
	    }
	
	    wrapperDom = this._makeDomArray(wrapper, i < lastIdx).slice(0, 1);
	    elInsertLocation = wrapperDom[0];
	    // Find the deepest child. Only consider the first tag child of each node
	    // (ignore text); stop if no children are found.
	    j = 0;
	
	    while (elInsertLocation && elInsertLocation.children) {
	      if (j >= elInsertLocation.children.length) {
	        break;
	      }
	
	      if (elInsertLocation.children[j].type === 'tag') {
	        elInsertLocation = elInsertLocation.children[j];
	        j=0;
	      } else {
	        j++;
	      }
	    }
	    index = siblings.indexOf(el);
	
	    updateDOM([el], elInsertLocation);
	    // The previous operation removed the current element from the `siblings`
	    // array, so the `dom` array can be inserted without removing any
	    // additional elements.
	    uniqueSplice(siblings, index, 0, wrapperDom, parent);
	  }, this));
	
	  return this;
	};
	
	exports.after = function() {
	  var elems = slice.call(arguments),
	      lastIdx = this.length - 1;
	
	  domEach(this, function(i, el) {
	    var parent = el.parent || el.root;
	    if (!parent) {
	      return;
	    }
	
	    var siblings = parent.children,
	        index = siblings.indexOf(el),
	        domSrc, dom;
	
	    // If not found, move on
	    if (index < 0) return;
	
	    if (typeof elems[0] === 'function') {
	      domSrc = elems[0].call(el, i, $.html(el.children));
	    } else {
	      domSrc = elems;
	    }
	    dom = this._makeDomArray(domSrc, i < lastIdx);
	
	    // Add element after `this` element
	    uniqueSplice(siblings, index + 1, 0, dom, parent);
	  });
	
	  return this;
	};
	
	exports.insertAfter = function(target) {
	  var clones = [],
	      self = this;
	  if (typeof target === 'string') {
	    target = this.constructor.call(this.constructor, target, null, this._originalRoot);
	  }
	  target = this._makeDomArray(target);
	  self.remove();
	  domEach(target, function(i, el) {
	    var clonedSelf = self._makeDomArray(self.clone());
	    var parent = el.parent || el.root;
	    if (!parent) {
	      return;
	    }
	
	    var siblings = parent.children,
	        index = siblings.indexOf(el);
	
	    // If not found, move on
	    if (index < 0) return;
	
	    // Add cloned `this` element(s) after target element
	    uniqueSplice(siblings, index + 1, 0, clonedSelf, parent);
	    clones.push(clonedSelf);
	  });
	  return this.constructor.call(this.constructor, this._makeDomArray(clones));
	};
	
	exports.before = function() {
	  var elems = slice.call(arguments),
	      lastIdx = this.length - 1;
	
	  domEach(this, function(i, el) {
	    var parent = el.parent || el.root;
	    if (!parent) {
	      return;
	    }
	
	    var siblings = parent.children,
	        index = siblings.indexOf(el),
	        domSrc, dom;
	
	    // If not found, move on
	    if (index < 0) return;
	
	    if (typeof elems[0] === 'function') {
	      domSrc = elems[0].call(el, i, $.html(el.children));
	    } else {
	      domSrc = elems;
	    }
	
	    dom = this._makeDomArray(domSrc, i < lastIdx);
	
	    // Add element before `el` element
	    uniqueSplice(siblings, index, 0, dom, parent);
	  });
	
	  return this;
	};
	
	exports.insertBefore = function(target) {
	  var clones = [],
	      self = this;
	  if (typeof target === 'string') {
	    target = this.constructor.call(this.constructor, target, null, this._originalRoot);
	  }
	  target = this._makeDomArray(target);
	  self.remove();
	  domEach(target, function(i, el) {
	    var clonedSelf = self._makeDomArray(self.clone());
	    var parent = el.parent || el.root;
	    if (!parent) {
	      return;
	    }
	
	    var siblings = parent.children,
	        index = siblings.indexOf(el);
	
	    // If not found, move on
	    if (index < 0) return;
	
	    // Add cloned `this` element(s) after target element
	    uniqueSplice(siblings, index, 0, clonedSelf, parent);
	    clones.push(clonedSelf);
	  });
	  return this.constructor.call(this.constructor, this._makeDomArray(clones));
	};
	
	/*
	  remove([selector])
	*/
	exports.remove = function(selector) {
	  var elems = this;
	
	  // Filter if we have selector
	  if (selector)
	    elems = elems.filter(selector);
	
	  domEach(elems, function(i, el) {
	    var parent = el.parent || el.root;
	    if (!parent) {
	      return;
	    }
	
	    var siblings = parent.children,
	        index = siblings.indexOf(el);
	
	    if (index < 0) return;
	
	    siblings.splice(index, 1);
	    if (el.prev) {
	      el.prev.next = el.next;
	    }
	    if (el.next) {
	      el.next.prev = el.prev;
	    }
	    el.prev = el.next = el.parent = el.root = null;
	  });
	
	  return this;
	};
	
	exports.replaceWith = function(content) {
	  var self = this;
	
	  domEach(this, function(i, el) {
	    var parent = el.parent || el.root;
	    if (!parent) {
	      return;
	    }
	
	    var siblings = parent.children,
	        dom = self._makeDomArray(typeof content === 'function' ? content.call(el, i, el) : content),
	        index;
	
	    // In the case that `dom` contains nodes that already exist in other
	    // structures, ensure those nodes are properly removed.
	    updateDOM(dom, null);
	
	    index = siblings.indexOf(el);
	
	    // Completely remove old element
	    uniqueSplice(siblings, index, 1, dom, parent);
	    el.parent = el.prev = el.next = el.root = null;
	  });
	
	  return this;
	};
	
	exports.empty = function() {
	  domEach(this, function(i, el) {
	    _.forEach(el.children, function(child) {
	      child.next = child.prev = child.parent = null;
	    });
	
	    el.children.length = 0;
	  });
	  return this;
	};
	
	/**
	 * Set/Get the HTML
	 */
	exports.html = function(str) {
	  if (str === undefined) {
	    if (!this[0] || !this[0].children) return null;
	    return $.html(this[0].children, this.options);
	  }
	
	  var opts = this.options;
	
	  domEach(this, function(i, el) {
	    _.forEach(el.children, function(child) {
	      child.next = child.prev = child.parent = null;
	    });
	
	    var content = str.cheerio ? str.clone().get() : evaluate('' + str, opts, false);
	
	    updateDOM(content, el);
	  });
	
	  return this;
	};
	
	exports.toString = function() {
	  return $.html(this, this.options);
	};
	
	exports.text = function(str) {
	  // If `str` is undefined, act as a "getter"
	  if (str === undefined) {
	    return $.text(this);
	  } else if (typeof str === 'function') {
	    // Function support
	    return domEach(this, function(i, el) {
	      var $el = [el];
	      return exports.text.call($el, str.call(el, i, $.text($el)));
	    });
	  }
	
	  // Append text node to each selected elements
	  domEach(this, function(i, el) {
	    _.forEach(el.children, function(child) {
	      child.next = child.prev = child.parent = null;
	    });
	
	    var elem = {
	      data: '' + str,
	      type: 'text',
	      parent: el,
	      prev: null,
	      next: null,
	      children: []
	    };
	
	    updateDOM(elem, el);
	  });
	
	  return this;
	};
	
	exports.clone = function() {
	  return this._make(cloneDom(this.get(), this.options));
	};


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	var select = __webpack_require__(596),
	    utils = __webpack_require__(198),
	    domEach = utils.domEach,
	    uniqueSort = __webpack_require__(179).DomUtils.uniqueSort,
	    isTag = utils.isTag,
	    _ = {
	      bind: __webpack_require__(466),
	      forEach: __webpack_require__(139),
	      reject: __webpack_require__(4340),
	      filter: __webpack_require__(4319),
	      reduce: __webpack_require__(4339)
	    };
	
	exports.find = function(selectorOrHaystack) {
	  var elems = _.reduce(this, function(memo, elem) {
	    return memo.concat(_.filter(elem.children, isTag));
	  }, []);
	  var contains = this.constructor.contains;
	  var haystack;
	
	  if (selectorOrHaystack && typeof selectorOrHaystack !== 'string') {
	    if (selectorOrHaystack.cheerio) {
	      haystack = selectorOrHaystack.get();
	    } else {
	      haystack = [selectorOrHaystack];
	    }
	
	    return this._make(haystack.filter(function(elem) {
	      var idx, len;
	      for (idx = 0, len = this.length; idx < len; ++idx) {
	        if (contains(this[idx], elem)) {
	          return true;
	        }
	      }
	    }, this));
	  }
	
	  var options = {__proto__: this.options, context: this.toArray()};
	
	  return this._make(select(selectorOrHaystack, elems, options));
	};
	
	// Get the parent of each element in the current set of matched elements,
	// optionally filtered by a selector.
	exports.parent = function(selector) {
	  var set = [];
	
	  domEach(this, function(idx, elem) {
	    var parentElem = elem.parent;
	    if (parentElem && set.indexOf(parentElem) < 0) {
	      set.push(parentElem);
	    }
	  });
	
	  if (arguments.length) {
	    set = exports.filter.call(set, selector, this);
	  }
	
	  return this._make(set);
	};
	
	exports.parents = function(selector) {
	  var parentNodes = [];
	
	  // When multiple DOM elements are in the original set, the resulting set will
	  // be in *reverse* order of the original elements as well, with duplicates
	  // removed.
	  this.get().reverse().forEach(function(elem) {
	    traverseParents(this, elem.parent, selector, Infinity)
	      .forEach(function(node) {
	        if (parentNodes.indexOf(node) === -1) {
	          parentNodes.push(node);
	        }
	      }
	    );
	  }, this);
	
	  return this._make(parentNodes);
	};
	
	exports.parentsUntil = function(selector, filter) {
	  var parentNodes = [], untilNode, untilNodes;
	
	  if (typeof selector === 'string') {
	    untilNode = select(selector, this.parents().toArray(), this.options)[0];
	  } else if (selector && selector.cheerio) {
	    untilNodes = selector.toArray();
	  } else if (selector) {
	    untilNode = selector;
	  }
	
	  // When multiple DOM elements are in the original set, the resulting set will
	  // be in *reverse* order of the original elements as well, with duplicates
	  // removed.
	
	  this.toArray().reverse().forEach(function(elem) {
	    while ((elem = elem.parent)) {
	      if ((untilNode && elem !== untilNode) ||
	        (untilNodes && untilNodes.indexOf(elem) === -1) ||
	        (!untilNode && !untilNodes)) {
	        if (isTag(elem) && parentNodes.indexOf(elem) === -1) { parentNodes.push(elem); }
	      } else {
	        break;
	      }
	    }
	  }, this);
	
	  return this._make(filter ? select(filter, parentNodes, this.options) : parentNodes);
	};
	
	// For each element in the set, get the first element that matches the selector
	// by testing the element itself and traversing up through its ancestors in the
	// DOM tree.
	exports.closest = function(selector) {
	  var set = [];
	
	  if (!selector) {
	    return this._make(set);
	  }
	
	  domEach(this, function(idx, elem) {
	    var closestElem = traverseParents(this, elem, selector, 1)[0];
	
	    // Do not add duplicate elements to the set
	    if (closestElem && set.indexOf(closestElem) < 0) {
	      set.push(closestElem);
	    }
	  }.bind(this));
	
	  return this._make(set);
	};
	
	exports.next = function(selector) {
	  if (!this[0]) { return this; }
	  var elems = [];
	
	  _.forEach(this, function(elem) {
	    while ((elem = elem.next)) {
	      if (isTag(elem)) {
	        elems.push(elem);
	        return;
	      }
	    }
	  });
	
	  return selector ?
	    exports.filter.call(elems, selector, this) :
	    this._make(elems);
	};
	
	exports.nextAll = function(selector) {
	  if (!this[0]) { return this; }
	  var elems = [];
	
	  _.forEach(this, function(elem) {
	    while ((elem = elem.next)) {
	      if (isTag(elem) && elems.indexOf(elem) === -1) {
	        elems.push(elem);
	      }
	    }
	  });
	
	  return selector ?
	    exports.filter.call(elems, selector, this) :
	    this._make(elems);
	};
	
	exports.nextUntil = function(selector, filterSelector) {
	  if (!this[0]) { return this; }
	  var elems = [], untilNode, untilNodes;
	
	  if (typeof selector === 'string') {
	    untilNode = select(selector, this.nextAll().get(), this.options)[0];
	  } else if (selector && selector.cheerio) {
	    untilNodes = selector.get();
	  } else if (selector) {
	    untilNode = selector;
	  }
	
	  _.forEach(this, function(elem) {
	    while ((elem = elem.next)) {
	      if ((untilNode && elem !== untilNode) ||
	        (untilNodes && untilNodes.indexOf(elem) === -1) ||
	        (!untilNode && !untilNodes)) {
	        if (isTag(elem) && elems.indexOf(elem) === -1) {
	          elems.push(elem);
	        }
	      } else {
	        break;
	      }
	    }
	  });
	
	  return filterSelector ?
	    exports.filter.call(elems, filterSelector, this) :
	    this._make(elems);
	};
	
	exports.prev = function(selector) {
	  if (!this[0]) { return this; }
	  var elems = [];
	
	  _.forEach(this, function(elem) {
	    while ((elem = elem.prev)) {
	      if (isTag(elem)) {
	        elems.push(elem);
	        return;
	      }
	    }
	  });
	
	  return selector ?
	    exports.filter.call(elems, selector, this) :
	    this._make(elems);
	};
	
	exports.prevAll = function(selector) {
	  if (!this[0]) { return this; }
	  var elems = [];
	
	  _.forEach(this, function(elem) {
	    while ((elem = elem.prev)) {
	      if (isTag(elem) && elems.indexOf(elem) === -1) {
	        elems.push(elem);
	      }
	    }
	  });
	
	  return selector ?
	    exports.filter.call(elems, selector, this) :
	    this._make(elems);
	};
	
	exports.prevUntil = function(selector, filterSelector) {
	  if (!this[0]) { return this; }
	  var elems = [], untilNode, untilNodes;
	
	  if (typeof selector === 'string') {
	    untilNode = select(selector, this.prevAll().get(), this.options)[0];
	  } else if (selector && selector.cheerio) {
	    untilNodes = selector.get();
	  } else if (selector) {
	    untilNode = selector;
	  }
	
	  _.forEach(this, function(elem) {
	    while ((elem = elem.prev)) {
	      if ((untilNode && elem !== untilNode) ||
	        (untilNodes && untilNodes.indexOf(elem) === -1) ||
	        (!untilNode && !untilNodes)) {
	        if (isTag(elem) && elems.indexOf(elem) === -1) {
	          elems.push(elem);
	        }
	      } else {
	        break;
	      }
	    }
	  });
	
	  return filterSelector ?
	    exports.filter.call(elems, filterSelector, this) :
	    this._make(elems);
	};
	
	exports.siblings = function(selector) {
	  var parent = this.parent();
	
	  var elems = _.filter(
	    parent ? parent.children() : this.siblingsAndMe(),
	    _.bind(function(elem) { return isTag(elem) && !this.is(elem); }, this)
	  );
	
	  if (selector !== undefined) {
	    return exports.filter.call(elems, selector, this);
	  } else {
	    return this._make(elems);
	  }
	};
	
	exports.children = function(selector) {
	
	  var elems = _.reduce(this, function(memo, elem) {
	    return memo.concat(_.filter(elem.children, isTag));
	  }, []);
	
	  if (selector === undefined) return this._make(elems);
	
	  return exports.filter.call(elems, selector, this);
	};
	
	exports.contents = function() {
	  return this._make(_.reduce(this, function(all, elem) {
	    all.push.apply(all, elem.children);
	    return all;
	  }, []));
	};
	
	exports.each = function(fn) {
	  var i = 0, len = this.length;
	  while (i < len && fn.call(this[i], i, this[i]) !== false) ++i;
	  return this;
	};
	
	exports.map = function(fn) {
	  return this._make(_.reduce(this, function(memo, el, i) {
	    var val = fn.call(el, i, el);
	    return val == null ? memo : memo.concat(val);
	  }, []));
	};
	
	var makeFilterMethod = function(filterFn) {
	  return function(match, container) {
	    var testFn;
	    container = container || this;
	
	    if (typeof match === 'string') {
	      testFn = select.compile(match, container.options);
	    } else if (typeof match === 'function') {
	      testFn = function(el, i) {
	        return match.call(el, i, el);
	      };
	    } else if (match.cheerio) {
	      testFn = match.is.bind(match);
	    } else {
	      testFn = function(el) {
	        return match === el;
	      };
	    }
	
	    return container._make(filterFn(this, testFn));
	  };
	};
	
	exports.filter = makeFilterMethod(_.filter);
	exports.not = makeFilterMethod(_.reject);
	
	exports.has = function(selectorOrHaystack) {
	  var that = this;
	  return exports.filter.call(this, function() {
	    return that._make(this).find(selectorOrHaystack).length > 0;
	  });
	};
	
	exports.first = function() {
	  return this.length > 1 ? this._make(this[0]) : this;
	};
	
	exports.last = function() {
	  return this.length > 1 ? this._make(this[this.length - 1]) : this;
	};
	
	// Reduce the set of matched elements to the one at the specified index.
	exports.eq = function(i) {
	  i = +i;
	
	  // Use the first identity optimization if possible
	  if (i === 0 && this.length <= 1) return this;
	
	  if (i < 0) i = this.length + i;
	  return this[i] ? this._make(this[i]) : this._make([]);
	};
	
	// Retrieve the DOM elements matched by the jQuery object.
	exports.get = function(i) {
	  if (i == null) {
	    return Array.prototype.slice.call(this);
	  } else {
	    return this[i < 0 ? (this.length + i) : i];
	  }
	};
	
	// Search for a given element from among the matched elements.
	exports.index = function(selectorOrNeedle) {
	  var $haystack, needle;
	
	  if (arguments.length === 0) {
	    $haystack = this.parent().children();
	    needle = this[0];
	  } else if (typeof selectorOrNeedle === 'string') {
	    $haystack = this._make(selectorOrNeedle);
	    needle = this[0];
	  } else {
	    $haystack = this;
	    needle = selectorOrNeedle.cheerio ? selectorOrNeedle[0] : selectorOrNeedle;
	  }
	
	  return $haystack.get().indexOf(needle);
	};
	
	exports.slice = function() {
	  return this._make([].slice.apply(this, arguments));
	};
	
	function traverseParents(self, elem, selector, limit) {
	  var elems = [];
	  while (elem && elems.length < limit) {
	    if (!selector || exports.filter.call([elem], selector, self).length) {
	      elems.push(elem);
	    }
	    elem = elem.parent;
	  }
	  return elems;
	}
	
	// End the most recent filtering operation in the current chain and return the
	// set of matched elements to its previous state.
	exports.end = function() {
	  return this.prevObject || this._make([]);
	};
	
	exports.add = function(other, context) {
	  var selection = this._make(other, context);
	  var contents = uniqueSort(selection.get().concat(this.get()));
	
	  for (var i = 0; i < contents.length; ++i) {
	    selection[i] = contents[i];
	  }
	  selection.length = contents.length;
	
	  return selection;
	};
	
	// Add the previous set of elements on the stack to the current set, optionally
	// filtered by a selector.
	exports.addBack = function(selector) {
	  return this.add(
	    arguments.length ? this.prevObject.filter(selector) : this.prevObject
	  );
	};


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(560);
	var route = __webpack_require__(1031);
	
	var convert = {};
	
	var models = Object.keys(conversions);
	
	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			return fn(args);
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			var result = fn(args);
	
			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}
	
			return result;
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	models.forEach(function (fromModel) {
		convert[fromModel] = {};
	
		Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});
	
		var routes = route(fromModel);
		var routeModels = Object.keys(routes);
	
		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];
	
			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});
	
	module.exports = convert;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(560);
	
	/*
		this function routes a model to all other models.
	
		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).
	
		conversions that are not possible simply are not included.
	*/
	
	function buildGraph() {
		var graph = {};
		// https://jsperf.com/object-keys-vs-for-in-with-closure/3
		var models = Object.keys(conversions);
	
		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}
	
		return graph;
	}
	
	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop
	
		graph[fromModel].distance = 0;
	
		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);
	
			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];
	
				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}
	
		return graph;
	}
	
	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}
	
	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];
	
		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}
	
		fn.conversion = path;
		return fn;
	}
	
	module.exports = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};
	
		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];
	
			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}
	
			conversion[toModel] = wrapConversion(toModel, graph);
		}
	
		return conversion;
	};
	


/***/ }),
/* 1032 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1123);
	__webpack_require__(1125);
	__webpack_require__(1128);
	__webpack_require__(1124);
	__webpack_require__(1126);
	__webpack_require__(1127);
	module.exports = __webpack_require__(173).Promise;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(206);
	__webpack_require__(1074);
	module.exports = __webpack_require__(21).Array.from;


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(207);
	__webpack_require__(206);
	module.exports = __webpack_require__(1073);


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(21);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(299);
	__webpack_require__(206);
	__webpack_require__(207);
	__webpack_require__(1076);
	__webpack_require__(1089);
	__webpack_require__(1088);
	__webpack_require__(1087);
	module.exports = __webpack_require__(21).Map;


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1077);
	module.exports = __webpack_require__(21).Math.sign;


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1078);
	module.exports = 0x1fffffffffffff;


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1079);
	module.exports = __webpack_require__(21).Object.assign;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1080);
	var $Object = __webpack_require__(21).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1081);
	var $Object = __webpack_require__(21).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1090);
	module.exports = __webpack_require__(21).Object.entries;


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(402);
	module.exports = __webpack_require__(21).Object.getOwnPropertySymbols;


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1082);
	module.exports = __webpack_require__(21).Object.getPrototypeOf;


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1083);
	module.exports = __webpack_require__(21).Object.keys;


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1084);
	module.exports = __webpack_require__(21).Object.setPrototypeOf;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1091);
	module.exports = __webpack_require__(21).Object.values;


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(299);
	__webpack_require__(206);
	__webpack_require__(207);
	__webpack_require__(1085);
	__webpack_require__(1092);
	__webpack_require__(1093);
	module.exports = __webpack_require__(21).Promise;


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(402);
	module.exports = __webpack_require__(21).Symbol['for'];


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(402);
	__webpack_require__(299);
	__webpack_require__(1094);
	__webpack_require__(1095);
	module.exports = __webpack_require__(21).Symbol;


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(206);
	__webpack_require__(207);
	module.exports = __webpack_require__(400).f('iterator');


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(299);
	__webpack_require__(207);
	__webpack_require__(1086);
	__webpack_require__(1097);
	__webpack_require__(1096);
	module.exports = __webpack_require__(21).WeakMap;


/***/ }),
/* 1054 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(170);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(129);
	var toLength = __webpack_require__(296);
	var toAbsoluteIndex = __webpack_require__(1072);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(46);
	var isArray = __webpack_require__(565);
	var SPECIES = __webpack_require__(41)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(1057);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(58).f;
	var create = __webpack_require__(294);
	var redefineAll = __webpack_require__(295);
	var ctx = __webpack_require__(85);
	var anInstance = __webpack_require__(292);
	var forOf = __webpack_require__(170);
	var $iterDefine = __webpack_require__(391);
	var step = __webpack_require__(568);
	var setSpecies = __webpack_require__(580);
	var DESCRIPTORS = __webpack_require__(70);
	var fastKey = __webpack_require__(202).fastKey;
	var validate = __webpack_require__(298);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(386);
	var from = __webpack_require__(1055);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(295);
	var getWeak = __webpack_require__(202).getWeak;
	var anObject = __webpack_require__(57);
	var isObject = __webpack_require__(46);
	var anInstance = __webpack_require__(292);
	var forOf = __webpack_require__(170);
	var createArrayMethod = __webpack_require__(385);
	var $has = __webpack_require__(94);
	var validate = __webpack_require__(298);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(58);
	var createDesc = __webpack_require__(204);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(171);
	var gOPS = __webpack_require__(393);
	var pIE = __webpack_require__(203);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 1064 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(294);
	var descriptor = __webpack_require__(204);
	var setToStringTag = __webpack_require__(205);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(95)(IteratorPrototype, __webpack_require__(41)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 1066 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(40);
	var macrotask = __webpack_require__(582).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(200)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(58);
	var anObject = __webpack_require__(57);
	var getKeys = __webpack_require__(171);
	
	module.exports = __webpack_require__(70) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(129);
	var gOPN = __webpack_require__(571).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(46);
	var anObject = __webpack_require__(57);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(85)(Function.call, __webpack_require__(570).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(397);
	var defined = __webpack_require__(387);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(397);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(57);
	var get = __webpack_require__(401);
	module.exports = __webpack_require__(21).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(85);
	var $export = __webpack_require__(28);
	var toObject = __webpack_require__(172);
	var call = __webpack_require__(566);
	var isArrayIter = __webpack_require__(564);
	var toLength = __webpack_require__(296);
	var createProperty = __webpack_require__(1062);
	var getIterFn = __webpack_require__(401);
	
	$export($export.S + $export.F * !__webpack_require__(567)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(1054);
	var step = __webpack_require__(568);
	var Iterators = __webpack_require__(201);
	var toIObject = __webpack_require__(129);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(391)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(1059);
	var validate = __webpack_require__(298);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(561)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(28);
	
	$export($export.S, 'Math', { sign: __webpack_require__(1066) });


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(28);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(28);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(569) });


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(28);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(294) });


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(28);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(70), 'Object', { defineProperty: __webpack_require__(58).f });


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(172);
	var $getPrototypeOf = __webpack_require__(572);
	
	__webpack_require__(574)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(172);
	var $keys = __webpack_require__(171);
	
	__webpack_require__(574)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(28);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1070).set });


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(293);
	var global = __webpack_require__(40);
	var ctx = __webpack_require__(85);
	var classof = __webpack_require__(386);
	var $export = __webpack_require__(28);
	var isObject = __webpack_require__(46);
	var aFunction = __webpack_require__(199);
	var anInstance = __webpack_require__(292);
	var forOf = __webpack_require__(170);
	var speciesConstructor = __webpack_require__(581);
	var task = __webpack_require__(582).set;
	var microtask = __webpack_require__(1067)();
	var newPromiseCapabilityModule = __webpack_require__(392);
	var perform = __webpack_require__(576);
	var promiseResolve = __webpack_require__(577);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(41)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(295)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(205)($Promise, PROMISE);
	__webpack_require__(580)(PROMISE);
	Wrapper = __webpack_require__(21)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(567)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(385)(0);
	var redefine = __webpack_require__(394);
	var meta = __webpack_require__(202);
	var assign = __webpack_require__(569);
	var weak = __webpack_require__(1061);
	var isObject = __webpack_require__(46);
	var fails = __webpack_require__(93);
	var validate = __webpack_require__(298);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(561)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(578)('Map');


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(579)('Map');


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(28);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(1060)('Map') });


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(28);
	var $entries = __webpack_require__(575)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(28);
	var $values = __webpack_require__(575)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(28);
	var core = __webpack_require__(21);
	var global = __webpack_require__(40);
	var speciesConstructor = __webpack_require__(581);
	var promiseResolve = __webpack_require__(577);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(28);
	var newPromiseCapability = __webpack_require__(392);
	var perform = __webpack_require__(576);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(399)('asyncIterator');


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(399)('observable');


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(578)('WeakMap');


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(579)('WeakMap');


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(47)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(174)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 1099 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(410);
	var toLength = __webpack_require__(595);
	var toAbsoluteIndex = __webpack_require__(1118);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(302);
	var call = __webpack_require__(1106);
	var isArrayIter = __webpack_require__(1105);
	var anObject = __webpack_require__(130);
	var toLength = __webpack_require__(595);
	var getIterFn = __webpack_require__(1121);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(208) && !__webpack_require__(584)(function () {
	  return Object.defineProperty(__webpack_require__(405)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 1103 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(301);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(210);
	var ITERATOR = __webpack_require__(47)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(130);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(1111);
	var descriptor = __webpack_require__(591);
	var setToStringTag = __webpack_require__(407);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(174)(IteratorPrototype, __webpack_require__(47)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(47)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 1109 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(52);
	var macrotask = __webpack_require__(594).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(301)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(130);
	var dPs = __webpack_require__(1112);
	var enumBugKeys = __webpack_require__(583);
	var IE_PROTO = __webpack_require__(408)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(405)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(585).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(305);
	var anObject = __webpack_require__(130);
	var getKeys = __webpack_require__(588);
	
	module.exports = __webpack_require__(208) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(304);
	var toObject = __webpack_require__(1119);
	var IE_PROTO = __webpack_require__(408)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(304);
	var toIObject = __webpack_require__(410);
	var arrayIndexOf = __webpack_require__(1100)(false);
	var IE_PROTO = __webpack_require__(408)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(211);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(52);
	var dP = __webpack_require__(305);
	var DESCRIPTORS = __webpack_require__(208);
	var SPECIES = __webpack_require__(47)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(409);
	var defined = __webpack_require__(404);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(409);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(404);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(209);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(403);
	var ITERATOR = __webpack_require__(47)('iterator');
	var Iterators = __webpack_require__(210);
	module.exports = __webpack_require__(173).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(1098);
	var step = __webpack_require__(1109);
	var Iterators = __webpack_require__(210);
	var toIObject = __webpack_require__(410);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(586)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(403);
	var test = {};
	test[__webpack_require__(47)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(211)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(587);
	var global = __webpack_require__(52);
	var ctx = __webpack_require__(302);
	var classof = __webpack_require__(403);
	var $export = __webpack_require__(303);
	var isObject = __webpack_require__(209);
	var aFunction = __webpack_require__(300);
	var anInstance = __webpack_require__(1099);
	var forOf = __webpack_require__(1101);
	var speciesConstructor = __webpack_require__(593);
	var task = __webpack_require__(594).set;
	var microtask = __webpack_require__(1110)();
	var newPromiseCapabilityModule = __webpack_require__(406);
	var perform = __webpack_require__(589);
	var promiseResolve = __webpack_require__(590);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(47)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(1115)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(407)($Promise, PROMISE);
	__webpack_require__(1116)(PROMISE);
	Wrapper = __webpack_require__(173)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(1108)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(1117)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(586)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(303);
	var core = __webpack_require__(173);
	var global = __webpack_require__(52);
	var speciesConstructor = __webpack_require__(593);
	var promiseResolve = __webpack_require__(590);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(303);
	var newPromiseCapability = __webpack_require__(406);
	var perform = __webpack_require__(589);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(1122);
	var getKeys = __webpack_require__(588);
	var redefine = __webpack_require__(211);
	var global = __webpack_require__(52);
	var hide = __webpack_require__(174);
	var Iterators = __webpack_require__(210);
	var wks = __webpack_require__(47);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(33);
	
	var emptyObject = __webpack_require__(176);
	var _invariant = __webpack_require__(134);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		compiles a selector to an executable function
	*/
	
	module.exports = compile;
	module.exports.compileUnsafe = compileUnsafe;
	module.exports.compileToken = compileToken;
	
	var parse       = __webpack_require__(1140),
	    DomUtils    = __webpack_require__(214),
	    isTag       = DomUtils.isTag,
	    Rules       = __webpack_require__(1131),
	    sortRules   = __webpack_require__(1132),
	    BaseFuncs   = __webpack_require__(197),
	    trueFunc    = BaseFuncs.trueFunc,
	    falseFunc   = BaseFuncs.falseFunc,
	    procedure   = __webpack_require__(634);
	
	function compile(selector, options, context){
		var next = compileUnsafe(selector, options, context);
		return wrap(next);
	}
	
	function wrap(next){
		return function base(elem){
			return isTag(elem) && next(elem);
		};
	}
	
	function compileUnsafe(selector, options, context){
		var token = parse(selector, options);
		return compileToken(token, options, context);
	}
	
	function includesScopePseudo(t){
	    return t.type === "pseudo" && (
	        t.name === "scope" || (
	            Array.isArray(t.data) &&
	            t.data.some(function(data){
	                return data.some(includesScopePseudo);
	            })
	        )
	    );
	}
	
	var DESCENDANT_TOKEN = {type: "descendant"},
	    SCOPE_TOKEN = {type: "pseudo", name: "scope"},
	    PLACEHOLDER_ELEMENT = {},
	    getParent = DomUtils.getParent;
	
	//CSS 4 Spec (Draft): 3.3.1. Absolutizing a Scope-relative Selector
	//http://www.w3.org/TR/selectors4/#absolutizing
	function absolutize(token, context){
	    //TODO better check if context is document
	    var hasContext = !!context && !!context.length && context.every(function(e){
	        return e === PLACEHOLDER_ELEMENT || !!getParent(e);
	    });
	
	
	    token.forEach(function(t){
	        if(t.length > 0 && isTraversal(t[0]) && t[0].type !== "descendant"){
	            //don't return in else branch
	        } else if(hasContext && !includesScopePseudo(t)){
	            t.unshift(DESCENDANT_TOKEN);
	        } else {
	            return;
	        }
	
	        t.unshift(SCOPE_TOKEN);
	    });
	}
	
	function compileToken(token, options, context){
	    token = token.filter(function(t){ return t.length > 0; });
	
		token.forEach(sortRules);
	
		var isArrayContext = Array.isArray(context);
	
	    context = (options && options.context) || context;
	
	    if(context && !isArrayContext) context = [context];
	
	    absolutize(token, context);
	
		return token
			.map(function(rules){ return compileRules(rules, options, context, isArrayContext); })
			.reduce(reduceRules, falseFunc);
	}
	
	function isTraversal(t){
		return procedure[t.type] < 0;
	}
	
	function compileRules(rules, options, context, isArrayContext){
		var acceptSelf = (isArrayContext && rules[0].name === "scope" && rules[1].type === "descendant");
		return rules.reduce(function(func, rule, index){
			if(func === falseFunc) return func;
			return Rules[rule.type](func, rule, options, context, acceptSelf && index === 1);
		}, options && options.rootFunc || trueFunc);
	}
	
	function reduceRules(a, b){
		if(b === falseFunc || a === trueFunc){
			return a;
		}
		if(a === falseFunc || b === trueFunc){
			return b;
		}
	
		return function combine(elem){
			return a(elem) || b(elem);
		};
	}
	
	//:not, :has and :matches have to compile selectors
	//doing this in lib/pseudos.js would lead to circular dependencies,
	//so we add them here
	
	var Pseudos     = __webpack_require__(412),
	    filters     = Pseudos.filters,
	    existsOne   = DomUtils.existsOne,
	    isTag       = DomUtils.isTag,
	    getChildren = DomUtils.getChildren;
	
	
	function containsTraversal(t){
		return t.some(isTraversal);
	}
	
	filters.not = function(next, token, options, context){
		var opts = {
		    	xmlMode: !!(options && options.xmlMode),
		    	strict: !!(options && options.strict)
		    };
	
		if(opts.strict){
			if(token.length > 1 || token.some(containsTraversal)){
				throw new SyntaxError("complex selectors in :not aren't allowed in strict mode");
			}
		}
	
	    var func = compileToken(token, opts, context);
	
		if(func === falseFunc) return next;
		if(func === trueFunc)  return falseFunc;
	
		return function(elem){
			return !func(elem) && next(elem);
		};
	};
	
	filters.has = function(next, token, options){
		var opts = {
			xmlMode: !!(options && options.xmlMode),
			strict: !!(options && options.strict)
		};
	
	    //FIXME: Uses an array as a pointer to the current element (side effects)
	    var context = token.some(containsTraversal) ? [PLACEHOLDER_ELEMENT] : null;
	
		var func = compileToken(token, opts, context);
	
		if(func === falseFunc) return falseFunc;
		if(func === trueFunc)  return function(elem){
				return getChildren(elem).some(isTag) && next(elem);
			};
	
		func = wrap(func);
	
	    if(context){
	        return function has(elem){
			return next(elem) && (
	                (context[0] = elem), existsOne(func, getChildren(elem))
	            );
		};
	    }
	
	    return function has(elem){
			return next(elem) && existsOne(func, getChildren(elem));
		};
	};
	
	filters.matches = function(next, token, options, context){
		var opts = {
			xmlMode: !!(options && options.xmlMode),
			strict: !!(options && options.strict),
			rootFunc: next
		};
	
		return compileToken(token, opts, context);
	};


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	var DomUtils    = __webpack_require__(214),
	    isTag       = DomUtils.isTag,
	    getParent   = DomUtils.getParent,
	    getChildren = DomUtils.getChildren,
	    getSiblings = DomUtils.getSiblings,
	    getName     = DomUtils.getName;
	
	/*
		all available rules
	*/
	module.exports = {
		__proto__: null,
	
		attribute: __webpack_require__(597).compile,
		pseudo: __webpack_require__(412).compile,
	
		//tags
		tag: function(next, data){
			var name = data.name;
			return function tag(elem){
				return getName(elem) === name && next(elem);
			};
		},
	
		//traversal
		descendant: function(next, rule, options, context, acceptSelf){
			return function descendant(elem){
	
				if (acceptSelf && next(elem)) return true;
	
				var found = false;
	
				while(!found && (elem = getParent(elem))){
					found = next(elem);
				}
	
				return found;
			};
		},
		parent: function(next, data, options){
			if(options && options.strict) throw SyntaxError("Parent selector isn't part of CSS3");
	
			return function parent(elem){
				return getChildren(elem).some(test);
			};
	
			function test(elem){
				return isTag(elem) && next(elem);
			}
		},
		child: function(next){
			return function child(elem){
				var parent = getParent(elem);
				return !!parent && next(parent);
			};
		},
		sibling: function(next){
			return function sibling(elem){
				var siblings = getSiblings(elem);
	
				for(var i = 0; i < siblings.length; i++){
					if(isTag(siblings[i])){
						if(siblings[i] === elem) break;
						if(next(siblings[i])) return true;
					}
				}
	
				return false;
			};
		},
		adjacent: function(next){
			return function adjacent(elem){
				var siblings = getSiblings(elem),
				    lastElement;
	
				for(var i = 0; i < siblings.length; i++){
					if(isTag(siblings[i])){
						if(siblings[i] === elem) break;
						lastElement = siblings[i];
					}
				}
	
				return !!lastElement && next(lastElement);
			};
		},
		universal: function(next){
			return next;
		}
	};

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = sortByProcedure;
	
	/*
		sort the parts of the passed selector,
		as there is potential for optimization
		(some types of selectors are faster than others)
	*/
	
	var procedure = __webpack_require__(634);
	
	var attributes = {
		__proto__: null,
		exists: 10,
		equals: 8,
		not: 7,
		start: 6,
		end: 6,
		any: 5,
		hyphen: 4,
		element: 4
	};
	
	function sortByProcedure(arr){
		var procs = arr.map(getProcedure);
		for(var i = 1; i < arr.length; i++){
			var procNew = procs[i];
	
			if(procNew < 0) continue;
	
			for(var j = i - 1; j >= 0 && procNew < procs[j]; j--){
				var token = arr[j + 1];
				arr[j + 1] = arr[j];
				arr[j] = token;
				procs[j + 1] = procs[j];
				procs[j] = procNew;
			}
		}
	}
	
	function getProcedure(token){
		var proc = procedure[token.type];
	
		if(proc === procedure.attribute){
			proc = attributes[token.action];
	
			if(proc === attributes.equals && token.name === "id"){
				//prefer ID selectors (eg. #ID)
				proc = 9;
			}
	
			if(token.ignoreCase){
				//ignoreCase adds some overhead, prefer "normal" token
				//this is a binary operation, to ensure it's still an int
				proc >>= 1;
			}
		} else if(proc === procedure.pseudo){
			if(!token.data){
				proc = 3;
			} else if(token.name === "has" || token.name === "contains"){
				proc = 0; //expensive in any case
			} else if(token.name === "matches" || token.name === "not"){
				proc = 0;
				for(var i = 0; i < token.data.length; i++){
					//TODO better handling of complex selectors
					if(token.data[i].length !== 1) continue;
					var cur = getProcedure(token.data[i][0]);
					//avoid executing :has or :contains
					if(cur === 0){
						proc = 0;
						break;
					}
					if(cur > proc) proc = cur;
				}
				if(token.data.length > 1 && proc > 0) proc -= 1;
			} else {
				proc = 1;
			}
		}
		return proc;
	}


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	var DomUtils = module.exports;
	
	[
		__webpack_require__(1138),
		__webpack_require__(1139),
		__webpack_require__(1136),
		__webpack_require__(1137),
		__webpack_require__(1135),
		__webpack_require__(1134)
	].forEach(function(ext){
		Object.keys(ext).forEach(function(key){
			DomUtils[key] = ext[key].bind(DomUtils);
		});
	});


/***/ }),
/* 1134 */
/***/ (function(module, exports) {

	// removeSubsets
	// Given an array of nodes, remove any member that is contained by another.
	exports.removeSubsets = function(nodes) {
		var idx = nodes.length, node, ancestor, replace;
	
		// Check if each node (or one of its ancestors) is already contained in the
		// array.
		while (--idx > -1) {
			node = ancestor = nodes[idx];
	
			// Temporarily remove the node under consideration
			nodes[idx] = null;
			replace = true;
	
			while (ancestor) {
				if (nodes.indexOf(ancestor) > -1) {
					replace = false;
					nodes.splice(idx, 1);
					break;
				}
				ancestor = ancestor.parent;
			}
	
			// If the node has been found to be unique, re-insert it.
			if (replace) {
				nodes[idx] = node;
			}
		}
	
		return nodes;
	};
	
	// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
	var POSITION = {
		DISCONNECTED: 1,
		PRECEDING: 2,
		FOLLOWING: 4,
		CONTAINS: 8,
		CONTAINED_BY: 16
	};
	
	// Compare the position of one node against another node in any other document.
	// The return value is a bitmask with the following values:
	//
	// document order:
	// > There is an ordering, document order, defined on all the nodes in the
	// > document corresponding to the order in which the first character of the
	// > XML representation of each node occurs in the XML representation of the
	// > document after expansion of general entities. Thus, the document element
	// > node will be the first node. Element nodes occur before their children.
	// > Thus, document order orders element nodes in order of the occurrence of
	// > their start-tag in the XML (after expansion of entities). The attribute
	// > nodes of an element occur after the element and before its children. The
	// > relative order of attribute nodes is implementation-dependent./
	// Source:
	// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
	//
	// @argument {Node} nodaA The first node to use in the comparison
	// @argument {Node} nodeB The second node to use in the comparison
	//
	// @return {Number} A bitmask describing the input nodes' relative position.
	//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
	//         a description of these values.
	var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
		var aParents = [];
		var bParents = [];
		var current, sharedParent, siblings, aSibling, bSibling, idx;
	
		if (nodeA === nodeB) {
			return 0;
		}
	
		current = nodeA;
		while (current) {
			aParents.unshift(current);
			current = current.parent;
		}
		current = nodeB;
		while (current) {
			bParents.unshift(current);
			current = current.parent;
		}
	
		idx = 0;
		while (aParents[idx] === bParents[idx]) {
			idx++;
		}
	
		if (idx === 0) {
			return POSITION.DISCONNECTED;
		}
	
		sharedParent = aParents[idx - 1];
		siblings = sharedParent.children;
		aSibling = aParents[idx];
		bSibling = bParents[idx];
	
		if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
			if (sharedParent === nodeB) {
				return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
			}
			return POSITION.FOLLOWING;
		} else {
			if (sharedParent === nodeA) {
				return POSITION.PRECEDING | POSITION.CONTAINS;
			}
			return POSITION.PRECEDING;
		}
	};
	
	// Sort an array of nodes based on their relative position in the document and
	// remove any duplicate nodes. If the array contains nodes that do not belong
	// to the same document, sort order is unspecified.
	//
	// @argument {Array} nodes Array of DOM nodes
	//
	// @returns {Array} collection of unique nodes, sorted in document order
	exports.uniqueSort = function(nodes) {
		var idx = nodes.length, node, position;
	
		nodes = nodes.slice();
	
		while (--idx > -1) {
			node = nodes[idx];
			position = nodes.indexOf(node);
			if (position > -1 && position < idx) {
				nodes.splice(idx, 1);
			}
		}
		nodes.sort(function(a, b) {
			var relative = comparePos(a, b);
			if (relative & POSITION.PRECEDING) {
				return -1;
			} else if (relative & POSITION.FOLLOWING) {
				return 1;
			}
			return 0;
		});
	
		return nodes;
	};


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(98);
	var isTag = exports.isTag = ElementType.isTag;
	
	exports.testElement = function(options, element){
		for(var key in options){
			if(!options.hasOwnProperty(key));
			else if(key === "tag_name"){
				if(!isTag(element) || !options.tag_name(element.name)){
					return false;
				}
			} else if(key === "tag_type"){
				if(!options.tag_type(element.type)) return false;
			} else if(key === "tag_contains"){
				if(isTag(element) || !options.tag_contains(element.data)){
					return false;
				}
			} else if(!element.attribs || !options[key](element.attribs[key])){
				return false;
			}
		}
		return true;
	};
	
	var Checks = {
		tag_name: function(name){
			if(typeof name === "function"){
				return function(elem){ return isTag(elem) && name(elem.name); };
			} else if(name === "*"){
				return isTag;
			} else {
				return function(elem){ return isTag(elem) && elem.name === name; };
			}
		},
		tag_type: function(type){
			if(typeof type === "function"){
				return function(elem){ return type(elem.type); };
			} else {
				return function(elem){ return elem.type === type; };
			}
		},
		tag_contains: function(data){
			if(typeof data === "function"){
				return function(elem){ return !isTag(elem) && data(elem.data); };
			} else {
				return function(elem){ return !isTag(elem) && elem.data === data; };
			}
		}
	};
	
	function getAttribCheck(attrib, value){
		if(typeof value === "function"){
			return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
		} else {
			return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
		}
	}
	
	function combineFuncs(a, b){
		return function(elem){
			return a(elem) || b(elem);
		};
	}
	
	exports.getElements = function(options, element, recurse, limit){
		var funcs = Object.keys(options).map(function(key){
			var value = options[key];
			return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
		});
	
		return funcs.length === 0 ? [] : this.filter(
			funcs.reduce(combineFuncs),
			element, recurse, limit
		);
	};
	
	exports.getElementById = function(id, element, recurse){
		if(!Array.isArray(element)) element = [element];
		return this.findOne(getAttribCheck("id", id), element, recurse !== false);
	};
	
	exports.getElementsByTagName = function(name, element, recurse, limit){
		return this.filter(Checks.tag_name(name), element, recurse, limit);
	};
	
	exports.getElementsByTagType = function(type, element, recurse, limit){
		return this.filter(Checks.tag_type(type), element, recurse, limit);
	};


/***/ }),
/* 1136 */
/***/ (function(module, exports) {

	exports.removeElement = function(elem){
		if(elem.prev) elem.prev.next = elem.next;
		if(elem.next) elem.next.prev = elem.prev;
	
		if(elem.parent){
			var childs = elem.parent.children;
			childs.splice(childs.lastIndexOf(elem), 1);
		}
	};
	
	exports.replaceElement = function(elem, replacement){
		var prev = replacement.prev = elem.prev;
		if(prev){
			prev.next = replacement;
		}
	
		var next = replacement.next = elem.next;
		if(next){
			next.prev = replacement;
		}
	
		var parent = replacement.parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs[childs.lastIndexOf(elem)] = replacement;
		}
	};
	
	exports.appendChild = function(elem, child){
		child.parent = elem;
	
		if(elem.children.push(child) !== 1){
			var sibling = elem.children[elem.children.length - 2];
			sibling.next = child;
			child.prev = sibling;
			child.next = null;
		}
	};
	
	exports.append = function(elem, next){
		var parent = elem.parent,
			currNext = elem.next;
	
		next.next = currNext;
		next.prev = elem;
		elem.next = next;
		next.parent = parent;
	
		if(currNext){
			currNext.prev = next;
			if(parent){
				var childs = parent.children;
				childs.splice(childs.lastIndexOf(currNext), 0, next);
			}
		} else if(parent){
			parent.children.push(next);
		}
	};
	
	exports.prepend = function(elem, prev){
		var parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(elem), 0, prev);
		}
	
		if(elem.prev){
			elem.prev.next = prev;
		}
		
		prev.parent = parent;
		prev.prev = elem.prev;
		prev.next = elem;
		elem.prev = prev;
	};
	
	


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	var isTag = __webpack_require__(98).isTag;
	
	module.exports = {
		filter: filter,
		find: find,
		findOneChild: findOneChild,
		findOne: findOne,
		existsOne: existsOne,
		findAll: findAll
	};
	
	function filter(test, element, recurse, limit){
		if(!Array.isArray(element)) element = [element];
	
		if(typeof limit !== "number" || !isFinite(limit)){
			limit = Infinity;
		}
		return find(test, element, recurse !== false, limit);
	}
	
	function find(test, elems, recurse, limit){
		var result = [], childs;
	
		for(var i = 0, j = elems.length; i < j; i++){
			if(test(elems[i])){
				result.push(elems[i]);
				if(--limit <= 0) break;
			}
	
			childs = elems[i].children;
			if(recurse && childs && childs.length > 0){
				childs = find(test, childs, recurse, limit);
				result = result.concat(childs);
				limit -= childs.length;
				if(limit <= 0) break;
			}
		}
	
		return result;
	}
	
	function findOneChild(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(test(elems[i])) return elems[i];
		}
	
		return null;
	}
	
	function findOne(test, elems){
		var elem = null;
	
		for(var i = 0, l = elems.length; i < l && !elem; i++){
			if(!isTag(elems[i])){
				continue;
			} else if(test(elems[i])){
				elem = elems[i];
			} else if(elems[i].children.length > 0){
				elem = findOne(test, elems[i].children);
			}
		}
	
		return elem;
	}
	
	function existsOne(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(
				isTag(elems[i]) && (
					test(elems[i]) || (
						elems[i].children.length > 0 &&
						existsOne(test, elems[i].children)
					)
				)
			){
				return true;
			}
		}
	
		return false;
	}
	
	function findAll(test, elems){
		var result = [];
		for(var i = 0, j = elems.length; i < j; i++){
			if(!isTag(elems[i])) continue;
			if(test(elems[i])) result.push(elems[i]);
	
			if(elems[i].children.length > 0){
				result = result.concat(findAll(test, elems[i].children));
			}
		}
		return result;
	}


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(98),
	    getOuterHTML = __webpack_require__(311),
	    isTag = ElementType.isTag;
	
	module.exports = {
		getInnerHTML: getInnerHTML,
		getOuterHTML: getOuterHTML,
		getText: getText
	};
	
	function getInnerHTML(elem, opts){
		return elem.children ? elem.children.map(function(elem){
			return getOuterHTML(elem, opts);
		}).join("") : "";
	}
	
	function getText(elem){
		if(Array.isArray(elem)) return elem.map(getText).join("");
		if(isTag(elem) || elem.type === ElementType.CDATA) return getText(elem.children);
		if(elem.type === ElementType.Text) return elem.data;
		return "";
	}


/***/ }),
/* 1139 */
/***/ (function(module, exports) {

	var getChildren = exports.getChildren = function(elem){
		return elem.children;
	};
	
	var getParent = exports.getParent = function(elem){
		return elem.parent;
	};
	
	exports.getSiblings = function(elem){
		var parent = getParent(elem);
		return parent ? getChildren(parent) : [elem];
	};
	
	exports.getAttributeValue = function(elem, name){
		return elem.attribs && elem.attribs[name];
	};
	
	exports.hasAttrib = function(elem, name){
		return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
	};
	
	exports.getName = function(elem){
		return elem.name;
	};


/***/ }),
/* 1140 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = parse;
	
	var re_name = /^(?:\\.|[\w\-\u00c0-\uFFFF])+/,
	    re_escape = /\\([\da-f]{1,6}\s?|(\s)|.)/ig,
	    //modified version of https://github.com/jquery/sizzle/blob/master/src/sizzle.js#L87
	    re_attr = /^\s*((?:\\.|[\w\u00c0-\uFFFF\-])+)\s*(?:(\S?)=\s*(?:(['"])(.*?)\3|(#?(?:\\.|[\w\u00c0-\uFFFF\-])*)|)|)\s*(i)?\]/;
	
	var actionTypes = {
		__proto__: null,
		"undefined": "exists",
		"":  "equals",
		"~": "element",
		"^": "start",
		"$": "end",
		"*": "any",
		"!": "not",
		"|": "hyphen"
	};
	
	var simpleSelectors = {
		__proto__: null,
		">": "child",
		"<": "parent",
		"~": "sibling",
		"+": "adjacent"
	};
	
	var attribSelectors = {
		__proto__: null,
		"#": ["id", "equals"],
		".": ["class", "element"]
	};
	
	//pseudos, whose data-property is parsed as well
	var unpackPseudos = {
		__proto__: null,
		"has": true,
		"not": true,
		"matches": true
	};
	
	var stripQuotesFromPseudos = {
		__proto__: null,
		"contains": true,
		"icontains": true
	};
	
	var quotes = {
		__proto__: null,
		"\"": true,
		"'": true
	};
	
	//unescape function taken from https://github.com/jquery/sizzle/blob/master/src/sizzle.js#L139
	function funescape( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			// BMP codepoint
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	}
	
	function unescapeCSS(str){
		return str.replace(re_escape, funescape);
	}
	
	function isWhitespace(c){
		return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
	}
	
	function parse(selector, options){
		var subselects = [];
	
		selector = parseSelector(subselects, selector + "", options);
	
		if(selector !== ""){
			throw new SyntaxError("Unmatched selector: " + selector);
		}
	
		return subselects;
	}
	
	function parseSelector(subselects, selector, options){
		var tokens = [],
			sawWS = false,
			data, firstChar, name, quot;
	
		function getName(){
			var sub = selector.match(re_name)[0];
			selector = selector.substr(sub.length);
			return unescapeCSS(sub);
		}
	
		function stripWhitespace(start){
			while(isWhitespace(selector.charAt(start))) start++;
			selector = selector.substr(start);
		}
	
		stripWhitespace(0);
	
		while(selector !== ""){
			firstChar = selector.charAt(0);
	
			if(isWhitespace(firstChar)){
				sawWS = true;
				stripWhitespace(1);
			} else if(firstChar in simpleSelectors){
				tokens.push({type: simpleSelectors[firstChar]});
				sawWS = false;
	
				stripWhitespace(1);
			} else if(firstChar === ","){
				if(tokens.length === 0){
					throw new SyntaxError("empty sub-selector");
				}
				subselects.push(tokens);
				tokens = [];
				sawWS = false;
				stripWhitespace(1);
			} else {
				if(sawWS){
					if(tokens.length > 0){
						tokens.push({type: "descendant"});
					}
					sawWS = false;
				}
	
				if(firstChar === "*"){
					selector = selector.substr(1);
					tokens.push({type: "universal"});
				} else if(firstChar in attribSelectors){
					selector = selector.substr(1);
					tokens.push({
						type: "attribute",
						name: attribSelectors[firstChar][0],
						action: attribSelectors[firstChar][1],
						value: getName(),
						ignoreCase: false
					});
				} else if(firstChar === "["){
					selector = selector.substr(1);
					data = selector.match(re_attr);
					if(!data){
						throw new SyntaxError("Malformed attribute selector: " + selector);
					}
					selector = selector.substr(data[0].length);
					name = unescapeCSS(data[1]);
	
					if(
						!options || (
							"lowerCaseAttributeNames" in options ?
								options.lowerCaseAttributeNames :
								!options.xmlMode
						)
					){
						name = name.toLowerCase();
					}
	
					tokens.push({
						type: "attribute",
						name: name,
						action: actionTypes[data[2]],
						value: unescapeCSS(data[4] || data[5] || ""),
						ignoreCase: !!data[6]
					});
	
				} else if(firstChar === ":"){
					if(selector.charAt(1) === ":"){
						selector = selector.substr(2);
						tokens.push({type: "pseudo-element", name: getName().toLowerCase()});
						continue;
					}
	
					selector = selector.substr(1);
	
					name = getName().toLowerCase();
					data = null;
	
					if(selector.charAt(0) === "("){
						if(name in unpackPseudos){
							quot = selector.charAt(1);
							var quoted = quot in quotes;
	
							selector = selector.substr(quoted + 1);
	
							data = [];
							selector = parseSelector(data, selector, options);
	
							if(quoted){
								if(selector.charAt(0) !== quot){
									throw new SyntaxError("unmatched quotes in :" + name);
								} else {
									selector = selector.substr(1);
								}
							}
	
							if(selector.charAt(0) !== ")"){
								throw new SyntaxError("missing closing parenthesis in :" + name + " " + selector);
							}
	
							selector = selector.substr(1);
						} else {
							var pos = 1, counter = 1;
	
							for(; counter > 0 && pos < selector.length; pos++){
								if(selector.charAt(pos) === "(") counter++;
								else if(selector.charAt(pos) === ")") counter--;
							}
	
							if(counter){
								throw new SyntaxError("parenthesis not matched");
							}
	
							data = selector.substr(1, pos - 2);
							selector = selector.substr(pos);
	
							if(name in stripQuotesFromPseudos){
								quot = data.charAt(0);
	
								if(quot === data.slice(-1) && quot in quotes){
									data = data.slice(1, -1);
								}
	
								data = unescapeCSS(data);
							}
						}
					}
	
					tokens.push({type: "pseudo", name: name, data: data});
				} else if(re_name.test(selector)){
					name = getName();
	
					if(!options || ("lowerCaseTags" in options ? options.lowerCaseTags : !options.xmlMode)){
						name = name.toLowerCase();
					}
	
					tokens.push({type: "tag", name: name});
				} else {
					if(tokens.length && tokens[tokens.length - 1].type === "descendant"){
						tokens.pop();
					}
					addToken(subselects, tokens);
					return selector;
				}
			}
		}
	
		addToken(subselects, tokens);
	
		return selector;
	}
	
	function addToken(subselects, tokens){
		if(subselects.length > 0 && tokens.length === 0){
			throw new SyntaxError("empty sub-selector");
		}
	
		subselects.push(tokens);
	}


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 */
	function setup(env) {
	  createDebug.debug = createDebug;
	  createDebug.default = createDebug;
	  createDebug.coerce = coerce;
	  createDebug.disable = disable;
	  createDebug.enable = enable;
	  createDebug.enabled = enabled;
	  createDebug.humanize = __webpack_require__(4351);
	  Object.keys(env).forEach(function (key) {
	    createDebug[key] = env[key];
	  });
	  /**
	  * Active `debug` instances.
	  */
	
	  createDebug.instances = [];
	  /**
	  * The currently active debug mode names, and names to skip.
	  */
	
	  createDebug.names = [];
	  createDebug.skips = [];
	  /**
	  * Map of special "%n" handling functions, for the debug "format" argument.
	  *
	  * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	  */
	
	  createDebug.formatters = {};
	  /**
	  * Selects a color for a debug namespace
	  * @param {String} namespace The namespace string for the for the debug instance to be colored
	  * @return {Number|String} An ANSI color code for the given namespace
	  * @api private
	  */
	
	  function selectColor(namespace) {
	    var hash = 0;
	
	    for (var i = 0; i < namespace.length; i++) {
	      hash = (hash << 5) - hash + namespace.charCodeAt(i);
	      hash |= 0; // Convert to 32bit integer
	    }
	
	    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
	  }
	
	  createDebug.selectColor = selectColor;
	  /**
	  * Create a debugger with the given `namespace`.
	  *
	  * @param {String} namespace
	  * @return {Function}
	  * @api public
	  */
	
	  function createDebug(namespace) {
	    var prevTime;
	
	    function debug() {
	      // Disabled?
	      if (!debug.enabled) {
	        return;
	      }
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var self = debug; // Set `diff` timestamp
	
	      var curr = Number(new Date());
	      var ms = curr - (prevTime || curr);
	      self.diff = ms;
	      self.prev = prevTime;
	      self.curr = curr;
	      prevTime = curr;
	      args[0] = createDebug.coerce(args[0]);
	
	      if (typeof args[0] !== 'string') {
	        // Anything else let's inspect with %O
	        args.unshift('%O');
	      } // Apply any `formatters` transformations
	
	
	      var index = 0;
	      args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
	        // If we encounter an escaped % then don't increase the array index
	        if (match === '%%') {
	          return match;
	        }
	
	        index++;
	        var formatter = createDebug.formatters[format];
	
	        if (typeof formatter === 'function') {
	          var val = args[index];
	          match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`
	
	          args.splice(index, 1);
	          index--;
	        }
	
	        return match;
	      }); // Apply env-specific formatting (colors, etc.)
	
	      createDebug.formatArgs.call(self, args);
	      var logFn = self.log || createDebug.log;
	      logFn.apply(self, args);
	    }
	
	    debug.namespace = namespace;
	    debug.enabled = createDebug.enabled(namespace);
	    debug.useColors = createDebug.useColors();
	    debug.color = selectColor(namespace);
	    debug.destroy = destroy;
	    debug.extend = extend; // Debug.formatArgs = formatArgs;
	    // debug.rawLog = rawLog;
	    // env-specific initialization logic for debug instances
	
	    if (typeof createDebug.init === 'function') {
	      createDebug.init(debug);
	    }
	
	    createDebug.instances.push(debug);
	    return debug;
	  }
	
	  function destroy() {
	    var index = createDebug.instances.indexOf(this);
	
	    if (index !== -1) {
	      createDebug.instances.splice(index, 1);
	      return true;
	    }
	
	    return false;
	  }
	
	  function extend(namespace, delimiter) {
	    return createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
	  }
	  /**
	  * Enables a debug mode by namespaces. This can include modes
	  * separated by a colon and wildcards.
	  *
	  * @param {String} namespaces
	  * @api public
	  */
	
	
	  function enable(namespaces) {
	    createDebug.save(namespaces);
	    createDebug.names = [];
	    createDebug.skips = [];
	    var i;
	    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	    var len = split.length;
	
	    for (i = 0; i < len; i++) {
	      if (!split[i]) {
	        // ignore empty strings
	        continue;
	      }
	
	      namespaces = split[i].replace(/\*/g, '.*?');
	
	      if (namespaces[0] === '-') {
	        createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	      } else {
	        createDebug.names.push(new RegExp('^' + namespaces + '$'));
	      }
	    }
	
	    for (i = 0; i < createDebug.instances.length; i++) {
	      var instance = createDebug.instances[i];
	      instance.enabled = createDebug.enabled(instance.namespace);
	    }
	  }
	  /**
	  * Disable debug output.
	  *
	  * @api public
	  */
	
	
	  function disable() {
	    createDebug.enable('');
	  }
	  /**
	  * Returns true if the given mode name is enabled, false otherwise.
	  *
	  * @param {String} name
	  * @return {Boolean}
	  * @api public
	  */
	
	
	  function enabled(name) {
	    if (name[name.length - 1] === '*') {
	      return true;
	    }
	
	    var i;
	    var len;
	
	    for (i = 0, len = createDebug.skips.length; i < len; i++) {
	      if (createDebug.skips[i].test(name)) {
	        return false;
	      }
	    }
	
	    for (i = 0, len = createDebug.names.length; i < len; i++) {
	      if (createDebug.names[i].test(name)) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	  /**
	  * Coerce `val`.
	  *
	  * @param {Mixed} val
	  * @return {Mixed}
	  * @api private
	  */
	
	
	  function coerce(val) {
	    if (val instanceof Error) {
	      return val.stack || val.message;
	    }
	
	    return val;
	  }
	
	  createDebug.enable(createDebug.load());
	  return createDebug;
	}
	
	module.exports = setup;
	


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* globals Symbol: false, Uint8Array: false, WeakMap: false */
	/*!
	 * deep-eql
	 * Copyright(c) 2013 Jake Luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	
	var type = __webpack_require__(528);
	function FakeMap() {
	  this._key = 'chai/deep-eql__' + Math.random() + Date.now();
	}
	
	FakeMap.prototype = {
	  get: function getMap(key) {
	    return key[this._key];
	  },
	  set: function setMap(key, value) {
	    if (Object.isExtensible(key)) {
	      Object.defineProperty(key, this._key, {
	        value: value,
	        configurable: true,
	      });
	    }
	  },
	};
	
	var MemoizeMap = typeof WeakMap === 'function' ? WeakMap : FakeMap;
	/*!
	 * Check to see if the MemoizeMap has recorded a result of the two operands
	 *
	 * @param {Mixed} leftHandOperand
	 * @param {Mixed} rightHandOperand
	 * @param {MemoizeMap} memoizeMap
	 * @returns {Boolean|null} result
	*/
	function memoizeCompare(leftHandOperand, rightHandOperand, memoizeMap) {
	  // Technically, WeakMap keys can *only* be objects, not primitives.
	  if (!memoizeMap || isPrimitive(leftHandOperand) || isPrimitive(rightHandOperand)) {
	    return null;
	  }
	  var leftHandMap = memoizeMap.get(leftHandOperand);
	  if (leftHandMap) {
	    var result = leftHandMap.get(rightHandOperand);
	    if (typeof result === 'boolean') {
	      return result;
	    }
	  }
	  return null;
	}
	
	/*!
	 * Set the result of the equality into the MemoizeMap
	 *
	 * @param {Mixed} leftHandOperand
	 * @param {Mixed} rightHandOperand
	 * @param {MemoizeMap} memoizeMap
	 * @param {Boolean} result
	*/
	function memoizeSet(leftHandOperand, rightHandOperand, memoizeMap, result) {
	  // Technically, WeakMap keys can *only* be objects, not primitives.
	  if (!memoizeMap || isPrimitive(leftHandOperand) || isPrimitive(rightHandOperand)) {
	    return;
	  }
	  var leftHandMap = memoizeMap.get(leftHandOperand);
	  if (leftHandMap) {
	    leftHandMap.set(rightHandOperand, result);
	  } else {
	    leftHandMap = new MemoizeMap();
	    leftHandMap.set(rightHandOperand, result);
	    memoizeMap.set(leftHandOperand, leftHandMap);
	  }
	}
	
	/*!
	 * Primary Export
	 */
	
	module.exports = deepEqual;
	module.exports.MemoizeMap = MemoizeMap;
	
	/**
	 * Assert deeply nested sameValue equality between two objects of any type.
	 *
	 * @param {Mixed} leftHandOperand
	 * @param {Mixed} rightHandOperand
	 * @param {Object} [options] (optional) Additional options
	 * @param {Array} [options.comparator] (optional) Override default algorithm, determining custom equality.
	 * @param {Array} [options.memoize] (optional) Provide a custom memoization object which will cache the results of
	    complex objects for a speed boost. By passing `false` you can disable memoization, but this will cause circular
	    references to blow the stack.
	 * @return {Boolean} equal match
	 */
	function deepEqual(leftHandOperand, rightHandOperand, options) {
	  // If we have a comparator, we can't assume anything; so bail to its check first.
	  if (options && options.comparator) {
	    return extensiveDeepEqual(leftHandOperand, rightHandOperand, options);
	  }
	
	  var simpleResult = simpleEqual(leftHandOperand, rightHandOperand);
	  if (simpleResult !== null) {
	    return simpleResult;
	  }
	
	  // Deeper comparisons are pushed through to a larger function
	  return extensiveDeepEqual(leftHandOperand, rightHandOperand, options);
	}
	
	/**
	 * Many comparisons can be canceled out early via simple equality or primitive checks.
	 * @param {Mixed} leftHandOperand
	 * @param {Mixed} rightHandOperand
	 * @return {Boolean|null} equal match
	 */
	function simpleEqual(leftHandOperand, rightHandOperand) {
	  // Equal references (except for Numbers) can be returned early
	  if (leftHandOperand === rightHandOperand) {
	    // Handle +-0 cases
	    return leftHandOperand !== 0 || 1 / leftHandOperand === 1 / rightHandOperand;
	  }
	
	  // handle NaN cases
	  if (
	    leftHandOperand !== leftHandOperand && // eslint-disable-line no-self-compare
	    rightHandOperand !== rightHandOperand // eslint-disable-line no-self-compare
	  ) {
	    return true;
	  }
	
	  // Anything that is not an 'object', i.e. symbols, functions, booleans, numbers,
	  // strings, and undefined, can be compared by reference.
	  if (isPrimitive(leftHandOperand) || isPrimitive(rightHandOperand)) {
	    // Easy out b/c it would have passed the first equality check
	    return false;
	  }
	  return null;
	}
	
	/*!
	 * The main logic of the `deepEqual` function.
	 *
	 * @param {Mixed} leftHandOperand
	 * @param {Mixed} rightHandOperand
	 * @param {Object} [options] (optional) Additional options
	 * @param {Array} [options.comparator] (optional) Override default algorithm, determining custom equality.
	 * @param {Array} [options.memoize] (optional) Provide a custom memoization object which will cache the results of
	    complex objects for a speed boost. By passing `false` you can disable memoization, but this will cause circular
	    references to blow the stack.
	 * @return {Boolean} equal match
	*/
	function extensiveDeepEqual(leftHandOperand, rightHandOperand, options) {
	  options = options || {};
	  options.memoize = options.memoize === false ? false : options.memoize || new MemoizeMap();
	  var comparator = options && options.comparator;
	
	  // Check if a memoized result exists.
	  var memoizeResultLeft = memoizeCompare(leftHandOperand, rightHandOperand, options.memoize);
	  if (memoizeResultLeft !== null) {
	    return memoizeResultLeft;
	  }
	  var memoizeResultRight = memoizeCompare(rightHandOperand, leftHandOperand, options.memoize);
	  if (memoizeResultRight !== null) {
	    return memoizeResultRight;
	  }
	
	  // If a comparator is present, use it.
	  if (comparator) {
	    var comparatorResult = comparator(leftHandOperand, rightHandOperand);
	    // Comparators may return null, in which case we want to go back to default behavior.
	    if (comparatorResult === false || comparatorResult === true) {
	      memoizeSet(leftHandOperand, rightHandOperand, options.memoize, comparatorResult);
	      return comparatorResult;
	    }
	    // To allow comparators to override *any* behavior, we ran them first. Since it didn't decide
	    // what to do, we need to make sure to return the basic tests first before we move on.
	    var simpleResult = simpleEqual(leftHandOperand, rightHandOperand);
	    if (simpleResult !== null) {
	      // Don't memoize this, it takes longer to set/retrieve than to just compare.
	      return simpleResult;
	    }
	  }
	
	  var leftHandType = type(leftHandOperand);
	  if (leftHandType !== type(rightHandOperand)) {
	    memoizeSet(leftHandOperand, rightHandOperand, options.memoize, false);
	    return false;
	  }
	
	  // Temporarily set the operands in the memoize object to prevent blowing the stack
	  memoizeSet(leftHandOperand, rightHandOperand, options.memoize, true);
	
	  var result = extensiveDeepEqualByType(leftHandOperand, rightHandOperand, leftHandType, options);
	  memoizeSet(leftHandOperand, rightHandOperand, options.memoize, result);
	  return result;
	}
	
	function extensiveDeepEqualByType(leftHandOperand, rightHandOperand, leftHandType, options) {
	  switch (leftHandType) {
	    case 'String':
	    case 'Number':
	    case 'Boolean':
	    case 'Date':
	      // If these types are their instance types (e.g. `new Number`) then re-deepEqual against their values
	      return deepEqual(leftHandOperand.valueOf(), rightHandOperand.valueOf());
	    case 'Promise':
	    case 'Symbol':
	    case 'function':
	    case 'WeakMap':
	    case 'WeakSet':
	    case 'Error':
	      return leftHandOperand === rightHandOperand;
	    case 'Arguments':
	    case 'Int8Array':
	    case 'Uint8Array':
	    case 'Uint8ClampedArray':
	    case 'Int16Array':
	    case 'Uint16Array':
	    case 'Int32Array':
	    case 'Uint32Array':
	    case 'Float32Array':
	    case 'Float64Array':
	    case 'Array':
	      return iterableEqual(leftHandOperand, rightHandOperand, options);
	    case 'RegExp':
	      return regexpEqual(leftHandOperand, rightHandOperand);
	    case 'Generator':
	      return generatorEqual(leftHandOperand, rightHandOperand, options);
	    case 'DataView':
	      return iterableEqual(new Uint8Array(leftHandOperand.buffer), new Uint8Array(rightHandOperand.buffer), options);
	    case 'ArrayBuffer':
	      return iterableEqual(new Uint8Array(leftHandOperand), new Uint8Array(rightHandOperand), options);
	    case 'Set':
	      return entriesEqual(leftHandOperand, rightHandOperand, options);
	    case 'Map':
	      return entriesEqual(leftHandOperand, rightHandOperand, options);
	    default:
	      return objectEqual(leftHandOperand, rightHandOperand, options);
	  }
	}
	
	/*!
	 * Compare two Regular Expressions for equality.
	 *
	 * @param {RegExp} leftHandOperand
	 * @param {RegExp} rightHandOperand
	 * @return {Boolean} result
	 */
	
	function regexpEqual(leftHandOperand, rightHandOperand) {
	  return leftHandOperand.toString() === rightHandOperand.toString();
	}
	
	/*!
	 * Compare two Sets/Maps for equality. Faster than other equality functions.
	 *
	 * @param {Set} leftHandOperand
	 * @param {Set} rightHandOperand
	 * @param {Object} [options] (Optional)
	 * @return {Boolean} result
	 */
	
	function entriesEqual(leftHandOperand, rightHandOperand, options) {
	  // IE11 doesn't support Set#entries or Set#@@iterator, so we need manually populate using Set#forEach
	  if (leftHandOperand.size !== rightHandOperand.size) {
	    return false;
	  }
	  if (leftHandOperand.size === 0) {
	    return true;
	  }
	  var leftHandItems = [];
	  var rightHandItems = [];
	  leftHandOperand.forEach(function gatherEntries(key, value) {
	    leftHandItems.push([ key, value ]);
	  });
	  rightHandOperand.forEach(function gatherEntries(key, value) {
	    rightHandItems.push([ key, value ]);
	  });
	  return iterableEqual(leftHandItems.sort(), rightHandItems.sort(), options);
	}
	
	/*!
	 * Simple equality for flat iterable objects such as Arrays, TypedArrays or Node.js buffers.
	 *
	 * @param {Iterable} leftHandOperand
	 * @param {Iterable} rightHandOperand
	 * @param {Object} [options] (Optional)
	 * @return {Boolean} result
	 */
	
	function iterableEqual(leftHandOperand, rightHandOperand, options) {
	  var length = leftHandOperand.length;
	  if (length !== rightHandOperand.length) {
	    return false;
	  }
	  if (length === 0) {
	    return true;
	  }
	  var index = -1;
	  while (++index < length) {
	    if (deepEqual(leftHandOperand[index], rightHandOperand[index], options) === false) {
	      return false;
	    }
	  }
	  return true;
	}
	
	/*!
	 * Simple equality for generator objects such as those returned by generator functions.
	 *
	 * @param {Iterable} leftHandOperand
	 * @param {Iterable} rightHandOperand
	 * @param {Object} [options] (Optional)
	 * @return {Boolean} result
	 */
	
	function generatorEqual(leftHandOperand, rightHandOperand, options) {
	  return iterableEqual(getGeneratorEntries(leftHandOperand), getGeneratorEntries(rightHandOperand), options);
	}
	
	/*!
	 * Determine if the given object has an @@iterator function.
	 *
	 * @param {Object} target
	 * @return {Boolean} `true` if the object has an @@iterator function.
	 */
	function hasIteratorFunction(target) {
	  return typeof Symbol !== 'undefined' &&
	    typeof target === 'object' &&
	    typeof Symbol.iterator !== 'undefined' &&
	    typeof target[Symbol.iterator] === 'function';
	}
	
	/*!
	 * Gets all iterator entries from the given Object. If the Object has no @@iterator function, returns an empty array.
	 * This will consume the iterator - which could have side effects depending on the @@iterator implementation.
	 *
	 * @param {Object} target
	 * @returns {Array} an array of entries from the @@iterator function
	 */
	function getIteratorEntries(target) {
	  if (hasIteratorFunction(target)) {
	    try {
	      return getGeneratorEntries(target[Symbol.iterator]());
	    } catch (iteratorError) {
	      return [];
	    }
	  }
	  return [];
	}
	
	/*!
	 * Gets all entries from a Generator. This will consume the generator - which could have side effects.
	 *
	 * @param {Generator} target
	 * @returns {Array} an array of entries from the Generator.
	 */
	function getGeneratorEntries(generator) {
	  var generatorResult = generator.next();
	  var accumulator = [ generatorResult.value ];
	  while (generatorResult.done === false) {
	    generatorResult = generator.next();
	    accumulator.push(generatorResult.value);
	  }
	  return accumulator;
	}
	
	/*!
	 * Gets all own and inherited enumerable keys from a target.
	 *
	 * @param {Object} target
	 * @returns {Array} an array of own and inherited enumerable keys from the target.
	 */
	function getEnumerableKeys(target) {
	  var keys = [];
	  for (var key in target) {
	    keys.push(key);
	  }
	  return keys;
	}
	
	/*!
	 * Determines if two objects have matching values, given a set of keys. Defers to deepEqual for the equality check of
	 * each key. If any value of the given key is not equal, the function will return false (early).
	 *
	 * @param {Mixed} leftHandOperand
	 * @param {Mixed} rightHandOperand
	 * @param {Array} keys An array of keys to compare the values of leftHandOperand and rightHandOperand against
	 * @param {Object} [options] (Optional)
	 * @return {Boolean} result
	 */
	function keysEqual(leftHandOperand, rightHandOperand, keys, options) {
	  var length = keys.length;
	  if (length === 0) {
	    return true;
	  }
	  for (var i = 0; i < length; i += 1) {
	    if (deepEqual(leftHandOperand[keys[i]], rightHandOperand[keys[i]], options) === false) {
	      return false;
	    }
	  }
	  return true;
	}
	
	/*!
	 * Recursively check the equality of two Objects. Once basic sameness has been established it will defer to `deepEqual`
	 * for each enumerable key in the object.
	 *
	 * @param {Mixed} leftHandOperand
	 * @param {Mixed} rightHandOperand
	 * @param {Object} [options] (Optional)
	 * @return {Boolean} result
	 */
	
	function objectEqual(leftHandOperand, rightHandOperand, options) {
	  var leftHandKeys = getEnumerableKeys(leftHandOperand);
	  var rightHandKeys = getEnumerableKeys(rightHandOperand);
	  if (leftHandKeys.length && leftHandKeys.length === rightHandKeys.length) {
	    leftHandKeys.sort();
	    rightHandKeys.sort();
	    if (iterableEqual(leftHandKeys, rightHandKeys) === false) {
	      return false;
	    }
	    return keysEqual(leftHandOperand, rightHandOperand, leftHandKeys, options);
	  }
	
	  var leftHandEntries = getIteratorEntries(leftHandOperand);
	  var rightHandEntries = getIteratorEntries(rightHandOperand);
	  if (leftHandEntries.length && leftHandEntries.length === rightHandEntries.length) {
	    leftHandEntries.sort();
	    rightHandEntries.sort();
	    return iterableEqual(leftHandEntries, rightHandEntries, options);
	  }
	
	  if (leftHandKeys.length === 0 &&
	      leftHandEntries.length === 0 &&
	      rightHandKeys.length === 0 &&
	      rightHandEntries.length === 0) {
	    return true;
	  }
	
	  return false;
	}
	
	/*!
	 * Returns true if the argument is a primitive.
	 *
	 * This intentionally returns true for all objects that can be compared by reference,
	 * including functions and symbols.
	 *
	 * @param {Mixed} value
	 * @return {Boolean} result
	 */
	function isPrimitive(value) {
	  return value === null || typeof value !== 'object';
	}


/***/ }),
/* 1143 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 1144 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addClass;
	
	var _hasClass = __webpack_require__(598);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	module.exports = exports['default'];

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filterEvents;
	
	var _contains = __webpack_require__(213);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _querySelectorAll = __webpack_require__(1149);
	
	var _querySelectorAll2 = _interopRequireDefault(_querySelectorAll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function filterEvents(selector, handler) {
	  return function filterHandler(e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = (0, _querySelectorAll2.default)(top, selector);
	
	    if (matches.some(function (match) {
	      return (0, _contains2.default)(match, target);
	    })) handler.call(this, e);
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(35);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _on = __webpack_require__(133);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(132);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listen = function listen() {};
	
	if (_inDOM2.default) {
	  listen = function listen(node, eventName, handler, capture) {
	    (0, _on2.default)(node, eventName, handler, capture);
	    return function () {
	      (0, _off2.default)(node, eventName, handler, capture);
	    };
	  };
	}
	
	exports.default = listen;
	module.exports = exports['default'];

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = qsa;
	// Zepto.js
	// (c) 2010-2015 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/;
	var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	}
	module.exports = exports['default'];

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scrollTop;
	
	var _isWindow = __webpack_require__(175);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow2.default)(node);
	
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	module.exports = exports['default'];

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scrollTop;
	
	var _isWindow = __webpack_require__(175);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow2.default)(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	module.exports = exports['default'];

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = __webpack_require__(599);
	
	var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	
	      prop = (0, _camelizeStyle2.default)(prop);
	
	      if (prop == 'float') prop = 'styleFloat';
	
	      var current = node.currentStyle[prop] || null;
	
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left;
	
	        // Put in the new values to get a computed value out
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px';
	
	        // Revert the changed values
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeStyle;
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	module.exports = exports['default'];

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	module.exports = exports["default"];

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;
	
	var _inDOM = __webpack_require__(35);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = 'transform';
	var prefix = void 0,
	    transitionEnd = void 0,
	    animationEnd = void 0;
	var transitionProperty = void 0,
	    transitionDuration = void 0,
	    transitionTiming = void 0,
	    transitionDelay = void 0;
	var animationName = void 0,
	    animationDuration = void 0,
	    animationTiming = void 0,
	    animationDelay = void 0;
	
	if (_inDOM2.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	
	
	  exports.transform = transform = prefix + '-' + transform;
	  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
	  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
	  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
	  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';
	
	  exports.animationName = animationName = prefix + '-animation-name';
	  exports.animationDuration = animationDuration = prefix + '-animation-duration';
	  exports.animationTiming = animationTiming = prefix + '-animation-delay';
	  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
	}
	
	exports.transform = transform;
	exports.transitionProperty = transitionProperty;
	exports.transitionTiming = transitionTiming;
	exports.transitionDelay = transitionDelay;
	exports.transitionDuration = transitionDuration;
	exports.transitionEnd = transitionEnd;
	exports.animationName = animationName;
	exports.animationDuration = animationDuration;
	exports.animationTiming = animationTiming;
	exports.animationDelay = animationDelay;
	exports.animationEnd = animationEnd;
	exports.default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	
	  var vendorMap = {
	    O: function O(e) {
	      return 'o' + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return 'webkit' + e;
	    },
	    ms: function ms(e) {
	      return 'MS' + e;
	    }
	  };
	
	  var vendors = Object.keys(vendorMap);
	
	  var transitionEnd = void 0,
	      animationEnd = void 0;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + 'TransitionProperty' in style) {
	      prefix = '-' + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	
	  style = null;
	
	  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
	}

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	module.exports = exports["default"];

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenate;
	
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	module.exports = exports['default'];

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateStyleName;
	
	var _hyphenate = __webpack_require__(1157);
	
	var _hyphenate2 = _interopRequireDefault(_hyphenate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var msPattern = /^ms-/; /**
	                         * Copyright 2013-2014, Facebook, Inc.
	                         * All rights reserved.
	                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	                         */
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
	}
	module.exports = exports['default'];

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(35);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf = void 0;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM2.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	exports.default = compatRaf;
	module.exports = exports['default'];

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

	//Types of elements found in the DOM
	module.exports = {
		Text: "text", //Text
		Directive: "directive", //<? ... ?>
		Comment: "comment", //<!-- ... -->
		Script: "script", //<script> tags
		Style: "style", //<style> tags
		Tag: "tag", //Any tag
		CDATA: "cdata", //<![CDATA[ ... ]]>
	
		isTag: function(elem){
			return elem.type === "tag" || elem.type === "script" || elem.type === "style";
		}
	};

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(98);
	
	var re_whitespace = /\s+/g;
	var NodePrototype = __webpack_require__(600);
	var ElementPrototype = __webpack_require__(1162);
	
	function DomHandler(callback, options, elementCB){
		if(typeof callback === "object"){
			elementCB = options;
			options = callback;
			callback = null;
		} else if(typeof options === "function"){
			elementCB = options;
			options = defaultOpts;
		}
		this._callback = callback;
		this._options = options || defaultOpts;
		this._elementCB = elementCB;
		this.dom = [];
		this._done = false;
		this._tagStack = [];
		this._parser = this._parser || null;
	}
	
	//default options
	var defaultOpts = {
		normalizeWhitespace: false, //Replace all whitespace with single spaces
		withStartIndices: false, //Add startIndex properties to nodes
		withEndIndices: false, //Add endIndex properties to nodes
	};
	
	DomHandler.prototype.onparserinit = function(parser){
		this._parser = parser;
	};
	
	//Resets the handler back to starting state
	DomHandler.prototype.onreset = function(){
		DomHandler.call(this, this._callback, this._options, this._elementCB);
	};
	
	//Signals the handler that parsing is done
	DomHandler.prototype.onend = function(){
		if(this._done) return;
		this._done = true;
		this._parser = null;
		this._handleCallback(null);
	};
	
	DomHandler.prototype._handleCallback =
	DomHandler.prototype.onerror = function(error){
		if(typeof this._callback === "function"){
			this._callback(error, this.dom);
		} else {
			if(error) throw error;
		}
	};
	
	DomHandler.prototype.onclosetag = function(){
		//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
		
		var elem = this._tagStack.pop();
	
		if(this._options.withEndIndices){
			elem.endIndex = this._parser.endIndex;
		}
	
		if(this._elementCB) this._elementCB(elem);
	};
	
	DomHandler.prototype._createDomElement = function(properties){
		if (!this._options.withDomLvl1) return properties;
	
		var element;
		if (properties.type === "tag") {
			element = Object.create(ElementPrototype);
		} else {
			element = Object.create(NodePrototype);
		}
	
		for (var key in properties) {
			if (properties.hasOwnProperty(key)) {
				element[key] = properties[key];
			}
		}
	
		return element;
	};
	
	DomHandler.prototype._addDomElement = function(element){
		var parent = this._tagStack[this._tagStack.length - 1];
		var siblings = parent ? parent.children : this.dom;
		var previousSibling = siblings[siblings.length - 1];
	
		element.next = null;
	
		if(this._options.withStartIndices){
			element.startIndex = this._parser.startIndex;
		}
		if(this._options.withEndIndices){
			element.endIndex = this._parser.endIndex;
		}
	
		if(previousSibling){
			element.prev = previousSibling;
			previousSibling.next = element;
		} else {
			element.prev = null;
		}
	
		siblings.push(element);
		element.parent = parent || null;
	};
	
	DomHandler.prototype.onopentag = function(name, attribs){
		var properties = {
			type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
			name: name,
			attribs: attribs,
			children: []
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
	
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.ontext = function(data){
		//the ignoreWhitespace is officially dropped, but for now,
		//it's an alias for normalizeWhitespace
		var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;
	
		var lastTag;
	
		if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(
				this._tagStack.length &&
				(lastTag = this._tagStack[this._tagStack.length - 1]) &&
				(lastTag = lastTag.children[lastTag.children.length - 1]) &&
				lastTag.type === ElementType.Text
			){
				if(normalize){
					lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
				} else {
					lastTag.data += data;
				}
			} else {
				if(normalize){
					data = data.replace(re_whitespace, " ");
				}
	
				var element = this._createDomElement({
					data: data,
					type: ElementType.Text
				});
	
				this._addDomElement(element);
			}
		}
	};
	
	DomHandler.prototype.oncomment = function(data){
		var lastTag = this._tagStack[this._tagStack.length - 1];
	
		if(lastTag && lastTag.type === ElementType.Comment){
			lastTag.data += data;
			return;
		}
	
		var properties = {
			data: data,
			type: ElementType.Comment
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncdatastart = function(){
		var properties = {
			children: [{
				data: "",
				type: ElementType.Text
			}],
			type: ElementType.CDATA
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
		this._tagStack.pop();
	};
	
	DomHandler.prototype.onprocessinginstruction = function(name, data){
		var element = this._createDomElement({
			name: name,
			data: data,
			type: ElementType.Directive
		});
	
		this._addDomElement(element);
	};
	
	module.exports = DomHandler;


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	// DOM-Level-1-compliant structure
	var NodePrototype = __webpack_require__(600);
	var ElementPrototype = module.exports = Object.create(NodePrototype);
	
	var domLvl1 = {
		tagName: "name"
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(ElementPrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ }),
/* 1163 */,
/* 1164 */
/***/ (function(module, exports) {

	// removeSubsets
	// Given an array of nodes, remove any member that is contained by another.
	exports.removeSubsets = function(nodes) {
		var idx = nodes.length, node, ancestor, replace;
	
		// Check if each node (or one of its ancestors) is already contained in the
		// array.
		while (--idx > -1) {
			node = ancestor = nodes[idx];
	
			// Temporarily remove the node under consideration
			nodes[idx] = null;
			replace = true;
	
			while (ancestor) {
				if (nodes.indexOf(ancestor) > -1) {
					replace = false;
					nodes.splice(idx, 1);
					break;
				}
				ancestor = ancestor.parent;
			}
	
			// If the node has been found to be unique, re-insert it.
			if (replace) {
				nodes[idx] = node;
			}
		}
	
		return nodes;
	};
	
	// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
	var POSITION = {
		DISCONNECTED: 1,
		PRECEDING: 2,
		FOLLOWING: 4,
		CONTAINS: 8,
		CONTAINED_BY: 16
	};
	
	// Compare the position of one node against another node in any other document.
	// The return value is a bitmask with the following values:
	//
	// document order:
	// > There is an ordering, document order, defined on all the nodes in the
	// > document corresponding to the order in which the first character of the
	// > XML representation of each node occurs in the XML representation of the
	// > document after expansion of general entities. Thus, the document element
	// > node will be the first node. Element nodes occur before their children.
	// > Thus, document order orders element nodes in order of the occurrence of
	// > their start-tag in the XML (after expansion of entities). The attribute
	// > nodes of an element occur after the element and before its children. The
	// > relative order of attribute nodes is implementation-dependent./
	// Source:
	// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
	//
	// @argument {Node} nodaA The first node to use in the comparison
	// @argument {Node} nodeB The second node to use in the comparison
	//
	// @return {Number} A bitmask describing the input nodes' relative position.
	//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
	//         a description of these values.
	var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
		var aParents = [];
		var bParents = [];
		var current, sharedParent, siblings, aSibling, bSibling, idx;
	
		if (nodeA === nodeB) {
			return 0;
		}
	
		current = nodeA;
		while (current) {
			aParents.unshift(current);
			current = current.parent;
		}
		current = nodeB;
		while (current) {
			bParents.unshift(current);
			current = current.parent;
		}
	
		idx = 0;
		while (aParents[idx] === bParents[idx]) {
			idx++;
		}
	
		if (idx === 0) {
			return POSITION.DISCONNECTED;
		}
	
		sharedParent = aParents[idx - 1];
		siblings = sharedParent.children;
		aSibling = aParents[idx];
		bSibling = bParents[idx];
	
		if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
			if (sharedParent === nodeB) {
				return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
			}
			return POSITION.FOLLOWING;
		} else {
			if (sharedParent === nodeA) {
				return POSITION.PRECEDING | POSITION.CONTAINS;
			}
			return POSITION.PRECEDING;
		}
	};
	
	// Sort an array of nodes based on their relative position in the document and
	// remove any duplicate nodes. If the array contains nodes that do not belong
	// to the same document, sort order is unspecified.
	//
	// @argument {Array} nodes Array of DOM nodes
	//
	// @returns {Array} collection of unique nodes, sorted in document order
	exports.uniqueSort = function(nodes) {
		var idx = nodes.length, node, position;
	
		nodes = nodes.slice();
	
		while (--idx > -1) {
			node = nodes[idx];
			position = nodes.indexOf(node);
			if (position > -1 && position < idx) {
				nodes.splice(idx, 1);
			}
		}
		nodes.sort(function(a, b) {
			var relative = comparePos(a, b);
			if (relative & POSITION.PRECEDING) {
				return -1;
			} else if (relative & POSITION.FOLLOWING) {
				return 1;
			}
			return 0;
		});
	
		return nodes;
	};


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(98);
	var isTag = exports.isTag = ElementType.isTag;
	
	exports.testElement = function(options, element){
		for(var key in options){
			if(!options.hasOwnProperty(key));
			else if(key === "tag_name"){
				if(!isTag(element) || !options.tag_name(element.name)){
					return false;
				}
			} else if(key === "tag_type"){
				if(!options.tag_type(element.type)) return false;
			} else if(key === "tag_contains"){
				if(isTag(element) || !options.tag_contains(element.data)){
					return false;
				}
			} else if(!element.attribs || !options[key](element.attribs[key])){
				return false;
			}
		}
		return true;
	};
	
	var Checks = {
		tag_name: function(name){
			if(typeof name === "function"){
				return function(elem){ return isTag(elem) && name(elem.name); };
			} else if(name === "*"){
				return isTag;
			} else {
				return function(elem){ return isTag(elem) && elem.name === name; };
			}
		},
		tag_type: function(type){
			if(typeof type === "function"){
				return function(elem){ return type(elem.type); };
			} else {
				return function(elem){ return elem.type === type; };
			}
		},
		tag_contains: function(data){
			if(typeof data === "function"){
				return function(elem){ return !isTag(elem) && data(elem.data); };
			} else {
				return function(elem){ return !isTag(elem) && elem.data === data; };
			}
		}
	};
	
	function getAttribCheck(attrib, value){
		if(typeof value === "function"){
			return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
		} else {
			return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
		}
	}
	
	function combineFuncs(a, b){
		return function(elem){
			return a(elem) || b(elem);
		};
	}
	
	exports.getElements = function(options, element, recurse, limit){
		var funcs = Object.keys(options).map(function(key){
			var value = options[key];
			return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
		});
	
		return funcs.length === 0 ? [] : this.filter(
			funcs.reduce(combineFuncs),
			element, recurse, limit
		);
	};
	
	exports.getElementById = function(id, element, recurse){
		if(!Array.isArray(element)) element = [element];
		return this.findOne(getAttribCheck("id", id), element, recurse !== false);
	};
	
	exports.getElementsByTagName = function(name, element, recurse, limit){
		return this.filter(Checks.tag_name(name), element, recurse, limit);
	};
	
	exports.getElementsByTagType = function(type, element, recurse, limit){
		return this.filter(Checks.tag_type(type), element, recurse, limit);
	};


/***/ }),
/* 1166 */
/***/ (function(module, exports) {

	exports.removeElement = function(elem){
		if(elem.prev) elem.prev.next = elem.next;
		if(elem.next) elem.next.prev = elem.prev;
	
		if(elem.parent){
			var childs = elem.parent.children;
			childs.splice(childs.lastIndexOf(elem), 1);
		}
	};
	
	exports.replaceElement = function(elem, replacement){
		var prev = replacement.prev = elem.prev;
		if(prev){
			prev.next = replacement;
		}
	
		var next = replacement.next = elem.next;
		if(next){
			next.prev = replacement;
		}
	
		var parent = replacement.parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs[childs.lastIndexOf(elem)] = replacement;
		}
	};
	
	exports.appendChild = function(elem, child){
		child.parent = elem;
	
		if(elem.children.push(child) !== 1){
			var sibling = elem.children[elem.children.length - 2];
			sibling.next = child;
			child.prev = sibling;
			child.next = null;
		}
	};
	
	exports.append = function(elem, next){
		var parent = elem.parent,
			currNext = elem.next;
	
		next.next = currNext;
		next.prev = elem;
		elem.next = next;
		next.parent = parent;
	
		if(currNext){
			currNext.prev = next;
			if(parent){
				var childs = parent.children;
				childs.splice(childs.lastIndexOf(currNext), 0, next);
			}
		} else if(parent){
			parent.children.push(next);
		}
	};
	
	exports.prepend = function(elem, prev){
		var parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(elem), 0, prev);
		}
	
		if(elem.prev){
			elem.prev.next = prev;
		}
		
		prev.parent = parent;
		prev.prev = elem.prev;
		prev.next = elem;
		elem.prev = prev;
	};
	
	


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	var isTag = __webpack_require__(98).isTag;
	
	module.exports = {
		filter: filter,
		find: find,
		findOneChild: findOneChild,
		findOne: findOne,
		existsOne: existsOne,
		findAll: findAll
	};
	
	function filter(test, element, recurse, limit){
		if(!Array.isArray(element)) element = [element];
	
		if(typeof limit !== "number" || !isFinite(limit)){
			limit = Infinity;
		}
		return find(test, element, recurse !== false, limit);
	}
	
	function find(test, elems, recurse, limit){
		var result = [], childs;
	
		for(var i = 0, j = elems.length; i < j; i++){
			if(test(elems[i])){
				result.push(elems[i]);
				if(--limit <= 0) break;
			}
	
			childs = elems[i].children;
			if(recurse && childs && childs.length > 0){
				childs = find(test, childs, recurse, limit);
				result = result.concat(childs);
				limit -= childs.length;
				if(limit <= 0) break;
			}
		}
	
		return result;
	}
	
	function findOneChild(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(test(elems[i])) return elems[i];
		}
	
		return null;
	}
	
	function findOne(test, elems){
		var elem = null;
	
		for(var i = 0, l = elems.length; i < l && !elem; i++){
			if(!isTag(elems[i])){
				continue;
			} else if(test(elems[i])){
				elem = elems[i];
			} else if(elems[i].children.length > 0){
				elem = findOne(test, elems[i].children);
			}
		}
	
		return elem;
	}
	
	function existsOne(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(
				isTag(elems[i]) && (
					test(elems[i]) || (
						elems[i].children.length > 0 &&
						existsOne(test, elems[i].children)
					)
				)
			){
				return true;
			}
		}
	
		return false;
	}
	
	function findAll(test, rootElems){
		var result = [];
		var stack = rootElems.slice();
		while(stack.length){
			var elem = stack.shift();
			if(!isTag(elem)) continue;
			if (elem.children && elem.children.length > 0) {
				stack.unshift.apply(stack, elem.children);
			}
			if(test(elem)) result.push(elem);
		}
		return result;
	}


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(98),
	    getOuterHTML = __webpack_require__(311),
	    isTag = ElementType.isTag;
	
	module.exports = {
		getInnerHTML: getInnerHTML,
		getOuterHTML: getOuterHTML,
		getText: getText
	};
	
	function getInnerHTML(elem, opts){
		return elem.children ? elem.children.map(function(elem){
			return getOuterHTML(elem, opts);
		}).join("") : "";
	}
	
	function getText(elem){
		if(Array.isArray(elem)) return elem.map(getText).join("");
		if(isTag(elem)) return elem.name === "br" ? "\n" : getText(elem.children);
		if(elem.type === ElementType.CDATA) return getText(elem.children);
		if(elem.type === ElementType.Text) return elem.data;
		return "";
	}


/***/ }),
/* 1169 */
/***/ (function(module, exports) {

	var getChildren = exports.getChildren = function(elem){
		return elem.children;
	};
	
	var getParent = exports.getParent = function(elem){
		return elem.parent;
	};
	
	exports.getSiblings = function(elem){
		var parent = getParent(elem);
		return parent ? getChildren(parent) : [elem];
	};
	
	exports.getAttributeValue = function(elem, name){
		return elem.attribs && elem.attribs[name];
	};
	
	exports.hasAttrib = function(elem, name){
		return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
	};
	
	exports.getName = function(elem){
		return elem.name;
	};


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	var encode = __webpack_require__(1172),
	    decode = __webpack_require__(1171);
	
	exports.decode = function(data, level){
		return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
	};
	
	exports.decodeStrict = function(data, level){
		return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
	};
	
	exports.encode = function(data, level){
		return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
	};
	
	exports.encodeXML = encode.XML;
	
	exports.encodeHTML4 =
	exports.encodeHTML5 =
	exports.encodeHTML  = encode.HTML;
	
	exports.decodeXML =
	exports.decodeXMLStrict = decode.XML;
	
	exports.decodeHTML4 =
	exports.decodeHTML5 =
	exports.decodeHTML = decode.HTML;
	
	exports.decodeHTML4Strict =
	exports.decodeHTML5Strict =
	exports.decodeHTMLStrict = decode.HTMLStrict;
	
	exports.escape = encode.escape;


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	var entityMap = __webpack_require__(426),
	    legacyMap = __webpack_require__(635),
	    xmlMap    = __webpack_require__(427),
	    decodeCodePoint = __webpack_require__(601);
	
	var decodeXMLStrict  = getStrictDecoder(xmlMap),
	    decodeHTMLStrict = getStrictDecoder(entityMap);
	
	function getStrictDecoder(map){
		var keys = Object.keys(map).join("|"),
		    replace = getReplacer(map);
	
		keys += "|#[xX][\\da-fA-F]+|#\\d+";
	
		var re = new RegExp("&(?:" + keys + ");", "g");
	
		return function(str){
			return String(str).replace(re, replace);
		};
	}
	
	var decodeHTML = (function(){
		var legacy = Object.keys(legacyMap)
			.sort(sorter);
	
		var keys = Object.keys(entityMap)
			.sort(sorter);
	
		for(var i = 0, j = 0; i < keys.length; i++){
			if(legacy[j] === keys[i]){
				keys[i] += ";?";
				j++;
			} else {
				keys[i] += ";";
			}
		}
	
		var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
		    replace = getReplacer(entityMap);
	
		function replacer(str){
			if(str.substr(-1) !== ";") str += ";";
			return replace(str);
		}
	
		//TODO consider creating a merged map
		return function(str){
			return String(str).replace(re, replacer);
		};
	}());
	
	function sorter(a, b){
		return a < b ? 1 : -1;
	}
	
	function getReplacer(map){
		return function replace(str){
			if(str.charAt(1) === "#"){
				if(str.charAt(2) === "X" || str.charAt(2) === "x"){
					return decodeCodePoint(parseInt(str.substr(3), 16));
				}
				return decodeCodePoint(parseInt(str.substr(2), 10));
			}
			return map[str.slice(1, -1)];
		};
	}
	
	module.exports = {
		XML: decodeXMLStrict,
		HTML: decodeHTML,
		HTMLStrict: decodeHTMLStrict
	};

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	var inverseXML = getInverseObj(__webpack_require__(427)),
	    xmlReplacer = getInverseReplacer(inverseXML);
	
	exports.XML = getInverse(inverseXML, xmlReplacer);
	
	var inverseHTML = getInverseObj(__webpack_require__(426)),
	    htmlReplacer = getInverseReplacer(inverseHTML);
	
	exports.HTML = getInverse(inverseHTML, htmlReplacer);
	
	function getInverseObj(obj){
		return Object.keys(obj).sort().reduce(function(inverse, name){
			inverse[obj[name]] = "&" + name + ";";
			return inverse;
		}, {});
	}
	
	function getInverseReplacer(inverse){
		var single = [],
		    multiple = [];
	
		Object.keys(inverse).forEach(function(k){
			if(k.length === 1){
				single.push("\\" + k);
			} else {
				multiple.push(k);
			}
		});
	
		//TODO add ranges
		multiple.unshift("[" + single.join("") + "]");
	
		return new RegExp(multiple.join("|"), "g");
	}
	
	var re_nonASCII = /[^\0-\x7F]/g,
	    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	
	function singleCharReplacer(c){
		return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
	}
	
	function astralReplacer(c){
		// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
		var high = c.charCodeAt(0);
		var low  = c.charCodeAt(1);
		var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
		return "&#x" + codePoint.toString(16).toUpperCase() + ";";
	}
	
	function getInverse(inverse, re){
		function func(name){
			return inverse[name];
		}
	
		return function(data){
			return data
					.replace(re, func)
					.replace(re_astralSymbols, astralReplacer)
					.replace(re_nonASCII, singleCharReplacer);
		};
	}
	
	var re_xmlChars = getInverseReplacer(inverseXML);
	
	function escapeXML(data){
		return data
				.replace(re_xmlChars, singleCharReplacer)
				.replace(re_astralSymbols, astralReplacer)
				.replace(re_nonASCII, singleCharReplacer);
	}
	
	exports.escape = escapeXML;


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(86);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _server = __webpack_require__(4388);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _shallow = __webpack_require__(4434);
	
	var _shallow2 = _interopRequireDefault(_shallow);
	
	var _testUtils = __webpack_require__(4389);
	
	var _testUtils2 = _interopRequireDefault(_testUtils);
	
	var _enzyme = __webpack_require__(607);
	
	var _enzymeAdapterUtils = __webpack_require__(1178);
	
	var _reflection = __webpack_require__(4400);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-use-before-define: 0 */
	
	// eslint-disable-next-line import/no-unresolved, import/extensions
	
	// eslint-disable-next-line import/no-unresolved, import/extensions
	
	// eslint-disable-next-line import/no-unresolved, import/extensions
	
	
	var HostRoot = 3;
	var ClassComponent = 2;
	var Fragment = 10;
	var FunctionalComponent = 1;
	var HostPortal = 4;
	var HostComponent = 5;
	var HostText = 6;
	
	function nodeAndSiblingsArray(nodeWithSibling) {
	  var array = [];
	  var node = nodeWithSibling;
	  while (node != null) {
	    array.push(node);
	    node = node.sibling;
	  }
	  return array;
	}
	
	function flatten(arr) {
	  var result = [];
	  var stack = [{ i: 0, array: arr }];
	  while (stack.length) {
	    var n = stack.pop();
	    while (n.i < n.array.length) {
	      var el = n.array[n.i];
	      n.i += 1;
	      if (Array.isArray(el)) {
	        stack.push(n);
	        stack.push({ i: 0, array: el });
	        break;
	      }
	      result.push(el);
	    }
	  }
	  return result;
	}
	
	function toTree(vnode) {
	  if (vnode == null) {
	    return null;
	  }
	  // TODO(lmr): I'm not really sure I understand whether or not this is what
	  // i should be doing, or if this is a hack for something i'm doing wrong
	  // somewhere else. Should talk to sebastian about this perhaps
	  var node = (0, _reflection.findCurrentFiberUsingSlowPath)(vnode);
	  switch (node.tag) {
	    case HostRoot:
	      // 3
	      return toTree(node.child);
	    case HostPortal:
	      // 4
	      return toTree(node.child);
	    case ClassComponent:
	      return {
	        nodeType: 'class',
	        type: node.type,
	        props: (0, _object2['default'])({}, node.memoizedProps),
	        key: node.key || undefined,
	        ref: node.ref,
	        instance: node.stateNode,
	        rendered: childrenToTree(node.child)
	      };
	    case Fragment:
	      // 10
	      return childrenToTree(node.child);
	    case FunctionalComponent:
	      // 1
	      return {
	        nodeType: 'function',
	        type: node.type,
	        props: (0, _object2['default'])({}, node.memoizedProps),
	        key: node.key || undefined,
	        ref: node.ref,
	        instance: null,
	        rendered: childrenToTree(node.child)
	      };
	    case HostComponent:
	      {
	        // 5
	        var renderedNodes = flatten(nodeAndSiblingsArray(node.child).map(toTree));
	        if (renderedNodes.length === 0) {
	          renderedNodes = [node.memoizedProps.children];
	        }
	        return {
	          nodeType: 'host',
	          type: node.type,
	          props: (0, _object2['default'])({}, node.memoizedProps),
	          key: node.key || undefined,
	          ref: node.ref,
	          instance: node.stateNode,
	          rendered: renderedNodes
	        };
	      }
	    case HostText:
	      // 6
	      return node.memoizedProps;
	    default:
	      throw new Error('Enzyme Internal Error: unknown node with tag ' + String(node.tag));
	  }
	}
	
	function childrenToTree(node) {
	  if (!node) {
	    return null;
	  }
	  var children = nodeAndSiblingsArray(node);
	  if (children.length === 0) {
	    return null;
	  } else if (children.length === 1) {
	    return toTree(children[0]);
	  }
	  return flatten(children.map(toTree));
	}
	
	function _nodeToHostNode(_node) {
	  // NOTE(lmr): node could be a function component
	  // which wont have an instance prop, but we can get the
	  // host node associated with its return value at that point.
	  // Although this breaks down if the return value is an array,
	  // as is possible with React 16.
	  var node = _node;
	  while (node && !Array.isArray(node) && node.instance === null) {
	    node = node.rendered;
	  }
	  if (Array.isArray(node)) {
	    // TODO(lmr): throw warning regarding not being able to get a host node here
	    throw new Error('Trying to get host node of an array');
	  }
	  // if the SFC returned null effectively, there is no host node.
	  if (!node) {
	    return null;
	  }
	  return _reactDom2['default'].findDOMNode(node.instance);
	}
	
	var ReactSixteenAdapter = function (_EnzymeAdapter) {
	  _inherits(ReactSixteenAdapter, _EnzymeAdapter);
	
	  function ReactSixteenAdapter() {
	    _classCallCheck(this, ReactSixteenAdapter);
	
	    var _this = _possibleConstructorReturn(this, (ReactSixteenAdapter.__proto__ || Object.getPrototypeOf(ReactSixteenAdapter)).call(this));
	
	    _this.options = (0, _object2['default'])({}, _this.options, {
	      enableComponentDidUpdateOnSetState: true
	    });
	    return _this;
	  }
	
	  _createClass(ReactSixteenAdapter, [{
	    key: 'createMountRenderer',
	    value: function () {
	      function createMountRenderer(options) {
	        (0, _enzymeAdapterUtils.assertDomAvailable)('mount');
	        var domNode = options.attachTo || global.document.createElement('div');
	        var instance = null;
	        return {
	          render: function () {
	            function render(el, context, callback) {
	              if (instance === null) {
	                var ReactWrapperComponent = (0, _enzymeAdapterUtils.createMountWrapper)(el, options);
	                var wrappedEl = _react2['default'].createElement(ReactWrapperComponent, {
	                  Component: el.type,
	                  props: el.props,
	                  context: context
	                });
	                instance = _reactDom2['default'].render(wrappedEl, domNode);
	                if (typeof callback === 'function') {
	                  callback();
	                }
	              } else {
	                instance.setChildProps(el.props, context, callback);
	              }
	            }
	
	            return render;
	          }(),
	          unmount: function () {
	            function unmount() {
	              _reactDom2['default'].unmountComponentAtNode(domNode);
	              instance = null;
	            }
	
	            return unmount;
	          }(),
	          getNode: function () {
	            function getNode() {
	              return instance ? toTree(instance._reactInternalFiber).rendered : null;
	            }
	
	            return getNode;
	          }(),
	          simulateEvent: function () {
	            function simulateEvent(node, event, mock) {
	              var mappedEvent = (0, _enzymeAdapterUtils.mapNativeEventNames)(event);
	              var eventFn = _testUtils2['default'].Simulate[mappedEvent];
	              if (!eventFn) {
	                throw new TypeError('ReactWrapper::simulate() event \'' + String(event) + '\' does not exist');
	              }
	              // eslint-disable-next-line react/no-find-dom-node
	              eventFn(_nodeToHostNode(node), mock);
	            }
	
	            return simulateEvent;
	          }(),
	          batchedUpdates: function () {
	            function batchedUpdates(fn) {
	              return fn();
	              // return ReactDOM.unstable_batchedUpdates(fn);
	            }
	
	            return batchedUpdates;
	          }()
	        };
	      }
	
	      return createMountRenderer;
	    }()
	  }, {
	    key: 'createShallowRenderer',
	    value: function () {
	      function createShallowRenderer() /* options */{
	        var renderer = new _shallow2['default']();
	        var isDOM = false;
	        var cachedNode = null;
	        return {
	          render: function () {
	            function render(el, context) {
	              cachedNode = el;
	              /* eslint consistent-return: 0 */
	              if (typeof el.type === 'string') {
	                isDOM = true;
	              } else {
	                isDOM = false;
	                return (0, _enzymeAdapterUtils.withSetStateAllowed)(function () {
	                  return renderer.render(el, context);
	                });
	              }
	            }
	
	            return render;
	          }(),
	          unmount: function () {
	            function unmount() {
	              renderer.unmount();
	            }
	
	            return unmount;
	          }(),
	          getNode: function () {
	            function getNode() {
	              if (isDOM) {
	                return (0, _enzymeAdapterUtils.elementToTree)(cachedNode);
	              }
	              var output = renderer.getRenderOutput();
	              return {
	                nodeType: (0, _enzymeAdapterUtils.nodeTypeFromType)(cachedNode.type),
	                type: cachedNode.type,
	                props: cachedNode.props,
	                key: cachedNode.key || undefined,
	                ref: cachedNode.ref,
	                instance: renderer._instance,
	                rendered: (0, _enzymeAdapterUtils.elementToTree)(output)
	              };
	            }
	
	            return getNode;
	          }(),
	          simulateEvent: function () {
	            function simulateEvent(node, event) {
	              for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	                args[_key - 2] = arguments[_key];
	              }
	
	              var handler = node.props[(0, _enzymeAdapterUtils.propFromEvent)(event)];
	              if (handler) {
	                (0, _enzymeAdapterUtils.withSetStateAllowed)(function () {
	                  // TODO(lmr): create/use synthetic events
	                  // TODO(lmr): emulate React's event propagation
	                  // ReactDOM.unstable_batchedUpdates(() => {
	                  handler.apply(undefined, _toConsumableArray(args));
	                  // });
	                });
	              }
	            }
	
	            return simulateEvent;
	          }(),
	          batchedUpdates: function () {
	            function batchedUpdates(fn) {
	              return fn();
	              // return ReactDOM.unstable_batchedUpdates(fn);
	            }
	
	            return batchedUpdates;
	          }()
	        };
	      }
	
	      return createShallowRenderer;
	    }()
	  }, {
	    key: 'createStringRenderer',
	    value: function () {
	      function createStringRenderer(options) {
	        return {
	          render: function () {
	            function render(el, context) {
	              if (options.context && (el.type.contextTypes || options.childContextTypes)) {
	                var childContextTypes = (0, _object2['default'])({}, el.type.contextTypes || {}, options.childContextTypes);
	                var ContextWrapper = (0, _enzymeAdapterUtils.createRenderWrapper)(el, context, childContextTypes);
	                return _server2['default'].renderToStaticMarkup(_react2['default'].createElement(ContextWrapper));
	              }
	              return _server2['default'].renderToStaticMarkup(el);
	            }
	
	            return render;
	          }()
	        };
	      }
	
	      return createStringRenderer;
	    }()
	
	    // Provided a bag of options, return an `EnzymeRenderer`. Some options can be implementation
	    // specific, like `attach` etc. for React, but not part of this interface explicitly.
	    // eslint-disable-next-line class-methods-use-this, no-unused-vars
	
	  }, {
	    key: 'createRenderer',
	    value: function () {
	      function createRenderer(options) {
	        switch (options.mode) {
	          case _enzyme.EnzymeAdapter.MODES.MOUNT:
	            return this.createMountRenderer(options);
	          case _enzyme.EnzymeAdapter.MODES.SHALLOW:
	            return this.createShallowRenderer(options);
	          case _enzyme.EnzymeAdapter.MODES.STRING:
	            return this.createStringRenderer(options);
	          default:
	            throw new Error('Enzyme Internal Error: Unrecognized mode: ' + String(options.mode));
	        }
	      }
	
	      return createRenderer;
	    }()
	
	    // converts an RSTNode to the corresponding JSX Pragma Element. This will be needed
	    // in order to implement the `Wrapper.mount()` and `Wrapper.shallow()` methods, but should
	    // be pretty straightforward for people to implement.
	    // eslint-disable-next-line class-methods-use-this, no-unused-vars
	
	  }, {
	    key: 'nodeToElement',
	    value: function () {
	      function nodeToElement(node) {
	        if (!node || (typeof node === 'undefined' ? 'undefined' : _typeof(node)) !== 'object') return null;
	        return _react2['default'].createElement(node.type, (0, _enzymeAdapterUtils.propsWithKeysAndRef)(node));
	      }
	
	      return nodeToElement;
	    }()
	  }, {
	    key: 'elementToNode',
	    value: function () {
	      function elementToNode(element) {
	        return (0, _enzymeAdapterUtils.elementToTree)(element);
	      }
	
	      return elementToNode;
	    }()
	  }, {
	    key: 'nodeToHostNode',
	    value: function () {
	      function nodeToHostNode(node) {
	        return _nodeToHostNode(node);
	      }
	
	      return nodeToHostNode;
	    }()
	  }, {
	    key: 'isValidElement',
	    value: function () {
	      function isValidElement(element) {
	        return _react2['default'].isValidElement(element);
	      }
	
	      return isValidElement;
	    }()
	  }, {
	    key: 'createElement',
	    value: function () {
	      function createElement() {
	        return _react2['default'].createElement.apply(_react2['default'], arguments);
	      }
	
	      return createElement;
	    }()
	  }]);
	
	  return ReactSixteenAdapter;
	}(_enzyme.EnzymeAdapter);
	
	module.exports = ReactSixteenAdapter;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint global-require: 0 */
	module.exports = __webpack_require__(1173);

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createRenderWrapper = exports.createMountWrapper = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.mapNativeEventNames = mapNativeEventNames;
	exports.propFromEvent = propFromEvent;
	exports.withSetStateAllowed = withSetStateAllowed;
	exports.assertDomAvailable = assertDomAvailable;
	exports.nodeTypeFromType = nodeTypeFromType;
	exports.isArrayLike = isArrayLike;
	exports.flatten = flatten;
	exports.elementToTree = elementToTree;
	exports.propsWithKeysAndRef = propsWithKeysAndRef;
	
	var _object = __webpack_require__(86);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _createMountWrapper = __webpack_require__(1176);
	
	var _createMountWrapper2 = _interopRequireDefault(_createMountWrapper);
	
	var _createRenderWrapper = __webpack_require__(1177);
	
	var _createRenderWrapper2 = _interopRequireDefault(_createRenderWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.createMountWrapper = _createMountWrapper2['default'];
	exports.createRenderWrapper = _createRenderWrapper2['default'];
	function mapNativeEventNames(event) {
	  var nativeToReactEventMap = {
	    compositionend: 'compositionEnd',
	    compositionstart: 'compositionStart',
	    compositionupdate: 'compositionUpdate',
	    keydown: 'keyDown',
	    keyup: 'keyUp',
	    keypress: 'keyPress',
	    contextmenu: 'contextMenu',
	    dblclick: 'doubleClick',
	    doubleclick: 'doubleClick', // kept for legacy. TODO: remove with next major.
	    dragend: 'dragEnd',
	    dragenter: 'dragEnter',
	    dragexist: 'dragExit',
	    dragleave: 'dragLeave',
	    dragover: 'dragOver',
	    dragstart: 'dragStart',
	    mousedown: 'mouseDown',
	    mousemove: 'mouseMove',
	    mouseout: 'mouseOut',
	    mouseover: 'mouseOver',
	    mouseup: 'mouseUp',
	    touchcancel: 'touchCancel',
	    touchend: 'touchEnd',
	    touchmove: 'touchMove',
	    touchstart: 'touchStart',
	    canplay: 'canPlay',
	    canplaythrough: 'canPlayThrough',
	    durationchange: 'durationChange',
	    loadeddata: 'loadedData',
	    loadedmetadata: 'loadedMetadata',
	    loadstart: 'loadStart',
	    ratechange: 'rateChange',
	    timeupdate: 'timeUpdate',
	    volumechange: 'volumeChange',
	    beforeinput: 'beforeInput',
	    mouseenter: 'mouseEnter',
	    mouseleave: 'mouseLeave',
	    transitionend: 'transitionEnd'
	  };
	
	  return nativeToReactEventMap[event] || event;
	}
	
	// 'click' => 'onClick'
	// 'mouseEnter' => 'onMouseEnter'
	function propFromEvent(event) {
	  var nativeEvent = mapNativeEventNames(event);
	  return 'on' + String(nativeEvent[0].toUpperCase()) + String(nativeEvent.slice(1));
	}
	
	function withSetStateAllowed(fn) {
	  // NOTE(lmr):
	  // this is currently here to circumvent a React bug where `setState()` is
	  // not allowed without global being defined.
	  var cleanup = false;
	  if (typeof global.document === 'undefined') {
	    cleanup = true;
	    global.document = {};
	  }
	  var result = fn();
	  if (cleanup) {
	    // This works around a bug in node/jest in that developers aren't able to
	    // delete things from global when running in a node vm.
	    global.document = undefined;
	    delete global.document;
	  }
	  return result;
	}
	
	function assertDomAvailable(feature) {
	  if (!global || !global.document || !global.document.createElement) {
	    throw new Error('Enzyme\'s ' + String(feature) + ' expects a DOM environment to be loaded, but found none');
	  }
	}
	
	function nodeTypeFromType(type) {
	  if (typeof type === 'string') {
	    return 'host';
	  }
	  if (type && type.prototype && type.prototype.isReactComponent) {
	    return 'class';
	  }
	  return 'function';
	}
	
	function getIteratorFn(obj) {
	  var iteratorFn = obj && (typeof Symbol === 'function' && _typeof(Symbol.iterator) === 'symbol' && obj[Symbol.iterator] || obj['@@iterator']);
	
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	
	  return undefined;
	}
	
	function isIterable(obj) {
	  return !!getIteratorFn(obj);
	}
	
	function isArrayLike(obj) {
	  return Array.isArray(obj) || typeof obj !== 'string' && isIterable(obj);
	}
	
	function flatten(arrs) {
	  // optimize for the most common case
	  if (Array.isArray(arrs)) {
	    return arrs.reduce(function (flatArrs, item) {
	      return flatArrs.concat(isArrayLike(item) ? flatten(item) : item);
	    }, []);
	  }
	
	  // fallback for arbitrary iterable children
	  var flatArrs = [];
	
	  var iteratorFn = getIteratorFn(arrs);
	  var iterator = iteratorFn.call(arrs);
	
	  var step = iterator.next();
	
	  while (!step.done) {
	    var item = step.value;
	    var flatItem = void 0;
	
	    if (isArrayLike(item)) {
	      flatItem = flatten(item);
	    } else {
	      flatItem = item;
	    }
	
	    flatArrs = flatArrs.concat(flatItem);
	
	    step = iterator.next();
	  }
	
	  return flatArrs;
	}
	
	function elementToTree(el) {
	  if (el === null || (typeof el === 'undefined' ? 'undefined' : _typeof(el)) !== 'object' || !('type' in el)) {
	    return el;
	  }
	  var type = el.type,
	      props = el.props,
	      key = el.key,
	      ref = el.ref;
	  var children = props.children;
	
	  var rendered = null;
	  if (isArrayLike(children)) {
	    rendered = flatten(children).map(elementToTree);
	  } else if (typeof children !== 'undefined') {
	    rendered = elementToTree(children);
	  }
	  return {
	    nodeType: nodeTypeFromType(type),
	    type: type,
	    props: props,
	    key: key || undefined,
	    ref: ref,
	    instance: null,
	    rendered: rendered
	  };
	}
	
	function propsWithKeysAndRef(node) {
	  if (node.ref !== null || node.key !== null) {
	    return (0, _object2['default'])({}, node.props, {
	      key: node.key,
	      ref: node.ref
	    });
	  }
	  return node.props;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports['default'] = createMountWrapper;
	
	var _object = __webpack_require__(86);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint react/forbid-prop-types: 0 */
	
	/**
	 * This is a utility component to wrap around the nodes we are
	 * passing in to `mount()`. Theoretically, you could do everything
	 * we are doing without this, but this makes it easier since
	 * `renderIntoDocument()` doesn't really pass back a reference to
	 * the DOM node it rendered to, so we can't really "re-render" to
	 * pass new props in.
	 */
	function createMountWrapper(node) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var WrapperComponent = function (_React$Component) {
	    _inherits(WrapperComponent, _React$Component);
	
	    function WrapperComponent() {
	      var _ref;
	
	      _classCallCheck(this, WrapperComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var _this = _possibleConstructorReturn(this, (_ref = WrapperComponent.__proto__ || Object.getPrototypeOf(WrapperComponent)).call.apply(_ref, [this].concat(args)));
	
	      _this.state = {
	        mount: true,
	        props: _this.props.props,
	        context: _this.props.context
	      };
	      return _this;
	    }
	
	    _createClass(WrapperComponent, [{
	      key: 'setChildProps',
	      value: function () {
	        function setChildProps(newProps, newContext) {
	          var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	          var props = (0, _object2['default'])({}, this.state.props, newProps);
	          var context = (0, _object2['default'])({}, this.state.context, newContext);
	          this.setState({ props: props, context: context }, callback);
	        }
	
	        return setChildProps;
	      }()
	    }, {
	      key: 'getInstance',
	      value: function () {
	        function getInstance() {
	          var component = this._reactInternalInstance._renderedComponent;
	          var inst = component.getPublicInstance();
	          if (inst === null) {
	            return component._instance;
	          }
	          return inst;
	        }
	
	        return getInstance;
	      }()
	    }, {
	      key: 'getWrappedComponent',
	      value: function () {
	        function getWrappedComponent() {
	          var component = this._reactInternalInstance._renderedComponent;
	          var inst = component.getPublicInstance();
	          if (inst === null) {
	            return component._instance;
	          }
	          return inst;
	        }
	
	        return getWrappedComponent;
	      }()
	    }, {
	      key: 'setChildContext',
	      value: function () {
	        function setChildContext(context) {
	          var _this2 = this;
	
	          return new Promise(function (resolve) {
	            return _this2.setState({ context: context }, resolve);
	          });
	        }
	
	        return setChildContext;
	      }()
	    }, {
	      key: 'render',
	      value: function () {
	        function render() {
	          var Component = this.props.Component;
	          var _state = this.state,
	              mount = _state.mount,
	              props = _state.props;
	
	          if (!mount) return null;
	          return _react2['default'].createElement(Component, props);
	        }
	
	        return render;
	      }()
	    }]);
	
	    return WrapperComponent;
	  }(_react2['default'].Component);
	
	  WrapperComponent.propTypes = {
	    Component: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].string]).isRequired,
	    props: _propTypes2['default'].object.isRequired,
	    context: _propTypes2['default'].object
	  };
	  WrapperComponent.defaultProps = {
	    context: null
	  };
	
	  if (options.context && (node.type.contextTypes || options.childContextTypes)) {
	    // For full rendering, we are using this wrapper component to provide context if it is
	    // specified in both the options AND the child component defines `contextTypes` statically
	    // OR the merged context types for all children (the node component or deeper children) are
	    // specified in options parameter under childContextTypes.
	    // In that case, we define both a `getChildContext()` function and a `childContextTypes` prop.
	    var childContextTypes = (0, _object2['default'])({}, node.type.contextTypes, options.childContextTypes);
	
	    WrapperComponent.prototype.getChildContext = function () {
	      function getChildContext() {
	        return this.state.context;
	      }
	
	      return getChildContext;
	    }();
	    WrapperComponent.childContextTypes = childContextTypes;
	  }
	  return WrapperComponent;
	}

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports['default'] = createRenderWrapper;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createRenderWrapper(node, context, childContextTypes) {
	  var ContextWrapper = function (_React$Component) {
	    _inherits(ContextWrapper, _React$Component);
	
	    function ContextWrapper() {
	      _classCallCheck(this, ContextWrapper);
	
	      return _possibleConstructorReturn(this, (ContextWrapper.__proto__ || Object.getPrototypeOf(ContextWrapper)).apply(this, arguments));
	    }
	
	    _createClass(ContextWrapper, [{
	      key: 'getChildContext',
	      value: function () {
	        function getChildContext() {
	          return context;
	        }
	
	        return getChildContext;
	      }()
	    }, {
	      key: 'render',
	      value: function () {
	        function render() {
	          return node;
	        }
	
	        return render;
	      }()
	    }]);
	
	    return ContextWrapper;
	  }(_react2['default'].Component);
	
	  ContextWrapper.childContextTypes = childContextTypes;
	  return ContextWrapper;
	}

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint global-require: 0 */
	module.exports = __webpack_require__(1175);

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = mount;
	
	var _ReactWrapper = __webpack_require__(604);
	
	var _ReactWrapper2 = _interopRequireDefault(_ReactWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Mounts and renders a react component into the document and provides a testing wrapper around it.
	 *
	 * @param node
	 * @returns {ReactWrapper}
	 */
	function mount(node, options) {
	  return new _ReactWrapper2['default'](node, null, options);
	}

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = render;
	
	var _object = __webpack_require__(86);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _cheerio = __webpack_require__(383);
	
	var _cheerio2 = _interopRequireDefault(_cheerio);
	
	var _Utils = __webpack_require__(216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Renders a react component into static HTML and provides a cheerio wrapper around it. This is
	 * somewhat asymmetric with `mount` and `shallow`, which don't use any external libraries, but
	 * Cheerio's API is pretty close to what we actually want and has a significant amount of utility
	 * that would be recreating the wheel if we didn't use it.
	 *
	 * I think there are a lot of good use cases to use `render` instead of `shallow` or `mount`, and
	 * thus I'd like to keep this API in here even though it's not really "ours".
	 *
	 * @param node
	 * @param options
	 * @returns {Cheerio}
	 */
	
	function render(node) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var adapter = (0, _Utils.getAdapter)(options);
	  var renderer = adapter.createRenderer((0, _object2['default'])({ mode: 'string' }, options));
	  var html = renderer.render(node, options.context);
	  return _cheerio2['default'].load('')(html);
	}

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = shallow;
	
	var _ShallowWrapper = __webpack_require__(605);
	
	var _ShallowWrapper2 = _interopRequireDefault(_ShallowWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Shallow renders a react component and provides a testing wrapper around it.
	 *
	 * @param node
	 * @returns {ShallowWrapper}
	 */
	function shallow(node, options) {
	  return new _ShallowWrapper2['default'](node, null, options);
	}

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(177);
	var toPrimitive = __webpack_require__(1187);
	
	var toStr = Object.prototype.toString;
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	var SymbolIterator = hasSymbols ? Symbol.iterator : null;
	
	var $isNaN = __webpack_require__(613);
	var $isFinite = __webpack_require__(612);
	var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	
	var assign = __webpack_require__(611);
	var sign = __webpack_require__(615);
	var mod = __webpack_require__(614);
	var isPrimitive = __webpack_require__(1185);
	var parseInteger = parseInt;
	var bind = __webpack_require__(135);
	var arraySlice = bind.call(Function.call, Array.prototype.slice);
	var strSlice = bind.call(Function.call, String.prototype.slice);
	var isBinary = bind.call(Function.call, RegExp.prototype.test, /^0b[01]+$/i);
	var isOctal = bind.call(Function.call, RegExp.prototype.test, /^0o[0-7]+$/i);
	var regexExec = bind.call(Function.call, RegExp.prototype.exec);
	var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
	var nonWSregex = new RegExp('[' + nonWS + ']', 'g');
	var hasNonWS = bind.call(Function.call, RegExp.prototype.test, nonWSregex);
	var invalidHexLiteral = /^[-+]0x[0-9a-f]+$/i;
	var isInvalidHexLiteral = bind.call(Function.call, RegExp.prototype.test, invalidHexLiteral);
	
	// whitespace from: http://es5.github.io/#x15.5.4.20
	// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
	var ws = [
		'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
		'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
		'\u2029\uFEFF'
	].join('');
	var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
	var replace = bind.call(Function.call, String.prototype.replace);
	var trim = function (value) {
		return replace(value, trimRegex, '');
	};
	
	var ES5 = __webpack_require__(1184);
	
	var hasRegExpMatcher = __webpack_require__(2733);
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations
	var ES6 = assign(assign({}, ES5), {
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
		Call: function Call(F, V) {
			var args = arguments.length > 2 ? arguments[2] : [];
			if (!this.IsCallable(F)) {
				throw new TypeError(F + ' is not a function');
			}
			return F.apply(V, args);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
		ToPrimitive: toPrimitive,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
		// ToBoolean: ES5.ToBoolean,
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-tonumber
		ToNumber: function ToNumber(argument) {
			var value = isPrimitive(argument) ? argument : toPrimitive(argument, Number);
			if (typeof value === 'symbol') {
				throw new TypeError('Cannot convert a Symbol value to a number');
			}
			if (typeof value === 'string') {
				if (isBinary(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 2));
				} else if (isOctal(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 8));
				} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
					return NaN;
				} else {
					var trimmed = trim(value);
					if (trimmed !== value) {
						return this.ToNumber(trimmed);
					}
				}
			}
			return Number(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
		// ToInteger: ES5.ToNumber,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
		// ToInt32: ES5.ToInt32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
		// ToUint32: ES5.ToUint32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
		ToInt16: function ToInt16(argument) {
			var int16bit = this.ToUint16(argument);
			return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
		// ToUint16: ES5.ToUint16,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
		ToInt8: function ToInt8(argument) {
			var int8bit = this.ToUint8(argument);
			return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
		ToUint8: function ToUint8(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * Math.floor(Math.abs(number));
			return mod(posInt, 0x100);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
		ToUint8Clamp: function ToUint8Clamp(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number <= 0) { return 0; }
			if (number >= 0xFF) { return 0xFF; }
			var f = Math.floor(argument);
			if (f + 0.5 < number) { return f + 1; }
			if (number < f + 0.5) { return f; }
			if (f % 2 !== 0) { return f + 1; }
			return f;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
		ToString: function ToString(argument) {
			if (typeof argument === 'symbol') {
				throw new TypeError('Cannot convert a Symbol value to a string');
			}
			return String(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
		ToObject: function ToObject(value) {
			this.RequireObjectCoercible(value);
			return Object(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
		ToPropertyKey: function ToPropertyKey(argument) {
			var key = this.ToPrimitive(argument, String);
			return typeof key === 'symbol' ? key : this.ToString(key);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
		ToLength: function ToLength(argument) {
			var len = this.ToInteger(argument);
			if (len <= 0) { return 0; } // includes converting -0 to +0
			if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
			return len;
		},
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
		CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
			if (toStr.call(argument) !== '[object String]') {
				throw new TypeError('must be a string');
			}
			if (argument === '-0') { return -0; }
			var n = this.ToNumber(argument);
			if (this.SameValue(this.ToString(n), argument)) { return n; }
			return void 0;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
		RequireObjectCoercible: ES5.CheckObjectCoercible,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
		IsArray: Array.isArray || function IsArray(argument) {
			return toStr.call(argument) === '[object Array]';
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
		// IsCallable: ES5.IsCallable,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
		IsConstructor: function IsConstructor(argument) {
			return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
		IsExtensible: function IsExtensible(obj) {
			if (!Object.preventExtensions) { return true; }
			if (isPrimitive(obj)) {
				return false;
			}
			return Object.isExtensible(obj);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
		IsInteger: function IsInteger(argument) {
			if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
				return false;
			}
			var abs = Math.abs(argument);
			return Math.floor(abs) === abs;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
		IsPropertyKey: function IsPropertyKey(argument) {
			return typeof argument === 'string' || typeof argument === 'symbol';
		},
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-isregexp
		IsRegExp: function IsRegExp(argument) {
			if (!argument || typeof argument !== 'object') {
				return false;
			}
			if (hasSymbols) {
				var isRegExp = argument[Symbol.match];
				if (typeof isRegExp !== 'undefined') {
					return ES5.ToBoolean(isRegExp);
				}
			}
			return hasRegExpMatcher(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
		// SameValue: ES5.SameValue,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
		SameValueZero: function SameValueZero(x, y) {
			return (x === y) || ($isNaN(x) && $isNaN(y));
		},
	
		/**
		 * 7.3.2 GetV (V, P)
		 * 1. Assert: IsPropertyKey(P) is true.
		 * 2. Let O be ToObject(V).
		 * 3. ReturnIfAbrupt(O).
		 * 4. Return O.[[Get]](P, V).
		 */
		GetV: function GetV(V, P) {
			// 7.3.2.1
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			// 7.3.2.2-3
			var O = this.ToObject(V);
	
			// 7.3.2.4
			return O[P];
		},
	
		/**
		 * 7.3.9 - http://www.ecma-international.org/ecma-262/6.0/#sec-getmethod
		 * 1. Assert: IsPropertyKey(P) is true.
		 * 2. Let func be GetV(O, P).
		 * 3. ReturnIfAbrupt(func).
		 * 4. If func is either undefined or null, return undefined.
		 * 5. If IsCallable(func) is false, throw a TypeError exception.
		 * 6. Return func.
		 */
		GetMethod: function GetMethod(O, P) {
			// 7.3.9.1
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			// 7.3.9.2
			var func = this.GetV(O, P);
	
			// 7.3.9.4
			if (func == null) {
				return void 0;
			}
	
			// 7.3.9.5
			if (!this.IsCallable(func)) {
				throw new TypeError(P + 'is not a function');
			}
	
			// 7.3.9.6
			return func;
		},
	
		/**
		 * 7.3.1 Get (O, P) - http://www.ecma-international.org/ecma-262/6.0/#sec-get-o-p
		 * 1. Assert: Type(O) is Object.
		 * 2. Assert: IsPropertyKey(P) is true.
		 * 3. Return O.[[Get]](P, O).
		 */
		Get: function Get(O, P) {
			// 7.3.1.1
			if (this.Type(O) !== 'Object') {
				throw new TypeError('Assertion failed: Type(O) is not Object');
			}
			// 7.3.1.2
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			// 7.3.1.3
			return O[P];
		},
	
		Type: function Type(x) {
			if (typeof x === 'symbol') {
				return 'Symbol';
			}
			return ES5.Type(x);
		},
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
		SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('Assertion failed: Type(O) is not Object');
			}
			var C = O.constructor;
			if (typeof C === 'undefined') {
				return defaultConstructor;
			}
			if (this.Type(C) !== 'Object') {
				throw new TypeError('O.constructor is not an Object');
			}
			var S = hasSymbols && Symbol.species ? C[Symbol.species] : void 0;
			if (S == null) {
				return defaultConstructor;
			}
			if (this.IsConstructor(S)) {
				return S;
			}
			throw new TypeError('no constructor found');
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-completepropertydescriptor
		CompletePropertyDescriptor: function CompletePropertyDescriptor(Desc) {
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new TypeError('Desc must be a Property Descriptor');
			}
	
			if (this.IsGenericDescriptor(Desc) || this.IsDataDescriptor(Desc)) {
				if (!has(Desc, '[[Value]]')) {
					Desc['[[Value]]'] = void 0;
				}
				if (!has(Desc, '[[Writable]]')) {
					Desc['[[Writable]]'] = false;
				}
			} else {
				if (!has(Desc, '[[Get]]')) {
					Desc['[[Get]]'] = void 0;
				}
				if (!has(Desc, '[[Set]]')) {
					Desc['[[Set]]'] = void 0;
				}
			}
			if (!has(Desc, '[[Enumerable]]')) {
				Desc['[[Enumerable]]'] = false;
			}
			if (!has(Desc, '[[Configurable]]')) {
				Desc['[[Configurable]]'] = false;
			}
			return Desc;
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-set-o-p-v-throw
		Set: function Set(O, P, V, Throw) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('P must be a Property Key');
			}
			if (this.Type(Throw) !== 'Boolean') {
				throw new TypeError('Throw must be a Boolean');
			}
			if (Throw) {
				O[P] = V;
				return true;
			} else {
				try {
					O[P] = V;
				} catch (e) {
					return false;
				}
			}
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-hasownproperty
		HasOwnProperty: function HasOwnProperty(O, P) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('P must be a Property Key');
			}
			return has(O, P);
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-hasproperty
		HasProperty: function HasProperty(O, P) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('P must be a Property Key');
			}
			return P in O;
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-isconcatspreadable
		IsConcatSpreadable: function IsConcatSpreadable(O) {
			if (this.Type(O) !== 'Object') {
				return false;
			}
			if (hasSymbols && typeof Symbol.isConcatSpreadable === 'symbol') {
				var spreadable = this.Get(O, Symbol.isConcatSpreadable);
				if (typeof spreadable !== 'undefined') {
					return this.ToBoolean(spreadable);
				}
			}
			return this.IsArray(O);
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-invoke
		Invoke: function Invoke(O, P) {
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('P must be a Property Key');
			}
			var argumentsList = arraySlice(arguments, 2);
			var func = this.GetV(O, P);
			return this.Call(func, O, argumentsList);
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-getiterator
		GetIterator: function GetIterator(obj, method) {
			if (!hasSymbols) {
				throw new SyntaxError('ES.GetIterator depends on native iterator support.');
			}
	
			var actualMethod = method;
			if (arguments.length < 2) {
				actualMethod = this.GetMethod(obj, SymbolIterator);
			}
			var iterator = this.Call(actualMethod, obj);
			if (this.Type(iterator) !== 'Object') {
				throw new TypeError('iterator must return an object');
			}
	
			return iterator;
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-iteratornext
		IteratorNext: function IteratorNext(iterator, value) {
			var result = this.Invoke(iterator, 'next', arguments.length < 2 ? [] : [value]);
			if (this.Type(result) !== 'Object') {
				throw new TypeError('iterator next must return an object');
			}
			return result;
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-iteratorcomplete
		IteratorComplete: function IteratorComplete(iterResult) {
			if (this.Type(iterResult) !== 'Object') {
				throw new TypeError('Assertion failed: Type(iterResult) is not Object');
			}
			return this.ToBoolean(this.Get(iterResult, 'done'));
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-iteratorvalue
		IteratorValue: function IteratorValue(iterResult) {
			if (this.Type(iterResult) !== 'Object') {
				throw new TypeError('Assertion failed: Type(iterResult) is not Object');
			}
			return this.Get(iterResult, 'value');
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-iteratorstep
		IteratorStep: function IteratorStep(iterator) {
			var result = this.IteratorNext(iterator);
			var done = this.IteratorComplete(result);
			return done === true ? false : result;
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-iteratorclose
		IteratorClose: function IteratorClose(iterator, completion) {
			if (this.Type(iterator) !== 'Object') {
				throw new TypeError('Assertion failed: Type(iterator) is not Object');
			}
			if (!this.IsCallable(completion)) {
				throw new TypeError('Assertion failed: completion is not a thunk for a Completion Record');
			}
			var completionThunk = completion;
	
			var iteratorReturn = this.GetMethod(iterator, 'return');
	
			if (typeof iteratorReturn === 'undefined') {
				return completionThunk();
			}
	
			var completionRecord;
			try {
				var innerResult = this.Call(iteratorReturn, iterator, []);
			} catch (e) {
				// if we hit here, then "e" is the innerResult completion that needs re-throwing
	
				// if the completion is of type "throw", this will throw.
				completionRecord = completionThunk();
				completionThunk = null; // ensure it's not called twice.
	
				// if not, then return the innerResult completion
				throw e;
			}
			completionRecord = completionThunk(); // if innerResult worked, then throw if the completion does
			completionThunk = null; // ensure it's not called twice.
	
			if (this.Type(innerResult) !== 'Object') {
				throw new TypeError('iterator .return must return an object');
			}
	
			return completionRecord;
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-createiterresultobject
		CreateIterResultObject: function CreateIterResultObject(value, done) {
			if (this.Type(done) !== 'Boolean') {
				throw new TypeError('Assertion failed: Type(done) is not Boolean');
			}
			return {
				value: value,
				done: done
			};
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-regexpexec
		RegExpExec: function RegExpExec(R, S) {
			if (this.Type(R) !== 'Object') {
				throw new TypeError('R must be an Object');
			}
			if (this.Type(S) !== 'String') {
				throw new TypeError('S must be a String');
			}
			var exec = this.Get(R, 'exec');
			if (this.IsCallable(exec)) {
				var result = this.Call(exec, R, [S]);
				if (result === null || this.Type(result) === 'Object') {
					return result;
				}
				throw new TypeError('"exec" method must return `null` or an Object');
			}
			return regexExec(R, S);
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-arrayspeciescreate
		ArraySpeciesCreate: function ArraySpeciesCreate(originalArray, length) {
			if (!this.IsInteger(length) || length < 0) {
				throw new TypeError('Assertion failed: length must be an integer >= 0');
			}
			var len = length === 0 ? 0 : length;
			var C;
			var isArray = this.IsArray(originalArray);
			if (isArray) {
				C = this.Get(originalArray, 'constructor');
				// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
				// if (this.IsConstructor(C)) {
				// 	if C is another realm's Array, C = undefined
				// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
				// }
				if (this.Type(C) === 'Object' && hasSymbols && Symbol.species) {
					C = this.Get(C, Symbol.species);
					if (C === null) {
						C = void 0;
					}
				}
			}
			if (typeof C === 'undefined') {
				return Array(len);
			}
			if (!this.IsConstructor(C)) {
				throw new TypeError('C must be a constructor');
			}
			return new C(len); // this.Construct(C, len);
		},
	
		CreateDataProperty: function CreateDataProperty(O, P, V) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('Assertion failed: Type(O) is not Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			var oldDesc = Object.getOwnPropertyDescriptor(O, P);
			var extensible = oldDesc || (typeof Object.isExtensible !== 'function' || Object.isExtensible(O));
			var immutable = oldDesc && (!oldDesc.writable || !oldDesc.configurable);
			if (immutable || !extensible) {
				return false;
			}
			var newDesc = {
				configurable: true,
				enumerable: true,
				value: V,
				writable: true
			};
			Object.defineProperty(O, P, newDesc);
			return true;
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow
		CreateDataPropertyOrThrow: function CreateDataPropertyOrThrow(O, P, V) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('Assertion failed: Type(O) is not Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			var success = this.CreateDataProperty(O, P, V);
			if (!success) {
				throw new TypeError('unable to create data property');
			}
			return success;
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-advancestringindex
		AdvanceStringIndex: function AdvanceStringIndex(S, index, unicode) {
			if (this.Type(S) !== 'String') {
				throw new TypeError('Assertion failed: Type(S) is not String');
			}
			if (!this.IsInteger(index)) {
				throw new TypeError('Assertion failed: length must be an integer >= 0 and <= (2**53 - 1)');
			}
			if (index < 0 || index > MAX_SAFE_INTEGER) {
				throw new RangeError('Assertion failed: length must be an integer >= 0 and <= (2**53 - 1)');
			}
			if (this.Type(unicode) !== 'Boolean') {
				throw new TypeError('Assertion failed: Type(unicode) is not Boolean');
			}
			if (!unicode) {
				return index + 1;
			}
			var length = S.length;
			if ((index + 1) >= length) {
				return index + 1;
			}
			var first = S.charCodeAt(index);
			if (first < 0xD800 || first > 0xDBFF) {
				return index + 1;
			}
			var second = S.charCodeAt(index + 1);
			if (second < 0xDC00 || second > 0xDFFF) {
				return index + 1;
			}
			return index + 2;
		}
	});
	
	delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible
	
	module.exports = ES6;


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES2015 = __webpack_require__(1182);
	var assign = __webpack_require__(611);
	
	var ES2016 = assign(assign({}, ES2015), {
		// https://github.com/tc39/ecma262/pull/60
		SameValueNonNumber: function SameValueNonNumber(x, y) {
			if (typeof x === 'number' || typeof x !== typeof y) {
				throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
			}
			return this.SameValue(x, y);
		}
	});
	
	module.exports = ES2016;


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $isNaN = __webpack_require__(613);
	var $isFinite = __webpack_require__(612);
	
	var sign = __webpack_require__(615);
	var mod = __webpack_require__(614);
	
	var IsCallable = __webpack_require__(220);
	var toPrimitive = __webpack_require__(1186);
	
	var has = __webpack_require__(177);
	
	// https://es5.github.io/#x9
	var ES5 = {
		ToPrimitive: toPrimitive,
	
		ToBoolean: function ToBoolean(value) {
			return !!value;
		},
		ToNumber: function ToNumber(value) {
			return Number(value);
		},
		ToInteger: function ToInteger(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number)) { return 0; }
			if (number === 0 || !$isFinite(number)) { return number; }
			return sign(number) * Math.floor(Math.abs(number));
		},
		ToInt32: function ToInt32(x) {
			return this.ToNumber(x) >> 0;
		},
		ToUint32: function ToUint32(x) {
			return this.ToNumber(x) >>> 0;
		},
		ToUint16: function ToUint16(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * Math.floor(Math.abs(number));
			return mod(posInt, 0x10000);
		},
		ToString: function ToString(value) {
			return String(value);
		},
		ToObject: function ToObject(value) {
			this.CheckObjectCoercible(value);
			return Object(value);
		},
		CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
			/* jshint eqnull:true */
			if (value == null) {
				throw new TypeError(optMessage || 'Cannot call method on ' + value);
			}
			return value;
		},
		IsCallable: IsCallable,
		SameValue: function SameValue(x, y) {
			if (x === y) { // 0 === -0, but they are not identical.
				if (x === 0) { return 1 / x === 1 / y; }
				return true;
			}
			return $isNaN(x) && $isNaN(y);
		},
	
		// http://www.ecma-international.org/ecma-262/5.1/#sec-8
		Type: function Type(x) {
			if (x === null) {
				return 'Null';
			}
			if (typeof x === 'undefined') {
				return 'Undefined';
			}
			if (typeof x === 'function' || typeof x === 'object') {
				return 'Object';
			}
			if (typeof x === 'number') {
				return 'Number';
			}
			if (typeof x === 'boolean') {
				return 'Boolean';
			}
			if (typeof x === 'string') {
				return 'String';
			}
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
		IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
			if (this.Type(Desc) !== 'Object') {
				return false;
			}
			var allowed = {
				'[[Configurable]]': true,
				'[[Enumerable]]': true,
				'[[Get]]': true,
				'[[Set]]': true,
				'[[Value]]': true,
				'[[Writable]]': true
			};
			// jscs:disable
			for (var key in Desc) { // eslint-disable-line
				if (has(Desc, key) && !allowed[key]) {
					return false;
				}
			}
			// jscs:enable
			var isData = has(Desc, '[[Value]]');
			var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
			if (isData && IsAccessor) {
				throw new TypeError('Property Descriptors may not be both accessor and data descriptors');
			}
			return true;
		},
	
		// http://ecma-international.org/ecma-262/5.1/#sec-8.10.1
		IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new TypeError('Desc must be a Property Descriptor');
			}
	
			if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
				return false;
			}
	
			return true;
		},
	
		// http://ecma-international.org/ecma-262/5.1/#sec-8.10.2
		IsDataDescriptor: function IsDataDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new TypeError('Desc must be a Property Descriptor');
			}
	
			if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
				return false;
			}
	
			return true;
		},
	
		// http://ecma-international.org/ecma-262/5.1/#sec-8.10.3
		IsGenericDescriptor: function IsGenericDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new TypeError('Desc must be a Property Descriptor');
			}
	
			if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
				return true;
			}
	
			return false;
		},
	
		// http://ecma-international.org/ecma-262/5.1/#sec-8.10.4
		FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return Desc;
			}
	
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new TypeError('Desc must be a Property Descriptor');
			}
	
			if (this.IsDataDescriptor(Desc)) {
				return {
					value: Desc['[[Value]]'],
					writable: !!Desc['[[Writable]]'],
					enumerable: !!Desc['[[Enumerable]]'],
					configurable: !!Desc['[[Configurable]]']
				};
			} else if (this.IsAccessorDescriptor(Desc)) {
				return {
					get: Desc['[[Get]]'],
					set: Desc['[[Set]]'],
					enumerable: !!Desc['[[Enumerable]]'],
					configurable: !!Desc['[[Configurable]]']
				};
			} else {
				throw new TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
			}
		},
	
		// http://ecma-international.org/ecma-262/5.1/#sec-8.10.5
		ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
			if (this.Type(Obj) !== 'Object') {
				throw new TypeError('ToPropertyDescriptor requires an object');
			}
	
			var desc = {};
			if (has(Obj, 'enumerable')) {
				desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
			}
			if (has(Obj, 'configurable')) {
				desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
			}
			if (has(Obj, 'value')) {
				desc['[[Value]]'] = Obj.value;
			}
			if (has(Obj, 'writable')) {
				desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
			}
			if (has(Obj, 'get')) {
				var getter = Obj.get;
				if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
					throw new TypeError('getter must be a function');
				}
				desc['[[Get]]'] = getter;
			}
			if (has(Obj, 'set')) {
				var setter = Obj.set;
				if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
					throw new TypeError('setter must be a function');
				}
				desc['[[Set]]'] = setter;
			}
	
			if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
				throw new TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
			}
			return desc;
		}
	};
	
	module.exports = ES5;


/***/ }),
/* 1185 */
/***/ (function(module, exports) {

	module.exports = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	var isPrimitive = __webpack_require__(616);
	
	var isCallable = __webpack_require__(220);
	
	// https://es5.github.io/#x8.12
	var ES5internalSlots = {
		'[[DefaultValue]]': function (O, hint) {
			var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);
	
			if (actualHint === String || actualHint === Number) {
				var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
				var value, i;
				for (i = 0; i < methods.length; ++i) {
					if (isCallable(O[methods[i]])) {
						value = O[methods[i]]();
						if (isPrimitive(value)) {
							return value;
						}
					}
				}
				throw new TypeError('No default value');
			}
			throw new TypeError('invalid [[DefaultValue]] hint supplied');
		}
	};
	
	// https://es5.github.io/#x9
	module.exports = function ToPrimitive(input, PreferredType) {
		if (isPrimitive(input)) {
			return input;
		}
		return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
	};


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	
	var isPrimitive = __webpack_require__(616);
	var isCallable = __webpack_require__(220);
	var isDate = __webpack_require__(2731);
	var isSymbol = __webpack_require__(2736);
	
	var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
		if (typeof O === 'undefined' || O === null) {
			throw new TypeError('Cannot call method on ' + O);
		}
		if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
			throw new TypeError('hint must be "string" or "number"');
		}
		var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
		var method, result, i;
		for (i = 0; i < methodNames.length; ++i) {
			method = O[methodNames[i]];
			if (isCallable(method)) {
				result = method.call(O);
				if (isPrimitive(result)) {
					return result;
				}
			}
		}
		throw new TypeError('No default value');
	};
	
	var GetMethod = function GetMethod(O, P) {
		var func = O[P];
		if (func !== null && typeof func !== 'undefined') {
			if (!isCallable(func)) {
				throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
			}
			return func;
		}
	};
	
	// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
	module.exports = function ToPrimitive(input, PreferredType) {
		if (isPrimitive(input)) {
			return input;
		}
		var hint = 'default';
		if (arguments.length > 1) {
			if (PreferredType === String) {
				hint = 'string';
			} else if (PreferredType === Number) {
				hint = 'number';
			}
		}
	
		var exoticToPrim;
		if (hasSymbols) {
			if (Symbol.toPrimitive) {
				exoticToPrim = GetMethod(input, Symbol.toPrimitive);
			} else if (isSymbol(input)) {
				exoticToPrim = Symbol.prototype.valueOf;
			}
		}
		if (typeof exoticToPrim !== 'undefined') {
			var result = exoticToPrim.call(input, hint);
			if (isPrimitive(result)) {
				return result;
			}
			throw new TypeError('unable to convert exotic object to primitive');
		}
		if (hint === 'default' && (isDate(input) || isSymbol(input))) {
			hint = 'string';
		}
		return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
	};


/***/ }),
/* 1188 */,
/* 1189 */
/***/ (function(module, exports) {

	'use strict';
	
	var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
	
	module.exports = function (str) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		return str.replace(matchOperatorsRe, '\\$&');
	};


/***/ }),
/* 1190 */
/***/ (function(module, exports) {

	/*
	  Copyright (C) 2013 Yusuke Suzuki <utatane.tea@gmail.com>
	
	  Redistribution and use in source and binary forms, with or without
	  modification, are permitted provided that the following conditions are met:
	
	    * Redistributions of source code must retain the above copyright
	      notice, this list of conditions and the following disclaimer.
	    * Redistributions in binary form must reproduce the above copyright
	      notice, this list of conditions and the following disclaimer in the
	      documentation and/or other materials provided with the distribution.
	
	  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS'
	  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
	  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
	  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
	  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
	  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
	  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	(function () {
	    'use strict';
	
	    function isExpression(node) {
	        if (node == null) { return false; }
	        switch (node.type) {
	            case 'ArrayExpression':
	            case 'AssignmentExpression':
	            case 'BinaryExpression':
	            case 'CallExpression':
	            case 'ConditionalExpression':
	            case 'FunctionExpression':
	            case 'Identifier':
	            case 'Literal':
	            case 'LogicalExpression':
	            case 'MemberExpression':
	            case 'NewExpression':
	            case 'ObjectExpression':
	            case 'SequenceExpression':
	            case 'ThisExpression':
	            case 'UnaryExpression':
	            case 'UpdateExpression':
	                return true;
	        }
	        return false;
	    }
	
	    function isIterationStatement(node) {
	        if (node == null) { return false; }
	        switch (node.type) {
	            case 'DoWhileStatement':
	            case 'ForInStatement':
	            case 'ForStatement':
	            case 'WhileStatement':
	                return true;
	        }
	        return false;
	    }
	
	    function isStatement(node) {
	        if (node == null) { return false; }
	        switch (node.type) {
	            case 'BlockStatement':
	            case 'BreakStatement':
	            case 'ContinueStatement':
	            case 'DebuggerStatement':
	            case 'DoWhileStatement':
	            case 'EmptyStatement':
	            case 'ExpressionStatement':
	            case 'ForInStatement':
	            case 'ForStatement':
	            case 'IfStatement':
	            case 'LabeledStatement':
	            case 'ReturnStatement':
	            case 'SwitchStatement':
	            case 'ThrowStatement':
	            case 'TryStatement':
	            case 'VariableDeclaration':
	            case 'WhileStatement':
	            case 'WithStatement':
	                return true;
	        }
	        return false;
	    }
	
	    function isSourceElement(node) {
	      return isStatement(node) || node != null && node.type === 'FunctionDeclaration';
	    }
	
	    function trailingStatement(node) {
	        switch (node.type) {
	        case 'IfStatement':
	            if (node.alternate != null) {
	                return node.alternate;
	            }
	            return node.consequent;
	
	        case 'LabeledStatement':
	        case 'ForStatement':
	        case 'ForInStatement':
	        case 'WhileStatement':
	        case 'WithStatement':
	            return node.body;
	        }
	        return null;
	    }
	
	    function isProblematicIfStatement(node) {
	        var current;
	
	        if (node.type !== 'IfStatement') {
	            return false;
	        }
	        if (node.alternate == null) {
	            return false;
	        }
	        current = node.consequent;
	        do {
	            if (current.type === 'IfStatement') {
	                if (current.alternate == null)  {
	                    return true;
	                }
	            }
	            current = trailingStatement(current);
	        } while (current);
	
	        return false;
	    }
	
	    module.exports = {
	        isExpression: isExpression,
	        isStatement: isStatement,
	        isIterationStatement: isIterationStatement,
	        isSourceElement: isSourceElement,
	        isProblematicIfStatement: isProblematicIfStatement,
	
	        trailingStatement: trailingStatement
	    };
	}());
	/* vim: set sw=4 ts=4 et tw=80 : */


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	  Copyright (C) 2013 Yusuke Suzuki <utatane.tea@gmail.com>
	
	  Redistribution and use in source and binary forms, with or without
	  modification, are permitted provided that the following conditions are met:
	
	    * Redistributions of source code must retain the above copyright
	      notice, this list of conditions and the following disclaimer.
	    * Redistributions in binary form must reproduce the above copyright
	      notice, this list of conditions and the following disclaimer in the
	      documentation and/or other materials provided with the distribution.
	
	  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
	  ARE DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
	  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
	  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
	  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
	  ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
	  THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	(function () {
	    'use strict';
	
	    var code = __webpack_require__(617);
	
	    function isStrictModeReservedWordES6(id) {
	        switch (id) {
	        case 'implements':
	        case 'interface':
	        case 'package':
	        case 'private':
	        case 'protected':
	        case 'public':
	        case 'static':
	        case 'let':
	            return true;
	        default:
	            return false;
	        }
	    }
	
	    function isKeywordES5(id, strict) {
	        // yield should not be treated as keyword under non-strict mode.
	        if (!strict && id === 'yield') {
	            return false;
	        }
	        return isKeywordES6(id, strict);
	    }
	
	    function isKeywordES6(id, strict) {
	        if (strict && isStrictModeReservedWordES6(id)) {
	            return true;
	        }
	
	        switch (id.length) {
	        case 2:
	            return (id === 'if') || (id === 'in') || (id === 'do');
	        case 3:
	            return (id === 'var') || (id === 'for') || (id === 'new') || (id === 'try');
	        case 4:
	            return (id === 'this') || (id === 'else') || (id === 'case') ||
	                (id === 'void') || (id === 'with') || (id === 'enum');
	        case 5:
	            return (id === 'while') || (id === 'break') || (id === 'catch') ||
	                (id === 'throw') || (id === 'const') || (id === 'yield') ||
	                (id === 'class') || (id === 'super');
	        case 6:
	            return (id === 'return') || (id === 'typeof') || (id === 'delete') ||
	                (id === 'switch') || (id === 'export') || (id === 'import');
	        case 7:
	            return (id === 'default') || (id === 'finally') || (id === 'extends');
	        case 8:
	            return (id === 'function') || (id === 'continue') || (id === 'debugger');
	        case 10:
	            return (id === 'instanceof');
	        default:
	            return false;
	        }
	    }
	
	    function isReservedWordES5(id, strict) {
	        return id === 'null' || id === 'true' || id === 'false' || isKeywordES5(id, strict);
	    }
	
	    function isReservedWordES6(id, strict) {
	        return id === 'null' || id === 'true' || id === 'false' || isKeywordES6(id, strict);
	    }
	
	    function isRestrictedWord(id) {
	        return id === 'eval' || id === 'arguments';
	    }
	
	    function isIdentifierNameES5(id) {
	        var i, iz, ch;
	
	        if (id.length === 0) { return false; }
	
	        ch = id.charCodeAt(0);
	        if (!code.isIdentifierStartES5(ch)) {
	            return false;
	        }
	
	        for (i = 1, iz = id.length; i < iz; ++i) {
	            ch = id.charCodeAt(i);
	            if (!code.isIdentifierPartES5(ch)) {
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function decodeUtf16(lead, trail) {
	        return (lead - 0xD800) * 0x400 + (trail - 0xDC00) + 0x10000;
	    }
	
	    function isIdentifierNameES6(id) {
	        var i, iz, ch, lowCh, check;
	
	        if (id.length === 0) { return false; }
	
	        check = code.isIdentifierStartES6;
	        for (i = 0, iz = id.length; i < iz; ++i) {
	            ch = id.charCodeAt(i);
	            if (0xD800 <= ch && ch <= 0xDBFF) {
	                ++i;
	                if (i >= iz) { return false; }
	                lowCh = id.charCodeAt(i);
	                if (!(0xDC00 <= lowCh && lowCh <= 0xDFFF)) {
	                    return false;
	                }
	                ch = decodeUtf16(ch, lowCh);
	            }
	            if (!check(ch)) {
	                return false;
	            }
	            check = code.isIdentifierPartES6;
	        }
	        return true;
	    }
	
	    function isIdentifierES5(id, strict) {
	        return isIdentifierNameES5(id) && !isReservedWordES5(id, strict);
	    }
	
	    function isIdentifierES6(id, strict) {
	        return isIdentifierNameES6(id) && !isReservedWordES6(id, strict);
	    }
	
	    module.exports = {
	        isKeywordES5: isKeywordES5,
	        isKeywordES6: isKeywordES6,
	        isReservedWordES5: isReservedWordES5,
	        isReservedWordES6: isReservedWordES6,
	        isRestrictedWord: isRestrictedWord,
	        isIdentifierNameES5: isIdentifierNameES5,
	        isIdentifierNameES6: isIdentifierNameES6,
	        isIdentifierES5: isIdentifierES5,
	        isIdentifierES6: isIdentifierES6
	    };
	}());
	/* vim: set sw=4 ts=4 et tw=80 : */


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(1233);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(1230);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(1232);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */
/***/ (function(module, exports) {

	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	module.exports = function forEach (obj, fn, ctx) {
	    if (toString.call(fn) !== '[object Function]') {
	        throw new TypeError('iterator must be a function');
	    }
	    var l = obj.length;
	    if (l === +l) {
	        for (var i = 0; i < l; i++) {
	            fn.call(ctx, obj[i], i, obj);
	        }
	    } else {
	        for (var k in obj) {
	            if (hasOwn.call(obj, k)) {
	                fn.call(ctx, obj[k], k, obj);
	            }
	        }
	    }
	};
	


/***/ }),
/* 1240 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(96).supportsDescriptors;
	var functionsHaveNames = __webpack_require__(620);
	var getPolyfill = __webpack_require__(622);
	var defineProperty = Object.defineProperty;
	var TypeErr = TypeError;
	
	module.exports = function shimName() {
		var polyfill = getPolyfill();
		if (functionsHaveNames) {
			return polyfill;
		}
		if (!supportsDescriptors) {
			throw new TypeErr('Shimming Function.prototype.name support requires ES5 property descriptor support.');
		}
		var functionProto = Function.prototype;
		defineProperty(functionProto, 'name', {
			configurable: true,
			enumerable: false,
			get: function () {
				var name = polyfill.call(this);
				if (this !== functionProto) {
					defineProperty(this, 'name', {
						configurable: true,
						enumerable: false,
						value: name,
						writable: false
					});
				}
				return name;
			}
		});
		return polyfill;
	};


/***/ }),
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */,
/* 2263 */,
/* 2264 */,
/* 2265 */,
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */,
/* 2272 */,
/* 2273 */,
/* 2274 */,
/* 2275 */,
/* 2276 */,
/* 2277 */,
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */,
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */,
/* 2289 */,
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */,
/* 2308 */,
/* 2309 */,
/* 2310 */,
/* 2311 */,
/* 2312 */,
/* 2313 */,
/* 2314 */,
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */,
/* 2322 */,
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */,
/* 2327 */,
/* 2328 */,
/* 2329 */,
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */,
/* 2350 */,
/* 2351 */,
/* 2352 */,
/* 2353 */,
/* 2354 */,
/* 2355 */,
/* 2356 */,
/* 2357 */,
/* 2358 */,
/* 2359 */,
/* 2360 */,
/* 2361 */,
/* 2362 */,
/* 2363 */,
/* 2364 */,
/* 2365 */,
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */,
/* 2370 */,
/* 2371 */,
/* 2372 */,
/* 2373 */,
/* 2374 */,
/* 2375 */,
/* 2376 */,
/* 2377 */,
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */,
/* 2383 */,
/* 2384 */,
/* 2385 */,
/* 2386 */,
/* 2387 */,
/* 2388 */,
/* 2389 */,
/* 2390 */,
/* 2391 */,
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */,
/* 2408 */,
/* 2409 */,
/* 2410 */,
/* 2411 */,
/* 2412 */,
/* 2413 */,
/* 2414 */,
/* 2415 */,
/* 2416 */,
/* 2417 */,
/* 2418 */,
/* 2419 */,
/* 2420 */,
/* 2421 */,
/* 2422 */,
/* 2423 */,
/* 2424 */,
/* 2425 */,
/* 2426 */,
/* 2427 */,
/* 2428 */,
/* 2429 */,
/* 2430 */,
/* 2431 */,
/* 2432 */,
/* 2433 */,
/* 2434 */,
/* 2435 */,
/* 2436 */,
/* 2437 */,
/* 2438 */,
/* 2439 */,
/* 2440 */,
/* 2441 */,
/* 2442 */,
/* 2443 */,
/* 2444 */,
/* 2445 */,
/* 2446 */,
/* 2447 */,
/* 2448 */,
/* 2449 */,
/* 2450 */,
/* 2451 */,
/* 2452 */,
/* 2453 */,
/* 2454 */,
/* 2455 */,
/* 2456 */,
/* 2457 */,
/* 2458 */,
/* 2459 */,
/* 2460 */,
/* 2461 */,
/* 2462 */,
/* 2463 */,
/* 2464 */,
/* 2465 */,
/* 2466 */,
/* 2467 */,
/* 2468 */,
/* 2469 */,
/* 2470 */,
/* 2471 */,
/* 2472 */,
/* 2473 */,
/* 2474 */,
/* 2475 */,
/* 2476 */,
/* 2477 */,
/* 2478 */,
/* 2479 */,
/* 2480 */,
/* 2481 */,
/* 2482 */,
/* 2483 */,
/* 2484 */,
/* 2485 */,
/* 2486 */,
/* 2487 */,
/* 2488 */,
/* 2489 */,
/* 2490 */,
/* 2491 */,
/* 2492 */,
/* 2493 */,
/* 2494 */,
/* 2495 */,
/* 2496 */,
/* 2497 */,
/* 2498 */,
/* 2499 */,
/* 2500 */,
/* 2501 */,
/* 2502 */,
/* 2503 */,
/* 2504 */,
/* 2505 */,
/* 2506 */,
/* 2507 */,
/* 2508 */,
/* 2509 */,
/* 2510 */,
/* 2511 */,
/* 2512 */,
/* 2513 */,
/* 2514 */,
/* 2515 */,
/* 2516 */,
/* 2517 */,
/* 2518 */,
/* 2519 */,
/* 2520 */,
/* 2521 */,
/* 2522 */,
/* 2523 */,
/* 2524 */,
/* 2525 */,
/* 2526 */,
/* 2527 */,
/* 2528 */,
/* 2529 */,
/* 2530 */,
/* 2531 */,
/* 2532 */,
/* 2533 */,
/* 2534 */,
/* 2535 */,
/* 2536 */,
/* 2537 */,
/* 2538 */,
/* 2539 */,
/* 2540 */,
/* 2541 */,
/* 2542 */,
/* 2543 */,
/* 2544 */,
/* 2545 */,
/* 2546 */,
/* 2547 */,
/* 2548 */,
/* 2549 */,
/* 2550 */,
/* 2551 */,
/* 2552 */,
/* 2553 */,
/* 2554 */,
/* 2555 */,
/* 2556 */,
/* 2557 */,
/* 2558 */,
/* 2559 */,
/* 2560 */,
/* 2561 */,
/* 2562 */,
/* 2563 */,
/* 2564 */,
/* 2565 */,
/* 2566 */,
/* 2567 */,
/* 2568 */,
/* 2569 */,
/* 2570 */,
/* 2571 */,
/* 2572 */,
/* 2573 */,
/* 2574 */,
/* 2575 */,
/* 2576 */,
/* 2577 */,
/* 2578 */,
/* 2579 */,
/* 2580 */,
/* 2581 */,
/* 2582 */,
/* 2583 */,
/* 2584 */,
/* 2585 */,
/* 2586 */,
/* 2587 */,
/* 2588 */,
/* 2589 */,
/* 2590 */,
/* 2591 */,
/* 2592 */,
/* 2593 */,
/* 2594 */,
/* 2595 */,
/* 2596 */,
/* 2597 */,
/* 2598 */,
/* 2599 */,
/* 2600 */,
/* 2601 */,
/* 2602 */,
/* 2603 */,
/* 2604 */,
/* 2605 */,
/* 2606 */,
/* 2607 */,
/* 2608 */,
/* 2609 */,
/* 2610 */,
/* 2611 */,
/* 2612 */,
/* 2613 */,
/* 2614 */,
/* 2615 */,
/* 2616 */,
/* 2617 */,
/* 2618 */,
/* 2619 */,
/* 2620 */,
/* 2621 */,
/* 2622 */,
/* 2623 */,
/* 2624 */,
/* 2625 */,
/* 2626 */,
/* 2627 */,
/* 2628 */,
/* 2629 */,
/* 2630 */,
/* 2631 */,
/* 2632 */,
/* 2633 */,
/* 2634 */,
/* 2635 */,
/* 2636 */,
/* 2637 */,
/* 2638 */,
/* 2639 */,
/* 2640 */,
/* 2641 */,
/* 2642 */,
/* 2643 */,
/* 2644 */,
/* 2645 */,
/* 2646 */,
/* 2647 */,
/* 2648 */,
/* 2649 */,
/* 2650 */,
/* 2651 */,
/* 2652 */,
/* 2653 */,
/* 2654 */,
/* 2655 */,
/* 2656 */,
/* 2657 */,
/* 2658 */,
/* 2659 */,
/* 2660 */,
/* 2661 */,
/* 2662 */,
/* 2663 */,
/* 2664 */,
/* 2665 */,
/* 2666 */,
/* 2667 */,
/* 2668 */,
/* 2669 */,
/* 2670 */,
/* 2671 */,
/* 2672 */,
/* 2673 */,
/* 2674 */,
/* 2675 */,
/* 2676 */,
/* 2677 */,
/* 2678 */,
/* 2679 */,
/* 2680 */,
/* 2681 */,
/* 2682 */,
/* 2683 */,
/* 2684 */,
/* 2685 */,
/* 2686 */,
/* 2687 */,
/* 2688 */,
/* 2689 */,
/* 2690 */,
/* 2691 */,
/* 2692 */,
/* 2693 */,
/* 2694 */,
/* 2695 */,
/* 2696 */,
/* 2697 */,
/* 2698 */,
/* 2699 */,
/* 2700 */,
/* 2701 */,
/* 2702 */,
/* 2703 */,
/* 2704 */,
/* 2705 */,
/* 2706 */,
/* 2707 */,
/* 2708 */,
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(314);
	
	var _scrollBehavior = __webpack_require__(4757);
	
	var _scrollBehavior2 = _interopRequireDefault(_scrollBehavior);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StateStorage = __webpack_require__(2711);
	
	var _StateStorage2 = _interopRequireDefault(_StateStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  shouldUpdateScroll: _propTypes2.default.func,
	  children: _propTypes2.default.element.isRequired,
	  location: _propTypes2.default.object.isRequired,
	  history: _propTypes2.default.object.isRequired
	};
	
	var childContextTypes = {
	  scrollBehavior: _propTypes2.default.object.isRequired
	};
	
	var ScrollContext = function (_React$Component) {
	  (0, _inherits3.default)(ScrollContext, _React$Component);
	
	  function ScrollContext(props, context) {
	    (0, _classCallCheck3.default)(this, ScrollContext);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	      var shouldUpdateScroll = _this.props.shouldUpdateScroll;
	
	      if (!shouldUpdateScroll) {
	        return true;
	      }
	
	      // Hack to allow accessing scrollBehavior._stateStorage.
	      return shouldUpdateScroll.call(_this.scrollBehavior, prevRouterProps, routerProps);
	    };
	
	    _this.registerElement = function (key, element, shouldUpdateScroll) {
	      _this.scrollBehavior.registerElement(key, element, shouldUpdateScroll, _this.getRouterProps());
	    };
	
	    _this.unregisterElement = function (key) {
	      _this.scrollBehavior.unregisterElement(key);
	    };
	
	    var history = props.history;
	
	
	    _this.scrollBehavior = new _scrollBehavior2.default({
	      addTransitionHook: history.listen,
	      stateStorage: new _StateStorage2.default(),
	      getCurrentLocation: function getCurrentLocation() {
	        return _this.props.location;
	      },
	      shouldUpdateScroll: _this.shouldUpdateScroll
	    });
	
	    _this.scrollBehavior.updateScroll(null, _this.getRouterProps());
	    return _this;
	  }
	
	  ScrollContext.prototype.getChildContext = function getChildContext() {
	    return {
	      scrollBehavior: this
	    };
	  };
	
	  ScrollContext.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _props = this.props,
	        location = _props.location,
	        history = _props.history;
	
	    var prevLocation = prevProps.location;
	
	    if (location === prevLocation) {
	      return;
	    }
	
	    var prevRouterProps = {
	      history: prevProps.history,
	      location: prevProps.location
	
	      // The "scroll-behavior" package expects the "action" to be on the location
	      // object so let's copy it over.
	    };location.action = history.action;
	    this.scrollBehavior.updateScroll(prevRouterProps, { history: history, location: location });
	  };
	
	  ScrollContext.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.scrollBehavior.stop();
	  };
	
	  ScrollContext.prototype.getRouterProps = function getRouterProps() {
	    var _props2 = this.props,
	        history = _props2.history,
	        location = _props2.location;
	
	    return { history: history, location: location };
	  };
	
	  ScrollContext.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return ScrollContext;
	}(_react2.default.Component);
	
	ScrollContext.propTypes = propTypes;
	ScrollContext.childContextTypes = childContextTypes;
	
	exports.default = (0, _reactRouterDom.withRouter)(ScrollContext);

/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  scrollKey: _propTypes2.default.string.isRequired,
	  shouldUpdateScroll: _propTypes2.default.func,
	  children: _propTypes2.default.element.isRequired
	};
	
	var contextTypes = {
	  // This is necessary when rendering on the client. However, when rendering on
	  // the server, this container will do nothing, and thus does not require the
	  // scroll behavior context.
	  scrollBehavior: _propTypes2.default.object
	};
	
	var ScrollContainer = function (_React$Component) {
	  (0, _inherits3.default)(ScrollContainer, _React$Component);
	
	  function ScrollContainer(props, context) {
	    (0, _classCallCheck3.default)(this, ScrollContainer);
	
	    // We don't re-register if the scroll key changes, so make sure we
	    // unregister with the initial scroll key just in case the user changes it.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	      var shouldUpdateScroll = _this.props.shouldUpdateScroll;
	
	      if (!shouldUpdateScroll) {
	        return true;
	      }
	
	      // Hack to allow accessing scrollBehavior._stateStorage.
	      return shouldUpdateScroll.call(_this.context.scrollBehavior.scrollBehavior, prevRouterProps, routerProps);
	    };
	
	    _this.scrollKey = props.scrollKey;
	    return _this;
	  }
	
	  ScrollContainer.prototype.componentDidMount = function componentDidMount() {
	    this.context.scrollBehavior.registerElement(this.props.scrollKey, _reactDom2.default.findDOMNode(this), // eslint-disable-line react/no-find-dom-node
	    this.shouldUpdateScroll);
	
	    // Only keep around the current DOM node in development, as this is only
	    // for emitting the appropriate warning.
	    if (false) {
	      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
	    }
	  };
	
	  ScrollContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	     false ? (0, _warning2.default)(nextProps.scrollKey === this.props.scrollKey, "<ScrollContainer> does not support changing scrollKey.") : void 0;
	  };
	
	  ScrollContainer.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (false) {
	      var prevDomNode = this.domNode;
	      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
	
	      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(this.domNode === prevDomNode, "<ScrollContainer> does not support changing DOM node.") : void 0;
	    }
	  };
	
	  ScrollContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.context.scrollBehavior.unregisterElement(this.scrollKey);
	  };
	
	  ScrollContainer.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return ScrollContainer;
	}(_react2.default.Component);
	
	ScrollContainer.propTypes = propTypes;
	ScrollContainer.contextTypes = contextTypes;
	
	exports.default = ScrollContainer;

/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _stringify = __webpack_require__(168);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATE_KEY_PREFIX = "@@scroll|";
	var GATSBY_ROUTER_SCROLL_STATE = "___GATSBY_REACT_ROUTER_SCROLL";
	
	var SessionStorage = function () {
	  function SessionStorage() {
	    (0, _classCallCheck3.default)(this, SessionStorage);
	  }
	
	  SessionStorage.prototype.read = function read(location, key) {
	    var stateKey = this.getStateKey(location, key);
	
	    try {
	      var value = window.sessionStorage.getItem(stateKey);
	      return JSON.parse(value);
	    } catch (e) {
	      console.warn("[gatsby-react-router-scroll] Unable to access sessionStorage; sessionStorage is not available.");
	
	      if (window && window[GATSBY_ROUTER_SCROLL_STATE] && window[GATSBY_ROUTER_SCROLL_STATE][stateKey]) {
	        return window[GATSBY_ROUTER_SCROLL_STATE][stateKey];
	      }
	
	      return {};
	    }
	  };
	
	  SessionStorage.prototype.save = function save(location, key, value) {
	    var stateKey = this.getStateKey(location, key);
	    var storedValue = (0, _stringify2.default)(value);
	
	    try {
	      window.sessionStorage.setItem(stateKey, storedValue);
	    } catch (e) {
	      if (window && window[GATSBY_ROUTER_SCROLL_STATE]) {
	        window[GATSBY_ROUTER_SCROLL_STATE][stateKey] = JSON.parse(storedValue);
	      } else {
	        window[GATSBY_ROUTER_SCROLL_STATE] = {};
	        window[GATSBY_ROUTER_SCROLL_STATE][stateKey] = JSON.parse(storedValue);
	      }
	
	      console.warn("[gatsby-react-router-scroll] Unable to save state in sessionStorage; sessionStorage is not available.");
	    }
	  };
	
	  SessionStorage.prototype.getStateKey = function getStateKey(location, key) {
	    var stateKeyBase = "" + STATE_KEY_PREFIX + location.pathname;
	    return key === null || typeof key === "undefined" ? stateKeyBase : stateKeyBase + "|" + key;
	  };
	
	  return SessionStorage;
	}();
	
	exports.default = SessionStorage;

/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ScrollBehaviorContext = __webpack_require__(2709);
	
	var _ScrollBehaviorContext2 = _interopRequireDefault(_ScrollBehaviorContext);
	
	var _ScrollContainer = __webpack_require__(2710);
	
	var _ScrollContainer2 = _interopRequireDefault(_ScrollContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ScrollContainer = _ScrollContainer2.default;
	exports.ScrollContext = _ScrollBehaviorContext2.default;

/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBrowserHistory = __webpack_require__(421);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _Router = __webpack_require__(420);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(20);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createHashHistory = __webpack_require__(627);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _Router = __webpack_require__(420);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ }),
/* 2715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(728);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 2716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(624);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(623);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref.ariaCurrent,
	      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);
	
	  return _react2.default.createElement(_Route2.default, {
	    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(' ') : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        'aria-current': isActive && ariaCurrent
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  ariaCurrent: _propTypes2.default.oneOf(['page', 'step', 'location', 'true'])
	};
	
	NavLink.defaultProps = {
	  activeClassName: 'active',
	  ariaCurrent: 'true'
	};
	
	exports.default = NavLink;

/***/ }),
/* 2717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(729);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 2718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(730);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(731);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 2720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(732);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 2721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(339);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(739);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 2723 */,
/* 2724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = __webpack_require__(4200);


/***/ }),
/* 2725 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 17], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ }),
/* 2726 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = CollectingHandler;
	
	function CollectingHandler(cbs){
		this._cbs = cbs || {};
		this.events = [];
	}
	
	var EVENTS = __webpack_require__(179).EVENTS;
	Object.keys(EVENTS).forEach(function(name){
		if(EVENTS[name] === 0){
			name = "on" + name;
			CollectingHandler.prototype[name] = function(){
				this.events.push([name]);
				if(this._cbs[name]) this._cbs[name]();
			};
		} else if(EVENTS[name] === 1){
			name = "on" + name;
			CollectingHandler.prototype[name] = function(a){
				this.events.push([name, a]);
				if(this._cbs[name]) this._cbs[name](a);
			};
		} else if(EVENTS[name] === 2){
			name = "on" + name;
			CollectingHandler.prototype[name] = function(a, b){
				this.events.push([name, a, b]);
				if(this._cbs[name]) this._cbs[name](a, b);
			};
		} else {
			throw Error("wrong number of arguments");
		}
	});
	
	CollectingHandler.prototype.onreset = function(){
		this.events = [];
		if(this._cbs.onreset) this._cbs.onreset();
	};
	
	CollectingHandler.prototype.restart = function(){
		if(this._cbs.onreset) this._cbs.onreset();
	
		for(var i = 0, len = this.events.length; i < len; i++){
			if(this._cbs[this.events[i][0]]){
	
				var num = this.events[i].length;
	
				if(num === 1){
					this._cbs[this.events[i][0]]();
				} else if(num === 2){
					this._cbs[this.events[i][0]](this.events[i][1]);
				} else {
					this._cbs[this.events[i][0]](this.events[i][1], this.events[i][2]);
				}
			}
		}
	};


/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

	var index = __webpack_require__(179),
	    DomHandler = index.DomHandler,
	    DomUtils = index.DomUtils;
	
	//TODO: make this a streamable handler
	function FeedHandler(callback, options){
		this.init(callback, options);
	}
	
	__webpack_require__(71)(FeedHandler, DomHandler);
	
	FeedHandler.prototype.init = DomHandler;
	
	function getElements(what, where){
		return DomUtils.getElementsByTagName(what, where, true);
	}
	function getOneElement(what, where){
		return DomUtils.getElementsByTagName(what, where, true, 1)[0];
	}
	function fetch(what, where, recurse){
		return DomUtils.getText(
			DomUtils.getElementsByTagName(what, where, recurse, 1)
		).trim();
	}
	
	function addConditionally(obj, prop, what, where, recurse){
		var tmp = fetch(what, where, recurse);
		if(tmp) obj[prop] = tmp;
	}
	
	var isValidFeed = function(value){
		return value === "rss" || value === "feed" || value === "rdf:RDF";
	};
	
	FeedHandler.prototype.onend = function(){
		var feed = {},
		    feedRoot = getOneElement(isValidFeed, this.dom),
		    tmp, childs;
	
		if(feedRoot){
			if(feedRoot.name === "feed"){
				childs = feedRoot.children;
	
				feed.type = "atom";
				addConditionally(feed, "id", "id", childs);
				addConditionally(feed, "title", "title", childs);
				if((tmp = getOneElement("link", childs)) && (tmp = tmp.attribs) && (tmp = tmp.href)) feed.link = tmp;
				addConditionally(feed, "description", "subtitle", childs);
				if((tmp = fetch("updated", childs))) feed.updated = new Date(tmp);
				addConditionally(feed, "author", "email", childs, true);
	
				feed.items = getElements("entry", childs).map(function(item){
					var entry = {}, tmp;
	
					item = item.children;
	
					addConditionally(entry, "id", "id", item);
					addConditionally(entry, "title", "title", item);
					if((tmp = getOneElement("link", item)) && (tmp = tmp.attribs) && (tmp = tmp.href)) entry.link = tmp;
					if((tmp = fetch("summary", item) || fetch("content", item))) entry.description = tmp;
					if((tmp = fetch("updated", item))) entry.pubDate = new Date(tmp);
					return entry;
				});
			} else {
				childs = getOneElement("channel", feedRoot.children).children;
	
				feed.type = feedRoot.name.substr(0, 3);
				feed.id = "";
				addConditionally(feed, "title", "title", childs);
				addConditionally(feed, "link", "link", childs);
				addConditionally(feed, "description", "description", childs);
				if((tmp = fetch("lastBuildDate", childs))) feed.updated = new Date(tmp);
				addConditionally(feed, "author", "managingEditor", childs, true);
	
				feed.items = getElements("item", feedRoot.children).map(function(item){
					var entry = {}, tmp;
	
					item = item.children;
	
					addConditionally(entry, "id", "guid", item);
					addConditionally(entry, "title", "title", item);
					addConditionally(entry, "link", "link", item);
					addConditionally(entry, "description", "description", item);
					if((tmp = fetch("pubDate", item))) entry.pubDate = new Date(tmp);
					return entry;
				});
			}
		}
		this.dom = feed;
		DomHandler.prototype._handleCallback.call(
			this, feedRoot ? null : Error("couldn't find root of feed")
		);
	};
	
	module.exports = FeedHandler;


/***/ }),
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = ProxyHandler;
	
	function ProxyHandler(cbs){
		this._cbs = cbs || {};
	}
	
	var EVENTS = __webpack_require__(179).EVENTS;
	Object.keys(EVENTS).forEach(function(name){
		if(EVENTS[name] === 0){
			name = "on" + name;
			ProxyHandler.prototype[name] = function(){
				if(this._cbs[name]) this._cbs[name]();
			};
		} else if(EVENTS[name] === 1){
			name = "on" + name;
			ProxyHandler.prototype[name] = function(a){
				if(this._cbs[name]) this._cbs[name](a);
			};
		} else if(EVENTS[name] === 2){
			name = "on" + name;
			ProxyHandler.prototype[name] = function(a, b){
				if(this._cbs[name]) this._cbs[name](a, b);
			};
		} else {
			throw Error("wrong number of arguments");
		}
	});

/***/ }),
/* 2729 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(631);
	
	function Stream(options){
		Parser.call(this, new Cbs(this), options);
	}
	
	__webpack_require__(71)(Stream, Parser);
	
	Stream.prototype.readable = true;
	
	function Cbs(scope){
		this.scope = scope;
	}
	
	var EVENTS = __webpack_require__(179).EVENTS;
	
	Object.keys(EVENTS).forEach(function(name){
		if(EVENTS[name] === 0){
			Cbs.prototype["on" + name] = function(){
				this.scope.emit(name);
			};
		} else if(EVENTS[name] === 1){
			Cbs.prototype["on" + name] = function(a){
				this.scope.emit(name, a);
			};
		} else if(EVENTS[name] === 2){
			Cbs.prototype["on" + name] = function(a, b){
				this.scope.emit(name, a, b);
			};
		} else {
			throw Error("wrong number of arguments!");
		}
	});

/***/ }),
/* 2730 */
/***/ (function(module, exports) {

	'use strict';
	
	var boolToStr = Boolean.prototype.toString;
	
	var tryBooleanObject = function tryBooleanObject(value) {
		try {
			boolToStr.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var boolClass = '[object Boolean]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isBoolean(value) {
		if (typeof value === 'boolean') { return true; }
		if (typeof value !== 'object') { return false; }
		return hasToStringTag ? tryBooleanObject(value) : toStr.call(value) === boolClass;
	};


/***/ }),
/* 2731 */
/***/ (function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateObject(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) { return false; }
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ }),
/* 2732 */
/***/ (function(module, exports) {

	'use strict';
	
	var numToStr = Number.prototype.toString;
	var tryNumberObject = function tryNumberObject(value) {
		try {
			numToStr.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var numClass = '[object Number]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isNumberObject(value) {
		if (typeof value === 'number') { return true; }
		if (typeof value !== 'object') { return false; }
		return hasToStringTag ? tryNumberObject(value) : toStr.call(value) === numClass;
	};


/***/ }),
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(177);
	var regexExec = RegExp.prototype.exec;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var tryRegexExecCall = function tryRegexExec(value) {
		try {
			var lastIndex = value.lastIndex;
			value.lastIndex = 0;
	
			regexExec.call(value);
			return true;
		} catch (e) {
			return false;
		} finally {
			value.lastIndex = lastIndex;
		}
	};
	var toStr = Object.prototype.toString;
	var regexClass = '[object RegExp]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}
		if (!hasToStringTag) {
			return toStr.call(value) === regexClass;
		}
	
		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}
	
		return tryRegexExecCall(value);
	};


/***/ }),
/* 2734 */
/***/ (function(module, exports) {

	'use strict';
	
	var strValue = String.prototype.valueOf;
	var tryStringObject = function tryStringObject(value) {
		try {
			strValue.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var strClass = '[object String]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isString(value) {
		if (typeof value === 'string') { return true; }
		if (typeof value !== 'object') { return false; }
		return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
	};


/***/ }),
/* 2735 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	/**
	 * Check if an object is contained within another object.
	 *
	 * Returns `true` if:
	 * - all enumerable keys of *subset* are also enumerable in *superset*, and
	 * - every value assigned to an enumerable key of *subset* strictly equals
	 *   the value assigned to the same key of *superset* – or is a subset of it.
	 *
	 * @param  {Object}  superset
	 * @param  {Object}  subset
	 *
	 * @returns  {Boolean}
	 *
	 * @module    is-subset
	 * @function  default
	 * @alias     isSubset
	 */
	var isSubset = (function (_isSubset) {
	  function isSubset(_x, _x2) {
	    return _isSubset.apply(this, arguments);
	  }
	
	  isSubset.toString = function () {
	    return _isSubset.toString();
	  };
	
	  return isSubset;
	})(function (superset, subset) {
	  if (typeof superset !== 'object' || superset === null || (typeof subset !== 'object' || subset === null)) return false;
	
	  return Object.keys(subset).every(function (key) {
	    if (!superset.propertyIsEnumerable(key)) return false;
	
	    var subsetItem = subset[key];
	    var supersetItem = superset[key];
	    if (typeof subsetItem === 'object' && subsetItem !== null ? !isSubset(supersetItem, subsetItem) : supersetItem !== subsetItem) return false;
	
	    return true;
	  });
	});
	
	exports['default'] = isSubset;
	module.exports = exports['default'];

/***/ }),
/* 2736 */
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';
	
	if (hasSymbols) {
		var symToStr = Symbol.prototype.toString;
		var symStringRegex = /^Symbol\(.*\)$/;
		var isSymbolObject = function isSymbolObject(value) {
			if (typeof value.valueOf() !== 'symbol') { return false; }
			return symStringRegex.test(symToStr.call(value));
		};
		module.exports = function isSymbol(value) {
			if (typeof value === 'symbol') { return true; }
			if (toStr.call(value) !== '[object Symbol]') { return false; }
			try {
				return isSymbolObject(value);
			} catch (e) {
				return false;
			}
		};
	} else {
		module.exports = function isSymbol(value) {
			// this environment does not support Symbols.
			return false;
		};
	}


/***/ }),
/* 2737 */
/***/ (function(module, exports) {

	// Copyright 2014, 2015, 2016, 2017 Simon Lydell
	// License: MIT. (See LICENSE.)
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	})
	
	// This regex comes from regex.coffee, and is inserted here by generate-index.js
	// (run `npm run build`).
	exports.default = /((['"])(?:(?!\2|\\).|\\(?:\r\n|[\s\S]))*(\2)?|`(?:[^`\\$]|\\[\s\S]|\$(?!\{)|\$\{(?:[^{}]|\{[^}]*\}?)*\}?)*(`)?)|(\/\/.*)|(\/\*(?:[^*]|\*(?!\/))*(\*\/)?)|(\/(?!\*)(?:\[(?:(?![\]\\]).|\\.)*\]|(?![\/\]\\]).|\\.)+\/(?:(?!\s*(?:\b|[\u0080-\uFFFF$\\'"~({]|[+\-!](?!=)|\.?\d))|[gmiyu]{1,5}\b(?![\u0080-\uFFFF$\\]|\s*(?:[+\-*%&|^<>!=?({]|\/(?![\/*])))))|(0[xX][\da-fA-F]+|0[oO][0-7]+|0[bB][01]+|(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?)|((?!\d)(?:(?!\s)[$\w\u0080-\uFFFF]|\\u[\da-fA-F]{4}|\\u\{[\da-fA-F]+\})+)|(--|\+\+|&&|\|\||=>|\.{3}|(?:[+\-\/%&|^]|\*{1,2}|<{1,2}|>{1,3}|!=?|={1,2})=?|[?~.,:;[\](){}])|(\s+)|(^$|[\s\S])/g
	
	exports.matchToToken = function(match) {
	  var token = {type: "invalid", value: match[0]}
	       if (match[ 1]) token.type = "string" , token.closed = !!(match[3] || match[4])
	  else if (match[ 5]) token.type = "comment"
	  else if (match[ 6]) token.type = "comment", token.closed = !!match[7]
	  else if (match[ 8]) token.type = "regex"
	  else if (match[ 9]) token.type = "number"
	  else if (match[10]) token.type = "name"
	  else if (match[11]) token.type = "punctuator"
	  else if (match[12]) token.type = "whitespace"
	  return token
	}


/***/ }),
/* 2738 */,
/* 2739 */,
/* 2740 */,
/* 2741 */,
/* 2742 */,
/* 2743 */,
/* 2744 */,
/* 2745 */,
/* 2746 */,
/* 2747 */,
/* 2748 */,
/* 2749 */,
/* 2750 */,
/* 2751 */,
/* 2752 */,
/* 2753 */,
/* 2754 */,
/* 2755 */,
/* 2756 */,
/* 2757 */,
/* 2758 */,
/* 2759 */,
/* 2760 */,
/* 2761 */,
/* 2762 */,
/* 2763 */,
/* 2764 */,
/* 2765 */,
/* 2766 */,
/* 2767 */,
/* 2768 */,
/* 2769 */,
/* 2770 */,
/* 2771 */,
/* 2772 */,
/* 2773 */,
/* 2774 */,
/* 2775 */,
/* 2776 */,
/* 2777 */,
/* 2778 */,
/* 2779 */,
/* 2780 */,
/* 2781 */,
/* 2782 */,
/* 2783 */,
/* 2784 */,
/* 2785 */,
/* 2786 */,
/* 2787 */,
/* 2788 */,
/* 2789 */,
/* 2790 */,
/* 2791 */,
/* 2792 */,
/* 2793 */,
/* 2794 */,
/* 2795 */,
/* 2796 */,
/* 2797 */,
/* 2798 */,
/* 2799 */,
/* 2800 */,
/* 2801 */,
/* 2802 */,
/* 2803 */,
/* 2804 */,
/* 2805 */,
/* 2806 */,
/* 2807 */,
/* 2808 */,
/* 2809 */,
/* 2810 */,
/* 2811 */,
/* 2812 */,
/* 2813 */,
/* 2814 */,
/* 2815 */,
/* 2816 */,
/* 2817 */,
/* 2818 */,
/* 2819 */,
/* 2820 */,
/* 2821 */,
/* 2822 */,
/* 2823 */,
/* 2824 */,
/* 2825 */,
/* 2826 */,
/* 2827 */,
/* 2828 */,
/* 2829 */,
/* 2830 */,
/* 2831 */,
/* 2832 */,
/* 2833 */,
/* 2834 */,
/* 2835 */,
/* 2836 */,
/* 2837 */,
/* 2838 */,
/* 2839 */,
/* 2840 */,
/* 2841 */,
/* 2842 */,
/* 2843 */,
/* 2844 */,
/* 2845 */,
/* 2846 */,
/* 2847 */,
/* 2848 */,
/* 2849 */,
/* 2850 */,
/* 2851 */,
/* 2852 */,
/* 2853 */,
/* 2854 */,
/* 2855 */,
/* 2856 */,
/* 2857 */,
/* 2858 */,
/* 2859 */,
/* 2860 */,
/* 2861 */,
/* 2862 */,
/* 2863 */,
/* 2864 */,
/* 2865 */,
/* 2866 */,
/* 2867 */,
/* 2868 */,
/* 2869 */,
/* 2870 */,
/* 2871 */,
/* 2872 */,
/* 2873 */,
/* 2874 */,
/* 2875 */,
/* 2876 */,
/* 2877 */,
/* 2878 */,
/* 2879 */,
/* 2880 */,
/* 2881 */,
/* 2882 */,
/* 2883 */,
/* 2884 */,
/* 2885 */,
/* 2886 */,
/* 2887 */,
/* 2888 */,
/* 2889 */,
/* 2890 */,
/* 2891 */,
/* 2892 */,
/* 2893 */,
/* 2894 */,
/* 2895 */,
/* 2896 */,
/* 2897 */,
/* 2898 */,
/* 2899 */,
/* 2900 */,
/* 2901 */,
/* 2902 */,
/* 2903 */,
/* 2904 */,
/* 2905 */,
/* 2906 */,
/* 2907 */,
/* 2908 */,
/* 2909 */,
/* 2910 */,
/* 2911 */,
/* 2912 */,
/* 2913 */,
/* 2914 */,
/* 2915 */,
/* 2916 */,
/* 2917 */,
/* 2918 */,
/* 2919 */,
/* 2920 */,
/* 2921 */,
/* 2922 */,
/* 2923 */,
/* 2924 */,
/* 2925 */,
/* 2926 */,
/* 2927 */,
/* 2928 */,
/* 2929 */,
/* 2930 */,
/* 2931 */,
/* 2932 */,
/* 2933 */,
/* 2934 */,
/* 2935 */,
/* 2936 */,
/* 2937 */,
/* 2938 */,
/* 2939 */,
/* 2940 */,
/* 2941 */,
/* 2942 */,
/* 2943 */,
/* 2944 */,
/* 2945 */,
/* 2946 */,
/* 2947 */,
/* 2948 */,
/* 2949 */,
/* 2950 */,
/* 2951 */,
/* 2952 */,
/* 2953 */,
/* 2954 */,
/* 2955 */,
/* 2956 */,
/* 2957 */,
/* 2958 */,
/* 2959 */,
/* 2960 */,
/* 2961 */,
/* 2962 */,
/* 2963 */,
/* 2964 */,
/* 2965 */,
/* 2966 */,
/* 2967 */,
/* 2968 */,
/* 2969 */,
/* 2970 */,
/* 2971 */,
/* 2972 */,
/* 2973 */,
/* 2974 */,
/* 2975 */,
/* 2976 */,
/* 2977 */,
/* 2978 */,
/* 2979 */,
/* 2980 */,
/* 2981 */,
/* 2982 */,
/* 2983 */,
/* 2984 */,
/* 2985 */,
/* 2986 */,
/* 2987 */,
/* 2988 */,
/* 2989 */,
/* 2990 */,
/* 2991 */,
/* 2992 */,
/* 2993 */,
/* 2994 */,
/* 2995 */,
/* 2996 */,
/* 2997 */,
/* 2998 */,
/* 2999 */,
/* 3000 */,
/* 3001 */,
/* 3002 */,
/* 3003 */,
/* 3004 */,
/* 3005 */,
/* 3006 */,
/* 3007 */,
/* 3008 */,
/* 3009 */,
/* 3010 */,
/* 3011 */,
/* 3012 */,
/* 3013 */,
/* 3014 */,
/* 3015 */,
/* 3016 */,
/* 3017 */,
/* 3018 */,
/* 3019 */,
/* 3020 */,
/* 3021 */,
/* 3022 */,
/* 3023 */,
/* 3024 */,
/* 3025 */,
/* 3026 */,
/* 3027 */,
/* 3028 */,
/* 3029 */,
/* 3030 */,
/* 3031 */,
/* 3032 */,
/* 3033 */,
/* 3034 */,
/* 3035 */,
/* 3036 */,
/* 3037 */,
/* 3038 */,
/* 3039 */,
/* 3040 */,
/* 3041 */,
/* 3042 */,
/* 3043 */,
/* 3044 */,
/* 3045 */,
/* 3046 */,
/* 3047 */,
/* 3048 */,
/* 3049 */,
/* 3050 */,
/* 3051 */,
/* 3052 */,
/* 3053 */,
/* 3054 */,
/* 3055 */,
/* 3056 */,
/* 3057 */,
/* 3058 */,
/* 3059 */,
/* 3060 */,
/* 3061 */,
/* 3062 */,
/* 3063 */,
/* 3064 */,
/* 3065 */,
/* 3066 */,
/* 3067 */,
/* 3068 */,
/* 3069 */,
/* 3070 */,
/* 3071 */,
/* 3072 */,
/* 3073 */,
/* 3074 */,
/* 3075 */,
/* 3076 */,
/* 3077 */,
/* 3078 */,
/* 3079 */,
/* 3080 */,
/* 3081 */,
/* 3082 */,
/* 3083 */,
/* 3084 */,
/* 3085 */,
/* 3086 */,
/* 3087 */,
/* 3088 */,
/* 3089 */,
/* 3090 */,
/* 3091 */,
/* 3092 */,
/* 3093 */,
/* 3094 */,
/* 3095 */,
/* 3096 */,
/* 3097 */,
/* 3098 */,
/* 3099 */,
/* 3100 */,
/* 3101 */,
/* 3102 */,
/* 3103 */,
/* 3104 */,
/* 3105 */,
/* 3106 */,
/* 3107 */,
/* 3108 */,
/* 3109 */,
/* 3110 */,
/* 3111 */,
/* 3112 */,
/* 3113 */,
/* 3114 */,
/* 3115 */,
/* 3116 */,
/* 3117 */,
/* 3118 */,
/* 3119 */,
/* 3120 */,
/* 3121 */,
/* 3122 */,
/* 3123 */,
/* 3124 */,
/* 3125 */,
/* 3126 */,
/* 3127 */,
/* 3128 */,
/* 3129 */,
/* 3130 */,
/* 3131 */,
/* 3132 */,
/* 3133 */,
/* 3134 */,
/* 3135 */,
/* 3136 */,
/* 3137 */,
/* 3138 */,
/* 3139 */,
/* 3140 */,
/* 3141 */,
/* 3142 */,
/* 3143 */,
/* 3144 */,
/* 3145 */,
/* 3146 */,
/* 3147 */,
/* 3148 */,
/* 3149 */,
/* 3150 */,
/* 3151 */,
/* 3152 */,
/* 3153 */,
/* 3154 */,
/* 3155 */,
/* 3156 */,
/* 3157 */,
/* 3158 */,
/* 3159 */,
/* 3160 */,
/* 3161 */,
/* 3162 */,
/* 3163 */,
/* 3164 */,
/* 3165 */,
/* 3166 */,
/* 3167 */,
/* 3168 */,
/* 3169 */,
/* 3170 */,
/* 3171 */,
/* 3172 */,
/* 3173 */,
/* 3174 */,
/* 3175 */,
/* 3176 */,
/* 3177 */,
/* 3178 */,
/* 3179 */,
/* 3180 */,
/* 3181 */,
/* 3182 */,
/* 3183 */,
/* 3184 */,
/* 3185 */,
/* 3186 */,
/* 3187 */,
/* 3188 */,
/* 3189 */,
/* 3190 */,
/* 3191 */,
/* 3192 */,
/* 3193 */,
/* 3194 */,
/* 3195 */,
/* 3196 */,
/* 3197 */,
/* 3198 */,
/* 3199 */,
/* 3200 */,
/* 3201 */,
/* 3202 */,
/* 3203 */,
/* 3204 */,
/* 3205 */,
/* 3206 */,
/* 3207 */,
/* 3208 */,
/* 3209 */,
/* 3210 */,
/* 3211 */,
/* 3212 */,
/* 3213 */,
/* 3214 */,
/* 3215 */,
/* 3216 */,
/* 3217 */,
/* 3218 */,
/* 3219 */,
/* 3220 */,
/* 3221 */,
/* 3222 */,
/* 3223 */,
/* 3224 */,
/* 3225 */,
/* 3226 */,
/* 3227 */,
/* 3228 */,
/* 3229 */,
/* 3230 */,
/* 3231 */,
/* 3232 */,
/* 3233 */,
/* 3234 */,
/* 3235 */,
/* 3236 */,
/* 3237 */,
/* 3238 */,
/* 3239 */,
/* 3240 */,
/* 3241 */,
/* 3242 */,
/* 3243 */,
/* 3244 */,
/* 3245 */,
/* 3246 */,
/* 3247 */,
/* 3248 */,
/* 3249 */,
/* 3250 */,
/* 3251 */,
/* 3252 */,
/* 3253 */,
/* 3254 */,
/* 3255 */,
/* 3256 */,
/* 3257 */,
/* 3258 */,
/* 3259 */,
/* 3260 */,
/* 3261 */,
/* 3262 */,
/* 3263 */,
/* 3264 */,
/* 3265 */,
/* 3266 */,
/* 3267 */,
/* 3268 */,
/* 3269 */,
/* 3270 */,
/* 3271 */,
/* 3272 */,
/* 3273 */,
/* 3274 */,
/* 3275 */,
/* 3276 */,
/* 3277 */,
/* 3278 */,
/* 3279 */,
/* 3280 */,
/* 3281 */,
/* 3282 */,
/* 3283 */,
/* 3284 */,
/* 3285 */,
/* 3286 */,
/* 3287 */,
/* 3288 */,
/* 3289 */,
/* 3290 */,
/* 3291 */,
/* 3292 */,
/* 3293 */,
/* 3294 */,
/* 3295 */,
/* 3296 */,
/* 3297 */,
/* 3298 */,
/* 3299 */,
/* 3300 */,
/* 3301 */,
/* 3302 */,
/* 3303 */,
/* 3304 */,
/* 3305 */,
/* 3306 */,
/* 3307 */,
/* 3308 */,
/* 3309 */,
/* 3310 */,
/* 3311 */,
/* 3312 */,
/* 3313 */,
/* 3314 */,
/* 3315 */,
/* 3316 */,
/* 3317 */,
/* 3318 */,
/* 3319 */,
/* 3320 */,
/* 3321 */,
/* 3322 */,
/* 3323 */,
/* 3324 */,
/* 3325 */,
/* 3326 */,
/* 3327 */,
/* 3328 */,
/* 3329 */,
/* 3330 */,
/* 3331 */,
/* 3332 */,
/* 3333 */,
/* 3334 */,
/* 3335 */,
/* 3336 */,
/* 3337 */,
/* 3338 */,
/* 3339 */,
/* 3340 */,
/* 3341 */,
/* 3342 */,
/* 3343 */,
/* 3344 */,
/* 3345 */,
/* 3346 */,
/* 3347 */,
/* 3348 */,
/* 3349 */,
/* 3350 */,
/* 3351 */,
/* 3352 */,
/* 3353 */,
/* 3354 */,
/* 3355 */,
/* 3356 */,
/* 3357 */,
/* 3358 */,
/* 3359 */,
/* 3360 */,
/* 3361 */,
/* 3362 */,
/* 3363 */,
/* 3364 */,
/* 3365 */,
/* 3366 */,
/* 3367 */,
/* 3368 */,
/* 3369 */,
/* 3370 */,
/* 3371 */,
/* 3372 */,
/* 3373 */,
/* 3374 */,
/* 3375 */,
/* 3376 */,
/* 3377 */,
/* 3378 */,
/* 3379 */,
/* 3380 */,
/* 3381 */,
/* 3382 */,
/* 3383 */,
/* 3384 */,
/* 3385 */,
/* 3386 */,
/* 3387 */,
/* 3388 */,
/* 3389 */,
/* 3390 */,
/* 3391 */,
/* 3392 */,
/* 3393 */,
/* 3394 */,
/* 3395 */,
/* 3396 */,
/* 3397 */,
/* 3398 */,
/* 3399 */,
/* 3400 */,
/* 3401 */,
/* 3402 */,
/* 3403 */,
/* 3404 */,
/* 3405 */,
/* 3406 */,
/* 3407 */,
/* 3408 */,
/* 3409 */,
/* 3410 */,
/* 3411 */,
/* 3412 */,
/* 3413 */,
/* 3414 */,
/* 3415 */,
/* 3416 */,
/* 3417 */,
/* 3418 */,
/* 3419 */,
/* 3420 */,
/* 3421 */,
/* 3422 */,
/* 3423 */,
/* 3424 */,
/* 3425 */,
/* 3426 */,
/* 3427 */,
/* 3428 */,
/* 3429 */,
/* 3430 */,
/* 3431 */,
/* 3432 */,
/* 3433 */,
/* 3434 */,
/* 3435 */,
/* 3436 */,
/* 3437 */,
/* 3438 */,
/* 3439 */,
/* 3440 */,
/* 3441 */,
/* 3442 */,
/* 3443 */,
/* 3444 */,
/* 3445 */,
/* 3446 */,
/* 3447 */,
/* 3448 */,
/* 3449 */,
/* 3450 */,
/* 3451 */,
/* 3452 */,
/* 3453 */,
/* 3454 */,
/* 3455 */,
/* 3456 */,
/* 3457 */,
/* 3458 */,
/* 3459 */,
/* 3460 */,
/* 3461 */,
/* 3462 */,
/* 3463 */,
/* 3464 */,
/* 3465 */,
/* 3466 */,
/* 3467 */,
/* 3468 */,
/* 3469 */,
/* 3470 */,
/* 3471 */,
/* 3472 */,
/* 3473 */,
/* 3474 */,
/* 3475 */,
/* 3476 */,
/* 3477 */,
/* 3478 */,
/* 3479 */,
/* 3480 */,
/* 3481 */,
/* 3482 */,
/* 3483 */,
/* 3484 */,
/* 3485 */,
/* 3486 */,
/* 3487 */,
/* 3488 */,
/* 3489 */,
/* 3490 */,
/* 3491 */,
/* 3492 */,
/* 3493 */,
/* 3494 */,
/* 3495 */,
/* 3496 */,
/* 3497 */,
/* 3498 */,
/* 3499 */,
/* 3500 */,
/* 3501 */,
/* 3502 */,
/* 3503 */,
/* 3504 */,
/* 3505 */,
/* 3506 */,
/* 3507 */,
/* 3508 */,
/* 3509 */,
/* 3510 */,
/* 3511 */,
/* 3512 */,
/* 3513 */,
/* 3514 */,
/* 3515 */,
/* 3516 */,
/* 3517 */,
/* 3518 */,
/* 3519 */,
/* 3520 */,
/* 3521 */,
/* 3522 */,
/* 3523 */,
/* 3524 */,
/* 3525 */,
/* 3526 */,
/* 3527 */,
/* 3528 */,
/* 3529 */,
/* 3530 */,
/* 3531 */,
/* 3532 */,
/* 3533 */,
/* 3534 */,
/* 3535 */,
/* 3536 */,
/* 3537 */,
/* 3538 */,
/* 3539 */,
/* 3540 */,
/* 3541 */,
/* 3542 */,
/* 3543 */,
/* 3544 */,
/* 3545 */,
/* 3546 */,
/* 3547 */,
/* 3548 */,
/* 3549 */,
/* 3550 */,
/* 3551 */,
/* 3552 */,
/* 3553 */,
/* 3554 */,
/* 3555 */,
/* 3556 */,
/* 3557 */,
/* 3558 */,
/* 3559 */,
/* 3560 */,
/* 3561 */,
/* 3562 */,
/* 3563 */,
/* 3564 */,
/* 3565 */,
/* 3566 */,
/* 3567 */,
/* 3568 */,
/* 3569 */,
/* 3570 */,
/* 3571 */,
/* 3572 */,
/* 3573 */,
/* 3574 */,
/* 3575 */,
/* 3576 */,
/* 3577 */,
/* 3578 */,
/* 3579 */,
/* 3580 */,
/* 3581 */,
/* 3582 */,
/* 3583 */,
/* 3584 */,
/* 3585 */,
/* 3586 */,
/* 3587 */,
/* 3588 */,
/* 3589 */,
/* 3590 */,
/* 3591 */,
/* 3592 */,
/* 3593 */,
/* 3594 */,
/* 3595 */,
/* 3596 */,
/* 3597 */,
/* 3598 */,
/* 3599 */,
/* 3600 */,
/* 3601 */,
/* 3602 */,
/* 3603 */,
/* 3604 */,
/* 3605 */,
/* 3606 */,
/* 3607 */,
/* 3608 */,
/* 3609 */,
/* 3610 */,
/* 3611 */,
/* 3612 */,
/* 3613 */,
/* 3614 */,
/* 3615 */,
/* 3616 */,
/* 3617 */,
/* 3618 */,
/* 3619 */,
/* 3620 */,
/* 3621 */,
/* 3622 */,
/* 3623 */,
/* 3624 */,
/* 3625 */,
/* 3626 */,
/* 3627 */,
/* 3628 */,
/* 3629 */,
/* 3630 */,
/* 3631 */,
/* 3632 */,
/* 3633 */,
/* 3634 */,
/* 3635 */,
/* 3636 */,
/* 3637 */,
/* 3638 */,
/* 3639 */,
/* 3640 */,
/* 3641 */,
/* 3642 */,
/* 3643 */,
/* 3644 */,
/* 3645 */,
/* 3646 */,
/* 3647 */,
/* 3648 */,
/* 3649 */,
/* 3650 */,
/* 3651 */,
/* 3652 */,
/* 3653 */,
/* 3654 */,
/* 3655 */,
/* 3656 */,
/* 3657 */,
/* 3658 */,
/* 3659 */,
/* 3660 */,
/* 3661 */,
/* 3662 */,
/* 3663 */,
/* 3664 */,
/* 3665 */,
/* 3666 */,
/* 3667 */,
/* 3668 */,
/* 3669 */,
/* 3670 */,
/* 3671 */,
/* 3672 */,
/* 3673 */,
/* 3674 */,
/* 3675 */,
/* 3676 */,
/* 3677 */,
/* 3678 */,
/* 3679 */,
/* 3680 */,
/* 3681 */,
/* 3682 */,
/* 3683 */,
/* 3684 */,
/* 3685 */,
/* 3686 */,
/* 3687 */,
/* 3688 */,
/* 3689 */,
/* 3690 */,
/* 3691 */,
/* 3692 */,
/* 3693 */,
/* 3694 */,
/* 3695 */,
/* 3696 */,
/* 3697 */,
/* 3698 */,
/* 3699 */,
/* 3700 */,
/* 3701 */,
/* 3702 */,
/* 3703 */,
/* 3704 */,
/* 3705 */,
/* 3706 */,
/* 3707 */,
/* 3708 */,
/* 3709 */,
/* 3710 */,
/* 3711 */,
/* 3712 */,
/* 3713 */,
/* 3714 */,
/* 3715 */,
/* 3716 */,
/* 3717 */,
/* 3718 */,
/* 3719 */,
/* 3720 */,
/* 3721 */,
/* 3722 */,
/* 3723 */,
/* 3724 */,
/* 3725 */,
/* 3726 */,
/* 3727 */,
/* 3728 */,
/* 3729 */,
/* 3730 */,
/* 3731 */,
/* 3732 */,
/* 3733 */,
/* 3734 */,
/* 3735 */,
/* 3736 */,
/* 3737 */,
/* 3738 */,
/* 3739 */,
/* 3740 */,
/* 3741 */,
/* 3742 */,
/* 3743 */,
/* 3744 */,
/* 3745 */,
/* 3746 */,
/* 3747 */,
/* 3748 */,
/* 3749 */,
/* 3750 */,
/* 3751 */,
/* 3752 */,
/* 3753 */,
/* 3754 */,
/* 3755 */,
/* 3756 */,
/* 3757 */,
/* 3758 */,
/* 3759 */,
/* 3760 */,
/* 3761 */,
/* 3762 */,
/* 3763 */,
/* 3764 */,
/* 3765 */,
/* 3766 */,
/* 3767 */,
/* 3768 */,
/* 3769 */,
/* 3770 */,
/* 3771 */,
/* 3772 */,
/* 3773 */,
/* 3774 */,
/* 3775 */,
/* 3776 */,
/* 3777 */,
/* 3778 */,
/* 3779 */,
/* 3780 */,
/* 3781 */,
/* 3782 */,
/* 3783 */,
/* 3784 */,
/* 3785 */,
/* 3786 */,
/* 3787 */,
/* 3788 */,
/* 3789 */,
/* 3790 */,
/* 3791 */,
/* 3792 */,
/* 3793 */,
/* 3794 */,
/* 3795 */,
/* 3796 */,
/* 3797 */,
/* 3798 */,
/* 3799 */,
/* 3800 */,
/* 3801 */,
/* 3802 */,
/* 3803 */,
/* 3804 */,
/* 3805 */,
/* 3806 */,
/* 3807 */,
/* 3808 */,
/* 3809 */,
/* 3810 */,
/* 3811 */,
/* 3812 */,
/* 3813 */,
/* 3814 */,
/* 3815 */,
/* 3816 */,
/* 3817 */,
/* 3818 */,
/* 3819 */,
/* 3820 */,
/* 3821 */,
/* 3822 */,
/* 3823 */,
/* 3824 */,
/* 3825 */,
/* 3826 */,
/* 3827 */,
/* 3828 */,
/* 3829 */,
/* 3830 */,
/* 3831 */,
/* 3832 */,
/* 3833 */,
/* 3834 */,
/* 3835 */,
/* 3836 */,
/* 3837 */,
/* 3838 */,
/* 3839 */,
/* 3840 */,
/* 3841 */,
/* 3842 */,
/* 3843 */,
/* 3844 */,
/* 3845 */,
/* 3846 */,
/* 3847 */,
/* 3848 */,
/* 3849 */,
/* 3850 */,
/* 3851 */,
/* 3852 */,
/* 3853 */,
/* 3854 */,
/* 3855 */,
/* 3856 */,
/* 3857 */,
/* 3858 */,
/* 3859 */,
/* 3860 */,
/* 3861 */,
/* 3862 */,
/* 3863 */,
/* 3864 */,
/* 3865 */,
/* 3866 */,
/* 3867 */,
/* 3868 */,
/* 3869 */,
/* 3870 */,
/* 3871 */,
/* 3872 */,
/* 3873 */,
/* 3874 */,
/* 3875 */,
/* 3876 */,
/* 3877 */,
/* 3878 */,
/* 3879 */,
/* 3880 */,
/* 3881 */,
/* 3882 */,
/* 3883 */,
/* 3884 */,
/* 3885 */,
/* 3886 */,
/* 3887 */,
/* 3888 */,
/* 3889 */,
/* 3890 */,
/* 3891 */,
/* 3892 */,
/* 3893 */,
/* 3894 */,
/* 3895 */,
/* 3896 */,
/* 3897 */,
/* 3898 */,
/* 3899 */,
/* 3900 */,
/* 3901 */,
/* 3902 */,
/* 3903 */,
/* 3904 */,
/* 3905 */,
/* 3906 */,
/* 3907 */,
/* 3908 */,
/* 3909 */,
/* 3910 */,
/* 3911 */,
/* 3912 */,
/* 3913 */,
/* 3914 */,
/* 3915 */,
/* 3916 */,
/* 3917 */,
/* 3918 */,
/* 3919 */,
/* 3920 */,
/* 3921 */,
/* 3922 */,
/* 3923 */,
/* 3924 */,
/* 3925 */,
/* 3926 */,
/* 3927 */,
/* 3928 */,
/* 3929 */,
/* 3930 */,
/* 3931 */,
/* 3932 */,
/* 3933 */,
/* 3934 */,
/* 3935 */,
/* 3936 */,
/* 3937 */,
/* 3938 */,
/* 3939 */,
/* 3940 */,
/* 3941 */,
/* 3942 */,
/* 3943 */,
/* 3944 */,
/* 3945 */,
/* 3946 */,
/* 3947 */,
/* 3948 */,
/* 3949 */,
/* 3950 */,
/* 3951 */,
/* 3952 */,
/* 3953 */,
/* 3954 */,
/* 3955 */,
/* 3956 */,
/* 3957 */,
/* 3958 */,
/* 3959 */,
/* 3960 */,
/* 3961 */,
/* 3962 */,
/* 3963 */,
/* 3964 */,
/* 3965 */,
/* 3966 */,
/* 3967 */,
/* 3968 */,
/* 3969 */,
/* 3970 */,
/* 3971 */,
/* 3972 */,
/* 3973 */,
/* 3974 */,
/* 3975 */,
/* 3976 */,
/* 3977 */,
/* 3978 */,
/* 3979 */,
/* 3980 */,
/* 3981 */,
/* 3982 */,
/* 3983 */,
/* 3984 */,
/* 3985 */,
/* 3986 */,
/* 3987 */,
/* 3988 */,
/* 3989 */,
/* 3990 */,
/* 3991 */,
/* 3992 */,
/* 3993 */,
/* 3994 */,
/* 3995 */,
/* 3996 */,
/* 3997 */,
/* 3998 */,
/* 3999 */,
/* 4000 */,
/* 4001 */,
/* 4002 */,
/* 4003 */,
/* 4004 */,
/* 4005 */,
/* 4006 */,
/* 4007 */,
/* 4008 */,
/* 4009 */,
/* 4010 */,
/* 4011 */,
/* 4012 */,
/* 4013 */,
/* 4014 */,
/* 4015 */,
/* 4016 */,
/* 4017 */,
/* 4018 */,
/* 4019 */,
/* 4020 */,
/* 4021 */,
/* 4022 */,
/* 4023 */,
/* 4024 */,
/* 4025 */,
/* 4026 */,
/* 4027 */,
/* 4028 */,
/* 4029 */,
/* 4030 */,
/* 4031 */,
/* 4032 */,
/* 4033 */,
/* 4034 */,
/* 4035 */,
/* 4036 */,
/* 4037 */,
/* 4038 */,
/* 4039 */,
/* 4040 */,
/* 4041 */,
/* 4042 */,
/* 4043 */,
/* 4044 */,
/* 4045 */,
/* 4046 */,
/* 4047 */,
/* 4048 */,
/* 4049 */,
/* 4050 */,
/* 4051 */,
/* 4052 */,
/* 4053 */,
/* 4054 */,
/* 4055 */,
/* 4056 */,
/* 4057 */,
/* 4058 */,
/* 4059 */,
/* 4060 */,
/* 4061 */,
/* 4062 */,
/* 4063 */,
/* 4064 */,
/* 4065 */,
/* 4066 */,
/* 4067 */,
/* 4068 */,
/* 4069 */,
/* 4070 */,
/* 4071 */,
/* 4072 */,
/* 4073 */,
/* 4074 */,
/* 4075 */,
/* 4076 */,
/* 4077 */,
/* 4078 */,
/* 4079 */,
/* 4080 */,
/* 4081 */,
/* 4082 */,
/* 4083 */,
/* 4084 */,
/* 4085 */,
/* 4086 */,
/* 4087 */,
/* 4088 */,
/* 4089 */,
/* 4090 */,
/* 4091 */,
/* 4092 */,
/* 4093 */,
/* 4094 */,
/* 4095 */,
/* 4096 */,
/* 4097 */,
/* 4098 */,
/* 4099 */,
/* 4100 */,
/* 4101 */,
/* 4102 */,
/* 4103 */,
/* 4104 */,
/* 4105 */,
/* 4106 */,
/* 4107 */,
/* 4108 */,
/* 4109 */,
/* 4110 */,
/* 4111 */,
/* 4112 */,
/* 4113 */,
/* 4114 */,
/* 4115 */,
/* 4116 */,
/* 4117 */,
/* 4118 */,
/* 4119 */,
/* 4120 */,
/* 4121 */,
/* 4122 */,
/* 4123 */,
/* 4124 */,
/* 4125 */,
/* 4126 */,
/* 4127 */,
/* 4128 */,
/* 4129 */,
/* 4130 */,
/* 4131 */,
/* 4132 */,
/* 4133 */,
/* 4134 */,
/* 4135 */,
/* 4136 */,
/* 4137 */,
/* 4138 */,
/* 4139 */,
/* 4140 */,
/* 4141 */,
/* 4142 */,
/* 4143 */,
/* 4144 */,
/* 4145 */,
/* 4146 */,
/* 4147 */,
/* 4148 */,
/* 4149 */,
/* 4150 */,
/* 4151 */,
/* 4152 */,
/* 4153 */,
/* 4154 */,
/* 4155 */,
/* 4156 */,
/* 4157 */,
/* 4158 */,
/* 4159 */,
/* 4160 */,
/* 4161 */,
/* 4162 */,
/* 4163 */,
/* 4164 */,
/* 4165 */,
/* 4166 */,
/* 4167 */,
/* 4168 */,
/* 4169 */,
/* 4170 */,
/* 4171 */,
/* 4172 */,
/* 4173 */,
/* 4174 */,
/* 4175 */,
/* 4176 */,
/* 4177 */,
/* 4178 */,
/* 4179 */,
/* 4180 */,
/* 4181 */,
/* 4182 */,
/* 4183 */,
/* 4184 */,
/* 4185 */,
/* 4186 */,
/* 4187 */,
/* 4188 */,
/* 4189 */,
/* 4190 */,
/* 4191 */,
/* 4192 */,
/* 4193 */,
/* 4194 */,
/* 4195 */,
/* 4196 */,
/* 4197 */,
/* 4198 */
/***/ (function(module, exports) {

	module.exports = {"name":"cheerio","version":"1.0.0-rc.2","description":"Tiny, fast, and elegant implementation of core jQuery designed specifically for the server","author":"Matt Mueller <mattmuelle@gmail.com> (mat.io)","license":"MIT","keywords":["htmlparser","jquery","selector","scraper","parser","html"],"repository":{"type":"git","url":"git://github.com/cheeriojs/cheerio.git"},"main":"./index.js","files":["index.js","lib"],"engines":{"node":">= 0.6"},"dependencies":{"css-select":"~1.2.0","dom-serializer":"~0.1.0","entities":"~1.1.1","htmlparser2":"^3.9.1","lodash":"^4.15.0","parse5":"^3.0.1"},"devDependencies":{"benchmark":"^2.1.0","coveralls":"^2.11.9","expect.js":"~0.3.1","istanbul":"^0.4.3","jquery":"^3.0.0","jsdom":"^9.2.1","jshint":"^2.9.2","mocha":"^3.1.2","xyz":"~1.1.0"},"scripts":{"test":"make test"}}

/***/ }),
/* 4199 */
/***/ (function(module, exports) {

	module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),
/* 4200 */
/***/ (function(module, exports) {

	module.exports = {"builtin":{"Array":false,"ArrayBuffer":false,"Atomics":false,"Boolean":false,"constructor":false,"DataView":false,"Date":false,"decodeURI":false,"decodeURIComponent":false,"encodeURI":false,"encodeURIComponent":false,"Error":false,"escape":false,"eval":false,"EvalError":false,"Float32Array":false,"Float64Array":false,"Function":false,"hasOwnProperty":false,"Infinity":false,"Int16Array":false,"Int32Array":false,"Int8Array":false,"isFinite":false,"isNaN":false,"isPrototypeOf":false,"JSON":false,"Map":false,"Math":false,"NaN":false,"Number":false,"Object":false,"parseFloat":false,"parseInt":false,"Promise":false,"propertyIsEnumerable":false,"Proxy":false,"RangeError":false,"ReferenceError":false,"Reflect":false,"RegExp":false,"Set":false,"SharedArrayBuffer":false,"String":false,"Symbol":false,"SyntaxError":false,"toLocaleString":false,"toString":false,"TypeError":false,"Uint16Array":false,"Uint32Array":false,"Uint8Array":false,"Uint8ClampedArray":false,"undefined":false,"unescape":false,"URIError":false,"valueOf":false,"WeakMap":false,"WeakSet":false},"es5":{"Array":false,"Boolean":false,"constructor":false,"Date":false,"decodeURI":false,"decodeURIComponent":false,"encodeURI":false,"encodeURIComponent":false,"Error":false,"escape":false,"eval":false,"EvalError":false,"Function":false,"hasOwnProperty":false,"Infinity":false,"isFinite":false,"isNaN":false,"isPrototypeOf":false,"JSON":false,"Math":false,"NaN":false,"Number":false,"Object":false,"parseFloat":false,"parseInt":false,"propertyIsEnumerable":false,"RangeError":false,"ReferenceError":false,"RegExp":false,"String":false,"SyntaxError":false,"toLocaleString":false,"toString":false,"TypeError":false,"undefined":false,"unescape":false,"URIError":false,"valueOf":false},"es2015":{"Array":false,"ArrayBuffer":false,"Boolean":false,"constructor":false,"DataView":false,"Date":false,"decodeURI":false,"decodeURIComponent":false,"encodeURI":false,"encodeURIComponent":false,"Error":false,"escape":false,"eval":false,"EvalError":false,"Float32Array":false,"Float64Array":false,"Function":false,"hasOwnProperty":false,"Infinity":false,"Int16Array":false,"Int32Array":false,"Int8Array":false,"isFinite":false,"isNaN":false,"isPrototypeOf":false,"JSON":false,"Map":false,"Math":false,"NaN":false,"Number":false,"Object":false,"parseFloat":false,"parseInt":false,"Promise":false,"propertyIsEnumerable":false,"Proxy":false,"RangeError":false,"ReferenceError":false,"Reflect":false,"RegExp":false,"Set":false,"String":false,"Symbol":false,"SyntaxError":false,"toLocaleString":false,"toString":false,"TypeError":false,"Uint16Array":false,"Uint32Array":false,"Uint8Array":false,"Uint8ClampedArray":false,"undefined":false,"unescape":false,"URIError":false,"valueOf":false,"WeakMap":false,"WeakSet":false},"es2017":{"Array":false,"ArrayBuffer":false,"Atomics":false,"Boolean":false,"constructor":false,"DataView":false,"Date":false,"decodeURI":false,"decodeURIComponent":false,"encodeURI":false,"encodeURIComponent":false,"Error":false,"escape":false,"eval":false,"EvalError":false,"Float32Array":false,"Float64Array":false,"Function":false,"hasOwnProperty":false,"Infinity":false,"Int16Array":false,"Int32Array":false,"Int8Array":false,"isFinite":false,"isNaN":false,"isPrototypeOf":false,"JSON":false,"Map":false,"Math":false,"NaN":false,"Number":false,"Object":false,"parseFloat":false,"parseInt":false,"Promise":false,"propertyIsEnumerable":false,"Proxy":false,"RangeError":false,"ReferenceError":false,"Reflect":false,"RegExp":false,"Set":false,"SharedArrayBuffer":false,"String":false,"Symbol":false,"SyntaxError":false,"toLocaleString":false,"toString":false,"TypeError":false,"Uint16Array":false,"Uint32Array":false,"Uint8Array":false,"Uint8ClampedArray":false,"undefined":false,"unescape":false,"URIError":false,"valueOf":false,"WeakMap":false,"WeakSet":false},"browser":{"AbortController":false,"AbortSignal":false,"addEventListener":false,"alert":false,"AnalyserNode":false,"Animation":false,"AnimationEffectReadOnly":false,"AnimationEffectTiming":false,"AnimationEffectTimingReadOnly":false,"AnimationEvent":false,"AnimationPlaybackEvent":false,"AnimationTimeline":false,"applicationCache":false,"ApplicationCache":false,"ApplicationCacheErrorEvent":false,"atob":false,"Attr":false,"Audio":false,"AudioBuffer":false,"AudioBufferSourceNode":false,"AudioContext":false,"AudioDestinationNode":false,"AudioListener":false,"AudioNode":false,"AudioParam":false,"AudioProcessingEvent":false,"AudioScheduledSourceNode":false,"BarProp":false,"BaseAudioContext":false,"BatteryManager":false,"BeforeUnloadEvent":false,"BiquadFilterNode":false,"Blob":false,"BlobEvent":false,"blur":false,"BroadcastChannel":false,"btoa":false,"BudgetService":false,"ByteLengthQueuingStrategy":false,"Cache":false,"caches":false,"CacheStorage":false,"cancelAnimationFrame":false,"cancelIdleCallback":false,"CanvasCaptureMediaStreamTrack":false,"CanvasGradient":false,"CanvasPattern":false,"CanvasRenderingContext2D":false,"ChannelMergerNode":false,"ChannelSplitterNode":false,"CharacterData":false,"clearInterval":false,"clearTimeout":false,"clientInformation":false,"ClipboardEvent":false,"close":false,"closed":false,"CloseEvent":false,"Comment":false,"CompositionEvent":false,"confirm":false,"console":false,"ConstantSourceNode":false,"ConvolverNode":false,"CountQueuingStrategy":false,"createImageBitmap":false,"Credential":false,"CredentialsContainer":false,"crypto":false,"Crypto":false,"CryptoKey":false,"CSS":false,"CSSConditionRule":false,"CSSFontFaceRule":false,"CSSGroupingRule":false,"CSSImportRule":false,"CSSKeyframeRule":false,"CSSKeyframesRule":false,"CSSMediaRule":false,"CSSNamespaceRule":false,"CSSPageRule":false,"CSSRule":false,"CSSRuleList":false,"CSSStyleDeclaration":false,"CSSStyleRule":false,"CSSStyleSheet":false,"CSSSupportsRule":false,"CustomElementRegistry":false,"customElements":false,"CustomEvent":false,"DataTransfer":false,"DataTransferItem":false,"DataTransferItemList":false,"defaultstatus":false,"defaultStatus":false,"DelayNode":false,"DeviceMotionEvent":false,"DeviceOrientationEvent":false,"devicePixelRatio":false,"dispatchEvent":false,"document":false,"Document":false,"DocumentFragment":false,"DocumentType":false,"DOMError":false,"DOMException":false,"DOMImplementation":false,"DOMMatrix":false,"DOMMatrixReadOnly":false,"DOMParser":false,"DOMPoint":false,"DOMPointReadOnly":false,"DOMQuad":false,"DOMRect":false,"DOMRectReadOnly":false,"DOMStringList":false,"DOMStringMap":false,"DOMTokenList":false,"DragEvent":false,"DynamicsCompressorNode":false,"Element":false,"ErrorEvent":false,"event":false,"Event":false,"EventSource":false,"EventTarget":false,"external":false,"fetch":false,"File":false,"FileList":false,"FileReader":false,"find":false,"focus":false,"FocusEvent":false,"FontFace":false,"FontFaceSetLoadEvent":false,"FormData":false,"frameElement":false,"frames":false,"GainNode":false,"Gamepad":false,"GamepadButton":false,"GamepadEvent":false,"getComputedStyle":false,"getSelection":false,"HashChangeEvent":false,"Headers":false,"history":false,"History":false,"HTMLAllCollection":false,"HTMLAnchorElement":false,"HTMLAreaElement":false,"HTMLAudioElement":false,"HTMLBaseElement":false,"HTMLBodyElement":false,"HTMLBRElement":false,"HTMLButtonElement":false,"HTMLCanvasElement":false,"HTMLCollection":false,"HTMLContentElement":false,"HTMLDataElement":false,"HTMLDataListElement":false,"HTMLDetailsElement":false,"HTMLDialogElement":false,"HTMLDirectoryElement":false,"HTMLDivElement":false,"HTMLDListElement":false,"HTMLDocument":false,"HTMLElement":false,"HTMLEmbedElement":false,"HTMLFieldSetElement":false,"HTMLFontElement":false,"HTMLFormControlsCollection":false,"HTMLFormElement":false,"HTMLFrameElement":false,"HTMLFrameSetElement":false,"HTMLHeadElement":false,"HTMLHeadingElement":false,"HTMLHRElement":false,"HTMLHtmlElement":false,"HTMLIFrameElement":false,"HTMLImageElement":false,"HTMLInputElement":false,"HTMLLabelElement":false,"HTMLLegendElement":false,"HTMLLIElement":false,"HTMLLinkElement":false,"HTMLMapElement":false,"HTMLMarqueeElement":false,"HTMLMediaElement":false,"HTMLMenuElement":false,"HTMLMetaElement":false,"HTMLMeterElement":false,"HTMLModElement":false,"HTMLObjectElement":false,"HTMLOListElement":false,"HTMLOptGroupElement":false,"HTMLOptionElement":false,"HTMLOptionsCollection":false,"HTMLOutputElement":false,"HTMLParagraphElement":false,"HTMLParamElement":false,"HTMLPictureElement":false,"HTMLPreElement":false,"HTMLProgressElement":false,"HTMLQuoteElement":false,"HTMLScriptElement":false,"HTMLSelectElement":false,"HTMLShadowElement":false,"HTMLSlotElement":false,"HTMLSourceElement":false,"HTMLSpanElement":false,"HTMLStyleElement":false,"HTMLTableCaptionElement":false,"HTMLTableCellElement":false,"HTMLTableColElement":false,"HTMLTableElement":false,"HTMLTableRowElement":false,"HTMLTableSectionElement":false,"HTMLTemplateElement":false,"HTMLTextAreaElement":false,"HTMLTimeElement":false,"HTMLTitleElement":false,"HTMLTrackElement":false,"HTMLUListElement":false,"HTMLUnknownElement":false,"HTMLVideoElement":false,"IDBCursor":false,"IDBCursorWithValue":false,"IDBDatabase":false,"IDBFactory":false,"IDBIndex":false,"IDBKeyRange":false,"IDBObjectStore":false,"IDBOpenDBRequest":false,"IDBRequest":false,"IDBTransaction":false,"IDBVersionChangeEvent":false,"IdleDeadline":false,"IIRFilterNode":false,"Image":false,"ImageBitmap":false,"ImageBitmapRenderingContext":false,"ImageCapture":false,"ImageData":false,"indexedDB":false,"innerHeight":false,"innerWidth":false,"InputEvent":false,"IntersectionObserver":false,"IntersectionObserverEntry":false,"Intl":false,"isSecureContext":false,"KeyboardEvent":false,"KeyframeEffect":false,"KeyframeEffectReadOnly":false,"length":false,"localStorage":false,"location":false,"Location":false,"locationbar":false,"matchMedia":false,"MediaDeviceInfo":false,"MediaDevices":false,"MediaElementAudioSourceNode":false,"MediaEncryptedEvent":false,"MediaError":false,"MediaKeyMessageEvent":false,"MediaKeySession":false,"MediaKeyStatusMap":false,"MediaKeySystemAccess":false,"MediaList":false,"MediaQueryList":false,"MediaQueryListEvent":false,"MediaRecorder":false,"MediaSettingsRange":false,"MediaSource":false,"MediaStream":false,"MediaStreamAudioDestinationNode":false,"MediaStreamAudioSourceNode":false,"MediaStreamEvent":false,"MediaStreamTrack":false,"MediaStreamTrackEvent":false,"menubar":false,"MessageChannel":false,"MessageEvent":false,"MessagePort":false,"MIDIAccess":false,"MIDIConnectionEvent":false,"MIDIInput":false,"MIDIInputMap":false,"MIDIMessageEvent":false,"MIDIOutput":false,"MIDIOutputMap":false,"MIDIPort":false,"MimeType":false,"MimeTypeArray":false,"MouseEvent":false,"moveBy":false,"moveTo":false,"MutationEvent":false,"MutationObserver":false,"MutationRecord":false,"name":false,"NamedNodeMap":false,"NavigationPreloadManager":false,"navigator":false,"Navigator":false,"NetworkInformation":false,"Node":false,"NodeFilter":false,"NodeIterator":false,"NodeList":false,"Notification":false,"OfflineAudioCompletionEvent":false,"OfflineAudioContext":false,"offscreenBuffering":false,"OffscreenCanvas":true,"onabort":true,"onafterprint":true,"onanimationend":true,"onanimationiteration":true,"onanimationstart":true,"onappinstalled":true,"onauxclick":true,"onbeforeinstallprompt":true,"onbeforeprint":true,"onbeforeunload":true,"onblur":true,"oncancel":true,"oncanplay":true,"oncanplaythrough":true,"onchange":true,"onclick":true,"onclose":true,"oncontextmenu":true,"oncuechange":true,"ondblclick":true,"ondevicemotion":true,"ondeviceorientation":true,"ondeviceorientationabsolute":true,"ondrag":true,"ondragend":true,"ondragenter":true,"ondragleave":true,"ondragover":true,"ondragstart":true,"ondrop":true,"ondurationchange":true,"onemptied":true,"onended":true,"onerror":true,"onfocus":true,"ongotpointercapture":true,"onhashchange":true,"oninput":true,"oninvalid":true,"onkeydown":true,"onkeypress":true,"onkeyup":true,"onlanguagechange":true,"onload":true,"onloadeddata":true,"onloadedmetadata":true,"onloadstart":true,"onlostpointercapture":true,"onmessage":true,"onmessageerror":true,"onmousedown":true,"onmouseenter":true,"onmouseleave":true,"onmousemove":true,"onmouseout":true,"onmouseover":true,"onmouseup":true,"onmousewheel":true,"onoffline":true,"ononline":true,"onpagehide":true,"onpageshow":true,"onpause":true,"onplay":true,"onplaying":true,"onpointercancel":true,"onpointerdown":true,"onpointerenter":true,"onpointerleave":true,"onpointermove":true,"onpointerout":true,"onpointerover":true,"onpointerup":true,"onpopstate":true,"onprogress":true,"onratechange":true,"onrejectionhandled":true,"onreset":true,"onresize":true,"onscroll":true,"onsearch":true,"onseeked":true,"onseeking":true,"onselect":true,"onstalled":true,"onstorage":true,"onsubmit":true,"onsuspend":true,"ontimeupdate":true,"ontoggle":true,"ontransitionend":true,"onunhandledrejection":true,"onunload":true,"onvolumechange":true,"onwaiting":true,"onwheel":true,"open":false,"openDatabase":false,"opener":false,"Option":false,"origin":false,"OscillatorNode":false,"outerHeight":false,"outerWidth":false,"PageTransitionEvent":false,"pageXOffset":false,"pageYOffset":false,"PannerNode":false,"parent":false,"Path2D":false,"PaymentAddress":false,"PaymentRequest":false,"PaymentRequestUpdateEvent":false,"PaymentResponse":false,"performance":false,"Performance":false,"PerformanceEntry":false,"PerformanceLongTaskTiming":false,"PerformanceMark":false,"PerformanceMeasure":false,"PerformanceNavigation":false,"PerformanceNavigationTiming":false,"PerformanceObserver":false,"PerformanceObserverEntryList":false,"PerformancePaintTiming":false,"PerformanceResourceTiming":false,"PerformanceTiming":false,"PeriodicWave":false,"Permissions":false,"PermissionStatus":false,"personalbar":false,"PhotoCapabilities":false,"Plugin":false,"PluginArray":false,"PointerEvent":false,"PopStateEvent":false,"postMessage":false,"Presentation":false,"PresentationAvailability":false,"PresentationConnection":false,"PresentationConnectionAvailableEvent":false,"PresentationConnectionCloseEvent":false,"PresentationConnectionList":false,"PresentationReceiver":false,"PresentationRequest":false,"print":false,"ProcessingInstruction":false,"ProgressEvent":false,"PromiseRejectionEvent":false,"prompt":false,"PushManager":false,"PushSubscription":false,"PushSubscriptionOptions":false,"RadioNodeList":false,"Range":false,"ReadableStream":false,"RemotePlayback":false,"removeEventListener":false,"Request":false,"requestAnimationFrame":false,"requestIdleCallback":false,"resizeBy":false,"ResizeObserver":false,"ResizeObserverEntry":false,"resizeTo":false,"Response":false,"RTCCertificate":false,"RTCDataChannel":false,"RTCDataChannelEvent":false,"RTCDtlsTransport":false,"RTCIceCandidate":false,"RTCIceGatherer":false,"RTCIceTransport":false,"RTCPeerConnection":false,"RTCPeerConnectionIceEvent":false,"RTCRtpContributingSource":false,"RTCRtpReceiver":false,"RTCRtpSender":false,"RTCSctpTransport":false,"RTCSessionDescription":false,"RTCStatsReport":false,"RTCTrackEvent":false,"screen":false,"Screen":false,"screenLeft":false,"ScreenOrientation":false,"screenTop":false,"screenX":false,"screenY":false,"ScriptProcessorNode":false,"scroll":false,"scrollbars":false,"scrollBy":false,"scrollTo":false,"scrollX":false,"scrollY":false,"SecurityPolicyViolationEvent":false,"Selection":false,"self":false,"ServiceWorker":false,"ServiceWorkerContainer":false,"ServiceWorkerRegistration":false,"sessionStorage":false,"setInterval":false,"setTimeout":false,"ShadowRoot":false,"SharedWorker":false,"SourceBuffer":false,"SourceBufferList":false,"speechSynthesis":false,"SpeechSynthesisEvent":false,"SpeechSynthesisUtterance":false,"StaticRange":false,"status":false,"statusbar":false,"StereoPannerNode":false,"stop":false,"Storage":false,"StorageEvent":false,"StorageManager":false,"styleMedia":false,"StyleSheet":false,"StyleSheetList":false,"SubtleCrypto":false,"SVGAElement":false,"SVGAngle":false,"SVGAnimatedAngle":false,"SVGAnimatedBoolean":false,"SVGAnimatedEnumeration":false,"SVGAnimatedInteger":false,"SVGAnimatedLength":false,"SVGAnimatedLengthList":false,"SVGAnimatedNumber":false,"SVGAnimatedNumberList":false,"SVGAnimatedPreserveAspectRatio":false,"SVGAnimatedRect":false,"SVGAnimatedString":false,"SVGAnimatedTransformList":false,"SVGAnimateElement":false,"SVGAnimateMotionElement":false,"SVGAnimateTransformElement":false,"SVGAnimationElement":false,"SVGCircleElement":false,"SVGClipPathElement":false,"SVGComponentTransferFunctionElement":false,"SVGDefsElement":false,"SVGDescElement":false,"SVGDiscardElement":false,"SVGElement":false,"SVGEllipseElement":false,"SVGFEBlendElement":false,"SVGFEColorMatrixElement":false,"SVGFEComponentTransferElement":false,"SVGFECompositeElement":false,"SVGFEConvolveMatrixElement":false,"SVGFEDiffuseLightingElement":false,"SVGFEDisplacementMapElement":false,"SVGFEDistantLightElement":false,"SVGFEDropShadowElement":false,"SVGFEFloodElement":false,"SVGFEFuncAElement":false,"SVGFEFuncBElement":false,"SVGFEFuncGElement":false,"SVGFEFuncRElement":false,"SVGFEGaussianBlurElement":false,"SVGFEImageElement":false,"SVGFEMergeElement":false,"SVGFEMergeNodeElement":false,"SVGFEMorphologyElement":false,"SVGFEOffsetElement":false,"SVGFEPointLightElement":false,"SVGFESpecularLightingElement":false,"SVGFESpotLightElement":false,"SVGFETileElement":false,"SVGFETurbulenceElement":false,"SVGFilterElement":false,"SVGForeignObjectElement":false,"SVGGElement":false,"SVGGeometryElement":false,"SVGGradientElement":false,"SVGGraphicsElement":false,"SVGImageElement":false,"SVGLength":false,"SVGLengthList":false,"SVGLinearGradientElement":false,"SVGLineElement":false,"SVGMarkerElement":false,"SVGMaskElement":false,"SVGMatrix":false,"SVGMetadataElement":false,"SVGMPathElement":false,"SVGNumber":false,"SVGNumberList":false,"SVGPathElement":false,"SVGPatternElement":false,"SVGPoint":false,"SVGPointList":false,"SVGPolygonElement":false,"SVGPolylineElement":false,"SVGPreserveAspectRatio":false,"SVGRadialGradientElement":false,"SVGRect":false,"SVGRectElement":false,"SVGScriptElement":false,"SVGSetElement":false,"SVGStopElement":false,"SVGStringList":false,"SVGStyleElement":false,"SVGSVGElement":false,"SVGSwitchElement":false,"SVGSymbolElement":false,"SVGTextContentElement":false,"SVGTextElement":false,"SVGTextPathElement":false,"SVGTextPositioningElement":false,"SVGTitleElement":false,"SVGTransform":false,"SVGTransformList":false,"SVGTSpanElement":false,"SVGUnitTypes":false,"SVGUseElement":false,"SVGViewElement":false,"TaskAttributionTiming":false,"Text":false,"TextDecoder":false,"TextEncoder":false,"TextEvent":false,"TextMetrics":false,"TextTrack":false,"TextTrackCue":false,"TextTrackCueList":false,"TextTrackList":false,"TimeRanges":false,"toolbar":false,"top":false,"Touch":false,"TouchEvent":false,"TouchList":false,"TrackEvent":false,"TransitionEvent":false,"TreeWalker":false,"UIEvent":false,"URL":false,"URLSearchParams":false,"ValidityState":false,"visualViewport":false,"VisualViewport":false,"VTTCue":false,"WaveShaperNode":false,"WebAssembly":false,"WebGL2RenderingContext":false,"WebGLActiveInfo":false,"WebGLBuffer":false,"WebGLContextEvent":false,"WebGLFramebuffer":false,"WebGLProgram":false,"WebGLQuery":false,"WebGLRenderbuffer":false,"WebGLRenderingContext":false,"WebGLSampler":false,"WebGLShader":false,"WebGLShaderPrecisionFormat":false,"WebGLSync":false,"WebGLTexture":false,"WebGLTransformFeedback":false,"WebGLUniformLocation":false,"WebGLVertexArrayObject":false,"WebSocket":false,"WheelEvent":false,"window":false,"Window":false,"Worker":false,"WritableStream":false,"XMLDocument":false,"XMLHttpRequest":false,"XMLHttpRequestEventTarget":false,"XMLHttpRequestUpload":false,"XMLSerializer":false,"XPathEvaluator":false,"XPathExpression":false,"XPathResult":false,"XSLTProcessor":false},"worker":{"applicationCache":false,"atob":false,"Blob":false,"BroadcastChannel":false,"btoa":false,"Cache":false,"caches":false,"clearInterval":false,"clearTimeout":false,"close":true,"console":false,"fetch":false,"FileReaderSync":false,"FormData":false,"Headers":false,"IDBCursor":false,"IDBCursorWithValue":false,"IDBDatabase":false,"IDBFactory":false,"IDBIndex":false,"IDBKeyRange":false,"IDBObjectStore":false,"IDBOpenDBRequest":false,"IDBRequest":false,"IDBTransaction":false,"IDBVersionChangeEvent":false,"ImageData":false,"importScripts":true,"indexedDB":false,"location":false,"MessageChannel":false,"MessagePort":false,"name":false,"navigator":false,"Notification":false,"onclose":true,"onconnect":true,"onerror":true,"onlanguagechange":true,"onmessage":true,"onoffline":true,"ononline":true,"onrejectionhandled":true,"onunhandledrejection":true,"performance":false,"Performance":false,"PerformanceEntry":false,"PerformanceMark":false,"PerformanceMeasure":false,"PerformanceNavigation":false,"PerformanceResourceTiming":false,"PerformanceTiming":false,"postMessage":true,"Promise":false,"Request":false,"Response":false,"self":true,"ServiceWorkerRegistration":false,"setInterval":false,"setTimeout":false,"TextDecoder":false,"TextEncoder":false,"URL":false,"URLSearchParams":false,"WebSocket":false,"Worker":false,"XMLHttpRequest":false},"node":{"__dirname":false,"__filename":false,"Buffer":false,"clearImmediate":false,"clearInterval":false,"clearTimeout":false,"console":false,"exports":true,"global":false,"Intl":false,"module":false,"process":false,"require":false,"setImmediate":false,"setInterval":false,"setTimeout":false},"commonjs":{"exports":true,"global":false,"module":false,"require":false},"amd":{"define":false,"require":false},"mocha":{"after":false,"afterEach":false,"before":false,"beforeEach":false,"context":false,"describe":false,"it":false,"mocha":false,"run":false,"setup":false,"specify":false,"suite":false,"suiteSetup":false,"suiteTeardown":false,"teardown":false,"test":false,"xcontext":false,"xdescribe":false,"xit":false,"xspecify":false},"jasmine":{"afterAll":false,"afterEach":false,"beforeAll":false,"beforeEach":false,"describe":false,"expect":false,"fail":false,"fdescribe":false,"fit":false,"it":false,"jasmine":false,"pending":false,"runs":false,"spyOn":false,"spyOnProperty":false,"waits":false,"waitsFor":false,"xdescribe":false,"xit":false},"jest":{"afterAll":false,"afterEach":false,"beforeAll":false,"beforeEach":false,"describe":false,"expect":false,"fdescribe":false,"fit":false,"it":false,"jest":false,"pit":false,"require":false,"test":false,"xdescribe":false,"xit":false,"xtest":false},"qunit":{"asyncTest":false,"deepEqual":false,"equal":false,"expect":false,"module":false,"notDeepEqual":false,"notEqual":false,"notOk":false,"notPropEqual":false,"notStrictEqual":false,"ok":false,"propEqual":false,"QUnit":false,"raises":false,"start":false,"stop":false,"strictEqual":false,"test":false,"throws":false},"phantomjs":{"console":true,"exports":true,"phantom":true,"require":true,"WebPage":true},"couch":{"emit":false,"exports":false,"getRow":false,"log":false,"module":false,"provides":false,"require":false,"respond":false,"send":false,"start":false,"sum":false},"rhino":{"defineClass":false,"deserialize":false,"gc":false,"help":false,"importClass":false,"importPackage":false,"java":false,"load":false,"loadClass":false,"Packages":false,"print":false,"quit":false,"readFile":false,"readUrl":false,"runCommand":false,"seal":false,"serialize":false,"spawn":false,"sync":false,"toint32":false,"version":false},"nashorn":{"__DIR__":false,"__FILE__":false,"__LINE__":false,"com":false,"edu":false,"exit":false,"java":false,"Java":false,"javafx":false,"JavaImporter":false,"javax":false,"JSAdapter":false,"load":false,"loadWithNewGlobal":false,"org":false,"Packages":false,"print":false,"quit":false},"wsh":{"ActiveXObject":true,"Enumerator":true,"GetObject":true,"ScriptEngine":true,"ScriptEngineBuildVersion":true,"ScriptEngineMajorVersion":true,"ScriptEngineMinorVersion":true,"VBArray":true,"WScript":true,"WSH":true,"XDomainRequest":true},"jquery":{"$":false,"jQuery":false},"yui":{"Y":false,"YUI":false,"YUI_config":false},"shelljs":{"cat":false,"cd":false,"chmod":false,"config":false,"cp":false,"dirs":false,"echo":false,"env":false,"error":false,"exec":false,"exit":false,"find":false,"grep":false,"ln":false,"ls":false,"mkdir":false,"mv":false,"popd":false,"pushd":false,"pwd":false,"rm":false,"sed":false,"set":false,"target":false,"tempdir":false,"test":false,"touch":false,"which":false},"prototypejs":{"$":false,"$$":false,"$A":false,"$break":false,"$continue":false,"$F":false,"$H":false,"$R":false,"$w":false,"Abstract":false,"Ajax":false,"Autocompleter":false,"Builder":false,"Class":false,"Control":false,"Draggable":false,"Draggables":false,"Droppables":false,"Effect":false,"Element":false,"Enumerable":false,"Event":false,"Field":false,"Form":false,"Hash":false,"Insertion":false,"ObjectRange":false,"PeriodicalExecuter":false,"Position":false,"Prototype":false,"Scriptaculous":false,"Selector":false,"Sortable":false,"SortableObserver":false,"Sound":false,"Template":false,"Toggle":false,"Try":false},"meteor":{"_":false,"$":false,"Accounts":false,"AccountsClient":false,"AccountsCommon":false,"AccountsServer":false,"App":false,"Assets":false,"Blaze":false,"check":false,"Cordova":false,"DDP":false,"DDPRateLimiter":false,"DDPServer":false,"Deps":false,"EJSON":false,"Email":false,"HTTP":false,"Log":false,"Match":false,"Meteor":false,"Mongo":false,"MongoInternals":false,"Npm":false,"Package":false,"Plugin":false,"process":false,"Random":false,"ReactiveDict":false,"ReactiveVar":false,"Router":false,"ServiceConfiguration":false,"Session":false,"share":false,"Spacebars":false,"Template":false,"Tinytest":false,"Tracker":false,"UI":false,"Utils":false,"WebApp":false,"WebAppInternals":false},"mongo":{"_isWindows":false,"_rand":false,"BulkWriteResult":false,"cat":false,"cd":false,"connect":false,"db":false,"getHostName":false,"getMemInfo":false,"hostname":false,"ISODate":false,"listFiles":false,"load":false,"ls":false,"md5sumFile":false,"mkdir":false,"Mongo":false,"NumberInt":false,"NumberLong":false,"ObjectId":false,"PlanCache":false,"print":false,"printjson":false,"pwd":false,"quit":false,"removeFile":false,"rs":false,"sh":false,"UUID":false,"version":false,"WriteResult":false},"applescript":{"$":false,"Application":false,"Automation":false,"console":false,"delay":false,"Library":false,"ObjC":false,"ObjectSpecifier":false,"Path":false,"Progress":false,"Ref":false},"serviceworker":{"Cache":false,"caches":false,"CacheStorage":false,"Client":false,"clients":false,"Clients":false,"ExtendableEvent":false,"ExtendableMessageEvent":false,"FetchEvent":false,"importScripts":false,"registration":false,"self":false,"ServiceWorker":false,"ServiceWorkerContainer":false,"ServiceWorkerGlobalScope":false,"ServiceWorkerMessageEvent":false,"ServiceWorkerRegistration":false,"skipWaiting":false,"WindowClient":false},"atomtest":{"advanceClock":false,"fakeClearInterval":false,"fakeClearTimeout":false,"fakeSetInterval":false,"fakeSetTimeout":false,"resetTimeouts":false,"waitsForPromise":false},"embertest":{"andThen":false,"click":false,"currentPath":false,"currentRouteName":false,"currentURL":false,"fillIn":false,"find":false,"findAll":false,"findWithAssert":false,"keyEvent":false,"pauseTest":false,"resumeTest":false,"triggerEvent":false,"visit":false,"wait":false},"protractor":{"$":false,"$$":false,"browser":false,"by":false,"By":false,"DartObject":false,"element":false,"protractor":false},"shared-node-browser":{"clearInterval":false,"clearTimeout":false,"console":false,"setInterval":false,"setTimeout":false},"webextensions":{"browser":false,"chrome":false,"opr":false},"greasemonkey":{"GM":false,"GM_addStyle":false,"GM_deleteValue":false,"GM_getResourceText":false,"GM_getResourceURL":false,"GM_getValue":false,"GM_info":false,"GM_listValues":false,"GM_log":false,"GM_openInTab":false,"GM_registerMenuCommand":false,"GM_setClipboard":false,"GM_setValue":false,"GM_xmlhttpRequest":false,"unsafeWindow":false},"devtools":{"$":false,"$_":false,"$$":false,"$0":false,"$1":false,"$2":false,"$3":false,"$4":false,"$x":false,"chrome":false,"clear":false,"copy":false,"debug":false,"dir":false,"dirxml":false,"getEventListeners":false,"inspect":false,"keys":false,"monitor":false,"monitorEvents":false,"profile":false,"profileEnd":false,"queryObjects":false,"table":false,"undebug":false,"unmonitor":false,"unmonitorEvents":false,"values":false}}

/***/ }),
/* 4201 */
/***/ (function(module, exports) {

	module.exports = {"75":8490,"83":383,"107":8490,"115":383,"181":924,"197":8491,"383":83,"452":453,"453":452,"455":456,"456":455,"458":459,"459":458,"497":498,"498":497,"837":8126,"914":976,"917":1013,"920":1012,"921":8126,"922":1008,"924":181,"928":982,"929":1009,"931":962,"934":981,"937":8486,"962":931,"976":914,"977":1012,"981":934,"982":928,"1008":922,"1009":929,"1012":[920,977],"1013":917,"7776":7835,"7835":7776,"8126":[837,921],"8486":937,"8490":75,"8491":197,"66560":66600,"66561":66601,"66562":66602,"66563":66603,"66564":66604,"66565":66605,"66566":66606,"66567":66607,"66568":66608,"66569":66609,"66570":66610,"66571":66611,"66572":66612,"66573":66613,"66574":66614,"66575":66615,"66576":66616,"66577":66617,"66578":66618,"66579":66619,"66580":66620,"66581":66621,"66582":66622,"66583":66623,"66584":66624,"66585":66625,"66586":66626,"66587":66627,"66588":66628,"66589":66629,"66590":66630,"66591":66631,"66592":66632,"66593":66633,"66594":66634,"66595":66635,"66596":66636,"66597":66637,"66598":66638,"66599":66639,"66600":66560,"66601":66561,"66602":66562,"66603":66563,"66604":66564,"66605":66565,"66606":66566,"66607":66567,"66608":66568,"66609":66569,"66610":66570,"66611":66571,"66612":66572,"66613":66573,"66614":66574,"66615":66575,"66616":66576,"66617":66577,"66618":66578,"66619":66579,"66620":66580,"66621":66581,"66622":66582,"66623":66583,"66624":66584,"66625":66585,"66626":66586,"66627":66587,"66628":66588,"66629":66589,"66630":66590,"66631":66591,"66632":66592,"66633":66593,"66634":66594,"66635":66595,"66636":66596,"66637":66597,"66638":66598,"66639":66599,"68736":68800,"68737":68801,"68738":68802,"68739":68803,"68740":68804,"68741":68805,"68742":68806,"68743":68807,"68744":68808,"68745":68809,"68746":68810,"68747":68811,"68748":68812,"68749":68813,"68750":68814,"68751":68815,"68752":68816,"68753":68817,"68754":68818,"68755":68819,"68756":68820,"68757":68821,"68758":68822,"68759":68823,"68760":68824,"68761":68825,"68762":68826,"68763":68827,"68764":68828,"68765":68829,"68766":68830,"68767":68831,"68768":68832,"68769":68833,"68770":68834,"68771":68835,"68772":68836,"68773":68837,"68774":68838,"68775":68839,"68776":68840,"68777":68841,"68778":68842,"68779":68843,"68780":68844,"68781":68845,"68782":68846,"68783":68847,"68784":68848,"68785":68849,"68786":68850,"68800":68736,"68801":68737,"68802":68738,"68803":68739,"68804":68740,"68805":68741,"68806":68742,"68807":68743,"68808":68744,"68809":68745,"68810":68746,"68811":68747,"68812":68748,"68813":68749,"68814":68750,"68815":68751,"68816":68752,"68817":68753,"68818":68754,"68819":68755,"68820":68756,"68821":68757,"68822":68758,"68823":68759,"68824":68760,"68825":68761,"68826":68762,"68827":68763,"68828":68764,"68829":68765,"68830":68766,"68831":68767,"68832":68768,"68833":68769,"68834":68770,"68835":68771,"68836":68772,"68837":68773,"68838":68774,"68839":68775,"68840":68776,"68841":68777,"68842":68778,"68843":68779,"68844":68780,"68845":68781,"68846":68782,"68847":68783,"68848":68784,"68849":68785,"68850":68786,"71840":71872,"71841":71873,"71842":71874,"71843":71875,"71844":71876,"71845":71877,"71846":71878,"71847":71879,"71848":71880,"71849":71881,"71850":71882,"71851":71883,"71852":71884,"71853":71885,"71854":71886,"71855":71887,"71856":71888,"71857":71889,"71858":71890,"71859":71891,"71860":71892,"71861":71893,"71862":71894,"71863":71895,"71864":71896,"71865":71897,"71866":71898,"71867":71899,"71868":71900,"71869":71901,"71870":71902,"71871":71903,"71872":71840,"71873":71841,"71874":71842,"71875":71843,"71876":71844,"71877":71845,"71878":71846,"71879":71847,"71880":71848,"71881":71849,"71882":71850,"71883":71851,"71884":71852,"71885":71853,"71886":71854,"71887":71855,"71888":71856,"71889":71857,"71890":71858,"71891":71859,"71892":71860,"71893":71861,"71894":71862,"71895":71863,"71896":71864,"71897":71865,"71898":71866,"71899":71867,"71900":71868,"71901":71869,"71902":71870,"71903":71871}

/***/ }),
/* 4202 */,
/* 4203 */,
/* 4204 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Recursively flattens `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flattenDeep([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, 3, 4, 5]
	 */
	function flattenDeep(array) {
	  var length = array ? array.length : 0;
	  return length ? baseFlatten(array, INFINITY) : [];
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = flattenDeep;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 4205 */,
/* 4206 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(137),
	    root = __webpack_require__(42);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 4207 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(4271),
	    hashDelete = __webpack_require__(4272),
	    hashGet = __webpack_require__(4273),
	    hashHas = __webpack_require__(4274),
	    hashSet = __webpack_require__(4275);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 4208 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(137),
	    root = __webpack_require__(42);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 4209 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ }),
/* 4210 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(101),
	    keys = __webpack_require__(76);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 4211 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(101),
	    keysIn = __webpack_require__(140);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 4212 */
/***/ (function(module, exports, __webpack_require__) {

	var baseConformsTo = __webpack_require__(4213),
	    keys = __webpack_require__(76);
	
	/**
	 * The base implementation of `_.conforms` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property predicates to conform to.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseConforms(source) {
	  var props = keys(source);
	  return function(object) {
	    return baseConformsTo(object, source, props);
	  };
	}
	
	module.exports = baseConforms;


/***/ }),
/* 4213 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.conformsTo` which accepts `props` to check.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property predicates to conform to.
	 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	 */
	function baseConformsTo(object, source, props) {
	  var length = props.length;
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (length--) {
	    var key = props[length],
	        predicate = source[key],
	        value = object[key];
	
	    if ((value === undefined && !(key in object)) || !predicate(value)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = baseConformsTo;


/***/ }),
/* 4214 */,
/* 4215 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(433),
	    arrayIncludes = __webpack_require__(436),
	    arrayIncludesWith = __webpack_require__(639),
	    arrayMap = __webpack_require__(100),
	    baseUnary = __webpack_require__(136),
	    cacheHas = __webpack_require__(449);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ }),
/* 4216 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(437),
	    isFlattenable = __webpack_require__(4279);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 4217 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(644),
	    keys = __webpack_require__(76);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 4218 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty.call(object, key);
	}
	
	module.exports = baseHas;


/***/ }),
/* 4219 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 4220 */
/***/ (function(module, exports) {

	/**
	 * This function is like `baseIndexOf` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOfWith(array, value, fromIndex, comparator) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (comparator(array[index], value)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOfWith;


/***/ }),
/* 4221 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(72),
	    isObjectLike = __webpack_require__(43);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 4222 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(317),
	    equalArrays = __webpack_require__(661),
	    equalByTag = __webpack_require__(4263),
	    equalObjects = __webpack_require__(4264),
	    getTag = __webpack_require__(224),
	    isArray = __webpack_require__(24),
	    isBuffer = __webpack_require__(232),
	    isTypedArray = __webpack_require__(333);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 4223 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(224),
	    isObjectLike = __webpack_require__(43);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 4224 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(317),
	    baseIsEqual = __webpack_require__(445);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 4225 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 4226 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(102),
	    isMasked = __webpack_require__(4281),
	    isObject = __webpack_require__(49),
	    toSource = __webpack_require__(680);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 4227 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(72),
	    isObjectLike = __webpack_require__(43);
	
	/** `Object#toString` result references. */
	var regexpTag = '[object RegExp]';
	
	/**
	 * The base implementation of `_.isRegExp` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 */
	function baseIsRegExp(value) {
	  return isObjectLike(value) && baseGetTag(value) == regexpTag;
	}
	
	module.exports = baseIsRegExp;


/***/ }),
/* 4228 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(224),
	    isObjectLike = __webpack_require__(43);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),
/* 4229 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(72),
	    isLength = __webpack_require__(473),
	    isObjectLike = __webpack_require__(43);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 4230 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(49),
	    isPrototype = __webpack_require__(228),
	    nativeKeysIn = __webpack_require__(4296);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 4231 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(221),
	    isArrayLike = __webpack_require__(74);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 4232 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(4224),
	    getMatchData = __webpack_require__(4267),
	    matchesStrictComparable = __webpack_require__(671);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 4233 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(317),
	    assignMergeValue = __webpack_require__(641),
	    baseFor = __webpack_require__(644),
	    baseMergeDeep = __webpack_require__(4234),
	    isObject = __webpack_require__(49),
	    keysIn = __webpack_require__(140),
	    safeGet = __webpack_require__(676);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ }),
/* 4234 */
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(641),
	    cloneBuffer = __webpack_require__(652),
	    cloneTypedArray = __webpack_require__(653),
	    copyArray = __webpack_require__(222),
	    initCloneObject = __webpack_require__(668),
	    isArguments = __webpack_require__(231),
	    isArray = __webpack_require__(24),
	    isArrayLikeObject = __webpack_require__(686),
	    isBuffer = __webpack_require__(232),
	    isFunction = __webpack_require__(102),
	    isObject = __webpack_require__(49),
	    isPlainObject = __webpack_require__(75),
	    isTypedArray = __webpack_require__(333),
	    safeGet = __webpack_require__(676),
	    toPlainObject = __webpack_require__(4346);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),
/* 4235 */
/***/ (function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(648),
	    hasIn = __webpack_require__(685);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ }),
/* 4236 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 4237 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(443);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 4238 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(100),
	    baseIndexOf = __webpack_require__(444),
	    baseIndexOfWith = __webpack_require__(4220),
	    baseUnary = __webpack_require__(136),
	    copyArray = __webpack_require__(222);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * The base implementation of `_.pullAllBy` without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to remove.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns `array`.
	 */
	function basePullAll(array, values, iteratee, comparator) {
	  var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	      index = -1,
	      length = values.length,
	      seen = array;
	
	  if (array === values) {
	    values = copyArray(values);
	  }
	  if (iteratee) {
	    seen = arrayMap(array, baseUnary(iteratee));
	  }
	  while (++index < length) {
	    var fromIndex = 0,
	        value = values[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	      if (seen !== array) {
	        splice.call(seen, fromIndex, 1);
	      }
	      splice.call(array, fromIndex, 1);
	    }
	  }
	  return array;
	}
	
	module.exports = basePullAll;


/***/ }),
/* 4239 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ }),
/* 4240 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor;
	
	/**
	 * The base implementation of `_.repeat` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {string} string The string to repeat.
	 * @param {number} n The number of times to repeat the string.
	 * @returns {string} Returns the repeated string.
	 */
	function baseRepeat(string, n) {
	  var result = '';
	  if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	    return result;
	  }
	  // Leverage the exponentiation by squaring algorithm for a faster repeat.
	  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	  do {
	    if (n % 2) {
	      result += string;
	    }
	    n = nativeFloor(n / 2);
	    if (n) {
	      string += string;
	    }
	  } while (n);
	
	  return result;
	}
	
	module.exports = baseRepeat;


/***/ }),
/* 4241 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(318),
	    castPath = __webpack_require__(322),
	    isIndex = __webpack_require__(226),
	    isObject = __webpack_require__(49),
	    toKey = __webpack_require__(230);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ }),
/* 4242 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(4316),
	    defineProperty = __webpack_require__(660),
	    identity = __webpack_require__(53);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 4243 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(221);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ }),
/* 4244 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 4245 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(181),
	    arrayMap = __webpack_require__(100),
	    isArray = __webpack_require__(24),
	    isSymbol = __webpack_require__(233);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 4246 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(53);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),
/* 4247 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(451);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 4248 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 4249 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(181);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 4250 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(101),
	    getSymbols = __webpack_require__(457);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 4251 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(101),
	    getSymbolsIn = __webpack_require__(666);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 4252 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(42);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 4253 */
/***/ (function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      ++result;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ }),
/* 4254 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(74);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 4255 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 4256 */
/***/ (function(module, exports, __webpack_require__) {

	var createCtor = __webpack_require__(324),
	    root = __webpack_require__(42);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBind;


/***/ }),
/* 4257 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(182),
	    createCtor = __webpack_require__(324),
	    createHybrid = __webpack_require__(656),
	    createRecurry = __webpack_require__(658),
	    getHolder = __webpack_require__(325),
	    replaceHolders = __webpack_require__(229),
	    root = __webpack_require__(42);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurry;


/***/ }),
/* 4258 */,
/* 4259 */
/***/ (function(module, exports, __webpack_require__) {

	var LodashWrapper = __webpack_require__(430),
	    flatRest = __webpack_require__(454),
	    getData = __webpack_require__(455),
	    getFuncName = __webpack_require__(665),
	    isArray = __webpack_require__(24),
	    isLaziable = __webpack_require__(669);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/**
	 * Creates a `_.flow` or `_.flowRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new flow function.
	 */
	function createFlow(fromRight) {
	  return flatRest(function(funcs) {
	    var length = funcs.length,
	        index = length,
	        prereq = LodashWrapper.prototype.thru;
	
	    if (fromRight) {
	      funcs.reverse();
	    }
	    while (index--) {
	      var func = funcs[index];
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	        var wrapper = new LodashWrapper([], true);
	      }
	    }
	    index = wrapper ? index : length;
	    while (++index < length) {
	      func = funcs[index];
	
	      var funcName = getFuncName(func),
	          data = funcName == 'wrapper' ? getData(func) : undefined;
	
	      if (data && isLaziable(data[0]) &&
	            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	            !data[4].length && data[9] == 1
	          ) {
	        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	      } else {
	        wrapper = (func.length == 1 && isLaziable(func))
	          ? wrapper[funcName]()
	          : wrapper.thru(func);
	      }
	    }
	    return function() {
	      var args = arguments,
	          value = args[0];
	
	      if (wrapper && args.length == 1 && isArray(value)) {
	        return wrapper.plant(value).value();
	      }
	      var index = 0,
	          result = length ? funcs[index].apply(this, args) : value;
	
	      while (++index < length) {
	        result = funcs[index].call(this, result);
	      }
	      return result;
	    };
	  });
	}
	
	module.exports = createFlow;


/***/ }),
/* 4260 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(182),
	    createCtor = __webpack_require__(324),
	    root = __webpack_require__(42);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartial;


/***/ }),
/* 4261 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(636),
	    noop = __webpack_require__(184),
	    setToArray = __webpack_require__(460);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ }),
/* 4262 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(138);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	 * of source objects to the destination object for all destination properties
	 * that resolve to `undefined`.
	 *
	 * @private
	 * @param {*} objValue The destination value.
	 * @param {*} srcValue The source value.
	 * @param {string} key The key of the property to assign.
	 * @param {Object} object The parent object of `objValue`.
	 * @returns {*} Returns the value to assign.
	 */
	function customDefaultsAssignIn(objValue, srcValue, key, object) {
	  if (objValue === undefined ||
	      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	    return srcValue;
	  }
	  return objValue;
	}
	
	module.exports = customDefaultsAssignIn;


/***/ }),
/* 4263 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(181),
	    Uint8Array = __webpack_require__(637),
	    eq = __webpack_require__(138),
	    equalArrays = __webpack_require__(661),
	    mapToArray = __webpack_require__(4292),
	    setToArray = __webpack_require__(460);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 4264 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(663);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 4265 */
/***/ (function(module, exports, __webpack_require__) {

	var basePropertyOf = __webpack_require__(447);
	
	/** Used to map characters to HTML entities. */
	var htmlEscapes = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#39;'
	};
	
	/**
	 * Used by `_.escape` to convert characters to HTML entities.
	 *
	 * @private
	 * @param {string} chr The matched character to escape.
	 * @returns {string} Returns the escaped character.
	 */
	var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	module.exports = escapeHtmlChar;


/***/ }),
/* 4266 */
/***/ (function(module, exports) {

	/** Used to escape characters for inclusion in compiled string literals. */
	var stringEscapes = {
	  '\\': '\\',
	  "'": "'",
	  '\n': 'n',
	  '\r': 'r',
	  '\u2028': 'u2028',
	  '\u2029': 'u2029'
	};
	
	/**
	 * Used by `_.template` to escape characters for inclusion in compiled string literals.
	 *
	 * @private
	 * @param {string} chr The matched character to escape.
	 * @returns {string} Returns the escaped character.
	 */
	function escapeStringChar(chr) {
	  return '\\' + stringEscapes[chr];
	}
	
	module.exports = escapeStringChar;


/***/ }),
/* 4267 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(670),
	    keys = __webpack_require__(76);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 4268 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(181);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 4269 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 4270 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	module.exports = getWrapDetails;


/***/ }),
/* 4271 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(327);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 4272 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 4273 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(327);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 4274 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(327);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 4275 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(327);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 4276 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 4277 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(451),
	    cloneDataView = __webpack_require__(4247),
	    cloneRegExp = __webpack_require__(4248),
	    cloneSymbol = __webpack_require__(4249),
	    cloneTypedArray = __webpack_require__(653);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 4278 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length;
	  if (!length) {
	    return source;
	  }
	  var lastIndex = length - 1;
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	module.exports = insertWrapDetails;


/***/ }),
/* 4279 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(181),
	    isArguments = __webpack_require__(231),
	    isArray = __webpack_require__(24);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 4280 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 4281 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(4252);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 4282 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 4283 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(319);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 4284 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(319);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 4285 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(319);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 4286 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(319);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 4287 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(4207),
	    ListCache = __webpack_require__(316),
	    Map = __webpack_require__(431);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 4288 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(326);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 4289 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(326);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 4290 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(326);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 4291 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(326);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 4292 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 4293 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(4331);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 4294 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(654),
	    composeArgsRight = __webpack_require__(655),
	    replaceHolders = __webpack_require__(229);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & WRAP_BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & WRAP_ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ }),
/* 4295 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(673);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 4296 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 4297 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 4298 */
/***/ (function(module, exports) {

	/** Used to match template delimiters. */
	var reEscape = /<%-([\s\S]+?)%>/g;
	
	module.exports = reEscape;


/***/ }),
/* 4299 */
/***/ (function(module, exports) {

	/** Used to match template delimiters. */
	var reEvaluate = /<%([\s\S]+?)%>/g;
	
	module.exports = reEvaluate;


/***/ }),
/* 4300 */
/***/ (function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ }),
/* 4301 */
/***/ (function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(222),
	    isIndex = __webpack_require__(226);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ }),
/* 4302 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 4303 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 4304 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(316);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 4305 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 4306 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 4307 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 4308 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(316),
	    Map = __webpack_require__(431),
	    MapCache = __webpack_require__(432);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 4309 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 4310 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(4293);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 4311 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(434),
	    arrayIncludes = __webpack_require__(436);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256,
	    WRAP_FLIP_FLAG = 512;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', WRAP_ARY_FLAG],
	  ['bind', WRAP_BIND_FLAG],
	  ['bindKey', WRAP_BIND_KEY_FLAG],
	  ['curry', WRAP_CURRY_FLAG],
	  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	  ['flip', WRAP_FLIP_FLAG],
	  ['partial', WRAP_PARTIAL_FLAG],
	  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	  ['rearg', WRAP_REARG_FLAG]
	];
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	module.exports = updateWrapDetails;


/***/ }),
/* 4312 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(429),
	    LodashWrapper = __webpack_require__(430),
	    copyArray = __webpack_require__(222);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ }),
/* 4313 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(101),
	    createAssigner = __webpack_require__(323),
	    keysIn = __webpack_require__(140);
	
	/**
	 * This method is like `_.assignIn` except that it accepts `customizer`
	 * which is invoked to produce the assigned values. If `customizer` returns
	 * `undefined`, assignment is handled by the method instead. The `customizer`
	 * is invoked with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extendWith
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @see _.assignWith
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignInWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObject(source, keysIn(source), object, customizer);
	});
	
	module.exports = assignInWith;


/***/ }),
/* 4314 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(320);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ }),
/* 4315 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(320),
	    baseConforms = __webpack_require__(4212);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a function that invokes the predicate properties of `source` with
	 * the corresponding property values of a given object, returning `true` if
	 * all predicates return truthy, else `false`.
	 *
	 * **Note:** The created function is equivalent to `_.conformsTo` with
	 * `source` partially applied.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {Object} source The object of property predicates to conform to.
	 * @returns {Function} Returns the new spec function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': 2, 'b': 1 },
	 *   { 'a': 1, 'b': 2 }
	 * ];
	 *
	 * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	 * // => [{ 'a': 1, 'b': 2 }]
	 */
	function conforms(source) {
	  return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	}
	
	module.exports = conforms;


/***/ }),
/* 4316 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 4317 */,
/* 4318 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(465);


/***/ }),
/* 4319 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(435),
	    baseFilter = __webpack_require__(642),
	    baseIteratee = __webpack_require__(60),
	    isArray = __webpack_require__(24);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),
/* 4320 */,
/* 4321 */,
/* 4322 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(443);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 4323 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(445);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ }),
/* 4324 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	 * @example
	 *
	 * _.isNull(null);
	 * // => true
	 *
	 * _.isNull(void 0);
	 * // => false
	 */
	function isNull(value) {
	  return value === null;
	}
	
	module.exports = isNull;


/***/ }),
/* 4325 */,
/* 4326 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsRegExp = __webpack_require__(4227),
	    baseUnary = __webpack_require__(136),
	    nodeUtil = __webpack_require__(328);
	
	/* Node.js helper references. */
	var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;
	
	/**
	 * Checks if `value` is classified as a `RegExp` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 * @example
	 *
	 * _.isRegExp(/abc/);
	 * // => true
	 *
	 * _.isRegExp('/abc/');
	 * // => false
	 */
	var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	module.exports = isRegExp;


/***/ }),
/* 4327 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(4228),
	    baseUnary = __webpack_require__(136),
	    nodeUtil = __webpack_require__(328);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 4328 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ }),
/* 4329 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 4330 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(100),
	    baseIteratee = __webpack_require__(60),
	    baseMap = __webpack_require__(4231),
	    isArray = __webpack_require__(24);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 4331 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(432);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 4332 */
/***/ (function(module, exports) {

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that negates the result of the predicate `func`. The
	 * `func` predicate is invoked with the `this` binding and arguments of the
	 * created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} predicate The predicate to negate.
	 * @returns {Function} Returns the new negated function.
	 * @example
	 *
	 * function isEven(n) {
	 *   return n % 2 == 0;
	 * }
	 *
	 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	 * // => [1, 3, 5]
	 */
	function negate(predicate) {
	  if (typeof predicate != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return function() {
	    var args = arguments;
	    switch (args.length) {
	      case 0: return !predicate.call(this);
	      case 1: return !predicate.call(this, args[0]);
	      case 2: return !predicate.call(this, args[0], args[1]);
	      case 3: return !predicate.call(this, args[0], args[1], args[2]);
	    }
	    return !predicate.apply(this, args);
	  };
	}
	
	module.exports = negate;


/***/ }),
/* 4333 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(4209),
	    createOver = __webpack_require__(657);
	
	/**
	 * Creates a function that checks if **all** of the `predicates` return
	 * truthy when invoked with the arguments it receives.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {...(Function|Function[])} [predicates=[_.identity]]
	 *  The predicates to check.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var func = _.overEvery([Boolean, isFinite]);
	 *
	 * func('1');
	 * // => true
	 *
	 * func(null);
	 * // => false
	 *
	 * func(NaN);
	 * // => false
	 */
	var overEvery = createOver(arrayEvery);
	
	module.exports = overEvery;


/***/ }),
/* 4334 */
/***/ (function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(439),
	    createOver = __webpack_require__(657);
	
	/**
	 * Creates a function that checks if **any** of the `predicates` return
	 * truthy when invoked with the arguments it receives.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {...(Function|Function[])} [predicates=[_.identity]]
	 *  The predicates to check.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var func = _.overSome([Boolean, isFinite]);
	 *
	 * func('1');
	 * // => true
	 *
	 * func(null);
	 * // => true
	 *
	 * func(NaN);
	 * // => false
	 */
	var overSome = createOver(arraySome);
	
	module.exports = overSome;


/***/ }),
/* 4335 */,
/* 4336 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(4236),
	    basePropertyDeep = __webpack_require__(4237),
	    isKey = __webpack_require__(459),
	    toKey = __webpack_require__(230);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 4337 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(73),
	    pullAll = __webpack_require__(4338);
	
	/**
	 * Removes all given values from `array` using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	 * to remove elements from an array by predicate.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {...*} [values] The values to remove.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	 *
	 * _.pull(array, 'a', 'c');
	 * console.log(array);
	 * // => ['b', 'b']
	 */
	var pull = baseRest(pullAll);
	
	module.exports = pull;


/***/ }),
/* 4338 */
/***/ (function(module, exports, __webpack_require__) {

	var basePullAll = __webpack_require__(4238);
	
	/**
	 * This method is like `_.pull` except that it accepts an array of values to remove.
	 *
	 * **Note:** Unlike `_.difference`, this method mutates `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to remove.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	 *
	 * _.pullAll(array, ['a', 'c']);
	 * console.log(array);
	 * // => ['b', 'b']
	 */
	function pullAll(array, values) {
	  return (array && array.length && values && values.length)
	    ? basePullAll(array, values)
	    : array;
	}
	
	module.exports = pullAll;


/***/ }),
/* 4339 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(438),
	    baseEach = __webpack_require__(221),
	    baseIteratee = __webpack_require__(60),
	    baseReduce = __webpack_require__(4239),
	    isArray = __webpack_require__(24);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ }),
/* 4340 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(435),
	    baseFilter = __webpack_require__(642),
	    baseIteratee = __webpack_require__(60),
	    isArray = __webpack_require__(24),
	    negate = __webpack_require__(4332);
	
	/**
	 * The opposite of `_.filter`; this method returns the elements of `collection`
	 * that `predicate` does **not** return truthy for.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.filter
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': true }
	 * ];
	 *
	 * _.reject(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.reject(users, { 'age': 40, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.reject(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.reject(users, 'active');
	 * // => objects for ['barney']
	 */
	function reject(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, negate(baseIteratee(predicate, 3)));
	}
	
	module.exports = reject;


/***/ }),
/* 4341 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRepeat = __webpack_require__(4240),
	    isIterateeCall = __webpack_require__(227),
	    toInteger = __webpack_require__(334),
	    toString = __webpack_require__(54);
	
	/**
	 * Repeats the given string `n` times.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to repeat.
	 * @param {number} [n=1] The number of times to repeat the string.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {string} Returns the repeated string.
	 * @example
	 *
	 * _.repeat('*', 3);
	 * // => '***'
	 *
	 * _.repeat('abc', 2);
	 * // => 'abcabc'
	 *
	 * _.repeat('abc', 0);
	 * // => ''
	 */
	function repeat(string, n, guard) {
	  if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	    n = 1;
	  } else {
	    n = toInteger(n);
	  }
	  return baseRepeat(toString(string), n);
	}
	
	module.exports = repeat;


/***/ }),
/* 4342 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 4343 */
/***/ (function(module, exports, __webpack_require__) {

	var assignInWith = __webpack_require__(4313),
	    attempt = __webpack_require__(681),
	    baseValues = __webpack_require__(651),
	    customDefaultsAssignIn = __webpack_require__(4262),
	    escapeStringChar = __webpack_require__(4266),
	    isError = __webpack_require__(472),
	    isIterateeCall = __webpack_require__(227),
	    keys = __webpack_require__(76),
	    reInterpolate = __webpack_require__(675),
	    templateSettings = __webpack_require__(4344),
	    toString = __webpack_require__(54);
	
	/** Used to match empty string literals in compiled template source. */
	var reEmptyStringLeading = /\b__p \+= '';/g,
	    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	/**
	 * Used to match
	 * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	 */
	var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	/** Used to ensure capturing order of template delimiters. */
	var reNoMatch = /($^)/;
	
	/** Used to match unescaped characters in compiled string literals. */
	var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	/**
	 * Creates a compiled template function that can interpolate data properties
	 * in "interpolate" delimiters, HTML-escape interpolated data properties in
	 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	 * properties may be accessed as free variables in the template. If a setting
	 * object is given, it takes precedence over `_.templateSettings` values.
	 *
	 * **Note:** In the development build `_.template` utilizes
	 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	 * for easier debugging.
	 *
	 * For more information on precompiling templates see
	 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	 *
	 * For more information on Chrome extension sandboxes see
	 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The template string.
	 * @param {Object} [options={}] The options object.
	 * @param {RegExp} [options.escape=_.templateSettings.escape]
	 *  The HTML "escape" delimiter.
	 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	 *  The "evaluate" delimiter.
	 * @param {Object} [options.imports=_.templateSettings.imports]
	 *  An object to import into the template as free variables.
	 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	 *  The "interpolate" delimiter.
	 * @param {string} [options.sourceURL='templateSources[n]']
	 *  The sourceURL of the compiled template.
	 * @param {string} [options.variable='obj']
	 *  The data object variable name.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the compiled template function.
	 * @example
	 *
	 * // Use the "interpolate" delimiter to create a compiled template.
	 * var compiled = _.template('hello <%= user %>!');
	 * compiled({ 'user': 'fred' });
	 * // => 'hello fred!'
	 *
	 * // Use the HTML "escape" delimiter to escape data property values.
	 * var compiled = _.template('<b><%- value %></b>');
	 * compiled({ 'value': '<script>' });
	 * // => '<b>&lt;script&gt;</b>'
	 *
	 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	 * compiled({ 'users': ['fred', 'barney'] });
	 * // => '<li>fred</li><li>barney</li>'
	 *
	 * // Use the internal `print` function in "evaluate" delimiters.
	 * var compiled = _.template('<% print("hello " + user); %>!');
	 * compiled({ 'user': 'barney' });
	 * // => 'hello barney!'
	 *
	 * // Use the ES template literal delimiter as an "interpolate" delimiter.
	 * // Disable support by replacing the "interpolate" delimiter.
	 * var compiled = _.template('hello ${ user }!');
	 * compiled({ 'user': 'pebbles' });
	 * // => 'hello pebbles!'
	 *
	 * // Use backslashes to treat delimiters as plain text.
	 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	 * compiled({ 'value': 'ignored' });
	 * // => '<%- value %>'
	 *
	 * // Use the `imports` option to import `jQuery` as `jq`.
	 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	 * compiled({ 'users': ['fred', 'barney'] });
	 * // => '<li>fred</li><li>barney</li>'
	 *
	 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	 * compiled(data);
	 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	 *
	 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	 * compiled.source;
	 * // => function(data) {
	 * //   var __t, __p = '';
	 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	 * //   return __p;
	 * // }
	 *
	 * // Use custom template delimiters.
	 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	 * var compiled = _.template('hello {{ user }}!');
	 * compiled({ 'user': 'mustache' });
	 * // => 'hello mustache!'
	 *
	 * // Use the `source` property to inline compiled templates for meaningful
	 * // line numbers in error messages and stack traces.
	 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	 *   var JST = {\
	 *     "main": ' + _.template(mainText).source + '\
	 *   };\
	 * ');
	 */
	function template(string, options, guard) {
	  // Based on John Resig's `tmpl` implementation
	  // (http://ejohn.org/blog/javascript-micro-templating/)
	  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	  var settings = templateSettings.imports._.templateSettings || templateSettings;
	
	  if (guard && isIterateeCall(string, options, guard)) {
	    options = undefined;
	  }
	  string = toString(string);
	  options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	  var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	      importsKeys = keys(imports),
	      importsValues = baseValues(imports, importsKeys);
	
	  var isEscaping,
	      isEvaluating,
	      index = 0,
	      interpolate = options.interpolate || reNoMatch,
	      source = "__p += '";
	
	  // Compile the regexp to match each delimiter.
	  var reDelimiters = RegExp(
	    (options.escape || reNoMatch).source + '|' +
	    interpolate.source + '|' +
	    (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	    (options.evaluate || reNoMatch).source + '|$'
	  , 'g');
	
	  // Use a sourceURL for easier debugging.
	  var sourceURL = 'sourceURL' in options ? '//# sourceURL=' + options.sourceURL + '\n' : '';
	
	  string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	    interpolateValue || (interpolateValue = esTemplateValue);
	
	    // Escape characters that can't be included in string literals.
	    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	    // Replace delimiters with snippets.
	    if (escapeValue) {
	      isEscaping = true;
	      source += "' +\n__e(" + escapeValue + ") +\n'";
	    }
	    if (evaluateValue) {
	      isEvaluating = true;
	      source += "';\n" + evaluateValue + ";\n__p += '";
	    }
	    if (interpolateValue) {
	      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	    }
	    index = offset + match.length;
	
	    // The JS engine embedded in Adobe products needs `match` returned in
	    // order to produce the correct `offset` value.
	    return match;
	  });
	
	  source += "';\n";
	
	  // If `variable` is not specified wrap a with-statement around the generated
	  // code to add the data object to the top of the scope chain.
	  var variable = options.variable;
	  if (!variable) {
	    source = 'with (obj) {\n' + source + '\n}\n';
	  }
	  // Cleanup code by stripping empty strings.
	  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	    .replace(reEmptyStringMiddle, '$1')
	    .replace(reEmptyStringTrailing, '$1;');
	
	  // Frame code as the function body.
	  source = 'function(' + (variable || 'obj') + ') {\n' +
	    (variable
	      ? ''
	      : 'obj || (obj = {});\n'
	    ) +
	    "var __t, __p = ''" +
	    (isEscaping
	       ? ', __e = _.escape'
	       : ''
	    ) +
	    (isEvaluating
	      ? ', __j = Array.prototype.join;\n' +
	        "function print() { __p += __j.call(arguments, '') }\n"
	      : ';\n'
	    ) +
	    source +
	    'return __p\n}';
	
	  var result = attempt(function() {
	    return Function(importsKeys, sourceURL + 'return ' + source)
	      .apply(undefined, importsValues);
	  });
	
	  // Provide the compiled function's source by its `toString` method or
	  // the `source` property as a convenience for inlining compiled templates.
	  result.source = source;
	  if (isError(result)) {
	    throw result;
	  }
	  return result;
	}
	
	module.exports = template;


/***/ }),
/* 4344 */
/***/ (function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(683),
	    reEscape = __webpack_require__(4298),
	    reEvaluate = __webpack_require__(4299),
	    reInterpolate = __webpack_require__(675);
	
	/**
	 * By default, the template delimiters used by lodash are like those in
	 * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	 * following template settings to use alternative delimiters.
	 *
	 * @static
	 * @memberOf _
	 * @type {Object}
	 */
	var templateSettings = {
	
	  /**
	   * Used to detect `data` property values to be HTML-escaped.
	   *
	   * @memberOf _.templateSettings
	   * @type {RegExp}
	   */
	  'escape': reEscape,
	
	  /**
	   * Used to detect code to be evaluated.
	   *
	   * @memberOf _.templateSettings
	   * @type {RegExp}
	   */
	  'evaluate': reEvaluate,
	
	  /**
	   * Used to detect `data` property values to inject.
	   *
	   * @memberOf _.templateSettings
	   * @type {RegExp}
	   */
	  'interpolate': reInterpolate,
	
	  /**
	   * Used to reference the data object in the template text.
	   *
	   * @memberOf _.templateSettings
	   * @type {string}
	   */
	  'variable': '',
	
	  /**
	   * Used to import variables into the compiled template.
	   *
	   * @memberOf _.templateSettings
	   * @type {Object}
	   */
	  'imports': {
	
	    /**
	     * A reference to the `lodash` function.
	     *
	     * @memberOf _.templateSettings.imports
	     * @type {Function}
	     */
	    '_': { 'escape': escape }
	  }
	};
	
	module.exports = templateSettings;


/***/ }),
/* 4345 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(695);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 4346 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(101),
	    keysIn = __webpack_require__(140);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 4347 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(60),
	    baseUniq = __webpack_require__(650);
	
	/**
	 * This method is like `_.uniq` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * uniqueness is computed. The order of result values is determined by the
	 * order they occur in the array. The iteratee is invoked with one argument:
	 * (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	 * // => [2.1, 1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniqBy(array, iteratee) {
	  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
	}
	
	module.exports = uniqBy;


/***/ }),
/* 4348 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(4215),
	    baseRest = __webpack_require__(73),
	    isArrayLikeObject = __webpack_require__(686);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.pull`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.xor
	 * @example
	 *
	 * _.without([2, 1, 2, 3], 1, 2);
	 * // => [3]
	 */
	var without = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ }),
/* 4349 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(429),
	    LodashWrapper = __webpack_require__(430),
	    baseLodash = __webpack_require__(446),
	    isArray = __webpack_require__(24),
	    isObjectLike = __webpack_require__(43),
	    wrapperClone = __webpack_require__(4312);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array and iteratees accept only
	 * one argument. The heuristic for whether a section qualifies for shortcut
	 * fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ }),
/* 4350 */,
/* 4351 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var w = d * 7;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\-?\d?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'weeks':
	    case 'week':
	    case 'w':
	      return n * w;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  var msAbs = Math.abs(ms);
	  if (msAbs >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (msAbs >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (msAbs >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (msAbs >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  var msAbs = Math.abs(ms);
	  if (msAbs >= d) {
	    return plural(ms, msAbs, d, 'day');
	  }
	  if (msAbs >= h) {
	    return plural(ms, msAbs, h, 'hour');
	  }
	  if (msAbs >= m) {
	    return plural(ms, msAbs, m, 'minute');
	  }
	  if (msAbs >= s) {
	    return plural(ms, msAbs, s, 'second');
	  }
	  return ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, msAbs, n, name) {
	  var isPlural = msAbs >= n * 1.5;
	  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
	}


/***/ }),
/* 4352 */
/***/ (function(module, exports) {

	(function(root, factory) {
	    if (typeof module === 'object' && module.exports) {
	        module.exports = factory();
	    } else {
	        root.nearley = factory();
	    }
	}(this, function() {
	
	    function Rule(name, symbols, postprocess) {
	        this.id = ++Rule.highestId;
	        this.name = name;
	        this.symbols = symbols;        // a list of literal | regex class | nonterminal
	        this.postprocess = postprocess;
	        return this;
	    }
	    Rule.highestId = 0;
	
	    Rule.prototype.toString = function(withCursorAt) {
	        function stringifySymbolSequence (e) {
	            return e.literal ? JSON.stringify(e.literal) :
	                   e.type ? '%' + e.type : e.toString();
	        }
	        var symbolSequence = (typeof withCursorAt === "undefined")
	                             ? this.symbols.map(stringifySymbolSequence).join(' ')
	                             : (   this.symbols.slice(0, withCursorAt).map(stringifySymbolSequence).join(' ')
	                                 + " ● "
	                                 + this.symbols.slice(withCursorAt).map(stringifySymbolSequence).join(' ')     );
	        return this.name + " → " + symbolSequence;
	    }
	
	
	    // a State is a rule at a position from a given starting point in the input stream (reference)
	    function State(rule, dot, reference, wantedBy) {
	        this.rule = rule;
	        this.dot = dot;
	        this.reference = reference;
	        this.data = [];
	        this.wantedBy = wantedBy;
	        this.isComplete = this.dot === rule.symbols.length;
	    }
	
	    State.prototype.toString = function() {
	        return "{" + this.rule.toString(this.dot) + "}, from: " + (this.reference || 0);
	    };
	
	    State.prototype.nextState = function(child) {
	        var state = new State(this.rule, this.dot + 1, this.reference, this.wantedBy);
	        state.left = this;
	        state.right = child;
	        if (state.isComplete) {
	            state.data = state.build();
	        }
	        return state;
	    };
	
	    State.prototype.build = function() {
	        var children = [];
	        var node = this;
	        do {
	            children.push(node.right.data);
	            node = node.left;
	        } while (node.left);
	        children.reverse();
	        return children;
	    };
	
	    State.prototype.finish = function() {
	        if (this.rule.postprocess) {
	            this.data = this.rule.postprocess(this.data, this.reference, Parser.fail);
	        }
	    };
	
	
	    function Column(grammar, index) {
	        this.grammar = grammar;
	        this.index = index;
	        this.states = [];
	        this.wants = {}; // states indexed by the non-terminal they expect
	        this.scannable = []; // list of states that expect a token
	        this.completed = {}; // states that are nullable
	    }
	
	
	    Column.prototype.process = function(nextColumn) {
	        var states = this.states;
	        var wants = this.wants;
	        var completed = this.completed;
	
	        for (var w = 0; w < states.length; w++) { // nb. we push() during iteration
	            var state = states[w];
	
	            if (state.isComplete) {
	                state.finish();
	                if (state.data !== Parser.fail) {
	                    // complete
	                    var wantedBy = state.wantedBy;
	                    for (var i = wantedBy.length; i--; ) { // this line is hot
	                        var left = wantedBy[i];
	                        this.complete(left, state);
	                    }
	
	                    // special-case nullables
	                    if (state.reference === this.index) {
	                        // make sure future predictors of this rule get completed.
	                        var exp = state.rule.name;
	                        (this.completed[exp] = this.completed[exp] || []).push(state);
	                    }
	                }
	
	            } else {
	                // queue scannable states
	                var exp = state.rule.symbols[state.dot];
	                if (typeof exp !== 'string') {
	                    this.scannable.push(state);
	                    continue;
	                }
	
	                // predict
	                if (wants[exp]) {
	                    wants[exp].push(state);
	
	                    if (completed.hasOwnProperty(exp)) {
	                        var nulls = completed[exp];
	                        for (var i = 0; i < nulls.length; i++) {
	                            var right = nulls[i];
	                            this.complete(state, right);
	                        }
	                    }
	                } else {
	                    wants[exp] = [state];
	                    this.predict(exp);
	                }
	            }
	        }
	    }
	
	    Column.prototype.predict = function(exp) {
	        var rules = this.grammar.byName[exp] || [];
	
	        for (var i = 0; i < rules.length; i++) {
	            var r = rules[i];
	            var wantedBy = this.wants[exp];
	            var s = new State(r, 0, this.index, wantedBy);
	            this.states.push(s);
	        }
	    }
	
	    Column.prototype.complete = function(left, right) {
	        var copy = left.nextState(right);
	        this.states.push(copy);
	    }
	
	
	    function Grammar(rules, start) {
	        this.rules = rules;
	        this.start = start || this.rules[0].name;
	        var byName = this.byName = {};
	        this.rules.forEach(function(rule) {
	            if (!byName.hasOwnProperty(rule.name)) {
	                byName[rule.name] = [];
	            }
	            byName[rule.name].push(rule);
	        });
	    }
	
	    // So we can allow passing (rules, start) directly to Parser for backwards compatibility
	    Grammar.fromCompiled = function(rules, start) {
	        var lexer = rules.Lexer;
	        if (rules.ParserStart) {
	          start = rules.ParserStart;
	          rules = rules.ParserRules;
	        }
	        var rules = rules.map(function (r) { return (new Rule(r.name, r.symbols, r.postprocess)); });
	        var g = new Grammar(rules, start);
	        g.lexer = lexer; // nb. storing lexer on Grammar is iffy, but unavoidable
	        return g;
	    }
	
	
	    function StreamLexer() {
	      this.reset("");
	    }
	
	    StreamLexer.prototype.reset = function(data, state) {
	        this.buffer = data;
	        this.index = 0;
	        this.line = state ? state.line : 1;
	        this.lastLineBreak = state ? -state.col : 0;
	    }
	
	    StreamLexer.prototype.next = function() {
	        if (this.index < this.buffer.length) {
	            var ch = this.buffer[this.index++];
	            if (ch === '\n') {
	              this.line += 1;
	              this.lastLineBreak = this.index;
	            }
	            return {value: ch};
	        }
	    }
	
	    StreamLexer.prototype.save = function() {
	      return {
	        line: this.line,
	        col: this.index - this.lastLineBreak,
	      }
	    }
	
	    StreamLexer.prototype.formatError = function(token, message) {
	        // nb. this gets called after consuming the offending token,
	        // so the culprit is index-1
	        var buffer = this.buffer;
	        if (typeof buffer === 'string') {
	            var nextLineBreak = buffer.indexOf('\n', this.index);
	            if (nextLineBreak === -1) nextLineBreak = buffer.length;
	            var line = buffer.substring(this.lastLineBreak, nextLineBreak)
	            var col = this.index - this.lastLineBreak;
	            message += " at line " + this.line + " col " + col + ":\n\n";
	            message += "  " + line + "\n"
	            message += "  " + Array(col).join(" ") + "^"
	            return message;
	        } else {
	            return message + " at index " + (this.index - 1);
	        }
	    }
	
	
	    function Parser(rules, start, options) {
	        if (rules instanceof Grammar) {
	            var grammar = rules;
	            var options = start;
	        } else {
	            var grammar = Grammar.fromCompiled(rules, start);
	        }
	        this.grammar = grammar;
	
	        // Read options
	        this.options = {
	            keepHistory: false,
	            lexer: grammar.lexer || new StreamLexer,
	        };
	        for (var key in (options || {})) {
	            this.options[key] = options[key];
	        }
	
	        // Setup lexer
	        this.lexer = this.options.lexer;
	        this.lexerState = undefined;
	
	        // Setup a table
	        var column = new Column(grammar, 0);
	        var table = this.table = [column];
	
	        // I could be expecting anything.
	        column.wants[grammar.start] = [];
	        column.predict(grammar.start);
	        // TODO what if start rule is nullable?
	        column.process();
	        this.current = 0; // token index
	    }
	
	    // create a reserved token for indicating a parse fail
	    Parser.fail = {};
	
	    Parser.prototype.feed = function(chunk) {
	        var lexer = this.lexer;
	        lexer.reset(chunk, this.lexerState);
	
	        var token;
	        while (token = lexer.next()) {
	            // We add new states to table[current+1]
	            var column = this.table[this.current];
	
	            // GC unused states
	            if (!this.options.keepHistory) {
	                delete this.table[this.current - 1];
	            }
	
	            var n = this.current + 1;
	            var nextColumn = new Column(this.grammar, n);
	            this.table.push(nextColumn);
	
	            // Advance all tokens that expect the symbol
	            var literal = token.value;
	            var value = lexer.constructor === StreamLexer ? token.value : token;
	            var scannable = column.scannable;
	            for (var w = scannable.length; w--; ) {
	                var state = scannable[w];
	                var expect = state.rule.symbols[state.dot];
	                // Try to consume the token
	                // either regex or literal
	                if (expect.test ? expect.test(value) :
	                    expect.type ? expect.type === token.type
	                                : expect.literal === literal) {
	                    // Add it
	                    var next = state.nextState({data: value, token: token, isToken: true, reference: n - 1});
	                    nextColumn.states.push(next);
	                }
	            }
	
	            // Next, for each of the rules, we either
	            // (a) complete it, and try to see if the reference row expected that
	            //     rule
	            // (b) predict the next nonterminal it expects by adding that
	            //     nonterminal's start state
	            // To prevent duplication, we also keep track of rules we have already
	            // added
	
	            nextColumn.process();
	
	            // If needed, throw an error:
	            if (nextColumn.states.length === 0) {
	                // No states at all! This is not good.
	                var message = this.lexer.formatError(token, "invalid syntax") + "\n";
	                message += "Unexpected " + (token.type ? token.type + " token: " : "");
	                message += JSON.stringify(token.value !== undefined ? token.value : token) + "\n";
	                var err = new Error(message);
	                err.offset = this.current;
	                err.token = token;
	                throw err;
	            }
	
	            // maybe save lexer state
	            if (this.options.keepHistory) {
	              column.lexerState = lexer.save()
	            }
	
	            this.current++;
	        }
	        if (column) {
	          this.lexerState = lexer.save()
	        }
	
	        // Incrementally keep track of results
	        this.results = this.finish();
	
	        // Allow chaining, for whatever it's worth
	        return this;
	    };
	
	    Parser.prototype.save = function() {
	        var column = this.table[this.current];
	        column.lexerState = this.lexerState;
	        return column;
	    };
	
	    Parser.prototype.restore = function(column) {
	        var index = column.index;
	        this.current = index;
	        this.table[index] = column;
	        this.table.splice(index + 1);
	        this.lexerState = column.lexerState;
	
	        // Incrementally keep track of results
	        this.results = this.finish();
	    };
	
	    // nb. deprecated: use save/restore instead!
	    Parser.prototype.rewind = function(index) {
	        if (!this.options.keepHistory) {
	            throw new Error('set option `keepHistory` to enable rewinding')
	        }
	        // nb. recall column (table) indicies fall between token indicies.
	        //        col 0   --   token 0   --   col 1
	        this.restore(this.table[index]);
	    };
	
	    Parser.prototype.finish = function() {
	        // Return the possible parsings
	        var considerations = [];
	        var start = this.grammar.start;
	        var column = this.table[this.table.length - 1]
	        column.states.forEach(function (t) {
	            if (t.rule.name === start
	                    && t.dot === t.rule.symbols.length
	                    && t.reference === 0
	                    && t.data !== Parser.fail) {
	                considerations.push(t);
	            }
	        });
	        return considerations.map(function(c) {return c.data; });
	    };
	
	    return {
	        Parser: Parser,
	        Grammar: Grammar,
	        Rule: Rule,
	    };
	
	}));


/***/ }),
/* 4353 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = compile;
	
	var BaseFuncs = __webpack_require__(197),
	    trueFunc  = BaseFuncs.trueFunc,
	    falseFunc = BaseFuncs.falseFunc;
	
	/*
		returns a function that checks if an elements index matches the given rule
		highly optimized to return the fastest solution
	*/
	function compile(parsed){
		var a = parsed[0],
		    b = parsed[1] - 1;
	
		//when b <= 0, a*n won't be possible for any matches when a < 0
		//besides, the specification says that no element is matched when a and b are 0
		if(b < 0 && a <= 0) return falseFunc;
	
		//when a is in the range -1..1, it matches any element (so only b is checked)
		if(a ===-1) return function(pos){ return pos <= b; };
		if(a === 0) return function(pos){ return pos === b; };
		//when b <= 0 and a === 1, they match any element
		if(a === 1) return b < 0 ? trueFunc : function(pos){ return pos >= b; };
	
		//when a > 0, modulo can be used to check if there is a match
		var bMod = b % a;
		if(bMod < 0) bMod += a;
	
		if(a > 1){
			return function(pos){
				return pos >= b && pos % a === bMod;
			};
		}
	
		a *= -1; //make `a` positive
	
		return function(pos){
			return pos <= b && pos % a === bMod;
		};
	}

/***/ }),
/* 4354 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(4355),
	    compile = __webpack_require__(4353);
	
	module.exports = function nthCheck(formula){
		return compile(parse(formula));
	};
	
	module.exports.parse = parse;
	module.exports.compile = compile;

/***/ }),
/* 4355 */
/***/ (function(module, exports) {

	module.exports = parse;
	
	//following http://www.w3.org/TR/css3-selectors/#nth-child-pseudo
	
	//[ ['-'|'+']? INTEGER? {N} [ S* ['-'|'+'] S* INTEGER ]?
	var re_nthElement = /^([+\-]?\d*n)?\s*(?:([+\-]?)\s*(\d+))?$/;
	
	/*
		parses a nth-check formula, returns an array of two numbers
	*/
	function parse(formula){
		formula = formula.trim().toLowerCase();
	
		if(formula === "even"){
			return [2, 0];
		} else if(formula === "odd"){
			return [2, 1];
		} else {
			var parsed = formula.match(re_nthElement);
	
			if(!parsed){
				throw new SyntaxError("n-th rule couldn't be parsed ('" + formula + "')");
			}
	
			var a;
	
			if(parsed[1]){
				a = parseInt(parsed[1], 10);
				if(isNaN(a)){
					if(parsed[1].charAt(0) === "-") a = -1;
					else a = 1;
				}
			} else a = 0;
	
			return [
				a,
				parsed[3] ? parseInt((parsed[2] || "") + parsed[3], 10) : 0
			];
		}
	}


/***/ }),
/* 4356 */
/***/ (function(module, exports, __webpack_require__) {

	var hasMap = typeof Map === 'function' && Map.prototype;
	var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
	var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
	var mapForEach = hasMap && Map.prototype.forEach;
	var hasSet = typeof Set === 'function' && Set.prototype;
	var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
	var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
	var setForEach = hasSet && Set.prototype.forEach;
	var booleanValueOf = Boolean.prototype.valueOf;
	var objectToString = Object.prototype.toString;
	
	var inspectCustom = __webpack_require__(4788).custom;
	var inspectSymbol = (inspectCustom && isSymbol(inspectCustom)) ? inspectCustom : null;
	
	module.exports = function inspect_ (obj, opts, depth, seen) {
	    if (!opts) opts = {};
	
	    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
	        throw new TypeError('option "quoteStyle" must be "single" or "double"');
	    }
	
	    if (typeof obj === 'undefined') {
	        return 'undefined';
	    }
	    if (obj === null) {
	        return 'null';
	    }
	    if (typeof obj === 'boolean') {
	        return obj ? 'true' : 'false';
	    }
	
	    if (typeof obj === 'string') {
	        return inspectString(obj, opts);
	    }
	    if (typeof obj === 'number') {
	      if (obj === 0) {
	        return Infinity / obj > 0 ? '0' : '-0';
	      }
	      return String(obj);
	    }
	
	    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
	    if (typeof depth === 'undefined') depth = 0;
	    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
	        return '[Object]';
	    }
	
	    if (typeof seen === 'undefined') seen = [];
	    else if (indexOf(seen, obj) >= 0) {
	        return '[Circular]';
	    }
	
	    function inspect (value, from) {
	        if (from) {
	            seen = seen.slice();
	            seen.push(from);
	        }
	        return inspect_(value, opts, depth + 1, seen);
	    }
	
	    if (typeof obj === 'function') {
	        var name = nameOf(obj);
	        return '[Function' + (name ? ': ' + name : '') + ']';
	    }
	    if (isSymbol(obj)) {
	        var symString = Symbol.prototype.toString.call(obj);
	        return typeof obj === 'object' ? markBoxed(symString) : symString;
	    }
	    if (isElement(obj)) {
	        var s = '<' + String(obj.nodeName).toLowerCase();
	        var attrs = obj.attributes || [];
	        for (var i = 0; i < attrs.length; i++) {
	            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
	        }
	        s += '>';
	        if (obj.childNodes && obj.childNodes.length) s += '...';
	        s += '</' + String(obj.nodeName).toLowerCase() + '>';
	        return s;
	    }
	    if (isArray(obj)) {
	        if (obj.length === 0) return '[]';
	        return '[ ' + arrObjKeys(obj, inspect).join(', ') + ' ]';
	    }
	    if (isError(obj)) {
	        var parts = arrObjKeys(obj, inspect);
	        if (parts.length === 0) return '[' + String(obj) + ']';
	        return '{ [' + String(obj) + '] ' + parts.join(', ') + ' }';
	    }
	    if (typeof obj === 'object') {
	        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
	            return obj[inspectSymbol]();
	        } else if (typeof obj.inspect === 'function') {
	            return obj.inspect();
	        }
	    }
	    if (isMap(obj)) {
	        var parts = [];
	        mapForEach.call(obj, function (value, key) {
	            parts.push(inspect(key, obj) + ' => ' + inspect(value, obj));
	        });
	        return collectionOf('Map', mapSize.call(obj), parts);
	    }
	    if (isSet(obj)) {
	        var parts = [];
	        setForEach.call(obj, function (value ) {
	            parts.push(inspect(value, obj));
	        });
	        return collectionOf('Set', setSize.call(obj), parts);
	    }
	    if (isNumber(obj)) {
	        return markBoxed(inspect(Number(obj)));
	    }
	    if (isBoolean(obj)) {
	        return markBoxed(booleanValueOf.call(obj));
	    }
	    if (isString(obj)) {
	        return markBoxed(inspect(String(obj)));
	    }
	    if (!isDate(obj) && !isRegExp(obj)) {
	        var xs = arrObjKeys(obj, inspect);
	        if (xs.length === 0) return '{}';
	        return '{ ' + xs.join(', ') + ' }';
	    }
	    return String(obj);
	};
	
	function wrapQuotes (s, defaultStyle, opts) {
	    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
	    return quoteChar + s + quoteChar;
	}
	
	function quote (s) {
	    return String(s).replace(/"/g, '&quot;');
	}
	
	function isArray (obj) { return toStr(obj) === '[object Array]' }
	function isDate (obj) { return toStr(obj) === '[object Date]' }
	function isRegExp (obj) { return toStr(obj) === '[object RegExp]' }
	function isError (obj) { return toStr(obj) === '[object Error]' }
	function isSymbol (obj) { return toStr(obj) === '[object Symbol]' }
	function isString (obj) { return toStr(obj) === '[object String]' }
	function isNumber (obj) { return toStr(obj) === '[object Number]' }
	function isBoolean (obj) { return toStr(obj) === '[object Boolean]' }
	
	var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
	function has (obj, key) {
	    return hasOwn.call(obj, key);
	}
	
	function toStr (obj) {
	    return objectToString.call(obj);
	}
	
	function nameOf (f) {
	    if (f.name) return f.name;
	    var m = String(f).match(/^function\s*([\w$]+)/);
	    if (m) return m[1];
	}
	
	function indexOf (xs, x) {
	    if (xs.indexOf) return xs.indexOf(x);
	    for (var i = 0, l = xs.length; i < l; i++) {
	        if (xs[i] === x) return i;
	    }
	    return -1;
	}
	
	function isMap (x) {
	    if (!mapSize) {
	        return false;
	    }
	    try {
	        mapSize.call(x);
	        try {
	            setSize.call(x);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof Map; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isSet (x) {
	    if (!setSize) {
	        return false;
	    }
	    try {
	        setSize.call(x);
	        try {
	            mapSize.call(x);
	        } catch (m) {
	            return true;
	        }
	        return x instanceof Set; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isElement (x) {
	    if (!x || typeof x !== 'object') return false;
	    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
	        return true;
	    }
	    return typeof x.nodeName === 'string'
	        && typeof x.getAttribute === 'function'
	    ;
	}
	
	function inspectString (str, opts) {
	    var s = str.replace(/(['\\])/g, '\\$1').replace(/[\x00-\x1f]/g, lowbyte);
	    return wrapQuotes(s, 'single', opts);
	}
	
	function lowbyte (c) {
	    var n = c.charCodeAt(0);
	    var x = { 8: 'b', 9: 't', 10: 'n', 12: 'f', 13: 'r' }[n];
	    if (x) return '\\' + x;
	    return '\\x' + (n < 0x10 ? '0' : '') + n.toString(16);
	}
	
	function markBoxed (str) {
	    return 'Object(' + str + ')';
	}
	
	function collectionOf (type, size, entries) {
	    return type + ' (' + size + ') {' + entries.join(', ') + '}';
	}
	
	function arrObjKeys (obj, inspect) {
	    var isArr = isArray(obj);
	    var xs = [];
	    if (isArr) {
	        xs.length = obj.length;
	        for (var i = 0; i < obj.length; i++) {
	            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
	        }
	    }
	    for (var key in obj) {
	        if (!has(obj, key)) continue;
	        if (isArr && String(Number(key)) === key && key < obj.length) continue;
	        if (/[^\w$]/.test(key)) {
	            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
	        } else {
	            xs.push(key + ': ' + inspect(obj[key], obj));
	        }
	    }
	    return xs;
	}


/***/ }),
/* 4357 */
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),
/* 4358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(96);
	var getPolyfill = __webpack_require__(701);
	
	module.exports = function shimAssign() {
		var polyfill = getPolyfill();
		define(
			Object,
			{ assign: polyfill },
			{ assign: function () { return Object.assign !== polyfill; } }
		);
		return polyfill;
	};


/***/ }),
/* 4359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(704);
	var define = __webpack_require__(96);
	
	module.exports = function shimEntries() {
		var polyfill = getPolyfill();
		define(Object, { entries: polyfill }, {
			entries: function testEntries() {
				return Object.entries !== polyfill;
			}
		});
		return polyfill;
	};


/***/ }),
/* 4360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(96);
	
	var implementation = __webpack_require__(705);
	var getPolyfill = __webpack_require__(706);
	var shim = __webpack_require__(4361);
	
	var polyfill = getPolyfill();
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ }),
/* 4361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(706);
	var define = __webpack_require__(96);
	
	module.exports = function shimValues() {
		var polyfill = getPolyfill();
		define(Object, { values: polyfill }, {
			values: function testValues() {
				return Object.values !== polyfill;
			}
		});
		return polyfill;
	};


/***/ }),
/* 4362 */,
/* 4363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Mixin = __webpack_require__(335),
	    inherits = __webpack_require__(55).inherits;
	
	var LocationInfoOpenElementStackMixin = module.exports = function (stack, options) {
	    Mixin.call(this, stack);
	
	    this.onItemPop = options.onItemPop;
	};
	
	inherits(LocationInfoOpenElementStackMixin, Mixin);
	
	LocationInfoOpenElementStackMixin.prototype._getOverriddenMethods = function (mxn, orig) {
	    return {
	        pop: function () {
	            mxn.onItemPop(this.current);
	            orig.pop.call(this);
	        },
	
	        popAllUpToHtmlElement: function () {
	            for (var i = this.stackTop; i > 0; i--)
	                mxn.onItemPop(this.items[i]);
	
	            orig.popAllUpToHtmlElement.call(this);
	        },
	
	        remove: function (element) {
	            mxn.onItemPop(this.current);
	            orig.remove.call(this, element);
	        }
	    };
	};
	


/***/ }),
/* 4364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Mixin = __webpack_require__(335),
	    Tokenizer = __webpack_require__(186),
	    LocationInfoTokenizerMixin = __webpack_require__(708),
	    PositionTrackingPreprocessorMixin = __webpack_require__(709),
	    LocationInfoOpenElementStackMixin = __webpack_require__(4363),
	    HTML = __webpack_require__(77),
	    inherits = __webpack_require__(55).inherits;
	
	
	//Aliases
	var $ = HTML.TAG_NAMES;
	
	var LocationInfoParserMixin = module.exports = function (parser) {
	    Mixin.call(this, parser);
	
	    this.parser = parser;
	    this.posTracker = null;
	    this.lastStartTagToken = null;
	    this.lastFosterParentingLocation = null;
	    this.currentToken = null;
	};
	
	inherits(LocationInfoParserMixin, Mixin);
	
	
	LocationInfoParserMixin.prototype._setStartLocation = function (element) {
	    if (this.lastStartTagToken) {
	        element.__location = Object.create(this.lastStartTagToken.location);
	        element.__location.startTag = this.lastStartTagToken.location;
	    }
	    else
	        element.__location = null;
	};
	
	LocationInfoParserMixin.prototype._setEndLocation = function (element, closingToken) {
	    var loc = element.__location;
	
	    if (loc) {
	        if (closingToken.location) {
	            var ctLoc = closingToken.location,
	                tn = this.parser.treeAdapter.getTagName(element);
	
	            // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
	            // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
	            var isClosingEndTag = closingToken.type === Tokenizer.END_TAG_TOKEN && tn === closingToken.tagName;
	
	            if (isClosingEndTag) {
	                loc.endTag = Object.create(ctLoc);
	                loc.endOffset = ctLoc.endOffset;
	            }
	
	            else
	                loc.endOffset = ctLoc.startOffset;
	        }
	
	        else if (closingToken.type === Tokenizer.EOF_TOKEN)
	            loc.endOffset = this.posTracker.offset;
	    }
	};
	
	LocationInfoParserMixin.prototype._getOverriddenMethods = function (mxn, orig) {
	    return {
	        _bootstrap: function (document, fragmentContext) {
	            orig._bootstrap.call(this, document, fragmentContext);
	
	            mxn.lastStartTagToken = null;
	            mxn.lastFosterParentingLocation = null;
	            mxn.currentToken = null;
	            mxn.posTracker = new PositionTrackingPreprocessorMixin(this.tokenizer.preprocessor);
	
	            new LocationInfoTokenizerMixin(this.tokenizer);
	
	            new LocationInfoOpenElementStackMixin(this.openElements, {
	                onItemPop: function (element) {
	                    mxn._setEndLocation(element, mxn.currentToken);
	                }
	            });
	        },
	
	        _runParsingLoop: function (scriptHandler) {
	            orig._runParsingLoop.call(this, scriptHandler);
	
	            // NOTE: generate location info for elements
	            // that remains on open element stack
	            for (var i = this.openElements.stackTop; i >= 0; i--)
	                mxn._setEndLocation(this.openElements.items[i], mxn.currentToken);
	        },
	
	
	        //Token processing
	        _processTokenInForeignContent: function (token) {
	            mxn.currentToken = token;
	            orig._processTokenInForeignContent.call(this, token);
	        },
	
	        _processToken: function (token) {
	            mxn.currentToken = token;
	            orig._processToken.call(this, token);
	
	            //NOTE: <body> and <html> are never popped from the stack, so we need to updated
	            //their end location explicitly.
	            var requireExplicitUpdate = token.type === Tokenizer.END_TAG_TOKEN &&
	                                        (token.tagName === $.HTML ||
	                                         token.tagName === $.BODY && this.openElements.hasInScope($.BODY));
	
	            if (requireExplicitUpdate) {
	                for (var i = this.openElements.stackTop; i >= 0; i--) {
	                    var element = this.openElements.items[i];
	
	                    if (this.treeAdapter.getTagName(element) === token.tagName) {
	                        mxn._setEndLocation(element, token);
	                        break;
	                    }
	                }
	            }
	        },
	
	
	        //Doctype
	        _setDocumentType: function (token) {
	            orig._setDocumentType.call(this, token);
	
	            var documentChildren = this.treeAdapter.getChildNodes(this.document),
	                cnLength = documentChildren.length;
	
	            for (var i = 0; i < cnLength; i++) {
	                var node = documentChildren[i];
	
	                if (this.treeAdapter.isDocumentTypeNode(node)) {
	                    node.__location = token.location;
	                    break;
	                }
	            }
	        },
	
	
	        //Elements
	        _attachElementToTree: function (element) {
	            //NOTE: _attachElementToTree is called from _appendElement, _insertElement and _insertTemplate methods.
	            //So we will use token location stored in this methods for the element.
	            mxn._setStartLocation(element);
	            mxn.lastStartTagToken = null;
	            orig._attachElementToTree.call(this, element);
	        },
	
	        _appendElement: function (token, namespaceURI) {
	            mxn.lastStartTagToken = token;
	            orig._appendElement.call(this, token, namespaceURI);
	        },
	
	        _insertElement: function (token, namespaceURI) {
	            mxn.lastStartTagToken = token;
	            orig._insertElement.call(this, token, namespaceURI);
	        },
	
	        _insertTemplate: function (token) {
	            mxn.lastStartTagToken = token;
	            orig._insertTemplate.call(this, token);
	
	            var tmplContent = this.treeAdapter.getTemplateContent(this.openElements.current);
	
	            tmplContent.__location = null;
	        },
	
	        _insertFakeRootElement: function () {
	            orig._insertFakeRootElement.call(this);
	            this.openElements.current.__location = null;
	        },
	
	        //Comments
	        _appendCommentNode: function (token, parent) {
	            orig._appendCommentNode.call(this, token, parent);
	
	            var children = this.treeAdapter.getChildNodes(parent),
	                commentNode = children[children.length - 1];
	
	            commentNode.__location = token.location;
	        },
	
	        //Text
	        _findFosterParentingLocation: function () {
	            //NOTE: store last foster parenting location, so we will be able to find inserted text
	            //in case of foster parenting
	            mxn.lastFosterParentingLocation = orig._findFosterParentingLocation.call(this);
	
	            return mxn.lastFosterParentingLocation;
	        },
	
	        _insertCharacters: function (token) {
	            orig._insertCharacters.call(this, token);
	
	            var hasFosterParent = this._shouldFosterParentOnInsertion(),
	                parent = hasFosterParent && mxn.lastFosterParentingLocation.parent ||
	                         this.openElements.currentTmplContent ||
	                         this.openElements.current,
	                siblings = this.treeAdapter.getChildNodes(parent),
	                textNodeIdx = hasFosterParent && mxn.lastFosterParentingLocation.beforeElement ?
	                siblings.indexOf(mxn.lastFosterParentingLocation.beforeElement) - 1 :
	                siblings.length - 1,
	                textNode = siblings[textNodeIdx];
	
	            //NOTE: if we have location assigned by another token, then just update end position
	            if (textNode.__location)
	                textNode.__location.endOffset = token.location.endOffset;
	
	            else
	                textNode.__location = token.location;
	        }
	    };
	};
	


/***/ }),
/* 4365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Parser = __webpack_require__(710),
	    Serializer = __webpack_require__(712);
	
	
	// Shorthands
	exports.parse = function parse(html, options) {
	    var parser = new Parser(options);
	
	    return parser.parse(html);
	};
	
	exports.parseFragment = function parseFragment(fragmentContext, html, options) {
	    if (typeof fragmentContext === 'string') {
	        options = html;
	        html = fragmentContext;
	        fragmentContext = null;
	    }
	
	    var parser = new Parser(options);
	
	    return parser.parseFragment(html, fragmentContext);
	};
	
	exports.serialize = function (node, options) {
	    var serializer = new Serializer(node, options);
	
	    return serializer.serialize();
	};
	
	
	// Tree adapters
	exports.treeAdapters = {
	    default: __webpack_require__(482),
	    htmlparser2: __webpack_require__(4375)
	};
	
	
	// Streaming
	exports.ParserStream = __webpack_require__(711);
	exports.PlainTextConversionStream = __webpack_require__(4368);
	exports.SerializerStream = __webpack_require__(4372);
	exports.SAXParser = __webpack_require__(4370);


/***/ }),
/* 4366 */
/***/ (function(module, exports) {

	'use strict';
	
	//Const
	var NOAH_ARK_CAPACITY = 3;
	
	//List of formatting elements
	var FormattingElementList = module.exports = function (treeAdapter) {
	    this.length = 0;
	    this.entries = [];
	    this.treeAdapter = treeAdapter;
	    this.bookmark = null;
	};
	
	//Entry types
	FormattingElementList.MARKER_ENTRY = 'MARKER_ENTRY';
	FormattingElementList.ELEMENT_ENTRY = 'ELEMENT_ENTRY';
	
	//Noah Ark's condition
	//OPTIMIZATION: at first we try to find possible candidates for exclusion using
	//lightweight heuristics without thorough attributes check.
	FormattingElementList.prototype._getNoahArkConditionCandidates = function (newElement) {
	    var candidates = [];
	
	    if (this.length >= NOAH_ARK_CAPACITY) {
	        var neAttrsLength = this.treeAdapter.getAttrList(newElement).length,
	            neTagName = this.treeAdapter.getTagName(newElement),
	            neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);
	
	        for (var i = this.length - 1; i >= 0; i--) {
	            var entry = this.entries[i];
	
	            if (entry.type === FormattingElementList.MARKER_ENTRY)
	                break;
	
	            var element = entry.element,
	                elementAttrs = this.treeAdapter.getAttrList(element),
	                isCandidate = this.treeAdapter.getTagName(element) === neTagName &&
	                              this.treeAdapter.getNamespaceURI(element) === neNamespaceURI &&
	                              elementAttrs.length === neAttrsLength;
	
	            if (isCandidate)
	                candidates.push({idx: i, attrs: elementAttrs});
	        }
	    }
	
	    return candidates.length < NOAH_ARK_CAPACITY ? [] : candidates;
	};
	
	FormattingElementList.prototype._ensureNoahArkCondition = function (newElement) {
	    var candidates = this._getNoahArkConditionCandidates(newElement),
	        cLength = candidates.length;
	
	    if (cLength) {
	        var neAttrs = this.treeAdapter.getAttrList(newElement),
	            neAttrsLength = neAttrs.length,
	            neAttrsMap = Object.create(null);
	
	        //NOTE: build attrs map for the new element so we can perform fast lookups
	        for (var i = 0; i < neAttrsLength; i++) {
	            var neAttr = neAttrs[i];
	
	            neAttrsMap[neAttr.name] = neAttr.value;
	        }
	
	        for (i = 0; i < neAttrsLength; i++) {
	            for (var j = 0; j < cLength; j++) {
	                var cAttr = candidates[j].attrs[i];
	
	                if (neAttrsMap[cAttr.name] !== cAttr.value) {
	                    candidates.splice(j, 1);
	                    cLength--;
	                }
	
	                if (candidates.length < NOAH_ARK_CAPACITY)
	                    return;
	            }
	        }
	
	        //NOTE: remove bottommost candidates until Noah's Ark condition will not be met
	        for (i = cLength - 1; i >= NOAH_ARK_CAPACITY - 1; i--) {
	            this.entries.splice(candidates[i].idx, 1);
	            this.length--;
	        }
	    }
	};
	
	//Mutations
	FormattingElementList.prototype.insertMarker = function () {
	    this.entries.push({type: FormattingElementList.MARKER_ENTRY});
	    this.length++;
	};
	
	FormattingElementList.prototype.pushElement = function (element, token) {
	    this._ensureNoahArkCondition(element);
	
	    this.entries.push({
	        type: FormattingElementList.ELEMENT_ENTRY,
	        element: element,
	        token: token
	    });
	
	    this.length++;
	};
	
	FormattingElementList.prototype.insertElementAfterBookmark = function (element, token) {
	    var bookmarkIdx = this.length - 1;
	
	    for (; bookmarkIdx >= 0; bookmarkIdx--) {
	        if (this.entries[bookmarkIdx] === this.bookmark)
	            break;
	    }
	
	    this.entries.splice(bookmarkIdx + 1, 0, {
	        type: FormattingElementList.ELEMENT_ENTRY,
	        element: element,
	        token: token
	    });
	
	    this.length++;
	};
	
	FormattingElementList.prototype.removeEntry = function (entry) {
	    for (var i = this.length - 1; i >= 0; i--) {
	        if (this.entries[i] === entry) {
	            this.entries.splice(i, 1);
	            this.length--;
	            break;
	        }
	    }
	};
	
	FormattingElementList.prototype.clearToLastMarker = function () {
	    while (this.length) {
	        var entry = this.entries.pop();
	
	        this.length--;
	
	        if (entry.type === FormattingElementList.MARKER_ENTRY)
	            break;
	    }
	};
	
	//Search
	FormattingElementList.prototype.getElementEntryInScopeWithTagName = function (tagName) {
	    for (var i = this.length - 1; i >= 0; i--) {
	        var entry = this.entries[i];
	
	        if (entry.type === FormattingElementList.MARKER_ENTRY)
	            return null;
	
	        if (this.treeAdapter.getTagName(entry.element) === tagName)
	            return entry;
	    }
	
	    return null;
	};
	
	FormattingElementList.prototype.getElementEntry = function (element) {
	    for (var i = this.length - 1; i >= 0; i--) {
	        var entry = this.entries[i];
	
	        if (entry.type === FormattingElementList.ELEMENT_ENTRY && entry.element === element)
	            return entry;
	    }
	
	    return null;
	};


/***/ }),
/* 4367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var HTML = __webpack_require__(77);
	
	//Aliases
	var $ = HTML.TAG_NAMES,
	    NS = HTML.NAMESPACES;
	
	//Element utils
	
	//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
	//It's faster than using dictionary.
	function isImpliedEndTagRequired(tn) {
	    switch (tn.length) {
	        case 1:
	            return tn === $.P;
	
	        case 2:
	            return tn === $.RB || tn === $.RP || tn === $.RT || tn === $.DD || tn === $.DT || tn === $.LI;
	
	        case 3:
	            return tn === $.RTC;
	
	        case 6:
	            return tn === $.OPTION;
	
	        case 8:
	            return tn === $.OPTGROUP || tn === $.MENUITEM;
	    }
	
	    return false;
	}
	
	function isScopingElement(tn, ns) {
	    switch (tn.length) {
	        case 2:
	            if (tn === $.TD || tn === $.TH)
	                return ns === NS.HTML;
	
	            else if (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS)
	                return ns === NS.MATHML;
	
	            break;
	
	        case 4:
	            if (tn === $.HTML)
	                return ns === NS.HTML;
	
	            else if (tn === $.DESC)
	                return ns === NS.SVG;
	
	            break;
	
	        case 5:
	            if (tn === $.TABLE)
	                return ns === NS.HTML;
	
	            else if (tn === $.MTEXT)
	                return ns === NS.MATHML;
	
	            else if (tn === $.TITLE)
	                return ns === NS.SVG;
	
	            break;
	
	        case 6:
	            return (tn === $.APPLET || tn === $.OBJECT) && ns === NS.HTML;
	
	        case 7:
	            return (tn === $.CAPTION || tn === $.MARQUEE) && ns === NS.HTML;
	
	        case 8:
	            return tn === $.TEMPLATE && ns === NS.HTML;
	
	        case 13:
	            return tn === $.FOREIGN_OBJECT && ns === NS.SVG;
	
	        case 14:
	            return tn === $.ANNOTATION_XML && ns === NS.MATHML;
	    }
	
	    return false;
	}
	
	//Stack of open elements
	var OpenElementStack = module.exports = function (document, treeAdapter) {
	    this.stackTop = -1;
	    this.items = [];
	    this.current = document;
	    this.currentTagName = null;
	    this.currentTmplContent = null;
	    this.tmplCount = 0;
	    this.treeAdapter = treeAdapter;
	};
	
	//Index of element
	OpenElementStack.prototype._indexOf = function (element) {
	    var idx = -1;
	
	    for (var i = this.stackTop; i >= 0; i--) {
	        if (this.items[i] === element) {
	            idx = i;
	            break;
	        }
	    }
	    return idx;
	};
	
	//Update current element
	OpenElementStack.prototype._isInTemplate = function () {
	    return this.currentTagName === $.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === NS.HTML;
	};
	
	OpenElementStack.prototype._updateCurrentElement = function () {
	    this.current = this.items[this.stackTop];
	    this.currentTagName = this.current && this.treeAdapter.getTagName(this.current);
	
	    this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
	};
	
	//Mutations
	OpenElementStack.prototype.push = function (element) {
	    this.items[++this.stackTop] = element;
	    this._updateCurrentElement();
	
	    if (this._isInTemplate())
	        this.tmplCount++;
	
	};
	
	OpenElementStack.prototype.pop = function () {
	    this.stackTop--;
	
	    if (this.tmplCount > 0 && this._isInTemplate())
	        this.tmplCount--;
	
	    this._updateCurrentElement();
	};
	
	OpenElementStack.prototype.replace = function (oldElement, newElement) {
	    var idx = this._indexOf(oldElement);
	
	    this.items[idx] = newElement;
	
	    if (idx === this.stackTop)
	        this._updateCurrentElement();
	};
	
	OpenElementStack.prototype.insertAfter = function (referenceElement, newElement) {
	    var insertionIdx = this._indexOf(referenceElement) + 1;
	
	    this.items.splice(insertionIdx, 0, newElement);
	
	    if (insertionIdx === ++this.stackTop)
	        this._updateCurrentElement();
	};
	
	OpenElementStack.prototype.popUntilTagNamePopped = function (tagName) {
	    while (this.stackTop > -1) {
	        var tn = this.currentTagName,
	            ns = this.treeAdapter.getNamespaceURI(this.current);
	
	        this.pop();
	
	        if (tn === tagName && ns === NS.HTML)
	            break;
	    }
	};
	
	OpenElementStack.prototype.popUntilElementPopped = function (element) {
	    while (this.stackTop > -1) {
	        var poppedElement = this.current;
	
	        this.pop();
	
	        if (poppedElement === element)
	            break;
	    }
	};
	
	OpenElementStack.prototype.popUntilNumberedHeaderPopped = function () {
	    while (this.stackTop > -1) {
	        var tn = this.currentTagName,
	            ns = this.treeAdapter.getNamespaceURI(this.current);
	
	        this.pop();
	
	        if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6 && ns === NS.HTML)
	            break;
	    }
	};
	
	OpenElementStack.prototype.popUntilTableCellPopped = function () {
	    while (this.stackTop > -1) {
	        var tn = this.currentTagName,
	            ns = this.treeAdapter.getNamespaceURI(this.current);
	
	        this.pop();
	
	        if (tn === $.TD || tn === $.TH && ns === NS.HTML)
	            break;
	    }
	};
	
	OpenElementStack.prototype.popAllUpToHtmlElement = function () {
	    //NOTE: here we assume that root <html> element is always first in the open element stack, so
	    //we perform this fast stack clean up.
	    this.stackTop = 0;
	    this._updateCurrentElement();
	};
	
	OpenElementStack.prototype.clearBackToTableContext = function () {
	    while (this.currentTagName !== $.TABLE &&
	           this.currentTagName !== $.TEMPLATE &&
	           this.currentTagName !== $.HTML ||
	           this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML)
	        this.pop();
	};
	
	OpenElementStack.prototype.clearBackToTableBodyContext = function () {
	    while (this.currentTagName !== $.TBODY &&
	           this.currentTagName !== $.TFOOT &&
	           this.currentTagName !== $.THEAD &&
	           this.currentTagName !== $.TEMPLATE &&
	           this.currentTagName !== $.HTML ||
	           this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML)
	        this.pop();
	};
	
	OpenElementStack.prototype.clearBackToTableRowContext = function () {
	    while (this.currentTagName !== $.TR &&
	           this.currentTagName !== $.TEMPLATE &&
	           this.currentTagName !== $.HTML ||
	           this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML)
	        this.pop();
	};
	
	OpenElementStack.prototype.remove = function (element) {
	    for (var i = this.stackTop; i >= 0; i--) {
	        if (this.items[i] === element) {
	            this.items.splice(i, 1);
	            this.stackTop--;
	            this._updateCurrentElement();
	            break;
	        }
	    }
	};
	
	//Search
	OpenElementStack.prototype.tryPeekProperlyNestedBodyElement = function () {
	    //Properly nested <body> element (should be second element in stack).
	    var element = this.items[1];
	
	    return element && this.treeAdapter.getTagName(element) === $.BODY ? element : null;
	};
	
	OpenElementStack.prototype.contains = function (element) {
	    return this._indexOf(element) > -1;
	};
	
	OpenElementStack.prototype.getCommonAncestor = function (element) {
	    var elementIdx = this._indexOf(element);
	
	    return --elementIdx >= 0 ? this.items[elementIdx] : null;
	};
	
	OpenElementStack.prototype.isRootHtmlElementCurrent = function () {
	    return this.stackTop === 0 && this.currentTagName === $.HTML;
	};
	
	//Element in scope
	OpenElementStack.prototype.hasInScope = function (tagName) {
	    for (var i = this.stackTop; i >= 0; i--) {
	        var tn = this.treeAdapter.getTagName(this.items[i]),
	            ns = this.treeAdapter.getNamespaceURI(this.items[i]);
	
	        if (tn === tagName && ns === NS.HTML)
	            return true;
	
	        if (isScopingElement(tn, ns))
	            return false;
	    }
	
	    return true;
	};
	
	OpenElementStack.prototype.hasNumberedHeaderInScope = function () {
	    for (var i = this.stackTop; i >= 0; i--) {
	        var tn = this.treeAdapter.getTagName(this.items[i]),
	            ns = this.treeAdapter.getNamespaceURI(this.items[i]);
	
	        if ((tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) && ns === NS.HTML)
	            return true;
	
	        if (isScopingElement(tn, ns))
	            return false;
	    }
	
	    return true;
	};
	
	OpenElementStack.prototype.hasInListItemScope = function (tagName) {
	    for (var i = this.stackTop; i >= 0; i--) {
	        var tn = this.treeAdapter.getTagName(this.items[i]),
	            ns = this.treeAdapter.getNamespaceURI(this.items[i]);
	
	        if (tn === tagName && ns === NS.HTML)
	            return true;
	
	        if ((tn === $.UL || tn === $.OL) && ns === NS.HTML || isScopingElement(tn, ns))
	            return false;
	    }
	
	    return true;
	};
	
	OpenElementStack.prototype.hasInButtonScope = function (tagName) {
	    for (var i = this.stackTop; i >= 0; i--) {
	        var tn = this.treeAdapter.getTagName(this.items[i]),
	            ns = this.treeAdapter.getNamespaceURI(this.items[i]);
	
	        if (tn === tagName && ns === NS.HTML)
	            return true;
	
	        if (tn === $.BUTTON && ns === NS.HTML || isScopingElement(tn, ns))
	            return false;
	    }
	
	    return true;
	};
	
	OpenElementStack.prototype.hasInTableScope = function (tagName) {
	    for (var i = this.stackTop; i >= 0; i--) {
	        var tn = this.treeAdapter.getTagName(this.items[i]),
	            ns = this.treeAdapter.getNamespaceURI(this.items[i]);
	
	        if (ns !== NS.HTML)
	            continue;
	
	        if (tn === tagName)
	            return true;
	
	        if (tn === $.TABLE || tn === $.TEMPLATE || tn === $.HTML)
	            return false;
	    }
	
	    return true;
	};
	
	OpenElementStack.prototype.hasTableBodyContextInTableScope = function () {
	    for (var i = this.stackTop; i >= 0; i--) {
	        var tn = this.treeAdapter.getTagName(this.items[i]),
	            ns = this.treeAdapter.getNamespaceURI(this.items[i]);
	
	        if (ns !== NS.HTML)
	            continue;
	
	        if (tn === $.TBODY || tn === $.THEAD || tn === $.TFOOT)
	            return true;
	
	        if (tn === $.TABLE || tn === $.HTML)
	            return false;
	    }
	
	    return true;
	};
	
	OpenElementStack.prototype.hasInSelectScope = function (tagName) {
	    for (var i = this.stackTop; i >= 0; i--) {
	        var tn = this.treeAdapter.getTagName(this.items[i]),
	            ns = this.treeAdapter.getNamespaceURI(this.items[i]);
	
	        if (ns !== NS.HTML)
	            continue;
	
	        if (tn === tagName)
	            return true;
	
	        if (tn !== $.OPTION && tn !== $.OPTGROUP)
	            return false;
	    }
	
	    return true;
	};
	
	//Implied end tags
	OpenElementStack.prototype.generateImpliedEndTags = function () {
	    while (isImpliedEndTagRequired(this.currentTagName))
	        this.pop();
	};
	
	OpenElementStack.prototype.generateImpliedEndTagsWithExclusion = function (exclusionTagName) {
	    while (isImpliedEndTagRequired(this.currentTagName) && this.currentTagName !== exclusionTagName)
	        this.pop();
	};


/***/ }),
/* 4368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ParserStream = __webpack_require__(711),
	    inherits = __webpack_require__(55).inherits,
	    $ = __webpack_require__(77).TAG_NAMES;
	
	var PlainTextConversionStream = module.exports = function (options) {
	    ParserStream.call(this, options);
	
	    // NOTE: see https://html.spec.whatwg.org/#read-text
	    this.parser._insertFakeElement($.HTML);
	    this.parser._insertFakeElement($.HEAD);
	    this.parser.openElements.pop();
	    this.parser._insertFakeElement($.BODY);
	    this.parser._insertFakeElement($.PRE);
	    this.parser.treeAdapter.insertText(this.parser.openElements.current, '\n');
	    this.parser.switchToPlaintextParsing();
	};
	
	inherits(PlainTextConversionStream, ParserStream);


/***/ }),
/* 4369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var WritableStream = __webpack_require__(273).Writable,
	    util = __webpack_require__(55);
	
	var DevNullStream = module.exports = function () {
	    WritableStream.call(this);
	};
	
	util.inherits(DevNullStream, WritableStream);
	
	DevNullStream.prototype._write = function (chunk, encoding, cb) {
	    cb();
	};


/***/ }),
/* 4370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var TransformStream = __webpack_require__(273).Transform,
	    DevNullStream = __webpack_require__(4369),
	    inherits = __webpack_require__(55).inherits,
	    Tokenizer = __webpack_require__(186),
	    LocationInfoTokenizerMixin = __webpack_require__(708),
	    ParserFeedbackSimulator = __webpack_require__(4371),
	    mergeOptions = __webpack_require__(483);
	
	var DEFAULT_OPTIONS = {
	    locationInfo: false
	};
	
	var SAXParser = module.exports = function (options) {
	    TransformStream.call(this);
	
	    this.options = mergeOptions(DEFAULT_OPTIONS, options);
	
	    this.tokenizer = new Tokenizer(options);
	
	    if (this.options.locationInfo)
	        new LocationInfoTokenizerMixin(this.tokenizer);
	
	    this.parserFeedbackSimulator = new ParserFeedbackSimulator(this.tokenizer);
	
	    this.pendingText = null;
	    this.currentTokenLocation = void 0;
	
	    this.lastChunkWritten = false;
	    this.stopped = false;
	
	    // NOTE: always pipe stream to the /dev/null stream to avoid
	    // `highWaterMark` hit even if we don't have consumers.
	    // (see: https://github.com/inikulin/parse5/issues/97#issuecomment-171940774)
	    this.pipe(new DevNullStream());
	};
	
	inherits(SAXParser, TransformStream);
	
	//TransformStream implementation
	SAXParser.prototype._transform = function (chunk, encoding, callback) {
	    if (!this.stopped) {
	        this.tokenizer.write(chunk.toString('utf8'), this.lastChunkWritten);
	        this._runParsingLoop();
	    }
	
	    this.push(chunk);
	
	    callback();
	};
	
	SAXParser.prototype._flush = function (callback) {
	    callback();
	};
	
	SAXParser.prototype.end = function (chunk, encoding, callback) {
	    this.lastChunkWritten = true;
	    TransformStream.prototype.end.call(this, chunk, encoding, callback);
	};
	
	SAXParser.prototype.stop = function () {
	    this.stopped = true;
	};
	
	//Internals
	SAXParser.prototype._runParsingLoop = function () {
	    do {
	        var token = this.parserFeedbackSimulator.getNextToken();
	
	        if (token.type === Tokenizer.HIBERNATION_TOKEN)
	            break;
	
	        if (token.type === Tokenizer.CHARACTER_TOKEN ||
	            token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN ||
	            token.type === Tokenizer.NULL_CHARACTER_TOKEN) {
	
	            if (this.options.locationInfo) {
	                if (this.pendingText === null)
	                    this.currentTokenLocation = token.location;
	
	                else
	                    this.currentTokenLocation.endOffset = token.location.endOffset;
	            }
	
	            this.pendingText = (this.pendingText || '') + token.chars;
	        }
	
	        else {
	            this._emitPendingText();
	            this._handleToken(token);
	        }
	    } while (!this.stopped && token.type !== Tokenizer.EOF_TOKEN);
	};
	
	SAXParser.prototype._handleToken = function (token) {
	    if (this.options.locationInfo)
	        this.currentTokenLocation = token.location;
	
	    if (token.type === Tokenizer.START_TAG_TOKEN)
	        this.emit('startTag', token.tagName, token.attrs, token.selfClosing, this.currentTokenLocation);
	
	    else if (token.type === Tokenizer.END_TAG_TOKEN)
	        this.emit('endTag', token.tagName, this.currentTokenLocation);
	
	    else if (token.type === Tokenizer.COMMENT_TOKEN)
	        this.emit('comment', token.data, this.currentTokenLocation);
	
	    else if (token.type === Tokenizer.DOCTYPE_TOKEN)
	        this.emit('doctype', token.name, token.publicId, token.systemId, this.currentTokenLocation);
	};
	
	SAXParser.prototype._emitPendingText = function () {
	    if (this.pendingText !== null) {
	        this.emit('text', this.pendingText, this.currentTokenLocation);
	        this.pendingText = null;
	    }
	};


/***/ }),
/* 4371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Tokenizer = __webpack_require__(186),
	    foreignContent = __webpack_require__(707),
	    UNICODE = __webpack_require__(234),
	    HTML = __webpack_require__(77);
	
	
	//Aliases
	var $ = HTML.TAG_NAMES,
	    NS = HTML.NAMESPACES;
	
	
	//ParserFeedbackSimulator
	//Simulates adjustment of the Tokenizer which performed by standard parser during tree construction.
	var ParserFeedbackSimulator = module.exports = function (tokenizer) {
	    this.tokenizer = tokenizer;
	
	    this.namespaceStack = [];
	    this.namespaceStackTop = -1;
	    this._enterNamespace(NS.HTML);
	};
	
	ParserFeedbackSimulator.prototype.getNextToken = function () {
	    var token = this.tokenizer.getNextToken();
	
	    if (token.type === Tokenizer.START_TAG_TOKEN)
	        this._handleStartTagToken(token);
	
	    else if (token.type === Tokenizer.END_TAG_TOKEN)
	        this._handleEndTagToken(token);
	
	    else if (token.type === Tokenizer.NULL_CHARACTER_TOKEN && this.inForeignContent) {
	        token.type = Tokenizer.CHARACTER_TOKEN;
	        token.chars = UNICODE.REPLACEMENT_CHARACTER;
	    }
	
	    else if (this.skipNextNewLine) {
	        if (token.type !== Tokenizer.HIBERNATION_TOKEN)
	            this.skipNextNewLine = false;
	
	        if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN && token.chars[0] === '\n') {
	            if (token.chars.length === 1)
	                return this.getNextToken();
	
	            token.chars = token.chars.substr(1);
	        }
	    }
	
	    return token;
	};
	
	//Namespace stack mutations
	ParserFeedbackSimulator.prototype._enterNamespace = function (namespace) {
	    this.namespaceStackTop++;
	    this.namespaceStack.push(namespace);
	
	    this.inForeignContent = namespace !== NS.HTML;
	    this.currentNamespace = namespace;
	    this.tokenizer.allowCDATA = this.inForeignContent;
	};
	
	ParserFeedbackSimulator.prototype._leaveCurrentNamespace = function () {
	    this.namespaceStackTop--;
	    this.namespaceStack.pop();
	
	    this.currentNamespace = this.namespaceStack[this.namespaceStackTop];
	    this.inForeignContent = this.currentNamespace !== NS.HTML;
	    this.tokenizer.allowCDATA = this.inForeignContent;
	};
	
	//Token handlers
	ParserFeedbackSimulator.prototype._ensureTokenizerMode = function (tn) {
	    if (tn === $.TEXTAREA || tn === $.TITLE)
	        this.tokenizer.state = Tokenizer.MODE.RCDATA;
	
	    else if (tn === $.PLAINTEXT)
	        this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
	
	    else if (tn === $.SCRIPT)
	        this.tokenizer.state = Tokenizer.MODE.SCRIPT_DATA;
	
	    else if (tn === $.STYLE || tn === $.IFRAME || tn === $.XMP ||
	             tn === $.NOEMBED || tn === $.NOFRAMES || tn === $.NOSCRIPT)
	        this.tokenizer.state = Tokenizer.MODE.RAWTEXT;
	};
	
	ParserFeedbackSimulator.prototype._handleStartTagToken = function (token) {
	    var tn = token.tagName;
	
	    if (tn === $.SVG)
	        this._enterNamespace(NS.SVG);
	
	    else if (tn === $.MATH)
	        this._enterNamespace(NS.MATHML);
	
	    if (this.inForeignContent) {
	        if (foreignContent.causesExit(token)) {
	            this._leaveCurrentNamespace();
	            return;
	        }
	
	        var currentNs = this.currentNamespace;
	
	        if (currentNs === NS.MATHML)
	            foreignContent.adjustTokenMathMLAttrs(token);
	
	        else if (currentNs === NS.SVG) {
	            foreignContent.adjustTokenSVGTagName(token);
	            foreignContent.adjustTokenSVGAttrs(token);
	        }
	
	        foreignContent.adjustTokenXMLAttrs(token);
	
	        tn = token.tagName;
	
	        if (!token.selfClosing && foreignContent.isIntegrationPoint(tn, currentNs, token.attrs))
	            this._enterNamespace(NS.HTML);
	    }
	
	    else {
	        if (tn === $.PRE || tn === $.TEXTAREA || tn === $.LISTING)
	            this.skipNextNewLine = true;
	
	        else if (tn === $.IMAGE)
	            token.tagName = $.IMG;
	
	        this._ensureTokenizerMode(tn);
	    }
	};
	
	ParserFeedbackSimulator.prototype._handleEndTagToken = function (token) {
	    var tn = token.tagName;
	
	    if (!this.inForeignContent) {
	        var previousNs = this.namespaceStack[this.namespaceStackTop - 1];
	
	        if (previousNs === NS.SVG && foreignContent.SVG_TAG_NAMES_ADJUSTMENT_MAP[tn])
	            tn = foreignContent.SVG_TAG_NAMES_ADJUSTMENT_MAP[tn];
	
	        //NOTE: check for exit from integration point
	        if (foreignContent.isIntegrationPoint(tn, previousNs, token.attrs))
	            this._leaveCurrentNamespace();
	    }
	
	    else if (tn === $.SVG && this.currentNamespace === NS.SVG ||
	             tn === $.MATH && this.currentNamespace === NS.MATHML)
	        this._leaveCurrentNamespace();
	
	    // NOTE: adjust end tag name as well for consistency
	    if (this.currentNamespace === NS.SVG)
	        foreignContent.adjustTokenSVGTagName(token);
	};


/***/ }),
/* 4372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ReadableStream = __webpack_require__(273).Readable,
	    inherits = __webpack_require__(55).inherits,
	    Serializer = __webpack_require__(712);
	
	var SerializerStream = module.exports = function (node, options) {
	    ReadableStream.call(this);
	
	    this.serializer = new Serializer(node, options);
	
	    Object.defineProperty(this.serializer, 'html', {
	        //NOTE: To make `+=` concat operator work properly we define
	        //getter which always returns empty string
	        get: function () {
	            return '';
	        },
	        set: this.push.bind(this)
	    });
	};
	
	inherits(SerializerStream, ReadableStream);
	
	//Readable stream implementation
	SerializerStream.prototype._read = function () {
	    this.serializer.serialize();
	    this.push(null);
	};


/***/ }),
/* 4373 */
/***/ (function(module, exports) {

	'use strict';
	
	//NOTE: this file contains auto-generated array mapped radix tree that is used for the named entity references consumption
	//(details: https://github.com/inikulin/parse5/tree/master/scripts/generate_named_entity_data/README.md)
	module.exports = new Uint16Array([4,52,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,106,303,412,810,1432,1701,1796,1987,2114,2360,2420,2484,3170,3251,4140,4393,4575,4610,5106,5512,5728,6117,6274,6315,6345,6427,6516,7002,7910,8733,9323,9870,10170,10631,10893,11318,11386,11467,12773,13092,14474,14922,15448,15542,16419,17666,18166,18611,19004,19095,19298,19397,4,16,69,77,97,98,99,102,103,108,109,110,111,112,114,115,116,117,140,150,158,169,176,194,199,210,216,222,226,242,256,266,283,294,108,105,103,5,198,1,59,148,1,198,80,5,38,1,59,156,1,38,99,117,116,101,5,193,1,59,167,1,193,114,101,118,101,59,1,258,4,2,105,121,182,191,114,99,5,194,1,59,189,1,194,59,1,1040,114,59,3,55349,56580,114,97,118,101,5,192,1,59,208,1,192,112,104,97,59,1,913,97,99,114,59,1,256,100,59,1,10835,4,2,103,112,232,237,111,110,59,1,260,102,59,3,55349,56632,112,108,121,70,117,110,99,116,105,111,110,59,1,8289,105,110,103,5,197,1,59,264,1,197,4,2,99,115,272,277,114,59,3,55349,56476,105,103,110,59,1,8788,105,108,100,101,5,195,1,59,292,1,195,109,108,5,196,1,59,301,1,196,4,8,97,99,101,102,111,114,115,117,321,350,354,383,388,394,400,405,4,2,99,114,327,336,107,115,108,97,115,104,59,1,8726,4,2,118,119,342,345,59,1,10983,101,100,59,1,8966,121,59,1,1041,4,3,99,114,116,362,369,379,97,117,115,101,59,1,8757,110,111,117,108,108,105,115,59,1,8492,97,59,1,914,114,59,3,55349,56581,112,102,59,3,55349,56633,101,118,101,59,1,728,99,114,59,1,8492,109,112,101,113,59,1,8782,4,14,72,79,97,99,100,101,102,104,105,108,111,114,115,117,442,447,456,504,542,547,569,573,577,616,678,784,790,796,99,121,59,1,1063,80,89,5,169,1,59,454,1,169,4,3,99,112,121,464,470,497,117,116,101,59,1,262,4,2,59,105,476,478,1,8914,116,97,108,68,105,102,102,101,114,101,110,116,105,97,108,68,59,1,8517,108,101,121,115,59,1,8493,4,4,97,101,105,111,514,520,530,535,114,111,110,59,1,268,100,105,108,5,199,1,59,528,1,199,114,99,59,1,264,110,105,110,116,59,1,8752,111,116,59,1,266,4,2,100,110,553,560,105,108,108,97,59,1,184,116,101,114,68,111,116,59,1,183,114,59,1,8493,105,59,1,935,114,99,108,101,4,4,68,77,80,84,591,596,603,609,111,116,59,1,8857,105,110,117,115,59,1,8854,108,117,115,59,1,8853,105,109,101,115,59,1,8855,111,4,2,99,115,623,646,107,119,105,115,101,67,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8754,101,67,117,114,108,121,4,2,68,81,658,671,111,117,98,108,101,81,117,111,116,101,59,1,8221,117,111,116,101,59,1,8217,4,4,108,110,112,117,688,701,736,753,111,110,4,2,59,101,696,698,1,8759,59,1,10868,4,3,103,105,116,709,717,722,114,117,101,110,116,59,1,8801,110,116,59,1,8751,111,117,114,73,110,116,101,103,114,97,108,59,1,8750,4,2,102,114,742,745,59,1,8450,111,100,117,99,116,59,1,8720,110,116,101,114,67,108,111,99,107,119,105,115,101,67,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8755,111,115,115,59,1,10799,99,114,59,3,55349,56478,112,4,2,59,67,803,805,1,8915,97,112,59,1,8781,4,11,68,74,83,90,97,99,101,102,105,111,115,834,850,855,860,865,888,903,916,921,1011,1415,4,2,59,111,840,842,1,8517,116,114,97,104,100,59,1,10513,99,121,59,1,1026,99,121,59,1,1029,99,121,59,1,1039,4,3,103,114,115,873,879,883,103,101,114,59,1,8225,114,59,1,8609,104,118,59,1,10980,4,2,97,121,894,900,114,111,110,59,1,270,59,1,1044,108,4,2,59,116,910,912,1,8711,97,59,1,916,114,59,3,55349,56583,4,2,97,102,927,998,4,2,99,109,933,992,114,105,116,105,99,97,108,4,4,65,68,71,84,950,957,978,985,99,117,116,101,59,1,180,111,4,2,116,117,964,967,59,1,729,98,108,101,65,99,117,116,101,59,1,733,114,97,118,101,59,1,96,105,108,100,101,59,1,732,111,110,100,59,1,8900,102,101,114,101,110,116,105,97,108,68,59,1,8518,4,4,112,116,117,119,1021,1026,1048,1249,102,59,3,55349,56635,4,3,59,68,69,1034,1036,1041,1,168,111,116,59,1,8412,113,117,97,108,59,1,8784,98,108,101,4,6,67,68,76,82,85,86,1065,1082,1101,1189,1211,1236,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8751,111,4,2,116,119,1089,1092,59,1,168,110,65,114,114,111,119,59,1,8659,4,2,101,111,1107,1141,102,116,4,3,65,82,84,1117,1124,1136,114,114,111,119,59,1,8656,105,103,104,116,65,114,114,111,119,59,1,8660,101,101,59,1,10980,110,103,4,2,76,82,1149,1177,101,102,116,4,2,65,82,1158,1165,114,114,111,119,59,1,10232,105,103,104,116,65,114,114,111,119,59,1,10234,105,103,104,116,65,114,114,111,119,59,1,10233,105,103,104,116,4,2,65,84,1199,1206,114,114,111,119,59,1,8658,101,101,59,1,8872,112,4,2,65,68,1218,1225,114,114,111,119,59,1,8657,111,119,110,65,114,114,111,119,59,1,8661,101,114,116,105,99,97,108,66,97,114,59,1,8741,110,4,6,65,66,76,82,84,97,1264,1292,1299,1352,1391,1408,114,114,111,119,4,3,59,66,85,1276,1278,1283,1,8595,97,114,59,1,10515,112,65,114,114,111,119,59,1,8693,114,101,118,101,59,1,785,101,102,116,4,3,82,84,86,1310,1323,1334,105,103,104,116,86,101,99,116,111,114,59,1,10576,101,101,86,101,99,116,111,114,59,1,10590,101,99,116,111,114,4,2,59,66,1345,1347,1,8637,97,114,59,1,10582,105,103,104,116,4,2,84,86,1362,1373,101,101,86,101,99,116,111,114,59,1,10591,101,99,116,111,114,4,2,59,66,1384,1386,1,8641,97,114,59,1,10583,101,101,4,2,59,65,1399,1401,1,8868,114,114,111,119,59,1,8615,114,114,111,119,59,1,8659,4,2,99,116,1421,1426,114,59,3,55349,56479,114,111,107,59,1,272,4,16,78,84,97,99,100,102,103,108,109,111,112,113,115,116,117,120,1466,1470,1478,1489,1515,1520,1525,1536,1544,1593,1609,1617,1650,1664,1668,1677,71,59,1,330,72,5,208,1,59,1476,1,208,99,117,116,101,5,201,1,59,1487,1,201,4,3,97,105,121,1497,1503,1512,114,111,110,59,1,282,114,99,5,202,1,59,1510,1,202,59,1,1069,111,116,59,1,278,114,59,3,55349,56584,114,97,118,101,5,200,1,59,1534,1,200,101,109,101,110,116,59,1,8712,4,2,97,112,1550,1555,99,114,59,1,274,116,121,4,2,83,86,1563,1576,109,97,108,108,83,113,117,97,114,101,59,1,9723,101,114,121,83,109,97,108,108,83,113,117,97,114,101,59,1,9643,4,2,103,112,1599,1604,111,110,59,1,280,102,59,3,55349,56636,115,105,108,111,110,59,1,917,117,4,2,97,105,1624,1640,108,4,2,59,84,1631,1633,1,10869,105,108,100,101,59,1,8770,108,105,98,114,105,117,109,59,1,8652,4,2,99,105,1656,1660,114,59,1,8496,109,59,1,10867,97,59,1,919,109,108,5,203,1,59,1675,1,203,4,2,105,112,1683,1689,115,116,115,59,1,8707,111,110,101,110,116,105,97,108,69,59,1,8519,4,5,99,102,105,111,115,1713,1717,1722,1762,1791,121,59,1,1060,114,59,3,55349,56585,108,108,101,100,4,2,83,86,1732,1745,109,97,108,108,83,113,117,97,114,101,59,1,9724,101,114,121,83,109,97,108,108,83,113,117,97,114,101,59,1,9642,4,3,112,114,117,1770,1775,1781,102,59,3,55349,56637,65,108,108,59,1,8704,114,105,101,114,116,114,102,59,1,8497,99,114,59,1,8497,4,12,74,84,97,98,99,100,102,103,111,114,115,116,1822,1827,1834,1848,1855,1877,1882,1887,1890,1896,1978,1984,99,121,59,1,1027,5,62,1,59,1832,1,62,109,109,97,4,2,59,100,1843,1845,1,915,59,1,988,114,101,118,101,59,1,286,4,3,101,105,121,1863,1869,1874,100,105,108,59,1,290,114,99,59,1,284,59,1,1043,111,116,59,1,288,114,59,3,55349,56586,59,1,8921,112,102,59,3,55349,56638,101,97,116,101,114,4,6,69,70,71,76,83,84,1915,1933,1944,1953,1959,1971,113,117,97,108,4,2,59,76,1925,1927,1,8805,101,115,115,59,1,8923,117,108,108,69,113,117,97,108,59,1,8807,114,101,97,116,101,114,59,1,10914,101,115,115,59,1,8823,108,97,110,116,69,113,117,97,108,59,1,10878,105,108,100,101,59,1,8819,99,114,59,3,55349,56482,59,1,8811,4,8,65,97,99,102,105,111,115,117,2005,2012,2026,2032,2036,2049,2073,2089,82,68,99,121,59,1,1066,4,2,99,116,2018,2023,101,107,59,1,711,59,1,94,105,114,99,59,1,292,114,59,1,8460,108,98,101,114,116,83,112,97,99,101,59,1,8459,4,2,112,114,2055,2059,102,59,1,8461,105,122,111,110,116,97,108,76,105,110,101,59,1,9472,4,2,99,116,2079,2083,114,59,1,8459,114,111,107,59,1,294,109,112,4,2,68,69,2097,2107,111,119,110,72,117,109,112,59,1,8782,113,117,97,108,59,1,8783,4,14,69,74,79,97,99,100,102,103,109,110,111,115,116,117,2144,2149,2155,2160,2171,2189,2194,2198,2209,2245,2307,2329,2334,2341,99,121,59,1,1045,108,105,103,59,1,306,99,121,59,1,1025,99,117,116,101,5,205,1,59,2169,1,205,4,2,105,121,2177,2186,114,99,5,206,1,59,2184,1,206,59,1,1048,111,116,59,1,304,114,59,1,8465,114,97,118,101,5,204,1,59,2207,1,204,4,3,59,97,112,2217,2219,2238,1,8465,4,2,99,103,2225,2229,114,59,1,298,105,110,97,114,121,73,59,1,8520,108,105,101,115,59,1,8658,4,2,116,118,2251,2281,4,2,59,101,2257,2259,1,8748,4,2,103,114,2265,2271,114,97,108,59,1,8747,115,101,99,116,105,111,110,59,1,8898,105,115,105,98,108,101,4,2,67,84,2293,2300,111,109,109,97,59,1,8291,105,109,101,115,59,1,8290,4,3,103,112,116,2315,2320,2325,111,110,59,1,302,102,59,3,55349,56640,97,59,1,921,99,114,59,1,8464,105,108,100,101,59,1,296,4,2,107,109,2347,2352,99,121,59,1,1030,108,5,207,1,59,2358,1,207,4,5,99,102,111,115,117,2372,2386,2391,2397,2414,4,2,105,121,2378,2383,114,99,59,1,308,59,1,1049,114,59,3,55349,56589,112,102,59,3,55349,56641,4,2,99,101,2403,2408,114,59,3,55349,56485,114,99,121,59,1,1032,107,99,121,59,1,1028,4,7,72,74,97,99,102,111,115,2436,2441,2446,2452,2467,2472,2478,99,121,59,1,1061,99,121,59,1,1036,112,112,97,59,1,922,4,2,101,121,2458,2464,100,105,108,59,1,310,59,1,1050,114,59,3,55349,56590,112,102,59,3,55349,56642,99,114,59,3,55349,56486,4,11,74,84,97,99,101,102,108,109,111,115,116,2508,2513,2520,2562,2585,2981,2986,3004,3011,3146,3167,99,121,59,1,1033,5,60,1,59,2518,1,60,4,5,99,109,110,112,114,2532,2538,2544,2548,2558,117,116,101,59,1,313,98,100,97,59,1,923,103,59,1,10218,108,97,99,101,116,114,102,59,1,8466,114,59,1,8606,4,3,97,101,121,2570,2576,2582,114,111,110,59,1,317,100,105,108,59,1,315,59,1,1051,4,2,102,115,2591,2907,116,4,10,65,67,68,70,82,84,85,86,97,114,2614,2663,2672,2728,2735,2760,2820,2870,2888,2895,4,2,110,114,2620,2633,103,108,101,66,114,97,99,107,101,116,59,1,10216,114,111,119,4,3,59,66,82,2644,2646,2651,1,8592,97,114,59,1,8676,105,103,104,116,65,114,114,111,119,59,1,8646,101,105,108,105,110,103,59,1,8968,111,4,2,117,119,2679,2692,98,108,101,66,114,97,99,107,101,116,59,1,10214,110,4,2,84,86,2699,2710,101,101,86,101,99,116,111,114,59,1,10593,101,99,116,111,114,4,2,59,66,2721,2723,1,8643,97,114,59,1,10585,108,111,111,114,59,1,8970,105,103,104,116,4,2,65,86,2745,2752,114,114,111,119,59,1,8596,101,99,116,111,114,59,1,10574,4,2,101,114,2766,2792,101,4,3,59,65,86,2775,2777,2784,1,8867,114,114,111,119,59,1,8612,101,99,116,111,114,59,1,10586,105,97,110,103,108,101,4,3,59,66,69,2806,2808,2813,1,8882,97,114,59,1,10703,113,117,97,108,59,1,8884,112,4,3,68,84,86,2829,2841,2852,111,119,110,86,101,99,116,111,114,59,1,10577,101,101,86,101,99,116,111,114,59,1,10592,101,99,116,111,114,4,2,59,66,2863,2865,1,8639,97,114,59,1,10584,101,99,116,111,114,4,2,59,66,2881,2883,1,8636,97,114,59,1,10578,114,114,111,119,59,1,8656,105,103,104,116,97,114,114,111,119,59,1,8660,115,4,6,69,70,71,76,83,84,2922,2936,2947,2956,2962,2974,113,117,97,108,71,114,101,97,116,101,114,59,1,8922,117,108,108,69,113,117,97,108,59,1,8806,114,101,97,116,101,114,59,1,8822,101,115,115,59,1,10913,108,97,110,116,69,113,117,97,108,59,1,10877,105,108,100,101,59,1,8818,114,59,3,55349,56591,4,2,59,101,2992,2994,1,8920,102,116,97,114,114,111,119,59,1,8666,105,100,111,116,59,1,319,4,3,110,112,119,3019,3110,3115,103,4,4,76,82,108,114,3030,3058,3070,3098,101,102,116,4,2,65,82,3039,3046,114,114,111,119,59,1,10229,105,103,104,116,65,114,114,111,119,59,1,10231,105,103,104,116,65,114,114,111,119,59,1,10230,101,102,116,4,2,97,114,3079,3086,114,114,111,119,59,1,10232,105,103,104,116,97,114,114,111,119,59,1,10234,105,103,104,116,97,114,114,111,119,59,1,10233,102,59,3,55349,56643,101,114,4,2,76,82,3123,3134,101,102,116,65,114,114,111,119,59,1,8601,105,103,104,116,65,114,114,111,119,59,1,8600,4,3,99,104,116,3154,3158,3161,114,59,1,8466,59,1,8624,114,111,107,59,1,321,59,1,8810,4,8,97,99,101,102,105,111,115,117,3188,3192,3196,3222,3227,3237,3243,3248,112,59,1,10501,121,59,1,1052,4,2,100,108,3202,3213,105,117,109,83,112,97,99,101,59,1,8287,108,105,110,116,114,102,59,1,8499,114,59,3,55349,56592,110,117,115,80,108,117,115,59,1,8723,112,102,59,3,55349,56644,99,114,59,1,8499,59,1,924,4,9,74,97,99,101,102,111,115,116,117,3271,3276,3283,3306,3422,3427,4120,4126,4137,99,121,59,1,1034,99,117,116,101,59,1,323,4,3,97,101,121,3291,3297,3303,114,111,110,59,1,327,100,105,108,59,1,325,59,1,1053,4,3,103,115,119,3314,3380,3415,97,116,105,118,101,4,3,77,84,86,3327,3340,3365,101,100,105,117,109,83,112,97,99,101,59,1,8203,104,105,4,2,99,110,3348,3357,107,83,112,97,99,101,59,1,8203,83,112,97,99,101,59,1,8203,101,114,121,84,104,105,110,83,112,97,99,101,59,1,8203,116,101,100,4,2,71,76,3389,3405,114,101,97,116,101,114,71,114,101,97,116,101,114,59,1,8811,101,115,115,76,101,115,115,59,1,8810,76,105,110,101,59,1,10,114,59,3,55349,56593,4,4,66,110,112,116,3437,3444,3460,3464,114,101,97,107,59,1,8288,66,114,101,97,107,105,110,103,83,112,97,99,101,59,1,160,102,59,1,8469,4,13,59,67,68,69,71,72,76,78,80,82,83,84,86,3492,3494,3517,3536,3578,3657,3685,3784,3823,3860,3915,4066,4107,1,10988,4,2,111,117,3500,3510,110,103,114,117,101,110,116,59,1,8802,112,67,97,112,59,1,8813,111,117,98,108,101,86,101,114,116,105,99,97,108,66,97,114,59,1,8742,4,3,108,113,120,3544,3552,3571,101,109,101,110,116,59,1,8713,117,97,108,4,2,59,84,3561,3563,1,8800,105,108,100,101,59,3,8770,824,105,115,116,115,59,1,8708,114,101,97,116,101,114,4,7,59,69,70,71,76,83,84,3600,3602,3609,3621,3631,3637,3650,1,8815,113,117,97,108,59,1,8817,117,108,108,69,113,117,97,108,59,3,8807,824,114,101,97,116,101,114,59,3,8811,824,101,115,115,59,1,8825,108,97,110,116,69,113,117,97,108,59,3,10878,824,105,108,100,101,59,1,8821,117,109,112,4,2,68,69,3666,3677,111,119,110,72,117,109,112,59,3,8782,824,113,117,97,108,59,3,8783,824,101,4,2,102,115,3692,3724,116,84,114,105,97,110,103,108,101,4,3,59,66,69,3709,3711,3717,1,8938,97,114,59,3,10703,824,113,117,97,108,59,1,8940,115,4,6,59,69,71,76,83,84,3739,3741,3748,3757,3764,3777,1,8814,113,117,97,108,59,1,8816,114,101,97,116,101,114,59,1,8824,101,115,115,59,3,8810,824,108,97,110,116,69,113,117,97,108,59,3,10877,824,105,108,100,101,59,1,8820,101,115,116,101,100,4,2,71,76,3795,3812,114,101,97,116,101,114,71,114,101,97,116,101,114,59,3,10914,824,101,115,115,76,101,115,115,59,3,10913,824,114,101,99,101,100,101,115,4,3,59,69,83,3838,3840,3848,1,8832,113,117,97,108,59,3,10927,824,108,97,110,116,69,113,117,97,108,59,1,8928,4,2,101,105,3866,3881,118,101,114,115,101,69,108,101,109,101,110,116,59,1,8716,103,104,116,84,114,105,97,110,103,108,101,4,3,59,66,69,3900,3902,3908,1,8939,97,114,59,3,10704,824,113,117,97,108,59,1,8941,4,2,113,117,3921,3973,117,97,114,101,83,117,4,2,98,112,3933,3952,115,101,116,4,2,59,69,3942,3945,3,8847,824,113,117,97,108,59,1,8930,101,114,115,101,116,4,2,59,69,3963,3966,3,8848,824,113,117,97,108,59,1,8931,4,3,98,99,112,3981,4000,4045,115,101,116,4,2,59,69,3990,3993,3,8834,8402,113,117,97,108,59,1,8840,99,101,101,100,115,4,4,59,69,83,84,4015,4017,4025,4037,1,8833,113,117,97,108,59,3,10928,824,108,97,110,116,69,113,117,97,108,59,1,8929,105,108,100,101,59,3,8831,824,101,114,115,101,116,4,2,59,69,4056,4059,3,8835,8402,113,117,97,108,59,1,8841,105,108,100,101,4,4,59,69,70,84,4080,4082,4089,4100,1,8769,113,117,97,108,59,1,8772,117,108,108,69,113,117,97,108,59,1,8775,105,108,100,101,59,1,8777,101,114,116,105,99,97,108,66,97,114,59,1,8740,99,114,59,3,55349,56489,105,108,100,101,5,209,1,59,4135,1,209,59,1,925,4,14,69,97,99,100,102,103,109,111,112,114,115,116,117,118,4170,4176,4187,4205,4212,4217,4228,4253,4259,4292,4295,4316,4337,4346,108,105,103,59,1,338,99,117,116,101,5,211,1,59,4185,1,211,4,2,105,121,4193,4202,114,99,5,212,1,59,4200,1,212,59,1,1054,98,108,97,99,59,1,336,114,59,3,55349,56594,114,97,118,101,5,210,1,59,4226,1,210,4,3,97,101,105,4236,4241,4246,99,114,59,1,332,103,97,59,1,937,99,114,111,110,59,1,927,112,102,59,3,55349,56646,101,110,67,117,114,108,121,4,2,68,81,4272,4285,111,117,98,108,101,81,117,111,116,101,59,1,8220,117,111,116,101,59,1,8216,59,1,10836,4,2,99,108,4301,4306,114,59,3,55349,56490,97,115,104,5,216,1,59,4314,1,216,105,4,2,108,109,4323,4332,100,101,5,213,1,59,4330,1,213,101,115,59,1,10807,109,108,5,214,1,59,4344,1,214,101,114,4,2,66,80,4354,4380,4,2,97,114,4360,4364,114,59,1,8254,97,99,4,2,101,107,4372,4375,59,1,9182,101,116,59,1,9140,97,114,101,110,116,104,101,115,105,115,59,1,9180,4,9,97,99,102,104,105,108,111,114,115,4413,4422,4426,4431,4435,4438,4448,4471,4561,114,116,105,97,108,68,59,1,8706,121,59,1,1055,114,59,3,55349,56595,105,59,1,934,59,1,928,117,115,77,105,110,117,115,59,1,177,4,2,105,112,4454,4467,110,99,97,114,101,112,108,97,110,101,59,1,8460,102,59,1,8473,4,4,59,101,105,111,4481,4483,4526,4531,1,10939,99,101,100,101,115,4,4,59,69,83,84,4498,4500,4507,4519,1,8826,113,117,97,108,59,1,10927,108,97,110,116,69,113,117,97,108,59,1,8828,105,108,100,101,59,1,8830,109,101,59,1,8243,4,2,100,112,4537,4543,117,99,116,59,1,8719,111,114,116,105,111,110,4,2,59,97,4555,4557,1,8759,108,59,1,8733,4,2,99,105,4567,4572,114,59,3,55349,56491,59,1,936,4,4,85,102,111,115,4585,4594,4599,4604,79,84,5,34,1,59,4592,1,34,114,59,3,55349,56596,112,102,59,1,8474,99,114,59,3,55349,56492,4,12,66,69,97,99,101,102,104,105,111,114,115,117,4636,4642,4650,4681,4704,4763,4767,4771,5047,5069,5081,5094,97,114,114,59,1,10512,71,5,174,1,59,4648,1,174,4,3,99,110,114,4658,4664,4668,117,116,101,59,1,340,103,59,1,10219,114,4,2,59,116,4675,4677,1,8608,108,59,1,10518,4,3,97,101,121,4689,4695,4701,114,111,110,59,1,344,100,105,108,59,1,342,59,1,1056,4,2,59,118,4710,4712,1,8476,101,114,115,101,4,2,69,85,4722,4748,4,2,108,113,4728,4736,101,109,101,110,116,59,1,8715,117,105,108,105,98,114,105,117,109,59,1,8651,112,69,113,117,105,108,105,98,114,105,117,109,59,1,10607,114,59,1,8476,111,59,1,929,103,104,116,4,8,65,67,68,70,84,85,86,97,4792,4840,4849,4905,4912,4972,5022,5040,4,2,110,114,4798,4811,103,108,101,66,114,97,99,107,101,116,59,1,10217,114,111,119,4,3,59,66,76,4822,4824,4829,1,8594,97,114,59,1,8677,101,102,116,65,114,114,111,119,59,1,8644,101,105,108,105,110,103,59,1,8969,111,4,2,117,119,4856,4869,98,108,101,66,114,97,99,107,101,116,59,1,10215,110,4,2,84,86,4876,4887,101,101,86,101,99,116,111,114,59,1,10589,101,99,116,111,114,4,2,59,66,4898,4900,1,8642,97,114,59,1,10581,108,111,111,114,59,1,8971,4,2,101,114,4918,4944,101,4,3,59,65,86,4927,4929,4936,1,8866,114,114,111,119,59,1,8614,101,99,116,111,114,59,1,10587,105,97,110,103,108,101,4,3,59,66,69,4958,4960,4965,1,8883,97,114,59,1,10704,113,117,97,108,59,1,8885,112,4,3,68,84,86,4981,4993,5004,111,119,110,86,101,99,116,111,114,59,1,10575,101,101,86,101,99,116,111,114,59,1,10588,101,99,116,111,114,4,2,59,66,5015,5017,1,8638,97,114,59,1,10580,101,99,116,111,114,4,2,59,66,5033,5035,1,8640,97,114,59,1,10579,114,114,111,119,59,1,8658,4,2,112,117,5053,5057,102,59,1,8477,110,100,73,109,112,108,105,101,115,59,1,10608,105,103,104,116,97,114,114,111,119,59,1,8667,4,2,99,104,5087,5091,114,59,1,8475,59,1,8625,108,101,68,101,108,97,121,101,100,59,1,10740,4,13,72,79,97,99,102,104,105,109,111,113,115,116,117,5134,5150,5157,5164,5198,5203,5259,5265,5277,5283,5374,5380,5385,4,2,67,99,5140,5146,72,99,121,59,1,1065,121,59,1,1064,70,84,99,121,59,1,1068,99,117,116,101,59,1,346,4,5,59,97,101,105,121,5176,5178,5184,5190,5195,1,10940,114,111,110,59,1,352,100,105,108,59,1,350,114,99,59,1,348,59,1,1057,114,59,3,55349,56598,111,114,116,4,4,68,76,82,85,5216,5227,5238,5250,111,119,110,65,114,114,111,119,59,1,8595,101,102,116,65,114,114,111,119,59,1,8592,105,103,104,116,65,114,114,111,119,59,1,8594,112,65,114,114,111,119,59,1,8593,103,109,97,59,1,931,97,108,108,67,105,114,99,108,101,59,1,8728,112,102,59,3,55349,56650,4,2,114,117,5289,5293,116,59,1,8730,97,114,101,4,4,59,73,83,85,5306,5308,5322,5367,1,9633,110,116,101,114,115,101,99,116,105,111,110,59,1,8851,117,4,2,98,112,5329,5347,115,101,116,4,2,59,69,5338,5340,1,8847,113,117,97,108,59,1,8849,101,114,115,101,116,4,2,59,69,5358,5360,1,8848,113,117,97,108,59,1,8850,110,105,111,110,59,1,8852,99,114,59,3,55349,56494,97,114,59,1,8902,4,4,98,99,109,112,5395,5420,5475,5478,4,2,59,115,5401,5403,1,8912,101,116,4,2,59,69,5411,5413,1,8912,113,117,97,108,59,1,8838,4,2,99,104,5426,5468,101,101,100,115,4,4,59,69,83,84,5440,5442,5449,5461,1,8827,113,117,97,108,59,1,10928,108,97,110,116,69,113,117,97,108,59,1,8829,105,108,100,101,59,1,8831,84,104,97,116,59,1,8715,59,1,8721,4,3,59,101,115,5486,5488,5507,1,8913,114,115,101,116,4,2,59,69,5498,5500,1,8835,113,117,97,108,59,1,8839,101,116,59,1,8913,4,11,72,82,83,97,99,102,104,105,111,114,115,5536,5546,5552,5567,5579,5602,5607,5655,5695,5701,5711,79,82,78,5,222,1,59,5544,1,222,65,68,69,59,1,8482,4,2,72,99,5558,5563,99,121,59,1,1035,121,59,1,1062,4,2,98,117,5573,5576,59,1,9,59,1,932,4,3,97,101,121,5587,5593,5599,114,111,110,59,1,356,100,105,108,59,1,354,59,1,1058,114,59,3,55349,56599,4,2,101,105,5613,5631,4,2,114,116,5619,5627,101,102,111,114,101,59,1,8756,97,59,1,920,4,2,99,110,5637,5647,107,83,112,97,99,101,59,3,8287,8202,83,112,97,99,101,59,1,8201,108,100,101,4,4,59,69,70,84,5668,5670,5677,5688,1,8764,113,117,97,108,59,1,8771,117,108,108,69,113,117,97,108,59,1,8773,105,108,100,101,59,1,8776,112,102,59,3,55349,56651,105,112,108,101,68,111,116,59,1,8411,4,2,99,116,5717,5722,114,59,3,55349,56495,114,111,107,59,1,358,4,14,97,98,99,100,102,103,109,110,111,112,114,115,116,117,5758,5789,5805,5823,5830,5835,5846,5852,5921,5937,6089,6095,6101,6108,4,2,99,114,5764,5774,117,116,101,5,218,1,59,5772,1,218,114,4,2,59,111,5781,5783,1,8607,99,105,114,59,1,10569,114,4,2,99,101,5796,5800,121,59,1,1038,118,101,59,1,364,4,2,105,121,5811,5820,114,99,5,219,1,59,5818,1,219,59,1,1059,98,108,97,99,59,1,368,114,59,3,55349,56600,114,97,118,101,5,217,1,59,5844,1,217,97,99,114,59,1,362,4,2,100,105,5858,5905,101,114,4,2,66,80,5866,5892,4,2,97,114,5872,5876,114,59,1,95,97,99,4,2,101,107,5884,5887,59,1,9183,101,116,59,1,9141,97,114,101,110,116,104,101,115,105,115,59,1,9181,111,110,4,2,59,80,5913,5915,1,8899,108,117,115,59,1,8846,4,2,103,112,5927,5932,111,110,59,1,370,102,59,3,55349,56652,4,8,65,68,69,84,97,100,112,115,5955,5985,5996,6009,6026,6033,6044,6075,114,114,111,119,4,3,59,66,68,5967,5969,5974,1,8593,97,114,59,1,10514,111,119,110,65,114,114,111,119,59,1,8645,111,119,110,65,114,114,111,119,59,1,8597,113,117,105,108,105,98,114,105,117,109,59,1,10606,101,101,4,2,59,65,6017,6019,1,8869,114,114,111,119,59,1,8613,114,114,111,119,59,1,8657,111,119,110,97,114,114,111,119,59,1,8661,101,114,4,2,76,82,6052,6063,101,102,116,65,114,114,111,119,59,1,8598,105,103,104,116,65,114,114,111,119,59,1,8599,105,4,2,59,108,6082,6084,1,978,111,110,59,1,933,105,110,103,59,1,366,99,114,59,3,55349,56496,105,108,100,101,59,1,360,109,108,5,220,1,59,6115,1,220,4,9,68,98,99,100,101,102,111,115,118,6137,6143,6148,6152,6166,6250,6255,6261,6267,97,115,104,59,1,8875,97,114,59,1,10987,121,59,1,1042,97,115,104,4,2,59,108,6161,6163,1,8873,59,1,10982,4,2,101,114,6172,6175,59,1,8897,4,3,98,116,121,6183,6188,6238,97,114,59,1,8214,4,2,59,105,6194,6196,1,8214,99,97,108,4,4,66,76,83,84,6209,6214,6220,6231,97,114,59,1,8739,105,110,101,59,1,124,101,112,97,114,97,116,111,114,59,1,10072,105,108,100,101,59,1,8768,84,104,105,110,83,112,97,99,101,59,1,8202,114,59,3,55349,56601,112,102,59,3,55349,56653,99,114,59,3,55349,56497,100,97,115,104,59,1,8874,4,5,99,101,102,111,115,6286,6292,6298,6303,6309,105,114,99,59,1,372,100,103,101,59,1,8896,114,59,3,55349,56602,112,102,59,3,55349,56654,99,114,59,3,55349,56498,4,4,102,105,111,115,6325,6330,6333,6339,114,59,3,55349,56603,59,1,926,112,102,59,3,55349,56655,99,114,59,3,55349,56499,4,9,65,73,85,97,99,102,111,115,117,6365,6370,6375,6380,6391,6405,6410,6416,6422,99,121,59,1,1071,99,121,59,1,1031,99,121,59,1,1070,99,117,116,101,5,221,1,59,6389,1,221,4,2,105,121,6397,6402,114,99,59,1,374,59,1,1067,114,59,3,55349,56604,112,102,59,3,55349,56656,99,114,59,3,55349,56500,109,108,59,1,376,4,8,72,97,99,100,101,102,111,115,6445,6450,6457,6472,6477,6501,6505,6510,99,121,59,1,1046,99,117,116,101,59,1,377,4,2,97,121,6463,6469,114,111,110,59,1,381,59,1,1047,111,116,59,1,379,4,2,114,116,6483,6497,111,87,105,100,116,104,83,112,97,99,101,59,1,8203,97,59,1,918,114,59,1,8488,112,102,59,1,8484,99,114,59,3,55349,56501,4,16,97,98,99,101,102,103,108,109,110,111,112,114,115,116,117,119,6550,6561,6568,6612,6622,6634,6645,6672,6699,6854,6870,6923,6933,6963,6974,6983,99,117,116,101,5,225,1,59,6559,1,225,114,101,118,101,59,1,259,4,6,59,69,100,105,117,121,6582,6584,6588,6591,6600,6609,1,8766,59,3,8766,819,59,1,8767,114,99,5,226,1,59,6598,1,226,116,101,5,180,1,59,6607,1,180,59,1,1072,108,105,103,5,230,1,59,6620,1,230,4,2,59,114,6628,6630,1,8289,59,3,55349,56606,114,97,118,101,5,224,1,59,6643,1,224,4,2,101,112,6651,6667,4,2,102,112,6657,6663,115,121,109,59,1,8501,104,59,1,8501,104,97,59,1,945,4,2,97,112,6678,6692,4,2,99,108,6684,6688,114,59,1,257,103,59,1,10815,5,38,1,59,6697,1,38,4,2,100,103,6705,6737,4,5,59,97,100,115,118,6717,6719,6724,6727,6734,1,8743,110,100,59,1,10837,59,1,10844,108,111,112,101,59,1,10840,59,1,10842,4,7,59,101,108,109,114,115,122,6753,6755,6758,6762,6814,6835,6848,1,8736,59,1,10660,101,59,1,8736,115,100,4,2,59,97,6770,6772,1,8737,4,8,97,98,99,100,101,102,103,104,6790,6793,6796,6799,6802,6805,6808,6811,59,1,10664,59,1,10665,59,1,10666,59,1,10667,59,1,10668,59,1,10669,59,1,10670,59,1,10671,116,4,2,59,118,6821,6823,1,8735,98,4,2,59,100,6830,6832,1,8894,59,1,10653,4,2,112,116,6841,6845,104,59,1,8738,59,1,197,97,114,114,59,1,9084,4,2,103,112,6860,6865,111,110,59,1,261,102,59,3,55349,56658,4,7,59,69,97,101,105,111,112,6886,6888,6891,6897,6900,6904,6908,1,8776,59,1,10864,99,105,114,59,1,10863,59,1,8778,100,59,1,8779,115,59,1,39,114,111,120,4,2,59,101,6917,6919,1,8776,113,59,1,8778,105,110,103,5,229,1,59,6931,1,229,4,3,99,116,121,6941,6946,6949,114,59,3,55349,56502,59,1,42,109,112,4,2,59,101,6957,6959,1,8776,113,59,1,8781,105,108,100,101,5,227,1,59,6972,1,227,109,108,5,228,1,59,6981,1,228,4,2,99,105,6989,6997,111,110,105,110,116,59,1,8755,110,116,59,1,10769,4,16,78,97,98,99,100,101,102,105,107,108,110,111,112,114,115,117,7036,7041,7119,7135,7149,7155,7219,7224,7347,7354,7463,7489,7786,7793,7814,7866,111,116,59,1,10989,4,2,99,114,7047,7094,107,4,4,99,101,112,115,7058,7064,7073,7080,111,110,103,59,1,8780,112,115,105,108,111,110,59,1,1014,114,105,109,101,59,1,8245,105,109,4,2,59,101,7088,7090,1,8765,113,59,1,8909,4,2,118,119,7100,7105,101,101,59,1,8893,101,100,4,2,59,103,7113,7115,1,8965,101,59,1,8965,114,107,4,2,59,116,7127,7129,1,9141,98,114,107,59,1,9142,4,2,111,121,7141,7146,110,103,59,1,8780,59,1,1073,113,117,111,59,1,8222,4,5,99,109,112,114,116,7167,7181,7188,7193,7199,97,117,115,4,2,59,101,7176,7178,1,8757,59,1,8757,112,116,121,118,59,1,10672,115,105,59,1,1014,110,111,117,59,1,8492,4,3,97,104,119,7207,7210,7213,59,1,946,59,1,8502,101,101,110,59,1,8812,114,59,3,55349,56607,103,4,7,99,111,115,116,117,118,119,7241,7262,7288,7305,7328,7335,7340,4,3,97,105,117,7249,7253,7258,112,59,1,8898,114,99,59,1,9711,112,59,1,8899,4,3,100,112,116,7270,7275,7281,111,116,59,1,10752,108,117,115,59,1,10753,105,109,101,115,59,1,10754,4,2,113,116,7294,7300,99,117,112,59,1,10758,97,114,59,1,9733,114,105,97,110,103,108,101,4,2,100,117,7318,7324,111,119,110,59,1,9661,112,59,1,9651,112,108,117,115,59,1,10756,101,101,59,1,8897,101,100,103,101,59,1,8896,97,114,111,119,59,1,10509,4,3,97,107,111,7362,7436,7458,4,2,99,110,7368,7432,107,4,3,108,115,116,7377,7386,7394,111,122,101,110,103,101,59,1,10731,113,117,97,114,101,59,1,9642,114,105,97,110,103,108,101,4,4,59,100,108,114,7411,7413,7419,7425,1,9652,111,119,110,59,1,9662,101,102,116,59,1,9666,105,103,104,116,59,1,9656,107,59,1,9251,4,2,49,51,7442,7454,4,2,50,52,7448,7451,59,1,9618,59,1,9617,52,59,1,9619,99,107,59,1,9608,4,2,101,111,7469,7485,4,2,59,113,7475,7478,3,61,8421,117,105,118,59,3,8801,8421,116,59,1,8976,4,4,112,116,119,120,7499,7504,7517,7523,102,59,3,55349,56659,4,2,59,116,7510,7512,1,8869,111,109,59,1,8869,116,105,101,59,1,8904,4,12,68,72,85,86,98,100,104,109,112,116,117,118,7549,7571,7597,7619,7655,7660,7682,7708,7715,7721,7728,7750,4,4,76,82,108,114,7559,7562,7565,7568,59,1,9559,59,1,9556,59,1,9558,59,1,9555,4,5,59,68,85,100,117,7583,7585,7588,7591,7594,1,9552,59,1,9574,59,1,9577,59,1,9572,59,1,9575,4,4,76,82,108,114,7607,7610,7613,7616,59,1,9565,59,1,9562,59,1,9564,59,1,9561,4,7,59,72,76,82,104,108,114,7635,7637,7640,7643,7646,7649,7652,1,9553,59,1,9580,59,1,9571,59,1,9568,59,1,9579,59,1,9570,59,1,9567,111,120,59,1,10697,4,4,76,82,108,114,7670,7673,7676,7679,59,1,9557,59,1,9554,59,1,9488,59,1,9484,4,5,59,68,85,100,117,7694,7696,7699,7702,7705,1,9472,59,1,9573,59,1,9576,59,1,9516,59,1,9524,105,110,117,115,59,1,8863,108,117,115,59,1,8862,105,109,101,115,59,1,8864,4,4,76,82,108,114,7738,7741,7744,7747,59,1,9563,59,1,9560,59,1,9496,59,1,9492,4,7,59,72,76,82,104,108,114,7766,7768,7771,7774,7777,7780,7783,1,9474,59,1,9578,59,1,9569,59,1,9566,59,1,9532,59,1,9508,59,1,9500,114,105,109,101,59,1,8245,4,2,101,118,7799,7804,118,101,59,1,728,98,97,114,5,166,1,59,7812,1,166,4,4,99,101,105,111,7824,7829,7834,7846,114,59,3,55349,56503,109,105,59,1,8271,109,4,2,59,101,7841,7843,1,8765,59,1,8909,108,4,3,59,98,104,7855,7857,7860,1,92,59,1,10693,115,117,98,59,1,10184,4,2,108,109,7872,7885,108,4,2,59,101,7879,7881,1,8226,116,59,1,8226,112,4,3,59,69,101,7894,7896,7899,1,8782,59,1,10926,4,2,59,113,7905,7907,1,8783,59,1,8783,4,15,97,99,100,101,102,104,105,108,111,114,115,116,117,119,121,7942,8021,8075,8080,8121,8126,8157,8279,8295,8430,8446,8485,8491,8707,8726,4,3,99,112,114,7950,7956,8007,117,116,101,59,1,263,4,6,59,97,98,99,100,115,7970,7972,7977,7984,7998,8003,1,8745,110,100,59,1,10820,114,99,117,112,59,1,10825,4,2,97,117,7990,7994,112,59,1,10827,112,59,1,10823,111,116,59,1,10816,59,3,8745,65024,4,2,101,111,8013,8017,116,59,1,8257,110,59,1,711,4,4,97,101,105,117,8031,8046,8056,8061,4,2,112,114,8037,8041,115,59,1,10829,111,110,59,1,269,100,105,108,5,231,1,59,8054,1,231,114,99,59,1,265,112,115,4,2,59,115,8069,8071,1,10828,109,59,1,10832,111,116,59,1,267,4,3,100,109,110,8088,8097,8104,105,108,5,184,1,59,8095,1,184,112,116,121,118,59,1,10674,116,5,162,2,59,101,8112,8114,1,162,114,100,111,116,59,1,183,114,59,3,55349,56608,4,3,99,101,105,8134,8138,8154,121,59,1,1095,99,107,4,2,59,109,8146,8148,1,10003,97,114,107,59,1,10003,59,1,967,114,4,7,59,69,99,101,102,109,115,8174,8176,8179,8258,8261,8268,8273,1,9675,59,1,10691,4,3,59,101,108,8187,8189,8193,1,710,113,59,1,8791,101,4,2,97,100,8200,8223,114,114,111,119,4,2,108,114,8210,8216,101,102,116,59,1,8634,105,103,104,116,59,1,8635,4,5,82,83,97,99,100,8235,8238,8241,8246,8252,59,1,174,59,1,9416,115,116,59,1,8859,105,114,99,59,1,8858,97,115,104,59,1,8861,59,1,8791,110,105,110,116,59,1,10768,105,100,59,1,10991,99,105,114,59,1,10690,117,98,115,4,2,59,117,8288,8290,1,9827,105,116,59,1,9827,4,4,108,109,110,112,8305,8326,8376,8400,111,110,4,2,59,101,8313,8315,1,58,4,2,59,113,8321,8323,1,8788,59,1,8788,4,2,109,112,8332,8344,97,4,2,59,116,8339,8341,1,44,59,1,64,4,3,59,102,108,8352,8354,8358,1,8705,110,59,1,8728,101,4,2,109,120,8365,8371,101,110,116,59,1,8705,101,115,59,1,8450,4,2,103,105,8382,8395,4,2,59,100,8388,8390,1,8773,111,116,59,1,10861,110,116,59,1,8750,4,3,102,114,121,8408,8412,8417,59,3,55349,56660,111,100,59,1,8720,5,169,2,59,115,8424,8426,1,169,114,59,1,8471,4,2,97,111,8436,8441,114,114,59,1,8629,115,115,59,1,10007,4,2,99,117,8452,8457,114,59,3,55349,56504,4,2,98,112,8463,8474,4,2,59,101,8469,8471,1,10959,59,1,10961,4,2,59,101,8480,8482,1,10960,59,1,10962,100,111,116,59,1,8943,4,7,100,101,108,112,114,118,119,8507,8522,8536,8550,8600,8697,8702,97,114,114,4,2,108,114,8516,8519,59,1,10552,59,1,10549,4,2,112,115,8528,8532,114,59,1,8926,99,59,1,8927,97,114,114,4,2,59,112,8545,8547,1,8630,59,1,10557,4,6,59,98,99,100,111,115,8564,8566,8573,8587,8592,8596,1,8746,114,99,97,112,59,1,10824,4,2,97,117,8579,8583,112,59,1,10822,112,59,1,10826,111,116,59,1,8845,114,59,1,10821,59,3,8746,65024,4,4,97,108,114,118,8610,8623,8663,8672,114,114,4,2,59,109,8618,8620,1,8631,59,1,10556,121,4,3,101,118,119,8632,8651,8656,113,4,2,112,115,8639,8645,114,101,99,59,1,8926,117,99,99,59,1,8927,101,101,59,1,8910,101,100,103,101,59,1,8911,101,110,5,164,1,59,8670,1,164,101,97,114,114,111,119,4,2,108,114,8684,8690,101,102,116,59,1,8630,105,103,104,116,59,1,8631,101,101,59,1,8910,101,100,59,1,8911,4,2,99,105,8713,8721,111,110,105,110,116,59,1,8754,110,116,59,1,8753,108,99,116,121,59,1,9005,4,19,65,72,97,98,99,100,101,102,104,105,106,108,111,114,115,116,117,119,122,8773,8778,8783,8821,8839,8854,8887,8914,8930,8944,9036,9041,9058,9197,9227,9258,9281,9297,9305,114,114,59,1,8659,97,114,59,1,10597,4,4,103,108,114,115,8793,8799,8805,8809,103,101,114,59,1,8224,101,116,104,59,1,8504,114,59,1,8595,104,4,2,59,118,8816,8818,1,8208,59,1,8867,4,2,107,108,8827,8834,97,114,111,119,59,1,10511,97,99,59,1,733,4,2,97,121,8845,8851,114,111,110,59,1,271,59,1,1076,4,3,59,97,111,8862,8864,8880,1,8518,4,2,103,114,8870,8876,103,101,114,59,1,8225,114,59,1,8650,116,115,101,113,59,1,10871,4,3,103,108,109,8895,8902,8907,5,176,1,59,8900,1,176,116,97,59,1,948,112,116,121,118,59,1,10673,4,2,105,114,8920,8926,115,104,116,59,1,10623,59,3,55349,56609,97,114,4,2,108,114,8938,8941,59,1,8643,59,1,8642,4,5,97,101,103,115,118,8956,8986,8989,8996,9001,109,4,3,59,111,115,8965,8967,8983,1,8900,110,100,4,2,59,115,8975,8977,1,8900,117,105,116,59,1,9830,59,1,9830,59,1,168,97,109,109,97,59,1,989,105,110,59,1,8946,4,3,59,105,111,9009,9011,9031,1,247,100,101,5,247,2,59,111,9020,9022,1,247,110,116,105,109,101,115,59,1,8903,110,120,59,1,8903,99,121,59,1,1106,99,4,2,111,114,9048,9053,114,110,59,1,8990,111,112,59,1,8973,4,5,108,112,116,117,119,9070,9076,9081,9130,9144,108,97,114,59,1,36,102,59,3,55349,56661,4,5,59,101,109,112,115,9093,9095,9109,9116,9122,1,729,113,4,2,59,100,9102,9104,1,8784,111,116,59,1,8785,105,110,117,115,59,1,8760,108,117,115,59,1,8724,113,117,97,114,101,59,1,8865,98,108,101,98,97,114,119,101,100,103,101,59,1,8966,110,4,3,97,100,104,9153,9160,9172,114,114,111,119,59,1,8595,111,119,110,97,114,114,111,119,115,59,1,8650,97,114,112,111,111,110,4,2,108,114,9184,9190,101,102,116,59,1,8643,105,103,104,116,59,1,8642,4,2,98,99,9203,9211,107,97,114,111,119,59,1,10512,4,2,111,114,9217,9222,114,110,59,1,8991,111,112,59,1,8972,4,3,99,111,116,9235,9248,9252,4,2,114,121,9241,9245,59,3,55349,56505,59,1,1109,108,59,1,10742,114,111,107,59,1,273,4,2,100,114,9264,9269,111,116,59,1,8945,105,4,2,59,102,9276,9278,1,9663,59,1,9662,4,2,97,104,9287,9292,114,114,59,1,8693,97,114,59,1,10607,97,110,103,108,101,59,1,10662,4,2,99,105,9311,9315,121,59,1,1119,103,114,97,114,114,59,1,10239,4,18,68,97,99,100,101,102,103,108,109,110,111,112,113,114,115,116,117,120,9361,9376,9398,9439,9444,9447,9462,9495,9531,9585,9598,9614,9659,9755,9771,9792,9808,9826,4,2,68,111,9367,9372,111,116,59,1,10871,116,59,1,8785,4,2,99,115,9382,9392,117,116,101,5,233,1,59,9390,1,233,116,101,114,59,1,10862,4,4,97,105,111,121,9408,9414,9430,9436,114,111,110,59,1,283,114,4,2,59,99,9421,9423,1,8790,5,234,1,59,9428,1,234,108,111,110,59,1,8789,59,1,1101,111,116,59,1,279,59,1,8519,4,2,68,114,9453,9458,111,116,59,1,8786,59,3,55349,56610,4,3,59,114,115,9470,9472,9482,1,10906,97,118,101,5,232,1,59,9480,1,232,4,2,59,100,9488,9490,1,10902,111,116,59,1,10904,4,4,59,105,108,115,9505,9507,9515,9518,1,10905,110,116,101,114,115,59,1,9191,59,1,8467,4,2,59,100,9524,9526,1,10901,111,116,59,1,10903,4,3,97,112,115,9539,9544,9564,99,114,59,1,275,116,121,4,3,59,115,118,9554,9556,9561,1,8709,101,116,59,1,8709,59,1,8709,112,4,2,49,59,9571,9583,4,2,51,52,9577,9580,59,1,8196,59,1,8197,1,8195,4,2,103,115,9591,9594,59,1,331,112,59,1,8194,4,2,103,112,9604,9609,111,110,59,1,281,102,59,3,55349,56662,4,3,97,108,115,9622,9635,9640,114,4,2,59,115,9629,9631,1,8917,108,59,1,10723,117,115,59,1,10865,105,4,3,59,108,118,9649,9651,9656,1,949,111,110,59,1,949,59,1,1013,4,4,99,115,117,118,9669,9686,9716,9747,4,2,105,111,9675,9680,114,99,59,1,8790,108,111,110,59,1,8789,4,2,105,108,9692,9696,109,59,1,8770,97,110,116,4,2,103,108,9705,9710,116,114,59,1,10902,101,115,115,59,1,10901,4,3,97,101,105,9724,9729,9734,108,115,59,1,61,115,116,59,1,8799,118,4,2,59,68,9741,9743,1,8801,68,59,1,10872,112,97,114,115,108,59,1,10725,4,2,68,97,9761,9766,111,116,59,1,8787,114,114,59,1,10609,4,3,99,100,105,9779,9783,9788,114,59,1,8495,111,116,59,1,8784,109,59,1,8770,4,2,97,104,9798,9801,59,1,951,5,240,1,59,9806,1,240,4,2,109,114,9814,9822,108,5,235,1,59,9820,1,235,111,59,1,8364,4,3,99,105,112,9834,9838,9843,108,59,1,33,115,116,59,1,8707,4,2,101,111,9849,9859,99,116,97,116,105,111,110,59,1,8496,110,101,110,116,105,97,108,101,59,1,8519,4,12,97,99,101,102,105,106,108,110,111,112,114,115,9896,9910,9914,9921,9954,9960,9967,9989,9994,10027,10036,10164,108,108,105,110,103,100,111,116,115,101,113,59,1,8786,121,59,1,1092,109,97,108,101,59,1,9792,4,3,105,108,114,9929,9935,9950,108,105,103,59,1,64259,4,2,105,108,9941,9945,103,59,1,64256,105,103,59,1,64260,59,3,55349,56611,108,105,103,59,1,64257,108,105,103,59,3,102,106,4,3,97,108,116,9975,9979,9984,116,59,1,9837,105,103,59,1,64258,110,115,59,1,9649,111,102,59,1,402,4,2,112,114,10000,10005,102,59,3,55349,56663,4,2,97,107,10011,10016,108,108,59,1,8704,4,2,59,118,10022,10024,1,8916,59,1,10969,97,114,116,105,110,116,59,1,10765,4,2,97,111,10042,10159,4,2,99,115,10048,10155,4,6,49,50,51,52,53,55,10062,10102,10114,10135,10139,10151,4,6,50,51,52,53,54,56,10076,10083,10086,10093,10096,10099,5,189,1,59,10081,1,189,59,1,8531,5,188,1,59,10091,1,188,59,1,8533,59,1,8537,59,1,8539,4,2,51,53,10108,10111,59,1,8532,59,1,8534,4,3,52,53,56,10122,10129,10132,5,190,1,59,10127,1,190,59,1,8535,59,1,8540,53,59,1,8536,4,2,54,56,10145,10148,59,1,8538,59,1,8541,56,59,1,8542,108,59,1,8260,119,110,59,1,8994,99,114,59,3,55349,56507,4,17,69,97,98,99,100,101,102,103,105,106,108,110,111,114,115,116,118,10206,10217,10247,10254,10268,10273,10358,10363,10374,10380,10385,10406,10458,10464,10470,10497,10610,4,2,59,108,10212,10214,1,8807,59,1,10892,4,3,99,109,112,10225,10231,10244,117,116,101,59,1,501,109,97,4,2,59,100,10239,10241,1,947,59,1,989,59,1,10886,114,101,118,101,59,1,287,4,2,105,121,10260,10265,114,99,59,1,285,59,1,1075,111,116,59,1,289,4,4,59,108,113,115,10283,10285,10288,10308,1,8805,59,1,8923,4,3,59,113,115,10296,10298,10301,1,8805,59,1,8807,108,97,110,116,59,1,10878,4,4,59,99,100,108,10318,10320,10324,10345,1,10878,99,59,1,10921,111,116,4,2,59,111,10332,10334,1,10880,4,2,59,108,10340,10342,1,10882,59,1,10884,4,2,59,101,10351,10354,3,8923,65024,115,59,1,10900,114,59,3,55349,56612,4,2,59,103,10369,10371,1,8811,59,1,8921,109,101,108,59,1,8503,99,121,59,1,1107,4,4,59,69,97,106,10395,10397,10400,10403,1,8823,59,1,10898,59,1,10917,59,1,10916,4,4,69,97,101,115,10416,10419,10434,10453,59,1,8809,112,4,2,59,112,10426,10428,1,10890,114,111,120,59,1,10890,4,2,59,113,10440,10442,1,10888,4,2,59,113,10448,10450,1,10888,59,1,8809,105,109,59,1,8935,112,102,59,3,55349,56664,97,118,101,59,1,96,4,2,99,105,10476,10480,114,59,1,8458,109,4,3,59,101,108,10489,10491,10494,1,8819,59,1,10894,59,1,10896,5,62,6,59,99,100,108,113,114,10512,10514,10527,10532,10538,10545,1,62,4,2,99,105,10520,10523,59,1,10919,114,59,1,10874,111,116,59,1,8919,80,97,114,59,1,10645,117,101,115,116,59,1,10876,4,5,97,100,101,108,115,10557,10574,10579,10599,10605,4,2,112,114,10563,10570,112,114,111,120,59,1,10886,114,59,1,10616,111,116,59,1,8919,113,4,2,108,113,10586,10592,101,115,115,59,1,8923,108,101,115,115,59,1,10892,101,115,115,59,1,8823,105,109,59,1,8819,4,2,101,110,10616,10626,114,116,110,101,113,113,59,3,8809,65024,69,59,3,8809,65024,4,10,65,97,98,99,101,102,107,111,115,121,10653,10658,10713,10718,10724,10760,10765,10786,10850,10875,114,114,59,1,8660,4,4,105,108,109,114,10668,10674,10678,10684,114,115,112,59,1,8202,102,59,1,189,105,108,116,59,1,8459,4,2,100,114,10690,10695,99,121,59,1,1098,4,3,59,99,119,10703,10705,10710,1,8596,105,114,59,1,10568,59,1,8621,97,114,59,1,8463,105,114,99,59,1,293,4,3,97,108,114,10732,10748,10754,114,116,115,4,2,59,117,10741,10743,1,9829,105,116,59,1,9829,108,105,112,59,1,8230,99,111,110,59,1,8889,114,59,3,55349,56613,115,4,2,101,119,10772,10779,97,114,111,119,59,1,10533,97,114,111,119,59,1,10534,4,5,97,109,111,112,114,10798,10803,10809,10839,10844,114,114,59,1,8703,116,104,116,59,1,8763,107,4,2,108,114,10816,10827,101,102,116,97,114,114,111,119,59,1,8617,105,103,104,116,97,114,114,111,119,59,1,8618,102,59,3,55349,56665,98,97,114,59,1,8213,4,3,99,108,116,10858,10863,10869,114,59,3,55349,56509,97,115,104,59,1,8463,114,111,107,59,1,295,4,2,98,112,10881,10887,117,108,108,59,1,8259,104,101,110,59,1,8208,4,15,97,99,101,102,103,105,106,109,110,111,112,113,115,116,117,10925,10936,10958,10977,10990,11001,11039,11045,11101,11192,11220,11226,11237,11285,11299,99,117,116,101,5,237,1,59,10934,1,237,4,3,59,105,121,10944,10946,10955,1,8291,114,99,5,238,1,59,10953,1,238,59,1,1080,4,2,99,120,10964,10968,121,59,1,1077,99,108,5,161,1,59,10975,1,161,4,2,102,114,10983,10986,59,1,8660,59,3,55349,56614,114,97,118,101,5,236,1,59,10999,1,236,4,4,59,105,110,111,11011,11013,11028,11034,1,8520,4,2,105,110,11019,11024,110,116,59,1,10764,116,59,1,8749,102,105,110,59,1,10716,116,97,59,1,8489,108,105,103,59,1,307,4,3,97,111,112,11053,11092,11096,4,3,99,103,116,11061,11065,11088,114,59,1,299,4,3,101,108,112,11073,11076,11082,59,1,8465,105,110,101,59,1,8464,97,114,116,59,1,8465,104,59,1,305,102,59,1,8887,101,100,59,1,437,4,5,59,99,102,111,116,11113,11115,11121,11136,11142,1,8712,97,114,101,59,1,8453,105,110,4,2,59,116,11129,11131,1,8734,105,101,59,1,10717,100,111,116,59,1,305,4,5,59,99,101,108,112,11154,11156,11161,11179,11186,1,8747,97,108,59,1,8890,4,2,103,114,11167,11173,101,114,115,59,1,8484,99,97,108,59,1,8890,97,114,104,107,59,1,10775,114,111,100,59,1,10812,4,4,99,103,112,116,11202,11206,11211,11216,121,59,1,1105,111,110,59,1,303,102,59,3,55349,56666,97,59,1,953,114,111,100,59,1,10812,117,101,115,116,5,191,1,59,11235,1,191,4,2,99,105,11243,11248,114,59,3,55349,56510,110,4,5,59,69,100,115,118,11261,11263,11266,11271,11282,1,8712,59,1,8953,111,116,59,1,8949,4,2,59,118,11277,11279,1,8948,59,1,8947,59,1,8712,4,2,59,105,11291,11293,1,8290,108,100,101,59,1,297,4,2,107,109,11305,11310,99,121,59,1,1110,108,5,239,1,59,11316,1,239,4,6,99,102,109,111,115,117,11332,11346,11351,11357,11363,11380,4,2,105,121,11338,11343,114,99,59,1,309,59,1,1081,114,59,3,55349,56615,97,116,104,59,1,567,112,102,59,3,55349,56667,4,2,99,101,11369,11374,114,59,3,55349,56511,114,99,121,59,1,1112,107,99,121,59,1,1108,4,8,97,99,102,103,104,106,111,115,11404,11418,11433,11438,11445,11450,11455,11461,112,112,97,4,2,59,118,11413,11415,1,954,59,1,1008,4,2,101,121,11424,11430,100,105,108,59,1,311,59,1,1082,114,59,3,55349,56616,114,101,101,110,59,1,312,99,121,59,1,1093,99,121,59,1,1116,112,102,59,3,55349,56668,99,114,59,3,55349,56512,4,23,65,66,69,72,97,98,99,100,101,102,103,104,106,108,109,110,111,112,114,115,116,117,118,11515,11538,11544,11555,11560,11721,11780,11818,11868,12136,12160,12171,12203,12208,12246,12275,12327,12509,12523,12569,12641,12732,12752,4,3,97,114,116,11523,11528,11532,114,114,59,1,8666,114,59,1,8656,97,105,108,59,1,10523,97,114,114,59,1,10510,4,2,59,103,11550,11552,1,8806,59,1,10891,97,114,59,1,10594,4,9,99,101,103,109,110,112,113,114,116,11580,11586,11594,11600,11606,11624,11627,11636,11694,117,116,101,59,1,314,109,112,116,121,118,59,1,10676,114,97,110,59,1,8466,98,100,97,59,1,955,103,4,3,59,100,108,11615,11617,11620,1,10216,59,1,10641,101,59,1,10216,59,1,10885,117,111,5,171,1,59,11634,1,171,114,4,8,59,98,102,104,108,112,115,116,11655,11657,11669,11673,11677,11681,11685,11690,1,8592,4,2,59,102,11663,11665,1,8676,115,59,1,10527,115,59,1,10525,107,59,1,8617,112,59,1,8619,108,59,1,10553,105,109,59,1,10611,108,59,1,8610,4,3,59,97,101,11702,11704,11709,1,10923,105,108,59,1,10521,4,2,59,115,11715,11717,1,10925,59,3,10925,65024,4,3,97,98,114,11729,11734,11739,114,114,59,1,10508,114,107,59,1,10098,4,2,97,107,11745,11758,99,4,2,101,107,11752,11755,59,1,123,59,1,91,4,2,101,115,11764,11767,59,1,10635,108,4,2,100,117,11774,11777,59,1,10639,59,1,10637,4,4,97,101,117,121,11790,11796,11811,11815,114,111,110,59,1,318,4,2,100,105,11802,11807,105,108,59,1,316,108,59,1,8968,98,59,1,123,59,1,1083,4,4,99,113,114,115,11828,11832,11845,11864,97,59,1,10550,117,111,4,2,59,114,11840,11842,1,8220,59,1,8222,4,2,100,117,11851,11857,104,97,114,59,1,10599,115,104,97,114,59,1,10571,104,59,1,8626,4,5,59,102,103,113,115,11880,11882,12008,12011,12031,1,8804,116,4,5,97,104,108,114,116,11895,11913,11935,11947,11996,114,114,111,119,4,2,59,116,11905,11907,1,8592,97,105,108,59,1,8610,97,114,112,111,111,110,4,2,100,117,11925,11931,111,119,110,59,1,8637,112,59,1,8636,101,102,116,97,114,114,111,119,115,59,1,8647,105,103,104,116,4,3,97,104,115,11959,11974,11984,114,114,111,119,4,2,59,115,11969,11971,1,8596,59,1,8646,97,114,112,111,111,110,115,59,1,8651,113,117,105,103,97,114,114,111,119,59,1,8621,104,114,101,101,116,105,109,101,115,59,1,8907,59,1,8922,4,3,59,113,115,12019,12021,12024,1,8804,59,1,8806,108,97,110,116,59,1,10877,4,5,59,99,100,103,115,12043,12045,12049,12070,12083,1,10877,99,59,1,10920,111,116,4,2,59,111,12057,12059,1,10879,4,2,59,114,12065,12067,1,10881,59,1,10883,4,2,59,101,12076,12079,3,8922,65024,115,59,1,10899,4,5,97,100,101,103,115,12095,12103,12108,12126,12131,112,112,114,111,120,59,1,10885,111,116,59,1,8918,113,4,2,103,113,12115,12120,116,114,59,1,8922,103,116,114,59,1,10891,116,114,59,1,8822,105,109,59,1,8818,4,3,105,108,114,12144,12150,12156,115,104,116,59,1,10620,111,111,114,59,1,8970,59,3,55349,56617,4,2,59,69,12166,12168,1,8822,59,1,10897,4,2,97,98,12177,12198,114,4,2,100,117,12184,12187,59,1,8637,4,2,59,108,12193,12195,1,8636,59,1,10602,108,107,59,1,9604,99,121,59,1,1113,4,5,59,97,99,104,116,12220,12222,12227,12235,12241,1,8810,114,114,59,1,8647,111,114,110,101,114,59,1,8990,97,114,100,59,1,10603,114,105,59,1,9722,4,2,105,111,12252,12258,100,111,116,59,1,320,117,115,116,4,2,59,97,12267,12269,1,9136,99,104,101,59,1,9136,4,4,69,97,101,115,12285,12288,12303,12322,59,1,8808,112,4,2,59,112,12295,12297,1,10889,114,111,120,59,1,10889,4,2,59,113,12309,12311,1,10887,4,2,59,113,12317,12319,1,10887,59,1,8808,105,109,59,1,8934,4,8,97,98,110,111,112,116,119,122,12345,12359,12364,12421,12446,12467,12474,12490,4,2,110,114,12351,12355,103,59,1,10220,114,59,1,8701,114,107,59,1,10214,103,4,3,108,109,114,12373,12401,12409,101,102,116,4,2,97,114,12382,12389,114,114,111,119,59,1,10229,105,103,104,116,97,114,114,111,119,59,1,10231,97,112,115,116,111,59,1,10236,105,103,104,116,97,114,114,111,119,59,1,10230,112,97,114,114,111,119,4,2,108,114,12433,12439,101,102,116,59,1,8619,105,103,104,116,59,1,8620,4,3,97,102,108,12454,12458,12462,114,59,1,10629,59,3,55349,56669,117,115,59,1,10797,105,109,101,115,59,1,10804,4,2,97,98,12480,12485,115,116,59,1,8727,97,114,59,1,95,4,3,59,101,102,12498,12500,12506,1,9674,110,103,101,59,1,9674,59,1,10731,97,114,4,2,59,108,12517,12519,1,40,116,59,1,10643,4,5,97,99,104,109,116,12535,12540,12548,12561,12564,114,114,59,1,8646,111,114,110,101,114,59,1,8991,97,114,4,2,59,100,12556,12558,1,8651,59,1,10605,59,1,8206,114,105,59,1,8895,4,6,97,99,104,105,113,116,12583,12589,12594,12597,12614,12635,113,117,111,59,1,8249,114,59,3,55349,56513,59,1,8624,109,4,3,59,101,103,12606,12608,12611,1,8818,59,1,10893,59,1,10895,4,2,98,117,12620,12623,59,1,91,111,4,2,59,114,12630,12632,1,8216,59,1,8218,114,111,107,59,1,322,5,60,8,59,99,100,104,105,108,113,114,12660,12662,12675,12680,12686,12692,12698,12705,1,60,4,2,99,105,12668,12671,59,1,10918,114,59,1,10873,111,116,59,1,8918,114,101,101,59,1,8907,109,101,115,59,1,8905,97,114,114,59,1,10614,117,101,115,116,59,1,10875,4,2,80,105,12711,12716,97,114,59,1,10646,4,3,59,101,102,12724,12726,12729,1,9667,59,1,8884,59,1,9666,114,4,2,100,117,12739,12746,115,104,97,114,59,1,10570,104,97,114,59,1,10598,4,2,101,110,12758,12768,114,116,110,101,113,113,59,3,8808,65024,69,59,3,8808,65024,4,14,68,97,99,100,101,102,104,105,108,110,111,112,115,117,12803,12809,12893,12908,12914,12928,12933,12937,13011,13025,13032,13049,13052,13069,68,111,116,59,1,8762,4,4,99,108,112,114,12819,12827,12849,12887,114,5,175,1,59,12825,1,175,4,2,101,116,12833,12836,59,1,9794,4,2,59,101,12842,12844,1,10016,115,101,59,1,10016,4,2,59,115,12855,12857,1,8614,116,111,4,4,59,100,108,117,12869,12871,12877,12883,1,8614,111,119,110,59,1,8615,101,102,116,59,1,8612,112,59,1,8613,107,101,114,59,1,9646,4,2,111,121,12899,12905,109,109,97,59,1,10793,59,1,1084,97,115,104,59,1,8212,97,115,117,114,101,100,97,110,103,108,101,59,1,8737,114,59,3,55349,56618,111,59,1,8487,4,3,99,100,110,12945,12954,12985,114,111,5,181,1,59,12952,1,181,4,4,59,97,99,100,12964,12966,12971,12976,1,8739,115,116,59,1,42,105,114,59,1,10992,111,116,5,183,1,59,12983,1,183,117,115,4,3,59,98,100,12995,12997,13000,1,8722,59,1,8863,4,2,59,117,13006,13008,1,8760,59,1,10794,4,2,99,100,13017,13021,112,59,1,10971,114,59,1,8230,112,108,117,115,59,1,8723,4,2,100,112,13038,13044,101,108,115,59,1,8871,102,59,3,55349,56670,59,1,8723,4,2,99,116,13058,13063,114,59,3,55349,56514,112,111,115,59,1,8766,4,3,59,108,109,13077,13079,13087,1,956,116,105,109,97,112,59,1,8888,97,112,59,1,8888,4,24,71,76,82,86,97,98,99,100,101,102,103,104,105,106,108,109,111,112,114,115,116,117,118,119,13142,13165,13217,13229,13247,13330,13359,13414,13420,13508,13513,13579,13602,13626,13631,13762,13767,13855,13936,13995,14214,14285,14312,14432,4,2,103,116,13148,13152,59,3,8921,824,4,2,59,118,13158,13161,3,8811,8402,59,3,8811,824,4,3,101,108,116,13173,13200,13204,102,116,4,2,97,114,13181,13188,114,114,111,119,59,1,8653,105,103,104,116,97,114,114,111,119,59,1,8654,59,3,8920,824,4,2,59,118,13210,13213,3,8810,8402,59,3,8810,824,105,103,104,116,97,114,114,111,119,59,1,8655,4,2,68,100,13235,13241,97,115,104,59,1,8879,97,115,104,59,1,8878,4,5,98,99,110,112,116,13259,13264,13270,13275,13308,108,97,59,1,8711,117,116,101,59,1,324,103,59,3,8736,8402,4,5,59,69,105,111,112,13287,13289,13293,13298,13302,1,8777,59,3,10864,824,100,59,3,8779,824,115,59,1,329,114,111,120,59,1,8777,117,114,4,2,59,97,13316,13318,1,9838,108,4,2,59,115,13325,13327,1,9838,59,1,8469,4,2,115,117,13336,13344,112,5,160,1,59,13342,1,160,109,112,4,2,59,101,13352,13355,3,8782,824,59,3,8783,824,4,5,97,101,111,117,121,13371,13385,13391,13407,13411,4,2,112,114,13377,13380,59,1,10819,111,110,59,1,328,100,105,108,59,1,326,110,103,4,2,59,100,13399,13401,1,8775,111,116,59,3,10861,824,112,59,1,10818,59,1,1085,97,115,104,59,1,8211,4,7,59,65,97,100,113,115,120,13436,13438,13443,13466,13472,13478,13494,1,8800,114,114,59,1,8663,114,4,2,104,114,13450,13454,107,59,1,10532,4,2,59,111,13460,13462,1,8599,119,59,1,8599,111,116,59,3,8784,824,117,105,118,59,1,8802,4,2,101,105,13484,13489,97,114,59,1,10536,109,59,3,8770,824,105,115,116,4,2,59,115,13503,13505,1,8708,59,1,8708,114,59,3,55349,56619,4,4,69,101,115,116,13523,13527,13563,13568,59,3,8807,824,4,3,59,113,115,13535,13537,13559,1,8817,4,3,59,113,115,13545,13547,13551,1,8817,59,3,8807,824,108,97,110,116,59,3,10878,824,59,3,10878,824,105,109,59,1,8821,4,2,59,114,13574,13576,1,8815,59,1,8815,4,3,65,97,112,13587,13592,13597,114,114,59,1,8654,114,114,59,1,8622,97,114,59,1,10994,4,3,59,115,118,13610,13612,13623,1,8715,4,2,59,100,13618,13620,1,8956,59,1,8954,59,1,8715,99,121,59,1,1114,4,7,65,69,97,100,101,115,116,13647,13652,13656,13661,13665,13737,13742,114,114,59,1,8653,59,3,8806,824,114,114,59,1,8602,114,59,1,8229,4,4,59,102,113,115,13675,13677,13703,13725,1,8816,116,4,2,97,114,13684,13691,114,114,111,119,59,1,8602,105,103,104,116,97,114,114,111,119,59,1,8622,4,3,59,113,115,13711,13713,13717,1,8816,59,3,8806,824,108,97,110,116,59,3,10877,824,4,2,59,115,13731,13734,3,10877,824,59,1,8814,105,109,59,1,8820,4,2,59,114,13748,13750,1,8814,105,4,2,59,101,13757,13759,1,8938,59,1,8940,105,100,59,1,8740,4,2,112,116,13773,13778,102,59,3,55349,56671,5,172,3,59,105,110,13787,13789,13829,1,172,110,4,4,59,69,100,118,13800,13802,13806,13812,1,8713,59,3,8953,824,111,116,59,3,8949,824,4,3,97,98,99,13820,13823,13826,59,1,8713,59,1,8951,59,1,8950,105,4,2,59,118,13836,13838,1,8716,4,3,97,98,99,13846,13849,13852,59,1,8716,59,1,8958,59,1,8957,4,3,97,111,114,13863,13892,13899,114,4,4,59,97,115,116,13874,13876,13883,13888,1,8742,108,108,101,108,59,1,8742,108,59,3,11005,8421,59,3,8706,824,108,105,110,116,59,1,10772,4,3,59,99,101,13907,13909,13914,1,8832,117,101,59,1,8928,4,2,59,99,13920,13923,3,10927,824,4,2,59,101,13929,13931,1,8832,113,59,3,10927,824,4,4,65,97,105,116,13946,13951,13971,13982,114,114,59,1,8655,114,114,4,3,59,99,119,13961,13963,13967,1,8603,59,3,10547,824,59,3,8605,824,103,104,116,97,114,114,111,119,59,1,8603,114,105,4,2,59,101,13990,13992,1,8939,59,1,8941,4,7,99,104,105,109,112,113,117,14011,14036,14060,14080,14085,14090,14106,4,4,59,99,101,114,14021,14023,14028,14032,1,8833,117,101,59,1,8929,59,3,10928,824,59,3,55349,56515,111,114,116,4,2,109,112,14045,14050,105,100,59,1,8740,97,114,97,108,108,101,108,59,1,8742,109,4,2,59,101,14067,14069,1,8769,4,2,59,113,14075,14077,1,8772,59,1,8772,105,100,59,1,8740,97,114,59,1,8742,115,117,4,2,98,112,14098,14102,101,59,1,8930,101,59,1,8931,4,3,98,99,112,14114,14157,14171,4,4,59,69,101,115,14124,14126,14130,14133,1,8836,59,3,10949,824,59,1,8840,101,116,4,2,59,101,14141,14144,3,8834,8402,113,4,2,59,113,14151,14153,1,8840,59,3,10949,824,99,4,2,59,101,14164,14166,1,8833,113,59,3,10928,824,4,4,59,69,101,115,14181,14183,14187,14190,1,8837,59,3,10950,824,59,1,8841,101,116,4,2,59,101,14198,14201,3,8835,8402,113,4,2,59,113,14208,14210,1,8841,59,3,10950,824,4,4,103,105,108,114,14224,14228,14238,14242,108,59,1,8825,108,100,101,5,241,1,59,14236,1,241,103,59,1,8824,105,97,110,103,108,101,4,2,108,114,14254,14269,101,102,116,4,2,59,101,14263,14265,1,8938,113,59,1,8940,105,103,104,116,4,2,59,101,14279,14281,1,8939,113,59,1,8941,4,2,59,109,14291,14293,1,957,4,3,59,101,115,14301,14303,14308,1,35,114,111,59,1,8470,112,59,1,8199,4,9,68,72,97,100,103,105,108,114,115,14332,14338,14344,14349,14355,14369,14376,14408,14426,97,115,104,59,1,8877,97,114,114,59,1,10500,112,59,3,8781,8402,97,115,104,59,1,8876,4,2,101,116,14361,14365,59,3,8805,8402,59,3,62,8402,110,102,105,110,59,1,10718,4,3,65,101,116,14384,14389,14393,114,114,59,1,10498,59,3,8804,8402,4,2,59,114,14399,14402,3,60,8402,105,101,59,3,8884,8402,4,2,65,116,14414,14419,114,114,59,1,10499,114,105,101,59,3,8885,8402,105,109,59,3,8764,8402,4,3,65,97,110,14440,14445,14468,114,114,59,1,8662,114,4,2,104,114,14452,14456,107,59,1,10531,4,2,59,111,14462,14464,1,8598,119,59,1,8598,101,97,114,59,1,10535,4,18,83,97,99,100,101,102,103,104,105,108,109,111,112,114,115,116,117,118,14512,14515,14535,14560,14597,14603,14618,14643,14657,14662,14701,14741,14747,14769,14851,14877,14907,14916,59,1,9416,4,2,99,115,14521,14531,117,116,101,5,243,1,59,14529,1,243,116,59,1,8859,4,2,105,121,14541,14557,114,4,2,59,99,14548,14550,1,8858,5,244,1,59,14555,1,244,59,1,1086,4,5,97,98,105,111,115,14572,14577,14583,14587,14591,115,104,59,1,8861,108,97,99,59,1,337,118,59,1,10808,116,59,1,8857,111,108,100,59,1,10684,108,105,103,59,1,339,4,2,99,114,14609,14614,105,114,59,1,10687,59,3,55349,56620,4,3,111,114,116,14626,14630,14640,110,59,1,731,97,118,101,5,242,1,59,14638,1,242,59,1,10689,4,2,98,109,14649,14654,97,114,59,1,10677,59,1,937,110,116,59,1,8750,4,4,97,99,105,116,14672,14677,14693,14698,114,114,59,1,8634,4,2,105,114,14683,14687,114,59,1,10686,111,115,115,59,1,10683,110,101,59,1,8254,59,1,10688,4,3,97,101,105,14709,14714,14719,99,114,59,1,333,103,97,59,1,969,4,3,99,100,110,14727,14733,14736,114,111,110,59,1,959,59,1,10678,117,115,59,1,8854,112,102,59,3,55349,56672,4,3,97,101,108,14755,14759,14764,114,59,1,10679,114,112,59,1,10681,117,115,59,1,8853,4,7,59,97,100,105,111,115,118,14785,14787,14792,14831,14837,14841,14848,1,8744,114,114,59,1,8635,4,4,59,101,102,109,14802,14804,14817,14824,1,10845,114,4,2,59,111,14811,14813,1,8500,102,59,1,8500,5,170,1,59,14822,1,170,5,186,1,59,14829,1,186,103,111,102,59,1,8886,114,59,1,10838,108,111,112,101,59,1,10839,59,1,10843,4,3,99,108,111,14859,14863,14873,114,59,1,8500,97,115,104,5,248,1,59,14871,1,248,108,59,1,8856,105,4,2,108,109,14884,14893,100,101,5,245,1,59,14891,1,245,101,115,4,2,59,97,14901,14903,1,8855,115,59,1,10806,109,108,5,246,1,59,14914,1,246,98,97,114,59,1,9021,4,12,97,99,101,102,104,105,108,109,111,114,115,117,14948,14992,14996,15033,15038,15068,15090,15189,15192,15222,15427,15441,114,4,4,59,97,115,116,14959,14961,14976,14989,1,8741,5,182,2,59,108,14968,14970,1,182,108,101,108,59,1,8741,4,2,105,108,14982,14986,109,59,1,10995,59,1,11005,59,1,8706,121,59,1,1087,114,4,5,99,105,109,112,116,15009,15014,15019,15024,15027,110,116,59,1,37,111,100,59,1,46,105,108,59,1,8240,59,1,8869,101,110,107,59,1,8241,114,59,3,55349,56621,4,3,105,109,111,15046,15057,15063,4,2,59,118,15052,15054,1,966,59,1,981,109,97,116,59,1,8499,110,101,59,1,9742,4,3,59,116,118,15076,15078,15087,1,960,99,104,102,111,114,107,59,1,8916,59,1,982,4,2,97,117,15096,15119,110,4,2,99,107,15103,15115,107,4,2,59,104,15110,15112,1,8463,59,1,8462,118,59,1,8463,115,4,9,59,97,98,99,100,101,109,115,116,15140,15142,15148,15151,15156,15168,15171,15179,15184,1,43,99,105,114,59,1,10787,59,1,8862,105,114,59,1,10786,4,2,111,117,15162,15165,59,1,8724,59,1,10789,59,1,10866,110,5,177,1,59,15177,1,177,105,109,59,1,10790,119,111,59,1,10791,59,1,177,4,3,105,112,117,15200,15208,15213,110,116,105,110,116,59,1,10773,102,59,3,55349,56673,110,100,5,163,1,59,15220,1,163,4,10,59,69,97,99,101,105,110,111,115,117,15244,15246,15249,15253,15258,15334,15347,15367,15416,15421,1,8826,59,1,10931,112,59,1,10935,117,101,59,1,8828,4,2,59,99,15264,15266,1,10927,4,6,59,97,99,101,110,115,15280,15282,15290,15299,15303,15329,1,8826,112,112,114,111,120,59,1,10935,117,114,108,121,101,113,59,1,8828,113,59,1,10927,4,3,97,101,115,15311,15319,15324,112,112,114,111,120,59,1,10937,113,113,59,1,10933,105,109,59,1,8936,105,109,59,1,8830,109,101,4,2,59,115,15342,15344,1,8242,59,1,8473,4,3,69,97,115,15355,15358,15362,59,1,10933,112,59,1,10937,105,109,59,1,8936,4,3,100,102,112,15375,15378,15404,59,1,8719,4,3,97,108,115,15386,15392,15398,108,97,114,59,1,9006,105,110,101,59,1,8978,117,114,102,59,1,8979,4,2,59,116,15410,15412,1,8733,111,59,1,8733,105,109,59,1,8830,114,101,108,59,1,8880,4,2,99,105,15433,15438,114,59,3,55349,56517,59,1,968,110,99,115,112,59,1,8200,4,6,102,105,111,112,115,117,15462,15467,15472,15478,15485,15491,114,59,3,55349,56622,110,116,59,1,10764,112,102,59,3,55349,56674,114,105,109,101,59,1,8279,99,114,59,3,55349,56518,4,3,97,101,111,15499,15520,15534,116,4,2,101,105,15506,15515,114,110,105,111,110,115,59,1,8461,110,116,59,1,10774,115,116,4,2,59,101,15528,15530,1,63,113,59,1,8799,116,5,34,1,59,15540,1,34,4,21,65,66,72,97,98,99,100,101,102,104,105,108,109,110,111,112,114,115,116,117,120,15586,15609,15615,15620,15796,15855,15893,15931,15977,16001,16039,16183,16204,16222,16228,16285,16312,16318,16363,16408,16416,4,3,97,114,116,15594,15599,15603,114,114,59,1,8667,114,59,1,8658,97,105,108,59,1,10524,97,114,114,59,1,10511,97,114,59,1,10596,4,7,99,100,101,110,113,114,116,15636,15651,15656,15664,15687,15696,15770,4,2,101,117,15642,15646,59,3,8765,817,116,101,59,1,341,105,99,59,1,8730,109,112,116,121,118,59,1,10675,103,4,4,59,100,101,108,15675,15677,15680,15683,1,10217,59,1,10642,59,1,10661,101,59,1,10217,117,111,5,187,1,59,15694,1,187,114,4,11,59,97,98,99,102,104,108,112,115,116,119,15721,15723,15727,15739,15742,15746,15750,15754,15758,15763,15767,1,8594,112,59,1,10613,4,2,59,102,15733,15735,1,8677,115,59,1,10528,59,1,10547,115,59,1,10526,107,59,1,8618,112,59,1,8620,108,59,1,10565,105,109,59,1,10612,108,59,1,8611,59,1,8605,4,2,97,105,15776,15781,105,108,59,1,10522,111,4,2,59,110,15788,15790,1,8758,97,108,115,59,1,8474,4,3,97,98,114,15804,15809,15814,114,114,59,1,10509,114,107,59,1,10099,4,2,97,107,15820,15833,99,4,2,101,107,15827,15830,59,1,125,59,1,93,4,2,101,115,15839,15842,59,1,10636,108,4,2,100,117,15849,15852,59,1,10638,59,1,10640,4,4,97,101,117,121,15865,15871,15886,15890,114,111,110,59,1,345,4,2,100,105,15877,15882,105,108,59,1,343,108,59,1,8969,98,59,1,125,59,1,1088,4,4,99,108,113,115,15903,15907,15914,15927,97,59,1,10551,100,104,97,114,59,1,10601,117,111,4,2,59,114,15922,15924,1,8221,59,1,8221,104,59,1,8627,4,3,97,99,103,15939,15966,15970,108,4,4,59,105,112,115,15950,15952,15957,15963,1,8476,110,101,59,1,8475,97,114,116,59,1,8476,59,1,8477,116,59,1,9645,5,174,1,59,15975,1,174,4,3,105,108,114,15985,15991,15997,115,104,116,59,1,10621,111,111,114,59,1,8971,59,3,55349,56623,4,2,97,111,16007,16028,114,4,2,100,117,16014,16017,59,1,8641,4,2,59,108,16023,16025,1,8640,59,1,10604,4,2,59,118,16034,16036,1,961,59,1,1009,4,3,103,110,115,16047,16167,16171,104,116,4,6,97,104,108,114,115,116,16063,16081,16103,16130,16143,16155,114,114,111,119,4,2,59,116,16073,16075,1,8594,97,105,108,59,1,8611,97,114,112,111,111,110,4,2,100,117,16093,16099,111,119,110,59,1,8641,112,59,1,8640,101,102,116,4,2,97,104,16112,16120,114,114,111,119,115,59,1,8644,97,114,112,111,111,110,115,59,1,8652,105,103,104,116,97,114,114,111,119,115,59,1,8649,113,117,105,103,97,114,114,111,119,59,1,8605,104,114,101,101,116,105,109,101,115,59,1,8908,103,59,1,730,105,110,103,100,111,116,115,101,113,59,1,8787,4,3,97,104,109,16191,16196,16201,114,114,59,1,8644,97,114,59,1,8652,59,1,8207,111,117,115,116,4,2,59,97,16214,16216,1,9137,99,104,101,59,1,9137,109,105,100,59,1,10990,4,4,97,98,112,116,16238,16252,16257,16278,4,2,110,114,16244,16248,103,59,1,10221,114,59,1,8702,114,107,59,1,10215,4,3,97,102,108,16265,16269,16273,114,59,1,10630,59,3,55349,56675,117,115,59,1,10798,105,109,101,115,59,1,10805,4,2,97,112,16291,16304,114,4,2,59,103,16298,16300,1,41,116,59,1,10644,111,108,105,110,116,59,1,10770,97,114,114,59,1,8649,4,4,97,99,104,113,16328,16334,16339,16342,113,117,111,59,1,8250,114,59,3,55349,56519,59,1,8625,4,2,98,117,16348,16351,59,1,93,111,4,2,59,114,16358,16360,1,8217,59,1,8217,4,3,104,105,114,16371,16377,16383,114,101,101,59,1,8908,109,101,115,59,1,8906,105,4,4,59,101,102,108,16394,16396,16399,16402,1,9657,59,1,8885,59,1,9656,116,114,105,59,1,10702,108,117,104,97,114,59,1,10600,59,1,8478,4,19,97,98,99,100,101,102,104,105,108,109,111,112,113,114,115,116,117,119,122,16459,16466,16472,16572,16590,16672,16687,16746,16844,16850,16924,16963,16988,17115,17121,17154,17206,17614,17656,99,117,116,101,59,1,347,113,117,111,59,1,8218,4,10,59,69,97,99,101,105,110,112,115,121,16494,16496,16499,16513,16518,16531,16536,16556,16564,16569,1,8827,59,1,10932,4,2,112,114,16505,16508,59,1,10936,111,110,59,1,353,117,101,59,1,8829,4,2,59,100,16524,16526,1,10928,105,108,59,1,351,114,99,59,1,349,4,3,69,97,115,16544,16547,16551,59,1,10934,112,59,1,10938,105,109,59,1,8937,111,108,105,110,116,59,1,10771,105,109,59,1,8831,59,1,1089,111,116,4,3,59,98,101,16582,16584,16587,1,8901,59,1,8865,59,1,10854,4,7,65,97,99,109,115,116,120,16606,16611,16634,16642,16646,16652,16668,114,114,59,1,8664,114,4,2,104,114,16618,16622,107,59,1,10533,4,2,59,111,16628,16630,1,8600,119,59,1,8600,116,5,167,1,59,16640,1,167,105,59,1,59,119,97,114,59,1,10537,109,4,2,105,110,16659,16665,110,117,115,59,1,8726,59,1,8726,116,59,1,10038,114,4,2,59,111,16679,16682,3,55349,56624,119,110,59,1,8994,4,4,97,99,111,121,16697,16702,16716,16739,114,112,59,1,9839,4,2,104,121,16708,16713,99,121,59,1,1097,59,1,1096,114,116,4,2,109,112,16724,16729,105,100,59,1,8739,97,114,97,108,108,101,108,59,1,8741,5,173,1,59,16744,1,173,4,2,103,109,16752,16770,109,97,4,3,59,102,118,16762,16764,16767,1,963,59,1,962,59,1,962,4,8,59,100,101,103,108,110,112,114,16788,16790,16795,16806,16817,16828,16832,16838,1,8764,111,116,59,1,10858,4,2,59,113,16801,16803,1,8771,59,1,8771,4,2,59,69,16812,16814,1,10910,59,1,10912,4,2,59,69,16823,16825,1,10909,59,1,10911,101,59,1,8774,108,117,115,59,1,10788,97,114,114,59,1,10610,97,114,114,59,1,8592,4,4,97,101,105,116,16860,16883,16891,16904,4,2,108,115,16866,16878,108,115,101,116,109,105,110,117,115,59,1,8726,104,112,59,1,10803,112,97,114,115,108,59,1,10724,4,2,100,108,16897,16900,59,1,8739,101,59,1,8995,4,2,59,101,16910,16912,1,10922,4,2,59,115,16918,16920,1,10924,59,3,10924,65024,4,3,102,108,112,16932,16938,16958,116,99,121,59,1,1100,4,2,59,98,16944,16946,1,47,4,2,59,97,16952,16954,1,10692,114,59,1,9023,102,59,3,55349,56676,97,4,2,100,114,16970,16985,101,115,4,2,59,117,16978,16980,1,9824,105,116,59,1,9824,59,1,8741,4,3,99,115,117,16996,17028,17089,4,2,97,117,17002,17015,112,4,2,59,115,17009,17011,1,8851,59,3,8851,65024,112,4,2,59,115,17022,17024,1,8852,59,3,8852,65024,117,4,2,98,112,17035,17062,4,3,59,101,115,17043,17045,17048,1,8847,59,1,8849,101,116,4,2,59,101,17056,17058,1,8847,113,59,1,8849,4,3,59,101,115,17070,17072,17075,1,8848,59,1,8850,101,116,4,2,59,101,17083,17085,1,8848,113,59,1,8850,4,3,59,97,102,17097,17099,17112,1,9633,114,4,2,101,102,17106,17109,59,1,9633,59,1,9642,59,1,9642,97,114,114,59,1,8594,4,4,99,101,109,116,17131,17136,17142,17148,114,59,3,55349,56520,116,109,110,59,1,8726,105,108,101,59,1,8995,97,114,102,59,1,8902,4,2,97,114,17160,17172,114,4,2,59,102,17167,17169,1,9734,59,1,9733,4,2,97,110,17178,17202,105,103,104,116,4,2,101,112,17188,17197,112,115,105,108,111,110,59,1,1013,104,105,59,1,981,115,59,1,175,4,5,98,99,109,110,112,17218,17351,17420,17423,17427,4,9,59,69,100,101,109,110,112,114,115,17238,17240,17243,17248,17261,17267,17279,17285,17291,1,8834,59,1,10949,111,116,59,1,10941,4,2,59,100,17254,17256,1,8838,111,116,59,1,10947,117,108,116,59,1,10945,4,2,69,101,17273,17276,59,1,10955,59,1,8842,108,117,115,59,1,10943,97,114,114,59,1,10617,4,3,101,105,117,17299,17335,17339,116,4,3,59,101,110,17308,17310,17322,1,8834,113,4,2,59,113,17317,17319,1,8838,59,1,10949,101,113,4,2,59,113,17330,17332,1,8842,59,1,10955,109,59,1,10951,4,2,98,112,17345,17348,59,1,10965,59,1,10963,99,4,6,59,97,99,101,110,115,17366,17368,17376,17385,17389,17415,1,8827,112,112,114,111,120,59,1,10936,117,114,108,121,101,113,59,1,8829,113,59,1,10928,4,3,97,101,115,17397,17405,17410,112,112,114,111,120,59,1,10938,113,113,59,1,10934,105,109,59,1,8937,105,109,59,1,8831,59,1,8721,103,59,1,9834,4,13,49,50,51,59,69,100,101,104,108,109,110,112,115,17455,17462,17469,17476,17478,17481,17496,17509,17524,17530,17536,17548,17554,5,185,1,59,17460,1,185,5,178,1,59,17467,1,178,5,179,1,59,17474,1,179,1,8835,59,1,10950,4,2,111,115,17487,17491,116,59,1,10942,117,98,59,1,10968,4,2,59,100,17502,17504,1,8839,111,116,59,1,10948,115,4,2,111,117,17516,17520,108,59,1,10185,98,59,1,10967,97,114,114,59,1,10619,117,108,116,59,1,10946,4,2,69,101,17542,17545,59,1,10956,59,1,8843,108,117,115,59,1,10944,4,3,101,105,117,17562,17598,17602,116,4,3,59,101,110,17571,17573,17585,1,8835,113,4,2,59,113,17580,17582,1,8839,59,1,10950,101,113,4,2,59,113,17593,17595,1,8843,59,1,10956,109,59,1,10952,4,2,98,112,17608,17611,59,1,10964,59,1,10966,4,3,65,97,110,17622,17627,17650,114,114,59,1,8665,114,4,2,104,114,17634,17638,107,59,1,10534,4,2,59,111,17644,17646,1,8601,119,59,1,8601,119,97,114,59,1,10538,108,105,103,5,223,1,59,17664,1,223,4,13,97,98,99,100,101,102,104,105,111,112,114,115,119,17694,17709,17714,17737,17742,17749,17754,17860,17905,17957,17964,18090,18122,4,2,114,117,17700,17706,103,101,116,59,1,8982,59,1,964,114,107,59,1,9140,4,3,97,101,121,17722,17728,17734,114,111,110,59,1,357,100,105,108,59,1,355,59,1,1090,111,116,59,1,8411,108,114,101,99,59,1,8981,114,59,3,55349,56625,4,4,101,105,107,111,17764,17805,17836,17851,4,2,114,116,17770,17786,101,4,2,52,102,17777,17780,59,1,8756,111,114,101,59,1,8756,97,4,3,59,115,118,17795,17797,17802,1,952,121,109,59,1,977,59,1,977,4,2,99,110,17811,17831,107,4,2,97,115,17818,17826,112,112,114,111,120,59,1,8776,105,109,59,1,8764,115,112,59,1,8201,4,2,97,115,17842,17846,112,59,1,8776,105,109,59,1,8764,114,110,5,254,1,59,17858,1,254,4,3,108,109,110,17868,17873,17901,100,101,59,1,732,101,115,5,215,3,59,98,100,17884,17886,17898,1,215,4,2,59,97,17892,17894,1,8864,114,59,1,10801,59,1,10800,116,59,1,8749,4,3,101,112,115,17913,17917,17953,97,59,1,10536,4,4,59,98,99,102,17927,17929,17934,17939,1,8868,111,116,59,1,9014,105,114,59,1,10993,4,2,59,111,17945,17948,3,55349,56677,114,107,59,1,10970,97,59,1,10537,114,105,109,101,59,1,8244,4,3,97,105,112,17972,17977,18082,100,101,59,1,8482,4,7,97,100,101,109,112,115,116,17993,18051,18056,18059,18066,18072,18076,110,103,108,101,4,5,59,100,108,113,114,18009,18011,18017,18032,18035,1,9653,111,119,110,59,1,9663,101,102,116,4,2,59,101,18026,18028,1,9667,113,59,1,8884,59,1,8796,105,103,104,116,4,2,59,101,18045,18047,1,9657,113,59,1,8885,111,116,59,1,9708,59,1,8796,105,110,117,115,59,1,10810,108,117,115,59,1,10809,98,59,1,10701,105,109,101,59,1,10811,101,122,105,117,109,59,1,9186,4,3,99,104,116,18098,18111,18116,4,2,114,121,18104,18108,59,3,55349,56521,59,1,1094,99,121,59,1,1115,114,111,107,59,1,359,4,2,105,111,18128,18133,120,116,59,1,8812,104,101,97,100,4,2,108,114,18143,18154,101,102,116,97,114,114,111,119,59,1,8606,105,103,104,116,97,114,114,111,119,59,1,8608,4,18,65,72,97,98,99,100,102,103,104,108,109,111,112,114,115,116,117,119,18204,18209,18214,18234,18250,18268,18292,18308,18319,18343,18379,18397,18413,18504,18547,18553,18584,18603,114,114,59,1,8657,97,114,59,1,10595,4,2,99,114,18220,18230,117,116,101,5,250,1,59,18228,1,250,114,59,1,8593,114,4,2,99,101,18241,18245,121,59,1,1118,118,101,59,1,365,4,2,105,121,18256,18265,114,99,5,251,1,59,18263,1,251,59,1,1091,4,3,97,98,104,18276,18281,18287,114,114,59,1,8645,108,97,99,59,1,369,97,114,59,1,10606,4,2,105,114,18298,18304,115,104,116,59,1,10622,59,3,55349,56626,114,97,118,101,5,249,1,59,18317,1,249,4,2,97,98,18325,18338,114,4,2,108,114,18332,18335,59,1,8639,59,1,8638,108,107,59,1,9600,4,2,99,116,18349,18374,4,2,111,114,18355,18369,114,110,4,2,59,101,18363,18365,1,8988,114,59,1,8988,111,112,59,1,8975,114,105,59,1,9720,4,2,97,108,18385,18390,99,114,59,1,363,5,168,1,59,18395,1,168,4,2,103,112,18403,18408,111,110,59,1,371,102,59,3,55349,56678,4,6,97,100,104,108,115,117,18427,18434,18445,18470,18475,18494,114,114,111,119,59,1,8593,111,119,110,97,114,114,111,119,59,1,8597,97,114,112,111,111,110,4,2,108,114,18457,18463,101,102,116,59,1,8639,105,103,104,116,59,1,8638,117,115,59,1,8846,105,4,3,59,104,108,18484,18486,18489,1,965,59,1,978,111,110,59,1,965,112,97,114,114,111,119,115,59,1,8648,4,3,99,105,116,18512,18537,18542,4,2,111,114,18518,18532,114,110,4,2,59,101,18526,18528,1,8989,114,59,1,8989,111,112,59,1,8974,110,103,59,1,367,114,105,59,1,9721,99,114,59,3,55349,56522,4,3,100,105,114,18561,18566,18572,111,116,59,1,8944,108,100,101,59,1,361,105,4,2,59,102,18579,18581,1,9653,59,1,9652,4,2,97,109,18590,18595,114,114,59,1,8648,108,5,252,1,59,18601,1,252,97,110,103,108,101,59,1,10663,4,15,65,66,68,97,99,100,101,102,108,110,111,112,114,115,122,18643,18648,18661,18667,18847,18851,18857,18904,18909,18915,18931,18937,18943,18949,18996,114,114,59,1,8661,97,114,4,2,59,118,18656,18658,1,10984,59,1,10985,97,115,104,59,1,8872,4,2,110,114,18673,18679,103,114,116,59,1,10652,4,7,101,107,110,112,114,115,116,18695,18704,18711,18720,18742,18754,18810,112,115,105,108,111,110,59,1,1013,97,112,112,97,59,1,1008,111,116,104,105,110,103,59,1,8709,4,3,104,105,114,18728,18732,18735,105,59,1,981,59,1,982,111,112,116,111,59,1,8733,4,2,59,104,18748,18750,1,8597,111,59,1,1009,4,2,105,117,18760,18766,103,109,97,59,1,962,4,2,98,112,18772,18791,115,101,116,110,101,113,4,2,59,113,18784,18787,3,8842,65024,59,3,10955,65024,115,101,116,110,101,113,4,2,59,113,18803,18806,3,8843,65024,59,3,10956,65024,4,2,104,114,18816,18822,101,116,97,59,1,977,105,97,110,103,108,101,4,2,108,114,18834,18840,101,102,116,59,1,8882,105,103,104,116,59,1,8883,121,59,1,1074,97,115,104,59,1,8866,4,3,101,108,114,18865,18884,18890,4,3,59,98,101,18873,18875,18880,1,8744,97,114,59,1,8891,113,59,1,8794,108,105,112,59,1,8942,4,2,98,116,18896,18901,97,114,59,1,124,59,1,124,114,59,3,55349,56627,116,114,105,59,1,8882,115,117,4,2,98,112,18923,18927,59,3,8834,8402,59,3,8835,8402,112,102,59,3,55349,56679,114,111,112,59,1,8733,116,114,105,59,1,8883,4,2,99,117,18955,18960,114,59,3,55349,56523,4,2,98,112,18966,18981,110,4,2,69,101,18973,18977,59,3,10955,65024,59,3,8842,65024,110,4,2,69,101,18988,18992,59,3,10956,65024,59,3,8843,65024,105,103,122,97,103,59,1,10650,4,7,99,101,102,111,112,114,115,19020,19026,19061,19066,19072,19075,19089,105,114,99,59,1,373,4,2,100,105,19032,19055,4,2,98,103,19038,19043,97,114,59,1,10847,101,4,2,59,113,19050,19052,1,8743,59,1,8793,101,114,112,59,1,8472,114,59,3,55349,56628,112,102,59,3,55349,56680,59,1,8472,4,2,59,101,19081,19083,1,8768,97,116,104,59,1,8768,99,114,59,3,55349,56524,4,14,99,100,102,104,105,108,109,110,111,114,115,117,118,119,19125,19146,19152,19157,19173,19176,19192,19197,19202,19236,19252,19269,19286,19291,4,3,97,105,117,19133,19137,19142,112,59,1,8898,114,99,59,1,9711,112,59,1,8899,116,114,105,59,1,9661,114,59,3,55349,56629,4,2,65,97,19163,19168,114,114,59,1,10234,114,114,59,1,10231,59,1,958,4,2,65,97,19182,19187,114,114,59,1,10232,114,114,59,1,10229,97,112,59,1,10236,105,115,59,1,8955,4,3,100,112,116,19210,19215,19230,111,116,59,1,10752,4,2,102,108,19221,19225,59,3,55349,56681,117,115,59,1,10753,105,109,101,59,1,10754,4,2,65,97,19242,19247,114,114,59,1,10233,114,114,59,1,10230,4,2,99,113,19258,19263,114,59,3,55349,56525,99,117,112,59,1,10758,4,2,112,116,19275,19281,108,117,115,59,1,10756,114,105,59,1,9651,101,101,59,1,8897,101,100,103,101,59,1,8896,4,8,97,99,101,102,105,111,115,117,19316,19335,19349,19357,19362,19367,19373,19379,99,4,2,117,121,19323,19332,116,101,5,253,1,59,19330,1,253,59,1,1103,4,2,105,121,19341,19346,114,99,59,1,375,59,1,1099,110,5,165,1,59,19355,1,165,114,59,3,55349,56630,99,121,59,1,1111,112,102,59,3,55349,56682,99,114,59,3,55349,56526,4,2,99,109,19385,19389,121,59,1,1102,108,5,255,1,59,19395,1,255,4,10,97,99,100,101,102,104,105,111,115,119,19419,19426,19441,19446,19462,19467,19472,19480,19486,19492,99,117,116,101,59,1,378,4,2,97,121,19432,19438,114,111,110,59,1,382,59,1,1079,111,116,59,1,380,4,2,101,116,19452,19458,116,114,102,59,1,8488,97,59,1,950,114,59,3,55349,56631,99,121,59,1,1078,103,114,97,114,114,59,1,8669,112,102,59,3,55349,56683,99,114,59,3,55349,56527,4,2,106,110,19498,19501,59,1,8205,106,59,1,8204]);

/***/ }),
/* 4374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var UNICODE = __webpack_require__(234);
	
	//Aliases
	var $ = UNICODE.CODE_POINTS;
	
	//Utils
	
	//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
	//this functions if they will be situated in another module due to context switch.
	//Always perform inlining check before modifying this functions ('node --trace-inlining').
	function isSurrogatePair(cp1, cp2) {
	    return cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF;
	}
	
	function getSurrogatePairCodePoint(cp1, cp2) {
	    return (cp1 - 0xD800) * 0x400 + 0x2400 + cp2;
	}
	
	
	//Const
	var DEFAULT_BUFFER_WATERLINE = 1 << 16;
	
	
	//Preprocessor
	//NOTE: HTML input preprocessing
	//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/parsing.html#preprocessing-the-input-stream)
	var Preprocessor = module.exports = function () {
	    this.html = null;
	
	    this.pos = -1;
	    this.lastGapPos = -1;
	    this.lastCharPos = -1;
	
	    this.gapStack = [];
	
	    this.skipNextNewLine = false;
	
	    this.lastChunkWritten = false;
	    this.endOfChunkHit = false;
	    this.bufferWaterline = DEFAULT_BUFFER_WATERLINE;
	};
	
	Preprocessor.prototype.dropParsedChunk = function () {
	    if (this.pos > this.bufferWaterline) {
	        this.lastCharPos -= this.pos;
	        this.html = this.html.substring(this.pos);
	        this.pos = 0;
	        this.lastGapPos = -1;
	        this.gapStack = [];
	    }
	};
	
	Preprocessor.prototype._addGap = function () {
	    this.gapStack.push(this.lastGapPos);
	    this.lastGapPos = this.pos;
	};
	
	Preprocessor.prototype._processHighRangeCodePoint = function (cp) {
	    //NOTE: try to peek a surrogate pair
	    if (this.pos !== this.lastCharPos) {
	        var nextCp = this.html.charCodeAt(this.pos + 1);
	
	        if (isSurrogatePair(cp, nextCp)) {
	            //NOTE: we have a surrogate pair. Peek pair character and recalculate code point.
	            this.pos++;
	            cp = getSurrogatePairCodePoint(cp, nextCp);
	
	            //NOTE: add gap that should be avoided during retreat
	            this._addGap();
	        }
	    }
	
	    // NOTE: we've hit the end of chunk, stop processing at this point
	    else if (!this.lastChunkWritten) {
	        this.endOfChunkHit = true;
	        return $.EOF;
	    }
	
	    return cp;
	};
	
	Preprocessor.prototype.write = function (chunk, isLastChunk) {
	    if (this.html)
	        this.html += chunk;
	
	    else
	        this.html = chunk;
	
	    this.lastCharPos = this.html.length - 1;
	    this.endOfChunkHit = false;
	    this.lastChunkWritten = isLastChunk;
	};
	
	Preprocessor.prototype.insertHtmlAtCurrentPos = function (chunk) {
	    this.html = this.html.substring(0, this.pos + 1) +
	                chunk +
	                this.html.substring(this.pos + 1, this.html.length);
	
	    this.lastCharPos = this.html.length - 1;
	    this.endOfChunkHit = false;
	};
	
	
	Preprocessor.prototype.advance = function () {
	    this.pos++;
	
	    if (this.pos > this.lastCharPos) {
	        if (!this.lastChunkWritten)
	            this.endOfChunkHit = true;
	
	        return $.EOF;
	    }
	
	    var cp = this.html.charCodeAt(this.pos);
	
	    //NOTE: any U+000A LINE FEED (LF) characters that immediately follow a U+000D CARRIAGE RETURN (CR) character
	    //must be ignored.
	    if (this.skipNextNewLine && cp === $.LINE_FEED) {
	        this.skipNextNewLine = false;
	        this._addGap();
	        return this.advance();
	    }
	
	    //NOTE: all U+000D CARRIAGE RETURN (CR) characters must be converted to U+000A LINE FEED (LF) characters
	    if (cp === $.CARRIAGE_RETURN) {
	        this.skipNextNewLine = true;
	        return $.LINE_FEED;
	    }
	
	    this.skipNextNewLine = false;
	
	    //OPTIMIZATION: first perform check if the code point in the allowed range that covers most common
	    //HTML input (e.g. ASCII codes) to avoid performance-cost operations for high-range code points.
	    return cp >= 0xD800 ? this._processHighRangeCodePoint(cp) : cp;
	};
	
	Preprocessor.prototype.retreat = function () {
	    if (this.pos === this.lastGapPos) {
	        this.lastGapPos = this.gapStack.pop();
	        this.pos--;
	    }
	
	    this.pos--;
	};
	


/***/ }),
/* 4375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var doctype = __webpack_require__(481),
	    DOCUMENT_MODE = __webpack_require__(77).DOCUMENT_MODE;
	
	
	//Conversion tables for DOM Level1 structure emulation
	var nodeTypes = {
	    element: 1,
	    text: 3,
	    cdata: 4,
	    comment: 8
	};
	
	var nodePropertyShorthands = {
	    tagName: 'name',
	    childNodes: 'children',
	    parentNode: 'parent',
	    previousSibling: 'prev',
	    nextSibling: 'next',
	    nodeValue: 'data'
	};
	
	//Node
	var Node = function (props) {
	    for (var key in props) {
	        if (props.hasOwnProperty(key))
	            this[key] = props[key];
	    }
	};
	
	Node.prototype = {
	    get firstChild() {
	        var children = this.children;
	
	        return children && children[0] || null;
	    },
	
	    get lastChild() {
	        var children = this.children;
	
	        return children && children[children.length - 1] || null;
	    },
	
	    get nodeType() {
	        return nodeTypes[this.type] || nodeTypes.element;
	    }
	};
	
	Object.keys(nodePropertyShorthands).forEach(function (key) {
	    var shorthand = nodePropertyShorthands[key];
	
	    Object.defineProperty(Node.prototype, key, {
	        get: function () {
	            return this[shorthand] || null;
	        },
	        set: function (val) {
	            this[shorthand] = val;
	            return val;
	        }
	    });
	});
	
	
	//Node construction
	exports.createDocument = function () {
	    return new Node({
	        type: 'root',
	        name: 'root',
	        parent: null,
	        prev: null,
	        next: null,
	        children: [],
	        'x-mode': DOCUMENT_MODE.NO_QUIRKS
	    });
	};
	
	exports.createDocumentFragment = function () {
	    return new Node({
	        type: 'root',
	        name: 'root',
	        parent: null,
	        prev: null,
	        next: null,
	        children: []
	    });
	};
	
	exports.createElement = function (tagName, namespaceURI, attrs) {
	    var attribs = Object.create(null),
	        attribsNamespace = Object.create(null),
	        attribsPrefix = Object.create(null);
	
	    for (var i = 0; i < attrs.length; i++) {
	        var attrName = attrs[i].name;
	
	        attribs[attrName] = attrs[i].value;
	        attribsNamespace[attrName] = attrs[i].namespace;
	        attribsPrefix[attrName] = attrs[i].prefix;
	    }
	
	    return new Node({
	        type: tagName === 'script' || tagName === 'style' ? tagName : 'tag',
	        name: tagName,
	        namespace: namespaceURI,
	        attribs: attribs,
	        'x-attribsNamespace': attribsNamespace,
	        'x-attribsPrefix': attribsPrefix,
	        children: [],
	        parent: null,
	        prev: null,
	        next: null
	    });
	};
	
	exports.createCommentNode = function (data) {
	    return new Node({
	        type: 'comment',
	        data: data,
	        parent: null,
	        prev: null,
	        next: null
	    });
	};
	
	var createTextNode = function (value) {
	    return new Node({
	        type: 'text',
	        data: value,
	        parent: null,
	        prev: null,
	        next: null
	    });
	};
	
	
	//Tree mutation
	var appendChild = exports.appendChild = function (parentNode, newNode) {
	    var prev = parentNode.children[parentNode.children.length - 1];
	
	    if (prev) {
	        prev.next = newNode;
	        newNode.prev = prev;
	    }
	
	    parentNode.children.push(newNode);
	    newNode.parent = parentNode;
	};
	
	var insertBefore = exports.insertBefore = function (parentNode, newNode, referenceNode) {
	    var insertionIdx = parentNode.children.indexOf(referenceNode),
	        prev = referenceNode.prev;
	
	    if (prev) {
	        prev.next = newNode;
	        newNode.prev = prev;
	    }
	
	    referenceNode.prev = newNode;
	    newNode.next = referenceNode;
	
	    parentNode.children.splice(insertionIdx, 0, newNode);
	    newNode.parent = parentNode;
	};
	
	exports.setTemplateContent = function (templateElement, contentElement) {
	    appendChild(templateElement, contentElement);
	};
	
	exports.getTemplateContent = function (templateElement) {
	    return templateElement.children[0];
	};
	
	exports.setDocumentType = function (document, name, publicId, systemId) {
	    var data = doctype.serializeContent(name, publicId, systemId),
	        doctypeNode = null;
	
	    for (var i = 0; i < document.children.length; i++) {
	        if (document.children[i].type === 'directive' && document.children[i].name === '!doctype') {
	            doctypeNode = document.children[i];
	            break;
	        }
	    }
	
	    if (doctypeNode) {
	        doctypeNode.data = data;
	        doctypeNode['x-name'] = name;
	        doctypeNode['x-publicId'] = publicId;
	        doctypeNode['x-systemId'] = systemId;
	    }
	
	    else {
	        appendChild(document, new Node({
	            type: 'directive',
	            name: '!doctype',
	            data: data,
	            'x-name': name,
	            'x-publicId': publicId,
	            'x-systemId': systemId
	        }));
	    }
	
	};
	
	exports.setDocumentMode = function (document, mode) {
	    document['x-mode'] = mode;
	};
	
	exports.getDocumentMode = function (document) {
	    return document['x-mode'];
	};
	
	exports.detachNode = function (node) {
	    if (node.parent) {
	        var idx = node.parent.children.indexOf(node),
	            prev = node.prev,
	            next = node.next;
	
	        node.prev = null;
	        node.next = null;
	
	        if (prev)
	            prev.next = next;
	
	        if (next)
	            next.prev = prev;
	
	        node.parent.children.splice(idx, 1);
	        node.parent = null;
	    }
	};
	
	exports.insertText = function (parentNode, text) {
	    var lastChild = parentNode.children[parentNode.children.length - 1];
	
	    if (lastChild && lastChild.type === 'text')
	        lastChild.data += text;
	    else
	        appendChild(parentNode, createTextNode(text));
	};
	
	exports.insertTextBefore = function (parentNode, text, referenceNode) {
	    var prevNode = parentNode.children[parentNode.children.indexOf(referenceNode) - 1];
	
	    if (prevNode && prevNode.type === 'text')
	        prevNode.data += text;
	    else
	        insertBefore(parentNode, createTextNode(text), referenceNode);
	};
	
	exports.adoptAttributes = function (recipient, attrs) {
	    for (var i = 0; i < attrs.length; i++) {
	        var attrName = attrs[i].name;
	
	        if (typeof recipient.attribs[attrName] === 'undefined') {
	            recipient.attribs[attrName] = attrs[i].value;
	            recipient['x-attribsNamespace'][attrName] = attrs[i].namespace;
	            recipient['x-attribsPrefix'][attrName] = attrs[i].prefix;
	        }
	    }
	};
	
	
	//Tree traversing
	exports.getFirstChild = function (node) {
	    return node.children[0];
	};
	
	exports.getChildNodes = function (node) {
	    return node.children;
	};
	
	exports.getParentNode = function (node) {
	    return node.parent;
	};
	
	exports.getAttrList = function (element) {
	    var attrList = [];
	
	    for (var name in element.attribs) {
	        attrList.push({
	            name: name,
	            value: element.attribs[name],
	            namespace: element['x-attribsNamespace'][name],
	            prefix: element['x-attribsPrefix'][name]
	        });
	    }
	
	    return attrList;
	};
	
	
	//Node data
	exports.getTagName = function (element) {
	    return element.name;
	};
	
	exports.getNamespaceURI = function (element) {
	    return element.namespace;
	};
	
	exports.getTextNodeContent = function (textNode) {
	    return textNode.data;
	};
	
	exports.getCommentNodeContent = function (commentNode) {
	    return commentNode.data;
	};
	
	exports.getDocumentTypeNodeName = function (doctypeNode) {
	    return doctypeNode['x-name'];
	};
	
	exports.getDocumentTypeNodePublicId = function (doctypeNode) {
	    return doctypeNode['x-publicId'];
	};
	
	exports.getDocumentTypeNodeSystemId = function (doctypeNode) {
	    return doctypeNode['x-systemId'];
	};
	
	
	//Node types
	exports.isTextNode = function (node) {
	    return node.type === 'text';
	};
	
	exports.isCommentNode = function (node) {
	    return node.type === 'comment';
	};
	
	exports.isDocumentTypeNode = function (node) {
	    return node.type === 'directive' && node.name === '!doctype';
	};
	
	exports.isElementNode = function (node) {
	    return !!node.attribs;
	};


/***/ }),
/* 4376 */
/***/ (function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(4377)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ }),
/* 4377 */
/***/ (function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 4378 */
/***/ (function(module, exports) {

	'use strict';
	
	/* !
	 * Chai - pathval utility
	 * Copyright(c) 2012-2014 Jake Luer <jake@alogicalparadox.com>
	 * @see https://github.com/logicalparadox/filtr
	 * MIT Licensed
	 */
	
	/**
	 * ### .hasProperty(object, name)
	 *
	 * This allows checking whether an object has own
	 * or inherited from prototype chain named property.
	 *
	 * Basically does the same thing as the `in`
	 * operator but works properly with null/undefined values
	 * and other primitives.
	 *
	 *     var obj = {
	 *         arr: ['a', 'b', 'c']
	 *       , str: 'Hello'
	 *     }
	 *
	 * The following would be the results.
	 *
	 *     hasProperty(obj, 'str');  // true
	 *     hasProperty(obj, 'constructor');  // true
	 *     hasProperty(obj, 'bar');  // false
	 *
	 *     hasProperty(obj.str, 'length'); // true
	 *     hasProperty(obj.str, 1);  // true
	 *     hasProperty(obj.str, 5);  // false
	 *
	 *     hasProperty(obj.arr, 'length');  // true
	 *     hasProperty(obj.arr, 2);  // true
	 *     hasProperty(obj.arr, 3);  // false
	 *
	 * @param {Object} object
	 * @param {String|Symbol} name
	 * @returns {Boolean} whether it exists
	 * @namespace Utils
	 * @name hasProperty
	 * @api public
	 */
	
	function hasProperty(obj, name) {
	  if (typeof obj === 'undefined' || obj === null) {
	    return false;
	  }
	
	  // The `in` operator does not work with primitives.
	  return name in Object(obj);
	}
	
	/* !
	 * ## parsePath(path)
	 *
	 * Helper function used to parse string object
	 * paths. Use in conjunction with `internalGetPathValue`.
	 *
	 *      var parsed = parsePath('myobject.property.subprop');
	 *
	 * ### Paths:
	 *
	 * * Can be infinitely deep and nested.
	 * * Arrays are also valid using the formal `myobject.document[3].property`.
	 * * Literal dots and brackets (not delimiter) must be backslash-escaped.
	 *
	 * @param {String} path
	 * @returns {Object} parsed
	 * @api private
	 */
	
	function parsePath(path) {
	  var str = path.replace(/([^\\])\[/g, '$1.[');
	  var parts = str.match(/(\\\.|[^.]+?)+/g);
	  return parts.map(function mapMatches(value) {
	    var regexp = /^\[(\d+)\]$/;
	    var mArr = regexp.exec(value);
	    var parsed = null;
	    if (mArr) {
	      parsed = { i: parseFloat(mArr[1]) };
	    } else {
	      parsed = { p: value.replace(/\\([.\[\]])/g, '$1') };
	    }
	
	    return parsed;
	  });
	}
	
	/* !
	 * ## internalGetPathValue(obj, parsed[, pathDepth])
	 *
	 * Helper companion function for `.parsePath` that returns
	 * the value located at the parsed address.
	 *
	 *      var value = getPathValue(obj, parsed);
	 *
	 * @param {Object} object to search against
	 * @param {Object} parsed definition from `parsePath`.
	 * @param {Number} depth (nesting level) of the property we want to retrieve
	 * @returns {Object|Undefined} value
	 * @api private
	 */
	
	function internalGetPathValue(obj, parsed, pathDepth) {
	  var temporaryValue = obj;
	  var res = null;
	  pathDepth = (typeof pathDepth === 'undefined' ? parsed.length : pathDepth);
	
	  for (var i = 0; i < pathDepth; i++) {
	    var part = parsed[i];
	    if (temporaryValue) {
	      if (typeof part.p === 'undefined') {
	        temporaryValue = temporaryValue[part.i];
	      } else {
	        temporaryValue = temporaryValue[part.p];
	      }
	
	      if (i === (pathDepth - 1)) {
	        res = temporaryValue;
	      }
	    }
	  }
	
	  return res;
	}
	
	/* !
	 * ## internalSetPathValue(obj, value, parsed)
	 *
	 * Companion function for `parsePath` that sets
	 * the value located at a parsed address.
	 *
	 *  internalSetPathValue(obj, 'value', parsed);
	 *
	 * @param {Object} object to search and define on
	 * @param {*} value to use upon set
	 * @param {Object} parsed definition from `parsePath`
	 * @api private
	 */
	
	function internalSetPathValue(obj, val, parsed) {
	  var tempObj = obj;
	  var pathDepth = parsed.length;
	  var part = null;
	  // Here we iterate through every part of the path
	  for (var i = 0; i < pathDepth; i++) {
	    var propName = null;
	    var propVal = null;
	    part = parsed[i];
	
	    // If it's the last part of the path, we set the 'propName' value with the property name
	    if (i === (pathDepth - 1)) {
	      propName = typeof part.p === 'undefined' ? part.i : part.p;
	      // Now we set the property with the name held by 'propName' on object with the desired val
	      tempObj[propName] = val;
	    } else if (typeof part.p !== 'undefined' && tempObj[part.p]) {
	      tempObj = tempObj[part.p];
	    } else if (typeof part.i !== 'undefined' && tempObj[part.i]) {
	      tempObj = tempObj[part.i];
	    } else {
	      // If the obj doesn't have the property we create one with that name to define it
	      var next = parsed[i + 1];
	      // Here we set the name of the property which will be defined
	      propName = typeof part.p === 'undefined' ? part.i : part.p;
	      // Here we decide if this property will be an array or a new object
	      propVal = typeof next.p === 'undefined' ? [] : {};
	      tempObj[propName] = propVal;
	      tempObj = tempObj[propName];
	    }
	  }
	}
	
	/**
	 * ### .getPathInfo(object, path)
	 *
	 * This allows the retrieval of property info in an
	 * object given a string path.
	 *
	 * The path info consists of an object with the
	 * following properties:
	 *
	 * * parent - The parent object of the property referenced by `path`
	 * * name - The name of the final property, a number if it was an array indexer
	 * * value - The value of the property, if it exists, otherwise `undefined`
	 * * exists - Whether the property exists or not
	 *
	 * @param {Object} object
	 * @param {String} path
	 * @returns {Object} info
	 * @namespace Utils
	 * @name getPathInfo
	 * @api public
	 */
	
	function getPathInfo(obj, path) {
	  var parsed = parsePath(path);
	  var last = parsed[parsed.length - 1];
	  var info = {
	    parent: parsed.length > 1 ? internalGetPathValue(obj, parsed, parsed.length - 1) : obj,
	    name: last.p || last.i,
	    value: internalGetPathValue(obj, parsed),
	  };
	  info.exists = hasProperty(info.parent, info.name);
	
	  return info;
	}
	
	/**
	 * ### .getPathValue(object, path)
	 *
	 * This allows the retrieval of values in an
	 * object given a string path.
	 *
	 *     var obj = {
	 *         prop1: {
	 *             arr: ['a', 'b', 'c']
	 *           , str: 'Hello'
	 *         }
	 *       , prop2: {
	 *             arr: [ { nested: 'Universe' } ]
	 *           , str: 'Hello again!'
	 *         }
	 *     }
	 *
	 * The following would be the results.
	 *
	 *     getPathValue(obj, 'prop1.str'); // Hello
	 *     getPathValue(obj, 'prop1.att[2]'); // b
	 *     getPathValue(obj, 'prop2.arr[0].nested'); // Universe
	 *
	 * @param {Object} object
	 * @param {String} path
	 * @returns {Object} value or `undefined`
	 * @namespace Utils
	 * @name getPathValue
	 * @api public
	 */
	
	function getPathValue(obj, path) {
	  var info = getPathInfo(obj, path);
	  return info.value;
	}
	
	/**
	 * ### .setPathValue(object, path, value)
	 *
	 * Define the value in an object at a given string path.
	 *
	 * ```js
	 * var obj = {
	 *     prop1: {
	 *         arr: ['a', 'b', 'c']
	 *       , str: 'Hello'
	 *     }
	 *   , prop2: {
	 *         arr: [ { nested: 'Universe' } ]
	 *       , str: 'Hello again!'
	 *     }
	 * };
	 * ```
	 *
	 * The following would be acceptable.
	 *
	 * ```js
	 * var properties = require('tea-properties');
	 * properties.set(obj, 'prop1.str', 'Hello Universe!');
	 * properties.set(obj, 'prop1.arr[2]', 'B');
	 * properties.set(obj, 'prop2.arr[0].nested.value', { hello: 'universe' });
	 * ```
	 *
	 * @param {Object} object
	 * @param {String} path
	 * @param {Mixed} value
	 * @api private
	 */
	
	function setPathValue(obj, path, val) {
	  var parsed = parsePath(path);
	  internalSetPathValue(obj, val, parsed);
	  return obj;
	}
	
	module.exports = {
	  hasProperty: hasProperty,
	  getPathInfo: getPathInfo,
	  getPathValue: getPathValue,
	  setPathValue: setPathValue,
	};


/***/ }),
/* 4379 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(4381);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 4380 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(99);
	var invariant = __webpack_require__(134);
	var ReactPropTypesSecret = __webpack_require__(715);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 4381 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(99);
	var invariant = __webpack_require__(134);
	var warning = __webpack_require__(313);
	var assign = __webpack_require__(33);
	
	var ReactPropTypesSecret = __webpack_require__(715);
	var checkPropTypes = __webpack_require__(714);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 4382 */,
/* 4383 */,
/* 4384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(18);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _createChainedFunction = __webpack_require__(87);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  href: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = function (_React$Component) {
	  (0, _inherits3.default)(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    (0, _classCallCheck3.default)(this, SafeAnchor);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        href = _props.href,
	        onClick = _props.onClick;
	
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (event.key === ' ') {
	      event.preventDefault();
	      this.handleClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        disabled = _props2.disabled,
	        onKeyDown = _props2.onKeyDown,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['componentClass', 'disabled', 'onKeyDown']);
	
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button';
	      // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	      props.href = props.href || '#';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends3.default)({ pointerEvents: 'none' }, props.style);
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, props, {
	      onClick: this.handleClick,
	      onKeyDown: (0, _createChainedFunction2.default)(this.handleKeyDown, onKeyDown)
	    }));
	  };
	
	  return SafeAnchor;
	}(_react2.default.Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	
	exports.default = SafeAnchor;
	module.exports = exports['default'];

/***/ }),
/* 4385 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.3.1
	 * react-dom-server.browser.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var p=__webpack_require__(33),q=__webpack_require__(2),t=__webpack_require__(99),w=__webpack_require__(176),x=__webpack_require__(1231),y=__webpack_require__(1234);
	function z(a){for(var b=arguments.length-1,d="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)d+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(d+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
	var A="function"===typeof Symbol&&Symbol["for"],C=A?Symbol["for"]("react.call"):60104,aa=A?Symbol["for"]("react.return"):60105,ba=A?Symbol["for"]("react.portal"):60106,E=A?Symbol["for"]("react.fragment"):60107,ca=A?Symbol["for"]("react.strict_mode"):60108,F=A?Symbol["for"]("react.provider"):60109,da=A?Symbol["for"]("react.context"):60110,ea=A?Symbol["for"]("react.async_mode"):60111,fa=A?Symbol["for"]("react.forward_ref"):60112,ha=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
	G={},H={};function ia(a){if(H.hasOwnProperty(a))return!0;if(G.hasOwnProperty(a))return!1;if(ha.test(a))return H[a]=!0;G[a]=!0;return!1}function ja(a,b,d,c){if(null!==d&&0===d.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(c)return!1;if(null!==d)return!d.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function ka(a,b,d,c){if(null===b||"undefined"===typeof b||ja(a,b,d,c))return!0;if(null!==d)switch(d.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function I(a,b,d,c,k){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=c;this.attributeNamespace=k;this.mustUseProperty=d;this.propertyName=a;this.type=b}var J={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});
	["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});
	["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var K=/[\-\:]([a-z])/g;function L(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(K,
	L);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);var la=/["'&<>]/;
	function M(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=la.exec(a);if(b){var d="",c,k=0;for(c=b.index;c<a.length;c++){switch(a.charCodeAt(c)){case 34:b="\x26quot;";break;case 38:b="\x26amp;";break;case 39:b="\x26#x27;";break;case 60:b="\x26lt;";break;case 62:b="\x26gt;";break;default:continue}k!==c&&(d+=a.substring(k,c));k=c+1;d+=b}a=k!==c?d+a.substring(k,c):d}return a}var N={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function O(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
	var P={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},ma=p({menuitem:!0},P),Q={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,
	fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},na=["Webkit","ms","Moz","O"];Object.keys(Q).forEach(function(a){na.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Q[b]=Q[a]})});var R=q.Children.toArray,S=t.thatReturns("");t.thatReturns("");var oa={listing:!0,pre:!0,textarea:!0};
	function T(a){return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}var pa=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,U={},qa=y(function(a){return x(a)});function ra(a){var b="";q.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function sa(a,b){if(a=a.contextTypes){var d={},c;for(c in a)d[c]=b[c];b=d}else b=w;return b}var ta={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};
	function V(a,b){void 0===a&&z("152",T(b)||"Component")}
	function ua(a,b){function d(c,k){var d=sa(k,b),f=[],h=!1,g={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===f)return null},enqueueReplaceState:function(b,a){h=!0;f=[a]},enqueueSetState:function(b,a){if(null===f)return null;f.push(a)}},e=void 0;if(k.prototype&&k.prototype.isReactComponent){if(e=new k(c.props,d,g),"function"===typeof k.getDerivedStateFromProps){var v=k.getDerivedStateFromProps.call(null,c.props,e.state);null!=v&&(e.state=p({},e.state,v))}}else if(e=k(c.props,
	d,g),null==e||null==e.render){a=e;V(a,k);return}e.props=c.props;e.context=d;e.updater=g;g=e.state;void 0===g&&(e.state=g=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof k.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof k.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),f.length){g=f;var u=h;f=null;h=!1;if(u&&
	1===g.length)e.state=g[0];else{v=u?g[0]:e.state;var m=!0;for(u=u?1:0;u<g.length;u++){var n=g[u];n="function"===typeof n?n.call(e,v,c.props,d):n;null!=n&&(m?(m=!1,v=p({},v,n)):p(v,n))}e.state=v}}else f=null;a=e.render();V(a,k);c=void 0;if("function"===typeof e.getChildContext&&(d=k.childContextTypes,"object"===typeof d)){c=e.getChildContext();for(var r in c)r in d?void 0:z("108",T(k)||"Unknown",r)}c&&(b=p({},b,c))}for(;q.isValidElement(a);){var c=a,k=c.type;if("function"!==typeof k)break;d(c,k)}return{child:a,
	context:b}}
	var W=function(){function a(b,d){if(!(this instanceof a))throw new TypeError("Cannot call a class as a function");q.isValidElement(b)?b.type!==E?b=[b]:(b=b.props.children,b=q.isValidElement(b)?[b]:R(b)):b=R(b);this.stack=[{type:null,domNamespace:N.html,children:b,childIndex:0,context:w,footer:""}];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=d;this.providerStack=[];this.providerIndex=-1}a.prototype.pushProvider=function(a){this.providerIndex+=1;
	this.providerStack[this.providerIndex]=a;a.type._context._currentValue=a.props.value};a.prototype.popProvider=function(a){this.providerStack[this.providerIndex]=null;--this.providerIndex;a=a.type._context;a._currentValue=0>this.providerIndex?a._defaultValue:this.providerStack[this.providerIndex].props.value};a.prototype.read=function(a){if(this.exhausted)return null;for(var b="";b.length<a;){if(0===this.stack.length){this.exhausted=!0;break}var c=this.stack[this.stack.length-1];if(c.childIndex>=c.children.length){var k=
	c.footer;b+=k;""!==k&&(this.previousWasTextNode=!1);this.stack.pop();"select"===c.type?this.currentSelectValue=null:null!=c.type&&null!=c.type.type&&c.type.type.$$typeof===F&&this.popProvider(c.type)}else k=c.children[c.childIndex++],b+=this.render(k,c.context,c.domNamespace)}return b};a.prototype.render=function(a,d,c){if("string"===typeof a||"number"===typeof a){c=""+a;if(""===c)return"";if(this.makeStaticMarkup)return M(c);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+M(c);this.previousWasTextNode=
	!0;return M(c)}d=ua(a,d);a=d.child;d=d.context;if(null===a||!1===a)return"";if(!q.isValidElement(a)){if(null!=a&&null!=a.$$typeof){var b=a.$$typeof;b===ba?z("257"):void 0;z("258",b.toString())}a=R(a);this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""});return""}b=a.type;if("string"===typeof b)return this.renderDOM(a,d,c);switch(b){case ca:case ea:case E:return a=R(a.props.children),this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""}),
	"";case C:case aa:z("259")}if("object"===typeof b&&null!==b)switch(b.$$typeof){case fa:return a=R(b.render(a.props,a.ref)),this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""}),"";case F:return b=R(a.props.children),c={type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""},this.pushProvider(a),this.stack.push(c),"";case da:return b=R(a.props.children(a.type._currentValue)),this.stack.push({type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""}),
	""}z("130",null==b?b:typeof b,"")};a.prototype.renderDOM=function(a,d,c){var b=a.type.toLowerCase();c===N.html&&O(b);U.hasOwnProperty(b)||(pa.test(b)?void 0:z("65",b),U[b]=!0);var f=a.props;if("input"===b)f=p({type:void 0},f,{defaultChecked:void 0,defaultValue:void 0,value:null!=f.value?f.value:f.defaultValue,checked:null!=f.checked?f.checked:f.defaultChecked});else if("textarea"===b){var h=f.value;if(null==h){h=f.defaultValue;var l=f.children;null!=l&&(null!=h?z("92"):void 0,Array.isArray(l)&&(1>=
	l.length?void 0:z("93"),l=l[0]),h=""+l);null==h&&(h="")}f=p({},f,{value:void 0,children:""+h})}else if("select"===b)this.currentSelectValue=null!=f.value?f.value:f.defaultValue,f=p({},f,{value:void 0});else if("option"===b){l=this.currentSelectValue;var D=ra(f.children);if(null!=l){var B=null!=f.value?f.value+"":D;h=!1;if(Array.isArray(l))for(var g=0;g<l.length;g++){if(""+l[g]===B){h=!0;break}}else h=""+l===B;f=p({selected:void 0,children:void 0},f,{selected:h,children:D})}}if(h=f)ma[b]&&(null!=h.children||
	null!=h.dangerouslySetInnerHTML?z("137",b,S()):void 0),null!=h.dangerouslySetInnerHTML&&(null!=h.children?z("60"):void 0,"object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML?void 0:z("61")),null!=h.style&&"object"!==typeof h.style?z("62",S()):void 0;h=f;l=this.makeStaticMarkup;D=1===this.stack.length;B="\x3c"+a.type;for(r in h)if(h.hasOwnProperty(r)){var e=h[r];if(null!=e){if("style"===r){g=void 0;var v="",u="";for(g in e)if(e.hasOwnProperty(g)){var m=0===g.indexOf("--"),
	n=e[g];null!=n&&(v+=u+qa(g)+":",u=g,m=null==n||"boolean"===typeof n||""===n?"":m||"number"!==typeof n||0===n||Q.hasOwnProperty(u)&&Q[u]?(""+n).trim():n+"px",v+=m,u=";")}e=v||null}g=null;b:if(m=b,n=h,-1===m.indexOf("-"))m="string"===typeof n.is;else switch(m){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":m=!1;break b;default:m=!0}if(m)ta.hasOwnProperty(r)||(g=r,g=ia(g)&&null!=
	e?g+"\x3d"+('"'+M(e)+'"'):"");else{m=r;g=e;e=J.hasOwnProperty(m)?J[m]:null;if(n="style"!==m)n=null!==e?0===e.type:!(2<m.length)||"o"!==m[0]&&"O"!==m[0]||"n"!==m[1]&&"N"!==m[1]?!1:!0;n||ka(m,g,e,!1)?g="":null!==e?(m=e.attributeName,e=e.type,g=3===e||4===e&&!0===g?m+'\x3d""':m+"\x3d"+('"'+M(g)+'"')):g=m+"\x3d"+('"'+M(g)+'"')}g&&(B+=" "+g)}}l||D&&(B+=' data-reactroot\x3d""');var r=B;h="";P.hasOwnProperty(b)?r+="/\x3e":(r+="\x3e",h="\x3c/"+a.type+"\x3e");a:{l=f.dangerouslySetInnerHTML;if(null!=l){if(null!=
	l.__html){l=l.__html;break a}}else if(l=f.children,"string"===typeof l||"number"===typeof l){l=M(l);break a}l=null}null!=l?(f=[],oa[b]&&"\n"===l.charAt(0)&&(r+="\n"),r+=l):f=R(f.children);a=a.type;c=null==c||"http://www.w3.org/1999/xhtml"===c?O(a):"http://www.w3.org/2000/svg"===c&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":c;this.stack.push({domNamespace:c,type:b,children:f,childIndex:0,context:d,footer:h});this.previousWasTextNode=!1;return r};return a}(),X={renderToString:function(a){return(new W(a,
	!1)).read(Infinity)},renderToStaticMarkup:function(a){return(new W(a,!0)).read(Infinity)},renderToNodeStream:function(){z("207")},renderToStaticNodeStream:function(){z("208")},version:"16.3.1"},Y=Object.freeze({default:X}),Z=Y&&X||Y;module.exports=Z["default"]?Z["default"]:Z;


/***/ }),
/* 4386 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.3.1
	 * react-dom-test-utils.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f=__webpack_require__(33),h=__webpack_require__(2),m=__webpack_require__(15),n=__webpack_require__(99),p=__webpack_require__(618);
	function q(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
	function r(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function t(a){2!==r(a)?q("188"):void 0}
	function u(a){var b=a.alternate;if(!b)return b=r(a),3===b?q("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],l=e?e.alternate:null;if(!e||!l)break;if(e.child===l.child){for(var g=e.child;g;){if(g===c)return t(e),a;if(g===d)return t(e),b;g=g.sibling}q("188")}if(c["return"]!==d["return"])c=e,d=l;else{g=!1;for(var k=e.child;k;){if(k===c){g=!0;c=e;d=l;break}if(k===d){g=!0;d=e;c=l;break}k=k.sibling}if(!g){for(k=l.child;k;){if(k===c){g=!0;c=l;d=e;break}if(k===d){g=!0;d=l;c=e;break}k=k.sibling}g?
	void 0:q("189")}}c.alternate!==d?q("190"):void 0}3!==c.tag?q("188"):void 0;return c.stateNode.current===c?a:b}var v="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),w={type:null,target:null,currentTarget:n.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	function x(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?n.thatReturnsTrue:n.thatReturnsFalse;this.isPropagationStopped=n.thatReturnsFalse;return this}
	f(x.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=n.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=n.thatReturnsTrue)},persist:function(){this.isPersistent=n.thatReturnsTrue},isPersistent:n.thatReturnsFalse,
	destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<v.length;a++)this[v[a]]=null}});x.Interface=w;x.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;f(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=f({},d.Interface,a);c.extend=d.extend;y(c);return c};y(x);
	function z(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function A(a){a instanceof this?void 0:q("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function y(a){a.eventPool=[];a.getPooled=z;a.release=A}function B(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
	var C={animationend:B("Animation","AnimationEnd"),animationiteration:B("Animation","AnimationIteration"),animationstart:B("Animation","AnimationStart"),transitionend:B("Transition","TransitionEnd")},D={},E={};p.canUseDOM&&(E=document.createElement("div").style,"AnimationEvent"in window||(delete C.animationend.animation,delete C.animationiteration.animation,delete C.animationstart.animation),"TransitionEvent"in window||delete C.transitionend.transition);
	function F(a){if(D[a])return D[a];if(!C[a])return a;var b=C[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in E)return D[a]=b[c];return a}
	var G={topAnimationEnd:F("animationend"),topAnimationIteration:F("animationiteration"),topAnimationStart:F("animationstart"),topBlur:"blur",topCancel:"cancel",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",
	topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoad:"load",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topScroll:"scroll",topSelectionChange:"selectionchange",topTextInput:"textInput",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
	topTouchStart:"touchstart",topTransitionEnd:F("transitionend"),topWheel:"wheel"},H=m.findDOMNode,I=m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,J=I.EventPluginHub,K=I.EventPluginRegistry,L=I.EventPropagators,M=I.ReactControlledComponent,N=I.ReactDOMComponentTree,O=I.ReactDOMEventListener;function P(){}
	function Q(a,b){if(!a)return[];a=u(a);if(!a)return[];for(var c=a,d=[];;){if(5===c.tag||6===c.tag||2===c.tag||1===c.tag){var e=c.stateNode;b(e)&&d.push(e)}if(c.child)c.child["return"]=c,c=c.child;else{if(c===a)return d;for(;!c.sibling;){if(!c["return"]||c["return"]===a)return d;c=c["return"]}c.sibling["return"]=c["return"];c=c.sibling}}}
	var R={renderIntoDocument:function(a){var b=document.createElement("div");return m.render(a,b)},isElement:function(a){return h.isValidElement(a)},isElementOfType:function(a,b){return h.isValidElement(a)&&a.type===b},isDOMComponent:function(a){return!(!a||1!==a.nodeType||!a.tagName)},isDOMComponentElement:function(a){return!!(a&&h.isValidElement(a)&&a.tagName)},isCompositeComponent:function(a){return R.isDOMComponent(a)?!1:null!=a&&"function"===typeof a.render&&"function"===typeof a.setState},isCompositeComponentWithType:function(a,
	b){return R.isCompositeComponent(a)?a._reactInternalFiber.type===b:!1},findAllInRenderedTree:function(a,b){if(!a)return[];R.isCompositeComponent(a)?void 0:q("10");return Q(a._reactInternalFiber,b)},scryRenderedDOMComponentsWithClass:function(a,b){return R.findAllInRenderedTree(a,function(a){if(R.isDOMComponent(a)){var c=a.className;"string"!==typeof c&&(c=a.getAttribute("class")||"");var e=c.split(/\s+/);Array.isArray(b)||(void 0===b?q("11"):void 0,b=b.split(/\s+/));return b.every(function(a){return-1!==
	e.indexOf(a)})}return!1})},findRenderedDOMComponentWithClass:function(a,b){a=R.scryRenderedDOMComponentsWithClass(a,b);if(1!==a.length)throw Error("Did not find exactly one match (found: "+a.length+") for class:"+b);return a[0]},scryRenderedDOMComponentsWithTag:function(a,b){return R.findAllInRenderedTree(a,function(a){return R.isDOMComponent(a)&&a.tagName.toUpperCase()===b.toUpperCase()})},findRenderedDOMComponentWithTag:function(a,b){a=R.scryRenderedDOMComponentsWithTag(a,b);if(1!==a.length)throw Error("Did not find exactly one match (found: "+
	a.length+") for tag:"+b);return a[0]},scryRenderedComponentsWithType:function(a,b){return R.findAllInRenderedTree(a,function(a){return R.isCompositeComponentWithType(a,b)})},findRenderedComponentWithType:function(a,b){a=R.scryRenderedComponentsWithType(a,b);if(1!==a.length)throw Error("Did not find exactly one match (found: "+a.length+") for componentType:"+b);return a[0]},mockComponent:function(a,b){b=b||a.mockTagName||"div";a.prototype.render.mockImplementation(function(){return h.createElement(b,
	null,this.props.children)});return this},simulateNativeEventOnNode:function(a,b,c){c.target=b;O.dispatchEvent(a,c)},simulateNativeEventOnDOMComponent:function(a,b,c){R.simulateNativeEventOnNode(a,H(b),c)},nativeTouchData:function(a,b){return{touches:[{pageX:a,pageY:b}]}},Simulate:null,SimulateNative:{}};
	function S(a){return function(b,c){h.isValidElement(b)?q("228"):void 0;R.isCompositeComponent(b)?q("229"):void 0;var d=K.eventNameDispatchConfigs[a],e=new P;e.target=b;e.type=a.toLowerCase();var l=N.getInstanceFromNode(b),g=new x(d,l,e,b);g.persist();f(g,c);d.phasedRegistrationNames?L.accumulateTwoPhaseDispatches(g):L.accumulateDirectDispatches(g);m.unstable_batchedUpdates(function(){M.enqueueStateRestore(b);J.runEventsInBatch(g,!0)});M.restoreStateIfNeeded()}}
	function T(){R.Simulate={};var a=void 0;for(a in K.eventNameDispatchConfigs)R.Simulate[a]=S(a)}var U=J.injection.injectEventPluginOrder;J.injection.injectEventPluginOrder=function(){U.apply(this,arguments);T()};var V=J.injection.injectEventPluginsByName;J.injection.injectEventPluginsByName=function(){V.apply(this,arguments);T()};T();
	function W(a){return function(b,c){var d=new P(a);f(d,c);R.isDOMComponent(b)?R.simulateNativeEventOnDOMComponent(a,b,d):b.tagName&&R.simulateNativeEventOnNode(a,b,d)}}
	[].concat(Object.keys(G),Object.keys({topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",
	topVolumeChange:"volumechange",topWaiting:"waiting"})).forEach(function(a){var b=0===a.indexOf("top")?a.charAt(3).toLowerCase()+a.substr(4):a;R.SimulateNative[b]=W(a)});var X=Object.freeze({default:R}),Y=X&&R||X;module.exports=Y["default"]?Y["default"]:Y;


/***/ }),
/* 4387 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.3.1
	 * react-dom.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var ba=__webpack_require__(2),m=__webpack_require__(618),A=__webpack_require__(33),C=__webpack_require__(99),ea=__webpack_require__(1229),fa=__webpack_require__(619),ha=__webpack_require__(1228),ja=__webpack_require__(176);
	function D(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}ba?void 0:D("227");
	function ka(a,b,c,d,e,f,h,g,k){this._hasCaughtError=!1;this._caughtError=null;var v=Array.prototype.slice.call(arguments,3);try{b.apply(c,v)}catch(l){this._caughtError=l,this._hasCaughtError=!0}}
	var E={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,h,g,k){ka.apply(E,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,h,g,k){E.invokeGuardedCallback.apply(this,arguments);if(E.hasCaughtError()){var v=E.clearCaughtError();E._hasRethrowError||(E._hasRethrowError=!0,E._rethrowError=v)}},rethrowCaughtError:function(){return ma.apply(E,arguments)},hasCaughtError:function(){return E._hasCaughtError},clearCaughtError:function(){if(E._hasCaughtError){var a=
	E._caughtError;E._caughtError=null;E._hasCaughtError=!1;return a}D("198")}};function ma(){if(E._hasRethrowError){var a=E._rethrowError;E._rethrowError=null;E._hasRethrowError=!1;throw a;}}var na=null,oa={};
	function pa(){if(na)for(var a in oa){var b=oa[a],c=na.indexOf(a);-1<c?void 0:D("96",a);if(!qa[c]){b.extractEvents?void 0:D("97",a);qa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;ra.hasOwnProperty(g)?D("99",g):void 0;ra[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&sa(k[e],h,g);e=!0}else f.registrationName?(sa(f.registrationName,h,g),e=!0):e=!1;e?void 0:D("98",d,a)}}}}
	function sa(a,b,c){ta[a]?D("100",a):void 0;ta[a]=b;ua[a]=b.eventTypes[c].dependencies}var qa=[],ra={},ta={},ua={};function va(a){na?D("101"):void 0;na=Array.prototype.slice.call(a);pa()}function wa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];oa.hasOwnProperty(c)&&oa[c]===d||(oa[c]?D("102",c):void 0,oa[c]=d,b=!0)}b&&pa()}
	var xa=Object.freeze({plugins:qa,eventNameDispatchConfigs:ra,registrationNameModules:ta,registrationNameDependencies:ua,possibleRegistrationNames:null,injectEventPluginOrder:va,injectEventPluginsByName:wa}),Ca=null,Da=null,Ea=null;function Fa(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ea(d);E.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
	function Ga(a,b){null==b?D("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ha(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ia=null;
	function Ja(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Fa(a,b,c[e],d[e]);else c&&Fa(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ka(a){return Ja(a,!0)}function La(a){return Ja(a,!1)}var Ma={injectEventPluginOrder:va,injectEventPluginsByName:wa};
	function Na(a,b){var c=a.stateNode;if(!c)return null;var d=Ca(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?D("231",b,typeof c):void 0;
	return c}function Oa(a,b){null!==a&&(Ia=Ga(Ia,a));a=Ia;Ia=null;a&&(b?Ha(a,Ka):Ha(a,La),Ia?D("95"):void 0,E.rethrowCaughtError())}function Pa(a,b,c,d){for(var e=null,f=0;f<qa.length;f++){var h=qa[f];h&&(h=h.extractEvents(a,b,c,d))&&(e=Ga(e,h))}Oa(e,!1)}var Qa=Object.freeze({injection:Ma,getListener:Na,runEventsInBatch:Oa,runExtractedEventsInBatch:Pa}),Ra=Math.random().toString(36).slice(2),F="__reactInternalInstance$"+Ra,Sa="__reactEventHandlers$"+Ra;
	function Ta(a){if(a[F])return a[F];for(;!a[F];)if(a.parentNode)a=a.parentNode;else return null;a=a[F];return 5===a.tag||6===a.tag?a:null}function Ua(a){if(5===a.tag||6===a.tag)return a.stateNode;D("33")}function Va(a){return a[Sa]||null}var Xa=Object.freeze({precacheFiberNode:function(a,b){b[F]=a},getClosestInstanceFromNode:Ta,getInstanceFromNode:function(a){a=a[F];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Ua,getFiberCurrentPropsFromNode:Va,updateFiberProps:function(a,b){a[Sa]=b}});
	function L(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function bb(a,b,c){for(var d=[];a;)d.push(a),a=L(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function cb(a,b,c){if(b=Na(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Ga(c._dispatchListeners,b),c._dispatchInstances=Ga(c._dispatchInstances,a)}function db(a){a&&a.dispatchConfig.phasedRegistrationNames&&bb(a._targetInst,cb,a)}
	function eb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?L(b):null;bb(b,cb,a)}}function fb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Na(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Ga(c._dispatchListeners,b),c._dispatchInstances=Ga(c._dispatchInstances,a))}function gb(a){a&&a.dispatchConfig.registrationName&&fb(a._targetInst,null,a)}function hb(a){Ha(a,db)}
	function ib(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,h=0,g=e;g;g=L(g))h++;g=0;for(var k=f;k;k=L(k))g++;for(;0<h-g;)e=L(e),h--;for(;0<g-h;)f=L(f),g--;for(;h--;){if(e===f||e===f.alternate)break a;e=L(e);f=L(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){h=c.alternate;if(null!==h&&h===f)break;e.push(c);c=L(c)}for(c=[];d&&d!==f;){h=d.alternate;if(null!==h&&h===f)break;c.push(d);d=L(d)}for(d=0;d<e.length;d++)fb(e[d],"bubbled",a);for(a=c.length;0<a--;)fb(c[a],"captured",b)}
	var jb=Object.freeze({accumulateTwoPhaseDispatches:hb,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ha(a,eb)},accumulateEnterLeaveDispatches:ib,accumulateDirectDispatches:function(a){Ha(a,gb)}}),kb=null;function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var M={_root:null,_startText:null,_fallbackText:null};
	function mb(){if(M._fallbackText)return M._fallbackText;var a,b=M._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);M._fallbackText=e.slice(a,1<d?1-d:void 0);return M._fallbackText}function nb(){return"value"in M._root?M._root.value:M._root[lb()]}
	var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	function N(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
	A(N.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
	destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});N.Interface=pb;N.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;A(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=A({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(N);
	function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:D("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=N.extend({data:null}),ub=N.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
	var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},Kb=!1;
	function Lb(a,b){switch(a){case "topKeyUp":return-1!==vb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function Mb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Nb=!1;function Ob(a,b){switch(a){case "topCompositionEnd":return Mb(b);case "topKeyPress":if(32!==b.which)return null;Kb=!0;return Ab;case "topTextInput":return a=b.data,a===Ab&&Kb?null:a;default:return null}}
	function Pb(a,b){if(Nb)return"topCompositionEnd"===a||!wb&&Lb(a,b)?(a=mb(),M._root=null,M._startText=null,M._fallbackText=null,Nb=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return zb?null:b.data;default:return null}}
	var Qb={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "topCompositionStart":e=Bb.compositionStart;break b;case "topCompositionEnd":e=Bb.compositionEnd;break b;case "topCompositionUpdate":e=Bb.compositionUpdate;break b}e=void 0}else Nb?Lb(a,c)&&(e=Bb.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Nb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Nb&&(f=mb()):(M._root=d,M._startText=nb(),Nb=!0)),e=tb.getPooled(e,
	b,c,d),f?e.data=f:(f=Mb(c),null!==f&&(e.data=f)),hb(e),f=e):f=null;(a=yb?Ob(a,c):Pb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,hb(b)):b=null;return null===f?b:null===b?f:[f,b]}},Rb=null,Sb=null,Tb=null;function Ub(a){if(a=Da(a)){Rb&&"function"===typeof Rb.restoreControlledState?void 0:D("194");var b=Ca(a.stateNode);Rb.restoreControlledState(a.stateNode,a.type,b)}}var Vb={injectFiberControlledHostComponent:function(a){Rb=a}};function Wb(a){Sb?Tb?Tb.push(a):Tb=[a]:Sb=a}
	function Xb(){return null!==Sb||null!==Tb}function Yb(){if(Sb){var a=Sb,b=Tb;Tb=Sb=null;Ub(a);if(b)for(a=0;a<b.length;a++)Ub(b[a])}}var Zb=Object.freeze({injection:Vb,enqueueStateRestore:Wb,needsStateRestore:Xb,restoreStateIfNeeded:Yb});function $b(a,b){return a(b)}function ac(a,b,c){return a(b,c)}function bc(){}var cc=!1;function dc(a,b){if(cc)return a(b);cc=!0;try{return $b(a,b)}finally{cc=!1,Xb()&&(bc(),Yb())}}
	var ec={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function fc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!ec[a.type]:"textarea"===b?!0:!1}function gc(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
	function hc(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ic(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function jc(a){var b=ic(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),Object.defineProperty(a,b,{enumerable:c.enumerable}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
	function kc(a){a._valueTracker||(a._valueTracker=jc(a))}function lc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ic(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
	var mc=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,O="function"===typeof Symbol&&Symbol["for"],nc=O?Symbol["for"]("react.element"):60103,oc=O?Symbol["for"]("react.call"):60104,pc=O?Symbol["for"]("react.return"):60105,qc=O?Symbol["for"]("react.portal"):60106,rc=O?Symbol["for"]("react.fragment"):60107,sc=O?Symbol["for"]("react.strict_mode"):60108,tc=O?Symbol["for"]("react.provider"):60109,uc=O?Symbol["for"]("react.context"):60110,vc=O?Symbol["for"]("react.async_mode"):60111,
	wc=O?Symbol["for"]("react.forward_ref"):60112,xc="function"===typeof Symbol&&Symbol.iterator;function yc(a){if(null===a||"undefined"===typeof a)return null;a=xc&&a[xc]||a["@@iterator"];return"function"===typeof a?a:null}function zc(a){a=a.type;if("function"===typeof a)return a.displayName||a.name;if("string"===typeof a)return a;switch(a){case rc:return"ReactFragment";case qc:return"ReactPortal";case oc:return"ReactCall";case pc:return"ReactReturn"}return null}
	function Ac(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=zc(a);var f=null;c&&(f=zc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a["return"]}while(a);return b}
	var Bc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Cc={},Dc={};function Ec(a){if(Dc.hasOwnProperty(a))return!0;if(Cc.hasOwnProperty(a))return!1;if(Bc.test(a))return Dc[a]=!0;Cc[a]=!0;return!1}
	function Fc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Gc(a,b,c,d){if(null===b||"undefined"===typeof b||Fc(a,b,c,d))return!0;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
	function U(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var V={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){V[a]=new U(a,0,!1,a,null)});
	[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];V[b]=new U(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){V[a]=new U(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){V[a]=new U(a,2,!1,a,null)});
	"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){V[a]=new U(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){V[a]=new U(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){V[a]=new U(a,4,!1,a.toLowerCase(),null)});
	["cols","rows","size","span"].forEach(function(a){V[a]=new U(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){V[a]=new U(a,5,!1,a.toLowerCase(),null)});var Hc=/[\-\:]([a-z])/g;function Sc(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Hc,
	Sc);V[b]=new U(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Hc,Sc);V[b]=new U(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Hc,Sc);V[b]=new U(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});V.tabIndex=new U("tabIndex",1,!1,"tabindex",null);
	function Tc(a,b,c,d){var e=V.hasOwnProperty(b)?V[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Gc(b,c,e,d)&&(c=null),d||null===e?Ec(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function Uc(a,b){var c=b.checked;return A({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Vc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Wc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Xc(a,b){b=b.checked;null!=b&&Tc(a,"checked",b,!1)}
	function Yc(a,b){Xc(a,b);var c=Wc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Zc(a,b.type,Wc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function $c(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
	function Wc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var ad={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function bd(a,b,c){a=N.getPooled(ad.change,a,b,c);a.type="change";Wb(c);hb(a);return a}var cd=null,dd=null;function ed(a){Oa(a,!1)}
	function fd(a){var b=Ua(a);if(lc(b))return a}function gd(a,b){if("topChange"===a)return b}var hd=!1;m.canUseDOM&&(hd=hc("input")&&(!document.documentMode||9<document.documentMode));function id(){cd&&(cd.detachEvent("onpropertychange",jd),dd=cd=null)}function jd(a){"value"===a.propertyName&&fd(dd)&&(a=bd(dd,a,gc(a)),dc(ed,a))}function kd(a,b,c){"topFocus"===a?(id(),cd=b,dd=c,cd.attachEvent("onpropertychange",jd)):"topBlur"===a&&id()}
	function ld(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return fd(dd)}function md(a,b){if("topClick"===a)return fd(b)}function nd(a,b){if("topInput"===a||"topChange"===a)return fd(b)}
	var od={eventTypes:ad,_isInputEventSupported:hd,extractEvents:function(a,b,c,d){var e=b?Ua(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=gd:fc(e)?hd?f=nd:(f=ld,h=kd):(g=e.nodeName,!g||"input"!==g.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(f=md));if(f&&(f=f(a,b)))return bd(f,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&Zc(e,"number",e.value)}},pd=N.extend({view:null,
	detail:null}),qd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function rd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=qd[a])?!!b[a]:!1}function sd(){return rd}
	var td=pd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:sd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),ud={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},vd={eventTypes:ud,extractEvents:function(a,
	b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?Ta(b):null):a=null;if(a===b)return null;var f=null==a?e:Ua(a);e=null==b?e:Ua(b);var h=td.getPooled(ud.mouseLeave,a,c,d);h.type="mouseleave";h.target=f;h.relatedTarget=e;c=td.getPooled(ud.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=
	f;ib(h,c,a,b);return[h,c]}};function wd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function xd(a){return(a=a._reactInternalFiber)?2===wd(a):!1}function yd(a){2!==wd(a)?D("188"):void 0}
	function zd(a){var b=a.alternate;if(!b)return b=wd(a),3===b?D("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var h=e.child;h;){if(h===c)return yd(e),a;if(h===d)return yd(e),b;h=h.sibling}D("188")}if(c["return"]!==d["return"])c=e,d=f;else{h=!1;for(var g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}h?
	void 0:D("189")}}c.alternate!==d?D("190"):void 0}3!==c.tag?D("188"):void 0;return c.stateNode.current===c?a:b}function Ad(a){a=zd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
	function Bd(a){a=zd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var Cd=N.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Dd=N.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Ed=pd.extend({relatedTarget:null});
	function Fd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var Gd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Hd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Id=pd.extend({key:function(a){if(a.key){var b=Gd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Fd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Hd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:sd,charCode:function(a){return"keypress"===
	a.type?Fd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?Fd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Jd=td.extend({dataTransfer:null}),Kd=pd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:sd}),Ld=N.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Md=td.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Nd={},Od={};function Pd(a,b){var c=a[0].toUpperCase()+a.slice(1),d="on"+c;c="top"+c;b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Nd[a]=b;Od[c]=b}
	"blur cancel click close contextMenu copy cut doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange".split(" ").forEach(function(a){Pd(a,!0)});
	"abort animationEnd animationIteration animationStart canPlay canPlayThrough drag dragEnter dragExit dragLeave dragOver durationChange emptied encrypted ended error load loadedData loadedMetadata loadStart mouseMove mouseOut mouseOver playing progress scroll seeking stalled suspend timeUpdate toggle touchMove transitionEnd waiting wheel".split(" ").forEach(function(a){Pd(a,!1)});
	var Qd={eventTypes:Nd,isInteractiveTopLevelEventType:function(a){a=Od[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Od[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Fd(c))return null;case "topKeyDown":case "topKeyUp":a=Id;break;case "topBlur":case "topFocus":a=Ed;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=
	td;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=Jd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=Kd;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Cd;break;case "topTransitionEnd":a=Ld;break;case "topScroll":a=pd;break;case "topWheel":a=Md;break;case "topCopy":case "topCut":case "topPaste":a=Dd;break;default:a=
	N}b=a.getPooled(e,b,c,d);hb(b);return b}},Rd=Qd.isInteractiveTopLevelEventType,Sd=[];function Td(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Ta(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Pa(a.topLevelType,b,a.nativeEvent,gc(a.nativeEvent))}var Ud=!0;function Vd(a){Ud=!!a}
	function W(a,b,c){if(!c)return null;a=(Rd(a)?Wd:Xd).bind(null,a);c.addEventListener(b,a,!1)}function Yd(a,b,c){if(!c)return null;a=(Rd(a)?Wd:Xd).bind(null,a);c.addEventListener(b,a,!0)}function Wd(a,b){ac(Xd,a,b)}
	function Xd(a,b){if(Ud){var c=gc(b);c=Ta(c);null!==c&&"number"===typeof c.tag&&2!==wd(c)&&(c=null);if(Sd.length){var d=Sd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{dc(Td,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Sd.length&&Sd.push(a)}}}
	var Zd=Object.freeze({get _enabled(){return Ud},setEnabled:Vd,isEnabled:function(){return Ud},trapBubbledEvent:W,trapCapturedEvent:Yd,dispatchEvent:Xd});function $d(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
	var ae={animationend:$d("Animation","AnimationEnd"),animationiteration:$d("Animation","AnimationIteration"),animationstart:$d("Animation","AnimationStart"),transitionend:$d("Transition","TransitionEnd")},be={},ce={};m.canUseDOM&&(ce=document.createElement("div").style,"AnimationEvent"in window||(delete ae.animationend.animation,delete ae.animationiteration.animation,delete ae.animationstart.animation),"TransitionEvent"in window||delete ae.transitionend.transition);
	function de(a){if(be[a])return be[a];if(!ae[a])return a;var b=ae[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in ce)return be[a]=b[c];return a}
	var ee={topAnimationEnd:de("animationend"),topAnimationIteration:de("animationiteration"),topAnimationStart:de("animationstart"),topBlur:"blur",topCancel:"cancel",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",
	topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoad:"load",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topScroll:"scroll",topSelectionChange:"selectionchange",topTextInput:"textInput",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
	topTouchStart:"touchstart",topTransitionEnd:de("transitionend"),topWheel:"wheel"},fe={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",
	topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},ge={},he=0,ie="_reactListenersID"+(""+Math.random()).slice(2);function je(a){Object.prototype.hasOwnProperty.call(a,ie)||(a[ie]=he++,ge[a[ie]]={});return ge[a[ie]]}function ke(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function le(a,b){var c=ke(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ke(c)}}function me(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
	var ne=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,oe={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},pe=null,qe=null,re=null,se=!1;
	function ue(a,b){if(se||null==pe||pe!==ea())return null;var c=pe;"selectionStart"in c&&me(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return re&&fa(re,c)?null:(re=c,a=N.getPooled(oe.select,qe,a,b),a.type="select",a.target=pe,hb(a),a)}
	var we={eventTypes:oe,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=je(e);f=ua.onSelect;for(var h=0;h<f.length;h++){var g=f[h];if(!e.hasOwnProperty(g)||!e[g]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ua(b):window;switch(a){case "topFocus":if(fc(e)||"true"===e.contentEditable)pe=e,qe=b,re=null;break;case "topBlur":re=qe=pe=null;break;case "topMouseDown":se=!0;break;case "topContextMenu":case "topMouseUp":return se=!1,ue(c,d);case "topSelectionChange":if(ne)break;
	case "topKeyDown":case "topKeyUp":return ue(c,d)}return null}};Ma.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Ca=Xa.getFiberCurrentPropsFromNode;Da=Xa.getInstanceFromNode;Ea=Xa.getNodeFromInstance;Ma.injectEventPluginsByName({SimpleEventPlugin:Qd,EnterLeaveEventPlugin:vd,ChangeEventPlugin:od,SelectEventPlugin:we,BeforeInputEventPlugin:Qb});
	function xe(a,b,c,d){this.tag=a;this.key=c;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
	function ye(a,b,c){var d=a.alternate;null===d?(d=new xe(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
	function ze(a,b,c){var d=a.type,e=a.key;a=a.props;var f=void 0;if("function"===typeof d)f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case rc:return Ae(a.children,b,c,e);case vc:f=11;b|=3;break;case sc:f=11;b|=2;break;case oc:f=7;break;case pc:f=9;break;default:if("object"===typeof d&&null!==d)switch(d.$$typeof){case tc:f=13;break;case uc:f=12;break;case wc:f=14;break;default:if("number"===typeof d.tag)return b=d,b.pendingProps=a,b.expirationTime=c,
	b;D("130",null==d?d:typeof d,"")}else D("130",null==d?d:typeof d,"")}b=new xe(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Ae(a,b,c,d){a=new xe(10,a,d,b);a.expirationTime=c;return a}function Be(a,b,c){a=new xe(6,a,null,b);a.expirationTime=c;return a}function Ce(a,b,c){b=new xe(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var De=null,Ee=null;
	function Fe(a){return function(b){try{return a(b)}catch(c){}}}function Ge(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);De=Fe(function(a){return b.onCommitFiberRoot(c,a)});Ee=Fe(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function He(a){"function"===typeof De&&De(a)}function Ie(a){"function"===typeof Ee&&Ee(a)}new Set;
	function Je(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1,capturedValues:null}}function Ke(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}var Le=void 0,Me=void 0;
	function Ne(a){Le=Me=null;var b=a.alternate,c=a.updateQueue;null===c&&(c=a.updateQueue=Je(null));null!==b?(a=b.updateQueue,null===a&&(a=b.updateQueue=Je(null))):a=null;Le=c;Me=a!==c?a:null}function Oe(a,b){Ne(a);a=Le;var c=Me;null===c?Ke(a,b):null===a.last||null===c.last?(Ke(a,b),Ke(c,b)):(Ke(a,b),c.last=b)}function Pe(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
	function Qe(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,capturedValues:c.capturedValues,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var h=!0,g=c.first,k=!1;null!==g;){var v=g.expirationTime;if(v>f){var l=c.expirationTime;if(0===l||l>v)c.expirationTime=v;k||(k=!0,c.baseState=a)}else{k||
	(c.first=g.next,null===c.first&&(c.last=null));if(g.isReplace)a=Pe(g,d,a,e),h=!0;else if(v=Pe(g,d,a,e))a=h?A({},a,v):A(a,v),h=!1;g.isForced&&(c.hasForceUpdate=!0);null!==g.callback&&(v=c.callbackList,null===v&&(v=c.callbackList=[]),v.push(g));null!==g.capturedValue&&(v=c.capturedValues,null===v?c.capturedValues=[g.capturedValue]:v.push(g.capturedValue))}g=g.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||null!==c.capturedValues||(b.updateQueue=null);k||(c.baseState=a);
	return a}function Re(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?D("191",e):void 0;e.call(b)}}
	function Se(a,b,c,d,e){function f(a,b,c,d,e,f){if(null===b||null!==a.updateQueue&&a.updateQueue.hasForceUpdate)return!0;var n=a.stateNode;a=a.type;return"function"===typeof n.shouldComponentUpdate?n.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!fa(b,c)||!fa(d,e):!0}function h(a,b){b.updater=r;a.stateNode=b;b._reactInternalFiber=a}function g(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&
	b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&r.enqueueReplaceState(b,b.state,null)}function k(a,b,c,d){a=a.type;if("function"===typeof a.getDerivedStateFromProps)return a.getDerivedStateFromProps.call(null,c,d)}var v=a.cacheContext,l=a.getMaskedContext,p=a.getUnmaskedContext,z=a.isContextConsumer,B=a.hasContextChanged,r={isMounted:xd,enqueueSetState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Oe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!1,isForced:!1,
	capturedValue:null,next:null});b(a,f)},enqueueReplaceState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Oe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!0,isForced:!1,capturedValue:null,next:null});b(a,f)},enqueueForceUpdate:function(a,d){a=a._reactInternalFiber;d=void 0===d?null:d;var e=c(a);Oe(a,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,capturedValue:null,next:null});b(a,e)}};return{adoptClassInstance:h,callGetDerivedStateFromProps:k,
	constructClassInstance:function(a,b){var c=a.type,d=p(a),e=z(a),f=e?l(a,d):ja;c=new c(b,f);var n=null!==c.state&&void 0!==c.state?c.state:null;h(a,c);a.memoizedState=n;b=k(a,c,b,n);null!==b&&void 0!==b&&(a.memoizedState=A({},a.memoizedState,b));e&&v(a,d,f);return c},mountClassInstance:function(a,b){var c=a.type,d=a.alternate,e=a.stateNode,f=a.pendingProps,n=p(a);e.props=f;e.state=a.memoizedState;e.refs=ja;e.context=l(a,n);"function"===typeof c.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||
	"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(c=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),c!==e.state&&r.enqueueReplaceState(e,e.state,null),c=a.updateQueue,null!==c&&(e.state=Qe(d,a,c,e,f,b)));"function"===typeof e.componentDidMount&&(a.effectTag|=4)},resumeMountClassInstance:function(a,b){var c=a.type,n=a.stateNode;n.props=a.memoizedProps;n.state=
	a.memoizedState;var h=a.memoizedProps,r=a.pendingProps,z=n.context,q=p(a);q=l(a,q);(c="function"===typeof c.getDerivedStateFromProps||"function"===typeof n.getSnapshotBeforeUpdate)||"function"!==typeof n.UNSAFE_componentWillReceiveProps&&"function"!==typeof n.componentWillReceiveProps||(h!==r||z!==q)&&g(a,n,r,q);z=a.memoizedState;b=null!==a.updateQueue?Qe(null,a,a.updateQueue,n,r,b):z;var u=void 0;h!==r&&(u=k(a,n,r,b));if(null!==u&&void 0!==u){b=null===b||void 0===b?u:A({},b,u);var t=a.updateQueue;
	null!==t&&(t.baseState=A({},t.baseState,u))}if(!(h!==r||z!==b||B()||null!==a.updateQueue&&a.updateQueue.hasForceUpdate))return"function"===typeof n.componentDidMount&&(a.effectTag|=4),!1;(h=f(a,h,r,z,b,q))?(c||"function"!==typeof n.UNSAFE_componentWillMount&&"function"!==typeof n.componentWillMount||("function"===typeof n.componentWillMount&&n.componentWillMount(),"function"===typeof n.UNSAFE_componentWillMount&&n.UNSAFE_componentWillMount()),"function"===typeof n.componentDidMount&&(a.effectTag|=
	4)):("function"===typeof n.componentDidMount&&(a.effectTag|=4),d(a,r),e(a,b));n.props=r;n.state=b;n.context=q;return h},updateClassInstance:function(a,b,c){var n=b.type,x=b.stateNode;x.props=b.memoizedProps;x.state=b.memoizedState;var h=b.memoizedProps,r=b.pendingProps,q=x.context,u=p(b);u=l(b,u);(n="function"===typeof n.getDerivedStateFromProps||"function"===typeof x.getSnapshotBeforeUpdate)||"function"!==typeof x.UNSAFE_componentWillReceiveProps&&"function"!==typeof x.componentWillReceiveProps||
	(h!==r||q!==u)&&g(b,x,r,u);q=b.memoizedState;c=null!==b.updateQueue?Qe(a,b,b.updateQueue,x,r,c):q;var t=void 0;h!==r&&(t=k(b,x,r,c));if(null!==t&&void 0!==t){c=null===c||void 0===c?t:A({},c,t);var y=b.updateQueue;null!==y&&(y.baseState=A({},y.baseState,t))}if(!(h!==r||q!==c||B()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&
	q===a.memoizedState||(b.effectTag|=2048),!1;(t=f(b,h,r,q,c,u))?(n||"function"!==typeof x.UNSAFE_componentWillUpdate&&"function"!==typeof x.componentWillUpdate||("function"===typeof x.componentWillUpdate&&x.componentWillUpdate(r,c,u),"function"===typeof x.UNSAFE_componentWillUpdate&&x.UNSAFE_componentWillUpdate(r,c,u)),"function"===typeof x.componentDidUpdate&&(b.effectTag|=4),"function"===typeof x.getSnapshotBeforeUpdate&&(b.effectTag|=2048)):("function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&
	q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=2048),d(b,r),e(b,c));x.props=r;x.state=c;x.context=u;return t}}}var Te=Array.isArray;
	function Ue(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?D("110"):void 0,d=c.stateNode);d?void 0:D("147",a);var e=""+a;if(null!==b&&null!==b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ja?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?D("148"):void 0;c._owner?void 0:D("254",a)}return a}
	function Ve(a,b){"textarea"!==a.type&&D("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
	function We(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ye(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=Be(c,a.mode,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ue(a,b,c),d["return"]=a,d;d=ze(c,a.mode,d);d.ref=Ue(a,b,c);d["return"]=a;return d}function v(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
	Ce(c,a.mode,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function l(a,b,c,d,f){if(null===b||10!==b.tag)return b=Ae(c,a.mode,d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Be(""+b,a.mode,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case nc:return c=ze(b,a.mode,c),c.ref=Ue(a,null,b),c["return"]=a,c;case qc:return b=Ce(b,a.mode,c),b["return"]=a,b}if(Te(b)||yc(b))return b=Ae(b,
	a.mode,c,null),b["return"]=a,b;Ve(a,b)}return null}function z(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case nc:return c.key===e?c.type===rc?l(a,b,c.props.children,d,e):k(a,b,c,d):null;case qc:return c.key===e?v(a,b,c,d):null}if(Te(c)||yc(c))return null!==e?null:l(a,b,c,d,null);Ve(a,c)}return null}function B(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
	null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case nc:return a=a.get(null===d.key?c:d.key)||null,d.type===rc?l(b,a,d.props.children,e,d.key):k(b,a,d,e);case qc:return a=a.get(null===d.key?c:d.key)||null,v(b,a,d,e)}if(Te(d)||yc(d))return a=a.get(c)||null,l(b,a,d,e,null);Ve(b,d)}return null}function r(e,g,l,h){for(var r=null,k=null,q=g,u=g=0,t=null;null!==q&&u<l.length;u++){q.index>u?(t=q,q=null):t=q.sibling;var n=z(e,q,l[u],h);if(null===n){null===q&&(q=t);break}a&&q&&null===
	n.alternate&&b(e,q);g=f(n,g,u);null===k?r=n:k.sibling=n;k=n;q=t}if(u===l.length)return c(e,q),r;if(null===q){for(;u<l.length;u++)if(q=p(e,l[u],h))g=f(q,g,u),null===k?r=q:k.sibling=q,k=q;return r}for(q=d(e,q);u<l.length;u++)if(t=B(q,e,u,l[u],h)){if(a&&null!==t.alternate)q["delete"](null===t.key?u:t.key);g=f(t,g,u);null===k?r=t:k.sibling=t;k=t}a&&q.forEach(function(a){return b(e,a)});return r}function Q(e,g,l,h){var r=yc(l);"function"!==typeof r?D("150"):void 0;l=r.call(l);null==l?D("151"):void 0;for(var k=
	r=null,q=g,u=g=0,t=null,n=l.next();null!==q&&!n.done;u++,n=l.next()){q.index>u?(t=q,q=null):t=q.sibling;var H=z(e,q,n.value,h);if(null===H){q||(q=t);break}a&&q&&null===H.alternate&&b(e,q);g=f(H,g,u);null===k?r=H:k.sibling=H;k=H;q=t}if(n.done)return c(e,q),r;if(null===q){for(;!n.done;u++,n=l.next())n=p(e,n.value,h),null!==n&&(g=f(n,g,u),null===k?r=n:k.sibling=n,k=n);return r}for(q=d(e,q);!n.done;u++,n=l.next())if(n=B(q,e,u,n.value,h),null!==n){if(a&&null!==n.alternate)q["delete"](null===n.key?u:n.key);
	g=f(n,g,u);null===k?r=n:k.sibling=n;k=n}a&&q.forEach(function(a){return b(e,a)});return r}return function(a,d,f,g){"object"===typeof f&&null!==f&&f.type===rc&&null===f.key&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case nc:a:{var k=f.key;for(l=d;null!==l;){if(l.key===k)if(10===l.tag?f.type===rc:l.type===f.type){c(a,l.sibling);d=e(l,f.type===rc?f.props.children:f.props,g);d.ref=Ue(a,l,f);d["return"]=a;a=d;break a}else{c(a,l);break}else b(a,l);l=l.sibling}f.type===
	rc?(d=Ae(f.props.children,a.mode,g,f.key),d["return"]=a,a=d):(g=ze(f,a.mode,g),g.ref=Ue(a,d,f),g["return"]=a,a=g)}return h(a);case qc:a:{for(l=f.key;null!==d;){if(d.key===l)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],g);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Ce(f,a.mode,g);d["return"]=a;a=d}return h(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&
	6===d.tag?(c(a,d.sibling),d=e(d,f,g)):(c(a,d),d=Be(f,a.mode,g)),d["return"]=a,a=d,h(a);if(Te(f))return r(a,d,f,g);if(yc(f))return Q(a,d,f,g);l&&Ve(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:g=a.type,D("152",g.displayName||g.name||"Component")}return c(a,d)}}var Xe=We(!0),Ye=We(!1);
	function Ze(a,b,c,d,e,f,h){function g(a,b,c){k(a,b,c,b.expirationTime)}function k(a,b,c,d){b.child=null===a?Ye(b,null,c,d):Xe(b,a.child,c,d)}function v(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function l(a,b,c,d,e,f){v(a,b);if(!c&&!e)return d&&y(b,!1),r(a,b);c=b.stateNode;mc.current=b;var g=e?null:c.render();b.effectTag|=1;e&&(k(a,b,null,f),b.child=null);k(a,b,g,f);b.memoizedState=c.state;b.memoizedProps=c.props;d&&y(b,!0);return b.child}function p(a){var b=a.stateNode;
	b.pendingContext?t(a,b.pendingContext,b.pendingContext!==b.context):b.context&&t(a,b.context,!1);Y(a,b.containerInfo)}function z(a,b,c,d){var e=a.child;for(null!==e&&(e["return"]=a);null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=
	d;else break;f=f["return"]}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=e.child}if(null!==f)f["return"]=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){f=e;break}f=f["return"]}e=f}}function B(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps;if(!q()&&f===e)return b.stateNode=0,G(b),r(a,b);var l=e.value;b.memoizedProps=e;if(null===f)l=1073741823;else if(f.value===e.value){if(f.children===e.children)return b.stateNode=0,G(b),
	r(a,b);l=0}else{var u=f.value;if(u===l&&(0!==u||1/u===1/l)||u!==u&&l!==l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b);l=0}else if(l="function"===typeof d._calculateChangedBits?d._calculateChangedBits(u,l):1073741823,l|=0,0===l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b)}else z(b,d,l,c)}b.stateNode=l;G(b);g(a,b,e.children);return b.child}function r(a,b){null!==a&&b.child!==a.child?D("153"):void 0;if(null!==b.child){a=b.child;var c=ye(a,a.pendingProps,a.expirationTime);
	b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ye(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}var Q=a.shouldSetTextContent,n=a.shouldDeprioritizeSubtree,x=b.pushHostContext,Y=b.pushHostContainer,G=d.pushProvider,R=c.getMaskedContext,S=c.getUnmaskedContext,q=c.hasContextChanged,u=c.pushContextProvider,t=c.pushTopLevelContextObject,y=c.invalidateContextProvider,H=e.enterHydrationState,Wa=e.resetHydrationState,Cb=e.tryToClaimNextHydratableInstance;
	a=Se(c,f,h,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var Jc=a.adoptClassInstance,Kc=a.callGetDerivedStateFromProps,Lc=a.constructClassInstance,Db=a.mountClassInstance,Mc=a.resumeMountClassInstance,Eb=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:p(b);break;case 2:u(b);break;case 4:Y(b,b.stateNode.containerInfo);break;case 13:G(b)}return null}switch(b.tag){case 0:null!==a?D("155"):void 0;var d=b.type,
	e=b.pendingProps,f=S(b);f=R(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,"function"===typeof f.getDerivedStateFromProps&&(e=Kc(b,d,e,b.memoizedState),null!==e&&void 0!==e&&(b.memoizedState=A({},b.memoizedState,e))),e=u(b),Jc(b,d),Db(b,c),a=l(a,b,!0,e,!1,c)):(b.tag=1,g(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,q()||
	b.memoizedProps!==c?(d=S(b),d=R(b,d),e=e(c,d),b.effectTag|=1,g(a,b,e),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 2:e=u(b);null===a?null===b.stateNode?(Lc(b,b.pendingProps),Db(b,c),d=!0):d=Mc(b,c):d=Eb(a,b,c);f=!1;var h=b.updateQueue;null!==h&&null!==h.capturedValues&&(f=d=!0);return l(a,b,d,e,f,c);case 3:a:if(p(b),d=b.updateQueue,null!==d){f=b.memoizedState;e=Qe(a,b,d,null,null,c);b.memoizedState=e;d=b.updateQueue;if(null!==d&&null!==d.capturedValues)d=null;else if(f===e){Wa();a=r(a,b);break a}else d=
	e.element;f=b.stateNode;(null===a||null===a.child)&&f.hydrate&&H(b)?(b.effectTag|=2,b.child=Ye(b,null,d,c)):(Wa(),g(a,b,d));b.memoizedState=e;a=b.child}else Wa(),a=r(a,b);return a;case 5:a:{x(b);null===a&&Cb(b);e=b.type;h=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!q()&&h===d){if(h=b.mode&1&&n(e,d))b.expirationTime=1073741823;if(!h||1073741823!==c){a=r(a,b);break a}}h=d.children;Q(e,d)?h=null:f&&Q(e,f)&&(b.effectTag|=16);v(a,b);1073741823!==c&&b.mode&1&&n(e,d)?(b.expirationTime=
	1073741823,b.memoizedProps=d,a=null):(g(a,b,h),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Cb(b),b.memoizedProps=b.pendingProps,null;case 8:b.tag=7;case 7:return e=b.pendingProps,q()||b.memoizedProps!==e||(e=b.memoizedProps),d=e.children,b.stateNode=null===a?Ye(b,b.stateNode,d,c):Xe(b,a.stateNode,d,c),b.memoizedProps=e,b.stateNode;case 9:return null;case 4:return Y(b,b.stateNode.containerInfo),e=b.pendingProps,q()||b.memoizedProps!==e?(null===a?b.child=Xe(b,null,e,c):g(a,b,e),b.memoizedProps=
	e,a=b.child):a=r(a,b),a;case 14:return c=b.type.render,c=c(b.pendingProps,b.ref),g(a,b,c),b.memoizedProps=c,b.child;case 10:return c=b.pendingProps,q()||b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 11:return c=b.pendingProps.children,q()||null!==c&&b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 13:return B(a,b,c);case 12:d=b.type;f=b.pendingProps;var t=b.memoizedProps;e=d._currentValue;h=d._changedBits;if(q()||0!==h||t!==f){b.memoizedProps=
	f;t=f.unstable_observedBits;if(void 0===t||null===t)t=1073741823;b.stateNode=t;0!==(h&t)&&z(b,d,h,c);c=f.children;c=c(e);g(a,b,c);a=b.child}else a=r(a,b);return a;default:D("156")}}}}
	function $e(a,b,c,d,e){function f(a){a.effectTag|=4}var h=a.createInstance,g=a.createTextInstance,k=a.appendInitialChild,v=a.finalizeInitialChildren,l=a.prepareUpdate,p=a.persistence,z=b.getRootHostContainer,B=b.popHostContext,r=b.getHostContext,Q=b.popHostContainer,n=c.popContextProvider,x=c.popTopLevelContextObject,Y=d.popProvider,G=e.prepareToHydrateHostInstance,R=e.prepareToHydrateHostTextInstance,S=e.popHydrationState,q=void 0,u=void 0,t=void 0;a.mutation?(q=function(){},u=function(a,b,c){(b.updateQueue=
	c)&&f(b)},t=function(a,b,c,d){c!==d&&f(b)}):p?D("235"):D("236");return{completeWork:function(a,b,c){var d=b.pendingProps;switch(b.tag){case 1:return null;case 2:return n(b),a=b.stateNode,d=b.updateQueue,null!==d&&null!==d.capturedValues&&(b.effectTag&=-65,"function"===typeof a.componentDidCatch?b.effectTag|=256:d.capturedValues=null),null;case 3:Q(b);x(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)S(b),b.effectTag&=-3;q(b);a=b.updateQueue;
	null!==a&&null!==a.capturedValues&&(b.effectTag|=256);return null;case 5:B(b);c=z();var e=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,H=b.stateNode,y=r();H=l(H,e,p,d,c,y);u(a,b,H,e,p,d,c,y);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!d)return null===b.stateNode?D("166"):void 0,null;a=r();if(S(b))G(b,c,a)&&f(b);else{p=h(e,d,c,a,b);a:for(y=b.child;null!==y;){if(5===y.tag||6===y.tag)k(p,y.stateNode);else if(4!==y.tag&&null!==y.child){y.child["return"]=y;y=y.child;continue}if(y===b)break;
	for(;null===y.sibling;){if(null===y["return"]||y["return"]===b)break a;y=y["return"]}y.sibling["return"]=y["return"];y=y.sibling}v(p,e,d,c,a)&&f(b);b.stateNode=p}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)t(a,b,a.memoizedProps,d);else{if("string"!==typeof d)return null===b.stateNode?D("166"):void 0,null;a=z();c=r();S(b)?R(b)&&f(b):b.stateNode=g(d,a,c,b)}return null;case 7:(d=b.memoizedProps)?void 0:D("165");b.tag=8;e=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==
	p;){if(5===p.tag||6===p.tag||4===p.tag)D("247");else if(9===p.tag)e.push(p.pendingProps.value);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=d.handler;d=p(d.props,e);b.child=Xe(b,null!==a?a.child:null,d,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 14:return null;case 10:return null;case 11:return null;case 4:return Q(b),q(b),null;
	case 13:return Y(b),null;case 12:return null;case 0:D("167");default:D("156")}}}}
	function af(a,b,c,d,e){var f=a.popHostContainer,h=a.popHostContext,g=b.popContextProvider,k=b.popTopLevelContextObject,v=c.popProvider;return{throwException:function(a,b,c){b.effectTag|=512;b.firstEffect=b.lastEffect=null;b={value:c,source:b,stack:Ac(b)};do{switch(a.tag){case 3:Ne(a);a.updateQueue.capturedValues=[b];a.effectTag|=1024;return;case 2:if(c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&!e(c)){Ne(a);c=a.updateQueue;var d=c.capturedValues;null===d?
	c.capturedValues=[b]:d.push(b);a.effectTag|=1024;return}}a=a["return"]}while(null!==a)},unwindWork:function(a){switch(a.tag){case 2:g(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return f(a),k(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return h(a),null;case 4:return f(a),null;case 13:return v(a),null;default:return null}},unwindInterruptedWork:function(a){switch(a.tag){case 2:g(a);break;case 3:f(a);k(a);break;case 5:h(a);break;case 4:f(a);break;case 13:v(a)}}}}
	function bf(a,b){var c=b.source;null===b.stack&&Ac(c);null!==c&&zc(c);b=b.value;null!==a&&2===a.tag&&zc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}
	function cf(a,b,c,d,e){function f(a){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null)}catch(t){b(a,t)}else c.current=null}function h(a){"function"===typeof Ie&&Ie(a);switch(a.tag){case 2:f(a);var c=a.stateNode;if("function"===typeof c.componentWillUnmount)try{c.props=a.memoizedProps,c.state=a.memoizedState,c.componentWillUnmount()}catch(t){b(a,t)}break;case 5:f(a);break;case 7:g(a.stateNode);break;case 4:p&&v(a)}}function g(a){for(var b=a;;)if(h(b),null===b.child||p&&4===b.tag){if(b===
	a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function k(a){return 5===a.tag||3===a.tag||4===a.tag}function v(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?D("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c["return"]}c=!0}if(5===
	b.tag||6===b.tag)g(b),e?S(d,b.stateNode):R(d,b.stateNode);else if(4===b.tag?d=b.stateNode.containerInfo:h(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var l=a.getPublicInstance,p=a.mutation;a=a.persistence;p||(a?D("235"):D("236"));var z=p.commitMount,B=p.commitUpdate,r=p.resetTextContent,Q=p.commitTextUpdate,n=p.appendChild,
	x=p.appendChildToContainer,Y=p.insertBefore,G=p.insertInContainerBefore,R=p.removeChild,S=p.removeChildFromContainer;return{commitBeforeMutationLifeCycles:function(a,b){switch(b.tag){case 2:if(b.effectTag&2048&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;a.props=b.memoizedProps;a.state=b.memoizedState;b=a.getSnapshotBeforeUpdate(c,d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:break;default:D("163")}},commitResetTextContent:function(a){r(a.stateNode)},
	commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(k(b)){var c=b;break a}b=b["return"]}D("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:D("161")}c.effectTag&16&&(r(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||k(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==
	c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?G(b,e.stateNode,c):Y(b,e.stateNode,c):d?x(b,e.stateNode):n(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){v(a);
	a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&B(c,f,e,a,d,b)}break;case 6:null===b.stateNode?D("162"):void 0;c=b.memoizedProps;Q(b.stateNode,null!==a?a.memoizedProps:c,c);break;case 3:break;default:D("163")}},commitLifeCycles:function(a,b,c){switch(c.tag){case 2:a=
	c.stateNode;if(c.effectTag&4)if(null===b)a.props=c.memoizedProps,a.state=c.memoizedState,a.componentDidMount();else{var d=b.memoizedProps;b=b.memoizedState;a.props=c.memoizedProps;a.state=c.memoizedState;a.componentDidUpdate(d,b,a.__reactInternalSnapshotBeforeUpdate)}c=c.updateQueue;null!==c&&Re(c,a);break;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=l(c.child.stateNode);break;case 2:a=c.child.stateNode}Re(b,a)}break;case 5:a=c.stateNode;null===b&&c.effectTag&
	4&&z(a,c.type,c.memoizedProps,c);break;case 6:break;case 4:break;default:D("163")}},commitErrorLogging:function(a,b){switch(a.tag){case 2:var c=a.type;b=a.stateNode;var d=a.updateQueue;null===d||null===d.capturedValues?D("264"):void 0;var f=d.capturedValues;d.capturedValues=null;"function"!==typeof c.getDerivedStateFromCatch&&e(b);b.props=a.memoizedProps;b.state=a.memoizedState;for(c=0;c<f.length;c++){d=f[c];var g=d.value,h=d.stack;bf(a,d);b.componentDidCatch(g,{componentStack:null!==h?h:""})}break;
	case 3:c=a.updateQueue;null===c||null===c.capturedValues?D("264"):void 0;f=c.capturedValues;c.capturedValues=null;for(c=0;c<f.length;c++)d=f[c],bf(a,d),b(d.value);break;default:D("265")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=l(c);break;default:a=c}"function"===typeof b?b(a):b.current=a}},commitDetachRef:function(a){a=a.ref;null!==a&&("function"===typeof a?a(null):a.current=null)}}}var df={};
	function ef(a,b){function c(a){a===df?D("174"):void 0;return a}var d=a.getChildHostContext,e=a.getRootHostContext;a=b.createCursor;var f=b.push,h=b.pop,g=a(df),k=a(df),v=a(df);return{getHostContext:function(){return c(g.current)},getRootHostContainer:function(){return c(v.current)},popHostContainer:function(a){h(g,a);h(k,a);h(v,a)},popHostContext:function(a){k.current===a&&(h(g,a),h(k,a))},pushHostContainer:function(a,b){f(v,b,a);f(k,a,a);f(g,df,a);b=e(b);h(g,a);f(g,b,a)},pushHostContext:function(a){var b=
	c(v.current),e=c(g.current);b=d(e,a.type,b);e!==b&&(f(k,a,a),f(g,b,a))}}}
	function ff(a){function b(a,b){var c=new xe(5,null,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=h(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];p=a}var e=a.shouldSetTextContent;
	a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){D("175")},prepareToHydrateHostTextInstance:function(){D("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,h=a.canHydrateTextInstance,g=a.getNextHydratableSibling,k=a.getFirstHydratableChild,v=a.hydrateInstance,l=a.hydrateTextInstance,p=null,z=null,B=!1;return{enterHydrationState:function(a){z=
	k(a.stateNode.containerInfo);p=a;return B=!0},resetHydrationState:function(){z=p=null;B=!1},tryToClaimNextHydratableInstance:function(a){if(B){var d=z;if(d){if(!c(a,d)){d=g(d);if(!d||!c(a,d)){a.effectTag|=2;B=!1;p=a;return}b(p,z)}p=a;z=k(d)}else a.effectTag|=2,B=!1,p=a}},prepareToHydrateHostInstance:function(a,b,c){b=v(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return l(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
	p)return!1;if(!B)return d(a),B=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=z;c;)b(a,c),c=g(c);d(a);z=p?g(a.stateNode):null;return!0}}}
	function gf(a){function b(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function c(a){return 2===a.tag&&null!=a.type.childContextTypes}function d(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:D("108",zc(a)||"Unknown",e);return A({},b,c)}var e=a.createCursor,f=a.push,h=a.pop,g=e(ja),k=e(!1),v=ja;return{getUnmaskedContext:function(a){return c(a)?
	v:g.current},cacheContext:b,getMaskedContext:function(a,c){var d=a.type.contextTypes;if(!d)return ja;var e=a.stateNode;if(e&&e.__reactInternalMemoizedUnmaskedChildContext===c)return e.__reactInternalMemoizedMaskedChildContext;var f={},g;for(g in d)f[g]=c[g];e&&b(a,c,f);return f},hasContextChanged:function(){return k.current},isContextConsumer:function(a){return 2===a.tag&&null!=a.type.contextTypes},isContextProvider:c,popContextProvider:function(a){c(a)&&(h(k,a),h(g,a))},popTopLevelContextObject:function(a){h(k,
	a);h(g,a)},pushTopLevelContextObject:function(a,b,c){null!=g.cursor?D("168"):void 0;f(g,b,a);f(k,c,a)},processChildContext:d,pushContextProvider:function(a){if(!c(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ja;v=g.current;f(g,b,a);f(k,k.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:D("169");if(b){var e=d(a,v);c.__reactInternalMemoizedMergedChildContext=e;h(k,a);h(g,a);f(g,e,a)}else h(k,a);f(k,b,a)},findCurrentUnmaskedContext:function(a){for(2!==
	wd(a)||2!==a.tag?D("170"):void 0;3!==a.tag;){if(c(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:D("171")}return a.stateNode.context}}}
	function hf(a){var b=a.createCursor,c=a.push,d=a.pop,e=b(null),f=b(null),h=b(0);return{pushProvider:function(a){var b=a.type._context;c(h,b._changedBits,a);c(f,b._currentValue,a);c(e,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode},popProvider:function(a){var b=h.current,c=f.current;d(e,a);d(f,a);d(h,a);a=a.type._context;a._currentValue=c;a._changedBits=b}}}
	function jf(){var a=[],b=-1;return{createCursor:function(a){return{current:a}},isEmpty:function(){return-1===b},pop:function(c){0>b||(c.current=a[b],a[b]=null,b--)},push:function(c,d){b++;a[b]=c.current;c.current=d},checkThatStackIsEmpty:function(){},resetStackAfterFatalErrorInDev:function(){}}}
	function kf(a){function b(){if(null!==I)for(var a=I["return"];null!==a;)Lc(a),a=a["return"];Ya=null;Z=0;I=null;Nc=!1}function c(a){return null!==ya&&ya.has(a)}function d(a){for(;;){var b=a.alternate,c=a["return"],d=a.sibling;if(0===(a.effectTag&512)){b=Cb(b,a,Z);var e=a;if(1073741823===Z||1073741823!==e.expirationTime){b:switch(e.tag){case 3:case 2:var f=e.updateQueue;f=null===f?0:f.expirationTime;break b;default:f=0}for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=
	g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{Nc=!0;break}}else{a=Kc(a);if(null!==a)return a.effectTag&=2559,a;null!==c&&(c.firstEffect=c.lastEffect=
	null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}function e(a){var b=Wa(a.alternate,a,Z);null===b&&(b=d(a));mc.current=null;return b}function f(a,c,f){ca?D("243"):void 0;ca=!0;if(c!==Z||a!==Ya||null===I)b(),Ya=a,Z=c,I=ye(Ya.current,null,Z),a.pendingCommitExpirationTime=0;var g=!1;do{try{if(f)for(;null!==I&&!S();)I=e(I);else for(;null!==I;)I=e(I)}catch(Oc){if(null===I){g=!0;q(Oc);break}f=I;var h=f["return"];if(null===h){g=!0;q(Oc);break}Jc(h,f,Oc);I=d(f)}break}while(1);
	ca=!1;if(g||null!==I)return null;if(Nc)return a.pendingCommitExpirationTime=c,a.current.alternate;D("262")}function h(a,b,c,d){a={value:c,source:a,stack:Ac(a)};Oe(b,{expirationTime:d,partialState:null,callback:null,isReplace:!1,isForced:!1,capturedValue:a,next:null});v(b,d)}function g(a,b){a:{ca&&!Za?D("263"):void 0;for(var d=a["return"];null!==d;){switch(d.tag){case 2:var e=d.stateNode;if("function"===typeof d.type.getDerivedStateFromCatch||"function"===typeof e.componentDidCatch&&!c(e)){h(a,d,b,
	1);a=void 0;break a}break;case 3:h(a,d,b,1);a=void 0;break a}d=d["return"]}3===a.tag&&h(a,a,b,1);a=void 0}return a}function k(a){a=0!==ia?ia:ca?Za?1:Z:a.mode&1?za?10*(((l()+50)/10|0)+1):25*(((l()+500)/25|0)+1):1;za&&(0===da||a>da)&&(da=a);return a}function v(a,c){a:{for(;null!==a;){if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>c)&&(a.alternate.expirationTime=c);if(null===a["return"])if(3===a.tag){var d=
	a.stateNode;!ca&&0!==Z&&c<Z&&b();ca&&!Za&&Ya===d||B(d,c);Fb>wg&&D("185")}else{c=void 0;break a}a=a["return"]}c=void 0}return c}function l(){ve=Ic()-Pc;return xg=(ve/10|0)+2}function p(a,b,c,d,e){var f=ia;ia=1;try{return a(b,c,d,e)}finally{ia=f}}function z(a){if(0!==Gb){if(a>Gb)return;yg(Qc)}var b=Ic()-Pc;Gb=a;Qc=lg(Q,{timeout:10*(a-2)-b})}function B(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===K?(la=K=a,a.nextScheduledRoot=a):(K=K.nextScheduledRoot=a,K.nextScheduledRoot=la);
	else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}T||(J?Hb&&(aa=a,P=1,G(a,1,!1)):1===b?n():z(b))}function r(){var a=0,b=null;if(null!==K)for(var c=K,d=la;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===K?D("244"):void 0;if(d===d.nextScheduledRoot){la=K=d.nextScheduledRoot=null;break}else if(d===la)la=e=d.nextScheduledRoot,K.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===K){K=c;K.nextScheduledRoot=la;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=
	d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===K)break;c=d;d=d.nextScheduledRoot}}c=aa;null!==c&&c===b&&1===a?Fb++:Fb=0;aa=b;P=a}function Q(a){x(0,!0,a)}function n(){x(1,!1,null)}function x(a,b,c){$a=c;r();if(b)for(;null!==aa&&0!==P&&(0===a||a>=P)&&(!Ib||l()>=P);)G(aa,P,!Ib),r();else for(;null!==aa&&0!==P&&(0===a||a>=P);)G(aa,P,!1),r();null!==$a&&(Gb=0,Qc=-1);0!==P&&z(P);$a=null;Ib=!1;Y()}function Y(){Fb=0;if(null!==Aa){var a=Aa;Aa=null;for(var b=
	0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(vg){Ba||(Ba=!0,Jb=vg)}}}if(Ba)throw a=Jb,Jb=null,Ba=!1,a;}function G(a,b,c){T?D("245"):void 0;T=!0;c?(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!0),null!==c&&(S()?a.finishedWork=c:R(a,c,b)))):(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!1),null!==c&&R(a,c,b)));T=!1}function R(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Aa?Aa=[d]:Aa.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=
	0;return}a.finishedWork=null;Za=ca=!0;c=b.stateNode;c.current===b?D("177"):void 0;d=c.pendingCommitExpirationTime;0===d?D("261"):void 0;c.pendingCommitExpirationTime=0;var e=l();mc.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var f=b.firstEffect}else f=b;else f=b.firstEffect;zg(c.containerInfo);for(w=f;null!==w;){var h=!1,k=void 0;try{for(;null!==w;)w.effectTag&2048&&Db(w.alternate,w),w=w.nextEffect}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==
	w&&(w=w.nextEffect))}for(w=f;null!==w;){h=!1;k=void 0;try{for(;null!==w;){var p=w.effectTag;p&16&&Mc(w);if(p&128){var n=w.alternate;null!==n&&kg(n)}switch(p&14){case 2:Eb(w);w.effectTag&=-3;break;case 6:Eb(w);w.effectTag&=-3;te(w.alternate,w);break;case 4:te(w.alternate,w);break;case 8:gg(w)}w=w.nextEffect}}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==w&&(w=w.nextEffect))}Ag(c.containerInfo);c.current=b;for(w=f;null!==w;){p=!1;n=void 0;try{for(f=c,h=e,k=d;null!==w;){var r=w.effectTag;
	r&36&&hg(f,w.alternate,w,h,k);r&256&&ig(w,q);r&128&&jg(w);var t=w.nextEffect;w.nextEffect=null;w=t}}catch(ab){p=!0,n=ab}p&&(null===w?D("178"):void 0,g(w,n),null!==w&&(w=w.nextEffect))}ca=Za=!1;"function"===typeof He&&He(b.stateNode);b=c.current.expirationTime;0===b&&(ya=null);a.remainingExpirationTime=b}function S(){return null===$a||$a.timeRemaining()>Bg?!1:Ib=!0}function q(a){null===aa?D("246"):void 0;aa.remainingExpirationTime=0;Ba||(Ba=!0,Jb=a)}var u=jf(),t=ef(a,u),y=gf(u);u=hf(u);var H=ff(a),
	Wa=Ze(a,t,y,u,H,v,k).beginWork,Cb=$e(a,t,y,u,H).completeWork;t=af(t,y,u,v,c);var Jc=t.throwException,Kc=t.unwindWork,Lc=t.unwindInterruptedWork;t=cf(a,g,v,k,function(a){null===ya?ya=new Set([a]):ya.add(a)},l);var Db=t.commitBeforeMutationLifeCycles,Mc=t.commitResetTextContent,Eb=t.commitPlacement,gg=t.commitDeletion,te=t.commitWork,hg=t.commitLifeCycles,ig=t.commitErrorLogging,jg=t.commitAttachRef,kg=t.commitDetachRef,Ic=a.now,lg=a.scheduleDeferredCallback,yg=a.cancelDeferredCallback,zg=a.prepareForCommit,
	Ag=a.resetAfterCommit,Pc=Ic(),xg=2,ve=Pc,Rc=0,ia=0,ca=!1,I=null,Ya=null,Z=0,w=null,Za=!1,Nc=!1,ya=null,la=null,K=null,Gb=0,Qc=-1,T=!1,aa=null,P=0,da=0,Ib=!1,Ba=!1,Jb=null,$a=null,J=!1,Hb=!1,za=!1,Aa=null,wg=1E3,Fb=0,Bg=1;return{recalculateCurrentTime:l,computeExpirationForFiber:k,scheduleWork:v,requestWork:B,flushRoot:function(a,b){T?D("253"):void 0;aa=a;P=b;G(a,b,!1);n();Y()},batchedUpdates:function(a,b){var c=J;J=!0;try{return a(b)}finally{(J=c)||T||n()}},unbatchedUpdates:function(a,b){if(J&&!Hb){Hb=
	!0;try{return a(b)}finally{Hb=!1}}return a(b)},flushSync:function(a,b){T?D("187"):void 0;var c=J;J=!0;try{return p(a,b)}finally{J=c,n()}},flushControlled:function(a){var b=J;J=!0;try{p(a)}finally{(J=b)||T||x(1,!1,null)}},deferredUpdates:function(a){var b=ia;ia=25*(((l()+500)/25|0)+1);try{return a()}finally{ia=b}},syncUpdates:p,interactiveUpdates:function(a,b,c){if(za)return a(b,c);J||T||0===da||(x(da,!1,null),da=0);var d=za,e=J;J=za=!0;try{return a(b,c)}finally{za=d,(J=e)||T||n()}},flushInteractiveUpdates:function(){T||
	0===da||(x(da,!1,null),da=0)},computeUniqueAsyncExpiration:function(){var a=25*(((l()+500)/25|0)+1);a<=Rc&&(a=Rc+1);return Rc=a},legacyContext:y}}
	function lf(a){function b(a,b,c,d,e,f){d=b.current;if(c){c=c._reactInternalFiber;var g=k(c);c=v(c)?l(c,g):g}else c=ja;null===b.context?b.context=c:b.pendingContext=c;b=f;Oe(d,{expirationTime:e,partialState:{element:a},callback:void 0===b?null:b,isReplace:!1,isForced:!1,capturedValue:null,next:null});h(d,e);return e}function c(a){a=Ad(a);return null===a?null:a.stateNode}var d=a.getPublicInstance;a=kf(a);var e=a.recalculateCurrentTime,f=a.computeExpirationForFiber,h=a.scheduleWork,g=a.legacyContext,
	k=g.findCurrentUnmaskedContext,v=g.isContextProvider,l=g.processChildContext;return{createContainer:function(a,b,c){b=new xe(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a},updateContainer:function(a,c,d,g){var h=c.current,k=e();h=f(h);return b(a,c,d,k,h,g)},updateContainerAtExpirationTime:function(a,
	c,d,f,g){var h=e();return b(a,c,d,h,f,g)},flushRoot:a.flushRoot,requestWork:a.requestWork,computeUniqueAsyncExpiration:a.computeUniqueAsyncExpiration,batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,syncUpdates:a.syncUpdates,interactiveUpdates:a.interactiveUpdates,flushInteractiveUpdates:a.flushInteractiveUpdates,flushControlled:a.flushControlled,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return d(a.child.stateNode);
	default:return a.child.stateNode}},findHostInstance:c,findHostInstanceWithNoPortals:function(a){a=Bd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var b=a.findFiberByHostInstance;return Ge(A({},a,{findHostInstanceByFiber:function(a){return c(a)},findFiberByHostInstance:function(a){return b?b(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;
	function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:qc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};var sf=void 0,tf=void 0;
	if(m.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf=void 0;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==
	wf&&wf<=a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=
	function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})})},tf=function(a){clearTimeout(a)};function Ef(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function Ff(a,b){a=A({children:void 0},b);if(b=Ef(b.children))a.children=b;return a}
	function Gf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Hf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function If(a,b){null!=b.dangerouslySetInnerHTML?D("91"):void 0;return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?D("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:D("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
	function Kf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Lf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Mf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Of(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pf=void 0,Qf=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mf.svg||"innerHTML"in a)a.innerHTML=b;else{Pf=Pf||document.createElement("div");Pf.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=Pf.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rf(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var Sf={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
	stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Tf=["Webkit","ms","Moz","O"];Object.keys(Sf).forEach(function(a){Tf.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Sf[b]=Sf[a]})});
	function Uf(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Sf.hasOwnProperty(e)&&Sf[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Vf=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function Wf(a,b,c){b&&(Vf[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?D("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?D("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:D("61")),null!=b.style&&"object"!==typeof b.style?D("62",c()):void 0)}
	function Xf(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Yf=Mf.html,Zf=C.thatReturns("");
	function $f(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=je(a);b=ua[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?Yd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(Yd("topFocus","focus",a),Yd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(hc("cancel",!0)&&Yd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(hc("close",!0)&&Yd("topClose","close",a),c.topClose=!0):ee.hasOwnProperty(e)&&W(e,ee[e],a),c[e]=!0)}}
	function ag(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Yf&&(d=Nf(a));d===Yf?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function bg(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
	function cg(a,b,c,d){var e=Xf(b,c);switch(b){case "iframe":case "object":W("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in fe)fe.hasOwnProperty(f)&&W(f,fe[f],a);f=c;break;case "source":W("topError","error",a);f=c;break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);f=c;break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);f=c;break;case "details":W("topToggle","toggle",a);f=c;break;case "input":Vc(a,c);f=Uc(a,c);W("topInvalid",
	"invalid",a);$f(d,"onChange");break;case "option":f=Ff(a,c);break;case "select":Hf(a,c);f=A({},c,{value:void 0});W("topInvalid","invalid",a);$f(d,"onChange");break;case "textarea":Jf(a,c);f=If(a,c);W("topInvalid","invalid",a);$f(d,"onChange");break;default:f=c}Wf(b,f,Zf);var h=f,g;for(g in h)if(h.hasOwnProperty(g)){var k=h[g];"style"===g?Uf(a,k,Zf):"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,null!=k&&Qf(a,k)):"children"===g?"string"===typeof k?("textarea"!==b||""!==k)&&Rf(a,k):"number"===typeof k&&
	Rf(a,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(ta.hasOwnProperty(g)?null!=k&&$f(d,g):null!=k&&Tc(a,g,k,e))}switch(b){case "input":kc(a);$c(a,c);break;case "textarea":kc(a);Lf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Gf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Gf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=C)}}
	function dg(a,b,c,d,e){var f=null;switch(b){case "input":c=Uc(a,c);d=Uc(a,d);f=[];break;case "option":c=Ff(a,c);d=Ff(a,d);f=[];break;case "select":c=A({},c,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":c=If(a,c);d=If(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}Wf(b,d,Zf);b=a=void 0;var h=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var g=c[a];for(b in g)g.hasOwnProperty(b)&&(h||
	(h={}),h[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ta.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];g=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==g&&(null!=k||null!=g))if("style"===a)if(g){for(b in g)!g.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(h||(h={}),h[b]="");for(b in k)k.hasOwnProperty(b)&&g[b]!==k[b]&&(h||(h={}),h[b]=k[b])}else h||(f||(f=[]),f.push(a,h)),
	h=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,g=g?g.__html:void 0,null!=k&&g!==k&&(f=f||[]).push(a,""+k)):"children"===a?g===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ta.hasOwnProperty(a)?(null!=k&&$f(e,a),f||g===k||(f=[])):(f=f||[]).push(a,k))}h&&(f=f||[]).push("style",h);return f}
	function eg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Xc(a,e);Xf(c,d);d=Xf(c,e);for(var f=0;f<b.length;f+=2){var h=b[f],g=b[f+1];"style"===h?Uf(a,g,Zf):"dangerouslySetInnerHTML"===h?Qf(a,g):"children"===h?Rf(a,g):Tc(a,h,g,d)}switch(c){case "input":Yc(a,e);break;case "textarea":Kf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Gf(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
	Gf(a,!!e.multiple,e.defaultValue,!0):Gf(a,!!e.multiple,e.multiple?[]:"",!1))}}
	function fg(a,b,c,d,e){switch(b){case "iframe":case "object":W("topLoad","load",a);break;case "video":case "audio":for(var f in fe)fe.hasOwnProperty(f)&&W(f,fe[f],a);break;case "source":W("topError","error",a);break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);break;case "details":W("topToggle","toggle",a);break;case "input":Vc(a,c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "select":Hf(a,
	c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "textarea":Jf(a,c),W("topInvalid","invalid",a),$f(e,"onChange")}Wf(b,c,Zf);d=null;for(var h in c)c.hasOwnProperty(h)&&(f=c[h],"children"===h?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):ta.hasOwnProperty(h)&&null!=f&&$f(e,h));switch(b){case "input":kc(a);$c(a,c);break;case "textarea":kc(a);Lf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
	(a.onclick=C)}return d}function mg(a,b){return a.nodeValue!==b}
	var ng=Object.freeze({createElement:ag,createTextNode:bg,setInitialProperties:cg,diffProperties:dg,updateProperties:eg,diffHydratedProperties:fg,diffHydratedText:mg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
	c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Va(d);e?void 0:D("90");lc(d);Yc(d,e)}}}break;case "textarea":Kf(a,c);break;case "select":b=c.value,null!=b&&Gf(a,!!c.multiple,b,!1)}}});Vb.injectFiberControlledHostComponent(ng);var og=null,pg=null;
	function qg(a){this._expirationTime=X.computeUniqueAsyncExpiration();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}qg.prototype.render=function(a){this._defer?void 0:D("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new rg;X.updateContainerAtExpirationTime(a,b,null,c,d._onCommit);return d};
	qg.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	qg.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:D("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?D("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;X.flushRoot(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
	null,this._defer=!1};qg.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function rg(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}rg.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	rg.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?D("191",c):void 0;c()}}};function sg(a,b,c){this._internalRoot=X.createContainer(a,b,c)}sg.prototype.render=function(a,b){var c=this._internalRoot,d=new rg;b=void 0===b?null:b;null!==b&&d.then(b);X.updateContainer(a,c,null,d._onCommit);return d};
	sg.prototype.unmount=function(a){var b=this._internalRoot,c=new rg;a=void 0===a?null:a;null!==a&&c.then(a);X.updateContainer(null,b,null,c._onCommit);return c};sg.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new rg;c=void 0===c?null:c;null!==c&&e.then(c);X.updateContainer(b,d,a,e._onCommit);return e};
	sg.prototype.createBatch=function(){var a=new qg(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function tg(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
	function ug(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	var X=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:Of(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=Of(a,b)}return a},getChildHostContext:function(a,b){return Of(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){og=Ud;var a=ea();if(me(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
	if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(B){b=null;break a}var f=0,h=-1,g=-1,k=0,v=0,l=a,p=null;b:for(;;){for(var z;;){l!==b||0!==d&&3!==l.nodeType||(h=f+d);l!==e||0!==c&&3!==l.nodeType||(g=f+c);3===l.nodeType&&(f+=l.nodeValue.length);if(null===(z=l.firstChild))break;p=l;l=z}for(;;){if(l===a)break b;p===b&&++k===d&&(h=f);p===e&&++v===c&&(g=f);if(null!==(z=l.nextSibling))break;l=p;p=l.parentNode}l=z}b=-1===h||-1===g?null:
	{start:h,end:g}}else b=null}b=b||{start:0,end:0}}else b=null;pg={focusedElem:a,selectionRange:b};Vd(!1)},resetAfterCommit:function(){var a=pg,b=ea(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&ha(document.documentElement,c)){if(me(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[lb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
	d&&(e=d,d=a,a=e);e=le(c,a);var f=le(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var h=document.createRange();h.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(h),b.extend(f.node,f.offset)):(h.setEnd(f.node,f.offset),b.addRange(h))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,
	a.element.scrollTop=a.top}pg=null;Vd(og);og=null},createInstance:function(a,b,c,d,e){a=ag(a,b,c,d);a[F]=e;a[Sa]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){cg(a,b,c,d);return ug(b,c)},prepareUpdate:function(a,b,c,d,e){return dg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===
	typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=bg(a,b);a[F]=d;return a},now:rf,mutation:{commitMount:function(a,b,c){ug(b,c)&&a.focus()},commitUpdate:function(a,b,c,d,e){a[Sa]=e;eg(a,b,c,d,e)},resetTextContent:function(a){Rf(a,"")},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},
	insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=
	a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[F]=f;a[Sa]=c;return fg(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[F]=c;return mg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},
	didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf}),Cg=X;$b=Cg.batchedUpdates;ac=Cg.interactiveUpdates;bc=Cg.flushInteractiveUpdates;
	function Dg(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new sg(a,!1,b)}
	function Eg(a,b,c,d,e){tg(c)?void 0:D("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var h=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);h.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Dg(c,d);if("function"===typeof e){var g=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);g.call(a)}}X.unbatchedUpdates(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return X.getPublicRootInstance(f._internalRoot)}
	function Fg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;tg(b)?void 0:D("200");return pf(a,b,null,c)}
	var Gg={createPortal:Fg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return X.findHostInstance(b);"function"===typeof a.render?D("188"):D("213",Object.keys(a))},hydrate:function(a,b,c){return Eg(null,a,b,!0,c)},render:function(a,b,c){return Eg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?D("38"):void 0;return Eg(a,b,c,!1,d)},unmountComponentAtNode:function(a){tg(a)?void 0:
	D("40");return a._reactRootContainer?(X.unbatchedUpdates(function(){Eg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Fg.apply(void 0,arguments)},unstable_batchedUpdates:X.batchedUpdates,unstable_deferredUpdates:X.deferredUpdates,flushSync:X.flushSync,unstable_flushControlled:X.flushControlled,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Qa,EventPluginRegistry:xa,EventPropagators:jb,ReactControlledComponent:Zb,ReactDOMComponentTree:Xa,
	ReactDOMEventListener:Zd},unstable_createRoot:function(a,b){return new sg(a,!0,null!=b&&!0===b.hydrate)}};X.injectIntoDevTools({findFiberByHostInstance:Ta,bundleType:0,version:"16.3.1",rendererPackageName:"react-dom"});var Hg=Object.freeze({default:Gg}),Ig=Hg&&Gg||Hg;module.exports=Ig["default"]?Ig["default"]:Ig;


/***/ }),
/* 4388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(4385);
	} else {
	  module.exports = require('./cjs/react-dom-server.browser.development.js');
	}


/***/ }),
/* 4389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(4386);
	} else {
	  module.exports = require('./cjs/react-dom-test-utils.development.js');
	}


/***/ }),
/* 4390 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(2), __webpack_require__(3));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 2);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = warn;
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trim;
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	
	function trim(s) {
	  return s.replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.testModeAPI = exports.OutboundLink = exports.plugin = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	
	var _format2 = __webpack_require__(3);
	
	var _format3 = _interopRequireDefault(_format2);
	
	var _removeLeadingSlash = __webpack_require__(6);
	
	var _removeLeadingSlash2 = _interopRequireDefault(_removeLeadingSlash);
	
	var _trim = __webpack_require__(1);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	var _loadGA = __webpack_require__(7);
	
	var _loadGA2 = _interopRequireDefault(_loadGA);
	
	var _warn = __webpack_require__(0);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	var _log = __webpack_require__(8);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _testModeAPI = __webpack_require__(9);
	
	var _testModeAPI2 = _interopRequireDefault(_testModeAPI);
	
	var _OutboundLink = __webpack_require__(10);
	
	var _OutboundLink2 = _interopRequireDefault(_OutboundLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
	                                                                                                                                                                                                     * React Google Analytics Module
	                                                                                                                                                                                                     *
	                                                                                                                                                                                                     * @package react-ga
	                                                                                                                                                                                                     * @author  Adam Lofting <adam@mozillafoundation.org>
	                                                                                                                                                                                                     *          Atul Varma <atul@mozillafoundation.org>
	                                                                                                                                                                                                     */
	
	/**
	 * Utilities
	 */
	
	
	var _debug = false;
	var _titleCase = true;
	var _testMode = false;
	var _alwaysSendToDefaultTracker = true;
	
	var internalGa = function internalGa() {
	  var _window;
	
	  if (_testMode) return _testModeAPI2.default.ga.apply(_testModeAPI2.default, arguments);
	  if (!window.ga) return (0, _warn2.default)('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
	  return (_window = window).ga.apply(_window, arguments);
	};
	
	function _format(s) {
	  return (0, _format3.default)(s, _titleCase);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn2.default)('ga command must be a string');
	      return;
	    }
	
	    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(undefined, args);
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(undefined, _toConsumableArray([name + '.' + command].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn2.default)('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function initialize(configsOrTrackingId, options) {
	  if (options && options.testMode === true) {
	    _testMode = true;
	  } else {
	    if (typeof window === 'undefined') {
	      return false;
	    }
	
	    (0, _loadGA2.default)(options);
	  }
	
	  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
	
	  if (Array.isArray(configsOrTrackingId)) {
	    configsOrTrackingId.forEach(function (config) {
	      if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
	        (0, _warn2.default)('All configs must be an object');
	        return;
	      }
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configsOrTrackingId, options);
	  }
	  return true;
	}
	
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	function ga() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(undefined, args);
	    if (_debug) {
	      (0, _log2.default)('called ga(\'arguments\');');
	      (0, _log2.default)('with arguments: ' + JSON.stringify(args));
	    }
	  }
	
	  return window.ga;
	}
	
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn2.default)('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if ((typeof fieldsObject === 'undefined' ? 'undefined' : _typeof(fieldsObject)) !== 'object') {
	    (0, _warn2.default)('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn2.default)('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log2.default)('called ga(\'set\', fieldsObject);');
	    (0, _log2.default)('with fieldsObject: ' + JSON.stringify(fieldsObject));
	  }
	}
	
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	  if (_debug) {
	    (0, _log2.default)('called ga(\'send\', fieldObject);');
	    (0, _log2.default)('with fieldObject: ' + JSON.stringify(fieldObject));
	    (0, _log2.default)('with trackers: ' + JSON.stringify(trackerNames));
	  }
	}
	
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 * @param {String} title - (optional) the page title e. g. 'My Website'
	 */
	function pageview(rawPath, trackerNames, title) {
	  if (!rawPath) {
	    (0, _warn2.default)('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim2.default)(rawPath);
	  if (path === '') {
	    (0, _warn2.default)('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  var extraFields = {};
	  if (title) {
	    extraFields.title = title;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', _extends({
	      hitType: 'pageview',
	      page: path
	    }, extraFields));
	
	    if (_debug) {
	      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
	      var extraLog = '';
	      if (title) {
	        extraLog = ' and title: ' + title;
	      }
	      (0, _log2.default)('with path: ' + path + extraLog);
	    }
	  }
	}
	
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn2.default)('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash2.default)((0, _trim2.default)(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn2.default)('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = '/modal/' + modalName;
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
	      (0, _log2.default)('with path: ' + path);
	    }
	  }
	}
	
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments[1];
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || !value || typeof value !== 'number') {
	      (0, _warn2.default)('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    }
	
	    // Required Fields
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param args.transport {string} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var trackerNames = arguments[1];
	
	  var category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ['category', 'action', 'label', 'value', 'nonInteraction', 'transport']);
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn2.default)('args.category AND args.action are required in event()');
	      return;
	    }
	
	    // Required Fields
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    };
	
	    // Optional Fields
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn2.default)('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn2.default)('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn2.default)('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn2.default)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	
	    // Send to GA
	    send(fieldObject, trackerNames);
	  }
	}
	
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    };
	
	    // Optional Fields
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn2.default)('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    }
	
	    // Send to GA
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = exports.plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   */
	  require: function require(rawName, options) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn2.default)('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim2.default)(rawName);
	      if (name === '') {
	        (0, _warn2.default)('`name` cannot be an empty string in .require()');
	        return;
	      }
	
	      // Optional Fields
	      if (options) {
	        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
	          (0, _warn2.default)('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn2.default)('Empty `options` given to .require()');
	        }
	
	        ga('require', name, options);
	
	        if (_debug) {
	          (0, _log2.default)('called ga(\'require\', \'' + name + '\', ' + JSON.stringify(options));
	        }
	      } else {
	        ga('require', name);
	
	        if (_debug) {
	          (0, _log2.default)('called ga(\'require\', \'' + name + '\');');
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload = void 0;
	    var actionType = void 0;
	
	    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
	      payload = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      actionType = arguments.length <= 2 ? undefined : arguments[2];
	      payload = arguments.length <= 3 ? undefined : arguments[3];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn2.default)('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn2.default)('Expected `action` arg to be a String.');
	      } else {
	        var command = pluginName + ':' + action;
	        payload = payload || null;
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	          if (_debug) {
	            (0, _log2.default)('called ga(\'' + command + '\');');
	            (0, _log2.default)('actionType: "' + actionType + '" with payload: ' + JSON.stringify(payload));
	          }
	        } else if (payload) {
	          ga(command, payload);
	          if (_debug) {
	            (0, _log2.default)('called ga(\'' + command + '\');');
	            (0, _log2.default)('with payload: ' + JSON.stringify(payload));
	          }
	        } else {
	          ga(command);
	          if (_debug) {
	            (0, _log2.default)('called ga(\'' + command + '\');');
	          }
	        }
	      }
	    }
	  }
	};
	
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn2.default)('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn2.default)('args.label is required in outboundLink()');
	      return;
	    }
	
	    // Required Fields
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	
	    var safetyCallbackCalled = false;
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	
	      hitCallback();
	    };
	
	    // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	
	    // register safety net timeout:
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA;
	
	    // Send to GA
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	_OutboundLink2.default.origTrackLink = _OutboundLink2.default.trackLink;
	_OutboundLink2.default.trackLink = outboundLink;
	var OutboundLink = exports.OutboundLink = _OutboundLink2.default;
	var testModeAPI = exports.testModeAPI = _testModeAPI2.default;
	
	exports.default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  OutboundLink: OutboundLink,
	  testModeAPI: _testModeAPI2.default
	};
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	
	var _mightBeEmail = __webpack_require__(4);
	
	var _mightBeEmail2 = _interopRequireDefault(_mightBeEmail);
	
	var _toTitleCase = __webpack_require__(5);
	
	var _toTitleCase2 = _interopRequireDefault(_toTitleCase);
	
	var _warn = __webpack_require__(0);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function format(s, titleCase) {
	  if ((0, _mightBeEmail2.default)(s)) {
	    (0, _warn2.default)('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  if (titleCase) {
	    return (0, _toTitleCase2.default)(s);
	  }
	
	  return s;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mightBeEmail;
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return (/[^@]+@[^@]+/.test(s)
	  );
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toTitleCase;
	
	var _trim = __webpack_require__(1);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; /**
	                                                                                                * To Title Case 2.1 - http://individed.com/code/to-title-case/
	                                                                                                * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	                                                                                                * https://github.com/gouch/to-title-case
	                                                                                                */
	
	function toTitleCase(string) {
	  return (0, _trim2.default)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeLeadingSlash;
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (options) {
	  // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	  /* eslint-disable */
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', options && options.gaAddress ? options.gaAddress : 'https://www.google-analytics.com/analytics.js', 'ga');
	  /* eslint-enable */
	};
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = log;
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var gaCalls = exports.gaCalls = [];
	
	exports.default = {
	  calls: gaCalls,
	  ga: function ga() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    gaCalls.push([].concat(args));
	  }
	};
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(11);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(12);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warn = __webpack_require__(0);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink = function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  function OutboundLink() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OutboundLink.__proto__ || Object.getPrototypeOf(OutboundLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick;
	
	      var eventMeta = { label: eventLabel };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        });
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {});
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(OutboundLink, [{
	    key: 'render',
	    value: function render() {
	      var props = _extends({}, this.props, {
	        href: this.props.to,
	        onClick: this.handleClick
	      });
	      delete props.eventLabel;
	      return _react2.default.createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	OutboundLink.propTypes = {
	  eventLabel: _propTypes2.default.string.isRequired,
	  target: _propTypes2.default.string,
	  to: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	OutboundLink.defaultProps = {
	  target: null,
	  to: null,
	  onClick: null
	};
	
	OutboundLink.trackLink = function () {
	  (0, _warn2.default)('ga tracking not enabled');
	};
	
	exports.default = OutboundLink;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_11__;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_12__;
	
	/***/ })
	/******/ ]);
	});

/***/ }),
/* 4391 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(33);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(717);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 4392 */
/***/ (function(module, exports) {

	/** @license React v16.3.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var b="function"===typeof Symbol&&Symbol["for"],c=b?Symbol["for"]("react.element"):60103,d=b?Symbol["for"]("react.portal"):60106,e=b?Symbol["for"]("react.fragment"):60107,f=b?Symbol["for"]("react.strict_mode"):60108,g=b?Symbol["for"]("react.provider"):60109,h=b?Symbol["for"]("react.context"):60110,k=b?Symbol["for"]("react.async_mode"):60111,l=b?Symbol["for"]("react.forward_ref"):60112;
	function m(a){if("object"===typeof a&&null!==a){var n=a.$$typeof;switch(n){case c:switch(a=a.type,a){case k:case e:case f:return a;default:switch(a=a&&a.$$typeof,a){case h:case l:case g:return a;default:return n}}case d:return n}}}exports.typeOf=m;exports.AsyncMode=k;exports.ContextConsumer=h;exports.ContextProvider=g;exports.Element=c;exports.ForwardRef=l;exports.Fragment=e;exports.Portal=d;exports.StrictMode=f;
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===k||a===f||"object"===typeof a&&null!==a&&(a.$$typeof===g||a.$$typeof===h||a.$$typeof===l)};exports.isAsyncMode=function(a){return m(a)===k};exports.isContextConsumer=function(a){return m(a)===h};exports.isContextProvider=function(a){return m(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return m(a)===l};
	exports.isFragment=function(a){return m(a)===e};exports.isPortal=function(a){return m(a)===d};exports.isStrictMode=function(a){return m(a)===f};


/***/ }),
/* 4393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(4392);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 4394 */,
/* 4395 */,
/* 4396 */,
/* 4397 */,
/* 4398 */,
/* 4399 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.2.0
	 * react-reconciler-reflection.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});function k(b){for(var a=arguments.length-1,c="Minified React error #"+b+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+b,d=0;d<a;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);a=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");a.name="Invariant Violation";a.framesToPop=1;throw a;}__webpack_require__(2);
	function l(b){var a=b;if(b.alternate)for(;a["return"];)a=a["return"];else{if(0!==(a.effectTag&2))return 1;for(;a["return"];)if(a=a["return"],0!==(a.effectTag&2))return 1}return 3===a.tag?2:3}function m(b){2!==l(b)?k("188"):void 0}
	function n(b){var a=b.alternate;if(!a)return a=l(b),3===a?k("188"):void 0,1===a?null:b;for(var c=b,d=a;;){var e=c["return"],h=e?e.alternate:null;if(!e||!h)break;if(e.child===h.child){for(var f=e.child;f;){if(f===c)return m(e),b;if(f===d)return m(e),a;f=f.sibling}k("188")}if(c["return"]!==d["return"])c=e,d=h;else{f=!1;for(var g=e.child;g;){if(g===c){f=!0;c=e;d=h;break}if(g===d){f=!0;d=e;c=h;break}g=g.sibling}if(!f){for(g=h.child;g;){if(g===c){f=!0;c=h;d=e;break}if(g===d){f=!0;d=h;c=e;break}g=g.sibling}f?
	void 0:k("189")}}c.alternate!==d?k("190"):void 0}3!==c.tag?k("188"):void 0;return c.stateNode.current===c?b:a}exports.isFiberMounted=function(b){return 2===l(b)};exports.isMounted=function(b){return(b=b._reactInternalFiber)?2===l(b):!1};exports.findCurrentFiberUsingSlowPath=n;
	exports.findCurrentHostFiber=function(b){b=n(b);if(!b)return null;for(var a=b;;){if(5===a.tag||6===a.tag)return a;if(a.child)a.child["return"]=a,a=a.child;else{if(a===b)break;for(;!a.sibling;){if(!a["return"]||a["return"]===b)return null;a=a["return"]}a.sibling["return"]=a["return"];a=a.sibling}}return null};
	exports.findCurrentHostFiberWithNoPortals=function(b){b=n(b);if(!b)return null;for(var a=b;;){if(5===a.tag||6===a.tag)return a;if(a.child&&4!==a.tag)a.child["return"]=a,a=a.child;else{if(a===b)break;for(;!a.sibling;){if(!a["return"]||a["return"]===b)return null;a=a["return"]}a.sibling["return"]=a["return"];a=a.sibling}}return null};


/***/ }),
/* 4400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(4399);
	} else {
	  module.exports = require('./cjs/react-reconciler-reflection.development.js');
	}


/***/ }),
/* 4401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(721);
	
	var _warning = __webpack_require__(498);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ }),
/* 4402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(719);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(4409);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(4403);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(4404);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(4405);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(4406);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ }),
/* 4403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(27);
	
	var _wrapMapToProps = __webpack_require__(720);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ }),
/* 4404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(720);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ }),
/* 4405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(722);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ }),
/* 4406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(4407);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),
/* 4407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(498);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),
/* 4408 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ }),
/* 4409 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 4410 */,
/* 4411 */,
/* 4412 */,
/* 4413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(733);
	
	var _reducer = __webpack_require__(727);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConnectedRouter = function (_Component) {
	  _inherits(ConnectedRouter, _Component);
	
	  function ConnectedRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ConnectedRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLocationChange = function (location) {
	      _this.store.dispatch({
	        type: _reducer.LOCATION_CHANGE,
	        payload: location
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        propsStore = _props.store,
	        history = _props.history,
	        isSSR = _props.isSSR;
	
	    this.store = propsStore || this.context.store;
	    this.handleLocationChange(history.location);
	
	    if (!isSSR) this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
	  };
	
	  ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
	  };
	
	  ConnectedRouter.prototype.render = function render() {
	    return _react2.default.createElement(_reactRouter.Router, this.props);
	  };
	
	  return ConnectedRouter;
	}(_react.Component);
	
	ConnectedRouter.propTypes = {
	  store: _propTypes2.default.object,
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node,
	  isSSR: _propTypes2.default.bool
	};
	ConnectedRouter.contextTypes = {
	  store: _propTypes2.default.object
	};
	exports.default = ConnectedRouter;

/***/ }),
/* 4414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerMiddleware;
	
	var _actions = __webpack_require__(726);
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, args);
	      };
	    };
	  };
	}

/***/ }),
/* 4415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMatchSelector = exports.getLocation = undefined;
	
	var _reactRouter = __webpack_require__(733);
	
	var getLocation = exports.getLocation = function getLocation(state) {
	  return state.router.location;
	};
	
	var createMatchSelector = exports.createMatchSelector = function createMatchSelector(path) {
	  var lastPathname = null;
	  var lastMatch = null;
	  return function (state) {
	    var _ref = getLocation(state) || {},
	        pathname = _ref.pathname;
	
	    if (pathname === lastPathname) {
	      return lastMatch;
	    }
	    lastPathname = pathname;
	    var match = (0, _reactRouter.matchPath)(pathname, path);
	    if (!match || !lastMatch || match.url !== lastMatch.url) {
	      lastMatch = match;
	    }
	    return lastMatch;
	  };
	};

/***/ }),
/* 4416 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 4417 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(340);
	
	var invariant = __webpack_require__(134);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 4418 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(33);
	
	var ReactBaseClasses = __webpack_require__(734);
	var ReactChildren = __webpack_require__(4419);
	var ReactDOMFactories = __webpack_require__(4420);
	var ReactElement = __webpack_require__(187);
	var ReactPropTypes = __webpack_require__(4421);
	var ReactVersion = __webpack_require__(4422);
	
	var createReactClass = __webpack_require__(4423);
	var onlyChild = __webpack_require__(4426);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 4419 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(4417);
	var ReactElement = __webpack_require__(187);
	
	var emptyFunction = __webpack_require__(99);
	var traverseAllChildren = __webpack_require__(4427);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 4420 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(187);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 4421 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(187),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(4379);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 4422 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 4423 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(734),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(187),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(737);
	var factory = __webpack_require__(1129);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 4424 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 4425 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 4426 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(340);
	
	var ReactElement = __webpack_require__(187);
	
	var invariant = __webpack_require__(134);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 4427 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(340);
	
	var ReactCurrentOwner = __webpack_require__(735);
	var REACT_ELEMENT_TYPE = __webpack_require__(736);
	
	var getIteratorFn = __webpack_require__(4424);
	var invariant = __webpack_require__(134);
	var KeyEscapeUtils = __webpack_require__(4416);
	var warning = __webpack_require__(313);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 4428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(1192));
	var shallowEqual = _interopDefault(__webpack_require__(4761));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),
/* 4429 */,
/* 4430 */,
/* 4431 */,
/* 4432 */,
/* 4433 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.3.1
	 * react-test-renderer-shallow.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var e=__webpack_require__(33),l=__webpack_require__(2),m=__webpack_require__(4393),n=__webpack_require__(176),p=__webpack_require__(619),q=__webpack_require__(714);
	function r(b){for(var a=arguments.length-1,c="Minified React error #"+b+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+b,d=0;d<a;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);a=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");a.name="Invariant Violation";a.framesToPop=1;throw a;}
	var t="function"===typeof Symbol&&Symbol["for"],u=t?Symbol["for"]("react.call"):60104,v=t?Symbol["for"]("react.return"):60105,x=t?Symbol["for"]("react.portal"):60106,y=t?Symbol["for"]("react.fragment"):60107;function z(b){b=b.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case y:return"ReactFragment";case x:return"ReactPortal";case u:return"ReactCall";case v:return"ReactReturn"}return null}
	function A(b,a){if(!(b instanceof a))throw new TypeError("Cannot call a class as a function");}
	var E=function(){function b(){A(this,b);this._rendered=this._newState=this._instance=this._element=this._context=null;this._forcedUpdate=this._rendering=!1;this._updater=new B(this)}b.prototype.getMountedInstance=function(){return this._instance};b.prototype.getRenderOutput=function(){return this._rendered};b.prototype.render=function(a){var c=1<arguments.length&&void 0!==arguments[1]?arguments[1]:n;l.isValidElement(a)?void 0:r("12","function"===typeof a?" Instead of passing a component class, make sure to instantiate it by passing it to React.createElement.":
	"");"string"===typeof a.type?r("13",a.type):void 0;m.isForwardRef(a)||"function"===typeof a.type?void 0:r("249",Array.isArray(a.type)?"array":null===a.type?"null":typeof a.type);if(!this._rendering){this._rendering=!0;this._element=a;var b=a.type.contextTypes;if(b){var g={},f;for(f in b)g[f]=c[f];c=g}else c=n;this._context=c;this._instance?this._updateClassComponent(a,this._context):m.isForwardRef(a)?this._rendered=a.type.render(a.props,a.ref):(c=a.type,c.prototype&&c.prototype.isReactComponent?(this._instance=
	new a.type(a.props,this._context,this._updater),this._updateStateFromStaticLifecycle(a.props),a.type.hasOwnProperty("contextTypes")&&(C=a,c=a.type,b=(b=this._instance)&&b.constructor,q(a.type.contextTypes,this._context,"context",c.displayName||b&&b.displayName||c.name||b&&b.name||null,D),C=null),this._mountClassComponent(a,this._context)):this._rendered=a.type(a.props,this._context));this._rendering=!1;this._updater._invokeCallbacks();return this.getRenderOutput()}};b.prototype.unmount=function(){this._instance&&
	"function"===typeof this._instance.componentWillUnmount&&this._instance.componentWillUnmount();this._instance=this._rendered=this._newState=this._element=this._context=null};b.prototype._mountClassComponent=function(a,c){this._instance.context=c;this._instance.props=a.props;this._instance.state=this._instance.state||null;this._instance.updater=this._updater;if("function"===typeof this._instance.UNSAFE_componentWillMount||"function"===typeof this._instance.componentWillMount)c=this._newState,"function"!==
	typeof a.type.getDerivedStateFromProps&&"function"!==typeof this._instance.getSnapshotBeforeUpdate&&("function"===typeof this._instance.componentWillMount&&this._instance.componentWillMount(),"function"===typeof this._instance.UNSAFE_componentWillMount&&this._instance.UNSAFE_componentWillMount()),c!==this._newState&&(this._instance.state=this._newState||n);this._rendered=this._instance.render()};b.prototype._updateClassComponent=function(a,c){var b=a.props,g=a.type,f=this._instance.state||n,w=this._instance.props;
	w!==b&&("function"!==typeof a.type.getDerivedStateFromProps&&"function"!==typeof this._instance.getSnapshotBeforeUpdate&&("function"===typeof this._instance.componentWillReceiveProps&&this._instance.componentWillReceiveProps(b,c),"function"===typeof this._instance.UNSAFE_componentWillReceiveProps&&this._instance.UNSAFE_componentWillReceiveProps(b,c)),this._updateStateFromStaticLifecycle(b));var h=this._newState||f,k=!0;this._forcedUpdate?(k=!0,this._forcedUpdate=!1):"function"===typeof this._instance.shouldComponentUpdate?
	k=!!this._instance.shouldComponentUpdate(b,h,c):g.prototype&&g.prototype.isPureReactComponent&&(k=!p(w,b)||!p(f,h));k&&"function"!==typeof a.type.getDerivedStateFromProps&&"function"!==typeof this._instance.getSnapshotBeforeUpdate&&("function"===typeof this._instance.componentWillUpdate&&this._instance.componentWillUpdate(b,h,c),"function"===typeof this._instance.UNSAFE_componentWillUpdate&&this._instance.UNSAFE_componentWillUpdate(b,h,c));this._instance.context=c;this._instance.props=b;this._instance.state=
	h;k&&(this._rendered=this._instance.render())};b.prototype._updateStateFromStaticLifecycle=function(a){var b=this._element.type;"function"===typeof b.getDerivedStateFromProps&&(a=b.getDerivedStateFromProps.call(null,a,this._instance.state),null!=a&&(a=e({},this._newState||this._instance.state,a),this._instance.state=this._newState=a))};return b}();E.createRenderer=function(){return new E};
	var B=function(){function b(a){A(this,b);this._renderer=a;this._callbacks=[]}b.prototype._enqueueCallback=function(a,b){"function"===typeof a&&b&&this._callbacks.push({callback:a,publicInstance:b})};b.prototype._invokeCallbacks=function(){var a=this._callbacks;this._callbacks=[];a.forEach(function(a){a.callback.call(a.publicInstance)})};b.prototype.isMounted=function(){return!!this._renderer._element};b.prototype.enqueueForceUpdate=function(a,b){this._enqueueCallback(b,a);this._renderer._forcedUpdate=
	!0;this._renderer.render(this._renderer._element,this._renderer._context)};b.prototype.enqueueReplaceState=function(a,b,d){this._enqueueCallback(d,a);this._renderer._newState=b;this._renderer.render(this._renderer._element,this._renderer._context)};b.prototype.enqueueSetState=function(a,b,d){this._enqueueCallback(d,a);d=this._renderer._newState||a.state;"function"===typeof b&&(b=b(d,a.props));this._renderer._newState=e({},d,b);this._renderer.render(this._renderer._element,this._renderer._context)};
	return b}(),C=null;function D(){var b="";if(C){var a=null==C?"#empty":"string"===typeof C||"number"===typeof C?"#text":"string"===typeof C.type?C.type:C.type.displayName||C.type.name||"Unknown",c=C._owner,d=C._source;c=c&&z(c);a="\n    in "+(a||"Unknown")+(d?" (at "+d.fileName.replace(/^.*[\\\/]/,"")+":"+d.lineNumber+")":c?" (created by "+c+")":"");b+=a}return b}var F=Object.freeze({default:E}),G=F&&E||F;module.exports=G["default"]?G["default"]:G;


/***/ }),
/* 4434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(4433);
	} else {
	  module.exports = require('./cjs/react-test-renderer-shallow.development.js');
	}


/***/ }),
/* 4435 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.3.1
	 * react.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var m=__webpack_require__(33),n=__webpack_require__(176),p=__webpack_require__(99),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.portal"):60106,u=q?Symbol["for"]("react.fragment"):60107,v=q?Symbol["for"]("react.strict_mode"):60108,w=q?Symbol["for"]("react.provider"):60109,x=q?Symbol["for"]("react.context"):60110,y=q?Symbol["for"]("react.async_mode"):60111,z=q?Symbol["for"]("react.forward_ref"):60112,A="function"===
	typeof Symbol&&Symbol.iterator;function B(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
	var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function D(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||C}D.prototype.isReactComponent={};D.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};D.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function E(){}
	E.prototype=D.prototype;function F(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||C}var G=F.prototype=new E;G.constructor=F;m(G,D.prototype);G.isPureReactComponent=!0;var H={current:null},I=Object.prototype.hasOwnProperty,J={key:!0,ref:!0,__self:!0,__source:!0};
	function K(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)I.call(b,c)&&!J.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:h,props:d,_owner:H.current}}
	function L(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var M=/\/+/g,N=[];function O(a,b,e,c){if(N.length){var d=N.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function P(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>N.length&&N.push(a)}
	function Q(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:g=!0}}if(g)return e(c,a,""===b?"."+R(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+R(d,h);g+=Q(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
	h=0;!(d=a.next()).done;)d=d.value,f=b+R(d,h++),g+=Q(d,f,e,c);else"object"===d&&(e=""+a,B("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function R(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function S(a,b){a.func.call(a.context,b,a.count++)}
	function T(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?U(a,c,e,p.thatReturnsArgument):null!=a&&(L(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(M,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function U(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(M,"$\x26/")+"/");b=O(b,g,c,d);null==a||Q(a,"",T,b);P(b)}
	var V={Children:{map:function(a,b,e){if(null==a)return a;var c=[];U(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=O(null,null,b,e);null==a||Q(a,"",S,b);P(b)},count:function(a){return null==a?0:Q(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];U(a,b,null,p.thatReturnsArgument);return b},only:function(a){L(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:D,PureComponent:F,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:x,
	_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:w,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:z,render:a}},Fragment:u,StrictMode:v,unstable_AsyncMode:y,createElement:K,cloneElement:function(a,b,e){var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=H.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&(k=a.type.defaultProps);for(c in b)I.call(b,
	c)&&!J.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k}return{$$typeof:r,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=K.bind(null,a);b.type=a;return b},isValidElement:L,version:"16.3.1",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:H,assign:m}},W=Object.freeze({default:V}),X=W&&V||W;
	module.exports=X["default"]?X["default"]:X;


/***/ }),
/* 4436 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(161);


/***/ }),
/* 4437 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(743);
	
	/*<replacement>*/
	var util = __webpack_require__(212);
	util.inherits = __webpack_require__(71);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 4438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(525).Buffer;
	var util = __webpack_require__(4790);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ }),
/* 4439 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(504).PassThrough


/***/ }),
/* 4440 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(504).Transform


/***/ }),
/* 4441 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(503);


/***/ }),
/* 4442 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = reduceReducers;
	
	function reduceReducers() {
	  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
	    reducers[_key] = arguments[_key];
	  }
	
	  return function (previous, current) {
	    return reducers.reduce(function (p, r) {
	      return r(p, current);
	    }, previous);
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 4443 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (array, callback) {
	  return array.reduce(function (partialObject, element) {
	    return callback(partialObject, element);
	  }, {});
	};

/***/ }),
/* 4444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createActions;
	
	var _camelCase = __webpack_require__(746);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _identity = __webpack_require__(53);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _isPlainObject = __webpack_require__(75);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isArray = __webpack_require__(24);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _last = __webpack_require__(4329);
	
	var _last2 = _interopRequireDefault(_last);
	
	var _isString = __webpack_require__(332);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isFunction = __webpack_require__(102);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isNil = __webpack_require__(688);
	
	var _isNil2 = _interopRequireDefault(_isNil);
	
	var _createAction = __webpack_require__(748);
	
	var _createAction2 = _interopRequireDefault(_createAction);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _arrayToObject = __webpack_require__(4443);
	
	var _arrayToObject2 = _interopRequireDefault(_arrayToObject);
	
	var _flattenUtils = __webpack_require__(749);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function createActions(actionMap) {
	  for (var _len = arguments.length, identityActions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    identityActions[_key - 1] = arguments[_key];
	  }
	
	  var options = (0, _isPlainObject2.default)((0, _last2.default)(identityActions)) ? identityActions.pop() : {};
	  (0, _invariant2.default)(identityActions.every(_isString2.default) && ((0, _isString2.default)(actionMap) || (0, _isPlainObject2.default)(actionMap)), 'Expected optional object followed by string action types');
	  if ((0, _isString2.default)(actionMap)) {
	    return actionCreatorsFromIdentityActions([actionMap].concat(identityActions), options);
	  }
	  return _extends({}, actionCreatorsFromActionMap(actionMap, options), actionCreatorsFromIdentityActions(identityActions, options));
	}
	
	function actionCreatorsFromActionMap(actionMap, options) {
	  var flatActionMap = (0, _flattenUtils.flattenActionMap)(actionMap, options);
	  var flatActionCreators = actionMapToActionCreators(flatActionMap);
	  return (0, _flattenUtils.unflattenActionCreators)(flatActionCreators, options);
	}
	
	function actionMapToActionCreators(actionMap) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      prefix = _ref.prefix,
	      _ref$namespace = _ref.namespace,
	      namespace = _ref$namespace === undefined ? _flattenUtils.defaultNamespace : _ref$namespace;
	
	  function isValidActionMapValue(actionMapValue) {
	    if ((0, _isFunction2.default)(actionMapValue) || (0, _isNil2.default)(actionMapValue)) {
	      return true;
	    } else if ((0, _isArray2.default)(actionMapValue)) {
	      var _actionMapValue = _slicedToArray(actionMapValue, 2),
	          _actionMapValue$ = _actionMapValue[0],
	          payload = _actionMapValue$ === undefined ? _identity2.default : _actionMapValue$,
	          meta = _actionMapValue[1];
	
	      return (0, _isFunction2.default)(payload) && (0, _isFunction2.default)(meta);
	    }
	    return false;
	  }
	
	  return (0, _arrayToObject2.default)(Object.keys(actionMap), function (partialActionCreators, type) {
	    var actionMapValue = actionMap[type];
	    (0, _invariant2.default)(isValidActionMapValue(actionMapValue), 'Expected function, undefined, null, or array with payload and meta ' + ('functions for ' + type));
	    var prefixedType = prefix ? '' + prefix + namespace + type : type;
	    var actionCreator = (0, _isArray2.default)(actionMapValue) ? _createAction2.default.apply(undefined, [prefixedType].concat(_toConsumableArray(actionMapValue))) : (0, _createAction2.default)(prefixedType, actionMapValue);
	    return _extends({}, partialActionCreators, _defineProperty({}, type, actionCreator));
	  });
	}
	
	function actionCreatorsFromIdentityActions(identityActions, options) {
	  var actionMap = (0, _arrayToObject2.default)(identityActions, function (partialActionMap, type) {
	    return _extends({}, partialActionMap, _defineProperty({}, type, _identity2.default));
	  });
	  var actionCreators = actionMapToActionCreators(actionMap, options);
	  return (0, _arrayToObject2.default)(Object.keys(actionCreators), function (partialActionCreators, type) {
	    return _extends({}, partialActionCreators, _defineProperty({}, (0, _camelCase2.default)(type), actionCreators[type]));
	  });
	}

/***/ }),
/* 4445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = handleActions;
	
	var _isPlainObject = __webpack_require__(75);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isMap = __webpack_require__(331);
	
	var _isMap2 = _interopRequireDefault(_isMap);
	
	var _reduceReducers = __webpack_require__(4442);
	
	var _reduceReducers2 = _interopRequireDefault(_reduceReducers);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _handleAction = __webpack_require__(750);
	
	var _handleAction2 = _interopRequireDefault(_handleAction);
	
	var _ownKeys = __webpack_require__(505);
	
	var _ownKeys2 = _interopRequireDefault(_ownKeys);
	
	var _flattenUtils = __webpack_require__(749);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function get(key, x) {
	  return (0, _isMap2.default)(x) ? x.get(key) : x[key];
	}
	
	function handleActions(handlers, defaultState) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  (0, _invariant2.default)((0, _isPlainObject2.default)(handlers) || (0, _isMap2.default)(handlers), 'Expected handlers to be a plain object.');
	  var flattenedReducerMap = (0, _flattenUtils.flattenReducerMap)(handlers, options);
	  var reducers = (0, _ownKeys2.default)(flattenedReducerMap).map(function (type) {
	    return (0, _handleAction2.default)(type, get(type, flattenedReducerMap), defaultState);
	  });
	  var reducer = _reduceReducers2.default.apply(undefined, _toConsumableArray(reducers));
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];
	    return reducer(state, action);
	  };
	}

/***/ }),
/* 4446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasGeneratorInterface;
	
	var _ownKeys = __webpack_require__(505);
	
	var _ownKeys2 = _interopRequireDefault(_ownKeys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasGeneratorInterface(handler) {
	  var keys = (0, _ownKeys2.default)(handler);
	  var hasOnlyInterfaceNames = keys.every(function (ownKey) {
	    return ownKey === 'next' || ownKey === 'throw';
	  });
	  return keys.length && keys.length <= 2 && hasOnlyInterfaceNames;
	}

/***/ }),
/* 4447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.combineEpics = undefined;
	
	var _merge = __webpack_require__(162);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	  Merges all epics into a single one.
	 */
	var combineEpics = exports.combineEpics = function combineEpics() {
	  for (var _len = arguments.length, epics = Array(_len), _key = 0; _key < _len; _key++) {
	    epics[_key] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _merge.merge.apply(undefined, _toConsumableArray(epics.map(function (epic) {
	      var output$ = epic.apply(undefined, args);
	      if (!output$) {
	        throw new TypeError('combineEpics: one of the provided Epics "' + (epic.name || '<anonymous>') + '" does not return a stream. Double check you\'re not missing a return statement!');
	      }
	      return output$;
	    })));
	  };
	};

/***/ }),
/* 4448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createEpicMiddleware = createEpicMiddleware;
	
	var _Subject = __webpack_require__(30);
	
	var _map = __webpack_require__(769);
	
	var _switchMap = __webpack_require__(770);
	
	var _ActionsObservable = __webpack_require__(751);
	
	var _EPIC_END = __webpack_require__(752);
	
	var defaultAdapter = {
	  input: function input(action$) {
	    return action$;
	  },
	  output: function output(action$) {
	    return action$;
	  }
	};
	
	var defaultOptions = {
	  adapter: defaultAdapter
	};
	
	function createEpicMiddleware(rootEpic) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;
	
	  if (typeof rootEpic !== 'function') {
	    throw new TypeError('You must provide a root Epic to createEpicMiddleware');
	  }
	
	  // even though we used default param, we need to merge the defaults
	  // inside the options object as well in case they declare only some
	  options = _extends({}, defaultOptions, options);
	  var input$ = new _Subject.Subject();
	  var action$ = options.adapter.input(new _ActionsObservable.ActionsObservable(input$));
	  var epic$ = new _Subject.Subject();
	  var store = void 0;
	
	  var epicMiddleware = function epicMiddleware(_store) {
	    store = _store;
	
	    return function (next) {
	      var _context;
	
	      (_context = _map.map.call(epic$, function (epic) {
	        var vault =  true ? store : {
	          getState: store.getState,
	          dispatch: function dispatch(action) {
	            require('./utils/console').deprecate('calling store.dispatch() directly in your Epics is deprecated and will be removed. Instead, emit actions through the Observable your Epic returns.\n\n  https://goo.gl/WWNYSP');
	            return store.dispatch(action);
	          }
	        };
	
	        var output$ = 'dependencies' in options ? epic(action$, vault, options.dependencies) : epic(action$, vault);
	
	        if (!output$) {
	          throw new TypeError('Your root Epic "' + (epic.name || '<anonymous>') + '" does not return a stream. Double check you\'re not missing a return statement!');
	        }
	
	        return output$;
	      }), _switchMap.switchMap).call(_context, function (output$) {
	        return options.adapter.output(output$);
	      }).subscribe(function (action) {
	        try {
	          store.dispatch(action);
	        } catch (err) {
	          console.error(err);
	        }
	      });
	
	      // Setup initial root epic
	      epic$.next(rootEpic);
	
	      return function (action) {
	        var result = next(action);
	        input$.next(action);
	        return result;
	      };
	    };
	  };
	
	  epicMiddleware.replaceEpic = function (rootEpic) {
	    // gives the previous root Epic a last chance
	    // to do some clean up
	    store.dispatch({ type: _EPIC_END.EPIC_END });
	    // switches to the new root Epic, synchronously terminating
	    // the previous one
	    epic$.next(rootEpic);
	  };
	
	  return epicMiddleware;
	}

/***/ }),
/* 4449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(754);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 4450 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 4451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(755);
	
	var _isPlainObject = __webpack_require__(75);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(756);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 4452 */,
/* 4453 */,
/* 4454 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(90);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	var _util = __webpack_require__(343);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	var hasOwn = Object.prototype.hasOwnProperty;
	
	// The hoist function takes a FunctionExpression or FunctionDeclaration
	// and replaces any Declaration nodes in its body with assignments, then
	// returns a VariableDeclaration containing just the names of the removed
	// declarations.
	exports.hoist = function (funPath) {
	  t.assertFunction(funPath.node);
	
	  var vars = {};
	
	  function varDeclToExpr(vdec, includeIdentifiers) {
	    t.assertVariableDeclaration(vdec);
	    // TODO assert.equal(vdec.kind, "var");
	    var exprs = [];
	
	    vdec.declarations.forEach(function (dec) {
	      // Note: We duplicate 'dec.id' here to ensure that the variable declaration IDs don't
	      // have the same 'loc' value, since that can make sourcemaps and retainLines behave poorly.
	      vars[dec.id.name] = t.identifier(dec.id.name);
	
	      if (dec.init) {
	        exprs.push(t.assignmentExpression("=", dec.id, dec.init));
	      } else if (includeIdentifiers) {
	        exprs.push(dec.id);
	      }
	    });
	
	    if (exprs.length === 0) return null;
	
	    if (exprs.length === 1) return exprs[0];
	
	    return t.sequenceExpression(exprs);
	  }
	
	  funPath.get("body").traverse({
	    VariableDeclaration: {
	      exit: function exit(path) {
	        var expr = varDeclToExpr(path.node, false);
	        if (expr === null) {
	          path.remove();
	        } else {
	          // We don't need to traverse this expression any further because
	          // there can't be any new declarations inside an expression.
	          util.replaceWithOrRemove(path, t.expressionStatement(expr));
	        }
	
	        // Since the original node has been either removed or replaced,
	        // avoid traversing it any further.
	        path.skip();
	      }
	    },
	
	    ForStatement: function ForStatement(path) {
	      var init = path.node.init;
	      if (t.isVariableDeclaration(init)) {
	        util.replaceWithOrRemove(path.get("init"), varDeclToExpr(init, false));
	      }
	    },
	
	    ForXStatement: function ForXStatement(path) {
	      var left = path.get("left");
	      if (left.isVariableDeclaration()) {
	        util.replaceWithOrRemove(left, varDeclToExpr(left.node, true));
	      }
	    },
	
	    FunctionDeclaration: function FunctionDeclaration(path) {
	      var node = path.node;
	      vars[node.id.name] = node.id;
	
	      var assignment = t.expressionStatement(t.assignmentExpression("=", node.id, t.functionExpression(node.id, node.params, node.body, node.generator, node.expression)));
	
	      if (path.parentPath.isBlockStatement()) {
	        // Insert the assignment form before the first statement in the
	        // enclosing block.
	        path.parentPath.unshiftContainer("body", assignment);
	
	        // Remove the function declaration now that we've inserted the
	        // equivalent assignment form at the beginning of the block.
	        path.remove();
	      } else {
	        // If the parent node is not a block statement, then we can just
	        // replace the declaration with the equivalent assignment form
	        // without worrying about hoisting it.
	        util.replaceWithOrRemove(path, assignment);
	      }
	
	      // Don't hoist variables out of inner functions.
	      path.skip();
	    },
	
	    FunctionExpression: function FunctionExpression(path) {
	      // Don't descend into nested function expressions.
	      path.skip();
	    }
	  });
	
	  var paramNames = {};
	  funPath.get("params").forEach(function (paramPath) {
	    var param = paramPath.node;
	    if (t.isIdentifier(param)) {
	      paramNames[param.name] = param;
	    } else {
	      // Variables declared by destructuring parameter patterns will be
	      // harmlessly re-declared.
	    }
	  });
	
	  var declarations = [];
	
	  (0, _keys2.default)(vars).forEach(function (name) {
	    if (!hasOwn.call(paramNames, name)) {
	      declarations.push(t.variableDeclarator(vars[name], null));
	    }
	  });
	
	  if (declarations.length === 0) {
	    return null; // Be sure to handle this case!
	  }
	
	  return t.variableDeclaration("var", declarations);
	};

/***/ }),
/* 4455 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (context) {
	  var plugin = {
	    visitor: __webpack_require__(4459).visitor
	  };
	
	  // Some presets manually call child presets, but fail to pass along the
	  // context object. Out of an abundance of caution, we verify that it
	  // exists first to avoid causing unnecessary breaking changes.
	  var version = context && context.version;
	
	  // The "name" property is not allowed in older versions of Babel (6.x)
	  // and will cause the plugin validator to throw an exception.
	  if (version && parseInt(version, 10) >= 7) {
	    plugin.name = "regenerator-transform";
	  }
	
	  return plugin;
	};

/***/ }),
/* 4456 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assert = __webpack_require__(275);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	var _util = __webpack_require__(55);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Entry() {
	  _assert2.default.ok(this instanceof Entry);
	} /**
	   * Copyright (c) 2014, Facebook, Inc.
	   * All rights reserved.
	   *
	   * This source code is licensed under the BSD-style license found in the
	   * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	   * additional grant of patent rights can be found in the PATENTS file in
	   * the same directory.
	   */
	
	function FunctionEntry(returnLoc) {
	  Entry.call(this);
	  t.assertLiteral(returnLoc);
	  this.returnLoc = returnLoc;
	}
	
	(0, _util.inherits)(FunctionEntry, Entry);
	exports.FunctionEntry = FunctionEntry;
	
	function LoopEntry(breakLoc, continueLoc, label) {
	  Entry.call(this);
	
	  t.assertLiteral(breakLoc);
	  t.assertLiteral(continueLoc);
	
	  if (label) {
	    t.assertIdentifier(label);
	  } else {
	    label = null;
	  }
	
	  this.breakLoc = breakLoc;
	  this.continueLoc = continueLoc;
	  this.label = label;
	}
	
	(0, _util.inherits)(LoopEntry, Entry);
	exports.LoopEntry = LoopEntry;
	
	function SwitchEntry(breakLoc) {
	  Entry.call(this);
	  t.assertLiteral(breakLoc);
	  this.breakLoc = breakLoc;
	}
	
	(0, _util.inherits)(SwitchEntry, Entry);
	exports.SwitchEntry = SwitchEntry;
	
	function TryEntry(firstLoc, catchEntry, finallyEntry) {
	  Entry.call(this);
	
	  t.assertLiteral(firstLoc);
	
	  if (catchEntry) {
	    _assert2.default.ok(catchEntry instanceof CatchEntry);
	  } else {
	    catchEntry = null;
	  }
	
	  if (finallyEntry) {
	    _assert2.default.ok(finallyEntry instanceof FinallyEntry);
	  } else {
	    finallyEntry = null;
	  }
	
	  // Have to have one or the other (or both).
	  _assert2.default.ok(catchEntry || finallyEntry);
	
	  this.firstLoc = firstLoc;
	  this.catchEntry = catchEntry;
	  this.finallyEntry = finallyEntry;
	}
	
	(0, _util.inherits)(TryEntry, Entry);
	exports.TryEntry = TryEntry;
	
	function CatchEntry(firstLoc, paramId) {
	  Entry.call(this);
	
	  t.assertLiteral(firstLoc);
	  t.assertIdentifier(paramId);
	
	  this.firstLoc = firstLoc;
	  this.paramId = paramId;
	}
	
	(0, _util.inherits)(CatchEntry, Entry);
	exports.CatchEntry = CatchEntry;
	
	function FinallyEntry(firstLoc, afterLoc) {
	  Entry.call(this);
	  t.assertLiteral(firstLoc);
	  t.assertLiteral(afterLoc);
	  this.firstLoc = firstLoc;
	  this.afterLoc = afterLoc;
	}
	
	(0, _util.inherits)(FinallyEntry, Entry);
	exports.FinallyEntry = FinallyEntry;
	
	function LabeledEntry(breakLoc, label) {
	  Entry.call(this);
	
	  t.assertLiteral(breakLoc);
	  t.assertIdentifier(label);
	
	  this.breakLoc = breakLoc;
	  this.label = label;
	}
	
	(0, _util.inherits)(LabeledEntry, Entry);
	exports.LabeledEntry = LabeledEntry;
	
	function LeapManager(emitter) {
	  _assert2.default.ok(this instanceof LeapManager);
	
	  var Emitter = __webpack_require__(758).Emitter;
	  _assert2.default.ok(emitter instanceof Emitter);
	
	  this.emitter = emitter;
	  this.entryStack = [new FunctionEntry(emitter.finalLoc)];
	}
	
	var LMp = LeapManager.prototype;
	exports.LeapManager = LeapManager;
	
	LMp.withEntry = function (entry, callback) {
	  _assert2.default.ok(entry instanceof Entry);
	  this.entryStack.push(entry);
	  try {
	    callback.call(this.emitter);
	  } finally {
	    var popped = this.entryStack.pop();
	    _assert2.default.strictEqual(popped, entry);
	  }
	};
	
	LMp._findLeapLocation = function (property, label) {
	  for (var i = this.entryStack.length - 1; i >= 0; --i) {
	    var entry = this.entryStack[i];
	    var loc = entry[property];
	    if (loc) {
	      if (label) {
	        if (entry.label && entry.label.name === label.name) {
	          return loc;
	        }
	      } else if (entry instanceof LabeledEntry) {
	        // Ignore LabeledEntry entries unless we are actually breaking to
	        // a label.
	      } else {
	        return loc;
	      }
	    }
	  }
	
	  return null;
	};
	
	LMp.getBreakLoc = function (label) {
	  return this._findLeapLocation("breakLoc", label);
	};
	
	LMp.getContinueLoc = function (label) {
	  return this._findLeapLocation("continueLoc", label);
	};

/***/ }),
/* 4457 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assert = __webpack_require__(275);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var m = __webpack_require__(713).makeAccessor(); /**
	                                            * Copyright (c) 2014, Facebook, Inc.
	                                            * All rights reserved.
	                                            *
	                                            * This source code is licensed under the BSD-style license found in the
	                                            * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	                                            * additional grant of patent rights can be found in the PATENTS file in
	                                            * the same directory.
	                                            */
	
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function makePredicate(propertyName, knownTypes) {
	  function onlyChildren(node) {
	    t.assertNode(node);
	
	    // Assume no side effects until we find out otherwise.
	    var result = false;
	
	    function check(child) {
	      if (result) {
	        // Do nothing.
	      } else if (Array.isArray(child)) {
	        child.some(check);
	      } else if (t.isNode(child)) {
	        _assert2.default.strictEqual(result, false);
	        result = predicate(child);
	      }
	      return result;
	    }
	
	    var keys = t.VISITOR_KEYS[node.type];
	    if (keys) {
	      for (var i = 0; i < keys.length; i++) {
	        var key = keys[i];
	        var child = node[key];
	        check(child);
	      }
	    }
	
	    return result;
	  }
	
	  function predicate(node) {
	    t.assertNode(node);
	
	    var meta = m(node);
	    if (hasOwn.call(meta, propertyName)) return meta[propertyName];
	
	    // Certain types are "opaque," which means they have no side
	    // effects or leaps and we don't care about their subexpressions.
	    if (hasOwn.call(opaqueTypes, node.type)) return meta[propertyName] = false;
	
	    if (hasOwn.call(knownTypes, node.type)) return meta[propertyName] = true;
	
	    return meta[propertyName] = onlyChildren(node);
	  }
	
	  predicate.onlyChildren = onlyChildren;
	
	  return predicate;
	}
	
	var opaqueTypes = {
	  FunctionExpression: true,
	  ArrowFunctionExpression: true
	};
	
	// These types potentially have side effects regardless of what side
	// effects their subexpressions have.
	var sideEffectTypes = {
	  CallExpression: true, // Anything could happen!
	  ForInStatement: true, // Modifies the key variable.
	  UnaryExpression: true, // Think delete.
	  BinaryExpression: true, // Might invoke .toString() or .valueOf().
	  AssignmentExpression: true, // Side-effecting by definition.
	  UpdateExpression: true, // Updates are essentially assignments.
	  NewExpression: true // Similar to CallExpression.
	};
	
	// These types are the direct cause of all leaps in control flow.
	var leapTypes = {
	  YieldExpression: true,
	  BreakStatement: true,
	  ContinueStatement: true,
	  ReturnStatement: true,
	  ThrowStatement: true
	};
	
	// All leap types are also side effect types.
	for (var type in leapTypes) {
	  if (hasOwn.call(leapTypes, type)) {
	    sideEffectTypes[type] = leapTypes[type];
	  }
	}
	
	exports.hasSideEffects = makePredicate("hasSideEffects", sideEffectTypes);
	exports.containsLeap = makePredicate("containsLeap", leapTypes);

/***/ }),
/* 4458 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = replaceShorthandObjectMethod;
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	var _util = __webpack_require__(343);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// this function converts a shorthand object generator method into a normal
	// (non-shorthand) object property which is a generator function expression. for
	// example, this:
	//
	//  var foo = {
	//    *bar(baz) { return 5; }
	//  }
	//
	// should be replaced with:
	//
	//  var foo = {
	//    bar: function*(baz) { return 5; }
	//  }
	//
	// to do this, it clones the parameter array and the body of the object generator
	// method into a new FunctionExpression.
	//
	// this method can be passed any Function AST node path, and it will return
	// either:
	//   a) the path that was passed in (iff the path did not need to be replaced) or
	//   b) the path of the new FunctionExpression that was created as a replacement
	//     (iff the path did need to be replaced)
	//
	// In either case, though, the caller can count on the fact that the return value
	// is a Function AST node path.
	//
	// If this function is called with an AST node path that is not a Function (or with an
	// argument that isn't an AST node path), it will throw an error.
	function replaceShorthandObjectMethod(path) {
	  if (!path.node || !t.isFunction(path.node)) {
	    throw new Error("replaceShorthandObjectMethod can only be called on Function AST node paths.");
	  }
	
	  // this function only replaces shorthand object methods (called ObjectMethod
	  // in Babel-speak).
	  if (!t.isObjectMethod(path.node)) {
	    return path;
	  }
	
	  // this function only replaces generators.
	  if (!path.node.generator) {
	    return path;
	  }
	
	  var parameters = path.node.params.map(function (param) {
	    return t.cloneDeep(param);
	  });
	
	  var functionExpression = t.functionExpression(null, // id
	  parameters, // params
	  t.cloneDeep(path.node.body), // body
	  path.node.generator, path.node.async);
	
	  util.replaceWithOrRemove(path, t.objectProperty(t.cloneDeep(path.node.key), // key
	  functionExpression, //value
	  path.node.computed, // computed
	  false // shorthand
	  ));
	
	  // path now refers to the ObjectProperty AST node path, but we want to return a
	  // Function AST node path for the function expression we created. we know that
	  // the FunctionExpression we just created is the value of the ObjectProperty,
	  // so return the "value" path off of this path.
	  return path.get("value");
	}

/***/ }),
/* 4459 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	"use strict";
	
	var _assert = __webpack_require__(275);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _babelTypes = __webpack_require__(9);
	
	var t = _interopRequireWildcard(_babelTypes);
	
	var _hoist = __webpack_require__(4454);
	
	var _emit = __webpack_require__(758);
	
	var _replaceShorthandObjectMethod = __webpack_require__(4458);
	
	var _replaceShorthandObjectMethod2 = _interopRequireDefault(_replaceShorthandObjectMethod);
	
	var _util = __webpack_require__(343);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.visitor = {
	  Function: {
	    exit: function exit(path, state) {
	      var node = path.node;
	
	      if (node.generator) {
	        if (node.async) {
	          // Async generator
	          if (state.opts.asyncGenerators === false) return;
	        } else {
	          // Plain generator
	          if (state.opts.generators === false) return;
	        }
	      } else if (node.async) {
	        // Async function
	        if (state.opts.async === false) return;
	      } else {
	        // Not a generator or async function.
	        return;
	      }
	
	      // if this is an ObjectMethod, we need to convert it to an ObjectProperty
	      path = (0, _replaceShorthandObjectMethod2.default)(path);
	      node = path.node;
	
	      var contextId = path.scope.generateUidIdentifier("context");
	      var argsId = path.scope.generateUidIdentifier("args");
	
	      path.ensureBlock();
	      var bodyBlockPath = path.get("body");
	
	      if (node.async) {
	        bodyBlockPath.traverse(awaitVisitor);
	      }
	
	      bodyBlockPath.traverse(functionSentVisitor, {
	        context: contextId
	      });
	
	      var outerBody = [];
	      var innerBody = [];
	
	      bodyBlockPath.get("body").forEach(function (childPath) {
	        var node = childPath.node;
	        if (t.isExpressionStatement(node) && t.isStringLiteral(node.expression)) {
	          // Babylon represents directives like "use strict" as elements
	          // of a bodyBlockPath.node.directives array, but they could just
	          // as easily be represented (by other parsers) as traditional
	          // string-literal-valued expression statements, so we need to
	          // handle that here. (#248)
	          outerBody.push(node);
	        } else if (node && node._blockHoist != null) {
	          outerBody.push(node);
	        } else {
	          innerBody.push(node);
	        }
	      });
	
	      if (outerBody.length > 0) {
	        // Only replace the inner body if we actually hoisted any statements
	        // to the outer body.
	        bodyBlockPath.node.body = innerBody;
	      }
	
	      var outerFnExpr = getOuterFnExpr(path);
	      // Note that getOuterFnExpr has the side-effect of ensuring that the
	      // function has a name (so node.id will always be an Identifier), even
	      // if a temporary name has to be synthesized.
	      t.assertIdentifier(node.id);
	      var innerFnId = t.identifier(node.id.name + "$");
	
	      // Turn all declarations into vars, and replace the original
	      // declarations with equivalent assignment expressions.
	      var vars = (0, _hoist.hoist)(path);
	
	      var didRenameArguments = renameArguments(path, argsId);
	      if (didRenameArguments) {
	        vars = vars || t.variableDeclaration("var", []);
	        var argumentIdentifier = t.identifier("arguments");
	        // we need to do this as otherwise arguments in arrow functions gets hoisted
	        argumentIdentifier._shadowedFunctionLiteral = path;
	        vars.declarations.push(t.variableDeclarator(argsId, argumentIdentifier));
	      }
	
	      var emitter = new _emit.Emitter(contextId);
	      emitter.explode(path.get("body"));
	
	      if (vars && vars.declarations.length > 0) {
	        outerBody.push(vars);
	      }
	
	      var wrapArgs = [emitter.getContextFunction(innerFnId),
	      // Async functions that are not generators don't care about the
	      // outer function because they don't need it to be marked and don't
	      // inherit from its .prototype.
	      node.generator ? outerFnExpr : t.nullLiteral(), t.thisExpression()];
	
	      var tryLocsList = emitter.getTryLocsList();
	      if (tryLocsList) {
	        wrapArgs.push(tryLocsList);
	      }
	
	      var wrapCall = t.callExpression(util.runtimeProperty(node.async ? "async" : "wrap"), wrapArgs);
	
	      outerBody.push(t.returnStatement(wrapCall));
	      node.body = t.blockStatement(outerBody);
	
	      var oldDirectives = bodyBlockPath.node.directives;
	      if (oldDirectives) {
	        // Babylon represents directives like "use strict" as elements of
	        // a bodyBlockPath.node.directives array. (#248)
	        node.body.directives = oldDirectives;
	      }
	
	      var wasGeneratorFunction = node.generator;
	      if (wasGeneratorFunction) {
	        node.generator = false;
	      }
	
	      if (node.async) {
	        node.async = false;
	      }
	
	      if (wasGeneratorFunction && t.isExpression(node)) {
	        util.replaceWithOrRemove(path, t.callExpression(util.runtimeProperty("mark"), [node]));
	        path.addComment("leading", "#__PURE__");
	      }
	
	      // Generators are processed in 'exit' handlers so that regenerator only has to run on
	      // an ES5 AST, but that means traversal will not pick up newly inserted references
	      // to things like 'regeneratorRuntime'. To avoid this, we explicitly requeue.
	      path.requeue();
	    }
	  }
	};
	
	// Given a NodePath for a Function, return an Expression node that can be
	// used to refer reliably to the function object from inside the function.
	// This expression is essentially a replacement for arguments.callee, with
	// the key advantage that it works in strict mode.
	function getOuterFnExpr(funPath) {
	  var node = funPath.node;
	  t.assertFunction(node);
	
	  if (!node.id) {
	    // Default-exported function declarations, and function expressions may not
	    // have a name to reference, so we explicitly add one.
	    node.id = funPath.scope.parent.generateUidIdentifier("callee");
	  }
	
	  if (node.generator && // Non-generator functions don't need to be marked.
	  t.isFunctionDeclaration(node)) {
	    // Return the identifier returned by runtime.mark(<node.id>).
	    return getMarkedFunctionId(funPath);
	  }
	
	  return node.id;
	}
	
	var getMarkInfo = __webpack_require__(713).makeAccessor();
	
	function getMarkedFunctionId(funPath) {
	  var node = funPath.node;
	  t.assertIdentifier(node.id);
	
	  var blockPath = funPath.findParent(function (path) {
	    return path.isProgram() || path.isBlockStatement();
	  });
	
	  if (!blockPath) {
	    return node.id;
	  }
	
	  var block = blockPath.node;
	  _assert2.default.ok(Array.isArray(block.body));
	
	  var info = getMarkInfo(block);
	  if (!info.decl) {
	    info.decl = t.variableDeclaration("var", []);
	    blockPath.unshiftContainer("body", info.decl);
	    info.declPath = blockPath.get("body.0");
	  }
	
	  _assert2.default.strictEqual(info.declPath.node, info.decl);
	
	  // Get a new unique identifier for our marked variable.
	  var markedId = blockPath.scope.generateUidIdentifier("marked");
	  var markCallExp = t.callExpression(util.runtimeProperty("mark"), [node.id]);
	
	  var index = info.decl.declarations.push(t.variableDeclarator(markedId, markCallExp)) - 1;
	
	  var markCallExpPath = info.declPath.get("declarations." + index + ".init");
	
	  _assert2.default.strictEqual(markCallExpPath.node, markCallExp);
	
	  markCallExpPath.addComment("leading", "#__PURE__");
	
	  return markedId;
	}
	
	function renameArguments(funcPath, argsId) {
	  var state = {
	    didRenameArguments: false,
	    argsId: argsId
	  };
	
	  funcPath.traverse(argumentsVisitor, state);
	
	  // If the traversal replaced any arguments references, then we need to
	  // alias the outer function's arguments binding (be it the implicit
	  // arguments object or some other parameter or variable) to the variable
	  // named by argsId.
	  return state.didRenameArguments;
	}
	
	var argumentsVisitor = {
	  "FunctionExpression|FunctionDeclaration": function FunctionExpressionFunctionDeclaration(path) {
	    path.skip();
	  },
	
	  Identifier: function Identifier(path, state) {
	    if (path.node.name === "arguments" && util.isReference(path)) {
	      util.replaceWithOrRemove(path, state.argsId);
	      state.didRenameArguments = true;
	    }
	  }
	};
	
	var functionSentVisitor = {
	  MetaProperty: function MetaProperty(path) {
	    var node = path.node;
	
	
	    if (node.meta.name === "function" && node.property.name === "sent") {
	      util.replaceWithOrRemove(path, t.memberExpression(this.context, t.identifier("_sent")));
	    }
	  }
	};
	
	var awaitVisitor = {
	  Function: function Function(path) {
	    path.skip(); // Don't descend into nested function scopes.
	  },
	
	  AwaitExpression: function AwaitExpression(path) {
	    // Convert await expressions to yield expressions.
	    var argument = path.node.argument;
	
	    // Transforming `await x` to `yield regeneratorRuntime.awrap(x)`
	    // causes the argument to be wrapped in such a way that the runtime
	    // can distinguish between awaited and merely yielded values.
	    util.replaceWithOrRemove(path, t.yieldExpression(t.callExpression(util.runtimeProperty("awrap"), [argument]), false));
	  }
	};

/***/ }),
/* 4460 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by `/scripts/character-class-escape-sets.js`. Do not edit.
	var regenerate = __webpack_require__(757);
	
	exports.REGULAR = {
		'd': regenerate()
			.addRange(0x30, 0x39),
		'D': regenerate()
			.addRange(0x0, 0x2F)
			.addRange(0x3A, 0xFFFF),
		's': regenerate(0x20, 0xA0, 0x1680, 0x180E, 0x202F, 0x205F, 0x3000, 0xFEFF)
			.addRange(0x9, 0xD)
			.addRange(0x2000, 0x200A)
			.addRange(0x2028, 0x2029),
		'S': regenerate()
			.addRange(0x0, 0x8)
			.addRange(0xE, 0x1F)
			.addRange(0x21, 0x9F)
			.addRange(0xA1, 0x167F)
			.addRange(0x1681, 0x180D)
			.addRange(0x180F, 0x1FFF)
			.addRange(0x200B, 0x2027)
			.addRange(0x202A, 0x202E)
			.addRange(0x2030, 0x205E)
			.addRange(0x2060, 0x2FFF)
			.addRange(0x3001, 0xFEFE)
			.addRange(0xFF00, 0xFFFF),
		'w': regenerate(0x5F)
			.addRange(0x30, 0x39)
			.addRange(0x41, 0x5A)
			.addRange(0x61, 0x7A),
		'W': regenerate(0x60)
			.addRange(0x0, 0x2F)
			.addRange(0x3A, 0x40)
			.addRange(0x5B, 0x5E)
			.addRange(0x7B, 0xFFFF)
	};
	
	exports.UNICODE = {
		'd': regenerate()
			.addRange(0x30, 0x39),
		'D': regenerate()
			.addRange(0x0, 0x2F)
			.addRange(0x3A, 0x10FFFF),
		's': regenerate(0x20, 0xA0, 0x1680, 0x180E, 0x202F, 0x205F, 0x3000, 0xFEFF)
			.addRange(0x9, 0xD)
			.addRange(0x2000, 0x200A)
			.addRange(0x2028, 0x2029),
		'S': regenerate()
			.addRange(0x0, 0x8)
			.addRange(0xE, 0x1F)
			.addRange(0x21, 0x9F)
			.addRange(0xA1, 0x167F)
			.addRange(0x1681, 0x180D)
			.addRange(0x180F, 0x1FFF)
			.addRange(0x200B, 0x2027)
			.addRange(0x202A, 0x202E)
			.addRange(0x2030, 0x205E)
			.addRange(0x2060, 0x2FFF)
			.addRange(0x3001, 0xFEFE)
			.addRange(0xFF00, 0x10FFFF),
		'w': regenerate(0x5F)
			.addRange(0x30, 0x39)
			.addRange(0x41, 0x5A)
			.addRange(0x61, 0x7A),
		'W': regenerate(0x60)
			.addRange(0x0, 0x2F)
			.addRange(0x3A, 0x40)
			.addRange(0x5B, 0x5E)
			.addRange(0x7B, 0x10FFFF)
	};
	
	exports.UNICODE_IGNORE_CASE = {
		'd': regenerate()
			.addRange(0x30, 0x39),
		'D': regenerate()
			.addRange(0x0, 0x2F)
			.addRange(0x3A, 0x10FFFF),
		's': regenerate(0x20, 0xA0, 0x1680, 0x180E, 0x202F, 0x205F, 0x3000, 0xFEFF)
			.addRange(0x9, 0xD)
			.addRange(0x2000, 0x200A)
			.addRange(0x2028, 0x2029),
		'S': regenerate()
			.addRange(0x0, 0x8)
			.addRange(0xE, 0x1F)
			.addRange(0x21, 0x9F)
			.addRange(0xA1, 0x167F)
			.addRange(0x1681, 0x180D)
			.addRange(0x180F, 0x1FFF)
			.addRange(0x200B, 0x2027)
			.addRange(0x202A, 0x202E)
			.addRange(0x2030, 0x205E)
			.addRange(0x2060, 0x2FFF)
			.addRange(0x3001, 0xFEFE)
			.addRange(0xFF00, 0x10FFFF),
		'w': regenerate(0x5F, 0x17F, 0x212A)
			.addRange(0x30, 0x39)
			.addRange(0x41, 0x5A)
			.addRange(0x61, 0x7A),
		'W': regenerate(0x4B, 0x53, 0x60)
			.addRange(0x0, 0x2F)
			.addRange(0x3A, 0x40)
			.addRange(0x5B, 0x5E)
			.addRange(0x7B, 0x10FFFF)
	};


/***/ }),
/* 4461 */
/***/ (function(module, exports, __webpack_require__) {

	var generate = __webpack_require__(4462).generate;
	var parse = __webpack_require__(4463).parse;
	var regenerate = __webpack_require__(757);
	var iuMappings = __webpack_require__(4201);
	var ESCAPE_SETS = __webpack_require__(4460);
	
	function getCharacterClassEscapeSet(character) {
		if (unicode) {
			if (ignoreCase) {
				return ESCAPE_SETS.UNICODE_IGNORE_CASE[character];
			}
			return ESCAPE_SETS.UNICODE[character];
		}
		return ESCAPE_SETS.REGULAR[character];
	}
	
	var object = {};
	var hasOwnProperty = object.hasOwnProperty;
	function has(object, property) {
		return hasOwnProperty.call(object, property);
	}
	
	// Prepare a Regenerate set containing all code points, used for negative
	// character classes (if any).
	var UNICODE_SET = regenerate().addRange(0x0, 0x10FFFF);
	// Without the `u` flag, the range stops at 0xFFFF.
	// https://mths.be/es6#sec-pattern-semantics
	var BMP_SET = regenerate().addRange(0x0, 0xFFFF);
	
	// Prepare a Regenerate set containing all code points that are supposed to be
	// matched by `/./u`. https://mths.be/es6#sec-atom
	var DOT_SET_UNICODE = UNICODE_SET.clone() // all Unicode code points
		.remove(
			// minus `LineTerminator`s (https://mths.be/es6#sec-line-terminators):
			0x000A, // Line Feed <LF>
			0x000D, // Carriage Return <CR>
			0x2028, // Line Separator <LS>
			0x2029  // Paragraph Separator <PS>
		);
	// Prepare a Regenerate set containing all code points that are supposed to be
	// matched by `/./` (only BMP code points).
	var DOT_SET = DOT_SET_UNICODE.clone()
		.intersection(BMP_SET);
	
	// Add a range of code points + any case-folded code points in that range to a
	// set.
	regenerate.prototype.iuAddRange = function(min, max) {
		var $this = this;
		do {
			var folded = caseFold(min);
			if (folded) {
				$this.add(folded);
			}
		} while (++min <= max);
		return $this;
	};
	
	function assign(target, source) {
		for (var key in source) {
			// Note: `hasOwnProperty` is not needed here.
			target[key] = source[key];
		}
	}
	
	function update(item, pattern) {
		// TODO: Test if memoizing `pattern` here is worth the effort.
		if (!pattern) {
			return;
		}
		var tree = parse(pattern, '');
		switch (tree.type) {
			case 'characterClass':
			case 'group':
			case 'value':
				// No wrapping needed.
				break;
			default:
				// Wrap the pattern in a non-capturing group.
				tree = wrap(tree, pattern);
		}
		assign(item, tree);
	}
	
	function wrap(tree, pattern) {
		// Wrap the pattern in a non-capturing group.
		return {
			'type': 'group',
			'behavior': 'ignore',
			'body': [tree],
			'raw': '(?:' + pattern + ')'
		};
	}
	
	function caseFold(codePoint) {
		return has(iuMappings, codePoint) ? iuMappings[codePoint] : false;
	}
	
	var ignoreCase = false;
	var unicode = false;
	function processCharacterClass(characterClassItem) {
		var set = regenerate();
		var body = characterClassItem.body.forEach(function(item) {
			switch (item.type) {
				case 'value':
					set.add(item.codePoint);
					if (ignoreCase && unicode) {
						var folded = caseFold(item.codePoint);
						if (folded) {
							set.add(folded);
						}
					}
					break;
				case 'characterClassRange':
					var min = item.min.codePoint;
					var max = item.max.codePoint;
					set.addRange(min, max);
					if (ignoreCase && unicode) {
						set.iuAddRange(min, max);
					}
					break;
				case 'characterClassEscape':
					set.add(getCharacterClassEscapeSet(item.value));
					break;
				// The `default` clause is only here as a safeguard; it should never be
				// reached. Code coverage tools should ignore it.
				/* istanbul ignore next */
				default:
					throw Error('Unknown term type: ' + item.type);
			}
		});
		if (characterClassItem.negative) {
			set = (unicode ? UNICODE_SET : BMP_SET).clone().remove(set);
		}
		update(characterClassItem, set.toString());
		return characterClassItem;
	}
	
	function processTerm(item) {
		switch (item.type) {
			case 'dot':
				update(
					item,
					(unicode ? DOT_SET_UNICODE : DOT_SET).toString()
				);
				break;
			case 'characterClass':
				item = processCharacterClass(item);
				break;
			case 'characterClassEscape':
				update(
					item,
					getCharacterClassEscapeSet(item.value).toString()
				);
				break;
			case 'alternative':
			case 'disjunction':
			case 'group':
			case 'quantifier':
				item.body = item.body.map(processTerm);
				break;
			case 'value':
				var codePoint = item.codePoint;
				var set = regenerate(codePoint);
				if (ignoreCase && unicode) {
					var folded = caseFold(codePoint);
					if (folded) {
						set.add(folded);
					}
				}
				update(item, set.toString());
				break;
			case 'anchor':
			case 'empty':
			case 'group':
			case 'reference':
				// Nothing to do here.
				break;
			// The `default` clause is only here as a safeguard; it should never be
			// reached. Code coverage tools should ignore it.
			/* istanbul ignore next */
			default:
				throw Error('Unknown term type: ' + item.type);
		}
		return item;
	};
	
	module.exports = function(pattern, flags) {
		var tree = parse(pattern, flags);
		ignoreCase = flags ? flags.indexOf('i') > -1 : false;
		unicode = flags ? flags.indexOf('u') > -1 : false;
		assign(tree, processTerm(tree));
		return generate(tree);
	};


/***/ }),
/* 4462 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*!
	 * RegJSGen
	 * Copyright 2014 Benjamin Tan <https://d10.github.io/>
	 * Available under MIT license <http://d10.mit-license.org/>
	 */
	;(function() {
	  'use strict';
	
	  /** Used to determine if values are of the language type `Object` */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used as a reference to the global object */
	  var root = (objectTypes[typeof window] && window) || this;
	
	  /** Backup possible global object */
	  var oldRoot = root;
	
	  /** Detect free variable `exports` */
	  var freeExports = objectTypes[typeof exports] && exports;
	
	  /** Detect free variable `module` */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js or Browserified code and use it as `root` */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global;
	  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /*! Based on https://mths.be/fromcodepoint v0.2.0 by @mathias */
	
	  var stringFromCharCode = String.fromCharCode;
	  var floor = Math.floor;
	  function fromCodePoint() {
	    var MAX_SIZE = 0x4000;
	    var codeUnits = [];
	    var highSurrogate;
	    var lowSurrogate;
	    var index = -1;
	    var length = arguments.length;
	    if (!length) {
	      return '';
	    }
	    var result = '';
	    while (++index < length) {
	      var codePoint = Number(arguments[index]);
	      if (
	        !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
	        codePoint < 0 || // not a valid Unicode code point
	        codePoint > 0x10FFFF || // not a valid Unicode code point
	        floor(codePoint) != codePoint // not an integer
	      ) {
	        throw RangeError('Invalid code point: ' + codePoint);
	      }
	      if (codePoint <= 0xFFFF) {
	        // BMP code point
	        codeUnits.push(codePoint);
	      } else {
	        // Astral code point; split in surrogate halves
	        // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	        codePoint -= 0x10000;
	        highSurrogate = (codePoint >> 10) + 0xD800;
	        lowSurrogate = (codePoint % 0x400) + 0xDC00;
	        codeUnits.push(highSurrogate, lowSurrogate);
	      }
	      if (index + 1 == length || codeUnits.length > MAX_SIZE) {
	        result += stringFromCharCode.apply(null, codeUnits);
	        codeUnits.length = 0;
	      }
	    }
	    return result;
	  }
	
	  function assertType(type, expected) {
	    if (expected.indexOf('|') == -1) {
	      if (type == expected) {
	        return;
	      }
	
	      throw Error('Invalid node type: ' + type);
	    }
	
	    expected = assertType.hasOwnProperty(expected)
	      ? assertType[expected]
	      : (assertType[expected] = RegExp('^(?:' + expected + ')$'));
	
	    if (expected.test(type)) {
	      return;
	    }
	
	    throw Error('Invalid node type: ' + type);
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  function generate(node) {
	    var type = node.type;
	
	    if (generate.hasOwnProperty(type) && typeof generate[type] == 'function') {
	      return generate[type](node);
	    }
	
	    throw Error('Invalid node type: ' + type);
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  function generateAlternative(node) {
	    assertType(node.type, 'alternative');
	
	    var terms = node.body,
	        length = terms ? terms.length : 0;
	
	    if (length == 1) {
	      return generateTerm(terms[0]);
	    } else {
	      var i = -1,
	          result = '';
	
	      while (++i < length) {
	        result += generateTerm(terms[i]);
	      }
	
	      return result;
	    }
	  }
	
	  function generateAnchor(node) {
	    assertType(node.type, 'anchor');
	
	    switch (node.kind) {
	      case 'start':
	        return '^';
	      case 'end':
	        return '$';
	      case 'boundary':
	        return '\\b';
	      case 'not-boundary':
	        return '\\B';
	      default:
	        throw Error('Invalid assertion');
	    }
	  }
	
	  function generateAtom(node) {
	    assertType(node.type, 'anchor|characterClass|characterClassEscape|dot|group|reference|value');
	
	    return generate(node);
	  }
	
	  function generateCharacterClass(node) {
	    assertType(node.type, 'characterClass');
	
	    var classRanges = node.body,
	        length = classRanges ? classRanges.length : 0;
	
	    var i = -1,
	        result = '[';
	
	    if (node.negative) {
	      result += '^';
	    }
	
	    while (++i < length) {
	      result += generateClassAtom(classRanges[i]);
	    }
	
	    result += ']';
	
	    return result;
	  }
	
	  function generateCharacterClassEscape(node) {
	    assertType(node.type, 'characterClassEscape');
	
	    return '\\' + node.value;
	  }
	
	  function generateCharacterClassRange(node) {
	    assertType(node.type, 'characterClassRange');
	
	    var min = node.min,
	        max = node.max;
	
	    if (min.type == 'characterClassRange' || max.type == 'characterClassRange') {
	      throw Error('Invalid character class range');
	    }
	
	    return generateClassAtom(min) + '-' + generateClassAtom(max);
	  }
	
	  function generateClassAtom(node) {
	    assertType(node.type, 'anchor|characterClassEscape|characterClassRange|dot|value');
	
	    return generate(node);
	  }
	
	  function generateDisjunction(node) {
	    assertType(node.type, 'disjunction');
	
	    var body = node.body,
	        length = body ? body.length : 0;
	
	    if (length == 0) {
	      throw Error('No body');
	    } else if (length == 1) {
	      return generate(body[0]);
	    } else {
	      var i = -1,
	          result = '';
	
	      while (++i < length) {
	        if (i != 0) {
	          result += '|';
	        }
	        result += generate(body[i]);
	      }
	
	      return result;
	    }
	  }
	
	  function generateDot(node) {
	    assertType(node.type, 'dot');
	
	    return '.';
	  }
	
	  function generateGroup(node) {
	    assertType(node.type, 'group');
	
	    var result = '(';
	
	    switch (node.behavior) {
	      case 'normal':
	        break;
	      case 'ignore':
	        result += '?:';
	        break;
	      case 'lookahead':
	        result += '?=';
	        break;
	      case 'negativeLookahead':
	        result += '?!';
	        break;
	      default:
	        throw Error('Invalid behaviour: ' + node.behaviour);
	    }
	
	    var body = node.body,
	        length = body ? body.length : 0;
	
	    if (length == 1) {
	      result += generate(body[0]);
	    } else {
	      var i = -1;
	
	      while (++i < length) {
	        result += generate(body[i]);
	      }
	    }
	
	    result += ')';
	
	    return result;
	  }
	
	  function generateQuantifier(node) {
	    assertType(node.type, 'quantifier');
	
	    var quantifier = '',
	        min = node.min,
	        max = node.max;
	
	    switch (max) {
	      case undefined:
	      case null:
	        switch (min) {
	          case 0:
	            quantifier = '*'
	            break;
	          case 1:
	            quantifier = '+';
	            break;
	          default:
	            quantifier = '{' + min + ',}';
	            break;
	        }
	        break;
	      default:
	        if (min == max) {
	          quantifier = '{' + min + '}';
	        }
	        else if (min == 0 && max == 1) {
	          quantifier = '?';
	        } else {
	          quantifier = '{' + min + ',' + max + '}';
	        }
	        break;
	    }
	
	    if (!node.greedy) {
	      quantifier += '?';
	    }
	
	    return generateAtom(node.body[0]) + quantifier;
	  }
	
	  function generateReference(node) {
	    assertType(node.type, 'reference');
	
	    return '\\' + node.matchIndex;
	  }
	
	  function generateTerm(node) {
	    assertType(node.type, 'anchor|characterClass|characterClassEscape|empty|group|quantifier|reference|value');
	
	    return generate(node);
	  }
	
	  function generateValue(node) {
	    assertType(node.type, 'value');
	
	    var kind = node.kind,
	        codePoint = node.codePoint;
	
	    switch (kind) {
	      case 'controlLetter':
	        return '\\c' + fromCodePoint(codePoint + 64);
	      case 'hexadecimalEscape':
	        return '\\x' + ('00' + codePoint.toString(16).toUpperCase()).slice(-2);
	      case 'identifier':
	        return '\\' + fromCodePoint(codePoint);
	      case 'null':
	        return '\\' + codePoint;
	      case 'octal':
	        return '\\' + codePoint.toString(8);
	      case 'singleEscape':
	        switch (codePoint) {
	          case 0x0008:
	            return '\\b';
	          case 0x009:
	            return '\\t';
	          case 0x00A:
	            return '\\n';
	          case 0x00B:
	            return '\\v';
	          case 0x00C:
	            return '\\f';
	          case 0x00D:
	            return '\\r';
	          default:
	            throw Error('Invalid codepoint: ' + codePoint);
	        }
	      case 'symbol':
	        return fromCodePoint(codePoint);
	      case 'unicodeEscape':
	        return '\\u' + ('0000' + codePoint.toString(16).toUpperCase()).slice(-4);
	      case 'unicodeCodePointEscape':
	        return '\\u{' + codePoint.toString(16).toUpperCase() + '}';
	      default:
	        throw Error('Unsupported node kind: ' + kind);
	    }
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  generate.alternative = generateAlternative;
	  generate.anchor = generateAnchor;
	  generate.characterClass = generateCharacterClass;
	  generate.characterClassEscape = generateCharacterClassEscape;
	  generate.characterClassRange = generateCharacterClassRange;
	  generate.disjunction = generateDisjunction;
	  generate.dot = generateDot;
	  generate.group = generateGroup;
	  generate.quantifier = generateQuantifier;
	  generate.reference = generateReference;
	  generate.value = generateValue;
	
	  /*--------------------------------------------------------------------------*/
	
	  // export regjsgen
	  // some AMD build optimizers, like r.js, check for condition patterns like the following:
	  if (true) {
	    // define as an anonymous module so, through path mapping, it can be aliased
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return {
	        'generate': generate
	      };
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // check for `exports` after `define` in case a build optimizer adds an `exports` object
	  else if (freeExports && freeModule) {
	    // in Narwhal, Node.js, Rhino -require, or RingoJS
	    freeExports.generate = generate;
	  }
	  // in a browser or Rhino
	  else {
	    root.regjsgen = {
	      'generate': generate
	    };
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)(module), (function() { return this; }())))

/***/ }),
/* 4463 */
/***/ (function(module, exports) {

	// regjsparser
	//
	// ==================================================================
	//
	// See ECMA-262 Standard: 15.10.1
	//
	// NOTE: The ECMA-262 standard uses the term "Assertion" for /^/. Here the
	//   term "Anchor" is used.
	//
	// Pattern ::
	//      Disjunction
	//
	// Disjunction ::
	//      Alternative
	//      Alternative | Disjunction
	//
	// Alternative ::
	//      [empty]
	//      Alternative Term
	//
	// Term ::
	//      Anchor
	//      Atom
	//      Atom Quantifier
	//
	// Anchor ::
	//      ^
	//      $
	//      \ b
	//      \ B
	//      ( ? = Disjunction )
	//      ( ? ! Disjunction )
	//
	// Quantifier ::
	//      QuantifierPrefix
	//      QuantifierPrefix ?
	//
	// QuantifierPrefix ::
	//      *
	//      +
	//      ?
	//      { DecimalDigits }
	//      { DecimalDigits , }
	//      { DecimalDigits , DecimalDigits }
	//
	// Atom ::
	//      PatternCharacter
	//      .
	//      \ AtomEscape
	//      CharacterClass
	//      ( Disjunction )
	//      ( ? : Disjunction )
	//
	// PatternCharacter ::
	//      SourceCharacter but not any of: ^ $ \ . * + ? ( ) [ ] { } |
	//
	// AtomEscape ::
	//      DecimalEscape
	//      CharacterEscape
	//      CharacterClassEscape
	//
	// CharacterEscape[U] ::
	//      ControlEscape
	//      c ControlLetter
	//      HexEscapeSequence
	//      RegExpUnicodeEscapeSequence[?U] (ES6)
	//      IdentityEscape[?U]
	//
	// ControlEscape ::
	//      one of f n r t v
	// ControlLetter ::
	//      one of
	//          a b c d e f g h i j k l m n o p q r s t u v w x y z
	//          A B C D E F G H I J K L M N O P Q R S T U V W X Y Z
	//
	// IdentityEscape ::
	//      SourceCharacter but not IdentifierPart
	//      <ZWJ>
	//      <ZWNJ>
	//
	// DecimalEscape ::
	//      DecimalIntegerLiteral [lookahead ∉ DecimalDigit]
	//
	// CharacterClassEscape ::
	//      one of d D s S w W
	//
	// CharacterClass ::
	//      [ [lookahead ∉ {^}] ClassRanges ]
	//      [ ^ ClassRanges ]
	//
	// ClassRanges ::
	//      [empty]
	//      NonemptyClassRanges
	//
	// NonemptyClassRanges ::
	//      ClassAtom
	//      ClassAtom NonemptyClassRangesNoDash
	//      ClassAtom - ClassAtom ClassRanges
	//
	// NonemptyClassRangesNoDash ::
	//      ClassAtom
	//      ClassAtomNoDash NonemptyClassRangesNoDash
	//      ClassAtomNoDash - ClassAtom ClassRanges
	//
	// ClassAtom ::
	//      -
	//      ClassAtomNoDash
	//
	// ClassAtomNoDash ::
	//      SourceCharacter but not one of \ or ] or -
	//      \ ClassEscape
	//
	// ClassEscape ::
	//      DecimalEscape
	//      b
	//      CharacterEscape
	//      CharacterClassEscape
	
	(function() {
	
	  function parse(str, flags) {
	    function addRaw(node) {
	      node.raw = str.substring(node.range[0], node.range[1]);
	      return node;
	    }
	
	    function updateRawStart(node, start) {
	      node.range[0] = start;
	      return addRaw(node);
	    }
	
	    function createAnchor(kind, rawLength) {
	      return addRaw({
	        type: 'anchor',
	        kind: kind,
	        range: [
	          pos - rawLength,
	          pos
	        ]
	      });
	    }
	
	    function createValue(kind, codePoint, from, to) {
	      return addRaw({
	        type: 'value',
	        kind: kind,
	        codePoint: codePoint,
	        range: [from, to]
	      });
	    }
	
	    function createEscaped(kind, codePoint, value, fromOffset) {
	      fromOffset = fromOffset || 0;
	      return createValue(kind, codePoint, pos - (value.length + fromOffset), pos);
	    }
	
	    function createCharacter(matches) {
	      var _char = matches[0];
	      var first = _char.charCodeAt(0);
	      if (hasUnicodeFlag) {
	        var second;
	        if (_char.length === 1 && first >= 0xD800 && first <= 0xDBFF) {
	          second = lookahead().charCodeAt(0);
	          if (second >= 0xDC00 && second <= 0xDFFF) {
	            // Unicode surrogate pair
	            pos++;
	            return createValue(
	                'symbol',
	                (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000,
	                pos - 2, pos);
	          }
	        }
	      }
	      return createValue('symbol', first, pos - 1, pos);
	    }
	
	    function createDisjunction(alternatives, from, to) {
	      return addRaw({
	        type: 'disjunction',
	        body: alternatives,
	        range: [
	          from,
	          to
	        ]
	      });
	    }
	
	    function createDot() {
	      return addRaw({
	        type: 'dot',
	        range: [
	          pos - 1,
	          pos
	        ]
	      });
	    }
	
	    function createCharacterClassEscape(value) {
	      return addRaw({
	        type: 'characterClassEscape',
	        value: value,
	        range: [
	          pos - 2,
	          pos
	        ]
	      });
	    }
	
	    function createReference(matchIndex) {
	      return addRaw({
	        type: 'reference',
	        matchIndex: parseInt(matchIndex, 10),
	        range: [
	          pos - 1 - matchIndex.length,
	          pos
	        ]
	      });
	    }
	
	    function createGroup(behavior, disjunction, from, to) {
	      return addRaw({
	        type: 'group',
	        behavior: behavior,
	        body: disjunction,
	        range: [
	          from,
	          to
	        ]
	      });
	    }
	
	    function createQuantifier(min, max, from, to) {
	      if (to == null) {
	        from = pos - 1;
	        to = pos;
	      }
	
	      return addRaw({
	        type: 'quantifier',
	        min: min,
	        max: max,
	        greedy: true,
	        body: null, // set later on
	        range: [
	          from,
	          to
	        ]
	      });
	    }
	
	    function createAlternative(terms, from, to) {
	      return addRaw({
	        type: 'alternative',
	        body: terms,
	        range: [
	          from,
	          to
	        ]
	      });
	    }
	
	    function createCharacterClass(classRanges, negative, from, to) {
	      return addRaw({
	        type: 'characterClass',
	        body: classRanges,
	        negative: negative,
	        range: [
	          from,
	          to
	        ]
	      });
	    }
	
	    function createClassRange(min, max, from, to) {
	      // See 15.10.2.15:
	      if (min.codePoint > max.codePoint) {
	        bail('invalid range in character class', min.raw + '-' + max.raw, from, to);
	      }
	
	      return addRaw({
	        type: 'characterClassRange',
	        min: min,
	        max: max,
	        range: [
	          from,
	          to
	        ]
	      });
	    }
	
	    function flattenBody(body) {
	      if (body.type === 'alternative') {
	        return body.body;
	      } else {
	        return [body];
	      }
	    }
	
	    function isEmpty(obj) {
	      return obj.type === 'empty';
	    }
	
	    function incr(amount) {
	      amount = (amount || 1);
	      var res = str.substring(pos, pos + amount);
	      pos += (amount || 1);
	      return res;
	    }
	
	    function skip(value) {
	      if (!match(value)) {
	        bail('character', value);
	      }
	    }
	
	    function match(value) {
	      if (str.indexOf(value, pos) === pos) {
	        return incr(value.length);
	      }
	    }
	
	    function lookahead() {
	      return str[pos];
	    }
	
	    function current(value) {
	      return str.indexOf(value, pos) === pos;
	    }
	
	    function next(value) {
	      return str[pos + 1] === value;
	    }
	
	    function matchReg(regExp) {
	      var subStr = str.substring(pos);
	      var res = subStr.match(regExp);
	      if (res) {
	        res.range = [];
	        res.range[0] = pos;
	        incr(res[0].length);
	        res.range[1] = pos;
	      }
	      return res;
	    }
	
	    function parseDisjunction() {
	      // Disjunction ::
	      //      Alternative
	      //      Alternative | Disjunction
	      var res = [], from = pos;
	      res.push(parseAlternative());
	
	      while (match('|')) {
	        res.push(parseAlternative());
	      }
	
	      if (res.length === 1) {
	        return res[0];
	      }
	
	      return createDisjunction(res, from, pos);
	    }
	
	    function parseAlternative() {
	      var res = [], from = pos;
	      var term;
	
	      // Alternative ::
	      //      [empty]
	      //      Alternative Term
	      while (term = parseTerm()) {
	        res.push(term);
	      }
	
	      if (res.length === 1) {
	        return res[0];
	      }
	
	      return createAlternative(res, from, pos);
	    }
	
	    function parseTerm() {
	      // Term ::
	      //      Anchor
	      //      Atom
	      //      Atom Quantifier
	
	      if (pos >= str.length || current('|') || current(')')) {
	        return null; /* Means: The term is empty */
	      }
	
	      var anchor = parseAnchor();
	
	      if (anchor) {
	        return anchor;
	      }
	
	      var atom = parseAtom();
	      if (!atom) {
	        bail('Expected atom');
	      }
	      var quantifier = parseQuantifier() || false;
	      if (quantifier) {
	        quantifier.body = flattenBody(atom);
	        // The quantifier contains the atom. Therefore, the beginning of the
	        // quantifier range is given by the beginning of the atom.
	        updateRawStart(quantifier, atom.range[0]);
	        return quantifier;
	      }
	      return atom;
	    }
	
	    function parseGroup(matchA, typeA, matchB, typeB) {
	      var type = null, from = pos;
	
	      if (match(matchA)) {
	        type = typeA;
	      } else if (match(matchB)) {
	        type = typeB;
	      } else {
	        return false;
	      }
	
	      var body = parseDisjunction();
	      if (!body) {
	        bail('Expected disjunction');
	      }
	      skip(')');
	      var group = createGroup(type, flattenBody(body), from, pos);
	
	      if (type == 'normal') {
	        // Keep track of the number of closed groups. This is required for
	        // parseDecimalEscape(). In case the string is parsed a second time the
	        // value already holds the total count and no incrementation is required.
	        if (firstIteration) {
	          closedCaptureCounter++;
	        }
	      }
	      return group;
	    }
	
	    function parseAnchor() {
	      // Anchor ::
	      //      ^
	      //      $
	      //      \ b
	      //      \ B
	      //      ( ? = Disjunction )
	      //      ( ? ! Disjunction )
	      var res, from = pos;
	
	      if (match('^')) {
	        return createAnchor('start', 1 /* rawLength */);
	      } else if (match('$')) {
	        return createAnchor('end', 1 /* rawLength */);
	      } else if (match('\\b')) {
	        return createAnchor('boundary', 2 /* rawLength */);
	      } else if (match('\\B')) {
	        return createAnchor('not-boundary', 2 /* rawLength */);
	      } else {
	        return parseGroup('(?=', 'lookahead', '(?!', 'negativeLookahead');
	      }
	    }
	
	    function parseQuantifier() {
	      // Quantifier ::
	      //      QuantifierPrefix
	      //      QuantifierPrefix ?
	      //
	      // QuantifierPrefix ::
	      //      *
	      //      +
	      //      ?
	      //      { DecimalDigits }
	      //      { DecimalDigits , }
	      //      { DecimalDigits , DecimalDigits }
	
	      var res, from = pos;
	      var quantifier;
	      var min, max;
	
	      if (match('*')) {
	        quantifier = createQuantifier(0);
	      }
	      else if (match('+')) {
	        quantifier = createQuantifier(1);
	      }
	      else if (match('?')) {
	        quantifier = createQuantifier(0, 1);
	      }
	      else if (res = matchReg(/^\{([0-9]+)\}/)) {
	        min = parseInt(res[1], 10);
	        quantifier = createQuantifier(min, min, res.range[0], res.range[1]);
	      }
	      else if (res = matchReg(/^\{([0-9]+),\}/)) {
	        min = parseInt(res[1], 10);
	        quantifier = createQuantifier(min, undefined, res.range[0], res.range[1]);
	      }
	      else if (res = matchReg(/^\{([0-9]+),([0-9]+)\}/)) {
	        min = parseInt(res[1], 10);
	        max = parseInt(res[2], 10);
	        if (min > max) {
	          bail('numbers out of order in {} quantifier', '', from, pos);
	        }
	        quantifier = createQuantifier(min, max, res.range[0], res.range[1]);
	      }
	
	      if (quantifier) {
	        if (match('?')) {
	          quantifier.greedy = false;
	          quantifier.range[1] += 1;
	        }
	      }
	
	      return quantifier;
	    }
	
	    function parseAtom() {
	      // Atom ::
	      //      PatternCharacter
	      //      .
	      //      \ AtomEscape
	      //      CharacterClass
	      //      ( Disjunction )
	      //      ( ? : Disjunction )
	
	      var res;
	
	      // jviereck: allow ']', '}' here as well to be compatible with browser's
	      //   implementations: ']'.match(/]/);
	      // if (res = matchReg(/^[^^$\\.*+?()[\]{}|]/)) {
	      if (res = matchReg(/^[^^$\\.*+?(){[|]/)) {
	        //      PatternCharacter
	        return createCharacter(res);
	      }
	      else if (match('.')) {
	        //      .
	        return createDot();
	      }
	      else if (match('\\')) {
	        //      \ AtomEscape
	        res = parseAtomEscape();
	        if (!res) {
	          bail('atomEscape');
	        }
	        return res;
	      }
	      else if (res = parseCharacterClass()) {
	        return res;
	      }
	      else {
	        //      ( Disjunction )
	        //      ( ? : Disjunction )
	        return parseGroup('(?:', 'ignore', '(', 'normal');
	      }
	    }
	
	    function parseUnicodeSurrogatePairEscape(firstEscape) {
	      if (hasUnicodeFlag) {
	        var first, second;
	        if (firstEscape.kind == 'unicodeEscape' &&
	          (first = firstEscape.codePoint) >= 0xD800 && first <= 0xDBFF &&
	          current('\\') && next('u') ) {
	          var prevPos = pos;
	          pos++;
	          var secondEscape = parseClassEscape();
	          if (secondEscape.kind == 'unicodeEscape' &&
	            (second = secondEscape.codePoint) >= 0xDC00 && second <= 0xDFFF) {
	            // Unicode surrogate pair
	            firstEscape.range[1] = secondEscape.range[1];
	            firstEscape.codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
	            firstEscape.type = 'value';
	            firstEscape.kind = 'unicodeCodePointEscape';
	            addRaw(firstEscape);
	          }
	          else {
	            pos = prevPos;
	          }
	        }
	      }
	      return firstEscape;
	    }
	
	    function parseClassEscape() {
	      return parseAtomEscape(true);
	    }
	
	    function parseAtomEscape(insideCharacterClass) {
	      // AtomEscape ::
	      //      DecimalEscape
	      //      CharacterEscape
	      //      CharacterClassEscape
	
	      var res, from = pos;
	
	      res = parseDecimalEscape();
	      if (res) {
	        return res;
	      }
	
	      // For ClassEscape
	      if (insideCharacterClass) {
	        if (match('b')) {
	          // 15.10.2.19
	          // The production ClassEscape :: b evaluates by returning the
	          // CharSet containing the one character <BS> (Unicode value 0008).
	          return createEscaped('singleEscape', 0x0008, '\\b');
	        } else if (match('B')) {
	          bail('\\B not possible inside of CharacterClass', '', from);
	        }
	      }
	
	      res = parseCharacterEscape();
	
	      return res;
	    }
	
	
	    function parseDecimalEscape() {
	      // DecimalEscape ::
	      //      DecimalIntegerLiteral [lookahead ∉ DecimalDigit]
	      //      CharacterClassEscape :: one of d D s S w W
	
	      var res, match;
	
	      if (res = matchReg(/^(?!0)\d+/)) {
	        match = res[0];
	        var refIdx = parseInt(res[0], 10);
	        if (refIdx <= closedCaptureCounter) {
	          // If the number is smaller than the normal-groups found so
	          // far, then it is a reference...
	          return createReference(res[0]);
	        } else {
	          // ... otherwise it needs to be interpreted as a octal (if the
	          // number is in an octal format). If it is NOT octal format,
	          // then the slash is ignored and the number is matched later
	          // as normal characters.
	
	          // Recall the negative decision to decide if the input must be parsed
	          // a second time with the total normal-groups.
	          backrefDenied.push(refIdx);
	
	          // Reset the position again, as maybe only parts of the previous
	          // matched numbers are actual octal numbers. E.g. in '019' only
	          // the '01' should be matched.
	          incr(-res[0].length);
	          if (res = matchReg(/^[0-7]{1,3}/)) {
	            return createEscaped('octal', parseInt(res[0], 8), res[0], 1);
	          } else {
	            // If we end up here, we have a case like /\91/. Then the
	            // first slash is to be ignored and the 9 & 1 to be treated
	            // like ordinary characters. Create a character for the
	            // first number only here - other number-characters
	            // (if available) will be matched later.
	            res = createCharacter(matchReg(/^[89]/));
	            return updateRawStart(res, res.range[0] - 1);
	          }
	        }
	      }
	      // Only allow octal numbers in the following. All matched numbers start
	      // with a zero (if the do not, the previous if-branch is executed).
	      // If the number is not octal format and starts with zero (e.g. `091`)
	      // then only the zeros `0` is treated here and the `91` are ordinary
	      // characters.
	      // Example:
	      //   /\091/.exec('\091')[0].length === 3
	      else if (res = matchReg(/^[0-7]{1,3}/)) {
	        match = res[0];
	        if (/^0{1,3}$/.test(match)) {
	          // If they are all zeros, then only take the first one.
	          return createEscaped('null', 0x0000, '0', match.length + 1);
	        } else {
	          return createEscaped('octal', parseInt(match, 8), match, 1);
	        }
	      } else if (res = matchReg(/^[dDsSwW]/)) {
	        return createCharacterClassEscape(res[0]);
	      }
	      return false;
	    }
	
	    function parseCharacterEscape() {
	      // CharacterEscape ::
	      //      ControlEscape
	      //      c ControlLetter
	      //      HexEscapeSequence
	      //      UnicodeEscapeSequence
	      //      IdentityEscape
	
	      var res;
	      if (res = matchReg(/^[fnrtv]/)) {
	        // ControlEscape
	        var codePoint = 0;
	        switch (res[0]) {
	          case 't': codePoint = 0x009; break;
	          case 'n': codePoint = 0x00A; break;
	          case 'v': codePoint = 0x00B; break;
	          case 'f': codePoint = 0x00C; break;
	          case 'r': codePoint = 0x00D; break;
	        }
	        return createEscaped('singleEscape', codePoint, '\\' + res[0]);
	      } else if (res = matchReg(/^c([a-zA-Z])/)) {
	        // c ControlLetter
	        return createEscaped('controlLetter', res[1].charCodeAt(0) % 32, res[1], 2);
	      } else if (res = matchReg(/^x([0-9a-fA-F]{2})/)) {
	        // HexEscapeSequence
	        return createEscaped('hexadecimalEscape', parseInt(res[1], 16), res[1], 2);
	      } else if (res = matchReg(/^u([0-9a-fA-F]{4})/)) {
	        // UnicodeEscapeSequence
	        return parseUnicodeSurrogatePairEscape(
	          createEscaped('unicodeEscape', parseInt(res[1], 16), res[1], 2)
	        );
	      } else if (hasUnicodeFlag && (res = matchReg(/^u\{([0-9a-fA-F]+)\}/))) {
	        // RegExpUnicodeEscapeSequence (ES6 Unicode code point escape)
	        return createEscaped('unicodeCodePointEscape', parseInt(res[1], 16), res[1], 4);
	      } else {
	        // IdentityEscape
	        return parseIdentityEscape();
	      }
	    }
	
	    // Taken from the Esprima parser.
	    function isIdentifierPart(ch) {
	      // Generated by `tools/generate-identifier-regex.js`.
	      var NonAsciiIdentifierPart = new RegExp('[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B2\u08E4-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58\u0C59\u0C60-\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D60-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFC-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA69D\uA69F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C4\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2D\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]');
	
	      return (ch === 36) || (ch === 95) ||  // $ (dollar) and _ (underscore)
	        (ch >= 65 && ch <= 90) ||         // A..Z
	        (ch >= 97 && ch <= 122) ||        // a..z
	        (ch >= 48 && ch <= 57) ||         // 0..9
	        (ch === 92) ||                    // \ (backslash)
	        ((ch >= 0x80) && NonAsciiIdentifierPart.test(String.fromCharCode(ch)));
	    }
	
	    function parseIdentityEscape() {
	      // IdentityEscape ::
	      //      SourceCharacter but not IdentifierPart
	      //      <ZWJ>
	      //      <ZWNJ>
	
	      var ZWJ = '\u200C';
	      var ZWNJ = '\u200D';
	
	      var tmp;
	
	      if (!isIdentifierPart(lookahead())) {
	        tmp = incr();
	        return createEscaped('identifier', tmp.charCodeAt(0), tmp, 1);
	      }
	
	      if (match(ZWJ)) {
	        // <ZWJ>
	        return createEscaped('identifier', 0x200C, ZWJ);
	      } else if (match(ZWNJ)) {
	        // <ZWNJ>
	        return createEscaped('identifier', 0x200D, ZWNJ);
	      }
	
	      return null;
	    }
	
	    function parseCharacterClass() {
	      // CharacterClass ::
	      //      [ [lookahead ∉ {^}] ClassRanges ]
	      //      [ ^ ClassRanges ]
	
	      var res, from = pos;
	      if (res = matchReg(/^\[\^/)) {
	        res = parseClassRanges();
	        skip(']');
	        return createCharacterClass(res, true, from, pos);
	      } else if (match('[')) {
	        res = parseClassRanges();
	        skip(']');
	        return createCharacterClass(res, false, from, pos);
	      }
	
	      return null;
	    }
	
	    function parseClassRanges() {
	      // ClassRanges ::
	      //      [empty]
	      //      NonemptyClassRanges
	
	      var res;
	      if (current(']')) {
	        // Empty array means nothing insinde of the ClassRange.
	        return [];
	      } else {
	        res = parseNonemptyClassRanges();
	        if (!res) {
	          bail('nonEmptyClassRanges');
	        }
	        return res;
	      }
	    }
	
	    function parseHelperClassRanges(atom) {
	      var from, to, res;
	      if (current('-') && !next(']')) {
	        // ClassAtom - ClassAtom ClassRanges
	        skip('-');
	
	        res = parseClassAtom();
	        if (!res) {
	          bail('classAtom');
	        }
	        to = pos;
	        var classRanges = parseClassRanges();
	        if (!classRanges) {
	          bail('classRanges');
	        }
	        from = atom.range[0];
	        if (classRanges.type === 'empty') {
	          return [createClassRange(atom, res, from, to)];
	        }
	        return [createClassRange(atom, res, from, to)].concat(classRanges);
	      }
	
	      res = parseNonemptyClassRangesNoDash();
	      if (!res) {
	        bail('nonEmptyClassRangesNoDash');
	      }
	
	      return [atom].concat(res);
	    }
	
	    function parseNonemptyClassRanges() {
	      // NonemptyClassRanges ::
	      //      ClassAtom
	      //      ClassAtom NonemptyClassRangesNoDash
	      //      ClassAtom - ClassAtom ClassRanges
	
	      var atom = parseClassAtom();
	      if (!atom) {
	        bail('classAtom');
	      }
	
	      if (current(']')) {
	        // ClassAtom
	        return [atom];
	      }
	
	      // ClassAtom NonemptyClassRangesNoDash
	      // ClassAtom - ClassAtom ClassRanges
	      return parseHelperClassRanges(atom);
	    }
	
	    function parseNonemptyClassRangesNoDash() {
	      // NonemptyClassRangesNoDash ::
	      //      ClassAtom
	      //      ClassAtomNoDash NonemptyClassRangesNoDash
	      //      ClassAtomNoDash - ClassAtom ClassRanges
	
	      var res = parseClassAtom();
	      if (!res) {
	        bail('classAtom');
	      }
	      if (current(']')) {
	        //      ClassAtom
	        return res;
	      }
	
	      // ClassAtomNoDash NonemptyClassRangesNoDash
	      // ClassAtomNoDash - ClassAtom ClassRanges
	      return parseHelperClassRanges(res);
	    }
	
	    function parseClassAtom() {
	      // ClassAtom ::
	      //      -
	      //      ClassAtomNoDash
	      if (match('-')) {
	        return createCharacter('-');
	      } else {
	        return parseClassAtomNoDash();
	      }
	    }
	
	    function parseClassAtomNoDash() {
	      // ClassAtomNoDash ::
	      //      SourceCharacter but not one of \ or ] or -
	      //      \ ClassEscape
	
	      var res;
	      if (res = matchReg(/^[^\\\]-]/)) {
	        return createCharacter(res[0]);
	      } else if (match('\\')) {
	        res = parseClassEscape();
	        if (!res) {
	          bail('classEscape');
	        }
	
	        return parseUnicodeSurrogatePairEscape(res);
	      }
	    }
	
	    function bail(message, details, from, to) {
	      from = from == null ? pos : from;
	      to = to == null ? from : to;
	
	      var contextStart = Math.max(0, from - 10);
	      var contextEnd = Math.min(to + 10, str.length);
	
	      // Output a bit of context and a line pointing to where our error is.
	      //
	      // We are assuming that there are no actual newlines in the content as this is a regular expression.
	      var context = '    ' + str.substring(contextStart, contextEnd);
	      var pointer = '    ' + new Array(from - contextStart + 1).join(' ') + '^';
	
	      throw SyntaxError(message + ' at position ' + from + (details ? ': ' + details : '') + '\n' + context + '\n' + pointer);
	    }
	
	    var backrefDenied = [];
	    var closedCaptureCounter = 0;
	    var firstIteration = true;
	    var hasUnicodeFlag = (flags || "").indexOf("u") !== -1;
	    var pos = 0;
	
	    // Convert the input to a string and treat the empty string special.
	    str = String(str);
	    if (str === '') {
	      str = '(?:)';
	    }
	
	    var result = parseDisjunction();
	
	    if (result.range[1] !== str.length) {
	      bail('Could not parse entire input - got stuck', '', result.range[1]);
	    }
	
	    // The spec requires to interpret the `\2` in `/\2()()/` as backreference.
	    // As the parser collects the number of capture groups as the string is
	    // parsed it is impossible to make these decisions at the point when the
	    // `\2` is handled. In case the local decision turns out to be wrong after
	    // the parsing has finished, the input string is parsed a second time with
	    // the total number of capture groups set.
	    //
	    // SEE: https://github.com/jviereck/regjsparser/issues/70
	    for (var i = 0; i < backrefDenied.length; i++) {
	      if (backrefDenied[i] <= closedCaptureCounter) {
	        // Parse the input a second time.
	        pos = 0;
	        firstIteration = false;
	        return parseDisjunction();
	      }
	    }
	
	    return result;
	  }
	
	  var regjsparser = {
	    parse: parse
	  };
	
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = regjsparser;
	  } else {
	    window.regjsparser = regjsparser;
	  }
	
	}());


/***/ }),
/* 4464 */,
/* 4465 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ }),
/* 4466 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// @flow
	
	/*:: import type {
	  CombinatorTokenType,
	  SelectorTokenType
	} from './types';*/
	
	
	var escapeValue = function escapeValue(value /*: string*/) /*: string*/ {
	  return JSON.stringify(value);
	};
	
	var renderSelector = function renderSelector(selectorToken /*: SelectorTokenType*/) {
	  var tokens = selectorToken.body;
	  var parts = [];
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var token = _step.value;
	
	      var part = void 0;
	
	      if (token.type === 'universalSelector') {
	        part = '*';
	      } else if (token.type === 'typeSelector') {
	        part = token.name;
	      } else if (token.type === 'idSelector') {
	        part = '#' + token.name;
	      } else if (token.type === 'classSelector') {
	        part = '.' + token.name;
	      } else if (token.type === 'attributePresenceSelector') {
	        part = '[' + token.name + ']';
	      } else if (token.type === 'attributeValueSelector') {
	        part = '[' + token.name + token.operator + escapeValue(token.value) + ']';
	      } else if (token.type === 'pseudoClassSelector') {
	        part = ':' + token.name;
	
	        if (token.parameters.length) {
	          part += '(' + token.parameters.map(escapeValue).join(', ') + ')';
	        }
	      } else if (token.type === 'pseudoElementSelector') {
	        part = '::' + token.name;
	      } else {
	        throw new Error('Unknown token.');
	      }
	
	      parts.push(part);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return parts.join('');
	};
	
	exports.default = function () {
	  var generate = function generate(tokens /*: Array<SelectorTokenType | CombinatorTokenType>*/) /*: string*/ {
	    /**
	     * @todo Think of a better name. This array contains selectors or combinators.
	     */
	    var sequences /*: Array<string>*/ = [];
	
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = tokens[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var token = _step2.value;
	
	        if (token.type === 'selector') {
	          sequences.push(renderSelector(token));
	        } else if (token.type === 'descendantCombinator') {
	          sequences.push(' ');
	        } else if (token.type === 'childCombinator') {
	          sequences.push(' > ');
	        } else if (token.type === 'adjacentSiblingCombinator') {
	          sequences.push(' + ');
	        } else if (token.type === 'generalSiblingCombinator') {
	          sequences.push(' ~ ');
	        } else {
	          throw new Error('Unknown token.');
	        }
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	
	    return sequences.join('');
	  };
	
	  return {
	    generate: generate
	  };
	};
	//# sourceMappingURL=createGenerator.js.map

/***/ }),
/* 4467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _nearley = __webpack_require__(4352);
	
	var _grammar = __webpack_require__(4468);
	
	var _grammar2 = _interopRequireDefault(_grammar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*:: import type {
	  CombinatorTokenType,
	  SelectorTokenType
	} from './types';*/ // @flow
	
	exports.default = function () {
	  var parse = function parse(selector /*: string*/) /*: Array<SelectorTokenType | CombinatorTokenType>*/ {
	    var parser = new _nearley.Parser(_grammar2.default.ParserRules, _grammar2.default.ParserStart);
	
	    var results = parser.feed(selector).results;
	
	    if (results.length === 0) {
	      throw new Error('Found no parsings.');
	    }
	
	    if (results.length > 1) {
	      throw new Error('Ambiguous results.');
	    }
	
	    return results[0];
	  };
	
	  return {
	    parse: parse
	  };
	};
	//# sourceMappingURL=createParser.js.map

/***/ }),
/* 4468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Generated automatically by nearley
	// http://github.com/Hardmath123/nearley
	(function () {
	  function id(x) {
	    return x[0];
	  }
	
	  var flattenDeep = __webpack_require__(4204);
	  var appendItem = function appendItem(a, b) {
	    return function (d) {
	      return d[a].concat([d[b]]);
	    };
	  };
	  var appendItemChar = function appendItemChar(a, b) {
	    return function (d) {
	      return d[a].concat(d[b]);
	    };
	  };
	
	  var flatten = function flatten(d) {
	    d = d.filter(function (r) {
	      return r !== null;
	    });
	    return flattenDeep(d);
	  };
	
	  var combinatorMap = {
	    ' ': 'descendantCombinator',
	    '+': 'adjacentSiblingCombinator',
	    '>': 'childCombinator',
	    '~': 'generalSiblingCombinator'
	  };
	
	  var concatUsingCombinator = function concatUsingCombinator(d) {
	    return (Array.isArray(d[0]) ? d[0] : [d[0]]).concat({
	      type: combinatorMap[d[2]]
	    }).concat(d[4]);
	  };
	
	  var parseAsNumber = function parseAsNumber(d, i, reject) {
	    var joined = flattenDeep(d).join('');
	    var parsed = parseFloat(joined);
	    if (isNaN(parsed)) {
	      return reject;
	    }
	    return parsed;
	  };
	
	  var parseAsBoolean = function parseAsBoolean(d, i, reject) {
	    if (d[0] === 'true') return true;
	    if (d[0] === 'false') return false;
	    return reject;
	  };
	
	  var parseFalsyPrimitive = function parseFalsyPrimitive(d, i, reject) {
	    if (d[0] === 'NaN') return NaN;
	    if (d[0] === 'undefined') return undefined;
	    if (d[0] === 'null') return null;
	    return reject;
	  };
	  var grammar = {
	    Lexer: undefined,
	    ParserRules: [{ "name": "combinator", "symbols": ["selector"] }, { "name": "combinator", "symbols": ["combinator", "_", /[>+~ ]/, "_", "selector"], "postprocess": concatUsingCombinator }, { "name": "selector", "symbols": ["selectorBody"], "postprocess": function postprocess(d) {
	        return { type: 'selector', body: d[0] };
	      } }, { "name": "selectorBody$ebnf$1", "symbols": ["typeSelector"], "postprocess": id }, { "name": "selectorBody$ebnf$1", "symbols": [], "postprocess": function postprocess(d) {
	        return null;
	      } }, { "name": "selectorBody$ebnf$2", "symbols": [] }, { "name": "selectorBody$ebnf$2", "symbols": ["selectorBody$ebnf$2", "simpleSelector"], "postprocess": function arrpush(d) {
	        return d[0].concat([d[1]]);
	      } }, { "name": "selectorBody", "symbols": ["selectorBody$ebnf$1", "selectorBody$ebnf$2"], "postprocess": function postprocess(d, i, reject) {
	        var selectors = flatten(d);if (!selectors.length) return reject;return selectors;
	      } }, { "name": "selectorBody$ebnf$3", "symbols": [] }, { "name": "selectorBody$ebnf$3", "symbols": ["selectorBody$ebnf$3", "simpleSelector"], "postprocess": function arrpush(d) {
	        return d[0].concat([d[1]]);
	      } }, { "name": "selectorBody", "symbols": ["universalSelector", "selectorBody$ebnf$3"], "postprocess": flatten }, { "name": "simpleSelector", "symbols": ["idSelector"] }, { "name": "simpleSelector", "symbols": ["classSelector"] }, { "name": "simpleSelector", "symbols": ["attributeValueSelector"] }, { "name": "simpleSelector", "symbols": ["attributePresenceSelector"] }, { "name": "simpleSelector", "symbols": ["pseudoClassSelector"] }, { "name": "simpleSelector", "symbols": ["pseudoElementSelector"] }, { "name": "typeSelector", "symbols": ["attributeName"], "postprocess": function postprocess(d) {
	        return { type: 'typeSelector', name: d[0] };
	      } }, { "name": "className$ebnf$1", "symbols": [{ "literal": "-" }], "postprocess": id }, { "name": "className$ebnf$1", "symbols": [], "postprocess": function postprocess(d) {
	        return null;
	      } }, { "name": "className$ebnf$2", "symbols": [] }, { "name": "className$ebnf$2", "symbols": ["className$ebnf$2", /[_a-zA-Z0-9-]/], "postprocess": function arrpush(d) {
	        return d[0].concat([d[1]]);
	      } }, { "name": "className", "symbols": ["className$ebnf$1", /[_a-zA-Z]/, "className$ebnf$2"], "postprocess": function postprocess(d) {
	        return (d[0] || '') + d[1] + d[2].join('');
	      } }, { "name": "attributeName$ebnf$1", "symbols": [] }, { "name": "attributeName$ebnf$1", "symbols": ["attributeName$ebnf$1", /[_a-zA-Z()0-9-]/], "postprocess": function arrpush(d) {
	        return d[0].concat([d[1]]);
	      } }, { "name": "attributeName", "symbols": [/[_a-z()A-Z]/, "attributeName$ebnf$1"], "postprocess": function postprocess(d) {
	        return d[0] + d[1].join('');
	      } }, { "name": "classSelector", "symbols": [{ "literal": "." }, "className"], "postprocess": function postprocess(d) {
	        return { type: 'classSelector', name: d[1] };
	      } }, { "name": "idSelector", "symbols": [{ "literal": "#" }, "attributeName"], "postprocess": function postprocess(d) {
	        return { type: 'idSelector', name: d[1] };
	      } }, { "name": "universalSelector", "symbols": [{ "literal": "*" }], "postprocess": function postprocess(d) {
	        return { type: 'universalSelector' };
	      } }, { "name": "attributePresenceSelector", "symbols": [{ "literal": "[" }, "attributeName", { "literal": "]" }], "postprocess": function postprocess(d) {
	        return { type: 'attributePresenceSelector', name: d[1] };
	      } }, { "name": "attributeOperator", "symbols": [{ "literal": "=" }] }, { "name": "attributeOperator$string$1", "symbols": [{ "literal": "~" }, { "literal": "=" }], "postprocess": function joiner(d) {
	        return d.join('');
	      } }, { "name": "attributeOperator", "symbols": ["attributeOperator$string$1"] }, { "name": "attributeOperator$string$2", "symbols": [{ "literal": "|" }, { "literal": "=" }], "postprocess": function joiner(d) {
	        return d.join('');
	      } }, { "name": "attributeOperator", "symbols": ["attributeOperator$string$2"] }, { "name": "attributeOperator$string$3", "symbols": [{ "literal": "^" }, { "literal": "=" }], "postprocess": function joiner(d) {
	        return d.join('');
	      } }, { "name": "attributeOperator", "symbols": ["attributeOperator$string$3"] }, { "name": "attributeOperator$string$4", "symbols": [{ "literal": "$" }, { "literal": "=" }], "postprocess": function joiner(d) {
	        return d.join('');
	      } }, { "name": "attributeOperator", "symbols": ["attributeOperator$string$4"] }, { "name": "attributeOperator$string$5", "symbols": [{ "literal": "*" }, { "literal": "=" }], "postprocess": function joiner(d) {
	        return d.join('');
	      } }, { "name": "attributeOperator", "symbols": ["attributeOperator$string$5"] }, { "name": "attributeValueSelector", "symbols": [{ "literal": "[" }, "attributeName", "attributeOperator", "attributeValue", { "literal": "]" }], "postprocess": function postprocess(d) {
	        return {
	          type: 'attributeValueSelector',
	          name: d[1],
	          value: d[3],
	          operator: d[2][0]
	        };
	      }
	    }, { "name": "attributeValue", "symbols": ["falsyPrimitiveStrings"], "postprocess": id }, { "name": "attributeValue", "symbols": ["numericValue"], "postprocess": id }, { "name": "attributeValue", "symbols": ["sqstring"], "postprocess": id }, { "name": "attributeValue", "symbols": ["dqstring"], "postprocess": id }, { "name": "falsyPrimitiveStrings$string$1", "symbols": [{ "literal": "f" }, { "literal": "a" }, { "literal": "l" }, { "literal": "s" }, { "literal": "e" }], "postprocess": function joiner(d) {
	        return d.join('');
	      } }, { "name": "falsyPrimitiveStrings", "symbols": ["falsyPrimitiveStrings$string$1"], "postprocess": parseAsBoolean }, { "name": "falsyPrimitiveStrings$string$2", "symbols": [{ "literal": "t" }, { "literal": "r" }, { "literal": "u" }, { "literal": "e" }], "postprocess": function joiner(d) {
	        return d.join('');
	      } }, { "name": "falsyPrimitiveStrings", "symbols": ["falsyPrimitiveStrings$string$2"], "postprocess": parseAsBoolean }, { "name": "falsyPrimitiveStrings$string$3", "symbols": [{ "literal": "N" }, { "literal": "a" }, { "literal": "N" }], "postprocess": function joiner(d) {
	        return d.join('');
	      } }, { "name": "falsyPrimitiveStrings", "symbols": ["falsyPrimitiveStrings$string$3"], "postprocess": parseFalsyPrimitive }, { "name": "falsyPrimitiveStrings$string$4", "symbols": [{ "literal": "n" }, { "literal": "u" }, { "literal": "l" }, { "literal": "l" }], "postprocess": function joiner(d) {
	        return d.join('');
	      } }, { "name": "falsyPrimitiveStrings", "symbols": ["falsyPrimitiveStrings$string$4"], "postprocess": parseFalsyPrimitive }, { "name": "falsyPrimitiveStrings$string$5", "symbols": [{ "literal": "u" }, { "literal": "n" }, { "literal": "d" }, { "literal": "e" }, { "literal": "f" }, { "literal": "i" }, { "literal": "n" }, { "literal": "e" }, { "literal": "d" }], "postprocess": function joiner(d) {
	        return d.join('');
	      } }, { "name": "falsyPrimitiveStrings", "symbols": ["falsyPrimitiveStrings$string$5"], "postprocess": parseFalsyPrimitive }, { "name": "numericValue", "symbols": ["int", { "literal": "." }, "int"], "postprocess": parseAsNumber }, { "name": "numericValue", "symbols": [{ "literal": "+" }, "int", { "literal": "." }, "int"], "postprocess": parseAsNumber }, { "name": "numericValue", "symbols": [{ "literal": "-" }, "int", { "literal": "." }, "int"], "postprocess": parseAsNumber }, { "name": "numericValue", "symbols": [{ "literal": "-" }, "int"], "postprocess": parseAsNumber }, { "name": "numericValue", "symbols": ["int"], "postprocess": parseAsNumber }, { "name": "numericValue", "symbols": [{ "literal": "+" }, "int"], "postprocess": parseAsNumber }, { "name": "numericValue$string$1", "symbols": [{ "literal": "I" }, { "literal": "n" }, { "literal": "f" }, { "literal": "i" }, { "literal": "n" }, { "literal": "i" }, { "literal": "t" }, { "literal": "y" }], "postprocess": function joiner(d) {
	        return d.join('');
	      } }, { "name": "numericValue", "symbols": ["numericValue$string$1"], "postprocess": parseAsNumber }, { "name": "numericValue$string$2", "symbols": [{ "literal": "+" }, { "literal": "I" }, { "literal": "n" }, { "literal": "f" }, { "literal": "i" }, { "literal": "n" }, { "literal": "i" }, { "literal": "t" }, { "literal": "y" }], "postprocess": function joiner(d) {
	        return d.join('');
	      } }, { "name": "numericValue", "symbols": ["numericValue$string$2"], "postprocess": parseAsNumber }, { "name": "numericValue$string$3", "symbols": [{ "literal": "-" }, { "literal": "I" }, { "literal": "n" }, { "literal": "f" }, { "literal": "i" }, { "literal": "n" }, { "literal": "i" }, { "literal": "t" }, { "literal": "y" }], "postprocess": function joiner(d) {
	        return d.join('');
	      } }, { "name": "numericValue", "symbols": ["numericValue$string$3"], "postprocess": parseAsNumber }, { "name": "int$ebnf$1", "symbols": [/[0-9]/] }, { "name": "int$ebnf$1", "symbols": ["int$ebnf$1", /[0-9]/], "postprocess": function arrpush(d) {
	        return d[0].concat([d[1]]);
	      } }, { "name": "int", "symbols": ["int$ebnf$1"] }, { "name": "classParameters", "symbols": [] }, { "name": "classParameters", "symbols": ["classParameter"] }, { "name": "classParameters", "symbols": ["classParameters", { "literal": "," }, "_", "classParameter"], "postprocess": appendItem(0, 3) }, { "name": "classParameter$ebnf$1", "symbols": [/[^()"', ]/] }, { "name": "classParameter$ebnf$1", "symbols": ["classParameter$ebnf$1", /[^()"', ]/], "postprocess": function arrpush(d) {
	        return d[0].concat([d[1]]);
	      } }, { "name": "classParameter", "symbols": ["classParameter$ebnf$1"], "postprocess": function postprocess(d) {
	        return d[0].join('');
	      } }, { "name": "classParameter", "symbols": ["sqstring"], "postprocess": id }, { "name": "classParameter", "symbols": ["dqstring"], "postprocess": id }, { "name": "pseudoElementSelector$string$1", "symbols": [{ "literal": ":" }, { "literal": ":" }], "postprocess": function joiner(d) {
	        return d.join('');
	      } }, { "name": "pseudoElementSelector", "symbols": ["pseudoElementSelector$string$1", "pseudoClassSelectorName"], "postprocess": function postprocess(d) {
	        return { type: 'pseudoElementSelector', name: d[1] };
	      } }, { "name": "pseudoClassSelector", "symbols": [{ "literal": ":" }, "pseudoClassSelectorName"], "postprocess": function postprocess(d) {
	        return { type: 'pseudoClassSelector', name: d[1] };
	      } }, { "name": "pseudoClassSelector", "symbols": [{ "literal": ":" }, "pseudoClassSelectorName", { "literal": "(" }, "classParameters", { "literal": ")" }], "postprocess": function postprocess(d) {
	        return { type: 'pseudoClassSelector', name: d[1], parameters: d[3] };
	      } }, { "name": "pseudoClassSelectorName$ebnf$1", "symbols": [/[a-zA-Z0-9-_]/] }, { "name": "pseudoClassSelectorName$ebnf$1", "symbols": ["pseudoClassSelectorName$ebnf$1", /[a-zA-Z0-9-_]/], "postprocess": function arrpush(d) {
	        return d[0].concat([d[1]]);
	      } }, { "name": "pseudoClassSelectorName", "symbols": [/[a-zA-Z]/, "pseudoClassSelectorName$ebnf$1"], "postprocess": function postprocess(d) {
	        return d[0] + d[1].join('');
	      } }, { "name": "dqstring$ebnf$1", "symbols": [] }, { "name": "dqstring$ebnf$1", "symbols": ["dqstring$ebnf$1", "dstrchar"], "postprocess": function arrpush(d) {
	        return d[0].concat([d[1]]);
	      } }, { "name": "dqstring", "symbols": [{ "literal": "\"" }, "dqstring$ebnf$1", { "literal": "\"" }], "postprocess": function postprocess(d) {
	        return d[1].join('');
	      } }, { "name": "dstrchar", "symbols": [/[^"]/], "postprocess": id }, { "name": "dstrchar$string$1", "symbols": [{ "literal": "\\" }, { "literal": "\"" }], "postprocess": function joiner(d) {
	        return d.join('');
	      } }, { "name": "dstrchar", "symbols": ["dstrchar$string$1"], "postprocess": function postprocess(d) {
	        return '"';
	      } }, { "name": "sqstring$ebnf$1", "symbols": [] }, { "name": "sqstring$ebnf$1", "symbols": ["sqstring$ebnf$1", "sstrchar"], "postprocess": function arrpush(d) {
	        return d[0].concat([d[1]]);
	      } }, { "name": "sqstring", "symbols": [{ "literal": "'" }, "sqstring$ebnf$1", { "literal": "'" }], "postprocess": function postprocess(d) {
	        return d[1].join('');
	      } }, { "name": "sstrchar", "symbols": [/[^']/], "postprocess": id }, { "name": "sstrchar$string$1", "symbols": [{ "literal": "\\" }, { "literal": "'" }], "postprocess": function joiner(d) {
	        return d.join('');
	      } }, { "name": "sstrchar", "symbols": ["sstrchar$string$1"], "postprocess": function postprocess(d) {
	        return '\'';
	      } }, { "name": "_$ebnf$1", "symbols": [] }, { "name": "_$ebnf$1", "symbols": ["_$ebnf$1", /[ ]/], "postprocess": function arrpush(d) {
	        return d[0].concat([d[1]]);
	      } }, { "name": "_", "symbols": ["_$ebnf$1"], "postprocess": function postprocess(d) {
	        return null;
	      } }],
	    ParserStart: "combinator"
	  };
	  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
	    module.exports = grammar;
	  } else {
	    window.grammar = grammar;
	  }
	})();
	//# sourceMappingURL=grammar.js.map

/***/ }),
/* 4469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createParser = exports.createGenerator = undefined;
	
	var _createGenerator = __webpack_require__(4466);
	
	var _createGenerator2 = _interopRequireDefault(_createGenerator);
	
	var _createParser = __webpack_require__(4467);
	
	var _createParser2 = _interopRequireDefault(_createParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// @flow
	
	exports.createGenerator = _createGenerator2.default;
	exports.createParser = _createParser2.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 4470 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(11);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var InnerSubscriber = (function (_super) {
	    __extends(InnerSubscriber, _super);
	    function InnerSubscriber(parent, outerValue, outerIndex) {
	        _super.call(this);
	        this.parent = parent;
	        this.outerValue = outerValue;
	        this.outerIndex = outerIndex;
	        this.index = 0;
	    }
	    InnerSubscriber.prototype._next = function (value) {
	        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
	    };
	    InnerSubscriber.prototype._error = function (error) {
	        this.parent.notifyError(error, this);
	        this.unsubscribe();
	    };
	    InnerSubscriber.prototype._complete = function () {
	        this.parent.notifyComplete(this);
	        this.unsubscribe();
	    };
	    return InnerSubscriber;
	}(Subscriber_1.Subscriber));
	exports.InnerSubscriber = InnerSubscriber;
	//# sourceMappingURL=InnerSubscriber.js.map

/***/ }),
/* 4471 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * An execution context and a data structure to order tasks and schedule their
	 * execution. Provides a notion of (potentially virtual) time, through the
	 * `now()` getter method.
	 *
	 * Each unit of work in a Scheduler is called an {@link Action}.
	 *
	 * ```ts
	 * class Scheduler {
	 *   now(): number;
	 *   schedule(work, delay?, state?): Subscription;
	 * }
	 * ```
	 *
	 * @class Scheduler
	 */
	var Scheduler = (function () {
	    function Scheduler(SchedulerAction, now) {
	        if (now === void 0) { now = Scheduler.now; }
	        this.SchedulerAction = SchedulerAction;
	        this.now = now;
	    }
	    /**
	     * Schedules a function, `work`, for execution. May happen at some point in
	     * the future, according to the `delay` parameter, if specified. May be passed
	     * some context object, `state`, which will be passed to the `work` function.
	     *
	     * The given arguments will be processed an stored as an Action object in a
	     * queue of actions.
	     *
	     * @param {function(state: ?T): ?Subscription} work A function representing a
	     * task, or some unit of work to be executed by the Scheduler.
	     * @param {number} [delay] Time to wait before executing the work, where the
	     * time unit is implicit and defined by the Scheduler itself.
	     * @param {T} [state] Some contextual data that the `work` function uses when
	     * called by the Scheduler.
	     * @return {Subscription} A subscription in order to be able to unsubscribe
	     * the scheduled work.
	     */
	    Scheduler.prototype.schedule = function (work, delay, state) {
	        if (delay === void 0) { delay = 0; }
	        return new this.SchedulerAction(this, work).schedule(state, delay);
	    };
	    Scheduler.now = Date.now ? Date.now : function () { return +new Date(); };
	    return Scheduler;
	}());
	exports.Scheduler = Scheduler;
	//# sourceMappingURL=Scheduler.js.map

/***/ }),
/* 4472 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var bindCallback_1 = __webpack_require__(4619);
	Observable_1.Observable.bindCallback = bindCallback_1.bindCallback;
	//# sourceMappingURL=bindCallback.js.map

/***/ }),
/* 4473 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var bindNodeCallback_1 = __webpack_require__(4620);
	Observable_1.Observable.bindNodeCallback = bindNodeCallback_1.bindNodeCallback;
	//# sourceMappingURL=bindNodeCallback.js.map

/***/ }),
/* 4474 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var combineLatest_1 = __webpack_require__(765);
	Observable_1.Observable.combineLatest = combineLatest_1.combineLatest;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 4475 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var concat_1 = __webpack_require__(265);
	Observable_1.Observable.concat = concat_1.concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 4476 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var defer_1 = __webpack_require__(4621);
	Observable_1.Observable.defer = defer_1.defer;
	//# sourceMappingURL=defer.js.map

/***/ }),
/* 4477 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var ajax_1 = __webpack_require__(4623);
	Observable_1.Observable.ajax = ajax_1.ajax;
	//# sourceMappingURL=ajax.js.map

/***/ }),
/* 4478 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var webSocket_1 = __webpack_require__(4624);
	Observable_1.Observable.webSocket = webSocket_1.webSocket;
	//# sourceMappingURL=webSocket.js.map

/***/ }),
/* 4479 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var empty_1 = __webpack_require__(507);
	Observable_1.Observable.empty = empty_1.empty;
	//# sourceMappingURL=empty.js.map

/***/ }),
/* 4480 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var forkJoin_1 = __webpack_require__(4625);
	Observable_1.Observable.forkJoin = forkJoin_1.forkJoin;
	//# sourceMappingURL=forkJoin.js.map

/***/ }),
/* 4481 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var from_1 = __webpack_require__(346);
	Observable_1.Observable.from = from_1.from;
	//# sourceMappingURL=from.js.map

/***/ }),
/* 4482 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var fromEvent_1 = __webpack_require__(4626);
	Observable_1.Observable.fromEvent = fromEvent_1.fromEvent;
	//# sourceMappingURL=fromEvent.js.map

/***/ }),
/* 4483 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var fromEventPattern_1 = __webpack_require__(4627);
	Observable_1.Observable.fromEventPattern = fromEventPattern_1.fromEventPattern;
	//# sourceMappingURL=fromEventPattern.js.map

/***/ }),
/* 4484 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var fromPromise_1 = __webpack_require__(4628);
	Observable_1.Observable.fromPromise = fromPromise_1.fromPromise;
	//# sourceMappingURL=fromPromise.js.map

/***/ }),
/* 4485 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var generate_1 = __webpack_require__(4629);
	Observable_1.Observable.generate = generate_1.generate;
	//# sourceMappingURL=generate.js.map

/***/ }),
/* 4486 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var if_1 = __webpack_require__(4630);
	Observable_1.Observable.if = if_1._if;
	//# sourceMappingURL=if.js.map

/***/ }),
/* 4487 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var interval_1 = __webpack_require__(4631);
	Observable_1.Observable.interval = interval_1.interval;
	//# sourceMappingURL=interval.js.map

/***/ }),
/* 4488 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var merge_1 = __webpack_require__(162);
	Observable_1.Observable.merge = merge_1.merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 4489 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var never_1 = __webpack_require__(4632);
	Observable_1.Observable.never = never_1.never;
	//# sourceMappingURL=never.js.map

/***/ }),
/* 4490 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var of_1 = __webpack_require__(89);
	Observable_1.Observable.of = of_1.of;
	//# sourceMappingURL=of.js.map

/***/ }),
/* 4491 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var onErrorResumeNext_1 = __webpack_require__(4633);
	Observable_1.Observable.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 4492 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var pairs_1 = __webpack_require__(4634);
	Observable_1.Observable.pairs = pairs_1.pairs;
	//# sourceMappingURL=pairs.js.map

/***/ }),
/* 4493 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var race_1 = __webpack_require__(508);
	Observable_1.Observable.race = race_1.race;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 4494 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var range_1 = __webpack_require__(4635);
	Observable_1.Observable.range = range_1.range;
	//# sourceMappingURL=range.js.map

/***/ }),
/* 4495 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var throw_1 = __webpack_require__(4636);
	Observable_1.Observable.throw = throw_1._throw;
	//# sourceMappingURL=throw.js.map

/***/ }),
/* 4496 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var timer_1 = __webpack_require__(767);
	Observable_1.Observable.timer = timer_1.timer;
	//# sourceMappingURL=timer.js.map

/***/ }),
/* 4497 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var using_1 = __webpack_require__(4637);
	Observable_1.Observable.using = using_1.using;
	//# sourceMappingURL=using.js.map

/***/ }),
/* 4498 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var zip_1 = __webpack_require__(4638);
	Observable_1.Observable.zip = zip_1.zip;
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 4499 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var audit_1 = __webpack_require__(4639);
	Observable_1.Observable.prototype.audit = audit_1.audit;
	//# sourceMappingURL=audit.js.map

/***/ }),
/* 4500 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var auditTime_1 = __webpack_require__(4640);
	Observable_1.Observable.prototype.auditTime = auditTime_1.auditTime;
	//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 4501 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var buffer_1 = __webpack_require__(4641);
	Observable_1.Observable.prototype.buffer = buffer_1.buffer;
	//# sourceMappingURL=buffer.js.map

/***/ }),
/* 4502 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var bufferCount_1 = __webpack_require__(4642);
	Observable_1.Observable.prototype.bufferCount = bufferCount_1.bufferCount;
	//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 4503 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var bufferTime_1 = __webpack_require__(4643);
	Observable_1.Observable.prototype.bufferTime = bufferTime_1.bufferTime;
	//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 4504 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var bufferToggle_1 = __webpack_require__(4644);
	Observable_1.Observable.prototype.bufferToggle = bufferToggle_1.bufferToggle;
	//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 4505 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var bufferWhen_1 = __webpack_require__(4645);
	Observable_1.Observable.prototype.bufferWhen = bufferWhen_1.bufferWhen;
	//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 4506 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var catch_1 = __webpack_require__(4646);
	Observable_1.Observable.prototype.catch = catch_1._catch;
	Observable_1.Observable.prototype._catch = catch_1._catch;
	//# sourceMappingURL=catch.js.map

/***/ }),
/* 4507 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var combineAll_1 = __webpack_require__(4647);
	Observable_1.Observable.prototype.combineAll = combineAll_1.combineAll;
	//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 4508 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var combineLatest_1 = __webpack_require__(4648);
	Observable_1.Observable.prototype.combineLatest = combineLatest_1.combineLatest;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 4509 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var concat_1 = __webpack_require__(4649);
	Observable_1.Observable.prototype.concat = concat_1.concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 4510 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var concatAll_1 = __webpack_require__(4650);
	Observable_1.Observable.prototype.concatAll = concatAll_1.concatAll;
	//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 4511 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var concatMap_1 = __webpack_require__(4651);
	Observable_1.Observable.prototype.concatMap = concatMap_1.concatMap;
	//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 4512 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var concatMapTo_1 = __webpack_require__(4652);
	Observable_1.Observable.prototype.concatMapTo = concatMapTo_1.concatMapTo;
	//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 4513 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var count_1 = __webpack_require__(4653);
	Observable_1.Observable.prototype.count = count_1.count;
	//# sourceMappingURL=count.js.map

/***/ }),
/* 4514 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var debounce_1 = __webpack_require__(4654);
	Observable_1.Observable.prototype.debounce = debounce_1.debounce;
	//# sourceMappingURL=debounce.js.map

/***/ }),
/* 4515 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var debounceTime_1 = __webpack_require__(4655);
	Observable_1.Observable.prototype.debounceTime = debounceTime_1.debounceTime;
	//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 4516 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var defaultIfEmpty_1 = __webpack_require__(4656);
	Observable_1.Observable.prototype.defaultIfEmpty = defaultIfEmpty_1.defaultIfEmpty;
	//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 4517 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var delay_1 = __webpack_require__(4657);
	Observable_1.Observable.prototype.delay = delay_1.delay;
	//# sourceMappingURL=delay.js.map

/***/ }),
/* 4518 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var delayWhen_1 = __webpack_require__(4658);
	Observable_1.Observable.prototype.delayWhen = delayWhen_1.delayWhen;
	//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 4519 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var dematerialize_1 = __webpack_require__(4659);
	Observable_1.Observable.prototype.dematerialize = dematerialize_1.dematerialize;
	//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 4520 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var distinct_1 = __webpack_require__(4660);
	Observable_1.Observable.prototype.distinct = distinct_1.distinct;
	//# sourceMappingURL=distinct.js.map

/***/ }),
/* 4521 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var distinctUntilChanged_1 = __webpack_require__(4661);
	Observable_1.Observable.prototype.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
	//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 4522 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var distinctUntilKeyChanged_1 = __webpack_require__(4662);
	Observable_1.Observable.prototype.distinctUntilKeyChanged = distinctUntilKeyChanged_1.distinctUntilKeyChanged;
	//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 4523 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var do_1 = __webpack_require__(4663);
	Observable_1.Observable.prototype.do = do_1._do;
	Observable_1.Observable.prototype._do = do_1._do;
	//# sourceMappingURL=do.js.map

/***/ }),
/* 4524 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var elementAt_1 = __webpack_require__(4664);
	Observable_1.Observable.prototype.elementAt = elementAt_1.elementAt;
	//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 4525 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var every_1 = __webpack_require__(4665);
	Observable_1.Observable.prototype.every = every_1.every;
	//# sourceMappingURL=every.js.map

/***/ }),
/* 4526 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var exhaust_1 = __webpack_require__(4666);
	Observable_1.Observable.prototype.exhaust = exhaust_1.exhaust;
	//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 4527 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var exhaustMap_1 = __webpack_require__(4667);
	Observable_1.Observable.prototype.exhaustMap = exhaustMap_1.exhaustMap;
	//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 4528 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var expand_1 = __webpack_require__(4668);
	Observable_1.Observable.prototype.expand = expand_1.expand;
	//# sourceMappingURL=expand.js.map

/***/ }),
/* 4529 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var filter_1 = __webpack_require__(768);
	Observable_1.Observable.prototype.filter = filter_1.filter;
	//# sourceMappingURL=filter.js.map

/***/ }),
/* 4530 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var finally_1 = __webpack_require__(4669);
	Observable_1.Observable.prototype.finally = finally_1._finally;
	Observable_1.Observable.prototype._finally = finally_1._finally;
	//# sourceMappingURL=finally.js.map

/***/ }),
/* 4531 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var find_1 = __webpack_require__(4670);
	Observable_1.Observable.prototype.find = find_1.find;
	//# sourceMappingURL=find.js.map

/***/ }),
/* 4532 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var findIndex_1 = __webpack_require__(4671);
	Observable_1.Observable.prototype.findIndex = findIndex_1.findIndex;
	//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 4533 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var first_1 = __webpack_require__(4672);
	Observable_1.Observable.prototype.first = first_1.first;
	//# sourceMappingURL=first.js.map

/***/ }),
/* 4534 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var groupBy_1 = __webpack_require__(4673);
	Observable_1.Observable.prototype.groupBy = groupBy_1.groupBy;
	//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 4535 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var ignoreElements_1 = __webpack_require__(4674);
	Observable_1.Observable.prototype.ignoreElements = ignoreElements_1.ignoreElements;
	//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 4536 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var isEmpty_1 = __webpack_require__(4675);
	Observable_1.Observable.prototype.isEmpty = isEmpty_1.isEmpty;
	//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 4537 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var last_1 = __webpack_require__(4676);
	Observable_1.Observable.prototype.last = last_1.last;
	//# sourceMappingURL=last.js.map

/***/ }),
/* 4538 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var let_1 = __webpack_require__(4677);
	Observable_1.Observable.prototype.let = let_1.letProto;
	Observable_1.Observable.prototype.letBind = let_1.letProto;
	//# sourceMappingURL=let.js.map

/***/ }),
/* 4539 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var map_1 = __webpack_require__(769);
	Observable_1.Observable.prototype.map = map_1.map;
	//# sourceMappingURL=map.js.map

/***/ }),
/* 4540 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var mapTo_1 = __webpack_require__(4678);
	Observable_1.Observable.prototype.mapTo = mapTo_1.mapTo;
	//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 4541 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var materialize_1 = __webpack_require__(4679);
	Observable_1.Observable.prototype.materialize = materialize_1.materialize;
	//# sourceMappingURL=materialize.js.map

/***/ }),
/* 4542 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var max_1 = __webpack_require__(4680);
	Observable_1.Observable.prototype.max = max_1.max;
	//# sourceMappingURL=max.js.map

/***/ }),
/* 4543 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var merge_1 = __webpack_require__(4681);
	Observable_1.Observable.prototype.merge = merge_1.merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 4544 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var mergeAll_1 = __webpack_require__(4682);
	Observable_1.Observable.prototype.mergeAll = mergeAll_1.mergeAll;
	//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 4545 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var mergeMap_1 = __webpack_require__(4683);
	Observable_1.Observable.prototype.mergeMap = mergeMap_1.mergeMap;
	Observable_1.Observable.prototype.flatMap = mergeMap_1.mergeMap;
	//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 4546 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var mergeMapTo_1 = __webpack_require__(4684);
	Observable_1.Observable.prototype.flatMapTo = mergeMapTo_1.mergeMapTo;
	Observable_1.Observable.prototype.mergeMapTo = mergeMapTo_1.mergeMapTo;
	//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 4547 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var mergeScan_1 = __webpack_require__(4685);
	Observable_1.Observable.prototype.mergeScan = mergeScan_1.mergeScan;
	//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 4548 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var min_1 = __webpack_require__(4686);
	Observable_1.Observable.prototype.min = min_1.min;
	//# sourceMappingURL=min.js.map

/***/ }),
/* 4549 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var multicast_1 = __webpack_require__(4687);
	Observable_1.Observable.prototype.multicast = multicast_1.multicast;
	//# sourceMappingURL=multicast.js.map

/***/ }),
/* 4550 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var observeOn_1 = __webpack_require__(4688);
	Observable_1.Observable.prototype.observeOn = observeOn_1.observeOn;
	//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 4551 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var onErrorResumeNext_1 = __webpack_require__(4689);
	Observable_1.Observable.prototype.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 4552 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var pairwise_1 = __webpack_require__(4690);
	Observable_1.Observable.prototype.pairwise = pairwise_1.pairwise;
	//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 4553 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var partition_1 = __webpack_require__(4691);
	Observable_1.Observable.prototype.partition = partition_1.partition;
	//# sourceMappingURL=partition.js.map

/***/ }),
/* 4554 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var pluck_1 = __webpack_require__(4692);
	Observable_1.Observable.prototype.pluck = pluck_1.pluck;
	//# sourceMappingURL=pluck.js.map

/***/ }),
/* 4555 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var publish_1 = __webpack_require__(4693);
	Observable_1.Observable.prototype.publish = publish_1.publish;
	//# sourceMappingURL=publish.js.map

/***/ }),
/* 4556 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var publishBehavior_1 = __webpack_require__(4694);
	Observable_1.Observable.prototype.publishBehavior = publishBehavior_1.publishBehavior;
	//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 4557 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var publishLast_1 = __webpack_require__(4695);
	Observable_1.Observable.prototype.publishLast = publishLast_1.publishLast;
	//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 4558 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var publishReplay_1 = __webpack_require__(4696);
	Observable_1.Observable.prototype.publishReplay = publishReplay_1.publishReplay;
	//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 4559 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var race_1 = __webpack_require__(4697);
	Observable_1.Observable.prototype.race = race_1.race;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 4560 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var reduce_1 = __webpack_require__(4698);
	Observable_1.Observable.prototype.reduce = reduce_1.reduce;
	//# sourceMappingURL=reduce.js.map

/***/ }),
/* 4561 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var repeat_1 = __webpack_require__(4699);
	Observable_1.Observable.prototype.repeat = repeat_1.repeat;
	//# sourceMappingURL=repeat.js.map

/***/ }),
/* 4562 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var repeatWhen_1 = __webpack_require__(4700);
	Observable_1.Observable.prototype.repeatWhen = repeatWhen_1.repeatWhen;
	//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 4563 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var retry_1 = __webpack_require__(4701);
	Observable_1.Observable.prototype.retry = retry_1.retry;
	//# sourceMappingURL=retry.js.map

/***/ }),
/* 4564 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var retryWhen_1 = __webpack_require__(4702);
	Observable_1.Observable.prototype.retryWhen = retryWhen_1.retryWhen;
	//# sourceMappingURL=retryWhen.js.map

/***/ }),
/* 4565 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var sample_1 = __webpack_require__(4703);
	Observable_1.Observable.prototype.sample = sample_1.sample;
	//# sourceMappingURL=sample.js.map

/***/ }),
/* 4566 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var sampleTime_1 = __webpack_require__(4704);
	Observable_1.Observable.prototype.sampleTime = sampleTime_1.sampleTime;
	//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 4567 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var scan_1 = __webpack_require__(4705);
	Observable_1.Observable.prototype.scan = scan_1.scan;
	//# sourceMappingURL=scan.js.map

/***/ }),
/* 4568 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var sequenceEqual_1 = __webpack_require__(4706);
	Observable_1.Observable.prototype.sequenceEqual = sequenceEqual_1.sequenceEqual;
	//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 4569 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var share_1 = __webpack_require__(4707);
	Observable_1.Observable.prototype.share = share_1.share;
	//# sourceMappingURL=share.js.map

/***/ }),
/* 4570 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var shareReplay_1 = __webpack_require__(4708);
	Observable_1.Observable.prototype.shareReplay = shareReplay_1.shareReplay;
	//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 4571 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var single_1 = __webpack_require__(4709);
	Observable_1.Observable.prototype.single = single_1.single;
	//# sourceMappingURL=single.js.map

/***/ }),
/* 4572 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var skip_1 = __webpack_require__(4710);
	Observable_1.Observable.prototype.skip = skip_1.skip;
	//# sourceMappingURL=skip.js.map

/***/ }),
/* 4573 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var skipLast_1 = __webpack_require__(4711);
	Observable_1.Observable.prototype.skipLast = skipLast_1.skipLast;
	//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 4574 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var skipUntil_1 = __webpack_require__(4712);
	Observable_1.Observable.prototype.skipUntil = skipUntil_1.skipUntil;
	//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 4575 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var skipWhile_1 = __webpack_require__(4713);
	Observable_1.Observable.prototype.skipWhile = skipWhile_1.skipWhile;
	//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 4576 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var startWith_1 = __webpack_require__(4714);
	Observable_1.Observable.prototype.startWith = startWith_1.startWith;
	//# sourceMappingURL=startWith.js.map

/***/ }),
/* 4577 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var subscribeOn_1 = __webpack_require__(4715);
	Observable_1.Observable.prototype.subscribeOn = subscribeOn_1.subscribeOn;
	//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 4578 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var switch_1 = __webpack_require__(4716);
	Observable_1.Observable.prototype.switch = switch_1._switch;
	Observable_1.Observable.prototype._switch = switch_1._switch;
	//# sourceMappingURL=switch.js.map

/***/ }),
/* 4579 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var switchMap_1 = __webpack_require__(770);
	Observable_1.Observable.prototype.switchMap = switchMap_1.switchMap;
	//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 4580 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var switchMapTo_1 = __webpack_require__(4717);
	Observable_1.Observable.prototype.switchMapTo = switchMapTo_1.switchMapTo;
	//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 4581 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var take_1 = __webpack_require__(4718);
	Observable_1.Observable.prototype.take = take_1.take;
	//# sourceMappingURL=take.js.map

/***/ }),
/* 4582 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var takeLast_1 = __webpack_require__(4719);
	Observable_1.Observable.prototype.takeLast = takeLast_1.takeLast;
	//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 4583 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var takeUntil_1 = __webpack_require__(4720);
	Observable_1.Observable.prototype.takeUntil = takeUntil_1.takeUntil;
	//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 4584 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var takeWhile_1 = __webpack_require__(4721);
	Observable_1.Observable.prototype.takeWhile = takeWhile_1.takeWhile;
	//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 4585 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var throttle_1 = __webpack_require__(4722);
	Observable_1.Observable.prototype.throttle = throttle_1.throttle;
	//# sourceMappingURL=throttle.js.map

/***/ }),
/* 4586 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var throttleTime_1 = __webpack_require__(4723);
	Observable_1.Observable.prototype.throttleTime = throttleTime_1.throttleTime;
	//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 4587 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var timeInterval_1 = __webpack_require__(771);
	Observable_1.Observable.prototype.timeInterval = timeInterval_1.timeInterval;
	//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 4588 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var timeout_1 = __webpack_require__(4724);
	Observable_1.Observable.prototype.timeout = timeout_1.timeout;
	//# sourceMappingURL=timeout.js.map

/***/ }),
/* 4589 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var timeoutWith_1 = __webpack_require__(4725);
	Observable_1.Observable.prototype.timeoutWith = timeoutWith_1.timeoutWith;
	//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 4590 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var timestamp_1 = __webpack_require__(4726);
	Observable_1.Observable.prototype.timestamp = timestamp_1.timestamp;
	//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 4591 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var toArray_1 = __webpack_require__(4727);
	Observable_1.Observable.prototype.toArray = toArray_1.toArray;
	//# sourceMappingURL=toArray.js.map

/***/ }),
/* 4592 */
/***/ (function(module, exports) {

	// HACK: does nothing, because `toPromise` now lives on the `Observable` itself.
	// leaving this module here to prevent breakage.
	//# sourceMappingURL=toPromise.js.map

/***/ }),
/* 4593 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var window_1 = __webpack_require__(4728);
	Observable_1.Observable.prototype.window = window_1.window;
	//# sourceMappingURL=window.js.map

/***/ }),
/* 4594 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var windowCount_1 = __webpack_require__(4729);
	Observable_1.Observable.prototype.windowCount = windowCount_1.windowCount;
	//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 4595 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var windowTime_1 = __webpack_require__(4730);
	Observable_1.Observable.prototype.windowTime = windowTime_1.windowTime;
	//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 4596 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var windowToggle_1 = __webpack_require__(4731);
	Observable_1.Observable.prototype.windowToggle = windowToggle_1.windowToggle;
	//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 4597 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var windowWhen_1 = __webpack_require__(4732);
	Observable_1.Observable.prototype.windowWhen = windowWhen_1.windowWhen;
	//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 4598 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var withLatestFrom_1 = __webpack_require__(4733);
	Observable_1.Observable.prototype.withLatestFrom = withLatestFrom_1.withLatestFrom;
	//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 4599 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var zip_1 = __webpack_require__(4734);
	Observable_1.Observable.prototype.zip = zip_1.zipProto;
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 4600 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(4);
	var zipAll_1 = __webpack_require__(4735);
	Observable_1.Observable.prototype.zipAll = zipAll_1.zipAll;
	//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 4601 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	var ScalarObservable_1 = __webpack_require__(506);
	var EmptyObservable_1 = __webpack_require__(119);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ArrayLikeObservable = (function (_super) {
	    __extends(ArrayLikeObservable, _super);
	    function ArrayLikeObservable(arrayLike, scheduler) {
	        _super.call(this);
	        this.arrayLike = arrayLike;
	        this.scheduler = scheduler;
	        if (!scheduler && arrayLike.length === 1) {
	            this._isScalar = true;
	            this.value = arrayLike[0];
	        }
	    }
	    ArrayLikeObservable.create = function (arrayLike, scheduler) {
	        var length = arrayLike.length;
	        if (length === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        else if (length === 1) {
	            return new ScalarObservable_1.ScalarObservable(arrayLike[0], scheduler);
	        }
	        else {
	            return new ArrayLikeObservable(arrayLike, scheduler);
	        }
	    };
	    ArrayLikeObservable.dispatch = function (state) {
	        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
	        if (subscriber.closed) {
	            return;
	        }
	        if (index >= length) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(arrayLike[index]);
	        state.index = index + 1;
	        this.schedule(state);
	    };
	    ArrayLikeObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
	        var length = arrayLike.length;
	        if (scheduler) {
	            return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
	                arrayLike: arrayLike, index: index, length: length, subscriber: subscriber
	            });
	        }
	        else {
	            for (var i = 0; i < length && !subscriber.closed; i++) {
	                subscriber.next(arrayLike[i]);
	            }
	            subscriber.complete();
	        }
	    };
	    return ArrayLikeObservable;
	}(Observable_1.Observable));
	exports.ArrayLikeObservable = ArrayLikeObservable;
	//# sourceMappingURL=ArrayLikeObservable.js.map

/***/ }),
/* 4602 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	var tryCatch_1 = __webpack_require__(34);
	var errorObject_1 = __webpack_require__(32);
	var AsyncSubject_1 = __webpack_require__(344);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var BoundCallbackObservable = (function (_super) {
	    __extends(BoundCallbackObservable, _super);
	    function BoundCallbackObservable(callbackFunc, selector, args, context, scheduler) {
	        _super.call(this);
	        this.callbackFunc = callbackFunc;
	        this.selector = selector;
	        this.args = args;
	        this.context = context;
	        this.scheduler = scheduler;
	    }
	    /* tslint:enable:max-line-length */
	    /**
	     * Converts a callback API to a function that returns an Observable.
	     *
	     * <span class="informal">Give it a function `f` of type `f(x, callback)` and
	     * it will return a function `g` that when called as `g(x)` will output an
	     * Observable.</span>
	     *
	     * `bindCallback` is not an operator because its input and output are not
	     * Observables. The input is a function `func` with some parameters, the
	     * last parameter must be a callback function that `func` calls when it is
	     * done.
	     *
	     * The output of `bindCallback` is a function that takes the same parameters
	     * as `func`, except the last one (the callback). When the output function
	     * is called with arguments it will return an Observable. If function `func`
	     * calls its callback with one argument the Observable will emit that value.
	     * If on the other hand the callback is called with multiple values the resulting
	     * Observable will emit an array with said values as arguments.
	     *
	     * It is very important to remember that input function `func` is not called
	     * when the output function is, but rather when the Observable returned by the output
	     * function is subscribed. This means if `func` makes an AJAX request, that request
	     * will be made every time someone subscribes to the resulting Observable, but not before.
	     *
	     * Optionally, a selector function can be passed to `bindObservable`. The selector function
	     * takes the same arguments as the callback and returns the value that will be emitted by the Observable.
	     * Even though by default multiple arguments passed to callback appear in the stream as an array
	     * the selector function will be called with arguments directly, just as the callback would.
	     * This means you can imagine the default selector (when one is not provided explicitly)
	     * as a function that aggregates all its arguments into an array, or simply returns first argument
	     * if there is only one.
	     *
	     * The last optional parameter - {@link Scheduler} - can be used to control when the call
	     * to `func` happens after someone subscribes to Observable, as well as when results
	     * passed to callback will be emitted. By default, the subscription to  an Observable calls `func`
	     * synchronously, but using `Scheduler.async` as the last parameter will defer the call to `func`,
	     * just like wrapping the call in `setTimeout` with a timeout of `0` would. If you use the async Scheduler
	     * and call `subscribe` on the output Observable all function calls that are currently executing
	     * will end before `func` is invoked.
	     *
	     * By default results passed to the callback are emitted immediately after `func` invokes the callback.
	     * In particular, if the callback is called synchronously the subscription of the resulting Observable
	     * will call the `next` function synchronously as well.  If you want to defer that call,
	     * you may use `Scheduler.async` just as before.  This means that by using `Scheduler.async` you can
	     * ensure that `func` always calls its callback asynchronously, thus avoiding terrifying Zalgo.
	     *
	     * Note that the Observable created by the output function will always emit a single value
	     * and then complete immediately. If `func` calls the callback multiple times, values from subsequent
	     * calls will not appear in the stream. If you need to listen for multiple calls,
	     *  you probably want to use {@link fromEvent} or {@link fromEventPattern} instead.
	     *
	     * If `func` depends on some context (`this` property) and is not already bound the context of `func`
	     * will be the context that the output function has at call time. In particular, if `func`
	     * is called as a method of some objec and if `func` is not already bound, in order to preserve the context
	     * it is recommended that the context of the output function is set to that object as well.
	     *
	     * If the input function calls its callback in the "node style" (i.e. first argument to callback is
	     * optional error parameter signaling whether the call failed or not), {@link bindNodeCallback}
	     * provides convenient error handling and probably is a better choice.
	     * `bindCallback` will treat such functions the same as any other and error parameters
	     * (whether passed or not) will always be interpreted as regular callback argument.
	     *
	     *
	     * @example <caption>Convert jQuery's getJSON to an Observable API</caption>
	     * // Suppose we have jQuery.getJSON('/my/url', callback)
	     * var getJSONAsObservable = Rx.Observable.bindCallback(jQuery.getJSON);
	     * var result = getJSONAsObservable('/my/url');
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     *
	     * @example <caption>Receive an array of arguments passed to a callback</caption>
	     * someFunction((a, b, c) => {
	     *   console.log(a); // 5
	     *   console.log(b); // 'some string'
	     *   console.log(c); // {someProperty: 'someValue'}
	     * });
	     *
	     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction);
	     * boundSomeFunction().subscribe(values => {
	     *   console.log(values) // [5, 'some string', {someProperty: 'someValue'}]
	     * });
	     *
	     *
	     * @example <caption>Use bindCallback with a selector function</caption>
	     * someFunction((a, b, c) => {
	     *   console.log(a); // 'a'
	     *   console.log(b); // 'b'
	     *   console.log(c); // 'c'
	     * });
	     *
	     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction, (a, b, c) => a + b + c);
	     * boundSomeFunction().subscribe(value => {
	     *   console.log(value) // 'abc'
	     * });
	     *
	     *
	     * @example <caption>Compare behaviour with and without async Scheduler</caption>
	     * function iCallMyCallbackSynchronously(cb) {
	     *   cb();
	     * }
	     *
	     * const boundSyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously);
	     * const boundAsyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously, null, Rx.Scheduler.async);
	     *
	     * boundSyncFn().subscribe(() => console.log('I was sync!'));
	     * boundAsyncFn().subscribe(() => console.log('I was async!'));
	     * console.log('This happened...');
	     *
	     * // Logs:
	     * // I was sync!
	     * // This happened...
	     * // I was async!
	     *
	     *
	     * @example <caption>Use bindCallback on an object method</caption>
	     * const boundMethod = Rx.Observable.bindCallback(someObject.methodWithCallback);
	     * boundMethod.call(someObject) // make sure methodWithCallback has access to someObject
	     * .subscribe(subscriber);
	     *
	     *
	     * @see {@link bindNodeCallback}
	     * @see {@link from}
	     * @see {@link fromPromise}
	     *
	     * @param {function} func A function with a callback as the last parameter.
	     * @param {function} [selector] A function which takes the arguments from the
	     * callback and maps them to a value that is emitted on the output Observable.
	     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
	     * callbacks.
	     * @return {function(...params: *): Observable} A function which returns the
	     * Observable that delivers the same values the callback would deliver.
	     * @static true
	     * @name bindCallback
	     * @owner Observable
	     */
	    BoundCallbackObservable.create = function (func, selector, scheduler) {
	        if (selector === void 0) { selector = undefined; }
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            return new BoundCallbackObservable(func, selector, args, this, scheduler);
	        };
	    };
	    BoundCallbackObservable.prototype._subscribe = function (subscriber) {
	        var callbackFunc = this.callbackFunc;
	        var args = this.args;
	        var scheduler = this.scheduler;
	        var subject = this.subject;
	        if (!scheduler) {
	            if (!subject) {
	                subject = this.subject = new AsyncSubject_1.AsyncSubject();
	                var handler = function handlerFn() {
	                    var innerArgs = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        innerArgs[_i - 0] = arguments[_i];
	                    }
	                    var source = handlerFn.source;
	                    var selector = source.selector, subject = source.subject;
	                    if (selector) {
	                        var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
	                        if (result_1 === errorObject_1.errorObject) {
	                            subject.error(errorObject_1.errorObject.e);
	                        }
	                        else {
	                            subject.next(result_1);
	                            subject.complete();
	                        }
	                    }
	                    else {
	                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
	                        subject.complete();
	                    }
	                };
	                // use named function instance to avoid closure.
	                handler.source = this;
	                var result = tryCatch_1.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
	                if (result === errorObject_1.errorObject) {
	                    subject.error(errorObject_1.errorObject.e);
	                }
	            }
	            return subject.subscribe(subscriber);
	        }
	        else {
	            return scheduler.schedule(BoundCallbackObservable.dispatch, 0, { source: this, subscriber: subscriber, context: this.context });
	        }
	    };
	    BoundCallbackObservable.dispatch = function (state) {
	        var self = this;
	        var source = state.source, subscriber = state.subscriber, context = state.context;
	        var callbackFunc = source.callbackFunc, args = source.args, scheduler = source.scheduler;
	        var subject = source.subject;
	        if (!subject) {
	            subject = source.subject = new AsyncSubject_1.AsyncSubject();
	            var handler = function handlerFn() {
	                var innerArgs = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    innerArgs[_i - 0] = arguments[_i];
	                }
	                var source = handlerFn.source;
	                var selector = source.selector, subject = source.subject;
	                if (selector) {
	                    var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
	                    if (result_2 === errorObject_1.errorObject) {
	                        self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
	                    }
	                    else {
	                        self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
	                    }
	                }
	                else {
	                    var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
	                    self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
	                }
	            };
	            // use named function to pass values in without closure
	            handler.source = source;
	            var result = tryCatch_1.tryCatch(callbackFunc).apply(context, args.concat(handler));
	            if (result === errorObject_1.errorObject) {
	                subject.error(errorObject_1.errorObject.e);
	            }
	        }
	        self.add(subject.subscribe(subscriber));
	    };
	    return BoundCallbackObservable;
	}(Observable_1.Observable));
	exports.BoundCallbackObservable = BoundCallbackObservable;
	function dispatchNext(arg) {
	    var value = arg.value, subject = arg.subject;
	    subject.next(value);
	    subject.complete();
	}
	function dispatchError(arg) {
	    var err = arg.err, subject = arg.subject;
	    subject.error(err);
	}
	//# sourceMappingURL=BoundCallbackObservable.js.map

/***/ }),
/* 4603 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	var tryCatch_1 = __webpack_require__(34);
	var errorObject_1 = __webpack_require__(32);
	var AsyncSubject_1 = __webpack_require__(344);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var BoundNodeCallbackObservable = (function (_super) {
	    __extends(BoundNodeCallbackObservable, _super);
	    function BoundNodeCallbackObservable(callbackFunc, selector, args, context, scheduler) {
	        _super.call(this);
	        this.callbackFunc = callbackFunc;
	        this.selector = selector;
	        this.args = args;
	        this.context = context;
	        this.scheduler = scheduler;
	    }
	    /* tslint:enable:max-line-length */
	    /**
	     * Converts a Node.js-style callback API to a function that returns an
	     * Observable.
	     *
	     * <span class="informal">It's just like {@link bindCallback}, but the
	     * callback is expected to be of type `callback(error, result)`.</span>
	     *
	     * `bindNodeCallback` is not an operator because its input and output are not
	     * Observables. The input is a function `func` with some parameters, but the
	     * last parameter must be a callback function that `func` calls when it is
	     * done. The callback function is expected to follow Node.js conventions,
	     * where the first argument to the callback is an error object, signaling
	     * whether call was successful. If that object is passed to callback, it means
	     * something went wrong.
	     *
	     * The output of `bindNodeCallback` is a function that takes the same
	     * parameters as `func`, except the last one (the callback). When the output
	     * function is called with arguments, it will return an Observable.
	     * If `func` calls its callback with error parameter present, Observable will
	     * error with that value as well. If error parameter is not passed, Observable will emit
	     * second parameter. If there are more parameters (third and so on),
	     * Observable will emit an array with all arguments, except first error argument.
	     *
	     * Optionally `bindNodeCallback` accepts selector function, which allows you to
	     * make resulting Observable emit value computed by selector, instead of regular
	     * callback arguments. It works similarly to {@link bindCallback} selector, but
	     * Node.js-style error argument will never be passed to that function.
	     *
	     * Note that `func` will not be called at the same time output function is,
	     * but rather whenever resulting Observable is subscribed. By default call to
	     * `func` will happen synchronously after subscription, but that can be changed
	     * with proper {@link Scheduler} provided as optional third parameter. Scheduler
	     * can also control when values from callback will be emitted by Observable.
	     * To find out more, check out documentation for {@link bindCallback}, where
	     * Scheduler works exactly the same.
	     *
	     * As in {@link bindCallback}, context (`this` property) of input function will be set to context
	     * of returned function, when it is called.
	     *
	     * After Observable emits value, it will complete immediately. This means
	     * even if `func` calls callback again, values from second and consecutive
	     * calls will never appear on the stream. If you need to handle functions
	     * that call callbacks multiple times, check out {@link fromEvent} or
	     * {@link fromEventPattern} instead.
	     *
	     * Note that `bindNodeCallback` can be used in non-Node.js environments as well.
	     * "Node.js-style" callbacks are just a convention, so if you write for
	     * browsers or any other environment and API you use implements that callback style,
	     * `bindNodeCallback` can be safely used on that API functions as well.
	     *
	     * Remember that Error object passed to callback does not have to be an instance
	     * of JavaScript built-in `Error` object. In fact, it does not even have to an object.
	     * Error parameter of callback function is interpreted as "present", when value
	     * of that parameter is truthy. It could be, for example, non-zero number, non-empty
	     * string or boolean `true`. In all of these cases resulting Observable would error
	     * with that value. This means usually regular style callbacks will fail very often when
	     * `bindNodeCallback` is used. If your Observable errors much more often then you
	     * would expect, check if callback really is called in Node.js-style and, if not,
	     * switch to {@link bindCallback} instead.
	     *
	     * Note that even if error parameter is technically present in callback, but its value
	     * is falsy, it still won't appear in array emitted by Observable or in selector function.
	     *
	     *
	     * @example <caption>Read a file from the filesystem and get the data as an Observable</caption>
	     * import * as fs from 'fs';
	     * var readFileAsObservable = Rx.Observable.bindNodeCallback(fs.readFile);
	     * var result = readFileAsObservable('./roadNames.txt', 'utf8');
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     *
	     * @example <caption>Use on function calling callback with multiple arguments</caption>
	     * someFunction((err, a, b) => {
	     *   console.log(err); // null
	     *   console.log(a); // 5
	     *   console.log(b); // "some string"
	     * });
	     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
	     * boundSomeFunction()
	     * .subscribe(value => {
	     *   console.log(value); // [5, "some string"]
	     * });
	     *
	     *
	     * @example <caption>Use with selector function</caption>
	     * someFunction((err, a, b) => {
	     *   console.log(err); // undefined
	     *   console.log(a); // "abc"
	     *   console.log(b); // "DEF"
	     * });
	     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction, (a, b) => a + b);
	     * boundSomeFunction()
	     * .subscribe(value => {
	     *   console.log(value); // "abcDEF"
	     * });
	     *
	     *
	     * @example <caption>Use on function calling callback in regular style</caption>
	     * someFunction(a => {
	     *   console.log(a); // 5
	     * });
	     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
	     * boundSomeFunction()
	     * .subscribe(
	     *   value => {}             // never gets called
	     *   err => console.log(err) // 5
	     *);
	     *
	     *
	     * @see {@link bindCallback}
	     * @see {@link from}
	     * @see {@link fromPromise}
	     *
	     * @param {function} func Function with a Node.js-style callback as the last parameter.
	     * @param {function} [selector] A function which takes the arguments from the
	     * callback and maps those to a value to emit on the output Observable.
	     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
	     * callbacks.
	     * @return {function(...params: *): Observable} A function which returns the
	     * Observable that delivers the same values the Node.js callback would
	     * deliver.
	     * @static true
	     * @name bindNodeCallback
	     * @owner Observable
	     */
	    BoundNodeCallbackObservable.create = function (func, selector, scheduler) {
	        if (selector === void 0) { selector = undefined; }
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            return new BoundNodeCallbackObservable(func, selector, args, this, scheduler);
	        };
	    };
	    BoundNodeCallbackObservable.prototype._subscribe = function (subscriber) {
	        var callbackFunc = this.callbackFunc;
	        var args = this.args;
	        var scheduler = this.scheduler;
	        var subject = this.subject;
	        if (!scheduler) {
	            if (!subject) {
	                subject = this.subject = new AsyncSubject_1.AsyncSubject();
	                var handler = function handlerFn() {
	                    var innerArgs = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        innerArgs[_i - 0] = arguments[_i];
	                    }
	                    var source = handlerFn.source;
	                    var selector = source.selector, subject = source.subject;
	                    var err = innerArgs.shift();
	                    if (err) {
	                        subject.error(err);
	                    }
	                    else if (selector) {
	                        var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
	                        if (result_1 === errorObject_1.errorObject) {
	                            subject.error(errorObject_1.errorObject.e);
	                        }
	                        else {
	                            subject.next(result_1);
	                            subject.complete();
	                        }
	                    }
	                    else {
	                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
	                        subject.complete();
	                    }
	                };
	                // use named function instance to avoid closure.
	                handler.source = this;
	                var result = tryCatch_1.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
	                if (result === errorObject_1.errorObject) {
	                    subject.error(errorObject_1.errorObject.e);
	                }
	            }
	            return subject.subscribe(subscriber);
	        }
	        else {
	            return scheduler.schedule(dispatch, 0, { source: this, subscriber: subscriber, context: this.context });
	        }
	    };
	    return BoundNodeCallbackObservable;
	}(Observable_1.Observable));
	exports.BoundNodeCallbackObservable = BoundNodeCallbackObservable;
	function dispatch(state) {
	    var self = this;
	    var source = state.source, subscriber = state.subscriber, context = state.context;
	    // XXX: cast to `any` to access to the private field in `source`.
	    var _a = source, callbackFunc = _a.callbackFunc, args = _a.args, scheduler = _a.scheduler;
	    var subject = source.subject;
	    if (!subject) {
	        subject = source.subject = new AsyncSubject_1.AsyncSubject();
	        var handler = function handlerFn() {
	            var innerArgs = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                innerArgs[_i - 0] = arguments[_i];
	            }
	            var source = handlerFn.source;
	            var selector = source.selector, subject = source.subject;
	            var err = innerArgs.shift();
	            if (err) {
	                self.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
	            }
	            else if (selector) {
	                var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
	                if (result_2 === errorObject_1.errorObject) {
	                    self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
	                }
	                else {
	                    self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
	                }
	            }
	            else {
	                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
	                self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
	            }
	        };
	        // use named function to pass values in without closure
	        handler.source = source;
	        var result = tryCatch_1.tryCatch(callbackFunc).apply(context, args.concat(handler));
	        if (result === errorObject_1.errorObject) {
	            self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
	        }
	    }
	    self.add(subject.subscribe(subscriber));
	}
	function dispatchNext(arg) {
	    var value = arg.value, subject = arg.subject;
	    subject.next(value);
	    subject.complete();
	}
	function dispatchError(arg) {
	    var err = arg.err, subject = arg.subject;
	    subject.error(err);
	}
	//# sourceMappingURL=BoundNodeCallbackObservable.js.map

/***/ }),
/* 4604 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	var subscribeToResult_1 = __webpack_require__(17);
	var OuterSubscriber_1 = __webpack_require__(16);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var DeferObservable = (function (_super) {
	    __extends(DeferObservable, _super);
	    function DeferObservable(observableFactory) {
	        _super.call(this);
	        this.observableFactory = observableFactory;
	    }
	    /**
	     * Creates an Observable that, on subscribe, calls an Observable factory to
	     * make an Observable for each new Observer.
	     *
	     * <span class="informal">Creates the Observable lazily, that is, only when it
	     * is subscribed.
	     * </span>
	     *
	     * <img src="./img/defer.png" width="100%">
	     *
	     * `defer` allows you to create the Observable only when the Observer
	     * subscribes, and create a fresh Observable for each Observer. It waits until
	     * an Observer subscribes to it, and then it generates an Observable,
	     * typically with an Observable factory function. It does this afresh for each
	     * subscriber, so although each subscriber may think it is subscribing to the
	     * same Observable, in fact each subscriber gets its own individual
	     * Observable.
	     *
	     * @example <caption>Subscribe to either an Observable of clicks or an Observable of interval, at random</caption>
	     * var clicksOrInterval = Rx.Observable.defer(function () {
	     *   if (Math.random() > 0.5) {
	     *     return Rx.Observable.fromEvent(document, 'click');
	     *   } else {
	     *     return Rx.Observable.interval(1000);
	     *   }
	     * });
	     * clicksOrInterval.subscribe(x => console.log(x));
	     *
	     * // Results in the following behavior:
	     * // If the result of Math.random() is greater than 0.5 it will listen
	     * // for clicks anywhere on the "document"; when document is clicked it
	     * // will log a MouseEvent object to the console. If the result is less
	     * // than 0.5 it will emit ascending numbers, one every second(1000ms).
	     *
	     * @see {@link create}
	     *
	     * @param {function(): SubscribableOrPromise} observableFactory The Observable
	     * factory function to invoke for each Observer that subscribes to the output
	     * Observable. May also return a Promise, which will be converted on the fly
	     * to an Observable.
	     * @return {Observable} An Observable whose Observers' subscriptions trigger
	     * an invocation of the given Observable factory function.
	     * @static true
	     * @name defer
	     * @owner Observable
	     */
	    DeferObservable.create = function (observableFactory) {
	        return new DeferObservable(observableFactory);
	    };
	    DeferObservable.prototype._subscribe = function (subscriber) {
	        return new DeferSubscriber(subscriber, this.observableFactory);
	    };
	    return DeferObservable;
	}(Observable_1.Observable));
	exports.DeferObservable = DeferObservable;
	var DeferSubscriber = (function (_super) {
	    __extends(DeferSubscriber, _super);
	    function DeferSubscriber(destination, factory) {
	        _super.call(this, destination);
	        this.factory = factory;
	        this.tryDefer();
	    }
	    DeferSubscriber.prototype.tryDefer = function () {
	        try {
	            this._callFactory();
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    DeferSubscriber.prototype._callFactory = function () {
	        var result = this.factory();
	        if (result) {
	            this.add(subscribeToResult_1.subscribeToResult(this, result));
	        }
	    };
	    return DeferSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=DeferObservable.js.map

/***/ }),
/* 4605 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ErrorObservable = (function (_super) {
	    __extends(ErrorObservable, _super);
	    function ErrorObservable(error, scheduler) {
	        _super.call(this);
	        this.error = error;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable that emits no items to the Observer and immediately
	     * emits an error notification.
	     *
	     * <span class="informal">Just emits 'error', and nothing else.
	     * </span>
	     *
	     * <img src="./img/throw.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that only
	     * emits the error notification. It can be used for composing with other
	     * Observables, such as in a {@link mergeMap}.
	     *
	     * @example <caption>Emit the number 7, then emit an error.</caption>
	     * var result = Rx.Observable.throw(new Error('oops!')).startWith(7);
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     * @example <caption>Map and flatten numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
	     * var interval = Rx.Observable.interval(1000);
	     * var result = interval.mergeMap(x =>
	     *   x === 13 ?
	     *     Rx.Observable.throw('Thirteens are bad') :
	     *     Rx.Observable.of('a', 'b', 'c')
	     * );
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     * @see {@link create}
	     * @see {@link empty}
	     * @see {@link never}
	     * @see {@link of}
	     *
	     * @param {any} error The particular Error to pass to the error notification.
	     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
	     * the emission of the error notification.
	     * @return {Observable} An error Observable: emits only the error notification
	     * using the given error argument.
	     * @static true
	     * @name throw
	     * @owner Observable
	     */
	    ErrorObservable.create = function (error, scheduler) {
	        return new ErrorObservable(error, scheduler);
	    };
	    ErrorObservable.dispatch = function (arg) {
	        var error = arg.error, subscriber = arg.subscriber;
	        subscriber.error(error);
	    };
	    ErrorObservable.prototype._subscribe = function (subscriber) {
	        var error = this.error;
	        var scheduler = this.scheduler;
	        subscriber.syncErrorThrowable = true;
	        if (scheduler) {
	            return scheduler.schedule(ErrorObservable.dispatch, 0, {
	                error: error, subscriber: subscriber
	            });
	        }
	        else {
	            subscriber.error(error);
	        }
	    };
	    return ErrorObservable;
	}(Observable_1.Observable));
	exports.ErrorObservable = ErrorObservable;
	//# sourceMappingURL=ErrorObservable.js.map

/***/ }),
/* 4606 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	var EmptyObservable_1 = __webpack_require__(119);
	var isArray_1 = __webpack_require__(81);
	var subscribeToResult_1 = __webpack_require__(17);
	var OuterSubscriber_1 = __webpack_require__(16);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ForkJoinObservable = (function (_super) {
	    __extends(ForkJoinObservable, _super);
	    function ForkJoinObservable(sources, resultSelector) {
	        _super.call(this);
	        this.sources = sources;
	        this.resultSelector = resultSelector;
	    }
	    /* tslint:enable:max-line-length */
	    /**
	     * Joins last values emitted by passed Observables.
	     *
	     * <span class="informal">Wait for Observables to complete and then combine last values they emitted.</span>
	     *
	     * <img src="./img/forkJoin.png" width="100%">
	     *
	     * `forkJoin` is an operator that takes any number of Observables which can be passed either as an array
	     * or directly as arguments. If no input Observables are provided, resulting stream will complete
	     * immediately.
	     *
	     * `forkJoin` will wait for all passed Observables to complete and then it will emit an array with last
	     * values from corresponding Observables. So if you pass `n` Observables to the operator, resulting
	     * array will have `n` values, where first value is the last thing emitted by the first Observable,
	     * second value is the last thing emitted by the second Observable and so on. That means `forkJoin` will
	     * not emit more than once and it will complete after that. If you need to emit combined values not only
	     * at the end of lifecycle of passed Observables, but also throughout it, try out {@link combineLatest}
	     * or {@link zip} instead.
	     *
	     * In order for resulting array to have the same length as the number of input Observables, whenever any of
	     * that Observables completes without emitting any value, `forkJoin` will complete at that moment as well
	     * and it will not emit anything either, even if it already has some last values from other Observables.
	     * Conversely, if there is an Observable that never completes, `forkJoin` will never complete as well,
	     * unless at any point some other Observable completes without emitting value, which brings us back to
	     * the previous case. Overall, in order for `forkJoin` to emit a value, all Observables passed as arguments
	     * have to emit something at least once and complete.
	     *
	     * If any input Observable errors at some point, `forkJoin` will error as well and all other Observables
	     * will be immediately unsubscribed.
	     *
	     * Optionally `forkJoin` accepts project function, that will be called with values which normally
	     * would land in emitted array. Whatever is returned by project function, will appear in output
	     * Observable instead. This means that default project can be thought of as a function that takes
	     * all its arguments and puts them into an array. Note that project function will be called only
	     * when output Observable is supposed to emit a result.
	     *
	     * @example <caption>Use forkJoin with operator emitting immediately</caption>
	     * const observable = Rx.Observable.forkJoin(
	     *   Rx.Observable.of(1, 2, 3, 4),
	     *   Rx.Observable.of(5, 6, 7, 8)
	     * );
	     * observable.subscribe(
	     *   value => console.log(value),
	     *   err => {},
	     *   () => console.log('This is how it ends!')
	     * );
	     *
	     * // Logs:
	     * // [4, 8]
	     * // "This is how it ends!"
	     *
	     *
	     * @example <caption>Use forkJoin with operator emitting after some time</caption>
	     * const observable = Rx.Observable.forkJoin(
	     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
	     *   Rx.Observable.interval(500).take(4) // emit 0, 1, 2, 3 every half a second and complete
	     * );
	     * observable.subscribe(
	     *   value => console.log(value),
	     *   err => {},
	     *   () => console.log('This is how it ends!')
	     * );
	     *
	     * // Logs:
	     * // [2, 3] after 3 seconds
	     * // "This is how it ends!" immediately after
	     *
	     *
	     * @example <caption>Use forkJoin with project function</caption>
	     * const observable = Rx.Observable.forkJoin(
	     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
	     *   Rx.Observable.interval(500).take(4), // emit 0, 1, 2, 3 every half a second and complete
	     *   (n, m) => n + m
	     * );
	     * observable.subscribe(
	     *   value => console.log(value),
	     *   err => {},
	     *   () => console.log('This is how it ends!')
	     * );
	     *
	     * // Logs:
	     * // 5 after 3 seconds
	     * // "This is how it ends!" immediately after
	     *
	     * @see {@link combineLatest}
	     * @see {@link zip}
	     *
	     * @param {...SubscribableOrPromise} sources Any number of Observables provided either as an array or as an arguments
	     * passed directly to the operator.
	     * @param {function} [project] Function that takes values emitted by input Observables and returns value
	     * that will appear in resulting Observable instead of default array.
	     * @return {Observable} Observable emitting either an array of last values emitted by passed Observables
	     * or value from project function.
	     * @static true
	     * @name forkJoin
	     * @owner Observable
	     */
	    ForkJoinObservable.create = function () {
	        var sources = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            sources[_i - 0] = arguments[_i];
	        }
	        if (sources === null || arguments.length === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        var resultSelector = null;
	        if (typeof sources[sources.length - 1] === 'function') {
	            resultSelector = sources.pop();
	        }
	        // if the first and only other argument besides the resultSelector is an array
	        // assume it's been called with `forkJoin([obs1, obs2, obs3], resultSelector)`
	        if (sources.length === 1 && isArray_1.isArray(sources[0])) {
	            sources = sources[0];
	        }
	        if (sources.length === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        return new ForkJoinObservable(sources, resultSelector);
	    };
	    ForkJoinObservable.prototype._subscribe = function (subscriber) {
	        return new ForkJoinSubscriber(subscriber, this.sources, this.resultSelector);
	    };
	    return ForkJoinObservable;
	}(Observable_1.Observable));
	exports.ForkJoinObservable = ForkJoinObservable;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ForkJoinSubscriber = (function (_super) {
	    __extends(ForkJoinSubscriber, _super);
	    function ForkJoinSubscriber(destination, sources, resultSelector) {
	        _super.call(this, destination);
	        this.sources = sources;
	        this.resultSelector = resultSelector;
	        this.completed = 0;
	        this.haveValues = 0;
	        var len = sources.length;
	        this.total = len;
	        this.values = new Array(len);
	        for (var i = 0; i < len; i++) {
	            var source = sources[i];
	            var innerSubscription = subscribeToResult_1.subscribeToResult(this, source, null, i);
	            if (innerSubscription) {
	                innerSubscription.outerIndex = i;
	                this.add(innerSubscription);
	            }
	        }
	    }
	    ForkJoinSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.values[outerIndex] = innerValue;
	        if (!innerSub._hasValue) {
	            innerSub._hasValue = true;
	            this.haveValues++;
	        }
	    };
	    ForkJoinSubscriber.prototype.notifyComplete = function (innerSub) {
	        var destination = this.destination;
	        var _a = this, haveValues = _a.haveValues, resultSelector = _a.resultSelector, values = _a.values;
	        var len = values.length;
	        if (!innerSub._hasValue) {
	            destination.complete();
	            return;
	        }
	        this.completed++;
	        if (this.completed !== len) {
	            return;
	        }
	        if (haveValues === len) {
	            var value = resultSelector ? resultSelector.apply(this, values) : values;
	            destination.next(value);
	        }
	        destination.complete();
	    };
	    return ForkJoinSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=ForkJoinObservable.js.map

/***/ }),
/* 4607 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	var tryCatch_1 = __webpack_require__(34);
	var isFunction_1 = __webpack_require__(360);
	var errorObject_1 = __webpack_require__(32);
	var Subscription_1 = __webpack_require__(31);
	var toString = Object.prototype.toString;
	function isNodeStyleEventEmitter(sourceObj) {
	    return !!sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
	}
	function isJQueryStyleEventEmitter(sourceObj) {
	    return !!sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
	}
	function isNodeList(sourceObj) {
	    return !!sourceObj && toString.call(sourceObj) === '[object NodeList]';
	}
	function isHTMLCollection(sourceObj) {
	    return !!sourceObj && toString.call(sourceObj) === '[object HTMLCollection]';
	}
	function isEventTarget(sourceObj) {
	    return !!sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
	}
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var FromEventObservable = (function (_super) {
	    __extends(FromEventObservable, _super);
	    function FromEventObservable(sourceObj, eventName, selector, options) {
	        _super.call(this);
	        this.sourceObj = sourceObj;
	        this.eventName = eventName;
	        this.selector = selector;
	        this.options = options;
	    }
	    /* tslint:enable:max-line-length */
	    /**
	     * Creates an Observable that emits events of a specific type coming from the
	     * given event target.
	     *
	     * <span class="informal">Creates an Observable from DOM events, or Node.js
	     * EventEmitter events or others.</span>
	     *
	     * <img src="./img/fromEvent.png" width="100%">
	     *
	     * `fromEvent` accepts as a first argument event target, which is an object with methods
	     * for registering event handler functions. As a second argument it takes string that indicates
	     * type of event we want to listen for. `fromEvent` supports selected types of event targets,
	     * which are described in detail below. If your event target does not match any of the ones listed,
	     * you should use {@link fromEventPattern}, which can be used on arbitrary APIs.
	     * When it comes to APIs supported by `fromEvent`, their methods for adding and removing event
	     * handler functions have different names, but they all accept a string describing event type
	     * and function itself, which will be called whenever said event happens.
	     *
	     * Every time resulting Observable is subscribed, event handler function will be registered
	     * to event target on given event type. When that event fires, value
	     * passed as a first argument to registered function will be emitted by output Observable.
	     * When Observable is unsubscribed, function will be unregistered from event target.
	     *
	     * Note that if event target calls registered function with more than one argument, second
	     * and following arguments will not appear in resulting stream. In order to get access to them,
	     * you can pass to `fromEvent` optional project function, which will be called with all arguments
	     * passed to event handler. Output Observable will then emit value returned by project function,
	     * instead of the usual value.
	     *
	     * Remember that event targets listed below are checked via duck typing. It means that
	     * no matter what kind of object you have and no matter what environment you work in,
	     * you can safely use `fromEvent` on that object if it exposes described methods (provided
	     * of course they behave as was described above). So for example if Node.js library exposes
	     * event target which has the same method names as DOM EventTarget, `fromEvent` is still
	     * a good choice.
	     *
	     * If the API you use is more callback then event handler oriented (subscribed
	     * callback function fires only once and thus there is no need to manually
	     * unregister it), you should use {@link bindCallback} or {@link bindNodeCallback}
	     * instead.
	     *
	     * `fromEvent` supports following types of event targets:
	     *
	     * **DOM EventTarget**
	     *
	     * This is an object with `addEventListener` and `removeEventListener` methods.
	     *
	     * In the browser, `addEventListener` accepts - apart from event type string and event
	     * handler function arguments - optional third parameter, which is either an object or boolean,
	     * both used for additional configuration how and when passed function will be called. When
	     * `fromEvent` is used with event target of that type, you can provide this values
	     * as third parameter as well.
	     *
	     * **Node.js EventEmitter**
	     *
	     * An object with `addListener` and `removeListener` methods.
	     *
	     * **JQuery-style event target**
	     *
	     * An object with `on` and `off` methods
	     *
	     * **DOM NodeList**
	     *
	     * List of DOM Nodes, returned for example by `document.querySelectorAll` or `Node.childNodes`.
	     *
	     * Although this collection is not event target in itself, `fromEvent` will iterate over all Nodes
	     * it contains and install event handler function in every of them. When returned Observable
	     * is unsubscribed, function will be removed from all Nodes.
	     *
	     * **DOM HtmlCollection**
	     *
	     * Just as in case of NodeList it is a collection of DOM nodes. Here as well event handler function is
	     * installed and removed in each of elements.
	     *
	     *
	     * @example <caption>Emits clicks happening on the DOM document</caption>
	     * var clicks = Rx.Observable.fromEvent(document, 'click');
	     * clicks.subscribe(x => console.log(x));
	     *
	     * // Results in:
	     * // MouseEvent object logged to console every time a click
	     * // occurs on the document.
	     *
	     *
	     * @example <caption>Use addEventListener with capture option</caption>
	     * var clicksInDocument = Rx.Observable.fromEvent(document, 'click', true); // note optional configuration parameter
	     *                                                                          // which will be passed to addEventListener
	     * var clicksInDiv = Rx.Observable.fromEvent(someDivInDocument, 'click');
	     *
	     * clicksInDocument.subscribe(() => console.log('document'));
	     * clicksInDiv.subscribe(() => console.log('div'));
	     *
	     * // By default events bubble UP in DOM tree, so normally
	     * // when we would click on div in document
	     * // "div" would be logged first and then "document".
	     * // Since we specified optional `capture` option, document
	     * // will catch event when it goes DOWN DOM tree, so console
	     * // will log "document" and then "div".
	     *
	     * @see {@link bindCallback}
	     * @see {@link bindNodeCallback}
	     * @see {@link fromEventPattern}
	     *
	     * @param {EventTargetLike} target The DOM EventTarget, Node.js
	     * EventEmitter, JQuery-like event target, NodeList or HTMLCollection to attach the event handler to.
	     * @param {string} eventName The event name of interest, being emitted by the
	     * `target`.
	     * @param {EventListenerOptions} [options] Options to pass through to addEventListener
	     * @param {SelectorMethodSignature<T>} [selector] An optional function to
	     * post-process results. It takes the arguments from the event handler and
	     * should return a single value.
	     * @return {Observable<T>}
	     * @static true
	     * @name fromEvent
	     * @owner Observable
	     */
	    FromEventObservable.create = function (target, eventName, options, selector) {
	        if (isFunction_1.isFunction(options)) {
	            selector = options;
	            options = undefined;
	        }
	        return new FromEventObservable(target, eventName, selector, options);
	    };
	    FromEventObservable.setupSubscription = function (sourceObj, eventName, handler, subscriber, options) {
	        var unsubscribe;
	        if (isNodeList(sourceObj) || isHTMLCollection(sourceObj)) {
	            for (var i = 0, len = sourceObj.length; i < len; i++) {
	                FromEventObservable.setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
	            }
	        }
	        else if (isEventTarget(sourceObj)) {
	            var source_1 = sourceObj;
	            sourceObj.addEventListener(eventName, handler, options);
	            unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
	        }
	        else if (isJQueryStyleEventEmitter(sourceObj)) {
	            var source_2 = sourceObj;
	            sourceObj.on(eventName, handler);
	            unsubscribe = function () { return source_2.off(eventName, handler); };
	        }
	        else if (isNodeStyleEventEmitter(sourceObj)) {
	            var source_3 = sourceObj;
	            sourceObj.addListener(eventName, handler);
	            unsubscribe = function () { return source_3.removeListener(eventName, handler); };
	        }
	        else {
	            throw new TypeError('Invalid event target');
	        }
	        subscriber.add(new Subscription_1.Subscription(unsubscribe));
	    };
	    FromEventObservable.prototype._subscribe = function (subscriber) {
	        var sourceObj = this.sourceObj;
	        var eventName = this.eventName;
	        var options = this.options;
	        var selector = this.selector;
	        var handler = selector ? function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            var result = tryCatch_1.tryCatch(selector).apply(void 0, args);
	            if (result === errorObject_1.errorObject) {
	                subscriber.error(errorObject_1.errorObject.e);
	            }
	            else {
	                subscriber.next(result);
	            }
	        } : function (e) { return subscriber.next(e); };
	        FromEventObservable.setupSubscription(sourceObj, eventName, handler, subscriber, options);
	    };
	    return FromEventObservable;
	}(Observable_1.Observable));
	exports.FromEventObservable = FromEventObservable;
	//# sourceMappingURL=FromEventObservable.js.map

/***/ }),
/* 4608 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isFunction_1 = __webpack_require__(360);
	var Observable_1 = __webpack_require__(4);
	var Subscription_1 = __webpack_require__(31);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var FromEventPatternObservable = (function (_super) {
	    __extends(FromEventPatternObservable, _super);
	    function FromEventPatternObservable(addHandler, removeHandler, selector) {
	        _super.call(this);
	        this.addHandler = addHandler;
	        this.removeHandler = removeHandler;
	        this.selector = selector;
	    }
	    /**
	     * Creates an Observable from an API based on addHandler/removeHandler
	     * functions.
	     *
	     * <span class="informal">Converts any addHandler/removeHandler API to an
	     * Observable.</span>
	     *
	     * <img src="./img/fromEventPattern.png" width="100%">
	     *
	     * Creates an Observable by using the `addHandler` and `removeHandler`
	     * functions to add and remove the handlers, with an optional selector
	     * function to project the event arguments to a result. The `addHandler` is
	     * called when the output Observable is subscribed, and `removeHandler` is
	     * called when the Subscription is unsubscribed.
	     *
	     * @example <caption>Emits clicks happening on the DOM document</caption>
	     * function addClickHandler(handler) {
	     *   document.addEventListener('click', handler);
	     * }
	     *
	     * function removeClickHandler(handler) {
	     *   document.removeEventListener('click', handler);
	     * }
	     *
	     * var clicks = Rx.Observable.fromEventPattern(
	     *   addClickHandler,
	     *   removeClickHandler
	     * );
	     * clicks.subscribe(x => console.log(x));
	     *
	     * @see {@link from}
	     * @see {@link fromEvent}
	     *
	     * @param {function(handler: Function): any} addHandler A function that takes
	     * a `handler` function as argument and attaches it somehow to the actual
	     * source of events.
	     * @param {function(handler: Function, signal?: any): void} [removeHandler] An optional function that
	     * takes a `handler` function as argument and removes it in case it was
	     * previously attached using `addHandler`. if addHandler returns signal to teardown when remove,
	     * removeHandler function will forward it.
	     * @param {function(...args: any): T} [selector] An optional function to
	     * post-process results. It takes the arguments from the event handler and
	     * should return a single value.
	     * @return {Observable<T>}
	     * @static true
	     * @name fromEventPattern
	     * @owner Observable
	     */
	    FromEventPatternObservable.create = function (addHandler, removeHandler, selector) {
	        return new FromEventPatternObservable(addHandler, removeHandler, selector);
	    };
	    FromEventPatternObservable.prototype._subscribe = function (subscriber) {
	        var _this = this;
	        var removeHandler = this.removeHandler;
	        var handler = !!this.selector ? function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            _this._callSelector(subscriber, args);
	        } : function (e) { subscriber.next(e); };
	        var retValue = this._callAddHandler(handler, subscriber);
	        if (!isFunction_1.isFunction(removeHandler)) {
	            return;
	        }
	        subscriber.add(new Subscription_1.Subscription(function () {
	            //TODO: determine whether or not to forward to error handler
	            removeHandler(handler, retValue);
	        }));
	    };
	    FromEventPatternObservable.prototype._callSelector = function (subscriber, args) {
	        try {
	            var result = this.selector.apply(this, args);
	            subscriber.next(result);
	        }
	        catch (e) {
	            subscriber.error(e);
	        }
	    };
	    FromEventPatternObservable.prototype._callAddHandler = function (handler, errorSubscriber) {
	        try {
	            return this.addHandler(handler) || null;
	        }
	        catch (e) {
	            errorSubscriber.error(e);
	        }
	    };
	    return FromEventPatternObservable;
	}(Observable_1.Observable));
	exports.FromEventPatternObservable = FromEventPatternObservable;
	//# sourceMappingURL=FromEventPatternObservable.js.map

/***/ }),
/* 4609 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	var isScheduler_1 = __webpack_require__(65);
	var selfSelector = function (value) { return value; };
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var GenerateObservable = (function (_super) {
	    __extends(GenerateObservable, _super);
	    function GenerateObservable(initialState, condition, iterate, resultSelector, scheduler) {
	        _super.call(this);
	        this.initialState = initialState;
	        this.condition = condition;
	        this.iterate = iterate;
	        this.resultSelector = resultSelector;
	        this.scheduler = scheduler;
	    }
	    GenerateObservable.create = function (initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
	        if (arguments.length == 1) {
	            return new GenerateObservable(initialStateOrOptions.initialState, initialStateOrOptions.condition, initialStateOrOptions.iterate, initialStateOrOptions.resultSelector || selfSelector, initialStateOrOptions.scheduler);
	        }
	        if (resultSelectorOrObservable === undefined || isScheduler_1.isScheduler(resultSelectorOrObservable)) {
	            return new GenerateObservable(initialStateOrOptions, condition, iterate, selfSelector, resultSelectorOrObservable);
	        }
	        return new GenerateObservable(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler);
	    };
	    GenerateObservable.prototype._subscribe = function (subscriber) {
	        var state = this.initialState;
	        if (this.scheduler) {
	            return this.scheduler.schedule(GenerateObservable.dispatch, 0, {
	                subscriber: subscriber,
	                iterate: this.iterate,
	                condition: this.condition,
	                resultSelector: this.resultSelector,
	                state: state });
	        }
	        var _a = this, condition = _a.condition, resultSelector = _a.resultSelector, iterate = _a.iterate;
	        do {
	            if (condition) {
	                var conditionResult = void 0;
	                try {
	                    conditionResult = condition(state);
	                }
	                catch (err) {
	                    subscriber.error(err);
	                    return;
	                }
	                if (!conditionResult) {
	                    subscriber.complete();
	                    break;
	                }
	            }
	            var value = void 0;
	            try {
	                value = resultSelector(state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return;
	            }
	            subscriber.next(value);
	            if (subscriber.closed) {
	                break;
	            }
	            try {
	                state = iterate(state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return;
	            }
	        } while (true);
	    };
	    GenerateObservable.dispatch = function (state) {
	        var subscriber = state.subscriber, condition = state.condition;
	        if (subscriber.closed) {
	            return;
	        }
	        if (state.needIterate) {
	            try {
	                state.state = state.iterate(state.state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return;
	            }
	        }
	        else {
	            state.needIterate = true;
	        }
	        if (condition) {
	            var conditionResult = void 0;
	            try {
	                conditionResult = condition(state.state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return;
	            }
	            if (!conditionResult) {
	                subscriber.complete();
	                return;
	            }
	            if (subscriber.closed) {
	                return;
	            }
	        }
	        var value;
	        try {
	            value = state.resultSelector(state.state);
	        }
	        catch (err) {
	            subscriber.error(err);
	            return;
	        }
	        if (subscriber.closed) {
	            return;
	        }
	        subscriber.next(value);
	        if (subscriber.closed) {
	            return;
	        }
	        return this.schedule(state);
	    };
	    return GenerateObservable;
	}(Observable_1.Observable));
	exports.GenerateObservable = GenerateObservable;
	//# sourceMappingURL=GenerateObservable.js.map

/***/ }),
/* 4610 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	var subscribeToResult_1 = __webpack_require__(17);
	var OuterSubscriber_1 = __webpack_require__(16);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var IfObservable = (function (_super) {
	    __extends(IfObservable, _super);
	    function IfObservable(condition, thenSource, elseSource) {
	        _super.call(this);
	        this.condition = condition;
	        this.thenSource = thenSource;
	        this.elseSource = elseSource;
	    }
	    IfObservable.create = function (condition, thenSource, elseSource) {
	        return new IfObservable(condition, thenSource, elseSource);
	    };
	    IfObservable.prototype._subscribe = function (subscriber) {
	        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
	        return new IfSubscriber(subscriber, condition, thenSource, elseSource);
	    };
	    return IfObservable;
	}(Observable_1.Observable));
	exports.IfObservable = IfObservable;
	var IfSubscriber = (function (_super) {
	    __extends(IfSubscriber, _super);
	    function IfSubscriber(destination, condition, thenSource, elseSource) {
	        _super.call(this, destination);
	        this.condition = condition;
	        this.thenSource = thenSource;
	        this.elseSource = elseSource;
	        this.tryIf();
	    }
	    IfSubscriber.prototype.tryIf = function () {
	        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
	        var result;
	        try {
	            result = condition();
	            var source = result ? thenSource : elseSource;
	            if (source) {
	                this.add(subscribeToResult_1.subscribeToResult(this, source));
	            }
	            else {
	                this._complete();
	            }
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    return IfSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=IfObservable.js.map

/***/ }),
/* 4611 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isNumeric_1 = __webpack_require__(272);
	var Observable_1 = __webpack_require__(4);
	var async_1 = __webpack_require__(23);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var IntervalObservable = (function (_super) {
	    __extends(IntervalObservable, _super);
	    function IntervalObservable(period, scheduler) {
	        if (period === void 0) { period = 0; }
	        if (scheduler === void 0) { scheduler = async_1.async; }
	        _super.call(this);
	        this.period = period;
	        this.scheduler = scheduler;
	        if (!isNumeric_1.isNumeric(period) || period < 0) {
	            this.period = 0;
	        }
	        if (!scheduler || typeof scheduler.schedule !== 'function') {
	            this.scheduler = async_1.async;
	        }
	    }
	    /**
	     * Creates an Observable that emits sequential numbers every specified
	     * interval of time, on a specified IScheduler.
	     *
	     * <span class="informal">Emits incremental numbers periodically in time.
	     * </span>
	     *
	     * <img src="./img/interval.png" width="100%">
	     *
	     * `interval` returns an Observable that emits an infinite sequence of
	     * ascending integers, with a constant interval of time of your choosing
	     * between those emissions. The first emission is not sent immediately, but
	     * only after the first period has passed. By default, this operator uses the
	     * `async` IScheduler to provide a notion of time, but you may pass any
	     * IScheduler to it.
	     *
	     * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
	     * var numbers = Rx.Observable.interval(1000);
	     * numbers.subscribe(x => console.log(x));
	     *
	     * @see {@link timer}
	     * @see {@link delay}
	     *
	     * @param {number} [period=0] The interval size in milliseconds (by default)
	     * or the time unit determined by the scheduler's clock.
	     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
	     * the emission of values, and providing a notion of "time".
	     * @return {Observable} An Observable that emits a sequential number each time
	     * interval.
	     * @static true
	     * @name interval
	     * @owner Observable
	     */
	    IntervalObservable.create = function (period, scheduler) {
	        if (period === void 0) { period = 0; }
	        if (scheduler === void 0) { scheduler = async_1.async; }
	        return new IntervalObservable(period, scheduler);
	    };
	    IntervalObservable.dispatch = function (state) {
	        var index = state.index, subscriber = state.subscriber, period = state.period;
	        subscriber.next(index);
	        if (subscriber.closed) {
	            return;
	        }
	        state.index += 1;
	        this.schedule(state, period);
	    };
	    IntervalObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var period = this.period;
	        var scheduler = this.scheduler;
	        subscriber.add(scheduler.schedule(IntervalObservable.dispatch, period, {
	            index: index, subscriber: subscriber, period: period
	        }));
	    };
	    return IntervalObservable;
	}(Observable_1.Observable));
	exports.IntervalObservable = IntervalObservable;
	//# sourceMappingURL=IntervalObservable.js.map

/***/ }),
/* 4612 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(39);
	var Observable_1 = __webpack_require__(4);
	var iterator_1 = __webpack_require__(270);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var IteratorObservable = (function (_super) {
	    __extends(IteratorObservable, _super);
	    function IteratorObservable(iterator, scheduler) {
	        _super.call(this);
	        this.scheduler = scheduler;
	        if (iterator == null) {
	            throw new Error('iterator cannot be null.');
	        }
	        this.iterator = getIterator(iterator);
	    }
	    IteratorObservable.create = function (iterator, scheduler) {
	        return new IteratorObservable(iterator, scheduler);
	    };
	    IteratorObservable.dispatch = function (state) {
	        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
	        if (hasError) {
	            subscriber.error(state.error);
	            return;
	        }
	        var result = iterator.next();
	        if (result.done) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(result.value);
	        state.index = index + 1;
	        if (subscriber.closed) {
	            if (typeof iterator.return === 'function') {
	                iterator.return();
	            }
	            return;
	        }
	        this.schedule(state);
	    };
	    IteratorObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(IteratorObservable.dispatch, 0, {
	                index: index, iterator: iterator, subscriber: subscriber
	            });
	        }
	        else {
	            do {
	                var result = iterator.next();
	                if (result.done) {
	                    subscriber.complete();
	                    break;
	                }
	                else {
	                    subscriber.next(result.value);
	                }
	                if (subscriber.closed) {
	                    if (typeof iterator.return === 'function') {
	                        iterator.return();
	                    }
	                    break;
	                }
	            } while (true);
	        }
	    };
	    return IteratorObservable;
	}(Observable_1.Observable));
	exports.IteratorObservable = IteratorObservable;
	var StringIterator = (function () {
	    function StringIterator(str, idx, len) {
	        if (idx === void 0) { idx = 0; }
	        if (len === void 0) { len = str.length; }
	        this.str = str;
	        this.idx = idx;
	        this.len = len;
	    }
	    StringIterator.prototype[iterator_1.iterator] = function () { return (this); };
	    StringIterator.prototype.next = function () {
	        return this.idx < this.len ? {
	            done: false,
	            value: this.str.charAt(this.idx++)
	        } : {
	            done: true,
	            value: undefined
	        };
	    };
	    return StringIterator;
	}());
	var ArrayIterator = (function () {
	    function ArrayIterator(arr, idx, len) {
	        if (idx === void 0) { idx = 0; }
	        if (len === void 0) { len = toLength(arr); }
	        this.arr = arr;
	        this.idx = idx;
	        this.len = len;
	    }
	    ArrayIterator.prototype[iterator_1.iterator] = function () { return this; };
	    ArrayIterator.prototype.next = function () {
	        return this.idx < this.len ? {
	            done: false,
	            value: this.arr[this.idx++]
	        } : {
	            done: true,
	            value: undefined
	        };
	    };
	    return ArrayIterator;
	}());
	function getIterator(obj) {
	    var i = obj[iterator_1.iterator];
	    if (!i && typeof obj === 'string') {
	        return new StringIterator(obj);
	    }
	    if (!i && obj.length !== undefined) {
	        return new ArrayIterator(obj);
	    }
	    if (!i) {
	        throw new TypeError('object is not iterable');
	    }
	    return obj[iterator_1.iterator]();
	}
	var maxSafeInteger = Math.pow(2, 53) - 1;
	function toLength(o) {
	    var len = +o.length;
	    if (isNaN(len)) {
	        return 0;
	    }
	    if (len === 0 || !numberIsFinite(len)) {
	        return len;
	    }
	    len = sign(len) * Math.floor(Math.abs(len));
	    if (len <= 0) {
	        return 0;
	    }
	    if (len > maxSafeInteger) {
	        return maxSafeInteger;
	    }
	    return len;
	}
	function numberIsFinite(value) {
	    return typeof value === 'number' && root_1.root.isFinite(value);
	}
	function sign(value) {
	    var valueAsNumber = +value;
	    if (valueAsNumber === 0) {
	        return valueAsNumber;
	    }
	    if (isNaN(valueAsNumber)) {
	        return valueAsNumber;
	    }
	    return valueAsNumber < 0 ? -1 : 1;
	}
	//# sourceMappingURL=IteratorObservable.js.map

/***/ }),
/* 4613 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	var noop_1 = __webpack_require__(523);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var NeverObservable = (function (_super) {
	    __extends(NeverObservable, _super);
	    function NeverObservable() {
	        _super.call(this);
	    }
	    /**
	     * Creates an Observable that emits no items to the Observer.
	     *
	     * <span class="informal">An Observable that never emits anything.</span>
	     *
	     * <img src="./img/never.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that emits
	     * neither values nor errors nor the completion notification. It can be used
	     * for testing purposes or for composing with other Observables. Please note
	     * that by never emitting a complete notification, this Observable keeps the
	     * subscription from being disposed automatically. Subscriptions need to be
	     * manually disposed.
	     *
	     * @example <caption>Emit the number 7, then never emit anything else (not even complete).</caption>
	     * function info() {
	     *   console.log('Will not be called');
	     * }
	     * var result = Rx.Observable.never().startWith(7);
	     * result.subscribe(x => console.log(x), info, info);
	     *
	     * @see {@link create}
	     * @see {@link empty}
	     * @see {@link of}
	     * @see {@link throw}
	     *
	     * @return {Observable} A "never" Observable: never emits anything.
	     * @static true
	     * @name never
	     * @owner Observable
	     */
	    NeverObservable.create = function () {
	        return new NeverObservable();
	    };
	    NeverObservable.prototype._subscribe = function (subscriber) {
	        noop_1.noop();
	    };
	    return NeverObservable;
	}(Observable_1.Observable));
	exports.NeverObservable = NeverObservable;
	//# sourceMappingURL=NeverObservable.js.map

/***/ }),
/* 4614 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	function dispatch(state) {
	    var obj = state.obj, keys = state.keys, length = state.length, index = state.index, subscriber = state.subscriber;
	    if (index === length) {
	        subscriber.complete();
	        return;
	    }
	    var key = keys[index];
	    subscriber.next([key, obj[key]]);
	    state.index = index + 1;
	    this.schedule(state);
	}
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var PairsObservable = (function (_super) {
	    __extends(PairsObservable, _super);
	    function PairsObservable(obj, scheduler) {
	        _super.call(this);
	        this.obj = obj;
	        this.scheduler = scheduler;
	        this.keys = Object.keys(obj);
	    }
	    /**
	     * Convert an object into an observable sequence of [key, value] pairs
	     * using an optional IScheduler to enumerate the object.
	     *
	     * @example <caption>Converts a javascript object to an Observable</caption>
	     * var obj = {
	     *   foo: 42,
	     *   bar: 56,
	     *   baz: 78
	     * };
	     *
	     * var source = Rx.Observable.pairs(obj);
	     *
	     * var subscription = source.subscribe(
	     *   function (x) {
	     *     console.log('Next: %s', x);
	     *   },
	     *   function (err) {
	     *     console.log('Error: %s', err);
	     *   },
	     *   function () {
	     *     console.log('Completed');
	     *   });
	     *
	     * @param {Object} obj The object to inspect and turn into an
	     * Observable sequence.
	     * @param {Scheduler} [scheduler] An optional IScheduler to run the
	     * enumeration of the input sequence on.
	     * @returns {(Observable<Array<string | T>>)} An observable sequence of
	     * [key, value] pairs from the object.
	     */
	    PairsObservable.create = function (obj, scheduler) {
	        return new PairsObservable(obj, scheduler);
	    };
	    PairsObservable.prototype._subscribe = function (subscriber) {
	        var _a = this, keys = _a.keys, scheduler = _a.scheduler;
	        var length = keys.length;
	        if (scheduler) {
	            return scheduler.schedule(dispatch, 0, {
	                obj: this.obj, keys: keys, length: length, index: 0, subscriber: subscriber
	            });
	        }
	        else {
	            for (var idx = 0; idx < length; idx++) {
	                var key = keys[idx];
	                subscriber.next([key, this.obj[key]]);
	            }
	            subscriber.complete();
	        }
	    };
	    return PairsObservable;
	}(Observable_1.Observable));
	exports.PairsObservable = PairsObservable;
	//# sourceMappingURL=PairsObservable.js.map

/***/ }),
/* 4615 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var RangeObservable = (function (_super) {
	    __extends(RangeObservable, _super);
	    function RangeObservable(start, count, scheduler) {
	        _super.call(this);
	        this.start = start;
	        this._count = count;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable that emits a sequence of numbers within a specified
	     * range.
	     *
	     * <span class="informal">Emits a sequence of numbers in a range.</span>
	     *
	     * <img src="./img/range.png" width="100%">
	     *
	     * `range` operator emits a range of sequential integers, in order, where you
	     * select the `start` of the range and its `length`. By default, uses no
	     * IScheduler and just delivers the notifications synchronously, but may use
	     * an optional IScheduler to regulate those deliveries.
	     *
	     * @example <caption>Emits the numbers 1 to 10</caption>
	     * var numbers = Rx.Observable.range(1, 10);
	     * numbers.subscribe(x => console.log(x));
	     *
	     * @see {@link timer}
	     * @see {@link interval}
	     *
	     * @param {number} [start=0] The value of the first integer in the sequence.
	     * @param {number} [count=0] The number of sequential integers to generate.
	     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
	     * the emissions of the notifications.
	     * @return {Observable} An Observable of numbers that emits a finite range of
	     * sequential integers.
	     * @static true
	     * @name range
	     * @owner Observable
	     */
	    RangeObservable.create = function (start, count, scheduler) {
	        if (start === void 0) { start = 0; }
	        if (count === void 0) { count = 0; }
	        return new RangeObservable(start, count, scheduler);
	    };
	    RangeObservable.dispatch = function (state) {
	        var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
	        if (index >= count) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(start);
	        if (subscriber.closed) {
	            return;
	        }
	        state.index = index + 1;
	        state.start = start + 1;
	        this.schedule(state);
	    };
	    RangeObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var start = this.start;
	        var count = this._count;
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(RangeObservable.dispatch, 0, {
	                index: index, count: count, start: start, subscriber: subscriber
	            });
	        }
	        else {
	            do {
	                if (index++ >= count) {
	                    subscriber.complete();
	                    break;
	                }
	                subscriber.next(start++);
	                if (subscriber.closed) {
	                    break;
	                }
	            } while (true);
	        }
	    };
	    return RangeObservable;
	}(Observable_1.Observable));
	exports.RangeObservable = RangeObservable;
	//# sourceMappingURL=RangeObservable.js.map

/***/ }),
/* 4616 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	var asap_1 = __webpack_require__(848);
	var isNumeric_1 = __webpack_require__(272);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var SubscribeOnObservable = (function (_super) {
	    __extends(SubscribeOnObservable, _super);
	    function SubscribeOnObservable(source, delayTime, scheduler) {
	        if (delayTime === void 0) { delayTime = 0; }
	        if (scheduler === void 0) { scheduler = asap_1.asap; }
	        _super.call(this);
	        this.source = source;
	        this.delayTime = delayTime;
	        this.scheduler = scheduler;
	        if (!isNumeric_1.isNumeric(delayTime) || delayTime < 0) {
	            this.delayTime = 0;
	        }
	        if (!scheduler || typeof scheduler.schedule !== 'function') {
	            this.scheduler = asap_1.asap;
	        }
	    }
	    SubscribeOnObservable.create = function (source, delay, scheduler) {
	        if (delay === void 0) { delay = 0; }
	        if (scheduler === void 0) { scheduler = asap_1.asap; }
	        return new SubscribeOnObservable(source, delay, scheduler);
	    };
	    SubscribeOnObservable.dispatch = function (arg) {
	        var source = arg.source, subscriber = arg.subscriber;
	        return this.add(source.subscribe(subscriber));
	    };
	    SubscribeOnObservable.prototype._subscribe = function (subscriber) {
	        var delay = this.delayTime;
	        var source = this.source;
	        var scheduler = this.scheduler;
	        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
	            source: source, subscriber: subscriber
	        });
	    };
	    return SubscribeOnObservable;
	}(Observable_1.Observable));
	exports.SubscribeOnObservable = SubscribeOnObservable;
	//# sourceMappingURL=SubscribeOnObservable.js.map

/***/ }),
/* 4617 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isNumeric_1 = __webpack_require__(272);
	var Observable_1 = __webpack_require__(4);
	var async_1 = __webpack_require__(23);
	var isScheduler_1 = __webpack_require__(65);
	var isDate_1 = __webpack_require__(359);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var TimerObservable = (function (_super) {
	    __extends(TimerObservable, _super);
	    function TimerObservable(dueTime, period, scheduler) {
	        if (dueTime === void 0) { dueTime = 0; }
	        _super.call(this);
	        this.period = -1;
	        this.dueTime = 0;
	        if (isNumeric_1.isNumeric(period)) {
	            this.period = Number(period) < 1 && 1 || Number(period);
	        }
	        else if (isScheduler_1.isScheduler(period)) {
	            scheduler = period;
	        }
	        if (!isScheduler_1.isScheduler(scheduler)) {
	            scheduler = async_1.async;
	        }
	        this.scheduler = scheduler;
	        this.dueTime = isDate_1.isDate(dueTime) ?
	            (+dueTime - this.scheduler.now()) :
	            dueTime;
	    }
	    /**
	     * Creates an Observable that starts emitting after an `initialDelay` and
	     * emits ever increasing numbers after each `period` of time thereafter.
	     *
	     * <span class="informal">Its like {@link interval}, but you can specify when
	     * should the emissions start.</span>
	     *
	     * <img src="./img/timer.png" width="100%">
	     *
	     * `timer` returns an Observable that emits an infinite sequence of ascending
	     * integers, with a constant interval of time, `period` of your choosing
	     * between those emissions. The first emission happens after the specified
	     * `initialDelay`. The initial delay may be a {@link Date}. By default, this
	     * operator uses the `async` IScheduler to provide a notion of time, but you
	     * may pass any IScheduler to it. If `period` is not specified, the output
	     * Observable emits only one value, `0`. Otherwise, it emits an infinite
	     * sequence.
	     *
	     * @example <caption>Emits ascending numbers, one every second (1000ms), starting after 3 seconds</caption>
	     * var numbers = Rx.Observable.timer(3000, 1000);
	     * numbers.subscribe(x => console.log(x));
	     *
	     * @example <caption>Emits one number after five seconds</caption>
	     * var numbers = Rx.Observable.timer(5000);
	     * numbers.subscribe(x => console.log(x));
	     *
	     * @see {@link interval}
	     * @see {@link delay}
	     *
	     * @param {number|Date} initialDelay The initial delay time to wait before
	     * emitting the first value of `0`.
	     * @param {number} [period] The period of time between emissions of the
	     * subsequent numbers.
	     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
	     * the emission of values, and providing a notion of "time".
	     * @return {Observable} An Observable that emits a `0` after the
	     * `initialDelay` and ever increasing numbers after each `period` of time
	     * thereafter.
	     * @static true
	     * @name timer
	     * @owner Observable
	     */
	    TimerObservable.create = function (initialDelay, period, scheduler) {
	        if (initialDelay === void 0) { initialDelay = 0; }
	        return new TimerObservable(initialDelay, period, scheduler);
	    };
	    TimerObservable.dispatch = function (state) {
	        var index = state.index, period = state.period, subscriber = state.subscriber;
	        var action = this;
	        subscriber.next(index);
	        if (subscriber.closed) {
	            return;
	        }
	        else if (period === -1) {
	            return subscriber.complete();
	        }
	        state.index = index + 1;
	        action.schedule(state, period);
	    };
	    TimerObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var _a = this, period = _a.period, dueTime = _a.dueTime, scheduler = _a.scheduler;
	        return scheduler.schedule(TimerObservable.dispatch, dueTime, {
	            index: index, period: period, subscriber: subscriber
	        });
	    };
	    return TimerObservable;
	}(Observable_1.Observable));
	exports.TimerObservable = TimerObservable;
	//# sourceMappingURL=TimerObservable.js.map

/***/ }),
/* 4618 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	var subscribeToResult_1 = __webpack_require__(17);
	var OuterSubscriber_1 = __webpack_require__(16);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var UsingObservable = (function (_super) {
	    __extends(UsingObservable, _super);
	    function UsingObservable(resourceFactory, observableFactory) {
	        _super.call(this);
	        this.resourceFactory = resourceFactory;
	        this.observableFactory = observableFactory;
	    }
	    UsingObservable.create = function (resourceFactory, observableFactory) {
	        return new UsingObservable(resourceFactory, observableFactory);
	    };
	    UsingObservable.prototype._subscribe = function (subscriber) {
	        var _a = this, resourceFactory = _a.resourceFactory, observableFactory = _a.observableFactory;
	        var resource;
	        try {
	            resource = resourceFactory();
	            return new UsingSubscriber(subscriber, resource, observableFactory);
	        }
	        catch (err) {
	            subscriber.error(err);
	        }
	    };
	    return UsingObservable;
	}(Observable_1.Observable));
	exports.UsingObservable = UsingObservable;
	var UsingSubscriber = (function (_super) {
	    __extends(UsingSubscriber, _super);
	    function UsingSubscriber(destination, resource, observableFactory) {
	        _super.call(this, destination);
	        this.resource = resource;
	        this.observableFactory = observableFactory;
	        destination.add(resource);
	        this.tryUse();
	    }
	    UsingSubscriber.prototype.tryUse = function () {
	        try {
	            var source = this.observableFactory.call(this, this.resource);
	            if (source) {
	                this.add(subscribeToResult_1.subscribeToResult(this, source));
	            }
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    return UsingSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=UsingObservable.js.map

/***/ }),
/* 4619 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var BoundCallbackObservable_1 = __webpack_require__(4602);
	exports.bindCallback = BoundCallbackObservable_1.BoundCallbackObservable.create;
	//# sourceMappingURL=bindCallback.js.map

/***/ }),
/* 4620 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var BoundNodeCallbackObservable_1 = __webpack_require__(4603);
	exports.bindNodeCallback = BoundNodeCallbackObservable_1.BoundNodeCallbackObservable.create;
	//# sourceMappingURL=bindNodeCallback.js.map

/***/ }),
/* 4621 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var DeferObservable_1 = __webpack_require__(4604);
	exports.defer = DeferObservable_1.DeferObservable.create;
	//# sourceMappingURL=defer.js.map

/***/ }),
/* 4622 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(30);
	var Subscriber_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(4);
	var Subscription_1 = __webpack_require__(31);
	var root_1 = __webpack_require__(39);
	var ReplaySubject_1 = __webpack_require__(345);
	var tryCatch_1 = __webpack_require__(34);
	var errorObject_1 = __webpack_require__(32);
	var assign_1 = __webpack_require__(4754);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var WebSocketSubject = (function (_super) {
	    __extends(WebSocketSubject, _super);
	    function WebSocketSubject(urlConfigOrSource, destination) {
	        if (urlConfigOrSource instanceof Observable_1.Observable) {
	            _super.call(this, destination, urlConfigOrSource);
	        }
	        else {
	            _super.call(this);
	            this.WebSocketCtor = root_1.root.WebSocket;
	            this._output = new Subject_1.Subject();
	            if (typeof urlConfigOrSource === 'string') {
	                this.url = urlConfigOrSource;
	            }
	            else {
	                // WARNING: config object could override important members here.
	                assign_1.assign(this, urlConfigOrSource);
	            }
	            if (!this.WebSocketCtor) {
	                throw new Error('no WebSocket constructor can be found');
	            }
	            this.destination = new ReplaySubject_1.ReplaySubject();
	        }
	    }
	    WebSocketSubject.prototype.resultSelector = function (e) {
	        return JSON.parse(e.data);
	    };
	    /**
	     * Wrapper around the w3c-compatible WebSocket object provided by the browser.
	     *
	     * @example <caption>Wraps browser WebSocket</caption>
	     *
	     * let socket$ = Observable.webSocket('ws://localhost:8081');
	     *
	     * socket$.subscribe(
	     *    (msg) => console.log('message received: ' + msg),
	     *    (err) => console.log(err),
	     *    () => console.log('complete')
	     *  );
	     *
	     * socket$.next(JSON.stringify({ op: 'hello' }));
	     *
	     * @example <caption>Wraps WebSocket from nodejs-websocket (using node.js)</caption>
	     *
	     * import { w3cwebsocket } from 'websocket';
	     *
	     * let socket$ = Observable.webSocket({
	     *   url: 'ws://localhost:8081',
	     *   WebSocketCtor: w3cwebsocket
	     * });
	     *
	     * socket$.subscribe(
	     *    (msg) => console.log('message received: ' + msg),
	     *    (err) => console.log(err),
	     *    () => console.log('complete')
	     *  );
	     *
	     * socket$.next(JSON.stringify({ op: 'hello' }));
	     *
	     * @param {string | WebSocketSubjectConfig} urlConfigOrSource the source of the websocket as an url or a structure defining the websocket object
	     * @return {WebSocketSubject}
	     * @static true
	     * @name webSocket
	     * @owner Observable
	     */
	    WebSocketSubject.create = function (urlConfigOrSource) {
	        return new WebSocketSubject(urlConfigOrSource);
	    };
	    WebSocketSubject.prototype.lift = function (operator) {
	        var sock = new WebSocketSubject(this, this.destination);
	        sock.operator = operator;
	        return sock;
	    };
	    WebSocketSubject.prototype._resetState = function () {
	        this.socket = null;
	        if (!this.source) {
	            this.destination = new ReplaySubject_1.ReplaySubject();
	        }
	        this._output = new Subject_1.Subject();
	    };
	    // TODO: factor this out to be a proper Operator/Subscriber implementation and eliminate closures
	    WebSocketSubject.prototype.multiplex = function (subMsg, unsubMsg, messageFilter) {
	        var self = this;
	        return new Observable_1.Observable(function (observer) {
	            var result = tryCatch_1.tryCatch(subMsg)();
	            if (result === errorObject_1.errorObject) {
	                observer.error(errorObject_1.errorObject.e);
	            }
	            else {
	                self.next(result);
	            }
	            var subscription = self.subscribe(function (x) {
	                var result = tryCatch_1.tryCatch(messageFilter)(x);
	                if (result === errorObject_1.errorObject) {
	                    observer.error(errorObject_1.errorObject.e);
	                }
	                else if (result) {
	                    observer.next(x);
	                }
	            }, function (err) { return observer.error(err); }, function () { return observer.complete(); });
	            return function () {
	                var result = tryCatch_1.tryCatch(unsubMsg)();
	                if (result === errorObject_1.errorObject) {
	                    observer.error(errorObject_1.errorObject.e);
	                }
	                else {
	                    self.next(result);
	                }
	                subscription.unsubscribe();
	            };
	        });
	    };
	    WebSocketSubject.prototype._connectSocket = function () {
	        var _this = this;
	        var WebSocketCtor = this.WebSocketCtor;
	        var observer = this._output;
	        var socket = null;
	        try {
	            socket = this.protocol ?
	                new WebSocketCtor(this.url, this.protocol) :
	                new WebSocketCtor(this.url);
	            this.socket = socket;
	            if (this.binaryType) {
	                this.socket.binaryType = this.binaryType;
	            }
	        }
	        catch (e) {
	            observer.error(e);
	            return;
	        }
	        var subscription = new Subscription_1.Subscription(function () {
	            _this.socket = null;
	            if (socket && socket.readyState === 1) {
	                socket.close();
	            }
	        });
	        socket.onopen = function (e) {
	            var openObserver = _this.openObserver;
	            if (openObserver) {
	                openObserver.next(e);
	            }
	            var queue = _this.destination;
	            _this.destination = Subscriber_1.Subscriber.create(function (x) { return socket.readyState === 1 && socket.send(x); }, function (e) {
	                var closingObserver = _this.closingObserver;
	                if (closingObserver) {
	                    closingObserver.next(undefined);
	                }
	                if (e && e.code) {
	                    socket.close(e.code, e.reason);
	                }
	                else {
	                    observer.error(new TypeError('WebSocketSubject.error must be called with an object with an error code, ' +
	                        'and an optional reason: { code: number, reason: string }'));
	                }
	                _this._resetState();
	            }, function () {
	                var closingObserver = _this.closingObserver;
	                if (closingObserver) {
	                    closingObserver.next(undefined);
	                }
	                socket.close();
	                _this._resetState();
	            });
	            if (queue && queue instanceof ReplaySubject_1.ReplaySubject) {
	                subscription.add(queue.subscribe(_this.destination));
	            }
	        };
	        socket.onerror = function (e) {
	            _this._resetState();
	            observer.error(e);
	        };
	        socket.onclose = function (e) {
	            _this._resetState();
	            var closeObserver = _this.closeObserver;
	            if (closeObserver) {
	                closeObserver.next(e);
	            }
	            if (e.wasClean) {
	                observer.complete();
	            }
	            else {
	                observer.error(e);
	            }
	        };
	        socket.onmessage = function (e) {
	            var result = tryCatch_1.tryCatch(_this.resultSelector)(e);
	            if (result === errorObject_1.errorObject) {
	                observer.error(errorObject_1.errorObject.e);
	            }
	            else {
	                observer.next(result);
	            }
	        };
	    };
	    WebSocketSubject.prototype._subscribe = function (subscriber) {
	        var _this = this;
	        var source = this.source;
	        if (source) {
	            return source.subscribe(subscriber);
	        }
	        if (!this.socket) {
	            this._connectSocket();
	        }
	        var subscription = new Subscription_1.Subscription();
	        subscription.add(this._output.subscribe(subscriber));
	        subscription.add(function () {
	            var socket = _this.socket;
	            if (_this._output.observers.length === 0) {
	                if (socket && socket.readyState === 1) {
	                    socket.close();
	                }
	                _this._resetState();
	            }
	        });
	        return subscription;
	    };
	    WebSocketSubject.prototype.unsubscribe = function () {
	        var _a = this, source = _a.source, socket = _a.socket;
	        if (socket && socket.readyState === 1) {
	            socket.close();
	            this._resetState();
	        }
	        _super.prototype.unsubscribe.call(this);
	        if (!source) {
	            this.destination = new ReplaySubject_1.ReplaySubject();
	        }
	    };
	    return WebSocketSubject;
	}(Subject_1.AnonymousSubject));
	exports.WebSocketSubject = WebSocketSubject;
	//# sourceMappingURL=WebSocketSubject.js.map

/***/ }),
/* 4623 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var AjaxObservable_1 = __webpack_require__(766);
	exports.ajax = AjaxObservable_1.AjaxObservable.create;
	//# sourceMappingURL=ajax.js.map

/***/ }),
/* 4624 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var WebSocketSubject_1 = __webpack_require__(4622);
	exports.webSocket = WebSocketSubject_1.WebSocketSubject.create;
	//# sourceMappingURL=webSocket.js.map

/***/ }),
/* 4625 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ForkJoinObservable_1 = __webpack_require__(4606);
	exports.forkJoin = ForkJoinObservable_1.ForkJoinObservable.create;
	//# sourceMappingURL=forkJoin.js.map

/***/ }),
/* 4626 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var FromEventObservable_1 = __webpack_require__(4607);
	exports.fromEvent = FromEventObservable_1.FromEventObservable.create;
	//# sourceMappingURL=fromEvent.js.map

/***/ }),
/* 4627 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var FromEventPatternObservable_1 = __webpack_require__(4608);
	exports.fromEventPattern = FromEventPatternObservable_1.FromEventPatternObservable.create;
	//# sourceMappingURL=fromEventPattern.js.map

/***/ }),
/* 4628 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var PromiseObservable_1 = __webpack_require__(764);
	exports.fromPromise = PromiseObservable_1.PromiseObservable.create;
	//# sourceMappingURL=fromPromise.js.map

/***/ }),
/* 4629 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var GenerateObservable_1 = __webpack_require__(4609);
	exports.generate = GenerateObservable_1.GenerateObservable.create;
	//# sourceMappingURL=generate.js.map

/***/ }),
/* 4630 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var IfObservable_1 = __webpack_require__(4610);
	exports._if = IfObservable_1.IfObservable.create;
	//# sourceMappingURL=if.js.map

/***/ }),
/* 4631 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var IntervalObservable_1 = __webpack_require__(4611);
	exports.interval = IntervalObservable_1.IntervalObservable.create;
	//# sourceMappingURL=interval.js.map

/***/ }),
/* 4632 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var NeverObservable_1 = __webpack_require__(4613);
	exports.never = NeverObservable_1.NeverObservable.create;
	//# sourceMappingURL=never.js.map

/***/ }),
/* 4633 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var onErrorResumeNext_1 = __webpack_require__(517);
	exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNextStatic;
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 4634 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var PairsObservable_1 = __webpack_require__(4614);
	exports.pairs = PairsObservable_1.PairsObservable.create;
	//# sourceMappingURL=pairs.js.map

/***/ }),
/* 4635 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var RangeObservable_1 = __webpack_require__(4615);
	exports.range = RangeObservable_1.RangeObservable.create;
	//# sourceMappingURL=range.js.map

/***/ }),
/* 4636 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ErrorObservable_1 = __webpack_require__(4605);
	exports._throw = ErrorObservable_1.ErrorObservable.create;
	//# sourceMappingURL=throw.js.map

/***/ }),
/* 4637 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var UsingObservable_1 = __webpack_require__(4618);
	exports.using = UsingObservable_1.UsingObservable.create;
	//# sourceMappingURL=using.js.map

/***/ }),
/* 4638 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var zip_1 = __webpack_require__(354);
	exports.zip = zip_1.zipStatic;
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 4639 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var audit_1 = __webpack_require__(509);
	/**
	 * Ignores source values for a duration determined by another Observable, then
	 * emits the most recent value from the source Observable, then repeats this
	 * process.
	 *
	 * <span class="informal">It's like {@link auditTime}, but the silencing
	 * duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/audit.png" width="100%">
	 *
	 * `audit` is similar to `throttle`, but emits the last value from the silenced
	 * time window, instead of the first value. `audit` emits the most recent value
	 * from the source Observable on the output Observable as soon as its internal
	 * timer becomes disabled, and ignores source values while the timer is enabled.
	 * Initially, the timer is disabled. As soon as the first source value arrives,
	 * the timer is enabled by calling the `durationSelector` function with the
	 * source value, which returns the "duration" Observable. When the duration
	 * Observable emits a value or completes, the timer is disabled, then the most
	 * recent source value is emitted on the output Observable, and this process
	 * repeats for the next source value.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounce}
	 * @see {@link delayWhen}
	 * @see {@link sample}
	 * @see {@link throttle}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the silencing
	 * duration, returned as an Observable or a Promise.
	 * @return {Observable<T>} An Observable that performs rate-limiting of
	 * emissions from the source Observable.
	 * @method audit
	 * @owner Observable
	 */
	function audit(durationSelector) {
	    return audit_1.audit(durationSelector)(this);
	}
	exports.audit = audit;
	//# sourceMappingURL=audit.js.map

/***/ }),
/* 4640 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(23);
	var auditTime_1 = __webpack_require__(772);
	/**
	 * Ignores source values for `duration` milliseconds, then emits the most recent
	 * value from the source Observable, then repeats this process.
	 *
	 * <span class="informal">When it sees a source values, it ignores that plus
	 * the next ones for `duration` milliseconds, and then it emits the most recent
	 * value from the source.</span>
	 *
	 * <img src="./img/auditTime.png" width="100%">
	 *
	 * `auditTime` is similar to `throttleTime`, but emits the last value from the
	 * silenced time window, instead of the first value. `auditTime` emits the most
	 * recent value from the source Observable on the output Observable as soon as
	 * its internal timer becomes disabled, and ignores source values while the
	 * timer is enabled. Initially, the timer is disabled. As soon as the first
	 * source value arrives, the timer is enabled. After `duration` milliseconds (or
	 * the time unit determined internally by the optional `scheduler`) has passed,
	 * the timer is disabled, then the most recent source value is emitted on the
	 * output Observable, and this process repeats for the next source value.
	 * Optionally takes a {@link IScheduler} for managing timers.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.auditTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttleTime}
	 *
	 * @param {number} duration Time to wait before emitting the most recent source
	 * value, measured in milliseconds or the time unit determined internally
	 * by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the rate-limiting behavior.
	 * @return {Observable<T>} An Observable that performs rate-limiting of
	 * emissions from the source Observable.
	 * @method auditTime
	 * @owner Observable
	 */
	function auditTime(duration, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return auditTime_1.auditTime(duration, scheduler)(this);
	}
	exports.auditTime = auditTime;
	//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 4641 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var buffer_1 = __webpack_require__(773);
	/**
	 * Buffers the source Observable values until `closingNotifier` emits.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * that array only when another Observable emits.</span>
	 *
	 * <img src="./img/buffer.png" width="100%">
	 *
	 * Buffers the incoming Observable values until the given `closingNotifier`
	 * Observable emits a value, at which point it emits the buffer on the output
	 * Observable and starts a new buffer internally, awaiting the next time
	 * `closingNotifier` emits.
	 *
	 * @example <caption>On every click, emit array of most recent interval events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var interval = Rx.Observable.interval(1000);
	 * var buffered = interval.buffer(clicks);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link window}
	 *
	 * @param {Observable<any>} closingNotifier An Observable that signals the
	 * buffer to be emitted on the output Observable.
	 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
	 * values.
	 * @method buffer
	 * @owner Observable
	 */
	function buffer(closingNotifier) {
	    return buffer_1.buffer(closingNotifier)(this);
	}
	exports.buffer = buffer;
	//# sourceMappingURL=buffer.js.map

/***/ }),
/* 4642 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var bufferCount_1 = __webpack_require__(774);
	/**
	 * Buffers the source Observable values until the size hits the maximum
	 * `bufferSize` given.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * that array only when its size reaches `bufferSize`.</span>
	 *
	 * <img src="./img/bufferCount.png" width="100%">
	 *
	 * Buffers a number of values from the source Observable by `bufferSize` then
	 * emits the buffer and clears it, and starts a new buffer each
	 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
	 * `null`, then new buffers are started immediately at the start of the source
	 * and when each buffer closes and is emitted.
	 *
	 * @example <caption>Emit the last two click events as an array</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferCount(2);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @example <caption>On every click, emit the last two click events as an array</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferCount(2, 1);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link pairwise}
	 * @see {@link windowCount}
	 *
	 * @param {number} bufferSize The maximum size of the buffer emitted.
	 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
	 * For example if `startBufferEvery` is `2`, then a new buffer will be started
	 * on every other value from the source. A new buffer is started at the
	 * beginning of the source by default.
	 * @return {Observable<T[]>} An Observable of arrays of buffered values.
	 * @method bufferCount
	 * @owner Observable
	 */
	function bufferCount(bufferSize, startBufferEvery) {
	    if (startBufferEvery === void 0) { startBufferEvery = null; }
	    return bufferCount_1.bufferCount(bufferSize, startBufferEvery)(this);
	}
	exports.bufferCount = bufferCount;
	//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 4643 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(23);
	var isScheduler_1 = __webpack_require__(65);
	var bufferTime_1 = __webpack_require__(775);
	/* tslint:enable:max-line-length */
	/**
	 * Buffers the source Observable values for a specific time period.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * those arrays periodically in time.</span>
	 *
	 * <img src="./img/bufferTime.png" width="100%">
	 *
	 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
	 * Unless the optional argument `bufferCreationInterval` is given, it emits and
	 * resets the buffer every `bufferTimeSpan` milliseconds. If
	 * `bufferCreationInterval` is given, this operator opens the buffer every
	 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
	 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
	 * `maxBufferSize` is specified, the buffer will be closed either after
	 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
	 *
	 * @example <caption>Every second, emit an array of the recent click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferTime(1000);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferTime(2000, 5000);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link windowTime}
	 *
	 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
	 * @param {number} [bufferCreationInterval] The interval at which to start new
	 * buffers.
	 * @param {number} [maxBufferSize] The maximum buffer size.
	 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
	 * intervals that determine buffer boundaries.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferTime
	 * @owner Observable
	 */
	function bufferTime(bufferTimeSpan) {
	    var length = arguments.length;
	    var scheduler = async_1.async;
	    if (isScheduler_1.isScheduler(arguments[arguments.length - 1])) {
	        scheduler = arguments[arguments.length - 1];
	        length--;
	    }
	    var bufferCreationInterval = null;
	    if (length >= 2) {
	        bufferCreationInterval = arguments[1];
	    }
	    var maxBufferSize = Number.POSITIVE_INFINITY;
	    if (length >= 3) {
	        maxBufferSize = arguments[2];
	    }
	    return bufferTime_1.bufferTime(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler)(this);
	}
	exports.bufferTime = bufferTime;
	//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 4644 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var bufferToggle_1 = __webpack_require__(776);
	/**
	 * Buffers the source Observable values starting from an emission from
	 * `openings` and ending when the output of `closingSelector` emits.
	 *
	 * <span class="informal">Collects values from the past as an array. Starts
	 * collecting only when `opening` emits, and calls the `closingSelector`
	 * function to get an Observable that tells when to close the buffer.</span>
	 *
	 * <img src="./img/bufferToggle.png" width="100%">
	 *
	 * Buffers values from the source by opening the buffer via signals from an
	 * Observable provided to `openings`, and closing and sending the buffers when
	 * a Subscribable or Promise returned by the `closingSelector` function emits.
	 *
	 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var openings = Rx.Observable.interval(1000);
	 * var buffered = clicks.bufferToggle(openings, i =>
	 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
	 * );
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferWhen}
	 * @see {@link windowToggle}
	 *
	 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
	 * buffers.
	 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
	 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
	 * which, when it emits, signals that the associated buffer should be emitted
	 * and cleared.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferToggle
	 * @owner Observable
	 */
	function bufferToggle(openings, closingSelector) {
	    return bufferToggle_1.bufferToggle(openings, closingSelector)(this);
	}
	exports.bufferToggle = bufferToggle;
	//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 4645 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var bufferWhen_1 = __webpack_require__(777);
	/**
	 * Buffers the source Observable values, using a factory function of closing
	 * Observables to determine when to close, emit, and reset the buffer.
	 *
	 * <span class="informal">Collects values from the past as an array. When it
	 * starts collecting values, it calls a function that returns an Observable that
	 * tells when to close the buffer and restart collecting.</span>
	 *
	 * <img src="./img/bufferWhen.png" width="100%">
	 *
	 * Opens a buffer immediately, then closes the buffer when the observable
	 * returned by calling `closingSelector` function emits a value. When it closes
	 * the buffer, it immediately opens a new buffer and repeats the process.
	 *
	 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferWhen(() =>
	 *   Rx.Observable.interval(1000 + Math.random() * 4000)
	 * );
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link windowWhen}
	 *
	 * @param {function(): Observable} closingSelector A function that takes no
	 * arguments and returns an Observable that signals buffer closure.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferWhen
	 * @owner Observable
	 */
	function bufferWhen(closingSelector) {
	    return bufferWhen_1.bufferWhen(closingSelector)(this);
	}
	exports.bufferWhen = bufferWhen;
	//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 4646 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var catchError_1 = __webpack_require__(778);
	/**
	 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
	 *
	 * <img src="./img/catch.png" width="100%">
	 *
	 * @example <caption>Continues with a different Observable when there's an error</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 * 	   if (n == 4) {
	 * 	     throw 'four!';
	 *     }
	 *	   return n;
	 *   })
	 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
	 *   .subscribe(x => console.log(x));
	 *   // 1, 2, 3, I, II, III, IV, V
	 *
	 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 * 	   if (n === 4) {
	 * 	     throw 'four!';
	 *     }
	 * 	   return n;
	 *   })
	 *   .catch((err, caught) => caught)
	 *   .take(30)
	 *   .subscribe(x => console.log(x));
	 *   // 1, 2, 3, 1, 2, 3, ...
	 *
	 * @example <caption>Throws a new error when the source Observable throws an error</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 *     if (n == 4) {
	 *       throw 'four!';
	 *     }
	 *     return n;
	 *   })
	 *   .catch(err => {
	 *     throw 'error in source. Details: ' + err;
	 *   })
	 *   .subscribe(
	 *     x => console.log(x),
	 *     err => console.log(err)
	 *   );
	 *   // 1, 2, 3, error in source. Details: four!
	 *
	 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
	 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
	 *  is returned by the `selector` will be used to continue the observable chain.
	 * @return {Observable} An observable that originates from either the source or the observable returned by the
	 *  catch `selector` function.
	 * @method catch
	 * @name catch
	 * @owner Observable
	 */
	function _catch(selector) {
	    return catchError_1.catchError(selector)(this);
	}
	exports._catch = _catch;
	//# sourceMappingURL=catch.js.map

/***/ }),
/* 4647 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var combineAll_1 = __webpack_require__(779);
	/**
	 * Converts a higher-order Observable into a first-order Observable by waiting
	 * for the outer Observable to complete, then applying {@link combineLatest}.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by applying
	 * {@link combineLatest} when the Observable-of-Observables completes.</span>
	 *
	 * <img src="./img/combineAll.png" width="100%">
	 *
	 * Takes an Observable of Observables, and collects all Observables from it.
	 * Once the outer Observable completes, it subscribes to all collected
	 * Observables and combines their values using the {@link combineLatest}
	 * strategy, such that:
	 * - Every time an inner Observable emits, the output Observable emits.
	 * - When the returned observable emits, it emits all of the latest values by:
	 *   - If a `project` function is provided, it is called with each recent value
	 *     from each inner Observable in whatever order they arrived, and the result
	 *     of the `project` function is what is emitted by the output Observable.
	 *   - If there is no `project` function, an array of all of the most recent
	 *     values is emitted by the output Observable.
	 *
	 * @example <caption>Map two click events to a finite interval Observable, then apply combineAll</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map(ev =>
	 *   Rx.Observable.interval(Math.random()*2000).take(3)
	 * ).take(2);
	 * var result = higherOrder.combineAll();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineLatest}
	 * @see {@link mergeAll}
	 *
	 * @param {function} [project] An optional function to map the most recent
	 * values from each inner Observable into a new result. Takes each of the most
	 * recent values from each collected inner Observable as arguments, in order.
	 * @return {Observable} An Observable of projected results or arrays of recent
	 * values.
	 * @method combineAll
	 * @owner Observable
	 */
	function combineAll(project) {
	    return combineAll_1.combineAll(project)(this);
	}
	exports.combineAll = combineAll;
	//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 4648 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var combineLatest_1 = __webpack_require__(347);
	/* tslint:enable:max-line-length */
	/**
	 * Combines multiple Observables to create an Observable whose values are
	 * calculated from the latest values of each of its input Observables.
	 *
	 * <span class="informal">Whenever any input Observable emits a value, it
	 * computes a formula using the latest values from all the inputs, then emits
	 * the output of that formula.</span>
	 *
	 * <img src="./img/combineLatest.png" width="100%">
	 *
	 * `combineLatest` combines the values from this Observable with values from
	 * Observables passed as arguments. This is done by subscribing to each
	 * Observable, in order, and collecting an array of each of the most recent
	 * values any time any of the input Observables emits, then either taking that
	 * array and passing it as arguments to an optional `project` function and
	 * emitting the return value of that, or just emitting the array of recent
	 * values directly if there is no `project` function.
	 *
	 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
	 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
	 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
	 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
	 * bmi.subscribe(x => console.log('BMI is ' + x));
	 *
	 * // With output to console:
	 * // BMI is 24.212293388429753
	 * // BMI is 23.93948099205209
	 * // BMI is 23.671253629592222
	 *
	 * @see {@link combineAll}
	 * @see {@link merge}
	 * @see {@link withLatestFrom}
	 *
	 * @param {ObservableInput} other An input Observable to combine with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {function} [project] An optional function to project the values from
	 * the combined latest values into a new value on the output Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @method combineLatest
	 * @owner Observable
	 */
	function combineLatest() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return combineLatest_1.combineLatest.apply(void 0, observables)(this);
	}
	exports.combineLatest = combineLatest;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 4649 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concat_1 = __webpack_require__(780);
	var concat_2 = __webpack_require__(265);
	exports.concatStatic = concat_2.concat;
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which sequentially emits all values from every
	 * given input Observable after the current Observable.
	 *
	 * <span class="informal">Concatenates multiple Observables together by
	 * sequentially emitting their values, one Observable after the other.</span>
	 *
	 * <img src="./img/concat.png" width="100%">
	 *
	 * Joins this Observable with multiple other Observables by subscribing to them
	 * one at a time, starting with the source, and merging their results into the
	 * output Observable. Will wait for each Observable to complete before moving
	 * on to the next.
	 *
	 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
	 * var timer = Rx.Observable.interval(1000).take(4);
	 * var sequence = Rx.Observable.range(1, 10);
	 * var result = timer.concat(sequence);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in:
	 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
	 *
	 * @example <caption>Concatenate 3 Observables</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var result = timer1.concat(timer2, timer3);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in the following:
	 * // (Prints to console sequentially)
	 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
	 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
	 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
	 *
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 *
	 * @param {ObservableInput} other An input Observable to concatenate after the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
	 * Observable subscription on.
	 * @return {Observable} All values of each passed Observable merged into a
	 * single Observable, in order, in serial fashion.
	 * @method concat
	 * @owner Observable
	 */
	function concat() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return concat_1.concat.apply(void 0, observables)(this);
	}
	exports.concat = concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 4650 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concatAll_1 = __webpack_require__(510);
	/* tslint:enable:max-line-length */
	/**
	 * Converts a higher-order Observable into a first-order Observable by
	 * concatenating the inner Observables in order.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by putting one
	 * inner Observable after the other.</span>
	 *
	 * <img src="./img/concatAll.png" width="100%">
	 *
	 * Joins every Observable emitted by the source (a higher-order Observable), in
	 * a serial fashion. It subscribes to each inner Observable only after the
	 * previous inner Observable has completed, and merges all of their values into
	 * the returned observable.
	 *
	 * __Warning:__ If the source Observable emits Observables quickly and
	 * endlessly, and the inner Observables it emits generally complete slower than
	 * the source emits, you can run into memory issues as the incoming Observables
	 * collect in an unbounded buffer.
	 *
	 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
	 * to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
	 * var firstOrder = higherOrder.concatAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link combineAll}
	 * @see {@link concat}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 * @see {@link exhaust}
	 * @see {@link mergeAll}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @return {Observable} An Observable emitting values from all the inner
	 * Observables concatenated.
	 * @method concatAll
	 * @owner Observable
	 */
	function concatAll() {
	    return concatAll_1.concatAll()(this);
	}
	exports.concatAll = concatAll;
	//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 4651 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concatMap_1 = __webpack_require__(511);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable, in a serialized fashion waiting for each one to complete before
	 * merging the next.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link concatAll}.</span>
	 *
	 * <img src="./img/concatMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. Each new inner Observable is
	 * concatenated with the previous inner Observable.
	 *
	 * __Warning:__ if source values arrive endlessly and faster than their
	 * corresponding inner Observables can complete, it will result in memory issues
	 * as inner Observables amass in an unbounded buffer waiting for their turn to
	 * be subscribed to.
	 *
	 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
	 * to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link concat}
	 * @see {@link concatAll}
	 * @see {@link concatMapTo}
	 * @see {@link exhaustMap}
	 * @see {@link mergeMap}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and taking values from each projected inner
	 * Observable sequentially.
	 * @method concatMap
	 * @owner Observable
	 */
	function concatMap(project, resultSelector) {
	    return concatMap_1.concatMap(project, resultSelector)(this);
	}
	exports.concatMap = concatMap;
	//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 4652 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concatMapTo_1 = __webpack_require__(781);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is merged multiple
	 * times in a serialized fashion on the output Observable.
	 *
	 * <span class="informal">It's like {@link concatMap}, but maps each value
	 * always to the same inner Observable.</span>
	 *
	 * <img src="./img/concatMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then flattens those resulting Observables into one
	 * single Observable, which is the output Observable. Each new `innerObservable`
	 * instance emitted on the output Observable is concatenated with the previous
	 * `innerObservable` instance.
	 *
	 * __Warning:__ if source values arrive endlessly and faster than their
	 * corresponding inner Observables can complete, it will result in memory issues
	 * as inner Observables amass in an unbounded buffer waiting for their turn to
	 * be subscribed to.
	 *
	 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
	 * set to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link concat}
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link mergeMapTo}
	 * @see {@link switchMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An observable of values merged together by joining the
	 * passed observable with itself, one after the other, for each value emitted
	 * from the source.
	 * @method concatMapTo
	 * @owner Observable
	 */
	function concatMapTo(innerObservable, resultSelector) {
	    return concatMapTo_1.concatMapTo(innerObservable, resultSelector)(this);
	}
	exports.concatMapTo = concatMapTo;
	//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 4653 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var count_1 = __webpack_require__(782);
	/**
	 * Counts the number of emissions on the source and emits that number when the
	 * source completes.
	 *
	 * <span class="informal">Tells how many values were emitted, when the source
	 * completes.</span>
	 *
	 * <img src="./img/count.png" width="100%">
	 *
	 * `count` transforms an Observable that emits values into an Observable that
	 * emits a single value that represents the number of values emitted by the
	 * source Observable. If the source Observable terminates with an error, `count`
	 * will pass this error notification along without emitting a value first. If
	 * the source Observable does not terminate at all, `count` will neither emit
	 * a value nor terminate. This operator takes an optional `predicate` function
	 * as argument, in which case the output emission will represent the number of
	 * source values that matched `true` with the `predicate`.
	 *
	 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
	 * var seconds = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var secondsBeforeClick = seconds.takeUntil(clicks);
	 * var result = secondsBeforeClick.count();
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
	 * var numbers = Rx.Observable.range(1, 7);
	 * var result = numbers.count(i => i % 2 === 1);
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // 4
	 *
	 * @see {@link max}
	 * @see {@link min}
	 * @see {@link reduce}
	 *
	 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
	 * boolean function to select what values are to be counted. It is provided with
	 * arguments of:
	 * - `value`: the value from the source Observable.
	 * - `index`: the (zero-based) "index" of the value from the source Observable.
	 * - `source`: the source Observable instance itself.
	 * @return {Observable} An Observable of one number that represents the count as
	 * described above.
	 * @method count
	 * @owner Observable
	 */
	function count(predicate) {
	    return count_1.count(predicate)(this);
	}
	exports.count = count;
	//# sourceMappingURL=count.js.map

/***/ }),
/* 4654 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var debounce_1 = __webpack_require__(783);
	/**
	 * Emits a value from the source Observable only after a particular time span
	 * determined by another Observable has passed without another source emission.
	 *
	 * <span class="informal">It's like {@link debounceTime}, but the time span of
	 * emission silence is determined by a second Observable.</span>
	 *
	 * <img src="./img/debounce.png" width="100%">
	 *
	 * `debounce` delays values emitted by the source Observable, but drops previous
	 * pending delayed emissions if a new value arrives on the source Observable.
	 * This operator keeps track of the most recent value from the source
	 * Observable, and spawns a duration Observable by calling the
	 * `durationSelector` function. The value is emitted only when the duration
	 * Observable emits a value or completes, and if no other value was emitted on
	 * the source Observable since the duration Observable was spawned. If a new
	 * value appears before the duration Observable emits, the previous value will
	 * be dropped and will not be emitted on the output Observable.
	 *
	 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
	 * delay-like operator since output emissions do not necessarily occur at the
	 * same time as they did on the source Observable.
	 *
	 * @example <caption>Emit the most recent click after a burst of clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounceTime}
	 * @see {@link delayWhen}
	 * @see {@link throttle}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the timeout
	 * duration for each source value, returned as an Observable or a Promise.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified duration Observable returned by
	 * `durationSelector`, and may drop some values if they occur too frequently.
	 * @method debounce
	 * @owner Observable
	 */
	function debounce(durationSelector) {
	    return debounce_1.debounce(durationSelector)(this);
	}
	exports.debounce = debounce;
	//# sourceMappingURL=debounce.js.map

/***/ }),
/* 4655 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(23);
	var debounceTime_1 = __webpack_require__(784);
	/**
	 * Emits a value from the source Observable only after a particular time span
	 * has passed without another source emission.
	 *
	 * <span class="informal">It's like {@link delay}, but passes only the most
	 * recent value from each burst of emissions.</span>
	 *
	 * <img src="./img/debounceTime.png" width="100%">
	 *
	 * `debounceTime` delays values emitted by the source Observable, but drops
	 * previous pending delayed emissions if a new value arrives on the source
	 * Observable. This operator keeps track of the most recent value from the
	 * source Observable, and emits that only when `dueTime` enough time has passed
	 * without any other value appearing on the source Observable. If a new value
	 * appears before `dueTime` silence occurs, the previous value will be dropped
	 * and will not be emitted on the output Observable.
	 *
	 * This is a rate-limiting operator, because it is impossible for more than one
	 * value to be emitted in any time window of duration `dueTime`, but it is also
	 * a delay-like operator since output emissions do not occur at the same time as
	 * they did on the source Observable. Optionally takes a {@link IScheduler} for
	 * managing timers.
	 *
	 * @example <caption>Emit the most recent click after a burst of clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.debounceTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounce}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttleTime}
	 *
	 * @param {number} dueTime The timeout duration in milliseconds (or the time
	 * unit determined internally by the optional `scheduler`) for the window of
	 * time required to wait for emission silence before emitting the most recent
	 * source value.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the timeout for each value.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified `dueTime`, and may drop some values if they occur
	 * too frequently.
	 * @method debounceTime
	 * @owner Observable
	 */
	function debounceTime(dueTime, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return debounceTime_1.debounceTime(dueTime, scheduler)(this);
	}
	exports.debounceTime = debounceTime;
	//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 4656 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var defaultIfEmpty_1 = __webpack_require__(512);
	/* tslint:enable:max-line-length */
	/**
	 * Emits a given value if the source Observable completes without emitting any
	 * `next` value, otherwise mirrors the source Observable.
	 *
	 * <span class="informal">If the source Observable turns out to be empty, then
	 * this operator will emit a default value.</span>
	 *
	 * <img src="./img/defaultIfEmpty.png" width="100%">
	 *
	 * `defaultIfEmpty` emits the values emitted by the source Observable or a
	 * specified default value if the source Observable is empty (completes without
	 * having emitted any `next` value).
	 *
	 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
	 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link empty}
	 * @see {@link last}
	 *
	 * @param {any} [defaultValue=null] The default value used if the source
	 * Observable is empty.
	 * @return {Observable} An Observable that emits either the specified
	 * `defaultValue` if the source Observable emits no items, or the values emitted
	 * by the source Observable.
	 * @method defaultIfEmpty
	 * @owner Observable
	 */
	function defaultIfEmpty(defaultValue) {
	    if (defaultValue === void 0) { defaultValue = null; }
	    return defaultIfEmpty_1.defaultIfEmpty(defaultValue)(this);
	}
	exports.defaultIfEmpty = defaultIfEmpty;
	//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 4657 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(23);
	var delay_1 = __webpack_require__(785);
	/**
	 * Delays the emission of items from the source Observable by a given timeout or
	 * until a given Date.
	 *
	 * <span class="informal">Time shifts each item by some specified amount of
	 * milliseconds.</span>
	 *
	 * <img src="./img/delay.png" width="100%">
	 *
	 * If the delay argument is a Number, this operator time shifts the source
	 * Observable by that amount of time expressed in milliseconds. The relative
	 * time intervals between the values are preserved.
	 *
	 * If the delay argument is a Date, this operator time shifts the start of the
	 * Observable execution until the given date occurs.
	 *
	 * @example <caption>Delay each click by one second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @example <caption>Delay all clicks until a future date happens</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var date = new Date('March 15, 2050 12:00:00'); // in the future
	 * var delayedClicks = clicks.delay(date); // click emitted only after that date
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @see {@link debounceTime}
	 * @see {@link delayWhen}
	 *
	 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
	 * a `Date` until which the emission of the source items is delayed.
	 * @param {Scheduler} [scheduler=async] The IScheduler to use for
	 * managing the timers that handle the time-shift for each item.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified timeout or Date.
	 * @method delay
	 * @owner Observable
	 */
	function delay(delay, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return delay_1.delay(delay, scheduler)(this);
	}
	exports.delay = delay;
	//# sourceMappingURL=delay.js.map

/***/ }),
/* 4658 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var delayWhen_1 = __webpack_require__(786);
	/**
	 * Delays the emission of items from the source Observable by a given time span
	 * determined by the emissions of another Observable.
	 *
	 * <span class="informal">It's like {@link delay}, but the time span of the
	 * delay duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/delayWhen.png" width="100%">
	 *
	 * `delayWhen` time shifts each emitted value from the source Observable by a
	 * time span determined by another Observable. When the source emits a value,
	 * the `delayDurationSelector` function is called with the source value as
	 * argument, and should return an Observable, called the "duration" Observable.
	 * The source value is emitted on the output Observable only when the duration
	 * Observable emits a value or completes.
	 *
	 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
	 * is an Observable. When `subscriptionDelay` emits its first value or
	 * completes, the source Observable is subscribed to and starts behaving like
	 * described in the previous paragraph. If `subscriptionDelay` is not provided,
	 * `delayWhen` will subscribe to the source Observable as soon as the output
	 * Observable is subscribed.
	 *
	 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var delayedClicks = clicks.delayWhen(event =>
	 *   Rx.Observable.interval(Math.random() * 5000)
	 * );
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @see {@link debounce}
	 * @see {@link delay}
	 *
	 * @param {function(value: T): Observable} delayDurationSelector A function that
	 * returns an Observable for each value emitted by the source Observable, which
	 * is then used to delay the emission of that item on the output Observable
	 * until the Observable returned from this function emits a value.
	 * @param {Observable} subscriptionDelay An Observable that triggers the
	 * subscription to the source Observable once it emits any value.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by an amount of time specified by the Observable returned by
	 * `delayDurationSelector`.
	 * @method delayWhen
	 * @owner Observable
	 */
	function delayWhen(delayDurationSelector, subscriptionDelay) {
	    return delayWhen_1.delayWhen(delayDurationSelector, subscriptionDelay)(this);
	}
	exports.delayWhen = delayWhen;
	//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 4659 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var dematerialize_1 = __webpack_require__(787);
	/**
	 * Converts an Observable of {@link Notification} objects into the emissions
	 * that they represent.
	 *
	 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
	 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
	 *
	 * <img src="./img/dematerialize.png" width="100%">
	 *
	 * `dematerialize` is assumed to operate an Observable that only emits
	 * {@link Notification} objects as `next` emissions, and does not emit any
	 * `error`. Such Observable is the output of a `materialize` operation. Those
	 * notifications are then unwrapped using the metadata they contain, and emitted
	 * as `next`, `error`, and `complete` on the output Observable.
	 *
	 * Use this operator in conjunction with {@link materialize}.
	 *
	 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
	 * var notifA = new Rx.Notification('N', 'A');
	 * var notifB = new Rx.Notification('N', 'B');
	 * var notifE = new Rx.Notification('E', void 0,
	 *   new TypeError('x.toUpperCase is not a function')
	 * );
	 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
	 * var upperCase = materialized.dematerialize();
	 * upperCase.subscribe(x => console.log(x), e => console.error(e));
	 *
	 * // Results in:
	 * // A
	 * // B
	 * // TypeError: x.toUpperCase is not a function
	 *
	 * @see {@link Notification}
	 * @see {@link materialize}
	 *
	 * @return {Observable} An Observable that emits items and notifications
	 * embedded in Notification objects emitted by the source Observable.
	 * @method dematerialize
	 * @owner Observable
	 */
	function dematerialize() {
	    return dematerialize_1.dematerialize()(this);
	}
	exports.dematerialize = dematerialize;
	//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 4660 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var distinct_1 = __webpack_require__(788);
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
	 *
	 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
	 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
	 * source observable directly with an equality check against previous values.
	 *
	 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
	 *
	 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
	 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
	 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
	 * that the internal `Set` can be "flushed", basically clearing it of values.
	 *
	 * @example <caption>A simple example with numbers</caption>
	 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
	 *   .distinct()
	 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
	 *
	 * @example <caption>An example using a keySelector function</caption>
	 * interface Person {
	 *    age: number,
	 *    name: string
	 * }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'})
	 *     .distinct((p: Person) => p.name)
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 *
	 * @see {@link distinctUntilChanged}
	 * @see {@link distinctUntilKeyChanged}
	 *
	 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
	 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
	 * @method distinct
	 * @owner Observable
	 */
	function distinct(keySelector, flushes) {
	    return distinct_1.distinct(keySelector, flushes)(this);
	}
	exports.distinct = distinct;
	//# sourceMappingURL=distinct.js.map

/***/ }),
/* 4661 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var distinctUntilChanged_1 = __webpack_require__(513);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
	 *
	 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
	 *
	 * If a comparator function is not provided, an equality check is used by default.
	 *
	 * @example <caption>A simple example with numbers</caption>
	 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
	 *   .distinctUntilChanged()
	 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
	 *
	 * @example <caption>An example using a compare function</caption>
	 * interface Person {
	 *    age: number,
	 *    name: string
	 * }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'})
	 *     { age: 6, name: 'Foo'})
	 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo' }
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilKeyChanged}
	 *
	 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
	 * @method distinctUntilChanged
	 * @owner Observable
	 */
	function distinctUntilChanged(compare, keySelector) {
	    return distinctUntilChanged_1.distinctUntilChanged(compare, keySelector)(this);
	}
	exports.distinctUntilChanged = distinctUntilChanged;
	//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 4662 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var distinctUntilKeyChanged_1 = __webpack_require__(789);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
	 * using a property accessed by using the key provided to check if the two items are distinct.
	 *
	 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
	 *
	 * If a comparator function is not provided, an equality check is used by default.
	 *
	 * @example <caption>An example comparing the name of persons</caption>
	 *
	 *  interface Person {
	 *     age: number,
	 *     name: string
	 *  }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'},
	 *     { age: 6, name: 'Foo'})
	 *     .distinctUntilKeyChanged('name')
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo' }
	 *
	 * @example <caption>An example comparing the first letters of the name</caption>
	 *
	 * interface Person {
	 *     age: number,
	 *     name: string
	 *  }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo1'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo2'},
	 *     { age: 6, name: 'Foo3'})
	 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo1' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo2' }
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilChanged}
	 *
	 * @param {string} key String key for object property lookup on each item.
	 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
	 * @method distinctUntilKeyChanged
	 * @owner Observable
	 */
	function distinctUntilKeyChanged(key, compare) {
	    return distinctUntilKeyChanged_1.distinctUntilKeyChanged(key, compare)(this);
	}
	exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
	//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 4663 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var tap_1 = __webpack_require__(352);
	/* tslint:enable:max-line-length */
	/**
	 * Perform a side effect for every emission on the source Observable, but return
	 * an Observable that is identical to the source.
	 *
	 * <span class="informal">Intercepts each emission on the source and runs a
	 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
	 *
	 * <img src="./img/do.png" width="100%">
	 *
	 * Returns a mirrored Observable of the source Observable, but modified so that
	 * the provided Observer is called to perform a side effect for every value,
	 * error, and completion emitted by the source. Any errors that are thrown in
	 * the aforementioned Observer or handlers are safely sent down the error path
	 * of the output Observable.
	 *
	 * This operator is useful for debugging your Observables for the correct values
	 * or performing other side effects.
	 *
	 * Note: this is different to a `subscribe` on the Observable. If the Observable
	 * returned by `do` is not subscribed, the side effects specified by the
	 * Observer will never happen. `do` therefore simply spies on existing
	 * execution, it does not trigger an execution to happen like `subscribe` does.
	 *
	 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks
	 *   .do(ev => console.log(ev))
	 *   .map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 * @see {@link subscribe}
	 *
	 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
	 * callback for `next`.
	 * @param {function} [error] Callback for errors in the source.
	 * @param {function} [complete] Callback for the completion of the source.
	 * @return {Observable} An Observable identical to the source, but runs the
	 * specified Observer or callback(s) for each item.
	 * @method do
	 * @name do
	 * @owner Observable
	 */
	function _do(nextOrObserver, error, complete) {
	    return tap_1.tap(nextOrObserver, error, complete)(this);
	}
	exports._do = _do;
	//# sourceMappingURL=do.js.map

/***/ }),
/* 4664 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var elementAt_1 = __webpack_require__(790);
	/**
	 * Emits the single value at the specified `index` in a sequence of emissions
	 * from the source Observable.
	 *
	 * <span class="informal">Emits only the i-th value, then completes.</span>
	 *
	 * <img src="./img/elementAt.png" width="100%">
	 *
	 * `elementAt` returns an Observable that emits the item at the specified
	 * `index` in the source Observable, or a default value if that `index` is out
	 * of range and the `default` argument is provided. If the `default` argument is
	 * not given and the `index` is out of range, the output Observable will emit an
	 * `ArgumentOutOfRangeError` error.
	 *
	 * @example <caption>Emit only the third click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.elementAt(2);
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // click 1 = nothing
	 * // click 2 = nothing
	 * // click 3 = MouseEvent object logged to console
	 *
	 * @see {@link first}
	 * @see {@link last}
	 * @see {@link skip}
	 * @see {@link single}
	 * @see {@link take}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
	 * Observable has completed before emitting the i-th `next` notification.
	 *
	 * @param {number} index Is the number `i` for the i-th source emission that has
	 * happened since the subscription, starting from the number `0`.
	 * @param {T} [defaultValue] The default value returned for missing indices.
	 * @return {Observable} An Observable that emits a single item, if it is found.
	 * Otherwise, will emit the default value if given. If not, then emits an error.
	 * @method elementAt
	 * @owner Observable
	 */
	function elementAt(index, defaultValue) {
	    return elementAt_1.elementAt(index, defaultValue)(this);
	}
	exports.elementAt = elementAt;
	//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 4665 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var every_1 = __webpack_require__(791);
	/**
	 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
	 *
	 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
	 *  Observable.of(1, 2, 3, 4, 5, 6)
	 *     .every(x => x < 5)
	 *     .subscribe(x => console.log(x)); // -> false
	 *
	 * @param {function} predicate A function for determining if an item meets a specified condition.
	 * @param {any} [thisArg] Optional object to use for `this` in the callback.
	 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
	 * @method every
	 * @owner Observable
	 */
	function every(predicate, thisArg) {
	    return every_1.every(predicate, thisArg)(this);
	}
	exports.every = every;
	//# sourceMappingURL=every.js.map

/***/ }),
/* 4666 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var exhaust_1 = __webpack_require__(792);
	/**
	 * Converts a higher-order Observable into a first-order Observable by dropping
	 * inner Observables while the previous inner Observable has not yet completed.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by dropping the
	 * next inner Observables while the current inner is still executing.</span>
	 *
	 * <img src="./img/exhaust.png" width="100%">
	 *
	 * `exhaust` subscribes to an Observable that emits Observables, also known as a
	 * higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, the output Observable begins emitting the items emitted by that
	 * inner Observable. So far, it behaves like {@link mergeAll}. However,
	 * `exhaust` ignores every new inner Observable if the previous Observable has
	 * not yet completed. Once that one completes, it will accept and flatten the
	 * next inner Observable and repeat this process.
	 *
	 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
	 * var result = higherOrder.exhaust();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link switch}
	 * @see {@link mergeAll}
	 * @see {@link exhaustMap}
	 * @see {@link zipAll}
	 *
	 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
	 * exclusively until it completes before subscribing to the next.
	 * @method exhaust
	 * @owner Observable
	 */
	function exhaust() {
	    return exhaust_1.exhaust()(this);
	}
	exports.exhaust = exhaust;
	//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 4667 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var exhaustMap_1 = __webpack_require__(793);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable only if the previous projected Observable has completed.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link exhaust}.</span>
	 *
	 * <img src="./img/exhaustMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. When it projects a source value to
	 * an Observable, the output Observable begins emitting the items emitted by
	 * that projected Observable. However, `exhaustMap` ignores every new projected
	 * Observable if the previous projected Observable has not yet completed. Once
	 * that one completes, it will accept and flatten the next projected Observable
	 * and repeat this process.
	 *
	 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaust}
	 * @see {@link mergeMap}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable containing projected Observables
	 * of each item of the source, ignoring projected Observables that start before
	 * their preceding Observable has completed.
	 * @method exhaustMap
	 * @owner Observable
	 */
	function exhaustMap(project, resultSelector) {
	    return exhaustMap_1.exhaustMap(project, resultSelector)(this);
	}
	exports.exhaustMap = exhaustMap;
	//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 4668 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var expand_1 = __webpack_require__(794);
	/* tslint:enable:max-line-length */
	/**
	 * Recursively projects each source value to an Observable which is merged in
	 * the output Observable.
	 *
	 * <span class="informal">It's similar to {@link mergeMap}, but applies the
	 * projection function to every source value as well as every output value.
	 * It's recursive.</span>
	 *
	 * <img src="./img/expand.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an Observable, and then merging those resulting Observables and
	 * emitting the results of this merger. *Expand* will re-emit on the output
	 * Observable every source value. Then, each output value is given to the
	 * `project` function which returns an inner Observable to be merged on the
	 * output Observable. Those output values resulting from the projection are also
	 * given to the `project` function to produce new output values. This is how
	 * *expand* behaves recursively.
	 *
	 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var powersOfTwo = clicks
	 *   .mapTo(1)
	 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
	 *   .take(10);
	 * powersOfTwo.subscribe(x => console.log(x));
	 *
	 * @see {@link mergeMap}
	 * @see {@link mergeScan}
	 *
	 * @param {function(value: T, index: number) => Observable} project A function
	 * that, when applied to an item emitted by the source or the output Observable,
	 * returns an Observable.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
	 * each projected inner Observable.
	 * @return {Observable} An Observable that emits the source values and also
	 * result of applying the projection function to each value emitted on the
	 * output Observable and and merging the results of the Observables obtained
	 * from this transformation.
	 * @method expand
	 * @owner Observable
	 */
	function expand(project, concurrent, scheduler) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    if (scheduler === void 0) { scheduler = undefined; }
	    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
	    return expand_1.expand(project, concurrent, scheduler)(this);
	}
	exports.expand = expand;
	//# sourceMappingURL=expand.js.map

/***/ }),
/* 4669 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var finalize_1 = __webpack_require__(795);
	/**
	 * Returns an Observable that mirrors the source Observable, but will call a specified function when
	 * the source terminates on complete or error.
	 * @param {function} callback Function to be called when source terminates.
	 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
	 * @method finally
	 * @owner Observable
	 */
	function _finally(callback) {
	    return finalize_1.finalize(callback)(this);
	}
	exports._finally = _finally;
	//# sourceMappingURL=finally.js.map

/***/ }),
/* 4670 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var find_1 = __webpack_require__(514);
	/* tslint:enable:max-line-length */
	/**
	 * Emits only the first value emitted by the source Observable that meets some
	 * condition.
	 *
	 * <span class="informal">Finds the first value that passes some test and emits
	 * that.</span>
	 *
	 * <img src="./img/find.png" width="100%">
	 *
	 * `find` searches for the first item in the source Observable that matches the
	 * specified condition embodied by the `predicate`, and returns the first
	 * occurrence in the source. Unlike {@link first}, the `predicate` is required
	 * in `find`, and does not emit an error if a valid value is not found.
	 *
	 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link first}
	 * @see {@link findIndex}
	 * @see {@link take}
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
	 * A function called with each item to test for condition matching.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable<T>} An Observable of the first item that matches the
	 * condition.
	 * @method find
	 * @owner Observable
	 */
	function find(predicate, thisArg) {
	    return find_1.find(predicate, thisArg)(this);
	}
	exports.find = find;
	//# sourceMappingURL=find.js.map

/***/ }),
/* 4671 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var findIndex_1 = __webpack_require__(796);
	/**
	 * Emits only the index of the first value emitted by the source Observable that
	 * meets some condition.
	 *
	 * <span class="informal">It's like {@link find}, but emits the index of the
	 * found value, not the value itself.</span>
	 *
	 * <img src="./img/findIndex.png" width="100%">
	 *
	 * `findIndex` searches for the first item in the source Observable that matches
	 * the specified condition embodied by the `predicate`, and returns the
	 * (zero-based) index of the first occurrence in the source. Unlike
	 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
	 * an error if a valid value is not found.
	 *
	 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link find}
	 * @see {@link first}
	 * @see {@link take}
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
	 * A function called with each item to test for condition matching.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable} An Observable of the index of the first item that
	 * matches the condition.
	 * @method find
	 * @owner Observable
	 */
	function findIndex(predicate, thisArg) {
	    return findIndex_1.findIndex(predicate, thisArg)(this);
	}
	exports.findIndex = findIndex;
	//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 4672 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var first_1 = __webpack_require__(797);
	/**
	 * Emits only the first value (or the first value that meets some condition)
	 * emitted by the source Observable.
	 *
	 * <span class="informal">Emits only the first value. Or emits only the first
	 * value that passes some test.</span>
	 *
	 * <img src="./img/first.png" width="100%">
	 *
	 * If called with no arguments, `first` emits the first value of the source
	 * Observable, then completes. If called with a `predicate` function, `first`
	 * emits the first value of the source that matches the specified condition. It
	 * may also take a `resultSelector` function to produce the output value from
	 * the input value, and a `defaultValue` to emit in case the source completes
	 * before it is able to emit a valid value. Throws an error if `defaultValue`
	 * was not provided and a matching element is not found.
	 *
	 * @example <caption>Emit only the first click that happens on the DOM</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.first();
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Emits the first click that happens on a DIV</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link find}
	 * @see {@link take}
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
	 * An optional function called with each item to test for condition matching.
	 * @param {function(value: T, index: number): R} [resultSelector] A function to
	 * produce the value on the output Observable based on the values
	 * and the indices of the source Observable. The arguments passed to this
	 * function are:
	 * - `value`: the value that was emitted on the source.
	 * - `index`: the "index" of the value from the source.
	 * @param {R} [defaultValue] The default value emitted in case no valid value
	 * was found on the source.
	 * @return {Observable<T|R>} An Observable of the first item that matches the
	 * condition.
	 * @method first
	 * @owner Observable
	 */
	function first(predicate, resultSelector, defaultValue) {
	    return first_1.first(predicate, resultSelector, defaultValue)(this);
	}
	exports.first = first;
	//# sourceMappingURL=first.js.map

/***/ }),
/* 4673 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var groupBy_1 = __webpack_require__(798);
	exports.GroupedObservable = groupBy_1.GroupedObservable;
	/* tslint:enable:max-line-length */
	/**
	 * Groups the items emitted by an Observable according to a specified criterion,
	 * and emits these grouped items as `GroupedObservables`, one
	 * {@link GroupedObservable} per group.
	 *
	 * <img src="./img/groupBy.png" width="100%">
	 *
	 * @example <caption>Group objects by id and return as array</caption>
	 * Observable.of<Obj>({id: 1, name: 'aze1'},
	 *                    {id: 2, name: 'sf2'},
	 *                    {id: 2, name: 'dg2'},
	 *                    {id: 1, name: 'erg1'},
	 *                    {id: 1, name: 'df1'},
	 *                    {id: 2, name: 'sfqfb2'},
	 *                    {id: 3, name: 'qfs3'},
	 *                    {id: 2, name: 'qsgqsfg2'}
	 *     )
	 *     .groupBy(p => p.id)
	 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
	 *     .subscribe(p => console.log(p));
	 *
	 * // displays:
	 * // [ { id: 1, name: 'aze1' },
	 * //   { id: 1, name: 'erg1' },
	 * //   { id: 1, name: 'df1' } ]
	 * //
	 * // [ { id: 2, name: 'sf2' },
	 * //   { id: 2, name: 'dg2' },
	 * //   { id: 2, name: 'sfqfb2' },
	 * //   { id: 2, name: 'qsgqsfg2' } ]
	 * //
	 * // [ { id: 3, name: 'qfs3' } ]
	 *
	 * @example <caption>Pivot data on the id field</caption>
	 * Observable.of<Obj>({id: 1, name: 'aze1'},
	 *                    {id: 2, name: 'sf2'},
	 *                    {id: 2, name: 'dg2'},
	 *                    {id: 1, name: 'erg1'},
	 *                    {id: 1, name: 'df1'},
	 *                    {id: 2, name: 'sfqfb2'},
	 *                    {id: 3, name: 'qfs1'},
	 *                    {id: 2, name: 'qsgqsfg2'}
	 *                   )
	 *     .groupBy(p => p.id, p => p.name)
	 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
	 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
	 *     .subscribe(p => console.log(p));
	 *
	 * // displays:
	 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
	 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
	 * // { id: 3, values: [ 'qfs1' ] }
	 *
	 * @param {function(value: T): K} keySelector A function that extracts the key
	 * for each item.
	 * @param {function(value: T): R} [elementSelector] A function that extracts the
	 * return element for each item.
	 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
	 * A function that returns an Observable to determine how long each group should
	 * exist.
	 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
	 * GroupedObservables, each of which corresponds to a unique key value and each
	 * of which emits those items from the source Observable that share that key
	 * value.
	 * @method groupBy
	 * @owner Observable
	 */
	function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
	    return groupBy_1.groupBy(keySelector, elementSelector, durationSelector, subjectSelector)(this);
	}
	exports.groupBy = groupBy;
	//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 4674 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ignoreElements_1 = __webpack_require__(515);
	/**
	 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
	 *
	 * <img src="./img/ignoreElements.png" width="100%">
	 *
	 * @return {Observable} An empty Observable that only calls `complete`
	 * or `error`, based on which one is called by the source Observable.
	 * @method ignoreElements
	 * @owner Observable
	 */
	function ignoreElements() {
	    return ignoreElements_1.ignoreElements()(this);
	}
	exports.ignoreElements = ignoreElements;
	;
	//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 4675 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isEmpty_1 = __webpack_require__(799);
	/**
	 * If the source Observable is empty it returns an Observable that emits true, otherwise it emits false.
	 *
	 * <img src="./img/isEmpty.png" width="100%">
	 *
	 * @return {Observable} An Observable that emits a Boolean.
	 * @method isEmpty
	 * @owner Observable
	 */
	function isEmpty() {
	    return isEmpty_1.isEmpty()(this);
	}
	exports.isEmpty = isEmpty;
	//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 4676 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var last_1 = __webpack_require__(800);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits only the last item emitted by the source Observable.
	 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
	 * the last item from the source Observable, the resulting Observable will emit the last item
	 * from the source Observable that satisfies the predicate.
	 *
	 * <img src="./img/last.png" width="100%">
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 * @param {function} predicate - The condition any source emitted item has to satisfy.
	 * @return {Observable} An Observable that emits only the last item satisfying the given condition
	 * from the source, or an NoSuchElementException if no such items are emitted.
	 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
	 * @method last
	 * @owner Observable
	 */
	function last(predicate, resultSelector, defaultValue) {
	    return last_1.last(predicate, resultSelector, defaultValue)(this);
	}
	exports.last = last;
	//# sourceMappingURL=last.js.map

/***/ }),
/* 4677 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @param func
	 * @return {Observable<R>}
	 * @method let
	 * @owner Observable
	 */
	function letProto(func) {
	    return func(this);
	}
	exports.letProto = letProto;
	//# sourceMappingURL=let.js.map

/***/ }),
/* 4678 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mapTo_1 = __webpack_require__(516);
	/**
	 * Emits the given constant value on the output Observable every time the source
	 * Observable emits a value.
	 *
	 * <span class="informal">Like {@link map}, but it maps every source value to
	 * the same output value every time.</span>
	 *
	 * <img src="./img/mapTo.png" width="100%">
	 *
	 * Takes a constant `value` as argument, and emits that whenever the source
	 * Observable emits a value. In other words, ignores the actual source value,
	 * and simply uses the emission moment to know when to emit the given `value`.
	 *
	 * @example <caption>Map every click to the string 'Hi'</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var greetings = clicks.mapTo('Hi');
	 * greetings.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 *
	 * @param {any} value The value to map each source value to.
	 * @return {Observable} An Observable that emits the given `value` every time
	 * the source Observable emits something.
	 * @method mapTo
	 * @owner Observable
	 */
	function mapTo(value) {
	    return mapTo_1.mapTo(value)(this);
	}
	exports.mapTo = mapTo;
	//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 4679 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var materialize_1 = __webpack_require__(801);
	/**
	 * Represents all of the notifications from the source Observable as `next`
	 * emissions marked with their original types within {@link Notification}
	 * objects.
	 *
	 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
	 * {@link Notification} objects, emitted as `next` on the output Observable.
	 * </span>
	 *
	 * <img src="./img/materialize.png" width="100%">
	 *
	 * `materialize` returns an Observable that emits a `next` notification for each
	 * `next`, `error`, or `complete` emission of the source Observable. When the
	 * source Observable emits `complete`, the output Observable will emit `next` as
	 * a Notification of type "complete", and then it will emit `complete` as well.
	 * When the source Observable emits `error`, the output will emit `next` as a
	 * Notification of type "error", and then `complete`.
	 *
	 * This operator is useful for producing metadata of the source Observable, to
	 * be consumed as `next` emissions. Use it in conjunction with
	 * {@link dematerialize}.
	 *
	 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
	 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
	 * var upperCase = letters.map(x => x.toUpperCase());
	 * var materialized = upperCase.materialize();
	 * materialized.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
	 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
	 * // - Notification {kind: "E", value: undefined, error: TypeError:
	 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
	 * //   [as project] (http://1…, hasValue: false}
	 *
	 * @see {@link Notification}
	 * @see {@link dematerialize}
	 *
	 * @return {Observable<Notification<T>>} An Observable that emits
	 * {@link Notification} objects that wrap the original emissions from the source
	 * Observable with metadata.
	 * @method materialize
	 * @owner Observable
	 */
	function materialize() {
	    return materialize_1.materialize()(this);
	}
	exports.materialize = materialize;
	//# sourceMappingURL=materialize.js.map

/***/ }),
/* 4680 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var max_1 = __webpack_require__(802);
	/**
	 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
	 * and when source Observable completes it emits a single item: the item with the largest value.
	 *
	 * <img src="./img/max.png" width="100%">
	 *
	 * @example <caption>Get the maximal value of a series of numbers</caption>
	 * Rx.Observable.of(5, 4, 7, 2, 8)
	 *   .max()
	 *   .subscribe(x => console.log(x)); // -> 8
	 *
	 * @example <caption>Use a comparer function to get the maximal item</caption>
	 * interface Person {
	 *   age: number,
	 *   name: string
	 * }
	 * Observable.of<Person>({age: 7, name: 'Foo'},
	 *                       {age: 5, name: 'Bar'},
	 *                       {age: 9, name: 'Beer'})
	 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
	 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
	 * }
	 *
	 * @see {@link min}
	 *
	 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
	 * value of two items.
	 * @return {Observable} An Observable that emits item with the largest value.
	 * @method max
	 * @owner Observable
	 */
	function max(comparer) {
	    return max_1.max(comparer)(this);
	}
	exports.max = max;
	//# sourceMappingURL=max.js.map

/***/ }),
/* 4681 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var merge_1 = __webpack_require__(803);
	var merge_2 = __webpack_require__(162);
	exports.mergeStatic = merge_2.merge;
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which concurrently emits all values from every
	 * given input Observable.
	 *
	 * <span class="informal">Flattens multiple Observables together by blending
	 * their values into one Observable.</span>
	 *
	 * <img src="./img/merge.png" width="100%">
	 *
	 * `merge` subscribes to each given input Observable (either the source or an
	 * Observable given as argument), and simply forwards (without doing any
	 * transformation) all the values from all the input Observables to the output
	 * Observable. The output Observable only completes once all input Observables
	 * have completed. Any error delivered by an input Observable will be immediately
	 * emitted on the output Observable.
	 *
	 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var clicksOrTimer = clicks.merge(timer);
	 * clicksOrTimer.subscribe(x => console.log(x));
	 *
	 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var concurrent = 2; // the argument
	 * var merged = timer1.merge(timer2, timer3, concurrent);
	 * merged.subscribe(x => console.log(x));
	 *
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 *
	 * @param {ObservableInput} other An input Observable to merge with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
	 * concurrency of input Observables.
	 * @return {Observable} An Observable that emits items that are the result of
	 * every input Observable.
	 * @method merge
	 * @owner Observable
	 */
	function merge() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return merge_1.merge.apply(void 0, observables)(this);
	}
	exports.merge = merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 4682 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeAll_1 = __webpack_require__(349);
	/**
	 * Converts a higher-order Observable into a first-order Observable which
	 * concurrently delivers all values that are emitted on the inner Observables.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables.</span>
	 *
	 * <img src="./img/mergeAll.png" width="100%">
	 *
	 * `mergeAll` subscribes to an Observable that emits Observables, also known as
	 * a higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, it subscribes to that and delivers all the values from the
	 * inner Observable on the output Observable. The output Observable only
	 * completes once all inner Observables have completed. Any error delivered by
	 * a inner Observable will be immediately emitted on the output Observable.
	 *
	 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
	 * var firstOrder = higherOrder.mergeAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
	 * var firstOrder = higherOrder.mergeAll(2);
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link exhaust}
	 * @see {@link merge}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits values coming from all the
	 * inner Observables emitted by the source Observable.
	 * @method mergeAll
	 * @owner Observable
	 */
	function mergeAll(concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeAll_1.mergeAll(concurrent)(this);
	}
	exports.mergeAll = mergeAll;
	//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 4683 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeMap_1 = __webpack_require__(266);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link mergeAll}.</span>
	 *
	 * <img src="./img/mergeMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an Observable, and then merging those resulting Observables and
	 * emitting the results of this merger.
	 *
	 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
	 * var letters = Rx.Observable.of('a', 'b', 'c');
	 * var result = letters.mergeMap(x =>
	 *   Rx.Observable.interval(1000).map(i => x+i)
	 * );
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // a0
	 * // b0
	 * // c0
	 * // a1
	 * // b1
	 * // c1
	 * // continues to list a,b,c with respective ascending integers
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link merge}
	 * @see {@link mergeAll}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and merging the results of the Observables obtained
	 * from this transformation.
	 * @method mergeMap
	 * @owner Observable
	 */
	function mergeMap(project, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeMap_1.mergeMap(project, resultSelector, concurrent)(this);
	}
	exports.mergeMap = mergeMap;
	//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 4684 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeMapTo_1 = __webpack_require__(804);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is merged multiple
	 * times in the output Observable.
	 *
	 * <span class="informal">It's like {@link mergeMap}, but maps each value always
	 * to the same inner Observable.</span>
	 *
	 * <img src="./img/mergeMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then merges those resulting Observables into one
	 * single Observable, which is the output Observable.
	 *
	 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMapTo}
	 * @see {@link merge}
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeScan}
	 * @see {@link switchMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits items from the given
	 * `innerObservable` (and optionally transformed through `resultSelector`) every
	 * time a value is emitted on the source Observable.
	 * @method mergeMapTo
	 * @owner Observable
	 */
	function mergeMapTo(innerObservable, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeMapTo_1.mergeMapTo(innerObservable, resultSelector, concurrent)(this);
	}
	exports.mergeMapTo = mergeMapTo;
	//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 4685 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeScan_1 = __webpack_require__(805);
	/**
	 * Applies an accumulator function over the source Observable where the
	 * accumulator function itself returns an Observable, then each intermediate
	 * Observable returned is merged into the output Observable.
	 *
	 * <span class="informal">It's like {@link scan}, but the Observables returned
	 * by the accumulator are merged into the outer Observable.</span>
	 *
	 * @example <caption>Count the number of click events</caption>
	 * const click$ = Rx.Observable.fromEvent(document, 'click');
	 * const one$ = click$.mapTo(1);
	 * const seed = 0;
	 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
	 * count$.subscribe(x => console.log(x));
	 *
	 * // Results:
	 * 1
	 * 2
	 * 3
	 * 4
	 * // ...and so on for each click
	 *
	 * @param {function(acc: R, value: T): Observable<R>} accumulator
	 * The accumulator function called on each source value.
	 * @param seed The initial accumulation value.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
	 * input Observables being subscribed to concurrently.
	 * @return {Observable<R>} An observable of the accumulated values.
	 * @method mergeScan
	 * @owner Observable
	 */
	function mergeScan(accumulator, seed, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeScan_1.mergeScan(accumulator, seed, concurrent)(this);
	}
	exports.mergeScan = mergeScan;
	//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 4686 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var min_1 = __webpack_require__(806);
	/**
	 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
	 * and when source Observable completes it emits a single item: the item with the smallest value.
	 *
	 * <img src="./img/min.png" width="100%">
	 *
	 * @example <caption>Get the minimal value of a series of numbers</caption>
	 * Rx.Observable.of(5, 4, 7, 2, 8)
	 *   .min()
	 *   .subscribe(x => console.log(x)); // -> 2
	 *
	 * @example <caption>Use a comparer function to get the minimal item</caption>
	 * interface Person {
	 *   age: number,
	 *   name: string
	 * }
	 * Observable.of<Person>({age: 7, name: 'Foo'},
	 *                       {age: 5, name: 'Bar'},
	 *                       {age: 9, name: 'Beer'})
	 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
	 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
	 * }
	 *
	 * @see {@link max}
	 *
	 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
	 * value of two items.
	 * @return {Observable<R>} An Observable that emits item with the smallest value.
	 * @method min
	 * @owner Observable
	 */
	function min(comparer) {
	    return min_1.min(comparer)(this);
	}
	exports.min = min;
	//# sourceMappingURL=min.js.map

/***/ }),
/* 4687 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var multicast_1 = __webpack_require__(164);
	/* tslint:enable:max-line-length */
	/**
	 * Allows source Observable to be subscribed only once with a Subject of choice,
	 * while still sharing its values between multiple subscribers.
	 *
	 * <span class="informal">Subscribe to Observable once, but send its values to multiple subscribers.</span>
	 *
	 * <img src="./img/multicast.png" width="100%">
	 *
	 * `multicast` is an operator that works in two modes.
	 *
	 * In the first mode you provide a single argument to it, which can be either an initialized Subject or a Subject
	 * factory. As a result you will get a special kind of an Observable - a {@link ConnectableObservable}. It can be
	 * subscribed multiple times, just as regular Observable, but it won't subscribe to the source Observable at that
	 * moment. It will do it only if you call its `connect` method. This means you can essentially control by hand, when
	 * source Observable will be actually subscribed. What is more, ConnectableObservable will share this one subscription
	 * between all of its subscribers. This means that, for example, `ajax` Observable will only send a request once,
	 * even though usually it would send a request per every subscriber. Since it sends a request at the moment of
	 * subscription, here request would be sent when the `connect` method of a ConnectableObservable is called.
	 *
	 * The most common pattern of using ConnectableObservable is calling `connect` when the first consumer subscribes,
	 * keeping the subscription alive while several consumers come and go and finally unsubscribing from the source
	 * Observable, when the last consumer unsubscribes. To not implement that logic over and over again,
	 * ConnectableObservable has a special operator, `refCount`. When called, it returns an Observable, which will count
	 * the number of consumers subscribed to it and keep ConnectableObservable connected as long as there is at least
	 * one consumer. So if you don't actually need to decide yourself when to connect and disconnect a
	 * ConnectableObservable, use `refCount`.
	 *
	 * The second mode is invoked by calling `multicast` with an additional, second argument - selector function.
	 * This function accepts an Observable - which basically mirrors the source Observable - and returns Observable
	 * as well, which should be the input stream modified by any operators you want. Note that in this
	 * mode you cannot provide initialized Subject as a first argument - it has to be a Subject factory. If
	 * you provide selector function, `multicast` returns just a regular Observable, instead of ConnectableObservable.
	 * Thus, as usual, each subscription to this stream triggers subscription to the source Observable. However,
	 * if inside the selector function you subscribe to the input Observable multiple times, actual source stream
	 * will be subscribed only once. So if you have a chain of operators that use some Observable many times,
	 * but you want to subscribe to that Observable only once, this is the mode you would use.
	 *
	 * Subject provided as a first parameter of `multicast` is used as a proxy for the single subscription to the
	 * source Observable. It means that all values from the source stream go through that Subject. Thus, if a Subject
	 * has some special properties, Observable returned by `multicast` will have them as well. If you want to use
	 * `multicast` with a Subject that is one of the ones included in RxJS by default - {@link Subject},
	 * {@link AsyncSubject}, {@link BehaviorSubject}, or {@link ReplaySubject} - simply use {@link publish},
	 * {@link publishLast}, {@link publishBehavior} or {@link publishReplay} respectively. These are actually
	 * just wrappers around `multicast`, with a specific Subject hardcoded inside.
	 *
	 * Also, if you use {@link publish} or {@link publishReplay} with a ConnectableObservables `refCount` operator,
	 * you can simply use {@link share} and {@link shareReplay} respectively, which chain these two.
	 *
	 * @example <caption>Use ConnectableObservable</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 * const connectableSeconds = seconds.multicast(new Subject());
	 *
	 * connectableSeconds.subscribe(value => console.log('first: ' + value));
	 * connectableSeconds.subscribe(value => console.log('second: ' + value));
	 *
	 * // At this point still nothing happens, even though we subscribed twice.
	 *
	 * connectableSeconds.connect();
	 *
	 * // From now on `seconds` are being logged to the console,
	 * // twice per every second. `seconds` Observable was however only subscribed once,
	 * // so under the hood Observable.interval had only one clock started.
	 *
	 * @example <caption>Use selector</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 *
	 * seconds
	 *     .multicast(
	 *         () => new Subject(),
	 *         seconds => seconds.zip(seconds) // Usually zip would subscribe to `seconds` twice.
	 *                                         // Because we are inside selector, `seconds` is subscribed once,
	 *     )                                   // thus starting only one clock used internally by Observable.interval.
	 *     .subscribe();
	 *
	 * @see {@link publish}
	 * @see {@link publishLast}
	 * @see {@link publishBehavior}
	 * @see {@link publishReplay}
	 * @see {@link share}
	 * @see {@link shareReplay}
	 *
	 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate Subject through
	 * which the source sequence's elements will be multicast to the selector function input Observable or
	 * ConnectableObservable returned by the operator.
	 * @param {Function} [selector] - Optional selector function that can use the input stream
	 * as many times as needed, without causing multiple subscriptions to the source stream.
	 * Subscribers to the input source will receive all notifications of the source from the
	 * time of the subscription forward.
	 * @return {Observable<T>|ConnectableObservable<T>} An Observable that emits the results of invoking the selector
	 * on the source stream or a special {@link ConnectableObservable}, if selector was not provided.
	 *
	 * @method multicast
	 * @owner Observable
	 */
	function multicast(subjectOrSubjectFactory, selector) {
	    return multicast_1.multicast(subjectOrSubjectFactory, selector)(this);
	}
	exports.multicast = multicast;
	//# sourceMappingURL=multicast.js.map

/***/ }),
/* 4688 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var observeOn_1 = __webpack_require__(350);
	/**
	 *
	 * Re-emits all notifications from source Observable with specified scheduler.
	 *
	 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
	 *
	 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
	 * notifications emitted by the source Observable. It might be useful, if you do not have control over
	 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
	 *
	 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
	 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
	 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
	 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
	 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
	 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
	 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
	 * little bit more, to ensure that they are emitted at expected moments.
	 *
	 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
	 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
	 * will delay all notifications - including error notifications - while `delay` will pass through error
	 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
	 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
	 * for notification emissions in general.
	 *
	 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
	 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
	 *                                               // with async scheduler by default...
	 *
	 * intervals
	 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
	 * .subscribe(val => {                           // scheduler to ensure smooth animation.
	 *   someDiv.style.height = val + 'px';
	 * });
	 *
	 * @see {@link delay}
	 *
	 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
	 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
	 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
	 * but with provided scheduler.
	 *
	 * @method observeOn
	 * @owner Observable
	 */
	function observeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return observeOn_1.observeOn(scheduler, delay)(this);
	}
	exports.observeOn = observeOn;
	//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 4689 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var onErrorResumeNext_1 = __webpack_require__(517);
	/* tslint:enable:max-line-length */
	/**
	 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
	 * that was passed.
	 *
	 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
	 *
	 * <img src="./img/onErrorResumeNext.png" width="100%">
	 *
	 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
	 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
	 * as the source.
	 *
	 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
	 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
	 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
	 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
	 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
	 * be happening until there is no more Observables left in the series, at which point returned Observable will
	 * complete - even if the last subscribed stream ended with an error.
	 *
	 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
	 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
	 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
	 * an error.
	 *
	 * Note that you do not get any access to errors emitted by the Observables. In particular do not
	 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
	 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
	 *
	 *
	 * @example <caption>Subscribe to the next Observable after map fails</caption>
	 * Rx.Observable.of(1, 2, 3, 0)
	 *   .map(x => {
	 *       if (x === 0) { throw Error(); }
	         return 10 / x;
	 *   })
	 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
	 *   .subscribe(
	 *     val => console.log(val),
	 *     err => console.log(err),          // Will never be called.
	 *     () => console.log('that\'s it!')
	 *   );
	 *
	 * // Logs:
	 * // 10
	 * // 5
	 * // 3.3333333333333335
	 * // 1
	 * // 2
	 * // 3
	 * // "that's it!"
	 *
	 * @see {@link concat}
	 * @see {@link catch}
	 *
	 * @param {...ObservableInput} observables Observables passed either directly or as an array.
	 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
	 * to the next passed Observable and so on, until it completes or runs out of Observables.
	 * @method onErrorResumeNext
	 * @owner Observable
	 */
	function onErrorResumeNext() {
	    var nextSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        nextSources[_i - 0] = arguments[_i];
	    }
	    return onErrorResumeNext_1.onErrorResumeNext.apply(void 0, nextSources)(this);
	}
	exports.onErrorResumeNext = onErrorResumeNext;
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 4690 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var pairwise_1 = __webpack_require__(807);
	/**
	 * Groups pairs of consecutive emissions together and emits them as an array of
	 * two values.
	 *
	 * <span class="informal">Puts the current value and previous value together as
	 * an array, and emits that.</span>
	 *
	 * <img src="./img/pairwise.png" width="100%">
	 *
	 * The Nth emission from the source Observable will cause the output Observable
	 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
	 * pair. For this reason, `pairwise` emits on the second and subsequent
	 * emissions from the source Observable, but not on the first emission, because
	 * there is no previous value in that case.
	 *
	 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var pairs = clicks.pairwise();
	 * var distance = pairs.map(pair => {
	 *   var x0 = pair[0].clientX;
	 *   var y0 = pair[0].clientY;
	 *   var x1 = pair[1].clientX;
	 *   var y1 = pair[1].clientY;
	 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
	 * });
	 * distance.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 *
	 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
	 * consecutive values from the source Observable.
	 * @method pairwise
	 * @owner Observable
	 */
	function pairwise() {
	    return pairwise_1.pairwise()(this);
	}
	exports.pairwise = pairwise;
	//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 4691 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var partition_1 = __webpack_require__(808);
	/**
	 * Splits the source Observable into two, one with values that satisfy a
	 * predicate, and another with values that don't satisfy the predicate.
	 *
	 * <span class="informal">It's like {@link filter}, but returns two Observables:
	 * one like the output of {@link filter}, and the other with values that did not
	 * pass the condition.</span>
	 *
	 * <img src="./img/partition.png" width="100%">
	 *
	 * `partition` outputs an array with two Observables that partition the values
	 * from the source Observable through the given `predicate` function. The first
	 * Observable in that array emits source values for which the predicate argument
	 * returns true. The second Observable emits source values for which the
	 * predicate returns false. The first behaves like {@link filter} and the second
	 * behaves like {@link filter} with the predicate negated.
	 *
	 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
	 * var clicksOnDivs = parts[0];
	 * var clicksElsewhere = parts[1];
	 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
	 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
	 *
	 * @see {@link filter}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates each value emitted by the source Observable. If it returns `true`,
	 * the value is emitted on the first Observable in the returned array, if
	 * `false` the value is emitted on the second Observable in the array. The
	 * `index` parameter is the number `i` for the i-th source emission that has
	 * happened since the subscription, starting from the number `0`.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
	 * with values that passed the predicate, and another with values that did not
	 * pass the predicate.
	 * @method partition
	 * @owner Observable
	 */
	function partition(predicate, thisArg) {
	    return partition_1.partition(predicate, thisArg)(this);
	}
	exports.partition = partition;
	//# sourceMappingURL=partition.js.map

/***/ }),
/* 4692 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var pluck_1 = __webpack_require__(809);
	/**
	 * Maps each source value (an object) to its specified nested property.
	 *
	 * <span class="informal">Like {@link map}, but meant only for picking one of
	 * the nested properties of every emitted object.</span>
	 *
	 * <img src="./img/pluck.png" width="100%">
	 *
	 * Given a list of strings describing a path to an object property, retrieves
	 * the value of a specified nested property from all values in the source
	 * Observable. If a property can't be resolved, it will return `undefined` for
	 * that value.
	 *
	 * @example <caption>Map every click to the tagName of the clicked target element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var tagNames = clicks.pluck('target', 'tagName');
	 * tagNames.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 *
	 * @param {...string} properties The nested properties to pluck from each source
	 * value (an object).
	 * @return {Observable} A new Observable of property values from the source values.
	 * @method pluck
	 * @owner Observable
	 */
	function pluck() {
	    var properties = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        properties[_i - 0] = arguments[_i];
	    }
	    return pluck_1.pluck.apply(void 0, properties)(this);
	}
	exports.pluck = pluck;
	//# sourceMappingURL=pluck.js.map

/***/ }),
/* 4693 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var publish_1 = __webpack_require__(810);
	/* tslint:enable:max-line-length */
	/**
	 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
	 * before it begins emitting items to those Observers that have subscribed to it.
	 *
	 * <img src="./img/publish.png" width="100%">
	 *
	 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
	 * as needed, without causing multiple subscriptions to the source sequence.
	 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
	 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
	 * @method publish
	 * @owner Observable
	 */
	function publish(selector) {
	    return publish_1.publish(selector)(this);
	}
	exports.publish = publish;
	//# sourceMappingURL=publish.js.map

/***/ }),
/* 4694 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var publishBehavior_1 = __webpack_require__(811);
	/**
	 * @param value
	 * @return {ConnectableObservable<T>}
	 * @method publishBehavior
	 * @owner Observable
	 */
	function publishBehavior(value) {
	    return publishBehavior_1.publishBehavior(value)(this);
	}
	exports.publishBehavior = publishBehavior;
	//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 4695 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var publishLast_1 = __webpack_require__(812);
	/**
	 * @return {ConnectableObservable<T>}
	 * @method publishLast
	 * @owner Observable
	 */
	function publishLast() {
	    //TODO(benlesh): correct type-flow through here.
	    return publishLast_1.publishLast()(this);
	}
	exports.publishLast = publishLast;
	//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 4696 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var publishReplay_1 = __webpack_require__(813);
	/* tslint:enable:max-line-length */
	/**
	 * @param bufferSize
	 * @param windowTime
	 * @param selectorOrScheduler
	 * @param scheduler
	 * @return {Observable<T> | ConnectableObservable<T>}
	 * @method publishReplay
	 * @owner Observable
	 */
	function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
	    return publishReplay_1.publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler)(this);
	}
	exports.publishReplay = publishReplay;
	//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 4697 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var race_1 = __webpack_require__(814);
	// NOTE: to support backwards compatability with 5.4.* and lower
	var race_2 = __webpack_require__(508);
	exports.raceStatic = race_2.race;
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that mirrors the first source Observable to emit an item
	 * from the combination of this Observable and supplied Observables.
	 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
	 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
	 * @method race
	 * @owner Observable
	 */
	function race() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return race_1.race.apply(void 0, observables)(this);
	}
	exports.race = race;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 4698 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var reduce_1 = __webpack_require__(267);
	/* tslint:enable:max-line-length */
	/**
	 * Applies an accumulator function over the source Observable, and returns the
	 * accumulated result when the source completes, given an optional seed value.
	 *
	 * <span class="informal">Combines together all values emitted on the source,
	 * using an accumulator function that knows how to join a new source value into
	 * the accumulation from the past.</span>
	 *
	 * <img src="./img/reduce.png" width="100%">
	 *
	 * Like
	 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
	 * `reduce` applies an `accumulator` function against an accumulation and each
	 * value of the source Observable (from the past) to reduce it to a single
	 * value, emitted on the output Observable. Note that `reduce` will only emit
	 * one value, only when the source Observable completes. It is equivalent to
	 * applying operator {@link scan} followed by operator {@link last}.
	 *
	 * Returns an Observable that applies a specified `accumulator` function to each
	 * item emitted by the source Observable. If a `seed` value is specified, then
	 * that value will be used as the initial value for the accumulator. If no seed
	 * value is specified, the first item of the source is used as the seed.
	 *
	 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
	 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
	 *   .takeUntil(Rx.Observable.interval(5000));
	 * var ones = clicksInFiveSeconds.mapTo(1);
	 * var seed = 0;
	 * var count = ones.reduce((acc, one) => acc + one, seed);
	 * count.subscribe(x => console.log(x));
	 *
	 * @see {@link count}
	 * @see {@link expand}
	 * @see {@link mergeScan}
	 * @see {@link scan}
	 *
	 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
	 * called on each source value.
	 * @param {R} [seed] The initial accumulation value.
	 * @return {Observable<R>} An Observable that emits a single value that is the
	 * result of accumulating the values emitted by the source Observable.
	 * @method reduce
	 * @owner Observable
	 */
	function reduce(accumulator, seed) {
	    // providing a seed of `undefined` *should* be valid and trigger
	    // hasSeed! so don't use `seed !== undefined` checks!
	    // For this reason, we have to check it here at the original call site
	    // otherwise inside Operator/Subscriber we won't know if `undefined`
	    // means they didn't provide anything or if they literally provided `undefined`
	    if (arguments.length >= 2) {
	        return reduce_1.reduce(accumulator, seed)(this);
	    }
	    return reduce_1.reduce(accumulator)(this);
	}
	exports.reduce = reduce;
	//# sourceMappingURL=reduce.js.map

/***/ }),
/* 4699 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var repeat_1 = __webpack_require__(815);
	/**
	 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
	 *
	 * <img src="./img/repeat.png" width="100%">
	 *
	 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
	 * an empty Observable.
	 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
	 * count times.
	 * @method repeat
	 * @owner Observable
	 */
	function repeat(count) {
	    if (count === void 0) { count = -1; }
	    return repeat_1.repeat(count)(this);
	}
	exports.repeat = repeat;
	//# sourceMappingURL=repeat.js.map

/***/ }),
/* 4700 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var repeatWhen_1 = __webpack_require__(816);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
	 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
	 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
	 * this method will resubscribe to the source Observable.
	 *
	 * <img src="./img/repeatWhen.png" width="100%">
	 *
	 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
	 * which a user can `complete` or `error`, aborting the repetition.
	 * @return {Observable} The source Observable modified with repeat logic.
	 * @method repeatWhen
	 * @owner Observable
	 */
	function repeatWhen(notifier) {
	    return repeatWhen_1.repeatWhen(notifier)(this);
	}
	exports.repeatWhen = repeatWhen;
	//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 4701 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var retry_1 = __webpack_require__(817);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
	 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
	 * as a number parameter) rather than propagating the `error` call.
	 *
	 * <img src="./img/retry.png" width="100%">
	 *
	 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
	 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
	 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
	 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
	 * @param {number} count - Number of retry attempts before failing.
	 * @return {Observable} The source Observable modified with the retry logic.
	 * @method retry
	 * @owner Observable
	 */
	function retry(count) {
	    if (count === void 0) { count = -1; }
	    return retry_1.retry(count)(this);
	}
	exports.retry = retry;
	//# sourceMappingURL=retry.js.map

/***/ }),
/* 4702 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var retryWhen_1 = __webpack_require__(818);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
	 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
	 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
	 * subscription. Otherwise this method will resubscribe to the source Observable.
	 *
	 * <img src="./img/retryWhen.png" width="100%">
	 *
	 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
	 * user can `complete` or `error`, aborting the retry.
	 * @return {Observable} The source Observable modified with retry logic.
	 * @method retryWhen
	 * @owner Observable
	 */
	function retryWhen(notifier) {
	    return retryWhen_1.retryWhen(notifier)(this);
	}
	exports.retryWhen = retryWhen;
	//# sourceMappingURL=retryWhen.js.map

/***/ }),
/* 4703 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var sample_1 = __webpack_require__(819);
	/**
	 * Emits the most recently emitted value from the source Observable whenever
	 * another Observable, the `notifier`, emits.
	 *
	 * <span class="informal">It's like {@link sampleTime}, but samples whenever
	 * the `notifier` Observable emits something.</span>
	 *
	 * <img src="./img/sample.png" width="100%">
	 *
	 * Whenever the `notifier` Observable emits a value or completes, `sample`
	 * looks at the source Observable and emits whichever value it has most recently
	 * emitted since the previous sampling, unless the source has not emitted
	 * anything since the previous sampling. The `notifier` is subscribed to as soon
	 * as the output Observable is subscribed.
	 *
	 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
	 * var seconds = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = seconds.sample(clicks);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounce}
	 * @see {@link sampleTime}
	 * @see {@link throttle}
	 *
	 * @param {Observable<any>} notifier The Observable to use for sampling the
	 * source Observable.
	 * @return {Observable<T>} An Observable that emits the results of sampling the
	 * values emitted by the source Observable whenever the notifier Observable
	 * emits value or completes.
	 * @method sample
	 * @owner Observable
	 */
	function sample(notifier) {
	    return sample_1.sample(notifier)(this);
	}
	exports.sample = sample;
	//# sourceMappingURL=sample.js.map

/***/ }),
/* 4704 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(23);
	var sampleTime_1 = __webpack_require__(820);
	/**
	 * Emits the most recently emitted value from the source Observable within
	 * periodic time intervals.
	 *
	 * <span class="informal">Samples the source Observable at periodic time
	 * intervals, emitting what it samples.</span>
	 *
	 * <img src="./img/sampleTime.png" width="100%">
	 *
	 * `sampleTime` periodically looks at the source Observable and emits whichever
	 * value it has most recently emitted since the previous sampling, unless the
	 * source has not emitted anything since the previous sampling. The sampling
	 * happens periodically in time every `period` milliseconds (or the time unit
	 * defined by the optional `scheduler` argument). The sampling starts as soon as
	 * the output Observable is subscribed.
	 *
	 * @example <caption>Every second, emit the most recent click at most once</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.sampleTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sample}
	 * @see {@link throttleTime}
	 *
	 * @param {number} period The sampling period expressed in milliseconds or the
	 * time unit determined internally by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the sampling.
	 * @return {Observable<T>} An Observable that emits the results of sampling the
	 * values emitted by the source Observable at the specified time interval.
	 * @method sampleTime
	 * @owner Observable
	 */
	function sampleTime(period, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return sampleTime_1.sampleTime(period, scheduler)(this);
	}
	exports.sampleTime = sampleTime;
	//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 4705 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var scan_1 = __webpack_require__(519);
	/* tslint:enable:max-line-length */
	/**
	 * Applies an accumulator function over the source Observable, and returns each
	 * intermediate result, with an optional seed value.
	 *
	 * <span class="informal">It's like {@link reduce}, but emits the current
	 * accumulation whenever the source emits a value.</span>
	 *
	 * <img src="./img/scan.png" width="100%">
	 *
	 * Combines together all values emitted on the source, using an accumulator
	 * function that knows how to join a new source value into the accumulation from
	 * the past. Is similar to {@link reduce}, but emits the intermediate
	 * accumulations.
	 *
	 * Returns an Observable that applies a specified `accumulator` function to each
	 * item emitted by the source Observable. If a `seed` value is specified, then
	 * that value will be used as the initial value for the accumulator. If no seed
	 * value is specified, the first item of the source is used as the seed.
	 *
	 * @example <caption>Count the number of click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var ones = clicks.mapTo(1);
	 * var seed = 0;
	 * var count = ones.scan((acc, one) => acc + one, seed);
	 * count.subscribe(x => console.log(x));
	 *
	 * @see {@link expand}
	 * @see {@link mergeScan}
	 * @see {@link reduce}
	 *
	 * @param {function(acc: R, value: T, index: number): R} accumulator
	 * The accumulator function called on each source value.
	 * @param {T|R} [seed] The initial accumulation value.
	 * @return {Observable<R>} An observable of the accumulated values.
	 * @method scan
	 * @owner Observable
	 */
	function scan(accumulator, seed) {
	    if (arguments.length >= 2) {
	        return scan_1.scan(accumulator, seed)(this);
	    }
	    return scan_1.scan(accumulator)(this);
	}
	exports.scan = scan;
	//# sourceMappingURL=scan.js.map

/***/ }),
/* 4706 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var sequenceEqual_1 = __webpack_require__(821);
	/**
	 * Compares all values of two observables in sequence using an optional comparor function
	 * and returns an observable of a single boolean value representing whether or not the two sequences
	 * are equal.
	 *
	 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
	 *
	 * <img src="./img/sequenceEqual.png" width="100%">
	 *
	 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
	 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
	 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
	 * observables completes, the operator will wait for the other observable to complete; If the other
	 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
	 * completes or emits after the other complets, the returned observable will never complete.
	 *
	 * @example <caption>figure out if the Konami code matches</caption>
	 * var code = Rx.Observable.from([
	 *  "ArrowUp",
	 *  "ArrowUp",
	 *  "ArrowDown",
	 *  "ArrowDown",
	 *  "ArrowLeft",
	 *  "ArrowRight",
	 *  "ArrowLeft",
	 *  "ArrowRight",
	 *  "KeyB",
	 *  "KeyA",
	 *  "Enter" // no start key, clearly.
	 * ]);
	 *
	 * var keys = Rx.Observable.fromEvent(document, 'keyup')
	 *  .map(e => e.code);
	 * var matches = keys.bufferCount(11, 1)
	 *  .mergeMap(
	 *    last11 =>
	 *      Rx.Observable.from(last11)
	 *        .sequenceEqual(code)
	 *   );
	 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
	 *
	 * @see {@link combineLatest}
	 * @see {@link zip}
	 * @see {@link withLatestFrom}
	 *
	 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
	 * @param {function} [comparor] An optional function to compare each value pair
	 * @return {Observable} An Observable of a single boolean value representing whether or not
	 * the values emitted by both observables were equal in sequence.
	 * @method sequenceEqual
	 * @owner Observable
	 */
	function sequenceEqual(compareTo, comparor) {
	    return sequenceEqual_1.sequenceEqual(compareTo, comparor)(this);
	}
	exports.sequenceEqual = sequenceEqual;
	//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 4707 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var share_1 = __webpack_require__(822);
	/**
	 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
	 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
	 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
	 *
	 * This behaves similarly to .publish().refCount(), with a behavior difference when the source observable emits complete.
	 * .publish().refCount() will not resubscribe to the original source, however .share() will resubscribe to the original source.
	 * Observable.of("test").publish().refCount() will not re-emit "test" on new subscriptions, Observable.of("test").share() will
	 * re-emit "test" to new subscriptions.
	 *
	 * <img src="./img/share.png" width="100%">
	 *
	 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
	 * @method share
	 * @owner Observable
	 */
	function share() {
	    return share_1.share()(this);
	}
	exports.share = share;
	;
	//# sourceMappingURL=share.js.map

/***/ }),
/* 4708 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var shareReplay_1 = __webpack_require__(823);
	/**
	 * @method shareReplay
	 * @owner Observable
	 */
	function shareReplay(bufferSize, windowTime, scheduler) {
	    return shareReplay_1.shareReplay(bufferSize, windowTime, scheduler)(this);
	}
	exports.shareReplay = shareReplay;
	;
	//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 4709 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var single_1 = __webpack_require__(824);
	/**
	 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
	 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
	 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
	 *
	 * <img src="./img/single.png" width="100%">
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
	 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
	 * the predicate.
	 .
	 * @method single
	 * @owner Observable
	 */
	function single(predicate) {
	    return single_1.single(predicate)(this);
	}
	exports.single = single;
	//# sourceMappingURL=single.js.map

/***/ }),
/* 4710 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var skip_1 = __webpack_require__(825);
	/**
	 * Returns an Observable that skips the first `count` items emitted by the source Observable.
	 *
	 * <img src="./img/skip.png" width="100%">
	 *
	 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
	 * @return {Observable} An Observable that skips values emitted by the source Observable.
	 *
	 * @method skip
	 * @owner Observable
	 */
	function skip(count) {
	    return skip_1.skip(count)(this);
	}
	exports.skip = skip;
	//# sourceMappingURL=skip.js.map

/***/ }),
/* 4711 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var skipLast_1 = __webpack_require__(826);
	/**
	 * Skip the last `count` values emitted by the source Observable.
	 *
	 * <img src="./img/skipLast.png" width="100%">
	 *
	 * `skipLast` returns an Observable that accumulates a queue with a length
	 * enough to store the first `count` values. As more values are received,
	 * values are taken from the front of the queue and produced on the result
	 * sequence. This causes values to be delayed.
	 *
	 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
	 * var many = Rx.Observable.range(1, 5);
	 * var skipLastTwo = many.skipLast(2);
	 * skipLastTwo.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // 1 2 3
	 *
	 * @see {@link skip}
	 * @see {@link skipUntil}
	 * @see {@link skipWhile}
	 * @see {@link take}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
	 * ArgumentOutOrRangeError if `i < 0`.
	 *
	 * @param {number} count Number of elements to skip from the end of the source Observable.
	 * @returns {Observable<T>} An Observable that skips the last count values
	 * emitted by the source Observable.
	 * @method skipLast
	 * @owner Observable
	 */
	function skipLast(count) {
	    return skipLast_1.skipLast(count)(this);
	}
	exports.skipLast = skipLast;
	//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 4712 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var skipUntil_1 = __webpack_require__(827);
	/**
	 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
	 *
	 * <img src="./img/skipUntil.png" width="100%">
	 *
	 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
	 * be mirrored by the resulting Observable.
	 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
	 * an item, then emits the remaining items.
	 * @method skipUntil
	 * @owner Observable
	 */
	function skipUntil(notifier) {
	    return skipUntil_1.skipUntil(notifier)(this);
	}
	exports.skipUntil = skipUntil;
	//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 4713 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var skipWhile_1 = __webpack_require__(828);
	/**
	 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
	 * true, but emits all further source items as soon as the condition becomes false.
	 *
	 * <img src="./img/skipWhile.png" width="100%">
	 *
	 * @param {Function} predicate - A function to test each item emitted from the source Observable.
	 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
	 * specified predicate becomes false.
	 * @method skipWhile
	 * @owner Observable
	 */
	function skipWhile(predicate) {
	    return skipWhile_1.skipWhile(predicate)(this);
	}
	exports.skipWhile = skipWhile;
	//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 4714 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var startWith_1 = __webpack_require__(829);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits the items you specify as arguments before it begins to emit
	 * items emitted by the source Observable.
	 *
	 * <img src="./img/startWith.png" width="100%">
	 *
	 * @param {...T} values - Items you want the modified Observable to emit first.
	 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
	 * the emissions of the `next` notifications.
	 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
	 * emitted by the source Observable.
	 * @method startWith
	 * @owner Observable
	 */
	function startWith() {
	    var array = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        array[_i - 0] = arguments[_i];
	    }
	    return startWith_1.startWith.apply(void 0, array)(this);
	}
	exports.startWith = startWith;
	//# sourceMappingURL=startWith.js.map

/***/ }),
/* 4715 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var subscribeOn_1 = __webpack_require__(4736);
	/**
	 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
	 *
	 * <img src="./img/subscribeOn.png" width="100%">
	 *
	 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
	 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
	 .
	 * @method subscribeOn
	 * @owner Observable
	 */
	function subscribeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return subscribeOn_1.subscribeOn(scheduler, delay)(this);
	}
	exports.subscribeOn = subscribeOn;
	//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 4716 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var switchAll_1 = __webpack_require__(830);
	/**
	 * Converts a higher-order Observable into a first-order Observable by
	 * subscribing to only the most recently emitted of those inner Observables.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by dropping the
	 * previous inner Observable once a new one appears.</span>
	 *
	 * <img src="./img/switch.png" width="100%">
	 *
	 * `switch` subscribes to an Observable that emits Observables, also known as a
	 * higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, the output Observable subscribes to the inner Observable and
	 * begins emitting the items emitted by that. So far, it behaves
	 * like {@link mergeAll}. However, when a new inner Observable is emitted,
	 * `switch` unsubscribes from the earlier-emitted inner Observable and
	 * subscribes to the new inner Observable and begins emitting items from it. It
	 * continues to behave like this for subsequent inner Observables.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * // Each click event is mapped to an Observable that ticks every second
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
	 * var switched = higherOrder.switch();
	 * // The outcome is that `switched` is essentially a timer that restarts
	 * // on every click. The interval Observables from older clicks do not merge
	 * // with the current interval Observable.
	 * switched.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link exhaust}
	 * @see {@link mergeAll}
	 * @see {@link switchMap}
	 * @see {@link switchMapTo}
	 * @see {@link zipAll}
	 *
	 * @return {Observable<T>} An Observable that emits the items emitted by the
	 * Observable most recently emitted by the source Observable.
	 * @method switch
	 * @name switch
	 * @owner Observable
	 */
	function _switch() {
	    return switchAll_1.switchAll()(this);
	}
	exports._switch = _switch;
	//# sourceMappingURL=switch.js.map

/***/ }),
/* 4717 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var switchMapTo_1 = __webpack_require__(831);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is flattened multiple
	 * times with {@link switch} in the output Observable.
	 *
	 * <span class="informal">It's like {@link switchMap}, but maps each value
	 * always to the same inner Observable.</span>
	 *
	 * <img src="./img/switchMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then flattens those resulting Observables into one
	 * single Observable, which is the output Observable. The output Observables
	 * emits values only from the most recently emitted instance of
	 * `innerObservable`.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMapTo}
	 * @see {@link switch}
	 * @see {@link switchMap}
	 * @see {@link mergeMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits items from the given
	 * `innerObservable` (and optionally transformed through `resultSelector`) every
	 * time a value is emitted on the source Observable, and taking only the values
	 * from the most recently projected inner Observable.
	 * @method switchMapTo
	 * @owner Observable
	 */
	function switchMapTo(innerObservable, resultSelector) {
	    return switchMapTo_1.switchMapTo(innerObservable, resultSelector)(this);
	}
	exports.switchMapTo = switchMapTo;
	//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 4718 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var take_1 = __webpack_require__(832);
	/**
	 * Emits only the first `count` values emitted by the source Observable.
	 *
	 * <span class="informal">Takes the first `count` values from the source, then
	 * completes.</span>
	 *
	 * <img src="./img/take.png" width="100%">
	 *
	 * `take` returns an Observable that emits only the first `count` values emitted
	 * by the source Observable. If the source emits fewer than `count` values then
	 * all of its values are emitted. After that, it completes, regardless if the
	 * source completes.
	 *
	 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
	 * var interval = Rx.Observable.interval(1000);
	 * var five = interval.take(5);
	 * five.subscribe(x => console.log(x));
	 *
	 * @see {@link takeLast}
	 * @see {@link takeUntil}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
	 *
	 * @param {number} count The maximum number of `next` values to emit.
	 * @return {Observable<T>} An Observable that emits only the first `count`
	 * values emitted by the source Observable, or all of the values from the source
	 * if the source emits fewer than `count` values.
	 * @method take
	 * @owner Observable
	 */
	function take(count) {
	    return take_1.take(count)(this);
	}
	exports.take = take;
	//# sourceMappingURL=take.js.map

/***/ }),
/* 4719 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var takeLast_1 = __webpack_require__(520);
	/**
	 * Emits only the last `count` values emitted by the source Observable.
	 *
	 * <span class="informal">Remembers the latest `count` values, then emits those
	 * only when the source completes.</span>
	 *
	 * <img src="./img/takeLast.png" width="100%">
	 *
	 * `takeLast` returns an Observable that emits at most the last `count` values
	 * emitted by the source Observable. If the source emits fewer than `count`
	 * values then all of its values are emitted. This operator must wait until the
	 * `complete` notification emission from the source in order to emit the `next`
	 * values on the output Observable, because otherwise it is impossible to know
	 * whether or not more values will be emitted on the source. For this reason,
	 * all values are emitted synchronously, followed by the complete notification.
	 *
	 * @example <caption>Take the last 3 values of an Observable with many values</caption>
	 * var many = Rx.Observable.range(1, 100);
	 * var lastThree = many.takeLast(3);
	 * lastThree.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeUntil}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
	 *
	 * @param {number} count The maximum number of values to emit from the end of
	 * the sequence of values emitted by the source Observable.
	 * @return {Observable<T>} An Observable that emits at most the last count
	 * values emitted by the source Observable.
	 * @method takeLast
	 * @owner Observable
	 */
	function takeLast(count) {
	    return takeLast_1.takeLast(count)(this);
	}
	exports.takeLast = takeLast;
	//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 4720 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var takeUntil_1 = __webpack_require__(833);
	/**
	 * Emits the values emitted by the source Observable until a `notifier`
	 * Observable emits a value.
	 *
	 * <span class="informal">Lets values pass until a second Observable,
	 * `notifier`, emits something. Then, it completes.</span>
	 *
	 * <img src="./img/takeUntil.png" width="100%">
	 *
	 * `takeUntil` subscribes and begins mirroring the source Observable. It also
	 * monitors a second Observable, `notifier` that you provide. If the `notifier`
	 * emits a value, the output Observable stops mirroring the source Observable
	 * and completes.
	 *
	 * @example <caption>Tick every second until the first click happens</caption>
	 * var interval = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = interval.takeUntil(clicks);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeLast}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @param {Observable} notifier The Observable whose first emitted value will
	 * cause the output Observable of `takeUntil` to stop emitting values from the
	 * source Observable.
	 * @return {Observable<T>} An Observable that emits the values from the source
	 * Observable until such time as `notifier` emits its first value.
	 * @method takeUntil
	 * @owner Observable
	 */
	function takeUntil(notifier) {
	    return takeUntil_1.takeUntil(notifier)(this);
	}
	exports.takeUntil = takeUntil;
	//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 4721 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var takeWhile_1 = __webpack_require__(834);
	/**
	 * Emits values emitted by the source Observable so long as each value satisfies
	 * the given `predicate`, and then completes as soon as this `predicate` is not
	 * satisfied.
	 *
	 * <span class="informal">Takes values from the source only while they pass the
	 * condition given. When the first value does not satisfy, it completes.</span>
	 *
	 * <img src="./img/takeWhile.png" width="100%">
	 *
	 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
	 * emitted on the source is given to the `predicate` function which returns a
	 * boolean, representing a condition to be satisfied by the source values. The
	 * output Observable emits the source values until such time as the `predicate`
	 * returns false, at which point `takeWhile` stops mirroring the source
	 * Observable and completes the output Observable.
	 *
	 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.takeWhile(ev => ev.clientX > 200);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeLast}
	 * @see {@link takeUntil}
	 * @see {@link skip}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates a value emitted by the source Observable and returns a boolean.
	 * Also takes the (zero-based) index as the second argument.
	 * @return {Observable<T>} An Observable that emits the values from the source
	 * Observable so long as each value satisfies the condition defined by the
	 * `predicate`, then completes.
	 * @method takeWhile
	 * @owner Observable
	 */
	function takeWhile(predicate) {
	    return takeWhile_1.takeWhile(predicate)(this);
	}
	exports.takeWhile = takeWhile;
	//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 4722 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var throttle_1 = __webpack_require__(353);
	/**
	 * Emits a value from the source Observable, then ignores subsequent source
	 * values for a duration determined by another Observable, then repeats this
	 * process.
	 *
	 * <span class="informal">It's like {@link throttleTime}, but the silencing
	 * duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/throttle.png" width="100%">
	 *
	 * `throttle` emits the source Observable values on the output Observable
	 * when its internal timer is disabled, and ignores source values when the timer
	 * is enabled. Initially, the timer is disabled. As soon as the first source
	 * value arrives, it is forwarded to the output Observable, and then the timer
	 * is enabled by calling the `durationSelector` function with the source value,
	 * which returns the "duration" Observable. When the duration Observable emits a
	 * value or completes, the timer is disabled, and this process repeats for the
	 * next source value.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounce}
	 * @see {@link delayWhen}
	 * @see {@link sample}
	 * @see {@link throttleTime}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the silencing
	 * duration for each source value, returned as an Observable or a Promise.
	 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
	 * to `{ leading: true, trailing: false }`.
	 * @return {Observable<T>} An Observable that performs the throttle operation to
	 * limit the rate of emissions from the source.
	 * @method throttle
	 * @owner Observable
	 */
	function throttle(durationSelector, config) {
	    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
	    return throttle_1.throttle(durationSelector, config)(this);
	}
	exports.throttle = throttle;
	//# sourceMappingURL=throttle.js.map

/***/ }),
/* 4723 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(23);
	var throttle_1 = __webpack_require__(353);
	var throttleTime_1 = __webpack_require__(835);
	/**
	 * Emits a value from the source Observable, then ignores subsequent source
	 * values for `duration` milliseconds, then repeats this process.
	 *
	 * <span class="informal">Lets a value pass, then ignores source values for the
	 * next `duration` milliseconds.</span>
	 *
	 * <img src="./img/throttleTime.png" width="100%">
	 *
	 * `throttleTime` emits the source Observable values on the output Observable
	 * when its internal timer is disabled, and ignores source values when the timer
	 * is enabled. Initially, the timer is disabled. As soon as the first source
	 * value arrives, it is forwarded to the output Observable, and then the timer
	 * is enabled. After `duration` milliseconds (or the time unit determined
	 * internally by the optional `scheduler`) has passed, the timer is disabled,
	 * and this process repeats for the next source value. Optionally takes a
	 * {@link IScheduler} for managing timers.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.throttleTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttle}
	 *
	 * @param {number} duration Time to wait before emitting another value after
	 * emitting the last value, measured in milliseconds or the time unit determined
	 * internally by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the throttling.
	 * @return {Observable<T>} An Observable that performs the throttle operation to
	 * limit the rate of emissions from the source.
	 * @method throttleTime
	 * @owner Observable
	 */
	function throttleTime(duration, scheduler, config) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
	    return throttleTime_1.throttleTime(duration, scheduler, config)(this);
	}
	exports.throttleTime = throttleTime;
	//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 4724 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(23);
	var timeout_1 = __webpack_require__(837);
	/**
	 *
	 * Errors if Observable does not emit a value in given time span.
	 *
	 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
	 *
	 * <img src="./img/timeout.png" width="100%">
	 *
	 * `timeout` operator accepts as an argument either a number or a Date.
	 *
	 * If number was provided, it returns an Observable that behaves like a source
	 * Observable, unless there is a period of time where there is no value emitted.
	 * So if you provide `100` as argument and first value comes after 50ms from
	 * the moment of subscription, this value will be simply re-emitted by the resulting
	 * Observable. If however after that 100ms passes without a second value being emitted,
	 * stream will end with an error and source Observable will be unsubscribed.
	 * These checks are performed throughout whole lifecycle of Observable - from the moment
	 * it was subscribed to, until it completes or errors itself. Thus every value must be
	 * emitted within specified period since previous value.
	 *
	 * If provided argument was Date, returned Observable behaves differently. It throws
	 * if Observable did not complete before provided Date. This means that periods between
	 * emission of particular values do not matter in this case. If Observable did not complete
	 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
	 * stream behaves just as source Observable.
	 *
	 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
	 * when returned Observable will check if source stream emitted value or completed.
	 *
	 * @example <caption>Check if ticks are emitted within certain timespan</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 *
	 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
	 *                       // since `interval` might fire a bit later then scheduled.
	 * .subscribe(
	 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
	 *     err => console.log(err) // Will never be called.
	 * );
	 *
	 * seconds.timeout(900).subscribe(
	 *     value => console.log(value), // Will never be called.
	 *     err => console.log(err) // Will emit error before even first value is emitted,
	 *                             // since it did not arrive within 900ms period.
	 * );
	 *
	 * @example <caption>Use Date to check if Observable completed</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 *
	 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
	 * .subscribe(
	 *     value => console.log(value), // Will emit values as regular `interval` would
	 *                                  // until December 17, 2020 at 03:24:00.
	 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
	 *                             // since Observable did not complete by then.
	 * );
	 *
	 * @see {@link timeoutWith}
	 *
	 * @param {number|Date} due Number specifying period within which Observable must emit values
	 *                          or Date specifying before when Observable should complete
	 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
	 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
	 * @method timeout
	 * @owner Observable
	 */
	function timeout(due, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return timeout_1.timeout(due, scheduler)(this);
	}
	exports.timeout = timeout;
	//# sourceMappingURL=timeout.js.map

/***/ }),
/* 4725 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(23);
	var timeoutWith_1 = __webpack_require__(838);
	/* tslint:enable:max-line-length */
	/**
	 *
	 * Errors if Observable does not emit a value in given time span, in case of which
	 * subscribes to the second Observable.
	 *
	 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
	 *
	 * <img src="./img/timeoutWith.png" width="100%">
	 *
	 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
	 * still accepting as a first argument either a number or a Date, which control - respectively -
	 * when values of source Observable should be emitted or when it should complete.
	 *
	 * The only difference is that it accepts a second, required parameter. This parameter
	 * should be an Observable which will be subscribed when source Observable fails any timeout check.
	 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
	 * values from second Observable. Note that this fallback Observable is not checked for timeouts
	 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
	 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
	 * stream completes, it completes as well.
	 *
	 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
	 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
	 * as a consequence - when second Observable will be subscribed, since subscription happens
	 * immediately after failing check.
	 *
	 * @example <caption>Add fallback observable</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 * const minutes = Rx.Observable.interval(60 * 1000);
	 *
	 * seconds.timeoutWith(900, minutes)
	 *     .subscribe(
	 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
	 *                                      // since first value of `seconds` will not arrive fast enough.
	 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
	 *                                 // but here will never be called.
	 *     );
	 *
	 * @param {number|Date} due Number specifying period within which Observable must emit values
	 *                          or Date specifying before when Observable should complete
	 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
	 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
	 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
	 *                          passed as a second parameter.
	 * @method timeoutWith
	 * @owner Observable
	 */
	function timeoutWith(due, withObservable, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return timeoutWith_1.timeoutWith(due, withObservable, scheduler)(this);
	}
	exports.timeoutWith = timeoutWith;
	//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 4726 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(23);
	var timestamp_1 = __webpack_require__(521);
	/**
	 * @param scheduler
	 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
	 * @method timestamp
	 * @owner Observable
	 */
	function timestamp(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return timestamp_1.timestamp(scheduler)(this);
	}
	exports.timestamp = timestamp;
	//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 4727 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var toArray_1 = __webpack_require__(839);
	/**
	 * Collects all source emissions and emits them as an array when the source completes.
	 *
	 * <span class="informal">Get all values inside an array when the source completes</span>
	 *
	 * <img src="./img/toArray.png" width="100%">
	 *
	 * `toArray` will wait until the source Observable completes
	 * before emitting the array containing all emissions.
	 * When the source Observable errors no array will be emitted.
	 *
	 * @example <caption>Create array from input</caption>
	 * const input = Rx.Observable.interval(100).take(4);
	 *
	 * input.toArray()
	 *   .subscribe(arr => console.log(arr)); // [0,1,2,3]
	 *
	 * @see {@link buffer}
	 *
	 * @return {Observable<any[]>|WebSocketSubject<T>|Observable<T>}
	 * @method toArray
	 * @owner Observable
	 */
	function toArray() {
	    return toArray_1.toArray()(this);
	}
	exports.toArray = toArray;
	//# sourceMappingURL=toArray.js.map

/***/ }),
/* 4728 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var window_1 = __webpack_require__(840);
	/**
	 * Branch out the source Observable values as a nested Observable whenever
	 * `windowBoundaries` emits.
	 *
	 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
	 * instead of an array.</span>
	 *
	 * <img src="./img/window.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits connected, non-overlapping
	 * windows. It emits the current window and opens a new one whenever the
	 * Observable `windowBoundaries` emits an item. Because each window is an
	 * Observable, the output is a higher-order Observable.
	 *
	 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var interval = Rx.Observable.interval(1000);
	 * var result = clicks.window(interval)
	 *   .map(win => win.take(2)) // each window has at most 2 emissions
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link windowWhen}
	 * @see {@link buffer}
	 *
	 * @param {Observable<any>} windowBoundaries An Observable that completes the
	 * previous window and starts a new window.
	 * @return {Observable<Observable<T>>} An Observable of windows, which are
	 * Observables emitting values of the source Observable.
	 * @method window
	 * @owner Observable
	 */
	function window(windowBoundaries) {
	    return window_1.window(windowBoundaries)(this);
	}
	exports.window = window;
	//# sourceMappingURL=window.js.map

/***/ }),
/* 4729 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var windowCount_1 = __webpack_require__(841);
	/**
	 * Branch out the source Observable values as a nested Observable with each
	 * nested Observable emitting at most `windowSize` values.
	 *
	 * <span class="informal">It's like {@link bufferCount}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowCount.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits windows every `startWindowEvery`
	 * items, each containing no more than `windowSize` items. When the source
	 * Observable completes or encounters an error, the output Observable emits
	 * the current window and propagates the notification from the source
	 * Observable. If `startWindowEvery` is not provided, then new windows are
	 * started immediately at the start of the source and when each window completes
	 * with size `windowSize`.
	 *
	 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.windowCount(3)
	 *   .map(win => win.skip(1)) // skip first of every 3 clicks
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.windowCount(2, 3)
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link windowWhen}
	 * @see {@link bufferCount}
	 *
	 * @param {number} windowSize The maximum number of values emitted by each
	 * window.
	 * @param {number} [startWindowEvery] Interval at which to start a new window.
	 * For example if `startWindowEvery` is `2`, then a new window will be started
	 * on every other value from the source. A new window is started at the
	 * beginning of the source by default.
	 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
	 * are Observable of values.
	 * @method windowCount
	 * @owner Observable
	 */
	function windowCount(windowSize, startWindowEvery) {
	    if (startWindowEvery === void 0) { startWindowEvery = 0; }
	    return windowCount_1.windowCount(windowSize, startWindowEvery)(this);
	}
	exports.windowCount = windowCount;
	//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 4730 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(23);
	var isNumeric_1 = __webpack_require__(272);
	var isScheduler_1 = __webpack_require__(65);
	var windowTime_1 = __webpack_require__(842);
	function windowTime(windowTimeSpan) {
	    var scheduler = async_1.async;
	    var windowCreationInterval = null;
	    var maxWindowSize = Number.POSITIVE_INFINITY;
	    if (isScheduler_1.isScheduler(arguments[3])) {
	        scheduler = arguments[3];
	    }
	    if (isScheduler_1.isScheduler(arguments[2])) {
	        scheduler = arguments[2];
	    }
	    else if (isNumeric_1.isNumeric(arguments[2])) {
	        maxWindowSize = arguments[2];
	    }
	    if (isScheduler_1.isScheduler(arguments[1])) {
	        scheduler = arguments[1];
	    }
	    else if (isNumeric_1.isNumeric(arguments[1])) {
	        windowCreationInterval = arguments[1];
	    }
	    return windowTime_1.windowTime(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler)(this);
	}
	exports.windowTime = windowTime;
	//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 4731 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var windowToggle_1 = __webpack_require__(843);
	/**
	 * Branch out the source Observable values as a nested Observable starting from
	 * an emission from `openings` and ending when the output of `closingSelector`
	 * emits.
	 *
	 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowToggle.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits windows that contain those items
	 * emitted by the source Observable between the time when the `openings`
	 * Observable emits an item and when the Observable returned by
	 * `closingSelector` emits an item.
	 *
	 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var openings = Rx.Observable.interval(1000);
	 * var result = clicks.windowToggle(openings, i =>
	 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
	 * ).mergeAll();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowWhen}
	 * @see {@link bufferToggle}
	 *
	 * @param {Observable<O>} openings An observable of notifications to start new
	 * windows.
	 * @param {function(value: O): Observable} closingSelector A function that takes
	 * the value emitted by the `openings` observable and returns an Observable,
	 * which, when it emits (either `next` or `complete`), signals that the
	 * associated window should complete.
	 * @return {Observable<Observable<T>>} An observable of windows, which in turn
	 * are Observables.
	 * @method windowToggle
	 * @owner Observable
	 */
	function windowToggle(openings, closingSelector) {
	    return windowToggle_1.windowToggle(openings, closingSelector)(this);
	}
	exports.windowToggle = windowToggle;
	//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 4732 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var windowWhen_1 = __webpack_require__(844);
	/**
	 * Branch out the source Observable values as a nested Observable using a
	 * factory function of closing Observables to determine when to start a new
	 * window.
	 *
	 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowWhen.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits connected, non-overlapping windows.
	 * It emits the current window and opens a new one whenever the Observable
	 * produced by the specified `closingSelector` function emits an item. The first
	 * window is opened immediately when subscribing to the output Observable.
	 *
	 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks
	 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
	 *   .map(win => win.take(2)) // each window has at most 2 emissions
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link bufferWhen}
	 *
	 * @param {function(): Observable} closingSelector A function that takes no
	 * arguments and returns an Observable that signals (on either `next` or
	 * `complete`) when to close the previous window and start a new one.
	 * @return {Observable<Observable<T>>} An observable of windows, which in turn
	 * are Observables.
	 * @method windowWhen
	 * @owner Observable
	 */
	function windowWhen(closingSelector) {
	    return windowWhen_1.windowWhen(closingSelector)(this);
	}
	exports.windowWhen = windowWhen;
	//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 4733 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var withLatestFrom_1 = __webpack_require__(845);
	/* tslint:enable:max-line-length */
	/**
	 * Combines the source Observable with other Observables to create an Observable
	 * whose values are calculated from the latest values of each, only when the
	 * source emits.
	 *
	 * <span class="informal">Whenever the source Observable emits a value, it
	 * computes a formula using that value plus the latest values from other input
	 * Observables, then emits the output of that formula.</span>
	 *
	 * <img src="./img/withLatestFrom.png" width="100%">
	 *
	 * `withLatestFrom` combines each value from the source Observable (the
	 * instance) with the latest values from the other input Observables only when
	 * the source emits a value, optionally using a `project` function to determine
	 * the value to be emitted on the output Observable. All input Observables must
	 * emit at least one value before the output Observable will emit a value.
	 *
	 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var result = clicks.withLatestFrom(timer);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineLatest}
	 *
	 * @param {ObservableInput} other An input Observable to combine with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {Function} [project] Projection function for combining values
	 * together. Receives all values in order of the Observables passed, where the
	 * first parameter is a value from the source Observable. (e.g.
	 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
	 * passed, arrays will be emitted on the output Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @method withLatestFrom
	 * @owner Observable
	 */
	function withLatestFrom() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i - 0] = arguments[_i];
	    }
	    return withLatestFrom_1.withLatestFrom.apply(void 0, args)(this);
	}
	exports.withLatestFrom = withLatestFrom;
	//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 4734 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var zip_1 = __webpack_require__(354);
	/* tslint:enable:max-line-length */
	/**
	 * @param observables
	 * @return {Observable<R>}
	 * @method zip
	 * @owner Observable
	 */
	function zipProto() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return zip_1.zip.apply(void 0, observables)(this);
	}
	exports.zipProto = zipProto;
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 4735 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var zipAll_1 = __webpack_require__(846);
	/**
	 * @param project
	 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
	 * @method zipAll
	 * @owner Observable
	 */
	function zipAll(project) {
	    return zipAll_1.zipAll(project)(this);
	}
	exports.zipAll = zipAll;
	//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 4736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var SubscribeOnObservable_1 = __webpack_require__(4616);
	/**
	 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
	 *
	 * <img src="./img/subscribeOn.png" width="100%">
	 *
	 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
	 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
	 .
	 * @method subscribeOn
	 * @owner Observable
	 */
	function subscribeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return function subscribeOnOperatorFunction(source) {
	        return source.lift(new SubscribeOnOperator(scheduler, delay));
	    };
	}
	exports.subscribeOn = subscribeOn;
	var SubscribeOnOperator = (function () {
	    function SubscribeOnOperator(scheduler, delay) {
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    SubscribeOnOperator.prototype.call = function (subscriber, source) {
	        return new SubscribeOnObservable_1.SubscribeOnObservable(source, this.delay, this.scheduler).subscribe(subscriber);
	    };
	    return SubscribeOnOperator;
	}());
	//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 4737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(31);
	/**
	 * A unit of work to be executed in a {@link Scheduler}. An action is typically
	 * created from within a Scheduler and an RxJS user does not need to concern
	 * themselves about creating and manipulating an Action.
	 *
	 * ```ts
	 * class Action<T> extends Subscription {
	 *   new (scheduler: Scheduler, work: (state?: T) => void);
	 *   schedule(state?: T, delay: number = 0): Subscription;
	 * }
	 * ```
	 *
	 * @class Action<T>
	 */
	var Action = (function (_super) {
	    __extends(Action, _super);
	    function Action(scheduler, work) {
	        _super.call(this);
	    }
	    /**
	     * Schedules this action on its parent Scheduler for execution. May be passed
	     * some context object, `state`. May happen at some point in the future,
	     * according to the `delay` parameter, if specified.
	     * @param {T} [state] Some contextual data that the `work` function uses when
	     * called by the Scheduler.
	     * @param {number} [delay] Time to wait before executing the work, where the
	     * time unit is implicit and defined by the Scheduler.
	     * @return {void}
	     */
	    Action.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        return this;
	    };
	    return Action;
	}(Subscription_1.Subscription));
	exports.Action = Action;
	//# sourceMappingURL=Action.js.map

/***/ }),
/* 4738 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncAction_1 = __webpack_require__(268);
	var AnimationFrame_1 = __webpack_require__(4748);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AnimationFrameAction = (function (_super) {
	    __extends(AnimationFrameAction, _super);
	    function AnimationFrameAction(scheduler, work) {
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	    }
	    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay is greater than 0, request as an async action.
	        if (delay !== null && delay > 0) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        // Push the action to the end of the scheduler queue.
	        scheduler.actions.push(this);
	        // If an animation frame has already been requested, don't request another
	        // one. If an animation frame hasn't been requested yet, request one. Return
	        // the current animation frame request id.
	        return scheduler.scheduled || (scheduler.scheduled = AnimationFrame_1.AnimationFrame.requestAnimationFrame(scheduler.flush.bind(scheduler, null)));
	    };
	    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay exists and is greater than 0, or if the delay is null (the
	        // action wasn't rescheduled) but was originally scheduled as an async
	        // action, then recycle as an async action.
	        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
	            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
	        }
	        // If the scheduler queue is empty, cancel the requested animation frame and
	        // set the scheduled flag to undefined so the next AnimationFrameAction will
	        // request its own.
	        if (scheduler.actions.length === 0) {
	            AnimationFrame_1.AnimationFrame.cancelAnimationFrame(id);
	            scheduler.scheduled = undefined;
	        }
	        // Return undefined so the action knows to request a new async id if it's rescheduled.
	        return undefined;
	    };
	    return AnimationFrameAction;
	}(AsyncAction_1.AsyncAction));
	exports.AnimationFrameAction = AnimationFrameAction;
	//# sourceMappingURL=AnimationFrameAction.js.map

/***/ }),
/* 4739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncScheduler_1 = __webpack_require__(269);
	var AnimationFrameScheduler = (function (_super) {
	    __extends(AnimationFrameScheduler, _super);
	    function AnimationFrameScheduler() {
	        _super.apply(this, arguments);
	    }
	    AnimationFrameScheduler.prototype.flush = function (action) {
	        this.active = true;
	        this.scheduled = undefined;
	        var actions = this.actions;
	        var error;
	        var index = -1;
	        var count = actions.length;
	        action = action || actions.shift();
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (++index < count && (action = actions.shift()));
	        this.active = false;
	        if (error) {
	            while (++index < count && (action = actions.shift())) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AnimationFrameScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.AnimationFrameScheduler = AnimationFrameScheduler;
	//# sourceMappingURL=AnimationFrameScheduler.js.map

/***/ }),
/* 4740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Immediate_1 = __webpack_require__(4750);
	var AsyncAction_1 = __webpack_require__(268);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AsapAction = (function (_super) {
	    __extends(AsapAction, _super);
	    function AsapAction(scheduler, work) {
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	    }
	    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay is greater than 0, request as an async action.
	        if (delay !== null && delay > 0) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        // Push the action to the end of the scheduler queue.
	        scheduler.actions.push(this);
	        // If a microtask has already been scheduled, don't schedule another
	        // one. If a microtask hasn't been scheduled yet, schedule one now. Return
	        // the current scheduled microtask id.
	        return scheduler.scheduled || (scheduler.scheduled = Immediate_1.Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
	    };
	    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay exists and is greater than 0, or if the delay is null (the
	        // action wasn't rescheduled) but was originally scheduled as an async
	        // action, then recycle as an async action.
	        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
	            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
	        }
	        // If the scheduler queue is empty, cancel the requested microtask and
	        // set the scheduled flag to undefined so the next AsapAction will schedule
	        // its own.
	        if (scheduler.actions.length === 0) {
	            Immediate_1.Immediate.clearImmediate(id);
	            scheduler.scheduled = undefined;
	        }
	        // Return undefined so the action knows to request a new async id if it's rescheduled.
	        return undefined;
	    };
	    return AsapAction;
	}(AsyncAction_1.AsyncAction));
	exports.AsapAction = AsapAction;
	//# sourceMappingURL=AsapAction.js.map

/***/ }),
/* 4741 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncScheduler_1 = __webpack_require__(269);
	var AsapScheduler = (function (_super) {
	    __extends(AsapScheduler, _super);
	    function AsapScheduler() {
	        _super.apply(this, arguments);
	    }
	    AsapScheduler.prototype.flush = function (action) {
	        this.active = true;
	        this.scheduled = undefined;
	        var actions = this.actions;
	        var error;
	        var index = -1;
	        var count = actions.length;
	        action = action || actions.shift();
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (++index < count && (action = actions.shift()));
	        this.active = false;
	        if (error) {
	            while (++index < count && (action = actions.shift())) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AsapScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.AsapScheduler = AsapScheduler;
	//# sourceMappingURL=AsapScheduler.js.map

/***/ }),
/* 4742 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncAction_1 = __webpack_require__(268);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var QueueAction = (function (_super) {
	    __extends(QueueAction, _super);
	    function QueueAction(scheduler, work) {
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	    }
	    QueueAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (delay > 0) {
	            return _super.prototype.schedule.call(this, state, delay);
	        }
	        this.delay = delay;
	        this.state = state;
	        this.scheduler.flush(this);
	        return this;
	    };
	    QueueAction.prototype.execute = function (state, delay) {
	        return (delay > 0 || this.closed) ?
	            _super.prototype.execute.call(this, state, delay) :
	            this._execute(state, delay);
	    };
	    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay exists and is greater than 0, or if the delay is null (the
	        // action wasn't rescheduled) but was originally scheduled as an async
	        // action, then recycle as an async action.
	        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        // Otherwise flush the scheduler starting with this action.
	        return scheduler.flush(this);
	    };
	    return QueueAction;
	}(AsyncAction_1.AsyncAction));
	exports.QueueAction = QueueAction;
	//# sourceMappingURL=QueueAction.js.map

/***/ }),
/* 4743 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncScheduler_1 = __webpack_require__(269);
	var QueueScheduler = (function (_super) {
	    __extends(QueueScheduler, _super);
	    function QueueScheduler() {
	        _super.apply(this, arguments);
	    }
	    return QueueScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.QueueScheduler = QueueScheduler;
	//# sourceMappingURL=QueueScheduler.js.map

/***/ }),
/* 4744 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var AnimationFrameAction_1 = __webpack_require__(4738);
	var AnimationFrameScheduler_1 = __webpack_require__(4739);
	/**
	 *
	 * Animation Frame Scheduler
	 *
	 * <span class="informal">Perform task when `window.requestAnimationFrame` would fire</span>
	 *
	 * When `animationFrame` scheduler is used with delay, it will fall back to {@link async} scheduler
	 * behaviour.
	 *
	 * Without delay, `animationFrame` scheduler can be used to create smooth browser animations.
	 * It makes sure scheduled task will happen just before next browser content repaint,
	 * thus performing animations as efficiently as possible.
	 *
	 * @example <caption>Schedule div height animation</caption>
	 * const div = document.querySelector('.some-div');
	 *
	 * Rx.Scheduler.schedule(function(height) {
	 *   div.style.height = height + "px";
	 *
	 *   this.schedule(height + 1);  // `this` references currently executing Action,
	 *                               // which we reschedule with new state
	 * }, 0, 0);
	 *
	 * // You will see .some-div element growing in height
	 *
	 *
	 * @static true
	 * @name animationFrame
	 * @owner Scheduler
	 */
	exports.animationFrame = new AnimationFrameScheduler_1.AnimationFrameScheduler(AnimationFrameAction_1.AnimationFrameAction);
	//# sourceMappingURL=animationFrame.js.map

/***/ }),
/* 4745 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	var Subscription_1 = __webpack_require__(31);
	var SubscriptionLoggable_1 = __webpack_require__(851);
	var applyMixins_1 = __webpack_require__(854);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ColdObservable = (function (_super) {
	    __extends(ColdObservable, _super);
	    function ColdObservable(messages, scheduler) {
	        _super.call(this, function (subscriber) {
	            var observable = this;
	            var index = observable.logSubscribedFrame();
	            subscriber.add(new Subscription_1.Subscription(function () {
	                observable.logUnsubscribedFrame(index);
	            }));
	            observable.scheduleMessages(subscriber);
	            return subscriber;
	        });
	        this.messages = messages;
	        this.subscriptions = [];
	        this.scheduler = scheduler;
	    }
	    ColdObservable.prototype.scheduleMessages = function (subscriber) {
	        var messagesLength = this.messages.length;
	        for (var i = 0; i < messagesLength; i++) {
	            var message = this.messages[i];
	            subscriber.add(this.scheduler.schedule(function (_a) {
	                var message = _a.message, subscriber = _a.subscriber;
	                message.notification.observe(subscriber);
	            }, message.frame, { message: message, subscriber: subscriber }));
	        }
	    };
	    return ColdObservable;
	}(Observable_1.Observable));
	exports.ColdObservable = ColdObservable;
	applyMixins_1.applyMixins(ColdObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
	//# sourceMappingURL=ColdObservable.js.map

/***/ }),
/* 4746 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(30);
	var Subscription_1 = __webpack_require__(31);
	var SubscriptionLoggable_1 = __webpack_require__(851);
	var applyMixins_1 = __webpack_require__(854);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var HotObservable = (function (_super) {
	    __extends(HotObservable, _super);
	    function HotObservable(messages, scheduler) {
	        _super.call(this);
	        this.messages = messages;
	        this.subscriptions = [];
	        this.scheduler = scheduler;
	    }
	    HotObservable.prototype._subscribe = function (subscriber) {
	        var subject = this;
	        var index = subject.logSubscribedFrame();
	        subscriber.add(new Subscription_1.Subscription(function () {
	            subject.logUnsubscribedFrame(index);
	        }));
	        return _super.prototype._subscribe.call(this, subscriber);
	    };
	    HotObservable.prototype.setup = function () {
	        var subject = this;
	        var messagesLength = subject.messages.length;
	        /* tslint:disable:no-var-keyword */
	        for (var i = 0; i < messagesLength; i++) {
	            (function () {
	                var message = subject.messages[i];
	                /* tslint:enable */
	                subject.scheduler.schedule(function () { message.notification.observe(subject); }, message.frame);
	            })();
	        }
	    };
	    return HotObservable;
	}(Subject_1.Subject));
	exports.HotObservable = HotObservable;
	applyMixins_1.applyMixins(HotObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
	//# sourceMappingURL=HotObservable.js.map

/***/ }),
/* 4747 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(4);
	var Notification_1 = __webpack_require__(264);
	var ColdObservable_1 = __webpack_require__(4745);
	var HotObservable_1 = __webpack_require__(4746);
	var SubscriptionLog_1 = __webpack_require__(850);
	var VirtualTimeScheduler_1 = __webpack_require__(847);
	var defaultMaxFrame = 750;
	var TestScheduler = (function (_super) {
	    __extends(TestScheduler, _super);
	    function TestScheduler(assertDeepEqual) {
	        _super.call(this, VirtualTimeScheduler_1.VirtualAction, defaultMaxFrame);
	        this.assertDeepEqual = assertDeepEqual;
	        this.hotObservables = [];
	        this.coldObservables = [];
	        this.flushTests = [];
	    }
	    TestScheduler.prototype.createTime = function (marbles) {
	        var indexOf = marbles.indexOf('|');
	        if (indexOf === -1) {
	            throw new Error('marble diagram for time should have a completion marker "|"');
	        }
	        return indexOf * TestScheduler.frameTimeFactor;
	    };
	    TestScheduler.prototype.createColdObservable = function (marbles, values, error) {
	        if (marbles.indexOf('^') !== -1) {
	            throw new Error('cold observable cannot have subscription offset "^"');
	        }
	        if (marbles.indexOf('!') !== -1) {
	            throw new Error('cold observable cannot have unsubscription marker "!"');
	        }
	        var messages = TestScheduler.parseMarbles(marbles, values, error);
	        var cold = new ColdObservable_1.ColdObservable(messages, this);
	        this.coldObservables.push(cold);
	        return cold;
	    };
	    TestScheduler.prototype.createHotObservable = function (marbles, values, error) {
	        if (marbles.indexOf('!') !== -1) {
	            throw new Error('hot observable cannot have unsubscription marker "!"');
	        }
	        var messages = TestScheduler.parseMarbles(marbles, values, error);
	        var subject = new HotObservable_1.HotObservable(messages, this);
	        this.hotObservables.push(subject);
	        return subject;
	    };
	    TestScheduler.prototype.materializeInnerObservable = function (observable, outerFrame) {
	        var _this = this;
	        var messages = [];
	        observable.subscribe(function (value) {
	            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createNext(value) });
	        }, function (err) {
	            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createError(err) });
	        }, function () {
	            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createComplete() });
	        });
	        return messages;
	    };
	    TestScheduler.prototype.expectObservable = function (observable, unsubscriptionMarbles) {
	        var _this = this;
	        if (unsubscriptionMarbles === void 0) { unsubscriptionMarbles = null; }
	        var actual = [];
	        var flushTest = { actual: actual, ready: false };
	        var unsubscriptionFrame = TestScheduler
	            .parseMarblesAsSubscriptions(unsubscriptionMarbles).unsubscribedFrame;
	        var subscription;
	        this.schedule(function () {
	            subscription = observable.subscribe(function (x) {
	                var value = x;
	                // Support Observable-of-Observables
	                if (x instanceof Observable_1.Observable) {
	                    value = _this.materializeInnerObservable(value, _this.frame);
	                }
	                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createNext(value) });
	            }, function (err) {
	                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createError(err) });
	            }, function () {
	                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createComplete() });
	            });
	        }, 0);
	        if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
	            this.schedule(function () { return subscription.unsubscribe(); }, unsubscriptionFrame);
	        }
	        this.flushTests.push(flushTest);
	        return {
	            toBe: function (marbles, values, errorValue) {
	                flushTest.ready = true;
	                flushTest.expected = TestScheduler.parseMarbles(marbles, values, errorValue, true);
	            }
	        };
	    };
	    TestScheduler.prototype.expectSubscriptions = function (actualSubscriptionLogs) {
	        var flushTest = { actual: actualSubscriptionLogs, ready: false };
	        this.flushTests.push(flushTest);
	        return {
	            toBe: function (marbles) {
	                var marblesArray = (typeof marbles === 'string') ? [marbles] : marbles;
	                flushTest.ready = true;
	                flushTest.expected = marblesArray.map(function (marbles) {
	                    return TestScheduler.parseMarblesAsSubscriptions(marbles);
	                });
	            }
	        };
	    };
	    TestScheduler.prototype.flush = function () {
	        var hotObservables = this.hotObservables;
	        while (hotObservables.length > 0) {
	            hotObservables.shift().setup();
	        }
	        _super.prototype.flush.call(this);
	        var readyFlushTests = this.flushTests.filter(function (test) { return test.ready; });
	        while (readyFlushTests.length > 0) {
	            var test = readyFlushTests.shift();
	            this.assertDeepEqual(test.actual, test.expected);
	        }
	    };
	    TestScheduler.parseMarblesAsSubscriptions = function (marbles) {
	        if (typeof marbles !== 'string') {
	            return new SubscriptionLog_1.SubscriptionLog(Number.POSITIVE_INFINITY);
	        }
	        var len = marbles.length;
	        var groupStart = -1;
	        var subscriptionFrame = Number.POSITIVE_INFINITY;
	        var unsubscriptionFrame = Number.POSITIVE_INFINITY;
	        for (var i = 0; i < len; i++) {
	            var frame = i * this.frameTimeFactor;
	            var c = marbles[i];
	            switch (c) {
	                case '-':
	                case ' ':
	                    break;
	                case '(':
	                    groupStart = frame;
	                    break;
	                case ')':
	                    groupStart = -1;
	                    break;
	                case '^':
	                    if (subscriptionFrame !== Number.POSITIVE_INFINITY) {
	                        throw new Error('found a second subscription point \'^\' in a ' +
	                            'subscription marble diagram. There can only be one.');
	                    }
	                    subscriptionFrame = groupStart > -1 ? groupStart : frame;
	                    break;
	                case '!':
	                    if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
	                        throw new Error('found a second subscription point \'^\' in a ' +
	                            'subscription marble diagram. There can only be one.');
	                    }
	                    unsubscriptionFrame = groupStart > -1 ? groupStart : frame;
	                    break;
	                default:
	                    throw new Error('there can only be \'^\' and \'!\' markers in a ' +
	                        'subscription marble diagram. Found instead \'' + c + '\'.');
	            }
	        }
	        if (unsubscriptionFrame < 0) {
	            return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame);
	        }
	        else {
	            return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame, unsubscriptionFrame);
	        }
	    };
	    TestScheduler.parseMarbles = function (marbles, values, errorValue, materializeInnerObservables) {
	        if (materializeInnerObservables === void 0) { materializeInnerObservables = false; }
	        if (marbles.indexOf('!') !== -1) {
	            throw new Error('conventional marble diagrams cannot have the ' +
	                'unsubscription marker "!"');
	        }
	        var len = marbles.length;
	        var testMessages = [];
	        var subIndex = marbles.indexOf('^');
	        var frameOffset = subIndex === -1 ? 0 : (subIndex * -this.frameTimeFactor);
	        var getValue = typeof values !== 'object' ?
	            function (x) { return x; } :
	            function (x) {
	                // Support Observable-of-Observables
	                if (materializeInnerObservables && values[x] instanceof ColdObservable_1.ColdObservable) {
	                    return values[x].messages;
	                }
	                return values[x];
	            };
	        var groupStart = -1;
	        for (var i = 0; i < len; i++) {
	            var frame = i * this.frameTimeFactor + frameOffset;
	            var notification = void 0;
	            var c = marbles[i];
	            switch (c) {
	                case '-':
	                case ' ':
	                    break;
	                case '(':
	                    groupStart = frame;
	                    break;
	                case ')':
	                    groupStart = -1;
	                    break;
	                case '|':
	                    notification = Notification_1.Notification.createComplete();
	                    break;
	                case '^':
	                    break;
	                case '#':
	                    notification = Notification_1.Notification.createError(errorValue || 'error');
	                    break;
	                default:
	                    notification = Notification_1.Notification.createNext(getValue(c));
	                    break;
	            }
	            if (notification) {
	                testMessages.push({ frame: groupStart > -1 ? groupStart : frame, notification: notification });
	            }
	        }
	        return testMessages;
	    };
	    return TestScheduler;
	}(VirtualTimeScheduler_1.VirtualTimeScheduler));
	exports.TestScheduler = TestScheduler;
	//# sourceMappingURL=TestScheduler.js.map

/***/ }),
/* 4748 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(39);
	var RequestAnimationFrameDefinition = (function () {
	    function RequestAnimationFrameDefinition(root) {
	        if (root.requestAnimationFrame) {
	            this.cancelAnimationFrame = root.cancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.requestAnimationFrame.bind(root);
	        }
	        else if (root.mozRequestAnimationFrame) {
	            this.cancelAnimationFrame = root.mozCancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.mozRequestAnimationFrame.bind(root);
	        }
	        else if (root.webkitRequestAnimationFrame) {
	            this.cancelAnimationFrame = root.webkitCancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.webkitRequestAnimationFrame.bind(root);
	        }
	        else if (root.msRequestAnimationFrame) {
	            this.cancelAnimationFrame = root.msCancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.msRequestAnimationFrame.bind(root);
	        }
	        else if (root.oRequestAnimationFrame) {
	            this.cancelAnimationFrame = root.oCancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.oRequestAnimationFrame.bind(root);
	        }
	        else {
	            this.cancelAnimationFrame = root.clearTimeout.bind(root);
	            this.requestAnimationFrame = function (cb) { return root.setTimeout(cb, 1000 / 60); };
	        }
	    }
	    return RequestAnimationFrameDefinition;
	}());
	exports.RequestAnimationFrameDefinition = RequestAnimationFrameDefinition;
	exports.AnimationFrame = new RequestAnimationFrameDefinition(root_1.root);
	//# sourceMappingURL=AnimationFrame.js.map

/***/ }),
/* 4749 */
/***/ (function(module, exports) {

	"use strict";
	var FastMap = (function () {
	    function FastMap() {
	        this.values = {};
	    }
	    FastMap.prototype.delete = function (key) {
	        this.values[key] = null;
	        return true;
	    };
	    FastMap.prototype.set = function (key, value) {
	        this.values[key] = value;
	        return this;
	    };
	    FastMap.prototype.get = function (key) {
	        return this.values[key];
	    };
	    FastMap.prototype.forEach = function (cb, thisArg) {
	        var values = this.values;
	        for (var key in values) {
	            if (values.hasOwnProperty(key) && values[key] !== null) {
	                cb.call(thisArg, values[key], key);
	            }
	        }
	    };
	    FastMap.prototype.clear = function () {
	        this.values = {};
	    };
	    return FastMap;
	}());
	exports.FastMap = FastMap;
	//# sourceMappingURL=FastMap.js.map

/***/ }),
/* 4750 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(clearImmediate, setImmediate) {/**
	Some credit for this helper goes to http://github.com/YuzuJS/setImmediate
	*/
	"use strict";
	var root_1 = __webpack_require__(39);
	var ImmediateDefinition = (function () {
	    function ImmediateDefinition(root) {
	        this.root = root;
	        if (root.setImmediate && typeof root.setImmediate === 'function') {
	            this.setImmediate = root.setImmediate.bind(root);
	            this.clearImmediate = root.clearImmediate.bind(root);
	        }
	        else {
	            this.nextHandle = 1;
	            this.tasksByHandle = {};
	            this.currentlyRunningATask = false;
	            // Don't get fooled by e.g. browserify environments.
	            if (this.canUseProcessNextTick()) {
	                // For Node.js before 0.9
	                this.setImmediate = this.createProcessNextTickSetImmediate();
	            }
	            else if (this.canUsePostMessage()) {
	                // For non-IE10 modern browsers
	                this.setImmediate = this.createPostMessageSetImmediate();
	            }
	            else if (this.canUseMessageChannel()) {
	                // For web workers, where supported
	                this.setImmediate = this.createMessageChannelSetImmediate();
	            }
	            else if (this.canUseReadyStateChange()) {
	                // For IE 6–8
	                this.setImmediate = this.createReadyStateChangeSetImmediate();
	            }
	            else {
	                // For older browsers
	                this.setImmediate = this.createSetTimeoutSetImmediate();
	            }
	            var ci = function clearImmediate(handle) {
	                delete clearImmediate.instance.tasksByHandle[handle];
	            };
	            ci.instance = this;
	            this.clearImmediate = ci;
	        }
	    }
	    ImmediateDefinition.prototype.identify = function (o) {
	        return this.root.Object.prototype.toString.call(o);
	    };
	    ImmediateDefinition.prototype.canUseProcessNextTick = function () {
	        return this.identify(this.root.process) === '[object process]';
	    };
	    ImmediateDefinition.prototype.canUseMessageChannel = function () {
	        return Boolean(this.root.MessageChannel);
	    };
	    ImmediateDefinition.prototype.canUseReadyStateChange = function () {
	        var document = this.root.document;
	        return Boolean(document && 'onreadystatechange' in document.createElement('script'));
	    };
	    ImmediateDefinition.prototype.canUsePostMessage = function () {
	        var root = this.root;
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `root.postMessage` means something completely different and can't be used for this purpose.
	        if (root.postMessage && !root.importScripts) {
	            var postMessageIsAsynchronous_1 = true;
	            var oldOnMessage = root.onmessage;
	            root.onmessage = function () {
	                postMessageIsAsynchronous_1 = false;
	            };
	            root.postMessage('', '*');
	            root.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous_1;
	        }
	        return false;
	    };
	    // This function accepts the same arguments as setImmediate, but
	    // returns a function that requires no arguments.
	    ImmediateDefinition.prototype.partiallyApplied = function (handler) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var fn = function result() {
	            var _a = result, handler = _a.handler, args = _a.args;
	            if (typeof handler === 'function') {
	                handler.apply(undefined, args);
	            }
	            else {
	                (new Function('' + handler))();
	            }
	        };
	        fn.handler = handler;
	        fn.args = args;
	        return fn;
	    };
	    ImmediateDefinition.prototype.addFromSetImmediateArguments = function (args) {
	        this.tasksByHandle[this.nextHandle] = this.partiallyApplied.apply(undefined, args);
	        return this.nextHandle++;
	    };
	    ImmediateDefinition.prototype.createProcessNextTickSetImmediate = function () {
	        var fn = function setImmediate() {
	            var instance = setImmediate.instance;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            instance.root.process.nextTick(instance.partiallyApplied(instance.runIfPresent, handle));
	            return handle;
	        };
	        fn.instance = this;
	        return fn;
	    };
	    ImmediateDefinition.prototype.createPostMessageSetImmediate = function () {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	        var root = this.root;
	        var messagePrefix = 'setImmediate$' + root.Math.random() + '$';
	        var onGlobalMessage = function globalMessageHandler(event) {
	            var instance = globalMessageHandler.instance;
	            if (event.source === root &&
	                typeof event.data === 'string' &&
	                event.data.indexOf(messagePrefix) === 0) {
	                instance.runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	        onGlobalMessage.instance = this;
	        root.addEventListener('message', onGlobalMessage, false);
	        var fn = function setImmediate() {
	            var _a = setImmediate, messagePrefix = _a.messagePrefix, instance = _a.instance;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            instance.root.postMessage(messagePrefix + handle, '*');
	            return handle;
	        };
	        fn.instance = this;
	        fn.messagePrefix = messagePrefix;
	        return fn;
	    };
	    ImmediateDefinition.prototype.runIfPresent = function (handle) {
	        // From the spec: 'Wait until any invocations of this algorithm started before this one have completed.'
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (this.currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // 'too much recursion' error.
	            this.root.setTimeout(this.partiallyApplied(this.runIfPresent, handle), 0);
	        }
	        else {
	            var task = this.tasksByHandle[handle];
	            if (task) {
	                this.currentlyRunningATask = true;
	                try {
	                    task();
	                }
	                finally {
	                    this.clearImmediate(handle);
	                    this.currentlyRunningATask = false;
	                }
	            }
	        }
	    };
	    ImmediateDefinition.prototype.createMessageChannelSetImmediate = function () {
	        var _this = this;
	        var channel = new this.root.MessageChannel();
	        channel.port1.onmessage = function (event) {
	            var handle = event.data;
	            _this.runIfPresent(handle);
	        };
	        var fn = function setImmediate() {
	            var _a = setImmediate, channel = _a.channel, instance = _a.instance;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            channel.port2.postMessage(handle);
	            return handle;
	        };
	        fn.channel = channel;
	        fn.instance = this;
	        return fn;
	    };
	    ImmediateDefinition.prototype.createReadyStateChangeSetImmediate = function () {
	        var fn = function setImmediate() {
	            var instance = setImmediate.instance;
	            var root = instance.root;
	            var doc = root.document;
	            var html = doc.documentElement;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement('script');
	            script.onreadystatechange = function () {
	                instance.runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	            return handle;
	        };
	        fn.instance = this;
	        return fn;
	    };
	    ImmediateDefinition.prototype.createSetTimeoutSetImmediate = function () {
	        var fn = function setImmediate() {
	            var instance = setImmediate.instance;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            instance.root.setTimeout(instance.partiallyApplied(instance.runIfPresent, handle), 0);
	            return handle;
	        };
	        fn.instance = this;
	        return fn;
	    };
	    return ImmediateDefinition;
	}());
	exports.ImmediateDefinition = ImmediateDefinition;
	exports.Immediate = new ImmediateDefinition(root_1.root);
	//# sourceMappingURL=Immediate.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(361).clearImmediate, __webpack_require__(361).setImmediate))

/***/ }),
/* 4751 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(39);
	var MapPolyfill_1 = __webpack_require__(4752);
	exports.Map = root_1.root.Map || (function () { return MapPolyfill_1.MapPolyfill; })();
	//# sourceMappingURL=Map.js.map

/***/ }),
/* 4752 */
/***/ (function(module, exports) {

	"use strict";
	var MapPolyfill = (function () {
	    function MapPolyfill() {
	        this.size = 0;
	        this._values = [];
	        this._keys = [];
	    }
	    MapPolyfill.prototype.get = function (key) {
	        var i = this._keys.indexOf(key);
	        return i === -1 ? undefined : this._values[i];
	    };
	    MapPolyfill.prototype.set = function (key, value) {
	        var i = this._keys.indexOf(key);
	        if (i === -1) {
	            this._keys.push(key);
	            this._values.push(value);
	            this.size++;
	        }
	        else {
	            this._values[i] = value;
	        }
	        return this;
	    };
	    MapPolyfill.prototype.delete = function (key) {
	        var i = this._keys.indexOf(key);
	        if (i === -1) {
	            return false;
	        }
	        this._values.splice(i, 1);
	        this._keys.splice(i, 1);
	        this.size--;
	        return true;
	    };
	    MapPolyfill.prototype.clear = function () {
	        this._keys.length = 0;
	        this._values.length = 0;
	        this.size = 0;
	    };
	    MapPolyfill.prototype.forEach = function (cb, thisArg) {
	        for (var i = 0; i < this.size; i++) {
	            cb.call(thisArg, this._values[i], this._keys[i]);
	        }
	    };
	    return MapPolyfill;
	}());
	exports.MapPolyfill = MapPolyfill;
	//# sourceMappingURL=MapPolyfill.js.map

/***/ }),
/* 4753 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(39);
	function minimalSetImpl() {
	    // THIS IS NOT a full impl of Set, this is just the minimum
	    // bits of functionality we need for this library.
	    return (function () {
	        function MinimalSet() {
	            this._values = [];
	        }
	        MinimalSet.prototype.add = function (value) {
	            if (!this.has(value)) {
	                this._values.push(value);
	            }
	        };
	        MinimalSet.prototype.has = function (value) {
	            return this._values.indexOf(value) !== -1;
	        };
	        Object.defineProperty(MinimalSet.prototype, "size", {
	            get: function () {
	                return this._values.length;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        MinimalSet.prototype.clear = function () {
	            this._values.length = 0;
	        };
	        return MinimalSet;
	    }());
	}
	exports.minimalSetImpl = minimalSetImpl;
	exports.Set = root_1.root.Set || minimalSetImpl();
	//# sourceMappingURL=Set.js.map

/***/ }),
/* 4754 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(39);
	function assignImpl(target) {
	    var sources = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        sources[_i - 1] = arguments[_i];
	    }
	    var len = sources.length;
	    for (var i = 0; i < len; i++) {
	        var source = sources[i];
	        for (var k in source) {
	            if (source.hasOwnProperty(k)) {
	                target[k] = source[k];
	            }
	        }
	    }
	    return target;
	}
	exports.assignImpl = assignImpl;
	;
	function getAssign(root) {
	    return root.Object.assign || assignImpl;
	}
	exports.getAssign = getAssign;
	exports.assign = getAssign(root_1.root);
	//# sourceMappingURL=assign.js.map

/***/ }),
/* 4755 */
/***/ (function(module, exports) {

	"use strict";
	function not(pred, thisArg) {
	    function notPred() {
	        return !(notPred.pred.apply(notPred.thisArg, arguments));
	    }
	    notPred.pred = pred;
	    notPred.thisArg = thisArg;
	    return notPred;
	}
	exports.not = not;
	//# sourceMappingURL=not.js.map

/***/ }),
/* 4756 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Subscriber_1 = __webpack_require__(11);
	var rxSubscriber_1 = __webpack_require__(356);
	var Observer_1 = __webpack_require__(760);
	function toSubscriber(nextOrObserver, error, complete) {
	    if (nextOrObserver) {
	        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
	            return nextOrObserver;
	        }
	        if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
	            return nextOrObserver[rxSubscriber_1.rxSubscriber]();
	        }
	    }
	    if (!nextOrObserver && !error && !complete) {
	        return new Subscriber_1.Subscriber(Observer_1.empty);
	    }
	    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
	}
	exports.toSubscriber = toSubscriber;
	//# sourceMappingURL=toSubscriber.js.map

/***/ }),
/* 4757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _off = __webpack_require__(132);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _on = __webpack_require__(133);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _scrollLeft = __webpack_require__(1150);
	
	var _scrollLeft2 = _interopRequireDefault(_scrollLeft);
	
	var _scrollTop = __webpack_require__(1151);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _requestAnimationFrame = __webpack_require__(1159);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _invariant = __webpack_require__(25);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(4758);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-underscore-dangle */
	
	// Try at most this many times to scroll, to avoid getting stuck.
	var MAX_SCROLL_ATTEMPTS = 2;
	
	var ScrollBehavior = function () {
	  function ScrollBehavior(_ref) {
	    var _this = this;
	
	    var addTransitionHook = _ref.addTransitionHook,
	        stateStorage = _ref.stateStorage,
	        getCurrentLocation = _ref.getCurrentLocation,
	        shouldUpdateScroll = _ref.shouldUpdateScroll;
	
	    _classCallCheck(this, ScrollBehavior);
	
	    this._onWindowScroll = function () {
	      // It's possible that this scroll operation was triggered by what will be a
	      // `POP` transition. Instead of updating the saved location immediately, we
	      // have to enqueue the update, then potentially cancel it if we observe a
	      // location update.
	      if (!_this._saveWindowPositionHandle) {
	        _this._saveWindowPositionHandle = (0, _requestAnimationFrame2.default)(_this._saveWindowPosition);
	      }
	
	      if (_this._windowScrollTarget) {
	        var _windowScrollTarget = _this._windowScrollTarget,
	            xTarget = _windowScrollTarget[0],
	            yTarget = _windowScrollTarget[1];
	
	        var x = (0, _scrollLeft2.default)(window);
	        var y = (0, _scrollTop2.default)(window);
	
	        if (x === xTarget && y === yTarget) {
	          _this._windowScrollTarget = null;
	          _this._cancelCheckWindowScroll();
	        }
	      }
	    };
	
	    this._saveWindowPosition = function () {
	      _this._saveWindowPositionHandle = null;
	
	      _this._savePosition(null, window);
	    };
	
	    this._checkWindowScrollPosition = function () {
	      _this._checkWindowScrollHandle = null;
	
	      // We can only get here if scrollTarget is set. Every code path that unsets
	      // scroll target also cancels the handle to avoid calling this handler.
	      // Still, check anyway just in case.
	      /* istanbul ignore if: paranoid guard */
	      if (!_this._windowScrollTarget) {
	        return;
	      }
	
	      _this.scrollToTarget(window, _this._windowScrollTarget);
	
	      ++_this._numWindowScrollAttempts;
	
	      /* istanbul ignore if: paranoid guard */
	      if (_this._numWindowScrollAttempts >= MAX_SCROLL_ATTEMPTS) {
	        _this._windowScrollTarget = null;
	        return;
	      }
	
	      _this._checkWindowScrollHandle = (0, _requestAnimationFrame2.default)(_this._checkWindowScrollPosition);
	    };
	
	    this._stateStorage = stateStorage;
	    this._getCurrentLocation = getCurrentLocation;
	    this._shouldUpdateScroll = shouldUpdateScroll;
	
	    // This helps avoid some jankiness in fighting against the browser's
	    // default scroll behavior on `POP` transitions.
	    /* istanbul ignore else: Travis browsers all support this */
	    if ('scrollRestoration' in window.history &&
	    // Unfortunately, Safari on iOS freezes for 2-6s after the user swipes to
	    // navigate through history with scrollRestoration being 'manual', so we
	    // need to detect this browser and exclude it from the following code
	    // until this bug is fixed by Apple.
	    !(0, _utils.isMobileSafari)()) {
	      this._oldScrollRestoration = window.history.scrollRestoration;
	      try {
	        window.history.scrollRestoration = 'manual';
	      } catch (e) {
	        this._oldScrollRestoration = null;
	      }
	    } else {
	      this._oldScrollRestoration = null;
	    }
	
	    this._saveWindowPositionHandle = null;
	    this._checkWindowScrollHandle = null;
	    this._windowScrollTarget = null;
	    this._numWindowScrollAttempts = 0;
	
	    this._scrollElements = {};
	
	    // We have to listen to each window scroll update rather than to just
	    // location updates, because some browsers will update scroll position
	    // before emitting the location change.
	    (0, _on2.default)(window, 'scroll', this._onWindowScroll);
	
	    this._removeTransitionHook = addTransitionHook(function () {
	      _requestAnimationFrame2.default.cancel(_this._saveWindowPositionHandle);
	      _this._saveWindowPositionHandle = null;
	
	      Object.keys(_this._scrollElements).forEach(function (key) {
	        var scrollElement = _this._scrollElements[key];
	        _requestAnimationFrame2.default.cancel(scrollElement.savePositionHandle);
	        scrollElement.savePositionHandle = null;
	
	        // It's fine to save element scroll positions here, though; the browser
	        // won't modify them.
	        _this._saveElementPosition(key);
	      });
	    });
	  }
	
	  ScrollBehavior.prototype.registerElement = function registerElement(key, element, shouldUpdateScroll, context) {
	    var _this2 = this;
	
	    !!this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is already an element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    var saveElementPosition = function saveElementPosition() {
	      _this2._saveElementPosition(key);
	    };
	
	    var scrollElement = {
	      element: element,
	      shouldUpdateScroll: shouldUpdateScroll,
	      savePositionHandle: null,
	
	      onScroll: function onScroll() {
	        if (!scrollElement.savePositionHandle) {
	          scrollElement.savePositionHandle = (0, _requestAnimationFrame2.default)(saveElementPosition);
	        }
	      }
	    };
	
	    this._scrollElements[key] = scrollElement;
	    (0, _on2.default)(element, 'scroll', scrollElement.onScroll);
	
	    this._updateElementScroll(key, null, context);
	  };
	
	  ScrollBehavior.prototype.unregisterElement = function unregisterElement(key) {
	    !this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is no element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    var _scrollElements$key = this._scrollElements[key],
	        element = _scrollElements$key.element,
	        onScroll = _scrollElements$key.onScroll,
	        savePositionHandle = _scrollElements$key.savePositionHandle;
	
	
	    (0, _off2.default)(element, 'scroll', onScroll);
	    _requestAnimationFrame2.default.cancel(savePositionHandle);
	
	    delete this._scrollElements[key];
	  };
	
	  ScrollBehavior.prototype.updateScroll = function updateScroll(prevContext, context) {
	    var _this3 = this;
	
	    this._updateWindowScroll(prevContext, context);
	
	    Object.keys(this._scrollElements).forEach(function (key) {
	      _this3._updateElementScroll(key, prevContext, context);
	    });
	  };
	
	  ScrollBehavior.prototype.stop = function stop() {
	    /* istanbul ignore if: not supported by any browsers on Travis */
	    if (this._oldScrollRestoration) {
	      try {
	        window.history.scrollRestoration = this._oldScrollRestoration;
	      } catch (e) {
	        /* silence */
	      }
	    }
	
	    (0, _off2.default)(window, 'scroll', this._onWindowScroll);
	    this._cancelCheckWindowScroll();
	
	    this._removeTransitionHook();
	  };
	
	  ScrollBehavior.prototype._cancelCheckWindowScroll = function _cancelCheckWindowScroll() {
	    _requestAnimationFrame2.default.cancel(this._checkWindowScrollHandle);
	    this._checkWindowScrollHandle = null;
	  };
	
	  ScrollBehavior.prototype._saveElementPosition = function _saveElementPosition(key) {
	    var scrollElement = this._scrollElements[key];
	    scrollElement.savePositionHandle = null;
	
	    this._savePosition(key, scrollElement.element);
	  };
	
	  ScrollBehavior.prototype._savePosition = function _savePosition(key, element) {
	    this._stateStorage.save(this._getCurrentLocation(), key, [(0, _scrollLeft2.default)(element), (0, _scrollTop2.default)(element)]);
	  };
	
	  ScrollBehavior.prototype._updateWindowScroll = function _updateWindowScroll(prevContext, context) {
	    // Whatever we were doing before isn't relevant any more.
	    this._cancelCheckWindowScroll();
	
	    this._windowScrollTarget = this._getScrollTarget(null, this._shouldUpdateScroll, prevContext, context);
	
	    // Updating the window scroll position is really flaky. Just trying to
	    // scroll it isn't enough. Instead, try to scroll a few times until it
	    // works.
	    this._numWindowScrollAttempts = 0;
	    this._checkWindowScrollPosition();
	  };
	
	  ScrollBehavior.prototype._updateElementScroll = function _updateElementScroll(key, prevContext, context) {
	    var _scrollElements$key2 = this._scrollElements[key],
	        element = _scrollElements$key2.element,
	        shouldUpdateScroll = _scrollElements$key2.shouldUpdateScroll;
	
	
	    var scrollTarget = this._getScrollTarget(key, shouldUpdateScroll, prevContext, context);
	    if (!scrollTarget) {
	      return;
	    }
	
	    // Unlike with the window, there shouldn't be any flakiness to deal with
	    // here.
	    this.scrollToTarget(element, scrollTarget);
	  };
	
	  ScrollBehavior.prototype._getDefaultScrollTarget = function _getDefaultScrollTarget(location) {
	    var hash = location.hash;
	    if (hash && hash !== '#') {
	      return hash.charAt(0) === '#' ? hash.slice(1) : hash;
	    }
	    return [0, 0];
	  };
	
	  ScrollBehavior.prototype._getScrollTarget = function _getScrollTarget(key, shouldUpdateScroll, prevContext, context) {
	    var scrollTarget = shouldUpdateScroll ? shouldUpdateScroll.call(this, prevContext, context) : true;
	
	    if (!scrollTarget || Array.isArray(scrollTarget) || typeof scrollTarget === 'string') {
	      return scrollTarget;
	    }
	
	    var location = this._getCurrentLocation();
	
	    return this._getSavedScrollTarget(key, location) || this._getDefaultScrollTarget(location);
	  };
	
	  ScrollBehavior.prototype._getSavedScrollTarget = function _getSavedScrollTarget(key, location) {
	    if (location.action === 'PUSH') {
	      return null;
	    }
	
	    return this._stateStorage.read(location, key);
	  };
	
	  ScrollBehavior.prototype.scrollToTarget = function scrollToTarget(element, target) {
	    if (typeof target === 'string') {
	      var targetElement = document.getElementById(target) || document.getElementsByName(target)[0];
	      if (targetElement) {
	        targetElement.scrollIntoView();
	        return;
	      }
	
	      // Fallback to scrolling to top when target fragment doesn't exist.
	      target = [0, 0]; // eslint-disable-line no-param-reassign
	    }
	
	    var _target = target,
	        left = _target[0],
	        top = _target[1];
	
	    (0, _scrollLeft2.default)(element, left);
	    (0, _scrollTop2.default)(element, top);
	  };
	
	  return ScrollBehavior;
	}();
	
	exports.default = ScrollBehavior;
	module.exports = exports['default'];

/***/ }),
/* 4758 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isMobileSafari = isMobileSafari;
	function isMobileSafari() {
	  return (/iPad|iPhone|iPod/.test(window.navigator.platform) && /^((?!CriOS).)*Safari/.test(window.navigator.userAgent)
	  );
	}

/***/ }),
/* 4759 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(78)))

/***/ }),
/* 4760 */,
/* 4761 */
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),
/* 4762 */
/***/ (function(module, exports, __webpack_require__) {

	var engine = __webpack_require__(4765)
	
	var storages = __webpack_require__(4766)
	var plugins = [__webpack_require__(4763)]
	
	module.exports = engine.createStore(storages, plugins)


/***/ }),
/* 4763 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = json2Plugin
	
	function json2Plugin() {
		__webpack_require__(4764)
		return {}
	}


/***/ }),
/* 4764 */
/***/ (function(module, exports) {

	/* eslint-disable */
	
	//  json2.js
	//  2016-10-28
	//  Public Domain.
	//  NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
	//  See http://www.JSON.org/js.html
	//  This code should be minified before deployment.
	//  See http://javascript.crockford.com/jsmin.html
	
	//  USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
	//  NOT CONTROL.
	
	//  This file creates a global JSON object containing two methods: stringify
	//  and parse. This file provides the ES5 JSON capability to ES3 systems.
	//  If a project might run on IE8 or earlier, then this file should be included.
	//  This file does nothing on ES5 systems.
	
	//      JSON.stringify(value, replacer, space)
	//          value       any JavaScript value, usually an object or array.
	//          replacer    an optional parameter that determines how object
	//                      values are stringified for objects. It can be a
	//                      function or an array of strings.
	//          space       an optional parameter that specifies the indentation
	//                      of nested structures. If it is omitted, the text will
	//                      be packed without extra whitespace. If it is a number,
	//                      it will specify the number of spaces to indent at each
	//                      level. If it is a string (such as "\t" or "&nbsp;"),
	//                      it contains the characters used to indent at each level.
	//          This method produces a JSON text from a JavaScript value.
	//          When an object value is found, if the object contains a toJSON
	//          method, its toJSON method will be called and the result will be
	//          stringified. A toJSON method does not serialize: it returns the
	//          value represented by the name/value pair that should be serialized,
	//          or undefined if nothing should be serialized. The toJSON method
	//          will be passed the key associated with the value, and this will be
	//          bound to the value.
	
	//          For example, this would serialize Dates as ISO strings.
	
	//              Date.prototype.toJSON = function (key) {
	//                  function f(n) {
	//                      // Format integers to have at least two digits.
	//                      return (n < 10)
	//                          ? "0" + n
	//                          : n;
	//                  }
	//                  return this.getUTCFullYear()   + "-" +
	//                       f(this.getUTCMonth() + 1) + "-" +
	//                       f(this.getUTCDate())      + "T" +
	//                       f(this.getUTCHours())     + ":" +
	//                       f(this.getUTCMinutes())   + ":" +
	//                       f(this.getUTCSeconds())   + "Z";
	//              };
	
	//          You can provide an optional replacer method. It will be passed the
	//          key and value of each member, with this bound to the containing
	//          object. The value that is returned from your method will be
	//          serialized. If your method returns undefined, then the member will
	//          be excluded from the serialization.
	
	//          If the replacer parameter is an array of strings, then it will be
	//          used to select the members to be serialized. It filters the results
	//          such that only members with keys listed in the replacer array are
	//          stringified.
	
	//          Values that do not have JSON representations, such as undefined or
	//          functions, will not be serialized. Such values in objects will be
	//          dropped; in arrays they will be replaced with null. You can use
	//          a replacer function to replace those with JSON values.
	
	//          JSON.stringify(undefined) returns undefined.
	
	//          The optional space parameter produces a stringification of the
	//          value that is filled with line breaks and indentation to make it
	//          easier to read.
	
	//          If the space parameter is a non-empty string, then that string will
	//          be used for indentation. If the space parameter is a number, then
	//          the indentation will be that many spaces.
	
	//          Example:
	
	//          text = JSON.stringify(["e", {pluribus: "unum"}]);
	//          // text is '["e",{"pluribus":"unum"}]'
	
	//          text = JSON.stringify(["e", {pluribus: "unum"}], null, "\t");
	//          // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'
	
	//          text = JSON.stringify([new Date()], function (key, value) {
	//              return this[key] instanceof Date
	//                  ? "Date(" + this[key] + ")"
	//                  : value;
	//          });
	//          // text is '["Date(---current time---)"]'
	
	//      JSON.parse(text, reviver)
	//          This method parses a JSON text to produce an object or array.
	//          It can throw a SyntaxError exception.
	
	//          The optional reviver parameter is a function that can filter and
	//          transform the results. It receives each of the keys and values,
	//          and its return value is used instead of the original value.
	//          If it returns what it received, then the structure is not modified.
	//          If it returns undefined then the member is deleted.
	
	//          Example:
	
	//          // Parse the text. Values that look like ISO date strings will
	//          // be converted to Date objects.
	
	//          myData = JSON.parse(text, function (key, value) {
	//              var a;
	//              if (typeof value === "string") {
	//                  a =
	//   /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
	//                  if (a) {
	//                      return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
	//                          +a[5], +a[6]));
	//                  }
	//              }
	//              return value;
	//          });
	
	//          myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
	//              var d;
	//              if (typeof value === "string" &&
	//                      value.slice(0, 5) === "Date(" &&
	//                      value.slice(-1) === ")") {
	//                  d = new Date(value.slice(5, -1));
	//                  if (d) {
	//                      return d;
	//                  }
	//              }
	//              return value;
	//          });
	
	//  This is a reference implementation. You are free to copy, modify, or
	//  redistribute.
	
	/*jslint
	    eval, for, this
	*/
	
	/*property
	    JSON, apply, call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
	    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
	    lastIndex, length, parse, prototype, push, replace, slice, stringify,
	    test, toJSON, toString, valueOf
	*/
	
	
	// Create a JSON object only if one does not already exist. We create the
	// methods in a closure to avoid creating global variables.
	
	if (typeof JSON !== "object") {
	    JSON = {};
	}
	
	(function () {
	    "use strict";
	
	    var rx_one = /^[\],:{}\s]*$/;
	    var rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
	    var rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
	    var rx_four = /(?:^|:|,)(?:\s*\[)+/g;
	    var rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
	    var rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
	
	    function f(n) {
	        // Format integers to have at least two digits.
	        return n < 10
	            ? "0" + n
	            : n;
	    }
	
	    function this_value() {
	        return this.valueOf();
	    }
	
	    if (typeof Date.prototype.toJSON !== "function") {
	
	        Date.prototype.toJSON = function () {
	
	            return isFinite(this.valueOf())
	                ? this.getUTCFullYear() + "-" +
	                        f(this.getUTCMonth() + 1) + "-" +
	                        f(this.getUTCDate()) + "T" +
	                        f(this.getUTCHours()) + ":" +
	                        f(this.getUTCMinutes()) + ":" +
	                        f(this.getUTCSeconds()) + "Z"
	                : null;
	        };
	
	        Boolean.prototype.toJSON = this_value;
	        Number.prototype.toJSON = this_value;
	        String.prototype.toJSON = this_value;
	    }
	
	    var gap;
	    var indent;
	    var meta;
	    var rep;
	
	
	    function quote(string) {
	
	// If the string contains no control characters, no quote characters, and no
	// backslash characters, then we can safely slap some quotes around it.
	// Otherwise we must also replace the offending characters with safe escape
	// sequences.
	
	        rx_escapable.lastIndex = 0;
	        return rx_escapable.test(string)
	            ? "\"" + string.replace(rx_escapable, function (a) {
	                var c = meta[a];
	                return typeof c === "string"
	                    ? c
	                    : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
	            }) + "\""
	            : "\"" + string + "\"";
	    }
	
	
	    function str(key, holder) {
	
	// Produce a string from holder[key].
	
	        var i;          // The loop counter.
	        var k;          // The member key.
	        var v;          // The member value.
	        var length;
	        var mind = gap;
	        var partial;
	        var value = holder[key];
	
	// If the value has a toJSON method, call it to obtain a replacement value.
	
	        if (value && typeof value === "object" &&
	                typeof value.toJSON === "function") {
	            value = value.toJSON(key);
	        }
	
	// If we were called with a replacer function, then call the replacer to
	// obtain a replacement value.
	
	        if (typeof rep === "function") {
	            value = rep.call(holder, key, value);
	        }
	
	// What happens next depends on the value's type.
	
	        switch (typeof value) {
	        case "string":
	            return quote(value);
	
	        case "number":
	
	// JSON numbers must be finite. Encode non-finite numbers as null.
	
	            return isFinite(value)
	                ? String(value)
	                : "null";
	
	        case "boolean":
	        case "null":
	
	// If the value is a boolean or null, convert it to a string. Note:
	// typeof null does not produce "null". The case is included here in
	// the remote chance that this gets fixed someday.
	
	            return String(value);
	
	// If the type is "object", we might be dealing with an object or an array or
	// null.
	
	        case "object":
	
	// Due to a specification blunder in ECMAScript, typeof null is "object",
	// so watch out for that case.
	
	            if (!value) {
	                return "null";
	            }
	
	// Make an array to hold the partial results of stringifying this object value.
	
	            gap += indent;
	            partial = [];
	
	// Is the value an array?
	
	            if (Object.prototype.toString.apply(value) === "[object Array]") {
	
	// The value is an array. Stringify every element. Use null as a placeholder
	// for non-JSON values.
	
	                length = value.length;
	                for (i = 0; i < length; i += 1) {
	                    partial[i] = str(i, value) || "null";
	                }
	
	// Join all of the elements together, separated with commas, and wrap them in
	// brackets.
	
	                v = partial.length === 0
	                    ? "[]"
	                    : gap
	                        ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]"
	                        : "[" + partial.join(",") + "]";
	                gap = mind;
	                return v;
	            }
	
	// If the replacer is an array, use it to select the members to be stringified.
	
	            if (rep && typeof rep === "object") {
	                length = rep.length;
	                for (i = 0; i < length; i += 1) {
	                    if (typeof rep[i] === "string") {
	                        k = rep[i];
	                        v = str(k, value);
	                        if (v) {
	                            partial.push(quote(k) + (
	                                gap
	                                    ? ": "
	                                    : ":"
	                            ) + v);
	                        }
	                    }
	                }
	            } else {
	
	// Otherwise, iterate through all of the keys in the object.
	
	                for (k in value) {
	                    if (Object.prototype.hasOwnProperty.call(value, k)) {
	                        v = str(k, value);
	                        if (v) {
	                            partial.push(quote(k) + (
	                                gap
	                                    ? ": "
	                                    : ":"
	                            ) + v);
	                        }
	                    }
	                }
	            }
	
	// Join all of the member texts together, separated with commas,
	// and wrap them in braces.
	
	            v = partial.length === 0
	                ? "{}"
	                : gap
	                    ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}"
	                    : "{" + partial.join(",") + "}";
	            gap = mind;
	            return v;
	        }
	    }
	
	// If the JSON object does not yet have a stringify method, give it one.
	
	    if (typeof JSON.stringify !== "function") {
	        meta = {    // table of character substitutions
	            "\b": "\\b",
	            "\t": "\\t",
	            "\n": "\\n",
	            "\f": "\\f",
	            "\r": "\\r",
	            "\"": "\\\"",
	            "\\": "\\\\"
	        };
	        JSON.stringify = function (value, replacer, space) {
	
	// The stringify method takes a value and an optional replacer, and an optional
	// space parameter, and returns a JSON text. The replacer can be a function
	// that can replace values, or an array of strings that will select the keys.
	// A default replacer method can be provided. Use of the space parameter can
	// produce text that is more easily readable.
	
	            var i;
	            gap = "";
	            indent = "";
	
	// If the space parameter is a number, make an indent string containing that
	// many spaces.
	
	            if (typeof space === "number") {
	                for (i = 0; i < space; i += 1) {
	                    indent += " ";
	                }
	
	// If the space parameter is a string, it will be used as the indent string.
	
	            } else if (typeof space === "string") {
	                indent = space;
	            }
	
	// If there is a replacer, it must be a function or an array.
	// Otherwise, throw an error.
	
	            rep = replacer;
	            if (replacer && typeof replacer !== "function" &&
	                    (typeof replacer !== "object" ||
	                    typeof replacer.length !== "number")) {
	                throw new Error("JSON.stringify");
	            }
	
	// Make a fake root object containing our value under the key of "".
	// Return the result of stringifying the value.
	
	            return str("", {"": value});
	        };
	    }
	
	
	// If the JSON object does not yet have a parse method, give it one.
	
	    if (typeof JSON.parse !== "function") {
	        JSON.parse = function (text, reviver) {
	
	// The parse method takes a text and an optional reviver function, and returns
	// a JavaScript value if the text is a valid JSON text.
	
	            var j;
	
	            function walk(holder, key) {
	
	// The walk method is used to recursively walk the resulting structure so
	// that modifications can be made.
	
	                var k;
	                var v;
	                var value = holder[key];
	                if (value && typeof value === "object") {
	                    for (k in value) {
	                        if (Object.prototype.hasOwnProperty.call(value, k)) {
	                            v = walk(value, k);
	                            if (v !== undefined) {
	                                value[k] = v;
	                            } else {
	                                delete value[k];
	                            }
	                        }
	                    }
	                }
	                return reviver.call(holder, key, value);
	            }
	
	
	// Parsing happens in four stages. In the first stage, we replace certain
	// Unicode characters with escape sequences. JavaScript handles many characters
	// incorrectly, either silently deleting them, or treating them as line endings.
	
	            text = String(text);
	            rx_dangerous.lastIndex = 0;
	            if (rx_dangerous.test(text)) {
	                text = text.replace(rx_dangerous, function (a) {
	                    return "\\u" +
	                            ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
	                });
	            }
	
	// In the second stage, we run the text against regular expressions that look
	// for non-JSON patterns. We are especially concerned with "()" and "new"
	// because they can cause invocation, and "=" because it can cause mutation.
	// But just to be safe, we want to reject all unexpected forms.
	
	// We split the second stage into 4 regexp operations in order to work around
	// crippling inefficiencies in IE's and Safari's regexp engines. First we
	// replace the JSON backslash pairs with "@" (a non-JSON character). Second, we
	// replace all simple value tokens with "]" characters. Third, we delete all
	// open brackets that follow a colon or comma or that begin the text. Finally,
	// we look to see that the remaining characters are only whitespace or "]" or
	// "," or ":" or "{" or "}". If that is so, then the text is safe for eval.
	
	            if (
	                rx_one.test(
	                    text
	                        .replace(rx_two, "@")
	                        .replace(rx_three, "]")
	                        .replace(rx_four, "")
	                )
	            ) {
	
	// In the third stage we use the eval function to compile the text into a
	// JavaScript structure. The "{" operator is subject to a syntactic ambiguity
	// in JavaScript: it can begin a block or an object literal. We wrap the text
	// in parens to eliminate the ambiguity.
	
	                j = eval("(" + text + ")");
	
	// In the optional fourth stage, we recursively walk the new structure, passing
	// each name/value pair to a reviver function for possible transformation.
	
	                return (typeof reviver === "function")
	                    ? walk({"": j}, "")
	                    : j;
	            }
	
	// If the text is not JSON parseable, then a SyntaxError is thrown.
	
	            throw new SyntaxError("JSON.parse");
	        };
	    }
	}());

/***/ }),
/* 4765 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(189)
	var slice = util.slice
	var pluck = util.pluck
	var each = util.each
	var bind = util.bind
	var create = util.create
	var isList = util.isList
	var isFunction = util.isFunction
	var isObject = util.isObject
	
	module.exports = {
		createStore: createStore
	}
	
	var storeAPI = {
		version: '2.0.12',
		enabled: false,
		
		// get returns the value of the given key. If that value
		// is undefined, it returns optionalDefaultValue instead.
		get: function(key, optionalDefaultValue) {
			var data = this.storage.read(this._namespacePrefix + key)
			return this._deserialize(data, optionalDefaultValue)
		},
	
		// set will store the given value at key and returns value.
		// Calling set with value === undefined is equivalent to calling remove.
		set: function(key, value) {
			if (value === undefined) {
				return this.remove(key)
			}
			this.storage.write(this._namespacePrefix + key, this._serialize(value))
			return value
		},
	
		// remove deletes the key and value stored at the given key.
		remove: function(key) {
			this.storage.remove(this._namespacePrefix + key)
		},
	
		// each will call the given callback once for each key-value pair
		// in this store.
		each: function(callback) {
			var self = this
			this.storage.each(function(val, namespacedKey) {
				callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''))
			})
		},
	
		// clearAll will remove all the stored key-value pairs in this store.
		clearAll: function() {
			this.storage.clearAll()
		},
	
		// additional functionality that can't live in plugins
		// ---------------------------------------------------
	
		// hasNamespace returns true if this store instance has the given namespace.
		hasNamespace: function(namespace) {
			return (this._namespacePrefix == '__storejs_'+namespace+'_')
		},
	
		// createStore creates a store.js instance with the first
		// functioning storage in the list of storage candidates,
		// and applies the the given mixins to the instance.
		createStore: function() {
			return createStore.apply(this, arguments)
		},
		
		addPlugin: function(plugin) {
			this._addPlugin(plugin)
		},
		
		namespace: function(namespace) {
			return createStore(this.storage, this.plugins, namespace)
		}
	}
	
	function _warn() {
		var _console = (typeof console == 'undefined' ? null : console)
		if (!_console) { return }
		var fn = (_console.warn ? _console.warn : _console.log)
		fn.apply(_console, arguments)
	}
	
	function createStore(storages, plugins, namespace) {
		if (!namespace) {
			namespace = ''
		}
		if (storages && !isList(storages)) {
			storages = [storages]
		}
		if (plugins && !isList(plugins)) {
			plugins = [plugins]
		}
	
		var namespacePrefix = (namespace ? '__storejs_'+namespace+'_' : '')
		var namespaceRegexp = (namespace ? new RegExp('^'+namespacePrefix) : null)
		var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
		if (!legalNamespaces.test(namespace)) {
			throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes')
		}
		
		var _privateStoreProps = {
			_namespacePrefix: namespacePrefix,
			_namespaceRegexp: namespaceRegexp,
	
			_testStorage: function(storage) {
				try {
					var testStr = '__storejs__test__'
					storage.write(testStr, testStr)
					var ok = (storage.read(testStr) === testStr)
					storage.remove(testStr)
					return ok
				} catch(e) {
					return false
				}
			},
	
			_assignPluginFnProp: function(pluginFnProp, propName) {
				var oldFn = this[propName]
				this[propName] = function pluginFn() {
					var args = slice(arguments, 0)
					var self = this
	
					// super_fn calls the old function which was overwritten by
					// this mixin.
					function super_fn() {
						if (!oldFn) { return }
						each(arguments, function(arg, i) {
							args[i] = arg
						})
						return oldFn.apply(self, args)
					}
	
					// Give mixing function access to super_fn by prefixing all mixin function
					// arguments with super_fn.
					var newFnArgs = [super_fn].concat(args)
	
					return pluginFnProp.apply(self, newFnArgs)
				}
			},
	
			_serialize: function(obj) {
				return JSON.stringify(obj)
			},
	
			_deserialize: function(strVal, defaultVal) {
				if (!strVal) { return defaultVal }
				// It is possible that a raw string value has been previously stored
				// in a storage without using store.js, meaning it will be a raw
				// string value instead of a JSON serialized string. By defaulting
				// to the raw string value in case of a JSON parse error, we allow
				// for past stored values to be forwards-compatible with store.js
				var val = ''
				try { val = JSON.parse(strVal) }
				catch(e) { val = strVal }
	
				return (val !== undefined ? val : defaultVal)
			},
			
			_addStorage: function(storage) {
				if (this.enabled) { return }
				if (this._testStorage(storage)) {
					this.storage = storage
					this.enabled = true
				}
			},
	
			_addPlugin: function(plugin) {
				var self = this
	
				// If the plugin is an array, then add all plugins in the array.
				// This allows for a plugin to depend on other plugins.
				if (isList(plugin)) {
					each(plugin, function(plugin) {
						self._addPlugin(plugin)
					})
					return
				}
	
				// Keep track of all plugins we've seen so far, so that we
				// don't add any of them twice.
				var seenPlugin = pluck(this.plugins, function(seenPlugin) {
					return (plugin === seenPlugin)
				})
				if (seenPlugin) {
					return
				}
				this.plugins.push(plugin)
	
				// Check that the plugin is properly formed
				if (!isFunction(plugin)) {
					throw new Error('Plugins must be function values that return objects')
				}
	
				var pluginProperties = plugin.call(this)
				if (!isObject(pluginProperties)) {
					throw new Error('Plugins must return an object of function properties')
				}
	
				// Add the plugin function properties to this store instance.
				each(pluginProperties, function(pluginFnProp, propName) {
					if (!isFunction(pluginFnProp)) {
						throw new Error('Bad plugin property: '+propName+' from plugin '+plugin.name+'. Plugins should only return functions.')
					}
					self._assignPluginFnProp(pluginFnProp, propName)
				})
			},
			
			// Put deprecated properties in the private API, so as to not expose it to accidential
			// discovery through inspection of the store object.
			
			// Deprecated: addStorage
			addStorage: function(storage) {
				_warn('store.addStorage(storage) is deprecated. Use createStore([storages])')
				this._addStorage(storage)
			}
		}
	
		var store = create(_privateStoreProps, storeAPI, {
			plugins: []
		})
		store.raw = {}
		each(store, function(prop, propName) {
			if (isFunction(prop)) {
				store.raw[propName] = bind(store, prop)			
			}
		})
		each(storages, function(storage) {
			store._addStorage(storage)
		})
		each(plugins, function(plugin) {
			store._addPlugin(plugin)
		})
		return store
	}


/***/ }),
/* 4766 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = [
		// Listed in order of usage preference
		__webpack_require__(4768),
		__webpack_require__(4770),
		__webpack_require__(4771),
		__webpack_require__(4767),
		__webpack_require__(4772),
		__webpack_require__(4769)
	]


/***/ }),
/* 4767 */
/***/ (function(module, exports, __webpack_require__) {

	// cookieStorage is useful Safari private browser mode, where localStorage
	// doesn't work but cookies do. This implementation is adopted from
	// https://developer.mozilla.org/en-US/docs/Web/API/Storage/LocalStorage
	
	var util = __webpack_require__(189)
	var Global = util.Global
	var trim = util.trim
	
	module.exports = {
		name: 'cookieStorage',
		read: read,
		write: write,
		each: each,
		remove: remove,
		clearAll: clearAll,
	}
	
	var doc = Global.document
	
	function read(key) {
		if (!key || !_has(key)) { return null }
		var regexpStr = "(?:^|.*;\\s*)" +
			escape(key).replace(/[\-\.\+\*]/g, "\\$&") +
			"\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*"
		return unescape(doc.cookie.replace(new RegExp(regexpStr), "$1"))
	}
	
	function each(callback) {
		var cookies = doc.cookie.split(/; ?/g)
		for (var i = cookies.length - 1; i >= 0; i--) {
			if (!trim(cookies[i])) {
				continue
			}
			var kvp = cookies[i].split('=')
			var key = unescape(kvp[0])
			var val = unescape(kvp[1])
			callback(val, key)
		}
	}
	
	function write(key, data) {
		if(!key) { return }
		doc.cookie = escape(key) + "=" + escape(data) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/"
	}
	
	function remove(key) {
		if (!key || !_has(key)) {
			return
		}
		doc.cookie = escape(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/"
	}
	
	function clearAll() {
		each(function(_, key) {
			remove(key)
		})
	}
	
	function _has(key) {
		return (new RegExp("(?:^|;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(doc.cookie)
	}


/***/ }),
/* 4768 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(189)
	var Global = util.Global
	
	module.exports = {
		name: 'localStorage',
		read: read,
		write: write,
		each: each,
		remove: remove,
		clearAll: clearAll,
	}
	
	function localStorage() {
		return Global.localStorage
	}
	
	function read(key) {
		return localStorage().getItem(key)
	}
	
	function write(key, data) {
		return localStorage().setItem(key, data)
	}
	
	function each(fn) {
		for (var i = localStorage().length - 1; i >= 0; i--) {
			var key = localStorage().key(i)
			fn(read(key), key)
		}
	}
	
	function remove(key) {
		return localStorage().removeItem(key)
	}
	
	function clearAll() {
		return localStorage().clear()
	}


/***/ }),
/* 4769 */
/***/ (function(module, exports) {

	// memoryStorage is a useful last fallback to ensure that the store
	// is functions (meaning store.get(), store.set(), etc will all function).
	// However, stored values will not persist when the browser navigates to
	// a new page or reloads the current page.
	
	module.exports = {
		name: 'memoryStorage',
		read: read,
		write: write,
		each: each,
		remove: remove,
		clearAll: clearAll,
	}
	
	var memoryStorage = {}
	
	function read(key) {
		return memoryStorage[key]
	}
	
	function write(key, data) {
		memoryStorage[key] = data
	}
	
	function each(callback) {
		for (var key in memoryStorage) {
			if (memoryStorage.hasOwnProperty(key)) {
				callback(memoryStorage[key], key)
			}
		}
	}
	
	function remove(key) {
		delete memoryStorage[key]
	}
	
	function clearAll(key) {
		memoryStorage = {}
	}


/***/ }),
/* 4770 */
/***/ (function(module, exports, __webpack_require__) {

	// oldFF-globalStorage provides storage for Firefox
	// versions 6 and 7, where no localStorage, etc
	// is available.
	
	var util = __webpack_require__(189)
	var Global = util.Global
	
	module.exports = {
		name: 'oldFF-globalStorage',
		read: read,
		write: write,
		each: each,
		remove: remove,
		clearAll: clearAll,
	}
	
	var globalStorage = Global.globalStorage
	
	function read(key) {
		return globalStorage[key]
	}
	
	function write(key, data) {
		globalStorage[key] = data
	}
	
	function each(fn) {
		for (var i = globalStorage.length - 1; i >= 0; i--) {
			var key = globalStorage.key(i)
			fn(globalStorage[key], key)
		}
	}
	
	function remove(key) {
		return globalStorage.removeItem(key)
	}
	
	function clearAll() {
		each(function(key, _) {
			delete globalStorage[key]
		})
	}


/***/ }),
/* 4771 */
/***/ (function(module, exports, __webpack_require__) {

	// oldIE-userDataStorage provides storage for Internet Explorer
	// versions 6 and 7, where no localStorage, sessionStorage, etc
	// is available.
	
	var util = __webpack_require__(189)
	var Global = util.Global
	
	module.exports = {
		name: 'oldIE-userDataStorage',
		write: write,
		read: read,
		each: each,
		remove: remove,
		clearAll: clearAll,
	}
	
	var storageName = 'storejs'
	var doc = Global.document
	var _withStorageEl = _makeIEStorageElFunction()
	var disable = (Global.navigator ? Global.navigator.userAgent : '').match(/ (MSIE 8|MSIE 9|MSIE 10)\./) // MSIE 9.x, MSIE 10.x
	
	function write(unfixedKey, data) {
		if (disable) { return }
		var fixedKey = fixKey(unfixedKey)
		_withStorageEl(function(storageEl) {
			storageEl.setAttribute(fixedKey, data)
			storageEl.save(storageName)
		})
	}
	
	function read(unfixedKey) {
		if (disable) { return }
		var fixedKey = fixKey(unfixedKey)
		var res = null
		_withStorageEl(function(storageEl) {
			res = storageEl.getAttribute(fixedKey)
		})
		return res
	}
	
	function each(callback) {
		_withStorageEl(function(storageEl) {
			var attributes = storageEl.XMLDocument.documentElement.attributes
			for (var i=attributes.length-1; i>=0; i--) {
				var attr = attributes[i]
				callback(storageEl.getAttribute(attr.name), attr.name)
			}
		})
	}
	
	function remove(unfixedKey) {
		var fixedKey = fixKey(unfixedKey)
		_withStorageEl(function(storageEl) {
			storageEl.removeAttribute(fixedKey)
			storageEl.save(storageName)
		})
	}
	
	function clearAll() {
		_withStorageEl(function(storageEl) {
			var attributes = storageEl.XMLDocument.documentElement.attributes
			storageEl.load(storageName)
			for (var i=attributes.length-1; i>=0; i--) {
				storageEl.removeAttribute(attributes[i].name)
			}
			storageEl.save(storageName)
		})
	}
	
	// Helpers
	//////////
	
	// In IE7, keys cannot start with a digit or contain certain chars.
	// See https://github.com/marcuswestin/store.js/issues/40
	// See https://github.com/marcuswestin/store.js/issues/83
	var forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g")
	function fixKey(key) {
		return key.replace(/^\d/, '___$&').replace(forbiddenCharsRegex, '___')
	}
	
	function _makeIEStorageElFunction() {
		if (!doc || !doc.documentElement || !doc.documentElement.addBehavior) {
			return null
		}
		var scriptTag = 'script',
			storageOwner,
			storageContainer,
			storageEl
	
		// Since #userData storage applies only to specific paths, we need to
		// somehow link our data to a specific path.  We choose /favicon.ico
		// as a pretty safe option, since all browsers already make a request to
		// this URL anyway and being a 404 will not hurt us here.  We wrap an
		// iframe pointing to the favicon in an ActiveXObject(htmlfile) object
		// (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
		// since the iframe access rules appear to allow direct access and
		// manipulation of the document element, even for a 404 page.  This
		// document can be used instead of the current document (which would
		// have been limited to the current path) to perform #userData storage.
		try {
			/* global ActiveXObject */
			storageContainer = new ActiveXObject('htmlfile')
			storageContainer.open()
			storageContainer.write('<'+scriptTag+'>document.w=window</'+scriptTag+'><iframe src="/favicon.ico"></iframe>')
			storageContainer.close()
			storageOwner = storageContainer.w.frames[0].document
			storageEl = storageOwner.createElement('div')
		} catch(e) {
			// somehow ActiveXObject instantiation failed (perhaps some special
			// security settings or otherwse), fall back to per-path storage
			storageEl = doc.createElement('div')
			storageOwner = doc.body
		}
	
		return function(storeFunction) {
			var args = [].slice.call(arguments, 0)
			args.unshift(storageEl)
			// See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
			// and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
			storageOwner.appendChild(storageEl)
			storageEl.addBehavior('#default#userData')
			storageEl.load(storageName)
			storeFunction.apply(this, args)
			storageOwner.removeChild(storageEl)
			return
		}
	}


/***/ }),
/* 4772 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(189)
	var Global = util.Global
	
	module.exports = {
		name: 'sessionStorage',
		read: read,
		write: write,
		each: each,
		remove: remove,
		clearAll: clearAll
	}
	
	function sessionStorage() {
		return Global.sessionStorage
	}
	
	function read(key) {
		return sessionStorage().getItem(key)
	}
	
	function write(key, data) {
		return sessionStorage().setItem(key, data)
	}
	
	function each(fn) {
		for (var i = sessionStorage().length - 1; i >= 0; i--) {
			var key = sessionStorage().key(i)
			fn(read(key), key)
		}
	}
	
	function remove(key) {
		return sessionStorage().removeItem(key)
	}
	
	function clearAll() {
		return sessionStorage().clear()
	}


/***/ }),
/* 4773 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(4774);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(67)(module)))

/***/ }),
/* 4774 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 4775 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function toFastproperties(o) {
		function Sub() {}
		Sub.prototype = o;
		var receiver = new Sub(); // create an instance
		function ic() { return typeof receiver.foo; } // perform access
		ic(); 
		ic();
		return o;
		eval("o" + o); // ensure no dead code elimination
	}


/***/ }),
/* 4776 */,
/* 4777 */,
/* 4778 */,
/* 4779 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 4780 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 4781 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 4782 */,
/* 4783 */,
/* 4784 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ }),
/* 4785 */,
/* 4786 */,
/* 4787 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 4788 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 4789 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 4790 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// commons-3423532e0022fee85972.js